
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire887a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire887a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3ca9q", function(module, exports) {

$parcel$export(module.exports, "ChainId", function () { return $dd934ee7b45983ea$export$c06e1e7429de6283; });
$parcel$export(module.exports, "AccountId", function () { return $dd934ee7b45983ea$export$ef7439494a23f06e; });
$parcel$export(module.exports, "AssetType", function () { return $dd934ee7b45983ea$export$e57062a38354425e; });
$parcel$export(module.exports, "AssetId", function () { return $dd934ee7b45983ea$export$7591af3d8814cc71; });
function $dd934ee7b45983ea$var$_extends() {
    $dd934ee7b45983ea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd934ee7b45983ea$var$_extends.apply(this, arguments);
}
var $dd934ee7b45983ea$var$CAIP2 = {
    name: "chainId",
    regex: "[-:a-zA-Z0-9]{5,41}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,32}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$CAIP10 = {
    name: "accountId",
    regex: "[-:a-zA-Z0-9]{7,106}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,32}"
            },
            2: {
                name: "address",
                regex: "[a-zA-Z0-9]{1,64}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$AssetName$1 = {
    name: "assetName",
    regex: "[-:a-zA-Z0-9]{5,73}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,64}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$CAIP19AssetType = {
    name: "assetType",
    regex: "[-:a-zA-Z0-9]{11,115}",
    parameters: {
        delimiter: "/",
        values: {
            0: $dd934ee7b45983ea$var$CAIP2,
            1: $dd934ee7b45983ea$var$AssetName$1
        }
    }
};
var $dd934ee7b45983ea$var$CAIP19AssetId = {
    name: "assetId",
    regex: "[-:a-zA-Z0-9]{13,148}",
    parameters: {
        delimiter: "/",
        values: {
            0: $dd934ee7b45983ea$var$CAIP2,
            1: $dd934ee7b45983ea$var$AssetName$1,
            2: {
                name: "tokenId",
                regex: "[-a-zA-Z0-9]{1,32}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$CAIP = {
    "2": $dd934ee7b45983ea$var$CAIP2,
    "10": $dd934ee7b45983ea$var$CAIP10,
    "19": {
        assetName: $dd934ee7b45983ea$var$AssetName$1,
        assetType: $dd934ee7b45983ea$var$CAIP19AssetType,
        assetId: $dd934ee7b45983ea$var$CAIP19AssetId
    }
};
function $dd934ee7b45983ea$var$splitParams(id, spec) {
    return id.split(spec.parameters.delimiter);
}
function $dd934ee7b45983ea$var$getParams(id, spec) {
    var arr = $dd934ee7b45983ea$var$splitParams(id, spec);
    var params = {};
    arr.forEach(function(value, index) {
        params[spec.parameters.values[index].name] = value;
    });
    return params;
}
function $dd934ee7b45983ea$var$joinParams(params, spec) {
    return Object.values(spec.parameters.values).map(function(parameter) {
        var param = params[parameter.name];
        return typeof param === "string" ? param : $dd934ee7b45983ea$var$joinParams(param, parameter);
    }).join(spec.parameters.delimiter);
}
function $dd934ee7b45983ea$var$isValidId(id, spec) {
    if (!new RegExp(spec.regex).test(id)) return false;
    var params = $dd934ee7b45983ea$var$splitParams(id, spec);
    if (params.length !== Object.keys(spec.parameters.values).length) return false;
    var matches = params.map(function(param, index) {
        return new RegExp(spec.parameters.values[index].regex).test(param);
    }).filter(function(x) {
        return !!x;
    });
    if (matches.length !== params.length) return false;
    return true;
}
var $dd934ee7b45983ea$export$c06e1e7429de6283 = /*#__PURE__*/ function() {
    function ChainId(params) {
        if (typeof params === "string") params = ChainId.parse(params);
        this.namespace = params.namespace;
        this.reference = params.reference;
    }
    ChainId.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new ChainId($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    ChainId.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = ChainId.prototype;
    _proto.toString = function toString() {
        return ChainId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            namespace: this.namespace,
            reference: this.reference
        };
    };
    return ChainId;
}();
$dd934ee7b45983ea$export$c06e1e7429de6283.spec = $dd934ee7b45983ea$var$CAIP["2"];
var $dd934ee7b45983ea$export$ef7439494a23f06e = /*#__PURE__*/ function() {
    function AccountId(params) {
        if (typeof params === "string") params = AccountId.parse(params);
        this.chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        this.address = params.address;
    }
    AccountId.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        var _getParams = $dd934ee7b45983ea$var$getParams(id, this.spec), namespace = _getParams.namespace, reference = _getParams.reference, address = _getParams.address;
        var chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283({
            namespace: namespace,
            reference: reference
        });
        return new AccountId({
            chainId: chainId,
            address: address
        }).toJSON();
    };
    AccountId.format = function format(params) {
        var chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        var splitParams = $dd934ee7b45983ea$var$_extends({}, chainId.toJSON(), {
            address: params.address
        });
        return $dd934ee7b45983ea$var$joinParams(splitParams, this.spec);
    };
    var _proto = AccountId.prototype;
    _proto.toString = function toString() {
        return AccountId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            address: this.address
        };
    };
    return AccountId;
}();
$dd934ee7b45983ea$export$ef7439494a23f06e.spec = $dd934ee7b45983ea$var$CAIP["10"];
var $dd934ee7b45983ea$var$AssetName = /*#__PURE__*/ function() {
    function AssetName(params) {
        if (typeof params === "string") params = AssetName.parse(params);
        this.namespace = params.namespace;
        this.reference = params.reference;
    }
    AssetName.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetName($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    AssetName.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = AssetName.prototype;
    _proto.toString = function toString() {
        return AssetName.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            namespace: this.namespace,
            reference: this.reference
        };
    };
    return AssetName;
}();
$dd934ee7b45983ea$var$AssetName.spec = $dd934ee7b45983ea$var$CAIP["19"].assetName;
var $dd934ee7b45983ea$export$e57062a38354425e = /*#__PURE__*/ function() {
    function AssetType(params) {
        if (typeof params === "string") params = AssetType.parse(params);
        this.chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        this.assetName = new $dd934ee7b45983ea$var$AssetName(params.assetName);
    }
    AssetType.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetType($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    AssetType.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = AssetType.prototype;
    _proto.toString = function toString() {
        return AssetType.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            assetName: this.assetName
        };
    };
    return AssetType;
}();
$dd934ee7b45983ea$export$e57062a38354425e.spec = $dd934ee7b45983ea$var$CAIP["19"].assetType;
var $dd934ee7b45983ea$export$7591af3d8814cc71 = /*#__PURE__*/ function() {
    function AssetId(params) {
        if (typeof params === "string") params = AssetId.parse(params);
        this.chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        this.assetName = new $dd934ee7b45983ea$var$AssetName(params.assetName);
        this.tokenId = params.tokenId;
    }
    AssetId.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetId($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    AssetId.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = AssetId.prototype;
    _proto.toString = function toString() {
        return AssetId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            assetName: this.assetName.toJSON(),
            tokenId: this.tokenId
        };
    };
    return AssetId;
}();
$dd934ee7b45983ea$export$7591af3d8814cc71.spec = $dd934ee7b45983ea$var$CAIP["19"].assetId;

});

parcelRegister("9HEDW", function(module, exports) {

$parcel$export(module.exports, "LegacyNetworks", function () { return $7107a818e1506aa8$export$81ee6de5033cd1db; });
$parcel$export(module.exports, "LegacyEvents", function () { return $7107a818e1506aa8$export$183808fb4a9082e9; });
$parcel$export(module.exports, "Persistor", function () { return $7107a818e1506aa8$export$e01a546649d7a495; });
$parcel$export(module.exports, "legacyFormatAddressWithNetwork", function () { return $7107a818e1506aa8$export$f5a1a2f05e7fdb98; });
$parcel$export(module.exports, "legacyReadAccountAddress", function () { return $7107a818e1506aa8$export$a03d8c9a97cb17f0; });
$parcel$export(module.exports, "legacyGetBlockChainNameFromId", function () { return $7107a818e1506aa8$export$2f76b7ab62da017c; });
$parcel$export(module.exports, "legacyIsEvmNamespace", function () { return $7107a818e1506aa8$export$206a51934803bc71; });
$parcel$export(module.exports, "LegacyWallet", function () { return $7107a818e1506aa8$export$aff9e20972034897; });
var $7107a818e1506aa8$var$k = Object.defineProperty;
var $7107a818e1506aa8$var$r = (a, t)=>$7107a818e1506aa8$var$k(a, "name", {
        value: t,
        configurable: !0
    });
var $7107a818e1506aa8$export$81ee6de5033cd1db = ((e)=>(e.BTC = "BTC", e.BSC = "BSC", e.LTC = "LTC", e.THORCHAIN = "THOR", e.BCH = "BCH", e.BINANCE = "BNB", e.BLAST = "BLAST", e.CELO = "CELO", e.LINEA = "LINEA", e.METIS = "METIS", e.SONIC = "SONIC", e.BERACHAIN = "BERACHAIN", e.ZETA_CHAIN = "ZETA_CHAIN", e.SCROLL = "SCROLL", e.ZKSYNC = "ZKSYNC", e.MONAD = "MONAD", e.ETHEREUM = "ETH", e.POLYGON = "POLYGON", e.TERRA = "TERRA", e.POLKADOT = "", e.TRON = "TRON", e.DOGE = "DOGE", e.HARMONY = "HARMONY", e.AVAX_CCHAIN = "AVAX_CCHAIN", e.FANTOM = "FANTOM", e.MOONBEAM = "MOONBEAM", e.ARBITRUM = "ARBITRUM", e.BOBA = "BOBA", e.OPTIMISM = "OPTIMISM", e.FUSE = "FUSE", e.CRONOS = "CRONOS", e.SOLANA = "SOLANA", e.MOONRIVER = "MOONRIVER", e.GNOSIS = "GNOSIS", e.COSMOS = "COSMOS", e.OSMOSIS = "OSMOSIS", e.AXELAR = "AXELAR", e.MARS = "MARS", e.STRIDE = "STRIDE", e.MAYA = "MAYA", e.AKASH = "AKASH", e.IRIS = "IRIS", e.PERSISTENCE = "PERSISTENCE", e.SENTINEL = "SENTINEL", e.REGEN = "REGEN", e.CRYPTO_ORG = "CRYPTO_ORG", e.SIF = "SIF", e.CHIHUAHUA = "CHIHUAHUA", e.JUNO = "JUNO", e.KUJIRA = "KUJIRA", e.STARNAME = "STARNAME", e.COMDEX = "COMDEX", e.STARGAZE = "STARGAZE", e.DESMOS = "DESMOS", e.BITCANNA = "BITCANNA", e.SECRET = "SECRET", e.INJECTIVE = "INJECTIVE", e.LUMNETWORK = "LUMNETWORK", e.BANDCHAIN = "BANDCHAIN", e.EMONEY = "EMONEY", e.BITSONG = "BITSONG", e.KI = "KI", e.MEDIBLOC = "MEDIBLOC", e.KONSTELLATION = "KONSTELLATION", e.UMEE = "UMEE", e.STARKNET = "STARKNET", e.STELLAR = "STELLAR", e.TON = "TON", e.BASE = "BASE", e.SUI = "SUI", e.XRPL = "XRPL", e.ZCASH = "ZCASH", e.Unknown = "Unkown", e))($7107a818e1506aa8$export$81ee6de5033cd1db || {}), $7107a818e1506aa8$export$183808fb4a9082e9 = ((c)=>(c.CONNECTED = "connected", c.CONNECTING = "connecting", c.REACHABLE = "reachable", c.INSTALLED = "installed", c.ACCOUNTS = "accounts", c.NETWORK = "network", c.NAMESPACE_DISCONNECTED = "namespace_disconnected", c.PROVIDER_DISCONNECTED = "provider_disconnected", c))($7107a818e1506aa8$export$183808fb4a9082e9 || {});
var $7107a818e1506aa8$export$e01a546649d7a495 = class {
    static{
        $7107a818e1506aa8$var$r(this, "Persistor");
    }
    getItem(t) {
        let n = localStorage.getItem(t);
        return n ? JSON.parse(n) : null;
    }
    setItem(t, n) {
        localStorage.setItem(t, JSON.stringify(n));
    }
    removeItem(t) {
        localStorage.removeItem(t);
    }
};
function $7107a818e1506aa8$export$f5a1a2f05e7fdb98(a, t) {
    return `${t || ""}:${a}`;
}
$7107a818e1506aa8$var$r($7107a818e1506aa8$export$f5a1a2f05e7fdb98, "formatAddressWithNetwork");
function $7107a818e1506aa8$var$y(a, t) {
    return a ? a.map((n)=>$7107a818e1506aa8$export$f5a1a2f05e7fdb98(n, t)) : [];
}
$7107a818e1506aa8$var$r($7107a818e1506aa8$var$y, "accountAddressesWithNetwork");
function $7107a818e1506aa8$export$a03d8c9a97cb17f0(a) {
    let [t, n] = a.split(":");
    return {
        network: t,
        address: n
    };
}
$7107a818e1506aa8$var$r($7107a818e1506aa8$export$a03d8c9a97cb17f0, "readAccountAddress");
function $7107a818e1506aa8$var$S(a) {
    let { checkInstallation: t = !0 } = a.config;
    return t;
}
$7107a818e1506aa8$var$r($7107a818e1506aa8$var$S, "needsCheckInstallation");
var $7107a818e1506aa8$export$2f76b7ab62da017c = $7107a818e1506aa8$var$r((a, t)=>(a = typeof a == "string" && a.startsWith("0x") ? parseInt(a) : a, Object.values($7107a818e1506aa8$export$81ee6de5033cd1db).includes(String(a)) ? a : a === "Binance-Chain-Tigris" ? "BNB" : t.filter((o)=>!!o.chainId).find((o)=>(o.chainId?.startsWith("0x") ? parseInt(o.chainId) : o.chainId) == a)?.name || null), "getBlockChainNameFromId");
async function $7107a818e1506aa8$export$ccf11e376b5e69b6(a) {
    if (await a.canEagerConnect()) return await a.connectHandler();
    throw new Error(`can't restore connection for ${a.providerName}.`);
}
$7107a818e1506aa8$var$r($7107a818e1506aa8$export$ccf11e376b5e69b6, "eagerConnectHandler");
function $7107a818e1506aa8$export$206a51934803bc71(a) {
    return a.namespace === "EVM";
}
$7107a818e1506aa8$var$r($7107a818e1506aa8$export$206a51934803bc71, "isEvmNamespace");
var $7107a818e1506aa8$var$T = class {
    static{
        $7107a818e1506aa8$var$r(this, "Wallet");
    }
    provider;
    actions;
    state;
    options;
    info;
    cleanupSubscribe;
    constructor(t, n){
        this.actions = n, this.options = t, this.provider = null, this.info = {
            supportedBlockchains: [],
            isContractWallet: !1,
            isHub: !1
        }, this.state = {
            connected: !1,
            connecting: !1,
            reachable: !1,
            installed: !1,
            accounts: null,
            network: null
        }, $7107a818e1506aa8$var$S(t) || this.setInstalledAs(!0);
    }
    async suggestAndConnect(t) {
        return this.actions.suggest && await this.actions.suggest({
            instance: this.provider,
            meta: this.info.supportedBlockchains,
            network: t
        }), await this.connect(t);
    }
    async connect(t, n) {
        if (this.state.connecting) throw new Error("Connecting...");
        let o = await this.getConnectionFromState(), i = this.state.network, s = t || i || this.options.config.defaultNetwork;
        if (o) {
            let p = i !== s && !!s;
            if (i === s) return o;
            let d = !0;
            if (this.actions.canSwitchNetworkTo && (d = this.actions.canSwitchNetworkTo({
                provider: this.provider,
                meta: this.info.supportedBlockchains,
                network: s || ""
            })), p && d && this.actions.switchNetwork) return await this.actions.switchNetwork({
                instance: this.provider,
                meta: this.info.supportedBlockchains,
                network: s,
                newInstance: this.tryGetInstance.bind(this),
                getState: this.getState.bind(this),
                updateChainId: this.updateChainId.bind(this)
            }), s !== this.state.network && !this.options.config.isAsyncSwitchNetwork && this.updateState({
                network: t
            }), {
                accounts: o.accounts,
                network: s,
                provider: this.provider
            };
        }
        let l = await this.tryGetInstance({
            network: t
        });
        this.updateState({
            connecting: !0
        }), this.setInstalledAs(!0);
        try {
            var g = await this.actions.connect({
                instance: l,
                network: s || void 0,
                meta: this.info.supportedBlockchains || [],
                namespaces: n
            });
        } catch (p) {
            throw this.resetState(), p;
        }
        this.updateState({
            connected: !0,
            reachable: !0,
            connecting: !1
        });
        let c = [], C = null, f;
        if (Array.isArray(g)) {
            let p = null;
            c = g.flatMap((h)=>{
                let v = h.chainId || "Unkown", m = $7107a818e1506aa8$export$2f76b7ab62da017c(v, this.info.supportedBlockchains) || "Unkown";
                return f = h.derivationPath ? h.derivationPath : f, !p && m !== "Unkown" && this.info.supportedBlockchains.find((w)=>w.name === m)?.info?.infoType === "EvmMetaInfo" && (p = m), $7107a818e1506aa8$var$y(h.accounts, m);
            }).filter(Boolean), C = p || s || this.options.config.defaultNetwork;
        } else {
            let p = g.chainId || "Unkown", d = $7107a818e1506aa8$export$2f76b7ab62da017c(p, this.info.supportedBlockchains) || "Unkown", h = g.derivationPath;
            c = $7107a818e1506aa8$var$y(g.accounts, d), C = d, f = h;
        }
        return c.length > 0 && this.updateState({
            accounts: c,
            network: C,
            derivationPath: f
        }), {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        };
    }
    async disconnect() {
        this.resetState(), this.actions.disconnect && this.actions.disconnect({
            instance: this.provider,
            destroyInstance: ()=>{
                this.setProvider(null);
            }
        });
    }
    async eagerConnect() {
        let t = await this.tryGetInstance({
            network: void 0
        }), { canEagerConnect: n } = this.actions, o = this.options.config.type;
        return await $7107a818e1506aa8$export$ccf11e376b5e69b6({
            canEagerConnect: async ()=>{
                if (!n) throw new Error(`${o} provider hasn't implemented canEagerConnect.`);
                return await n({
                    instance: t,
                    meta: this.info.supportedBlockchains
                });
            },
            connectHandler: async ()=>await this.connect(),
            providerName: o
        });
    }
    async getSigners(t) {
        return await this.actions.getSigners(t);
    }
    getWalletInfo(t) {
        return this.actions.getWalletInfo(t);
    }
    canSwitchNetworkTo(t, n) {
        let o = this.actions.canSwitchNetworkTo;
        return o ? o({
            network: t,
            meta: this.info.supportedBlockchains,
            provider: n
        }) : !1;
    }
    onInit() {
        if (!this.actions.getInstance) throw new Error(`Provider hasn't defined how to get wallet's instance. provider: ${this.options.config.type} on: onInit`);
        this.options.config.isAsyncInstance ? $7107a818e1506aa8$var$S(this.options) && this.actions.getInstance().then((t)=>{
            t && this.setInstalledAs(!0);
        }) : this.actions.getInstance() && !this.state.installed && this.setInstalledAs(!0);
    }
    setProvider(t) {
        if (this.provider = t, t && this.actions.subscribe) {
            let n = this.actions.subscribe({
                instance: t,
                state: this.state,
                meta: this.info.supportedBlockchains,
                connect: this.connect.bind(this),
                disconnect: this.disconnect.bind(this),
                updateAccounts: (o, i)=>{
                    let s = this.state.network;
                    i && (s = $7107a818e1506aa8$export$2f76b7ab62da017c(i, this.info.supportedBlockchains) || "Unkown");
                    let l = $7107a818e1506aa8$var$y(o, s);
                    l.length > 0 && this.updateState({
                        accounts: l
                    });
                },
                updateChainId: this.updateChainId.bind(this)
            });
            this.cleanupSubscribe = n;
        } else !t && this.cleanupSubscribe && this.cleanupSubscribe();
    }
    setInfo(t) {
        typeof t.supportedBlockchains < "u" && (this.info.supportedBlockchains = t.supportedBlockchains), typeof t.isContractWallet < "u" && (this.info.isContractWallet = t.isContractWallet);
    }
    setHandler(t) {
        this.options.handler = t;
    }
    getState() {
        return this.state;
    }
    updateState(t) {
        let n = [];
        typeof t.connected < "u" && (this.state.connected = t.connected, n.push([
            "connected",
            t.connected
        ])), typeof t.connecting < "u" && (this.state.connecting = t.connecting, n.push([
            "connecting",
            t.connecting
        ])), typeof t.reachable < "u" && (this.state.reachable = t.reachable, n.push([
            "reachable",
            t.reachable
        ])), typeof t.installed < "u" && (this.state.installed = t.installed, n.push([
            "installed",
            t.installed
        ])), typeof t.accounts < "u" && (this.state.accounts = t.accounts, this.state.derivationPath = t.derivationPath, n.push([
            "accounts",
            t.accounts
        ])), typeof t.network < "u" && (this.state.network = t.network, n.push([
            "network",
            t.network
        ]));
        let o = this.getState();
        n.forEach(([i, s])=>{
            let l = {
                supportedBlockchains: this.info.supportedBlockchains,
                isContractWallet: this.info.isContractWallet,
                isHub: !1
            };
            this.options.handler(this.options.config.type, i, s, o, l);
        });
    }
    resetState() {
        this.updateState({
            connected: !1,
            connecting: !1,
            reachable: !1,
            accounts: null,
            network: null
        });
    }
    async getConnectionFromState() {
        return this.state.connected && this.provider ? {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        } : null;
    }
    updateChainId(t) {
        let n = t ? $7107a818e1506aa8$export$2f76b7ab62da017c(t, this.info.supportedBlockchains) : "Unkown";
        this.updateState({
            network: n
        });
    }
    setInstalledAs(t) {
        !$7107a818e1506aa8$var$S(this.options) && t === !1 || this.updateState({
            installed: t
        });
    }
    async tryGetInstance({ network: t, force: n }) {
        let o = null;
        if (this.setProvider(null), this.options.config.isAsyncInstance) {
            let i = {
                currentProvider: this.provider,
                meta: this.info.supportedBlockchains,
                force: n || !1,
                updateChainId: this.updateChainId.bind(this),
                getState: this.getState.bind(this)
            };
            t && (i.network = t), o = await this.actions.getInstance(i);
        } else o = this.actions.getInstance();
        if (!o) {
            this.setInstalledAs(!1), this.resetState();
            let i = `It seems your selected wallet (${this.options.config.type}) isn't installed.`;
            throw new Error(i);
        }
        return this.setProvider(o), o;
    }
}, $7107a818e1506aa8$export$aff9e20972034897 = $7107a818e1506aa8$var$T;

});

parcelRegister("7MbFH", function(module, exports) {
$parcel$export(module.exports, "convertEvmBlockchainMetaToEvmChainInfo", function () { return (parcelRequire("fIwj6")).convertEvmBlockchainMetaToEvmChainInfo; });
$parcel$export(module.exports, "dynamicImportWithRefinedError", function () { return (parcelRequire("fIwj6")).dynamicImportWithRefinedError; });
$parcel$export(module.exports, "getSolanaAccounts", function () { return (parcelRequire("fIwj6")).getSolanaAccounts; });
$parcel$export(module.exports, "isEvmAddress", function () { return (parcelRequire("9XxdG")).isAddress; });
$parcel$export(module.exports, "timeout", function () { return (parcelRequire("fIwj6")).timeout; });
$parcel$export(module.exports, "canEagerlyConnectToEvm", function () { return (parcelRequire("gSYt0")).canEagerlyConnectToEvm; });
$parcel$export(module.exports, "canSwitchNetworkToEvm", function () { return (parcelRequire("gSYt0")).canSwitchNetworkToEvm; });
$parcel$export(module.exports, "chooseInstance", function () { return (parcelRequire("gSYt0")).chooseInstance; });
$parcel$export(module.exports, "getEvmAccounts", function () { return (parcelRequire("gSYt0")).getEvmAccounts; });
$parcel$export(module.exports, "getEvmProvider", function () { return (parcelRequire("gSYt0")).getEvmProvider; });
$parcel$export(module.exports, "getNetworkInstance", function () { return (parcelRequire("gSYt0")).getNetworkInstance; });
$parcel$export(module.exports, "subscribeToEvm", function () { return (parcelRequire("gSYt0")).subscribeToEvm; });
$parcel$export(module.exports, "switchNetworkForEvm", function () { return (parcelRequire("gSYt0")).switchNetworkForEvm; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_RPC_URL", function () { return (parcelRequire("9cRHO")).DEFAULT_ETHEREUM_RPC_URL; });
$parcel$export(module.exports, "ETHEREUM_CHAIN_ID", function () { return (parcelRequire("9cRHO")).ETHEREUM_CHAIN_ID; });
$parcel$export(module.exports, "getBlockChainNameFromId", function () { return (parcelRequire("9HEDW")).legacyGetBlockChainNameFromId; });
$parcel$export(module.exports, "Networks", function () { return (parcelRequire("9HEDW")).LegacyNetworks; });
$parcel$export(module.exports, "WalletTypes", function () { return (parcelRequire("9cRHO")).WalletTypes; });
$parcel$export(module.exports, "XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS", function () { return (parcelRequire("9cRHO")).XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS; });
$parcel$export(module.exports, "getCosmosAccounts", function () { return (parcelRequire("ehvdX")).getCosmosAccounts; });
parcelRequire("fIwj6");
parcelRequire("gSYt0");
parcelRequire("9cRHO");
parcelRequire("ehvdX");

});
parcelRegister("fIwj6", function(module, exports) {

$parcel$export(module.exports, "deepCopy", function () { return $4e2d9937c85e1191$export$6c40052bed430212; });
$parcel$export(module.exports, "switchOrAddNetworkForMetamaskCompatibleWallets", function () { return $4e2d9937c85e1191$export$56ce9af15430dcbb; });
$parcel$export(module.exports, "timeout", function () { return $4e2d9937c85e1191$export$83e74882c5df8fe1; });
$parcel$export(module.exports, "convertEvmBlockchainMetaToEvmChainInfo", function () { return $4e2d9937c85e1191$export$f0e13d51b5c692b6; });
$parcel$export(module.exports, "getSolanaAccounts", function () { return $4e2d9937c85e1191$export$a009f0f0c363aa6c; });
$parcel$export(module.exports, "dynamicImportWithRefinedError", function () { return $4e2d9937c85e1191$export$94992c0fabd8e60b; });
$parcel$export(module.exports, "isEvmAddress", function () { return (parcelRequire("9XxdG")).isAddress; });
parcelRequire("9cRHO");
var $9HEDW = parcelRequire("9HEDW");

var $9XxdG = parcelRequire("9XxdG");
function $4e2d9937c85e1191$export$6c40052bed430212(obj) {
    let copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || 'object' != typeof obj) return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for(let i = 0, len = obj.length; i < len; i++)copy[i] = $4e2d9937c85e1191$export$6c40052bed430212(obj[i]);
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        copy = {};
        for(const attr in obj)if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = $4e2d9937c85e1191$export$6c40052bed430212(obj[attr]);
        return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
async function $4e2d9937c85e1191$export$56ce9af15430dcbb(// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, network, evmNetworksChainInfo) {
    const targetChain = evmNetworksChainInfo[network];
    try {
        await instance.request({
            method: 'wallet_switchEthereumChain',
            params: [
                {
                    chainId: targetChain?.chainId
                }
            ]
        });
    } catch (switchError) {
        /*
     * @ts-ignore
     * To resolve this error: Catch clause variable type annotation must be any or unknown if specified
     */ const error = switchError;
        if (!targetChain) throw new Error(`It seems you don't have ${network} network on your wallet. Please add it manually.`);
        else if (error.code === 4902 || !error.code) {
            /*
       * Note: on WalletConnect `code` is undefined so we have to use !switchError.code as fallback.
       * This error code indicates that the chain has not been added to wallet.
       */ await instance.request({
                method: 'wallet_addEthereumChain',
                params: [
                    targetChain
                ]
            });
            // Return if target chain has been added successfully
            return;
        }
        throw switchError;
    }
}
async function $4e2d9937c85e1191$export$83e74882c5df8fe1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
forPromise, time) {
    const timeoutPromise = new Promise((_, reject)=>{
        setTimeout(()=>{
            reject('Timeout!');
        }, time);
    });
    return Promise.race([
        forPromise,
        timeoutPromise
    ]);
}
const $4e2d9937c85e1191$export$f0e13d51b5c692b6 = (evmBlockchains)=>evmBlockchains.reduce((evmNetWorksChainInfo, blockchainMeta)=>(evmNetWorksChainInfo[blockchainMeta.name] = {
            chainName: blockchainMeta.info.chainName,
            chainId: blockchainMeta.chainId,
            nativeCurrency: blockchainMeta.info.nativeCurrency,
            rpcUrls: blockchainMeta.info.rpcUrls,
            blockExplorerUrls: blockchainMeta.info.blockExplorerUrls
        }, evmNetWorksChainInfo), {});
const $4e2d9937c85e1191$export$6965bcf5cb20b5b5 = (evmNetworkChainInfo)=>{
    return Object.fromEntries(new Map(Object.keys(evmNetworkChainInfo).map((chainName)=>{
        const info = evmNetworkChainInfo[chainName];
        /*
         * This `if` is only used for satisfying typescript,
         * Because we iterating over Object.keys(EVM_NETWORKS_CHAIN_INFO)
         * And obviously it cannot be `undefined` and always has a value.
         */ if (info) return [
            parseInt(info.chainId),
            info.rpcUrls[0]
        ];
        return [
            0,
            ''
        ];
    })));
};
const $4e2d9937c85e1191$export$a009f0f0c363aa6c = async ({ instance: instance })=>{
    let account = '';
    if (instance.isConnected && instance.publicKey) account = instance.publicKey.toString();
    else {
        // Asking for account from wallet if not connected or no public key available.
        const solanaResponse = await instance.connect();
        account = solanaResponse.publicKey.toString();
    }
    return {
        accounts: [
            account
        ],
        chainId: (0, $9HEDW.LegacyNetworks).SOLANA
    };
};
function $4e2d9937c85e1191$export$83c5a315dd1cff42(wallets) {
    return wallets.sort((a, b)=>Number(b.connected) - Number(a.connected) || Number(b.extensionAvailable) - Number(a.extensionAvailable));
}
function $4e2d9937c85e1191$var$isBrave() {
    let isBrave = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const nav = navigator;
    if (nav.brave && nav.brave.isBrave) nav.brave.isBrave().then((res)=>{
        if (res) isBrave = true;
    });
    return isBrave;
}
function $4e2d9937c85e1191$export$fd0008baca2bf83d(install) {
    if (typeof install !== 'object') return install;
    let link;
    if ($4e2d9937c85e1191$var$isBrave()) link = install.BRAVE;
    else if (navigator.userAgent?.toLowerCase().indexOf('chrome') !== -1) link = install.CHROME;
    else if (navigator.userAgent?.toLowerCase().indexOf('firefox') !== -1) link = install.FIREFOX;
    else if (navigator.userAgent?.toLowerCase().indexOf('edge') !== -1) link = install.EDGE;
    return link || install.DEFAULT;
}
function $4e2d9937c85e1191$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
async function $4e2d9937c85e1191$export$94992c0fabd8e60b(importer) {
    try {
        return await importer();
    } catch (error) {
        throw new Error('A network error occurred while processing your request. Please check your internet connection or refresh the page and try again.', {
            cause: error
        });
    }
}

});
parcelRegister("9cRHO", function(module, exports) {

$parcel$export(module.exports, "WalletTypes", function () { return $4f3f4d76f30e9a91$export$b80cfa133c9c182d; });
$parcel$export(module.exports, "XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS", function () { return $4f3f4d76f30e9a91$export$7289d9aba3deaf99; });
$parcel$export(module.exports, "ETHEREUM_CHAIN_ID", function () { return $4f3f4d76f30e9a91$export$814907fc0b5ea6f0; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_RPC_URL", function () { return $4f3f4d76f30e9a91$export$4ee19c176513503a; });
$parcel$export(module.exports, "Networks", function () { return (parcelRequire("9HEDW")).LegacyNetworks; });
$parcel$export(module.exports, "getBlockChainNameFromId", function () { return (parcelRequire("9HEDW")).legacyGetBlockChainNameFromId; });

var $9HEDW = parcelRequire("9HEDW");

var $ihoyg = parcelRequire("ihoyg");
var $4f3f4d76f30e9a91$require$Buffer = $ihoyg.Buffer;
const $4f3f4d76f30e9a91$export$3fce19fdf0c5de73 = false;
const $4f3f4d76f30e9a91$export$c44b02fb03dbac82 = (buffer)=>{
    return $4f3f4d76f30e9a91$require$Buffer.from(buffer).toString('hex');
};
var $4f3f4d76f30e9a91$export$b80cfa133c9c182d = /*#__PURE__*/ function(WalletTypes) {
    WalletTypes["DEFAULT"] = "default";
    WalletTypes["META_MASK"] = "metamask";
    WalletTypes["WALLET_CONNECT_2"] = "wallet-connect-2";
    WalletTypes["TRUST_WALLET"] = "trust-wallet";
    WalletTypes["KEPLR"] = "keplr";
    WalletTypes["BINANCE"] = "binance";
    WalletTypes["PHANTOM"] = "phantom";
    WalletTypes["BITGET"] = "bitget";
    WalletTypes["TRON_LINK"] = "tron-link";
    WalletTypes["COINBASE"] = "coinbase";
    WalletTypes["XDEFI"] = "xdefi";
    WalletTypes["READY"] = "ready";
    WalletTypes["COSMOSTATION"] = "cosmostation";
    WalletTypes["COIN98"] = "coin98";
    WalletTypes["SAFEPAL"] = "safepal";
    WalletTypes["SAFE"] = "safe";
    WalletTypes["TOKEN_POCKET"] = "token-pocket";
    WalletTypes["BRAVE"] = "brave";
    WalletTypes["BRAAVOS"] = "braavos";
    WalletTypes["MATH"] = "math";
    WalletTypes["EXODUS"] = "exodus";
    WalletTypes["OKX"] = "okx";
    WalletTypes["LEAP"] = "leap";
    WalletTypes["LEAP_COSMOS"] = "leap-cosmos";
    WalletTypes["STATION"] = "station";
    WalletTypes["ENKRYPT"] = "enkrypt";
    WalletTypes["TAHO"] = "taho";
    WalletTypes["LEDGER"] = "ledger";
    WalletTypes["Rabby"] = "rabby";
    WalletTypes["TOMO"] = "tomo";
    WalletTypes["TREZOR"] = "trezor";
    WalletTypes["SOLFLARE"] = "solflare";
    WalletTypes["SLUSH"] = "slush";
    WalletTypes["TON_CONNECT"] = "tonconnect";
    WalletTypes["XVERSE"] = "xverse";
    return WalletTypes;
}({});
const $4f3f4d76f30e9a91$export$41fc20bb625e8618 = {
    EVM: {
        mainBlockchain: 'ETH',
        title: 'Ethereum',
        derivationPaths: [
            {
                id: 'metamask',
                label: `Metamask (m/44'/60'/0'/0/index)`,
                generateDerivationPath: (index)=>`44'/60'/0'/0/${index}`
            },
            {
                id: 'ledgerLive',
                label: `LedgerLive (m/44'/60'/index'/0/0)`,
                generateDerivationPath: (index)=>`44'/60'/${index}'/0/0`
            },
            {
                id: 'legacy',
                label: `Legacy (m/44'/60'/0'/index)`,
                generateDerivationPath: (index)=>`44'/60'/0'/${index}`
            }
        ]
    },
    Solana: {
        mainBlockchain: 'SOLANA',
        title: 'Solana',
        derivationPaths: [
            {
                id: `(m/44'/501'/index')`,
                label: `(m/44'/501'/index')`,
                generateDerivationPath: (index)=>`44'/501'/${index}'`
            },
            {
                id: `(m/44'/501'/0'/index)`,
                label: `(m/44'/501'/0'/index)`,
                generateDerivationPath: (index)=>`44'/501'/0'/${index}`
            }
        ]
    },
    Cosmos: {
        mainBlockchain: 'COSMOS',
        title: 'Cosmos'
    },
    UTXO: {
        title: 'UTXO',
        mainBlockchain: 'BTC'
    },
    Starknet: {
        title: 'Starknet',
        mainBlockchain: 'STARKNET'
    },
    Tron: {
        title: 'Tron',
        mainBlockchain: 'TRON'
    },
    Ton: {
        title: 'Ton',
        mainBlockchain: 'TON'
    },
    Sui: {
        mainBlockchain: 'SUI',
        title: 'Sui'
    },
    XRPL: {
        mainBlockchain: 'XRPL',
        title: 'XRPL'
    },
    Stellar: {
        mainBlockchain: 'Stellar',
        title: 'Stellar'
    }
};
const $4f3f4d76f30e9a91$export$7289d9aba3deaf99 = [
    (0, $9HEDW.LegacyNetworks).BTC,
    (0, $9HEDW.LegacyNetworks).LTC,
    (0, $9HEDW.LegacyNetworks).THORCHAIN,
    (0, $9HEDW.LegacyNetworks).BCH,
    (0, $9HEDW.LegacyNetworks).MAYA,
    (0, $9HEDW.LegacyNetworks).DOGE
];
const $4f3f4d76f30e9a91$export$12e8aeb69ff35d9 = [
    "keplr",
    "cosmostation",
    "leap-cosmos",
    "xdefi"
];
const $4f3f4d76f30e9a91$export$832fb1b437e459ec = 'https://cosmos-rpc.polkachu.com';
const $4f3f4d76f30e9a91$export$814907fc0b5ea6f0 = '0x1';
const $4f3f4d76f30e9a91$export$4ee19c176513503a = 'https://rpc.ankr.com/eth/8d43f5e842676d766141cb1943b9b4e12821f463665e180c209bd3dab9639df2';

});
parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a; }, function (v) { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d4ecdbf520e63dca$export$599f31c3813fae4d; }, function (v) { return $d4ecdbf520e63dca$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d4ecdbf520e63dca$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $034686670a8a195b$export$a48f0734ac7c2329; }, function (v) { return $034686670a8a195b$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("9XxdG", function(module, exports) {

$parcel$export(module.exports, "isAddressable", function () { return $74036477af77c863$export$6a88e03bca5eb759; });
$parcel$export(module.exports, "isAddress", function () { return $74036477af77c863$export$977e255126d763d6; });
$parcel$export(module.exports, "resolveAddress", function () { return $74036477af77c863$export$687eed6b344123c9; });

var $bCA3C = parcelRequire("bCA3C");

var $hbt3Q = parcelRequire("hbt3Q");
function $74036477af77c863$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $74036477af77c863$export$977e255126d763d6(value) {
    try {
        (0, $hbt3Q.getAddress)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $74036477af77c863$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $bCA3C.assert)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $bCA3C.assertArgument)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $hbt3Q.getAddress)(result);
}
function $74036477af77c863$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $hbt3Q.getAddress)(target);
        (0, $bCA3C.assert)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $74036477af77c863$var$checkAddress(target, resolver.resolveName(target));
    } else if ($74036477af77c863$export$6a88e03bca5eb759(target)) return $74036477af77c863$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $74036477af77c863$var$checkAddress(target, target);
    (0, $bCA3C.assertArgument)(false, "unsupported addressable value", "target", target);
}

});
parcelRegister("bCA3C", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $875f368eb239f4a3$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isCallException", function () { return $875f368eb239f4a3$export$748c4fa78f31ff35; });
$parcel$export(module.exports, "makeError", function () { return $875f368eb239f4a3$export$5a4bb2b1c89bdce7; });
$parcel$export(module.exports, "assert", function () { return $875f368eb239f4a3$export$a7a9523472993e97; });
$parcel$export(module.exports, "assertArgument", function () { return $875f368eb239f4a3$export$c3d31707e5030f5e; });
$parcel$export(module.exports, "assertArgumentCount", function () { return $875f368eb239f4a3$export$d228410a8a77e4fa; });
$parcel$export(module.exports, "assertNormalize", function () { return $875f368eb239f4a3$export$d993e67fefdfecda; });
$parcel$export(module.exports, "assertPrivate", function () { return $875f368eb239f4a3$export$ac1a938d48ec8c7b; });
/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ 
var $8UXwq = parcelRequire("8UXwq");

var $b74mN = parcelRequire("b74mN");
function $875f368eb239f4a3$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($875f368eb239f4a3$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $875f368eb239f4a3$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$875f368eb239f4a3$var$stringify(k)}: ${$875f368eb239f4a3$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $875f368eb239f4a3$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $875f368eb239f4a3$export$748c4fa78f31ff35(error) {
    return $875f368eb239f4a3$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $875f368eb239f4a3$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$875f368eb239f4a3$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $875f368eb239f4a3$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $8UXwq.version)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $b74mN.defineProperties)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $b74mN.defineProperties)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $875f368eb239f4a3$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $875f368eb239f4a3$export$5a4bb2b1c89bdce7(message, code, info);
}
function $875f368eb239f4a3$export$c3d31707e5030f5e(check, message, name, value) {
    $875f368eb239f4a3$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $875f368eb239f4a3$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $875f368eb239f4a3$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $875f368eb239f4a3$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $875f368eb239f4a3$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $875f368eb239f4a3$export$d993e67fefdfecda(form) {
    $875f368eb239f4a3$export$a7a9523472993e97($875f368eb239f4a3$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $875f368eb239f4a3$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $875f368eb239f4a3$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}

});
parcelRegister("8UXwq", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $67e1b984ae1fe502$export$83d89fbfd8236492; });
/* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $67e1b984ae1fe502$export$83d89fbfd8236492 = "6.13.2";

});

parcelRegister("b74mN", function(module, exports) {

$parcel$export(module.exports, "resolveProperties", function () { return $8173bc4630c21e05$export$d503dd157d963b60; });
$parcel$export(module.exports, "defineProperties", function () { return $8173bc4630c21e05$export$b61bda4fbca264f2; });
/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $8173bc4630c21e05$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $8173bc4630c21e05$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $8173bc4630c21e05$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $8173bc4630c21e05$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}

});


parcelRegister("hbt3Q", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $033a7be5d84d5e49$export$88411125f012957a; });
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
const $033a7be5d84d5e49$var$BN_0 = BigInt(0);
const $033a7be5d84d5e49$var$BN_36 = BigInt(36);
function $033a7be5d84d5e49$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $k39Yy.getBytes)((0, $eL5Ay.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $033a7be5d84d5e49$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$033a7be5d84d5e49$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$033a7be5d84d5e49$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $033a7be5d84d5e49$var$safeDigits = 15;
function $033a7be5d84d5e49$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $033a7be5d84d5e49$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $033a7be5d84d5e49$var$safeDigits){
        let block = expanded.substring(0, $033a7be5d84d5e49$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $033a7be5d84d5e49$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $033a7be5d84d5e49$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $033a7be5d84d5e49$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $033a7be5d84d5e49$var$BN_36 + $033a7be5d84d5e49$var$Base36[value[i]];
    return result;
}
function $033a7be5d84d5e49$export$88411125f012957a(address) {
    (0, $bCA3C.assertArgument)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $033a7be5d84d5e49$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $bCA3C.assertArgument)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $bCA3C.assertArgument)(address.substring(2, 4) === $033a7be5d84d5e49$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $033a7be5d84d5e49$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $033a7be5d84d5e49$var$getChecksumAddress("0x" + result);
    }
    (0, $bCA3C.assertArgument)(false, "invalid address", "address", address);
}
function $033a7be5d84d5e49$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($033a7be5d84d5e49$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $033a7be5d84d5e49$var$ibanChecksum("XE00" + base36) + base36;
}

});
parcelRegister("iJHOx", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("eL5Ay")).keccak256; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("DAvpQ")).sha256; });
/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ 
var $2Pxqz = parcelRequire("2Pxqz");

var $eL5Ay = parcelRequire("eL5Ay");

var $3xZm1 = parcelRequire("3xZm1");

var $lnZ4p = parcelRequire("lnZ4p");

var $7DYYs = parcelRequire("7DYYs");

var $kxPgV = parcelRequire("kxPgV");

var $DAvpQ = parcelRequire("DAvpQ");

var $hgbdt = parcelRequire("hgbdt");

var $ba4Oi = parcelRequire("ba4Oi");
/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $da3e6a8bd1a9da47$export$6a9f04c98a658ecb() {
    (0, $2Pxqz.computeHmac).lock();
    (0, $eL5Ay.keccak256).lock();
    (0, $lnZ4p.pbkdf2).lock();
    (0, $7DYYs.randomBytes).lock();
    (0, $3xZm1.ripemd160).lock();
    (0, $kxPgV.scrypt).lock();
    (0, $kxPgV.scryptSync).lock();
    (0, $DAvpQ.sha256).lock();
    (0, $DAvpQ.sha512).lock();
    (0, $7DYYs.randomBytes).lock();
}

});
parcelRegister("2Pxqz", function(module, exports) {

$parcel$export(module.exports, "computeHmac", function () { return $20fa463a78065886$export$967075d2f3b8e7ff; });
/**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ 
var $hsQHE = parcelRequire("hsQHE");

var $k39Yy = parcelRequire("k39Yy");
let $20fa463a78065886$var$locked = false;
const $20fa463a78065886$var$_computeHmac = function(algorithm, key, data) {
    return (0, $hsQHE.createHmac)(algorithm, key).update(data).digest();
};
let $20fa463a78065886$var$__computeHmac = $20fa463a78065886$var$_computeHmac;
function $20fa463a78065886$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $k39Yy.getBytes)(_key, "key");
    const data = (0, $k39Yy.getBytes)(_data, "data");
    return (0, $k39Yy.hexlify)($20fa463a78065886$var$__computeHmac(algorithm, key, data));
}
$20fa463a78065886$export$967075d2f3b8e7ff._ = $20fa463a78065886$var$_computeHmac;
$20fa463a78065886$export$967075d2f3b8e7ff.lock = function() {
    $20fa463a78065886$var$locked = true;
};
$20fa463a78065886$export$967075d2f3b8e7ff.register = function(func) {
    if ($20fa463a78065886$var$locked) throw new Error("computeHmac is locked");
    $20fa463a78065886$var$__computeHmac = func;
};
Object.freeze($20fa463a78065886$export$967075d2f3b8e7ff);

});
parcelRegister("hsQHE", function(module, exports) {

$parcel$export(module.exports, "createHash", function () { return $cb6deeef153dde1d$export$2fb37efbf6ae0c0e; });
$parcel$export(module.exports, "createHmac", function () { return $cb6deeef153dde1d$export$da39cf97e1eb7c91; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $cb6deeef153dde1d$export$b80c7ba289c8fa56; });
$parcel$export(module.exports, "randomBytes", function () { return $cb6deeef153dde1d$export$5f828d93ff035aa8; });
/* Browser Crypto Shims */ 
var $iNKdA = parcelRequire("iNKdA");

var $bWiGr = parcelRequire("bWiGr");

var $bR0s6 = parcelRequire("bR0s6");

var $eZbSS = parcelRequire("eZbSS");

var $bCA3C = parcelRequire("bCA3C");
function $cb6deeef153dde1d$var$getGlobal() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
}
const $cb6deeef153dde1d$var$anyGlobal = $cb6deeef153dde1d$var$getGlobal();
const $cb6deeef153dde1d$var$crypto = $cb6deeef153dde1d$var$anyGlobal.crypto || $cb6deeef153dde1d$var$anyGlobal.msCrypto;
function $cb6deeef153dde1d$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $bR0s6.sha256).create();
        case "sha512":
            return (0, $eZbSS.sha512).create();
    }
    (0, $bCA3C.assertArgument)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $cb6deeef153dde1d$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $bR0s6.sha256,
        sha512: $eZbSS.sha512
    }[_algo];
    (0, $bCA3C.assertArgument)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $iNKdA.hmac).create(algo, key);
}
function $cb6deeef153dde1d$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $bR0s6.sha256,
        sha512: $eZbSS.sha512
    }[_algo];
    (0, $bCA3C.assertArgument)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $bWiGr.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $cb6deeef153dde1d$export$5f828d93ff035aa8(length) {
    (0, $bCA3C.assert)($cb6deeef153dde1d$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $bCA3C.assertArgument)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $cb6deeef153dde1d$var$crypto.getRandomValues(result);
    return result;
}

});
parcelRegister("iNKdA", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $db00a788e73f74f5$export$355af40f8ab02f34; });

var $9cVci = parcelRequire("9cVci");

var $8FCYS = parcelRequire("8FCYS");
class $db00a788e73f74f5$export$7b9cf41ebec74f45 extends (0, $8FCYS.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $9cVci.hash)(hash);
        const key = (0, $8FCYS.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $9cVci.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $9cVci.exists)(this);
        (0, $9cVci.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $db00a788e73f74f5$export$355af40f8ab02f34 = (hash, key, message)=>new $db00a788e73f74f5$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$db00a788e73f74f5$export$355af40f8ab02f34.create = (hash, key)=>new $db00a788e73f74f5$export$7b9cf41ebec74f45(hash, key);

});
parcelRegister("9cVci", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $6b419a3cdd7705ea$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $6b419a3cdd7705ea$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $6b419a3cdd7705ea$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $6b419a3cdd7705ea$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $6b419a3cdd7705ea$export$c789db2c85949867; });
function $6b419a3cdd7705ea$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $6b419a3cdd7705ea$export$87b259aa03e3d267(b) {
    if (typeof b !== 'boolean') throw new Error(`Expected boolean, not ${b}`);
}
function $6b419a3cdd7705ea$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error('Expected Uint8Array');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $6b419a3cdd7705ea$export$d6af199866bfb566(hash) {
    if (typeof hash !== 'function' || typeof hash.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $6b419a3cdd7705ea$export$98e628dec113755e(hash.outputLen);
    $6b419a3cdd7705ea$export$98e628dec113755e(hash.blockLen);
}
function $6b419a3cdd7705ea$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $6b419a3cdd7705ea$export$c789db2c85949867(out, instance) {
    $6b419a3cdd7705ea$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $6b419a3cdd7705ea$var$assert = {
    number: $6b419a3cdd7705ea$export$98e628dec113755e,
    bool: $6b419a3cdd7705ea$export$87b259aa03e3d267,
    bytes: $6b419a3cdd7705ea$export$b3317979f9250576,
    hash: $6b419a3cdd7705ea$export$d6af199866bfb566,
    exists: $6b419a3cdd7705ea$export$f7e9f41ea797a17,
    output: $6b419a3cdd7705ea$export$c789db2c85949867
};
var $6b419a3cdd7705ea$export$2e2bcd8739ae039 = $6b419a3cdd7705ea$var$assert;

});

parcelRegister("8FCYS", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $650063d78919b4bc$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $650063d78919b4bc$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $650063d78919b4bc$export$466993d7d0d272aa; });
$parcel$export(module.exports, "asyncLoop", function () { return $650063d78919b4bc$export$57207d71b8c929c8; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $650063d78919b4bc$export$3df70a15530b5e81; });
$parcel$export(module.exports, "toBytes", function () { return $650063d78919b4bc$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $650063d78919b4bc$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $650063d78919b4bc$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "checkOpts", function () { return $650063d78919b4bc$export$6fcee72895eceb1e; });
$parcel$export(module.exports, "wrapConstructor", function () { return $650063d78919b4bc$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $650063d78919b4bc$export$e18964dbd6e083c1; });
$parcel$export(module.exports, "randomBytes", function () { return $650063d78919b4bc$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $5kcsi = parcelRequire("5kcsi");
const $650063d78919b4bc$var$u8a = (a)=>a instanceof Uint8Array;
const $650063d78919b4bc$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $650063d78919b4bc$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $650063d78919b4bc$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $650063d78919b4bc$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $650063d78919b4bc$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$650063d78919b4bc$export$a0f88e38d4cf9577) throw new Error('Non little-endian hardware is not supported');
const $650063d78919b4bc$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $650063d78919b4bc$export$58b867e287a802c8(bytes) {
    if (!$650063d78919b4bc$var$u8a(bytes)) throw new Error('Uint8Array expected');
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $650063d78919b4bc$var$hexes[bytes[i]];
    return hex;
}
function $650063d78919b4bc$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error('Invalid byte sequence');
        array[i] = byte;
    }
    return array;
}
const $650063d78919b4bc$export$bdd553fddd433dcb = async ()=>{};
async function $650063d78919b4bc$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $650063d78919b4bc$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $650063d78919b4bc$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $650063d78919b4bc$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $650063d78919b4bc$export$3df70a15530b5e81(data);
    if (!$650063d78919b4bc$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $650063d78919b4bc$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$650063d78919b4bc$var$u8a(a)) throw new Error('Uint8Array expected');
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $650063d78919b4bc$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $650063d78919b4bc$var$toStr = {}.toString;
function $650063d78919b4bc$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $650063d78919b4bc$var$toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $650063d78919b4bc$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($650063d78919b4bc$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $650063d78919b4bc$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($650063d78919b4bc$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $650063d78919b4bc$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($650063d78919b4bc$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $650063d78919b4bc$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $5kcsi.crypto) && typeof (0, $5kcsi.crypto).getRandomValues === 'function') return (0, $5kcsi.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("5kcsi", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $3e087b61472fb85e$export$7effb53edfc7fa2d; });
const $3e087b61472fb85e$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("bWiGr", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $8b139aaa24511b05$export$448fa22aedc9dbca; });

var $9cVci = parcelRequire("9cVci");

var $iNKdA = parcelRequire("iNKdA");

var $8FCYS = parcelRequire("8FCYS");
// Common prologue and epilogue for sync/async functions
function $8b139aaa24511b05$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $9cVci.hash)(hash);
    const opts = (0, $8FCYS.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $9cVci.number)(c);
    (0, $9cVci.number)(dkLen);
    (0, $9cVci.number)(asyncTick);
    if (c < 1) throw new Error('PBKDF2: iterations (c) should be >= 1');
    const password = (0, $8FCYS.toBytes)(_password);
    const salt = (0, $8FCYS.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = (0, $iNKdA.hmac).create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8b139aaa24511b05$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
function $8b139aaa24511b05$export$448fa22aedc9dbca(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8b139aaa24511b05$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $8FCYS.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8b139aaa24511b05$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
async function $8b139aaa24511b05$export$fda056adff0996c3(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8b139aaa24511b05$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $8FCYS.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $8FCYS.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8b139aaa24511b05$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}

});

parcelRegister("bR0s6", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $8a14febdf3a26935$export$bced8d2aada2d1c9; });

var $i3DWn = parcelRequire("i3DWn");

var $8FCYS = parcelRequire("8FCYS");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $8a14febdf3a26935$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $8a14febdf3a26935$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $8a14febdf3a26935$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $8a14febdf3a26935$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $8a14febdf3a26935$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $8a14febdf3a26935$var$SHA256 extends (0, $i3DWn.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $8a14febdf3a26935$var$IV[0] | 0;
        this.B = $8a14febdf3a26935$var$IV[1] | 0;
        this.C = $8a14febdf3a26935$var$IV[2] | 0;
        this.D = $8a14febdf3a26935$var$IV[3] | 0;
        this.E = $8a14febdf3a26935$var$IV[4] | 0;
        this.F = $8a14febdf3a26935$var$IV[5] | 0;
        this.G = $8a14febdf3a26935$var$IV[6] | 0;
        this.H = $8a14febdf3a26935$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$8a14febdf3a26935$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $8a14febdf3a26935$var$SHA256_W[i - 15];
            const W2 = $8a14febdf3a26935$var$SHA256_W[i - 2];
            const s0 = (0, $8FCYS.rotr)(W15, 7) ^ (0, $8FCYS.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $8FCYS.rotr)(W2, 17) ^ (0, $8FCYS.rotr)(W2, 19) ^ W2 >>> 10;
            $8a14febdf3a26935$var$SHA256_W[i] = s1 + $8a14febdf3a26935$var$SHA256_W[i - 7] + s0 + $8a14febdf3a26935$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $8FCYS.rotr)(E, 6) ^ (0, $8FCYS.rotr)(E, 11) ^ (0, $8FCYS.rotr)(E, 25);
            const T1 = H + sigma1 + $8a14febdf3a26935$var$Chi(E, F, G) + $8a14febdf3a26935$var$SHA256_K[i] + $8a14febdf3a26935$var$SHA256_W[i] | 0;
            const sigma0 = (0, $8FCYS.rotr)(A, 2) ^ (0, $8FCYS.rotr)(A, 13) ^ (0, $8FCYS.rotr)(A, 22);
            const T2 = sigma0 + $8a14febdf3a26935$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $8a14febdf3a26935$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $8a14febdf3a26935$var$SHA224 extends $8a14febdf3a26935$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $8a14febdf3a26935$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $8a14febdf3a26935$var$SHA256());
const $8a14febdf3a26935$export$97b70509d4e397ea = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $8a14febdf3a26935$var$SHA224());

});
parcelRegister("i3DWn", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $d2577d2a5c3aa836$export$ebbe38f24b9a0856; });

var $9cVci = parcelRequire("9cVci");

var $8FCYS = parcelRequire("8FCYS");
// Polyfill for Safari 14
function $d2577d2a5c3aa836$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $d2577d2a5c3aa836$export$ebbe38f24b9a0856 extends (0, $8FCYS.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $8FCYS.createView)(this.buffer);
    }
    update(data) {
        (0, $9cVci.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $8FCYS.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $8FCYS.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $9cVci.exists)(this);
        (0, $9cVci.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $d2577d2a5c3aa836$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $8FCYS.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});


parcelRegister("eZbSS", function(module, exports) {

$parcel$export(module.exports, "sha512", function () { return $ae8ffb25310b8bb6$export$a888d2532e6dc7bb; });

var $i3DWn = parcelRequire("i3DWn");

var $22mfl = parcelRequire("22mfl");

var $8FCYS = parcelRequire("8FCYS");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$ae8ffb25310b8bb6$var$SHA512_Kh, $ae8ffb25310b8bb6$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $22mfl.default).split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $ae8ffb25310b8bb6$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $ae8ffb25310b8bb6$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $ae8ffb25310b8bb6$export$d655fdb8a1cad5df extends (0, $i3DWn.SHA2) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $ae8ffb25310b8bb6$var$SHA512_W_H[i] = view.getUint32(offset);
            $ae8ffb25310b8bb6$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $ae8ffb25310b8bb6$var$SHA512_W_H[i - 15] | 0;
            const W15l = $ae8ffb25310b8bb6$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $22mfl.default).rotrSH(W15h, W15l, 1) ^ (0, $22mfl.default).rotrSH(W15h, W15l, 8) ^ (0, $22mfl.default).shrSH(W15h, W15l, 7);
            const s0l = (0, $22mfl.default).rotrSL(W15h, W15l, 1) ^ (0, $22mfl.default).rotrSL(W15h, W15l, 8) ^ (0, $22mfl.default).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $ae8ffb25310b8bb6$var$SHA512_W_H[i - 2] | 0;
            const W2l = $ae8ffb25310b8bb6$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $22mfl.default).rotrSH(W2h, W2l, 19) ^ (0, $22mfl.default).rotrBH(W2h, W2l, 61) ^ (0, $22mfl.default).shrSH(W2h, W2l, 6);
            const s1l = (0, $22mfl.default).rotrSL(W2h, W2l, 19) ^ (0, $22mfl.default).rotrBL(W2h, W2l, 61) ^ (0, $22mfl.default).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $22mfl.default).add4L(s0l, s1l, $ae8ffb25310b8bb6$var$SHA512_W_L[i - 7], $ae8ffb25310b8bb6$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $22mfl.default).add4H(SUMl, s0h, s1h, $ae8ffb25310b8bb6$var$SHA512_W_H[i - 7], $ae8ffb25310b8bb6$var$SHA512_W_H[i - 16]);
            $ae8ffb25310b8bb6$var$SHA512_W_H[i] = SUMh | 0;
            $ae8ffb25310b8bb6$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $22mfl.default).rotrSH(Eh, El, 14) ^ (0, $22mfl.default).rotrSH(Eh, El, 18) ^ (0, $22mfl.default).rotrBH(Eh, El, 41);
            const sigma1l = (0, $22mfl.default).rotrSL(Eh, El, 14) ^ (0, $22mfl.default).rotrSL(Eh, El, 18) ^ (0, $22mfl.default).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $22mfl.default).add5L(Hl, sigma1l, CHIl, $ae8ffb25310b8bb6$var$SHA512_Kl[i], $ae8ffb25310b8bb6$var$SHA512_W_L[i]);
            const T1h = (0, $22mfl.default).add5H(T1ll, Hh, sigma1h, CHIh, $ae8ffb25310b8bb6$var$SHA512_Kh[i], $ae8ffb25310b8bb6$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $22mfl.default).rotrSH(Ah, Al, 28) ^ (0, $22mfl.default).rotrBH(Ah, Al, 34) ^ (0, $22mfl.default).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $22mfl.default).rotrSL(Ah, Al, 28) ^ (0, $22mfl.default).rotrBL(Ah, Al, 34) ^ (0, $22mfl.default).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $22mfl.default).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $22mfl.default).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $22mfl.default).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $22mfl.default).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $22mfl.default).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $22mfl.default).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $22mfl.default).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $22mfl.default).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $22mfl.default).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $22mfl.default).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $22mfl.default).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $ae8ffb25310b8bb6$var$SHA512_W_H.fill(0);
        $ae8ffb25310b8bb6$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $ae8ffb25310b8bb6$var$SHA512_224 extends $ae8ffb25310b8bb6$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $ae8ffb25310b8bb6$var$SHA512_256 extends $ae8ffb25310b8bb6$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $ae8ffb25310b8bb6$var$SHA384 extends $ae8ffb25310b8bb6$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $ae8ffb25310b8bb6$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $ae8ffb25310b8bb6$export$d655fdb8a1cad5df());
const $ae8ffb25310b8bb6$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $ae8ffb25310b8bb6$var$SHA512_224());
const $ae8ffb25310b8bb6$export$c78786b6da86db2a = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $ae8ffb25310b8bb6$var$SHA512_256());
const $ae8ffb25310b8bb6$export$612d47d55dedde45 = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $ae8ffb25310b8bb6$var$SHA384());

});
parcelRegister("22mfl", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $17bd066120b9d2c7$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $17bd066120b9d2c7$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $17bd066120b9d2c7$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $17bd066120b9d2c7$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $17bd066120b9d2c7$export$5d12cc1da441323f; });
$parcel$export(module.exports, "default", function () { return $17bd066120b9d2c7$export$2e2bcd8739ae039; });
const $17bd066120b9d2c7$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $17bd066120b9d2c7$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $17bd066120b9d2c7$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $17bd066120b9d2c7$var$U32_MASK64),
        l: Number(n >> $17bd066120b9d2c7$var$_32n & $17bd066120b9d2c7$var$U32_MASK64)
    };
    return {
        h: Number(n >> $17bd066120b9d2c7$var$_32n & $17bd066120b9d2c7$var$U32_MASK64) | 0,
        l: Number(n & $17bd066120b9d2c7$var$U32_MASK64) | 0
    };
}
function $17bd066120b9d2c7$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $17bd066120b9d2c7$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $17bd066120b9d2c7$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $17bd066120b9d2c7$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $17bd066120b9d2c7$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $17bd066120b9d2c7$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $17bd066120b9d2c7$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $17bd066120b9d2c7$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $17bd066120b9d2c7$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $17bd066120b9d2c7$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $17bd066120b9d2c7$export$a088d44bd387d2a3 = (_h, l)=>l;
const $17bd066120b9d2c7$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $17bd066120b9d2c7$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $17bd066120b9d2c7$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $17bd066120b9d2c7$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $17bd066120b9d2c7$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $17bd066120b9d2c7$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $17bd066120b9d2c7$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $17bd066120b9d2c7$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $17bd066120b9d2c7$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $17bd066120b9d2c7$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $17bd066120b9d2c7$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $17bd066120b9d2c7$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $17bd066120b9d2c7$var$u64 = {
    fromBig: $17bd066120b9d2c7$export$9625d4333cb56c3f,
    split: $17bd066120b9d2c7$export$65980d18b75784e2,
    toBig: $17bd066120b9d2c7$export$30f78adcaaa2eb7,
    shrSH: $17bd066120b9d2c7$export$75aa78dc5bd52853,
    shrSL: $17bd066120b9d2c7$export$a0225ff0aee14e25,
    rotrSH: $17bd066120b9d2c7$export$97f812dfd830ca87,
    rotrSL: $17bd066120b9d2c7$export$60987e30e2c9d9d,
    rotrBH: $17bd066120b9d2c7$export$af9c7fbac44dcb76,
    rotrBL: $17bd066120b9d2c7$export$f619171d6d5ac414,
    rotr32H: $17bd066120b9d2c7$export$a088d44bd387d2a3,
    rotr32L: $17bd066120b9d2c7$export$8415aae4d1f69577,
    rotlSH: $17bd066120b9d2c7$export$4b80a2917447870e,
    rotlSL: $17bd066120b9d2c7$export$20652918a7b63b3,
    rotlBH: $17bd066120b9d2c7$export$a52f14bf902f9977,
    rotlBL: $17bd066120b9d2c7$export$5d12cc1da441323f,
    add: $17bd066120b9d2c7$export$e16d8520af44a096,
    add3L: $17bd066120b9d2c7$export$c0c22b91f08911f,
    add3H: $17bd066120b9d2c7$export$ef7b26044977a8ec,
    add4L: $17bd066120b9d2c7$export$2f4e199c560f545d,
    add4H: $17bd066120b9d2c7$export$e909220d675a7741,
    add5H: $17bd066120b9d2c7$export$b45ee8d78c965098,
    add5L: $17bd066120b9d2c7$export$d732b061fe9c9ae4
};
var $17bd066120b9d2c7$export$2e2bcd8739ae039 = $17bd066120b9d2c7$var$u64;

});



parcelRegister("k39Yy", function(module, exports) {

$parcel$export(module.exports, "getBytes", function () { return $e98bd3663e2f682d$export$a3521add2594f3c8; });
$parcel$export(module.exports, "getBytesCopy", function () { return $e98bd3663e2f682d$export$37110e7fee0af4ad; });
$parcel$export(module.exports, "isHexString", function () { return $e98bd3663e2f682d$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytesLike", function () { return $e98bd3663e2f682d$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "hexlify", function () { return $e98bd3663e2f682d$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "concat", function () { return $e98bd3663e2f682d$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "dataLength", function () { return $e98bd3663e2f682d$export$2321cd91b99770ff; });
$parcel$export(module.exports, "dataSlice", function () { return $e98bd3663e2f682d$export$f6d845ffb449edc9; });
$parcel$export(module.exports, "zeroPadValue", function () { return $e98bd3663e2f682d$export$4473860254365feb; });
$parcel$export(module.exports, "zeroPadBytes", function () { return $e98bd3663e2f682d$export$1dc7fbe1b8738fe7; });
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
var $bCA3C = parcelRequire("bCA3C");
function $e98bd3663e2f682d$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $bCA3C.assertArgument)(false, "invalid BytesLike value", name || "value", value);
}
function $e98bd3663e2f682d$export$a3521add2594f3c8(value, name) {
    return $e98bd3663e2f682d$var$_getBytes(value, name, false);
}
function $e98bd3663e2f682d$export$37110e7fee0af4ad(value, name) {
    return $e98bd3663e2f682d$var$_getBytes(value, name, true);
}
function $e98bd3663e2f682d$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $e98bd3663e2f682d$export$9a14abb1a440cd5e(value) {
    return $e98bd3663e2f682d$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $e98bd3663e2f682d$var$HexCharacters = "0123456789abcdef";
function $e98bd3663e2f682d$export$2b0d6b5fbe698c70(data) {
    const bytes = $e98bd3663e2f682d$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $e98bd3663e2f682d$var$HexCharacters[(v & 0xf0) >> 4] + $e98bd3663e2f682d$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $e98bd3663e2f682d$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$e98bd3663e2f682d$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $e98bd3663e2f682d$export$2321cd91b99770ff(data) {
    if ($e98bd3663e2f682d$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $e98bd3663e2f682d$export$a3521add2594f3c8(data).length;
}
function $e98bd3663e2f682d$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $e98bd3663e2f682d$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $bCA3C.assert)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $e98bd3663e2f682d$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $e98bd3663e2f682d$export$9c854001a22ebaa2(data) {
    let bytes = $e98bd3663e2f682d$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $e98bd3663e2f682d$var$zeroPad(data, length, left) {
    const bytes = $e98bd3663e2f682d$export$a3521add2594f3c8(data);
    (0, $bCA3C.assert)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $e98bd3663e2f682d$export$2b0d6b5fbe698c70(result);
}
function $e98bd3663e2f682d$export$4473860254365feb(data, length) {
    return $e98bd3663e2f682d$var$zeroPad(data, length, true);
}
function $e98bd3663e2f682d$export$1dc7fbe1b8738fe7(data, length) {
    return $e98bd3663e2f682d$var$zeroPad(data, length, false);
}

});


parcelRegister("eL5Ay", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $abe9ca45ee6046d9$export$f8151fce47ad1c35; });
/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ 
var $gJtMk = parcelRequire("gJtMk");

var $k39Yy = parcelRequire("k39Yy");
let $abe9ca45ee6046d9$var$locked = false;
const $abe9ca45ee6046d9$var$_keccak256 = function(data) {
    return (0, $gJtMk.keccak_256)(data);
};
let $abe9ca45ee6046d9$var$__keccak256 = $abe9ca45ee6046d9$var$_keccak256;
function $abe9ca45ee6046d9$export$f8151fce47ad1c35(_data) {
    const data = (0, $k39Yy.getBytes)(_data, "data");
    return (0, $k39Yy.hexlify)($abe9ca45ee6046d9$var$__keccak256(data));
}
$abe9ca45ee6046d9$export$f8151fce47ad1c35._ = $abe9ca45ee6046d9$var$_keccak256;
$abe9ca45ee6046d9$export$f8151fce47ad1c35.lock = function() {
    $abe9ca45ee6046d9$var$locked = true;
};
$abe9ca45ee6046d9$export$f8151fce47ad1c35.register = function(func) {
    if ($abe9ca45ee6046d9$var$locked) throw new TypeError("keccak256 is locked");
    $abe9ca45ee6046d9$var$__keccak256 = func;
};
Object.freeze($abe9ca45ee6046d9$export$f8151fce47ad1c35);

});
parcelRegister("gJtMk", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $c2e7f2ac72cc47d3$export$860ddaa9ca84a66d; });

var $9cVci = parcelRequire("9cVci");

var $22mfl = parcelRequire("22mfl");

var $8FCYS = parcelRequire("8FCYS");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$c2e7f2ac72cc47d3$var$SHA3_PI, $c2e7f2ac72cc47d3$var$SHA3_ROTL, $c2e7f2ac72cc47d3$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $c2e7f2ac72cc47d3$var$_0n = /* @__PURE__ */ BigInt(0);
const $c2e7f2ac72cc47d3$var$_1n = /* @__PURE__ */ BigInt(1);
const $c2e7f2ac72cc47d3$var$_2n = /* @__PURE__ */ BigInt(2);
const $c2e7f2ac72cc47d3$var$_7n = /* @__PURE__ */ BigInt(7);
const $c2e7f2ac72cc47d3$var$_256n = /* @__PURE__ */ BigInt(256);
const $c2e7f2ac72cc47d3$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $c2e7f2ac72cc47d3$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $c2e7f2ac72cc47d3$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $c2e7f2ac72cc47d3$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $c2e7f2ac72cc47d3$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $c2e7f2ac72cc47d3$var$_1n ^ (R >> $c2e7f2ac72cc47d3$var$_7n) * $c2e7f2ac72cc47d3$var$_0x71n) % $c2e7f2ac72cc47d3$var$_256n;
        if (R & $c2e7f2ac72cc47d3$var$_2n) t ^= $c2e7f2ac72cc47d3$var$_1n << ($c2e7f2ac72cc47d3$var$_1n << /* @__PURE__ */ BigInt(j)) - $c2e7f2ac72cc47d3$var$_1n;
    }
    $c2e7f2ac72cc47d3$var$_SHA3_IOTA.push(t);
}
const [$c2e7f2ac72cc47d3$var$SHA3_IOTA_H, $c2e7f2ac72cc47d3$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $22mfl.split)($c2e7f2ac72cc47d3$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $c2e7f2ac72cc47d3$var$rotlH = (h, l, s)=>s > 32 ? (0, $22mfl.rotlBH)(h, l, s) : (0, $22mfl.rotlSH)(h, l, s);
const $c2e7f2ac72cc47d3$var$rotlL = (h, l, s)=>s > 32 ? (0, $22mfl.rotlBL)(h, l, s) : (0, $22mfl.rotlSL)(h, l, s);
function $c2e7f2ac72cc47d3$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $c2e7f2ac72cc47d3$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $c2e7f2ac72cc47d3$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $c2e7f2ac72cc47d3$var$SHA3_ROTL[t];
            const Th = $c2e7f2ac72cc47d3$var$rotlH(curH, curL, shift);
            const Tl = $c2e7f2ac72cc47d3$var$rotlL(curH, curL, shift);
            const PI = $c2e7f2ac72cc47d3$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $c2e7f2ac72cc47d3$var$SHA3_IOTA_H[round];
        s[1] ^= $c2e7f2ac72cc47d3$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e extends (0, $8FCYS.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $9cVci.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = (0, $8FCYS.u32)(this.state);
    }
    keccak() {
        $c2e7f2ac72cc47d3$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $9cVci.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $8FCYS.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $9cVci.exists)(this, false);
        (0, $9cVci.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $9cVci.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $9cVci.output)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $c2e7f2ac72cc47d3$var$gen = (suffix, blockLen, outputLen)=>(0, $8FCYS.wrapConstructor)(()=>new $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $c2e7f2ac72cc47d3$export$fe6c2b96a79338e9 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 144, 28);
const $c2e7f2ac72cc47d3$export$76e19b6966813b14 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 136, 32);
const $c2e7f2ac72cc47d3$export$a58509fa80f30d15 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 104, 48);
const $c2e7f2ac72cc47d3$export$20ed324dbdf09b7c = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 72, 64);
const $c2e7f2ac72cc47d3$export$2f7fb3c6fac246bc = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 144, 28);
const $c2e7f2ac72cc47d3$export$860ddaa9ca84a66d = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 136, 32);
const $c2e7f2ac72cc47d3$export$46fcdeb4c5686552 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 104, 48);
const $c2e7f2ac72cc47d3$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 72, 64);
const $c2e7f2ac72cc47d3$var$genShake = (suffix, blockLen, outputLen)=>(0, $8FCYS.wrapXOFConstructorWithOpts)((opts = {})=>new $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $c2e7f2ac72cc47d3$export$f43dc3bb86efbba2 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$genShake(0x1f, 168, 16);
const $c2e7f2ac72cc47d3$export$c240d011f1520440 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$genShake(0x1f, 136, 32);

});


parcelRegister("3xZm1", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $29540bd79a8f30ac$export$d1cea0ee4e3f0d3e; });

var $cWFXn = parcelRequire("cWFXn");

var $k39Yy = parcelRequire("k39Yy");
let $29540bd79a8f30ac$var$locked = false;
const $29540bd79a8f30ac$var$_ripemd160 = function(data) {
    return (0, $cWFXn.ripemd160)(data);
};
let $29540bd79a8f30ac$var$__ripemd160 = $29540bd79a8f30ac$var$_ripemd160;
function $29540bd79a8f30ac$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $k39Yy.getBytes)(_data, "data");
    return (0, $k39Yy.hexlify)($29540bd79a8f30ac$var$__ripemd160(data));
}
$29540bd79a8f30ac$export$d1cea0ee4e3f0d3e._ = $29540bd79a8f30ac$var$_ripemd160;
$29540bd79a8f30ac$export$d1cea0ee4e3f0d3e.lock = function() {
    $29540bd79a8f30ac$var$locked = true;
};
$29540bd79a8f30ac$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($29540bd79a8f30ac$var$locked) throw new TypeError("ripemd160 is locked");
    $29540bd79a8f30ac$var$__ripemd160 = func;
};
Object.freeze($29540bd79a8f30ac$export$d1cea0ee4e3f0d3e);

});
parcelRegister("cWFXn", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $96cb7285c7772e2c$export$d1cea0ee4e3f0d3e; });

var $i3DWn = parcelRequire("i3DWn");

var $8FCYS = parcelRequire("8FCYS");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $96cb7285c7772e2c$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $96cb7285c7772e2c$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $96cb7285c7772e2c$var$Pi = /* @__PURE__ */ $96cb7285c7772e2c$var$Id.map((i)=>(9 * i + 5) % 16);
let $96cb7285c7772e2c$var$idxL = [
    $96cb7285c7772e2c$var$Id
];
let $96cb7285c7772e2c$var$idxR = [
    $96cb7285c7772e2c$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $96cb7285c7772e2c$var$idxL,
    $96cb7285c7772e2c$var$idxR
])j.push(j[i].map((k)=>$96cb7285c7772e2c$var$Rho[k]));
const $96cb7285c7772e2c$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $96cb7285c7772e2c$var$shiftsL = /* @__PURE__ */ $96cb7285c7772e2c$var$idxL.map((idx, i)=>idx.map((j)=>$96cb7285c7772e2c$var$shifts[i][j]));
const $96cb7285c7772e2c$var$shiftsR = /* @__PURE__ */ $96cb7285c7772e2c$var$idxR.map((idx, i)=>idx.map((j)=>$96cb7285c7772e2c$var$shifts[i][j]));
const $96cb7285c7772e2c$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $96cb7285c7772e2c$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $96cb7285c7772e2c$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $96cb7285c7772e2c$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $96cb7285c7772e2c$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $96cb7285c7772e2c$export$7b0ccd21718381c9 extends (0, $i3DWn.SHA2) {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$96cb7285c7772e2c$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $96cb7285c7772e2c$var$Kl[group], hbr = $96cb7285c7772e2c$var$Kr[group]; // prettier-ignore
            const rl = $96cb7285c7772e2c$var$idxL[group], rr = $96cb7285c7772e2c$var$idxR[group]; // prettier-ignore
            const sl = $96cb7285c7772e2c$var$shiftsL[group], sr = $96cb7285c7772e2c$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $96cb7285c7772e2c$var$rotl(al + $96cb7285c7772e2c$var$f(group, bl, cl, dl) + $96cb7285c7772e2c$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $96cb7285c7772e2c$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $96cb7285c7772e2c$var$rotl(ar + $96cb7285c7772e2c$var$f(rGroup, br, cr, dr) + $96cb7285c7772e2c$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $96cb7285c7772e2c$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $96cb7285c7772e2c$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
const $96cb7285c7772e2c$export$d1cea0ee4e3f0d3e = /* @__PURE__ */ (0, $8FCYS.wrapConstructor)(()=>new $96cb7285c7772e2c$export$7b0ccd21718381c9());

});


parcelRegister("lnZ4p", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $f91b1e3034067996$export$448fa22aedc9dbca; });
/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 
var $hsQHE = parcelRequire("hsQHE");

var $k39Yy = parcelRequire("k39Yy");
let $f91b1e3034067996$var$locked = false;
const $f91b1e3034067996$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $hsQHE.pbkdf2Sync)(password, salt, iterations, keylen, algo);
};
let $f91b1e3034067996$var$__pbkdf2 = $f91b1e3034067996$var$_pbkdf2;
function $f91b1e3034067996$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $k39Yy.getBytes)(_password, "password");
    const salt = (0, $k39Yy.getBytes)(_salt, "salt");
    return (0, $k39Yy.hexlify)($f91b1e3034067996$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$f91b1e3034067996$export$448fa22aedc9dbca._ = $f91b1e3034067996$var$_pbkdf2;
$f91b1e3034067996$export$448fa22aedc9dbca.lock = function() {
    $f91b1e3034067996$var$locked = true;
};
$f91b1e3034067996$export$448fa22aedc9dbca.register = function(func) {
    if ($f91b1e3034067996$var$locked) throw new Error("pbkdf2 is locked");
    $f91b1e3034067996$var$__pbkdf2 = func;
};
Object.freeze($f91b1e3034067996$export$448fa22aedc9dbca);

});

parcelRegister("7DYYs", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $590b791864644cce$export$5f828d93ff035aa8; });
/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
var $hsQHE = parcelRequire("hsQHE");
let $590b791864644cce$var$locked = false;
const $590b791864644cce$var$_randomBytes = function(length) {
    return new Uint8Array((0, $hsQHE.randomBytes)(length));
};
let $590b791864644cce$var$__randomBytes = $590b791864644cce$var$_randomBytes;
function $590b791864644cce$export$5f828d93ff035aa8(length) {
    return $590b791864644cce$var$__randomBytes(length);
}
$590b791864644cce$export$5f828d93ff035aa8._ = $590b791864644cce$var$_randomBytes;
$590b791864644cce$export$5f828d93ff035aa8.lock = function() {
    $590b791864644cce$var$locked = true;
};
$590b791864644cce$export$5f828d93ff035aa8.register = function(func) {
    if ($590b791864644cce$var$locked) throw new Error("randomBytes is locked");
    $590b791864644cce$var$__randomBytes = func;
};
Object.freeze($590b791864644cce$export$5f828d93ff035aa8);

});

parcelRegister("kxPgV", function(module, exports) {

$parcel$export(module.exports, "scrypt", function () { return $ef4ea9440846434f$export$7cf7c2f1ec457bf3; });
$parcel$export(module.exports, "scryptSync", function () { return $ef4ea9440846434f$export$86c79e0734c26a76; });

var $9wZFO = parcelRequire("9wZFO");

var $k39Yy = parcelRequire("k39Yy");
let $ef4ea9440846434f$var$lockedSync = false, $ef4ea9440846434f$var$lockedAsync = false;
const $ef4ea9440846434f$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $9wZFO.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $ef4ea9440846434f$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $9wZFO.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $ef4ea9440846434f$var$__scryptAsync = $ef4ea9440846434f$var$_scryptAsync;
let $ef4ea9440846434f$var$__scryptSync = $ef4ea9440846434f$var$_scryptSync;
async function $ef4ea9440846434f$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $k39Yy.getBytes)(_passwd, "passwd");
    const salt = (0, $k39Yy.getBytes)(_salt, "salt");
    return (0, $k39Yy.hexlify)(await $ef4ea9440846434f$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$ef4ea9440846434f$export$7cf7c2f1ec457bf3._ = $ef4ea9440846434f$var$_scryptAsync;
$ef4ea9440846434f$export$7cf7c2f1ec457bf3.lock = function() {
    $ef4ea9440846434f$var$lockedAsync = true;
};
$ef4ea9440846434f$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($ef4ea9440846434f$var$lockedAsync) throw new Error("scrypt is locked");
    $ef4ea9440846434f$var$__scryptAsync = func;
};
Object.freeze($ef4ea9440846434f$export$7cf7c2f1ec457bf3);
function $ef4ea9440846434f$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $k39Yy.getBytes)(_passwd, "passwd");
    const salt = (0, $k39Yy.getBytes)(_salt, "salt");
    return (0, $k39Yy.hexlify)($ef4ea9440846434f$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$ef4ea9440846434f$export$86c79e0734c26a76._ = $ef4ea9440846434f$var$_scryptSync;
$ef4ea9440846434f$export$86c79e0734c26a76.lock = function() {
    $ef4ea9440846434f$var$lockedSync = true;
};
$ef4ea9440846434f$export$86c79e0734c26a76.register = function(func) {
    if ($ef4ea9440846434f$var$lockedSync) throw new Error("scryptSync is locked");
    $ef4ea9440846434f$var$__scryptSync = func;
};
Object.freeze($ef4ea9440846434f$export$86c79e0734c26a76);

});
parcelRegister("9wZFO", function(module, exports) {

$parcel$export(module.exports, "scrypt", function () { return $6f06f13ea722a0cf$export$7cf7c2f1ec457bf3; });
$parcel$export(module.exports, "scryptAsync", function () { return $6f06f13ea722a0cf$export$aaeeb1df7f0390e8; });

var $9cVci = parcelRequire("9cVci");

var $bR0s6 = parcelRequire("bR0s6");

var $bWiGr = parcelRequire("bWiGr");

var $8FCYS = parcelRequire("8FCYS");
// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $6f06f13ea722a0cf$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $6f06f13ea722a0cf$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $6f06f13ea722a0cf$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $6f06f13ea722a0cf$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $6f06f13ea722a0cf$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $6f06f13ea722a0cf$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $6f06f13ea722a0cf$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $6f06f13ea722a0cf$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $6f06f13ea722a0cf$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $6f06f13ea722a0cf$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $6f06f13ea722a0cf$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $6f06f13ea722a0cf$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $6f06f13ea722a0cf$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $6f06f13ea722a0cf$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $6f06f13ea722a0cf$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $6f06f13ea722a0cf$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $6f06f13ea722a0cf$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $6f06f13ea722a0cf$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $6f06f13ea722a0cf$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $6f06f13ea722a0cf$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $6f06f13ea722a0cf$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $6f06f13ea722a0cf$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $6f06f13ea722a0cf$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $6f06f13ea722a0cf$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $6f06f13ea722a0cf$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $6f06f13ea722a0cf$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $6f06f13ea722a0cf$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $6f06f13ea722a0cf$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $6f06f13ea722a0cf$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $6f06f13ea722a0cf$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $6f06f13ea722a0cf$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $6f06f13ea722a0cf$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $6f06f13ea722a0cf$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $6f06f13ea722a0cf$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $6f06f13ea722a0cf$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $6f06f13ea722a0cf$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $6f06f13ea722a0cf$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $6f06f13ea722a0cf$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $8FCYS.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $9cVci.number)(N);
    (0, $9cVci.number)(r);
    (0, $9cVci.number)(p);
    (0, $9cVci.number)(dkLen);
    (0, $9cVci.number)(asyncTick);
    (0, $9cVci.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== 'function') throw new Error('progressCb should be function');
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error('Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32');
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error('Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)');
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error('Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32');
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $bWiGr.pbkdf2)((0, $bR0s6.sha256), password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $8FCYS.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $8FCYS.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $8FCYS.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $6f06f13ea722a0cf$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $bWiGr.pbkdf2)((0, $bR0s6.sha256), password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
function $6f06f13ea722a0cf$export$7cf7c2f1ec457bf3(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $6f06f13ea722a0cf$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $6f06f13ea722a0cf$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $6f06f13ea722a0cf$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $6f06f13ea722a0cf$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $6f06f13ea722a0cf$var$scryptOutput(password, dkLen, B, V, tmp);
}
async function $6f06f13ea722a0cf$export$aaeeb1df7f0390e8(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $6f06f13ea722a0cf$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $8FCYS.asyncLoop)(N - 1, asyncTick, ()=>{
            $6f06f13ea722a0cf$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $6f06f13ea722a0cf$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $8FCYS.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $6f06f13ea722a0cf$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $6f06f13ea722a0cf$var$scryptOutput(password, dkLen, B, V, tmp);
}

});


parcelRegister("DAvpQ", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $076ff5e7ff8ef8a3$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $076ff5e7ff8ef8a3$export$a888d2532e6dc7bb; });

var $hsQHE = parcelRequire("hsQHE");

var $k39Yy = parcelRequire("k39Yy");
const $076ff5e7ff8ef8a3$var$_sha256 = function(data) {
    return (0, $hsQHE.createHash)("sha256").update(data).digest();
};
const $076ff5e7ff8ef8a3$var$_sha512 = function(data) {
    return (0, $hsQHE.createHash)("sha512").update(data).digest();
};
let $076ff5e7ff8ef8a3$var$__sha256 = $076ff5e7ff8ef8a3$var$_sha256;
let $076ff5e7ff8ef8a3$var$__sha512 = $076ff5e7ff8ef8a3$var$_sha512;
let $076ff5e7ff8ef8a3$var$locked256 = false, $076ff5e7ff8ef8a3$var$locked512 = false;
function $076ff5e7ff8ef8a3$export$bced8d2aada2d1c9(_data) {
    const data = (0, $k39Yy.getBytes)(_data, "data");
    return (0, $k39Yy.hexlify)($076ff5e7ff8ef8a3$var$__sha256(data));
}
$076ff5e7ff8ef8a3$export$bced8d2aada2d1c9._ = $076ff5e7ff8ef8a3$var$_sha256;
$076ff5e7ff8ef8a3$export$bced8d2aada2d1c9.lock = function() {
    $076ff5e7ff8ef8a3$var$locked256 = true;
};
$076ff5e7ff8ef8a3$export$bced8d2aada2d1c9.register = function(func) {
    if ($076ff5e7ff8ef8a3$var$locked256) throw new Error("sha256 is locked");
    $076ff5e7ff8ef8a3$var$__sha256 = func;
};
Object.freeze($076ff5e7ff8ef8a3$export$bced8d2aada2d1c9);
function $076ff5e7ff8ef8a3$export$a888d2532e6dc7bb(_data) {
    const data = (0, $k39Yy.getBytes)(_data, "data");
    return (0, $k39Yy.hexlify)($076ff5e7ff8ef8a3$var$__sha512(data));
}
$076ff5e7ff8ef8a3$export$a888d2532e6dc7bb._ = $076ff5e7ff8ef8a3$var$_sha512;
$076ff5e7ff8ef8a3$export$a888d2532e6dc7bb.lock = function() {
    $076ff5e7ff8ef8a3$var$locked512 = true;
};
$076ff5e7ff8ef8a3$export$a888d2532e6dc7bb.register = function(func) {
    if ($076ff5e7ff8ef8a3$var$locked512) throw new Error("sha512 is locked");
    $076ff5e7ff8ef8a3$var$__sha512 = func;
};
Object.freeze($076ff5e7ff8ef8a3$export$bced8d2aada2d1c9);

});

parcelRegister("hgbdt", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $c90ca1a25834517b$export$21643ca94aed3e83; });
/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ 
var $75Cpc = parcelRequire("75Cpc");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $ltdtW = parcelRequire("ltdtW");

var $ba4Oi = parcelRequire("ba4Oi");
class $c90ca1a25834517b$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataLength)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $k39Yy.hexlify)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $c90ca1a25834517b$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $c90ca1a25834517b$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $75Cpc.secp256k1).sign((0, $k39Yy.getBytesCopy)(digest), (0, $k39Yy.getBytesCopy)(this.#privateKey), {
            lowS: true
        });
        return (0, $ba4Oi.Signature).from({
            r: (0, $ltdtW.toBeHex)(sig.r, 32),
            s: (0, $ltdtW.toBeHex)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $c90ca1a25834517b$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $k39Yy.hexlify)((0, $75Cpc.secp256k1).getSharedSecret((0, $k39Yy.getBytesCopy)(this.#privateKey), (0, $k39Yy.getBytes)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $k39Yy.getBytes)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $75Cpc.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, $k39Yy.hexlify)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $75Cpc.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, $k39Yy.hexlify)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $ba4Oi.Signature).from(signature);
        let secpSig = (0, $75Cpc.secp256k1).Signature.fromCompact((0, $k39Yy.getBytesCopy)((0, $k39Yy.concat)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $k39Yy.getBytesCopy)(digest));
        (0, $bCA3C.assertArgument)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $75Cpc.secp256k1).ProjectivePoint.fromHex($c90ca1a25834517b$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $75Cpc.secp256k1).ProjectivePoint.fromHex($c90ca1a25834517b$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}

});
parcelRegister("75Cpc", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $5296ca8b936039b9$export$529e6123e9353a90; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $bR0s6 = parcelRequire("bR0s6");

var $8FCYS = parcelRequire("8FCYS");

var $bHBcf = parcelRequire("bHBcf");

var $cUT9o = parcelRequire("cUT9o");

var $1jejV = parcelRequire("1jejV");

var $43eum = parcelRequire("43eum");

var $8bHDj = parcelRequire("8bHDj");
const $5296ca8b936039b9$var$secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
const $5296ca8b936039b9$var$secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
const $5296ca8b936039b9$var$_1n = BigInt(1);
const $5296ca8b936039b9$var$_2n = BigInt(2);
const $5296ca8b936039b9$var$divNearest = (a, b)=>(a + b / $5296ca8b936039b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $5296ca8b936039b9$var$sqrtMod(y) {
    const P = $5296ca8b936039b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $bHBcf.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $bHBcf.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $bHBcf.pow2)(b9, $5296ca8b936039b9$var$_2n, P) * b2 % P;
    const b22 = (0, $bHBcf.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $bHBcf.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $bHBcf.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $bHBcf.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $bHBcf.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $bHBcf.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $bHBcf.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $bHBcf.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $bHBcf.pow2)(t2, $5296ca8b936039b9$var$_2n, P);
    if (!$5296ca8b936039b9$var$Fp.eql($5296ca8b936039b9$var$Fp.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $5296ca8b936039b9$var$Fp = (0, $bHBcf.Field)($5296ca8b936039b9$var$secp256k1P, undefined, undefined, {
    sqrt: $5296ca8b936039b9$var$sqrtMod
});
const $5296ca8b936039b9$export$529e6123e9353a90 = (0, $8bHDj.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $5296ca8b936039b9$var$Fp,
    n: $5296ca8b936039b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: (k)=>{
            const n = $5296ca8b936039b9$var$secp256k1N;
            const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            const b1 = -$5296ca8b936039b9$var$_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            const b2 = a1;
            const POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            const c1 = $5296ca8b936039b9$var$divNearest(b2 * k, n);
            const c2 = $5296ca8b936039b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $bHBcf.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $bHBcf.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error('splitScalar: Endomorphism failed, k=' + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $bR0s6.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $5296ca8b936039b9$var$_0n = BigInt(0);
const $5296ca8b936039b9$var$fe = (x)=>typeof x === 'bigint' && $5296ca8b936039b9$var$_0n < x && x < $5296ca8b936039b9$var$secp256k1P;
const $5296ca8b936039b9$var$ge = (x)=>typeof x === 'bigint' && $5296ca8b936039b9$var$_0n < x && x < $5296ca8b936039b9$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $5296ca8b936039b9$var$TAGGED_HASH_PREFIXES = {};
function $5296ca8b936039b9$var$taggedHash(tag, ...messages) {
    let tagP = $5296ca8b936039b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $bR0s6.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $1jejV.concatBytes)(tagH, tagH);
        $5296ca8b936039b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $bR0s6.sha256)((0, $1jejV.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $5296ca8b936039b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $5296ca8b936039b9$var$numTo32b = (n)=>(0, $1jejV.numberToBytesBE)(n, 32);
const $5296ca8b936039b9$var$modP = (x)=>(0, $bHBcf.mod)(x, $5296ca8b936039b9$var$secp256k1P);
const $5296ca8b936039b9$var$modN = (x)=>(0, $bHBcf.mod)(x, $5296ca8b936039b9$var$secp256k1N);
const $5296ca8b936039b9$var$Point = $5296ca8b936039b9$export$529e6123e9353a90.ProjectivePoint;
const $5296ca8b936039b9$var$GmulAdd = (Q, a, b)=>$5296ca8b936039b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $5296ca8b936039b9$var$schnorrGetExtPubKey(priv) {
    let d_ = $5296ca8b936039b9$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $5296ca8b936039b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $5296ca8b936039b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $5296ca8b936039b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $5296ca8b936039b9$var$lift_x(x) {
    if (!$5296ca8b936039b9$var$fe(x)) throw new Error('bad x: need 0 < x < p'); // Fail if x ≥ p.
    const xx = $5296ca8b936039b9$var$modP(x * x);
    const c = $5296ca8b936039b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $5296ca8b936039b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $5296ca8b936039b9$var$_2n !== $5296ca8b936039b9$var$_0n) y = $5296ca8b936039b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $5296ca8b936039b9$var$Point(x, y, $5296ca8b936039b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $5296ca8b936039b9$var$challenge(...args) {
    return $5296ca8b936039b9$var$modN((0, $1jejV.bytesToNumberBE)($5296ca8b936039b9$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $5296ca8b936039b9$var$schnorrGetPublicKey(privateKey) {
    return $5296ca8b936039b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $5296ca8b936039b9$var$schnorrSign(message, privateKey, auxRand = (0, $8FCYS.randomBytes)(32)) {
    const m = (0, $1jejV.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = $5296ca8b936039b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $1jejV.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $5296ca8b936039b9$var$numTo32b(d ^ (0, $1jejV.bytesToNumberBE)($5296ca8b936039b9$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $5296ca8b936039b9$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $5296ca8b936039b9$var$modN((0, $1jejV.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $5296ca8b936039b9$var$_0n) throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $5296ca8b936039b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $5296ca8b936039b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($5296ca8b936039b9$var$numTo32b($5296ca8b936039b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$5296ca8b936039b9$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $5296ca8b936039b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $1jejV.ensureBytes)('signature', signature, 64);
    const m = (0, $1jejV.ensureBytes)('message', message);
    const pub = (0, $1jejV.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = $5296ca8b936039b9$var$lift_x((0, $1jejV.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $1jejV.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$5296ca8b936039b9$var$fe(r)) return false;
        const s = (0, $1jejV.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$5296ca8b936039b9$var$ge(s)) return false;
        const e = $5296ca8b936039b9$var$challenge($5296ca8b936039b9$var$numTo32b(r), $5296ca8b936039b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $5296ca8b936039b9$var$GmulAdd(P, s, $5296ca8b936039b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $5296ca8b936039b9$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $5296ca8b936039b9$var$schnorrGetPublicKey,
        sign: $5296ca8b936039b9$var$schnorrSign,
        verify: $5296ca8b936039b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: $5296ca8b936039b9$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $5296ca8b936039b9$var$lift_x,
            pointToBytes: $5296ca8b936039b9$var$pointToBytes,
            numberToBytesBE: $1jejV.numberToBytesBE,
            bytesToNumberBE: $1jejV.bytesToNumberBE,
            taggedHash: $5296ca8b936039b9$var$taggedHash,
            mod: $bHBcf.mod
        }
    }))();
const $5296ca8b936039b9$var$isoMap = /* @__PURE__ */ (()=>(0, $43eum.isogenyMap)($5296ca8b936039b9$var$Fp, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $5296ca8b936039b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $cUT9o.mapToCurveSimpleSWU)($5296ca8b936039b9$var$Fp, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $5296ca8b936039b9$var$Fp.create(BigInt('-11'))
    }))();
const $5296ca8b936039b9$var$htf = /* @__PURE__ */ (()=>(0, $43eum.createHasher)($5296ca8b936039b9$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $5296ca8b936039b9$var$mapSWU($5296ca8b936039b9$var$Fp.create(scalars[0]));
        return $5296ca8b936039b9$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $5296ca8b936039b9$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $bR0s6.sha256)
    }))();
const $5296ca8b936039b9$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$5296ca8b936039b9$var$htf.hashToCurve)();
const $5296ca8b936039b9$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$5296ca8b936039b9$var$htf.encodeToCurve)();

});
parcelRegister("bHBcf", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $8850904c61e4dc45$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow", function () { return $8850904c61e4dc45$export$9c297f60e22e3389; });
$parcel$export(module.exports, "pow2", function () { return $8850904c61e4dc45$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $8850904c61e4dc45$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "isNegativeLE", function () { return $8850904c61e4dc45$export$7806f13ad5078b2f; });
$parcel$export(module.exports, "validateField", function () { return $8850904c61e4dc45$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $8850904c61e4dc45$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $8850904c61e4dc45$export$a455218a85c89869; });
$parcel$export(module.exports, "FpSqrtEven", function () { return $8850904c61e4dc45$export$1d7b691df0888e02; });
$parcel$export(module.exports, "getMinHashLength", function () { return $8850904c61e4dc45$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $8850904c61e4dc45$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $1jejV = parcelRequire("1jejV");
// prettier-ignore
const $8850904c61e4dc45$var$_0n = BigInt(0), $8850904c61e4dc45$var$_1n = BigInt(1), $8850904c61e4dc45$var$_2n = BigInt(2), $8850904c61e4dc45$var$_3n = BigInt(3);
// prettier-ignore
const $8850904c61e4dc45$var$_4n = BigInt(4), $8850904c61e4dc45$var$_5n = BigInt(5), $8850904c61e4dc45$var$_8n = BigInt(8);
// prettier-ignore
const $8850904c61e4dc45$var$_9n = BigInt(9), $8850904c61e4dc45$var$_16n = BigInt(16);
function $8850904c61e4dc45$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $8850904c61e4dc45$var$_0n ? result : b + result;
}
function $8850904c61e4dc45$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $8850904c61e4dc45$var$_0n || power < $8850904c61e4dc45$var$_0n) throw new Error('Expected power/modulo > 0');
    if (modulo === $8850904c61e4dc45$var$_1n) return $8850904c61e4dc45$var$_0n;
    let res = $8850904c61e4dc45$var$_1n;
    while(power > $8850904c61e4dc45$var$_0n){
        if (power & $8850904c61e4dc45$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8850904c61e4dc45$var$_1n;
    }
    return res;
}
function $8850904c61e4dc45$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $8850904c61e4dc45$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $8850904c61e4dc45$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $8850904c61e4dc45$var$_0n || modulo <= $8850904c61e4dc45$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $8850904c61e4dc45$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $8850904c61e4dc45$var$_0n, y = $8850904c61e4dc45$var$_1n, u = $8850904c61e4dc45$var$_1n, v = $8850904c61e4dc45$var$_0n;
    while(a !== $8850904c61e4dc45$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $8850904c61e4dc45$var$_1n) throw new Error('invert: does not exist');
    return $8850904c61e4dc45$export$842a2cf37af977e1(x, modulo);
}
function $8850904c61e4dc45$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8850904c61e4dc45$var$_1n, S = 0; Q % $8850904c61e4dc45$var$_2n === $8850904c61e4dc45$var$_0n; Q /= $8850904c61e4dc45$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8850904c61e4dc45$var$_2n; Z < P && $8850904c61e4dc45$export$9c297f60e22e3389(Z, legendreC, P) !== P - $8850904c61e4dc45$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error('Cannot find square root');
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $8850904c61e4dc45$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $8850904c61e4dc45$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8850904c61e4dc45$var$_4n === $8850904c61e4dc45$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8850904c61e4dc45$var$_8n === $8850904c61e4dc45$var$_5n) {
        const c1 = (P - $8850904c61e4dc45$var$_5n) / $8850904c61e4dc45$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $8850904c61e4dc45$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $8850904c61e4dc45$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8850904c61e4dc45$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8850904c61e4dc45$export$69f29ab1f3e9a234(P);
}
const $8850904c61e4dc45$export$7806f13ad5078b2f = (num, modulo)=>($8850904c61e4dc45$export$842a2cf37af977e1(num, modulo) & $8850904c61e4dc45$var$_1n) === $8850904c61e4dc45$var$_1n;
// prettier-ignore
const $8850904c61e4dc45$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $8850904c61e4dc45$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger'
    };
    const opts = $8850904c61e4dc45$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    return (0, $1jejV.validateObject)(field, opts);
}
function $8850904c61e4dc45$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8850904c61e4dc45$var$_0n) throw new Error('Expected power > 0');
    if (power === $8850904c61e4dc45$var$_0n) return f.ONE;
    if (power === $8850904c61e4dc45$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $8850904c61e4dc45$var$_0n){
        if (power & $8850904c61e4dc45$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8850904c61e4dc45$var$_1n;
    }
    return p;
}
function $8850904c61e4dc45$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8850904c61e4dc45$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? $8850904c61e4dc45$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $8850904c61e4dc45$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $8850904c61e4dc45$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $8850904c61e4dc45$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $8850904c61e4dc45$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $8850904c61e4dc45$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error('Field lengths over 2048 bytes are not supported');
    const sqrtP = $8850904c61e4dc45$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $1jejV.bitMask)(BITS),
        ZERO: $8850904c61e4dc45$var$_0n,
        ONE: $8850904c61e4dc45$var$_1n,
        create: (num)=>$8850904c61e4dc45$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $8850904c61e4dc45$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $8850904c61e4dc45$var$_0n,
        isOdd: (num)=>(num & $8850904c61e4dc45$var$_1n) === $8850904c61e4dc45$var$_1n,
        neg: (num)=>$8850904c61e4dc45$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$8850904c61e4dc45$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$8850904c61e4dc45$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs * $8850904c61e4dc45$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$8850904c61e4dc45$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$8850904c61e4dc45$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $1jejV.numberToBytesLE)(num, BYTES) : (0, $1jejV.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $1jejV.bytesToNumberLE)(bytes) : (0, $1jejV.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8850904c61e4dc45$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8850904c61e4dc45$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $8850904c61e4dc45$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $1jejV.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $8850904c61e4dc45$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $1jejV.bytesToNumberLE)(hash) : (0, $1jejV.bytesToNumberBE)(hash);
    return $8850904c61e4dc45$export$842a2cf37af977e1(num, groupOrder - $8850904c61e4dc45$var$_1n) + $8850904c61e4dc45$var$_1n;
}
function $8850904c61e4dc45$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $8850904c61e4dc45$export$d058763b563056af(fieldOrder) {
    const length = $8850904c61e4dc45$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $8850904c61e4dc45$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $8850904c61e4dc45$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $8850904c61e4dc45$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $1jejV.bytesToNumberBE)(key) : (0, $1jejV.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $8850904c61e4dc45$export$842a2cf37af977e1(num, fieldOrder - $8850904c61e4dc45$var$_1n) + $8850904c61e4dc45$var$_1n;
    return isLE ? (0, $1jejV.numberToBytesLE)(reduced, fieldLen) : (0, $1jejV.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("1jejV", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $0f42ac80af044784$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $0f42ac80af044784$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $0f42ac80af044784$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $0f42ac80af044784$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $0f42ac80af044784$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $0f42ac80af044784$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $0f42ac80af044784$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $0f42ac80af044784$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $0f42ac80af044784$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $0f42ac80af044784$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $0f42ac80af044784$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $0f42ac80af044784$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $0f42ac80af044784$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $0f42ac80af044784$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $0f42ac80af044784$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $0f42ac80af044784$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $0f42ac80af044784$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $0f42ac80af044784$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $0f42ac80af044784$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $0f42ac80af044784$var$_0n = BigInt(0);
const $0f42ac80af044784$var$_1n = BigInt(1);
const $0f42ac80af044784$var$_2n = BigInt(2);
const $0f42ac80af044784$var$u8a = (a)=>a instanceof Uint8Array;
const $0f42ac80af044784$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $0f42ac80af044784$export$58b867e287a802c8(bytes) {
    if (!$0f42ac80af044784$var$u8a(bytes)) throw new Error('Uint8Array expected');
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $0f42ac80af044784$var$hexes[bytes[i]];
    return hex;
}
function $0f42ac80af044784$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $0f42ac80af044784$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // Big Endian
    return BigInt(hex === '' ? '0' : `0x${hex}`);
}
function $0f42ac80af044784$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error('Invalid byte sequence');
        array[i] = byte;
    }
    return array;
}
function $0f42ac80af044784$export$d609354794974f8(bytes) {
    return $0f42ac80af044784$export$d57f2bacc26b4249($0f42ac80af044784$export$58b867e287a802c8(bytes));
}
function $0f42ac80af044784$export$d67b1d03392107e7(bytes) {
    if (!$0f42ac80af044784$var$u8a(bytes)) throw new Error('Uint8Array expected');
    return $0f42ac80af044784$export$d57f2bacc26b4249($0f42ac80af044784$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $0f42ac80af044784$export$1459dafd057611cb(n, len) {
    return $0f42ac80af044784$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, '0'));
}
function $0f42ac80af044784$export$ba2172e58d139f6d(n, len) {
    return $0f42ac80af044784$export$1459dafd057611cb(n, len).reverse();
}
function $0f42ac80af044784$export$80ee8c1914de6dde(n) {
    return $0f42ac80af044784$export$31c96b9df38bc8d4($0f42ac80af044784$export$4ed2545b622827c1(n));
}
function $0f42ac80af044784$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = $0f42ac80af044784$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($0f42ac80af044784$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $0f42ac80af044784$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$0f42ac80af044784$var$u8a(a)) throw new Error('Uint8Array expected');
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $0f42ac80af044784$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $0f42ac80af044784$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $0f42ac80af044784$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $0f42ac80af044784$var$_0n; n >>= $0f42ac80af044784$var$_1n, len += 1);
    return len;
}
function $0f42ac80af044784$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $0f42ac80af044784$var$_1n;
}
const $0f42ac80af044784$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $0f42ac80af044784$var$_1n : $0f42ac80af044784$var$_0n) << BigInt(pos);
};
const $0f42ac80af044784$export$803efa2fa1c7279 = (n)=>($0f42ac80af044784$var$_2n << BigInt(n - 1)) - $0f42ac80af044784$var$_1n;
// DRBG
const $0f42ac80af044784$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $0f42ac80af044784$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $0f42ac80af044784$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $0f42ac80af044784$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $0f42ac80af044784$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $0f42ac80af044784$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($0f42ac80af044784$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($0f42ac80af044784$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $0f42ac80af044784$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $0f42ac80af044784$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
function $0f42ac80af044784$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $0f42ac80af044784$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("cUT9o", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $96757ebae6de2114$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $96757ebae6de2114$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");

var $9DLjl = parcelRequire("9DLjl");
function $96757ebae6de2114$var$validatePointOpts(curve) {
    const opts = (0, $9DLjl.validateBasic)(curve);
    $1jejV.validateObject(opts, {
        a: 'field',
        b: 'field'
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function'
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error('Endomorphism can only be defined for Koblitz curves that have a=0');
        if (typeof endo !== 'object' || typeof endo.beta !== 'bigint' || typeof endo.splitScalar !== 'function') throw new Error('Expected endomorphism with beta: bigint and splitScalar: function');
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $96757ebae6de2114$var$b2n, hexToBytes: $96757ebae6de2114$var$h2b } = $1jejV;
const $96757ebae6de2114$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ''){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $96757ebae6de2114$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E('Invalid signature integer tag');
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E('Invalid signature integer: wrong length');
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E('Invalid signature integer: negative');
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E('Invalid signature integer: unnecessary leading zero');
        return {
            d: $96757ebae6de2114$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $96757ebae6de2114$export$56ac33195d7076db;
        const data = typeof hex === 'string' ? $96757ebae6de2114$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error('ui8a expected');
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E('Invalid signature tag');
        if (data[1] !== l - 2) throw new E('Invalid signature: incorrect length');
        const { d: r, l: sBytes } = $96757ebae6de2114$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $96757ebae6de2114$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E('Invalid signature: left bytes after parsing');
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? '00' + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $96757ebae6de2114$var$_0n = BigInt(0), $96757ebae6de2114$var$_1n = BigInt(1), $96757ebae6de2114$var$_2n = BigInt(2), $96757ebae6de2114$var$_3n = BigInt(3), $96757ebae6de2114$var$_4n = BigInt(4);
function $96757ebae6de2114$export$fa783af82e4fe0fc(opts) {
    const CURVE = $96757ebae6de2114$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $1jejV.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === 'bigint' && $96757ebae6de2114$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error('Expected valid bigint: 0 < bigint < curve.n');
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== 'bigint') {
            if (key instanceof Uint8Array) key = $1jejV.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length)) throw new Error('Invalid key');
            key = key.padStart(nByteLength * 2, '0');
        }
        let num;
        try {
            num = typeof key === 'bigint' ? key : $1jejV.bytesToNumberBE((0, $1jejV.ensureBytes)('private key', key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $bHBcf.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error('x required');
            if (py == null || !Fp.isValid(py)) throw new Error('y required');
            if (pz == null || !Fp.isValid(pz)) throw new Error('z required');
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $1jejV.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error('bad point: ZERO');
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not FE');
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error('bad point: equation left != right');
            if (!this.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $96757ebae6de2114$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $96757ebae6de2114$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $96757ebae6de2114$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $96757ebae6de2114$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $96757ebae6de2114$var$_0n || k2 > $96757ebae6de2114$var$_0n){
                if (k1 & $96757ebae6de2114$var$_1n) k1p = k1p.add(d);
                if (k2 & $96757ebae6de2114$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $96757ebae6de2114$var$_1n;
                k2 >>= $96757ebae6de2114$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $96757ebae6de2114$var$_0n || a === $96757ebae6de2114$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $96757ebae6de2114$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $96757ebae6de2114$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $1jejV.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $9DLjl.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $96757ebae6de2114$var$validateOpts(curve) {
    const opts = (0, $9DLjl.validateBasic)(curve);
    $1jejV.validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function'
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean'
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $96757ebae6de2114$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $96757ebae6de2114$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $96757ebae6de2114$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $bHBcf.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $bHBcf.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $96757ebae6de2114$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $1jejV.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $1jejV.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error('Point is not on curve');
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $96757ebae6de2114$var$_1n) === $96757ebae6de2114$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$1jejV.bytesToHex($1jejV.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $96757ebae6de2114$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$1jejV.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $1jejV.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $96757ebae6de2114$export$56ac33195d7076db.toSig((0, $1jejV.ensureBytes)('DER', hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error('r must be 0 < r < CURVE.n');
            if (!isWithinCurveOrder(this.s)) throw new Error('s must be 0 < s < CURVE.n');
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $1jejV.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error('recovery id 2 or 3 invalid');
            const prefix = (rec & 1) === 0 ? '02' : '03';
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $1jejV.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $96757ebae6de2114$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $1jejV.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $bHBcf.getMinHashLength(CURVE.n);
            return $bHBcf.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === 'string';
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error('first arg must be private key');
        if (!isProbPub(publicB)) throw new Error('second arg must be public key');
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $1jejV.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $1jejV.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== 'bigint') throw new Error('bigint expected');
        if (!($96757ebae6de2114$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $1jejV.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $1jejV.ensureBytes)('msgHash', msgHash);
        if (prehash) msgHash = (0, $1jejV.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $1jejV.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = $1jejV.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $96757ebae6de2114$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $96757ebae6de2114$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $96757ebae6de2114$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $1jejV.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $1jejV.ensureBytes)('msgHash', msgHash);
        publicKey = (0, $1jejV.ensureBytes)('publicKey', publicKey);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === 'string' || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $96757ebae6de2114$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint') {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error('PARSE');
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === 'PARSE') throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $96757ebae6de2114$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $96757ebae6de2114$var$_0n;
    for(let o = q - $96757ebae6de2114$var$_1n; o % $96757ebae6de2114$var$_2n === $96757ebae6de2114$var$_0n; o /= $96757ebae6de2114$var$_2n)l += $96757ebae6de2114$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $96757ebae6de2114$var$_2n << c1 - $96757ebae6de2114$var$_1n - $96757ebae6de2114$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $96757ebae6de2114$var$_2n;
    const c2 = (q - $96757ebae6de2114$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $96757ebae6de2114$var$_1n) / $96757ebae6de2114$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $96757ebae6de2114$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $96757ebae6de2114$var$_1n) / $96757ebae6de2114$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $96757ebae6de2114$var$_1n; i--){
            let tv5 = i - $96757ebae6de2114$var$_2n; // 18.    tv5 = i - 2
            tv5 = $96757ebae6de2114$var$_2n << tv5 - $96757ebae6de2114$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $96757ebae6de2114$var$_4n === $96757ebae6de2114$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $96757ebae6de2114$var$_3n) / $96757ebae6de2114$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $96757ebae6de2114$export$cc7fea9756a17416(Fp, opts) {
    $bHBcf.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $96757ebae6de2114$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("9DLjl", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $bHBcf.validateField)(curve.Fp);
    (0, $1jejV.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $bHBcf.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});


parcelRegister("43eum", function(module, exports) {

$parcel$export(module.exports, "expand_message_xmd", function () { return $2f32ae64234d5d04$export$3df78c69af9fc85d; });
$parcel$export(module.exports, "isogenyMap", function () { return $2f32ae64234d5d04$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $2f32ae64234d5d04$export$14b114effbc08b6b; });

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");
function $2f32ae64234d5d04$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === 'string') return (0, $1jejV.utf8ToBytes)(dst);
    throw new Error('DST must be Uint8Array or string');
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $2f32ae64234d5d04$var$os2ip = (0, $1jejV.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $2f32ae64234d5d04$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $2f32ae64234d5d04$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $2f32ae64234d5d04$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error('Uint8Array expected');
}
function $2f32ae64234d5d04$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
function $2f32ae64234d5d04$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $2f32ae64234d5d04$var$isBytes(msg);
    $2f32ae64234d5d04$var$isBytes(DST);
    $2f32ae64234d5d04$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $1jejV.concatBytes)((0, $1jejV.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error('Invalid xmd length');
    const DST_prime = (0, $1jejV.concatBytes)(DST, $2f32ae64234d5d04$var$i2osp(DST.length, 1));
    const Z_pad = $2f32ae64234d5d04$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $2f32ae64234d5d04$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $1jejV.concatBytes)(Z_pad, msg, l_i_b_str, $2f32ae64234d5d04$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $1jejV.concatBytes)(b_0, $2f32ae64234d5d04$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $2f32ae64234d5d04$var$strxor(b_0, b[i - 1]),
            $2f32ae64234d5d04$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $1jejV.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $1jejV.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $2f32ae64234d5d04$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $2f32ae64234d5d04$var$isBytes(msg);
    $2f32ae64234d5d04$var$isBytes(DST);
    $2f32ae64234d5d04$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $1jejV.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($2f32ae64234d5d04$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($2f32ae64234d5d04$var$i2osp(DST.length, 1)).digest();
}
function $2f32ae64234d5d04$export$97cdd5ee18de8172(msg, count, options) {
    (0, $1jejV.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $2f32ae64234d5d04$var$isBytes(msg);
    $2f32ae64234d5d04$var$isNum(count);
    const DST = $2f32ae64234d5d04$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $2f32ae64234d5d04$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $2f32ae64234d5d04$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $bHBcf.mod)($2f32ae64234d5d04$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $2f32ae64234d5d04$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $2f32ae64234d5d04$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $2f32ae64234d5d04$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $2f32ae64234d5d04$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("8bHDj", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $0189d364cc74de23$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $iNKdA = parcelRequire("iNKdA");

var $8FCYS = parcelRequire("8FCYS");

var $cUT9o = parcelRequire("cUT9o");
function $0189d364cc74de23$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $iNKdA.hmac)(hash, key, (0, $8FCYS.concatBytes)(...msgs)),
        randomBytes: $8FCYS.randomBytes
    };
}
function $0189d364cc74de23$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $cUT9o.weierstrass)({
            ...curveDef,
            ...$0189d364cc74de23$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});


parcelRegister("ltdtW", function(module, exports) {

$parcel$export(module.exports, "fromTwos", function () { return $fa16c3a527819cdd$export$92182edcfa20e5bc; });
$parcel$export(module.exports, "getNumber", function () { return $fa16c3a527819cdd$export$b14f2714108df84; });
$parcel$export(module.exports, "toTwos", function () { return $fa16c3a527819cdd$export$7101cd4e6275351c; });
$parcel$export(module.exports, "getBigInt", function () { return $fa16c3a527819cdd$export$61fe455e2b1e28a4; });
$parcel$export(module.exports, "mask", function () { return $fa16c3a527819cdd$export$d99f0801a68bbcf1; });
$parcel$export(module.exports, "toBigInt", function () { return $fa16c3a527819cdd$export$c221a145703ab783; });
$parcel$export(module.exports, "toNumber", function () { return $fa16c3a527819cdd$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "toBeHex", function () { return $fa16c3a527819cdd$export$c6ebe05badb16181; });
$parcel$export(module.exports, "toBeArray", function () { return $fa16c3a527819cdd$export$b627fcfb5ea68cb0; });
$parcel$export(module.exports, "toQuantity", function () { return $fa16c3a527819cdd$export$d9c067986dbc68dd; });
/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 
var $k39Yy = parcelRequire("k39Yy");

var $bCA3C = parcelRequire("bCA3C");
const $fa16c3a527819cdd$var$BN_0 = BigInt(0);
const $fa16c3a527819cdd$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $fa16c3a527819cdd$var$maxValue = 0x1fffffffffffff;
function $fa16c3a527819cdd$export$92182edcfa20e5bc(_value, _width) {
    const value = $fa16c3a527819cdd$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($fa16c3a527819cdd$export$b14f2714108df84(_width, "width"));
    (0, $bCA3C.assert)(value >> width === $fa16c3a527819cdd$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $fa16c3a527819cdd$var$BN_1) {
        const mask = ($fa16c3a527819cdd$var$BN_1 << width) - $fa16c3a527819cdd$var$BN_1;
        return -((~value & mask) + $fa16c3a527819cdd$var$BN_1);
    }
    return value;
}
function $fa16c3a527819cdd$export$7101cd4e6275351c(_value, _width) {
    let value = $fa16c3a527819cdd$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($fa16c3a527819cdd$export$b14f2714108df84(_width, "width"));
    const limit = $fa16c3a527819cdd$var$BN_1 << width - $fa16c3a527819cdd$var$BN_1;
    if (value < $fa16c3a527819cdd$var$BN_0) {
        value = -value;
        (0, $bCA3C.assert)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($fa16c3a527819cdd$var$BN_1 << width) - $fa16c3a527819cdd$var$BN_1;
        return (~value & mask) + $fa16c3a527819cdd$var$BN_1;
    } else (0, $bCA3C.assert)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $fa16c3a527819cdd$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $fa16c3a527819cdd$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($fa16c3a527819cdd$export$b14f2714108df84(_bits, "bits"));
    return value & ($fa16c3a527819cdd$var$BN_1 << bits) - $fa16c3a527819cdd$var$BN_1;
}
function $fa16c3a527819cdd$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $bCA3C.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $bCA3C.assertArgument)(value >= -$fa16c3a527819cdd$var$maxValue && value <= $fa16c3a527819cdd$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $bCA3C.assertArgument)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $bCA3C.assertArgument)(false, "invalid BigNumberish value", name || "value", value);
}
function $fa16c3a527819cdd$export$8677d6ca9282a154(value, name) {
    const result = $fa16c3a527819cdd$export$61fe455e2b1e28a4(value, name);
    (0, $bCA3C.assert)(result >= $fa16c3a527819cdd$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $fa16c3a527819cdd$var$Nibbles = "0123456789abcdef";
function $fa16c3a527819cdd$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $fa16c3a527819cdd$var$Nibbles[v >> 4];
            result += $fa16c3a527819cdd$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $fa16c3a527819cdd$export$61fe455e2b1e28a4(value);
}
function $fa16c3a527819cdd$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $bCA3C.assertArgument)(value >= -$fa16c3a527819cdd$var$maxValue && value <= $fa16c3a527819cdd$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $bCA3C.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $bCA3C.assertArgument)(value >= -$fa16c3a527819cdd$var$maxValue && value <= $fa16c3a527819cdd$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $fa16c3a527819cdd$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $bCA3C.assertArgument)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $bCA3C.assertArgument)(false, "invalid numeric value", name || "value", value);
}
function $fa16c3a527819cdd$export$a0a81dc3380ce7d3(value) {
    return $fa16c3a527819cdd$export$b14f2714108df84($fa16c3a527819cdd$export$c221a145703ab783(value));
}
function $fa16c3a527819cdd$export$c6ebe05badb16181(_value, _width) {
    const value = $fa16c3a527819cdd$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $fa16c3a527819cdd$export$b14f2714108df84(_width, "width");
        (0, $bCA3C.assert)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $fa16c3a527819cdd$export$b627fcfb5ea68cb0(_value) {
    const value = $fa16c3a527819cdd$export$8677d6ca9282a154(_value, "value");
    if (value === $fa16c3a527819cdd$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $fa16c3a527819cdd$export$d9c067986dbc68dd(value) {
    let result = (0, $k39Yy.hexlify)((0, $k39Yy.isBytesLike)(value) ? value : $fa16c3a527819cdd$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}

});

parcelRegister("ba4Oi", function(module, exports) {

$parcel$export(module.exports, "Signature", function () { return $82045c1b12ef9a99$export$848620f5f2f26e86; });

var $b16e4 = parcelRequire("b16e4");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $ltdtW = parcelRequire("ltdtW");
// Constants
const $82045c1b12ef9a99$var$BN_0 = BigInt(0);
const $82045c1b12ef9a99$var$BN_1 = BigInt(1);
const $82045c1b12ef9a99$var$BN_2 = BigInt(2);
const $82045c1b12ef9a99$var$BN_27 = BigInt(27);
const $82045c1b12ef9a99$var$BN_28 = BigInt(28);
const $82045c1b12ef9a99$var$BN_35 = BigInt(35);
const $82045c1b12ef9a99$var$_guard = {};
function $82045c1b12ef9a99$var$toUint256(value) {
    return (0, $k39Yy.zeroPadValue)((0, $ltdtW.toBeArray)(value), 32);
}
class $82045c1b12ef9a99$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataLength)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $k39Yy.hexlify)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataLength)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $k39Yy.hexlify)(_value);
        (0, $bCA3C.assertArgument)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $ltdtW.getNumber)(value, "value");
        (0, $bCA3C.assertArgument)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $82045c1b12ef9a99$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $k39Yy.getBytes)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $k39Yy.hexlify)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $k39Yy.concat)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $k39Yy.concat)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $bCA3C.assertPrivate)(guard, $82045c1b12ef9a99$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $82045c1b12ef9a99$export$848620f5f2f26e86($82045c1b12ef9a99$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $ltdtW.getBigInt)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $82045c1b12ef9a99$var$BN_27 || bv == $82045c1b12ef9a99$var$BN_28) return $82045c1b12ef9a99$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $bCA3C.assertArgument)(bv >= $82045c1b12ef9a99$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $82045c1b12ef9a99$var$BN_35) / $82045c1b12ef9a99$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $ltdtW.getBigInt)(chainId) * $82045c1b12ef9a99$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $ltdtW.getBigInt)(v);
        if (bv === $82045c1b12ef9a99$var$BN_0 || bv === $82045c1b12ef9a99$var$BN_27) return 27;
        if (bv === $82045c1b12ef9a99$var$BN_1 || bv === $82045c1b12ef9a99$var$BN_28) return 28;
        (0, $bCA3C.assertArgument)(bv >= $82045c1b12ef9a99$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $82045c1b12ef9a99$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $bCA3C.assertArgument)(check, message, "signature", sig);
        }
        if (sig == null) return new $82045c1b12ef9a99$export$848620f5f2f26e86($82045c1b12ef9a99$var$_guard, (0, $b16e4.ZeroHash), (0, $b16e4.ZeroHash), 27);
        if (typeof sig === "string") {
            const bytes = (0, $k39Yy.getBytes)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $k39Yy.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $82045c1b12ef9a99$export$848620f5f2f26e86($82045c1b12ef9a99$var$_guard, r, (0, $k39Yy.hexlify)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $k39Yy.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $82045c1b12ef9a99$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $82045c1b12ef9a99$export$848620f5f2f26e86($82045c1b12ef9a99$var$_guard, r, (0, $k39Yy.hexlify)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $82045c1b12ef9a99$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $82045c1b12ef9a99$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $82045c1b12ef9a99$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $k39Yy.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $k39Yy.getBytes)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $k39Yy.hexlify)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $k39Yy.getBytes)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $ltdtW.getBigInt)(_v);
                return {
                    networkV: v >= $82045c1b12ef9a99$var$BN_35 ? v : undefined,
                    v: $82045c1b12ef9a99$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $k39Yy.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $k39Yy.getBytes)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $ltdtW.getNumber)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $82045c1b12ef9a99$export$848620f5f2f26e86($82045c1b12ef9a99$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $ltdtW.getNumber)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}

});
parcelRegister("b16e4", function(module, exports) {

$parcel$export(module.exports, "ZeroHash", function () { return $80549e0a6667510d$export$89c2533b29c23a61; });
/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $80549e0a6667510d$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});







parcelRegister("gSYt0", function(module, exports) {

$parcel$export(module.exports, "getEvmAccounts", function () { return $a13dc2b4f56bc81b$export$785cd5e95d0717c1; });
$parcel$export(module.exports, "subscribeToEvm", function () { return $a13dc2b4f56bc81b$export$dae4ecb17c5c4020; });
$parcel$export(module.exports, "canEagerlyConnectToEvm", function () { return $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c; });
$parcel$export(module.exports, "switchNetworkForEvm", function () { return $a13dc2b4f56bc81b$export$394219efce660c44; });
$parcel$export(module.exports, "getNetworkInstance", function () { return $a13dc2b4f56bc81b$export$2029b78bc980a576; });
$parcel$export(module.exports, "canSwitchNetworkToEvm", function () { return $a13dc2b4f56bc81b$export$86abff8ce014c125; });
$parcel$export(module.exports, "chooseInstance", function () { return $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3; });
$parcel$export(module.exports, "getEvmProvider", function () { return $a13dc2b4f56bc81b$export$2515b173249f2353; });
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9cRHO");
var $9HEDW = parcelRequire("9HEDW");
async function $a13dc2b4f56bc81b$export$785cd5e95d0717c1(instance) {
    const [accounts, chainId] = await Promise.all([
        instance.request({
            method: 'eth_requestAccounts'
        }),
        instance.request({
            method: 'eth_chainId'
        })
    ]);
    return {
        accounts: accounts,
        chainId: chainId
    };
}
const $a13dc2b4f56bc81b$export$dae4ecb17c5c4020 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (addresses)=>{
        /*
     * TODO: after enabling autoconnect, we can consider this condition
     * to be removed.
     * The problem was if a user already connected its wallet,
     * Metamask is triggering this event on first load, so when autoconnect is disabled,
     * it's automaticlally change the state of wallet to `connected`.
     */ if (state.connected) updateAccounts(addresses);
    };
    const handleChainChanged = (chainId)=>{
        updateChainId(chainId);
    };
    instance?.on?.('accountsChanged', handleAccountsChanged);
    instance?.on?.('chainChanged', handleChainChanged);
    const cleanup = ()=>{
        instance?.off?.('accountsChanged', handleAccountsChanged);
        instance?.off?.('chainChanged', handleChainChanged);
    };
    return cleanup;
};
const $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c = async ({ instance: instance })=>{
    try {
        const accounts = await instance.request({
            method: 'eth_accounts'
        });
        if (accounts.length) return true;
        return false;
    } catch (error) {
        return false;
    }
};
const $a13dc2b4f56bc81b$export$394219efce660c44 = async ({ instance: instance, network: network, meta: meta })=>{
    const evmBlockchains = meta.filter((0, $hE77Y.isEvmBlockchain));
    const evmInstance = $a13dc2b4f56bc81b$export$2029b78bc980a576(instance, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    await (0, $fIwj6.switchOrAddNetworkForMetamaskCompatibleWallets)(evmInstance, network, (0, $fIwj6.convertEvmBlockchainMetaToEvmChainInfo)(evmBlockchains));
};
const $a13dc2b4f56bc81b$export$86abff8ce014c125 = ({ network: network, meta: meta })=>{
    return $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta).includes(network);
};
function $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta) {
    return meta.filter((0, $hE77Y.isEvmBlockchain)).map((blockchain)=>blockchain.name);
}
function $a13dc2b4f56bc81b$export$d1cfcb1ce8ae2e4e(network, meta) {
    if (!network) return null;
    const evmBlockchains = $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta);
    return evmBlockchains.includes(network) ? (0, $9HEDW.LegacyNetworks).ETHEREUM : null;
}
function $a13dc2b4f56bc81b$var$isEvmNetwork(network, meta) {
    if (!network) return false;
    return $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta).includes(network);
}
function $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3(instances, meta, network) {
    // If there is no `network` we fallback to default network.
    network = network || (0, $9HEDW.LegacyNetworks).ETHEREUM;
    const instance_network_name = $a13dc2b4f56bc81b$var$isEvmNetwork(network, meta) ? $a13dc2b4f56bc81b$export$d1cfcb1ce8ae2e4e(network, meta) : network;
    const instance = !!instances && !!instance_network_name ? instances.get(instance_network_name) : null;
    return instance;
}
function $a13dc2b4f56bc81b$export$2029b78bc980a576(provider, network) {
    return provider.size ? provider.get(network) : provider;
}
function $a13dc2b4f56bc81b$export$2515b173249f2353(providers, type) {
    if (type && providers[type]) {
        // we need this because provider can return an instance or a map of instances, so what you are doing here is try to detect that.
        if (providers[type].size) return providers[type].get((0, $9HEDW.LegacyNetworks).ETHEREUM);
        return providers[type];
    }
    return null;
}

});
parcelRegister("9U3Qn", function(module, exports) {
$parcel$export(module.exports, "cosmosBlockchains", function () { return (parcelRequire("hE77Y")).cosmosBlockchains; });
$parcel$export(module.exports, "evmBlockchains", function () { return (parcelRequire("hE77Y")).evmBlockchains; });
$parcel$export(module.exports, "isAPIErrorCode", function () { return (parcelRequire("9B1kL")).isAPIErrorCode; });
$parcel$export(module.exports, "isCosmosBlockchain", function () { return (parcelRequire("hE77Y")).isCosmosBlockchain; });
$parcel$export(module.exports, "isEvmBlockchain", function () { return (parcelRequire("hE77Y")).isEvmBlockchain; });
$parcel$export(module.exports, "isSolanaBlockchain", function () { return (parcelRequire("hE77Y")).isSolanaBlockchain; });
$parcel$export(module.exports, "isStellarTransaction", function () { return (parcelRequire("2UxIz")).isStellarTransaction; });
$parcel$export(module.exports, "isXrplTransaction", function () { return (parcelRequire("3RHtn")).isXrplTransaction; });
$parcel$export(module.exports, "solanaBlockchain", function () { return (parcelRequire("hE77Y")).solanaBlockchain; });
$parcel$export(module.exports, "starknetBlockchain", function () { return (parcelRequire("hE77Y")).starknetBlockchain; });
$parcel$export(module.exports, "STELLAR_CHANGE_TRUSTLINE_TYPE", function () { return (parcelRequire("gEbmX")).STELLAR_CHANGE_TRUSTLINE_TYPE; });
$parcel$export(module.exports, "tonBlockchain", function () { return (parcelRequire("hE77Y")).tonBlockchain; });
$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("9B1kL")).TransactionType; });
$parcel$export(module.exports, "tronBlockchain", function () { return (parcelRequire("hE77Y")).tronBlockchain; });
$parcel$export(module.exports, "XRPL_CHANGE_TRUSTLINE_TYPE", function () { return (parcelRequire("gEbmX")).XRPL_CHANGE_TRUSTLINE_TYPE; });
$parcel$export(module.exports, "xrplBlockchain", function () { return (parcelRequire("hE77Y")).xrplBlockchain; });
$parcel$export(module.exports, "DefaultSignerFactory", function () { return (parcelRequire("fbZBq")).DefaultSignerFactory; });
$parcel$export(module.exports, "isSignerErrorCode", function () { return (parcelRequire("9gKM3")).isSignerErrorCode; });
$parcel$export(module.exports, "RPCErrorCode", function () { return (parcelRequire("9gKM3")).RPCErrorCode; });
$parcel$export(module.exports, "SignerError", function () { return (parcelRequire("9gKM3")).SignerError; });
$parcel$export(module.exports, "SignerErrorCode", function () { return (parcelRequire("9gKM3")).SignerErrorCode; });
$parcel$export(module.exports, "isXrplChangeTrustLinePrerequisiteResult", function () { return (parcelRequire("8H2HB")).isXrplChangeTrustLinePrerequisiteResult; });
$parcel$export(module.exports, "PendingSwapNetworkStatus", function () { return (parcelRequire("k5IP8")).PendingSwapNetworkStatus; });

var $a89pv = parcelRequire("a89pv");

var $lCEPF = parcelRequire("lCEPF");
parcelRequire("bT4fh");
parcelRequire("a9Ish");
parcelRequire("k5IP8");
parcelRequire("egw4O");

});
parcelRegister("a89pv", function(module, exports) {
parcelRequire("jpdxZ");
parcelRequire("zrfKS");
parcelRequire("kfOK1");
parcelRequire("2itnv");
parcelRequire("k4mVo");
parcelRequire("h3T4D");

});
parcelRegister("jpdxZ", function(module, exports) {

});

parcelRegister("zrfKS", function(module, exports) {

});

parcelRegister("kfOK1", function(module, exports) {

});

parcelRegister("2itnv", function(module, exports) {
parcelRequire("bT4fh");
var $jPoEL = parcelRequire("jPoEL");

});
parcelRegister("bT4fh", function(module, exports) {
$parcel$export(module.exports, "isAPIErrorCode", function () { return (parcelRequire("9B1kL")).isAPIErrorCode; });
$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("9B1kL")).TransactionType; });
$parcel$export(module.exports, "isStellarTransaction", function () { return (parcelRequire("2UxIz")).isStellarTransaction; });
$parcel$export(module.exports, "isXrplTransaction", function () { return (parcelRequire("3RHtn")).isXrplTransaction; });
$parcel$export(module.exports, "cosmosBlockchains", function () { return (parcelRequire("hE77Y")).cosmosBlockchains; });
$parcel$export(module.exports, "evmBlockchains", function () { return (parcelRequire("hE77Y")).evmBlockchains; });
$parcel$export(module.exports, "isCosmosBlockchain", function () { return (parcelRequire("hE77Y")).isCosmosBlockchain; });
$parcel$export(module.exports, "isEvmBlockchain", function () { return (parcelRequire("hE77Y")).isEvmBlockchain; });
$parcel$export(module.exports, "isSolanaBlockchain", function () { return (parcelRequire("hE77Y")).isSolanaBlockchain; });
$parcel$export(module.exports, "solanaBlockchain", function () { return (parcelRequire("hE77Y")).solanaBlockchain; });
$parcel$export(module.exports, "starknetBlockchain", function () { return (parcelRequire("hE77Y")).starknetBlockchain; });
$parcel$export(module.exports, "tonBlockchain", function () { return (parcelRequire("hE77Y")).tonBlockchain; });
$parcel$export(module.exports, "tronBlockchain", function () { return (parcelRequire("hE77Y")).tronBlockchain; });
$parcel$export(module.exports, "xrplBlockchain", function () { return (parcelRequire("hE77Y")).xrplBlockchain; });
$parcel$export(module.exports, "STELLAR_CHANGE_TRUSTLINE_TYPE", function () { return (parcelRequire("gEbmX")).STELLAR_CHANGE_TRUSTLINE_TYPE; });
$parcel$export(module.exports, "XRPL_CHANGE_TRUSTLINE_TYPE", function () { return (parcelRequire("gEbmX")).XRPL_CHANGE_TRUSTLINE_TYPE; });
parcelRequire("b9uM5");
parcelRequire("aOBg6");
parcelRequire("jhfWl");
parcelRequire("jPoEL");
parcelRequire("9B1kL");
parcelRequire("ik89g");
parcelRequire("hE77Y");
parcelRequire("lq457");

});
parcelRegister("b9uM5", function(module, exports) {

});

parcelRegister("aOBg6", function(module, exports) {

});

parcelRegister("jhfWl", function(module, exports) {

});

parcelRegister("jPoEL", function(module, exports) {
/**
 * Routing Result Type
 *
 */ var $e6f5e807863367da$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
    RoutingResultType["HIGH_IMPACT_FOR_CREATE_TX"] = "HIGH_IMPACT_FOR_CREATE_TX";
})($e6f5e807863367da$export$9244fb3192b4c649 || ($e6f5e807863367da$export$9244fb3192b4c649 = {}));

});

parcelRegister("9B1kL", function(module, exports) {

$parcel$export(module.exports, "TransactionType", function () { return $6fc89aa3c0b05299$export$d513b00599f845d4; });
$parcel$export(module.exports, "isAPIErrorCode", function () { return $6fc89aa3c0b05299$export$882b4f79e45cc211; });
/**
 * The type of transaction
 */ var $6fc89aa3c0b05299$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
    TransactionType["SUI"] = "SUI";
    TransactionType["XRPL"] = "XRPL";
    TransactionType["STELLAR"] = "STELLAR";
    TransactionType["HYPERLIQUID"] = "HYPERLIQUID";
})($6fc89aa3c0b05299$export$d513b00599f845d4 || ($6fc89aa3c0b05299$export$d513b00599f845d4 = {}));
var $6fc89aa3c0b05299$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($6fc89aa3c0b05299$export$d5c0ec10a1bea971 || ($6fc89aa3c0b05299$export$d5c0ec10a1bea971 = {}));
function $6fc89aa3c0b05299$export$882b4f79e45cc211(value) {
    return [
        'TX_FAIL',
        'TX_EXPIRED',
        'FETCH_TX_FAILED',
        'USER_REJECT',
        'USER_CANCEL',
        'USER_CANCELED_TX',
        'CALL_WALLET_FAILED',
        'SEND_TX_FAILED',
        'CALL_OR_SEND_FAILED',
        'TX_FAILED_IN_BLOCKCHAIN',
        'CLIENT_UNEXPECTED_BEHAVIOUR',
        'INSUFFICIENT_APPROVE'
    ].includes(value);
}
var $6fc89aa3c0b05299$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($6fc89aa3c0b05299$export$7c391bd3b61d2374 || ($6fc89aa3c0b05299$export$7c391bd3b61d2374 = {}));

});

parcelRegister("ik89g", function(module, exports) {
$parcel$export(module.exports, "isXrplTransaction", function () { return (parcelRequire("3RHtn")).isXrplTransaction; });
$parcel$export(module.exports, "isStellarTransaction", function () { return (parcelRequire("2UxIz")).isStellarTransaction; });
parcelRequire("kDkyO");
parcelRequire("fiiFi");
parcelRequire("lFaFA");
parcelRequire("ejzPa");
parcelRequire("fppEN");
parcelRequire("bUixl");
parcelRequire("l7YP3");
parcelRequire("3RHtn");
parcelRequire("2UxIz");

});
parcelRegister("kDkyO", function(module, exports) {

});

parcelRegister("fiiFi", function(module, exports) {

var $9B1kL = parcelRequire("9B1kL");
var $b22703f608461047$export$16073528a91c8d2a = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).COSMOS;
};

});

parcelRegister("lFaFA", function(module, exports) {

var $9B1kL = parcelRequire("9B1kL");
var $fc55b41765145bb6$export$b1818bc93202fd47 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).SOLANA;
};

});

parcelRegister("ejzPa", function(module, exports) {

var $9B1kL = parcelRequire("9B1kL");
var $a6bea102f63ac66f$export$a6e014f972e5c64c = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).TRANSFER;
};

});

parcelRegister("fppEN", function(module, exports) {

});

parcelRegister("bUixl", function(module, exports) {

var $9B1kL = parcelRequire("9B1kL");
var $8ab34db4cfd56cbf$export$9fd5291d9179852a = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).TRON;
};

});

parcelRegister("l7YP3", function(module, exports) {

var $9B1kL = parcelRequire("9B1kL");
var $f6196e7f50fa730a$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($f6196e7f50fa730a$export$6ef804aee1395a14 || ($f6196e7f50fa730a$export$6ef804aee1395a14 = {}));
var $f6196e7f50fa730a$export$232916af2d90d322 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).TON;
};

});

parcelRegister("3RHtn", function(module, exports) {

$parcel$export(module.exports, "isXrplTransaction", function () { return $2d080b23777d5255$export$7de0e58480dfd83; });
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");
var $2d080b23777d5255$export$7de0e58480dfd83 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).XRPL;
};

});

parcelRegister("2UxIz", function(module, exports) {

$parcel$export(module.exports, "isStellarTransaction", function () { return $21eaf7657f1a18a2$export$b9bf524c770f2077; });
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");
var $21eaf7657f1a18a2$export$b9bf524c770f2077 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).STELLAR;
};

});


parcelRegister("hE77Y", function(module, exports) {

$parcel$export(module.exports, "isEvmBlockchain", function () { return $cd8bb37a306c2b01$export$9d749b8b357dfab2; });
$parcel$export(module.exports, "isCosmosBlockchain", function () { return $cd8bb37a306c2b01$export$d917e9e8a70036a6; });
$parcel$export(module.exports, "isSolanaBlockchain", function () { return $cd8bb37a306c2b01$export$ff5a0a65a8982bf2; });
$parcel$export(module.exports, "evmBlockchains", function () { return $cd8bb37a306c2b01$export$e2a694e57950e88e; });
$parcel$export(module.exports, "solanaBlockchain", function () { return $cd8bb37a306c2b01$export$11a35c42f4dd4832; });
$parcel$export(module.exports, "starknetBlockchain", function () { return $cd8bb37a306c2b01$export$e1f5443c7a926d0f; });
$parcel$export(module.exports, "tronBlockchain", function () { return $cd8bb37a306c2b01$export$61a2144ef91f3622; });
$parcel$export(module.exports, "cosmosBlockchains", function () { return $cd8bb37a306c2b01$export$7a136f0d6bb0d722; });
$parcel$export(module.exports, "tonBlockchain", function () { return $cd8bb37a306c2b01$export$e38bf62be0c23ec5; });
$parcel$export(module.exports, "xrplBlockchain", function () { return $cd8bb37a306c2b01$export$b872edb03b12cfaa; });
var $cd8bb37a306c2b01$export$9d749b8b357dfab2 = function(blockchainMeta) {
    return blockchainMeta.type === 'EVM';
};
var $cd8bb37a306c2b01$export$d917e9e8a70036a6 = function(blockchainMeta) {
    return blockchainMeta.type === 'COSMOS';
};
var $cd8bb37a306c2b01$export$ff5a0a65a8982bf2 = function(blockchainMeta) {
    return blockchainMeta.type === 'SOLANA';
};
var $cd8bb37a306c2b01$export$744fa0907a94ca40 = function(blockchainMeta) {
    return blockchainMeta.type === 'TRON';
};
var $cd8bb37a306c2b01$export$83b5ebc3a9031095 = function(blockchainMeta) {
    return blockchainMeta.type === 'TRANSFER';
};
var $cd8bb37a306c2b01$export$80db8fd9e7a31db2 = function(blockchainMeta) {
    return blockchainMeta.type === 'STARKNET';
};
var $cd8bb37a306c2b01$export$9500a92ad5d775aa = function(blockchainMeta) {
    return blockchainMeta.type === 'TON';
};
var $cd8bb37a306c2b01$export$91bd0dedd228558 = function(blockchainMeta) {
    return blockchainMeta.type === 'XRPL';
};
var $cd8bb37a306c2b01$export$166c7bb8293a61af = function(blockchainMeta) {
    return blockchainMeta.type === 'HYPERLIQUID';
};
var $cd8bb37a306c2b01$export$e2a694e57950e88e = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$9d749b8b357dfab2);
};
var $cd8bb37a306c2b01$export$11a35c42f4dd4832 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$ff5a0a65a8982bf2);
};
var $cd8bb37a306c2b01$export$e1f5443c7a926d0f = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$80db8fd9e7a31db2);
};
var $cd8bb37a306c2b01$export$61a2144ef91f3622 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$744fa0907a94ca40);
};
var $cd8bb37a306c2b01$export$7a136f0d6bb0d722 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$d917e9e8a70036a6);
};
var $cd8bb37a306c2b01$export$80dff8c560b1e7ce = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$83b5ebc3a9031095);
};
var $cd8bb37a306c2b01$export$e38bf62be0c23ec5 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$9500a92ad5d775aa);
};
var $cd8bb37a306c2b01$export$b872edb03b12cfaa = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$91bd0dedd228558);
};
var $cd8bb37a306c2b01$export$18c65c826bbef61 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$166c7bb8293a61af);
};

});

parcelRegister("lq457", function(module, exports) {

$parcel$export(module.exports, "XRPL_CHANGE_TRUSTLINE_TYPE", function () { return (parcelRequire("gEbmX")).XRPL_CHANGE_TRUSTLINE_TYPE; });
$parcel$export(module.exports, "STELLAR_CHANGE_TRUSTLINE_TYPE", function () { return (parcelRequire("gEbmX")).STELLAR_CHANGE_TRUSTLINE_TYPE; });

var $9aeND = parcelRequire("9aeND");

var $5KPgT = parcelRequire("5KPgT");

var $gEbmX = parcelRequire("gEbmX");

});
parcelRegister("9aeND", function(module, exports) {

var $gEbmX = parcelRequire("gEbmX");
var $6ac0871a72fdb32c$export$6c7c6602f47e965 = function(prerequisite) {
    return prerequisite.type === (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE);
};

});
parcelRegister("gEbmX", function(module, exports) {

$parcel$export(module.exports, "XRPL_CHANGE_TRUSTLINE_TYPE", function () { return $c1e93374191ea8ba$export$e6b0c22c31469151; });
$parcel$export(module.exports, "STELLAR_CHANGE_TRUSTLINE_TYPE", function () { return $c1e93374191ea8ba$export$891f7844c4787fb; });
var $c1e93374191ea8ba$export$e6b0c22c31469151 = 'XRPL_CHANGE_TRUSTLINE';
var $c1e93374191ea8ba$export$891f7844c4787fb = 'STELLAR_CHANGE_TRUSTLINE';

});


parcelRegister("5KPgT", function(module, exports) {

var $gEbmX = parcelRequire("gEbmX");
var $4309050e2903f65f$export$a537f3e1e37a80b5 = function(prerequisite) {
    return prerequisite.type === (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE);
};

});




parcelRegister("k4mVo", function(module, exports) {
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");

});

parcelRegister("h3T4D", function(module, exports) {
parcelRequire("jmWvv");
parcelRequire("2NoRO");
parcelRequire("h9ANy");
parcelRequire("1GJSM");
parcelRequire("41Zdz");
parcelRequire("hsqlZ");
parcelRequire("dKw5Y");
parcelRequire("6hJhM");
parcelRequire("aw10I");
parcelRequire("lEZSB");
parcelRequire("fxOBk");

});
parcelRegister("jmWvv", function(module, exports) {
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");
var $e19d74b5ae43de4e$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).EVM;
};

});

parcelRegister("2NoRO", function(module, exports) {
parcelRequire("bT4fh");
var $fiiFi = parcelRequire("fiiFi");

});

parcelRegister("h9ANy", function(module, exports) {
parcelRequire("bT4fh");
var $ejzPa = parcelRequire("ejzPa");

});

parcelRegister("1GJSM", function(module, exports) {
parcelRequire("bT4fh");
var $lFaFA = parcelRequire("lFaFA");

});

parcelRegister("41Zdz", function(module, exports) {
parcelRequire("bT4fh");
var $bUixl = parcelRequire("bUixl");

});

parcelRegister("hsqlZ", function(module, exports) {
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");
var $cb597e8266469fb1$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).STARKNET;
};

});

parcelRegister("dKw5Y", function(module, exports) {

var $l7YP3 = parcelRequire("l7YP3");

});

parcelRegister("6hJhM", function(module, exports) {
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");
var $4937756619ee81d1$export$4c1876242d4cbd09 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).SUI;
};

});

parcelRegister("aw10I", function(module, exports) {

var $3RHtn = parcelRequire("3RHtn");

});

parcelRegister("lEZSB", function(module, exports) {

var $2UxIz = parcelRequire("2UxIz");

});

parcelRegister("fxOBk", function(module, exports) {

var $cPTUZ = parcelRequire("cPTUZ");

});
parcelRegister("cPTUZ", function(module, exports) {

var $9B1kL = parcelRequire("9B1kL");
var $95859fa2a49015ec$export$ec5aa33c5b2a7cfb = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).HYPERLIQUID;
};

});




parcelRegister("lCEPF", function(module, exports) {
parcelRequire("eHpmI");
parcelRequire("1d0B6");
parcelRequire("2P2g5");
parcelRequire("3043I");
parcelRequire("gOR1Q");
parcelRequire("8iBBb");

});
parcelRegister("eHpmI", function(module, exports) {

});

parcelRegister("1d0B6", function(module, exports) {

});

parcelRegister("2P2g5", function(module, exports) {

});

parcelRegister("3043I", function(module, exports) {
parcelRequire("bT4fh");
var $jPoEL = parcelRequire("jPoEL");

});

parcelRegister("gOR1Q", function(module, exports) {

$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("9B1kL")).TransactionType; });
parcelRequire("bT4fh");
var $9B1kL = parcelRequire("9B1kL");

});

parcelRegister("8iBBb", function(module, exports) {
parcelRequire("dsoKk");
parcelRequire("1PUHf");
parcelRequire("2RJrr");
parcelRequire("chsnM");
parcelRequire("g37wG");

});
parcelRegister("dsoKk", function(module, exports) {
parcelRequire("gOR1Q");
var $9B1kL = parcelRequire("9B1kL");
var $9cc115f359bcfe1a$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).EVM;
};

});

parcelRegister("1PUHf", function(module, exports) {
parcelRequire("bT4fh");
var $fiiFi = parcelRequire("fiiFi");

});

parcelRegister("2RJrr", function(module, exports) {
parcelRequire("bT4fh");
var $ejzPa = parcelRequire("ejzPa");

});

parcelRegister("chsnM", function(module, exports) {
parcelRequire("bT4fh");
var $lFaFA = parcelRequire("lFaFA");

});

parcelRegister("g37wG", function(module, exports) {
parcelRequire("gOR1Q");
var $9B1kL = parcelRequire("9B1kL");
var $baf2c3afa66fdd89$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $9B1kL.TransactionType).STARKNET;
};

});



parcelRegister("a9Ish", function(module, exports) {
$parcel$export(module.exports, "isSignerErrorCode", function () { return (parcelRequire("9gKM3")).isSignerErrorCode; });
$parcel$export(module.exports, "RPCErrorCode", function () { return (parcelRequire("9gKM3")).RPCErrorCode; });
$parcel$export(module.exports, "SignerError", function () { return (parcelRequire("9gKM3")).SignerError; });
$parcel$export(module.exports, "SignerErrorCode", function () { return (parcelRequire("9gKM3")).SignerErrorCode; });
$parcel$export(module.exports, "DefaultSignerFactory", function () { return (parcelRequire("fbZBq")).DefaultSignerFactory; });
parcelRequire("9gKM3");
parcelRequire("fbZBq");

});
parcelRegister("9gKM3", function(module, exports) {

$parcel$export(module.exports, "SignerErrorCode", function () { return $6bf9e406f810d981$export$1105a941ceaa4b25; });
$parcel$export(module.exports, "RPCErrorCode", function () { return $6bf9e406f810d981$export$618932a85b762ea3; });
$parcel$export(module.exports, "isSignerErrorCode", function () { return $6bf9e406f810d981$export$be10b575629ad8f; });
$parcel$export(module.exports, "SignerError", function () { return $6bf9e406f810d981$export$7cc7da8fa05ccee8; });
var $6bf9e406f810d981$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6bf9e406f810d981$var$__assign = undefined && undefined.__assign || function() {
    $6bf9e406f810d981$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6bf9e406f810d981$var$__assign.apply(this, arguments);
};
var $6bf9e406f810d981$export$1105a941ceaa4b25;
(function(SignerErrorCode) {
    SignerErrorCode["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    SignerErrorCode["SIGN_TX_ERROR"] = "SIGN_TX_ERROR";
    SignerErrorCode["SEND_TX_ERROR"] = "SEND_TX_ERROR";
    SignerErrorCode["TX_FAILED_IN_BLOCKCHAIN"] = "TX_FAILED_IN_BLOCKCHAIN";
    SignerErrorCode["OPERATION_UNSUPPORTED"] = "OPERATION_UNSUPPORTED";
    SignerErrorCode["UNEXPECTED_BEHAVIOUR"] = "UNEXPECTED_BEHAVIOUR";
    SignerErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})($6bf9e406f810d981$export$1105a941ceaa4b25 || ($6bf9e406f810d981$export$1105a941ceaa4b25 = {}));
var $6bf9e406f810d981$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["REJECTION"] = "REJECTION";
    RPCErrorCode["UNDER_PRICED"] = "UNDER_PRICED";
    RPCErrorCode["OUT_OF_GAS"] = "OUT_OF_GAS";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["INTERNAL"] = "INTERNAL";
    RPCErrorCode["SLIPPAGE"] = "SLIPPAGE";
    RPCErrorCode["UNKNOWN_ERROR"] = "UNKNOWN";
})($6bf9e406f810d981$export$618932a85b762ea3 || ($6bf9e406f810d981$export$618932a85b762ea3 = {}));
function $6bf9e406f810d981$export$be10b575629ad8f(value) {
    return Object.keys($6bf9e406f810d981$export$1105a941ceaa4b25).includes(value);
}
function $6bf9e406f810d981$export$714f3eb4b9ca37c5(code) {
    var _a;
    var errorMap = (_a = {}, _a[$6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER] = 'User rejected the transaction', _a[$6bf9e406f810d981$export$1105a941ceaa4b25.SIGN_TX_ERROR] = 'Error signing the transaction', _a[$6bf9e406f810d981$export$1105a941ceaa4b25.SEND_TX_ERROR] = 'Error sending the transaction', _a[$6bf9e406f810d981$export$1105a941ceaa4b25.NOT_IMPLEMENTED] = 'Operation not implemented', _a[$6bf9e406f810d981$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED] = 'Unsupported operation', _a[$6bf9e406f810d981$export$1105a941ceaa4b25.TX_FAILED_IN_BLOCKCHAIN] = 'Transaction failed in blockchain', _a[$6bf9e406f810d981$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR] = 'Unexpected error', _a);
    return errorMap[code];
}
var $6bf9e406f810d981$export$7cc7da8fa05ccee8 = /** @class */ function(_super) {
    $6bf9e406f810d981$var$__extends(SignerError, _super);
    function SignerError(code, m, root, rpcCode, cause, context) {
        var _this = _super.call(this, m || $6bf9e406f810d981$export$714f3eb4b9ca37c5(code), {
            cause: cause
        }) || this;
        _this.name = 'SignerError';
        _this._isSignerError = true;
        Object.setPrototypeOf(_this, SignerError.prototype);
        SignerError.prototype._isSignerError = true;
        _this.code = code;
        _this.root = root;
        _this.rpcCode = rpcCode;
        _this.context = context;
        if (_this.code === $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER || SignerError.isRejectedError(root)) {
            _this.code = $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER;
            _this.message = 'User rejected the transaction';
            _this.root = undefined;
        }
        return _this;
    }
    SignerError.isSignerError = function(obj) {
        return obj instanceof SignerError || Object.prototype.hasOwnProperty.call(obj, '_isSignerError');
    };
    SignerError.isRejectedError = function(error) {
        var POSSIBLE_REJECTION_ERRORS = [
            'rejected by user',
            'rejected by the user',
            'user canceled',
            'user rejected',
            'user denied',
            'request rejected',
            'user abort',
            'disapproved',
            'declined by user'
        ];
        if (!!error && typeof error === 'string') for(var _i = 0, POSSIBLE_REJECTION_ERRORS_1 = POSSIBLE_REJECTION_ERRORS; _i < POSSIBLE_REJECTION_ERRORS_1.length; _i++){
            var msg = POSSIBLE_REJECTION_ERRORS_1[_i];
            if (error.toLowerCase().includes(msg.toLowerCase())) return true;
        }
        else if (!!error && typeof error === 'object') {
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) return true;
            for(var _a = 0, POSSIBLE_REJECTION_ERRORS_2 = POSSIBLE_REJECTION_ERRORS; _a < POSSIBLE_REJECTION_ERRORS_2.length; _a++){
                var msg = POSSIBLE_REJECTION_ERRORS_2[_a];
                if (JSON.stringify(error).toLowerCase().includes(msg.toLowerCase()) || ((error === null || error === void 0 ? void 0 : error.message) || '').toLowerCase().includes(msg.toLowerCase())) return true;
            }
        }
        return false;
    };
    SignerError.UnsupportedError = function(operation) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED, "'".concat(operation, "' is not supported by the signer"));
    };
    SignerError.UnimplementedError = function(operation) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.NOT_IMPLEMENTED, "'".concat(operation, "' is not implemented by the signer"));
    };
    SignerError.AssertionFailed = function(m) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR, 'Assertion failed: ' + m);
    };
    SignerError.prototype.getErrorContext = function() {
        return $6bf9e406f810d981$var$__assign({
            code: this.code,
            rpcCode: this.rpcCode,
            message: this.message
        }, this.context || {});
    };
    SignerError.prototype.getErrorDetail = function() {
        var _a;
        if (this.code === $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER) return {
            code: this.code,
            message: this.message,
            detail: ((_a = this.root) === null || _a === void 0 ? void 0 : _a.message) || 'User rejected the transaction'
        };
        var rawMessage = typeof this.root === 'object' && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        var rootStr = typeof this.root === 'string' ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            code: this.code,
            message: this.message,
            detail: rootStr
        };
    };
    return SignerError;
}(Error);

});

parcelRegister("fbZBq", function(module, exports) {

$parcel$export(module.exports, "DefaultSignerFactory", function () { return $b0f7ab1c178913fc$export$2006fb7614e99307; });
var $b0f7ab1c178913fc$export$2006fb7614e99307 = /** @class */ function() {
    function DefaultSignerFactory() {
        this.signers = {};
        this.signers = {};
    }
    DefaultSignerFactory.prototype.registerSigner = function(txType, signer) {
        this.signers[txType] = signer;
    };
    DefaultSignerFactory.prototype.getSigner = function(txType) {
        if (this.signers && txType in this.signers) {
            var signer = this.signers[txType];
            if (!!signer) return signer;
        }
        throw new Error('Signer not found for ' + txType);
    };
    return DefaultSignerFactory;
}();

});


parcelRegister("k5IP8", function(module, exports) {

$parcel$export(module.exports, "PendingSwapNetworkStatus", function () { return $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9; });
$parcel$export(module.exports, "isXrplChangeTrustLinePrerequisiteResult", function () { return (parcelRequire("8H2HB")).isXrplChangeTrustLinePrerequisiteResult; });

var $8H2HB = parcelRequire("8H2HB");
var $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9;
(function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
    PendingSwapNetworkStatus["NetworkChangeFailed"] = "networkChangeFailed";
})($ea070b5dc0dc0a6d$export$b1569e7f9d4064a9 || ($ea070b5dc0dc0a6d$export$b1569e7f9d4064a9 = {}));
var $ea070b5dc0dc0a6d$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($ea070b5dc0dc0a6d$export$bb45678bd9ad9127 || ($ea070b5dc0dc0a6d$export$bb45678bd9ad9127 = {}));

});
parcelRegister("8H2HB", function(module, exports) {

$parcel$export(module.exports, "isXrplChangeTrustLinePrerequisiteResult", function () { return $65446f7f4bd37c3e$export$d5d10d781045951f; });
parcelRequire("lq457");
var $gEbmX = parcelRequire("gEbmX");
var $65446f7f4bd37c3e$export$38e83bbee9fb7fcb = function(prerequisiteResult) {
    return prerequisiteResult.prerequisiteType === (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE);
};
var $65446f7f4bd37c3e$export$d5d10d781045951f = function(prerequisiteResult) {
    return prerequisiteResult.prerequisiteType === (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE);
};

});


parcelRegister("egw4O", function(module, exports) {
parcelRequire("56fgy");
parcelRequire("60A3a");

});
parcelRegister("56fgy", function(module, exports) {

});

parcelRegister("60A3a", function(module, exports) {

});




parcelRegister("ehvdX", function(module, exports) {

$parcel$export(module.exports, "getCosmosAccounts", function () { return $732a2def649037d7$export$d4d8333f992ebe8c; });

var $fIwj6 = parcelRequire("fIwj6");
const $732a2def649037d7$var$GET_ACCOUNTS_TIMEOUT = 1000;
const $732a2def649037d7$var$getCosmosMainChainsIds = (blockchains)=>blockchains.filter((blockchain)=>blockchain.info && !blockchain.info.experimental).map((blockchain)=>blockchain.chainId).filter((chainId)=>!!chainId);
const $732a2def649037d7$var$getCosmosMiscChainsIds = (blockchains)=>blockchains.filter((blockchain)=>blockchain.info?.experimental).map((blockchain)=>blockchain.chainId).filter((chainId)=>!!chainId);
const $732a2def649037d7$export$9a5d8b9457d52deb = (blockchains)=>blockchains.filter((blockchain)=>!!blockchain.info).filter((blockchain)=>!!blockchain.chainId).reduce((cosmosExperimentalChainsInfo, blockchain)=>{
        const info = (0, $fIwj6.deepCopy)(blockchain.info);
        info.stakeCurrency.coinImageUrl = window.location.origin + info.stakeCurrency.coinImageUrl;
        info.currencies = info.currencies.map((currency)=>({
                ...currency,
                coinImageUrl: window.location.origin + currency.coinImageUrl
            }));
        info.feeCurrencies = info.feeCurrencies.map((currency)=>({
                ...currency,
                coinImageUrl: window.location.origin + currency.coinImageUrl
            }));
        if (!info.gasPriceStep) delete info.gasPriceStep;
        const { experimental: experimental, ...otherProperties } = info;
        return cosmosExperimentalChainsInfo[blockchain.name] = {
            id: blockchain.chainId,
            info: {
                ...otherProperties,
                chainId: blockchain.chainId
            },
            experimental: experimental
        }, cosmosExperimentalChainsInfo;
    }, {});
async function $732a2def649037d7$var$getMainAccounts({ desiredChainIds: desiredChainIds, instance: instance }) {
    // Trying to get accounts from all chains
    const offlineSigners = desiredChainIds.map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    }).filter(Boolean);
    const timeout = new Promise((_, reject)=>setTimeout(()=>reject(new Error('Timeout while fetching accounts')), $732a2def649037d7$var$GET_ACCOUNTS_TIMEOUT));
    const accountsPromises = offlineSigners.map(async ({ signer: signer })=>Promise.race([
            signer.getAccounts(),
            timeout
        ]));
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const resolvedAccounts = [];
    availableAccountForChains.forEach((result, index)=>{
        if (result.status !== 'fulfilled') return;
        const accounts = result.value;
        const { chainId: chainId } = offlineSigners[index];
        const addresses = accounts.map((account)=>account.address);
        resolvedAccounts.push({
            accounts: addresses,
            chainId: chainId
        });
    });
    return resolvedAccounts;
}
async function $732a2def649037d7$var$tryRequestMiscAccounts({ excludedChain: excludedChain, instance: instance, meta: meta }) {
    const offlineSigners = $732a2def649037d7$var$getCosmosMiscChainsIds(meta).filter((id)=>id !== excludedChain).map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    });
    const accountsPromises = offlineSigners.map(async ({ signer: signer })=>signer.getAccounts());
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const resolvedAccounts = [];
    availableAccountForChains.forEach((result, index)=>{
        if (result.status !== 'fulfilled') return;
        const accounts = result.value;
        const { chainId: chainId } = offlineSigners[index];
        const addresses = accounts.map((account)=>account.address);
        resolvedAccounts.push({
            accounts: addresses,
            chainId: chainId
        });
    });
    return resolvedAccounts;
}
const $732a2def649037d7$export$d4d8333f992ebe8c = async ({ instance: instance, network: network, meta: meta })=>{
    const chainInfo = network ? $732a2def649037d7$export$9a5d8b9457d52deb(meta)[network] : null;
    if (!!network && !chainInfo) throw new Error(`You need to add ${network} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    // Asking for connect to wallet.
    if (!!chainInfo) await instance.experimentalSuggestChain(chainInfo.info);
    // Getting main chains + target network
    let desiredChainIds = $732a2def649037d7$var$getCosmosMainChainsIds(meta);
    if (!!chainInfo) desiredChainIds.push(chainInfo.id);
    desiredChainIds = Array.from(new Set(desiredChainIds)).filter(Boolean);
    await instance.enable(desiredChainIds);
    const mainAccounts = await $732a2def649037d7$var$getMainAccounts({
        desiredChainIds: desiredChainIds,
        instance: instance
    });
    const exclude = !!chainInfo ? chainInfo.id : undefined;
    const miscAccounts = exclude ? await $732a2def649037d7$var$tryRequestMiscAccounts({
        instance: instance,
        meta: meta,
        excludedChain: exclude
    }) : [];
    const results = [
        ...mainAccounts,
        ...miscAccounts
    ];
    return results;
};
const $732a2def649037d7$export$d873bd134feb393 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const chainInfo = network ? $732a2def649037d7$export$9a5d8b9457d52deb(meta)[network] : null;
    if (!chainInfo) throw new Error(`You need to add ${network} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    // Asking for add experimental chain to wallet.
    await instance.experimentalSuggestChain(chainInfo.info);
};

});


parcelRegister("7tam3", function(module, exports) {
module.exports = $parcel$import("bUb9a").then(()=>parcelRequire('8ihWb'));

});

parcelRegister("f59Be", function(module, exports) {

$parcel$export(module.exports, "builders", function () { return $afaec4e9fb2825db$export$aea8daed5328d69c; });
$parcel$export(module.exports, "parseErrorAndThrowStandardizeError", function () { return $afaec4e9fb2825db$export$6fda7c7a9e5f000b; });
$parcel$export(module.exports, "standardizeAndThrowError", function () { return $afaec4e9fb2825db$export$734d16ba0914db57; });
$parcel$export(module.exports, "intoConnectionFinished", function () { return $afaec4e9fb2825db$export$30634c0e852f7667; });
$parcel$export(module.exports, "ChangeAccountSubscriberBuilder", function () { return $afaec4e9fb2825db$export$e2cb044debbf9499; });
$parcel$export(module.exports, "connectAndUpdateStateForSingleNetwork", function () { return $afaec4e9fb2825db$export$f83ab4691335f982; });
$parcel$export(module.exports, "connectAndUpdateStateForMultiNetworks", function () { return $afaec4e9fb2825db$export$3082ffb12bcfc304; });
$parcel$export(module.exports, "intoConnecting", function () { return $afaec4e9fb2825db$export$ccde031b5ef8b91; });



var $3ca9q = parcelRequire("3ca9q");
var $afaec4e9fb2825db$var$x = Object.defineProperty;
var $afaec4e9fb2825db$var$t = (r, e)=>$afaec4e9fb2825db$var$x(r, "name", {
        value: e,
        configurable: !0
    });
var $afaec4e9fb2825db$var$b = (r, e)=>{
    for(var o in e)$afaec4e9fb2825db$var$x(r, o, {
        get: e[o],
        enumerable: !0
    });
};
var $afaec4e9fb2825db$export$e324594224ef24da = {};
$afaec4e9fb2825db$var$b($afaec4e9fb2825db$export$e324594224ef24da, {
    disconnect: ()=>$afaec4e9fb2825db$var$a,
    recommended: ()=>$afaec4e9fb2825db$var$R
});
function $afaec4e9fb2825db$var$a(r) {
    let [, e] = r.state();
    e("network", null), e("accounts", null), e("connected", !1), e("connecting", !1), e("connectArgs", null);
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$var$a, "disconnect");
var $afaec4e9fb2825db$var$R = [
    [
        "disconnect",
        $afaec4e9fb2825db$var$a
    ]
];
var $afaec4e9fb2825db$export$aea8daed5328d69c = {};
$afaec4e9fb2825db$var$b($afaec4e9fb2825db$export$aea8daed5328d69c, {
    disconnect: ()=>$afaec4e9fb2825db$var$_
});
var $afaec4e9fb2825db$var$n = class {
    static{
        $afaec4e9fb2825db$var$t(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #o = new Map;
    #r = new Map;
    #n;
    constructor(e){
        this.name = e;
    }
    and(e) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(e), this;
    }
    or(e) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(e), this;
    }
    before(e) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(e), this;
    }
    after(e) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(e), this;
    }
    action(e) {
        return this.#n = e, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#r,
            after: this.#o,
            and: this.#e,
            or: this.#t
        };
    }
};
var $afaec4e9fb2825db$var$_ = $afaec4e9fb2825db$var$t(()=>new $afaec4e9fb2825db$var$n("disconnect").action($afaec4e9fb2825db$var$a), "disconnect");
function $afaec4e9fb2825db$export$6fda7c7a9e5f000b(r) {
    if (r instanceof Error) throw r;
    let e;
    typeof r == "object" && r !== null && "message" in r && typeof r.message == "string" ? e = r.message : typeof r == "string" ? e = r : e = String(r);
    let o = new Error(e);
    throw typeof r == "object" && r !== null && ("code" in r && (o.code = r.code), "data" in r && (o.data = r.data)), o;
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$export$6fda7c7a9e5f000b, "parseErrorAndThrowStandardizeError");
function $afaec4e9fb2825db$export$734d16ba0914db57(r, e) {
    $afaec4e9fb2825db$export$6fda7c7a9e5f000b(e);
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$export$734d16ba0914db57, "standardizeAndThrowError");
function $afaec4e9fb2825db$export$30634c0e852f7667(r) {
    let [, e] = r.state();
    e("connecting", !1);
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$export$30634c0e852f7667, "intoConnectionFinished");
var $afaec4e9fb2825db$export$6b517f6984240e4b = [
    [
        "connect",
        $afaec4e9fb2825db$export$30634c0e852f7667
    ]
];
var $afaec4e9fb2825db$export$e2cb044debbf9499 = class {
    static{
        $afaec4e9fb2825db$var$t(this, "ChangeAccountSubscriberBuilder");
    }
    #e = null;
    #t = null;
    #o = null;
    #r = null;
    #n = null;
    getInstance(e) {
        return this.#e = e, this;
    }
    format(e) {
        return this.#t = e, this;
    }
    onSwitchAccount(e) {
        return this.#o = e, this;
    }
    addEventListener(e) {
        return this.#r = e, this;
    }
    removeEventListener(e) {
        return this.#n = e, this;
    }
    build() {
        if (this.#e === null) throw new Error(this.#s("getInstance"));
        if (this.#t === null) throw new Error(this.#s("format"));
        if (this.#r === null) throw new Error(this.#s("addEventListener"));
        if (this.#n === null) throw new Error(this.#s("removeEventListener"));
        let e = this.#e, o = this.#t, T = this.#r, k = this.#n, I = this.#o, d, i;
        return [
            async (p)=>{
                let [, u] = p.state(), s = e();
                if (!s) throw new Error("Trying to subscribe to your wallet, but seems its instance is not available.");
                d = $afaec4e9fb2825db$var$t(async (g)=>{
                    let S = !0;
                    I?.({
                        payload: g,
                        preventDefault: ()=>{
                            S = !1;
                        }
                    }, p), S && u("accounts", await o(s, g));
                }, "subscriber"), i = T(s, d);
            },
            (p, u)=>{
                i && typeof i == "function" && i();
                let s = e();
                return k(s, d), u;
            }
        ];
    }
    #s(e) {
        return `Required "${e}" operation has not been set for "changeAccountSubscriber"`;
    }
};
function $afaec4e9fb2825db$var$y(r) {
    try {
        return (0, $3ca9q.AccountId).parse(r), !0;
    } catch  {
        return !1;
    }
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$var$y, "isValidCaipAddress");
function $afaec4e9fb2825db$export$f83ab4691335f982(r, e) {
    if (!e.every($afaec4e9fb2825db$var$y)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e}`);
    let [, o] = r.state();
    return o("accounts", e), o("connected", !0), e;
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$export$f83ab4691335f982, "connectAndUpdateStateForSingleNetwork");
function $afaec4e9fb2825db$export$3082ffb12bcfc304(r, e) {
    if (!e.accounts.every($afaec4e9fb2825db$var$y)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e.accounts}`);
    let [, o] = r.state();
    return o("accounts", e.accounts), o("network", e.network), o("connected", !0), e;
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$export$3082ffb12bcfc304, "connectAndUpdateStateForMultiNetworks");
var $afaec4e9fb2825db$export$cdc335a31749eb5c = [];
function $afaec4e9fb2825db$export$ccde031b5ef8b91(r) {
    let [, e] = r.state();
    e("connecting", !0);
}
$afaec4e9fb2825db$var$t($afaec4e9fb2825db$export$ccde031b5ef8b91, "intoConnecting");
var $afaec4e9fb2825db$export$ac99a03f4a460356 = [
    [
        "connect",
        $afaec4e9fb2825db$export$ccde031b5ef8b91
    ]
];

});

parcelRegister("cCZtf", function(module, exports) {
module.exports = $parcel$import("jrxP9").then(()=>parcelRequire('dzwSW'));

});

parcelRegister("1q68f", function(module, exports) {
module.exports = $parcel$import("gBgzU").then(()=>parcelRequire('dQ9wr'));

});

parcelRegister("6Zvtg", function(module, exports) {

$parcel$export(module.exports, "DefaultSolanaSigner", function () { return (parcelRequire("13wKd")).DefaultSolanaSigner; });
$parcel$export(module.exports, "executeSolanaTransaction", function () { return (parcelRequire("4tkSS")).executeSolanaTransaction; });
$parcel$export(module.exports, "generalSolanaTransactionExecutor", function () { return (parcelRequire("4tkSS")).generalSolanaTransactionExecutor; });
$parcel$export(module.exports, "prepareTransaction", function () { return (parcelRequire("gPoET")).prepareTransaction; });
$parcel$export(module.exports, "getSolanaConnection", function () { return (parcelRequire("fULdq")).getSolanaConnection; });
$parcel$export(module.exports, "getSolanaRpcNodes", function () { return (parcelRequire("fULdq")).getSolanaRpcNodes; });
$parcel$export(module.exports, "simulateTransaction", function () { return (parcelRequire("kJ7Yx")).simulateTransaction; });
$parcel$export(module.exports, "setSolanaSignerConfig", function () { return (parcelRequire("1ppfI")).setSolanaSignerConfig; });

var $13wKd = parcelRequire("13wKd");
parcelRequire("6wsXt");
var $4tkSS = parcelRequire("4tkSS");
var $fULdq = parcelRequire("fULdq");
var $gPoET = parcelRequire("gPoET");
var $kJ7Yx = parcelRequire("kJ7Yx");

var $1ppfI = parcelRequire("1ppfI");

});
parcelRegister("13wKd", function(module, exports) {

$parcel$export(module.exports, "DefaultSolanaSigner", function () { return $fab2810f51324a2a$export$38f28568c8f589a4; });

var $hZS7n = parcelRequire("hZS7n");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $4tkSS = parcelRequire("4tkSS");
class $fab2810f51324a2a$export$38f28568c8f589a4 {
    constructor(provider){
        this._provider = provider;
    }
    get provider() {
        return this._provider;
    }
    async signMessage(msg) {
        try {
            const encodedMessage = new TextEncoder().encode(msg);
            const { signature: signature } = await this._provider.request({
                method: 'signMessage',
                params: {
                    message: encodedMessage
                }
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(signature);
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        const hash = await (0, $4tkSS.executeSolanaTransaction)(tx, this._provider);
        return {
            hash: hash
        };
    }
}

});
parcelRegister("hZS7n", function(module, exports) {

var $haLVF = parcelRequire("haLVF");
const $d1a21cdb0a134c34$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $haLVF($d1a21cdb0a134c34$var$ALPHABET);

});
parcelRegister("haLVF", function(module, exports) {
'use strict';
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $c8088c912f709a84$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $c8088c912f709a84$var$base;

});


parcelRegister("4tkSS", function(module, exports) {

$parcel$export(module.exports, "generalSolanaTransactionExecutor", function () { return $6adbea206a1d1349$export$2c46e2eb81692c02; });
$parcel$export(module.exports, "executeSolanaTransaction", function () { return $6adbea206a1d1349$export$478d53c60663f0a6; });
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $fULdq = parcelRequire("fULdq");

var $gPoET = parcelRequire("gPoET");

var $3W3Ha = parcelRequire("3W3Ha");

var $kJ7Yx = parcelRequire("kJ7Yx");
const $6adbea206a1d1349$export$2c46e2eb81692c02 = async (tx, DefaultSolanaSigner)=>{
    const connection = (0, $fULdq.getSolanaConnection)((0, $fULdq.getSolanaRpcNodes)().main);
    const latestBlock = await connection.getLatestBlockhash('confirmed');
    const finalTx = (0, $gPoET.prepareTransaction)(tx, latestBlock.blockhash);
    const serializedTransaction = await DefaultSolanaSigner(finalTx);
    // We first simulate whether the transaction would be successful
    await (0, $kJ7Yx.simulateTransaction)(finalTx, tx.txType);
    const connectionPool = {
        main: connection,
        list: (0, $fULdq.getSolanaRpcNodes)().list.map((url)=>(0, $fULdq.getSolanaConnection)(url))
    };
    const { txId: txId, txResponse: txResponse } = await (0, $3W3Ha.transactionSenderAndConfirmationWaiter)({
        connectionPool: connectionPool,
        serializedTransaction: serializedTransaction
    });
    if (!txId || !txResponse) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SEND_TX_ERROR, undefined, 'Error confirming the transaction');
    return txId;
};
async function $6adbea206a1d1349$export$478d53c60663f0a6(tx, solanaProvider) {
    const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
        if (!solanaProvider.publicKey) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, 'Please make sure the required account is connected properly.');
        if (tx.from !== solanaProvider.publicKey?.toString()) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, `Your connected account doesn't match with the required account. Please ensure that you are connected with the correct account and try again.`);
        try {
            const signedTransaction = await solanaProvider.signTransaction(solanaWeb3Transaction);
            return signedTransaction.serialize();
        } catch (e) {
            const REJECTION_CODE = 4001;
            if (e && Object.hasOwn(e, 'code') && e.code === REJECTION_CODE) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).REJECTED_BY_USER, undefined, e);
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, e);
        }
    };
    return await $6adbea206a1d1349$export$2c46e2eb81692c02(tx, DefaultSolanaSigner);
}

});
parcelRegister("fULdq", function(module, exports) {

$parcel$export(module.exports, "getSolanaConnection", function () { return $182cacbd5ad0896f$export$4b8aa67d974d7528; });
$parcel$export(module.exports, "getSolanaRpcNodes", function () { return $182cacbd5ad0896f$export$defdef6020fbfc1b; });
$parcel$export(module.exports, "wait", function () { return $182cacbd5ad0896f$export$5c069c93d2b7493f; });

var $2v1vt = parcelRequire("2v1vt");

var $1ppfI = parcelRequire("1ppfI");
const $182cacbd5ad0896f$var$IS_DEV = false;
// This main rpc url is used to fetch latest blockhash, simulate transaction, etc
const $182cacbd5ad0896f$var$DEFAULT_SOLANA_RPC_URL = !$182cacbd5ad0896f$var$IS_DEV ? 'https://purple-practical-friday.solana-mainnet.quiknode.pro/d94ab067f793d48c81354c78c86ae908d9fc1582/' : 'https://fluent-still-scion.solana-mainnet.discover.quiknode.pro/fc8be9b8ac7aea382ec591359628e16d8c52ef6a/';
function $182cacbd5ad0896f$export$4b8aa67d974d7528(url) {
    return new (0, $2v1vt.Connection)(url, {
        commitment: 'confirmed',
        disableRetryOnRateLimit: false
    });
}
function $182cacbd5ad0896f$export$defdef6020fbfc1b() {
    const customRPC = (0, $1ppfI.getSolanaSignerConfig)('customRPC');
    let list = [];
    if (customRPC) {
        if (!Array.isArray(customRPC)) list = [
            customRPC
        ];
        else if (customRPC.length) list = customRPC;
    } else list = [
        $182cacbd5ad0896f$var$DEFAULT_SOLANA_RPC_URL
    ];
    return {
        main: list[0],
        list: list
    };
}
const $182cacbd5ad0896f$export$5c069c93d2b7493f = async (time)=>new Promise((resolve)=>setTimeout(resolve, time));

});
parcelRegister("2v1vt", function(module, exports) {

$parcel$export(module.exports, "PublicKey", function () { return $1d1fa5388254e796$export$ca8b6604d6ce14de; });
$parcel$export(module.exports, "TransactionExpiredBlockheightExceededError", function () { return $1d1fa5388254e796$export$718fcd78527f88ed; });
$parcel$export(module.exports, "TransactionInstruction", function () { return $1d1fa5388254e796$export$a7a3aa8360ac9f59; });
$parcel$export(module.exports, "Transaction", function () { return $1d1fa5388254e796$export$febc5573c75cefb0; });
$parcel$export(module.exports, "VersionedTransaction", function () { return $1d1fa5388254e796$export$232cc3f078dcc284; });
$parcel$export(module.exports, "Connection", function () { return $1d1fa5388254e796$export$98b66c25bb38499d; });

var $ihoyg = parcelRequire("ihoyg");

var $evN8c = parcelRequire("evN8c");

var $7vYz3 = parcelRequire("7vYz3");

var $7fZv8 = parcelRequire("7fZv8");

var $5apAE = parcelRequire("5apAE");

var $4xx4u = parcelRequire("4xx4u");

var $3wEH9 = parcelRequire("3wEH9");

var $gbKvo = parcelRequire("gbKvo");

var $kRZRk = parcelRequire("kRZRk");

var $fFbWN = parcelRequire("fFbWN");

var $81012 = parcelRequire("81012");

var $6U8NG = parcelRequire("6U8NG");

var $ek8qD = parcelRequire("ek8qD");

var $75Cpc = parcelRequire("75Cpc");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $1d1fa5388254e796$var$generatePrivateKey = (0, $evN8c.ed25519).utils.randomPrivateKey;
const $1d1fa5388254e796$var$generateKeypair = ()=>{
    const privateScalar = (0, $evN8c.ed25519).utils.randomPrivateKey();
    const publicKey = $1d1fa5388254e796$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $1d1fa5388254e796$var$getPublicKey = (0, $evN8c.ed25519).getPublicKey;
function $1d1fa5388254e796$var$isOnCurve(publicKey) {
    try {
        (0, $evN8c.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $1d1fa5388254e796$var$sign = (message, secretKey)=>(0, $evN8c.ed25519).sign(message, secretKey.slice(0, 32));
const $1d1fa5388254e796$var$verify = (0, $evN8c.ed25519).verify;
const $1d1fa5388254e796$var$toBuffer = (arr)=>{
    if ((0, $ihoyg.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $ihoyg.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $ihoyg.Buffer).from(arr);
};
// Class wrapping a plain object
class $1d1fa5388254e796$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $ihoyg.Buffer).from((0, $4xx4u.serialize)($1d1fa5388254e796$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $4xx4u.deserialize)($1d1fa5388254e796$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $4xx4u.deserializeUnchecked)($1d1fa5388254e796$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $1d1fa5388254e796$export$deb82508dd66d288 extends $1d1fa5388254e796$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = '';
        if (Object.keys(properties).length !== 1) throw new Error('Enum can only take single value');
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $1d1fa5388254e796$export$68d13ce9b4cc48f3 = new Map();
var $1d1fa5388254e796$var$_class;
let $1d1fa5388254e796$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $1d1fa5388254e796$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $1d1fa5388254e796$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $1d1fa5388254e796$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $1d1fa5388254e796$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $1d1fa5388254e796$var$_Symbol$toStringTag = Symbol.toStringTag;
class $1d1fa5388254e796$export$ca8b6604d6ce14de extends $1d1fa5388254e796$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($1d1fa5388254e796$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === 'string') {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(value);
                if (decoded.length != $1d1fa5388254e796$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(value);
            if (this._bn.byteLength() > $1d1fa5388254e796$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $1d1fa5388254e796$export$ca8b6604d6ce14de($1d1fa5388254e796$var$uniquePublicKeyCounter);
        $1d1fa5388254e796$var$uniquePublicKeyCounter += 1;
        return new $1d1fa5388254e796$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $ihoyg.Buffer));
        if (b.length === $1d1fa5388254e796$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $ihoyg.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$1d1fa5388254e796$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $ihoyg.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $ihoyg.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $5apAE.sha256)(buffer);
        return new $1d1fa5388254e796$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $ihoyg.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $1d1fa5388254e796$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $ihoyg.Buffer).concat([
                buffer,
                $1d1fa5388254e796$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $ihoyg.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $ihoyg.Buffer).from('ProgramDerivedAddress')
        ]);
        const publicKeyBytes = (0, $5apAE.sha256)(buffer);
        if ($1d1fa5388254e796$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $1d1fa5388254e796$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $ihoyg.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $1d1fa5388254e796$export$ca8b6604d6ce14de(pubkeyData);
        return $1d1fa5388254e796$var$isOnCurve(pubkey.toBytes());
    }
}
$1d1fa5388254e796$var$_class = $1d1fa5388254e796$export$ca8b6604d6ce14de;
$1d1fa5388254e796$export$ca8b6604d6ce14de.default = new $1d1fa5388254e796$var$_class('11111111111111111111111111111111');
$1d1fa5388254e796$export$68d13ce9b4cc48f3.set($1d1fa5388254e796$export$ca8b6604d6ce14de, {
    kind: 'struct',
    fields: [
        [
            '_bn',
            'u256'
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $1d1fa5388254e796$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $1d1fa5388254e796$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error('bad secret key size');
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $1d1fa5388254e796$var$toBuffer($1d1fa5388254e796$var$generatePrivateKey());
            this._publicKey = $1d1fa5388254e796$var$toBuffer($1d1fa5388254e796$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $1d1fa5388254e796$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $ihoyg.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $1d1fa5388254e796$export$42bd37c1c64962b6 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('BPFLoader1111111111111111111111111111111111');
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $1d1fa5388254e796$export$4c6d5b89e1596f26 = 1232;
const $1d1fa5388254e796$export$3c3793d809f8b858 = 0x7f;
const $1d1fa5388254e796$export$14aee086fde78fa6 = 64;
class $1d1fa5388254e796$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($1d1fa5388254e796$export$718fcd78527f88ed.prototype, 'name', {
    value: 'TransactionExpiredBlockheightExceededError'
});
class $1d1fa5388254e796$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + 'unknown if it succeeded or failed. Check signature ' + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($1d1fa5388254e796$export$b822204c22e46bdf.prototype, 'name', {
    value: 'TransactionExpiredTimeoutError'
});
class $1d1fa5388254e796$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($1d1fa5388254e796$export$a3e7565a95f5a1e5.prototype, 'name', {
    value: 'TransactionExpiredNonceInvalidError'
});
class $1d1fa5388254e796$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error('Account index overflow encountered during compilation');
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error('Encountered an unknown instruction account key during compilation');
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $1d1fa5388254e796$var$publicKey = (property = 'publicKey')=>{
    return $3wEH9.blob(32, property);
};
/**
 * Layout for a signature
 */ const $1d1fa5388254e796$var$signature = (property = 'signature')=>{
    return $3wEH9.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $1d1fa5388254e796$var$rustString = (property = 'string')=>{
    const rsl = $3wEH9.struct([
        $3wEH9.u32('length'),
        $3wEH9.u32('lengthPadding'),
        $3wEH9.blob($3wEH9.offset($3wEH9.u32(), -8), 'chars')
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data['chars'].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $ihoyg.Buffer).from(str, 'utf8')
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $3wEH9.u32().span + $3wEH9.u32().span + (0, $ihoyg.Buffer).from(str, 'utf8').length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $1d1fa5388254e796$var$authorized = (property = 'authorized')=>{
    return $3wEH9.struct([
        $1d1fa5388254e796$var$publicKey('staker'),
        $1d1fa5388254e796$var$publicKey('withdrawer')
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $1d1fa5388254e796$var$lockup = (property = 'lockup')=>{
    return $3wEH9.struct([
        $3wEH9.ns64('unixTimestamp'),
        $3wEH9.ns64('epoch'),
        $1d1fa5388254e796$var$publicKey('custodian')
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $1d1fa5388254e796$var$voteInit = (property = 'voteInit')=>{
    return $3wEH9.struct([
        $1d1fa5388254e796$var$publicKey('nodePubkey'),
        $1d1fa5388254e796$var$publicKey('authorizedVoter'),
        $1d1fa5388254e796$var$publicKey('authorizedWithdrawer'),
        $3wEH9.u8('commission')
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $1d1fa5388254e796$var$voteAuthorizeWithSeedArgs = (property = 'voteAuthorizeWithSeedArgs')=>{
    return $3wEH9.struct([
        $3wEH9.u32('voteAuthorizationType'),
        $1d1fa5388254e796$var$publicKey('currentAuthorityDerivedKeyOwnerPubkey'),
        $1d1fa5388254e796$var$rustString('currentAuthorityDerivedKeySeed'),
        $1d1fa5388254e796$var$publicKey('newAuthorized')
    ], property);
};
function $1d1fa5388254e796$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === 'function') return item.alloc(fields[item.property]);
        else if ('count' in item && 'elementLayout' in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ('fields' in item) // This is a `Structure` whose size needs to be recursively measured.
        return $1d1fa5388254e796$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $1d1fa5388254e796$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $1d1fa5388254e796$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $1d1fa5388254e796$var$assert(condition, message) {
    if (!condition) throw new Error(message || 'Assertion failed');
}
class $1d1fa5388254e796$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $1d1fa5388254e796$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $1d1fa5388254e796$var$assert(mapEntries.length <= 256, 'Max static account keys length exceeded');
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $1d1fa5388254e796$var$assert(writableSigners.length > 0, 'Expected at least one writable signer key');
            const [payerAddress] = writableSigners[0];
            $1d1fa5388254e796$var$assert(payerAddress === this.payer.toBase58(), 'Expected first writable signer key to be the fee payer');
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $1d1fa5388254e796$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $1d1fa5388254e796$var$assert(lookupTableIndex < 256, 'Max lookup table index exceeded');
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $1d1fa5388254e796$var$END_OF_BUFFER_ERROR_MESSAGE = 'Reached end of buffer unexpectedly';
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $1d1fa5388254e796$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($1d1fa5388254e796$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $1d1fa5388254e796$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($1d1fa5388254e796$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $1d1fa5388254e796$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return 'legacy';
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $1d1fa5388254e796$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $1d1fa5388254e796$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $1d1fa5388254e796$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode(ix.data)
            }));
        return new $1d1fa5388254e796$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $1d1fa5388254e796$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(instruction.data));
            let keyIndicesCount = [];
            $1d1fa5388254e796$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $1d1fa5388254e796$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $ihoyg.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $ihoyg.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $1d1fa5388254e796$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $ihoyg.Buffer).alloc($1d1fa5388254e796$export$4c6d5b89e1596f26);
        (0, $ihoyg.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $3wEH9.struct([
                $3wEH9.u8('programIdIndex'),
                $3wEH9.blob(instruction.keyIndicesCount.length, 'keyIndicesCount'),
                $3wEH9.seq($3wEH9.u8('keyIndex'), instruction.keyIndices.length, 'keyIndices'),
                $3wEH9.blob(instruction.dataLength.length, 'dataLength'),
                $3wEH9.seq($3wEH9.u8('userdatum'), instruction.data.length, 'data')
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $3wEH9.struct([
            $3wEH9.blob(1, 'numRequiredSignatures'),
            $3wEH9.blob(1, 'numReadonlySignedAccounts'),
            $3wEH9.blob(1, 'numReadonlyUnsignedAccounts'),
            $3wEH9.blob(keyCount.length, 'keyCount'),
            $3wEH9.seq($1d1fa5388254e796$var$publicKey('key'), numKeys, 'keys'),
            $1d1fa5388254e796$var$publicKey('recentBlockhash')
        ]);
        const transaction = {
            numRequiredSignatures: (0, $ihoyg.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $ihoyg.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $ihoyg.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $ihoyg.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$1d1fa5388254e796$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(this.recentBlockhash)
        };
        let signData = (0, $ihoyg.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $1d1fa5388254e796$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $1d1fa5388254e796$export$3c3793d809f8b858)) throw new Error('Versioned messages must be deserialized with VersionedMessage.deserialize()');
        const numReadonlySignedAccounts = $1d1fa5388254e796$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $1d1fa5388254e796$var$guardedShift(byteArray);
        const accountCount = $1d1fa5388254e796$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$84fc0a248cc54343);
            accountKeys.push(new $1d1fa5388254e796$export$ca8b6604d6ce14de((0, $ihoyg.Buffer).from(account)));
        }
        const recentBlockhash = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$84fc0a248cc54343);
        const instructionCount = $1d1fa5388254e796$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $1d1fa5388254e796$var$guardedShift(byteArray);
            const accountCount = $1d1fa5388254e796$var$decodeLength(byteArray);
            const accounts = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $1d1fa5388254e796$var$decodeLength(byteArray);
            const dataSlice = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode((0, $ihoyg.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode((0, $ihoyg.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $1d1fa5388254e796$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $1d1fa5388254e796$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && 'accountKeysFromLookups' in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error('Failed to get account keys because of a mismatch in the number of account keys from lookups');
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && 'addressLookupTableAccounts' in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error('Failed to get account keys because address table lookups were not resolved');
        return new $1d1fa5388254e796$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $1d1fa5388254e796$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $1d1fa5388254e796$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $1d1fa5388254e796$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $1d1fa5388254e796$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $1d1fa5388254e796$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $1d1fa5388254e796$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $3wEH9.struct([
            $3wEH9.u8('prefix'),
            $3wEH9.struct([
                $3wEH9.u8('numRequiredSignatures'),
                $3wEH9.u8('numReadonlySignedAccounts'),
                $3wEH9.u8('numReadonlyUnsignedAccounts')
            ], 'header'),
            $3wEH9.blob(encodedStaticAccountKeysLength.length, 'staticAccountKeysLength'),
            $3wEH9.seq($1d1fa5388254e796$var$publicKey(), this.staticAccountKeys.length, 'staticAccountKeys'),
            $1d1fa5388254e796$var$publicKey('recentBlockhash'),
            $3wEH9.blob(encodedInstructionsLength.length, 'instructionsLength'),
            $3wEH9.blob(serializedInstructions.length, 'serializedInstructions'),
            $3wEH9.blob(encodedAddressTableLookupsLength.length, 'addressTableLookupsLength'),
            $3wEH9.blob(serializedAddressTableLookups.length, 'serializedAddressTableLookups')
        ]);
        const serializedMessage = new Uint8Array($1d1fa5388254e796$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($1d1fa5388254e796$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $1d1fa5388254e796$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $1d1fa5388254e796$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $3wEH9.struct([
                $3wEH9.u8('programIdIndex'),
                $3wEH9.blob(encodedAccountKeyIndexesLength.length, 'encodedAccountKeyIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), instruction.accountKeyIndexes.length, 'accountKeyIndexes'),
                $3wEH9.blob(encodedDataLength.length, 'encodedDataLength'),
                $3wEH9.blob(instruction.data.length, 'data')
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($1d1fa5388254e796$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $1d1fa5388254e796$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $1d1fa5388254e796$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $3wEH9.struct([
                $1d1fa5388254e796$var$publicKey('accountKey'),
                $3wEH9.blob(encodedWritableIndexesLength.length, 'encodedWritableIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), lookup.writableIndexes.length, 'writableIndexes'),
                $3wEH9.blob(encodedReadonlyIndexesLength.length, 'encodedReadonlyIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), lookup.readonlyIndexes.length, 'readonlyIndexes')
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $1d1fa5388254e796$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $1d1fa5388254e796$export$3c3793d809f8b858;
        $1d1fa5388254e796$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $1d1fa5388254e796$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $1d1fa5388254e796$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $1d1fa5388254e796$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $1d1fa5388254e796$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $1d1fa5388254e796$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $1d1fa5388254e796$export$ca8b6604d6ce14de($1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode($1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$84fc0a248cc54343));
        const instructionCount = $1d1fa5388254e796$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $1d1fa5388254e796$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $1d1fa5388254e796$var$decodeLength(byteArray);
            const accountKeyIndexes = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $1d1fa5388254e796$var$decodeLength(byteArray);
            const data = new Uint8Array($1d1fa5388254e796$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $1d1fa5388254e796$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $1d1fa5388254e796$export$ca8b6604d6ce14de($1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$84fc0a248cc54343));
            const writableIndexesLength = $1d1fa5388254e796$var$decodeLength(byteArray);
            const writableIndexes = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $1d1fa5388254e796$var$decodeLength(byteArray);
            const readonlyIndexes = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $1d1fa5388254e796$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $1d1fa5388254e796$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $1d1fa5388254e796$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return 'legacy';
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $1d1fa5388254e796$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === 'legacy') return $1d1fa5388254e796$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $1d1fa5388254e796$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $1d1fa5388254e796$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $1d1fa5388254e796$var$DEFAULT_SIGNATURE = (0, $ihoyg.Buffer).alloc($1d1fa5388254e796$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $1d1fa5388254e796$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $ihoyg.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $1d1fa5388254e796$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, 'nonceInfo')) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, 'lastValidBlockHeight')) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error('No instructions');
        items.forEach((item)=>{
            if ('instructions' in item) this.instructions = this.instructions.concat(item.instructions);
            else if ('data' in item && 'programId' in item && 'keys' in item) this.instructions.push(item);
            else this.instructions.push(new $1d1fa5388254e796$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error('Transaction recentBlockhash required');
        if (instructions.length < 1) console.warn('No instructions provided');
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error('Transaction fee payer required');
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: 'best fit',
                usage: 'sort',
                sensitivity: 'variant',
                ignorePunctuation: false,
                numeric: false,
                caseFirst: 'lower'
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), 'en', options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $1d1fa5388254e796$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$1d1fa5388254e796$var$assert(keyIndex >= 0));
        });
        return new $1d1fa5388254e796$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $1d1fa5388254e796$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $1d1fa5388254e796$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $1d1fa5388254e796$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $ihoyg.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$1d1fa5388254e796$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = 'Signature verification failed.';
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? '' : '(s)'} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join('`, `')}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? '' : '(s)'} [\`${sigErrors.missing.map((p)=>p.toBase58()).join('`, `')}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $1d1fa5388254e796$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $ihoyg.Buffer).alloc(transactionLength);
        $1d1fa5388254e796$var$assert(signatures.length < 256);
        (0, $ihoyg.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $1d1fa5388254e796$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $ihoyg.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $1d1fa5388254e796$var$assert(wireTransaction.length <= $1d1fa5388254e796$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$1d1fa5388254e796$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $1d1fa5388254e796$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $1d1fa5388254e796$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $1d1fa5388254e796$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $1d1fa5388254e796$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode((0, $ihoyg.Buffer).from(signature)));
        }
        return $1d1fa5388254e796$export$febc5573c75cefb0.populate($1d1fa5388254e796$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).encode($1d1fa5388254e796$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $1d1fa5388254e796$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $1d1fa5388254e796$var$assert(numWritableSignedAccounts > 0, 'Message header is invalid');
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $1d1fa5388254e796$var$assert(numWritableUnsignedAccounts >= 0, 'Message header is invalid');
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error('Failed to decompile message because no account keys were found');
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $1d1fa5388254e796$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $1d1fa5388254e796$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $1d1fa5388254e796$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $1d1fa5388254e796$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $1d1fa5388254e796$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $1d1fa5388254e796$var$assert(signatures.length === message.header.numRequiredSignatures, 'Expected signatures length to be equal to the number of required signatures');
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($1d1fa5388254e796$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $1d1fa5388254e796$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $3wEH9.struct([
            $3wEH9.blob(encodedSignaturesLength.length, 'encodedSignaturesLength'),
            $3wEH9.seq($1d1fa5388254e796$var$signature(), this.signatures.length, 'signatures'),
            $3wEH9.blob(serializedMessage.length, 'serializedMessage')
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $1d1fa5388254e796$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$14aee086fde78fa6)));
        const message = $1d1fa5388254e796$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $1d1fa5388254e796$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $1d1fa5388254e796$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $1d1fa5388254e796$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $1d1fa5388254e796$var$assert(signature.byteLength === 64, 'Signature must be 64 bytes long');
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $1d1fa5388254e796$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $1d1fa5388254e796$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $1d1fa5388254e796$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $1d1fa5388254e796$var$NUM_SLOTS_PER_SECOND = $1d1fa5388254e796$var$NUM_TICKS_PER_SECOND / $1d1fa5388254e796$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $1d1fa5388254e796$var$MS_PER_SLOT = 1000 / $1d1fa5388254e796$var$NUM_SLOTS_PER_SECOND;
const $1d1fa5388254e796$export$393aa1412d47050e = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarC1ock11111111111111111111111111111111');
const $1d1fa5388254e796$export$2b71d479444d2f4 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarEpochSchedu1e111111111111111111111111');
const $1d1fa5388254e796$export$54419cc1a3ece8d6 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('Sysvar1nstructions1111111111111111111111111');
const $1d1fa5388254e796$export$e74201139e9833db = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarRecentB1ockHashes11111111111111111111');
const $1d1fa5388254e796$export$970d0190cdb3a8e9 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarRent111111111111111111111111111111111');
const $1d1fa5388254e796$export$da3b38d796bc1af1 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarRewards111111111111111111111111111111');
const $1d1fa5388254e796$export$7b3a057916a4a7ae = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarS1otHashes111111111111111111111111111');
const $1d1fa5388254e796$export$3272815bf0633907 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarS1otHistory11111111111111111111111111');
const $1d1fa5388254e796$export$ca994171317280ea = new $1d1fa5388254e796$export$ca8b6604d6ce14de('SysvarStakeHistory1111111111111111111111111');
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $1d1fa5388254e796$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $1d1fa5388254e796$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $1d1fa5388254e796$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $1d1fa5388254e796$var$getAlloc(type, fields);
    const data = (0, $ihoyg.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $1d1fa5388254e796$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $1d1fa5388254e796$export$d1cc579b1c48f515 = $3wEH9.nu64('lamportsPerSignature');
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $1d1fa5388254e796$var$NonceAccountLayout = $3wEH9.struct([
    $3wEH9.u32('version'),
    $3wEH9.u32('state'),
    $1d1fa5388254e796$var$publicKey('authorizedPubkey'),
    $1d1fa5388254e796$var$publicKey('nonce'),
    $3wEH9.struct([
        $1d1fa5388254e796$export$d1cc579b1c48f515
    ], 'feeCalculator')
]);
const $1d1fa5388254e796$export$7126250b6d8bd94a = $1d1fa5388254e796$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $1d1fa5388254e796$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $1d1fa5388254e796$var$NonceAccountLayout.decode($1d1fa5388254e796$var$toBuffer(buffer), 0);
        return new $1d1fa5388254e796$export$ed1c2356ce604759({
            authorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $1d1fa5388254e796$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $1d1fa5388254e796$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $1d1fa5388254e796$var$bigInt = (length)=>(property)=>{
        const layout = (0, $3wEH9.blob)(length, property);
        const { encode: encode, decode: decode } = $1d1fa5388254e796$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $gbKvo.toBigIntLE)((0, $ihoyg.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $gbKvo.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $1d1fa5388254e796$var$u64 = $1d1fa5388254e796$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $1d1fa5388254e796$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($1d1fa5388254e796$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a SystemInstruction');
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $1d1fa5388254e796$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($1d1fa5388254e796$export$d8c4e17726848113.programId)) throw new Error('invalid instruction; programId is not SystemProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $1d1fa5388254e796$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports'),
            $3wEH9.ns64('space'),
            $1d1fa5388254e796$var$publicKey('programId')
        ])
    },
    Assign: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('programId')
        ])
    },
    Transfer: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$u64('lamports')
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('base'),
            $1d1fa5388254e796$var$rustString('seed'),
            $3wEH9.ns64('lamports'),
            $3wEH9.ns64('space'),
            $1d1fa5388254e796$var$publicKey('programId')
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('authorized')
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('authorized')
        ])
    },
    Allocate: {
        index: 8,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('space')
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('base'),
            $1d1fa5388254e796$var$rustString('seed'),
            $3wEH9.ns64('space'),
            $1d1fa5388254e796$var$publicKey('programId')
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('base'),
            $1d1fa5388254e796$var$rustString('seed'),
            $1d1fa5388254e796$var$publicKey('programId')
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$u64('lamports'),
            $1d1fa5388254e796$var$rustString('seed'),
            $1d1fa5388254e796$var$publicKey('programId')
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $1d1fa5388254e796$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.Create;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $1d1fa5388254e796$var$toBuffer(params.programId.toBuffer())
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $1d1fa5388254e796$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $1d1fa5388254e796$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.Transfer;
            data = $1d1fa5388254e796$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $1d1fa5388254e796$var$encodeData(type, {
                base: $1d1fa5388254e796$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $1d1fa5388254e796$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.Assign;
            data = $1d1fa5388254e796$var$encodeData(type, {
                programId: $1d1fa5388254e796$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            base: $1d1fa5388254e796$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $1d1fa5388254e796$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        if ('basePubkey' in params && 'seed' in params) transaction.add($1d1fa5388254e796$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $1d1fa5388254e796$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($1d1fa5388254e796$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $1d1fa5388254e796$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            authorized: $1d1fa5388254e796$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $1d1fa5388254e796$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            authorized: $1d1fa5388254e796$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $1d1fa5388254e796$var$encodeData(type, {
                base: $1d1fa5388254e796$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $1d1fa5388254e796$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $1d1fa5388254e796$export$74bdf41d8d1e7108.Allocate;
            data = $1d1fa5388254e796$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$1d1fa5388254e796$export$d8c4e17726848113.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('11111111111111111111111111111111');
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $1d1fa5388254e796$var$CHUNK_SIZE = $1d1fa5388254e796$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $1d1fa5388254e796$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $1d1fa5388254e796$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, 'confirmed');
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error('Program load failed, account is already executable');
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $1d1fa5388254e796$export$febc5573c75cefb0();
                    transaction.add($1d1fa5388254e796$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $1d1fa5388254e796$export$febc5573c75cefb0();
                    transaction.add($1d1fa5388254e796$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $1d1fa5388254e796$export$febc5573c75cefb0();
                    transaction.add($1d1fa5388254e796$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $1d1fa5388254e796$export$febc5573c75cefb0().add($1d1fa5388254e796$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $1d1fa5388254e796$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            });
        }
        const dataLayout = $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.u32('offset'),
            $3wEH9.u32('bytesLength'),
            $3wEH9.u32('bytesLengthPadding'),
            $3wEH9.seq($3wEH9.u8('byte'), $3wEH9.offset($3wEH9.u32(), -8), 'bytes')
        ]);
        const chunkSize = $1d1fa5388254e796$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $ihoyg.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($1d1fa5388254e796$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes('solana.com')) {
                const REQUESTS_PER_SECOND = 4;
                await $1d1fa5388254e796$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $3wEH9.struct([
                $3wEH9.u32('instruction')
            ]);
            const data = (0, $ihoyg.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $1d1fa5388254e796$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = 'processed';
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($1d1fa5388254e796$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$1d1fa5388254e796$export$3b0d6d7590275603.chunkSize = $1d1fa5388254e796$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $1d1fa5388254e796$export$59833422f998b937 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('BPFLoader2111111111111111111111111111111111');
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $1d1fa5388254e796$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $1d1fa5388254e796$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $1d1fa5388254e796$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $1d1fa5388254e796$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $1d1fa5388254e796$var$objToString = Object.prototype.toString;
var $1d1fa5388254e796$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $1d1fa5388254e796$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $1d1fa5388254e796$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $1d1fa5388254e796$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = '[';
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $1d1fa5388254e796$var$stringify(val[i], true) + ',';
                    if (max > -1) str += $1d1fa5388254e796$var$stringify(val[i], true);
                    return str + ']';
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $1d1fa5388254e796$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $1d1fa5388254e796$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ',';
                            str += JSON.stringify(key) + ':' + propVal;
                        }
                        i++;
                    }
                    return '{' + str + '}';
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $1d1fa5388254e796$var$fastStableStringify = function(val) {
    var returnVal = $1d1fa5388254e796$var$stringify(val, false);
    if (returnVal !== undefined) return '' + returnVal;
};
var $1d1fa5388254e796$var$fastStableStringify$1 = /*@__PURE__*/ $1d1fa5388254e796$var$getDefaultExportFromCjs($1d1fa5388254e796$var$fastStableStringify);
const $1d1fa5388254e796$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $1d1fa5388254e796$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $1d1fa5388254e796$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $1d1fa5388254e796$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $1d1fa5388254e796$var$trailingZeros($1d1fa5388254e796$var$nextPowerOfTwo(slot + $1d1fa5388254e796$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $1d1fa5388254e796$var$trailingZeros($1d1fa5388254e796$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $1d1fa5388254e796$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $1d1fa5388254e796$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $1d1fa5388254e796$var$trailingZeros($1d1fa5388254e796$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $1d1fa5388254e796$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $1d1fa5388254e796$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $1d1fa5388254e796$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = 'SolanaJSONRPCError';
    }
}
var $1d1fa5388254e796$var$fetchImpl = globalThis.fetch;
class $1d1fa5388254e796$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($81012))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($6U8NG)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ('socket' in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error('Tried to call a JSON-RPC method `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error('Tried to send a JSON-RPC notification `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $1d1fa5388254e796$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $1d1fa5388254e796$var$LOOKUP_TABLE_META_SIZE = 56;
class $1d1fa5388254e796$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt('0xffffffffffffffff');
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $1d1fa5388254e796$var$decodeData($1d1fa5388254e796$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $1d1fa5388254e796$var$LOOKUP_TABLE_META_SIZE;
        $1d1fa5388254e796$var$assert(serializedAddressesLen >= 0, 'lookup table is invalid');
        $1d1fa5388254e796$var$assert(serializedAddressesLen % 32 === 0, 'lookup table is invalid');
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $3wEH9.struct([
            $3wEH9.seq($1d1fa5388254e796$var$publicKey(), numSerializedAddresses, 'addresses')
        ]).decode(accountData.slice($1d1fa5388254e796$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $1d1fa5388254e796$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(address))
        };
    }
}
const $1d1fa5388254e796$var$LookupTableMetaLayout = {
    index: 1,
    layout: $3wEH9.struct([
        $3wEH9.u32('typeIndex'),
        $1d1fa5388254e796$var$u64('deactivationSlot'),
        $3wEH9.nu64('lastExtendedSlot'),
        $3wEH9.u8('lastExtendedStartIndex'),
        $3wEH9.u8(),
        // option
        $3wEH9.seq($1d1fa5388254e796$var$publicKey(), $3wEH9.offset($3wEH9.u8(), -1), 'authority')
    ])
};
const $1d1fa5388254e796$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $1d1fa5388254e796$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($1d1fa5388254e796$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith('https:') ? 'wss:' : 'ws:';
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? '' : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $1d1fa5388254e796$var$PublicKeyFromString = (0, $kRZRk.coerce)((0, $kRZRk.instance)($1d1fa5388254e796$export$ca8b6604d6ce14de), (0, $kRZRk.string)(), (value)=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(value));
const $1d1fa5388254e796$var$RawAccountDataResult = (0, $kRZRk.tuple)([
    (0, $kRZRk.string)(),
    (0, $kRZRk.literal)('base64')
]);
const $1d1fa5388254e796$var$BufferFromRawAccountData = (0, $kRZRk.coerce)((0, $kRZRk.instance)((0, $ihoyg.Buffer)), $1d1fa5388254e796$var$RawAccountDataResult, (value)=>(0, $ihoyg.Buffer).from(value[0], 'base64'));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $1d1fa5388254e796$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $1d1fa5388254e796$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError('Endpoint URL must start with `http:` or `https:`.');
    return putativeUrl;
}
/** @internal */ function $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === 'string') commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $1d1fa5388254e796$var$createRpcResult(result) {
    return (0, $kRZRk.union)([
        (0, $kRZRk.type)({
            jsonrpc: (0, $kRZRk.literal)('2.0'),
            id: (0, $kRZRk.string)(),
            result: result
        }),
        (0, $kRZRk.type)({
            jsonrpc: (0, $kRZRk.literal)('2.0'),
            id: (0, $kRZRk.string)(),
            error: (0, $kRZRk.type)({
                code: (0, $kRZRk.unknown)(),
                message: (0, $kRZRk.string)(),
                data: (0, $kRZRk.optional)((0, $kRZRk.any)())
            })
        })
    ]);
}
const $1d1fa5388254e796$var$UnknownRpcResult = $1d1fa5388254e796$var$createRpcResult((0, $kRZRk.unknown)());
/**
 * @internal
 */ function $1d1fa5388254e796$var$jsonRpcResult(schema) {
    return (0, $kRZRk.coerce)($1d1fa5388254e796$var$createRpcResult(schema), $1d1fa5388254e796$var$UnknownRpcResult, (value)=>{
        if ('error' in value) return value;
        else return {
            ...value,
            result: (0, $kRZRk.create)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $1d1fa5388254e796$var$jsonRpcResultAndContext(value) {
    return $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.type)({
        context: (0, $kRZRk.type)({
            slot: (0, $kRZRk.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $1d1fa5388254e796$var$notificationResultAndContext(value) {
    return (0, $kRZRk.type)({
        context: (0, $kRZRk.type)({
            slot: (0, $kRZRk.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $1d1fa5388254e796$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $1d1fa5388254e796$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $1d1fa5388254e796$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $1d1fa5388254e796$var$GetInflationGovernorResult = (0, $kRZRk.type)({
    foundation: (0, $kRZRk.number)(),
    foundationTerm: (0, $kRZRk.number)(),
    initial: (0, $kRZRk.number)(),
    taper: (0, $kRZRk.number)(),
    terminal: (0, $kRZRk.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $1d1fa5388254e796$var$GetInflationRewardResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)((0, $kRZRk.nullable)((0, $kRZRk.type)({
    epoch: (0, $kRZRk.number)(),
    effectiveSlot: (0, $kRZRk.number)(),
    amount: (0, $kRZRk.number)(),
    postBalance: (0, $kRZRk.number)(),
    commission: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $1d1fa5388254e796$var$GetRecentPrioritizationFeesResult = (0, $kRZRk.array)((0, $kRZRk.type)({
    slot: (0, $kRZRk.number)(),
    prioritizationFee: (0, $kRZRk.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $1d1fa5388254e796$var$GetInflationRateResult = (0, $kRZRk.type)({
    total: (0, $kRZRk.number)(),
    validator: (0, $kRZRk.number)(),
    foundation: (0, $kRZRk.number)(),
    epoch: (0, $kRZRk.number)()
});
/**
 * Information about the current epoch
 */ const $1d1fa5388254e796$var$GetEpochInfoResult = (0, $kRZRk.type)({
    epoch: (0, $kRZRk.number)(),
    slotIndex: (0, $kRZRk.number)(),
    slotsInEpoch: (0, $kRZRk.number)(),
    absoluteSlot: (0, $kRZRk.number)(),
    blockHeight: (0, $kRZRk.optional)((0, $kRZRk.number)()),
    transactionCount: (0, $kRZRk.optional)((0, $kRZRk.number)())
});
const $1d1fa5388254e796$var$GetEpochScheduleResult = (0, $kRZRk.type)({
    slotsPerEpoch: (0, $kRZRk.number)(),
    leaderScheduleSlotOffset: (0, $kRZRk.number)(),
    warmup: (0, $kRZRk.boolean)(),
    firstNormalEpoch: (0, $kRZRk.number)(),
    firstNormalSlot: (0, $kRZRk.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $1d1fa5388254e796$var$GetLeaderScheduleResult = (0, $kRZRk.record)((0, $kRZRk.string)(), (0, $kRZRk.array)((0, $kRZRk.number)()));
/**
 * Transaction error or null
 */ const $1d1fa5388254e796$var$TransactionErrorResult = (0, $kRZRk.nullable)((0, $kRZRk.union)([
    (0, $kRZRk.type)({}),
    (0, $kRZRk.string)()
]));
/**
 * Signature status for a transaction
 */ const $1d1fa5388254e796$var$SignatureStatusResult = (0, $kRZRk.type)({
    err: $1d1fa5388254e796$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $1d1fa5388254e796$var$SignatureReceivedResult = (0, $kRZRk.literal)('receivedSignature');
/**
 * Version info for a node
 */ const $1d1fa5388254e796$var$VersionResult = (0, $kRZRk.type)({
    'solana-core': (0, $kRZRk.string)(),
    'feature-set': (0, $kRZRk.optional)((0, $kRZRk.number)())
});
const $1d1fa5388254e796$var$SimulatedTransactionResponseStruct = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.type)({
    err: (0, $kRZRk.nullable)((0, $kRZRk.union)([
        (0, $kRZRk.type)({}),
        (0, $kRZRk.string)()
    ])),
    logs: (0, $kRZRk.nullable)((0, $kRZRk.array)((0, $kRZRk.string)())),
    accounts: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)((0, $kRZRk.nullable)((0, $kRZRk.type)({
        executable: (0, $kRZRk.boolean)(),
        owner: (0, $kRZRk.string)(),
        lamports: (0, $kRZRk.number)(),
        data: (0, $kRZRk.array)((0, $kRZRk.string)()),
        rentEpoch: (0, $kRZRk.optional)((0, $kRZRk.number)())
    }))))),
    unitsConsumed: (0, $kRZRk.optional)((0, $kRZRk.number)()),
    returnData: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.type)({
        programId: (0, $kRZRk.string)(),
        data: (0, $kRZRk.tuple)([
            (0, $kRZRk.string)(),
            (0, $kRZRk.literal)('base64')
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $1d1fa5388254e796$var$BlockProductionResponseStruct = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.type)({
    byIdentity: (0, $kRZRk.record)((0, $kRZRk.string)(), (0, $kRZRk.array)((0, $kRZRk.number)())),
    range: (0, $kRZRk.type)({
        firstSlot: (0, $kRZRk.number)(),
        lastSlot: (0, $kRZRk.number)()
    })
}));
/**
 * A performance sample
 */ function $1d1fa5388254e796$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $1d1fa5388254e796$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($fFbWN)))(async (request, callback)=>{
        const options = {
            method: 'POST',
            body: request,
            agent: agent,
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, httpHeaders || {}, $1d1fa5388254e796$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $1d1fa5388254e796$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $1d1fa5388254e796$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $1d1fa5388254e796$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $1d1fa5388254e796$var$GetInflationGovernorRpcResult = $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $1d1fa5388254e796$var$GetInflationRateRpcResult = $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $1d1fa5388254e796$var$GetRecentPrioritizationFeesRpcResult = $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $1d1fa5388254e796$var$GetEpochInfoRpcResult = $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $1d1fa5388254e796$var$GetEpochScheduleRpcResult = $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $1d1fa5388254e796$var$GetLeaderScheduleRpcResult = $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $1d1fa5388254e796$var$SlotRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $1d1fa5388254e796$var$GetSupplyRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.type)({
    total: (0, $kRZRk.number)(),
    circulating: (0, $kRZRk.number)(),
    nonCirculating: (0, $kRZRk.number)(),
    nonCirculatingAccounts: (0, $kRZRk.array)($1d1fa5388254e796$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $1d1fa5388254e796$var$TokenAmountResult = (0, $kRZRk.type)({
    amount: (0, $kRZRk.string)(),
    uiAmount: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    decimals: (0, $kRZRk.number)(),
    uiAmountString: (0, $kRZRk.optional)((0, $kRZRk.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $1d1fa5388254e796$var$GetTokenLargestAccountsResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.type)({
    address: $1d1fa5388254e796$var$PublicKeyFromString,
    amount: (0, $kRZRk.string)(),
    uiAmount: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    decimals: (0, $kRZRk.number)(),
    uiAmountString: (0, $kRZRk.optional)((0, $kRZRk.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $1d1fa5388254e796$var$GetTokenAccountsByOwner = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.type)({
    pubkey: $1d1fa5388254e796$var$PublicKeyFromString,
    account: (0, $kRZRk.type)({
        executable: (0, $kRZRk.boolean)(),
        owner: $1d1fa5388254e796$var$PublicKeyFromString,
        lamports: (0, $kRZRk.number)(),
        data: $1d1fa5388254e796$var$BufferFromRawAccountData,
        rentEpoch: (0, $kRZRk.number)()
    })
})));
const $1d1fa5388254e796$var$ParsedAccountDataResult = (0, $kRZRk.type)({
    program: (0, $kRZRk.string)(),
    parsed: (0, $kRZRk.unknown)(),
    space: (0, $kRZRk.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $1d1fa5388254e796$var$GetParsedTokenAccountsByOwner = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.type)({
    pubkey: $1d1fa5388254e796$var$PublicKeyFromString,
    account: (0, $kRZRk.type)({
        executable: (0, $kRZRk.boolean)(),
        owner: $1d1fa5388254e796$var$PublicKeyFromString,
        lamports: (0, $kRZRk.number)(),
        data: $1d1fa5388254e796$var$ParsedAccountDataResult,
        rentEpoch: (0, $kRZRk.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $1d1fa5388254e796$var$GetLargestAccountsRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.type)({
    lamports: (0, $kRZRk.number)(),
    address: $1d1fa5388254e796$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $1d1fa5388254e796$var$AccountInfoResult = (0, $kRZRk.type)({
    executable: (0, $kRZRk.boolean)(),
    owner: $1d1fa5388254e796$var$PublicKeyFromString,
    lamports: (0, $kRZRk.number)(),
    data: $1d1fa5388254e796$var$BufferFromRawAccountData,
    rentEpoch: (0, $kRZRk.number)()
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$KeyedAccountInfoResult = (0, $kRZRk.type)({
    pubkey: $1d1fa5388254e796$var$PublicKeyFromString,
    account: $1d1fa5388254e796$var$AccountInfoResult
});
const $1d1fa5388254e796$var$ParsedOrRawAccountData = (0, $kRZRk.coerce)((0, $kRZRk.union)([
    (0, $kRZRk.instance)((0, $ihoyg.Buffer)),
    $1d1fa5388254e796$var$ParsedAccountDataResult
]), (0, $kRZRk.union)([
    $1d1fa5388254e796$var$RawAccountDataResult,
    $1d1fa5388254e796$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $kRZRk.create)(value, $1d1fa5388254e796$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$ParsedAccountInfoResult = (0, $kRZRk.type)({
    executable: (0, $kRZRk.boolean)(),
    owner: $1d1fa5388254e796$var$PublicKeyFromString,
    lamports: (0, $kRZRk.number)(),
    data: $1d1fa5388254e796$var$ParsedOrRawAccountData,
    rentEpoch: (0, $kRZRk.number)()
});
const $1d1fa5388254e796$var$KeyedParsedAccountInfoResult = (0, $kRZRk.type)({
    pubkey: $1d1fa5388254e796$var$PublicKeyFromString,
    account: $1d1fa5388254e796$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$StakeActivationResult = (0, $kRZRk.type)({
    state: (0, $kRZRk.union)([
        (0, $kRZRk.literal)('active'),
        (0, $kRZRk.literal)('inactive'),
        (0, $kRZRk.literal)('activating'),
        (0, $kRZRk.literal)('deactivating')
    ]),
    active: (0, $kRZRk.number)(),
    inactive: (0, $kRZRk.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $1d1fa5388254e796$var$GetConfirmedSignaturesForAddress2RpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)((0, $kRZRk.type)({
    signature: (0, $kRZRk.string)(),
    slot: (0, $kRZRk.number)(),
    err: $1d1fa5388254e796$var$TransactionErrorResult,
    memo: (0, $kRZRk.nullable)((0, $kRZRk.string)()),
    blockTime: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $1d1fa5388254e796$var$GetSignaturesForAddressRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)((0, $kRZRk.type)({
    signature: (0, $kRZRk.string)(),
    slot: (0, $kRZRk.number)(),
    err: $1d1fa5388254e796$var$TransactionErrorResult,
    memo: (0, $kRZRk.nullable)((0, $kRZRk.string)()),
    blockTime: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $1d1fa5388254e796$var$AccountNotificationResult = (0, $kRZRk.type)({
    subscription: (0, $kRZRk.number)(),
    result: $1d1fa5388254e796$var$notificationResultAndContext($1d1fa5388254e796$var$AccountInfoResult)
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$ProgramAccountInfoResult = (0, $kRZRk.type)({
    pubkey: $1d1fa5388254e796$var$PublicKeyFromString,
    account: $1d1fa5388254e796$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $1d1fa5388254e796$var$ProgramAccountNotificationResult = (0, $kRZRk.type)({
    subscription: (0, $kRZRk.number)(),
    result: $1d1fa5388254e796$var$notificationResultAndContext($1d1fa5388254e796$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$SlotInfoResult = (0, $kRZRk.type)({
    parent: (0, $kRZRk.number)(),
    slot: (0, $kRZRk.number)(),
    root: (0, $kRZRk.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $1d1fa5388254e796$var$SlotNotificationResult = (0, $kRZRk.type)({
    subscription: (0, $kRZRk.number)(),
    result: $1d1fa5388254e796$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $1d1fa5388254e796$var$SlotUpdateResult = (0, $kRZRk.union)([
    (0, $kRZRk.type)({
        type: (0, $kRZRk.union)([
            (0, $kRZRk.literal)('firstShredReceived'),
            (0, $kRZRk.literal)('completed'),
            (0, $kRZRk.literal)('optimisticConfirmation'),
            (0, $kRZRk.literal)('root')
        ]),
        slot: (0, $kRZRk.number)(),
        timestamp: (0, $kRZRk.number)()
    }),
    (0, $kRZRk.type)({
        type: (0, $kRZRk.literal)('createdBank'),
        parent: (0, $kRZRk.number)(),
        slot: (0, $kRZRk.number)(),
        timestamp: (0, $kRZRk.number)()
    }),
    (0, $kRZRk.type)({
        type: (0, $kRZRk.literal)('frozen'),
        slot: (0, $kRZRk.number)(),
        timestamp: (0, $kRZRk.number)(),
        stats: (0, $kRZRk.type)({
            numTransactionEntries: (0, $kRZRk.number)(),
            numSuccessfulTransactions: (0, $kRZRk.number)(),
            numFailedTransactions: (0, $kRZRk.number)(),
            maxTransactionsPerEntry: (0, $kRZRk.number)()
        })
    }),
    (0, $kRZRk.type)({
        type: (0, $kRZRk.literal)('dead'),
        slot: (0, $kRZRk.number)(),
        timestamp: (0, $kRZRk.number)(),
        err: (0, $kRZRk.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $1d1fa5388254e796$var$SlotUpdateNotificationResult = (0, $kRZRk.type)({
    subscription: (0, $kRZRk.number)(),
    result: $1d1fa5388254e796$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $1d1fa5388254e796$var$SignatureNotificationResult = (0, $kRZRk.type)({
    subscription: (0, $kRZRk.number)(),
    result: $1d1fa5388254e796$var$notificationResultAndContext((0, $kRZRk.union)([
        $1d1fa5388254e796$var$SignatureStatusResult,
        $1d1fa5388254e796$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $1d1fa5388254e796$var$RootNotificationResult = (0, $kRZRk.type)({
    subscription: (0, $kRZRk.number)(),
    result: (0, $kRZRk.number)()
});
const $1d1fa5388254e796$var$ContactInfoResult = (0, $kRZRk.type)({
    pubkey: (0, $kRZRk.string)(),
    gossip: (0, $kRZRk.nullable)((0, $kRZRk.string)()),
    tpu: (0, $kRZRk.nullable)((0, $kRZRk.string)()),
    rpc: (0, $kRZRk.nullable)((0, $kRZRk.string)()),
    version: (0, $kRZRk.nullable)((0, $kRZRk.string)())
});
const $1d1fa5388254e796$var$VoteAccountInfoResult = (0, $kRZRk.type)({
    votePubkey: (0, $kRZRk.string)(),
    nodePubkey: (0, $kRZRk.string)(),
    activatedStake: (0, $kRZRk.number)(),
    epochVoteAccount: (0, $kRZRk.boolean)(),
    epochCredits: (0, $kRZRk.array)((0, $kRZRk.tuple)([
        (0, $kRZRk.number)(),
        (0, $kRZRk.number)(),
        (0, $kRZRk.number)()
    ])),
    commission: (0, $kRZRk.number)(),
    lastVote: (0, $kRZRk.number)(),
    rootSlot: (0, $kRZRk.nullable)((0, $kRZRk.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $1d1fa5388254e796$var$GetVoteAccounts = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.type)({
    current: (0, $kRZRk.array)($1d1fa5388254e796$var$VoteAccountInfoResult),
    delinquent: (0, $kRZRk.array)($1d1fa5388254e796$var$VoteAccountInfoResult)
}));
const $1d1fa5388254e796$var$ConfirmationStatus = (0, $kRZRk.union)([
    (0, $kRZRk.literal)('processed'),
    (0, $kRZRk.literal)('confirmed'),
    (0, $kRZRk.literal)('finalized')
]);
const $1d1fa5388254e796$var$SignatureStatusResponse = (0, $kRZRk.type)({
    slot: (0, $kRZRk.number)(),
    confirmations: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    err: $1d1fa5388254e796$var$TransactionErrorResult,
    confirmationStatus: (0, $kRZRk.optional)($1d1fa5388254e796$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $1d1fa5388254e796$var$GetSignatureStatusesRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.nullable)($1d1fa5388254e796$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $1d1fa5388254e796$var$GetMinimumBalanceForRentExemptionRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.number)());
const $1d1fa5388254e796$var$AddressTableLookupStruct = (0, $kRZRk.type)({
    accountKey: $1d1fa5388254e796$var$PublicKeyFromString,
    writableIndexes: (0, $kRZRk.array)((0, $kRZRk.number)()),
    readonlyIndexes: (0, $kRZRk.array)((0, $kRZRk.number)())
});
const $1d1fa5388254e796$var$ConfirmedTransactionResult = (0, $kRZRk.type)({
    signatures: (0, $kRZRk.array)((0, $kRZRk.string)()),
    message: (0, $kRZRk.type)({
        accountKeys: (0, $kRZRk.array)((0, $kRZRk.string)()),
        header: (0, $kRZRk.type)({
            numRequiredSignatures: (0, $kRZRk.number)(),
            numReadonlySignedAccounts: (0, $kRZRk.number)(),
            numReadonlyUnsignedAccounts: (0, $kRZRk.number)()
        }),
        instructions: (0, $kRZRk.array)((0, $kRZRk.type)({
            accounts: (0, $kRZRk.array)((0, $kRZRk.number)()),
            data: (0, $kRZRk.string)(),
            programIdIndex: (0, $kRZRk.number)()
        })),
        recentBlockhash: (0, $kRZRk.string)(),
        addressTableLookups: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$AddressTableLookupStruct))
    })
});
const $1d1fa5388254e796$var$AnnotatedAccountKey = (0, $kRZRk.type)({
    pubkey: $1d1fa5388254e796$var$PublicKeyFromString,
    signer: (0, $kRZRk.boolean)(),
    writable: (0, $kRZRk.boolean)(),
    source: (0, $kRZRk.optional)((0, $kRZRk.union)([
        (0, $kRZRk.literal)('transaction'),
        (0, $kRZRk.literal)('lookupTable')
    ]))
});
const $1d1fa5388254e796$var$ConfirmedTransactionAccountsModeResult = (0, $kRZRk.type)({
    accountKeys: (0, $kRZRk.array)($1d1fa5388254e796$var$AnnotatedAccountKey),
    signatures: (0, $kRZRk.array)((0, $kRZRk.string)())
});
const $1d1fa5388254e796$var$ParsedInstructionResult = (0, $kRZRk.type)({
    parsed: (0, $kRZRk.unknown)(),
    program: (0, $kRZRk.string)(),
    programId: $1d1fa5388254e796$var$PublicKeyFromString
});
const $1d1fa5388254e796$var$RawInstructionResult = (0, $kRZRk.type)({
    accounts: (0, $kRZRk.array)($1d1fa5388254e796$var$PublicKeyFromString),
    data: (0, $kRZRk.string)(),
    programId: $1d1fa5388254e796$var$PublicKeyFromString
});
const $1d1fa5388254e796$var$InstructionResult = (0, $kRZRk.union)([
    $1d1fa5388254e796$var$RawInstructionResult,
    $1d1fa5388254e796$var$ParsedInstructionResult
]);
const $1d1fa5388254e796$var$UnknownInstructionResult = (0, $kRZRk.union)([
    (0, $kRZRk.type)({
        parsed: (0, $kRZRk.unknown)(),
        program: (0, $kRZRk.string)(),
        programId: (0, $kRZRk.string)()
    }),
    (0, $kRZRk.type)({
        accounts: (0, $kRZRk.array)((0, $kRZRk.string)()),
        data: (0, $kRZRk.string)(),
        programId: (0, $kRZRk.string)()
    })
]);
const $1d1fa5388254e796$var$ParsedOrRawInstruction = (0, $kRZRk.coerce)($1d1fa5388254e796$var$InstructionResult, $1d1fa5388254e796$var$UnknownInstructionResult, (value)=>{
    if ('accounts' in value) return (0, $kRZRk.create)(value, $1d1fa5388254e796$var$RawInstructionResult);
    else return (0, $kRZRk.create)(value, $1d1fa5388254e796$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$ParsedConfirmedTransactionResult = (0, $kRZRk.type)({
    signatures: (0, $kRZRk.array)((0, $kRZRk.string)()),
    message: (0, $kRZRk.type)({
        accountKeys: (0, $kRZRk.array)($1d1fa5388254e796$var$AnnotatedAccountKey),
        instructions: (0, $kRZRk.array)($1d1fa5388254e796$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $kRZRk.string)(),
        addressTableLookups: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)($1d1fa5388254e796$var$AddressTableLookupStruct)))
    })
});
const $1d1fa5388254e796$var$TokenBalanceResult = (0, $kRZRk.type)({
    accountIndex: (0, $kRZRk.number)(),
    mint: (0, $kRZRk.string)(),
    owner: (0, $kRZRk.optional)((0, $kRZRk.string)()),
    uiTokenAmount: $1d1fa5388254e796$var$TokenAmountResult
});
const $1d1fa5388254e796$var$LoadedAddressesResult = (0, $kRZRk.type)({
    writable: (0, $kRZRk.array)($1d1fa5388254e796$var$PublicKeyFromString),
    readonly: (0, $kRZRk.array)($1d1fa5388254e796$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$ConfirmedTransactionMetaResult = (0, $kRZRk.type)({
    err: $1d1fa5388254e796$var$TransactionErrorResult,
    fee: (0, $kRZRk.number)(),
    innerInstructions: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)((0, $kRZRk.type)({
        index: (0, $kRZRk.number)(),
        instructions: (0, $kRZRk.array)((0, $kRZRk.type)({
            accounts: (0, $kRZRk.array)((0, $kRZRk.number)()),
            data: (0, $kRZRk.string)(),
            programIdIndex: (0, $kRZRk.number)()
        }))
    })))),
    preBalances: (0, $kRZRk.array)((0, $kRZRk.number)()),
    postBalances: (0, $kRZRk.array)((0, $kRZRk.number)()),
    logMessages: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)((0, $kRZRk.string)()))),
    preTokenBalances: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)($1d1fa5388254e796$var$TokenBalanceResult))),
    postTokenBalances: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)($1d1fa5388254e796$var$TokenBalanceResult))),
    loadedAddresses: (0, $kRZRk.optional)($1d1fa5388254e796$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $kRZRk.optional)((0, $kRZRk.number)())
});
/**
 * @internal
 */ const $1d1fa5388254e796$var$ParsedConfirmedTransactionMetaResult = (0, $kRZRk.type)({
    err: $1d1fa5388254e796$var$TransactionErrorResult,
    fee: (0, $kRZRk.number)(),
    innerInstructions: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)((0, $kRZRk.type)({
        index: (0, $kRZRk.number)(),
        instructions: (0, $kRZRk.array)($1d1fa5388254e796$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $kRZRk.array)((0, $kRZRk.number)()),
    postBalances: (0, $kRZRk.array)((0, $kRZRk.number)()),
    logMessages: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)((0, $kRZRk.string)()))),
    preTokenBalances: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)($1d1fa5388254e796$var$TokenBalanceResult))),
    postTokenBalances: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.array)($1d1fa5388254e796$var$TokenBalanceResult))),
    loadedAddresses: (0, $kRZRk.optional)($1d1fa5388254e796$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $kRZRk.optional)((0, $kRZRk.number)())
});
const $1d1fa5388254e796$var$TransactionVersionStruct = (0, $kRZRk.union)([
    (0, $kRZRk.literal)(0),
    (0, $kRZRk.literal)('legacy')
]);
/** @internal */ const $1d1fa5388254e796$var$RewardsResult = (0, $kRZRk.type)({
    pubkey: (0, $kRZRk.string)(),
    lamports: (0, $kRZRk.number)(),
    postBalance: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    rewardType: (0, $kRZRk.nullable)((0, $kRZRk.string)()),
    commission: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $1d1fa5388254e796$var$GetBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    transactions: (0, $kRZRk.array)((0, $kRZRk.type)({
        transaction: $1d1fa5388254e796$var$ConfirmedTransactionResult,
        meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ConfirmedTransactionMetaResult),
        version: (0, $kRZRk.optional)($1d1fa5388254e796$var$TransactionVersionStruct)
    })),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    blockHeight: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $1d1fa5388254e796$var$GetNoneModeBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    blockHeight: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $1d1fa5388254e796$var$GetAccountsModeBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    transactions: (0, $kRZRk.array)((0, $kRZRk.type)({
        transaction: $1d1fa5388254e796$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ConfirmedTransactionMetaResult),
        version: (0, $kRZRk.optional)($1d1fa5388254e796$var$TransactionVersionStruct)
    })),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    blockHeight: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $1d1fa5388254e796$var$GetParsedBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    transactions: (0, $kRZRk.array)((0, $kRZRk.type)({
        transaction: $1d1fa5388254e796$var$ParsedConfirmedTransactionResult,
        meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $kRZRk.optional)($1d1fa5388254e796$var$TransactionVersionStruct)
    })),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    blockHeight: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $1d1fa5388254e796$var$GetParsedAccountsModeBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    transactions: (0, $kRZRk.array)((0, $kRZRk.type)({
        transaction: $1d1fa5388254e796$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $kRZRk.optional)($1d1fa5388254e796$var$TransactionVersionStruct)
    })),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    blockHeight: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $1d1fa5388254e796$var$GetParsedNoneModeBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)()),
    blockHeight: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $1d1fa5388254e796$var$GetConfirmedBlockRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    transactions: (0, $kRZRk.array)((0, $kRZRk.type)({
        transaction: $1d1fa5388254e796$var$ConfirmedTransactionResult,
        meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $kRZRk.optional)((0, $kRZRk.array)($1d1fa5388254e796$var$RewardsResult)),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $1d1fa5388254e796$var$GetBlockSignaturesRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    previousBlockhash: (0, $kRZRk.string)(),
    parentSlot: (0, $kRZRk.number)(),
    signatures: (0, $kRZRk.array)((0, $kRZRk.string)()),
    blockTime: (0, $kRZRk.nullable)((0, $kRZRk.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $1d1fa5388254e796$var$GetTransactionRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    slot: (0, $kRZRk.number)(),
    meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.number)())),
    transaction: $1d1fa5388254e796$var$ConfirmedTransactionResult,
    version: (0, $kRZRk.optional)($1d1fa5388254e796$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $1d1fa5388254e796$var$GetParsedTransactionRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.type)({
    slot: (0, $kRZRk.number)(),
    transaction: $1d1fa5388254e796$var$ParsedConfirmedTransactionResult,
    meta: (0, $kRZRk.nullable)($1d1fa5388254e796$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $kRZRk.optional)((0, $kRZRk.nullable)((0, $kRZRk.number)())),
    version: (0, $kRZRk.optional)($1d1fa5388254e796$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $1d1fa5388254e796$var$GetRecentBlockhashAndContextRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    feeCalculator: (0, $kRZRk.type)({
        lamportsPerSignature: (0, $kRZRk.number)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $1d1fa5388254e796$var$GetLatestBlockhashRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.type)({
    blockhash: (0, $kRZRk.string)(),
    lastValidBlockHeight: (0, $kRZRk.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $1d1fa5388254e796$var$IsBlockhashValidRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.boolean)());
const $1d1fa5388254e796$var$PerfSampleResult = (0, $kRZRk.type)({
    slot: (0, $kRZRk.number)(),
    numTransactions: (0, $kRZRk.number)(),
    numSlots: (0, $kRZRk.number)(),
    samplePeriodSecs: (0, $kRZRk.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $1d1fa5388254e796$var$GetRecentPerformanceSamplesRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)($1d1fa5388254e796$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $1d1fa5388254e796$var$GetFeeCalculatorRpcResult = $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.nullable)((0, $kRZRk.type)({
    feeCalculator: (0, $kRZRk.type)({
        lamportsPerSignature: (0, $kRZRk.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $1d1fa5388254e796$var$RequestAirdropRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $1d1fa5388254e796$var$SendTransactionRpcResult = $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $1d1fa5388254e796$var$LogsResult = (0, $kRZRk.type)({
    err: $1d1fa5388254e796$var$TransactionErrorResult,
    logs: (0, $kRZRk.array)((0, $kRZRk.string)()),
    signature: (0, $kRZRk.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $1d1fa5388254e796$var$LogsNotificationResult = (0, $kRZRk.type)({
    result: $1d1fa5388254e796$var$notificationResultAndContext($1d1fa5388254e796$var$LogsResult),
    subscription: (0, $kRZRk.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $1d1fa5388254e796$var$COMMON_HTTP_HEADERS = {
    'solana-client': `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $1d1fa5388254e796$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $1d1fa5388254e796$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest('getBlockHeight', args);
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.number)()));
                        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get block height information');
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === 'string') this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $1d1fa5388254e796$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $1d1fa5388254e796$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $1d1fa5388254e796$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $1d1fa5388254e796$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $1d1fa5388254e796$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $1d1fa5388254e796$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on('open', this._wsOnOpen.bind(this));
        this._rpcWebSocket.on('error', this._wsOnError.bind(this));
        this._rpcWebSocket.on('close', this._wsOnClose.bind(this));
        this._rpcWebSocket.on('accountNotification', this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on('programNotification', this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on('slotNotification', this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on('slotsUpdatesNotification', this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on('signatureNotification', this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on('rootNotification', this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on('logsNotification', this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBalance', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.number)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get balance of account ' + publicKey.toBase58() + ': ' + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest('getBlockTime', [
            slot
        ]);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.nullable)((0, $kRZRk.number)())));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest('minimumLedgerSlot', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.number)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get minimum ledger slot');
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest('getFirstAvailableBlock', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$SlotRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get first available block');
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === 'string') configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest('getSupply', [
            configArg
        ]);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetSupplyRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get supply');
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenSupply', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext($1d1fa5388254e796$var$TokenAmountResult));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get token supply');
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenAccountBalance', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext($1d1fa5388254e796$var$TokenAmountResult));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get token account balance');
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetTokenAccountsByOwner);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedTokenAccountsByOwner);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest('getLargestAccounts', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetLargestAccountsRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get largest accounts');
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenLargestAccounts', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetTokenLargestAccountsResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get token largest accounts');
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.nullable)($1d1fa5388254e796$var$AccountInfoResult)));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.nullable)($1d1fa5388254e796$var$ParsedAccountInfoResult)));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get info about account ' + publicKey.toBase58() + ': ' + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.nullable)($1d1fa5388254e796$var$ParsedAccountInfoResult))));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.array)((0, $kRZRk.nullable)($1d1fa5388254e796$var$AccountInfoResult))));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getStakeActivation', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$StakeActivationResult));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || 'base64', configWithoutEncoding);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const baseSchema = (0, $kRZRk.array)($1d1fa5388254e796$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext(baseSchema)) : (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult(baseSchema));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)($1d1fa5388254e796$var$KeyedParsedAccountInfoResult)));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == 'string') rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($7fZv8))).decode(rawSignature);
        } catch (err) {
            throw new Error('signature must be base58 encoded: ' + rawSignature);
        }
        $1d1fa5388254e796$var$assert(decodedSignature.length === 64, 'signature has invalid length');
        if (typeof strategy === 'string') return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ('lastValidBlockHeight' in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener('abort', ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $1d1fa5388254e796$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === 'subscribed') resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case 'confirmed':
                            case 'single':
                            case 'singleGossip':
                                if (value.confirmationStatus === 'processed') return;
                                break;
                            case 'finalized':
                            case 'max':
                            case 'root':
                                if (value.confirmationStatus === 'processed' || value.confirmationStatus === 'confirmed') return;
                                break;
                            // exhaust enums to ensure full coverage
                            case 'processed':
                            case 'recent':
                        }
                        done = true;
                        resolve({
                            __type: $1d1fa5388254e796$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $1d1fa5388254e796$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $1d1fa5388254e796$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $1d1fa5388254e796$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $1d1fa5388254e796$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $1d1fa5388254e796$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $1d1fa5388254e796$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $1d1fa5388254e796$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $1d1fa5388254e796$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || 'finalized';
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case 'processed':
                        case 'recent':
                            if (confirmationStatus !== 'processed' && confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $1d1fa5388254e796$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'confirmed':
                        case 'single':
                        case 'singleGossip':
                            if (confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $1d1fa5388254e796$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'finalized':
                        case 'max':
                        case 'root':
                            if (confirmationStatus !== 'finalized') throw new $1d1fa5388254e796$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $1d1fa5388254e796$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case 'processed':
                case 'recent':
                case 'single':
                case 'confirmed':
                case 'singleGossip':
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $1d1fa5388254e796$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $1d1fa5388254e796$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $1d1fa5388254e796$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest('getClusterNodes', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)($1d1fa5388254e796$var$ContactInfoResult)));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get cluster nodes');
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getVoteAccounts', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetVoteAccounts);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get vote accounts');
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlot', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.number)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot');
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlotLeader', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.string)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leader');
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest('getSlotLeaders', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)($1d1fa5388254e796$var$PublicKeyFromString)));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leaders');
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $1d1fa5388254e796$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest('getSignatureStatuses', params);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetSignatureStatusesRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get signature status');
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransactionCount', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.number)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction count');
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getInflationGovernor', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetInflationGovernorRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation');
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getInflationReward', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetInflationRewardResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation reward');
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest('getInflationRate', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetInflationRateRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation rate');
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getEpochInfo', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetEpochInfoRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch info');
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest('getEpochSchedule', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetEpochScheduleRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch schedule');
        const epochSchedule = res.result;
        return new $1d1fa5388254e796$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest('getLeaderSchedule', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetLeaderScheduleRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get leader schedule');
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest('getMinimumBalanceForRentExemption', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ('error' in res) {
            console.warn('Unable to fetch minimum balance for rent exemption');
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getRecentBlockhash', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetRecentBlockhashAndContextRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent blockhash');
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest('getRecentPerformanceSamples', limit ? [
            limit
        ] : []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetRecentPerformanceSamplesRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent performance samples');
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeCalculatorForBlockhash', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetFeeCalculatorRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee calculator');
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $1d1fa5388254e796$var$toBuffer(message.serialize()).toString('base64');
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeForMessage', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.nullable)((0, $kRZRk.number)())));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee for message');
        if (res.result === null) throw new Error('invalid blockhash');
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest('getRecentPrioritizationFees', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetRecentPrioritizationFeesRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent prioritization fees');
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getLatestBlockhash', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetLatestBlockhashRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get latest blockhash');
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('isBlockhashValid', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$IsBlockhashValidRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to determine if the blockhash `' + blockhash + '`is valid');
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest('getVersion', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult($1d1fa5388254e796$var$VersionResult));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get version');
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest('getGenesisHash', []);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.string)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get genesis hash');
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetBlockRpcResult);
                        if ('error' in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $1d1fa5388254e796$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(e, 'failed to get confirmed block');
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(e, 'failed to get block');
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === 'string') commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, 'base64', extra);
        const unsafeRes = await this._rpcRequest('getBlockProduction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$BlockProductionResponseStruct);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get block production information');
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetTransactionRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $1d1fa5388254e796$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed', config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $1d1fa5388254e796$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetTransactionRpcResult);
            if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $1d1fa5388254e796$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getConfirmedBlock', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetConfirmedBlockRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $1d1fa5388254e796$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $1d1fa5388254e796$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getBlocks', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResult((0, $kRZRk.array)((0, $kRZRk.number)())));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get blocks');
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getBlock', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get block');
        const result = res.result;
        if (!result) throw new Error('Block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getConfirmedBlock', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest('getConfirmedTransaction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetTransactionRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        const message = new $1d1fa5388254e796$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $1d1fa5388254e796$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getConfirmedTransaction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed');
            return {
                methodName: 'getConfirmedTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!('until' in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, 'finalized');
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot('finalized');
        while(!('before' in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getConfirmedSignaturesForAddress2', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed signatures for address');
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getSignaturesForAddress', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$GetSignaturesForAddressRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, 'failed to get signatures for address');
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $1d1fa5388254e796$export$5b2310da10e607da({
            key: accountKey,
            state: $1d1fa5388254e796$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $1d1fa5388254e796$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get nonce for account ' + nonceAccount.toBase58() + ': ' + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest('requestAirdrop', [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$RequestAirdropRpcResult);
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $1d1fa5388254e796$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $1d1fa5388254e796$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash('finalized');
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $1d1fa5388254e796$var$sleep($1d1fa5388254e796$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $1d1fa5388254e796$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, 'base64', configArg);
        const unsafeRes = await this._rpcRequest('getStakeMinimumDelegation', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$jsonRpcResultAndContext((0, $kRZRk.number)()));
        if ('error' in res) throw new $1d1fa5388254e796$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ('message' in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $ihoyg.Buffer).from(wireTransaction).toString('base64');
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error('Invalid arguments');
            const config = configOrSigners || {};
            config.encoding = 'base64';
            if (!('commitment' in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest('simulateTransaction', args);
            const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$SimulatedTransactionResponseStruct);
            if ('error' in res) throw new Error('failed to simulate transaction: ' + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $1d1fa5388254e796$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $1d1fa5388254e796$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error('Invalid arguments');
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString('base64');
        const config = {
            encoding: 'base64',
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config['accounts'] = {
                encoding: 'base64',
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('simulateTransaction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$SimulatedTransactionResponseStruct);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = '\n    ';
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $1d1fa5388254e796$export$121e803f723b3045('failed to simulate transaction: ' + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ('version' in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $1d1fa5388254e796$var$toBuffer(rawTransaction).toString('base64');
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: 'base64'
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? 'processed' // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('sendTransaction', args);
        const res = (0, $kRZRk.create)(unsafeRes, $1d1fa5388254e796$var$SendTransactionRpcResult);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) logs = res.error.data.logs;
            throw new $1d1fa5388254e796$export$121e803f723b3045('failed to send transaction: ' + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify('ping');
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error('ws error:', err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: 'pending'
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case 'pending':
                case 'unsubscribed':
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === 'unsubscribed') delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'subscribing'
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: 'subscribed'
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'pending'
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case 'subscribed':
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: 'subscribed'
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: 'unsubscribed'
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $1d1fa5388254e796$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: 'pending'
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $1d1fa5388254e796$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64');
        return this._makeSubscription({
            callback: callback,
            method: 'accountSubscribe',
            unsubscribeMethod: 'accountUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'account change');
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64' /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: 'programSubscribe',
            unsubscribeMethod: 'programUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'program account change');
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === 'object' ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: 'logsSubscribe',
            unsubscribeMethod: 'logsUnsubscribe'
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'logs');
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotSubscribe',
            unsubscribeMethod: 'slotUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot change');
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotsUpdatesSubscribe',
            unsubscribeMethod: 'slotsUpdatesUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot update');
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn('Ignored unsubscribe request because an active subscription with id ' + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + 'could not be found.');
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            'confirmed',
            'finalized'
        ].includes(commitment)) throw new Error('Using Connection with default commitment: `' + this._commitment + '`, but method requires at least `confirmed`');
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$SignatureNotificationResult);
        if (result.value !== 'receivedSignature') /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === 'receivedSignature' ? [
            {
                type: 'received'
            },
            result.context
        ] : [
            {
                type: 'status',
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === 'status') {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || 'finalized' // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'signature result');
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kRZRk.create)(notification, $1d1fa5388254e796$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'rootSubscribe',
            unsubscribeMethod: 'rootUnsubscribe'
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'root change');
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $1d1fa5388254e796$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $1d1fa5388254e796$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $1d1fa5388254e796$export$c53bca448cf33676($1d1fa5388254e796$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error('bad secret key size');
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $1d1fa5388254e796$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error('provided secretKey is invalid');
            }
        }
        return new $1d1fa5388254e796$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $1d1fa5388254e796$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $1d1fa5388254e796$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $1d1fa5388254e796$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $1d1fa5388254e796$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$u64('recentSlot'),
            $3wEH9.u8('bumpSeed')
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$u64(),
            $3wEH9.seq($1d1fa5388254e796$var$publicKey(), $3wEH9.offset($3wEH9.u32(), -8), 'addresses')
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    }
});
class $1d1fa5388254e796$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($1d1fa5388254e796$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error('Invalid Instruction. Should be a LookupTable Instruction');
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $1d1fa5388254e796$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($1d1fa5388254e796$export$5147a345798de168.programId)) throw new Error('invalid instruction; programId is not AddressLookupTable Program');
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $1d1fa5388254e796$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $1d1fa5388254e796$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $gbKvo.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $1d1fa5388254e796$export$7d102200c3a357d6.CreateLookupTable;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $1d1fa5388254e796$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $1d1fa5388254e796$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $1d1fa5388254e796$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $1d1fa5388254e796$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $1d1fa5388254e796$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $1d1fa5388254e796$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $1d1fa5388254e796$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $1d1fa5388254e796$export$7d102200c3a357d6.CloseLookupTable;
        const data = $1d1fa5388254e796$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$1d1fa5388254e796$export$5147a345798de168.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('AddressLookupTab1e1111111111111111111111111');
/**
 * Compute Budget Instruction class
 */ class $1d1fa5388254e796$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u8('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($1d1fa5388254e796$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a ComputeBudgetInstruction');
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($1d1fa5388254e796$export$11585db5942bcdb7.programId)) throw new Error('invalid instruction; programId is not ComputeBudgetProgram');
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $1d1fa5388254e796$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('units'),
            $3wEH9.u32('additionalFee')
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('bytes')
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('units')
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $1d1fa5388254e796$var$u64('microLamports')
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $1d1fa5388254e796$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $1d1fa5388254e796$export$b7c79c50764da3d6.RequestUnits;
        const data = $1d1fa5388254e796$var$encodeData(type, params);
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $1d1fa5388254e796$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $1d1fa5388254e796$var$encodeData(type, params);
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $1d1fa5388254e796$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $1d1fa5388254e796$var$encodeData(type, params);
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $1d1fa5388254e796$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$1d1fa5388254e796$export$11585db5942bcdb7.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('ComputeBudget111111111111111111111111111111');
const $1d1fa5388254e796$var$PRIVATE_KEY_BYTES$1 = 64;
const $1d1fa5388254e796$var$PUBLIC_KEY_BYTES$1 = 32;
const $1d1fa5388254e796$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $1d1fa5388254e796$var$ED25519_INSTRUCTION_LAYOUT = $3wEH9.struct([
    $3wEH9.u8('numSignatures'),
    $3wEH9.u8('padding'),
    $3wEH9.u16('signatureOffset'),
    $3wEH9.u16('signatureInstructionIndex'),
    $3wEH9.u16('publicKeyOffset'),
    $3wEH9.u16('publicKeyInstructionIndex'),
    $3wEH9.u16('messageDataOffset'),
    $3wEH9.u16('messageDataSize'),
    $3wEH9.u16('messageInstructionIndex')
]);
class $1d1fa5388254e796$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $1d1fa5388254e796$var$assert(publicKey.length === $1d1fa5388254e796$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$1d1fa5388254e796$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $1d1fa5388254e796$var$assert(signature.length === $1d1fa5388254e796$var$SIGNATURE_BYTES, `Signature must be ${$1d1fa5388254e796$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $1d1fa5388254e796$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $ihoyg.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $1d1fa5388254e796$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $1d1fa5388254e796$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $1d1fa5388254e796$var$assert(privateKey.length === $1d1fa5388254e796$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$1d1fa5388254e796$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $1d1fa5388254e796$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $1d1fa5388254e796$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$1d1fa5388254e796$export$e5087aea02631e.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('Ed25519SigVerify111111111111111111111111111');
const $1d1fa5388254e796$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $75Cpc.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $75Cpc.secp256k1).utils.isValidPrivateKey;
const $1d1fa5388254e796$var$publicKeyCreate = (0, $75Cpc.secp256k1).getPublicKey;
const $1d1fa5388254e796$var$PRIVATE_KEY_BYTES = 32;
const $1d1fa5388254e796$var$ETHEREUM_ADDRESS_BYTES = 20;
const $1d1fa5388254e796$var$PUBLIC_KEY_BYTES = 64;
const $1d1fa5388254e796$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $1d1fa5388254e796$var$SECP256K1_INSTRUCTION_LAYOUT = $3wEH9.struct([
    $3wEH9.u8('numSignatures'),
    $3wEH9.u16('signatureOffset'),
    $3wEH9.u8('signatureInstructionIndex'),
    $3wEH9.u16('ethAddressOffset'),
    $3wEH9.u8('ethAddressInstructionIndex'),
    $3wEH9.u16('messageDataOffset'),
    $3wEH9.u16('messageDataSize'),
    $3wEH9.u8('messageInstructionIndex'),
    $3wEH9.blob(20, 'ethAddress'),
    $3wEH9.blob(64, 'signature'),
    $3wEH9.u8('recoveryId')
]);
class $1d1fa5388254e796$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $1d1fa5388254e796$var$assert(publicKey.length === $1d1fa5388254e796$var$PUBLIC_KEY_BYTES, `Public key must be ${$1d1fa5388254e796$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $ihoyg.Buffer).from((0, $ek8qD.keccak_256)($1d1fa5388254e796$var$toBuffer(publicKey))).slice(-$1d1fa5388254e796$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $1d1fa5388254e796$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $1d1fa5388254e796$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === 'string') {
            if (rawAddress.startsWith('0x')) ethAddress = (0, $ihoyg.Buffer).from(rawAddress.substr(2), 'hex');
            else ethAddress = (0, $ihoyg.Buffer).from(rawAddress, 'hex');
        } else ethAddress = rawAddress;
        $1d1fa5388254e796$var$assert(ethAddress.length === $1d1fa5388254e796$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$1d1fa5388254e796$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $1d1fa5388254e796$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $ihoyg.Buffer).alloc($1d1fa5388254e796$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $1d1fa5388254e796$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $1d1fa5388254e796$var$toBuffer(signature),
            ethAddress: $1d1fa5388254e796$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($1d1fa5388254e796$var$toBuffer(message), $1d1fa5388254e796$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $1d1fa5388254e796$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $1d1fa5388254e796$var$assert(pkey.length === $1d1fa5388254e796$var$PRIVATE_KEY_BYTES, `Private key must be ${$1d1fa5388254e796$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $1d1fa5388254e796$var$toBuffer(pkey);
            const publicKey = $1d1fa5388254e796$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $ihoyg.Buffer).from((0, $ek8qD.keccak_256)($1d1fa5388254e796$var$toBuffer(message)));
            const [signature, recoveryId] = $1d1fa5388254e796$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$1d1fa5388254e796$export$d85dd4c1161d13c9.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('KeccakSecp256k11111111111111111111111111111');
var $1d1fa5388254e796$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $1d1fa5388254e796$export$18aac71979bdd08f = new $1d1fa5388254e796$export$ca8b6604d6ce14de('StakeConfig11111111111111111111111111111111');
/**
 * Stake account authority info
 */ class $1d1fa5388254e796$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $1d1fa5388254e796$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$1d1fa5388254e796$var$_class2 = $1d1fa5388254e796$export$e7f3941ade35598c;
$1d1fa5388254e796$export$e7f3941ade35598c.default = new $1d1fa5388254e796$var$_class2(0, 0, $1d1fa5388254e796$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $1d1fa5388254e796$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($1d1fa5388254e796$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a StakeInstruction');
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $1d1fa5388254e796$export$9ac74ae66932a145(new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorized.staker), new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $1d1fa5388254e796$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $1d1fa5388254e796$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($1d1fa5388254e796$export$df86f933e9f8fb15.programId)) throw new Error('invalid instruction; programId is not StakeProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $1d1fa5388254e796$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$authorized(),
            $1d1fa5388254e796$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('newAuthorized'),
            $3wEH9.u32('stakeAuthorizationType')
        ])
    },
    Delegate: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    Split: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    Withdraw: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    Deactivate: {
        index: 5,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    Merge: {
        index: 7,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('newAuthorized'),
            $3wEH9.u32('stakeAuthorizationType'),
            $1d1fa5388254e796$var$rustString('authoritySeed'),
            $1d1fa5388254e796$var$publicKey('authorityOwner')
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $1d1fa5388254e796$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $1d1fa5388254e796$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $1d1fa5388254e796$export$e7f3941ade35598c.default;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Initialize;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            authorized: {
                staker: $1d1fa5388254e796$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $1d1fa5388254e796$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $1d1fa5388254e796$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        transaction.add($1d1fa5388254e796$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        transaction.add($1d1fa5388254e796$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Delegate;
        const data = $1d1fa5388254e796$var$encodeData(type);
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Authorize;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            newAuthorized: $1d1fa5388254e796$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            newAuthorized: $1d1fa5388254e796$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $1d1fa5388254e796$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Split;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            lamports: lamports
        });
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        transaction.add($1d1fa5388254e796$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        transaction.add($1d1fa5388254e796$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($1d1fa5388254e796$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Merge;
        const data = $1d1fa5388254e796$var$encodeData(type);
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Withdraw;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $1d1fa5388254e796$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $1d1fa5388254e796$export$c89793bd2bba8b2e.Deactivate;
        const data = $1d1fa5388254e796$var$encodeData(type);
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$1d1fa5388254e796$export$df86f933e9f8fb15.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('Stake11111111111111111111111111111111111111');
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $1d1fa5388254e796$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $1d1fa5388254e796$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $1d1fa5388254e796$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a VoteInstruction');
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $1d1fa5388254e796$export$3f9d1b16ff840d7(new $1d1fa5388254e796$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $1d1fa5388254e796$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $1d1fa5388254e796$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $1d1fa5388254e796$var$decodeData$1($1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($1d1fa5388254e796$export$83db2bc702bee1eb.programId)) throw new Error('invalid instruction; programId is not VoteProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$publicKey('newAuthorized'),
            $3wEH9.u32('voteAuthorizationType')
        ])
    },
    Withdraw: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $1d1fa5388254e796$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $1d1fa5388254e796$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $1d1fa5388254e796$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            voteInit: {
                nodePubkey: $1d1fa5388254e796$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $1d1fa5388254e796$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $1d1fa5388254e796$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $1d1fa5388254e796$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $1d1fa5388254e796$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $1d1fa5388254e796$export$febc5573c75cefb0();
        transaction.add($1d1fa5388254e796$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            newAuthorized: $1d1fa5388254e796$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $1d1fa5388254e796$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $1d1fa5388254e796$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $1d1fa5388254e796$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $1d1fa5388254e796$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error('Withdraw will leave vote account with insufficient funds.');
        return $1d1fa5388254e796$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $1d1fa5388254e796$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $1d1fa5388254e796$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $1d1fa5388254e796$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$1d1fa5388254e796$export$83db2bc702bee1eb.programId = new $1d1fa5388254e796$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $1d1fa5388254e796$export$83db2bc702bee1eb.space = 3762;
const $1d1fa5388254e796$export$afdb09d3afdde87c = new $1d1fa5388254e796$export$ca8b6604d6ce14de('Va1idator1nfo111111111111111111111111111111');
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $1d1fa5388254e796$var$InfoString = (0, $kRZRk.type)({
    name: (0, $kRZRk.string)(),
    website: (0, $kRZRk.optional)((0, $kRZRk.string)()),
    details: (0, $kRZRk.optional)((0, $kRZRk.string)()),
    keybaseUsername: (0, $kRZRk.optional)((0, $kRZRk.string)())
});
/**
 * ValidatorInfo class
 */ class $1d1fa5388254e796$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $1d1fa5388254e796$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $1d1fa5388254e796$export$ca8b6604d6ce14de($1d1fa5388254e796$var$guardedSplice(byteArray, 0, $1d1fa5388254e796$export$84fc0a248cc54343));
            const isSigner = $1d1fa5388254e796$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($1d1fa5388254e796$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $1d1fa5388254e796$var$rustString().decode((0, $ihoyg.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $kRZRk.assert)(info, $1d1fa5388254e796$var$InfoString);
                return new $1d1fa5388254e796$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $1d1fa5388254e796$export$90bca02a3aea0768 = new $1d1fa5388254e796$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $1d1fa5388254e796$var$VoteAccountLayout = $3wEH9.struct([
    $1d1fa5388254e796$var$publicKey('nodePubkey'),
    $1d1fa5388254e796$var$publicKey('authorizedWithdrawer'),
    $3wEH9.u8('commission'),
    $3wEH9.nu64(),
    // votes.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('slot'),
        $3wEH9.u32('confirmationCount')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'votes'),
    $3wEH9.u8('rootSlotValid'),
    $3wEH9.nu64('rootSlot'),
    $3wEH9.nu64(),
    // authorizedVoters.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('epoch'),
        $1d1fa5388254e796$var$publicKey('authorizedVoter')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'authorizedVoters'),
    $3wEH9.struct([
        $3wEH9.seq($3wEH9.struct([
            $1d1fa5388254e796$var$publicKey('authorizedPubkey'),
            $3wEH9.nu64('epochOfLastAuthorizedSwitch'),
            $3wEH9.nu64('targetEpoch')
        ]), 32, 'buf'),
        $3wEH9.nu64('idx'),
        $3wEH9.u8('isEmpty')
    ], 'priorVoters'),
    $3wEH9.nu64(),
    // epochCredits.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('epoch'),
        $3wEH9.nu64('credits'),
        $3wEH9.nu64('prevCredits')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'epochCredits'),
    $3wEH9.struct([
        $3wEH9.nu64('slot'),
        $3wEH9.nu64('timestamp')
    ], 'lastTimestamp')
]);
/**
 * VoteAccount class
 */ class $1d1fa5388254e796$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $1d1fa5388254e796$var$VoteAccountLayout.decode($1d1fa5388254e796$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $1d1fa5388254e796$export$89ef186f708d638b({
            nodePubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $1d1fa5388254e796$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($1d1fa5388254e796$var$parseAuthorizedVoter),
            priorVoters: $1d1fa5388254e796$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $1d1fa5388254e796$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $1d1fa5388254e796$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $1d1fa5388254e796$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $1d1fa5388254e796$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($1d1fa5388254e796$var$parsePriorVoters),
        ...buf.slice(0, idx).map($1d1fa5388254e796$var$parsePriorVoters)
    ];
}
const $1d1fa5388254e796$var$endpoint = {
    http: {
        devnet: 'http://api.devnet.solana.com',
        testnet: 'http://api.testnet.solana.com',
        'mainnet-beta': 'http://api.mainnet-beta.solana.com/'
    },
    https: {
        devnet: 'https://api.devnet.solana.com',
        testnet: 'https://api.testnet.solana.com',
        'mainnet-beta': 'https://api.mainnet-beta.solana.com/'
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $1d1fa5388254e796$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? 'http' : 'https';
    if (!cluster) return $1d1fa5388254e796$var$endpoint[key]['devnet'];
    const url = $1d1fa5388254e796$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $1d1fa5388254e796$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'lastValidBlockHeight')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'nonceValue')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $1d1fa5388254e796$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("evN8c", function(module, exports) {

$parcel$export(module.exports, "ed25519", function () { return $a90a12660a450f2b$export$f63794f4a09a19c1; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $eZbSS = parcelRequire("eZbSS");

var $8FCYS = parcelRequire("8FCYS");

var $2xYGu = parcelRequire("2xYGu");

var $h7Kuu = parcelRequire("h7Kuu");

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");

var $43eum = parcelRequire("43eum");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $a90a12660a450f2b$var$ED25519_P = BigInt('57896044618658097711785492504343953926634992332820282019728792003956564819949');
// √(-1) aka √(a) aka 2^((p-1)/4)
const $a90a12660a450f2b$var$ED25519_SQRT_M1 = BigInt('19681161376707505956807079304988542015446066515923890162744021073123829784752');
// prettier-ignore
const $a90a12660a450f2b$var$_0n = BigInt(0), $a90a12660a450f2b$var$_1n = BigInt(1), $a90a12660a450f2b$var$_2n = BigInt(2), $a90a12660a450f2b$var$_5n = BigInt(5);
// prettier-ignore
const $a90a12660a450f2b$var$_10n = BigInt(10), $a90a12660a450f2b$var$_20n = BigInt(20), $a90a12660a450f2b$var$_40n = BigInt(40), $a90a12660a450f2b$var$_80n = BigInt(80);
function $a90a12660a450f2b$var$ed25519_pow_2_252_3(x) {
    const P = $a90a12660a450f2b$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $bHBcf.pow2)(b2, $a90a12660a450f2b$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $bHBcf.pow2)(b4, $a90a12660a450f2b$var$_1n, P) * x % P; // x^31
    const b10 = (0, $bHBcf.pow2)(b5, $a90a12660a450f2b$var$_5n, P) * b5 % P;
    const b20 = (0, $bHBcf.pow2)(b10, $a90a12660a450f2b$var$_10n, P) * b10 % P;
    const b40 = (0, $bHBcf.pow2)(b20, $a90a12660a450f2b$var$_20n, P) * b20 % P;
    const b80 = (0, $bHBcf.pow2)(b40, $a90a12660a450f2b$var$_40n, P) * b40 % P;
    const b160 = (0, $bHBcf.pow2)(b80, $a90a12660a450f2b$var$_80n, P) * b80 % P;
    const b240 = (0, $bHBcf.pow2)(b160, $a90a12660a450f2b$var$_80n, P) * b80 % P;
    const b250 = (0, $bHBcf.pow2)(b240, $a90a12660a450f2b$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $bHBcf.pow2)(b250, $a90a12660a450f2b$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $a90a12660a450f2b$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $a90a12660a450f2b$var$uvRatio(u, v) {
    const P = $a90a12660a450f2b$var$ED25519_P;
    const v3 = (0, $bHBcf.mod)(v * v * v, P); // v³
    const v7 = (0, $bHBcf.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $a90a12660a450f2b$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $bHBcf.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $bHBcf.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $bHBcf.mod)(x * $a90a12660a450f2b$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $bHBcf.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $bHBcf.mod)(-u * $a90a12660a450f2b$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $bHBcf.isNegativeLE)(x, P)) x = (0, $bHBcf.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $a90a12660a450f2b$export$5ce3305f0d0b8e6f = [
    '0100000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a',
    '0000000000000000000000000000000000000000000000000000000000000080',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05',
    'ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85',
    '0000000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa'
];
const $a90a12660a450f2b$var$Fp = (0, $bHBcf.Field)($a90a12660a450f2b$var$ED25519_P, undefined, true);
const $a90a12660a450f2b$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt('37095705934669439343138083508754565189542113879843219016388785533085940283555'),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $a90a12660a450f2b$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt('7237005577332262213973186563042994240857116359379907606001950938285454250989'),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt('15112221349535400772501151409588531511454012693041857206046113283949847762202'),
    Gy: BigInt('46316835694926478169428394003475163141307993866256225615783033603165251855960'),
    hash: (0, $eZbSS.sha512),
    randomBytes: $8FCYS.randomBytes,
    adjustScalarBytes: $a90a12660a450f2b$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $a90a12660a450f2b$var$uvRatio
};
const $a90a12660a450f2b$export$f63794f4a09a19c1 = /* @__PURE__ */ (0, $2xYGu.twistedEdwards)($a90a12660a450f2b$var$ed25519Defaults);
function $a90a12660a450f2b$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error('Context is too big');
    return (0, $8FCYS.concatBytes)((0, $8FCYS.utf8ToBytes)('SigEd25519 no Ed25519 collisions'), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $a90a12660a450f2b$export$1bc11da7986b0196 = /* @__PURE__ */ (0, $2xYGu.twistedEdwards)({
    ...$a90a12660a450f2b$var$ed25519Defaults,
    domain: $a90a12660a450f2b$var$ed25519_domain
});
const $a90a12660a450f2b$export$473acbb6f701cbb6 = /* @__PURE__ */ (0, $2xYGu.twistedEdwards)({
    ...$a90a12660a450f2b$var$ed25519Defaults,
    domain: $a90a12660a450f2b$var$ed25519_domain,
    prehash: (0, $eZbSS.sha512)
});
const $a90a12660a450f2b$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $h7Kuu.montgomery)({
        P: $a90a12660a450f2b$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $a90a12660a450f2b$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $a90a12660a450f2b$var$ed25519_pow_2_252_3(x);
            return (0, $bHBcf.mod)((0, $bHBcf.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $a90a12660a450f2b$var$adjustScalarBytes,
        randomBytes: $8FCYS.randomBytes
    }))();
function $a90a12660a450f2b$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $a90a12660a450f2b$var$Fp.toBytes($a90a12660a450f2b$var$Fp.create((_1n + y) * $a90a12660a450f2b$var$Fp.inv(_1n - y)));
}
const $a90a12660a450f2b$export$84bc39a6e4664b07 = $a90a12660a450f2b$export$78609ae56f1edf04; // deprecated
function $a90a12660a450f2b$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $a90a12660a450f2b$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $a90a12660a450f2b$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $a90a12660a450f2b$var$ELL2_C1 = ($a90a12660a450f2b$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $a90a12660a450f2b$var$ELL2_C2 = $a90a12660a450f2b$var$Fp.pow($a90a12660a450f2b$var$_2n, $a90a12660a450f2b$var$ELL2_C1); // 2. c2 = 2^c1
const $a90a12660a450f2b$var$ELL2_C3 = $a90a12660a450f2b$var$Fp.sqrt($a90a12660a450f2b$var$Fp.neg($a90a12660a450f2b$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $a90a12660a450f2b$var$ELL2_C4 = ($a90a12660a450f2b$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $a90a12660a450f2b$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $a90a12660a450f2b$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $a90a12660a450f2b$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $a90a12660a450f2b$var$Fp.mul(tv1, $a90a12660a450f2b$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $a90a12660a450f2b$var$Fp.add(tv1, $a90a12660a450f2b$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $a90a12660a450f2b$var$Fp.neg($a90a12660a450f2b$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $a90a12660a450f2b$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $a90a12660a450f2b$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $a90a12660a450f2b$var$Fp.mul(tv1, $a90a12660a450f2b$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $a90a12660a450f2b$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $a90a12660a450f2b$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $a90a12660a450f2b$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $a90a12660a450f2b$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $a90a12660a450f2b$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $a90a12660a450f2b$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $a90a12660a450f2b$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $a90a12660a450f2b$var$Fp.pow(tv2, $a90a12660a450f2b$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $a90a12660a450f2b$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $a90a12660a450f2b$var$Fp.mul(y11, $a90a12660a450f2b$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $a90a12660a450f2b$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $a90a12660a450f2b$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $a90a12660a450f2b$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $a90a12660a450f2b$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $a90a12660a450f2b$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $a90a12660a450f2b$var$Fp.mul(y21, $a90a12660a450f2b$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $a90a12660a450f2b$var$Fp.mul(y21, $a90a12660a450f2b$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $a90a12660a450f2b$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $a90a12660a450f2b$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $a90a12660a450f2b$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $a90a12660a450f2b$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $a90a12660a450f2b$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $a90a12660a450f2b$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $a90a12660a450f2b$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $a90a12660a450f2b$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $a90a12660a450f2b$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $a90a12660a450f2b$var$Fp.cmov(y, $a90a12660a450f2b$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $a90a12660a450f2b$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $a90a12660a450f2b$var$ELL2_C1_EDWARDS = (0, $bHBcf.FpSqrtEven)($a90a12660a450f2b$var$Fp, $a90a12660a450f2b$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $a90a12660a450f2b$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $a90a12660a450f2b$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $a90a12660a450f2b$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $a90a12660a450f2b$var$Fp.mul(xn, $a90a12660a450f2b$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $a90a12660a450f2b$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $a90a12660a450f2b$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $a90a12660a450f2b$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $a90a12660a450f2b$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $a90a12660a450f2b$var$Fp.eql(tv1, $a90a12660a450f2b$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $a90a12660a450f2b$var$Fp.cmov(xn, $a90a12660a450f2b$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $a90a12660a450f2b$var$Fp.cmov(xd, $a90a12660a450f2b$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $a90a12660a450f2b$var$Fp.cmov(yn, $a90a12660a450f2b$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $a90a12660a450f2b$var$Fp.cmov(yd, $a90a12660a450f2b$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $a90a12660a450f2b$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $a90a12660a450f2b$var$Fp.mul(xn, inv[0]),
        y: $a90a12660a450f2b$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $a90a12660a450f2b$var$htf = /* @__PURE__ */ (()=>(0, $43eum.createHasher)($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$a90a12660a450f2b$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: 'edwards25519_XMD:SHA-512_ELL2_RO_',
        encodeDST: 'edwards25519_XMD:SHA-512_ELL2_NU_',
        p: $a90a12660a450f2b$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $eZbSS.sha512)
    }))();
const $a90a12660a450f2b$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$a90a12660a450f2b$var$htf.hashToCurve)();
const $a90a12660a450f2b$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$a90a12660a450f2b$var$htf.encodeToCurve)();
function $a90a12660a450f2b$var$assertRstPoint(other) {
    if (!(other instanceof $a90a12660a450f2b$var$RistPoint)) throw new Error('RistrettoPoint expected');
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $a90a12660a450f2b$var$SQRT_M1 = $a90a12660a450f2b$var$ED25519_SQRT_M1;
// √(ad - 1)
const $a90a12660a450f2b$var$SQRT_AD_MINUS_ONE = BigInt('25063068953384623474111414158702152701244531502492656460079210482610430750235');
// 1 / √(a-d)
const $a90a12660a450f2b$var$INVSQRT_A_MINUS_D = BigInt('54469307008909316920995813868745141605393597292927456921205312896311721017578');
// 1-d²
const $a90a12660a450f2b$var$ONE_MINUS_D_SQ = BigInt('1159843021668779879193775521855586647937357759715417654439879720876111806838');
// (d-1)²
const $a90a12660a450f2b$var$D_MINUS_ONE_SQ = BigInt('40440834346308536858101042469323190826248399146238708352240133220865137265952');
// Calculates 1/√(number)
const $a90a12660a450f2b$var$invertSqrt = (number)=>$a90a12660a450f2b$var$uvRatio($a90a12660a450f2b$var$_1n, number);
const $a90a12660a450f2b$var$MAX_255B = BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
const $a90a12660a450f2b$var$bytes255ToNumberLE = (bytes)=>$a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create((0, $1jejV.bytesToNumberLE)(bytes) & $a90a12660a450f2b$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $a90a12660a450f2b$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE;
    const P = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($a90a12660a450f2b$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $a90a12660a450f2b$var$_1n) * $a90a12660a450f2b$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $a90a12660a450f2b$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $bHBcf.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $a90a12660a450f2b$var$_1n) * $a90a12660a450f2b$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $a90a12660a450f2b$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($a90a12660a450f2b$var$_1n - s2); // 12
    const W3 = mod($a90a12660a450f2b$var$_1n + s2); // 13
    return new $a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $a90a12660a450f2b$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $a90a12660a450f2b$var$RistPoint($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $1jejV.ensureBytes)('ristrettoHash', hex, 64);
        const r1 = $a90a12660a450f2b$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $a90a12660a450f2b$var$calcElligatorRistrettoMap(r1);
        const r2 = $a90a12660a450f2b$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $a90a12660a450f2b$var$calcElligatorRistrettoMap(r2);
        return new $a90a12660a450f2b$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $1jejV.ensureBytes)('ristrettoHex', hex, 32);
        const { a: a, d: d } = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE;
        const P = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = 'RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint';
        const s = $a90a12660a450f2b$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $1jejV.equalBytes)((0, $1jejV.numberToBytesLE)(s, 32), hex) || (0, $bHBcf.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($a90a12660a450f2b$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($a90a12660a450f2b$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $a90a12660a450f2b$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $bHBcf.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $bHBcf.isNegativeLE)(t, P) || y === $a90a12660a450f2b$var$_0n) throw new Error(emsg);
        return new $a90a12660a450f2b$var$RistPoint(new $a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint(x, y, $a90a12660a450f2b$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $a90a12660a450f2b$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $bHBcf.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $a90a12660a450f2b$var$SQRT_M1);
            let _y = mod(x * $a90a12660a450f2b$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $a90a12660a450f2b$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $bHBcf.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $bHBcf.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $1jejV.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $1jejV.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $a90a12660a450f2b$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $a90a12660a450f2b$var$assertRstPoint(other);
        return new $a90a12660a450f2b$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $a90a12660a450f2b$var$assertRstPoint(other);
        return new $a90a12660a450f2b$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $a90a12660a450f2b$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $a90a12660a450f2b$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
}
const $a90a12660a450f2b$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$a90a12660a450f2b$var$RistPoint.BASE) $a90a12660a450f2b$var$RistPoint.BASE = new $a90a12660a450f2b$var$RistPoint($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$a90a12660a450f2b$var$RistPoint.ZERO) $a90a12660a450f2b$var$RistPoint.ZERO = new $a90a12660a450f2b$var$RistPoint($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $a90a12660a450f2b$var$RistPoint;
})();
const $a90a12660a450f2b$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === 'string' ? (0, $8FCYS.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $43eum.expand_message_xmd)(msg, DST, 64, (0, $eZbSS.sha512));
    const P = $a90a12660a450f2b$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $a90a12660a450f2b$export$667ef88de7a83a7f = $a90a12660a450f2b$export$c9ad4c0d917ad3; // legacy

});
parcelRegister("2xYGu", function(module, exports) {

$parcel$export(module.exports, "twistedEdwards", function () { return $1dadbc7d3718cfa4$export$f0c1eee63ea541eb; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");

var $9DLjl = parcelRequire("9DLjl");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $1dadbc7d3718cfa4$var$_0n = BigInt(0), $1dadbc7d3718cfa4$var$_1n = BigInt(1), $1dadbc7d3718cfa4$var$_2n = BigInt(2), $1dadbc7d3718cfa4$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $1dadbc7d3718cfa4$var$VERIFY_DEFAULT = {
    zip215: true
};
function $1dadbc7d3718cfa4$var$validateOpts(curve) {
    const opts = (0, $9DLjl.validateBasic)(curve);
    $1jejV.validateObject(curve, {
        hash: 'function',
        a: 'bigint',
        d: 'bigint',
        randomBytes: 'function'
    }, {
        adjustScalarBytes: 'function',
        domain: 'function',
        uvRatio: 'function',
        mapToCurve: 'function'
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $1dadbc7d3718cfa4$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $1dadbc7d3718cfa4$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $1dadbc7d3718cfa4$var$_2n << BigInt(nByteLength * 8) - $1dadbc7d3718cfa4$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $1dadbc7d3718cfa4$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error('Contexts/pre-hash are not supported');
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === 'bigint' && $1dadbc7d3718cfa4$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $1dadbc7d3718cfa4$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $1dadbc7d3718cfa4$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error('ExtendedPoint expected');
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error('x required');
            if (!in0MaskRange(ey)) throw new Error('y required');
            if (!in0MaskRange(ez)) throw new Error('z required');
            if (!in0MaskRange(et)) throw new Error('t required');
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error('extended point not allowed');
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error('invalid affine point');
            return new Point(x, y, $1dadbc7d3718cfa4$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error('bad point: ZERO'); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error('bad point: equation left != right (1)');
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error('bad point: equation left != right (2)');
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($1dadbc7d3718cfa4$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $1dadbc7d3718cfa4$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $1dadbc7d3718cfa4$var$_2n * T2);
                const D = modP(T1 * $1dadbc7d3718cfa4$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $1dadbc7d3718cfa4$var$_0n) return I;
            if (this.equals(I) || n === $1dadbc7d3718cfa4$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $1dadbc7d3718cfa4$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $1dadbc7d3718cfa4$var$_0n,
                y: $1dadbc7d3718cfa4$var$_1n
            };
            if (zz !== $1dadbc7d3718cfa4$var$_1n) throw new Error('invZ was invalid');
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $1dadbc7d3718cfa4$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $1jejV.ensureBytes)('pointHex', hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $1jejV.bytesToNumberLE(normed);
            if (y === $1dadbc7d3718cfa4$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $1dadbc7d3718cfa4$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error('Point.fromHex: invalid y coordinate');
            const isXOdd = (x & $1dadbc7d3718cfa4$var$_1n) === $1dadbc7d3718cfa4$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $1dadbc7d3718cfa4$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error('Point.fromHex: x=0 and x_0=1');
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $1jejV.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $1dadbc7d3718cfa4$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $1jejV.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $1dadbc7d3718cfa4$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($1dadbc7d3718cfa4$var$_0n, $1dadbc7d3718cfa4$var$_1n, $1dadbc7d3718cfa4$var$_1n, $1dadbc7d3718cfa4$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $9DLjl.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $bHBcf.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($1jejV.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $1jejV.ensureBytes)('private key', key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $1jejV.ensureBytes)('hashed private key', cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $1jejV.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $1jejV.ensureBytes)('context', context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $1jejV.ensureBytes)('message', msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $1jejV.concatBytes(R, $1jejV.numberToBytesLE(s, Fp.BYTES));
        return (0, $1jejV.ensureBytes)('result', res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $1dadbc7d3718cfa4$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $1jejV.ensureBytes)('signature', sig, 2 * len); // An extended group equation is checked.
        msg = (0, $1jejV.ensureBytes)('message', msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $1jejV.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}

});

parcelRegister("h7Kuu", function(module, exports) {

$parcel$export(module.exports, "montgomery", function () { return $c7772731a8887cd6$export$bdbee0d01bf914a7; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");
const $c7772731a8887cd6$var$_0n = BigInt(0);
const $c7772731a8887cd6$var$_1n = BigInt(1);
function $c7772731a8887cd6$var$validateOpts(curve) {
    (0, $1jejV.validateObject)(curve, {
        a: 'bigint'
    }, {
        montgomeryBits: 'isSafeInteger',
        nByteLength: 'isSafeInteger',
        adjustScalarBytes: 'function',
        domain: 'function',
        powPminus2: 'function',
        Gu: 'bigint'
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $c7772731a8887cd6$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $c7772731a8887cd6$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $bHBcf.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $bHBcf.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === 'bigint' && $c7772731a8887cd6$var$_0n <= n && n < P) return n;
        throw new Error('Expected valid scalar 0 < scalar < CURVE.P');
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $c7772731a8887cd6$var$_1n;
        let z_2 = $c7772731a8887cd6$var$_0n;
        let x_3 = u;
        let z_3 = $c7772731a8887cd6$var$_1n;
        let swap = $c7772731a8887cd6$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $c7772731a8887cd6$var$_0n; t--){
            const k_t = k >> t & $c7772731a8887cd6$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $1jejV.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        // This is very ugly way, but it works because fieldLen-1 is outside of bounds for X448, so this becomes NOOP
        // fieldLen - scalaryBytes = 1 for X448 and = 0 for X25519
        const u = (0, $1jejV.ensureBytes)('u coordinate', uEnc, montgomeryBytes);
        // u[fieldLen-1] crashes QuickJS (TypeError: out-of-bound numeric index)
        if (fieldLen === montgomeryBytes) u[fieldLen - 1] &= 127; // 0b0111_1111
        return (0, $1jejV.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $1jejV.ensureBytes)('scalar', n);
        if (bytes.length !== montgomeryBytes && bytes.length !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${bytes.length}`);
        return (0, $1jejV.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $c7772731a8887cd6$var$_0n) throw new Error('Invalid private or public key received');
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}

});


parcelRegister("7vYz3", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});


parcelRegister("7fZv8", function(module, exports) {

var $kG2My = parcelRequire("kG2My");
var $5489a3fbc4b040fc$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $kG2My($5489a3fbc4b040fc$var$ALPHABET);

});
parcelRegister("kG2My", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $f0d9e357f46e8580$require$_Buffer = $6U9mG.Buffer;
function $f0d9e357f46e8580$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $f0d9e357f46e8580$require$_Buffer.from(source);
        if (!$f0d9e357f46e8580$require$_Buffer.isBuffer(source)) throw new TypeError('Expected Buffer');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return $f0d9e357f46e8580$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $f0d9e357f46e8580$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $f0d9e357f46e8580$var$base;

});
parcelRegister("6U9mG", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $506f3cb9e9ae23e7$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $506f3cb9e9ae23e7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($506f3cb9e9ae23e7$var$Buffer.from && $506f3cb9e9ae23e7$var$Buffer.alloc && $506f3cb9e9ae23e7$var$Buffer.allocUnsafe && $506f3cb9e9ae23e7$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $506f3cb9e9ae23e7$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $506f3cb9e9ae23e7$var$SafeBuffer;
}
function $506f3cb9e9ae23e7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
}
$506f3cb9e9ae23e7$var$SafeBuffer.prototype = Object.create($506f3cb9e9ae23e7$var$Buffer.prototype);
// Copy static methods from Buffer
$506f3cb9e9ae23e7$var$copyProps($506f3cb9e9ae23e7$var$Buffer, $506f3cb9e9ae23e7$var$SafeBuffer);
$506f3cb9e9ae23e7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
};
$506f3cb9e9ae23e7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $506f3cb9e9ae23e7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $506f3cb9e9ae23e7$var$Buffer(size);
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ihoyg.SlowBuffer(size);
};

});



parcelRegister("5apAE", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $3c31bc916cd146c2$export$bced8d2aada2d1c9; });

var $gHKg0 = parcelRequire("gHKg0");

var $3SZ63 = parcelRequire("3SZ63");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $3c31bc916cd146c2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $3c31bc916cd146c2$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $3c31bc916cd146c2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $3c31bc916cd146c2$var$SHA256 extends (0, $gHKg0.HashMD) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $3c31bc916cd146c2$var$SHA256_IV[0] | 0;
        this.B = $3c31bc916cd146c2$var$SHA256_IV[1] | 0;
        this.C = $3c31bc916cd146c2$var$SHA256_IV[2] | 0;
        this.D = $3c31bc916cd146c2$var$SHA256_IV[3] | 0;
        this.E = $3c31bc916cd146c2$var$SHA256_IV[4] | 0;
        this.F = $3c31bc916cd146c2$var$SHA256_IV[5] | 0;
        this.G = $3c31bc916cd146c2$var$SHA256_IV[6] | 0;
        this.H = $3c31bc916cd146c2$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$3c31bc916cd146c2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $3c31bc916cd146c2$var$SHA256_W[i - 15];
            const W2 = $3c31bc916cd146c2$var$SHA256_W[i - 2];
            const s0 = (0, $3SZ63.rotr)(W15, 7) ^ (0, $3SZ63.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3SZ63.rotr)(W2, 17) ^ (0, $3SZ63.rotr)(W2, 19) ^ W2 >>> 10;
            $3c31bc916cd146c2$var$SHA256_W[i] = s1 + $3c31bc916cd146c2$var$SHA256_W[i - 7] + s0 + $3c31bc916cd146c2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3SZ63.rotr)(E, 6) ^ (0, $3SZ63.rotr)(E, 11) ^ (0, $3SZ63.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $gHKg0.Chi)(E, F, G) + $3c31bc916cd146c2$var$SHA256_K[i] + $3c31bc916cd146c2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3SZ63.rotr)(A, 2) ^ (0, $3SZ63.rotr)(A, 13) ^ (0, $3SZ63.rotr)(A, 22);
            const T2 = sigma0 + (0, $gHKg0.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $3c31bc916cd146c2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $3c31bc916cd146c2$var$SHA224 extends $3c31bc916cd146c2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $3c31bc916cd146c2$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $3SZ63.wrapConstructor)(()=>new $3c31bc916cd146c2$var$SHA256());
const $3c31bc916cd146c2$export$97b70509d4e397ea = /* @__PURE__ */ (0, $3SZ63.wrapConstructor)(()=>new $3c31bc916cd146c2$var$SHA224());

});
parcelRegister("gHKg0", function(module, exports) {

$parcel$export(module.exports, "Chi", function () { return $c2948b3820e24178$export$d0d97f016526eaf0; });
$parcel$export(module.exports, "Maj", function () { return $c2948b3820e24178$export$8b1d810b1bd30adf; });
$parcel$export(module.exports, "HashMD", function () { return $c2948b3820e24178$export$f9f830659f932cb2; });

var $b3mfP = parcelRequire("b3mfP");

var $3SZ63 = parcelRequire("3SZ63");
// Polyfill for Safari 14
function $c2948b3820e24178$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $c2948b3820e24178$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $c2948b3820e24178$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $c2948b3820e24178$export$f9f830659f932cb2 extends (0, $3SZ63.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3SZ63.createView)(this.buffer);
    }
    update(data) {
        (0, $b3mfP.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3SZ63.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3SZ63.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $b3mfP.exists)(this);
        (0, $b3mfP.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $c2948b3820e24178$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3SZ63.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("b3mfP", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $80c13cc4cd0a2569$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $80c13cc4cd0a2569$export$b3317979f9250576; });
$parcel$export(module.exports, "exists", function () { return $80c13cc4cd0a2569$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $80c13cc4cd0a2569$export$c789db2c85949867; });
function $80c13cc4cd0a2569$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $80c13cc4cd0a2569$export$87b259aa03e3d267(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
function $80c13cc4cd0a2569$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
function $80c13cc4cd0a2569$export$b3317979f9250576(b, ...lengths) {
    if (!$80c13cc4cd0a2569$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $80c13cc4cd0a2569$export$d6af199866bfb566(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $80c13cc4cd0a2569$export$98e628dec113755e(h.outputLen);
    $80c13cc4cd0a2569$export$98e628dec113755e(h.blockLen);
}
function $80c13cc4cd0a2569$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $80c13cc4cd0a2569$export$c789db2c85949867(out, instance) {
    $80c13cc4cd0a2569$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $80c13cc4cd0a2569$var$assert = {
    number: $80c13cc4cd0a2569$export$98e628dec113755e,
    bool: $80c13cc4cd0a2569$export$87b259aa03e3d267,
    bytes: $80c13cc4cd0a2569$export$b3317979f9250576,
    hash: $80c13cc4cd0a2569$export$d6af199866bfb566,
    exists: $80c13cc4cd0a2569$export$f7e9f41ea797a17,
    output: $80c13cc4cd0a2569$export$c789db2c85949867
};
var $80c13cc4cd0a2569$export$2e2bcd8739ae039 = $80c13cc4cd0a2569$var$assert;

});

parcelRegister("3SZ63", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $2d45cec2b16f8b9f$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $2d45cec2b16f8b9f$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $2d45cec2b16f8b9f$export$466993d7d0d272aa; });
$parcel$export(module.exports, "isLE", function () { return $2d45cec2b16f8b9f$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $2d45cec2b16f8b9f$export$97b40fc37f25d711; });
$parcel$export(module.exports, "toBytes", function () { return $2d45cec2b16f8b9f$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "Hash", function () { return $2d45cec2b16f8b9f$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $2d45cec2b16f8b9f$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $2d45cec2b16f8b9f$export$e18964dbd6e083c1; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $4Oiq0 = parcelRequire("4Oiq0");

var $b3mfP = parcelRequire("b3mfP");
function $2d45cec2b16f8b9f$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
const $2d45cec2b16f8b9f$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $2d45cec2b16f8b9f$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $2d45cec2b16f8b9f$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $2d45cec2b16f8b9f$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $2d45cec2b16f8b9f$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $2d45cec2b16f8b9f$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $2d45cec2b16f8b9f$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $2d45cec2b16f8b9f$export$4a0a88cc2d284e7f = $2d45cec2b16f8b9f$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$2d45cec2b16f8b9f$export$a4170f7f8be47425(n);
function $2d45cec2b16f8b9f$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $2d45cec2b16f8b9f$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $2d45cec2b16f8b9f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $2d45cec2b16f8b9f$export$58b867e287a802c8(bytes) {
    (0, $b3mfP.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $2d45cec2b16f8b9f$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $2d45cec2b16f8b9f$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $2d45cec2b16f8b9f$var$asciiToBase16(char) {
    if (char >= $2d45cec2b16f8b9f$var$asciis._0 && char <= $2d45cec2b16f8b9f$var$asciis._9) return char - $2d45cec2b16f8b9f$var$asciis._0;
    if (char >= $2d45cec2b16f8b9f$var$asciis._A && char <= $2d45cec2b16f8b9f$var$asciis._F) return char - ($2d45cec2b16f8b9f$var$asciis._A - 10);
    if (char >= $2d45cec2b16f8b9f$var$asciis._a && char <= $2d45cec2b16f8b9f$var$asciis._f) return char - ($2d45cec2b16f8b9f$var$asciis._a - 10);
    return;
}
function $2d45cec2b16f8b9f$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $2d45cec2b16f8b9f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $2d45cec2b16f8b9f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $2d45cec2b16f8b9f$export$bdd553fddd433dcb = async ()=>{};
async function $2d45cec2b16f8b9f$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $2d45cec2b16f8b9f$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $2d45cec2b16f8b9f$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $2d45cec2b16f8b9f$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $2d45cec2b16f8b9f$export$3df70a15530b5e81(data);
    (0, $b3mfP.bytes)(data);
    return data;
}
function $2d45cec2b16f8b9f$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $b3mfP.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $2d45cec2b16f8b9f$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $2d45cec2b16f8b9f$var$toStr = {}.toString;
function $2d45cec2b16f8b9f$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $2d45cec2b16f8b9f$var$toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $2d45cec2b16f8b9f$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($2d45cec2b16f8b9f$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $2d45cec2b16f8b9f$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($2d45cec2b16f8b9f$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $2d45cec2b16f8b9f$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($2d45cec2b16f8b9f$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $2d45cec2b16f8b9f$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $4Oiq0.crypto) && typeof (0, $4Oiq0.crypto).getRandomValues === 'function') return (0, $4Oiq0.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("4Oiq0", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $380a1e760c951f52$export$7effb53edfc7fa2d; });
const $380a1e760c951f52$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("4xx4u", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $34e3e5c42c9dc29c$require$Buffer = $ihoyg.Buffer;
"use strict";
var $34e3e5c42c9dc29c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34e3e5c42c9dc29c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $34e3e5c42c9dc29c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $34e3e5c42c9dc29c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $34e3e5c42c9dc29c$var$__createBinding(result, mod, k);
    }
    $34e3e5c42c9dc29c$var$__setModuleDefault(result, mod);
    return result;
};
var $34e3e5c42c9dc29c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $34e3e5c42c9dc29c$var$bn_js_1 = $34e3e5c42c9dc29c$var$__importDefault((parcelRequire("7vYz3")));

const $34e3e5c42c9dc29c$var$bs58_1 = $34e3e5c42c9dc29c$var$__importDefault((parcelRequire("5Ajb1")));

// TODO: Make sure this polyfill not included when not required
const $34e3e5c42c9dc29c$var$encoding = $34e3e5c42c9dc29c$var$__importStar((parcelRequire("9vosj")));
const $34e3e5c42c9dc29c$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $34e3e5c42c9dc29c$var$encoding.TextDecoder : TextDecoder;
const $34e3e5c42c9dc29c$var$textDecoder = new $34e3e5c42c9dc29c$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $34e3e5c42c9dc29c$var$baseEncode(value) {
    if (typeof value === "string") value = $34e3e5c42c9dc29c$require$Buffer.from(value, "utf8");
    return $34e3e5c42c9dc29c$var$bs58_1.default.encode($34e3e5c42c9dc29c$require$Buffer.from(value));
}
module.exports.baseEncode = $34e3e5c42c9dc29c$var$baseEncode;
function $34e3e5c42c9dc29c$var$baseDecode(value) {
    return $34e3e5c42c9dc29c$require$Buffer.from($34e3e5c42c9dc29c$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $34e3e5c42c9dc29c$var$baseDecode;
const $34e3e5c42c9dc29c$var$INITIAL_LENGTH = 1024;
class $34e3e5c42c9dc29c$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $34e3e5c42c9dc29c$var$BorshError;
/// Binary encoder.
class $34e3e5c42c9dc29c$var$BinaryWriter {
    constructor(){
        this.buf = $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $34e3e5c42c9dc29c$require$Buffer.concat([
            this.buf,
            $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $34e3e5c42c9dc29c$require$Buffer.concat([
            $34e3e5c42c9dc29c$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $34e3e5c42c9dc29c$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $34e3e5c42c9dc29c$var$BinaryWriter;
function $34e3e5c42c9dc29c$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $34e3e5c42c9dc29c$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $34e3e5c42c9dc29c$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $34e3e5c42c9dc29c$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $34e3e5c42c9dc29c$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU8", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU16", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU32", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU64", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU128", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU256", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU512", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readString", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readFixedArray", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $34e3e5c42c9dc29c$var$BinaryReader;
function $34e3e5c42c9dc29c$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$34e3e5c42c9dc29c$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $34e3e5c42c9dc29c$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $34e3e5c42c9dc29c$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$34e3e5c42c9dc29c$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $34e3e5c42c9dc29c$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $34e3e5c42c9dc29c$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $34e3e5c42c9dc29c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $34e3e5c42c9dc29c$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $34e3e5c42c9dc29c$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $34e3e5c42c9dc29c$var$serialize(schema, obj, Writer = $34e3e5c42c9dc29c$var$BinaryWriter) {
    const writer = new Writer();
    $34e3e5c42c9dc29c$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $34e3e5c42c9dc29c$var$serialize;
function $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$34e3e5c42c9dc29c$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($34e3e5c42c9dc29c$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $34e3e5c42c9dc29c$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $34e3e5c42c9dc29c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $34e3e5c42c9dc29c$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $34e3e5c42c9dc29c$var$deserialize(schema, classType, buffer, Reader = $34e3e5c42c9dc29c$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $34e3e5c42c9dc29c$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $34e3e5c42c9dc29c$var$deserializeUnchecked(schema, classType, buffer, Reader = $34e3e5c42c9dc29c$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $34e3e5c42c9dc29c$var$deserializeUnchecked;

});
parcelRegister("5Ajb1", function(module, exports) {

var $kG2My = parcelRequire("kG2My");
var $410f30a5a58a7bee$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $kG2My($410f30a5a58a7bee$var$ALPHABET);

});

parcelRegister("9vosj", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $6eb9fab1eab3180d$export$88fb0cfd153261a7; }, function (v) { return $6eb9fab1eab3180d$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $6eb9fab1eab3180d$export$9c6b53e35bc51b5c; }, function (v) { return $6eb9fab1eab3180d$export$9c6b53e35bc51b5c = v; });
var $6eb9fab1eab3180d$export$88fb0cfd153261a7;
var $6eb9fab1eab3180d$export$9c6b53e35bc51b5c;
'use strict';
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $6eb9fab1eab3180d$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $6eb9fab1eab3180d$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError('Could not convert argument to dictionary');
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $6eb9fab1eab3180d$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $6eb9fab1eab3180d$var$codePointsToString(code_points) {
    var s = '';
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $6eb9fab1eab3180d$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $6eb9fab1eab3180d$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$6eb9fab1eab3180d$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $6eb9fab1eab3180d$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $6eb9fab1eab3180d$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $6eb9fab1eab3180d$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError('Decoder error');
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $6eb9fab1eab3180d$var$DEFAULT_ENCODING = 'utf-8';
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $6eb9fab1eab3180d$var$TextDecoder(encoding, options) {
    if (!(this instanceof $6eb9fab1eab3180d$var$TextDecoder)) return new $6eb9fab1eab3180d$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $6eb9fab1eab3180d$var$DEFAULT_ENCODING;
    if (encoding !== $6eb9fab1eab3180d$var$DEFAULT_ENCODING) throw new Error('Encoding not supported. Only utf-8 is supported');
    options = $6eb9fab1eab3180d$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options['fatal']);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options['ignoreBOM']);
    Object.defineProperty(this, 'encoding', {
        value: 'utf-8'
    });
    Object.defineProperty(this, 'fatal', {
        value: this._fatal
    });
    Object.defineProperty(this, 'ignoreBOM', {
        value: this._ignoreBOM
    });
}
$6eb9fab1eab3180d$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === 'object' && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === 'object' && 'buffer' in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $6eb9fab1eab3180d$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $6eb9fab1eab3180d$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options['stream']);
        var input_stream = new $6eb9fab1eab3180d$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $6eb9fab1eab3180d$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $6eb9fab1eab3180d$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                'utf-8'
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $6eb9fab1eab3180d$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $6eb9fab1eab3180d$var$TextEncoder(encoding, options) {
    if (!(this instanceof $6eb9fab1eab3180d$var$TextEncoder)) return new $6eb9fab1eab3180d$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $6eb9fab1eab3180d$var$DEFAULT_ENCODING;
    if (encoding !== $6eb9fab1eab3180d$var$DEFAULT_ENCODING) throw new Error('Encoding not supported. Only utf-8 is supported');
    options = $6eb9fab1eab3180d$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options['fatal'])
    };
    Object.defineProperty(this, 'encoding', {
        value: 'utf-8'
    });
}
$6eb9fab1eab3180d$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : '';
        options = $6eb9fab1eab3180d$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $6eb9fab1eab3180d$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options['stream']);
        var bytes = [];
        var input_stream = new $6eb9fab1eab3180d$var$Stream($6eb9fab1eab3180d$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $6eb9fab1eab3180d$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $6eb9fab1eab3180d$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $6eb9fab1eab3180d$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $6eb9fab1eab3180d$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $6eb9fab1eab3180d$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $6eb9fab1eab3180d$var$end_of_stream) return $6eb9fab1eab3180d$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($6eb9fab1eab3180d$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($6eb9fab1eab3180d$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($6eb9fab1eab3180d$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($6eb9fab1eab3180d$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $6eb9fab1eab3180d$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$6eb9fab1eab3180d$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $6eb9fab1eab3180d$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $6eb9fab1eab3180d$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $6eb9fab1eab3180d$var$end_of_stream) return $6eb9fab1eab3180d$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($6eb9fab1eab3180d$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$6eb9fab1eab3180d$export$88fb0cfd153261a7 = $6eb9fab1eab3180d$var$TextEncoder;
$6eb9fab1eab3180d$export$9c6b53e35bc51b5c = $6eb9fab1eab3180d$var$TextDecoder;

});


parcelRegister("3wEH9", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ 'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.s16 = module.exports.s8 = module.exports.nu64be = module.exports.u48be = module.exports.u40be = module.exports.u32be = module.exports.u24be = module.exports.u16be = module.exports.nu64 = module.exports.u48 = module.exports.u40 = module.exports.u32 = module.exports.u24 = module.exports.u16 = module.exports.u8 = module.exports.offset = module.exports.greedy = module.exports.Constant = module.exports.UTF8 = module.exports.CString = module.exports.Blob = module.exports.Boolean = module.exports.BitField = module.exports.BitStructure = module.exports.VariantLayout = module.exports.Union = module.exports.UnionLayoutDiscriminator = module.exports.UnionDiscriminator = module.exports.Structure = module.exports.Sequence = module.exports.DoubleBE = module.exports.Double = module.exports.FloatBE = module.exports.Float = module.exports.NearInt64BE = module.exports.NearInt64 = module.exports.NearUInt64BE = module.exports.NearUInt64 = module.exports.IntBE = module.exports.Int = module.exports.UIntBE = module.exports.UInt = module.exports.OffsetLayout = module.exports.GreedyCount = module.exports.ExternalLayout = module.exports.bindConstructorLayout = module.exports.nameWithProperty = module.exports.Layout = module.exports.uint8ArrayToBuffer = module.exports.checkUint8Array = void 0;
module.exports.constant = module.exports.utf8 = module.exports.cstr = module.exports.blob = module.exports.unionLayoutDiscriminator = module.exports.union = module.exports.seq = module.exports.bits = module.exports.struct = module.exports.f64be = module.exports.f64 = module.exports.f32be = module.exports.f32 = module.exports.ns64be = module.exports.s48be = module.exports.s40be = module.exports.s32be = module.exports.s24be = module.exports.s16be = module.exports.ns64 = module.exports.s48 = module.exports.s40 = module.exports.s32 = module.exports.s24 = void 0;

var $ihoyg = parcelRequire("ihoyg");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $2913ed74210dce84$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError('b must be a Uint8Array');
}
module.exports.checkUint8Array = $2913ed74210dce84$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $2913ed74210dce84$var$uint8ArrayToBuffer(b) {
    $2913ed74210dce84$var$checkUint8Array(b);
    return $ihoyg.Buffer.from(b.buffer, b.byteOffset, b.length);
}
module.exports.uint8ArrayToBuffer = $2913ed74210dce84$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $2913ed74210dce84$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError('span must be an integer');
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError('indeterminate span');
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
module.exports.Layout = $2913ed74210dce84$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $2913ed74210dce84$var$nameWithProperty(name, lo) {
    if (lo.property) return name + '[' + lo.property + ']';
    return name;
}
module.exports.nameWithProperty = $2913ed74210dce84$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $2913ed74210dce84$var$bindConstructorLayout(Class, layout) {
    if ('function' !== typeof Class) throw new TypeError('Class must be constructor');
    if (Object.prototype.hasOwnProperty.call(Class, 'layout_')) throw new Error('Class is already bound to a layout');
    if (!(layout && layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError('layout must be a Layout');
    if (Object.prototype.hasOwnProperty.call(layout, 'boundConstructor_')) throw new Error('layout is already bound to a constructor');
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, 'encode', {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, 'decode', {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
module.exports.bindConstructorLayout = $2913ed74210dce84$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $2913ed74210dce84$var$ExternalLayout extends $2913ed74210dce84$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error('ExternalLayout is abstract');
    }
}
module.exports.ExternalLayout = $2913ed74210dce84$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $2913ed74210dce84$var$GreedyCount extends $2913ed74210dce84$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError('elementSpan must be a (positive) integer');
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
module.exports.GreedyCount = $2913ed74210dce84$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$OffsetLayout extends $2913ed74210dce84$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError('layout must be a Layout');
        if (!Number.isInteger(offset)) throw new TypeError('offset must be integer or undefined');
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $2913ed74210dce84$var$UInt || this.layout instanceof $2913ed74210dce84$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
module.exports.OffsetLayout = $2913ed74210dce84$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UInt extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UInt = $2913ed74210dce84$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UIntBE extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UIntBE = $2913ed74210dce84$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Int extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.Int = $2913ed74210dce84$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$IntBE extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.IntBE = $2913ed74210dce84$var$IntBE;
const $2913ed74210dce84$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $2913ed74210dce84$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $2913ed74210dce84$var$V2E32);
    const lo32 = src - hi32 * $2913ed74210dce84$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $2913ed74210dce84$var$roundedInt64(hi32, lo32) {
    return hi32 * $2913ed74210dce84$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearUInt64 extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64 = $2913ed74210dce84$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearUInt64BE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64BE = $2913ed74210dce84$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearInt64 extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64 = $2913ed74210dce84$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearInt64BE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64BE = $2913ed74210dce84$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Float extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
module.exports.Float = $2913ed74210dce84$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$FloatBE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
module.exports.FloatBE = $2913ed74210dce84$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Double extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
module.exports.Double = $2913ed74210dce84$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$DoubleBE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
module.exports.DoubleBE = $2913ed74210dce84$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Sequence extends $2913ed74210dce84$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError('elementLayout must be a Layout');
        if (!(count instanceof $2913ed74210dce84$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $2913ed74210dce84$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $2913ed74210dce84$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $2913ed74210dce84$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $2913ed74210dce84$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
module.exports.Sequence = $2913ed74210dce84$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Structure extends $2913ed74210dce84$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $2913ed74210dce84$var$Layout, true))) throw new TypeError('fields must be array of Layout instances');
        if ('boolean' === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error('fields cannot contain unnamed variable-length layout');
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError('indeterminate span');
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ('string' !== typeof property) throw new TypeError('property must be string');
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ('string' !== typeof property) throw new TypeError('property must be string');
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
module.exports.Structure = $2913ed74210dce84$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $2913ed74210dce84$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error('UnionDiscriminator is abstract');
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error('UnionDiscriminator is abstract');
    }
}
module.exports.UnionDiscriminator = $2913ed74210dce84$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $2913ed74210dce84$var$UnionLayoutDiscriminator extends $2913ed74210dce84$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $2913ed74210dce84$var$ExternalLayout && layout.isCount())) throw new TypeError('layout must be an unsigned integer ExternalLayout');
        super(property || layout.property || 'variant');
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
module.exports.UnionLayoutDiscriminator = $2913ed74210dce84$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Union extends $2913ed74210dce84$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE) discriminator = new $2913ed74210dce84$var$UnionLayoutDiscriminator(new $2913ed74210dce84$var$OffsetLayout(discr));
        else if (discr instanceof $2913ed74210dce84$var$ExternalLayout && discr.isCount()) discriminator = new $2913ed74210dce84$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $2913ed74210dce84$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError('defaultLayout must be null or a Layout');
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error('defaultLayout must have constant span');
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate('content');
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error('unable to determine span for unrecognized variant');
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error('unable to infer src variant');
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $2913ed74210dce84$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
module.exports.Union = $2913ed74210dce84$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$VariantLayout extends $2913ed74210dce84$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $2913ed74210dce84$var$Union)) throw new TypeError('union must be a Union');
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError('variant must be a (non-negative) integer');
        if ('string' === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError('layout must be a Layout');
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error('variant span exceeds span of containing union');
            if ('string' !== typeof property) throw new TypeError('variant must have a String property');
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error('variant mismatch');
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError('variant lacks property ' + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error('encoded variant overruns containing union');
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
module.exports.VariantLayout = $2913ed74210dce84$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $2913ed74210dce84$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$BitStructure extends $2913ed74210dce84$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $2913ed74210dce84$var$UInt || word instanceof $2913ed74210dce84$var$UIntBE)) throw new TypeError('word must be a UInt or UIntBE layout');
        if ('string' === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError('word cannot exceed 32 bits');
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $2913ed74210dce84$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $2913ed74210dce84$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $2913ed74210dce84$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ('string' !== typeof property) throw new TypeError('property must be string');
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
module.exports.BitStructure = $2913ed74210dce84$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $2913ed74210dce84$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $2913ed74210dce84$var$BitStructure)) throw new TypeError('container must be a BitStructure');
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError('bits must be positive integer');
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error('bits too long for span remainder (' + (totalBits - usedBits) + ' of ' + totalBits + ' remain)');
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $2913ed74210dce84$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $2913ed74210dce84$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ('number' !== typeof value || !Number.isInteger(value) || value !== $2913ed74210dce84$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($2913ed74210dce84$var$nameWithProperty('BitField.encode', this) + ' value must be integer not exceeding ' + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $2913ed74210dce84$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($2913ed74210dce84$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
module.exports.BitField = $2913ed74210dce84$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $2913ed74210dce84$var$Boolean extends $2913ed74210dce84$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ('boolean' === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
module.exports.Boolean = $2913ed74210dce84$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Blob extends $2913ed74210dce84$var$Layout {
    constructor(length, property){
        if (!(length instanceof $2913ed74210dce84$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $2913ed74210dce84$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $2913ed74210dce84$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($2913ed74210dce84$var$nameWithProperty('Blob.encode', this) + ' requires (length ' + span + ') Uint8Array as src');
        if (offset + span > b.length) throw new RangeError('encoding overruns Uint8Array');
        const srcBuffer = $2913ed74210dce84$var$uint8ArrayToBuffer(src);
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).write(srcBuffer.toString('hex'), offset, span, 'hex');
        if (this.length instanceof $2913ed74210dce84$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
module.exports.Blob = $2913ed74210dce84$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$CString extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString('utf-8');
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ('string' !== typeof src) src = String(src);
        const srcb = $ihoyg.Buffer.from(src, 'utf8');
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError('encoding overruns Buffer');
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
module.exports.CString = $2913ed74210dce84$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UTF8 extends $2913ed74210dce84$var$Layout {
    constructor(maxSpan, property){
        if ('string' === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError('maxSpan must be an integer');
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError('text length exceeds maxSpan');
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString('utf-8');
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ('string' !== typeof src) src = String(src);
        const srcb = $ihoyg.Buffer.from(src, 'utf8');
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError('text length exceeds maxSpan');
        if (offset + span > b.length) throw new RangeError('encoding overruns Buffer');
        srcb.copy($2913ed74210dce84$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
module.exports.UTF8 = $2913ed74210dce84$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Constant extends $2913ed74210dce84$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
module.exports.Constant = $2913ed74210dce84$var$Constant;
/** Factory for {@link GreedyCount}. */ module.exports.greedy = (elementSpan, property)=>new $2913ed74210dce84$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ module.exports.offset = (layout, offset, property)=>new $2913ed74210dce84$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ module.exports.u8 = (property)=>new $2913ed74210dce84$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16 = (property)=>new $2913ed74210dce84$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24 = (property)=>new $2913ed74210dce84$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32 = (property)=>new $2913ed74210dce84$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40 = (property)=>new $2913ed74210dce84$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48 = (property)=>new $2913ed74210dce84$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64 = (property)=>new $2913ed74210dce84$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16be = (property)=>new $2913ed74210dce84$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24be = (property)=>new $2913ed74210dce84$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32be = (property)=>new $2913ed74210dce84$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40be = (property)=>new $2913ed74210dce84$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48be = (property)=>new $2913ed74210dce84$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64be = (property)=>new $2913ed74210dce84$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ module.exports.s8 = (property)=>new $2913ed74210dce84$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16 = (property)=>new $2913ed74210dce84$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24 = (property)=>new $2913ed74210dce84$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32 = (property)=>new $2913ed74210dce84$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40 = (property)=>new $2913ed74210dce84$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48 = (property)=>new $2913ed74210dce84$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64 = (property)=>new $2913ed74210dce84$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16be = (property)=>new $2913ed74210dce84$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24be = (property)=>new $2913ed74210dce84$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32be = (property)=>new $2913ed74210dce84$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40be = (property)=>new $2913ed74210dce84$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48be = (property)=>new $2913ed74210dce84$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64be = (property)=>new $2913ed74210dce84$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ module.exports.f32 = (property)=>new $2913ed74210dce84$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ module.exports.f32be = (property)=>new $2913ed74210dce84$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ module.exports.f64 = (property)=>new $2913ed74210dce84$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ module.exports.f64be = (property)=>new $2913ed74210dce84$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ module.exports.struct = (fields, property, decodePrefixes)=>new $2913ed74210dce84$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ module.exports.bits = (word, msb, property)=>new $2913ed74210dce84$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ module.exports.seq = (elementLayout, count, property)=>new $2913ed74210dce84$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ module.exports.union = (discr, defaultLayout, property)=>new $2913ed74210dce84$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ module.exports.unionLayoutDiscriminator = (layout, property)=>new $2913ed74210dce84$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ module.exports.blob = (length, property)=>new $2913ed74210dce84$var$Blob(length, property);
/** Factory for {@link CString} values. */ module.exports.cstr = (property)=>new $2913ed74210dce84$var$CString(property);
/** Factory for {@link UTF8} values. */ module.exports.utf8 = (maxSpan, property)=>new $2913ed74210dce84$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ module.exports.constant = (value, property)=>new $2913ed74210dce84$var$Constant(value, property);

});

parcelRegister("gbKvo", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $bc91bf67ed8c7241$require$Buffer = $ihoyg.Buffer;
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
let $bc91bf67ed8c7241$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $bc91bf67ed8c7241$var$toBigIntLE(buf) {
    {
        const reversed = $bc91bf67ed8c7241$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString('hex');
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $bc91bf67ed8c7241$var$converter.toBigInt(buf, false);
}
module.exports.toBigIntLE = $bc91bf67ed8c7241$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $bc91bf67ed8c7241$var$toBigIntBE(buf) {
    {
        const hex = buf.toString('hex');
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $bc91bf67ed8c7241$var$converter.toBigInt(buf, true);
}
module.exports.toBigIntBE = $bc91bf67ed8c7241$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $bc91bf67ed8c7241$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $bc91bf67ed8c7241$require$Buffer.from(hex.padStart(width * 2, '0').slice(0, width * 2), 'hex');
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $bc91bf67ed8c7241$var$converter.fromBigInt(num, $bc91bf67ed8c7241$require$Buffer.allocUnsafe(width), false);
}
module.exports.toBufferLE = $bc91bf67ed8c7241$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $bc91bf67ed8c7241$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $bc91bf67ed8c7241$require$Buffer.from(hex.padStart(width * 2, '0').slice(0, width * 2), 'hex');
    }
    return $bc91bf67ed8c7241$var$converter.fromBigInt(num, $bc91bf67ed8c7241$require$Buffer.allocUnsafe(width), true);
}
module.exports.toBufferBE = $bc91bf67ed8c7241$var$toBufferBE;

});

parcelRegister("kRZRk", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $f318bdd5723fa8a3$export$a7a9523472993e97; });
$parcel$export(module.exports, "create", function () { return $f318bdd5723fa8a3$export$185802fd694ee1f5; });
$parcel$export(module.exports, "optional", function () { return $f318bdd5723fa8a3$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "any", function () { return $f318bdd5723fa8a3$export$4154a199d7d90455; });
$parcel$export(module.exports, "array", function () { return $f318bdd5723fa8a3$export$2f23118c22fb2630; });
$parcel$export(module.exports, "boolean", function () { return $f318bdd5723fa8a3$export$4a21f16c33752377; });
$parcel$export(module.exports, "instance", function () { return $f318bdd5723fa8a3$export$9544d5bb712b01ea; });
$parcel$export(module.exports, "literal", function () { return $f318bdd5723fa8a3$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "nullable", function () { return $f318bdd5723fa8a3$export$133fc36489ac9add; });
$parcel$export(module.exports, "number", function () { return $f318bdd5723fa8a3$export$98e628dec113755e; });
$parcel$export(module.exports, "record", function () { return $f318bdd5723fa8a3$export$e5185e241753e543; });
$parcel$export(module.exports, "string", function () { return $f318bdd5723fa8a3$export$22b082955e083ec3; });
$parcel$export(module.exports, "tuple", function () { return $f318bdd5723fa8a3$export$65e3907585753458; });
$parcel$export(module.exports, "type", function () { return $f318bdd5723fa8a3$export$bf9fb029d174d554; });
$parcel$export(module.exports, "union", function () { return $f318bdd5723fa8a3$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "unknown", function () { return $f318bdd5723fa8a3$export$19282c40b967aec6; });
$parcel$export(module.exports, "coerce", function () { return $f318bdd5723fa8a3$export$8c14e57e778d3873; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $f318bdd5723fa8a3$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join('.') + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $f318bdd5723fa8a3$var$isIterable(x) {
    return $f318bdd5723fa8a3$var$isObject(x) && typeof x[Symbol.iterator] === 'function';
}
/**
 * Check if a value is a plain object.
 */ function $f318bdd5723fa8a3$var$isObject(x) {
    return typeof x === 'object' && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $f318bdd5723fa8a3$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $f318bdd5723fa8a3$var$print(value) {
    return typeof value === 'string' ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $f318bdd5723fa8a3$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $f318bdd5723fa8a3$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === 'string') result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : '') + ", but received: `" + $f318bdd5723fa8a3$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $f318bdd5723fa8a3$var$toFailures(result, context, struct, value) {
    if (!$f318bdd5723fa8a3$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $f318bdd5723fa8a3$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $f318bdd5723fa8a3$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== 'type' && $f318bdd5723fa8a3$var$isObject(struct.schema) && $f318bdd5723fa8a3$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $f318bdd5723fa8a3$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($f318bdd5723fa8a3$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $f318bdd5723fa8a3$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $f318bdd5723fa8a3$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $f318bdd5723fa8a3$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $f318bdd5723fa8a3$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $f318bdd5723fa8a3$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $f318bdd5723fa8a3$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $f318bdd5723fa8a3$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $f318bdd5723fa8a3$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $f318bdd5723fa8a3$export$a7a9523472993e97(value, struct) {
    const result = $f318bdd5723fa8a3$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $f318bdd5723fa8a3$export$185802fd694ee1f5(value, struct) {
    const result = $f318bdd5723fa8a3$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $f318bdd5723fa8a3$export$d99f0801a68bbcf1(value, struct) {
    const result = $f318bdd5723fa8a3$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $f318bdd5723fa8a3$export$226b3eccf92c9ed9(value, struct) {
    const result = $f318bdd5723fa8a3$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $f318bdd5723fa8a3$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $f318bdd5723fa8a3$var$run(value, struct, options);
    const tuple = $f318bdd5723fa8a3$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $f318bdd5723fa8a3$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $f318bdd5723fa8a3$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $f318bdd5723fa8a3$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $f318bdd5723fa8a3$export$f36d6a7a5c09a23e(name, validator) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $f318bdd5723fa8a3$export$cdd73fc4100a6ef4(struct, log) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $f318bdd5723fa8a3$export$7077912c31975674(fn) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'dynamic',
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $f318bdd5723fa8a3$export$488013bae63b21da(fn) {
    let struct;
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'lazy',
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $f318bdd5723fa8a3$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $f318bdd5723fa8a3$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $f318bdd5723fa8a3$export$e45945969df8035a(struct) {
    const schema = struct instanceof $f318bdd5723fa8a3$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $f318bdd5723fa8a3$export$516e28dec6a4b6d4(schema[key]);
    return $f318bdd5723fa8a3$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $f318bdd5723fa8a3$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $f318bdd5723fa8a3$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $f318bdd5723fa8a3$export$8cf3da7c1c9174ea(name, validator) {
    console.warn('superstruct@0.11 - The `struct` helper has been renamed to `define`.');
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $f318bdd5723fa8a3$export$4154a199d7d90455() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('any', ()=>true);
}
function $f318bdd5723fa8a3$export$2f23118c22fb2630(Element) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'array',
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $f318bdd5723fa8a3$export$4a21f16c33752377() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('boolean', (value)=>{
        return typeof value === 'boolean';
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $f318bdd5723fa8a3$export$324d90190a8b822a() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('date', (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $f318bdd5723fa8a3$var$print(value);
    });
}
function $f318bdd5723fa8a3$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$f318bdd5723fa8a3$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'enums',
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $f318bdd5723fa8a3$export$86951950244e2001() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('func', (value)=>{
        return typeof value === 'function' || "Expected a function, but received: " + $f318bdd5723fa8a3$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $f318bdd5723fa8a3$export$9544d5bb712b01ea(Class) {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('instance', (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $f318bdd5723fa8a3$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $f318bdd5723fa8a3$export$32744b5b3bba4764() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('integer', (value)=>{
        return typeof value === 'number' && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $f318bdd5723fa8a3$var$print(value);
    });
}
function $f318bdd5723fa8a3$export$bc86dfbf7795668c(Structs) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'intersection',
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $f318bdd5723fa8a3$export$c8ec6e1ec9fefcb0(constant) {
    const description = $f318bdd5723fa8a3$var$print(constant);
    const t = typeof constant;
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'literal',
        schema: t === 'string' || t === 'number' || t === 'boolean' ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
function $f318bdd5723fa8a3$export$871de8747c9eaa88(Key, Value) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'map',
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $f318bdd5723fa8a3$export$b3e22bcfd64c1022() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('never', ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $f318bdd5723fa8a3$export$133fc36489ac9add(struct) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $f318bdd5723fa8a3$export$98e628dec113755e() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('number', (value)=>{
        return typeof value === 'number' && !isNaN(value) || "Expected a number, but received: " + $f318bdd5723fa8a3$var$print(value);
    });
}
function $f318bdd5723fa8a3$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $f318bdd5723fa8a3$export$b3e22bcfd64c1022();
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'object',
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $f318bdd5723fa8a3$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $f318bdd5723fa8a3$var$isObject(value) || "Expected an object, but received: " + $f318bdd5723fa8a3$var$print(value);
        },
        coercer (value) {
            return $f318bdd5723fa8a3$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $f318bdd5723fa8a3$export$516e28dec6a4b6d4(struct) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $f318bdd5723fa8a3$export$e5185e241753e543(Key, Value) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'record',
        schema: null,
        *entries (value) {
            if ($f318bdd5723fa8a3$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $f318bdd5723fa8a3$var$isObject(value) || "Expected an object, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $f318bdd5723fa8a3$export$efdc1e5bdb609bb() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('regexp', (value)=>{
        return value instanceof RegExp;
    });
}
function $f318bdd5723fa8a3$export$adaa4cf7ef1b65be(Element) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'set',
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $f318bdd5723fa8a3$export$22b082955e083ec3() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('string', (value)=>{
        return typeof value === 'string' || "Expected a string, but received: " + $f318bdd5723fa8a3$var$print(value);
    });
}
function $f318bdd5723fa8a3$export$65e3907585753458(Elements) {
    const Never = $f318bdd5723fa8a3$export$b3e22bcfd64c1022();
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'tuple',
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $f318bdd5723fa8a3$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'type',
        schema: schema,
        *entries (value) {
            if ($f318bdd5723fa8a3$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $f318bdd5723fa8a3$var$isObject(value) || "Expected an object, but received: " + $f318bdd5723fa8a3$var$print(value);
        }
    });
}
function $f318bdd5723fa8a3$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(' | ');
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        type: 'union',
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $f318bdd5723fa8a3$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $f318bdd5723fa8a3$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $f318bdd5723fa8a3$export$19282c40b967aec6() {
    return $f318bdd5723fa8a3$export$f36d6a7a5c09a23e('unknown', ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f318bdd5723fa8a3$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $f318bdd5723fa8a3$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f318bdd5723fa8a3$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $f318bdd5723fa8a3$export$8c14e57e778d3873(struct, $f318bdd5723fa8a3$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === 'function' ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $f318bdd5723fa8a3$var$isPlainObject(x) && $f318bdd5723fa8a3$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f318bdd5723fa8a3$export$41f369984ed28930(struct) {
    return $f318bdd5723fa8a3$export$8c14e57e778d3873(struct, $f318bdd5723fa8a3$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $f318bdd5723fa8a3$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $f318bdd5723fa8a3$export$edc9d475108b3212(struct, 'empty', (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $f318bdd5723fa8a3$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $f318bdd5723fa8a3$export$edc9d475108b3212(struct, 'max', (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $f318bdd5723fa8a3$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $f318bdd5723fa8a3$export$edc9d475108b3212(struct, 'min', (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $f318bdd5723fa8a3$export$24f82734ea047e6f(struct, regexp) {
    return $f318bdd5723fa8a3$export$edc9d475108b3212(struct, 'pattern', (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + "/` but received \"" + value + "\"";
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $f318bdd5723fa8a3$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $f318bdd5723fa8a3$export$edc9d475108b3212(struct, 'size', (value)=>{
        if (typeof value === 'number' || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $f318bdd5723fa8a3$export$edc9d475108b3212(struct, name, refiner) {
    return new $f318bdd5723fa8a3$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $f318bdd5723fa8a3$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});

parcelRegister("fFbWN", function(module, exports) {
'use strict';

var $bEzwx = parcelRequire("bEzwx");
var $b673f3d4b64776a3$require$uuid = $bEzwx.default;

var $iwCvH = parcelRequire("iwCvH");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $b673f3d4b64776a3$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $b673f3d4b64776a3$var$ClientBrowser)) return new $b673f3d4b64776a3$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== 'undefined' ? options.reviver : null,
        replacer: typeof options.replacer !== 'undefined' ? options.replacer : null,
        generator: typeof options.generator !== 'undefined' ? options.generator : function() {
            return $b673f3d4b64776a3$require$uuid();
        },
        version: typeof options.version !== 'undefined' ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === 'boolean' ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $b673f3d4b64776a3$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $b673f3d4b64776a3$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === 'function';
    if (this.options.version === 1 && isBatch) throw new TypeError('JSON-RPC 1.0 does not support batching');
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === 'object' && typeof params === 'function';
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === 'function') {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === 'function';
        try {
            request = $iwCvH(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $b673f3d4b64776a3$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== 'undefined';
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};

});
parcelRegister("bEzwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87befc68df50040c$export$2e2bcd8739ae039; });

var $kknQe = parcelRequire("kknQe");

var $7YxFJ = parcelRequire("7YxFJ");
function $87befc68df50040c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $kknQe.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7YxFJ.default)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;

});
parcelRegister("kknQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc82b4b4d5334a5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ecc82b4b4d5334a5$var$getRandomValues;
var $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}

});

parcelRegister("7YxFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ce84198744ccadf$export$2e2bcd8739ae039; });

var $jPUoq = parcelRequire("jPUoq");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5ce84198744ccadf$var$byteToHex = [];
for(var $5ce84198744ccadf$var$i = 0; $5ce84198744ccadf$var$i < 256; ++$5ce84198744ccadf$var$i)$5ce84198744ccadf$var$byteToHex.push(($5ce84198744ccadf$var$i + 0x100).toString(16).substr(1));
function $5ce84198744ccadf$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $jPUoq.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;

});
parcelRegister("jPUoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e86397c656fa2$export$2e2bcd8739ae039; });

var $bjlDU = parcelRequire("bjlDU");
function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $bjlDU.default).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;

});
parcelRegister("bjlDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c241de251331e8$export$2e2bcd8739ae039; });
var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("iwCvH", function(module, exports) {
'use strict';

var $bEzwx = parcelRequire("bEzwx");
var $d7c9167c515e7513$require$uuid = $bEzwx.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $d7c9167c515e7513$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== 'string') throw new TypeError(method + ' must be a string');
    options = options || {};
    // check valid version provided
    const version = typeof options.version === 'number' ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + ' must be 1 or 2');
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = '2.0';
    if (params) {
        // params given, but invalid?
        if (typeof params !== 'object' && !Array.isArray(params)) throw new TypeError(params + ' must be an object, array or omitted');
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === 'undefined') {
        const generator = typeof options.generator === 'function' ? options.generator : function() {
            return $d7c9167c515e7513$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $d7c9167c515e7513$var$generateRequest;

});


parcelRegister("81012", function(module, exports) {
/**
 * "Client" wraps "ws" or a browser-implemented "WebSocket" library
 * according to the environment providing JSON RPC 2.0 support on top.
 * @module Client
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $5d5e6dd86cf1d7bc$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5d5e6dd86cf1d7bc$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $5d5e6dd86cf1d7bc$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $5d5e6dd86cf1d7bc$var$_typeof2 = $2ZnTs((parcelRequire("crtHL")));

var $5d5e6dd86cf1d7bc$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $5d5e6dd86cf1d7bc$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $5d5e6dd86cf1d7bc$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $5d5e6dd86cf1d7bc$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $5d5e6dd86cf1d7bc$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $emi2d = parcelRequire("emi2d");

var $8ABsC = parcelRequire("8ABsC");
function $5d5e6dd86cf1d7bc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d5e6dd86cf1d7bc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $5d5e6dd86cf1d7bc$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5d5e6dd86cf1d7bc$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5d5e6dd86cf1d7bc$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $5d5e6dd86cf1d7bc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5d5e6dd86cf1d7bc$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// @ts-ignore
var $5d5e6dd86cf1d7bc$var$CommonClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $5d5e6dd86cf1d7bc$var$_inherits2["default"])(CommonClient, _EventEmitter);
    var _super = $5d5e6dd86cf1d7bc$var$_createSuper(CommonClient);
    /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */ function CommonClient(webSocketFactory) {
        var _this;
        var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";
        var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
        var dataPack = arguments.length > 4 ? arguments[4] : undefined;
        (0, $5d5e6dd86cf1d7bc$var$_classCallCheck2["default"])(this, CommonClient);
        var _a$autoconnect = _a.autoconnect, autoconnect = _a$autoconnect === void 0 ? true : _a$autoconnect, _a$reconnect = _a.reconnect, reconnect = _a$reconnect === void 0 ? true : _a$reconnect, _a$reconnect_interval = _a.reconnect_interval, reconnect_interval = _a$reconnect_interval === void 0 ? 1000 : _a$reconnect_interval, _a$max_reconnects = _a.max_reconnects, max_reconnects = _a$max_reconnects === void 0 ? 5 : _a$max_reconnects, rest_options = $5d5e6dd86cf1d7bc$var$__rest(_a, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = undefined;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $8ABsC.DefaultDataPack();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, Object.assign({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */ (0, $5d5e6dd86cf1d7bc$var$_createClass2["default"])(CommonClient, [
        {
            key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, Object.assign({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this2 = this;
                if (!ws_opts && "object" === (0, $5d5e6dd86cf1d7bc$var$_typeof2["default"])(timeout)) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this2.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this2.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || undefined,
                        id: rpc_id
                    };
                    _this2.socket.send(_this2.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this2.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this2.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this2.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: function() {
                var _login = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee(params) {
                    var resp;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.call("rpc.login", params);
                            case 2:
                                resp = _context.sent;
                                if (resp) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("authentication failed");
                            case 5:
                                return _context.abrupt("return", resp);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function login(_x) {
                    return _login.apply(this, arguments);
                }
                return login;
            }()
        },
        {
            key: "listMethods",
            value: function() {
                var _listMethods = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee2() {
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.call("__listMethods");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function listMethods() {
                    return _listMethods.apply(this, arguments);
                }
                return listMethods;
            }()
        },
        {
            key: "notify",
            value: function notify(method, params) {
                var _this3 = this;
                return new Promise(function(resolve, reject) {
                    if (!_this3.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this3.socket.send(_this3.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee3(event) {
                    var result;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context3.next = 3;
                                return this.call("rpc.on", event);
                            case 3:
                                result = _context3.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context3.next = 6;
                                    break;
                                }
                                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                            case 6:
                                return _context3.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function subscribe(_x2) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "unsubscribe",
            value: function() {
                var _unsubscribe = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee4(event) {
                    var result;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context4.next = 3;
                                return this.call("rpc.off", event);
                            case 3:
                                result = _context4.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context4.next = 6;
                                    break;
                                }
                                throw new Error("Failed unsubscribing from an event with: " + result);
                            case 6:
                                return _context4.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function unsubscribe(_x3) {
                    return _unsubscribe.apply(this, arguments);
                }
                return unsubscribe;
            }()
        },
        {
            key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1000, data);
            }
        },
        {
            key: "_connect",
            value: function _connect(address, options) {
                var _this4 = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this4.ready = true;
                    _this4.emit("open");
                    _this4.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(_ref) {
                    var message = _ref.data;
                    if (message instanceof ArrayBuffer) message = $5d5e6dd86cf1d7bc$require$Buffer.from(message).toString();
                    try {
                        message = _this4.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    // check if any listeners are attached and forward event
                    if (message.notification && _this4.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this4.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else // using for-loop instead of unshift/spread because performance is better
                        for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        // run as microtask so that pending queue messages are resolved first
                        // eslint-disable-next-line prefer-spread
                        return Promise.resolve().then(function() {
                            _this4.emit.apply(_this4, args);
                        });
                    }
                    if (!_this4.queue[message.id]) {
                        // general JSON RPC 2.0 events
                        if (message.method && message.params) // run as microtask so that pending queue messages are resolved first
                        return Promise.resolve().then(function() {
                            _this4.emit(message.method, message.params);
                        });
                        return;
                    }
                    // reject early since server's response is invalid
                    if ("error" in message === "result" in message) _this4.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this4.queue[message.id].timeout) clearTimeout(_this4.queue[message.id].timeout);
                    if (message.error) _this4.queue[message.id].promise[1](message.error);
                    else _this4.queue[message.id].promise[0](message.result);
                    delete _this4.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this4.emit("error", error);
                });
                this.socket.addEventListener("close", function(_ref2) {
                    var code = _ref2.code, reason = _ref2.reason;
                    if (_this4.ready) // Delay close event until internal state is updated
                    setTimeout(function() {
                        return _this4.emit("close", code, reason);
                    }, 0);
                    _this4.ready = false;
                    _this4.socket = undefined;
                    if (code === 1000) return;
                    _this4.current_reconnects++;
                    if (_this4.reconnect && (_this4.max_reconnects > _this4.current_reconnects || _this4.max_reconnects === 0)) _this4.reconnect_timer_id = setTimeout(function() {
                        return _this4._connect(address, options);
                    }, _this4.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}($emi2d.EventEmitter);
module.exports["default"] = $5d5e6dd86cf1d7bc$var$CommonClient;

});
parcelRegister("2ZnTs", function(module, exports) {
function $22d3d00379a62cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $22d3d00379a62cb8$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kM9CL", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $f1ffc181de632b16$var$runtime = (parcelRequire("3pCEE"))();
module.exports = $f1ffc181de632b16$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $f1ffc181de632b16$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $f1ffc181de632b16$var$runtime;
    else Function("r", "regeneratorRuntime = r")($f1ffc181de632b16$var$runtime);
}

});
parcelRegister("3pCEE", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $27c1b0e942ce910b$var$_typeof = $crtHL.default;
function $27c1b0e942ce910b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $27c1b0e942ce910b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($27c1b0e942ce910b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(o);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dxUGa", function(module, exports) {
function $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dca52b7b9a5d7e7$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $9dca52b7b9a5d7e7$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bfbtb", function(module, exports) {
function $82f9fe10102e948b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $82f9fe10102e948b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kNrk6", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $f23d94100a43e193$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7keJs(descriptor.key), descriptor);
    }
}
function $f23d94100a43e193$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f23d94100a43e193$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f23d94100a43e193$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $f23d94100a43e193$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7keJs", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $5555d428bd3bf37b$var$_typeof = $crtHL.default;

var $2PEUm = parcelRequire("2PEUm");
function $5555d428bd3bf37b$var$_toPropertyKey(arg) {
    var key = $2PEUm(arg, "string");
    return $5555d428bd3bf37b$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $5555d428bd3bf37b$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2PEUm", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $210013a7b1d5e66c$var$_typeof = $crtHL.default;
function $210013a7b1d5e66c$var$_toPrimitive(input, hint) {
    if ($210013a7b1d5e66c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($210013a7b1d5e66c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $210013a7b1d5e66c$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ljhd4", function(module, exports) {

var $96bT5 = parcelRequire("96bT5");
function $f838b8d3ab72d3a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $96bT5(subClass, superClass);
}
module.exports = $f838b8d3ab72d3a5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("96bT5", function(module, exports) {
function $69fde538af35e679$var$_setPrototypeOf(o, p) {
    module.exports = $69fde538af35e679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $69fde538af35e679$var$_setPrototypeOf(o, p);
}
module.exports = $69fde538af35e679$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cybvJ", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $923196d71df5e353$var$_typeof = $crtHL.default;

var $eiXAs = parcelRequire("eiXAs");
function $923196d71df5e353$var$_possibleConstructorReturn(self, call) {
    if (call && ($923196d71df5e353$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $eiXAs(self);
}
module.exports = $923196d71df5e353$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eiXAs", function(module, exports) {
function $a6a0f7da525baef5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $a6a0f7da525baef5$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("j4o1m", function(module, exports) {
function $de21061e32125644$var$_getPrototypeOf(o) {
    module.exports = $de21061e32125644$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $de21061e32125644$var$_getPrototypeOf(o);
}
module.exports = $de21061e32125644$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("emi2d", function(module, exports) {
'use strict';
var $a7411c1a9b3d09c2$var$has = Object.prototype.hasOwnProperty, $a7411c1a9b3d09c2$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $a7411c1a9b3d09c2$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $a7411c1a9b3d09c2$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $a7411c1a9b3d09c2$var$Events().__proto__) $a7411c1a9b3d09c2$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $a7411c1a9b3d09c2$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $a7411c1a9b3d09c2$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $a7411c1a9b3d09c2$var$EE(fn, context || emitter, once), evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $a7411c1a9b3d09c2$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $a7411c1a9b3d09c2$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $a7411c1a9b3d09c2$var$EventEmitter() {
    this._events = new $a7411c1a9b3d09c2$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($a7411c1a9b3d09c2$var$has.call(events, name)) names.push($a7411c1a9b3d09c2$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $a7411c1a9b3d09c2$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $a7411c1a9b3d09c2$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $a7411c1a9b3d09c2$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $a7411c1a9b3d09c2$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $a7411c1a9b3d09c2$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
        if (this._events[evt]) $a7411c1a9b3d09c2$var$clearEvent(this, evt);
    } else {
        this._events = new $a7411c1a9b3d09c2$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$a7411c1a9b3d09c2$var$EventEmitter.prototype.off = $a7411c1a9b3d09c2$var$EventEmitter.prototype.removeListener;
$a7411c1a9b3d09c2$var$EventEmitter.prototype.addListener = $a7411c1a9b3d09c2$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$a7411c1a9b3d09c2$var$EventEmitter.prefixed = $a7411c1a9b3d09c2$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$a7411c1a9b3d09c2$var$EventEmitter.EventEmitter = $a7411c1a9b3d09c2$var$EventEmitter;
module.exports = $a7411c1a9b3d09c2$var$EventEmitter;

});

parcelRegister("8ABsC", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultDataPack = void 0;
module.exports.createError = $640ebe6e674b49c7$var$createError;

var $640ebe6e674b49c7$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $640ebe6e674b49c7$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));
var $640ebe6e674b49c7$var$errors = new Map([
    [
        -32000,
        "Event not provided"
    ],
    [
        -32600,
        "Invalid Request"
    ],
    [
        -32601,
        "Method not found"
    ],
    [
        -32602,
        "Invalid params"
    ],
    [
        -32603,
        "Internal error"
    ],
    [
        -32604,
        "Params not found"
    ],
    [
        -32605,
        "Method forbidden"
    ],
    [
        -32606,
        "Event forbidden"
    ],
    [
        -32700,
        "Parse error"
    ]
]);
var $640ebe6e674b49c7$var$DefaultDataPack = /*#__PURE__*/ function() {
    function DefaultDataPack() {
        (0, $640ebe6e674b49c7$var$_classCallCheck2["default"])(this, DefaultDataPack);
    }
    (0, $640ebe6e674b49c7$var$_createClass2["default"])(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
/**
 * Creates a JSON-RPC 2.0-compliant error.
 * @param {Number} code - error code
 * @param {String} details - error details
 * @return {Object}
 */ module.exports.DefaultDataPack = $640ebe6e674b49c7$var$DefaultDataPack;
function $640ebe6e674b49c7$var$createError(code, details) {
    var error = {
        code: code,
        message: $640ebe6e674b49c7$var$errors.get(code) || "Internal Server Error"
    };
    if (details) error["data"] = details;
    return error;
}

});


parcelRegister("6U8NG", function(module, exports) {
/**
 * WebSocket implements a browser-side WebSocket specification.
 * @module Client
 */ "use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $506ecc9a680f3f9d$var$_default;

var $506ecc9a680f3f9d$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $506ecc9a680f3f9d$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $506ecc9a680f3f9d$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $506ecc9a680f3f9d$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $506ecc9a680f3f9d$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $emi2d = parcelRequire("emi2d");
function $506ecc9a680f3f9d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $506ecc9a680f3f9d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $506ecc9a680f3f9d$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $506ecc9a680f3f9d$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $506ecc9a680f3f9d$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $506ecc9a680f3f9d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $506ecc9a680f3f9d$var$WebSocketBrowserImpl = /*#__PURE__*/ function(_EventEmitter) {
    (0, $506ecc9a680f3f9d$var$_inherits2["default"])(WebSocketBrowserImpl, _EventEmitter);
    var _super = $506ecc9a680f3f9d$var$_createSuper(WebSocketBrowserImpl);
    /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */ function WebSocketBrowserImpl(address, options, protocols) {
        var _this;
        (0, $506ecc9a680f3f9d$var$_classCallCheck2["default"])(this, WebSocketBrowserImpl);
        _this = _super.call(this);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */ (0, $506ecc9a680f3f9d$var$_createClass2["default"])(WebSocketBrowserImpl, [
        {
            key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}($emi2d.EventEmitter);
/**
 * factory method for common WebSocket instance
 * @method
 * @param {String} address - url to a websocket server
 * @param {(Object)} options - websocket options
 * @return {Undefined}
 */ function $506ecc9a680f3f9d$var$_default(address, options) {
    return new $506ecc9a680f3f9d$var$WebSocketBrowserImpl(address, options);
}

});

parcelRegister("ek8qD", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $a6d978ac7d5ba982$export$860ddaa9ca84a66d; });

var $b3mfP = parcelRequire("b3mfP");

var $3B2Zj = parcelRequire("3B2Zj");

var $3SZ63 = parcelRequire("3SZ63");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $a6d978ac7d5ba982$var$SHA3_PI = [];
const $a6d978ac7d5ba982$var$SHA3_ROTL = [];
const $a6d978ac7d5ba982$var$_SHA3_IOTA = [];
const $a6d978ac7d5ba982$var$_0n = /* @__PURE__ */ BigInt(0);
const $a6d978ac7d5ba982$var$_1n = /* @__PURE__ */ BigInt(1);
const $a6d978ac7d5ba982$var$_2n = /* @__PURE__ */ BigInt(2);
const $a6d978ac7d5ba982$var$_7n = /* @__PURE__ */ BigInt(7);
const $a6d978ac7d5ba982$var$_256n = /* @__PURE__ */ BigInt(256);
const $a6d978ac7d5ba982$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $a6d978ac7d5ba982$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $a6d978ac7d5ba982$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $a6d978ac7d5ba982$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $a6d978ac7d5ba982$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $a6d978ac7d5ba982$var$_1n ^ (R >> $a6d978ac7d5ba982$var$_7n) * $a6d978ac7d5ba982$var$_0x71n) % $a6d978ac7d5ba982$var$_256n;
        if (R & $a6d978ac7d5ba982$var$_2n) t ^= $a6d978ac7d5ba982$var$_1n << ($a6d978ac7d5ba982$var$_1n << /* @__PURE__ */ BigInt(j)) - $a6d978ac7d5ba982$var$_1n;
    }
    $a6d978ac7d5ba982$var$_SHA3_IOTA.push(t);
}
const [$a6d978ac7d5ba982$var$SHA3_IOTA_H, $a6d978ac7d5ba982$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $3B2Zj.split)($a6d978ac7d5ba982$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $a6d978ac7d5ba982$var$rotlH = (h, l, s)=>s > 32 ? (0, $3B2Zj.rotlBH)(h, l, s) : (0, $3B2Zj.rotlSH)(h, l, s);
const $a6d978ac7d5ba982$var$rotlL = (h, l, s)=>s > 32 ? (0, $3B2Zj.rotlBL)(h, l, s) : (0, $3B2Zj.rotlSL)(h, l, s);
function $a6d978ac7d5ba982$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $a6d978ac7d5ba982$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $a6d978ac7d5ba982$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $a6d978ac7d5ba982$var$SHA3_ROTL[t];
            const Th = $a6d978ac7d5ba982$var$rotlH(curH, curL, shift);
            const Tl = $a6d978ac7d5ba982$var$rotlL(curH, curL, shift);
            const PI = $a6d978ac7d5ba982$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $a6d978ac7d5ba982$var$SHA3_IOTA_H[round];
        s[1] ^= $a6d978ac7d5ba982$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $a6d978ac7d5ba982$export$f7374b8b4498bc2e extends (0, $3SZ63.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $b3mfP.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = (0, $3SZ63.u32)(this.state);
    }
    keccak() {
        if (!(0, $3SZ63.isLE)) (0, $3SZ63.byteSwap32)(this.state32);
        $a6d978ac7d5ba982$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $3SZ63.isLE)) (0, $3SZ63.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $b3mfP.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $3SZ63.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $b3mfP.exists)(this, false);
        (0, $b3mfP.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $b3mfP.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $b3mfP.output)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $a6d978ac7d5ba982$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $a6d978ac7d5ba982$var$gen = (suffix, blockLen, outputLen)=>(0, $3SZ63.wrapConstructor)(()=>new $a6d978ac7d5ba982$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $a6d978ac7d5ba982$export$fe6c2b96a79338e9 = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x06, 144, 28);
const $a6d978ac7d5ba982$export$76e19b6966813b14 = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x06, 136, 32);
const $a6d978ac7d5ba982$export$a58509fa80f30d15 = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x06, 104, 48);
const $a6d978ac7d5ba982$export$20ed324dbdf09b7c = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x06, 72, 64);
const $a6d978ac7d5ba982$export$2f7fb3c6fac246bc = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x01, 144, 28);
const $a6d978ac7d5ba982$export$860ddaa9ca84a66d = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x01, 136, 32);
const $a6d978ac7d5ba982$export$46fcdeb4c5686552 = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x01, 104, 48);
const $a6d978ac7d5ba982$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $a6d978ac7d5ba982$var$gen(0x01, 72, 64);
const $a6d978ac7d5ba982$var$genShake = (suffix, blockLen, outputLen)=>(0, $3SZ63.wrapXOFConstructorWithOpts)((opts = {})=>new $a6d978ac7d5ba982$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $a6d978ac7d5ba982$export$f43dc3bb86efbba2 = /* @__PURE__ */ $a6d978ac7d5ba982$var$genShake(0x1f, 168, 16);
const $a6d978ac7d5ba982$export$c240d011f1520440 = /* @__PURE__ */ $a6d978ac7d5ba982$var$genShake(0x1f, 136, 32);

});
parcelRegister("3B2Zj", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $29e7252352433c04$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $29e7252352433c04$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $29e7252352433c04$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $29e7252352433c04$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $29e7252352433c04$export$5d12cc1da441323f; });
const $29e7252352433c04$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $29e7252352433c04$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $29e7252352433c04$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $29e7252352433c04$var$U32_MASK64),
        l: Number(n >> $29e7252352433c04$var$_32n & $29e7252352433c04$var$U32_MASK64)
    };
    return {
        h: Number(n >> $29e7252352433c04$var$_32n & $29e7252352433c04$var$U32_MASK64) | 0,
        l: Number(n & $29e7252352433c04$var$U32_MASK64) | 0
    };
}
function $29e7252352433c04$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $29e7252352433c04$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $29e7252352433c04$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $29e7252352433c04$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $29e7252352433c04$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $29e7252352433c04$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $29e7252352433c04$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $29e7252352433c04$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $29e7252352433c04$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $29e7252352433c04$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $29e7252352433c04$export$a088d44bd387d2a3 = (_h, l)=>l;
const $29e7252352433c04$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $29e7252352433c04$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $29e7252352433c04$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $29e7252352433c04$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $29e7252352433c04$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $29e7252352433c04$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $29e7252352433c04$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $29e7252352433c04$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $29e7252352433c04$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $29e7252352433c04$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $29e7252352433c04$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $29e7252352433c04$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $29e7252352433c04$var$u64 = {
    fromBig: $29e7252352433c04$export$9625d4333cb56c3f,
    split: $29e7252352433c04$export$65980d18b75784e2,
    toBig: $29e7252352433c04$export$30f78adcaaa2eb7,
    shrSH: $29e7252352433c04$export$75aa78dc5bd52853,
    shrSL: $29e7252352433c04$export$a0225ff0aee14e25,
    rotrSH: $29e7252352433c04$export$97f812dfd830ca87,
    rotrSL: $29e7252352433c04$export$60987e30e2c9d9d,
    rotrBH: $29e7252352433c04$export$af9c7fbac44dcb76,
    rotrBL: $29e7252352433c04$export$f619171d6d5ac414,
    rotr32H: $29e7252352433c04$export$a088d44bd387d2a3,
    rotr32L: $29e7252352433c04$export$8415aae4d1f69577,
    rotlSH: $29e7252352433c04$export$4b80a2917447870e,
    rotlSL: $29e7252352433c04$export$20652918a7b63b3,
    rotlBH: $29e7252352433c04$export$a52f14bf902f9977,
    rotlBL: $29e7252352433c04$export$5d12cc1da441323f,
    add: $29e7252352433c04$export$e16d8520af44a096,
    add3L: $29e7252352433c04$export$c0c22b91f08911f,
    add3H: $29e7252352433c04$export$ef7b26044977a8ec,
    add4L: $29e7252352433c04$export$2f4e199c560f545d,
    add4H: $29e7252352433c04$export$e909220d675a7741,
    add5H: $29e7252352433c04$export$b45ee8d78c965098,
    add5L: $29e7252352433c04$export$d732b061fe9c9ae4
};
var $29e7252352433c04$export$2e2bcd8739ae039 = $29e7252352433c04$var$u64;

});



parcelRegister("1ppfI", function(module, exports) {

$parcel$export(module.exports, "setSolanaSignerConfig", function () { return $bba759f11d6953ae$export$e36eb7a2b6b6c75c; });
$parcel$export(module.exports, "getSolanaSignerConfig", function () { return $bba759f11d6953ae$export$9b3036b45850ff6; });
const $bba759f11d6953ae$var$solanaSignerConfig = {};
function $bba759f11d6953ae$export$e36eb7a2b6b6c75c(key, value) {
    $bba759f11d6953ae$var$solanaSignerConfig[key] = value;
    return value;
}
function $bba759f11d6953ae$export$9b3036b45850ff6(key) {
    return $bba759f11d6953ae$var$solanaSignerConfig[key];
}

});


parcelRegister("gPoET", function(module, exports) {

$parcel$export(module.exports, "prepareTransaction", function () { return $d51c415790c16caa$export$7e0572dffdc923a3; });

var $2v1vt = parcelRequire("2v1vt");

var $ihoyg = parcelRequire("ihoyg");
var $d51c415790c16caa$require$Buffer = $ihoyg.Buffer;
const $d51c415790c16caa$export$7e0572dffdc923a3 = (tx, recentBlockhash)=>{
    if (tx.txType === 'VERSIONED') return $d51c415790c16caa$export$e3627c823b2d0e16(tx, recentBlockhash);
    return $d51c415790c16caa$export$6746e97ddad7e458(tx, recentBlockhash);
};
function $d51c415790c16caa$export$e3627c823b2d0e16(tx, recentBlockhash) {
    const versionedTransaction = (0, $2v1vt.VersionedTransaction).deserialize(new Uint8Array(tx.serializedMessage || []));
    /*
   * We shouldn't override the recent blockhash provided by the API
   * Otherwise, the transaction will become invalid if partially signed by the API
   */ versionedTransaction.message.recentBlockhash = tx.recentBlockhash || recentBlockhash;
    tx.signatures.forEach(({ publicKey: publicKey, signature: signature })=>{
        versionedTransaction.addSignature(new (0, $2v1vt.PublicKey)(publicKey), new Uint8Array(signature));
    });
    return versionedTransaction;
}
function $d51c415790c16caa$export$6746e97ddad7e458(tx, recentBlockhash) {
    const transaction = new (0, $2v1vt.Transaction)({
        feePayer: new (0, $2v1vt.PublicKey)(tx.from),
        recentBlockhash: tx.recentBlockhash || recentBlockhash
    });
    tx.instructions.forEach(({ keys: keys, programId: programId, data: data })=>{
        const instruction = new (0, $2v1vt.TransactionInstruction)({
            keys: keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: new (0, $2v1vt.PublicKey)(pubkey),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: new (0, $2v1vt.PublicKey)(programId),
            data: $d51c415790c16caa$require$Buffer.from(data)
        });
        transaction.add(instruction);
    });
    tx.signatures.forEach(({ publicKey: publicKey, signature: signature })=>{
        transaction.addSignature(new (0, $2v1vt.PublicKey)(publicKey), $d51c415790c16caa$require$Buffer.from(new Uint8Array(signature)));
    });
    return transaction;
}

});

parcelRegister("3W3Ha", function(module, exports) {

$parcel$export(module.exports, "transactionSenderAndConfirmationWaiter", function () { return $e9381a9dc9bca476$export$c6a44f9085145c9f; });

var $2v1vt = parcelRequire("2v1vt");

var $aKcLZ = parcelRequire("aKcLZ");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $fULdq = parcelRequire("fULdq");
const $e9381a9dc9bca476$var$SEND_OPTIONS = {
    skipPreflight: true
};
const $e9381a9dc9bca476$var$TIME_OUT = 2000;
const $e9381a9dc9bca476$var$CONFIRMATION_TIME_OUT = 60000;
async function $e9381a9dc9bca476$var$sendTransactionOnMultipleNodes(serializedTransaction, connectionPool) {
    await Promise.allSettled(connectionPool.list.map(async (connection)=>connection.sendRawTransaction(serializedTransaction, $e9381a9dc9bca476$var$SEND_OPTIONS).catch((e)=>console.warn(`Failed to resend transaction: ${e}`))));
}
async function $e9381a9dc9bca476$export$c6a44f9085145c9f({ connectionPool: connectionPool, serializedTransaction: serializedTransaction }) {
    const txId = await connectionPool.main.sendRawTransaction(serializedTransaction, $e9381a9dc9bca476$var$SEND_OPTIONS);
    const controller = new AbortController();
    const abortSignal = controller.signal;
    const abortableResender = async ()=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            await (0, $fULdq.wait)($e9381a9dc9bca476$var$TIME_OUT);
            if (abortSignal.aborted) return;
            await $e9381a9dc9bca476$var$sendTransactionOnMultipleNodes(serializedTransaction, connectionPool);
        }
    };
    try {
        abortableResender();
        // this would throw TransactionExpiredBlockheightExceededError
        await Promise.race([
            new Promise((_, reject)=>setTimeout(()=>{
                    if (!abortSignal.aborted) reject(new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SEND_TX_ERROR, undefined, `Error confirming transaction (timeout)`));
                }, $e9381a9dc9bca476$var$CONFIRMATION_TIME_OUT)),
            // eslint-disable-next-line no-async-promise-executor
            new Promise(async (resolve, reject)=>{
                // in case ws socket died
                while(!abortSignal.aborted){
                    await (0, $fULdq.wait)($e9381a9dc9bca476$var$TIME_OUT);
                    const { value: statuses } = await connectionPool.main.getSignatureStatuses([
                        txId
                    ], {
                        searchTransactionHistory: false
                    });
                    if (statuses?.length > 0) {
                        const status = statuses[0];
                        if (status) {
                            if (status.err) reject(new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SEND_TX_ERROR, undefined, `Transaction failed: ${JSON.stringify(status.err)}`));
                            if (status.confirmationStatus && [
                                'confirmed',
                                'finalized'
                            ].includes(status.confirmationStatus)) resolve(true);
                        }
                    }
                }
            })
        ]);
    } catch (e) {
        if (e instanceof (0, $2v1vt.TransactionExpiredBlockheightExceededError)) // we consume this error and getTransaction would return null
        return {
            txId: txId,
            txResponse: null
        };
        throw e;
    } finally{
        controller.abort();
    }
    // in case rpc is not synced yet, we add some retries
    const txResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aKcLZ)))(async (retry)=>{
        const response = await connectionPool.main.getTransaction(txId, {
            commitment: 'confirmed',
            maxSupportedTransactionVersion: 0
        });
        if (!response) retry(response);
        return response;
    }, {
        retries: 5,
        minTimeout: 1e3
    });
    return {
        txId: txId,
        txResponse: txResponse
    };
}

});
parcelRegister("aKcLZ", function(module, exports) {
'use strict';

var $h2yUk = parcelRequire("h2yUk");

var $g0f7C = parcelRequire("g0f7C");
var $7d281bb894fee019$var$hasOwn = Object.prototype.hasOwnProperty;
function $7d281bb894fee019$var$isRetryError(err) {
    return err && err.code === 'EPROMISERETRY' && $7d281bb894fee019$var$hasOwn.call(err, 'retried');
}
function $7d281bb894fee019$var$promiseRetry(fn, options) {
    var temp;
    var operation;
    if (typeof fn === 'object' && typeof options === 'function') {
        // Swap options and fn when using alternate signature (options, fn)
        temp = options;
        options = fn;
        fn = temp;
    }
    operation = $g0f7C.operation(options);
    return new Promise(function(resolve, reject) {
        operation.attempt(function(number) {
            Promise.resolve().then(function() {
                return fn(function(err) {
                    if ($7d281bb894fee019$var$isRetryError(err)) err = err.retried;
                    throw $h2yUk(new Error('Retrying'), 'EPROMISERETRY', {
                        retried: err
                    });
                }, number);
            }).then(resolve, function(err) {
                if ($7d281bb894fee019$var$isRetryError(err)) {
                    err = err.retried;
                    if (operation.retry(err || new Error())) return;
                }
                reject(err);
            });
        });
    });
}
module.exports = $7d281bb894fee019$var$promiseRetry;

});
parcelRegister("h2yUk", function(module, exports) {
'use strict';
function $c67db3748fec4d45$var$assign(obj, props) {
    for(const key in props)Object.defineProperty(obj, key, {
        value: props[key],
        enumerable: true,
        configurable: true
    });
    return obj;
}
function $c67db3748fec4d45$var$createError(err, code, props) {
    if (!err || typeof err === 'string') throw new TypeError('Please pass an Error to err-code');
    if (!props) props = {};
    if (typeof code === 'object') {
        props = code;
        code = undefined;
    }
    if (code != null) props.code = code;
    try {
        return $c67db3748fec4d45$var$assign(err, props);
    } catch (_) {
        props.message = err.message;
        props.stack = err.stack;
        const ErrClass = function() {};
        ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
        return $c67db3748fec4d45$var$assign(new ErrClass(), props);
    }
}
module.exports = $c67db3748fec4d45$var$createError;

});

parcelRegister("g0f7C", function(module, exports) {

module.exports = (parcelRequire("hGTxg"));

});
parcelRegister("hGTxg", function(module, exports) {

var $5xJzM = parcelRequire("5xJzM");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $5xJzM(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("5xJzM", function(module, exports) {
function $40936345ce6e0a1c$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $40936345ce6e0a1c$var$RetryOperation;
$40936345ce6e0a1c$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$40936345ce6e0a1c$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$40936345ce6e0a1c$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$40936345ce6e0a1c$var$RetryOperation.prototype.start = $40936345ce6e0a1c$var$RetryOperation.prototype.try;
$40936345ce6e0a1c$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});





parcelRegister("kJ7Yx", function(module, exports) {

$parcel$export(module.exports, "simulateTransaction", function () { return $24e598c60511f55c$export$d7412238dc36647a; });
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $fULdq = parcelRequire("fULdq");
const $24e598c60511f55c$var$INSUFFICIENT_FUNDS_ERROR_CODE = 1;
const $24e598c60511f55c$var$SLIPPAGE_ERROR_CODE = 6001;
const $24e598c60511f55c$var$PROGRAM_FAILED_TO_COMPLETE_ERROR = 'ProgramFailedToComplete';
const $24e598c60511f55c$var$ACCOUNT_NOT_FOUND_ERROR = 'AccountNotFound';
async function $24e598c60511f55c$export$d7412238dc36647a(tx, type) {
    if (type === 'VERSIONED') {
        const connection = (0, $fULdq.getSolanaConnection)((0, $fULdq.getSolanaRpcNodes)().main);
        // We first simulate whether the transaction would be successful
        const { value: simulatedTransactionResponse } = await connection.simulateTransaction(tx, {
            replaceRecentBlockhash: true,
            commitment: 'processed'
        });
        const { err: err, logs: logs } = simulatedTransactionResponse;
        if (err) {
            /*
       * Simulation error, we can check the logs for more details
       * If you are getting an invalid account error, make sure that you have the input mint account to actually swap from.
       */ console.error('Simulation Error:', {
                err: err,
                logs: logs
            });
            throw $24e598c60511f55c$var$getSimulationError(err, logs);
        }
    }
}
function $24e598c60511f55c$var$getInsufficientFundsErrorMessage(logs) {
    const insufficientLamportErrorMessage = logs?.find((log)=>log.toLowerCase()?.includes('insufficient lamports'));
    return insufficientLamportErrorMessage || 'Insufficient funds';
}
function $24e598c60511f55c$var$getSimulationError(error, logs) {
    let message = (logs?.length || 0) > 0 ? logs?.[logs?.length - 1] : JSON.stringify(error);
    /*
   * trying to detect common errors (e.g. insufficient fund or slippage error)
   * We could probably remove this code after upgrading solana/web3 lib to v2
   */ if (typeof error === 'string') message = error === $24e598c60511f55c$var$ACCOUNT_NOT_FOUND_ERROR ? 'Attempt to debit an account but found no record of a prior credit.' : error;
    else {
        if (Array.isArray(error?.InstructionError) && error.InstructionError.length > 1) {
            const instructionError = error.InstructionError[1];
            if (typeof instructionError === 'object') switch(instructionError.Custom){
                case $24e598c60511f55c$var$INSUFFICIENT_FUNDS_ERROR_CODE:
                    message = $24e598c60511f55c$var$getInsufficientFundsErrorMessage(logs);
                    break;
                case $24e598c60511f55c$var$SLIPPAGE_ERROR_CODE:
                    message = 'Slippage error';
                    break;
                default:
                    break;
            }
            else if (instructionError === $24e598c60511f55c$var$PROGRAM_FAILED_TO_COMPLETE_ERROR) message = 'Program failed to complete';
        } else if (error?.InsufficientFundsForRent) message = 'Transaction results in an account with insufficient funds for rent.';
    }
    return new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SEND_TX_ERROR, undefined, `Simulation failed: ${message}`);
}

});



parcelRegister("6wsXt", function(module, exports) {

$parcel$export(module.exports, "executeSolanaTransaction", function () { return (parcelRequire("4tkSS")).executeSolanaTransaction; });
$parcel$export(module.exports, "generalSolanaTransactionExecutor", function () { return (parcelRequire("4tkSS")).generalSolanaTransactionExecutor; });
$parcel$export(module.exports, "prepareTransaction", function () { return (parcelRequire("gPoET")).prepareTransaction; });
$parcel$export(module.exports, "getSolanaConnection", function () { return (parcelRequire("fULdq")).getSolanaConnection; });
$parcel$export(module.exports, "getSolanaRpcNodes", function () { return (parcelRequire("fULdq")).getSolanaRpcNodes; });
$parcel$export(module.exports, "simulateTransaction", function () { return (parcelRequire("kJ7Yx")).simulateTransaction; });

var $4tkSS = parcelRequire("4tkSS");

var $gPoET = parcelRequire("gPoET");

var $fULdq = parcelRequire("fULdq");

var $kJ7Yx = parcelRequire("kJ7Yx");

});


parcelRegister("f6MG1", function(module, exports) {
module.exports = $parcel$import("619bN").then(()=>parcelRequire('90jyD'));

});

parcelRegister("dTrds", function(module, exports) {
"use strict";
var $a1d585f91ec8a1a3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAccount = void 0;

var $3zkAb = parcelRequire("3zkAb");

var $1cWJc = parcelRequire("1cWJc");
class $a1d585f91ec8a1a3$var$BaseAccount {
    static fetchFromRest(rest, address, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = false) {
        return $a1d585f91ec8a1a3$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (0, $1cWJc.simpleFetch)(rest, `/cosmos/auth/v1beta1/accounts/${address}`, {
                validateStatus: function(status) {
                    // Permit 404 not found to handle the case of account not exists
                    return status >= 200 && status < 300 || status === 404;
                }
            });
            return $a1d585f91ec8a1a3$var$BaseAccount.fromProtoJSON(result.data, defaultBech32Address ? address : "");
        });
    }
    static fromProtoJSON(obj, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = "") {
        if (!obj.account) {
            // Case of not existing account.
            // {
            //   "code": 5,
            //   "message": "rpc error: code = NotFound desc = account {address} not found: key not found",
            //   "details": [
            //   ]
            // }
            if (!defaultBech32Address) throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            return new $a1d585f91ec8a1a3$var$BaseAccount("", defaultBech32Address, new $3zkAb.Int(0), new $3zkAb.Int(0));
        }
        let value = obj.account;
        const type = value["@type"] || "";
        // If the chain modifies the account type, handle the case where the account type embeds the base account.
        // (Actually, the only existent case is ethermint, and this is the line for handling ethermint)
        const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
        if (baseAccount) value = baseAccount;
        // If the chain modifies the account type, handle the case where the account type embeds the account.
        // (Actually, the only existent case is desmos, and this is the line for handling desmos)
        const embedAccount = value.account;
        if (embedAccount) value = embedAccount;
        // If the account is the vesting account that embeds the base vesting account,
        // the actual base account exists under the base vesting account.
        // But, this can be different according to the version of cosmos-sdk.
        // So, anyway, try to parse it by some ways...
        const baseVestingAccount = value.BaseVestingAccount || value.baseVestingAccount || value.base_vesting_account;
        if (baseVestingAccount) {
            value = baseVestingAccount;
            const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
            if (baseAccount) value = baseAccount;
        }
        let address = value.address;
        if (!address) {
            if (!defaultBech32Address) throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            address = defaultBech32Address;
        }
        const accountNumber = value.account_number;
        const sequence = value.sequence;
        return new $a1d585f91ec8a1a3$var$BaseAccount(type, address, new $3zkAb.Int(accountNumber || "0"), new $3zkAb.Int(sequence || "0"));
    }
    constructor(type, address, accountNumber, sequence){
        this.type = type;
        this.address = address;
        this.accountNumber = accountNumber;
        this.sequence = sequence;
    }
    getType() {
        return this.type;
    }
    getAddress() {
        return this.address;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
    getSequence() {
        return this.sequence;
    }
}
module.exports.BaseAccount = $a1d585f91ec8a1a3$var$BaseAccount;

});
parcelRegister("3zkAb", function(module, exports) {
"use strict";
var $29949b4273e83309$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29949b4273e83309$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29949b4273e83309$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$29949b4273e83309$var$__exportStar((parcelRequire("iHEZr")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("alAPZ")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("4GgGj")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("9hZKW")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("cSmV0")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("k20Vo")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("hZyWy")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("cYm4M")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("fDbBK")), module.exports);

});
parcelRegister("iHEZr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntPretty = void 0;

var $9hZKW = parcelRequire("9hZKW");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");

var $k20Vo = parcelRequire("k20Vo");
class $d9dc09e80584e41f$var$IntPretty {
    constructor(num){
        this.floatingDecimalPointRight = 0;
        this._options = {
            maxDecimals: 0,
            trim: false,
            shrink: false,
            ready: true,
            locale: true,
            inequalitySymbol: false,
            inequalitySymbolSeparator: " "
        };
        if (typeof num === "object" && "toDec" in num) num = num.toDec();
        else if (!(num instanceof $cSmV0.Dec)) num = new $cSmV0.Dec(num);
        if (num.isZero()) {
            this.dec = num;
            return;
        }
        let dec = num;
        let decPrecision = 0;
        for(let i = 0; i < 18; i++){
            if (!dec.truncate().equals(new $9hZKW.Int(0)) && dec.equals(new $cSmV0.Dec(dec.truncate()))) break;
            dec = dec.mul(new $cSmV0.Dec(10));
            decPrecision++;
        }
        this.dec = num;
        this._options.maxDecimals = decPrecision;
    }
    get options() {
        return this._options;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += -delta;
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += delta;
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty._options.maxDecimals = max;
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty._options.inequalitySymbol = bool;
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty._options.inequalitySymbolSeparator = str;
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty._options.trim = bool;
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty._options.shrink = bool;
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty._options.ready = bool;
        return pretty;
    }
    get isReady() {
        return this._options.ready;
    }
    add(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().add(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    sub(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().sub(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    mul(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().mul(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    quo(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().quo(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    toDec() {
        if (this.floatingDecimalPointRight === 0) return this.dec;
        else if (this.floatingDecimalPointRight > 0) return this.dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(this.floatingDecimalPointRight));
        else {
            // Since a decimal in Dec cannot exceed 18, it cannot be computed at once.
            let i = -this.floatingDecimalPointRight;
            let dec = this.dec;
            while(i > 0)if (i >= $cSmV0.Dec.precision) {
                dec = dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(-$cSmV0.Dec.precision));
                i -= $cSmV0.Dec.precision;
            } else {
                dec = dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(-(i % $cSmV0.Dec.precision)));
                break;
            }
            return dec;
        }
    }
    toString() {
        return this.toStringWithSymbols("", "");
    }
    toStringWithSymbols(prefix, suffix) {
        const dec = this.toDec();
        if (this._options.inequalitySymbol && !dec.isZero() && dec.abs().lt($hZyWy.DecUtils.getTenExponentN(-this._options.maxDecimals))) {
            const isNeg = dec.isNegative();
            return `${isNeg ? ">" : "<"}${this._options.inequalitySymbolSeparator}${isNeg ? "-" : ""}${prefix}${$hZyWy.DecUtils.getTenExponentN(-this._options.maxDecimals).toString(this._options.maxDecimals, this._options.locale)}${suffix}`;
        }
        let result;
        if (!this._options.shrink) result = dec.toString(this._options.maxDecimals, this._options.locale);
        else result = $k20Vo.CoinUtils.shrinkDecimals(dec, 0, this._options.maxDecimals, this._options.locale);
        if (this._options.trim) result = $hZyWy.DecUtils.trim(result);
        const isNeg = result.charAt(0) === "-";
        if (isNeg) result = result.slice(1);
        return `${isNeg ? "-" : ""}${prefix}${result}${suffix}`;
    }
    clone() {
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.dec);
        pretty.dec = this.dec;
        pretty.floatingDecimalPointRight = this.floatingDecimalPointRight;
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
}
module.exports.IntPretty = $d9dc09e80584e41f$var$IntPretty;

});
parcelRegister("9hZKW", function(module, exports) {
"use strict";
var $6c359b125abde327$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint = module.exports.Int = void 0;

const $6c359b125abde327$var$big_integer_1 = $6c359b125abde327$var$__importDefault((parcelRequire("8w8wf")));

var $a8WWN = parcelRequire("a8WWN");
class $6c359b125abde327$var$Int {
    /**
     * @param int - Parse a number | bigInteger | string into a bigInt.
     */ constructor(int){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (!(0, $a8WWN.isValidIntegerString)(int)) {
                if ((0, $a8WWN.isExponentDecString)(int)) int = (0, $a8WWN.exponentDecStringToDecString)(int);
                else throw new Error(`invalid integer: ${int}`);
            }
            this.int = (0, $6c359b125abde327$var$big_integer_1.default)(int);
        } else if (typeof int === "bigint") this.int = (0, $6c359b125abde327$var$big_integer_1.default)(int);
        else this.int = (0, $6c359b125abde327$var$big_integer_1.default)(int);
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.int.abs().gt($6c359b125abde327$var$Int.maxInt)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    toString() {
        return this.int.toString(10);
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    isZero() {
        return this.int.eq((0, $6c359b125abde327$var$big_integer_1.default)(0));
    }
    equals(i) {
        return this.int.equals(i.int);
    }
    gt(i) {
        return this.int.gt(i.int);
    }
    gte(i) {
        return this.int.greaterOrEquals(i.int);
    }
    lt(i) {
        return this.int.lt(i.int);
    }
    lte(i) {
        return this.int.lesserOrEquals(i.int);
    }
    abs() {
        return new $6c359b125abde327$var$Int(this.int.abs());
    }
    absUInt() {
        return new $6c359b125abde327$var$Uint(this.int.abs());
    }
    add(i) {
        return new $6c359b125abde327$var$Int(this.int.add(i.int));
    }
    sub(i) {
        return new $6c359b125abde327$var$Int(this.int.subtract(i.int));
    }
    mul(i) {
        return new $6c359b125abde327$var$Int(this.int.multiply(i.int));
    }
    div(i) {
        return new $6c359b125abde327$var$Int(this.int.divide(i.int));
    }
    mod(i) {
        return new $6c359b125abde327$var$Int(this.int.mod(i.int));
    }
    neg() {
        return new $6c359b125abde327$var$Int(this.int.negate());
    }
    pow(i) {
        return new $6c359b125abde327$var$Int(this.int.pow(i.toBigNumber()));
    }
    toBigNumber() {
        return this.int;
    }
}
module.exports.Int = $6c359b125abde327$var$Int;
// (2 ** 256) - 1
$6c359b125abde327$var$Int.maxInt = (0, $6c359b125abde327$var$big_integer_1.default)("115792089237316195423570985008687907853269984665640564039457584007913129639935");
class $6c359b125abde327$var$Uint {
    /**
     * @param uint - Parse a number | bigInteger | string into a bigUint.
     */ constructor(uint){
        if (typeof uint === "number") uint = uint.toString();
        if (typeof uint === "string") {
            if (!(0, $a8WWN.isValidIntegerString)(uint)) {
                if ((0, $a8WWN.isExponentDecString)(uint)) uint = (0, $a8WWN.exponentDecStringToDecString)(uint);
                else throw new Error(`invalid integer: ${uint}`);
            }
            this.uint = (0, $6c359b125abde327$var$big_integer_1.default)(uint);
        } else if (typeof uint === "bigint") this.uint = (0, $6c359b125abde327$var$big_integer_1.default)(uint);
        else this.uint = (0, $6c359b125abde327$var$big_integer_1.default)(uint);
        if (this.uint.isNegative()) throw new TypeError("Uint should not be negative");
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.uint.abs().bitLength().gt(256)) throw new Error(`Integer out of range ${this.uint.toString()}`);
    }
    toString() {
        return this.uint.toString(10);
    }
    isZero() {
        return this.uint.eq((0, $6c359b125abde327$var$big_integer_1.default)(0));
    }
    equals(i) {
        return this.uint.equals(i.uint);
    }
    gt(i) {
        return this.uint.gt(i.uint);
    }
    gte(i) {
        return this.uint.greaterOrEquals(i.uint);
    }
    lt(i) {
        return this.uint.lt(i.uint);
    }
    lte(i) {
        return this.uint.lesserOrEquals(i.uint);
    }
    add(i) {
        return new $6c359b125abde327$var$Uint(this.uint.add(i.uint));
    }
    sub(i) {
        return new $6c359b125abde327$var$Uint(this.uint.subtract(i.uint));
    }
    mul(i) {
        return new $6c359b125abde327$var$Uint(this.uint.multiply(i.uint));
    }
    div(i) {
        return new $6c359b125abde327$var$Uint(this.uint.divide(i.uint));
    }
    mod(i) {
        return new $6c359b125abde327$var$Uint(this.uint.mod(i.uint));
    }
    pow(i) {
        return new $6c359b125abde327$var$Uint(this.uint.pow(i.toBigNumber()));
    }
    toBigNumber() {
        return this.uint;
    }
}
module.exports.Uint = $6c359b125abde327$var$Uint;

});
parcelRegister("8w8wf", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
    var supportsNativeBigInt = typeof BigInt === "function";
    function Integer(v, radix, alphabet, caseSensitive) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function NativeBigInt(value) {
        this.value = value;
    }
    NativeBigInt.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    NativeBigInt.prototype.add = function(v) {
        return new NativeBigInt(this.value + parseValue(v).value);
    };
    NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    NativeBigInt.prototype.subtract = function(v) {
        return new NativeBigInt(this.value - parseValue(v).value);
    };
    NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    NativeBigInt.prototype.negate = function() {
        return new NativeBigInt(-this.value);
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    NativeBigInt.prototype.abs = function() {
        return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    NativeBigInt.prototype.multiply = function(v) {
        return new NativeBigInt(this.value * parseValue(v).value);
    };
    NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    NativeBigInt.prototype.square = function(v) {
        return new NativeBigInt(this.value * this.value);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        if (supportsNativeBigInt) return [
            new NativeBigInt(self.value / n.value),
            new NativeBigInt(self.value % n.value)
        ];
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
        return new NativeBigInt(this.value / parseValue(v).value);
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
        return new NativeBigInt(this.value % parseValue(v).value);
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    NativeBigInt.prototype.pow = function(v) {
        var n = parseValue(v);
        var a = this.value, b = n.value;
        var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
        if (b === _0) return Integer[1];
        if (a === _0) return Integer[0];
        if (a === _1) return Integer[1];
        if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.isNegative()) return new NativeBigInt(_0);
        var x = this;
        var y = Integer[1];
        while(true){
            if ((b & _1) === _1) {
                y = y.times(x);
                --b;
            }
            if (b === _0) break;
            b /= _2;
            x = x.square();
        }
        return y;
    };
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        if (exp.isNegative()) {
            exp = exp.multiply(Integer[-1]);
            base = base.modInv(mod);
        }
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    NativeBigInt.prototype.compareAbs = function(v) {
        var a = this.value;
        var b = parseValue(v).value;
        a = a >= 0 ? a : -a;
        b = b >= 0 ? b : -b;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    NativeBigInt.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var a = this.value;
        var b = parseValue(v).value;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    NativeBigInt.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    NativeBigInt.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    NativeBigInt.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    NativeBigInt.prototype.isZero = function() {
        return this.value === BigInt(0);
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        if (n.isZero()) return false;
        if (n.isUnit()) return true;
        if (n.compareAbs(2) === 0) return this.isEven();
        return this.mod(n).isZero();
    };
    NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.isUnit() || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37
        ]);
        var logN = Math.log(2) * bits.toJSNumber();
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations, rng) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.isZero()){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    NativeBigInt.prototype.next = function() {
        return new NativeBigInt(this.value + BigInt(1));
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    NativeBigInt.prototype.prev = function() {
        return new NativeBigInt(this.value - BigInt(1));
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return Math.abs(n) <= BASE;
    }
    BigInteger.prototype.shiftLeft = function(v) {
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(v) {
        var remQuo;
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b, rng) {
        a = parseValue(a);
        b = parseValue(b);
        var usedRNG = rng || Math.random;
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
        var digits = toBase(range, BASE).value;
        var result = [], restricted = true;
        for(var i = 0; i < digits.length; i++){
            var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
            var digit = truncate(usedRNG() * top);
            result.push(digit);
            if (digit < digits[i]) restricted = false;
        }
        return low.add(Integer.fromArray(result, BASE, false));
    }
    var parseBase = function(text, base, alphabet, caseSensitive) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        text = String(text);
        if (!caseSensitive) {
            text = text.toLowerCase();
            alphabet = alphabet.toLowerCase();
        }
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        var alphabetValues = {};
        for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
        for(i = 0; i < length; i++){
            var c = text[i];
            if (c === "-") continue;
            if (c in alphabetValues) {
                if (alphabetValues[c] >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                }
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i];
            if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">" && i < text.length);
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit, alphabet) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        if (digit < alphabet.length) return alphabet[digit];
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.isUnit()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base, alphabet) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
            return stringify(x, alphabet);
        }).join('');
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    NativeBigInt.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
        return String(this.value);
    };
    NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
    NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
    };
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        if (typeof v === "bigint") return new NativeBigInt(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = parseValue(i);
        if (i > 0) Integer[-i] = parseValue(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define(function() {
    return bigInt;
});

});

parcelRegister("a8WWN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exponentDecStringToDecString = module.exports.isExponentDecString = module.exports.isValidDecimalString = module.exports.isValidIntegerString = void 0;
const $7628606d84f7b13d$var$regexIntString = /^-?\d+$/;
const $7628606d84f7b13d$var$regexDecString = /^-?\d+.?\d*$/;
const $7628606d84f7b13d$var$regexExponentDecString = /^(-?)([\d.]+)e([-+])([\d]+)$/;
function $7628606d84f7b13d$var$isValidIntegerString(str) {
    return $7628606d84f7b13d$var$regexIntString.test(str);
}
module.exports.isValidIntegerString = $7628606d84f7b13d$var$isValidIntegerString;
function $7628606d84f7b13d$var$isValidDecimalString(str) {
    return $7628606d84f7b13d$var$regexDecString.test(str);
}
module.exports.isValidDecimalString = $7628606d84f7b13d$var$isValidDecimalString;
function $7628606d84f7b13d$var$isExponentDecString(str) {
    return $7628606d84f7b13d$var$regexExponentDecString.test(str);
}
module.exports.isExponentDecString = $7628606d84f7b13d$var$isExponentDecString;
function $7628606d84f7b13d$var$makeZerosStr(len) {
    let r = "";
    for(let i = 0; i < len; i++)r += "0";
    return r;
}
function $7628606d84f7b13d$var$removeHeadZeros(str) {
    while(str.length > 0 && str[0] === "0")str = str.slice(1);
    if (str.length === 0 || str[0] === ".") return "0" + str;
    return str;
}
function $7628606d84f7b13d$var$exponentDecStringToDecString(str) {
    const split = str.split($7628606d84f7b13d$var$regexExponentDecString);
    if (split.length !== 6) return str;
    const isNeg = split[1] === "-";
    let numStr = split[2];
    const numStrFractionIndex = numStr.indexOf(".");
    const exponentStr = split[4];
    let exponent = parseInt(exponentStr) * (split[3] === "-" ? -1 : 1);
    if (numStrFractionIndex >= 0) {
        const fractionLen = numStr.length - numStrFractionIndex - 1;
        exponent = exponent - fractionLen;
        numStr = $7628606d84f7b13d$var$removeHeadZeros(numStr.replace(".", ""));
    }
    const prefix = isNeg ? "-" : "";
    if (exponent < 0) {
        if (numStr.length > -exponent) {
            const fractionPosition = numStr.length + exponent;
            return prefix + (numStr.slice(0, fractionPosition) + "." + numStr.slice(fractionPosition));
        }
        return prefix + "0." + $7628606d84f7b13d$var$makeZerosStr(-(numStr.length + exponent)) + numStr;
    } else return prefix + numStr + $7628606d84f7b13d$var$makeZerosStr(exponent);
}
module.exports.exponentDecStringToDecString = $7628606d84f7b13d$var$exponentDecStringToDecString;

});


parcelRegister("cSmV0", function(module, exports) {
"use strict";
var $95fc4e4e6117eb7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dec = void 0;

const $95fc4e4e6117eb7b$var$big_integer_1 = $95fc4e4e6117eb7b$var$__importDefault((parcelRequire("8w8wf")));

var $9hZKW = parcelRequire("9hZKW");

var $a8WWN = parcelRequire("a8WWN");

var $eVpIe = parcelRequire("eVpIe");
class $95fc4e4e6117eb7b$var$Dec {
    static calcPrecisionMultiplier(prec) {
        if (prec < 0) throw new Error("Invalid prec");
        if (prec > $95fc4e4e6117eb7b$var$Dec.precision) throw new Error("Too much precision");
        const key = prec.toString();
        const cached = $95fc4e4e6117eb7b$var$Dec.precisionMultipliers.get(key);
        if (cached) return cached;
        const zerosToAdd = $95fc4e4e6117eb7b$var$Dec.precision - prec;
        const multiplier = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)(10).pow(zerosToAdd);
        $95fc4e4e6117eb7b$var$Dec.precisionMultipliers.set(key, multiplier);
        return multiplier;
    }
    static reduceDecimalsFromString(str) {
        const decimalPointIndex = str.indexOf(".");
        if (decimalPointIndex < 0) return {
            res: str,
            isDownToZero: false
        };
        const exceededDecimals = str.length - 1 - decimalPointIndex - $95fc4e4e6117eb7b$var$Dec.precision;
        if (exceededDecimals <= 0) return {
            res: str,
            isDownToZero: false
        };
        const res = str.slice(0, str.length - exceededDecimals);
        return {
            res: res,
            isDownToZero: /^[0.]*$/.test(res)
        };
    }
    /**
     * Create a new Dec from integer with decimal place at prec
     * @param int - Parse a number | bigInteger | string into a Dec.
     * If int is string and contains dot(.), prec is ignored and automatically calculated.
     * @param prec - Precision
     */ constructor(int, prec = 0){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (int.length === 0) throw new Error("empty string");
            if (!(0, $a8WWN.isValidDecimalString)(int)) {
                if ((0, $a8WWN.isExponentDecString)(int)) int = (0, $a8WWN.exponentDecStringToDecString)(int);
                else throw new Error(`invalid decimal: ${int}`);
            }
            // Even if an input with more than 18 decimals, it does not throw an error and ignores the rest.
            const reduced = $95fc4e4e6117eb7b$var$Dec.reduceDecimalsFromString(int);
            if (reduced.isDownToZero) // However, as a result, if the input becomes 0, a problem may occur in mul or quo. In this case, print a warning.
            console.log(`WARNING: Got ${int}. Dec can only handle up to 18 decimals. However, since the decimal point of the input exceeds 18 digits, the remainder is discarded. As a result, input becomes 0.`);
            int = reduced.res;
            if (int.indexOf(".") >= 0) {
                prec = int.length - int.indexOf(".") - 1;
                int = int.replace(".", "");
            }
            this.int = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)(int);
        } else if (int instanceof $9hZKW.Int) this.int = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)(int.toString());
        else if (int instanceof $9hZKW.Uint) this.int = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)(int.toString());
        else if (typeof int === "bigint") this.int = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)(int);
        else this.int = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)(int);
        this.int = this.int.multiply($95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(prec));
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.int.abs().gt($95fc4e4e6117eb7b$var$Dec.maxDec)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    isZero() {
        return this.int.eq((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(0));
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    equals(d2) {
        return this.int.eq(d2.int);
    }
    /**
     * Alias for the greater method.
     */ gt(d2) {
        return this.int.gt(d2.int);
    }
    /**
     * Alias for the greaterOrEquals method.
     */ gte(d2) {
        return this.int.geq(d2.int);
    }
    /**
     * Alias for the lesser method.
     */ lt(d2) {
        return this.int.lt(d2.int);
    }
    /**
     * Alias for the lesserOrEquals method.
     */ lte(d2) {
        return this.int.leq(d2.int);
    }
    /**
     * reverse the decimal sign.
     */ neg() {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.negate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    /**
     * Returns the absolute value of a decimals.
     */ abs() {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.abs(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    add(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.add(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    sub(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.subtract(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    pow(n) {
        if (n.isZero()) return new $95fc4e4e6117eb7b$var$Dec(1);
        if (n.isNegative()) return new $95fc4e4e6117eb7b$var$Dec(1).quo(this.pow(n.abs()));
        let base = new $95fc4e4e6117eb7b$var$Dec(this.int, $95fc4e4e6117eb7b$var$Dec.precision);
        let tmp = new $95fc4e4e6117eb7b$var$Dec(1);
        for(let i = n; i.gt(new $9hZKW.Int(1)); i = i.div(new $9hZKW.Int(2))){
            if (!i.mod(new $9hZKW.Int(2)).isZero()) tmp = tmp.mul(base);
            base = base.mul(base);
        }
        return base.mul(tmp);
    }
    approxSqrt() {
        return this.approxRoot(2);
    }
    approxRoot(root, maxIters = 300) {
        if (this.isNegative()) return this.neg().approxRoot(root).neg();
        if (root === 1 || this.isZero() || this.equals($95fc4e4e6117eb7b$var$Dec.one)) return this;
        if (root === 0) return $95fc4e4e6117eb7b$var$Dec.one;
        let [guess, delta] = [
            $95fc4e4e6117eb7b$var$Dec.one,
            $95fc4e4e6117eb7b$var$Dec.one
        ];
        for(let i = 0; delta.abs().gt($95fc4e4e6117eb7b$var$Dec.smallestDec) && i < maxIters; i++){
            let prev = guess.pow(new $9hZKW.Int(root - 1));
            if (prev.isZero()) prev = $95fc4e4e6117eb7b$var$Dec.smallestDec;
            delta = this.quo(prev);
            delta = delta.sub(guess);
            delta = delta.quoTruncate(new $95fc4e4e6117eb7b$var$Dec(root));
            guess = guess.add(delta);
        }
        return guess;
    }
    mul(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndRound(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulTruncate(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndTruncate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulRoundUp(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndRoundUp(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulRaw(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.multiply(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quo(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndRound(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoTruncate(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndTruncate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoRoundUp(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndRoundUp(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoRaw(d2) {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        // multiply precision twice
        const mul = this.int.multiply(precision).multiply(precision);
        return new $95fc4e4e6117eb7b$var$Dec(mul.divide(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    isInteger() {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        return this.int.remainder(precision).equals((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(0));
    }
    /**
     * Remove a Precision amount of rightmost digits and perform bankers rounding
     * on the remainder (gaussian rounding) on the digits which have been removed.
     */ chopPrecisionAndRound() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            const choped = absoulteDec.chopPrecisionAndRound();
            return choped.negate();
        }
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        const fivePrecision = precision.divide((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(2));
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(0))) return quotient;
        if (remainder.lt(fivePrecision)) return quotient;
        else if (remainder.gt(fivePrecision)) return quotient.add((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(1));
        else {
            // always round to an even number
            if (quotient.divide((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(2)).equals((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(0))) return quotient;
            else return quotient.add((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(1));
        }
    }
    chopPrecisionAndRoundUp() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            // truncate since d is negative...
            const choped = absoulteDec.chopPrecisionAndTruncate();
            return choped.negate();
        }
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(0))) return quotient;
        return quotient.add((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(1));
    }
    /**
     * Similar to chopPrecisionAndRound, but always rounds down
     */ chopPrecisionAndTruncate() {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        return this.int.divide(precision);
    }
    toString(prec = $95fc4e4e6117eb7b$var$Dec.precision, locale = false) {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        const int = this.int.abs();
        const { quotient: integer, remainder: fraction } = int.divmod(precision);
        let fractionStr = fraction.toString(10);
        for(let i = 0, l = fractionStr.length; i < $95fc4e4e6117eb7b$var$Dec.precision - l; i++)fractionStr = "0" + fractionStr;
        fractionStr = fractionStr.substring(0, prec);
        const isNegative = this.isNegative() && !(integer.eq((0, $95fc4e4e6117eb7b$var$big_integer_1.default)(0)) && fractionStr.length === 0);
        const integerStr = locale ? (0, $eVpIe.integerStringToUSLocaleString)(integer.toString()) : integer.toString();
        return `${isNegative ? "-" : ""}${integerStr}${fractionStr.length > 0 ? "." + fractionStr : ""}`;
    }
    round() {
        return new $9hZKW.Int(this.chopPrecisionAndRound());
    }
    roundUp() {
        return new $9hZKW.Int(this.chopPrecisionAndRoundUp());
    }
    truncate() {
        return new $9hZKW.Int(this.chopPrecisionAndTruncate());
    }
    roundDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndRound(), 0);
    }
    roundUpDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndRoundUp(), 0);
    }
    truncateDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndTruncate(), 0);
    }
}
module.exports.Dec = $95fc4e4e6117eb7b$var$Dec;
$95fc4e4e6117eb7b$var$Dec.precision = 18;
// Bytes required to represent the above precision is 18.
// Ceiling[Log2[999 999 999 999 999 999]]
$95fc4e4e6117eb7b$var$Dec.decimalPrecisionBits = 60;
// Max bit length for `Dec` is 256 + 60(decimalPrecisionBits)
// The int in the `Dec` is handled as integer assuming that it has 18 precision.
// (2 ** (256 + 60) - 1)
$95fc4e4e6117eb7b$var$Dec.maxDec = (0, $95fc4e4e6117eb7b$var$big_integer_1.default)("133499189745056880149688856635597007162669032647290798121690100488888732861290034376435130433535");
$95fc4e4e6117eb7b$var$Dec.precisionMultipliers = new Map();
$95fc4e4e6117eb7b$var$Dec.zero = new $95fc4e4e6117eb7b$var$Dec(0);
/** Smallest `Dec` with current precision. */ $95fc4e4e6117eb7b$var$Dec.smallestDec = new $95fc4e4e6117eb7b$var$Dec("1", $95fc4e4e6117eb7b$var$Dec.precision);
$95fc4e4e6117eb7b$var$Dec.one = new $95fc4e4e6117eb7b$var$Dec(1);
$9hZKW.Int.prototype.toDec = function() {
    return new $95fc4e4e6117eb7b$var$Dec(this);
};
$9hZKW.Uint.prototype.toDec = function() {
    return new $95fc4e4e6117eb7b$var$Dec(this);
};

});
parcelRegister("eVpIe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.integerStringToUSLocaleString = void 0;
/**
 * Change the non-locale integer string to locale string.
 * Only support en-US format.
 * This method uses the BigInt if the environment supports the BigInt.
 * @param numberStr
 */ function $adda557d20a69629$var$integerStringToUSLocaleString(numberStr) {
    if (numberStr.indexOf(".") >= 0) throw new Error(`${numberStr} is not integer`);
    if (typeof BigInt !== "undefined") return BigInt(numberStr).toLocaleString("en-US");
    const integer = numberStr;
    const chunks = [];
    for(let i = integer.length; i > 0; i -= 3)chunks.push(integer.slice(Math.max(0, i - 3), i));
    return chunks.reverse().join(",");
}
module.exports.integerStringToUSLocaleString = $adda557d20a69629$var$integerStringToUSLocaleString;

});


parcelRegister("hZyWy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecUtils = void 0;

var $cSmV0 = parcelRequire("cSmV0");

var $9hZKW = parcelRequire("9hZKW");
class $d1933d2f9e6ea493$var$DecUtils {
    static trim(dec) {
        let decStr = typeof dec === "string" ? dec : dec.toString();
        if (decStr.indexOf(".") < 0) return decStr;
        for(let i = decStr.length - 1; i >= 0; i--){
            if (decStr[i] === "0") decStr = decStr.slice(0, i);
            else break;
        }
        if (decStr.length > 0) {
            if (decStr[decStr.length - 1] === ".") decStr = decStr.slice(0, decStr.length - 1);
        }
        return decStr;
    }
    static getTenExponentN(n) {
        if (n < -$cSmV0.Dec.precision) // Dec can only handle up to precision 18.
        // Anything less than 18 precision is 0, so there is a high probability of an error.
        throw new Error("Too little precision");
        if ($d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()]) return $d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()];
        const dec = new $cSmV0.Dec(10).pow(new $9hZKW.Int(n));
        $d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()] = dec;
        return dec;
    }
    static getTenExponentNInPrecisionRange(n) {
        if (n > $cSmV0.Dec.precision) throw new Error("Too much precision");
        return $d1933d2f9e6ea493$var$DecUtils.getTenExponentN(n);
    }
    /**
     * @deprecated Use`getTenExponentNInPrecisionRange`
     */ static getPrecisionDec(precision) {
        return $d1933d2f9e6ea493$var$DecUtils.getTenExponentNInPrecisionRange(precision);
    }
}
module.exports.DecUtils = $d1933d2f9e6ea493$var$DecUtils;
$d1933d2f9e6ea493$var$DecUtils.tenExponentNs = {};

});

parcelRegister("k20Vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinUtils = void 0;

var $4GgGj = parcelRequire("4GgGj");

var $9hZKW = parcelRequire("9hZKW");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");

var $eVpIe = parcelRequire("eVpIe");
class $e954b62c02afd604$var$CoinUtils {
    static createCoinsFromPrimitives(coinPrimitives) {
        return coinPrimitives.map((primitive)=>{
            return new $4GgGj.Coin(primitive.denom, primitive.amount);
        });
    }
    static amountOf(coins, denom) {
        const coin = coins.find((coin)=>{
            return coin.denom === denom;
        });
        if (!coin) return new $9hZKW.Int(0);
        else return coin.amount;
    }
    static exclude(coins, demons) {
        return coins.filter((coin)=>{
            return demons.indexOf(coin.denom) === 0;
        });
    }
    static concat(...coins) {
        if (coins.length === 0) return [];
        const arr = coins.slice();
        const reducer = (accumulator, coin)=>{
            // Find the duplicated denom.
            const find = accumulator.find((c)=>c.denom === coin.denom);
            // If duplicated coin exists, add the amount to duplicated one.
            if (find) {
                const newCoin = new $4GgGj.Coin(find.denom, find.amount.add(coin.amount));
                accumulator.push(newCoin);
            } else {
                const newCoin = new $4GgGj.Coin(coin.denom, coin.amount);
                accumulator.push(newCoin);
            }
            return accumulator;
        };
        return arr.reduce(reducer, []);
    }
    static getCoinFromDecimals(currencies, decAmountStr, denom) {
        const currency = currencies.find((currency)=>{
            return currency.coinDenom === denom;
        });
        if (!currency) throw new Error("Invalid currency");
        let precision = new $cSmV0.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $cSmV0.Dec(10));
        let decAmount = new $cSmV0.Dec(decAmountStr);
        decAmount = decAmount.mul(precision);
        if (!new $cSmV0.Dec(decAmount.truncate()).equals(decAmount)) throw new Error("Can't divide anymore");
        return new $4GgGj.Coin(currency.coinMinimalDenom, decAmount.truncate());
    }
    static parseDecAndDenomFromCoin(currencies, coin) {
        let currency = currencies.find((currency)=>{
            return currency.coinMinimalDenom === coin.denom;
        });
        if (!currency) // If the currency is unknown, just use the raw currency.
        currency = {
            coinDecimals: 0,
            coinDenom: coin.denom,
            coinMinimalDenom: coin.denom
        };
        let precision = new $cSmV0.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $cSmV0.Dec(10));
        const decAmount = new $cSmV0.Dec(coin.amount).quoTruncate(precision);
        return {
            amount: decAmount.toString(currency.coinDecimals),
            denom: currency.coinDenom
        };
    }
    static shrinkDecimals(dec, minDecimals, maxDecimals, locale = false) {
        if (dec.equals(new $cSmV0.Dec(0))) return "0";
        const isNeg = dec.isNegative();
        const integer = dec.abs().truncate();
        const fraction = dec.abs().sub(new $cSmV0.Dec(integer));
        const decimals = Math.max(maxDecimals - integer.toString().length + 1, minDecimals);
        const fractionStr = decimals === 0 ? "" : fraction.toString(decimals).replace("0.", "");
        const integerStr = locale ? $e954b62c02afd604$var$CoinUtils.integerStringToUSLocaleString(integer.toString()) : integer.toString();
        return (isNeg ? "-" : "") + integerStr + (fractionStr.length > 0 ? "." : "") + fractionStr;
    }
    static coinToTrimmedString(coin, currency, separator = " ") {
        const dec = new $cSmV0.Dec(coin.amount).quoTruncate($hZyWy.DecUtils.getPrecisionDec(currency.coinDecimals));
        return `${$hZyWy.DecUtils.trim(dec)}${separator}${currency.coinDenom}`;
    }
}
module.exports.CoinUtils = $e954b62c02afd604$var$CoinUtils;
$e954b62c02afd604$var$CoinUtils.integerStringToUSLocaleString = $eVpIe.integerStringToUSLocaleString;

});
parcelRegister("4GgGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Coin = void 0;

var $9hZKW = parcelRequire("9hZKW");
class $36880644d09b865b$var$Coin {
    static parse(str) {
        const re = new RegExp("([0-9]+)[ ]*([a-zA-Z]+)$");
        const execed = re.exec(str);
        if (!execed || execed.length !== 3) throw new Error("Invalid coin str");
        const denom = execed[2];
        const amount = execed[1];
        return new $36880644d09b865b$var$Coin(denom, amount);
    }
    constructor(denom, amount){
        this.denom = denom;
        this.amount = amount instanceof $9hZKW.Int ? amount : new $9hZKW.Int(amount);
    }
    toString() {
        return `${this.amount.toString()}${this.denom}`;
    }
}
module.exports.Coin = $36880644d09b865b$var$Coin;

});



parcelRegister("alAPZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinPretty = void 0;

var $iHEZr = parcelRequire("iHEZr");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");
class $788870baa7f882d3$var$CoinPretty {
    constructor(_currency, amount){
        this._currency = _currency;
        this._options = {
            separator: " ",
            upperCase: false,
            lowerCase: false,
            hideDenom: false,
            hideIBCMetadata: false
        };
        if (typeof amount === "object" && "toDec" in amount) amount = amount.toDec();
        else if (!(amount instanceof $cSmV0.Dec)) amount = new $cSmV0.Dec(amount);
        this.intPretty = new $iHEZr.IntPretty(amount.quoTruncate($hZyWy.DecUtils.getTenExponentNInPrecisionRange(_currency.coinDecimals))).maxDecimals(_currency.coinDecimals);
    }
    get options() {
        return Object.assign(Object.assign({}, this._options), this.intPretty.options);
    }
    get denom() {
        return this.currency.coinDenom;
    }
    get currency() {
        return this._currency;
    }
    setCurrency(currency) {
        const pretty = this.clone();
        pretty.intPretty = this.intPretty.moveDecimalPointRight(this._currency.coinDecimals - currency.coinDecimals);
        pretty._currency = currency;
        return pretty;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    hideDenom(bool) {
        const pretty = this.clone();
        pretty._options.hideDenom = bool;
        return pretty;
    }
    hideIBCMetadata(bool) {
        const pretty = this.clone();
        pretty._options.hideIBCMetadata = bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const isCoinPretty = target instanceof $788870baa7f882d3$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(isCoinPretty ? target : target.mul($hZyWy.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    sub(target) {
        const isCoinPretty = target instanceof $788870baa7f882d3$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(isCoinPretty ? target : target.mul($hZyWy.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toCoin() {
        const amount = this.toDec().mulTruncate($hZyWy.DecUtils.getTenExponentNInPrecisionRange(this.currency.coinDecimals)).truncate();
        return {
            denom: this.currency.coinMinimalDenom,
            amount: amount.toString()
        };
    }
    toString() {
        let denom = this.denom;
        if (this._options.hideIBCMetadata && "originCurrency" in this.currency && this.currency.originCurrency) denom = this.currency.originCurrency.coinDenom;
        if (this._options.upperCase) denom = denom.toUpperCase();
        if (this._options.lowerCase) denom = denom.toLowerCase();
        let separator = this._options.separator;
        if (this._options.hideDenom) {
            denom = "";
            separator = "";
        }
        return this.intPretty.toStringWithSymbols("", `${separator}${denom}`);
    }
    clone() {
        const pretty = new $788870baa7f882d3$var$CoinPretty(this._currency, 0);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.CoinPretty = $788870baa7f882d3$var$CoinPretty;

});

parcelRegister("cYm4M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricePretty = void 0;

var $iHEZr = parcelRequire("iHEZr");

var $hZyWy = parcelRequire("hZyWy");
class $971c367a20613f18$var$PricePretty {
    constructor(_fiatCurrency, amount){
        this._fiatCurrency = _fiatCurrency;
        this._options = {
            separator: "",
            upperCase: false,
            lowerCase: false,
            locale: "en-US"
        };
        this.intPretty = new $iHEZr.IntPretty(amount).maxDecimals(_fiatCurrency.maxDecimals).shrink(true).trim(true).locale(false).inequalitySymbol(true);
        this._options.locale = _fiatCurrency.locale;
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    get symbol() {
        return this._fiatCurrency.symbol;
    }
    get fiatCurrency() {
        return this._fiatCurrency;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        let symbol = this.symbol;
        if (this._options.upperCase) symbol = symbol.toUpperCase();
        if (this._options.lowerCase) symbol = symbol.toLowerCase();
        const dec = this.toDec();
        const options = this.options;
        if (options.inequalitySymbol && !dec.isZero() && dec.abs().lt($hZyWy.DecUtils.getTenExponentN(-options.maxDecimals))) return this.intPretty.toStringWithSymbols(`${symbol}${this._options.separator}`, "");
        let localeString = parseFloat(this.intPretty.toString()).toLocaleString(options.locale, {
            maximumFractionDigits: options.maxDecimals
        });
        const isNeg = localeString.charAt(0) === "-";
        if (isNeg) localeString = localeString.slice(1);
        return `${isNeg ? "-" : ""}${symbol}${this._options.separator}${localeString}`;
    }
    clone() {
        const pretty = new $971c367a20613f18$var$PricePretty(this._fiatCurrency, 0);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.PricePretty = $971c367a20613f18$var$PricePretty;

});

parcelRegister("fDbBK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RatePretty = void 0;

var $iHEZr = parcelRequire("iHEZr");
/**
 * RatePretty treats `Dec` in rate form for easy calculation, and displays it as a percentage to the user by using toString().
 * By default, if the value is less than maxDeciamls, it is displayed using an inequality sign (Ex. < 0.001%)
 */ class $b61380a1fb89463e$var$RatePretty {
    constructor(amount){
        this._options = {
            separator: "",
            symbol: "%"
        };
        this.intPretty = new $iHEZr.IntPretty(amount);
        this.intPretty = this.intPretty.maxDecimals(3).shrink(false).trim(true).locale(true).inequalitySymbol(true);
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    symbol(str) {
        const pretty = this.clone();
        pretty._options.symbol = str;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        return this.intPretty.moveDecimalPointRight(2).toStringWithSymbols("", `${this._options.separator}${this._options.symbol}`);
    }
    clone() {
        const pretty = new $b61380a1fb89463e$var$RatePretty(0);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.RatePretty = $b61380a1fb89463e$var$RatePretty;

});


parcelRegister("1cWJc", function(module, exports) {
"use strict";
var $0e147795c7b38058$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0e147795c7b38058$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0e147795c7b38058$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0e147795c7b38058$var$__exportStar((parcelRequire("1lqQj")), module.exports);

$0e147795c7b38058$var$__exportStar((parcelRequire("384MI")), module.exports);

$0e147795c7b38058$var$__exportStar((parcelRequire("5OkjQ")), module.exports);

});
parcelRegister("1lqQj", function(module, exports) {
"use strict";
var $0fac930100fec48c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0fac930100fec48c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleFetch = module.exports.makeURL = void 0;

var $384MI = parcelRequire("384MI");
function $0fac930100fec48c$var$makeURL(baseURL, url) {
    const baseURLInstance = new URL(baseURL);
    baseURL = $0fac930100fec48c$var$removeLastSlashIfIs(baseURLInstance.origin);
    url = $0fac930100fec48c$var$removeLastSlashIfIs(baseURLInstance.pathname) + "/" + $0fac930100fec48c$var$removeFirstSlashIfIs(url);
    return $0fac930100fec48c$var$removeLastSlashIfIs(baseURL + "/" + $0fac930100fec48c$var$removeFirstSlashIfIs(url));
}
module.exports.makeURL = $0fac930100fec48c$var$makeURL;
function $0fac930100fec48c$var$removeFirstSlashIfIs(str) {
    if (str.length > 0 && str[0] === "/") return str.slice(1);
    return str;
}
function $0fac930100fec48c$var$removeLastSlashIfIs(str) {
    if (str.length > 0 && str[str.length - 1] === "/") return str.slice(0, str.length - 1);
    return str;
}
function $0fac930100fec48c$var$simpleFetch(baseURL, url, options) {
    return $0fac930100fec48c$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof url !== "string") {
            if (url) options = url;
            url = "";
        }
        if (url === "/") // If url is "/", probably its mean should be to use only base url.
        // However, `URL` with "/" url generate the root url with removing trailing url from base url.
        // To prevent this invalid case, just handle "/" as "".
        url = "";
        const actualURL = $0fac930100fec48c$var$makeURL(baseURL, url);
        const _a = options || {}, { headers: optionHeaders } = _a, otherOptions = $0fac930100fec48c$var$__rest(_a, [
            "headers"
        ]);
        const fetched = yield fetch(actualURL, Object.assign({
            headers: Object.assign({
                accept: "application/json, text/plain, */*"
            }, optionHeaders)
        }, otherOptions));
        let data;
        const contentType = fetched.headers.get("content-type") || "";
        if (contentType.startsWith("application/json")) data = yield fetched.json();
        else {
            const r = yield fetched.text();
            const trim = r.trim();
            if (trim.startsWith("{") && trim.endsWith("}")) data = JSON.parse(trim);
            else data = r;
        }
        const res = {
            url: actualURL,
            data: data,
            headers: fetched.headers,
            status: fetched.status,
            statusText: fetched.statusText
        };
        const validateStatusFn = (options === null || options === void 0 ? void 0 : options.validateStatus) || $0fac930100fec48c$var$defaultValidateStatusFn;
        if (!validateStatusFn(fetched.status)) throw new $384MI.SimpleFetchError(baseURL, url, res);
        return res;
    });
}
module.exports.simpleFetch = $0fac930100fec48c$var$simpleFetch;
function $0fac930100fec48c$var$defaultValidateStatusFn(status) {
    return status === 200;
}

});
parcelRegister("384MI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSimpleFetchError = module.exports.SimpleFetchError = void 0;
class $2475d494952856a8$var$SimpleFetchError extends Error {
    constructor(baseURL, url, response){
        super(`Failed to get response from ${new URL(url, baseURL).toString()}`);
        this.baseURL = baseURL;
        this.url = url;
        this.response = response;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $2475d494952856a8$var$SimpleFetchError.prototype);
    }
}
module.exports.SimpleFetchError = $2475d494952856a8$var$SimpleFetchError;
function $2475d494952856a8$var$isSimpleFetchError(payload) {
    return payload instanceof $2475d494952856a8$var$SimpleFetchError;
}
module.exports.isSimpleFetchError = $2475d494952856a8$var$isSimpleFetchError;

});


parcelRegister("5OkjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("lWBwx", function(module, exports) {
"use strict";
var $ff9c1f2cd9baf8af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ff9c1f2cd9baf8af$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ff9c1f2cd9baf8af$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ff9c1f2cd9baf8af$var$__createBinding(result, mod, k);
    }
    $ff9c1f2cd9baf8af$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32Address = void 0;

const $ff9c1f2cd9baf8af$var$bech32_1 = $ff9c1f2cd9baf8af$var$__importStar((parcelRequire("5wgCY")));

var $ihoyg = parcelRequire("ihoyg");

var $7pv2A = parcelRequire("7pv2A");
class $ff9c1f2cd9baf8af$var$Bech32Address {
    static shortenAddress(bech32, maxCharacters) {
        if (maxCharacters >= bech32.length) return bech32;
        const i = bech32.indexOf("1");
        const prefix = bech32.slice(0, i);
        const address = bech32.slice(i + 1);
        maxCharacters -= prefix.length;
        maxCharacters -= 3; // For "..."
        maxCharacters -= 1; // For "1"
        if (maxCharacters <= 0) return "";
        const mid = Math.floor(address.length / 2);
        let former = address.slice(0, mid);
        let latter = address.slice(mid);
        while(maxCharacters < former.length + latter.length)if ((former.length + latter.length) % 2 === 1 && former.length > 0) former = former.slice(0, former.length - 1);
        else latter = latter.slice(1);
        return prefix + "1" + former + "..." + latter;
    }
    static fromBech32(bech32Address, prefix) {
        const decoded = $ff9c1f2cd9baf8af$var$bech32_1.default.decode(bech32Address);
        if (prefix && decoded.prefix !== prefix) throw new Error("Unmatched prefix");
        return new $ff9c1f2cd9baf8af$var$Bech32Address(new Uint8Array((0, $ff9c1f2cd9baf8af$var$bech32_1.fromWords)(decoded.words)));
    }
    static validate(bech32Address, prefix) {
        const { prefix: decodedPrefix } = $ff9c1f2cd9baf8af$var$bech32_1.default.decode(bech32Address);
        if (prefix && prefix !== decodedPrefix) throw new Error(`Unexpected prefix (expected: ${prefix}, actual: ${decodedPrefix})`);
    }
    static defaultBech32Config(mainPrefix, validatorPrefix = "val", consensusPrefix = "cons", publicPrefix = "pub", operatorPrefix = "oper") {
        return {
            bech32PrefixAccAddr: mainPrefix,
            bech32PrefixAccPub: mainPrefix + publicPrefix,
            bech32PrefixValAddr: mainPrefix + validatorPrefix + operatorPrefix,
            bech32PrefixValPub: mainPrefix + validatorPrefix + operatorPrefix + publicPrefix,
            bech32PrefixConsAddr: mainPrefix + validatorPrefix + consensusPrefix,
            bech32PrefixConsPub: mainPrefix + validatorPrefix + consensusPrefix + publicPrefix
        };
    }
    constructor(address){
        this.address = address;
    }
    toBech32(prefix) {
        const words = $ff9c1f2cd9baf8af$var$bech32_1.default.toWords(this.address);
        return $ff9c1f2cd9baf8af$var$bech32_1.default.encode(prefix, words);
    }
    toHex(mixedCaseChecksum = true) {
        const hex = $ihoyg.Buffer.from(this.address).toString("hex");
        if (hex.length === 0) throw new Error("Empty address");
        if (mixedCaseChecksum) return (0, $7pv2A.getAddress)("0x" + hex);
        else return "0x" + hex;
    }
}
module.exports.Bech32Address = $ff9c1f2cd9baf8af$var$Bech32Address;

});
parcelRegister("5wgCY", function(module, exports) {
'use strict';
var $404cd6cca7e8755b$var$ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
// pre-compute lookup table
var $404cd6cca7e8755b$var$ALPHABET_MAP = {};
for(var $404cd6cca7e8755b$var$z = 0; $404cd6cca7e8755b$var$z < $404cd6cca7e8755b$var$ALPHABET.length; $404cd6cca7e8755b$var$z++){
    var $404cd6cca7e8755b$var$x = $404cd6cca7e8755b$var$ALPHABET.charAt($404cd6cca7e8755b$var$z);
    if ($404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] !== undefined) throw new TypeError($404cd6cca7e8755b$var$x + ' is ambiguous');
    $404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] = $404cd6cca7e8755b$var$z;
}
function $404cd6cca7e8755b$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $404cd6cca7e8755b$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')';
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $404cd6cca7e8755b$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $404cd6cca7e8755b$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError('Exceeds length limit');
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === 'string') throw new Error(chk);
    var result = prefix + '1';
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error('Non 5-bit word');
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ x;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $404cd6cca7e8755b$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(v);
    }
    return result;
}
function $404cd6cca7e8755b$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + ' too short';
    if (str.length > LIMIT) return 'Exceeds length limit';
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str;
    str = lowered;
    var split = str.lastIndexOf('1');
    if (split === -1) return 'No separator character for ' + str;
    if (split === 0) return 'Missing prefix for ' + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return 'Data too short';
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === 'string') return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $404cd6cca7e8755b$var$ALPHABET_MAP[c];
        if (v === undefined) return 'Unknown character ' + c;
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return 'Invalid checksum for ' + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $404cd6cca7e8755b$var$decodeUnsafe() {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === 'object') return res;
}
function $404cd6cca7e8755b$var$decode(str) {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === 'object') return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return 'Excess padding';
        if (value << outBits - bits & maxV) return 'Non-zero padding';
    }
    return result;
}
function $404cd6cca7e8755b$var$toWordsUnsafe(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$toWords(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$fromWordsUnsafe(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$fromWords(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $404cd6cca7e8755b$var$decodeUnsafe,
    decode: $404cd6cca7e8755b$var$decode,
    encode: $404cd6cca7e8755b$var$encode,
    toWordsUnsafe: $404cd6cca7e8755b$var$toWordsUnsafe,
    toWords: $404cd6cca7e8755b$var$toWords,
    fromWordsUnsafe: $404cd6cca7e8755b$var$fromWordsUnsafe,
    fromWords: $404cd6cca7e8755b$var$fromWords
};

});

parcelRegister("7pv2A", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $5652f239bab101de$export$88411125f012957a; });

var $5D3z9 = parcelRequire("5D3z9");

var $9m7bl = parcelRequire("9m7bl");

var $8unkG = parcelRequire("8unkG");

var $i1kbF = parcelRequire("i1kbF");

var $ZCdgK = parcelRequire("ZCdgK");

var $1GUII = parcelRequire("1GUII");
"use strict";
const $5652f239bab101de$var$logger = new (0, $ZCdgK.Logger)((0, $1GUII.version));
function $5652f239bab101de$var$getChecksumAddress(address) {
    if (!(0, $5D3z9.isHexString)(address, 20)) $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $5D3z9.arrayify)((0, $8unkG.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $5652f239bab101de$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5652f239bab101de$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $5652f239bab101de$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$5652f239bab101de$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$5652f239bab101de$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $5652f239bab101de$var$safeDigits = Math.floor($5652f239bab101de$var$log10($5652f239bab101de$var$MAX_SAFE_INTEGER));
function $5652f239bab101de$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $5652f239bab101de$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5652f239bab101de$var$safeDigits){
        let block = expanded.substring(0, $5652f239bab101de$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5652f239bab101de$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5652f239bab101de$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5652f239bab101de$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5652f239bab101de$var$ibanChecksum(address)) $5652f239bab101de$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $9m7bl._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5652f239bab101de$var$getChecksumAddress("0x" + result);
    } else $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5652f239bab101de$export$977e255126d763d6(address) {
    try {
        $5652f239bab101de$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5652f239bab101de$export$962c4ddada9f668f(address) {
    let base36 = (0, $9m7bl._base16To36)($5652f239bab101de$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5652f239bab101de$var$ibanChecksum("XE00" + base36) + base36;
}
function $5652f239bab101de$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $5652f239bab101de$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5652f239bab101de$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $5D3z9.stripZeros)((0, $5D3z9.arrayify)((0, $9m7bl.BigNumber).from(transaction.nonce).toHexString()));
    return $5652f239bab101de$export$88411125f012957a((0, $5D3z9.hexDataSlice)((0, $8unkG.keccak256)((0, $i1kbF.encode)([
        from,
        nonce
    ])), 12));
}
function $5652f239bab101de$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $5D3z9.hexDataLength)(salt) !== 32) $5652f239bab101de$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $5D3z9.hexDataLength)(initCodeHash) !== 32) $5652f239bab101de$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5652f239bab101de$export$88411125f012957a((0, $5D3z9.hexDataSlice)((0, $8unkG.keccak256)((0, $5D3z9.concat)([
        "0xff",
        $5652f239bab101de$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("5D3z9", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $41935c69d82abd55$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $41935c69d82abd55$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $41935c69d82abd55$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $41935c69d82abd55$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $41935c69d82abd55$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $41935c69d82abd55$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "hexlify", function () { return $41935c69d82abd55$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $41935c69d82abd55$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $41935c69d82abd55$export$15da666eba198c18; });

var $ZCdgK = parcelRequire("ZCdgK");

var $gcSie = parcelRequire("gcSie");
"use strict";
const $41935c69d82abd55$var$logger = new (0, $ZCdgK.Logger)((0, $gcSie.version));
///////////////////////////////
function $41935c69d82abd55$var$isHexable(value) {
    return !!value.toHexString;
}
function $41935c69d82abd55$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $41935c69d82abd55$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $41935c69d82abd55$export$9a14abb1a440cd5e(value) {
    return $41935c69d82abd55$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $41935c69d82abd55$export$c6fabfbfd097fc30(value);
}
function $41935c69d82abd55$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $41935c69d82abd55$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$41935c69d82abd55$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$41935c69d82abd55$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $41935c69d82abd55$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $41935c69d82abd55$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $41935c69d82abd55$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($41935c69d82abd55$var$isHexable(value)) value = value.toHexString();
    if ($41935c69d82abd55$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $41935c69d82abd55$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $41935c69d82abd55$var$addSlice(new Uint8Array(result));
    }
    if ($41935c69d82abd55$export$c6fabfbfd097fc30(value)) return $41935c69d82abd55$var$addSlice(new Uint8Array(value));
    return $41935c69d82abd55$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $41935c69d82abd55$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$41935c69d82abd55$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $41935c69d82abd55$var$addSlice(result);
}
function $41935c69d82abd55$export$a8f4574d0e56446c(value) {
    let result = $41935c69d82abd55$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $41935c69d82abd55$export$3cdc770bf8b2ed3d(value, length) {
    value = $41935c69d82abd55$export$3131421a7d01b4fb(value);
    if (value.length > length) $41935c69d82abd55$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $41935c69d82abd55$var$addSlice(result);
}
function $41935c69d82abd55$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $41935c69d82abd55$var$HexCharacters = "0123456789abcdef";
function $41935c69d82abd55$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $41935c69d82abd55$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $41935c69d82abd55$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($41935c69d82abd55$var$isHexable(value)) return value.toHexString();
    if ($41935c69d82abd55$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $41935c69d82abd55$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($41935c69d82abd55$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $41935c69d82abd55$var$HexCharacters[(v & 0xf0) >> 4] + $41935c69d82abd55$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $41935c69d82abd55$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $41935c69d82abd55$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $41935c69d82abd55$export$2b0d6b5fbe698c70(data);
    else if (!$41935c69d82abd55$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $41935c69d82abd55$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $41935c69d82abd55$export$2b0d6b5fbe698c70(data);
    else if (!$41935c69d82abd55$export$b02a40aff8e4ad18(data) || data.length % 2) $41935c69d82abd55$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $41935c69d82abd55$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $41935c69d82abd55$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $41935c69d82abd55$export$6916af760a341dd3(value) {
    const trimmed = $41935c69d82abd55$export$967bc0082a978949($41935c69d82abd55$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $41935c69d82abd55$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $41935c69d82abd55$export$2b0d6b5fbe698c70(value);
    if (!$41935c69d82abd55$export$b02a40aff8e4ad18(value)) $41935c69d82abd55$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $41935c69d82abd55$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $41935c69d82abd55$export$2b0d6b5fbe698c70(value);
    else if (!$41935c69d82abd55$export$b02a40aff8e4ad18(value)) $41935c69d82abd55$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $41935c69d82abd55$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $41935c69d82abd55$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($41935c69d82abd55$export$9a14abb1a440cd5e(signature)) {
        let bytes = $41935c69d82abd55$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $41935c69d82abd55$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $41935c69d82abd55$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $41935c69d82abd55$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $41935c69d82abd55$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $41935c69d82abd55$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $41935c69d82abd55$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $41935c69d82abd55$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $41935c69d82abd55$export$3cdc770bf8b2ed3d($41935c69d82abd55$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $41935c69d82abd55$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $41935c69d82abd55$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $41935c69d82abd55$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $41935c69d82abd55$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $41935c69d82abd55$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $41935c69d82abd55$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$41935c69d82abd55$export$b02a40aff8e4ad18(result.r)) $41935c69d82abd55$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $41935c69d82abd55$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$41935c69d82abd55$export$b02a40aff8e4ad18(result.s)) $41935c69d82abd55$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $41935c69d82abd55$export$e9c46a54370b47e8(result.s, 32);
        const vs = $41935c69d82abd55$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $41935c69d82abd55$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $41935c69d82abd55$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$41935c69d82abd55$export$b02a40aff8e4ad18(result._vs)) $41935c69d82abd55$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $41935c69d82abd55$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $41935c69d82abd55$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $41935c69d82abd55$export$71bb9d78a59bbe25(signature) {
    signature = $41935c69d82abd55$export$7fb170f1e457988f(signature);
    return $41935c69d82abd55$export$2b0d6b5fbe698c70($41935c69d82abd55$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("ZCdgK", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $0b9356edde1e2a54$export$efa9a398d6368992; });

var $9CVok = parcelRequire("9CVok");
"use strict";
let $0b9356edde1e2a54$var$_permanentCensorErrors = false;
let $0b9356edde1e2a54$var$_censorErrors = false;
const $0b9356edde1e2a54$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $0b9356edde1e2a54$var$_logLevel = $0b9356edde1e2a54$var$LogLevels["default"];
let $0b9356edde1e2a54$var$_globalLogger = null;
function $0b9356edde1e2a54$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $0b9356edde1e2a54$var$_normalizeError = $0b9356edde1e2a54$var$_checkNormalize();
var $0b9356edde1e2a54$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($0b9356edde1e2a54$export$243e62d78d3b544d || ($0b9356edde1e2a54$export$243e62d78d3b544d = {}));
var $0b9356edde1e2a54$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($0b9356edde1e2a54$export$d4e71bc0b80dc0fb || ($0b9356edde1e2a54$export$d4e71bc0b80dc0fb = {}));
const $0b9356edde1e2a54$var$HEX = "0123456789abcdef";
class $0b9356edde1e2a54$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($0b9356edde1e2a54$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($0b9356edde1e2a54$var$_logLevel > $0b9356edde1e2a54$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($0b9356edde1e2a54$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($0b9356edde1e2a54$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($0b9356edde1e2a54$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($0b9356edde1e2a54$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $0b9356edde1e2a54$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $0b9356edde1e2a54$var$HEX[value[i] >> 4];
                        hex += $0b9356edde1e2a54$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $0b9356edde1e2a54$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $0b9356edde1e2a54$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($0b9356edde1e2a54$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $0b9356edde1e2a54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $0b9356edde1e2a54$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $0b9356edde1e2a54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $0b9356edde1e2a54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $0b9356edde1e2a54$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $0b9356edde1e2a54$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $0b9356edde1e2a54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $0b9356edde1e2a54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $0b9356edde1e2a54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$0b9356edde1e2a54$var$_globalLogger) $0b9356edde1e2a54$var$_globalLogger = new $0b9356edde1e2a54$export$efa9a398d6368992((0, $9CVok.version));
        return $0b9356edde1e2a54$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $0b9356edde1e2a54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($0b9356edde1e2a54$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $0b9356edde1e2a54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $0b9356edde1e2a54$var$_censorErrors = !!censorship;
        $0b9356edde1e2a54$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $0b9356edde1e2a54$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $0b9356edde1e2a54$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $0b9356edde1e2a54$var$_logLevel = level;
    }
    static from(version) {
        return new $0b9356edde1e2a54$export$efa9a398d6368992(version);
    }
}
$0b9356edde1e2a54$export$efa9a398d6368992.errors = $0b9356edde1e2a54$export$d4e71bc0b80dc0fb;
$0b9356edde1e2a54$export$efa9a398d6368992.levels = $0b9356edde1e2a54$export$243e62d78d3b544d;

});
parcelRegister("9CVok", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $70242e65d47d6700$export$83d89fbfd8236492; });
const $70242e65d47d6700$export$83d89fbfd8236492 = "logger/5.8.0";

});


parcelRegister("gcSie", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $bcc7e1c98f1ff00f$export$83d89fbfd8236492; });
const $bcc7e1c98f1ff00f$export$83d89fbfd8236492 = "bytes/5.8.0";

});


parcelRegister("9m7bl", function(module, exports) {

$parcel$export(module.exports, "BigNumber", function () { return $6cfbbd4fa592f4c0$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $6cfbbd4fa592f4c0$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $6cfbbd4fa592f4c0$export$1293db5d29c264ff; });

var $7vYz3 = parcelRequire("7vYz3");

var $5D3z9 = parcelRequire("5D3z9");

var $ZCdgK = parcelRequire("ZCdgK");

var $bObDM = parcelRequire("bObDM");
"use strict";
var $6cfbbd4fa592f4c0$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3))).BN;
const $6cfbbd4fa592f4c0$var$logger = new (0, $ZCdgK.Logger)((0, $bObDM.version));
const $6cfbbd4fa592f4c0$var$_constructorGuard = {};
const $6cfbbd4fa592f4c0$var$MAX_SAFE = 0x1fffffffffffff;
function $6cfbbd4fa592f4c0$export$a3d0a7fa9b65683b(value) {
    return value != null && ($6cfbbd4fa592f4c0$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $5D3z9.isHexString)(value) || typeof value === "bigint" || (0, $5D3z9.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $6cfbbd4fa592f4c0$var$_warnedToStringRadix = false;
class $6cfbbd4fa592f4c0$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $6cfbbd4fa592f4c0$var$_constructorGuard) $6cfbbd4fa592f4c0$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $ZCdgK.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).add($6cfbbd4fa592f4c0$var$toBN(other)));
    }
    sub(other) {
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).sub($6cfbbd4fa592f4c0$var$toBN(other)));
    }
    div(other) {
        const o = $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(other);
        if (o.isZero()) $6cfbbd4fa592f4c0$var$throwFault("division-by-zero", "div");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).div($6cfbbd4fa592f4c0$var$toBN(other)));
    }
    mul(other) {
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).mul($6cfbbd4fa592f4c0$var$toBN(other)));
    }
    mod(other) {
        const value = $6cfbbd4fa592f4c0$var$toBN(other);
        if (value.isNeg()) $6cfbbd4fa592f4c0$var$throwFault("division-by-zero", "mod");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $6cfbbd4fa592f4c0$var$toBN(other);
        if (value.isNeg()) $6cfbbd4fa592f4c0$var$throwFault("negative-power", "pow");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $6cfbbd4fa592f4c0$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $6cfbbd4fa592f4c0$var$throwFault("unbound-bitwise-result", "and");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).and(value));
    }
    or(other) {
        const value = $6cfbbd4fa592f4c0$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $6cfbbd4fa592f4c0$var$throwFault("unbound-bitwise-result", "or");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $6cfbbd4fa592f4c0$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $6cfbbd4fa592f4c0$var$throwFault("unbound-bitwise-result", "xor");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $6cfbbd4fa592f4c0$var$throwFault("negative-width", "mask");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $6cfbbd4fa592f4c0$var$throwFault("negative-width", "shl");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $6cfbbd4fa592f4c0$var$throwFault("negative-width", "shr");
        return $6cfbbd4fa592f4c0$var$toBigNumber($6cfbbd4fa592f4c0$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $6cfbbd4fa592f4c0$var$toBN(this).eq($6cfbbd4fa592f4c0$var$toBN(other));
    }
    lt(other) {
        return $6cfbbd4fa592f4c0$var$toBN(this).lt($6cfbbd4fa592f4c0$var$toBN(other));
    }
    lte(other) {
        return $6cfbbd4fa592f4c0$var$toBN(this).lte($6cfbbd4fa592f4c0$var$toBN(other));
    }
    gt(other) {
        return $6cfbbd4fa592f4c0$var$toBN(this).gt($6cfbbd4fa592f4c0$var$toBN(other));
    }
    gte(other) {
        return $6cfbbd4fa592f4c0$var$toBN(this).gte($6cfbbd4fa592f4c0$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $6cfbbd4fa592f4c0$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $6cfbbd4fa592f4c0$var$toBN(this).toNumber();
        } catch (error) {
            $6cfbbd4fa592f4c0$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $6cfbbd4fa592f4c0$var$logger.throwError("this platform does not support BigInt", (0, $ZCdgK.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$6cfbbd4fa592f4c0$var$_warnedToStringRadix) {
                    $6cfbbd4fa592f4c0$var$_warnedToStringRadix = true;
                    $6cfbbd4fa592f4c0$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $6cfbbd4fa592f4c0$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $ZCdgK.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $6cfbbd4fa592f4c0$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $ZCdgK.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $6cfbbd4fa592f4c0$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $6cfbbd4fa592f4c0$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $6cfbbd4fa592f4c0$export$d97aa349ed20696($6cfbbd4fa592f4c0$var$_constructorGuard, $6cfbbd4fa592f4c0$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $6cfbbd4fa592f4c0$export$d97aa349ed20696($6cfbbd4fa592f4c0$var$_constructorGuard, $6cfbbd4fa592f4c0$var$toHex(new $6cfbbd4fa592f4c0$var$BN(value)));
            return $6cfbbd4fa592f4c0$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $6cfbbd4fa592f4c0$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $6cfbbd4fa592f4c0$var$MAX_SAFE || value <= -$6cfbbd4fa592f4c0$var$MAX_SAFE) $6cfbbd4fa592f4c0$var$throwFault("overflow", "BigNumber.from", value);
            return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $5D3z9.isBytes)(anyValue)) return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from((0, $5D3z9.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $5D3z9.isHexString)(hex) || hex[0] === "-" && (0, $5D3z9.isHexString)(hex.substring(1))) return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $6cfbbd4fa592f4c0$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $6cfbbd4fa592f4c0$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $6cfbbd4fa592f4c0$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $6cfbbd4fa592f4c0$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $6cfbbd4fa592f4c0$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $6cfbbd4fa592f4c0$var$toBigNumber(value) {
    return $6cfbbd4fa592f4c0$export$d97aa349ed20696.from($6cfbbd4fa592f4c0$var$toHex(value));
}
function $6cfbbd4fa592f4c0$var$toBN(value) {
    const hex = $6cfbbd4fa592f4c0$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $6cfbbd4fa592f4c0$var$BN("-" + hex.substring(3), 16);
    return new $6cfbbd4fa592f4c0$var$BN(hex.substring(2), 16);
}
function $6cfbbd4fa592f4c0$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $6cfbbd4fa592f4c0$var$logger.throwError(fault, (0, $ZCdgK.Logger).errors.NUMERIC_FAULT, params);
}
function $6cfbbd4fa592f4c0$export$51e4a08295f7770f(value) {
    return new $6cfbbd4fa592f4c0$var$BN(value, 36).toString(16);
}
function $6cfbbd4fa592f4c0$export$1293db5d29c264ff(value) {
    return new $6cfbbd4fa592f4c0$var$BN(value, 16).toString(36);
}

});
parcelRegister("bObDM", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $898d64cc36d98731$export$83d89fbfd8236492; });
const $898d64cc36d98731$export$83d89fbfd8236492 = "bignumber/5.8.0";

});


parcelRegister("8unkG", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $62e3396d458230e9$export$f8151fce47ad1c35; });

var $baOVG = parcelRequire("baOVG");

var $dSUaS = parcelRequire("dSUaS");
"use strict";
function $62e3396d458230e9$export$f8151fce47ad1c35(data) {
    return '0x' + (0, (/*@__PURE__*/$parcel$interopDefault($baOVG))).keccak_256((0, $dSUaS.arrayify)(data));
}

});
parcelRegister("baOVG", function(module, exports) {
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var INPUT_ERROR = 'input is invalid type';
    var FINALIZE_ERROR = 'finalize already called';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && false;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        'hex',
        'buffer',
        'arrayBuffer',
        'array',
        'digest'
    ];
    var CSHAKE_BYTEPAD = {
        '128': 168,
        '256': 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, 'hex');
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, 'hex');
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods['shake' + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, 'hex');
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                'KMAC',
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: 'keccak',
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'sha3',
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: 'shake',
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: 'cshake',
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: 'kmac',
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + '_' + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== 'sha3') {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== 'string') {
            if (type === 'object') {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = '', block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});

parcelRegister("dSUaS", function(module, exports) {

$parcel$export(module.exports, "arrayify", function () { return $a1bbe4901b8fcd4c$export$3131421a7d01b4fb; });

var $ett0i = parcelRequire("ett0i");

var $7JDnc = parcelRequire("7JDnc");
"use strict";
const $a1bbe4901b8fcd4c$var$logger = new (0, $ett0i.Logger)((0, $7JDnc.version));
///////////////////////////////
function $a1bbe4901b8fcd4c$var$isHexable(value) {
    return !!value.toHexString;
}
function $a1bbe4901b8fcd4c$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $a1bbe4901b8fcd4c$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $a1bbe4901b8fcd4c$export$9a14abb1a440cd5e(value) {
    return $a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $a1bbe4901b8fcd4c$export$c6fabfbfd097fc30(value);
}
function $a1bbe4901b8fcd4c$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $a1bbe4901b8fcd4c$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$a1bbe4901b8fcd4c$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$a1bbe4901b8fcd4c$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $a1bbe4901b8fcd4c$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $a1bbe4901b8fcd4c$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $a1bbe4901b8fcd4c$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($a1bbe4901b8fcd4c$var$isHexable(value)) value = value.toHexString();
    if ($a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $a1bbe4901b8fcd4c$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $a1bbe4901b8fcd4c$var$addSlice(new Uint8Array(result));
    }
    if ($a1bbe4901b8fcd4c$export$c6fabfbfd097fc30(value)) return $a1bbe4901b8fcd4c$var$addSlice(new Uint8Array(value));
    return $a1bbe4901b8fcd4c$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $a1bbe4901b8fcd4c$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$a1bbe4901b8fcd4c$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $a1bbe4901b8fcd4c$var$addSlice(result);
}
function $a1bbe4901b8fcd4c$export$a8f4574d0e56446c(value) {
    let result = $a1bbe4901b8fcd4c$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $a1bbe4901b8fcd4c$export$3cdc770bf8b2ed3d(value, length) {
    value = $a1bbe4901b8fcd4c$export$3131421a7d01b4fb(value);
    if (value.length > length) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $a1bbe4901b8fcd4c$var$addSlice(result);
}
function $a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $a1bbe4901b8fcd4c$var$HexCharacters = "0123456789abcdef";
function $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $a1bbe4901b8fcd4c$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $a1bbe4901b8fcd4c$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($a1bbe4901b8fcd4c$var$isHexable(value)) return value.toHexString();
    if ($a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $a1bbe4901b8fcd4c$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($a1bbe4901b8fcd4c$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $a1bbe4901b8fcd4c$var$HexCharacters[(v & 0xf0) >> 4] + $a1bbe4901b8fcd4c$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $a1bbe4901b8fcd4c$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $a1bbe4901b8fcd4c$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(data);
    else if (!$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $a1bbe4901b8fcd4c$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(data);
    else if (!$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(data) || data.length % 2) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $a1bbe4901b8fcd4c$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $a1bbe4901b8fcd4c$export$6916af760a341dd3(value) {
    const trimmed = $a1bbe4901b8fcd4c$export$967bc0082a978949($a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $a1bbe4901b8fcd4c$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(value);
    if (!$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(value)) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $a1bbe4901b8fcd4c$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(value);
    else if (!$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(value)) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $a1bbe4901b8fcd4c$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($a1bbe4901b8fcd4c$export$9a14abb1a440cd5e(signature)) {
        let bytes = $a1bbe4901b8fcd4c$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $a1bbe4901b8fcd4c$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $a1bbe4901b8fcd4c$export$3cdc770bf8b2ed3d($a1bbe4901b8fcd4c$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(result.r)) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $a1bbe4901b8fcd4c$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(result.s)) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $a1bbe4901b8fcd4c$export$e9c46a54370b47e8(result.s, 32);
        const vs = $a1bbe4901b8fcd4c$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$a1bbe4901b8fcd4c$export$b02a40aff8e4ad18(result._vs)) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $a1bbe4901b8fcd4c$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $a1bbe4901b8fcd4c$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $a1bbe4901b8fcd4c$export$71bb9d78a59bbe25(signature) {
    signature = $a1bbe4901b8fcd4c$export$7fb170f1e457988f(signature);
    return $a1bbe4901b8fcd4c$export$2b0d6b5fbe698c70($a1bbe4901b8fcd4c$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("ett0i", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $a89a45a93cda276a$export$efa9a398d6368992; });

var $fEe8u = parcelRequire("fEe8u");
"use strict";
let $a89a45a93cda276a$var$_permanentCensorErrors = false;
let $a89a45a93cda276a$var$_censorErrors = false;
const $a89a45a93cda276a$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $a89a45a93cda276a$var$_logLevel = $a89a45a93cda276a$var$LogLevels["default"];
let $a89a45a93cda276a$var$_globalLogger = null;
function $a89a45a93cda276a$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $a89a45a93cda276a$var$_normalizeError = $a89a45a93cda276a$var$_checkNormalize();
var $a89a45a93cda276a$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($a89a45a93cda276a$export$243e62d78d3b544d || ($a89a45a93cda276a$export$243e62d78d3b544d = {}));
var $a89a45a93cda276a$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($a89a45a93cda276a$export$d4e71bc0b80dc0fb || ($a89a45a93cda276a$export$d4e71bc0b80dc0fb = {}));
const $a89a45a93cda276a$var$HEX = "0123456789abcdef";
class $a89a45a93cda276a$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($a89a45a93cda276a$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($a89a45a93cda276a$var$_logLevel > $a89a45a93cda276a$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($a89a45a93cda276a$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($a89a45a93cda276a$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($a89a45a93cda276a$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($a89a45a93cda276a$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $a89a45a93cda276a$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $a89a45a93cda276a$var$HEX[value[i] >> 4];
                        hex += $a89a45a93cda276a$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $a89a45a93cda276a$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $a89a45a93cda276a$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($a89a45a93cda276a$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $a89a45a93cda276a$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $a89a45a93cda276a$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $a89a45a93cda276a$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $a89a45a93cda276a$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $a89a45a93cda276a$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $a89a45a93cda276a$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $a89a45a93cda276a$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $a89a45a93cda276a$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $a89a45a93cda276a$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$a89a45a93cda276a$var$_globalLogger) $a89a45a93cda276a$var$_globalLogger = new $a89a45a93cda276a$export$efa9a398d6368992((0, $fEe8u.version));
        return $a89a45a93cda276a$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $a89a45a93cda276a$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($a89a45a93cda276a$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $a89a45a93cda276a$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $a89a45a93cda276a$var$_censorErrors = !!censorship;
        $a89a45a93cda276a$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $a89a45a93cda276a$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $a89a45a93cda276a$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $a89a45a93cda276a$var$_logLevel = level;
    }
    static from(version) {
        return new $a89a45a93cda276a$export$efa9a398d6368992(version);
    }
}
$a89a45a93cda276a$export$efa9a398d6368992.errors = $a89a45a93cda276a$export$d4e71bc0b80dc0fb;
$a89a45a93cda276a$export$efa9a398d6368992.levels = $a89a45a93cda276a$export$243e62d78d3b544d;

});
parcelRegister("fEe8u", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b6458e91b4c4232f$export$83d89fbfd8236492; });
const $b6458e91b4c4232f$export$83d89fbfd8236492 = "logger/5.8.0";

});


parcelRegister("7JDnc", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $5a1b471333994b75$export$83d89fbfd8236492; });
const $5a1b471333994b75$export$83d89fbfd8236492 = "bytes/5.8.0";

});



parcelRegister("i1kbF", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $d1e7fab9210c26a4$export$c564cdbbe6da493; });

var $5D3z9 = parcelRequire("5D3z9");

var $ZCdgK = parcelRequire("ZCdgK");

var $ha7Xf = parcelRequire("ha7Xf");
"use strict";
const $d1e7fab9210c26a4$var$logger = new (0, $ZCdgK.Logger)((0, $ha7Xf.version));
function $d1e7fab9210c26a4$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $d1e7fab9210c26a4$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $d1e7fab9210c26a4$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($d1e7fab9210c26a4$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $d1e7fab9210c26a4$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $5D3z9.isBytesLike)(object)) $d1e7fab9210c26a4$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $5D3z9.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $d1e7fab9210c26a4$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $d1e7fab9210c26a4$export$c564cdbbe6da493(object) {
    return (0, $5D3z9.hexlify)($d1e7fab9210c26a4$var$_encode(object));
}
function $d1e7fab9210c26a4$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $d1e7fab9210c26a4$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $d1e7fab9210c26a4$var$logger.throwError("child data too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $d1e7fab9210c26a4$var$_decode(data, offset) {
    if (data.length === 0) $d1e7fab9210c26a4$var$logger.throwError("data too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $d1e7fab9210c26a4$var$logger.throwError("data short segment too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
        const length = $d1e7fab9210c26a4$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $d1e7fab9210c26a4$var$logger.throwError("data long segment too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
        return $d1e7fab9210c26a4$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $d1e7fab9210c26a4$var$logger.throwError("data array too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
        return $d1e7fab9210c26a4$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $d1e7fab9210c26a4$var$logger.throwError("data array too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
        const length = $d1e7fab9210c26a4$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $d1e7fab9210c26a4$var$logger.throwError("data array too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $5D3z9.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $d1e7fab9210c26a4$var$logger.throwError("data too short", (0, $ZCdgK.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $5D3z9.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $5D3z9.hexlify)(data[offset])
    };
}
function $d1e7fab9210c26a4$export$2f872c0f2117be69(data) {
    const bytes = (0, $5D3z9.arrayify)(data);
    const decoded = $d1e7fab9210c26a4$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $d1e7fab9210c26a4$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("ha7Xf", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $c7e98a75a78c7f02$export$83d89fbfd8236492; });
const $c7e98a75a78c7f02$export$83d89fbfd8236492 = "rlp/5.8.0";

});


parcelRegister("1GUII", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $13b5b621afd5242c$export$83d89fbfd8236492; });
const $13b5b621afd5242c$export$83d89fbfd8236492 = "address/5.8.0";

});



parcelRegister("4Ve8M", function(module, exports) {
"use strict";
var $395774564c11ab2c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $395774564c11ab2c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $395774564c11ab2c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$395774564c11ab2c$var$__exportStar((parcelRequire("duv37")), module.exports);

$395774564c11ab2c$var$__exportStar((parcelRequire("kk9lF")), module.exports);

});
parcelRegister("duv37", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChainIdHelper = void 0;
class $9d26296fb9202b0d$var$ChainIdHelper {
    static parse(chainId) {
        // In the case of injective dev/testnet, there is a difficult problem to deal with keplr's chain identifier system...
        // Fundamentally, keplr's chain identifier system started when the app was created, so too mnay logic depends on chain identifier.
        // Temporarily deal with it in the way below.
        // There is a possibility of some kind of problem...
        // But anyway, it's not a big problem because it's dev/testnet...
        if (chainId === "injective-777" || chainId === "injective-888") return {
            identifier: chainId,
            version: 0
        };
        const split = chainId.split($9d26296fb9202b0d$var$ChainIdHelper.VersionFormatRegExp).filter(Boolean);
        if (split.length !== 2) return {
            identifier: chainId,
            version: 0
        };
        else return {
            identifier: split[0],
            version: parseInt(split[1])
        };
    }
    static hasChainVersion(chainId) {
        const version = $9d26296fb9202b0d$var$ChainIdHelper.parse(chainId);
        return version.identifier !== chainId;
    }
}
module.exports.ChainIdHelper = $9d26296fb9202b0d$var$ChainIdHelper;
// VersionFormatRegExp checks if a chainID is in the format required for parsing versions
// The chainID should be in the form: `{identifier}-{version}`
$9d26296fb9202b0d$var$ChainIdHelper.VersionFormatRegExp = /(.+)-([\d]+)/;

});

parcelRegister("kk9lF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EthermintChainIdHelper = void 0;

var $duv37 = parcelRequire("duv37");
class $ecbced53521fdad8$var$EthermintChainIdHelper {
    static parse(chainId) {
        const cosmosChainId = $duv37.ChainIdHelper.parse(chainId);
        if (chainId.startsWith("injective")) {
            const injectiveTestnetChainIds = [
                "injective-777",
                "injective-888"
            ];
            if (injectiveTestnetChainIds.includes(chainId)) return Object.assign({
                ethChainId: 5
            }, cosmosChainId);
            return Object.assign({
                ethChainId: 1
            }, cosmosChainId);
        }
        const matches = chainId.match("^([a-z]{1,})_{1}([1-9][0-9]*)-{1}([1-9][0-9]*)$");
        if (!matches || matches.length !== 4 || matches[1] === "" || Number.isNaN(parseFloat(matches[2])) || !Number.isInteger(parseFloat(matches[2]))) throw new Error(`Invalid chainId for ethermint: ${chainId}`);
        return Object.assign(Object.assign({}, cosmosChainId), {
            ethChainId: parseFloat(matches[2])
        });
    }
}
module.exports.EthermintChainIdHelper = $ecbced53521fdad8$var$EthermintChainIdHelper;

});


parcelRegister("3kRIM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TendermintTxTracer = void 0;

var $apDzW = parcelRequire("apDzW");

var $ihoyg = parcelRequire("ihoyg");
class $26dce94b375b0bff$var$TendermintTxTracer {
    constructor(url, wsEndpoint, options = {}){
        this.url = url;
        this.wsEndpoint = wsEndpoint;
        this.options = options;
        this.newBlockSubscribes = [];
        // Key is "id" for jsonrpc
        this.txSubscribes = new Map();
        // Key is "id" for jsonrpc
        this.pendingQueries = new Map();
        this.listeners = {};
        this.onOpen = (e)=>{
            var _a;
            if (this.newBlockSubscribes.length > 0) this.sendSubscribeBlockRpc();
            for (const [id, tx] of this.txSubscribes)this.sendSubscribeTxRpc(id, tx.params);
            for (const [id, query] of this.pendingQueries)this.sendQueryRpc(id, query.method, query.params);
            for (const listener of (_a = this.listeners.open) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.onMessage = (e)=>{
            var _a, _b, _c, _d, _e, _f;
            for (const listener of (_a = this.listeners.message) !== null && _a !== void 0 ? _a : [])listener(e);
            if (e.data) try {
                const obj = JSON.parse(e.data);
                if (obj === null || obj === void 0 ? void 0 : obj.id) {
                    if (this.pendingQueries.has(obj.id)) {
                        if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                        else // XXX: I'm not sure why this happens, but somtimes the form of tx id delivered under the "tx_result" field.
                        if ((_b = obj.result) === null || _b === void 0 ? void 0 : _b.tx_result) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result.tx_result);
                        else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result);
                        this.pendingQueries.delete(obj.id);
                    }
                }
                if (((_d = (_c = obj === null || obj === void 0 ? void 0 : obj.result) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.type) === "tendermint/event/NewBlock") for (const handler of this.newBlockSubscribes)handler.handler(obj.result.data.value);
                if (((_f = (_e = obj === null || obj === void 0 ? void 0 : obj.result) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.type) === "tendermint/event/Tx") {
                    if (obj === null || obj === void 0 ? void 0 : obj.id) {
                        if (this.txSubscribes.has(obj.id)) {
                            if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                            else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).resolver(obj.result.data.value.TxResult.result);
                            this.txSubscribes.delete(obj.id);
                        }
                    }
                }
            } catch (e) {
                console.log(`Tendermint websocket jsonrpc response is not JSON: ${e.message || e.toString()}`);
            }
        };
        this.onClose = (e)=>{
            var _a;
            for (const listener of (_a = this.listeners.close) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.ws = this.options.wsObject ? new this.options.wsObject(this.getWsEndpoint()) : new WebSocket(this.getWsEndpoint());
        this.ws.onopen = this.onOpen;
        this.ws.onmessage = this.onMessage;
        this.ws.onclose = this.onClose;
    }
    getWsEndpoint() {
        let url = this.url;
        if (url.startsWith("http")) url = url.replace("http", "ws");
        if (!url.endsWith(this.wsEndpoint)) {
            const wsEndpoint = this.wsEndpoint.startsWith("/") ? this.wsEndpoint : "/" + this.wsEndpoint;
            url = url.endsWith("/") ? url + wsEndpoint.slice(1) : url + wsEndpoint;
        }
        return url;
    }
    close() {
        this.ws.close();
    }
    get readyState() {
        switch(this.ws.readyState){
            case 0:
                return $apDzW.WsReadyState.CONNECTING;
            case 1:
                return $apDzW.WsReadyState.OPEN;
            case 2:
                return $apDzW.WsReadyState.CLOSING;
            case 3:
                return $apDzW.WsReadyState.CLOSED;
            default:
                return $apDzW.WsReadyState.NONE;
        }
    }
    addEventListener(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.listeners[type].push(listener);
    }
    /**
     * SubscribeBlock receives the handler for the block.
     * The handelrs shares the subscription of block.
     * @param handler
     * @return unsubscriber
     */ subscribeBlock(handler) {
        this.newBlockSubscribes.push({
            handler: handler
        });
        if (this.newBlockSubscribes.length === 1) this.sendSubscribeBlockRpc();
        return ()=>{
            this.newBlockSubscribes = this.newBlockSubscribes.filter((s)=>s.handler !== handler);
        };
    }
    sendSubscribeBlockRpc() {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                "tm.event='NewBlock'"
            ],
            id: 1
        }));
    }
    // Query the tx and subscribe the tx.
    traceTx(query) {
        return new Promise((resolve)=>{
            // At first, try to query the tx at the same time of subscribing the tx.
            // But, the querying's error will be ignored.
            this.queryTx(query).then((result)=>{
                if (query instanceof Uint8Array) {
                    resolve(result);
                    return;
                }
                if ((result === null || result === void 0 ? void 0 : result.total_count) !== "0") {
                    resolve(result);
                    return;
                }
            }).catch(()=>{
            // noop
            });
            this.subscribeTx(query).then(resolve);
        }).then((tx)=>{
            // Occasionally, even if the subscribe tx event occurs, the state through query is not changed yet.
            // Perhaps it is because the block has not been committed yet even though the result of deliverTx in tendermint is complete.
            // This method is usually used to reflect the state change through query when tx is completed.
            // The simplest solution is to just add a little delay.
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(tx), 100);
            });
        });
    }
    subscribeTx(query) {
        if (query instanceof Uint8Array) {
            const id = this.createRandomId();
            const params = {
                query: `tm.event='Tx' AND tx.hash='${$ihoyg.Buffer.from(query).toString("hex").toUpperCase()}'`
            };
            return new Promise((resolve, reject)=>{
                this.txSubscribes.set(id, {
                    params: params,
                    resolver: resolve,
                    rejector: reject
                });
                this.sendSubscribeTxRpc(id, params);
            });
        } else {
            const id = this.createRandomId();
            const params = {
                query: `tm.event='Tx' and ` + Object.keys(query).map((key)=>{
                    return {
                        key: key,
                        value: query[key]
                    };
                }).map((obj)=>{
                    return `${obj.key}=${typeof obj.value === "string" ? `'${obj.value}'` : obj.value}`;
                }).join(" and "),
                page: "1",
                per_page: "1",
                order_by: "desc"
            };
            return new Promise((resolve, reject)=>{
                this.txSubscribes.set(id, {
                    params: params,
                    resolver: resolve,
                    rejector: reject
                });
                this.sendSubscribeTxRpc(id, params);
            });
        }
    }
    sendSubscribeTxRpc(id, params) {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: params,
            id: id
        }));
    }
    queryTx(query) {
        if (query instanceof Uint8Array) return this.query("tx", {
            hash: $ihoyg.Buffer.from(query).toString("base64"),
            prove: false
        });
        else {
            const params = {
                query: Object.keys(query).map((key)=>{
                    return {
                        key: key,
                        value: query[key]
                    };
                }).map((obj)=>{
                    return `${obj.key}=${typeof obj.value === "string" ? `'${obj.value}'` : obj.value}`;
                }).join(" and "),
                page: "1",
                per_page: "1",
                order_by: "desc"
            };
            return this.query("tx_search", params);
        }
    }
    query(method, params) {
        const id = this.createRandomId();
        return new Promise((resolve, reject)=>{
            this.pendingQueries.set(id, {
                method: method,
                params: params,
                resolver: resolve,
                rejector: reject
            });
            this.sendQueryRpc(id, method, params);
        });
    }
    sendQueryRpc(id, method, params) {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: method,
            params: params,
            id: id
        }));
    }
    createRandomId() {
        return parseInt(Array.from({
            length: 6
        }).map(()=>Math.floor(Math.random() * 100)).join(""));
    }
}
module.exports.TendermintTxTracer = $26dce94b375b0bff$var$TendermintTxTracer;

});
parcelRegister("apDzW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WsReadyState = void 0;
var $794af0b3813c95b3$var$WsReadyState;
(function(WsReadyState) {
    WsReadyState[WsReadyState["CONNECTING"] = 0] = "CONNECTING";
    WsReadyState[WsReadyState["OPEN"] = 1] = "OPEN";
    WsReadyState[WsReadyState["CLOSING"] = 2] = "CLOSING";
    WsReadyState[WsReadyState["CLOSED"] = 3] = "CLOSED";
    // WS is not initialized or the ready state of WS is unknown
    WsReadyState[WsReadyState["NONE"] = 4] = "NONE";
})($794af0b3813c95b3$var$WsReadyState = module.exports.WsReadyState || (module.exports.WsReadyState = {}));

});


parcelRegister("cDipa", function(module, exports) {
"use strict";
var $93276766e1c4d3c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93276766e1c4d3c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93276766e1c4d3c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$93276766e1c4d3c8$var$__exportStar((parcelRequire("7jGk0")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("g0kvf")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("5AbUo")), module.exports);

});
parcelRegister("7jGk0", function(module, exports) {
"use strict";
var $553b22f5c6975bda$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $553b22f5c6975bda$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $553b22f5c6975bda$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultProtoCodec = module.exports.ProtoCodec = void 0;

var $5uhLg = parcelRequire("5uhLg");

var $kz1pS = parcelRequire("kz1pS");

var $7Phca = parcelRequire("7Phca");

var $1eDdt = parcelRequire("1eDdt");

var $1vxkN = parcelRequire("1vxkN");

var $c8xZ5 = parcelRequire("c8xZ5");

var $c9nld = parcelRequire("c9nld");

var $9rLeA = parcelRequire("9rLeA");


var $9tRBL = parcelRequire("9tRBL");

var $jPbAy = parcelRequire("jPbAy");

var $dMp8E = parcelRequire("dMp8E");

var $ihoyg = parcelRequire("ihoyg");

$553b22f5c6975bda$var$__exportStar((parcelRequire("dHVad")), module.exports);
class $553b22f5c6975bda$var$ProtoCodec {
    constructor(){
        this.typeUrlMap = new Map();
    }
    unpackAnyFactory(typeUrl) {
        if (!this.typeUrlMap.has(typeUrl)) return undefined;
        return this.typeUrlMap.get(typeUrl);
    }
    /**
     * Unpack the any to the registered message.
     * NOTE: If there is no matched message, it will not throw an error but return the `UnknownMessage` class.
     * @param any
     */ unpackAny(any) {
        const factory = this.unpackAnyFactory(any.typeUrl);
        if (!factory) return new (parcelRequire("dHVad")).UnknownMessage(any.typeUrl, any.value);
        const unpacked = factory.decode(any.value);
        return Object.assign(Object.assign({}, any), {
            unpacked: unpacked
        });
    }
    unpackedAnyToJSONRecursive(unpacked) {
        if (unpacked instanceof (parcelRequire("dHVad")).UnknownMessage) return unpacked.toJSON();
        const factory = this.unpackAnyFactory(unpacked.typeUrl);
        if (factory && "unpacked" in unpacked && unpacked.unpacked) {
            const isJSONEncodedAny = (any)=>{
                const r = typeof any === "object" && !(any instanceof (parcelRequire("dHVad")).UnknownMessage) && "typeUrl" in any && any.typeUrl && typeof any.typeUrl === "string" && "value" in any && any.value && typeof any.value === "string";
                if (r) try {
                    $ihoyg.Buffer.from(any.value, "base64");
                } catch (_a) {
                    return false;
                }
                return r;
            };
            const unpackJSONEncodedAnyInner = (jsonEncodedAny)=>{
                const factory = this.unpackAnyFactory(jsonEncodedAny.typeUrl);
                const bz = $ihoyg.Buffer.from(jsonEncodedAny.value, "base64");
                if (!factory) return new (parcelRequire("dHVad")).UnknownMessage(jsonEncodedAny.typeUrl, bz).toJSON();
                const unpacked = factory.decode(bz);
                return {
                    typeUrl: jsonEncodedAny.typeUrl,
                    value: factory.toJSON(unpacked)
                };
            };
            const unpackedJSONEncodedAnyRecursive = (obj)=>{
                if (Array.isArray(obj)) for(let i = 0; i < obj.length; i++){
                    const value = obj[i];
                    if (isJSONEncodedAny(value)) obj[i] = unpackJSONEncodedAnyInner(value);
                    else if (typeof value === "object") obj[i] = unpackedJSONEncodedAnyRecursive(value);
                }
                else for(const key in obj){
                    const value = obj[key];
                    if (isJSONEncodedAny(value)) obj[key] = unpackJSONEncodedAnyInner(value);
                    else if (typeof value === "object") obj[key] = unpackedJSONEncodedAnyRecursive(value);
                }
                return obj;
            };
            // This is mutated by logic.
            let mutObj = factory.toJSON(unpacked.unpacked);
            if (mutObj && typeof mutObj === "object") {
                mutObj = unpackedJSONEncodedAnyRecursive(mutObj);
                return {
                    typeUrl: unpacked.typeUrl,
                    value: mutObj
                };
            }
        }
        return new (parcelRequire("dHVad")).UnknownMessage(unpacked.typeUrl, unpacked.value).toJSON();
    }
    registerAny(typeUrl, message) {
        this.typeUrlMap.set(typeUrl, message);
    }
}
module.exports.ProtoCodec = $553b22f5c6975bda$var$ProtoCodec;
module.exports.defaultProtoCodec = new $553b22f5c6975bda$var$ProtoCodec();
module.exports.defaultProtoCodec.registerAny("/agoric.swingset.MsgWalletSpendAction", $5uhLg.MsgWalletSpendAction);
module.exports.defaultProtoCodec.registerAny("/agoric.swingset.MsgProvision", $5uhLg.MsgProvision);
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgSend", $kz1pS.MsgSend);
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgMultiSend", $kz1pS.MsgMultiSend);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDelegate", $7Phca.MsgDelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUndelegate", $7Phca.MsgUndelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgBeginRedelegate", $7Phca.MsgBeginRedelegate);
module.exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgExecuteContract", $c9nld.MsgExecuteContract);
module.exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgInstantiateContract", $c9nld.MsgInstantiateContract);
module.exports.defaultProtoCodec.registerAny("/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", $c8xZ5.MsgWithdrawDelegatorReward);
module.exports.defaultProtoCodec.registerAny("/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", $c8xZ5.MsgSetWithdrawAddress);
module.exports.defaultProtoCodec.registerAny("/ibc.applications.transfer.v1.MsgTransfer", $9rLeA.MsgTransfer);
module.exports.defaultProtoCodec.registerAny("/cosmos.gov.v1beta1.MsgVote", $1vxkN.MsgVote);
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgGrant", $1eDdt.MsgGrant);
// ----- Authz grants -----
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.GenericAuthorization", $9tRBL.GenericAuthorization);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.StakeAuthorization", $jPbAy.StakeAuthorization);
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.SendAuthorization", $dMp8E.SendAuthorization);
// ----- Authz grants -----
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgRevoke", $1eDdt.MsgRevoke);
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgExec", $1eDdt.MsgExec);

});
parcelRegister("5uhLg", function(module, exports) {
"use strict";
var $3fed881892d5f3e9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgInstallBundleResponse = module.exports.MsgInstallBundle = module.exports.MsgProvisionResponse = module.exports.MsgProvision = module.exports.MsgWalletSpendActionResponse = module.exports.MsgWalletSpendAction = module.exports.MsgWalletActionResponse = module.exports.MsgWalletAction = module.exports.MsgDeliverInboundResponse = module.exports.MsgDeliverInbound = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $3fed881892d5f3e9$var$long_1 = $3fed881892d5f3e9$var$__importDefault((parcelRequire("jRkuS")));

const $3fed881892d5f3e9$var$minimal_1 = $3fed881892d5f3e9$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "agoric.swingset";
function $3fed881892d5f3e9$var$createBaseMsgDeliverInbound() {
    return {
        messages: [],
        nums: [],
        ack: "0",
        submitter: new Uint8Array()
    };
}
module.exports.MsgDeliverInbound = {
    encode (message, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)writer.uint32(10).string(v);
        writer.uint32(18).fork();
        for (const v of message.nums)writer.uint64(v);
        writer.ldelim();
        if (message.ack !== "0") writer.uint32(24).uint64(message.ack);
        if (message.submitter.length !== 0) writer.uint32(34).bytes(message.submitter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgDeliverInbound();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push(reader.string());
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.nums.push($3fed881892d5f3e9$var$longToString(reader.uint64()));
                    } else message.nums.push($3fed881892d5f3e9$var$longToString(reader.uint64()));
                    break;
                case 3:
                    message.ack = $3fed881892d5f3e9$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.submitter = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map((e)=>String(e)) : [],
            nums: Array.isArray(object === null || object === void 0 ? void 0 : object.nums) ? object.nums.map((e)=>String(e)) : [],
            ack: $3fed881892d5f3e9$var$isSet(object.ack) ? String(object.ack) : "0",
            submitter: $3fed881892d5f3e9$var$isSet(object.submitter) ? $3fed881892d5f3e9$var$bytesFromBase64(object.submitter) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e);
        else obj.messages = [];
        if (message.nums) obj.nums = message.nums.map((e)=>e);
        else obj.nums = [];
        message.ack !== undefined && (obj.ack = message.ack);
        message.submitter !== undefined && (obj.submitter = $3fed881892d5f3e9$var$base64FromBytes(message.submitter !== undefined ? message.submitter : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $3fed881892d5f3e9$var$createBaseMsgDeliverInbound();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        message.nums = ((_b = object.nums) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        message.ack = (_c = object.ack) !== null && _c !== void 0 ? _c : "0";
        message.submitter = (_d = object.submitter) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgDeliverInboundResponse() {
    return {};
}
module.exports.MsgDeliverInboundResponse = {
    encode (_, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgDeliverInboundResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3fed881892d5f3e9$var$createBaseMsgDeliverInboundResponse();
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgWalletAction() {
    return {
        owner: new Uint8Array(),
        action: ""
    };
}
module.exports.MsgWalletAction = {
    encode (message, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        if (message.owner.length !== 0) writer.uint32(10).bytes(message.owner);
        if (message.action !== "") writer.uint32(18).string(message.action);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletAction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.owner = reader.bytes();
                    break;
                case 2:
                    message.action = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            owner: $3fed881892d5f3e9$var$isSet(object.owner) ? $3fed881892d5f3e9$var$bytesFromBase64(object.owner) : new Uint8Array(),
            action: $3fed881892d5f3e9$var$isSet(object.action) ? String(object.action) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.owner !== undefined && (obj.owner = $3fed881892d5f3e9$var$base64FromBytes(message.owner !== undefined ? message.owner : new Uint8Array()));
        message.action !== undefined && (obj.action = message.action);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletAction();
        message.owner = (_a = object.owner) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.action = (_b = object.action) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgWalletActionResponse() {
    return {};
}
module.exports.MsgWalletActionResponse = {
    encode (_, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletActionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletActionResponse();
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgWalletSpendAction() {
    return {
        owner: new Uint8Array(),
        spendAction: ""
    };
}
module.exports.MsgWalletSpendAction = {
    encode (message, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        if (message.owner.length !== 0) writer.uint32(10).bytes(message.owner);
        if (message.spendAction !== "") writer.uint32(18).string(message.spendAction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletSpendAction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.owner = reader.bytes();
                    break;
                case 2:
                    message.spendAction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            owner: $3fed881892d5f3e9$var$isSet(object.owner) ? $3fed881892d5f3e9$var$bytesFromBase64(object.owner) : new Uint8Array(),
            spendAction: $3fed881892d5f3e9$var$isSet(object.spendAction) ? String(object.spendAction) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.owner !== undefined && (obj.owner = $3fed881892d5f3e9$var$base64FromBytes(message.owner !== undefined ? message.owner : new Uint8Array()));
        message.spendAction !== undefined && (obj.spendAction = message.spendAction);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletSpendAction();
        message.owner = (_a = object.owner) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.spendAction = (_b = object.spendAction) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgWalletSpendActionResponse() {
    return {};
}
module.exports.MsgWalletSpendActionResponse = {
    encode (_, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletSpendActionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3fed881892d5f3e9$var$createBaseMsgWalletSpendActionResponse();
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgProvision() {
    return {
        nickname: "",
        address: new Uint8Array(),
        powerFlags: [],
        submitter: new Uint8Array()
    };
}
module.exports.MsgProvision = {
    encode (message, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        if (message.nickname !== "") writer.uint32(10).string(message.nickname);
        if (message.address.length !== 0) writer.uint32(18).bytes(message.address);
        for (const v of message.powerFlags)writer.uint32(26).string(v);
        if (message.submitter.length !== 0) writer.uint32(34).bytes(message.submitter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgProvision();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nickname = reader.string();
                    break;
                case 2:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.powerFlags.push(reader.string());
                    break;
                case 4:
                    message.submitter = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nickname: $3fed881892d5f3e9$var$isSet(object.nickname) ? String(object.nickname) : "",
            address: $3fed881892d5f3e9$var$isSet(object.address) ? $3fed881892d5f3e9$var$bytesFromBase64(object.address) : new Uint8Array(),
            powerFlags: Array.isArray(object === null || object === void 0 ? void 0 : object.powerFlags) ? object.powerFlags.map((e)=>String(e)) : [],
            submitter: $3fed881892d5f3e9$var$isSet(object.submitter) ? $3fed881892d5f3e9$var$bytesFromBase64(object.submitter) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.nickname !== undefined && (obj.nickname = message.nickname);
        message.address !== undefined && (obj.address = $3fed881892d5f3e9$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        if (message.powerFlags) obj.powerFlags = message.powerFlags.map((e)=>e);
        else obj.powerFlags = [];
        message.submitter !== undefined && (obj.submitter = $3fed881892d5f3e9$var$base64FromBytes(message.submitter !== undefined ? message.submitter : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $3fed881892d5f3e9$var$createBaseMsgProvision();
        message.nickname = (_a = object.nickname) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.powerFlags = ((_c = object.powerFlags) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.submitter = (_d = object.submitter) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgProvisionResponse() {
    return {};
}
module.exports.MsgProvisionResponse = {
    encode (_, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgProvisionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3fed881892d5f3e9$var$createBaseMsgProvisionResponse();
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgInstallBundle() {
    return {
        bundle: "",
        submitter: new Uint8Array(),
        compressedBundle: new Uint8Array(),
        uncompressedSize: "0"
    };
}
module.exports.MsgInstallBundle = {
    encode (message, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        if (message.bundle !== "") writer.uint32(10).string(message.bundle);
        if (message.submitter.length !== 0) writer.uint32(18).bytes(message.submitter);
        if (message.compressedBundle.length !== 0) writer.uint32(26).bytes(message.compressedBundle);
        if (message.uncompressedSize !== "0") writer.uint32(32).int64(message.uncompressedSize);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgInstallBundle();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bundle = reader.string();
                    break;
                case 2:
                    message.submitter = reader.bytes();
                    break;
                case 3:
                    message.compressedBundle = reader.bytes();
                    break;
                case 4:
                    message.uncompressedSize = $3fed881892d5f3e9$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bundle: $3fed881892d5f3e9$var$isSet(object.bundle) ? String(object.bundle) : "",
            submitter: $3fed881892d5f3e9$var$isSet(object.submitter) ? $3fed881892d5f3e9$var$bytesFromBase64(object.submitter) : new Uint8Array(),
            compressedBundle: $3fed881892d5f3e9$var$isSet(object.compressedBundle) ? $3fed881892d5f3e9$var$bytesFromBase64(object.compressedBundle) : new Uint8Array(),
            uncompressedSize: $3fed881892d5f3e9$var$isSet(object.uncompressedSize) ? String(object.uncompressedSize) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.bundle !== undefined && (obj.bundle = message.bundle);
        message.submitter !== undefined && (obj.submitter = $3fed881892d5f3e9$var$base64FromBytes(message.submitter !== undefined ? message.submitter : new Uint8Array()));
        message.compressedBundle !== undefined && (obj.compressedBundle = $3fed881892d5f3e9$var$base64FromBytes(message.compressedBundle !== undefined ? message.compressedBundle : new Uint8Array()));
        message.uncompressedSize !== undefined && (obj.uncompressedSize = message.uncompressedSize);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $3fed881892d5f3e9$var$createBaseMsgInstallBundle();
        message.bundle = (_a = object.bundle) !== null && _a !== void 0 ? _a : "";
        message.submitter = (_b = object.submitter) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.compressedBundle = (_c = object.compressedBundle) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.uncompressedSize = (_d = object.uncompressedSize) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $3fed881892d5f3e9$var$createBaseMsgInstallBundleResponse() {
    return {};
}
module.exports.MsgInstallBundleResponse = {
    encode (_, writer = $3fed881892d5f3e9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3fed881892d5f3e9$var$minimal_1.default.Reader ? input : new $3fed881892d5f3e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3fed881892d5f3e9$var$createBaseMsgInstallBundleResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3fed881892d5f3e9$var$createBaseMsgInstallBundleResponse();
        return message;
    }
};
var $3fed881892d5f3e9$var$globalThis = (()=>{
    if (typeof $3fed881892d5f3e9$var$globalThis !== "undefined") return $3fed881892d5f3e9$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $3fed881892d5f3e9$var$atob = $3fed881892d5f3e9$var$globalThis.atob || ((b64)=>$3fed881892d5f3e9$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $3fed881892d5f3e9$var$bytesFromBase64(b64) {
    const bin = $3fed881892d5f3e9$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $3fed881892d5f3e9$var$btoa = $3fed881892d5f3e9$var$globalThis.btoa || ((bin)=>$3fed881892d5f3e9$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $3fed881892d5f3e9$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $3fed881892d5f3e9$var$btoa(bin.join(""));
}
function $3fed881892d5f3e9$var$longToString(long) {
    return long.toString();
}
if ($3fed881892d5f3e9$var$minimal_1.default.util.Long !== $3fed881892d5f3e9$var$long_1.default) {
    $3fed881892d5f3e9$var$minimal_1.default.util.Long = $3fed881892d5f3e9$var$long_1.default;
    $3fed881892d5f3e9$var$minimal_1.default.configure();
}
function $3fed881892d5f3e9$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("jRkuS", function(module, exports) {
module.exports = $e752ddd240bc56a4$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $e752ddd240bc56a4$var$wasm = null;
try {
    $e752ddd240bc56a4$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $e752ddd240bc56a4$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $e752ddd240bc56a4$var$Long.prototype.__isLong__;
Object.defineProperty($e752ddd240bc56a4$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $e752ddd240bc56a4$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$Long.isLong = $e752ddd240bc56a4$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $e752ddd240bc56a4$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $e752ddd240bc56a4$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $e752ddd240bc56a4$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $e752ddd240bc56a4$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromInt = $e752ddd240bc56a4$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    if (unsigned) {
        if (value < 0) return $e752ddd240bc56a4$var$UZERO;
        if (value >= $e752ddd240bc56a4$var$TWO_PWR_64_DBL) return $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MIN_VALUE;
        if (value + 1 >= $e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MAX_VALUE;
    }
    if (value < 0) return $e752ddd240bc56a4$var$fromNumber(-value, unsigned).neg();
    return $e752ddd240bc56a4$var$fromBits(value % $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, value / $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromNumber = $e752ddd240bc56a4$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromBits(lowBits, highBits, unsigned) {
    return new $e752ddd240bc56a4$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBits = $e752ddd240bc56a4$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $e752ddd240bc56a4$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $e752ddd240bc56a4$var$ZERO;
    if (typeof unsigned === 'number') // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
    else if (p === 0) return $e752ddd240bc56a4$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 8));
    var result = $e752ddd240bc56a4$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, size));
            result = result.mul(power).add($e752ddd240bc56a4$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($e752ddd240bc56a4$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromString = $e752ddd240bc56a4$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromValue(val, unsigned) {
    if (typeof val === 'number') return $e752ddd240bc56a4$var$fromNumber(val, unsigned);
    if (typeof val === 'string') return $e752ddd240bc56a4$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $e752ddd240bc56a4$var$fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$Long.fromValue = $e752ddd240bc56a4$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_32_DBL = $e752ddd240bc56a4$var$TWO_PWR_16_DBL * $e752ddd240bc56a4$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_64_DBL = $e752ddd240bc56a4$var$TWO_PWR_32_DBL * $e752ddd240bc56a4$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_63_DBL = $e752ddd240bc56a4$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24 = $e752ddd240bc56a4$var$fromInt($e752ddd240bc56a4$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ZERO = $e752ddd240bc56a4$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ZERO = $e752ddd240bc56a4$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UZERO = $e752ddd240bc56a4$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UZERO = $e752ddd240bc56a4$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ONE = $e752ddd240bc56a4$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ONE = $e752ddd240bc56a4$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UONE = $e752ddd240bc56a4$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UONE = $e752ddd240bc56a4$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$NEG_ONE = $e752ddd240bc56a4$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.NEG_ONE = $e752ddd240bc56a4$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_VALUE = $e752ddd240bc56a4$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_VALUE = $e752ddd240bc56a4$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MIN_VALUE = $e752ddd240bc56a4$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MIN_VALUE = $e752ddd240bc56a4$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $e752ddd240bc56a4$var$LongPrototype = $e752ddd240bc56a4$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $e752ddd240bc56a4$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';
    if (this.isNegative()) {
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $e752ddd240bc56a4$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return '-' + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = '';
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($e752ddd240bc56a4$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eqz = $e752ddd240bc56a4$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.equals = function equals(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eq = $e752ddd240bc56a4$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.neq = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ne = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lt = $e752ddd240bc56a4$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lte = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.le = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gt = $e752ddd240bc56a4$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gte = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ge = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.compare = function compare(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.comp = $e752ddd240bc56a4$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$MIN_VALUE;
    return this.not().add($e752ddd240bc56a4$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.neg = $e752ddd240bc56a4$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $e752ddd240bc56a4$var$LongPrototype.add = function add(addend) {
    if (!$e752ddd240bc56a4$var$isLong(addend)) addend = $e752ddd240bc56a4$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$e752ddd240bc56a4$var$isLong(subtrahend)) subtrahend = $e752ddd240bc56a4$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.sub = $e752ddd240bc56a4$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (!$e752ddd240bc56a4$var$isLong(multiplier)) multiplier = $e752ddd240bc56a4$var$fromValue(multiplier);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = $e752ddd240bc56a4$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return multiplier.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (multiplier.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($e752ddd240bc56a4$var$TWO_PWR_24) && multiplier.lt($e752ddd240bc56a4$var$TWO_PWR_24)) return $e752ddd240bc56a4$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.mul = $e752ddd240bc56a4$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.divide = function divide(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero');
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.div_u : $e752ddd240bc56a4$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            if (divisor.eq($e752ddd240bc56a4$var$ONE) || divisor.eq($e752ddd240bc56a4$var$NEG_ONE)) return $e752ddd240bc56a4$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($e752ddd240bc56a4$var$ZERO)) return divisor.isNegative() ? $e752ddd240bc56a4$var$ONE : $e752ddd240bc56a4$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $e752ddd240bc56a4$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $e752ddd240bc56a4$var$UZERO;
        if (divisor.gt(this.shru(1))) return $e752ddd240bc56a4$var$UONE;
        res = $e752ddd240bc56a4$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $e752ddd240bc56a4$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $e752ddd240bc56a4$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $e752ddd240bc56a4$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $e752ddd240bc56a4$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.div = $e752ddd240bc56a4$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.rem_u : $e752ddd240bc56a4$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.mod = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.rem = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.not = function not() {
    return $e752ddd240bc56a4$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.and = function and(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.or = function or(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.xor = function xor(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shl = $e752ddd240bc56a4$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr = $e752ddd240bc56a4$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $e752ddd240bc56a4$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $e752ddd240bc56a4$var$fromBits(high, 0, this.unsigned);
        else return $e752ddd240bc56a4$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shru = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr_u = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $e752ddd240bc56a4$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $e752ddd240bc56a4$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $e752ddd240bc56a4$var$Long.fromBytesLE(bytes, unsigned) : $e752ddd240bc56a4$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("fQBv0", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("lgkiq"));

});
parcelRegister("lgkiq", function(module, exports) {
"use strict";
var $f7aad5fe2e4466b7$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $f7aad5fe2e4466b7$var$protobuf.build = "minimal";

// Serialization
$f7aad5fe2e4466b7$var$protobuf.Writer = (parcelRequire("73ZlY"));

$f7aad5fe2e4466b7$var$protobuf.BufferWriter = (parcelRequire("6oXFW"));

$f7aad5fe2e4466b7$var$protobuf.Reader = (parcelRequire("jNsDJ"));

$f7aad5fe2e4466b7$var$protobuf.BufferReader = (parcelRequire("kDrIk"));

// Utility
$f7aad5fe2e4466b7$var$protobuf.util = (parcelRequire("fK14h"));

$f7aad5fe2e4466b7$var$protobuf.rpc = (parcelRequire("cFFQd"));

$f7aad5fe2e4466b7$var$protobuf.roots = (parcelRequire("eFuHd"));
$f7aad5fe2e4466b7$var$protobuf.configure = $f7aad5fe2e4466b7$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $f7aad5fe2e4466b7$var$configure() {
    $f7aad5fe2e4466b7$var$protobuf.util._configure();
    $f7aad5fe2e4466b7$var$protobuf.Writer._configure($f7aad5fe2e4466b7$var$protobuf.BufferWriter);
    $f7aad5fe2e4466b7$var$protobuf.Reader._configure($f7aad5fe2e4466b7$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$f7aad5fe2e4466b7$var$configure();

});
parcelRegister("73ZlY", function(module, exports) {
"use strict";
module.exports = $524867ba9b208546$var$Writer;

var $fK14h = parcelRequire("fK14h");
var $524867ba9b208546$var$BufferWriter; // cyclic
var $524867ba9b208546$var$LongBits = $fK14h.LongBits, $524867ba9b208546$var$base64 = $fK14h.base64, $524867ba9b208546$var$utf8 = $fK14h.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $524867ba9b208546$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $524867ba9b208546$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $524867ba9b208546$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $524867ba9b208546$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $524867ba9b208546$var$create = function create() {
    return $fK14h.Buffer ? function create_buffer_setup() {
        return ($524867ba9b208546$var$Writer.create = function create_buffer() {
            return new $524867ba9b208546$var$BufferWriter();
        })();
    } : function create_array() {
        return new $524867ba9b208546$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $524867ba9b208546$var$Writer.create = $524867ba9b208546$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $524867ba9b208546$var$Writer.alloc = function alloc(size) {
    return new $fK14h.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($fK14h.Array !== Array) $524867ba9b208546$var$Writer.alloc = $fK14h.pool($524867ba9b208546$var$Writer.alloc, $fK14h.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $524867ba9b208546$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $524867ba9b208546$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $524867ba9b208546$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $524867ba9b208546$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $524867ba9b208546$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$524867ba9b208546$var$VarintOp.prototype = Object.create($524867ba9b208546$var$Op.prototype);
$524867ba9b208546$var$VarintOp.prototype.fn = $524867ba9b208546$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $524867ba9b208546$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($524867ba9b208546$var$writeVarint64, 10, $524867ba9b208546$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $524867ba9b208546$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value);
    return this._push($524867ba9b208546$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.int64 = $524867ba9b208546$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value).zzEncode();
    return this._push($524867ba9b208546$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($524867ba9b208546$var$writeByte, 1, value ? 1 : 0);
};
function $524867ba9b208546$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($524867ba9b208546$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.sfixed32 = $524867ba9b208546$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value);
    return this._push($524867ba9b208546$var$writeFixed32, 4, bits.lo)._push($524867ba9b208546$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.sfixed64 = $524867ba9b208546$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.float = function write_float(value) {
    return this._push($fK14h.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.double = function write_double(value) {
    return this._push($fK14h.float.writeDoubleLE, 8, value);
};
var $524867ba9b208546$var$writeBytes = $fK14h.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($524867ba9b208546$var$writeByte, 1, 0);
    if ($fK14h.isString(value)) {
        var buf = $524867ba9b208546$var$Writer.alloc(len = $524867ba9b208546$var$base64.length(value));
        $524867ba9b208546$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($524867ba9b208546$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.string = function write_string(value) {
    var len = $524867ba9b208546$var$utf8.length(value);
    return len ? this.uint32(len)._push($524867ba9b208546$var$utf8.write, len, value) : this._push($524867ba9b208546$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.fork = function fork() {
    this.states = new $524867ba9b208546$var$State(this);
    this.head = this.tail = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $524867ba9b208546$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$524867ba9b208546$var$Writer._configure = function(BufferWriter_) {
    $524867ba9b208546$var$BufferWriter = BufferWriter_;
    $524867ba9b208546$var$Writer.create = $524867ba9b208546$var$create();
    $524867ba9b208546$var$BufferWriter._configure();
};

});
parcelRegister("fK14h", function(module, exports) {
"use strict";
var $b75bfaf55b32d107$var$util = module.exports;

// used to return a Promise where callback is omitted
$b75bfaf55b32d107$var$util.asPromise = (parcelRequire("4kb80"));

// converts to / from base64 encoded strings
$b75bfaf55b32d107$var$util.base64 = (parcelRequire("1U6dm"));

// base class of rpc.Service
$b75bfaf55b32d107$var$util.EventEmitter = (parcelRequire("4BOh8"));

// float handling accross browsers
$b75bfaf55b32d107$var$util.float = (parcelRequire("fQJez"));

// requires modules optionally and hides the call from bundlers
$b75bfaf55b32d107$var$util.inquire = (parcelRequire("8PAo2"));

// converts to / from utf8 encoded strings
$b75bfaf55b32d107$var$util.utf8 = (parcelRequire("lgVql"));

// provides a node-like buffer pool in the browser
$b75bfaf55b32d107$var$util.pool = (parcelRequire("g3IvT"));

// utility to work with the low and high bits of a 64 bit value
$b75bfaf55b32d107$var$util.LongBits = (parcelRequire("bDI60"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $b75bfaf55b32d107$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $b75bfaf55b32d107$var$util.global = $b75bfaf55b32d107$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $b75bfaf55b32d107$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $b75bfaf55b32d107$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $b75bfaf55b32d107$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $b75bfaf55b32d107$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $b75bfaf55b32d107$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $b75bfaf55b32d107$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $b75bfaf55b32d107$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $b75bfaf55b32d107$var$util.Buffer = function() {
    try {
        var Buffer = $b75bfaf55b32d107$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$b75bfaf55b32d107$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$b75bfaf55b32d107$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $b75bfaf55b32d107$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $b75bfaf55b32d107$var$util.Buffer ? $b75bfaf55b32d107$var$util._Buffer_allocUnsafe(sizeOrArray) : new $b75bfaf55b32d107$var$util.Array(sizeOrArray) : $b75bfaf55b32d107$var$util.Buffer ? $b75bfaf55b32d107$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $b75bfaf55b32d107$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $b75bfaf55b32d107$var$util.Long = /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.dcodeIO && /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.Long || $b75bfaf55b32d107$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $b75bfaf55b32d107$var$util.longToHash = function longToHash(value) {
    return value ? $b75bfaf55b32d107$var$util.LongBits.from(value).toHash() : $b75bfaf55b32d107$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $b75bfaf55b32d107$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $b75bfaf55b32d107$var$util.LongBits.fromHash(hash);
    if ($b75bfaf55b32d107$var$util.Long) return $b75bfaf55b32d107$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $b75bfaf55b32d107$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$b75bfaf55b32d107$var$util.merge = $b75bfaf55b32d107$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $b75bfaf55b32d107$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $b75bfaf55b32d107$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $b75bfaf55b32d107$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$b75bfaf55b32d107$var$util.newError = $b75bfaf55b32d107$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $b75bfaf55b32d107$var$util.ProtocolError = $b75bfaf55b32d107$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $b75bfaf55b32d107$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $b75bfaf55b32d107$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $b75bfaf55b32d107$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$b75bfaf55b32d107$var$util._configure = function() {
    var Buffer = $b75bfaf55b32d107$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $b75bfaf55b32d107$var$util._Buffer_from = $b75bfaf55b32d107$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $b75bfaf55b32d107$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $b75bfaf55b32d107$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("4kb80", function(module, exports) {
"use strict";
module.exports = $3261a98357726230$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $3261a98357726230$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("1U6dm", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $162fd77556348d84$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $162fd77556348d84$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $162fd77556348d84$var$b64 = new Array(64);
// Base64 decoding table
var $162fd77556348d84$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $162fd77556348d84$var$i = 0; $162fd77556348d84$var$i < 64;)$162fd77556348d84$var$s64[$162fd77556348d84$var$b64[$162fd77556348d84$var$i] = $162fd77556348d84$var$i < 26 ? $162fd77556348d84$var$i + 65 : $162fd77556348d84$var$i < 52 ? $162fd77556348d84$var$i + 71 : $162fd77556348d84$var$i < 62 ? $162fd77556348d84$var$i - 4 : $162fd77556348d84$var$i - 59 | 43] = $162fd77556348d84$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $162fd77556348d84$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $162fd77556348d84$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $162fd77556348d84$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $162fd77556348d84$var$b64[t | b >> 6];
                chunk[i++] = $162fd77556348d84$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $162fd77556348d84$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $162fd77556348d84$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $162fd77556348d84$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $162fd77556348d84$var$s64[c]) === undefined) throw Error($162fd77556348d84$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($162fd77556348d84$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $162fd77556348d84$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("4BOh8", function(module, exports) {
"use strict";
module.exports = $35b19dc581739756$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $35b19dc581739756$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("fQJez", function(module, exports) {
"use strict";
module.exports = $b89eccdf9e00ce53$var$factory($b89eccdf9e00ce53$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $b89eccdf9e00ce53$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $b89eccdf9e00ce53$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $b89eccdf9e00ce53$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $b89eccdf9e00ce53$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $b89eccdf9e00ce53$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("8PAo2", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRegister("lgVql", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $f7c7a2cdd3358709$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $f7c7a2cdd3358709$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $f7c7a2cdd3358709$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $f7c7a2cdd3358709$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("g3IvT", function(module, exports) {
"use strict";
module.exports = $bb0f74988a25d628$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $bb0f74988a25d628$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("bDI60", function(module, exports) {
"use strict";
module.exports = $87958abfc7ed58e3$var$LongBits;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $87958abfc7ed58e3$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $87958abfc7ed58e3$var$zero = $87958abfc7ed58e3$var$LongBits.zero = new $87958abfc7ed58e3$var$LongBits(0, 0);
$87958abfc7ed58e3$var$zero.toNumber = function() {
    return 0;
};
$87958abfc7ed58e3$var$zero.zzEncode = $87958abfc7ed58e3$var$zero.zzDecode = function() {
    return this;
};
$87958abfc7ed58e3$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $87958abfc7ed58e3$var$zeroHash = $87958abfc7ed58e3$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $87958abfc7ed58e3$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $87958abfc7ed58e3$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $87958abfc7ed58e3$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $87958abfc7ed58e3$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $87958abfc7ed58e3$var$LongBits.fromNumber(value);
    if ($fK14h.isString(value)) {
        /* istanbul ignore else */ if ($fK14h.Long) value = $fK14h.Long.fromString(value);
        else return $87958abfc7ed58e3$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $87958abfc7ed58e3$var$LongBits(value.low >>> 0, value.high >>> 0) : $87958abfc7ed58e3$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $87958abfc7ed58e3$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $87958abfc7ed58e3$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $fK14h.Long ? new $fK14h.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $87958abfc7ed58e3$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $87958abfc7ed58e3$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $87958abfc7ed58e3$var$zeroHash) return $87958abfc7ed58e3$var$zero;
    return new $87958abfc7ed58e3$var$LongBits(($87958abfc7ed58e3$var$charCodeAt.call(hash, 0) | $87958abfc7ed58e3$var$charCodeAt.call(hash, 1) << 8 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 2) << 16 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($87958abfc7ed58e3$var$charCodeAt.call(hash, 4) | $87958abfc7ed58e3$var$charCodeAt.call(hash, 5) << 8 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 6) << 16 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $87958abfc7ed58e3$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $87958abfc7ed58e3$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $87958abfc7ed58e3$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $87958abfc7ed58e3$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("6oXFW", function(module, exports) {
"use strict";
module.exports = $4a9346486373df92$var$BufferWriter;

var $73ZlY = parcelRequire("73ZlY");
($4a9346486373df92$var$BufferWriter.prototype = Object.create($73ZlY.prototype)).constructor = $4a9346486373df92$var$BufferWriter;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $4a9346486373df92$var$BufferWriter() {
    $73ZlY.call(this);
}
$4a9346486373df92$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $4a9346486373df92$var$BufferWriter.alloc = $fK14h._Buffer_allocUnsafe;
    $4a9346486373df92$var$BufferWriter.writeBytesBuffer = $fK14h.Buffer && $fK14h.Buffer.prototype instanceof Uint8Array && $fK14h.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $4a9346486373df92$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($fK14h.isString(value)) value = $fK14h._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($4a9346486373df92$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $4a9346486373df92$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $fK14h.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $4a9346486373df92$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $fK14h.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($4a9346486373df92$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $4a9346486373df92$var$BufferWriter._configure();

});

parcelRegister("jNsDJ", function(module, exports) {
"use strict";
module.exports = $e698cf366e13f6cc$var$Reader;

var $fK14h = parcelRequire("fK14h");
var $e698cf366e13f6cc$var$BufferReader; // cyclic
var $e698cf366e13f6cc$var$LongBits = $fK14h.LongBits, $e698cf366e13f6cc$var$utf8 = $fK14h.utf8;
/* istanbul ignore next */ function $e698cf366e13f6cc$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $e698cf366e13f6cc$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $e698cf366e13f6cc$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $e698cf366e13f6cc$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $e698cf366e13f6cc$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $e698cf366e13f6cc$var$create = function create() {
    return $fK14h.Buffer ? function create_buffer_setup(buffer) {
        return ($e698cf366e13f6cc$var$Reader.create = function create_buffer(buffer) {
            return $fK14h.Buffer.isBuffer(buffer) ? new $e698cf366e13f6cc$var$BufferReader(buffer) : $e698cf366e13f6cc$var$create_array(buffer);
        })(buffer);
    } : $e698cf366e13f6cc$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $e698cf366e13f6cc$var$Reader.create = $e698cf366e13f6cc$var$create();
$e698cf366e13f6cc$var$Reader.prototype._slice = $fK14h.Array.prototype.subarray || /* istanbul ignore next */ $fK14h.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $e698cf366e13f6cc$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $e698cf366e13f6cc$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $e698cf366e13f6cc$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $e698cf366e13f6cc$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    return $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    return $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $e698cf366e13f6cc$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 8);
    return new $e698cf366e13f6cc$var$LongBits($e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4), $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    var value = $fK14h.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    var value = $fK14h.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $e698cf366e13f6cc$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $e698cf366e13f6cc$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $e698cf366e13f6cc$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$e698cf366e13f6cc$var$Reader._configure = function(BufferReader_) {
    $e698cf366e13f6cc$var$BufferReader = BufferReader_;
    $e698cf366e13f6cc$var$Reader.create = $e698cf366e13f6cc$var$create();
    $e698cf366e13f6cc$var$BufferReader._configure();
    var fn = $fK14h.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $fK14h.merge($e698cf366e13f6cc$var$Reader.prototype, {
        int64: function read_int64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $e698cf366e13f6cc$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $e698cf366e13f6cc$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("kDrIk", function(module, exports) {
"use strict";
module.exports = $f05cf291b5626a0a$var$BufferReader;

var $jNsDJ = parcelRequire("jNsDJ");
($f05cf291b5626a0a$var$BufferReader.prototype = Object.create($jNsDJ.prototype)).constructor = $f05cf291b5626a0a$var$BufferReader;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $f05cf291b5626a0a$var$BufferReader(buffer) {
    $jNsDJ.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$f05cf291b5626a0a$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($fK14h.Buffer) $f05cf291b5626a0a$var$BufferReader.prototype._slice = $fK14h.Buffer.prototype.slice;
};
/**
 * @override
 */ $f05cf291b5626a0a$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $f05cf291b5626a0a$var$BufferReader._configure();

});

parcelRegister("cFFQd", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $9399c52e3a844204$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $9399c52e3a844204$var$rpc.Service = (parcelRequire("k0kEe"));

});
parcelRegister("k0kEe", function(module, exports) {
"use strict";
module.exports = $e903d2f6365c046a$var$Service;

var $fK14h = parcelRequire("fK14h");
// Extends EventEmitter
($e903d2f6365c046a$var$Service.prototype = Object.create($fK14h.EventEmitter.prototype)).constructor = $e903d2f6365c046a$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $e903d2f6365c046a$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $fK14h.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $e903d2f6365c046a$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $fK14h.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $e903d2f6365c046a$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("eFuHd", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});




parcelRegister("kz1pS", function(module, exports) {
"use strict";
var $ef882ccf8f3548b9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgMultiSendResponse = module.exports.MsgMultiSend = module.exports.MsgSendResponse = module.exports.MsgSend = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ef882ccf8f3548b9$var$long_1 = $ef882ccf8f3548b9$var$__importDefault((parcelRequire("jRkuS")));

const $ef882ccf8f3548b9$var$minimal_1 = $ef882ccf8f3548b9$var$__importDefault((parcelRequire("fQBv0")));

var $9QyHq = parcelRequire("9QyHq");

var $1LyaC = parcelRequire("1LyaC");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $ef882ccf8f3548b9$var$createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
module.exports.MsgSend = {
    encode (message, writer = $ef882ccf8f3548b9$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$9QyHq.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef882ccf8f3548b9$var$minimal_1.default.Reader ? input : new $ef882ccf8f3548b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef882ccf8f3548b9$var$createBaseMsgSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: $ef882ccf8f3548b9$var$isSet(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: $ef882ccf8f3548b9$var$isSet(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $ef882ccf8f3548b9$var$createBaseMsgSend();
        message.fromAddress = (_a = object.fromAddress) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $ef882ccf8f3548b9$var$createBaseMsgSendResponse() {
    return {};
}
module.exports.MsgSendResponse = {
    encode (_, writer = $ef882ccf8f3548b9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef882ccf8f3548b9$var$minimal_1.default.Reader ? input : new $ef882ccf8f3548b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef882ccf8f3548b9$var$createBaseMsgSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ef882ccf8f3548b9$var$createBaseMsgSendResponse();
        return message;
    }
};
function $ef882ccf8f3548b9$var$createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: []
    };
}
module.exports.MsgMultiSend = {
    encode (message, writer = $ef882ccf8f3548b9$var$minimal_1.default.Writer.create()) {
        for (const v of message.inputs)$1LyaC.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$1LyaC.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef882ccf8f3548b9$var$minimal_1.default.Reader ? input : new $ef882ccf8f3548b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef882ccf8f3548b9$var$createBaseMsgMultiSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($1LyaC.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($1LyaC.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inputs: Array.isArray(object === null || object === void 0 ? void 0 : object.inputs) ? object.inputs.map((e)=>$1LyaC.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object === null || object === void 0 ? void 0 : object.outputs) ? object.outputs.map((e)=>$1LyaC.Output.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $1LyaC.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $1LyaC.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ef882ccf8f3548b9$var$createBaseMsgMultiSend();
        message.inputs = ((_a = object.inputs) === null || _a === void 0 ? void 0 : _a.map((e)=>$1LyaC.Input.fromPartial(e))) || [];
        message.outputs = ((_b = object.outputs) === null || _b === void 0 ? void 0 : _b.map((e)=>$1LyaC.Output.fromPartial(e))) || [];
        return message;
    }
};
function $ef882ccf8f3548b9$var$createBaseMsgMultiSendResponse() {
    return {};
}
module.exports.MsgMultiSendResponse = {
    encode (_, writer = $ef882ccf8f3548b9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef882ccf8f3548b9$var$minimal_1.default.Reader ? input : new $ef882ccf8f3548b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef882ccf8f3548b9$var$createBaseMsgMultiSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ef882ccf8f3548b9$var$createBaseMsgMultiSendResponse();
        return message;
    }
};
if ($ef882ccf8f3548b9$var$minimal_1.default.util.Long !== $ef882ccf8f3548b9$var$long_1.default) {
    $ef882ccf8f3548b9$var$minimal_1.default.util.Long = $ef882ccf8f3548b9$var$long_1.default;
    $ef882ccf8f3548b9$var$minimal_1.default.configure();
}
function $ef882ccf8f3548b9$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("9QyHq", function(module, exports) {
"use strict";
var $72b3e2f57d04b2f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $72b3e2f57d04b2f9$var$long_1 = $72b3e2f57d04b2f9$var$__importDefault((parcelRequire("jRkuS")));

const $72b3e2f57d04b2f9$var$minimal_1 = $72b3e2f57d04b2f9$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "cosmos.base.v1beta1";
function $72b3e2f57d04b2f9$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.Coin = {
    encode (message, writer = $72b3e2f57d04b2f9$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $72b3e2f57d04b2f9$var$minimal_1.default.Reader ? input : new $72b3e2f57d04b2f9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $72b3e2f57d04b2f9$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $72b3e2f57d04b2f9$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $72b3e2f57d04b2f9$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $72b3e2f57d04b2f9$var$createBaseCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $72b3e2f57d04b2f9$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.DecCoin = {
    encode (message, writer = $72b3e2f57d04b2f9$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $72b3e2f57d04b2f9$var$minimal_1.default.Reader ? input : new $72b3e2f57d04b2f9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $72b3e2f57d04b2f9$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $72b3e2f57d04b2f9$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $72b3e2f57d04b2f9$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $72b3e2f57d04b2f9$var$createBaseDecCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $72b3e2f57d04b2f9$var$createBaseIntProto() {
    return {
        int: ""
    };
}
module.exports.IntProto = {
    encode (message, writer = $72b3e2f57d04b2f9$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $72b3e2f57d04b2f9$var$minimal_1.default.Reader ? input : new $72b3e2f57d04b2f9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $72b3e2f57d04b2f9$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: $72b3e2f57d04b2f9$var$isSet(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $72b3e2f57d04b2f9$var$createBaseIntProto();
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $72b3e2f57d04b2f9$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
module.exports.DecProto = {
    encode (message, writer = $72b3e2f57d04b2f9$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $72b3e2f57d04b2f9$var$minimal_1.default.Reader ? input : new $72b3e2f57d04b2f9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $72b3e2f57d04b2f9$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: $72b3e2f57d04b2f9$var$isSet(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $72b3e2f57d04b2f9$var$createBaseDecProto();
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
if ($72b3e2f57d04b2f9$var$minimal_1.default.util.Long !== $72b3e2f57d04b2f9$var$long_1.default) {
    $72b3e2f57d04b2f9$var$minimal_1.default.util.Long = $72b3e2f57d04b2f9$var$long_1.default;
    $72b3e2f57d04b2f9$var$minimal_1.default.configure();
}
function $72b3e2f57d04b2f9$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("1LyaC", function(module, exports) {
"use strict";
var $1494afbc10ede711$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Metadata = module.exports.DenomUnit = module.exports.Supply = module.exports.Output = module.exports.Input = module.exports.SendEnabled = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $1494afbc10ede711$var$long_1 = $1494afbc10ede711$var$__importDefault((parcelRequire("jRkuS")));

const $1494afbc10ede711$var$minimal_1 = $1494afbc10ede711$var$__importDefault((parcelRequire("fQBv0")));

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $1494afbc10ede711$var$createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false
    };
}
module.exports.Params = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        for (const v of message.sendEnabled)module.exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push(module.exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.sendEnabled) ? object.sendEnabled.map((e)=>module.exports.SendEnabled.fromJSON(e)) : [],
            defaultSendEnabled: $1494afbc10ede711$var$isSet(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? module.exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $1494afbc10ede711$var$createBaseParams();
        message.sendEnabled = ((_a = object.sendEnabled) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SendEnabled.fromPartial(e))) || [];
        message.defaultSendEnabled = (_b = object.defaultSendEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
function $1494afbc10ede711$var$createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false
    };
}
module.exports.SendEnabled = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $1494afbc10ede711$var$isSet(object.denom) ? String(object.denom) : "",
            enabled: $1494afbc10ede711$var$isSet(object.enabled) ? Boolean(object.enabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $1494afbc10ede711$var$createBaseSendEnabled();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
function $1494afbc10ede711$var$createBaseInput() {
    return {
        address: "",
        coins: []
    };
}
module.exports.Input = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$9QyHq.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseInput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $1494afbc10ede711$var$isSet(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $1494afbc10ede711$var$createBaseInput();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $1494afbc10ede711$var$createBaseOutput() {
    return {
        address: "",
        coins: []
    };
}
module.exports.Output = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$9QyHq.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseOutput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $1494afbc10ede711$var$isSet(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $1494afbc10ede711$var$createBaseOutput();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $1494afbc10ede711$var$createBaseSupply() {
    return {
        total: []
    };
}
module.exports.Supply = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        for (const v of message.total)$9QyHq.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseSupply();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1494afbc10ede711$var$createBaseSupply();
        message.total = ((_a = object.total) === null || _a === void 0 ? void 0 : _a.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $1494afbc10ede711$var$createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: []
    };
}
module.exports.DenomUnit = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseDenomUnit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $1494afbc10ede711$var$isSet(object.denom) ? String(object.denom) : "",
            exponent: $1494afbc10ede711$var$isSet(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object === null || object === void 0 ? void 0 : object.aliases) ? object.aliases.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $1494afbc10ede711$var$createBaseDenomUnit();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.exponent = (_b = object.exponent) !== null && _b !== void 0 ? _b : 0;
        message.aliases = ((_c = object.aliases) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
function $1494afbc10ede711$var$createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: ""
    };
}
module.exports.Metadata = {
    encode (message, writer = $1494afbc10ede711$var$minimal_1.default.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)module.exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1494afbc10ede711$var$minimal_1.default.Reader ? input : new $1494afbc10ede711$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1494afbc10ede711$var$createBaseMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(module.exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: $1494afbc10ede711$var$isSet(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object === null || object === void 0 ? void 0 : object.denomUnits) ? object.denomUnits.map((e)=>module.exports.DenomUnit.fromJSON(e)) : [],
            base: $1494afbc10ede711$var$isSet(object.base) ? String(object.base) : "",
            display: $1494afbc10ede711$var$isSet(object.display) ? String(object.display) : "",
            name: $1494afbc10ede711$var$isSet(object.name) ? String(object.name) : "",
            symbol: $1494afbc10ede711$var$isSet(object.symbol) ? String(object.symbol) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? module.exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $1494afbc10ede711$var$createBaseMetadata();
        message.description = (_a = object.description) !== null && _a !== void 0 ? _a : "";
        message.denomUnits = ((_b = object.denomUnits) === null || _b === void 0 ? void 0 : _b.map((e)=>module.exports.DenomUnit.fromPartial(e))) || [];
        message.base = (_c = object.base) !== null && _c !== void 0 ? _c : "";
        message.display = (_d = object.display) !== null && _d !== void 0 ? _d : "";
        message.name = (_e = object.name) !== null && _e !== void 0 ? _e : "";
        message.symbol = (_f = object.symbol) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
if ($1494afbc10ede711$var$minimal_1.default.util.Long !== $1494afbc10ede711$var$long_1.default) {
    $1494afbc10ede711$var$minimal_1.default.util.Long = $1494afbc10ede711$var$long_1.default;
    $1494afbc10ede711$var$minimal_1.default.configure();
}
function $1494afbc10ede711$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("7Phca", function(module, exports) {
"use strict";
var $5b2aa27086e3c58a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgUndelegateResponse = module.exports.MsgUndelegate = module.exports.MsgBeginRedelegateResponse = module.exports.MsgBeginRedelegate = module.exports.MsgDelegateResponse = module.exports.MsgDelegate = module.exports.MsgEditValidatorResponse = module.exports.MsgEditValidator = module.exports.MsgCreateValidatorResponse = module.exports.MsgCreateValidator = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $5b2aa27086e3c58a$var$long_1 = $5b2aa27086e3c58a$var$__importDefault((parcelRequire("jRkuS")));

const $5b2aa27086e3c58a$var$minimal_1 = $5b2aa27086e3c58a$var$__importDefault((parcelRequire("fQBv0")));

var $xgb9l = parcelRequire("xgb9l");

var $2qK3B = parcelRequire("2qK3B");

var $5fiTY = parcelRequire("5fiTY");

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
function $5b2aa27086e3c58a$var$createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined
    };
}
module.exports.MsgCreateValidator = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $2qK3B.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $2qK3B.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $5fiTY.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $9QyHq.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgCreateValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $2qK3B.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $2qK3B.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: $5b2aa27086e3c58a$var$isSet(object.description) ? $2qK3B.Description.fromJSON(object.description) : undefined,
            commission: $5b2aa27086e3c58a$var$isSet(object.commission) ? $2qK3B.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: $5b2aa27086e3c58a$var$isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: $5b2aa27086e3c58a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $5b2aa27086e3c58a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: $5b2aa27086e3c58a$var$isSet(object.pubkey) ? $5fiTY.Any.fromJSON(object.pubkey) : undefined,
            value: $5b2aa27086e3c58a$var$isSet(object.value) ? $9QyHq.Coin.fromJSON(object.value) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $2qK3B.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $2qK3B.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $5fiTY.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $9QyHq.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5b2aa27086e3c58a$var$createBaseMsgCreateValidator();
        message.description = object.description !== undefined && object.description !== null ? $2qK3B.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $2qK3B.CommissionRates.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = (_a = object.minSelfDelegation) !== null && _a !== void 0 ? _a : "";
        message.delegatorAddress = (_b = object.delegatorAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorAddress = (_c = object.validatorAddress) !== null && _c !== void 0 ? _c : "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $5fiTY.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $9QyHq.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgCreateValidatorResponse() {
    return {};
}
module.exports.MsgCreateValidatorResponse = {
    encode (_, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgCreateValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $5b2aa27086e3c58a$var$createBaseMsgCreateValidatorResponse();
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: ""
    };
}
module.exports.MsgEditValidator = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $2qK3B.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgEditValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $2qK3B.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: $5b2aa27086e3c58a$var$isSet(object.description) ? $2qK3B.Description.fromJSON(object.description) : undefined,
            validatorAddress: $5b2aa27086e3c58a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: $5b2aa27086e3c58a$var$isSet(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: $5b2aa27086e3c58a$var$isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $2qK3B.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5b2aa27086e3c58a$var$createBaseMsgEditValidator();
        message.description = object.description !== undefined && object.description !== null ? $2qK3B.Description.fromPartial(object.description) : undefined;
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.commissionRate = (_b = object.commissionRate) !== null && _b !== void 0 ? _b : "";
        message.minSelfDelegation = (_c = object.minSelfDelegation) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgEditValidatorResponse() {
    return {};
}
module.exports.MsgEditValidatorResponse = {
    encode (_, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgEditValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $5b2aa27086e3c58a$var$createBaseMsgEditValidatorResponse();
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgDelegate = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $9QyHq.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgDelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5b2aa27086e3c58a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $5b2aa27086e3c58a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: $5b2aa27086e3c58a$var$isSet(object.amount) ? $9QyHq.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $9QyHq.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5b2aa27086e3c58a$var$createBaseMsgDelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $9QyHq.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgDelegateResponse() {
    return {};
}
module.exports.MsgDelegateResponse = {
    encode (_, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $5b2aa27086e3c58a$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined
    };
}
module.exports.MsgBeginRedelegate = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $9QyHq.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgBeginRedelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5b2aa27086e3c58a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: $5b2aa27086e3c58a$var$isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: $5b2aa27086e3c58a$var$isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: $5b2aa27086e3c58a$var$isSet(object.amount) ? $9QyHq.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $9QyHq.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5b2aa27086e3c58a$var$createBaseMsgBeginRedelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $9QyHq.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $xgb9l.Timestamp.encode($5b2aa27086e3c58a$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgBeginRedelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $5b2aa27086e3c58a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: $5b2aa27086e3c58a$var$isSet(object.completionTime) ? $5b2aa27086e3c58a$var$fromJsonTimestamp(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5b2aa27086e3c58a$var$createBaseMsgBeginRedelegateResponse();
        message.completionTime = (_a = object.completionTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgUndelegate = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $9QyHq.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5b2aa27086e3c58a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $5b2aa27086e3c58a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: $5b2aa27086e3c58a$var$isSet(object.amount) ? $9QyHq.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $9QyHq.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5b2aa27086e3c58a$var$createBaseMsgUndelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $9QyHq.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $5b2aa27086e3c58a$var$createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgUndelegateResponse = {
    encode (message, writer = $5b2aa27086e3c58a$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $xgb9l.Timestamp.encode($5b2aa27086e3c58a$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5b2aa27086e3c58a$var$minimal_1.default.Reader ? input : new $5b2aa27086e3c58a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5b2aa27086e3c58a$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $5b2aa27086e3c58a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: $5b2aa27086e3c58a$var$isSet(object.completionTime) ? $5b2aa27086e3c58a$var$fromJsonTimestamp(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5b2aa27086e3c58a$var$createBaseMsgUndelegateResponse();
        message.completionTime = (_a = object.completionTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $5b2aa27086e3c58a$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $5b2aa27086e3c58a$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $5b2aa27086e3c58a$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $5b2aa27086e3c58a$var$fromTimestamp($xgb9l.Timestamp.fromJSON(o));
}
if ($5b2aa27086e3c58a$var$minimal_1.default.util.Long !== $5b2aa27086e3c58a$var$long_1.default) {
    $5b2aa27086e3c58a$var$minimal_1.default.util.Long = $5b2aa27086e3c58a$var$long_1.default;
    $5b2aa27086e3c58a$var$minimal_1.default.configure();
}
function $5b2aa27086e3c58a$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("xgb9l", function(module, exports) {
"use strict";
var $063fa1f6384d686a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timestamp = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $063fa1f6384d686a$var$long_1 = $063fa1f6384d686a$var$__importDefault((parcelRequire("jRkuS")));

const $063fa1f6384d686a$var$minimal_1 = $063fa1f6384d686a$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "google.protobuf";
function $063fa1f6384d686a$var$createBaseTimestamp() {
    return {
        seconds: "0",
        nanos: 0
    };
}
module.exports.Timestamp = {
    encode (message, writer = $063fa1f6384d686a$var$minimal_1.default.Writer.create()) {
        if (message.seconds !== "0") writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $063fa1f6384d686a$var$minimal_1.default.Reader ? input : new $063fa1f6384d686a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $063fa1f6384d686a$var$createBaseTimestamp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = $063fa1f6384d686a$var$longToString(reader.int64());
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: $063fa1f6384d686a$var$isSet(object.seconds) ? String(object.seconds) : "0",
            nanos: $063fa1f6384d686a$var$isSet(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = message.seconds);
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $063fa1f6384d686a$var$createBaseTimestamp();
        message.seconds = (_a = object.seconds) !== null && _a !== void 0 ? _a : "0";
        message.nanos = (_b = object.nanos) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function $063fa1f6384d686a$var$longToString(long) {
    return long.toString();
}
if ($063fa1f6384d686a$var$minimal_1.default.util.Long !== $063fa1f6384d686a$var$long_1.default) {
    $063fa1f6384d686a$var$minimal_1.default.util.Long = $063fa1f6384d686a$var$long_1.default;
    $063fa1f6384d686a$var$minimal_1.default.configure();
}
function $063fa1f6384d686a$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("2qK3B", function(module, exports) {
"use strict";
var $1c51bc7b9449e22a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pool = module.exports.RedelegationResponse = module.exports.RedelegationEntryResponse = module.exports.DelegationResponse = module.exports.Params = module.exports.Redelegation = module.exports.RedelegationEntry = module.exports.UnbondingDelegationEntry = module.exports.UnbondingDelegation = module.exports.Delegation = module.exports.DVVTriplets = module.exports.DVVTriplet = module.exports.DVPairs = module.exports.DVPair = module.exports.ValAddresses = module.exports.Validator = module.exports.Description = module.exports.Commission = module.exports.CommissionRates = module.exports.HistoricalInfo = module.exports.bondStatusToJSON = module.exports.bondStatusFromJSON = module.exports.BondStatus = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $1c51bc7b9449e22a$var$long_1 = $1c51bc7b9449e22a$var$__importDefault((parcelRequire("jRkuS")));

const $1c51bc7b9449e22a$var$minimal_1 = $1c51bc7b9449e22a$var$__importDefault((parcelRequire("fQBv0")));

var $xgb9l = parcelRequire("xgb9l");

var $jkyee = parcelRequire("jkyee");

var $5fiTY = parcelRequire("5fiTY");

var $lM6jn = parcelRequire("lM6jn");

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $1c51bc7b9449e22a$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1c51bc7b9449e22a$var$BondStatus = module.exports.BondStatus || (module.exports.BondStatus = {}));
function $1c51bc7b9449e22a$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1c51bc7b9449e22a$var$BondStatus.UNRECOGNIZED;
    }
}
module.exports.bondStatusFromJSON = $1c51bc7b9449e22a$var$bondStatusFromJSON;
function $1c51bc7b9449e22a$var$bondStatusToJSON(object) {
    switch(object){
        case $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $1c51bc7b9449e22a$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        default:
            return "UNKNOWN";
    }
}
module.exports.bondStatusToJSON = $1c51bc7b9449e22a$var$bondStatusToJSON;
function $1c51bc7b9449e22a$var$createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: []
    };
}
module.exports.HistoricalInfo = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) $jkyee.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)module.exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseHistoricalInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $jkyee.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: $1c51bc7b9449e22a$var$isSet(object.header) ? $jkyee.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object === null || object === void 0 ? void 0 : object.valset) ? object.valset.map((e)=>module.exports.Validator.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $jkyee.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseHistoricalInfo();
        message.header = object.header !== undefined && object.header !== null ? $jkyee.Header.fromPartial(object.header) : undefined;
        message.valset = ((_a = object.valset) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.Validator.fromPartial(e))) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: ""
    };
}
module.exports.CommissionRates = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseCommissionRates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rate: $1c51bc7b9449e22a$var$isSet(object.rate) ? String(object.rate) : "",
            maxRate: $1c51bc7b9449e22a$var$isSet(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: $1c51bc7b9449e22a$var$isSet(object.maxChangeRate) ? String(object.maxChangeRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $1c51bc7b9449e22a$var$createBaseCommissionRates();
        message.rate = (_a = object.rate) !== null && _a !== void 0 ? _a : "";
        message.maxRate = (_b = object.maxRate) !== null && _b !== void 0 ? _b : "";
        message.maxChangeRate = (_c = object.maxChangeRate) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined
    };
}
module.exports.Commission = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.commissionRates !== undefined) module.exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $xgb9l.Timestamp.encode($1c51bc7b9449e22a$var$toTimestamp(message.updateTime), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = module.exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $1c51bc7b9449e22a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commissionRates: $1c51bc7b9449e22a$var$isSet(object.commissionRates) ? module.exports.CommissionRates.fromJSON(object.commissionRates) : undefined,
            updateTime: $1c51bc7b9449e22a$var$isSet(object.updateTime) ? $1c51bc7b9449e22a$var$fromJsonTimestamp(object.updateTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? module.exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseCommission();
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? module.exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = (_a = object.updateTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: ""
    };
}
module.exports.Description = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDescription();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moniker: $1c51bc7b9449e22a$var$isSet(object.moniker) ? String(object.moniker) : "",
            identity: $1c51bc7b9449e22a$var$isSet(object.identity) ? String(object.identity) : "",
            website: $1c51bc7b9449e22a$var$isSet(object.website) ? String(object.website) : "",
            securityContact: $1c51bc7b9449e22a$var$isSet(object.securityContact) ? String(object.securityContact) : "",
            details: $1c51bc7b9449e22a$var$isSet(object.details) ? String(object.details) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $1c51bc7b9449e22a$var$createBaseDescription();
        message.moniker = (_a = object.moniker) !== null && _a !== void 0 ? _a : "";
        message.identity = (_b = object.identity) !== null && _b !== void 0 ? _b : "";
        message.website = (_c = object.website) !== null && _c !== void 0 ? _c : "";
        message.securityContact = (_d = object.securityContact) !== null && _d !== void 0 ? _d : "";
        message.details = (_e = object.details) !== null && _e !== void 0 ? _e : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: "0",
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: ""
    };
}
module.exports.Validator = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $5fiTY.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) module.exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (message.unbondingHeight !== "0") writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $xgb9l.Timestamp.encode($1c51bc7b9449e22a$var$toTimestamp(message.unbondingTime), writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) module.exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = module.exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = $1c51bc7b9449e22a$var$longToString(reader.int64());
                    break;
                case 9:
                    message.unbondingTime = $1c51bc7b9449e22a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.commission = module.exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: $1c51bc7b9449e22a$var$isSet(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: $1c51bc7b9449e22a$var$isSet(object.consensusPubkey) ? $5fiTY.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: $1c51bc7b9449e22a$var$isSet(object.jailed) ? Boolean(object.jailed) : false,
            status: $1c51bc7b9449e22a$var$isSet(object.status) ? $1c51bc7b9449e22a$var$bondStatusFromJSON(object.status) : 0,
            tokens: $1c51bc7b9449e22a$var$isSet(object.tokens) ? String(object.tokens) : "",
            delegatorShares: $1c51bc7b9449e22a$var$isSet(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: $1c51bc7b9449e22a$var$isSet(object.description) ? module.exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: $1c51bc7b9449e22a$var$isSet(object.unbondingHeight) ? String(object.unbondingHeight) : "0",
            unbondingTime: $1c51bc7b9449e22a$var$isSet(object.unbondingTime) ? $1c51bc7b9449e22a$var$fromJsonTimestamp(object.unbondingTime) : undefined,
            commission: $1c51bc7b9449e22a$var$isSet(object.commission) ? module.exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: $1c51bc7b9449e22a$var$isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $5fiTY.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $1c51bc7b9449e22a$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? module.exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = message.unbondingHeight);
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime.toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? module.exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = $1c51bc7b9449e22a$var$createBaseValidator();
        message.operatorAddress = (_a = object.operatorAddress) !== null && _a !== void 0 ? _a : "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $5fiTY.Any.fromPartial(object.consensusPubkey) : undefined;
        message.jailed = (_b = object.jailed) !== null && _b !== void 0 ? _b : false;
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : 0;
        message.tokens = (_d = object.tokens) !== null && _d !== void 0 ? _d : "";
        message.delegatorShares = (_e = object.delegatorShares) !== null && _e !== void 0 ? _e : "";
        message.description = object.description !== undefined && object.description !== null ? module.exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = (_f = object.unbondingHeight) !== null && _f !== void 0 ? _f : "0";
        message.unbondingTime = (_g = object.unbondingTime) !== null && _g !== void 0 ? _g : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? module.exports.Commission.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = (_h = object.minSelfDelegation) !== null && _h !== void 0 ? _h : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseValAddresses() {
    return {
        addresses: []
    };
}
module.exports.ValAddresses = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseValAddresses();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseValAddresses();
        message.addresses = ((_a = object.addresses) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.DVPair = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDVPair();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $1c51bc7b9449e22a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $1c51bc7b9449e22a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $1c51bc7b9449e22a$var$createBaseDVPair();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDVPairs() {
    return {
        pairs: []
    };
}
module.exports.DVPairs = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        for (const v of message.pairs)module.exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDVPairs();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push(module.exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pairs: Array.isArray(object === null || object === void 0 ? void 0 : object.pairs) ? object.pairs.map((e)=>module.exports.DVPair.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? module.exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseDVPairs();
        message.pairs = ((_a = object.pairs) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.DVPair.fromPartial(e))) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: ""
    };
}
module.exports.DVVTriplet = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDVVTriplet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $1c51bc7b9449e22a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: $1c51bc7b9449e22a$var$isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: $1c51bc7b9449e22a$var$isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $1c51bc7b9449e22a$var$createBaseDVVTriplet();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDVVTriplets() {
    return {
        triplets: []
    };
}
module.exports.DVVTriplets = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        for (const v of message.triplets)module.exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDVVTriplets();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push(module.exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            triplets: Array.isArray(object === null || object === void 0 ? void 0 : object.triplets) ? object.triplets.map((e)=>module.exports.DVVTriplet.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? module.exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseDVVTriplets();
        message.triplets = ((_a = object.triplets) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.DVVTriplet.fromPartial(e))) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: ""
    };
}
module.exports.Delegation = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $1c51bc7b9449e22a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $1c51bc7b9449e22a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: $1c51bc7b9449e22a$var$isSet(object.shares) ? String(object.shares) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $1c51bc7b9449e22a$var$createBaseDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.shares = (_c = object.shares) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: []
    };
}
module.exports.UnbondingDelegation = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)module.exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push(module.exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $1c51bc7b9449e22a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $1c51bc7b9449e22a$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e)=>module.exports.UnbondingDelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $1c51bc7b9449e22a$var$createBaseUnbondingDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.entries = ((_c = object.entries) === null || _c === void 0 ? void 0 : _c.map((e)=>module.exports.UnbondingDelegationEntry.fromPartial(e))) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: "0",
        completionTime: undefined,
        initialBalance: "",
        balance: ""
    };
}
module.exports.UnbondingDelegationEntry = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.creationHeight !== "0") writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $xgb9l.Timestamp.encode($1c51bc7b9449e22a$var$toTimestamp(message.completionTime), writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseUnbondingDelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = $1c51bc7b9449e22a$var$longToString(reader.int64());
                    break;
                case 2:
                    message.completionTime = $1c51bc7b9449e22a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: $1c51bc7b9449e22a$var$isSet(object.creationHeight) ? String(object.creationHeight) : "0",
            completionTime: $1c51bc7b9449e22a$var$isSet(object.completionTime) ? $1c51bc7b9449e22a$var$fromJsonTimestamp(object.completionTime) : undefined,
            initialBalance: $1c51bc7b9449e22a$var$isSet(object.initialBalance) ? String(object.initialBalance) : "",
            balance: $1c51bc7b9449e22a$var$isSet(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = message.creationHeight);
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $1c51bc7b9449e22a$var$createBaseUnbondingDelegationEntry();
        message.creationHeight = (_a = object.creationHeight) !== null && _a !== void 0 ? _a : "0";
        message.completionTime = (_b = object.completionTime) !== null && _b !== void 0 ? _b : undefined;
        message.initialBalance = (_c = object.initialBalance) !== null && _c !== void 0 ? _c : "";
        message.balance = (_d = object.balance) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseRedelegationEntry() {
    return {
        creationHeight: "0",
        completionTime: undefined,
        initialBalance: "",
        sharesDst: ""
    };
}
module.exports.RedelegationEntry = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.creationHeight !== "0") writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $xgb9l.Timestamp.encode($1c51bc7b9449e22a$var$toTimestamp(message.completionTime), writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = $1c51bc7b9449e22a$var$longToString(reader.int64());
                    break;
                case 2:
                    message.completionTime = $1c51bc7b9449e22a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: $1c51bc7b9449e22a$var$isSet(object.creationHeight) ? String(object.creationHeight) : "0",
            completionTime: $1c51bc7b9449e22a$var$isSet(object.completionTime) ? $1c51bc7b9449e22a$var$fromJsonTimestamp(object.completionTime) : undefined,
            initialBalance: $1c51bc7b9449e22a$var$isSet(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: $1c51bc7b9449e22a$var$isSet(object.sharesDst) ? String(object.sharesDst) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = message.creationHeight);
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegationEntry();
        message.creationHeight = (_a = object.creationHeight) !== null && _a !== void 0 ? _a : "0";
        message.completionTime = (_b = object.completionTime) !== null && _b !== void 0 ? _b : undefined;
        message.initialBalance = (_c = object.initialBalance) !== null && _c !== void 0 ? _c : "";
        message.sharesDst = (_d = object.sharesDst) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: []
    };
}
module.exports.Redelegation = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)module.exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push(module.exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $1c51bc7b9449e22a$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: $1c51bc7b9449e22a$var$isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: $1c51bc7b9449e22a$var$isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e)=>module.exports.RedelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.entries = ((_d = object.entries) === null || _d === void 0 ? void 0 : _d.map((e)=>module.exports.RedelegationEntry.fromPartial(e))) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: ""
    };
}
module.exports.Params = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.unbondingTime !== undefined) $lM6jn.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $lM6jn.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingTime: $1c51bc7b9449e22a$var$isSet(object.unbondingTime) ? $lM6jn.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: $1c51bc7b9449e22a$var$isSet(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: $1c51bc7b9449e22a$var$isSet(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: $1c51bc7b9449e22a$var$isSet(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: $1c51bc7b9449e22a$var$isSet(object.bondDenom) ? String(object.bondDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $lM6jn.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined && (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $1c51bc7b9449e22a$var$createBaseParams();
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $lM6jn.Duration.fromPartial(object.unbondingTime) : undefined;
        message.maxValidators = (_a = object.maxValidators) !== null && _a !== void 0 ? _a : 0;
        message.maxEntries = (_b = object.maxEntries) !== null && _b !== void 0 ? _b : 0;
        message.historicalEntries = (_c = object.historicalEntries) !== null && _c !== void 0 ? _c : 0;
        message.bondDenom = (_d = object.bondDenom) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined
    };
}
module.exports.DelegationResponse = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.delegation !== undefined) module.exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $9QyHq.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = module.exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegation: $1c51bc7b9449e22a$var$isSet(object.delegation) ? module.exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: $1c51bc7b9449e22a$var$isSet(object.balance) ? $9QyHq.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? module.exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $9QyHq.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $1c51bc7b9449e22a$var$createBaseDelegationResponse();
        message.delegation = object.delegation !== undefined && object.delegation !== null ? module.exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $9QyHq.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: ""
    };
}
module.exports.RedelegationEntryResponse = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.redelegationEntry !== undefined) module.exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegationEntryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = module.exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationEntry: $1c51bc7b9449e22a$var$isSet(object.redelegationEntry) ? module.exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined,
            balance: $1c51bc7b9449e22a$var$isSet(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? module.exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegationEntryResponse();
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? module.exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        message.balance = (_a = object.balance) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: []
    };
}
module.exports.RedelegationResponse = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.redelegation !== undefined) module.exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)module.exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = module.exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push(module.exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegation: $1c51bc7b9449e22a$var$isSet(object.redelegation) ? module.exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e)=>module.exports.RedelegationEntryResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? module.exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $1c51bc7b9449e22a$var$createBaseRedelegationResponse();
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? module.exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.RedelegationEntryResponse.fromPartial(e))) || [];
        return message;
    }
};
function $1c51bc7b9449e22a$var$createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: ""
    };
}
module.exports.Pool = {
    encode (message, writer = $1c51bc7b9449e22a$var$minimal_1.default.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1c51bc7b9449e22a$var$minimal_1.default.Reader ? input : new $1c51bc7b9449e22a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1c51bc7b9449e22a$var$createBasePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            notBondedTokens: $1c51bc7b9449e22a$var$isSet(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: $1c51bc7b9449e22a$var$isSet(object.bondedTokens) ? String(object.bondedTokens) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $1c51bc7b9449e22a$var$createBasePool();
        message.notBondedTokens = (_a = object.notBondedTokens) !== null && _a !== void 0 ? _a : "";
        message.bondedTokens = (_b = object.bondedTokens) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $1c51bc7b9449e22a$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $1c51bc7b9449e22a$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $1c51bc7b9449e22a$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $1c51bc7b9449e22a$var$fromTimestamp($xgb9l.Timestamp.fromJSON(o));
}
function $1c51bc7b9449e22a$var$longToString(long) {
    return long.toString();
}
if ($1c51bc7b9449e22a$var$minimal_1.default.util.Long !== $1c51bc7b9449e22a$var$long_1.default) {
    $1c51bc7b9449e22a$var$minimal_1.default.util.Long = $1c51bc7b9449e22a$var$long_1.default;
    $1c51bc7b9449e22a$var$minimal_1.default.configure();
}
function $1c51bc7b9449e22a$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("jkyee", function(module, exports) {
"use strict";
var $e12a6fa6f406a50c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TxProof = module.exports.BlockMeta = module.exports.LightBlock = module.exports.SignedHeader = module.exports.Proposal = module.exports.CommitSig = module.exports.Commit = module.exports.Vote = module.exports.Data = module.exports.Header = module.exports.BlockID = module.exports.Part = module.exports.PartSetHeader = module.exports.signedMsgTypeToJSON = module.exports.signedMsgTypeFromJSON = module.exports.SignedMsgType = module.exports.blockIDFlagToJSON = module.exports.blockIDFlagFromJSON = module.exports.BlockIDFlag = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $e12a6fa6f406a50c$var$long_1 = $e12a6fa6f406a50c$var$__importDefault((parcelRequire("jRkuS")));

const $e12a6fa6f406a50c$var$minimal_1 = $e12a6fa6f406a50c$var$__importDefault((parcelRequire("fQBv0")));

var $xgb9l = parcelRequire("xgb9l");

var $9LIDg = parcelRequire("9LIDg");

var $8jbeC = parcelRequire("8jbeC");

var $cz32K = parcelRequire("cz32K");
module.exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $e12a6fa6f406a50c$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e12a6fa6f406a50c$var$BlockIDFlag = module.exports.BlockIDFlag || (module.exports.BlockIDFlag = {}));
function $e12a6fa6f406a50c$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e12a6fa6f406a50c$var$BlockIDFlag.UNRECOGNIZED;
    }
}
module.exports.blockIDFlagFromJSON = $e12a6fa6f406a50c$var$blockIDFlagFromJSON;
function $e12a6fa6f406a50c$var$blockIDFlagToJSON(object) {
    switch(object){
        case $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $e12a6fa6f406a50c$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        default:
            return "UNKNOWN";
    }
}
module.exports.blockIDFlagToJSON = $e12a6fa6f406a50c$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $e12a6fa6f406a50c$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e12a6fa6f406a50c$var$SignedMsgType = module.exports.SignedMsgType || (module.exports.SignedMsgType = {}));
function $e12a6fa6f406a50c$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e12a6fa6f406a50c$var$SignedMsgType.UNRECOGNIZED;
    }
}
module.exports.signedMsgTypeFromJSON = $e12a6fa6f406a50c$var$signedMsgTypeFromJSON;
function $e12a6fa6f406a50c$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $e12a6fa6f406a50c$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        default:
            return "UNKNOWN";
    }
}
module.exports.signedMsgTypeToJSON = $e12a6fa6f406a50c$var$signedMsgTypeToJSON;
function $e12a6fa6f406a50c$var$createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array()
    };
}
module.exports.PartSetHeader = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBasePartSetHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: $e12a6fa6f406a50c$var$isSet(object.total) ? Number(object.total) : 0,
            hash: $e12a6fa6f406a50c$var$isSet(object.hash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined && (obj.hash = $e12a6fa6f406a50c$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $e12a6fa6f406a50c$var$createBasePartSetHeader();
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : 0;
        message.hash = (_b = object.hash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined
    };
}
module.exports.Part = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $9LIDg.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBasePart();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $9LIDg.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: $e12a6fa6f406a50c$var$isSet(object.index) ? Number(object.index) : 0,
            bytes: $e12a6fa6f406a50c$var$isSet(object.bytes) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.bytes) : new Uint8Array(),
            proof: $e12a6fa6f406a50c$var$isSet(object.proof) ? $9LIDg.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined && (obj.bytes = $e12a6fa6f406a50c$var$base64FromBytes(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $9LIDg.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $e12a6fa6f406a50c$var$createBasePart();
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.bytes = (_b = object.bytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $9LIDg.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined
    };
}
module.exports.BlockID = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) module.exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseBlockID();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = module.exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: $e12a6fa6f406a50c$var$isSet(object.hash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.hash) : new Uint8Array(),
            partSetHeader: $e12a6fa6f406a50c$var$isSet(object.partSetHeader) ? module.exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $e12a6fa6f406a50c$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? module.exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $e12a6fa6f406a50c$var$createBaseBlockID();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? module.exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: "0",
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
module.exports.Header = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.version !== undefined) $8jbeC.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.height !== "0") writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $xgb9l.Timestamp.encode($e12a6fa6f406a50c$var$toTimestamp(message.time), writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) module.exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $8jbeC.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = $e12a6fa6f406a50c$var$longToString(reader.int64());
                    break;
                case 4:
                    message.time = $e12a6fa6f406a50c$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.lastBlockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: $e12a6fa6f406a50c$var$isSet(object.version) ? $8jbeC.Consensus.fromJSON(object.version) : undefined,
            chainId: $e12a6fa6f406a50c$var$isSet(object.chainId) ? String(object.chainId) : "",
            height: $e12a6fa6f406a50c$var$isSet(object.height) ? String(object.height) : "0",
            time: $e12a6fa6f406a50c$var$isSet(object.time) ? $e12a6fa6f406a50c$var$fromJsonTimestamp(object.time) : undefined,
            lastBlockId: $e12a6fa6f406a50c$var$isSet(object.lastBlockId) ? module.exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: $e12a6fa6f406a50c$var$isSet(object.lastCommitHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.lastCommitHash) : new Uint8Array(),
            dataHash: $e12a6fa6f406a50c$var$isSet(object.dataHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.dataHash) : new Uint8Array(),
            validatorsHash: $e12a6fa6f406a50c$var$isSet(object.validatorsHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.validatorsHash) : new Uint8Array(),
            nextValidatorsHash: $e12a6fa6f406a50c$var$isSet(object.nextValidatorsHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.nextValidatorsHash) : new Uint8Array(),
            consensusHash: $e12a6fa6f406a50c$var$isSet(object.consensusHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.consensusHash) : new Uint8Array(),
            appHash: $e12a6fa6f406a50c$var$isSet(object.appHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.appHash) : new Uint8Array(),
            lastResultsHash: $e12a6fa6f406a50c$var$isSet(object.lastResultsHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.lastResultsHash) : new Uint8Array(),
            evidenceHash: $e12a6fa6f406a50c$var$isSet(object.evidenceHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.evidenceHash) : new Uint8Array(),
            proposerAddress: $e12a6fa6f406a50c$var$isSet(object.proposerAddress) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $8jbeC.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = message.height);
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? module.exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = $e12a6fa6f406a50c$var$base64FromBytes(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = $e12a6fa6f406a50c$var$base64FromBytes(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = $e12a6fa6f406a50c$var$base64FromBytes(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = $e12a6fa6f406a50c$var$base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = $e12a6fa6f406a50c$var$base64FromBytes(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = $e12a6fa6f406a50c$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = $e12a6fa6f406a50c$var$base64FromBytes(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = $e12a6fa6f406a50c$var$base64FromBytes(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = $e12a6fa6f406a50c$var$base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const message = $e12a6fa6f406a50c$var$createBaseHeader();
        message.version = object.version !== undefined && object.version !== null ? $8jbeC.Consensus.fromPartial(object.version) : undefined;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.height = (_b = object.height) !== null && _b !== void 0 ? _b : "0";
        message.time = (_c = object.time) !== null && _c !== void 0 ? _c : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? module.exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        message.lastCommitHash = (_d = object.lastCommitHash) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.dataHash = (_e = object.dataHash) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.validatorsHash = (_f = object.validatorsHash) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.nextValidatorsHash = (_g = object.nextValidatorsHash) !== null && _g !== void 0 ? _g : new Uint8Array();
        message.consensusHash = (_h = object.consensusHash) !== null && _h !== void 0 ? _h : new Uint8Array();
        message.appHash = (_j = object.appHash) !== null && _j !== void 0 ? _j : new Uint8Array();
        message.lastResultsHash = (_k = object.lastResultsHash) !== null && _k !== void 0 ? _k : new Uint8Array();
        message.evidenceHash = (_l = object.evidenceHash) !== null && _l !== void 0 ? _l : new Uint8Array();
        message.proposerAddress = (_m = object.proposerAddress) !== null && _m !== void 0 ? _m : new Uint8Array();
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseData() {
    return {
        txs: []
    };
}
module.exports.Data = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map((e)=>$e12a6fa6f406a50c$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>$e12a6fa6f406a50c$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $e12a6fa6f406a50c$var$createBaseData();
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseVote() {
    return {
        type: 0,
        height: "0",
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array()
    };
}
module.exports.Vote = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.height !== "0") writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $xgb9l.Timestamp.encode($e12a6fa6f406a50c$var$toTimestamp(message.timestamp), writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = $e12a6fa6f406a50c$var$longToString(reader.int64());
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $e12a6fa6f406a50c$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: $e12a6fa6f406a50c$var$isSet(object.type) ? $e12a6fa6f406a50c$var$signedMsgTypeFromJSON(object.type) : 0,
            height: $e12a6fa6f406a50c$var$isSet(object.height) ? String(object.height) : "0",
            round: $e12a6fa6f406a50c$var$isSet(object.round) ? Number(object.round) : 0,
            blockId: $e12a6fa6f406a50c$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: $e12a6fa6f406a50c$var$isSet(object.timestamp) ? $e12a6fa6f406a50c$var$fromJsonTimestamp(object.timestamp) : undefined,
            validatorAddress: $e12a6fa6f406a50c$var$isSet(object.validatorAddress) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.validatorAddress) : new Uint8Array(),
            validatorIndex: $e12a6fa6f406a50c$var$isSet(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: $e12a6fa6f406a50c$var$isSet(object.signature) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $e12a6fa6f406a50c$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = message.height);
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = $e12a6fa6f406a50c$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined && (obj.signature = $e12a6fa6f406a50c$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = $e12a6fa6f406a50c$var$createBaseVote();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height = (_b = object.height) !== null && _b !== void 0 ? _b : "0";
        message.round = (_c = object.round) !== null && _c !== void 0 ? _c : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = (_d = object.timestamp) !== null && _d !== void 0 ? _d : undefined;
        message.validatorAddress = (_e = object.validatorAddress) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.validatorIndex = (_f = object.validatorIndex) !== null && _f !== void 0 ? _f : 0;
        message.signature = (_g = object.signature) !== null && _g !== void 0 ? _g : new Uint8Array();
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseCommit() {
    return {
        height: "0",
        round: 0,
        blockId: undefined,
        signatures: []
    };
}
module.exports.Commit = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.height !== "0") writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)module.exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $e12a6fa6f406a50c$var$longToString(reader.int64());
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push(module.exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: $e12a6fa6f406a50c$var$isSet(object.height) ? String(object.height) : "0",
            round: $e12a6fa6f406a50c$var$isSet(object.round) ? Number(object.round) : 0,
            blockId: $e12a6fa6f406a50c$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>module.exports.CommitSig.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height);
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $e12a6fa6f406a50c$var$createBaseCommit();
        message.height = (_a = object.height) !== null && _a !== void 0 ? _a : "0";
        message.round = (_b = object.round) !== null && _b !== void 0 ? _b : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = ((_c = object.signatures) === null || _c === void 0 ? void 0 : _c.map((e)=>module.exports.CommitSig.fromPartial(e))) || [];
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
module.exports.CommitSig = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $xgb9l.Timestamp.encode($e12a6fa6f406a50c$var$toTimestamp(message.timestamp), writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseCommitSig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $e12a6fa6f406a50c$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockIdFlag: $e12a6fa6f406a50c$var$isSet(object.blockIdFlag) ? $e12a6fa6f406a50c$var$blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: $e12a6fa6f406a50c$var$isSet(object.validatorAddress) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.validatorAddress) : new Uint8Array(),
            timestamp: $e12a6fa6f406a50c$var$isSet(object.timestamp) ? $e12a6fa6f406a50c$var$fromJsonTimestamp(object.timestamp) : undefined,
            signature: $e12a6fa6f406a50c$var$isSet(object.signature) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $e12a6fa6f406a50c$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = $e12a6fa6f406a50c$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.signature !== undefined && (obj.signature = $e12a6fa6f406a50c$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $e12a6fa6f406a50c$var$createBaseCommitSig();
        message.blockIdFlag = (_a = object.blockIdFlag) !== null && _a !== void 0 ? _a : 0;
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.timestamp = (_c = object.timestamp) !== null && _c !== void 0 ? _c : undefined;
        message.signature = (_d = object.signature) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseProposal() {
    return {
        type: 0,
        height: "0",
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
module.exports.Proposal = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.height !== "0") writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $xgb9l.Timestamp.encode($e12a6fa6f406a50c$var$toTimestamp(message.timestamp), writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = $e12a6fa6f406a50c$var$longToString(reader.int64());
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $e12a6fa6f406a50c$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: $e12a6fa6f406a50c$var$isSet(object.type) ? $e12a6fa6f406a50c$var$signedMsgTypeFromJSON(object.type) : 0,
            height: $e12a6fa6f406a50c$var$isSet(object.height) ? String(object.height) : "0",
            round: $e12a6fa6f406a50c$var$isSet(object.round) ? Number(object.round) : 0,
            polRound: $e12a6fa6f406a50c$var$isSet(object.polRound) ? Number(object.polRound) : 0,
            blockId: $e12a6fa6f406a50c$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: $e12a6fa6f406a50c$var$isSet(object.timestamp) ? $e12a6fa6f406a50c$var$fromJsonTimestamp(object.timestamp) : undefined,
            signature: $e12a6fa6f406a50c$var$isSet(object.signature) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $e12a6fa6f406a50c$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = message.height);
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.signature !== undefined && (obj.signature = $e12a6fa6f406a50c$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $e12a6fa6f406a50c$var$createBaseProposal();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height = (_b = object.height) !== null && _b !== void 0 ? _b : "0";
        message.round = (_c = object.round) !== null && _c !== void 0 ? _c : 0;
        message.polRound = (_d = object.polRound) !== null && _d !== void 0 ? _d : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = (_e = object.timestamp) !== null && _e !== void 0 ? _e : undefined;
        message.signature = (_f = object.signature) !== null && _f !== void 0 ? _f : new Uint8Array();
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined
    };
}
module.exports.SignedHeader = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) module.exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseSignedHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = module.exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: $e12a6fa6f406a50c$var$isSet(object.header) ? module.exports.Header.fromJSON(object.header) : undefined,
            commit: $e12a6fa6f406a50c$var$isSet(object.commit) ? module.exports.Commit.fromJSON(object.commit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e12a6fa6f406a50c$var$createBaseSignedHeader();
        message.header = object.header !== undefined && object.header !== null ? module.exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? module.exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined
    };
}
module.exports.LightBlock = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) module.exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $cz32K.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseLightBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = module.exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $cz32K.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: $e12a6fa6f406a50c$var$isSet(object.signedHeader) ? module.exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: $e12a6fa6f406a50c$var$isSet(object.validatorSet) ? $cz32K.ValidatorSet.fromJSON(object.validatorSet) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? module.exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $cz32K.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e12a6fa6f406a50c$var$createBaseLightBlock();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? module.exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $cz32K.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: "0",
        header: undefined,
        numTxs: "0"
    };
}
module.exports.BlockMeta = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (message.blockSize !== "0") writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (message.numTxs !== "0") writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseBlockMeta();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = $e12a6fa6f406a50c$var$longToString(reader.int64());
                    break;
                case 3:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = $e12a6fa6f406a50c$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockId: $e12a6fa6f406a50c$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: $e12a6fa6f406a50c$var$isSet(object.blockSize) ? String(object.blockSize) : "0",
            header: $e12a6fa6f406a50c$var$isSet(object.header) ? module.exports.Header.fromJSON(object.header) : undefined,
            numTxs: $e12a6fa6f406a50c$var$isSet(object.numTxs) ? String(object.numTxs) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = message.blockSize);
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = message.numTxs);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $e12a6fa6f406a50c$var$createBaseBlockMeta();
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = (_a = object.blockSize) !== null && _a !== void 0 ? _a : "0";
        message.header = object.header !== undefined && object.header !== null ? module.exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = (_b = object.numTxs) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $e12a6fa6f406a50c$var$createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined
    };
}
module.exports.TxProof = {
    encode (message, writer = $e12a6fa6f406a50c$var$minimal_1.default.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $9LIDg.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e12a6fa6f406a50c$var$minimal_1.default.Reader ? input : new $e12a6fa6f406a50c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e12a6fa6f406a50c$var$createBaseTxProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $9LIDg.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rootHash: $e12a6fa6f406a50c$var$isSet(object.rootHash) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.rootHash) : new Uint8Array(),
            data: $e12a6fa6f406a50c$var$isSet(object.data) ? $e12a6fa6f406a50c$var$bytesFromBase64(object.data) : new Uint8Array(),
            proof: $e12a6fa6f406a50c$var$isSet(object.proof) ? $9LIDg.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = $e12a6fa6f406a50c$var$base64FromBytes(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = $e12a6fa6f406a50c$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $9LIDg.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $e12a6fa6f406a50c$var$createBaseTxProof();
        message.rootHash = (_a = object.rootHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $9LIDg.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
var $e12a6fa6f406a50c$var$globalThis = (()=>{
    if (typeof $e12a6fa6f406a50c$var$globalThis !== "undefined") return $e12a6fa6f406a50c$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $e12a6fa6f406a50c$var$atob = $e12a6fa6f406a50c$var$globalThis.atob || ((b64)=>$e12a6fa6f406a50c$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $e12a6fa6f406a50c$var$bytesFromBase64(b64) {
    const bin = $e12a6fa6f406a50c$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $e12a6fa6f406a50c$var$btoa = $e12a6fa6f406a50c$var$globalThis.btoa || ((bin)=>$e12a6fa6f406a50c$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $e12a6fa6f406a50c$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $e12a6fa6f406a50c$var$btoa(bin.join(""));
}
function $e12a6fa6f406a50c$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $e12a6fa6f406a50c$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $e12a6fa6f406a50c$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $e12a6fa6f406a50c$var$fromTimestamp($xgb9l.Timestamp.fromJSON(o));
}
function $e12a6fa6f406a50c$var$longToString(long) {
    return long.toString();
}
if ($e12a6fa6f406a50c$var$minimal_1.default.util.Long !== $e12a6fa6f406a50c$var$long_1.default) {
    $e12a6fa6f406a50c$var$minimal_1.default.util.Long = $e12a6fa6f406a50c$var$long_1.default;
    $e12a6fa6f406a50c$var$minimal_1.default.configure();
}
function $e12a6fa6f406a50c$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("9LIDg", function(module, exports) {
"use strict";
var $71cb1fe453e866fd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProofOps = module.exports.ProofOp = module.exports.DominoOp = module.exports.ValueOp = module.exports.Proof = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $71cb1fe453e866fd$var$long_1 = $71cb1fe453e866fd$var$__importDefault((parcelRequire("jRkuS")));

const $71cb1fe453e866fd$var$minimal_1 = $71cb1fe453e866fd$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "tendermint.crypto";
function $71cb1fe453e866fd$var$createBaseProof() {
    return {
        total: "0",
        index: "0",
        leafHash: new Uint8Array(),
        aunts: []
    };
}
module.exports.Proof = {
    encode (message, writer = $71cb1fe453e866fd$var$minimal_1.default.Writer.create()) {
        if (message.total !== "0") writer.uint32(8).int64(message.total);
        if (message.index !== "0") writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $71cb1fe453e866fd$var$minimal_1.default.Reader ? input : new $71cb1fe453e866fd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $71cb1fe453e866fd$var$createBaseProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = $71cb1fe453e866fd$var$longToString(reader.int64());
                    break;
                case 2:
                    message.index = $71cb1fe453e866fd$var$longToString(reader.int64());
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: $71cb1fe453e866fd$var$isSet(object.total) ? String(object.total) : "0",
            index: $71cb1fe453e866fd$var$isSet(object.index) ? String(object.index) : "0",
            leafHash: $71cb1fe453e866fd$var$isSet(object.leafHash) ? $71cb1fe453e866fd$var$bytesFromBase64(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object === null || object === void 0 ? void 0 : object.aunts) ? object.aunts.map((e)=>$71cb1fe453e866fd$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = message.total);
        message.index !== undefined && (obj.index = message.index);
        message.leafHash !== undefined && (obj.leafHash = $71cb1fe453e866fd$var$base64FromBytes(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>$71cb1fe453e866fd$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $71cb1fe453e866fd$var$createBaseProof();
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : "0";
        message.index = (_b = object.index) !== null && _b !== void 0 ? _b : "0";
        message.leafHash = (_c = object.leafHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.aunts = ((_d = object.aunts) === null || _d === void 0 ? void 0 : _d.map((e)=>e)) || [];
        return message;
    }
};
function $71cb1fe453e866fd$var$createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined
    };
}
module.exports.ValueOp = {
    encode (message, writer = $71cb1fe453e866fd$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) module.exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $71cb1fe453e866fd$var$minimal_1.default.Reader ? input : new $71cb1fe453e866fd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $71cb1fe453e866fd$var$createBaseValueOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = module.exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $71cb1fe453e866fd$var$isSet(object.key) ? $71cb1fe453e866fd$var$bytesFromBase64(object.key) : new Uint8Array(),
            proof: $71cb1fe453e866fd$var$isSet(object.proof) ? module.exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $71cb1fe453e866fd$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? module.exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $71cb1fe453e866fd$var$createBaseValueOp();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? module.exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $71cb1fe453e866fd$var$createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: ""
    };
}
module.exports.DominoOp = {
    encode (message, writer = $71cb1fe453e866fd$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $71cb1fe453e866fd$var$minimal_1.default.Reader ? input : new $71cb1fe453e866fd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $71cb1fe453e866fd$var$createBaseDominoOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $71cb1fe453e866fd$var$isSet(object.key) ? String(object.key) : "",
            input: $71cb1fe453e866fd$var$isSet(object.input) ? String(object.input) : "",
            output: $71cb1fe453e866fd$var$isSet(object.output) ? String(object.output) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $71cb1fe453e866fd$var$createBaseDominoOp();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.input = (_b = object.input) !== null && _b !== void 0 ? _b : "";
        message.output = (_c = object.output) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $71cb1fe453e866fd$var$createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array()
    };
}
module.exports.ProofOp = {
    encode (message, writer = $71cb1fe453e866fd$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $71cb1fe453e866fd$var$minimal_1.default.Reader ? input : new $71cb1fe453e866fd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $71cb1fe453e866fd$var$createBaseProofOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: $71cb1fe453e866fd$var$isSet(object.type) ? String(object.type) : "",
            key: $71cb1fe453e866fd$var$isSet(object.key) ? $71cb1fe453e866fd$var$bytesFromBase64(object.key) : new Uint8Array(),
            data: $71cb1fe453e866fd$var$isSet(object.data) ? $71cb1fe453e866fd$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = $71cb1fe453e866fd$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = $71cb1fe453e866fd$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $71cb1fe453e866fd$var$createBaseProofOp();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.key = (_b = object.key) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
function $71cb1fe453e866fd$var$createBaseProofOps() {
    return {
        ops: []
    };
}
module.exports.ProofOps = {
    encode (message, writer = $71cb1fe453e866fd$var$minimal_1.default.Writer.create()) {
        for (const v of message.ops)module.exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $71cb1fe453e866fd$var$minimal_1.default.Reader ? input : new $71cb1fe453e866fd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $71cb1fe453e866fd$var$createBaseProofOps();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push(module.exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ops: Array.isArray(object === null || object === void 0 ? void 0 : object.ops) ? object.ops.map((e)=>module.exports.ProofOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? module.exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $71cb1fe453e866fd$var$createBaseProofOps();
        message.ops = ((_a = object.ops) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.ProofOp.fromPartial(e))) || [];
        return message;
    }
};
var $71cb1fe453e866fd$var$globalThis = (()=>{
    if (typeof $71cb1fe453e866fd$var$globalThis !== "undefined") return $71cb1fe453e866fd$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $71cb1fe453e866fd$var$atob = $71cb1fe453e866fd$var$globalThis.atob || ((b64)=>$71cb1fe453e866fd$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $71cb1fe453e866fd$var$bytesFromBase64(b64) {
    const bin = $71cb1fe453e866fd$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $71cb1fe453e866fd$var$btoa = $71cb1fe453e866fd$var$globalThis.btoa || ((bin)=>$71cb1fe453e866fd$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $71cb1fe453e866fd$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $71cb1fe453e866fd$var$btoa(bin.join(""));
}
function $71cb1fe453e866fd$var$longToString(long) {
    return long.toString();
}
if ($71cb1fe453e866fd$var$minimal_1.default.util.Long !== $71cb1fe453e866fd$var$long_1.default) {
    $71cb1fe453e866fd$var$minimal_1.default.util.Long = $71cb1fe453e866fd$var$long_1.default;
    $71cb1fe453e866fd$var$minimal_1.default.configure();
}
function $71cb1fe453e866fd$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("8jbeC", function(module, exports) {
"use strict";
var $60c8d017f642869a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Consensus = module.exports.App = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $60c8d017f642869a$var$long_1 = $60c8d017f642869a$var$__importDefault((parcelRequire("jRkuS")));

const $60c8d017f642869a$var$minimal_1 = $60c8d017f642869a$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "tendermint.version";
function $60c8d017f642869a$var$createBaseApp() {
    return {
        protocol: "0",
        software: ""
    };
}
module.exports.App = {
    encode (message, writer = $60c8d017f642869a$var$minimal_1.default.Writer.create()) {
        if (message.protocol !== "0") writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $60c8d017f642869a$var$minimal_1.default.Reader ? input : new $60c8d017f642869a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $60c8d017f642869a$var$createBaseApp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = $60c8d017f642869a$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            protocol: $60c8d017f642869a$var$isSet(object.protocol) ? String(object.protocol) : "0",
            software: $60c8d017f642869a$var$isSet(object.software) ? String(object.software) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = message.protocol);
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $60c8d017f642869a$var$createBaseApp();
        message.protocol = (_a = object.protocol) !== null && _a !== void 0 ? _a : "0";
        message.software = (_b = object.software) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $60c8d017f642869a$var$createBaseConsensus() {
    return {
        block: "0",
        app: "0"
    };
}
module.exports.Consensus = {
    encode (message, writer = $60c8d017f642869a$var$minimal_1.default.Writer.create()) {
        if (message.block !== "0") writer.uint32(8).uint64(message.block);
        if (message.app !== "0") writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $60c8d017f642869a$var$minimal_1.default.Reader ? input : new $60c8d017f642869a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $60c8d017f642869a$var$createBaseConsensus();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $60c8d017f642869a$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.app = $60c8d017f642869a$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: $60c8d017f642869a$var$isSet(object.block) ? String(object.block) : "0",
            app: $60c8d017f642869a$var$isSet(object.app) ? String(object.app) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block);
        message.app !== undefined && (obj.app = message.app);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $60c8d017f642869a$var$createBaseConsensus();
        message.block = (_a = object.block) !== null && _a !== void 0 ? _a : "0";
        message.app = (_b = object.app) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $60c8d017f642869a$var$longToString(long) {
    return long.toString();
}
if ($60c8d017f642869a$var$minimal_1.default.util.Long !== $60c8d017f642869a$var$long_1.default) {
    $60c8d017f642869a$var$minimal_1.default.util.Long = $60c8d017f642869a$var$long_1.default;
    $60c8d017f642869a$var$minimal_1.default.configure();
}
function $60c8d017f642869a$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("cz32K", function(module, exports) {
"use strict";
var $925b1d3c645ee03d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleValidator = module.exports.Validator = module.exports.ValidatorSet = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $925b1d3c645ee03d$var$long_1 = $925b1d3c645ee03d$var$__importDefault((parcelRequire("jRkuS")));

const $925b1d3c645ee03d$var$minimal_1 = $925b1d3c645ee03d$var$__importDefault((parcelRequire("fQBv0")));

var $aSBJU = parcelRequire("aSBJU");
module.exports.protobufPackage = "tendermint.types";
function $925b1d3c645ee03d$var$createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: "0"
    };
}
module.exports.ValidatorSet = {
    encode (message, writer = $925b1d3c645ee03d$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)module.exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) module.exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (message.totalVotingPower !== "0") writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $925b1d3c645ee03d$var$minimal_1.default.Reader ? input : new $925b1d3c645ee03d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $925b1d3c645ee03d$var$createBaseValidatorSet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = $925b1d3c645ee03d$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map((e)=>module.exports.Validator.fromJSON(e)) : [],
            proposer: $925b1d3c645ee03d$var$isSet(object.proposer) ? module.exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: $925b1d3c645ee03d$var$isSet(object.totalVotingPower) ? String(object.totalVotingPower) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? module.exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = message.totalVotingPower);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $925b1d3c645ee03d$var$createBaseValidatorSet();
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.Validator.fromPartial(e))) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? module.exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = (_b = object.totalVotingPower) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $925b1d3c645ee03d$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: "0",
        proposerPriority: "0"
    };
}
module.exports.Validator = {
    encode (message, writer = $925b1d3c645ee03d$var$minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $aSBJU.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (message.votingPower !== "0") writer.uint32(24).int64(message.votingPower);
        if (message.proposerPriority !== "0") writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $925b1d3c645ee03d$var$minimal_1.default.Reader ? input : new $925b1d3c645ee03d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $925b1d3c645ee03d$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $aSBJU.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = $925b1d3c645ee03d$var$longToString(reader.int64());
                    break;
                case 4:
                    message.proposerPriority = $925b1d3c645ee03d$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $925b1d3c645ee03d$var$isSet(object.address) ? $925b1d3c645ee03d$var$bytesFromBase64(object.address) : new Uint8Array(),
            pubKey: $925b1d3c645ee03d$var$isSet(object.pubKey) ? $aSBJU.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: $925b1d3c645ee03d$var$isSet(object.votingPower) ? String(object.votingPower) : "0",
            proposerPriority: $925b1d3c645ee03d$var$isSet(object.proposerPriority) ? String(object.proposerPriority) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = $925b1d3c645ee03d$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $aSBJU.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = message.votingPower);
        message.proposerPriority !== undefined && (obj.proposerPriority = message.proposerPriority);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $925b1d3c645ee03d$var$createBaseValidator();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $aSBJU.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = (_b = object.votingPower) !== null && _b !== void 0 ? _b : "0";
        message.proposerPriority = (_c = object.proposerPriority) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $925b1d3c645ee03d$var$createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: "0"
    };
}
module.exports.SimpleValidator = {
    encode (message, writer = $925b1d3c645ee03d$var$minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) $aSBJU.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (message.votingPower !== "0") writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $925b1d3c645ee03d$var$minimal_1.default.Reader ? input : new $925b1d3c645ee03d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $925b1d3c645ee03d$var$createBaseSimpleValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $aSBJU.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = $925b1d3c645ee03d$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: $925b1d3c645ee03d$var$isSet(object.pubKey) ? $aSBJU.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: $925b1d3c645ee03d$var$isSet(object.votingPower) ? String(object.votingPower) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $aSBJU.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = message.votingPower);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $925b1d3c645ee03d$var$createBaseSimpleValidator();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $aSBJU.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = (_a = object.votingPower) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
var $925b1d3c645ee03d$var$globalThis = (()=>{
    if (typeof $925b1d3c645ee03d$var$globalThis !== "undefined") return $925b1d3c645ee03d$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $925b1d3c645ee03d$var$atob = $925b1d3c645ee03d$var$globalThis.atob || ((b64)=>$925b1d3c645ee03d$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $925b1d3c645ee03d$var$bytesFromBase64(b64) {
    const bin = $925b1d3c645ee03d$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $925b1d3c645ee03d$var$btoa = $925b1d3c645ee03d$var$globalThis.btoa || ((bin)=>$925b1d3c645ee03d$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $925b1d3c645ee03d$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $925b1d3c645ee03d$var$btoa(bin.join(""));
}
function $925b1d3c645ee03d$var$longToString(long) {
    return long.toString();
}
if ($925b1d3c645ee03d$var$minimal_1.default.util.Long !== $925b1d3c645ee03d$var$long_1.default) {
    $925b1d3c645ee03d$var$minimal_1.default.util.Long = $925b1d3c645ee03d$var$long_1.default;
    $925b1d3c645ee03d$var$minimal_1.default.configure();
}
function $925b1d3c645ee03d$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("aSBJU", function(module, exports) {
"use strict";
var $7ebc38cef552dc0c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $7ebc38cef552dc0c$var$long_1 = $7ebc38cef552dc0c$var$__importDefault((parcelRequire("jRkuS")));

const $7ebc38cef552dc0c$var$minimal_1 = $7ebc38cef552dc0c$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "tendermint.crypto";
function $7ebc38cef552dc0c$var$createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined
    };
}
module.exports.PublicKey = {
    encode (message, writer = $7ebc38cef552dc0c$var$minimal_1.default.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ebc38cef552dc0c$var$minimal_1.default.Reader ? input : new $7ebc38cef552dc0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ebc38cef552dc0c$var$createBasePublicKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ed25519: $7ebc38cef552dc0c$var$isSet(object.ed25519) ? $7ebc38cef552dc0c$var$bytesFromBase64(object.ed25519) : undefined,
            secp256k1: $7ebc38cef552dc0c$var$isSet(object.secp256k1) ? $7ebc38cef552dc0c$var$bytesFromBase64(object.secp256k1) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? $7ebc38cef552dc0c$var$base64FromBytes(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? $7ebc38cef552dc0c$var$base64FromBytes(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7ebc38cef552dc0c$var$createBasePublicKey();
        message.ed25519 = (_a = object.ed25519) !== null && _a !== void 0 ? _a : undefined;
        message.secp256k1 = (_b = object.secp256k1) !== null && _b !== void 0 ? _b : undefined;
        return message;
    }
};
var $7ebc38cef552dc0c$var$globalThis = (()=>{
    if (typeof $7ebc38cef552dc0c$var$globalThis !== "undefined") return $7ebc38cef552dc0c$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $7ebc38cef552dc0c$var$atob = $7ebc38cef552dc0c$var$globalThis.atob || ((b64)=>$7ebc38cef552dc0c$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $7ebc38cef552dc0c$var$bytesFromBase64(b64) {
    const bin = $7ebc38cef552dc0c$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $7ebc38cef552dc0c$var$btoa = $7ebc38cef552dc0c$var$globalThis.btoa || ((bin)=>$7ebc38cef552dc0c$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $7ebc38cef552dc0c$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $7ebc38cef552dc0c$var$btoa(bin.join(""));
}
if ($7ebc38cef552dc0c$var$minimal_1.default.util.Long !== $7ebc38cef552dc0c$var$long_1.default) {
    $7ebc38cef552dc0c$var$minimal_1.default.util.Long = $7ebc38cef552dc0c$var$long_1.default;
    $7ebc38cef552dc0c$var$minimal_1.default.configure();
}
function $7ebc38cef552dc0c$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("5fiTY", function(module, exports) {
"use strict";
var $3d1d03fdb5b70bff$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $3d1d03fdb5b70bff$var$long_1 = $3d1d03fdb5b70bff$var$__importDefault((parcelRequire("jRkuS")));

const $3d1d03fdb5b70bff$var$minimal_1 = $3d1d03fdb5b70bff$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "google.protobuf";
function $3d1d03fdb5b70bff$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
module.exports.Any = {
    encode (message, writer = $3d1d03fdb5b70bff$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d1d03fdb5b70bff$var$minimal_1.default.Reader ? input : new $3d1d03fdb5b70bff$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d1d03fdb5b70bff$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: $3d1d03fdb5b70bff$var$isSet(object.typeUrl) ? String(object.typeUrl) : "",
            value: $3d1d03fdb5b70bff$var$isSet(object.value) ? $3d1d03fdb5b70bff$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $3d1d03fdb5b70bff$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $3d1d03fdb5b70bff$var$createBaseAny();
        message.typeUrl = (_a = object.typeUrl) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $3d1d03fdb5b70bff$var$globalThis = (()=>{
    if (typeof $3d1d03fdb5b70bff$var$globalThis !== "undefined") return $3d1d03fdb5b70bff$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $3d1d03fdb5b70bff$var$atob = $3d1d03fdb5b70bff$var$globalThis.atob || ((b64)=>$3d1d03fdb5b70bff$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $3d1d03fdb5b70bff$var$bytesFromBase64(b64) {
    const bin = $3d1d03fdb5b70bff$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $3d1d03fdb5b70bff$var$btoa = $3d1d03fdb5b70bff$var$globalThis.btoa || ((bin)=>$3d1d03fdb5b70bff$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $3d1d03fdb5b70bff$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $3d1d03fdb5b70bff$var$btoa(bin.join(""));
}
if ($3d1d03fdb5b70bff$var$minimal_1.default.util.Long !== $3d1d03fdb5b70bff$var$long_1.default) {
    $3d1d03fdb5b70bff$var$minimal_1.default.util.Long = $3d1d03fdb5b70bff$var$long_1.default;
    $3d1d03fdb5b70bff$var$minimal_1.default.configure();
}
function $3d1d03fdb5b70bff$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("lM6jn", function(module, exports) {
"use strict";
var $fda2fa07d1062017$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $fda2fa07d1062017$var$long_1 = $fda2fa07d1062017$var$__importDefault((parcelRequire("jRkuS")));

const $fda2fa07d1062017$var$minimal_1 = $fda2fa07d1062017$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "google.protobuf";
function $fda2fa07d1062017$var$createBaseDuration() {
    return {
        seconds: "0",
        nanos: 0
    };
}
module.exports.Duration = {
    encode (message, writer = $fda2fa07d1062017$var$minimal_1.default.Writer.create()) {
        if (message.seconds !== "0") writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fda2fa07d1062017$var$minimal_1.default.Reader ? input : new $fda2fa07d1062017$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fda2fa07d1062017$var$createBaseDuration();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = $fda2fa07d1062017$var$longToString(reader.int64());
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: $fda2fa07d1062017$var$isSet(object.seconds) ? String(object.seconds) : "0",
            nanos: $fda2fa07d1062017$var$isSet(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = message.seconds);
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $fda2fa07d1062017$var$createBaseDuration();
        message.seconds = (_a = object.seconds) !== null && _a !== void 0 ? _a : "0";
        message.nanos = (_b = object.nanos) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function $fda2fa07d1062017$var$longToString(long) {
    return long.toString();
}
if ($fda2fa07d1062017$var$minimal_1.default.util.Long !== $fda2fa07d1062017$var$long_1.default) {
    $fda2fa07d1062017$var$minimal_1.default.util.Long = $fda2fa07d1062017$var$long_1.default;
    $fda2fa07d1062017$var$minimal_1.default.configure();
}
function $fda2fa07d1062017$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("1eDdt", function(module, exports) {
"use strict";
var $0e6584ca50896724$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgRevokeResponse = module.exports.MsgRevoke = module.exports.MsgGrantResponse = module.exports.MsgExec = module.exports.MsgExecResponse = module.exports.MsgGrant = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $0e6584ca50896724$var$long_1 = $0e6584ca50896724$var$__importDefault((parcelRequire("jRkuS")));

const $0e6584ca50896724$var$minimal_1 = $0e6584ca50896724$var$__importDefault((parcelRequire("fQBv0")));

var $9tRBL = parcelRequire("9tRBL");

var $5fiTY = parcelRequire("5fiTY");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $0e6584ca50896724$var$createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined
    };
}
module.exports.MsgGrant = {
    encode (message, writer = $0e6584ca50896724$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $9tRBL.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e6584ca50896724$var$minimal_1.default.Reader ? input : new $0e6584ca50896724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0e6584ca50896724$var$createBaseMsgGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $9tRBL.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: $0e6584ca50896724$var$isSet(object.granter) ? String(object.granter) : "",
            grantee: $0e6584ca50896724$var$isSet(object.grantee) ? String(object.grantee) : "",
            grant: $0e6584ca50896724$var$isSet(object.grant) ? $9tRBL.Grant.fromJSON(object.grant) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $9tRBL.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $0e6584ca50896724$var$createBaseMsgGrant();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.grant = object.grant !== undefined && object.grant !== null ? $9tRBL.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
function $0e6584ca50896724$var$createBaseMsgExecResponse() {
    return {
        results: []
    };
}
module.exports.MsgExecResponse = {
    encode (message, writer = $0e6584ca50896724$var$minimal_1.default.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e6584ca50896724$var$minimal_1.default.Reader ? input : new $0e6584ca50896724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0e6584ca50896724$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            results: Array.isArray(object === null || object === void 0 ? void 0 : object.results) ? object.results.map((e)=>$0e6584ca50896724$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>$0e6584ca50896724$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $0e6584ca50896724$var$createBaseMsgExecResponse();
        message.results = ((_a = object.results) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $0e6584ca50896724$var$createBaseMsgExec() {
    return {
        grantee: "",
        msgs: []
    };
}
module.exports.MsgExec = {
    encode (message, writer = $0e6584ca50896724$var$minimal_1.default.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$5fiTY.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e6584ca50896724$var$minimal_1.default.Reader ? input : new $0e6584ca50896724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0e6584ca50896724$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($5fiTY.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: $0e6584ca50896724$var$isSet(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object === null || object === void 0 ? void 0 : object.msgs) ? object.msgs.map((e)=>$5fiTY.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $5fiTY.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $0e6584ca50896724$var$createBaseMsgExec();
        message.grantee = (_a = object.grantee) !== null && _a !== void 0 ? _a : "";
        message.msgs = ((_b = object.msgs) === null || _b === void 0 ? void 0 : _b.map((e)=>$5fiTY.Any.fromPartial(e))) || [];
        return message;
    }
};
function $0e6584ca50896724$var$createBaseMsgGrantResponse() {
    return {};
}
module.exports.MsgGrantResponse = {
    encode (_, writer = $0e6584ca50896724$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e6584ca50896724$var$minimal_1.default.Reader ? input : new $0e6584ca50896724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0e6584ca50896724$var$createBaseMsgGrantResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0e6584ca50896724$var$createBaseMsgGrantResponse();
        return message;
    }
};
function $0e6584ca50896724$var$createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: ""
    };
}
module.exports.MsgRevoke = {
    encode (message, writer = $0e6584ca50896724$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e6584ca50896724$var$minimal_1.default.Reader ? input : new $0e6584ca50896724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0e6584ca50896724$var$createBaseMsgRevoke();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: $0e6584ca50896724$var$isSet(object.granter) ? String(object.granter) : "",
            grantee: $0e6584ca50896724$var$isSet(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: $0e6584ca50896724$var$isSet(object.msgTypeUrl) ? String(object.msgTypeUrl) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $0e6584ca50896724$var$createBaseMsgRevoke();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.msgTypeUrl = (_c = object.msgTypeUrl) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $0e6584ca50896724$var$createBaseMsgRevokeResponse() {
    return {};
}
module.exports.MsgRevokeResponse = {
    encode (_, writer = $0e6584ca50896724$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e6584ca50896724$var$minimal_1.default.Reader ? input : new $0e6584ca50896724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0e6584ca50896724$var$createBaseMsgRevokeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0e6584ca50896724$var$createBaseMsgRevokeResponse();
        return message;
    }
};
var $0e6584ca50896724$var$globalThis = (()=>{
    if (typeof $0e6584ca50896724$var$globalThis !== "undefined") return $0e6584ca50896724$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $0e6584ca50896724$var$atob = $0e6584ca50896724$var$globalThis.atob || ((b64)=>$0e6584ca50896724$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $0e6584ca50896724$var$bytesFromBase64(b64) {
    const bin = $0e6584ca50896724$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $0e6584ca50896724$var$btoa = $0e6584ca50896724$var$globalThis.btoa || ((bin)=>$0e6584ca50896724$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $0e6584ca50896724$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $0e6584ca50896724$var$btoa(bin.join(""));
}
if ($0e6584ca50896724$var$minimal_1.default.util.Long !== $0e6584ca50896724$var$long_1.default) {
    $0e6584ca50896724$var$minimal_1.default.util.Long = $0e6584ca50896724$var$long_1.default;
    $0e6584ca50896724$var$minimal_1.default.configure();
}
function $0e6584ca50896724$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("9tRBL", function(module, exports) {
"use strict";
var $6e7067f6e5e595e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Grant = module.exports.GenericAuthorization = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6e7067f6e5e595e3$var$long_1 = $6e7067f6e5e595e3$var$__importDefault((parcelRequire("jRkuS")));

const $6e7067f6e5e595e3$var$minimal_1 = $6e7067f6e5e595e3$var$__importDefault((parcelRequire("fQBv0")));

var $xgb9l = parcelRequire("xgb9l");

var $5fiTY = parcelRequire("5fiTY");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $6e7067f6e5e595e3$var$createBaseGenericAuthorization() {
    return {
        msg: ""
    };
}
module.exports.GenericAuthorization = {
    encode (message, writer = $6e7067f6e5e595e3$var$minimal_1.default.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6e7067f6e5e595e3$var$minimal_1.default.Reader ? input : new $6e7067f6e5e595e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6e7067f6e5e595e3$var$createBaseGenericAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msg: $6e7067f6e5e595e3$var$isSet(object.msg) ? String(object.msg) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $6e7067f6e5e595e3$var$createBaseGenericAuthorization();
        message.msg = (_a = object.msg) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $6e7067f6e5e595e3$var$createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined
    };
}
module.exports.Grant = {
    encode (message, writer = $6e7067f6e5e595e3$var$minimal_1.default.Writer.create()) {
        if (message.authorization !== undefined) $5fiTY.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $xgb9l.Timestamp.encode($6e7067f6e5e595e3$var$toTimestamp(message.expiration), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6e7067f6e5e595e3$var$minimal_1.default.Reader ? input : new $6e7067f6e5e595e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6e7067f6e5e595e3$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $6e7067f6e5e595e3$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authorization: $6e7067f6e5e595e3$var$isSet(object.authorization) ? $5fiTY.Any.fromJSON(object.authorization) : undefined,
            expiration: $6e7067f6e5e595e3$var$isSet(object.expiration) ? $6e7067f6e5e595e3$var$fromJsonTimestamp(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $5fiTY.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = message.expiration.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $6e7067f6e5e595e3$var$createBaseGrant();
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $5fiTY.Any.fromPartial(object.authorization) : undefined;
        message.expiration = (_a = object.expiration) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $6e7067f6e5e595e3$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $6e7067f6e5e595e3$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $6e7067f6e5e595e3$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $6e7067f6e5e595e3$var$fromTimestamp($xgb9l.Timestamp.fromJSON(o));
}
if ($6e7067f6e5e595e3$var$minimal_1.default.util.Long !== $6e7067f6e5e595e3$var$long_1.default) {
    $6e7067f6e5e595e3$var$minimal_1.default.util.Long = $6e7067f6e5e595e3$var$long_1.default;
    $6e7067f6e5e595e3$var$minimal_1.default.configure();
}
function $6e7067f6e5e595e3$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("1vxkN", function(module, exports) {
"use strict";
var $11928b3dd70c50ce$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgDepositResponse = module.exports.MsgDeposit = module.exports.MsgVoteWeightedResponse = module.exports.MsgVoteWeighted = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $11928b3dd70c50ce$var$long_1 = $11928b3dd70c50ce$var$__importDefault((parcelRequire("jRkuS")));

const $11928b3dd70c50ce$var$minimal_1 = $11928b3dd70c50ce$var$__importDefault((parcelRequire("fQBv0")));

var $fjYzG = parcelRequire("fjYzG");

var $5fiTY = parcelRequire("5fiTY");

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.gov.v1beta1";
function $11928b3dd70c50ce$var$createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: ""
    };
}
module.exports.MsgSubmitProposal = {
    encode (message, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        if (message.content !== undefined) $5fiTY.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$9QyHq.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: $11928b3dd70c50ce$var$isSet(object.content) ? $5fiTY.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.initialDeposit) ? object.initialDeposit.map((e)=>$9QyHq.Coin.fromJSON(e)) : [],
            proposer: $11928b3dd70c50ce$var$isSet(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $5fiTY.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $11928b3dd70c50ce$var$createBaseMsgSubmitProposal();
        message.content = object.content !== undefined && object.content !== null ? $5fiTY.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = ((_a = object.initialDeposit) === null || _a === void 0 ? void 0 : _a.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        message.proposer = (_b = object.proposer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: "0"
    };
}
module.exports.MsgSubmitProposalResponse = {
    encode (message, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $11928b3dd70c50ce$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $11928b3dd70c50ce$var$isSet(object.proposalId) ? String(object.proposalId) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $11928b3dd70c50ce$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgVote() {
    return {
        proposalId: "0",
        voter: "",
        option: 0
    };
}
module.exports.MsgVote = {
    encode (message, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $11928b3dd70c50ce$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $11928b3dd70c50ce$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            voter: $11928b3dd70c50ce$var$isSet(object.voter) ? String(object.voter) : "",
            option: $11928b3dd70c50ce$var$isSet(object.option) ? (0, $fjYzG.voteOptionFromJSON)(object.option) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $fjYzG.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $11928b3dd70c50ce$var$createBaseMsgVote();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.option = (_c = object.option) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgVoteResponse() {
    return {};
}
module.exports.MsgVoteResponse = {
    encode (_, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $11928b3dd70c50ce$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: "0",
        voter: "",
        options: []
    };
}
module.exports.MsgVoteWeighted = {
    encode (message, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$fjYzG.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $11928b3dd70c50ce$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($fjYzG.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $11928b3dd70c50ce$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            voter: $11928b3dd70c50ce$var$isSet(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map((e)=>$fjYzG.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $fjYzG.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $11928b3dd70c50ce$var$createBaseMsgVoteWeighted();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map((e)=>$fjYzG.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
module.exports.MsgVoteWeightedResponse = {
    encode (_, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $11928b3dd70c50ce$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgDeposit() {
    return {
        proposalId: "0",
        depositor: "",
        amount: []
    };
}
module.exports.MsgDeposit = {
    encode (message, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$9QyHq.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $11928b3dd70c50ce$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $11928b3dd70c50ce$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            depositor: $11928b3dd70c50ce$var$isSet(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $11928b3dd70c50ce$var$createBaseMsgDeposit();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $11928b3dd70c50ce$var$createBaseMsgDepositResponse() {
    return {};
}
module.exports.MsgDepositResponse = {
    encode (_, writer = $11928b3dd70c50ce$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $11928b3dd70c50ce$var$minimal_1.default.Reader ? input : new $11928b3dd70c50ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $11928b3dd70c50ce$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $11928b3dd70c50ce$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $11928b3dd70c50ce$var$longToString(long) {
    return long.toString();
}
if ($11928b3dd70c50ce$var$minimal_1.default.util.Long !== $11928b3dd70c50ce$var$long_1.default) {
    $11928b3dd70c50ce$var$minimal_1.default.util.Long = $11928b3dd70c50ce$var$long_1.default;
    $11928b3dd70c50ce$var$minimal_1.default.configure();
}
function $11928b3dd70c50ce$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("fjYzG", function(module, exports) {
"use strict";
var $b2779e3a59b6d314$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TallyParams = module.exports.VotingParams = module.exports.DepositParams = module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.Deposit = module.exports.TextProposal = module.exports.WeightedVoteOption = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b2779e3a59b6d314$var$long_1 = $b2779e3a59b6d314$var$__importDefault((parcelRequire("jRkuS")));

const $b2779e3a59b6d314$var$minimal_1 = $b2779e3a59b6d314$var$__importDefault((parcelRequire("fQBv0")));

var $xgb9l = parcelRequire("xgb9l");

var $9QyHq = parcelRequire("9QyHq");

var $5fiTY = parcelRequire("5fiTY");

var $lM6jn = parcelRequire("lM6jn");
module.exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $b2779e3a59b6d314$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($b2779e3a59b6d314$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $b2779e3a59b6d314$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $b2779e3a59b6d314$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $b2779e3a59b6d314$var$voteOptionFromJSON;
function $b2779e3a59b6d314$var$voteOptionToJSON(object) {
    switch(object){
        case $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $b2779e3a59b6d314$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        default:
            return "UNKNOWN";
    }
}
module.exports.voteOptionToJSON = $b2779e3a59b6d314$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $b2779e3a59b6d314$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default propopsal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($b2779e3a59b6d314$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $b2779e3a59b6d314$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $b2779e3a59b6d314$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $b2779e3a59b6d314$var$proposalStatusFromJSON;
function $b2779e3a59b6d314$var$proposalStatusToJSON(object) {
    switch(object){
        case $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $b2779e3a59b6d314$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        default:
            return "UNKNOWN";
    }
}
module.exports.proposalStatusToJSON = $b2779e3a59b6d314$var$proposalStatusToJSON;
function $b2779e3a59b6d314$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
module.exports.WeightedVoteOption = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: $b2779e3a59b6d314$var$isSet(object.option) ? $b2779e3a59b6d314$var$voteOptionFromJSON(object.option) : 0,
            weight: $b2779e3a59b6d314$var$isSet(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $b2779e3a59b6d314$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $b2779e3a59b6d314$var$createBaseWeightedVoteOption();
        message.option = (_a = object.option) !== null && _a !== void 0 ? _a : 0;
        message.weight = (_b = object.weight) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseTextProposal() {
    return {
        title: "",
        description: ""
    };
}
module.exports.TextProposal = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseTextProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $b2779e3a59b6d314$var$isSet(object.title) ? String(object.title) : "",
            description: $b2779e3a59b6d314$var$isSet(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $b2779e3a59b6d314$var$createBaseTextProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseDeposit() {
    return {
        proposalId: "0",
        depositor: "",
        amount: []
    };
}
module.exports.Deposit = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$9QyHq.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $b2779e3a59b6d314$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $b2779e3a59b6d314$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            depositor: $b2779e3a59b6d314$var$isSet(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b2779e3a59b6d314$var$createBaseDeposit();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseProposal() {
    return {
        proposalId: "0",
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined
    };
}
module.exports.Proposal = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $5fiTY.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $xgb9l.Timestamp.encode($b2779e3a59b6d314$var$toTimestamp(message.submitTime), writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $xgb9l.Timestamp.encode($b2779e3a59b6d314$var$toTimestamp(message.depositEndTime), writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$9QyHq.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $xgb9l.Timestamp.encode($b2779e3a59b6d314$var$toTimestamp(message.votingStartTime), writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $xgb9l.Timestamp.encode($b2779e3a59b6d314$var$toTimestamp(message.votingEndTime), writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $b2779e3a59b6d314$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.content = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $b2779e3a59b6d314$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.depositEndTime = $b2779e3a59b6d314$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.totalDeposit.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $b2779e3a59b6d314$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.votingEndTime = $b2779e3a59b6d314$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $b2779e3a59b6d314$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            content: $b2779e3a59b6d314$var$isSet(object.content) ? $5fiTY.Any.fromJSON(object.content) : undefined,
            status: $b2779e3a59b6d314$var$isSet(object.status) ? $b2779e3a59b6d314$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: $b2779e3a59b6d314$var$isSet(object.finalTallyResult) ? module.exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: $b2779e3a59b6d314$var$isSet(object.submitTime) ? $b2779e3a59b6d314$var$fromJsonTimestamp(object.submitTime) : undefined,
            depositEndTime: $b2779e3a59b6d314$var$isSet(object.depositEndTime) ? $b2779e3a59b6d314$var$fromJsonTimestamp(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDeposit) ? object.totalDeposit.map((e)=>$9QyHq.Coin.fromJSON(e)) : [],
            votingStartTime: $b2779e3a59b6d314$var$isSet(object.votingStartTime) ? $b2779e3a59b6d314$var$fromJsonTimestamp(object.votingStartTime) : undefined,
            votingEndTime: $b2779e3a59b6d314$var$isSet(object.votingEndTime) ? $b2779e3a59b6d314$var$fromJsonTimestamp(object.votingEndTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.content !== undefined && (obj.content = message.content ? $5fiTY.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $b2779e3a59b6d314$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = message.submitTime.toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = message.depositEndTime.toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = message.votingStartTime.toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = message.votingEndTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = $b2779e3a59b6d314$var$createBaseProposal();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.content = object.content !== undefined && object.content !== null ? $5fiTY.Any.fromPartial(object.content) : undefined;
        message.status = (_b = object.status) !== null && _b !== void 0 ? _b : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? module.exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = (_c = object.submitTime) !== null && _c !== void 0 ? _c : undefined;
        message.depositEndTime = (_d = object.depositEndTime) !== null && _d !== void 0 ? _d : undefined;
        message.totalDeposit = ((_e = object.totalDeposit) === null || _e === void 0 ? void 0 : _e.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        message.votingStartTime = (_f = object.votingStartTime) !== null && _f !== void 0 ? _f : undefined;
        message.votingEndTime = (_g = object.votingEndTime) !== null && _g !== void 0 ? _g : undefined;
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: ""
    };
}
module.exports.TallyResult = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yes: $b2779e3a59b6d314$var$isSet(object.yes) ? String(object.yes) : "",
            abstain: $b2779e3a59b6d314$var$isSet(object.abstain) ? String(object.abstain) : "",
            no: $b2779e3a59b6d314$var$isSet(object.no) ? String(object.no) : "",
            noWithVeto: $b2779e3a59b6d314$var$isSet(object.noWithVeto) ? String(object.noWithVeto) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b2779e3a59b6d314$var$createBaseTallyResult();
        message.yes = (_a = object.yes) !== null && _a !== void 0 ? _a : "";
        message.abstain = (_b = object.abstain) !== null && _b !== void 0 ? _b : "";
        message.no = (_c = object.no) !== null && _c !== void 0 ? _c : "";
        message.noWithVeto = (_d = object.noWithVeto) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseVote() {
    return {
        proposalId: "0",
        voter: "",
        option: 0,
        options: []
    };
}
module.exports.Vote = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)module.exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $b2779e3a59b6d314$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push(module.exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $b2779e3a59b6d314$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            voter: $b2779e3a59b6d314$var$isSet(object.voter) ? String(object.voter) : "",
            option: $b2779e3a59b6d314$var$isSet(object.option) ? $b2779e3a59b6d314$var$voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map((e)=>module.exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $b2779e3a59b6d314$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? module.exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b2779e3a59b6d314$var$createBaseVote();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.option = (_c = object.option) !== null && _c !== void 0 ? _c : 0;
        message.options = ((_d = object.options) === null || _d === void 0 ? void 0 : _d.map((e)=>module.exports.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
module.exports.DepositParams = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        for (const v of message.minDeposit)$9QyHq.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $lM6jn.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $lM6jn.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.minDeposit) ? object.minDeposit.map((e)=>$9QyHq.Coin.fromJSON(e)) : [],
            maxDepositPeriod: $b2779e3a59b6d314$var$isSet(object.maxDepositPeriod) ? $lM6jn.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $lM6jn.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $b2779e3a59b6d314$var$createBaseDepositParams();
        message.minDeposit = ((_a = object.minDeposit) === null || _a === void 0 ? void 0 : _a.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $lM6jn.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
module.exports.VotingParams = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.votingPeriod !== undefined) $lM6jn.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $lM6jn.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: $b2779e3a59b6d314$var$isSet(object.votingPeriod) ? $lM6jn.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $lM6jn.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $b2779e3a59b6d314$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $lM6jn.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $b2779e3a59b6d314$var$createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array()
    };
}
module.exports.TallyParams = {
    encode (message, writer = $b2779e3a59b6d314$var$minimal_1.default.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b2779e3a59b6d314$var$minimal_1.default.Reader ? input : new $b2779e3a59b6d314$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b2779e3a59b6d314$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: $b2779e3a59b6d314$var$isSet(object.quorum) ? $b2779e3a59b6d314$var$bytesFromBase64(object.quorum) : new Uint8Array(),
            threshold: $b2779e3a59b6d314$var$isSet(object.threshold) ? $b2779e3a59b6d314$var$bytesFromBase64(object.threshold) : new Uint8Array(),
            vetoThreshold: $b2779e3a59b6d314$var$isSet(object.vetoThreshold) ? $b2779e3a59b6d314$var$bytesFromBase64(object.vetoThreshold) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = $b2779e3a59b6d314$var$base64FromBytes(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = $b2779e3a59b6d314$var$base64FromBytes(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = $b2779e3a59b6d314$var$base64FromBytes(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b2779e3a59b6d314$var$createBaseTallyParams();
        message.quorum = (_a = object.quorum) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.threshold = (_b = object.threshold) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.vetoThreshold = (_c = object.vetoThreshold) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
var $b2779e3a59b6d314$var$globalThis = (()=>{
    if (typeof $b2779e3a59b6d314$var$globalThis !== "undefined") return $b2779e3a59b6d314$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b2779e3a59b6d314$var$atob = $b2779e3a59b6d314$var$globalThis.atob || ((b64)=>$b2779e3a59b6d314$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b2779e3a59b6d314$var$bytesFromBase64(b64) {
    const bin = $b2779e3a59b6d314$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b2779e3a59b6d314$var$btoa = $b2779e3a59b6d314$var$globalThis.btoa || ((bin)=>$b2779e3a59b6d314$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b2779e3a59b6d314$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b2779e3a59b6d314$var$btoa(bin.join(""));
}
function $b2779e3a59b6d314$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $b2779e3a59b6d314$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $b2779e3a59b6d314$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $b2779e3a59b6d314$var$fromTimestamp($xgb9l.Timestamp.fromJSON(o));
}
function $b2779e3a59b6d314$var$longToString(long) {
    return long.toString();
}
if ($b2779e3a59b6d314$var$minimal_1.default.util.Long !== $b2779e3a59b6d314$var$long_1.default) {
    $b2779e3a59b6d314$var$minimal_1.default.util.Long = $b2779e3a59b6d314$var$long_1.default;
    $b2779e3a59b6d314$var$minimal_1.default.configure();
}
function $b2779e3a59b6d314$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("c8xZ5", function(module, exports) {
"use strict";
var $8d6097f52d2f83a6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgFundCommunityPoolResponse = module.exports.MsgFundCommunityPool = module.exports.MsgWithdrawValidatorCommissionResponse = module.exports.MsgWithdrawValidatorCommission = module.exports.MsgWithdrawDelegatorRewardResponse = module.exports.MsgWithdrawDelegatorReward = module.exports.MsgSetWithdrawAddressResponse = module.exports.MsgSetWithdrawAddress = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $8d6097f52d2f83a6$var$long_1 = $8d6097f52d2f83a6$var$__importDefault((parcelRequire("jRkuS")));

const $8d6097f52d2f83a6$var$minimal_1 = $8d6097f52d2f83a6$var$__importDefault((parcelRequire("fQBv0")));

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
function $8d6097f52d2f83a6$var$createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: ""
    };
}
module.exports.MsgSetWithdrawAddress = {
    encode (message, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgSetWithdrawAddress();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $8d6097f52d2f83a6$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: $8d6097f52d2f83a6$var$isSet(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $8d6097f52d2f83a6$var$createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.withdrawAddress = (_b = object.withdrawAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
module.exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgSetWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $8d6097f52d2f83a6$var$createBaseMsgSetWithdrawAddressResponse();
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $8d6097f52d2f83a6$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $8d6097f52d2f83a6$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgWithdrawDelegatorRewardResponse() {
    return {};
}
module.exports.MsgWithdrawDelegatorRewardResponse = {
    encode (_, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawDelegatorRewardResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawDelegatorRewardResponse();
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: ""
    };
}
module.exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawValidatorCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: $8d6097f52d2f83a6$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgWithdrawValidatorCommissionResponse() {
    return {};
}
module.exports.MsgWithdrawValidatorCommissionResponse = {
    encode (_, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $8d6097f52d2f83a6$var$createBaseMsgWithdrawValidatorCommissionResponse();
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: ""
    };
}
module.exports.MsgFundCommunityPool = {
    encode (message, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$9QyHq.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgFundCommunityPool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$9QyHq.Coin.fromJSON(e)) : [],
            depositor: $8d6097f52d2f83a6$var$isSet(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $8d6097f52d2f83a6$var$createBaseMsgFundCommunityPool();
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $8d6097f52d2f83a6$var$createBaseMsgFundCommunityPoolResponse() {
    return {};
}
module.exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $8d6097f52d2f83a6$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d6097f52d2f83a6$var$minimal_1.default.Reader ? input : new $8d6097f52d2f83a6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d6097f52d2f83a6$var$createBaseMsgFundCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $8d6097f52d2f83a6$var$createBaseMsgFundCommunityPoolResponse();
        return message;
    }
};
if ($8d6097f52d2f83a6$var$minimal_1.default.util.Long !== $8d6097f52d2f83a6$var$long_1.default) {
    $8d6097f52d2f83a6$var$minimal_1.default.util.Long = $8d6097f52d2f83a6$var$long_1.default;
    $8d6097f52d2f83a6$var$minimal_1.default.configure();
}
function $8d6097f52d2f83a6$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("c9nld", function(module, exports) {
"use strict";
var $8d886e65337ad696$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClearAdminResponse = module.exports.MsgClearAdmin = module.exports.MsgUpdateAdminResponse = module.exports.MsgUpdateAdmin = module.exports.MsgMigrateContractResponse = module.exports.MsgMigrateContract = module.exports.MsgExecuteContractResponse = module.exports.MsgExecuteContract = module.exports.MsgInstantiateContractResponse = module.exports.MsgInstantiateContract = module.exports.MsgStoreCodeResponse = module.exports.MsgStoreCode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $8d886e65337ad696$var$long_1 = $8d886e65337ad696$var$__importDefault((parcelRequire("jRkuS")));

const $8d886e65337ad696$var$minimal_1 = $8d886e65337ad696$var$__importDefault((parcelRequire("fQBv0")));

var $AqERh = parcelRequire("AqERh");

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
function $8d886e65337ad696$var$createBaseMsgStoreCode() {
    return {
        sender: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined
    };
}
module.exports.MsgStoreCode = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.wasmByteCode.length !== 0) writer.uint32(18).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $AqERh.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgStoreCode();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = $AqERh.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $8d886e65337ad696$var$isSet(object.sender) ? String(object.sender) : "",
            wasmByteCode: $8d886e65337ad696$var$isSet(object.wasmByteCode) ? $8d886e65337ad696$var$bytesFromBase64(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: $8d886e65337ad696$var$isSet(object.instantiatePermission) ? $AqERh.AccessConfig.fromJSON(object.instantiatePermission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = $8d886e65337ad696$var$base64FromBytes(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $AqERh.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $8d886e65337ad696$var$createBaseMsgStoreCode();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.wasmByteCode = (_b = object.wasmByteCode) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? $AqERh.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgStoreCodeResponse() {
    return {
        codeId: "0"
    };
}
module.exports.MsgStoreCodeResponse = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.codeId !== "0") writer.uint32(8).uint64(message.codeId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgStoreCodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = $8d886e65337ad696$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $8d886e65337ad696$var$isSet(object.codeId) ? String(object.codeId) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = message.codeId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $8d886e65337ad696$var$createBaseMsgStoreCodeResponse();
        message.codeId = (_a = object.codeId) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgInstantiateContract() {
    return {
        sender: "",
        admin: "",
        codeId: "0",
        label: "",
        msg: new Uint8Array(),
        funds: []
    };
}
module.exports.MsgInstantiateContract = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (message.codeId !== "0") writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        for (const v of message.funds)$9QyHq.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgInstantiateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = $8d886e65337ad696$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $8d886e65337ad696$var$isSet(object.sender) ? String(object.sender) : "",
            admin: $8d886e65337ad696$var$isSet(object.admin) ? String(object.admin) : "",
            codeId: $8d886e65337ad696$var$isSet(object.codeId) ? String(object.codeId) : "0",
            label: $8d886e65337ad696$var$isSet(object.label) ? String(object.label) : "",
            msg: $8d886e65337ad696$var$isSet(object.msg) ? $8d886e65337ad696$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = $8d886e65337ad696$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $8d886e65337ad696$var$createBaseMsgInstantiateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.admin = (_b = object.admin) !== null && _b !== void 0 ? _b : "";
        message.codeId = (_c = object.codeId) !== null && _c !== void 0 ? _c : "0";
        message.label = (_d = object.label) !== null && _d !== void 0 ? _d : "";
        message.msg = (_e = object.msg) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.funds = ((_f = object.funds) === null || _f === void 0 ? void 0 : _f.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgInstantiateContractResponse() {
    return {
        address: "",
        data: new Uint8Array()
    };
}
module.exports.MsgInstantiateContractResponse = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgInstantiateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $8d886e65337ad696$var$isSet(object.address) ? String(object.address) : "",
            data: $8d886e65337ad696$var$isSet(object.data) ? $8d886e65337ad696$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = $8d886e65337ad696$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $8d886e65337ad696$var$createBaseMsgInstantiateContractResponse();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgExecuteContract() {
    return {
        sender: "",
        contract: "",
        msg: new Uint8Array(),
        funds: []
    };
}
module.exports.MsgExecuteContract = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(26).bytes(message.msg);
        for (const v of message.funds)$9QyHq.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgExecuteContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $8d886e65337ad696$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $8d886e65337ad696$var$isSet(object.contract) ? String(object.contract) : "",
            msg: $8d886e65337ad696$var$isSet(object.msg) ? $8d886e65337ad696$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $8d886e65337ad696$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $8d886e65337ad696$var$createBaseMsgExecuteContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.funds = ((_d = object.funds) === null || _d === void 0 ? void 0 : _d.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgExecuteContractResponse() {
    return {
        data: new Uint8Array()
    };
}
module.exports.MsgExecuteContractResponse = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgExecuteContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $8d886e65337ad696$var$isSet(object.data) ? $8d886e65337ad696$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $8d886e65337ad696$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $8d886e65337ad696$var$createBaseMsgExecuteContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgMigrateContract() {
    return {
        sender: "",
        contract: "",
        codeId: "0",
        msg: new Uint8Array()
    };
}
module.exports.MsgMigrateContract = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.codeId !== "0") writer.uint32(24).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgMigrateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = $8d886e65337ad696$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $8d886e65337ad696$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $8d886e65337ad696$var$isSet(object.contract) ? String(object.contract) : "",
            codeId: $8d886e65337ad696$var$isSet(object.codeId) ? String(object.codeId) : "0",
            msg: $8d886e65337ad696$var$isSet(object.msg) ? $8d886e65337ad696$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.msg !== undefined && (obj.msg = $8d886e65337ad696$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $8d886e65337ad696$var$createBaseMsgMigrateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.codeId = (_c = object.codeId) !== null && _c !== void 0 ? _c : "0";
        message.msg = (_d = object.msg) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgMigrateContractResponse() {
    return {
        data: new Uint8Array()
    };
}
module.exports.MsgMigrateContractResponse = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgMigrateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $8d886e65337ad696$var$isSet(object.data) ? $8d886e65337ad696$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $8d886e65337ad696$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $8d886e65337ad696$var$createBaseMsgMigrateContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgUpdateAdmin() {
    return {
        sender: "",
        newAdmin: "",
        contract: ""
    };
}
module.exports.MsgUpdateAdmin = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.newAdmin !== "") writer.uint32(18).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgUpdateAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $8d886e65337ad696$var$isSet(object.sender) ? String(object.sender) : "",
            newAdmin: $8d886e65337ad696$var$isSet(object.newAdmin) ? String(object.newAdmin) : "",
            contract: $8d886e65337ad696$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $8d886e65337ad696$var$createBaseMsgUpdateAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.newAdmin = (_b = object.newAdmin) !== null && _b !== void 0 ? _b : "";
        message.contract = (_c = object.contract) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgUpdateAdminResponse() {
    return {};
}
module.exports.MsgUpdateAdminResponse = {
    encode (_, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgUpdateAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $8d886e65337ad696$var$createBaseMsgUpdateAdminResponse();
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgClearAdmin() {
    return {
        sender: "",
        contract: ""
    };
}
module.exports.MsgClearAdmin = {
    encode (message, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgClearAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $8d886e65337ad696$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $8d886e65337ad696$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $8d886e65337ad696$var$createBaseMsgClearAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $8d886e65337ad696$var$createBaseMsgClearAdminResponse() {
    return {};
}
module.exports.MsgClearAdminResponse = {
    encode (_, writer = $8d886e65337ad696$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8d886e65337ad696$var$minimal_1.default.Reader ? input : new $8d886e65337ad696$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8d886e65337ad696$var$createBaseMsgClearAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $8d886e65337ad696$var$createBaseMsgClearAdminResponse();
        return message;
    }
};
var $8d886e65337ad696$var$globalThis = (()=>{
    if (typeof $8d886e65337ad696$var$globalThis !== "undefined") return $8d886e65337ad696$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $8d886e65337ad696$var$atob = $8d886e65337ad696$var$globalThis.atob || ((b64)=>$8d886e65337ad696$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $8d886e65337ad696$var$bytesFromBase64(b64) {
    const bin = $8d886e65337ad696$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $8d886e65337ad696$var$btoa = $8d886e65337ad696$var$globalThis.btoa || ((bin)=>$8d886e65337ad696$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $8d886e65337ad696$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $8d886e65337ad696$var$btoa(bin.join(""));
}
function $8d886e65337ad696$var$longToString(long) {
    return long.toString();
}
if ($8d886e65337ad696$var$minimal_1.default.util.Long !== $8d886e65337ad696$var$long_1.default) {
    $8d886e65337ad696$var$minimal_1.default.util.Long = $8d886e65337ad696$var$long_1.default;
    $8d886e65337ad696$var$minimal_1.default.configure();
}
function $8d886e65337ad696$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("AqERh", function(module, exports) {
"use strict";
var $06d80aa1e996c3a1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Model = module.exports.AbsoluteTxPosition = module.exports.ContractCodeHistoryEntry = module.exports.ContractInfo = module.exports.CodeInfo = module.exports.Params = module.exports.AccessConfig = module.exports.AccessTypeParam = module.exports.contractCodeHistoryOperationTypeToJSON = module.exports.contractCodeHistoryOperationTypeFromJSON = module.exports.ContractCodeHistoryOperationType = module.exports.accessTypeToJSON = module.exports.accessTypeFromJSON = module.exports.AccessType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $06d80aa1e996c3a1$var$long_1 = $06d80aa1e996c3a1$var$__importDefault((parcelRequire("jRkuS")));

const $06d80aa1e996c3a1$var$minimal_1 = $06d80aa1e996c3a1$var$__importDefault((parcelRequire("fQBv0")));

var $5fiTY = parcelRequire("5fiTY");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */ var $06d80aa1e996c3a1$var$AccessType;
(function(AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */ AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */ AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /** ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to an address */ AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */ AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($06d80aa1e996c3a1$var$AccessType = module.exports.AccessType || (module.exports.AccessType = {}));
function $06d80aa1e996c3a1$var$accessTypeFromJSON(object) {
    switch(object){
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_EVERYBODY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $06d80aa1e996c3a1$var$AccessType.UNRECOGNIZED;
    }
}
module.exports.accessTypeFromJSON = $06d80aa1e996c3a1$var$accessTypeFromJSON;
function $06d80aa1e996c3a1$var$accessTypeToJSON(object) {
    switch(object){
        case $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case $06d80aa1e996c3a1$var$AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        default:
            return "UNKNOWN";
    }
}
module.exports.accessTypeToJSON = $06d80aa1e996c3a1$var$accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */ var $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType;
(function(ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($06d80aa1e996c3a1$var$ContractCodeHistoryOperationType = module.exports.ContractCodeHistoryOperationType || (module.exports.ContractCodeHistoryOperationType = {}));
function $06d80aa1e996c3a1$var$contractCodeHistoryOperationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
module.exports.contractCodeHistoryOperationTypeFromJSON = $06d80aa1e996c3a1$var$contractCodeHistoryOperationTypeFromJSON;
function $06d80aa1e996c3a1$var$contractCodeHistoryOperationTypeToJSON(object) {
    switch(object){
        case $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case $06d80aa1e996c3a1$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        default:
            return "UNKNOWN";
    }
}
module.exports.contractCodeHistoryOperationTypeToJSON = $06d80aa1e996c3a1$var$contractCodeHistoryOperationTypeToJSON;
function $06d80aa1e996c3a1$var$createBaseAccessTypeParam() {
    return {
        value: 0
    };
}
module.exports.AccessTypeParam = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.value !== 0) writer.uint32(8).int32(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseAccessTypeParam();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            value: $06d80aa1e996c3a1$var$isSet(object.value) ? $06d80aa1e996c3a1$var$accessTypeFromJSON(object.value) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.value !== undefined && (obj.value = $06d80aa1e996c3a1$var$accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $06d80aa1e996c3a1$var$createBaseAccessTypeParam();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseAccessConfig() {
    return {
        permission: 0,
        address: ""
    };
}
module.exports.AccessConfig = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.permission !== 0) writer.uint32(8).int32(message.permission);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseAccessConfig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            permission: $06d80aa1e996c3a1$var$isSet(object.permission) ? $06d80aa1e996c3a1$var$accessTypeFromJSON(object.permission) : 0,
            address: $06d80aa1e996c3a1$var$isSet(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.permission !== undefined && (obj.permission = $06d80aa1e996c3a1$var$accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $06d80aa1e996c3a1$var$createBaseAccessConfig();
        message.permission = (_a = object.permission) !== null && _a !== void 0 ? _a : 0;
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseParams() {
    return {
        codeUploadAccess: undefined,
        instantiateDefaultPermission: 0,
        maxWasmCodeSize: "0"
    };
}
module.exports.Params = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.codeUploadAccess !== undefined) module.exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        if (message.instantiateDefaultPermission !== 0) writer.uint32(16).int32(message.instantiateDefaultPermission);
        if (message.maxWasmCodeSize !== "0") writer.uint32(24).uint64(message.maxWasmCodeSize);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeUploadAccess = module.exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                case 3:
                    message.maxWasmCodeSize = $06d80aa1e996c3a1$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeUploadAccess: $06d80aa1e996c3a1$var$isSet(object.codeUploadAccess) ? module.exports.AccessConfig.fromJSON(object.codeUploadAccess) : undefined,
            instantiateDefaultPermission: $06d80aa1e996c3a1$var$isSet(object.instantiateDefaultPermission) ? $06d80aa1e996c3a1$var$accessTypeFromJSON(object.instantiateDefaultPermission) : 0,
            maxWasmCodeSize: $06d80aa1e996c3a1$var$isSet(object.maxWasmCodeSize) ? String(object.maxWasmCodeSize) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeUploadAccess !== undefined && (obj.codeUploadAccess = message.codeUploadAccess ? module.exports.AccessConfig.toJSON(message.codeUploadAccess) : undefined);
        message.instantiateDefaultPermission !== undefined && (obj.instantiateDefaultPermission = $06d80aa1e996c3a1$var$accessTypeToJSON(message.instantiateDefaultPermission));
        message.maxWasmCodeSize !== undefined && (obj.maxWasmCodeSize = message.maxWasmCodeSize);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $06d80aa1e996c3a1$var$createBaseParams();
        message.codeUploadAccess = object.codeUploadAccess !== undefined && object.codeUploadAccess !== null ? module.exports.AccessConfig.fromPartial(object.codeUploadAccess) : undefined;
        message.instantiateDefaultPermission = (_a = object.instantiateDefaultPermission) !== null && _a !== void 0 ? _a : 0;
        message.maxWasmCodeSize = (_b = object.maxWasmCodeSize) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseCodeInfo() {
    return {
        codeHash: new Uint8Array(),
        creator: "",
        instantiateConfig: undefined
    };
}
module.exports.CodeInfo = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.codeHash.length !== 0) writer.uint32(10).bytes(message.codeHash);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.instantiateConfig !== undefined) module.exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseCodeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = module.exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeHash: $06d80aa1e996c3a1$var$isSet(object.codeHash) ? $06d80aa1e996c3a1$var$bytesFromBase64(object.codeHash) : new Uint8Array(),
            creator: $06d80aa1e996c3a1$var$isSet(object.creator) ? String(object.creator) : "",
            instantiateConfig: $06d80aa1e996c3a1$var$isSet(object.instantiateConfig) ? module.exports.AccessConfig.fromJSON(object.instantiateConfig) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeHash !== undefined && (obj.codeHash = $06d80aa1e996c3a1$var$base64FromBytes(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined && (obj.instantiateConfig = message.instantiateConfig ? module.exports.AccessConfig.toJSON(message.instantiateConfig) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $06d80aa1e996c3a1$var$createBaseCodeInfo();
        message.codeHash = (_a = object.codeHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.instantiateConfig = object.instantiateConfig !== undefined && object.instantiateConfig !== null ? module.exports.AccessConfig.fromPartial(object.instantiateConfig) : undefined;
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseContractInfo() {
    return {
        codeId: "0",
        creator: "",
        admin: "",
        label: "",
        created: undefined,
        ibcPortId: "",
        extension: undefined
    };
}
module.exports.ContractInfo = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.codeId !== "0") writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.created !== undefined) module.exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        if (message.ibcPortId !== "") writer.uint32(50).string(message.ibcPortId);
        if (message.extension !== undefined) $5fiTY.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseContractInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = $06d80aa1e996c3a1$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = module.exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $06d80aa1e996c3a1$var$isSet(object.codeId) ? String(object.codeId) : "0",
            creator: $06d80aa1e996c3a1$var$isSet(object.creator) ? String(object.creator) : "",
            admin: $06d80aa1e996c3a1$var$isSet(object.admin) ? String(object.admin) : "",
            label: $06d80aa1e996c3a1$var$isSet(object.label) ? String(object.label) : "",
            created: $06d80aa1e996c3a1$var$isSet(object.created) ? module.exports.AbsoluteTxPosition.fromJSON(object.created) : undefined,
            ibcPortId: $06d80aa1e996c3a1$var$isSet(object.ibcPortId) ? String(object.ibcPortId) : "",
            extension: $06d80aa1e996c3a1$var$isSet(object.extension) ? $5fiTY.Any.fromJSON(object.extension) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined && (obj.created = message.created ? module.exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined && (obj.extension = message.extension ? $5fiTY.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $06d80aa1e996c3a1$var$createBaseContractInfo();
        message.codeId = (_a = object.codeId) !== null && _a !== void 0 ? _a : "0";
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.admin = (_c = object.admin) !== null && _c !== void 0 ? _c : "";
        message.label = (_d = object.label) !== null && _d !== void 0 ? _d : "";
        message.created = object.created !== undefined && object.created !== null ? module.exports.AbsoluteTxPosition.fromPartial(object.created) : undefined;
        message.ibcPortId = (_e = object.ibcPortId) !== null && _e !== void 0 ? _e : "";
        message.extension = object.extension !== undefined && object.extension !== null ? $5fiTY.Any.fromPartial(object.extension) : undefined;
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseContractCodeHistoryEntry() {
    return {
        operation: 0,
        codeId: "0",
        updated: undefined,
        msg: new Uint8Array()
    };
}
module.exports.ContractCodeHistoryEntry = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.operation !== 0) writer.uint32(8).int32(message.operation);
        if (message.codeId !== "0") writer.uint32(16).uint64(message.codeId);
        if (message.updated !== undefined) module.exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseContractCodeHistoryEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = $06d80aa1e996c3a1$var$longToString(reader.uint64());
                    break;
                case 3:
                    message.updated = module.exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operation: $06d80aa1e996c3a1$var$isSet(object.operation) ? $06d80aa1e996c3a1$var$contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
            codeId: $06d80aa1e996c3a1$var$isSet(object.codeId) ? String(object.codeId) : "0",
            updated: $06d80aa1e996c3a1$var$isSet(object.updated) ? module.exports.AbsoluteTxPosition.fromJSON(object.updated) : undefined,
            msg: $06d80aa1e996c3a1$var$isSet(object.msg) ? $06d80aa1e996c3a1$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.operation !== undefined && (obj.operation = $06d80aa1e996c3a1$var$contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.updated !== undefined && (obj.updated = message.updated ? module.exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined && (obj.msg = $06d80aa1e996c3a1$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $06d80aa1e996c3a1$var$createBaseContractCodeHistoryEntry();
        message.operation = (_a = object.operation) !== null && _a !== void 0 ? _a : 0;
        message.codeId = (_b = object.codeId) !== null && _b !== void 0 ? _b : "0";
        message.updated = object.updated !== undefined && object.updated !== null ? module.exports.AbsoluteTxPosition.fromPartial(object.updated) : undefined;
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseAbsoluteTxPosition() {
    return {
        blockHeight: "0",
        txIndex: "0"
    };
}
module.exports.AbsoluteTxPosition = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.blockHeight !== "0") writer.uint32(8).uint64(message.blockHeight);
        if (message.txIndex !== "0") writer.uint32(16).uint64(message.txIndex);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseAbsoluteTxPosition();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockHeight = $06d80aa1e996c3a1$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.txIndex = $06d80aa1e996c3a1$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockHeight: $06d80aa1e996c3a1$var$isSet(object.blockHeight) ? String(object.blockHeight) : "0",
            txIndex: $06d80aa1e996c3a1$var$isSet(object.txIndex) ? String(object.txIndex) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = message.blockHeight);
        message.txIndex !== undefined && (obj.txIndex = message.txIndex);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $06d80aa1e996c3a1$var$createBaseAbsoluteTxPosition();
        message.blockHeight = (_a = object.blockHeight) !== null && _a !== void 0 ? _a : "0";
        message.txIndex = (_b = object.txIndex) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $06d80aa1e996c3a1$var$createBaseModel() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array()
    };
}
module.exports.Model = {
    encode (message, writer = $06d80aa1e996c3a1$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $06d80aa1e996c3a1$var$minimal_1.default.Reader ? input : new $06d80aa1e996c3a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $06d80aa1e996c3a1$var$createBaseModel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $06d80aa1e996c3a1$var$isSet(object.key) ? $06d80aa1e996c3a1$var$bytesFromBase64(object.key) : new Uint8Array(),
            value: $06d80aa1e996c3a1$var$isSet(object.value) ? $06d80aa1e996c3a1$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $06d80aa1e996c3a1$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $06d80aa1e996c3a1$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $06d80aa1e996c3a1$var$createBaseModel();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $06d80aa1e996c3a1$var$globalThis = (()=>{
    if (typeof $06d80aa1e996c3a1$var$globalThis !== "undefined") return $06d80aa1e996c3a1$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $06d80aa1e996c3a1$var$atob = $06d80aa1e996c3a1$var$globalThis.atob || ((b64)=>$06d80aa1e996c3a1$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $06d80aa1e996c3a1$var$bytesFromBase64(b64) {
    const bin = $06d80aa1e996c3a1$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $06d80aa1e996c3a1$var$btoa = $06d80aa1e996c3a1$var$globalThis.btoa || ((bin)=>$06d80aa1e996c3a1$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $06d80aa1e996c3a1$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $06d80aa1e996c3a1$var$btoa(bin.join(""));
}
function $06d80aa1e996c3a1$var$longToString(long) {
    return long.toString();
}
if ($06d80aa1e996c3a1$var$minimal_1.default.util.Long !== $06d80aa1e996c3a1$var$long_1.default) {
    $06d80aa1e996c3a1$var$minimal_1.default.util.Long = $06d80aa1e996c3a1$var$long_1.default;
    $06d80aa1e996c3a1$var$minimal_1.default.configure();
}
function $06d80aa1e996c3a1$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("9rLeA", function(module, exports) {
"use strict";
var $6e0b466db7aa9f27$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgTransferResponse = module.exports.MsgTransfer = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6e0b466db7aa9f27$var$long_1 = $6e0b466db7aa9f27$var$__importDefault((parcelRequire("jRkuS")));

const $6e0b466db7aa9f27$var$minimal_1 = $6e0b466db7aa9f27$var$__importDefault((parcelRequire("fQBv0")));

var $9QyHq = parcelRequire("9QyHq");

var $6prBK = parcelRequire("6prBK");
module.exports.protobufPackage = "ibc.applications.transfer.v1";
function $6e0b466db7aa9f27$var$createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: "0",
        memo: ""
    };
}
module.exports.MsgTransfer = {
    encode (message, writer = $6e0b466db7aa9f27$var$minimal_1.default.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $9QyHq.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $6prBK.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (message.timeoutTimestamp !== "0") writer.uint32(56).uint64(message.timeoutTimestamp);
        if (message.memo !== "") writer.uint32(66).string(message.memo);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6e0b466db7aa9f27$var$minimal_1.default.Reader ? input : new $6e0b466db7aa9f27$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6e0b466db7aa9f27$var$createBaseMsgTransfer();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $6prBK.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = $6e0b466db7aa9f27$var$longToString(reader.uint64());
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sourcePort: $6e0b466db7aa9f27$var$isSet(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: $6e0b466db7aa9f27$var$isSet(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: $6e0b466db7aa9f27$var$isSet(object.token) ? $9QyHq.Coin.fromJSON(object.token) : undefined,
            sender: $6e0b466db7aa9f27$var$isSet(object.sender) ? String(object.sender) : "",
            receiver: $6e0b466db7aa9f27$var$isSet(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: $6e0b466db7aa9f27$var$isSet(object.timeoutHeight) ? $6prBK.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: $6e0b466db7aa9f27$var$isSet(object.timeoutTimestamp) ? String(object.timeoutTimestamp) : "0",
            memo: $6e0b466db7aa9f27$var$isSet(object.memo) ? String(object.memo) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $9QyHq.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $6prBK.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = message.timeoutTimestamp);
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $6e0b466db7aa9f27$var$createBaseMsgTransfer();
        message.sourcePort = (_a = object.sourcePort) !== null && _a !== void 0 ? _a : "";
        message.sourceChannel = (_b = object.sourceChannel) !== null && _b !== void 0 ? _b : "";
        message.token = object.token !== undefined && object.token !== null ? $9QyHq.Coin.fromPartial(object.token) : undefined;
        message.sender = (_c = object.sender) !== null && _c !== void 0 ? _c : "";
        message.receiver = (_d = object.receiver) !== null && _d !== void 0 ? _d : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $6prBK.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = (_e = object.timeoutTimestamp) !== null && _e !== void 0 ? _e : "0";
        message.memo = (_f = object.memo) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $6e0b466db7aa9f27$var$createBaseMsgTransferResponse() {
    return {};
}
module.exports.MsgTransferResponse = {
    encode (_, writer = $6e0b466db7aa9f27$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6e0b466db7aa9f27$var$minimal_1.default.Reader ? input : new $6e0b466db7aa9f27$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6e0b466db7aa9f27$var$createBaseMsgTransferResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6e0b466db7aa9f27$var$createBaseMsgTransferResponse();
        return message;
    }
};
function $6e0b466db7aa9f27$var$longToString(long) {
    return long.toString();
}
if ($6e0b466db7aa9f27$var$minimal_1.default.util.Long !== $6e0b466db7aa9f27$var$long_1.default) {
    $6e0b466db7aa9f27$var$minimal_1.default.util.Long = $6e0b466db7aa9f27$var$long_1.default;
    $6e0b466db7aa9f27$var$minimal_1.default.configure();
}
function $6e0b466db7aa9f27$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("6prBK", function(module, exports) {
"use strict";
var $4aaa7e35453166b5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Height = module.exports.UpgradeProposal = module.exports.ClientUpdateProposal = module.exports.ClientConsensusStates = module.exports.ConsensusStateWithHeight = module.exports.IdentifiedClientState = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $4aaa7e35453166b5$var$long_1 = $4aaa7e35453166b5$var$__importDefault((parcelRequire("jRkuS")));

const $4aaa7e35453166b5$var$minimal_1 = $4aaa7e35453166b5$var$__importDefault((parcelRequire("fQBv0")));

var $5fiTY = parcelRequire("5fiTY");

var $klhsD = parcelRequire("klhsD");
module.exports.protobufPackage = "ibc.core.client.v1";
function $4aaa7e35453166b5$var$createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined
    };
}
module.exports.IdentifiedClientState = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $5fiTY.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseIdentifiedClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: $4aaa7e35453166b5$var$isSet(object.clientId) ? String(object.clientId) : "",
            clientState: $4aaa7e35453166b5$var$isSet(object.clientState) ? $5fiTY.Any.fromJSON(object.clientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $5fiTY.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $4aaa7e35453166b5$var$createBaseIdentifiedClientState();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $5fiTY.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
function $4aaa7e35453166b5$var$createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined
    };
}
module.exports.ConsensusStateWithHeight = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        if (message.height !== undefined) module.exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $5fiTY.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseConsensusStateWithHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = module.exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: $4aaa7e35453166b5$var$isSet(object.height) ? module.exports.Height.fromJSON(object.height) : undefined,
            consensusState: $4aaa7e35453166b5$var$isSet(object.consensusState) ? $5fiTY.Any.fromJSON(object.consensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? module.exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $5fiTY.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4aaa7e35453166b5$var$createBaseConsensusStateWithHeight();
        message.height = object.height !== undefined && object.height !== null ? module.exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $5fiTY.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
function $4aaa7e35453166b5$var$createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: []
    };
}
module.exports.ClientConsensusStates = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)module.exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseClientConsensusStates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push(module.exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: $4aaa7e35453166b5$var$isSet(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStates) ? object.consensusStates.map((e)=>module.exports.ConsensusStateWithHeight.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? module.exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $4aaa7e35453166b5$var$createBaseClientConsensusStates();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.consensusStates = ((_b = object.consensusStates) === null || _b === void 0 ? void 0 : _b.map((e)=>module.exports.ConsensusStateWithHeight.fromPartial(e))) || [];
        return message;
    }
};
function $4aaa7e35453166b5$var$createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: ""
    };
}
module.exports.ClientUpdateProposal = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseClientUpdateProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $4aaa7e35453166b5$var$isSet(object.title) ? String(object.title) : "",
            description: $4aaa7e35453166b5$var$isSet(object.description) ? String(object.description) : "",
            subjectClientId: $4aaa7e35453166b5$var$isSet(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: $4aaa7e35453166b5$var$isSet(object.substituteClientId) ? String(object.substituteClientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $4aaa7e35453166b5$var$createBaseClientUpdateProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.subjectClientId = (_c = object.subjectClientId) !== null && _c !== void 0 ? _c : "";
        message.substituteClientId = (_d = object.substituteClientId) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $4aaa7e35453166b5$var$createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined
    };
}
module.exports.UpgradeProposal = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $klhsD.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $5fiTY.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $klhsD.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $4aaa7e35453166b5$var$isSet(object.title) ? String(object.title) : "",
            description: $4aaa7e35453166b5$var$isSet(object.description) ? String(object.description) : "",
            plan: $4aaa7e35453166b5$var$isSet(object.plan) ? $klhsD.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: $4aaa7e35453166b5$var$isSet(object.upgradedClientState) ? $5fiTY.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $klhsD.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $5fiTY.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $4aaa7e35453166b5$var$createBaseUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.plan = object.plan !== undefined && object.plan !== null ? $klhsD.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $5fiTY.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $4aaa7e35453166b5$var$createBaseHeight() {
    return {
        revisionNumber: "0",
        revisionHeight: "0"
    };
}
module.exports.Height = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        if (message.revisionNumber !== "0") writer.uint32(8).uint64(message.revisionNumber);
        if (message.revisionHeight !== "0") writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = $4aaa7e35453166b5$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.revisionHeight = $4aaa7e35453166b5$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            revisionNumber: $4aaa7e35453166b5$var$isSet(object.revisionNumber) ? String(object.revisionNumber) : "0",
            revisionHeight: $4aaa7e35453166b5$var$isSet(object.revisionHeight) ? String(object.revisionHeight) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = message.revisionNumber);
        message.revisionHeight !== undefined && (obj.revisionHeight = message.revisionHeight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $4aaa7e35453166b5$var$createBaseHeight();
        message.revisionNumber = (_a = object.revisionNumber) !== null && _a !== void 0 ? _a : "0";
        message.revisionHeight = (_b = object.revisionHeight) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $4aaa7e35453166b5$var$createBaseParams() {
    return {
        allowedClients: []
    };
}
module.exports.Params = {
    encode (message, writer = $4aaa7e35453166b5$var$minimal_1.default.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4aaa7e35453166b5$var$minimal_1.default.Reader ? input : new $4aaa7e35453166b5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4aaa7e35453166b5$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowedClients: Array.isArray(object === null || object === void 0 ? void 0 : object.allowedClients) ? object.allowedClients.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $4aaa7e35453166b5$var$createBaseParams();
        message.allowedClients = ((_a = object.allowedClients) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $4aaa7e35453166b5$var$longToString(long) {
    return long.toString();
}
if ($4aaa7e35453166b5$var$minimal_1.default.util.Long !== $4aaa7e35453166b5$var$long_1.default) {
    $4aaa7e35453166b5$var$minimal_1.default.util.Long = $4aaa7e35453166b5$var$long_1.default;
    $4aaa7e35453166b5$var$minimal_1.default.configure();
}
function $4aaa7e35453166b5$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("klhsD", function(module, exports) {
"use strict";
var $ecf35030afdab57a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleVersion = module.exports.CancelSoftwareUpgradeProposal = module.exports.SoftwareUpgradeProposal = module.exports.Plan = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ecf35030afdab57a$var$long_1 = $ecf35030afdab57a$var$__importDefault((parcelRequire("jRkuS")));

const $ecf35030afdab57a$var$minimal_1 = $ecf35030afdab57a$var$__importDefault((parcelRequire("fQBv0")));

var $xgb9l = parcelRequire("xgb9l");

var $5fiTY = parcelRequire("5fiTY");
module.exports.protobufPackage = "cosmos.upgrade.v1beta1";
function $ecf35030afdab57a$var$createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: "0",
        info: "",
        upgradedClientState: undefined
    };
}
module.exports.Plan = {
    encode (message, writer = $ecf35030afdab57a$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $xgb9l.Timestamp.encode($ecf35030afdab57a$var$toTimestamp(message.time), writer.uint32(18).fork()).ldelim();
        if (message.height !== "0") writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $5fiTY.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ecf35030afdab57a$var$minimal_1.default.Reader ? input : new $ecf35030afdab57a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ecf35030afdab57a$var$createBasePlan();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $ecf35030afdab57a$var$fromTimestamp($xgb9l.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.height = $ecf35030afdab57a$var$longToString(reader.int64());
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: $ecf35030afdab57a$var$isSet(object.name) ? String(object.name) : "",
            time: $ecf35030afdab57a$var$isSet(object.time) ? $ecf35030afdab57a$var$fromJsonTimestamp(object.time) : undefined,
            height: $ecf35030afdab57a$var$isSet(object.height) ? String(object.height) : "0",
            info: $ecf35030afdab57a$var$isSet(object.info) ? String(object.info) : "",
            upgradedClientState: $ecf35030afdab57a$var$isSet(object.upgradedClientState) ? $5fiTY.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.height !== undefined && (obj.height = message.height);
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $5fiTY.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $ecf35030afdab57a$var$createBasePlan();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.time = (_b = object.time) !== null && _b !== void 0 ? _b : undefined;
        message.height = (_c = object.height) !== null && _c !== void 0 ? _c : "0";
        message.info = (_d = object.info) !== null && _d !== void 0 ? _d : "";
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $5fiTY.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $ecf35030afdab57a$var$createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined
    };
}
module.exports.SoftwareUpgradeProposal = {
    encode (message, writer = $ecf35030afdab57a$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) module.exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ecf35030afdab57a$var$minimal_1.default.Reader ? input : new $ecf35030afdab57a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ecf35030afdab57a$var$createBaseSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = module.exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $ecf35030afdab57a$var$isSet(object.title) ? String(object.title) : "",
            description: $ecf35030afdab57a$var$isSet(object.description) ? String(object.description) : "",
            plan: $ecf35030afdab57a$var$isSet(object.plan) ? module.exports.Plan.fromJSON(object.plan) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? module.exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ecf35030afdab57a$var$createBaseSoftwareUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.plan = object.plan !== undefined && object.plan !== null ? module.exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    }
};
function $ecf35030afdab57a$var$createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: ""
    };
}
module.exports.CancelSoftwareUpgradeProposal = {
    encode (message, writer = $ecf35030afdab57a$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ecf35030afdab57a$var$minimal_1.default.Reader ? input : new $ecf35030afdab57a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ecf35030afdab57a$var$createBaseCancelSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $ecf35030afdab57a$var$isSet(object.title) ? String(object.title) : "",
            description: $ecf35030afdab57a$var$isSet(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ecf35030afdab57a$var$createBaseCancelSoftwareUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $ecf35030afdab57a$var$createBaseModuleVersion() {
    return {
        name: "",
        version: "0"
    };
}
module.exports.ModuleVersion = {
    encode (message, writer = $ecf35030afdab57a$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.version !== "0") writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ecf35030afdab57a$var$minimal_1.default.Reader ? input : new $ecf35030afdab57a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ecf35030afdab57a$var$createBaseModuleVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = $ecf35030afdab57a$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: $ecf35030afdab57a$var$isSet(object.name) ? String(object.name) : "",
            version: $ecf35030afdab57a$var$isSet(object.version) ? String(object.version) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ecf35030afdab57a$var$createBaseModuleVersion();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.version = (_b = object.version) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $ecf35030afdab57a$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $ecf35030afdab57a$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $ecf35030afdab57a$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $ecf35030afdab57a$var$fromTimestamp($xgb9l.Timestamp.fromJSON(o));
}
function $ecf35030afdab57a$var$longToString(long) {
    return long.toString();
}
if ($ecf35030afdab57a$var$minimal_1.default.util.Long !== $ecf35030afdab57a$var$long_1.default) {
    $ecf35030afdab57a$var$minimal_1.default.util.Long = $ecf35030afdab57a$var$long_1.default;
    $ecf35030afdab57a$var$minimal_1.default.configure();
}
function $ecf35030afdab57a$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("dHVad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownMessage = void 0;

var $ihoyg = parcelRequire("ihoyg");
class $9faba20bf8621575$var$UnknownMessage {
    constructor(/** Any type_url. */ _typeUrl, /** Any value. */ _value){
        this._typeUrl = _typeUrl;
        this._value = _value;
    }
    get typeUrl() {
        return this._typeUrl;
    }
    get value() {
        return this._value;
    }
    toJSON() {
        return {
            typeUrl: this._typeUrl,
            value: $ihoyg.Buffer.from(this._value).toString("base64")
        };
    }
}
module.exports.UnknownMessage = $9faba20bf8621575$var$UnknownMessage;

});

parcelRegister("jPbAy", function(module, exports) {
"use strict";
var $e6ebc4f8d17c2726$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakeAuthorization_Validators = module.exports.StakeAuthorization = module.exports.authorizationTypeToJSON = module.exports.authorizationTypeFromJSON = module.exports.AuthorizationType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $e6ebc4f8d17c2726$var$long_1 = $e6ebc4f8d17c2726$var$__importDefault((parcelRequire("jRkuS")));

const $e6ebc4f8d17c2726$var$minimal_1 = $e6ebc4f8d17c2726$var$__importDefault((parcelRequire("fQBv0")));

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/** AuthorizationType defines the type of staking module authorization type */ var $e6ebc4f8d17c2726$var$AuthorizationType;
(function(AuthorizationType) {
    /** AUTHORIZATION_TYPE_UNSPECIFIED - AUTHORIZATION_TYPE_UNSPECIFIED specifies an unknown authorization type */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNSPECIFIED"] = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED";
    /** AUTHORIZATION_TYPE_DELEGATE - AUTHORIZATION_TYPE_DELEGATE defines an authorization type for Msg/Delegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_DELEGATE"] = 1] = "AUTHORIZATION_TYPE_DELEGATE";
    /** AUTHORIZATION_TYPE_UNDELEGATE - AUTHORIZATION_TYPE_UNDELEGATE defines an authorization type for Msg/Undelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNDELEGATE"] = 2] = "AUTHORIZATION_TYPE_UNDELEGATE";
    /** AUTHORIZATION_TYPE_REDELEGATE - AUTHORIZATION_TYPE_REDELEGATE defines an authorization type for Msg/BeginRedelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_REDELEGATE"] = 3] = "AUTHORIZATION_TYPE_REDELEGATE";
    AuthorizationType[AuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e6ebc4f8d17c2726$var$AuthorizationType = module.exports.AuthorizationType || (module.exports.AuthorizationType = {}));
function $e6ebc4f8d17c2726$var$authorizationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "AUTHORIZATION_TYPE_UNSPECIFIED":
            return $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED;
        case 1:
        case "AUTHORIZATION_TYPE_DELEGATE":
            return $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE;
        case 2:
        case "AUTHORIZATION_TYPE_UNDELEGATE":
            return $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE;
        case 3:
        case "AUTHORIZATION_TYPE_REDELEGATE":
            return $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e6ebc4f8d17c2726$var$AuthorizationType.UNRECOGNIZED;
    }
}
module.exports.authorizationTypeFromJSON = $e6ebc4f8d17c2726$var$authorizationTypeFromJSON;
function $e6ebc4f8d17c2726$var$authorizationTypeToJSON(object) {
    switch(object){
        case $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED:
            return "AUTHORIZATION_TYPE_UNSPECIFIED";
        case $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
            return "AUTHORIZATION_TYPE_DELEGATE";
        case $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
            return "AUTHORIZATION_TYPE_UNDELEGATE";
        case $e6ebc4f8d17c2726$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
            return "AUTHORIZATION_TYPE_REDELEGATE";
        default:
            return "UNKNOWN";
    }
}
module.exports.authorizationTypeToJSON = $e6ebc4f8d17c2726$var$authorizationTypeToJSON;
function $e6ebc4f8d17c2726$var$createBaseStakeAuthorization() {
    return {
        maxTokens: undefined,
        allowList: undefined,
        denyList: undefined,
        authorizationType: 0
    };
}
module.exports.StakeAuthorization = {
    encode (message, writer = $e6ebc4f8d17c2726$var$minimal_1.default.Writer.create()) {
        if (message.maxTokens !== undefined) $9QyHq.Coin.encode(message.maxTokens, writer.uint32(10).fork()).ldelim();
        if (message.allowList !== undefined) module.exports.StakeAuthorization_Validators.encode(message.allowList, writer.uint32(18).fork()).ldelim();
        if (message.denyList !== undefined) module.exports.StakeAuthorization_Validators.encode(message.denyList, writer.uint32(26).fork()).ldelim();
        if (message.authorizationType !== 0) writer.uint32(32).int32(message.authorizationType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6ebc4f8d17c2726$var$minimal_1.default.Reader ? input : new $e6ebc4f8d17c2726$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6ebc4f8d17c2726$var$createBaseStakeAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTokens = $9QyHq.Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowList = module.exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.denyList = module.exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.authorizationType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxTokens: $e6ebc4f8d17c2726$var$isSet(object.maxTokens) ? $9QyHq.Coin.fromJSON(object.maxTokens) : undefined,
            allowList: $e6ebc4f8d17c2726$var$isSet(object.allowList) ? module.exports.StakeAuthorization_Validators.fromJSON(object.allowList) : undefined,
            denyList: $e6ebc4f8d17c2726$var$isSet(object.denyList) ? module.exports.StakeAuthorization_Validators.fromJSON(object.denyList) : undefined,
            authorizationType: $e6ebc4f8d17c2726$var$isSet(object.authorizationType) ? $e6ebc4f8d17c2726$var$authorizationTypeFromJSON(object.authorizationType) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxTokens !== undefined && (obj.maxTokens = message.maxTokens ? $9QyHq.Coin.toJSON(message.maxTokens) : undefined);
        message.allowList !== undefined && (obj.allowList = message.allowList ? module.exports.StakeAuthorization_Validators.toJSON(message.allowList) : undefined);
        message.denyList !== undefined && (obj.denyList = message.denyList ? module.exports.StakeAuthorization_Validators.toJSON(message.denyList) : undefined);
        message.authorizationType !== undefined && (obj.authorizationType = $e6ebc4f8d17c2726$var$authorizationTypeToJSON(message.authorizationType));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $e6ebc4f8d17c2726$var$createBaseStakeAuthorization();
        message.maxTokens = object.maxTokens !== undefined && object.maxTokens !== null ? $9QyHq.Coin.fromPartial(object.maxTokens) : undefined;
        message.allowList = object.allowList !== undefined && object.allowList !== null ? module.exports.StakeAuthorization_Validators.fromPartial(object.allowList) : undefined;
        message.denyList = object.denyList !== undefined && object.denyList !== null ? module.exports.StakeAuthorization_Validators.fromPartial(object.denyList) : undefined;
        message.authorizationType = (_a = object.authorizationType) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $e6ebc4f8d17c2726$var$createBaseStakeAuthorization_Validators() {
    return {
        address: []
    };
}
module.exports.StakeAuthorization_Validators = {
    encode (message, writer = $e6ebc4f8d17c2726$var$minimal_1.default.Writer.create()) {
        for (const v of message.address)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6ebc4f8d17c2726$var$minimal_1.default.Reader ? input : new $e6ebc4f8d17c2726$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6ebc4f8d17c2726$var$createBaseStakeAuthorization_Validators();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: Array.isArray(object === null || object === void 0 ? void 0 : object.address) ? object.address.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.address) obj.address = message.address.map((e)=>e);
        else obj.address = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $e6ebc4f8d17c2726$var$createBaseStakeAuthorization_Validators();
        message.address = ((_a = object.address) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
if ($e6ebc4f8d17c2726$var$minimal_1.default.util.Long !== $e6ebc4f8d17c2726$var$long_1.default) {
    $e6ebc4f8d17c2726$var$minimal_1.default.util.Long = $e6ebc4f8d17c2726$var$long_1.default;
    $e6ebc4f8d17c2726$var$minimal_1.default.configure();
}
function $e6ebc4f8d17c2726$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("dMp8E", function(module, exports) {
"use strict";
var $a083420d4de95765$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendAuthorization = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $a083420d4de95765$var$long_1 = $a083420d4de95765$var$__importDefault((parcelRequire("jRkuS")));

const $a083420d4de95765$var$minimal_1 = $a083420d4de95765$var$__importDefault((parcelRequire("fQBv0")));

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $a083420d4de95765$var$createBaseSendAuthorization() {
    return {
        spendLimit: []
    };
}
module.exports.SendAuthorization = {
    encode (message, writer = $a083420d4de95765$var$minimal_1.default.Writer.create()) {
        for (const v of message.spendLimit)$9QyHq.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a083420d4de95765$var$minimal_1.default.Reader ? input : new $a083420d4de95765$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a083420d4de95765$var$createBaseSendAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            spendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.spendLimit) ? object.spendLimit.map((e)=>$9QyHq.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $a083420d4de95765$var$createBaseSendAuthorization();
        message.spendLimit = ((_a = object.spendLimit) === null || _a === void 0 ? void 0 : _a.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        return message;
    }
};
if ($a083420d4de95765$var$minimal_1.default.util.Long !== $a083420d4de95765$var$long_1.default) {
    $a083420d4de95765$var$minimal_1.default.util.Long = $a083420d4de95765$var$long_1.default;
    $a083420d4de95765$var$minimal_1.default.configure();
}

});


parcelRegister("g0kvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProtoSignDocDecoder = void 0;

var $bcGNv = parcelRequire("bcGNv");

var $7jGk0 = parcelRequire("7jGk0");
class $ba6c8ce2d120e456$var$ProtoSignDocDecoder {
    static decode(bytes) {
        return new $ba6c8ce2d120e456$var$ProtoSignDocDecoder($bcGNv.SignDoc.decode(bytes));
    }
    constructor(signDoc, protoCodec = $7jGk0.defaultProtoCodec){
        this.signDoc = signDoc;
        this.protoCodec = protoCodec;
    }
    get txBody() {
        if (!this._txBody) this._txBody = $bcGNv.TxBody.decode(this.signDoc.bodyBytes);
        return this._txBody;
    }
    get txMsgs() {
        const msgs = [];
        for (const msg of this.txBody.messages)msgs.push(this.protoCodec.unpackAny(msg));
        return msgs;
    }
    get authInfo() {
        if (!this._authInfo) this._authInfo = $bcGNv.AuthInfo.decode(this.signDoc.authInfoBytes);
        return this._authInfo;
    }
    get chainId() {
        return this.signDoc.chainId;
    }
    get accountNumber() {
        return this.signDoc.accountNumber.toString();
    }
    toBytes() {
        return $bcGNv.SignDoc.encode(this.signDoc).finish();
    }
    toJSON() {
        return {
            txBody: Object.assign(Object.assign({}, $bcGNv.TxBody.toJSON(this.txBody)), {
                messages: this.txMsgs.map((msg)=>{
                    return this.protoCodec.unpackedAnyToJSONRecursive(msg);
                })
            }),
            authInfo: $bcGNv.AuthInfo.toJSON(this.authInfo),
            chainId: this.chainId,
            accountNumber: this.accountNumber
        };
    }
}
module.exports.ProtoSignDocDecoder = $ba6c8ce2d120e456$var$ProtoSignDocDecoder;

});
parcelRegister("bcGNv", function(module, exports) {
"use strict";
var $828203695cc7c91c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fee = module.exports.ModeInfo_Multi = module.exports.ModeInfo_Single = module.exports.ModeInfo = module.exports.SignerInfo = module.exports.AuthInfo = module.exports.TxBody = module.exports.SignDoc = module.exports.TxRaw = module.exports.Tx = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $828203695cc7c91c$var$long_1 = $828203695cc7c91c$var$__importDefault((parcelRequire("jRkuS")));

const $828203695cc7c91c$var$minimal_1 = $828203695cc7c91c$var$__importDefault((parcelRequire("fQBv0")));

var $7fzEU = parcelRequire("7fzEU");

var $5fiTY = parcelRequire("5fiTY");

var $inTEs = parcelRequire("inTEs");

var $9QyHq = parcelRequire("9QyHq");
module.exports.protobufPackage = "cosmos.tx.v1beta1";
function $828203695cc7c91c$var$createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: []
    };
}
module.exports.Tx = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.body !== undefined) module.exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) module.exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = module.exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = module.exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            body: $828203695cc7c91c$var$isSet(object.body) ? module.exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: $828203695cc7c91c$var$isSet(object.authInfo) ? module.exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>$828203695cc7c91c$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? module.exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? module.exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$828203695cc7c91c$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $828203695cc7c91c$var$createBaseTx();
        message.body = object.body !== undefined && object.body !== null ? module.exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? module.exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $828203695cc7c91c$var$createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
    };
}
module.exports.TxRaw = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseTxRaw();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: $828203695cc7c91c$var$isSet(object.bodyBytes) ? $828203695cc7c91c$var$bytesFromBase64(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: $828203695cc7c91c$var$isSet(object.authInfoBytes) ? $828203695cc7c91c$var$bytesFromBase64(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>$828203695cc7c91c$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $828203695cc7c91c$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $828203695cc7c91c$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$828203695cc7c91c$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $828203695cc7c91c$var$createBaseTxRaw();
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.signatures = ((_c = object.signatures) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
function $828203695cc7c91c$var$createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: "0"
    };
}
module.exports.SignDoc = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (message.accountNumber !== "0") writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseSignDoc();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = $828203695cc7c91c$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: $828203695cc7c91c$var$isSet(object.bodyBytes) ? $828203695cc7c91c$var$bytesFromBase64(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: $828203695cc7c91c$var$isSet(object.authInfoBytes) ? $828203695cc7c91c$var$bytesFromBase64(object.authInfoBytes) : new Uint8Array(),
            chainId: $828203695cc7c91c$var$isSet(object.chainId) ? String(object.chainId) : "",
            accountNumber: $828203695cc7c91c$var$isSet(object.accountNumber) ? String(object.accountNumber) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $828203695cc7c91c$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $828203695cc7c91c$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = message.accountNumber);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $828203695cc7c91c$var$createBaseSignDoc();
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.chainId = (_c = object.chainId) !== null && _c !== void 0 ? _c : "";
        message.accountNumber = (_d = object.accountNumber) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $828203695cc7c91c$var$createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: "0",
        extensionOptions: [],
        nonCriticalExtensionOptions: []
    };
}
module.exports.TxBody = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)$5fiTY.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (message.timeoutHeight !== "0") writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$5fiTY.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$5fiTY.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseTxBody();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($5fiTY.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = $828203695cc7c91c$var$longToString(reader.uint64());
                    break;
                case 1023:
                    message.extensionOptions.push($5fiTY.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($5fiTY.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map((e)=>$5fiTY.Any.fromJSON(e)) : [],
            memo: $828203695cc7c91c$var$isSet(object.memo) ? String(object.memo) : "",
            timeoutHeight: $828203695cc7c91c$var$isSet(object.timeoutHeight) ? String(object.timeoutHeight) : "0",
            extensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.extensionOptions) ? object.extensionOptions.map((e)=>$5fiTY.Any.fromJSON(e)) : [],
            nonCriticalExtensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.nonCriticalExtensionOptions) ? object.nonCriticalExtensionOptions.map((e)=>$5fiTY.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $5fiTY.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight);
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $5fiTY.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $5fiTY.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $828203695cc7c91c$var$createBaseTxBody();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e)=>$5fiTY.Any.fromPartial(e))) || [];
        message.memo = (_b = object.memo) !== null && _b !== void 0 ? _b : "";
        message.timeoutHeight = (_c = object.timeoutHeight) !== null && _c !== void 0 ? _c : "0";
        message.extensionOptions = ((_d = object.extensionOptions) === null || _d === void 0 ? void 0 : _d.map((e)=>$5fiTY.Any.fromPartial(e))) || [];
        message.nonCriticalExtensionOptions = ((_e = object.nonCriticalExtensionOptions) === null || _e === void 0 ? void 0 : _e.map((e)=>$5fiTY.Any.fromPartial(e))) || [];
        return message;
    }
};
function $828203695cc7c91c$var$createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined
    };
}
module.exports.AuthInfo = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        for (const v of message.signerInfos)module.exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) module.exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseAuthInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push(module.exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = module.exports.Fee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signerInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.signerInfos) ? object.signerInfos.map((e)=>module.exports.SignerInfo.fromJSON(e)) : [],
            fee: $828203695cc7c91c$var$isSet(object.fee) ? module.exports.Fee.fromJSON(object.fee) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? module.exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? module.exports.Fee.toJSON(message.fee) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $828203695cc7c91c$var$createBaseAuthInfo();
        message.signerInfos = ((_a = object.signerInfos) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SignerInfo.fromPartial(e))) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? module.exports.Fee.fromPartial(object.fee) : undefined;
        return message;
    }
};
function $828203695cc7c91c$var$createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: "0"
    };
}
module.exports.SignerInfo = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $5fiTY.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) module.exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (message.sequence !== "0") writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseSignerInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = module.exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = $828203695cc7c91c$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: $828203695cc7c91c$var$isSet(object.publicKey) ? $5fiTY.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: $828203695cc7c91c$var$isSet(object.modeInfo) ? module.exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: $828203695cc7c91c$var$isSet(object.sequence) ? String(object.sequence) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $5fiTY.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? module.exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $828203695cc7c91c$var$createBaseSignerInfo();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $5fiTY.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? module.exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = (_a = object.sequence) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $828203695cc7c91c$var$createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined
    };
}
module.exports.ModeInfo = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseModeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: $828203695cc7c91c$var$isSet(object.single) ? module.exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: $828203695cc7c91c$var$isSet(object.multi) ? module.exports.ModeInfo_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $828203695cc7c91c$var$createBaseModeInfo();
        message.single = object.single !== undefined && object.single !== null ? module.exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? module.exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $828203695cc7c91c$var$createBaseModeInfo_Single() {
    return {
        mode: 0
    };
}
module.exports.ModeInfo_Single = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseModeInfo_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: $828203695cc7c91c$var$isSet(object.mode) ? (0, $7fzEU.signModeFromJSON)(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, $7fzEU.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $828203695cc7c91c$var$createBaseModeInfo_Single();
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $828203695cc7c91c$var$createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: []
    };
}
module.exports.ModeInfo_Multi = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $inTEs.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)module.exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseModeInfo_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $inTEs.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(module.exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: $828203695cc7c91c$var$isSet(object.bitarray) ? $inTEs.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.modeInfos) ? object.modeInfos.map((e)=>module.exports.ModeInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $inTEs.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? module.exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $828203695cc7c91c$var$createBaseModeInfo_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $inTEs.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = ((_a = object.modeInfos) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.ModeInfo.fromPartial(e))) || [];
        return message;
    }
};
function $828203695cc7c91c$var$createBaseFee() {
    return {
        amount: [],
        gasLimit: "0",
        payer: "",
        granter: ""
    };
}
module.exports.Fee = {
    encode (message, writer = $828203695cc7c91c$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$9QyHq.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.gasLimit !== "0") writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $828203695cc7c91c$var$minimal_1.default.Reader ? input : new $828203695cc7c91c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $828203695cc7c91c$var$createBaseFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($9QyHq.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = $828203695cc7c91c$var$longToString(reader.uint64());
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$9QyHq.Coin.fromJSON(e)) : [],
            gasLimit: $828203695cc7c91c$var$isSet(object.gasLimit) ? String(object.gasLimit) : "0",
            payer: $828203695cc7c91c$var$isSet(object.payer) ? String(object.payer) : "",
            granter: $828203695cc7c91c$var$isSet(object.granter) ? String(object.granter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $9QyHq.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = message.gasLimit);
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $828203695cc7c91c$var$createBaseFee();
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$9QyHq.Coin.fromPartial(e))) || [];
        message.gasLimit = (_b = object.gasLimit) !== null && _b !== void 0 ? _b : "0";
        message.payer = (_c = object.payer) !== null && _c !== void 0 ? _c : "";
        message.granter = (_d = object.granter) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
var $828203695cc7c91c$var$globalThis = (()=>{
    if (typeof $828203695cc7c91c$var$globalThis !== "undefined") return $828203695cc7c91c$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $828203695cc7c91c$var$atob = $828203695cc7c91c$var$globalThis.atob || ((b64)=>$828203695cc7c91c$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $828203695cc7c91c$var$bytesFromBase64(b64) {
    const bin = $828203695cc7c91c$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $828203695cc7c91c$var$btoa = $828203695cc7c91c$var$globalThis.btoa || ((bin)=>$828203695cc7c91c$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $828203695cc7c91c$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $828203695cc7c91c$var$btoa(bin.join(""));
}
function $828203695cc7c91c$var$longToString(long) {
    return long.toString();
}
if ($828203695cc7c91c$var$minimal_1.default.util.Long !== $828203695cc7c91c$var$long_1.default) {
    $828203695cc7c91c$var$minimal_1.default.util.Long = $828203695cc7c91c$var$long_1.default;
    $828203695cc7c91c$var$minimal_1.default.configure();
}
function $828203695cc7c91c$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("7fzEU", function(module, exports) {
"use strict";
var $5475983d3e7c8c18$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureDescriptor_Data_Multi = module.exports.SignatureDescriptor_Data_Single = module.exports.SignatureDescriptor_Data = module.exports.SignatureDescriptor = module.exports.SignatureDescriptors = module.exports.signModeToJSON = module.exports.signModeFromJSON = module.exports.SignMode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $5475983d3e7c8c18$var$long_1 = $5475983d3e7c8c18$var$__importDefault((parcelRequire("jRkuS")));

const $5475983d3e7c8c18$var$minimal_1 = $5475983d3e7c8c18$var$__importDefault((parcelRequire("fQBv0")));

var $5fiTY = parcelRequire("5fiTY");

var $inTEs = parcelRequire("inTEs");
module.exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/** SignMode represents a signing mode with its own security guarantees. */ var $5475983d3e7c8c18$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($5475983d3e7c8c18$var$SignMode = module.exports.SignMode || (module.exports.SignMode = {}));
function $5475983d3e7c8c18$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $5475983d3e7c8c18$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $5475983d3e7c8c18$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $5475983d3e7c8c18$var$SignMode.SIGN_MODE_TEXTUAL;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $5475983d3e7c8c18$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $5475983d3e7c8c18$var$SignMode.UNRECOGNIZED;
    }
}
module.exports.signModeFromJSON = $5475983d3e7c8c18$var$signModeFromJSON;
function $5475983d3e7c8c18$var$signModeToJSON(object) {
    switch(object){
        case $5475983d3e7c8c18$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $5475983d3e7c8c18$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $5475983d3e7c8c18$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $5475983d3e7c8c18$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        default:
            return "UNKNOWN";
    }
}
module.exports.signModeToJSON = $5475983d3e7c8c18$var$signModeToJSON;
function $5475983d3e7c8c18$var$createBaseSignatureDescriptors() {
    return {
        signatures: []
    };
}
module.exports.SignatureDescriptors = {
    encode (message, writer = $5475983d3e7c8c18$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)module.exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5475983d3e7c8c18$var$minimal_1.default.Reader ? input : new $5475983d3e7c8c18$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptors();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(module.exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>module.exports.SignatureDescriptor.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptors();
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SignatureDescriptor.fromPartial(e))) || [];
        return message;
    }
};
function $5475983d3e7c8c18$var$createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: "0"
    };
}
module.exports.SignatureDescriptor = {
    encode (message, writer = $5475983d3e7c8c18$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $5fiTY.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) module.exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.sequence !== "0") writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5475983d3e7c8c18$var$minimal_1.default.Reader ? input : new $5475983d3e7c8c18$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $5fiTY.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = $5475983d3e7c8c18$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: $5475983d3e7c8c18$var$isSet(object.publicKey) ? $5fiTY.Any.fromJSON(object.publicKey) : undefined,
            data: $5475983d3e7c8c18$var$isSet(object.data) ? module.exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: $5475983d3e7c8c18$var$isSet(object.sequence) ? String(object.sequence) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $5fiTY.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? module.exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $5fiTY.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? module.exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = (_a = object.sequence) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined
    };
}
module.exports.SignatureDescriptor_Data = {
    encode (message, writer = $5475983d3e7c8c18$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5475983d3e7c8c18$var$minimal_1.default.Reader ? input : new $5475983d3e7c8c18$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: $5475983d3e7c8c18$var$isSet(object.single) ? module.exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: $5475983d3e7c8c18$var$isSet(object.multi) ? module.exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data();
        message.single = object.single !== undefined && object.single !== null ? module.exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? module.exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array()
    };
}
module.exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $5475983d3e7c8c18$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5475983d3e7c8c18$var$minimal_1.default.Reader ? input : new $5475983d3e7c8c18$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: $5475983d3e7c8c18$var$isSet(object.mode) ? $5475983d3e7c8c18$var$signModeFromJSON(object.mode) : 0,
            signature: $5475983d3e7c8c18$var$isSet(object.signature) ? $5475983d3e7c8c18$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $5475983d3e7c8c18$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = $5475983d3e7c8c18$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data_Single();
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        message.signature = (_b = object.signature) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: []
    };
}
module.exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $5475983d3e7c8c18$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $inTEs.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)module.exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5475983d3e7c8c18$var$minimal_1.default.Reader ? input : new $5475983d3e7c8c18$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $inTEs.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: $5475983d3e7c8c18$var$isSet(object.bitarray) ? $inTEs.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>module.exports.SignatureDescriptor_Data.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $inTEs.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5475983d3e7c8c18$var$createBaseSignatureDescriptor_Data_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $inTEs.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SignatureDescriptor_Data.fromPartial(e))) || [];
        return message;
    }
};
var $5475983d3e7c8c18$var$globalThis = (()=>{
    if (typeof $5475983d3e7c8c18$var$globalThis !== "undefined") return $5475983d3e7c8c18$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $5475983d3e7c8c18$var$atob = $5475983d3e7c8c18$var$globalThis.atob || ((b64)=>$5475983d3e7c8c18$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $5475983d3e7c8c18$var$bytesFromBase64(b64) {
    const bin = $5475983d3e7c8c18$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $5475983d3e7c8c18$var$btoa = $5475983d3e7c8c18$var$globalThis.btoa || ((bin)=>$5475983d3e7c8c18$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $5475983d3e7c8c18$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $5475983d3e7c8c18$var$btoa(bin.join(""));
}
function $5475983d3e7c8c18$var$longToString(long) {
    return long.toString();
}
if ($5475983d3e7c8c18$var$minimal_1.default.util.Long !== $5475983d3e7c8c18$var$long_1.default) {
    $5475983d3e7c8c18$var$minimal_1.default.util.Long = $5475983d3e7c8c18$var$long_1.default;
    $5475983d3e7c8c18$var$minimal_1.default.configure();
}
function $5475983d3e7c8c18$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("inTEs", function(module, exports) {
"use strict";
var $d6258b39aa985c25$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompactBitArray = module.exports.MultiSignature = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $d6258b39aa985c25$var$long_1 = $d6258b39aa985c25$var$__importDefault((parcelRequire("jRkuS")));

const $d6258b39aa985c25$var$minimal_1 = $d6258b39aa985c25$var$__importDefault((parcelRequire("fQBv0")));
module.exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function $d6258b39aa985c25$var$createBaseMultiSignature() {
    return {
        signatures: []
    };
}
module.exports.MultiSignature = {
    encode (message, writer = $d6258b39aa985c25$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6258b39aa985c25$var$minimal_1.default.Reader ? input : new $d6258b39aa985c25$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6258b39aa985c25$var$createBaseMultiSignature();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>$d6258b39aa985c25$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$d6258b39aa985c25$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $d6258b39aa985c25$var$createBaseMultiSignature();
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $d6258b39aa985c25$var$createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array()
    };
}
module.exports.CompactBitArray = {
    encode (message, writer = $d6258b39aa985c25$var$minimal_1.default.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6258b39aa985c25$var$minimal_1.default.Reader ? input : new $d6258b39aa985c25$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6258b39aa985c25$var$createBaseCompactBitArray();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            extraBitsStored: $d6258b39aa985c25$var$isSet(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: $d6258b39aa985c25$var$isSet(object.elems) ? $d6258b39aa985c25$var$bytesFromBase64(object.elems) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined && (obj.elems = $d6258b39aa985c25$var$base64FromBytes(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $d6258b39aa985c25$var$createBaseCompactBitArray();
        message.extraBitsStored = (_a = object.extraBitsStored) !== null && _a !== void 0 ? _a : 0;
        message.elems = (_b = object.elems) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $d6258b39aa985c25$var$globalThis = (()=>{
    if (typeof $d6258b39aa985c25$var$globalThis !== "undefined") return $d6258b39aa985c25$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d6258b39aa985c25$var$atob = $d6258b39aa985c25$var$globalThis.atob || ((b64)=>$d6258b39aa985c25$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d6258b39aa985c25$var$bytesFromBase64(b64) {
    const bin = $d6258b39aa985c25$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $d6258b39aa985c25$var$btoa = $d6258b39aa985c25$var$globalThis.btoa || ((bin)=>$d6258b39aa985c25$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d6258b39aa985c25$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $d6258b39aa985c25$var$btoa(bin.join(""));
}
if ($d6258b39aa985c25$var$minimal_1.default.util.Long !== $d6258b39aa985c25$var$long_1.default) {
    $d6258b39aa985c25$var$minimal_1.default.util.Long = $d6258b39aa985c25$var$long_1.default;
    $d6258b39aa985c25$var$minimal_1.default.configure();
}
function $d6258b39aa985c25$var$isSet(value) {
    return value !== null && value !== undefined;
}

});




parcelRegister("5AbUo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignDocWrapper = void 0;

var $g0kvf = parcelRequire("g0kvf");

var $bcGNv = parcelRequire("bcGNv");

var $SezG1 = parcelRequire("SezG1");
class $41098d5be6ed112f$var$SignDocWrapper {
    constructor(signDoc){
        this.signDoc = signDoc;
        if ("msgs" in signDoc) this.mode = "amino";
        else this.mode = "direct";
        if (this.mode === "amino") // Check that the sign doc is for ADR-36.
        // The validation should be performed on the background process.
        // So, here, we check once more, but the validation related to bech32 is considered to be done in the background process.
        this.isADR36SignDoc = (0, $SezG1.checkAndValidateADR36AminoSignDoc)(this.aminoSignDoc);
        else // Currently, only support amino sign doc for ADR-36
        this.isADR36SignDoc = false;
    }
    static fromAminoSignDoc(signDoc) {
        return new $41098d5be6ed112f$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDoc(signDoc) {
        return new $41098d5be6ed112f$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDocBytes(signDocBytes) {
        return new $41098d5be6ed112f$var$SignDocWrapper($bcGNv.SignDoc.decode(signDocBytes));
    }
    clone() {
        return new $41098d5be6ed112f$var$SignDocWrapper(this.signDoc);
    }
    get protoSignDoc() {
        if (this.mode === "amino") throw new Error("Sign doc is encoded as Amino Json");
        if ("msgs" in this.signDoc) throw new Error("Unexpected error");
        if (!this._protoSignDoc) this._protoSignDoc = new $g0kvf.ProtoSignDocDecoder(this.signDoc);
        return this._protoSignDoc;
    }
    get aminoSignDoc() {
        if (this.mode === "direct") throw new Error("Sign doc is encoded as Protobuf");
        if (!("msgs" in this.signDoc)) throw new Error("Unexpected error");
        return this.signDoc;
    }
    get chainId() {
        if (this.mode === "direct") return this.protoSignDoc.chainId;
        return this.aminoSignDoc.chain_id;
    }
    get memo() {
        if (this.mode === "direct") return this.protoSignDoc.txBody.memo;
        return this.aminoSignDoc.memo;
    }
    get fees() {
        var _a, _b;
        if (this.mode === "direct") {
            const fees = [];
            for (const coinObj of (_b = (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : []){
                if (coinObj.denom == null || coinObj.amount == null) throw new Error("Invalid fee");
                fees.push({
                    denom: coinObj.denom,
                    amount: coinObj.amount
                });
            }
            return fees;
        }
        return this.aminoSignDoc.fee.amount;
    }
    get payer() {
        var _a;
        if (this.mode === "direct") return (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.payer;
        return this.aminoSignDoc.fee.payer;
    }
    get granter() {
        var _a;
        if (this.mode === "direct") return (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.granter;
        return this.aminoSignDoc.fee.granter;
    }
    get gas() {
        var _a;
        if (this.mode === "direct") {
            if ((_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.gasLimit) return parseInt(this.protoSignDoc.authInfo.fee.gasLimit);
            else return 0;
        }
        return parseInt(this.aminoSignDoc.fee.gas);
    }
}
module.exports.SignDocWrapper = $41098d5be6ed112f$var$SignDocWrapper;

});
parcelRegister("SezG1", function(module, exports) {
"use strict";
var $0a30597052387768$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a30597052387768$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a30597052387768$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a30597052387768$var$__exportStar((parcelRequire("6yIMA")), module.exports);

});
parcelRegister("6yIMA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifyADR36Amino = module.exports.verifyADR36AminoSignDoc = module.exports.makeADR36AminoSignDoc = module.exports.checkAndValidateADR36AminoSignDoc = void 0;

var $hXbrg = parcelRequire("hXbrg");

var $lWBwx = parcelRequire("lWBwx");

var $ihoyg = parcelRequire("ihoyg");

var $hkK8Z = parcelRequire("hkK8Z");
/**
 * Check the sign doc is for ADR-36.
 * If the sign doc is expected to be ADR-36, validate the sign doc and throw an error if the sign doc is valid ADR-36.
 * @param signDoc
 * @param bech32PrefixAccAddr If this argument is provided, validate the signer in the `MsgSignData` with this prefix.
 *                            If not, validate the signer in the `MsgSignData` without considering the bech32 prefix.
 */ function $4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr) {
    const hasOnlyMsgSignData = (()=>{
        if (signDoc && signDoc.msgs && Array.isArray(signDoc.msgs) && signDoc.msgs.length === 1) {
            const msg = signDoc.msgs[0];
            return msg.type === "sign/MsgSignData";
        } else return false;
    })();
    if (!hasOnlyMsgSignData) return false;
    if (signDoc.chain_id !== "") throw new Error("Chain id should be empty string for ADR-36 signing");
    if (signDoc.memo !== "") throw new Error("Memo should be empty string for ADR-36 signing");
    if (signDoc.account_number !== "0") throw new Error('Account number should be "0" for ADR-36 signing');
    if (signDoc.sequence !== "0") throw new Error('Sequence should be "0" for ADR-36 signing');
    if (signDoc.fee.gas !== "0") throw new Error('Gas should be "0" for ADR-36 signing');
    if (signDoc.fee.amount.length !== 0) throw new Error("Fee amount should be empty array for ADR-36 signing");
    const msg = signDoc.msgs[0];
    if (msg.type !== "sign/MsgSignData") throw new Error(`Invalid type of ADR-36 sign msg: ${msg.type}`);
    if (!msg.value) throw new Error("Empty value in the msg");
    const signer = msg.value.signer;
    if (!signer) throw new Error("Empty signer in the ADR-36 msg");
    $lWBwx.Bech32Address.validate(signer, bech32PrefixAccAddr);
    const data = msg.value.data;
    if (!data) throw new Error("Empty data in the ADR-36 msg");
    const rawData = $ihoyg.Buffer.from(data, "base64");
    // Validate the data is encoded as base64.
    if (rawData.toString("base64") !== data) throw new Error("Data is not encoded by base64");
    if (rawData.length === 0) throw new Error("Empty data in the ADR-36 msg");
    return true;
}
module.exports.checkAndValidateADR36AminoSignDoc = $4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc;
function $4c68a7f214782361$var$makeADR36AminoSignDoc(signer, data) {
    if (typeof data === "string") data = $ihoyg.Buffer.from(data).toString("base64");
    else data = $ihoyg.Buffer.from(data).toString("base64");
    return {
        chain_id: "",
        account_number: "0",
        sequence: "0",
        fee: {
            gas: "0",
            amount: []
        },
        msgs: [
            {
                type: "sign/MsgSignData",
                value: {
                    signer: signer,
                    data: data
                }
            }
        ],
        memo: ""
    };
}
module.exports.makeADR36AminoSignDoc = $4c68a7f214782361$var$makeADR36AminoSignDoc;
function $4c68a7f214782361$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature, algo = "secp256k1") {
    if (!$4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr)) throw new Error("Invalid sign doc for ADR-36");
    const cryptoPubKey = new $hkK8Z.PubKeySecp256k1(pubKey);
    const expectedSigner = (()=>{
        if (algo === "ethsecp256k1") return new $lWBwx.Bech32Address(cryptoPubKey.getEthAddress()).toBech32(bech32PrefixAccAddr);
        return new $lWBwx.Bech32Address(cryptoPubKey.getCosmosAddress()).toBech32(bech32PrefixAccAddr);
    })();
    const signer = signDoc.msgs[0].value.signer;
    if (expectedSigner !== signer) throw new Error("Unmatched signer");
    const msg = (0, $hXbrg.serializeSignDoc)(signDoc);
    return cryptoPubKey.verifyDigest32((()=>{
        if (algo === "ethsecp256k1") return $hkK8Z.Hash.keccak256(msg);
        return $hkK8Z.Hash.sha256(msg);
    })(), signature);
}
module.exports.verifyADR36AminoSignDoc = $4c68a7f214782361$var$verifyADR36AminoSignDoc;
function $4c68a7f214782361$var$verifyADR36Amino(bech32PrefixAccAddr, signer, data, pubKey, signature, algo = "secp256k1") {
    const signDoc = $4c68a7f214782361$var$makeADR36AminoSignDoc(signer, data);
    return $4c68a7f214782361$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature, algo);
}
module.exports.verifyADR36Amino = $4c68a7f214782361$var$verifyADR36Amino;

});
parcelRegister("hXbrg", function(module, exports) {
"use strict";
var $d120d1d8ce061621$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d120d1d8ce061621$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d120d1d8ce061621$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d120d1d8ce061621$var$__exportStar((parcelRequire("5Ak0e")), module.exports);

});
parcelRegister("5Ak0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeSignDoc = module.exports.encodeSecp256k1Signature = module.exports.encodeSecp256k1Pubkey = void 0;

var $ihoyg = parcelRequire("ihoyg");

var $9A6I0 = parcelRequire("9A6I0");
function $410fd4acfbc7be0c$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: "tendermint/PubKeySecp256k1",
        value: $ihoyg.Buffer.from(pubkey).toString("base64")
    };
}
module.exports.encodeSecp256k1Pubkey = $410fd4acfbc7be0c$var$encodeSecp256k1Pubkey;
function $410fd4acfbc7be0c$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: $410fd4acfbc7be0c$var$encodeSecp256k1Pubkey(pubkey),
        signature: $ihoyg.Buffer.from(signature).toString("base64")
    };
}
module.exports.encodeSecp256k1Signature = $410fd4acfbc7be0c$var$encodeSecp256k1Signature;
function $410fd4acfbc7be0c$var$serializeSignDoc(signDoc) {
    return $ihoyg.Buffer.from((0, $9A6I0.escapeHTML)((0, $9A6I0.sortedJsonByKeyStringify)(signDoc)));
}
module.exports.serializeSignDoc = $410fd4acfbc7be0c$var$serializeSignDoc;

});
parcelRegister("9A6I0", function(module, exports) {
"use strict";
var $6f9cae0f1a771aca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6f9cae0f1a771aca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6f9cae0f1a771aca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("6runR")), module.exports);

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("bLU7l")), module.exports);

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("66Dak")), module.exports);

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("kD8tN")), module.exports);

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("Ao8HI")), module.exports);

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("lPnds")), module.exports);

$6f9cae0f1a771aca$var$__exportStar((parcelRequire("56GCf")), module.exports);

});
parcelRegister("6runR", function(module, exports) {
"use strict";
var $4b0cd546e38ec403$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4b0cd546e38ec403$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4b0cd546e38ec403$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4b0cd546e38ec403$var$__exportStar((parcelRequire("653rh")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("kRwuz")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("b3Xt5")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("kfte6")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("gvAUq")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("hkG1R")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("eeQQb")), module.exports);

$4b0cd546e38ec403$var$__exportStar((parcelRequire("dq80M")), module.exports);

});
parcelRegister("653rh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kRwuz", function(module, exports) {
"use strict";
var $f301f62817df0245$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtensionKVStore = void 0;

var $b3Xt5 = parcelRequire("b3Xt5");
class $f301f62817df0245$var$ExtensionKVStore extends $b3Xt5.BaseKVStore {
    constructor(prefix){
        if (!$f301f62817df0245$var$ExtensionKVStore.KVStoreProvider) {
            if (typeof browser === "undefined") console.log("You should use ExtensionKVStore on the extension environment.");
            else if (!browser.storage || !browser.storage.local) console.log("The 'browser' exists, but it doesn't seem to be an extension environment. This can happen in Safari browser.");
            else $f301f62817df0245$var$ExtensionKVStore.KVStoreProvider = {
                get: browser.storage.local.get,
                set: browser.storage.local.set,
                multiGet: browser.storage.local.get
            };
        }
        if (!$f301f62817df0245$var$ExtensionKVStore.KVStoreProvider) throw new Error("Can't initialize kv store for browser extension");
        super($f301f62817df0245$var$ExtensionKVStore.KVStoreProvider, prefix);
    }
    multiGet(keys) {
        var _a;
        return $f301f62817df0245$var$__awaiter(this, void 0, void 0, function*() {
            // Remove duplications
            keys = Array.from(new Set(keys));
            const res = (_a = yield $f301f62817df0245$var$ExtensionKVStore.KVStoreProvider.multiGet(keys.map((k)=>this.prefix() + "/" + k))) !== null && _a !== void 0 ? _a : {};
            const prefixedKeys = Object.keys(res);
            for (const prefixedKey of prefixedKeys){
                const key = prefixedKey.slice(this.prefix().length + 1);
                res[key] = res[prefixedKey];
                delete res[prefixedKey];
            }
            return res;
        });
    }
}
module.exports.ExtensionKVStore = $f301f62817df0245$var$ExtensionKVStore;

});
parcelRegister("b3Xt5", function(module, exports) {
"use strict";
var $80de1aa1a042ad8a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseKVStore = void 0;
class $80de1aa1a042ad8a$var$BaseKVStore {
    constructor(provider, _prefix){
        this.provider = provider;
        this._prefix = _prefix;
    }
    get(key) {
        return $80de1aa1a042ad8a$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            const data = yield this.provider.get();
            return data[k];
        });
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        return this.provider.set({
            [k]: data
        });
    }
    prefix() {
        return this._prefix;
    }
}
module.exports.BaseKVStore = $80de1aa1a042ad8a$var$BaseKVStore;

});


parcelRegister("kfte6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MemoryKVStore = void 0;

var $b3Xt5 = parcelRequire("b3Xt5");
class $ebdbe11d01becf08$var$MemoryKVStoreProvider {
    constructor(){
        this.store = {};
    }
    get() {
        return Promise.resolve(this.store);
    }
    set(items) {
        this.store = Object.assign(Object.assign({}, this.store), items);
        return Promise.resolve();
    }
    checkNotPrimitiveField(items) {
        Object.keys(items).forEach((key)=>{
            const value = items[key];
            if (value != null && typeof value === "object") {
                if (value.constructor !== Object && value.constructor !== Array) throw new Error(`${key} may not be serializable: ${value.constructor.name}`);
                this.checkNotPrimitiveField(value);
            }
        });
    }
}
class $ebdbe11d01becf08$var$MemoryKVStore extends $b3Xt5.BaseKVStore {
    constructor(prefix){
        super(new $ebdbe11d01becf08$var$MemoryKVStoreProvider(), prefix);
    }
}
module.exports.MemoryKVStore = $ebdbe11d01becf08$var$MemoryKVStore;

});

parcelRegister("gvAUq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalKVStore = void 0;
class $c04c2bf641f6e8f0$var$LocalKVStore {
    constructor(_prefix){
        this._prefix = _prefix;
    }
    get(key) {
        const k = this.prefix() + "/" + key;
        const data = localStorage.getItem(k);
        if (data === null) return Promise.resolve(undefined);
        return Promise.resolve(JSON.parse(data));
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        if (data === null) return Promise.resolve(localStorage.removeItem(k));
        return Promise.resolve(localStorage.setItem(k, JSON.stringify(data)));
    }
    prefix() {
        return this._prefix;
    }
}
module.exports.LocalKVStore = $c04c2bf641f6e8f0$var$LocalKVStore;

});

parcelRegister("hkG1R", function(module, exports) {
"use strict";
var $c9e4e80119b9d42b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IndexedDBKVStore = void 0;
class $c9e4e80119b9d42b$var$IndexedDBKVStore {
    constructor(_prefix){
        this._prefix = _prefix;
    }
    get(key) {
        return $c9e4e80119b9d42b$var$__awaiter(this, void 0, void 0, function*() {
            const tx = (yield this.getDB()).transaction([
                this.prefix()
            ], "readonly");
            const store = tx.objectStore(this.prefix());
            return new Promise((resolve, reject)=>{
                const request = store.get(key);
                request.onerror = (event)=>{
                    event.stopPropagation();
                    reject(event.target);
                };
                request.onsuccess = ()=>{
                    if (!request.result) resolve(undefined);
                    else resolve(request.result.data);
                };
            });
        });
    }
    set(key, data) {
        return $c9e4e80119b9d42b$var$__awaiter(this, void 0, void 0, function*() {
            if (data === null) {
                const tx = (yield this.getDB()).transaction([
                    this.prefix()
                ], "readwrite");
                const store = tx.objectStore(this.prefix());
                return new Promise((resolve, reject)=>{
                    const request = store.delete(key);
                    request.onerror = (event)=>{
                        event.stopPropagation();
                        reject(event.target);
                    };
                    request.onsuccess = ()=>{
                        resolve();
                    };
                });
            } else {
                const tx = (yield this.getDB()).transaction([
                    this.prefix()
                ], "readwrite");
                const store = tx.objectStore(this.prefix());
                return new Promise((resolve, reject)=>{
                    const request = store.put({
                        key: key,
                        data: data
                    });
                    request.onerror = (event)=>{
                        event.stopPropagation();
                        reject(event.target);
                    };
                    request.onsuccess = ()=>{
                        resolve();
                    };
                });
            }
        });
    }
    prefix() {
        return this._prefix;
    }
    getDB() {
        return $c9e4e80119b9d42b$var$__awaiter(this, void 0, void 0, function*() {
            if (this.cachedDB) return this.cachedDB;
            return new Promise((resolve, reject)=>{
                const request = window.indexedDB.open(this.prefix());
                request.onerror = (event)=>{
                    event.stopPropagation();
                    reject(event.target);
                };
                request.onupgradeneeded = (event)=>{
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const db = event.target.result;
                    db.createObjectStore(this.prefix(), {
                        keyPath: "key"
                    });
                };
                request.onsuccess = ()=>{
                    this.cachedDB = request.result;
                    resolve(request.result);
                };
            });
        });
    }
}
module.exports.IndexedDBKVStore = $c9e4e80119b9d42b$var$IndexedDBKVStore;

});

parcelRegister("eeQQb", function(module, exports) {
"use strict";
var $a5db5c909d1d7387$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrefixKVStore = void 0;
class $a5db5c909d1d7387$var$PrefixKVStore {
    constructor(kvStore, _prefix){
        this.kvStore = kvStore;
        this._prefix = _prefix;
    }
    prefix() {
        return this._prefix;
    }
    get(key) {
        return $a5db5c909d1d7387$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            return yield this.kvStore.get(k);
        });
    }
    set(key, data) {
        return $a5db5c909d1d7387$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            return yield this.kvStore.set(k, data);
        });
    }
}
module.exports.PrefixKVStore = $a5db5c909d1d7387$var$PrefixKVStore;

});

parcelRegister("dq80M", function(module, exports) {
"use strict";
var $9c53eb001e3ba437$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WrapMultiGetKVStore = void 0;
class $9c53eb001e3ba437$var$WrapMultiGetKVStore {
    constructor(kvStore){
        this.kvStore = kvStore;
    }
    multiGet(keys) {
        return $9c53eb001e3ba437$var$__awaiter(this, void 0, void 0, function*() {
            // Remove duplications
            keys = Array.from(new Set(keys));
            const res = {};
            const promises = [];
            for (const key of keys)promises.push((()=>$9c53eb001e3ba437$var$__awaiter(this, void 0, void 0, function*() {
                    res[key] = yield this.kvStore.get(key);
                }))());
            yield Promise.all(promises);
            return res;
        });
    }
}
module.exports.WrapMultiGetKVStore = $9c53eb001e3ba437$var$WrapMultiGetKVStore;

});


parcelRegister("bLU7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DenomHelper = void 0;

var $ihoyg = parcelRequire("ihoyg");

var $hkK8Z = parcelRequire("hkK8Z");
class $891f9d46680e60f3$var$DenomHelper {
    static ibcDenom(paths, coinMinimalDenom) {
        const prefixes = [];
        for (const path of paths)prefixes.push(`${path.portId}/${path.channelId}`);
        const prefix = prefixes.join("/");
        const denom = `${prefix}/${coinMinimalDenom}`;
        return "ibc/" + $ihoyg.Buffer.from($hkK8Z.Hash.sha256($ihoyg.Buffer.from(denom))).toString("hex").toUpperCase();
    }
    constructor(_denom){
        this._denom = _denom;
        // Remember that the coin's actual denom should start with "type:contractAddress:denom" if it is for the token based on contract.
        const split = this.denom.split(/(\w+):(\w+):(.+)/).filter(Boolean);
        if (split.length !== 1 && split.length !== 3) throw new Error(`Invalid denom: ${this.denom}`);
        this._type = split.length === 3 ? split[0] : "";
        this._contractAddress = split.length === 3 ? split[1] : "";
    }
    get denom() {
        return this._denom;
    }
    get type() {
        return this._type || "native";
    }
    get contractAddress() {
        return this._contractAddress;
    }
}
module.exports.DenomHelper = $891f9d46680e60f3$var$DenomHelper;

});
parcelRegister("hkK8Z", function(module, exports) {
"use strict";
var $c9e81926954056aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9e81926954056aa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c9e81926954056aa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c9e81926954056aa$var$__exportStar((parcelRequire("ewTme")), module.exports);

$c9e81926954056aa$var$__exportStar((parcelRequire("eMsup")), module.exports);

$c9e81926954056aa$var$__exportStar((parcelRequire("i1G9i")), module.exports);

});
parcelRegister("ewTme", function(module, exports) {
"use strict";
var $a93efeb1ff5efce6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;

var $5qnT8 = parcelRequire("5qnT8");

var $8AB7q = parcelRequire("8AB7q");

var $1Vf4C = parcelRequire("1Vf4C");

var $ihoyg = parcelRequire("ihoyg");
class $a93efeb1ff5efce6$var$Mnemonic {
    static generateWallet(rng, path = `m/44'/118'/0'/0/0`, password = "", strength = 256) {
        return $a93efeb1ff5efce6$var$__awaiter(this, void 0, void 0, function*() {
            const mnemonic = yield $a93efeb1ff5efce6$var$Mnemonic.generateSeed(rng, strength);
            const privKey = $a93efeb1ff5efce6$var$Mnemonic.generateWalletFromMnemonic(mnemonic, path, password);
            return {
                privKey: privKey,
                mnemonic: mnemonic
            };
        });
    }
    static validateMnemonic(mnemonic) {
        return $5qnT8.validateMnemonic(mnemonic);
    }
    static generateSeed(rng, strength = 128) {
        return $a93efeb1ff5efce6$var$__awaiter(this, void 0, void 0, function*() {
            if (strength % 32 !== 0) throw new TypeError("invalid entropy");
            let bytes = new Uint8Array(strength / 8);
            bytes = yield rng(bytes);
            return $5qnT8.entropyToMnemonic($ihoyg.Buffer.from(bytes).toString("hex"));
        });
    }
    static generateWalletFromMnemonic(mnemonic, path = `m/44'/118'/0'/0/0`, password = "") {
        const seed = $5qnT8.mnemonicToSeedSync(mnemonic, password);
        const masterSeed = $8AB7q.fromSeed(seed);
        const hd = masterSeed.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
    static generateMasterSeedFromMnemonic(mnemonic, password = "") {
        const seed = $5qnT8.mnemonicToSeedSync(mnemonic, password);
        const masterKey = $8AB7q.fromSeed(seed);
        return $ihoyg.Buffer.from($1Vf4C.decode(masterKey.toBase58()));
    }
    static generatePrivateKeyFromMasterSeed(seed, path = `m/44'/118'/0'/0/0`) {
        const masterSeed = $8AB7q.fromBase58($1Vf4C.encode(seed));
        const hd = masterSeed.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
}
module.exports.Mnemonic = $a93efeb1ff5efce6$var$Mnemonic;

});
parcelRegister("5qnT8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $3f31e9298802700a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

var $bQlVj = parcelRequire("bQlVj");

var $ebEok = parcelRequire("ebEok");

var $guT51 = parcelRequire("guT51");
let $3f31e9298802700a$var$DEFAULT_WORDLIST = $guT51._default;
const $3f31e9298802700a$var$INVALID_MNEMONIC = 'Invalid mnemonic';
const $3f31e9298802700a$var$INVALID_ENTROPY = 'Invalid entropy';
const $3f31e9298802700a$var$INVALID_CHECKSUM = 'Invalid mnemonic checksum';
const $3f31e9298802700a$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $3f31e9298802700a$var$normalize(str) {
    return (str || '').normalize('NFKD');
}
function $3f31e9298802700a$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $3f31e9298802700a$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $3f31e9298802700a$var$bytesToBinary(bytes) {
    return bytes.map((x)=>$3f31e9298802700a$var$lpad(x.toString(2), '0', 8)).join('');
}
function $3f31e9298802700a$var$deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = $lrsL3.sha256(Uint8Array.from(entropyBuffer));
    return $3f31e9298802700a$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $3f31e9298802700a$var$salt(password) {
    return 'mnemonic' + (password || '');
}
function $3f31e9298802700a$var$mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), 'utf8'));
    const saltBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), 'utf8'));
    const res = $bQlVj.pbkdf2($fJ9Lg.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return $3f31e9298802700a$require$Buffer.from(res);
}
module.exports.mnemonicToSeedSync = $3f31e9298802700a$var$mnemonicToSeedSync;
function $3f31e9298802700a$var$mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), 'utf8'));
    const saltBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), 'utf8'));
    return $bQlVj.pbkdf2Async($fJ9Lg.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>$3f31e9298802700a$require$Buffer.from(res));
}
module.exports.mnemonicToSeed = $3f31e9298802700a$var$mnemonicToSeed;
function $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    const words = $3f31e9298802700a$var$normalize(mnemonic).split(' ');
    if (words.length % 3 !== 0) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
        return $3f31e9298802700a$var$lpad(index.toString(2), '0', 11);
    }).join('');
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($3f31e9298802700a$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropy = $3f31e9298802700a$require$Buffer.from(entropyBytes);
    const newChecksum = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($3f31e9298802700a$var$INVALID_CHECKSUM);
    return entropy.toString('hex');
}
module.exports.mnemonicToEntropy = $3f31e9298802700a$var$mnemonicToEntropy;
function $3f31e9298802700a$var$entropyToMnemonic(entropy, wordlist) {
    if (!$3f31e9298802700a$require$Buffer.isBuffer(entropy)) entropy = $3f31e9298802700a$require$Buffer.from(entropy, 'hex');
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropyBits = $3f31e9298802700a$var$bytesToBinary(Array.from(entropy));
    const checksumBits = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = $3f31e9298802700a$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === '\u3042\u3044\u3053\u304f\u3057\u3093' // Japanese wordlist
     ? words.join('\u3000') : words.join(' ');
}
module.exports.entropyToMnemonic = $3f31e9298802700a$var$entropyToMnemonic;
function $3f31e9298802700a$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    rng = rng || ((size)=>$3f31e9298802700a$require$Buffer.from($ebEok.randomBytes(size)));
    return $3f31e9298802700a$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
module.exports.generateMnemonic = $3f31e9298802700a$var$generateMnemonic;
function $3f31e9298802700a$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
module.exports.validateMnemonic = $3f31e9298802700a$var$validateMnemonic;
function $3f31e9298802700a$var$setDefaultWordlist(language) {
    const result = $guT51.wordlists[language];
    if (result) $3f31e9298802700a$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
module.exports.setDefaultWordlist = $3f31e9298802700a$var$setDefaultWordlist;
function $3f31e9298802700a$var$getDefaultWordlist() {
    if (!$3f31e9298802700a$var$DEFAULT_WORDLIST) throw new Error('No Default Wordlist set');
    return Object.keys($guT51.wordlists).filter((lang)=>{
        if (lang === 'JA' || lang === 'EN') return false;
        return $guT51.wordlists[lang].every((word, index)=>word === $3f31e9298802700a$var$DEFAULT_WORDLIST[index]);
    })[0];
}
module.exports.getDefaultWordlist = $3f31e9298802700a$var$getDefaultWordlist;

var $guT51 = parcelRequire("guT51");
module.exports.wordlists = $guT51.wordlists;

});
parcelRegister("lrsL3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $ebEok = parcelRequire("ebEok");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $f9c26d55b725e95d$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $f9c26d55b725e95d$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $f9c26d55b725e95d$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $f9c26d55b725e95d$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $f9c26d55b725e95d$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $f9c26d55b725e95d$var$SHA256 extends $lQ6Zm.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $f9c26d55b725e95d$var$IV[0] | 0;
        this.B = $f9c26d55b725e95d$var$IV[1] | 0;
        this.C = $f9c26d55b725e95d$var$IV[2] | 0;
        this.D = $f9c26d55b725e95d$var$IV[3] | 0;
        this.E = $f9c26d55b725e95d$var$IV[4] | 0;
        this.F = $f9c26d55b725e95d$var$IV[5] | 0;
        this.G = $f9c26d55b725e95d$var$IV[6] | 0;
        this.H = $f9c26d55b725e95d$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$f9c26d55b725e95d$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $f9c26d55b725e95d$var$SHA256_W[i - 15];
            const W2 = $f9c26d55b725e95d$var$SHA256_W[i - 2];
            const s0 = (0, $ebEok.rotr)(W15, 7) ^ (0, $ebEok.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $ebEok.rotr)(W2, 17) ^ (0, $ebEok.rotr)(W2, 19) ^ W2 >>> 10;
            $f9c26d55b725e95d$var$SHA256_W[i] = s1 + $f9c26d55b725e95d$var$SHA256_W[i - 7] + s0 + $f9c26d55b725e95d$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $ebEok.rotr)(E, 6) ^ (0, $ebEok.rotr)(E, 11) ^ (0, $ebEok.rotr)(E, 25);
            const T1 = H + sigma1 + $f9c26d55b725e95d$var$Chi(E, F, G) + $f9c26d55b725e95d$var$SHA256_K[i] + $f9c26d55b725e95d$var$SHA256_W[i] | 0;
            const sigma0 = (0, $ebEok.rotr)(A, 2) ^ (0, $ebEok.rotr)(A, 13) ^ (0, $ebEok.rotr)(A, 22);
            const T2 = sigma0 + $f9c26d55b725e95d$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $f9c26d55b725e95d$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $f9c26d55b725e95d$var$SHA224 extends $f9c26d55b725e95d$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $ebEok.wrapConstructor)(()=>new $f9c26d55b725e95d$var$SHA256());
module.exports.sha224 = (0, $ebEok.wrapConstructor)(()=>new $f9c26d55b725e95d$var$SHA224());

});
parcelRegister("lQ6Zm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $ebEok = parcelRequire("ebEok");
// Polyfill for Safari 14
function $fe63e01cd6f9f765$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $fe63e01cd6f9f765$var$SHA2 extends $ebEok.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $ebEok.createView)(this.buffer);
    }
    update(data) {
        (0, $kjkVj.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $ebEok.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $ebEok.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $kjkVj.exists)(this);
        (0, $kjkVj.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $fe63e01cd6f9f765$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $ebEok.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $fe63e01cd6f9f765$var$SHA2;

});
parcelRegister("kjkVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $ec95cfedc1b0632e$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $ec95cfedc1b0632e$var$number;
function $ec95cfedc1b0632e$var$bool(b) {
    if (typeof b !== 'boolean') throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $ec95cfedc1b0632e$var$bool;
function $ec95cfedc1b0632e$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error('Expected Uint8Array');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $ec95cfedc1b0632e$var$bytes;
function $ec95cfedc1b0632e$var$hash(hash) {
    if (typeof hash !== 'function' || typeof hash.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $ec95cfedc1b0632e$var$number(hash.outputLen);
    $ec95cfedc1b0632e$var$number(hash.blockLen);
}
module.exports.hash = $ec95cfedc1b0632e$var$hash;
function $ec95cfedc1b0632e$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
module.exports.exists = $ec95cfedc1b0632e$var$exists;
function $ec95cfedc1b0632e$var$output(out, instance) {
    $ec95cfedc1b0632e$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $ec95cfedc1b0632e$var$output;
const $ec95cfedc1b0632e$var$assert = {
    number: $ec95cfedc1b0632e$var$number,
    bool: $ec95cfedc1b0632e$var$bool,
    bytes: $ec95cfedc1b0632e$var$bytes,
    hash: $ec95cfedc1b0632e$var$hash,
    exists: $ec95cfedc1b0632e$var$exists,
    output: $ec95cfedc1b0632e$var$output
};
module.exports.default = $ec95cfedc1b0632e$var$assert;

});

parcelRegister("ebEok", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $iHiEG = parcelRequire("iHiEG");
const $a5416cad94001a40$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $a5416cad94001a40$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $a5416cad94001a40$var$u8;
const $a5416cad94001a40$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $a5416cad94001a40$var$u32;
// Cast array to view
const $a5416cad94001a40$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $a5416cad94001a40$var$createView;
// The rotate right (circular right shift) operation for uint32
const $a5416cad94001a40$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $a5416cad94001a40$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error('Non little-endian hardware is not supported');
const $a5416cad94001a40$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a5416cad94001a40$var$bytesToHex(bytes) {
    if (!$a5416cad94001a40$var$u8a(bytes)) throw new Error('Uint8Array expected');
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $a5416cad94001a40$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a5416cad94001a40$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a5416cad94001a40$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error('Invalid byte sequence');
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a5416cad94001a40$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $a5416cad94001a40$var$nextTick = async ()=>{};
module.exports.nextTick = $a5416cad94001a40$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $a5416cad94001a40$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $a5416cad94001a40$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a5416cad94001a40$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a5416cad94001a40$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $a5416cad94001a40$var$toBytes(data) {
    if (typeof data === 'string') data = $a5416cad94001a40$var$utf8ToBytes(data);
    if (!$a5416cad94001a40$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $a5416cad94001a40$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a5416cad94001a40$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a5416cad94001a40$var$u8a(a)) throw new Error('Uint8Array expected');
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a5416cad94001a40$var$concatBytes;
// For runtime check if class implements interface
class $a5416cad94001a40$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $a5416cad94001a40$var$Hash;
const $a5416cad94001a40$var$toStr = {}.toString;
function $a5416cad94001a40$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $a5416cad94001a40$var$toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $a5416cad94001a40$var$checkOpts;
function $a5416cad94001a40$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $a5416cad94001a40$var$wrapConstructor;
function $a5416cad94001a40$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $a5416cad94001a40$var$wrapConstructorWithOpts;
function $a5416cad94001a40$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $a5416cad94001a40$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $a5416cad94001a40$var$randomBytes(bytesLength = 32) {
    if ($iHiEG.crypto && typeof $iHiEG.crypto.getRandomValues === 'function') return $iHiEG.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}
module.exports.randomBytes = $a5416cad94001a40$var$randomBytes;

});
parcelRegister("iHiEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("fJ9Lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $gXXaj = parcelRequire("gXXaj");

var $ebEok = parcelRequire("ebEok");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$b732a15ea3159c68$var$SHA512_Kh, $b732a15ea3159c68$var$SHA512_Kl] = /* @__PURE__ */ (()=>$gXXaj.default.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $b732a15ea3159c68$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $b732a15ea3159c68$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $b732a15ea3159c68$var$SHA512 extends $lQ6Zm.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $b732a15ea3159c68$var$SHA512_W_H[i] = view.getUint32(offset);
            $b732a15ea3159c68$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $b732a15ea3159c68$var$SHA512_W_H[i - 15] | 0;
            const W15l = $b732a15ea3159c68$var$SHA512_W_L[i - 15] | 0;
            const s0h = $gXXaj.default.rotrSH(W15h, W15l, 1) ^ $gXXaj.default.rotrSH(W15h, W15l, 8) ^ $gXXaj.default.shrSH(W15h, W15l, 7);
            const s0l = $gXXaj.default.rotrSL(W15h, W15l, 1) ^ $gXXaj.default.rotrSL(W15h, W15l, 8) ^ $gXXaj.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $b732a15ea3159c68$var$SHA512_W_H[i - 2] | 0;
            const W2l = $b732a15ea3159c68$var$SHA512_W_L[i - 2] | 0;
            const s1h = $gXXaj.default.rotrSH(W2h, W2l, 19) ^ $gXXaj.default.rotrBH(W2h, W2l, 61) ^ $gXXaj.default.shrSH(W2h, W2l, 6);
            const s1l = $gXXaj.default.rotrSL(W2h, W2l, 19) ^ $gXXaj.default.rotrBL(W2h, W2l, 61) ^ $gXXaj.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $gXXaj.default.add4L(s0l, s1l, $b732a15ea3159c68$var$SHA512_W_L[i - 7], $b732a15ea3159c68$var$SHA512_W_L[i - 16]);
            const SUMh = $gXXaj.default.add4H(SUMl, s0h, s1h, $b732a15ea3159c68$var$SHA512_W_H[i - 7], $b732a15ea3159c68$var$SHA512_W_H[i - 16]);
            $b732a15ea3159c68$var$SHA512_W_H[i] = SUMh | 0;
            $b732a15ea3159c68$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $gXXaj.default.rotrSH(Eh, El, 14) ^ $gXXaj.default.rotrSH(Eh, El, 18) ^ $gXXaj.default.rotrBH(Eh, El, 41);
            const sigma1l = $gXXaj.default.rotrSL(Eh, El, 14) ^ $gXXaj.default.rotrSL(Eh, El, 18) ^ $gXXaj.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $gXXaj.default.add5L(Hl, sigma1l, CHIl, $b732a15ea3159c68$var$SHA512_Kl[i], $b732a15ea3159c68$var$SHA512_W_L[i]);
            const T1h = $gXXaj.default.add5H(T1ll, Hh, sigma1h, CHIh, $b732a15ea3159c68$var$SHA512_Kh[i], $b732a15ea3159c68$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $gXXaj.default.rotrSH(Ah, Al, 28) ^ $gXXaj.default.rotrBH(Ah, Al, 34) ^ $gXXaj.default.rotrBH(Ah, Al, 39);
            const sigma0l = $gXXaj.default.rotrSL(Ah, Al, 28) ^ $gXXaj.default.rotrBL(Ah, Al, 34) ^ $gXXaj.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $gXXaj.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $gXXaj.default.add3L(T1l, sigma0l, MAJl);
            Ah = $gXXaj.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $gXXaj.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $gXXaj.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $gXXaj.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $gXXaj.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $gXXaj.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $gXXaj.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $gXXaj.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $gXXaj.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $b732a15ea3159c68$var$SHA512_W_H.fill(0);
        $b732a15ea3159c68$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $b732a15ea3159c68$var$SHA512;
class $b732a15ea3159c68$var$SHA512_224 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $b732a15ea3159c68$var$SHA512_256 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $b732a15ea3159c68$var$SHA384 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512());
module.exports.sha512_224 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512_224());
module.exports.sha512_256 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512_256());
module.exports.sha384 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA384());

});
parcelRegister("gXXaj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $c5a00d09d36d1ee1$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $c5a00d09d36d1ee1$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $c5a00d09d36d1ee1$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64),
        l: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0,
        l: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $c5a00d09d36d1ee1$var$fromBig;
function $c5a00d09d36d1ee1$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c5a00d09d36d1ee1$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $c5a00d09d36d1ee1$var$split;
const $c5a00d09d36d1ee1$var$toBig = (h, l)=>BigInt(h >>> 0) << $c5a00d09d36d1ee1$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $c5a00d09d36d1ee1$var$toBig;
// for Shift in [0, 32)
const $c5a00d09d36d1ee1$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $c5a00d09d36d1ee1$var$shrSH;
const $c5a00d09d36d1ee1$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $c5a00d09d36d1ee1$var$shrSL;
// Right rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $c5a00d09d36d1ee1$var$rotrSH;
const $c5a00d09d36d1ee1$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $c5a00d09d36d1ee1$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $c5a00d09d36d1ee1$var$rotrBH;
const $c5a00d09d36d1ee1$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $c5a00d09d36d1ee1$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $c5a00d09d36d1ee1$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $c5a00d09d36d1ee1$var$rotr32H;
const $c5a00d09d36d1ee1$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $c5a00d09d36d1ee1$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $c5a00d09d36d1ee1$var$rotlSH;
const $c5a00d09d36d1ee1$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $c5a00d09d36d1ee1$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $c5a00d09d36d1ee1$var$rotlBH;
const $c5a00d09d36d1ee1$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $c5a00d09d36d1ee1$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c5a00d09d36d1ee1$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $c5a00d09d36d1ee1$var$add;
// Addition with more than 2 elements
const $c5a00d09d36d1ee1$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $c5a00d09d36d1ee1$var$add3L;
const $c5a00d09d36d1ee1$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $c5a00d09d36d1ee1$var$add3H;
const $c5a00d09d36d1ee1$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $c5a00d09d36d1ee1$var$add4L;
const $c5a00d09d36d1ee1$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $c5a00d09d36d1ee1$var$add4H;
const $c5a00d09d36d1ee1$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $c5a00d09d36d1ee1$var$add5L;
const $c5a00d09d36d1ee1$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $c5a00d09d36d1ee1$var$add5H;
// prettier-ignore
const $c5a00d09d36d1ee1$var$u64 = {
    fromBig: $c5a00d09d36d1ee1$var$fromBig,
    split: $c5a00d09d36d1ee1$var$split,
    toBig: $c5a00d09d36d1ee1$var$toBig,
    shrSH: $c5a00d09d36d1ee1$var$shrSH,
    shrSL: $c5a00d09d36d1ee1$var$shrSL,
    rotrSH: $c5a00d09d36d1ee1$var$rotrSH,
    rotrSL: $c5a00d09d36d1ee1$var$rotrSL,
    rotrBH: $c5a00d09d36d1ee1$var$rotrBH,
    rotrBL: $c5a00d09d36d1ee1$var$rotrBL,
    rotr32H: $c5a00d09d36d1ee1$var$rotr32H,
    rotr32L: $c5a00d09d36d1ee1$var$rotr32L,
    rotlSH: $c5a00d09d36d1ee1$var$rotlSH,
    rotlSL: $c5a00d09d36d1ee1$var$rotlSL,
    rotlBH: $c5a00d09d36d1ee1$var$rotlBH,
    rotlBL: $c5a00d09d36d1ee1$var$rotlBL,
    add: $c5a00d09d36d1ee1$var$add,
    add3L: $c5a00d09d36d1ee1$var$add3L,
    add3H: $c5a00d09d36d1ee1$var$add3H,
    add4L: $c5a00d09d36d1ee1$var$add4L,
    add4H: $c5a00d09d36d1ee1$var$add4H,
    add5H: $c5a00d09d36d1ee1$var$add5H,
    add5L: $c5a00d09d36d1ee1$var$add5L
};
module.exports.default = $c5a00d09d36d1ee1$var$u64;

});


parcelRegister("bQlVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $63hPu = parcelRequire("63hPu");

var $ebEok = parcelRequire("ebEok");
// Common prologue and epilogue for sync/async functions
function $89f58e9713408a6c$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $kjkVj.hash)(hash);
    const opts = (0, $ebEok.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $kjkVj.number)(c);
    (0, $kjkVj.number)(dkLen);
    (0, $kjkVj.number)(asyncTick);
    if (c < 1) throw new Error('PBKDF2: iterations (c) should be >= 1');
    const password = (0, $ebEok.toBytes)(_password);
    const salt = (0, $ebEok.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $63hPu.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $89f58e9713408a6c$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $89f58e9713408a6c$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $ebEok.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $89f58e9713408a6c$var$pbkdf2;
async function $89f58e9713408a6c$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $89f58e9713408a6c$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $ebEok.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $ebEok.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2Async = $89f58e9713408a6c$var$pbkdf2Async;

});
parcelRegister("63hPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $ebEok = parcelRequire("ebEok");
// HMAC (RFC 2104)
class $4680da7360be1f5f$var$HMAC extends $ebEok.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $kjkVj.hash)(hash);
        const key = (0, $ebEok.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $kjkVj.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $kjkVj.exists)(this);
        (0, $kjkVj.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $4680da7360be1f5f$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $4680da7360be1f5f$var$hmac = (hash, key, message)=>new $4680da7360be1f5f$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $4680da7360be1f5f$var$hmac;
module.exports.hmac.create = (hash, key)=>new $4680da7360be1f5f$var$HMAC(hash, key);

});


parcelRegister("guT51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const $c02a2c711f53a649$var$wordlists = {};
module.exports.wordlists = $c02a2c711f53a649$var$wordlists;
let $c02a2c711f53a649$var$_default;
module.exports._default = $c02a2c711f53a649$var$_default;

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4YRZc"));
    $c02a2c711f53a649$var$wordlists.czech = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("gmhgI"));
    $c02a2c711f53a649$var$wordlists.chinese_simplified = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("9FVoO"));
    $c02a2c711f53a649$var$wordlists.chinese_traditional = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4M2Fv"));
    $c02a2c711f53a649$var$wordlists.korean = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("eFCbz"));
    $c02a2c711f53a649$var$wordlists.french = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("hrLhZ"));
    $c02a2c711f53a649$var$wordlists.italian = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("911oV"));
    $c02a2c711f53a649$var$wordlists.spanish = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("lW32h"));
    $c02a2c711f53a649$var$wordlists.japanese = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.JA = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("g6Pks"));
    $c02a2c711f53a649$var$wordlists.portuguese = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("ml96a"));
    $c02a2c711f53a649$var$wordlists.english = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.EN = $c02a2c711f53a649$var$_default;
} catch (err) {}

});
parcelRegister("4YRZc", function(module, exports) {
module.exports = JSON.parse("[\"abdikace\",\"abeceda\",\"adresa\",\"agrese\",\"akce\",\"aktovka\",\"alej\",\"alkohol\",\"amputace\",\"ananas\",\"andulka\",\"anekdota\",\"anketa\",\"antika\",\"anulovat\",\"archa\",\"arogance\",\"asfalt\",\"asistent\",\"aspirace\",\"astma\",\"astronom\",\"atlas\",\"atletika\",\"atol\",\"autobus\",\"azyl\",\"babka\",\"bachor\",\"bacil\",\"baculka\",\"badatel\",\"bageta\",\"bagr\",\"bahno\",\"bakterie\",\"balada\",\"baletka\",\"balkon\",\"balonek\",\"balvan\",\"balza\",\"bambus\",\"bankomat\",\"barbar\",\"baret\",\"barman\",\"baroko\",\"barva\",\"baterka\",\"batoh\",\"bavlna\",\"bazalka\",\"bazilika\",\"bazuka\",\"bedna\",\"beran\",\"beseda\",\"bestie\",\"beton\",\"bezinka\",\"bezmoc\",\"beztak\",\"bicykl\",\"bidlo\",\"biftek\",\"bikiny\",\"bilance\",\"biograf\",\"biolog\",\"bitva\",\"bizon\",\"blahobyt\",\"blatouch\",\"blecha\",\"bledule\",\"blesk\",\"blikat\",\"blizna\",\"blokovat\",\"bloudit\",\"blud\",\"bobek\",\"bobr\",\"bodlina\",\"bodnout\",\"bohatost\",\"bojkot\",\"bojovat\",\"bokorys\",\"bolest\",\"borec\",\"borovice\",\"bota\",\"boubel\",\"bouchat\",\"bouda\",\"boule\",\"bourat\",\"boxer\",\"bradavka\",\"brambora\",\"branka\",\"bratr\",\"brepta\",\"briketa\",\"brko\",\"brloh\",\"bronz\",\"broskev\",\"brunetka\",\"brusinka\",\"brzda\",\"brzy\",\"bublina\",\"bubnovat\",\"buchta\",\"buditel\",\"budka\",\"budova\",\"bufet\",\"bujarost\",\"bukvice\",\"buldok\",\"bulva\",\"bunda\",\"bunkr\",\"burza\",\"butik\",\"buvol\",\"buzola\",\"bydlet\",\"bylina\",\"bytovka\",\"bzukot\",\"capart\",\"carevna\",\"cedr\",\"cedule\",\"cejch\",\"cejn\",\"cela\",\"celer\",\"celkem\",\"celnice\",\"cenina\",\"cennost\",\"cenovka\",\"centrum\",\"cenzor\",\"cestopis\",\"cetka\",\"chalupa\",\"chapadlo\",\"charita\",\"chata\",\"chechtat\",\"chemie\",\"chichot\",\"chirurg\",\"chlad\",\"chleba\",\"chlubit\",\"chmel\",\"chmura\",\"chobot\",\"chochol\",\"chodba\",\"cholera\",\"chomout\",\"chopit\",\"choroba\",\"chov\",\"chrapot\",\"chrlit\",\"chrt\",\"chrup\",\"chtivost\",\"chudina\",\"chutnat\",\"chvat\",\"chvilka\",\"chvost\",\"chyba\",\"chystat\",\"chytit\",\"cibule\",\"cigareta\",\"cihelna\",\"cihla\",\"cinkot\",\"cirkus\",\"cisterna\",\"citace\",\"citrus\",\"cizinec\",\"cizost\",\"clona\",\"cokoliv\",\"couvat\",\"ctitel\",\"ctnost\",\"cudnost\",\"cuketa\",\"cukr\",\"cupot\",\"cvaknout\",\"cval\",\"cvik\",\"cvrkot\",\"cyklista\",\"daleko\",\"dareba\",\"datel\",\"datum\",\"dcera\",\"debata\",\"dechovka\",\"decibel\",\"deficit\",\"deflace\",\"dekl\",\"dekret\",\"demokrat\",\"deprese\",\"derby\",\"deska\",\"detektiv\",\"dikobraz\",\"diktovat\",\"dioda\",\"diplom\",\"disk\",\"displej\",\"divadlo\",\"divoch\",\"dlaha\",\"dlouho\",\"dluhopis\",\"dnes\",\"dobro\",\"dobytek\",\"docent\",\"dochutit\",\"dodnes\",\"dohled\",\"dohoda\",\"dohra\",\"dojem\",\"dojnice\",\"doklad\",\"dokola\",\"doktor\",\"dokument\",\"dolar\",\"doleva\",\"dolina\",\"doma\",\"dominant\",\"domluvit\",\"domov\",\"donutit\",\"dopad\",\"dopis\",\"doplnit\",\"doposud\",\"doprovod\",\"dopustit\",\"dorazit\",\"dorost\",\"dort\",\"dosah\",\"doslov\",\"dostatek\",\"dosud\",\"dosyta\",\"dotaz\",\"dotek\",\"dotknout\",\"doufat\",\"doutnat\",\"dovozce\",\"dozadu\",\"doznat\",\"dozorce\",\"drahota\",\"drak\",\"dramatik\",\"dravec\",\"draze\",\"drdol\",\"drobnost\",\"drogerie\",\"drozd\",\"drsnost\",\"drtit\",\"drzost\",\"duben\",\"duchovno\",\"dudek\",\"duha\",\"duhovka\",\"dusit\",\"dusno\",\"dutost\",\"dvojice\",\"dvorec\",\"dynamit\",\"ekolog\",\"ekonomie\",\"elektron\",\"elipsa\",\"email\",\"emise\",\"emoce\",\"empatie\",\"epizoda\",\"epocha\",\"epopej\",\"epos\",\"esej\",\"esence\",\"eskorta\",\"eskymo\",\"etiketa\",\"euforie\",\"evoluce\",\"exekuce\",\"exkurze\",\"expedice\",\"exploze\",\"export\",\"extrakt\",\"facka\",\"fajfka\",\"fakulta\",\"fanatik\",\"fantazie\",\"farmacie\",\"favorit\",\"fazole\",\"federace\",\"fejeton\",\"fenka\",\"fialka\",\"figurant\",\"filozof\",\"filtr\",\"finance\",\"finta\",\"fixace\",\"fjord\",\"flanel\",\"flirt\",\"flotila\",\"fond\",\"fosfor\",\"fotbal\",\"fotka\",\"foton\",\"frakce\",\"freska\",\"fronta\",\"fukar\",\"funkce\",\"fyzika\",\"galeje\",\"garant\",\"genetika\",\"geolog\",\"gilotina\",\"glazura\",\"glejt\",\"golem\",\"golfista\",\"gotika\",\"graf\",\"gramofon\",\"granule\",\"grep\",\"gril\",\"grog\",\"groteska\",\"guma\",\"hadice\",\"hadr\",\"hala\",\"halenka\",\"hanba\",\"hanopis\",\"harfa\",\"harpuna\",\"havran\",\"hebkost\",\"hejkal\",\"hejno\",\"hejtman\",\"hektar\",\"helma\",\"hematom\",\"herec\",\"herna\",\"heslo\",\"hezky\",\"historik\",\"hladovka\",\"hlasivky\",\"hlava\",\"hledat\",\"hlen\",\"hlodavec\",\"hloh\",\"hloupost\",\"hltat\",\"hlubina\",\"hluchota\",\"hmat\",\"hmota\",\"hmyz\",\"hnis\",\"hnojivo\",\"hnout\",\"hoblina\",\"hoboj\",\"hoch\",\"hodiny\",\"hodlat\",\"hodnota\",\"hodovat\",\"hojnost\",\"hokej\",\"holinka\",\"holka\",\"holub\",\"homole\",\"honitba\",\"honorace\",\"horal\",\"horda\",\"horizont\",\"horko\",\"horlivec\",\"hormon\",\"hornina\",\"horoskop\",\"horstvo\",\"hospoda\",\"hostina\",\"hotovost\",\"houba\",\"houf\",\"houpat\",\"houska\",\"hovor\",\"hradba\",\"hranice\",\"hravost\",\"hrazda\",\"hrbolek\",\"hrdina\",\"hrdlo\",\"hrdost\",\"hrnek\",\"hrobka\",\"hromada\",\"hrot\",\"hrouda\",\"hrozen\",\"hrstka\",\"hrubost\",\"hryzat\",\"hubenost\",\"hubnout\",\"hudba\",\"hukot\",\"humr\",\"husita\",\"hustota\",\"hvozd\",\"hybnost\",\"hydrant\",\"hygiena\",\"hymna\",\"hysterik\",\"idylka\",\"ihned\",\"ikona\",\"iluze\",\"imunita\",\"infekce\",\"inflace\",\"inkaso\",\"inovace\",\"inspekce\",\"internet\",\"invalida\",\"investor\",\"inzerce\",\"ironie\",\"jablko\",\"jachta\",\"jahoda\",\"jakmile\",\"jakost\",\"jalovec\",\"jantar\",\"jarmark\",\"jaro\",\"jasan\",\"jasno\",\"jatka\",\"javor\",\"jazyk\",\"jedinec\",\"jedle\",\"jednatel\",\"jehlan\",\"jekot\",\"jelen\",\"jelito\",\"jemnost\",\"jenom\",\"jepice\",\"jeseter\",\"jevit\",\"jezdec\",\"jezero\",\"jinak\",\"jindy\",\"jinoch\",\"jiskra\",\"jistota\",\"jitrnice\",\"jizva\",\"jmenovat\",\"jogurt\",\"jurta\",\"kabaret\",\"kabel\",\"kabinet\",\"kachna\",\"kadet\",\"kadidlo\",\"kahan\",\"kajak\",\"kajuta\",\"kakao\",\"kaktus\",\"kalamita\",\"kalhoty\",\"kalibr\",\"kalnost\",\"kamera\",\"kamkoliv\",\"kamna\",\"kanibal\",\"kanoe\",\"kantor\",\"kapalina\",\"kapela\",\"kapitola\",\"kapka\",\"kaple\",\"kapota\",\"kapr\",\"kapusta\",\"kapybara\",\"karamel\",\"karotka\",\"karton\",\"kasa\",\"katalog\",\"katedra\",\"kauce\",\"kauza\",\"kavalec\",\"kazajka\",\"kazeta\",\"kazivost\",\"kdekoliv\",\"kdesi\",\"kedluben\",\"kemp\",\"keramika\",\"kino\",\"klacek\",\"kladivo\",\"klam\",\"klapot\",\"klasika\",\"klaun\",\"klec\",\"klenba\",\"klepat\",\"klesnout\",\"klid\",\"klima\",\"klisna\",\"klobouk\",\"klokan\",\"klopa\",\"kloub\",\"klubovna\",\"klusat\",\"kluzkost\",\"kmen\",\"kmitat\",\"kmotr\",\"kniha\",\"knot\",\"koalice\",\"koberec\",\"kobka\",\"kobliha\",\"kobyla\",\"kocour\",\"kohout\",\"kojenec\",\"kokos\",\"koktejl\",\"kolaps\",\"koleda\",\"kolize\",\"kolo\",\"komando\",\"kometa\",\"komik\",\"komnata\",\"komora\",\"kompas\",\"komunita\",\"konat\",\"koncept\",\"kondice\",\"konec\",\"konfese\",\"kongres\",\"konina\",\"konkurs\",\"kontakt\",\"konzerva\",\"kopanec\",\"kopie\",\"kopnout\",\"koprovka\",\"korbel\",\"korektor\",\"kormidlo\",\"koroptev\",\"korpus\",\"koruna\",\"koryto\",\"korzet\",\"kosatec\",\"kostka\",\"kotel\",\"kotleta\",\"kotoul\",\"koukat\",\"koupelna\",\"kousek\",\"kouzlo\",\"kovboj\",\"koza\",\"kozoroh\",\"krabice\",\"krach\",\"krajina\",\"kralovat\",\"krasopis\",\"kravata\",\"kredit\",\"krejcar\",\"kresba\",\"kreveta\",\"kriket\",\"kritik\",\"krize\",\"krkavec\",\"krmelec\",\"krmivo\",\"krocan\",\"krok\",\"kronika\",\"kropit\",\"kroupa\",\"krovka\",\"krtek\",\"kruhadlo\",\"krupice\",\"krutost\",\"krvinka\",\"krychle\",\"krypta\",\"krystal\",\"kryt\",\"kudlanka\",\"kufr\",\"kujnost\",\"kukla\",\"kulajda\",\"kulich\",\"kulka\",\"kulomet\",\"kultura\",\"kuna\",\"kupodivu\",\"kurt\",\"kurzor\",\"kutil\",\"kvalita\",\"kvasinka\",\"kvestor\",\"kynolog\",\"kyselina\",\"kytara\",\"kytice\",\"kytka\",\"kytovec\",\"kyvadlo\",\"labrador\",\"lachtan\",\"ladnost\",\"laik\",\"lakomec\",\"lamela\",\"lampa\",\"lanovka\",\"lasice\",\"laso\",\"lastura\",\"latinka\",\"lavina\",\"lebka\",\"leckdy\",\"leden\",\"lednice\",\"ledovka\",\"ledvina\",\"legenda\",\"legie\",\"legrace\",\"lehce\",\"lehkost\",\"lehnout\",\"lektvar\",\"lenochod\",\"lentilka\",\"lepenka\",\"lepidlo\",\"letadlo\",\"letec\",\"letmo\",\"letokruh\",\"levhart\",\"levitace\",\"levobok\",\"libra\",\"lichotka\",\"lidojed\",\"lidskost\",\"lihovina\",\"lijavec\",\"lilek\",\"limetka\",\"linie\",\"linka\",\"linoleum\",\"listopad\",\"litina\",\"litovat\",\"lobista\",\"lodivod\",\"logika\",\"logoped\",\"lokalita\",\"loket\",\"lomcovat\",\"lopata\",\"lopuch\",\"lord\",\"losos\",\"lotr\",\"loudal\",\"louh\",\"louka\",\"louskat\",\"lovec\",\"lstivost\",\"lucerna\",\"lucifer\",\"lump\",\"lusk\",\"lustrace\",\"lvice\",\"lyra\",\"lyrika\",\"lysina\",\"madam\",\"madlo\",\"magistr\",\"mahagon\",\"majetek\",\"majitel\",\"majorita\",\"makak\",\"makovice\",\"makrela\",\"malba\",\"malina\",\"malovat\",\"malvice\",\"maminka\",\"mandle\",\"manko\",\"marnost\",\"masakr\",\"maskot\",\"masopust\",\"matice\",\"matrika\",\"maturita\",\"mazanec\",\"mazivo\",\"mazlit\",\"mazurka\",\"mdloba\",\"mechanik\",\"meditace\",\"medovina\",\"melasa\",\"meloun\",\"mentolka\",\"metla\",\"metoda\",\"metr\",\"mezera\",\"migrace\",\"mihnout\",\"mihule\",\"mikina\",\"mikrofon\",\"milenec\",\"milimetr\",\"milost\",\"mimika\",\"mincovna\",\"minibar\",\"minomet\",\"minulost\",\"miska\",\"mistr\",\"mixovat\",\"mladost\",\"mlha\",\"mlhovina\",\"mlok\",\"mlsat\",\"mluvit\",\"mnich\",\"mnohem\",\"mobil\",\"mocnost\",\"modelka\",\"modlitba\",\"mohyla\",\"mokro\",\"molekula\",\"momentka\",\"monarcha\",\"monokl\",\"monstrum\",\"montovat\",\"monzun\",\"mosaz\",\"moskyt\",\"most\",\"motivace\",\"motorka\",\"motyka\",\"moucha\",\"moudrost\",\"mozaika\",\"mozek\",\"mozol\",\"mramor\",\"mravenec\",\"mrkev\",\"mrtvola\",\"mrzet\",\"mrzutost\",\"mstitel\",\"mudrc\",\"muflon\",\"mulat\",\"mumie\",\"munice\",\"muset\",\"mutace\",\"muzeum\",\"muzikant\",\"myslivec\",\"mzda\",\"nabourat\",\"nachytat\",\"nadace\",\"nadbytek\",\"nadhoz\",\"nadobro\",\"nadpis\",\"nahlas\",\"nahnat\",\"nahodile\",\"nahradit\",\"naivita\",\"najednou\",\"najisto\",\"najmout\",\"naklonit\",\"nakonec\",\"nakrmit\",\"nalevo\",\"namazat\",\"namluvit\",\"nanometr\",\"naoko\",\"naopak\",\"naostro\",\"napadat\",\"napevno\",\"naplnit\",\"napnout\",\"naposled\",\"naprosto\",\"narodit\",\"naruby\",\"narychlo\",\"nasadit\",\"nasekat\",\"naslepo\",\"nastat\",\"natolik\",\"navenek\",\"navrch\",\"navzdory\",\"nazvat\",\"nebe\",\"nechat\",\"necky\",\"nedaleko\",\"nedbat\",\"neduh\",\"negace\",\"nehet\",\"nehoda\",\"nejen\",\"nejprve\",\"neklid\",\"nelibost\",\"nemilost\",\"nemoc\",\"neochota\",\"neonka\",\"nepokoj\",\"nerost\",\"nerv\",\"nesmysl\",\"nesoulad\",\"netvor\",\"neuron\",\"nevina\",\"nezvykle\",\"nicota\",\"nijak\",\"nikam\",\"nikdy\",\"nikl\",\"nikterak\",\"nitro\",\"nocleh\",\"nohavice\",\"nominace\",\"nora\",\"norek\",\"nositel\",\"nosnost\",\"nouze\",\"noviny\",\"novota\",\"nozdra\",\"nuda\",\"nudle\",\"nuget\",\"nutit\",\"nutnost\",\"nutrie\",\"nymfa\",\"obal\",\"obarvit\",\"obava\",\"obdiv\",\"obec\",\"obehnat\",\"obejmout\",\"obezita\",\"obhajoba\",\"obilnice\",\"objasnit\",\"objekt\",\"obklopit\",\"oblast\",\"oblek\",\"obliba\",\"obloha\",\"obluda\",\"obnos\",\"obohatit\",\"obojek\",\"obout\",\"obrazec\",\"obrna\",\"obruba\",\"obrys\",\"obsah\",\"obsluha\",\"obstarat\",\"obuv\",\"obvaz\",\"obvinit\",\"obvod\",\"obvykle\",\"obyvatel\",\"obzor\",\"ocas\",\"ocel\",\"ocenit\",\"ochladit\",\"ochota\",\"ochrana\",\"ocitnout\",\"odboj\",\"odbyt\",\"odchod\",\"odcizit\",\"odebrat\",\"odeslat\",\"odevzdat\",\"odezva\",\"odhadce\",\"odhodit\",\"odjet\",\"odjinud\",\"odkaz\",\"odkoupit\",\"odliv\",\"odluka\",\"odmlka\",\"odolnost\",\"odpad\",\"odpis\",\"odplout\",\"odpor\",\"odpustit\",\"odpykat\",\"odrazka\",\"odsoudit\",\"odstup\",\"odsun\",\"odtok\",\"odtud\",\"odvaha\",\"odveta\",\"odvolat\",\"odvracet\",\"odznak\",\"ofina\",\"ofsajd\",\"ohlas\",\"ohnisko\",\"ohrada\",\"ohrozit\",\"ohryzek\",\"okap\",\"okenice\",\"oklika\",\"okno\",\"okouzlit\",\"okovy\",\"okrasa\",\"okres\",\"okrsek\",\"okruh\",\"okupant\",\"okurka\",\"okusit\",\"olejnina\",\"olizovat\",\"omak\",\"omeleta\",\"omezit\",\"omladina\",\"omlouvat\",\"omluva\",\"omyl\",\"onehdy\",\"opakovat\",\"opasek\",\"operace\",\"opice\",\"opilost\",\"opisovat\",\"opora\",\"opozice\",\"opravdu\",\"oproti\",\"orbital\",\"orchestr\",\"orgie\",\"orlice\",\"orloj\",\"ortel\",\"osada\",\"oschnout\",\"osika\",\"osivo\",\"oslava\",\"oslepit\",\"oslnit\",\"oslovit\",\"osnova\",\"osoba\",\"osolit\",\"ospalec\",\"osten\",\"ostraha\",\"ostuda\",\"ostych\",\"osvojit\",\"oteplit\",\"otisk\",\"otop\",\"otrhat\",\"otrlost\",\"otrok\",\"otruby\",\"otvor\",\"ovanout\",\"ovar\",\"oves\",\"ovlivnit\",\"ovoce\",\"oxid\",\"ozdoba\",\"pachatel\",\"pacient\",\"padouch\",\"pahorek\",\"pakt\",\"palanda\",\"palec\",\"palivo\",\"paluba\",\"pamflet\",\"pamlsek\",\"panenka\",\"panika\",\"panna\",\"panovat\",\"panstvo\",\"pantofle\",\"paprika\",\"parketa\",\"parodie\",\"parta\",\"paruka\",\"paryba\",\"paseka\",\"pasivita\",\"pastelka\",\"patent\",\"patrona\",\"pavouk\",\"pazneht\",\"pazourek\",\"pecka\",\"pedagog\",\"pejsek\",\"peklo\",\"peloton\",\"penalta\",\"pendrek\",\"penze\",\"periskop\",\"pero\",\"pestrost\",\"petarda\",\"petice\",\"petrolej\",\"pevnina\",\"pexeso\",\"pianista\",\"piha\",\"pijavice\",\"pikle\",\"piknik\",\"pilina\",\"pilnost\",\"pilulka\",\"pinzeta\",\"pipeta\",\"pisatel\",\"pistole\",\"pitevna\",\"pivnice\",\"pivovar\",\"placenta\",\"plakat\",\"plamen\",\"planeta\",\"plastika\",\"platit\",\"plavidlo\",\"plaz\",\"plech\",\"plemeno\",\"plenta\",\"ples\",\"pletivo\",\"plevel\",\"plivat\",\"plnit\",\"plno\",\"plocha\",\"plodina\",\"plomba\",\"plout\",\"pluk\",\"plyn\",\"pobavit\",\"pobyt\",\"pochod\",\"pocit\",\"poctivec\",\"podat\",\"podcenit\",\"podepsat\",\"podhled\",\"podivit\",\"podklad\",\"podmanit\",\"podnik\",\"podoba\",\"podpora\",\"podraz\",\"podstata\",\"podvod\",\"podzim\",\"poezie\",\"pohanka\",\"pohnutka\",\"pohovor\",\"pohroma\",\"pohyb\",\"pointa\",\"pojistka\",\"pojmout\",\"pokazit\",\"pokles\",\"pokoj\",\"pokrok\",\"pokuta\",\"pokyn\",\"poledne\",\"polibek\",\"polknout\",\"poloha\",\"polynom\",\"pomalu\",\"pominout\",\"pomlka\",\"pomoc\",\"pomsta\",\"pomyslet\",\"ponechat\",\"ponorka\",\"ponurost\",\"popadat\",\"popel\",\"popisek\",\"poplach\",\"poprosit\",\"popsat\",\"popud\",\"poradce\",\"porce\",\"porod\",\"porucha\",\"poryv\",\"posadit\",\"posed\",\"posila\",\"poskok\",\"poslanec\",\"posoudit\",\"pospolu\",\"postava\",\"posudek\",\"posyp\",\"potah\",\"potkan\",\"potlesk\",\"potomek\",\"potrava\",\"potupa\",\"potvora\",\"poukaz\",\"pouto\",\"pouzdro\",\"povaha\",\"povidla\",\"povlak\",\"povoz\",\"povrch\",\"povstat\",\"povyk\",\"povzdech\",\"pozdrav\",\"pozemek\",\"poznatek\",\"pozor\",\"pozvat\",\"pracovat\",\"prahory\",\"praktika\",\"prales\",\"praotec\",\"praporek\",\"prase\",\"pravda\",\"princip\",\"prkno\",\"probudit\",\"procento\",\"prodej\",\"profese\",\"prohra\",\"projekt\",\"prolomit\",\"promile\",\"pronikat\",\"propad\",\"prorok\",\"prosba\",\"proton\",\"proutek\",\"provaz\",\"prskavka\",\"prsten\",\"prudkost\",\"prut\",\"prvek\",\"prvohory\",\"psanec\",\"psovod\",\"pstruh\",\"ptactvo\",\"puberta\",\"puch\",\"pudl\",\"pukavec\",\"puklina\",\"pukrle\",\"pult\",\"pumpa\",\"punc\",\"pupen\",\"pusa\",\"pusinka\",\"pustina\",\"putovat\",\"putyka\",\"pyramida\",\"pysk\",\"pytel\",\"racek\",\"rachot\",\"radiace\",\"radnice\",\"radon\",\"raft\",\"ragby\",\"raketa\",\"rakovina\",\"rameno\",\"rampouch\",\"rande\",\"rarach\",\"rarita\",\"rasovna\",\"rastr\",\"ratolest\",\"razance\",\"razidlo\",\"reagovat\",\"reakce\",\"recept\",\"redaktor\",\"referent\",\"reflex\",\"rejnok\",\"reklama\",\"rekord\",\"rekrut\",\"rektor\",\"reputace\",\"revize\",\"revma\",\"revolver\",\"rezerva\",\"riskovat\",\"riziko\",\"robotika\",\"rodokmen\",\"rohovka\",\"rokle\",\"rokoko\",\"romaneto\",\"ropovod\",\"ropucha\",\"rorejs\",\"rosol\",\"rostlina\",\"rotmistr\",\"rotoped\",\"rotunda\",\"roubenka\",\"roucho\",\"roup\",\"roura\",\"rovina\",\"rovnice\",\"rozbor\",\"rozchod\",\"rozdat\",\"rozeznat\",\"rozhodce\",\"rozinka\",\"rozjezd\",\"rozkaz\",\"rozloha\",\"rozmar\",\"rozpad\",\"rozruch\",\"rozsah\",\"roztok\",\"rozum\",\"rozvod\",\"rubrika\",\"ruchadlo\",\"rukavice\",\"rukopis\",\"ryba\",\"rybolov\",\"rychlost\",\"rydlo\",\"rypadlo\",\"rytina\",\"ryzost\",\"sadista\",\"sahat\",\"sako\",\"samec\",\"samizdat\",\"samota\",\"sanitka\",\"sardinka\",\"sasanka\",\"satelit\",\"sazba\",\"sazenice\",\"sbor\",\"schovat\",\"sebranka\",\"secese\",\"sedadlo\",\"sediment\",\"sedlo\",\"sehnat\",\"sejmout\",\"sekera\",\"sekta\",\"sekunda\",\"sekvoje\",\"semeno\",\"seno\",\"servis\",\"sesadit\",\"seshora\",\"seskok\",\"seslat\",\"sestra\",\"sesuv\",\"sesypat\",\"setba\",\"setina\",\"setkat\",\"setnout\",\"setrvat\",\"sever\",\"seznam\",\"shoda\",\"shrnout\",\"sifon\",\"silnice\",\"sirka\",\"sirotek\",\"sirup\",\"situace\",\"skafandr\",\"skalisko\",\"skanzen\",\"skaut\",\"skeptik\",\"skica\",\"skladba\",\"sklenice\",\"sklo\",\"skluz\",\"skoba\",\"skokan\",\"skoro\",\"skripta\",\"skrz\",\"skupina\",\"skvost\",\"skvrna\",\"slabika\",\"sladidlo\",\"slanina\",\"slast\",\"slavnost\",\"sledovat\",\"slepec\",\"sleva\",\"slezina\",\"slib\",\"slina\",\"sliznice\",\"slon\",\"sloupek\",\"slovo\",\"sluch\",\"sluha\",\"slunce\",\"slupka\",\"slza\",\"smaragd\",\"smetana\",\"smilstvo\",\"smlouva\",\"smog\",\"smrad\",\"smrk\",\"smrtka\",\"smutek\",\"smysl\",\"snad\",\"snaha\",\"snob\",\"sobota\",\"socha\",\"sodovka\",\"sokol\",\"sopka\",\"sotva\",\"souboj\",\"soucit\",\"soudce\",\"souhlas\",\"soulad\",\"soumrak\",\"souprava\",\"soused\",\"soutok\",\"souviset\",\"spalovna\",\"spasitel\",\"spis\",\"splav\",\"spodek\",\"spojenec\",\"spolu\",\"sponzor\",\"spornost\",\"spousta\",\"sprcha\",\"spustit\",\"sranda\",\"sraz\",\"srdce\",\"srna\",\"srnec\",\"srovnat\",\"srpen\",\"srst\",\"srub\",\"stanice\",\"starosta\",\"statika\",\"stavba\",\"stehno\",\"stezka\",\"stodola\",\"stolek\",\"stopa\",\"storno\",\"stoupat\",\"strach\",\"stres\",\"strhnout\",\"strom\",\"struna\",\"studna\",\"stupnice\",\"stvol\",\"styk\",\"subjekt\",\"subtropy\",\"suchar\",\"sudost\",\"sukno\",\"sundat\",\"sunout\",\"surikata\",\"surovina\",\"svah\",\"svalstvo\",\"svetr\",\"svatba\",\"svazek\",\"svisle\",\"svitek\",\"svoboda\",\"svodidlo\",\"svorka\",\"svrab\",\"sykavka\",\"sykot\",\"synek\",\"synovec\",\"sypat\",\"sypkost\",\"syrovost\",\"sysel\",\"sytost\",\"tabletka\",\"tabule\",\"tahoun\",\"tajemno\",\"tajfun\",\"tajga\",\"tajit\",\"tajnost\",\"taktika\",\"tamhle\",\"tampon\",\"tancovat\",\"tanec\",\"tanker\",\"tapeta\",\"tavenina\",\"tazatel\",\"technika\",\"tehdy\",\"tekutina\",\"telefon\",\"temnota\",\"tendence\",\"tenista\",\"tenor\",\"teplota\",\"tepna\",\"teprve\",\"terapie\",\"termoska\",\"textil\",\"ticho\",\"tiskopis\",\"titulek\",\"tkadlec\",\"tkanina\",\"tlapka\",\"tleskat\",\"tlukot\",\"tlupa\",\"tmel\",\"toaleta\",\"topinka\",\"topol\",\"torzo\",\"touha\",\"toulec\",\"tradice\",\"traktor\",\"tramp\",\"trasa\",\"traverza\",\"trefit\",\"trest\",\"trezor\",\"trhavina\",\"trhlina\",\"trochu\",\"trojice\",\"troska\",\"trouba\",\"trpce\",\"trpitel\",\"trpkost\",\"trubec\",\"truchlit\",\"truhlice\",\"trus\",\"trvat\",\"tudy\",\"tuhnout\",\"tuhost\",\"tundra\",\"turista\",\"turnaj\",\"tuzemsko\",\"tvaroh\",\"tvorba\",\"tvrdost\",\"tvrz\",\"tygr\",\"tykev\",\"ubohost\",\"uboze\",\"ubrat\",\"ubrousek\",\"ubrus\",\"ubytovna\",\"ucho\",\"uctivost\",\"udivit\",\"uhradit\",\"ujednat\",\"ujistit\",\"ujmout\",\"ukazatel\",\"uklidnit\",\"uklonit\",\"ukotvit\",\"ukrojit\",\"ulice\",\"ulita\",\"ulovit\",\"umyvadlo\",\"unavit\",\"uniforma\",\"uniknout\",\"upadnout\",\"uplatnit\",\"uplynout\",\"upoutat\",\"upravit\",\"uran\",\"urazit\",\"usednout\",\"usilovat\",\"usmrtit\",\"usnadnit\",\"usnout\",\"usoudit\",\"ustlat\",\"ustrnout\",\"utahovat\",\"utkat\",\"utlumit\",\"utonout\",\"utopenec\",\"utrousit\",\"uvalit\",\"uvolnit\",\"uvozovka\",\"uzdravit\",\"uzel\",\"uzenina\",\"uzlina\",\"uznat\",\"vagon\",\"valcha\",\"valoun\",\"vana\",\"vandal\",\"vanilka\",\"varan\",\"varhany\",\"varovat\",\"vcelku\",\"vchod\",\"vdova\",\"vedro\",\"vegetace\",\"vejce\",\"velbloud\",\"veletrh\",\"velitel\",\"velmoc\",\"velryba\",\"venkov\",\"veranda\",\"verze\",\"veselka\",\"veskrze\",\"vesnice\",\"vespodu\",\"vesta\",\"veterina\",\"veverka\",\"vibrace\",\"vichr\",\"videohra\",\"vidina\",\"vidle\",\"vila\",\"vinice\",\"viset\",\"vitalita\",\"vize\",\"vizitka\",\"vjezd\",\"vklad\",\"vkus\",\"vlajka\",\"vlak\",\"vlasec\",\"vlevo\",\"vlhkost\",\"vliv\",\"vlnovka\",\"vloupat\",\"vnucovat\",\"vnuk\",\"voda\",\"vodivost\",\"vodoznak\",\"vodstvo\",\"vojensky\",\"vojna\",\"vojsko\",\"volant\",\"volba\",\"volit\",\"volno\",\"voskovka\",\"vozidlo\",\"vozovna\",\"vpravo\",\"vrabec\",\"vracet\",\"vrah\",\"vrata\",\"vrba\",\"vrcholek\",\"vrhat\",\"vrstva\",\"vrtule\",\"vsadit\",\"vstoupit\",\"vstup\",\"vtip\",\"vybavit\",\"vybrat\",\"vychovat\",\"vydat\",\"vydra\",\"vyfotit\",\"vyhledat\",\"vyhnout\",\"vyhodit\",\"vyhradit\",\"vyhubit\",\"vyjasnit\",\"vyjet\",\"vyjmout\",\"vyklopit\",\"vykonat\",\"vylekat\",\"vymazat\",\"vymezit\",\"vymizet\",\"vymyslet\",\"vynechat\",\"vynikat\",\"vynutit\",\"vypadat\",\"vyplatit\",\"vypravit\",\"vypustit\",\"vyrazit\",\"vyrovnat\",\"vyrvat\",\"vyslovit\",\"vysoko\",\"vystavit\",\"vysunout\",\"vysypat\",\"vytasit\",\"vytesat\",\"vytratit\",\"vyvinout\",\"vyvolat\",\"vyvrhel\",\"vyzdobit\",\"vyznat\",\"vzadu\",\"vzbudit\",\"vzchopit\",\"vzdor\",\"vzduch\",\"vzdychat\",\"vzestup\",\"vzhledem\",\"vzkaz\",\"vzlykat\",\"vznik\",\"vzorek\",\"vzpoura\",\"vztah\",\"vztek\",\"xylofon\",\"zabrat\",\"zabydlet\",\"zachovat\",\"zadarmo\",\"zadusit\",\"zafoukat\",\"zahltit\",\"zahodit\",\"zahrada\",\"zahynout\",\"zajatec\",\"zajet\",\"zajistit\",\"zaklepat\",\"zakoupit\",\"zalepit\",\"zamezit\",\"zamotat\",\"zamyslet\",\"zanechat\",\"zanikat\",\"zaplatit\",\"zapojit\",\"zapsat\",\"zarazit\",\"zastavit\",\"zasunout\",\"zatajit\",\"zatemnit\",\"zatknout\",\"zaujmout\",\"zavalit\",\"zavelet\",\"zavinit\",\"zavolat\",\"zavrtat\",\"zazvonit\",\"zbavit\",\"zbrusu\",\"zbudovat\",\"zbytek\",\"zdaleka\",\"zdarma\",\"zdatnost\",\"zdivo\",\"zdobit\",\"zdroj\",\"zdvih\",\"zdymadlo\",\"zelenina\",\"zeman\",\"zemina\",\"zeptat\",\"zezadu\",\"zezdola\",\"zhatit\",\"zhltnout\",\"zhluboka\",\"zhotovit\",\"zhruba\",\"zima\",\"zimnice\",\"zjemnit\",\"zklamat\",\"zkoumat\",\"zkratka\",\"zkumavka\",\"zlato\",\"zlehka\",\"zloba\",\"zlom\",\"zlost\",\"zlozvyk\",\"zmapovat\",\"zmar\",\"zmatek\",\"zmije\",\"zmizet\",\"zmocnit\",\"zmodrat\",\"zmrzlina\",\"zmutovat\",\"znak\",\"znalost\",\"znamenat\",\"znovu\",\"zobrazit\",\"zotavit\",\"zoubek\",\"zoufale\",\"zplodit\",\"zpomalit\",\"zprava\",\"zprostit\",\"zprudka\",\"zprvu\",\"zrada\",\"zranit\",\"zrcadlo\",\"zrnitost\",\"zrno\",\"zrovna\",\"zrychlit\",\"zrzavost\",\"zticha\",\"ztratit\",\"zubovina\",\"zubr\",\"zvednout\",\"zvenku\",\"zvesela\",\"zvon\",\"zvrat\",\"zvukovod\",\"zvyk\"]");

});

parcelRegister("gmhgI", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("9FVoO", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("4M2Fv", function(module, exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

});

parcelRegister("eFCbz", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

});

parcelRegister("hrLhZ", function(module, exports) {
module.exports = JSON.parse("[\"abaco\",\"abbaglio\",\"abbinato\",\"abete\",\"abisso\",\"abolire\",\"abrasivo\",\"abrogato\",\"accadere\",\"accenno\",\"accusato\",\"acetone\",\"achille\",\"acido\",\"acqua\",\"acre\",\"acrilico\",\"acrobata\",\"acuto\",\"adagio\",\"addebito\",\"addome\",\"adeguato\",\"aderire\",\"adipe\",\"adottare\",\"adulare\",\"affabile\",\"affetto\",\"affisso\",\"affranto\",\"aforisma\",\"afoso\",\"africano\",\"agave\",\"agente\",\"agevole\",\"aggancio\",\"agire\",\"agitare\",\"agonismo\",\"agricolo\",\"agrumeto\",\"aguzzo\",\"alabarda\",\"alato\",\"albatro\",\"alberato\",\"albo\",\"albume\",\"alce\",\"alcolico\",\"alettone\",\"alfa\",\"algebra\",\"aliante\",\"alibi\",\"alimento\",\"allagato\",\"allegro\",\"allievo\",\"allodola\",\"allusivo\",\"almeno\",\"alogeno\",\"alpaca\",\"alpestre\",\"altalena\",\"alterno\",\"alticcio\",\"altrove\",\"alunno\",\"alveolo\",\"alzare\",\"amalgama\",\"amanita\",\"amarena\",\"ambito\",\"ambrato\",\"ameba\",\"america\",\"ametista\",\"amico\",\"ammasso\",\"ammenda\",\"ammirare\",\"ammonito\",\"amore\",\"ampio\",\"ampliare\",\"amuleto\",\"anacardo\",\"anagrafe\",\"analista\",\"anarchia\",\"anatra\",\"anca\",\"ancella\",\"ancora\",\"andare\",\"andrea\",\"anello\",\"angelo\",\"angolare\",\"angusto\",\"anima\",\"annegare\",\"annidato\",\"anno\",\"annuncio\",\"anonimo\",\"anticipo\",\"anzi\",\"apatico\",\"apertura\",\"apode\",\"apparire\",\"appetito\",\"appoggio\",\"approdo\",\"appunto\",\"aprile\",\"arabica\",\"arachide\",\"aragosta\",\"araldica\",\"arancio\",\"aratura\",\"arazzo\",\"arbitro\",\"archivio\",\"ardito\",\"arenile\",\"argento\",\"argine\",\"arguto\",\"aria\",\"armonia\",\"arnese\",\"arredato\",\"arringa\",\"arrosto\",\"arsenico\",\"arso\",\"artefice\",\"arzillo\",\"asciutto\",\"ascolto\",\"asepsi\",\"asettico\",\"asfalto\",\"asino\",\"asola\",\"aspirato\",\"aspro\",\"assaggio\",\"asse\",\"assoluto\",\"assurdo\",\"asta\",\"astenuto\",\"astice\",\"astratto\",\"atavico\",\"ateismo\",\"atomico\",\"atono\",\"attesa\",\"attivare\",\"attorno\",\"attrito\",\"attuale\",\"ausilio\",\"austria\",\"autista\",\"autonomo\",\"autunno\",\"avanzato\",\"avere\",\"avvenire\",\"avviso\",\"avvolgere\",\"azione\",\"azoto\",\"azzimo\",\"azzurro\",\"babele\",\"baccano\",\"bacino\",\"baco\",\"badessa\",\"badilata\",\"bagnato\",\"baita\",\"balcone\",\"baldo\",\"balena\",\"ballata\",\"balzano\",\"bambino\",\"bandire\",\"baraonda\",\"barbaro\",\"barca\",\"baritono\",\"barlume\",\"barocco\",\"basilico\",\"basso\",\"batosta\",\"battuto\",\"baule\",\"bava\",\"bavosa\",\"becco\",\"beffa\",\"belgio\",\"belva\",\"benda\",\"benevole\",\"benigno\",\"benzina\",\"bere\",\"berlina\",\"beta\",\"bibita\",\"bici\",\"bidone\",\"bifido\",\"biga\",\"bilancia\",\"bimbo\",\"binocolo\",\"biologo\",\"bipede\",\"bipolare\",\"birbante\",\"birra\",\"biscotto\",\"bisesto\",\"bisnonno\",\"bisonte\",\"bisturi\",\"bizzarro\",\"blando\",\"blatta\",\"bollito\",\"bonifico\",\"bordo\",\"bosco\",\"botanico\",\"bottino\",\"bozzolo\",\"braccio\",\"bradipo\",\"brama\",\"branca\",\"bravura\",\"bretella\",\"brevetto\",\"brezza\",\"briglia\",\"brillante\",\"brindare\",\"broccolo\",\"brodo\",\"bronzina\",\"brullo\",\"bruno\",\"bubbone\",\"buca\",\"budino\",\"buffone\",\"buio\",\"bulbo\",\"buono\",\"burlone\",\"burrasca\",\"bussola\",\"busta\",\"cadetto\",\"caduco\",\"calamaro\",\"calcolo\",\"calesse\",\"calibro\",\"calmo\",\"caloria\",\"cambusa\",\"camerata\",\"camicia\",\"cammino\",\"camola\",\"campale\",\"canapa\",\"candela\",\"cane\",\"canino\",\"canotto\",\"cantina\",\"capace\",\"capello\",\"capitolo\",\"capogiro\",\"cappero\",\"capra\",\"capsula\",\"carapace\",\"carcassa\",\"cardo\",\"carisma\",\"carovana\",\"carretto\",\"cartolina\",\"casaccio\",\"cascata\",\"caserma\",\"caso\",\"cassone\",\"castello\",\"casuale\",\"catasta\",\"catena\",\"catrame\",\"cauto\",\"cavillo\",\"cedibile\",\"cedrata\",\"cefalo\",\"celebre\",\"cellulare\",\"cena\",\"cenone\",\"centesimo\",\"ceramica\",\"cercare\",\"certo\",\"cerume\",\"cervello\",\"cesoia\",\"cespo\",\"ceto\",\"chela\",\"chiaro\",\"chicca\",\"chiedere\",\"chimera\",\"china\",\"chirurgo\",\"chitarra\",\"ciao\",\"ciclismo\",\"cifrare\",\"cigno\",\"cilindro\",\"ciottolo\",\"circa\",\"cirrosi\",\"citrico\",\"cittadino\",\"ciuffo\",\"civetta\",\"civile\",\"classico\",\"clinica\",\"cloro\",\"cocco\",\"codardo\",\"codice\",\"coerente\",\"cognome\",\"collare\",\"colmato\",\"colore\",\"colposo\",\"coltivato\",\"colza\",\"coma\",\"cometa\",\"commando\",\"comodo\",\"computer\",\"comune\",\"conciso\",\"condurre\",\"conferma\",\"congelare\",\"coniuge\",\"connesso\",\"conoscere\",\"consumo\",\"continuo\",\"convegno\",\"coperto\",\"copione\",\"coppia\",\"copricapo\",\"corazza\",\"cordata\",\"coricato\",\"cornice\",\"corolla\",\"corpo\",\"corredo\",\"corsia\",\"cortese\",\"cosmico\",\"costante\",\"cottura\",\"covato\",\"cratere\",\"cravatta\",\"creato\",\"credere\",\"cremoso\",\"crescita\",\"creta\",\"criceto\",\"crinale\",\"crisi\",\"critico\",\"croce\",\"cronaca\",\"crostata\",\"cruciale\",\"crusca\",\"cucire\",\"cuculo\",\"cugino\",\"cullato\",\"cupola\",\"curatore\",\"cursore\",\"curvo\",\"cuscino\",\"custode\",\"dado\",\"daino\",\"dalmata\",\"damerino\",\"daniela\",\"dannoso\",\"danzare\",\"datato\",\"davanti\",\"davvero\",\"debutto\",\"decennio\",\"deciso\",\"declino\",\"decollo\",\"decreto\",\"dedicato\",\"definito\",\"deforme\",\"degno\",\"delegare\",\"delfino\",\"delirio\",\"delta\",\"demenza\",\"denotato\",\"dentro\",\"deposito\",\"derapata\",\"derivare\",\"deroga\",\"descritto\",\"deserto\",\"desiderio\",\"desumere\",\"detersivo\",\"devoto\",\"diametro\",\"dicembre\",\"diedro\",\"difeso\",\"diffuso\",\"digerire\",\"digitale\",\"diluvio\",\"dinamico\",\"dinnanzi\",\"dipinto\",\"diploma\",\"dipolo\",\"diradare\",\"dire\",\"dirotto\",\"dirupo\",\"disagio\",\"discreto\",\"disfare\",\"disgelo\",\"disposto\",\"distanza\",\"disumano\",\"dito\",\"divano\",\"divelto\",\"dividere\",\"divorato\",\"doblone\",\"docente\",\"doganale\",\"dogma\",\"dolce\",\"domato\",\"domenica\",\"dominare\",\"dondolo\",\"dono\",\"dormire\",\"dote\",\"dottore\",\"dovuto\",\"dozzina\",\"drago\",\"druido\",\"dubbio\",\"dubitare\",\"ducale\",\"duna\",\"duomo\",\"duplice\",\"duraturo\",\"ebano\",\"eccesso\",\"ecco\",\"eclissi\",\"economia\",\"edera\",\"edicola\",\"edile\",\"editoria\",\"educare\",\"egemonia\",\"egli\",\"egoismo\",\"egregio\",\"elaborato\",\"elargire\",\"elegante\",\"elencato\",\"eletto\",\"elevare\",\"elfico\",\"elica\",\"elmo\",\"elsa\",\"eluso\",\"emanato\",\"emblema\",\"emesso\",\"emiro\",\"emotivo\",\"emozione\",\"empirico\",\"emulo\",\"endemico\",\"enduro\",\"energia\",\"enfasi\",\"enoteca\",\"entrare\",\"enzima\",\"epatite\",\"epilogo\",\"episodio\",\"epocale\",\"eppure\",\"equatore\",\"erario\",\"erba\",\"erboso\",\"erede\",\"eremita\",\"erigere\",\"ermetico\",\"eroe\",\"erosivo\",\"errante\",\"esagono\",\"esame\",\"esanime\",\"esaudire\",\"esca\",\"esempio\",\"esercito\",\"esibito\",\"esigente\",\"esistere\",\"esito\",\"esofago\",\"esortato\",\"esoso\",\"espanso\",\"espresso\",\"essenza\",\"esso\",\"esteso\",\"estimare\",\"estonia\",\"estroso\",\"esultare\",\"etilico\",\"etnico\",\"etrusco\",\"etto\",\"euclideo\",\"europa\",\"evaso\",\"evidenza\",\"evitato\",\"evoluto\",\"evviva\",\"fabbrica\",\"faccenda\",\"fachiro\",\"falco\",\"famiglia\",\"fanale\",\"fanfara\",\"fango\",\"fantasma\",\"fare\",\"farfalla\",\"farinoso\",\"farmaco\",\"fascia\",\"fastoso\",\"fasullo\",\"faticare\",\"fato\",\"favoloso\",\"febbre\",\"fecola\",\"fede\",\"fegato\",\"felpa\",\"feltro\",\"femmina\",\"fendere\",\"fenomeno\",\"fermento\",\"ferro\",\"fertile\",\"fessura\",\"festivo\",\"fetta\",\"feudo\",\"fiaba\",\"fiducia\",\"fifa\",\"figurato\",\"filo\",\"finanza\",\"finestra\",\"finire\",\"fiore\",\"fiscale\",\"fisico\",\"fiume\",\"flacone\",\"flamenco\",\"flebo\",\"flemma\",\"florido\",\"fluente\",\"fluoro\",\"fobico\",\"focaccia\",\"focoso\",\"foderato\",\"foglio\",\"folata\",\"folclore\",\"folgore\",\"fondente\",\"fonetico\",\"fonia\",\"fontana\",\"forbito\",\"forchetta\",\"foresta\",\"formica\",\"fornaio\",\"foro\",\"fortezza\",\"forzare\",\"fosfato\",\"fosso\",\"fracasso\",\"frana\",\"frassino\",\"fratello\",\"freccetta\",\"frenata\",\"fresco\",\"frigo\",\"frollino\",\"fronde\",\"frugale\",\"frutta\",\"fucilata\",\"fucsia\",\"fuggente\",\"fulmine\",\"fulvo\",\"fumante\",\"fumetto\",\"fumoso\",\"fune\",\"funzione\",\"fuoco\",\"furbo\",\"furgone\",\"furore\",\"fuso\",\"futile\",\"gabbiano\",\"gaffe\",\"galateo\",\"gallina\",\"galoppo\",\"gambero\",\"gamma\",\"garanzia\",\"garbo\",\"garofano\",\"garzone\",\"gasdotto\",\"gasolio\",\"gastrico\",\"gatto\",\"gaudio\",\"gazebo\",\"gazzella\",\"geco\",\"gelatina\",\"gelso\",\"gemello\",\"gemmato\",\"gene\",\"genitore\",\"gennaio\",\"genotipo\",\"gergo\",\"ghepardo\",\"ghiaccio\",\"ghisa\",\"giallo\",\"gilda\",\"ginepro\",\"giocare\",\"gioiello\",\"giorno\",\"giove\",\"girato\",\"girone\",\"gittata\",\"giudizio\",\"giurato\",\"giusto\",\"globulo\",\"glutine\",\"gnomo\",\"gobba\",\"golf\",\"gomito\",\"gommone\",\"gonfio\",\"gonna\",\"governo\",\"gracile\",\"grado\",\"grafico\",\"grammo\",\"grande\",\"grattare\",\"gravoso\",\"grazia\",\"greca\",\"gregge\",\"grifone\",\"grigio\",\"grinza\",\"grotta\",\"gruppo\",\"guadagno\",\"guaio\",\"guanto\",\"guardare\",\"gufo\",\"guidare\",\"ibernato\",\"icona\",\"identico\",\"idillio\",\"idolo\",\"idra\",\"idrico\",\"idrogeno\",\"igiene\",\"ignaro\",\"ignorato\",\"ilare\",\"illeso\",\"illogico\",\"illudere\",\"imballo\",\"imbevuto\",\"imbocco\",\"imbuto\",\"immane\",\"immerso\",\"immolato\",\"impacco\",\"impeto\",\"impiego\",\"importo\",\"impronta\",\"inalare\",\"inarcare\",\"inattivo\",\"incanto\",\"incendio\",\"inchino\",\"incisivo\",\"incluso\",\"incontro\",\"incrocio\",\"incubo\",\"indagine\",\"india\",\"indole\",\"inedito\",\"infatti\",\"infilare\",\"inflitto\",\"ingaggio\",\"ingegno\",\"inglese\",\"ingordo\",\"ingrosso\",\"innesco\",\"inodore\",\"inoltrare\",\"inondato\",\"insano\",\"insetto\",\"insieme\",\"insonnia\",\"insulina\",\"intasato\",\"intero\",\"intonaco\",\"intuito\",\"inumidire\",\"invalido\",\"invece\",\"invito\",\"iperbole\",\"ipnotico\",\"ipotesi\",\"ippica\",\"iride\",\"irlanda\",\"ironico\",\"irrigato\",\"irrorare\",\"isolato\",\"isotopo\",\"isterico\",\"istituto\",\"istrice\",\"italia\",\"iterare\",\"labbro\",\"labirinto\",\"lacca\",\"lacerato\",\"lacrima\",\"lacuna\",\"laddove\",\"lago\",\"lampo\",\"lancetta\",\"lanterna\",\"lardoso\",\"larga\",\"laringe\",\"lastra\",\"latenza\",\"latino\",\"lattuga\",\"lavagna\",\"lavoro\",\"legale\",\"leggero\",\"lembo\",\"lentezza\",\"lenza\",\"leone\",\"lepre\",\"lesivo\",\"lessato\",\"lesto\",\"letterale\",\"leva\",\"levigato\",\"libero\",\"lido\",\"lievito\",\"lilla\",\"limatura\",\"limitare\",\"limpido\",\"lineare\",\"lingua\",\"liquido\",\"lira\",\"lirica\",\"lisca\",\"lite\",\"litigio\",\"livrea\",\"locanda\",\"lode\",\"logica\",\"lombare\",\"londra\",\"longevo\",\"loquace\",\"lorenzo\",\"loto\",\"lotteria\",\"luce\",\"lucidato\",\"lumaca\",\"luminoso\",\"lungo\",\"lupo\",\"luppolo\",\"lusinga\",\"lusso\",\"lutto\",\"macabro\",\"macchina\",\"macero\",\"macinato\",\"madama\",\"magico\",\"maglia\",\"magnete\",\"magro\",\"maiolica\",\"malafede\",\"malgrado\",\"malinteso\",\"malsano\",\"malto\",\"malumore\",\"mana\",\"mancia\",\"mandorla\",\"mangiare\",\"manifesto\",\"mannaro\",\"manovra\",\"mansarda\",\"mantide\",\"manubrio\",\"mappa\",\"maratona\",\"marcire\",\"maretta\",\"marmo\",\"marsupio\",\"maschera\",\"massaia\",\"mastino\",\"materasso\",\"matricola\",\"mattone\",\"maturo\",\"mazurca\",\"meandro\",\"meccanico\",\"mecenate\",\"medesimo\",\"meditare\",\"mega\",\"melassa\",\"melis\",\"melodia\",\"meninge\",\"meno\",\"mensola\",\"mercurio\",\"merenda\",\"merlo\",\"meschino\",\"mese\",\"messere\",\"mestolo\",\"metallo\",\"metodo\",\"mettere\",\"miagolare\",\"mica\",\"micelio\",\"michele\",\"microbo\",\"midollo\",\"miele\",\"migliore\",\"milano\",\"milite\",\"mimosa\",\"minerale\",\"mini\",\"minore\",\"mirino\",\"mirtillo\",\"miscela\",\"missiva\",\"misto\",\"misurare\",\"mitezza\",\"mitigare\",\"mitra\",\"mittente\",\"mnemonico\",\"modello\",\"modifica\",\"modulo\",\"mogano\",\"mogio\",\"mole\",\"molosso\",\"monastero\",\"monco\",\"mondina\",\"monetario\",\"monile\",\"monotono\",\"monsone\",\"montato\",\"monviso\",\"mora\",\"mordere\",\"morsicato\",\"mostro\",\"motivato\",\"motosega\",\"motto\",\"movenza\",\"movimento\",\"mozzo\",\"mucca\",\"mucosa\",\"muffa\",\"mughetto\",\"mugnaio\",\"mulatto\",\"mulinello\",\"multiplo\",\"mummia\",\"munto\",\"muovere\",\"murale\",\"musa\",\"muscolo\",\"musica\",\"mutevole\",\"muto\",\"nababbo\",\"nafta\",\"nanometro\",\"narciso\",\"narice\",\"narrato\",\"nascere\",\"nastrare\",\"naturale\",\"nautica\",\"naviglio\",\"nebulosa\",\"necrosi\",\"negativo\",\"negozio\",\"nemmeno\",\"neofita\",\"neretto\",\"nervo\",\"nessuno\",\"nettuno\",\"neutrale\",\"neve\",\"nevrotico\",\"nicchia\",\"ninfa\",\"nitido\",\"nobile\",\"nocivo\",\"nodo\",\"nome\",\"nomina\",\"nordico\",\"normale\",\"norvegese\",\"nostrano\",\"notare\",\"notizia\",\"notturno\",\"novella\",\"nucleo\",\"nulla\",\"numero\",\"nuovo\",\"nutrire\",\"nuvola\",\"nuziale\",\"oasi\",\"obbedire\",\"obbligo\",\"obelisco\",\"oblio\",\"obolo\",\"obsoleto\",\"occasione\",\"occhio\",\"occidente\",\"occorrere\",\"occultare\",\"ocra\",\"oculato\",\"odierno\",\"odorare\",\"offerta\",\"offrire\",\"offuscato\",\"oggetto\",\"oggi\",\"ognuno\",\"olandese\",\"olfatto\",\"oliato\",\"oliva\",\"ologramma\",\"oltre\",\"omaggio\",\"ombelico\",\"ombra\",\"omega\",\"omissione\",\"ondoso\",\"onere\",\"onice\",\"onnivoro\",\"onorevole\",\"onta\",\"operato\",\"opinione\",\"opposto\",\"oracolo\",\"orafo\",\"ordine\",\"orecchino\",\"orefice\",\"orfano\",\"organico\",\"origine\",\"orizzonte\",\"orma\",\"ormeggio\",\"ornativo\",\"orologio\",\"orrendo\",\"orribile\",\"ortensia\",\"ortica\",\"orzata\",\"orzo\",\"osare\",\"oscurare\",\"osmosi\",\"ospedale\",\"ospite\",\"ossa\",\"ossidare\",\"ostacolo\",\"oste\",\"otite\",\"otre\",\"ottagono\",\"ottimo\",\"ottobre\",\"ovale\",\"ovest\",\"ovino\",\"oviparo\",\"ovocito\",\"ovunque\",\"ovviare\",\"ozio\",\"pacchetto\",\"pace\",\"pacifico\",\"padella\",\"padrone\",\"paese\",\"paga\",\"pagina\",\"palazzina\",\"palesare\",\"pallido\",\"palo\",\"palude\",\"pandoro\",\"pannello\",\"paolo\",\"paonazzo\",\"paprica\",\"parabola\",\"parcella\",\"parere\",\"pargolo\",\"pari\",\"parlato\",\"parola\",\"partire\",\"parvenza\",\"parziale\",\"passivo\",\"pasticca\",\"patacca\",\"patologia\",\"pattume\",\"pavone\",\"peccato\",\"pedalare\",\"pedonale\",\"peggio\",\"peloso\",\"penare\",\"pendice\",\"penisola\",\"pennuto\",\"penombra\",\"pensare\",\"pentola\",\"pepe\",\"pepita\",\"perbene\",\"percorso\",\"perdonato\",\"perforare\",\"pergamena\",\"periodo\",\"permesso\",\"perno\",\"perplesso\",\"persuaso\",\"pertugio\",\"pervaso\",\"pesatore\",\"pesista\",\"peso\",\"pestifero\",\"petalo\",\"pettine\",\"petulante\",\"pezzo\",\"piacere\",\"pianta\",\"piattino\",\"piccino\",\"picozza\",\"piega\",\"pietra\",\"piffero\",\"pigiama\",\"pigolio\",\"pigro\",\"pila\",\"pilifero\",\"pillola\",\"pilota\",\"pimpante\",\"pineta\",\"pinna\",\"pinolo\",\"pioggia\",\"piombo\",\"piramide\",\"piretico\",\"pirite\",\"pirolisi\",\"pitone\",\"pizzico\",\"placebo\",\"planare\",\"plasma\",\"platano\",\"plenario\",\"pochezza\",\"poderoso\",\"podismo\",\"poesia\",\"poggiare\",\"polenta\",\"poligono\",\"pollice\",\"polmonite\",\"polpetta\",\"polso\",\"poltrona\",\"polvere\",\"pomice\",\"pomodoro\",\"ponte\",\"popoloso\",\"porfido\",\"poroso\",\"porpora\",\"porre\",\"portata\",\"posa\",\"positivo\",\"possesso\",\"postulato\",\"potassio\",\"potere\",\"pranzo\",\"prassi\",\"pratica\",\"precluso\",\"predica\",\"prefisso\",\"pregiato\",\"prelievo\",\"premere\",\"prenotare\",\"preparato\",\"presenza\",\"pretesto\",\"prevalso\",\"prima\",\"principe\",\"privato\",\"problema\",\"procura\",\"produrre\",\"profumo\",\"progetto\",\"prolunga\",\"promessa\",\"pronome\",\"proposta\",\"proroga\",\"proteso\",\"prova\",\"prudente\",\"prugna\",\"prurito\",\"psiche\",\"pubblico\",\"pudica\",\"pugilato\",\"pugno\",\"pulce\",\"pulito\",\"pulsante\",\"puntare\",\"pupazzo\",\"pupilla\",\"puro\",\"quadro\",\"qualcosa\",\"quasi\",\"querela\",\"quota\",\"raccolto\",\"raddoppio\",\"radicale\",\"radunato\",\"raffica\",\"ragazzo\",\"ragione\",\"ragno\",\"ramarro\",\"ramingo\",\"ramo\",\"randagio\",\"rantolare\",\"rapato\",\"rapina\",\"rappreso\",\"rasatura\",\"raschiato\",\"rasente\",\"rassegna\",\"rastrello\",\"rata\",\"ravveduto\",\"reale\",\"recepire\",\"recinto\",\"recluta\",\"recondito\",\"recupero\",\"reddito\",\"redimere\",\"regalato\",\"registro\",\"regola\",\"regresso\",\"relazione\",\"remare\",\"remoto\",\"renna\",\"replica\",\"reprimere\",\"reputare\",\"resa\",\"residente\",\"responso\",\"restauro\",\"rete\",\"retina\",\"retorica\",\"rettifica\",\"revocato\",\"riassunto\",\"ribadire\",\"ribelle\",\"ribrezzo\",\"ricarica\",\"ricco\",\"ricevere\",\"riciclato\",\"ricordo\",\"ricreduto\",\"ridicolo\",\"ridurre\",\"rifasare\",\"riflesso\",\"riforma\",\"rifugio\",\"rigare\",\"rigettato\",\"righello\",\"rilassato\",\"rilevato\",\"rimanere\",\"rimbalzo\",\"rimedio\",\"rimorchio\",\"rinascita\",\"rincaro\",\"rinforzo\",\"rinnovo\",\"rinomato\",\"rinsavito\",\"rintocco\",\"rinuncia\",\"rinvenire\",\"riparato\",\"ripetuto\",\"ripieno\",\"riportare\",\"ripresa\",\"ripulire\",\"risata\",\"rischio\",\"riserva\",\"risibile\",\"riso\",\"rispetto\",\"ristoro\",\"risultato\",\"risvolto\",\"ritardo\",\"ritegno\",\"ritmico\",\"ritrovo\",\"riunione\",\"riva\",\"riverso\",\"rivincita\",\"rivolto\",\"rizoma\",\"roba\",\"robotico\",\"robusto\",\"roccia\",\"roco\",\"rodaggio\",\"rodere\",\"roditore\",\"rogito\",\"rollio\",\"romantico\",\"rompere\",\"ronzio\",\"rosolare\",\"rospo\",\"rotante\",\"rotondo\",\"rotula\",\"rovescio\",\"rubizzo\",\"rubrica\",\"ruga\",\"rullino\",\"rumine\",\"rumoroso\",\"ruolo\",\"rupe\",\"russare\",\"rustico\",\"sabato\",\"sabbiare\",\"sabotato\",\"sagoma\",\"salasso\",\"saldatura\",\"salgemma\",\"salivare\",\"salmone\",\"salone\",\"saltare\",\"saluto\",\"salvo\",\"sapere\",\"sapido\",\"saporito\",\"saraceno\",\"sarcasmo\",\"sarto\",\"sassoso\",\"satellite\",\"satira\",\"satollo\",\"saturno\",\"savana\",\"savio\",\"saziato\",\"sbadiglio\",\"sbalzo\",\"sbancato\",\"sbarra\",\"sbattere\",\"sbavare\",\"sbendare\",\"sbirciare\",\"sbloccato\",\"sbocciato\",\"sbrinare\",\"sbruffone\",\"sbuffare\",\"scabroso\",\"scadenza\",\"scala\",\"scambiare\",\"scandalo\",\"scapola\",\"scarso\",\"scatenare\",\"scavato\",\"scelto\",\"scenico\",\"scettro\",\"scheda\",\"schiena\",\"sciarpa\",\"scienza\",\"scindere\",\"scippo\",\"sciroppo\",\"scivolo\",\"sclerare\",\"scodella\",\"scolpito\",\"scomparto\",\"sconforto\",\"scoprire\",\"scorta\",\"scossone\",\"scozzese\",\"scriba\",\"scrollare\",\"scrutinio\",\"scuderia\",\"scultore\",\"scuola\",\"scuro\",\"scusare\",\"sdebitare\",\"sdoganare\",\"seccatura\",\"secondo\",\"sedano\",\"seggiola\",\"segnalato\",\"segregato\",\"seguito\",\"selciato\",\"selettivo\",\"sella\",\"selvaggio\",\"semaforo\",\"sembrare\",\"seme\",\"seminato\",\"sempre\",\"senso\",\"sentire\",\"sepolto\",\"sequenza\",\"serata\",\"serbato\",\"sereno\",\"serio\",\"serpente\",\"serraglio\",\"servire\",\"sestina\",\"setola\",\"settimana\",\"sfacelo\",\"sfaldare\",\"sfamato\",\"sfarzoso\",\"sfaticato\",\"sfera\",\"sfida\",\"sfilato\",\"sfinge\",\"sfocato\",\"sfoderare\",\"sfogo\",\"sfoltire\",\"sforzato\",\"sfratto\",\"sfruttato\",\"sfuggito\",\"sfumare\",\"sfuso\",\"sgabello\",\"sgarbato\",\"sgonfiare\",\"sgorbio\",\"sgrassato\",\"sguardo\",\"sibilo\",\"siccome\",\"sierra\",\"sigla\",\"signore\",\"silenzio\",\"sillaba\",\"simbolo\",\"simpatico\",\"simulato\",\"sinfonia\",\"singolo\",\"sinistro\",\"sino\",\"sintesi\",\"sinusoide\",\"sipario\",\"sisma\",\"sistole\",\"situato\",\"slitta\",\"slogatura\",\"sloveno\",\"smarrito\",\"smemorato\",\"smentito\",\"smeraldo\",\"smilzo\",\"smontare\",\"smottato\",\"smussato\",\"snellire\",\"snervato\",\"snodo\",\"sobbalzo\",\"sobrio\",\"soccorso\",\"sociale\",\"sodale\",\"soffitto\",\"sogno\",\"soldato\",\"solenne\",\"solido\",\"sollazzo\",\"solo\",\"solubile\",\"solvente\",\"somatico\",\"somma\",\"sonda\",\"sonetto\",\"sonnifero\",\"sopire\",\"soppeso\",\"sopra\",\"sorgere\",\"sorpasso\",\"sorriso\",\"sorso\",\"sorteggio\",\"sorvolato\",\"sospiro\",\"sosta\",\"sottile\",\"spada\",\"spalla\",\"spargere\",\"spatola\",\"spavento\",\"spazzola\",\"specie\",\"spedire\",\"spegnere\",\"spelatura\",\"speranza\",\"spessore\",\"spettrale\",\"spezzato\",\"spia\",\"spigoloso\",\"spillato\",\"spinoso\",\"spirale\",\"splendido\",\"sportivo\",\"sposo\",\"spranga\",\"sprecare\",\"spronato\",\"spruzzo\",\"spuntino\",\"squillo\",\"sradicare\",\"srotolato\",\"stabile\",\"stacco\",\"staffa\",\"stagnare\",\"stampato\",\"stantio\",\"starnuto\",\"stasera\",\"statuto\",\"stelo\",\"steppa\",\"sterzo\",\"stiletto\",\"stima\",\"stirpe\",\"stivale\",\"stizzoso\",\"stonato\",\"storico\",\"strappo\",\"stregato\",\"stridulo\",\"strozzare\",\"strutto\",\"stuccare\",\"stufo\",\"stupendo\",\"subentro\",\"succoso\",\"sudore\",\"suggerito\",\"sugo\",\"sultano\",\"suonare\",\"superbo\",\"supporto\",\"surgelato\",\"surrogato\",\"sussurro\",\"sutura\",\"svagare\",\"svedese\",\"sveglio\",\"svelare\",\"svenuto\",\"svezia\",\"sviluppo\",\"svista\",\"svizzera\",\"svolta\",\"svuotare\",\"tabacco\",\"tabulato\",\"tacciare\",\"taciturno\",\"tale\",\"talismano\",\"tampone\",\"tannino\",\"tara\",\"tardivo\",\"targato\",\"tariffa\",\"tarpare\",\"tartaruga\",\"tasto\",\"tattico\",\"taverna\",\"tavolata\",\"tazza\",\"teca\",\"tecnico\",\"telefono\",\"temerario\",\"tempo\",\"temuto\",\"tendone\",\"tenero\",\"tensione\",\"tentacolo\",\"teorema\",\"terme\",\"terrazzo\",\"terzetto\",\"tesi\",\"tesserato\",\"testato\",\"tetro\",\"tettoia\",\"tifare\",\"tigella\",\"timbro\",\"tinto\",\"tipico\",\"tipografo\",\"tiraggio\",\"tiro\",\"titanio\",\"titolo\",\"titubante\",\"tizio\",\"tizzone\",\"toccare\",\"tollerare\",\"tolto\",\"tombola\",\"tomo\",\"tonfo\",\"tonsilla\",\"topazio\",\"topologia\",\"toppa\",\"torba\",\"tornare\",\"torrone\",\"tortora\",\"toscano\",\"tossire\",\"tostatura\",\"totano\",\"trabocco\",\"trachea\",\"trafila\",\"tragedia\",\"tralcio\",\"tramonto\",\"transito\",\"trapano\",\"trarre\",\"trasloco\",\"trattato\",\"trave\",\"treccia\",\"tremolio\",\"trespolo\",\"tributo\",\"tricheco\",\"trifoglio\",\"trillo\",\"trincea\",\"trio\",\"tristezza\",\"triturato\",\"trivella\",\"tromba\",\"trono\",\"troppo\",\"trottola\",\"trovare\",\"truccato\",\"tubatura\",\"tuffato\",\"tulipano\",\"tumulto\",\"tunisia\",\"turbare\",\"turchino\",\"tuta\",\"tutela\",\"ubicato\",\"uccello\",\"uccisore\",\"udire\",\"uditivo\",\"uffa\",\"ufficio\",\"uguale\",\"ulisse\",\"ultimato\",\"umano\",\"umile\",\"umorismo\",\"uncinetto\",\"ungere\",\"ungherese\",\"unicorno\",\"unificato\",\"unisono\",\"unitario\",\"unte\",\"uovo\",\"upupa\",\"uragano\",\"urgenza\",\"urlo\",\"usanza\",\"usato\",\"uscito\",\"usignolo\",\"usuraio\",\"utensile\",\"utilizzo\",\"utopia\",\"vacante\",\"vaccinato\",\"vagabondo\",\"vagliato\",\"valanga\",\"valgo\",\"valico\",\"valletta\",\"valoroso\",\"valutare\",\"valvola\",\"vampata\",\"vangare\",\"vanitoso\",\"vano\",\"vantaggio\",\"vanvera\",\"vapore\",\"varano\",\"varcato\",\"variante\",\"vasca\",\"vedetta\",\"vedova\",\"veduto\",\"vegetale\",\"veicolo\",\"velcro\",\"velina\",\"velluto\",\"veloce\",\"venato\",\"vendemmia\",\"vento\",\"verace\",\"verbale\",\"vergogna\",\"verifica\",\"vero\",\"verruca\",\"verticale\",\"vescica\",\"vessillo\",\"vestale\",\"veterano\",\"vetrina\",\"vetusto\",\"viandante\",\"vibrante\",\"vicenda\",\"vichingo\",\"vicinanza\",\"vidimare\",\"vigilia\",\"vigneto\",\"vigore\",\"vile\",\"villano\",\"vimini\",\"vincitore\",\"viola\",\"vipera\",\"virgola\",\"virologo\",\"virulento\",\"viscoso\",\"visione\",\"vispo\",\"vissuto\",\"visura\",\"vita\",\"vitello\",\"vittima\",\"vivanda\",\"vivido\",\"viziare\",\"voce\",\"voga\",\"volatile\",\"volere\",\"volpe\",\"voragine\",\"vulcano\",\"zampogna\",\"zanna\",\"zappato\",\"zattera\",\"zavorra\",\"zefiro\",\"zelante\",\"zelo\",\"zenzero\",\"zerbino\",\"zibetto\",\"zinco\",\"zircone\",\"zitto\",\"zolla\",\"zotico\",\"zucchero\",\"zufolo\",\"zulu\",\"zuppa\"]");

});

parcelRegister("911oV", function(module, exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRegister("lW32h", function(module, exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

});

parcelRegister("g6Pks", function(module, exports) {
module.exports = JSON.parse("[\"abacate\",\"abaixo\",\"abalar\",\"abater\",\"abduzir\",\"abelha\",\"aberto\",\"abismo\",\"abotoar\",\"abranger\",\"abreviar\",\"abrigar\",\"abrupto\",\"absinto\",\"absoluto\",\"absurdo\",\"abutre\",\"acabado\",\"acalmar\",\"acampar\",\"acanhar\",\"acaso\",\"aceitar\",\"acelerar\",\"acenar\",\"acervo\",\"acessar\",\"acetona\",\"achatar\",\"acidez\",\"acima\",\"acionado\",\"acirrar\",\"aclamar\",\"aclive\",\"acolhida\",\"acomodar\",\"acoplar\",\"acordar\",\"acumular\",\"acusador\",\"adaptar\",\"adega\",\"adentro\",\"adepto\",\"adequar\",\"aderente\",\"adesivo\",\"adeus\",\"adiante\",\"aditivo\",\"adjetivo\",\"adjunto\",\"admirar\",\"adorar\",\"adquirir\",\"adubo\",\"adverso\",\"advogado\",\"aeronave\",\"afastar\",\"aferir\",\"afetivo\",\"afinador\",\"afivelar\",\"aflito\",\"afluente\",\"afrontar\",\"agachar\",\"agarrar\",\"agasalho\",\"agenciar\",\"agilizar\",\"agiota\",\"agitado\",\"agora\",\"agradar\",\"agreste\",\"agrupar\",\"aguardar\",\"agulha\",\"ajoelhar\",\"ajudar\",\"ajustar\",\"alameda\",\"alarme\",\"alastrar\",\"alavanca\",\"albergue\",\"albino\",\"alcatra\",\"aldeia\",\"alecrim\",\"alegria\",\"alertar\",\"alface\",\"alfinete\",\"algum\",\"alheio\",\"aliar\",\"alicate\",\"alienar\",\"alinhar\",\"aliviar\",\"almofada\",\"alocar\",\"alpiste\",\"alterar\",\"altitude\",\"alucinar\",\"alugar\",\"aluno\",\"alusivo\",\"alvo\",\"amaciar\",\"amador\",\"amarelo\",\"amassar\",\"ambas\",\"ambiente\",\"ameixa\",\"amenizar\",\"amido\",\"amistoso\",\"amizade\",\"amolador\",\"amontoar\",\"amoroso\",\"amostra\",\"amparar\",\"ampliar\",\"ampola\",\"anagrama\",\"analisar\",\"anarquia\",\"anatomia\",\"andaime\",\"anel\",\"anexo\",\"angular\",\"animar\",\"anjo\",\"anomalia\",\"anotado\",\"ansioso\",\"anterior\",\"anuidade\",\"anunciar\",\"anzol\",\"apagador\",\"apalpar\",\"apanhado\",\"apego\",\"apelido\",\"apertada\",\"apesar\",\"apetite\",\"apito\",\"aplauso\",\"aplicada\",\"apoio\",\"apontar\",\"aposta\",\"aprendiz\",\"aprovar\",\"aquecer\",\"arame\",\"aranha\",\"arara\",\"arcada\",\"ardente\",\"areia\",\"arejar\",\"arenito\",\"aresta\",\"argiloso\",\"argola\",\"arma\",\"arquivo\",\"arraial\",\"arrebate\",\"arriscar\",\"arroba\",\"arrumar\",\"arsenal\",\"arterial\",\"artigo\",\"arvoredo\",\"asfaltar\",\"asilado\",\"aspirar\",\"assador\",\"assinar\",\"assoalho\",\"assunto\",\"astral\",\"atacado\",\"atadura\",\"atalho\",\"atarefar\",\"atear\",\"atender\",\"aterro\",\"ateu\",\"atingir\",\"atirador\",\"ativo\",\"atoleiro\",\"atracar\",\"atrevido\",\"atriz\",\"atual\",\"atum\",\"auditor\",\"aumentar\",\"aura\",\"aurora\",\"autismo\",\"autoria\",\"autuar\",\"avaliar\",\"avante\",\"avaria\",\"avental\",\"avesso\",\"aviador\",\"avisar\",\"avulso\",\"axila\",\"azarar\",\"azedo\",\"azeite\",\"azulejo\",\"babar\",\"babosa\",\"bacalhau\",\"bacharel\",\"bacia\",\"bagagem\",\"baiano\",\"bailar\",\"baioneta\",\"bairro\",\"baixista\",\"bajular\",\"baleia\",\"baliza\",\"balsa\",\"banal\",\"bandeira\",\"banho\",\"banir\",\"banquete\",\"barato\",\"barbado\",\"baronesa\",\"barraca\",\"barulho\",\"baseado\",\"bastante\",\"batata\",\"batedor\",\"batida\",\"batom\",\"batucar\",\"baunilha\",\"beber\",\"beijo\",\"beirada\",\"beisebol\",\"beldade\",\"beleza\",\"belga\",\"beliscar\",\"bendito\",\"bengala\",\"benzer\",\"berimbau\",\"berlinda\",\"berro\",\"besouro\",\"bexiga\",\"bezerro\",\"bico\",\"bicudo\",\"bienal\",\"bifocal\",\"bifurcar\",\"bigorna\",\"bilhete\",\"bimestre\",\"bimotor\",\"biologia\",\"biombo\",\"biosfera\",\"bipolar\",\"birrento\",\"biscoito\",\"bisneto\",\"bispo\",\"bissexto\",\"bitola\",\"bizarro\",\"blindado\",\"bloco\",\"bloquear\",\"boato\",\"bobagem\",\"bocado\",\"bocejo\",\"bochecha\",\"boicotar\",\"bolada\",\"boletim\",\"bolha\",\"bolo\",\"bombeiro\",\"bonde\",\"boneco\",\"bonita\",\"borbulha\",\"borda\",\"boreal\",\"borracha\",\"bovino\",\"boxeador\",\"branco\",\"brasa\",\"braveza\",\"breu\",\"briga\",\"brilho\",\"brincar\",\"broa\",\"brochura\",\"bronzear\",\"broto\",\"bruxo\",\"bucha\",\"budismo\",\"bufar\",\"bule\",\"buraco\",\"busca\",\"busto\",\"buzina\",\"cabana\",\"cabelo\",\"cabide\",\"cabo\",\"cabrito\",\"cacau\",\"cacetada\",\"cachorro\",\"cacique\",\"cadastro\",\"cadeado\",\"cafezal\",\"caiaque\",\"caipira\",\"caixote\",\"cajado\",\"caju\",\"calafrio\",\"calcular\",\"caldeira\",\"calibrar\",\"calmante\",\"calota\",\"camada\",\"cambista\",\"camisa\",\"camomila\",\"campanha\",\"camuflar\",\"canavial\",\"cancelar\",\"caneta\",\"canguru\",\"canhoto\",\"canivete\",\"canoa\",\"cansado\",\"cantar\",\"canudo\",\"capacho\",\"capela\",\"capinar\",\"capotar\",\"capricho\",\"captador\",\"capuz\",\"caracol\",\"carbono\",\"cardeal\",\"careca\",\"carimbar\",\"carneiro\",\"carpete\",\"carreira\",\"cartaz\",\"carvalho\",\"casaco\",\"casca\",\"casebre\",\"castelo\",\"casulo\",\"catarata\",\"cativar\",\"caule\",\"causador\",\"cautelar\",\"cavalo\",\"caverna\",\"cebola\",\"cedilha\",\"cegonha\",\"celebrar\",\"celular\",\"cenoura\",\"censo\",\"centeio\",\"cercar\",\"cerrado\",\"certeiro\",\"cerveja\",\"cetim\",\"cevada\",\"chacota\",\"chaleira\",\"chamado\",\"chapada\",\"charme\",\"chatice\",\"chave\",\"chefe\",\"chegada\",\"cheiro\",\"cheque\",\"chicote\",\"chifre\",\"chinelo\",\"chocalho\",\"chover\",\"chumbo\",\"chutar\",\"chuva\",\"cicatriz\",\"ciclone\",\"cidade\",\"cidreira\",\"ciente\",\"cigana\",\"cimento\",\"cinto\",\"cinza\",\"ciranda\",\"circuito\",\"cirurgia\",\"citar\",\"clareza\",\"clero\",\"clicar\",\"clone\",\"clube\",\"coado\",\"coagir\",\"cobaia\",\"cobertor\",\"cobrar\",\"cocada\",\"coelho\",\"coentro\",\"coeso\",\"cogumelo\",\"coibir\",\"coifa\",\"coiote\",\"colar\",\"coleira\",\"colher\",\"colidir\",\"colmeia\",\"colono\",\"coluna\",\"comando\",\"combinar\",\"comentar\",\"comitiva\",\"comover\",\"complexo\",\"comum\",\"concha\",\"condor\",\"conectar\",\"confuso\",\"congelar\",\"conhecer\",\"conjugar\",\"consumir\",\"contrato\",\"convite\",\"cooperar\",\"copeiro\",\"copiador\",\"copo\",\"coquetel\",\"coragem\",\"cordial\",\"corneta\",\"coronha\",\"corporal\",\"correio\",\"cortejo\",\"coruja\",\"corvo\",\"cosseno\",\"costela\",\"cotonete\",\"couro\",\"couve\",\"covil\",\"cozinha\",\"cratera\",\"cravo\",\"creche\",\"credor\",\"creme\",\"crer\",\"crespo\",\"criada\",\"criminal\",\"crioulo\",\"crise\",\"criticar\",\"crosta\",\"crua\",\"cruzeiro\",\"cubano\",\"cueca\",\"cuidado\",\"cujo\",\"culatra\",\"culminar\",\"culpar\",\"cultura\",\"cumprir\",\"cunhado\",\"cupido\",\"curativo\",\"curral\",\"cursar\",\"curto\",\"cuspir\",\"custear\",\"cutelo\",\"damasco\",\"datar\",\"debater\",\"debitar\",\"deboche\",\"debulhar\",\"decalque\",\"decimal\",\"declive\",\"decote\",\"decretar\",\"dedal\",\"dedicado\",\"deduzir\",\"defesa\",\"defumar\",\"degelo\",\"degrau\",\"degustar\",\"deitado\",\"deixar\",\"delator\",\"delegado\",\"delinear\",\"delonga\",\"demanda\",\"demitir\",\"demolido\",\"dentista\",\"depenado\",\"depilar\",\"depois\",\"depressa\",\"depurar\",\"deriva\",\"derramar\",\"desafio\",\"desbotar\",\"descanso\",\"desenho\",\"desfiado\",\"desgaste\",\"desigual\",\"deslize\",\"desmamar\",\"desova\",\"despesa\",\"destaque\",\"desviar\",\"detalhar\",\"detentor\",\"detonar\",\"detrito\",\"deusa\",\"dever\",\"devido\",\"devotado\",\"dezena\",\"diagrama\",\"dialeto\",\"didata\",\"difuso\",\"digitar\",\"dilatado\",\"diluente\",\"diminuir\",\"dinastia\",\"dinheiro\",\"diocese\",\"direto\",\"discreta\",\"disfarce\",\"disparo\",\"disquete\",\"dissipar\",\"distante\",\"ditador\",\"diurno\",\"diverso\",\"divisor\",\"divulgar\",\"dizer\",\"dobrador\",\"dolorido\",\"domador\",\"dominado\",\"donativo\",\"donzela\",\"dormente\",\"dorsal\",\"dosagem\",\"dourado\",\"doutor\",\"drenagem\",\"drible\",\"drogaria\",\"duelar\",\"duende\",\"dueto\",\"duplo\",\"duquesa\",\"durante\",\"duvidoso\",\"eclodir\",\"ecoar\",\"ecologia\",\"edificar\",\"edital\",\"educado\",\"efeito\",\"efetivar\",\"ejetar\",\"elaborar\",\"eleger\",\"eleitor\",\"elenco\",\"elevador\",\"eliminar\",\"elogiar\",\"embargo\",\"embolado\",\"embrulho\",\"embutido\",\"emenda\",\"emergir\",\"emissor\",\"empatia\",\"empenho\",\"empinado\",\"empolgar\",\"emprego\",\"empurrar\",\"emulador\",\"encaixe\",\"encenado\",\"enchente\",\"encontro\",\"endeusar\",\"endossar\",\"enfaixar\",\"enfeite\",\"enfim\",\"engajado\",\"engenho\",\"englobar\",\"engomado\",\"engraxar\",\"enguia\",\"enjoar\",\"enlatar\",\"enquanto\",\"enraizar\",\"enrolado\",\"enrugar\",\"ensaio\",\"enseada\",\"ensino\",\"ensopado\",\"entanto\",\"enteado\",\"entidade\",\"entortar\",\"entrada\",\"entulho\",\"envergar\",\"enviado\",\"envolver\",\"enxame\",\"enxerto\",\"enxofre\",\"enxuto\",\"epiderme\",\"equipar\",\"ereto\",\"erguido\",\"errata\",\"erva\",\"ervilha\",\"esbanjar\",\"esbelto\",\"escama\",\"escola\",\"escrita\",\"escuta\",\"esfinge\",\"esfolar\",\"esfregar\",\"esfumado\",\"esgrima\",\"esmalte\",\"espanto\",\"espelho\",\"espiga\",\"esponja\",\"espreita\",\"espumar\",\"esquerda\",\"estaca\",\"esteira\",\"esticar\",\"estofado\",\"estrela\",\"estudo\",\"esvaziar\",\"etanol\",\"etiqueta\",\"euforia\",\"europeu\",\"evacuar\",\"evaporar\",\"evasivo\",\"eventual\",\"evidente\",\"evoluir\",\"exagero\",\"exalar\",\"examinar\",\"exato\",\"exausto\",\"excesso\",\"excitar\",\"exclamar\",\"executar\",\"exemplo\",\"exibir\",\"exigente\",\"exonerar\",\"expandir\",\"expelir\",\"expirar\",\"explanar\",\"exposto\",\"expresso\",\"expulsar\",\"externo\",\"extinto\",\"extrato\",\"fabricar\",\"fabuloso\",\"faceta\",\"facial\",\"fada\",\"fadiga\",\"faixa\",\"falar\",\"falta\",\"familiar\",\"fandango\",\"fanfarra\",\"fantoche\",\"fardado\",\"farelo\",\"farinha\",\"farofa\",\"farpa\",\"fartura\",\"fatia\",\"fator\",\"favorita\",\"faxina\",\"fazenda\",\"fechado\",\"feijoada\",\"feirante\",\"felino\",\"feminino\",\"fenda\",\"feno\",\"fera\",\"feriado\",\"ferrugem\",\"ferver\",\"festejar\",\"fetal\",\"feudal\",\"fiapo\",\"fibrose\",\"ficar\",\"ficheiro\",\"figurado\",\"fileira\",\"filho\",\"filme\",\"filtrar\",\"firmeza\",\"fisgada\",\"fissura\",\"fita\",\"fivela\",\"fixador\",\"fixo\",\"flacidez\",\"flamingo\",\"flanela\",\"flechada\",\"flora\",\"flutuar\",\"fluxo\",\"focal\",\"focinho\",\"fofocar\",\"fogo\",\"foguete\",\"foice\",\"folgado\",\"folheto\",\"forjar\",\"formiga\",\"forno\",\"forte\",\"fosco\",\"fossa\",\"fragata\",\"fralda\",\"frango\",\"frasco\",\"fraterno\",\"freira\",\"frente\",\"fretar\",\"frieza\",\"friso\",\"fritura\",\"fronha\",\"frustrar\",\"fruteira\",\"fugir\",\"fulano\",\"fuligem\",\"fundar\",\"fungo\",\"funil\",\"furador\",\"furioso\",\"futebol\",\"gabarito\",\"gabinete\",\"gado\",\"gaiato\",\"gaiola\",\"gaivota\",\"galega\",\"galho\",\"galinha\",\"galocha\",\"ganhar\",\"garagem\",\"garfo\",\"gargalo\",\"garimpo\",\"garoupa\",\"garrafa\",\"gasoduto\",\"gasto\",\"gata\",\"gatilho\",\"gaveta\",\"gazela\",\"gelado\",\"geleia\",\"gelo\",\"gemada\",\"gemer\",\"gemido\",\"generoso\",\"gengiva\",\"genial\",\"genoma\",\"genro\",\"geologia\",\"gerador\",\"germinar\",\"gesso\",\"gestor\",\"ginasta\",\"gincana\",\"gingado\",\"girafa\",\"girino\",\"glacial\",\"glicose\",\"global\",\"glorioso\",\"goela\",\"goiaba\",\"golfe\",\"golpear\",\"gordura\",\"gorjeta\",\"gorro\",\"gostoso\",\"goteira\",\"governar\",\"gracejo\",\"gradual\",\"grafite\",\"gralha\",\"grampo\",\"granada\",\"gratuito\",\"graveto\",\"graxa\",\"grego\",\"grelhar\",\"greve\",\"grilo\",\"grisalho\",\"gritaria\",\"grosso\",\"grotesco\",\"grudado\",\"grunhido\",\"gruta\",\"guache\",\"guarani\",\"guaxinim\",\"guerrear\",\"guiar\",\"guincho\",\"guisado\",\"gula\",\"guloso\",\"guru\",\"habitar\",\"harmonia\",\"haste\",\"haver\",\"hectare\",\"herdar\",\"heresia\",\"hesitar\",\"hiato\",\"hibernar\",\"hidratar\",\"hiena\",\"hino\",\"hipismo\",\"hipnose\",\"hipoteca\",\"hoje\",\"holofote\",\"homem\",\"honesto\",\"honrado\",\"hormonal\",\"hospedar\",\"humorado\",\"iate\",\"ideia\",\"idoso\",\"ignorado\",\"igreja\",\"iguana\",\"ileso\",\"ilha\",\"iludido\",\"iluminar\",\"ilustrar\",\"imagem\",\"imediato\",\"imenso\",\"imersivo\",\"iminente\",\"imitador\",\"imortal\",\"impacto\",\"impedir\",\"implante\",\"impor\",\"imprensa\",\"impune\",\"imunizar\",\"inalador\",\"inapto\",\"inativo\",\"incenso\",\"inchar\",\"incidir\",\"incluir\",\"incolor\",\"indeciso\",\"indireto\",\"indutor\",\"ineficaz\",\"inerente\",\"infantil\",\"infestar\",\"infinito\",\"inflamar\",\"informal\",\"infrator\",\"ingerir\",\"inibido\",\"inicial\",\"inimigo\",\"injetar\",\"inocente\",\"inodoro\",\"inovador\",\"inox\",\"inquieto\",\"inscrito\",\"inseto\",\"insistir\",\"inspetor\",\"instalar\",\"insulto\",\"intacto\",\"integral\",\"intimar\",\"intocado\",\"intriga\",\"invasor\",\"inverno\",\"invicto\",\"invocar\",\"iogurte\",\"iraniano\",\"ironizar\",\"irreal\",\"irritado\",\"isca\",\"isento\",\"isolado\",\"isqueiro\",\"italiano\",\"janeiro\",\"jangada\",\"janta\",\"jararaca\",\"jardim\",\"jarro\",\"jasmim\",\"jato\",\"javali\",\"jazida\",\"jejum\",\"joaninha\",\"joelhada\",\"jogador\",\"joia\",\"jornal\",\"jorrar\",\"jovem\",\"juba\",\"judeu\",\"judoca\",\"juiz\",\"julgador\",\"julho\",\"jurado\",\"jurista\",\"juro\",\"justa\",\"labareda\",\"laboral\",\"lacre\",\"lactante\",\"ladrilho\",\"lagarta\",\"lagoa\",\"laje\",\"lamber\",\"lamentar\",\"laminar\",\"lampejo\",\"lanche\",\"lapidar\",\"lapso\",\"laranja\",\"lareira\",\"largura\",\"lasanha\",\"lastro\",\"lateral\",\"latido\",\"lavanda\",\"lavoura\",\"lavrador\",\"laxante\",\"lazer\",\"lealdade\",\"lebre\",\"legado\",\"legendar\",\"legista\",\"leigo\",\"leiloar\",\"leitura\",\"lembrete\",\"leme\",\"lenhador\",\"lentilha\",\"leoa\",\"lesma\",\"leste\",\"letivo\",\"letreiro\",\"levar\",\"leveza\",\"levitar\",\"liberal\",\"libido\",\"liderar\",\"ligar\",\"ligeiro\",\"limitar\",\"limoeiro\",\"limpador\",\"linda\",\"linear\",\"linhagem\",\"liquidez\",\"listagem\",\"lisura\",\"litoral\",\"livro\",\"lixa\",\"lixeira\",\"locador\",\"locutor\",\"lojista\",\"lombo\",\"lona\",\"longe\",\"lontra\",\"lorde\",\"lotado\",\"loteria\",\"loucura\",\"lousa\",\"louvar\",\"luar\",\"lucidez\",\"lucro\",\"luneta\",\"lustre\",\"lutador\",\"luva\",\"macaco\",\"macete\",\"machado\",\"macio\",\"madeira\",\"madrinha\",\"magnata\",\"magreza\",\"maior\",\"mais\",\"malandro\",\"malha\",\"malote\",\"maluco\",\"mamilo\",\"mamoeiro\",\"mamute\",\"manada\",\"mancha\",\"mandato\",\"manequim\",\"manhoso\",\"manivela\",\"manobrar\",\"mansa\",\"manter\",\"manusear\",\"mapeado\",\"maquinar\",\"marcador\",\"maresia\",\"marfim\",\"margem\",\"marinho\",\"marmita\",\"maroto\",\"marquise\",\"marreco\",\"martelo\",\"marujo\",\"mascote\",\"masmorra\",\"massagem\",\"mastigar\",\"matagal\",\"materno\",\"matinal\",\"matutar\",\"maxilar\",\"medalha\",\"medida\",\"medusa\",\"megafone\",\"meiga\",\"melancia\",\"melhor\",\"membro\",\"memorial\",\"menino\",\"menos\",\"mensagem\",\"mental\",\"merecer\",\"mergulho\",\"mesada\",\"mesclar\",\"mesmo\",\"mesquita\",\"mestre\",\"metade\",\"meteoro\",\"metragem\",\"mexer\",\"mexicano\",\"micro\",\"migalha\",\"migrar\",\"milagre\",\"milenar\",\"milhar\",\"mimado\",\"minerar\",\"minhoca\",\"ministro\",\"minoria\",\"miolo\",\"mirante\",\"mirtilo\",\"misturar\",\"mocidade\",\"moderno\",\"modular\",\"moeda\",\"moer\",\"moinho\",\"moita\",\"moldura\",\"moleza\",\"molho\",\"molinete\",\"molusco\",\"montanha\",\"moqueca\",\"morango\",\"morcego\",\"mordomo\",\"morena\",\"mosaico\",\"mosquete\",\"mostarda\",\"motel\",\"motim\",\"moto\",\"motriz\",\"muda\",\"muito\",\"mulata\",\"mulher\",\"multar\",\"mundial\",\"munido\",\"muralha\",\"murcho\",\"muscular\",\"museu\",\"musical\",\"nacional\",\"nadador\",\"naja\",\"namoro\",\"narina\",\"narrado\",\"nascer\",\"nativa\",\"natureza\",\"navalha\",\"navegar\",\"navio\",\"neblina\",\"nebuloso\",\"negativa\",\"negociar\",\"negrito\",\"nervoso\",\"neta\",\"neural\",\"nevasca\",\"nevoeiro\",\"ninar\",\"ninho\",\"nitidez\",\"nivelar\",\"nobreza\",\"noite\",\"noiva\",\"nomear\",\"nominal\",\"nordeste\",\"nortear\",\"notar\",\"noticiar\",\"noturno\",\"novelo\",\"novilho\",\"novo\",\"nublado\",\"nudez\",\"numeral\",\"nupcial\",\"nutrir\",\"nuvem\",\"obcecado\",\"obedecer\",\"objetivo\",\"obrigado\",\"obscuro\",\"obstetra\",\"obter\",\"obturar\",\"ocidente\",\"ocioso\",\"ocorrer\",\"oculista\",\"ocupado\",\"ofegante\",\"ofensiva\",\"oferenda\",\"oficina\",\"ofuscado\",\"ogiva\",\"olaria\",\"oleoso\",\"olhar\",\"oliveira\",\"ombro\",\"omelete\",\"omisso\",\"omitir\",\"ondulado\",\"oneroso\",\"ontem\",\"opcional\",\"operador\",\"oponente\",\"oportuno\",\"oposto\",\"orar\",\"orbitar\",\"ordem\",\"ordinal\",\"orfanato\",\"orgasmo\",\"orgulho\",\"oriental\",\"origem\",\"oriundo\",\"orla\",\"ortodoxo\",\"orvalho\",\"oscilar\",\"ossada\",\"osso\",\"ostentar\",\"otimismo\",\"ousadia\",\"outono\",\"outubro\",\"ouvido\",\"ovelha\",\"ovular\",\"oxidar\",\"oxigenar\",\"pacato\",\"paciente\",\"pacote\",\"pactuar\",\"padaria\",\"padrinho\",\"pagar\",\"pagode\",\"painel\",\"pairar\",\"paisagem\",\"palavra\",\"palestra\",\"palheta\",\"palito\",\"palmada\",\"palpitar\",\"pancada\",\"panela\",\"panfleto\",\"panqueca\",\"pantanal\",\"papagaio\",\"papelada\",\"papiro\",\"parafina\",\"parcial\",\"pardal\",\"parede\",\"partida\",\"pasmo\",\"passado\",\"pastel\",\"patamar\",\"patente\",\"patinar\",\"patrono\",\"paulada\",\"pausar\",\"peculiar\",\"pedalar\",\"pedestre\",\"pediatra\",\"pedra\",\"pegada\",\"peitoral\",\"peixe\",\"pele\",\"pelicano\",\"penca\",\"pendurar\",\"peneira\",\"penhasco\",\"pensador\",\"pente\",\"perceber\",\"perfeito\",\"pergunta\",\"perito\",\"permitir\",\"perna\",\"perplexo\",\"persiana\",\"pertence\",\"peruca\",\"pescado\",\"pesquisa\",\"pessoa\",\"petiscar\",\"piada\",\"picado\",\"piedade\",\"pigmento\",\"pilastra\",\"pilhado\",\"pilotar\",\"pimenta\",\"pincel\",\"pinguim\",\"pinha\",\"pinote\",\"pintar\",\"pioneiro\",\"pipoca\",\"piquete\",\"piranha\",\"pires\",\"pirueta\",\"piscar\",\"pistola\",\"pitanga\",\"pivete\",\"planta\",\"plaqueta\",\"platina\",\"plebeu\",\"plumagem\",\"pluvial\",\"pneu\",\"poda\",\"poeira\",\"poetisa\",\"polegada\",\"policiar\",\"poluente\",\"polvilho\",\"pomar\",\"pomba\",\"ponderar\",\"pontaria\",\"populoso\",\"porta\",\"possuir\",\"postal\",\"pote\",\"poupar\",\"pouso\",\"povoar\",\"praia\",\"prancha\",\"prato\",\"praxe\",\"prece\",\"predador\",\"prefeito\",\"premiar\",\"prensar\",\"preparar\",\"presilha\",\"pretexto\",\"prevenir\",\"prezar\",\"primata\",\"princesa\",\"prisma\",\"privado\",\"processo\",\"produto\",\"profeta\",\"proibido\",\"projeto\",\"prometer\",\"propagar\",\"prosa\",\"protetor\",\"provador\",\"publicar\",\"pudim\",\"pular\",\"pulmonar\",\"pulseira\",\"punhal\",\"punir\",\"pupilo\",\"pureza\",\"puxador\",\"quadra\",\"quantia\",\"quarto\",\"quase\",\"quebrar\",\"queda\",\"queijo\",\"quente\",\"querido\",\"quimono\",\"quina\",\"quiosque\",\"rabanada\",\"rabisco\",\"rachar\",\"racionar\",\"radial\",\"raiar\",\"rainha\",\"raio\",\"raiva\",\"rajada\",\"ralado\",\"ramal\",\"ranger\",\"ranhura\",\"rapadura\",\"rapel\",\"rapidez\",\"raposa\",\"raquete\",\"raridade\",\"rasante\",\"rascunho\",\"rasgar\",\"raspador\",\"rasteira\",\"rasurar\",\"ratazana\",\"ratoeira\",\"realeza\",\"reanimar\",\"reaver\",\"rebaixar\",\"rebelde\",\"rebolar\",\"recado\",\"recente\",\"recheio\",\"recibo\",\"recordar\",\"recrutar\",\"recuar\",\"rede\",\"redimir\",\"redonda\",\"reduzida\",\"reenvio\",\"refinar\",\"refletir\",\"refogar\",\"refresco\",\"refugiar\",\"regalia\",\"regime\",\"regra\",\"reinado\",\"reitor\",\"rejeitar\",\"relativo\",\"remador\",\"remendo\",\"remorso\",\"renovado\",\"reparo\",\"repelir\",\"repleto\",\"repolho\",\"represa\",\"repudiar\",\"requerer\",\"resenha\",\"resfriar\",\"resgatar\",\"residir\",\"resolver\",\"respeito\",\"ressaca\",\"restante\",\"resumir\",\"retalho\",\"reter\",\"retirar\",\"retomada\",\"retratar\",\"revelar\",\"revisor\",\"revolta\",\"riacho\",\"rica\",\"rigidez\",\"rigoroso\",\"rimar\",\"ringue\",\"risada\",\"risco\",\"risonho\",\"robalo\",\"rochedo\",\"rodada\",\"rodeio\",\"rodovia\",\"roedor\",\"roleta\",\"romano\",\"roncar\",\"rosado\",\"roseira\",\"rosto\",\"rota\",\"roteiro\",\"rotina\",\"rotular\",\"rouco\",\"roupa\",\"roxo\",\"rubro\",\"rugido\",\"rugoso\",\"ruivo\",\"rumo\",\"rupestre\",\"russo\",\"sabor\",\"saciar\",\"sacola\",\"sacudir\",\"sadio\",\"safira\",\"saga\",\"sagrada\",\"saibro\",\"salada\",\"saleiro\",\"salgado\",\"saliva\",\"salpicar\",\"salsicha\",\"saltar\",\"salvador\",\"sambar\",\"samurai\",\"sanar\",\"sanfona\",\"sangue\",\"sanidade\",\"sapato\",\"sarda\",\"sargento\",\"sarjeta\",\"saturar\",\"saudade\",\"saxofone\",\"sazonal\",\"secar\",\"secular\",\"seda\",\"sedento\",\"sediado\",\"sedoso\",\"sedutor\",\"segmento\",\"segredo\",\"segundo\",\"seiva\",\"seleto\",\"selvagem\",\"semanal\",\"semente\",\"senador\",\"senhor\",\"sensual\",\"sentado\",\"separado\",\"sereia\",\"seringa\",\"serra\",\"servo\",\"setembro\",\"setor\",\"sigilo\",\"silhueta\",\"silicone\",\"simetria\",\"simpatia\",\"simular\",\"sinal\",\"sincero\",\"singular\",\"sinopse\",\"sintonia\",\"sirene\",\"siri\",\"situado\",\"soberano\",\"sobra\",\"socorro\",\"sogro\",\"soja\",\"solda\",\"soletrar\",\"solteiro\",\"sombrio\",\"sonata\",\"sondar\",\"sonegar\",\"sonhador\",\"sono\",\"soprano\",\"soquete\",\"sorrir\",\"sorteio\",\"sossego\",\"sotaque\",\"soterrar\",\"sovado\",\"sozinho\",\"suavizar\",\"subida\",\"submerso\",\"subsolo\",\"subtrair\",\"sucata\",\"sucesso\",\"suco\",\"sudeste\",\"sufixo\",\"sugador\",\"sugerir\",\"sujeito\",\"sulfato\",\"sumir\",\"suor\",\"superior\",\"suplicar\",\"suposto\",\"suprimir\",\"surdina\",\"surfista\",\"surpresa\",\"surreal\",\"surtir\",\"suspiro\",\"sustento\",\"tabela\",\"tablete\",\"tabuada\",\"tacho\",\"tagarela\",\"talher\",\"talo\",\"talvez\",\"tamanho\",\"tamborim\",\"tampa\",\"tangente\",\"tanto\",\"tapar\",\"tapioca\",\"tardio\",\"tarefa\",\"tarja\",\"tarraxa\",\"tatuagem\",\"taurino\",\"taxativo\",\"taxista\",\"teatral\",\"tecer\",\"tecido\",\"teclado\",\"tedioso\",\"teia\",\"teimar\",\"telefone\",\"telhado\",\"tempero\",\"tenente\",\"tensor\",\"tentar\",\"termal\",\"terno\",\"terreno\",\"tese\",\"tesoura\",\"testado\",\"teto\",\"textura\",\"texugo\",\"tiara\",\"tigela\",\"tijolo\",\"timbrar\",\"timidez\",\"tingido\",\"tinteiro\",\"tiragem\",\"titular\",\"toalha\",\"tocha\",\"tolerar\",\"tolice\",\"tomada\",\"tomilho\",\"tonel\",\"tontura\",\"topete\",\"tora\",\"torcido\",\"torneio\",\"torque\",\"torrada\",\"torto\",\"tostar\",\"touca\",\"toupeira\",\"toxina\",\"trabalho\",\"tracejar\",\"tradutor\",\"trafegar\",\"trajeto\",\"trama\",\"trancar\",\"trapo\",\"traseiro\",\"tratador\",\"travar\",\"treino\",\"tremer\",\"trepidar\",\"trevo\",\"triagem\",\"tribo\",\"triciclo\",\"tridente\",\"trilogia\",\"trindade\",\"triplo\",\"triturar\",\"triunfal\",\"trocar\",\"trombeta\",\"trova\",\"trunfo\",\"truque\",\"tubular\",\"tucano\",\"tudo\",\"tulipa\",\"tupi\",\"turbo\",\"turma\",\"turquesa\",\"tutelar\",\"tutorial\",\"uivar\",\"umbigo\",\"unha\",\"unidade\",\"uniforme\",\"urologia\",\"urso\",\"urtiga\",\"urubu\",\"usado\",\"usina\",\"usufruir\",\"vacina\",\"vadiar\",\"vagaroso\",\"vaidoso\",\"vala\",\"valente\",\"validade\",\"valores\",\"vantagem\",\"vaqueiro\",\"varanda\",\"vareta\",\"varrer\",\"vascular\",\"vasilha\",\"vassoura\",\"vazar\",\"vazio\",\"veado\",\"vedar\",\"vegetar\",\"veicular\",\"veleiro\",\"velhice\",\"veludo\",\"vencedor\",\"vendaval\",\"venerar\",\"ventre\",\"verbal\",\"verdade\",\"vereador\",\"vergonha\",\"vermelho\",\"verniz\",\"versar\",\"vertente\",\"vespa\",\"vestido\",\"vetorial\",\"viaduto\",\"viagem\",\"viajar\",\"viatura\",\"vibrador\",\"videira\",\"vidraria\",\"viela\",\"viga\",\"vigente\",\"vigiar\",\"vigorar\",\"vilarejo\",\"vinco\",\"vinheta\",\"vinil\",\"violeta\",\"virada\",\"virtude\",\"visitar\",\"visto\",\"vitral\",\"viveiro\",\"vizinho\",\"voador\",\"voar\",\"vogal\",\"volante\",\"voleibol\",\"voltagem\",\"volumoso\",\"vontade\",\"vulto\",\"vuvuzela\",\"xadrez\",\"xarope\",\"xeque\",\"xeretar\",\"xerife\",\"xingar\",\"zangado\",\"zarpar\",\"zebu\",\"zelador\",\"zombar\",\"zoologia\",\"zumbido\"]");

});

parcelRegister("ml96a", function(module, exports) {
module.exports = JSON.parse("[\"abandon\",\"ability\",\"able\",\"about\",\"above\",\"absent\",\"absorb\",\"abstract\",\"absurd\",\"abuse\",\"access\",\"accident\",\"account\",\"accuse\",\"achieve\",\"acid\",\"acoustic\",\"acquire\",\"across\",\"act\",\"action\",\"actor\",\"actress\",\"actual\",\"adapt\",\"add\",\"addict\",\"address\",\"adjust\",\"admit\",\"adult\",\"advance\",\"advice\",\"aerobic\",\"affair\",\"afford\",\"afraid\",\"again\",\"age\",\"agent\",\"agree\",\"ahead\",\"aim\",\"air\",\"airport\",\"aisle\",\"alarm\",\"album\",\"alcohol\",\"alert\",\"alien\",\"all\",\"alley\",\"allow\",\"almost\",\"alone\",\"alpha\",\"already\",\"also\",\"alter\",\"always\",\"amateur\",\"amazing\",\"among\",\"amount\",\"amused\",\"analyst\",\"anchor\",\"ancient\",\"anger\",\"angle\",\"angry\",\"animal\",\"ankle\",\"announce\",\"annual\",\"another\",\"answer\",\"antenna\",\"antique\",\"anxiety\",\"any\",\"apart\",\"apology\",\"appear\",\"apple\",\"approve\",\"april\",\"arch\",\"arctic\",\"area\",\"arena\",\"argue\",\"arm\",\"armed\",\"armor\",\"army\",\"around\",\"arrange\",\"arrest\",\"arrive\",\"arrow\",\"art\",\"artefact\",\"artist\",\"artwork\",\"ask\",\"aspect\",\"assault\",\"asset\",\"assist\",\"assume\",\"asthma\",\"athlete\",\"atom\",\"attack\",\"attend\",\"attitude\",\"attract\",\"auction\",\"audit\",\"august\",\"aunt\",\"author\",\"auto\",\"autumn\",\"average\",\"avocado\",\"avoid\",\"awake\",\"aware\",\"away\",\"awesome\",\"awful\",\"awkward\",\"axis\",\"baby\",\"bachelor\",\"bacon\",\"badge\",\"bag\",\"balance\",\"balcony\",\"ball\",\"bamboo\",\"banana\",\"banner\",\"bar\",\"barely\",\"bargain\",\"barrel\",\"base\",\"basic\",\"basket\",\"battle\",\"beach\",\"bean\",\"beauty\",\"because\",\"become\",\"beef\",\"before\",\"begin\",\"behave\",\"behind\",\"believe\",\"below\",\"belt\",\"bench\",\"benefit\",\"best\",\"betray\",\"better\",\"between\",\"beyond\",\"bicycle\",\"bid\",\"bike\",\"bind\",\"biology\",\"bird\",\"birth\",\"bitter\",\"black\",\"blade\",\"blame\",\"blanket\",\"blast\",\"bleak\",\"bless\",\"blind\",\"blood\",\"blossom\",\"blouse\",\"blue\",\"blur\",\"blush\",\"board\",\"boat\",\"body\",\"boil\",\"bomb\",\"bone\",\"bonus\",\"book\",\"boost\",\"border\",\"boring\",\"borrow\",\"boss\",\"bottom\",\"bounce\",\"box\",\"boy\",\"bracket\",\"brain\",\"brand\",\"brass\",\"brave\",\"bread\",\"breeze\",\"brick\",\"bridge\",\"brief\",\"bright\",\"bring\",\"brisk\",\"broccoli\",\"broken\",\"bronze\",\"broom\",\"brother\",\"brown\",\"brush\",\"bubble\",\"buddy\",\"budget\",\"buffalo\",\"build\",\"bulb\",\"bulk\",\"bullet\",\"bundle\",\"bunker\",\"burden\",\"burger\",\"burst\",\"bus\",\"business\",\"busy\",\"butter\",\"buyer\",\"buzz\",\"cabbage\",\"cabin\",\"cable\",\"cactus\",\"cage\",\"cake\",\"call\",\"calm\",\"camera\",\"camp\",\"can\",\"canal\",\"cancel\",\"candy\",\"cannon\",\"canoe\",\"canvas\",\"canyon\",\"capable\",\"capital\",\"captain\",\"car\",\"carbon\",\"card\",\"cargo\",\"carpet\",\"carry\",\"cart\",\"case\",\"cash\",\"casino\",\"castle\",\"casual\",\"cat\",\"catalog\",\"catch\",\"category\",\"cattle\",\"caught\",\"cause\",\"caution\",\"cave\",\"ceiling\",\"celery\",\"cement\",\"census\",\"century\",\"cereal\",\"certain\",\"chair\",\"chalk\",\"champion\",\"change\",\"chaos\",\"chapter\",\"charge\",\"chase\",\"chat\",\"cheap\",\"check\",\"cheese\",\"chef\",\"cherry\",\"chest\",\"chicken\",\"chief\",\"child\",\"chimney\",\"choice\",\"choose\",\"chronic\",\"chuckle\",\"chunk\",\"churn\",\"cigar\",\"cinnamon\",\"circle\",\"citizen\",\"city\",\"civil\",\"claim\",\"clap\",\"clarify\",\"claw\",\"clay\",\"clean\",\"clerk\",\"clever\",\"click\",\"client\",\"cliff\",\"climb\",\"clinic\",\"clip\",\"clock\",\"clog\",\"close\",\"cloth\",\"cloud\",\"clown\",\"club\",\"clump\",\"cluster\",\"clutch\",\"coach\",\"coast\",\"coconut\",\"code\",\"coffee\",\"coil\",\"coin\",\"collect\",\"color\",\"column\",\"combine\",\"come\",\"comfort\",\"comic\",\"common\",\"company\",\"concert\",\"conduct\",\"confirm\",\"congress\",\"connect\",\"consider\",\"control\",\"convince\",\"cook\",\"cool\",\"copper\",\"copy\",\"coral\",\"core\",\"corn\",\"correct\",\"cost\",\"cotton\",\"couch\",\"country\",\"couple\",\"course\",\"cousin\",\"cover\",\"coyote\",\"crack\",\"cradle\",\"craft\",\"cram\",\"crane\",\"crash\",\"crater\",\"crawl\",\"crazy\",\"cream\",\"credit\",\"creek\",\"crew\",\"cricket\",\"crime\",\"crisp\",\"critic\",\"crop\",\"cross\",\"crouch\",\"crowd\",\"crucial\",\"cruel\",\"cruise\",\"crumble\",\"crunch\",\"crush\",\"cry\",\"crystal\",\"cube\",\"culture\",\"cup\",\"cupboard\",\"curious\",\"current\",\"curtain\",\"curve\",\"cushion\",\"custom\",\"cute\",\"cycle\",\"dad\",\"damage\",\"damp\",\"dance\",\"danger\",\"daring\",\"dash\",\"daughter\",\"dawn\",\"day\",\"deal\",\"debate\",\"debris\",\"decade\",\"december\",\"decide\",\"decline\",\"decorate\",\"decrease\",\"deer\",\"defense\",\"define\",\"defy\",\"degree\",\"delay\",\"deliver\",\"demand\",\"demise\",\"denial\",\"dentist\",\"deny\",\"depart\",\"depend\",\"deposit\",\"depth\",\"deputy\",\"derive\",\"describe\",\"desert\",\"design\",\"desk\",\"despair\",\"destroy\",\"detail\",\"detect\",\"develop\",\"device\",\"devote\",\"diagram\",\"dial\",\"diamond\",\"diary\",\"dice\",\"diesel\",\"diet\",\"differ\",\"digital\",\"dignity\",\"dilemma\",\"dinner\",\"dinosaur\",\"direct\",\"dirt\",\"disagree\",\"discover\",\"disease\",\"dish\",\"dismiss\",\"disorder\",\"display\",\"distance\",\"divert\",\"divide\",\"divorce\",\"dizzy\",\"doctor\",\"document\",\"dog\",\"doll\",\"dolphin\",\"domain\",\"donate\",\"donkey\",\"donor\",\"door\",\"dose\",\"double\",\"dove\",\"draft\",\"dragon\",\"drama\",\"drastic\",\"draw\",\"dream\",\"dress\",\"drift\",\"drill\",\"drink\",\"drip\",\"drive\",\"drop\",\"drum\",\"dry\",\"duck\",\"dumb\",\"dune\",\"during\",\"dust\",\"dutch\",\"duty\",\"dwarf\",\"dynamic\",\"eager\",\"eagle\",\"early\",\"earn\",\"earth\",\"easily\",\"east\",\"easy\",\"echo\",\"ecology\",\"economy\",\"edge\",\"edit\",\"educate\",\"effort\",\"egg\",\"eight\",\"either\",\"elbow\",\"elder\",\"electric\",\"elegant\",\"element\",\"elephant\",\"elevator\",\"elite\",\"else\",\"embark\",\"embody\",\"embrace\",\"emerge\",\"emotion\",\"employ\",\"empower\",\"empty\",\"enable\",\"enact\",\"end\",\"endless\",\"endorse\",\"enemy\",\"energy\",\"enforce\",\"engage\",\"engine\",\"enhance\",\"enjoy\",\"enlist\",\"enough\",\"enrich\",\"enroll\",\"ensure\",\"enter\",\"entire\",\"entry\",\"envelope\",\"episode\",\"equal\",\"equip\",\"era\",\"erase\",\"erode\",\"erosion\",\"error\",\"erupt\",\"escape\",\"essay\",\"essence\",\"estate\",\"eternal\",\"ethics\",\"evidence\",\"evil\",\"evoke\",\"evolve\",\"exact\",\"example\",\"excess\",\"exchange\",\"excite\",\"exclude\",\"excuse\",\"execute\",\"exercise\",\"exhaust\",\"exhibit\",\"exile\",\"exist\",\"exit\",\"exotic\",\"expand\",\"expect\",\"expire\",\"explain\",\"expose\",\"express\",\"extend\",\"extra\",\"eye\",\"eyebrow\",\"fabric\",\"face\",\"faculty\",\"fade\",\"faint\",\"faith\",\"fall\",\"false\",\"fame\",\"family\",\"famous\",\"fan\",\"fancy\",\"fantasy\",\"farm\",\"fashion\",\"fat\",\"fatal\",\"father\",\"fatigue\",\"fault\",\"favorite\",\"feature\",\"february\",\"federal\",\"fee\",\"feed\",\"feel\",\"female\",\"fence\",\"festival\",\"fetch\",\"fever\",\"few\",\"fiber\",\"fiction\",\"field\",\"figure\",\"file\",\"film\",\"filter\",\"final\",\"find\",\"fine\",\"finger\",\"finish\",\"fire\",\"firm\",\"first\",\"fiscal\",\"fish\",\"fit\",\"fitness\",\"fix\",\"flag\",\"flame\",\"flash\",\"flat\",\"flavor\",\"flee\",\"flight\",\"flip\",\"float\",\"flock\",\"floor\",\"flower\",\"fluid\",\"flush\",\"fly\",\"foam\",\"focus\",\"fog\",\"foil\",\"fold\",\"follow\",\"food\",\"foot\",\"force\",\"forest\",\"forget\",\"fork\",\"fortune\",\"forum\",\"forward\",\"fossil\",\"foster\",\"found\",\"fox\",\"fragile\",\"frame\",\"frequent\",\"fresh\",\"friend\",\"fringe\",\"frog\",\"front\",\"frost\",\"frown\",\"frozen\",\"fruit\",\"fuel\",\"fun\",\"funny\",\"furnace\",\"fury\",\"future\",\"gadget\",\"gain\",\"galaxy\",\"gallery\",\"game\",\"gap\",\"garage\",\"garbage\",\"garden\",\"garlic\",\"garment\",\"gas\",\"gasp\",\"gate\",\"gather\",\"gauge\",\"gaze\",\"general\",\"genius\",\"genre\",\"gentle\",\"genuine\",\"gesture\",\"ghost\",\"giant\",\"gift\",\"giggle\",\"ginger\",\"giraffe\",\"girl\",\"give\",\"glad\",\"glance\",\"glare\",\"glass\",\"glide\",\"glimpse\",\"globe\",\"gloom\",\"glory\",\"glove\",\"glow\",\"glue\",\"goat\",\"goddess\",\"gold\",\"good\",\"goose\",\"gorilla\",\"gospel\",\"gossip\",\"govern\",\"gown\",\"grab\",\"grace\",\"grain\",\"grant\",\"grape\",\"grass\",\"gravity\",\"great\",\"green\",\"grid\",\"grief\",\"grit\",\"grocery\",\"group\",\"grow\",\"grunt\",\"guard\",\"guess\",\"guide\",\"guilt\",\"guitar\",\"gun\",\"gym\",\"habit\",\"hair\",\"half\",\"hammer\",\"hamster\",\"hand\",\"happy\",\"harbor\",\"hard\",\"harsh\",\"harvest\",\"hat\",\"have\",\"hawk\",\"hazard\",\"head\",\"health\",\"heart\",\"heavy\",\"hedgehog\",\"height\",\"hello\",\"helmet\",\"help\",\"hen\",\"hero\",\"hidden\",\"high\",\"hill\",\"hint\",\"hip\",\"hire\",\"history\",\"hobby\",\"hockey\",\"hold\",\"hole\",\"holiday\",\"hollow\",\"home\",\"honey\",\"hood\",\"hope\",\"horn\",\"horror\",\"horse\",\"hospital\",\"host\",\"hotel\",\"hour\",\"hover\",\"hub\",\"huge\",\"human\",\"humble\",\"humor\",\"hundred\",\"hungry\",\"hunt\",\"hurdle\",\"hurry\",\"hurt\",\"husband\",\"hybrid\",\"ice\",\"icon\",\"idea\",\"identify\",\"idle\",\"ignore\",\"ill\",\"illegal\",\"illness\",\"image\",\"imitate\",\"immense\",\"immune\",\"impact\",\"impose\",\"improve\",\"impulse\",\"inch\",\"include\",\"income\",\"increase\",\"index\",\"indicate\",\"indoor\",\"industry\",\"infant\",\"inflict\",\"inform\",\"inhale\",\"inherit\",\"initial\",\"inject\",\"injury\",\"inmate\",\"inner\",\"innocent\",\"input\",\"inquiry\",\"insane\",\"insect\",\"inside\",\"inspire\",\"install\",\"intact\",\"interest\",\"into\",\"invest\",\"invite\",\"involve\",\"iron\",\"island\",\"isolate\",\"issue\",\"item\",\"ivory\",\"jacket\",\"jaguar\",\"jar\",\"jazz\",\"jealous\",\"jeans\",\"jelly\",\"jewel\",\"job\",\"join\",\"joke\",\"journey\",\"joy\",\"judge\",\"juice\",\"jump\",\"jungle\",\"junior\",\"junk\",\"just\",\"kangaroo\",\"keen\",\"keep\",\"ketchup\",\"key\",\"kick\",\"kid\",\"kidney\",\"kind\",\"kingdom\",\"kiss\",\"kit\",\"kitchen\",\"kite\",\"kitten\",\"kiwi\",\"knee\",\"knife\",\"knock\",\"know\",\"lab\",\"label\",\"labor\",\"ladder\",\"lady\",\"lake\",\"lamp\",\"language\",\"laptop\",\"large\",\"later\",\"latin\",\"laugh\",\"laundry\",\"lava\",\"law\",\"lawn\",\"lawsuit\",\"layer\",\"lazy\",\"leader\",\"leaf\",\"learn\",\"leave\",\"lecture\",\"left\",\"leg\",\"legal\",\"legend\",\"leisure\",\"lemon\",\"lend\",\"length\",\"lens\",\"leopard\",\"lesson\",\"letter\",\"level\",\"liar\",\"liberty\",\"library\",\"license\",\"life\",\"lift\",\"light\",\"like\",\"limb\",\"limit\",\"link\",\"lion\",\"liquid\",\"list\",\"little\",\"live\",\"lizard\",\"load\",\"loan\",\"lobster\",\"local\",\"lock\",\"logic\",\"lonely\",\"long\",\"loop\",\"lottery\",\"loud\",\"lounge\",\"love\",\"loyal\",\"lucky\",\"luggage\",\"lumber\",\"lunar\",\"lunch\",\"luxury\",\"lyrics\",\"machine\",\"mad\",\"magic\",\"magnet\",\"maid\",\"mail\",\"main\",\"major\",\"make\",\"mammal\",\"man\",\"manage\",\"mandate\",\"mango\",\"mansion\",\"manual\",\"maple\",\"marble\",\"march\",\"margin\",\"marine\",\"market\",\"marriage\",\"mask\",\"mass\",\"master\",\"match\",\"material\",\"math\",\"matrix\",\"matter\",\"maximum\",\"maze\",\"meadow\",\"mean\",\"measure\",\"meat\",\"mechanic\",\"medal\",\"media\",\"melody\",\"melt\",\"member\",\"memory\",\"mention\",\"menu\",\"mercy\",\"merge\",\"merit\",\"merry\",\"mesh\",\"message\",\"metal\",\"method\",\"middle\",\"midnight\",\"milk\",\"million\",\"mimic\",\"mind\",\"minimum\",\"minor\",\"minute\",\"miracle\",\"mirror\",\"misery\",\"miss\",\"mistake\",\"mix\",\"mixed\",\"mixture\",\"mobile\",\"model\",\"modify\",\"mom\",\"moment\",\"monitor\",\"monkey\",\"monster\",\"month\",\"moon\",\"moral\",\"more\",\"morning\",\"mosquito\",\"mother\",\"motion\",\"motor\",\"mountain\",\"mouse\",\"move\",\"movie\",\"much\",\"muffin\",\"mule\",\"multiply\",\"muscle\",\"museum\",\"mushroom\",\"music\",\"must\",\"mutual\",\"myself\",\"mystery\",\"myth\",\"naive\",\"name\",\"napkin\",\"narrow\",\"nasty\",\"nation\",\"nature\",\"near\",\"neck\",\"need\",\"negative\",\"neglect\",\"neither\",\"nephew\",\"nerve\",\"nest\",\"net\",\"network\",\"neutral\",\"never\",\"news\",\"next\",\"nice\",\"night\",\"noble\",\"noise\",\"nominee\",\"noodle\",\"normal\",\"north\",\"nose\",\"notable\",\"note\",\"nothing\",\"notice\",\"novel\",\"now\",\"nuclear\",\"number\",\"nurse\",\"nut\",\"oak\",\"obey\",\"object\",\"oblige\",\"obscure\",\"observe\",\"obtain\",\"obvious\",\"occur\",\"ocean\",\"october\",\"odor\",\"off\",\"offer\",\"office\",\"often\",\"oil\",\"okay\",\"old\",\"olive\",\"olympic\",\"omit\",\"once\",\"one\",\"onion\",\"online\",\"only\",\"open\",\"opera\",\"opinion\",\"oppose\",\"option\",\"orange\",\"orbit\",\"orchard\",\"order\",\"ordinary\",\"organ\",\"orient\",\"original\",\"orphan\",\"ostrich\",\"other\",\"outdoor\",\"outer\",\"output\",\"outside\",\"oval\",\"oven\",\"over\",\"own\",\"owner\",\"oxygen\",\"oyster\",\"ozone\",\"pact\",\"paddle\",\"page\",\"pair\",\"palace\",\"palm\",\"panda\",\"panel\",\"panic\",\"panther\",\"paper\",\"parade\",\"parent\",\"park\",\"parrot\",\"party\",\"pass\",\"patch\",\"path\",\"patient\",\"patrol\",\"pattern\",\"pause\",\"pave\",\"payment\",\"peace\",\"peanut\",\"pear\",\"peasant\",\"pelican\",\"pen\",\"penalty\",\"pencil\",\"people\",\"pepper\",\"perfect\",\"permit\",\"person\",\"pet\",\"phone\",\"photo\",\"phrase\",\"physical\",\"piano\",\"picnic\",\"picture\",\"piece\",\"pig\",\"pigeon\",\"pill\",\"pilot\",\"pink\",\"pioneer\",\"pipe\",\"pistol\",\"pitch\",\"pizza\",\"place\",\"planet\",\"plastic\",\"plate\",\"play\",\"please\",\"pledge\",\"pluck\",\"plug\",\"plunge\",\"poem\",\"poet\",\"point\",\"polar\",\"pole\",\"police\",\"pond\",\"pony\",\"pool\",\"popular\",\"portion\",\"position\",\"possible\",\"post\",\"potato\",\"pottery\",\"poverty\",\"powder\",\"power\",\"practice\",\"praise\",\"predict\",\"prefer\",\"prepare\",\"present\",\"pretty\",\"prevent\",\"price\",\"pride\",\"primary\",\"print\",\"priority\",\"prison\",\"private\",\"prize\",\"problem\",\"process\",\"produce\",\"profit\",\"program\",\"project\",\"promote\",\"proof\",\"property\",\"prosper\",\"protect\",\"proud\",\"provide\",\"public\",\"pudding\",\"pull\",\"pulp\",\"pulse\",\"pumpkin\",\"punch\",\"pupil\",\"puppy\",\"purchase\",\"purity\",\"purpose\",\"purse\",\"push\",\"put\",\"puzzle\",\"pyramid\",\"quality\",\"quantum\",\"quarter\",\"question\",\"quick\",\"quit\",\"quiz\",\"quote\",\"rabbit\",\"raccoon\",\"race\",\"rack\",\"radar\",\"radio\",\"rail\",\"rain\",\"raise\",\"rally\",\"ramp\",\"ranch\",\"random\",\"range\",\"rapid\",\"rare\",\"rate\",\"rather\",\"raven\",\"raw\",\"razor\",\"ready\",\"real\",\"reason\",\"rebel\",\"rebuild\",\"recall\",\"receive\",\"recipe\",\"record\",\"recycle\",\"reduce\",\"reflect\",\"reform\",\"refuse\",\"region\",\"regret\",\"regular\",\"reject\",\"relax\",\"release\",\"relief\",\"rely\",\"remain\",\"remember\",\"remind\",\"remove\",\"render\",\"renew\",\"rent\",\"reopen\",\"repair\",\"repeat\",\"replace\",\"report\",\"require\",\"rescue\",\"resemble\",\"resist\",\"resource\",\"response\",\"result\",\"retire\",\"retreat\",\"return\",\"reunion\",\"reveal\",\"review\",\"reward\",\"rhythm\",\"rib\",\"ribbon\",\"rice\",\"rich\",\"ride\",\"ridge\",\"rifle\",\"right\",\"rigid\",\"ring\",\"riot\",\"ripple\",\"risk\",\"ritual\",\"rival\",\"river\",\"road\",\"roast\",\"robot\",\"robust\",\"rocket\",\"romance\",\"roof\",\"rookie\",\"room\",\"rose\",\"rotate\",\"rough\",\"round\",\"route\",\"royal\",\"rubber\",\"rude\",\"rug\",\"rule\",\"run\",\"runway\",\"rural\",\"sad\",\"saddle\",\"sadness\",\"safe\",\"sail\",\"salad\",\"salmon\",\"salon\",\"salt\",\"salute\",\"same\",\"sample\",\"sand\",\"satisfy\",\"satoshi\",\"sauce\",\"sausage\",\"save\",\"say\",\"scale\",\"scan\",\"scare\",\"scatter\",\"scene\",\"scheme\",\"school\",\"science\",\"scissors\",\"scorpion\",\"scout\",\"scrap\",\"screen\",\"script\",\"scrub\",\"sea\",\"search\",\"season\",\"seat\",\"second\",\"secret\",\"section\",\"security\",\"seed\",\"seek\",\"segment\",\"select\",\"sell\",\"seminar\",\"senior\",\"sense\",\"sentence\",\"series\",\"service\",\"session\",\"settle\",\"setup\",\"seven\",\"shadow\",\"shaft\",\"shallow\",\"share\",\"shed\",\"shell\",\"sheriff\",\"shield\",\"shift\",\"shine\",\"ship\",\"shiver\",\"shock\",\"shoe\",\"shoot\",\"shop\",\"short\",\"shoulder\",\"shove\",\"shrimp\",\"shrug\",\"shuffle\",\"shy\",\"sibling\",\"sick\",\"side\",\"siege\",\"sight\",\"sign\",\"silent\",\"silk\",\"silly\",\"silver\",\"similar\",\"simple\",\"since\",\"sing\",\"siren\",\"sister\",\"situate\",\"six\",\"size\",\"skate\",\"sketch\",\"ski\",\"skill\",\"skin\",\"skirt\",\"skull\",\"slab\",\"slam\",\"sleep\",\"slender\",\"slice\",\"slide\",\"slight\",\"slim\",\"slogan\",\"slot\",\"slow\",\"slush\",\"small\",\"smart\",\"smile\",\"smoke\",\"smooth\",\"snack\",\"snake\",\"snap\",\"sniff\",\"snow\",\"soap\",\"soccer\",\"social\",\"sock\",\"soda\",\"soft\",\"solar\",\"soldier\",\"solid\",\"solution\",\"solve\",\"someone\",\"song\",\"soon\",\"sorry\",\"sort\",\"soul\",\"sound\",\"soup\",\"source\",\"south\",\"space\",\"spare\",\"spatial\",\"spawn\",\"speak\",\"special\",\"speed\",\"spell\",\"spend\",\"sphere\",\"spice\",\"spider\",\"spike\",\"spin\",\"spirit\",\"split\",\"spoil\",\"sponsor\",\"spoon\",\"sport\",\"spot\",\"spray\",\"spread\",\"spring\",\"spy\",\"square\",\"squeeze\",\"squirrel\",\"stable\",\"stadium\",\"staff\",\"stage\",\"stairs\",\"stamp\",\"stand\",\"start\",\"state\",\"stay\",\"steak\",\"steel\",\"stem\",\"step\",\"stereo\",\"stick\",\"still\",\"sting\",\"stock\",\"stomach\",\"stone\",\"stool\",\"story\",\"stove\",\"strategy\",\"street\",\"strike\",\"strong\",\"struggle\",\"student\",\"stuff\",\"stumble\",\"style\",\"subject\",\"submit\",\"subway\",\"success\",\"such\",\"sudden\",\"suffer\",\"sugar\",\"suggest\",\"suit\",\"summer\",\"sun\",\"sunny\",\"sunset\",\"super\",\"supply\",\"supreme\",\"sure\",\"surface\",\"surge\",\"surprise\",\"surround\",\"survey\",\"suspect\",\"sustain\",\"swallow\",\"swamp\",\"swap\",\"swarm\",\"swear\",\"sweet\",\"swift\",\"swim\",\"swing\",\"switch\",\"sword\",\"symbol\",\"symptom\",\"syrup\",\"system\",\"table\",\"tackle\",\"tag\",\"tail\",\"talent\",\"talk\",\"tank\",\"tape\",\"target\",\"task\",\"taste\",\"tattoo\",\"taxi\",\"teach\",\"team\",\"tell\",\"ten\",\"tenant\",\"tennis\",\"tent\",\"term\",\"test\",\"text\",\"thank\",\"that\",\"theme\",\"then\",\"theory\",\"there\",\"they\",\"thing\",\"this\",\"thought\",\"three\",\"thrive\",\"throw\",\"thumb\",\"thunder\",\"ticket\",\"tide\",\"tiger\",\"tilt\",\"timber\",\"time\",\"tiny\",\"tip\",\"tired\",\"tissue\",\"title\",\"toast\",\"tobacco\",\"today\",\"toddler\",\"toe\",\"together\",\"toilet\",\"token\",\"tomato\",\"tomorrow\",\"tone\",\"tongue\",\"tonight\",\"tool\",\"tooth\",\"top\",\"topic\",\"topple\",\"torch\",\"tornado\",\"tortoise\",\"toss\",\"total\",\"tourist\",\"toward\",\"tower\",\"town\",\"toy\",\"track\",\"trade\",\"traffic\",\"tragic\",\"train\",\"transfer\",\"trap\",\"trash\",\"travel\",\"tray\",\"treat\",\"tree\",\"trend\",\"trial\",\"tribe\",\"trick\",\"trigger\",\"trim\",\"trip\",\"trophy\",\"trouble\",\"truck\",\"true\",\"truly\",\"trumpet\",\"trust\",\"truth\",\"try\",\"tube\",\"tuition\",\"tumble\",\"tuna\",\"tunnel\",\"turkey\",\"turn\",\"turtle\",\"twelve\",\"twenty\",\"twice\",\"twin\",\"twist\",\"two\",\"type\",\"typical\",\"ugly\",\"umbrella\",\"unable\",\"unaware\",\"uncle\",\"uncover\",\"under\",\"undo\",\"unfair\",\"unfold\",\"unhappy\",\"uniform\",\"unique\",\"unit\",\"universe\",\"unknown\",\"unlock\",\"until\",\"unusual\",\"unveil\",\"update\",\"upgrade\",\"uphold\",\"upon\",\"upper\",\"upset\",\"urban\",\"urge\",\"usage\",\"use\",\"used\",\"useful\",\"useless\",\"usual\",\"utility\",\"vacant\",\"vacuum\",\"vague\",\"valid\",\"valley\",\"valve\",\"van\",\"vanish\",\"vapor\",\"various\",\"vast\",\"vault\",\"vehicle\",\"velvet\",\"vendor\",\"venture\",\"venue\",\"verb\",\"verify\",\"version\",\"very\",\"vessel\",\"veteran\",\"viable\",\"vibrant\",\"vicious\",\"victory\",\"video\",\"view\",\"village\",\"vintage\",\"violin\",\"virtual\",\"virus\",\"visa\",\"visit\",\"visual\",\"vital\",\"vivid\",\"vocal\",\"voice\",\"void\",\"volcano\",\"volume\",\"vote\",\"voyage\",\"wage\",\"wagon\",\"wait\",\"walk\",\"wall\",\"walnut\",\"want\",\"warfare\",\"warm\",\"warrior\",\"wash\",\"wasp\",\"waste\",\"water\",\"wave\",\"way\",\"wealth\",\"weapon\",\"wear\",\"weasel\",\"weather\",\"web\",\"wedding\",\"weekend\",\"weird\",\"welcome\",\"west\",\"wet\",\"whale\",\"what\",\"wheat\",\"wheel\",\"when\",\"where\",\"whip\",\"whisper\",\"wide\",\"width\",\"wife\",\"wild\",\"will\",\"win\",\"window\",\"wine\",\"wing\",\"wink\",\"winner\",\"winter\",\"wire\",\"wisdom\",\"wise\",\"wish\",\"witness\",\"wolf\",\"woman\",\"wonder\",\"wood\",\"wool\",\"word\",\"work\",\"world\",\"worry\",\"worth\",\"wrap\",\"wreck\",\"wrestle\",\"wrist\",\"write\",\"wrong\",\"yard\",\"year\",\"yellow\",\"you\",\"young\",\"youth\",\"zebra\",\"zero\",\"zone\",\"zoo\"]");

});



parcelRegister("8AB7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jzgQH = parcelRequire("jzgQH");
module.exports.fromSeed = $jzgQH.fromSeed;
module.exports.fromBase58 = $jzgQH.fromBase58;
module.exports.fromPublicKey = $jzgQH.fromPublicKey;
module.exports.fromPrivateKey = $jzgQH.fromPrivateKey;

});
parcelRegister("jzgQH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e3ee5b147894d49f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fuOE5 = parcelRequire("fuOE5");

var $1Vf4C = parcelRequire("1Vf4C");

var $bAAqK = parcelRequire("bAAqK");

var $bDP98 = parcelRequire("bDP98");

var $bTFmB = parcelRequire("bTFmB");
const $e3ee5b147894d49f$var$UINT256_TYPE = $bDP98.BufferN(32);
const $e3ee5b147894d49f$var$NETWORK_TYPE = $bDP98.compile({
    wif: $bDP98.UInt8,
    bip32: {
        public: $bDP98.UInt32,
        private: $bDP98.UInt32
    }
});
const $e3ee5b147894d49f$var$BITCOIN = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'bc',
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $e3ee5b147894d49f$var$HIGHEST_BIT = 0x80000000;
const $e3ee5b147894d49f$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $e3ee5b147894d49f$var$BIP32Path(value) {
    return $bDP98.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $e3ee5b147894d49f$var$UInt31(value) {
    return $bDP98.UInt32(value) && value <= $e3ee5b147894d49f$var$UINT31_MAX;
}
class $e3ee5b147894d49f$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $bDP98($e3ee5b147894d49f$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $bAAqK.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $fuOE5.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $e3ee5b147894d49f$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $e3ee5b147894d49f$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $1Vf4C.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError('Missing private key');
        return $bTFmB.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $bDP98($bDP98.UInt32, index);
        const isHardened = index >= $e3ee5b147894d49f$var$HIGHEST_BIT;
        const data = $e3ee5b147894d49f$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError('Missing private key for hardened child key');
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $fuOE5.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$bAAqK.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $bAAqK.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $bAAqK.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $bDP98($e3ee5b147894d49f$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $e3ee5b147894d49f$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $bDP98($e3ee5b147894d49f$var$BIP32Path, path);
        let splitPath = path.split('/');
        if (splitPath[0] === 'm') {
            if (this.parentFingerprint) throw new TypeError('Expected master, got child');
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error('Missing private key');
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $bAAqK.sign(hash, this.privateKey);
        else {
            let sig = $bAAqK.sign(hash, this.privateKey);
            const extraData = $e3ee5b147894d49f$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $bAAqK.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $bAAqK.verify(hash, this.publicKey, signature);
    }
}
function $e3ee5b147894d49f$var$fromBase58(inString, network) {
    const buffer = $1Vf4C.decode(inString);
    if (buffer.length !== 78) throw new TypeError('Invalid buffer length');
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError('Invalid network version');
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError('Invalid parent fingerprint');
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError('Invalid index');
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError('Invalid private key');
        const k = buffer.slice(46, 78);
        hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
module.exports.fromBase58 = $e3ee5b147894d49f$var$fromBase58;
function $e3ee5b147894d49f$var$fromPrivateKey(privateKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
module.exports.fromPrivateKey = $e3ee5b147894d49f$var$fromPrivateKey;
function $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        privateKey: $e3ee5b147894d49f$var$UINT256_TYPE,
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    if (!$bAAqK.isPrivate(privateKey)) throw new TypeError('Private key not in range [1, n)');
    return new $e3ee5b147894d49f$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromPublicKey(publicKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
module.exports.fromPublicKey = $e3ee5b147894d49f$var$fromPublicKey;
function $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        publicKey: $bDP98.BufferN(33),
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$bAAqK.isPoint(publicKey)) throw new TypeError('Point is not on the curve');
    return new $e3ee5b147894d49f$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromSeed(seed, network) {
    $bDP98($bDP98.Buffer, seed);
    if (seed.length < 16) throw new TypeError('Seed should be at least 128 bits');
    if (seed.length > 64) throw new TypeError('Seed should be at most 512 bits');
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    const I = $fuOE5.hmacSHA512($e3ee5b147894d49f$require$Buffer.from('Bitcoin seed', 'utf8'), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $e3ee5b147894d49f$var$fromPrivateKey(IL, IR, network);
}
module.exports.fromSeed = $e3ee5b147894d49f$var$fromSeed;

});
parcelRegister("fuOE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3FiLE = parcelRequire("3FiLE");

var $cUvgf = parcelRequire("cUvgf");
function $b480f183ee1f31a5$var$hash160(buffer) {
    const sha256Hash = $3FiLE('sha256').update(buffer).digest();
    try {
        return $3FiLE('rmd160').update(sha256Hash).digest();
    } catch (err) {
        return $3FiLE('ripemd160').update(sha256Hash).digest();
    }
}
module.exports.hash160 = $b480f183ee1f31a5$var$hash160;
function $b480f183ee1f31a5$var$hmacSHA512(key, data) {
    return $cUvgf('sha512', key).update(data).digest();
}
module.exports.hmacSHA512 = $b480f183ee1f31a5$var$hmacSHA512;

});
parcelRegister("3FiLE", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $cvCaQ = parcelRequire("cvCaQ");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $fpHcA = parcelRequire("fpHcA");
function $2ab3c24d6f7239f3$var$Hash(hash) {
    $fpHcA.call(this, 'digest');
    this._hash = hash;
}
$eSHUL($2ab3c24d6f7239f3$var$Hash, $fpHcA);
$2ab3c24d6f7239f3$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2ab3c24d6f7239f3$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $cvCaQ();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $cjuEr();
    return new $2ab3c24d6f7239f3$var$Hash($fkJVr(alg));
};

});
parcelRegister("eSHUL", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("cvCaQ", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");

var $6U9mG = parcelRequire("6U9mG");
var $91b5fdd475e07956$require$Buffer = $6U9mG.Buffer;
var $91b5fdd475e07956$var$ARRAY16 = new Array(16);
function $91b5fdd475e07956$var$MD5() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$eSHUL($91b5fdd475e07956$var$MD5, $9aUYR);
$91b5fdd475e07956$var$MD5.prototype._update = function() {
    var M = $91b5fdd475e07956$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$91b5fdd475e07956$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $91b5fdd475e07956$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $91b5fdd475e07956$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $91b5fdd475e07956$var$fnF(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnG(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnH(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnI(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $91b5fdd475e07956$var$MD5;

});
parcelRegister("9aUYR", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $6ae13f602076a4da$require$Buffer = $6U9mG.Buffer;

var $9AddZ = parcelRequire("9AddZ");
var $6ae13f602076a4da$require$Transform = $9AddZ.Transform;

var $eSHUL = parcelRequire("eSHUL");
function $6ae13f602076a4da$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $6ae13f602076a4da$var$HashBase(blockSize) {
    $6ae13f602076a4da$require$Transform.call(this);
    this._block = $6ae13f602076a4da$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$eSHUL($6ae13f602076a4da$var$HashBase, $6ae13f602076a4da$require$Transform);
$6ae13f602076a4da$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype.update = function(data, encoding) {
    $6ae13f602076a4da$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(data)) data = $6ae13f602076a4da$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6ae13f602076a4da$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$6ae13f602076a4da$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6ae13f602076a4da$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $6ae13f602076a4da$var$HashBase;

});
parcelRegister("9AddZ", function(module, exports) {

exports = module.exports = (parcelRequire("cEnbP"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("cuAoD"));

exports.Duplex = (parcelRequire("2Hlr9"));

exports.Transform = (parcelRequire("l7DDn"));

exports.PassThrough = (parcelRequire("6VFzs"));

exports.finished = (parcelRequire("gr8mb"));

exports.pipeline = (parcelRequire("e8JAK"));

});
parcelRegister("cEnbP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
'use strict';
module.exports = $935b35782dc2f587$var$Readable;
/*<replacement>*/ var $935b35782dc2f587$var$Duplex;
/*</replacement>*/ $935b35782dc2f587$var$Readable.ReadableState = $935b35782dc2f587$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $935b35782dc2f587$require$EE = $jMc9N.EventEmitter;
var $935b35782dc2f587$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $935b35782dc2f587$require$Buffer = $ihoyg.Buffer;
var $935b35782dc2f587$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk) {
    return $935b35782dc2f587$require$Buffer.from(chunk);
}
function $935b35782dc2f587$var$_isUint8Array(obj) {
    return $935b35782dc2f587$require$Buffer.isBuffer(obj) || obj instanceof $935b35782dc2f587$var$OurUint8Array;
}

var $5Io6y = parcelRequire("5Io6y");
var $935b35782dc2f587$var$debug;
if ($5Io6y && $5Io6y.debuglog) $935b35782dc2f587$var$debug = $5Io6y.debuglog('stream');
else $935b35782dc2f587$var$debug = function debug() {};

var $5KjdV = parcelRequire("5KjdV");

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $935b35782dc2f587$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $935b35782dc2f587$require$_require$codes = $dzxhd.codes;
var $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE = $935b35782dc2f587$require$_require$codes.ERR_INVALID_ARG_TYPE, $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF = $935b35782dc2f587$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED = $935b35782dc2f587$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $935b35782dc2f587$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $935b35782dc2f587$var$StringDecoder;
var $935b35782dc2f587$var$createReadableStreamAsyncIterator;
var $935b35782dc2f587$var$from;

(parcelRequire("eSHUL"))($935b35782dc2f587$var$Readable, $j5tZS);
var $935b35782dc2f587$var$errorOrDestroy = $kZIsm.errorOrDestroy;
var $935b35782dc2f587$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $935b35782dc2f587$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $935b35782dc2f587$var$ReadableState(options, stream, isDuplex) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $935b35782dc2f587$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $935b35782dc2f587$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5KjdV();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
        this.decoder = new $935b35782dc2f587$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $935b35782dc2f587$var$Readable(options) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    if (!(this instanceof $935b35782dc2f587$var$Readable)) return new $935b35782dc2f587$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $935b35782dc2f587$var$Duplex;
    this._readableState = new $935b35782dc2f587$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $j5tZS.call(this);
}
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$935b35782dc2f587$var$Readable.prototype.destroy = $kZIsm.destroy;
$935b35782dc2f587$var$Readable.prototype._undestroy = $kZIsm.undestroy;
$935b35782dc2f587$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$935b35782dc2f587$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $935b35782dc2f587$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$935b35782dc2f587$var$Readable.prototype.unshift = function(chunk) {
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, null, true, false);
};
function $935b35782dc2f587$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $935b35782dc2f587$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $935b35782dc2f587$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $935b35782dc2f587$var$chunkInvalid(state, chunk);
        if (er) $935b35782dc2f587$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $935b35782dc2f587$require$Buffer.prototype) chunk = $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $935b35782dc2f587$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
                    else $935b35782dc2f587$var$maybeReadMore(stream, state);
                } else $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $935b35782dc2f587$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $935b35782dc2f587$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $935b35782dc2f587$var$emitReadable(stream);
    }
    $935b35782dc2f587$var$maybeReadMore(stream, state);
}
function $935b35782dc2f587$var$chunkInvalid(state, chunk) {
    var er;
    if (!$935b35782dc2f587$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$935b35782dc2f587$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$935b35782dc2f587$var$Readable.prototype.setEncoding = function(enc) {
    if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
    var decoder = new $935b35782dc2f587$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $935b35782dc2f587$var$MAX_HWM = 0x40000000;
function $935b35782dc2f587$var$computeNewHighWaterMark(n) {
    if (n >= $935b35782dc2f587$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $935b35782dc2f587$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $935b35782dc2f587$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$935b35782dc2f587$var$Readable.prototype.read = function(n) {
    $935b35782dc2f587$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $935b35782dc2f587$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $935b35782dc2f587$var$endReadable(this);
        else $935b35782dc2f587$var$emitReadable(this);
        return null;
    }
    n = $935b35782dc2f587$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $935b35782dc2f587$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $935b35782dc2f587$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $935b35782dc2f587$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $935b35782dc2f587$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $935b35782dc2f587$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $935b35782dc2f587$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $935b35782dc2f587$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $935b35782dc2f587$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $935b35782dc2f587$var$onEofChunk(stream, state) {
    $935b35782dc2f587$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $935b35782dc2f587$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $935b35782dc2f587$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $935b35782dc2f587$var$emitReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $935b35782dc2f587$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4TNnu.nextTick($935b35782dc2f587$var$emitReadable_, stream);
    }
}
function $935b35782dc2f587$var$emitReadable_(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $935b35782dc2f587$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $935b35782dc2f587$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4TNnu.nextTick($935b35782dc2f587$var$maybeReadMore_, stream, state);
    }
}
function $935b35782dc2f587$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $935b35782dc2f587$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$935b35782dc2f587$var$Readable.prototype._read = function(n) {
    $935b35782dc2f587$var$errorOrDestroy(this, new $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$935b35782dc2f587$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $935b35782dc2f587$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4TNnu.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $935b35782dc2f587$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $935b35782dc2f587$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $935b35782dc2f587$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $935b35782dc2f587$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $935b35782dc2f587$var$debug('ondata');
        var ret = dest.write(chunk);
        $935b35782dc2f587$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $935b35782dc2f587$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $935b35782dc2f587$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $935b35782dc2f587$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($935b35782dc2f587$var$EElistenerCount(dest, 'error') === 0) $935b35782dc2f587$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $935b35782dc2f587$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $935b35782dc2f587$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $935b35782dc2f587$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $935b35782dc2f587$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $935b35782dc2f587$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $935b35782dc2f587$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $935b35782dc2f587$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $935b35782dc2f587$var$flow(src);
        }
    };
}
$935b35782dc2f587$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $935b35782dc2f587$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$935b35782dc2f587$var$Readable.prototype.on = function(ev, fn) {
    var res = $j5tZS.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $935b35782dc2f587$var$debug('on readable', state.length, state.reading);
            if (state.length) $935b35782dc2f587$var$emitReadable(this);
            else if (!state.reading) $4TNnu.nextTick($935b35782dc2f587$var$nReadingNextTick, this);
        }
    }
    return res;
};
$935b35782dc2f587$var$Readable.prototype.addListener = $935b35782dc2f587$var$Readable.prototype.on;
$935b35782dc2f587$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $j5tZS.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
$935b35782dc2f587$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $j5tZS.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
function $935b35782dc2f587$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $935b35782dc2f587$var$nReadingNextTick(self1) {
    $935b35782dc2f587$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$935b35782dc2f587$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $935b35782dc2f587$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $935b35782dc2f587$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $935b35782dc2f587$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4TNnu.nextTick($935b35782dc2f587$var$resume_, stream, state);
    }
}
function $935b35782dc2f587$var$resume_(stream, state) {
    $935b35782dc2f587$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $935b35782dc2f587$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$935b35782dc2f587$var$Readable.prototype.pause = function() {
    $935b35782dc2f587$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $935b35782dc2f587$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $935b35782dc2f587$var$flow(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$935b35782dc2f587$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $935b35782dc2f587$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $935b35782dc2f587$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $935b35782dc2f587$var$kProxyEvents.length; n++)stream.on($935b35782dc2f587$var$kProxyEvents[n], this.emit.bind(this, $935b35782dc2f587$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $935b35782dc2f587$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $935b35782dc2f587$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($935b35782dc2f587$var$createReadableStreamAsyncIterator === undefined) $935b35782dc2f587$var$createReadableStreamAsyncIterator = (parcelRequire("8BamM"));
    return $935b35782dc2f587$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$935b35782dc2f587$var$Readable._fromList = $935b35782dc2f587$var$fromList;
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $935b35782dc2f587$var$endReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4TNnu.nextTick($935b35782dc2f587$var$endReadableNT, state, stream);
    }
}
function $935b35782dc2f587$var$endReadableNT(state, stream) {
    $935b35782dc2f587$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $935b35782dc2f587$var$Readable.from = function(iterable, opts) {
    if ($935b35782dc2f587$var$from === undefined) $935b35782dc2f587$var$from = (parcelRequire("eGESN"));
    return $935b35782dc2f587$var$from($935b35782dc2f587$var$Readable, iterable, opts);
};
function $935b35782dc2f587$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = 'browser';
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ''; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391299e0893a3dfa$var$process.cwd = function() {
    return '/';
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $e65bee21a7cdc3da$var$R = typeof Reflect === 'object' ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === 'function' ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === 'function') $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("j5tZS", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("5KjdV", function(module, exports) {
'use strict';
function $42f0290b37cf0d25$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $42f0290b37cf0d25$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $42f0290b37cf0d25$var$ownKeys(Object(source), !0).forEach(function(key) {
            $42f0290b37cf0d25$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $42f0290b37cf0d25$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $42f0290b37cf0d25$var$_defineProperty(obj, key, value) {
    key = $42f0290b37cf0d25$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $42f0290b37cf0d25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $42f0290b37cf0d25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $42f0290b37cf0d25$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $42f0290b37cf0d25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $42f0290b37cf0d25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $42f0290b37cf0d25$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $42f0290b37cf0d25$var$_toPropertyKey(arg) {
    var key = $42f0290b37cf0d25$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $42f0290b37cf0d25$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ihoyg = parcelRequire("ihoyg");
var $42f0290b37cf0d25$var$Buffer = $ihoyg.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $42f0290b37cf0d25$var$inspect = $5Io6y.inspect;
var $42f0290b37cf0d25$var$custom = $42f0290b37cf0d25$var$inspect && $42f0290b37cf0d25$var$inspect.custom || 'inspect';
function $42f0290b37cf0d25$var$copyBuffer(src, target, offset) {
    $42f0290b37cf0d25$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $42f0290b37cf0d25$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $42f0290b37cf0d25$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $42f0290b37cf0d25$var$Buffer.alloc(0);
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $42f0290b37cf0d25$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $42f0290b37cf0d25$var$custom,
            value: function value(_, options) {
                return $42f0290b37cf0d25$var$inspect(this, $42f0290b37cf0d25$var$_objectSpread($42f0290b37cf0d25$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("kZIsm", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $f48bfd4745615c07$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
        } else if (cb) {
            $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
            cb(err);
        } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
    });
    return this;
}
function $f48bfd4745615c07$var$emitErrorAndCloseNT(self, err) {
    $f48bfd4745615c07$var$emitErrorNT(self, err);
    $f48bfd4745615c07$var$emitCloseNT(self);
}
function $f48bfd4745615c07$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $f48bfd4745615c07$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $f48bfd4745615c07$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $f48bfd4745615c07$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $f48bfd4745615c07$var$destroy,
    undestroy: $f48bfd4745615c07$var$undestroy,
    errorOrDestroy: $f48bfd4745615c07$var$errorOrDestroy
};

});

parcelRegister("ipGaF", function(module, exports) {
'use strict';

var $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE = (parcelRequire("dzxhd")).codes.ERR_INVALID_OPT_VALUE;
function $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d67b4619993ae46f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $d67b4619993ae46f$var$getHighWaterMark
};

});
parcelRegister("dzxhd", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $9e185b4d377b7281$export$e45cb6485273080e; }, function (v) { return $9e185b4d377b7281$export$e45cb6485273080e = v; });
var $9e185b4d377b7281$export$e45cb6485273080e;
'use strict';
function $9e185b4d377b7281$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $9e185b4d377b7281$var$codes = {};
function $9e185b4d377b7281$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $9e185b4d377b7281$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $9e185b4d377b7281$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $9e185b4d377b7281$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $9e185b4d377b7281$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $9e185b4d377b7281$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $9e185b4d377b7281$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$9e185b4d377b7281$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$9e185b4d377b7281$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $9e185b4d377b7281$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($9e185b4d377b7281$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, 'type'));
    else {
        var type = $9e185b4d377b7281$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$9e185b4d377b7281$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$9e185b4d377b7281$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$9e185b4d377b7281$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$9e185b4d377b7281$export$e45cb6485273080e = $9e185b4d377b7281$var$codes;

});


parcelRegister("2Hlr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4TNnu = parcelRequire("4TNnu");
'use strict';
/*<replacement>*/ var $1f7039dea5b1b29a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1f7039dea5b1b29a$var$Duplex;

var $cEnbP = parcelRequire("cEnbP");

var $cuAoD = parcelRequire("cuAoD");

(parcelRequire("eSHUL"))($1f7039dea5b1b29a$var$Duplex, $cEnbP);
// Allow the keys array to be GC'ed.
var $1f7039dea5b1b29a$var$keys = $1f7039dea5b1b29a$var$objectKeys($cuAoD.prototype);
for(var $1f7039dea5b1b29a$var$v = 0; $1f7039dea5b1b29a$var$v < $1f7039dea5b1b29a$var$keys.length; $1f7039dea5b1b29a$var$v++){
    var $1f7039dea5b1b29a$var$method = $1f7039dea5b1b29a$var$keys[$1f7039dea5b1b29a$var$v];
    if (!$1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method]) $1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method] = $cuAoD.prototype[$1f7039dea5b1b29a$var$method];
}
function $1f7039dea5b1b29a$var$Duplex(options) {
    if (!(this instanceof $1f7039dea5b1b29a$var$Duplex)) return new $1f7039dea5b1b29a$var$Duplex(options);
    $cEnbP.call(this, options);
    $cuAoD.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $1f7039dea5b1b29a$var$onend);
        }
    }
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $1f7039dea5b1b29a$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4TNnu.nextTick($1f7039dea5b1b29a$var$onEndNT, this);
}
function $1f7039dea5b1b29a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("cuAoD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4TNnu = parcelRequire("4TNnu");
'use strict';
module.exports = $918484e8c698b555$var$Writable;
/* <replacement> */ function $918484e8c698b555$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $918484e8c698b555$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $918484e8c698b555$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $918484e8c698b555$var$Duplex;
/*</replacement>*/ $918484e8c698b555$var$Writable.WritableState = $918484e8c698b555$var$WritableState;

/*<replacement>*/ var $918484e8c698b555$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $918484e8c698b555$require$Buffer = $ihoyg.Buffer;
var $918484e8c698b555$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $918484e8c698b555$var$_uint8ArrayToBuffer(chunk) {
    return $918484e8c698b555$require$Buffer.from(chunk);
}
function $918484e8c698b555$var$_isUint8Array(obj) {
    return $918484e8c698b555$require$Buffer.isBuffer(obj) || obj instanceof $918484e8c698b555$var$OurUint8Array;
}

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $918484e8c698b555$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $918484e8c698b555$require$_require$codes = $dzxhd.codes;
var $918484e8c698b555$var$ERR_INVALID_ARG_TYPE = $918484e8c698b555$require$_require$codes.ERR_INVALID_ARG_TYPE, $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED = $918484e8c698b555$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK = $918484e8c698b555$require$_require$codes.ERR_MULTIPLE_CALLBACK, $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE = $918484e8c698b555$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $918484e8c698b555$var$ERR_STREAM_DESTROYED = $918484e8c698b555$require$_require$codes.ERR_STREAM_DESTROYED, $918484e8c698b555$var$ERR_STREAM_NULL_VALUES = $918484e8c698b555$require$_require$codes.ERR_STREAM_NULL_VALUES, $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END = $918484e8c698b555$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $918484e8c698b555$var$ERR_UNKNOWN_ENCODING = $918484e8c698b555$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $918484e8c698b555$var$errorOrDestroy = $kZIsm.errorOrDestroy;

(parcelRequire("eSHUL"))($918484e8c698b555$var$Writable, $j5tZS);
function $918484e8c698b555$var$nop() {}

function $918484e8c698b555$var$WritableState(options, stream, isDuplex) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $918484e8c698b555$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $918484e8c698b555$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $918484e8c698b555$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(this);
}
$918484e8c698b555$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($918484e8c698b555$var$WritableState.prototype, 'buffer', {
            get: $918484e8c698b555$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $918484e8c698b555$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $918484e8c698b555$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($918484e8c698b555$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($918484e8c698b555$var$realHasInstance.call(this, object)) return true;
            if (this !== $918484e8c698b555$var$Writable) return false;
            return object && object._writableState instanceof $918484e8c698b555$var$WritableState;
        }
    });
} else $918484e8c698b555$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $918484e8c698b555$var$Writable(options) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $918484e8c698b555$var$Duplex;
    if (!isDuplex && !$918484e8c698b555$var$realHasInstance.call($918484e8c698b555$var$Writable, this)) return new $918484e8c698b555$var$Writable(options);
    this._writableState = new $918484e8c698b555$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $j5tZS.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$918484e8c698b555$var$Writable.prototype.pipe = function() {
    $918484e8c698b555$var$errorOrDestroy(this, new $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE());
};
function $918484e8c698b555$var$writeAfterEnd(stream, cb) {
    var er = new $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $918484e8c698b555$var$errorOrDestroy(stream, er);
    $4TNnu.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $918484e8c698b555$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $918484e8c698b555$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $918484e8c698b555$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        $4TNnu.nextTick(cb, er);
        return false;
    }
    return true;
}
$918484e8c698b555$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $918484e8c698b555$var$_isUint8Array(chunk);
    if (isBuf && !$918484e8c698b555$require$Buffer.isBuffer(chunk)) chunk = $918484e8c698b555$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $918484e8c698b555$var$nop;
    if (state.ending) $918484e8c698b555$var$writeAfterEnd(this, cb);
    else if (isBuf || $918484e8c698b555$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $918484e8c698b555$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$918484e8c698b555$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$918484e8c698b555$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(this, state);
    }
};
$918484e8c698b555$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $918484e8c698b555$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $918484e8c698b555$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $918484e8c698b555$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $918484e8c698b555$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $918484e8c698b555$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $918484e8c698b555$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $918484e8c698b555$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4TNnu.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4TNnu.nextTick($918484e8c698b555$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $918484e8c698b555$var$finishMaybe(stream, state);
    }
}
function $918484e8c698b555$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $918484e8c698b555$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK();
    $918484e8c698b555$var$onwriteStateUpdate(state);
    if (er) $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $918484e8c698b555$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(stream, state);
        if (sync) $4TNnu.nextTick($918484e8c698b555$var$afterWrite, stream, state, finished, cb);
        else $918484e8c698b555$var$afterWrite(stream, state, finished, cb);
    }
}
function $918484e8c698b555$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $918484e8c698b555$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $918484e8c698b555$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $918484e8c698b555$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $918484e8c698b555$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $918484e8c698b555$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$918484e8c698b555$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$918484e8c698b555$var$Writable.prototype._writev = null;
$918484e8c698b555$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $918484e8c698b555$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $918484e8c698b555$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $918484e8c698b555$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $918484e8c698b555$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $918484e8c698b555$var$finishMaybe(stream, state);
    });
}
function $918484e8c698b555$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4TNnu.nextTick($918484e8c698b555$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $918484e8c698b555$var$finishMaybe(stream, state) {
    var need = $918484e8c698b555$var$needFinish(state);
    if (need) {
        $918484e8c698b555$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $918484e8c698b555$var$endWritable(stream, state, cb) {
    state.ending = true;
    $918484e8c698b555$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4TNnu.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $918484e8c698b555$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$918484e8c698b555$var$Writable.prototype.destroy = $kZIsm.destroy;
$918484e8c698b555$var$Writable.prototype._undestroy = $kZIsm.undestroy;
$918484e8c698b555$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("l4FQK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $f57a6f356a44cf08$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f57a6f356a44cf08$var$deprecate(fn, msg) {
    if ($f57a6f356a44cf08$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f57a6f356a44cf08$var$config('throwDeprecation')) throw new Error(msg);
            else if ($f57a6f356a44cf08$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f57a6f356a44cf08$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("lEpDX", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $fc3139ad3bf9c399$export$63a7aa211a91ed69; }, function (v) { return $fc3139ad3bf9c399$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $fc3139ad3bf9c399$export$63a7aa211a91ed69;
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $fc3139ad3bf9c399$require$Buffer = $6U9mG.Buffer;
/*</replacement>*/ var $fc3139ad3bf9c399$var$isEncoding = $fc3139ad3bf9c399$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $fc3139ad3bf9c399$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $fc3139ad3bf9c399$var$normalizeEncoding(enc) {
    var nenc = $fc3139ad3bf9c399$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($fc3139ad3bf9c399$require$Buffer.isEncoding === $fc3139ad3bf9c399$var$isEncoding || !$fc3139ad3bf9c399$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$fc3139ad3bf9c399$export$63a7aa211a91ed69 = $fc3139ad3bf9c399$var$StringDecoder;
function $fc3139ad3bf9c399$var$StringDecoder(encoding) {
    this.encoding = $fc3139ad3bf9c399$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $fc3139ad3bf9c399$var$utf16Text;
            this.end = $fc3139ad3bf9c399$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $fc3139ad3bf9c399$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $fc3139ad3bf9c399$var$base64Text;
            this.end = $fc3139ad3bf9c399$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $fc3139ad3bf9c399$var$simpleWrite;
            this.end = $fc3139ad3bf9c399$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $fc3139ad3bf9c399$require$Buffer.allocUnsafe(nb);
}
$fc3139ad3bf9c399$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$fc3139ad3bf9c399$var$StringDecoder.prototype.end = $fc3139ad3bf9c399$var$utf8End;
// Returns only complete characters in a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.text = $fc3139ad3bf9c399$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $fc3139ad3bf9c399$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $fc3139ad3bf9c399$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $fc3139ad3bf9c399$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $fc3139ad3bf9c399$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $fc3139ad3bf9c399$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $fc3139ad3bf9c399$var$utf8Text(buf, i) {
    var total = $fc3139ad3bf9c399$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $fc3139ad3bf9c399$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $fc3139ad3bf9c399$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $fc3139ad3bf9c399$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $fc3139ad3bf9c399$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $fc3139ad3bf9c399$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $fc3139ad3bf9c399$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $fc3139ad3bf9c399$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("8BamM", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
'use strict';
var $6429d1f92cebcf33$var$_Object$setPrototypeO;
function $6429d1f92cebcf33$var$_defineProperty(obj, key, value) {
    key = $6429d1f92cebcf33$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6429d1f92cebcf33$var$_toPropertyKey(arg) {
    var key = $6429d1f92cebcf33$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6429d1f92cebcf33$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $gr8mb = parcelRequire("gr8mb");
var $6429d1f92cebcf33$var$kLastResolve = Symbol('lastResolve');
var $6429d1f92cebcf33$var$kLastReject = Symbol('lastReject');
var $6429d1f92cebcf33$var$kError = Symbol('error');
var $6429d1f92cebcf33$var$kEnded = Symbol('ended');
var $6429d1f92cebcf33$var$kLastPromise = Symbol('lastPromise');
var $6429d1f92cebcf33$var$kHandlePromise = Symbol('handlePromise');
var $6429d1f92cebcf33$var$kStream = Symbol('stream');
function $6429d1f92cebcf33$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $6429d1f92cebcf33$var$readAndResolve(iter) {
    var resolve = iter[$6429d1f92cebcf33$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$6429d1f92cebcf33$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$6429d1f92cebcf33$var$kLastPromise] = null;
            iter[$6429d1f92cebcf33$var$kLastResolve] = null;
            iter[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(data, false));
        }
    }
}
function $6429d1f92cebcf33$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4TNnu.nextTick($6429d1f92cebcf33$var$readAndResolve, iter);
}
function $6429d1f92cebcf33$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$6429d1f92cebcf33$var$kEnded]) {
                resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
                return;
            }
            iter[$6429d1f92cebcf33$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $6429d1f92cebcf33$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($6429d1f92cebcf33$var$_Object$setPrototypeO = {
    get stream () {
        return this[$6429d1f92cebcf33$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$6429d1f92cebcf33$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$6429d1f92cebcf33$var$kEnded]) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        if (this[$6429d1f92cebcf33$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4TNnu.nextTick(function() {
                if (_this[$6429d1f92cebcf33$var$kError]) reject(_this[$6429d1f92cebcf33$var$kError]);
                else resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$6429d1f92cebcf33$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($6429d1f92cebcf33$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$6429d1f92cebcf33$var$kStream].read();
            if (data !== null) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            promise = new Promise(this[$6429d1f92cebcf33$var$kHandlePromise]);
        }
        this[$6429d1f92cebcf33$var$kLastPromise] = promise;
        return promise;
    }
}, $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$6429d1f92cebcf33$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        });
    });
}), $6429d1f92cebcf33$var$_Object$setPrototypeO), $6429d1f92cebcf33$var$AsyncIteratorPrototype);
var $6429d1f92cebcf33$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kStream, {
        value: stream,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastResolve, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastReject, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kError, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$6429d1f92cebcf33$var$kStream].read();
            if (data) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            } else {
                iterator[$6429d1f92cebcf33$var$kLastResolve] = resolve;
                iterator[$6429d1f92cebcf33$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
    $gr8mb(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$6429d1f92cebcf33$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                reject(err);
            }
            iterator[$6429d1f92cebcf33$var$kError] = err;
            return;
        }
        var resolve = iterator[$6429d1f92cebcf33$var$kLastResolve];
        if (resolve !== null) {
            iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
            iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
            iterator[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        }
        iterator[$6429d1f92cebcf33$var$kEnded] = true;
    });
    stream.on('readable', $6429d1f92cebcf33$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $6429d1f92cebcf33$var$createReadableStreamAsyncIterator;

});
parcelRegister("gr8mb", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("dzxhd")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $bf75a6707710fb34$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $bf75a6707710fb34$var$noop() {}
function $bf75a6707710fb34$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $bf75a6707710fb34$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $bf75a6707710fb34$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $bf75a6707710fb34$var$once(callback || $bf75a6707710fb34$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($bf75a6707710fb34$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $bf75a6707710fb34$var$eos;

});


parcelRegister("eGESN", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("l7DDn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $f608fef10a5347dd$var$Transform;

var $dzxhd = parcelRequire("dzxhd");
var $f608fef10a5347dd$require$_require$codes = $dzxhd.codes;
var $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED = $f608fef10a5347dd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK = $f608fef10a5347dd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0 = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $2Hlr9 = parcelRequire("2Hlr9");

(parcelRequire("eSHUL"))($f608fef10a5347dd$var$Transform, $2Hlr9);
function $f608fef10a5347dd$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $f608fef10a5347dd$var$Transform(options) {
    if (!(this instanceof $f608fef10a5347dd$var$Transform)) return new $f608fef10a5347dd$var$Transform(options);
    $2Hlr9.call(this, options);
    this._transformState = {
        afterTransform: $f608fef10a5347dd$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $f608fef10a5347dd$var$prefinish);
}
function $f608fef10a5347dd$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $f608fef10a5347dd$var$done(_this, er, data);
    });
    else $f608fef10a5347dd$var$done(this, null, null);
}
$f608fef10a5347dd$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2Hlr9.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$f608fef10a5347dd$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$f608fef10a5347dd$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$f608fef10a5347dd$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$f608fef10a5347dd$var$Transform.prototype._destroy = function(err, cb) {
    $2Hlr9.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $f608fef10a5347dd$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6VFzs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $50b8500ab5b3088d$var$PassThrough;

var $l7DDn = parcelRequire("l7DDn");

(parcelRequire("eSHUL"))($50b8500ab5b3088d$var$PassThrough, $l7DDn);
function $50b8500ab5b3088d$var$PassThrough(options) {
    if (!(this instanceof $50b8500ab5b3088d$var$PassThrough)) return new $50b8500ab5b3088d$var$PassThrough(options);
    $l7DDn.call(this, options);
}
$50b8500ab5b3088d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("e8JAK", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $a4b52da101f8f158$var$eos;
function $a4b52da101f8f158$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dzxhd = parcelRequire("dzxhd");
var $a4b52da101f8f158$require$_require$codes = $dzxhd.codes;
var $a4b52da101f8f158$var$ERR_MISSING_ARGS = $a4b52da101f8f158$require$_require$codes.ERR_MISSING_ARGS, $a4b52da101f8f158$var$ERR_STREAM_DESTROYED = $a4b52da101f8f158$require$_require$codes.ERR_STREAM_DESTROYED;
function $a4b52da101f8f158$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a4b52da101f8f158$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $a4b52da101f8f158$var$destroyer(stream, reading, writing, callback) {
    callback = $a4b52da101f8f158$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($a4b52da101f8f158$var$eos === undefined) $a4b52da101f8f158$var$eos = (parcelRequire("gr8mb"));
    $a4b52da101f8f158$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($a4b52da101f8f158$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $a4b52da101f8f158$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $a4b52da101f8f158$var$call(fn) {
    fn();
}
function $a4b52da101f8f158$var$pipe(from, to) {
    return from.pipe(to);
}
function $a4b52da101f8f158$var$popCallback(streams) {
    if (!streams.length) return $a4b52da101f8f158$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $a4b52da101f8f158$var$noop;
    return streams.pop();
}
function $a4b52da101f8f158$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a4b52da101f8f158$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a4b52da101f8f158$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a4b52da101f8f158$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a4b52da101f8f158$var$call);
            if (reading) return;
            destroys.forEach($a4b52da101f8f158$var$call);
            callback(error);
        });
    });
    return streams.reduce($a4b52da101f8f158$var$pipe);
}
module.exports = $a4b52da101f8f158$var$pipeline;

});




parcelRegister("cjuEr", function(module, exports) {
'use strict';

var $ihoyg = parcelRequire("ihoyg");
var $8f6f09199cc1903f$require$Buffer = $ihoyg.Buffer;

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");
var $8f6f09199cc1903f$var$ARRAY16 = new Array(16);
var $8f6f09199cc1903f$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8f6f09199cc1903f$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8f6f09199cc1903f$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8f6f09199cc1903f$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8f6f09199cc1903f$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8f6f09199cc1903f$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8f6f09199cc1903f$var$RIPEMD160() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$eSHUL($8f6f09199cc1903f$var$RIPEMD160, $9aUYR);
$8f6f09199cc1903f$var$RIPEMD160.prototype._update = function() {
    var words = $8f6f09199cc1903f$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8f6f09199cc1903f$var$fn1(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[0], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn5(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[0], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 32) {
            tl = $8f6f09199cc1903f$var$fn2(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[1], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn4(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[1], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 48) {
            tl = $8f6f09199cc1903f$var$fn3(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[2], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn3(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[2], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 64) {
            tl = $8f6f09199cc1903f$var$fn4(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[3], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn2(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[3], $8f6f09199cc1903f$var$sr[i]);
        } else {
            tl = $8f6f09199cc1903f$var$fn5(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[4], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn1(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[4], $8f6f09199cc1903f$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8f6f09199cc1903f$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8f6f09199cc1903f$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8f6f09199cc1903f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8f6f09199cc1903f$require$Buffer.alloc ? $8f6f09199cc1903f$require$Buffer.alloc(20) : new $8f6f09199cc1903f$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $8f6f09199cc1903f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8f6f09199cc1903f$var$fn1(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn2(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn3(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn4(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn5(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $8f6f09199cc1903f$var$RIPEMD160;

});

parcelRegister("fkJVr", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("g2uoB"));

module.exports.sha1 = (parcelRequire("lyJtz"));

module.exports.sha224 = (parcelRequire("cwjAo"));

module.exports.sha256 = (parcelRequire("1o1iT"));

module.exports.sha384 = (parcelRequire("kWtXA"));

module.exports.sha512 = (parcelRequire("1HQNC"));

});
parcelRegister("g2uoB", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $bad46934fbfe816d$require$Buffer = $6U9mG.Buffer;
var $bad46934fbfe816d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $bad46934fbfe816d$var$W = new Array(80);
function $bad46934fbfe816d$var$Sha() {
    this.init();
    this._w = $bad46934fbfe816d$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($bad46934fbfe816d$var$Sha, $6fUHB);
$bad46934fbfe816d$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $bad46934fbfe816d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $bad46934fbfe816d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $bad46934fbfe816d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$bad46934fbfe816d$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $bad46934fbfe816d$var$rotl5(a) + $bad46934fbfe816d$var$ft(s, b, c, d) + e + w[j] + $bad46934fbfe816d$var$K[s] | 0;
        e = d;
        d = c;
        c = $bad46934fbfe816d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$bad46934fbfe816d$var$Sha.prototype._hash = function() {
    var H = $bad46934fbfe816d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $bad46934fbfe816d$var$Sha;

});
parcelRegister("6fUHB", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $48e020b2c4716d14$require$Buffer = $6U9mG.Buffer;

var $lePHA = parcelRequire("lePHA");
// prototype class for hash functions
function $48e020b2c4716d14$var$Hash(blockSize, finalSize) {
    this._block = $48e020b2c4716d14$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$48e020b2c4716d14$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $lePHA(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$48e020b2c4716d14$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$48e020b2c4716d14$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $48e020b2c4716d14$var$Hash;

});
parcelRegister("lePHA", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $03fd77c92c6f79f5$require$Buffer = $6U9mG.Buffer;

var $9ILyq = parcelRequire("9ILyq");

var $gIvYr = parcelRequire("gIvYr");
var $03fd77c92c6f79f5$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $gIvYr(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $03fd77c92c6f79f5$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $03fd77c92c6f79f5$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $03fd77c92c6f79f5$var$useFromArrayBuffer = $03fd77c92c6f79f5$var$useArrayBuffer && ($03fd77c92c6f79f5$require$Buffer.prototype instanceof Uint8Array || $03fd77c92c6f79f5$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($03fd77c92c6f79f5$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $03fd77c92c6f79f5$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $03fd77c92c6f79f5$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($03fd77c92c6f79f5$var$useArrayBuffer && $03fd77c92c6f79f5$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $03fd77c92c6f79f5$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($03fd77c92c6f79f5$var$useFromArrayBuffer) {
            var res = $03fd77c92c6f79f5$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $03fd77c92c6f79f5$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($03fd77c92c6f79f5$var$useUint8Array && data instanceof Uint8Array) return $03fd77c92c6f79f5$require$Buffer.from(data);
    var isArr = $9ILyq(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $03fd77c92c6f79f5$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $03fd77c92c6f79f5$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("9ILyq", function(module, exports) {
var $713d1c6c66d58098$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $713d1c6c66d58098$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("gIvYr", function(module, exports) {
'use strict';

var $eDiIz = parcelRequire("eDiIz");

var $bhqNG = parcelRequire("bhqNG");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $c2b98eb82cec83ce$var$$typedArrayBuffer = $bhqNG('TypedArray.prototype.buffer', true);

var $f6vGj = parcelRequire("f6vGj");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $c2b98eb82cec83ce$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$f6vGj(x)) throw new $eDiIz('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("eDiIz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("bhqNG", function(module, exports) {
'use strict';

var $bjzYz = parcelRequire("bjzYz");

var $csNIY = parcelRequire("csNIY");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $8366123d1c7410f8$var$$indexOf = $csNIY([
    $bjzYz('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ $bjzYz(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8366123d1c7410f8$var$$indexOf(name, '.prototype.') > -1) return $csNIY([
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("bjzYz", function(module, exports) {
'use strict';
var $83cd601c17e58462$var$undefined1;

var $7KrI3 = parcelRequire("7KrI3");

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");

var $db7xm = parcelRequire("db7xm");

var $gKnEJ = parcelRequire("gKnEJ");

var $42MO3 = parcelRequire("42MO3");

var $daBYy = parcelRequire("daBYy");

var $7VgwK = parcelRequire("7VgwK");

var $6GICW = parcelRequire("6GICW");

var $lj3GK = parcelRequire("lj3GK");
var $83cd601c17e58462$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $83cd601c17e58462$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $83cd601c17e58462$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $crSdH = parcelRequire("crSdH");

var $gdD7m = parcelRequire("gdD7m");
var $83cd601c17e58462$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $83cd601c17e58462$var$ThrowTypeError = $crSdH ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $83cd601c17e58462$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $crSdH(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $83cd601c17e58462$var$throwTypeError;
        }
    }
}() : $83cd601c17e58462$var$throwTypeError;

var $83cd601c17e58462$var$hasSymbols = (parcelRequire("5CmBX"))();

var $agKAf = parcelRequire("agKAf");

var $e351b = parcelRequire("e351b");

var $kF6dV = parcelRequire("kF6dV");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");
var $83cd601c17e58462$var$needsEval = {};
var $83cd601c17e58462$var$TypedArray = typeof Uint8Array === 'undefined' || !$agKAf ? undefined : $agKAf(Uint8Array);
var $83cd601c17e58462$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $83cd601c17e58462$var$hasSymbols && $agKAf ? $agKAf([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $83cd601c17e58462$var$needsEval,
    '%AsyncGenerator%': $83cd601c17e58462$var$needsEval,
    '%AsyncGeneratorFunction%': $83cd601c17e58462$var$needsEval,
    '%AsyncIteratorPrototype%': $83cd601c17e58462$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $83cd601c17e58462$var$$Function,
    '%GeneratorFunction%': $83cd601c17e58462$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $83cd601c17e58462$var$hasSymbols && $agKAf ? $agKAf($agKAf([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$83cd601c17e58462$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7KrI3,
    '%Object.getOwnPropertyDescriptor%': $crSdH,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$83cd601c17e58462$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $83cd601c17e58462$var$hasSymbols && $agKAf ? $agKAf(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $83cd601c17e58462$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $83cd601c17e58462$var$ThrowTypeError,
    '%TypedArray%': $83cd601c17e58462$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9RlYm,
    '%Function.prototype.apply%': $hsI1I,
    '%Object.defineProperty%': $gdD7m,
    '%Object.getPrototypeOf%': $e351b,
    '%Math.abs%': $db7xm,
    '%Math.floor%': $gKnEJ,
    '%Math.max%': $42MO3,
    '%Math.min%': $daBYy,
    '%Math.pow%': $7VgwK,
    '%Math.round%': $6GICW,
    '%Math.sign%': $lj3GK,
    '%Reflect.getPrototypeOf%': $kF6dV
};
if ($agKAf) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $83cd601c17e58462$var$errorProto = $agKAf($agKAf(e));
    $83cd601c17e58462$var$INTRINSICS['%Error.prototype%'] = $83cd601c17e58462$var$errorProto;
}
var $83cd601c17e58462$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $83cd601c17e58462$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $83cd601c17e58462$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $83cd601c17e58462$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $agKAf) value = $agKAf(gen.prototype);
    }
    $83cd601c17e58462$var$INTRINSICS[name] = value;
    return value;
};
var $83cd601c17e58462$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $83cd601c17e58462$var$$concat = $a7ABz.call($9RlYm, Array.prototype.concat);
var $83cd601c17e58462$var$$spliceApply = $a7ABz.call($hsI1I, Array.prototype.splice);
var $83cd601c17e58462$var$$replace = $a7ABz.call($9RlYm, String.prototype.replace);
var $83cd601c17e58462$var$$strSlice = $a7ABz.call($9RlYm, String.prototype.slice);
var $83cd601c17e58462$var$$exec = $a7ABz.call($9RlYm, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $83cd601c17e58462$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $83cd601c17e58462$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $83cd601c17e58462$var$stringToPath = function stringToPath(string) {
    var first = $83cd601c17e58462$var$$strSlice(string, 0, 1);
    var last = $83cd601c17e58462$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $83cd601c17e58462$var$$replace(string, $83cd601c17e58462$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $83cd601c17e58462$var$$replace(subString, $83cd601c17e58462$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $83cd601c17e58462$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($83cd601c17e58462$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $83cd601c17e58462$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7Dte4($83cd601c17e58462$var$INTRINSICS, intrinsicName)) {
        var value = $83cd601c17e58462$var$INTRINSICS[intrinsicName];
        if (value === $83cd601c17e58462$var$needsEval) value = $83cd601c17e58462$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($83cd601c17e58462$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $83cd601c17e58462$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $83cd601c17e58462$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $83cd601c17e58462$var$$spliceApply(parts, $83cd601c17e58462$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $83cd601c17e58462$var$$strSlice(part, 0, 1);
        var last = $83cd601c17e58462$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7Dte4($83cd601c17e58462$var$INTRINSICS, intrinsicRealName)) value = $83cd601c17e58462$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($crSdH && i + 1 >= parts.length) {
                var desc = $crSdH(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $83cd601c17e58462$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("7KrI3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ki6v4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6ZF4E", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jFaeR", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aNqH3", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("iOgL8", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("guz3A", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("db7xm", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("gKnEJ", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("42MO3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("daBYy", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("7VgwK", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("6GICW", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lj3GK", function(module, exports) {
'use strict';

var $jhjZ6 = parcelRequire("jhjZ6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jhjZ6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jhjZ6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("crSdH", function(module, exports) {
'use strict';

var $gRO4r = parcelRequire("gRO4r");
var $9102109fbf1ea315$require$$gOPD = $gRO4r;
if ($9102109fbf1ea315$require$$gOPD) try {
    $9102109fbf1ea315$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$require$$gOPD = null;
}
module.exports = $9102109fbf1ea315$require$$gOPD;

});
parcelRegister("gRO4r", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("gdD7m", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $bcec34397e853298$var$$defineProperty = Object.defineProperty || false;
if ($bcec34397e853298$var$$defineProperty) try {
    $bcec34397e853298$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $bcec34397e853298$var$$defineProperty = false;
}
module.exports = $bcec34397e853298$var$$defineProperty;

});

parcelRegister("5CmBX", function(module, exports) {
'use strict';
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $41720a79fda68d9e$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("agKAf", function(module, exports) {
'use strict';

var $kF6dV = parcelRequire("kF6dV");

var $e351b = parcelRequire("e351b");

var $lMT7N = parcelRequire("lMT7N");
/** @type {import('.')} */ module.exports = $kF6dV ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kF6dV(O);
} : $e351b ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e351b(O);
} : $lMT7N ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lMT7N(O);
} : null;

});
parcelRegister("kF6dV", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("e351b", function(module, exports) {
'use strict';

var $7KrI3 = parcelRequire("7KrI3");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $7KrI3.getPrototypeOf || null;

});

parcelRegister("lMT7N", function(module, exports) {
'use strict';

var $csNIY = parcelRequire("csNIY");

var $crSdH = parcelRequire("crSdH");
var $fdc8d75150bf6587$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $fdc8d75150bf6587$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $fdc8d75150bf6587$var$desc = !!$fdc8d75150bf6587$var$hasProtoAccessor && $crSdH && $crSdH(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $fdc8d75150bf6587$var$$Object = Object;
var $fdc8d75150bf6587$var$$getPrototypeOf = $fdc8d75150bf6587$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $fdc8d75150bf6587$var$desc && typeof $fdc8d75150bf6587$var$desc.get === 'function' ? $csNIY([
    $fdc8d75150bf6587$var$desc.get
]) : typeof $fdc8d75150bf6587$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $fdc8d75150bf6587$var$$getPrototypeOf(value == null ? value : $fdc8d75150bf6587$var$$Object(value));
} : false;

});
parcelRegister("csNIY", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $eDiIz = parcelRequire("eDiIz");

var $9RlYm = parcelRequire("9RlYm");

var $2Y4BE = parcelRequire("2Y4BE");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eDiIz('a function is required');
    return $2Y4BE($a7ABz, $9RlYm, args);
};

});
parcelRegister("a7ABz", function(module, exports) {
'use strict';

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = '[object Function]';
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $923fbadf1e720976$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9RlYm", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("2Y4BE", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");

var $cnaFh = parcelRequire("cnaFh");
/** @type {import('./actualApply')} */ module.exports = $cnaFh || $a7ABz.call($9RlYm, $hsI1I);

});
parcelRegister("hsI1I", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cnaFh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("7Dte4", function(module, exports) {
'use strict';
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {import('.')} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});



parcelRegister("f6vGj", function(module, exports) {
'use strict';

var $gZq5J = parcelRequire("gZq5J");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gZq5J(value);
};

});
parcelRegister("gZq5J", function(module, exports) {
'use strict';

var $lF3bv = parcelRequire("lF3bv");

var $4WiZC = parcelRequire("4WiZC");

var $fWmVJ = parcelRequire("fWmVJ");

var $bhqNG = parcelRequire("bhqNG");

var $crSdH = parcelRequire("crSdH");
/** @type {(O: object) => string} */ var $c5e6950dc1e98562$var$$toString = $bhqNG('Object.prototype.toString');

var $c5e6950dc1e98562$var$hasToStringTag = (parcelRequire("d1SRx"))();
var $c5e6950dc1e98562$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c5e6950dc1e98562$var$typedArrays = $4WiZC();
var $c5e6950dc1e98562$var$$slice = $bhqNG('String.prototype.slice');
var $c5e6950dc1e98562$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c5e6950dc1e98562$var$$indexOf = $bhqNG('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $c5e6950dc1e98562$var$cache = {
    __proto__: null
};
if ($c5e6950dc1e98562$var$hasToStringTag && $crSdH && $c5e6950dc1e98562$var$getPrototypeOf) $lF3bv($c5e6950dc1e98562$var$typedArrays, function(typedArray) {
    var arr = new $c5e6950dc1e98562$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c5e6950dc1e98562$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $crSdH(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c5e6950dc1e98562$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $crSdH(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c5e6950dc1e98562$var$cache['$' + typedArray] = $fWmVJ(descriptor.get);
    }
});
else $lF3bv($c5e6950dc1e98562$var$typedArrays, function(typedArray) {
    var arr = new $c5e6950dc1e98562$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $c5e6950dc1e98562$var$cache['$' + typedArray] = $fWmVJ(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c5e6950dc1e98562$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lF3bv(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $c5e6950dc1e98562$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $c5e6950dc1e98562$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c5e6950dc1e98562$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lF3bv(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $c5e6950dc1e98562$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $c5e6950dc1e98562$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c5e6950dc1e98562$var$hasToStringTag) {
        /** @type {string} */ var tag = $c5e6950dc1e98562$var$$slice($c5e6950dc1e98562$var$$toString(value), 8, -1);
        if ($c5e6950dc1e98562$var$$indexOf($c5e6950dc1e98562$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c5e6950dc1e98562$var$trySlices(value);
    }
    if (!$crSdH) return null;
     // unknown engine
    return $c5e6950dc1e98562$var$tryTypedArrays(value);
};

});
parcelRegister("lF3bv", function(module, exports) {
'use strict';

var $8pyWb = parcelRequire("8pyWb");
var $fc4fe5af5b35393c$var$toStr = Object.prototype.toString;
var $fc4fe5af5b35393c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $fc4fe5af5b35393c$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($fc4fe5af5b35393c$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $fc4fe5af5b35393c$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $fc4fe5af5b35393c$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($fc4fe5af5b35393c$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $fc4fe5af5b35393c$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$8pyWb(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($fc4fe5af5b35393c$var$toStr.call(list) === '[object Array]') $fc4fe5af5b35393c$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $fc4fe5af5b35393c$var$forEachString(list, iterator, receiver);
    else $fc4fe5af5b35393c$var$forEachObject(list, iterator, receiver);
};
module.exports = $fc4fe5af5b35393c$var$forEach;

});
parcelRegister("8pyWb", function(module, exports) {
'use strict';
var $61fbc2635a6bc632$var$fnToStr = Function.prototype.toString;
var $61fbc2635a6bc632$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $61fbc2635a6bc632$var$badArrayLike;
var $61fbc2635a6bc632$var$isCallableMarker;
if (typeof $61fbc2635a6bc632$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $61fbc2635a6bc632$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $61fbc2635a6bc632$var$isCallableMarker;
        }
    });
    $61fbc2635a6bc632$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $61fbc2635a6bc632$var$reflectApply(function() {
        throw 42;
    }, null, $61fbc2635a6bc632$var$badArrayLike);
} catch (_) {
    if (_ !== $61fbc2635a6bc632$var$isCallableMarker) $61fbc2635a6bc632$var$reflectApply = null;
}
else $61fbc2635a6bc632$var$reflectApply = null;
var $61fbc2635a6bc632$var$constructorRegex = /^\s*class\b/;
var $61fbc2635a6bc632$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $61fbc2635a6bc632$var$fnToStr.call(value);
        return $61fbc2635a6bc632$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $61fbc2635a6bc632$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($61fbc2635a6bc632$var$isES6ClassFn(value)) return false;
        $61fbc2635a6bc632$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $61fbc2635a6bc632$var$toStr = Object.prototype.toString;
var $61fbc2635a6bc632$var$objectClass = '[object Object]';
var $61fbc2635a6bc632$var$fnClass = '[object Function]';
var $61fbc2635a6bc632$var$genClass = '[object GeneratorFunction]';
var $61fbc2635a6bc632$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $61fbc2635a6bc632$var$ddaClass2 = '[object HTML document.all class]';
var $61fbc2635a6bc632$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $61fbc2635a6bc632$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $61fbc2635a6bc632$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $61fbc2635a6bc632$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $61fbc2635a6bc632$var$all = document.all;
    if ($61fbc2635a6bc632$var$toStr.call($61fbc2635a6bc632$var$all) === $61fbc2635a6bc632$var$toStr.call(document.all)) $61fbc2635a6bc632$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($61fbc2635a6bc632$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $61fbc2635a6bc632$var$toStr.call(value);
            return (str === $61fbc2635a6bc632$var$ddaClass || str === $61fbc2635a6bc632$var$ddaClass2 || str === $61fbc2635a6bc632$var$ddaClass3 // opera 12.16
             || str === $61fbc2635a6bc632$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $61fbc2635a6bc632$var$reflectApply ? function isCallable(value) {
    if ($61fbc2635a6bc632$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $61fbc2635a6bc632$var$reflectApply(value, null, $61fbc2635a6bc632$var$badArrayLike);
    } catch (e) {
        if (e !== $61fbc2635a6bc632$var$isCallableMarker) return false;
    }
    return !$61fbc2635a6bc632$var$isES6ClassFn(value) && $61fbc2635a6bc632$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($61fbc2635a6bc632$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($61fbc2635a6bc632$var$hasToStringTag) return $61fbc2635a6bc632$var$tryFunctionObject(value);
    if ($61fbc2635a6bc632$var$isES6ClassFn(value)) return false;
    var strClass = $61fbc2635a6bc632$var$toStr.call(value);
    if (strClass !== $61fbc2635a6bc632$var$fnClass && strClass !== $61fbc2635a6bc632$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $61fbc2635a6bc632$var$tryFunctionObject(value);
};

});


parcelRegister("4WiZC", function(module, exports) {
'use strict';

var $2gCm2 = parcelRequire("2gCm2");
var $398b4fc8077d8698$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $2gCm2.length; i++)if (typeof $398b4fc8077d8698$var$g[$2gCm2[i]] === 'function') // @ts-expect-error
    out[out.length] = $2gCm2[i];
    return out;
};

});
parcelRegister("2gCm2", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("fWmVJ", function(module, exports) {
'use strict';

var $64wPI = parcelRequire("64wPI");

var $4jAFO = parcelRequire("4jAFO");

var $1eVlk = parcelRequire("1eVlk");

var $cfoUM = parcelRequire("cfoUM");
module.exports = function callBind(originalFunction) {
    var func = $1eVlk(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $64wPI(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($4jAFO) $4jAFO(module.exports, 'apply', {
    value: $cfoUM
});
else module.exports.apply = $cfoUM;

});
parcelRegister("64wPI", function(module, exports) {
'use strict';

var $iFhAO = parcelRequire("iFhAO");

var $26m4v = parcelRequire("26m4v");

var $46bc95c30a58fa4c$var$hasDescriptors = (parcelRequire("dhJs9"))();

var $O9kmX = parcelRequire("O9kmX");

var $eDiIz = parcelRequire("eDiIz");
var $46bc95c30a58fa4c$var$$floor = $iFhAO('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eDiIz('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $46bc95c30a58fa4c$var$$floor(length) !== length) throw new $eDiIz('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $O9kmX) {
        var desc = $O9kmX(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($46bc95c30a58fa4c$var$hasDescriptors) $26m4v(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $26m4v(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("iFhAO", function(module, exports) {
'use strict';
var $d969b3e6ce9838c1$var$undefined1;

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");
var $d969b3e6ce9838c1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $d969b3e6ce9838c1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $d969b3e6ce9838c1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $d969b3e6ce9838c1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($d969b3e6ce9838c1$var$$gOPD) try {
    $d969b3e6ce9838c1$var$$gOPD({}, '');
} catch (e) {
    $d969b3e6ce9838c1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $d969b3e6ce9838c1$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $d969b3e6ce9838c1$var$ThrowTypeError = $d969b3e6ce9838c1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $d969b3e6ce9838c1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $d969b3e6ce9838c1$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $d969b3e6ce9838c1$var$throwTypeError;
        }
    }
}() : $d969b3e6ce9838c1$var$throwTypeError;

var $d969b3e6ce9838c1$var$hasSymbols = (parcelRequire("5CmBX"))();

var $d969b3e6ce9838c1$var$hasProto = (parcelRequire("1q0DH"))();
var $d969b3e6ce9838c1$var$getProto = Object.getPrototypeOf || ($d969b3e6ce9838c1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $d969b3e6ce9838c1$var$needsEval = {};
var $d969b3e6ce9838c1$var$TypedArray = typeof Uint8Array === 'undefined' || !$d969b3e6ce9838c1$var$getProto ? undefined : $d969b3e6ce9838c1$var$getProto(Uint8Array);
var $d969b3e6ce9838c1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $d969b3e6ce9838c1$var$hasSymbols && $d969b3e6ce9838c1$var$getProto ? $d969b3e6ce9838c1$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $d969b3e6ce9838c1$var$needsEval,
    '%AsyncGenerator%': $d969b3e6ce9838c1$var$needsEval,
    '%AsyncGeneratorFunction%': $d969b3e6ce9838c1$var$needsEval,
    '%AsyncIteratorPrototype%': $d969b3e6ce9838c1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $d969b3e6ce9838c1$var$$Function,
    '%GeneratorFunction%': $d969b3e6ce9838c1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $d969b3e6ce9838c1$var$hasSymbols && $d969b3e6ce9838c1$var$getProto ? $d969b3e6ce9838c1$var$getProto($d969b3e6ce9838c1$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$d969b3e6ce9838c1$var$hasSymbols || !$d969b3e6ce9838c1$var$getProto ? undefined : $d969b3e6ce9838c1$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$d969b3e6ce9838c1$var$hasSymbols || !$d969b3e6ce9838c1$var$getProto ? undefined : $d969b3e6ce9838c1$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $d969b3e6ce9838c1$var$hasSymbols && $d969b3e6ce9838c1$var$getProto ? $d969b3e6ce9838c1$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $d969b3e6ce9838c1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $d969b3e6ce9838c1$var$ThrowTypeError,
    '%TypedArray%': $d969b3e6ce9838c1$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($d969b3e6ce9838c1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $d969b3e6ce9838c1$var$errorProto = $d969b3e6ce9838c1$var$getProto($d969b3e6ce9838c1$var$getProto(e));
    $d969b3e6ce9838c1$var$INTRINSICS['%Error.prototype%'] = $d969b3e6ce9838c1$var$errorProto;
}
var $d969b3e6ce9838c1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $d969b3e6ce9838c1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $d969b3e6ce9838c1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $d969b3e6ce9838c1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $d969b3e6ce9838c1$var$getProto) value = $d969b3e6ce9838c1$var$getProto(gen.prototype);
    }
    $d969b3e6ce9838c1$var$INTRINSICS[name] = value;
    return value;
};
var $d969b3e6ce9838c1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $hElW3 = parcelRequire("hElW3");
var $d969b3e6ce9838c1$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $d969b3e6ce9838c1$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $d969b3e6ce9838c1$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $d969b3e6ce9838c1$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $d969b3e6ce9838c1$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $d969b3e6ce9838c1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $d969b3e6ce9838c1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $d969b3e6ce9838c1$var$stringToPath = function stringToPath(string) {
    var first = $d969b3e6ce9838c1$var$$strSlice(string, 0, 1);
    var last = $d969b3e6ce9838c1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $d969b3e6ce9838c1$var$$replace(string, $d969b3e6ce9838c1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $d969b3e6ce9838c1$var$$replace(subString, $d969b3e6ce9838c1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $d969b3e6ce9838c1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($hElW3($d969b3e6ce9838c1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $d969b3e6ce9838c1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($hElW3($d969b3e6ce9838c1$var$INTRINSICS, intrinsicName)) {
        var value = $d969b3e6ce9838c1$var$INTRINSICS[intrinsicName];
        if (value === $d969b3e6ce9838c1$var$needsEval) value = $d969b3e6ce9838c1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($d969b3e6ce9838c1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $d969b3e6ce9838c1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $d969b3e6ce9838c1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $d969b3e6ce9838c1$var$$spliceApply(parts, $d969b3e6ce9838c1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $d969b3e6ce9838c1$var$$strSlice(part, 0, 1);
        var last = $d969b3e6ce9838c1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($hElW3($d969b3e6ce9838c1$var$INTRINSICS, intrinsicRealName)) value = $d969b3e6ce9838c1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($d969b3e6ce9838c1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $d969b3e6ce9838c1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $hElW3(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $d969b3e6ce9838c1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1q0DH", function(module, exports) {
'use strict';
var $1088b720f9e31113$var$test = {
    foo: {}
};
var $1088b720f9e31113$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $1088b720f9e31113$var$test
    }).foo === $1088b720f9e31113$var$test.foo && !(({
        __proto__: null
    }) instanceof $1088b720f9e31113$var$$Object);
};

});

parcelRegister("hElW3", function(module, exports) {
'use strict';
var $cd9730069716c4c8$var$call = Function.prototype.call;
var $cd9730069716c4c8$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $a7ABz.call($cd9730069716c4c8$var$call, $cd9730069716c4c8$var$$hasOwn);

});


parcelRegister("26m4v", function(module, exports) {
'use strict';

var $4jAFO = parcelRequire("4jAFO");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $f1fH9 = parcelRequire("f1fH9");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eDiIz('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eDiIz('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eDiIz('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eDiIz('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eDiIz('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eDiIz('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$f1fH9 && $f1fH9(obj, property);
    if ($4jAFO) $4jAFO(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $iOgL8('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});
parcelRegister("4jAFO", function(module, exports) {
'use strict';

var $f8Xrm = parcelRequire("f8Xrm");
/** @type {import('.')} */ var $3245625cab00454b$var$$defineProperty = $f8Xrm('%Object.defineProperty%', true) || false;
if ($3245625cab00454b$var$$defineProperty) try {
    $3245625cab00454b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3245625cab00454b$var$$defineProperty = false;
}
module.exports = $3245625cab00454b$var$$defineProperty;

});
parcelRegister("f8Xrm", function(module, exports) {
'use strict';
var $b065b5f487d1712c$var$undefined1;

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");
var $b065b5f487d1712c$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $b065b5f487d1712c$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $b065b5f487d1712c$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $b065b5f487d1712c$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($b065b5f487d1712c$var$$gOPD) try {
    $b065b5f487d1712c$var$$gOPD({}, '');
} catch (e) {
    $b065b5f487d1712c$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $b065b5f487d1712c$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $b065b5f487d1712c$var$ThrowTypeError = $b065b5f487d1712c$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $b065b5f487d1712c$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $b065b5f487d1712c$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $b065b5f487d1712c$var$throwTypeError;
        }
    }
}() : $b065b5f487d1712c$var$throwTypeError;

var $b065b5f487d1712c$var$hasSymbols = (parcelRequire("5CmBX"))();

var $b065b5f487d1712c$var$hasProto = (parcelRequire("1q0DH"))();
var $b065b5f487d1712c$var$getProto = Object.getPrototypeOf || ($b065b5f487d1712c$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $b065b5f487d1712c$var$needsEval = {};
var $b065b5f487d1712c$var$TypedArray = typeof Uint8Array === 'undefined' || !$b065b5f487d1712c$var$getProto ? undefined : $b065b5f487d1712c$var$getProto(Uint8Array);
var $b065b5f487d1712c$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $b065b5f487d1712c$var$hasSymbols && $b065b5f487d1712c$var$getProto ? $b065b5f487d1712c$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $b065b5f487d1712c$var$needsEval,
    '%AsyncGenerator%': $b065b5f487d1712c$var$needsEval,
    '%AsyncGeneratorFunction%': $b065b5f487d1712c$var$needsEval,
    '%AsyncIteratorPrototype%': $b065b5f487d1712c$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $b065b5f487d1712c$var$$Function,
    '%GeneratorFunction%': $b065b5f487d1712c$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $b065b5f487d1712c$var$hasSymbols && $b065b5f487d1712c$var$getProto ? $b065b5f487d1712c$var$getProto($b065b5f487d1712c$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$b065b5f487d1712c$var$hasSymbols || !$b065b5f487d1712c$var$getProto ? undefined : $b065b5f487d1712c$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$b065b5f487d1712c$var$hasSymbols || !$b065b5f487d1712c$var$getProto ? undefined : $b065b5f487d1712c$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $b065b5f487d1712c$var$hasSymbols && $b065b5f487d1712c$var$getProto ? $b065b5f487d1712c$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $b065b5f487d1712c$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $b065b5f487d1712c$var$ThrowTypeError,
    '%TypedArray%': $b065b5f487d1712c$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($b065b5f487d1712c$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $b065b5f487d1712c$var$errorProto = $b065b5f487d1712c$var$getProto($b065b5f487d1712c$var$getProto(e));
    $b065b5f487d1712c$var$INTRINSICS['%Error.prototype%'] = $b065b5f487d1712c$var$errorProto;
}
var $b065b5f487d1712c$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $b065b5f487d1712c$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $b065b5f487d1712c$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $b065b5f487d1712c$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $b065b5f487d1712c$var$getProto) value = $b065b5f487d1712c$var$getProto(gen.prototype);
    }
    $b065b5f487d1712c$var$INTRINSICS[name] = value;
    return value;
};
var $b065b5f487d1712c$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $6XO7n = parcelRequire("6XO7n");
var $b065b5f487d1712c$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $b065b5f487d1712c$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $b065b5f487d1712c$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $b065b5f487d1712c$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $b065b5f487d1712c$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $b065b5f487d1712c$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $b065b5f487d1712c$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $b065b5f487d1712c$var$stringToPath = function stringToPath(string) {
    var first = $b065b5f487d1712c$var$$strSlice(string, 0, 1);
    var last = $b065b5f487d1712c$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $b065b5f487d1712c$var$$replace(string, $b065b5f487d1712c$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $b065b5f487d1712c$var$$replace(subString, $b065b5f487d1712c$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $b065b5f487d1712c$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($6XO7n($b065b5f487d1712c$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $b065b5f487d1712c$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($6XO7n($b065b5f487d1712c$var$INTRINSICS, intrinsicName)) {
        var value = $b065b5f487d1712c$var$INTRINSICS[intrinsicName];
        if (value === $b065b5f487d1712c$var$needsEval) value = $b065b5f487d1712c$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($b065b5f487d1712c$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $b065b5f487d1712c$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $b065b5f487d1712c$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $b065b5f487d1712c$var$$spliceApply(parts, $b065b5f487d1712c$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $b065b5f487d1712c$var$$strSlice(part, 0, 1);
        var last = $b065b5f487d1712c$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($6XO7n($b065b5f487d1712c$var$INTRINSICS, intrinsicRealName)) value = $b065b5f487d1712c$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($b065b5f487d1712c$var$$gOPD && i + 1 >= parts.length) {
                var desc = $b065b5f487d1712c$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $6XO7n(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $b065b5f487d1712c$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("6XO7n", function(module, exports) {
'use strict';
var $511f212a6524f395$var$call = Function.prototype.call;
var $511f212a6524f395$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $a7ABz.call($511f212a6524f395$var$call, $511f212a6524f395$var$$hasOwn);

});



parcelRegister("f1fH9", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");
var $aef31fb9007382a1$var$$gOPD = $avqmt('%Object.getOwnPropertyDescriptor%', true);
if ($aef31fb9007382a1$var$$gOPD) try {
    $aef31fb9007382a1$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $aef31fb9007382a1$var$$gOPD = null;
}
module.exports = $aef31fb9007382a1$var$$gOPD;

});
parcelRegister("avqmt", function(module, exports) {
'use strict';
var $7a613f7503e09dde$var$undefined1;
var $7a613f7503e09dde$var$$SyntaxError = SyntaxError;
var $7a613f7503e09dde$var$$Function = Function;
var $7a613f7503e09dde$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $7a613f7503e09dde$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7a613f7503e09dde$var$$gOPD) try {
    $7a613f7503e09dde$var$$gOPD({}, '');
} catch (e) {
    $7a613f7503e09dde$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $7a613f7503e09dde$var$$TypeError();
};
var $7a613f7503e09dde$var$ThrowTypeError = $7a613f7503e09dde$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7a613f7503e09dde$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $7a613f7503e09dde$var$hasProto = (parcelRequire("1q0DH"))();
var $7a613f7503e09dde$var$getProto = Object.getPrototypeOf || ($7a613f7503e09dde$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === 'undefined' || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGenerator%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncIteratorPrototype%': $7a613f7503e09dde$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $7a613f7503e09dde$var$$Function,
    '%GeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $7a613f7503e09dde$var$$SyntaxError,
    '%ThrowTypeError%': $7a613f7503e09dde$var$ThrowTypeError,
    '%TypedArray%': $7a613f7503e09dde$var$TypedArray,
    '%TypeError%': $7a613f7503e09dde$var$$TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($7a613f7503e09dde$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto(e));
    $7a613f7503e09dde$var$INTRINSICS['%Error.prototype%'] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $7a613f7503e09dde$var$getProto) value = $7a613f7503e09dde$var$getProto(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $fWEXb = parcelRequire("fWEXb");
var $7a613f7503e09dde$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $7a613f7503e09dde$var$$SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $7a613f7503e09dde$var$$SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($fWEXb($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($fWEXb($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $7a613f7503e09dde$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $7a613f7503e09dde$var$$SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $7a613f7503e09dde$var$$TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $7a613f7503e09dde$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $7a613f7503e09dde$var$$SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $7a613f7503e09dde$var$$SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($fWEXb($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7a613f7503e09dde$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7a613f7503e09dde$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7a613f7503e09dde$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $fWEXb(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("fWEXb", function(module, exports) {
'use strict';
var $b9bc0a4e36e9f1fa$var$call = Function.prototype.call;
var $b9bc0a4e36e9f1fa$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $a7ABz.call($b9bc0a4e36e9f1fa$var$call, $b9bc0a4e36e9f1fa$var$$hasOwn);

});




parcelRegister("dhJs9", function(module, exports) {
'use strict';

var $4jAFO = parcelRequire("4jAFO");
var $9ac01ef16d8b0add$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$4jAFO;
};
$9ac01ef16d8b0add$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$4jAFO) return null;
    try {
        return $4jAFO([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9ac01ef16d8b0add$var$hasPropertyDescriptors;

});

parcelRegister("O9kmX", function(module, exports) {
'use strict';

var $adO4a = parcelRequire("adO4a");
var $096be7e1a0fec8c5$var$$gOPD = $adO4a('%Object.getOwnPropertyDescriptor%', true);
if ($096be7e1a0fec8c5$var$$gOPD) try {
    $096be7e1a0fec8c5$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $096be7e1a0fec8c5$var$$gOPD = null;
}
module.exports = $096be7e1a0fec8c5$var$$gOPD;

});
parcelRegister("adO4a", function(module, exports) {
'use strict';
var $7711f468412c79bf$var$undefined1;
var $7711f468412c79bf$var$$SyntaxError = SyntaxError;
var $7711f468412c79bf$var$$Function = Function;
var $7711f468412c79bf$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $7711f468412c79bf$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7711f468412c79bf$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $7711f468412c79bf$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7711f468412c79bf$var$$gOPD) try {
    $7711f468412c79bf$var$$gOPD({}, '');
} catch (e) {
    $7711f468412c79bf$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7711f468412c79bf$var$throwTypeError = function() {
    throw new $7711f468412c79bf$var$$TypeError();
};
var $7711f468412c79bf$var$ThrowTypeError = $7711f468412c79bf$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7711f468412c79bf$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7711f468412c79bf$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $7711f468412c79bf$var$throwTypeError;
        }
    }
}() : $7711f468412c79bf$var$throwTypeError;

var $7711f468412c79bf$var$hasSymbols = (parcelRequire("5CmBX"))();

var $7711f468412c79bf$var$hasProto = (parcelRequire("1q0DH"))();
var $7711f468412c79bf$var$getProto = Object.getPrototypeOf || ($7711f468412c79bf$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7711f468412c79bf$var$needsEval = {};
var $7711f468412c79bf$var$TypedArray = typeof Uint8Array === 'undefined' || !$7711f468412c79bf$var$getProto ? undefined : $7711f468412c79bf$var$getProto(Uint8Array);
var $7711f468412c79bf$var$INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $7711f468412c79bf$var$hasSymbols && $7711f468412c79bf$var$getProto ? $7711f468412c79bf$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $7711f468412c79bf$var$needsEval,
    '%AsyncGenerator%': $7711f468412c79bf$var$needsEval,
    '%AsyncGeneratorFunction%': $7711f468412c79bf$var$needsEval,
    '%AsyncIteratorPrototype%': $7711f468412c79bf$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $7711f468412c79bf$var$$Function,
    '%GeneratorFunction%': $7711f468412c79bf$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $7711f468412c79bf$var$hasSymbols && $7711f468412c79bf$var$getProto ? $7711f468412c79bf$var$getProto($7711f468412c79bf$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$7711f468412c79bf$var$hasSymbols || !$7711f468412c79bf$var$getProto ? undefined : $7711f468412c79bf$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$7711f468412c79bf$var$hasSymbols || !$7711f468412c79bf$var$getProto ? undefined : $7711f468412c79bf$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $7711f468412c79bf$var$hasSymbols && $7711f468412c79bf$var$getProto ? $7711f468412c79bf$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $7711f468412c79bf$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $7711f468412c79bf$var$$SyntaxError,
    '%ThrowTypeError%': $7711f468412c79bf$var$ThrowTypeError,
    '%TypedArray%': $7711f468412c79bf$var$TypedArray,
    '%TypeError%': $7711f468412c79bf$var$$TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($7711f468412c79bf$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7711f468412c79bf$var$errorProto = $7711f468412c79bf$var$getProto($7711f468412c79bf$var$getProto(e));
    $7711f468412c79bf$var$INTRINSICS['%Error.prototype%'] = $7711f468412c79bf$var$errorProto;
}
var $7711f468412c79bf$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $7711f468412c79bf$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $7711f468412c79bf$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $7711f468412c79bf$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $7711f468412c79bf$var$getProto) value = $7711f468412c79bf$var$getProto(gen.prototype);
    }
    $7711f468412c79bf$var$INTRINSICS[name] = value;
    return value;
};
var $7711f468412c79bf$var$LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $hElW3 = parcelRequire("hElW3");
var $7711f468412c79bf$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $7711f468412c79bf$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $7711f468412c79bf$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $7711f468412c79bf$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $7711f468412c79bf$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7711f468412c79bf$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7711f468412c79bf$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7711f468412c79bf$var$stringToPath = function stringToPath(string) {
    var first = $7711f468412c79bf$var$$strSlice(string, 0, 1);
    var last = $7711f468412c79bf$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $7711f468412c79bf$var$$SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $7711f468412c79bf$var$$SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $7711f468412c79bf$var$$replace(string, $7711f468412c79bf$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7711f468412c79bf$var$$replace(subString, $7711f468412c79bf$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $7711f468412c79bf$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($hElW3($7711f468412c79bf$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7711f468412c79bf$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($hElW3($7711f468412c79bf$var$INTRINSICS, intrinsicName)) {
        var value = $7711f468412c79bf$var$INTRINSICS[intrinsicName];
        if (value === $7711f468412c79bf$var$needsEval) value = $7711f468412c79bf$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $7711f468412c79bf$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $7711f468412c79bf$var$$SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $7711f468412c79bf$var$$TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $7711f468412c79bf$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($7711f468412c79bf$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $7711f468412c79bf$var$$SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $7711f468412c79bf$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $7711f468412c79bf$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7711f468412c79bf$var$$spliceApply(parts, $7711f468412c79bf$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7711f468412c79bf$var$$strSlice(part, 0, 1);
        var last = $7711f468412c79bf$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $7711f468412c79bf$var$$SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($hElW3($7711f468412c79bf$var$INTRINSICS, intrinsicRealName)) value = $7711f468412c79bf$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7711f468412c79bf$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7711f468412c79bf$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7711f468412c79bf$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $hElW3(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7711f468412c79bf$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});



parcelRegister("1eVlk", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $eDiIz = parcelRequire("eDiIz");

var $7IKhL = parcelRequire("7IKhL");

var $k1EQC = parcelRequire("k1EQC");
/** @type {import('.')} */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eDiIz('a function is required');
    return $k1EQC($a7ABz, $7IKhL, args);
};

});
parcelRegister("7IKhL", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("k1EQC", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $lqk9Y = parcelRequire("lqk9Y");

var $7IKhL = parcelRequire("7IKhL");

var $2f4vS = parcelRequire("2f4vS");
/** @type {import('./actualApply')} */ module.exports = $2f4vS || $a7ABz.call($7IKhL, $lqk9Y);

});
parcelRegister("lqk9Y", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("2f4vS", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});



parcelRegister("cfoUM", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $lqk9Y = parcelRequire("lqk9Y");

var $k1EQC = parcelRequire("k1EQC");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $k1EQC($a7ABz, $lqk9Y, arguments);
};

});


parcelRegister("d1SRx", function(module, exports) {
'use strict';

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $fNdnD() && !!Symbol.toStringTag;
};

});







parcelRegister("lyJtz", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $fb200c8a1442e09f$require$Buffer = $6U9mG.Buffer;
var $fb200c8a1442e09f$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fb200c8a1442e09f$var$W = new Array(80);
function $fb200c8a1442e09f$var$Sha1() {
    this.init();
    this._w = $fb200c8a1442e09f$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($fb200c8a1442e09f$var$Sha1, $6fUHB);
$fb200c8a1442e09f$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fb200c8a1442e09f$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $fb200c8a1442e09f$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fb200c8a1442e09f$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fb200c8a1442e09f$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fb200c8a1442e09f$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $fb200c8a1442e09f$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fb200c8a1442e09f$var$rotl5(a) + $fb200c8a1442e09f$var$ft(s, b, c, d) + e + w[j] + $fb200c8a1442e09f$var$K[s] | 0;
        e = d;
        d = c;
        c = $fb200c8a1442e09f$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fb200c8a1442e09f$var$Sha1.prototype._hash = function() {
    var H = $fb200c8a1442e09f$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fb200c8a1442e09f$var$Sha1;

});

parcelRegister("cwjAo", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $1o1iT = parcelRequire("1o1iT");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $91d7aa8b17a16320$require$Buffer = $6U9mG.Buffer;
var $91d7aa8b17a16320$var$W = new Array(64);
function $91d7aa8b17a16320$var$Sha224() {
    this.init();
    this._w = $91d7aa8b17a16320$var$W; // new Array(64)
    $6fUHB.call(this, 64, 56);
}
$eSHUL($91d7aa8b17a16320$var$Sha224, $1o1iT);
$91d7aa8b17a16320$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$91d7aa8b17a16320$var$Sha224.prototype._hash = function() {
    var H = $91d7aa8b17a16320$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $91d7aa8b17a16320$var$Sha224;

});
parcelRegister("1o1iT", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $10290b3c9978cdf8$require$Buffer = $6U9mG.Buffer;
var $10290b3c9978cdf8$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $10290b3c9978cdf8$var$W = new Array(64);
function $10290b3c9978cdf8$var$Sha256() {
    this.init();
    this._w = $10290b3c9978cdf8$var$W; // new Array(64)
    $6fUHB.call(this, 64, 56);
}
$eSHUL($10290b3c9978cdf8$var$Sha256, $6fUHB);
$10290b3c9978cdf8$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $10290b3c9978cdf8$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $10290b3c9978cdf8$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $10290b3c9978cdf8$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $10290b3c9978cdf8$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $10290b3c9978cdf8$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $10290b3c9978cdf8$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$10290b3c9978cdf8$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $10290b3c9978cdf8$var$gamma1(w[i - 2]) + w[i - 7] + $10290b3c9978cdf8$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $10290b3c9978cdf8$var$sigma1(e) + $10290b3c9978cdf8$var$ch(e, f, g) + $10290b3c9978cdf8$var$K[j] + w[j] | 0;
        var T2 = $10290b3c9978cdf8$var$sigma0(a) + $10290b3c9978cdf8$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$10290b3c9978cdf8$var$Sha256.prototype._hash = function() {
    var H = $10290b3c9978cdf8$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $10290b3c9978cdf8$var$Sha256;

});


parcelRegister("kWtXA", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $1HQNC = parcelRequire("1HQNC");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $f3f076e48793fba5$require$Buffer = $6U9mG.Buffer;
var $f3f076e48793fba5$var$W = new Array(160);
function $f3f076e48793fba5$var$Sha384() {
    this.init();
    this._w = $f3f076e48793fba5$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($f3f076e48793fba5$var$Sha384, $1HQNC);
$f3f076e48793fba5$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$f3f076e48793fba5$var$Sha384.prototype._hash = function() {
    var H = $f3f076e48793fba5$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $f3f076e48793fba5$var$Sha384;

});
parcelRegister("1HQNC", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $13e2c371a41c8789$require$Buffer = $6U9mG.Buffer;
var $13e2c371a41c8789$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $13e2c371a41c8789$var$W = new Array(160);
function $13e2c371a41c8789$var$Sha512() {
    this.init();
    this._w = $13e2c371a41c8789$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($13e2c371a41c8789$var$Sha512, $6fUHB);
$13e2c371a41c8789$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $13e2c371a41c8789$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $13e2c371a41c8789$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $13e2c371a41c8789$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $13e2c371a41c8789$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $13e2c371a41c8789$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $13e2c371a41c8789$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $13e2c371a41c8789$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $13e2c371a41c8789$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $13e2c371a41c8789$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$13e2c371a41c8789$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $13e2c371a41c8789$var$Gamma0(xh, xl);
        var gamma0l = $13e2c371a41c8789$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $13e2c371a41c8789$var$Gamma1(xh, xl);
        var gamma1l = $13e2c371a41c8789$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $13e2c371a41c8789$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $13e2c371a41c8789$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $13e2c371a41c8789$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $13e2c371a41c8789$var$maj(ah, bh, ch);
        var majl = $13e2c371a41c8789$var$maj(al, bl, cl);
        var sigma0h = $13e2c371a41c8789$var$sigma0(ah, al);
        var sigma0l = $13e2c371a41c8789$var$sigma0(al, ah);
        var sigma1h = $13e2c371a41c8789$var$sigma1(eh, el);
        var sigma1l = $13e2c371a41c8789$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $13e2c371a41c8789$var$K[j];
        var Kil = $13e2c371a41c8789$var$K[j + 1];
        var chh = $13e2c371a41c8789$var$Ch(eh, fh, gh);
        var chl = $13e2c371a41c8789$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $13e2c371a41c8789$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $13e2c371a41c8789$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $13e2c371a41c8789$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $13e2c371a41c8789$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $13e2c371a41c8789$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $13e2c371a41c8789$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $13e2c371a41c8789$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $13e2c371a41c8789$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $13e2c371a41c8789$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $13e2c371a41c8789$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $13e2c371a41c8789$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $13e2c371a41c8789$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $13e2c371a41c8789$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $13e2c371a41c8789$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $13e2c371a41c8789$var$getCarry(this._hl, hl) | 0;
};
$13e2c371a41c8789$var$Sha512.prototype._hash = function() {
    var H = $13e2c371a41c8789$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $13e2c371a41c8789$var$Sha512;

});



parcelRegister("fpHcA", function(module, exports) {
'use strict';

var $6U9mG = parcelRequire("6U9mG");
var $b38ab3d1a7f86ec9$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $b38ab3d1a7f86ec9$require$Transform = $bks2w.Transform;

var $lEpDX = parcelRequire("lEpDX");
var $b38ab3d1a7f86ec9$require$StringDecoder = $lEpDX.StringDecoder;

var $eSHUL = parcelRequire("eSHUL");

var $lePHA = parcelRequire("lePHA");
function $b38ab3d1a7f86ec9$var$CipherBase(hashMode) {
    $b38ab3d1a7f86ec9$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$eSHUL($b38ab3d1a7f86ec9$var$CipherBase, $b38ab3d1a7f86ec9$require$Transform);
$b38ab3d1a7f86ec9$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $lePHA(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAutoPadding = function() {};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $b38ab3d1a7f86ec9$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $b38ab3d1a7f86ec9$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $b38ab3d1a7f86ec9$var$CipherBase;

});
parcelRegister("bks2w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $83f7500f17fcc367$var$Stream;

var $jMc9N = parcelRequire("jMc9N");
var $83f7500f17fcc367$require$EE = $jMc9N.EventEmitter;

var $eSHUL = parcelRequire("eSHUL");
$eSHUL($83f7500f17fcc367$var$Stream, $83f7500f17fcc367$require$EE);

$83f7500f17fcc367$var$Stream.Readable = (parcelRequire("cEnbP"));

$83f7500f17fcc367$var$Stream.Writable = (parcelRequire("cuAoD"));

$83f7500f17fcc367$var$Stream.Duplex = (parcelRequire("2Hlr9"));

$83f7500f17fcc367$var$Stream.Transform = (parcelRequire("l7DDn"));

$83f7500f17fcc367$var$Stream.PassThrough = (parcelRequire("6VFzs"));

$83f7500f17fcc367$var$Stream.finished = (parcelRequire("gr8mb"));

$83f7500f17fcc367$var$Stream.pipeline = (parcelRequire("e8JAK"));
// Backwards-compat with node 0.4.x
$83f7500f17fcc367$var$Stream.Stream = $83f7500f17fcc367$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $83f7500f17fcc367$var$Stream() {
    $83f7500f17fcc367$require$EE.call(this);
}
$83f7500f17fcc367$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($83f7500f17fcc367$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("cUvgf", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $bRBTe = parcelRequire("bRBTe");

var $fpHcA = parcelRequire("fpHcA");

var $6U9mG = parcelRequire("6U9mG");
var $9662f6cbdeac7c49$require$Buffer = $6U9mG.Buffer;

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");
var $9662f6cbdeac7c49$var$ZEROS = $9662f6cbdeac7c49$require$Buffer.alloc(128);
function $9662f6cbdeac7c49$var$Hmac(alg, key) {
    $fpHcA.call(this, 'digest');
    if (typeof key === 'string') key = $9662f6cbdeac7c49$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $cjuEr() : $fkJVr(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $9662f6cbdeac7c49$require$Buffer.concat([
        key,
        $9662f6cbdeac7c49$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $cjuEr() : $fkJVr(alg);
    this._hash.update(ipad);
}
$eSHUL($9662f6cbdeac7c49$var$Hmac, $fpHcA);
$9662f6cbdeac7c49$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$9662f6cbdeac7c49$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $cjuEr() : $fkJVr(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $9662f6cbdeac7c49$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $bRBTe($5GY4Y, key);
    return new $9662f6cbdeac7c49$var$Hmac(alg, key);
};

});
parcelRegister("bRBTe", function(module, exports) {
'use strict';

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $8a32091105b403f5$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");
var $8a32091105b403f5$var$ZEROS = $8a32091105b403f5$require$Buffer.alloc(128);
var $8a32091105b403f5$var$blocksize = 64;
function $8a32091105b403f5$var$Hmac(alg, key) {
    $fpHcA.call(this, 'digest');
    if (typeof key === 'string') key = $8a32091105b403f5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $8a32091105b403f5$var$blocksize) key = alg(key);
    else if (key.length < $8a32091105b403f5$var$blocksize) key = $8a32091105b403f5$require$Buffer.concat([
        key,
        $8a32091105b403f5$var$ZEROS
    ], $8a32091105b403f5$var$blocksize);
    var ipad = this._ipad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    var opad = this._opad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    for(var i = 0; i < $8a32091105b403f5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$eSHUL($8a32091105b403f5$var$Hmac, $fpHcA);
$8a32091105b403f5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$8a32091105b403f5$var$Hmac.prototype._final = function() {
    var h = this._alg($8a32091105b403f5$require$Buffer.concat(this._hash));
    return this._alg($8a32091105b403f5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $8a32091105b403f5$var$Hmac;

});

parcelRegister("5GY4Y", function(module, exports) {

var $cvCaQ = parcelRequire("cvCaQ");
module.exports = function(buffer) {
    return new $cvCaQ().update(buffer).digest();
};

});



parcelRegister("1Vf4C", function(module, exports) {
'use strict';

var $3FiLE = parcelRequire("3FiLE");

var $g1FRD = parcelRequire("g1FRD");
// SHA256(SHA256(buffer))
function $1666ce9de42769b3$var$sha256x2(buffer) {
    var tmp = $3FiLE('sha256').update(buffer).digest();
    return $3FiLE('sha256').update(tmp).digest();
}
module.exports = $g1FRD($1666ce9de42769b3$var$sha256x2);

});
parcelRegister("g1FRD", function(module, exports) {
'use strict';

var $dSuum = parcelRequire("dSuum");

var $6U9mG = parcelRequire("6U9mG");
var $baad36aa31fd3816$require$Buffer = $6U9mG.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $dSuum.encode($baad36aa31fd3816$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $dSuum.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $dSuum.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("dSuum", function(module, exports) {

var $kG2My = parcelRequire("kG2My");
var $a1a7f7e9dc6810a7$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $kG2My($a1a7f7e9dc6810a7$var$ALPHABET);

});



parcelRegister("bAAqK", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $86ff50d9446c20a0$require$Buffer = $ihoyg.Buffer;

var $l8769 = parcelRequire("l8769");

var $8J1ou = parcelRequire("8J1ou");
var $86ff50d9446c20a0$require$EC = $8J1ou.ec;
const $86ff50d9446c20a0$var$secp256k1 = new $86ff50d9446c20a0$require$EC('secp256k1');

var $6JcDT = parcelRequire("6JcDT");
const $86ff50d9446c20a0$var$ZERO32 = $86ff50d9446c20a0$require$Buffer.alloc(32, 0);
const $86ff50d9446c20a0$var$EC_GROUP_ORDER = $86ff50d9446c20a0$require$Buffer.from('fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141', 'hex');
const $86ff50d9446c20a0$var$EC_P = $86ff50d9446c20a0$require$Buffer.from('fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f', 'hex');
const $86ff50d9446c20a0$var$n = $86ff50d9446c20a0$var$secp256k1.curve.n;
const $86ff50d9446c20a0$var$nDiv2 = $86ff50d9446c20a0$var$n.shrn(1);
const $86ff50d9446c20a0$var$G = $86ff50d9446c20a0$var$secp256k1.curve.g;
const $86ff50d9446c20a0$var$THROW_BAD_PRIVATE = 'Expected Private';
const $86ff50d9446c20a0$var$THROW_BAD_POINT = 'Expected Point';
const $86ff50d9446c20a0$var$THROW_BAD_TWEAK = 'Expected Tweak';
const $86ff50d9446c20a0$var$THROW_BAD_HASH = 'Expected Hash';
const $86ff50d9446c20a0$var$THROW_BAD_SIGNATURE = 'Expected Signature';
const $86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA = 'Expected Extra Data (32 bytes)';
function $86ff50d9446c20a0$var$isScalar(x) {
    return $86ff50d9446c20a0$require$Buffer.isBuffer(x) && x.length === 32;
}
function $86ff50d9446c20a0$var$isOrderScalar(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isPoint(p) {
    if (!$86ff50d9446c20a0$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (x.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $86ff50d9446c20a0$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (y.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $86ff50d9446c20a0$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $86ff50d9446c20a0$var$isPointCompressed(p) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) return false;
    return $86ff50d9446c20a0$var$__isPointCompressed(p);
}
function $86ff50d9446c20a0$var$isPrivate(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$ZERO32) > 0 && // > 0
    x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $86ff50d9446c20a0$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 && s.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0;
}
function $86ff50d9446c20a0$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $86ff50d9446c20a0$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $86ff50d9446c20a0$var$fromBuffer(d) {
    return new $l8769(d);
}
function $86ff50d9446c20a0$var$toBuffer(d) {
    return d.toArrayLike($86ff50d9446c20a0$require$Buffer, 'be', 32);
}
function $86ff50d9446c20a0$var$decodeFrom(P) {
    return $86ff50d9446c20a0$var$secp256k1.curve.decodePoint(P);
}
function $86ff50d9446c20a0$var$getEncoded(P, compressed) {
    return $86ff50d9446c20a0$require$Buffer.from(P._encode(compressed));
}
function $86ff50d9446c20a0$var$pointAdd(pA, pB, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(pA)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isPoint(pB)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const a = $86ff50d9446c20a0$var$decodeFrom(pA);
    const b = $86ff50d9446c20a0$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, pA);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointAddScalar(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (tweak.compare($86ff50d9446c20a0$var$ZERO32) === 0) return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = $86ff50d9446c20a0$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(uu, compressed);
}
function $86ff50d9446c20a0$var$pointCompress(p, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointFromScalar(d, __compressed) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const pp = $86ff50d9446c20a0$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointMultiply(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(qq, compressed);
}
function $86ff50d9446c20a0$var$privateAdd(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.add(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$privateSub(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.sub(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$sign(hash, x) {
    return $86ff50d9446c20a0$var$__sign(hash, x);
}
function $86ff50d9446c20a0$var$signWithEntropy(hash, x, addData) {
    return $86ff50d9446c20a0$var$__sign(hash, x, addData);
}
function $86ff50d9446c20a0$var$__sign(hash, x, addData) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPrivate(x)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$86ff50d9446c20a0$var$isScalar(addData)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA);
    const d = $86ff50d9446c20a0$var$fromBuffer(x);
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $86ff50d9446c20a0$var$fromBuffer(k);
        const Q = $86ff50d9446c20a0$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($86ff50d9446c20a0$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($86ff50d9446c20a0$var$n).mul(e.add(d.mul(r))).umod($86ff50d9446c20a0$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $6JcDT(hash, x, checkSig, $86ff50d9446c20a0$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) s = $86ff50d9446c20a0$var$n.sub(s);
    const buffer = $86ff50d9446c20a0$require$Buffer.allocUnsafe(64);
    $86ff50d9446c20a0$var$toBuffer(r).copy(buffer, 0);
    $86ff50d9446c20a0$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $86ff50d9446c20a0$var$verify(hash, q, signature, strict) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPoint(q)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$86ff50d9446c20a0$var$isSignature(signature)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_SIGNATURE);
    const Q = $86ff50d9446c20a0$var$decodeFrom(q);
    const r = $86ff50d9446c20a0$var$fromBuffer(signature.slice(0, 32));
    const s = $86ff50d9446c20a0$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($86ff50d9446c20a0$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($86ff50d9446c20a0$var$n);
    const u2 = r.mul(sInv).umod($86ff50d9446c20a0$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $86ff50d9446c20a0$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($86ff50d9446c20a0$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
module.exports = {
    isPoint: $86ff50d9446c20a0$var$isPoint,
    isPointCompressed: $86ff50d9446c20a0$var$isPointCompressed,
    isPrivate: $86ff50d9446c20a0$var$isPrivate,
    pointAdd: $86ff50d9446c20a0$var$pointAdd,
    pointAddScalar: $86ff50d9446c20a0$var$pointAddScalar,
    pointCompress: $86ff50d9446c20a0$var$pointCompress,
    pointFromScalar: $86ff50d9446c20a0$var$pointFromScalar,
    pointMultiply: $86ff50d9446c20a0$var$pointMultiply,
    privateAdd: $86ff50d9446c20a0$var$privateAdd,
    privateSub: $86ff50d9446c20a0$var$privateSub,
    sign: $86ff50d9446c20a0$var$sign,
    signWithEntropy: $86ff50d9446c20a0$var$signWithEntropy,
    verify: $86ff50d9446c20a0$var$verify
};

});
parcelRegister("l8769", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8J1ou", function(module, exports) {
'use strict';
var $65a39b84537b61c7$var$elliptic = module.exports;

$65a39b84537b61c7$var$elliptic.version = (parcelRequire("jfwBV")).version;

$65a39b84537b61c7$var$elliptic.utils = (parcelRequire("ZdcNb"));

$65a39b84537b61c7$var$elliptic.rand = (parcelRequire("9JRha"));

$65a39b84537b61c7$var$elliptic.curve = (parcelRequire("fYJT3"));

$65a39b84537b61c7$var$elliptic.curves = (parcelRequire("hwVHR"));

// Protocols
$65a39b84537b61c7$var$elliptic.ec = (parcelRequire("9lW0h"));

$65a39b84537b61c7$var$elliptic.eddsa = (parcelRequire("96jZE"));

});
parcelRegister("jfwBV", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.5.4\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("ZdcNb", function(module, exports) {
'use strict';
var $0b7ff0ec21b47efd$var$utils = module.exports;

var $6soDQ = parcelRequire("6soDQ");

var $aJt1P = parcelRequire("aJt1P");

var $6J8qY = parcelRequire("6J8qY");
$0b7ff0ec21b47efd$var$utils.assert = $aJt1P;
$0b7ff0ec21b47efd$var$utils.toArray = $6J8qY.toArray;
$0b7ff0ec21b47efd$var$utils.zero2 = $6J8qY.zero2;
$0b7ff0ec21b47efd$var$utils.toHex = $6J8qY.toHex;
$0b7ff0ec21b47efd$var$utils.encode = $6J8qY.encode;
// Represent num in a w-NAF form
function $0b7ff0ec21b47efd$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$0b7ff0ec21b47efd$var$utils.getNAF = $0b7ff0ec21b47efd$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $0b7ff0ec21b47efd$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$0b7ff0ec21b47efd$var$utils.getJSF = $0b7ff0ec21b47efd$var$getJSF;
function $0b7ff0ec21b47efd$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$0b7ff0ec21b47efd$var$utils.cachedProperty = $0b7ff0ec21b47efd$var$cachedProperty;
function $0b7ff0ec21b47efd$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $0b7ff0ec21b47efd$var$utils.toArray(bytes, 'hex') : bytes;
}
$0b7ff0ec21b47efd$var$utils.parseBytes = $0b7ff0ec21b47efd$var$parseBytes;
function $0b7ff0ec21b47efd$var$intFromLE(bytes) {
    return new $6soDQ(bytes, 'hex', 'le');
}
$0b7ff0ec21b47efd$var$utils.intFromLE = $0b7ff0ec21b47efd$var$intFromLE;

});
parcelRegister("6soDQ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("aJt1P", function(module, exports) {
module.exports = $7d049fca35679f9f$var$assert;
function $7d049fca35679f9f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$7d049fca35679f9f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});

parcelRegister("6J8qY", function(module, exports) {
'use strict';
var $4e5d7ce234b4cbb5$var$utils = module.exports;
function $4e5d7ce234b4cbb5$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toArray = $4e5d7ce234b4cbb5$var$toArray;
function $4e5d7ce234b4cbb5$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$4e5d7ce234b4cbb5$var$utils.zero2 = $4e5d7ce234b4cbb5$var$zero2;
function $4e5d7ce234b4cbb5$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $4e5d7ce234b4cbb5$var$zero2(msg[i].toString(16));
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toHex = $4e5d7ce234b4cbb5$var$toHex;
$4e5d7ce234b4cbb5$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $4e5d7ce234b4cbb5$var$toHex(arr);
    else return arr;
};

});


parcelRegister("9JRha", function(module, exports) {
var $7171a486633c2eed$var$r;
module.exports = function rand(len) {
    if (!$7171a486633c2eed$var$r) $7171a486633c2eed$var$r = new $7171a486633c2eed$var$Rand(null);
    return $7171a486633c2eed$var$r.generate(len);
};
function $7171a486633c2eed$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $7171a486633c2eed$var$Rand;
$7171a486633c2eed$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $7171a486633c2eed$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $7171a486633c2eed$var$crypto = (parcelRequire("5Io6y"));
    if (typeof $7171a486633c2eed$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        return $7171a486633c2eed$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("fYJT3", function(module, exports) {
'use strict';
var $ba200dd58ee56ab1$var$curve = module.exports;

$ba200dd58ee56ab1$var$curve.base = (parcelRequire("1dHTG"));

$ba200dd58ee56ab1$var$curve.short = (parcelRequire("laKc8"));

$ba200dd58ee56ab1$var$curve.mont = (parcelRequire("3uGhx"));

$ba200dd58ee56ab1$var$curve.edwards = (parcelRequire("a0HUE"));

});
parcelRegister("1dHTG", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $0e390e60fe847ab5$var$getNAF = $ZdcNb.getNAF;
var $0e390e60fe847ab5$var$getJSF = $ZdcNb.getJSF;
var $0e390e60fe847ab5$var$assert = $ZdcNb.assert;
function $0e390e60fe847ab5$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $6soDQ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $6soDQ.red(conf.prime) : $6soDQ.mont(this.p);
    // Useful for many curves
    this.zero = new $6soDQ(0).toRed(this.red);
    this.one = new $6soDQ(1).toRed(this.red);
    this.two = new $6soDQ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $6soDQ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $0e390e60fe847ab5$var$BaseCurve;
$0e390e60fe847ab5$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$0e390e60fe847ab5$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$0e390e60fe847ab5$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $0e390e60fe847ab5$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $0e390e60fe847ab5$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $0e390e60fe847ab5$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $0e390e60fe847ab5$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $0e390e60fe847ab5$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $0e390e60fe847ab5$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $0e390e60fe847ab5$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $0e390e60fe847ab5$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$0e390e60fe847ab5$var$BaseCurve.BasePoint = $0e390e60fe847ab5$var$BasePoint;
$0e390e60fe847ab5$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$0e390e60fe847ab5$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$0e390e60fe847ab5$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $ZdcNb.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$0e390e60fe847ab5$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$0e390e60fe847ab5$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$0e390e60fe847ab5$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $ZdcNb.encode(this._encode(compact), enc);
};
$0e390e60fe847ab5$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$0e390e60fe847ab5$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$0e390e60fe847ab5$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$0e390e60fe847ab5$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("laKc8", function(module, exports) {
'use strict';

var $ZdcNb = parcelRequire("ZdcNb");

var $6soDQ = parcelRequire("6soDQ");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $f69e5d783a5b036a$var$assert = $ZdcNb.assert;
function $f69e5d783a5b036a$var$ShortCurve(conf) {
    $1dHTG.call(this, 'short', conf);
    this.a = new $6soDQ(conf.a, 16).toRed(this.red);
    this.b = new $6soDQ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$eSHUL($f69e5d783a5b036a$var$ShortCurve, $1dHTG);
module.exports = $f69e5d783a5b036a$var$ShortCurve;
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $6soDQ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $6soDQ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f69e5d783a5b036a$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $6soDQ(vec.a, 16),
            b: new $6soDQ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $6soDQ.mont(num);
    var tinv = new $6soDQ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $6soDQ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $6soDQ(1);
    var y1 = new $6soDQ(0);
    var x2 = new $6soDQ(0);
    var y2 = new $6soDQ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6soDQ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f69e5d783a5b036a$var$Point(curve, x, y, isRed) {
    $1dHTG.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $6soDQ(x, 16);
        this.y = new $6soDQ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$eSHUL($f69e5d783a5b036a$var$Point, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f69e5d783a5b036a$var$Point(this, x, y, isRed);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f69e5d783a5b036a$var$Point.fromJSON(this, obj, red);
};
$f69e5d783a5b036a$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f69e5d783a5b036a$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f69e5d783a5b036a$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$f69e5d783a5b036a$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f69e5d783a5b036a$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.mul = function mul(k) {
    k = new $6soDQ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f69e5d783a5b036a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f69e5d783a5b036a$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f69e5d783a5b036a$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f69e5d783a5b036a$var$JPoint(curve, x, y, z) {
    $1dHTG.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $6soDQ(0);
    } else {
        this.x = new $6soDQ(x, 16);
        this.y = new $6soDQ(y, 16);
        this.z = new $6soDQ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$eSHUL($f69e5d783a5b036a$var$JPoint, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f69e5d783a5b036a$var$JPoint(this, x, y, z);
};
$f69e5d783a5b036a$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f69e5d783a5b036a$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f69e5d783a5b036a$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f69e5d783a5b036a$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $6soDQ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f69e5d783a5b036a$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$f69e5d783a5b036a$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("3uGhx", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");

var $ZdcNb = parcelRequire("ZdcNb");
function $28b4f8bfddf22eb4$var$MontCurve(conf) {
    $1dHTG.call(this, 'mont', conf);
    this.a = new $6soDQ(conf.a, 16).toRed(this.red);
    this.b = new $6soDQ(conf.b, 16).toRed(this.red);
    this.i4 = new $6soDQ(4).toRed(this.red).redInvm();
    this.two = new $6soDQ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$eSHUL($28b4f8bfddf22eb4$var$MontCurve, $1dHTG);
module.exports = $28b4f8bfddf22eb4$var$MontCurve;
$28b4f8bfddf22eb4$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $28b4f8bfddf22eb4$var$Point(curve, x, z) {
    $1dHTG.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $6soDQ(x, 16);
        this.z = new $6soDQ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$eSHUL($28b4f8bfddf22eb4$var$Point, $1dHTG.BasePoint);
$28b4f8bfddf22eb4$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($ZdcNb.toArray(bytes, enc), 1);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.point = function point(x, z) {
    return new $28b4f8bfddf22eb4$var$Point(this, x, z);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $28b4f8bfddf22eb4$var$Point.fromJSON(this, obj);
};
$28b4f8bfddf22eb4$var$Point.prototype.precompute = function precompute() {
// No-op
};
$28b4f8bfddf22eb4$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$28b4f8bfddf22eb4$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $28b4f8bfddf22eb4$var$Point(curve, obj[0], obj[1] || curve.one);
};
$28b4f8bfddf22eb4$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$28b4f8bfddf22eb4$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$28b4f8bfddf22eb4$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$28b4f8bfddf22eb4$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$28b4f8bfddf22eb4$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$28b4f8bfddf22eb4$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$28b4f8bfddf22eb4$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("a0HUE", function(module, exports) {
'use strict';

var $ZdcNb = parcelRequire("ZdcNb");

var $6soDQ = parcelRequire("6soDQ");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $749bf799fac4284f$var$assert = $ZdcNb.assert;
function $749bf799fac4284f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $1dHTG.call(this, 'edwards', conf);
    this.a = new $6soDQ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $6soDQ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $6soDQ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $749bf799fac4284f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$eSHUL($749bf799fac4284f$var$EdwardsCurve, $1dHTG);
module.exports = $749bf799fac4284f$var$EdwardsCurve;
$749bf799fac4284f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$749bf799fac4284f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$749bf799fac4284f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6soDQ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $6soDQ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $749bf799fac4284f$var$Point(curve, x, y, z, t) {
    $1dHTG.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $6soDQ(x, 16);
        this.y = new $6soDQ(y, 16);
        this.z = z ? new $6soDQ(z, 16) : this.curve.one;
        this.t = t && new $6soDQ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$eSHUL($749bf799fac4284f$var$Point, $1dHTG.BasePoint);
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $749bf799fac4284f$var$Point.fromJSON(this, obj);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $749bf799fac4284f$var$Point(this, x, y, z, t);
};
$749bf799fac4284f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $749bf799fac4284f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$749bf799fac4284f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$749bf799fac4284f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$749bf799fac4284f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$749bf799fac4284f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$749bf799fac4284f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$749bf799fac4284f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$749bf799fac4284f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$749bf799fac4284f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$749bf799fac4284f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$749bf799fac4284f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$749bf799fac4284f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$749bf799fac4284f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$749bf799fac4284f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$749bf799fac4284f$var$Point.prototype.toP = $749bf799fac4284f$var$Point.prototype.normalize;
$749bf799fac4284f$var$Point.prototype.mixedAdd = $749bf799fac4284f$var$Point.prototype.add;

});


parcelRegister("hwVHR", function(module, exports) {
'use strict';
var $cc32301b3f482b8e$var$curves = module.exports;

var $leqJp = parcelRequire("leqJp");

var $fYJT3 = parcelRequire("fYJT3");

var $ZdcNb = parcelRequire("ZdcNb");
var $cc32301b3f482b8e$var$assert = $ZdcNb.assert;
function $cc32301b3f482b8e$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $fYJT3.short(options);
    else if (options.type === 'edwards') this.curve = new $fYJT3.edwards(options);
    else this.curve = new $fYJT3.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $cc32301b3f482b8e$var$assert(this.g.validate(), 'Invalid curve');
    $cc32301b3f482b8e$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$cc32301b3f482b8e$var$curves.PresetCurve = $cc32301b3f482b8e$var$PresetCurve;
function $cc32301b3f482b8e$var$defineCurve(name, options) {
    Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $cc32301b3f482b8e$var$PresetCurve(options);
            Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$cc32301b3f482b8e$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$cc32301b3f482b8e$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$cc32301b3f482b8e$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$cc32301b3f482b8e$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $leqJp.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$cc32301b3f482b8e$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $leqJp.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$cc32301b3f482b8e$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$cc32301b3f482b8e$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $cc32301b3f482b8e$var$pre;

try {
    $cc32301b3f482b8e$var$pre = (parcelRequire("63oZi"));
} catch (e) {
    $cc32301b3f482b8e$var$pre = undefined;
}
$cc32301b3f482b8e$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $leqJp.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $cc32301b3f482b8e$var$pre
    ]
});

});
parcelRegister("leqJp", function(module, exports) {
var $f74fa412f2053ea0$var$hash = module.exports;

$f74fa412f2053ea0$var$hash.utils = (parcelRequire("3vltz"));

$f74fa412f2053ea0$var$hash.common = (parcelRequire("hoO3s"));

$f74fa412f2053ea0$var$hash.sha = (parcelRequire("esJCG"));

$f74fa412f2053ea0$var$hash.ripemd = (parcelRequire("ak1PH"));

$f74fa412f2053ea0$var$hash.hmac = (parcelRequire("X5z30"));
// Proxy hash functions to the main object
$f74fa412f2053ea0$var$hash.sha1 = $f74fa412f2053ea0$var$hash.sha.sha1;
$f74fa412f2053ea0$var$hash.sha256 = $f74fa412f2053ea0$var$hash.sha.sha256;
$f74fa412f2053ea0$var$hash.sha224 = $f74fa412f2053ea0$var$hash.sha.sha224;
$f74fa412f2053ea0$var$hash.sha384 = $f74fa412f2053ea0$var$hash.sha.sha384;
$f74fa412f2053ea0$var$hash.sha512 = $f74fa412f2053ea0$var$hash.sha.sha512;
$f74fa412f2053ea0$var$hash.ripemd160 = $f74fa412f2053ea0$var$hash.ripemd.ripemd160;

});
parcelRegister("3vltz", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $28d4ed0635aac004$export$69f1b2dcda23c5f8; }, function (v) { return $28d4ed0635aac004$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $28d4ed0635aac004$export$45b10814cc054894; }, function (v) { return $28d4ed0635aac004$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $28d4ed0635aac004$export$7ea66e3774a60b67; }, function (v) { return $28d4ed0635aac004$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $28d4ed0635aac004$export$34a52f00f601f6f1; }, function (v) { return $28d4ed0635aac004$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $28d4ed0635aac004$export$812b0cbd5e8a72ab; }, function (v) { return $28d4ed0635aac004$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $28d4ed0635aac004$export$f24f9e11d63bb314; }, function (v) { return $28d4ed0635aac004$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $28d4ed0635aac004$export$b71357c7e07ca1f1; }, function (v) { return $28d4ed0635aac004$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $28d4ed0635aac004$export$2e58a4b541fdcbe8; }, function (v) { return $28d4ed0635aac004$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $28d4ed0635aac004$export$183b950bde9faab8; }, function (v) { return $28d4ed0635aac004$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $28d4ed0635aac004$export$4785c77169fea59e; }, function (v) { return $28d4ed0635aac004$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $28d4ed0635aac004$export$242a185dfcffac5b; }, function (v) { return $28d4ed0635aac004$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $28d4ed0635aac004$export$58c04ae0ae31877d; }, function (v) { return $28d4ed0635aac004$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $28d4ed0635aac004$export$d058ca695f8c6f11; }, function (v) { return $28d4ed0635aac004$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $28d4ed0635aac004$export$a1efd7fc3e986367; }, function (v) { return $28d4ed0635aac004$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $28d4ed0635aac004$export$bbfea4a2b5abaab4; }, function (v) { return $28d4ed0635aac004$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $28d4ed0635aac004$export$97ad4afc7de86152; }, function (v) { return $28d4ed0635aac004$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $28d4ed0635aac004$export$ce4673d9a79f6a4b; }, function (v) { return $28d4ed0635aac004$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $28d4ed0635aac004$export$786cc99fc6eedc0b; }, function (v) { return $28d4ed0635aac004$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $28d4ed0635aac004$export$45c59b9a1848dd0; }, function (v) { return $28d4ed0635aac004$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $28d4ed0635aac004$export$50d8f613e76d3034; }, function (v) { return $28d4ed0635aac004$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $28d4ed0635aac004$export$b8e83683c60ee162; }, function (v) { return $28d4ed0635aac004$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $28d4ed0635aac004$export$aeeb51790d1bcc4a; }, function (v) { return $28d4ed0635aac004$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $28d4ed0635aac004$export$bb7c616f719ad9c; }, function (v) { return $28d4ed0635aac004$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $28d4ed0635aac004$export$4d63290824f9d7df; }, function (v) { return $28d4ed0635aac004$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $28d4ed0635aac004$export$2f64ceb90ef28ea1; }, function (v) { return $28d4ed0635aac004$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $28d4ed0635aac004$export$8d2089d465f6d10d; }, function (v) { return $28d4ed0635aac004$export$8d2089d465f6d10d = v; });
var $28d4ed0635aac004$export$69f1b2dcda23c5f8;
var $28d4ed0635aac004$export$45b10814cc054894;
var $28d4ed0635aac004$export$7ea66e3774a60b67;
var $28d4ed0635aac004$export$34a52f00f601f6f1;
var $28d4ed0635aac004$export$812b0cbd5e8a72ab;
var $28d4ed0635aac004$export$f24f9e11d63bb314;
var $28d4ed0635aac004$export$b71357c7e07ca1f1;
var $28d4ed0635aac004$export$2e58a4b541fdcbe8;
var $28d4ed0635aac004$export$183b950bde9faab8;
var $28d4ed0635aac004$export$4785c77169fea59e;
var $28d4ed0635aac004$export$242a185dfcffac5b;
var $28d4ed0635aac004$export$58c04ae0ae31877d;
var $28d4ed0635aac004$export$d058ca695f8c6f11;
var $28d4ed0635aac004$export$a1efd7fc3e986367;
var $28d4ed0635aac004$export$bbfea4a2b5abaab4;
var $28d4ed0635aac004$export$97ad4afc7de86152;
var $28d4ed0635aac004$export$ce4673d9a79f6a4b;
var $28d4ed0635aac004$export$786cc99fc6eedc0b;
var $28d4ed0635aac004$export$45c59b9a1848dd0;
var $28d4ed0635aac004$export$50d8f613e76d3034;
var $28d4ed0635aac004$export$b8e83683c60ee162;
var $28d4ed0635aac004$export$aeeb51790d1bcc4a;
var $28d4ed0635aac004$export$bb7c616f719ad9c;
var $28d4ed0635aac004$export$4d63290824f9d7df;
var $28d4ed0635aac004$export$2f64ceb90ef28ea1;
var $28d4ed0635aac004$export$8d2089d465f6d10d;
'use strict';

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
$28d4ed0635aac004$export$69f1b2dcda23c5f8 = $eSHUL;
function $28d4ed0635aac004$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $28d4ed0635aac004$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($28d4ed0635aac004$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$28d4ed0635aac004$export$45b10814cc054894 = $28d4ed0635aac004$var$toArray;
function $28d4ed0635aac004$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $28d4ed0635aac004$var$zero2(msg[i].toString(16));
    return res;
}
$28d4ed0635aac004$export$7ea66e3774a60b67 = $28d4ed0635aac004$var$toHex;
function $28d4ed0635aac004$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$28d4ed0635aac004$export$34a52f00f601f6f1 = $28d4ed0635aac004$var$htonl;
function $28d4ed0635aac004$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $28d4ed0635aac004$var$htonl(w);
        res += $28d4ed0635aac004$var$zero8(w.toString(16));
    }
    return res;
}
$28d4ed0635aac004$export$812b0cbd5e8a72ab = $28d4ed0635aac004$var$toHex32;
function $28d4ed0635aac004$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$28d4ed0635aac004$export$f24f9e11d63bb314 = $28d4ed0635aac004$var$zero2;
function $28d4ed0635aac004$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$28d4ed0635aac004$export$b71357c7e07ca1f1 = $28d4ed0635aac004$var$zero8;
function $28d4ed0635aac004$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aJt1P(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$28d4ed0635aac004$export$2e58a4b541fdcbe8 = $28d4ed0635aac004$var$join32;
function $28d4ed0635aac004$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$28d4ed0635aac004$export$183b950bde9faab8 = $28d4ed0635aac004$var$split32;
function $28d4ed0635aac004$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$28d4ed0635aac004$export$4785c77169fea59e = $28d4ed0635aac004$var$rotr32;
function $28d4ed0635aac004$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$28d4ed0635aac004$export$242a185dfcffac5b = $28d4ed0635aac004$var$rotl32;
function $28d4ed0635aac004$var$sum32(a, b) {
    return a + b >>> 0;
}
$28d4ed0635aac004$export$58c04ae0ae31877d = $28d4ed0635aac004$var$sum32;
function $28d4ed0635aac004$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$28d4ed0635aac004$export$d058ca695f8c6f11 = $28d4ed0635aac004$var$sum32_3;
function $28d4ed0635aac004$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$28d4ed0635aac004$export$a1efd7fc3e986367 = $28d4ed0635aac004$var$sum32_4;
function $28d4ed0635aac004$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$28d4ed0635aac004$export$bbfea4a2b5abaab4 = $28d4ed0635aac004$var$sum32_5;
function $28d4ed0635aac004$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$28d4ed0635aac004$export$97ad4afc7de86152 = $28d4ed0635aac004$var$sum64;
function $28d4ed0635aac004$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$28d4ed0635aac004$export$ce4673d9a79f6a4b = $28d4ed0635aac004$var$sum64_hi;
function $28d4ed0635aac004$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$786cc99fc6eedc0b = $28d4ed0635aac004$var$sum64_lo;
function $28d4ed0635aac004$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$45c59b9a1848dd0 = $28d4ed0635aac004$var$sum64_4_hi;
function $28d4ed0635aac004$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$50d8f613e76d3034 = $28d4ed0635aac004$var$sum64_4_lo;
function $28d4ed0635aac004$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$b8e83683c60ee162 = $28d4ed0635aac004$var$sum64_5_hi;
function $28d4ed0635aac004$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$28d4ed0635aac004$export$aeeb51790d1bcc4a = $28d4ed0635aac004$var$sum64_5_lo;
function $28d4ed0635aac004$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$bb7c616f719ad9c = $28d4ed0635aac004$var$rotr64_hi;
function $28d4ed0635aac004$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$4d63290824f9d7df = $28d4ed0635aac004$var$rotr64_lo;
function $28d4ed0635aac004$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$28d4ed0635aac004$export$2f64ceb90ef28ea1 = $28d4ed0635aac004$var$shr64_hi;
function $28d4ed0635aac004$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$8d2089d465f6d10d = $28d4ed0635aac004$var$shr64_lo;

});

parcelRegister("hoO3s", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $caab81610dd48e7b$export$8687658379b577e6; }, function (v) { return $caab81610dd48e7b$export$8687658379b577e6 = v; });
var $caab81610dd48e7b$export$8687658379b577e6;
'use strict';

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $caab81610dd48e7b$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$caab81610dd48e7b$export$8687658379b577e6 = $caab81610dd48e7b$var$BlockHash;
$caab81610dd48e7b$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $3vltz.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $3vltz.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$caab81610dd48e7b$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aJt1P(this.pending === null);
    return this._digest(enc);
};
$caab81610dd48e7b$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("esJCG", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $a87711fd35b0090f$export$5091bdda49ba90f5; }, function (v) { return $a87711fd35b0090f$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $a87711fd35b0090f$export$97b70509d4e397ea; }, function (v) { return $a87711fd35b0090f$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $a87711fd35b0090f$export$bced8d2aada2d1c9; }, function (v) { return $a87711fd35b0090f$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $a87711fd35b0090f$export$612d47d55dedde45; }, function (v) { return $a87711fd35b0090f$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $a87711fd35b0090f$export$a888d2532e6dc7bb; }, function (v) { return $a87711fd35b0090f$export$a888d2532e6dc7bb = v; });
var $a87711fd35b0090f$export$5091bdda49ba90f5;
var $a87711fd35b0090f$export$97b70509d4e397ea;
var $a87711fd35b0090f$export$bced8d2aada2d1c9;
var $a87711fd35b0090f$export$612d47d55dedde45;
var $a87711fd35b0090f$export$a888d2532e6dc7bb;
'use strict';

$a87711fd35b0090f$export$5091bdda49ba90f5 = (parcelRequire("4n9Qi"));

$a87711fd35b0090f$export$97b70509d4e397ea = (parcelRequire("2w2RS"));

$a87711fd35b0090f$export$bced8d2aada2d1c9 = (parcelRequire("6tl9X"));

$a87711fd35b0090f$export$612d47d55dedde45 = (parcelRequire("1zFKP"));

$a87711fd35b0090f$export$a888d2532e6dc7bb = (parcelRequire("b8Cnj"));

});
parcelRegister("4n9Qi", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");
var $32f0f1f12aa851fd$var$rotl32 = $3vltz.rotl32;
var $32f0f1f12aa851fd$var$sum32 = $3vltz.sum32;
var $32f0f1f12aa851fd$var$sum32_5 = $3vltz.sum32_5;
var $32f0f1f12aa851fd$var$ft_1 = $7pXSD.ft_1;
var $32f0f1f12aa851fd$var$BlockHash = $hoO3s.BlockHash;
var $32f0f1f12aa851fd$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $32f0f1f12aa851fd$var$SHA1() {
    if (!(this instanceof $32f0f1f12aa851fd$var$SHA1)) return new $32f0f1f12aa851fd$var$SHA1();
    $32f0f1f12aa851fd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$3vltz.inherits($32f0f1f12aa851fd$var$SHA1, $32f0f1f12aa851fd$var$BlockHash);
module.exports = $32f0f1f12aa851fd$var$SHA1;
$32f0f1f12aa851fd$var$SHA1.blockSize = 512;
$32f0f1f12aa851fd$var$SHA1.outSize = 160;
$32f0f1f12aa851fd$var$SHA1.hmacStrength = 80;
$32f0f1f12aa851fd$var$SHA1.padLength = 64;
$32f0f1f12aa851fd$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $32f0f1f12aa851fd$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $32f0f1f12aa851fd$var$sum32_5($32f0f1f12aa851fd$var$rotl32(a, 5), $32f0f1f12aa851fd$var$ft_1(s, b, c, d), e, W[i], $32f0f1f12aa851fd$var$sha1_K[s]);
        e = d;
        d = c;
        c = $32f0f1f12aa851fd$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $32f0f1f12aa851fd$var$sum32(this.h[0], a);
    this.h[1] = $32f0f1f12aa851fd$var$sum32(this.h[1], b);
    this.h[2] = $32f0f1f12aa851fd$var$sum32(this.h[2], c);
    this.h[3] = $32f0f1f12aa851fd$var$sum32(this.h[3], d);
    this.h[4] = $32f0f1f12aa851fd$var$sum32(this.h[4], e);
};
$32f0f1f12aa851fd$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'big');
    else return $3vltz.split32(this.h, 'big');
};

});
parcelRegister("7pXSD", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $5669512b21aa6962$export$5a92649d7ddb9f63; }, function (v) { return $5669512b21aa6962$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $5669512b21aa6962$export$c6d0d020c3a6269; }, function (v) { return $5669512b21aa6962$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $5669512b21aa6962$export$eb90c27fca05f956; }, function (v) { return $5669512b21aa6962$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $5669512b21aa6962$export$14a4a98e063b1999; }, function (v) { return $5669512b21aa6962$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $5669512b21aa6962$export$d20cecfa1564c686; }, function (v) { return $5669512b21aa6962$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $5669512b21aa6962$export$44fd472a12fc6db; }, function (v) { return $5669512b21aa6962$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $5669512b21aa6962$export$1ed238bb6ea1dd47; }, function (v) { return $5669512b21aa6962$export$1ed238bb6ea1dd47 = v; });
var $5669512b21aa6962$export$5a92649d7ddb9f63;
var $5669512b21aa6962$export$c6d0d020c3a6269;
var $5669512b21aa6962$export$eb90c27fca05f956;
var $5669512b21aa6962$export$cc992891a14496a1;
var $5669512b21aa6962$export$14a4a98e063b1999;
var $5669512b21aa6962$export$d20cecfa1564c686;
var $5669512b21aa6962$export$44fd472a12fc6db;
var $5669512b21aa6962$export$1ed238bb6ea1dd47;
'use strict';

var $3vltz = parcelRequire("3vltz");
var $5669512b21aa6962$var$rotr32 = $3vltz.rotr32;
function $5669512b21aa6962$var$ft_1(s, x, y, z) {
    if (s === 0) return $5669512b21aa6962$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5669512b21aa6962$var$p32(x, y, z);
    if (s === 2) return $5669512b21aa6962$var$maj32(x, y, z);
}
$5669512b21aa6962$export$5a92649d7ddb9f63 = $5669512b21aa6962$var$ft_1;
function $5669512b21aa6962$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5669512b21aa6962$export$c6d0d020c3a6269 = $5669512b21aa6962$var$ch32;
function $5669512b21aa6962$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5669512b21aa6962$export$eb90c27fca05f956 = $5669512b21aa6962$var$maj32;
function $5669512b21aa6962$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5669512b21aa6962$export$cc992891a14496a1 = $5669512b21aa6962$var$p32;
function $5669512b21aa6962$var$s0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 2) ^ $5669512b21aa6962$var$rotr32(x, 13) ^ $5669512b21aa6962$var$rotr32(x, 22);
}
$5669512b21aa6962$export$14a4a98e063b1999 = $5669512b21aa6962$var$s0_256;
function $5669512b21aa6962$var$s1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 6) ^ $5669512b21aa6962$var$rotr32(x, 11) ^ $5669512b21aa6962$var$rotr32(x, 25);
}
$5669512b21aa6962$export$d20cecfa1564c686 = $5669512b21aa6962$var$s1_256;
function $5669512b21aa6962$var$g0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 7) ^ $5669512b21aa6962$var$rotr32(x, 18) ^ x >>> 3;
}
$5669512b21aa6962$export$44fd472a12fc6db = $5669512b21aa6962$var$g0_256;
function $5669512b21aa6962$var$g1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 17) ^ $5669512b21aa6962$var$rotr32(x, 19) ^ x >>> 10;
}
$5669512b21aa6962$export$1ed238bb6ea1dd47 = $5669512b21aa6962$var$g1_256;

});


parcelRegister("2w2RS", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $6tl9X = parcelRequire("6tl9X");
function $1d50cb6dff0ac7e1$var$SHA224() {
    if (!(this instanceof $1d50cb6dff0ac7e1$var$SHA224)) return new $1d50cb6dff0ac7e1$var$SHA224();
    $6tl9X.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$3vltz.inherits($1d50cb6dff0ac7e1$var$SHA224, $6tl9X);
module.exports = $1d50cb6dff0ac7e1$var$SHA224;
$1d50cb6dff0ac7e1$var$SHA224.blockSize = 512;
$1d50cb6dff0ac7e1$var$SHA224.outSize = 224;
$1d50cb6dff0ac7e1$var$SHA224.hmacStrength = 192;
$1d50cb6dff0ac7e1$var$SHA224.padLength = 64;
$1d50cb6dff0ac7e1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $3vltz.toHex32(this.h.slice(0, 7), 'big');
    else return $3vltz.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("6tl9X", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");

var $aJt1P = parcelRequire("aJt1P");
var $4b65dd591dedf929$var$sum32 = $3vltz.sum32;
var $4b65dd591dedf929$var$sum32_4 = $3vltz.sum32_4;
var $4b65dd591dedf929$var$sum32_5 = $3vltz.sum32_5;
var $4b65dd591dedf929$var$ch32 = $7pXSD.ch32;
var $4b65dd591dedf929$var$maj32 = $7pXSD.maj32;
var $4b65dd591dedf929$var$s0_256 = $7pXSD.s0_256;
var $4b65dd591dedf929$var$s1_256 = $7pXSD.s1_256;
var $4b65dd591dedf929$var$g0_256 = $7pXSD.g0_256;
var $4b65dd591dedf929$var$g1_256 = $7pXSD.g1_256;
var $4b65dd591dedf929$var$BlockHash = $hoO3s.BlockHash;
var $4b65dd591dedf929$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b65dd591dedf929$var$SHA256() {
    if (!(this instanceof $4b65dd591dedf929$var$SHA256)) return new $4b65dd591dedf929$var$SHA256();
    $4b65dd591dedf929$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b65dd591dedf929$var$sha256_K;
    this.W = new Array(64);
}
$3vltz.inherits($4b65dd591dedf929$var$SHA256, $4b65dd591dedf929$var$BlockHash);
module.exports = $4b65dd591dedf929$var$SHA256;
$4b65dd591dedf929$var$SHA256.blockSize = 512;
$4b65dd591dedf929$var$SHA256.outSize = 256;
$4b65dd591dedf929$var$SHA256.hmacStrength = 192;
$4b65dd591dedf929$var$SHA256.padLength = 64;
$4b65dd591dedf929$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b65dd591dedf929$var$sum32_4($4b65dd591dedf929$var$g1_256(W[i - 2]), W[i - 7], $4b65dd591dedf929$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aJt1P(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b65dd591dedf929$var$sum32_5(h, $4b65dd591dedf929$var$s1_256(e), $4b65dd591dedf929$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b65dd591dedf929$var$sum32($4b65dd591dedf929$var$s0_256(a), $4b65dd591dedf929$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b65dd591dedf929$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b65dd591dedf929$var$sum32(T1, T2);
    }
    this.h[0] = $4b65dd591dedf929$var$sum32(this.h[0], a);
    this.h[1] = $4b65dd591dedf929$var$sum32(this.h[1], b);
    this.h[2] = $4b65dd591dedf929$var$sum32(this.h[2], c);
    this.h[3] = $4b65dd591dedf929$var$sum32(this.h[3], d);
    this.h[4] = $4b65dd591dedf929$var$sum32(this.h[4], e);
    this.h[5] = $4b65dd591dedf929$var$sum32(this.h[5], f);
    this.h[6] = $4b65dd591dedf929$var$sum32(this.h[6], g);
    this.h[7] = $4b65dd591dedf929$var$sum32(this.h[7], h);
};
$4b65dd591dedf929$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'big');
    else return $3vltz.split32(this.h, 'big');
};

});


parcelRegister("1zFKP", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $b8Cnj = parcelRequire("b8Cnj");
function $125972e0f41acdab$var$SHA384() {
    if (!(this instanceof $125972e0f41acdab$var$SHA384)) return new $125972e0f41acdab$var$SHA384();
    $b8Cnj.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$3vltz.inherits($125972e0f41acdab$var$SHA384, $b8Cnj);
module.exports = $125972e0f41acdab$var$SHA384;
$125972e0f41acdab$var$SHA384.blockSize = 1024;
$125972e0f41acdab$var$SHA384.outSize = 384;
$125972e0f41acdab$var$SHA384.hmacStrength = 192;
$125972e0f41acdab$var$SHA384.padLength = 128;
$125972e0f41acdab$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h.slice(0, 12), 'big');
    else return $3vltz.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("b8Cnj", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $aJt1P = parcelRequire("aJt1P");
var $81be358d8f6abcff$var$rotr64_hi = $3vltz.rotr64_hi;
var $81be358d8f6abcff$var$rotr64_lo = $3vltz.rotr64_lo;
var $81be358d8f6abcff$var$shr64_hi = $3vltz.shr64_hi;
var $81be358d8f6abcff$var$shr64_lo = $3vltz.shr64_lo;
var $81be358d8f6abcff$var$sum64 = $3vltz.sum64;
var $81be358d8f6abcff$var$sum64_hi = $3vltz.sum64_hi;
var $81be358d8f6abcff$var$sum64_lo = $3vltz.sum64_lo;
var $81be358d8f6abcff$var$sum64_4_hi = $3vltz.sum64_4_hi;
var $81be358d8f6abcff$var$sum64_4_lo = $3vltz.sum64_4_lo;
var $81be358d8f6abcff$var$sum64_5_hi = $3vltz.sum64_5_hi;
var $81be358d8f6abcff$var$sum64_5_lo = $3vltz.sum64_5_lo;
var $81be358d8f6abcff$var$BlockHash = $hoO3s.BlockHash;
var $81be358d8f6abcff$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $81be358d8f6abcff$var$SHA512() {
    if (!(this instanceof $81be358d8f6abcff$var$SHA512)) return new $81be358d8f6abcff$var$SHA512();
    $81be358d8f6abcff$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $81be358d8f6abcff$var$sha512_K;
    this.W = new Array(160);
}
$3vltz.inherits($81be358d8f6abcff$var$SHA512, $81be358d8f6abcff$var$BlockHash);
module.exports = $81be358d8f6abcff$var$SHA512;
$81be358d8f6abcff$var$SHA512.blockSize = 1024;
$81be358d8f6abcff$var$SHA512.outSize = 512;
$81be358d8f6abcff$var$SHA512.hmacStrength = 192;
$81be358d8f6abcff$var$SHA512.padLength = 128;
$81be358d8f6abcff$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $81be358d8f6abcff$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $81be358d8f6abcff$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $81be358d8f6abcff$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $81be358d8f6abcff$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $81be358d8f6abcff$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $81be358d8f6abcff$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$81be358d8f6abcff$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aJt1P(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $81be358d8f6abcff$var$s1_512_hi(eh, el);
        var c1_lo = $81be358d8f6abcff$var$s1_512_lo(eh, el);
        var c2_hi = $81be358d8f6abcff$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $81be358d8f6abcff$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $81be358d8f6abcff$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $81be358d8f6abcff$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $81be358d8f6abcff$var$s0_512_hi(ah, al);
        c0_lo = $81be358d8f6abcff$var$s0_512_lo(ah, al);
        c1_hi = $81be358d8f6abcff$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $81be358d8f6abcff$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $81be358d8f6abcff$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $81be358d8f6abcff$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $81be358d8f6abcff$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $81be358d8f6abcff$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $81be358d8f6abcff$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $81be358d8f6abcff$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $81be358d8f6abcff$var$sum64(this.h, 0, ah, al);
    $81be358d8f6abcff$var$sum64(this.h, 2, bh, bl);
    $81be358d8f6abcff$var$sum64(this.h, 4, ch, cl);
    $81be358d8f6abcff$var$sum64(this.h, 6, dh, dl);
    $81be358d8f6abcff$var$sum64(this.h, 8, eh, el);
    $81be358d8f6abcff$var$sum64(this.h, 10, fh, fl);
    $81be358d8f6abcff$var$sum64(this.h, 12, gh, gl);
    $81be358d8f6abcff$var$sum64(this.h, 14, hh, hl);
};
$81be358d8f6abcff$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'big');
    else return $3vltz.split32(this.h, 'big');
};
function $81be358d8f6abcff$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("ak1PH", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e; }, function (v) { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e = v; });
var $783d3195a6b3253e$export$d1cea0ee4e3f0d3e;
'use strict';

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");
var $783d3195a6b3253e$var$rotl32 = $3vltz.rotl32;
var $783d3195a6b3253e$var$sum32 = $3vltz.sum32;
var $783d3195a6b3253e$var$sum32_3 = $3vltz.sum32_3;
var $783d3195a6b3253e$var$sum32_4 = $3vltz.sum32_4;
var $783d3195a6b3253e$var$BlockHash = $hoO3s.BlockHash;
function $783d3195a6b3253e$var$RIPEMD160() {
    if (!(this instanceof $783d3195a6b3253e$var$RIPEMD160)) return new $783d3195a6b3253e$var$RIPEMD160();
    $783d3195a6b3253e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$3vltz.inherits($783d3195a6b3253e$var$RIPEMD160, $783d3195a6b3253e$var$BlockHash);
$783d3195a6b3253e$export$d1cea0ee4e3f0d3e = $783d3195a6b3253e$var$RIPEMD160;
$783d3195a6b3253e$var$RIPEMD160.blockSize = 512;
$783d3195a6b3253e$var$RIPEMD160.outSize = 160;
$783d3195a6b3253e$var$RIPEMD160.hmacStrength = 192;
$783d3195a6b3253e$var$RIPEMD160.padLength = 64;
$783d3195a6b3253e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(A, $783d3195a6b3253e$var$f(j, B, C, D), msg[$783d3195a6b3253e$var$r[j] + start], $783d3195a6b3253e$var$K(j)), $783d3195a6b3253e$var$s[j]), E);
        A = E;
        E = D;
        D = $783d3195a6b3253e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(Ah, $783d3195a6b3253e$var$f(79 - j, Bh, Ch, Dh), msg[$783d3195a6b3253e$var$rh[j] + start], $783d3195a6b3253e$var$Kh(j)), $783d3195a6b3253e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $783d3195a6b3253e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $783d3195a6b3253e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $783d3195a6b3253e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $783d3195a6b3253e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $783d3195a6b3253e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $783d3195a6b3253e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$783d3195a6b3253e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $3vltz.toHex32(this.h, 'little');
    else return $3vltz.split32(this.h, 'little');
};
function $783d3195a6b3253e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $783d3195a6b3253e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $783d3195a6b3253e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $783d3195a6b3253e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $783d3195a6b3253e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $783d3195a6b3253e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $783d3195a6b3253e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("X5z30", function(module, exports) {
'use strict';

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $0b19d3c0f7d555a6$var$Hmac(hash, key, enc) {
    if (!(this instanceof $0b19d3c0f7d555a6$var$Hmac)) return new $0b19d3c0f7d555a6$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($3vltz.toArray(key, enc));
}
module.exports = $0b19d3c0f7d555a6$var$Hmac;
$0b19d3c0f7d555a6$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aJt1P(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$0b19d3c0f7d555a6$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$0b19d3c0f7d555a6$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("63oZi", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("9lW0h", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $5WFpm = parcelRequire("5WFpm");

var $ZdcNb = parcelRequire("ZdcNb");

var $hwVHR = parcelRequire("hwVHR");

var $9JRha = parcelRequire("9JRha");
var $6cf31182d56f3d95$var$assert = $ZdcNb.assert;

var $lE5ol = parcelRequire("lE5ol");

var $kQeFn = parcelRequire("kQeFn");
function $6cf31182d56f3d95$var$EC(options) {
    if (!(this instanceof $6cf31182d56f3d95$var$EC)) return new $6cf31182d56f3d95$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $6cf31182d56f3d95$var$assert(Object.prototype.hasOwnProperty.call($hwVHR, options), 'Unknown curve ' + options);
        options = $hwVHR[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hwVHR.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $6cf31182d56f3d95$var$EC;
$6cf31182d56f3d95$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lE5ol(this, options);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lE5ol.fromPrivate(this, priv, enc);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lE5ol.fromPublic(this, pub, enc);
};
$6cf31182d56f3d95$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $9JRha(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $6soDQ(2));
    for(;;){
        var priv = new $6soDQ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$6cf31182d56f3d95$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$6cf31182d56f3d95$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $6soDQ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $6soDQ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $6soDQ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kQeFn({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$6cf31182d56f3d95$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $6soDQ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $kQeFn(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$6cf31182d56f3d95$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $6cf31182d56f3d95$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $kQeFn(signature, enc);
    var n = this.n;
    var e = new $6soDQ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$6cf31182d56f3d95$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kQeFn(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("5WFpm", function(module, exports) {
'use strict';

var $leqJp = parcelRequire("leqJp");

var $6J8qY = parcelRequire("6J8qY");

var $aJt1P = parcelRequire("aJt1P");
function $45427d4f96da3b8c$var$HmacDRBG(options) {
    if (!(this instanceof $45427d4f96da3b8c$var$HmacDRBG)) return new $45427d4f96da3b8c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $6J8qY.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $6J8qY.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $6J8qY.toArray(options.pers, options.persEnc || 'hex');
    $aJt1P(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $45427d4f96da3b8c$var$HmacDRBG;
$45427d4f96da3b8c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $leqJp.hmac(this.hash, this.K);
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $6J8qY.toArray(entropy, entropyEnc);
    add = $6J8qY.toArray(add, addEnc);
    $aJt1P(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $6J8qY.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $6J8qY.encode(res, enc);
};

});

parcelRegister("lE5ol", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $fc21840fd53be280$var$assert = $ZdcNb.assert;
function $fc21840fd53be280$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fc21840fd53be280$var$KeyPair;
$fc21840fd53be280$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fc21840fd53be280$var$KeyPair) return pub;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fc21840fd53be280$var$KeyPair) return priv;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fc21840fd53be280$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fc21840fd53be280$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fc21840fd53be280$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $6soDQ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fc21840fd53be280$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fc21840fd53be280$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fc21840fd53be280$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fc21840fd53be280$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fc21840fd53be280$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fc21840fd53be280$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fc21840fd53be280$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fc21840fd53be280$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("kQeFn", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $f2c40a6448de4ea4$var$assert = $ZdcNb.assert;
function $f2c40a6448de4ea4$var$Signature(options, enc) {
    if (options instanceof $f2c40a6448de4ea4$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f2c40a6448de4ea4$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $6soDQ(options.r, 16);
    this.s = new $6soDQ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f2c40a6448de4ea4$var$Signature;
function $f2c40a6448de4ea4$var$Position() {
    this.place = 0;
}
function $f2c40a6448de4ea4$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f2c40a6448de4ea4$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f2c40a6448de4ea4$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $ZdcNb.toArray(data, enc);
    var p = new $f2c40a6448de4ea4$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f2c40a6448de4ea4$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $6soDQ(r);
    this.s = new $6soDQ(s);
    this.recoveryParam = null;
    return true;
};
function $f2c40a6448de4ea4$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f2c40a6448de4ea4$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f2c40a6448de4ea4$var$rmPadding(r);
    s = $f2c40a6448de4ea4$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f2c40a6448de4ea4$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f2c40a6448de4ea4$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f2c40a6448de4ea4$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $ZdcNb.encode(res, enc);
};

});


parcelRegister("96jZE", function(module, exports) {
'use strict';

var $leqJp = parcelRequire("leqJp");

var $hwVHR = parcelRequire("hwVHR");

var $ZdcNb = parcelRequire("ZdcNb");
var $6a042ee1f208896f$var$assert = $ZdcNb.assert;
var $6a042ee1f208896f$var$parseBytes = $ZdcNb.parseBytes;

var $cR8ar = parcelRequire("cR8ar");

var $8zcvU = parcelRequire("8zcvU");
function $6a042ee1f208896f$var$EDDSA(curve) {
    $6a042ee1f208896f$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $6a042ee1f208896f$var$EDDSA)) return new $6a042ee1f208896f$var$EDDSA(curve);
    curve = $hwVHR[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $leqJp.sha512;
}
module.exports = $6a042ee1f208896f$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6a042ee1f208896f$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6a042ee1f208896f$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6a042ee1f208896f$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $ZdcNb.intFromLE(hash.digest()).umod(this.curve.n);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $cR8ar.fromPublic(this, pub);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $cR8ar.fromSecret(this, secret);
};
$6a042ee1f208896f$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $8zcvU) return sig;
    return new $8zcvU(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6a042ee1f208896f$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6a042ee1f208896f$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $ZdcNb.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $ZdcNb.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6a042ee1f208896f$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$6a042ee1f208896f$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $ZdcNb.intFromLE(bytes);
};
$6a042ee1f208896f$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("cR8ar", function(module, exports) {
'use strict';

var $ZdcNb = parcelRequire("ZdcNb");
var $95c0c52842c57a81$var$assert = $ZdcNb.assert;
var $95c0c52842c57a81$var$parseBytes = $ZdcNb.parseBytes;
var $95c0c52842c57a81$var$cachedProperty = $ZdcNb.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $95c0c52842c57a81$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $95c0c52842c57a81$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $95c0c52842c57a81$var$parseBytes(params.pub);
}
$95c0c52842c57a81$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $95c0c52842c57a81$var$KeyPair) return pub;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        pub: pub
    });
};
$95c0c52842c57a81$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $95c0c52842c57a81$var$KeyPair) return secret;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        secret: secret
    });
};
$95c0c52842c57a81$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$95c0c52842c57a81$var$KeyPair.prototype.sign = function sign(message) {
    $95c0c52842c57a81$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $95c0c52842c57a81$var$assert(this._secret, 'KeyPair is public only');
    return $ZdcNb.encode(this.secret(), enc);
};
$95c0c52842c57a81$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ZdcNb.encode(this.pubBytes(), enc);
};
module.exports = $95c0c52842c57a81$var$KeyPair;

});

parcelRegister("8zcvU", function(module, exports) {
'use strict';

var $6soDQ = parcelRequire("6soDQ");

var $ZdcNb = parcelRequire("ZdcNb");
var $63cb4c939de36593$var$assert = $ZdcNb.assert;
var $63cb4c939de36593$var$cachedProperty = $ZdcNb.cachedProperty;
var $63cb4c939de36593$var$parseBytes = $ZdcNb.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $63cb4c939de36593$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $63cb4c939de36593$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $63cb4c939de36593$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $6soDQ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$63cb4c939de36593$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$63cb4c939de36593$var$Signature.prototype.toHex = function toHex() {
    return $ZdcNb.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $63cb4c939de36593$var$Signature;

});



parcelRegister("6JcDT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0143a0025c0142a7$require$Buffer = $ihoyg.Buffer;

var $cUvgf = parcelRequire("cUvgf");
const $0143a0025c0142a7$var$ONE1 = $0143a0025c0142a7$require$Buffer.alloc(1, 1);
const $0143a0025c0142a7$var$ZERO1 = $0143a0025c0142a7$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $0143a0025c0142a7$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $0143a0025c0142a7$require$Buffer.alloc(32, 0);
    let v = $0143a0025c0142a7$require$Buffer.alloc(32, 1);
    // Step D
    k = $cUvgf('sha256', k).update(v).update($0143a0025c0142a7$var$ZERO1).update(x).update(hash).update(extraEntropy || '').digest();
    // Step E
    v = $cUvgf('sha256', k).update(v).digest();
    // Step F
    k = $cUvgf('sha256', k).update(v).update($0143a0025c0142a7$var$ONE1).update(x).update(hash).update(extraEntropy || '').digest();
    // Step G
    v = $cUvgf('sha256', k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $cUvgf('sha256', k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $cUvgf('sha256', k).update(v).update($0143a0025c0142a7$var$ZERO1).digest();
        v = $cUvgf('sha256', k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $cUvgf('sha256', k).update(v).digest();
        T = v;
    }
    return T;
}
module.exports = $0143a0025c0142a7$var$deterministicGenerateK;

});


parcelRegister("bDP98", function(module, exports) {

var $5PqjV = parcelRequire("5PqjV");

var $WjcEN = parcelRequire("WjcEN");
// short-hand
var $879b02cdd754e3b5$var$tfJSON = $5PqjV.tfJSON;
var $879b02cdd754e3b5$var$TfTypeError = $5PqjV.TfTypeError;
var $879b02cdd754e3b5$var$TfPropertyTypeError = $5PqjV.TfPropertyTypeError;
var $879b02cdd754e3b5$var$tfSubError = $5PqjV.tfSubError;
var $879b02cdd754e3b5$var$getValueTypeName = $5PqjV.getValueTypeName;
var $879b02cdd754e3b5$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $879b02cdd754e3b5$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$WjcEN.Array(array)) return false;
            if ($WjcEN.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = '[' + $879b02cdd754e3b5$var$tfJSON(type) + ']';
            if (options.length !== undefined) str += '{' + options.length + '}';
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += '{' + (options.minLength === undefined ? 0 : options.minLength) + ',' + (options.maxLength === undefined ? Infinity : options.maxLength) + '}';
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $879b02cdd754e3b5$var$compile(type);
        function _maybe(value, strict) {
            return $WjcEN.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return '?' + $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $879b02cdd754e3b5$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $879b02cdd754e3b5$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $879b02cdd754e3b5$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName, 'key');
                }
                try {
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return '{' + $879b02cdd754e3b5$var$tfJSON(propertyKeyType) + ': ' + $879b02cdd754e3b5$var$tfJSON(propertyType) + '}';
        };
        else _map.toJSON = function() {
            return '{' + $879b02cdd754e3b5$var$tfJSON(propertyType) + '}';
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $879b02cdd754e3b5$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $879b02cdd754e3b5$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join('|');
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join(' & ');
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $879b02cdd754e3b5$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _tuple(values, strict) {
            if ($WjcEN.Nil(values)) return false;
            if ($WjcEN.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return '(' + types.map($879b02cdd754e3b5$var$tfJSON).join(', ') + ')';
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$879b02cdd754e3b5$var$TYPES.oneOf = $879b02cdd754e3b5$var$TYPES.anyOf;
function $879b02cdd754e3b5$var$compile(type) {
    if ($WjcEN.String(type)) {
        if (type[0] === '?') return $879b02cdd754e3b5$var$TYPES.maybe(type.slice(1));
        return $WjcEN[type] || $879b02cdd754e3b5$var$TYPES.quacksLike(type);
    } else if (type && $WjcEN.Object(type)) {
        if ($WjcEN.Array(type)) {
            if (type.length !== 1) throw new TypeError('Expected compile() parameter of type Array of length 1');
            return $879b02cdd754e3b5$var$TYPES.arrayOf(type[0]);
        }
        return $879b02cdd754e3b5$var$TYPES.object(type);
    } else if ($WjcEN.Function(type)) return type;
    return $879b02cdd754e3b5$var$TYPES.value(type);
}
function $879b02cdd754e3b5$var$typeforce(type, value, strict, surrogate) {
    if ($WjcEN.Function(type)) {
        if (type(value, strict)) return true;
        throw new $879b02cdd754e3b5$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $879b02cdd754e3b5$var$typeforce($879b02cdd754e3b5$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $879b02cdd754e3b5$var$typeName in $WjcEN)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $WjcEN[$879b02cdd754e3b5$var$typeName];
for($879b02cdd754e3b5$var$typeName in $879b02cdd754e3b5$var$TYPES)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $879b02cdd754e3b5$var$TYPES[$879b02cdd754e3b5$var$typeName];

var $i4G8Y = parcelRequire("i4G8Y");
for($879b02cdd754e3b5$var$typeName in $i4G8Y)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $i4G8Y[$879b02cdd754e3b5$var$typeName];
$879b02cdd754e3b5$var$typeforce.compile = $879b02cdd754e3b5$var$compile;
$879b02cdd754e3b5$var$typeforce.TfTypeError = $879b02cdd754e3b5$var$TfTypeError;
$879b02cdd754e3b5$var$typeforce.TfPropertyTypeError = $879b02cdd754e3b5$var$TfPropertyTypeError;
module.exports = $879b02cdd754e3b5$var$typeforce;

});
parcelRegister("5PqjV", function(module, exports) {

var $WjcEN = parcelRequire("WjcEN");
function $43e621d6b47985c7$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $43e621d6b47985c7$var$getValueTypeName(value) {
    return $WjcEN.Nil(value) ? '' : $43e621d6b47985c7$var$getTypeName(value.constructor);
}
function $43e621d6b47985c7$var$getValue(value) {
    if ($WjcEN.Function(value)) return '';
    if ($WjcEN.String(value)) return JSON.stringify(value);
    if (value && $WjcEN.Object(value)) return '';
    return value;
}
function $43e621d6b47985c7$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $43e621d6b47985c7$var$tfJSON(type) {
    if ($WjcEN.Function(type)) return type.toJSON ? type.toJSON() : $43e621d6b47985c7$var$getTypeName(type);
    if ($WjcEN.Array(type)) return 'Array';
    if (type && $WjcEN.Object(type)) return 'Object';
    return type !== undefined ? type : '';
}
function $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $43e621d6b47985c7$var$getValue(value);
    return 'Expected ' + $43e621d6b47985c7$var$tfJSON(type) + ', got' + (valueTypeName !== '' ? ' ' + valueTypeName : '') + (valueJson !== '' ? ' ' + valueJson : '');
}
function $43e621d6b47985c7$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
    this.message = $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === 'key') description = '" with key type ';
    return $43e621d6b47985c7$var$tfErrorString('property "' + $43e621d6b47985c7$var$tfJSON(name) + description + $43e621d6b47985c7$var$tfJSON(type), value, valueTypeName);
}
function $43e621d6b47985c7$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
        this.message = $43e621d6b47985c7$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfPropertyTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfCustomError(expected, actual) {
    return new $43e621d6b47985c7$var$TfTypeError(expected, {}, actual);
}
function $43e621d6b47985c7$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $43e621d6b47985c7$var$TfPropertyTypeError) {
        property = property + '.' + e.__property;
        e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $43e621d6b47985c7$var$TfTypeError) e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $43e621d6b47985c7$var$TfTypeError,
    TfPropertyTypeError: $43e621d6b47985c7$var$TfPropertyTypeError,
    tfCustomError: $43e621d6b47985c7$var$tfCustomError,
    tfSubError: $43e621d6b47985c7$var$tfSubError,
    tfJSON: $43e621d6b47985c7$var$tfJSON,
    getValueTypeName: $43e621d6b47985c7$var$getValueTypeName
};

});
parcelRegister("WjcEN", function(module, exports) {
var $0af4503d1812f988$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === 'boolean';
    },
    Function: function(value) {
        return typeof value === 'function';
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === 'number';
    },
    Object: function(value) {
        return typeof value === 'object';
    },
    String: function(value) {
        return typeof value === 'string';
    },
    '': function() {
        return true;
    }
};
// TODO: deprecate
$0af4503d1812f988$var$types.Null = $0af4503d1812f988$var$types.Nil;
for(var $0af4503d1812f988$var$typeName in $0af4503d1812f988$var$types)$0af4503d1812f988$var$types[$0af4503d1812f988$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $0af4503d1812f988$var$typeName);
module.exports = $0af4503d1812f988$var$types;

});


parcelRegister("i4G8Y", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03654fa7a69bc7e8$require$Buffer = $ihoyg.Buffer;

var $WjcEN = parcelRequire("WjcEN");

var $5PqjV = parcelRequire("5PqjV");
function $03654fa7a69bc7e8$var$_Buffer(value) {
    return $03654fa7a69bc7e8$require$Buffer.isBuffer(value);
}
function $03654fa7a69bc7e8$var$Hex(value) {
    return typeof value === 'string' && /^([0-9a-f]{2})+$/i.test(value);
}
function $03654fa7a69bc7e8$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $5PqjV.tfCustomError(name + '(Length: ' + length + ')', name + '(Length: ' + value.length + ')');
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $03654fa7a69bc7e8$var$_ArrayN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.Array);
var $03654fa7a69bc7e8$var$_BufferN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$_Buffer);
var $03654fa7a69bc7e8$var$_HexN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$Hex);
var $03654fa7a69bc7e8$var$_StringN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.String);
function $03654fa7a69bc7e8$var$Range(a, b, f) {
    f = f || $WjcEN.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $03654fa7a69bc7e8$var$INT53_MAX = Math.pow(2, 53) - 1;
function $03654fa7a69bc7e8$var$Finite(value) {
    return typeof value === 'number' && isFinite(value);
}
function $03654fa7a69bc7e8$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $03654fa7a69bc7e8$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $03654fa7a69bc7e8$var$Int32(value) {
    return (value | 0) === value;
}
function $03654fa7a69bc7e8$var$Int53(value) {
    return typeof value === 'number' && value >= -$03654fa7a69bc7e8$var$INT53_MAX && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
function $03654fa7a69bc7e8$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $03654fa7a69bc7e8$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $03654fa7a69bc7e8$var$UInt32(value) {
    return value >>> 0 === value;
}
function $03654fa7a69bc7e8$var$UInt53(value) {
    return typeof value === 'number' && value >= 0 && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
var $03654fa7a69bc7e8$var$types = {
    ArrayN: $03654fa7a69bc7e8$var$_ArrayN,
    Buffer: $03654fa7a69bc7e8$var$_Buffer,
    BufferN: $03654fa7a69bc7e8$var$_BufferN,
    Finite: $03654fa7a69bc7e8$var$Finite,
    Hex: $03654fa7a69bc7e8$var$Hex,
    HexN: $03654fa7a69bc7e8$var$_HexN,
    Int8: $03654fa7a69bc7e8$var$Int8,
    Int16: $03654fa7a69bc7e8$var$Int16,
    Int32: $03654fa7a69bc7e8$var$Int32,
    Int53: $03654fa7a69bc7e8$var$Int53,
    Range: $03654fa7a69bc7e8$var$Range,
    StringN: $03654fa7a69bc7e8$var$_StringN,
    UInt8: $03654fa7a69bc7e8$var$UInt8,
    UInt16: $03654fa7a69bc7e8$var$UInt16,
    UInt32: $03654fa7a69bc7e8$var$UInt32,
    UInt53: $03654fa7a69bc7e8$var$UInt53
};
for(var $03654fa7a69bc7e8$var$typeName in $03654fa7a69bc7e8$var$types)$03654fa7a69bc7e8$var$types[$03654fa7a69bc7e8$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $03654fa7a69bc7e8$var$typeName);
module.exports = $03654fa7a69bc7e8$var$types;

});


parcelRegister("bTFmB", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8a94eab3b5d39034$require$Buffer = $ihoyg.Buffer;

var $1Vf4C = parcelRequire("1Vf4C");
function $8a94eab3b5d39034$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error('Invalid network version');
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error('Invalid WIF length');
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error('Invalid compression flag');
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed) {
    var result = new $8a94eab3b5d39034$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $8a94eab3b5d39034$var$decode(string, version) {
    return $8a94eab3b5d39034$var$decodeRaw($1Vf4C.decode(string), version);
}
function $8a94eab3b5d39034$var$encode(version, privateKey, compressed) {
    if (typeof version === 'number') return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed));
    return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $8a94eab3b5d39034$var$decode,
    decodeRaw: $8a94eab3b5d39034$var$decodeRaw,
    encode: $8a94eab3b5d39034$var$encode,
    encodeRaw: $8a94eab3b5d39034$var$encodeRaw
};

});




parcelRegister("eMsup", function(module, exports) {
"use strict";
var $ac2ba5ca5607cf24$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PubKeySecp256k1 = module.exports.PrivKeySecp256k1 = void 0;

var $8J1ou = parcelRequire("8J1ou");

const $ac2ba5ca5607cf24$var$crypto_js_1 = $ac2ba5ca5607cf24$var$__importDefault((parcelRequire("kWcCv")));

var $ihoyg = parcelRequire("ihoyg");

var $i1G9i = parcelRequire("i1G9i");
class $ac2ba5ca5607cf24$var$PrivKeySecp256k1 {
    static generateRandomKey() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        return new $ac2ba5ca5607cf24$var$PrivKeySecp256k1($ihoyg.Buffer.from(secp256k1.genKeyPair().getPrivate().toArray()));
    }
    constructor(privKey){
        this.privKey = privKey;
    }
    toBytes() {
        return new Uint8Array(this.privKey);
    }
    getPubKey() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        return new $ac2ba5ca5607cf24$var$PubKeySecp256k1(new Uint8Array(key.getPublic().encodeCompressed("array")));
    }
    signDigest32(digest) {
        if (digest.length !== 32) throw new Error(`Invalid length of digest to sign: ${digest.length}`);
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        const signature = key.sign(digest, {
            canonical: true
        });
        return {
            r: new Uint8Array(signature.r.toArray("be", 32)),
            s: new Uint8Array(signature.s.toArray("be", 32)),
            v: signature.recoveryParam
        };
    }
}
module.exports.PrivKeySecp256k1 = $ac2ba5ca5607cf24$var$PrivKeySecp256k1;
class $ac2ba5ca5607cf24$var$PubKeySecp256k1 {
    constructor(pubKey){
        this.pubKey = pubKey;
        if (pubKey.length !== 33 && pubKey.length !== 65) throw new Error(`Invalid length of public key: ${pubKey.length}`);
    }
    toBytes(uncompressed) {
        if (uncompressed && this.pubKey.length === 65) return this.pubKey;
        if (!uncompressed && this.pubKey.length === 33) return this.pubKey;
        const keyPair = this.toKeyPair();
        if (uncompressed) return new Uint8Array($ihoyg.Buffer.from(keyPair.getPublic().encode("hex", false), "hex"));
        else return new Uint8Array($ihoyg.Buffer.from(keyPair.getPublic().encodeCompressed("hex"), "hex"));
    }
    /**
     * @deprecated Use `getCosmosAddress()` instead.
     */ getAddress() {
        return this.getCosmosAddress();
    }
    getCosmosAddress() {
        let hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(this.toBytes(false))).toString();
        hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.RIPEMD160($ac2ba5ca5607cf24$var$crypto_js_1.default.enc.Hex.parse(hash)).toString();
        return new Uint8Array($ihoyg.Buffer.from(hash, "hex"));
    }
    getEthAddress() {
        // Should be uncompressed.
        // And remove prefix byte.
        // And hash by keccak256.
        // Use last 20 bytes.
        return $i1G9i.Hash.keccak256(this.toBytes(true).slice(1)).slice(-20);
    }
    toKeyPair() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        return secp256k1.keyFromPublic($ihoyg.Buffer.from(this.pubKey).toString("hex"), "hex");
    }
    verifyDigest32(digest, signature) {
        if (digest.length !== 32) throw new Error(`Invalid length of digest to verify: ${digest.length}`);
        if (signature.length !== 64) throw new Error(`Invalid length of signature: ${signature.length}`);
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const r = signature.slice(0, 32);
        const s = signature.slice(32);
        return secp256k1.verify(digest, {
            r: $ihoyg.Buffer.from(r).toString("hex"),
            s: $ihoyg.Buffer.from(s).toString("hex")
        }, this.toKeyPair());
    }
}
module.exports.PubKeySecp256k1 = $ac2ba5ca5607cf24$var$PubKeySecp256k1;

});
parcelRegister("kWcCv", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("9PUgX")), (parcelRequire("gu0dW")), (parcelRequire("500SS")), (parcelRequire("8aX4Y")), (parcelRequire("6oXxt")), (parcelRequire("lqaMD")), (parcelRequire("hNROW")), (parcelRequire("kgfdC")), (parcelRequire("6PaKQ")), (parcelRequire("bZEkw")), (parcelRequire("AFosI")), (parcelRequire("bIitx")), (parcelRequire("7ft6W")), (parcelRequire("as0jN")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")), (parcelRequire("kvEE5")), (parcelRequire("4phbY")), (parcelRequire("5AuZH")), (parcelRequire("9xxh3")), (parcelRequire("hsvIJ")), (parcelRequire("cIj8k")), (parcelRequire("3XsJo")), (parcelRequire("4cP0m")), (parcelRequire("1bHm1")), (parcelRequire("5oWlT")), (parcelRequire("eSHMm")), (parcelRequire("3H9rt")), (parcelRequire("2QWZ2")), (parcelRequire("1sYM8")), (parcelRequire("hUv46")), (parcelRequire("3ybbi")), (parcelRequire("f4sF8")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("cfaDk", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("5Io6y"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("gn80J", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("9PUgX", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("gu0dW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("500SS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("8aX4Y", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("6oXxt", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("lqaMD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("hNROW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("kgfdC", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("6PaKQ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("bZEkw", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("6PaKQ")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("AFosI", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("bIitx", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("7ft6W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("as0jN", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("ioEPr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("fctwD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("ioEPr")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == 'string') return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == 'string') return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("kvEE5", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("4phbY", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("5AuZH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("9xxh3", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("hsvIJ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("cIj8k", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("3XsJo", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("4cP0m", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("1bHm1", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("5oWlT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("eSHMm", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("3H9rt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("2QWZ2", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("1sYM8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("hUv46", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("3ybbi", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("f4sF8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


parcelRegister("i1G9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = void 0;

var $fkJVr = parcelRequire("fkJVr");

var $8unkG = parcelRequire("8unkG");

var $ihoyg = parcelRequire("ihoyg");
class $d1f903e0ae54b644$var$Hash {
    static sha256(data) {
        return new Uint8Array(new $fkJVr.sha256().update(data).digest());
    }
    static keccak256(data) {
        return $ihoyg.Buffer.from((0, $8unkG.keccak256)(data).replace("0x", ""), "hex");
    }
    static truncHashPortion(str, firstCharCount = str.length, endCharCount = 0) {
        return str.substring(0, firstCharCount) + "\u2026" + str.substring(str.length - endCharCount, str.length);
    }
}
module.exports.Hash = $d1f903e0ae54b644$var$Hash;

});




parcelRegister("66Dak", function(module, exports) {
"use strict";
var $4721af15c4c1284c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4721af15c4c1284c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4721af15c4c1284c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4721af15c4c1284c$var$__exportStar((parcelRequire("3pcXM")), module.exports);

$4721af15c4c1284c$var$__exportStar((parcelRequire("8uubE")), module.exports);

});
parcelRegister("3pcXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toGenerator = void 0;
// Copied from the mobx-state-tree repository.
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise to a generator yielding that promise
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* toGenerator(getDataAsync("input value"));
 *     ...
 *   })
 * }))
 * ```
 */ function* $27adc320c4563bce$var$toGenerator(p) {
    return yield p;
}
module.exports.toGenerator = $27adc320c4563bce$var$toGenerator;

});

parcelRegister("8uubE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DebounceActionTimer = void 0;

var $9Qp9d = parcelRequire("9Qp9d");
class $62e88a9027882594$var$DebounceActionTimer {
    constructor(debounceMs, handler){
        this.debounceMs = debounceMs;
        this.handler = handler;
        this.requests = [];
        this.startTime = 0;
        this.tick = ()=>{
            let shouldExec = this.debounceMs <= 0;
            if (this.debounceMs > 0) {
                const now = Date.now();
                if (now - this.startTime >= this.debounceMs) shouldExec = true;
            }
            if (shouldExec) {
                // Should use sliced (copied) array
                const requests = this.requests.slice();
                const responses = this.handler(requests);
                if (typeof responses === "object" && "then" in responses) Promise.resolve(responses).then((responses)=>{
                    this.handleResponses(requests, responses);
                });
                else this.handleResponses(requests, responses);
                this.requests = [];
            } else this.nextTick(this.tick);
        };
        this.handleResponses = (requests, responses)=>{
            (0, $9Qp9d.runInAction)(()=>{
                for(let i = 0; i < requests.length; i++){
                    const req = requests[i];
                    const res = responses[i];
                    req.action(res);
                }
            });
            for (const req of requests)req.resolver();
        };
    }
    call(args, action) {
        return new Promise((resolve)=>{
            const newStart = this.requests.length === 0;
            this.requests.push({
                args: args,
                action: action,
                resolver: resolve
            });
            if (newStart) this.startTimer();
        });
    }
    startTimer() {
        this.startTime = Date.now();
        this.nextTick(this.tick);
    }
    nextTick(fn) {
        if (this.debounceMs <= 0) {
            Promise.resolve().then(fn);
            return;
        }
        if (typeof window !== "undefined" && window.requestAnimationFrame) window.requestAnimationFrame(fn);
        else setTimeout(fn, this.debounceMs);
    }
}
module.exports.DebounceActionTimer = $62e88a9027882594$var$DebounceActionTimer;

});
parcelRegister("9Qp9d", function(module, exports) {

$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});



parcelRegister("kD8tN", function(module, exports) {
"use strict";
var $f04e070ac49b61e2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f04e070ac49b61e2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f04e070ac49b61e2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f04e070ac49b61e2$var$__exportStar((parcelRequire("lDYd8")), module.exports);

});
parcelRegister("lDYd8", function(module, exports) {
"use strict";
var $fc1bf222db89e6f3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Debouncer = void 0;
class $fc1bf222db89e6f3$var$Debouncer {
    static promise(fn) {
        let currentPromise;
        return (...arguments_)=>$fc1bf222db89e6f3$var$__awaiter(this, void 0, void 0, function*() {
                if (currentPromise) return currentPromise;
                try {
                    currentPromise = fn.apply(this, arguments_);
                    return yield currentPromise;
                } finally{
                    currentPromise = undefined;
                }
            });
    }
}
module.exports.Debouncer = $fc1bf222db89e6f3$var$Debouncer;

});


parcelRegister("Ao8HI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unescapeHTML = module.exports.escapeHTML = void 0;
/**
 * Escapes <,>,& in string.
 * Golang's json marshaller escapes <,>,& by default.
 * However, because JS doesn't do that by default, to match the sign doc with cosmos-sdk,
 * we should escape <,>,& in string manually.
 * @param str
 */ function $06d6167cbd8e9bb2$var$escapeHTML(str) {
    return str.replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
module.exports.escapeHTML = $06d6167cbd8e9bb2$var$escapeHTML;
/**
 * Unescapes \u003c/(<),\u003e(>),\u0026(&) in string.
 * Golang's json marshaller escapes <,>,& by default, whilst for most of the users, such escape characters are unfamiliar.
 * This function can be used to show the escaped characters with more familiar characters.
 * @param str
 */ function $06d6167cbd8e9bb2$var$unescapeHTML(str) {
    return str.replace(/\\u003c/g, "<").replace(/\\u003e/g, ">").replace(/\\u0026/g, "&");
}
module.exports.unescapeHTML = $06d6167cbd8e9bb2$var$unescapeHTML;

});

parcelRegister("lPnds", function(module, exports) {
"use strict";
var $fe405e995f78751f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe405e995f78751f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fe405e995f78751f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fe405e995f78751f$var$__exportStar((parcelRequire("5TeGA")), module.exports);

});
parcelRegister("5TeGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortedJsonByKeyStringify = module.exports.sortObjectByKey = void 0;
function $449d7b20b52cdc77$var$sortObjectByKey(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($449d7b20b52cdc77$var$sortObjectByKey);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    sortedKeys.forEach((key)=>{
        result[key] = $449d7b20b52cdc77$var$sortObjectByKey(obj[key]);
    });
    return result;
}
module.exports.sortObjectByKey = $449d7b20b52cdc77$var$sortObjectByKey;
function $449d7b20b52cdc77$var$sortedJsonByKeyStringify(obj) {
    return JSON.stringify($449d7b20b52cdc77$var$sortObjectByKey(obj));
}
module.exports.sortedJsonByKeyStringify = $449d7b20b52cdc77$var$sortedJsonByKeyStringify;

});


parcelRegister("56GCf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateICNSName = module.exports.parseICNSName = void 0;
function $3b7e91e67773fd13$var$parseICNSName(name) {
    const split = name.split(".");
    if (split.length === 2) {
        if (split[0].length > 0 && split[1].length > 0) return [
            split[0],
            split[1]
        ];
    }
    return undefined;
}
module.exports.parseICNSName = $3b7e91e67773fd13$var$parseICNSName;
function $3b7e91e67773fd13$var$validateICNSName(name, bech32Prefix) {
    const parsed = $3b7e91e67773fd13$var$parseICNSName(name);
    if (!parsed) return false;
    return parsed[1] === bech32Prefix;
}
module.exports.validateICNSName = $3b7e91e67773fd13$var$validateICNSName;

});








parcelRegister("5SJmA", function(module, exports) {
'use strict';

var $5h1gV = parcelRequire("5h1gV");
var $44852f155f7153c6$require$MAX_SAFE_COMPONENT_LENGTH = $5h1gV.MAX_SAFE_COMPONENT_LENGTH;
var $44852f155f7153c6$require$MAX_SAFE_BUILD_LENGTH = $5h1gV.MAX_SAFE_BUILD_LENGTH;
var $44852f155f7153c6$require$MAX_LENGTH = $5h1gV.MAX_LENGTH;

var $55cMj = parcelRequire("55cMj");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        $44852f155f7153c6$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $44852f155f7153c6$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $55cMj(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
// Non-numberic identifiers include numberic identifiers but can be longer.
// Therefore non-numberic identifiers must go first.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${$44852f155f7153c6$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$44852f155f7153c6$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$44852f155f7153c6$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

});
parcelRegister("5h1gV", function(module, exports) {
'use strict';
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $3d6f86dbb10c2e17$var$SEMVER_SPEC_VERSION = '2.0.0';
const $3d6f86dbb10c2e17$var$MAX_LENGTH = 256;
const $3d6f86dbb10c2e17$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $3d6f86dbb10c2e17$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $3d6f86dbb10c2e17$var$MAX_SAFE_BUILD_LENGTH = $3d6f86dbb10c2e17$var$MAX_LENGTH - 6;
const $3d6f86dbb10c2e17$var$RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH: $3d6f86dbb10c2e17$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $3d6f86dbb10c2e17$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $3d6f86dbb10c2e17$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $3d6f86dbb10c2e17$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $3d6f86dbb10c2e17$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $3d6f86dbb10c2e17$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("55cMj", function(module, exports) {
'use strict';
const $3b3754e47e8a4a61$var$debug = ()=>{};
module.exports = $3b3754e47e8a4a61$var$debug;

});


parcelRegister("87el0", function(module, exports) {

$parcel$export(module.exports, "WALLET_ID", function () { return $1c912b91d0424812$export$7c460c214963f696; });
$parcel$export(module.exports, "HORIZON_URL", function () { return $1c912b91d0424812$export$16a6b582b6afb2f9; });
$parcel$export(module.exports, "RPC_URL", function () { return $1c912b91d0424812$export$b80b0b2fde73cc85; });
$parcel$export(module.exports, "NETWORK_PASSPHRASE", function () { return $1c912b91d0424812$export$3dccf8efa688f59e; });
$parcel$export(module.exports, "metadata", function () { return $1c912b91d0424812$export$dbb5e893e736e4ee; });

var $9HEDW = parcelRequire("9HEDW");

var $at5fu = parcelRequire("at5fu");
const $1c912b91d0424812$export$7c460c214963f696 = 'frighter';
const $1c912b91d0424812$export$16a6b582b6afb2f9 = 'https://horizon.stellar.org';
const $1c912b91d0424812$export$b80b0b2fde73cc85 = 'https://mainnet.sorobanrpc.com';
const $1c912b91d0424812$export$3dccf8efa688f59e = 'Public Global Stellar Network ; September 2015';
const $1c912b91d0424812$export$dbb5e893e736e4ee = {
    name: 'Freighter',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/freighter/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/freighter/bcacfldlkkdogcmkkibnjlakofdplcbk',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/freighter/',
        brave: 'https://chromewebstore.google.com/detail/freighter/bcacfldlkkdogcmkkibnjlakofdplcbk',
        homepage: 'https://www.freighter.app/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Stellar',
                        value: 'Stellar',
                        id: 'STELLAR',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((blockchainMeta)=>blockchainMeta.name === (0, $9HEDW.LegacyNetworks).STELLAR)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $at5fu.default)()
            }
        }
    ]
};

});
parcelRegister("at5fu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6976ec182e662426$export$2e2bcd8739ae039; });
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $6976ec182e662426$export$2e2bcd8739ae039() {
    const { Signer: StellarSigner } = await (parcelRequire("9Ozl8"));
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).STELLAR, new StellarSigner());
    return signers;
}

});
parcelRegister("9Ozl8", function(module, exports) {
module.exports = $parcel$import("gLEwd").then(()=>parcelRequire('gFciz'));

});



parcelRegister("13w09", function(module, exports) {

$parcel$export(module.exports, "namespace", function () { return $496951799cb28587$export$76a88f7de6507443; });
parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $6Mj8D = parcelRequire("6Mj8D");

var $jJRID = parcelRequire("jJRID");

var $87el0 = parcelRequire("87el0");

var $4ZOJS = parcelRequire("4ZOJS");
const [$496951799cb28587$var$changeAccountSubscriber, $496951799cb28587$var$changeAccountCleanup] = (0, $4ZOJS.changeAccountSubscriberBuilder)();
const $496951799cb28587$var$connect = (0, $6Mj8D.builders).connect().action(async function() {
    const result = await $jJRID.requestAccess();
    if (result.error) throw result.error;
    return [
        (0, $6Mj8D.utils).formatAddressToCAIP(result.address)
    ];
}).before($496951799cb28587$var$changeAccountSubscriber).or($496951799cb28587$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $496951799cb28587$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action(async function() {
    const result = await $jJRID.getAddress();
    return !!result.address;
}).build();
const $496951799cb28587$var$disconnect = (0, $f59Be.builders).disconnect().after($496951799cb28587$var$changeAccountCleanup).build();
const $496951799cb28587$var$balanceLines = (0, $6Mj8D.builders).balanceLines.build();
const $496951799cb28587$export$76a88f7de6507443 = new (0, $at2GJ.NamespaceBuilder)('Stellar', (0, $87el0.WALLET_ID)).action($496951799cb28587$var$connect).action($496951799cb28587$var$canEagerConnect).action($496951799cb28587$var$disconnect).action($496951799cb28587$var$balanceLines).build();

});
parcelRegister("fvuxD", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return (parcelRequire("hRmKL")).Hub; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("hmR2n")).Provider; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("e21ow")).createStore; });
$parcel$export(module.exports, "NamespaceBuilder", function () { return (parcelRequire("at2GJ")).NamespaceBuilder; });
$parcel$export(module.exports, "ProviderBuilder", function () { return (parcelRequire("fFglI")).ProviderBuilder; });
$parcel$export(module.exports, "ActionBuilder", function () { return (parcelRequire("fha7R")).ActionBuilder; });
parcelRequire("eb86r");
var $e21ow = parcelRequire("e21ow");
var $hRmKL = parcelRequire("hRmKL");
var $hmR2n = parcelRequire("hmR2n");
parcelRequire("fXICR");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");
var $fFglI = parcelRequire("fFglI");
parcelRequire("gYI4Q");
var $2974Y = parcelRequire("2974Y");

});
parcelRegister("eb86r", function(module, exports) {

$parcel$export(module.exports, "Namespace", function () { return (parcelRequire("h89vi")).Namespace; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("hmR2n")).Provider; });
$parcel$export(module.exports, "Hub", function () { return (parcelRequire("hRmKL")).Hub; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("e21ow")).createStore; });
parcelRequire("9qqlo");
var $h89vi = parcelRequire("h89vi");
parcelRequire("IkSJw");
var $hmR2n = parcelRequire("hmR2n");

var $hRmKL = parcelRequire("hRmKL");
parcelRequire("9Jqza");
var $e21ow = parcelRequire("e21ow");

var $dfA3S = parcelRequire("dfA3S");

});
parcelRegister("9qqlo", function(module, exports) {

$parcel$export(module.exports, "Namespace", function () { return (parcelRequire("h89vi")).Namespace; });

var $h89vi = parcelRequire("h89vi");

});
parcelRegister("h89vi", function(module, exports) {

$parcel$export(module.exports, "Namespace", function () { return $1baac8b2b2b1ced3$export$f89ac22183df46e9; });

var $dfA3S = parcelRequire("dfA3S");

var $aTNJM = parcelRequire("aTNJM");
/**
 *
 * A Namespace is a unit of wallets where usually handles connecting, signing, accounts, ...
 * It will be injected by wallet in its object, for example, `window.phantom.ethereum` or `window.phantom.solana`
 * Each namespace (like solana) has its own functionality which is not shared between all the blockchains.
 * For example in EVM namespaces, you can have different networks (e.g. Ethereum,Polygon, ...) and there are specific flows to handle connecting to them or add a network and etc.
 * But Solana doesn't have this concept and you will directly always connect to solana itself.
 * This is true for signing a transaction, getting information about blockchain and more.
 * So by creating a namespace for each of these, we can define a custom namespace based on blockchain's properties.
 *
 */ class $1baac8b2b2b1ced3$export$f89ac22183df46e9 {
    #actions;
    #andOperators;
    #orOperators;
    // `context` for these two can be Namespace context or Provider context
    #beforeHooks;
    #afterHooks;
    #initiated;
    #store;
    // Namespace doesn't has any configs now, but we will need the feature in future
    // eslint-disable-next-line no-unused-private-class-members
    #configs;
    constructor(id, providerId, options){
        this.#andOperators = new Map();
        this.#orOperators = new Map();
        this.#beforeHooks = new Map();
        this.#afterHooks = new Map();
        this.#initiated = false;
        const { configs: configs, actions: actions } = options;
        this.namespaceId = id;
        this.providerId = providerId;
        this.#configs = configs || new Map();
        this.#actions = actions;
        if (options.store) this.store(options.store);
    }
    /**
   * This is an special action that will be called **only once**.
   * We don't call this in `constructor` and developer should call this manually. we only ensure it will be called once.
   *
   * ```ts
   * const myInit = () => {  whatever; }
   * const actions = new Map();
   * actions.set("init", myInit)
   * const ns = new Namespace(..., {actions});
   *
   * // Will run `myInit`
   * ns.init()
   *
   * // Will not run `myInit` anymore.
   * ns.init()
   * ns.init()
   * ```
   */ init() {
        if (this.#initiated) return;
        const definedInitByUser = this.#actions.get('init');
        if (definedInitByUser) definedInitByUser(this.#context());
        // else, this namespace doesn't have any `init` implemented.
        this.#initiated = true;
    }
    /**
   * Reading states from store and also update them.
   *
   * @example
   * ```ts
   * const ns = new Namespace(...);
   * const [getState, setState] = ns.state();
   * ```
   */ state() {
        const store = this.#store;
        if (!store) throw new Error('You need to set your store using `.store` method first.');
        const id = this.#storeId();
        const setState = (name, value)=>{
            store.getState().namespaces.updateStatus(id, name, value);
        };
        const getState = (name)=>{
            const state = store.getState().namespaces.getNamespaceData(id);
            if (!name) return state;
            return state[name];
        };
        return [
            getState,
            setState
        ];
    }
    /**
   * For keeping state, we need a store. all the states will be write to/read from store.
   *
   * Note: Store can be setup on constructor as well.
   *
   * @example
   * ```ts
   * const myStore = createStore();
   * const ns = new Namespace(...);
   * ns.store(myStore);
   * ```
   */ store(store) {
        if (this.#store) console.warn("You've already set an store for your Namespace. Old store will be replaced by the new one.");
        this.#store = store;
        this.#setupStore();
        return this;
    }
    /**
   * It's a boolean operator to run a sync function if action ran successfully.
   * For example, if we have a `connect` action, we can add function to be run after `connect` if it ran successfully.
   *
   * @example
   * ```ts
   *  const ns = new Namespace(..);
   *
   *  ns.and_then('connect', (context) => {
   *    ...
   *  });
   * ```
   *
   */ and_then(actionName, operatorFn) {
        const currentAndOperators = this.#andOperators.get(actionName) || [];
        this.#andOperators.set(actionName, currentAndOperators.concat(operatorFn));
        return this;
    }
    /**
   * It's a boolean operator to run a function to handle when an action fails.
   * For example, if we have a `connect` action, we can add function to be run when `connect` fails (throw an error).
   *
   * @example
   * ```ts
   *  const ns = new Namespace(..);
   *
   *  ns.or_else('connect', (context, error) => {
   *    ...
   *  });
   * ```
   */ or_else(actionName, operatorFn) {
        const currentOrOperators = this.#orOperators.get(actionName) || [];
        this.#orOperators.set(actionName, currentOrOperators.concat(operatorFn));
        return this;
    }
    /**
   * Running a function after a specific action
   *
   * Note: the context can be set from outside as well. this is useful for Provider to set its context instead of namespace context.
   *
   * @example
   * ```ts
   *  const ns = new Namespace(...);
   *
   *  ns.after("connect", (context) => {});
   * ```
   */ after(actionName, hook, options) {
        const currentAfterHooks = this.#afterHooks.get(actionName) || [];
        const hookWithOptions = {
            hook: hook,
            options: {
                context: options?.context
            }
        };
        this.#afterHooks.set(actionName, currentAfterHooks.concat(hookWithOptions));
        return this;
    }
    /**
   * Running a function before a specific action
   *
   * Note: the context can be set from outside as well. this is useful for Provider to set its context instead of using namespace context.
   *
   * @example
   * ```ts
   *  const ns = new Namespace(...);
   *
   *  ns.before("connect", (context) => {});
   * ```
   */ before(actionName, hook, options) {
        const currentBeforeHooks = this.#beforeHooks.get(actionName) || [];
        const hookWithOptions = {
            hook: hook,
            options: {
                context: options?.context
            }
        };
        this.#beforeHooks.set(actionName, currentBeforeHooks.concat(hookWithOptions));
        return this;
    }
    has(actionName) {
        return !!this.#actions.get(actionName);
    }
    /**
   *
   * Registered actions will be called using `run`. it will run an action and all the operators or hooks that assigned.
   *
   * @example
   * ```ts
   *  const actions = new Map();
   *  actions.set('connect', connectAction);
   *
   *  const ns = new Namespace(NAMESPACE, PROVIDER_ID, {
   *    actions: actions,
   *  });
   *
   *  ns.run("action");
   * ```
   */ run(actionName, ...args) {
        const action = this.#actions.get(actionName);
        if (!action) throw new Error((0, $aTNJM.ACTION_NOT_FOUND_ERROR)(actionName.toString()));
        /*
     * Action can be both, sync or async. To simplify the process we can not make `sync` mode to async
     * Since every user's sync action will be an async function and affect what user expect,
     * it makes all the actions async and it doesn't match with Namespace interface (e.g. EvmActions)
     *
     * To avoid this issue and also not duplicating code, I broke the process into smaller methods
     * and two main methods to run actions: tryRunAsyncAction & tryRunAction.
     */ const result = (0, $dfA3S.isAsync)(action) ? this.#tryRunAsyncAction(actionName, args) : this.#tryRunAction(actionName, args);
        return result;
    }
    #tryRunAction(actionName, params) {
        try {
            this.#tryRunBeforeHooks(actionName);
        } catch (error) {
            this.#tryRunAfterHooks(actionName);
            throw new Error((0, $aTNJM.BEFORE_ACTION_FAILED_ERROR)(actionName.toString()), {
                cause: error
            });
        }
        const action = this.#actions.get(actionName);
        if (!action) throw new Error((0, $aTNJM.ACTION_NOT_FOUND_ERROR)(actionName.toString()));
        const context = this.#context();
        let result;
        try {
            result = action(context, ...params);
            result = this.#tryRunAndOperators(actionName, result);
        } catch (e) {
            result = this.#tryRunOrOperators(actionName, e);
        } finally{
            this.#tryRunAfterHooks(actionName);
        }
        return result;
    }
    async #tryRunAsyncAction(actionName, params) {
        try {
            this.#tryRunBeforeHooks(actionName);
        } catch (error) {
            this.#tryRunAfterHooks(actionName);
            throw new Error((0, $aTNJM.BEFORE_ACTION_FAILED_ERROR)(actionName.toString()), {
                cause: error
            });
        }
        const action = this.#actions.get(actionName);
        if (!action) throw new Error((0, $aTNJM.ACTION_NOT_FOUND_ERROR)(actionName.toString()));
        const context = this.#context();
        return await action(context, ...params).then((result)=>this.#tryRunAndOperators(actionName, result)).catch((e)=>this.#tryRunOrOperators(actionName, e)).finally(()=>this.#tryRunAfterHooks(actionName));
    }
    #tryRunAfterHooks(actionName) {
        const afterActions = this.#afterHooks.get(actionName);
        if (afterActions) afterActions.forEach((afterAction)=>{
            const context = afterAction.options?.context || this.#context();
            afterAction.hook(context);
        });
    }
    #tryRunBeforeHooks(actionName) {
        const beforeActions = this.#beforeHooks.get(actionName);
        if (beforeActions) beforeActions.forEach((beforeAction)=>{
            const context = beforeAction.options?.context || this.#context();
            beforeAction.hook(context);
        });
    }
    #tryRunAndOperators(actionName, result) {
        const andActions = this.#andOperators.get(actionName);
        if (andActions) {
            const context = this.#context();
            result = andActions.reduce((prev, andAction)=>{
                return andAction(context, prev);
            }, result);
        }
        return result;
    }
    #tryRunOrOperators(actionName, actionError) {
        const orActions = this.#orOperators.get(actionName);
        if (orActions) try {
            const context = this.#context();
            return orActions.reduce((prev, orAction)=>{
                return orAction(context, prev);
            }, actionError);
        } catch (orActionError) {
            if (orActionError instanceof Error) {
                orActionError.cause = actionError;
                throw orActionError;
            }
            const errorMessage = (0, $aTNJM.OR_ELSE_ACTION_FAILED_ERROR)(`${actionName.toString()} for ${this.namespaceId} namespace.`);
            const standardOrActionError = new Error(String(orActionError), {
                cause: actionError
            });
            throw new Error(errorMessage, {
                cause: standardOrActionError
            });
        }
        else throw actionError;
    }
    #setupStore() {
        const store = this.#store;
        if (!store) throw new Error((0, $aTNJM.NO_STORE_FOUND_ERROR));
        const id = this.#storeId();
        store.getState().namespaces.addNamespace(id, {
            namespaceId: this.namespaceId,
            providerId: this.providerId
        });
    }
    #storeId() {
        return (0, $dfA3S.generateStoreId)(this.providerId, this.namespaceId);
    }
    #context() {
        return {
            state: this.state.bind(this),
            action: this.run.bind(this)
        };
    }
}

});
parcelRegister("dfA3S", function(module, exports) {

$parcel$export(module.exports, "isAsync", function () { return $14a075f9a1797443$export$aefee5ebe1dcfd9e; });
$parcel$export(module.exports, "generateStoreId", function () { return $14a075f9a1797443$export$614fbb61b67095d0; });
/**
 * Note: This only works native async, if we are going to support for old transpilers like Babel.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $14a075f9a1797443$export$aefee5ebe1dcfd9e(fn) {
    return fn.constructor.name === 'AsyncFunction';
}
function $14a075f9a1797443$export$614fbb61b67095d0(providerId, namespace) {
    return `${providerId}$$${namespace}`;
}

});

parcelRegister("aTNJM", function(module, exports) {

$parcel$export(module.exports, "ACTION_NOT_FOUND_ERROR", function () { return $1223c31570db10a7$export$5b1d9ce3c3921fcd; });
$parcel$export(module.exports, "OR_ELSE_ACTION_FAILED_ERROR", function () { return $1223c31570db10a7$export$aefc0ab600a93b91; });
$parcel$export(module.exports, "BEFORE_ACTION_FAILED_ERROR", function () { return $1223c31570db10a7$export$15c3a5e0733e3116; });
$parcel$export(module.exports, "NO_STORE_FOUND_ERROR", function () { return $1223c31570db10a7$export$233c0dfe69728b75; });
const $1223c31570db10a7$export$5b1d9ce3c3921fcd = (name)=>`Couldn't find "${name}" action. Are you sure you've added the action?`;
const $1223c31570db10a7$export$aefc0ab600a93b91 = (name)=>`An error occurred during running ${name}`;
const $1223c31570db10a7$export$15c3a5e0733e3116 = (name)=>`An error occurred during running before for "${name}" action`;
const $1223c31570db10a7$export$233c0dfe69728b75 = 'For setup store, you should set `store` first.';

});



parcelRegister("IkSJw", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("hmR2n")).Provider; });

var $hmR2n = parcelRequire("hmR2n");

});
parcelRegister("hmR2n", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $e33dc31fe6df6483$export$2881499e37b75b9a; });
const $e33dc31fe6df6483$var$VERSION = '1.0';
class $e33dc31fe6df6483$export$2881499e37b75b9a {
    #namespaces;
    #initiated;
    #extendInternalActions;
    #store;
    #configs;
    constructor(id, namespaces, configs, options){
        this.version = $e33dc31fe6df6483$var$VERSION;
        this.#initiated = false;
        this.#extendInternalActions = {};
        this.id = id;
        this.#configs = configs;
        // it should be only created here, to make sure `after/before` will work properly.
        this.#extendInternalActions = options?.extendInternalActions || {};
        this.#namespaces = namespaces;
        /**
     * Our assumption is that the store will be optional for the provider.
     * If a store is provided in the options, it will be initialized and set up.
     */ if (options?.store) {
            this.#store = options.store;
            this.#setupStore();
        }
    }
    /**
   * This is an special callback that will be called **only once**.
   * We don't call this in `constructor` and developer should call this manually. we only ensure it will be called once.
   *
   * ```ts
   * const myInit = () => {  whatever; }   *
   * const provider = new Provider(..., {extendInternalActions: {init: myInit} });
   *
   * // Will run `myInit`
   * provider.init()
   *
   * // Will not run `myInit` anymore.
   * provider.init()
   * provider.init()
   * ```
   */ init(args) {
        if (this.#initiated) return;
        const definedInitByUser = this.#extendInternalActions.init;
        if (definedInitByUser) definedInitByUser(this.#context(), args);
        this.#initiated = true;
    }
    /**
   * Getting state of a provider
   *
   * **Note:**
   *    Each namespace has it's own state as well, in Legacy we didn't have this separation and all of them was accessible through Provider itself
   *    To be compatible with legacy, `getState` has a logic to guess the final state to produce same state as legacy.
   *
   * @example
   * ```ts
   * const provider = new Provider(...);
   * const [getState, setState] = provider.state();
   *
   * getState('installed');
   * // or
   * getState().installed;
   * ```
   *
   */ state() {
        const store = this.#store;
        if (!store) throw new Error(`Any store detected for ${this.id}. You need to set your store using '.store' method first.`);
        /**
     * State updater
     */ const setState = (name, value)=>{
            switch(name){
                case 'installed':
                    return store.getState().providers.updateStatus(this.id, name, value);
                default:
                    throw new Error(`Unhandled state update for provider. (provider id: ${this.id}, state name: ${name})`);
            }
        };
        /**
     * State getter
     */ const getState = (name)=>{
            const state = store.getState().providers.guessNamespacesState(this.id);
            if (!name) return state;
            switch(name){
                case 'installed':
                case 'connected':
                case 'connecting':
                    return state[name];
                default:
                    throw new Error('Unhandled state for provider');
            }
        };
        return [
            getState,
            setState
        ];
    }
    /**
   * For keeping state, we need a store. all the states will be write to/read from store.
   *
   * **Note: When you are setting an store for provider, it will be set for its namespaces automatically as well**
   *
   * @example
   * ```ts
   * const myStore = createStore();
   * const provider = new Provider(...);
   * provider.store(myStore); // or it can be passed to Provider constructor;
   * ```
   */ store(store) {
        if (this.#store) console.warn("You've already set an store for your Provider. Old store will be replaced by the new one.");
        this.#store = store;
        this.#setupStore();
        return this;
    }
    /**
   * Getting information about a provider which has been set on constructing Provider.
   *
   * @example
   * ```ts
   * const walletInfo = {name: "Garbage wallet", ...}
   * const provider = new Provider(..., {info: walletInfo});
   *
   * provider.info();
   * ```
   */ info() {
        const store = this.#store;
        if (!store) return this.#configs;
        const config = store.getState().providers.list[this.id].config;
        return {
            metadata: config.metadata
        };
    }
    /**
   * A list of registered _proxied_ namespaces.
   *
   * @example
   * ```ts
   *  const provider = new Provider(...);
   *  const allNamespaces = provider.getAll();
   * ```
   */ getAll() {
        return this.#namespaces;
    }
    /**
   * Get a registered namespace in provider by its **namespace key**.
   *
   * Note: difference between namespace key and namespace id is the first one is setting from a predefined list the second one can be anything and will be chosen by library's user.
   *
   * @param {string} id - evm, solana, cosmos, ... (CommonActions)
   */ get(id) {
        return this.#namespaces.get(id);
    }
    /**
   *
   * Get a registered namespace by its **namespaceId**.
   *
   * Note: difference between namespace key and namespace id is the first one is setting from a predefined list the second one can be anything and will be chosen by library's user.
   *
   * @example
   * ```ts
   * const provider = new Provider(...);
   * provider.findByNamespace("whatever-id-i-set-for-namespace")
   * ```
   */ findByNamespace(namespaceLookingFor) {
        // If we didn't found any match, we will return `undefined`.
        let result = undefined;
        this.#namespaces.forEach((namespace)=>{
            if (namespace.namespaceId === namespaceLookingFor) result = namespace;
        });
        return result;
    }
    /**
   * Running a hook function _after_ a specific action for **all registered namespaces**.
   *
   * **Note:** the context can be set from outside as well. this is useful for Provider to set its context instead of namespace context.
   *
   * @example
   * ```ts
   *  const provider = new Provider(...);
   *
   *  provider.after("connect", (context) => {});
   * ```
   */ before(actionName, hookFn) {
        this.#addHook('before', actionName, hookFn);
        return this;
    }
    /**
   * Running a hook function _before_ a specific action for **all registered namespaces**.
   *
   * **Note:** the context can be set from outside as well. this is useful for Provider to set its context instead of namespace context.
   *
   * @example
   * ```ts
   *  const provider = new Provider(...);
   *
   *  provider.after("connect", (context) => {});
   * ```
   */ after(actionName, hookFn) {
        this.#addHook('after', actionName, hookFn);
        return this;
    }
    #addHook(hookName, actionName, cb) {
        const context = {
            state: this.state.bind(this)
        };
        this.#namespaces.forEach((namespace)=>{
            if (hookName === 'after') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace.after(actionName, cb, {
                context: context
            });
            else if (hookName === 'before') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace.before(actionName, cb, {
                context: context
            });
            else throw new Error(`You hook name is invalid: ${hookName}`);
        });
        return this;
    }
    #setupStore() {
        const store = this.#store;
        if (!store) throw new Error('For setup store, you should set `store` first.');
        store.getState().providers.addProvider(this.id, this.#configs);
        this.#namespaces.forEach((provider)=>{
            provider.store(store);
        });
    }
    #context() {
        return {
            state: this.state.bind(this)
        };
    }
}

});


parcelRegister("hRmKL", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $4c5faa43eb6ae878$export$8c41bb232f1008b1; });
class $4c5faa43eb6ae878$export$8c41bb232f1008b1 {
    #providers;
    #options;
    constructor(options){
        this.#providers = new Map();
        this.#options = options ?? {};
    }
    init(args) {
        this.runAll('init', args);
    }
    /*
   * Running a specific action (e.g. init) on all namespaces and providers one by one.
   *
   *  TODO: Some of methods may accepts args, with this implementation we only limit to those one without any argument.
   */ runAll(action, args) {
        const output = [];
        // run action on all providers eagerConnect, disconnect
        const providers = this.#providers.values();
        for (const provider of providers){
            // Calling `action` on `Provider` if exists.
            const providerOutput = {
                id: provider.id,
                provider: undefined,
                namespaces: []
            };
            const providerMethod = provider[action];
            if (typeof providerMethod === 'function') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            providerOutput.provider = providerMethod.call(provider, args?.[provider.id]?.provider);
            // Namespace instances can have their own `action` as well. we will call them as well.
            const namespaces = provider.getAll().values();
            for (const namespace of namespaces){
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                const namespaceMethod = namespace[action];
                if (typeof namespaceMethod === 'function') {
                    const result = namespaceMethod(args?.[provider.id]?.namespaces?.[namespace.namespaceId]);
                    providerOutput.namespaces.push(result);
                }
            }
            output.push(providerOutput);
        }
        return output;
    }
    add(id, provider) {
        if (this.#options.store) provider.store(this.#options.store);
        this.#providers.set(id, provider);
        return this;
    }
    remove(id) {
        const providerToRemove = this.#providers.get(id);
        if (!providerToRemove) throw new Error(`Provider not found: No provider exists with ID "${id}"`);
        this.#options.store?.getState().providers.removeProvider(id);
        this.#providers.delete(id);
        return this;
    }
    get(providerId) {
        return this.#providers.get(providerId);
    }
    getAll() {
        return this.#providers;
    }
    state() {
        const output = this.runAll('state');
        const res = {};
        output.forEach((result)=>{
            const namespaces = [];
            result.namespaces.forEach((b)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const [getNamespaceState] = b;
                namespaces.push(getNamespaceState());
            });
            const [getProviderState] = result.provider;
            res[result.id] = {
                ...getProviderState() || {},
                namespaces: namespaces
            };
        });
        return res;
    }
}

});

parcelRegister("9Jqza", function(module, exports) {

$parcel$export(module.exports, "guessProviderStateSelector", function () { return (parcelRequire("7ioGd")).guessProviderStateSelector; });
$parcel$export(module.exports, "namespaceStateSelector", function () { return (parcelRequire("7ioGd")).namespaceStateSelector; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("e21ow")).createStore; });

var $7ioGd = parcelRequire("7ioGd");

var $e21ow = parcelRequire("e21ow");

});
parcelRegister("7ioGd", function(module, exports) {

$parcel$export(module.exports, "guessProviderStateSelector", function () { return $53d065d7d9269f46$export$a630946b982e1350; });
$parcel$export(module.exports, "namespaceStateSelector", function () { return $53d065d7d9269f46$export$7365d352ad16833a; });
/**
 * Note: Zustand has some difficulty when you are trying to `previous` state on `subscribe`.
 * If these selectors define inside store directly and use `get()` for accessing state, it will get the latest state
 * instead of previous state which desired.
 * So make them a helper will let us to reuse them both in store and outside of store in a `subscribe`.
 */ function $53d065d7d9269f46$export$a630946b982e1350(state, providerId) {
    /*
   * We keep namespaces in a separate branch than providers.
   * We should look at all of them and find all the namespaces that for our current proivder.
   */ const allNamespaces = state.namespaces.list;
    const currentProviderNamespaces = Object.keys(allNamespaces).filter((key)=>allNamespaces[key].info.providerId === providerId);
    // Returning provider state value directly.
    const installed = !!state.providers.list[providerId]?.data.installed;
    /*
   * If any namespaces returns `true`, we consider the whole provider for this field to be `true`.
   * it has a downside regarding errors which explained on top of the function.
   */ const connected = currentProviderNamespaces.length > 0 ? currentProviderNamespaces.some((key)=>allNamespaces[key].data.connected) : false;
    const connecting = currentProviderNamespaces.length > 0 ? currentProviderNamespaces.some((key)=>allNamespaces[key].data.connecting) : false;
    return {
        installed: installed,
        connected: connected,
        connecting: connecting
    };
}
function $53d065d7d9269f46$export$7365d352ad16833a(state, storeId) {
    return state.namespaces.list[storeId].data;
}

});

parcelRegister("e21ow", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $78528c8005605fa2$export$f51a9068ac82ea43; });

var $gj0MH = parcelRequire("gj0MH");

var $liChl = parcelRequire("liChl");

var $rAVjZ = parcelRequire("rAVjZ");

var $jip1W = parcelRequire("jip1W");

var $6uKzN = parcelRequire("6uKzN");
const $78528c8005605fa2$export$f51a9068ac82ea43 = ()=>{
    const store = (0, $gj0MH.createStore)((...api)=>{
        return {
            hub: (0, $rAVjZ.hubStore)(...api),
            providers: (0, $6uKzN.providersStore)(...api),
            namespaces: (0, $jip1W.namespacesStore)(...api)
        };
    });
    return (0, $liChl.extend)(store);
};

});
parcelRegister("gj0MH", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $4b3463fa0eb86489$export$f51a9068ac82ea43; });
var $4b3463fa0eb86489$import_meta = Object.assign(Object.create(null), {
    url: "file:///wallets/core/node_modules/zustand/esm/vanilla.mjs"
});
const $4b3463fa0eb86489$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($4b3463fa0eb86489$import_meta.env ? $4b3463fa0eb86489$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $4b3463fa0eb86489$export$f51a9068ac82ea43 = (createState)=>createState ? $4b3463fa0eb86489$var$createStoreImpl(createState) : $4b3463fa0eb86489$var$createStoreImpl;
var $4b3463fa0eb86489$export$2e2bcd8739ae039 = (createState)=>{
    if (($4b3463fa0eb86489$import_meta.env ? $4b3463fa0eb86489$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $4b3463fa0eb86489$export$f51a9068ac82ea43(createState);
};

});

parcelRegister("liChl", function(module, exports) {

$parcel$export(module.exports, "extend", function () { return $2076ab9837f44f1f$export$8b58be045bf06082; });

var $7ioGd = parcelRequire("7ioGd");
function $2076ab9837f44f1f$export$8b58be045bf06082(store) {
    const extendedSubscribe = (store)=>(listener)=>{
            const executeListener = (events, state, prevState)=>{
                for (const ev of events)listener(ev, state, prevState);
            };
            /*
       * only known changes will fire event for lib users
       * so all the changes in store won't trigger a user-face event
       */ store.subscribe((state, prevState)=>{
                const eventsLike = $2076ab9837f44f1f$var$getEventsLike(state, prevState);
                const events = $2076ab9837f44f1f$var$tryConsumeEvents(state);
                const allQueuedEvents = [
                    ...events,
                    ...eventsLike
                ];
                executeListener(allQueuedEvents, state, prevState);
            });
            return {
                /**
         * Manually run pending events.
         * This useful when use `subscribe` method after sometime and when store initialized.
         *
         * Note: Please consider both current and previous state will be same and we don't have access to previous state in a such scenario.
         */ flushEvents: ()=>{
                    const state = store.getState();
                    const events = $2076ab9837f44f1f$var$tryConsumeEvents(state);
                    executeListener(events, state, state);
                }
            };
        };
    return new Proxy(store, {
        get: function(target, prop, receiver) {
            if (prop === 'subscribe') return extendedSubscribe(target);
            return Reflect.get(target, prop, receiver);
        }
    });
}
/**
 * Retrieves the ConsumableEvent from the store and returns its values.
 * The values will be consumed by iterating over the field.
 */ function $2076ab9837f44f1f$var$tryConsumeEvents(state) {
    return [
        ...state.providers.events,
        ...state.namespaces.events
    ];
}
/**
 * In certain cases, adding events to the store is not possible (e.g., namespace or provider layer).
 * In these cases, we observe store changes and treat specific patterns as events when detected.
 *
 * Note: This approach should be avoided in most cases. It is used here to maintain backward compatibility
 * with the provider's legacy interface.
 */ function $2076ab9837f44f1f$var$getEventsLike(state, prevState) {
    const events = [];
    for (const providerId of Object.keys(state.providers.list)){
        const currentProviderState = (0, $7ioGd.guessProviderStateSelector)(state, providerId);
        const previousProviderState = (0, $7ioGd.guessProviderStateSelector)(prevState, providerId);
        if (previousProviderState.connecting !== currentProviderState.connecting) {
            const ev = {
                type: 'provider_connecting',
                provider: providerId,
                value: currentProviderState.connecting
            };
            events.push(ev);
        }
        if (!previousProviderState.connected && currentProviderState.connected) {
            const ev = {
                type: 'provider_connected',
                provider: providerId
            };
            events.push(ev);
        }
        if (previousProviderState.connected && !currentProviderState.connected) {
            const ev = {
                type: 'provider_disconnected',
                provider: providerId
            };
            events.push(ev);
        }
    }
    return events;
}

});

parcelRegister("rAVjZ", function(module, exports) {

$parcel$export(module.exports, "hubStore", function () { return $5a220e375d9450d9$export$5d3c93e8f10c87ca; });
/************ Hub ************/ const $5a220e375d9450d9$export$5d3c93e8f10c87ca = ()=>({
        config: {}
    });

});

parcelRegister("jip1W", function(module, exports) {

$parcel$export(module.exports, "namespacesStore", function () { return $0c62859522e25598$export$65a842e344249; });
/************ Namespace ************/ 
var $9YKpI = parcelRequire("9YKpI");

var $d1bRH = parcelRequire("d1bRH");
parcelRequire("9Jqza");
var $7ioGd = parcelRequire("7ioGd");
const $0c62859522e25598$export$65a842e344249 = (set, get)=>({
        events: new (0, $d1bRH.ConsumableEvents)(),
        list: {},
        addNamespace: (id, info)=>{
            const data = {
                accounts: null,
                network: null,
                connected: false,
                connecting: false,
                connectArgs: null
            };
            const item = {
                data: data,
                error: '',
                info: info
            };
            set((0, $9YKpI.produce)((state)=>{
                state.namespaces.list[id] = item;
            }));
        },
        updateStatus: (id, key, value)=>{
            const ns = get().namespaces.list[id];
            if (!ns) throw new Error(`No namespace with '${id}' found.`);
            get().namespaces._produceEventsWhenUpdatingStatus(ns, id, key, value);
            // Updating state
            set((0, $9YKpI.produce)((state)=>{
                state.namespaces.list[id].data[key] = value;
            }));
        },
        getNamespaceData (storeId) {
            return (0, $7ioGd.namespaceStateSelector)(get(), storeId);
        },
        _produceEventsWhenUpdatingStatus: (namespace, id, key, value)=>{
            if (key === 'accounts') {
                // check for both null and empty array
                const isAccountsEmpty = Object.is(value, null) || Array.isArray(value) && value.length === 0;
                if (isAccountsEmpty) {
                    const currentConnectedStatus = get().namespaces.list[id].data.connected;
                    if (currentConnectedStatus) {
                        const event = {
                            type: 'namespace_disconnected',
                            provider: namespace.info.providerId,
                            namespace: namespace.info.namespaceId
                        };
                        get().namespaces.events.push(event);
                    }
                // Skip emitting disconnect event, if the `connected` is false
                } else {
                    const currentAccounts = get().namespaces.list[id].data.accounts;
                    if (!currentAccounts) {
                        const event = {
                            type: 'namespace_connected',
                            provider: namespace.info.providerId,
                            namespace: namespace.info.namespaceId,
                            accounts: value
                        };
                        get().namespaces.events.push(event);
                    } else {
                        const areSameAccounts = // Clone the object from the Zustand store, as it's immutable, to avoid errors during sorting.
                        [
                            ...currentAccounts
                        ].sort().toString() === value.sort().toString();
                        if (!areSameAccounts) {
                            const event = {
                                type: 'namespace_account_switched',
                                provider: namespace.info.providerId,
                                namespace: namespace.info.namespaceId,
                                previousAccounts: currentAccounts,
                                accounts: value
                            };
                            get().namespaces.events.push(event);
                        }
                    }
                }
            } else if (key === 'network') {
                const currentNetwork = get().namespaces.list[id].data.network;
                const event = {
                    type: 'namespace_network_switched',
                    provider: namespace.info.providerId,
                    namespace: namespace.info.namespaceId,
                    network: value,
                    previousNetwork: currentNetwork
                };
                get().namespaces.events.push(event);
            }
        }
    });

});
parcelRegister("9YKpI", function(module, exports) {

$parcel$export(module.exports, "produce", function () { return $4fe0feaa500ab97c$export$b46cabe22e78bc00; });
// src/utils/env.ts
var $4fe0feaa500ab97c$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $4fe0feaa500ab97c$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $4fe0feaa500ab97c$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $4fe0feaa500ab97c$var$errors = [];
function $4fe0feaa500ab97c$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $4fe0feaa500ab97c$var$getPrototypeOf = Object.getPrototypeOf;
function $4fe0feaa500ab97c$export$541ac630993a4c84(value) {
    return !!value && !!value[$4fe0feaa500ab97c$var$DRAFT_STATE];
}
function $4fe0feaa500ab97c$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $4fe0feaa500ab97c$var$isPlainObject(value) || Array.isArray(value) || !!value[$4fe0feaa500ab97c$export$6ee2082928bcb0ee] || !!value.constructor?.[$4fe0feaa500ab97c$export$6ee2082928bcb0ee] || $4fe0feaa500ab97c$var$isMap(value) || $4fe0feaa500ab97c$var$isSet(value);
}
var $4fe0feaa500ab97c$var$objectCtorString = Object.prototype.constructor.toString();
function $4fe0feaa500ab97c$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $4fe0feaa500ab97c$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $4fe0feaa500ab97c$var$objectCtorString;
}
function $4fe0feaa500ab97c$export$22e8af3f75a010e3(value) {
    if (!$4fe0feaa500ab97c$export$541ac630993a4c84(value)) $4fe0feaa500ab97c$var$die(15, value);
    return value[$4fe0feaa500ab97c$var$DRAFT_STATE].base_;
}
function $4fe0feaa500ab97c$var$each(obj, iter) {
    if ($4fe0feaa500ab97c$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $4fe0feaa500ab97c$var$getArchtype(thing) {
    const state = thing[$4fe0feaa500ab97c$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $4fe0feaa500ab97c$var$isMap(thing) ? 2 /* Map */  : $4fe0feaa500ab97c$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $4fe0feaa500ab97c$var$has(thing, prop) {
    return $4fe0feaa500ab97c$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $4fe0feaa500ab97c$var$get(thing, prop) {
    return $4fe0feaa500ab97c$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $4fe0feaa500ab97c$var$set(thing, propOrOldValue, value) {
    const t = $4fe0feaa500ab97c$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $4fe0feaa500ab97c$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $4fe0feaa500ab97c$var$isMap(target) {
    return target instanceof Map;
}
function $4fe0feaa500ab97c$var$isSet(target) {
    return target instanceof Set;
}
function $4fe0feaa500ab97c$var$latest(state) {
    return state.copy_ || state.base_;
}
function $4fe0feaa500ab97c$var$shallowCopy(base, strict) {
    if ($4fe0feaa500ab97c$var$isMap(base)) return new Map(base);
    if ($4fe0feaa500ab97c$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $4fe0feaa500ab97c$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$4fe0feaa500ab97c$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($4fe0feaa500ab97c$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $4fe0feaa500ab97c$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $4fe0feaa500ab97c$export$792f3d81ea979f55(obj, deep = false) {
    if ($4fe0feaa500ab97c$var$isFrozen(obj) || $4fe0feaa500ab97c$export$541ac630993a4c84(obj) || !$4fe0feaa500ab97c$export$16e3aed3edb85946(obj)) return obj;
    if ($4fe0feaa500ab97c$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $4fe0feaa500ab97c$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$4fe0feaa500ab97c$export$792f3d81ea979f55(value, true));
    return obj;
}
function $4fe0feaa500ab97c$var$dontMutateFrozenCollections() {
    $4fe0feaa500ab97c$var$die(2);
}
function $4fe0feaa500ab97c$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $4fe0feaa500ab97c$var$plugins = {};
function $4fe0feaa500ab97c$var$getPlugin(pluginKey) {
    const plugin = $4fe0feaa500ab97c$var$plugins[pluginKey];
    if (!plugin) $4fe0feaa500ab97c$var$die(0, pluginKey);
    return plugin;
}
function $4fe0feaa500ab97c$var$loadPlugin(pluginKey, implementation) {
    if (!$4fe0feaa500ab97c$var$plugins[pluginKey]) $4fe0feaa500ab97c$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $4fe0feaa500ab97c$var$currentScope;
function $4fe0feaa500ab97c$var$getCurrentScope() {
    return $4fe0feaa500ab97c$var$currentScope;
}
function $4fe0feaa500ab97c$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $4fe0feaa500ab97c$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $4fe0feaa500ab97c$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $4fe0feaa500ab97c$var$revokeScope(scope) {
    $4fe0feaa500ab97c$var$leaveScope(scope);
    scope.drafts_.forEach($4fe0feaa500ab97c$var$revokeDraft);
    scope.drafts_ = null;
}
function $4fe0feaa500ab97c$var$leaveScope(scope) {
    if (scope === $4fe0feaa500ab97c$var$currentScope) $4fe0feaa500ab97c$var$currentScope = scope.parent_;
}
function $4fe0feaa500ab97c$var$enterScope(immer2) {
    return $4fe0feaa500ab97c$var$currentScope = $4fe0feaa500ab97c$var$createScope($4fe0feaa500ab97c$var$currentScope, immer2);
}
function $4fe0feaa500ab97c$var$revokeDraft(draft) {
    const state = draft[$4fe0feaa500ab97c$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $4fe0feaa500ab97c$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$4fe0feaa500ab97c$var$DRAFT_STATE].modified_) {
            $4fe0feaa500ab97c$var$revokeScope(scope);
            $4fe0feaa500ab97c$var$die(4);
        }
        if ($4fe0feaa500ab97c$export$16e3aed3edb85946(result)) {
            result = $4fe0feaa500ab97c$var$finalize(scope, result);
            if (!scope.parent_) $4fe0feaa500ab97c$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $4fe0feaa500ab97c$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$4fe0feaa500ab97c$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $4fe0feaa500ab97c$var$finalize(scope, baseDraft, []);
    $4fe0feaa500ab97c$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $4fe0feaa500ab97c$export$45b790e32b2810ee ? result : void 0;
}
function $4fe0feaa500ab97c$var$finalize(rootScope, value, path) {
    if ($4fe0feaa500ab97c$var$isFrozen(value)) return value;
    const state = value[$4fe0feaa500ab97c$var$DRAFT_STATE];
    if (!state) {
        $4fe0feaa500ab97c$var$each(value, (key, childValue)=>$4fe0feaa500ab97c$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $4fe0feaa500ab97c$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $4fe0feaa500ab97c$var$each(resultEach, (key, childValue)=>$4fe0feaa500ab97c$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $4fe0feaa500ab97c$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $4fe0feaa500ab97c$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $4fe0feaa500ab97c$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($4fe0feaa500ab97c$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$4fe0feaa500ab97c$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $4fe0feaa500ab97c$var$finalize(rootScope, childValue, path);
        $4fe0feaa500ab97c$var$set(targetObject, prop, res);
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($4fe0feaa500ab97c$export$16e3aed3edb85946(childValue) && !$4fe0feaa500ab97c$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $4fe0feaa500ab97c$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $4fe0feaa500ab97c$var$maybeFreeze(rootScope, childValue);
    }
}
function $4fe0feaa500ab97c$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $4fe0feaa500ab97c$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $4fe0feaa500ab97c$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $4fe0feaa500ab97c$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $4fe0feaa500ab97c$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $4fe0feaa500ab97c$var$objectTraps = {
    get (state, prop) {
        if (prop === $4fe0feaa500ab97c$var$DRAFT_STATE) return state;
        const source = $4fe0feaa500ab97c$var$latest(state);
        if (!$4fe0feaa500ab97c$var$has(source, prop)) return $4fe0feaa500ab97c$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$4fe0feaa500ab97c$export$16e3aed3edb85946(value)) return value;
        if (value === $4fe0feaa500ab97c$var$peek(state.base_, prop)) {
            $4fe0feaa500ab97c$var$prepareCopy(state);
            return state.copy_[prop] = $4fe0feaa500ab97c$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $4fe0feaa500ab97c$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($4fe0feaa500ab97c$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $4fe0feaa500ab97c$var$getDescriptorFromProto($4fe0feaa500ab97c$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $4fe0feaa500ab97c$var$peek($4fe0feaa500ab97c$var$latest(state), prop);
            const currentState = current2?.[$4fe0feaa500ab97c$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($4fe0feaa500ab97c$var$is(value, current2) && (value !== void 0 || $4fe0feaa500ab97c$var$has(state.base_, prop))) return true;
            $4fe0feaa500ab97c$var$prepareCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($4fe0feaa500ab97c$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $4fe0feaa500ab97c$var$prepareCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $4fe0feaa500ab97c$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $4fe0feaa500ab97c$var$die(11);
    },
    getPrototypeOf (state) {
        return $4fe0feaa500ab97c$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $4fe0feaa500ab97c$var$die(12);
    }
};
var $4fe0feaa500ab97c$var$arrayTraps = {};
$4fe0feaa500ab97c$var$each($4fe0feaa500ab97c$var$objectTraps, (key, fn)=>{
    $4fe0feaa500ab97c$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$4fe0feaa500ab97c$var$arrayTraps.deleteProperty = function(state, prop) {
    return $4fe0feaa500ab97c$var$arrayTraps.set.call(this, state, prop, void 0);
};
$4fe0feaa500ab97c$var$arrayTraps.set = function(state, prop, value) {
    return $4fe0feaa500ab97c$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $4fe0feaa500ab97c$var$peek(draft, prop) {
    const state = draft[$4fe0feaa500ab97c$var$DRAFT_STATE];
    const source = state ? $4fe0feaa500ab97c$var$latest(state) : draft;
    return source[prop];
}
function $4fe0feaa500ab97c$var$readPropFromProto(state, source, prop) {
    const desc = $4fe0feaa500ab97c$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $4fe0feaa500ab97c$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $4fe0feaa500ab97c$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $4fe0feaa500ab97c$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $4fe0feaa500ab97c$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $4fe0feaa500ab97c$var$markChanged(state.parent_);
    }
}
function $4fe0feaa500ab97c$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $4fe0feaa500ab97c$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $4fe0feaa500ab97c$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $4fe0feaa500ab97c$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $4fe0feaa500ab97c$var$die(7);
            let result;
            if ($4fe0feaa500ab97c$export$16e3aed3edb85946(base)) {
                const scope = $4fe0feaa500ab97c$var$enterScope(this);
                const proxy = $4fe0feaa500ab97c$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $4fe0feaa500ab97c$var$revokeScope(scope);
                    else $4fe0feaa500ab97c$var$leaveScope(scope);
                }
                $4fe0feaa500ab97c$var$usePatchesInScope(scope, patchListener);
                return $4fe0feaa500ab97c$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $4fe0feaa500ab97c$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $4fe0feaa500ab97c$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $4fe0feaa500ab97c$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $4fe0feaa500ab97c$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof config?.autoFreeze === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof config?.useStrictShallowCopy === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$4fe0feaa500ab97c$export$16e3aed3edb85946(base)) $4fe0feaa500ab97c$var$die(8);
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(base)) base = $4fe0feaa500ab97c$export$97aac956da55dae9(base);
        const scope = $4fe0feaa500ab97c$var$enterScope(this);
        const proxy = $4fe0feaa500ab97c$var$createProxy(base, void 0);
        proxy[$4fe0feaa500ab97c$var$DRAFT_STATE].isManual_ = true;
        $4fe0feaa500ab97c$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$4fe0feaa500ab97c$var$DRAFT_STATE];
        if (!state || !state.isManual_) $4fe0feaa500ab97c$var$die(9);
        const { scope_: scope } = state;
        $4fe0feaa500ab97c$var$usePatchesInScope(scope, patchListener);
        return $4fe0feaa500ab97c$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $4fe0feaa500ab97c$var$getPlugin("Patches").applyPatches_;
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $4fe0feaa500ab97c$var$createProxy(value, parent) {
    const draft = $4fe0feaa500ab97c$var$isMap(value) ? $4fe0feaa500ab97c$var$getPlugin("MapSet").proxyMap_(value, parent) : $4fe0feaa500ab97c$var$isSet(value) ? $4fe0feaa500ab97c$var$getPlugin("MapSet").proxySet_(value, parent) : $4fe0feaa500ab97c$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $4fe0feaa500ab97c$export$97aac956da55dae9(value) {
    if (!$4fe0feaa500ab97c$export$541ac630993a4c84(value)) $4fe0feaa500ab97c$var$die(10, value);
    return $4fe0feaa500ab97c$var$currentImpl(value);
}
function $4fe0feaa500ab97c$var$currentImpl(value) {
    if (!$4fe0feaa500ab97c$export$16e3aed3edb85946(value) || $4fe0feaa500ab97c$var$isFrozen(value)) return value;
    const state = value[$4fe0feaa500ab97c$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $4fe0feaa500ab97c$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $4fe0feaa500ab97c$var$shallowCopy(value, true);
    $4fe0feaa500ab97c$var$each(copy, (key, childValue)=>{
        $4fe0feaa500ab97c$var$set(copy, key, $4fe0feaa500ab97c$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $4fe0feaa500ab97c$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $4fe0feaa500ab97c$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $4fe0feaa500ab97c$var$get(base_, key);
            const value = $4fe0feaa500ab97c$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $4fe0feaa500ab97c$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $4fe0feaa500ab97c$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $4fe0feaa500ab97c$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $4fe0feaa500ab97c$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $4fe0feaa500ab97c$var$die(errorOffset + 3);
                base = $4fe0feaa500ab97c$var$get(base, p);
                if (typeof base !== "object") $4fe0feaa500ab97c$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $4fe0feaa500ab97c$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $4fe0feaa500ab97c$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $4fe0feaa500ab97c$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$4fe0feaa500ab97c$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($4fe0feaa500ab97c$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($4fe0feaa500ab97c$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($4fe0feaa500ab97c$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($4fe0feaa500ab97c$var$has(obj, $4fe0feaa500ab97c$export$6ee2082928bcb0ee)) cloned[$4fe0feaa500ab97c$export$6ee2082928bcb0ee] = obj[$4fe0feaa500ab97c$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $4fe0feaa500ab97c$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $4fe0feaa500ab97c$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$4fe0feaa500ab97c$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$4fe0feaa500ab97c$var$latest(state).has(key) || $4fe0feaa500ab97c$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($4fe0feaa500ab97c$var$latest(state).size) {
                prepareMapCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $4fe0feaa500ab97c$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            $4fe0feaa500ab97c$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $4fe0feaa500ab97c$var$latest(state).get(key);
            if (state.finalized_ || !$4fe0feaa500ab97c$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $4fe0feaa500ab97c$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($4fe0feaa500ab97c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$4fe0feaa500ab97c$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($4fe0feaa500ab97c$var$latest(state).size) {
                prepareSetCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($4fe0feaa500ab97c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($4fe0feaa500ab97c$export$16e3aed3edb85946(value)) {
                    const draft = $4fe0feaa500ab97c$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $4fe0feaa500ab97c$var$die(3, JSON.stringify($4fe0feaa500ab97c$var$latest(state)));
    }
    $4fe0feaa500ab97c$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $4fe0feaa500ab97c$var$immer = new $4fe0feaa500ab97c$export$aaadc6ff0f822719();
var $4fe0feaa500ab97c$export$b46cabe22e78bc00 = $4fe0feaa500ab97c$var$immer.produce;
var $4fe0feaa500ab97c$export$4da66d41c9492c78 = $4fe0feaa500ab97c$var$immer.produceWithPatches.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$573f26f60825c493 = $4fe0feaa500ab97c$var$immer.setAutoFreeze.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$333ce65961cbe047 = $4fe0feaa500ab97c$var$immer.setUseStrictShallowCopy.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$a8b8e03e6bbe5473 = $4fe0feaa500ab97c$var$immer.applyPatches.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$3c3214997190395f = $4fe0feaa500ab97c$var$immer.createDraft.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$c60f5e69c521b528 = $4fe0feaa500ab97c$var$immer.finishDraft.bind($4fe0feaa500ab97c$var$immer);
function $4fe0feaa500ab97c$export$c05b21e3257751e5(value) {
    return value;
}
function $4fe0feaa500ab97c$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("d1bRH", function(module, exports) {

$parcel$export(module.exports, "ConsumableEvents", function () { return $798cdb0cb41ad382$export$e10639700aa3dc36; });
class $798cdb0cb41ad382$export$e10639700aa3dc36 {
    #data;
    push(val) {
        this.#data.push(val);
    }
    [Symbol.iterator]() {
        return {
            next: ()=>{
                if (this.#data.length == 0) return {
                    done: true,
                    value: undefined
                };
                // Typescript can not narrow the type, but we have a runtime check to ensure it will never be an empty list
                const value = this.#data.shift();
                return {
                    done: false,
                    value: value
                };
            }
        };
    }
    constructor(){
        this.#data = [];
    }
}

});


parcelRegister("6uKzN", function(module, exports) {

$parcel$export(module.exports, "providersStore", function () { return $b3439fc9fc95dcae$export$a34c3a828c363d86; });

var $9YKpI = parcelRequire("9YKpI");

var $d1bRH = parcelRequire("d1bRH");
parcelRequire("9Jqza");
var $7ioGd = parcelRequire("7ioGd");
const $b3439fc9fc95dcae$export$a34c3a828c363d86 = (set, get)=>({
        events: new (0, $d1bRH.ConsumableEvents)(),
        list: {},
        addProvider: (id, config)=>{
            const item = {
                data: {
                    installed: false
                },
                error: '',
                config: config
            };
            set((0, $9YKpI.produce)((state)=>{
                state.providers.list[id] = item;
            }));
        },
        removeProvider: (id)=>{
            set((0, $9YKpI.produce)((state)=>{
                delete state.providers.list[id];
            }));
        },
        updateStatus: (id, key, value)=>{
            const provider = get().providers.list[id];
            if (!provider) throw new Error(`No namespace namespace with '${id}' found.`);
            get().providers._produceEventsWhenUpdatingStatus(provider, id, key, value);
            set((0, $9YKpI.produce)((state)=>{
                state.providers.list[id].data[key] = value;
            }));
        },
        guessNamespacesState: (providerId)=>{
            return (0, $7ioGd.guessProviderStateSelector)(get(), providerId);
        },
        _produceEventsWhenUpdatingStatus: (_provider, id, key, _value)=>{
            if (key === 'installed') {
                const event = {
                    type: 'provider_detected',
                    provider: id
                };
                get().providers.events.push(event);
            }
        }
    });

});




parcelRegister("fXICR", function(module, exports) {

$parcel$export(module.exports, "NamespaceBuilder", function () { return (parcelRequire("at2GJ")).NamespaceBuilder; });
$parcel$export(module.exports, "ProviderBuilder", function () { return (parcelRequire("fFglI")).ProviderBuilder; });
$parcel$export(module.exports, "ActionBuilder", function () { return (parcelRequire("fha7R")).ActionBuilder; });

var $at2GJ = parcelRequire("at2GJ");

var $fFglI = parcelRequire("fFglI");

var $fha7R = parcelRequire("fha7R");

});
parcelRegister("at2GJ", function(module, exports) {

$parcel$export(module.exports, "NamespaceBuilder", function () { return $f11445e8f6008be3$export$7604a8e63ce34423; });
parcelRequire("eb86r");
var $h89vi = parcelRequire("h89vi");
const $f11445e8f6008be3$export$eb5342c0071f2e04 = [
    'init',
    'state',
    'after',
    'before',
    'and_then',
    'or_else',
    'store'
];
/**
 * List of value types that are considered safe to return directly when
 * accessing properties on a proxied `Namespace`.
 *
 * This is useful for allowing public values like `version` to be accessed.
 * If a property's value is of one of these types (e.g.,`'string'`, `'number'`),
 * it will be returned as-is.
 *
 * @const {Array<'string' | 'number'>} allowedPublicValues
 */ const $f11445e8f6008be3$var$allowedPublicValues = [
    'string',
    'number'
];
class $f11445e8f6008be3$export$7604a8e63ce34423 {
    #id;
    #providerId;
    #actions;
    /*
   * We keep a list of `ActionBuilder` outputs here to use them in separate phases.
   * Actually, `ActionBuilder` is packing action and its hooks in one place, here we should expand them and them in appropriate places.
   * Eventually, action will be added to `#actions` and its hooks will be added to `Namespace`.
   */ #actionBuilders;
    #configs;
    constructor(id, providerId){
        this.#actions = new Map();
        this.#actionBuilders = [];
        this.#id = id;
        this.#providerId = providerId;
        this.#configs = {};
    }
    /** There are some predefined configs that can be set for each namespace separately */ config(name, value) {
        this.#configs[name] = value;
        return this;
    }
    /**
   *
   * Actions are piece of functionality that a namespace can have, for example it can be a `connect` function
   * or a sign function or even a function for updating namespace's internal state. Actions are flexible and can be anything.
   *
   * Generally, each standard namespace (e.g. evm) has an standard interface defined in `src/namespaces/`
   * and provider (which includes namespaces) authors will implement those actions.
   *
   * You can call this function by a list of actions or a single action.
   *
   */ action(action, actionFn) {
        // List mode
        if (Array.isArray(action)) {
            action.forEach(([name, actionFnForItem])=>{
                this.#actions.set(name, actionFnForItem);
            });
            return this;
        }
        // Action builder mode
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof action === 'object' && !!action?.actionName) {
            this.#actionBuilders.push(action);
            return this;
        }
        // Single action mode
        if (!!actionFn) this.#actions.set(action, actionFn);
        return this;
    }
    /**
   * By calling build, an instance of Namespace will be built.
   *
   * Note: it's not exactly a `Namespace`, it returns a Proxy which add more convenient use like `namespace.connect()` instead of `namespace.run("connect")`
   */ build() {
        if (this.#isConfigsValid(this.#configs)) return this.#buildApi(this.#configs);
        throw new Error(`You namespace config isn't valid.`);
    }
    // Currently, namespace doesn't has any config.
    #isConfigsValid(_config) {
        return true;
    }
    /*
   * Extracting hooks and add them to `Namespace` for the action.
   *
   * Note: this should be called after `addActionsFromActionBuilders` to ensure the action is added first.
   */ #addHooksFromActionBuilders(namespace) {
        this.#actionBuilders.forEach((actionByBuild)=>{
            actionByBuild.after.forEach((afterHooks)=>{
                afterHooks.map((action)=>{
                    namespace.after(actionByBuild.actionName, action);
                });
            });
            actionByBuild.before.forEach((beforeHooks)=>{
                beforeHooks.map((action)=>{
                    namespace.before(actionByBuild.actionName, action);
                });
            });
            actionByBuild.and.forEach((andHooks)=>{
                andHooks.map((action)=>{
                    namespace.and_then(actionByBuild.actionName, action);
                });
            });
            actionByBuild.or.forEach((orHooks)=>{
                orHooks.map((action)=>{
                    namespace.or_else(actionByBuild.actionName, action);
                });
            });
        });
    }
    /**
   * Iterate over `actionBuilders` and add them to exists `actions`.
   * Note: Hooks will be added in a separate phase.
   */ #addActionsFromActionBuilders() {
        this.#actionBuilders.forEach((actionByBuild)=>{
            this.#actions.set(actionByBuild.actionName, actionByBuild.action);
        });
    }
    /**
   * Build a Proxy object to call actions in a more convenient way. e.g `.connect()` instead of `.run(connect)`
   */ #buildApi(configs) {
        this.#addActionsFromActionBuilders();
        const namespace = new (0, $h89vi.Namespace)(this.#id, this.#providerId, {
            configs: configs,
            actions: this.#actions
        });
        this.#addHooksFromActionBuilders(namespace);
        const api = new Proxy(namespace, {
            has: (_, property)=>{
                if (typeof property !== 'string') throw new Error('You can use string as your property on Namespace instance.');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                if ($f11445e8f6008be3$export$eb5342c0071f2e04.includes(property)) return true;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                if ($f11445e8f6008be3$var$allowedPublicValues.includes(typeof namespace[property])) return true;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                return namespace.has(property);
            },
            get: (_, property)=>{
                if (typeof property !== 'string') throw new Error('You can use string as your property on Namespace instance.');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                const targetValue = namespace[property];
                if ($f11445e8f6008be3$export$eb5342c0071f2e04.includes(property)) return targetValue.bind(namespace);
                /*
         * This is useful accessing values like `version`, If we don't do this, we should whitelist
         * All the values as well, So it can be confusing for someone that only wants to add a public value to `Namespace`
         */ if ($f11445e8f6008be3$var$allowedPublicValues.includes(typeof targetValue)) return targetValue;
                return namespace.run.bind(namespace, property);
            },
            set: ()=>{
                throw new Error('You can not set anything on this object.');
            }
        });
        return api;
    }
}

});

parcelRegister("fFglI", function(module, exports) {

$parcel$export(module.exports, "ProviderBuilder", function () { return $be65fe34731f4242$export$1f80a02347eafbe4; });
parcelRequire("IkSJw");
var $hmR2n = parcelRequire("hmR2n");
class $be65fe34731f4242$export$1f80a02347eafbe4 {
    #id;
    #namespaces;
    #methods;
    #configs;
    #options;
    constructor(id, options){
        this.#namespaces = new Map();
        this.#methods = {};
        this.#configs = {};
        this.#id = id;
        this.#options = options || {};
    }
    add(id, namespace) {
        if (this.#options.store) namespace.store(this.#options.store);
        this.#namespaces.set(id, namespace);
        return this;
    }
    config(name, value) {
        this.#configs[name] = value;
        return this;
    }
    init(cb) {
        this.#methods.init = cb;
        return this;
    }
    build() {
        if (this.#isConfigsValid(this.#configs)) return new (0, $hmR2n.Provider)(this.#id, this.#namespaces, this.#configs, {
            extendInternalActions: this.#methods,
            store: this.#options.store
        });
        throw new Error('You need to set all required configs.');
    }
    #isConfigsValid(config) {
        return !!config.metadata;
    }
}

});

parcelRegister("fha7R", function(module, exports) {

$parcel$export(module.exports, "ActionBuilder", function () { return $504bf65fa83c29ff$export$88e10164fb7d79bf; });
class $504bf65fa83c29ff$export$88e10164fb7d79bf {
    #and;
    #or;
    #after;
    #before;
    #action;
    constructor(name){
        this.#and = new Map();
        this.#or = new Map();
        this.#after = new Map();
        this.#before = new Map();
        this.name = name;
    }
    and(action) {
        if (!this.#and.has(this.name)) this.#and.set(this.name, []);
        this.#and.get(this.name)?.push(action);
        return this;
    }
    or(action) {
        if (!this.#or.has(this.name)) this.#or.set(this.name, []);
        this.#or.get(this.name)?.push(action);
        return this;
    }
    before(action) {
        if (!this.#before.has(this.name)) this.#before.set(this.name, []);
        this.#before.get(this.name)?.push(action);
        return this;
    }
    after(action) {
        if (!this.#after.has(this.name)) this.#after.set(this.name, []);
        this.#after.get(this.name)?.push(action);
        return this;
    }
    action(action) {
        this.#action = action;
        return this;
    }
    build() {
        if (!this.#action) throw new Error('Your action builder should includes an action.');
        return {
            actionName: this.name,
            action: this.#action,
            before: this.#before,
            after: this.#after,
            and: this.#and,
            or: this.#or
        };
    }
}

});


parcelRegister("gYI4Q", function(module, exports) {
/*
 * It is not a good idea to re-export all of CAIP because if they have a breaking change, we will break as well.
 * It would be better to create an abstraction over them and export our own interface to ensure it is under our control.
 */ 
var $3ca9q = parcelRequire("3ca9q");

var $dfA3S = parcelRequire("dfA3S");
parcelRequire("2974Y");

});
parcelRegister("2974Y", function(module, exports) {
function $879dc4f6a64855c5$export$e07c34986d13152a(list, targetVersion) {
    if (!targetVersion) throw new Error(`You should provide a valid semver, e.g 1.0.0.`);
    const target = list.find(([version])=>version === targetVersion);
    if (!target) throw new Error(`You target version hasn't been found. Available versions: ${Object.keys(list).join(', ')}`);
    return target;
}
function $879dc4f6a64855c5$export$37be72d69eff8ef3() {
    const versions = [];
    const api = {
        version: (semver, value)=>{
            versions.push([
                semver,
                value
            ]);
            return api;
        },
        build: ()=>{
            return versions;
        }
    };
    return api;
}
function $879dc4f6a64855c5$export$3ce31bfaa5288b9a(provider) {
    return $879dc4f6a64855c5$export$37be72d69eff8ef3().version('0.0.0', provider).build();
}

});



parcelRegister("6Mj8D", function(module, exports) {

$parcel$export(module.exports, "builders", function () { return $4ef612392755fa02$export$aea8daed5328d69c; });
$parcel$export(module.exports, "utils", function () { return $4ef612392755fa02$export$eab97d15b1788b8d; });

var $4lvIP = parcelRequire("4lvIP");



var $3ca9q = parcelRequire("3ca9q");
var $4ef612392755fa02$var$h = Object.defineProperty;
var $4ef612392755fa02$var$e = (r, t)=>$4ef612392755fa02$var$h(r, "name", {
        value: t,
        configurable: !0
    });
var $4ef612392755fa02$var$l = (r, t)=>{
    for(var n in t)$4ef612392755fa02$var$h(r, n, {
        get: t[n],
        enumerable: !0
    });
};
var $4ef612392755fa02$export$aea8daed5328d69c = {};
$4ef612392755fa02$var$l($4ef612392755fa02$export$aea8daed5328d69c, {
    balanceLines: ()=>$4ef612392755fa02$var$_,
    connect: ()=>$4ef612392755fa02$var$R
});
var $4ef612392755fa02$var$o = class {
    static{
        $4ef612392755fa02$var$e(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #r = new Map;
    #o = new Map;
    #n;
    constructor(t){
        this.name = t;
    }
    and(t) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(t), this;
    }
    or(t) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(t), this;
    }
    before(t) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(t), this;
    }
    after(t) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(t), this;
    }
    action(t) {
        return this.#n = t, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#o,
            after: this.#r,
            and: this.#e,
            or: this.#t
        };
    }
};
function $4ef612392755fa02$var$p(r) {
    let [, t] = r.state();
    t("connecting", !1);
}
$4ef612392755fa02$var$e($4ef612392755fa02$var$p, "intoConnectionFinished");
function $4ef612392755fa02$var$S(r) {
    try {
        return (0, $3ca9q.AccountId).parse(r), !0;
    } catch  {
        return !1;
    }
}
$4ef612392755fa02$var$e($4ef612392755fa02$var$S, "isValidCaipAddress");
function $4ef612392755fa02$var$d(r, t) {
    if (!t.every($4ef612392755fa02$var$S)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${t}`);
    let [, n] = r.state();
    return n("accounts", t), n("connected", !0), t;
}
$4ef612392755fa02$var$e($4ef612392755fa02$var$d, "connectAndUpdateStateForSingleNetwork");
function $4ef612392755fa02$var$u(r) {
    let [, t] = r.state();
    t("connecting", !0);
}
$4ef612392755fa02$var$e($4ef612392755fa02$var$u, "intoConnecting");
var $4ef612392755fa02$export$c67e5a7ce034264a = "stellar", $4ef612392755fa02$export$5ec861ba75b1b43 = "mainnet", $4ef612392755fa02$var$g = "https://horizon.stellar.org";
var $4ef612392755fa02$var$R = $4ef612392755fa02$var$e(()=>new $4ef612392755fa02$var$o("connect").and($4ef612392755fa02$var$d).before($4ef612392755fa02$var$u).after($4ef612392755fa02$var$p), "connect"), $4ef612392755fa02$var$_ = new $4ef612392755fa02$var$o("balanceLines").action(async function(r, t) {
    return (await new $4lvIP.Horizon.Server($4ef612392755fa02$var$g).loadAccount(t)).balances;
});
var $4ef612392755fa02$export$eab97d15b1788b8d = {};
$4ef612392755fa02$var$l($4ef612392755fa02$export$eab97d15b1788b8d, {
    formatAddressToCAIP: ()=>$4ef612392755fa02$var$K
});
function $4ef612392755fa02$var$K(r) {
    return (0, $3ca9q.AccountId).format({
        address: r,
        chainId: {
            namespace: $4ef612392755fa02$export$c67e5a7ce034264a,
            reference: $4ef612392755fa02$export$5ec861ba75b1b43
        }
    });
}
$4ef612392755fa02$var$e($4ef612392755fa02$var$K, "formatAddressToCAIP");

});
parcelRegister("4lvIP", function(module, exports) {
/*! For license information please see stellar-sdk.min.js.LICENSE.txt */ 
var $4TNnu = parcelRequire("4TNnu");
!function(e, t) {
    module.exports = t();
}(self, ()=>(()=>{
        var e = {
            8950 (e) {
                var t;
                self, t = ()=>(()=>{
                        var e = {
                            41 (e, t, r) {
                                "use strict";
                                var n = r(655), o = r(8068), i = r(9675), a = r(5795);
                                e.exports = function(e, t, r) {
                                    if (!e || "object" != typeof e && "function" != typeof e) throw new i("`obj` must be an object or a function`");
                                    if ("string" != typeof t && "symbol" != typeof t) throw new i("`property` must be a string or a symbol`");
                                    if (arguments.length > 3 && "boolean" != typeof arguments[3] && null !== arguments[3]) throw new i("`nonEnumerable`, if provided, must be a boolean or null");
                                    if (arguments.length > 4 && "boolean" != typeof arguments[4] && null !== arguments[4]) throw new i("`nonWritable`, if provided, must be a boolean or null");
                                    if (arguments.length > 5 && "boolean" != typeof arguments[5] && null !== arguments[5]) throw new i("`nonConfigurable`, if provided, must be a boolean or null");
                                    if (arguments.length > 6 && "boolean" != typeof arguments[6]) throw new i("`loose`, if provided, must be a boolean");
                                    var s = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, l = arguments.length > 6 && arguments[6], f = !!a && a(e, t);
                                    if (n) n(e, t, {
                                        configurable: null === c && f ? f.configurable : !c,
                                        enumerable: null === s && f ? f.enumerable : !s,
                                        value: r,
                                        writable: null === u && f ? f.writable : !u
                                    });
                                    else {
                                        if (!l && (s || u || c)) throw new o("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
                                        e[t] = r;
                                    }
                                };
                            },
                            76 (e) {
                                "use strict";
                                e.exports = Function.prototype.call;
                            },
                            251 (e, t) {
                                t.read = function(e, t, r, n, o) {
                                    var i, a, s = 8 * o - n - 1, u = (1 << s) - 1, c = u >> 1, l = -7, f = r ? o - 1 : 0, p = r ? -1 : 1, d = e[t + f];
                                    for(f += p, i = d & (1 << -l) - 1, d >>= -l, l += s; l > 0; i = 256 * i + e[t + f], f += p, l -= 8);
                                    for(a = i & (1 << -l) - 1, i >>= -l, l += n; l > 0; a = 256 * a + e[t + f], f += p, l -= 8);
                                    if (0 === i) i = 1 - c;
                                    else {
                                        if (i === u) return a ? NaN : 1 / 0 * (d ? -1 : 1);
                                        a += Math.pow(2, n), i -= c;
                                    }
                                    return (d ? -1 : 1) * a * Math.pow(2, i - n);
                                }, t.write = function(e, t, r, n, o, i) {
                                    var a, s, u, c = 8 * i - o - 1, l = (1 << c) - 1, f = l >> 1, p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : i - 1, h = n ? 1 : -1, y = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + f >= 1 ? p / u : p * Math.pow(2, 1 - f)) * u >= 2 && (a++, u /= 2), a + f >= l ? (s = 0, a = l) : a + f >= 1 ? (s = (t * u - 1) * Math.pow(2, o), a += f) : (s = t * Math.pow(2, f - 1) * Math.pow(2, o), a = 0)); o >= 8; e[r + d] = 255 & s, d += h, s /= 256, o -= 8);
                                    for(a = a << o | s, c += o; c > 0; e[r + d] = 255 & a, d += h, a /= 256, c -= 8);
                                    e[r + d - h] |= 128 * y;
                                };
                            },
                            392 (e, t, r) {
                                "use strict";
                                var n = r(2861).Buffer, o = r(5377);
                                function i(e, t) {
                                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                                }
                                i.prototype.update = function(e, t) {
                                    e = o(e, t || "utf8");
                                    for(var r = this._block, n = this._blockSize, i = e.length, a = this._len, s = 0; s < i;){
                                        for(var u = a % n, c = Math.min(i - s, n - u), l = 0; l < c; l++)r[u + l] = e[s + l];
                                        s += c, (a += c) % n === 0 && this._update(r);
                                    }
                                    return this._len += i, this;
                                }, i.prototype.digest = function(e) {
                                    var t = this._len % this._blockSize;
                                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                                    var r = 8 * this._len;
                                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                                    else {
                                        var n = (4294967295 & r) >>> 0, o = (r - n) / 4294967296;
                                        this._block.writeUInt32BE(o, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                                    }
                                    this._update(this._block);
                                    var i = this._hash();
                                    return e ? i.toString(e) : i;
                                }, i.prototype._update = function() {
                                    throw new Error("_update must be implemented by subclass");
                                }, e.exports = i;
                            },
                            414 (e) {
                                "use strict";
                                e.exports = Math.round;
                            },
                            448 (e, t, r) {
                                "use strict";
                                r.r(t), r.d(t, {
                                    Account: ()=>Yn,
                                    Address: ()=>sn,
                                    Asset: ()=>Yt,
                                    AuthClawbackEnabledFlag: ()=>gn,
                                    AuthImmutableFlag: ()=>mn,
                                    AuthRequiredFlag: ()=>hn,
                                    AuthRevocableFlag: ()=>yn,
                                    BASE_FEE: ()=>Si,
                                    Claimant: ()=>Mr,
                                    Contract: ()=>ho,
                                    FeeBumpTransaction: ()=>Xn,
                                    Hyper: ()=>n.Hyper,
                                    Int128: ()=>Fo,
                                    Int256: ()=>Wo,
                                    Keypair: ()=>Wt,
                                    LiquidityPoolAsset: ()=>Nr,
                                    LiquidityPoolFeeV18: ()=>er,
                                    LiquidityPoolId: ()=>Hr,
                                    Memo: ()=>Pn,
                                    MemoHash: ()=>_n,
                                    MemoID: ()=>On,
                                    MemoNone: ()=>Tn,
                                    MemoReturn: ()=>xn,
                                    MemoText: ()=>kn,
                                    MuxedAccount: ()=>to,
                                    Networks: ()=>Oi,
                                    Operation: ()=>vn,
                                    ScInt: ()=>ni,
                                    SignerKey: ()=>co,
                                    Soroban: ()=>Ri,
                                    SorobanDataBuilder: ()=>io,
                                    StrKey: ()=>Lt,
                                    TimeoutInfinite: ()=>Ai,
                                    Transaction: ()=>Fn,
                                    TransactionBase: ()=>ar,
                                    TransactionBuilder: ()=>Ei,
                                    Uint128: ()=>Ao,
                                    Uint256: ()=>Ro,
                                    UnsignedHyper: ()=>n.UnsignedHyper,
                                    XdrLargeInt: ()=>Yo,
                                    authorizeEntry: ()=>Vi,
                                    authorizeInvocation: ()=>Gi,
                                    buildInvocationTree: ()=>Xi,
                                    cereal: ()=>a,
                                    decodeAddressToMuxedAccount: ()=>Wr,
                                    default: ()=>$i,
                                    encodeMuxedAccount: ()=>Kr,
                                    encodeMuxedAccountToAddress: ()=>Xr,
                                    extractBaseAddress: ()=>Zr,
                                    getLiquidityPoolId: ()=>tr,
                                    hash: ()=>u,
                                    humanizeEvents: ()=>Ui,
                                    nativeToScVal: ()=>fi,
                                    scValToBigInt: ()=>oi,
                                    scValToNative: ()=>pi,
                                    sign: ()=>Tt,
                                    verify: ()=>Ot,
                                    walkInvocationTree: ()=>Ki,
                                    xdr: ()=>i
                                });
                                var n = r(3740), o = n.config(function(e) {
                                    var t = 1024;
                                    e.typedef("Value", e.varOpaque()), e.struct("ScpBallot", [
                                        [
                                            "counter",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "value",
                                            e.lookup("Value")
                                        ]
                                    ]), e.enum("ScpStatementType", {
                                        scpStPrepare: 0,
                                        scpStConfirm: 1,
                                        scpStExternalize: 2,
                                        scpStNominate: 3
                                    }), e.struct("ScpNomination", [
                                        [
                                            "quorumSetHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "votes",
                                            e.varArray(e.lookup("Value"), 2147483647)
                                        ],
                                        [
                                            "accepted",
                                            e.varArray(e.lookup("Value"), 2147483647)
                                        ]
                                    ]), e.struct("ScpStatementPrepare", [
                                        [
                                            "quorumSetHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "ballot",
                                            e.lookup("ScpBallot")
                                        ],
                                        [
                                            "prepared",
                                            e.option(e.lookup("ScpBallot"))
                                        ],
                                        [
                                            "preparedPrime",
                                            e.option(e.lookup("ScpBallot"))
                                        ],
                                        [
                                            "nC",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nH",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ScpStatementConfirm", [
                                        [
                                            "ballot",
                                            e.lookup("ScpBallot")
                                        ],
                                        [
                                            "nPrepared",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nCommit",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nH",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "quorumSetHash",
                                            e.lookup("Hash")
                                        ]
                                    ]), e.struct("ScpStatementExternalize", [
                                        [
                                            "commit",
                                            e.lookup("ScpBallot")
                                        ],
                                        [
                                            "nH",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "commitQuorumSetHash",
                                            e.lookup("Hash")
                                        ]
                                    ]), e.union("ScpStatementPledges", {
                                        switchOn: e.lookup("ScpStatementType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "scpStPrepare",
                                                "prepare"
                                            ],
                                            [
                                                "scpStConfirm",
                                                "confirm"
                                            ],
                                            [
                                                "scpStExternalize",
                                                "externalize"
                                            ],
                                            [
                                                "scpStNominate",
                                                "nominate"
                                            ]
                                        ],
                                        arms: {
                                            prepare: e.lookup("ScpStatementPrepare"),
                                            confirm: e.lookup("ScpStatementConfirm"),
                                            externalize: e.lookup("ScpStatementExternalize"),
                                            nominate: e.lookup("ScpNomination")
                                        }
                                    }), e.struct("ScpStatement", [
                                        [
                                            "nodeId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "slotIndex",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "pledges",
                                            e.lookup("ScpStatementPledges")
                                        ]
                                    ]), e.struct("ScpEnvelope", [
                                        [
                                            "statement",
                                            e.lookup("ScpStatement")
                                        ],
                                        [
                                            "signature",
                                            e.lookup("Signature")
                                        ]
                                    ]), e.struct("ScpQuorumSet", [
                                        [
                                            "threshold",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "validators",
                                            e.varArray(e.lookup("NodeId"), 2147483647)
                                        ],
                                        [
                                            "innerSets",
                                            e.varArray(e.lookup("ScpQuorumSet"), 2147483647)
                                        ]
                                    ]), e.typedef("Thresholds", e.opaque(4)), e.typedef("String32", e.string(32)), e.typedef("String64", e.string(64)), e.typedef("SequenceNumber", e.lookup("Int64")), e.typedef("DataValue", e.varOpaque(64)), e.typedef("AssetCode4", e.opaque(4)), e.typedef("AssetCode12", e.opaque(12)), e.enum("AssetType", {
                                        assetTypeNative: 0,
                                        assetTypeCreditAlphanum4: 1,
                                        assetTypeCreditAlphanum12: 2,
                                        assetTypePoolShare: 3
                                    }), e.union("AssetCode", {
                                        switchOn: e.lookup("AssetType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "assetTypeCreditAlphanum4",
                                                "assetCode4"
                                            ],
                                            [
                                                "assetTypeCreditAlphanum12",
                                                "assetCode12"
                                            ]
                                        ],
                                        arms: {
                                            assetCode4: e.lookup("AssetCode4"),
                                            assetCode12: e.lookup("AssetCode12")
                                        }
                                    }), e.struct("AlphaNum4", [
                                        [
                                            "assetCode",
                                            e.lookup("AssetCode4")
                                        ],
                                        [
                                            "issuer",
                                            e.lookup("AccountId")
                                        ]
                                    ]), e.struct("AlphaNum12", [
                                        [
                                            "assetCode",
                                            e.lookup("AssetCode12")
                                        ],
                                        [
                                            "issuer",
                                            e.lookup("AccountId")
                                        ]
                                    ]), e.union("Asset", {
                                        switchOn: e.lookup("AssetType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "assetTypeNative",
                                                e.void()
                                            ],
                                            [
                                                "assetTypeCreditAlphanum4",
                                                "alphaNum4"
                                            ],
                                            [
                                                "assetTypeCreditAlphanum12",
                                                "alphaNum12"
                                            ]
                                        ],
                                        arms: {
                                            alphaNum4: e.lookup("AlphaNum4"),
                                            alphaNum12: e.lookup("AlphaNum12")
                                        }
                                    }), e.struct("Price", [
                                        [
                                            "n",
                                            e.lookup("Int32")
                                        ],
                                        [
                                            "d",
                                            e.lookup("Int32")
                                        ]
                                    ]), e.struct("Liabilities", [
                                        [
                                            "buying",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "selling",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.enum("ThresholdIndices", {
                                        thresholdMasterWeight: 0,
                                        thresholdLow: 1,
                                        thresholdMed: 2,
                                        thresholdHigh: 3
                                    }), e.enum("LedgerEntryType", {
                                        account: 0,
                                        trustline: 1,
                                        offer: 2,
                                        data: 3,
                                        claimableBalance: 4,
                                        liquidityPool: 5,
                                        contractData: 6,
                                        contractCode: 7,
                                        configSetting: 8,
                                        ttl: 9
                                    }), e.struct("Signer", [
                                        [
                                            "key",
                                            e.lookup("SignerKey")
                                        ],
                                        [
                                            "weight",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.enum("AccountFlags", {
                                        authRequiredFlag: 1,
                                        authRevocableFlag: 2,
                                        authImmutableFlag: 4,
                                        authClawbackEnabledFlag: 8
                                    }), e.const("MASK_ACCOUNT_FLAGS", 7), e.const("MASK_ACCOUNT_FLAGS_V17", 15), e.const("MAX_SIGNERS", 20), e.typedef("SponsorshipDescriptor", e.option(e.lookup("AccountId"))), e.struct("AccountEntryExtensionV3", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "seqLedger",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "seqTime",
                                            e.lookup("TimePoint")
                                        ]
                                    ]), e.union("AccountEntryExtensionV2Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                3,
                                                "v3"
                                            ]
                                        ],
                                        arms: {
                                            v3: e.lookup("AccountEntryExtensionV3")
                                        }
                                    }), e.struct("AccountEntryExtensionV2", [
                                        [
                                            "numSponsored",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "numSponsoring",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "signerSponsoringIDs",
                                            e.varArray(e.lookup("SponsorshipDescriptor"), e.lookup("MAX_SIGNERS"))
                                        ],
                                        [
                                            "ext",
                                            e.lookup("AccountEntryExtensionV2Ext")
                                        ]
                                    ]), e.union("AccountEntryExtensionV1Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                2,
                                                "v2"
                                            ]
                                        ],
                                        arms: {
                                            v2: e.lookup("AccountEntryExtensionV2")
                                        }
                                    }), e.struct("AccountEntryExtensionV1", [
                                        [
                                            "liabilities",
                                            e.lookup("Liabilities")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("AccountEntryExtensionV1Ext")
                                        ]
                                    ]), e.union("AccountEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("AccountEntryExtensionV1")
                                        }
                                    }), e.struct("AccountEntry", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "balance",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "seqNum",
                                            e.lookup("SequenceNumber")
                                        ],
                                        [
                                            "numSubEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "inflationDest",
                                            e.option(e.lookup("AccountId"))
                                        ],
                                        [
                                            "flags",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "homeDomain",
                                            e.lookup("String32")
                                        ],
                                        [
                                            "thresholds",
                                            e.lookup("Thresholds")
                                        ],
                                        [
                                            "signers",
                                            e.varArray(e.lookup("Signer"), e.lookup("MAX_SIGNERS"))
                                        ],
                                        [
                                            "ext",
                                            e.lookup("AccountEntryExt")
                                        ]
                                    ]), e.enum("TrustLineFlags", {
                                        authorizedFlag: 1,
                                        authorizedToMaintainLiabilitiesFlag: 2,
                                        trustlineClawbackEnabledFlag: 4
                                    }), e.const("MASK_TRUSTLINE_FLAGS", 1), e.const("MASK_TRUSTLINE_FLAGS_V13", 3), e.const("MASK_TRUSTLINE_FLAGS_V17", 7), e.enum("LiquidityPoolType", {
                                        liquidityPoolConstantProduct: 0
                                    }), e.union("TrustLineAsset", {
                                        switchOn: e.lookup("AssetType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "assetTypeNative",
                                                e.void()
                                            ],
                                            [
                                                "assetTypeCreditAlphanum4",
                                                "alphaNum4"
                                            ],
                                            [
                                                "assetTypeCreditAlphanum12",
                                                "alphaNum12"
                                            ],
                                            [
                                                "assetTypePoolShare",
                                                "liquidityPoolId"
                                            ]
                                        ],
                                        arms: {
                                            alphaNum4: e.lookup("AlphaNum4"),
                                            alphaNum12: e.lookup("AlphaNum12"),
                                            liquidityPoolId: e.lookup("PoolId")
                                        }
                                    }), e.union("TrustLineEntryExtensionV2Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("TrustLineEntryExtensionV2", [
                                        [
                                            "liquidityPoolUseCount",
                                            e.lookup("Int32")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TrustLineEntryExtensionV2Ext")
                                        ]
                                    ]), e.union("TrustLineEntryV1Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                2,
                                                "v2"
                                            ]
                                        ],
                                        arms: {
                                            v2: e.lookup("TrustLineEntryExtensionV2")
                                        }
                                    }), e.struct("TrustLineEntryV1", [
                                        [
                                            "liabilities",
                                            e.lookup("Liabilities")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TrustLineEntryV1Ext")
                                        ]
                                    ]), e.union("TrustLineEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("TrustLineEntryV1")
                                        }
                                    }), e.struct("TrustLineEntry", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("TrustLineAsset")
                                        ],
                                        [
                                            "balance",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "limit",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "flags",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TrustLineEntryExt")
                                        ]
                                    ]), e.enum("OfferEntryFlags", {
                                        passiveFlag: 1
                                    }), e.const("MASK_OFFERENTRY_FLAGS", 1), e.union("OfferEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("OfferEntry", [
                                        [
                                            "sellerId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "offerId",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "selling",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "buying",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "price",
                                            e.lookup("Price")
                                        ],
                                        [
                                            "flags",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("OfferEntryExt")
                                        ]
                                    ]), e.union("DataEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("DataEntry", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "dataName",
                                            e.lookup("String64")
                                        ],
                                        [
                                            "dataValue",
                                            e.lookup("DataValue")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("DataEntryExt")
                                        ]
                                    ]), e.enum("ClaimPredicateType", {
                                        claimPredicateUnconditional: 0,
                                        claimPredicateAnd: 1,
                                        claimPredicateOr: 2,
                                        claimPredicateNot: 3,
                                        claimPredicateBeforeAbsoluteTime: 4,
                                        claimPredicateBeforeRelativeTime: 5
                                    }), e.union("ClaimPredicate", {
                                        switchOn: e.lookup("ClaimPredicateType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "claimPredicateUnconditional",
                                                e.void()
                                            ],
                                            [
                                                "claimPredicateAnd",
                                                "andPredicates"
                                            ],
                                            [
                                                "claimPredicateOr",
                                                "orPredicates"
                                            ],
                                            [
                                                "claimPredicateNot",
                                                "notPredicate"
                                            ],
                                            [
                                                "claimPredicateBeforeAbsoluteTime",
                                                "absBefore"
                                            ],
                                            [
                                                "claimPredicateBeforeRelativeTime",
                                                "relBefore"
                                            ]
                                        ],
                                        arms: {
                                            andPredicates: e.varArray(e.lookup("ClaimPredicate"), 2),
                                            orPredicates: e.varArray(e.lookup("ClaimPredicate"), 2),
                                            notPredicate: e.option(e.lookup("ClaimPredicate")),
                                            absBefore: e.lookup("Int64"),
                                            relBefore: e.lookup("Int64")
                                        }
                                    }), e.enum("ClaimantType", {
                                        claimantTypeV0: 0
                                    }), e.struct("ClaimantV0", [
                                        [
                                            "destination",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "predicate",
                                            e.lookup("ClaimPredicate")
                                        ]
                                    ]), e.union("Claimant", {
                                        switchOn: e.lookup("ClaimantType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "claimantTypeV0",
                                                "v0"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("ClaimantV0")
                                        }
                                    }), e.enum("ClaimableBalanceFlags", {
                                        claimableBalanceClawbackEnabledFlag: 1
                                    }), e.const("MASK_CLAIMABLE_BALANCE_FLAGS", 1), e.union("ClaimableBalanceEntryExtensionV1Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("ClaimableBalanceEntryExtensionV1", [
                                        [
                                            "ext",
                                            e.lookup("ClaimableBalanceEntryExtensionV1Ext")
                                        ],
                                        [
                                            "flags",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.union("ClaimableBalanceEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("ClaimableBalanceEntryExtensionV1")
                                        }
                                    }), e.struct("ClaimableBalanceEntry", [
                                        [
                                            "balanceId",
                                            e.lookup("ClaimableBalanceId")
                                        ],
                                        [
                                            "claimants",
                                            e.varArray(e.lookup("Claimant"), 10)
                                        ],
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("ClaimableBalanceEntryExt")
                                        ]
                                    ]), e.struct("LiquidityPoolConstantProductParameters", [
                                        [
                                            "assetA",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "assetB",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "fee",
                                            e.lookup("Int32")
                                        ]
                                    ]), e.struct("LiquidityPoolEntryConstantProduct", [
                                        [
                                            "params",
                                            e.lookup("LiquidityPoolConstantProductParameters")
                                        ],
                                        [
                                            "reserveA",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "reserveB",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "totalPoolShares",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "poolSharesTrustLineCount",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.union("LiquidityPoolEntryBody", {
                                        switchOn: e.lookup("LiquidityPoolType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "liquidityPoolConstantProduct",
                                                "constantProduct"
                                            ]
                                        ],
                                        arms: {
                                            constantProduct: e.lookup("LiquidityPoolEntryConstantProduct")
                                        }
                                    }), e.struct("LiquidityPoolEntry", [
                                        [
                                            "liquidityPoolId",
                                            e.lookup("PoolId")
                                        ],
                                        [
                                            "body",
                                            e.lookup("LiquidityPoolEntryBody")
                                        ]
                                    ]), e.enum("ContractDataDurability", {
                                        temporary: 0,
                                        persistent: 1
                                    }), e.struct("ContractDataEntry", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "contract",
                                            e.lookup("ScAddress")
                                        ],
                                        [
                                            "key",
                                            e.lookup("ScVal")
                                        ],
                                        [
                                            "durability",
                                            e.lookup("ContractDataDurability")
                                        ],
                                        [
                                            "val",
                                            e.lookup("ScVal")
                                        ]
                                    ]), e.struct("ContractCodeCostInputs", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "nInstructions",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nFunctions",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nGlobals",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nTableEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nTypes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nDataSegments",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nElemSegments",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nImports",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nExports",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nDataSegmentBytes",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ContractCodeEntryV1", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "costInputs",
                                            e.lookup("ContractCodeCostInputs")
                                        ]
                                    ]), e.union("ContractCodeEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("ContractCodeEntryV1")
                                        }
                                    }), e.struct("ContractCodeEntry", [
                                        [
                                            "ext",
                                            e.lookup("ContractCodeEntryExt")
                                        ],
                                        [
                                            "hash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "code",
                                            e.varOpaque()
                                        ]
                                    ]), e.struct("TtlEntry", [
                                        [
                                            "keyHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "liveUntilLedgerSeq",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.union("LedgerEntryExtensionV1Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("LedgerEntryExtensionV1", [
                                        [
                                            "sponsoringId",
                                            e.lookup("SponsorshipDescriptor")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("LedgerEntryExtensionV1Ext")
                                        ]
                                    ]), e.union("LedgerEntryData", {
                                        switchOn: e.lookup("LedgerEntryType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "account",
                                                "account"
                                            ],
                                            [
                                                "trustline",
                                                "trustLine"
                                            ],
                                            [
                                                "offer",
                                                "offer"
                                            ],
                                            [
                                                "data",
                                                "data"
                                            ],
                                            [
                                                "claimableBalance",
                                                "claimableBalance"
                                            ],
                                            [
                                                "liquidityPool",
                                                "liquidityPool"
                                            ],
                                            [
                                                "contractData",
                                                "contractData"
                                            ],
                                            [
                                                "contractCode",
                                                "contractCode"
                                            ],
                                            [
                                                "configSetting",
                                                "configSetting"
                                            ],
                                            [
                                                "ttl",
                                                "ttl"
                                            ]
                                        ],
                                        arms: {
                                            account: e.lookup("AccountEntry"),
                                            trustLine: e.lookup("TrustLineEntry"),
                                            offer: e.lookup("OfferEntry"),
                                            data: e.lookup("DataEntry"),
                                            claimableBalance: e.lookup("ClaimableBalanceEntry"),
                                            liquidityPool: e.lookup("LiquidityPoolEntry"),
                                            contractData: e.lookup("ContractDataEntry"),
                                            contractCode: e.lookup("ContractCodeEntry"),
                                            configSetting: e.lookup("ConfigSettingEntry"),
                                            ttl: e.lookup("TtlEntry")
                                        }
                                    }), e.union("LedgerEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("LedgerEntryExtensionV1")
                                        }
                                    }), e.struct("LedgerEntry", [
                                        [
                                            "lastModifiedLedgerSeq",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "data",
                                            e.lookup("LedgerEntryData")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("LedgerEntryExt")
                                        ]
                                    ]), e.struct("LedgerKeyAccount", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ]
                                    ]), e.struct("LedgerKeyTrustLine", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("TrustLineAsset")
                                        ]
                                    ]), e.struct("LedgerKeyOffer", [
                                        [
                                            "sellerId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "offerId",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("LedgerKeyData", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "dataName",
                                            e.lookup("String64")
                                        ]
                                    ]), e.struct("LedgerKeyClaimableBalance", [
                                        [
                                            "balanceId",
                                            e.lookup("ClaimableBalanceId")
                                        ]
                                    ]), e.struct("LedgerKeyLiquidityPool", [
                                        [
                                            "liquidityPoolId",
                                            e.lookup("PoolId")
                                        ]
                                    ]), e.struct("LedgerKeyContractData", [
                                        [
                                            "contract",
                                            e.lookup("ScAddress")
                                        ],
                                        [
                                            "key",
                                            e.lookup("ScVal")
                                        ],
                                        [
                                            "durability",
                                            e.lookup("ContractDataDurability")
                                        ]
                                    ]), e.struct("LedgerKeyContractCode", [
                                        [
                                            "hash",
                                            e.lookup("Hash")
                                        ]
                                    ]), e.struct("LedgerKeyConfigSetting", [
                                        [
                                            "configSettingId",
                                            e.lookup("ConfigSettingId")
                                        ]
                                    ]), e.struct("LedgerKeyTtl", [
                                        [
                                            "keyHash",
                                            e.lookup("Hash")
                                        ]
                                    ]), e.union("LedgerKey", {
                                        switchOn: e.lookup("LedgerEntryType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "account",
                                                "account"
                                            ],
                                            [
                                                "trustline",
                                                "trustLine"
                                            ],
                                            [
                                                "offer",
                                                "offer"
                                            ],
                                            [
                                                "data",
                                                "data"
                                            ],
                                            [
                                                "claimableBalance",
                                                "claimableBalance"
                                            ],
                                            [
                                                "liquidityPool",
                                                "liquidityPool"
                                            ],
                                            [
                                                "contractData",
                                                "contractData"
                                            ],
                                            [
                                                "contractCode",
                                                "contractCode"
                                            ],
                                            [
                                                "configSetting",
                                                "configSetting"
                                            ],
                                            [
                                                "ttl",
                                                "ttl"
                                            ]
                                        ],
                                        arms: {
                                            account: e.lookup("LedgerKeyAccount"),
                                            trustLine: e.lookup("LedgerKeyTrustLine"),
                                            offer: e.lookup("LedgerKeyOffer"),
                                            data: e.lookup("LedgerKeyData"),
                                            claimableBalance: e.lookup("LedgerKeyClaimableBalance"),
                                            liquidityPool: e.lookup("LedgerKeyLiquidityPool"),
                                            contractData: e.lookup("LedgerKeyContractData"),
                                            contractCode: e.lookup("LedgerKeyContractCode"),
                                            configSetting: e.lookup("LedgerKeyConfigSetting"),
                                            ttl: e.lookup("LedgerKeyTtl")
                                        }
                                    }), e.enum("EnvelopeType", {
                                        envelopeTypeTxV0: 0,
                                        envelopeTypeScp: 1,
                                        envelopeTypeTx: 2,
                                        envelopeTypeAuth: 3,
                                        envelopeTypeScpvalue: 4,
                                        envelopeTypeTxFeeBump: 5,
                                        envelopeTypeOpId: 6,
                                        envelopeTypePoolRevokeOpId: 7,
                                        envelopeTypeContractId: 8,
                                        envelopeTypeSorobanAuthorization: 9
                                    }), e.enum("BucketListType", {
                                        live: 0,
                                        hotArchive: 1
                                    }), e.enum("BucketEntryType", {
                                        metaentry: -1,
                                        liveentry: 0,
                                        deadentry: 1,
                                        initentry: 2
                                    }), e.enum("HotArchiveBucketEntryType", {
                                        hotArchiveMetaentry: -1,
                                        hotArchiveArchived: 0,
                                        hotArchiveLive: 1
                                    }), e.union("BucketMetadataExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "bucketListType"
                                            ]
                                        ],
                                        arms: {
                                            bucketListType: e.lookup("BucketListType")
                                        }
                                    }), e.struct("BucketMetadata", [
                                        [
                                            "ledgerVersion",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("BucketMetadataExt")
                                        ]
                                    ]), e.union("BucketEntry", {
                                        switchOn: e.lookup("BucketEntryType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "liveentry",
                                                "liveEntry"
                                            ],
                                            [
                                                "initentry",
                                                "liveEntry"
                                            ],
                                            [
                                                "deadentry",
                                                "deadEntry"
                                            ],
                                            [
                                                "metaentry",
                                                "metaEntry"
                                            ]
                                        ],
                                        arms: {
                                            liveEntry: e.lookup("LedgerEntry"),
                                            deadEntry: e.lookup("LedgerKey"),
                                            metaEntry: e.lookup("BucketMetadata")
                                        }
                                    }), e.union("HotArchiveBucketEntry", {
                                        switchOn: e.lookup("HotArchiveBucketEntryType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "hotArchiveArchived",
                                                "archivedEntry"
                                            ],
                                            [
                                                "hotArchiveLive",
                                                "key"
                                            ],
                                            [
                                                "hotArchiveMetaentry",
                                                "metaEntry"
                                            ]
                                        ],
                                        arms: {
                                            archivedEntry: e.lookup("LedgerEntry"),
                                            key: e.lookup("LedgerKey"),
                                            metaEntry: e.lookup("BucketMetadata")
                                        }
                                    }), e.typedef("UpgradeType", e.varOpaque(128)), e.enum("StellarValueType", {
                                        stellarValueBasic: 0,
                                        stellarValueSigned: 1
                                    }), e.struct("LedgerCloseValueSignature", [
                                        [
                                            "nodeId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "signature",
                                            e.lookup("Signature")
                                        ]
                                    ]), e.union("StellarValueExt", {
                                        switchOn: e.lookup("StellarValueType"),
                                        switchName: "v",
                                        switches: [
                                            [
                                                "stellarValueBasic",
                                                e.void()
                                            ],
                                            [
                                                "stellarValueSigned",
                                                "lcValueSignature"
                                            ]
                                        ],
                                        arms: {
                                            lcValueSignature: e.lookup("LedgerCloseValueSignature")
                                        }
                                    }), e.struct("StellarValue", [
                                        [
                                            "txSetHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "closeTime",
                                            e.lookup("TimePoint")
                                        ],
                                        [
                                            "upgrades",
                                            e.varArray(e.lookup("UpgradeType"), 6)
                                        ],
                                        [
                                            "ext",
                                            e.lookup("StellarValueExt")
                                        ]
                                    ]), e.const("MASK_LEDGER_HEADER_FLAGS", 7), e.enum("LedgerHeaderFlags", {
                                        disableLiquidityPoolTradingFlag: 1,
                                        disableLiquidityPoolDepositFlag: 2,
                                        disableLiquidityPoolWithdrawalFlag: 4
                                    }), e.union("LedgerHeaderExtensionV1Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("LedgerHeaderExtensionV1", [
                                        [
                                            "flags",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("LedgerHeaderExtensionV1Ext")
                                        ]
                                    ]), e.union("LedgerHeaderExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("LedgerHeaderExtensionV1")
                                        }
                                    }), e.struct("LedgerHeader", [
                                        [
                                            "ledgerVersion",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "previousLedgerHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "scpValue",
                                            e.lookup("StellarValue")
                                        ],
                                        [
                                            "txSetResultHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "bucketListHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "ledgerSeq",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "totalCoins",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "feePool",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "inflationSeq",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "idPool",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "baseFee",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "baseReserve",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "maxTxSetSize",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "skipList",
                                            e.array(e.lookup("Hash"), 4)
                                        ],
                                        [
                                            "ext",
                                            e.lookup("LedgerHeaderExt")
                                        ]
                                    ]), e.enum("LedgerUpgradeType", {
                                        ledgerUpgradeVersion: 1,
                                        ledgerUpgradeBaseFee: 2,
                                        ledgerUpgradeMaxTxSetSize: 3,
                                        ledgerUpgradeBaseReserve: 4,
                                        ledgerUpgradeFlags: 5,
                                        ledgerUpgradeConfig: 6,
                                        ledgerUpgradeMaxSorobanTxSetSize: 7
                                    }), e.struct("ConfigUpgradeSetKey", [
                                        [
                                            "contractId",
                                            e.lookup("ContractId")
                                        ],
                                        [
                                            "contentHash",
                                            e.lookup("Hash")
                                        ]
                                    ]), e.union("LedgerUpgrade", {
                                        switchOn: e.lookup("LedgerUpgradeType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "ledgerUpgradeVersion",
                                                "newLedgerVersion"
                                            ],
                                            [
                                                "ledgerUpgradeBaseFee",
                                                "newBaseFee"
                                            ],
                                            [
                                                "ledgerUpgradeMaxTxSetSize",
                                                "newMaxTxSetSize"
                                            ],
                                            [
                                                "ledgerUpgradeBaseReserve",
                                                "newBaseReserve"
                                            ],
                                            [
                                                "ledgerUpgradeFlags",
                                                "newFlags"
                                            ],
                                            [
                                                "ledgerUpgradeConfig",
                                                "newConfig"
                                            ],
                                            [
                                                "ledgerUpgradeMaxSorobanTxSetSize",
                                                "newMaxSorobanTxSetSize"
                                            ]
                                        ],
                                        arms: {
                                            newLedgerVersion: e.lookup("Uint32"),
                                            newBaseFee: e.lookup("Uint32"),
                                            newMaxTxSetSize: e.lookup("Uint32"),
                                            newBaseReserve: e.lookup("Uint32"),
                                            newFlags: e.lookup("Uint32"),
                                            newConfig: e.lookup("ConfigUpgradeSetKey"),
                                            newMaxSorobanTxSetSize: e.lookup("Uint32")
                                        }
                                    }), e.struct("ConfigUpgradeSet", [
                                        [
                                            "updatedEntry",
                                            e.varArray(e.lookup("ConfigSettingEntry"), 2147483647)
                                        ]
                                    ]), e.enum("TxSetComponentType", {
                                        txsetCompTxsMaybeDiscountedFee: 0
                                    }), e.typedef("DependentTxCluster", e.varArray(e.lookup("TransactionEnvelope"), 2147483647)), e.typedef("ParallelTxExecutionStage", e.varArray(e.lookup("DependentTxCluster"), 2147483647)), e.struct("ParallelTxsComponent", [
                                        [
                                            "baseFee",
                                            e.option(e.lookup("Int64"))
                                        ],
                                        [
                                            "executionStages",
                                            e.varArray(e.lookup("ParallelTxExecutionStage"), 2147483647)
                                        ]
                                    ]), e.struct("TxSetComponentTxsMaybeDiscountedFee", [
                                        [
                                            "baseFee",
                                            e.option(e.lookup("Int64"))
                                        ],
                                        [
                                            "txes",
                                            e.varArray(e.lookup("TransactionEnvelope"), 2147483647)
                                        ]
                                    ]), e.union("TxSetComponent", {
                                        switchOn: e.lookup("TxSetComponentType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "txsetCompTxsMaybeDiscountedFee",
                                                "txsMaybeDiscountedFee"
                                            ]
                                        ],
                                        arms: {
                                            txsMaybeDiscountedFee: e.lookup("TxSetComponentTxsMaybeDiscountedFee")
                                        }
                                    }), e.union("TransactionPhase", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                "v0Components"
                                            ],
                                            [
                                                1,
                                                "parallelTxsComponent"
                                            ]
                                        ],
                                        arms: {
                                            v0Components: e.varArray(e.lookup("TxSetComponent"), 2147483647),
                                            parallelTxsComponent: e.lookup("ParallelTxsComponent")
                                        }
                                    }), e.struct("TransactionSet", [
                                        [
                                            "previousLedgerHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "txes",
                                            e.varArray(e.lookup("TransactionEnvelope"), 2147483647)
                                        ]
                                    ]), e.struct("TransactionSetV1", [
                                        [
                                            "previousLedgerHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "phases",
                                            e.varArray(e.lookup("TransactionPhase"), 2147483647)
                                        ]
                                    ]), e.union("GeneralizedTransactionSet", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                1,
                                                "v1TxSet"
                                            ]
                                        ],
                                        arms: {
                                            v1TxSet: e.lookup("TransactionSetV1")
                                        }
                                    }), e.struct("TransactionResultPair", [
                                        [
                                            "transactionHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "result",
                                            e.lookup("TransactionResult")
                                        ]
                                    ]), e.struct("TransactionResultSet", [
                                        [
                                            "results",
                                            e.varArray(e.lookup("TransactionResultPair"), 2147483647)
                                        ]
                                    ]), e.union("TransactionHistoryEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "generalizedTxSet"
                                            ]
                                        ],
                                        arms: {
                                            generalizedTxSet: e.lookup("GeneralizedTransactionSet")
                                        }
                                    }), e.struct("TransactionHistoryEntry", [
                                        [
                                            "ledgerSeq",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txSet",
                                            e.lookup("TransactionSet")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TransactionHistoryEntryExt")
                                        ]
                                    ]), e.union("TransactionHistoryResultEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("TransactionHistoryResultEntry", [
                                        [
                                            "ledgerSeq",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txResultSet",
                                            e.lookup("TransactionResultSet")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TransactionHistoryResultEntryExt")
                                        ]
                                    ]), e.union("LedgerHeaderHistoryEntryExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("LedgerHeaderHistoryEntry", [
                                        [
                                            "hash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "header",
                                            e.lookup("LedgerHeader")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("LedgerHeaderHistoryEntryExt")
                                        ]
                                    ]), e.struct("LedgerScpMessages", [
                                        [
                                            "ledgerSeq",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "messages",
                                            e.varArray(e.lookup("ScpEnvelope"), 2147483647)
                                        ]
                                    ]), e.struct("ScpHistoryEntryV0", [
                                        [
                                            "quorumSets",
                                            e.varArray(e.lookup("ScpQuorumSet"), 2147483647)
                                        ],
                                        [
                                            "ledgerMessages",
                                            e.lookup("LedgerScpMessages")
                                        ]
                                    ]), e.union("ScpHistoryEntry", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                "v0"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("ScpHistoryEntryV0")
                                        }
                                    }), e.enum("LedgerEntryChangeType", {
                                        ledgerEntryCreated: 0,
                                        ledgerEntryUpdated: 1,
                                        ledgerEntryRemoved: 2,
                                        ledgerEntryState: 3,
                                        ledgerEntryRestored: 4
                                    }), e.union("LedgerEntryChange", {
                                        switchOn: e.lookup("LedgerEntryChangeType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "ledgerEntryCreated",
                                                "created"
                                            ],
                                            [
                                                "ledgerEntryUpdated",
                                                "updated"
                                            ],
                                            [
                                                "ledgerEntryRemoved",
                                                "removed"
                                            ],
                                            [
                                                "ledgerEntryState",
                                                "state"
                                            ],
                                            [
                                                "ledgerEntryRestored",
                                                "restored"
                                            ]
                                        ],
                                        arms: {
                                            created: e.lookup("LedgerEntry"),
                                            updated: e.lookup("LedgerEntry"),
                                            removed: e.lookup("LedgerKey"),
                                            state: e.lookup("LedgerEntry"),
                                            restored: e.lookup("LedgerEntry")
                                        }
                                    }), e.typedef("LedgerEntryChanges", e.varArray(e.lookup("LedgerEntryChange"), 2147483647)), e.struct("OperationMeta", [
                                        [
                                            "changes",
                                            e.lookup("LedgerEntryChanges")
                                        ]
                                    ]), e.struct("TransactionMetaV1", [
                                        [
                                            "txChanges",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "operations",
                                            e.varArray(e.lookup("OperationMeta"), 2147483647)
                                        ]
                                    ]), e.struct("TransactionMetaV2", [
                                        [
                                            "txChangesBefore",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "operations",
                                            e.varArray(e.lookup("OperationMeta"), 2147483647)
                                        ],
                                        [
                                            "txChangesAfter",
                                            e.lookup("LedgerEntryChanges")
                                        ]
                                    ]), e.enum("ContractEventType", {
                                        system: 0,
                                        contract: 1,
                                        diagnostic: 2
                                    }), e.struct("ContractEventV0", [
                                        [
                                            "topics",
                                            e.varArray(e.lookup("ScVal"), 2147483647)
                                        ],
                                        [
                                            "data",
                                            e.lookup("ScVal")
                                        ]
                                    ]), e.union("ContractEventBody", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                "v0"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("ContractEventV0")
                                        }
                                    }), e.struct("ContractEvent", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "contractId",
                                            e.option(e.lookup("ContractId"))
                                        ],
                                        [
                                            "type",
                                            e.lookup("ContractEventType")
                                        ],
                                        [
                                            "body",
                                            e.lookup("ContractEventBody")
                                        ]
                                    ]), e.struct("DiagnosticEvent", [
                                        [
                                            "inSuccessfulContractCall",
                                            e.bool()
                                        ],
                                        [
                                            "event",
                                            e.lookup("ContractEvent")
                                        ]
                                    ]), e.struct("SorobanTransactionMetaExtV1", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "totalNonRefundableResourceFeeCharged",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "totalRefundableResourceFeeCharged",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "rentFeeCharged",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.union("SorobanTransactionMetaExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("SorobanTransactionMetaExtV1")
                                        }
                                    }), e.struct("SorobanTransactionMeta", [
                                        [
                                            "ext",
                                            e.lookup("SorobanTransactionMetaExt")
                                        ],
                                        [
                                            "events",
                                            e.varArray(e.lookup("ContractEvent"), 2147483647)
                                        ],
                                        [
                                            "returnValue",
                                            e.lookup("ScVal")
                                        ],
                                        [
                                            "diagnosticEvents",
                                            e.varArray(e.lookup("DiagnosticEvent"), 2147483647)
                                        ]
                                    ]), e.struct("TransactionMetaV3", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "txChangesBefore",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "operations",
                                            e.varArray(e.lookup("OperationMeta"), 2147483647)
                                        ],
                                        [
                                            "txChangesAfter",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "sorobanMeta",
                                            e.option(e.lookup("SorobanTransactionMeta"))
                                        ]
                                    ]), e.struct("OperationMetaV2", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "changes",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "events",
                                            e.varArray(e.lookup("ContractEvent"), 2147483647)
                                        ]
                                    ]), e.struct("SorobanTransactionMetaV2", [
                                        [
                                            "ext",
                                            e.lookup("SorobanTransactionMetaExt")
                                        ],
                                        [
                                            "returnValue",
                                            e.option(e.lookup("ScVal"))
                                        ]
                                    ]), e.enum("TransactionEventStage", {
                                        transactionEventStageBeforeAllTxes: 0,
                                        transactionEventStageAfterTx: 1,
                                        transactionEventStageAfterAllTxes: 2
                                    }), e.struct("TransactionEvent", [
                                        [
                                            "stage",
                                            e.lookup("TransactionEventStage")
                                        ],
                                        [
                                            "event",
                                            e.lookup("ContractEvent")
                                        ]
                                    ]), e.struct("TransactionMetaV4", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "txChangesBefore",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "operations",
                                            e.varArray(e.lookup("OperationMetaV2"), 2147483647)
                                        ],
                                        [
                                            "txChangesAfter",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "sorobanMeta",
                                            e.option(e.lookup("SorobanTransactionMetaV2"))
                                        ],
                                        [
                                            "events",
                                            e.varArray(e.lookup("TransactionEvent"), 2147483647)
                                        ],
                                        [
                                            "diagnosticEvents",
                                            e.varArray(e.lookup("DiagnosticEvent"), 2147483647)
                                        ]
                                    ]), e.struct("InvokeHostFunctionSuccessPreImage", [
                                        [
                                            "returnValue",
                                            e.lookup("ScVal")
                                        ],
                                        [
                                            "events",
                                            e.varArray(e.lookup("ContractEvent"), 2147483647)
                                        ]
                                    ]), e.union("TransactionMeta", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                "operations"
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ],
                                            [
                                                2,
                                                "v2"
                                            ],
                                            [
                                                3,
                                                "v3"
                                            ],
                                            [
                                                4,
                                                "v4"
                                            ]
                                        ],
                                        arms: {
                                            operations: e.varArray(e.lookup("OperationMeta"), 2147483647),
                                            v1: e.lookup("TransactionMetaV1"),
                                            v2: e.lookup("TransactionMetaV2"),
                                            v3: e.lookup("TransactionMetaV3"),
                                            v4: e.lookup("TransactionMetaV4")
                                        }
                                    }), e.struct("TransactionResultMeta", [
                                        [
                                            "result",
                                            e.lookup("TransactionResultPair")
                                        ],
                                        [
                                            "feeProcessing",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "txApplyProcessing",
                                            e.lookup("TransactionMeta")
                                        ]
                                    ]), e.struct("TransactionResultMetaV1", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "result",
                                            e.lookup("TransactionResultPair")
                                        ],
                                        [
                                            "feeProcessing",
                                            e.lookup("LedgerEntryChanges")
                                        ],
                                        [
                                            "txApplyProcessing",
                                            e.lookup("TransactionMeta")
                                        ],
                                        [
                                            "postTxApplyFeeProcessing",
                                            e.lookup("LedgerEntryChanges")
                                        ]
                                    ]), e.struct("UpgradeEntryMeta", [
                                        [
                                            "upgrade",
                                            e.lookup("LedgerUpgrade")
                                        ],
                                        [
                                            "changes",
                                            e.lookup("LedgerEntryChanges")
                                        ]
                                    ]), e.struct("LedgerCloseMetaV0", [
                                        [
                                            "ledgerHeader",
                                            e.lookup("LedgerHeaderHistoryEntry")
                                        ],
                                        [
                                            "txSet",
                                            e.lookup("TransactionSet")
                                        ],
                                        [
                                            "txProcessing",
                                            e.varArray(e.lookup("TransactionResultMeta"), 2147483647)
                                        ],
                                        [
                                            "upgradesProcessing",
                                            e.varArray(e.lookup("UpgradeEntryMeta"), 2147483647)
                                        ],
                                        [
                                            "scpInfo",
                                            e.varArray(e.lookup("ScpHistoryEntry"), 2147483647)
                                        ]
                                    ]), e.struct("LedgerCloseMetaExtV1", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "sorobanFeeWrite1Kb",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.union("LedgerCloseMetaExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("LedgerCloseMetaExtV1")
                                        }
                                    }), e.struct("LedgerCloseMetaV1", [
                                        [
                                            "ext",
                                            e.lookup("LedgerCloseMetaExt")
                                        ],
                                        [
                                            "ledgerHeader",
                                            e.lookup("LedgerHeaderHistoryEntry")
                                        ],
                                        [
                                            "txSet",
                                            e.lookup("GeneralizedTransactionSet")
                                        ],
                                        [
                                            "txProcessing",
                                            e.varArray(e.lookup("TransactionResultMeta"), 2147483647)
                                        ],
                                        [
                                            "upgradesProcessing",
                                            e.varArray(e.lookup("UpgradeEntryMeta"), 2147483647)
                                        ],
                                        [
                                            "scpInfo",
                                            e.varArray(e.lookup("ScpHistoryEntry"), 2147483647)
                                        ],
                                        [
                                            "totalByteSizeOfLiveSorobanState",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "evictedKeys",
                                            e.varArray(e.lookup("LedgerKey"), 2147483647)
                                        ],
                                        [
                                            "unused",
                                            e.varArray(e.lookup("LedgerEntry"), 2147483647)
                                        ]
                                    ]), e.struct("LedgerCloseMetaV2", [
                                        [
                                            "ext",
                                            e.lookup("LedgerCloseMetaExt")
                                        ],
                                        [
                                            "ledgerHeader",
                                            e.lookup("LedgerHeaderHistoryEntry")
                                        ],
                                        [
                                            "txSet",
                                            e.lookup("GeneralizedTransactionSet")
                                        ],
                                        [
                                            "txProcessing",
                                            e.varArray(e.lookup("TransactionResultMetaV1"), 2147483647)
                                        ],
                                        [
                                            "upgradesProcessing",
                                            e.varArray(e.lookup("UpgradeEntryMeta"), 2147483647)
                                        ],
                                        [
                                            "scpInfo",
                                            e.varArray(e.lookup("ScpHistoryEntry"), 2147483647)
                                        ],
                                        [
                                            "totalByteSizeOfLiveSorobanState",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "evictedKeys",
                                            e.varArray(e.lookup("LedgerKey"), 2147483647)
                                        ]
                                    ]), e.union("LedgerCloseMeta", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                "v0"
                                            ],
                                            [
                                                1,
                                                "v1"
                                            ],
                                            [
                                                2,
                                                "v2"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("LedgerCloseMetaV0"),
                                            v1: e.lookup("LedgerCloseMetaV1"),
                                            v2: e.lookup("LedgerCloseMetaV2")
                                        }
                                    }), e.enum("ErrorCode", {
                                        errMisc: 0,
                                        errData: 1,
                                        errConf: 2,
                                        errAuth: 3,
                                        errLoad: 4
                                    }), e.struct("Error", [
                                        [
                                            "code",
                                            e.lookup("ErrorCode")
                                        ],
                                        [
                                            "msg",
                                            e.string(100)
                                        ]
                                    ]), e.struct("SendMore", [
                                        [
                                            "numMessages",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("SendMoreExtended", [
                                        [
                                            "numMessages",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "numBytes",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("AuthCert", [
                                        [
                                            "pubkey",
                                            e.lookup("Curve25519Public")
                                        ],
                                        [
                                            "expiration",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "sig",
                                            e.lookup("Signature")
                                        ]
                                    ]), e.struct("Hello", [
                                        [
                                            "ledgerVersion",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "overlayVersion",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "overlayMinVersion",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "networkId",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "versionStr",
                                            e.string(100)
                                        ],
                                        [
                                            "listeningPort",
                                            e.int()
                                        ],
                                        [
                                            "peerId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "cert",
                                            e.lookup("AuthCert")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Uint256")
                                        ]
                                    ]), e.const("AUTH_MSG_FLAG_FLOW_CONTROL_BYTES_REQUESTED", 200), e.struct("Auth", [
                                        [
                                            "flags",
                                            e.int()
                                        ]
                                    ]), e.enum("IpAddrType", {
                                        iPv4: 0,
                                        iPv6: 1
                                    }), e.union("PeerAddressIp", {
                                        switchOn: e.lookup("IpAddrType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "iPv4",
                                                "ipv4"
                                            ],
                                            [
                                                "iPv6",
                                                "ipv6"
                                            ]
                                        ],
                                        arms: {
                                            ipv4: e.opaque(4),
                                            ipv6: e.opaque(16)
                                        }
                                    }), e.struct("PeerAddress", [
                                        [
                                            "ip",
                                            e.lookup("PeerAddressIp")
                                        ],
                                        [
                                            "port",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "numFailures",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.enum("MessageType", {
                                        errorMsg: 0,
                                        auth: 2,
                                        dontHave: 3,
                                        peers: 5,
                                        getTxSet: 6,
                                        txSet: 7,
                                        generalizedTxSet: 17,
                                        transaction: 8,
                                        getScpQuorumset: 9,
                                        scpQuorumset: 10,
                                        scpMessage: 11,
                                        getScpState: 12,
                                        hello: 13,
                                        sendMore: 16,
                                        sendMoreExtended: 20,
                                        floodAdvert: 18,
                                        floodDemand: 19,
                                        timeSlicedSurveyRequest: 21,
                                        timeSlicedSurveyResponse: 22,
                                        timeSlicedSurveyStartCollecting: 23,
                                        timeSlicedSurveyStopCollecting: 24
                                    }), e.struct("DontHave", [
                                        [
                                            "type",
                                            e.lookup("MessageType")
                                        ],
                                        [
                                            "reqHash",
                                            e.lookup("Uint256")
                                        ]
                                    ]), e.enum("SurveyMessageCommandType", {
                                        timeSlicedSurveyTopology: 1
                                    }), e.enum("SurveyMessageResponseType", {
                                        surveyTopologyResponseV2: 2
                                    }), e.struct("TimeSlicedSurveyStartCollectingMessage", [
                                        [
                                            "surveyorId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ledgerNum",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("SignedTimeSlicedSurveyStartCollectingMessage", [
                                        [
                                            "signature",
                                            e.lookup("Signature")
                                        ],
                                        [
                                            "startCollecting",
                                            e.lookup("TimeSlicedSurveyStartCollectingMessage")
                                        ]
                                    ]), e.struct("TimeSlicedSurveyStopCollectingMessage", [
                                        [
                                            "surveyorId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ledgerNum",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("SignedTimeSlicedSurveyStopCollectingMessage", [
                                        [
                                            "signature",
                                            e.lookup("Signature")
                                        ],
                                        [
                                            "stopCollecting",
                                            e.lookup("TimeSlicedSurveyStopCollectingMessage")
                                        ]
                                    ]), e.struct("SurveyRequestMessage", [
                                        [
                                            "surveyorPeerId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "surveyedPeerId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "ledgerNum",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "encryptionKey",
                                            e.lookup("Curve25519Public")
                                        ],
                                        [
                                            "commandType",
                                            e.lookup("SurveyMessageCommandType")
                                        ]
                                    ]), e.struct("TimeSlicedSurveyRequestMessage", [
                                        [
                                            "request",
                                            e.lookup("SurveyRequestMessage")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "inboundPeersIndex",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "outboundPeersIndex",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("SignedTimeSlicedSurveyRequestMessage", [
                                        [
                                            "requestSignature",
                                            e.lookup("Signature")
                                        ],
                                        [
                                            "request",
                                            e.lookup("TimeSlicedSurveyRequestMessage")
                                        ]
                                    ]), e.typedef("EncryptedBody", e.varOpaque(64e3)), e.struct("SurveyResponseMessage", [
                                        [
                                            "surveyorPeerId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "surveyedPeerId",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "ledgerNum",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "commandType",
                                            e.lookup("SurveyMessageCommandType")
                                        ],
                                        [
                                            "encryptedBody",
                                            e.lookup("EncryptedBody")
                                        ]
                                    ]), e.struct("TimeSlicedSurveyResponseMessage", [
                                        [
                                            "response",
                                            e.lookup("SurveyResponseMessage")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("SignedTimeSlicedSurveyResponseMessage", [
                                        [
                                            "responseSignature",
                                            e.lookup("Signature")
                                        ],
                                        [
                                            "response",
                                            e.lookup("TimeSlicedSurveyResponseMessage")
                                        ]
                                    ]), e.struct("PeerStats", [
                                        [
                                            "id",
                                            e.lookup("NodeId")
                                        ],
                                        [
                                            "versionStr",
                                            e.string(100)
                                        ],
                                        [
                                            "messagesRead",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "messagesWritten",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "bytesRead",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "bytesWritten",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "secondsConnected",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "uniqueFloodBytesRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "duplicateFloodBytesRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "uniqueFetchBytesRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "duplicateFetchBytesRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "uniqueFloodMessageRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "duplicateFloodMessageRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "uniqueFetchMessageRecv",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "duplicateFetchMessageRecv",
                                            e.lookup("Uint64")
                                        ]
                                    ]), e.struct("TimeSlicedNodeData", [
                                        [
                                            "addedAuthenticatedPeers",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "droppedAuthenticatedPeers",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "totalInboundPeerCount",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "totalOutboundPeerCount",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "p75ScpFirstToSelfLatencyMs",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "p75ScpSelfToOtherLatencyMs",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "lostSyncCount",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "isValidator",
                                            e.bool()
                                        ],
                                        [
                                            "maxInboundPeerCount",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "maxOutboundPeerCount",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("TimeSlicedPeerData", [
                                        [
                                            "peerStats",
                                            e.lookup("PeerStats")
                                        ],
                                        [
                                            "averageLatencyMs",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.typedef("TimeSlicedPeerDataList", e.varArray(e.lookup("TimeSlicedPeerData"), 25)), e.struct("TopologyResponseBodyV2", [
                                        [
                                            "inboundPeers",
                                            e.lookup("TimeSlicedPeerDataList")
                                        ],
                                        [
                                            "outboundPeers",
                                            e.lookup("TimeSlicedPeerDataList")
                                        ],
                                        [
                                            "nodeData",
                                            e.lookup("TimeSlicedNodeData")
                                        ]
                                    ]), e.union("SurveyResponseBody", {
                                        switchOn: e.lookup("SurveyMessageResponseType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "surveyTopologyResponseV2",
                                                "topologyResponseBodyV2"
                                            ]
                                        ],
                                        arms: {
                                            topologyResponseBodyV2: e.lookup("TopologyResponseBodyV2")
                                        }
                                    }), e.const("TX_ADVERT_VECTOR_MAX_SIZE", 1e3), e.typedef("TxAdvertVector", e.varArray(e.lookup("Hash"), e.lookup("TX_ADVERT_VECTOR_MAX_SIZE"))), e.struct("FloodAdvert", [
                                        [
                                            "txHashes",
                                            e.lookup("TxAdvertVector")
                                        ]
                                    ]), e.const("TX_DEMAND_VECTOR_MAX_SIZE", 1e3), e.typedef("TxDemandVector", e.varArray(e.lookup("Hash"), e.lookup("TX_DEMAND_VECTOR_MAX_SIZE"))), e.struct("FloodDemand", [
                                        [
                                            "txHashes",
                                            e.lookup("TxDemandVector")
                                        ]
                                    ]), e.union("StellarMessage", {
                                        switchOn: e.lookup("MessageType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "errorMsg",
                                                "error"
                                            ],
                                            [
                                                "hello",
                                                "hello"
                                            ],
                                            [
                                                "auth",
                                                "auth"
                                            ],
                                            [
                                                "dontHave",
                                                "dontHave"
                                            ],
                                            [
                                                "peers",
                                                "peers"
                                            ],
                                            [
                                                "getTxSet",
                                                "txSetHash"
                                            ],
                                            [
                                                "txSet",
                                                "txSet"
                                            ],
                                            [
                                                "generalizedTxSet",
                                                "generalizedTxSet"
                                            ],
                                            [
                                                "transaction",
                                                "transaction"
                                            ],
                                            [
                                                "timeSlicedSurveyRequest",
                                                "signedTimeSlicedSurveyRequestMessage"
                                            ],
                                            [
                                                "timeSlicedSurveyResponse",
                                                "signedTimeSlicedSurveyResponseMessage"
                                            ],
                                            [
                                                "timeSlicedSurveyStartCollecting",
                                                "signedTimeSlicedSurveyStartCollectingMessage"
                                            ],
                                            [
                                                "timeSlicedSurveyStopCollecting",
                                                "signedTimeSlicedSurveyStopCollectingMessage"
                                            ],
                                            [
                                                "getScpQuorumset",
                                                "qSetHash"
                                            ],
                                            [
                                                "scpQuorumset",
                                                "qSet"
                                            ],
                                            [
                                                "scpMessage",
                                                "envelope"
                                            ],
                                            [
                                                "getScpState",
                                                "getScpLedgerSeq"
                                            ],
                                            [
                                                "sendMore",
                                                "sendMoreMessage"
                                            ],
                                            [
                                                "sendMoreExtended",
                                                "sendMoreExtendedMessage"
                                            ],
                                            [
                                                "floodAdvert",
                                                "floodAdvert"
                                            ],
                                            [
                                                "floodDemand",
                                                "floodDemand"
                                            ]
                                        ],
                                        arms: {
                                            error: e.lookup("Error"),
                                            hello: e.lookup("Hello"),
                                            auth: e.lookup("Auth"),
                                            dontHave: e.lookup("DontHave"),
                                            peers: e.varArray(e.lookup("PeerAddress"), 100),
                                            txSetHash: e.lookup("Uint256"),
                                            txSet: e.lookup("TransactionSet"),
                                            generalizedTxSet: e.lookup("GeneralizedTransactionSet"),
                                            transaction: e.lookup("TransactionEnvelope"),
                                            signedTimeSlicedSurveyRequestMessage: e.lookup("SignedTimeSlicedSurveyRequestMessage"),
                                            signedTimeSlicedSurveyResponseMessage: e.lookup("SignedTimeSlicedSurveyResponseMessage"),
                                            signedTimeSlicedSurveyStartCollectingMessage: e.lookup("SignedTimeSlicedSurveyStartCollectingMessage"),
                                            signedTimeSlicedSurveyStopCollectingMessage: e.lookup("SignedTimeSlicedSurveyStopCollectingMessage"),
                                            qSetHash: e.lookup("Uint256"),
                                            qSet: e.lookup("ScpQuorumSet"),
                                            envelope: e.lookup("ScpEnvelope"),
                                            getScpLedgerSeq: e.lookup("Uint32"),
                                            sendMoreMessage: e.lookup("SendMore"),
                                            sendMoreExtendedMessage: e.lookup("SendMoreExtended"),
                                            floodAdvert: e.lookup("FloodAdvert"),
                                            floodDemand: e.lookup("FloodDemand")
                                        }
                                    }), e.struct("AuthenticatedMessageV0", [
                                        [
                                            "sequence",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "message",
                                            e.lookup("StellarMessage")
                                        ],
                                        [
                                            "mac",
                                            e.lookup("HmacSha256Mac")
                                        ]
                                    ]), e.union("AuthenticatedMessage", {
                                        switchOn: e.lookup("Uint32"),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                "v0"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("AuthenticatedMessageV0")
                                        }
                                    }), e.const("MAX_OPS_PER_TX", 100), e.union("LiquidityPoolParameters", {
                                        switchOn: e.lookup("LiquidityPoolType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "liquidityPoolConstantProduct",
                                                "constantProduct"
                                            ]
                                        ],
                                        arms: {
                                            constantProduct: e.lookup("LiquidityPoolConstantProductParameters")
                                        }
                                    }), e.struct("MuxedAccountMed25519", [
                                        [
                                            "id",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "ed25519",
                                            e.lookup("Uint256")
                                        ]
                                    ]), e.union("MuxedAccount", {
                                        switchOn: e.lookup("CryptoKeyType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "keyTypeEd25519",
                                                "ed25519"
                                            ],
                                            [
                                                "keyTypeMuxedEd25519",
                                                "med25519"
                                            ]
                                        ],
                                        arms: {
                                            ed25519: e.lookup("Uint256"),
                                            med25519: e.lookup("MuxedAccountMed25519")
                                        }
                                    }), e.struct("DecoratedSignature", [
                                        [
                                            "hint",
                                            e.lookup("SignatureHint")
                                        ],
                                        [
                                            "signature",
                                            e.lookup("Signature")
                                        ]
                                    ]), e.enum("OperationType", {
                                        createAccount: 0,
                                        payment: 1,
                                        pathPaymentStrictReceive: 2,
                                        manageSellOffer: 3,
                                        createPassiveSellOffer: 4,
                                        setOptions: 5,
                                        changeTrust: 6,
                                        allowTrust: 7,
                                        accountMerge: 8,
                                        inflation: 9,
                                        manageData: 10,
                                        bumpSequence: 11,
                                        manageBuyOffer: 12,
                                        pathPaymentStrictSend: 13,
                                        createClaimableBalance: 14,
                                        claimClaimableBalance: 15,
                                        beginSponsoringFutureReserves: 16,
                                        endSponsoringFutureReserves: 17,
                                        revokeSponsorship: 18,
                                        clawback: 19,
                                        clawbackClaimableBalance: 20,
                                        setTrustLineFlags: 21,
                                        liquidityPoolDeposit: 22,
                                        liquidityPoolWithdraw: 23,
                                        invokeHostFunction: 24,
                                        extendFootprintTtl: 25,
                                        restoreFootprint: 26
                                    }), e.struct("CreateAccountOp", [
                                        [
                                            "destination",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "startingBalance",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("PaymentOp", [
                                        [
                                            "destination",
                                            e.lookup("MuxedAccount")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("PathPaymentStrictReceiveOp", [
                                        [
                                            "sendAsset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "sendMax",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "destination",
                                            e.lookup("MuxedAccount")
                                        ],
                                        [
                                            "destAsset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "destAmount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "path",
                                            e.varArray(e.lookup("Asset"), 5)
                                        ]
                                    ]), e.struct("PathPaymentStrictSendOp", [
                                        [
                                            "sendAsset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "sendAmount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "destination",
                                            e.lookup("MuxedAccount")
                                        ],
                                        [
                                            "destAsset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "destMin",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "path",
                                            e.varArray(e.lookup("Asset"), 5)
                                        ]
                                    ]), e.struct("ManageSellOfferOp", [
                                        [
                                            "selling",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "buying",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "price",
                                            e.lookup("Price")
                                        ],
                                        [
                                            "offerId",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ManageBuyOfferOp", [
                                        [
                                            "selling",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "buying",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "buyAmount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "price",
                                            e.lookup("Price")
                                        ],
                                        [
                                            "offerId",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("CreatePassiveSellOfferOp", [
                                        [
                                            "selling",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "buying",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "price",
                                            e.lookup("Price")
                                        ]
                                    ]), e.struct("SetOptionsOp", [
                                        [
                                            "inflationDest",
                                            e.option(e.lookup("AccountId"))
                                        ],
                                        [
                                            "clearFlags",
                                            e.option(e.lookup("Uint32"))
                                        ],
                                        [
                                            "setFlags",
                                            e.option(e.lookup("Uint32"))
                                        ],
                                        [
                                            "masterWeight",
                                            e.option(e.lookup("Uint32"))
                                        ],
                                        [
                                            "lowThreshold",
                                            e.option(e.lookup("Uint32"))
                                        ],
                                        [
                                            "medThreshold",
                                            e.option(e.lookup("Uint32"))
                                        ],
                                        [
                                            "highThreshold",
                                            e.option(e.lookup("Uint32"))
                                        ],
                                        [
                                            "homeDomain",
                                            e.option(e.lookup("String32"))
                                        ],
                                        [
                                            "signer",
                                            e.option(e.lookup("Signer"))
                                        ]
                                    ]), e.union("ChangeTrustAsset", {
                                        switchOn: e.lookup("AssetType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "assetTypeNative",
                                                e.void()
                                            ],
                                            [
                                                "assetTypeCreditAlphanum4",
                                                "alphaNum4"
                                            ],
                                            [
                                                "assetTypeCreditAlphanum12",
                                                "alphaNum12"
                                            ],
                                            [
                                                "assetTypePoolShare",
                                                "liquidityPool"
                                            ]
                                        ],
                                        arms: {
                                            alphaNum4: e.lookup("AlphaNum4"),
                                            alphaNum12: e.lookup("AlphaNum12"),
                                            liquidityPool: e.lookup("LiquidityPoolParameters")
                                        }
                                    }), e.struct("ChangeTrustOp", [
                                        [
                                            "line",
                                            e.lookup("ChangeTrustAsset")
                                        ],
                                        [
                                            "limit",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("AllowTrustOp", [
                                        [
                                            "trustor",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("AssetCode")
                                        ],
                                        [
                                            "authorize",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ManageDataOp", [
                                        [
                                            "dataName",
                                            e.lookup("String64")
                                        ],
                                        [
                                            "dataValue",
                                            e.option(e.lookup("DataValue"))
                                        ]
                                    ]), e.struct("BumpSequenceOp", [
                                        [
                                            "bumpTo",
                                            e.lookup("SequenceNumber")
                                        ]
                                    ]), e.struct("CreateClaimableBalanceOp", [
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "claimants",
                                            e.varArray(e.lookup("Claimant"), 10)
                                        ]
                                    ]), e.struct("ClaimClaimableBalanceOp", [
                                        [
                                            "balanceId",
                                            e.lookup("ClaimableBalanceId")
                                        ]
                                    ]), e.struct("BeginSponsoringFutureReservesOp", [
                                        [
                                            "sponsoredId",
                                            e.lookup("AccountId")
                                        ]
                                    ]), e.enum("RevokeSponsorshipType", {
                                        revokeSponsorshipLedgerEntry: 0,
                                        revokeSponsorshipSigner: 1
                                    }), e.struct("RevokeSponsorshipOpSigner", [
                                        [
                                            "accountId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "signerKey",
                                            e.lookup("SignerKey")
                                        ]
                                    ]), e.union("RevokeSponsorshipOp", {
                                        switchOn: e.lookup("RevokeSponsorshipType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "revokeSponsorshipLedgerEntry",
                                                "ledgerKey"
                                            ],
                                            [
                                                "revokeSponsorshipSigner",
                                                "signer"
                                            ]
                                        ],
                                        arms: {
                                            ledgerKey: e.lookup("LedgerKey"),
                                            signer: e.lookup("RevokeSponsorshipOpSigner")
                                        }
                                    }), e.struct("ClawbackOp", [
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "from",
                                            e.lookup("MuxedAccount")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ClawbackClaimableBalanceOp", [
                                        [
                                            "balanceId",
                                            e.lookup("ClaimableBalanceId")
                                        ]
                                    ]), e.struct("SetTrustLineFlagsOp", [
                                        [
                                            "trustor",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "clearFlags",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "setFlags",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.const("LIQUIDITY_POOL_FEE_V18", 30), e.struct("LiquidityPoolDepositOp", [
                                        [
                                            "liquidityPoolId",
                                            e.lookup("PoolId")
                                        ],
                                        [
                                            "maxAmountA",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "maxAmountB",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "minPrice",
                                            e.lookup("Price")
                                        ],
                                        [
                                            "maxPrice",
                                            e.lookup("Price")
                                        ]
                                    ]), e.struct("LiquidityPoolWithdrawOp", [
                                        [
                                            "liquidityPoolId",
                                            e.lookup("PoolId")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "minAmountA",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "minAmountB",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.enum("HostFunctionType", {
                                        hostFunctionTypeInvokeContract: 0,
                                        hostFunctionTypeCreateContract: 1,
                                        hostFunctionTypeUploadContractWasm: 2,
                                        hostFunctionTypeCreateContractV2: 3
                                    }), e.enum("ContractIdPreimageType", {
                                        contractIdPreimageFromAddress: 0,
                                        contractIdPreimageFromAsset: 1
                                    }), e.struct("ContractIdPreimageFromAddress", [
                                        [
                                            "address",
                                            e.lookup("ScAddress")
                                        ],
                                        [
                                            "salt",
                                            e.lookup("Uint256")
                                        ]
                                    ]), e.union("ContractIdPreimage", {
                                        switchOn: e.lookup("ContractIdPreimageType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "contractIdPreimageFromAddress",
                                                "fromAddress"
                                            ],
                                            [
                                                "contractIdPreimageFromAsset",
                                                "fromAsset"
                                            ]
                                        ],
                                        arms: {
                                            fromAddress: e.lookup("ContractIdPreimageFromAddress"),
                                            fromAsset: e.lookup("Asset")
                                        }
                                    }), e.struct("CreateContractArgs", [
                                        [
                                            "contractIdPreimage",
                                            e.lookup("ContractIdPreimage")
                                        ],
                                        [
                                            "executable",
                                            e.lookup("ContractExecutable")
                                        ]
                                    ]), e.struct("CreateContractArgsV2", [
                                        [
                                            "contractIdPreimage",
                                            e.lookup("ContractIdPreimage")
                                        ],
                                        [
                                            "executable",
                                            e.lookup("ContractExecutable")
                                        ],
                                        [
                                            "constructorArgs",
                                            e.varArray(e.lookup("ScVal"), 2147483647)
                                        ]
                                    ]), e.struct("InvokeContractArgs", [
                                        [
                                            "contractAddress",
                                            e.lookup("ScAddress")
                                        ],
                                        [
                                            "functionName",
                                            e.lookup("ScSymbol")
                                        ],
                                        [
                                            "args",
                                            e.varArray(e.lookup("ScVal"), 2147483647)
                                        ]
                                    ]), e.union("HostFunction", {
                                        switchOn: e.lookup("HostFunctionType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "hostFunctionTypeInvokeContract",
                                                "invokeContract"
                                            ],
                                            [
                                                "hostFunctionTypeCreateContract",
                                                "createContract"
                                            ],
                                            [
                                                "hostFunctionTypeUploadContractWasm",
                                                "wasm"
                                            ],
                                            [
                                                "hostFunctionTypeCreateContractV2",
                                                "createContractV2"
                                            ]
                                        ],
                                        arms: {
                                            invokeContract: e.lookup("InvokeContractArgs"),
                                            createContract: e.lookup("CreateContractArgs"),
                                            wasm: e.varOpaque(),
                                            createContractV2: e.lookup("CreateContractArgsV2")
                                        }
                                    }), e.enum("SorobanAuthorizedFunctionType", {
                                        sorobanAuthorizedFunctionTypeContractFn: 0,
                                        sorobanAuthorizedFunctionTypeCreateContractHostFn: 1,
                                        sorobanAuthorizedFunctionTypeCreateContractV2HostFn: 2
                                    }), e.union("SorobanAuthorizedFunction", {
                                        switchOn: e.lookup("SorobanAuthorizedFunctionType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "sorobanAuthorizedFunctionTypeContractFn",
                                                "contractFn"
                                            ],
                                            [
                                                "sorobanAuthorizedFunctionTypeCreateContractHostFn",
                                                "createContractHostFn"
                                            ],
                                            [
                                                "sorobanAuthorizedFunctionTypeCreateContractV2HostFn",
                                                "createContractV2HostFn"
                                            ]
                                        ],
                                        arms: {
                                            contractFn: e.lookup("InvokeContractArgs"),
                                            createContractHostFn: e.lookup("CreateContractArgs"),
                                            createContractV2HostFn: e.lookup("CreateContractArgsV2")
                                        }
                                    }), e.struct("SorobanAuthorizedInvocation", [
                                        [
                                            "function",
                                            e.lookup("SorobanAuthorizedFunction")
                                        ],
                                        [
                                            "subInvocations",
                                            e.varArray(e.lookup("SorobanAuthorizedInvocation"), 2147483647)
                                        ]
                                    ]), e.struct("SorobanAddressCredentials", [
                                        [
                                            "address",
                                            e.lookup("ScAddress")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "signatureExpirationLedger",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "signature",
                                            e.lookup("ScVal")
                                        ]
                                    ]), e.enum("SorobanCredentialsType", {
                                        sorobanCredentialsSourceAccount: 0,
                                        sorobanCredentialsAddress: 1
                                    }), e.union("SorobanCredentials", {
                                        switchOn: e.lookup("SorobanCredentialsType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "sorobanCredentialsSourceAccount",
                                                e.void()
                                            ],
                                            [
                                                "sorobanCredentialsAddress",
                                                "address"
                                            ]
                                        ],
                                        arms: {
                                            address: e.lookup("SorobanAddressCredentials")
                                        }
                                    }), e.struct("SorobanAuthorizationEntry", [
                                        [
                                            "credentials",
                                            e.lookup("SorobanCredentials")
                                        ],
                                        [
                                            "rootInvocation",
                                            e.lookup("SorobanAuthorizedInvocation")
                                        ]
                                    ]), e.typedef("SorobanAuthorizationEntries", e.varArray(e.lookup("SorobanAuthorizationEntry"), 2147483647)), e.struct("InvokeHostFunctionOp", [
                                        [
                                            "hostFunction",
                                            e.lookup("HostFunction")
                                        ],
                                        [
                                            "auth",
                                            e.varArray(e.lookup("SorobanAuthorizationEntry"), 2147483647)
                                        ]
                                    ]), e.struct("ExtendFootprintTtlOp", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "extendTo",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("RestoreFootprintOp", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ]
                                    ]), e.union("OperationBody", {
                                        switchOn: e.lookup("OperationType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "createAccount",
                                                "createAccountOp"
                                            ],
                                            [
                                                "payment",
                                                "paymentOp"
                                            ],
                                            [
                                                "pathPaymentStrictReceive",
                                                "pathPaymentStrictReceiveOp"
                                            ],
                                            [
                                                "manageSellOffer",
                                                "manageSellOfferOp"
                                            ],
                                            [
                                                "createPassiveSellOffer",
                                                "createPassiveSellOfferOp"
                                            ],
                                            [
                                                "setOptions",
                                                "setOptionsOp"
                                            ],
                                            [
                                                "changeTrust",
                                                "changeTrustOp"
                                            ],
                                            [
                                                "allowTrust",
                                                "allowTrustOp"
                                            ],
                                            [
                                                "accountMerge",
                                                "destination"
                                            ],
                                            [
                                                "inflation",
                                                e.void()
                                            ],
                                            [
                                                "manageData",
                                                "manageDataOp"
                                            ],
                                            [
                                                "bumpSequence",
                                                "bumpSequenceOp"
                                            ],
                                            [
                                                "manageBuyOffer",
                                                "manageBuyOfferOp"
                                            ],
                                            [
                                                "pathPaymentStrictSend",
                                                "pathPaymentStrictSendOp"
                                            ],
                                            [
                                                "createClaimableBalance",
                                                "createClaimableBalanceOp"
                                            ],
                                            [
                                                "claimClaimableBalance",
                                                "claimClaimableBalanceOp"
                                            ],
                                            [
                                                "beginSponsoringFutureReserves",
                                                "beginSponsoringFutureReservesOp"
                                            ],
                                            [
                                                "endSponsoringFutureReserves",
                                                e.void()
                                            ],
                                            [
                                                "revokeSponsorship",
                                                "revokeSponsorshipOp"
                                            ],
                                            [
                                                "clawback",
                                                "clawbackOp"
                                            ],
                                            [
                                                "clawbackClaimableBalance",
                                                "clawbackClaimableBalanceOp"
                                            ],
                                            [
                                                "setTrustLineFlags",
                                                "setTrustLineFlagsOp"
                                            ],
                                            [
                                                "liquidityPoolDeposit",
                                                "liquidityPoolDepositOp"
                                            ],
                                            [
                                                "liquidityPoolWithdraw",
                                                "liquidityPoolWithdrawOp"
                                            ],
                                            [
                                                "invokeHostFunction",
                                                "invokeHostFunctionOp"
                                            ],
                                            [
                                                "extendFootprintTtl",
                                                "extendFootprintTtlOp"
                                            ],
                                            [
                                                "restoreFootprint",
                                                "restoreFootprintOp"
                                            ]
                                        ],
                                        arms: {
                                            createAccountOp: e.lookup("CreateAccountOp"),
                                            paymentOp: e.lookup("PaymentOp"),
                                            pathPaymentStrictReceiveOp: e.lookup("PathPaymentStrictReceiveOp"),
                                            manageSellOfferOp: e.lookup("ManageSellOfferOp"),
                                            createPassiveSellOfferOp: e.lookup("CreatePassiveSellOfferOp"),
                                            setOptionsOp: e.lookup("SetOptionsOp"),
                                            changeTrustOp: e.lookup("ChangeTrustOp"),
                                            allowTrustOp: e.lookup("AllowTrustOp"),
                                            destination: e.lookup("MuxedAccount"),
                                            manageDataOp: e.lookup("ManageDataOp"),
                                            bumpSequenceOp: e.lookup("BumpSequenceOp"),
                                            manageBuyOfferOp: e.lookup("ManageBuyOfferOp"),
                                            pathPaymentStrictSendOp: e.lookup("PathPaymentStrictSendOp"),
                                            createClaimableBalanceOp: e.lookup("CreateClaimableBalanceOp"),
                                            claimClaimableBalanceOp: e.lookup("ClaimClaimableBalanceOp"),
                                            beginSponsoringFutureReservesOp: e.lookup("BeginSponsoringFutureReservesOp"),
                                            revokeSponsorshipOp: e.lookup("RevokeSponsorshipOp"),
                                            clawbackOp: e.lookup("ClawbackOp"),
                                            clawbackClaimableBalanceOp: e.lookup("ClawbackClaimableBalanceOp"),
                                            setTrustLineFlagsOp: e.lookup("SetTrustLineFlagsOp"),
                                            liquidityPoolDepositOp: e.lookup("LiquidityPoolDepositOp"),
                                            liquidityPoolWithdrawOp: e.lookup("LiquidityPoolWithdrawOp"),
                                            invokeHostFunctionOp: e.lookup("InvokeHostFunctionOp"),
                                            extendFootprintTtlOp: e.lookup("ExtendFootprintTtlOp"),
                                            restoreFootprintOp: e.lookup("RestoreFootprintOp")
                                        }
                                    }), e.struct("Operation", [
                                        [
                                            "sourceAccount",
                                            e.option(e.lookup("MuxedAccount"))
                                        ],
                                        [
                                            "body",
                                            e.lookup("OperationBody")
                                        ]
                                    ]), e.struct("HashIdPreimageOperationId", [
                                        [
                                            "sourceAccount",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "seqNum",
                                            e.lookup("SequenceNumber")
                                        ],
                                        [
                                            "opNum",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("HashIdPreimageRevokeId", [
                                        [
                                            "sourceAccount",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "seqNum",
                                            e.lookup("SequenceNumber")
                                        ],
                                        [
                                            "opNum",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "liquidityPoolId",
                                            e.lookup("PoolId")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ]
                                    ]), e.struct("HashIdPreimageContractId", [
                                        [
                                            "networkId",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "contractIdPreimage",
                                            e.lookup("ContractIdPreimage")
                                        ]
                                    ]), e.struct("HashIdPreimageSorobanAuthorization", [
                                        [
                                            "networkId",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "nonce",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "signatureExpirationLedger",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "invocation",
                                            e.lookup("SorobanAuthorizedInvocation")
                                        ]
                                    ]), e.union("HashIdPreimage", {
                                        switchOn: e.lookup("EnvelopeType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "envelopeTypeOpId",
                                                "operationId"
                                            ],
                                            [
                                                "envelopeTypePoolRevokeOpId",
                                                "revokeId"
                                            ],
                                            [
                                                "envelopeTypeContractId",
                                                "contractId"
                                            ],
                                            [
                                                "envelopeTypeSorobanAuthorization",
                                                "sorobanAuthorization"
                                            ]
                                        ],
                                        arms: {
                                            operationId: e.lookup("HashIdPreimageOperationId"),
                                            revokeId: e.lookup("HashIdPreimageRevokeId"),
                                            contractId: e.lookup("HashIdPreimageContractId"),
                                            sorobanAuthorization: e.lookup("HashIdPreimageSorobanAuthorization")
                                        }
                                    }), e.enum("MemoType", {
                                        memoNone: 0,
                                        memoText: 1,
                                        memoId: 2,
                                        memoHash: 3,
                                        memoReturn: 4
                                    }), e.union("Memo", {
                                        switchOn: e.lookup("MemoType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "memoNone",
                                                e.void()
                                            ],
                                            [
                                                "memoText",
                                                "text"
                                            ],
                                            [
                                                "memoId",
                                                "id"
                                            ],
                                            [
                                                "memoHash",
                                                "hash"
                                            ],
                                            [
                                                "memoReturn",
                                                "retHash"
                                            ]
                                        ],
                                        arms: {
                                            text: e.string(28),
                                            id: e.lookup("Uint64"),
                                            hash: e.lookup("Hash"),
                                            retHash: e.lookup("Hash")
                                        }
                                    }), e.struct("TimeBounds", [
                                        [
                                            "minTime",
                                            e.lookup("TimePoint")
                                        ],
                                        [
                                            "maxTime",
                                            e.lookup("TimePoint")
                                        ]
                                    ]), e.struct("LedgerBounds", [
                                        [
                                            "minLedger",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "maxLedger",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("PreconditionsV2", [
                                        [
                                            "timeBounds",
                                            e.option(e.lookup("TimeBounds"))
                                        ],
                                        [
                                            "ledgerBounds",
                                            e.option(e.lookup("LedgerBounds"))
                                        ],
                                        [
                                            "minSeqNum",
                                            e.option(e.lookup("SequenceNumber"))
                                        ],
                                        [
                                            "minSeqAge",
                                            e.lookup("Duration")
                                        ],
                                        [
                                            "minSeqLedgerGap",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "extraSigners",
                                            e.varArray(e.lookup("SignerKey"), 2)
                                        ]
                                    ]), e.enum("PreconditionType", {
                                        precondNone: 0,
                                        precondTime: 1,
                                        precondV2: 2
                                    }), e.union("Preconditions", {
                                        switchOn: e.lookup("PreconditionType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "precondNone",
                                                e.void()
                                            ],
                                            [
                                                "precondTime",
                                                "timeBounds"
                                            ],
                                            [
                                                "precondV2",
                                                "v2"
                                            ]
                                        ],
                                        arms: {
                                            timeBounds: e.lookup("TimeBounds"),
                                            v2: e.lookup("PreconditionsV2")
                                        }
                                    }), e.struct("LedgerFootprint", [
                                        [
                                            "readOnly",
                                            e.varArray(e.lookup("LedgerKey"), 2147483647)
                                        ],
                                        [
                                            "readWrite",
                                            e.varArray(e.lookup("LedgerKey"), 2147483647)
                                        ]
                                    ]), e.struct("SorobanResources", [
                                        [
                                            "footprint",
                                            e.lookup("LedgerFootprint")
                                        ],
                                        [
                                            "instructions",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "diskReadBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "writeBytes",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("SorobanResourcesExtV0", [
                                        [
                                            "archivedSorobanEntries",
                                            e.varArray(e.lookup("Uint32"), 2147483647)
                                        ]
                                    ]), e.union("SorobanTransactionDataExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "resourceExt"
                                            ]
                                        ],
                                        arms: {
                                            resourceExt: e.lookup("SorobanResourcesExtV0")
                                        }
                                    }), e.struct("SorobanTransactionData", [
                                        [
                                            "ext",
                                            e.lookup("SorobanTransactionDataExt")
                                        ],
                                        [
                                            "resources",
                                            e.lookup("SorobanResources")
                                        ],
                                        [
                                            "resourceFee",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.union("TransactionV0Ext", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("TransactionV0", [
                                        [
                                            "sourceAccountEd25519",
                                            e.lookup("Uint256")
                                        ],
                                        [
                                            "fee",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "seqNum",
                                            e.lookup("SequenceNumber")
                                        ],
                                        [
                                            "timeBounds",
                                            e.option(e.lookup("TimeBounds"))
                                        ],
                                        [
                                            "memo",
                                            e.lookup("Memo")
                                        ],
                                        [
                                            "operations",
                                            e.varArray(e.lookup("Operation"), e.lookup("MAX_OPS_PER_TX"))
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TransactionV0Ext")
                                        ]
                                    ]), e.struct("TransactionV0Envelope", [
                                        [
                                            "tx",
                                            e.lookup("TransactionV0")
                                        ],
                                        [
                                            "signatures",
                                            e.varArray(e.lookup("DecoratedSignature"), 20)
                                        ]
                                    ]), e.union("TransactionExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ],
                                            [
                                                1,
                                                "sorobanData"
                                            ]
                                        ],
                                        arms: {
                                            sorobanData: e.lookup("SorobanTransactionData")
                                        }
                                    }), e.struct("Transaction", [
                                        [
                                            "sourceAccount",
                                            e.lookup("MuxedAccount")
                                        ],
                                        [
                                            "fee",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "seqNum",
                                            e.lookup("SequenceNumber")
                                        ],
                                        [
                                            "cond",
                                            e.lookup("Preconditions")
                                        ],
                                        [
                                            "memo",
                                            e.lookup("Memo")
                                        ],
                                        [
                                            "operations",
                                            e.varArray(e.lookup("Operation"), e.lookup("MAX_OPS_PER_TX"))
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TransactionExt")
                                        ]
                                    ]), e.struct("TransactionV1Envelope", [
                                        [
                                            "tx",
                                            e.lookup("Transaction")
                                        ],
                                        [
                                            "signatures",
                                            e.varArray(e.lookup("DecoratedSignature"), 20)
                                        ]
                                    ]), e.union("FeeBumpTransactionInnerTx", {
                                        switchOn: e.lookup("EnvelopeType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "envelopeTypeTx",
                                                "v1"
                                            ]
                                        ],
                                        arms: {
                                            v1: e.lookup("TransactionV1Envelope")
                                        }
                                    }), e.union("FeeBumpTransactionExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("FeeBumpTransaction", [
                                        [
                                            "feeSource",
                                            e.lookup("MuxedAccount")
                                        ],
                                        [
                                            "fee",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "innerTx",
                                            e.lookup("FeeBumpTransactionInnerTx")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("FeeBumpTransactionExt")
                                        ]
                                    ]), e.struct("FeeBumpTransactionEnvelope", [
                                        [
                                            "tx",
                                            e.lookup("FeeBumpTransaction")
                                        ],
                                        [
                                            "signatures",
                                            e.varArray(e.lookup("DecoratedSignature"), 20)
                                        ]
                                    ]), e.union("TransactionEnvelope", {
                                        switchOn: e.lookup("EnvelopeType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "envelopeTypeTxV0",
                                                "v0"
                                            ],
                                            [
                                                "envelopeTypeTx",
                                                "v1"
                                            ],
                                            [
                                                "envelopeTypeTxFeeBump",
                                                "feeBump"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("TransactionV0Envelope"),
                                            v1: e.lookup("TransactionV1Envelope"),
                                            feeBump: e.lookup("FeeBumpTransactionEnvelope")
                                        }
                                    }), e.union("TransactionSignaturePayloadTaggedTransaction", {
                                        switchOn: e.lookup("EnvelopeType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "envelopeTypeTx",
                                                "tx"
                                            ],
                                            [
                                                "envelopeTypeTxFeeBump",
                                                "feeBump"
                                            ]
                                        ],
                                        arms: {
                                            tx: e.lookup("Transaction"),
                                            feeBump: e.lookup("FeeBumpTransaction")
                                        }
                                    }), e.struct("TransactionSignaturePayload", [
                                        [
                                            "networkId",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "taggedTransaction",
                                            e.lookup("TransactionSignaturePayloadTaggedTransaction")
                                        ]
                                    ]), e.enum("ClaimAtomType", {
                                        claimAtomTypeV0: 0,
                                        claimAtomTypeOrderBook: 1,
                                        claimAtomTypeLiquidityPool: 2
                                    }), e.struct("ClaimOfferAtomV0", [
                                        [
                                            "sellerEd25519",
                                            e.lookup("Uint256")
                                        ],
                                        [
                                            "offerId",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "assetSold",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amountSold",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "assetBought",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amountBought",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ClaimOfferAtom", [
                                        [
                                            "sellerId",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "offerId",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "assetSold",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amountSold",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "assetBought",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amountBought",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ClaimLiquidityAtom", [
                                        [
                                            "liquidityPoolId",
                                            e.lookup("PoolId")
                                        ],
                                        [
                                            "assetSold",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amountSold",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "assetBought",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amountBought",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.union("ClaimAtom", {
                                        switchOn: e.lookup("ClaimAtomType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "claimAtomTypeV0",
                                                "v0"
                                            ],
                                            [
                                                "claimAtomTypeOrderBook",
                                                "orderBook"
                                            ],
                                            [
                                                "claimAtomTypeLiquidityPool",
                                                "liquidityPool"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("ClaimOfferAtomV0"),
                                            orderBook: e.lookup("ClaimOfferAtom"),
                                            liquidityPool: e.lookup("ClaimLiquidityAtom")
                                        }
                                    }), e.enum("CreateAccountResultCode", {
                                        createAccountSuccess: 0,
                                        createAccountMalformed: -1,
                                        createAccountUnderfunded: -2,
                                        createAccountLowReserve: -3,
                                        createAccountAlreadyExist: -4
                                    }), e.union("CreateAccountResult", {
                                        switchOn: e.lookup("CreateAccountResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "createAccountSuccess",
                                                e.void()
                                            ],
                                            [
                                                "createAccountMalformed",
                                                e.void()
                                            ],
                                            [
                                                "createAccountUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "createAccountLowReserve",
                                                e.void()
                                            ],
                                            [
                                                "createAccountAlreadyExist",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("PaymentResultCode", {
                                        paymentSuccess: 0,
                                        paymentMalformed: -1,
                                        paymentUnderfunded: -2,
                                        paymentSrcNoTrust: -3,
                                        paymentSrcNotAuthorized: -4,
                                        paymentNoDestination: -5,
                                        paymentNoTrust: -6,
                                        paymentNotAuthorized: -7,
                                        paymentLineFull: -8,
                                        paymentNoIssuer: -9
                                    }), e.union("PaymentResult", {
                                        switchOn: e.lookup("PaymentResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "paymentSuccess",
                                                e.void()
                                            ],
                                            [
                                                "paymentMalformed",
                                                e.void()
                                            ],
                                            [
                                                "paymentUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "paymentSrcNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "paymentSrcNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "paymentNoDestination",
                                                e.void()
                                            ],
                                            [
                                                "paymentNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "paymentNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "paymentLineFull",
                                                e.void()
                                            ],
                                            [
                                                "paymentNoIssuer",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("PathPaymentStrictReceiveResultCode", {
                                        pathPaymentStrictReceiveSuccess: 0,
                                        pathPaymentStrictReceiveMalformed: -1,
                                        pathPaymentStrictReceiveUnderfunded: -2,
                                        pathPaymentStrictReceiveSrcNoTrust: -3,
                                        pathPaymentStrictReceiveSrcNotAuthorized: -4,
                                        pathPaymentStrictReceiveNoDestination: -5,
                                        pathPaymentStrictReceiveNoTrust: -6,
                                        pathPaymentStrictReceiveNotAuthorized: -7,
                                        pathPaymentStrictReceiveLineFull: -8,
                                        pathPaymentStrictReceiveNoIssuer: -9,
                                        pathPaymentStrictReceiveTooFewOffers: -10,
                                        pathPaymentStrictReceiveOfferCrossSelf: -11,
                                        pathPaymentStrictReceiveOverSendmax: -12
                                    }), e.struct("SimplePaymentResult", [
                                        [
                                            "destination",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "asset",
                                            e.lookup("Asset")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("PathPaymentStrictReceiveResultSuccess", [
                                        [
                                            "offers",
                                            e.varArray(e.lookup("ClaimAtom"), 2147483647)
                                        ],
                                        [
                                            "last",
                                            e.lookup("SimplePaymentResult")
                                        ]
                                    ]), e.union("PathPaymentStrictReceiveResult", {
                                        switchOn: e.lookup("PathPaymentStrictReceiveResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "pathPaymentStrictReceiveSuccess",
                                                "success"
                                            ],
                                            [
                                                "pathPaymentStrictReceiveMalformed",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveSrcNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveSrcNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveNoDestination",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveLineFull",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveNoIssuer",
                                                "noIssuer"
                                            ],
                                            [
                                                "pathPaymentStrictReceiveTooFewOffers",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveOfferCrossSelf",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictReceiveOverSendmax",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            success: e.lookup("PathPaymentStrictReceiveResultSuccess"),
                                            noIssuer: e.lookup("Asset")
                                        }
                                    }), e.enum("PathPaymentStrictSendResultCode", {
                                        pathPaymentStrictSendSuccess: 0,
                                        pathPaymentStrictSendMalformed: -1,
                                        pathPaymentStrictSendUnderfunded: -2,
                                        pathPaymentStrictSendSrcNoTrust: -3,
                                        pathPaymentStrictSendSrcNotAuthorized: -4,
                                        pathPaymentStrictSendNoDestination: -5,
                                        pathPaymentStrictSendNoTrust: -6,
                                        pathPaymentStrictSendNotAuthorized: -7,
                                        pathPaymentStrictSendLineFull: -8,
                                        pathPaymentStrictSendNoIssuer: -9,
                                        pathPaymentStrictSendTooFewOffers: -10,
                                        pathPaymentStrictSendOfferCrossSelf: -11,
                                        pathPaymentStrictSendUnderDestmin: -12
                                    }), e.struct("PathPaymentStrictSendResultSuccess", [
                                        [
                                            "offers",
                                            e.varArray(e.lookup("ClaimAtom"), 2147483647)
                                        ],
                                        [
                                            "last",
                                            e.lookup("SimplePaymentResult")
                                        ]
                                    ]), e.union("PathPaymentStrictSendResult", {
                                        switchOn: e.lookup("PathPaymentStrictSendResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "pathPaymentStrictSendSuccess",
                                                "success"
                                            ],
                                            [
                                                "pathPaymentStrictSendMalformed",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendSrcNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendSrcNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendNoDestination",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendLineFull",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendNoIssuer",
                                                "noIssuer"
                                            ],
                                            [
                                                "pathPaymentStrictSendTooFewOffers",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendOfferCrossSelf",
                                                e.void()
                                            ],
                                            [
                                                "pathPaymentStrictSendUnderDestmin",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            success: e.lookup("PathPaymentStrictSendResultSuccess"),
                                            noIssuer: e.lookup("Asset")
                                        }
                                    }), e.enum("ManageSellOfferResultCode", {
                                        manageSellOfferSuccess: 0,
                                        manageSellOfferMalformed: -1,
                                        manageSellOfferSellNoTrust: -2,
                                        manageSellOfferBuyNoTrust: -3,
                                        manageSellOfferSellNotAuthorized: -4,
                                        manageSellOfferBuyNotAuthorized: -5,
                                        manageSellOfferLineFull: -6,
                                        manageSellOfferUnderfunded: -7,
                                        manageSellOfferCrossSelf: -8,
                                        manageSellOfferSellNoIssuer: -9,
                                        manageSellOfferBuyNoIssuer: -10,
                                        manageSellOfferNotFound: -11,
                                        manageSellOfferLowReserve: -12
                                    }), e.enum("ManageOfferEffect", {
                                        manageOfferCreated: 0,
                                        manageOfferUpdated: 1,
                                        manageOfferDeleted: 2
                                    }), e.union("ManageOfferSuccessResultOffer", {
                                        switchOn: e.lookup("ManageOfferEffect"),
                                        switchName: "effect",
                                        switches: [
                                            [
                                                "manageOfferCreated",
                                                "offer"
                                            ],
                                            [
                                                "manageOfferUpdated",
                                                "offer"
                                            ],
                                            [
                                                "manageOfferDeleted",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            offer: e.lookup("OfferEntry")
                                        }
                                    }), e.struct("ManageOfferSuccessResult", [
                                        [
                                            "offersClaimed",
                                            e.varArray(e.lookup("ClaimAtom"), 2147483647)
                                        ],
                                        [
                                            "offer",
                                            e.lookup("ManageOfferSuccessResultOffer")
                                        ]
                                    ]), e.union("ManageSellOfferResult", {
                                        switchOn: e.lookup("ManageSellOfferResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "manageSellOfferSuccess",
                                                "success"
                                            ],
                                            [
                                                "manageSellOfferMalformed",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferSellNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferBuyNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferSellNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferBuyNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferLineFull",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferCrossSelf",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferSellNoIssuer",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferBuyNoIssuer",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferNotFound",
                                                e.void()
                                            ],
                                            [
                                                "manageSellOfferLowReserve",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            success: e.lookup("ManageOfferSuccessResult")
                                        }
                                    }), e.enum("ManageBuyOfferResultCode", {
                                        manageBuyOfferSuccess: 0,
                                        manageBuyOfferMalformed: -1,
                                        manageBuyOfferSellNoTrust: -2,
                                        manageBuyOfferBuyNoTrust: -3,
                                        manageBuyOfferSellNotAuthorized: -4,
                                        manageBuyOfferBuyNotAuthorized: -5,
                                        manageBuyOfferLineFull: -6,
                                        manageBuyOfferUnderfunded: -7,
                                        manageBuyOfferCrossSelf: -8,
                                        manageBuyOfferSellNoIssuer: -9,
                                        manageBuyOfferBuyNoIssuer: -10,
                                        manageBuyOfferNotFound: -11,
                                        manageBuyOfferLowReserve: -12
                                    }), e.union("ManageBuyOfferResult", {
                                        switchOn: e.lookup("ManageBuyOfferResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "manageBuyOfferSuccess",
                                                "success"
                                            ],
                                            [
                                                "manageBuyOfferMalformed",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferSellNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferBuyNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferSellNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferBuyNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferLineFull",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferCrossSelf",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferSellNoIssuer",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferBuyNoIssuer",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferNotFound",
                                                e.void()
                                            ],
                                            [
                                                "manageBuyOfferLowReserve",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            success: e.lookup("ManageOfferSuccessResult")
                                        }
                                    }), e.enum("SetOptionsResultCode", {
                                        setOptionsSuccess: 0,
                                        setOptionsLowReserve: -1,
                                        setOptionsTooManySigners: -2,
                                        setOptionsBadFlags: -3,
                                        setOptionsInvalidInflation: -4,
                                        setOptionsCantChange: -5,
                                        setOptionsUnknownFlag: -6,
                                        setOptionsThresholdOutOfRange: -7,
                                        setOptionsBadSigner: -8,
                                        setOptionsInvalidHomeDomain: -9,
                                        setOptionsAuthRevocableRequired: -10
                                    }), e.union("SetOptionsResult", {
                                        switchOn: e.lookup("SetOptionsResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "setOptionsSuccess",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsLowReserve",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsTooManySigners",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsBadFlags",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsInvalidInflation",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsCantChange",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsUnknownFlag",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsThresholdOutOfRange",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsBadSigner",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsInvalidHomeDomain",
                                                e.void()
                                            ],
                                            [
                                                "setOptionsAuthRevocableRequired",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("ChangeTrustResultCode", {
                                        changeTrustSuccess: 0,
                                        changeTrustMalformed: -1,
                                        changeTrustNoIssuer: -2,
                                        changeTrustInvalidLimit: -3,
                                        changeTrustLowReserve: -4,
                                        changeTrustSelfNotAllowed: -5,
                                        changeTrustTrustLineMissing: -6,
                                        changeTrustCannotDelete: -7,
                                        changeTrustNotAuthMaintainLiabilities: -8
                                    }), e.union("ChangeTrustResult", {
                                        switchOn: e.lookup("ChangeTrustResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "changeTrustSuccess",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustMalformed",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustNoIssuer",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustInvalidLimit",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustLowReserve",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustSelfNotAllowed",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustTrustLineMissing",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustCannotDelete",
                                                e.void()
                                            ],
                                            [
                                                "changeTrustNotAuthMaintainLiabilities",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("AllowTrustResultCode", {
                                        allowTrustSuccess: 0,
                                        allowTrustMalformed: -1,
                                        allowTrustNoTrustLine: -2,
                                        allowTrustTrustNotRequired: -3,
                                        allowTrustCantRevoke: -4,
                                        allowTrustSelfNotAllowed: -5,
                                        allowTrustLowReserve: -6
                                    }), e.union("AllowTrustResult", {
                                        switchOn: e.lookup("AllowTrustResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "allowTrustSuccess",
                                                e.void()
                                            ],
                                            [
                                                "allowTrustMalformed",
                                                e.void()
                                            ],
                                            [
                                                "allowTrustNoTrustLine",
                                                e.void()
                                            ],
                                            [
                                                "allowTrustTrustNotRequired",
                                                e.void()
                                            ],
                                            [
                                                "allowTrustCantRevoke",
                                                e.void()
                                            ],
                                            [
                                                "allowTrustSelfNotAllowed",
                                                e.void()
                                            ],
                                            [
                                                "allowTrustLowReserve",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("AccountMergeResultCode", {
                                        accountMergeSuccess: 0,
                                        accountMergeMalformed: -1,
                                        accountMergeNoAccount: -2,
                                        accountMergeImmutableSet: -3,
                                        accountMergeHasSubEntries: -4,
                                        accountMergeSeqnumTooFar: -5,
                                        accountMergeDestFull: -6,
                                        accountMergeIsSponsor: -7
                                    }), e.union("AccountMergeResult", {
                                        switchOn: e.lookup("AccountMergeResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "accountMergeSuccess",
                                                "sourceAccountBalance"
                                            ],
                                            [
                                                "accountMergeMalformed",
                                                e.void()
                                            ],
                                            [
                                                "accountMergeNoAccount",
                                                e.void()
                                            ],
                                            [
                                                "accountMergeImmutableSet",
                                                e.void()
                                            ],
                                            [
                                                "accountMergeHasSubEntries",
                                                e.void()
                                            ],
                                            [
                                                "accountMergeSeqnumTooFar",
                                                e.void()
                                            ],
                                            [
                                                "accountMergeDestFull",
                                                e.void()
                                            ],
                                            [
                                                "accountMergeIsSponsor",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            sourceAccountBalance: e.lookup("Int64")
                                        }
                                    }), e.enum("InflationResultCode", {
                                        inflationSuccess: 0,
                                        inflationNotTime: -1
                                    }), e.struct("InflationPayout", [
                                        [
                                            "destination",
                                            e.lookup("AccountId")
                                        ],
                                        [
                                            "amount",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.union("InflationResult", {
                                        switchOn: e.lookup("InflationResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "inflationSuccess",
                                                "payouts"
                                            ],
                                            [
                                                "inflationNotTime",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            payouts: e.varArray(e.lookup("InflationPayout"), 2147483647)
                                        }
                                    }), e.enum("ManageDataResultCode", {
                                        manageDataSuccess: 0,
                                        manageDataNotSupportedYet: -1,
                                        manageDataNameNotFound: -2,
                                        manageDataLowReserve: -3,
                                        manageDataInvalidName: -4
                                    }), e.union("ManageDataResult", {
                                        switchOn: e.lookup("ManageDataResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "manageDataSuccess",
                                                e.void()
                                            ],
                                            [
                                                "manageDataNotSupportedYet",
                                                e.void()
                                            ],
                                            [
                                                "manageDataNameNotFound",
                                                e.void()
                                            ],
                                            [
                                                "manageDataLowReserve",
                                                e.void()
                                            ],
                                            [
                                                "manageDataInvalidName",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("BumpSequenceResultCode", {
                                        bumpSequenceSuccess: 0,
                                        bumpSequenceBadSeq: -1
                                    }), e.union("BumpSequenceResult", {
                                        switchOn: e.lookup("BumpSequenceResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "bumpSequenceSuccess",
                                                e.void()
                                            ],
                                            [
                                                "bumpSequenceBadSeq",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("CreateClaimableBalanceResultCode", {
                                        createClaimableBalanceSuccess: 0,
                                        createClaimableBalanceMalformed: -1,
                                        createClaimableBalanceLowReserve: -2,
                                        createClaimableBalanceNoTrust: -3,
                                        createClaimableBalanceNotAuthorized: -4,
                                        createClaimableBalanceUnderfunded: -5
                                    }), e.union("CreateClaimableBalanceResult", {
                                        switchOn: e.lookup("CreateClaimableBalanceResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "createClaimableBalanceSuccess",
                                                "balanceId"
                                            ],
                                            [
                                                "createClaimableBalanceMalformed",
                                                e.void()
                                            ],
                                            [
                                                "createClaimableBalanceLowReserve",
                                                e.void()
                                            ],
                                            [
                                                "createClaimableBalanceNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "createClaimableBalanceNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "createClaimableBalanceUnderfunded",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            balanceId: e.lookup("ClaimableBalanceId")
                                        }
                                    }), e.enum("ClaimClaimableBalanceResultCode", {
                                        claimClaimableBalanceSuccess: 0,
                                        claimClaimableBalanceDoesNotExist: -1,
                                        claimClaimableBalanceCannotClaim: -2,
                                        claimClaimableBalanceLineFull: -3,
                                        claimClaimableBalanceNoTrust: -4,
                                        claimClaimableBalanceNotAuthorized: -5,
                                        claimClaimableBalanceTrustlineFrozen: -6
                                    }), e.union("ClaimClaimableBalanceResult", {
                                        switchOn: e.lookup("ClaimClaimableBalanceResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "claimClaimableBalanceSuccess",
                                                e.void()
                                            ],
                                            [
                                                "claimClaimableBalanceDoesNotExist",
                                                e.void()
                                            ],
                                            [
                                                "claimClaimableBalanceCannotClaim",
                                                e.void()
                                            ],
                                            [
                                                "claimClaimableBalanceLineFull",
                                                e.void()
                                            ],
                                            [
                                                "claimClaimableBalanceNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "claimClaimableBalanceNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "claimClaimableBalanceTrustlineFrozen",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("BeginSponsoringFutureReservesResultCode", {
                                        beginSponsoringFutureReservesSuccess: 0,
                                        beginSponsoringFutureReservesMalformed: -1,
                                        beginSponsoringFutureReservesAlreadySponsored: -2,
                                        beginSponsoringFutureReservesRecursive: -3
                                    }), e.union("BeginSponsoringFutureReservesResult", {
                                        switchOn: e.lookup("BeginSponsoringFutureReservesResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "beginSponsoringFutureReservesSuccess",
                                                e.void()
                                            ],
                                            [
                                                "beginSponsoringFutureReservesMalformed",
                                                e.void()
                                            ],
                                            [
                                                "beginSponsoringFutureReservesAlreadySponsored",
                                                e.void()
                                            ],
                                            [
                                                "beginSponsoringFutureReservesRecursive",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("EndSponsoringFutureReservesResultCode", {
                                        endSponsoringFutureReservesSuccess: 0,
                                        endSponsoringFutureReservesNotSponsored: -1
                                    }), e.union("EndSponsoringFutureReservesResult", {
                                        switchOn: e.lookup("EndSponsoringFutureReservesResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "endSponsoringFutureReservesSuccess",
                                                e.void()
                                            ],
                                            [
                                                "endSponsoringFutureReservesNotSponsored",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("RevokeSponsorshipResultCode", {
                                        revokeSponsorshipSuccess: 0,
                                        revokeSponsorshipDoesNotExist: -1,
                                        revokeSponsorshipNotSponsor: -2,
                                        revokeSponsorshipLowReserve: -3,
                                        revokeSponsorshipOnlyTransferable: -4,
                                        revokeSponsorshipMalformed: -5
                                    }), e.union("RevokeSponsorshipResult", {
                                        switchOn: e.lookup("RevokeSponsorshipResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "revokeSponsorshipSuccess",
                                                e.void()
                                            ],
                                            [
                                                "revokeSponsorshipDoesNotExist",
                                                e.void()
                                            ],
                                            [
                                                "revokeSponsorshipNotSponsor",
                                                e.void()
                                            ],
                                            [
                                                "revokeSponsorshipLowReserve",
                                                e.void()
                                            ],
                                            [
                                                "revokeSponsorshipOnlyTransferable",
                                                e.void()
                                            ],
                                            [
                                                "revokeSponsorshipMalformed",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("ClawbackResultCode", {
                                        clawbackSuccess: 0,
                                        clawbackMalformed: -1,
                                        clawbackNotClawbackEnabled: -2,
                                        clawbackNoTrust: -3,
                                        clawbackUnderfunded: -4
                                    }), e.union("ClawbackResult", {
                                        switchOn: e.lookup("ClawbackResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "clawbackSuccess",
                                                e.void()
                                            ],
                                            [
                                                "clawbackMalformed",
                                                e.void()
                                            ],
                                            [
                                                "clawbackNotClawbackEnabled",
                                                e.void()
                                            ],
                                            [
                                                "clawbackNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "clawbackUnderfunded",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("ClawbackClaimableBalanceResultCode", {
                                        clawbackClaimableBalanceSuccess: 0,
                                        clawbackClaimableBalanceDoesNotExist: -1,
                                        clawbackClaimableBalanceNotIssuer: -2,
                                        clawbackClaimableBalanceNotClawbackEnabled: -3
                                    }), e.union("ClawbackClaimableBalanceResult", {
                                        switchOn: e.lookup("ClawbackClaimableBalanceResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "clawbackClaimableBalanceSuccess",
                                                e.void()
                                            ],
                                            [
                                                "clawbackClaimableBalanceDoesNotExist",
                                                e.void()
                                            ],
                                            [
                                                "clawbackClaimableBalanceNotIssuer",
                                                e.void()
                                            ],
                                            [
                                                "clawbackClaimableBalanceNotClawbackEnabled",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("SetTrustLineFlagsResultCode", {
                                        setTrustLineFlagsSuccess: 0,
                                        setTrustLineFlagsMalformed: -1,
                                        setTrustLineFlagsNoTrustLine: -2,
                                        setTrustLineFlagsCantRevoke: -3,
                                        setTrustLineFlagsInvalidState: -4,
                                        setTrustLineFlagsLowReserve: -5
                                    }), e.union("SetTrustLineFlagsResult", {
                                        switchOn: e.lookup("SetTrustLineFlagsResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "setTrustLineFlagsSuccess",
                                                e.void()
                                            ],
                                            [
                                                "setTrustLineFlagsMalformed",
                                                e.void()
                                            ],
                                            [
                                                "setTrustLineFlagsNoTrustLine",
                                                e.void()
                                            ],
                                            [
                                                "setTrustLineFlagsCantRevoke",
                                                e.void()
                                            ],
                                            [
                                                "setTrustLineFlagsInvalidState",
                                                e.void()
                                            ],
                                            [
                                                "setTrustLineFlagsLowReserve",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("LiquidityPoolDepositResultCode", {
                                        liquidityPoolDepositSuccess: 0,
                                        liquidityPoolDepositMalformed: -1,
                                        liquidityPoolDepositNoTrust: -2,
                                        liquidityPoolDepositNotAuthorized: -3,
                                        liquidityPoolDepositUnderfunded: -4,
                                        liquidityPoolDepositLineFull: -5,
                                        liquidityPoolDepositBadPrice: -6,
                                        liquidityPoolDepositPoolFull: -7,
                                        liquidityPoolDepositTrustlineFrozen: -8
                                    }), e.union("LiquidityPoolDepositResult", {
                                        switchOn: e.lookup("LiquidityPoolDepositResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "liquidityPoolDepositSuccess",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositMalformed",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositNotAuthorized",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositLineFull",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositBadPrice",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositPoolFull",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolDepositTrustlineFrozen",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("LiquidityPoolWithdrawResultCode", {
                                        liquidityPoolWithdrawSuccess: 0,
                                        liquidityPoolWithdrawMalformed: -1,
                                        liquidityPoolWithdrawNoTrust: -2,
                                        liquidityPoolWithdrawUnderfunded: -3,
                                        liquidityPoolWithdrawLineFull: -4,
                                        liquidityPoolWithdrawUnderMinimum: -5,
                                        liquidityPoolWithdrawTrustlineFrozen: -6
                                    }), e.union("LiquidityPoolWithdrawResult", {
                                        switchOn: e.lookup("LiquidityPoolWithdrawResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "liquidityPoolWithdrawSuccess",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolWithdrawMalformed",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolWithdrawNoTrust",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolWithdrawUnderfunded",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolWithdrawLineFull",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolWithdrawUnderMinimum",
                                                e.void()
                                            ],
                                            [
                                                "liquidityPoolWithdrawTrustlineFrozen",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("InvokeHostFunctionResultCode", {
                                        invokeHostFunctionSuccess: 0,
                                        invokeHostFunctionMalformed: -1,
                                        invokeHostFunctionTrapped: -2,
                                        invokeHostFunctionResourceLimitExceeded: -3,
                                        invokeHostFunctionEntryArchived: -4,
                                        invokeHostFunctionInsufficientRefundableFee: -5
                                    }), e.union("InvokeHostFunctionResult", {
                                        switchOn: e.lookup("InvokeHostFunctionResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "invokeHostFunctionSuccess",
                                                "success"
                                            ],
                                            [
                                                "invokeHostFunctionMalformed",
                                                e.void()
                                            ],
                                            [
                                                "invokeHostFunctionTrapped",
                                                e.void()
                                            ],
                                            [
                                                "invokeHostFunctionResourceLimitExceeded",
                                                e.void()
                                            ],
                                            [
                                                "invokeHostFunctionEntryArchived",
                                                e.void()
                                            ],
                                            [
                                                "invokeHostFunctionInsufficientRefundableFee",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            success: e.lookup("Hash")
                                        }
                                    }), e.enum("ExtendFootprintTtlResultCode", {
                                        extendFootprintTtlSuccess: 0,
                                        extendFootprintTtlMalformed: -1,
                                        extendFootprintTtlResourceLimitExceeded: -2,
                                        extendFootprintTtlInsufficientRefundableFee: -3
                                    }), e.union("ExtendFootprintTtlResult", {
                                        switchOn: e.lookup("ExtendFootprintTtlResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "extendFootprintTtlSuccess",
                                                e.void()
                                            ],
                                            [
                                                "extendFootprintTtlMalformed",
                                                e.void()
                                            ],
                                            [
                                                "extendFootprintTtlResourceLimitExceeded",
                                                e.void()
                                            ],
                                            [
                                                "extendFootprintTtlInsufficientRefundableFee",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("RestoreFootprintResultCode", {
                                        restoreFootprintSuccess: 0,
                                        restoreFootprintMalformed: -1,
                                        restoreFootprintResourceLimitExceeded: -2,
                                        restoreFootprintInsufficientRefundableFee: -3
                                    }), e.union("RestoreFootprintResult", {
                                        switchOn: e.lookup("RestoreFootprintResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "restoreFootprintSuccess",
                                                e.void()
                                            ],
                                            [
                                                "restoreFootprintMalformed",
                                                e.void()
                                            ],
                                            [
                                                "restoreFootprintResourceLimitExceeded",
                                                e.void()
                                            ],
                                            [
                                                "restoreFootprintInsufficientRefundableFee",
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("OperationResultCode", {
                                        opInner: 0,
                                        opBadAuth: -1,
                                        opNoAccount: -2,
                                        opNotSupported: -3,
                                        opTooManySubentries: -4,
                                        opExceededWorkLimit: -5,
                                        opTooManySponsoring: -6
                                    }), e.union("OperationResultTr", {
                                        switchOn: e.lookup("OperationType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "createAccount",
                                                "createAccountResult"
                                            ],
                                            [
                                                "payment",
                                                "paymentResult"
                                            ],
                                            [
                                                "pathPaymentStrictReceive",
                                                "pathPaymentStrictReceiveResult"
                                            ],
                                            [
                                                "manageSellOffer",
                                                "manageSellOfferResult"
                                            ],
                                            [
                                                "createPassiveSellOffer",
                                                "createPassiveSellOfferResult"
                                            ],
                                            [
                                                "setOptions",
                                                "setOptionsResult"
                                            ],
                                            [
                                                "changeTrust",
                                                "changeTrustResult"
                                            ],
                                            [
                                                "allowTrust",
                                                "allowTrustResult"
                                            ],
                                            [
                                                "accountMerge",
                                                "accountMergeResult"
                                            ],
                                            [
                                                "inflation",
                                                "inflationResult"
                                            ],
                                            [
                                                "manageData",
                                                "manageDataResult"
                                            ],
                                            [
                                                "bumpSequence",
                                                "bumpSeqResult"
                                            ],
                                            [
                                                "manageBuyOffer",
                                                "manageBuyOfferResult"
                                            ],
                                            [
                                                "pathPaymentStrictSend",
                                                "pathPaymentStrictSendResult"
                                            ],
                                            [
                                                "createClaimableBalance",
                                                "createClaimableBalanceResult"
                                            ],
                                            [
                                                "claimClaimableBalance",
                                                "claimClaimableBalanceResult"
                                            ],
                                            [
                                                "beginSponsoringFutureReserves",
                                                "beginSponsoringFutureReservesResult"
                                            ],
                                            [
                                                "endSponsoringFutureReserves",
                                                "endSponsoringFutureReservesResult"
                                            ],
                                            [
                                                "revokeSponsorship",
                                                "revokeSponsorshipResult"
                                            ],
                                            [
                                                "clawback",
                                                "clawbackResult"
                                            ],
                                            [
                                                "clawbackClaimableBalance",
                                                "clawbackClaimableBalanceResult"
                                            ],
                                            [
                                                "setTrustLineFlags",
                                                "setTrustLineFlagsResult"
                                            ],
                                            [
                                                "liquidityPoolDeposit",
                                                "liquidityPoolDepositResult"
                                            ],
                                            [
                                                "liquidityPoolWithdraw",
                                                "liquidityPoolWithdrawResult"
                                            ],
                                            [
                                                "invokeHostFunction",
                                                "invokeHostFunctionResult"
                                            ],
                                            [
                                                "extendFootprintTtl",
                                                "extendFootprintTtlResult"
                                            ],
                                            [
                                                "restoreFootprint",
                                                "restoreFootprintResult"
                                            ]
                                        ],
                                        arms: {
                                            createAccountResult: e.lookup("CreateAccountResult"),
                                            paymentResult: e.lookup("PaymentResult"),
                                            pathPaymentStrictReceiveResult: e.lookup("PathPaymentStrictReceiveResult"),
                                            manageSellOfferResult: e.lookup("ManageSellOfferResult"),
                                            createPassiveSellOfferResult: e.lookup("ManageSellOfferResult"),
                                            setOptionsResult: e.lookup("SetOptionsResult"),
                                            changeTrustResult: e.lookup("ChangeTrustResult"),
                                            allowTrustResult: e.lookup("AllowTrustResult"),
                                            accountMergeResult: e.lookup("AccountMergeResult"),
                                            inflationResult: e.lookup("InflationResult"),
                                            manageDataResult: e.lookup("ManageDataResult"),
                                            bumpSeqResult: e.lookup("BumpSequenceResult"),
                                            manageBuyOfferResult: e.lookup("ManageBuyOfferResult"),
                                            pathPaymentStrictSendResult: e.lookup("PathPaymentStrictSendResult"),
                                            createClaimableBalanceResult: e.lookup("CreateClaimableBalanceResult"),
                                            claimClaimableBalanceResult: e.lookup("ClaimClaimableBalanceResult"),
                                            beginSponsoringFutureReservesResult: e.lookup("BeginSponsoringFutureReservesResult"),
                                            endSponsoringFutureReservesResult: e.lookup("EndSponsoringFutureReservesResult"),
                                            revokeSponsorshipResult: e.lookup("RevokeSponsorshipResult"),
                                            clawbackResult: e.lookup("ClawbackResult"),
                                            clawbackClaimableBalanceResult: e.lookup("ClawbackClaimableBalanceResult"),
                                            setTrustLineFlagsResult: e.lookup("SetTrustLineFlagsResult"),
                                            liquidityPoolDepositResult: e.lookup("LiquidityPoolDepositResult"),
                                            liquidityPoolWithdrawResult: e.lookup("LiquidityPoolWithdrawResult"),
                                            invokeHostFunctionResult: e.lookup("InvokeHostFunctionResult"),
                                            extendFootprintTtlResult: e.lookup("ExtendFootprintTtlResult"),
                                            restoreFootprintResult: e.lookup("RestoreFootprintResult")
                                        }
                                    }), e.union("OperationResult", {
                                        switchOn: e.lookup("OperationResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "opInner",
                                                "tr"
                                            ],
                                            [
                                                "opBadAuth",
                                                e.void()
                                            ],
                                            [
                                                "opNoAccount",
                                                e.void()
                                            ],
                                            [
                                                "opNotSupported",
                                                e.void()
                                            ],
                                            [
                                                "opTooManySubentries",
                                                e.void()
                                            ],
                                            [
                                                "opExceededWorkLimit",
                                                e.void()
                                            ],
                                            [
                                                "opTooManySponsoring",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            tr: e.lookup("OperationResultTr")
                                        }
                                    }), e.enum("TransactionResultCode", {
                                        txFeeBumpInnerSuccess: 1,
                                        txSuccess: 0,
                                        txFailed: -1,
                                        txTooEarly: -2,
                                        txTooLate: -3,
                                        txMissingOperation: -4,
                                        txBadSeq: -5,
                                        txBadAuth: -6,
                                        txInsufficientBalance: -7,
                                        txNoAccount: -8,
                                        txInsufficientFee: -9,
                                        txBadAuthExtra: -10,
                                        txInternalError: -11,
                                        txNotSupported: -12,
                                        txFeeBumpInnerFailed: -13,
                                        txBadSponsorship: -14,
                                        txBadMinSeqAgeOrGap: -15,
                                        txMalformed: -16,
                                        txSorobanInvalid: -17,
                                        txFrozenKeyAccessed: -18
                                    }), e.union("InnerTransactionResultResult", {
                                        switchOn: e.lookup("TransactionResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "txSuccess",
                                                "results"
                                            ],
                                            [
                                                "txFailed",
                                                "results"
                                            ],
                                            [
                                                "txTooEarly",
                                                e.void()
                                            ],
                                            [
                                                "txTooLate",
                                                e.void()
                                            ],
                                            [
                                                "txMissingOperation",
                                                e.void()
                                            ],
                                            [
                                                "txBadSeq",
                                                e.void()
                                            ],
                                            [
                                                "txBadAuth",
                                                e.void()
                                            ],
                                            [
                                                "txInsufficientBalance",
                                                e.void()
                                            ],
                                            [
                                                "txNoAccount",
                                                e.void()
                                            ],
                                            [
                                                "txInsufficientFee",
                                                e.void()
                                            ],
                                            [
                                                "txBadAuthExtra",
                                                e.void()
                                            ],
                                            [
                                                "txInternalError",
                                                e.void()
                                            ],
                                            [
                                                "txNotSupported",
                                                e.void()
                                            ],
                                            [
                                                "txBadSponsorship",
                                                e.void()
                                            ],
                                            [
                                                "txBadMinSeqAgeOrGap",
                                                e.void()
                                            ],
                                            [
                                                "txMalformed",
                                                e.void()
                                            ],
                                            [
                                                "txSorobanInvalid",
                                                e.void()
                                            ],
                                            [
                                                "txFrozenKeyAccessed",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            results: e.varArray(e.lookup("OperationResult"), 2147483647)
                                        }
                                    }), e.union("InnerTransactionResultExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("InnerTransactionResult", [
                                        [
                                            "feeCharged",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "result",
                                            e.lookup("InnerTransactionResultResult")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("InnerTransactionResultExt")
                                        ]
                                    ]), e.struct("InnerTransactionResultPair", [
                                        [
                                            "transactionHash",
                                            e.lookup("Hash")
                                        ],
                                        [
                                            "result",
                                            e.lookup("InnerTransactionResult")
                                        ]
                                    ]), e.union("TransactionResultResult", {
                                        switchOn: e.lookup("TransactionResultCode"),
                                        switchName: "code",
                                        switches: [
                                            [
                                                "txFeeBumpInnerSuccess",
                                                "innerResultPair"
                                            ],
                                            [
                                                "txFeeBumpInnerFailed",
                                                "innerResultPair"
                                            ],
                                            [
                                                "txSuccess",
                                                "results"
                                            ],
                                            [
                                                "txFailed",
                                                "results"
                                            ],
                                            [
                                                "txTooEarly",
                                                e.void()
                                            ],
                                            [
                                                "txTooLate",
                                                e.void()
                                            ],
                                            [
                                                "txMissingOperation",
                                                e.void()
                                            ],
                                            [
                                                "txBadSeq",
                                                e.void()
                                            ],
                                            [
                                                "txBadAuth",
                                                e.void()
                                            ],
                                            [
                                                "txInsufficientBalance",
                                                e.void()
                                            ],
                                            [
                                                "txNoAccount",
                                                e.void()
                                            ],
                                            [
                                                "txInsufficientFee",
                                                e.void()
                                            ],
                                            [
                                                "txBadAuthExtra",
                                                e.void()
                                            ],
                                            [
                                                "txInternalError",
                                                e.void()
                                            ],
                                            [
                                                "txNotSupported",
                                                e.void()
                                            ],
                                            [
                                                "txBadSponsorship",
                                                e.void()
                                            ],
                                            [
                                                "txBadMinSeqAgeOrGap",
                                                e.void()
                                            ],
                                            [
                                                "txMalformed",
                                                e.void()
                                            ],
                                            [
                                                "txSorobanInvalid",
                                                e.void()
                                            ],
                                            [
                                                "txFrozenKeyAccessed",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            innerResultPair: e.lookup("InnerTransactionResultPair"),
                                            results: e.varArray(e.lookup("OperationResult"), 2147483647)
                                        }
                                    }), e.union("TransactionResultExt", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.struct("TransactionResult", [
                                        [
                                            "feeCharged",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "result",
                                            e.lookup("TransactionResultResult")
                                        ],
                                        [
                                            "ext",
                                            e.lookup("TransactionResultExt")
                                        ]
                                    ]), e.typedef("Hash", e.opaque(32)), e.typedef("Uint256", e.opaque(32)), e.typedef("Uint32", e.uint()), e.typedef("Int32", e.int()), e.typedef("Uint64", e.uhyper()), e.typedef("Int64", e.hyper()), e.typedef("TimePoint", e.lookup("Uint64")), e.typedef("Duration", e.lookup("Uint64")), e.union("ExtensionPoint", {
                                        switchOn: e.int(),
                                        switchName: "v",
                                        switches: [
                                            [
                                                0,
                                                e.void()
                                            ]
                                        ],
                                        arms: {}
                                    }), e.enum("CryptoKeyType", {
                                        keyTypeEd25519: 0,
                                        keyTypePreAuthTx: 1,
                                        keyTypeHashX: 2,
                                        keyTypeEd25519SignedPayload: 3,
                                        keyTypeMuxedEd25519: 256
                                    }), e.enum("PublicKeyType", {
                                        publicKeyTypeEd25519: 0
                                    }), e.enum("SignerKeyType", {
                                        signerKeyTypeEd25519: 0,
                                        signerKeyTypePreAuthTx: 1,
                                        signerKeyTypeHashX: 2,
                                        signerKeyTypeEd25519SignedPayload: 3
                                    }), e.union("PublicKey", {
                                        switchOn: e.lookup("PublicKeyType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "publicKeyTypeEd25519",
                                                "ed25519"
                                            ]
                                        ],
                                        arms: {
                                            ed25519: e.lookup("Uint256")
                                        }
                                    }), e.struct("SignerKeyEd25519SignedPayload", [
                                        [
                                            "ed25519",
                                            e.lookup("Uint256")
                                        ],
                                        [
                                            "payload",
                                            e.varOpaque(64)
                                        ]
                                    ]), e.union("SignerKey", {
                                        switchOn: e.lookup("SignerKeyType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "signerKeyTypeEd25519",
                                                "ed25519"
                                            ],
                                            [
                                                "signerKeyTypePreAuthTx",
                                                "preAuthTx"
                                            ],
                                            [
                                                "signerKeyTypeHashX",
                                                "hashX"
                                            ],
                                            [
                                                "signerKeyTypeEd25519SignedPayload",
                                                "ed25519SignedPayload"
                                            ]
                                        ],
                                        arms: {
                                            ed25519: e.lookup("Uint256"),
                                            preAuthTx: e.lookup("Uint256"),
                                            hashX: e.lookup("Uint256"),
                                            ed25519SignedPayload: e.lookup("SignerKeyEd25519SignedPayload")
                                        }
                                    }), e.typedef("Signature", e.varOpaque(64)), e.typedef("SignatureHint", e.opaque(4)), e.typedef("NodeId", e.lookup("PublicKey")), e.typedef("AccountId", e.lookup("PublicKey")), e.typedef("ContractId", e.lookup("Hash")), e.struct("Curve25519Secret", [
                                        [
                                            "key",
                                            e.opaque(32)
                                        ]
                                    ]), e.struct("Curve25519Public", [
                                        [
                                            "key",
                                            e.opaque(32)
                                        ]
                                    ]), e.struct("HmacSha256Key", [
                                        [
                                            "key",
                                            e.opaque(32)
                                        ]
                                    ]), e.struct("HmacSha256Mac", [
                                        [
                                            "mac",
                                            e.opaque(32)
                                        ]
                                    ]), e.struct("ShortHashSeed", [
                                        [
                                            "seed",
                                            e.opaque(16)
                                        ]
                                    ]), e.enum("BinaryFuseFilterType", {
                                        binaryFuseFilter8Bit: 0,
                                        binaryFuseFilter16Bit: 1,
                                        binaryFuseFilter32Bit: 2
                                    }), e.struct("SerializedBinaryFuseFilter", [
                                        [
                                            "type",
                                            e.lookup("BinaryFuseFilterType")
                                        ],
                                        [
                                            "inputHashSeed",
                                            e.lookup("ShortHashSeed")
                                        ],
                                        [
                                            "filterSeed",
                                            e.lookup("ShortHashSeed")
                                        ],
                                        [
                                            "segmentLength",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "segementLengthMask",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "segmentCount",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "segmentCountLength",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "fingerprintLength",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "fingerprints",
                                            e.varOpaque()
                                        ]
                                    ]), e.typedef("PoolId", e.lookup("Hash")), e.enum("ClaimableBalanceIdType", {
                                        claimableBalanceIdTypeV0: 0
                                    }), e.union("ClaimableBalanceId", {
                                        switchOn: e.lookup("ClaimableBalanceIdType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "claimableBalanceIdTypeV0",
                                                "v0"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("Hash")
                                        }
                                    }), e.enum("ScValType", {
                                        scvBool: 0,
                                        scvVoid: 1,
                                        scvError: 2,
                                        scvU32: 3,
                                        scvI32: 4,
                                        scvU64: 5,
                                        scvI64: 6,
                                        scvTimepoint: 7,
                                        scvDuration: 8,
                                        scvU128: 9,
                                        scvI128: 10,
                                        scvU256: 11,
                                        scvI256: 12,
                                        scvBytes: 13,
                                        scvString: 14,
                                        scvSymbol: 15,
                                        scvVec: 16,
                                        scvMap: 17,
                                        scvAddress: 18,
                                        scvContractInstance: 19,
                                        scvLedgerKeyContractInstance: 20,
                                        scvLedgerKeyNonce: 21
                                    }), e.enum("ScErrorType", {
                                        sceContract: 0,
                                        sceWasmVm: 1,
                                        sceContext: 2,
                                        sceStorage: 3,
                                        sceObject: 4,
                                        sceCrypto: 5,
                                        sceEvents: 6,
                                        sceBudget: 7,
                                        sceValue: 8,
                                        sceAuth: 9
                                    }), e.enum("ScErrorCode", {
                                        scecArithDomain: 0,
                                        scecIndexBounds: 1,
                                        scecInvalidInput: 2,
                                        scecMissingValue: 3,
                                        scecExistingValue: 4,
                                        scecExceededLimit: 5,
                                        scecInvalidAction: 6,
                                        scecInternalError: 7,
                                        scecUnexpectedType: 8,
                                        scecUnexpectedSize: 9
                                    }), e.union("ScError", {
                                        switchOn: e.lookup("ScErrorType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "sceContract",
                                                "contractCode"
                                            ],
                                            [
                                                "sceWasmVm",
                                                "code"
                                            ],
                                            [
                                                "sceContext",
                                                "code"
                                            ],
                                            [
                                                "sceStorage",
                                                "code"
                                            ],
                                            [
                                                "sceObject",
                                                "code"
                                            ],
                                            [
                                                "sceCrypto",
                                                "code"
                                            ],
                                            [
                                                "sceEvents",
                                                "code"
                                            ],
                                            [
                                                "sceBudget",
                                                "code"
                                            ],
                                            [
                                                "sceValue",
                                                "code"
                                            ],
                                            [
                                                "sceAuth",
                                                "code"
                                            ]
                                        ],
                                        arms: {
                                            contractCode: e.lookup("Uint32"),
                                            code: e.lookup("ScErrorCode")
                                        }
                                    }), e.struct("UInt128Parts", [
                                        [
                                            "hi",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "lo",
                                            e.lookup("Uint64")
                                        ]
                                    ]), e.struct("Int128Parts", [
                                        [
                                            "hi",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "lo",
                                            e.lookup("Uint64")
                                        ]
                                    ]), e.struct("UInt256Parts", [
                                        [
                                            "hiHi",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "hiLo",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "loHi",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "loLo",
                                            e.lookup("Uint64")
                                        ]
                                    ]), e.struct("Int256Parts", [
                                        [
                                            "hiHi",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "hiLo",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "loHi",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "loLo",
                                            e.lookup("Uint64")
                                        ]
                                    ]), e.enum("ContractExecutableType", {
                                        contractExecutableWasm: 0,
                                        contractExecutableStellarAsset: 1
                                    }), e.union("ContractExecutable", {
                                        switchOn: e.lookup("ContractExecutableType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "contractExecutableWasm",
                                                "wasmHash"
                                            ],
                                            [
                                                "contractExecutableStellarAsset",
                                                e.void()
                                            ]
                                        ],
                                        arms: {
                                            wasmHash: e.lookup("Hash")
                                        }
                                    }), e.enum("ScAddressType", {
                                        scAddressTypeAccount: 0,
                                        scAddressTypeContract: 1,
                                        scAddressTypeMuxedAccount: 2,
                                        scAddressTypeClaimableBalance: 3,
                                        scAddressTypeLiquidityPool: 4
                                    }), e.struct("MuxedEd25519Account", [
                                        [
                                            "id",
                                            e.lookup("Uint64")
                                        ],
                                        [
                                            "ed25519",
                                            e.lookup("Uint256")
                                        ]
                                    ]), e.union("ScAddress", {
                                        switchOn: e.lookup("ScAddressType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "scAddressTypeAccount",
                                                "accountId"
                                            ],
                                            [
                                                "scAddressTypeContract",
                                                "contractId"
                                            ],
                                            [
                                                "scAddressTypeMuxedAccount",
                                                "muxedAccount"
                                            ],
                                            [
                                                "scAddressTypeClaimableBalance",
                                                "claimableBalanceId"
                                            ],
                                            [
                                                "scAddressTypeLiquidityPool",
                                                "liquidityPoolId"
                                            ]
                                        ],
                                        arms: {
                                            accountId: e.lookup("AccountId"),
                                            contractId: e.lookup("ContractId"),
                                            muxedAccount: e.lookup("MuxedEd25519Account"),
                                            claimableBalanceId: e.lookup("ClaimableBalanceId"),
                                            liquidityPoolId: e.lookup("PoolId")
                                        }
                                    }), e.const("SCSYMBOL_LIMIT", 32), e.typedef("ScVec", e.varArray(e.lookup("ScVal"), 2147483647)), e.typedef("ScMap", e.varArray(e.lookup("ScMapEntry"), 2147483647)), e.typedef("ScBytes", e.varOpaque()), e.typedef("ScString", e.string()), e.typedef("ScSymbol", e.string(32)), e.struct("ScNonceKey", [
                                        [
                                            "nonce",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ScContractInstance", [
                                        [
                                            "executable",
                                            e.lookup("ContractExecutable")
                                        ],
                                        [
                                            "storage",
                                            e.option(e.lookup("ScMap"))
                                        ]
                                    ]), e.union("ScVal", {
                                        switchOn: e.lookup("ScValType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "scvBool",
                                                "b"
                                            ],
                                            [
                                                "scvVoid",
                                                e.void()
                                            ],
                                            [
                                                "scvError",
                                                "error"
                                            ],
                                            [
                                                "scvU32",
                                                "u32"
                                            ],
                                            [
                                                "scvI32",
                                                "i32"
                                            ],
                                            [
                                                "scvU64",
                                                "u64"
                                            ],
                                            [
                                                "scvI64",
                                                "i64"
                                            ],
                                            [
                                                "scvTimepoint",
                                                "timepoint"
                                            ],
                                            [
                                                "scvDuration",
                                                "duration"
                                            ],
                                            [
                                                "scvU128",
                                                "u128"
                                            ],
                                            [
                                                "scvI128",
                                                "i128"
                                            ],
                                            [
                                                "scvU256",
                                                "u256"
                                            ],
                                            [
                                                "scvI256",
                                                "i256"
                                            ],
                                            [
                                                "scvBytes",
                                                "bytes"
                                            ],
                                            [
                                                "scvString",
                                                "str"
                                            ],
                                            [
                                                "scvSymbol",
                                                "sym"
                                            ],
                                            [
                                                "scvVec",
                                                "vec"
                                            ],
                                            [
                                                "scvMap",
                                                "map"
                                            ],
                                            [
                                                "scvAddress",
                                                "address"
                                            ],
                                            [
                                                "scvContractInstance",
                                                "instance"
                                            ],
                                            [
                                                "scvLedgerKeyContractInstance",
                                                e.void()
                                            ],
                                            [
                                                "scvLedgerKeyNonce",
                                                "nonceKey"
                                            ]
                                        ],
                                        arms: {
                                            b: e.bool(),
                                            error: e.lookup("ScError"),
                                            u32: e.lookup("Uint32"),
                                            i32: e.lookup("Int32"),
                                            u64: e.lookup("Uint64"),
                                            i64: e.lookup("Int64"),
                                            timepoint: e.lookup("TimePoint"),
                                            duration: e.lookup("Duration"),
                                            u128: e.lookup("UInt128Parts"),
                                            i128: e.lookup("Int128Parts"),
                                            u256: e.lookup("UInt256Parts"),
                                            i256: e.lookup("Int256Parts"),
                                            bytes: e.lookup("ScBytes"),
                                            str: e.lookup("ScString"),
                                            sym: e.lookup("ScSymbol"),
                                            vec: e.option(e.lookup("ScVec")),
                                            map: e.option(e.lookup("ScMap")),
                                            address: e.lookup("ScAddress"),
                                            instance: e.lookup("ScContractInstance"),
                                            nonceKey: e.lookup("ScNonceKey")
                                        }
                                    }), e.struct("ScMapEntry", [
                                        [
                                            "key",
                                            e.lookup("ScVal")
                                        ],
                                        [
                                            "val",
                                            e.lookup("ScVal")
                                        ]
                                    ]), e.enum("ScEnvMetaKind", {
                                        scEnvMetaKindInterfaceVersion: 0
                                    }), e.struct("ScEnvMetaEntryInterfaceVersion", [
                                        [
                                            "protocol",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "preRelease",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.union("ScEnvMetaEntry", {
                                        switchOn: e.lookup("ScEnvMetaKind"),
                                        switchName: "kind",
                                        switches: [
                                            [
                                                "scEnvMetaKindInterfaceVersion",
                                                "interfaceVersion"
                                            ]
                                        ],
                                        arms: {
                                            interfaceVersion: e.lookup("ScEnvMetaEntryInterfaceVersion")
                                        }
                                    }), e.struct("ScMetaV0", [
                                        [
                                            "key",
                                            e.string()
                                        ],
                                        [
                                            "val",
                                            e.string()
                                        ]
                                    ]), e.enum("ScMetaKind", {
                                        scMetaV0: 0
                                    }), e.union("ScMetaEntry", {
                                        switchOn: e.lookup("ScMetaKind"),
                                        switchName: "kind",
                                        switches: [
                                            [
                                                "scMetaV0",
                                                "v0"
                                            ]
                                        ],
                                        arms: {
                                            v0: e.lookup("ScMetaV0")
                                        }
                                    }), e.const("SC_SPEC_DOC_LIMIT", 1024), e.enum("ScSpecType", {
                                        scSpecTypeVal: 0,
                                        scSpecTypeBool: 1,
                                        scSpecTypeVoid: 2,
                                        scSpecTypeError: 3,
                                        scSpecTypeU32: 4,
                                        scSpecTypeI32: 5,
                                        scSpecTypeU64: 6,
                                        scSpecTypeI64: 7,
                                        scSpecTypeTimepoint: 8,
                                        scSpecTypeDuration: 9,
                                        scSpecTypeU128: 10,
                                        scSpecTypeI128: 11,
                                        scSpecTypeU256: 12,
                                        scSpecTypeI256: 13,
                                        scSpecTypeBytes: 14,
                                        scSpecTypeString: 16,
                                        scSpecTypeSymbol: 17,
                                        scSpecTypeAddress: 19,
                                        scSpecTypeMuxedAddress: 20,
                                        scSpecTypeOption: 1e3,
                                        scSpecTypeResult: 1001,
                                        scSpecTypeVec: 1002,
                                        scSpecTypeMap: 1004,
                                        scSpecTypeTuple: 1005,
                                        scSpecTypeBytesN: 1006,
                                        scSpecTypeUdt: 2e3
                                    }), e.struct("ScSpecTypeOption", [
                                        [
                                            "valueType",
                                            e.lookup("ScSpecTypeDef")
                                        ]
                                    ]), e.struct("ScSpecTypeResult", [
                                        [
                                            "okType",
                                            e.lookup("ScSpecTypeDef")
                                        ],
                                        [
                                            "errorType",
                                            e.lookup("ScSpecTypeDef")
                                        ]
                                    ]), e.struct("ScSpecTypeVec", [
                                        [
                                            "elementType",
                                            e.lookup("ScSpecTypeDef")
                                        ]
                                    ]), e.struct("ScSpecTypeMap", [
                                        [
                                            "keyType",
                                            e.lookup("ScSpecTypeDef")
                                        ],
                                        [
                                            "valueType",
                                            e.lookup("ScSpecTypeDef")
                                        ]
                                    ]), e.struct("ScSpecTypeTuple", [
                                        [
                                            "valueTypes",
                                            e.varArray(e.lookup("ScSpecTypeDef"), 12)
                                        ]
                                    ]), e.struct("ScSpecTypeBytesN", [
                                        [
                                            "n",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ScSpecTypeUdt", [
                                        [
                                            "name",
                                            e.string(60)
                                        ]
                                    ]), e.union("ScSpecTypeDef", {
                                        switchOn: e.lookup("ScSpecType"),
                                        switchName: "type",
                                        switches: [
                                            [
                                                "scSpecTypeVal",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeBool",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeVoid",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeError",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeU32",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeI32",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeU64",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeI64",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeTimepoint",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeDuration",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeU128",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeI128",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeU256",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeI256",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeBytes",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeString",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeSymbol",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeAddress",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeMuxedAddress",
                                                e.void()
                                            ],
                                            [
                                                "scSpecTypeOption",
                                                "option"
                                            ],
                                            [
                                                "scSpecTypeResult",
                                                "result"
                                            ],
                                            [
                                                "scSpecTypeVec",
                                                "vec"
                                            ],
                                            [
                                                "scSpecTypeMap",
                                                "map"
                                            ],
                                            [
                                                "scSpecTypeTuple",
                                                "tuple"
                                            ],
                                            [
                                                "scSpecTypeBytesN",
                                                "bytesN"
                                            ],
                                            [
                                                "scSpecTypeUdt",
                                                "udt"
                                            ]
                                        ],
                                        arms: {
                                            option: e.lookup("ScSpecTypeOption"),
                                            result: e.lookup("ScSpecTypeResult"),
                                            vec: e.lookup("ScSpecTypeVec"),
                                            map: e.lookup("ScSpecTypeMap"),
                                            tuple: e.lookup("ScSpecTypeTuple"),
                                            bytesN: e.lookup("ScSpecTypeBytesN"),
                                            udt: e.lookup("ScSpecTypeUdt")
                                        }
                                    }), e.struct("ScSpecUdtStructFieldV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(30)
                                        ],
                                        [
                                            "type",
                                            e.lookup("ScSpecTypeDef")
                                        ]
                                    ]), e.struct("ScSpecUdtStructV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "lib",
                                            e.string(80)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "fields",
                                            e.varArray(e.lookup("ScSpecUdtStructFieldV0"), 2147483647)
                                        ]
                                    ]), e.struct("ScSpecUdtUnionCaseVoidV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ]
                                    ]), e.struct("ScSpecUdtUnionCaseTupleV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "type",
                                            e.varArray(e.lookup("ScSpecTypeDef"), 2147483647)
                                        ]
                                    ]), e.enum("ScSpecUdtUnionCaseV0Kind", {
                                        scSpecUdtUnionCaseVoidV0: 0,
                                        scSpecUdtUnionCaseTupleV0: 1
                                    }), e.union("ScSpecUdtUnionCaseV0", {
                                        switchOn: e.lookup("ScSpecUdtUnionCaseV0Kind"),
                                        switchName: "kind",
                                        switches: [
                                            [
                                                "scSpecUdtUnionCaseVoidV0",
                                                "voidCase"
                                            ],
                                            [
                                                "scSpecUdtUnionCaseTupleV0",
                                                "tupleCase"
                                            ]
                                        ],
                                        arms: {
                                            voidCase: e.lookup("ScSpecUdtUnionCaseVoidV0"),
                                            tupleCase: e.lookup("ScSpecUdtUnionCaseTupleV0")
                                        }
                                    }), e.struct("ScSpecUdtUnionV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "lib",
                                            e.string(80)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "cases",
                                            e.varArray(e.lookup("ScSpecUdtUnionCaseV0"), 2147483647)
                                        ]
                                    ]), e.struct("ScSpecUdtEnumCaseV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "value",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ScSpecUdtEnumV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "lib",
                                            e.string(80)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "cases",
                                            e.varArray(e.lookup("ScSpecUdtEnumCaseV0"), 2147483647)
                                        ]
                                    ]), e.struct("ScSpecUdtErrorEnumCaseV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "value",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ScSpecUdtErrorEnumV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "lib",
                                            e.string(80)
                                        ],
                                        [
                                            "name",
                                            e.string(60)
                                        ],
                                        [
                                            "cases",
                                            e.varArray(e.lookup("ScSpecUdtErrorEnumCaseV0"), 2147483647)
                                        ]
                                    ]), e.struct("ScSpecFunctionInputV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(30)
                                        ],
                                        [
                                            "type",
                                            e.lookup("ScSpecTypeDef")
                                        ]
                                    ]), e.struct("ScSpecFunctionV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.lookup("ScSymbol")
                                        ],
                                        [
                                            "inputs",
                                            e.varArray(e.lookup("ScSpecFunctionInputV0"), 2147483647)
                                        ],
                                        [
                                            "outputs",
                                            e.varArray(e.lookup("ScSpecTypeDef"), 1)
                                        ]
                                    ]), e.enum("ScSpecEventParamLocationV0", {
                                        scSpecEventParamLocationData: 0,
                                        scSpecEventParamLocationTopicList: 1
                                    }), e.struct("ScSpecEventParamV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "name",
                                            e.string(30)
                                        ],
                                        [
                                            "type",
                                            e.lookup("ScSpecTypeDef")
                                        ],
                                        [
                                            "location",
                                            e.lookup("ScSpecEventParamLocationV0")
                                        ]
                                    ]), e.enum("ScSpecEventDataFormat", {
                                        scSpecEventDataFormatSingleValue: 0,
                                        scSpecEventDataFormatVec: 1,
                                        scSpecEventDataFormatMap: 2
                                    }), e.struct("ScSpecEventV0", [
                                        [
                                            "doc",
                                            e.string(t)
                                        ],
                                        [
                                            "lib",
                                            e.string(80)
                                        ],
                                        [
                                            "name",
                                            e.lookup("ScSymbol")
                                        ],
                                        [
                                            "prefixTopics",
                                            e.varArray(e.lookup("ScSymbol"), 2)
                                        ],
                                        [
                                            "params",
                                            e.varArray(e.lookup("ScSpecEventParamV0"), 2147483647)
                                        ],
                                        [
                                            "dataFormat",
                                            e.lookup("ScSpecEventDataFormat")
                                        ]
                                    ]), e.enum("ScSpecEntryKind", {
                                        scSpecEntryFunctionV0: 0,
                                        scSpecEntryUdtStructV0: 1,
                                        scSpecEntryUdtUnionV0: 2,
                                        scSpecEntryUdtEnumV0: 3,
                                        scSpecEntryUdtErrorEnumV0: 4,
                                        scSpecEntryEventV0: 5
                                    }), e.union("ScSpecEntry", {
                                        switchOn: e.lookup("ScSpecEntryKind"),
                                        switchName: "kind",
                                        switches: [
                                            [
                                                "scSpecEntryFunctionV0",
                                                "functionV0"
                                            ],
                                            [
                                                "scSpecEntryUdtStructV0",
                                                "udtStructV0"
                                            ],
                                            [
                                                "scSpecEntryUdtUnionV0",
                                                "udtUnionV0"
                                            ],
                                            [
                                                "scSpecEntryUdtEnumV0",
                                                "udtEnumV0"
                                            ],
                                            [
                                                "scSpecEntryUdtErrorEnumV0",
                                                "udtErrorEnumV0"
                                            ],
                                            [
                                                "scSpecEntryEventV0",
                                                "eventV0"
                                            ]
                                        ],
                                        arms: {
                                            functionV0: e.lookup("ScSpecFunctionV0"),
                                            udtStructV0: e.lookup("ScSpecUdtStructV0"),
                                            udtUnionV0: e.lookup("ScSpecUdtUnionV0"),
                                            udtEnumV0: e.lookup("ScSpecUdtEnumV0"),
                                            udtErrorEnumV0: e.lookup("ScSpecUdtErrorEnumV0"),
                                            eventV0: e.lookup("ScSpecEventV0")
                                        }
                                    }), e.typedef("EncodedLedgerKey", e.varOpaque()), e.struct("ConfigSettingContractExecutionLanesV0", [
                                        [
                                            "ledgerMaxTxCount",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ConfigSettingContractComputeV0", [
                                        [
                                            "ledgerMaxInstructions",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "txMaxInstructions",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "feeRatePerInstructionsIncrement",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "txMemoryLimit",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ConfigSettingContractParallelComputeV0", [
                                        [
                                            "ledgerMaxDependentTxClusters",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ConfigSettingContractLedgerCostV0", [
                                        [
                                            "ledgerMaxDiskReadEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ledgerMaxDiskReadBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ledgerMaxWriteLedgerEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ledgerMaxWriteBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txMaxDiskReadEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txMaxDiskReadBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txMaxWriteLedgerEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txMaxWriteBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "feeDiskReadLedgerEntry",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "feeWriteLedgerEntry",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "feeDiskRead1Kb",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "sorobanStateTargetSizeBytes",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "rentFee1KbSorobanStateSizeLow",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "rentFee1KbSorobanStateSizeHigh",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "sorobanStateRentFeeGrowthFactor",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("ConfigSettingContractLedgerCostExtV0", [
                                        [
                                            "txMaxFootprintEntries",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "feeWrite1Kb",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ConfigSettingContractHistoricalDataV0", [
                                        [
                                            "feeHistorical1Kb",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ConfigSettingContractEventsV0", [
                                        [
                                            "txMaxContractEventsSizeBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "feeContractEvents1Kb",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("ConfigSettingContractBandwidthV0", [
                                        [
                                            "ledgerMaxTxsSizeBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "txMaxSizeBytes",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "feeTxSize1Kb",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.enum("ContractCostType", {
                                        wasmInsnExec: 0,
                                        memAlloc: 1,
                                        memCpy: 2,
                                        memCmp: 3,
                                        dispatchHostFunction: 4,
                                        visitObject: 5,
                                        valSer: 6,
                                        valDeser: 7,
                                        computeSha256Hash: 8,
                                        computeEd25519PubKey: 9,
                                        verifyEd25519Sig: 10,
                                        vmInstantiation: 11,
                                        vmCachedInstantiation: 12,
                                        invokeVmFunction: 13,
                                        computeKeccak256Hash: 14,
                                        decodeEcdsaCurve256Sig: 15,
                                        recoverEcdsaSecp256k1Key: 16,
                                        int256AddSub: 17,
                                        int256Mul: 18,
                                        int256Div: 19,
                                        int256Pow: 20,
                                        int256Shift: 21,
                                        chaCha20DrawBytes: 22,
                                        parseWasmInstructions: 23,
                                        parseWasmFunctions: 24,
                                        parseWasmGlobals: 25,
                                        parseWasmTableEntries: 26,
                                        parseWasmTypes: 27,
                                        parseWasmDataSegments: 28,
                                        parseWasmElemSegments: 29,
                                        parseWasmImports: 30,
                                        parseWasmExports: 31,
                                        parseWasmDataSegmentBytes: 32,
                                        instantiateWasmInstructions: 33,
                                        instantiateWasmFunctions: 34,
                                        instantiateWasmGlobals: 35,
                                        instantiateWasmTableEntries: 36,
                                        instantiateWasmTypes: 37,
                                        instantiateWasmDataSegments: 38,
                                        instantiateWasmElemSegments: 39,
                                        instantiateWasmImports: 40,
                                        instantiateWasmExports: 41,
                                        instantiateWasmDataSegmentBytes: 42,
                                        sec1DecodePointUncompressed: 43,
                                        verifyEcdsaSecp256r1Sig: 44,
                                        bls12381EncodeFp: 45,
                                        bls12381DecodeFp: 46,
                                        bls12381G1CheckPointOnCurve: 47,
                                        bls12381G1CheckPointInSubgroup: 48,
                                        bls12381G2CheckPointOnCurve: 49,
                                        bls12381G2CheckPointInSubgroup: 50,
                                        bls12381G1ProjectiveToAffine: 51,
                                        bls12381G2ProjectiveToAffine: 52,
                                        bls12381G1Add: 53,
                                        bls12381G1Mul: 54,
                                        bls12381G1Msm: 55,
                                        bls12381MapFpToG1: 56,
                                        bls12381HashToG1: 57,
                                        bls12381G2Add: 58,
                                        bls12381G2Mul: 59,
                                        bls12381G2Msm: 60,
                                        bls12381MapFp2ToG2: 61,
                                        bls12381HashToG2: 62,
                                        bls12381Pairing: 63,
                                        bls12381FrFromU256: 64,
                                        bls12381FrToU256: 65,
                                        bls12381FrAddSub: 66,
                                        bls12381FrMul: 67,
                                        bls12381FrPow: 68,
                                        bls12381FrInv: 69,
                                        bn254EncodeFp: 70,
                                        bn254DecodeFp: 71,
                                        bn254G1CheckPointOnCurve: 72,
                                        bn254G2CheckPointOnCurve: 73,
                                        bn254G2CheckPointInSubgroup: 74,
                                        bn254G1ProjectiveToAffine: 75,
                                        bn254G1Add: 76,
                                        bn254G1Mul: 77,
                                        bn254Pairing: 78,
                                        bn254FrFromU256: 79,
                                        bn254FrToU256: 80,
                                        bn254FrAddSub: 81,
                                        bn254FrMul: 82,
                                        bn254FrPow: 83,
                                        bn254FrInv: 84,
                                        bn254G1Msm: 85
                                    }), e.struct("ContractCostParamEntry", [
                                        [
                                            "ext",
                                            e.lookup("ExtensionPoint")
                                        ],
                                        [
                                            "constTerm",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "linearTerm",
                                            e.lookup("Int64")
                                        ]
                                    ]), e.struct("StateArchivalSettings", [
                                        [
                                            "maxEntryTtl",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "minTemporaryTtl",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "minPersistentTtl",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "persistentRentRateDenominator",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "tempRentRateDenominator",
                                            e.lookup("Int64")
                                        ],
                                        [
                                            "maxEntriesToArchive",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "liveSorobanStateSizeWindowSampleSize",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "liveSorobanStateSizeWindowSamplePeriod",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "evictionScanSize",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "startingEvictionScanLevel",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("EvictionIterator", [
                                        [
                                            "bucketListLevel",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "isCurrBucket",
                                            e.bool()
                                        ],
                                        [
                                            "bucketFileOffset",
                                            e.lookup("Uint64")
                                        ]
                                    ]), e.struct("ConfigSettingScpTiming", [
                                        [
                                            "ledgerTargetCloseTimeMilliseconds",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nominationTimeoutInitialMilliseconds",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "nominationTimeoutIncrementMilliseconds",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ballotTimeoutInitialMilliseconds",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ballotTimeoutIncrementMilliseconds",
                                            e.lookup("Uint32")
                                        ]
                                    ]), e.struct("FrozenLedgerKeys", [
                                        [
                                            "keys",
                                            e.varArray(e.lookup("EncodedLedgerKey"), 2147483647)
                                        ]
                                    ]), e.struct("FrozenLedgerKeysDelta", [
                                        [
                                            "keysToFreeze",
                                            e.varArray(e.lookup("EncodedLedgerKey"), 2147483647)
                                        ],
                                        [
                                            "keysToUnfreeze",
                                            e.varArray(e.lookup("EncodedLedgerKey"), 2147483647)
                                        ]
                                    ]), e.struct("FreezeBypassTxes", [
                                        [
                                            "txHashes",
                                            e.varArray(e.lookup("Hash"), 2147483647)
                                        ]
                                    ]), e.struct("FreezeBypassTxsDelta", [
                                        [
                                            "addTxes",
                                            e.varArray(e.lookup("Hash"), 2147483647)
                                        ],
                                        [
                                            "removeTxes",
                                            e.varArray(e.lookup("Hash"), 2147483647)
                                        ]
                                    ]), e.const("CONTRACT_COST_COUNT_LIMIT", 1024), e.typedef("ContractCostParams", e.varArray(e.lookup("ContractCostParamEntry"), e.lookup("CONTRACT_COST_COUNT_LIMIT"))), e.enum("ConfigSettingId", {
                                        configSettingContractMaxSizeBytes: 0,
                                        configSettingContractComputeV0: 1,
                                        configSettingContractLedgerCostV0: 2,
                                        configSettingContractHistoricalDataV0: 3,
                                        configSettingContractEventsV0: 4,
                                        configSettingContractBandwidthV0: 5,
                                        configSettingContractCostParamsCpuInstructions: 6,
                                        configSettingContractCostParamsMemoryBytes: 7,
                                        configSettingContractDataKeySizeBytes: 8,
                                        configSettingContractDataEntrySizeBytes: 9,
                                        configSettingStateArchival: 10,
                                        configSettingContractExecutionLanes: 11,
                                        configSettingLiveSorobanStateSizeWindow: 12,
                                        configSettingEvictionIterator: 13,
                                        configSettingContractParallelComputeV0: 14,
                                        configSettingContractLedgerCostExtV0: 15,
                                        configSettingScpTiming: 16,
                                        configSettingFrozenLedgerKeys: 17,
                                        configSettingFrozenLedgerKeysDelta: 18,
                                        configSettingFreezeBypassTxes: 19,
                                        configSettingFreezeBypassTxsDelta: 20
                                    }), e.union("ConfigSettingEntry", {
                                        switchOn: e.lookup("ConfigSettingId"),
                                        switchName: "configSettingId",
                                        switches: [
                                            [
                                                "configSettingContractMaxSizeBytes",
                                                "contractMaxSizeBytes"
                                            ],
                                            [
                                                "configSettingContractComputeV0",
                                                "contractCompute"
                                            ],
                                            [
                                                "configSettingContractLedgerCostV0",
                                                "contractLedgerCost"
                                            ],
                                            [
                                                "configSettingContractHistoricalDataV0",
                                                "contractHistoricalData"
                                            ],
                                            [
                                                "configSettingContractEventsV0",
                                                "contractEvents"
                                            ],
                                            [
                                                "configSettingContractBandwidthV0",
                                                "contractBandwidth"
                                            ],
                                            [
                                                "configSettingContractCostParamsCpuInstructions",
                                                "contractCostParamsCpuInsns"
                                            ],
                                            [
                                                "configSettingContractCostParamsMemoryBytes",
                                                "contractCostParamsMemBytes"
                                            ],
                                            [
                                                "configSettingContractDataKeySizeBytes",
                                                "contractDataKeySizeBytes"
                                            ],
                                            [
                                                "configSettingContractDataEntrySizeBytes",
                                                "contractDataEntrySizeBytes"
                                            ],
                                            [
                                                "configSettingStateArchival",
                                                "stateArchivalSettings"
                                            ],
                                            [
                                                "configSettingContractExecutionLanes",
                                                "contractExecutionLanes"
                                            ],
                                            [
                                                "configSettingLiveSorobanStateSizeWindow",
                                                "liveSorobanStateSizeWindow"
                                            ],
                                            [
                                                "configSettingEvictionIterator",
                                                "evictionIterator"
                                            ],
                                            [
                                                "configSettingContractParallelComputeV0",
                                                "contractParallelCompute"
                                            ],
                                            [
                                                "configSettingContractLedgerCostExtV0",
                                                "contractLedgerCostExt"
                                            ],
                                            [
                                                "configSettingScpTiming",
                                                "contractScpTiming"
                                            ],
                                            [
                                                "configSettingFrozenLedgerKeys",
                                                "frozenLedgerKeys"
                                            ],
                                            [
                                                "configSettingFrozenLedgerKeysDelta",
                                                "frozenLedgerKeysDelta"
                                            ],
                                            [
                                                "configSettingFreezeBypassTxes",
                                                "freezeBypassTxes"
                                            ],
                                            [
                                                "configSettingFreezeBypassTxsDelta",
                                                "freezeBypassTxsDelta"
                                            ]
                                        ],
                                        arms: {
                                            contractMaxSizeBytes: e.lookup("Uint32"),
                                            contractCompute: e.lookup("ConfigSettingContractComputeV0"),
                                            contractLedgerCost: e.lookup("ConfigSettingContractLedgerCostV0"),
                                            contractHistoricalData: e.lookup("ConfigSettingContractHistoricalDataV0"),
                                            contractEvents: e.lookup("ConfigSettingContractEventsV0"),
                                            contractBandwidth: e.lookup("ConfigSettingContractBandwidthV0"),
                                            contractCostParamsCpuInsns: e.lookup("ContractCostParams"),
                                            contractCostParamsMemBytes: e.lookup("ContractCostParams"),
                                            contractDataKeySizeBytes: e.lookup("Uint32"),
                                            contractDataEntrySizeBytes: e.lookup("Uint32"),
                                            stateArchivalSettings: e.lookup("StateArchivalSettings"),
                                            contractExecutionLanes: e.lookup("ConfigSettingContractExecutionLanesV0"),
                                            liveSorobanStateSizeWindow: e.varArray(e.lookup("Uint64"), 2147483647),
                                            evictionIterator: e.lookup("EvictionIterator"),
                                            contractParallelCompute: e.lookup("ConfigSettingContractParallelComputeV0"),
                                            contractLedgerCostExt: e.lookup("ConfigSettingContractLedgerCostExtV0"),
                                            contractScpTiming: e.lookup("ConfigSettingScpTiming"),
                                            frozenLedgerKeys: e.lookup("FrozenLedgerKeys"),
                                            frozenLedgerKeysDelta: e.lookup("FrozenLedgerKeysDelta"),
                                            freezeBypassTxes: e.lookup("FreezeBypassTxes"),
                                            freezeBypassTxsDelta: e.lookup("FreezeBypassTxsDelta")
                                        }
                                    }), e.struct("LedgerCloseMetaBatch", [
                                        [
                                            "startSequence",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "endSequence",
                                            e.lookup("Uint32")
                                        ],
                                        [
                                            "ledgerCloseMeta",
                                            e.varArray(e.lookup("LedgerCloseMeta"), 2147483647)
                                        ]
                                    ]);
                                });
                                const i = o, a = {
                                    XdrWriter: n.XdrWriter,
                                    XdrReader: n.XdrReader
                                };
                                var s = r(2802);
                                function u(e) {
                                    var t = new s.sha256;
                                    return t.update(e, "utf8"), t.digest();
                                }
                                const c = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
                                function l(e) {
                                    return e instanceof Uint8Array || ArrayBuffer.isView(e) && "Uint8Array" === e.constructor.name;
                                }
                                function f(e, ...t) {
                                    if (!l(e)) throw new Error("Uint8Array expected");
                                    if (t.length > 0 && !t.includes(e.length)) throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
                                }
                                function p(e, t = !0) {
                                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                                }
                                function d(...e) {
                                    for(let t = 0; t < e.length; t++)e[t].fill(0);
                                }
                                function h(e) {
                                    return new DataView(e.buffer, e.byteOffset, e.byteLength);
                                }
                                const y = "function" == typeof Uint8Array.from([]).toHex && "function" == typeof Uint8Array.fromHex, m = Array.from({
                                    length: 256
                                }, (e, t)=>t.toString(16).padStart(2, "0"));
                                function g(e) {
                                    if (f(e), y) return e.toHex();
                                    let t = "";
                                    for(let r = 0; r < e.length; r++)t += m[e[r]];
                                    return t;
                                }
                                function v(e) {
                                    return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : void 0;
                                }
                                function b(e) {
                                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                                    if (y) return Uint8Array.fromHex(e);
                                    const t = e.length, r = t / 2;
                                    if (t % 2) throw new Error("hex string expected, got unpadded hex of length " + t);
                                    const n = new Uint8Array(r);
                                    for(let t = 0, o = 0; t < r; t++, o += 2){
                                        const r = v(e.charCodeAt(o)), i = v(e.charCodeAt(o + 1));
                                        if (void 0 === r || void 0 === i) {
                                            const t = e[o] + e[o + 1];
                                            throw new Error('hex string expected, got non-hex character "' + t + '" at index ' + o);
                                        }
                                        n[t] = 16 * r + i;
                                    }
                                    return n;
                                }
                                function w(e) {
                                    if ("string" != typeof e) throw new Error("string expected");
                                    return new Uint8Array((new TextEncoder).encode(e));
                                }
                                function S(e) {
                                    return "string" == typeof e && (e = w(e)), f(e), e;
                                }
                                function A(...e) {
                                    let t = 0;
                                    for(let r = 0; r < e.length; r++){
                                        const n = e[r];
                                        f(n), t += n.length;
                                    }
                                    const r = new Uint8Array(t);
                                    for(let t = 0, n = 0; t < e.length; t++){
                                        const o = e[t];
                                        r.set(o, n), n += o.length;
                                    }
                                    return r;
                                }
                                class E {
                                }
                                function T(e = 32) {
                                    if (c && "function" == typeof c.getRandomValues) return c.getRandomValues(new Uint8Array(e));
                                    if (c && "function" == typeof c.randomBytes) return Uint8Array.from(c.randomBytes(e));
                                    throw new Error("crypto.getRandomValues must be defined");
                                }
                                class O extends E {
                                    constructor(e, t, r, n){
                                        super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.buffer = new Uint8Array(e), this.view = h(this.buffer);
                                    }
                                    update(e) {
                                        p(this), f(e = S(e));
                                        const { view: t, buffer: r, blockLen: n } = this, o = e.length;
                                        for(let i = 0; i < o;){
                                            const a = Math.min(n - this.pos, o - i);
                                            if (a === n) {
                                                const t = h(e);
                                                for(; n <= o - i; i += n)this.process(t, i);
                                                continue;
                                            }
                                            r.set(e.subarray(i, i + a), this.pos), this.pos += a, i += a, this.pos === n && (this.process(t, 0), this.pos = 0);
                                        }
                                        return this.length += e.length, this.roundClean(), this;
                                    }
                                    digestInto(e) {
                                        p(this), function(e, t) {
                                            f(e);
                                            const r = t.outputLen;
                                            if (e.length < r) throw new Error("digestInto() expects output buffer of length at least " + r);
                                        }(e, this), this.finished = !0;
                                        const { buffer: t, view: r, blockLen: n, isLE: o } = this;
                                        let { pos: i } = this;
                                        t[i++] = 128, d(this.buffer.subarray(i)), this.padOffset > n - i && (this.process(r, 0), i = 0);
                                        for(let e = i; e < n; e++)t[e] = 0;
                                        !function(e, t, r, n) {
                                            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
                                            const o = BigInt(32), i = BigInt(4294967295), a = Number(r >> o & i), s = Number(r & i), u = n ? 4 : 0, c = n ? 0 : 4;
                                            e.setUint32(t + u, a, n), e.setUint32(t + c, s, n);
                                        }(r, n - 8, BigInt(8 * this.length), o), this.process(r, 0);
                                        const a = h(e), s = this.outputLen;
                                        if (s % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                                        const u = s / 4, c = this.get();
                                        if (u > c.length) throw new Error("_sha2: outputLen bigger than state");
                                        for(let e = 0; e < u; e++)a.setUint32(4 * e, c[e], o);
                                    }
                                    digest() {
                                        const { buffer: e, outputLen: t } = this;
                                        this.digestInto(e);
                                        const r = e.slice(0, t);
                                        return this.destroy(), r;
                                    }
                                    _cloneInto(e) {
                                        e || (e = new this.constructor), e.set(...this.get());
                                        const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: a } = this;
                                        return e.destroyed = i, e.finished = o, e.length = n, e.pos = a, n % t && e.buffer.set(r), e;
                                    }
                                    clone() {
                                        return this._cloneInto();
                                    }
                                }
                                const k = Uint32Array.from([
                                    1779033703,
                                    4089235720,
                                    3144134277,
                                    2227873595,
                                    1013904242,
                                    4271175723,
                                    2773480762,
                                    1595750129,
                                    1359893119,
                                    2917565137,
                                    2600822924,
                                    725511199,
                                    528734635,
                                    4215389547,
                                    1541459225,
                                    327033209
                                ]), _ = BigInt(2 ** 32 - 1), x = BigInt(32);
                                function P(e, t = !1) {
                                    return t ? {
                                        h: Number(e & _),
                                        l: Number(e >> x & _)
                                    } : {
                                        h: 0 | Number(e >> x & _),
                                        l: 0 | Number(e & _)
                                    };
                                }
                                const R = (e, t, r)=>e >>> r, I = (e, t, r)=>e << 32 - r | t >>> r, B = (e, t, r)=>e >>> r | t << 32 - r, C = (e, t, r)=>e << 32 - r | t >>> r, j = (e, t, r)=>e << 64 - r | t >>> r - 32, U = (e, t, r)=>e >>> r - 32 | t << 64 - r;
                                function N(e, t, r, n) {
                                    const o = (t >>> 0) + (n >>> 0);
                                    return {
                                        h: e + r + (o / 2 ** 32 | 0) | 0,
                                        l: 0 | o
                                    };
                                }
                                const L = (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0), F = (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0, D = (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), M = (e, t, r, n, o)=>t + r + n + o + (e / 2 ** 32 | 0) | 0, V = (e, t, r, n, o)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), q = (e, t, r, n, o, i)=>t + r + n + o + i + (e / 2 ** 32 | 0) | 0, G = function(e, t = !1) {
                                    const r = e.length;
                                    let n = new Uint32Array(r), o = new Uint32Array(r);
                                    for(let i = 0; i < r; i++){
                                        const { h: r, l: a } = P(e[i], t);
                                        [n[i], o[i]] = [
                                            r,
                                            a
                                        ];
                                    }
                                    return [
                                        n,
                                        o
                                    ];
                                }([
                                    "0x428a2f98d728ae22",
                                    "0x7137449123ef65cd",
                                    "0xb5c0fbcfec4d3b2f",
                                    "0xe9b5dba58189dbbc",
                                    "0x3956c25bf348b538",
                                    "0x59f111f1b605d019",
                                    "0x923f82a4af194f9b",
                                    "0xab1c5ed5da6d8118",
                                    "0xd807aa98a3030242",
                                    "0x12835b0145706fbe",
                                    "0x243185be4ee4b28c",
                                    "0x550c7dc3d5ffb4e2",
                                    "0x72be5d74f27b896f",
                                    "0x80deb1fe3b1696b1",
                                    "0x9bdc06a725c71235",
                                    "0xc19bf174cf692694",
                                    "0xe49b69c19ef14ad2",
                                    "0xefbe4786384f25e3",
                                    "0x0fc19dc68b8cd5b5",
                                    "0x240ca1cc77ac9c65",
                                    "0x2de92c6f592b0275",
                                    "0x4a7484aa6ea6e483",
                                    "0x5cb0a9dcbd41fbd4",
                                    "0x76f988da831153b5",
                                    "0x983e5152ee66dfab",
                                    "0xa831c66d2db43210",
                                    "0xb00327c898fb213f",
                                    "0xbf597fc7beef0ee4",
                                    "0xc6e00bf33da88fc2",
                                    "0xd5a79147930aa725",
                                    "0x06ca6351e003826f",
                                    "0x142929670a0e6e70",
                                    "0x27b70a8546d22ffc",
                                    "0x2e1b21385c26c926",
                                    "0x4d2c6dfc5ac42aed",
                                    "0x53380d139d95b3df",
                                    "0x650a73548baf63de",
                                    "0x766a0abb3c77b2a8",
                                    "0x81c2c92e47edaee6",
                                    "0x92722c851482353b",
                                    "0xa2bfe8a14cf10364",
                                    "0xa81a664bbc423001",
                                    "0xc24b8b70d0f89791",
                                    "0xc76c51a30654be30",
                                    "0xd192e819d6ef5218",
                                    "0xd69906245565a910",
                                    "0xf40e35855771202a",
                                    "0x106aa07032bbd1b8",
                                    "0x19a4c116b8d2d0c8",
                                    "0x1e376c085141ab53",
                                    "0x2748774cdf8eeb99",
                                    "0x34b0bcb5e19b48a8",
                                    "0x391c0cb3c5c95a63",
                                    "0x4ed8aa4ae3418acb",
                                    "0x5b9cca4f7763e373",
                                    "0x682e6ff3d6b2b8a3",
                                    "0x748f82ee5defb2fc",
                                    "0x78a5636f43172f60",
                                    "0x84c87814a1f0ab72",
                                    "0x8cc702081a6439ec",
                                    "0x90befffa23631e28",
                                    "0xa4506cebde82bde9",
                                    "0xbef9a3f7b2c67915",
                                    "0xc67178f2e372532b",
                                    "0xca273eceea26619c",
                                    "0xd186b8c721c0c207",
                                    "0xeada7dd6cde0eb1e",
                                    "0xf57d4f7fee6ed178",
                                    "0x06f067aa72176fba",
                                    "0x0a637dc5a2c898a6",
                                    "0x113f9804bef90dae",
                                    "0x1b710b35131c471b",
                                    "0x28db77f523047d84",
                                    "0x32caab7b40c72493",
                                    "0x3c9ebe0a15c9bebc",
                                    "0x431d67c49c100d4c",
                                    "0x4cc5d4becb3e42b6",
                                    "0x597f299cfc657e2a",
                                    "0x5fcb6fab3ad6faec",
                                    "0x6c44198c4a475817"
                                ].map((e)=>BigInt(e))), H = G[0], z = G[1], W = new Uint32Array(80), X = new Uint32Array(80);
                                class K extends O {
                                    constructor(e = 64){
                                        super(128, e, 16, !1), this.Ah = 0 | k[0], this.Al = 0 | k[1], this.Bh = 0 | k[2], this.Bl = 0 | k[3], this.Ch = 0 | k[4], this.Cl = 0 | k[5], this.Dh = 0 | k[6], this.Dl = 0 | k[7], this.Eh = 0 | k[8], this.El = 0 | k[9], this.Fh = 0 | k[10], this.Fl = 0 | k[11], this.Gh = 0 | k[12], this.Gl = 0 | k[13], this.Hh = 0 | k[14], this.Hl = 0 | k[15];
                                    }
                                    get() {
                                        const { Ah: e, Al: t, Bh: r, Bl: n, Ch: o, Cl: i, Dh: a, Dl: s, Eh: u, El: c, Fh: l, Fl: f, Gh: p, Gl: d, Hh: h, Hl: y } = this;
                                        return [
                                            e,
                                            t,
                                            r,
                                            n,
                                            o,
                                            i,
                                            a,
                                            s,
                                            u,
                                            c,
                                            l,
                                            f,
                                            p,
                                            d,
                                            h,
                                            y
                                        ];
                                    }
                                    set(e, t, r, n, o, i, a, s, u, c, l, f, p, d, h, y) {
                                        this.Ah = 0 | e, this.Al = 0 | t, this.Bh = 0 | r, this.Bl = 0 | n, this.Ch = 0 | o, this.Cl = 0 | i, this.Dh = 0 | a, this.Dl = 0 | s, this.Eh = 0 | u, this.El = 0 | c, this.Fh = 0 | l, this.Fl = 0 | f, this.Gh = 0 | p, this.Gl = 0 | d, this.Hh = 0 | h, this.Hl = 0 | y;
                                    }
                                    process(e, t) {
                                        for(let r = 0; r < 16; r++, t += 4)W[r] = e.getUint32(t), X[r] = e.getUint32(t += 4);
                                        for(let e = 16; e < 80; e++){
                                            const t = 0 | W[e - 15], r = 0 | X[e - 15], n = B(t, r, 1) ^ B(t, r, 8) ^ R(t, 0, 7), o = C(t, r, 1) ^ C(t, r, 8) ^ I(t, r, 7), i = 0 | W[e - 2], a = 0 | X[e - 2], s = B(i, a, 19) ^ j(i, a, 61) ^ R(i, 0, 6), u = C(i, a, 19) ^ U(i, a, 61) ^ I(i, a, 6), c = D(o, u, X[e - 7], X[e - 16]), l = M(c, n, s, W[e - 7], W[e - 16]);
                                            W[e] = 0 | l, X[e] = 0 | c;
                                        }
                                        let { Ah: r, Al: n, Bh: o, Bl: i, Ch: a, Cl: s, Dh: u, Dl: c, Eh: l, El: f, Fh: p, Fl: d, Gh: h, Gl: y, Hh: m, Hl: g } = this;
                                        for(let e = 0; e < 80; e++){
                                            const t = B(l, f, 14) ^ B(l, f, 18) ^ j(l, f, 41), v = C(l, f, 14) ^ C(l, f, 18) ^ U(l, f, 41), b = l & p ^ ~l & h, w = V(g, v, f & d ^ ~f & y, z[e], X[e]), S = q(w, m, t, b, H[e], W[e]), A = 0 | w, E = B(r, n, 28) ^ j(r, n, 34) ^ j(r, n, 39), T = C(r, n, 28) ^ U(r, n, 34) ^ U(r, n, 39), O = r & o ^ r & a ^ o & a, k = n & i ^ n & s ^ i & s;
                                            m = 0 | h, g = 0 | y, h = 0 | p, y = 0 | d, p = 0 | l, d = 0 | f, ({ h: l, l: f } = N(0 | u, 0 | c, 0 | S, 0 | A)), u = 0 | a, c = 0 | s, a = 0 | o, s = 0 | i, o = 0 | r, i = 0 | n;
                                            const _ = L(A, T, k);
                                            r = F(_, S, E, O), n = 0 | _;
                                        }
                                        ({ h: r, l: n } = N(0 | this.Ah, 0 | this.Al, 0 | r, 0 | n)), ({ h: o, l: i } = N(0 | this.Bh, 0 | this.Bl, 0 | o, 0 | i)), ({ h: a, l: s } = N(0 | this.Ch, 0 | this.Cl, 0 | a, 0 | s)), ({ h: u, l: c } = N(0 | this.Dh, 0 | this.Dl, 0 | u, 0 | c)), ({ h: l, l: f } = N(0 | this.Eh, 0 | this.El, 0 | l, 0 | f)), ({ h: p, l: d } = N(0 | this.Fh, 0 | this.Fl, 0 | p, 0 | d)), ({ h: h, l: y } = N(0 | this.Gh, 0 | this.Gl, 0 | h, 0 | y)), ({ h: m, l: g } = N(0 | this.Hh, 0 | this.Hl, 0 | m, 0 | g)), this.set(r, n, o, i, a, s, u, c, l, f, p, d, h, y, m, g);
                                    }
                                    roundClean() {
                                        d(W, X);
                                    }
                                    destroy() {
                                        d(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                                    }
                                }
                                const Z = function(e) {
                                    const t = (t)=>e().update(S(t)).digest(), r = e();
                                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                                }(()=>new K), $ = BigInt(0), Y = BigInt(1);
                                function Q(e, t = "") {
                                    if ("boolean" != typeof e) throw new Error((t && `"${t}"`) + "expected boolean, got type=" + typeof e);
                                    return e;
                                }
                                function J(e, t, r = "") {
                                    const n = l(e), o = e?.length, i = void 0 !== t;
                                    if (!n || i && o !== t) throw new Error((r && `"${r}" `) + "expected Uint8Array" + (i ? ` of length ${t}` : "") + ", got " + (n ? `length=${o}` : "type=" + typeof e));
                                    return e;
                                }
                                function ee(e) {
                                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                                    return "" === e ? $ : BigInt("0x" + e);
                                }
                                function te(e) {
                                    return f(e), ee(g(Uint8Array.from(e).reverse()));
                                }
                                function re(e, t) {
                                    return b(e.toString(16).padStart(2 * t, "0"));
                                }
                                function ne(e, t, r) {
                                    let n;
                                    if ("string" == typeof t) try {
                                        n = b(t);
                                    } catch (t) {
                                        throw new Error(e + " must be hex string or Uint8Array, cause: " + t);
                                    }
                                    else {
                                        if (!l(t)) throw new Error(e + " must be hex string or Uint8Array");
                                        n = Uint8Array.from(t);
                                    }
                                    const o = n.length;
                                    if ("number" == typeof r && o !== r) throw new Error(e + " of length " + r + " expected, got " + o);
                                    return n;
                                }
                                function oe(e) {
                                    return Uint8Array.from(e);
                                }
                                const ie = (e)=>"bigint" == typeof e && $ <= e;
                                function ae(e, t, r, n) {
                                    if (!function(e, t, r) {
                                        return ie(e) && ie(t) && ie(r) && t <= e && e < r;
                                    }(t, r, n)) throw new Error("expected valid " + e + ": " + r + " <= n < " + n + ", got " + t);
                                }
                                const se = (e)=>(Y << BigInt(e)) - Y;
                                function ue(e, t, r = {}) {
                                    if (!e || "object" != typeof e) throw new Error("expected valid options object");
                                    function n(t, r, n) {
                                        const o = e[t];
                                        if (n && void 0 === o) return;
                                        const i = typeof o;
                                        if (i !== r || null === o) throw new Error(`param "${t}" is invalid: expected ${r}, got ${i}`);
                                    }
                                    Object.entries(t).forEach(([e, t])=>n(e, t, !1)), Object.entries(r).forEach(([e, t])=>n(e, t, !0));
                                }
                                const ce = ()=>{
                                    throw new Error("not implemented");
                                };
                                function le(e) {
                                    const t = new WeakMap;
                                    return (r, ...n)=>{
                                        const o = t.get(r);
                                        if (void 0 !== o) return o;
                                        const i = e(r, ...n);
                                        return t.set(r, i), i;
                                    };
                                }
                                const fe = BigInt(0), pe = BigInt(1), de = BigInt(2), he = BigInt(3), ye = BigInt(4), me = BigInt(5), ge = BigInt(7), ve = BigInt(8), be = BigInt(9), we = BigInt(16);
                                function Se(e, t) {
                                    const r = e % t;
                                    return r >= fe ? r : t + r;
                                }
                                function Ae(e, t, r) {
                                    let n = e;
                                    for(; t-- > fe;)n *= n, n %= r;
                                    return n;
                                }
                                function Ee(e, t) {
                                    if (e === fe) throw new Error("invert: expected non-zero number");
                                    if (t <= fe) throw new Error("invert: expected positive modulus, got " + t);
                                    let r = Se(e, t), n = t, o = fe, i = pe, a = pe, s = fe;
                                    for(; r !== fe;){
                                        const e = n / r, t = n % r, u = o - a * e, c = i - s * e;
                                        n = r, r = t, o = a, i = s, a = u, s = c;
                                    }
                                    if (n !== pe) throw new Error("invert: does not exist");
                                    return Se(o, t);
                                }
                                function Te(e, t, r) {
                                    if (!e.eql(e.sqr(t), r)) throw new Error("Cannot find square root");
                                }
                                function Oe(e, t) {
                                    const r = (e.ORDER + pe) / ye, n = e.pow(t, r);
                                    return Te(e, n, t), n;
                                }
                                function ke(e, t) {
                                    const r = (e.ORDER - me) / ve, n = e.mul(t, de), o = e.pow(n, r), i = e.mul(t, o), a = e.mul(e.mul(i, de), o), s = e.mul(i, e.sub(a, e.ONE));
                                    return Te(e, s, t), s;
                                }
                                function _e(e) {
                                    if (e < he) throw new Error("sqrt is not defined for small field");
                                    let t = e - pe, r = 0;
                                    for(; t % de === fe;)t /= de, r++;
                                    let n = de;
                                    const o = Ce(e);
                                    for(; 1 === Ie(o, n);)if (n++ > 1e3) throw new Error("Cannot find square root: probably non-prime P");
                                    if (1 === r) return Oe;
                                    let i = o.pow(n, t);
                                    const a = (t + pe) / de;
                                    return function(e, n) {
                                        if (e.is0(n)) return n;
                                        if (1 !== Ie(e, n)) throw new Error("Cannot find square root");
                                        let o = r, s = e.mul(e.ONE, i), u = e.pow(n, t), c = e.pow(n, a);
                                        for(; !e.eql(u, e.ONE);){
                                            if (e.is0(u)) return e.ZERO;
                                            let t = 1, r = e.sqr(u);
                                            for(; !e.eql(r, e.ONE);)if (t++, r = e.sqr(r), t === o) throw new Error("Cannot find square root");
                                            const n = pe << BigInt(o - t - 1), i = e.pow(s, n);
                                            o = t, s = e.sqr(i), u = e.mul(u, s), c = e.mul(c, i);
                                        }
                                        return c;
                                    };
                                }
                                const xe = (e, t)=>(Se(e, t) & pe) === pe, Pe = [
                                    "create",
                                    "isValid",
                                    "is0",
                                    "neg",
                                    "inv",
                                    "sqrt",
                                    "sqr",
                                    "eql",
                                    "add",
                                    "sub",
                                    "mul",
                                    "pow",
                                    "div",
                                    "addN",
                                    "subN",
                                    "mulN",
                                    "sqrN"
                                ];
                                function Re(e, t, r = !1) {
                                    const n = new Array(t.length).fill(r ? e.ZERO : void 0), o = t.reduce((t, r, o)=>e.is0(r) ? t : (n[o] = t, e.mul(t, r)), e.ONE), i = e.inv(o);
                                    return t.reduceRight((t, r, o)=>e.is0(r) ? t : (n[o] = e.mul(t, n[o]), e.mul(t, r)), i), n;
                                }
                                function Ie(e, t) {
                                    const r = (e.ORDER - pe) / de, n = e.pow(t, r), o = e.eql(n, e.ONE), i = e.eql(n, e.ZERO), a = e.eql(n, e.neg(e.ONE));
                                    if (!o && !i && !a) throw new Error("invalid Legendre symbol result");
                                    return o ? 1 : i ? 0 : -1;
                                }
                                function Be(e, t) {
                                    void 0 !== t && function(e) {
                                        if (!Number.isSafeInteger(e) || e < 0) throw new Error("positive integer expected, got " + e);
                                    }(t);
                                    const r = void 0 !== t ? t : e.toString(2).length;
                                    return {
                                        nBitLength: r,
                                        nByteLength: Math.ceil(r / 8)
                                    };
                                }
                                function Ce(e, t, r = !1, n = {}) {
                                    if (e <= fe) throw new Error("invalid field: expected ORDER > 0, got " + e);
                                    let o, i, a, s = !1;
                                    if ("object" == typeof t && null != t) {
                                        if (n.sqrt || r) throw new Error("cannot specify opts in two arguments");
                                        const e = t;
                                        e.BITS && (o = e.BITS), e.sqrt && (i = e.sqrt), "boolean" == typeof e.isLE && (r = e.isLE), "boolean" == typeof e.modFromBytes && (s = e.modFromBytes), a = e.allowedLengths;
                                    } else "number" == typeof t && (o = t), n.sqrt && (i = n.sqrt);
                                    const { nBitLength: u, nByteLength: c } = Be(e, o);
                                    if (c > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
                                    let l;
                                    const f = Object.freeze({
                                        ORDER: e,
                                        isLE: r,
                                        BITS: u,
                                        BYTES: c,
                                        MASK: se(u),
                                        ZERO: fe,
                                        ONE: pe,
                                        allowedLengths: a,
                                        create: (t)=>Se(t, e),
                                        isValid: (t)=>{
                                            if ("bigint" != typeof t) throw new Error("invalid field element: expected bigint, got " + typeof t);
                                            return fe <= t && t < e;
                                        },
                                        is0: (e)=>e === fe,
                                        isValidNot0: (e)=>!f.is0(e) && f.isValid(e),
                                        isOdd: (e)=>(e & pe) === pe,
                                        neg: (t)=>Se(-t, e),
                                        eql: (e, t)=>e === t,
                                        sqr: (t)=>Se(t * t, e),
                                        add: (t, r)=>Se(t + r, e),
                                        sub: (t, r)=>Se(t - r, e),
                                        mul: (t, r)=>Se(t * r, e),
                                        pow: (e, t)=>(function(e, t, r) {
                                                if (r < fe) throw new Error("invalid exponent, negatives unsupported");
                                                if (r === fe) return e.ONE;
                                                if (r === pe) return t;
                                                let n = e.ONE, o = t;
                                                for(; r > fe;)r & pe && (n = e.mul(n, o)), o = e.sqr(o), r >>= pe;
                                                return n;
                                            })(f, e, t),
                                        div: (t, r)=>Se(t * Ee(r, e), e),
                                        sqrN: (e)=>e * e,
                                        addN: (e, t)=>e + t,
                                        subN: (e, t)=>e - t,
                                        mulN: (e, t)=>e * t,
                                        inv: (t)=>Ee(t, e),
                                        sqrt: i || ((t)=>(l || (l = function(e) {
                                                return e % ye === he ? Oe : e % ve === me ? ke : e % we === be ? function(e) {
                                                    const t = Ce(e), r = _e(e), n = r(t, t.neg(t.ONE)), o = r(t, n), i = r(t, t.neg(n)), a = (e + ge) / we;
                                                    return (e, t)=>{
                                                        let r = e.pow(t, a), s = e.mul(r, n);
                                                        const u = e.mul(r, o), c = e.mul(r, i), l = e.eql(e.sqr(s), t), f = e.eql(e.sqr(u), t);
                                                        r = e.cmov(r, s, l), s = e.cmov(c, u, f);
                                                        const p = e.eql(e.sqr(s), t), d = e.cmov(r, s, p);
                                                        return Te(e, d, t), d;
                                                    };
                                                }(e) : _e(e);
                                            }(e)), l(f, t))),
                                        toBytes: (e)=>r ? re(e, c).reverse() : re(e, c),
                                        fromBytes: (t, n = !0)=>{
                                            if (a) {
                                                if (!a.includes(t.length) || t.length > c) throw new Error("Field.fromBytes: expected " + a + " bytes, got " + t.length);
                                                const e = new Uint8Array(c);
                                                e.set(t, r ? 0 : e.length - t.length), t = e;
                                            }
                                            if (t.length !== c) throw new Error("Field.fromBytes: expected " + c + " bytes, got " + t.length);
                                            let o = r ? te(t) : function(e) {
                                                return ee(g(e));
                                            }(t);
                                            if (s && (o = Se(o, e)), !n && !f.isValid(o)) throw new Error("invalid field element: outside of range 0..ORDER");
                                            return o;
                                        },
                                        invertBatch: (e)=>Re(f, e),
                                        cmov: (e, t, r)=>r ? t : e
                                    });
                                    return Object.freeze(f);
                                }
                                const je = BigInt(0), Ue = BigInt(1);
                                function Ne(e, t) {
                                    const r = t.negate();
                                    return e ? r : t;
                                }
                                function Le(e, t) {
                                    const r = Re(e.Fp, t.map((e)=>e.Z));
                                    return t.map((t, n)=>e.fromAffine(t.toAffine(r[n])));
                                }
                                function Fe(e, t) {
                                    if (!Number.isSafeInteger(e) || e <= 0 || e > t) throw new Error("invalid window size, expected [1.." + t + "], got W=" + e);
                                }
                                function De(e, t) {
                                    Fe(e, t);
                                    const r = 2 ** e;
                                    return {
                                        windows: Math.ceil(t / e) + 1,
                                        windowSize: 2 ** (e - 1),
                                        mask: se(e),
                                        maxNumber: r,
                                        shiftBy: BigInt(e)
                                    };
                                }
                                function Me(e, t, r) {
                                    const { windowSize: n, mask: o, maxNumber: i, shiftBy: a } = r;
                                    let s = Number(e & o), u = e >> a;
                                    s > n && (s -= i, u += Ue);
                                    const c = t * n;
                                    return {
                                        nextN: u,
                                        offset: c + Math.abs(s) - 1,
                                        isZero: 0 === s,
                                        isNeg: s < 0,
                                        isNegF: t % 2 != 0,
                                        offsetF: c
                                    };
                                }
                                const Ve = new WeakMap, qe = new WeakMap;
                                function Ge(e) {
                                    return qe.get(e) || 1;
                                }
                                function He(e) {
                                    if (e !== je) throw new Error("invalid wNAF");
                                }
                                class ze {
                                    constructor(e, t){
                                        this.BASE = e.BASE, this.ZERO = e.ZERO, this.Fn = e.Fn, this.bits = t;
                                    }
                                    _unsafeLadder(e, t, r = this.ZERO) {
                                        let n = e;
                                        for(; t > je;)t & Ue && (r = r.add(n)), n = n.double(), t >>= Ue;
                                        return r;
                                    }
                                    precomputeWindow(e, t) {
                                        const { windows: r, windowSize: n } = De(t, this.bits), o = [];
                                        let i = e, a = i;
                                        for(let e = 0; e < r; e++){
                                            a = i, o.push(a);
                                            for(let e = 1; e < n; e++)a = a.add(i), o.push(a);
                                            i = a.double();
                                        }
                                        return o;
                                    }
                                    wNAF(e, t, r) {
                                        if (!this.Fn.isValid(r)) throw new Error("invalid scalar");
                                        let n = this.ZERO, o = this.BASE;
                                        const i = De(e, this.bits);
                                        for(let e = 0; e < i.windows; e++){
                                            const { nextN: a, offset: s, isZero: u, isNeg: c, isNegF: l, offsetF: f } = Me(r, e, i);
                                            r = a, u ? o = o.add(Ne(l, t[f])) : n = n.add(Ne(c, t[s]));
                                        }
                                        return He(r), {
                                            p: n,
                                            f: o
                                        };
                                    }
                                    wNAFUnsafe(e, t, r, n = this.ZERO) {
                                        const o = De(e, this.bits);
                                        for(let e = 0; e < o.windows && r !== je; e++){
                                            const { nextN: i, offset: a, isZero: s, isNeg: u } = Me(r, e, o);
                                            if (r = i, !s) {
                                                const e = t[a];
                                                n = n.add(u ? e.negate() : e);
                                            }
                                        }
                                        return He(r), n;
                                    }
                                    getPrecomputes(e, t, r) {
                                        let n = Ve.get(t);
                                        return n || (n = this.precomputeWindow(t, e), 1 !== e && ("function" == typeof r && (n = r(n)), Ve.set(t, n))), n;
                                    }
                                    cached(e, t, r) {
                                        const n = Ge(e);
                                        return this.wNAF(n, this.getPrecomputes(n, e, r), t);
                                    }
                                    unsafe(e, t, r, n) {
                                        const o = Ge(e);
                                        return 1 === o ? this._unsafeLadder(e, t, n) : this.wNAFUnsafe(o, this.getPrecomputes(o, e, r), t, n);
                                    }
                                    createCache(e, t) {
                                        Fe(t, this.bits), qe.set(e, t), Ve.delete(e);
                                    }
                                    hasCache(e) {
                                        return 1 !== Ge(e);
                                    }
                                }
                                function We(e, t, r, n) {
                                    (function(e, t) {
                                        if (!Array.isArray(e)) throw new Error("array expected");
                                        e.forEach((e, r)=>{
                                            if (!(e instanceof t)) throw new Error("invalid point at index " + r);
                                        });
                                    })(r, e), function(e, t) {
                                        if (!Array.isArray(e)) throw new Error("array of scalars expected");
                                        e.forEach((e, r)=>{
                                            if (!t.isValid(e)) throw new Error("invalid scalar at index " + r);
                                        });
                                    }(n, t);
                                    const o = r.length, i = n.length;
                                    if (o !== i) throw new Error("arrays of points and scalars must have equal length");
                                    const a = e.ZERO, s = function(e) {
                                        let t;
                                        for(t = 0; e > $; e >>= Y, t += 1);
                                        return t;
                                    }(BigInt(o));
                                    let u = 1;
                                    s > 12 ? u = s - 3 : s > 4 ? u = s - 2 : s > 0 && (u = 2);
                                    const c = se(u), l = new Array(Number(c) + 1).fill(a);
                                    let f = a;
                                    for(let e = Math.floor((t.BITS - 1) / u) * u; e >= 0; e -= u){
                                        l.fill(a);
                                        for(let t = 0; t < i; t++){
                                            const o = n[t], i = Number(o >> BigInt(e) & c);
                                            l[i] = l[i].add(r[t]);
                                        }
                                        let t = a;
                                        for(let e = l.length - 1, r = a; e > 0; e--)r = r.add(l[e]), t = t.add(r);
                                        if (f = f.add(t), 0 !== e) for(let e = 0; e < u; e++)f = f.double();
                                    }
                                    return f;
                                }
                                function Xe(e, t, r) {
                                    if (t) {
                                        if (t.ORDER !== e) throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
                                        return function(e) {
                                            ue(e, Pe.reduce((e, t)=>(e[t] = "function", e), {
                                                ORDER: "bigint",
                                                MASK: "bigint",
                                                BYTES: "number",
                                                BITS: "number"
                                            }));
                                        }(t), t;
                                    }
                                    return Ce(e, {
                                        isLE: r
                                    });
                                }
                                const Ke = BigInt(0), Ze = BigInt(1), $e = BigInt(2), Ye = BigInt(8);
                                class Qe {
                                    constructor(e){
                                        this.ep = e;
                                    }
                                    static fromBytes(e) {
                                        ce();
                                    }
                                    static fromHex(e) {
                                        ce();
                                    }
                                    get x() {
                                        return this.toAffine().x;
                                    }
                                    get y() {
                                        return this.toAffine().y;
                                    }
                                    clearCofactor() {
                                        return this;
                                    }
                                    assertValidity() {
                                        this.ep.assertValidity();
                                    }
                                    toAffine(e) {
                                        return this.ep.toAffine(e);
                                    }
                                    toHex() {
                                        return g(this.toBytes());
                                    }
                                    toString() {
                                        return this.toHex();
                                    }
                                    isTorsionFree() {
                                        return !0;
                                    }
                                    isSmallOrder() {
                                        return !1;
                                    }
                                    add(e) {
                                        return this.assertSame(e), this.init(this.ep.add(e.ep));
                                    }
                                    subtract(e) {
                                        return this.assertSame(e), this.init(this.ep.subtract(e.ep));
                                    }
                                    multiply(e) {
                                        return this.init(this.ep.multiply(e));
                                    }
                                    multiplyUnsafe(e) {
                                        return this.init(this.ep.multiplyUnsafe(e));
                                    }
                                    double() {
                                        return this.init(this.ep.double());
                                    }
                                    negate() {
                                        return this.init(this.ep.negate());
                                    }
                                    precompute(e, t) {
                                        return this.init(this.ep.precompute(e, t));
                                    }
                                    toRawBytes() {
                                        return this.toBytes();
                                    }
                                }
                                function Je(e) {
                                    const { CURVE: t, curveOpts: r, hash: n, eddsaOpts: o } = function(e) {
                                        const t = {
                                            a: e.a,
                                            d: e.d,
                                            p: e.Fp.ORDER,
                                            n: e.n,
                                            h: e.h,
                                            Gx: e.Gx,
                                            Gy: e.Gy
                                        }, r = {
                                            Fp: e.Fp,
                                            Fn: Ce(t.n, e.nBitLength, !0),
                                            uvRatio: e.uvRatio
                                        }, n = {
                                            randomBytes: e.randomBytes,
                                            adjustScalarBytes: e.adjustScalarBytes,
                                            domain: e.domain,
                                            prehash: e.prehash,
                                            mapToCurve: e.mapToCurve
                                        };
                                        return {
                                            CURVE: t,
                                            curveOpts: r,
                                            hash: e.hash,
                                            eddsaOpts: n
                                        };
                                    }(e);
                                    return function(e, t) {
                                        const r = t.Point;
                                        return Object.assign({}, t, {
                                            ExtendedPoint: r,
                                            CURVE: e,
                                            nBitLength: r.Fn.BITS,
                                            nByteLength: r.Fn.BYTES
                                        });
                                    }(e, function(e, t, r = {}) {
                                        if ("function" != typeof t) throw new Error('"hash" function param is required');
                                        ue(r, {}, {
                                            adjustScalarBytes: "function",
                                            randomBytes: "function",
                                            domain: "function",
                                            prehash: "function",
                                            mapToCurve: "function"
                                        });
                                        const { prehash: n } = r, { BASE: o, Fp: i, Fn: a } = e, s = r.randomBytes || T, u = r.adjustScalarBytes || ((e)=>e), c = r.domain || ((e, t, r)=>{
                                            if (Q(r, "phflag"), t.length || r) throw new Error("Contexts/pre-hash are not supported");
                                            return e;
                                        });
                                        function f(e) {
                                            return a.create(te(e));
                                        }
                                        function p(e) {
                                            const { head: r, prefix: n, scalar: i } = function(e) {
                                                const r = g.secretKey;
                                                e = ne("private key", e, r);
                                                const n = ne("hashed private key", t(e), 2 * r), o = u(n.slice(0, r));
                                                return {
                                                    head: o,
                                                    prefix: n.slice(r, 2 * r),
                                                    scalar: f(o)
                                                };
                                            }(e), a = o.multiply(i), s = a.toBytes();
                                            return {
                                                head: r,
                                                prefix: n,
                                                scalar: i,
                                                point: a,
                                                pointBytes: s
                                            };
                                        }
                                        function d(e) {
                                            return p(e).pointBytes;
                                        }
                                        function h(e = Uint8Array.of(), ...r) {
                                            const o = A(...r);
                                            return f(t(c(o, ne("context", e), !!n)));
                                        }
                                        const y = {
                                            zip215: !0
                                        }, m = i.BYTES, g = {
                                            secretKey: m,
                                            publicKey: m,
                                            signature: 2 * m,
                                            seed: m
                                        };
                                        function v(e = s(g.seed)) {
                                            return J(e, g.seed, "seed");
                                        }
                                        const b = {
                                            getExtendedPublicKey: p,
                                            randomSecretKey: v,
                                            isValidSecretKey: function(e) {
                                                return l(e) && e.length === a.BYTES;
                                            },
                                            isValidPublicKey: function(t, r) {
                                                try {
                                                    return !!e.fromBytes(t, r);
                                                } catch (e) {
                                                    return !1;
                                                }
                                            },
                                            toMontgomery (t) {
                                                const { y: r } = e.fromBytes(t), n = g.publicKey, o = 32 === n;
                                                if (!o && 57 !== n) throw new Error("only defined for 25519 and 448");
                                                const a = o ? i.div(Ze + r, Ze - r) : i.div(r - Ze, r + Ze);
                                                return i.toBytes(a);
                                            },
                                            toMontgomerySecret (e) {
                                                const r = g.secretKey;
                                                J(e, r);
                                                const n = t(e.subarray(0, r));
                                                return u(n).subarray(0, r);
                                            },
                                            randomPrivateKey: v,
                                            precompute: (t = 8, r = e.BASE)=>r.precompute(t, !1)
                                        };
                                        return Object.freeze({
                                            keygen: function(e) {
                                                const t = b.randomSecretKey(e);
                                                return {
                                                    secretKey: t,
                                                    publicKey: d(t)
                                                };
                                            },
                                            getPublicKey: d,
                                            sign: function(e, t, r = {}) {
                                                e = ne("message", e), n && (e = n(e));
                                                const { prefix: i, scalar: s, pointBytes: u } = p(t), c = h(r.context, i, e), l = o.multiply(c).toBytes(), f = h(r.context, l, u, e), d = a.create(c + f * s);
                                                if (!a.isValid(d)) throw new Error("sign failed: invalid s");
                                                return J(A(l, a.toBytes(d)), g.signature, "result");
                                            },
                                            verify: function(t, r, i, a = y) {
                                                const { context: s, zip215: u } = a, c = g.signature;
                                                t = ne("signature", t, c), r = ne("message", r), i = ne("publicKey", i, g.publicKey), void 0 !== u && Q(u, "zip215"), n && (r = n(r));
                                                const l = c / 2, f = t.subarray(0, l), p = te(t.subarray(l, c));
                                                let d, m, v;
                                                try {
                                                    d = e.fromBytes(i, u), m = e.fromBytes(f, u), v = o.multiplyUnsafe(p);
                                                } catch (e) {
                                                    return !1;
                                                }
                                                if (!u && d.isSmallOrder()) return !1;
                                                const b = h(s, m.toBytes(), d.toBytes(), r);
                                                return m.add(d.multiplyUnsafe(b)).subtract(v).clearCofactor().is0();
                                            },
                                            utils: b,
                                            Point: e,
                                            lengths: g
                                        });
                                    }(function(e, t = {}) {
                                        const r = function(e, t, r = {}, n) {
                                            if (void 0 === n && (n = "edwards" === e), !t || "object" != typeof t) throw new Error(`expected valid ${e} CURVE object`);
                                            for (const e of [
                                                "p",
                                                "n",
                                                "h"
                                            ]){
                                                const r = t[e];
                                                if (!("bigint" == typeof r && r > je)) throw new Error(`CURVE.${e} must be positive bigint`);
                                            }
                                            const o = Xe(t.p, r.Fp, n), i = Xe(t.n, r.Fn, n), a = [
                                                "Gx",
                                                "Gy",
                                                "a",
                                                "weierstrass" === e ? "b" : "d"
                                            ];
                                            for (const e of a)if (!o.isValid(t[e])) throw new Error(`CURVE.${e} must be valid field element of CURVE.Fp`);
                                            return {
                                                CURVE: t = Object.freeze(Object.assign({}, t)),
                                                Fp: o,
                                                Fn: i
                                            };
                                        }("edwards", e, t, t.FpFnLE), { Fp: n, Fn: o } = r;
                                        let i = r.CURVE;
                                        const { h: a } = i;
                                        ue(t, {}, {
                                            uvRatio: "function"
                                        });
                                        const s = $e << BigInt(8 * o.BYTES) - Ze, u = (e)=>n.create(e), c = t.uvRatio || ((e, t)=>{
                                            try {
                                                return {
                                                    isValid: !0,
                                                    value: n.sqrt(n.div(e, t))
                                                };
                                            } catch (e) {
                                                return {
                                                    isValid: !1,
                                                    value: Ke
                                                };
                                            }
                                        });
                                        if (!function(e, t, r, n) {
                                            const o = e.sqr(r), i = e.sqr(n), a = e.add(e.mul(t.a, o), i), s = e.add(e.ONE, e.mul(t.d, e.mul(o, i)));
                                            return e.eql(a, s);
                                        }(n, i, i.Gx, i.Gy)) throw new Error("bad curve params: generator point");
                                        function l(e, t, r = !1) {
                                            return ae("coordinate " + e, t, r ? Ze : Ke, s), t;
                                        }
                                        function f(e) {
                                            if (!(e instanceof h)) throw new Error("ExtendedPoint expected");
                                        }
                                        const p = le((e, t)=>{
                                            const { X: r, Y: o, Z: i } = e, a = e.is0();
                                            null == t && (t = a ? Ye : n.inv(i));
                                            const s = u(r * t), c = u(o * t), l = n.mul(i, t);
                                            if (a) return {
                                                x: Ke,
                                                y: Ze
                                            };
                                            if (l !== Ze) throw new Error("invZ was invalid");
                                            return {
                                                x: s,
                                                y: c
                                            };
                                        }), d = le((e)=>{
                                            const { a: t, d: r } = i;
                                            if (e.is0()) throw new Error("bad point: ZERO");
                                            const { X: n, Y: o, Z: a, T: s } = e, c = u(n * n), l = u(o * o), f = u(a * a), p = u(f * f), d = u(c * t);
                                            if (u(f * u(d + l)) !== u(p + u(r * u(c * l)))) throw new Error("bad point: equation left != right (1)");
                                            if (u(n * o) !== u(a * s)) throw new Error("bad point: equation left != right (2)");
                                            return !0;
                                        });
                                        class h {
                                            constructor(e, t, r, n){
                                                this.X = l("x", e), this.Y = l("y", t), this.Z = l("z", r, !0), this.T = l("t", n), Object.freeze(this);
                                            }
                                            static CURVE() {
                                                return i;
                                            }
                                            static fromAffine(e) {
                                                if (e instanceof h) throw new Error("extended point not allowed");
                                                const { x: t, y: r } = e || {};
                                                return l("x", t), l("y", r), new h(t, r, Ze, u(t * r));
                                            }
                                            static fromBytes(e, t = !1) {
                                                const r = n.BYTES, { a: o, d: a } = i;
                                                e = oe(J(e, r, "point")), Q(t, "zip215");
                                                const l = oe(e), f = e[r - 1];
                                                l[r - 1] = -129 & f;
                                                const p = te(l), d = t ? s : n.ORDER;
                                                ae("point.y", p, Ke, d);
                                                const y = u(p * p), m = u(y - Ze), g = u(a * y - o);
                                                let { isValid: v, value: b } = c(m, g);
                                                if (!v) throw new Error("bad point: invalid y coordinate");
                                                const w = (b & Ze) === Ze, S = !!(128 & f);
                                                if (!t && b === Ke && S) throw new Error("bad point: x=0 and x_0=1");
                                                return S !== w && (b = u(-b)), h.fromAffine({
                                                    x: b,
                                                    y: p
                                                });
                                            }
                                            static fromHex(e, t = !1) {
                                                return h.fromBytes(ne("point", e), t);
                                            }
                                            get x() {
                                                return this.toAffine().x;
                                            }
                                            get y() {
                                                return this.toAffine().y;
                                            }
                                            precompute(e = 8, t = !0) {
                                                return y.createCache(this, e), t || this.multiply($e), this;
                                            }
                                            assertValidity() {
                                                d(this);
                                            }
                                            equals(e) {
                                                f(e);
                                                const { X: t, Y: r, Z: n } = this, { X: o, Y: i, Z: a } = e, s = u(t * a), c = u(o * n), l = u(r * a), p = u(i * n);
                                                return s === c && l === p;
                                            }
                                            is0() {
                                                return this.equals(h.ZERO);
                                            }
                                            negate() {
                                                return new h(u(-this.X), this.Y, this.Z, u(-this.T));
                                            }
                                            double() {
                                                const { a: e } = i, { X: t, Y: r, Z: n } = this, o = u(t * t), a = u(r * r), s = u($e * u(n * n)), c = u(e * o), l = t + r, f = u(u(l * l) - o - a), p = c + a, d = p - s, y = c - a, m = u(f * d), g = u(p * y), v = u(f * y), b = u(d * p);
                                                return new h(m, g, b, v);
                                            }
                                            add(e) {
                                                f(e);
                                                const { a: t, d: r } = i, { X: n, Y: o, Z: a, T: s } = this, { X: c, Y: l, Z: p, T: d } = e, y = u(n * c), m = u(o * l), g = u(s * r * d), v = u(a * p), b = u((n + o) * (c + l) - y - m), w = v - g, S = v + g, A = u(m - t * y), E = u(b * w), T = u(S * A), O = u(b * A), k = u(w * S);
                                                return new h(E, T, k, O);
                                            }
                                            subtract(e) {
                                                return this.add(e.negate());
                                            }
                                            multiply(e) {
                                                if (!o.isValidNot0(e)) throw new Error("invalid scalar: expected 1 <= sc < curve.n");
                                                const { p: t, f: r } = y.cached(this, e, (e)=>Le(h, e));
                                                return Le(h, [
                                                    t,
                                                    r
                                                ])[0];
                                            }
                                            multiplyUnsafe(e, t = h.ZERO) {
                                                if (!o.isValid(e)) throw new Error("invalid scalar: expected 0 <= sc < curve.n");
                                                return e === Ke ? h.ZERO : this.is0() || e === Ze ? this : y.unsafe(this, e, (e)=>Le(h, e), t);
                                            }
                                            isSmallOrder() {
                                                return this.multiplyUnsafe(a).is0();
                                            }
                                            isTorsionFree() {
                                                return y.unsafe(this, i.n).is0();
                                            }
                                            toAffine(e) {
                                                return p(this, e);
                                            }
                                            clearCofactor() {
                                                return a === Ze ? this : this.multiplyUnsafe(a);
                                            }
                                            toBytes() {
                                                const { x: e, y: t } = this.toAffine(), r = n.toBytes(t);
                                                return r[r.length - 1] |= e & Ze ? 128 : 0, r;
                                            }
                                            toHex() {
                                                return g(this.toBytes());
                                            }
                                            toString() {
                                                return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
                                            }
                                            get ex() {
                                                return this.X;
                                            }
                                            get ey() {
                                                return this.Y;
                                            }
                                            get ez() {
                                                return this.Z;
                                            }
                                            get et() {
                                                return this.T;
                                            }
                                            static normalizeZ(e) {
                                                return Le(h, e);
                                            }
                                            static msm(e, t) {
                                                return We(h, o, e, t);
                                            }
                                            _setWindowSize(e) {
                                                this.precompute(e);
                                            }
                                            toRawBytes() {
                                                return this.toBytes();
                                            }
                                        }
                                        h.BASE = new h(i.Gx, i.Gy, Ze, u(i.Gx * i.Gy)), h.ZERO = new h(Ke, Ze, Ze, Ke), h.Fp = n, h.Fn = o;
                                        const y = new ze(h, o.BITS);
                                        return h.BASE.precompute(8), h;
                                    }(t, r), n, o));
                                }
                                w("HashToScalar-");
                                const et = BigInt(0), tt = BigInt(1), rt = BigInt(2), nt = (BigInt(3), BigInt(5)), ot = BigInt(8), it = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"), at = {
                                    p: it,
                                    n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"),
                                    h: ot,
                                    a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"),
                                    d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"),
                                    Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"),
                                    Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658")
                                };
                                function st(e) {
                                    return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
                                }
                                const ut = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
                                function ct(e, t) {
                                    const r = it, n = Se(t * t * t, r), o = Se(n * n * t, r);
                                    let i = Se(e * n * function(e) {
                                        const t = BigInt(10), r = BigInt(20), n = BigInt(40), o = BigInt(80), i = it, a = e * e % i * e % i, s = Ae(a, rt, i) * a % i, u = Ae(s, tt, i) * e % i, c = Ae(u, nt, i) * u % i, l = Ae(c, t, i) * c % i, f = Ae(l, r, i) * l % i, p = Ae(f, n, i) * f % i, d = Ae(p, o, i) * p % i, h = Ae(d, o, i) * p % i, y = Ae(h, t, i) * c % i;
                                        return {
                                            pow_p_5_8: Ae(y, rt, i) * e % i,
                                            b2: a
                                        };
                                    }(e * o).pow_p_5_8, r);
                                    const a = Se(t * i * i, r), s = i, u = Se(i * ut, r), c = a === e, l = a === Se(-e, r), f = a === Se(-e * ut, r);
                                    return c && (i = s), (l || f) && (i = u), xe(i, r) && (i = Se(-i, r)), {
                                        isValid: c || l,
                                        value: i
                                    };
                                }
                                const lt = Ce(at.p, {
                                    isLE: !0
                                }), ft = Ce(at.n, {
                                    isLE: !0
                                }), pt = Je({
                                    ...at,
                                    Fp: lt,
                                    hash: Z,
                                    adjustScalarBytes: st,
                                    uvRatio: ct
                                }), dt = ut, ht = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235"), yt = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578"), mt = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838"), gt = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952"), vt = (e)=>ct(tt, e), bt = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), wt = (e)=>pt.Point.Fp.create(te(e) & bt);
                                function St(e) {
                                    const { d: t } = at, r = it, n = (e)=>lt.create(e), o = n(dt * e * e), i = n((o + tt) * mt);
                                    let a = BigInt(-1);
                                    const s = n((a - t * o) * n(o + t));
                                    let { isValid: u, value: c } = ct(i, s), l = n(c * e);
                                    xe(l, r) || (l = n(-l)), u || (c = l), u || (a = o);
                                    const f = n(a * (o - tt) * gt - s), p = c * c, d = n((c + c) * s), h = n(f * ht), y = n(tt - p), m = n(tt + p);
                                    return new pt.Point(n(d * m), n(y * h), n(h * m), n(d * y));
                                }
                                class At extends Qe {
                                    constructor(e){
                                        super(e);
                                    }
                                    static fromAffine(e) {
                                        return new At(pt.Point.fromAffine(e));
                                    }
                                    assertSame(e) {
                                        if (!(e instanceof At)) throw new Error("RistrettoPoint expected");
                                    }
                                    init(e) {
                                        return new At(e);
                                    }
                                    static hashToCurve(e) {
                                        return function(e) {
                                            f(e, 64);
                                            const t = St(wt(e.subarray(0, 32))), r = St(wt(e.subarray(32, 64)));
                                            return new At(t.add(r));
                                        }(ne("ristrettoHash", e, 64));
                                    }
                                    static fromBytes(e) {
                                        f(e, 32);
                                        const { a: t, d: r } = at, n = it, o = (e)=>lt.create(e), i = wt(e);
                                        if (!function(e, t) {
                                            if (e.length !== t.length) return !1;
                                            let r = 0;
                                            for(let n = 0; n < e.length; n++)r |= e[n] ^ t[n];
                                            return 0 === r;
                                        }(lt.toBytes(i), e) || xe(i, n)) throw new Error("invalid ristretto255 encoding 1");
                                        const a = o(i * i), s = o(tt + t * a), u = o(tt - t * a), c = o(s * s), l = o(u * u), p = o(t * r * c - l), { isValid: d, value: h } = vt(o(p * l)), y = o(h * u), m = o(h * y * p);
                                        let g = o((i + i) * y);
                                        xe(g, n) && (g = o(-g));
                                        const v = o(s * m), b = o(g * v);
                                        if (!d || xe(b, n) || v === et) throw new Error("invalid ristretto255 encoding 2");
                                        return new At(new pt.Point(g, v, tt, b));
                                    }
                                    static fromHex(e) {
                                        return At.fromBytes(ne("ristrettoHex", e, 32));
                                    }
                                    static msm(e, t) {
                                        return We(At, pt.Point.Fn, e, t);
                                    }
                                    toBytes() {
                                        let { X: e, Y: t, Z: r, T: n } = this.ep;
                                        const o = it, i = (e)=>lt.create(e), a = i(i(r + t) * i(r - t)), s = i(e * t), u = i(s * s), { value: c } = vt(i(a * u)), l = i(c * a), f = i(c * s), p = i(l * f * n);
                                        let d;
                                        if (xe(n * p, o)) {
                                            let r = i(t * dt), n = i(e * dt);
                                            e = r, t = n, d = i(l * yt);
                                        } else d = f;
                                        xe(e * p, o) && (t = i(-t));
                                        let h = i((r - t) * d);
                                        return xe(h, o) && (h = i(-h)), lt.toBytes(h);
                                    }
                                    equals(e) {
                                        this.assertSame(e);
                                        const { X: t, Y: r } = this.ep, { X: n, Y: o } = e.ep, i = (e)=>lt.create(e), a = i(t * o) === i(r * n), s = i(r * o) === i(t * n);
                                        return a || s;
                                    }
                                    is0() {
                                        return this.equals(At.ZERO);
                                    }
                                }
                                At.BASE = new At(pt.Point.BASE), At.ZERO = new At(pt.Point.ZERO), At.Fp = lt, At.Fn = ft;
                                var Et = r(8287).Buffer;
                                function Tt(e, t) {
                                    return Et.from(pt.sign(Et.from(e), t));
                                }
                                function Ot(e, t, r) {
                                    return pt.verify(Et.from(t), Et.from(e), Et.from(r), {
                                        zip215: !1
                                    });
                                }
                                var kt = function(e, t) {
                                    for(var r = "number" == typeof e, n = String(e); n.endsWith(t);)n = n.slice(0, -1);
                                    return r ? Number(n) : n;
                                }, _t = r(5360), xt = r(8287).Buffer;
                                function Pt(e) {
                                    return Pt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Pt(e);
                                }
                                function Rt(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, It(n.key), n);
                                    }
                                }
                                function It(e) {
                                    var t = function(e) {
                                        if ("object" != Pt(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Pt(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Pt(t) ? t : t + "";
                                }
                                var Bt, Ct, jt, Ut = {
                                    ed25519PublicKey: 48,
                                    ed25519SecretSeed: 144,
                                    med25519PublicKey: 96,
                                    preAuthTx: 152,
                                    sha256Hash: 184,
                                    signedPayload: 120,
                                    contract: 16,
                                    liquidityPool: 88,
                                    claimableBalance: 8
                                }, Nt = {
                                    G: "ed25519PublicKey",
                                    S: "ed25519SecretSeed",
                                    M: "med25519PublicKey",
                                    T: "preAuthTx",
                                    X: "sha256Hash",
                                    P: "signedPayload",
                                    C: "contract",
                                    L: "liquidityPool",
                                    B: "claimableBalance"
                                }, Lt = function() {
                                    var e, t;
                                    return e = function e() {
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, e);
                                    }, t = [
                                        {
                                            key: "encodeEd25519PublicKey",
                                            value: function(e) {
                                                return Mt("ed25519PublicKey", e);
                                            }
                                        },
                                        {
                                            key: "decodeEd25519PublicKey",
                                            value: function(e) {
                                                return Dt("ed25519PublicKey", e);
                                            }
                                        },
                                        {
                                            key: "isValidEd25519PublicKey",
                                            value: function(e) {
                                                return Ft("ed25519PublicKey", e);
                                            }
                                        },
                                        {
                                            key: "encodeEd25519SecretSeed",
                                            value: function(e) {
                                                return Mt("ed25519SecretSeed", e);
                                            }
                                        },
                                        {
                                            key: "decodeEd25519SecretSeed",
                                            value: function(e) {
                                                return Dt("ed25519SecretSeed", e);
                                            }
                                        },
                                        {
                                            key: "isValidEd25519SecretSeed",
                                            value: function(e) {
                                                return Ft("ed25519SecretSeed", e);
                                            }
                                        },
                                        {
                                            key: "encodeMed25519PublicKey",
                                            value: function(e) {
                                                return Mt("med25519PublicKey", e);
                                            }
                                        },
                                        {
                                            key: "decodeMed25519PublicKey",
                                            value: function(e) {
                                                return Dt("med25519PublicKey", e);
                                            }
                                        },
                                        {
                                            key: "isValidMed25519PublicKey",
                                            value: function(e) {
                                                return Ft("med25519PublicKey", e);
                                            }
                                        },
                                        {
                                            key: "encodePreAuthTx",
                                            value: function(e) {
                                                return Mt("preAuthTx", e);
                                            }
                                        },
                                        {
                                            key: "decodePreAuthTx",
                                            value: function(e) {
                                                return Dt("preAuthTx", e);
                                            }
                                        },
                                        {
                                            key: "encodeSha256Hash",
                                            value: function(e) {
                                                return Mt("sha256Hash", e);
                                            }
                                        },
                                        {
                                            key: "decodeSha256Hash",
                                            value: function(e) {
                                                return Dt("sha256Hash", e);
                                            }
                                        },
                                        {
                                            key: "encodeSignedPayload",
                                            value: function(e) {
                                                return Mt("signedPayload", e);
                                            }
                                        },
                                        {
                                            key: "decodeSignedPayload",
                                            value: function(e) {
                                                return Dt("signedPayload", e);
                                            }
                                        },
                                        {
                                            key: "isValidSignedPayload",
                                            value: function(e) {
                                                return Ft("signedPayload", e);
                                            }
                                        },
                                        {
                                            key: "encodeContract",
                                            value: function(e) {
                                                return Mt("contract", e);
                                            }
                                        },
                                        {
                                            key: "decodeContract",
                                            value: function(e) {
                                                return Dt("contract", e);
                                            }
                                        },
                                        {
                                            key: "isValidContract",
                                            value: function(e) {
                                                return Ft("contract", e);
                                            }
                                        },
                                        {
                                            key: "encodeClaimableBalance",
                                            value: function(e) {
                                                return Mt("claimableBalance", e);
                                            }
                                        },
                                        {
                                            key: "decodeClaimableBalance",
                                            value: function(e) {
                                                return Dt("claimableBalance", e);
                                            }
                                        },
                                        {
                                            key: "isValidClaimableBalance",
                                            value: function(e) {
                                                return Ft("claimableBalance", e);
                                            }
                                        },
                                        {
                                            key: "encodeLiquidityPool",
                                            value: function(e) {
                                                return Mt("liquidityPool", e);
                                            }
                                        },
                                        {
                                            key: "decodeLiquidityPool",
                                            value: function(e) {
                                                return Dt("liquidityPool", e);
                                            }
                                        },
                                        {
                                            key: "isValidLiquidityPool",
                                            value: function(e) {
                                                return Ft("liquidityPool", e);
                                            }
                                        },
                                        {
                                            key: "getVersionByteForPrefix",
                                            value: function(e) {
                                                return Nt[e[0]];
                                            }
                                        }
                                    ], t && Rt(e, t), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                                function Ft(e, t) {
                                    if ("string" != typeof t) return !1;
                                    switch(e){
                                        case "ed25519PublicKey":
                                        case "ed25519SecretSeed":
                                        case "preAuthTx":
                                        case "sha256Hash":
                                        case "contract":
                                        case "liquidityPool":
                                            if (56 !== t.length) return !1;
                                            break;
                                        case "claimableBalance":
                                            if (58 !== t.length) return !1;
                                            break;
                                        case "med25519PublicKey":
                                            if (69 !== t.length) return !1;
                                            break;
                                        case "signedPayload":
                                            if (t.length < 56 || t.length > 165) return !1;
                                            break;
                                        default:
                                            return !1;
                                    }
                                    var r = "";
                                    try {
                                        r = Dt(e, t);
                                    } catch (e) {
                                        return !1;
                                    }
                                    switch(e){
                                        case "ed25519PublicKey":
                                        case "ed25519SecretSeed":
                                        case "preAuthTx":
                                        case "sha256Hash":
                                        case "contract":
                                        case "liquidityPool":
                                            return 32 === r.length;
                                        case "claimableBalance":
                                            return 33 === r.length;
                                        case "med25519PublicKey":
                                            return 40 === r.length;
                                        case "signedPayload":
                                            return r.length >= 40 && r.length <= 100;
                                        default:
                                            return !1;
                                    }
                                }
                                function Dt(e, t) {
                                    if ("string" != typeof t) throw new TypeError("encoded argument must be of type String");
                                    var r = _t.decode(t), n = r[0], o = r.slice(0, -2), i = o.slice(1), a = r.slice(-2);
                                    if (t !== _t.encode(r)) throw new Error("invalid encoded string");
                                    var s = Ut[e];
                                    if (void 0 === s) throw new Error("".concat(e, " is not a valid version byte name. ") + "Expected one of ".concat(Object.keys(Ut).join(", ")));
                                    if (n !== s) throw new Error("invalid version byte. expected ".concat(s, ", got ").concat(n));
                                    if (!function(e, t) {
                                        if (e.length !== t.length) return !1;
                                        if (0 === e.length) return !0;
                                        for(var r = 0; r < e.length; r += 1)if (e[r] !== t[r]) return !1;
                                        return !0;
                                    }(Vt(o), a)) throw new Error("invalid checksum");
                                    return xt.from(i);
                                }
                                function Mt(e, t) {
                                    if (null == t) throw new Error("cannot encode null data");
                                    var r = Ut[e];
                                    if (void 0 === r) throw new Error("".concat(e, " is not a valid version byte name. ") + "Expected one of ".concat(Object.keys(Ut).join(", ")));
                                    t = xt.from(t);
                                    var n = xt.from([
                                        r
                                    ]), o = xt.concat([
                                        n,
                                        t
                                    ]), i = xt.from(Vt(o)), a = xt.concat([
                                        o,
                                        i
                                    ]);
                                    return _t.encode(a);
                                }
                                function Vt(e) {
                                    for(var t = [
                                        0,
                                        4129,
                                        8258,
                                        12387,
                                        16516,
                                        20645,
                                        24774,
                                        28903,
                                        33032,
                                        37161,
                                        41290,
                                        45419,
                                        49548,
                                        53677,
                                        57806,
                                        61935,
                                        4657,
                                        528,
                                        12915,
                                        8786,
                                        21173,
                                        17044,
                                        29431,
                                        25302,
                                        37689,
                                        33560,
                                        45947,
                                        41818,
                                        54205,
                                        50076,
                                        62463,
                                        58334,
                                        9314,
                                        13379,
                                        1056,
                                        5121,
                                        25830,
                                        29895,
                                        17572,
                                        21637,
                                        42346,
                                        46411,
                                        34088,
                                        38153,
                                        58862,
                                        62927,
                                        50604,
                                        54669,
                                        13907,
                                        9842,
                                        5649,
                                        1584,
                                        30423,
                                        26358,
                                        22165,
                                        18100,
                                        46939,
                                        42874,
                                        38681,
                                        34616,
                                        63455,
                                        59390,
                                        55197,
                                        51132,
                                        18628,
                                        22757,
                                        26758,
                                        30887,
                                        2112,
                                        6241,
                                        10242,
                                        14371,
                                        51660,
                                        55789,
                                        59790,
                                        63919,
                                        35144,
                                        39273,
                                        43274,
                                        47403,
                                        23285,
                                        19156,
                                        31415,
                                        27286,
                                        6769,
                                        2640,
                                        14899,
                                        10770,
                                        56317,
                                        52188,
                                        64447,
                                        60318,
                                        39801,
                                        35672,
                                        47931,
                                        43802,
                                        27814,
                                        31879,
                                        19684,
                                        23749,
                                        11298,
                                        15363,
                                        3168,
                                        7233,
                                        60846,
                                        64911,
                                        52716,
                                        56781,
                                        44330,
                                        48395,
                                        36200,
                                        40265,
                                        32407,
                                        28342,
                                        24277,
                                        20212,
                                        15891,
                                        11826,
                                        7761,
                                        3696,
                                        65439,
                                        61374,
                                        57309,
                                        53244,
                                        48923,
                                        44858,
                                        40793,
                                        36728,
                                        37256,
                                        33193,
                                        45514,
                                        41451,
                                        53516,
                                        49453,
                                        61774,
                                        57711,
                                        4224,
                                        161,
                                        12482,
                                        8419,
                                        20484,
                                        16421,
                                        28742,
                                        24679,
                                        33721,
                                        37784,
                                        41979,
                                        46042,
                                        49981,
                                        54044,
                                        58239,
                                        62302,
                                        689,
                                        4752,
                                        8947,
                                        13010,
                                        16949,
                                        21012,
                                        25207,
                                        29270,
                                        46570,
                                        42443,
                                        38312,
                                        34185,
                                        62830,
                                        58703,
                                        54572,
                                        50445,
                                        13538,
                                        9411,
                                        5280,
                                        1153,
                                        29798,
                                        25671,
                                        21540,
                                        17413,
                                        42971,
                                        47098,
                                        34713,
                                        38840,
                                        59231,
                                        63358,
                                        50973,
                                        55100,
                                        9939,
                                        14066,
                                        1681,
                                        5808,
                                        26199,
                                        30326,
                                        17941,
                                        22068,
                                        55628,
                                        51565,
                                        63758,
                                        59695,
                                        39368,
                                        35305,
                                        47498,
                                        43435,
                                        22596,
                                        18533,
                                        30726,
                                        26663,
                                        6336,
                                        2273,
                                        14466,
                                        10403,
                                        52093,
                                        56156,
                                        60223,
                                        64286,
                                        35833,
                                        39896,
                                        43963,
                                        48026,
                                        19061,
                                        23124,
                                        27191,
                                        31254,
                                        2801,
                                        6864,
                                        10931,
                                        14994,
                                        64814,
                                        60687,
                                        56684,
                                        52557,
                                        48554,
                                        44427,
                                        40424,
                                        36297,
                                        31782,
                                        27655,
                                        23652,
                                        19525,
                                        15522,
                                        11395,
                                        7392,
                                        3265,
                                        61215,
                                        65342,
                                        53085,
                                        57212,
                                        44955,
                                        49082,
                                        36825,
                                        40952,
                                        28183,
                                        32310,
                                        20053,
                                        24180,
                                        11923,
                                        16050,
                                        3793,
                                        7920
                                    ], r = 0, n = 0; n < e.length; n += 1)r = r << 8 ^ t[r >> 8 ^ e[n]], r &= 65535;
                                    var o = new Uint8Array(2);
                                    return o[0] = 255 & r, o[1] = r >> 8 & 255, o;
                                }
                                Bt = Lt, jt = Nt, (Ct = It(Ct = "types")) in Bt ? Object.defineProperty(Bt, Ct, {
                                    value: jt,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : Bt[Ct] = jt;
                                var qt = r(8287).Buffer;
                                function Gt(e) {
                                    return Gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Gt(e);
                                }
                                function Ht(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zt(n.key), n);
                                    }
                                }
                                function zt(e) {
                                    var t = function(e) {
                                        if ("object" != Gt(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Gt(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Gt(t) ? t : t + "";
                                }
                                var Wt = function(e, t, r) {
                                    return t && Ht(e.prototype, t), r && Ht(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), "ed25519" !== t.type) throw new Error("Invalid keys type");
                                    if (this.type = t.type, t.secretKey) {
                                        if (t.secretKey = qt.from(t.secretKey), 32 !== t.secretKey.length) throw new Error("secretKey length is invalid");
                                        if (this._secretSeed = t.secretKey, this._publicKey = (r = t.secretKey, Et.from(pt.getPublicKey(r))), this._secretKey = t.secretKey, t.publicKey && !this._publicKey.equals(qt.from(t.publicKey))) throw new Error("secretKey does not match publicKey");
                                    } else if (this._publicKey = qt.from(t.publicKey), 32 !== this._publicKey.length) throw new Error("publicKey length is invalid");
                                    var r;
                                }, [
                                    {
                                        key: "xdrAccountId",
                                        value: function() {
                                            return new i.AccountId.publicKeyTypeEd25519(this._publicKey);
                                        }
                                    },
                                    {
                                        key: "xdrPublicKey",
                                        value: function() {
                                            return new i.PublicKey.publicKeyTypeEd25519(this._publicKey);
                                        }
                                    },
                                    {
                                        key: "xdrMuxedAccount",
                                        value: function(e) {
                                            if (void 0 !== e) {
                                                if ("string" != typeof e) throw new TypeError("expected string for ID, got ".concat(Gt(e)));
                                                return i.MuxedAccount.keyTypeMuxedEd25519(new i.MuxedAccountMed25519({
                                                    id: i.Uint64.fromString(e),
                                                    ed25519: this._publicKey
                                                }));
                                            }
                                            return new i.MuxedAccount.keyTypeEd25519(this._publicKey);
                                        }
                                    },
                                    {
                                        key: "rawPublicKey",
                                        value: function() {
                                            return this._publicKey;
                                        }
                                    },
                                    {
                                        key: "signatureHint",
                                        value: function() {
                                            var e = this.xdrAccountId().toXDR();
                                            return e.slice(e.length - 4);
                                        }
                                    },
                                    {
                                        key: "publicKey",
                                        value: function() {
                                            return Lt.encodeEd25519PublicKey(this._publicKey);
                                        }
                                    },
                                    {
                                        key: "secret",
                                        value: function() {
                                            if (!this._secretSeed) throw new Error("no secret key available");
                                            if ("ed25519" === this.type) return Lt.encodeEd25519SecretSeed(this._secretSeed);
                                            throw new Error("Invalid Keypair type");
                                        }
                                    },
                                    {
                                        key: "rawSecretKey",
                                        value: function() {
                                            return this._secretSeed;
                                        }
                                    },
                                    {
                                        key: "canSign",
                                        value: function() {
                                            return !!this._secretKey;
                                        }
                                    },
                                    {
                                        key: "sign",
                                        value: function(e) {
                                            if (!this.canSign()) throw new Error("cannot sign: no secret key available");
                                            return Tt(e, this._secretKey);
                                        }
                                    },
                                    {
                                        key: "verify",
                                        value: function(e, t) {
                                            try {
                                                return Ot(e, t, this._publicKey);
                                            } catch (e) {
                                                return !1;
                                            }
                                        }
                                    },
                                    {
                                        key: "signDecorated",
                                        value: function(e) {
                                            var t = this.sign(e), r = this.signatureHint();
                                            return new i.DecoratedSignature({
                                                hint: r,
                                                signature: t
                                            });
                                        }
                                    },
                                    {
                                        key: "signPayloadDecorated",
                                        value: function(e) {
                                            var t = this.sign(e), r = this.signatureHint(), n = qt.from(e.slice(-4));
                                            return n.length < 4 && (n = qt.concat([
                                                n,
                                                qt.alloc(4 - e.length, 0)
                                            ])), new i.DecoratedSignature({
                                                hint: n.map(function(e, t) {
                                                    return e ^ r[t];
                                                }),
                                                signature: t
                                            });
                                        }
                                    }
                                ], [
                                    {
                                        key: "fromSecret",
                                        value: function(e) {
                                            var t = Lt.decodeEd25519SecretSeed(e);
                                            return this.fromRawEd25519Seed(t);
                                        }
                                    },
                                    {
                                        key: "fromRawEd25519Seed",
                                        value: function(e) {
                                            return new this({
                                                type: "ed25519",
                                                secretKey: e
                                            });
                                        }
                                    },
                                    {
                                        key: "master",
                                        value: function(e) {
                                            if (!e) throw new Error("No network selected. Please pass a network argument, e.g. `Keypair.master(Networks.PUBLIC)`.");
                                            return this.fromRawEd25519Seed(u(e));
                                        }
                                    },
                                    {
                                        key: "fromPublicKey",
                                        value: function(e) {
                                            if (32 !== (e = Lt.decodeEd25519PublicKey(e)).length) throw new Error("Invalid Stellar public key");
                                            return new this({
                                                type: "ed25519",
                                                publicKey: e
                                            });
                                        }
                                    },
                                    {
                                        key: "random",
                                        value: function() {
                                            var e = pt.utils.randomPrivateKey();
                                            return this.fromRawEd25519Seed(e);
                                        }
                                    }
                                ]), Xt = r(8287).Buffer;
                                function Kt(e) {
                                    return Kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Kt(e);
                                }
                                function Zt(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $t(n.key), n);
                                    }
                                }
                                function $t(e) {
                                    var t = function(e) {
                                        if ("object" != Kt(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Kt(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Kt(t) ? t : t + "";
                                }
                                var Yt = function() {
                                    function e(t, r) {
                                        if (function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, e), !/^[a-zA-Z0-9]{1,12}$/.test(t)) throw new Error("Asset code is invalid (maximum alphanumeric, 12 characters at max)");
                                        if ("xlm" !== String(t).toLowerCase() && !r) throw new Error("Issuer cannot be null");
                                        if (r && !Lt.isValidEd25519PublicKey(r)) throw new Error("Issuer is invalid");
                                        "xlm" === String(t).toLowerCase() ? this.code = "XLM" : this.code = t, this.issuer = r;
                                    }
                                    return function(e, t, r) {
                                        return t && Zt(e.prototype, t), r && Zt(e, r), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(e, [
                                        {
                                            key: "toXDRObject",
                                            value: function() {
                                                return this._toXDRObject(i.Asset);
                                            }
                                        },
                                        {
                                            key: "toChangeTrustXDRObject",
                                            value: function() {
                                                return this._toXDRObject(i.ChangeTrustAsset);
                                            }
                                        },
                                        {
                                            key: "toTrustLineXDRObject",
                                            value: function() {
                                                return this._toXDRObject(i.TrustLineAsset);
                                            }
                                        },
                                        {
                                            key: "contractId",
                                            value: function(e) {
                                                var t = u(Xt.from(e)), r = i.HashIdPreimage.envelopeTypeContractId(new i.HashIdPreimageContractId({
                                                    networkId: t,
                                                    contractIdPreimage: i.ContractIdPreimage.contractIdPreimageFromAsset(this.toXDRObject())
                                                }));
                                                return Lt.encodeContract(u(r.toXDR()));
                                            }
                                        },
                                        {
                                            key: "_toXDRObject",
                                            value: function() {
                                                var e, t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.Asset;
                                                if (this.isNative()) return r.assetTypeNative();
                                                this.code.length <= 4 ? (e = i.AlphaNum4, t = "assetTypeCreditAlphanum4") : (e = i.AlphaNum12, t = "assetTypeCreditAlphanum12");
                                                var n = this.code.length <= 4 ? 4 : 12;
                                                return new r(t, new e({
                                                    assetCode: this.code.padEnd(n, "\0"),
                                                    issuer: Wt.fromPublicKey(this.issuer).xdrAccountId()
                                                }));
                                            }
                                        },
                                        {
                                            key: "getCode",
                                            value: function() {
                                                if (void 0 !== this.code) return String(this.code);
                                            }
                                        },
                                        {
                                            key: "getIssuer",
                                            value: function() {
                                                if (void 0 !== this.issuer) return String(this.issuer);
                                            }
                                        },
                                        {
                                            key: "getAssetType",
                                            value: function() {
                                                switch(this.getRawAssetType().value){
                                                    case i.AssetType.assetTypeNative().value:
                                                        return "native";
                                                    case i.AssetType.assetTypeCreditAlphanum4().value:
                                                        return "credit_alphanum4";
                                                    case i.AssetType.assetTypeCreditAlphanum12().value:
                                                        return "credit_alphanum12";
                                                    default:
                                                        return "unknown";
                                                }
                                            }
                                        },
                                        {
                                            key: "getRawAssetType",
                                            value: function() {
                                                return this.isNative() ? i.AssetType.assetTypeNative() : this.code.length <= 4 ? i.AssetType.assetTypeCreditAlphanum4() : i.AssetType.assetTypeCreditAlphanum12();
                                            }
                                        },
                                        {
                                            key: "isNative",
                                            value: function() {
                                                return !this.issuer;
                                            }
                                        },
                                        {
                                            key: "equals",
                                            value: function(e) {
                                                return this.code === e.getCode() && this.issuer === e.getIssuer();
                                            }
                                        },
                                        {
                                            key: "toString",
                                            value: function() {
                                                return this.isNative() ? "native" : "".concat(this.getCode(), ":").concat(this.getIssuer());
                                            }
                                        }
                                    ], [
                                        {
                                            key: "native",
                                            value: function() {
                                                return new e("XLM");
                                            }
                                        },
                                        {
                                            key: "fromOperation",
                                            value: function(e) {
                                                var t, r;
                                                switch(e.switch()){
                                                    case i.AssetType.assetTypeNative():
                                                        return this.native();
                                                    case i.AssetType.assetTypeCreditAlphanum4():
                                                        t = e.alphaNum4();
                                                    case i.AssetType.assetTypeCreditAlphanum12():
                                                        return t = t || e.alphaNum12(), r = Lt.encodeEd25519PublicKey(t.issuer().ed25519()), new this(kt(t.assetCode(), "\0"), r);
                                                    default:
                                                        throw new Error("Invalid asset type: ".concat(e.switch().name));
                                                }
                                            }
                                        },
                                        {
                                            key: "compare",
                                            value: function(t, r) {
                                                if (!(t && t instanceof e)) throw new Error("assetA is invalid");
                                                if (!(r && r instanceof e)) throw new Error("assetB is invalid");
                                                if (t.equals(r)) return 0;
                                                var n = t.getRawAssetType().value, o = r.getRawAssetType().value;
                                                if (n !== o) return n < o ? -1 : 1;
                                                var i = Qt(t.getCode(), r.getCode());
                                                return 0 !== i ? i : Qt(t.getIssuer(), r.getIssuer());
                                            }
                                        }
                                    ]);
                                }();
                                function Qt(e, t) {
                                    return Xt.compare(Xt.from(e, "ascii"), Xt.from(t, "ascii"));
                                }
                                var Jt = r(8287).Buffer, er = 30;
                                function tr(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    if ("constant_product" !== e) throw new Error("liquidityPoolType is invalid");
                                    var r = t.assetA, n = t.assetB, o = t.fee;
                                    if (!(r && r instanceof Yt)) throw new Error("assetA is invalid");
                                    if (!(n && n instanceof Yt)) throw new Error("assetB is invalid");
                                    if (!o || o !== er) throw new Error("fee is invalid");
                                    if (-1 !== Yt.compare(r, n)) throw new Error("Assets are not in lexicographic order");
                                    var a = i.LiquidityPoolType.liquidityPoolConstantProduct().toXDR(), s = new i.LiquidityPoolConstantProductParameters({
                                        assetA: r.toXDRObject(),
                                        assetB: n.toXDRObject(),
                                        fee: o
                                    }).toXDR();
                                    return u(Jt.concat([
                                        a,
                                        s
                                    ]));
                                }
                                var rr = r(8287).Buffer;
                                function nr(e) {
                                    return nr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, nr(e);
                                }
                                function or(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ir(n.key), n);
                                    }
                                }
                                function ir(e) {
                                    var t = function(e) {
                                        if ("object" != nr(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != nr(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == nr(t) ? t : t + "";
                                }
                                var ar = function(e, t) {
                                    return t && or(e.prototype, t), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t, r, n, o) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), "string" != typeof o) throw new Error("Invalid passphrase provided to Transaction: expected a string but got a ".concat(nr(o)));
                                    this._networkPassphrase = o, this._tx = t, this._signatures = r, this._fee = n;
                                }, [
                                    {
                                        key: "signatures",
                                        get: function() {
                                            return this._signatures;
                                        },
                                        set: function(e) {
                                            throw new Error("Transaction is immutable");
                                        }
                                    },
                                    {
                                        key: "tx",
                                        get: function() {
                                            return this._tx;
                                        },
                                        set: function(e) {
                                            throw new Error("Transaction is immutable");
                                        }
                                    },
                                    {
                                        key: "fee",
                                        get: function() {
                                            return this._fee;
                                        },
                                        set: function(e) {
                                            throw new Error("Transaction is immutable");
                                        }
                                    },
                                    {
                                        key: "networkPassphrase",
                                        get: function() {
                                            return this._networkPassphrase;
                                        },
                                        set: function(e) {
                                            throw new Error("Transaction is immutable");
                                        }
                                    },
                                    {
                                        key: "sign",
                                        value: function() {
                                            for(var e = this, t = this.hash(), r = arguments.length, n = new Array(r), o = 0; o < r; o++)n[o] = arguments[o];
                                            n.forEach(function(r) {
                                                var n = r.signDecorated(t);
                                                e.signatures.push(n);
                                            });
                                        }
                                    },
                                    {
                                        key: "getKeypairSignature",
                                        value: function(e) {
                                            return e.sign(this.hash()).toString("base64");
                                        }
                                    },
                                    {
                                        key: "addSignature",
                                        value: function() {
                                            var e, t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                                            if (!n || "string" != typeof n) throw new Error("Invalid signature");
                                            if (!r || "string" != typeof r) throw new Error("Invalid publicKey");
                                            var o = rr.from(n, "base64");
                                            try {
                                                t = (e = Wt.fromPublicKey(r)).signatureHint();
                                            } catch (e) {
                                                throw new Error("Invalid publicKey");
                                            }
                                            if (!e.verify(this.hash(), o)) throw new Error("Invalid signature");
                                            this.signatures.push(new i.DecoratedSignature({
                                                hint: t,
                                                signature: o
                                            }));
                                        }
                                    },
                                    {
                                        key: "addDecoratedSignature",
                                        value: function(e) {
                                            this.signatures.push(e);
                                        }
                                    },
                                    {
                                        key: "signHashX",
                                        value: function(e) {
                                            if ("string" == typeof e && (e = rr.from(e, "hex")), e.length > 64) throw new Error("preimage cannnot be longer than 64 bytes");
                                            var t = e, r = u(e), n = r.slice(r.length - 4);
                                            this.signatures.push(new i.DecoratedSignature({
                                                hint: n,
                                                signature: t
                                            }));
                                        }
                                    },
                                    {
                                        key: "hash",
                                        value: function() {
                                            return u(this.signatureBase());
                                        }
                                    },
                                    {
                                        key: "signatureBase",
                                        value: function() {
                                            throw new Error("Implement in subclass");
                                        }
                                    },
                                    {
                                        key: "toEnvelope",
                                        value: function() {
                                            throw new Error("Implement in subclass");
                                        }
                                    },
                                    {
                                        key: "toXDR",
                                        value: function() {
                                            return this.toEnvelope().toXDR().toString("base64");
                                        }
                                    }
                                ]), sr = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, ur = Math.ceil, cr = Math.floor, lr = "[BigNumber Error] ", fr = lr + "Number primitive has more than 15 significant digits: ", pr = 1e14, dr = 14, hr = 9007199254740991, yr = [
                                    1,
                                    10,
                                    100,
                                    1e3,
                                    1e4,
                                    1e5,
                                    1e6,
                                    1e7,
                                    1e8,
                                    1e9,
                                    1e10,
                                    1e11,
                                    1e12,
                                    1e13
                                ], mr = 1e7, gr = 1e9;
                                function vr(e) {
                                    var t = 0 | e;
                                    return e > 0 || e === t ? t : t - 1;
                                }
                                function br(e) {
                                    for(var t, r, n = 1, o = e.length, i = e[0] + ""; n < o;){
                                        for(t = e[n++] + "", r = dr - t.length; r--; t = "0" + t);
                                        i += t;
                                    }
                                    for(o = i.length; 48 === i.charCodeAt(--o););
                                    return i.slice(0, o + 1 || 1);
                                }
                                function wr(e, t) {
                                    var r, n, o = e.c, i = t.c, a = e.s, s = t.s, u = e.e, c = t.e;
                                    if (!a || !s) return null;
                                    if (r = o && !o[0], n = i && !i[0], r || n) return r ? n ? 0 : -s : a;
                                    if (a != s) return a;
                                    if (r = a < 0, n = u == c, !o || !i) return n ? 0 : !o ^ r ? 1 : -1;
                                    if (!n) return u > c ^ r ? 1 : -1;
                                    for(s = (u = o.length) < (c = i.length) ? u : c, a = 0; a < s; a++)if (o[a] != i[a]) return o[a] > i[a] ^ r ? 1 : -1;
                                    return u == c ? 0 : u > c ^ r ? 1 : -1;
                                }
                                function Sr(e, t, r, n) {
                                    if (e < t || e > r || e !== cr(e)) throw Error(lr + (n || "Argument") + ("number" == typeof e ? e < t || e > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
                                }
                                function Ar(e) {
                                    var t = e.c.length - 1;
                                    return vr(e.e / dr) == t && e.c[t] % 2 != 0;
                                }
                                function Er(e, t) {
                                    return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
                                }
                                function Tr(e, t, r) {
                                    var n, o;
                                    if (t < 0) {
                                        for(o = r + "."; ++t; o += r);
                                        e = o + e;
                                    } else if (++t > (n = e.length)) {
                                        for(o = r, t -= n; --t; o += r);
                                        e += o;
                                    } else t < n && (e = e.slice(0, t) + "." + e.slice(t));
                                    return e;
                                }
                                var Or = function e(t) {
                                    var r, n, o, i, a, s, u, c, l, f, p = k.prototype = {
                                        constructor: k,
                                        toString: null,
                                        valueOf: null
                                    }, d = new k(1), h = 20, y = 4, m = -7, g = 21, v = -10000000, b = 1e7, w = !1, S = 1, A = 0, E = {
                                        prefix: "",
                                        groupSize: 3,
                                        secondaryGroupSize: 0,
                                        groupSeparator: ",",
                                        decimalSeparator: ".",
                                        fractionGroupSize: 0,
                                        fractionGroupSeparator: "\xa0",
                                        suffix: ""
                                    }, T = "0123456789abcdefghijklmnopqrstuvwxyz", O = !0;
                                    function k(e, t) {
                                        var r, i, a, s, u, c, l, f, p = this;
                                        if (!(p instanceof k)) return new k(e, t);
                                        if (null == t) {
                                            if (e && !0 === e._isBigNumber) return p.s = e.s, void (!e.c || e.e > b ? p.c = p.e = null : e.e < v ? p.c = [
                                                p.e = 0
                                            ] : (p.e = e.e, p.c = e.c.slice()));
                                            if ((c = "number" == typeof e) && 0 * e == 0) {
                                                if (p.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                                                    for(s = 0, u = e; u >= 10; u /= 10, s++);
                                                    return void (s > b ? p.c = p.e = null : (p.e = s, p.c = [
                                                        e
                                                    ]));
                                                }
                                                f = String(e);
                                            } else {
                                                if (!sr.test(f = String(e))) return o(p, f, c);
                                                p.s = 45 == f.charCodeAt(0) ? (f = f.slice(1), -1) : 1;
                                            }
                                            (s = f.indexOf(".")) > -1 && (f = f.replace(".", "")), (u = f.search(/e/i)) > 0 ? (s < 0 && (s = u), s += +f.slice(u + 1), f = f.substring(0, u)) : s < 0 && (s = f.length);
                                        } else {
                                            if (Sr(t, 2, T.length, "Base"), 10 == t && O) return R(p = new k(e), h + p.e + 1, y);
                                            if (f = String(e), c = "number" == typeof e) {
                                                if (0 * e != 0) return o(p, f, c, t);
                                                if (p.s = 1 / e < 0 ? (f = f.slice(1), -1) : 1, k.DEBUG && f.replace(/^0\.0*|\./, "").length > 15) throw Error(fr + e);
                                            } else p.s = 45 === f.charCodeAt(0) ? (f = f.slice(1), -1) : 1;
                                            for(r = T.slice(0, t), s = u = 0, l = f.length; u < l; u++)if (r.indexOf(i = f.charAt(u)) < 0) {
                                                if ("." == i) {
                                                    if (u > s) {
                                                        s = l;
                                                        continue;
                                                    }
                                                } else if (!a && (f == f.toUpperCase() && (f = f.toLowerCase()) || f == f.toLowerCase() && (f = f.toUpperCase()))) {
                                                    a = !0, u = -1, s = 0;
                                                    continue;
                                                }
                                                return o(p, String(e), c, t);
                                            }
                                            c = !1, (s = (f = n(f, t, 10, p.s)).indexOf(".")) > -1 ? f = f.replace(".", "") : s = f.length;
                                        }
                                        for(u = 0; 48 === f.charCodeAt(u); u++);
                                        for(l = f.length; 48 === f.charCodeAt(--l););
                                        if (f = f.slice(u, ++l)) {
                                            if (l -= u, c && k.DEBUG && l > 15 && (e > hr || e !== cr(e))) throw Error(fr + p.s * e);
                                            if ((s = s - u - 1) > b) p.c = p.e = null;
                                            else if (s < v) p.c = [
                                                p.e = 0
                                            ];
                                            else {
                                                if (p.e = s, p.c = [], u = (s + 1) % dr, s < 0 && (u += dr), u < l) {
                                                    for(u && p.c.push(+f.slice(0, u)), l -= dr; u < l;)p.c.push(+f.slice(u, u += dr));
                                                    u = dr - (f = f.slice(u)).length;
                                                } else u -= l;
                                                for(; u--; f += "0");
                                                p.c.push(+f);
                                            }
                                        } else p.c = [
                                            p.e = 0
                                        ];
                                    }
                                    function _(e, t, r, n) {
                                        var o, i, a, s, u;
                                        if (null == r ? r = y : Sr(r, 0, 8), !e.c) return e.toString();
                                        if (o = e.c[0], a = e.e, null == t) u = br(e.c), u = 1 == n || 2 == n && (a <= m || a >= g) ? Er(u, a) : Tr(u, a, "0");
                                        else if (i = (e = R(new k(e), t, r)).e, s = (u = br(e.c)).length, 1 == n || 2 == n && (t <= i || i <= m)) {
                                            for(; s < t; u += "0", s++);
                                            u = Er(u, i);
                                        } else if (t -= a + (2 === n && i > a), u = Tr(u, i, "0"), i + 1 > s) {
                                            if (--t > 0) for(u += "."; t--; u += "0");
                                        } else if ((t += i - s) > 0) for(i + 1 == s && (u += "."); t--; u += "0");
                                        return e.s < 0 && o ? "-" + u : u;
                                    }
                                    function x(e, t) {
                                        for(var r, n, o = 1, i = new k(e[0]); o < e.length; o++)(!(n = new k(e[o])).s || (r = wr(i, n)) === t || 0 === r && i.s === t) && (i = n);
                                        return i;
                                    }
                                    function P(e, t, r) {
                                        for(var n = 1, o = t.length; !t[--o]; t.pop());
                                        for(o = t[0]; o >= 10; o /= 10, n++);
                                        return (r = n + r * dr - 1) > b ? e.c = e.e = null : r < v ? e.c = [
                                            e.e = 0
                                        ] : (e.e = r, e.c = t), e;
                                    }
                                    function R(e, t, r, n) {
                                        var o, i, a, s, u, c, l, f = e.c, p = yr;
                                        if (f) {
                                            e: {
                                                for(o = 1, s = f[0]; s >= 10; s /= 10, o++);
                                                if ((i = t - o) < 0) i += dr, a = t, u = f[c = 0], l = cr(u / p[o - a - 1] % 10);
                                                else if ((c = ur((i + 1) / dr)) >= f.length) {
                                                    if (!n) break e;
                                                    for(; f.length <= c; f.push(0));
                                                    u = l = 0, o = 1, a = (i %= dr) - dr + 1;
                                                } else {
                                                    for(u = s = f[c], o = 1; s >= 10; s /= 10, o++);
                                                    l = (a = (i %= dr) - dr + o) < 0 ? 0 : cr(u / p[o - a - 1] % 10);
                                                }
                                                if (n = n || t < 0 || null != f[c + 1] || (a < 0 ? u : u % p[o - a - 1]), n = r < 4 ? (l || n) && (0 == r || r == (e.s < 0 ? 3 : 2)) : l > 5 || 5 == l && (4 == r || n || 6 == r && (i > 0 ? a > 0 ? u / p[o - a] : 0 : f[c - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !f[0]) return f.length = 0, n ? (t -= e.e + 1, f[0] = p[(dr - t % dr) % dr], e.e = -t || 0) : f[0] = e.e = 0, e;
                                                if (0 == i ? (f.length = c, s = 1, c--) : (f.length = c + 1, s = p[dr - i], f[c] = a > 0 ? cr(u / p[o - a] % p[a]) * s : 0), n) for(;;){
                                                    if (0 == c) {
                                                        for(i = 1, a = f[0]; a >= 10; a /= 10, i++);
                                                        for(a = f[0] += s, s = 1; a >= 10; a /= 10, s++);
                                                        i != s && (e.e++, f[0] == pr && (f[0] = 1));
                                                        break;
                                                    }
                                                    if (f[c] += s, f[c] != pr) break;
                                                    f[c--] = 0, s = 1;
                                                }
                                                for(i = f.length; 0 === f[--i]; f.pop());
                                            }
                                            e.e > b ? e.c = e.e = null : e.e < v && (e.c = [
                                                e.e = 0
                                            ]);
                                        }
                                        return e;
                                    }
                                    function I(e) {
                                        var t, r = e.e;
                                        return null === r ? e.toString() : (t = br(e.c), t = r <= m || r >= g ? Er(t, r) : Tr(t, r, "0"), e.s < 0 ? "-" + t : t);
                                    }
                                    return k.clone = e, k.ROUND_UP = 0, k.ROUND_DOWN = 1, k.ROUND_CEIL = 2, k.ROUND_FLOOR = 3, k.ROUND_HALF_UP = 4, k.ROUND_HALF_DOWN = 5, k.ROUND_HALF_EVEN = 6, k.ROUND_HALF_CEIL = 7, k.ROUND_HALF_FLOOR = 8, k.EUCLID = 9, k.config = k.set = function(e) {
                                        var t, r;
                                        if (null != e) {
                                            if ("object" != typeof e) throw Error(lr + "Object expected: " + e);
                                            if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (Sr(r = e[t], 0, gr, t), h = r), e.hasOwnProperty(t = "ROUNDING_MODE") && (Sr(r = e[t], 0, 8, t), y = r), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((r = e[t]) && r.pop ? (Sr(r[0], -gr, 0, t), Sr(r[1], 0, gr, t), m = r[0], g = r[1]) : (Sr(r, -gr, gr, t), m = -(g = r < 0 ? -r : r))), e.hasOwnProperty(t = "RANGE")) {
                                                if ((r = e[t]) && r.pop) Sr(r[0], -gr, -1, t), Sr(r[1], 1, gr, t), v = r[0], b = r[1];
                                                else {
                                                    if (Sr(r, -gr, gr, t), !r) throw Error(lr + t + " cannot be zero: " + r);
                                                    v = -(b = r < 0 ? -r : r);
                                                }
                                            }
                                            if (e.hasOwnProperty(t = "CRYPTO")) {
                                                if ((r = e[t]) !== !!r) throw Error(lr + t + " not true or false: " + r);
                                                if (r) {
                                                    if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw w = !r, Error(lr + "crypto unavailable");
                                                    w = r;
                                                } else w = r;
                                            }
                                            if (e.hasOwnProperty(t = "MODULO_MODE") && (Sr(r = e[t], 0, 9, t), S = r), e.hasOwnProperty(t = "POW_PRECISION") && (Sr(r = e[t], 0, gr, t), A = r), e.hasOwnProperty(t = "FORMAT")) {
                                                if ("object" != typeof (r = e[t])) throw Error(lr + t + " not an object: " + r);
                                                E = r;
                                            }
                                            if (e.hasOwnProperty(t = "ALPHABET")) {
                                                if ("string" != typeof (r = e[t]) || /^.?$|[+\-.\s]|(.).*\1/.test(r)) throw Error(lr + t + " invalid: " + r);
                                                O = "0123456789" == r.slice(0, 10), T = r;
                                            }
                                        }
                                        return {
                                            DECIMAL_PLACES: h,
                                            ROUNDING_MODE: y,
                                            EXPONENTIAL_AT: [
                                                m,
                                                g
                                            ],
                                            RANGE: [
                                                v,
                                                b
                                            ],
                                            CRYPTO: w,
                                            MODULO_MODE: S,
                                            POW_PRECISION: A,
                                            FORMAT: E,
                                            ALPHABET: T
                                        };
                                    }, k.isBigNumber = function(e) {
                                        if (!e || !0 !== e._isBigNumber) return !1;
                                        if (!k.DEBUG) return !0;
                                        var t, r, n = e.c, o = e.e, i = e.s;
                                        e: if ("[object Array]" == ({}).toString.call(n)) {
                                            if ((1 === i || -1 === i) && o >= -gr && o <= gr && o === cr(o)) {
                                                if (0 === n[0]) {
                                                    if (0 === o && 1 === n.length) return !0;
                                                    break e;
                                                }
                                                if ((t = (o + 1) % dr) < 1 && (t += dr), String(n[0]).length == t) {
                                                    for(t = 0; t < n.length; t++)if ((r = n[t]) < 0 || r >= pr || r !== cr(r)) break e;
                                                    if (0 !== r) return !0;
                                                }
                                            }
                                        } else if (null === n && null === o && (null === i || 1 === i || -1 === i)) return !0;
                                        throw Error(lr + "Invalid BigNumber: " + e);
                                    }, k.maximum = k.max = function() {
                                        return x(arguments, -1);
                                    }, k.minimum = k.min = function() {
                                        return x(arguments, 1);
                                    }, k.random = (i = 9007199254740992, a = Math.random() * i & 2097151 ? function() {
                                        return cr(Math.random() * i);
                                    } : function() {
                                        return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
                                    }, function(e) {
                                        var t, r, n, o, i, s = 0, u = [], c = new k(d);
                                        if (null == e ? e = h : Sr(e, 0, gr), o = ur(e / dr), w) {
                                            if (crypto.getRandomValues) {
                                                for(t = crypto.getRandomValues(new Uint32Array(o *= 2)); s < o;)(i = 131072 * t[s] + (t[s + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), t[s] = r[0], t[s + 1] = r[1]) : (u.push(i % 1e14), s += 2);
                                                s = o / 2;
                                            } else {
                                                if (!crypto.randomBytes) throw w = !1, Error(lr + "crypto unavailable");
                                                for(t = crypto.randomBytes(o *= 7); s < o;)(i = 281474976710656 * (31 & t[s]) + 1099511627776 * t[s + 1] + 4294967296 * t[s + 2] + 16777216 * t[s + 3] + (t[s + 4] << 16) + (t[s + 5] << 8) + t[s + 6]) >= 9e15 ? crypto.randomBytes(7).copy(t, s) : (u.push(i % 1e14), s += 7);
                                                s = o / 7;
                                            }
                                        }
                                        if (!w) for(; s < o;)(i = a()) < 9e15 && (u[s++] = i % 1e14);
                                        for(o = u[--s], e %= dr, o && e && (i = yr[dr - e], u[s] = cr(o / i) * i); 0 === u[s]; u.pop(), s--);
                                        if (s < 0) u = [
                                            n = 0
                                        ];
                                        else {
                                            for(n = -1; 0 === u[0]; u.splice(0, 1), n -= dr);
                                            for(s = 1, i = u[0]; i >= 10; i /= 10, s++);
                                            s < dr && (n -= dr - s);
                                        }
                                        return c.e = n, c.c = u, c;
                                    }), k.sum = function() {
                                        for(var e = 1, t = arguments, r = new k(t[0]); e < t.length;)r = r.plus(t[e++]);
                                        return r;
                                    }, n = function() {
                                        var e = "0123456789";
                                        function t(e, t, r, n) {
                                            for(var o, i, a = [
                                                0
                                            ], s = 0, u = e.length; s < u;){
                                                for(i = a.length; i--; a[i] *= t);
                                                for(a[0] += n.indexOf(e.charAt(s++)), o = 0; o < a.length; o++)a[o] > r - 1 && (null == a[o + 1] && (a[o + 1] = 0), a[o + 1] += a[o] / r | 0, a[o] %= r);
                                            }
                                            return a.reverse();
                                        }
                                        return function(n, o, i, a, s) {
                                            var u, c, l, f, p, d, m, g, v = n.indexOf("."), b = h, w = y;
                                            for(v >= 0 && (f = A, A = 0, n = n.replace(".", ""), d = (g = new k(o)).pow(n.length - v), A = f, g.c = t(Tr(br(d.c), d.e, "0"), 10, i, e), g.e = g.c.length), l = f = (m = t(n, o, i, s ? (u = T, e) : (u = e, T))).length; 0 == m[--f]; m.pop());
                                            if (!m[0]) return u.charAt(0);
                                            if (v < 0 ? --l : (d.c = m, d.e = l, d.s = a, m = (d = r(d, g, b, w, i)).c, p = d.r, l = d.e), v = m[c = l + b + 1], f = i / 2, p = p || c < 0 || null != m[c + 1], p = w < 4 ? (null != v || p) && (0 == w || w == (d.s < 0 ? 3 : 2)) : v > f || v == f && (4 == w || p || 6 == w && 1 & m[c - 1] || w == (d.s < 0 ? 8 : 7)), c < 1 || !m[0]) n = p ? Tr(u.charAt(1), -b, u.charAt(0)) : u.charAt(0);
                                            else {
                                                if (m.length = c, p) for(--i; ++m[--c] > i;)m[c] = 0, c || (++l, m = [
                                                    1
                                                ].concat(m));
                                                for(f = m.length; !m[--f];);
                                                for(v = 0, n = ""; v <= f; n += u.charAt(m[v++]));
                                                n = Tr(n, l, u.charAt(0));
                                            }
                                            return n;
                                        };
                                    }(), r = function() {
                                        function e(e, t, r) {
                                            var n, o, i, a, s = 0, u = e.length, c = t % mr, l = t / mr | 0;
                                            for(e = e.slice(); u--;)s = ((o = c * (i = e[u] % mr) + (n = l * i + (a = e[u] / mr | 0) * c) % mr * mr + s) / r | 0) + (n / mr | 0) + l * a, e[u] = o % r;
                                            return s && (e = [
                                                s
                                            ].concat(e)), e;
                                        }
                                        function t(e, t, r, n) {
                                            var o, i;
                                            if (r != n) i = r > n ? 1 : -1;
                                            else for(o = i = 0; o < r; o++)if (e[o] != t[o]) {
                                                i = e[o] > t[o] ? 1 : -1;
                                                break;
                                            }
                                            return i;
                                        }
                                        function r(e, t, r, n) {
                                            for(var o = 0; r--;)e[r] -= o, o = e[r] < t[r] ? 1 : 0, e[r] = o * n + e[r] - t[r];
                                            for(; !e[0] && e.length > 1; e.splice(0, 1));
                                        }
                                        return function(n, o, i, a, s) {
                                            var u, c, l, f, p, d, h, y, m, g, v, b, w, S, A, E, T, O = n.s == o.s ? 1 : -1, _ = n.c, x = o.c;
                                            if (!(_ && _[0] && x && x[0])) return new k(n.s && o.s && (_ ? !x || _[0] != x[0] : x) ? _ && 0 == _[0] || !x ? 0 * O : O / 0 : NaN);
                                            for(m = (y = new k(O)).c = [], O = i + (c = n.e - o.e) + 1, s || (s = pr, c = vr(n.e / dr) - vr(o.e / dr), O = O / dr | 0), l = 0; x[l] == (_[l] || 0); l++);
                                            if (x[l] > (_[l] || 0) && c--, O < 0) m.push(1), f = !0;
                                            else {
                                                for(S = _.length, E = x.length, l = 0, O += 2, (p = cr(s / (x[0] + 1))) > 1 && (x = e(x, p, s), _ = e(_, p, s), E = x.length, S = _.length), w = E, v = (g = _.slice(0, E)).length; v < E; g[v++] = 0);
                                                T = x.slice(), T = [
                                                    0
                                                ].concat(T), A = x[0], x[1] >= s / 2 && A++;
                                                do {
                                                    if (p = 0, (u = t(x, g, E, v)) < 0) {
                                                        if (b = g[0], E != v && (b = b * s + (g[1] || 0)), (p = cr(b / A)) > 1) for(p >= s && (p = s - 1), h = (d = e(x, p, s)).length, v = g.length; 1 == t(d, g, h, v);)p--, r(d, E < h ? T : x, h, s), h = d.length, u = 1;
                                                        else 0 == p && (u = p = 1), h = (d = x.slice()).length;
                                                        if (h < v && (d = [
                                                            0
                                                        ].concat(d)), r(g, d, v, s), v = g.length, -1 == u) for(; t(x, g, E, v) < 1;)p++, r(g, E < v ? T : x, v, s), v = g.length;
                                                    } else 0 === u && (p++, g = [
                                                        0
                                                    ]);
                                                    m[l++] = p, g[0] ? g[v++] = _[w] || 0 : (g = [
                                                        _[w]
                                                    ], v = 1);
                                                }while ((w++ < S || null != g[0]) && O--);
                                                f = null != g[0], m[0] || m.splice(0, 1);
                                            }
                                            if (s == pr) {
                                                for(l = 1, O = m[0]; O >= 10; O /= 10, l++);
                                                R(y, i + (y.e = l + c * dr - 1) + 1, a, f);
                                            } else y.e = c, y.r = +f;
                                            return y;
                                        };
                                    }(), s = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, c = /^\.([^.]+)$/, l = /^-?(Infinity|NaN)$/, f = /^\s*\+(?=[\w.])|^\s+|\s+$/g, o = function(e, t, r, n) {
                                        var o, i = r ? t : t.replace(f, "");
                                        if (l.test(i)) e.s = isNaN(i) ? null : i < 0 ? -1 : 1;
                                        else {
                                            if (!r && (i = i.replace(s, function(e, t, r) {
                                                return o = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != o ? e : t;
                                            }), n && (o = n, i = i.replace(u, "$1").replace(c, "0.$1")), t != i)) return new k(i, o);
                                            if (k.DEBUG) throw Error(lr + "Not a" + (n ? " base " + n : "") + " number: " + t);
                                            e.s = null;
                                        }
                                        e.c = e.e = null;
                                    }, p.absoluteValue = p.abs = function() {
                                        var e = new k(this);
                                        return e.s < 0 && (e.s = 1), e;
                                    }, p.comparedTo = function(e, t) {
                                        return wr(this, new k(e, t));
                                    }, p.decimalPlaces = p.dp = function(e, t) {
                                        var r, n, o, i = this;
                                        if (null != e) return Sr(e, 0, gr), null == t ? t = y : Sr(t, 0, 8), R(new k(i), e + i.e + 1, t);
                                        if (!(r = i.c)) return null;
                                        if (n = ((o = r.length - 1) - vr(this.e / dr)) * dr, o = r[o]) for(; o % 10 == 0; o /= 10, n--);
                                        return n < 0 && (n = 0), n;
                                    }, p.dividedBy = p.div = function(e, t) {
                                        return r(this, new k(e, t), h, y);
                                    }, p.dividedToIntegerBy = p.idiv = function(e, t) {
                                        return r(this, new k(e, t), 0, 1);
                                    }, p.exponentiatedBy = p.pow = function(e, t) {
                                        var r, n, o, i, a, s, u, c, l = this;
                                        if ((e = new k(e)).c && !e.isInteger()) throw Error(lr + "Exponent not an integer: " + I(e));
                                        if (null != t && (t = new k(t)), a = e.e > 14, !l.c || !l.c[0] || 1 == l.c[0] && !l.e && 1 == l.c.length || !e.c || !e.c[0]) return c = new k(Math.pow(+I(l), a ? e.s * (2 - Ar(e)) : +I(e))), t ? c.mod(t) : c;
                                        if (s = e.s < 0, t) {
                                            if (t.c ? !t.c[0] : !t.s) return new k(NaN);
                                            (n = !s && l.isInteger() && t.isInteger()) && (l = l.mod(t));
                                        } else {
                                            if (e.e > 9 && (l.e > 0 || l.e < -1 || (0 == l.e ? l.c[0] > 1 || a && l.c[1] >= 24e7 : l.c[0] < 8e13 || a && l.c[0] <= 9999975e7))) return i = l.s < 0 && Ar(e) ? -0 : 0, l.e > -1 && (i = 1 / i), new k(s ? 1 / i : i);
                                            A && (i = ur(A / dr + 2));
                                        }
                                        for(a ? (r = new k(.5), s && (e.s = 1), u = Ar(e)) : u = (o = Math.abs(+I(e))) % 2, c = new k(d);;){
                                            if (u) {
                                                if (!(c = c.times(l)).c) break;
                                                i ? c.c.length > i && (c.c.length = i) : n && (c = c.mod(t));
                                            }
                                            if (o) {
                                                if (0 === (o = cr(o / 2))) break;
                                                u = o % 2;
                                            } else if (R(e = e.times(r), e.e + 1, 1), e.e > 14) u = Ar(e);
                                            else {
                                                if (0 === (o = +I(e))) break;
                                                u = o % 2;
                                            }
                                            l = l.times(l), i ? l.c && l.c.length > i && (l.c.length = i) : n && (l = l.mod(t));
                                        }
                                        return n ? c : (s && (c = d.div(c)), t ? c.mod(t) : i ? R(c, A, y, void 0) : c);
                                    }, p.integerValue = function(e) {
                                        var t = new k(this);
                                        return null == e ? e = y : Sr(e, 0, 8), R(t, t.e + 1, e);
                                    }, p.isEqualTo = p.eq = function(e, t) {
                                        return 0 === wr(this, new k(e, t));
                                    }, p.isFinite = function() {
                                        return !!this.c;
                                    }, p.isGreaterThan = p.gt = function(e, t) {
                                        return wr(this, new k(e, t)) > 0;
                                    }, p.isGreaterThanOrEqualTo = p.gte = function(e, t) {
                                        return 1 === (t = wr(this, new k(e, t))) || 0 === t;
                                    }, p.isInteger = function() {
                                        return !!this.c && vr(this.e / dr) > this.c.length - 2;
                                    }, p.isLessThan = p.lt = function(e, t) {
                                        return wr(this, new k(e, t)) < 0;
                                    }, p.isLessThanOrEqualTo = p.lte = function(e, t) {
                                        return -1 === (t = wr(this, new k(e, t))) || 0 === t;
                                    }, p.isNaN = function() {
                                        return !this.s;
                                    }, p.isNegative = function() {
                                        return this.s < 0;
                                    }, p.isPositive = function() {
                                        return this.s > 0;
                                    }, p.isZero = function() {
                                        return !!this.c && 0 == this.c[0];
                                    }, p.minus = function(e, t) {
                                        var r, n, o, i, a = this, s = a.s;
                                        if (t = (e = new k(e, t)).s, !s || !t) return new k(NaN);
                                        if (s != t) return e.s = -t, a.plus(e);
                                        var u = a.e / dr, c = e.e / dr, l = a.c, f = e.c;
                                        if (!u || !c) {
                                            if (!l || !f) return l ? (e.s = -t, e) : new k(f ? a : NaN);
                                            if (!l[0] || !f[0]) return f[0] ? (e.s = -t, e) : new k(l[0] ? a : 3 == y ? -0 : 0);
                                        }
                                        if (u = vr(u), c = vr(c), l = l.slice(), s = u - c) {
                                            for((i = s < 0) ? (s = -s, o = l) : (c = u, o = f), o.reverse(), t = s; t--; o.push(0));
                                            o.reverse();
                                        } else for(n = (i = (s = l.length) < (t = f.length)) ? s : t, s = t = 0; t < n; t++)if (l[t] != f[t]) {
                                            i = l[t] < f[t];
                                            break;
                                        }
                                        if (i && (o = l, l = f, f = o, e.s = -e.s), (t = (n = f.length) - (r = l.length)) > 0) for(; t--; l[r++] = 0);
                                        for(t = pr - 1; n > s;){
                                            if (l[--n] < f[n]) {
                                                for(r = n; r && !l[--r]; l[r] = t);
                                                --l[r], l[n] += pr;
                                            }
                                            l[n] -= f[n];
                                        }
                                        for(; 0 == l[0]; l.splice(0, 1), --c);
                                        return l[0] ? P(e, l, c) : (e.s = 3 == y ? -1 : 1, e.c = [
                                            e.e = 0
                                        ], e);
                                    }, p.modulo = p.mod = function(e, t) {
                                        var n, o, i = this;
                                        return e = new k(e, t), !i.c || !e.s || e.c && !e.c[0] ? new k(NaN) : !e.c || i.c && !i.c[0] ? new k(i) : (9 == S ? (o = e.s, e.s = 1, n = r(i, e, 0, 3), e.s = o, n.s *= o) : n = r(i, e, 0, S), (e = i.minus(n.times(e))).c[0] || 1 != S || (e.s = i.s), e);
                                    }, p.multipliedBy = p.times = function(e, t) {
                                        var r, n, o, i, a, s, u, c, l, f, p, d, h, y, m, g = this, v = g.c, b = (e = new k(e, t)).c;
                                        if (!(v && b && v[0] && b[0])) return !g.s || !e.s || v && !v[0] && !b || b && !b[0] && !v ? e.c = e.e = e.s = null : (e.s *= g.s, v && b ? (e.c = [
                                            0
                                        ], e.e = 0) : e.c = e.e = null), e;
                                        for(n = vr(g.e / dr) + vr(e.e / dr), e.s *= g.s, (u = v.length) < (f = b.length) && (h = v, v = b, b = h, o = u, u = f, f = o), o = u + f, h = []; o--; h.push(0));
                                        for(y = pr, m = mr, o = f; --o >= 0;){
                                            for(r = 0, p = b[o] % m, d = b[o] / m | 0, i = o + (a = u); i > o;)r = ((c = p * (c = v[--a] % m) + (s = d * c + (l = v[a] / m | 0) * p) % m * m + h[i] + r) / y | 0) + (s / m | 0) + d * l, h[i--] = c % y;
                                            h[i] = r;
                                        }
                                        return r ? ++n : h.splice(0, 1), P(e, h, n);
                                    }, p.negated = function() {
                                        var e = new k(this);
                                        return e.s = -e.s || null, e;
                                    }, p.plus = function(e, t) {
                                        var r, n = this, o = n.s;
                                        if (t = (e = new k(e, t)).s, !o || !t) return new k(NaN);
                                        if (o != t) return e.s = -t, n.minus(e);
                                        var i = n.e / dr, a = e.e / dr, s = n.c, u = e.c;
                                        if (!i || !a) {
                                            if (!s || !u) return new k(o / 0);
                                            if (!s[0] || !u[0]) return u[0] ? e : new k(s[0] ? n : 0 * o);
                                        }
                                        if (i = vr(i), a = vr(a), s = s.slice(), o = i - a) {
                                            for(o > 0 ? (a = i, r = u) : (o = -o, r = s), r.reverse(); o--; r.push(0));
                                            r.reverse();
                                        }
                                        for((o = s.length) - (t = u.length) < 0 && (r = u, u = s, s = r, t = o), o = 0; t;)o = (s[--t] = s[t] + u[t] + o) / pr | 0, s[t] = pr === s[t] ? 0 : s[t] % pr;
                                        return o && (s = [
                                            o
                                        ].concat(s), ++a), P(e, s, a);
                                    }, p.precision = p.sd = function(e, t) {
                                        var r, n, o, i = this;
                                        if (null != e && e !== !!e) return Sr(e, 1, gr), null == t ? t = y : Sr(t, 0, 8), R(new k(i), e, t);
                                        if (!(r = i.c)) return null;
                                        if (n = (o = r.length - 1) * dr + 1, o = r[o]) {
                                            for(; o % 10 == 0; o /= 10, n--);
                                            for(o = r[0]; o >= 10; o /= 10, n++);
                                        }
                                        return e && i.e + 1 > n && (n = i.e + 1), n;
                                    }, p.shiftedBy = function(e) {
                                        return Sr(e, -9007199254740991, hr), this.times("1e" + e);
                                    }, p.squareRoot = p.sqrt = function() {
                                        var e, t, n, o, i, a = this, s = a.c, u = a.s, c = a.e, l = h + 4, f = new k("0.5");
                                        if (1 !== u || !s || !s[0]) return new k(!u || u < 0 && (!s || s[0]) ? NaN : s ? a : 1 / 0);
                                        if (0 == (u = Math.sqrt(+I(a))) || u == 1 / 0 ? (((t = br(s)).length + c) % 2 == 0 && (t += "0"), u = Math.sqrt(+t), c = vr((c + 1) / 2) - (c < 0 || c % 2), n = new k(t = u == 1 / 0 ? "5e" + c : (t = u.toExponential()).slice(0, t.indexOf("e") + 1) + c)) : n = new k(u + ""), n.c[0]) {
                                            for((u = (c = n.e) + l) < 3 && (u = 0);;)if (i = n, n = f.times(i.plus(r(a, i, l, 1))), br(i.c).slice(0, u) === (t = br(n.c)).slice(0, u)) {
                                                if (n.e < c && --u, "9999" != (t = t.slice(u - 3, u + 1)) && (o || "4999" != t)) {
                                                    +t && (+t.slice(1) || "5" != t.charAt(0)) || (R(n, n.e + h + 2, 1), e = !n.times(n).eq(a));
                                                    break;
                                                }
                                                if (!o && (R(i, i.e + h + 2, 0), i.times(i).eq(a))) {
                                                    n = i;
                                                    break;
                                                }
                                                l += 4, u += 4, o = 1;
                                            }
                                        }
                                        return R(n, n.e + h + 1, y, e);
                                    }, p.toExponential = function(e, t) {
                                        return null != e && (Sr(e, 0, gr), e++), _(this, e, t, 1);
                                    }, p.toFixed = function(e, t) {
                                        return null != e && (Sr(e, 0, gr), e = e + this.e + 1), _(this, e, t);
                                    }, p.toFormat = function(e, t, r) {
                                        var n, o = this;
                                        if (null == r) null != e && t && "object" == typeof t ? (r = t, t = null) : e && "object" == typeof e ? (r = e, e = t = null) : r = E;
                                        else if ("object" != typeof r) throw Error(lr + "Argument not an object: " + r);
                                        if (n = o.toFixed(e, t), o.c) {
                                            var i, a = n.split("."), s = +r.groupSize, u = +r.secondaryGroupSize, c = r.groupSeparator || "", l = a[0], f = a[1], p = o.s < 0, d = p ? l.slice(1) : l, h = d.length;
                                            if (u && (i = s, s = u, u = i, h -= i), s > 0 && h > 0) {
                                                for(i = h % s || s, l = d.substr(0, i); i < h; i += s)l += c + d.substr(i, s);
                                                u > 0 && (l += c + d.slice(i)), p && (l = "-" + l);
                                            }
                                            n = f ? l + (r.decimalSeparator || "") + ((u = +r.fractionGroupSize) ? f.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : f) : l;
                                        }
                                        return (r.prefix || "") + n + (r.suffix || "");
                                    }, p.toFraction = function(e) {
                                        var t, n, o, i, a, s, u, c, l, f, p, h, m = this, g = m.c;
                                        if (null != e && (!(u = new k(e)).isInteger() && (u.c || 1 !== u.s) || u.lt(d))) throw Error(lr + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + I(u));
                                        if (!g) return new k(m);
                                        for(t = new k(d), l = n = new k(d), o = c = new k(d), h = br(g), a = t.e = h.length - m.e - 1, t.c[0] = yr[(s = a % dr) < 0 ? dr + s : s], e = !e || u.comparedTo(t) > 0 ? a > 0 ? t : l : u, s = b, b = 1 / 0, u = new k(h), c.c[0] = 0; f = r(u, t, 0, 1), 1 != (i = n.plus(f.times(o))).comparedTo(e);)n = o, o = i, l = c.plus(f.times(i = l)), c = i, t = u.minus(f.times(i = t)), u = i;
                                        return i = r(e.minus(n), o, 0, 1), c = c.plus(i.times(l)), n = n.plus(i.times(o)), c.s = l.s = m.s, p = r(l, o, a *= 2, y).minus(m).abs().comparedTo(r(c, n, a, y).minus(m).abs()) < 1 ? [
                                            l,
                                            o
                                        ] : [
                                            c,
                                            n
                                        ], b = s, p;
                                    }, p.toNumber = function() {
                                        return +I(this);
                                    }, p.toPrecision = function(e, t) {
                                        return null != e && Sr(e, 1, gr), _(this, e, t, 2);
                                    }, p.toString = function(e) {
                                        var t, r = this, o = r.s, i = r.e;
                                        return null === i ? o ? (t = "Infinity", o < 0 && (t = "-" + t)) : t = "NaN" : (null == e ? t = i <= m || i >= g ? Er(br(r.c), i) : Tr(br(r.c), i, "0") : 10 === e && O ? t = Tr(br((r = R(new k(r), h + i + 1, y)).c), r.e, "0") : (Sr(e, 2, T.length, "Base"), t = n(Tr(br(r.c), i, "0"), 10, e, o, !0)), o < 0 && r.c[0] && (t = "-" + t)), t;
                                    }, p.valueOf = p.toJSON = function() {
                                        return I(this);
                                    }, p._isBigNumber = !0, p[Symbol.toStringTag] = "BigNumber", p[Symbol.for("nodejs.util.inspect.custom")] = p.valueOf, null != t && k.set(t), k;
                                }(), kr = Or.clone();
                                kr.DEBUG = !0;
                                const _r = kr;
                                function xr(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                                    return n;
                                }
                                var Pr = 2147483647;
                                function Rr(e) {
                                    return Rr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Rr(e);
                                }
                                function Ir(e, t) {
                                    var r = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var n = Object.getOwnPropertySymbols(e);
                                        t && (n = n.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), r.push.apply(r, n);
                                    }
                                    return r;
                                }
                                function Br(e) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var r = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? Ir(Object(r), !0).forEach(function(t) {
                                            Cr(e, t, r[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ir(Object(r)).forEach(function(t) {
                                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                        });
                                    }
                                    return e;
                                }
                                function Cr(e, t, r) {
                                    return (t = Ur(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function jr(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ur(n.key), n);
                                    }
                                }
                                function Ur(e) {
                                    var t = function(e) {
                                        if ("object" != Rr(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Rr(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Rr(t) ? t : t + "";
                                }
                                var Nr = function(e, t, r) {
                                    return t && jr(e.prototype, t), r && jr(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t, r, n) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), !(t && t instanceof Yt)) throw new Error("assetA is invalid");
                                    if (!(r && r instanceof Yt)) throw new Error("assetB is invalid");
                                    if (-1 !== Yt.compare(t, r)) throw new Error("Assets are not in lexicographic order");
                                    if (!n || n !== er) throw new Error("fee is invalid");
                                    this.assetA = t, this.assetB = r, this.fee = n;
                                }, [
                                    {
                                        key: "toXDRObject",
                                        value: function() {
                                            var e = new i.LiquidityPoolConstantProductParameters({
                                                assetA: this.assetA.toXDRObject(),
                                                assetB: this.assetB.toXDRObject(),
                                                fee: this.fee
                                            }), t = new i.LiquidityPoolParameters("liquidityPoolConstantProduct", e);
                                            return new i.ChangeTrustAsset("assetTypePoolShare", t);
                                        }
                                    },
                                    {
                                        key: "getLiquidityPoolParameters",
                                        value: function() {
                                            return Br(Br({}, this), {}, {
                                                assetA: this.assetA,
                                                assetB: this.assetB,
                                                fee: this.fee
                                            });
                                        }
                                    },
                                    {
                                        key: "getAssetType",
                                        value: function() {
                                            return "liquidity_pool_shares";
                                        }
                                    },
                                    {
                                        key: "equals",
                                        value: function(e) {
                                            return this.assetA.equals(e.assetA) && this.assetB.equals(e.assetB) && this.fee === e.fee;
                                        }
                                    },
                                    {
                                        key: "toString",
                                        value: function() {
                                            var e = tr("constant_product", this.getLiquidityPoolParameters()).toString("hex");
                                            return "liquidity_pool:".concat(e);
                                        }
                                    }
                                ], [
                                    {
                                        key: "fromOperation",
                                        value: function(e) {
                                            var t = e.switch();
                                            if (t === i.AssetType.assetTypePoolShare()) {
                                                var r = e.liquidityPool().constantProduct();
                                                return new this(Yt.fromOperation(r.assetA()), Yt.fromOperation(r.assetB()), r.fee());
                                            }
                                            throw new Error("Invalid asset type: ".concat(t.name));
                                        }
                                    }
                                ]);
                                function Lr(e) {
                                    return Lr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Lr(e);
                                }
                                function Fr(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dr(n.key), n);
                                    }
                                }
                                function Dr(e) {
                                    var t = function(e) {
                                        if ("object" != Lr(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Lr(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Lr(t) ? t : t + "";
                                }
                                var Mr = function(e, t, r) {
                                    return t && Fr(e.prototype, t), r && Fr(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t, r) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), t && !Lt.isValidEd25519PublicKey(t)) throw new Error("Destination is invalid");
                                    if (this._destination = t, r) {
                                        if (!(r instanceof i.ClaimPredicate)) throw new Error("Predicate should be an xdr.ClaimPredicate");
                                        this._predicate = r;
                                    } else this._predicate = i.ClaimPredicate.claimPredicateUnconditional();
                                }, [
                                    {
                                        key: "toXDRObject",
                                        value: function() {
                                            var e = new i.ClaimantV0({
                                                destination: Wt.fromPublicKey(this._destination).xdrAccountId(),
                                                predicate: this._predicate
                                            });
                                            return i.Claimant.claimantTypeV0(e);
                                        }
                                    },
                                    {
                                        key: "destination",
                                        get: function() {
                                            return this._destination;
                                        },
                                        set: function(e) {
                                            throw new Error("Claimant is immutable");
                                        }
                                    },
                                    {
                                        key: "predicate",
                                        get: function() {
                                            return this._predicate;
                                        },
                                        set: function(e) {
                                            throw new Error("Claimant is immutable");
                                        }
                                    }
                                ], [
                                    {
                                        key: "predicateUnconditional",
                                        value: function() {
                                            return i.ClaimPredicate.claimPredicateUnconditional();
                                        }
                                    },
                                    {
                                        key: "predicateAnd",
                                        value: function(e, t) {
                                            if (!(e instanceof i.ClaimPredicate)) throw new Error("left Predicate should be an xdr.ClaimPredicate");
                                            if (!(t instanceof i.ClaimPredicate)) throw new Error("right Predicate should be an xdr.ClaimPredicate");
                                            return i.ClaimPredicate.claimPredicateAnd([
                                                e,
                                                t
                                            ]);
                                        }
                                    },
                                    {
                                        key: "predicateOr",
                                        value: function(e, t) {
                                            if (!(e instanceof i.ClaimPredicate)) throw new Error("left Predicate should be an xdr.ClaimPredicate");
                                            if (!(t instanceof i.ClaimPredicate)) throw new Error("right Predicate should be an xdr.ClaimPredicate");
                                            return i.ClaimPredicate.claimPredicateOr([
                                                e,
                                                t
                                            ]);
                                        }
                                    },
                                    {
                                        key: "predicateNot",
                                        value: function(e) {
                                            if (!(e instanceof i.ClaimPredicate)) throw new Error("right Predicate should be an xdr.ClaimPredicate");
                                            return i.ClaimPredicate.claimPredicateNot(e);
                                        }
                                    },
                                    {
                                        key: "predicateBeforeAbsoluteTime",
                                        value: function(e) {
                                            return i.ClaimPredicate.claimPredicateBeforeAbsoluteTime(i.Int64.fromString(e));
                                        }
                                    },
                                    {
                                        key: "predicateBeforeRelativeTime",
                                        value: function(e) {
                                            return i.ClaimPredicate.claimPredicateBeforeRelativeTime(i.Int64.fromString(e));
                                        }
                                    },
                                    {
                                        key: "fromXDR",
                                        value: function(e) {
                                            var t;
                                            if (e.switch() === i.ClaimantType.claimantTypeV0()) return t = e.v0(), new this(Lt.encodeEd25519PublicKey(t.destination().ed25519()), t.predicate());
                                            throw new Error("Invalid claimant type: ".concat(e.switch().name));
                                        }
                                    }
                                ]);
                                function Vr(e) {
                                    return Vr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Vr(e);
                                }
                                function qr(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gr(n.key), n);
                                    }
                                }
                                function Gr(e) {
                                    var t = function(e) {
                                        if ("object" != Vr(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Vr(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Vr(t) ? t : t + "";
                                }
                                var Hr = function(e, t, r) {
                                    return t && qr(e.prototype, t), r && qr(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), !t) throw new Error("liquidityPoolId cannot be empty");
                                    if (!/^[a-f0-9]{64}$/.test(t)) throw new Error("Liquidity pool ID is not a valid hash");
                                    this.liquidityPoolId = t;
                                }, [
                                    {
                                        key: "toXDRObject",
                                        value: function() {
                                            var e = i.PoolId.fromXDR(this.liquidityPoolId, "hex");
                                            return new i.TrustLineAsset("assetTypePoolShare", e);
                                        }
                                    },
                                    {
                                        key: "getLiquidityPoolId",
                                        value: function() {
                                            return String(this.liquidityPoolId);
                                        }
                                    },
                                    {
                                        key: "getAssetType",
                                        value: function() {
                                            return "liquidity_pool_shares";
                                        }
                                    },
                                    {
                                        key: "equals",
                                        value: function(e) {
                                            return this.liquidityPoolId === e.getLiquidityPoolId();
                                        }
                                    },
                                    {
                                        key: "toString",
                                        value: function() {
                                            return "liquidity_pool:".concat(this.liquidityPoolId);
                                        }
                                    }
                                ], [
                                    {
                                        key: "fromOperation",
                                        value: function(e) {
                                            var t = e.switch();
                                            if (t === i.AssetType.assetTypePoolShare()) return new this(e.liquidityPoolId().toString("hex"));
                                            throw new Error("Invalid asset type: ".concat(t.name));
                                        }
                                    }
                                ]), zr = r(8287).Buffer;
                                function Wr(e) {
                                    return Lt.isValidMed25519PublicKey(e) ? function(e) {
                                        var t = Lt.decodeMed25519PublicKey(e);
                                        return i.MuxedAccount.keyTypeMuxedEd25519(new i.MuxedAccountMed25519({
                                            id: i.Uint64.fromXDR(t.subarray(-8)),
                                            ed25519: t.subarray(0, -8)
                                        }));
                                    }(e) : i.MuxedAccount.keyTypeEd25519(Lt.decodeEd25519PublicKey(e));
                                }
                                function Xr(e) {
                                    return e.switch().value === i.CryptoKeyType.keyTypeMuxedEd25519().value ? function(e) {
                                        if (e.switch() === i.CryptoKeyType.keyTypeEd25519()) return Xr(e);
                                        var t = e.med25519();
                                        return Lt.encodeMed25519PublicKey(zr.concat([
                                            t.ed25519(),
                                            t.id().toXDR("raw")
                                        ]));
                                    }(e) : Lt.encodeEd25519PublicKey(e.ed25519());
                                }
                                function Kr(e, t) {
                                    if (!Lt.isValidEd25519PublicKey(e)) throw new Error("address should be a Stellar account ID (G...)");
                                    if ("string" != typeof t) throw new Error("id should be a string representing a number (uint64)");
                                    return i.MuxedAccount.keyTypeMuxedEd25519(new i.MuxedAccountMed25519({
                                        id: i.Uint64.fromString(t),
                                        ed25519: Lt.decodeEd25519PublicKey(e)
                                    }));
                                }
                                function Zr(e) {
                                    if (Lt.isValidEd25519PublicKey(e)) return e;
                                    if (!Lt.isValidMed25519PublicKey(e)) throw new TypeError("expected muxed account (M...), got ".concat(e));
                                    var t = Wr(e);
                                    return Lt.encodeEd25519PublicKey(t.med25519().ed25519());
                                }
                                function $r(e) {
                                    if ("string" != typeof e || 72 !== e.length) throw new Error("must provide a valid claimable balance id");
                                }
                                var Yr = r(8287).Buffer, Qr = r(8287).Buffer;
                                function Jr(e, t) {
                                    if (e >= 0 && e <= 255) return !0;
                                    throw new Error("".concat(t, " value must be between 0 and 255"));
                                }
                                var en = r(8287).Buffer;
                                function tn(e) {
                                    return tn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, tn(e);
                                }
                                var rn = r(8287).Buffer;
                                function nn(e) {
                                    return nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, nn(e);
                                }
                                function on(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, an(n.key), n);
                                    }
                                }
                                function an(e) {
                                    var t = function(e) {
                                        if ("object" != nn(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != nn(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == nn(t) ? t : t + "";
                                }
                                var sn = function() {
                                    function e(t) {
                                        if (function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, e), Lt.isValidEd25519PublicKey(t)) this._type = "account", this._key = Lt.decodeEd25519PublicKey(t);
                                        else if (Lt.isValidContract(t)) this._type = "contract", this._key = Lt.decodeContract(t);
                                        else if (Lt.isValidMed25519PublicKey(t)) this._type = "muxedAccount", this._key = Lt.decodeMed25519PublicKey(t);
                                        else if (Lt.isValidClaimableBalance(t)) this._type = "claimableBalance", this._key = Lt.decodeClaimableBalance(t);
                                        else {
                                            if (!Lt.isValidLiquidityPool(t)) throw new Error("Unsupported address type: ".concat(t));
                                            this._type = "liquidityPool", this._key = Lt.decodeLiquidityPool(t);
                                        }
                                    }
                                    return function(e, t, r) {
                                        return t && on(e.prototype, t), r && on(e, r), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(e, [
                                        {
                                            key: "toString",
                                            value: function() {
                                                switch(this._type){
                                                    case "account":
                                                        return Lt.encodeEd25519PublicKey(this._key);
                                                    case "contract":
                                                        return Lt.encodeContract(this._key);
                                                    case "claimableBalance":
                                                        return Lt.encodeClaimableBalance(this._key);
                                                    case "liquidityPool":
                                                        return Lt.encodeLiquidityPool(this._key);
                                                    case "muxedAccount":
                                                        return Lt.encodeMed25519PublicKey(this._key);
                                                    default:
                                                        throw new Error("Unsupported address type");
                                                }
                                            }
                                        },
                                        {
                                            key: "toScVal",
                                            value: function() {
                                                return i.ScVal.scvAddress(this.toScAddress());
                                            }
                                        },
                                        {
                                            key: "toScAddress",
                                            value: function() {
                                                switch(this._type){
                                                    case "account":
                                                        return i.ScAddress.scAddressTypeAccount(i.PublicKey.publicKeyTypeEd25519(this._key));
                                                    case "contract":
                                                        return i.ScAddress.scAddressTypeContract(this._key);
                                                    case "liquidityPool":
                                                        return i.ScAddress.scAddressTypeLiquidityPool(this._key);
                                                    case "claimableBalance":
                                                        return i.ScAddress.scAddressTypeClaimableBalance(new i.ClaimableBalanceId("claimableBalanceIdTypeV".concat(this._key.at(0)), this._key.subarray(1)));
                                                    case "muxedAccount":
                                                        return i.ScAddress.scAddressTypeMuxedAccount(new i.MuxedEd25519Account({
                                                            ed25519: this._key.subarray(0, 32),
                                                            id: i.Uint64.fromXDR(this._key.subarray(32, 40), "raw")
                                                        }));
                                                    default:
                                                        throw new Error("Unsupported address type: ".concat(this._type));
                                                }
                                            }
                                        },
                                        {
                                            key: "toBuffer",
                                            value: function() {
                                                return this._key;
                                            }
                                        }
                                    ], [
                                        {
                                            key: "fromString",
                                            value: function(t) {
                                                return new e(t);
                                            }
                                        },
                                        {
                                            key: "account",
                                            value: function(t) {
                                                return new e(Lt.encodeEd25519PublicKey(t));
                                            }
                                        },
                                        {
                                            key: "contract",
                                            value: function(t) {
                                                return new e(Lt.encodeContract(t));
                                            }
                                        },
                                        {
                                            key: "claimableBalance",
                                            value: function(t) {
                                                return new e(Lt.encodeClaimableBalance(t));
                                            }
                                        },
                                        {
                                            key: "liquidityPool",
                                            value: function(t) {
                                                return new e(Lt.encodeLiquidityPool(t));
                                            }
                                        },
                                        {
                                            key: "muxedAccount",
                                            value: function(t) {
                                                return new e(Lt.encodeMed25519PublicKey(t));
                                            }
                                        },
                                        {
                                            key: "fromScVal",
                                            value: function(t) {
                                                return e.fromScAddress(t.address());
                                            }
                                        },
                                        {
                                            key: "fromScAddress",
                                            value: function(t) {
                                                switch(t.switch().value){
                                                    case i.ScAddressType.scAddressTypeAccount().value:
                                                        return e.account(t.accountId().ed25519());
                                                    case i.ScAddressType.scAddressTypeContract().value:
                                                        return e.contract(t.contractId());
                                                    case i.ScAddressType.scAddressTypeMuxedAccount().value:
                                                        var r = rn.concat([
                                                            t.muxedAccount().ed25519(),
                                                            t.muxedAccount().id().toXDR("raw")
                                                        ]);
                                                        return e.muxedAccount(r);
                                                    case i.ScAddressType.scAddressTypeClaimableBalance().value:
                                                        var n = t.claimableBalanceId();
                                                        return e.claimableBalance(rn.concat([
                                                            rn.from([
                                                                n.switch().value
                                                            ]),
                                                            n.v0()
                                                        ]));
                                                    case i.ScAddressType.scAddressTypeLiquidityPool().value:
                                                        return e.liquidityPool(t.liquidityPoolId());
                                                    default:
                                                        throw new Error("Unsupported address type: ".concat(t.switch().name));
                                                }
                                            }
                                        }
                                    ]);
                                }(), un = r(8287).Buffer;
                                function cn(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                                    return n;
                                }
                                function ln(e) {
                                    return ln = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, ln(e);
                                }
                                function fn(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pn(n.key), n);
                                    }
                                }
                                function pn(e) {
                                    var t = function(e) {
                                        if ("object" != ln(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != ln(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == ln(t) ? t : t + "";
                                }
                                var dn = 1e7, hn = 1, yn = 2, mn = 4, gn = 8, vn = function(e, t, r) {
                                    return r && fn(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }, 0, [
                                    {
                                        key: "setSourceAccount",
                                        value: function(e, t) {
                                            if (t.source) try {
                                                e.sourceAccount = Wr(t.source);
                                            } catch (e) {
                                                throw new Error("Source address is invalid");
                                            }
                                        }
                                    },
                                    {
                                        key: "fromXDRObject",
                                        value: function(e) {
                                            var t = {};
                                            e.sourceAccount() && (t.source = Xr(e.sourceAccount()));
                                            var r = e.body().value(), n = e.body().switch().name;
                                            switch(n){
                                                case "createAccount":
                                                    t.type = "createAccount", t.destination = bn(r.destination()), t.startingBalance = this._fromXDRAmount(r.startingBalance());
                                                    break;
                                                case "payment":
                                                    t.type = "payment", t.destination = Xr(r.destination()), t.asset = Yt.fromOperation(r.asset()), t.amount = this._fromXDRAmount(r.amount());
                                                    break;
                                                case "pathPaymentStrictReceive":
                                                    t.type = "pathPaymentStrictReceive", t.sendAsset = Yt.fromOperation(r.sendAsset()), t.sendMax = this._fromXDRAmount(r.sendMax()), t.destination = Xr(r.destination()), t.destAsset = Yt.fromOperation(r.destAsset()), t.destAmount = this._fromXDRAmount(r.destAmount()), t.path = [];
                                                    var o = r.path();
                                                    Object.keys(o).forEach(function(e) {
                                                        t.path.push(Yt.fromOperation(o[e]));
                                                    });
                                                    break;
                                                case "pathPaymentStrictSend":
                                                    t.type = "pathPaymentStrictSend", t.sendAsset = Yt.fromOperation(r.sendAsset()), t.sendAmount = this._fromXDRAmount(r.sendAmount()), t.destination = Xr(r.destination()), t.destAsset = Yt.fromOperation(r.destAsset()), t.destMin = this._fromXDRAmount(r.destMin()), t.path = [];
                                                    var a = r.path();
                                                    Object.keys(a).forEach(function(e) {
                                                        t.path.push(Yt.fromOperation(a[e]));
                                                    });
                                                    break;
                                                case "changeTrust":
                                                    t.type = "changeTrust", r.line().switch() === i.AssetType.assetTypePoolShare() ? t.line = Nr.fromOperation(r.line()) : t.line = Yt.fromOperation(r.line()), t.limit = this._fromXDRAmount(r.limit());
                                                    break;
                                                case "allowTrust":
                                                    t.type = "allowTrust", t.trustor = bn(r.trustor()), t.assetCode = r.asset().value().toString(), t.assetCode = kt(t.assetCode, "\0"), t.authorize = r.authorize();
                                                    break;
                                                case "setOptions":
                                                    if (t.type = "setOptions", r.inflationDest() && (t.inflationDest = bn(r.inflationDest())), t.clearFlags = r.clearFlags(), t.setFlags = r.setFlags(), t.masterWeight = r.masterWeight(), t.lowThreshold = r.lowThreshold(), t.medThreshold = r.medThreshold(), t.highThreshold = r.highThreshold(), t.homeDomain = void 0 !== r.homeDomain() ? r.homeDomain().toString("ascii") : void 0, r.signer()) {
                                                        var s = {}, u = r.signer().key().arm();
                                                        if ("ed25519" === u) s.ed25519PublicKey = bn(r.signer().key());
                                                        else if ("preAuthTx" === u) s.preAuthTx = r.signer().key().preAuthTx();
                                                        else if ("hashX" === u) s.sha256Hash = r.signer().key().hashX();
                                                        else if ("ed25519SignedPayload" === u) {
                                                            var c = r.signer().key().ed25519SignedPayload();
                                                            s.ed25519SignedPayload = Lt.encodeSignedPayload(c.toXDR());
                                                        }
                                                        s.weight = r.signer().weight(), t.signer = s;
                                                    }
                                                    break;
                                                case "manageOffer":
                                                case "manageSellOffer":
                                                    t.type = "manageSellOffer", t.selling = Yt.fromOperation(r.selling()), t.buying = Yt.fromOperation(r.buying()), t.amount = this._fromXDRAmount(r.amount()), t.price = this._fromXDRPrice(r.price()), t.offerId = r.offerId().toString();
                                                    break;
                                                case "manageBuyOffer":
                                                    t.type = "manageBuyOffer", t.selling = Yt.fromOperation(r.selling()), t.buying = Yt.fromOperation(r.buying()), t.buyAmount = this._fromXDRAmount(r.buyAmount()), t.price = this._fromXDRPrice(r.price()), t.offerId = r.offerId().toString();
                                                    break;
                                                case "createPassiveOffer":
                                                case "createPassiveSellOffer":
                                                    t.type = "createPassiveSellOffer", t.selling = Yt.fromOperation(r.selling()), t.buying = Yt.fromOperation(r.buying()), t.amount = this._fromXDRAmount(r.amount()), t.price = this._fromXDRPrice(r.price());
                                                    break;
                                                case "accountMerge":
                                                    t.type = "accountMerge", t.destination = Xr(r);
                                                    break;
                                                case "manageData":
                                                    t.type = "manageData", t.name = r.dataName().toString("ascii"), t.value = r.dataValue();
                                                    break;
                                                case "inflation":
                                                    t.type = "inflation";
                                                    break;
                                                case "bumpSequence":
                                                    t.type = "bumpSequence", t.bumpTo = r.bumpTo().toString();
                                                    break;
                                                case "createClaimableBalance":
                                                    t.type = "createClaimableBalance", t.asset = Yt.fromOperation(r.asset()), t.amount = this._fromXDRAmount(r.amount()), t.claimants = [], r.claimants().forEach(function(e) {
                                                        t.claimants.push(Mr.fromXDR(e));
                                                    });
                                                    break;
                                                case "claimClaimableBalance":
                                                    t.type = "claimClaimableBalance", t.balanceId = r.toXDR("hex");
                                                    break;
                                                case "beginSponsoringFutureReserves":
                                                    t.type = "beginSponsoringFutureReserves", t.sponsoredId = bn(r.sponsoredId());
                                                    break;
                                                case "endSponsoringFutureReserves":
                                                    t.type = "endSponsoringFutureReserves";
                                                    break;
                                                case "revokeSponsorship":
                                                    !function(e, t) {
                                                        switch(e.switch().name){
                                                            case "revokeSponsorshipLedgerEntry":
                                                                var r = e.ledgerKey();
                                                                switch(r.switch().name){
                                                                    case i.LedgerEntryType.account().name:
                                                                        t.type = "revokeAccountSponsorship", t.account = bn(r.account().accountId());
                                                                        break;
                                                                    case i.LedgerEntryType.trustline().name:
                                                                        t.type = "revokeTrustlineSponsorship", t.account = bn(r.trustLine().accountId());
                                                                        var n = r.trustLine().asset();
                                                                        n.switch() === i.AssetType.assetTypePoolShare() ? t.asset = Hr.fromOperation(n) : t.asset = Yt.fromOperation(n);
                                                                        break;
                                                                    case i.LedgerEntryType.offer().name:
                                                                        t.type = "revokeOfferSponsorship", t.seller = bn(r.offer().sellerId()), t.offerId = r.offer().offerId().toString();
                                                                        break;
                                                                    case i.LedgerEntryType.data().name:
                                                                        t.type = "revokeDataSponsorship", t.account = bn(r.data().accountId()), t.name = r.data().dataName().toString("ascii");
                                                                        break;
                                                                    case i.LedgerEntryType.claimableBalance().name:
                                                                        t.type = "revokeClaimableBalanceSponsorship", t.balanceId = r.claimableBalance().balanceId().toXDR("hex");
                                                                        break;
                                                                    case i.LedgerEntryType.liquidityPool().name:
                                                                        t.type = "revokeLiquidityPoolSponsorship", t.liquidityPoolId = r.liquidityPool().liquidityPoolId().toString("hex");
                                                                        break;
                                                                    default:
                                                                        throw new Error("Unknown ledgerKey: ".concat(e.switch().name));
                                                                }
                                                                break;
                                                            case "revokeSponsorshipSigner":
                                                                t.type = "revokeSignerSponsorship", t.account = bn(e.signer().accountId()), t.signer = function(e) {
                                                                    var t = {};
                                                                    switch(e.switch().name){
                                                                        case i.SignerKeyType.signerKeyTypeEd25519().name:
                                                                            t.ed25519PublicKey = Lt.encodeEd25519PublicKey(e.ed25519());
                                                                            break;
                                                                        case i.SignerKeyType.signerKeyTypePreAuthTx().name:
                                                                            t.preAuthTx = e.preAuthTx().toString("hex");
                                                                            break;
                                                                        case i.SignerKeyType.signerKeyTypeHashX().name:
                                                                            t.sha256Hash = e.hashX().toString("hex");
                                                                            break;
                                                                        default:
                                                                            throw new Error("Unknown signerKey: ".concat(e.switch().name));
                                                                    }
                                                                    return t;
                                                                }(e.signer().signerKey());
                                                                break;
                                                            default:
                                                                throw new Error("Unknown revokeSponsorship: ".concat(e.switch().name));
                                                        }
                                                    }(r, t);
                                                    break;
                                                case "clawback":
                                                    t.type = "clawback", t.amount = this._fromXDRAmount(r.amount()), t.from = Xr(r.from()), t.asset = Yt.fromOperation(r.asset());
                                                    break;
                                                case "clawbackClaimableBalance":
                                                    t.type = "clawbackClaimableBalance", t.balanceId = r.toXDR("hex");
                                                    break;
                                                case "setTrustLineFlags":
                                                    t.type = "setTrustLineFlags", t.asset = Yt.fromOperation(r.asset()), t.trustor = bn(r.trustor());
                                                    var l = r.clearFlags(), f = r.setFlags(), p = {
                                                        authorized: i.TrustLineFlags.authorizedFlag(),
                                                        authorizedToMaintainLiabilities: i.TrustLineFlags.authorizedToMaintainLiabilitiesFlag(),
                                                        clawbackEnabled: i.TrustLineFlags.trustlineClawbackEnabledFlag()
                                                    };
                                                    t.flags = {}, Object.keys(p).forEach(function(e) {
                                                        var r;
                                                        t.flags[e] = (r = p[e].value, !!(f & r) || !(l & r) && void 0);
                                                    });
                                                    break;
                                                case "liquidityPoolDeposit":
                                                    t.type = "liquidityPoolDeposit", t.liquidityPoolId = r.liquidityPoolId().toString("hex"), t.maxAmountA = this._fromXDRAmount(r.maxAmountA()), t.maxAmountB = this._fromXDRAmount(r.maxAmountB()), t.minPrice = this._fromXDRPrice(r.minPrice()), t.maxPrice = this._fromXDRPrice(r.maxPrice());
                                                    break;
                                                case "liquidityPoolWithdraw":
                                                    t.type = "liquidityPoolWithdraw", t.liquidityPoolId = r.liquidityPoolId().toString("hex"), t.amount = this._fromXDRAmount(r.amount()), t.minAmountA = this._fromXDRAmount(r.minAmountA()), t.minAmountB = this._fromXDRAmount(r.minAmountB());
                                                    break;
                                                case "invokeHostFunction":
                                                    var d;
                                                    t.type = "invokeHostFunction", t.func = r.hostFunction(), t.auth = null !== (d = r.auth()) && void 0 !== d ? d : [];
                                                    break;
                                                case "extendFootprintTtl":
                                                    t.type = "extendFootprintTtl", t.extendTo = r.extendTo();
                                                    break;
                                                case "restoreFootprint":
                                                    t.type = "restoreFootprint";
                                                    break;
                                                default:
                                                    throw new Error("Unknown operation: ".concat(n));
                                            }
                                            return t;
                                        }
                                    },
                                    {
                                        key: "isValidAmount",
                                        value: function(e) {
                                            var t, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                            if ("string" != typeof e) return !1;
                                            try {
                                                t = new _r(e);
                                            } catch (e) {
                                                return !1;
                                            }
                                            return !(!r && t.isZero() || t.isNegative() || t.times(dn).gt(new _r("9223372036854775807").toString()) || t.decimalPlaces() > 7 || t.isNaN() || !t.isFinite());
                                        }
                                    },
                                    {
                                        key: "constructAmountRequirementsError",
                                        value: function(e) {
                                            return "".concat(e, " argument must be of type String, represent a positive number and have at most 7 digits after the decimal");
                                        }
                                    },
                                    {
                                        key: "_checkUnsignedIntValue",
                                        value: function(e, t) {
                                            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                                            if (void 0 !== t) switch("string" == typeof t && (t = parseFloat(t)), !0){
                                                case "number" != typeof t || !Number.isFinite(t) || t % 1 != 0:
                                                    throw new Error("".concat(e, " value is invalid"));
                                                case t < 0:
                                                    throw new Error("".concat(e, " value must be unsigned"));
                                                case !r || r && r(t, e):
                                                    return t;
                                                default:
                                                    throw new Error("".concat(e, " value is invalid"));
                                            }
                                        }
                                    },
                                    {
                                        key: "_toXDRAmount",
                                        value: function(e) {
                                            var t = new _r(e).times(dn);
                                            return n.Hyper.fromString(t.toString());
                                        }
                                    },
                                    {
                                        key: "_fromXDRAmount",
                                        value: function(e) {
                                            return new _r(e).div(dn).toFixed(7);
                                        }
                                    },
                                    {
                                        key: "_fromXDRPrice",
                                        value: function(e) {
                                            return new _r(e.n()).div(new _r(e.d())).toString();
                                        }
                                    },
                                    {
                                        key: "_toXDRPrice",
                                        value: function(e) {
                                            var t;
                                            if (void 0 !== e.n && void 0 !== e.d) t = new i.Price(e);
                                            else {
                                                var r = function(e) {
                                                    for(var t, r, n = new _r(e), o = [
                                                        [
                                                            new _r(0),
                                                            new _r(1)
                                                        ],
                                                        [
                                                            new _r(1),
                                                            new _r(0)
                                                        ]
                                                    ], i = 2; !n.gt(Pr);){
                                                        t = n.integerValue(_r.ROUND_FLOOR), r = n.minus(t);
                                                        var a = t.times(o[i - 1][0]).plus(o[i - 2][0]), s = t.times(o[i - 1][1]).plus(o[i - 2][1]);
                                                        if (a.gt(Pr) || s.gt(Pr)) break;
                                                        if (o.push([
                                                            a,
                                                            s
                                                        ]), r.eq(0)) break;
                                                        n = new _r(1).div(r), i += 1;
                                                    }
                                                    var u = function(e, t) {
                                                        return function(e) {
                                                            if (Array.isArray(e)) return e;
                                                        }(e) || function(e, t) {
                                                            var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                                            if (null != r) {
                                                                var n, o, i, a, s = [], u = !0, c = !1;
                                                                try {
                                                                    if (i = (r = r.call(e)).next, 0 === t) {
                                                                        if (Object(r) !== r) return;
                                                                        u = !1;
                                                                    } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                                                                } catch (e) {
                                                                    c = !0, o = e;
                                                                } finally{
                                                                    try {
                                                                        if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                                                    } finally{
                                                                        if (c) throw o;
                                                                    }
                                                                }
                                                                return s;
                                                            }
                                                        }(e, t) || function(e, t) {
                                                            if (e) {
                                                                if ("string" == typeof e) return xr(e, t);
                                                                var r = ({}).toString.call(e).slice(8, -1);
                                                                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? xr(e, t) : void 0;
                                                            }
                                                        }(e, t) || function() {
                                                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                        }();
                                                    }(o[o.length - 1], 2), c = u[0], l = u[1];
                                                    if (c.isZero() || l.isZero()) throw new Error("Couldn't find approximation");
                                                    return [
                                                        c.toNumber(),
                                                        l.toNumber()
                                                    ];
                                                }(e);
                                                t = new i.Price({
                                                    n: parseInt(r[0], 10),
                                                    d: parseInt(r[1], 10)
                                                });
                                            }
                                            if (t.n() < 0 || t.d() < 0) throw new Error("price must be positive");
                                            return t;
                                        }
                                    }
                                ]);
                                function bn(e) {
                                    return Lt.encodeEd25519PublicKey(e.ed25519());
                                }
                                vn.accountMerge = function(e) {
                                    var t = {};
                                    try {
                                        t.body = i.OperationBody.accountMerge(Wr(e.destination));
                                    } catch (e) {
                                        throw new Error("destination is invalid");
                                    }
                                    return this.setSourceAccount(t, e), new i.Operation(t);
                                }, vn.allowTrust = function(e) {
                                    if (!Lt.isValidEd25519PublicKey(e.trustor)) throw new Error("trustor is invalid");
                                    var t = {};
                                    if (t.trustor = Wt.fromPublicKey(e.trustor).xdrAccountId(), e.assetCode.length <= 4) {
                                        var r = e.assetCode.padEnd(4, "\0");
                                        t.asset = i.AssetCode.assetTypeCreditAlphanum4(r);
                                    } else {
                                        if (!(e.assetCode.length <= 12)) throw new Error("Asset code must be 12 characters at max.");
                                        var n = e.assetCode.padEnd(12, "\0");
                                        t.asset = i.AssetCode.assetTypeCreditAlphanum12(n);
                                    }
                                    "boolean" == typeof e.authorize ? e.authorize ? t.authorize = i.TrustLineFlags.authorizedFlag().value : t.authorize = 0 : t.authorize = e.authorize;
                                    var o = new i.AllowTrustOp(t), a = {};
                                    return a.body = i.OperationBody.allowTrust(o), this.setSourceAccount(a, e), new i.Operation(a);
                                }, vn.bumpSequence = function(e) {
                                    var t = {};
                                    if ("string" != typeof e.bumpTo) throw new Error("bumpTo must be a string");
                                    try {
                                        new _r(e.bumpTo);
                                    } catch (e) {
                                        throw new Error("bumpTo must be a stringified number");
                                    }
                                    t.bumpTo = n.Hyper.fromString(e.bumpTo);
                                    var r = new i.BumpSequenceOp(t), o = {};
                                    return o.body = i.OperationBody.bumpSequence(r), this.setSourceAccount(o, e), new i.Operation(o);
                                }, vn.changeTrust = function(e) {
                                    var t = {};
                                    if (e.asset instanceof Yt) t.line = e.asset.toChangeTrustXDRObject();
                                    else {
                                        if (!(e.asset instanceof Nr)) throw new TypeError("asset must be Asset or LiquidityPoolAsset");
                                        t.line = e.asset.toXDRObject();
                                    }
                                    if (void 0 !== e.limit && !this.isValidAmount(e.limit, !0)) throw new TypeError(this.constructAmountRequirementsError("limit"));
                                    e.limit ? t.limit = this._toXDRAmount(e.limit) : t.limit = n.Hyper.fromString(new _r("9223372036854775807").toString()), e.source && (t.source = e.source.masterKeypair);
                                    var r = new i.ChangeTrustOp(t), o = {};
                                    return o.body = i.OperationBody.changeTrust(r), this.setSourceAccount(o, e), new i.Operation(o);
                                }, vn.createAccount = function(e) {
                                    if (!Lt.isValidEd25519PublicKey(e.destination)) throw new Error("destination is invalid");
                                    if (!this.isValidAmount(e.startingBalance, !0)) throw new TypeError(this.constructAmountRequirementsError("startingBalance"));
                                    var t = {};
                                    t.destination = Wt.fromPublicKey(e.destination).xdrAccountId(), t.startingBalance = this._toXDRAmount(e.startingBalance);
                                    var r = new i.CreateAccountOp(t), n = {};
                                    return n.body = i.OperationBody.createAccount(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.createClaimableBalance = function(e) {
                                    if (!(e.asset instanceof Yt)) throw new Error("must provide an asset for create claimable balance operation");
                                    if (!this.isValidAmount(e.amount)) throw new TypeError(this.constructAmountRequirementsError("amount"));
                                    if (!Array.isArray(e.claimants) || 0 === e.claimants.length) throw new Error("must provide at least one claimant");
                                    var t = {};
                                    t.asset = e.asset.toXDRObject(), t.amount = this._toXDRAmount(e.amount), t.claimants = Object.values(e.claimants).map(function(e) {
                                        return e.toXDRObject();
                                    });
                                    var r = new i.CreateClaimableBalanceOp(t), n = {};
                                    return n.body = i.OperationBody.createClaimableBalance(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.claimClaimableBalance = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    $r(e.balanceId);
                                    var t = {};
                                    t.balanceId = i.ClaimableBalanceId.fromXDR(e.balanceId, "hex");
                                    var r = new i.ClaimClaimableBalanceOp(t), n = {};
                                    return n.body = i.OperationBody.claimClaimableBalance(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.clawbackClaimableBalance = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    $r(e.balanceId);
                                    var t = {
                                        balanceId: i.ClaimableBalanceId.fromXDR(e.balanceId, "hex")
                                    }, r = {
                                        body: i.OperationBody.clawbackClaimableBalance(new i.ClawbackClaimableBalanceOp(t))
                                    };
                                    return this.setSourceAccount(r, e), new i.Operation(r);
                                }, vn.createPassiveSellOffer = function(e) {
                                    var t = {};
                                    if (t.selling = e.selling.toXDRObject(), t.buying = e.buying.toXDRObject(), !this.isValidAmount(e.amount)) throw new TypeError(this.constructAmountRequirementsError("amount"));
                                    if (t.amount = this._toXDRAmount(e.amount), void 0 === e.price) throw new TypeError("price argument is required");
                                    t.price = this._toXDRPrice(e.price);
                                    var r = new i.CreatePassiveSellOfferOp(t), n = {};
                                    return n.body = i.OperationBody.createPassiveSellOffer(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.inflation = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = {};
                                    return t.body = i.OperationBody.inflation(), this.setSourceAccount(t, e), new i.Operation(t);
                                }, vn.manageData = function(e) {
                                    var t = {};
                                    if (!("string" == typeof e.name && e.name.length <= 64)) throw new Error("name must be a string, up to 64 characters");
                                    if (t.dataName = e.name, "string" != typeof e.value && !Yr.isBuffer(e.value) && null !== e.value) throw new Error("value must be a string, Buffer or null");
                                    if ("string" == typeof e.value ? t.dataValue = Yr.from(e.value) : t.dataValue = e.value, null !== t.dataValue && t.dataValue.length > 64) throw new Error("value cannot be longer that 64 bytes");
                                    var r = new i.ManageDataOp(t), n = {};
                                    return n.body = i.OperationBody.manageData(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.manageSellOffer = function(e) {
                                    var t = {};
                                    if (t.selling = e.selling.toXDRObject(), t.buying = e.buying.toXDRObject(), !this.isValidAmount(e.amount, !0)) throw new TypeError(this.constructAmountRequirementsError("amount"));
                                    if (t.amount = this._toXDRAmount(e.amount), void 0 === e.price) throw new TypeError("price argument is required");
                                    t.price = this._toXDRPrice(e.price), void 0 !== e.offerId ? e.offerId = e.offerId.toString() : e.offerId = "0", t.offerId = n.Hyper.fromString(e.offerId);
                                    var r = new i.ManageSellOfferOp(t), o = {};
                                    return o.body = i.OperationBody.manageSellOffer(r), this.setSourceAccount(o, e), new i.Operation(o);
                                }, vn.manageBuyOffer = function(e) {
                                    var t = {};
                                    if (t.selling = e.selling.toXDRObject(), t.buying = e.buying.toXDRObject(), !this.isValidAmount(e.buyAmount, !0)) throw new TypeError(this.constructAmountRequirementsError("buyAmount"));
                                    if (t.buyAmount = this._toXDRAmount(e.buyAmount), void 0 === e.price) throw new TypeError("price argument is required");
                                    t.price = this._toXDRPrice(e.price), void 0 !== e.offerId ? e.offerId = e.offerId.toString() : e.offerId = "0", t.offerId = n.Hyper.fromString(e.offerId);
                                    var r = new i.ManageBuyOfferOp(t), o = {};
                                    return o.body = i.OperationBody.manageBuyOffer(r), this.setSourceAccount(o, e), new i.Operation(o);
                                }, vn.pathPaymentStrictReceive = function(e) {
                                    switch(!0){
                                        case !e.sendAsset:
                                            throw new Error("Must specify a send asset");
                                        case !this.isValidAmount(e.sendMax):
                                            throw new TypeError(this.constructAmountRequirementsError("sendMax"));
                                        case !e.destAsset:
                                            throw new Error("Must provide a destAsset for a payment operation");
                                        case !this.isValidAmount(e.destAmount):
                                            throw new TypeError(this.constructAmountRequirementsError("destAmount"));
                                    }
                                    var t = {};
                                    t.sendAsset = e.sendAsset.toXDRObject(), t.sendMax = this._toXDRAmount(e.sendMax);
                                    try {
                                        t.destination = Wr(e.destination);
                                    } catch (e) {
                                        throw new Error("destination is invalid");
                                    }
                                    t.destAsset = e.destAsset.toXDRObject(), t.destAmount = this._toXDRAmount(e.destAmount);
                                    var r = e.path ? e.path : [];
                                    t.path = r.map(function(e) {
                                        return e.toXDRObject();
                                    });
                                    var n = new i.PathPaymentStrictReceiveOp(t), o = {};
                                    return o.body = i.OperationBody.pathPaymentStrictReceive(n), this.setSourceAccount(o, e), new i.Operation(o);
                                }, vn.pathPaymentStrictSend = function(e) {
                                    switch(!0){
                                        case !e.sendAsset:
                                            throw new Error("Must specify a send asset");
                                        case !this.isValidAmount(e.sendAmount):
                                            throw new TypeError(this.constructAmountRequirementsError("sendAmount"));
                                        case !e.destAsset:
                                            throw new Error("Must provide a destAsset for a payment operation");
                                        case !this.isValidAmount(e.destMin):
                                            throw new TypeError(this.constructAmountRequirementsError("destMin"));
                                    }
                                    var t = {};
                                    t.sendAsset = e.sendAsset.toXDRObject(), t.sendAmount = this._toXDRAmount(e.sendAmount);
                                    try {
                                        t.destination = Wr(e.destination);
                                    } catch (e) {
                                        throw new Error("destination is invalid");
                                    }
                                    t.destAsset = e.destAsset.toXDRObject(), t.destMin = this._toXDRAmount(e.destMin);
                                    var r = e.path ? e.path : [];
                                    t.path = r.map(function(e) {
                                        return e.toXDRObject();
                                    });
                                    var n = new i.PathPaymentStrictSendOp(t), o = {};
                                    return o.body = i.OperationBody.pathPaymentStrictSend(n), this.setSourceAccount(o, e), new i.Operation(o);
                                }, vn.payment = function(e) {
                                    if (!e.asset) throw new Error("Must provide an asset for a payment operation");
                                    if (!this.isValidAmount(e.amount)) throw new TypeError(this.constructAmountRequirementsError("amount"));
                                    var t = {};
                                    try {
                                        t.destination = Wr(e.destination);
                                    } catch (e) {
                                        throw new Error("destination is invalid");
                                    }
                                    t.asset = e.asset.toXDRObject(), t.amount = this._toXDRAmount(e.amount);
                                    var r = new i.PaymentOp(t), n = {};
                                    return n.body = i.OperationBody.payment(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.setOptions = function(e) {
                                    var t = {};
                                    if (e.inflationDest) {
                                        if (!Lt.isValidEd25519PublicKey(e.inflationDest)) throw new Error("inflationDest is invalid");
                                        t.inflationDest = Wt.fromPublicKey(e.inflationDest).xdrAccountId();
                                    }
                                    if (t.clearFlags = this._checkUnsignedIntValue("clearFlags", e.clearFlags), t.setFlags = this._checkUnsignedIntValue("setFlags", e.setFlags), t.masterWeight = this._checkUnsignedIntValue("masterWeight", e.masterWeight, Jr), t.lowThreshold = this._checkUnsignedIntValue("lowThreshold", e.lowThreshold, Jr), t.medThreshold = this._checkUnsignedIntValue("medThreshold", e.medThreshold, Jr), t.highThreshold = this._checkUnsignedIntValue("highThreshold", e.highThreshold, Jr), void 0 !== e.homeDomain && "string" != typeof e.homeDomain) throw new TypeError("homeDomain argument must be of type String");
                                    if (t.homeDomain = e.homeDomain, e.signer) {
                                        var r, n = this._checkUnsignedIntValue("signer.weight", e.signer.weight, Jr), o = 0;
                                        if (e.signer.ed25519PublicKey) {
                                            if (!Lt.isValidEd25519PublicKey(e.signer.ed25519PublicKey)) throw new Error("signer.ed25519PublicKey is invalid.");
                                            var a = Lt.decodeEd25519PublicKey(e.signer.ed25519PublicKey);
                                            r = new i.SignerKey.signerKeyTypeEd25519(a), o += 1;
                                        }
                                        if (e.signer.preAuthTx) {
                                            if ("string" == typeof e.signer.preAuthTx && (e.signer.preAuthTx = Qr.from(e.signer.preAuthTx, "hex")), !Qr.isBuffer(e.signer.preAuthTx) || 32 !== e.signer.preAuthTx.length) throw new Error("signer.preAuthTx must be 32 bytes Buffer.");
                                            r = new i.SignerKey.signerKeyTypePreAuthTx(e.signer.preAuthTx), o += 1;
                                        }
                                        if (e.signer.sha256Hash) {
                                            if ("string" == typeof e.signer.sha256Hash && (e.signer.sha256Hash = Qr.from(e.signer.sha256Hash, "hex")), !Qr.isBuffer(e.signer.sha256Hash) || 32 !== e.signer.sha256Hash.length) throw new Error("signer.sha256Hash must be 32 bytes Buffer.");
                                            r = new i.SignerKey.signerKeyTypeHashX(e.signer.sha256Hash), o += 1;
                                        }
                                        if (e.signer.ed25519SignedPayload) {
                                            if (!Lt.isValidSignedPayload(e.signer.ed25519SignedPayload)) throw new Error("signer.ed25519SignedPayload is invalid.");
                                            var s = Lt.decodeSignedPayload(e.signer.ed25519SignedPayload), u = i.SignerKeyEd25519SignedPayload.fromXDR(s);
                                            r = i.SignerKey.signerKeyTypeEd25519SignedPayload(u), o += 1;
                                        }
                                        if (1 !== o) throw new Error("Signer object must contain exactly one of signer.ed25519PublicKey, signer.sha256Hash, signer.preAuthTx.");
                                        t.signer = new i.Signer({
                                            key: r,
                                            weight: n
                                        });
                                    }
                                    var c = new i.SetOptionsOp(t), l = {};
                                    return l.body = i.OperationBody.setOptions(c), this.setSourceAccount(l, e), new i.Operation(l);
                                }, vn.beginSponsoringFutureReserves = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (!Lt.isValidEd25519PublicKey(e.sponsoredId)) throw new Error("sponsoredId is invalid");
                                    var t = new i.BeginSponsoringFutureReservesOp({
                                        sponsoredId: Wt.fromPublicKey(e.sponsoredId).xdrAccountId()
                                    }), r = {};
                                    return r.body = i.OperationBody.beginSponsoringFutureReserves(t), this.setSourceAccount(r, e), new i.Operation(r);
                                }, vn.endSponsoringFutureReserves = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = {};
                                    return t.body = i.OperationBody.endSponsoringFutureReserves(), this.setSourceAccount(t, e), new i.Operation(t);
                                }, vn.revokeAccountSponsorship = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (!Lt.isValidEd25519PublicKey(e.account)) throw new Error("account is invalid");
                                    var t = i.LedgerKey.account(new i.LedgerKeyAccount({
                                        accountId: Wt.fromPublicKey(e.account).xdrAccountId()
                                    })), r = i.RevokeSponsorshipOp.revokeSponsorshipLedgerEntry(t), n = {};
                                    return n.body = i.OperationBody.revokeSponsorship(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.revokeTrustlineSponsorship = function() {
                                    var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (!Lt.isValidEd25519PublicKey(t.account)) throw new Error("account is invalid");
                                    if (t.asset instanceof Yt) e = t.asset.toTrustLineXDRObject();
                                    else {
                                        if (!(t.asset instanceof Hr)) throw new TypeError("asset must be an Asset or LiquidityPoolId");
                                        e = t.asset.toXDRObject();
                                    }
                                    var r = i.LedgerKey.trustline(new i.LedgerKeyTrustLine({
                                        accountId: Wt.fromPublicKey(t.account).xdrAccountId(),
                                        asset: e
                                    })), n = i.RevokeSponsorshipOp.revokeSponsorshipLedgerEntry(r), o = {};
                                    return o.body = i.OperationBody.revokeSponsorship(n), this.setSourceAccount(o, t), new i.Operation(o);
                                }, vn.revokeOfferSponsorship = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (!Lt.isValidEd25519PublicKey(e.seller)) throw new Error("seller is invalid");
                                    if ("string" != typeof e.offerId) throw new Error("offerId is invalid");
                                    var t = i.LedgerKey.offer(new i.LedgerKeyOffer({
                                        sellerId: Wt.fromPublicKey(e.seller).xdrAccountId(),
                                        offerId: i.Int64.fromString(e.offerId)
                                    })), r = i.RevokeSponsorshipOp.revokeSponsorshipLedgerEntry(t), n = {};
                                    return n.body = i.OperationBody.revokeSponsorship(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.revokeDataSponsorship = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (!Lt.isValidEd25519PublicKey(e.account)) throw new Error("account is invalid");
                                    if ("string" != typeof e.name || e.name.length > 64) throw new Error("name must be a string, up to 64 characters");
                                    var t = i.LedgerKey.data(new i.LedgerKeyData({
                                        accountId: Wt.fromPublicKey(e.account).xdrAccountId(),
                                        dataName: e.name
                                    })), r = i.RevokeSponsorshipOp.revokeSponsorshipLedgerEntry(t), n = {};
                                    return n.body = i.OperationBody.revokeSponsorship(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.revokeClaimableBalanceSponsorship = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if ("string" != typeof e.balanceId) throw new Error("balanceId is invalid");
                                    var t = i.LedgerKey.claimableBalance(new i.LedgerKeyClaimableBalance({
                                        balanceId: i.ClaimableBalanceId.fromXDR(e.balanceId, "hex")
                                    })), r = i.RevokeSponsorshipOp.revokeSponsorshipLedgerEntry(t), n = {};
                                    return n.body = i.OperationBody.revokeSponsorship(r), this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.revokeLiquidityPoolSponsorship = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if ("string" != typeof e.liquidityPoolId) throw new Error("liquidityPoolId is invalid");
                                    var t = i.LedgerKey.liquidityPool(new i.LedgerKeyLiquidityPool({
                                        liquidityPoolId: i.PoolId.fromXDR(e.liquidityPoolId, "hex")
                                    })), r = i.RevokeSponsorshipOp.revokeSponsorshipLedgerEntry(t), n = {
                                        body: i.OperationBody.revokeSponsorship(r)
                                    };
                                    return this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.revokeSignerSponsorship = function() {
                                    var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (!Lt.isValidEd25519PublicKey(t.account)) throw new Error("account is invalid");
                                    if (t.signer.ed25519PublicKey) {
                                        if (!Lt.isValidEd25519PublicKey(t.signer.ed25519PublicKey)) throw new Error("signer.ed25519PublicKey is invalid.");
                                        var r = Lt.decodeEd25519PublicKey(t.signer.ed25519PublicKey);
                                        e = new i.SignerKey.signerKeyTypeEd25519(r);
                                    } else if (t.signer.preAuthTx) {
                                        var n;
                                        if (n = "string" == typeof t.signer.preAuthTx ? en.from(t.signer.preAuthTx, "hex") : t.signer.preAuthTx, !en.isBuffer(n) || 32 !== n.length) throw new Error("signer.preAuthTx must be 32 bytes Buffer.");
                                        e = new i.SignerKey.signerKeyTypePreAuthTx(n);
                                    } else {
                                        if (!t.signer.sha256Hash) throw new Error("signer is invalid");
                                        var o;
                                        if (o = "string" == typeof t.signer.sha256Hash ? en.from(t.signer.sha256Hash, "hex") : t.signer.sha256Hash, !en.isBuffer(o) || 32 !== o.length) throw new Error("signer.sha256Hash must be 32 bytes Buffer.");
                                        e = new i.SignerKey.signerKeyTypeHashX(o);
                                    }
                                    var a = new i.RevokeSponsorshipOpSigner({
                                        accountId: Wt.fromPublicKey(t.account).xdrAccountId(),
                                        signerKey: e
                                    }), s = i.RevokeSponsorshipOp.revokeSponsorshipSigner(a), u = {};
                                    return u.body = i.OperationBody.revokeSponsorship(s), this.setSourceAccount(u, t), new i.Operation(u);
                                }, vn.clawback = function(e) {
                                    var t = {};
                                    if (!this.isValidAmount(e.amount)) throw new TypeError(this.constructAmountRequirementsError("amount"));
                                    t.amount = this._toXDRAmount(e.amount), t.asset = e.asset.toXDRObject();
                                    try {
                                        t.from = Wr(e.from);
                                    } catch (e) {
                                        throw new Error("from address is invalid");
                                    }
                                    var r = {
                                        body: i.OperationBody.clawback(new i.ClawbackOp(t))
                                    };
                                    return this.setSourceAccount(r, e), new i.Operation(r);
                                }, vn.setTrustLineFlags = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = {};
                                    if ("object" !== tn(e.flags) || 0 === Object.keys(e.flags).length) throw new Error("opts.flags must be a map of boolean flags to modify");
                                    var r = {
                                        authorized: i.TrustLineFlags.authorizedFlag(),
                                        authorizedToMaintainLiabilities: i.TrustLineFlags.authorizedToMaintainLiabilitiesFlag(),
                                        clawbackEnabled: i.TrustLineFlags.trustlineClawbackEnabledFlag()
                                    }, n = 0, o = 0;
                                    Object.keys(e.flags).forEach(function(t) {
                                        if (!Object.prototype.hasOwnProperty.call(r, t)) throw new Error("unsupported flag name specified: ".concat(t));
                                        var i = e.flags[t], a = r[t].value;
                                        !0 === i ? o |= a : !1 === i && (n |= a);
                                    }), t.trustor = Wt.fromPublicKey(e.trustor).xdrAccountId(), t.asset = e.asset.toXDRObject(), t.clearFlags = n, t.setFlags = o;
                                    var a = {
                                        body: i.OperationBody.setTrustLineFlags(new i.SetTrustLineFlagsOp(t))
                                    };
                                    return this.setSourceAccount(a, e), new i.Operation(a);
                                }, vn.liquidityPoolDeposit = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.liquidityPoolId, r = e.maxAmountA, n = e.maxAmountB, o = e.minPrice, a = e.maxPrice, s = {};
                                    if (!t) throw new TypeError("liquidityPoolId argument is required");
                                    if (s.liquidityPoolId = i.PoolId.fromXDR(t, "hex"), !this.isValidAmount(r, !0)) throw new TypeError(this.constructAmountRequirementsError("maxAmountA"));
                                    if (s.maxAmountA = this._toXDRAmount(r), !this.isValidAmount(n, !0)) throw new TypeError(this.constructAmountRequirementsError("maxAmountB"));
                                    if (s.maxAmountB = this._toXDRAmount(n), void 0 === o) throw new TypeError("minPrice argument is required");
                                    if (s.minPrice = this._toXDRPrice(o), void 0 === a) throw new TypeError("maxPrice argument is required");
                                    s.maxPrice = this._toXDRPrice(a);
                                    var u = new i.LiquidityPoolDepositOp(s), c = {
                                        body: i.OperationBody.liquidityPoolDeposit(u)
                                    };
                                    return this.setSourceAccount(c, e), new i.Operation(c);
                                }, vn.liquidityPoolWithdraw = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = {};
                                    if (!e.liquidityPoolId) throw new TypeError("liquidityPoolId argument is required");
                                    if (t.liquidityPoolId = i.PoolId.fromXDR(e.liquidityPoolId, "hex"), !this.isValidAmount(e.amount)) throw new TypeError(this.constructAmountRequirementsError("amount"));
                                    if (t.amount = this._toXDRAmount(e.amount), !this.isValidAmount(e.minAmountA, !0)) throw new TypeError(this.constructAmountRequirementsError("minAmountA"));
                                    if (t.minAmountA = this._toXDRAmount(e.minAmountA), !this.isValidAmount(e.minAmountB, !0)) throw new TypeError(this.constructAmountRequirementsError("minAmountB"));
                                    t.minAmountB = this._toXDRAmount(e.minAmountB);
                                    var r = new i.LiquidityPoolWithdrawOp(t), n = {
                                        body: i.OperationBody.liquidityPoolWithdraw(r)
                                    };
                                    return this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.invokeHostFunction = function(e) {
                                    if (!e.func) throw new TypeError("host function invocation ('func') required (got ".concat(JSON.stringify(e), ")"));
                                    e.func.switch().value === i.HostFunctionType.hostFunctionTypeInvokeContract().value && e.func.invokeContract().args().forEach(function(e) {
                                        var t;
                                        try {
                                            t = sn.fromScVal(e);
                                        } catch (e) {
                                            return;
                                        }
                                        switch(t._type){
                                            case "claimableBalance":
                                            case "liquidityPool":
                                                throw new TypeError("claimable balances and liquidity pools cannot be arguments to invokeHostFunction");
                                        }
                                    });
                                    var t = new i.InvokeHostFunctionOp({
                                        hostFunction: e.func,
                                        auth: e.auth || []
                                    }), r = {
                                        body: i.OperationBody.invokeHostFunction(t)
                                    };
                                    return this.setSourceAccount(r, e), new i.Operation(r);
                                }, vn.extendFootprintTtl = function(e) {
                                    var t;
                                    if ((null !== (t = e.extendTo) && void 0 !== t ? t : -1) <= 0) throw new RangeError("extendTo has to be positive");
                                    var r = new i.ExtendFootprintTtlOp({
                                        ext: new i.ExtensionPoint(0),
                                        extendTo: e.extendTo
                                    }), n = {
                                        body: i.OperationBody.extendFootprintTtl(r)
                                    };
                                    return this.setSourceAccount(n, e), new i.Operation(n);
                                }, vn.restoreFootprint = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = new i.RestoreFootprintOp({
                                        ext: new i.ExtensionPoint(0)
                                    }), r = {
                                        body: i.OperationBody.restoreFootprint(t)
                                    };
                                    return this.setSourceAccount(r, null != e ? e : {}), new i.Operation(r);
                                }, vn.createStellarAssetContract = function(e) {
                                    var t = e.asset;
                                    if ("string" == typeof t) {
                                        var r = function(e, t) {
                                            return function(e) {
                                                if (Array.isArray(e)) return e;
                                            }(e) || function(e, t) {
                                                var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                                if (null != r) {
                                                    var n, o, i, a, s = [], u = !0, c = !1;
                                                    try {
                                                        if (i = (r = r.call(e)).next, 0 === t) {
                                                            if (Object(r) !== r) return;
                                                            u = !1;
                                                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                                                    } catch (e) {
                                                        c = !0, o = e;
                                                    } finally{
                                                        try {
                                                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                                        } finally{
                                                            if (c) throw o;
                                                        }
                                                    }
                                                    return s;
                                                }
                                            }(e, t) || function(e, t) {
                                                if (e) {
                                                    if ("string" == typeof e) return cn(e, t);
                                                    var r = ({}).toString.call(e).slice(8, -1);
                                                    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? cn(e, t) : void 0;
                                                }
                                            }(e, t) || function() {
                                                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }();
                                        }(t.split(":"), 2), n = r[0], o = r[1];
                                        t = new Yt(n, o);
                                    }
                                    if (!(t instanceof Yt)) throw new TypeError("expected Asset in 'opts.asset', got ".concat(t));
                                    return this.invokeHostFunction({
                                        source: e.source,
                                        auth: e.auth,
                                        func: i.HostFunction.hostFunctionTypeCreateContract(new i.CreateContractArgs({
                                            executable: i.ContractExecutable.contractExecutableStellarAsset(),
                                            contractIdPreimage: i.ContractIdPreimage.contractIdPreimageFromAsset(t.toXDRObject())
                                        }))
                                    });
                                }, vn.invokeContractFunction = function(e) {
                                    var t = new sn(e.contract);
                                    if ("contract" !== t._type) throw new TypeError("expected contract strkey instance, got ".concat(t));
                                    return this.invokeHostFunction({
                                        source: e.source,
                                        auth: e.auth,
                                        func: i.HostFunction.hostFunctionTypeInvokeContract(new i.InvokeContractArgs({
                                            contractAddress: t.toScAddress(),
                                            functionName: e.function,
                                            args: e.args
                                        }))
                                    });
                                }, vn.createCustomContract = function(e) {
                                    var t, r = un.from(e.salt || Wt.random().xdrPublicKey().value());
                                    if (!e.wasmHash || 32 !== e.wasmHash.length) throw new TypeError("expected hash(contract WASM) in 'opts.wasmHash', got ".concat(e.wasmHash));
                                    if (32 !== r.length) throw new TypeError("expected 32-byte salt in 'opts.salt', got ".concat(e.wasmHash));
                                    return this.invokeHostFunction({
                                        source: e.source,
                                        auth: e.auth,
                                        func: i.HostFunction.hostFunctionTypeCreateContractV2(new i.CreateContractArgsV2({
                                            executable: i.ContractExecutable.contractExecutableWasm(un.from(e.wasmHash)),
                                            contractIdPreimage: i.ContractIdPreimage.contractIdPreimageFromAddress(new i.ContractIdPreimageFromAddress({
                                                address: e.address.toScAddress(),
                                                salt: r
                                            })),
                                            constructorArgs: null !== (t = e.constructorArgs) && void 0 !== t ? t : []
                                        }))
                                    });
                                }, vn.uploadContractWasm = function(e) {
                                    return this.invokeHostFunction({
                                        source: e.source,
                                        auth: e.auth,
                                        func: i.HostFunction.hostFunctionTypeUploadContractWasm(un.from(e.wasm))
                                    });
                                };
                                var wn = r(8287).Buffer;
                                function Sn(e) {
                                    return Sn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Sn(e);
                                }
                                function An(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, En(n.key), n);
                                    }
                                }
                                function En(e) {
                                    var t = function(e) {
                                        if ("object" != Sn(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Sn(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Sn(t) ? t : t + "";
                                }
                                var Tn = "none", On = "id", kn = "text", _n = "hash", xn = "return", Pn = function() {
                                    function e(t) {
                                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                        switch(function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, e), this._type = t, this._value = r, this._type){
                                            case Tn:
                                                break;
                                            case On:
                                                e._validateIdValue(r);
                                                break;
                                            case kn:
                                                e._validateTextValue(r);
                                                break;
                                            case _n:
                                            case xn:
                                                e._validateHashValue(r), "string" == typeof r && (this._value = wn.from(r, "hex"));
                                                break;
                                            default:
                                                throw new Error("Invalid memo type");
                                        }
                                    }
                                    return function(e, t, r) {
                                        return t && An(e.prototype, t), r && An(e, r), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(e, [
                                        {
                                            key: "type",
                                            get: function() {
                                                return this._type;
                                            },
                                            set: function(e) {
                                                throw new Error("Memo is immutable");
                                            }
                                        },
                                        {
                                            key: "value",
                                            get: function() {
                                                switch(this._type){
                                                    case Tn:
                                                        return null;
                                                    case On:
                                                    case kn:
                                                        return this._value;
                                                    case _n:
                                                    case xn:
                                                        return wn.from(this._value);
                                                    default:
                                                        throw new Error("Invalid memo type");
                                                }
                                            },
                                            set: function(e) {
                                                throw new Error("Memo is immutable");
                                            }
                                        },
                                        {
                                            key: "toXDRObject",
                                            value: function() {
                                                switch(this._type){
                                                    case Tn:
                                                        return i.Memo.memoNone();
                                                    case On:
                                                        return i.Memo.memoId(n.UnsignedHyper.fromString(this._value));
                                                    case kn:
                                                        return i.Memo.memoText(this._value);
                                                    case _n:
                                                        return i.Memo.memoHash(this._value);
                                                    case xn:
                                                        return i.Memo.memoReturn(this._value);
                                                    default:
                                                        return null;
                                                }
                                            }
                                        }
                                    ], [
                                        {
                                            key: "_validateIdValue",
                                            value: function(e) {
                                                var t, r = new Error("Expects a uint64 as a string. Got ".concat(e));
                                                if ("string" != typeof e) throw r;
                                                try {
                                                    t = new _r(e);
                                                } catch (e) {
                                                    throw r;
                                                }
                                                if (!t.isFinite()) throw r;
                                                if (t.isNaN()) throw r;
                                                if (t.isNegative()) throw r;
                                                if (!t.isInteger()) throw r;
                                                if (t.isGreaterThan("18446744073709551615")) throw r;
                                            }
                                        },
                                        {
                                            key: "_validateTextValue",
                                            value: function(e) {
                                                if (!i.Memo.armTypeForArm("text").isValid(e)) throw new Error("Expects string, array or buffer, max 28 bytes");
                                            }
                                        },
                                        {
                                            key: "_validateHashValue",
                                            value: function(e) {
                                                var t, r = new Error("Expects a 32 byte hash value or hex encoded string. Got ".concat(e));
                                                if (null == e) throw r;
                                                if ("string" == typeof e) {
                                                    if (!/^[0-9A-Fa-f]{64}$/g.test(e)) throw r;
                                                    t = wn.from(e, "hex");
                                                } else {
                                                    if (!wn.isBuffer(e)) throw r;
                                                    t = wn.from(e);
                                                }
                                                if (!t.length || 32 !== t.length) throw r;
                                            }
                                        },
                                        {
                                            key: "none",
                                            value: function() {
                                                return new e(Tn);
                                            }
                                        },
                                        {
                                            key: "text",
                                            value: function(t) {
                                                return new e(kn, t);
                                            }
                                        },
                                        {
                                            key: "id",
                                            value: function(t) {
                                                return new e(On, t);
                                            }
                                        },
                                        {
                                            key: "hash",
                                            value: function(t) {
                                                return new e(_n, t);
                                            }
                                        },
                                        {
                                            key: "return",
                                            value: function(t) {
                                                return new e(xn, t);
                                            }
                                        },
                                        {
                                            key: "fromXDRObject",
                                            value: function(t) {
                                                switch(t.arm()){
                                                    case "id":
                                                        return e.id(t.value().toString());
                                                    case "text":
                                                        return e.text(t.value());
                                                    case "hash":
                                                        return e.hash(t.value());
                                                    case "retHash":
                                                        return e.return(t.value());
                                                }
                                                if (void 0 === t.value()) return e.none();
                                                throw new Error("Unknown type");
                                            }
                                        }
                                    ]);
                                }(), Rn = r(8287).Buffer;
                                function In(e) {
                                    return In = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, In(e);
                                }
                                function Bn(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cn(n.key), n);
                                    }
                                }
                                function Cn(e) {
                                    var t = function(e) {
                                        if ("object" != In(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != In(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == In(t) ? t : t + "";
                                }
                                function jn(e, t, r) {
                                    return t = Nn(t), function(e, t) {
                                        if (t && ("object" == In(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, Un() ? Reflect.construct(t, r || [], Nn(e).constructor) : t.apply(e, r));
                                }
                                function Un() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (Un = function() {
                                        return !!e;
                                    })();
                                }
                                function Nn(e) {
                                    return Nn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, Nn(e);
                                }
                                function Ln(e, t) {
                                    return Ln = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, Ln(e, t);
                                }
                                var Fn = function(e) {
                                    function t(e, r) {
                                        var n;
                                        if (function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t), "string" == typeof e) {
                                            var o = Rn.from(e, "base64");
                                            e = i.TransactionEnvelope.fromXDR(o);
                                        }
                                        var a = e.switch();
                                        if (a !== i.EnvelopeType.envelopeTypeTxV0() && a !== i.EnvelopeType.envelopeTypeTx()) throw new Error("Invalid TransactionEnvelope: expected an envelopeTypeTxV0 or envelopeTypeTx but received an ".concat(a.name, "."));
                                        var s = e.value(), u = s.tx(), c = u.fee().toString();
                                        (n = jn(this, t, [
                                            u,
                                            (s.signatures() || []).slice(),
                                            c,
                                            r
                                        ]))._envelopeType = a, n._memo = u.memo(), n._sequence = u.seqNum().toString(), n._envelopeType === i.EnvelopeType.envelopeTypeTxV0() ? n._source = Lt.encodeEd25519PublicKey(n.tx.sourceAccountEd25519()) : n._source = Xr(n.tx.sourceAccount());
                                        var l = null, f = null;
                                        switch(n._envelopeType){
                                            case i.EnvelopeType.envelopeTypeTxV0():
                                                f = u.timeBounds();
                                                break;
                                            case i.EnvelopeType.envelopeTypeTx():
                                                switch(u.cond().switch()){
                                                    case i.PreconditionType.precondTime():
                                                        f = u.cond().timeBounds();
                                                        break;
                                                    case i.PreconditionType.precondV2():
                                                        f = (l = u.cond().v2()).timeBounds();
                                                }
                                        }
                                        if (f && (n._timeBounds = {
                                            minTime: f.minTime().toString(),
                                            maxTime: f.maxTime().toString()
                                        }), l) {
                                            var p = l.ledgerBounds();
                                            p && (n._ledgerBounds = {
                                                minLedger: p.minLedger(),
                                                maxLedger: p.maxLedger()
                                            });
                                            var d = l.minSeqNum();
                                            d && (n._minAccountSequence = d.toString()), n._minAccountSequenceAge = l.minSeqAge(), n._minAccountSequenceLedgerGap = l.minSeqLedgerGap(), n._extraSigners = l.extraSigners();
                                        }
                                        var h = u.operations() || [];
                                        return n._operations = h.map(function(e) {
                                            return vn.fromXDRObject(e);
                                        }), n;
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && Ln(e, t);
                                    }(t, e), function(e, t) {
                                        return t && Bn(e.prototype, t), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t, [
                                        {
                                            key: "timeBounds",
                                            get: function() {
                                                return this._timeBounds;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "ledgerBounds",
                                            get: function() {
                                                return this._ledgerBounds;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "minAccountSequence",
                                            get: function() {
                                                return this._minAccountSequence;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "minAccountSequenceAge",
                                            get: function() {
                                                return this._minAccountSequenceAge;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "minAccountSequenceLedgerGap",
                                            get: function() {
                                                return this._minAccountSequenceLedgerGap;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "extraSigners",
                                            get: function() {
                                                return this._extraSigners;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "sequence",
                                            get: function() {
                                                return this._sequence;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "source",
                                            get: function() {
                                                return this._source;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "operations",
                                            get: function() {
                                                return this._operations;
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "memo",
                                            get: function() {
                                                return Pn.fromXDRObject(this._memo);
                                            },
                                            set: function(e) {
                                                throw new Error("Transaction is immutable");
                                            }
                                        },
                                        {
                                            key: "signatureBase",
                                            value: function() {
                                                var e = this.tx;
                                                this._envelopeType === i.EnvelopeType.envelopeTypeTxV0() && (e = i.Transaction.fromXDR(Rn.concat([
                                                    i.PublicKeyType.publicKeyTypeEd25519().toXDR(),
                                                    e.toXDR()
                                                ])));
                                                var t = new i.TransactionSignaturePayloadTaggedTransaction.envelopeTypeTx(e);
                                                return new i.TransactionSignaturePayload({
                                                    networkId: i.Hash.fromXDR(u(this.networkPassphrase)),
                                                    taggedTransaction: t
                                                }).toXDR();
                                            }
                                        },
                                        {
                                            key: "toEnvelope",
                                            value: function() {
                                                var e, t = this.tx.toXDR(), r = this.signatures.slice();
                                                switch(this._envelopeType){
                                                    case i.EnvelopeType.envelopeTypeTxV0():
                                                        e = new i.TransactionEnvelope.envelopeTypeTxV0(new i.TransactionV0Envelope({
                                                            tx: i.TransactionV0.fromXDR(t),
                                                            signatures: r
                                                        }));
                                                        break;
                                                    case i.EnvelopeType.envelopeTypeTx():
                                                        e = new i.TransactionEnvelope.envelopeTypeTx(new i.TransactionV1Envelope({
                                                            tx: i.Transaction.fromXDR(t),
                                                            signatures: r
                                                        }));
                                                        break;
                                                    default:
                                                        throw new Error("Invalid TransactionEnvelope: expected an envelopeTypeTxV0 or envelopeTypeTx but received an ".concat(this._envelopeType.name, "."));
                                                }
                                                return e;
                                            }
                                        },
                                        {
                                            key: "getClaimableBalanceId",
                                            value: function(e) {
                                                if (!Number.isInteger(e) || e < 0 || e >= this.operations.length) throw new RangeError("invalid operation index");
                                                var t = this.operations[e];
                                                try {
                                                    t = vn.createClaimableBalance(t);
                                                } catch (e) {
                                                    throw new TypeError("expected createClaimableBalance, got ".concat(t.type, ": ").concat(e));
                                                }
                                                var r = Lt.decodeEd25519PublicKey(Zr(this.source)), n = u(i.HashIdPreimage.envelopeTypeOpId(new i.HashIdPreimageOperationId({
                                                    sourceAccount: i.AccountId.publicKeyTypeEd25519(r),
                                                    seqNum: i.SequenceNumber.fromString(this.sequence),
                                                    opNum: e
                                                })).toXDR("raw"));
                                                return i.ClaimableBalanceId.claimableBalanceIdTypeV0(n).toXDR("hex");
                                            }
                                        }
                                    ]);
                                }(ar), Dn = r(8287).Buffer;
                                function Mn(e) {
                                    return Mn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Mn(e);
                                }
                                function Vn(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qn(n.key), n);
                                    }
                                }
                                function qn(e) {
                                    var t = function(e) {
                                        if ("object" != Mn(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Mn(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Mn(t) ? t : t + "";
                                }
                                function Gn(e, t, r) {
                                    return t = zn(t), function(e, t) {
                                        if (t && ("object" == Mn(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, Hn() ? Reflect.construct(t, r || [], zn(e).constructor) : t.apply(e, r));
                                }
                                function Hn() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (Hn = function() {
                                        return !!e;
                                    })();
                                }
                                function zn(e) {
                                    return zn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, zn(e);
                                }
                                function Wn(e, t) {
                                    return Wn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, Wn(e, t);
                                }
                                var Xn = function(e) {
                                    function t(e, r) {
                                        var n;
                                        if (function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t), "string" == typeof e) {
                                            var o = Dn.from(e, "base64");
                                            e = i.TransactionEnvelope.fromXDR(o);
                                        }
                                        var a = e.switch();
                                        if (a !== i.EnvelopeType.envelopeTypeTxFeeBump()) throw new Error("Invalid TransactionEnvelope: expected an envelopeTypeTxFeeBump but received an ".concat(a.name, "."));
                                        var s = e.value(), u = s.tx(), c = u.fee().toString();
                                        n = Gn(this, t, [
                                            u,
                                            (s.signatures() || []).slice(),
                                            c,
                                            r
                                        ]);
                                        var l = i.TransactionEnvelope.envelopeTypeTx(u.innerTx().v1());
                                        return n._feeSource = Xr(n.tx.feeSource()), n._innerTransaction = new Fn(l, r), n;
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && Wn(e, t);
                                    }(t, e), function(e, t) {
                                        return t && Vn(e.prototype, t), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t, [
                                        {
                                            key: "innerTransaction",
                                            get: function() {
                                                return this._innerTransaction;
                                            }
                                        },
                                        {
                                            key: "operations",
                                            get: function() {
                                                return this._innerTransaction.operations;
                                            }
                                        },
                                        {
                                            key: "feeSource",
                                            get: function() {
                                                return this._feeSource;
                                            }
                                        },
                                        {
                                            key: "signatureBase",
                                            value: function() {
                                                var e = new i.TransactionSignaturePayloadTaggedTransaction.envelopeTypeTxFeeBump(this.tx);
                                                return new i.TransactionSignaturePayload({
                                                    networkId: i.Hash.fromXDR(u(this.networkPassphrase)),
                                                    taggedTransaction: e
                                                }).toXDR();
                                            }
                                        },
                                        {
                                            key: "toEnvelope",
                                            value: function() {
                                                var e = new i.FeeBumpTransactionEnvelope({
                                                    tx: i.FeeBumpTransaction.fromXDR(this.tx.toXDR()),
                                                    signatures: this.signatures.slice()
                                                });
                                                return new i.TransactionEnvelope.envelopeTypeTxFeeBump(e);
                                            }
                                        }
                                    ]);
                                }(ar);
                                function Kn(e) {
                                    return Kn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Kn(e);
                                }
                                function Zn(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $n(n.key), n);
                                    }
                                }
                                function $n(e) {
                                    var t = function(e) {
                                        if ("object" != Kn(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Kn(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Kn(t) ? t : t + "";
                                }
                                var Yn = function(e, t) {
                                    return t && Zn(e.prototype, t), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t, r) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), Lt.isValidMed25519PublicKey(t)) throw new Error("accountId is an M-address; use MuxedAccount instead");
                                    if (!Lt.isValidEd25519PublicKey(t)) throw new Error("accountId is invalid");
                                    if ("string" != typeof r) throw new Error("sequence must be of type string");
                                    this._accountId = t, this.sequence = new _r(r);
                                }, [
                                    {
                                        key: "accountId",
                                        value: function() {
                                            return this._accountId;
                                        }
                                    },
                                    {
                                        key: "sequenceNumber",
                                        value: function() {
                                            return this.sequence.toString();
                                        }
                                    },
                                    {
                                        key: "incrementSequenceNumber",
                                        value: function() {
                                            this.sequence = this.sequence.plus(1);
                                        }
                                    }
                                ]);
                                function Qn(e) {
                                    return Qn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Qn(e);
                                }
                                function Jn(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eo(n.key), n);
                                    }
                                }
                                function eo(e) {
                                    var t = function(e) {
                                        if ("object" != Qn(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Qn(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Qn(t) ? t : t + "";
                                }
                                var to = function() {
                                    function e(t, r) {
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, e);
                                        var n = t.accountId();
                                        if (!Lt.isValidEd25519PublicKey(n)) throw new Error("accountId is invalid");
                                        this.account = t, this._muxedXdr = Kr(n, r), this._mAddress = Xr(this._muxedXdr), this._id = r;
                                    }
                                    return function(e, t, r) {
                                        return t && Jn(e.prototype, t), r && Jn(e, r), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(e, [
                                        {
                                            key: "baseAccount",
                                            value: function() {
                                                return this.account;
                                            }
                                        },
                                        {
                                            key: "accountId",
                                            value: function() {
                                                return this._mAddress;
                                            }
                                        },
                                        {
                                            key: "id",
                                            value: function() {
                                                return this._id;
                                            }
                                        },
                                        {
                                            key: "setId",
                                            value: function(e) {
                                                if ("string" != typeof e) throw new Error("id should be a string representing a number (uint64)");
                                                return this._muxedXdr.med25519().id(i.Uint64.fromString(e)), this._mAddress = Xr(this._muxedXdr), this._id = e, this;
                                            }
                                        },
                                        {
                                            key: "sequenceNumber",
                                            value: function() {
                                                return this.account.sequenceNumber();
                                            }
                                        },
                                        {
                                            key: "incrementSequenceNumber",
                                            value: function() {
                                                return this.account.incrementSequenceNumber();
                                            }
                                        },
                                        {
                                            key: "toXDRObject",
                                            value: function() {
                                                return this._muxedXdr;
                                            }
                                        },
                                        {
                                            key: "equals",
                                            value: function(e) {
                                                return this.accountId() === e.accountId();
                                            }
                                        }
                                    ], [
                                        {
                                            key: "fromAddress",
                                            value: function(t, r) {
                                                var n = Wr(t), o = Zr(t), i = n.med25519().id().toString();
                                                return new e(new Yn(o, r), i);
                                            }
                                        }
                                    ]);
                                }();
                                function ro(e) {
                                    return ro = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, ro(e);
                                }
                                function no(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oo(n.key), n);
                                    }
                                }
                                function oo(e) {
                                    var t = function(e) {
                                        if ("object" != ro(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != ro(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == ro(t) ? t : t + "";
                                }
                                var io = function(e, t, r) {
                                    return t && no(e.prototype, t), r && no(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t) {
                                    var r;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), function(e, t, r) {
                                        (t = oo(t)) in e ? Object.defineProperty(e, t, {
                                            value: r,
                                            enumerable: !0,
                                            configurable: !0,
                                            writable: !0
                                        }) : e[t] = r;
                                    }(this, "_data", void 0), r = t ? "string" == typeof t || ArrayBuffer.isView(t) ? e.fromXDR(t) : e.fromXDR(t.toXDR()) : new i.SorobanTransactionData({
                                        resources: new i.SorobanResources({
                                            footprint: new i.LedgerFootprint({
                                                readOnly: [],
                                                readWrite: []
                                            }),
                                            instructions: 0,
                                            diskReadBytes: 0,
                                            writeBytes: 0
                                        }),
                                        ext: new i.SorobanTransactionDataExt(0),
                                        resourceFee: new i.Int64(0)
                                    }), this._data = r;
                                }, [
                                    {
                                        key: "setResourceFee",
                                        value: function(e) {
                                            return this._data.resourceFee(new i.Int64(e)), this;
                                        }
                                    },
                                    {
                                        key: "setResources",
                                        value: function(e, t, r) {
                                            return this._data.resources().instructions(e), this._data.resources().diskReadBytes(t), this._data.resources().writeBytes(r), this;
                                        }
                                    },
                                    {
                                        key: "appendFootprint",
                                        value: function(e, t) {
                                            return this.setFootprint(this.getReadOnly().concat(e), this.getReadWrite().concat(t));
                                        }
                                    },
                                    {
                                        key: "setFootprint",
                                        value: function(e, t) {
                                            return null !== e && this.setReadOnly(e), null !== t && this.setReadWrite(t), this;
                                        }
                                    },
                                    {
                                        key: "setReadOnly",
                                        value: function(e) {
                                            return this._data.resources().footprint().readOnly(null != e ? e : []), this;
                                        }
                                    },
                                    {
                                        key: "setReadWrite",
                                        value: function(e) {
                                            return this._data.resources().footprint().readWrite(null != e ? e : []), this;
                                        }
                                    },
                                    {
                                        key: "build",
                                        value: function() {
                                            return i.SorobanTransactionData.fromXDR(this._data.toXDR());
                                        }
                                    },
                                    {
                                        key: "getReadOnly",
                                        value: function() {
                                            return this.getFootprint().readOnly();
                                        }
                                    },
                                    {
                                        key: "getReadWrite",
                                        value: function() {
                                            return this.getFootprint().readWrite();
                                        }
                                    },
                                    {
                                        key: "getFootprint",
                                        value: function() {
                                            return this._data.resources().footprint();
                                        }
                                    }
                                ], [
                                    {
                                        key: "fromXDR",
                                        value: function(e) {
                                            return i.SorobanTransactionData.fromXDR(e, "string" == typeof e ? "base64" : "raw");
                                        }
                                    }
                                ]);
                                function ao(e) {
                                    return ao = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, ao(e);
                                }
                                function so(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uo(n.key), n);
                                    }
                                }
                                function uo(e) {
                                    var t = function(e) {
                                        if ("object" != ao(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != ao(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == ao(t) ? t : t + "";
                                }
                                var co = function(e, t, r) {
                                    return r && so(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }, 0, [
                                    {
                                        key: "decodeAddress",
                                        value: function(e) {
                                            var t = {
                                                ed25519PublicKey: i.SignerKey.signerKeyTypeEd25519,
                                                preAuthTx: i.SignerKey.signerKeyTypePreAuthTx,
                                                sha256Hash: i.SignerKey.signerKeyTypeHashX,
                                                signedPayload: i.SignerKey.signerKeyTypeEd25519SignedPayload
                                            }, r = Lt.getVersionByteForPrefix(e), n = t[r];
                                            if (!n) throw new Error("invalid signer key type (".concat(r, ")"));
                                            var o = Dt(r, e);
                                            return n("signedPayload" === r ? new i.SignerKeyEd25519SignedPayload({
                                                ed25519: o.slice(0, 32),
                                                payload: o.slice(36, 36 + o.readUInt32BE(32))
                                            }) : o);
                                        }
                                    },
                                    {
                                        key: "encodeSignerKey",
                                        value: function(e) {
                                            var t, r;
                                            switch(e.switch()){
                                                case i.SignerKeyType.signerKeyTypeEd25519():
                                                    t = "ed25519PublicKey", r = e.value();
                                                    break;
                                                case i.SignerKeyType.signerKeyTypePreAuthTx():
                                                    t = "preAuthTx", r = e.value();
                                                    break;
                                                case i.SignerKeyType.signerKeyTypeHashX():
                                                    t = "sha256Hash", r = e.value();
                                                    break;
                                                case i.SignerKeyType.signerKeyTypeEd25519SignedPayload():
                                                    t = "signedPayload", r = e.ed25519SignedPayload().toXDR("raw");
                                                    break;
                                                default:
                                                    throw new Error("invalid SignerKey (type: ".concat(e.switch(), ")"));
                                            }
                                            return Mt(t, r);
                                        }
                                    }
                                ]);
                                function lo(e) {
                                    return lo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, lo(e);
                                }
                                function fo(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, po(n.key), n);
                                    }
                                }
                                function po(e) {
                                    var t = function(e) {
                                        if ("object" != lo(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != lo(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == lo(t) ? t : t + "";
                                }
                                var ho = function(e, t) {
                                    return t && fo(e.prototype, t), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t) {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                    try {
                                        this._id = Lt.decodeContract(t);
                                    } catch (e) {
                                        throw new Error("Invalid contract ID: ".concat(t));
                                    }
                                }, [
                                    {
                                        key: "contractId",
                                        value: function() {
                                            return Lt.encodeContract(this._id);
                                        }
                                    },
                                    {
                                        key: "toString",
                                        value: function() {
                                            return this.contractId();
                                        }
                                    },
                                    {
                                        key: "address",
                                        value: function() {
                                            return sn.contract(this._id);
                                        }
                                    },
                                    {
                                        key: "call",
                                        value: function(e) {
                                            for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                            return vn.invokeContractFunction({
                                                contract: this.address().toString(),
                                                function: e,
                                                args: r
                                            });
                                        }
                                    },
                                    {
                                        key: "getFootprint",
                                        value: function() {
                                            return i.LedgerKey.contractData(new i.LedgerKeyContractData({
                                                contract: this.address().toScAddress(),
                                                key: i.ScVal.scvLedgerKeyContractInstance(),
                                                durability: i.ContractDataDurability.persistent()
                                            }));
                                        }
                                    }
                                ]);
                                function yo(e) {
                                    return yo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, yo(e);
                                }
                                function mo(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, go(n.key), n);
                                    }
                                }
                                function go(e) {
                                    var t = function(e) {
                                        if ("object" != yo(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != yo(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == yo(t) ? t : t + "";
                                }
                                function vo(e, t, r) {
                                    return t = wo(t), function(e, t) {
                                        if (t && ("object" == yo(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, bo() ? Reflect.construct(t, r || [], wo(e).constructor) : t.apply(e, r));
                                }
                                function bo() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (bo = function() {
                                        return !!e;
                                    })();
                                }
                                function wo(e) {
                                    return wo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, wo(e);
                                }
                                function So(e, t) {
                                    return So = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, So(e, t);
                                }
                                var Ao = function(e) {
                                    function t() {
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t);
                                        for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                                        return vo(this, t, [
                                            r
                                        ]);
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && So(e, t);
                                    }(t, e), function(e, t) {
                                        return t && mo(e.prototype, t), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t, [
                                        {
                                            key: "unsigned",
                                            get: function() {
                                                return !0;
                                            }
                                        },
                                        {
                                            key: "size",
                                            get: function() {
                                                return 128;
                                            }
                                        }
                                    ]);
                                }(n.LargeInt);
                                function Eo(e) {
                                    return Eo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Eo(e);
                                }
                                function To(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Oo(n.key), n);
                                    }
                                }
                                function Oo(e) {
                                    var t = function(e) {
                                        if ("object" != Eo(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Eo(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Eo(t) ? t : t + "";
                                }
                                function ko(e, t, r) {
                                    return t = xo(t), function(e, t) {
                                        if (t && ("object" == Eo(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, _o() ? Reflect.construct(t, r || [], xo(e).constructor) : t.apply(e, r));
                                }
                                function _o() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (_o = function() {
                                        return !!e;
                                    })();
                                }
                                function xo(e) {
                                    return xo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, xo(e);
                                }
                                function Po(e, t) {
                                    return Po = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, Po(e, t);
                                }
                                Ao.defineIntBoundaries();
                                var Ro = function(e) {
                                    function t() {
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t);
                                        for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                                        return ko(this, t, [
                                            r
                                        ]);
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && Po(e, t);
                                    }(t, e), function(e, t) {
                                        return t && To(e.prototype, t), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t, [
                                        {
                                            key: "unsigned",
                                            get: function() {
                                                return !0;
                                            }
                                        },
                                        {
                                            key: "size",
                                            get: function() {
                                                return 256;
                                            }
                                        }
                                    ]);
                                }(n.LargeInt);
                                function Io(e) {
                                    return Io = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Io(e);
                                }
                                function Bo(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Co(n.key), n);
                                    }
                                }
                                function Co(e) {
                                    var t = function(e) {
                                        if ("object" != Io(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Io(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Io(t) ? t : t + "";
                                }
                                function jo(e, t, r) {
                                    return t = No(t), function(e, t) {
                                        if (t && ("object" == Io(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, Uo() ? Reflect.construct(t, r || [], No(e).constructor) : t.apply(e, r));
                                }
                                function Uo() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (Uo = function() {
                                        return !!e;
                                    })();
                                }
                                function No(e) {
                                    return No = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, No(e);
                                }
                                function Lo(e, t) {
                                    return Lo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, Lo(e, t);
                                }
                                Ro.defineIntBoundaries();
                                var Fo = function(e) {
                                    function t() {
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t);
                                        for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                                        return jo(this, t, [
                                            r
                                        ]);
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && Lo(e, t);
                                    }(t, e), function(e, t) {
                                        return t && Bo(e.prototype, t), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t, [
                                        {
                                            key: "unsigned",
                                            get: function() {
                                                return !1;
                                            }
                                        },
                                        {
                                            key: "size",
                                            get: function() {
                                                return 128;
                                            }
                                        }
                                    ]);
                                }(n.LargeInt);
                                function Do(e) {
                                    return Do = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Do(e);
                                }
                                function Mo(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vo(n.key), n);
                                    }
                                }
                                function Vo(e) {
                                    var t = function(e) {
                                        if ("object" != Do(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Do(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Do(t) ? t : t + "";
                                }
                                function qo(e, t, r) {
                                    return t = Ho(t), function(e, t) {
                                        if (t && ("object" == Do(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, Go() ? Reflect.construct(t, r || [], Ho(e).constructor) : t.apply(e, r));
                                }
                                function Go() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (Go = function() {
                                        return !!e;
                                    })();
                                }
                                function Ho(e) {
                                    return Ho = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, Ho(e);
                                }
                                function zo(e, t) {
                                    return zo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, zo(e, t);
                                }
                                Fo.defineIntBoundaries();
                                var Wo = function(e) {
                                    function t() {
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t);
                                        for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                                        return qo(this, t, [
                                            r
                                        ]);
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && zo(e, t);
                                    }(t, e), function(e, t) {
                                        return t && Mo(e.prototype, t), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t, [
                                        {
                                            key: "unsigned",
                                            get: function() {
                                                return !1;
                                            }
                                        },
                                        {
                                            key: "size",
                                            get: function() {
                                                return 256;
                                            }
                                        }
                                    ]);
                                }(n.LargeInt);
                                function Xo(e) {
                                    return Xo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Xo(e);
                                }
                                function Ko(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $o(n.key), n);
                                    }
                                }
                                function Zo(e, t, r) {
                                    return (t = $o(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function $o(e) {
                                    var t = function(e) {
                                        if ("object" != Xo(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != Xo(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == Xo(t) ? t : t + "";
                                }
                                Wo.defineIntBoundaries();
                                var Yo = function(e, t, r) {
                                    return t && Ko(e.prototype, t), r && Ko(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t, r) {
                                    switch(function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), Zo(this, "int", void 0), Zo(this, "type", void 0), r instanceof Array || (r = [
                                        r
                                    ]), r = r.map(function(e) {
                                        return "bigint" == typeof e ? e : "function" == typeof e.toBigInt ? e.toBigInt() : BigInt(e);
                                    }), t){
                                        case "i64":
                                            this.int = new n.Hyper(r);
                                            break;
                                        case "i128":
                                            this.int = new Fo(r);
                                            break;
                                        case "i256":
                                            this.int = new Wo(r);
                                            break;
                                        case "u64":
                                        case "timepoint":
                                        case "duration":
                                            this.int = new n.UnsignedHyper(r);
                                            break;
                                        case "u128":
                                            this.int = new Ao(r);
                                            break;
                                        case "u256":
                                            this.int = new Ro(r);
                                            break;
                                        default:
                                            throw TypeError("invalid type: ".concat(t));
                                    }
                                    this.type = t;
                                }, [
                                    {
                                        key: "toNumber",
                                        value: function() {
                                            var e = this.int.toBigInt();
                                            if (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) throw RangeError("value ".concat(e, " not in range for Number ") + "[".concat(Number.MAX_SAFE_INTEGER, ", ").concat(Number.MIN_SAFE_INTEGER, "]"));
                                            return Number(e);
                                        }
                                    },
                                    {
                                        key: "toBigInt",
                                        value: function() {
                                            return this.int.toBigInt();
                                        }
                                    },
                                    {
                                        key: "toI64",
                                        value: function() {
                                            this._sizeCheck(64);
                                            var e = this.toBigInt();
                                            if (BigInt.asIntN(64, e) !== e) throw RangeError("value too large for i64: ".concat(e));
                                            return i.ScVal.scvI64(new i.Int64(e));
                                        }
                                    },
                                    {
                                        key: "toU64",
                                        value: function() {
                                            return this._sizeCheck(64), i.ScVal.scvU64(new i.Uint64(BigInt.asUintN(64, this.toBigInt())));
                                        }
                                    },
                                    {
                                        key: "toTimepoint",
                                        value: function() {
                                            return this._sizeCheck(64), i.ScVal.scvTimepoint(new i.Uint64(BigInt.asUintN(64, this.toBigInt())));
                                        }
                                    },
                                    {
                                        key: "toDuration",
                                        value: function() {
                                            return this._sizeCheck(64), i.ScVal.scvDuration(new i.Uint64(BigInt.asUintN(64, this.toBigInt())));
                                        }
                                    },
                                    {
                                        key: "toI128",
                                        value: function() {
                                            this._sizeCheck(128);
                                            var e = this.int.toBigInt(), t = BigInt.asIntN(64, e >> 64n), r = BigInt.asUintN(64, e);
                                            return i.ScVal.scvI128(new i.Int128Parts({
                                                hi: new i.Int64(t),
                                                lo: new i.Uint64(r)
                                            }));
                                        }
                                    },
                                    {
                                        key: "toU128",
                                        value: function() {
                                            this._sizeCheck(128);
                                            var e = this.int.toBigInt();
                                            return i.ScVal.scvU128(new i.UInt128Parts({
                                                hi: new i.Uint64(BigInt.asUintN(64, e >> 64n)),
                                                lo: new i.Uint64(BigInt.asUintN(64, e))
                                            }));
                                        }
                                    },
                                    {
                                        key: "toI256",
                                        value: function() {
                                            var e = this.int.toBigInt(), t = BigInt.asIntN(64, e >> 192n), r = BigInt.asUintN(64, e >> 128n), n = BigInt.asUintN(64, e >> 64n), o = BigInt.asUintN(64, e);
                                            return i.ScVal.scvI256(new i.Int256Parts({
                                                hiHi: new i.Int64(t),
                                                hiLo: new i.Uint64(r),
                                                loHi: new i.Uint64(n),
                                                loLo: new i.Uint64(o)
                                            }));
                                        }
                                    },
                                    {
                                        key: "toU256",
                                        value: function() {
                                            var e = this.int.toBigInt(), t = BigInt.asUintN(64, e >> 192n), r = BigInt.asUintN(64, e >> 128n), n = BigInt.asUintN(64, e >> 64n), o = BigInt.asUintN(64, e);
                                            return i.ScVal.scvU256(new i.UInt256Parts({
                                                hiHi: new i.Uint64(t),
                                                hiLo: new i.Uint64(r),
                                                loHi: new i.Uint64(n),
                                                loLo: new i.Uint64(o)
                                            }));
                                        }
                                    },
                                    {
                                        key: "toScVal",
                                        value: function() {
                                            switch(this.type){
                                                case "i64":
                                                    return this.toI64();
                                                case "i128":
                                                    return this.toI128();
                                                case "i256":
                                                    return this.toI256();
                                                case "u64":
                                                    return this.toU64();
                                                case "u128":
                                                    return this.toU128();
                                                case "u256":
                                                    return this.toU256();
                                                case "timepoint":
                                                    return this.toTimepoint();
                                                case "duration":
                                                    return this.toDuration();
                                                default:
                                                    throw TypeError("invalid type: ".concat(this.type));
                                            }
                                        }
                                    },
                                    {
                                        key: "valueOf",
                                        value: function() {
                                            return this.int.valueOf();
                                        }
                                    },
                                    {
                                        key: "toString",
                                        value: function() {
                                            return this.int.toString();
                                        }
                                    },
                                    {
                                        key: "toJSON",
                                        value: function() {
                                            return {
                                                value: this.toBigInt().toString(),
                                                type: this.type
                                            };
                                        }
                                    },
                                    {
                                        key: "_sizeCheck",
                                        value: function(e) {
                                            if (this.int.size > e) throw RangeError("value too large for ".concat(e, " bits (").concat(this.type, ")"));
                                        }
                                    }
                                ], [
                                    {
                                        key: "isType",
                                        value: function(e) {
                                            switch(e){
                                                case "i64":
                                                case "i128":
                                                case "i256":
                                                case "u64":
                                                case "u128":
                                                case "u256":
                                                case "timepoint":
                                                case "duration":
                                                    return !0;
                                                default:
                                                    return !1;
                                            }
                                        }
                                    },
                                    {
                                        key: "getType",
                                        value: function(e) {
                                            return e.slice(3).toLowerCase();
                                        }
                                    }
                                ]);
                                function Qo(e) {
                                    return Qo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Qo(e);
                                }
                                function Jo(e, t, r) {
                                    return t = ti(t), function(e, t) {
                                        if (t && ("object" == Qo(t) || "function" == typeof t)) return t;
                                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                        return function(e) {
                                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                            return e;
                                        }(e);
                                    }(e, ei() ? Reflect.construct(t, r || [], ti(e).constructor) : t.apply(e, r));
                                }
                                function ei() {
                                    try {
                                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                    } catch (e) {}
                                    return (ei = function() {
                                        return !!e;
                                    })();
                                }
                                function ti(e) {
                                    return ti = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, ti(e);
                                }
                                function ri(e, t) {
                                    return ri = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, ri(e, t);
                                }
                                var ni = function(e) {
                                    function t(e, r) {
                                        var n;
                                        !function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, t);
                                        var o = BigInt(e), i = o < 0n, a = null !== (n = null == r ? void 0 : r.type) && void 0 !== n ? n : "";
                                        if (a.startsWith("u") && i) throw TypeError("specified type ".concat(r.type, " yet negative (").concat(e, ")"));
                                        if ("" === a) {
                                            a = i ? "i" : "u";
                                            var s = function(e) {
                                                var t, r = e.toString(2).length;
                                                return null !== (t = [
                                                    64,
                                                    128,
                                                    256
                                                ].find(function(e) {
                                                    return r <= e;
                                                })) && void 0 !== t ? t : r;
                                            }(o);
                                            switch(s){
                                                case 64:
                                                case 128:
                                                case 256:
                                                    a += s.toString();
                                                    break;
                                                default:
                                                    throw RangeError("expected 64/128/256 bits for input (".concat(e, "), got ").concat(s));
                                            }
                                        }
                                        return Jo(this, t, [
                                            a,
                                            o
                                        ]);
                                    }
                                    return function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && ri(e, t);
                                    }(t, e), function(e) {
                                        return Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(t);
                                }(Yo);
                                function oi(e) {
                                    var t = Yo.getType(e.switch().name);
                                    switch(e.switch().name){
                                        case "scvU32":
                                        case "scvI32":
                                            return BigInt(e.value());
                                        case "scvU64":
                                        case "scvI64":
                                        case "scvTimepoint":
                                        case "scvDuration":
                                            return new Yo(t, e.value()).toBigInt();
                                        case "scvU128":
                                        case "scvI128":
                                            return new Yo(t, [
                                                e.value().lo(),
                                                e.value().hi()
                                            ]).toBigInt();
                                        case "scvU256":
                                        case "scvI256":
                                            return new Yo(t, [
                                                e.value().loLo(),
                                                e.value().loHi(),
                                                e.value().hiLo(),
                                                e.value().hiHi()
                                            ]).toBigInt();
                                        default:
                                            throw TypeError("expected integer type, got ".concat(e.switch()));
                                    }
                                }
                                var ii = r(8287).Buffer;
                                function ai(e, t) {
                                    return function(e) {
                                        if (Array.isArray(e)) return e;
                                    }(e) || function(e, t) {
                                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                        if (null != r) {
                                            var n, o, i, a, s = [], u = !0, c = !1;
                                            try {
                                                if (i = (r = r.call(e)).next, 0 === t) {
                                                    if (Object(r) !== r) return;
                                                    u = !1;
                                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                                            } catch (e) {
                                                c = !0, o = e;
                                            } finally{
                                                try {
                                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                                } finally{
                                                    if (c) throw o;
                                                }
                                            }
                                            return s;
                                        }
                                    }(e, t) || function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return si(e, t);
                                            var r = ({}).toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? si(e, t) : void 0;
                                        }
                                    }(e, t) || function() {
                                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }
                                function si(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                                    return n;
                                }
                                function ui(e, t) {
                                    var r = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var n = Object.getOwnPropertySymbols(e);
                                        t && (n = n.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), r.push.apply(r, n);
                                    }
                                    return r;
                                }
                                function ci(e, t, r) {
                                    return (t = function(e) {
                                        var t = function(e) {
                                            if ("object" != li(e) || !e) return e;
                                            var t = e[Symbol.toPrimitive];
                                            if (void 0 !== t) {
                                                var r = t.call(e, "string");
                                                if ("object" != li(r)) return r;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            return String(e);
                                        }(e);
                                        return "symbol" == li(t) ? t : t + "";
                                    }(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function li(e) {
                                    return li = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, li(e);
                                }
                                function fi(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    switch(li(e)){
                                        case "object":
                                            var r, n, o;
                                            if (null === e) return i.ScVal.scvVoid();
                                            if (e instanceof i.ScVal) return e;
                                            if (e instanceof sn) return e.toScVal();
                                            if (e instanceof Wt) return fi(e.publicKey(), {
                                                type: "address"
                                            });
                                            if (e instanceof ho) return e.address().toScVal();
                                            if (e instanceof Uint8Array || ii.isBuffer(e)) {
                                                var a, s = Uint8Array.from(e);
                                                switch(null !== (a = null == t ? void 0 : t.type) && void 0 !== a ? a : "bytes"){
                                                    case "bytes":
                                                        return i.ScVal.scvBytes(s);
                                                    case "symbol":
                                                        return i.ScVal.scvSymbol(s);
                                                    case "string":
                                                        return i.ScVal.scvString(s);
                                                    default:
                                                        throw new TypeError("invalid type (".concat(t.type, ") specified for bytes-like value"));
                                                }
                                            }
                                            if (Array.isArray(e)) return i.ScVal.scvVec(e.map(function(e, r) {
                                                return Array.isArray(t.type) ? fi(e, function(e) {
                                                    for(var t = 1; t < arguments.length; t++){
                                                        var r = null != arguments[t] ? arguments[t] : {};
                                                        t % 2 ? ui(Object(r), !0).forEach(function(t) {
                                                            ci(e, t, r[t]);
                                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ui(Object(r)).forEach(function(t) {
                                                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                                        });
                                                    }
                                                    return e;
                                                }({}, t.type.length > r && {
                                                    type: t.type[r]
                                                })) : fi(e, t);
                                            }));
                                            if ("Object" !== (null !== (r = null === (n = e.constructor) || void 0 === n ? void 0 : n.name) && void 0 !== r ? r : "")) throw new TypeError("cannot interpret ".concat(null === (o = e.constructor) || void 0 === o ? void 0 : o.name, " value as ScVal (").concat(JSON.stringify(e), ")"));
                                            return i.ScVal.scvMap(Object.entries(e).sort(function(e, t) {
                                                var r = ai(e, 1)[0], n = ai(t, 1)[0];
                                                return r.localeCompare(n);
                                            }).map(function(e) {
                                                var r, n, o = ai(e, 2), a = o[0], s = o[1], u = ai(null !== (r = (null !== (n = null == t ? void 0 : t.type) && void 0 !== n ? n : {})[a]) && void 0 !== r ? r : [
                                                    null,
                                                    null
                                                ], 2), c = u[0], l = u[1], f = c ? {
                                                    type: c
                                                } : {}, p = l ? {
                                                    type: l
                                                } : {};
                                                return new i.ScMapEntry({
                                                    key: fi(a, f),
                                                    val: fi(s, p)
                                                });
                                            }));
                                        case "number":
                                        case "bigint":
                                            switch(null == t ? void 0 : t.type){
                                                case "u32":
                                                    return i.ScVal.scvU32(e);
                                                case "i32":
                                                    return i.ScVal.scvI32(e);
                                            }
                                            return new ni(e, {
                                                type: null == t ? void 0 : t.type
                                            }).toScVal();
                                        case "string":
                                            var u, c = null !== (u = null == t ? void 0 : t.type) && void 0 !== u ? u : "string";
                                            switch(c){
                                                case "string":
                                                    return i.ScVal.scvString(e);
                                                case "symbol":
                                                    return i.ScVal.scvSymbol(e);
                                                case "address":
                                                    return new sn(e).toScVal();
                                                case "u32":
                                                    return i.ScVal.scvU32(parseInt(e, 10));
                                                case "i32":
                                                    return i.ScVal.scvI32(parseInt(e, 10));
                                                default:
                                                    if (Yo.isType(c)) return new Yo(c, e).toScVal();
                                                    throw new TypeError("invalid type (".concat(t.type, ") specified for string value"));
                                            }
                                        case "boolean":
                                            return i.ScVal.scvBool(e);
                                        case "undefined":
                                            return i.ScVal.scvVoid();
                                        case "function":
                                            return fi(e());
                                        default:
                                            throw new TypeError("failed to convert typeof ".concat(li(e), " (").concat(e, ")"));
                                    }
                                }
                                function pi(e) {
                                    var t, r;
                                    switch(e.switch().value){
                                        case i.ScValType.scvVoid().value:
                                            return null;
                                        case i.ScValType.scvU64().value:
                                        case i.ScValType.scvI64().value:
                                            return e.value().toBigInt();
                                        case i.ScValType.scvU128().value:
                                        case i.ScValType.scvI128().value:
                                        case i.ScValType.scvU256().value:
                                        case i.ScValType.scvI256().value:
                                            return oi(e);
                                        case i.ScValType.scvVec().value:
                                            return (null !== (t = e.vec()) && void 0 !== t ? t : []).map(pi);
                                        case i.ScValType.scvAddress().value:
                                            return sn.fromScVal(e).toString();
                                        case i.ScValType.scvMap().value:
                                            return Object.fromEntries((null !== (r = e.map()) && void 0 !== r ? r : []).map(function(e) {
                                                return [
                                                    pi(e.key()),
                                                    pi(e.val())
                                                ];
                                            }));
                                        case i.ScValType.scvBool().value:
                                        case i.ScValType.scvU32().value:
                                        case i.ScValType.scvI32().value:
                                        case i.ScValType.scvBytes().value:
                                            return e.value();
                                        case i.ScValType.scvSymbol().value:
                                        case i.ScValType.scvString().value:
                                            var n = e.value();
                                            if (ii.isBuffer(n) || ArrayBuffer.isView(n)) try {
                                                return (new TextDecoder).decode(n);
                                            } catch (e) {
                                                return new Uint8Array(n.buffer);
                                            }
                                            return n;
                                        case i.ScValType.scvTimepoint().value:
                                        case i.ScValType.scvDuration().value:
                                            return new i.Uint64(e.value()).toBigInt();
                                        case i.ScValType.scvError().value:
                                            if (e.error().switch().value === i.ScErrorType.sceContract().value) return {
                                                type: "contract",
                                                code: e.error().contractCode()
                                            };
                                            var o = e.error();
                                            return {
                                                type: "system",
                                                code: o.code().value,
                                                value: o.code().name
                                            };
                                        default:
                                            return e.value();
                                    }
                                }
                                function di(e) {
                                    return di = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, di(e);
                                }
                                function hi(e) {
                                    return function(e) {
                                        if (Array.isArray(e)) return yi(e);
                                    }(e) || function(e) {
                                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                                    }(e) || function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return yi(e, t);
                                            var r = ({}).toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? yi(e, t) : void 0;
                                        }
                                    }(e) || function() {
                                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }
                                function yi(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                                    return n;
                                }
                                function mi(e, t) {
                                    var r = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var n = Object.getOwnPropertySymbols(e);
                                        t && (n = n.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), r.push.apply(r, n);
                                    }
                                    return r;
                                }
                                function gi(e) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var r = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? mi(Object(r), !0).forEach(function(t) {
                                            vi(e, t, r[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mi(Object(r)).forEach(function(t) {
                                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                        });
                                    }
                                    return e;
                                }
                                function vi(e, t, r) {
                                    return (t = wi(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function bi(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wi(n.key), n);
                                    }
                                }
                                function wi(e) {
                                    var t = function(e) {
                                        if ("object" != di(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != di(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == di(t) ? t : t + "";
                                }
                                i.scvSortedMap = function(e) {
                                    var t = Array.from(e).sort(function(e, t) {
                                        var r = pi(e.key()), n = pi(t.key());
                                        switch(li(r)){
                                            case "number":
                                            case "bigint":
                                                return r < n ? -1 : 1;
                                            default:
                                                return r.toString().localeCompare(n.toString());
                                        }
                                    });
                                    return i.ScVal.scvMap(t);
                                };
                                var Si = "100", Ai = 0, Ei = function() {
                                    function e(t) {
                                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                        if (function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, e), !t) throw new Error("must specify source account for the transaction");
                                        if (void 0 === r.fee) throw new Error("must specify fee for the transaction (in stroops)");
                                        this.source = t, this.operations = [], this.baseFee = r.fee, this.timebounds = r.timebounds ? gi({}, r.timebounds) : null, this.ledgerbounds = r.ledgerbounds ? gi({}, r.ledgerbounds) : null, this.minAccountSequence = r.minAccountSequence || null, this.minAccountSequenceAge = r.minAccountSequenceAge || null, this.minAccountSequenceLedgerGap = r.minAccountSequenceLedgerGap || null, this.extraSigners = r.extraSigners ? hi(r.extraSigners) : null, this.memo = r.memo || Pn.none(), this.networkPassphrase = r.networkPassphrase || null, this.sorobanData = r.sorobanData ? new io(r.sorobanData).build() : null;
                                    }
                                    return function(e, t, r) {
                                        return t && bi(e.prototype, t), r && bi(e, r), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), e;
                                    }(e, [
                                        {
                                            key: "addOperation",
                                            value: function(e) {
                                                return this.operations.push(e), this;
                                            }
                                        },
                                        {
                                            key: "addOperationAt",
                                            value: function(e, t) {
                                                return this.operations.splice(t, 0, e), this;
                                            }
                                        },
                                        {
                                            key: "clearOperations",
                                            value: function() {
                                                return this.operations = [], this;
                                            }
                                        },
                                        {
                                            key: "clearOperationAt",
                                            value: function(e) {
                                                return this.operations.splice(e, 1), this;
                                            }
                                        },
                                        {
                                            key: "addMemo",
                                            value: function(e) {
                                                return this.memo = e, this;
                                            }
                                        },
                                        {
                                            key: "setTimeout",
                                            value: function(e) {
                                                if (null !== this.timebounds && this.timebounds.maxTime > 0) throw new Error("TimeBounds.max_time has been already set - setting timeout would overwrite it.");
                                                if (e < 0) throw new Error("timeout cannot be negative");
                                                if (e > 0) {
                                                    var t = Math.floor(Date.now() / 1e3) + e;
                                                    null === this.timebounds ? this.timebounds = {
                                                        minTime: 0,
                                                        maxTime: t
                                                    } : this.timebounds = {
                                                        minTime: this.timebounds.minTime,
                                                        maxTime: t
                                                    };
                                                } else this.timebounds = {
                                                    minTime: 0,
                                                    maxTime: 0
                                                };
                                                return this;
                                            }
                                        },
                                        {
                                            key: "setTimebounds",
                                            value: function(e, t) {
                                                if ("number" == typeof e && (e = new Date(1e3 * e)), "number" == typeof t && (t = new Date(1e3 * t)), null !== this.timebounds) throw new Error("TimeBounds has been already set - setting timebounds would overwrite it.");
                                                var r = Math.floor(e.valueOf() / 1e3), n = Math.floor(t.valueOf() / 1e3);
                                                if (r < 0) throw new Error("min_time cannot be negative");
                                                if (n < 0) throw new Error("max_time cannot be negative");
                                                if (n > 0 && r > n) throw new Error("min_time cannot be greater than max_time");
                                                return this.timebounds = {
                                                    minTime: r,
                                                    maxTime: n
                                                }, this;
                                            }
                                        },
                                        {
                                            key: "setLedgerbounds",
                                            value: function(e, t) {
                                                if (null !== this.ledgerbounds) throw new Error("LedgerBounds has been already set - setting ledgerbounds would overwrite it.");
                                                if (e < 0) throw new Error("min_ledger cannot be negative");
                                                if (t < 0) throw new Error("max_ledger cannot be negative");
                                                if (t > 0 && e > t) throw new Error("min_ledger cannot be greater than max_ledger");
                                                return this.ledgerbounds = {
                                                    minLedger: e,
                                                    maxLedger: t
                                                }, this;
                                            }
                                        },
                                        {
                                            key: "setMinAccountSequence",
                                            value: function(e) {
                                                if (null !== this.minAccountSequence) throw new Error("min_account_sequence has been already set - setting min_account_sequence would overwrite it.");
                                                return this.minAccountSequence = e, this;
                                            }
                                        },
                                        {
                                            key: "setMinAccountSequenceAge",
                                            value: function(e) {
                                                if ("number" != typeof e) throw new Error("min_account_sequence_age must be a number");
                                                if (null !== this.minAccountSequenceAge) throw new Error("min_account_sequence_age has been already set - setting min_account_sequence_age would overwrite it.");
                                                if (e < 0) throw new Error("min_account_sequence_age cannot be negative");
                                                return this.minAccountSequenceAge = e, this;
                                            }
                                        },
                                        {
                                            key: "setMinAccountSequenceLedgerGap",
                                            value: function(e) {
                                                if (null !== this.minAccountSequenceLedgerGap) throw new Error("min_account_sequence_ledger_gap has been already set - setting min_account_sequence_ledger_gap would overwrite it.");
                                                if (e < 0) throw new Error("min_account_sequence_ledger_gap cannot be negative");
                                                return this.minAccountSequenceLedgerGap = e, this;
                                            }
                                        },
                                        {
                                            key: "setExtraSigners",
                                            value: function(e) {
                                                if (!Array.isArray(e)) throw new Error("extra_signers must be an array of strings.");
                                                if (null !== this.extraSigners) throw new Error("extra_signers has been already set - setting extra_signers would overwrite it.");
                                                if (e.length > 2) throw new Error("extra_signers cannot be longer than 2 elements.");
                                                return this.extraSigners = hi(e), this;
                                            }
                                        },
                                        {
                                            key: "setNetworkPassphrase",
                                            value: function(e) {
                                                return this.networkPassphrase = e, this;
                                            }
                                        },
                                        {
                                            key: "setSorobanData",
                                            value: function(e) {
                                                return this.sorobanData = new io(e).build(), this;
                                            }
                                        },
                                        {
                                            key: "addSacTransferOperation",
                                            value: function(e, t, r, o) {
                                                if (BigInt(r) <= 0n) throw new Error("Amount must be a positive integer");
                                                if (BigInt(r) > n.Hyper.MAX_VALUE) throw new Error("Amount exceeds maximum value for i64");
                                                if (o) {
                                                    var a = o.instructions, s = o.readBytes, u = o.writeBytes, c = o.resourceFee, l = 4294967295;
                                                    if (a <= 0 || a > l) throw new Error("instructions must be greater than 0 and at most ".concat(l));
                                                    if (s <= 0 || s > l) throw new Error("readBytes must be greater than 0 and at most ".concat(l));
                                                    if (u <= 0 || u > l) throw new Error("writeBytes must be greater than 0 and at most ".concat(l));
                                                    if (c <= 0n || c > n.Hyper.MAX_VALUE) throw new Error("resourceFee must be greater than 0 and at most i64 max");
                                                }
                                                var f = Lt.isValidContract(e);
                                                if (!f && !Lt.isValidEd25519PublicKey(e) && !Lt.isValidMed25519PublicKey(e)) throw new Error("Invalid destination address. Must be a valid Stellar address or contract ID.");
                                                if (e === this.source.accountId()) throw new Error("Destination cannot be the same as the source account.");
                                                var p = t.contractId(this.networkPassphrase), d = "transfer", h = this.source.accountId(), y = [
                                                    fi(h, {
                                                        type: "address"
                                                    }),
                                                    fi(e, {
                                                        type: "address"
                                                    }),
                                                    fi(r, {
                                                        type: "i128"
                                                    })
                                                ], m = t.isNative(), g = new i.SorobanAuthorizationEntry({
                                                    credentials: i.SorobanCredentials.sorobanCredentialsSourceAccount(),
                                                    rootInvocation: new i.SorobanAuthorizedInvocation({
                                                        function: i.SorobanAuthorizedFunction.sorobanAuthorizedFunctionTypeContractFn(new i.InvokeContractArgs({
                                                            contractAddress: sn.fromString(p).toScAddress(),
                                                            functionName: d,
                                                            args: y
                                                        })),
                                                        subInvocations: []
                                                    })
                                                }), v = new i.LedgerFootprint({
                                                    readOnly: [
                                                        i.LedgerKey.contractData(new i.LedgerKeyContractData({
                                                            contract: sn.fromString(p).toScAddress(),
                                                            key: i.ScVal.scvLedgerKeyContractInstance(),
                                                            durability: i.ContractDataDurability.persistent()
                                                        }))
                                                    ],
                                                    readWrite: []
                                                });
                                                f ? (v.readWrite().push(i.LedgerKey.contractData(new i.LedgerKeyContractData({
                                                    contract: sn.fromString(p).toScAddress(),
                                                    key: i.ScVal.scvVec([
                                                        fi("Balance", {
                                                            type: "symbol"
                                                        }),
                                                        fi(e, {
                                                            type: "address"
                                                        })
                                                    ]),
                                                    durability: i.ContractDataDurability.persistent()
                                                }))), m || v.readOnly().push(i.LedgerKey.account(new i.LedgerKeyAccount({
                                                    accountId: Wt.fromPublicKey(t.getIssuer()).xdrPublicKey()
                                                })))) : m ? v.readWrite().push(i.LedgerKey.account(new i.LedgerKeyAccount({
                                                    accountId: Wt.fromPublicKey(e).xdrPublicKey()
                                                }))) : t.getIssuer() !== e && v.readWrite().push(i.LedgerKey.trustline(new i.LedgerKeyTrustLine({
                                                    accountId: Wt.fromPublicKey(e).xdrPublicKey(),
                                                    asset: t.toTrustLineXDRObject()
                                                }))), t.isNative() ? v.readWrite().push(i.LedgerKey.account(new i.LedgerKeyAccount({
                                                    accountId: Wt.fromPublicKey(h).xdrPublicKey()
                                                }))) : t.getIssuer() !== h && v.readWrite().push(i.LedgerKey.trustline(new i.LedgerKeyTrustLine({
                                                    accountId: Wt.fromPublicKey(h).xdrPublicKey(),
                                                    asset: t.toTrustLineXDRObject()
                                                })));
                                                var b = {
                                                    instructions: 4e5,
                                                    readBytes: 1e3,
                                                    writeBytes: 1e3,
                                                    resourceFee: BigInt(5e6)
                                                }, w = new i.SorobanTransactionData({
                                                    resources: new i.SorobanResources({
                                                        footprint: v,
                                                        instructions: o ? o.instructions : b.instructions,
                                                        diskReadBytes: o ? o.readBytes : b.readBytes,
                                                        writeBytes: o ? o.writeBytes : b.writeBytes
                                                    }),
                                                    ext: new i.SorobanTransactionDataExt(0),
                                                    resourceFee: new i.Int64(o ? o.resourceFee : b.resourceFee)
                                                }), S = vn.invokeContractFunction({
                                                    contract: p,
                                                    function: d,
                                                    args: y,
                                                    auth: [
                                                        g
                                                    ]
                                                });
                                                return this.setSorobanData(w), this.addOperation(S);
                                            }
                                        },
                                        {
                                            key: "build",
                                            value: function() {
                                                var e = new _r(this.source.sequenceNumber()).plus(1), t = {
                                                    fee: new _r(this.baseFee).times(this.operations.length).toNumber(),
                                                    seqNum: i.SequenceNumber.fromString(e.toString()),
                                                    memo: this.memo ? this.memo.toXDRObject() : null
                                                };
                                                if (null === this.timebounds || void 0 === this.timebounds.minTime || void 0 === this.timebounds.maxTime) throw new Error("TimeBounds has to be set or you must call setTimeout(TimeoutInfinite).");
                                                Ti(this.timebounds.minTime) && (this.timebounds.minTime = Math.floor(this.timebounds.minTime.getTime() / 1e3)), Ti(this.timebounds.maxTime) && (this.timebounds.maxTime = Math.floor(this.timebounds.maxTime.getTime() / 1e3)), this.timebounds.minTime = n.UnsignedHyper.fromString(this.timebounds.minTime.toString()), this.timebounds.maxTime = n.UnsignedHyper.fromString(this.timebounds.maxTime.toString());
                                                var r = new i.TimeBounds(this.timebounds);
                                                if (this.hasV2Preconditions()) {
                                                    var o = null;
                                                    null !== this.ledgerbounds && (o = new i.LedgerBounds(this.ledgerbounds));
                                                    var a = this.minAccountSequence || "0";
                                                    a = i.SequenceNumber.fromString(a);
                                                    var s = n.UnsignedHyper.fromString(null !== this.minAccountSequenceAge ? this.minAccountSequenceAge.toString() : "0"), u = this.minAccountSequenceLedgerGap || 0, c = null !== this.extraSigners ? this.extraSigners.map(co.decodeAddress) : [];
                                                    t.cond = i.Preconditions.precondV2(new i.PreconditionsV2({
                                                        timeBounds: r,
                                                        ledgerBounds: o,
                                                        minSeqNum: a,
                                                        minSeqAge: s,
                                                        minSeqLedgerGap: u,
                                                        extraSigners: c
                                                    }));
                                                } else t.cond = i.Preconditions.precondTime(r);
                                                t.sourceAccount = Wr(this.source.accountId()), this.sorobanData ? (t.ext = new i.TransactionExt(1, this.sorobanData), t.fee = new _r(t.fee).plus(this.sorobanData.resourceFee()).toNumber()) : t.ext = new i.TransactionExt(0, i.Void);
                                                var l = new i.Transaction(t);
                                                l.operations(this.operations);
                                                var f = new i.TransactionEnvelope.envelopeTypeTx(new i.TransactionV1Envelope({
                                                    tx: l
                                                })), p = new Fn(f, this.networkPassphrase);
                                                return this.source.incrementSequenceNumber(), p;
                                            }
                                        },
                                        {
                                            key: "hasV2Preconditions",
                                            value: function() {
                                                return null !== this.ledgerbounds || null !== this.minAccountSequence || null !== this.minAccountSequenceAge || null !== this.minAccountSequenceLedgerGap || null !== this.extraSigners && this.extraSigners.length > 0;
                                            }
                                        }
                                    ], [
                                        {
                                            key: "cloneFrom",
                                            value: function(t) {
                                                var r, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                                if (!(t instanceof Fn)) throw new TypeError("expected a 'Transaction', got: ".concat(t));
                                                var o, i = (BigInt(t.sequence) - 1n).toString();
                                                if (Lt.isValidMed25519PublicKey(t.source)) o = to.fromAddress(t.source, i);
                                                else {
                                                    if (!Lt.isValidEd25519PublicKey(t.source)) throw new TypeError("unsupported tx source account: ".concat(t.source));
                                                    o = new Yn(t.source, i);
                                                }
                                                var a = new e(o, gi({
                                                    fee: (Math.floor(parseInt(t.fee, 10) / t.operations.length) || Si).toString(),
                                                    memo: t.memo,
                                                    networkPassphrase: t.networkPassphrase,
                                                    timebounds: t.timeBounds,
                                                    ledgerbounds: t.ledgerBounds,
                                                    minAccountSequence: t.minAccountSequence,
                                                    minAccountSequenceAge: t.minAccountSequenceAge,
                                                    minAccountSequenceLedgerGap: t.minAccountSequenceLedgerGap,
                                                    extraSigners: null === (r = t.extraSigners) || void 0 === r ? void 0 : r.map(co.encodeSignerKey)
                                                }, n));
                                                return t._tx.operations().forEach(function(e) {
                                                    return a.addOperation(e);
                                                }), a;
                                            }
                                        },
                                        {
                                            key: "buildFeeBumpTransaction",
                                            value: function(e, t, r, n) {
                                                var o = r.operations.length, a = new _r(Si), s = new _r(0), u = r.toEnvelope();
                                                if (u.switch().value === i.EnvelopeType.envelopeTypeTx().value) {
                                                    var c, l = u.v1().tx().ext().value();
                                                    s = new _r(null !== (c = null == l ? void 0 : l.resourceFee()) && void 0 !== c ? c : 0);
                                                }
                                                var f = new _r(r.fee).minus(s).div(o), p = new _r(t);
                                                if (p.lt(f)) throw new Error("Invalid baseFee, it should be at least ".concat(f, " stroops."));
                                                if (p.lt(a)) throw new Error("Invalid baseFee, it should be at least ".concat(a, " stroops."));
                                                var d, h = r.toEnvelope();
                                                if (h.switch() === i.EnvelopeType.envelopeTypeTxV0()) {
                                                    var y = h.v0().tx(), m = new i.Transaction({
                                                        sourceAccount: new i.MuxedAccount.keyTypeEd25519(y.sourceAccountEd25519()),
                                                        fee: y.fee(),
                                                        seqNum: y.seqNum(),
                                                        cond: i.Preconditions.precondTime(y.timeBounds()),
                                                        memo: y.memo(),
                                                        operations: y.operations(),
                                                        ext: new i.TransactionExt(0)
                                                    });
                                                    h = new i.TransactionEnvelope.envelopeTypeTx(new i.TransactionV1Envelope({
                                                        tx: m,
                                                        signatures: h.v0().signatures()
                                                    }));
                                                }
                                                d = "string" == typeof e ? Wr(e) : e.xdrMuxedAccount();
                                                var g = new i.FeeBumpTransaction({
                                                    feeSource: d,
                                                    fee: i.Int64.fromString(p.times(o + 1).plus(s).toString()),
                                                    innerTx: i.FeeBumpTransactionInnerTx.envelopeTypeTx(h.v1()),
                                                    ext: new i.FeeBumpTransactionExt(0)
                                                }), v = new i.FeeBumpTransactionEnvelope({
                                                    tx: g,
                                                    signatures: []
                                                }), b = new i.TransactionEnvelope.envelopeTypeTxFeeBump(v);
                                                return new Xn(b, n);
                                            }
                                        },
                                        {
                                            key: "fromXDR",
                                            value: function(e, t) {
                                                return "string" == typeof e && (e = i.TransactionEnvelope.fromXDR(e, "base64")), e.switch() === i.EnvelopeType.envelopeTypeTxFeeBump() ? new Xn(e, t) : new Fn(e, t);
                                            }
                                        }
                                    ]);
                                }();
                                function Ti(e) {
                                    return e instanceof Date && !isNaN(e);
                                }
                                var Oi = {
                                    PUBLIC: "Public Global Stellar Network ; September 2015",
                                    TESTNET: "Test SDF Network ; September 2015",
                                    FUTURENET: "Test SDF Future Network ; October 2022",
                                    SANDBOX: "Local Sandbox Stellar Network ; September 2022",
                                    STANDALONE: "Standalone Network ; February 2017"
                                };
                                function ki(e) {
                                    return ki = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, ki(e);
                                }
                                function _i(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                                    return n;
                                }
                                function xi(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pi(n.key), n);
                                    }
                                }
                                function Pi(e) {
                                    var t = function(e) {
                                        if ("object" != ki(e) || !e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" != ki(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" == ki(t) ? t : t + "";
                                }
                                var Ri = function(e, t, r) {
                                    return r && xi(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }, 0, [
                                    {
                                        key: "formatTokenAmount",
                                        value: function(e, t) {
                                            if (e.includes(".")) throw new TypeError("No decimals are allowed");
                                            var r = e;
                                            return t > 0 && (r = t > r.length ? [
                                                "0",
                                                r.toString().padStart(t, "0")
                                            ].join(".") : [
                                                r.slice(0, -t),
                                                r.slice(-t)
                                            ].join(".")), r.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, ".0").replace(/^\./, "0.");
                                        }
                                    },
                                    {
                                        key: "parseTokenAmount",
                                        value: function(e, t) {
                                            var r, n = function(e) {
                                                return function(e) {
                                                    if (Array.isArray(e)) return e;
                                                }(e) || function(e) {
                                                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                                                }(e) || function(e, t) {
                                                    if (e) {
                                                        if ("string" == typeof e) return _i(e, t);
                                                        var r = ({}).toString.call(e).slice(8, -1);
                                                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _i(e, t) : void 0;
                                                    }
                                                }(e) || function() {
                                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }();
                                            }(e.split(".").slice()), o = n[0], i = n[1];
                                            if (_i(n).slice(2).length) throw new Error("Invalid decimal value: ".concat(e));
                                            if ((null == i ? void 0 : i.length) > t) throw new Error('Too many decimal places in "'.concat(e, '": expected at most ').concat(t, ", got ").concat(i.length));
                                            return BigInt(o + (null !== (r = null == i ? void 0 : i.padEnd(t, "0")) && void 0 !== r ? r : "0".repeat(t))).toString();
                                        }
                                    }
                                ]);
                                function Ii(e) {
                                    return Ii = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Ii(e);
                                }
                                function Bi(e, t) {
                                    var r = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var n = Object.getOwnPropertySymbols(e);
                                        t && (n = n.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), r.push.apply(r, n);
                                    }
                                    return r;
                                }
                                function Ci(e) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var r = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? Bi(Object(r), !0).forEach(function(t) {
                                            ji(e, t, r[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bi(Object(r)).forEach(function(t) {
                                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                        });
                                    }
                                    return e;
                                }
                                function ji(e, t, r) {
                                    return (t = function(e) {
                                        var t = function(e) {
                                            if ("object" != Ii(e) || !e) return e;
                                            var t = e[Symbol.toPrimitive];
                                            if (void 0 !== t) {
                                                var r = t.call(e, "string");
                                                if ("object" != Ii(r)) return r;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            return String(e);
                                        }(e);
                                        return "symbol" == Ii(t) ? t : t + "";
                                    }(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function Ui(e) {
                                    return e.map(function(e) {
                                        return e.inSuccessfulContractCall ? Ni(e.event()) : Ni(e);
                                    });
                                }
                                function Ni(e) {
                                    return Ci(Ci({}, "function" == typeof e.contractId && null != e.contractId() && {
                                        contractId: Lt.encodeContract(e.contractId())
                                    }), {}, {
                                        type: e.type().name,
                                        topics: e.body().value().topics().map(function(e) {
                                            return pi(e);
                                        }),
                                        data: pi(e.body().value().data())
                                    });
                                }
                                var Li = r(8287).Buffer;
                                function Fi() {
                                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                                    function i(r, n, o, i) {
                                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                                        return Di(c, "_invoke", function(r, n, o) {
                                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                                p: 0,
                                                n: 0,
                                                v: e,
                                                a: d,
                                                f: d.bind(e, 4),
                                                d: function(t, r) {
                                                    return i = t, s = 0, u = e, p.n = r, a;
                                                }
                                            };
                                            function d(r, n) {
                                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                                    var o, i = l[t], d = p.p, h = i[2];
                                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                                }
                                                if (o || r > 1) return a;
                                                throw f = !0, n;
                                            }
                                            return function(o, l, h) {
                                                if (c > 1) throw TypeError("Generator is already running");
                                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                                    try {
                                                        if (c = 2, i) {
                                                            if (s || (o = "next"), t = i[o]) {
                                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                                if (!t.done) return t;
                                                                u = t.value, s < 2 && (s = 0);
                                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                                            i = e;
                                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                                    } catch (t) {
                                                        i = e, s = 1, u = t;
                                                    } finally{
                                                        c = 1;
                                                    }
                                                }
                                                return {
                                                    value: t,
                                                    done: f
                                                };
                                            };
                                        }(r, o, i), !0), c;
                                    }
                                    var a = {};
                                    function s() {}
                                    function u() {}
                                    function c() {}
                                    t = Object.getPrototypeOf;
                                    var l = [][n] ? t(t([][n]())) : (Di(t = {}, n, function() {
                                        return this;
                                    }), t), f = c.prototype = s.prototype = Object.create(l);
                                    function p(e) {
                                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, Di(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                                    }
                                    return u.prototype = c, Di(f, "constructor", c), Di(c, "constructor", u), u.displayName = "GeneratorFunction", Di(c, o, "GeneratorFunction"), Di(f), Di(f, o, "Generator"), Di(f, n, function() {
                                        return this;
                                    }), Di(f, "toString", function() {
                                        return "[object Generator]";
                                    }), (Fi = function() {
                                        return {
                                            w: i,
                                            m: p
                                        };
                                    })();
                                }
                                function Di(e, t, r, n) {
                                    var o = Object.defineProperty;
                                    try {
                                        o({}, "", {});
                                    } catch (e) {
                                        o = 0;
                                    }
                                    Di = function(e, t, r, n) {
                                        function i(t, r) {
                                            Di(e, t, function(e) {
                                                return this._invoke(t, r, e);
                                            });
                                        }
                                        t ? o ? o(e, t, {
                                            value: r,
                                            enumerable: !n,
                                            configurable: !n,
                                            writable: !n
                                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                                    }, Di(e, t, r, n);
                                }
                                function Mi(e, t, r, n, o, i, a) {
                                    try {
                                        var s = e[i](a), u = s.value;
                                    } catch (e) {
                                        return void r(e);
                                    }
                                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                                }
                                function Vi(e, t, r) {
                                    return qi.apply(this, arguments);
                                }
                                function qi() {
                                    var e;
                                    return e = Fi().m(function e(t, r, n) {
                                        var o, a, s, c, l, f, p, d, h, y, m = arguments;
                                        return Fi().w(function(e) {
                                            for(;;)switch(e.n){
                                                case 0:
                                                    if (o = m.length > 3 && void 0 !== m[3] ? m[3] : Oi.FUTURENET, t.credentials().switch().value === i.SorobanCredentialsType.sorobanCredentialsAddress().value) {
                                                        e.n = 1;
                                                        break;
                                                    }
                                                    return e.a(2, t);
                                                case 1:
                                                    if (a = i.SorobanAuthorizationEntry.fromXDR(t.toXDR()), (s = a.credentials().address()).signatureExpirationLedger(n), c = u(Li.from(o)), l = i.HashIdPreimage.envelopeTypeSorobanAuthorization(new i.HashIdPreimageSorobanAuthorization({
                                                        networkId: c,
                                                        nonce: s.nonce(),
                                                        invocation: a.rootInvocation(),
                                                        signatureExpirationLedger: s.signatureExpirationLedger()
                                                    })), f = u(l.toXDR()), "function" != typeof r) {
                                                        e.n = 3;
                                                        break;
                                                    }
                                                    return e.n = 2, r(l);
                                                case 2:
                                                    null != (h = e.v) && h.signature ? (p = Li.from(h.signature), d = h.publicKey) : (p = Li.from(h), d = sn.fromScAddress(s.address()).toString()), e.n = 4;
                                                    break;
                                                case 3:
                                                    p = Li.from(r.sign(f)), d = r.publicKey();
                                                case 4:
                                                    if (Wt.fromPublicKey(d).verify(f, p)) {
                                                        e.n = 5;
                                                        break;
                                                    }
                                                    throw new Error("signature doesn't match payload");
                                                case 5:
                                                    return y = fi({
                                                        public_key: Lt.decodeEd25519PublicKey(d),
                                                        signature: p
                                                    }, {
                                                        type: {
                                                            public_key: [
                                                                "symbol",
                                                                null
                                                            ],
                                                            signature: [
                                                                "symbol",
                                                                null
                                                            ]
                                                        }
                                                    }), s.signature(i.ScVal.scvVec([
                                                        y
                                                    ])), e.a(2, a);
                                            }
                                        }, e);
                                    }), qi = function() {
                                        var t = this, r = arguments;
                                        return new Promise(function(n, o) {
                                            var i = e.apply(t, r);
                                            function a(e) {
                                                Mi(i, n, o, a, s, "next", e);
                                            }
                                            function s(e) {
                                                Mi(i, n, o, a, s, "throw", e);
                                            }
                                            a(void 0);
                                        });
                                    }, qi.apply(this, arguments);
                                }
                                function Gi(e, t, r) {
                                    var n, o, a, s, u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "", c = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : Oi.FUTURENET, l = Wt.random().rawPublicKey(), f = new i.Int64((o = (n = l.subarray(0, 8))[0] << 24 | n[1] << 16 | n[2] << 8 | n[3], a = n[4] << 24 | n[5] << 16 | n[6] << 8 | n[7], s = BigInt(o >>> 0) * BigInt(Math.pow(2, 32)) + BigInt(a >>> 0), BigInt.asIntN(64, s))), p = u || e.publicKey();
                                    if (!p) throw new Error("authorizeInvocation requires publicKey parameter");
                                    return Vi(new i.SorobanAuthorizationEntry({
                                        rootInvocation: r,
                                        credentials: i.SorobanCredentials.sorobanCredentialsAddress(new i.SorobanAddressCredentials({
                                            address: new sn(p).toScAddress(),
                                            nonce: f,
                                            signatureExpirationLedger: 0,
                                            signature: i.ScVal.scvVec([])
                                        }))
                                    }), e, t, c);
                                }
                                function Hi(e) {
                                    return Hi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, Hi(e);
                                }
                                function zi(e, t) {
                                    var r = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var n = Object.getOwnPropertySymbols(e);
                                        t && (n = n.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), r.push.apply(r, n);
                                    }
                                    return r;
                                }
                                function Wi(e, t, r) {
                                    return (t = function(e) {
                                        var t = function(e) {
                                            if ("object" != Hi(e) || !e) return e;
                                            var t = e[Symbol.toPrimitive];
                                            if (void 0 !== t) {
                                                var r = t.call(e, "string");
                                                if ("object" != Hi(r)) return r;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            return String(e);
                                        }(e);
                                        return "symbol" == Hi(t) ? t : t + "";
                                    }(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function Xi(e) {
                                    var t = e.function(), r = {}, n = t.value();
                                    switch(t.switch().value){
                                        case 0:
                                            r.type = "execute", r.args = {
                                                source: sn.fromScAddress(n.contractAddress()).toString(),
                                                function: n.functionName(),
                                                args: n.args().map(function(e) {
                                                    return pi(e);
                                                })
                                            };
                                            break;
                                        case 1:
                                        case 2:
                                            var o = 2 === t.switch().value;
                                            r.type = "create", r.args = {};
                                            var i = [
                                                n.executable(),
                                                n.contractIdPreimage()
                                            ], a = i[0], s = i[1];
                                            if (!!a.switch().value != !!s.switch().value) throw new Error("creation function appears invalid: ".concat(JSON.stringify(n), " (should be wasm+address or token+asset)"));
                                            switch(a.switch().value){
                                                case 0:
                                                    var u = s.fromAddress();
                                                    r.args.type = "wasm", r.args.wasm = function(e) {
                                                        for(var t = 1; t < arguments.length; t++){
                                                            var r = null != arguments[t] ? arguments[t] : {};
                                                            t % 2 ? zi(Object(r), !0).forEach(function(t) {
                                                                Wi(e, t, r[t]);
                                                            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zi(Object(r)).forEach(function(t) {
                                                                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                                            });
                                                        }
                                                        return e;
                                                    }({
                                                        salt: u.salt().toString("hex"),
                                                        hash: a.wasmHash().toString("hex"),
                                                        address: sn.fromScAddress(u.address()).toString()
                                                    }, o && {
                                                        constructorArgs: n.constructorArgs().map(function(e) {
                                                            return pi(e);
                                                        })
                                                    });
                                                    break;
                                                case 1:
                                                    r.args.type = "sac", r.args.asset = Yt.fromOperation(s.fromAsset()).toString();
                                                    break;
                                                default:
                                                    throw new Error("unknown creation type: ".concat(JSON.stringify(a)));
                                            }
                                            break;
                                        default:
                                            throw new Error("unknown invocation type (".concat(t.switch(), "): ").concat(JSON.stringify(t)));
                                    }
                                    return r.invocations = e.subInvocations().map(function(e) {
                                        return Xi(e);
                                    }), r;
                                }
                                function Ki(e, t) {
                                    Zi(e, 1, t);
                                }
                                function Zi(e, t, r, n) {
                                    !1 !== r(e, t, n) && e.subInvocations().forEach(function(n) {
                                        return Zi(n, t + 1, r, e);
                                    });
                                }
                                const $i = (e = r.hmd(e)).exports;
                            },
                            453 (e, t, r) {
                                "use strict";
                                var n, o = r(9612), i = r(9383), a = r(1237), s = r(9290), u = r(9538), c = r(8068), l = r(9675), f = r(5345), p = r(1514), d = r(8968), h = r(6188), y = r(8002), m = r(5880), g = r(414), v = r(3093), b = Function, w = function(e) {
                                    try {
                                        return b('"use strict"; return (' + e + ").constructor;")();
                                    } catch (e) {}
                                }, S = r(5795), A = r(655), E = function() {
                                    throw new l;
                                }, T = S ? function() {
                                    try {
                                        return E;
                                    } catch (e) {
                                        try {
                                            return S(arguments, "callee").get;
                                        } catch (e) {
                                            return E;
                                        }
                                    }
                                }() : E, O = r(4039)(), k = r(3628), _ = r(1064), x = r(8648), P = r(1002), R = r(76), I = {}, B = "undefined" != typeof Uint8Array && k ? k(Uint8Array) : n, C = {
                                    __proto__: null,
                                    "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
                                    "%Array%": Array,
                                    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
                                    "%ArrayIteratorPrototype%": O && k ? k([][Symbol.iterator]()) : n,
                                    "%AsyncFromSyncIteratorPrototype%": n,
                                    "%AsyncFunction%": I,
                                    "%AsyncGenerator%": I,
                                    "%AsyncGeneratorFunction%": I,
                                    "%AsyncIteratorPrototype%": I,
                                    "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
                                    "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
                                    "%BigInt64Array%": "undefined" == typeof BigInt64Array ? n : BigInt64Array,
                                    "%BigUint64Array%": "undefined" == typeof BigUint64Array ? n : BigUint64Array,
                                    "%Boolean%": Boolean,
                                    "%DataView%": "undefined" == typeof DataView ? n : DataView,
                                    "%Date%": Date,
                                    "%decodeURI%": decodeURI,
                                    "%decodeURIComponent%": decodeURIComponent,
                                    "%encodeURI%": encodeURI,
                                    "%encodeURIComponent%": encodeURIComponent,
                                    "%Error%": i,
                                    "%eval%": eval,
                                    "%EvalError%": a,
                                    "%Float16Array%": "undefined" == typeof Float16Array ? n : Float16Array,
                                    "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
                                    "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
                                    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
                                    "%Function%": b,
                                    "%GeneratorFunction%": I,
                                    "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
                                    "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
                                    "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
                                    "%isFinite%": isFinite,
                                    "%isNaN%": isNaN,
                                    "%IteratorPrototype%": O && k ? k(k([][Symbol.iterator]())) : n,
                                    "%JSON%": "object" == typeof JSON ? JSON : n,
                                    "%Map%": "undefined" == typeof Map ? n : Map,
                                    "%MapIteratorPrototype%": "undefined" != typeof Map && O && k ? k((new Map)[Symbol.iterator]()) : n,
                                    "%Math%": Math,
                                    "%Number%": Number,
                                    "%Object%": o,
                                    "%Object.getOwnPropertyDescriptor%": S,
                                    "%parseFloat%": parseFloat,
                                    "%parseInt%": parseInt,
                                    "%Promise%": "undefined" == typeof Promise ? n : Promise,
                                    "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
                                    "%RangeError%": s,
                                    "%ReferenceError%": u,
                                    "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
                                    "%RegExp%": RegExp,
                                    "%Set%": "undefined" == typeof Set ? n : Set,
                                    "%SetIteratorPrototype%": "undefined" != typeof Set && O && k ? k((new Set)[Symbol.iterator]()) : n,
                                    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                                    "%String%": String,
                                    "%StringIteratorPrototype%": O && k ? k(""[Symbol.iterator]()) : n,
                                    "%Symbol%": O ? Symbol : n,
                                    "%SyntaxError%": c,
                                    "%ThrowTypeError%": T,
                                    "%TypedArray%": B,
                                    "%TypeError%": l,
                                    "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
                                    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                                    "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
                                    "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
                                    "%URIError%": f,
                                    "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
                                    "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
                                    "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet,
                                    "%Function.prototype.call%": R,
                                    "%Function.prototype.apply%": P,
                                    "%Object.defineProperty%": A,
                                    "%Object.getPrototypeOf%": _,
                                    "%Math.abs%": p,
                                    "%Math.floor%": d,
                                    "%Math.max%": h,
                                    "%Math.min%": y,
                                    "%Math.pow%": m,
                                    "%Math.round%": g,
                                    "%Math.sign%": v,
                                    "%Reflect.getPrototypeOf%": x
                                };
                                if (k) try {
                                    null.error;
                                } catch (e) {
                                    var j = k(k(e));
                                    C["%Error.prototype%"] = j;
                                }
                                var U = function e(t) {
                                    var r;
                                    if ("%AsyncFunction%" === t) r = w("async function () {}");
                                    else if ("%GeneratorFunction%" === t) r = w("function* () {}");
                                    else if ("%AsyncGeneratorFunction%" === t) r = w("async function* () {}");
                                    else if ("%AsyncGenerator%" === t) {
                                        var n = e("%AsyncGeneratorFunction%");
                                        n && (r = n.prototype);
                                    } else if ("%AsyncIteratorPrototype%" === t) {
                                        var o = e("%AsyncGenerator%");
                                        o && k && (r = k(o.prototype));
                                    }
                                    return C[t] = r, r;
                                }, N = {
                                    __proto__: null,
                                    "%ArrayBufferPrototype%": [
                                        "ArrayBuffer",
                                        "prototype"
                                    ],
                                    "%ArrayPrototype%": [
                                        "Array",
                                        "prototype"
                                    ],
                                    "%ArrayProto_entries%": [
                                        "Array",
                                        "prototype",
                                        "entries"
                                    ],
                                    "%ArrayProto_forEach%": [
                                        "Array",
                                        "prototype",
                                        "forEach"
                                    ],
                                    "%ArrayProto_keys%": [
                                        "Array",
                                        "prototype",
                                        "keys"
                                    ],
                                    "%ArrayProto_values%": [
                                        "Array",
                                        "prototype",
                                        "values"
                                    ],
                                    "%AsyncFunctionPrototype%": [
                                        "AsyncFunction",
                                        "prototype"
                                    ],
                                    "%AsyncGenerator%": [
                                        "AsyncGeneratorFunction",
                                        "prototype"
                                    ],
                                    "%AsyncGeneratorPrototype%": [
                                        "AsyncGeneratorFunction",
                                        "prototype",
                                        "prototype"
                                    ],
                                    "%BooleanPrototype%": [
                                        "Boolean",
                                        "prototype"
                                    ],
                                    "%DataViewPrototype%": [
                                        "DataView",
                                        "prototype"
                                    ],
                                    "%DatePrototype%": [
                                        "Date",
                                        "prototype"
                                    ],
                                    "%ErrorPrototype%": [
                                        "Error",
                                        "prototype"
                                    ],
                                    "%EvalErrorPrototype%": [
                                        "EvalError",
                                        "prototype"
                                    ],
                                    "%Float32ArrayPrototype%": [
                                        "Float32Array",
                                        "prototype"
                                    ],
                                    "%Float64ArrayPrototype%": [
                                        "Float64Array",
                                        "prototype"
                                    ],
                                    "%FunctionPrototype%": [
                                        "Function",
                                        "prototype"
                                    ],
                                    "%Generator%": [
                                        "GeneratorFunction",
                                        "prototype"
                                    ],
                                    "%GeneratorPrototype%": [
                                        "GeneratorFunction",
                                        "prototype",
                                        "prototype"
                                    ],
                                    "%Int8ArrayPrototype%": [
                                        "Int8Array",
                                        "prototype"
                                    ],
                                    "%Int16ArrayPrototype%": [
                                        "Int16Array",
                                        "prototype"
                                    ],
                                    "%Int32ArrayPrototype%": [
                                        "Int32Array",
                                        "prototype"
                                    ],
                                    "%JSONParse%": [
                                        "JSON",
                                        "parse"
                                    ],
                                    "%JSONStringify%": [
                                        "JSON",
                                        "stringify"
                                    ],
                                    "%MapPrototype%": [
                                        "Map",
                                        "prototype"
                                    ],
                                    "%NumberPrototype%": [
                                        "Number",
                                        "prototype"
                                    ],
                                    "%ObjectPrototype%": [
                                        "Object",
                                        "prototype"
                                    ],
                                    "%ObjProto_toString%": [
                                        "Object",
                                        "prototype",
                                        "toString"
                                    ],
                                    "%ObjProto_valueOf%": [
                                        "Object",
                                        "prototype",
                                        "valueOf"
                                    ],
                                    "%PromisePrototype%": [
                                        "Promise",
                                        "prototype"
                                    ],
                                    "%PromiseProto_then%": [
                                        "Promise",
                                        "prototype",
                                        "then"
                                    ],
                                    "%Promise_all%": [
                                        "Promise",
                                        "all"
                                    ],
                                    "%Promise_reject%": [
                                        "Promise",
                                        "reject"
                                    ],
                                    "%Promise_resolve%": [
                                        "Promise",
                                        "resolve"
                                    ],
                                    "%RangeErrorPrototype%": [
                                        "RangeError",
                                        "prototype"
                                    ],
                                    "%ReferenceErrorPrototype%": [
                                        "ReferenceError",
                                        "prototype"
                                    ],
                                    "%RegExpPrototype%": [
                                        "RegExp",
                                        "prototype"
                                    ],
                                    "%SetPrototype%": [
                                        "Set",
                                        "prototype"
                                    ],
                                    "%SharedArrayBufferPrototype%": [
                                        "SharedArrayBuffer",
                                        "prototype"
                                    ],
                                    "%StringPrototype%": [
                                        "String",
                                        "prototype"
                                    ],
                                    "%SymbolPrototype%": [
                                        "Symbol",
                                        "prototype"
                                    ],
                                    "%SyntaxErrorPrototype%": [
                                        "SyntaxError",
                                        "prototype"
                                    ],
                                    "%TypedArrayPrototype%": [
                                        "TypedArray",
                                        "prototype"
                                    ],
                                    "%TypeErrorPrototype%": [
                                        "TypeError",
                                        "prototype"
                                    ],
                                    "%Uint8ArrayPrototype%": [
                                        "Uint8Array",
                                        "prototype"
                                    ],
                                    "%Uint8ClampedArrayPrototype%": [
                                        "Uint8ClampedArray",
                                        "prototype"
                                    ],
                                    "%Uint16ArrayPrototype%": [
                                        "Uint16Array",
                                        "prototype"
                                    ],
                                    "%Uint32ArrayPrototype%": [
                                        "Uint32Array",
                                        "prototype"
                                    ],
                                    "%URIErrorPrototype%": [
                                        "URIError",
                                        "prototype"
                                    ],
                                    "%WeakMapPrototype%": [
                                        "WeakMap",
                                        "prototype"
                                    ],
                                    "%WeakSetPrototype%": [
                                        "WeakSet",
                                        "prototype"
                                    ]
                                }, L = r(6743), F = r(9957), D = L.call(R, Array.prototype.concat), M = L.call(P, Array.prototype.splice), V = L.call(R, String.prototype.replace), q = L.call(R, String.prototype.slice), G = L.call(R, RegExp.prototype.exec), H = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, z = /\\(\\)?/g, W = function(e, t) {
                                    var r, n = e;
                                    if (F(N, n) && (n = "%" + (r = N[n])[0] + "%"), F(C, n)) {
                                        var o = C[n];
                                        if (o === I && (o = U(n)), void 0 === o && !t) throw new l("intrinsic " + e + " exists, but is not available. Please file an issue!");
                                        return {
                                            alias: r,
                                            name: n,
                                            value: o
                                        };
                                    }
                                    throw new c("intrinsic " + e + " does not exist!");
                                };
                                e.exports = function(e, t) {
                                    if ("string" != typeof e || 0 === e.length) throw new l("intrinsic name must be a non-empty string");
                                    if (arguments.length > 1 && "boolean" != typeof t) throw new l('"allowMissing" argument must be a boolean');
                                    if (null === G(/^%?[^%]*%?$/, e)) throw new c("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                                    var r = function(e) {
                                        var t = q(e, 0, 1), r = q(e, -1);
                                        if ("%" === t && "%" !== r) throw new c("invalid intrinsic syntax, expected closing `%`");
                                        if ("%" === r && "%" !== t) throw new c("invalid intrinsic syntax, expected opening `%`");
                                        var n = [];
                                        return V(e, H, function(e, t, r, o) {
                                            n[n.length] = r ? V(o, z, "$1") : t || e;
                                        }), n;
                                    }(e), n = r.length > 0 ? r[0] : "", o = W("%" + n + "%", t), i = o.name, a = o.value, s = !1, u = o.alias;
                                    u && (n = u[0], M(r, D([
                                        0,
                                        1
                                    ], u)));
                                    for(var f = 1, p = !0; f < r.length; f += 1){
                                        var d = r[f], h = q(d, 0, 1), y = q(d, -1);
                                        if (('"' === h || "'" === h || "`" === h || '"' === y || "'" === y || "`" === y) && h !== y) throw new c("property names with quotes must have matching quotes");
                                        if ("constructor" !== d && p || (s = !0), F(C, i = "%" + (n += "." + d) + "%")) a = C[i];
                                        else if (null != a) {
                                            if (!(d in a)) {
                                                if (!t) throw new l("base intrinsic for " + e + " exists, but the property is not available.");
                                                return;
                                            }
                                            if (S && f + 1 >= r.length) {
                                                var m = S(a, d);
                                                a = (p = !!m) && "get" in m && !("originalValue" in m.get) ? m.get : a[d];
                                            } else p = F(a, d), a = a[d];
                                            p && !s && (C[i] = a);
                                        }
                                    }
                                    return a;
                                };
                            },
                            487 (e, t, r) {
                                "use strict";
                                var n = r(6897), o = r(655), i = r(3126), a = r(2205);
                                e.exports = function(e) {
                                    var t = i(arguments), r = e.length - (arguments.length - 1);
                                    return n(t, 1 + (r > 0 ? r : 0), !0);
                                }, o ? o(e.exports, "apply", {
                                    value: a
                                }) : e.exports.apply = a;
                            },
                            537 (e, t, r) {
                                var n = r(5606), o = r(6763), i = Object.getOwnPropertyDescriptors || function(e) {
                                    for(var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
                                    return r;
                                }, a = /%[sdj%]/g;
                                t.format = function(e) {
                                    if (!w(e)) {
                                        for(var t = [], r = 0; r < arguments.length; r++)t.push(l(arguments[r]));
                                        return t.join(" ");
                                    }
                                    r = 1;
                                    for(var n = arguments, o = n.length, i = String(e).replace(a, function(e) {
                                        if ("%%" === e) return "%";
                                        if (r >= o) return e;
                                        switch(e){
                                            case "%s":
                                                return String(n[r++]);
                                            case "%d":
                                                return Number(n[r++]);
                                            case "%j":
                                                try {
                                                    return JSON.stringify(n[r++]);
                                                } catch (e) {
                                                    return "[Circular]";
                                                }
                                            default:
                                                return e;
                                        }
                                    }), s = n[r]; r < o; s = n[++r])v(s) || !E(s) ? i += " " + s : i += " " + l(s);
                                    return i;
                                }, t.deprecate = function(e, r) {
                                    if (void 0 !== n && !0 === n.noDeprecation) return e;
                                    if (void 0 === n) return function() {
                                        return t.deprecate(e, r).apply(this, arguments);
                                    };
                                    var i = !1;
                                    return function() {
                                        if (!i) {
                                            if (n.throwDeprecation) throw new Error(r);
                                            n.traceDeprecation ? o.trace(r) : o.error(r), i = !0;
                                        }
                                        return e.apply(this, arguments);
                                    };
                                };
                                var s = {}, u = /^$/;
                                if (n.env.NODE_DEBUG) {
                                    var c = n.env.NODE_DEBUG;
                                    c = c.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), u = new RegExp("^" + c + "$", "i");
                                }
                                function l(e, r) {
                                    var n = {
                                        seen: [],
                                        stylize: p
                                    };
                                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), g(r) ? n.showHidden = r : r && t._extend(n, r), S(n.showHidden) && (n.showHidden = !1), S(n.depth) && (n.depth = 2), S(n.colors) && (n.colors = !1), S(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = f), d(n, e, n.depth);
                                }
                                function f(e, t) {
                                    var r = l.styles[t];
                                    return r ? "\x1b[" + l.colors[r][0] + "m" + e + "\x1b[" + l.colors[r][1] + "m" : e;
                                }
                                function p(e, t) {
                                    return e;
                                }
                                function d(e, r, n) {
                                    if (e.customInspect && r && k(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                                        var o = r.inspect(n, e);
                                        return w(o) || (o = d(e, o, n)), o;
                                    }
                                    var i = function(e, t) {
                                        if (S(t)) return e.stylize("undefined", "undefined");
                                        if (w(t)) {
                                            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                            return e.stylize(r, "string");
                                        }
                                        return b(t) ? e.stylize("" + t, "number") : g(t) ? e.stylize("" + t, "boolean") : v(t) ? e.stylize("null", "null") : void 0;
                                    }(e, r);
                                    if (i) return i;
                                    var a = Object.keys(r), s = function(e) {
                                        var t = {};
                                        return e.forEach(function(e, r) {
                                            t[e] = !0;
                                        }), t;
                                    }(a);
                                    if (e.showHidden && (a = Object.getOwnPropertyNames(r)), O(r) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return h(r);
                                    if (0 === a.length) {
                                        if (k(r)) {
                                            var u = r.name ? ": " + r.name : "";
                                            return e.stylize("[Function" + u + "]", "special");
                                        }
                                        if (A(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
                                        if (T(r)) return e.stylize(Date.prototype.toString.call(r), "date");
                                        if (O(r)) return h(r);
                                    }
                                    var c, l = "", f = !1, p = [
                                        "{",
                                        "}"
                                    ];
                                    return m(r) && (f = !0, p = [
                                        "[",
                                        "]"
                                    ]), k(r) && (l = " [Function" + (r.name ? ": " + r.name : "") + "]"), A(r) && (l = " " + RegExp.prototype.toString.call(r)), T(r) && (l = " " + Date.prototype.toUTCString.call(r)), O(r) && (l = " " + h(r)), 0 !== a.length || f && 0 != r.length ? n < 0 ? A(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), c = f ? function(e, t, r, n, o) {
                                        for(var i = [], a = 0, s = t.length; a < s; ++a)R(t, String(a)) ? i.push(y(e, t, r, n, String(a), !0)) : i.push("");
                                        return o.forEach(function(o) {
                                            o.match(/^\d+$/) || i.push(y(e, t, r, n, o, !0));
                                        }), i;
                                    }(e, r, n, s, a) : a.map(function(t) {
                                        return y(e, r, n, s, t, f);
                                    }), e.seen.pop(), function(e, t, r) {
                                        var n = e.reduce(function(e, t) {
                                            return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                        }, 0);
                                        return n > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
                                    }(c, l, p)) : p[0] + l + p[1];
                                }
                                function h(e) {
                                    return "[" + Error.prototype.toString.call(e) + "]";
                                }
                                function y(e, t, r, n, o, i) {
                                    var a, s, u;
                                    if ((u = Object.getOwnPropertyDescriptor(t, o) || {
                                        value: t[o]
                                    }).get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), R(n, o) || (a = "[" + o + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = v(r) ? d(e, u.value, null) : d(e, u.value, r - 1)).indexOf("\n") > -1 && (s = i ? s.split("\n").map(function(e) {
                                        return "  " + e;
                                    }).join("\n").slice(2) : "\n" + s.split("\n").map(function(e) {
                                        return "   " + e;
                                    }).join("\n")) : s = e.stylize("[Circular]", "special")), S(a)) {
                                        if (i && o.match(/^\d+$/)) return s;
                                        (a = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.slice(1, -1), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
                                    }
                                    return a + ": " + s;
                                }
                                function m(e) {
                                    return Array.isArray(e);
                                }
                                function g(e) {
                                    return "boolean" == typeof e;
                                }
                                function v(e) {
                                    return null === e;
                                }
                                function b(e) {
                                    return "number" == typeof e;
                                }
                                function w(e) {
                                    return "string" == typeof e;
                                }
                                function S(e) {
                                    return void 0 === e;
                                }
                                function A(e) {
                                    return E(e) && "[object RegExp]" === _(e);
                                }
                                function E(e) {
                                    return "object" == typeof e && null !== e;
                                }
                                function T(e) {
                                    return E(e) && "[object Date]" === _(e);
                                }
                                function O(e) {
                                    return E(e) && ("[object Error]" === _(e) || e instanceof Error);
                                }
                                function k(e) {
                                    return "function" == typeof e;
                                }
                                function _(e) {
                                    return Object.prototype.toString.call(e);
                                }
                                function x(e) {
                                    return e < 10 ? "0" + e.toString(10) : e.toString(10);
                                }
                                t.debuglog = function(e) {
                                    if (e = e.toUpperCase(), !s[e]) {
                                        if (u.test(e)) {
                                            var r = n.pid;
                                            s[e] = function() {
                                                var n = t.format.apply(t, arguments);
                                                o.error("%s %d: %s", e, r, n);
                                            };
                                        } else s[e] = function() {};
                                    }
                                    return s[e];
                                }, t.inspect = l, l.colors = {
                                    bold: [
                                        1,
                                        22
                                    ],
                                    italic: [
                                        3,
                                        23
                                    ],
                                    underline: [
                                        4,
                                        24
                                    ],
                                    inverse: [
                                        7,
                                        27
                                    ],
                                    white: [
                                        37,
                                        39
                                    ],
                                    grey: [
                                        90,
                                        39
                                    ],
                                    black: [
                                        30,
                                        39
                                    ],
                                    blue: [
                                        34,
                                        39
                                    ],
                                    cyan: [
                                        36,
                                        39
                                    ],
                                    green: [
                                        32,
                                        39
                                    ],
                                    magenta: [
                                        35,
                                        39
                                    ],
                                    red: [
                                        31,
                                        39
                                    ],
                                    yellow: [
                                        33,
                                        39
                                    ]
                                }, l.styles = {
                                    special: "cyan",
                                    number: "yellow",
                                    boolean: "yellow",
                                    undefined: "grey",
                                    null: "bold",
                                    string: "green",
                                    date: "magenta",
                                    regexp: "red"
                                }, t.types = r(9032), t.isArray = m, t.isBoolean = g, t.isNull = v, t.isNullOrUndefined = function(e) {
                                    return null == e;
                                }, t.isNumber = b, t.isString = w, t.isSymbol = function(e) {
                                    return "symbol" == typeof e;
                                }, t.isUndefined = S, t.isRegExp = A, t.types.isRegExp = A, t.isObject = E, t.isDate = T, t.types.isDate = T, t.isError = O, t.types.isNativeError = O, t.isFunction = k, t.isPrimitive = function(e) {
                                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                                }, t.isBuffer = r(1135);
                                var P = [
                                    "Jan",
                                    "Feb",
                                    "Mar",
                                    "Apr",
                                    "May",
                                    "Jun",
                                    "Jul",
                                    "Aug",
                                    "Sep",
                                    "Oct",
                                    "Nov",
                                    "Dec"
                                ];
                                function R(e, t) {
                                    return Object.prototype.hasOwnProperty.call(e, t);
                                }
                                t.log = function() {
                                    var e, r;
                                    o.log("%s - %s", (r = [
                                        x((e = new Date).getHours()),
                                        x(e.getMinutes()),
                                        x(e.getSeconds())
                                    ].join(":"), [
                                        e.getDate(),
                                        P[e.getMonth()],
                                        r
                                    ].join(" ")), t.format.apply(t, arguments));
                                }, t.inherits = r(6698), t._extend = function(e, t) {
                                    if (!t || !E(t)) return e;
                                    for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                                    return e;
                                };
                                var I = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
                                function B(e, t) {
                                    if (!e) {
                                        var r = new Error("Promise was rejected with a falsy value");
                                        r.reason = e, e = r;
                                    }
                                    return t(e);
                                }
                                t.promisify = function(e) {
                                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                                    if (I && e[I]) {
                                        var t;
                                        if ("function" != typeof (t = e[I])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                                        return Object.defineProperty(t, I, {
                                            value: t,
                                            enumerable: !1,
                                            writable: !1,
                                            configurable: !0
                                        }), t;
                                    }
                                    function t() {
                                        for(var t, r, n = new Promise(function(e, n) {
                                            t = e, r = n;
                                        }), o = [], i = 0; i < arguments.length; i++)o.push(arguments[i]);
                                        o.push(function(e, n) {
                                            e ? r(e) : t(n);
                                        });
                                        try {
                                            e.apply(this, o);
                                        } catch (e) {
                                            r(e);
                                        }
                                        return n;
                                    }
                                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), I && Object.defineProperty(t, I, {
                                        value: t,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }), Object.defineProperties(t, i(e));
                                }, t.promisify.custom = I, t.callbackify = function(e) {
                                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                                    function t() {
                                        for(var t = [], r = 0; r < arguments.length; r++)t.push(arguments[r]);
                                        var o = t.pop();
                                        if ("function" != typeof o) throw new TypeError("The last argument must be of type Function");
                                        var i = this, a = function() {
                                            return o.apply(i, arguments);
                                        };
                                        e.apply(this, t).then(function(e) {
                                            n.nextTick(a.bind(null, null, e));
                                        }, function(e) {
                                            n.nextTick(B.bind(null, e, a));
                                        });
                                    }
                                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, i(e)), t;
                                };
                            },
                            592 (e, t, r) {
                                "use strict";
                                var n = r(655), o = function() {
                                    return !!n;
                                };
                                o.hasArrayLengthDefineBug = function() {
                                    if (!n) return null;
                                    try {
                                        return 1 !== n([], "length", {
                                            value: 1
                                        }).length;
                                    } catch (e) {
                                        return !0;
                                    }
                                }, e.exports = o;
                            },
                            655 (e) {
                                "use strict";
                                var t = Object.defineProperty || !1;
                                if (t) try {
                                    t({}, "a", {
                                        value: 1
                                    });
                                } catch (e) {
                                    t = !1;
                                }
                                e.exports = t;
                            },
                            1002 (e) {
                                "use strict";
                                e.exports = Function.prototype.apply;
                            },
                            1064 (e, t, r) {
                                "use strict";
                                var n = r(9612);
                                e.exports = n.getPrototypeOf || null;
                            },
                            1093 (e) {
                                "use strict";
                                var t = Object.prototype.toString;
                                e.exports = function(e) {
                                    var r = t.call(e), n = "[object Arguments]" === r;
                                    return n || (n = "[object Array]" !== r && null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Function]" === t.call(e.callee)), n;
                                };
                            },
                            1135 (e) {
                                e.exports = function(e) {
                                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                                };
                            },
                            1189 (e, t, r) {
                                "use strict";
                                var n = Array.prototype.slice, o = r(1093), i = Object.keys, a = i ? function(e) {
                                    return i(e);
                                } : r(8875), s = Object.keys;
                                a.shim = function() {
                                    if (Object.keys) {
                                        var e = function() {
                                            var e = Object.keys(arguments);
                                            return e && e.length === arguments.length;
                                        }(1, 2);
                                        e || (Object.keys = function(e) {
                                            return o(e) ? s(n.call(e)) : s(e);
                                        });
                                    } else Object.keys = a;
                                    return Object.keys || a;
                                }, e.exports = a;
                            },
                            1237 (e) {
                                "use strict";
                                e.exports = EvalError;
                            },
                            1333 (e) {
                                "use strict";
                                e.exports = function() {
                                    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                                    if ("symbol" == typeof Symbol.iterator) return !0;
                                    var e = {}, t = Symbol("test"), r = Object(t);
                                    if ("string" == typeof t) return !1;
                                    if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
                                    if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                                    for(var n in e[t] = 42, e)return !1;
                                    if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
                                    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
                                    var o = Object.getOwnPropertySymbols(e);
                                    if (1 !== o.length || o[0] !== t) return !1;
                                    if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
                                    if ("function" == typeof Object.getOwnPropertyDescriptor) {
                                        var i = Object.getOwnPropertyDescriptor(e, t);
                                        if (42 !== i.value || !0 !== i.enumerable) return !1;
                                    }
                                    return !0;
                                };
                            },
                            1514 (e) {
                                "use strict";
                                e.exports = Math.abs;
                            },
                            2205 (e, t, r) {
                                "use strict";
                                var n = r(6743), o = r(1002), i = r(3144);
                                e.exports = function() {
                                    return i(n, o, arguments);
                                };
                            },
                            2299 (e, t, r) {
                                "use strict";
                                function n(e, t) {
                                    return function(e) {
                                        if (Array.isArray(e)) return e;
                                    }(e) || function(e, t) {
                                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                        if (null != r) {
                                            var n, o, i, a, s = [], u = !0, c = !1;
                                            try {
                                                if (i = (r = r.call(e)).next, 0 === t) {
                                                    if (Object(r) !== r) return;
                                                    u = !1;
                                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                                            } catch (e) {
                                                c = !0, o = e;
                                            } finally{
                                                try {
                                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                                } finally{
                                                    if (c) throw o;
                                                }
                                            }
                                            return s;
                                        }
                                    }(e, t) || function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return o(e, t);
                                            var r = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(e, t) : void 0;
                                        }
                                    }(e, t) || function() {
                                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }
                                function o(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                                    return n;
                                }
                                function i(e) {
                                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, i(e);
                                }
                                var a = void 0 !== /a/g.flags, s = function(e) {
                                    var t = [];
                                    return e.forEach(function(e) {
                                        return t.push(e);
                                    }), t;
                                }, u = function(e) {
                                    var t = [];
                                    return e.forEach(function(e, r) {
                                        return t.push([
                                            r,
                                            e
                                        ]);
                                    }), t;
                                }, c = Object.is ? Object.is : r(7653), l = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                                    return [];
                                }, f = Number.isNaN ? Number.isNaN : r(4133);
                                function p(e) {
                                    return e.call.bind(e);
                                }
                                var d = p(Object.prototype.hasOwnProperty), h = p(Object.prototype.propertyIsEnumerable), y = p(Object.prototype.toString), m = r(537).types, g = m.isAnyArrayBuffer, v = m.isArrayBufferView, b = m.isDate, w = m.isMap, S = m.isRegExp, A = m.isSet, E = m.isNativeError, T = m.isBoxedPrimitive, O = m.isNumberObject, k = m.isStringObject, _ = m.isBooleanObject, x = m.isBigIntObject, P = m.isSymbolObject, R = m.isFloat32Array, I = m.isFloat64Array;
                                function B(e) {
                                    if (0 === e.length || e.length > 10) return !0;
                                    for(var t = 0; t < e.length; t++){
                                        var r = e.charCodeAt(t);
                                        if (r < 48 || r > 57) return !0;
                                    }
                                    return 10 === e.length && e >= Math.pow(2, 32);
                                }
                                function C(e) {
                                    return Object.keys(e).filter(B).concat(l(e).filter(Object.prototype.propertyIsEnumerable.bind(e)));
                                }
                                function j(e, t) {
                                    if (e === t) return 0;
                                    for(var r = e.length, n = t.length, o = 0, i = Math.min(r, n); o < i; ++o)if (e[o] !== t[o]) {
                                        r = e[o], n = t[o];
                                        break;
                                    }
                                    return r < n ? -1 : n < r ? 1 : 0;
                                }
                                function U(e, t, r, n) {
                                    if (e === t) return 0 !== e || !r || c(e, t);
                                    if (r) {
                                        if ("object" !== i(e)) return "number" == typeof e && f(e) && f(t);
                                        if ("object" !== i(t) || null === e || null === t) return !1;
                                        if (Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
                                    } else {
                                        if (null === e || "object" !== i(e)) return (null === t || "object" !== i(t)) && e == t;
                                        if (null === t || "object" !== i(t)) return !1;
                                    }
                                    var o, s, u, l, p = y(e);
                                    if (p !== y(t)) return !1;
                                    if (Array.isArray(e)) {
                                        if (e.length !== t.length) return !1;
                                        var d = C(e), h = C(t);
                                        return d.length === h.length && L(e, t, r, n, 1, d);
                                    }
                                    if ("[object Object]" === p && (!w(e) && w(t) || !A(e) && A(t))) return !1;
                                    if (b(e)) {
                                        if (!b(t) || Date.prototype.getTime.call(e) !== Date.prototype.getTime.call(t)) return !1;
                                    } else if (S(e)) {
                                        if (!S(t) || (u = e, l = t, !(a ? u.source === l.source && u.flags === l.flags : RegExp.prototype.toString.call(u) === RegExp.prototype.toString.call(l)))) return !1;
                                    } else if (E(e) || e instanceof Error) {
                                        if (e.message !== t.message || e.name !== t.name) return !1;
                                    } else {
                                        if (v(e)) {
                                            if (r || !R(e) && !I(e)) {
                                                if (!function(e, t) {
                                                    return e.byteLength === t.byteLength && 0 === j(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
                                                }(e, t)) return !1;
                                            } else if (!function(e, t) {
                                                if (e.byteLength !== t.byteLength) return !1;
                                                for(var r = 0; r < e.byteLength; r++)if (e[r] !== t[r]) return !1;
                                                return !0;
                                            }(e, t)) return !1;
                                            var m = C(e), B = C(t);
                                            return m.length === B.length && L(e, t, r, n, 0, m);
                                        }
                                        if (A(e)) return !(!A(t) || e.size !== t.size) && L(e, t, r, n, 2);
                                        if (w(e)) return !(!w(t) || e.size !== t.size) && L(e, t, r, n, 3);
                                        if (g(e)) {
                                            if (s = t, (o = e).byteLength !== s.byteLength || 0 !== j(new Uint8Array(o), new Uint8Array(s))) return !1;
                                        } else if (T(e) && !function(e, t) {
                                            return O(e) ? O(t) && c(Number.prototype.valueOf.call(e), Number.prototype.valueOf.call(t)) : k(e) ? k(t) && String.prototype.valueOf.call(e) === String.prototype.valueOf.call(t) : _(e) ? _(t) && Boolean.prototype.valueOf.call(e) === Boolean.prototype.valueOf.call(t) : x(e) ? x(t) && BigInt.prototype.valueOf.call(e) === BigInt.prototype.valueOf.call(t) : P(t) && Symbol.prototype.valueOf.call(e) === Symbol.prototype.valueOf.call(t);
                                        }(e, t)) return !1;
                                    }
                                    return L(e, t, r, n, 0);
                                }
                                function N(e, t) {
                                    return t.filter(function(t) {
                                        return h(e, t);
                                    });
                                }
                                function L(e, t, r, o, a, c) {
                                    if (5 === arguments.length) {
                                        c = Object.keys(e);
                                        var f = Object.keys(t);
                                        if (c.length !== f.length) return !1;
                                    }
                                    for(var p = 0; p < c.length; p++)if (!d(t, c[p])) return !1;
                                    if (r && 5 === arguments.length) {
                                        var y = l(e);
                                        if (0 !== y.length) {
                                            var m = 0;
                                            for(p = 0; p < y.length; p++){
                                                var g = y[p];
                                                if (h(e, g)) {
                                                    if (!h(t, g)) return !1;
                                                    c.push(g), m++;
                                                } else if (h(t, g)) return !1;
                                            }
                                            var v = l(t);
                                            if (y.length !== v.length && N(t, v).length !== m) return !1;
                                        } else {
                                            var b = l(t);
                                            if (0 !== b.length && 0 !== N(t, b).length) return !1;
                                        }
                                    }
                                    if (0 === c.length && (0 === a || 1 === a && 0 === e.length || 0 === e.size)) return !0;
                                    if (void 0 === o) o = {
                                        val1: new Map,
                                        val2: new Map,
                                        position: 0
                                    };
                                    else {
                                        var w = o.val1.get(e);
                                        if (void 0 !== w) {
                                            var S = o.val2.get(t);
                                            if (void 0 !== S) return w === S;
                                        }
                                        o.position++;
                                    }
                                    o.val1.set(e, o.position), o.val2.set(t, o.position);
                                    var A = function(e, t, r, o, a, c) {
                                        var l = 0;
                                        if (2 === c) {
                                            if (!function(e, t, r, n) {
                                                for(var o = null, a = s(e), u = 0; u < a.length; u++){
                                                    var c = a[u];
                                                    if ("object" === i(c) && null !== c) null === o && (o = new Set), o.add(c);
                                                    else if (!t.has(c)) {
                                                        if (r) return !1;
                                                        if (!M(e, t, c)) return !1;
                                                        null === o && (o = new Set), o.add(c);
                                                    }
                                                }
                                                if (null !== o) {
                                                    for(var l = s(t), f = 0; f < l.length; f++){
                                                        var p = l[f];
                                                        if ("object" === i(p) && null !== p) {
                                                            if (!F(o, p, r, n)) return !1;
                                                        } else if (!r && !e.has(p) && !F(o, p, r, n)) return !1;
                                                    }
                                                    return 0 === o.size;
                                                }
                                                return !0;
                                            }(e, t, r, a)) return !1;
                                        } else if (3 === c) {
                                            if (!function(e, t, r, o) {
                                                for(var a = null, s = u(e), c = 0; c < s.length; c++){
                                                    var l = n(s[c], 2), f = l[0], p = l[1];
                                                    if ("object" === i(f) && null !== f) null === a && (a = new Set), a.add(f);
                                                    else {
                                                        var d = t.get(f);
                                                        if (void 0 === d && !t.has(f) || !U(p, d, r, o)) {
                                                            if (r) return !1;
                                                            if (!V(e, t, f, p, o)) return !1;
                                                            null === a && (a = new Set), a.add(f);
                                                        }
                                                    }
                                                }
                                                if (null !== a) {
                                                    for(var h = u(t), y = 0; y < h.length; y++){
                                                        var m = n(h[y], 2), g = m[0], v = m[1];
                                                        if ("object" === i(g) && null !== g) {
                                                            if (!q(a, e, g, v, r, o)) return !1;
                                                        } else if (!(r || e.has(g) && U(e.get(g), v, !1, o) || q(a, e, g, v, !1, o))) return !1;
                                                    }
                                                    return 0 === a.size;
                                                }
                                                return !0;
                                            }(e, t, r, a)) return !1;
                                        } else if (1 === c) for(; l < e.length; l++){
                                            if (!d(e, l)) {
                                                if (d(t, l)) return !1;
                                                for(var f = Object.keys(e); l < f.length; l++){
                                                    var p = f[l];
                                                    if (!d(t, p) || !U(e[p], t[p], r, a)) return !1;
                                                }
                                                return f.length === Object.keys(t).length;
                                            }
                                            if (!d(t, l) || !U(e[l], t[l], r, a)) return !1;
                                        }
                                        for(l = 0; l < o.length; l++){
                                            var h = o[l];
                                            if (!U(e[h], t[h], r, a)) return !1;
                                        }
                                        return !0;
                                    }(e, t, r, c, o, a);
                                    return o.val1.delete(e), o.val2.delete(t), A;
                                }
                                function F(e, t, r, n) {
                                    for(var o = s(e), i = 0; i < o.length; i++){
                                        var a = o[i];
                                        if (U(t, a, r, n)) return e.delete(a), !0;
                                    }
                                    return !1;
                                }
                                function D(e) {
                                    switch(i(e)){
                                        case "undefined":
                                            return null;
                                        case "object":
                                            return;
                                        case "symbol":
                                            return !1;
                                        case "string":
                                            e = +e;
                                        case "number":
                                            if (f(e)) return !1;
                                    }
                                    return !0;
                                }
                                function M(e, t, r) {
                                    var n = D(r);
                                    return null != n ? n : t.has(n) && !e.has(n);
                                }
                                function V(e, t, r, n, o) {
                                    var i = D(r);
                                    if (null != i) return i;
                                    var a = t.get(i);
                                    return !(void 0 === a && !t.has(i) || !U(n, a, !1, o)) && !e.has(i) && U(n, a, !1, o);
                                }
                                function q(e, t, r, n, o, i) {
                                    for(var a = s(e), u = 0; u < a.length; u++){
                                        var c = a[u];
                                        if (U(r, c, o, i) && U(n, t.get(c), o, i)) return e.delete(c), !0;
                                    }
                                    return !1;
                                }
                                e.exports = {
                                    isDeepEqual: function(e, t) {
                                        return U(e, t, !1);
                                    },
                                    isDeepStrictEqual: function(e, t) {
                                        return U(e, t, !0);
                                    }
                                };
                            },
                            2464 (e, t, r) {
                                "use strict";
                                var n = r(8452), o = r(6642);
                                e.exports = function() {
                                    var e = o();
                                    return n(Number, {
                                        isNaN: e
                                    }, {
                                        isNaN: function() {
                                            return Number.isNaN !== e;
                                        }
                                    }), e;
                                };
                            },
                            2682 (e, t, r) {
                                "use strict";
                                var n = r(9600), o = Object.prototype.toString, i = Object.prototype.hasOwnProperty;
                                e.exports = function(e, t, r) {
                                    if (!n(t)) throw new TypeError("iterator must be a function");
                                    var a, s;
                                    arguments.length >= 3 && (a = r), s = e, "[object Array]" === o.call(s) ? function(e, t, r) {
                                        for(var n = 0, o = e.length; n < o; n++)i.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                                    }(e, t, a) : "string" == typeof e ? function(e, t, r) {
                                        for(var n = 0, o = e.length; n < o; n++)null == r ? t(e.charAt(n), n, e) : t.call(r, e.charAt(n), n, e);
                                    }(e, t, a) : function(e, t, r) {
                                        for(var n in e)i.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                                    }(e, t, a);
                                };
                            },
                            2802 (e, t, r) {
                                "use strict";
                                e.exports = function(t) {
                                    var r = t.toLowerCase(), n = e.exports[r];
                                    if (!n) throw new Error(r + " is not supported (we accept pull requests)");
                                    return new n;
                                }, e.exports.sha = r(7816), e.exports.sha1 = r(3737), e.exports.sha224 = r(6710), e.exports.sha256 = r(4107), e.exports.sha384 = r(2827), e.exports.sha512 = r(2890);
                            },
                            2827 (e, t, r) {
                                "use strict";
                                var n = r(6698), o = r(2890), i = r(392), a = r(2861).Buffer, s = new Array(160);
                                function u() {
                                    this.init(), this._w = s, i.call(this, 128, 112);
                                }
                                n(u, o), u.prototype.init = function() {
                                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                                }, u.prototype._hash = function() {
                                    var e = a.allocUnsafe(48);
                                    function t(t, r, n) {
                                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                                    }
                                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                                }, e.exports = u;
                            },
                            2861 (e, t, r) {
                                var n = r(8287), o = n.Buffer;
                                function i(e, t) {
                                    for(var r in e)t[r] = e[r];
                                }
                                function a(e, t, r) {
                                    return o(e, t, r);
                                }
                                o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = a), a.prototype = Object.create(o.prototype), i(o, a), a.from = function(e, t, r) {
                                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                                    return o(e, t, r);
                                }, a.alloc = function(e, t, r) {
                                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                                    var n = o(e);
                                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                                }, a.allocUnsafe = function(e) {
                                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                                    return o(e);
                                }, a.allocUnsafeSlow = function(e) {
                                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                                    return n.SlowBuffer(e);
                                };
                            },
                            2890 (e, t, r) {
                                "use strict";
                                var n = r(6698), o = r(392), i = r(2861).Buffer, a = [
                                    1116352408,
                                    3609767458,
                                    1899447441,
                                    602891725,
                                    3049323471,
                                    3964484399,
                                    3921009573,
                                    2173295548,
                                    961987163,
                                    4081628472,
                                    1508970993,
                                    3053834265,
                                    2453635748,
                                    2937671579,
                                    2870763221,
                                    3664609560,
                                    3624381080,
                                    2734883394,
                                    310598401,
                                    1164996542,
                                    607225278,
                                    1323610764,
                                    1426881987,
                                    3590304994,
                                    1925078388,
                                    4068182383,
                                    2162078206,
                                    991336113,
                                    2614888103,
                                    633803317,
                                    3248222580,
                                    3479774868,
                                    3835390401,
                                    2666613458,
                                    4022224774,
                                    944711139,
                                    264347078,
                                    2341262773,
                                    604807628,
                                    2007800933,
                                    770255983,
                                    1495990901,
                                    1249150122,
                                    1856431235,
                                    1555081692,
                                    3175218132,
                                    1996064986,
                                    2198950837,
                                    2554220882,
                                    3999719339,
                                    2821834349,
                                    766784016,
                                    2952996808,
                                    2566594879,
                                    3210313671,
                                    3203337956,
                                    3336571891,
                                    1034457026,
                                    3584528711,
                                    2466948901,
                                    113926993,
                                    3758326383,
                                    338241895,
                                    168717936,
                                    666307205,
                                    1188179964,
                                    773529912,
                                    1546045734,
                                    1294757372,
                                    1522805485,
                                    1396182291,
                                    2643833823,
                                    1695183700,
                                    2343527390,
                                    1986661051,
                                    1014477480,
                                    2177026350,
                                    1206759142,
                                    2456956037,
                                    344077627,
                                    2730485921,
                                    1290863460,
                                    2820302411,
                                    3158454273,
                                    3259730800,
                                    3505952657,
                                    3345764771,
                                    106217008,
                                    3516065817,
                                    3606008344,
                                    3600352804,
                                    1432725776,
                                    4094571909,
                                    1467031594,
                                    275423344,
                                    851169720,
                                    430227734,
                                    3100823752,
                                    506948616,
                                    1363258195,
                                    659060556,
                                    3750685593,
                                    883997877,
                                    3785050280,
                                    958139571,
                                    3318307427,
                                    1322822218,
                                    3812723403,
                                    1537002063,
                                    2003034995,
                                    1747873779,
                                    3602036899,
                                    1955562222,
                                    1575990012,
                                    2024104815,
                                    1125592928,
                                    2227730452,
                                    2716904306,
                                    2361852424,
                                    442776044,
                                    2428436474,
                                    593698344,
                                    2756734187,
                                    3733110249,
                                    3204031479,
                                    2999351573,
                                    3329325298,
                                    3815920427,
                                    3391569614,
                                    3928383900,
                                    3515267271,
                                    566280711,
                                    3940187606,
                                    3454069534,
                                    4118630271,
                                    4000239992,
                                    116418474,
                                    1914138554,
                                    174292421,
                                    2731055270,
                                    289380356,
                                    3203993006,
                                    460393269,
                                    320620315,
                                    685471733,
                                    587496836,
                                    852142971,
                                    1086792851,
                                    1017036298,
                                    365543100,
                                    1126000580,
                                    2618297676,
                                    1288033470,
                                    3409855158,
                                    1501505948,
                                    4234509866,
                                    1607167915,
                                    987167468,
                                    1816402316,
                                    1246189591
                                ], s = new Array(160);
                                function u() {
                                    this.init(), this._w = s, o.call(this, 128, 112);
                                }
                                function c(e, t, r) {
                                    return r ^ e & (t ^ r);
                                }
                                function l(e, t, r) {
                                    return e & t | r & (e | t);
                                }
                                function f(e, t) {
                                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                                }
                                function p(e, t) {
                                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                                }
                                function d(e, t) {
                                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                                }
                                function h(e, t) {
                                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                                }
                                function y(e, t) {
                                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                                }
                                function m(e, t) {
                                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                                }
                                function g(e, t) {
                                    return e >>> 0 < t >>> 0 ? 1 : 0;
                                }
                                n(u, o), u.prototype.init = function() {
                                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                                }, u.prototype._update = function(e) {
                                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, o = 0 | this._ch, i = 0 | this._dh, s = 0 | this._eh, u = 0 | this._fh, v = 0 | this._gh, b = 0 | this._hh, w = 0 | this._al, S = 0 | this._bl, A = 0 | this._cl, E = 0 | this._dl, T = 0 | this._el, O = 0 | this._fl, k = 0 | this._gl, _ = 0 | this._hl, x = 0; x < 32; x += 2)t[x] = e.readInt32BE(4 * x), t[x + 1] = e.readInt32BE(4 * x + 4);
                                    for(; x < 160; x += 2){
                                        var P = t[x - 30], R = t[x - 30 + 1], I = d(P, R), B = h(R, P), C = y(P = t[x - 4], R = t[x - 4 + 1]), j = m(R, P), U = t[x - 14], N = t[x - 14 + 1], L = t[x - 32], F = t[x - 32 + 1], D = B + N | 0, M = I + U + g(D, B) | 0;
                                        M = (M = M + C + g(D = D + j | 0, j) | 0) + L + g(D = D + F | 0, F) | 0, t[x] = M, t[x + 1] = D;
                                    }
                                    for(var V = 0; V < 160; V += 2){
                                        M = t[V], D = t[V + 1];
                                        var q = l(r, n, o), G = l(w, S, A), H = f(r, w), z = f(w, r), W = p(s, T), X = p(T, s), K = a[V], Z = a[V + 1], $ = c(s, u, v), Y = c(T, O, k), Q = _ + X | 0, J = b + W + g(Q, _) | 0;
                                        J = (J = (J = J + $ + g(Q = Q + Y | 0, Y) | 0) + K + g(Q = Q + Z | 0, Z) | 0) + M + g(Q = Q + D | 0, D) | 0;
                                        var ee = z + G | 0, te = H + q + g(ee, z) | 0;
                                        b = v, _ = k, v = u, k = O, u = s, O = T, s = i + J + g(T = E + Q | 0, E) | 0, i = o, E = A, o = n, A = S, n = r, S = w, r = J + te + g(w = Q + ee | 0, Q) | 0;
                                    }
                                    this._al = this._al + w | 0, this._bl = this._bl + S | 0, this._cl = this._cl + A | 0, this._dl = this._dl + E | 0, this._el = this._el + T | 0, this._fl = this._fl + O | 0, this._gl = this._gl + k | 0, this._hl = this._hl + _ | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, S) | 0, this._ch = this._ch + o + g(this._cl, A) | 0, this._dh = this._dh + i + g(this._dl, E) | 0, this._eh = this._eh + s + g(this._el, T) | 0, this._fh = this._fh + u + g(this._fl, O) | 0, this._gh = this._gh + v + g(this._gl, k) | 0, this._hh = this._hh + b + g(this._hl, _) | 0;
                                }, u.prototype._hash = function() {
                                    var e = i.allocUnsafe(64);
                                    function t(t, r, n) {
                                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                                    }
                                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                                }, e.exports = u;
                            },
                            3003 (e) {
                                "use strict";
                                e.exports = function(e) {
                                    return e != e;
                                };
                            },
                            3093 (e, t, r) {
                                "use strict";
                                var n = r(4459);
                                e.exports = function(e) {
                                    return n(e) || 0 === e ? e : e < 0 ? -1 : 1;
                                };
                            },
                            3126 (e, t, r) {
                                "use strict";
                                var n = r(6743), o = r(9675), i = r(76), a = r(3144);
                                e.exports = function(e) {
                                    if (e.length < 1 || "function" != typeof e[0]) throw new o("a function is required");
                                    return a(n, i, e);
                                };
                            },
                            3144 (e, t, r) {
                                "use strict";
                                var n = r(6743), o = r(1002), i = r(76), a = r(7119);
                                e.exports = a || n.call(i, o);
                            },
                            3628 (e, t, r) {
                                "use strict";
                                var n = r(8648), o = r(1064), i = r(7176);
                                e.exports = n ? function(e) {
                                    return n(e);
                                } : o ? function(e) {
                                    if (!e || "object" != typeof e && "function" != typeof e) throw new TypeError("getProto: not an object");
                                    return o(e);
                                } : i ? function(e) {
                                    return i(e);
                                } : null;
                            },
                            3737 (e, t, r) {
                                "use strict";
                                var n = r(6698), o = r(392), i = r(2861).Buffer, a = [
                                    1518500249,
                                    1859775393,
                                    -1894007588,
                                    -899497514
                                ], s = new Array(80);
                                function u() {
                                    this.init(), this._w = s, o.call(this, 64, 56);
                                }
                                function c(e) {
                                    return e << 1 | e >>> 31;
                                }
                                function l(e) {
                                    return e << 5 | e >>> 27;
                                }
                                function f(e) {
                                    return e << 30 | e >>> 2;
                                }
                                function p(e, t, r, n) {
                                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                                }
                                n(u, o), u.prototype.init = function() {
                                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                                }, u.prototype._update = function(e) {
                                    for(var t = this._w, r = 0 | this._a, n = 0 | this._b, o = 0 | this._c, i = 0 | this._d, s = 0 | this._e, u = 0; u < 16; ++u)t[u] = e.readInt32BE(4 * u);
                                    for(; u < 80; ++u)t[u] = c(t[u - 3] ^ t[u - 8] ^ t[u - 14] ^ t[u - 16]);
                                    for(var d = 0; d < 80; ++d){
                                        var h = ~~(d / 20), y = l(r) + p(h, n, o, i) + s + t[d] + a[h] | 0;
                                        s = i, i = o, o = f(n), n = r, r = y;
                                    }
                                    this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = o + this._c | 0, this._d = i + this._d | 0, this._e = s + this._e | 0;
                                }, u.prototype._hash = function() {
                                    var e = i.allocUnsafe(20);
                                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                                }, e.exports = u;
                            },
                            3740 (e, t, r) {
                                var n, o = r(6763);
                                n = ()=>(()=>{
                                        var e = {
                                            348 (e, t, r) {
                                                const n = r(928);
                                                e.exports = n;
                                            },
                                            350 (e, t) {
                                                "use strict";
                                                t.byteLength = function(e) {
                                                    var t = s(e), r = t[0], n = t[1];
                                                    return 3 * (r + n) / 4 - n;
                                                }, t.toByteArray = function(e) {
                                                    var t, r, i = s(e), a = i[0], u = i[1], c = new o(function(e, t, r) {
                                                        return 3 * (t + r) / 4 - r;
                                                    }(0, a, u)), l = 0, f = u > 0 ? a - 4 : a;
                                                    for(r = 0; r < f; r += 4)t = n[e.charCodeAt(r)] << 18 | n[e.charCodeAt(r + 1)] << 12 | n[e.charCodeAt(r + 2)] << 6 | n[e.charCodeAt(r + 3)], c[l++] = t >> 16 & 255, c[l++] = t >> 8 & 255, c[l++] = 255 & t;
                                                    return 2 === u && (t = n[e.charCodeAt(r)] << 2 | n[e.charCodeAt(r + 1)] >> 4, c[l++] = 255 & t), 1 === u && (t = n[e.charCodeAt(r)] << 10 | n[e.charCodeAt(r + 1)] << 4 | n[e.charCodeAt(r + 2)] >> 2, c[l++] = t >> 8 & 255, c[l++] = 255 & t), c;
                                                }, t.fromByteArray = function(e) {
                                                    for(var t, n = e.length, o = n % 3, i = [], a = 16383, s = 0, u = n - o; s < u; s += a)i.push(c(e, s, s + a > u ? u : s + a));
                                                    return 1 === o ? (t = e[n - 1], i.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === o && (t = (e[n - 2] << 8) + e[n - 1], i.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "=")), i.join("");
                                                };
                                                for(var r = [], n = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0; a < 64; ++a)r[a] = i[a], n[i.charCodeAt(a)] = a;
                                                function s(e) {
                                                    var t = e.length;
                                                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                                                    var r = e.indexOf("=");
                                                    return -1 === r && (r = t), [
                                                        r,
                                                        r === t ? 0 : 4 - r % 4
                                                    ];
                                                }
                                                function u(e) {
                                                    return r[e >> 18 & 63] + r[e >> 12 & 63] + r[e >> 6 & 63] + r[63 & e];
                                                }
                                                function c(e, t, r) {
                                                    for(var n, o = [], i = t; i < r; i += 3)n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push(u(n));
                                                    return o.join("");
                                                }
                                                n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
                                            },
                                            686 (e, t, r) {
                                                "use strict";
                                                const n = r(350), i = r(947), a = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
                                                t.hp = c, t.IS = 50;
                                                const s = 2147483647;
                                                function u(e) {
                                                    if (e > s) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                                                    const t = new Uint8Array(e);
                                                    return Object.setPrototypeOf(t, c.prototype), t;
                                                }
                                                function c(e, t, r) {
                                                    if ("number" == typeof e) {
                                                        if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                                        return p(e);
                                                    }
                                                    return l(e, t, r);
                                                }
                                                function l(e, t, r) {
                                                    if ("string" == typeof e) return function(e, t) {
                                                        if ("string" == typeof t && "" !== t || (t = "utf8"), !c.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                                        const r = 0 | m(e, t);
                                                        let n = u(r);
                                                        const o = n.write(e, t);
                                                        return o !== r && (n = n.slice(0, o)), n;
                                                    }(e, t);
                                                    if (ArrayBuffer.isView(e)) return function(e) {
                                                        if ($(e, Uint8Array)) {
                                                            const t = new Uint8Array(e);
                                                            return h(t.buffer, t.byteOffset, t.byteLength);
                                                        }
                                                        return d(e);
                                                    }(e);
                                                    if (null == e) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                                                    if ($(e, ArrayBuffer) || e && $(e.buffer, ArrayBuffer)) return h(e, t, r);
                                                    if ("undefined" != typeof SharedArrayBuffer && ($(e, SharedArrayBuffer) || e && $(e.buffer, SharedArrayBuffer))) return h(e, t, r);
                                                    if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                                                    const n = e.valueOf && e.valueOf();
                                                    if (null != n && n !== e) return c.from(n, t, r);
                                                    const o = function(e) {
                                                        if (c.isBuffer(e)) {
                                                            const t = 0 | y(e.length), r = u(t);
                                                            return 0 === r.length || e.copy(r, 0, 0, t), r;
                                                        }
                                                        return void 0 !== e.length ? "number" != typeof e.length || Y(e.length) ? u(0) : d(e) : "Buffer" === e.type && Array.isArray(e.data) ? d(e.data) : void 0;
                                                    }(e);
                                                    if (o) return o;
                                                    if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return c.from(e[Symbol.toPrimitive]("string"), t, r);
                                                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                                                }
                                                function f(e) {
                                                    if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                                                    if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                                                }
                                                function p(e) {
                                                    return f(e), u(e < 0 ? 0 : 0 | y(e));
                                                }
                                                function d(e) {
                                                    const t = e.length < 0 ? 0 : 0 | y(e.length), r = u(t);
                                                    for(let n = 0; n < t; n += 1)r[n] = 255 & e[n];
                                                    return r;
                                                }
                                                function h(e, t, r) {
                                                    if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                                    if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                                    let n;
                                                    return n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r), Object.setPrototypeOf(n, c.prototype), n;
                                                }
                                                function y(e) {
                                                    if (e >= s) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
                                                    return 0 | e;
                                                }
                                                function m(e, t) {
                                                    if (c.isBuffer(e)) return e.length;
                                                    if (ArrayBuffer.isView(e) || $(e, ArrayBuffer)) return e.byteLength;
                                                    if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                                                    const r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                                                    if (!n && 0 === r) return 0;
                                                    let o = !1;
                                                    for(;;)switch(t){
                                                        case "ascii":
                                                        case "latin1":
                                                        case "binary":
                                                            return r;
                                                        case "utf8":
                                                        case "utf-8":
                                                            return X(e).length;
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return 2 * r;
                                                        case "hex":
                                                            return r >>> 1;
                                                        case "base64":
                                                            return K(e).length;
                                                        default:
                                                            if (o) return n ? -1 : X(e).length;
                                                            t = ("" + t).toLowerCase(), o = !0;
                                                    }
                                                }
                                                function g(e, t, r) {
                                                    let n = !1;
                                                    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                                                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                                                    if ((r >>>= 0) <= (t >>>= 0)) return "";
                                                    for(e || (e = "utf8");;)switch(e){
                                                        case "hex":
                                                            return I(this, t, r);
                                                        case "utf8":
                                                        case "utf-8":
                                                            return _(this, t, r);
                                                        case "ascii":
                                                            return P(this, t, r);
                                                        case "latin1":
                                                        case "binary":
                                                            return R(this, t, r);
                                                        case "base64":
                                                            return k(this, t, r);
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return B(this, t, r);
                                                        default:
                                                            if (n) throw new TypeError("Unknown encoding: " + e);
                                                            e = (e + "").toLowerCase(), n = !0;
                                                    }
                                                }
                                                function v(e, t, r) {
                                                    const n = e[t];
                                                    e[t] = e[r], e[r] = n;
                                                }
                                                function b(e, t, r, n, o) {
                                                    if (0 === e.length) return -1;
                                                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), Y(r = +r) && (r = o ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                                        if (o) return -1;
                                                        r = e.length - 1;
                                                    } else if (r < 0) {
                                                        if (!o) return -1;
                                                        r = 0;
                                                    }
                                                    if ("string" == typeof t && (t = c.from(t, n)), c.isBuffer(t)) return 0 === t.length ? -1 : w(e, t, r, n, o);
                                                    if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : w(e, [
                                                        t
                                                    ], r, n, o);
                                                    throw new TypeError("val must be string, number or Buffer");
                                                }
                                                function w(e, t, r, n, o) {
                                                    let i, a = 1, s = e.length, u = t.length;
                                                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                                        if (e.length < 2 || t.length < 2) return -1;
                                                        a = 2, s /= 2, u /= 2, r /= 2;
                                                    }
                                                    function c(e, t) {
                                                        return 1 === a ? e[t] : e.readUInt16BE(t * a);
                                                    }
                                                    if (o) {
                                                        let n = -1;
                                                        for(i = r; i < s; i++)if (c(e, i) === c(t, -1 === n ? 0 : i - n)) {
                                                            if (-1 === n && (n = i), i - n + 1 === u) return n * a;
                                                        } else -1 !== n && (i -= i - n), n = -1;
                                                    } else for(r + u > s && (r = s - u), i = r; i >= 0; i--){
                                                        let r = !0;
                                                        for(let n = 0; n < u; n++)if (c(e, i + n) !== c(t, n)) {
                                                            r = !1;
                                                            break;
                                                        }
                                                        if (r) return i;
                                                    }
                                                    return -1;
                                                }
                                                function S(e, t, r, n) {
                                                    r = Number(r) || 0;
                                                    const o = e.length - r;
                                                    n ? (n = Number(n)) > o && (n = o) : n = o;
                                                    const i = t.length;
                                                    let a;
                                                    for(n > i / 2 && (n = i / 2), a = 0; a < n; ++a){
                                                        const n = parseInt(t.substr(2 * a, 2), 16);
                                                        if (Y(n)) return a;
                                                        e[r + a] = n;
                                                    }
                                                    return a;
                                                }
                                                function A(e, t, r, n) {
                                                    return Z(X(t, e.length - r), e, r, n);
                                                }
                                                function E(e, t, r, n) {
                                                    return Z(function(e) {
                                                        const t = [];
                                                        for(let r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                                        return t;
                                                    }(t), e, r, n);
                                                }
                                                function T(e, t, r, n) {
                                                    return Z(K(t), e, r, n);
                                                }
                                                function O(e, t, r, n) {
                                                    return Z(function(e, t) {
                                                        let r, n, o;
                                                        const i = [];
                                                        for(let a = 0; a < e.length && !((t -= 2) < 0); ++a)r = e.charCodeAt(a), n = r >> 8, o = r % 256, i.push(o), i.push(n);
                                                        return i;
                                                    }(t, e.length - r), e, r, n);
                                                }
                                                function k(e, t, r) {
                                                    return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
                                                }
                                                function _(e, t, r) {
                                                    r = Math.min(e.length, r);
                                                    const n = [];
                                                    let o = t;
                                                    for(; o < r;){
                                                        const t = e[o];
                                                        let i = null, a = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
                                                        if (o + a <= r) {
                                                            let r, n, s, u;
                                                            switch(a){
                                                                case 1:
                                                                    t < 128 && (i = t);
                                                                    break;
                                                                case 2:
                                                                    r = e[o + 1], 128 == (192 & r) && (u = (31 & t) << 6 | 63 & r, u > 127 && (i = u));
                                                                    break;
                                                                case 3:
                                                                    r = e[o + 1], n = e[o + 2], 128 == (192 & r) && 128 == (192 & n) && (u = (15 & t) << 12 | (63 & r) << 6 | 63 & n, u > 2047 && (u < 55296 || u > 57343) && (i = u));
                                                                    break;
                                                                case 4:
                                                                    r = e[o + 1], n = e[o + 2], s = e[o + 3], 128 == (192 & r) && 128 == (192 & n) && 128 == (192 & s) && (u = (15 & t) << 18 | (63 & r) << 12 | (63 & n) << 6 | 63 & s, u > 65535 && u < 1114112 && (i = u));
                                                            }
                                                        }
                                                        null === i ? (i = 65533, a = 1) : i > 65535 && (i -= 65536, n.push(i >>> 10 & 1023 | 55296), i = 56320 | 1023 & i), n.push(i), o += a;
                                                    }
                                                    return function(e) {
                                                        const t = e.length;
                                                        if (t <= x) return String.fromCharCode.apply(String, e);
                                                        let r = "", n = 0;
                                                        for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += x));
                                                        return r;
                                                    }(n);
                                                }
                                                c.TYPED_ARRAY_SUPPORT = function() {
                                                    try {
                                                        const e = new Uint8Array(1), t = {
                                                            foo: function() {
                                                                return 42;
                                                            }
                                                        };
                                                        return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e, t), 42 === e.foo();
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(), c.TYPED_ARRAY_SUPPORT || void 0 === o || "function" != typeof o.error || o.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(c.prototype, "parent", {
                                                    enumerable: !0,
                                                    get: function() {
                                                        if (c.isBuffer(this)) return this.buffer;
                                                    }
                                                }), Object.defineProperty(c.prototype, "offset", {
                                                    enumerable: !0,
                                                    get: function() {
                                                        if (c.isBuffer(this)) return this.byteOffset;
                                                    }
                                                }), c.poolSize = 8192, c.from = function(e, t, r) {
                                                    return l(e, t, r);
                                                }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array), c.alloc = function(e, t, r) {
                                                    return function(e, t, r) {
                                                        return f(e), e <= 0 ? u(e) : void 0 !== t ? "string" == typeof r ? u(e).fill(t, r) : u(e).fill(t) : u(e);
                                                    }(e, t, r);
                                                }, c.allocUnsafe = function(e) {
                                                    return p(e);
                                                }, c.allocUnsafeSlow = function(e) {
                                                    return p(e);
                                                }, c.isBuffer = function(e) {
                                                    return null != e && !0 === e._isBuffer && e !== c.prototype;
                                                }, c.compare = function(e, t) {
                                                    if ($(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), $(t, Uint8Array) && (t = c.from(t, t.offset, t.byteLength)), !c.isBuffer(e) || !c.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                                                    if (e === t) return 0;
                                                    let r = e.length, n = t.length;
                                                    for(let o = 0, i = Math.min(r, n); o < i; ++o)if (e[o] !== t[o]) {
                                                        r = e[o], n = t[o];
                                                        break;
                                                    }
                                                    return r < n ? -1 : n < r ? 1 : 0;
                                                }, c.isEncoding = function(e) {
                                                    switch(String(e).toLowerCase()){
                                                        case "hex":
                                                        case "utf8":
                                                        case "utf-8":
                                                        case "ascii":
                                                        case "latin1":
                                                        case "binary":
                                                        case "base64":
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return !0;
                                                        default:
                                                            return !1;
                                                    }
                                                }, c.concat = function(e, t) {
                                                    if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                                                    if (0 === e.length) return c.alloc(0);
                                                    let r;
                                                    if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                                                    const n = c.allocUnsafe(t);
                                                    let o = 0;
                                                    for(r = 0; r < e.length; ++r){
                                                        let t = e[r];
                                                        if ($(t, Uint8Array)) o + t.length > n.length ? (c.isBuffer(t) || (t = c.from(t)), t.copy(n, o)) : Uint8Array.prototype.set.call(n, t, o);
                                                        else {
                                                            if (!c.isBuffer(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                                                            t.copy(n, o);
                                                        }
                                                        o += t.length;
                                                    }
                                                    return n;
                                                }, c.byteLength = m, c.prototype._isBuffer = !0, c.prototype.swap16 = function() {
                                                    const e = this.length;
                                                    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                                                    for(let t = 0; t < e; t += 2)v(this, t, t + 1);
                                                    return this;
                                                }, c.prototype.swap32 = function() {
                                                    const e = this.length;
                                                    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                                                    for(let t = 0; t < e; t += 4)v(this, t, t + 3), v(this, t + 1, t + 2);
                                                    return this;
                                                }, c.prototype.swap64 = function() {
                                                    const e = this.length;
                                                    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                                                    for(let t = 0; t < e; t += 8)v(this, t, t + 7), v(this, t + 1, t + 6), v(this, t + 2, t + 5), v(this, t + 3, t + 4);
                                                    return this;
                                                }, c.prototype.toString = function() {
                                                    const e = this.length;
                                                    return 0 === e ? "" : 0 === arguments.length ? _(this, 0, e) : g.apply(this, arguments);
                                                }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(e) {
                                                    if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                                                    return this === e || 0 === c.compare(this, e);
                                                }, c.prototype.inspect = function() {
                                                    let e = "";
                                                    const r = t.IS;
                                                    return e = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (e += " ... "), "<Buffer " + e + ">";
                                                }, a && (c.prototype[a] = c.prototype.inspect), c.prototype.compare = function(e, t, r, n, o) {
                                                    if ($(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), !c.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                                                    if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), t < 0 || r > e.length || n < 0 || o > this.length) throw new RangeError("out of range index");
                                                    if (n >= o && t >= r) return 0;
                                                    if (n >= o) return -1;
                                                    if (t >= r) return 1;
                                                    if (this === e) return 0;
                                                    let i = (o >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0);
                                                    const s = Math.min(i, a), u = this.slice(n, o), l = e.slice(t, r);
                                                    for(let e = 0; e < s; ++e)if (u[e] !== l[e]) {
                                                        i = u[e], a = l[e];
                                                        break;
                                                    }
                                                    return i < a ? -1 : a < i ? 1 : 0;
                                                }, c.prototype.includes = function(e, t, r) {
                                                    return -1 !== this.indexOf(e, t, r);
                                                }, c.prototype.indexOf = function(e, t, r) {
                                                    return b(this, e, t, r, !0);
                                                }, c.prototype.lastIndexOf = function(e, t, r) {
                                                    return b(this, e, t, r, !1);
                                                }, c.prototype.write = function(e, t, r, n) {
                                                    if (void 0 === t) n = "utf8", r = this.length, t = 0;
                                                    else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                                                    else {
                                                        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                                        t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                                                    }
                                                    const o = this.length - t;
                                                    if ((void 0 === r || r > o) && (r = o), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                                                    n || (n = "utf8");
                                                    let i = !1;
                                                    for(;;)switch(n){
                                                        case "hex":
                                                            return S(this, e, t, r);
                                                        case "utf8":
                                                        case "utf-8":
                                                            return A(this, e, t, r);
                                                        case "ascii":
                                                        case "latin1":
                                                        case "binary":
                                                            return E(this, e, t, r);
                                                        case "base64":
                                                            return T(this, e, t, r);
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return O(this, e, t, r);
                                                        default:
                                                            if (i) throw new TypeError("Unknown encoding: " + n);
                                                            n = ("" + n).toLowerCase(), i = !0;
                                                    }
                                                }, c.prototype.toJSON = function() {
                                                    return {
                                                        type: "Buffer",
                                                        data: Array.prototype.slice.call(this._arr || this, 0)
                                                    };
                                                };
                                                const x = 4096;
                                                function P(e, t, r) {
                                                    let n = "";
                                                    r = Math.min(e.length, r);
                                                    for(let o = t; o < r; ++o)n += String.fromCharCode(127 & e[o]);
                                                    return n;
                                                }
                                                function R(e, t, r) {
                                                    let n = "";
                                                    r = Math.min(e.length, r);
                                                    for(let o = t; o < r; ++o)n += String.fromCharCode(e[o]);
                                                    return n;
                                                }
                                                function I(e, t, r) {
                                                    const n = e.length;
                                                    (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                                                    let o = "";
                                                    for(let n = t; n < r; ++n)o += Q[e[n]];
                                                    return o;
                                                }
                                                function B(e, t, r) {
                                                    const n = e.slice(t, r);
                                                    let o = "";
                                                    for(let e = 0; e < n.length - 1; e += 2)o += String.fromCharCode(n[e] + 256 * n[e + 1]);
                                                    return o;
                                                }
                                                function C(e, t, r) {
                                                    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                                                    if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                                                }
                                                function j(e, t, r, n, o, i) {
                                                    if (!c.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                                                    if (t > o || t < i) throw new RangeError('"value" argument is out of bounds');
                                                    if (r + n > e.length) throw new RangeError("Index out of range");
                                                }
                                                function U(e, t, r, n, o) {
                                                    G(t, n, o, e, r, 7);
                                                    let i = Number(t & BigInt(4294967295));
                                                    e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i;
                                                    let a = Number(t >> BigInt(32) & BigInt(4294967295));
                                                    return e[r++] = a, a >>= 8, e[r++] = a, a >>= 8, e[r++] = a, a >>= 8, e[r++] = a, r;
                                                }
                                                function N(e, t, r, n, o) {
                                                    G(t, n, o, e, r, 7);
                                                    let i = Number(t & BigInt(4294967295));
                                                    e[r + 7] = i, i >>= 8, e[r + 6] = i, i >>= 8, e[r + 5] = i, i >>= 8, e[r + 4] = i;
                                                    let a = Number(t >> BigInt(32) & BigInt(4294967295));
                                                    return e[r + 3] = a, a >>= 8, e[r + 2] = a, a >>= 8, e[r + 1] = a, a >>= 8, e[r] = a, r + 8;
                                                }
                                                function L(e, t, r, n, o, i) {
                                                    if (r + n > e.length) throw new RangeError("Index out of range");
                                                    if (r < 0) throw new RangeError("Index out of range");
                                                }
                                                function F(e, t, r, n, o) {
                                                    return t = +t, r >>>= 0, o || L(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
                                                }
                                                function D(e, t, r, n, o) {
                                                    return t = +t, r >>>= 0, o || L(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
                                                }
                                                c.prototype.slice = function(e, t) {
                                                    const r = this.length;
                                                    (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                                                    const n = this.subarray(e, t);
                                                    return Object.setPrototypeOf(n, c.prototype), n;
                                                }, c.prototype.readUintLE = c.prototype.readUIntLE = function(e, t, r) {
                                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                                    let n = this[e], o = 1, i = 0;
                                                    for(; ++i < t && (o *= 256);)n += this[e + i] * o;
                                                    return n;
                                                }, c.prototype.readUintBE = c.prototype.readUIntBE = function(e, t, r) {
                                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                                    let n = this[e + --t], o = 1;
                                                    for(; t > 0 && (o *= 256);)n += this[e + --t] * o;
                                                    return n;
                                                }, c.prototype.readUint8 = c.prototype.readUInt8 = function(e, t) {
                                                    return e >>>= 0, t || C(e, 1, this.length), this[e];
                                                }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 2, this.length), this[e] | this[e + 1] << 8;
                                                }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 2, this.length), this[e] << 8 | this[e + 1];
                                                }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                                                }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                                                }, c.prototype.readBigUInt64LE = J(function(e) {
                                                    H(e >>>= 0, "offset");
                                                    const t = this[e], r = this[e + 7];
                                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                                    const n = t + 256 * this[++e] + 65536 * this[++e] + this[++e] * 2 ** 24, o = this[++e] + 256 * this[++e] + 65536 * this[++e] + r * 2 ** 24;
                                                    return BigInt(n) + (BigInt(o) << BigInt(32));
                                                }), c.prototype.readBigUInt64BE = J(function(e) {
                                                    H(e >>>= 0, "offset");
                                                    const t = this[e], r = this[e + 7];
                                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                                    const n = t * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + this[++e], o = this[++e] * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + r;
                                                    return (BigInt(n) << BigInt(32)) + BigInt(o);
                                                }), c.prototype.readIntLE = function(e, t, r) {
                                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                                    let n = this[e], o = 1, i = 0;
                                                    for(; ++i < t && (o *= 256);)n += this[e + i] * o;
                                                    return o *= 128, n >= o && (n -= Math.pow(2, 8 * t)), n;
                                                }, c.prototype.readIntBE = function(e, t, r) {
                                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                                    let n = t, o = 1, i = this[e + --n];
                                                    for(; n > 0 && (o *= 256);)i += this[e + --n] * o;
                                                    return o *= 128, i >= o && (i -= Math.pow(2, 8 * t)), i;
                                                }, c.prototype.readInt8 = function(e, t) {
                                                    return e >>>= 0, t || C(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                                                }, c.prototype.readInt16LE = function(e, t) {
                                                    e >>>= 0, t || C(e, 2, this.length);
                                                    const r = this[e] | this[e + 1] << 8;
                                                    return 32768 & r ? 4294901760 | r : r;
                                                }, c.prototype.readInt16BE = function(e, t) {
                                                    e >>>= 0, t || C(e, 2, this.length);
                                                    const r = this[e + 1] | this[e] << 8;
                                                    return 32768 & r ? 4294901760 | r : r;
                                                }, c.prototype.readInt32LE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                                                }, c.prototype.readInt32BE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                                                }, c.prototype.readBigInt64LE = J(function(e) {
                                                    H(e >>>= 0, "offset");
                                                    const t = this[e], r = this[e + 7];
                                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                                    const n = this[e + 4] + 256 * this[e + 5] + 65536 * this[e + 6] + (r << 24);
                                                    return (BigInt(n) << BigInt(32)) + BigInt(t + 256 * this[++e] + 65536 * this[++e] + this[++e] * 2 ** 24);
                                                }), c.prototype.readBigInt64BE = J(function(e) {
                                                    H(e >>>= 0, "offset");
                                                    const t = this[e], r = this[e + 7];
                                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                                    const n = (t << 24) + 65536 * this[++e] + 256 * this[++e] + this[++e];
                                                    return (BigInt(n) << BigInt(32)) + BigInt(this[++e] * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + r);
                                                }), c.prototype.readFloatLE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 4, this.length), i.read(this, e, !0, 23, 4);
                                                }, c.prototype.readFloatBE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 4, this.length), i.read(this, e, !1, 23, 4);
                                                }, c.prototype.readDoubleLE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 8, this.length), i.read(this, e, !0, 52, 8);
                                                }, c.prototype.readDoubleBE = function(e, t) {
                                                    return e >>>= 0, t || C(e, 8, this.length), i.read(this, e, !1, 52, 8);
                                                }, c.prototype.writeUintLE = c.prototype.writeUIntLE = function(e, t, r, n) {
                                                    e = +e, t >>>= 0, r >>>= 0, n || j(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                                                    let o = 1, i = 0;
                                                    for(this[t] = 255 & e; ++i < r && (o *= 256);)this[t + i] = e / o & 255;
                                                    return t + r;
                                                }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(e, t, r, n) {
                                                    e = +e, t >>>= 0, r >>>= 0, n || j(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                                                    let o = r - 1, i = 1;
                                                    for(this[t + o] = 255 & e; --o >= 0 && (i *= 256);)this[t + o] = e / i & 255;
                                                    return t + r;
                                                }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                                                }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                                                }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                                                }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                                                }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                                                }, c.prototype.writeBigUInt64LE = J(function(e, t = 0) {
                                                    return U(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
                                                }), c.prototype.writeBigUInt64BE = J(function(e, t = 0) {
                                                    return N(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
                                                }), c.prototype.writeIntLE = function(e, t, r, n) {
                                                    if (e = +e, t >>>= 0, !n) {
                                                        const n = Math.pow(2, 8 * r - 1);
                                                        j(this, e, t, r, n - 1, -n);
                                                    }
                                                    let o = 0, i = 1, a = 0;
                                                    for(this[t] = 255 & e; ++o < r && (i *= 256);)e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1), this[t + o] = (e / i | 0) - a & 255;
                                                    return t + r;
                                                }, c.prototype.writeIntBE = function(e, t, r, n) {
                                                    if (e = +e, t >>>= 0, !n) {
                                                        const n = Math.pow(2, 8 * r - 1);
                                                        j(this, e, t, r, n - 1, -n);
                                                    }
                                                    let o = r - 1, i = 1, a = 0;
                                                    for(this[t + o] = 255 & e; --o >= 0 && (i *= 256);)e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1), this[t + o] = (e / i | 0) - a & 255;
                                                    return t + r;
                                                }, c.prototype.writeInt8 = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                                                }, c.prototype.writeInt16LE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                                                }, c.prototype.writeInt16BE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                                                }, c.prototype.writeInt32LE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                                                }, c.prototype.writeInt32BE = function(e, t, r) {
                                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                                                }, c.prototype.writeBigInt64LE = J(function(e, t = 0) {
                                                    return U(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                                                }), c.prototype.writeBigInt64BE = J(function(e, t = 0) {
                                                    return N(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                                                }), c.prototype.writeFloatLE = function(e, t, r) {
                                                    return F(this, e, t, !0, r);
                                                }, c.prototype.writeFloatBE = function(e, t, r) {
                                                    return F(this, e, t, !1, r);
                                                }, c.prototype.writeDoubleLE = function(e, t, r) {
                                                    return D(this, e, t, !0, r);
                                                }, c.prototype.writeDoubleBE = function(e, t, r) {
                                                    return D(this, e, t, !1, r);
                                                }, c.prototype.copy = function(e, t, r, n) {
                                                    if (!c.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                                                    if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                                                    if (0 === e.length || 0 === this.length) return 0;
                                                    if (t < 0) throw new RangeError("targetStart out of bounds");
                                                    if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                                                    if (n < 0) throw new RangeError("sourceEnd out of bounds");
                                                    n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                                                    const o = n - r;
                                                    return this === e && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(t, r, n) : Uint8Array.prototype.set.call(e, this.subarray(r, n), t), o;
                                                }, c.prototype.fill = function(e, t, r, n) {
                                                    if ("string" == typeof e) {
                                                        if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                                        if ("string" == typeof n && !c.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                                        if (1 === e.length) {
                                                            const t = e.charCodeAt(0);
                                                            ("utf8" === n && t < 128 || "latin1" === n) && (e = t);
                                                        }
                                                    } else "number" == typeof e ? e &= 255 : "boolean" == typeof e && (e = Number(e));
                                                    if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                                                    if (r <= t) return this;
                                                    let o;
                                                    if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                                                    else {
                                                        const i = c.isBuffer(e) ? e : c.from(e, n), a = i.length;
                                                        if (0 === a) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                                        for(o = 0; o < r - t; ++o)this[o + t] = i[o % a];
                                                    }
                                                    return this;
                                                };
                                                const M = {};
                                                function V(e, t, r) {
                                                    M[e] = class extends r {
                                                        constructor(){
                                                            super(), Object.defineProperty(this, "message", {
                                                                value: t.apply(this, arguments),
                                                                writable: !0,
                                                                configurable: !0
                                                            }), this.name = `${this.name} [${e}]`, this.stack, delete this.name;
                                                        }
                                                        get code() {
                                                            return e;
                                                        }
                                                        set code(e) {
                                                            Object.defineProperty(this, "code", {
                                                                configurable: !0,
                                                                enumerable: !0,
                                                                value: e,
                                                                writable: !0
                                                            });
                                                        }
                                                        toString() {
                                                            return `${this.name} [${e}]: ${this.message}`;
                                                        }
                                                    };
                                                }
                                                function q(e) {
                                                    let t = "", r = e.length;
                                                    const n = "-" === e[0] ? 1 : 0;
                                                    for(; r >= n + 4; r -= 3)t = `_${e.slice(r - 3, r)}${t}`;
                                                    return `${e.slice(0, r)}${t}`;
                                                }
                                                function G(e, t, r, n, o, i) {
                                                    if (e > r || e < t) {
                                                        const n = "bigint" == typeof t ? "n" : "";
                                                        let o;
                                                        throw o = i > 3 ? 0 === t || t === BigInt(0) ? `>= 0${n} and < 2${n} ** ${8 * (i + 1)}${n}` : `>= -(2${n} ** ${8 * (i + 1) - 1}${n}) and < 2 ** ${8 * (i + 1) - 1}${n}` : `>= ${t}${n} and <= ${r}${n}`, new M.ERR_OUT_OF_RANGE("value", o, e);
                                                    }
                                                    !function(e, t, r) {
                                                        H(t, "offset"), void 0 !== e[t] && void 0 !== e[t + r] || z(t, e.length - (r + 1));
                                                    }(n, o, i);
                                                }
                                                function H(e, t) {
                                                    if ("number" != typeof e) throw new M.ERR_INVALID_ARG_TYPE(t, "number", e);
                                                }
                                                function z(e, t, r) {
                                                    if (Math.floor(e) !== e) throw H(e, r), new M.ERR_OUT_OF_RANGE(r || "offset", "an integer", e);
                                                    if (t < 0) throw new M.ERR_BUFFER_OUT_OF_BOUNDS;
                                                    throw new M.ERR_OUT_OF_RANGE(r || "offset", `>= ${r ? 1 : 0} and <= ${t}`, e);
                                                }
                                                V("ERR_BUFFER_OUT_OF_BOUNDS", function(e) {
                                                    return e ? `${e} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
                                                }, RangeError), V("ERR_INVALID_ARG_TYPE", function(e, t) {
                                                    return `The "${e}" argument must be of type number. Received type ${typeof t}`;
                                                }, TypeError), V("ERR_OUT_OF_RANGE", function(e, t, r) {
                                                    let n = `The value of "${e}" is out of range.`, o = r;
                                                    return Number.isInteger(r) && Math.abs(r) > 2 ** 32 ? o = q(String(r)) : "bigint" == typeof r && (o = String(r), (r > BigInt(2) ** BigInt(32) || r < -(BigInt(2) ** BigInt(32))) && (o = q(o)), o += "n"), n += ` It must be ${t}. Received ${o}`, n;
                                                }, RangeError);
                                                const W = /[^+/0-9A-Za-z-_]/g;
                                                function X(e, t) {
                                                    let r;
                                                    t = t || 1 / 0;
                                                    const n = e.length;
                                                    let o = null;
                                                    const i = [];
                                                    for(let a = 0; a < n; ++a){
                                                        if (r = e.charCodeAt(a), r > 55295 && r < 57344) {
                                                            if (!o) {
                                                                if (r > 56319) {
                                                                    (t -= 3) > -1 && i.push(239, 191, 189);
                                                                    continue;
                                                                }
                                                                if (a + 1 === n) {
                                                                    (t -= 3) > -1 && i.push(239, 191, 189);
                                                                    continue;
                                                                }
                                                                o = r;
                                                                continue;
                                                            }
                                                            if (r < 56320) {
                                                                (t -= 3) > -1 && i.push(239, 191, 189), o = r;
                                                                continue;
                                                            }
                                                            r = 65536 + (o - 55296 << 10 | r - 56320);
                                                        } else o && (t -= 3) > -1 && i.push(239, 191, 189);
                                                        if (o = null, r < 128) {
                                                            if ((t -= 1) < 0) break;
                                                            i.push(r);
                                                        } else if (r < 2048) {
                                                            if ((t -= 2) < 0) break;
                                                            i.push(r >> 6 | 192, 63 & r | 128);
                                                        } else if (r < 65536) {
                                                            if ((t -= 3) < 0) break;
                                                            i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                                        } else {
                                                            if (!(r < 1114112)) throw new Error("Invalid code point");
                                                            if ((t -= 4) < 0) break;
                                                            i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                                        }
                                                    }
                                                    return i;
                                                }
                                                function K(e) {
                                                    return n.toByteArray(function(e) {
                                                        if ((e = (e = e.split("=")[0]).trim().replace(W, "")).length < 2) return "";
                                                        for(; e.length % 4 != 0;)e += "=";
                                                        return e;
                                                    }(e));
                                                }
                                                function Z(e, t, r, n) {
                                                    let o;
                                                    for(o = 0; o < n && !(o + r >= t.length || o >= e.length); ++o)t[o + r] = e[o];
                                                    return o;
                                                }
                                                function $(e, t) {
                                                    return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                                                }
                                                function Y(e) {
                                                    return e != e;
                                                }
                                                const Q = function() {
                                                    const e = "0123456789abcdef", t = new Array(256);
                                                    for(let r = 0; r < 16; ++r){
                                                        const n = 16 * r;
                                                        for(let o = 0; o < 16; ++o)t[n + o] = e[r] + e[o];
                                                    }
                                                    return t;
                                                }();
                                                function J(e) {
                                                    return "undefined" == typeof BigInt ? ee : e;
                                                }
                                                function ee() {
                                                    throw new Error("BigInt not supported");
                                                }
                                            },
                                            928 (e, t, r) {
                                                "use strict";
                                                r.r(t), r.d(t, {
                                                    Array: ()=>q,
                                                    Bool: ()=>U,
                                                    Double: ()=>C,
                                                    Enum: ()=>W,
                                                    Float: ()=>B,
                                                    Hyper: ()=>x,
                                                    Int: ()=>E,
                                                    LargeInt: ()=>_,
                                                    Opaque: ()=>D,
                                                    Option: ()=>H,
                                                    Quadruple: ()=>j,
                                                    Reference: ()=>X,
                                                    String: ()=>L,
                                                    Struct: ()=>K,
                                                    Union: ()=>$,
                                                    UnsignedHyper: ()=>I,
                                                    UnsignedInt: ()=>R,
                                                    VarArray: ()=>G,
                                                    VarOpaque: ()=>V,
                                                    Void: ()=>z,
                                                    XdrReader: ()=>u,
                                                    XdrWriter: ()=>f,
                                                    config: ()=>ie
                                                });
                                                class n extends TypeError {
                                                    constructor(e){
                                                        super(`XDR Write Error: ${e}`);
                                                    }
                                                }
                                                class o extends TypeError {
                                                    constructor(e){
                                                        super(`XDR Read Error: ${e}`);
                                                    }
                                                }
                                                class i extends TypeError {
                                                    constructor(e){
                                                        super(`XDR Type Definition Error: ${e}`);
                                                    }
                                                }
                                                class a extends i {
                                                    constructor(){
                                                        super("method not implemented, it should be overloaded in the descendant class.");
                                                    }
                                                }
                                                var s = r(686).hp;
                                                class u {
                                                    constructor(e){
                                                        if (!s.isBuffer(e)) {
                                                            if (!(e instanceof Array || Array.isArray(e) || ArrayBuffer.isView(e))) throw new o(`source invalid: ${e}`);
                                                            e = s.from(e);
                                                        }
                                                        this._buffer = e, this._length = e.length, this._index = 0;
                                                    }
                                                    _buffer;
                                                    _length;
                                                    _index;
                                                    get eof() {
                                                        return this._index === this._length;
                                                    }
                                                    advance(e) {
                                                        const t = this._index;
                                                        if (this._index += e, this._length < this._index) throw new o("attempt to read outside the boundary of the buffer");
                                                        const r = 4 - (e % 4 || 4);
                                                        if (r > 0) {
                                                            for(let e = 0; e < r; e++)if (0 !== this._buffer[this._index + e]) throw new o("invalid padding");
                                                            this._index += r;
                                                        }
                                                        return t;
                                                    }
                                                    rewind() {
                                                        this._index = 0;
                                                    }
                                                    remainingBytes() {
                                                        return this._length - this._index;
                                                    }
                                                    read(e) {
                                                        const t = this.advance(e);
                                                        return this._buffer.subarray(t, t + e);
                                                    }
                                                    readInt32BE() {
                                                        return this._buffer.readInt32BE(this.advance(4));
                                                    }
                                                    readUInt32BE() {
                                                        return this._buffer.readUInt32BE(this.advance(4));
                                                    }
                                                    readBigInt64BE() {
                                                        return this._buffer.readBigInt64BE(this.advance(8));
                                                    }
                                                    readBigUInt64BE() {
                                                        return this._buffer.readBigUInt64BE(this.advance(8));
                                                    }
                                                    readFloatBE() {
                                                        return this._buffer.readFloatBE(this.advance(4));
                                                    }
                                                    readDoubleBE() {
                                                        return this._buffer.readDoubleBE(this.advance(8));
                                                    }
                                                    ensureInputConsumed() {
                                                        if (this._index !== this._length) throw new o("invalid XDR contract typecast - source buffer not entirely consumed");
                                                    }
                                                }
                                                var c = r(686).hp;
                                                const l = 8192;
                                                class f {
                                                    constructor(e){
                                                        "number" == typeof e ? e = c.allocUnsafe(e) : e instanceof c || (e = c.allocUnsafe(l)), this._buffer = e, this._length = e.length;
                                                    }
                                                    _buffer;
                                                    _length;
                                                    _index = 0;
                                                    alloc(e) {
                                                        const t = this._index;
                                                        return this._index += e, this._length < this._index && this.resize(this._index), t;
                                                    }
                                                    resize(e) {
                                                        const t = Math.ceil(e / l) * l, r = c.allocUnsafe(t);
                                                        this._buffer.copy(r, 0, 0, this._length), this._buffer = r, this._length = t;
                                                    }
                                                    finalize() {
                                                        return this._buffer.subarray(0, this._index);
                                                    }
                                                    toArray() {
                                                        return [
                                                            ...this.finalize()
                                                        ];
                                                    }
                                                    write(e, t) {
                                                        if ("string" == typeof e) {
                                                            const r = this.alloc(t);
                                                            this._buffer.write(e, r, "utf8");
                                                        } else {
                                                            e instanceof c || (e = c.from(e));
                                                            const r = this.alloc(t);
                                                            e.copy(this._buffer, r, 0, t);
                                                        }
                                                        const r = 4 - (t % 4 || 4);
                                                        if (r > 0) {
                                                            const e = this.alloc(r);
                                                            this._buffer.fill(0, e, this._index);
                                                        }
                                                    }
                                                    writeInt32BE(e) {
                                                        const t = this.alloc(4);
                                                        this._buffer.writeInt32BE(e, t);
                                                    }
                                                    writeUInt32BE(e) {
                                                        const t = this.alloc(4);
                                                        this._buffer.writeUInt32BE(e, t);
                                                    }
                                                    writeBigInt64BE(e) {
                                                        const t = this.alloc(8);
                                                        this._buffer.writeBigInt64BE(e, t);
                                                    }
                                                    writeBigUInt64BE(e) {
                                                        const t = this.alloc(8);
                                                        this._buffer.writeBigUInt64BE(e, t);
                                                    }
                                                    writeFloatBE(e) {
                                                        const t = this.alloc(4);
                                                        this._buffer.writeFloatBE(e, t);
                                                    }
                                                    writeDoubleBE(e) {
                                                        const t = this.alloc(8);
                                                        this._buffer.writeDoubleBE(e, t);
                                                    }
                                                    static bufferChunkSize = l;
                                                }
                                                var p = r(686).hp;
                                                class d {
                                                    toXDR(e = "raw") {
                                                        if (!this.write) return this.constructor.toXDR(this, e);
                                                        const t = new f;
                                                        return this.write(this, t), v(t.finalize(), e);
                                                    }
                                                    fromXDR(e, t = "raw") {
                                                        if (!this.read) return this.constructor.fromXDR(e, t);
                                                        const r = new u(b(e, t)), n = this.read(r);
                                                        return r.ensureInputConsumed(), n;
                                                    }
                                                    validateXDR(e, t = "raw") {
                                                        try {
                                                            return this.fromXDR(e, t), !0;
                                                        } catch (e) {
                                                            return !1;
                                                        }
                                                    }
                                                    static toXDR(e, t = "raw") {
                                                        const r = new f;
                                                        return this.write(e, r), v(r.finalize(), t);
                                                    }
                                                    static fromXDR(e, t = "raw") {
                                                        const r = new u(b(e, t)), n = this.read(r);
                                                        return r.ensureInputConsumed(), n;
                                                    }
                                                    static validateXDR(e, t = "raw") {
                                                        try {
                                                            return this.fromXDR(e, t), !0;
                                                        } catch (e) {
                                                            return !1;
                                                        }
                                                    }
                                                }
                                                class h extends d {
                                                    static read(e) {
                                                        throw new a;
                                                    }
                                                    static write(e, t) {
                                                        throw new a;
                                                    }
                                                    static isValid(e) {
                                                        return !1;
                                                    }
                                                }
                                                class y extends d {
                                                    isValid(e) {
                                                        return !1;
                                                    }
                                                }
                                                class m extends y {
                                                    constructor(e){
                                                        super(), this._maxDepth = e ?? m.DEFAULT_MAX_DEPTH;
                                                    }
                                                    static checkDepth(e) {
                                                        if (void 0 !== e) {
                                                            if (!Number.isFinite(e)) throw new TypeError(`remainingDepth (current remaining decoding depth budget) must be a finite number, got ${typeof e}: ${e}`);
                                                            if (e < 0) throw new o("exceeded max decoding depth");
                                                        }
                                                    }
                                                }
                                                m.DEFAULT_MAX_DEPTH = 200, m._maxDepth = m.DEFAULT_MAX_DEPTH;
                                                class g extends TypeError {
                                                    constructor(e){
                                                        super(`Invalid format ${e}, must be one of "raw", "hex", "base64"`);
                                                    }
                                                }
                                                function v(e, t) {
                                                    switch(t){
                                                        case "raw":
                                                            return e;
                                                        case "hex":
                                                            return e.toString("hex");
                                                        case "base64":
                                                            return e.toString("base64");
                                                        default:
                                                            throw new g(t);
                                                    }
                                                }
                                                function b(e, t) {
                                                    switch(t){
                                                        case "raw":
                                                            return e;
                                                        case "hex":
                                                            return p.from(e, "hex");
                                                        case "base64":
                                                            return p.from(e, "base64");
                                                        default:
                                                            throw new g(t);
                                                    }
                                                }
                                                function w(e, t) {
                                                    return null != e && (e instanceof t || S(e, t) && "function" == typeof e.constructor.read && "function" == typeof e.constructor.write && S(e, "XdrType"));
                                                }
                                                function S(e, t) {
                                                    do {
                                                        if (e.constructor.name === t) return !0;
                                                    }while (e = Object.getPrototypeOf(e));
                                                    return !1;
                                                }
                                                const A = 2147483647;
                                                class E extends h {
                                                    static read(e) {
                                                        return e.readInt32BE();
                                                    }
                                                    static write(e, t) {
                                                        if ("number" != typeof e) throw new n("not a number");
                                                        if ((0 | e) !== e) throw new n("invalid i32 value");
                                                        t.writeInt32BE(e);
                                                    }
                                                    static isValid(e) {
                                                        return "number" == typeof e && (0 | e) === e && e >= -2147483648 && e <= A;
                                                    }
                                                }
                                                function T(e, t) {
                                                    return `${t ? "u" : "i"}${e}`;
                                                }
                                                function O(e, t) {
                                                    if (t) return [
                                                        0n,
                                                        (1n << BigInt(e)) - 1n
                                                    ];
                                                    const r = 1n << BigInt(e - 1);
                                                    return [
                                                        0n - r,
                                                        r - 1n
                                                    ];
                                                }
                                                function k(e, t) {
                                                    const r = BigInt.asIntN(t, e) === e, n = BigInt.asUintN(t, e) === e;
                                                    if (!r && !n) throw new RangeError(`slice value ${e} does not fit in ${t} bits`);
                                                }
                                                E.MAX_VALUE = A, E.MIN_VALUE = 2147483648;
                                                class _ extends h {
                                                    constructor(e){
                                                        super(), this._value = function(e, t, r) {
                                                            e instanceof Array ? e.length && e[0] instanceof Array && (e = e[0]) : e = [
                                                                e
                                                            ];
                                                            const n = t / e.length;
                                                            switch(n){
                                                                case 32:
                                                                case 64:
                                                                case 128:
                                                                case 256:
                                                                    break;
                                                                default:
                                                                    throw new RangeError(`expected slices to fit in 32/64/128/256 bits, got ${e}`);
                                                            }
                                                            try {
                                                                for(let t = 0; t < e.length; t++)"bigint" != typeof e[t] && (e[t] = BigInt(e[t].valueOf()));
                                                            } catch (t) {
                                                                throw new TypeError(`expected bigint-like values, got: ${e} (${t})`);
                                                            }
                                                            if (1 === e.length) {
                                                                const n = e[0];
                                                                if (r && n < 0n) throw new RangeError(`expected a positive value, got: ${e}`);
                                                                const [o, i] = O(t, r);
                                                                if (n < o || n > i) throw new RangeError(`bigint value ${n} for ${T(t, r)} out of range [${o}, ${i}]`);
                                                                return n;
                                                            }
                                                            let o = 0n;
                                                            for(let t = 0; t < e.length; t++)k(e[t], n), o |= BigInt.asUintN(n, e[t]) << BigInt(t * n);
                                                            r || (o = BigInt.asIntN(t, o));
                                                            const [i, a] = O(t, r);
                                                            if (o >= i && o <= a) return o;
                                                            throw new RangeError(`bigint values [${e}] for ${T(t, r)} out of range [${i}, ${a}]: ${o}`);
                                                        }(e, this.size, this.unsigned);
                                                    }
                                                    get unsigned() {
                                                        throw new a;
                                                    }
                                                    get size() {
                                                        throw new a;
                                                    }
                                                    slice(e) {
                                                        return function(e, t, r) {
                                                            if ("bigint" != typeof e) throw new TypeError("Expected bigint 'value', got " + typeof e);
                                                            const n = t / r;
                                                            if (1 === n) return [
                                                                e
                                                            ];
                                                            if (r < 32 || r > 128 || 2 !== n && 4 !== n && 8 !== n) throw new TypeError(`invalid bigint (${e}) and slice size (${t} -> ${r}) combination`);
                                                            const o = BigInt(r), i = new Array(n);
                                                            for(let t = 0; t < n; t++)i[t] = BigInt.asIntN(r, e), e >>= o;
                                                            return i;
                                                        }(this._value, this.size, e);
                                                    }
                                                    toString() {
                                                        return this._value.toString();
                                                    }
                                                    toJSON() {
                                                        return {
                                                            _value: this._value.toString()
                                                        };
                                                    }
                                                    toBigInt() {
                                                        return BigInt(this._value);
                                                    }
                                                    static read(e) {
                                                        const { size: t, unsigned: r } = this.prototype;
                                                        return 64 === t ? new this(r ? e.readBigUInt64BE() : e.readBigInt64BE()) : new this(...Array.from({
                                                            length: t / 64
                                                        }, ()=>e.readBigUInt64BE()).reverse());
                                                    }
                                                    static write(e, t) {
                                                        if (e instanceof this) e = e._value;
                                                        else if ("bigint" != typeof e || e > this.MAX_VALUE || e < this.MIN_VALUE) throw new n(`${e} is not a ${this.name}`);
                                                        const { unsigned: r, size: o } = this.prototype;
                                                        if (64 === o) r ? t.writeBigUInt64BE(e) : t.writeBigInt64BE(e);
                                                        else {
                                                            const n = r ? e : BigInt.asUintN(o, e);
                                                            for(let e = o / 64 - 1; e >= 0; e--)t.writeBigUInt64BE(n >> BigInt(64 * e) & 0xffffffffffffffffn);
                                                        }
                                                    }
                                                    static isValid(e) {
                                                        return e instanceof this || "bigint" == typeof e && e >= this.MIN_VALUE && e <= this.MAX_VALUE;
                                                    }
                                                    static fromString(e) {
                                                        return new this(e);
                                                    }
                                                    static MAX_VALUE = 0n;
                                                    static MIN_VALUE = 0n;
                                                    static defineIntBoundaries() {
                                                        const [e, t] = O(this.prototype.size, this.prototype.unsigned);
                                                        this.MIN_VALUE = e, this.MAX_VALUE = t;
                                                    }
                                                }
                                                class x extends _ {
                                                    constructor(...e){
                                                        super(e);
                                                    }
                                                    get low() {
                                                        return 0 | Number(0xffffffffn & this._value);
                                                    }
                                                    get high() {
                                                        return 0 | Number(this._value >> 32n);
                                                    }
                                                    get size() {
                                                        return 64;
                                                    }
                                                    get unsigned() {
                                                        return !1;
                                                    }
                                                    static fromBits(e, t) {
                                                        return new this(e, t);
                                                    }
                                                }
                                                x.defineIntBoundaries();
                                                const P = 4294967295;
                                                class R extends h {
                                                    static read(e) {
                                                        return e.readUInt32BE();
                                                    }
                                                    static write(e, t) {
                                                        if ("number" != typeof e || !(e >= 0 && e <= P) || e % 1 != 0) throw new n("invalid u32 value");
                                                        t.writeUInt32BE(e);
                                                    }
                                                    static isValid(e) {
                                                        return "number" == typeof e && e % 1 == 0 && e >= 0 && e <= P;
                                                    }
                                                }
                                                R.MAX_VALUE = P, R.MIN_VALUE = 0;
                                                class I extends _ {
                                                    constructor(...e){
                                                        super(e);
                                                    }
                                                    get low() {
                                                        return 0 | Number(0xffffffffn & this._value);
                                                    }
                                                    get high() {
                                                        return 0 | Number(this._value >> 32n);
                                                    }
                                                    get size() {
                                                        return 64;
                                                    }
                                                    get unsigned() {
                                                        return !0;
                                                    }
                                                    static fromBits(e, t) {
                                                        return new this(e, t);
                                                    }
                                                }
                                                I.defineIntBoundaries();
                                                class B extends h {
                                                    static read(e) {
                                                        return e.readFloatBE();
                                                    }
                                                    static write(e, t) {
                                                        if ("number" != typeof e) throw new n("not a number");
                                                        t.writeFloatBE(e);
                                                    }
                                                    static isValid(e) {
                                                        return "number" == typeof e;
                                                    }
                                                }
                                                class C extends h {
                                                    static read(e) {
                                                        return e.readDoubleBE();
                                                    }
                                                    static write(e, t) {
                                                        if ("number" != typeof e) throw new n("not a number");
                                                        t.writeDoubleBE(e);
                                                    }
                                                    static isValid(e) {
                                                        return "number" == typeof e;
                                                    }
                                                }
                                                class j extends h {
                                                    static read() {
                                                        throw new i("quadruple not supported");
                                                    }
                                                    static write() {
                                                        throw new i("quadruple not supported");
                                                    }
                                                    static isValid() {
                                                        return !1;
                                                    }
                                                }
                                                class U extends h {
                                                    static read(e) {
                                                        const t = E.read(e);
                                                        switch(t){
                                                            case 0:
                                                                return !1;
                                                            case 1:
                                                                return !0;
                                                            default:
                                                                throw new o(`got ${t} when trying to read a bool`);
                                                        }
                                                    }
                                                    static write(e, t) {
                                                        const r = e ? 1 : 0;
                                                        E.write(r, t);
                                                    }
                                                    static isValid(e) {
                                                        return "boolean" == typeof e;
                                                    }
                                                }
                                                var N = r(686).hp;
                                                class L extends y {
                                                    constructor(e = R.MAX_VALUE){
                                                        super(), this._maxLength = e;
                                                    }
                                                    read(e) {
                                                        const t = R.read(e);
                                                        if (t > this._maxLength) throw new o(`saw ${t} length String, max allowed is ${this._maxLength}`);
                                                        return e.read(t);
                                                    }
                                                    readString(e) {
                                                        return this.read(e).toString("utf8");
                                                    }
                                                    write(e, t) {
                                                        const r = "string" == typeof e ? N.byteLength(e, "utf8") : e.length;
                                                        if (r > this._maxLength) throw new n(`got ${e.length} bytes, max allowed is ${this._maxLength}`);
                                                        R.write(r, t), t.write(e, r);
                                                    }
                                                    isValid(e) {
                                                        return "string" == typeof e ? N.byteLength(e, "utf8") <= this._maxLength : !!(e instanceof Array || N.isBuffer(e)) && e.length <= this._maxLength;
                                                    }
                                                }
                                                var F = r(686).hp;
                                                class D extends y {
                                                    constructor(e){
                                                        super(), this._length = e;
                                                    }
                                                    read(e) {
                                                        return e.read(this._length);
                                                    }
                                                    write(e, t) {
                                                        const { length: r } = e;
                                                        if (r !== this._length) throw new n(`got ${e.length} bytes, expected ${this._length}`);
                                                        t.write(e, r);
                                                    }
                                                    isValid(e) {
                                                        return F.isBuffer(e) && e.length === this._length;
                                                    }
                                                }
                                                var M = r(686).hp;
                                                class V extends y {
                                                    constructor(e = R.MAX_VALUE){
                                                        super(), this._maxLength = e;
                                                    }
                                                    read(e) {
                                                        const t = R.read(e);
                                                        if (t > this._maxLength) throw new o(`saw ${t} length VarOpaque, max allowed is ${this._maxLength}`);
                                                        return e.read(t);
                                                    }
                                                    write(e, t) {
                                                        const { length: r } = e;
                                                        if (e.length > this._maxLength) throw new n(`got ${e.length} bytes, max allowed is ${this._maxLength}`);
                                                        R.write(r, t), t.write(e, r);
                                                    }
                                                    isValid(e) {
                                                        return M.isBuffer(e) && e.length <= this._maxLength;
                                                    }
                                                }
                                                class q extends m {
                                                    constructor(e, t, r = m.DEFAULT_MAX_DEPTH){
                                                        super(r), this._childType = e, this._length = t;
                                                    }
                                                    read(e, t = this._maxDepth) {
                                                        if (this._length > e.remainingBytes()) throw new o(`Array length ${this._length} exceeds remaining ${e.remainingBytes()} bytes`);
                                                        m.checkDepth(t);
                                                        const r = [];
                                                        for(let n = 0; n < this._length; n++)r.push(this._childType.read(e, t - 1));
                                                        return r;
                                                    }
                                                    write(e, t) {
                                                        if (!r.g.Array.isArray(e)) throw new n("value is not array");
                                                        if (e.length !== this._length) throw new n(`got array of size ${e.length}, expected ${this._length}`);
                                                        for (const r of e)this._childType.write(r, t);
                                                    }
                                                    isValid(e) {
                                                        if (!(e instanceof r.g.Array) || e.length !== this._length) return !1;
                                                        for (const t of e)if (!this._childType.isValid(t)) return !1;
                                                        return !0;
                                                    }
                                                }
                                                class G extends m {
                                                    constructor(e, t = R.MAX_VALUE, r = m.DEFAULT_MAX_DEPTH){
                                                        super(r), this._childType = e, this._maxLength = t;
                                                    }
                                                    read(e, t = this._maxDepth) {
                                                        m.checkDepth(t);
                                                        const r = R.read(e);
                                                        if (r > this._maxLength) throw new o(`saw ${r} length VarArray, max allowed is ${this._maxLength}`);
                                                        if (r > e.remainingBytes()) throw new o(`VarArray length ${r} exceeds remaining ${e.remainingBytes()} bytes`);
                                                        const n = [];
                                                        for(let o = 0; o < r; o++)n.push(this._childType.read(e, t - 1));
                                                        return n;
                                                    }
                                                    write(e, t) {
                                                        if (!(e instanceof Array)) throw new n("value is not array");
                                                        if (e.length > this._maxLength) throw new n(`got array of size ${e.length}, max allowed is ${this._maxLength}`);
                                                        R.write(e.length, t);
                                                        for (const r of e)this._childType.write(r, t);
                                                    }
                                                    isValid(e) {
                                                        if (!(e instanceof Array) || e.length > this._maxLength) return !1;
                                                        for (const t of e)if (!this._childType.isValid(t)) return !1;
                                                        return !0;
                                                    }
                                                }
                                                class H extends m {
                                                    constructor(e, t = m.DEFAULT_MAX_DEPTH){
                                                        super(t), this._childType = e;
                                                    }
                                                    read(e, t = this._maxDepth) {
                                                        if (m.checkDepth(t), U.read(e)) return this._childType.read(e, t - 1);
                                                    }
                                                    write(e, t) {
                                                        const r = null != e;
                                                        U.write(r, t), r && this._childType.write(e, t);
                                                    }
                                                    isValid(e) {
                                                        return null == e || this._childType.isValid(e);
                                                    }
                                                }
                                                class z extends h {
                                                    static read() {}
                                                    static write(e) {
                                                        if (void 0 !== e) throw new n("trying to write value to a void slot");
                                                    }
                                                    static isValid(e) {
                                                        return void 0 === e;
                                                    }
                                                }
                                                class W extends h {
                                                    constructor(e, t){
                                                        super(), this.name = e, this.value = t;
                                                    }
                                                    static read(e) {
                                                        const t = E.read(e), r = this._byValue[t];
                                                        if (void 0 === r) throw new o(`unknown ${this.enumName} member for value ${t}`);
                                                        return r;
                                                    }
                                                    static write(e, t) {
                                                        if (!this.isValid(e)) throw new n(`${e} has enum name ${e?.enumName}, not ${this.enumName}: ${JSON.stringify(e)}`);
                                                        E.write(e.value, t);
                                                    }
                                                    static isValid(e) {
                                                        return e?.constructor?.enumName === this.enumName || w(e, this);
                                                    }
                                                    static members() {
                                                        return this._members;
                                                    }
                                                    static values() {
                                                        return Object.values(this._members);
                                                    }
                                                    static fromName(e) {
                                                        const t = this._members[e];
                                                        if (!t) throw new TypeError(`${e} is not a member of ${this.enumName}`);
                                                        return t;
                                                    }
                                                    static fromValue(e) {
                                                        const t = this._byValue[e];
                                                        if (void 0 === t) throw new TypeError(`${e} is not a value of any member of ${this.enumName}`);
                                                        return t;
                                                    }
                                                    static create(e, t, r) {
                                                        const n = class extends W {
                                                        };
                                                        n.enumName = t, e.results[t] = n, n._members = {}, n._byValue = {};
                                                        for (const [e, t] of Object.entries(r)){
                                                            const r = new n(e, t);
                                                            n._members[e] = r, n._byValue[t] = r, n[e] = ()=>r;
                                                        }
                                                        return n;
                                                    }
                                                }
                                                class X extends h {
                                                    resolve() {
                                                        throw new i('"resolve" method should be implemented in the descendant class');
                                                    }
                                                }
                                                class K extends m {
                                                    constructor(e, t){
                                                        super(t ?? new.target?._maxDepth), this._attributes = e || {};
                                                    }
                                                    static read(e, t = this._maxDepth) {
                                                        m.checkDepth(t);
                                                        const r = {};
                                                        for (const [n, o] of this._fields)r[n] = o.read(e, t - 1);
                                                        return new this(r, this._maxDepth);
                                                    }
                                                    static write(e, t) {
                                                        if (!this.isValid(e)) throw new n(`${e} has struct name ${e?.constructor?.structName}, not ${this.structName}: ${JSON.stringify(e)}`);
                                                        for (const [r, n] of this._fields){
                                                            const o = e._attributes[r];
                                                            n.write(o, t);
                                                        }
                                                    }
                                                    static isValid(e) {
                                                        return e?.constructor?.structName === this.structName || w(e, this);
                                                    }
                                                    static create(e, t, r, n = m.DEFAULT_MAX_DEPTH) {
                                                        const o = class extends K {
                                                        };
                                                        o.structName = t, o._maxDepth = n, e.results[t] = o;
                                                        const i = new Array(r.length);
                                                        for(let t = 0; t < r.length; t++){
                                                            const n = r[t], a = n[0];
                                                            let s = n[1];
                                                            s instanceof X && (s = s.resolve(e)), i[t] = [
                                                                a,
                                                                s
                                                            ], o.prototype[a] = Z(a);
                                                        }
                                                        return o._fields = i, o;
                                                    }
                                                }
                                                function Z(e) {
                                                    return function(t) {
                                                        return void 0 !== t && (this._attributes[e] = t), this._attributes[e];
                                                    };
                                                }
                                                class $ extends m {
                                                    constructor(e, t, r){
                                                        super(r ?? new.target?._maxDepth), this.set(e, t);
                                                    }
                                                    set(e, t) {
                                                        "string" == typeof e && (e = this.constructor._switchOn.fromName(e)), this._switch = e;
                                                        const r = this.constructor.armForSwitch(this._switch);
                                                        this._arm = r, this._armType = r === z ? z : this.constructor._arms[r], this._value = t;
                                                    }
                                                    get(e = this._arm) {
                                                        if (this._arm !== z && this._arm !== e) throw new TypeError(`${e} not set`);
                                                        return this._value;
                                                    }
                                                    switch() {
                                                        return this._switch;
                                                    }
                                                    arm() {
                                                        return this._arm;
                                                    }
                                                    armType() {
                                                        return this._armType;
                                                    }
                                                    value() {
                                                        return this._value;
                                                    }
                                                    static armForSwitch(e) {
                                                        const t = this._switches.get(e);
                                                        if (void 0 !== t) return t;
                                                        if (this._defaultArm) return this._defaultArm;
                                                        throw new TypeError(`Bad union switch: ${e}`);
                                                    }
                                                    static armTypeForArm(e) {
                                                        return e === z ? z : this._arms[e];
                                                    }
                                                    static read(e, t = this._maxDepth) {
                                                        m.checkDepth(t);
                                                        const r = this._switchOn.read(e, t - 1), n = this.armForSwitch(r), o = n === z ? z : this._arms[n];
                                                        let i;
                                                        return i = void 0 !== o ? o.read(e, t - 1) : n.read(e, t - 1), new this(r, i, this._maxDepth);
                                                    }
                                                    static write(e, t) {
                                                        if (!this.isValid(e)) throw new n(`${e} has union name ${e?.unionName}, not ${this.unionName}: ${JSON.stringify(e)}`);
                                                        this._switchOn.write(e.switch(), t), e.armType().write(e.value(), t);
                                                    }
                                                    static isValid(e) {
                                                        return e?.constructor?.unionName === this.unionName || w(e, this);
                                                    }
                                                    static create(e, t, r, n = m.DEFAULT_MAX_DEPTH) {
                                                        const o = class extends $ {
                                                        };
                                                        o.unionName = t, o._maxDepth = n, e.results[t] = o, r.switchOn instanceof X ? o._switchOn = r.switchOn.resolve(e) : o._switchOn = r.switchOn, o._switches = new Map, o._arms = {};
                                                        let i = r.defaultArm;
                                                        i instanceof X && (i = i.resolve(e)), o._defaultArm = i;
                                                        for (const [e, t] of r.switches){
                                                            const r = "string" == typeof e ? o._switchOn.fromName(e) : e;
                                                            o._switches.set(r, t);
                                                        }
                                                        if (void 0 !== o._switchOn.values) for (const e of o._switchOn.values())o[e.name] = function(t) {
                                                            return new o(e, t);
                                                        }, o.prototype[e.name] = function(t) {
                                                            return this.set(e, t);
                                                        };
                                                        if (r.arms) for (const [t, n] of Object.entries(r.arms))o._arms[t] = n instanceof X ? n.resolve(e) : n, n !== z && (o.prototype[t] = function() {
                                                            return this.get(t);
                                                        });
                                                        return o;
                                                    }
                                                }
                                                class Y extends X {
                                                    constructor(e){
                                                        super(), this.name = e;
                                                    }
                                                    resolve(e) {
                                                        return e.definitions[this.name].resolve(e);
                                                    }
                                                }
                                                class Q extends X {
                                                    constructor(e, t, r = !1){
                                                        super(), this.childReference = e, this.length = t, this.variable = r;
                                                    }
                                                    resolve(e) {
                                                        let t = this.childReference, r = this.length;
                                                        return t instanceof X && (t = t.resolve(e)), r instanceof X && (r = r.resolve(e)), this.variable ? new G(t, r) : new q(t, r);
                                                    }
                                                }
                                                class J extends X {
                                                    constructor(e){
                                                        super(), this.childReference = e, this.name = e.name;
                                                    }
                                                    resolve(e) {
                                                        let t = this.childReference;
                                                        return t instanceof X && (t = t.resolve(e)), new H(t);
                                                    }
                                                }
                                                class ee extends X {
                                                    constructor(e, t){
                                                        super(), this.sizedType = e, this.length = t;
                                                    }
                                                    resolve(e) {
                                                        let t = this.length;
                                                        return t instanceof X && (t = t.resolve(e)), new this.sizedType(t);
                                                    }
                                                }
                                                class te {
                                                    constructor(e, t, r){
                                                        this.constructor = e, this.name = t, this.config = r;
                                                    }
                                                    resolve(e) {
                                                        return this.name in e.results ? e.results[this.name] : this.constructor(e, this.name, this.config);
                                                    }
                                                }
                                                function re(e, t, r) {
                                                    return r instanceof X && (r = r.resolve(e)), e.results[t] = r, r;
                                                }
                                                function ne(e, t, r) {
                                                    return e.results[t] = r, r;
                                                }
                                                class oe {
                                                    constructor(e){
                                                        this._destination = e, this._definitions = {};
                                                    }
                                                    enum(e, t) {
                                                        const r = new te(W.create, e, t);
                                                        this.define(e, r);
                                                    }
                                                    struct(e, t) {
                                                        const r = new te(K.create, e, t);
                                                        this.define(e, r);
                                                    }
                                                    union(e, t) {
                                                        const r = new te($.create, e, t);
                                                        this.define(e, r);
                                                    }
                                                    typedef(e, t) {
                                                        const r = new te(re, e, t);
                                                        this.define(e, r);
                                                    }
                                                    const(e, t) {
                                                        const r = new te(ne, e, t);
                                                        this.define(e, r);
                                                    }
                                                    void() {
                                                        return z;
                                                    }
                                                    bool() {
                                                        return U;
                                                    }
                                                    int() {
                                                        return E;
                                                    }
                                                    hyper() {
                                                        return x;
                                                    }
                                                    uint() {
                                                        return R;
                                                    }
                                                    uhyper() {
                                                        return I;
                                                    }
                                                    float() {
                                                        return B;
                                                    }
                                                    double() {
                                                        return C;
                                                    }
                                                    quadruple() {
                                                        return j;
                                                    }
                                                    string(e) {
                                                        return new ee(L, e);
                                                    }
                                                    opaque(e) {
                                                        return new ee(D, e);
                                                    }
                                                    varOpaque(e) {
                                                        return new ee(V, e);
                                                    }
                                                    array(e, t) {
                                                        return new Q(e, t);
                                                    }
                                                    varArray(e, t) {
                                                        return new Q(e, t, !0);
                                                    }
                                                    option(e) {
                                                        return new J(e);
                                                    }
                                                    define(e, t) {
                                                        if (void 0 !== this._destination[e]) throw new i(`${e} is already defined`);
                                                        this._definitions[e] = t;
                                                    }
                                                    lookup(e) {
                                                        return new Y(e);
                                                    }
                                                    resolve() {
                                                        for (const e of Object.values(this._definitions))e.resolve({
                                                            definitions: this._definitions,
                                                            results: this._destination
                                                        });
                                                    }
                                                }
                                                function ie(e, t = {}) {
                                                    if (e) {
                                                        const r = new oe(t);
                                                        e(r), r.resolve();
                                                    }
                                                    return t;
                                                }
                                            },
                                            947 (e, t) {
                                                t.read = function(e, t, r, n, o) {
                                                    var i, a, s = 8 * o - n - 1, u = (1 << s) - 1, c = u >> 1, l = -7, f = r ? o - 1 : 0, p = r ? -1 : 1, d = e[t + f];
                                                    for(f += p, i = d & (1 << -l) - 1, d >>= -l, l += s; l > 0; i = 256 * i + e[t + f], f += p, l -= 8);
                                                    for(a = i & (1 << -l) - 1, i >>= -l, l += n; l > 0; a = 256 * a + e[t + f], f += p, l -= 8);
                                                    if (0 === i) i = 1 - c;
                                                    else {
                                                        if (i === u) return a ? NaN : 1 / 0 * (d ? -1 : 1);
                                                        a += Math.pow(2, n), i -= c;
                                                    }
                                                    return (d ? -1 : 1) * a * Math.pow(2, i - n);
                                                }, t.write = function(e, t, r, n, o, i) {
                                                    var a, s, u, c = 8 * i - o - 1, l = (1 << c) - 1, f = l >> 1, p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : i - 1, h = n ? 1 : -1, y = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                                                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + f >= 1 ? p / u : p * Math.pow(2, 1 - f)) * u >= 2 && (a++, u /= 2), a + f >= l ? (s = 0, a = l) : a + f >= 1 ? (s = (t * u - 1) * Math.pow(2, o), a += f) : (s = t * Math.pow(2, f - 1) * Math.pow(2, o), a = 0)); o >= 8; e[r + d] = 255 & s, d += h, s /= 256, o -= 8);
                                                    for(a = a << o | s, c += o; c > 0; e[r + d] = 255 & a, d += h, a /= 256, c -= 8);
                                                    e[r + d - h] |= 128 * y;
                                                };
                                            }
                                        }, t = {};
                                        function r(n) {
                                            var o = t[n];
                                            if (void 0 !== o) return o.exports;
                                            var i = t[n] = {
                                                exports: {}
                                            };
                                            return e[n](i, i.exports, r), i.exports;
                                        }
                                        return r.d = (e, t)=>{
                                            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                                                enumerable: !0,
                                                get: t[n]
                                            });
                                        }, r.g = function() {
                                            if ("object" == typeof globalThis) return globalThis;
                                            try {
                                                return this || new Function("return this")();
                                            } catch (e) {
                                                if ("object" == typeof window) return window;
                                            }
                                        }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
                                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                                value: "Module"
                                            }), Object.defineProperty(e, "__esModule", {
                                                value: !0
                                            });
                                        }, r(348);
                                    })(), e.exports = n();
                            },
                            3918 (e, t, r) {
                                "use strict";
                                var n = r(5606);
                                function o(e, t) {
                                    var r = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var n = Object.getOwnPropertySymbols(e);
                                        t && (n = n.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), r.push.apply(r, n);
                                    }
                                    return r;
                                }
                                function i(e) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var r = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? o(Object(r), !0).forEach(function(t) {
                                            a(e, t, r[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                        });
                                    }
                                    return e;
                                }
                                function a(e, t, r) {
                                    return (t = u(t)) in e ? Object.defineProperty(e, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = r, e;
                                }
                                function s(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, u(n.key), n);
                                    }
                                }
                                function u(e) {
                                    var t = function(e) {
                                        if ("object" !== m(e) || null === e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" !== m(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" === m(t) ? t : String(t);
                                }
                                function c(e, t) {
                                    if (t && ("object" === m(t) || "function" == typeof t)) return t;
                                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                    return l(e);
                                }
                                function l(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }
                                function f(e) {
                                    var t = "function" == typeof Map ? new Map : void 0;
                                    return f = function(e) {
                                        if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
                                        var r;
                                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                                        if (void 0 !== t) {
                                            if (t.has(e)) return t.get(e);
                                            t.set(e, n);
                                        }
                                        function n() {
                                            return p(e, arguments, y(this).constructor);
                                        }
                                        return n.prototype = Object.create(e.prototype, {
                                            constructor: {
                                                value: n,
                                                enumerable: !1,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), h(n, e);
                                    }, f(e);
                                }
                                function p(e, t, r) {
                                    return p = d() ? Reflect.construct.bind() : function(e, t, r) {
                                        var n = [
                                            null
                                        ];
                                        n.push.apply(n, t);
                                        var o = new (Function.bind.apply(e, n));
                                        return r && h(o, r.prototype), o;
                                    }, p.apply(null, arguments);
                                }
                                function d() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }
                                function h(e, t) {
                                    return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, h(e, t);
                                }
                                function y(e) {
                                    return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, y(e);
                                }
                                function m(e) {
                                    return m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, m(e);
                                }
                                var g = r(537).inspect, v = r(9597).codes.ERR_INVALID_ARG_TYPE;
                                function b(e, t, r) {
                                    return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                                }
                                var w = "", S = "", A = "", E = "", T = {
                                    deepStrictEqual: "Expected values to be strictly deep-equal:",
                                    strictEqual: "Expected values to be strictly equal:",
                                    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                                    deepEqual: "Expected values to be loosely deep-equal:",
                                    equal: "Expected values to be loosely equal:",
                                    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                                    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                                    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                                    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                                    notEqual: 'Expected "actual" to be loosely unequal to:',
                                    notIdentical: "Values identical but not reference-equal:"
                                };
                                function O(e) {
                                    var t = Object.keys(e), r = Object.create(Object.getPrototypeOf(e));
                                    return t.forEach(function(t) {
                                        r[t] = e[t];
                                    }), Object.defineProperty(r, "message", {
                                        value: e.message
                                    }), r;
                                }
                                function k(e) {
                                    return g(e, {
                                        compact: !1,
                                        customInspect: !1,
                                        depth: 1e3,
                                        maxArrayLength: 1 / 0,
                                        showHidden: !1,
                                        breakLength: 1 / 0,
                                        showProxy: !1,
                                        sorted: !0,
                                        getters: !0
                                    });
                                }
                                function _(e, t, r) {
                                    var o = "", i = "", a = 0, s = "", u = !1, c = k(e), l = c.split("\n"), f = k(t).split("\n"), p = 0, d = "";
                                    if ("strictEqual" === r && "object" === m(e) && "object" === m(t) && null !== e && null !== t && (r = "strictEqualObject"), 1 === l.length && 1 === f.length && l[0] !== f[0]) {
                                        var h = l[0].length + f[0].length;
                                        if (h <= 10) {
                                            if (!("object" === m(e) && null !== e || "object" === m(t) && null !== t || 0 === e && 0 === t)) return "".concat(T[r], "\n\n") + "".concat(l[0], " !== ").concat(f[0], "\n");
                                        } else if ("strictEqualObject" !== r && h < (n.stderr && n.stderr.isTTY ? n.stderr.columns : 80)) {
                                            for(; l[0][p] === f[0][p];)p++;
                                            p > 2 && (d = "\n  ".concat(function(e, t) {
                                                if (t = Math.floor(t), 0 == e.length || 0 == t) return "";
                                                var r = e.length * t;
                                                for(t = Math.floor(Math.log(t) / Math.log(2)); t;)e += e, t--;
                                                return e + e.substring(0, r - e.length);
                                            }(" ", p), "^"), p = 0);
                                        }
                                    }
                                    for(var y = l[l.length - 1], g = f[f.length - 1]; y === g && (p++ < 2 ? s = "\n  ".concat(y).concat(s) : o = y, l.pop(), f.pop(), 0 !== l.length && 0 !== f.length);)y = l[l.length - 1], g = f[f.length - 1];
                                    var v = Math.max(l.length, f.length);
                                    if (0 === v) {
                                        var O = c.split("\n");
                                        if (O.length > 30) for(O[26] = "".concat(w, "...").concat(E); O.length > 27;)O.pop();
                                        return "".concat(T.notIdentical, "\n\n").concat(O.join("\n"), "\n");
                                    }
                                    p > 3 && (s = "\n".concat(w, "...").concat(E).concat(s), u = !0), "" !== o && (s = "\n  ".concat(o).concat(s), o = "");
                                    var _ = 0, x = T[r] + "\n".concat(S, "+ actual").concat(E, " ").concat(A, "- expected").concat(E), P = " ".concat(w, "...").concat(E, " Lines skipped");
                                    for(p = 0; p < v; p++){
                                        var R = p - a;
                                        if (l.length < p + 1) R > 1 && p > 2 && (R > 4 ? (i += "\n".concat(w, "...").concat(E), u = !0) : R > 3 && (i += "\n  ".concat(f[p - 2]), _++), i += "\n  ".concat(f[p - 1]), _++), a = p, o += "\n".concat(A, "-").concat(E, " ").concat(f[p]), _++;
                                        else if (f.length < p + 1) R > 1 && p > 2 && (R > 4 ? (i += "\n".concat(w, "...").concat(E), u = !0) : R > 3 && (i += "\n  ".concat(l[p - 2]), _++), i += "\n  ".concat(l[p - 1]), _++), a = p, i += "\n".concat(S, "+").concat(E, " ").concat(l[p]), _++;
                                        else {
                                            var I = f[p], B = l[p], C = B !== I && (!b(B, ",") || B.slice(0, -1) !== I);
                                            C && b(I, ",") && I.slice(0, -1) === B && (C = !1, B += ","), C ? (R > 1 && p > 2 && (R > 4 ? (i += "\n".concat(w, "...").concat(E), u = !0) : R > 3 && (i += "\n  ".concat(l[p - 2]), _++), i += "\n  ".concat(l[p - 1]), _++), a = p, i += "\n".concat(S, "+").concat(E, " ").concat(B), o += "\n".concat(A, "-").concat(E, " ").concat(I), _ += 2) : (i += o, o = "", 1 !== R && 0 !== p || (i += "\n  ".concat(B), _++));
                                        }
                                        if (_ > 20 && p < v - 2) return "".concat(x).concat(P, "\n").concat(i, "\n").concat(w, "...").concat(E).concat(o, "\n") + "".concat(w, "...").concat(E);
                                    }
                                    return "".concat(x).concat(u ? P : "", "\n").concat(i).concat(o).concat(s).concat(d);
                                }
                                var x = function(e, t) {
                                    !function(e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(e, "prototype", {
                                            writable: !1
                                        }), t && h(e, t);
                                    }(p, e);
                                    var r, o, a, u, f = (r = p, o = d(), function() {
                                        var e, t = y(r);
                                        if (o) {
                                            var n = y(this).constructor;
                                            e = Reflect.construct(t, arguments, n);
                                        } else e = t.apply(this, arguments);
                                        return c(this, e);
                                    });
                                    function p(e) {
                                        var t;
                                        if (function(e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                        }(this, p), "object" !== m(e) || null === e) throw new v("options", "Object", e);
                                        var r = e.message, o = e.operator, i = e.stackStartFn, a = e.actual, s = e.expected, u = Error.stackTraceLimit;
                                        if (Error.stackTraceLimit = 0, null != r) t = f.call(this, String(r));
                                        else if (n.stderr && n.stderr.isTTY && (n.stderr && n.stderr.getColorDepth && 1 !== n.stderr.getColorDepth() ? (w = "\x1b[34m", S = "\x1b[32m", E = "\x1b[39m", A = "\x1b[31m") : (w = "", S = "", E = "", A = "")), "object" === m(a) && null !== a && "object" === m(s) && null !== s && "stack" in a && a instanceof Error && "stack" in s && s instanceof Error && (a = O(a), s = O(s)), "deepStrictEqual" === o || "strictEqual" === o) t = f.call(this, _(a, s, o));
                                        else if ("notDeepStrictEqual" === o || "notStrictEqual" === o) {
                                            var d = T[o], h = k(a).split("\n");
                                            if ("notStrictEqual" === o && "object" === m(a) && null !== a && (d = T.notStrictEqualObject), h.length > 30) for(h[26] = "".concat(w, "...").concat(E); h.length > 27;)h.pop();
                                            t = 1 === h.length ? f.call(this, "".concat(d, " ").concat(h[0])) : f.call(this, "".concat(d, "\n\n").concat(h.join("\n"), "\n"));
                                        } else {
                                            var y = k(a), g = "", b = T[o];
                                            "notDeepEqual" === o || "notEqual" === o ? (y = "".concat(T[o], "\n\n").concat(y)).length > 1024 && (y = "".concat(y.slice(0, 1021), "...")) : (g = "".concat(k(s)), y.length > 512 && (y = "".concat(y.slice(0, 509), "...")), g.length > 512 && (g = "".concat(g.slice(0, 509), "...")), "deepEqual" === o || "equal" === o ? y = "".concat(b, "\n\n").concat(y, "\n\nshould equal\n\n") : g = " ".concat(o, " ").concat(g)), t = f.call(this, "".concat(y).concat(g));
                                        }
                                        return Error.stackTraceLimit = u, t.generatedMessage = !r, Object.defineProperty(l(t), "name", {
                                            value: "AssertionError [ERR_ASSERTION]",
                                            enumerable: !1,
                                            writable: !0,
                                            configurable: !0
                                        }), t.code = "ERR_ASSERTION", t.actual = a, t.expected = s, t.operator = o, Error.captureStackTrace && Error.captureStackTrace(l(t), i), t.stack, t.name = "AssertionError", c(t);
                                    }
                                    return a = p, u = [
                                        {
                                            key: "toString",
                                            value: function() {
                                                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                                            }
                                        },
                                        {
                                            key: t,
                                            value: function(e, t) {
                                                return g(this, i(i({}, t), {}, {
                                                    customInspect: !1,
                                                    depth: 0
                                                }));
                                            }
                                        }
                                    ], s(a.prototype, u), Object.defineProperty(a, "prototype", {
                                        writable: !1
                                    }), p;
                                }(f(Error), g.custom);
                                e.exports = x;
                            },
                            4035 (e, t, r) {
                                "use strict";
                                var n, o = r(6556), i = r(9092)(), a = r(9957), s = r(5795);
                                if (i) {
                                    var u = o("RegExp.prototype.exec"), c = {}, l = function() {
                                        throw c;
                                    }, f = {
                                        toString: l,
                                        valueOf: l
                                    };
                                    "symbol" == typeof Symbol.toPrimitive && (f[Symbol.toPrimitive] = l), n = function(e) {
                                        if (!e || "object" != typeof e) return !1;
                                        var t = s(e, "lastIndex");
                                        if (!t || !a(t, "value")) return !1;
                                        try {
                                            u(e, f);
                                        } catch (e) {
                                            return e === c;
                                        }
                                    };
                                } else {
                                    var p = o("Object.prototype.toString");
                                    n = function(e) {
                                        return !(!e || "object" != typeof e && "function" != typeof e) && "[object RegExp]" === p(e);
                                    };
                                }
                                e.exports = n;
                            },
                            4039 (e, t, r) {
                                "use strict";
                                var n = "undefined" != typeof Symbol && Symbol, o = r(1333);
                                e.exports = function() {
                                    return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && o();
                                };
                            },
                            4107 (e, t, r) {
                                "use strict";
                                var n = r(6698), o = r(392), i = r(2861).Buffer, a = [
                                    1116352408,
                                    1899447441,
                                    3049323471,
                                    3921009573,
                                    961987163,
                                    1508970993,
                                    2453635748,
                                    2870763221,
                                    3624381080,
                                    310598401,
                                    607225278,
                                    1426881987,
                                    1925078388,
                                    2162078206,
                                    2614888103,
                                    3248222580,
                                    3835390401,
                                    4022224774,
                                    264347078,
                                    604807628,
                                    770255983,
                                    1249150122,
                                    1555081692,
                                    1996064986,
                                    2554220882,
                                    2821834349,
                                    2952996808,
                                    3210313671,
                                    3336571891,
                                    3584528711,
                                    113926993,
                                    338241895,
                                    666307205,
                                    773529912,
                                    1294757372,
                                    1396182291,
                                    1695183700,
                                    1986661051,
                                    2177026350,
                                    2456956037,
                                    2730485921,
                                    2820302411,
                                    3259730800,
                                    3345764771,
                                    3516065817,
                                    3600352804,
                                    4094571909,
                                    275423344,
                                    430227734,
                                    506948616,
                                    659060556,
                                    883997877,
                                    958139571,
                                    1322822218,
                                    1537002063,
                                    1747873779,
                                    1955562222,
                                    2024104815,
                                    2227730452,
                                    2361852424,
                                    2428436474,
                                    2756734187,
                                    3204031479,
                                    3329325298
                                ], s = new Array(64);
                                function u() {
                                    this.init(), this._w = s, o.call(this, 64, 56);
                                }
                                function c(e, t, r) {
                                    return r ^ e & (t ^ r);
                                }
                                function l(e, t, r) {
                                    return e & t | r & (e | t);
                                }
                                function f(e) {
                                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                                }
                                function p(e) {
                                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                                }
                                function d(e) {
                                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                                }
                                function h(e) {
                                    return (e >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10;
                                }
                                n(u, o), u.prototype.init = function() {
                                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                                }, u.prototype._update = function(e) {
                                    for(var t = this._w, r = 0 | this._a, n = 0 | this._b, o = 0 | this._c, i = 0 | this._d, s = 0 | this._e, u = 0 | this._f, y = 0 | this._g, m = 0 | this._h, g = 0; g < 16; ++g)t[g] = e.readInt32BE(4 * g);
                                    for(; g < 64; ++g)t[g] = h(t[g - 2]) + t[g - 7] + d(t[g - 15]) + t[g - 16] | 0;
                                    for(var v = 0; v < 64; ++v){
                                        var b = m + p(s) + c(s, u, y) + a[v] + t[v] | 0, w = f(r) + l(r, n, o) | 0;
                                        m = y, y = u, u = s, s = i + b | 0, i = o, o = n, n = r, r = b + w | 0;
                                    }
                                    this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = o + this._c | 0, this._d = i + this._d | 0, this._e = s + this._e | 0, this._f = u + this._f | 0, this._g = y + this._g | 0, this._h = m + this._h | 0;
                                }, u.prototype._hash = function() {
                                    var e = i.allocUnsafe(32);
                                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                                }, e.exports = u;
                            },
                            4133 (e, t, r) {
                                "use strict";
                                var n = r(487), o = r(8452), i = r(3003), a = r(6642), s = r(2464), u = n(a(), Number);
                                o(u, {
                                    getPolyfill: a,
                                    implementation: i,
                                    shim: s
                                }), e.exports = u;
                            },
                            4148 (e, t, r) {
                                "use strict";
                                var n = r(5606), o = r(6763);
                                function i(e) {
                                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, i(e);
                                }
                                function a(e, t) {
                                    for(var r = 0; r < t.length; r++){
                                        var n = t[r];
                                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, s(n.key), n);
                                    }
                                }
                                function s(e) {
                                    var t = function(e) {
                                        if ("object" !== i(e) || null === e) return e;
                                        var t = e[Symbol.toPrimitive];
                                        if (void 0 !== t) {
                                            var r = t.call(e, "string");
                                            if ("object" !== i(r)) return r;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e);
                                    }(e);
                                    return "symbol" === i(t) ? t : String(t);
                                }
                                var u, c, l = r(9597).codes, f = l.ERR_AMBIGUOUS_ARGUMENT, p = l.ERR_INVALID_ARG_TYPE, d = l.ERR_INVALID_ARG_VALUE, h = l.ERR_INVALID_RETURN_VALUE, y = l.ERR_MISSING_ARGS, m = r(3918), g = r(537).inspect, v = r(537).types, b = v.isPromise, w = v.isRegExp, S = r(9133)(), A = r(9394)(), E = r(8075)("RegExp.prototype.test");
                                function T() {
                                    var e = r(2299);
                                    u = e.isDeepEqual, c = e.isDeepStrictEqual;
                                }
                                new Map;
                                var O = !1, k = e.exports = R, _ = {};
                                function x(e) {
                                    if (e.message instanceof Error) throw e.message;
                                    throw new m(e);
                                }
                                function P(e, t, r, n) {
                                    if (!r) {
                                        var o = !1;
                                        if (0 === t) o = !0, n = "No value argument passed to `assert.ok()`";
                                        else if (n instanceof Error) throw n;
                                        var i = new m({
                                            actual: r,
                                            expected: !0,
                                            message: n,
                                            operator: "==",
                                            stackStartFn: e
                                        });
                                        throw i.generatedMessage = o, i;
                                    }
                                }
                                function R() {
                                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                                    P.apply(void 0, [
                                        R,
                                        t.length
                                    ].concat(t));
                                }
                                k.fail = function e(t, r, i, a, s) {
                                    var u, c = arguments.length;
                                    if (0 === c ? u = "Failed" : 1 === c ? (i = t, t = void 0) : (!1 === O && (O = !0, (n.emitWarning ? n.emitWarning : o.warn.bind(o))("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094")), 2 === c && (a = "!=")), i instanceof Error) throw i;
                                    var l = {
                                        actual: t,
                                        expected: r,
                                        operator: void 0 === a ? "fail" : a,
                                        stackStartFn: s || e
                                    };
                                    void 0 !== i && (l.message = i);
                                    var f = new m(l);
                                    throw u && (f.message = u, f.generatedMessage = !0), f;
                                }, k.AssertionError = m, k.ok = R, k.equal = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    t != r && x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "==",
                                        stackStartFn: e
                                    });
                                }, k.notEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    t == r && x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "!=",
                                        stackStartFn: e
                                    });
                                }, k.deepEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    void 0 === u && T(), u(t, r) || x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "deepEqual",
                                        stackStartFn: e
                                    });
                                }, k.notDeepEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    void 0 === u && T(), u(t, r) && x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "notDeepEqual",
                                        stackStartFn: e
                                    });
                                }, k.deepStrictEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    void 0 === u && T(), c(t, r) || x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "deepStrictEqual",
                                        stackStartFn: e
                                    });
                                }, k.notDeepStrictEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    void 0 === u && T(), c(t, r) && x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "notDeepStrictEqual",
                                        stackStartFn: e
                                    });
                                }, k.strictEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    A(t, r) || x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "strictEqual",
                                        stackStartFn: e
                                    });
                                }, k.notStrictEqual = function e(t, r, n) {
                                    if (arguments.length < 2) throw new y("actual", "expected");
                                    A(t, r) && x({
                                        actual: t,
                                        expected: r,
                                        message: n,
                                        operator: "notStrictEqual",
                                        stackStartFn: e
                                    });
                                };
                                var I = function(e, t, r) {
                                    return t && a(e.prototype, t), r && a(e, r), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }(function e(t, r, n) {
                                    var o = this;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), r.forEach(function(e) {
                                        e in t && (void 0 !== n && "string" == typeof n[e] && w(t[e]) && E(t[e], n[e]) ? o[e] = n[e] : o[e] = t[e]);
                                    });
                                });
                                function B(e, t, r, n) {
                                    if ("function" != typeof t) {
                                        if (w(t)) return E(t, e);
                                        if (2 === arguments.length) throw new p("expected", [
                                            "Function",
                                            "RegExp"
                                        ], t);
                                        if ("object" !== i(e) || null === e) {
                                            var o = new m({
                                                actual: e,
                                                expected: t,
                                                message: r,
                                                operator: "deepStrictEqual",
                                                stackStartFn: n
                                            });
                                            throw o.operator = n.name, o;
                                        }
                                        var a = Object.keys(t);
                                        if (t instanceof Error) a.push("name", "message");
                                        else if (0 === a.length) throw new d("error", t, "may not be an empty object");
                                        return void 0 === u && T(), a.forEach(function(o) {
                                            "string" == typeof e[o] && w(t[o]) && E(t[o], e[o]) || function(e, t, r, n, o, i) {
                                                if (!(r in e) || !c(e[r], t[r])) {
                                                    if (!n) {
                                                        var a = new I(e, o), s = new I(t, o, e), u = new m({
                                                            actual: a,
                                                            expected: s,
                                                            operator: "deepStrictEqual",
                                                            stackStartFn: i
                                                        });
                                                        throw u.actual = e, u.expected = t, u.operator = i.name, u;
                                                    }
                                                    x({
                                                        actual: e,
                                                        expected: t,
                                                        message: n,
                                                        operator: i.name,
                                                        stackStartFn: i
                                                    });
                                                }
                                            }(e, t, o, r, a, n);
                                        }), !0;
                                    }
                                    return void 0 !== t.prototype && e instanceof t || !Error.isPrototypeOf(t) && !0 === t.call({}, e);
                                }
                                function C(e) {
                                    if ("function" != typeof e) throw new p("fn", "Function", e);
                                    try {
                                        e();
                                    } catch (e) {
                                        return e;
                                    }
                                    return _;
                                }
                                function j(e) {
                                    return b(e) || null !== e && "object" === i(e) && "function" == typeof e.then && "function" == typeof e.catch;
                                }
                                function U(e) {
                                    return Promise.resolve().then(function() {
                                        var t;
                                        if ("function" == typeof e) {
                                            if (!j(t = e())) throw new h("instance of Promise", "promiseFn", t);
                                        } else {
                                            if (!j(e)) throw new p("promiseFn", [
                                                "Function",
                                                "Promise"
                                            ], e);
                                            t = e;
                                        }
                                        return Promise.resolve().then(function() {
                                            return t;
                                        }).then(function() {
                                            return _;
                                        }).catch(function(e) {
                                            return e;
                                        });
                                    });
                                }
                                function N(e, t, r, n) {
                                    if ("string" == typeof r) {
                                        if (4 === arguments.length) throw new p("error", [
                                            "Object",
                                            "Error",
                                            "Function",
                                            "RegExp"
                                        ], r);
                                        if ("object" === i(t) && null !== t) {
                                            if (t.message === r) throw new f("error/message", 'The error message "'.concat(t.message, '" is identical to the message.'));
                                        } else if (t === r) throw new f("error/message", 'The error "'.concat(t, '" is identical to the message.'));
                                        n = r, r = void 0;
                                    } else if (null != r && "object" !== i(r) && "function" != typeof r) throw new p("error", [
                                        "Object",
                                        "Error",
                                        "Function",
                                        "RegExp"
                                    ], r);
                                    if (t === _) {
                                        var o = "";
                                        r && r.name && (o += " (".concat(r.name, ")")), o += n ? ": ".concat(n) : ".";
                                        var a = "rejects" === e.name ? "rejection" : "exception";
                                        x({
                                            actual: void 0,
                                            expected: r,
                                            operator: e.name,
                                            message: "Missing expected ".concat(a).concat(o),
                                            stackStartFn: e
                                        });
                                    }
                                    if (r && !B(t, r, n, e)) throw t;
                                }
                                function L(e, t, r, n) {
                                    if (t !== _) {
                                        if ("string" == typeof r && (n = r, r = void 0), !r || B(t, r)) {
                                            var o = n ? ": ".concat(n) : ".", i = "doesNotReject" === e.name ? "rejection" : "exception";
                                            x({
                                                actual: t,
                                                expected: r,
                                                operator: e.name,
                                                message: "Got unwanted ".concat(i).concat(o, "\n") + 'Actual message: "'.concat(t && t.message, '"'),
                                                stackStartFn: e
                                            });
                                        }
                                        throw t;
                                    }
                                }
                                function F(e, t, r, n, o) {
                                    if (!w(t)) throw new p("regexp", "RegExp", t);
                                    var a = "match" === o;
                                    if ("string" != typeof e || E(t, e) !== a) {
                                        if (r instanceof Error) throw r;
                                        var s = !r;
                                        r = r || ("string" != typeof e ? 'The "string" argument must be of type string. Received type ' + "".concat(i(e), " (").concat(g(e), ")") : (a ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(g(t), ". Input:\n\n").concat(g(e), "\n"));
                                        var u = new m({
                                            actual: e,
                                            expected: t,
                                            message: r,
                                            operator: o,
                                            stackStartFn: n
                                        });
                                        throw u.generatedMessage = s, u;
                                    }
                                }
                                function D() {
                                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                                    P.apply(void 0, [
                                        D,
                                        t.length
                                    ].concat(t));
                                }
                                k.throws = function e(t) {
                                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                    N.apply(void 0, [
                                        e,
                                        C(t)
                                    ].concat(n));
                                }, k.rejects = function e(t) {
                                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                    return U(t).then(function(t) {
                                        return N.apply(void 0, [
                                            e,
                                            t
                                        ].concat(n));
                                    });
                                }, k.doesNotThrow = function e(t) {
                                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                    L.apply(void 0, [
                                        e,
                                        C(t)
                                    ].concat(n));
                                }, k.doesNotReject = function e(t) {
                                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                    return U(t).then(function(t) {
                                        return L.apply(void 0, [
                                            e,
                                            t
                                        ].concat(n));
                                    });
                                }, k.ifError = function e(t) {
                                    if (null != t) {
                                        var r = "ifError got unwanted exception: ";
                                        "object" === i(t) && "string" == typeof t.message ? 0 === t.message.length && t.constructor ? r += t.constructor.name : r += t.message : r += g(t);
                                        var n = new m({
                                            actual: t,
                                            expected: null,
                                            operator: "ifError",
                                            message: r,
                                            stackStartFn: e
                                        }), o = t.stack;
                                        if ("string" == typeof o) {
                                            var a = o.split("\n");
                                            a.shift();
                                            for(var s = n.stack.split("\n"), u = 0; u < a.length; u++){
                                                var c = s.indexOf(a[u]);
                                                if (-1 !== c) {
                                                    s = s.slice(0, c);
                                                    break;
                                                }
                                            }
                                            n.stack = "".concat(s.join("\n"), "\n").concat(a.join("\n"));
                                        }
                                        throw n;
                                    }
                                }, k.match = function e(t, r, n) {
                                    F(t, r, n, e, "match");
                                }, k.doesNotMatch = function e(t, r, n) {
                                    F(t, r, n, e, "doesNotMatch");
                                }, k.strict = S(D, k, {
                                    equal: k.strictEqual,
                                    deepEqual: k.deepStrictEqual,
                                    notEqual: k.notStrictEqual,
                                    notDeepEqual: k.notDeepStrictEqual
                                }), k.strict.strict = k.strict;
                            },
                            4233 (e) {
                                "use strict";
                                const t = (function*() {}).constructor;
                                e.exports = ()=>t;
                            },
                            4372 (e, t, r) {
                                "use strict";
                                var n = r(9675), o = r(6556)("TypedArray.prototype.buffer", !0), i = r(5680);
                                e.exports = o || function(e) {
                                    if (!i(e)) throw new n("Not a Typed Array");
                                    return e.buffer;
                                };
                            },
                            4459 (e) {
                                "use strict";
                                e.exports = Number.isNaN || function(e) {
                                    return e != e;
                                };
                            },
                            4634 (e) {
                                var t = {}.toString;
                                e.exports = Array.isArray || function(e) {
                                    return "[object Array]" == t.call(e);
                                };
                            },
                            5345 (e) {
                                "use strict";
                                e.exports = URIError;
                            },
                            5360 (e, t) {
                                "use strict";
                                var r = function(e, t) {
                                    return t || (t = {}), e.split("").forEach(function(e, r) {
                                        e in t || (t[e] = r);
                                    }), t;
                                }, n = {
                                    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
                                    charmap: {
                                        0: 14,
                                        1: 8
                                    }
                                };
                                n.charmap = r(n.alphabet, n.charmap);
                                var o = {
                                    alphabet: "0123456789ABCDEFGHJKMNPQRSTVWXYZ",
                                    charmap: {
                                        O: 0,
                                        I: 1,
                                        L: 1
                                    }
                                };
                                o.charmap = r(o.alphabet, o.charmap);
                                var i = {
                                    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
                                    charmap: {}
                                };
                                function a(e) {
                                    if (this.buf = [], this.shift = 8, this.carry = 0, e) {
                                        switch(e.type){
                                            case "rfc4648":
                                                this.charmap = t.rfc4648.charmap;
                                                break;
                                            case "crockford":
                                                this.charmap = t.crockford.charmap;
                                                break;
                                            case "base32hex":
                                                this.charmap = t.base32hex.charmap;
                                                break;
                                            default:
                                                throw new Error("invalid type");
                                        }
                                        e.charmap && (this.charmap = e.charmap);
                                    }
                                }
                                function s(e) {
                                    if (this.buf = "", this.shift = 3, this.carry = 0, e) {
                                        switch(e.type){
                                            case "rfc4648":
                                                this.alphabet = t.rfc4648.alphabet;
                                                break;
                                            case "crockford":
                                                this.alphabet = t.crockford.alphabet;
                                                break;
                                            case "base32hex":
                                                this.alphabet = t.base32hex.alphabet;
                                                break;
                                            default:
                                                throw new Error("invalid type");
                                        }
                                        e.alphabet ? this.alphabet = e.alphabet : e.lc && (this.alphabet = this.alphabet.toLowerCase());
                                    }
                                }
                                i.charmap = r(i.alphabet, i.charmap), a.prototype.charmap = n.charmap, a.prototype.write = function(e) {
                                    var t = this.charmap, r = this.buf, n = this.shift, o = this.carry;
                                    return e.toUpperCase().split("").forEach(function(e) {
                                        if ("=" != e) {
                                            var i = 255 & t[e];
                                            (n -= 5) > 0 ? o |= i << n : n < 0 ? (r.push(o | i >> -n), o = i << (n += 8) & 255) : (r.push(o | i), n = 8, o = 0);
                                        }
                                    }), this.shift = n, this.carry = o, this;
                                }, a.prototype.finalize = function(e) {
                                    return e && this.write(e), 8 !== this.shift && 0 !== this.carry && (this.buf.push(this.carry), this.shift = 8, this.carry = 0), this.buf;
                                }, s.prototype.alphabet = n.alphabet, s.prototype.write = function(e) {
                                    var t, r, n, o = this.shift, i = this.carry;
                                    for(n = 0; n < e.length; n++)t = i | (r = e[n]) >> o, this.buf += this.alphabet[31 & t], o > 5 && (t = r >> (o -= 5), this.buf += this.alphabet[31 & t]), i = r << (o = 5 - o), o = 8 - o;
                                    return this.shift = o, this.carry = i, this;
                                }, s.prototype.finalize = function(e) {
                                    return e && this.write(e), 3 !== this.shift && (this.buf += this.alphabet[31 & this.carry], this.shift = 3, this.carry = 0), this.buf;
                                }, t.encode = function(e, t) {
                                    return new s(t).finalize(e);
                                }, t.decode = function(e, t) {
                                    return new a(t).finalize(e);
                                }, t.Decoder = a, t.Encoder = s, t.charmap = r, t.crockford = o, t.rfc4648 = n, t.base32hex = i;
                            },
                            5377 (e, t, r) {
                                "use strict";
                                var n = r(2861).Buffer, o = r(4634), i = r(4372), a = ArrayBuffer.isView || function(e) {
                                    try {
                                        return i(e), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }, s = "undefined" != typeof Uint8Array, u = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, c = u && (n.prototype instanceof Uint8Array || n.TYPED_ARRAY_SUPPORT);
                                e.exports = function(e, t) {
                                    if (n.isBuffer(e)) return e.constructor && !("isBuffer" in e) ? n.from(e) : e;
                                    if ("string" == typeof e) return n.from(e, t);
                                    if (u && a(e)) {
                                        if (0 === e.byteLength) return n.alloc(0);
                                        if (c) {
                                            var r = n.from(e.buffer, e.byteOffset, e.byteLength);
                                            if (r.byteLength === e.byteLength) return r;
                                        }
                                        var i = e instanceof Uint8Array ? e : new Uint8Array(e.buffer, e.byteOffset, e.byteLength), l = n.from(i);
                                        if (l.length === e.byteLength) return l;
                                    }
                                    if (s && e instanceof Uint8Array) return n.from(e);
                                    var f = o(e);
                                    if (f) for(var p = 0; p < e.length; p += 1){
                                        var d = e[p];
                                        if ("number" != typeof d || d < 0 || d > 255 || ~~d !== d) throw new RangeError("Array items must be numbers in the range 0-255.");
                                    }
                                    if (f || n.isBuffer(e) && e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e)) return n.from(e);
                                    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
                                };
                            },
                            5606 (e) {
                                var t, r, n = e.exports = {};
                                function o() {
                                    throw new Error("setTimeout has not been defined");
                                }
                                function i() {
                                    throw new Error("clearTimeout has not been defined");
                                }
                                function a(e) {
                                    if (t === setTimeout) return setTimeout(e, 0);
                                    if ((t === o || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                                    try {
                                        return t(e, 0);
                                    } catch (r) {
                                        try {
                                            return t.call(null, e, 0);
                                        } catch (r) {
                                            return t.call(this, e, 0);
                                        }
                                    }
                                }
                                !function() {
                                    try {
                                        t = "function" == typeof setTimeout ? setTimeout : o;
                                    } catch (e) {
                                        t = o;
                                    }
                                    try {
                                        r = "function" == typeof clearTimeout ? clearTimeout : i;
                                    } catch (e) {
                                        r = i;
                                    }
                                }();
                                var s, u = [], c = !1, l = -1;
                                function f() {
                                    c && s && (c = !1, s.length ? u = s.concat(u) : l = -1, u.length && p());
                                }
                                function p() {
                                    if (!c) {
                                        var e = a(f);
                                        c = !0;
                                        for(var t = u.length; t;){
                                            for(s = u, u = []; ++l < t;)s && s[l].run();
                                            l = -1, t = u.length;
                                        }
                                        s = null, c = !1, function(e) {
                                            if (r === clearTimeout) return clearTimeout(e);
                                            if ((r === i || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                                            try {
                                                return r(e);
                                            } catch (t) {
                                                try {
                                                    return r.call(null, e);
                                                } catch (t) {
                                                    return r.call(this, e);
                                                }
                                            }
                                        }(e);
                                    }
                                }
                                function d(e, t) {
                                    this.fun = e, this.array = t;
                                }
                                function h() {}
                                n.nextTick = function(e) {
                                    var t = new Array(arguments.length - 1);
                                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                                    u.push(new d(e, t)), 1 !== u.length || c || a(p);
                                }, d.prototype.run = function() {
                                    this.fun.apply(null, this.array);
                                }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = h, n.addListener = h, n.once = h, n.off = h, n.removeListener = h, n.removeAllListeners = h, n.emit = h, n.prependListener = h, n.prependOnceListener = h, n.listeners = function(e) {
                                    return [];
                                }, n.binding = function(e) {
                                    throw new Error("process.binding is not supported");
                                }, n.cwd = function() {
                                    return "/";
                                }, n.chdir = function(e) {
                                    throw new Error("process.chdir is not supported");
                                }, n.umask = function() {
                                    return 0;
                                };
                            },
                            5680 (e, t, r) {
                                "use strict";
                                var n = r(5767);
                                e.exports = function(e) {
                                    return !!n(e);
                                };
                            },
                            5767 (e, t, r) {
                                "use strict";
                                var n = r(2682), o = r(9209), i = r(487), a = r(6556), s = r(5795), u = r(3628), c = a("Object.prototype.toString"), l = r(9092)(), f = "undefined" == typeof globalThis ? r.g : globalThis, p = o(), d = a("String.prototype.slice"), h = a("Array.prototype.indexOf", !0) || function(e, t) {
                                    for(var r = 0; r < e.length; r += 1)if (e[r] === t) return r;
                                    return -1;
                                }, y = {
                                    __proto__: null
                                };
                                n(p, l && s && u ? function(e) {
                                    var t = new f[e];
                                    if (Symbol.toStringTag in t && u) {
                                        var r = u(t), n = s(r, Symbol.toStringTag);
                                        if (!n && r) {
                                            var o = u(r);
                                            n = s(o, Symbol.toStringTag);
                                        }
                                        y["$" + e] = i(n.get);
                                    }
                                } : function(e) {
                                    var t = new f[e], r = t.slice || t.set;
                                    r && (y["$" + e] = i(r));
                                }), e.exports = function(e) {
                                    if (!e || "object" != typeof e) return !1;
                                    if (!l) {
                                        var t = d(c(e), 8, -1);
                                        return h(p, t) > -1 ? t : "Object" === t && function(e) {
                                            var t = !1;
                                            return n(y, function(r, n) {
                                                if (!t) try {
                                                    r(e), t = d(n, 1);
                                                } catch (e) {}
                                            }), t;
                                        }(e);
                                    }
                                    return s ? function(e) {
                                        var t = !1;
                                        return n(y, function(r, n) {
                                            if (!t) try {
                                                "$" + r(e) === n && (t = d(n, 1));
                                            } catch (e) {}
                                        }), t;
                                    }(e) : null;
                                };
                            },
                            5795 (e, t, r) {
                                "use strict";
                                var n = r(6549);
                                if (n) try {
                                    n([], "length");
                                } catch (e) {
                                    n = null;
                                }
                                e.exports = n;
                            },
                            5880 (e) {
                                "use strict";
                                e.exports = Math.pow;
                            },
                            6188 (e) {
                                "use strict";
                                e.exports = Math.max;
                            },
                            6549 (e) {
                                "use strict";
                                e.exports = Object.getOwnPropertyDescriptor;
                            },
                            6556 (e, t, r) {
                                "use strict";
                                var n = r(453), o = r(3126), i = o([
                                    n("%String.prototype.indexOf%")
                                ]);
                                e.exports = function(e, t) {
                                    var r = n(e, !!t);
                                    return "function" == typeof r && i(e, ".prototype.") > -1 ? o([
                                        r
                                    ]) : r;
                                };
                            },
                            6576 (e, t, r) {
                                "use strict";
                                var n = r(9394), o = r(8452);
                                e.exports = function() {
                                    var e = n();
                                    return o(Object, {
                                        is: e
                                    }, {
                                        is: function() {
                                            return Object.is !== e;
                                        }
                                    }), e;
                                };
                            },
                            6578 (e) {
                                "use strict";
                                e.exports = [
                                    "Float16Array",
                                    "Float32Array",
                                    "Float64Array",
                                    "Int8Array",
                                    "Int16Array",
                                    "Int32Array",
                                    "Uint8Array",
                                    "Uint8ClampedArray",
                                    "Uint16Array",
                                    "Uint32Array",
                                    "BigInt64Array",
                                    "BigUint64Array"
                                ];
                            },
                            6642 (e, t, r) {
                                "use strict";
                                var n = r(3003);
                                e.exports = function() {
                                    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : n;
                                };
                            },
                            6698 (e) {
                                "function" == typeof Object.create ? e.exports = function(e, t) {
                                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                                        constructor: {
                                            value: e,
                                            enumerable: !1,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }));
                                } : e.exports = function(e, t) {
                                    if (t) {
                                        e.super_ = t;
                                        var r = function() {};
                                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                                    }
                                };
                            },
                            6710 (e, t, r) {
                                "use strict";
                                var n = r(6698), o = r(4107), i = r(392), a = r(2861).Buffer, s = new Array(64);
                                function u() {
                                    this.init(), this._w = s, i.call(this, 64, 56);
                                }
                                n(u, o), u.prototype.init = function() {
                                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                                }, u.prototype._hash = function() {
                                    var e = a.allocUnsafe(28);
                                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                                }, e.exports = u;
                            },
                            6743 (e, t, r) {
                                "use strict";
                                var n = r(9353);
                                e.exports = Function.prototype.bind || n;
                            },
                            6763 (e, t, r) {
                                var n = r(537), o = r(4148);
                                function i() {
                                    return (new Date).getTime();
                                }
                                var a, s = Array.prototype.slice, u = {};
                                a = void 0 !== r.g && r.g.console ? r.g.console : "undefined" != typeof window && window.console ? window.console : {};
                                for(var c = [
                                    [
                                        function() {},
                                        "log"
                                    ],
                                    [
                                        function() {
                                            a.log.apply(a, arguments);
                                        },
                                        "info"
                                    ],
                                    [
                                        function() {
                                            a.log.apply(a, arguments);
                                        },
                                        "warn"
                                    ],
                                    [
                                        function() {
                                            a.warn.apply(a, arguments);
                                        },
                                        "error"
                                    ],
                                    [
                                        function(e) {
                                            u[e] = i();
                                        },
                                        "time"
                                    ],
                                    [
                                        function(e) {
                                            var t = u[e];
                                            if (!t) throw new Error("No such label: " + e);
                                            delete u[e];
                                            var r = i() - t;
                                            a.log(e + ": " + r + "ms");
                                        },
                                        "timeEnd"
                                    ],
                                    [
                                        function() {
                                            var e = new Error;
                                            e.name = "Trace", e.message = n.format.apply(null, arguments), a.error(e.stack);
                                        },
                                        "trace"
                                    ],
                                    [
                                        function(e) {
                                            a.log(n.inspect(e) + "\n");
                                        },
                                        "dir"
                                    ],
                                    [
                                        function(e) {
                                            if (!e) {
                                                var t = s.call(arguments, 1);
                                                o.ok(!1, n.format.apply(null, t));
                                            }
                                        },
                                        "assert"
                                    ]
                                ], l = 0; l < c.length; l++){
                                    var f = c[l], p = f[0], d = f[1];
                                    a[d] || (a[d] = p);
                                }
                                e.exports = a;
                            },
                            6897 (e, t, r) {
                                "use strict";
                                var n = r(453), o = r(41), i = r(592)(), a = r(5795), s = r(9675), u = n("%Math.floor%");
                                e.exports = function(e, t) {
                                    if ("function" != typeof e) throw new s("`fn` is not a function");
                                    if ("number" != typeof t || t < 0 || t > 4294967295 || u(t) !== t) throw new s("`length` must be a positive 32-bit integer");
                                    var r = arguments.length > 2 && !!arguments[2], n = !0, c = !0;
                                    if ("length" in e && a) {
                                        var l = a(e, "length");
                                        l && !l.configurable && (n = !1), l && !l.writable && (c = !1);
                                    }
                                    return (n || c || !r) && (i ? o(e, "length", t, !0, !0) : o(e, "length", t)), e;
                                };
                            },
                            7119 (e) {
                                "use strict";
                                e.exports = "undefined" != typeof Reflect && Reflect && Reflect.apply;
                            },
                            7176 (e, t, r) {
                                "use strict";
                                var n, o = r(3126), i = r(5795);
                                try {
                                    n = [].__proto__ === Array.prototype;
                                } catch (e) {
                                    if (!e || "object" != typeof e || !("code" in e) || "ERR_PROTO_ACCESS" !== e.code) throw e;
                                }
                                var a = !!n && i && i(Object.prototype, "__proto__"), s = Object, u = s.getPrototypeOf;
                                e.exports = a && "function" == typeof a.get ? o([
                                    a.get
                                ]) : "function" == typeof u && function(e) {
                                    return u(null == e ? e : s(e));
                                };
                            },
                            7244 (e, t, r) {
                                "use strict";
                                var n = r(9092)(), o = r(6556)("Object.prototype.toString"), i = function(e) {
                                    return !(n && e && "object" == typeof e && Symbol.toStringTag in e) && "[object Arguments]" === o(e);
                                }, a = function(e) {
                                    return !!i(e) || null !== e && "object" == typeof e && "length" in e && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== o(e) && "callee" in e && "[object Function]" === o(e.callee);
                                }, s = function() {
                                    return i(arguments);
                                }();
                                i.isLegacyArguments = a, e.exports = s ? i : a;
                            },
                            7526 (e, t) {
                                "use strict";
                                t.byteLength = function(e) {
                                    var t = s(e), r = t[0], n = t[1];
                                    return 3 * (r + n) / 4 - n;
                                }, t.toByteArray = function(e) {
                                    var t, r, i = s(e), a = i[0], u = i[1], c = new o(function(e, t, r) {
                                        return 3 * (t + r) / 4 - r;
                                    }(0, a, u)), l = 0, f = u > 0 ? a - 4 : a;
                                    for(r = 0; r < f; r += 4)t = n[e.charCodeAt(r)] << 18 | n[e.charCodeAt(r + 1)] << 12 | n[e.charCodeAt(r + 2)] << 6 | n[e.charCodeAt(r + 3)], c[l++] = t >> 16 & 255, c[l++] = t >> 8 & 255, c[l++] = 255 & t;
                                    return 2 === u && (t = n[e.charCodeAt(r)] << 2 | n[e.charCodeAt(r + 1)] >> 4, c[l++] = 255 & t), 1 === u && (t = n[e.charCodeAt(r)] << 10 | n[e.charCodeAt(r + 1)] << 4 | n[e.charCodeAt(r + 2)] >> 2, c[l++] = t >> 8 & 255, c[l++] = 255 & t), c;
                                }, t.fromByteArray = function(e) {
                                    for(var t, n = e.length, o = n % 3, i = [], a = 16383, s = 0, u = n - o; s < u; s += a)i.push(c(e, s, s + a > u ? u : s + a));
                                    return 1 === o ? (t = e[n - 1], i.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === o && (t = (e[n - 2] << 8) + e[n - 1], i.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "=")), i.join("");
                                };
                                for(var r = [], n = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0; a < 64; ++a)r[a] = i[a], n[i.charCodeAt(a)] = a;
                                function s(e) {
                                    var t = e.length;
                                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                                    var r = e.indexOf("=");
                                    return -1 === r && (r = t), [
                                        r,
                                        r === t ? 0 : 4 - r % 4
                                    ];
                                }
                                function u(e) {
                                    return r[e >> 18 & 63] + r[e >> 12 & 63] + r[e >> 6 & 63] + r[63 & e];
                                }
                                function c(e, t, r) {
                                    for(var n, o = [], i = t; i < r; i += 3)n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push(u(n));
                                    return o.join("");
                                }
                                n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
                            },
                            7653 (e, t, r) {
                                "use strict";
                                var n = r(8452), o = r(487), i = r(9211), a = r(9394), s = r(6576), u = o(a(), Object);
                                n(u, {
                                    getPolyfill: a,
                                    implementation: i,
                                    shim: s
                                }), e.exports = u;
                            },
                            7816 (e, t, r) {
                                "use strict";
                                var n = r(6698), o = r(392), i = r(2861).Buffer, a = [
                                    1518500249,
                                    1859775393,
                                    -1894007588,
                                    -899497514
                                ], s = new Array(80);
                                function u() {
                                    this.init(), this._w = s, o.call(this, 64, 56);
                                }
                                function c(e) {
                                    return e << 5 | e >>> 27;
                                }
                                function l(e) {
                                    return e << 30 | e >>> 2;
                                }
                                function f(e, t, r, n) {
                                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                                }
                                n(u, o), u.prototype.init = function() {
                                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                                }, u.prototype._update = function(e) {
                                    for(var t = this._w, r = 0 | this._a, n = 0 | this._b, o = 0 | this._c, i = 0 | this._d, s = 0 | this._e, u = 0; u < 16; ++u)t[u] = e.readInt32BE(4 * u);
                                    for(; u < 80; ++u)t[u] = t[u - 3] ^ t[u - 8] ^ t[u - 14] ^ t[u - 16];
                                    for(var p = 0; p < 80; ++p){
                                        var d = ~~(p / 20), h = c(r) + f(d, n, o, i) + s + t[p] + a[d] | 0;
                                        s = i, i = o, o = l(n), n = r, r = h;
                                    }
                                    this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = o + this._c | 0, this._d = i + this._d | 0, this._e = s + this._e | 0;
                                }, u.prototype._hash = function() {
                                    var e = i.allocUnsafe(20);
                                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                                }, e.exports = u;
                            },
                            8002 (e) {
                                "use strict";
                                e.exports = Math.min;
                            },
                            8068 (e) {
                                "use strict";
                                e.exports = SyntaxError;
                            },
                            8075 (e, t, r) {
                                "use strict";
                                var n = r(453), o = r(487), i = o(n("String.prototype.indexOf"));
                                e.exports = function(e, t) {
                                    var r = n(e, !!t);
                                    return "function" == typeof r && i(e, ".prototype.") > -1 ? o(r) : r;
                                };
                            },
                            8184 (e, t, r) {
                                "use strict";
                                var n = r(6556), o = r(9721)(/^\s*(?:function)?\*/), i = r(9092)(), a = r(3628), s = n("Object.prototype.toString"), u = n("Function.prototype.toString"), c = r(4233);
                                e.exports = function(e) {
                                    if ("function" != typeof e) return !1;
                                    if (o(u(e))) return !0;
                                    if (!i) return "[object GeneratorFunction]" === s(e);
                                    if (!a) return !1;
                                    var t = c();
                                    return t && a(e) === t.prototype;
                                };
                            },
                            8287 (e, t, r) {
                                "use strict";
                                var n = r(6763);
                                const o = r(7526), i = r(251), a = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
                                t.Buffer = c, t.SlowBuffer = function(e) {
                                    return +e != e && (e = 0), c.alloc(+e);
                                }, t.INSPECT_MAX_BYTES = 50;
                                const s = 2147483647;
                                function u(e) {
                                    if (e > s) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                                    const t = new Uint8Array(e);
                                    return Object.setPrototypeOf(t, c.prototype), t;
                                }
                                function c(e, t, r) {
                                    if ("number" == typeof e) {
                                        if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                        return p(e);
                                    }
                                    return l(e, t, r);
                                }
                                function l(e, t, r) {
                                    if ("string" == typeof e) return function(e, t) {
                                        if ("string" == typeof t && "" !== t || (t = "utf8"), !c.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                        const r = 0 | m(e, t);
                                        let n = u(r);
                                        const o = n.write(e, t);
                                        return o !== r && (n = n.slice(0, o)), n;
                                    }(e, t);
                                    if (ArrayBuffer.isView(e)) return function(e) {
                                        if ($(e, Uint8Array)) {
                                            const t = new Uint8Array(e);
                                            return h(t.buffer, t.byteOffset, t.byteLength);
                                        }
                                        return d(e);
                                    }(e);
                                    if (null == e) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                                    if ($(e, ArrayBuffer) || e && $(e.buffer, ArrayBuffer)) return h(e, t, r);
                                    if ("undefined" != typeof SharedArrayBuffer && ($(e, SharedArrayBuffer) || e && $(e.buffer, SharedArrayBuffer))) return h(e, t, r);
                                    if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                                    const n = e.valueOf && e.valueOf();
                                    if (null != n && n !== e) return c.from(n, t, r);
                                    const o = function(e) {
                                        if (c.isBuffer(e)) {
                                            const t = 0 | y(e.length), r = u(t);
                                            return 0 === r.length || e.copy(r, 0, 0, t), r;
                                        }
                                        return void 0 !== e.length ? "number" != typeof e.length || Y(e.length) ? u(0) : d(e) : "Buffer" === e.type && Array.isArray(e.data) ? d(e.data) : void 0;
                                    }(e);
                                    if (o) return o;
                                    if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return c.from(e[Symbol.toPrimitive]("string"), t, r);
                                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                                }
                                function f(e) {
                                    if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                                    if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                                }
                                function p(e) {
                                    return f(e), u(e < 0 ? 0 : 0 | y(e));
                                }
                                function d(e) {
                                    const t = e.length < 0 ? 0 : 0 | y(e.length), r = u(t);
                                    for(let n = 0; n < t; n += 1)r[n] = 255 & e[n];
                                    return r;
                                }
                                function h(e, t, r) {
                                    if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                    if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                    let n;
                                    return n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r), Object.setPrototypeOf(n, c.prototype), n;
                                }
                                function y(e) {
                                    if (e >= s) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
                                    return 0 | e;
                                }
                                function m(e, t) {
                                    if (c.isBuffer(e)) return e.length;
                                    if (ArrayBuffer.isView(e) || $(e, ArrayBuffer)) return e.byteLength;
                                    if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                                    const r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                                    if (!n && 0 === r) return 0;
                                    let o = !1;
                                    for(;;)switch(t){
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                            return r;
                                        case "utf8":
                                        case "utf-8":
                                            return X(e).length;
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return 2 * r;
                                        case "hex":
                                            return r >>> 1;
                                        case "base64":
                                            return K(e).length;
                                        default:
                                            if (o) return n ? -1 : X(e).length;
                                            t = ("" + t).toLowerCase(), o = !0;
                                    }
                                }
                                function g(e, t, r) {
                                    let n = !1;
                                    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                                    if ((r >>>= 0) <= (t >>>= 0)) return "";
                                    for(e || (e = "utf8");;)switch(e){
                                        case "hex":
                                            return I(this, t, r);
                                        case "utf8":
                                        case "utf-8":
                                            return _(this, t, r);
                                        case "ascii":
                                            return P(this, t, r);
                                        case "latin1":
                                        case "binary":
                                            return R(this, t, r);
                                        case "base64":
                                            return k(this, t, r);
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return B(this, t, r);
                                        default:
                                            if (n) throw new TypeError("Unknown encoding: " + e);
                                            e = (e + "").toLowerCase(), n = !0;
                                    }
                                }
                                function v(e, t, r) {
                                    const n = e[t];
                                    e[t] = e[r], e[r] = n;
                                }
                                function b(e, t, r, n, o) {
                                    if (0 === e.length) return -1;
                                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), Y(r = +r) && (r = o ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                        if (o) return -1;
                                        r = e.length - 1;
                                    } else if (r < 0) {
                                        if (!o) return -1;
                                        r = 0;
                                    }
                                    if ("string" == typeof t && (t = c.from(t, n)), c.isBuffer(t)) return 0 === t.length ? -1 : w(e, t, r, n, o);
                                    if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : w(e, [
                                        t
                                    ], r, n, o);
                                    throw new TypeError("val must be string, number or Buffer");
                                }
                                function w(e, t, r, n, o) {
                                    let i, a = 1, s = e.length, u = t.length;
                                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                        if (e.length < 2 || t.length < 2) return -1;
                                        a = 2, s /= 2, u /= 2, r /= 2;
                                    }
                                    function c(e, t) {
                                        return 1 === a ? e[t] : e.readUInt16BE(t * a);
                                    }
                                    if (o) {
                                        let n = -1;
                                        for(i = r; i < s; i++)if (c(e, i) === c(t, -1 === n ? 0 : i - n)) {
                                            if (-1 === n && (n = i), i - n + 1 === u) return n * a;
                                        } else -1 !== n && (i -= i - n), n = -1;
                                    } else for(r + u > s && (r = s - u), i = r; i >= 0; i--){
                                        let r = !0;
                                        for(let n = 0; n < u; n++)if (c(e, i + n) !== c(t, n)) {
                                            r = !1;
                                            break;
                                        }
                                        if (r) return i;
                                    }
                                    return -1;
                                }
                                function S(e, t, r, n) {
                                    r = Number(r) || 0;
                                    const o = e.length - r;
                                    n ? (n = Number(n)) > o && (n = o) : n = o;
                                    const i = t.length;
                                    let a;
                                    for(n > i / 2 && (n = i / 2), a = 0; a < n; ++a){
                                        const n = parseInt(t.substr(2 * a, 2), 16);
                                        if (Y(n)) return a;
                                        e[r + a] = n;
                                    }
                                    return a;
                                }
                                function A(e, t, r, n) {
                                    return Z(X(t, e.length - r), e, r, n);
                                }
                                function E(e, t, r, n) {
                                    return Z(function(e) {
                                        const t = [];
                                        for(let r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                        return t;
                                    }(t), e, r, n);
                                }
                                function T(e, t, r, n) {
                                    return Z(K(t), e, r, n);
                                }
                                function O(e, t, r, n) {
                                    return Z(function(e, t) {
                                        let r, n, o;
                                        const i = [];
                                        for(let a = 0; a < e.length && !((t -= 2) < 0); ++a)r = e.charCodeAt(a), n = r >> 8, o = r % 256, i.push(o), i.push(n);
                                        return i;
                                    }(t, e.length - r), e, r, n);
                                }
                                function k(e, t, r) {
                                    return 0 === t && r === e.length ? o.fromByteArray(e) : o.fromByteArray(e.slice(t, r));
                                }
                                function _(e, t, r) {
                                    r = Math.min(e.length, r);
                                    const n = [];
                                    let o = t;
                                    for(; o < r;){
                                        const t = e[o];
                                        let i = null, a = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
                                        if (o + a <= r) {
                                            let r, n, s, u;
                                            switch(a){
                                                case 1:
                                                    t < 128 && (i = t);
                                                    break;
                                                case 2:
                                                    r = e[o + 1], 128 == (192 & r) && (u = (31 & t) << 6 | 63 & r, u > 127 && (i = u));
                                                    break;
                                                case 3:
                                                    r = e[o + 1], n = e[o + 2], 128 == (192 & r) && 128 == (192 & n) && (u = (15 & t) << 12 | (63 & r) << 6 | 63 & n, u > 2047 && (u < 55296 || u > 57343) && (i = u));
                                                    break;
                                                case 4:
                                                    r = e[o + 1], n = e[o + 2], s = e[o + 3], 128 == (192 & r) && 128 == (192 & n) && 128 == (192 & s) && (u = (15 & t) << 18 | (63 & r) << 12 | (63 & n) << 6 | 63 & s, u > 65535 && u < 1114112 && (i = u));
                                            }
                                        }
                                        null === i ? (i = 65533, a = 1) : i > 65535 && (i -= 65536, n.push(i >>> 10 & 1023 | 55296), i = 56320 | 1023 & i), n.push(i), o += a;
                                    }
                                    return function(e) {
                                        const t = e.length;
                                        if (t <= x) return String.fromCharCode.apply(String, e);
                                        let r = "", n = 0;
                                        for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += x));
                                        return r;
                                    }(n);
                                }
                                t.kMaxLength = s, c.TYPED_ARRAY_SUPPORT = function() {
                                    try {
                                        const e = new Uint8Array(1), t = {
                                            foo: function() {
                                                return 42;
                                            }
                                        };
                                        return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e, t), 42 === e.foo();
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), c.TYPED_ARRAY_SUPPORT || void 0 === n || "function" != typeof n.error || n.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(c.prototype, "parent", {
                                    enumerable: !0,
                                    get: function() {
                                        if (c.isBuffer(this)) return this.buffer;
                                    }
                                }), Object.defineProperty(c.prototype, "offset", {
                                    enumerable: !0,
                                    get: function() {
                                        if (c.isBuffer(this)) return this.byteOffset;
                                    }
                                }), c.poolSize = 8192, c.from = function(e, t, r) {
                                    return l(e, t, r);
                                }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array), c.alloc = function(e, t, r) {
                                    return function(e, t, r) {
                                        return f(e), e <= 0 ? u(e) : void 0 !== t ? "string" == typeof r ? u(e).fill(t, r) : u(e).fill(t) : u(e);
                                    }(e, t, r);
                                }, c.allocUnsafe = function(e) {
                                    return p(e);
                                }, c.allocUnsafeSlow = function(e) {
                                    return p(e);
                                }, c.isBuffer = function(e) {
                                    return null != e && !0 === e._isBuffer && e !== c.prototype;
                                }, c.compare = function(e, t) {
                                    if ($(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), $(t, Uint8Array) && (t = c.from(t, t.offset, t.byteLength)), !c.isBuffer(e) || !c.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                                    if (e === t) return 0;
                                    let r = e.length, n = t.length;
                                    for(let o = 0, i = Math.min(r, n); o < i; ++o)if (e[o] !== t[o]) {
                                        r = e[o], n = t[o];
                                        break;
                                    }
                                    return r < n ? -1 : n < r ? 1 : 0;
                                }, c.isEncoding = function(e) {
                                    switch(String(e).toLowerCase()){
                                        case "hex":
                                        case "utf8":
                                        case "utf-8":
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                        case "base64":
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return !0;
                                        default:
                                            return !1;
                                    }
                                }, c.concat = function(e, t) {
                                    if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                                    if (0 === e.length) return c.alloc(0);
                                    let r;
                                    if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                                    const n = c.allocUnsafe(t);
                                    let o = 0;
                                    for(r = 0; r < e.length; ++r){
                                        let t = e[r];
                                        if ($(t, Uint8Array)) o + t.length > n.length ? (c.isBuffer(t) || (t = c.from(t)), t.copy(n, o)) : Uint8Array.prototype.set.call(n, t, o);
                                        else {
                                            if (!c.isBuffer(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                                            t.copy(n, o);
                                        }
                                        o += t.length;
                                    }
                                    return n;
                                }, c.byteLength = m, c.prototype._isBuffer = !0, c.prototype.swap16 = function() {
                                    const e = this.length;
                                    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                                    for(let t = 0; t < e; t += 2)v(this, t, t + 1);
                                    return this;
                                }, c.prototype.swap32 = function() {
                                    const e = this.length;
                                    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                                    for(let t = 0; t < e; t += 4)v(this, t, t + 3), v(this, t + 1, t + 2);
                                    return this;
                                }, c.prototype.swap64 = function() {
                                    const e = this.length;
                                    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                                    for(let t = 0; t < e; t += 8)v(this, t, t + 7), v(this, t + 1, t + 6), v(this, t + 2, t + 5), v(this, t + 3, t + 4);
                                    return this;
                                }, c.prototype.toString = function() {
                                    const e = this.length;
                                    return 0 === e ? "" : 0 === arguments.length ? _(this, 0, e) : g.apply(this, arguments);
                                }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(e) {
                                    if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                                    return this === e || 0 === c.compare(this, e);
                                }, c.prototype.inspect = function() {
                                    let e = "";
                                    const r = t.INSPECT_MAX_BYTES;
                                    return e = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (e += " ... "), "<Buffer " + e + ">";
                                }, a && (c.prototype[a] = c.prototype.inspect), c.prototype.compare = function(e, t, r, n, o) {
                                    if ($(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), !c.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                                    if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), t < 0 || r > e.length || n < 0 || o > this.length) throw new RangeError("out of range index");
                                    if (n >= o && t >= r) return 0;
                                    if (n >= o) return -1;
                                    if (t >= r) return 1;
                                    if (this === e) return 0;
                                    let i = (o >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0);
                                    const s = Math.min(i, a), u = this.slice(n, o), l = e.slice(t, r);
                                    for(let e = 0; e < s; ++e)if (u[e] !== l[e]) {
                                        i = u[e], a = l[e];
                                        break;
                                    }
                                    return i < a ? -1 : a < i ? 1 : 0;
                                }, c.prototype.includes = function(e, t, r) {
                                    return -1 !== this.indexOf(e, t, r);
                                }, c.prototype.indexOf = function(e, t, r) {
                                    return b(this, e, t, r, !0);
                                }, c.prototype.lastIndexOf = function(e, t, r) {
                                    return b(this, e, t, r, !1);
                                }, c.prototype.write = function(e, t, r, n) {
                                    if (void 0 === t) n = "utf8", r = this.length, t = 0;
                                    else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                                    else {
                                        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                        t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                                    }
                                    const o = this.length - t;
                                    if ((void 0 === r || r > o) && (r = o), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                                    n || (n = "utf8");
                                    let i = !1;
                                    for(;;)switch(n){
                                        case "hex":
                                            return S(this, e, t, r);
                                        case "utf8":
                                        case "utf-8":
                                            return A(this, e, t, r);
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                            return E(this, e, t, r);
                                        case "base64":
                                            return T(this, e, t, r);
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return O(this, e, t, r);
                                        default:
                                            if (i) throw new TypeError("Unknown encoding: " + n);
                                            n = ("" + n).toLowerCase(), i = !0;
                                    }
                                }, c.prototype.toJSON = function() {
                                    return {
                                        type: "Buffer",
                                        data: Array.prototype.slice.call(this._arr || this, 0)
                                    };
                                };
                                const x = 4096;
                                function P(e, t, r) {
                                    let n = "";
                                    r = Math.min(e.length, r);
                                    for(let o = t; o < r; ++o)n += String.fromCharCode(127 & e[o]);
                                    return n;
                                }
                                function R(e, t, r) {
                                    let n = "";
                                    r = Math.min(e.length, r);
                                    for(let o = t; o < r; ++o)n += String.fromCharCode(e[o]);
                                    return n;
                                }
                                function I(e, t, r) {
                                    const n = e.length;
                                    (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                                    let o = "";
                                    for(let n = t; n < r; ++n)o += Q[e[n]];
                                    return o;
                                }
                                function B(e, t, r) {
                                    const n = e.slice(t, r);
                                    let o = "";
                                    for(let e = 0; e < n.length - 1; e += 2)o += String.fromCharCode(n[e] + 256 * n[e + 1]);
                                    return o;
                                }
                                function C(e, t, r) {
                                    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                                    if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                                }
                                function j(e, t, r, n, o, i) {
                                    if (!c.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                                    if (t > o || t < i) throw new RangeError('"value" argument is out of bounds');
                                    if (r + n > e.length) throw new RangeError("Index out of range");
                                }
                                function U(e, t, r, n, o) {
                                    G(t, n, o, e, r, 7);
                                    let i = Number(t & BigInt(4294967295));
                                    e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i;
                                    let a = Number(t >> BigInt(32) & BigInt(4294967295));
                                    return e[r++] = a, a >>= 8, e[r++] = a, a >>= 8, e[r++] = a, a >>= 8, e[r++] = a, r;
                                }
                                function N(e, t, r, n, o) {
                                    G(t, n, o, e, r, 7);
                                    let i = Number(t & BigInt(4294967295));
                                    e[r + 7] = i, i >>= 8, e[r + 6] = i, i >>= 8, e[r + 5] = i, i >>= 8, e[r + 4] = i;
                                    let a = Number(t >> BigInt(32) & BigInt(4294967295));
                                    return e[r + 3] = a, a >>= 8, e[r + 2] = a, a >>= 8, e[r + 1] = a, a >>= 8, e[r] = a, r + 8;
                                }
                                function L(e, t, r, n, o, i) {
                                    if (r + n > e.length) throw new RangeError("Index out of range");
                                    if (r < 0) throw new RangeError("Index out of range");
                                }
                                function F(e, t, r, n, o) {
                                    return t = +t, r >>>= 0, o || L(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
                                }
                                function D(e, t, r, n, o) {
                                    return t = +t, r >>>= 0, o || L(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
                                }
                                c.prototype.slice = function(e, t) {
                                    const r = this.length;
                                    (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                                    const n = this.subarray(e, t);
                                    return Object.setPrototypeOf(n, c.prototype), n;
                                }, c.prototype.readUintLE = c.prototype.readUIntLE = function(e, t, r) {
                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                    let n = this[e], o = 1, i = 0;
                                    for(; ++i < t && (o *= 256);)n += this[e + i] * o;
                                    return n;
                                }, c.prototype.readUintBE = c.prototype.readUIntBE = function(e, t, r) {
                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                    let n = this[e + --t], o = 1;
                                    for(; t > 0 && (o *= 256);)n += this[e + --t] * o;
                                    return n;
                                }, c.prototype.readUint8 = c.prototype.readUInt8 = function(e, t) {
                                    return e >>>= 0, t || C(e, 1, this.length), this[e];
                                }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(e, t) {
                                    return e >>>= 0, t || C(e, 2, this.length), this[e] | this[e + 1] << 8;
                                }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(e, t) {
                                    return e >>>= 0, t || C(e, 2, this.length), this[e] << 8 | this[e + 1];
                                }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(e, t) {
                                    return e >>>= 0, t || C(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                                }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(e, t) {
                                    return e >>>= 0, t || C(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                                }, c.prototype.readBigUInt64LE = J(function(e) {
                                    H(e >>>= 0, "offset");
                                    const t = this[e], r = this[e + 7];
                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                    const n = t + 256 * this[++e] + 65536 * this[++e] + this[++e] * 2 ** 24, o = this[++e] + 256 * this[++e] + 65536 * this[++e] + r * 2 ** 24;
                                    return BigInt(n) + (BigInt(o) << BigInt(32));
                                }), c.prototype.readBigUInt64BE = J(function(e) {
                                    H(e >>>= 0, "offset");
                                    const t = this[e], r = this[e + 7];
                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                    const n = t * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + this[++e], o = this[++e] * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + r;
                                    return (BigInt(n) << BigInt(32)) + BigInt(o);
                                }), c.prototype.readIntLE = function(e, t, r) {
                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                    let n = this[e], o = 1, i = 0;
                                    for(; ++i < t && (o *= 256);)n += this[e + i] * o;
                                    return o *= 128, n >= o && (n -= Math.pow(2, 8 * t)), n;
                                }, c.prototype.readIntBE = function(e, t, r) {
                                    e >>>= 0, t >>>= 0, r || C(e, t, this.length);
                                    let n = t, o = 1, i = this[e + --n];
                                    for(; n > 0 && (o *= 256);)i += this[e + --n] * o;
                                    return o *= 128, i >= o && (i -= Math.pow(2, 8 * t)), i;
                                }, c.prototype.readInt8 = function(e, t) {
                                    return e >>>= 0, t || C(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                                }, c.prototype.readInt16LE = function(e, t) {
                                    e >>>= 0, t || C(e, 2, this.length);
                                    const r = this[e] | this[e + 1] << 8;
                                    return 32768 & r ? 4294901760 | r : r;
                                }, c.prototype.readInt16BE = function(e, t) {
                                    e >>>= 0, t || C(e, 2, this.length);
                                    const r = this[e + 1] | this[e] << 8;
                                    return 32768 & r ? 4294901760 | r : r;
                                }, c.prototype.readInt32LE = function(e, t) {
                                    return e >>>= 0, t || C(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                                }, c.prototype.readInt32BE = function(e, t) {
                                    return e >>>= 0, t || C(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                                }, c.prototype.readBigInt64LE = J(function(e) {
                                    H(e >>>= 0, "offset");
                                    const t = this[e], r = this[e + 7];
                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                    const n = this[e + 4] + 256 * this[e + 5] + 65536 * this[e + 6] + (r << 24);
                                    return (BigInt(n) << BigInt(32)) + BigInt(t + 256 * this[++e] + 65536 * this[++e] + this[++e] * 2 ** 24);
                                }), c.prototype.readBigInt64BE = J(function(e) {
                                    H(e >>>= 0, "offset");
                                    const t = this[e], r = this[e + 7];
                                    void 0 !== t && void 0 !== r || z(e, this.length - 8);
                                    const n = (t << 24) + 65536 * this[++e] + 256 * this[++e] + this[++e];
                                    return (BigInt(n) << BigInt(32)) + BigInt(this[++e] * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + r);
                                }), c.prototype.readFloatLE = function(e, t) {
                                    return e >>>= 0, t || C(e, 4, this.length), i.read(this, e, !0, 23, 4);
                                }, c.prototype.readFloatBE = function(e, t) {
                                    return e >>>= 0, t || C(e, 4, this.length), i.read(this, e, !1, 23, 4);
                                }, c.prototype.readDoubleLE = function(e, t) {
                                    return e >>>= 0, t || C(e, 8, this.length), i.read(this, e, !0, 52, 8);
                                }, c.prototype.readDoubleBE = function(e, t) {
                                    return e >>>= 0, t || C(e, 8, this.length), i.read(this, e, !1, 52, 8);
                                }, c.prototype.writeUintLE = c.prototype.writeUIntLE = function(e, t, r, n) {
                                    e = +e, t >>>= 0, r >>>= 0, n || j(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                                    let o = 1, i = 0;
                                    for(this[t] = 255 & e; ++i < r && (o *= 256);)this[t + i] = e / o & 255;
                                    return t + r;
                                }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(e, t, r, n) {
                                    e = +e, t >>>= 0, r >>>= 0, n || j(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                                    let o = r - 1, i = 1;
                                    for(this[t + o] = 255 & e; --o >= 0 && (i *= 256);)this[t + o] = e / i & 255;
                                    return t + r;
                                }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                                }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                                }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                                }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                                }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                                }, c.prototype.writeBigUInt64LE = J(function(e, t = 0) {
                                    return U(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
                                }), c.prototype.writeBigUInt64BE = J(function(e, t = 0) {
                                    return N(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
                                }), c.prototype.writeIntLE = function(e, t, r, n) {
                                    if (e = +e, t >>>= 0, !n) {
                                        const n = Math.pow(2, 8 * r - 1);
                                        j(this, e, t, r, n - 1, -n);
                                    }
                                    let o = 0, i = 1, a = 0;
                                    for(this[t] = 255 & e; ++o < r && (i *= 256);)e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1), this[t + o] = (e / i | 0) - a & 255;
                                    return t + r;
                                }, c.prototype.writeIntBE = function(e, t, r, n) {
                                    if (e = +e, t >>>= 0, !n) {
                                        const n = Math.pow(2, 8 * r - 1);
                                        j(this, e, t, r, n - 1, -n);
                                    }
                                    let o = r - 1, i = 1, a = 0;
                                    for(this[t + o] = 255 & e; --o >= 0 && (i *= 256);)e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1), this[t + o] = (e / i | 0) - a & 255;
                                    return t + r;
                                }, c.prototype.writeInt8 = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                                }, c.prototype.writeInt16LE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                                }, c.prototype.writeInt16BE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                                }, c.prototype.writeInt32LE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                                }, c.prototype.writeInt32BE = function(e, t, r) {
                                    return e = +e, t >>>= 0, r || j(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                                }, c.prototype.writeBigInt64LE = J(function(e, t = 0) {
                                    return U(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                                }), c.prototype.writeBigInt64BE = J(function(e, t = 0) {
                                    return N(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                                }), c.prototype.writeFloatLE = function(e, t, r) {
                                    return F(this, e, t, !0, r);
                                }, c.prototype.writeFloatBE = function(e, t, r) {
                                    return F(this, e, t, !1, r);
                                }, c.prototype.writeDoubleLE = function(e, t, r) {
                                    return D(this, e, t, !0, r);
                                }, c.prototype.writeDoubleBE = function(e, t, r) {
                                    return D(this, e, t, !1, r);
                                }, c.prototype.copy = function(e, t, r, n) {
                                    if (!c.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                                    if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                                    if (0 === e.length || 0 === this.length) return 0;
                                    if (t < 0) throw new RangeError("targetStart out of bounds");
                                    if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                                    if (n < 0) throw new RangeError("sourceEnd out of bounds");
                                    n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                                    const o = n - r;
                                    return this === e && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(t, r, n) : Uint8Array.prototype.set.call(e, this.subarray(r, n), t), o;
                                }, c.prototype.fill = function(e, t, r, n) {
                                    if ("string" == typeof e) {
                                        if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                        if ("string" == typeof n && !c.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                        if (1 === e.length) {
                                            const t = e.charCodeAt(0);
                                            ("utf8" === n && t < 128 || "latin1" === n) && (e = t);
                                        }
                                    } else "number" == typeof e ? e &= 255 : "boolean" == typeof e && (e = Number(e));
                                    if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                                    if (r <= t) return this;
                                    let o;
                                    if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                                    else {
                                        const i = c.isBuffer(e) ? e : c.from(e, n), a = i.length;
                                        if (0 === a) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                        for(o = 0; o < r - t; ++o)this[o + t] = i[o % a];
                                    }
                                    return this;
                                };
                                const M = {};
                                function V(e, t, r) {
                                    M[e] = class extends r {
                                        constructor(){
                                            super(), Object.defineProperty(this, "message", {
                                                value: t.apply(this, arguments),
                                                writable: !0,
                                                configurable: !0
                                            }), this.name = `${this.name} [${e}]`, this.stack, delete this.name;
                                        }
                                        get code() {
                                            return e;
                                        }
                                        set code(e) {
                                            Object.defineProperty(this, "code", {
                                                configurable: !0,
                                                enumerable: !0,
                                                value: e,
                                                writable: !0
                                            });
                                        }
                                        toString() {
                                            return `${this.name} [${e}]: ${this.message}`;
                                        }
                                    };
                                }
                                function q(e) {
                                    let t = "", r = e.length;
                                    const n = "-" === e[0] ? 1 : 0;
                                    for(; r >= n + 4; r -= 3)t = `_${e.slice(r - 3, r)}${t}`;
                                    return `${e.slice(0, r)}${t}`;
                                }
                                function G(e, t, r, n, o, i) {
                                    if (e > r || e < t) {
                                        const n = "bigint" == typeof t ? "n" : "";
                                        let o;
                                        throw o = i > 3 ? 0 === t || t === BigInt(0) ? `>= 0${n} and < 2${n} ** ${8 * (i + 1)}${n}` : `>= -(2${n} ** ${8 * (i + 1) - 1}${n}) and < 2 ** ${8 * (i + 1) - 1}${n}` : `>= ${t}${n} and <= ${r}${n}`, new M.ERR_OUT_OF_RANGE("value", o, e);
                                    }
                                    !function(e, t, r) {
                                        H(t, "offset"), void 0 !== e[t] && void 0 !== e[t + r] || z(t, e.length - (r + 1));
                                    }(n, o, i);
                                }
                                function H(e, t) {
                                    if ("number" != typeof e) throw new M.ERR_INVALID_ARG_TYPE(t, "number", e);
                                }
                                function z(e, t, r) {
                                    if (Math.floor(e) !== e) throw H(e, r), new M.ERR_OUT_OF_RANGE(r || "offset", "an integer", e);
                                    if (t < 0) throw new M.ERR_BUFFER_OUT_OF_BOUNDS;
                                    throw new M.ERR_OUT_OF_RANGE(r || "offset", `>= ${r ? 1 : 0} and <= ${t}`, e);
                                }
                                V("ERR_BUFFER_OUT_OF_BOUNDS", function(e) {
                                    return e ? `${e} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
                                }, RangeError), V("ERR_INVALID_ARG_TYPE", function(e, t) {
                                    return `The "${e}" argument must be of type number. Received type ${typeof t}`;
                                }, TypeError), V("ERR_OUT_OF_RANGE", function(e, t, r) {
                                    let n = `The value of "${e}" is out of range.`, o = r;
                                    return Number.isInteger(r) && Math.abs(r) > 2 ** 32 ? o = q(String(r)) : "bigint" == typeof r && (o = String(r), (r > BigInt(2) ** BigInt(32) || r < -(BigInt(2) ** BigInt(32))) && (o = q(o)), o += "n"), n += ` It must be ${t}. Received ${o}`, n;
                                }, RangeError);
                                const W = /[^+/0-9A-Za-z-_]/g;
                                function X(e, t) {
                                    let r;
                                    t = t || 1 / 0;
                                    const n = e.length;
                                    let o = null;
                                    const i = [];
                                    for(let a = 0; a < n; ++a){
                                        if (r = e.charCodeAt(a), r > 55295 && r < 57344) {
                                            if (!o) {
                                                if (r > 56319) {
                                                    (t -= 3) > -1 && i.push(239, 191, 189);
                                                    continue;
                                                }
                                                if (a + 1 === n) {
                                                    (t -= 3) > -1 && i.push(239, 191, 189);
                                                    continue;
                                                }
                                                o = r;
                                                continue;
                                            }
                                            if (r < 56320) {
                                                (t -= 3) > -1 && i.push(239, 191, 189), o = r;
                                                continue;
                                            }
                                            r = 65536 + (o - 55296 << 10 | r - 56320);
                                        } else o && (t -= 3) > -1 && i.push(239, 191, 189);
                                        if (o = null, r < 128) {
                                            if ((t -= 1) < 0) break;
                                            i.push(r);
                                        } else if (r < 2048) {
                                            if ((t -= 2) < 0) break;
                                            i.push(r >> 6 | 192, 63 & r | 128);
                                        } else if (r < 65536) {
                                            if ((t -= 3) < 0) break;
                                            i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                        } else {
                                            if (!(r < 1114112)) throw new Error("Invalid code point");
                                            if ((t -= 4) < 0) break;
                                            i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                        }
                                    }
                                    return i;
                                }
                                function K(e) {
                                    return o.toByteArray(function(e) {
                                        if ((e = (e = e.split("=")[0]).trim().replace(W, "")).length < 2) return "";
                                        for(; e.length % 4 != 0;)e += "=";
                                        return e;
                                    }(e));
                                }
                                function Z(e, t, r, n) {
                                    let o;
                                    for(o = 0; o < n && !(o + r >= t.length || o >= e.length); ++o)t[o + r] = e[o];
                                    return o;
                                }
                                function $(e, t) {
                                    return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                                }
                                function Y(e) {
                                    return e != e;
                                }
                                const Q = function() {
                                    const e = "0123456789abcdef", t = new Array(256);
                                    for(let r = 0; r < 16; ++r){
                                        const n = 16 * r;
                                        for(let o = 0; o < 16; ++o)t[n + o] = e[r] + e[o];
                                    }
                                    return t;
                                }();
                                function J(e) {
                                    return "undefined" == typeof BigInt ? ee : e;
                                }
                                function ee() {
                                    throw new Error("BigInt not supported");
                                }
                            },
                            8403 (e, t, r) {
                                "use strict";
                                var n = r(1189), o = r(1333)(), i = r(6556), a = r(9612), s = i("Array.prototype.push"), u = i("Object.prototype.propertyIsEnumerable"), c = o ? a.getOwnPropertySymbols : null;
                                e.exports = function(e, t) {
                                    if (null == e) throw new TypeError("target must be an object");
                                    var r = a(e);
                                    if (1 === arguments.length) return r;
                                    for(var i = 1; i < arguments.length; ++i){
                                        var l = a(arguments[i]), f = n(l), p = o && (a.getOwnPropertySymbols || c);
                                        if (p) for(var d = p(l), h = 0; h < d.length; ++h){
                                            var y = d[h];
                                            u(l, y) && s(f, y);
                                        }
                                        for(var m = 0; m < f.length; ++m){
                                            var g = f[m];
                                            if (u(l, g)) {
                                                var v = l[g];
                                                r[g] = v;
                                            }
                                        }
                                    }
                                    return r;
                                };
                            },
                            8452 (e, t, r) {
                                "use strict";
                                var n = r(1189), o = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"), i = Object.prototype.toString, a = Array.prototype.concat, s = r(41), u = r(592)(), c = function(e, t, r, n) {
                                    if (t in e) {
                                        if (!0 === n) {
                                            if (e[t] === r) return;
                                        } else if ("function" != typeof (o = n) || "[object Function]" !== i.call(o) || !n()) return;
                                    }
                                    var o;
                                    u ? s(e, t, r, !0) : s(e, t, r);
                                }, l = function(e, t) {
                                    var r = arguments.length > 2 ? arguments[2] : {}, i = n(t);
                                    o && (i = a.call(i, Object.getOwnPropertySymbols(t)));
                                    for(var s = 0; s < i.length; s += 1)c(e, i[s], t[i[s]], r[i[s]]);
                                };
                                l.supportsDescriptors = !!u, e.exports = l;
                            },
                            8648 (e) {
                                "use strict";
                                e.exports = "undefined" != typeof Reflect && Reflect.getPrototypeOf || null;
                            },
                            8875 (e, t, r) {
                                "use strict";
                                var n;
                                if (!Object.keys) {
                                    var o = Object.prototype.hasOwnProperty, i = Object.prototype.toString, a = r(1093), s = Object.prototype.propertyIsEnumerable, u = !s.call({
                                        toString: null
                                    }, "toString"), c = s.call(function() {}, "prototype"), l = [
                                        "toString",
                                        "toLocaleString",
                                        "valueOf",
                                        "hasOwnProperty",
                                        "isPrototypeOf",
                                        "propertyIsEnumerable",
                                        "constructor"
                                    ], f = function(e) {
                                        var t = e.constructor;
                                        return t && t.prototype === e;
                                    }, p = {
                                        $applicationCache: !0,
                                        $console: !0,
                                        $external: !0,
                                        $frame: !0,
                                        $frameElement: !0,
                                        $frames: !0,
                                        $innerHeight: !0,
                                        $innerWidth: !0,
                                        $onmozfullscreenchange: !0,
                                        $onmozfullscreenerror: !0,
                                        $outerHeight: !0,
                                        $outerWidth: !0,
                                        $pageXOffset: !0,
                                        $pageYOffset: !0,
                                        $parent: !0,
                                        $scrollLeft: !0,
                                        $scrollTop: !0,
                                        $scrollX: !0,
                                        $scrollY: !0,
                                        $self: !0,
                                        $webkitIndexedDB: !0,
                                        $webkitStorageInfo: !0,
                                        $window: !0
                                    }, d = function() {
                                        if ("undefined" == typeof window) return !1;
                                        for(var e in window)try {
                                            if (!p["$" + e] && o.call(window, e) && null !== window[e] && "object" == typeof window[e]) try {
                                                f(window[e]);
                                            } catch (e) {
                                                return !0;
                                            }
                                        } catch (e) {
                                            return !0;
                                        }
                                        return !1;
                                    }();
                                    n = function(e) {
                                        var t = null !== e && "object" == typeof e, r = "[object Function]" === i.call(e), n = a(e), s = t && "[object String]" === i.call(e), p = [];
                                        if (!t && !r && !n) throw new TypeError("Object.keys called on a non-object");
                                        var h = c && r;
                                        if (s && e.length > 0 && !o.call(e, 0)) for(var y = 0; y < e.length; ++y)p.push(String(y));
                                        if (n && e.length > 0) for(var m = 0; m < e.length; ++m)p.push(String(m));
                                        else for(var g in e)h && "prototype" === g || !o.call(e, g) || p.push(String(g));
                                        if (u) for(var v = function(e) {
                                            if ("undefined" == typeof window || !d) return f(e);
                                            try {
                                                return f(e);
                                            } catch (e) {
                                                return !1;
                                            }
                                        }(e), b = 0; b < l.length; ++b)v && "constructor" === l[b] || !o.call(e, l[b]) || p.push(l[b]);
                                        return p;
                                    };
                                }
                                e.exports = n;
                            },
                            8968 (e) {
                                "use strict";
                                e.exports = Math.floor;
                            },
                            9032 (e, t, r) {
                                "use strict";
                                var n = r(7244), o = r(8184), i = r(5767), a = r(5680);
                                function s(e) {
                                    return e.call.bind(e);
                                }
                                var u = "undefined" != typeof BigInt, c = "undefined" != typeof Symbol, l = s(Object.prototype.toString), f = s(Number.prototype.valueOf), p = s(String.prototype.valueOf), d = s(Boolean.prototype.valueOf);
                                if (u) var h = s(BigInt.prototype.valueOf);
                                if (c) var y = s(Symbol.prototype.valueOf);
                                function m(e, t) {
                                    if ("object" != typeof e) return !1;
                                    try {
                                        return t(e), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }
                                function g(e) {
                                    return "[object Map]" === l(e);
                                }
                                function v(e) {
                                    return "[object Set]" === l(e);
                                }
                                function b(e) {
                                    return "[object WeakMap]" === l(e);
                                }
                                function w(e) {
                                    return "[object WeakSet]" === l(e);
                                }
                                function S(e) {
                                    return "[object ArrayBuffer]" === l(e);
                                }
                                function A(e) {
                                    return "undefined" != typeof ArrayBuffer && (S.working ? S(e) : e instanceof ArrayBuffer);
                                }
                                function E(e) {
                                    return "[object DataView]" === l(e);
                                }
                                function T(e) {
                                    return "undefined" != typeof DataView && (E.working ? E(e) : e instanceof DataView);
                                }
                                t.isArgumentsObject = n, t.isGeneratorFunction = o, t.isTypedArray = a, t.isPromise = function(e) {
                                    return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" == typeof e && "function" == typeof e.then && "function" == typeof e.catch;
                                }, t.isArrayBufferView = function(e) {
                                    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : a(e) || T(e);
                                }, t.isUint8Array = function(e) {
                                    return "Uint8Array" === i(e);
                                }, t.isUint8ClampedArray = function(e) {
                                    return "Uint8ClampedArray" === i(e);
                                }, t.isUint16Array = function(e) {
                                    return "Uint16Array" === i(e);
                                }, t.isUint32Array = function(e) {
                                    return "Uint32Array" === i(e);
                                }, t.isInt8Array = function(e) {
                                    return "Int8Array" === i(e);
                                }, t.isInt16Array = function(e) {
                                    return "Int16Array" === i(e);
                                }, t.isInt32Array = function(e) {
                                    return "Int32Array" === i(e);
                                }, t.isFloat32Array = function(e) {
                                    return "Float32Array" === i(e);
                                }, t.isFloat64Array = function(e) {
                                    return "Float64Array" === i(e);
                                }, t.isBigInt64Array = function(e) {
                                    return "BigInt64Array" === i(e);
                                }, t.isBigUint64Array = function(e) {
                                    return "BigUint64Array" === i(e);
                                }, g.working = "undefined" != typeof Map && g(new Map), t.isMap = function(e) {
                                    return "undefined" != typeof Map && (g.working ? g(e) : e instanceof Map);
                                }, v.working = "undefined" != typeof Set && v(new Set), t.isSet = function(e) {
                                    return "undefined" != typeof Set && (v.working ? v(e) : e instanceof Set);
                                }, b.working = "undefined" != typeof WeakMap && b(new WeakMap), t.isWeakMap = function(e) {
                                    return "undefined" != typeof WeakMap && (b.working ? b(e) : e instanceof WeakMap);
                                }, w.working = "undefined" != typeof WeakSet && w(new WeakSet), t.isWeakSet = function(e) {
                                    return w(e);
                                }, S.working = "undefined" != typeof ArrayBuffer && S(new ArrayBuffer), t.isArrayBuffer = A, E.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && E(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = T;
                                var O = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
                                function k(e) {
                                    return "[object SharedArrayBuffer]" === l(e);
                                }
                                function _(e) {
                                    return void 0 !== O && (void 0 === k.working && (k.working = k(new O)), k.working ? k(e) : e instanceof O);
                                }
                                function x(e) {
                                    return m(e, f);
                                }
                                function P(e) {
                                    return m(e, p);
                                }
                                function R(e) {
                                    return m(e, d);
                                }
                                function I(e) {
                                    return u && m(e, h);
                                }
                                function B(e) {
                                    return c && m(e, y);
                                }
                                t.isSharedArrayBuffer = _, t.isAsyncFunction = function(e) {
                                    return "[object AsyncFunction]" === l(e);
                                }, t.isMapIterator = function(e) {
                                    return "[object Map Iterator]" === l(e);
                                }, t.isSetIterator = function(e) {
                                    return "[object Set Iterator]" === l(e);
                                }, t.isGeneratorObject = function(e) {
                                    return "[object Generator]" === l(e);
                                }, t.isWebAssemblyCompiledModule = function(e) {
                                    return "[object WebAssembly.Module]" === l(e);
                                }, t.isNumberObject = x, t.isStringObject = P, t.isBooleanObject = R, t.isBigIntObject = I, t.isSymbolObject = B, t.isBoxedPrimitive = function(e) {
                                    return x(e) || P(e) || R(e) || I(e) || B(e);
                                }, t.isAnyArrayBuffer = function(e) {
                                    return "undefined" != typeof Uint8Array && (A(e) || _(e));
                                }, [
                                    "isProxy",
                                    "isExternal",
                                    "isModuleNamespaceObject"
                                ].forEach(function(e) {
                                    Object.defineProperty(t, e, {
                                        enumerable: !1,
                                        value: function() {
                                            throw new Error(e + " is not supported in userland");
                                        }
                                    });
                                });
                            },
                            9092 (e, t, r) {
                                "use strict";
                                var n = r(1333);
                                e.exports = function() {
                                    return n() && !!Symbol.toStringTag;
                                };
                            },
                            9133 (e, t, r) {
                                "use strict";
                                var n = r(8403);
                                e.exports = function() {
                                    return Object.assign ? function() {
                                        if (!Object.assign) return !1;
                                        for(var e = "abcdefghijklmnopqrst", t = e.split(""), r = {}, n = 0; n < t.length; ++n)r[t[n]] = t[n];
                                        var o = Object.assign({}, r), i = "";
                                        for(var a in o)i += a;
                                        return e !== i;
                                    }() || function() {
                                        if (!Object.assign || !Object.preventExtensions) return !1;
                                        var e = Object.preventExtensions({
                                            1: 2
                                        });
                                        try {
                                            Object.assign(e, "xy");
                                        } catch (t) {
                                            return "y" === e[1];
                                        }
                                        return !1;
                                    }() ? n : Object.assign : n;
                                };
                            },
                            9209 (e, t, r) {
                                "use strict";
                                var n = r(6578), o = "undefined" == typeof globalThis ? r.g : globalThis;
                                e.exports = function() {
                                    for(var e = [], t = 0; t < n.length; t++)"function" == typeof o[n[t]] && (e[e.length] = n[t]);
                                    return e;
                                };
                            },
                            9211 (e) {
                                "use strict";
                                var t = function(e) {
                                    return e != e;
                                };
                                e.exports = function(e, r) {
                                    return 0 === e && 0 === r ? 1 / e == 1 / r : e === r || !(!t(e) || !t(r));
                                };
                            },
                            9290 (e) {
                                "use strict";
                                e.exports = RangeError;
                            },
                            9353 (e) {
                                "use strict";
                                var t = Object.prototype.toString, r = Math.max, n = function(e, t) {
                                    for(var r = [], n = 0; n < e.length; n += 1)r[n] = e[n];
                                    for(var o = 0; o < t.length; o += 1)r[o + e.length] = t[o];
                                    return r;
                                };
                                e.exports = function(e) {
                                    var o = this;
                                    if ("function" != typeof o || "[object Function]" !== t.apply(o)) throw new TypeError("Function.prototype.bind called on incompatible " + o);
                                    for(var i, a = function(e) {
                                        for(var t = [], r = 1, n = 0; r < e.length; r += 1, n += 1)t[n] = e[r];
                                        return t;
                                    }(arguments), s = r(0, o.length - a.length), u = [], c = 0; c < s; c++)u[c] = "$" + c;
                                    if (i = Function("binder", "return function (" + function(e) {
                                        for(var t = "", r = 0; r < e.length; r += 1)t += e[r], r + 1 < e.length && (t += ",");
                                        return t;
                                    }(u) + "){ return binder.apply(this,arguments); }")(function() {
                                        if (this instanceof i) {
                                            var t = o.apply(this, n(a, arguments));
                                            return Object(t) === t ? t : this;
                                        }
                                        return o.apply(e, n(a, arguments));
                                    }), o.prototype) {
                                        var l = function() {};
                                        l.prototype = o.prototype, i.prototype = new l, l.prototype = null;
                                    }
                                    return i;
                                };
                            },
                            9383 (e) {
                                "use strict";
                                e.exports = Error;
                            },
                            9394 (e, t, r) {
                                "use strict";
                                var n = r(9211);
                                e.exports = function() {
                                    return "function" == typeof Object.is ? Object.is : n;
                                };
                            },
                            9538 (e) {
                                "use strict";
                                e.exports = ReferenceError;
                            },
                            9597 (e, t, r) {
                                "use strict";
                                function n(e) {
                                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                        return typeof e;
                                    } : function(e) {
                                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                    }, n(e);
                                }
                                function o(e, t) {
                                    return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, o(e, t);
                                }
                                function i(e) {
                                    var t = function() {
                                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                        if (Reflect.construct.sham) return !1;
                                        if ("function" == typeof Proxy) return !0;
                                        try {
                                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                        } catch (e) {
                                            return !1;
                                        }
                                    }();
                                    return function() {
                                        var r, o = a(e);
                                        if (t) {
                                            var i = a(this).constructor;
                                            r = Reflect.construct(o, arguments, i);
                                        } else r = o.apply(this, arguments);
                                        return function(e, t) {
                                            if (t && ("object" === n(t) || "function" == typeof t)) return t;
                                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                            return function(e) {
                                                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                                return e;
                                            }(e);
                                        }(this, r);
                                    };
                                }
                                function a(e) {
                                    return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, a(e);
                                }
                                var s, u, c = {};
                                function l(e, t, r) {
                                    r || (r = Error);
                                    var n = function(r) {
                                        !function(e, t) {
                                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                            e.prototype = Object.create(t && t.prototype, {
                                                constructor: {
                                                    value: e,
                                                    writable: !0,
                                                    configurable: !0
                                                }
                                            }), Object.defineProperty(e, "prototype", {
                                                writable: !1
                                            }), t && o(e, t);
                                        }(s, r);
                                        var n, a = i(s);
                                        function s(r, n, o) {
                                            var i;
                                            return function(e, t) {
                                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                            }(this, s), i = a.call(this, function(e, r, n) {
                                                return "string" == typeof t ? t : t(e, r, n);
                                            }(r, n, o)), i.code = e, i;
                                        }
                                        return n = s, Object.defineProperty(n, "prototype", {
                                            writable: !1
                                        }), n;
                                    }(r);
                                    c[e] = n;
                                }
                                function f(e, t) {
                                    if (Array.isArray(e)) {
                                        var r = e.length;
                                        return e = e.map(function(e) {
                                            return String(e);
                                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                                    }
                                    return "of ".concat(t, " ").concat(String(e));
                                }
                                l("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), l("ERR_INVALID_ARG_TYPE", function(e, t, o) {
                                    var i, a, u;
                                    if (void 0 === s && (s = r(4148)), s("string" == typeof e, "'name' must be a string"), "string" == typeof t && (a = "not ", t.substr(0, 4) === a) ? (i = "must not be", t = t.replace(/^not /, "")) : i = "must be", function(e, t, r) {
                                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - 9, r) === t;
                                    }(e, " argument")) u = "The ".concat(e, " ").concat(i, " ").concat(f(t, "type"));
                                    else {
                                        var c = function(e, t, r) {
                                            return "number" != typeof r && (r = 0), !(r + 1 > e.length) && -1 !== e.indexOf(".", r);
                                        }(e) ? "property" : "argument";
                                        u = 'The "'.concat(e, '" ').concat(c, " ").concat(i, " ").concat(f(t, "type"));
                                    }
                                    return u + ". Received type ".concat(n(o));
                                }, TypeError), l("ERR_INVALID_ARG_VALUE", function(e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "is invalid";
                                    void 0 === u && (u = r(537));
                                    var o = u.inspect(t);
                                    return o.length > 128 && (o = "".concat(o.slice(0, 128), "...")), "The argument '".concat(e, "' ").concat(n, ". Received ").concat(o);
                                }, TypeError, RangeError), l("ERR_INVALID_RETURN_VALUE", function(e, t, r) {
                                    var o;
                                    return o = r && r.constructor && r.constructor.name ? "instance of ".concat(r.constructor.name) : "type ".concat(n(r)), "Expected ".concat(e, ' to be returned from the "').concat(t, '"') + " function but got ".concat(o, ".");
                                }, TypeError), l("ERR_MISSING_ARGS", function() {
                                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                                    void 0 === s && (s = r(4148)), s(t.length > 0, "At least one arg needs to be specified");
                                    var o = "The ", i = t.length;
                                    switch(t = t.map(function(e) {
                                        return '"'.concat(e, '"');
                                    }), i){
                                        case 1:
                                            o += "".concat(t[0], " argument");
                                            break;
                                        case 2:
                                            o += "".concat(t[0], " and ").concat(t[1], " arguments");
                                            break;
                                        default:
                                            o += t.slice(0, i - 1).join(", "), o += ", and ".concat(t[i - 1], " arguments");
                                    }
                                    return "".concat(o, " must be specified");
                                }, TypeError), e.exports.codes = c;
                            },
                            9600 (e) {
                                "use strict";
                                var t, r, n = Function.prototype.toString, o = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
                                if ("function" == typeof o && "function" == typeof Object.defineProperty) try {
                                    t = Object.defineProperty({}, "length", {
                                        get: function() {
                                            throw r;
                                        }
                                    }), r = {}, o(function() {
                                        throw 42;
                                    }, null, t);
                                } catch (e) {
                                    e !== r && (o = null);
                                }
                                else o = null;
                                var i = /^\s*class\b/, a = function(e) {
                                    try {
                                        var t = n.call(e);
                                        return i.test(t);
                                    } catch (e) {
                                        return !1;
                                    }
                                }, s = function(e) {
                                    try {
                                        return !a(e) && (n.call(e), !0);
                                    } catch (e) {
                                        return !1;
                                    }
                                }, u = Object.prototype.toString, c = "function" == typeof Symbol && !!Symbol.toStringTag, l = !(0 in [
                                    , 
                                ]), f = function() {
                                    return !1;
                                };
                                if ("object" == typeof document) {
                                    var p = document.all;
                                    u.call(p) === u.call(document.all) && (f = function(e) {
                                        if ((l || !e) && (void 0 === e || "object" == typeof e)) try {
                                            var t = u.call(e);
                                            return ("[object HTMLAllCollection]" === t || "[object HTML document.all class]" === t || "[object HTMLCollection]" === t || "[object Object]" === t) && null == e("");
                                        } catch (e) {}
                                        return !1;
                                    });
                                }
                                e.exports = o ? function(e) {
                                    if (f(e)) return !0;
                                    if (!e) return !1;
                                    if ("function" != typeof e && "object" != typeof e) return !1;
                                    try {
                                        o(e, null, t);
                                    } catch (e) {
                                        if (e !== r) return !1;
                                    }
                                    return !a(e) && s(e);
                                } : function(e) {
                                    if (f(e)) return !0;
                                    if (!e) return !1;
                                    if ("function" != typeof e && "object" != typeof e) return !1;
                                    if (c) return s(e);
                                    if (a(e)) return !1;
                                    var t = u.call(e);
                                    return !("[object Function]" !== t && "[object GeneratorFunction]" !== t && !/^\[object HTML/.test(t)) && s(e);
                                };
                            },
                            9612 (e) {
                                "use strict";
                                e.exports = Object;
                            },
                            9675 (e) {
                                "use strict";
                                e.exports = TypeError;
                            },
                            9721 (e, t, r) {
                                "use strict";
                                var n = r(6556), o = r(4035), i = n("RegExp.prototype.exec"), a = r(9675);
                                e.exports = function(e) {
                                    if (!o(e)) throw new a("`regex` must be a RegExp");
                                    return function(t) {
                                        return null !== i(e, t);
                                    };
                                };
                            },
                            9957 (e, t, r) {
                                "use strict";
                                var n = Function.prototype.call, o = Object.prototype.hasOwnProperty, i = r(6743);
                                e.exports = i.call(n, o);
                            }
                        }, t = {};
                        function r(n) {
                            var o = t[n];
                            if (void 0 !== o) return o.exports;
                            var i = t[n] = {
                                id: n,
                                loaded: !1,
                                exports: {}
                            };
                            return e[n].call(i.exports, i, i.exports, r), i.loaded = !0, i.exports;
                        }
                        return r.d = (e, t)=>{
                            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: t[n]
                            });
                        }, r.g = function() {
                            if ("object" == typeof globalThis) return globalThis;
                            try {
                                return this || new Function("return this")();
                            } catch (e) {
                                if ("object" == typeof window) return window;
                            }
                        }(), r.hmd = (e)=>((e = Object.create(e)).children || (e.children = []), Object.defineProperty(e, "exports", {
                                enumerable: !0,
                                set: ()=>{
                                    throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e.id);
                                }
                            }), e), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e, "__esModule", {
                                value: !0
                            });
                        }, r(448);
                    })(), e.exports = t();
            },
            6682 (e, t, r) {
                "use strict";
                r.d(t, {
                    fe: ()=>Q
                });
                var n = r(8250);
                function o(e) {
                    return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, o(e);
                }
                function i(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != o(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == o(t) ? t : t + "";
                }
                var s, u, c, l = (s = function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }, u = [
                    {
                        key: "generate",
                        value: function(e) {
                            var t = e.contractName;
                            return {
                                packageJson: this.generatePackageJson(t),
                                tsConfig: this.generateTsConfig(),
                                gitignore: this.generateGitignore(),
                                readme: this.generateReadme(t)
                            };
                        }
                    },
                    {
                        key: "generatePackageJson",
                        value: function(e) {
                            var t = {
                                name: e.toLowerCase().replace(/[^a-z0-9-]/g, "-"),
                                version: "0.0.1",
                                description: "Generated TypeScript bindings for ".concat(e, " Stellar contract"),
                                type: "module",
                                main: "dist/index.js",
                                types: "dist/index.d.ts",
                                scripts: {
                                    build: "tsc"
                                },
                                dependencies: {
                                    "@stellar/stellar-sdk": "^".concat("15.1.0"),
                                    buffer: "6.0.3"
                                },
                                devDependencies: {
                                    typescript: "^5.6.3"
                                }
                            };
                            return JSON.stringify(t, null, 2);
                        }
                    },
                    {
                        key: "generateTsConfig",
                        value: function() {
                            return JSON.stringify({
                                compilerOptions: {
                                    target: "ESNext",
                                    module: "NodeNext",
                                    moduleResolution: "nodenext",
                                    declaration: !0,
                                    outDir: "./dist",
                                    strictNullChecks: !0,
                                    skipLibCheck: !0
                                },
                                include: [
                                    "src/*"
                                ]
                            }, null, 2);
                        }
                    },
                    {
                        key: "generateGitignore",
                        value: function() {
                            return [
                                "# Dependencies",
                                "node_modules/",
                                "",
                                "# Build outputs",
                                "dist/",
                                "*.tgz",
                                "",
                                "# IDE",
                                ".vscode/",
                                ".idea/",
                                "",
                                "# OS",
                                ".DS_Store",
                                "Thumbs.db",
                                "",
                                "# Logs",
                                "*.log",
                                "npm-debug.log*",
                                "",
                                "# Runtime data",
                                "*.pid",
                                "*.seed"
                            ].join("\n");
                        }
                    },
                    {
                        key: "generateReadme",
                        value: function(e) {
                            return [
                                "# ".concat(e, " Contract Bindings"),
                                "",
                                "TypeScript bindings for the ".concat(e, " Stellar smart contract."),
                                "",
                                "## Installation",
                                "",
                                "```bash",
                                "npm install",
                                "```",
                                "",
                                "## Build",
                                "",
                                "```bash",
                                "npm run build",
                                "```",
                                "",
                                "## Usage",
                                "",
                                "```typescript",
                                'import { Client } from "./src";',
                                "",
                                "const client = new Client({",
                                '  contractId: "YOUR_CONTRACT_ID",',
                                '  rpcUrl: "https://soroban-testnet.stellar.org:443",',
                                '  networkPassphrase: "Test SDF Network ; September 2015",',
                                "});",
                                "",
                                "// Call contract methods",
                                "// const result = await client.methodName();",
                                "```",
                                "",
                                "## Generated Files",
                                "",
                                "- `src/index.ts` - Entry point exporting the Client",
                                "- `src/types.ts` - Type definitions for contract structs, enums, and unions",
                                "- `src/contract.ts` - Client implementation",
                                "- `tsconfig.json` - TypeScript configuration",
                                "- `package.json` - NPM package configuration",
                                "",
                                "This package was generated using the Js-Stellar-SDK contract binding generator."
                            ].join("\n");
                        }
                    }
                ], i(s.prototype, u), c && i(s, c), Object.defineProperty(s, "prototype", {
                    writable: !1
                }), s), f = r(8950), p = r(4366);
                function d(e) {
                    return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, d(e);
                }
                function h(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y(n.key), n);
                    }
                }
                function y(e) {
                    var t = function(e, t) {
                        if ("object" != d(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != d(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == d(t) ? t : t + "";
                }
                var m = function(e, t, r) {
                    return t && h(e.prototype, t), r && h(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }(function e(t) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.spec = t;
                }, [
                    {
                        key: "generate",
                        value: function() {
                            var e = this, t = this.spec.entries.map(function(t) {
                                return e.generateEntry(t);
                            }).filter(function(e) {
                                return e;
                            }).join("\n\n"), r = this.generateImports();
                            return "".concat(r, "\n\n    ").concat(t, "\n    ");
                        }
                    },
                    {
                        key: "generateEntry",
                        value: function(e) {
                            switch(e.switch()){
                                case f.xdr.ScSpecEntryKind.scSpecEntryUdtStructV0():
                                    return (0, p.Q7)(e.udtStructV0()) ? this.generateTupleStruct(e.udtStructV0()) : this.generateStruct(e.udtStructV0());
                                case f.xdr.ScSpecEntryKind.scSpecEntryUdtUnionV0():
                                    return this.generateUnion(e.udtUnionV0());
                                case f.xdr.ScSpecEntryKind.scSpecEntryUdtEnumV0():
                                    return this.generateEnum(e.udtEnumV0());
                                case f.xdr.ScSpecEntryKind.scSpecEntryUdtErrorEnumV0():
                                    return this.generateErrorEnum(e.udtErrorEnumV0());
                                default:
                                    return null;
                            }
                        }
                    },
                    {
                        key: "generateImports",
                        value: function() {
                            var e = (0, p.ch)(this.spec.entries.flatMap(function(e) {
                                switch(e.switch()){
                                    case f.xdr.ScSpecEntryKind.scSpecEntryUdtStructV0():
                                        return e.udtStructV0().fields().map(function(e) {
                                            return e.type();
                                        });
                                    case f.xdr.ScSpecEntryKind.scSpecEntryUdtUnionV0():
                                        return e.udtUnionV0().cases().flatMap(function(e) {
                                            return e.switch() === f.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseTupleV0() ? e.tupleCase().type() : [];
                                        });
                                    case f.xdr.ScSpecEntryKind.scSpecEntryUdtEnumV0():
                                    case f.xdr.ScSpecEntryKind.scSpecEntryUdtErrorEnumV0():
                                    default:
                                        return [];
                                }
                            }));
                            return (0, p.Sq)(e, {
                                includeTypeFileImports: !1
                            });
                        }
                    },
                    {
                        key: "generateStruct",
                        value: function(e) {
                            var t = (0, p.ff)(e.name().toString()), r = (0, p.SB)(e.doc().toString() || "Struct: ".concat(t), 0), n = e.fields().map(function(e) {
                                var t = (0, p.ff)(e.name().toString()), r = (0, p.z0)(e.type()), n = (0, p.SB)(e.doc().toString(), 2);
                                return "".concat(n, "  ").concat(t, ": ").concat(r, ";");
                            }).join("\n");
                            return "".concat(r, "export interface ").concat(t, " {\n").concat(n, "\n}");
                        }
                    },
                    {
                        key: "generateUnion",
                        value: function(e) {
                            var t = this, r = (0, p.ff)(e.name().toString()), n = (0, p.SB)(e.doc().toString() || "Union: ".concat(r), 0), o = e.cases().map(function(e) {
                                return t.generateUnionCase(e);
                            }).map(function(e) {
                                return e.types.length > 0 ? "".concat((0, p.SB)(e.doc, 2), '  { tag: "').concat((0, p.c0)(e.name), '"; values: readonly [').concat(e.types.join(", "), "] }") : "".concat((0, p.SB)(e.doc, 2), '  { tag: "').concat((0, p.c0)(e.name), '"; values: void }');
                            }).join(" |\n");
                            return "".concat(n, " export type ").concat(r, " =\n").concat(o, ";");
                        }
                    },
                    {
                        key: "generateEnum",
                        value: function(e) {
                            var t = (0, p.ff)(e.name().toString()), r = (0, p.SB)(e.doc().toString() || "Enum: ".concat(t), 0), n = e.cases().map(function(e) {
                                var t = (0, p.ff)(e.name().toString()), r = e.value(), n = e.doc().toString() || "Enum Case: ".concat(t);
                                return "".concat((0, p.SB)(n, 2), "  ").concat(t, " = ").concat(r);
                            }).join(",\n");
                            return "".concat(r, "export enum ").concat(t, " {\n").concat(n, "\n}");
                        }
                    },
                    {
                        key: "generateErrorEnum",
                        value: function(e) {
                            var t = this, r = (0, p.ff)(e.name().toString()), n = (0, p.SB)(e.doc().toString() || "Error Enum: ".concat(r), 0), o = e.cases().map(function(e) {
                                return t.generateEnumCase(e);
                            }).map(function(e) {
                                return "".concat((0, p.SB)(e.doc, 2), "  ").concat(e.value, ' : { message: "').concat((0, p.c0)(e.name), '" }');
                            }).join(",\n");
                            return "".concat(n, "export const ").concat(r, " = {\n").concat(o, "\n}");
                        }
                    },
                    {
                        key: "generateUnionCase",
                        value: function(e) {
                            switch(e.switch()){
                                case f.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseVoidV0():
                                    var t = e.voidCase();
                                    return {
                                        doc: t.doc().toString(),
                                        name: t.name().toString(),
                                        types: []
                                    };
                                case f.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseTupleV0():
                                    var r = e.tupleCase();
                                    return {
                                        doc: r.doc().toString(),
                                        name: r.name().toString(),
                                        types: r.type().map(function(e) {
                                            return (0, p.z0)(e);
                                        })
                                    };
                                default:
                                    throw new Error("Unknown union case kind: ".concat(e.switch()));
                            }
                        }
                    },
                    {
                        key: "generateEnumCase",
                        value: function(e) {
                            return {
                                doc: e.doc().toString(),
                                name: e.name().toString(),
                                value: e.value()
                            };
                        }
                    },
                    {
                        key: "generateTupleStruct",
                        value: function(e) {
                            var t = (0, p.ff)(e.name().toString()), r = (0, p.SB)(e.doc().toString() || "Tuple Struct: ".concat(t), 0), n = e.fields().map(function(e) {
                                return (0, p.z0)(e.type());
                            }).join(", ");
                            return "".concat(r, "export type ").concat(t, " = readonly [").concat(n, "];");
                        }
                    }
                ]);
                function g(e) {
                    return g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, g(e);
                }
                function v(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b(n.key), n);
                    }
                }
                function b(e) {
                    var t = function(e, t) {
                        if ("object" != g(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != g(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == g(t) ? t : t + "";
                }
                var w = function(e, t, r) {
                    return t && v(e.prototype, t), r && v(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }(function e(t) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.spec = t;
                }, [
                    {
                        key: "generate",
                        value: function() {
                            var e = this, t = "";
                            try {
                                var r = this.spec.getFunc("__constructor");
                                t = this.generateDeployMethod(r);
                            } catch (e) {
                                t = this.generateDeployMethod(void 0);
                            }
                            var n = this.spec.funcs().filter(function(e) {
                                return "__constructor" !== e.name().toString();
                            }).map(function(t) {
                                return e.generateInterfaceMethod(t);
                            }).join("\n"), o = this.generateImports(), i = this.spec.entries.map(function(e) {
                                return '"'.concat(e.toXDR("base64"), '"');
                            }), a = this.spec.funcs().filter(function(e) {
                                return "__constructor" !== e.name().toString();
                            }).map(function(t) {
                                return e.generateFromJSONMethod(t);
                            }).join(",");
                            return "".concat(o, "\n\nexport interface Client {\n").concat(n, "\n}\n\nexport class Client extends ContractClient {\n  constructor(public readonly options: ContractClientOptions) {\n    super(\n      new Spec([").concat(i.join(", "), "]),\n      options\n    );\n  }\n\n ").concat(t, "\n  public readonly fromJSON = {\n  ").concat(a, "\n  };\n}");
                        }
                    },
                    {
                        key: "generateImports",
                        value: function() {
                            var e = (0, p.ch)(this.spec.funcs().flatMap(function(e) {
                                var t = e.inputs(), r = e.outputs();
                                return t.map(function(e) {
                                    return e.type();
                                }).concat(r);
                            }));
                            return (0, p.Sq)(e, {
                                includeTypeFileImports: !0,
                                additionalStellarContractImports: [
                                    "Spec",
                                    "AssembledTransaction",
                                    "Client as ContractClient",
                                    "ClientOptions as ContractClientOptions",
                                    "MethodOptions"
                                ]
                            });
                        }
                    },
                    {
                        key: "generateInterfaceMethod",
                        value: function(e) {
                            var t = (0, p.ff)(e.name().toString()), r = e.inputs().map(function(e) {
                                return {
                                    name: (0, p.ff)(e.name().toString()),
                                    type: (0, p.z0)(e.type(), !0)
                                };
                            }), n = e.outputs().length > 0 ? (0, p.z0)(e.outputs()[0]) : "void", o = (0, p.SB)(e.doc().toString(), 2), i = this.formatMethodParameters(r);
                            return "".concat(o, "  ").concat(t, "(").concat(i, "): Promise<AssembledTransaction<").concat(n, ">>;");
                        }
                    },
                    {
                        key: "generateFromJSONMethod",
                        value: function(e) {
                            var t = (0, p.ff)(e.name().toString()), r = e.outputs().length > 0 ? (0, p.z0)(e.outputs()[0]) : "void";
                            return "  ".concat(t, " : this.txFromJSON<").concat(r, ">");
                        }
                    },
                    {
                        key: "generateDeployMethod",
                        value: function(e) {
                            if (!e) {
                                var t = this.formatConstructorParameters([]);
                                return "  static deploy<T = Client>(".concat(t, "): Promise<AssembledTransaction<T>> {\n    return ContractClient.deploy(null, options);\n  }");
                            }
                            var r = e.inputs().map(function(e) {
                                return {
                                    name: (0, p.ff)(e.name().toString()),
                                    type: (0, p.z0)(e.type(), !0)
                                };
                            }), n = this.formatConstructorParameters(r), o = r.length > 0 ? "{ ".concat(r.map(function(e) {
                                return e.name;
                            }).join(", "), " }, ") : "";
                            return "  static deploy<T = Client>(".concat(n, "): Promise<AssembledTransaction<T>> {\n    return ContractClient.deploy(").concat(o, "options);\n  }");
                        }
                    },
                    {
                        key: "formatMethodParameters",
                        value: function(e) {
                            var t = [];
                            if (e.length > 0) {
                                var r = "{ ".concat(e.map(function(e) {
                                    return "".concat(e.name, ": ").concat(e.type);
                                }).join("; "), " }");
                                t.push("{ ".concat(e.map(function(e) {
                                    return e.name;
                                }).join(", "), " }: ").concat(r));
                            }
                            return t.push("options?: MethodOptions"), t.join(", ");
                        }
                    },
                    {
                        key: "formatConstructorParameters",
                        value: function(e) {
                            var t = [];
                            if (e.length > 0) {
                                var r = "{ ".concat(e.map(function(e) {
                                    return "".concat(e.name, ": ").concat(e.type);
                                }).join("; "), " }");
                                t.push("{ ".concat(e.map(function(e) {
                                    return e.name;
                                }).join(", "), " }: ").concat(r));
                            }
                            return t.push('options: MethodOptions & Omit<ContractClientOptions, \'contractId\'> & { wasmHash: Buffer | string; salt?: Buffer | Uint8Array; format?: "hex" | "base64"; address?: string; }'), t.join(", ");
                        }
                    }
                ]), S = r(8451), A = r(8287).Buffer;
                function E(e) {
                    return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, E(e);
                }
                function T() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return O(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (O(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, O(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, O(f, "constructor", c), O(c, "constructor", u), u.displayName = "GeneratorFunction", O(c, o, "GeneratorFunction"), O(f), O(f, o, "Generator"), O(f, n, function() {
                        return this;
                    }), O(f, "toString", function() {
                        return "[object Generator]";
                    }), (T = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function O(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    O = function(e, t, r, n) {
                        function i(t, r) {
                            O(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, O(e, t, r, n);
                }
                function k(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function _(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                k(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                k(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function x(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, P(n.key), n);
                    }
                }
                function P(e) {
                    var t = function(e, t) {
                        if ("object" != E(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != E(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == E(t) ? t : t + "";
                }
                function R(e, t, r) {
                    return t = j(t), function(e, t) {
                        if (t && ("object" == E(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, B() ? Reflect.construct(t, r || [], j(e).constructor) : t.apply(e, r));
                }
                function I(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return I = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return function(e, t, r) {
                                if (B()) return Reflect.construct.apply(null, arguments);
                                var n = [
                                    null
                                ];
                                n.push.apply(n, t);
                                var o = new (e.bind.apply(e, n));
                                return r && C(o, r.prototype), o;
                            }(e, arguments, j(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), C(r, e);
                    }, I(e);
                }
                function B() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (B = function() {
                        return !!e;
                    })();
                }
                function C(e, t) {
                    return C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, C(e, t);
                }
                function j(e) {
                    return j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, j(e);
                }
                var U = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = R(this, t, [
                            e
                        ])).cause = r, n.name = "WasmFetchError", n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && C(e, t);
                    }(t, e), function(e, t, r) {
                        return t && x(e.prototype, t), r && x(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t);
                }(I(Error));
                function N(e, t) {
                    return L.apply(this, arguments);
                }
                function L() {
                    return (L = _(T().m(function e(t, r) {
                        var n, o, i, a, s;
                        return T().w(function(e) {
                            for(;;)switch(e.p = e.n){
                                case 0:
                                    return e.p = 0, n = f.xdr.LedgerKey.contractCode(new f.xdr.LedgerKeyContractCode({
                                        hash: f.xdr.Hash.fromXDR(r, "raw")
                                    })), e.n = 1, t.getLedgerEntries(n);
                                case 1:
                                    if ((o = e.v).entries && 0 !== o.entries.length) {
                                        e.n = 2;
                                        break;
                                    }
                                    throw new U("WASM not found for the given hash");
                                case 2:
                                    if ((i = o.entries[0]).key.switch() === f.xdr.LedgerEntryType.contractCode()) {
                                        e.n = 3;
                                        break;
                                    }
                                    throw new U("Invalid ledger entry type returned");
                                case 3:
                                    return a = i.val.contractCode(), e.a(2, A.from(a.code()));
                                case 4:
                                    if (e.p = 4, !((s = e.v) instanceof U)) {
                                        e.n = 5;
                                        break;
                                    }
                                    throw s;
                                case 5:
                                    throw new U("Failed to fetch WASM from hash", s);
                                case 6:
                                    return e.a(2);
                            }
                        }, e, null, [
                            [
                                0,
                                4
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function F(e) {
                    return e.executable().switch() === f.xdr.ContractExecutableType.contractExecutableStellarAsset();
                }
                function D(e, t) {
                    return M.apply(this, arguments);
                }
                function M() {
                    return M = _(T().m(function e(t, r) {
                        var n, o, i, a, s, u, c, l;
                        return T().w(function(e) {
                            for(;;)switch(e.p = e.n){
                                case 0:
                                    return e.p = 0, n = new f.Contract(r.toString()), e.n = 1, t.getLedgerEntries(n.getFootprint());
                                case 1:
                                    if ((o = e.v).entries && 0 !== o.entries.length) {
                                        e.n = 2;
                                        break;
                                    }
                                    throw new U("Contract instance not found");
                                case 2:
                                    if ((i = o.entries[0]).key.switch() === f.xdr.LedgerEntryType.contractData()) {
                                        e.n = 3;
                                        break;
                                    }
                                    throw new U("Invalid ledger entry type returned");
                                case 3:
                                    if (a = i.val.contractData(), !F(s = a.val().instance())) {
                                        e.n = 4;
                                        break;
                                    }
                                    return e.a(2, {
                                        type: "stellar-asset-contract"
                                    });
                                case 4:
                                    return u = s.executable().wasmHash(), e.n = 5, N(t, u);
                                case 5:
                                    return c = e.v, e.a(2, {
                                        type: "wasm",
                                        wasmBytes: c
                                    });
                                case 6:
                                    if (e.p = 6, !((l = e.v) instanceof U)) {
                                        e.n = 7;
                                        break;
                                    }
                                    throw l;
                                case 7:
                                    throw new U("Failed to fetch WASM from contract", l);
                                case 8:
                                    return e.a(2);
                            }
                        }, e, null, [
                            [
                                0,
                                6
                            ]
                        ]);
                    })), M.apply(this, arguments);
                }
                function V(e, t) {
                    return q.apply(this, arguments);
                }
                function q() {
                    return (q = _(T().m(function e(t, r) {
                        var n, o, i;
                        return T().w(function(e) {
                            for(;;)switch(e.p = e.n){
                                case 0:
                                    if (e.p = 0, 32 === (n = A.from(t, "hex")).length) {
                                        e.n = 1;
                                        break;
                                    }
                                    throw new U("Invalid WASM hash length: expected 32 bytes, got ".concat(n.length));
                                case 1:
                                    return e.n = 2, N(r, n);
                                case 2:
                                    return o = e.v, e.a(2, {
                                        type: "wasm",
                                        wasmBytes: o
                                    });
                                case 3:
                                    throw e.p = 3, i = e.v, new U("Failed to fetch WASM from hash ".concat(t), i);
                                case 4:
                                    return e.a(2);
                            }
                        }, e, null, [
                            [
                                0,
                                3
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function G(e, t) {
                    return H.apply(this, arguments);
                }
                function H() {
                    return (H = _(T().m(function e(t, r) {
                        var n, o;
                        return T().w(function(e) {
                            for(;;)switch(e.p = e.n){
                                case 0:
                                    if (e.p = 0, f.StrKey.isValidContract(t)) {
                                        e.n = 1;
                                        break;
                                    }
                                    throw new U("Invalid contract ID: ".concat(t));
                                case 1:
                                    return n = f.Address.fromString(t), e.n = 2, D(r, n);
                                case 2:
                                    return e.a(2, e.v);
                                case 3:
                                    throw e.p = 3, o = e.v, new U("Failed to fetch WASM from contract ".concat(t), o);
                                case 4:
                                    return e.a(2);
                            }
                        }, e, null, [
                            [
                                0,
                                3
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function z(e) {
                    return z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, z(e);
                }
                function W() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return X(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (X(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, X(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, X(f, "constructor", c), X(c, "constructor", u), u.displayName = "GeneratorFunction", X(c, o, "GeneratorFunction"), X(f), X(f, o, "Generator"), X(f, n, function() {
                        return this;
                    }), X(f, "toString", function() {
                        return "[object Generator]";
                    }), (W = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function X(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    X = function(e, t, r, n) {
                        function i(t, r) {
                            X(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, X(e, t, r, n);
                }
                function K(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function Z(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                K(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                K(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function $(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Y(n.key), n);
                    }
                }
                function Y(e) {
                    var t = function(e, t) {
                        if ("object" != z(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != z(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == z(t) ? t : t + "";
                }
                var Q = function() {
                    function e(t) {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.spec = t;
                    }
                    var t, r;
                    return function(e, t, r) {
                        return t && $(e.prototype, t), r && $(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(e, [
                        {
                            key: "generate",
                            value: function(e) {
                                this.validateOptions(e);
                                var t = new m(this.spec), r = new w(this.spec), n = t.generate(), o = r.generate(), i = 'export { Client } from "./client.js";';
                                "" !== n.trim() && (i = i.concat('\nexport * from "./types.js";'));
                                var a = (new l).generate(e);
                                return {
                                    index: i,
                                    types: n,
                                    client: o,
                                    packageJson: a.packageJson,
                                    tsConfig: a.tsConfig,
                                    readme: a.readme,
                                    gitignore: a.gitignore
                                };
                            }
                        },
                        {
                            key: "validateOptions",
                            value: function(e) {
                                if (!e.contractName || "" === e.contractName.trim()) throw new Error("contractName is required and cannot be empty");
                            }
                        }
                    ], [
                        {
                            key: "fromSpec",
                            value: function(t) {
                                return new e(t);
                            }
                        },
                        {
                            key: "fromWasm",
                            value: function(t) {
                                return new e(new n.Spec((0, S.U)(t)));
                            }
                        },
                        {
                            key: "fromWasmHash",
                            value: (r = Z(W().m(function t(r, n) {
                                var o;
                                return W().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return t.n = 1, V(r, n);
                                        case 1:
                                            if ("wasm" === (o = t.v).type) {
                                                t.n = 2;
                                                break;
                                            }
                                            throw new Error("Fetched contract is not of type 'wasm'");
                                        case 2:
                                            return t.a(2, e.fromWasm(o.wasmBytes));
                                    }
                                }, t);
                            })), function(e, t) {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "fromContractId",
                            value: (t = Z(W().m(function t(r, o) {
                                var i, a;
                                return W().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return t.n = 1, G(r, o);
                                        case 1:
                                            if ("wasm" !== (i = t.v).type) {
                                                t.n = 2;
                                                break;
                                            }
                                            return t.a(2, e.fromWasm(i.wasmBytes));
                                        case 2:
                                            return a = new n.Spec("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"), t.a(2, e.fromSpec(a));
                                    }
                                }, t);
                            })), function(e, r) {
                                return t.apply(this, arguments);
                            })
                        }
                    ]);
                }();
            },
            4366 (e, t, r) {
                "use strict";
                r.d(t, {
                    Q7: ()=>d,
                    SB: ()=>p,
                    Sq: ()=>f,
                    c0: ()=>s,
                    ch: ()=>l,
                    ff: ()=>a,
                    z0: ()=>u
                });
                var n = r(8950);
                function o(e) {
                    return function(e) {
                        if (Array.isArray(e)) return i(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return i(e, t);
                            var r = ({}).toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function i(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function a(e) {
                    var t = e.replace(/[^a-zA-Z0-9_$]/g, "_");
                    return [
                        "break",
                        "case",
                        "catch",
                        "class",
                        "const",
                        "continue",
                        "debugger",
                        "default",
                        "delete",
                        "do",
                        "else",
                        "export",
                        "extends",
                        "finally",
                        "for",
                        "function",
                        "if",
                        "import",
                        "in",
                        "instanceof",
                        "new",
                        "return",
                        "super",
                        "switch",
                        "this",
                        "throw",
                        "try",
                        "typeof",
                        "var",
                        "void",
                        "while",
                        "with",
                        "yield",
                        "enum",
                        "implements",
                        "interface",
                        "let",
                        "package",
                        "private",
                        "protected",
                        "public",
                        "static",
                        "async",
                        "await",
                        "constructor",
                        "null",
                        "true",
                        "false"
                    ].includes(t) ? t + "_" : /^\d/.test(t) ? "_" + t : "" === t || /^_+$/.test(t) ? "_unnamed" : t;
                }
                function s(e) {
                    return e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
                }
                function u(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    switch(e.switch()){
                        case n.xdr.ScSpecType.scSpecTypeVal():
                            return "any";
                        case n.xdr.ScSpecType.scSpecTypeBool():
                            return "boolean";
                        case n.xdr.ScSpecType.scSpecTypeVoid():
                            return "null";
                        case n.xdr.ScSpecType.scSpecTypeError():
                            return "Error";
                        case n.xdr.ScSpecType.scSpecTypeU32():
                        case n.xdr.ScSpecType.scSpecTypeI32():
                            return "number";
                        case n.xdr.ScSpecType.scSpecTypeU64():
                        case n.xdr.ScSpecType.scSpecTypeI64():
                        case n.xdr.ScSpecType.scSpecTypeTimepoint():
                        case n.xdr.ScSpecType.scSpecTypeDuration():
                        case n.xdr.ScSpecType.scSpecTypeU128():
                        case n.xdr.ScSpecType.scSpecTypeI128():
                        case n.xdr.ScSpecType.scSpecTypeU256():
                        case n.xdr.ScSpecType.scSpecTypeI256():
                            return "bigint";
                        case n.xdr.ScSpecType.scSpecTypeBytes():
                        case n.xdr.ScSpecType.scSpecTypeBytesN():
                            return "Buffer";
                        case n.xdr.ScSpecType.scSpecTypeString():
                        case n.xdr.ScSpecType.scSpecTypeSymbol():
                            return "string";
                        case n.xdr.ScSpecType.scSpecTypeAddress():
                        case n.xdr.ScSpecType.scSpecTypeMuxedAddress():
                            return t ? "string | Address" : "string";
                        case n.xdr.ScSpecType.scSpecTypeVec():
                            var r = u(e.vec().elementType(), t);
                            return "Array<".concat(r, ">");
                        case n.xdr.ScSpecType.scSpecTypeMap():
                            var o = u(e.map().keyType(), t), i = u(e.map().valueType(), t);
                            return "Map<".concat(o, ", ").concat(i, ">");
                        case n.xdr.ScSpecType.scSpecTypeTuple():
                            var s = e.tuple().valueTypes().map(function(e) {
                                return u(e, t);
                            });
                            return "[".concat(s.join(", "), "]");
                        case n.xdr.ScSpecType.scSpecTypeOption():
                            for(; e.option().valueType().switch() === n.xdr.ScSpecType.scSpecTypeOption();)e = e.option().valueType();
                            var c = u(e.option().valueType(), t);
                            return "".concat(c, " | null");
                        case n.xdr.ScSpecType.scSpecTypeResult():
                            var l = u(e.result().okType(), t), f = u(e.result().errorType(), t);
                            return "Result<".concat(l, ", ").concat(f, ">");
                        case n.xdr.ScSpecType.scSpecTypeUdt():
                            return a(e.udt().name().toString());
                        default:
                            return "unknown";
                    }
                }
                function c(e, t) {
                    switch(e.switch()){
                        case n.xdr.ScSpecType.scSpecTypeUdt():
                            return void t.typeFileImports.add(a(e.udt().name().toString()));
                        case n.xdr.ScSpecType.scSpecTypeAddress():
                        case n.xdr.ScSpecType.scSpecTypeMuxedAddress():
                            return void t.stellarImports.add("Address");
                        case n.xdr.ScSpecType.scSpecTypeBytes():
                        case n.xdr.ScSpecType.scSpecTypeBytesN():
                            return void (t.needsBufferImport = !0);
                        case n.xdr.ScSpecType.scSpecTypeVal():
                            return void t.stellarImports.add("xdr");
                        case n.xdr.ScSpecType.scSpecTypeResult():
                            t.stellarContractImports.add("Result");
                            break;
                        case n.xdr.ScSpecType.scSpecTypeBool():
                        case n.xdr.ScSpecType.scSpecTypeVoid():
                        case n.xdr.ScSpecType.scSpecTypeError():
                        case n.xdr.ScSpecType.scSpecTypeU32():
                        case n.xdr.ScSpecType.scSpecTypeI32():
                        case n.xdr.ScSpecType.scSpecTypeU64():
                        case n.xdr.ScSpecType.scSpecTypeI64():
                        case n.xdr.ScSpecType.scSpecTypeTimepoint():
                        case n.xdr.ScSpecType.scSpecTypeDuration():
                        case n.xdr.ScSpecType.scSpecTypeU128():
                        case n.xdr.ScSpecType.scSpecTypeI128():
                        case n.xdr.ScSpecType.scSpecTypeU256():
                        case n.xdr.ScSpecType.scSpecTypeI256():
                        case n.xdr.ScSpecType.scSpecTypeString():
                        case n.xdr.ScSpecType.scSpecTypeSymbol():
                            return;
                    }
                    var r = function(e) {
                        switch(e.switch()){
                            case n.xdr.ScSpecType.scSpecTypeVec():
                                return [
                                    e.vec().elementType()
                                ];
                            case n.xdr.ScSpecType.scSpecTypeMap():
                                return [
                                    e.map().keyType(),
                                    e.map().valueType()
                                ];
                            case n.xdr.ScSpecType.scSpecTypeTuple():
                                return e.tuple().valueTypes();
                            case n.xdr.ScSpecType.scSpecTypeOption():
                                return [
                                    e.option().valueType()
                                ];
                            case n.xdr.ScSpecType.scSpecTypeResult():
                                return [
                                    e.result().okType(),
                                    e.result().errorType()
                                ];
                            default:
                                return [];
                        }
                    }(e);
                    r.forEach(function(e) {
                        return c(e, t);
                    });
                }
                function l(e) {
                    var t = {
                        typeFileImports: new Set,
                        stellarContractImports: new Set,
                        stellarImports: new Set,
                        needsBufferImport: !1
                    };
                    return e.forEach(function(e) {
                        return c(e, t);
                    }), t;
                }
                function f(e, t) {
                    var r = [], n = e.typeFileImports, i = [].concat(o(e.stellarContractImports), o((null == t ? void 0 : t.additionalStellarContractImports) || [])), a = [].concat(o(e.stellarImports), o((null == t ? void 0 : t.additionalStellarImports) || []));
                    if (null != t && t.includeTypeFileImports && n.size > 0 && r.push("import {".concat(Array.from(n).join(", "), "} from './types.js';")), i.length > 0) {
                        var s = Array.from(new Set(i));
                        r.push("import {".concat(s.join(", "), "} from '@stellar/stellar-sdk/contract';"));
                    }
                    if (a.length > 0) {
                        var u = Array.from(new Set(a));
                        r.push("import {".concat(u.join(", "), "} from '@stellar/stellar-sdk';"));
                    }
                    return e.needsBufferImport && r.push("import { Buffer } from 'buffer';"), r.join("\n");
                }
                function p(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    if ("" === e.trim()) return "";
                    var r = " ".repeat(t), n = e.replace(/\*\//g, "* /").replace(/@(?!(param|returns?|type|throws?|example|deprecated|see|link|since|author|version|description|summary)\b)/g, "\\@").split("\n").map(function(e) {
                        return "".concat(r, " * ").concat(e).trimEnd();
                    });
                    return "".concat(r, "/**\n").concat(n.join("\n"), "\n").concat(r, " */\n");
                }
                function d(e) {
                    return e.fields().every(function(e, t) {
                        return e.name().toString().trim() === t.toString();
                    });
                }
            },
            1924 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    StellarBase: ()=>a,
                    default: ()=>s,
                    httpClient: ()=>n.ok
                });
                var n = r(9983), o = r(4356), i = {};
                for(const e in o)[
                    "default",
                    "StellarBase",
                    "httpClient"
                ].indexOf(e) < 0 && (i[e] = ()=>o[e]);
                r.d(t, i);
                var a = r(8950);
                const s = (e = r.hmd(e)).exports;
            },
            8732 (e, t, r) {
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, u(n.key), n);
                    }
                }
                function i(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function a(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = u(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function u(e) {
                    var t = function(e, t) {
                        if ("object" != n(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, t || "default");
                            if ("object" != n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == n(t) ? t : t + "";
                }
                r.d(t, {
                    T: ()=>h
                });
                var c, l, f, p = {
                    allowHttp: !1,
                    timeout: 0
                }, d = a({}, p), h = (c = function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }, f = [
                    {
                        key: "setAllowHttp",
                        value: function(e) {
                            d.allowHttp = e;
                        }
                    },
                    {
                        key: "setTimeout",
                        value: function(e) {
                            d.timeout = e;
                        }
                    },
                    {
                        key: "isAllowHttp",
                        value: function() {
                            return d.allowHttp;
                        }
                    },
                    {
                        key: "getTimeout",
                        value: function() {
                            return d.timeout;
                        }
                    },
                    {
                        key: "setDefault",
                        value: function() {
                            d = a({}, p);
                        }
                    }
                ], l = null, f && o(c, f), Object.defineProperty(c, "prototype", {
                    writable: !1
                }), c);
            },
            8250 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    AssembledTransaction: ()=>Ee,
                    Client: ()=>ct,
                    DEFAULT_TIMEOUT: ()=>m.c,
                    Err: ()=>h,
                    NULL_ACCOUNT: ()=>m.u,
                    Ok: ()=>d,
                    SentTransaction: ()=>j,
                    Spec: ()=>He,
                    Watcher: ()=>U,
                    basicNodeSigner: ()=>Pe
                });
                var n = r(8950), o = r(3496), i = r(4076), a = r(8680);
                function s(e) {
                    return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, s(e);
                }
                function u(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function c(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, f(n.key), n);
                    }
                }
                function l(e, t, r) {
                    return t && c(e.prototype, t), r && c(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function f(e) {
                    var t = function(e, t) {
                        if ("object" != s(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != s(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == s(t) ? t : t + "";
                }
                var p, d = l(function e(t) {
                    u(this, e), this.value = t;
                }, [
                    {
                        key: "unwrapErr",
                        value: function() {
                            throw new Error("No error");
                        }
                    },
                    {
                        key: "unwrap",
                        value: function() {
                            return this.value;
                        }
                    },
                    {
                        key: "isOk",
                        value: function() {
                            return !0;
                        }
                    },
                    {
                        key: "isErr",
                        value: function() {
                            return !1;
                        }
                    }
                ]), h = l(function e(t) {
                    u(this, e), this.error = t;
                }, [
                    {
                        key: "unwrapErr",
                        value: function() {
                            return this.error;
                        }
                    },
                    {
                        key: "unwrap",
                        value: function() {
                            throw new Error(this.error.message);
                        }
                    },
                    {
                        key: "isOk",
                        value: function() {
                            return !1;
                        }
                    },
                    {
                        key: "isErr",
                        value: function() {
                            return !0;
                        }
                    }
                ]), y = r(8302), m = r(9138);
                function g(e, t, r) {
                    return t = A(t), function(e, t) {
                        if (t && ("object" == E(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, w() ? Reflect.construct(t, r || [], A(e).constructor) : t.apply(e, r));
                }
                function v(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && S(e, t);
                }
                function b(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return b = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return function(e, t, r) {
                                if (w()) return Reflect.construct.apply(null, arguments);
                                var n = [
                                    null
                                ];
                                n.push.apply(n, t);
                                var o = new (e.bind.apply(e, n));
                                return r && S(o, r.prototype), o;
                            }(e, arguments, A(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), S(r, e);
                    }, b(e);
                }
                function w() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (w = function() {
                        return !!e;
                    })();
                }
                function S(e, t) {
                    return S = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, S(e, t);
                }
                function A(e) {
                    return A = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, A(e);
                }
                function E(e) {
                    return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, E(e);
                }
                function T() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return O(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (O(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, O(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, O(f, "constructor", c), O(c, "constructor", u), u.displayName = "GeneratorFunction", O(c, o, "GeneratorFunction"), O(f), O(f, o, "Generator"), O(f, n, function() {
                        return this;
                    }), O(f, "toString", function() {
                        return "[object Generator]";
                    }), (T = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function O(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    O = function(e, t, r, n) {
                        function i(t, r) {
                            O(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, O(e, t, r, n);
                }
                function k(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function _(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                k(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                k(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function x(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function P(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, B(n.key), n);
                    }
                }
                function R(e, t, r) {
                    return t && P(e.prototype, t), r && P(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function I(e, t, r) {
                    return (t = B(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function B(e) {
                    var t = function(e, t) {
                        if ("object" != E(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != E(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == E(t) ? t : t + "";
                }
                var C, j = function() {
                    function e(t) {
                        var r, n = this;
                        x(this, e), I(this, "send", (r = _(T().m(function t(r) {
                            var o, a, s;
                            return T().w(function(t) {
                                for(;;)switch(t.n){
                                    case 0:
                                        return t.n = 1, n.server.sendTransaction(n.assembled.signed);
                                    case 1:
                                        if (n.sendTransactionResponse = t.v, "PENDING" === n.sendTransactionResponse.status) {
                                            t.n = 2;
                                            break;
                                        }
                                        throw new e.Errors.SendFailed("Sending the transaction to the network failed!\n".concat(JSON.stringify(n.sendTransactionResponse, null, 2)));
                                    case 2:
                                        return null != r && r.onSubmitted && r.onSubmitted(n.sendTransactionResponse), a = n.sendTransactionResponse.hash, s = null !== (o = n.assembled.options.timeoutInSeconds) && void 0 !== o ? o : m.c, t.n = 3, (0, y.cF)(_(T().m(function e() {
                                            var t;
                                            return T().w(function(e) {
                                                for(;;)switch(e.n){
                                                    case 0:
                                                        return e.n = 1, n.server.getTransaction(a);
                                                    case 1:
                                                        return t = e.v, null != r && r.onProgress && r.onProgress(t), e.a(2, t);
                                                }
                                            }, e);
                                        })), function(e) {
                                            return e.status === i.j.GetTransactionStatus.NOT_FOUND;
                                        }, s);
                                    case 3:
                                        if (n.getTransactionResponseAll = t.v, n.getTransactionResponse = n.getTransactionResponseAll[n.getTransactionResponseAll.length - 1], n.getTransactionResponse.status !== i.j.GetTransactionStatus.NOT_FOUND) {
                                            t.n = 4;
                                            break;
                                        }
                                        throw new e.Errors.TransactionStillPending("Waited ".concat(s, " seconds for transaction to complete, but it did not. ") + "Returning anyway. Check the transaction status manually. " + "Sent transaction: ".concat(JSON.stringify(n.sendTransactionResponse, null, 2), "\n") + "All attempts to get the result: ".concat(JSON.stringify(n.getTransactionResponseAll, null, 2)));
                                    case 4:
                                        return t.a(2, n);
                                }
                            }, t);
                        })), function(e) {
                            return r.apply(this, arguments);
                        })), this.assembled = t;
                        var a = this.assembled.options, s = a.server, u = a.allowHttp, c = a.headers, l = a.rpcUrl;
                        this.server = null != s ? s : new o.Server(l, {
                            allowHttp: u,
                            headers: c
                        });
                    }
                    return R(e, [
                        {
                            key: "result",
                            get: function() {
                                if ("getTransactionResponse" in this && this.getTransactionResponse) {
                                    if ("returnValue" in this.getTransactionResponse) return this.assembled.options.parseResultXdr(this.getTransactionResponse.returnValue);
                                    throw new Error("Transaction failed! Cannot parse result.");
                                }
                                if (this.sendTransactionResponse) {
                                    var t, r = null === (t = this.sendTransactionResponse.errorResult) || void 0 === t ? void 0 : t.result();
                                    if (r) throw new e.Errors.SendFailed("Transaction simulation looked correct, but attempting to send the transaction failed. Check `simulation` and `sendTransactionResponseAll` to troubleshoot. Decoded `sendTransactionResponse.errorResultXdr`: ".concat(r));
                                    throw new e.Errors.SendResultOnly("Transaction was sent to the network, but not yet awaited. No result to show. Await transaction completion with `getTransaction(sendTransactionResponse.hash)`");
                                }
                                throw new Error("Sending transaction failed: ".concat(JSON.stringify(this.assembled.signed)));
                            }
                        }
                    ]);
                }();
                p = j, I(j, "Errors", {
                    SendFailed: function(e) {
                        function t() {
                            return x(this, t), g(this, t, arguments);
                        }
                        return v(t, e), R(t);
                    }(b(Error)),
                    SendResultOnly: function(e) {
                        function t() {
                            return x(this, t), g(this, t, arguments);
                        }
                        return v(t, e), R(t);
                    }(b(Error)),
                    TransactionStillPending: function(e) {
                        function t() {
                            return x(this, t), g(this, t, arguments);
                        }
                        return v(t, e), R(t);
                    }(b(Error))
                }), I(j, "init", (C = _(T().m(function e(t, r) {
                    var n, o;
                    return T().w(function(e) {
                        for(;;)switch(e.n){
                            case 0:
                                return n = new p(t), e.n = 1, n.send(r);
                            case 1:
                                return o = e.v, e.a(2, o);
                        }
                    }, e);
                })), function(e, t) {
                    return C.apply(this, arguments);
                }));
                var U = R(function e() {
                    x(this, e);
                });
                function N(e) {
                    return N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, N(e);
                }
                function L(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, D(n.key), n);
                    }
                }
                function F(e, t, r) {
                    return t && L(e.prototype, t), r && L(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function D(e) {
                    var t = function(e, t) {
                        if ("object" != N(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != N(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == N(t) ? t : t + "";
                }
                function M(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function V(e, t, r) {
                    return t = W(t), function(e, t) {
                        if (t && ("object" == N(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, H() ? Reflect.construct(t, r || [], W(e).constructor) : t.apply(e, r));
                }
                function q(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && z(e, t);
                }
                function G(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return G = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return function(e, t, r) {
                                if (H()) return Reflect.construct.apply(null, arguments);
                                var n = [
                                    null
                                ];
                                n.push.apply(n, t);
                                var o = new (e.bind.apply(e, n));
                                return r && z(o, r.prototype), o;
                            }(e, arguments, W(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), z(r, e);
                    }, G(e);
                }
                function H() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (H = function() {
                        return !!e;
                    })();
                }
                function z(e, t) {
                    return z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, z(e, t);
                }
                function W(e) {
                    return W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, W(e);
                }
                var X = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), K = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), Z = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), $ = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), Y = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), Q = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), J = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), ee = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), te = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), re = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), ne = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), oe = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), ie = function(e) {
                    function t() {
                        return M(this, t), V(this, t, arguments);
                    }
                    return q(t, e), F(t);
                }(G(Error)), ae = r(8287).Buffer;
                function se(e) {
                    return se = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, se(e);
                }
                function ue(e) {
                    if (null != e) {
                        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
                        if (t) return t.call(e);
                        if ("function" == typeof e.next) return e;
                        if (!isNaN(e.length)) return {
                            next: function() {
                                return e && r >= e.length && (e = void 0), {
                                    value: e && e[r++],
                                    done: !e
                                };
                            }
                        };
                    }
                    throw new TypeError(se(e) + " is not iterable");
                }
                function ce(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, o, i, a, s = [], u = !0, c = !1;
                            try {
                                if (i = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    u = !1;
                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                            } catch (e) {
                                c = !0, o = e;
                            } finally{
                                try {
                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw o;
                                }
                            }
                            return s;
                        }
                    }(e, t) || me(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function le(e, t) {
                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e) || (r = me(e)) || t && e && "number" == typeof e.length) {
                            r && (e = r);
                            var n = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return n >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[n++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, s = !1;
                    return {
                        s: function() {
                            r = r.call(e);
                        },
                        n: function() {
                            var e = r.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            s = !0, i = e;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                    };
                }
                function fe(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function pe(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? fe(Object(r), !0).forEach(function(t) {
                            Se(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fe(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function de() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return he(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (he(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, he(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, he(f, "constructor", c), he(c, "constructor", u), u.displayName = "GeneratorFunction", he(c, o, "GeneratorFunction"), he(f), he(f, o, "Generator"), he(f, n, function() {
                        return this;
                    }), he(f, "toString", function() {
                        return "[object Generator]";
                    }), (de = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function he(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    he = function(e, t, r, n) {
                        function i(t, r) {
                            he(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, he(e, t, r, n);
                }
                function ye(e) {
                    return function(e) {
                        if (Array.isArray(e)) return ge(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || me(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function me(e, t) {
                    if (e) {
                        if ("string" == typeof e) return ge(e, t);
                        var r = ({}).toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ge(e, t) : void 0;
                    }
                }
                function ge(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function ve(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function be(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                ve(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                ve(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function we(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ae(n.key), n);
                    }
                }
                function Se(e, t, r) {
                    return (t = Ae(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function Ae(e) {
                    var t = function(e, t) {
                        if ("object" != se(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != se(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == se(t) ? t : t + "";
                }
                var Ee = function() {
                    function e(t) {
                        var r, s = this;
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), Se(this, "simulate", be(de().m(function t() {
                            var r, o, u, c, l, f, p, d, h = arguments;
                            return de().w(function(t) {
                                for(;;)switch(t.n){
                                    case 0:
                                        if (r = (h.length > 0 && void 0 !== h[0] ? h[0] : {}).restore, s.built) {
                                            t.n = 2;
                                            break;
                                        }
                                        if (s.raw) {
                                            t.n = 1;
                                            break;
                                        }
                                        throw new Error("Transaction has not yet been assembled; call `AssembledTransaction.build` first.");
                                    case 1:
                                        s.built = s.raw.build();
                                    case 2:
                                        return r = null != r ? r : s.options.restore, delete s.simulationResult, delete s.simulationTransactionData, t.n = 3, s.server.simulateTransaction(s.built);
                                    case 3:
                                        if (s.simulation = t.v, !r || !i.j.isSimulationRestore(s.simulation)) {
                                            t.n = 8;
                                            break;
                                        }
                                        return t.n = 4, (0, y.sU)(s.options, s.server);
                                    case 4:
                                        return o = t.v, t.n = 5, s.restoreFootprint(s.simulation.restorePreamble, o);
                                    case 5:
                                        if ((u = t.v).status !== i.j.GetTransactionStatus.SUCCESS) {
                                            t.n = 7;
                                            break;
                                        }
                                        return d = s.originalOp ? s.originalOp : (c = new n.Contract(s.options.contractId)).call.apply(c, [
                                            s.options.method
                                        ].concat(ye(null !== (l = s.options.args) && void 0 !== l ? l : []))), s.raw = new n.TransactionBuilder(o, {
                                            fee: null !== (f = s.options.fee) && void 0 !== f ? f : n.BASE_FEE,
                                            networkPassphrase: s.options.networkPassphrase
                                        }).addOperation(d).setTimeout(null !== (p = s.options.timeoutInSeconds) && void 0 !== p ? p : m.c), delete s.built, t.n = 6, s.simulate();
                                    case 6:
                                        return t.a(2, s);
                                    case 7:
                                        throw new e.Errors.RestorationFailure("Automatic restore failed! You set 'restore: true' but the attempted restore did not work. Result:\n".concat(JSON.stringify(u)));
                                    case 8:
                                        return i.j.isSimulationSuccess(s.simulation) && (s.built = (0, a.X)(s.built, s.simulation).build()), t.a(2, s);
                                }
                            }, t);
                        }))), Se(this, "sign", be(de().m(function t() {
                            var r, o, i, a, u, c, l, f, p, d, h, y, g = arguments;
                            return de().w(function(t) {
                                for(;;)switch(t.n){
                                    case 0:
                                        if (i = (o = g.length > 0 && void 0 !== g[0] ? g[0] : {}).force, a = void 0 !== i && i, u = o.signTransaction, c = void 0 === u ? s.options.signTransaction : u, s.built) {
                                            t.n = 1;
                                            break;
                                        }
                                        throw new Error("Transaction has not yet been simulated");
                                    case 1:
                                        if (a || !s.isReadCall) {
                                            t.n = 2;
                                            break;
                                        }
                                        throw new e.Errors.NoSignatureNeeded("This is a read call. It requires no signature or sending. Use `force: true` to sign and send anyway.");
                                    case 2:
                                        if (c) {
                                            t.n = 3;
                                            break;
                                        }
                                        throw new e.Errors.NoSigner("You must provide a signTransaction function, either when calling `signAndSend` or when initializing your Client");
                                    case 3:
                                        if (s.options.publicKey) {
                                            t.n = 4;
                                            break;
                                        }
                                        throw new e.Errors.FakeAccount("This transaction was constructed using a default account. Provide a valid publicKey in the AssembledTransactionOptions.");
                                    case 4:
                                        if (!(l = s.needsNonInvokerSigningBy().filter(function(e) {
                                            return !e.startsWith("C");
                                        })).length) {
                                            t.n = 5;
                                            break;
                                        }
                                        throw new e.Errors.NeedsMoreSignatures("Transaction requires signatures from ".concat(l, ". ") + "See `needsNonInvokerSigningBy` for details.");
                                    case 5:
                                        return f = null !== (r = s.options.timeoutInSeconds) && void 0 !== r ? r : m.c, s.built = n.TransactionBuilder.cloneFrom(s.built, {
                                            fee: s.built.fee,
                                            timebounds: void 0,
                                            sorobanData: s.simulationData.transactionData
                                        }).setTimeout(f).build(), p = {
                                            networkPassphrase: s.options.networkPassphrase
                                        }, s.options.address && (p.address = s.options.address), void 0 !== s.options.submit && (p.submit = s.options.submit), s.options.submitUrl && (p.submitUrl = s.options.submitUrl), t.n = 6, c(s.built.toXDR(), p);
                                    case 6:
                                        d = t.v, h = d.signedTxXdr, y = d.error, s.handleWalletError(y), s.signed = n.TransactionBuilder.fromXDR(h, s.options.networkPassphrase);
                                    case 7:
                                        return t.a(2);
                                }
                            }, t);
                        }))), Se(this, "signAndSend", be(de().m(function e() {
                            var t, r, n, o, i, a, u, c, l = arguments;
                            return de().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if (r = (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}).force, n = void 0 !== r && r, o = t.signTransaction, i = void 0 === o ? s.options.signTransaction : o, a = t.watcher, s.signed) {
                                            e.n = 1;
                                            break;
                                        }
                                        return u = i || s.options.signTransaction, c = s.options.submit && u ? function(e, t) {
                                            return u(e, pe(pe({}, t), {}, {
                                                submit: !1
                                            }));
                                        } : i, e.n = 1, s.sign({
                                            force: n,
                                            signTransaction: c
                                        });
                                    case 1:
                                        return e.a(2, s.send(a));
                                }
                            }, e);
                        }))), Se(this, "needsNonInvokerSigningBy", function() {
                            var e, t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).includeAlreadySigned, r = void 0 !== t && t;
                            if (!s.built) throw new Error("Transaction has not yet been simulated");
                            if (!("operations" in s.built)) throw new Error("Unexpected Transaction type; no operations: ".concat(JSON.stringify(s.built)));
                            var o = s.built.operations[0];
                            return ye(new Set((null !== (e = o.auth) && void 0 !== e ? e : []).filter(function(e) {
                                return e.credentials().switch() === n.xdr.SorobanCredentialsType.sorobanCredentialsAddress() && (r || "scvVoid" === e.credentials().address().signature().switch().name);
                            }).map(function(e) {
                                return n.Address.fromScAddress(e.credentials().address().address()).toString();
                            })));
                        }), Se(this, "signAuthEntries", be(de().m(function t() {
                            var r, o, i, a, u, c, l, f, p, d, h, y, m, g, v, b, w, S = arguments;
                            return de().w(function(t) {
                                for(;;)switch(t.p = t.n){
                                    case 0:
                                        if (i = (o = S.length > 0 && void 0 !== S[0] ? S[0] : {}).expiration, a = void 0 === i ? be(de().m(function e() {
                                            var t;
                                            return de().w(function(e) {
                                                for(;;)switch(e.n){
                                                    case 0:
                                                        return e.n = 1, s.server.getLatestLedger();
                                                    case 1:
                                                        return t = e.v.sequence, e.a(2, t + 100);
                                                }
                                            }, e);
                                        }))() : i, u = o.signAuthEntry, c = void 0 === u ? s.options.signAuthEntry : u, l = o.address, f = void 0 === l ? s.options.publicKey : l, p = o.authorizeEntry, d = void 0 === p ? n.authorizeEntry : p, s.built) {
                                            t.n = 1;
                                            break;
                                        }
                                        throw new Error("Transaction has not yet been assembled or simulated");
                                    case 1:
                                        if (d !== n.authorizeEntry) {
                                            t.n = 4;
                                            break;
                                        }
                                        if (0 !== (h = s.needsNonInvokerSigningBy()).length) {
                                            t.n = 2;
                                            break;
                                        }
                                        throw new e.Errors.NoUnsignedNonInvokerAuthEntries("No unsigned non-invoker auth entries; maybe you already signed?");
                                    case 2:
                                        if (-1 !== h.indexOf(null != f ? f : "")) {
                                            t.n = 3;
                                            break;
                                        }
                                        throw new e.Errors.NoSignatureNeeded('No auth entries for public key "'.concat(f, '"'));
                                    case 3:
                                        if (c) {
                                            t.n = 4;
                                            break;
                                        }
                                        throw new e.Errors.NoSigner("You must provide `signAuthEntry` or a custom `authorizeEntry`");
                                    case 4:
                                        y = s.built.operations[0], m = null !== (r = y.auth) && void 0 !== r ? r : [], g = le(m.entries()), t.p = 5, b = de().m(function e() {
                                            var t, r, o, i, u, l, p, h;
                                            return de().w(function(e) {
                                                for(;;)switch(e.n){
                                                    case 0:
                                                        if (t = ce(v.value, 2), r = t[0], o = t[1], (i = n.xdr.SorobanCredentials.fromXDR(o.credentials().toXDR())).switch() === n.xdr.SorobanCredentialsType.sorobanCredentialsAddress()) {
                                                            e.n = 1;
                                                            break;
                                                        }
                                                        return e.a(2, 0);
                                                    case 1:
                                                        if (n.Address.fromScAddress(i.address().address()).toString() === f) {
                                                            e.n = 2;
                                                            break;
                                                        }
                                                        return e.a(2, 0);
                                                    case 2:
                                                        return u = null != c ? c : Promise.resolve, l = d, p = o, h = function() {
                                                            var e = be(de().m(function e(t) {
                                                                var r, n, o;
                                                                return de().w(function(e) {
                                                                    for(;;)switch(e.n){
                                                                        case 0:
                                                                            return e.n = 1, u(t.toXDR("base64"), {
                                                                                address: f
                                                                            });
                                                                        case 1:
                                                                            return r = e.v, n = r.signedAuthEntry, o = r.error, s.handleWalletError(o), e.a(2, ae.from(n, "base64"));
                                                                    }
                                                                }, e);
                                                            }));
                                                            return function(t) {
                                                                return e.apply(this, arguments);
                                                            };
                                                        }(), e.n = 3, a;
                                                    case 3:
                                                        return e.n = 4, l(p, h, e.v, s.options.networkPassphrase);
                                                    case 4:
                                                        m[r] = e.v;
                                                    case 5:
                                                        return e.a(2);
                                                }
                                            }, e);
                                        }), g.s();
                                    case 6:
                                        if ((v = g.n()).done) {
                                            t.n = 9;
                                            break;
                                        }
                                        return t.d(ue(b()), 7);
                                    case 7:
                                        if (0 !== t.v) {
                                            t.n = 8;
                                            break;
                                        }
                                        return t.a(3, 8);
                                    case 8:
                                        t.n = 6;
                                        break;
                                    case 9:
                                        t.n = 11;
                                        break;
                                    case 10:
                                        t.p = 10, w = t.v, g.e(w);
                                    case 11:
                                        return t.p = 11, g.f(), t.f(11);
                                    case 12:
                                        return t.a(2);
                                }
                            }, t, null, [
                                [
                                    5,
                                    10,
                                    11,
                                    12
                                ]
                            ]);
                        }))), this.options = t, this.options.simulate = null === (r = this.options.simulate) || void 0 === r || r;
                        var u = this.options, c = u.server, l = u.allowHttp, f = u.headers, p = u.rpcUrl;
                        this.server = null != c ? c : new o.Server(p, {
                            allowHttp: l,
                            headers: f
                        });
                    }
                    var t, r, s, u, c, l, f;
                    return t = e, r = [
                        {
                            key: "toJSON",
                            value: function() {
                                var e;
                                return JSON.stringify({
                                    method: this.options.method,
                                    tx: null === (e = this.built) || void 0 === e ? void 0 : e.toXDR(),
                                    simulationResult: {
                                        auth: this.simulationData.result.auth.map(function(e) {
                                            return e.toXDR("base64");
                                        }),
                                        retval: this.simulationData.result.retval.toXDR("base64")
                                    },
                                    simulationTransactionData: this.simulationData.transactionData.toXDR("base64")
                                });
                            }
                        },
                        {
                            key: "toXDR",
                            value: function() {
                                var e;
                                if (!this.built) throw new Error("Transaction has not yet been simulated; call `AssembledTransaction.simulate` first.");
                                return null === (e = this.built) || void 0 === e ? void 0 : e.toEnvelope().toXDR("base64");
                            }
                        },
                        {
                            key: "handleWalletError",
                            value: function(t) {
                                if (t) {
                                    var r = t.message, n = t.code, o = "".concat(r).concat(t.ext ? " (".concat(t.ext.join(", "), ")") : "");
                                    switch(n){
                                        case -1:
                                            throw new e.Errors.InternalWalletError(o);
                                        case -2:
                                            throw new e.Errors.ExternalServiceError(o);
                                        case -3:
                                            throw new e.Errors.InvalidClientRequest(o);
                                        case -4:
                                            throw new e.Errors.UserRejected(o);
                                        default:
                                            throw new Error("Unhandled error: ".concat(o));
                                    }
                                }
                            }
                        },
                        {
                            key: "simulationData",
                            get: function() {
                                var t;
                                if (this.simulationResult && this.simulationTransactionData) return {
                                    result: this.simulationResult,
                                    transactionData: this.simulationTransactionData
                                };
                                var r = this.simulation;
                                if (!r) throw new e.Errors.NotYetSimulated("Transaction has not yet been simulated");
                                if (i.j.isSimulationError(r)) throw new e.Errors.SimulationFailed('Transaction simulation failed: "'.concat(r.error, '"'));
                                if (i.j.isSimulationRestore(r)) throw new e.Errors.ExpiredState("You need to restore some contract state before you can invoke this method.\nYou can set `restore` to true in the method options in order to automatically restore the contract state when needed.");
                                return this.simulationResult = null !== (t = r.result) && void 0 !== t ? t : {
                                    auth: [],
                                    retval: n.xdr.ScVal.scvVoid()
                                }, this.simulationTransactionData = r.transactionData.build(), {
                                    result: this.simulationResult,
                                    transactionData: this.simulationTransactionData
                                };
                            }
                        },
                        {
                            key: "result",
                            get: function() {
                                try {
                                    if (!this.simulationData.result) throw new Error("No simulation result!");
                                    return this.options.parseResultXdr(this.simulationData.result.retval);
                                } catch (t) {
                                    if (!(0, y.pp)(t)) throw t;
                                    var e = this.parseError(t.toString());
                                    if (e) return e;
                                    throw t;
                                }
                            }
                        },
                        {
                            key: "parseError",
                            value: function(e) {
                                if (this.options.errorTypes) {
                                    var t = e.match(y.X8);
                                    if (t) {
                                        var r = parseInt(t[1], 10), n = this.options.errorTypes[r];
                                        if (n) return new h(n);
                                    }
                                }
                            }
                        },
                        {
                            key: "send",
                            value: (f = be(de().m(function e(t) {
                                var r;
                                return de().w(function(e) {
                                    for(;;)switch(e.n){
                                        case 0:
                                            if (this.signed) {
                                                e.n = 1;
                                                break;
                                            }
                                            throw new Error("The transaction has not yet been signed. Run `sign` first, or use `signAndSend` instead.");
                                        case 1:
                                            return e.n = 2, j.init(this, t);
                                        case 2:
                                            return r = e.v, e.a(2, r);
                                    }
                                }, e, this);
                            })), function(e) {
                                return f.apply(this, arguments);
                            })
                        },
                        {
                            key: "isReadCall",
                            get: function() {
                                var e = this.simulationData.result.auth.length, t = this.simulationData.transactionData.resources().footprint().readWrite().length;
                                return 0 === e && 0 === t;
                            }
                        },
                        {
                            key: "restoreFootprint",
                            value: (l = be(de().m(function t(r, n) {
                                var o, i, a;
                                return de().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            if (this.options.signTransaction) {
                                                t.n = 1;
                                                break;
                                            }
                                            throw new Error("For automatic restore to work you must provide a signTransaction function when initializing your Client");
                                        case 1:
                                            if (null == n) {
                                                t.n = 2;
                                                break;
                                            }
                                            a = n, t.n = 4;
                                            break;
                                        case 2:
                                            return t.n = 3, (0, y.sU)(this.options, this.server);
                                        case 3:
                                            a = t.v;
                                        case 4:
                                            return n = a, t.n = 5, e.buildFootprintRestoreTransaction(pe({}, this.options), r.transactionData, n, r.minResourceFee);
                                        case 5:
                                            return o = t.v, t.n = 6, o.signAndSend();
                                        case 6:
                                            if ((i = t.v).getTransactionResponse) {
                                                t.n = 7;
                                                break;
                                            }
                                            throw new e.Errors.RestorationFailure("The attempt at automatic restore failed. \n".concat(JSON.stringify(i)));
                                        case 7:
                                            return t.a(2, i.getTransactionResponse);
                                    }
                                }, t, this);
                            })), function(e, t) {
                                return l.apply(this, arguments);
                            })
                        }
                    ], s = [
                        {
                            key: "validateInvokeContractOp",
                            value: function(e, t) {
                                if (1 !== e.operations.length) throw new Error("Transaction envelope must contain exactly one operation.");
                                var r = e.operations[0];
                                if ("invokeHostFunction" !== r.type) throw new Error("Transaction envelope does not contain an invokeHostFunction operation.");
                                var o = r;
                                if ("hostFunctionTypeInvokeContract" !== o.func.switch().name) throw new Error("Transaction envelope does not contain an invokeContract host function.");
                                var i, a, s = o.func.value();
                                try {
                                    i = s.contractAddress(), a = s.functionName().toString("utf-8");
                                } catch (e) {
                                    throw new Error("Could not extract contract address or method name from the transaction envelope.");
                                }
                                if (!i || !a) throw new Error("Could not extract contract address or method name from the transaction envelope.");
                                var u = n.Address.fromScAddress(i).toString();
                                if (u !== t) throw new Error("Transaction envelope targets contract ".concat(u, ", but this Client is configured for ").concat(t, "."));
                                return s;
                            }
                        },
                        {
                            key: "fromJSON",
                            value: function(t, r) {
                                var o = r.tx, i = r.simulationResult, a = r.simulationTransactionData, s = new e(t);
                                s.built = n.TransactionBuilder.fromXDR(o, t.networkPassphrase);
                                var u = e.validateInvokeContractOp(s.built, t.contractId).functionName().toString("utf-8");
                                if (u !== t.method) throw new Error("Transaction envelope calls method '".concat(u, "', but the provided method is '").concat(t.method, "'."));
                                return s.simulationResult = {
                                    auth: i.auth.map(function(e) {
                                        return n.xdr.SorobanAuthorizationEntry.fromXDR(e, "base64");
                                    }),
                                    retval: n.xdr.ScVal.fromXDR(i.retval, "base64")
                                }, s.simulationTransactionData = n.xdr.SorobanTransactionData.fromXDR(a, "base64"), s;
                            }
                        },
                        {
                            key: "fromXDR",
                            value: function(t, r, o) {
                                var i = n.xdr.TransactionEnvelope.fromXDR(r, "base64"), a = n.TransactionBuilder.fromXDR(i, t.networkPassphrase), s = e.validateInvokeContractOp(a, t.contractId).functionName().toString("utf-8"), u = new e(pe(pe({}, t), {}, {
                                    method: s,
                                    parseResultXdr: function(e) {
                                        return o.funcResToNative(s, e);
                                    }
                                }));
                                return u.built = a, u;
                            }
                        },
                        {
                            key: "build",
                            value: function(t) {
                                var r, o = new n.Contract(t.contractId);
                                return e.buildWithOp(o.call.apply(o, [
                                    t.method
                                ].concat(ye(null !== (r = t.args) && void 0 !== r ? r : []))), t);
                            }
                        },
                        {
                            key: "buildWithOp",
                            value: (c = be(de().m(function t(r, o) {
                                var i, a, s, u;
                                return de().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return (s = new e(o)).originalOp = r, t.n = 1, (0, y.sU)(o, s.server);
                                        case 1:
                                            if (u = t.v, s.raw = new n.TransactionBuilder(u, {
                                                fee: null !== (i = o.fee) && void 0 !== i ? i : n.BASE_FEE,
                                                networkPassphrase: o.networkPassphrase
                                            }).setTimeout(null !== (a = o.timeoutInSeconds) && void 0 !== a ? a : m.c).addOperation(r), !o.simulate) {
                                                t.n = 2;
                                                break;
                                            }
                                            return t.n = 2, s.simulate();
                                        case 2:
                                            return t.a(2, s);
                                    }
                                }, t);
                            })), function(e, t) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "buildFootprintRestoreTransaction",
                            value: (u = be(de().m(function t(r, o, i, a) {
                                var s, u;
                                return de().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return (u = new e(r)).raw = new n.TransactionBuilder(i, {
                                                fee: a,
                                                networkPassphrase: r.networkPassphrase
                                            }).setSorobanData(o instanceof n.SorobanDataBuilder ? o.build() : o).addOperation(n.Operation.restoreFootprint({})).setTimeout(null !== (s = r.timeoutInSeconds) && void 0 !== s ? s : m.c), t.n = 1, u.simulate({
                                                restore: !1
                                            });
                                        case 1:
                                            return t.a(2, u);
                                    }
                                }, t);
                            })), function(e, t, r, n) {
                                return u.apply(this, arguments);
                            })
                        }
                    ], r && we(t.prototype, r), s && we(t, s), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), t;
                }();
                Se(Ee, "Errors", {
                    ExpiredState: X,
                    RestorationFailure: K,
                    NeedsMoreSignatures: Z,
                    NoSignatureNeeded: $,
                    NoUnsignedNonInvokerAuthEntries: Y,
                    NoSigner: Q,
                    NotYetSimulated: J,
                    FakeAccount: ee,
                    SimulationFailed: te,
                    InternalWalletError: re,
                    ExternalServiceError: ne,
                    InvalidClientRequest: oe,
                    UserRejected: ie
                });
                var Te = r(8287).Buffer;
                function Oe() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return ke(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (ke(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, ke(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, ke(f, "constructor", c), ke(c, "constructor", u), u.displayName = "GeneratorFunction", ke(c, o, "GeneratorFunction"), ke(f), ke(f, o, "Generator"), ke(f, n, function() {
                        return this;
                    }), ke(f, "toString", function() {
                        return "[object Generator]";
                    }), (Oe = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function ke(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    ke = function(e, t, r, n) {
                        function i(t, r) {
                            ke(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, ke(e, t, r, n);
                }
                function _e(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function xe(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                _e(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                _e(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                var Pe = function(e, t) {
                    var r, o;
                    return {
                        signTransaction: (o = xe(Oe().m(function r(o, i) {
                            var a;
                            return Oe().w(function(r) {
                                for(;;)if (0 === r.n) return (a = n.TransactionBuilder.fromXDR(o, (null == i ? void 0 : i.networkPassphrase) || t)).sign(e), r.a(2, {
                                    signedTxXdr: a.toXDR(),
                                    signerAddress: e.publicKey()
                                });
                            }, r);
                        })), function(e, t) {
                            return o.apply(this, arguments);
                        }),
                        signAuthEntry: (r = xe(Oe().m(function t(r) {
                            var o;
                            return Oe().w(function(t) {
                                for(;;)if (0 === t.n) return o = e.sign((0, n.hash)(Te.from(r, "base64"))).toString("base64"), t.a(2, {
                                    signedAuthEntry: o,
                                    signerAddress: e.publicKey()
                                });
                            }, t);
                        })), function(e) {
                            return r.apply(this, arguments);
                        })
                    };
                }, Re = r(8451), Ie = r(8287).Buffer;
                function Be(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function Ce(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Be(Object(r), !0).forEach(function(t) {
                            Ne(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Be(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function je(e) {
                    return je = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, je(e);
                }
                function Ue(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Le(n.key), n);
                    }
                }
                function Ne(e, t, r) {
                    return (t = Le(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function Le(e) {
                    var t = function(e, t) {
                        if ("object" != je(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != je(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == je(t) ? t : t + "";
                }
                function Fe(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, o, i, a, s = [], u = !0, c = !1;
                            try {
                                if (i = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    u = !1;
                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                            } catch (e) {
                                c = !0, o = e;
                            } finally{
                                try {
                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw o;
                                }
                            }
                            return s;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return De(e, t);
                            var r = ({}).toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? De(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function De(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function Me(e) {
                    return /^\d+$/.test(e.name().toString());
                }
                var Ve = {
                    U32: {
                        type: "integer",
                        minimum: 0,
                        maximum: 4294967295
                    },
                    I32: {
                        type: "integer",
                        minimum: -2147483648,
                        maximum: 2147483647
                    },
                    U64: {
                        type: "string",
                        pattern: "^([1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 20
                    },
                    Timepoint: {
                        type: "string",
                        pattern: "^([1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 20
                    },
                    Duration: {
                        type: "string",
                        pattern: "^([1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 20
                    },
                    I64: {
                        type: "string",
                        pattern: "^(-?[1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 21
                    },
                    U128: {
                        type: "string",
                        pattern: "^([1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 39
                    },
                    I128: {
                        type: "string",
                        pattern: "^(-?[1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 40
                    },
                    U256: {
                        type: "string",
                        pattern: "^([1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 78
                    },
                    I256: {
                        type: "string",
                        pattern: "^(-?[1-9][0-9]*|0)$",
                        minLength: 1,
                        maxLength: 79
                    },
                    Address: {
                        type: "string",
                        format: "address",
                        description: "Address can be a public key or contract id"
                    },
                    MuxedAddress: {
                        type: "string",
                        format: "address",
                        description: "Stellar public key with M prefix combining a G address and unique ID"
                    },
                    ScString: {
                        type: "string",
                        description: "ScString is a string"
                    },
                    ScSymbol: {
                        type: "string",
                        description: "ScSymbol is a string"
                    },
                    DataUrl: {
                        type: "string",
                        pattern: "^(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\\/]{3}=)?$"
                    }
                };
                function qe(e) {
                    var t;
                    switch(e.switch().value){
                        case n.xdr.ScSpecType.scSpecTypeVal().value:
                            t = "Val";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeBool().value:
                            return {
                                type: "boolean"
                            };
                        case n.xdr.ScSpecType.scSpecTypeVoid().value:
                            return {
                                type: "null"
                            };
                        case n.xdr.ScSpecType.scSpecTypeError().value:
                            t = "Error";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeU32().value:
                            t = "U32";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeI32().value:
                            t = "I32";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeU64().value:
                            t = "U64";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeI64().value:
                            t = "I64";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeTimepoint().value:
                            t = "Timepoint";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeDuration().value:
                            t = "Duration";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeU128().value:
                            t = "U128";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeI128().value:
                            t = "I128";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeU256().value:
                            t = "U256";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeI256().value:
                            t = "I256";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeBytes().value:
                            t = "DataUrl";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeString().value:
                            t = "ScString";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeSymbol().value:
                            t = "ScSymbol";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeAddress().value:
                            t = "Address";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeMuxedAddress().value:
                            t = "MuxedAddress";
                            break;
                        case n.xdr.ScSpecType.scSpecTypeOption().value:
                            return qe(e.option().valueType());
                        case n.xdr.ScSpecType.scSpecTypeResult().value:
                            return qe(e.result().okType());
                        case n.xdr.ScSpecType.scSpecTypeVec().value:
                            return {
                                type: "array",
                                items: qe(e.vec().elementType())
                            };
                        case n.xdr.ScSpecType.scSpecTypeMap().value:
                            var r = e.map();
                            return {
                                type: "array",
                                items: {
                                    type: "array",
                                    items: [
                                        qe(r.keyType()),
                                        qe(r.valueType())
                                    ],
                                    minItems: 2,
                                    maxItems: 2
                                }
                            };
                        case n.xdr.ScSpecType.scSpecTypeTuple().value:
                            var o = e.tuple(), i = o.valueTypes().length, a = i;
                            return {
                                type: "array",
                                items: o.valueTypes().map(qe),
                                minItems: i,
                                maxItems: a
                            };
                        case n.xdr.ScSpecType.scSpecTypeBytesN().value:
                            return {
                                $ref: "#/definitions/DataUrl",
                                maxLength: e.bytesN().n()
                            };
                        case n.xdr.ScSpecType.scSpecTypeUdt().value:
                            t = e.udt().name().toString();
                    }
                    return {
                        $ref: "#/definitions/".concat(t)
                    };
                }
                function Ge(e) {
                    var t = {}, r = [];
                    e.forEach(function(e) {
                        var o = e.type(), i = e.name().toString();
                        t[i] = qe(o), o.switch().value !== n.xdr.ScSpecType.scSpecTypeOption().value && r.push(i);
                    });
                    var o = {
                        properties: t
                    };
                    return r.length > 0 && (o.required = r), o;
                }
                var He = function() {
                    function e(t) {
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), Ne(this, "entries", []), Ie.isBuffer(t)) this.entries = (0, y.ns)(t);
                        else if ("string" == typeof t) this.entries = (0, y.ns)(Ie.from(t, "base64"));
                        else {
                            if (0 === t.length) throw new Error("Contract spec must have at least one entry");
                            var r = t[0];
                            this.entries = "string" == typeof r ? t.map(function(e) {
                                return n.xdr.ScSpecEntry.fromXDR(e, "base64");
                            }) : t;
                        }
                    }
                    var t, r, o;
                    return t = e, r = [
                        {
                            key: "funcs",
                            value: function() {
                                return this.entries.filter(function(e) {
                                    return e.switch().value === n.xdr.ScSpecEntryKind.scSpecEntryFunctionV0().value;
                                }).map(function(e) {
                                    return e.functionV0();
                                });
                            }
                        },
                        {
                            key: "getFunc",
                            value: function(e) {
                                var t = this.findEntry(e);
                                if (t.switch().value !== n.xdr.ScSpecEntryKind.scSpecEntryFunctionV0().value) throw new Error("".concat(e, " is not a function"));
                                return t.functionV0();
                            }
                        },
                        {
                            key: "funcArgsToScVals",
                            value: function(e, t) {
                                var r = this;
                                return this.getFunc(e).inputs().map(function(e) {
                                    return r.nativeToScVal(function(e, t) {
                                        var r = t.name().toString(), n = Object.entries(e).find(function(e) {
                                            return Fe(e, 1)[0] === r;
                                        });
                                        if (!n) throw new Error("Missing field ".concat(r));
                                        return n[1];
                                    }(t, e), e.type());
                                });
                            }
                        },
                        {
                            key: "funcResToNative",
                            value: function(e, t) {
                                var r = "string" == typeof t ? n.xdr.ScVal.fromXDR(t, "base64") : t, o = this.getFunc(e).outputs();
                                if (0 === o.length) {
                                    var i = r.switch();
                                    if (i.value !== n.xdr.ScValType.scvVoid().value) throw new Error("Expected void, got ".concat(i.name));
                                    return null;
                                }
                                if (o.length > 1) throw new Error("Multiple outputs not supported");
                                var a = o[0];
                                return a.switch().value === n.xdr.ScSpecType.scSpecTypeResult().value ? r.switch().value === n.xdr.ScValType.scvError().value ? new h({
                                    message: r.error().toXDR("base64")
                                }) : new d(this.scValToNative(r, a.result().okType())) : this.scValToNative(r, a);
                            }
                        },
                        {
                            key: "findEntry",
                            value: function(e) {
                                var t = this.entries.find(function(t) {
                                    return t.value().name().toString() === e;
                                });
                                if (!t) throw new Error("no such entry: ".concat(e));
                                return t;
                            }
                        },
                        {
                            key: "nativeToScVal",
                            value: function(e, t) {
                                var r = this, o = t.switch(), i = o.value;
                                if (o.value === n.xdr.ScSpecType.scSpecTypeUdt().value) {
                                    var a = t.udt();
                                    return this.nativeToUdt(e, a.name().toString());
                                }
                                if (i === n.xdr.ScSpecType.scSpecTypeOption().value) {
                                    var s = t.option();
                                    return null == e ? n.xdr.ScVal.scvVoid() : this.nativeToScVal(e, s.valueType());
                                }
                                switch(je(e)){
                                    case "object":
                                        var u, c, l;
                                        if (null === e) {
                                            if (i === n.xdr.ScSpecType.scSpecTypeVoid().value) return n.xdr.ScVal.scvVoid();
                                            throw new TypeError("Type ".concat(t, " was not void, but value was null"));
                                        }
                                        if (e instanceof n.xdr.ScVal) return e;
                                        if (e instanceof n.Address) {
                                            if (t.switch().value !== n.xdr.ScSpecType.scSpecTypeAddress().value) throw new TypeError("Type ".concat(t, " was not address, but value was Address"));
                                            return e.toScVal();
                                        }
                                        if (e instanceof n.Contract) {
                                            if (t.switch().value !== n.xdr.ScSpecType.scSpecTypeAddress().value) throw new TypeError("Type ".concat(t, " was not address, but value was Address"));
                                            return e.address().toScVal();
                                        }
                                        if (e instanceof Uint8Array || Ie.isBuffer(e)) {
                                            var f = Uint8Array.from(e);
                                            switch(i){
                                                case n.xdr.ScSpecType.scSpecTypeBytesN().value:
                                                    var p = t.bytesN();
                                                    if (f.length !== p.n()) throw new TypeError("expected ".concat(p.n(), " bytes, but got ").concat(f.length));
                                                    return n.xdr.ScVal.scvBytes(f);
                                                case n.xdr.ScSpecType.scSpecTypeBytes().value:
                                                    return n.xdr.ScVal.scvBytes(f);
                                                default:
                                                    throw new TypeError("invalid type (".concat(t, ") specified for Bytes and BytesN"));
                                            }
                                        }
                                        if (Array.isArray(e)) switch(i){
                                            case n.xdr.ScSpecType.scSpecTypeVec().value:
                                                var d = t.vec().elementType();
                                                return n.xdr.ScVal.scvVec(e.map(function(e) {
                                                    return r.nativeToScVal(e, d);
                                                }));
                                            case n.xdr.ScSpecType.scSpecTypeTuple().value:
                                                var h = t.tuple().valueTypes();
                                                if (e.length !== h.length) throw new TypeError("Tuple expects ".concat(h.length, " values, but ").concat(e.length, " were provided"));
                                                return n.xdr.ScVal.scvVec(e.map(function(e, t) {
                                                    return r.nativeToScVal(e, h[t]);
                                                }));
                                            case n.xdr.ScSpecType.scSpecTypeMap().value:
                                                var y = t.map(), m = y.keyType(), g = y.valueType();
                                                return n.xdr.ScVal.scvMap(e.map(function(e) {
                                                    var t = r.nativeToScVal(e[0], m), o = r.nativeToScVal(e[1], g);
                                                    return new n.xdr.ScMapEntry({
                                                        key: t,
                                                        val: o
                                                    });
                                                }));
                                            default:
                                                throw new TypeError("Type ".concat(t, " was not vec, but value was Array"));
                                        }
                                        if (e.constructor === Map) {
                                            if (i !== n.xdr.ScSpecType.scSpecTypeMap().value) throw new TypeError("Type ".concat(t, " was not map, but value was Map"));
                                            for(var v = t.map(), b = [], w = e.entries(), S = w.next(); !S.done;){
                                                var A = Fe(S.value, 2), E = A[0], T = A[1], O = this.nativeToScVal(E, v.keyType()), k = this.nativeToScVal(T, v.valueType());
                                                b.push(new n.xdr.ScMapEntry({
                                                    key: O,
                                                    val: k
                                                })), S = w.next();
                                            }
                                            return n.xdr.ScVal.scvMap(b);
                                        }
                                        if ("Object" !== (null !== (u = null === (c = e.constructor) || void 0 === c ? void 0 : c.name) && void 0 !== u ? u : "")) throw new TypeError("cannot interpret ".concat(null === (l = e.constructor) || void 0 === l ? void 0 : l.name, " value as ScVal (").concat(JSON.stringify(e), ")"));
                                        throw new TypeError("Received object ".concat(e, "  did not match the provided type ").concat(t));
                                    case "number":
                                    case "bigint":
                                        switch(i){
                                            case n.xdr.ScSpecType.scSpecTypeU32().value:
                                                if (BigInt(e) < BigInt(n.xdr.Uint32.MIN_VALUE) || BigInt(e) > BigInt(n.xdr.Uint32.MAX_VALUE)) throw new RangeError("Value ".concat(e, " is out of range for U32"));
                                                return n.xdr.ScVal.scvU32(Number(e));
                                            case n.xdr.ScSpecType.scSpecTypeI32().value:
                                                if (BigInt(e) < -BigInt(n.xdr.Int32.MIN_VALUE) || BigInt(e) > BigInt(n.xdr.Int32.MAX_VALUE)) throw new RangeError("Value ".concat(e, " is out of range for I32"));
                                                return n.xdr.ScVal.scvI32(Number(e));
                                            case n.xdr.ScSpecType.scSpecTypeU64().value:
                                            case n.xdr.ScSpecType.scSpecTypeI64().value:
                                            case n.xdr.ScSpecType.scSpecTypeU128().value:
                                            case n.xdr.ScSpecType.scSpecTypeI128().value:
                                            case n.xdr.ScSpecType.scSpecTypeU256().value:
                                            case n.xdr.ScSpecType.scSpecTypeI256().value:
                                            case n.xdr.ScSpecType.scSpecTypeTimepoint().value:
                                            case n.xdr.ScSpecType.scSpecTypeDuration().value:
                                                var _ = o.name.substring(10).toLowerCase();
                                                return new n.XdrLargeInt(_, e).toScVal();
                                            default:
                                                throw new TypeError("invalid type (".concat(t, ") specified for integer"));
                                        }
                                    case "string":
                                        return function(e, t) {
                                            switch(t.value){
                                                case n.xdr.ScSpecType.scSpecTypeString().value:
                                                    return n.xdr.ScVal.scvString(e);
                                                case n.xdr.ScSpecType.scSpecTypeSymbol().value:
                                                    return n.xdr.ScVal.scvSymbol(e);
                                                case n.xdr.ScSpecType.scSpecTypeAddress().value:
                                                case n.xdr.ScSpecType.scSpecTypeMuxedAddress().value:
                                                    return n.Address.fromString(e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeU64().value:
                                                    return new n.XdrLargeInt("u64", e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeI64().value:
                                                    return new n.XdrLargeInt("i64", e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeU128().value:
                                                    return new n.XdrLargeInt("u128", e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeI128().value:
                                                    return new n.XdrLargeInt("i128", e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeU256().value:
                                                    return new n.XdrLargeInt("u256", e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeI256().value:
                                                    return new n.XdrLargeInt("i256", e).toScVal();
                                                case n.xdr.ScSpecType.scSpecTypeBytes().value:
                                                case n.xdr.ScSpecType.scSpecTypeBytesN().value:
                                                    return n.xdr.ScVal.scvBytes(Ie.from(e, "base64"));
                                                case n.xdr.ScSpecType.scSpecTypeTimepoint().value:
                                                    return n.xdr.ScVal.scvTimepoint(new n.xdr.Uint64(e));
                                                case n.xdr.ScSpecType.scSpecTypeDuration().value:
                                                    return n.xdr.ScVal.scvDuration(new n.xdr.Uint64(e));
                                                default:
                                                    throw new TypeError("invalid type ".concat(t.name, " specified for string value"));
                                            }
                                        }(e, o);
                                    case "boolean":
                                        if (i !== n.xdr.ScSpecType.scSpecTypeBool().value) throw TypeError("Type ".concat(t, " was not bool, but value was bool"));
                                        return n.xdr.ScVal.scvBool(e);
                                    case "undefined":
                                        if (!t) return n.xdr.ScVal.scvVoid();
                                        switch(i){
                                            case n.xdr.ScSpecType.scSpecTypeVoid().value:
                                            case n.xdr.ScSpecType.scSpecTypeOption().value:
                                                return n.xdr.ScVal.scvVoid();
                                            default:
                                                throw new TypeError("Type ".concat(t, " was not void, but value was undefined"));
                                        }
                                    case "function":
                                        return this.nativeToScVal(e(), t);
                                    default:
                                        throw new TypeError("failed to convert typeof ".concat(je(e), " (").concat(e, ")"));
                                }
                            }
                        },
                        {
                            key: "nativeToUdt",
                            value: function(e, t) {
                                var r = this.findEntry(t);
                                switch(r.switch()){
                                    case n.xdr.ScSpecEntryKind.scSpecEntryUdtEnumV0():
                                        if ("number" != typeof e) throw new TypeError("expected number for enum ".concat(t, ", but got ").concat(je(e)));
                                        return this.nativeToEnum(e, r.udtEnumV0());
                                    case n.xdr.ScSpecEntryKind.scSpecEntryUdtStructV0():
                                        return this.nativeToStruct(e, r.udtStructV0());
                                    case n.xdr.ScSpecEntryKind.scSpecEntryUdtUnionV0():
                                        return this.nativeToUnion(e, r.udtUnionV0());
                                    default:
                                        throw new Error("failed to parse udt ".concat(t));
                                }
                            }
                        },
                        {
                            key: "nativeToUnion",
                            value: function(e, t) {
                                var r = this, o = e.tag, i = t.cases().find(function(e) {
                                    return e.value().name().toString() === o;
                                });
                                if (!i) throw new TypeError("no such enum entry: ".concat(o, " in ").concat(t));
                                var a = n.xdr.ScVal.scvSymbol(o);
                                switch(i.switch()){
                                    case n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseVoidV0():
                                        return n.xdr.ScVal.scvVec([
                                            a
                                        ]);
                                    case n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseTupleV0():
                                        var s = i.tupleCase().type();
                                        if (Array.isArray(e.values)) {
                                            if (e.values.length !== s.length) throw new TypeError("union ".concat(t, " expects ").concat(s.length, " values, but got ").concat(e.values.length));
                                            var u = e.values.map(function(e, t) {
                                                return r.nativeToScVal(e, s[t]);
                                            });
                                            return u.unshift(a), n.xdr.ScVal.scvVec(u);
                                        }
                                        throw new Error("failed to parse union case ".concat(i, " with ").concat(e));
                                    default:
                                        throw new Error("failed to parse union ".concat(t, " with ").concat(e));
                                }
                            }
                        },
                        {
                            key: "nativeToStruct",
                            value: function(e, t) {
                                var r = this, o = t.fields();
                                if (o.some(Me)) {
                                    if (!o.every(Me)) throw new Error("mixed numeric and non-numeric field names are not allowed");
                                    return n.xdr.ScVal.scvVec(o.map(function(t, n) {
                                        return r.nativeToScVal(e[n], o[n].type());
                                    }));
                                }
                                return n.xdr.ScVal.scvMap(o.map(function(t) {
                                    var o = t.name().toString();
                                    return new n.xdr.ScMapEntry({
                                        key: r.nativeToScVal(o, n.xdr.ScSpecTypeDef.scSpecTypeSymbol()),
                                        val: r.nativeToScVal(e[o], t.type())
                                    });
                                }));
                            }
                        },
                        {
                            key: "nativeToEnum",
                            value: function(e, t) {
                                if (t.cases().some(function(t) {
                                    return t.value() === e;
                                })) return n.xdr.ScVal.scvU32(e);
                                throw new TypeError("no such enum entry: ".concat(e, " in ").concat(t));
                            }
                        },
                        {
                            key: "scValStrToNative",
                            value: function(e, t) {
                                return this.scValToNative(n.xdr.ScVal.fromXDR(e, "base64"), t);
                            }
                        },
                        {
                            key: "scValToNative",
                            value: function(e, t) {
                                var r = this, o = t.switch(), i = o.value;
                                if (i === n.xdr.ScSpecType.scSpecTypeOption().value) return e.switch().value === n.xdr.ScValType.scvVoid().value ? null : this.scValToNative(e, t.option().valueType());
                                if (i === n.xdr.ScSpecType.scSpecTypeUdt().value) return this.scValUdtToNative(e, t.udt());
                                switch(e.switch().value){
                                    case n.xdr.ScValType.scvVoid().value:
                                        return null;
                                    case n.xdr.ScValType.scvU64().value:
                                    case n.xdr.ScValType.scvI64().value:
                                    case n.xdr.ScValType.scvTimepoint().value:
                                    case n.xdr.ScValType.scvDuration().value:
                                    case n.xdr.ScValType.scvU128().value:
                                    case n.xdr.ScValType.scvI128().value:
                                    case n.xdr.ScValType.scvU256().value:
                                    case n.xdr.ScValType.scvI256().value:
                                        return (0, n.scValToBigInt)(e);
                                    case n.xdr.ScValType.scvVec().value:
                                        if (i === n.xdr.ScSpecType.scSpecTypeVec().value) {
                                            var a, s = t.vec();
                                            return (null !== (a = e.vec()) && void 0 !== a ? a : []).map(function(e) {
                                                return r.scValToNative(e, s.elementType());
                                            });
                                        }
                                        if (i === n.xdr.ScSpecType.scSpecTypeTuple().value) {
                                            var u, c = t.tuple().valueTypes();
                                            return (null !== (u = e.vec()) && void 0 !== u ? u : []).map(function(e, t) {
                                                return r.scValToNative(e, c[t]);
                                            });
                                        }
                                        throw new TypeError("Type ".concat(t, " was not vec, but ").concat(e, " is"));
                                    case n.xdr.ScValType.scvAddress().value:
                                        return n.Address.fromScVal(e).toString();
                                    case n.xdr.ScValType.scvMap().value:
                                        var l, f = null !== (l = e.map()) && void 0 !== l ? l : [];
                                        if (i === n.xdr.ScSpecType.scSpecTypeMap().value) {
                                            var p = t.map(), d = p.keyType(), h = p.valueType();
                                            return f.map(function(e) {
                                                return [
                                                    r.scValToNative(e.key(), d),
                                                    r.scValToNative(e.val(), h)
                                                ];
                                            });
                                        }
                                        throw new TypeError("ScSpecType ".concat(o.name, " was not map, but ").concat(JSON.stringify(e, null, 2), " is"));
                                    case n.xdr.ScValType.scvBool().value:
                                    case n.xdr.ScValType.scvU32().value:
                                    case n.xdr.ScValType.scvI32().value:
                                    case n.xdr.ScValType.scvBytes().value:
                                        return e.value();
                                    case n.xdr.ScValType.scvString().value:
                                    case n.xdr.ScValType.scvSymbol().value:
                                        var y;
                                        if (i !== n.xdr.ScSpecType.scSpecTypeString().value && i !== n.xdr.ScSpecType.scSpecTypeSymbol().value) throw new Error("ScSpecType ".concat(o.name, " was not string or symbol, but ").concat(JSON.stringify(e, null, 2), " is"));
                                        return null === (y = e.value()) || void 0 === y ? void 0 : y.toString();
                                    default:
                                        throw new TypeError("failed to convert ".concat(JSON.stringify(e, null, 2), " to native type from type ").concat(o.name));
                                }
                            }
                        },
                        {
                            key: "scValUdtToNative",
                            value: function(e, t) {
                                var r = this.findEntry(t.name().toString());
                                switch(r.switch()){
                                    case n.xdr.ScSpecEntryKind.scSpecEntryUdtEnumV0():
                                        return this.enumToNative(e);
                                    case n.xdr.ScSpecEntryKind.scSpecEntryUdtStructV0():
                                        return this.structToNative(e, r.udtStructV0());
                                    case n.xdr.ScSpecEntryKind.scSpecEntryUdtUnionV0():
                                        return this.unionToNative(e, r.udtUnionV0());
                                    default:
                                        throw new Error("failed to parse udt ".concat(t.name().toString(), ": ").concat(r));
                                }
                            }
                        },
                        {
                            key: "unionToNative",
                            value: function(e, t) {
                                var r = this, o = e.vec();
                                if (!o) throw new Error("".concat(JSON.stringify(e, null, 2), " is not a vec"));
                                if (0 === o.length && 0 !== t.cases.length) throw new Error("".concat(e, " has length 0, but the there are at least one case in the union"));
                                var i = o[0].sym().toString();
                                if (o[0].switch().value !== n.xdr.ScValType.scvSymbol().value) throw new Error("".concat(o[0], " is not a symbol"));
                                var a = t.cases().find(function(e) {
                                    return function(t) {
                                        switch(t.switch().value){
                                            case n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseTupleV0().value:
                                                return t.tupleCase().name().toString() === e;
                                            case n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseVoidV0().value:
                                                return t.voidCase().name().toString() === e;
                                            default:
                                                return !1;
                                        }
                                    };
                                }(i));
                                if (!a) throw new Error("failed to find entry ".concat(i, " in union ").concat(t.name().toString()));
                                var s = {
                                    tag: i
                                };
                                if (a.switch().value === n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseTupleV0().value) {
                                    var u = a.tupleCase().type().map(function(e, t) {
                                        return r.scValToNative(o[t + 1], e);
                                    });
                                    s.values = u;
                                }
                                return s;
                            }
                        },
                        {
                            key: "structToNative",
                            value: function(e, t) {
                                var r, n, o = this, i = {}, a = t.fields();
                                return a.some(Me) ? null === (n = e.vec()) || void 0 === n ? void 0 : n.map(function(e, t) {
                                    return o.scValToNative(e, a[t].type());
                                }) : (null === (r = e.map()) || void 0 === r || r.forEach(function(e, t) {
                                    var r = a[t];
                                    i[r.name().toString()] = o.scValToNative(e.val(), r.type());
                                }), i);
                            }
                        },
                        {
                            key: "enumToNative",
                            value: function(e) {
                                if (e.switch().value !== n.xdr.ScValType.scvU32().value) throw new Error("Enum must have a u32 value");
                                return e.u32();
                            }
                        },
                        {
                            key: "errorCases",
                            value: function() {
                                return this.entries.filter(function(e) {
                                    return e.switch().value === n.xdr.ScSpecEntryKind.scSpecEntryUdtErrorEnumV0().value;
                                }).flatMap(function(e) {
                                    return e.value().cases();
                                });
                            }
                        },
                        {
                            key: "jsonSchema",
                            value: function(e) {
                                var t = {};
                                this.entries.forEach(function(e) {
                                    switch(e.switch().value){
                                        case n.xdr.ScSpecEntryKind.scSpecEntryUdtEnumV0().value:
                                            var r = e.udtEnumV0();
                                            t[r.name().toString()] = function(e) {
                                                var t = e.doc().toString(), r = e.cases(), n = [];
                                                r.forEach(function(e) {
                                                    var t = e.name().toString(), r = e.doc().toString();
                                                    n.push({
                                                        description: r,
                                                        title: t,
                                                        enum: [
                                                            e.value()
                                                        ],
                                                        type: "number"
                                                    });
                                                });
                                                var o = {
                                                    oneOf: n
                                                };
                                                return t.length > 0 && (o.description = t), o;
                                            }(r);
                                            break;
                                        case n.xdr.ScSpecEntryKind.scSpecEntryUdtStructV0().value:
                                            var o = e.udtStructV0();
                                            t[o.name().toString()] = function(e) {
                                                var t = e.fields();
                                                if (t.some(Me)) {
                                                    if (!t.every(Me)) throw new Error("mixed numeric and non-numeric field names are not allowed");
                                                    return {
                                                        type: "array",
                                                        items: t.map(function(e, r) {
                                                            return qe(t[r].type());
                                                        }),
                                                        minItems: t.length,
                                                        maxItems: t.length
                                                    };
                                                }
                                                var r = e.doc().toString(), n = Ge(t);
                                                return {
                                                    description: r,
                                                    properties: n.properties,
                                                    required: n.required,
                                                    additionalProperties: !1,
                                                    type: "object"
                                                };
                                            }(o);
                                            break;
                                        case n.xdr.ScSpecEntryKind.scSpecEntryUdtUnionV0().value:
                                            var i = e.udtUnionV0();
                                            t[i.name().toString()] = function(e) {
                                                var t = e.doc().toString(), r = e.cases(), o = [];
                                                r.forEach(function(e) {
                                                    switch(e.switch().value){
                                                        case n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseVoidV0().value:
                                                            var t = e.voidCase().name().toString();
                                                            o.push({
                                                                type: "object",
                                                                title: t,
                                                                properties: {
                                                                    tag: t
                                                                },
                                                                additionalProperties: !1,
                                                                required: [
                                                                    "tag"
                                                                ]
                                                            });
                                                            break;
                                                        case n.xdr.ScSpecUdtUnionCaseV0Kind.scSpecUdtUnionCaseTupleV0().value:
                                                            var r = e.tupleCase(), i = r.name().toString();
                                                            o.push({
                                                                type: "object",
                                                                title: i,
                                                                properties: {
                                                                    tag: i,
                                                                    values: {
                                                                        type: "array",
                                                                        items: r.type().map(qe)
                                                                    }
                                                                },
                                                                required: [
                                                                    "tag",
                                                                    "values"
                                                                ],
                                                                additionalProperties: !1
                                                            });
                                                    }
                                                });
                                                var i = {
                                                    oneOf: o
                                                };
                                                return t.length > 0 && (i.description = t), i;
                                            }(i);
                                            break;
                                        case n.xdr.ScSpecEntryKind.scSpecEntryFunctionV0().value:
                                            var a = e.functionV0(), s = a.name().toString(), u = function(e) {
                                                var t = Ge(e.inputs()), r = t.properties, o = t.required, i = {
                                                    additionalProperties: !1,
                                                    properties: r,
                                                    type: "object"
                                                };
                                                (null == o ? void 0 : o.length) > 0 && (i.required = o);
                                                var a = {
                                                    properties: {
                                                        args: i
                                                    }
                                                }, s = e.outputs(), u = s.length > 0 ? qe(s[0]) : qe(n.xdr.ScSpecTypeDef.scSpecTypeVoid()), c = e.doc().toString();
                                                return c.length > 0 && (a.description = c), a.additionalProperties = !1, u.additionalProperties = !1, {
                                                    input: a,
                                                    output: u
                                                };
                                            }(a), c = u.input;
                                            t[s] = c;
                                        case n.xdr.ScSpecEntryKind.scSpecEntryUdtErrorEnumV0().value:
                                    }
                                });
                                var r = {
                                    $schema: "http://json-schema.org/draft-07/schema#",
                                    definitions: Ce(Ce({}, Ve), t)
                                };
                                return e && (r.$ref = "#/definitions/".concat(e)), r;
                            }
                        }
                    ], o = [
                        {
                            key: "fromWasm",
                            value: function(t) {
                                return new e((0, Re.U)(t));
                            }
                        }
                    ], r && Ue(t.prototype, r), o && Ue(t, o), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), t;
                }(), ze = r(4366), We = r(8287).Buffer;
                function Xe(e) {
                    return Xe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Xe(e);
                }
                var Ke = [
                    "method"
                ], Ze = [
                    "wasmHash",
                    "salt",
                    "format",
                    "fee",
                    "timeoutInSeconds",
                    "simulate"
                ];
                function $e() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return Ye(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (Ye(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, Ye(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, Ye(f, "constructor", c), Ye(c, "constructor", u), u.displayName = "GeneratorFunction", Ye(c, o, "GeneratorFunction"), Ye(f), Ye(f, o, "Generator"), Ye(f, n, function() {
                        return this;
                    }), Ye(f, "toString", function() {
                        return "[object Generator]";
                    }), ($e = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function Ye(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    Ye = function(e, t, r, n) {
                        function i(t, r) {
                            Ye(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, Ye(e, t, r, n);
                }
                function Qe(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function Je(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Qe(Object(r), !0).forEach(function(t) {
                            rt(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qe(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function et(e, t) {
                    if (null == e) return {};
                    var r, n, o = function(e, t) {
                        if (null == e) return {};
                        var r = {};
                        for(var n in e)if (({}).hasOwnProperty.call(e, n)) {
                            if (-1 !== t.indexOf(n)) continue;
                            r[n] = e[n];
                        }
                        return r;
                    }(e, t);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e);
                        for(n = 0; n < i.length; n++)r = i[n], -1 === t.indexOf(r) && ({}).propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
                    }
                    return o;
                }
                function tt(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nt(n.key), n);
                    }
                }
                function rt(e, t, r) {
                    return (t = nt(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function nt(e) {
                    var t = function(e, t) {
                        if ("object" != Xe(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Xe(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Xe(t) ? t : t + "";
                }
                function ot(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function it(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                ot(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                ot(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                var at = "__constructor";
                function st(e, t) {
                    return ut.apply(this, arguments);
                }
                function ut() {
                    return ut = it($e().m(function e(t, r) {
                        var n, i, a, s, u, c, l, f = arguments;
                        return $e().w(function(e) {
                            for(;;)switch(e.n){
                                case 0:
                                    if (n = f.length > 2 && void 0 !== f[2] ? f[2] : "hex", r && r.rpcUrl) {
                                        e.n = 1;
                                        break;
                                    }
                                    throw new TypeError("options must contain rpcUrl");
                                case 1:
                                    return i = r.rpcUrl, a = r.allowHttp, s = r.headers, u = {
                                        allowHttp: a,
                                        headers: s
                                    }, c = new o.Server(i, u), e.n = 2, c.getContractWasmByHash(t, n);
                                case 2:
                                    return l = e.v, e.a(2, He.fromWasm(l));
                            }
                        }, e);
                    })), ut.apply(this, arguments);
                }
                var ct = function() {
                    function e(t, r) {
                        var n = this;
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), rt(this, "txFromJSON", function(e) {
                            var t = JSON.parse(e), r = t.method, o = et(t, Ke);
                            return Ee.fromJSON(Je(Je({}, n.options), {}, {
                                method: r,
                                parseResultXdr: function(e) {
                                    return n.spec.funcResToNative(r, e);
                                }
                            }), o);
                        }), rt(this, "txFromXDR", function(e) {
                            return Ee.fromXDR(n.options, e, n.spec);
                        }), this.spec = t, this.options = r, void 0 === r.server) {
                            var i = r.allowHttp, a = r.headers;
                            r.server = new o.Server(r.rpcUrl, {
                                allowHttp: i,
                                headers: a
                            });
                        }
                        this.spec.funcs().forEach(function(e) {
                            var o = e.name().toString();
                            if (o !== at) {
                                var i = function(e, n) {
                                    return Ee.build(Je(Je(Je({
                                        method: o,
                                        args: e && t.funcArgsToScVals(o, e)
                                    }, r), n), {}, {
                                        errorTypes: t.errorCases().reduce(function(e, t) {
                                            return Je(Je({}, e), {}, rt({}, t.value(), {
                                                message: t.doc().toString()
                                            }));
                                        }, {}),
                                        parseResultXdr: function(e) {
                                            return t.funcResToNative(o, e);
                                        }
                                    }));
                                };
                                n[(0, ze.ff)(o)] = 0 === t.getFunc(o).inputs().length ? function(e) {
                                    return i(void 0, e);
                                } : i;
                            }
                        });
                    }
                    var t, r, i, a, s, u, c;
                    return t = e, r = null, i = [
                        {
                            key: "deploy",
                            value: (c = it($e().m(function t(r, o) {
                                var i, a, s, u, c, l, f, p, d;
                                return $e().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return i = o.wasmHash, a = o.salt, s = o.format, u = o.fee, c = o.timeoutInSeconds, l = o.simulate, f = et(o, Ze), t.n = 1, st(i, f, s);
                                        case 1:
                                            return p = t.v, d = n.Operation.createCustomContract({
                                                address: new n.Address(o.address || o.publicKey),
                                                wasmHash: "string" == typeof i ? We.from(i, null != s ? s : "hex") : i,
                                                salt: a,
                                                constructorArgs: r ? p.funcArgsToScVals(at, r) : []
                                            }), t.a(2, Ee.buildWithOp(d, Je(Je({
                                                fee: u,
                                                timeoutInSeconds: c,
                                                simulate: l
                                            }, f), {}, {
                                                contractId: "ignored",
                                                method: at,
                                                parseResultXdr: function(t) {
                                                    return new e(p, Je(Je({}, f), {}, {
                                                        contractId: n.Address.fromScVal(t).toString()
                                                    }));
                                                }
                                            })));
                                    }
                                }, t);
                            })), function(e, t) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "fromWasmHash",
                            value: (u = it($e().m(function t(r, n) {
                                var i, a, s, u, c, l, f, p = arguments;
                                return $e().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            if (a = p.length > 2 && void 0 !== p[2] ? p[2] : "hex", n && n.rpcUrl) {
                                                t.n = 1;
                                                break;
                                            }
                                            throw new TypeError("options must contain rpcUrl");
                                        case 1:
                                            return s = n.rpcUrl, u = n.allowHttp, c = n.headers, l = null !== (i = n.server) && void 0 !== i ? i : new o.Server(s, {
                                                allowHttp: u,
                                                headers: c
                                            }), t.n = 2, l.getContractWasmByHash(r, a);
                                        case 2:
                                            return f = t.v, t.a(2, e.fromWasm(f, n));
                                    }
                                }, t);
                            })), function(e, t) {
                                return u.apply(this, arguments);
                            })
                        },
                        {
                            key: "fromWasm",
                            value: (s = it($e().m(function t(r, n) {
                                var o;
                                return $e().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return t.n = 1, He.fromWasm(r);
                                        case 1:
                                            return o = t.v, t.a(2, new e(o, n));
                                    }
                                }, t);
                            })), function(e, t) {
                                return s.apply(this, arguments);
                            })
                        },
                        {
                            key: "from",
                            value: (a = it($e().m(function t(r) {
                                var n, i, a, s, u, c;
                                return $e().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            if (r && r.rpcUrl && r.contractId) {
                                                t.n = 1;
                                                break;
                                            }
                                            throw new TypeError("options must contain rpcUrl and contractId");
                                        case 1:
                                            return n = r.rpcUrl, i = r.contractId, a = r.allowHttp, s = r.headers, u = new o.Server(n, {
                                                allowHttp: a,
                                                headers: s
                                            }), t.n = 2, u.getContractWasmByContractId(i);
                                        case 2:
                                            return c = t.v, t.a(2, e.fromWasm(c, r));
                                    }
                                }, t);
                            })), function(e) {
                                return a.apply(this, arguments);
                            })
                        }
                    ], r && tt(t.prototype, r), i && tt(t, i), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), t;
                }();
            },
            9138 (e, t, r) {
                "use strict";
                r.d(t, {
                    c: ()=>n,
                    u: ()=>o
                });
                r(8950);
                var n = 300, o = "GAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWHF";
            },
            8302 (e, t, r) {
                "use strict";
                r.d(t, {
                    X8: ()=>h,
                    cF: ()=>p,
                    ns: ()=>g,
                    ph: ()=>m,
                    pp: ()=>y,
                    sU: ()=>v
                });
                var n = r(8950), o = r(9138);
                function i() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function s(r, n, o, i) {
                        var s = n && n.prototype instanceof c ? n : c, l = Object.create(s.prototype);
                        return a(l, "_invoke", function(r, n, o) {
                            var i, a, s, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, a = 0, s = e, p.n = r, u;
                                }
                            };
                            function d(r, n) {
                                for(a = r, s = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (s = i[(a = i[4]) ? 5 : (a = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (a = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, a = 0));
                                }
                                if (o || r > 1) return u;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), a = l, s = h; (t = a < 2 ? e : s) || !f;){
                                    i || (a ? a < 3 ? (a > 1 && (p.n = -1), d(a, s)) : p.n = s : p.v = s);
                                    try {
                                        if (c = 2, i) {
                                            if (a || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, s))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                s = t.value, a < 2 && (a = 0);
                                            } else 1 === a && (t = i.return) && t.call(i), a < 2 && (s = TypeError("The iterator does not provide a '" + o + "' method"), a = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? s : r.call(n, p)) !== u) break;
                                    } catch (t) {
                                        i = e, a = 1, s = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), l;
                    }
                    var u = {};
                    function c() {}
                    function l() {}
                    function f() {}
                    t = Object.getPrototypeOf;
                    var p = [][n] ? t(t([][n]())) : (a(t = {}, n, function() {
                        return this;
                    }), t), d = f.prototype = c.prototype = Object.create(p);
                    function h(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, a(e, o, "GeneratorFunction")), e.prototype = Object.create(d), e;
                    }
                    return l.prototype = f, a(d, "constructor", f), a(f, "constructor", l), l.displayName = "GeneratorFunction", a(f, o, "GeneratorFunction"), a(d), a(d, o, "Generator"), a(d, n, function() {
                        return this;
                    }), a(d, "toString", function() {
                        return "[object Generator]";
                    }), (i = function() {
                        return {
                            w: s,
                            m: h
                        };
                    })();
                }
                function a(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    a = function(e, t, r, n) {
                        function i(t, r) {
                            a(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, a(e, t, r, n);
                }
                function s(e) {
                    return function(e) {
                        if (Array.isArray(e)) return u(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return u(e, t);
                            var r = ({}).toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function u(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function c(e) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, c(e);
                }
                function l(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function f(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                l(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                l(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function p(e, t, r) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = f(i().m(function e(t, r, n) {
                        var o, a, s, u, c, l, f, p, d, h = arguments;
                        return i().w(function(e) {
                            for(;;)switch(e.n){
                                case 0:
                                    return o = h.length > 3 && void 0 !== h[3] ? h[3] : 1.5, a = h.length > 4 && void 0 !== h[4] && h[4], u = 0, p = s = [], e.n = 1, t();
                                case 1:
                                    if (p.push.call(p, e.v), r(s[s.length - 1])) {
                                        e.n = 2;
                                        break;
                                    }
                                    return e.a(2, s);
                                case 2:
                                    c = new Date(Date.now() + 1e3 * n).valueOf(), f = l = 1e3;
                                case 3:
                                    if (!(Date.now() < c && r(s[s.length - 1]))) {
                                        e.n = 6;
                                        break;
                                    }
                                    return u += 1, a && console.info("Waiting ".concat(l, "ms before trying again (bringing the total wait time to ").concat(f, "ms so far, of total ").concat(1e3 * n, "ms)")), e.n = 4, new Promise(function(e) {
                                        return setTimeout(e, l);
                                    });
                                case 4:
                                    return l *= o, new Date(Date.now() + l).valueOf() > c && (l = c - Date.now(), a && console.info("was gonna wait too long; new waitTime: ".concat(l, "ms"))), f = l + f, d = s, e.n = 5, t(s[s.length - 1]);
                                case 5:
                                    d.push.call(d, e.v), a && r(s[s.length - 1]) && console.info("".concat(u, ". Called ").concat(t, "; ").concat(s.length, " prev attempts. Most recent: ").concat(JSON.stringify(s[s.length - 1], null, 2))), e.n = 3;
                                    break;
                                case 6:
                                    return e.a(2, s);
                            }
                        }, e);
                    })), d.apply(this, arguments);
                }
                var h = /Error\(Contract, #(\d+)\)/;
                function y(e) {
                    return "object" === c(e) && null !== e && "toString" in e;
                }
                function m(e) {
                    var t = new Map, r = e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength), n = 0, o = function(t) {
                        if (n + t > e.byteLength) throw new Error("Buffer overflow");
                        var o = new Uint8Array(r, n, t);
                        return n += t, o;
                    };
                    function i() {
                        for(var e = 0, t = 0;;){
                            var r = o(1)[0];
                            if (e |= (127 & r) << t, !(128 & r)) break;
                            if ((t += 7) >= 32) throw new Error("Invalid WASM value");
                        }
                        return e >>> 0;
                    }
                    if ("0,97,115,109" !== s(o(4)).join()) throw new Error("Invalid WASM magic");
                    if ("1,0,0,0" !== s(o(4)).join()) throw new Error("Invalid WASM version");
                    for(; n < e.byteLength;){
                        var a = o(1)[0], u = i(), c = n;
                        if (0 === a) {
                            var l = i();
                            if (l > 0 && n + l <= c + u) {
                                var f = o(l), p = o(u - (n - c));
                                try {
                                    var d = new TextDecoder("utf-8", {
                                        fatal: !0
                                    }).decode(f);
                                    p.length > 0 && t.set(d, (t.get(d) || []).concat(p));
                                } catch (e) {}
                            }
                        }
                        n = c + u;
                    }
                    return t;
                }
                function g(e) {
                    for(var t = new n.cereal.XdrReader(e), r = []; !t.eof;)r.push(n.xdr.ScSpecEntry.read(t));
                    return r;
                }
                function v(e, t) {
                    return b.apply(this, arguments);
                }
                function b() {
                    return (b = f(i().m(function e(t, r) {
                        return i().w(function(e) {
                            for(;;)if (0 === e.n) return e.a(2, t.publicKey ? r.getAccount(t.publicKey) : new n.Account(o.u, "0"));
                        }, e);
                    }))).apply(this, arguments);
                }
            },
            8451 (e, t, r) {
                "use strict";
                r.d(t, {
                    U: ()=>i
                });
                var n = r(8302), o = r(8287).Buffer;
                function i(e) {
                    var t = (0, n.ph)(e).get("contractspecv0");
                    if (!t || 0 === t.length) throw new Error("Could not obtain contract spec from wasm");
                    return o.from(t[0]);
                }
            },
            5976 (e, t, r) {
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, i(n.key), n);
                    }
                }
                function i(e) {
                    var t = function(e, t) {
                        if ("object" != n(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, t || "default");
                            if ("object" != n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == n(t) ? t : t + "";
                }
                function a(e, t, r) {
                    return t = l(t), function(e, t) {
                        if (t && ("object" == n(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, u() ? Reflect.construct(t, r || [], l(e).constructor) : t.apply(e, r));
                }
                function s(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return s = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return function(e, t, r) {
                                if (u()) return Reflect.construct.apply(null, arguments);
                                var n = [
                                    null
                                ];
                                n.push.apply(n, t);
                                var o = new (e.bind.apply(e, n));
                                return r && c(o, r.prototype), o;
                            }(e, arguments, l(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), c(r, e);
                    }, s(e);
                }
                function u() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (u = function() {
                        return !!e;
                    })();
                }
                function c(e, t) {
                    return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, c(e, t);
                }
                function l(e) {
                    return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, l(e);
                }
                r.d(t, {
                    Cu: ()=>H,
                    v7: ()=>_,
                    nS: ()=>U,
                    Dr: ()=>f,
                    m_: ()=>b
                });
                var f = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = a(this, t, [
                            e
                        ])).response = r, n;
                    }
                    var r, n, i;
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && c(e, t);
                    }(t, e), r = t, n = [
                        {
                            key: "getResponse",
                            value: function() {
                                return this.response;
                            }
                        }
                    ], o(r.prototype, n), i && o(r, i), Object.defineProperty(r, "prototype", {
                        writable: !1
                    }), r;
                }(s(Error));
                function p(e) {
                    return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, p(e);
                }
                function d(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, h(n.key), n);
                    }
                }
                function h(e) {
                    var t = function(e, t) {
                        if ("object" != p(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != p(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == p(t) ? t : t + "";
                }
                function y(e, t, r) {
                    return t = g(t), function(e, t) {
                        if (t && ("object" == p(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, m() ? Reflect.construct(t, r || [], g(e).constructor) : t.apply(e, r));
                }
                function m() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (m = function() {
                        return !!e;
                    })();
                }
                function g(e) {
                    return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, g(e);
                }
                function v(e, t) {
                    return v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, v(e, t);
                }
                var b = function(e) {
                    function t() {
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), y(this, t, arguments);
                    }
                    var r, n, o;
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && v(e, t);
                    }(t, e), r = t, n && d(r.prototype, n), o && d(r, o), Object.defineProperty(r, "prototype", {
                        writable: !1
                    }), r;
                }(f);
                function w(e) {
                    return w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, w(e);
                }
                function S(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, A(n.key), n);
                    }
                }
                function A(e) {
                    var t = function(e, t) {
                        if ("object" != w(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != w(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == w(t) ? t : t + "";
                }
                function E(e, t, r) {
                    return t = O(t), function(e, t) {
                        if (t && ("object" == w(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, T() ? Reflect.construct(t, r || [], O(e).constructor) : t.apply(e, r));
                }
                function T() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (T = function() {
                        return !!e;
                    })();
                }
                function O(e) {
                    return O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, O(e);
                }
                function k(e, t) {
                    return k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, k(e, t);
                }
                var _ = function(e) {
                    function t() {
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), E(this, t, arguments);
                    }
                    var r, n, o;
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && k(e, t);
                    }(t, e), r = t, n && S(r.prototype, n), o && S(r, o), Object.defineProperty(r, "prototype", {
                        writable: !1
                    }), r;
                }(f);
                function x(e) {
                    return x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, x(e);
                }
                function P(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, R(n.key), n);
                    }
                }
                function R(e) {
                    var t = function(e, t) {
                        if ("object" != x(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != x(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == x(t) ? t : t + "";
                }
                function I(e, t, r) {
                    return t = C(t), function(e, t) {
                        if (t && ("object" == x(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, B() ? Reflect.construct(t, r || [], C(e).constructor) : t.apply(e, r));
                }
                function B() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (B = function() {
                        return !!e;
                    })();
                }
                function C(e) {
                    return C = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, C(e);
                }
                function j(e, t) {
                    return j = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, j(e, t);
                }
                var U = function(e) {
                    function t() {
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), I(this, t, arguments);
                    }
                    var r, n, o;
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && j(e, t);
                    }(t, e), r = t, n && P(r.prototype, n), o && P(r, o), Object.defineProperty(r, "prototype", {
                        writable: !1
                    }), r;
                }(f);
                function N(e) {
                    return N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, N(e);
                }
                function L(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, F(n.key), n);
                    }
                }
                function F(e) {
                    var t = function(e, t) {
                        if ("object" != N(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != N(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == N(t) ? t : t + "";
                }
                function D(e, t, r) {
                    return t = G(t), function(e, t) {
                        if (t && ("object" == N(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, V() ? Reflect.construct(t, r || [], G(e).constructor) : t.apply(e, r));
                }
                function M(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return M = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return function(e, t, r) {
                                if (V()) return Reflect.construct.apply(null, arguments);
                                var n = [
                                    null
                                ];
                                n.push.apply(n, t);
                                var o = new (e.bind.apply(e, n));
                                return r && q(o, r.prototype), o;
                            }(e, arguments, G(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), q(r, e);
                    }, M(e);
                }
                function V() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (V = function() {
                        return !!e;
                    })();
                }
                function q(e, t) {
                    return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, q(e, t);
                }
                function G(e) {
                    return G = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, G(e);
                }
                var H = function(e) {
                    function t(e, r, n) {
                        var o;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (o = D(this, t, [
                            e
                        ])).accountId = r, o.operationIndex = n, o;
                    }
                    var r, n, o;
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && q(e, t);
                    }(t, e), r = t, n && L(r.prototype, n), o && L(r, o), Object.defineProperty(r, "prototype", {
                        writable: !1
                    }), r;
                }(M(Error));
            },
            6602 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    Api: ()=>{},
                    FEDERATION_RESPONSE_MAX_SIZE: ()=>w,
                    Server: ()=>S
                });
                var n = r(8950), o = r(4193), i = r.n(o), a = r(8732), s = r(5976), u = r(3898), c = r(9983);
                function l(e) {
                    if (!/^(?:[A-Za-z](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)*[A-Za-z](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?::\d+)?$/.test(e)) throw new Error("The provided domain is invalid. Ensure that the domain adheres to RFC 1035");
                }
                function f(e) {
                    return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, f(e);
                }
                function p(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, o, i, a, s = [], u = !0, c = !1;
                            try {
                                if (i = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    u = !1;
                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                            } catch (e) {
                                c = !0, o = e;
                            } finally{
                                try {
                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw o;
                                }
                            }
                            return s;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return d(e, t);
                            var r = ({}).toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function d(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function h() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return y(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (y(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, y(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, y(f, "constructor", c), y(c, "constructor", u), u.displayName = "GeneratorFunction", y(c, o, "GeneratorFunction"), y(f), y(f, o, "Generator"), y(f, n, function() {
                        return this;
                    }), y(f, "toString", function() {
                        return "[object Generator]";
                    }), (h = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function y(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    y = function(e, t, r, n) {
                        function i(t, r) {
                            y(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, y(e, t, r, n);
                }
                function m(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function g(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                m(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                m(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function v(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b(n.key), n);
                    }
                }
                function b(e) {
                    var t = function(e, t) {
                        if ("object" != f(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != f(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == f(t) ? t : t + "";
                }
                var w = 102400, S = function() {
                    function e(t, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.serverURL = i()(t), this.domain = r, l(r);
                        var o = void 0 === n.allowHttp ? a.T.isAllowHttp() : n.allowHttp;
                        if (this.timeout = void 0 === n.timeout ? a.T.getTimeout() : n.timeout, "https" !== this.serverURL.protocol() && !o) throw new Error("Cannot connect to insecure federation server");
                    }
                    var t, r, o, f, d, y, m, b, S;
                    return t = e, r = [
                        {
                            key: "resolveAddress",
                            value: (S = g(h().m(function e(t) {
                                var r, n;
                                return h().w(function(e) {
                                    for(;;)switch(e.n){
                                        case 0:
                                            if (r = t, !(t.indexOf("*") < 0)) {
                                                e.n = 2;
                                                break;
                                            }
                                            if (this.domain) {
                                                e.n = 1;
                                                break;
                                            }
                                            return e.a(2, Promise.reject(new Error("Unknown domain. Make sure `address` contains a domain (ex. `bob*stellar.org`) or pass `domain` parameter when instantiating the server object.")));
                                        case 1:
                                            r = "".concat(t, "*").concat(this.domain);
                                        case 2:
                                            return n = this.serverURL.clone().query({
                                                type: "name",
                                                q: r
                                            }), e.a(2, this._sendRequest(n));
                                    }
                                }, e, this);
                            })), function(e) {
                                return S.apply(this, arguments);
                            })
                        },
                        {
                            key: "resolveAccountId",
                            value: (b = g(h().m(function e(t) {
                                var r;
                                return h().w(function(e) {
                                    for(;;)if (0 === e.n) return r = this.serverURL.clone().query({
                                        type: "id",
                                        q: t
                                    }), e.a(2, this._sendRequest(r));
                                }, e, this);
                            })), function(e) {
                                return b.apply(this, arguments);
                            })
                        },
                        {
                            key: "resolveTransactionId",
                            value: (m = g(h().m(function e(t) {
                                var r;
                                return h().w(function(e) {
                                    for(;;)if (0 === e.n) return r = this.serverURL.clone().query({
                                        type: "txid",
                                        q: t
                                    }), e.a(2, this._sendRequest(r));
                                }, e, this);
                            })), function(e) {
                                return m.apply(this, arguments);
                            })
                        },
                        {
                            key: "_sendRequest",
                            value: (y = g(h().m(function e(t) {
                                var r;
                                return h().w(function(e) {
                                    for(;;)if (0 === e.n) return r = this.timeout, e.a(2, c.ok.get(t.toString(), {
                                        maxContentLength: w,
                                        timeout: r
                                    }).then(function(e) {
                                        if (void 0 !== e.data.memo && "string" != typeof e.data.memo) throw new Error("memo value should be of type string");
                                        return e.data;
                                    }).catch(function(e) {
                                        if (e instanceof Error) {
                                            if (e.message.match(/^maxContentLength size/)) throw new Error("federation response exceeds allowed size of ".concat(w));
                                            return Promise.reject(e);
                                        }
                                        return Promise.reject(new s.nS("Server query failed. Server responded: ".concat(e.status, " ").concat(e.statusText), e.data));
                                    }));
                                }, e, this);
                            })), function(e) {
                                return y.apply(this, arguments);
                            })
                        }
                    ], o = [
                        {
                            key: "resolve",
                            value: (d = g(h().m(function t(r) {
                                var o, i, a, s, u, c = arguments;
                                return h().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            if (o = c.length > 1 && void 0 !== c[1] ? c[1] : {}, !(r.indexOf("*") < 0)) {
                                                t.n = 2;
                                                break;
                                            }
                                            if (n.StrKey.isValidEd25519PublicKey(r)) {
                                                t.n = 1;
                                                break;
                                            }
                                            return t.a(2, Promise.reject(new Error("Invalid Account ID")));
                                        case 1:
                                            return t.a(2, Promise.resolve({
                                                account_id: r
                                            }));
                                        case 2:
                                            if (i = r.split("*"), a = p(i, 2), s = a[1], 2 === i.length && s) {
                                                t.n = 3;
                                                break;
                                            }
                                            return t.a(2, Promise.reject(new Error("Invalid Stellar address")));
                                        case 3:
                                            return t.n = 4, e.createForDomain(s, o);
                                        case 4:
                                            return u = t.v, t.a(2, u.resolveAddress(r));
                                    }
                                }, t);
                            })), function(e) {
                                return d.apply(this, arguments);
                            })
                        },
                        {
                            key: "createForDomain",
                            value: (f = g(h().m(function t(r) {
                                var n, o, i = arguments;
                                return h().w(function(t) {
                                    for(;;)switch(t.n){
                                        case 0:
                                            return n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, l(r), t.n = 1, u.Resolver.resolve(r, n);
                                        case 1:
                                            if ((o = t.v).FEDERATION_SERVER) {
                                                t.n = 2;
                                                break;
                                            }
                                            return t.a(2, Promise.reject(new Error("stellar.toml does not contain FEDERATION_SERVER field")));
                                        case 2:
                                            return t.a(2, new e(o.FEDERATION_SERVER, r, n));
                                    }
                                }, t);
                            })), function(e) {
                                return f.apply(this, arguments);
                            })
                        }
                    ], r && v(t.prototype, r), o && v(t, o), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), t;
                }();
            },
            8242 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    Api: ()=>{}
                });
            },
            8733 (e, t, r) {
                "use strict";
                var n;
                r.r(t), r.d(t, {
                    AccountResponse: ()=>h,
                    HorizonApi: ()=>n,
                    SERVER_TIME_MAP: ()=>W,
                    Server: ()=>en,
                    ServerApi: ()=>i,
                    default: ()=>tn,
                    getCurrentServerTime: ()=>K
                }), function(e) {
                    var t = function(e) {
                        return e.constantProduct = "constant_product", e;
                    }({});
                    e.LiquidityPoolType = t;
                    var r = function(e) {
                        return e.createAccount = "create_account", e.payment = "payment", e.pathPayment = "path_payment_strict_receive", e.createPassiveOffer = "create_passive_sell_offer", e.manageOffer = "manage_sell_offer", e.setOptions = "set_options", e.changeTrust = "change_trust", e.allowTrust = "allow_trust", e.accountMerge = "account_merge", e.inflation = "inflation", e.manageData = "manage_data", e.bumpSequence = "bump_sequence", e.manageBuyOffer = "manage_buy_offer", e.pathPaymentStrictSend = "path_payment_strict_send", e.createClaimableBalance = "create_claimable_balance", e.claimClaimableBalance = "claim_claimable_balance", e.beginSponsoringFutureReserves = "begin_sponsoring_future_reserves", e.endSponsoringFutureReserves = "end_sponsoring_future_reserves", e.revokeSponsorship = "revoke_sponsorship", e.clawback = "clawback", e.clawbackClaimableBalance = "clawback_claimable_balance", e.setTrustLineFlags = "set_trust_line_flags", e.liquidityPoolDeposit = "liquidity_pool_deposit", e.liquidityPoolWithdraw = "liquidity_pool_withdraw", e.invokeHostFunction = "invoke_host_function", e.bumpFootprintExpiration = "bump_footprint_expiration", e.restoreFootprint = "restore_footprint", e;
                    }({});
                    e.OperationResponseType = r;
                    var n = function(e) {
                        return e[e.createAccount = 0] = "createAccount", e[e.payment = 1] = "payment", e[e.pathPayment = 2] = "pathPayment", e[e.createPassiveOffer = 3] = "createPassiveOffer", e[e.manageOffer = 4] = "manageOffer", e[e.setOptions = 5] = "setOptions", e[e.changeTrust = 6] = "changeTrust", e[e.allowTrust = 7] = "allowTrust", e[e.accountMerge = 8] = "accountMerge", e[e.inflation = 9] = "inflation", e[e.manageData = 10] = "manageData", e[e.bumpSequence = 11] = "bumpSequence", e[e.manageBuyOffer = 12] = "manageBuyOffer", e[e.pathPaymentStrictSend = 13] = "pathPaymentStrictSend", e[e.createClaimableBalance = 14] = "createClaimableBalance", e[e.claimClaimableBalance = 15] = "claimClaimableBalance", e[e.beginSponsoringFutureReserves = 16] = "beginSponsoringFutureReserves", e[e.endSponsoringFutureReserves = 17] = "endSponsoringFutureReserves", e[e.revokeSponsorship = 18] = "revokeSponsorship", e[e.clawback = 19] = "clawback", e[e.clawbackClaimableBalance = 20] = "clawbackClaimableBalance", e[e.setTrustLineFlags = 21] = "setTrustLineFlags", e[e.liquidityPoolDeposit = 22] = "liquidityPoolDeposit", e[e.liquidityPoolWithdraw = 23] = "liquidityPoolWithdraw", e[e.invokeHostFunction = 24] = "invokeHostFunction", e[e.bumpFootprintExpiration = 25] = "bumpFootprintExpiration", e[e.restoreFootprint = 26] = "restoreFootprint", e;
                    }({});
                    e.OperationResponseTypeI = n;
                    var o = function(e) {
                        return e.TX_FAILED = "tx_failed", e.TX_BAD_SEQ = "tx_bad_seq", e.TX_BAD_AUTH = "tx_bad_auth", e.TX_BAD_AUTH_EXTRA = "tx_bad_auth_extra", e.TX_FEE_BUMP_INNER_SUCCESS = "tx_fee_bump_inner_success", e.TX_FEE_BUMP_INNER_FAILED = "tx_fee_bump_inner_failed", e.TX_NOT_SUPPORTED = "tx_not_supported", e.TX_SUCCESS = "tx_success", e.TX_TOO_EARLY = "tx_too_early", e.TX_TOO_LATE = "tx_too_late", e.TX_MISSING_OPERATION = "tx_missing_operation", e.TX_INSUFFICIENT_BALANCE = "tx_insufficient_balance", e.TX_NO_SOURCE_ACCOUNT = "tx_no_source_account", e.TX_INSUFFICIENT_FEE = "tx_insufficient_fee", e.TX_INTERNAL_ERROR = "tx_internal_error", e;
                    }({});
                    e.TransactionFailedResultCodes = o;
                }(n || (n = {}));
                var o, i, a = ((o = {})[o.account_created = 0] = "account_created", o[o.account_removed = 1] = "account_removed", o[o.account_credited = 2] = "account_credited", o[o.account_debited = 3] = "account_debited", o[o.account_thresholds_updated = 4] = "account_thresholds_updated", o[o.account_home_domain_updated = 5] = "account_home_domain_updated", o[o.account_flags_updated = 6] = "account_flags_updated", o[o.account_inflation_destination_updated = 7] = "account_inflation_destination_updated", o[o.signer_created = 10] = "signer_created", o[o.signer_removed = 11] = "signer_removed", o[o.signer_updated = 12] = "signer_updated", o[o.trustline_created = 20] = "trustline_created", o[o.trustline_removed = 21] = "trustline_removed", o[o.trustline_updated = 22] = "trustline_updated", o[o.trustline_authorized = 23] = "trustline_authorized", o[o.trustline_deauthorized = 24] = "trustline_deauthorized", o[o.trustline_authorized_to_maintain_liabilities = 25] = "trustline_authorized_to_maintain_liabilities", o[o.trustline_flags_updated = 26] = "trustline_flags_updated", o[o.offer_created = 30] = "offer_created", o[o.offer_removed = 31] = "offer_removed", o[o.offer_updated = 32] = "offer_updated", o[o.trade = 33] = "trade", o[o.data_created = 40] = "data_created", o[o.data_removed = 41] = "data_removed", o[o.data_updated = 42] = "data_updated", o[o.sequence_bumped = 43] = "sequence_bumped", o[o.claimable_balance_created = 50] = "claimable_balance_created", o[o.claimable_balance_claimant_created = 51] = "claimable_balance_claimant_created", o[o.claimable_balance_claimed = 52] = "claimable_balance_claimed", o[o.account_sponsorship_created = 60] = "account_sponsorship_created", o[o.account_sponsorship_updated = 61] = "account_sponsorship_updated", o[o.account_sponsorship_removed = 62] = "account_sponsorship_removed", o[o.trustline_sponsorship_created = 63] = "trustline_sponsorship_created", o[o.trustline_sponsorship_updated = 64] = "trustline_sponsorship_updated", o[o.trustline_sponsorship_removed = 65] = "trustline_sponsorship_removed", o[o.data_sponsorship_created = 66] = "data_sponsorship_created", o[o.data_sponsorship_updated = 67] = "data_sponsorship_updated", o[o.data_sponsorship_removed = 68] = "data_sponsorship_removed", o[o.claimable_balance_sponsorship_created = 69] = "claimable_balance_sponsorship_created", o[o.claimable_balance_sponsorship_updated = 70] = "claimable_balance_sponsorship_updated", o[o.claimable_balance_sponsorship_removed = 71] = "claimable_balance_sponsorship_removed", o[o.signer_sponsorship_created = 72] = "signer_sponsorship_created", o[o.signer_sponsorship_updated = 73] = "signer_sponsorship_updated", o[o.signer_sponsorship_removed = 74] = "signer_sponsorship_removed", o[o.claimable_balance_clawed_back = 80] = "claimable_balance_clawed_back", o[o.liquidity_pool_deposited = 90] = "liquidity_pool_deposited", o[o.liquidity_pool_withdrew = 91] = "liquidity_pool_withdrew", o[o.liquidity_pool_trade = 92] = "liquidity_pool_trade", o[o.liquidity_pool_created = 93] = "liquidity_pool_created", o[o.liquidity_pool_removed = 94] = "liquidity_pool_removed", o[o.liquidity_pool_revoked = 95] = "liquidity_pool_revoked", o[o.contract_credited = 96] = "contract_credited", o[o.contract_debited = 97] = "contract_debited", o);
                !function(e) {
                    e.EffectType = a;
                    var t = function(e) {
                        return e.all = "all", e.liquidityPools = "liquidity_pool", e.orderbook = "orderbook", e;
                    }({});
                    e.TradeType = t;
                    n.OperationResponseType, n.OperationResponseTypeI;
                }(i || (i = {}));
                var s = r(8950);
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function c(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, l(n.key), n);
                    }
                }
                function l(e) {
                    var t = function(e, t) {
                        if ("object" != u(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != u(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == u(t) ? t : t + "";
                }
                var f, p, d, h = (f = function e(t) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this._baseAccount = new s.Account(t.account_id, t.sequence), this.effects = t.effects, this.offers = t.offers, this.operations = t.operations, this.payments = t.payments, this.trades = t.trades, this.data = t.data, this.transactions = t.transactions, this.id = t.id, this.paging_token = t.paging_token, this.account_id = t.account_id, this.sequence = t.sequence, this.sequence_ledger = t.sequence_ledger, this.sequence_time = t.sequence_time, this.subentry_count = t.subentry_count, this.home_domain = t.home_domain, this.inflation_destination = t.inflation_destination, this.last_modified_ledger = t.last_modified_ledger, this.last_modified_time = t.last_modified_time, this.thresholds = t.thresholds, this.flags = t.flags, this.balances = t.balances, this.signers = t.signers, this.data_attr = t.data_attr, this.sponsor = t.sponsor, this.num_sponsoring = t.num_sponsoring, this.num_sponsored = t.num_sponsored;
                }, p = [
                    {
                        key: "accountId",
                        value: function() {
                            return this._baseAccount.accountId();
                        }
                    },
                    {
                        key: "sequenceNumber",
                        value: function() {
                            return this._baseAccount.sequenceNumber();
                        }
                    },
                    {
                        key: "incrementSequenceNumber",
                        value: function() {
                            this._baseAccount.incrementSequenceNumber(), this.sequence = this._baseAccount.sequenceNumber();
                        }
                    }
                ], c(f.prototype, p), d && c(f, d), Object.defineProperty(f, "prototype", {
                    writable: !1
                }), f), y = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, m = Math.ceil, g = Math.floor, v = "[BigNumber Error] ", b = v + "Number primitive has more than 15 significant digits: ", w = 1e14, S = 14, A = 9007199254740991, E = [
                    1,
                    10,
                    100,
                    1e3,
                    1e4,
                    1e5,
                    1e6,
                    1e7,
                    1e8,
                    1e9,
                    1e10,
                    1e11,
                    1e12,
                    1e13
                ], T = 1e7, O = 1e9;
                function k(e) {
                    var t = 0 | e;
                    return e > 0 || e === t ? t : t - 1;
                }
                function _(e) {
                    for(var t, r, n = 1, o = e.length, i = e[0] + ""; n < o;){
                        for(t = e[n++] + "", r = S - t.length; r--; t = "0" + t);
                        i += t;
                    }
                    for(o = i.length; 48 === i.charCodeAt(--o););
                    return i.slice(0, o + 1 || 1);
                }
                function x(e, t) {
                    var r, n, o = e.c, i = t.c, a = e.s, s = t.s, u = e.e, c = t.e;
                    if (!a || !s) return null;
                    if (r = o && !o[0], n = i && !i[0], r || n) return r ? n ? 0 : -s : a;
                    if (a != s) return a;
                    if (r = a < 0, n = u == c, !o || !i) return n ? 0 : !o ^ r ? 1 : -1;
                    if (!n) return u > c ^ r ? 1 : -1;
                    for(s = (u = o.length) < (c = i.length) ? u : c, a = 0; a < s; a++)if (o[a] != i[a]) return o[a] > i[a] ^ r ? 1 : -1;
                    return u == c ? 0 : u > c ^ r ? 1 : -1;
                }
                function P(e, t, r, n) {
                    if (e < t || e > r || e !== g(e)) throw Error(v + (n || "Argument") + ("number" == typeof e ? e < t || e > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
                }
                function R(e) {
                    var t = e.c.length - 1;
                    return k(e.e / S) == t && e.c[t] % 2 != 0;
                }
                function I(e, t) {
                    return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
                }
                function B(e, t, r) {
                    var n, o;
                    if (t < 0) {
                        for(o = r + "."; ++t; o += r);
                        e = o + e;
                    } else if (++t > (n = e.length)) {
                        for(o = r, t -= n; --t; o += r);
                        e += o;
                    } else t < n && (e = e.slice(0, t) + "." + e.slice(t));
                    return e;
                }
                var C = function e(t) {
                    var r, n, o, i, a, s, u, c, l, f, p = H.prototype = {
                        constructor: H,
                        toString: null,
                        valueOf: null
                    }, d = new H(1), h = 20, C = 4, j = -7, U = 21, N = -10000000, L = 1e7, F = !1, D = 1, M = 0, V = {
                        prefix: "",
                        groupSize: 3,
                        secondaryGroupSize: 0,
                        groupSeparator: ",",
                        decimalSeparator: ".",
                        fractionGroupSize: 0,
                        fractionGroupSeparator: "\xa0",
                        suffix: ""
                    }, q = "0123456789abcdefghijklmnopqrstuvwxyz", G = !0;
                    function H(e, t) {
                        var r, i, a, s, u, c, l, f, p = this;
                        if (!(p instanceof H)) return new H(e, t);
                        if (null == t) {
                            if (e && !0 === e._isBigNumber) return p.s = e.s, void (!e.c || e.e > L ? p.c = p.e = null : e.e < N ? p.c = [
                                p.e = 0
                            ] : (p.e = e.e, p.c = e.c.slice()));
                            if ((c = "number" == typeof e) && 0 * e == 0) {
                                if (p.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                                    for(s = 0, u = e; u >= 10; u /= 10, s++);
                                    return void (s > L ? p.c = p.e = null : (p.e = s, p.c = [
                                        e
                                    ]));
                                }
                                f = String(e);
                            } else {
                                if (!y.test(f = String(e))) return o(p, f, c);
                                p.s = 45 == f.charCodeAt(0) ? (f = f.slice(1), -1) : 1;
                            }
                            (s = f.indexOf(".")) > -1 && (f = f.replace(".", "")), (u = f.search(/e/i)) > 0 ? (s < 0 && (s = u), s += +f.slice(u + 1), f = f.substring(0, u)) : s < 0 && (s = f.length);
                        } else {
                            if (P(t, 2, q.length, "Base"), 10 == t && G) return K(p = new H(e), h + p.e + 1, C);
                            if (f = String(e), c = "number" == typeof e) {
                                if (0 * e != 0) return o(p, f, c, t);
                                if (p.s = 1 / e < 0 ? (f = f.slice(1), -1) : 1, H.DEBUG && f.replace(/^0\.0*|\./, "").length > 15) throw Error(b + e);
                            } else p.s = 45 === f.charCodeAt(0) ? (f = f.slice(1), -1) : 1;
                            for(r = q.slice(0, t), s = u = 0, l = f.length; u < l; u++)if (r.indexOf(i = f.charAt(u)) < 0) {
                                if ("." == i) {
                                    if (u > s) {
                                        s = l;
                                        continue;
                                    }
                                } else if (!a && (f == f.toUpperCase() && (f = f.toLowerCase()) || f == f.toLowerCase() && (f = f.toUpperCase()))) {
                                    a = !0, u = -1, s = 0;
                                    continue;
                                }
                                return o(p, String(e), c, t);
                            }
                            c = !1, (s = (f = n(f, t, 10, p.s)).indexOf(".")) > -1 ? f = f.replace(".", "") : s = f.length;
                        }
                        for(u = 0; 48 === f.charCodeAt(u); u++);
                        for(l = f.length; 48 === f.charCodeAt(--l););
                        if (f = f.slice(u, ++l)) {
                            if (l -= u, c && H.DEBUG && l > 15 && (e > A || e !== g(e))) throw Error(b + p.s * e);
                            if ((s = s - u - 1) > L) p.c = p.e = null;
                            else if (s < N) p.c = [
                                p.e = 0
                            ];
                            else {
                                if (p.e = s, p.c = [], u = (s + 1) % S, s < 0 && (u += S), u < l) {
                                    for(u && p.c.push(+f.slice(0, u)), l -= S; u < l;)p.c.push(+f.slice(u, u += S));
                                    u = S - (f = f.slice(u)).length;
                                } else u -= l;
                                for(; u--; f += "0");
                                p.c.push(+f);
                            }
                        } else p.c = [
                            p.e = 0
                        ];
                    }
                    function z(e, t, r, n) {
                        var o, i, a, s, u;
                        if (null == r ? r = C : P(r, 0, 8), !e.c) return e.toString();
                        if (o = e.c[0], a = e.e, null == t) u = _(e.c), u = 1 == n || 2 == n && (a <= j || a >= U) ? I(u, a) : B(u, a, "0");
                        else if (i = (e = K(new H(e), t, r)).e, s = (u = _(e.c)).length, 1 == n || 2 == n && (t <= i || i <= j)) {
                            for(; s < t; u += "0", s++);
                            u = I(u, i);
                        } else if (t -= a + (2 === n && i > a), u = B(u, i, "0"), i + 1 > s) {
                            if (--t > 0) for(u += "."; t--; u += "0");
                        } else if ((t += i - s) > 0) for(i + 1 == s && (u += "."); t--; u += "0");
                        return e.s < 0 && o ? "-" + u : u;
                    }
                    function W(e, t) {
                        for(var r, n, o = 1, i = new H(e[0]); o < e.length; o++)(!(n = new H(e[o])).s || (r = x(i, n)) === t || 0 === r && i.s === t) && (i = n);
                        return i;
                    }
                    function X(e, t, r) {
                        for(var n = 1, o = t.length; !t[--o]; t.pop());
                        for(o = t[0]; o >= 10; o /= 10, n++);
                        return (r = n + r * S - 1) > L ? e.c = e.e = null : r < N ? e.c = [
                            e.e = 0
                        ] : (e.e = r, e.c = t), e;
                    }
                    function K(e, t, r, n) {
                        var o, i, a, s, u, c, l, f = e.c, p = E;
                        if (f) {
                            e: {
                                for(o = 1, s = f[0]; s >= 10; s /= 10, o++);
                                if ((i = t - o) < 0) i += S, a = t, u = f[c = 0], l = g(u / p[o - a - 1] % 10);
                                else if ((c = m((i + 1) / S)) >= f.length) {
                                    if (!n) break e;
                                    for(; f.length <= c; f.push(0));
                                    u = l = 0, o = 1, a = (i %= S) - S + 1;
                                } else {
                                    for(u = s = f[c], o = 1; s >= 10; s /= 10, o++);
                                    l = (a = (i %= S) - S + o) < 0 ? 0 : g(u / p[o - a - 1] % 10);
                                }
                                if (n = n || t < 0 || null != f[c + 1] || (a < 0 ? u : u % p[o - a - 1]), n = r < 4 ? (l || n) && (0 == r || r == (e.s < 0 ? 3 : 2)) : l > 5 || 5 == l && (4 == r || n || 6 == r && (i > 0 ? a > 0 ? u / p[o - a] : 0 : f[c - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !f[0]) return f.length = 0, n ? (t -= e.e + 1, f[0] = p[(S - t % S) % S], e.e = -t || 0) : f[0] = e.e = 0, e;
                                if (0 == i ? (f.length = c, s = 1, c--) : (f.length = c + 1, s = p[S - i], f[c] = a > 0 ? g(u / p[o - a] % p[a]) * s : 0), n) for(;;){
                                    if (0 == c) {
                                        for(i = 1, a = f[0]; a >= 10; a /= 10, i++);
                                        for(a = f[0] += s, s = 1; a >= 10; a /= 10, s++);
                                        i != s && (e.e++, f[0] == w && (f[0] = 1));
                                        break;
                                    }
                                    if (f[c] += s, f[c] != w) break;
                                    f[c--] = 0, s = 1;
                                }
                                for(i = f.length; 0 === f[--i]; f.pop());
                            }
                            e.e > L ? e.c = e.e = null : e.e < N && (e.c = [
                                e.e = 0
                            ]);
                        }
                        return e;
                    }
                    function Z(e) {
                        var t, r = e.e;
                        return null === r ? e.toString() : (t = _(e.c), t = r <= j || r >= U ? I(t, r) : B(t, r, "0"), e.s < 0 ? "-" + t : t);
                    }
                    return H.clone = e, H.ROUND_UP = 0, H.ROUND_DOWN = 1, H.ROUND_CEIL = 2, H.ROUND_FLOOR = 3, H.ROUND_HALF_UP = 4, H.ROUND_HALF_DOWN = 5, H.ROUND_HALF_EVEN = 6, H.ROUND_HALF_CEIL = 7, H.ROUND_HALF_FLOOR = 8, H.EUCLID = 9, H.config = H.set = function(e) {
                        var t, r;
                        if (null != e) {
                            if ("object" != typeof e) throw Error(v + "Object expected: " + e);
                            if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (P(r = e[t], 0, O, t), h = r), e.hasOwnProperty(t = "ROUNDING_MODE") && (P(r = e[t], 0, 8, t), C = r), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((r = e[t]) && r.pop ? (P(r[0], -O, 0, t), P(r[1], 0, O, t), j = r[0], U = r[1]) : (P(r, -O, O, t), j = -(U = r < 0 ? -r : r))), e.hasOwnProperty(t = "RANGE")) {
                                if ((r = e[t]) && r.pop) P(r[0], -O, -1, t), P(r[1], 1, O, t), N = r[0], L = r[1];
                                else {
                                    if (P(r, -O, O, t), !r) throw Error(v + t + " cannot be zero: " + r);
                                    N = -(L = r < 0 ? -r : r);
                                }
                            }
                            if (e.hasOwnProperty(t = "CRYPTO")) {
                                if ((r = e[t]) !== !!r) throw Error(v + t + " not true or false: " + r);
                                if (r) {
                                    if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw F = !r, Error(v + "crypto unavailable");
                                    F = r;
                                } else F = r;
                            }
                            if (e.hasOwnProperty(t = "MODULO_MODE") && (P(r = e[t], 0, 9, t), D = r), e.hasOwnProperty(t = "POW_PRECISION") && (P(r = e[t], 0, O, t), M = r), e.hasOwnProperty(t = "FORMAT")) {
                                if ("object" != typeof (r = e[t])) throw Error(v + t + " not an object: " + r);
                                V = r;
                            }
                            if (e.hasOwnProperty(t = "ALPHABET")) {
                                if ("string" != typeof (r = e[t]) || /^.?$|[+\-.\s]|(.).*\1/.test(r)) throw Error(v + t + " invalid: " + r);
                                G = "0123456789" == r.slice(0, 10), q = r;
                            }
                        }
                        return {
                            DECIMAL_PLACES: h,
                            ROUNDING_MODE: C,
                            EXPONENTIAL_AT: [
                                j,
                                U
                            ],
                            RANGE: [
                                N,
                                L
                            ],
                            CRYPTO: F,
                            MODULO_MODE: D,
                            POW_PRECISION: M,
                            FORMAT: V,
                            ALPHABET: q
                        };
                    }, H.isBigNumber = function(e) {
                        if (!e || !0 !== e._isBigNumber) return !1;
                        if (!H.DEBUG) return !0;
                        var t, r, n = e.c, o = e.e, i = e.s;
                        e: if ("[object Array]" == ({}).toString.call(n)) {
                            if ((1 === i || -1 === i) && o >= -O && o <= O && o === g(o)) {
                                if (0 === n[0]) {
                                    if (0 === o && 1 === n.length) return !0;
                                    break e;
                                }
                                if ((t = (o + 1) % S) < 1 && (t += S), String(n[0]).length == t) {
                                    for(t = 0; t < n.length; t++)if ((r = n[t]) < 0 || r >= w || r !== g(r)) break e;
                                    if (0 !== r) return !0;
                                }
                            }
                        } else if (null === n && null === o && (null === i || 1 === i || -1 === i)) return !0;
                        throw Error(v + "Invalid BigNumber: " + e);
                    }, H.maximum = H.max = function() {
                        return W(arguments, -1);
                    }, H.minimum = H.min = function() {
                        return W(arguments, 1);
                    }, H.random = (i = 9007199254740992, a = Math.random() * i & 2097151 ? function() {
                        return g(Math.random() * i);
                    } : function() {
                        return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
                    }, function(e) {
                        var t, r, n, o, i, s = 0, u = [], c = new H(d);
                        if (null == e ? e = h : P(e, 0, O), o = m(e / S), F) {
                            if (crypto.getRandomValues) {
                                for(t = crypto.getRandomValues(new Uint32Array(o *= 2)); s < o;)(i = 131072 * t[s] + (t[s + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), t[s] = r[0], t[s + 1] = r[1]) : (u.push(i % 1e14), s += 2);
                                s = o / 2;
                            } else {
                                if (!crypto.randomBytes) throw F = !1, Error(v + "crypto unavailable");
                                for(t = crypto.randomBytes(o *= 7); s < o;)(i = 281474976710656 * (31 & t[s]) + 1099511627776 * t[s + 1] + 4294967296 * t[s + 2] + 16777216 * t[s + 3] + (t[s + 4] << 16) + (t[s + 5] << 8) + t[s + 6]) >= 9e15 ? crypto.randomBytes(7).copy(t, s) : (u.push(i % 1e14), s += 7);
                                s = o / 7;
                            }
                        }
                        if (!F) for(; s < o;)(i = a()) < 9e15 && (u[s++] = i % 1e14);
                        for(o = u[--s], e %= S, o && e && (i = E[S - e], u[s] = g(o / i) * i); 0 === u[s]; u.pop(), s--);
                        if (s < 0) u = [
                            n = 0
                        ];
                        else {
                            for(n = -1; 0 === u[0]; u.splice(0, 1), n -= S);
                            for(s = 1, i = u[0]; i >= 10; i /= 10, s++);
                            s < S && (n -= S - s);
                        }
                        return c.e = n, c.c = u, c;
                    }), H.sum = function() {
                        for(var e = 1, t = arguments, r = new H(t[0]); e < t.length;)r = r.plus(t[e++]);
                        return r;
                    }, n = function() {
                        var e = "0123456789";
                        function t(e, t, r, n) {
                            for(var o, i, a = [
                                0
                            ], s = 0, u = e.length; s < u;){
                                for(i = a.length; i--; a[i] *= t);
                                for(a[0] += n.indexOf(e.charAt(s++)), o = 0; o < a.length; o++)a[o] > r - 1 && (null == a[o + 1] && (a[o + 1] = 0), a[o + 1] += a[o] / r | 0, a[o] %= r);
                            }
                            return a.reverse();
                        }
                        return function(n, o, i, a, s) {
                            var u, c, l, f, p, d, y, m, g = n.indexOf("."), v = h, b = C;
                            for(g >= 0 && (f = M, M = 0, n = n.replace(".", ""), d = (m = new H(o)).pow(n.length - g), M = f, m.c = t(B(_(d.c), d.e, "0"), 10, i, e), m.e = m.c.length), l = f = (y = t(n, o, i, s ? (u = q, e) : (u = e, q))).length; 0 == y[--f]; y.pop());
                            if (!y[0]) return u.charAt(0);
                            if (g < 0 ? --l : (d.c = y, d.e = l, d.s = a, y = (d = r(d, m, v, b, i)).c, p = d.r, l = d.e), g = y[c = l + v + 1], f = i / 2, p = p || c < 0 || null != y[c + 1], p = b < 4 ? (null != g || p) && (0 == b || b == (d.s < 0 ? 3 : 2)) : g > f || g == f && (4 == b || p || 6 == b && 1 & y[c - 1] || b == (d.s < 0 ? 8 : 7)), c < 1 || !y[0]) n = p ? B(u.charAt(1), -v, u.charAt(0)) : u.charAt(0);
                            else {
                                if (y.length = c, p) for(--i; ++y[--c] > i;)y[c] = 0, c || (++l, y = [
                                    1
                                ].concat(y));
                                for(f = y.length; !y[--f];);
                                for(g = 0, n = ""; g <= f; n += u.charAt(y[g++]));
                                n = B(n, l, u.charAt(0));
                            }
                            return n;
                        };
                    }(), r = function() {
                        function e(e, t, r) {
                            var n, o, i, a, s = 0, u = e.length, c = t % T, l = t / T | 0;
                            for(e = e.slice(); u--;)s = ((o = c * (i = e[u] % T) + (n = l * i + (a = e[u] / T | 0) * c) % T * T + s) / r | 0) + (n / T | 0) + l * a, e[u] = o % r;
                            return s && (e = [
                                s
                            ].concat(e)), e;
                        }
                        function t(e, t, r, n) {
                            var o, i;
                            if (r != n) i = r > n ? 1 : -1;
                            else for(o = i = 0; o < r; o++)if (e[o] != t[o]) {
                                i = e[o] > t[o] ? 1 : -1;
                                break;
                            }
                            return i;
                        }
                        function r(e, t, r, n) {
                            for(var o = 0; r--;)e[r] -= o, o = e[r] < t[r] ? 1 : 0, e[r] = o * n + e[r] - t[r];
                            for(; !e[0] && e.length > 1; e.splice(0, 1));
                        }
                        return function(n, o, i, a, s) {
                            var u, c, l, f, p, d, h, y, m, v, b, A, E, T, O, _, x, P = n.s == o.s ? 1 : -1, R = n.c, I = o.c;
                            if (!(R && R[0] && I && I[0])) return new H(n.s && o.s && (R ? !I || R[0] != I[0] : I) ? R && 0 == R[0] || !I ? 0 * P : P / 0 : NaN);
                            for(m = (y = new H(P)).c = [], P = i + (c = n.e - o.e) + 1, s || (s = w, c = k(n.e / S) - k(o.e / S), P = P / S | 0), l = 0; I[l] == (R[l] || 0); l++);
                            if (I[l] > (R[l] || 0) && c--, P < 0) m.push(1), f = !0;
                            else {
                                for(T = R.length, _ = I.length, l = 0, P += 2, (p = g(s / (I[0] + 1))) > 1 && (I = e(I, p, s), R = e(R, p, s), _ = I.length, T = R.length), E = _, b = (v = R.slice(0, _)).length; b < _; v[b++] = 0);
                                x = I.slice(), x = [
                                    0
                                ].concat(x), O = I[0], I[1] >= s / 2 && O++;
                                do {
                                    if (p = 0, (u = t(I, v, _, b)) < 0) {
                                        if (A = v[0], _ != b && (A = A * s + (v[1] || 0)), (p = g(A / O)) > 1) for(p >= s && (p = s - 1), h = (d = e(I, p, s)).length, b = v.length; 1 == t(d, v, h, b);)p--, r(d, _ < h ? x : I, h, s), h = d.length, u = 1;
                                        else 0 == p && (u = p = 1), h = (d = I.slice()).length;
                                        if (h < b && (d = [
                                            0
                                        ].concat(d)), r(v, d, b, s), b = v.length, -1 == u) for(; t(I, v, _, b) < 1;)p++, r(v, _ < b ? x : I, b, s), b = v.length;
                                    } else 0 === u && (p++, v = [
                                        0
                                    ]);
                                    m[l++] = p, v[0] ? v[b++] = R[E] || 0 : (v = [
                                        R[E]
                                    ], b = 1);
                                }while ((E++ < T || null != v[0]) && P--);
                                f = null != v[0], m[0] || m.splice(0, 1);
                            }
                            if (s == w) {
                                for(l = 1, P = m[0]; P >= 10; P /= 10, l++);
                                K(y, i + (y.e = l + c * S - 1) + 1, a, f);
                            } else y.e = c, y.r = +f;
                            return y;
                        };
                    }(), s = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, c = /^\.([^.]+)$/, l = /^-?(Infinity|NaN)$/, f = /^\s*\+(?=[\w.])|^\s+|\s+$/g, o = function(e, t, r, n) {
                        var o, i = r ? t : t.replace(f, "");
                        if (l.test(i)) e.s = isNaN(i) ? null : i < 0 ? -1 : 1;
                        else {
                            if (!r && (i = i.replace(s, function(e, t, r) {
                                return o = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != o ? e : t;
                            }), n && (o = n, i = i.replace(u, "$1").replace(c, "0.$1")), t != i)) return new H(i, o);
                            if (H.DEBUG) throw Error(v + "Not a" + (n ? " base " + n : "") + " number: " + t);
                            e.s = null;
                        }
                        e.c = e.e = null;
                    }, p.absoluteValue = p.abs = function() {
                        var e = new H(this);
                        return e.s < 0 && (e.s = 1), e;
                    }, p.comparedTo = function(e, t) {
                        return x(this, new H(e, t));
                    }, p.decimalPlaces = p.dp = function(e, t) {
                        var r, n, o, i = this;
                        if (null != e) return P(e, 0, O), null == t ? t = C : P(t, 0, 8), K(new H(i), e + i.e + 1, t);
                        if (!(r = i.c)) return null;
                        if (n = ((o = r.length - 1) - k(this.e / S)) * S, o = r[o]) for(; o % 10 == 0; o /= 10, n--);
                        return n < 0 && (n = 0), n;
                    }, p.dividedBy = p.div = function(e, t) {
                        return r(this, new H(e, t), h, C);
                    }, p.dividedToIntegerBy = p.idiv = function(e, t) {
                        return r(this, new H(e, t), 0, 1);
                    }, p.exponentiatedBy = p.pow = function(e, t) {
                        var r, n, o, i, a, s, u, c, l = this;
                        if ((e = new H(e)).c && !e.isInteger()) throw Error(v + "Exponent not an integer: " + Z(e));
                        if (null != t && (t = new H(t)), a = e.e > 14, !l.c || !l.c[0] || 1 == l.c[0] && !l.e && 1 == l.c.length || !e.c || !e.c[0]) return c = new H(Math.pow(+Z(l), a ? e.s * (2 - R(e)) : +Z(e))), t ? c.mod(t) : c;
                        if (s = e.s < 0, t) {
                            if (t.c ? !t.c[0] : !t.s) return new H(NaN);
                            (n = !s && l.isInteger() && t.isInteger()) && (l = l.mod(t));
                        } else {
                            if (e.e > 9 && (l.e > 0 || l.e < -1 || (0 == l.e ? l.c[0] > 1 || a && l.c[1] >= 24e7 : l.c[0] < 8e13 || a && l.c[0] <= 9999975e7))) return i = l.s < 0 && R(e) ? -0 : 0, l.e > -1 && (i = 1 / i), new H(s ? 1 / i : i);
                            M && (i = m(M / S + 2));
                        }
                        for(a ? (r = new H(.5), s && (e.s = 1), u = R(e)) : u = (o = Math.abs(+Z(e))) % 2, c = new H(d);;){
                            if (u) {
                                if (!(c = c.times(l)).c) break;
                                i ? c.c.length > i && (c.c.length = i) : n && (c = c.mod(t));
                            }
                            if (o) {
                                if (0 === (o = g(o / 2))) break;
                                u = o % 2;
                            } else if (K(e = e.times(r), e.e + 1, 1), e.e > 14) u = R(e);
                            else {
                                if (0 === (o = +Z(e))) break;
                                u = o % 2;
                            }
                            l = l.times(l), i ? l.c && l.c.length > i && (l.c.length = i) : n && (l = l.mod(t));
                        }
                        return n ? c : (s && (c = d.div(c)), t ? c.mod(t) : i ? K(c, M, C, void 0) : c);
                    }, p.integerValue = function(e) {
                        var t = new H(this);
                        return null == e ? e = C : P(e, 0, 8), K(t, t.e + 1, e);
                    }, p.isEqualTo = p.eq = function(e, t) {
                        return 0 === x(this, new H(e, t));
                    }, p.isFinite = function() {
                        return !!this.c;
                    }, p.isGreaterThan = p.gt = function(e, t) {
                        return x(this, new H(e, t)) > 0;
                    }, p.isGreaterThanOrEqualTo = p.gte = function(e, t) {
                        return 1 === (t = x(this, new H(e, t))) || 0 === t;
                    }, p.isInteger = function() {
                        return !!this.c && k(this.e / S) > this.c.length - 2;
                    }, p.isLessThan = p.lt = function(e, t) {
                        return x(this, new H(e, t)) < 0;
                    }, p.isLessThanOrEqualTo = p.lte = function(e, t) {
                        return -1 === (t = x(this, new H(e, t))) || 0 === t;
                    }, p.isNaN = function() {
                        return !this.s;
                    }, p.isNegative = function() {
                        return this.s < 0;
                    }, p.isPositive = function() {
                        return this.s > 0;
                    }, p.isZero = function() {
                        return !!this.c && 0 == this.c[0];
                    }, p.minus = function(e, t) {
                        var r, n, o, i, a = this, s = a.s;
                        if (t = (e = new H(e, t)).s, !s || !t) return new H(NaN);
                        if (s != t) return e.s = -t, a.plus(e);
                        var u = a.e / S, c = e.e / S, l = a.c, f = e.c;
                        if (!u || !c) {
                            if (!l || !f) return l ? (e.s = -t, e) : new H(f ? a : NaN);
                            if (!l[0] || !f[0]) return f[0] ? (e.s = -t, e) : new H(l[0] ? a : 3 == C ? -0 : 0);
                        }
                        if (u = k(u), c = k(c), l = l.slice(), s = u - c) {
                            for((i = s < 0) ? (s = -s, o = l) : (c = u, o = f), o.reverse(), t = s; t--; o.push(0));
                            o.reverse();
                        } else for(n = (i = (s = l.length) < (t = f.length)) ? s : t, s = t = 0; t < n; t++)if (l[t] != f[t]) {
                            i = l[t] < f[t];
                            break;
                        }
                        if (i && (o = l, l = f, f = o, e.s = -e.s), (t = (n = f.length) - (r = l.length)) > 0) for(; t--; l[r++] = 0);
                        for(t = w - 1; n > s;){
                            if (l[--n] < f[n]) {
                                for(r = n; r && !l[--r]; l[r] = t);
                                --l[r], l[n] += w;
                            }
                            l[n] -= f[n];
                        }
                        for(; 0 == l[0]; l.splice(0, 1), --c);
                        return l[0] ? X(e, l, c) : (e.s = 3 == C ? -1 : 1, e.c = [
                            e.e = 0
                        ], e);
                    }, p.modulo = p.mod = function(e, t) {
                        var n, o, i = this;
                        return e = new H(e, t), !i.c || !e.s || e.c && !e.c[0] ? new H(NaN) : !e.c || i.c && !i.c[0] ? new H(i) : (9 == D ? (o = e.s, e.s = 1, n = r(i, e, 0, 3), e.s = o, n.s *= o) : n = r(i, e, 0, D), (e = i.minus(n.times(e))).c[0] || 1 != D || (e.s = i.s), e);
                    }, p.multipliedBy = p.times = function(e, t) {
                        var r, n, o, i, a, s, u, c, l, f, p, d, h, y, m, g = this, v = g.c, b = (e = new H(e, t)).c;
                        if (!(v && b && v[0] && b[0])) return !g.s || !e.s || v && !v[0] && !b || b && !b[0] && !v ? e.c = e.e = e.s = null : (e.s *= g.s, v && b ? (e.c = [
                            0
                        ], e.e = 0) : e.c = e.e = null), e;
                        for(n = k(g.e / S) + k(e.e / S), e.s *= g.s, (u = v.length) < (f = b.length) && (h = v, v = b, b = h, o = u, u = f, f = o), o = u + f, h = []; o--; h.push(0));
                        for(y = w, m = T, o = f; --o >= 0;){
                            for(r = 0, p = b[o] % m, d = b[o] / m | 0, i = o + (a = u); i > o;)r = ((c = p * (c = v[--a] % m) + (s = d * c + (l = v[a] / m | 0) * p) % m * m + h[i] + r) / y | 0) + (s / m | 0) + d * l, h[i--] = c % y;
                            h[i] = r;
                        }
                        return r ? ++n : h.splice(0, 1), X(e, h, n);
                    }, p.negated = function() {
                        var e = new H(this);
                        return e.s = -e.s || null, e;
                    }, p.plus = function(e, t) {
                        var r, n = this, o = n.s;
                        if (t = (e = new H(e, t)).s, !o || !t) return new H(NaN);
                        if (o != t) return e.s = -t, n.minus(e);
                        var i = n.e / S, a = e.e / S, s = n.c, u = e.c;
                        if (!i || !a) {
                            if (!s || !u) return new H(o / 0);
                            if (!s[0] || !u[0]) return u[0] ? e : new H(s[0] ? n : 0 * o);
                        }
                        if (i = k(i), a = k(a), s = s.slice(), o = i - a) {
                            for(o > 0 ? (a = i, r = u) : (o = -o, r = s), r.reverse(); o--; r.push(0));
                            r.reverse();
                        }
                        for((o = s.length) - (t = u.length) < 0 && (r = u, u = s, s = r, t = o), o = 0; t;)o = (s[--t] = s[t] + u[t] + o) / w | 0, s[t] = w === s[t] ? 0 : s[t] % w;
                        return o && (s = [
                            o
                        ].concat(s), ++a), X(e, s, a);
                    }, p.precision = p.sd = function(e, t) {
                        var r, n, o, i = this;
                        if (null != e && e !== !!e) return P(e, 1, O), null == t ? t = C : P(t, 0, 8), K(new H(i), e, t);
                        if (!(r = i.c)) return null;
                        if (n = (o = r.length - 1) * S + 1, o = r[o]) {
                            for(; o % 10 == 0; o /= 10, n--);
                            for(o = r[0]; o >= 10; o /= 10, n++);
                        }
                        return e && i.e + 1 > n && (n = i.e + 1), n;
                    }, p.shiftedBy = function(e) {
                        return P(e, -9007199254740991, A), this.times("1e" + e);
                    }, p.squareRoot = p.sqrt = function() {
                        var e, t, n, o, i, a = this, s = a.c, u = a.s, c = a.e, l = h + 4, f = new H("0.5");
                        if (1 !== u || !s || !s[0]) return new H(!u || u < 0 && (!s || s[0]) ? NaN : s ? a : 1 / 0);
                        if (0 == (u = Math.sqrt(+Z(a))) || u == 1 / 0 ? (((t = _(s)).length + c) % 2 == 0 && (t += "0"), u = Math.sqrt(+t), c = k((c + 1) / 2) - (c < 0 || c % 2), n = new H(t = u == 1 / 0 ? "5e" + c : (t = u.toExponential()).slice(0, t.indexOf("e") + 1) + c)) : n = new H(u + ""), n.c[0]) {
                            for((u = (c = n.e) + l) < 3 && (u = 0);;)if (i = n, n = f.times(i.plus(r(a, i, l, 1))), _(i.c).slice(0, u) === (t = _(n.c)).slice(0, u)) {
                                if (n.e < c && --u, "9999" != (t = t.slice(u - 3, u + 1)) && (o || "4999" != t)) {
                                    +t && (+t.slice(1) || "5" != t.charAt(0)) || (K(n, n.e + h + 2, 1), e = !n.times(n).eq(a));
                                    break;
                                }
                                if (!o && (K(i, i.e + h + 2, 0), i.times(i).eq(a))) {
                                    n = i;
                                    break;
                                }
                                l += 4, u += 4, o = 1;
                            }
                        }
                        return K(n, n.e + h + 1, C, e);
                    }, p.toExponential = function(e, t) {
                        return null != e && (P(e, 0, O), e++), z(this, e, t, 1);
                    }, p.toFixed = function(e, t) {
                        return null != e && (P(e, 0, O), e = e + this.e + 1), z(this, e, t);
                    }, p.toFormat = function(e, t, r) {
                        var n, o = this;
                        if (null == r) null != e && t && "object" == typeof t ? (r = t, t = null) : e && "object" == typeof e ? (r = e, e = t = null) : r = V;
                        else if ("object" != typeof r) throw Error(v + "Argument not an object: " + r);
                        if (n = o.toFixed(e, t), o.c) {
                            var i, a = n.split("."), s = +r.groupSize, u = +r.secondaryGroupSize, c = r.groupSeparator || "", l = a[0], f = a[1], p = o.s < 0, d = p ? l.slice(1) : l, h = d.length;
                            if (u && (i = s, s = u, u = i, h -= i), s > 0 && h > 0) {
                                for(i = h % s || s, l = d.substr(0, i); i < h; i += s)l += c + d.substr(i, s);
                                u > 0 && (l += c + d.slice(i)), p && (l = "-" + l);
                            }
                            n = f ? l + (r.decimalSeparator || "") + ((u = +r.fractionGroupSize) ? f.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : f) : l;
                        }
                        return (r.prefix || "") + n + (r.suffix || "");
                    }, p.toFraction = function(e) {
                        var t, n, o, i, a, s, u, c, l, f, p, h, y = this, m = y.c;
                        if (null != e && (!(u = new H(e)).isInteger() && (u.c || 1 !== u.s) || u.lt(d))) throw Error(v + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + Z(u));
                        if (!m) return new H(y);
                        for(t = new H(d), l = n = new H(d), o = c = new H(d), h = _(m), a = t.e = h.length - y.e - 1, t.c[0] = E[(s = a % S) < 0 ? S + s : s], e = !e || u.comparedTo(t) > 0 ? a > 0 ? t : l : u, s = L, L = 1 / 0, u = new H(h), c.c[0] = 0; f = r(u, t, 0, 1), 1 != (i = n.plus(f.times(o))).comparedTo(e);)n = o, o = i, l = c.plus(f.times(i = l)), c = i, t = u.minus(f.times(i = t)), u = i;
                        return i = r(e.minus(n), o, 0, 1), c = c.plus(i.times(l)), n = n.plus(i.times(o)), c.s = l.s = y.s, p = r(l, o, a *= 2, C).minus(y).abs().comparedTo(r(c, n, a, C).minus(y).abs()) < 1 ? [
                            l,
                            o
                        ] : [
                            c,
                            n
                        ], L = s, p;
                    }, p.toNumber = function() {
                        return +Z(this);
                    }, p.toPrecision = function(e, t) {
                        return null != e && P(e, 1, O), z(this, e, t, 2);
                    }, p.toString = function(e) {
                        var t, r = this, o = r.s, i = r.e;
                        return null === i ? o ? (t = "Infinity", o < 0 && (t = "-" + t)) : t = "NaN" : (null == e ? t = i <= j || i >= U ? I(_(r.c), i) : B(_(r.c), i, "0") : 10 === e && G ? t = B(_((r = K(new H(r), h + i + 1, C)).c), r.e, "0") : (P(e, 2, q.length, "Base"), t = n(B(_(r.c), i, "0"), 10, e, o, !0)), o < 0 && r.c[0] && (t = "-" + t)), t;
                    }, p.valueOf = p.toJSON = function() {
                        return Z(this);
                    }, p._isBigNumber = !0, p[Symbol.toStringTag] = "BigNumber", p[Symbol.for("nodejs.util.inspect.custom")] = p.valueOf, null != t && H.set(t), H;
                }();
                const j = C;
                var U = r(4193), N = r.n(U), L = r(9127), F = r.n(L), D = r(5976), M = r(9983);
                function V(e) {
                    return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, V(e);
                }
                function q(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function G(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? q(Object(r), !0).forEach(function(t) {
                            H(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function H(e, t, r) {
                    return (t = function(e) {
                        var t = function(e, t) {
                            if ("object" != V(e) || !e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(e, t || "default");
                                if ("object" != V(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(e, "string");
                        return "symbol" == V(t) ? t : t + "";
                    }(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                var z = "15.1.0", W = {};
                function X(e) {
                    return Math.floor(e / 1e3);
                }
                function K(e) {
                    var t = W[e];
                    if (!t || !t.localTimeRecorded || !t.serverTime) return null;
                    var r = t.serverTime, n = t.localTimeRecorded, o = X((new Date).getTime());
                    return o - n > 300 ? null : o - n + r;
                }
                function Z(e) {
                    return Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Z(e);
                }
                function $() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return Y(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (Y(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, Y(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, Y(f, "constructor", c), Y(c, "constructor", u), u.displayName = "GeneratorFunction", Y(c, o, "GeneratorFunction"), Y(f), Y(f, o, "Generator"), Y(f, n, function() {
                        return this;
                    }), Y(f, "toString", function() {
                        return "[object Generator]";
                    }), ($ = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function Y(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    Y = function(e, t, r, n) {
                        function i(t, r) {
                            Y(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, Y(e, t, r, n);
                }
                function Q(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function J(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                Q(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                Q(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function ee(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, o, i, a, s = [], u = !0, c = !1;
                            try {
                                if (i = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    u = !1;
                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                            } catch (e) {
                                c = !0, o = e;
                            } finally{
                                try {
                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw o;
                                }
                            }
                            return s;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return te(e, t);
                            var r = ({}).toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? te(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function te(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function re(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ne(n.key), n);
                    }
                }
                function ne(e) {
                    var t = function(e, t) {
                        if ("object" != Z(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Z(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Z(t) ? t : t + "";
                }
                var oe, ie, ae, se, ue = [
                    "transaction"
                ], ce = r.g;
                oe = null !== (ie = null !== (ae = ce.EventSource) && void 0 !== ae ? ae : null === (se = ce.window) || void 0 === se ? void 0 : se.EventSource) && void 0 !== ie ? ie : r(1731);
                var le, fe, pe = function(e, t, r) {
                    return t && re(e.prototype, t), r && re(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }(function e(t, r) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.url = t.clone(), this.filter = [], this.originalSegments = this.url.segment() || [], this.neighborRoot = n, this.httpClient = r;
                }, [
                    {
                        key: "call",
                        value: function() {
                            var e = this;
                            return this.checkFilter(), this._sendNormalRequest(this.url).then(function(t) {
                                return e._parseResponse(t);
                            });
                        }
                    },
                    {
                        key: "stream",
                        value: function() {
                            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            if (void 0 === oe) throw new Error("Streaming requires eventsource to be enabled. If you need this functionality, compile with USE_EVENTSOURCE=true.");
                            this.checkFilter();
                            var r = this.url.clone();
                            r.setQuery("X-Client-Name", "js-stellar-sdk"), r.setQuery("X-Client-Version", z);
                            var n, o, i = this.httpClient.defaults.headers;
                            i && [
                                "X-App-Name",
                                "X-App-Version"
                            ].forEach(function(e) {
                                var t, n;
                                if (i instanceof Headers) t = null !== (n = i.get(e)) && void 0 !== n ? n : void 0;
                                else if (Array.isArray(i)) {
                                    var o = i.find(function(t) {
                                        return ee(t, 1)[0] === e;
                                    });
                                    t = null == o ? void 0 : o[1];
                                } else t = i[e];
                                t && r.setQuery(e, t);
                            });
                            var a = function() {
                                o = setTimeout(function() {
                                    var e;
                                    null === (e = n) || void 0 === e || e.close(), n = s();
                                }, t.reconnectTimeout || 15e3);
                            }, s = function() {
                                try {
                                    n = new oe(r.toString());
                                } catch (e) {
                                    t.onerror && t.onerror(e);
                                }
                                if (a(), !n) return n;
                                var i = !1, u = function() {
                                    i || (clearTimeout(o), n.close(), s(), i = !0);
                                }, c = function(n) {
                                    if ("close" !== n.type) {
                                        var i = n.data ? e._parseRecord(JSON.parse(n.data)) : n;
                                        i.paging_token && r.setQuery("cursor", i.paging_token), clearTimeout(o), a(), void 0 !== t.onmessage && t.onmessage(i);
                                    } else u();
                                }, l = function(e) {
                                    t.onerror && t.onerror(e);
                                };
                                return n.addEventListener ? (n.addEventListener("message", c.bind(e)), n.addEventListener("error", l.bind(e)), n.addEventListener("close", u.bind(e))) : (n.onmessage = c.bind(e), n.onerror = l.bind(e)), n;
                            };
                            return s(), function() {
                                var e;
                                clearTimeout(o), null === (e = n) || void 0 === e || e.close();
                            };
                        }
                    },
                    {
                        key: "cursor",
                        value: function(e) {
                            return this.url.setQuery("cursor", e), this;
                        }
                    },
                    {
                        key: "limit",
                        value: function(e) {
                            return this.url.setQuery("limit", e.toString()), this;
                        }
                    },
                    {
                        key: "order",
                        value: function(e) {
                            return this.url.setQuery("order", e), this;
                        }
                    },
                    {
                        key: "join",
                        value: function(e) {
                            return this.url.setQuery("join", e), this;
                        }
                    },
                    {
                        key: "forEndpoint",
                        value: function(e, t) {
                            if ("" === this.neighborRoot) throw new Error("Invalid usage: neighborRoot not set in constructor");
                            return this.filter.push([
                                e,
                                t,
                                this.neighborRoot
                            ]), this;
                        }
                    },
                    {
                        key: "checkFilter",
                        value: function() {
                            if (this.filter.length >= 2) throw new D.v7("Too many filters specified", this.filter);
                            if (1 === this.filter.length) {
                                var e = this.originalSegments.concat(this.filter[0]);
                                this.url.segment(e);
                            }
                        }
                    },
                    {
                        key: "_requestFnForLink",
                        value: function(e) {
                            var t = this;
                            return J($().m(function r() {
                                var n, o, i, a, s = arguments;
                                return $().w(function(r) {
                                    for(;;)switch(r.n){
                                        case 0:
                                            return n = s.length > 0 && void 0 !== s[0] ? s[0] : {}, e.templated ? (i = F()(e.href), o = N()(i.expand(n))) : o = N()(e.href), r.n = 1, t._sendNormalRequest(o);
                                        case 1:
                                            return a = r.v, r.a(2, t._parseResponse(a));
                                    }
                                }, r);
                            }));
                        }
                    },
                    {
                        key: "_parseRecord",
                        value: function(e) {
                            var t = this;
                            return e._links ? (Object.keys(e._links).forEach(function(r) {
                                var n = e._links[r], o = !1;
                                if (void 0 !== e[r] && (e["".concat(r, "_attr")] = e[r], o = !0), o && ue.indexOf(r) >= 0) {
                                    var i = t._parseRecord(e[r]);
                                    e[r] = J($().m(function e() {
                                        return $().w(function(e) {
                                            for(;;)if (0 === e.n) return e.a(2, i);
                                        }, e);
                                    }));
                                } else e[r] = t._requestFnForLink(n);
                            }), e) : e;
                        }
                    },
                    {
                        key: "_sendNormalRequest",
                        value: (fe = J($().m(function e(t) {
                            var r;
                            return $().w(function(e) {
                                for(;;)if (0 === e.n) return r = (r = t).authority(this.url.authority()).protocol(this.url.protocol()), e.a(2, this.httpClient.get(r.toString()).then(function(e) {
                                    return e.data;
                                }).catch(this._handleNetworkError));
                            }, e, this);
                        })), function(e) {
                            return fe.apply(this, arguments);
                        })
                    },
                    {
                        key: "_parseResponse",
                        value: function(e) {
                            return e._embedded && e._embedded.records ? this._toCollectionPage(e) : this._parseRecord(e);
                        }
                    },
                    {
                        key: "_toCollectionPage",
                        value: function(e) {
                            for(var t, r, n = this, o = 0; o < e._embedded.records.length; o += 1)e._embedded.records[o] = this._parseRecord(e._embedded.records[o]);
                            return {
                                records: e._embedded.records,
                                next: (r = J($().m(function t() {
                                    var r;
                                    return $().w(function(t) {
                                        for(;;)switch(t.n){
                                            case 0:
                                                return t.n = 1, n._sendNormalRequest(N()(e._links.next.href));
                                            case 1:
                                                return r = t.v, t.a(2, n._toCollectionPage(r));
                                        }
                                    }, t);
                                })), function() {
                                    return r.apply(this, arguments);
                                }),
                                prev: (t = J($().m(function t() {
                                    var r;
                                    return $().w(function(t) {
                                        for(;;)switch(t.n){
                                            case 0:
                                                return t.n = 1, n._sendNormalRequest(N()(e._links.prev.href));
                                            case 1:
                                                return r = t.v, t.a(2, n._toCollectionPage(r));
                                        }
                                    }, t);
                                })), function() {
                                    return t.apply(this, arguments);
                                })
                            };
                        }
                    },
                    {
                        key: "_handleNetworkError",
                        value: (le = J($().m(function e(t) {
                            var r, n, o;
                            return $().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if (!t.response || !t.response.status) {
                                            e.n = 4;
                                            break;
                                        }
                                        o = t.response.status, e.n = 404 === o ? 1 : 2;
                                        break;
                                    case 1:
                                        return e.a(2, Promise.reject(new D.m_(null !== (r = t.response.statusText) && void 0 !== r ? r : "Not Found", t.response.data)));
                                    case 2:
                                        return e.a(2, Promise.reject(new D.Dr(null !== (n = t.response.statusText) && void 0 !== n ? n : "Unknown", t.response.data)));
                                    case 3:
                                        e.n = 5;
                                        break;
                                    case 4:
                                        return e.a(2, Promise.reject(new Error(t.message)));
                                    case 5:
                                        return e.a(2);
                                }
                            }, e);
                        })), function(e) {
                            return le.apply(this, arguments);
                        })
                    }
                ]), de = r(8732);
                function he(e) {
                    return he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, he(e);
                }
                function ye(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, me(n.key), n);
                    }
                }
                function me(e) {
                    var t = function(e, t) {
                        if ("object" != he(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != he(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == he(t) ? t : t + "";
                }
                function ge(e, t, r) {
                    return t = be(t), function(e, t) {
                        if (t && ("object" == he(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, ve() ? Reflect.construct(t, r || [], be(e).constructor) : t.apply(e, r));
                }
                function ve() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (ve = function() {
                        return !!e;
                    })();
                }
                function be(e) {
                    return be = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, be(e);
                }
                function we(e, t) {
                    return we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, we(e, t);
                }
                var Se = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = ge(this, t, [
                            e,
                            r
                        ])).url.segment("accounts"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && we(e, t);
                    }(t, e), function(e, t, r) {
                        return t && ye(e.prototype, t), r && ye(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "accountId",
                            value: function(e) {
                                var t = new pe(this.url.clone(), this.httpClient);
                                return t.filter.push([
                                    e
                                ]), t;
                            }
                        },
                        {
                            key: "forSigner",
                            value: function(e) {
                                return this.url.setQuery("signer", e), this;
                            }
                        },
                        {
                            key: "forAsset",
                            value: function(e) {
                                return this.url.setQuery("asset", "".concat(e)), this;
                            }
                        },
                        {
                            key: "sponsor",
                            value: function(e) {
                                return this.url.setQuery("sponsor", e), this;
                            }
                        },
                        {
                            key: "forLiquidityPool",
                            value: function(e) {
                                return this.url.setQuery("liquidity_pool", e), this;
                            }
                        }
                    ]);
                }(pe);
                function Ae(e) {
                    return Ae = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Ae(e);
                }
                function Ee(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Te(n.key), n);
                    }
                }
                function Te(e) {
                    var t = function(e, t) {
                        if ("object" != Ae(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Ae(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Ae(t) ? t : t + "";
                }
                function Oe(e, t, r) {
                    return t = _e(t), function(e, t) {
                        if (t && ("object" == Ae(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, ke() ? Reflect.construct(t, r || [], _e(e).constructor) : t.apply(e, r));
                }
                function ke() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (ke = function() {
                        return !!e;
                    })();
                }
                function _e(e) {
                    return _e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, _e(e);
                }
                function xe(e, t) {
                    return xe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, xe(e, t);
                }
                var Pe = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = Oe(this, t, [
                            e,
                            r
                        ])).url.segment("assets"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && xe(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Ee(e.prototype, t), r && Ee(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "forCode",
                            value: function(e) {
                                return this.url.setQuery("asset_code", e), this;
                            }
                        },
                        {
                            key: "forIssuer",
                            value: function(e) {
                                return this.url.setQuery("asset_issuer", e), this;
                            }
                        }
                    ]);
                }(pe);
                function Re(e) {
                    return Re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Re(e);
                }
                function Ie(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Be(n.key), n);
                    }
                }
                function Be(e) {
                    var t = function(e, t) {
                        if ("object" != Re(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Re(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Re(t) ? t : t + "";
                }
                function Ce(e, t, r) {
                    return t = Ue(t), function(e, t) {
                        if (t && ("object" == Re(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, je() ? Reflect.construct(t, r || [], Ue(e).constructor) : t.apply(e, r));
                }
                function je() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (je = function() {
                        return !!e;
                    })();
                }
                function Ue(e) {
                    return Ue = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Ue(e);
                }
                function Ne(e, t) {
                    return Ne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Ne(e, t);
                }
                var Le = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = Ce(this, t, [
                            e,
                            r
                        ])).url.segment("claimable_balances"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Ne(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Ie(e.prototype, t), r && Ie(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "claimableBalance",
                            value: function(e) {
                                var t = new pe(this.url.clone(), this.httpClient);
                                return t.filter.push([
                                    e
                                ]), t;
                            }
                        },
                        {
                            key: "sponsor",
                            value: function(e) {
                                return this.url.setQuery("sponsor", e), this;
                            }
                        },
                        {
                            key: "claimant",
                            value: function(e) {
                                return this.url.setQuery("claimant", e), this;
                            }
                        },
                        {
                            key: "asset",
                            value: function(e) {
                                return this.url.setQuery("asset", e.toString()), this;
                            }
                        }
                    ]);
                }(pe);
                function Fe(e) {
                    return Fe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Fe(e);
                }
                function De(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Me(n.key), n);
                    }
                }
                function Me(e) {
                    var t = function(e, t) {
                        if ("object" != Fe(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Fe(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Fe(t) ? t : t + "";
                }
                function Ve(e, t, r) {
                    return t = Ge(t), function(e, t) {
                        if (t && ("object" == Fe(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, qe() ? Reflect.construct(t, r || [], Ge(e).constructor) : t.apply(e, r));
                }
                function qe() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (qe = function() {
                        return !!e;
                    })();
                }
                function Ge(e) {
                    return Ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Ge(e);
                }
                function He(e, t) {
                    return He = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, He(e, t);
                }
                var ze = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = Ve(this, t, [
                            e,
                            r,
                            "effects"
                        ])).url.segment("effects"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && He(e, t);
                    }(t, e), function(e, t, r) {
                        return t && De(e.prototype, t), r && De(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.forEndpoint("accounts", e);
                            }
                        },
                        {
                            key: "forLedger",
                            value: function(e) {
                                return this.forEndpoint("ledgers", e.toString());
                            }
                        },
                        {
                            key: "forTransaction",
                            value: function(e) {
                                return this.forEndpoint("transactions", e);
                            }
                        },
                        {
                            key: "forOperation",
                            value: function(e) {
                                return this.forEndpoint("operations", e);
                            }
                        },
                        {
                            key: "forLiquidityPool",
                            value: function(e) {
                                return this.forEndpoint("liquidity_pools", e);
                            }
                        }
                    ]);
                }(pe);
                function We(e) {
                    return We = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, We(e);
                }
                function Xe(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ke(n.key), n);
                    }
                }
                function Ke(e) {
                    var t = function(e, t) {
                        if ("object" != We(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != We(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == We(t) ? t : t + "";
                }
                function Ze(e, t, r) {
                    return t = Ye(t), function(e, t) {
                        if (t && ("object" == We(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, $e() ? Reflect.construct(t, r || [], Ye(e).constructor) : t.apply(e, r));
                }
                function $e() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return ($e = function() {
                        return !!e;
                    })();
                }
                function Ye(e) {
                    return Ye = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Ye(e);
                }
                function Qe(e, t) {
                    return Qe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Qe(e, t);
                }
                var Je = function(e) {
                    function t(e, r, n) {
                        var o;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (o = Ze(this, t, [
                            e,
                            r
                        ])).url.segment("friendbot"), o.url.setQuery("addr", n), o;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Qe(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Xe(e.prototype, t), r && Xe(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t);
                }(pe);
                function et(e) {
                    return et = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, et(e);
                }
                function tt(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rt(n.key), n);
                    }
                }
                function rt(e) {
                    var t = function(e, t) {
                        if ("object" != et(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != et(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == et(t) ? t : t + "";
                }
                function nt(e, t, r) {
                    return t = it(t), function(e, t) {
                        if (t && ("object" == et(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, ot() ? Reflect.construct(t, r || [], it(e).constructor) : t.apply(e, r));
                }
                function ot() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (ot = function() {
                        return !!e;
                    })();
                }
                function it(e) {
                    return it = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, it(e);
                }
                function at(e, t) {
                    return at = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, at(e, t);
                }
                var st = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = nt(this, t, [
                            e,
                            r
                        ])).url.segment("ledgers"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && at(e, t);
                    }(t, e), function(e, t, r) {
                        return t && tt(e.prototype, t), r && tt(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "ledger",
                            value: function(e) {
                                return this.filter.push([
                                    "ledgers",
                                    e.toString()
                                ]), this;
                            }
                        }
                    ]);
                }(pe);
                function ut(e) {
                    return ut = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, ut(e);
                }
                function ct(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lt(n.key), n);
                    }
                }
                function lt(e) {
                    var t = function(e, t) {
                        if ("object" != ut(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != ut(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == ut(t) ? t : t + "";
                }
                function ft(e, t, r) {
                    return t = dt(t), function(e, t) {
                        if (t && ("object" == ut(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, pt() ? Reflect.construct(t, r || [], dt(e).constructor) : t.apply(e, r));
                }
                function pt() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (pt = function() {
                        return !!e;
                    })();
                }
                function dt(e) {
                    return dt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, dt(e);
                }
                function ht(e, t) {
                    return ht = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, ht(e, t);
                }
                var yt = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = ft(this, t, [
                            e,
                            r
                        ])).url.segment("liquidity_pools"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && ht(e, t);
                    }(t, e), function(e, t, r) {
                        return t && ct(e.prototype, t), r && ct(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "forAssets",
                            value: function() {
                                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                                var n = t.map(function(e) {
                                    return e.toString();
                                }).join(",");
                                return this.url.setQuery("reserves", n), this;
                            }
                        },
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.url.setQuery("account", e), this;
                            }
                        },
                        {
                            key: "liquidityPoolId",
                            value: function(e) {
                                if (!e.match(/[a-fA-F0-9]{64}/)) throw new TypeError("".concat(e, " does not look like a liquidity pool ID"));
                                var t = new pe(this.url.clone(), this.httpClient);
                                return t.filter.push([
                                    e.toLowerCase()
                                ]), t;
                            }
                        }
                    ]);
                }(pe);
                function mt(e) {
                    return mt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, mt(e);
                }
                function gt(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vt(n.key), n);
                    }
                }
                function vt(e) {
                    var t = function(e, t) {
                        if ("object" != mt(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != mt(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == mt(t) ? t : t + "";
                }
                function bt(e, t, r) {
                    return t = St(t), function(e, t) {
                        if (t && ("object" == mt(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, wt() ? Reflect.construct(t, r || [], St(e).constructor) : t.apply(e, r));
                }
                function wt() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (wt = function() {
                        return !!e;
                    })();
                }
                function St(e) {
                    return St = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, St(e);
                }
                function At(e, t) {
                    return At = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, At(e, t);
                }
                var Et = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = bt(this, t, [
                            e,
                            r,
                            "offers"
                        ])).url.segment("offers"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && At(e, t);
                    }(t, e), function(e, t, r) {
                        return t && gt(e.prototype, t), r && gt(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "offer",
                            value: function(e) {
                                var t = new pe(this.url.clone(), this.httpClient);
                                return t.filter.push([
                                    e
                                ]), t;
                            }
                        },
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.forEndpoint("accounts", e);
                            }
                        },
                        {
                            key: "buying",
                            value: function(e) {
                                return e.isNative() ? this.url.setQuery("buying_asset_type", "native") : (this.url.setQuery("buying_asset_type", e.getAssetType()), this.url.setQuery("buying_asset_code", e.getCode()), this.url.setQuery("buying_asset_issuer", e.getIssuer())), this;
                            }
                        },
                        {
                            key: "selling",
                            value: function(e) {
                                return e.isNative() ? this.url.setQuery("selling_asset_type", "native") : (this.url.setQuery("selling_asset_type", e.getAssetType()), this.url.setQuery("selling_asset_code", e.getCode()), this.url.setQuery("selling_asset_issuer", e.getIssuer())), this;
                            }
                        },
                        {
                            key: "sponsor",
                            value: function(e) {
                                return this.url.setQuery("sponsor", e), this;
                            }
                        },
                        {
                            key: "seller",
                            value: function(e) {
                                return this.url.setQuery("seller", e), this;
                            }
                        }
                    ]);
                }(pe);
                function Tt(e) {
                    return Tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Tt(e);
                }
                function Ot(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kt(n.key), n);
                    }
                }
                function kt(e) {
                    var t = function(e, t) {
                        if ("object" != Tt(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Tt(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Tt(t) ? t : t + "";
                }
                function _t(e, t, r) {
                    return t = Pt(t), function(e, t) {
                        if (t && ("object" == Tt(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, xt() ? Reflect.construct(t, r || [], Pt(e).constructor) : t.apply(e, r));
                }
                function xt() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (xt = function() {
                        return !!e;
                    })();
                }
                function Pt(e) {
                    return Pt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Pt(e);
                }
                function Rt(e, t) {
                    return Rt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Rt(e, t);
                }
                var It = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = _t(this, t, [
                            e,
                            r,
                            "operations"
                        ])).url.segment("operations"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Rt(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Ot(e.prototype, t), r && Ot(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "operation",
                            value: function(e) {
                                var t = new pe(this.url.clone(), this.httpClient);
                                return t.filter.push([
                                    e
                                ]), t;
                            }
                        },
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.forEndpoint("accounts", e);
                            }
                        },
                        {
                            key: "forClaimableBalance",
                            value: function(e) {
                                return this.forEndpoint("claimable_balances", e);
                            }
                        },
                        {
                            key: "forLedger",
                            value: function(e) {
                                return this.forEndpoint("ledgers", e.toString());
                            }
                        },
                        {
                            key: "forTransaction",
                            value: function(e) {
                                return this.forEndpoint("transactions", e);
                            }
                        },
                        {
                            key: "forLiquidityPool",
                            value: function(e) {
                                return this.forEndpoint("liquidity_pools", e);
                            }
                        },
                        {
                            key: "includeFailed",
                            value: function(e) {
                                return this.url.setQuery("include_failed", e.toString()), this;
                            }
                        }
                    ]);
                }(pe);
                function Bt(e) {
                    return Bt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Bt(e);
                }
                function Ct(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jt(n.key), n);
                    }
                }
                function jt(e) {
                    var t = function(e, t) {
                        if ("object" != Bt(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Bt(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Bt(t) ? t : t + "";
                }
                function Ut(e, t, r) {
                    return t = Lt(t), function(e, t) {
                        if (t && ("object" == Bt(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, Nt() ? Reflect.construct(t, r || [], Lt(e).constructor) : t.apply(e, r));
                }
                function Nt() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (Nt = function() {
                        return !!e;
                    })();
                }
                function Lt(e) {
                    return Lt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Lt(e);
                }
                function Ft(e, t) {
                    return Ft = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Ft(e, t);
                }
                var Dt = function(e) {
                    function t(e, r, n, o) {
                        var i;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (i = Ut(this, t, [
                            e,
                            r
                        ])).url.segment("order_book"), n.isNative() ? i.url.setQuery("selling_asset_type", "native") : (i.url.setQuery("selling_asset_type", n.getAssetType()), i.url.setQuery("selling_asset_code", n.getCode()), i.url.setQuery("selling_asset_issuer", n.getIssuer())), o.isNative() ? i.url.setQuery("buying_asset_type", "native") : (i.url.setQuery("buying_asset_type", o.getAssetType()), i.url.setQuery("buying_asset_code", o.getCode()), i.url.setQuery("buying_asset_issuer", o.getIssuer())), i;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Ft(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Ct(e.prototype, t), r && Ct(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t);
                }(pe);
                function Mt(e) {
                    return Mt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Mt(e);
                }
                function Vt(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qt(n.key), n);
                    }
                }
                function qt(e) {
                    var t = function(e, t) {
                        if ("object" != Mt(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Mt(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Mt(t) ? t : t + "";
                }
                function Gt(e, t, r) {
                    return t = zt(t), function(e, t) {
                        if (t && ("object" == Mt(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, Ht() ? Reflect.construct(t, r || [], zt(e).constructor) : t.apply(e, r));
                }
                function Ht() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (Ht = function() {
                        return !!e;
                    })();
                }
                function zt(e) {
                    return zt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, zt(e);
                }
                function Wt(e, t) {
                    return Wt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Wt(e, t);
                }
                var Xt = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = Gt(this, t, [
                            e,
                            r,
                            "payments"
                        ])).url.segment("payments"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Wt(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Vt(e.prototype, t), r && Vt(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.forEndpoint("accounts", e);
                            }
                        },
                        {
                            key: "forLedger",
                            value: function(e) {
                                return this.forEndpoint("ledgers", e.toString());
                            }
                        },
                        {
                            key: "forTransaction",
                            value: function(e) {
                                return this.forEndpoint("transactions", e);
                            }
                        },
                        {
                            key: "includeFailed",
                            value: function(e) {
                                return this.url.setQuery("include_failed", e.toString()), this;
                            }
                        }
                    ]);
                }(pe);
                function Kt(e) {
                    return Kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Kt(e);
                }
                function Zt(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $t(n.key), n);
                    }
                }
                function $t(e) {
                    var t = function(e, t) {
                        if ("object" != Kt(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Kt(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Kt(t) ? t : t + "";
                }
                function Yt(e, t, r) {
                    return t = Jt(t), function(e, t) {
                        if (t && ("object" == Kt(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, Qt() ? Reflect.construct(t, r || [], Jt(e).constructor) : t.apply(e, r));
                }
                function Qt() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (Qt = function() {
                        return !!e;
                    })();
                }
                function Jt(e) {
                    return Jt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Jt(e);
                }
                function er(e, t) {
                    return er = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, er(e, t);
                }
                var tr = function(e) {
                    function t(e, r, n, o, i) {
                        var a;
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (a = Yt(this, t, [
                            e,
                            r
                        ])).url.segment("paths/strict-receive"), "string" == typeof n) a.url.setQuery("source_account", n);
                        else {
                            var s = n.map(function(e) {
                                return e.isNative() ? "native" : "".concat(e.getCode(), ":").concat(e.getIssuer());
                            }).join(",");
                            a.url.setQuery("source_assets", s);
                        }
                        return a.url.setQuery("destination_amount", i), o.isNative() ? a.url.setQuery("destination_asset_type", "native") : (a.url.setQuery("destination_asset_type", o.getAssetType()), a.url.setQuery("destination_asset_code", o.getCode()), a.url.setQuery("destination_asset_issuer", o.getIssuer())), a;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && er(e, t);
                    }(t, e), function(e, t, r) {
                        return t && Zt(e.prototype, t), r && Zt(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t);
                }(pe);
                function rr(e) {
                    return rr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, rr(e);
                }
                function nr(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, or(n.key), n);
                    }
                }
                function or(e) {
                    var t = function(e, t) {
                        if ("object" != rr(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != rr(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == rr(t) ? t : t + "";
                }
                function ir(e, t, r) {
                    return t = sr(t), function(e, t) {
                        if (t && ("object" == rr(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, ar() ? Reflect.construct(t, r || [], sr(e).constructor) : t.apply(e, r));
                }
                function ar() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (ar = function() {
                        return !!e;
                    })();
                }
                function sr(e) {
                    return sr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, sr(e);
                }
                function ur(e, t) {
                    return ur = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, ur(e, t);
                }
                var cr = function(e) {
                    function t(e, r, n, o, i) {
                        var a;
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (a = ir(this, t, [
                            e,
                            r
                        ])).url.segment("paths/strict-send"), n.isNative() ? a.url.setQuery("source_asset_type", "native") : (a.url.setQuery("source_asset_type", n.getAssetType()), a.url.setQuery("source_asset_code", n.getCode()), a.url.setQuery("source_asset_issuer", n.getIssuer())), a.url.setQuery("source_amount", o), "string" == typeof i) a.url.setQuery("destination_account", i);
                        else {
                            var s = i.map(function(e) {
                                return e.isNative() ? "native" : "".concat(e.getCode(), ":").concat(e.getIssuer());
                            }).join(",");
                            a.url.setQuery("destination_assets", s);
                        }
                        return a;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && ur(e, t);
                    }(t, e), function(e, t, r) {
                        return t && nr(e.prototype, t), r && nr(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t);
                }(pe);
                function lr(e) {
                    return lr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, lr(e);
                }
                function fr(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pr(n.key), n);
                    }
                }
                function pr(e) {
                    var t = function(e, t) {
                        if ("object" != lr(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != lr(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == lr(t) ? t : t + "";
                }
                function dr(e, t, r) {
                    return t = yr(t), function(e, t) {
                        if (t && ("object" == lr(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, hr() ? Reflect.construct(t, r || [], yr(e).constructor) : t.apply(e, r));
                }
                function hr() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (hr = function() {
                        return !!e;
                    })();
                }
                function yr(e) {
                    return yr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, yr(e);
                }
                function mr(e, t) {
                    return mr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, mr(e, t);
                }
                var gr = [
                    6e4,
                    3e5,
                    9e5,
                    36e5,
                    864e5,
                    6048e5
                ], vr = function(e) {
                    function t(e, r, n, o, i, a, s, u) {
                        var c;
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (c = dr(this, t, [
                            e,
                            r
                        ])).url.segment("trade_aggregations"), n.isNative() ? c.url.setQuery("base_asset_type", "native") : (c.url.setQuery("base_asset_type", n.getAssetType()), c.url.setQuery("base_asset_code", n.getCode()), c.url.setQuery("base_asset_issuer", n.getIssuer())), o.isNative() ? c.url.setQuery("counter_asset_type", "native") : (c.url.setQuery("counter_asset_type", o.getAssetType()), c.url.setQuery("counter_asset_code", o.getCode()), c.url.setQuery("counter_asset_issuer", o.getIssuer())), "number" != typeof i || "number" != typeof a) throw new D.v7("Invalid time bounds", [
                            i,
                            a
                        ]);
                        if (c.url.setQuery("start_time", i.toString()), c.url.setQuery("end_time", a.toString()), !c.isValidResolution(s)) throw new D.v7("Invalid resolution", s);
                        if (c.url.setQuery("resolution", s.toString()), !c.isValidOffset(u, s)) throw new D.v7("Invalid offset", u);
                        return c.url.setQuery("offset", u.toString()), c;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && mr(e, t);
                    }(t, e), function(e, t, r) {
                        return t && fr(e.prototype, t), r && fr(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "isValidResolution",
                            value: function(e) {
                                return gr.some(function(t) {
                                    return t === e;
                                });
                            }
                        },
                        {
                            key: "isValidOffset",
                            value: function(e, t) {
                                var r = 36e5;
                                return !(e > t || e >= 24 * r || e % r !== 0);
                            }
                        }
                    ]);
                }(pe);
                function br(e) {
                    return br = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, br(e);
                }
                function wr(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Sr(n.key), n);
                    }
                }
                function Sr(e) {
                    var t = function(e, t) {
                        if ("object" != br(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != br(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == br(t) ? t : t + "";
                }
                function Ar(e, t, r) {
                    return t = Tr(t), function(e, t) {
                        if (t && ("object" == br(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, Er() ? Reflect.construct(t, r || [], Tr(e).constructor) : t.apply(e, r));
                }
                function Er() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (Er = function() {
                        return !!e;
                    })();
                }
                function Tr(e) {
                    return Tr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Tr(e);
                }
                function Or(e, t) {
                    return Or = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Or(e, t);
                }
                var kr = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = Ar(this, t, [
                            e,
                            r,
                            "trades"
                        ])).url.segment("trades"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Or(e, t);
                    }(t, e), function(e, t, r) {
                        return t && wr(e.prototype, t), r && wr(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "forAssetPair",
                            value: function(e, t) {
                                return e.isNative() ? this.url.setQuery("base_asset_type", "native") : (this.url.setQuery("base_asset_type", e.getAssetType()), this.url.setQuery("base_asset_code", e.getCode()), this.url.setQuery("base_asset_issuer", e.getIssuer())), t.isNative() ? this.url.setQuery("counter_asset_type", "native") : (this.url.setQuery("counter_asset_type", t.getAssetType()), this.url.setQuery("counter_asset_code", t.getCode()), this.url.setQuery("counter_asset_issuer", t.getIssuer())), this;
                            }
                        },
                        {
                            key: "forOffer",
                            value: function(e) {
                                return this.url.setQuery("offer_id", e), this;
                            }
                        },
                        {
                            key: "forType",
                            value: function(e) {
                                return this.url.setQuery("trade_type", e), this;
                            }
                        },
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.forEndpoint("accounts", e);
                            }
                        },
                        {
                            key: "forLiquidityPool",
                            value: function(e) {
                                return this.forEndpoint("liquidity_pools", e);
                            }
                        }
                    ]);
                }(pe);
                function _r(e) {
                    return _r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, _r(e);
                }
                function xr(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pr(n.key), n);
                    }
                }
                function Pr(e) {
                    var t = function(e, t) {
                        if ("object" != _r(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != _r(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == _r(t) ? t : t + "";
                }
                function Rr(e, t, r) {
                    return t = Br(t), function(e, t) {
                        if (t && ("object" == _r(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, Ir() ? Reflect.construct(t, r || [], Br(e).constructor) : t.apply(e, r));
                }
                function Ir() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (Ir = function() {
                        return !!e;
                    })();
                }
                function Br(e) {
                    return Br = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, Br(e);
                }
                function Cr(e, t) {
                    return Cr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, Cr(e, t);
                }
                var jr = function(e) {
                    function t(e, r) {
                        var n;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), (n = Rr(this, t, [
                            e,
                            r,
                            "transactions"
                        ])).url.segment("transactions"), n;
                    }
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && Cr(e, t);
                    }(t, e), function(e, t, r) {
                        return t && xr(e.prototype, t), r && xr(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }(t, [
                        {
                            key: "transaction",
                            value: function(e) {
                                var t = new pe(this.url.clone(), this.httpClient);
                                return t.filter.push([
                                    e
                                ]), t;
                            }
                        },
                        {
                            key: "forAccount",
                            value: function(e) {
                                return this.forEndpoint("accounts", e);
                            }
                        },
                        {
                            key: "forClaimableBalance",
                            value: function(e) {
                                return this.forEndpoint("claimable_balances", e);
                            }
                        },
                        {
                            key: "forLedger",
                            value: function(e) {
                                return this.forEndpoint("ledgers", e.toString());
                            }
                        },
                        {
                            key: "forLiquidityPool",
                            value: function(e) {
                                return this.forEndpoint("liquidity_pools", e);
                            }
                        },
                        {
                            key: "includeFailed",
                            value: function(e) {
                                return this.url.setQuery("include_failed", e.toString()), this;
                            }
                        }
                    ]);
                }(pe);
                function Ur(e) {
                    return Ur = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, Ur(e);
                }
                function Nr(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function Lr(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Nr(Object(r), !0).forEach(function(t) {
                            Fr(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nr(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function Fr(e, t, r) {
                    return (t = Hr(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function Dr() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return Mr(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (Mr(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, Mr(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, Mr(f, "constructor", c), Mr(c, "constructor", u), u.displayName = "GeneratorFunction", Mr(c, o, "GeneratorFunction"), Mr(f), Mr(f, o, "Generator"), Mr(f, n, function() {
                        return this;
                    }), Mr(f, "toString", function() {
                        return "[object Generator]";
                    }), (Dr = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function Mr(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    Mr = function(e, t, r, n) {
                        function i(t, r) {
                            Mr(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, Mr(e, t, r, n);
                }
                function Vr(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function qr(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                Vr(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                Vr(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function Gr(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Hr(n.key), n);
                    }
                }
                function Hr(e) {
                    var t = function(e, t) {
                        if ("object" != Ur(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != Ur(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == Ur(t) ? t : t + "";
                }
                function zr(e) {
                    return new j(e).div(1e7).toString();
                }
                var Wr, Xr, Kr, Zr, $r, Yr, Qr, Jr, en = function(e, t, r) {
                    return t && Gr(e.prototype, t), r && Gr(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }(function e(t) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.serverURL = N()(t);
                    var n, o, i = void 0 === r.allowHttp ? de.T.isAllowHttp() : r.allowHttp, a = {};
                    if (r.appName && (a["X-App-Name"] = r.appName), r.appVersion && (a["X-App-Version"] = r.appVersion), r.authToken && (a["X-Auth-Token"] = r.authToken), r.headers && Object.assign(a, r.headers), this.httpClient = (n = a, (o = (0, M.vt)({
                        headers: G(G({}, n), {}, {
                            "X-Client-Name": "js-stellar-sdk",
                            "X-Client-Version": z
                        })
                    })).interceptors.response.use(function(e) {
                        var t = N()(e.config.url), r = t.port() ? "".concat(t.hostname(), ":").concat(t.port()) : t.hostname(), n = 0;
                        if (e.headers instanceof Headers) {
                            var o = e.headers.get("date");
                            o && (n = X(Date.parse(o)));
                        } else if ("object" === V(e.headers) && "date" in e.headers) {
                            var i = e.headers;
                            "string" == typeof i.date && (n = X(Date.parse(i.date)));
                        }
                        var a = X((new Date).getTime());
                        return Number.isNaN(n) || (W[r] = {
                            serverTime: n,
                            localTimeRecorded: a
                        }), e;
                    }), o), "https" !== this.serverURL.protocol() && !i) throw new Error("Cannot connect to insecure horizon server");
                }, [
                    {
                        key: "fetchTimebounds",
                        value: (Jr = qr(Dr().m(function e(t) {
                            var r, n, o, i = arguments;
                            return Dr().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if (r = i.length > 1 && void 0 !== i[1] && i[1], n = this.serverURL.port() ? "".concat(this.serverURL.hostname(), ":").concat(this.serverURL.port()) : this.serverURL.hostname(), !(o = K(n))) {
                                            e.n = 1;
                                            break;
                                        }
                                        return e.a(2, {
                                            minTime: 0,
                                            maxTime: o + t
                                        });
                                    case 1:
                                        if (!r) {
                                            e.n = 2;
                                            break;
                                        }
                                        return e.a(2, {
                                            minTime: 0,
                                            maxTime: Math.floor((new Date).getTime() / 1e3) + t
                                        });
                                    case 2:
                                        return e.n = 3, this.httpClient.get(this.serverURL.toString());
                                    case 3:
                                        return e.a(2, this.fetchTimebounds(t, !0));
                                }
                            }, e, this);
                        })), function(e) {
                            return Jr.apply(this, arguments);
                        })
                    },
                    {
                        key: "fetchBaseFee",
                        value: (Qr = qr(Dr().m(function e() {
                            var t;
                            return Dr().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return e.n = 1, this.feeStats();
                                    case 1:
                                        return t = e.v, e.a(2, parseInt(t.last_ledger_base_fee, 10) || 100);
                                }
                            }, e, this);
                        })), function() {
                            return Qr.apply(this, arguments);
                        })
                    },
                    {
                        key: "feeStats",
                        value: (Yr = qr(Dr().m(function e() {
                            var t;
                            return Dr().w(function(e) {
                                for(;;)if (0 === e.n) return (t = new pe(this.serverURL, this.httpClient)).filter.push([
                                    "fee_stats"
                                ]), e.a(2, t.call());
                            }, e, this);
                        })), function() {
                            return Yr.apply(this, arguments);
                        })
                    },
                    {
                        key: "root",
                        value: ($r = qr(Dr().m(function e() {
                            var t;
                            return Dr().w(function(e) {
                                for(;;)if (0 === e.n) return t = new pe(this.serverURL, this.httpClient), e.a(2, t.call());
                            }, e, this);
                        })), function() {
                            return $r.apply(this, arguments);
                        })
                    },
                    {
                        key: "submitTransaction",
                        value: (Zr = qr(Dr().m(function e(t) {
                            var r, n = arguments;
                            return Dr().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if ((n.length > 1 && void 0 !== n[1] ? n[1] : {
                                            skipMemoRequiredCheck: !1
                                        }).skipMemoRequiredCheck) {
                                            e.n = 1;
                                            break;
                                        }
                                        return e.n = 1, this.checkMemoRequired(t);
                                    case 1:
                                        return r = encodeURIComponent(t.toEnvelope().toXDR().toString("base64")), e.a(2, this.httpClient.post(this.serverURL.clone().segment("transactions").toString(), "tx=".concat(r), {
                                            timeout: 6e4,
                                            headers: {
                                                "Content-Type": "application/x-www-form-urlencoded"
                                            }
                                        }).then(function(e) {
                                            if (!e.data.result_xdr) return e.data;
                                            var t, r, n = s.xdr.TransactionResult.fromXDR(e.data.result_xdr, "base64").result().value();
                                            return n.length && (t = n.map(function(e, t) {
                                                if ("manageBuyOffer" !== e.value().switch().name && "manageSellOffer" !== e.value().switch().name) return null;
                                                r = !0;
                                                var n, o = new j(0), i = new j(0), a = e.value().value().success(), u = a.offersClaimed().map(function(e) {
                                                    var t = e.value(), r = "";
                                                    switch(e.switch()){
                                                        case s.xdr.ClaimAtomType.claimAtomTypeV0():
                                                            r = s.StrKey.encodeEd25519PublicKey(t.sellerEd25519());
                                                            break;
                                                        case s.xdr.ClaimAtomType.claimAtomTypeOrderBook():
                                                            r = s.StrKey.encodeEd25519PublicKey(t.sellerId().ed25519());
                                                            break;
                                                        default:
                                                            throw new Error("Invalid offer result type: ".concat(e.switch()));
                                                    }
                                                    var n = new j(t.amountBought().toString()), a = new j(t.amountSold().toString());
                                                    o = o.plus(a), i = i.plus(n);
                                                    var u = s.Asset.fromOperation(t.assetSold()), c = s.Asset.fromOperation(t.assetBought()), l = {
                                                        type: u.getAssetType(),
                                                        assetCode: u.getCode(),
                                                        issuer: u.getIssuer()
                                                    }, f = {
                                                        type: c.getAssetType(),
                                                        assetCode: c.getCode(),
                                                        issuer: c.getIssuer()
                                                    };
                                                    return {
                                                        sellerId: r,
                                                        offerId: t.offerId().toString(),
                                                        assetSold: l,
                                                        amountSold: zr(a),
                                                        assetBought: f,
                                                        amountBought: zr(n)
                                                    };
                                                }), c = a.offer().switch().name;
                                                if ("function" == typeof a.offer().value && a.offer().value()) {
                                                    var l = a.offer().value();
                                                    n = {
                                                        offerId: l.offerId().toString(),
                                                        selling: {},
                                                        buying: {},
                                                        amount: zr(l.amount().toString()),
                                                        price: {
                                                            n: l.price().n(),
                                                            d: l.price().d()
                                                        }
                                                    };
                                                    var f = s.Asset.fromOperation(l.selling());
                                                    n.selling = {
                                                        type: f.getAssetType(),
                                                        assetCode: f.getCode(),
                                                        issuer: f.getIssuer()
                                                    };
                                                    var p = s.Asset.fromOperation(l.buying());
                                                    n.buying = {
                                                        type: p.getAssetType(),
                                                        assetCode: p.getCode(),
                                                        issuer: p.getIssuer()
                                                    };
                                                }
                                                return {
                                                    offersClaimed: u,
                                                    effect: c,
                                                    operationIndex: t,
                                                    currentOffer: n,
                                                    amountBought: zr(o),
                                                    amountSold: zr(i),
                                                    isFullyOpen: !u.length && "manageOfferDeleted" !== c,
                                                    wasPartiallyFilled: !!u.length && "manageOfferDeleted" !== c,
                                                    wasImmediatelyFilled: !!u.length && "manageOfferDeleted" === c,
                                                    wasImmediatelyDeleted: !u.length && "manageOfferDeleted" === c
                                                };
                                            }).filter(function(e) {
                                                return !!e;
                                            })), Lr(Lr({}, e.data), {}, {
                                                offerResults: r ? t : void 0
                                            });
                                        }).catch(function(e) {
                                            return e instanceof Error ? Promise.reject(e) : Promise.reject(new D.nS("Transaction submission failed. Server responded: ".concat(e.status, " ").concat(e.statusText), e.data));
                                        }));
                                }
                            }, e, this);
                        })), function(e) {
                            return Zr.apply(this, arguments);
                        })
                    },
                    {
                        key: "submitAsyncTransaction",
                        value: (Kr = qr(Dr().m(function e(t) {
                            var r, n = arguments;
                            return Dr().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if ((n.length > 1 && void 0 !== n[1] ? n[1] : {
                                            skipMemoRequiredCheck: !1
                                        }).skipMemoRequiredCheck) {
                                            e.n = 1;
                                            break;
                                        }
                                        return e.n = 1, this.checkMemoRequired(t);
                                    case 1:
                                        return r = encodeURIComponent(t.toEnvelope().toXDR().toString("base64")), e.a(2, this.httpClient.post(this.serverURL.clone().segment("transactions_async").toString(), "tx=".concat(r), {
                                            headers: {
                                                "Content-Type": "application/x-www-form-urlencoded"
                                            }
                                        }).then(function(e) {
                                            return e.data;
                                        }).catch(function(e) {
                                            return e instanceof Error ? Promise.reject(e) : Promise.reject(new D.nS("Transaction submission failed. Server responded: ".concat(e.status, " ").concat(e.statusText), e.data));
                                        }));
                                }
                            }, e, this);
                        })), function(e) {
                            return Kr.apply(this, arguments);
                        })
                    },
                    {
                        key: "accounts",
                        value: function() {
                            return new Se(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "claimableBalances",
                        value: function() {
                            return new Le(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "ledgers",
                        value: function() {
                            return new st(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "transactions",
                        value: function() {
                            return new jr(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "offers",
                        value: function() {
                            return new Et(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "orderbook",
                        value: function(e, t) {
                            return new Dt(this.serverURL, this.httpClient, e, t);
                        }
                    },
                    {
                        key: "trades",
                        value: function() {
                            return new kr(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "operations",
                        value: function() {
                            return new It(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "liquidityPools",
                        value: function() {
                            return new yt(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "strictReceivePaths",
                        value: function(e, t, r) {
                            return new tr(this.serverURL, this.httpClient, e, t, r);
                        }
                    },
                    {
                        key: "strictSendPaths",
                        value: function(e, t, r) {
                            return new cr(this.serverURL, this.httpClient, e, t, r);
                        }
                    },
                    {
                        key: "payments",
                        value: function() {
                            return new Xt(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "effects",
                        value: function() {
                            return new ze(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "friendbot",
                        value: function(e) {
                            return new Je(this.serverURL, this.httpClient, e);
                        }
                    },
                    {
                        key: "assets",
                        value: function() {
                            return new Pe(this.serverURL, this.httpClient);
                        }
                    },
                    {
                        key: "loadAccount",
                        value: (Xr = qr(Dr().m(function e(t) {
                            var r;
                            return Dr().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return e.n = 1, this.accounts().accountId(t).call();
                                    case 1:
                                        return r = e.v, e.a(2, new h(r));
                                }
                            }, e, this);
                        })), function(e) {
                            return Xr.apply(this, arguments);
                        })
                    },
                    {
                        key: "tradeAggregation",
                        value: function(e, t, r, n, o, i) {
                            return new vr(this.serverURL, this.httpClient, e, t, r, n, o, i);
                        }
                    },
                    {
                        key: "checkMemoRequired",
                        value: (Wr = qr(Dr().m(function e(t) {
                            var r, n, o, i, a, u;
                            return Dr().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        if (t instanceof s.FeeBumpTransaction && (t = t.innerTransaction), "none" === t.memo.type) {
                                            e.n = 1;
                                            break;
                                        }
                                        return e.a(2);
                                    case 1:
                                        r = new Set, n = 0;
                                    case 2:
                                        if (!(n < t.operations.length)) {
                                            e.n = 14;
                                            break;
                                        }
                                        o = t.operations[n], a = o.type, e.n = "payment" === a || "pathPaymentStrictReceive" === a || "pathPaymentStrictSend" === a || "accountMerge" === a ? 3 : 4;
                                        break;
                                    case 3:
                                        return e.a(3, 5);
                                    case 4:
                                        return e.a(3, 13);
                                    case 5:
                                        if (i = o.destination, !r.has(i)) {
                                            e.n = 6;
                                            break;
                                        }
                                        return e.a(3, 13);
                                    case 6:
                                        if (r.add(i), !i.startsWith("M")) {
                                            e.n = 7;
                                            break;
                                        }
                                        return e.a(3, 13);
                                    case 7:
                                        return e.p = 7, e.n = 8, this.loadAccount(i);
                                    case 8:
                                        if ("MQ==" !== e.v.data_attr["config.memo_required"]) {
                                            e.n = 9;
                                            break;
                                        }
                                        throw new D.Cu("account requires memo", i, n);
                                    case 9:
                                        e.n = 13;
                                        break;
                                    case 10:
                                        if (e.p = 10, !((u = e.v) instanceof D.Cu)) {
                                            e.n = 11;
                                            break;
                                        }
                                        throw u;
                                    case 11:
                                        if (u instanceof D.m_) {
                                            e.n = 12;
                                            break;
                                        }
                                        throw u;
                                    case 12:
                                        return e.a(3, 13);
                                    case 13:
                                        n += 1, e.n = 2;
                                        break;
                                    case 14:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    7,
                                    10
                                ]
                            ]);
                        })), function(e) {
                            return Wr.apply(this, arguments);
                        })
                    }
                ]);
                const tn = (e = r.hmd(e)).exports;
            },
            6121 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    axiosClient: ()=>Et,
                    create: ()=>Tt
                });
                var n = {};
                function o(e, t) {
                    return function() {
                        return e.apply(t, arguments);
                    };
                }
                r.r(n), r.d(n, {
                    hasBrowserEnv: ()=>he,
                    hasStandardBrowserEnv: ()=>me,
                    hasStandardBrowserWebWorkerEnv: ()=>ge,
                    navigator: ()=>ye,
                    origin: ()=>ve
                });
                const { toString: i } = Object.prototype, { getPrototypeOf: a } = Object, { iterator: s, toStringTag: u } = Symbol, c = (l = Object.create(null), (e)=>{
                    const t = i.call(e);
                    return l[t] || (l[t] = t.slice(8, -1).toLowerCase());
                });
                var l;
                const f = (e)=>(e = e.toLowerCase(), (t)=>c(t) === e), p = (e)=>(t)=>typeof t === e, { isArray: d } = Array, h = p("undefined");
                function y(e) {
                    return null !== e && !h(e) && null !== e.constructor && !h(e.constructor) && v(e.constructor.isBuffer) && e.constructor.isBuffer(e);
                }
                const m = f("ArrayBuffer");
                const g = p("string"), v = p("function"), b = p("number"), w = (e)=>null !== e && "object" == typeof e, S = (e)=>{
                    if ("object" !== c(e)) return !1;
                    const t = a(e);
                    return !(null !== t && t !== Object.prototype && null !== Object.getPrototypeOf(t) || u in e || s in e);
                }, A = f("Date"), E = f("File"), T = f("Blob"), O = f("FileList");
                const k = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r.g ? r.g : {}, _ = void 0 !== k.FormData ? k.FormData : void 0, x = f("URLSearchParams"), [P, R, I, B] = [
                    "ReadableStream",
                    "Request",
                    "Response",
                    "Headers"
                ].map(f);
                function C(e, t, { allOwnKeys: r = !1 } = {}) {
                    if (null == e) return;
                    let n, o;
                    if ("object" != typeof e && (e = [
                        e
                    ]), d(e)) for(n = 0, o = e.length; n < o; n++)t.call(null, e[n], n, e);
                    else {
                        if (y(e)) return;
                        const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
                        let a;
                        for(n = 0; n < i; n++)a = o[n], t.call(null, e[a], a, e);
                    }
                }
                function j(e, t) {
                    if (y(e)) return null;
                    t = t.toLowerCase();
                    const r = Object.keys(e);
                    let n, o = r.length;
                    for(; o-- > 0;)if (n = r[o], t === n.toLowerCase()) return n;
                    return null;
                }
                const U = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : r.g, N = (e)=>!h(e) && e !== U;
                const L = (F = "undefined" != typeof Uint8Array && a(Uint8Array), (e)=>F && e instanceof F);
                var F;
                const D = f("HTMLFormElement"), M = (({ hasOwnProperty: e })=>(t, r)=>e.call(t, r))(Object.prototype), V = f("RegExp"), q = (e, t)=>{
                    const r = Object.getOwnPropertyDescriptors(e), n = {};
                    C(r, (r, o)=>{
                        let i;
                        !1 !== (i = t(r, o, e)) && (n[o] = i || r);
                    }), Object.defineProperties(e, n);
                };
                const G = f("AsyncFunction"), H = (z = "function" == typeof setImmediate, W = v(U.postMessage), z ? setImmediate : W ? (X = `axios@${Math.random()}`, K = [], U.addEventListener("message", ({ source: e, data: t })=>{
                    e === U && t === X && K.length && K.shift()();
                }, !1), (e)=>{
                    K.push(e), U.postMessage(X, "*");
                }) : (e)=>setTimeout(e));
                var z, W, X, K;
                const Z = "undefined" != typeof queueMicrotask ? queueMicrotask.bind(U) : H, $ = {
                    isArray: d,
                    isArrayBuffer: m,
                    isBuffer: y,
                    isFormData: (e)=>{
                        let t;
                        return e && (_ && e instanceof _ || v(e.append) && ("formdata" === (t = c(e)) || "object" === t && v(e.toString) && "[object FormData]" === e.toString()));
                    },
                    isArrayBufferView: function(e) {
                        let t;
                        return t = "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && m(e.buffer), t;
                    },
                    isString: g,
                    isNumber: b,
                    isBoolean: (e)=>!0 === e || !1 === e,
                    isObject: w,
                    isPlainObject: S,
                    isEmptyObject: (e)=>{
                        if (!w(e) || y(e)) return !1;
                        try {
                            return 0 === Object.keys(e).length && Object.getPrototypeOf(e) === Object.prototype;
                        } catch (e) {
                            return !1;
                        }
                    },
                    isReadableStream: P,
                    isRequest: R,
                    isResponse: I,
                    isHeaders: B,
                    isUndefined: h,
                    isDate: A,
                    isFile: E,
                    isReactNativeBlob: (e)=>!(!e || void 0 === e.uri),
                    isReactNative: (e)=>e && void 0 !== e.getParts,
                    isBlob: T,
                    isRegExp: V,
                    isFunction: v,
                    isStream: (e)=>w(e) && v(e.pipe),
                    isURLSearchParams: x,
                    isTypedArray: L,
                    isFileList: O,
                    forEach: C,
                    merge: function e() {
                        const { caseless: t, skipUndefined: r } = N(this) && this || {}, n = {}, o = (o, i)=>{
                            if ("__proto__" === i || "constructor" === i || "prototype" === i) return;
                            const a = t && j(n, i) || i;
                            S(n[a]) && S(o) ? n[a] = e(n[a], o) : S(o) ? n[a] = e({}, o) : d(o) ? n[a] = o.slice() : r && h(o) || (n[a] = o);
                        };
                        for(let e = 0, t = arguments.length; e < t; e++)arguments[e] && C(arguments[e], o);
                        return n;
                    },
                    extend: (e, t, r, { allOwnKeys: n } = {})=>(C(t, (t, n)=>{
                            r && v(t) ? Object.defineProperty(e, n, {
                                value: o(t, r),
                                writable: !0,
                                enumerable: !0,
                                configurable: !0
                            }) : Object.defineProperty(e, n, {
                                value: t,
                                writable: !0,
                                enumerable: !0,
                                configurable: !0
                            });
                        }, {
                            allOwnKeys: n
                        }), e),
                    trim: (e)=>e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""),
                    stripBOM: (e)=>(65279 === e.charCodeAt(0) && (e = e.slice(1)), e),
                    inherits: (e, t, r, n)=>{
                        e.prototype = Object.create(t.prototype, n), Object.defineProperty(e.prototype, "constructor", {
                            value: e,
                            writable: !0,
                            enumerable: !1,
                            configurable: !0
                        }), Object.defineProperty(e, "super", {
                            value: t.prototype
                        }), r && Object.assign(e.prototype, r);
                    },
                    toFlatObject: (e, t, r, n)=>{
                        let o, i, s;
                        const u = {};
                        if (t = t || {}, null == e) return t;
                        do {
                            for(o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0;)s = o[i], n && !n(s, e, t) || u[s] || (t[s] = e[s], u[s] = !0);
                            e = !1 !== r && a(e);
                        }while (e && (!r || r(e, t)) && e !== Object.prototype);
                        return t;
                    },
                    kindOf: c,
                    kindOfTest: f,
                    endsWith: (e, t, r)=>{
                        e = String(e), (void 0 === r || r > e.length) && (r = e.length), r -= t.length;
                        const n = e.indexOf(t, r);
                        return -1 !== n && n === r;
                    },
                    toArray: (e)=>{
                        if (!e) return null;
                        if (d(e)) return e;
                        let t = e.length;
                        if (!b(t)) return null;
                        const r = new Array(t);
                        for(; t-- > 0;)r[t] = e[t];
                        return r;
                    },
                    forEachEntry: (e, t)=>{
                        const r = (e && e[s]).call(e);
                        let n;
                        for(; (n = r.next()) && !n.done;){
                            const r = n.value;
                            t.call(e, r[0], r[1]);
                        }
                    },
                    matchAll: (e, t)=>{
                        let r;
                        const n = [];
                        for(; null !== (r = e.exec(t));)n.push(r);
                        return n;
                    },
                    isHTMLForm: D,
                    hasOwnProperty: M,
                    hasOwnProp: M,
                    reduceDescriptors: q,
                    freezeMethods: (e)=>{
                        q(e, (t, r)=>{
                            if (v(e) && -1 !== [
                                "arguments",
                                "caller",
                                "callee"
                            ].indexOf(r)) return !1;
                            const n = e[r];
                            v(n) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = ()=>{
                                throw Error("Can not rewrite read-only method '" + r + "'");
                            }));
                        });
                    },
                    toObjectSet: (e, t)=>{
                        const r = {}, n = (e)=>{
                            e.forEach((e)=>{
                                r[e] = !0;
                            });
                        };
                        return d(e) ? n(e) : n(String(e).split(t)), r;
                    },
                    toCamelCase: (e)=>e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, r) {
                            return t.toUpperCase() + r;
                        }),
                    noop: ()=>{},
                    toFiniteNumber: (e, t)=>null != e && Number.isFinite(e = +e) ? e : t,
                    findKey: j,
                    global: U,
                    isContextDefined: N,
                    isSpecCompliantForm: function(e) {
                        return !!(e && v(e.append) && "FormData" === e[u] && e[s]);
                    },
                    toJSONObject: (e)=>{
                        const t = new Array(10), r = (e, n)=>{
                            if (w(e)) {
                                if (t.indexOf(e) >= 0) return;
                                if (y(e)) return e;
                                if (!("toJSON" in e)) {
                                    t[n] = e;
                                    const o = d(e) ? [] : {};
                                    return C(e, (e, t)=>{
                                        const i = r(e, n + 1);
                                        !h(i) && (o[t] = i);
                                    }), t[n] = void 0, o;
                                }
                            }
                            return e;
                        };
                        return r(e, 0);
                    },
                    isAsyncFn: G,
                    isThenable: (e)=>e && (w(e) || v(e)) && v(e.then) && v(e.catch),
                    setImmediate: H,
                    asap: Z,
                    isIterable: (e)=>null != e && v(e[s])
                };
                class Y extends Error {
                    static from(e, t, r, n, o, i) {
                        const a = new Y(e.message, t || e.code, r, n, o);
                        return a.cause = e, a.name = e.name, null != e.status && null == a.status && (a.status = e.status), i && Object.assign(a, i), a;
                    }
                    constructor(e, t, r, n, o){
                        super(e), Object.defineProperty(this, "message", {
                            value: e,
                            enumerable: !0,
                            writable: !0,
                            configurable: !0
                        }), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status);
                    }
                    toJSON() {
                        return {
                            message: this.message,
                            name: this.name,
                            description: this.description,
                            number: this.number,
                            fileName: this.fileName,
                            lineNumber: this.lineNumber,
                            columnNumber: this.columnNumber,
                            stack: this.stack,
                            config: $.toJSONObject(this.config),
                            code: this.code,
                            status: this.status
                        };
                    }
                }
                Y.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", Y.ERR_BAD_OPTION = "ERR_BAD_OPTION", Y.ECONNABORTED = "ECONNABORTED", Y.ETIMEDOUT = "ETIMEDOUT", Y.ERR_NETWORK = "ERR_NETWORK", Y.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", Y.ERR_DEPRECATED = "ERR_DEPRECATED", Y.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", Y.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", Y.ERR_CANCELED = "ERR_CANCELED", Y.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", Y.ERR_INVALID_URL = "ERR_INVALID_URL";
                const Q = Y;
                var J = r(8287).Buffer;
                function ee(e) {
                    return $.isPlainObject(e) || $.isArray(e);
                }
                function te(e) {
                    return $.endsWith(e, "[]") ? e.slice(0, -2) : e;
                }
                function re(e, t, r) {
                    return e ? e.concat(t).map(function(e, t) {
                        return e = te(e), !r && t ? "[" + e + "]" : e;
                    }).join(r ? "." : "") : t;
                }
                const ne = $.toFlatObject($, {}, null, function(e) {
                    return /^is[A-Z]/.test(e);
                });
                const oe = function(e, t, r) {
                    if (!$.isObject(e)) throw new TypeError("target must be an object");
                    t = t || new FormData;
                    const n = (r = $.toFlatObject(r, {
                        metaTokens: !0,
                        dots: !1,
                        indexes: !1
                    }, !1, function(e, t) {
                        return !$.isUndefined(t[e]);
                    })).metaTokens, o = r.visitor || c, i = r.dots, a = r.indexes, s = (r.Blob || "undefined" != typeof Blob && Blob) && $.isSpecCompliantForm(t);
                    if (!$.isFunction(o)) throw new TypeError("visitor must be a function");
                    function u(e) {
                        if (null === e) return "";
                        if ($.isDate(e)) return e.toISOString();
                        if ($.isBoolean(e)) return e.toString();
                        if (!s && $.isBlob(e)) throw new Q("Blob is not supported. Use a Buffer instead.");
                        return $.isArrayBuffer(e) || $.isTypedArray(e) ? s && "function" == typeof Blob ? new Blob([
                            e
                        ]) : J.from(e) : e;
                    }
                    function c(e, r, o) {
                        let s = e;
                        if ($.isReactNative(t) && $.isReactNativeBlob(e)) return t.append(re(o, r, i), u(e)), !1;
                        if (e && !o && "object" == typeof e) {
                            if ($.endsWith(r, "{}")) r = n ? r : r.slice(0, -2), e = JSON.stringify(e);
                            else if ($.isArray(e) && function(e) {
                                return $.isArray(e) && !e.some(ee);
                            }(e) || ($.isFileList(e) || $.endsWith(r, "[]")) && (s = $.toArray(e))) return r = te(r), s.forEach(function(e, n) {
                                !$.isUndefined(e) && null !== e && t.append(!0 === a ? re([
                                    r
                                ], n, i) : null === a ? r : r + "[]", u(e));
                            }), !1;
                        }
                        return !!ee(e) || (t.append(re(o, r, i), u(e)), !1);
                    }
                    const l = [], f = Object.assign(ne, {
                        defaultVisitor: c,
                        convertValue: u,
                        isVisitable: ee
                    });
                    if (!$.isObject(e)) throw new TypeError("data must be an object");
                    return function e(r, n) {
                        if (!$.isUndefined(r)) {
                            if (-1 !== l.indexOf(r)) throw Error("Circular reference detected in " + n.join("."));
                            l.push(r), $.forEach(r, function(r, i) {
                                !0 === (!($.isUndefined(r) || null === r) && o.call(t, r, $.isString(i) ? i.trim() : i, n, f)) && e(r, n ? n.concat(i) : [
                                    i
                                ]);
                            }), l.pop();
                        }
                    }(e), t;
                };
                function ie(e) {
                    const t = {
                        "!": "%21",
                        "'": "%27",
                        "(": "%28",
                        ")": "%29",
                        "~": "%7E",
                        "%20": "+",
                        "%00": "\0"
                    };
                    return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(e) {
                        return t[e];
                    });
                }
                function ae(e, t) {
                    this._pairs = [], e && oe(e, this, t);
                }
                const se = ae.prototype;
                se.append = function(e, t) {
                    this._pairs.push([
                        e,
                        t
                    ]);
                }, se.toString = function(e) {
                    const t = e ? function(t) {
                        return e.call(this, t, ie);
                    } : ie;
                    return this._pairs.map(function(e) {
                        return t(e[0]) + "=" + t(e[1]);
                    }, "").join("&");
                };
                const ue = ae;
                function ce(e) {
                    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
                }
                function le(e, t, r) {
                    if (!t) return e;
                    const n = r && r.encode || ce, o = $.isFunction(r) ? {
                        serialize: r
                    } : r, i = o && o.serialize;
                    let a;
                    if (a = i ? i(t, o) : $.isURLSearchParams(t) ? t.toString() : new ue(t, o).toString(n), a) {
                        const t = e.indexOf("#");
                        -1 !== t && (e = e.slice(0, t)), e += (-1 === e.indexOf("?") ? "?" : "&") + a;
                    }
                    return e;
                }
                const fe = class {
                    constructor(){
                        this.handlers = [];
                    }
                    use(e, t, r) {
                        return this.handlers.push({
                            fulfilled: e,
                            rejected: t,
                            synchronous: !!r && r.synchronous,
                            runWhen: r ? r.runWhen : null
                        }), this.handlers.length - 1;
                    }
                    eject(e) {
                        this.handlers[e] && (this.handlers[e] = null);
                    }
                    clear() {
                        this.handlers && (this.handlers = []);
                    }
                    forEach(e) {
                        $.forEach(this.handlers, function(t) {
                            null !== t && e(t);
                        });
                    }
                }, pe = {
                    silentJSONParsing: !0,
                    forcedJSONParsing: !0,
                    clarifyTimeoutError: !1,
                    legacyInterceptorReqResOrdering: !0
                }, de = {
                    isBrowser: !0,
                    classes: {
                        URLSearchParams: "undefined" != typeof URLSearchParams ? URLSearchParams : ue,
                        FormData: "undefined" != typeof FormData ? FormData : null,
                        Blob: "undefined" != typeof Blob ? Blob : null
                    },
                    protocols: [
                        "http",
                        "https",
                        "file",
                        "blob",
                        "url",
                        "data"
                    ]
                }, he = "undefined" != typeof window && "undefined" != typeof document, ye = "object" == typeof navigator && navigator || void 0, me = he && (!ye || [
                    "ReactNative",
                    "NativeScript",
                    "NS"
                ].indexOf(ye.product) < 0), ge = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && "function" == typeof self.importScripts, ve = he && window.location.href || "http://localhost", be = {
                    ...n,
                    ...de
                };
                const we = function(e) {
                    function t(e, r, n, o) {
                        let i = e[o++];
                        if ("__proto__" === i) return !0;
                        const a = Number.isFinite(+i), s = o >= e.length;
                        if (i = !i && $.isArray(n) ? n.length : i, s) return $.hasOwnProp(n, i) ? n[i] = [
                            n[i],
                            r
                        ] : n[i] = r, !a;
                        n[i] && $.isObject(n[i]) || (n[i] = []);
                        return t(e, r, n[i], o) && $.isArray(n[i]) && (n[i] = function(e) {
                            const t = {}, r = Object.keys(e);
                            let n;
                            const o = r.length;
                            let i;
                            for(n = 0; n < o; n++)i = r[n], t[i] = e[i];
                            return t;
                        }(n[i])), !a;
                    }
                    if ($.isFormData(e) && $.isFunction(e.entries)) {
                        const r = {};
                        return $.forEachEntry(e, (e, n)=>{
                            t(function(e) {
                                return $.matchAll(/\w+|\[(\w*)]/g, e).map((e)=>"[]" === e[0] ? "" : e[1] || e[0]);
                            }(e), n, r, 0);
                        }), r;
                    }
                    return null;
                };
                const Se = {
                    transitional: pe,
                    adapter: [
                        "xhr",
                        "http",
                        "fetch"
                    ],
                    transformRequest: [
                        function(e, t) {
                            const r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = $.isObject(e);
                            o && $.isHTMLForm(e) && (e = new FormData(e));
                            if ($.isFormData(e)) return n ? JSON.stringify(we(e)) : e;
                            if ($.isArrayBuffer(e) || $.isBuffer(e) || $.isStream(e) || $.isFile(e) || $.isBlob(e) || $.isReadableStream(e)) return e;
                            if ($.isArrayBufferView(e)) return e.buffer;
                            if ($.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
                            let i;
                            if (o) {
                                if (r.indexOf("application/x-www-form-urlencoded") > -1) return (function(e, t) {
                                    return oe(e, new be.classes.URLSearchParams, {
                                        visitor: function(e, t, r, n) {
                                            return be.isNode && $.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : n.defaultVisitor.apply(this, arguments);
                                        },
                                        ...t
                                    });
                                })(e, this.formSerializer).toString();
                                if ((i = $.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
                                    const t = this.env && this.env.FormData;
                                    return oe(i ? {
                                        "files[]": e
                                    } : e, t && new t, this.formSerializer);
                                }
                            }
                            return o || n ? (t.setContentType("application/json", !1), function(e, t, r) {
                                if ($.isString(e)) try {
                                    return (t || JSON.parse)(e), $.trim(e);
                                } catch (e) {
                                    if ("SyntaxError" !== e.name) throw e;
                                }
                                return (r || JSON.stringify)(e);
                            }(e)) : e;
                        }
                    ],
                    transformResponse: [
                        function(e) {
                            const t = this.transitional || Se.transitional, r = t && t.forcedJSONParsing, n = "json" === this.responseType;
                            if ($.isResponse(e) || $.isReadableStream(e)) return e;
                            if (e && $.isString(e) && (r && !this.responseType || n)) {
                                const r = !(t && t.silentJSONParsing) && n;
                                try {
                                    return JSON.parse(e, this.parseReviver);
                                } catch (e) {
                                    if (r) {
                                        if ("SyntaxError" === e.name) throw Q.from(e, Q.ERR_BAD_RESPONSE, this, null, this.response);
                                        throw e;
                                    }
                                }
                            }
                            return e;
                        }
                    ],
                    timeout: 0,
                    xsrfCookieName: "XSRF-TOKEN",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    env: {
                        FormData: be.classes.FormData,
                        Blob: be.classes.Blob
                    },
                    validateStatus: function(e) {
                        return e >= 200 && e < 300;
                    },
                    headers: {
                        common: {
                            Accept: "application/json, text/plain, */*",
                            "Content-Type": void 0
                        }
                    }
                };
                $.forEach([
                    "delete",
                    "get",
                    "head",
                    "post",
                    "put",
                    "patch"
                ], (e)=>{
                    Se.headers[e] = {};
                });
                const Ae = Se, Ee = $.toObjectSet([
                    "age",
                    "authorization",
                    "content-length",
                    "content-type",
                    "etag",
                    "expires",
                    "from",
                    "host",
                    "if-modified-since",
                    "if-unmodified-since",
                    "last-modified",
                    "location",
                    "max-forwards",
                    "proxy-authorization",
                    "referer",
                    "retry-after",
                    "user-agent"
                ]), Te = Symbol("internals");
                function Oe(e, t) {
                    if (!1 !== e && null != e) {
                        if ($.isArray(e)) e.forEach((e)=>Oe(e, t));
                        else if (!((e)=>!/[\r\n]/.test(e))(String(e))) throw new Error(`Invalid character in header content ["${t}"]`);
                    }
                }
                function ke(e) {
                    return e && String(e).trim().toLowerCase();
                }
                function _e(e) {
                    return !1 === e || null == e ? e : $.isArray(e) ? e.map(_e) : function(e) {
                        let t = e.length;
                        for(; t > 0;){
                            const r = e.charCodeAt(t - 1);
                            if (10 !== r && 13 !== r) break;
                            t -= 1;
                        }
                        return t === e.length ? e : e.slice(0, t);
                    }(String(e));
                }
                function xe(e, t, r, n, o) {
                    return $.isFunction(n) ? n.call(this, t, r) : (o && (t = r), $.isString(t) ? $.isString(n) ? -1 !== t.indexOf(n) : $.isRegExp(n) ? n.test(t) : void 0 : void 0);
                }
                class Pe {
                    constructor(e){
                        e && this.set(e);
                    }
                    set(e, t, r) {
                        const n = this;
                        function o(e, t, r) {
                            const o = ke(t);
                            if (!o) throw new Error("header name must be a non-empty string");
                            const i = $.findKey(n, o);
                            (!i || void 0 === n[i] || !0 === r || void 0 === r && !1 !== n[i]) && (Oe(e, t), n[i || t] = _e(e));
                        }
                        const i = (e, t)=>$.forEach(e, (e, r)=>o(e, r, t));
                        if ($.isPlainObject(e) || e instanceof this.constructor) i(e, t);
                        else if ($.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) i(((e)=>{
                            const t = {};
                            let r, n, o;
                            return e && e.split("\n").forEach(function(e) {
                                o = e.indexOf(":"), r = e.substring(0, o).trim().toLowerCase(), n = e.substring(o + 1).trim(), !r || t[r] && Ee[r] || ("set-cookie" === r ? t[r] ? t[r].push(n) : t[r] = [
                                    n
                                ] : t[r] = t[r] ? t[r] + ", " + n : n);
                            }), t;
                        })(e), t);
                        else if ($.isObject(e) && $.isIterable(e)) {
                            let r, n, o = {};
                            for (const t of e){
                                if (!$.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
                                o[n = t[0]] = (r = o[n]) ? $.isArray(r) ? [
                                    ...r,
                                    t[1]
                                ] : [
                                    r,
                                    t[1]
                                ] : t[1];
                            }
                            i(o, t);
                        } else null != e && o(t, e, r);
                        return this;
                    }
                    get(e, t) {
                        if (e = ke(e)) {
                            const r = $.findKey(this, e);
                            if (r) {
                                const e = this[r];
                                if (!t) return e;
                                if (!0 === t) return function(e) {
                                    const t = Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                                    let n;
                                    for(; n = r.exec(e);)t[n[1]] = n[2];
                                    return t;
                                }(e);
                                if ($.isFunction(t)) return t.call(this, e, r);
                                if ($.isRegExp(t)) return t.exec(e);
                                throw new TypeError("parser must be boolean|regexp|function");
                            }
                        }
                    }
                    has(e, t) {
                        if (e = ke(e)) {
                            const r = $.findKey(this, e);
                            return !(!r || void 0 === this[r] || t && !xe(0, this[r], r, t));
                        }
                        return !1;
                    }
                    delete(e, t) {
                        const r = this;
                        let n = !1;
                        function o(e) {
                            if (e = ke(e)) {
                                const o = $.findKey(r, e);
                                !o || t && !xe(0, r[o], o, t) || (delete r[o], n = !0);
                            }
                        }
                        return $.isArray(e) ? e.forEach(o) : o(e), n;
                    }
                    clear(e) {
                        const t = Object.keys(this);
                        let r = t.length, n = !1;
                        for(; r--;){
                            const o = t[r];
                            e && !xe(0, this[o], o, e, !0) || (delete this[o], n = !0);
                        }
                        return n;
                    }
                    normalize(e) {
                        const t = this, r = {};
                        return $.forEach(this, (n, o)=>{
                            const i = $.findKey(r, o);
                            if (i) return t[i] = _e(n), void delete t[o];
                            const a = e ? function(e) {
                                return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, r)=>t.toUpperCase() + r);
                            }(o) : String(o).trim();
                            a !== o && delete t[o], t[a] = _e(n), r[a] = !0;
                        }), this;
                    }
                    concat(...e) {
                        return this.constructor.concat(this, ...e);
                    }
                    toJSON(e) {
                        const t = Object.create(null);
                        return $.forEach(this, (r, n)=>{
                            null != r && !1 !== r && (t[n] = e && $.isArray(r) ? r.join(", ") : r);
                        }), t;
                    }
                    [Symbol.iterator]() {
                        return Object.entries(this.toJSON())[Symbol.iterator]();
                    }
                    toString() {
                        return Object.entries(this.toJSON()).map(([e, t])=>e + ": " + t).join("\n");
                    }
                    getSetCookie() {
                        return this.get("set-cookie") || [];
                    }
                    get [Symbol.toStringTag]() {
                        return "AxiosHeaders";
                    }
                    static from(e) {
                        return e instanceof this ? e : new this(e);
                    }
                    static concat(e, ...t) {
                        const r = new this(e);
                        return t.forEach((e)=>r.set(e)), r;
                    }
                    static accessor(e) {
                        const t = (this[Te] = this[Te] = {
                            accessors: {}
                        }).accessors, r = this.prototype;
                        function n(e) {
                            const n = ke(e);
                            t[n] || (!function(e, t) {
                                const r = $.toCamelCase(" " + t);
                                [
                                    "get",
                                    "set",
                                    "has"
                                ].forEach((n)=>{
                                    Object.defineProperty(e, n + r, {
                                        value: function(e, r, o) {
                                            return this[n].call(this, t, e, r, o);
                                        },
                                        configurable: !0
                                    });
                                });
                            }(r, e), t[n] = !0);
                        }
                        return $.isArray(e) ? e.forEach(n) : n(e), this;
                    }
                }
                Pe.accessor([
                    "Content-Type",
                    "Content-Length",
                    "Accept",
                    "Accept-Encoding",
                    "User-Agent",
                    "Authorization"
                ]), $.reduceDescriptors(Pe.prototype, ({ value: e }, t)=>{
                    let r = t[0].toUpperCase() + t.slice(1);
                    return {
                        get: ()=>e,
                        set (e) {
                            this[r] = e;
                        }
                    };
                }), $.freezeMethods(Pe);
                const Re = Pe;
                function Ie(e, t) {
                    const r = this || Ae, n = t || r, o = Re.from(n.headers);
                    let i = n.data;
                    return $.forEach(e, function(e) {
                        i = e.call(r, i, o.normalize(), t ? t.status : void 0);
                    }), o.normalize(), i;
                }
                function Be(e) {
                    return !(!e || !e.__CANCEL__);
                }
                const Ce = class extends Q {
                    constructor(e, t, r){
                        super(null == e ? "canceled" : e, Q.ERR_CANCELED, t, r), this.name = "CanceledError", this.__CANCEL__ = !0;
                    }
                };
                function je(e, t, r) {
                    const n = r.config.validateStatus;
                    r.status && n && !n(r.status) ? t(new Q("Request failed with status code " + r.status, [
                        Q.ERR_BAD_REQUEST,
                        Q.ERR_BAD_RESPONSE
                    ][Math.floor(r.status / 100) - 4], r.config, r.request, r)) : e(r);
                }
                const Ue = function(e, t) {
                    e = e || 10;
                    const r = new Array(e), n = new Array(e);
                    let o, i = 0, a = 0;
                    return t = void 0 !== t ? t : 1e3, function(s) {
                        const u = Date.now(), c = n[a];
                        o || (o = u), r[i] = s, n[i] = u;
                        let l = a, f = 0;
                        for(; l !== i;)f += r[l++], l %= e;
                        if (i = (i + 1) % e, i === a && (a = (a + 1) % e), u - o < t) return;
                        const p = c && u - c;
                        return p ? Math.round(1e3 * f / p) : void 0;
                    };
                };
                const Ne = function(e, t) {
                    let r, n, o = 0, i = 1e3 / t;
                    const a = (t, i = Date.now())=>{
                        o = i, r = null, n && (clearTimeout(n), n = null), e(...t);
                    };
                    return [
                        (...e)=>{
                            const t = Date.now(), s = t - o;
                            s >= i ? a(e, t) : (r = e, n || (n = setTimeout(()=>{
                                n = null, a(r);
                            }, i - s)));
                        },
                        ()=>r && a(r)
                    ];
                }, Le = (e, t, r = 3)=>{
                    let n = 0;
                    const o = Ue(50, 250);
                    return Ne((r)=>{
                        const i = r.loaded, a = r.lengthComputable ? r.total : void 0, s = i - n, u = o(s);
                        n = i;
                        e({
                            loaded: i,
                            total: a,
                            progress: a ? i / a : void 0,
                            bytes: s,
                            rate: u || void 0,
                            estimated: u && a && i <= a ? (a - i) / u : void 0,
                            event: r,
                            lengthComputable: null != a,
                            [t ? "download" : "upload"]: !0
                        });
                    }, r);
                }, Fe = (e, t)=>{
                    const r = null != e;
                    return [
                        (n)=>t[0]({
                                lengthComputable: r,
                                total: e,
                                loaded: n
                            }),
                        t[1]
                    ];
                }, De = (e)=>(...t)=>$.asap(()=>e(...t)), Me = be.hasStandardBrowserEnv ? ((e, t)=>(r)=>(r = new URL(r, be.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(new URL(be.origin), be.navigator && /(msie|trident)/i.test(be.navigator.userAgent)) : ()=>!0, Ve = be.hasStandardBrowserEnv ? {
                    write (e, t, r, n, o, i, a) {
                        if ("undefined" == typeof document) return;
                        const s = [
                            `${e}=${encodeURIComponent(t)}`
                        ];
                        $.isNumber(r) && s.push(`expires=${new Date(r).toUTCString()}`), $.isString(n) && s.push(`path=${n}`), $.isString(o) && s.push(`domain=${o}`), !0 === i && s.push("secure"), $.isString(a) && s.push(`SameSite=${a}`), document.cookie = s.join("; ");
                    },
                    read (e) {
                        if ("undefined" == typeof document) return null;
                        const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
                        return t ? decodeURIComponent(t[1]) : null;
                    },
                    remove (e) {
                        this.write(e, "", Date.now() - 864e5, "/");
                    }
                } : {
                    write () {},
                    read: ()=>null,
                    remove () {}
                };
                function qe(e, t, r) {
                    let n = !("string" == typeof (o = t) && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(o));
                    var o;
                    return e && (n || 0 == r) ? function(e, t) {
                        return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
                    }(e, t) : t;
                }
                const Ge = (e)=>e instanceof Re ? {
                        ...e
                    } : e;
                function He(e, t) {
                    t = t || {};
                    const r = {};
                    function n(e, t, r, n) {
                        return $.isPlainObject(e) && $.isPlainObject(t) ? $.merge.call({
                            caseless: n
                        }, e, t) : $.isPlainObject(t) ? $.merge({}, t) : $.isArray(t) ? t.slice() : t;
                    }
                    function o(e, t, r, o) {
                        return $.isUndefined(t) ? $.isUndefined(e) ? void 0 : n(void 0, e, 0, o) : n(e, t, 0, o);
                    }
                    function i(e, t) {
                        if (!$.isUndefined(t)) return n(void 0, t);
                    }
                    function a(e, t) {
                        return $.isUndefined(t) ? $.isUndefined(e) ? void 0 : n(void 0, e) : n(void 0, t);
                    }
                    function s(r, o, i) {
                        return i in t ? n(r, o) : i in e ? n(void 0, r) : void 0;
                    }
                    const u = {
                        url: i,
                        method: i,
                        data: i,
                        baseURL: a,
                        transformRequest: a,
                        transformResponse: a,
                        paramsSerializer: a,
                        timeout: a,
                        timeoutMessage: a,
                        withCredentials: a,
                        withXSRFToken: a,
                        adapter: a,
                        responseType: a,
                        xsrfCookieName: a,
                        xsrfHeaderName: a,
                        onUploadProgress: a,
                        onDownloadProgress: a,
                        decompress: a,
                        maxContentLength: a,
                        maxBodyLength: a,
                        beforeRedirect: a,
                        transport: a,
                        httpAgent: a,
                        httpsAgent: a,
                        cancelToken: a,
                        socketPath: a,
                        responseEncoding: a,
                        validateStatus: s,
                        headers: (e, t, r)=>o(Ge(e), Ge(t), 0, !0)
                    };
                    return $.forEach(Object.keys({
                        ...e,
                        ...t
                    }), function(n) {
                        if ("__proto__" === n || "constructor" === n || "prototype" === n) return;
                        const i = $.hasOwnProp(u, n) ? u[n] : o, a = i(e[n], t[n], n);
                        $.isUndefined(a) && i !== s || (r[n] = a);
                    }), r;
                }
                const ze = (e)=>{
                    const t = He({}, e);
                    let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: s } = t;
                    if (t.headers = a = Re.from(a), t.url = le(qe(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && a.set("Authorization", "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))), $.isFormData(r)) {
                        if (be.hasStandardBrowserEnv || be.hasStandardBrowserWebWorkerEnv) a.setContentType(void 0);
                        else if ($.isFunction(r.getHeaders)) {
                            const e = r.getHeaders(), t = [
                                "content-type",
                                "content-length"
                            ];
                            Object.entries(e).forEach(([e, r])=>{
                                t.includes(e.toLowerCase()) && a.set(e, r);
                            });
                        }
                    }
                    if (be.hasStandardBrowserEnv && (n && $.isFunction(n) && (n = n(t)), n || !1 !== n && Me(t.url))) {
                        const e = o && i && Ve.read(i);
                        e && a.set(o, e);
                    }
                    return t;
                }, We = "undefined" != typeof XMLHttpRequest && function(e) {
                    return new Promise(function(t, r) {
                        const n = ze(e);
                        let o = n.data;
                        const i = Re.from(n.headers).normalize();
                        let a, s, u, c, l, { responseType: f, onUploadProgress: p, onDownloadProgress: d } = n;
                        function h() {
                            c && c(), l && l(), n.cancelToken && n.cancelToken.unsubscribe(a), n.signal && n.signal.removeEventListener("abort", a);
                        }
                        let y = new XMLHttpRequest;
                        function m() {
                            if (!y) return;
                            const n = Re.from("getAllResponseHeaders" in y && y.getAllResponseHeaders());
                            je(function(e) {
                                t(e), h();
                            }, function(e) {
                                r(e), h();
                            }, {
                                data: f && "text" !== f && "json" !== f ? y.response : y.responseText,
                                status: y.status,
                                statusText: y.statusText,
                                headers: n,
                                config: e,
                                request: y
                            }), y = null;
                        }
                        y.open(n.method.toUpperCase(), n.url, !0), y.timeout = n.timeout, "onloadend" in y ? y.onloadend = m : y.onreadystatechange = function() {
                            y && 4 === y.readyState && (0 !== y.status || y.responseURL && 0 === y.responseURL.indexOf("file:")) && setTimeout(m);
                        }, y.onabort = function() {
                            y && (r(new Q("Request aborted", Q.ECONNABORTED, e, y)), y = null);
                        }, y.onerror = function(t) {
                            const n = t && t.message ? t.message : "Network Error", o = new Q(n, Q.ERR_NETWORK, e, y);
                            o.event = t || null, r(o), y = null;
                        }, y.ontimeout = function() {
                            let t = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
                            const o = n.transitional || pe;
                            n.timeoutErrorMessage && (t = n.timeoutErrorMessage), r(new Q(t, o.clarifyTimeoutError ? Q.ETIMEDOUT : Q.ECONNABORTED, e, y)), y = null;
                        }, void 0 === o && i.setContentType(null), "setRequestHeader" in y && $.forEach(i.toJSON(), function(e, t) {
                            y.setRequestHeader(t, e);
                        }), $.isUndefined(n.withCredentials) || (y.withCredentials = !!n.withCredentials), f && "json" !== f && (y.responseType = n.responseType), d && ([u, l] = Le(d, !0), y.addEventListener("progress", u)), p && y.upload && ([s, c] = Le(p), y.upload.addEventListener("progress", s), y.upload.addEventListener("loadend", c)), (n.cancelToken || n.signal) && (a = (t)=>{
                            y && (r(!t || t.type ? new Ce(null, e, y) : t), y.abort(), y = null);
                        }, n.cancelToken && n.cancelToken.subscribe(a), n.signal && (n.signal.aborted ? a() : n.signal.addEventListener("abort", a)));
                        const g = function(e) {
                            const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
                            return t && t[1] || "";
                        }(n.url);
                        g && -1 === be.protocols.indexOf(g) ? r(new Q("Unsupported protocol " + g + ":", Q.ERR_BAD_REQUEST, e)) : y.send(o || null);
                    });
                }, Xe = (e, t)=>{
                    const { length: r } = e = e ? e.filter(Boolean) : [];
                    if (t || r) {
                        let r, n = new AbortController;
                        const o = function(e) {
                            if (!r) {
                                r = !0, a();
                                const t = e instanceof Error ? e : this.reason;
                                n.abort(t instanceof Q ? t : new Ce(t instanceof Error ? t.message : t));
                            }
                        };
                        let i = t && setTimeout(()=>{
                            i = null, o(new Q(`timeout of ${t}ms exceeded`, Q.ETIMEDOUT));
                        }, t);
                        const a = ()=>{
                            e && (i && clearTimeout(i), i = null, e.forEach((e)=>{
                                e.unsubscribe ? e.unsubscribe(o) : e.removeEventListener("abort", o);
                            }), e = null);
                        };
                        e.forEach((e)=>e.addEventListener("abort", o));
                        const { signal: s } = n;
                        return s.unsubscribe = ()=>$.asap(a), s;
                    }
                }, Ke = function*(e, t) {
                    let r = e.byteLength;
                    if (!t || r < t) return void (yield e);
                    let n, o = 0;
                    for(; o < r;)n = o + t, yield e.slice(o, n), o = n;
                }, Ze = async function*(e) {
                    if (e[Symbol.asyncIterator]) return void (yield* e);
                    const t = e.getReader();
                    try {
                        for(;;){
                            const { done: e, value: r } = await t.read();
                            if (e) break;
                            yield r;
                        }
                    } finally{
                        await t.cancel();
                    }
                }, $e = (e, t, r, n)=>{
                    const o = async function*(e, t) {
                        for await (const r of Ze(e))yield* Ke(r, t);
                    }(e, t);
                    let i, a = 0, s = (e)=>{
                        i || (i = !0, n && n(e));
                    };
                    return new ReadableStream({
                        async pull (e) {
                            try {
                                const { done: t, value: n } = await o.next();
                                if (t) return s(), void e.close();
                                let i = n.byteLength;
                                if (r) {
                                    let e = a += i;
                                    r(e);
                                }
                                e.enqueue(new Uint8Array(n));
                            } catch (e) {
                                throw s(e), e;
                            }
                        },
                        cancel: (e)=>(s(e), o.return())
                    }, {
                        highWaterMark: 2
                    });
                }, { isFunction: Ye } = $, Qe = (({ Request: e, Response: t })=>({
                        Request: e,
                        Response: t
                    }))($.global), { ReadableStream: Je, TextEncoder: et } = $.global, tt = (e, ...t)=>{
                    try {
                        return !!e(...t);
                    } catch (e) {
                        return !1;
                    }
                }, rt = (e)=>{
                    e = $.merge.call({
                        skipUndefined: !0
                    }, Qe, e);
                    const { fetch: t, Request: r, Response: n } = e, o = t ? Ye(t) : "function" == typeof fetch, i = Ye(r), a = Ye(n);
                    if (!o) return !1;
                    const s = o && Ye(Je), u = o && ("function" == typeof et ? (c = new et, (e)=>c.encode(e)) : async (e)=>new Uint8Array(await new r(e).arrayBuffer()));
                    var c;
                    const l = i && s && tt(()=>{
                        let e = !1;
                        const t = new Je, n = new r(be.origin, {
                            body: t,
                            method: "POST",
                            get duplex () {
                                return e = !0, "half";
                            }
                        }).headers.has("Content-Type");
                        return t.cancel(), e && !n;
                    }), f = a && s && tt(()=>$.isReadableStream(new n("").body)), p = {
                        stream: f && ((e)=>e.body)
                    };
                    o && [
                        "text",
                        "arrayBuffer",
                        "blob",
                        "formData",
                        "stream"
                    ].forEach((e)=>{
                        !p[e] && (p[e] = (t, r)=>{
                            let n = t && t[e];
                            if (n) return n.call(t);
                            throw new Q(`Response type '${e}' is not supported`, Q.ERR_NOT_SUPPORT, r);
                        });
                    });
                    const d = async (e, t)=>{
                        const n = $.toFiniteNumber(e.getContentLength());
                        return null == n ? (async (e)=>{
                            if (null == e) return 0;
                            if ($.isBlob(e)) return e.size;
                            if ($.isSpecCompliantForm(e)) {
                                const t = new r(be.origin, {
                                    method: "POST",
                                    body: e
                                });
                                return (await t.arrayBuffer()).byteLength;
                            }
                            return $.isArrayBufferView(e) || $.isArrayBuffer(e) ? e.byteLength : ($.isURLSearchParams(e) && (e += ""), $.isString(e) ? (await u(e)).byteLength : void 0);
                        })(t) : n;
                    };
                    return async (e)=>{
                        let { url: o, method: a, data: s, signal: u, cancelToken: c, timeout: h, onDownloadProgress: y, onUploadProgress: m, responseType: g, headers: v, withCredentials: b = "same-origin", fetchOptions: w } = ze(e), S = t || fetch;
                        g = g ? (g + "").toLowerCase() : "text";
                        let A = Xe([
                            u,
                            c && c.toAbortSignal()
                        ], h), E = null;
                        const T = A && A.unsubscribe && (()=>{
                            A.unsubscribe();
                        });
                        let O;
                        try {
                            if (m && l && "get" !== a && "head" !== a && 0 !== (O = await d(v, s))) {
                                let e, t = new r(o, {
                                    method: "POST",
                                    body: s,
                                    duplex: "half"
                                });
                                if ($.isFormData(s) && (e = t.headers.get("content-type")) && v.setContentType(e), t.body) {
                                    const [e, r] = Fe(O, Le(De(m)));
                                    s = $e(t.body, 65536, e, r);
                                }
                            }
                            $.isString(b) || (b = b ? "include" : "omit");
                            const t = i && "credentials" in r.prototype, u = {
                                ...w,
                                signal: A,
                                method: a.toUpperCase(),
                                headers: v.normalize().toJSON(),
                                body: s,
                                duplex: "half",
                                credentials: t ? b : void 0
                            };
                            E = i && new r(o, u);
                            let c = await (i ? S(E, w) : S(o, u));
                            const h = f && ("stream" === g || "response" === g);
                            if (f && (y || h && T)) {
                                const e = {};
                                [
                                    "status",
                                    "statusText",
                                    "headers"
                                ].forEach((t)=>{
                                    e[t] = c[t];
                                });
                                const t = $.toFiniteNumber(c.headers.get("content-length")), [r, o] = y && Fe(t, Le(De(y), !0)) || [];
                                c = new n($e(c.body, 65536, r, ()=>{
                                    o && o(), T && T();
                                }), e);
                            }
                            g = g || "text";
                            let k = await p[$.findKey(p, g) || "text"](c, e);
                            return !h && T && T(), await new Promise((t, r)=>{
                                je(t, r, {
                                    data: k,
                                    headers: Re.from(c.headers),
                                    status: c.status,
                                    statusText: c.statusText,
                                    config: e,
                                    request: E
                                });
                            });
                        } catch (t) {
                            if (T && T(), t && "TypeError" === t.name && /Load failed|fetch/i.test(t.message)) throw Object.assign(new Q("Network Error", Q.ERR_NETWORK, e, E, t && t.response), {
                                cause: t.cause || t
                            });
                            throw Q.from(t, t && t.code, e, E, t && t.response);
                        }
                    };
                }, nt = new Map, ot = (e)=>{
                    let t = e && e.env || {};
                    const { fetch: r, Request: n, Response: o } = t, i = [
                        n,
                        o,
                        r
                    ];
                    let a, s, u = i.length, c = nt;
                    for(; u--;)a = i[u], s = c.get(a), void 0 === s && c.set(a, s = u ? new Map : rt(t)), c = s;
                    return s;
                }, it = (ot(), {
                    http: null,
                    xhr: We,
                    fetch: {
                        get: ot
                    }
                });
                $.forEach(it, (e, t)=>{
                    if (e) {
                        try {
                            Object.defineProperty(e, "name", {
                                value: t
                            });
                        } catch (e) {}
                        Object.defineProperty(e, "adapterName", {
                            value: t
                        });
                    }
                });
                const at = (e)=>`- ${e}`, st = (e)=>$.isFunction(e) || null === e || !1 === e;
                const ut = {
                    getAdapter: function(e, t) {
                        e = $.isArray(e) ? e : [
                            e
                        ];
                        const { length: r } = e;
                        let n, o;
                        const i = {};
                        for(let a = 0; a < r; a++){
                            let r;
                            if (n = e[a], o = n, !st(n) && (o = it[(r = String(n)).toLowerCase()], void 0 === o)) throw new Q(`Unknown adapter '${r}'`);
                            if (o && ($.isFunction(o) || (o = o.get(t)))) break;
                            i[r || "#" + a] = o;
                        }
                        if (!o) {
                            const e = Object.entries(i).map(([e, t])=>`adapter ${e} ` + (!1 === t ? "is not supported by the environment" : "is not available in the build"));
                            let t = r ? e.length > 1 ? "since :\n" + e.map(at).join("\n") : " " + at(e[0]) : "as no adapter specified";
                            throw new Q("There is no suitable adapter to dispatch the request " + t, "ERR_NOT_SUPPORT");
                        }
                        return o;
                    },
                    adapters: it
                };
                function ct(e) {
                    if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Ce(null, e);
                }
                function lt(e) {
                    ct(e), e.headers = Re.from(e.headers), e.data = Ie.call(e, e.transformRequest), -1 !== [
                        "post",
                        "put",
                        "patch"
                    ].indexOf(e.method) && e.headers.setContentType("application/x-www-form-urlencoded", !1);
                    return ut.getAdapter(e.adapter || Ae.adapter, e)(e).then(function(t) {
                        return ct(e), t.data = Ie.call(e, e.transformResponse, t), t.headers = Re.from(t.headers), t;
                    }, function(t) {
                        return Be(t) || (ct(e), t && t.response && (t.response.data = Ie.call(e, e.transformResponse, t.response), t.response.headers = Re.from(t.response.headers))), Promise.reject(t);
                    });
                }
                const ft = "1.15.0", pt = {};
                [
                    "object",
                    "boolean",
                    "number",
                    "function",
                    "string",
                    "symbol"
                ].forEach((e, t)=>{
                    pt[e] = function(r) {
                        return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
                    };
                });
                const dt = {};
                pt.transitional = function(e, t, r) {
                    function n(e, t) {
                        return "[Axios v" + ft + "] Transitional option '" + e + "'" + t + (r ? ". " + r : "");
                    }
                    return (r, o, i)=>{
                        if (!1 === e) throw new Q(n(o, " has been removed" + (t ? " in " + t : "")), Q.ERR_DEPRECATED);
                        return t && !dt[o] && (dt[o] = !0, console.warn(n(o, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(r, o, i);
                    };
                }, pt.spelling = function(e) {
                    return (t, r)=>(console.warn(`${r} is likely a misspelling of ${e}`), !0);
                };
                const ht = {
                    assertOptions: function(e, t, r) {
                        if ("object" != typeof e) throw new Q("options must be an object", Q.ERR_BAD_OPTION_VALUE);
                        const n = Object.keys(e);
                        let o = n.length;
                        for(; o-- > 0;){
                            const i = n[o], a = t[i];
                            if (a) {
                                const t = e[i], r = void 0 === t || a(t, i, e);
                                if (!0 !== r) throw new Q("option " + i + " must be " + r, Q.ERR_BAD_OPTION_VALUE);
                                continue;
                            }
                            if (!0 !== r) throw new Q("Unknown option " + i, Q.ERR_BAD_OPTION);
                        }
                    },
                    validators: pt
                }, yt = ht.validators;
                class mt {
                    constructor(e){
                        this.defaults = e || {}, this.interceptors = {
                            request: new fe,
                            response: new fe
                        };
                    }
                    async request(e, t) {
                        try {
                            return await this._request(e, t);
                        } catch (e) {
                            if (e instanceof Error) {
                                let t = {};
                                Error.captureStackTrace ? Error.captureStackTrace(t) : t = new Error;
                                const r = (()=>{
                                    if (!t.stack) return "";
                                    const e = t.stack.indexOf("\n");
                                    return -1 === e ? "" : t.stack.slice(e + 1);
                                })();
                                try {
                                    if (e.stack) {
                                        if (r) {
                                            const t = r.indexOf("\n"), n = -1 === t ? -1 : r.indexOf("\n", t + 1), o = -1 === n ? "" : r.slice(n + 1);
                                            String(e.stack).endsWith(o) || (e.stack += "\n" + r);
                                        }
                                    } else e.stack = r;
                                } catch (e) {}
                            }
                            throw e;
                        }
                    }
                    _request(e, t) {
                        "string" == typeof e ? (t = t || {}).url = e : t = e || {}, t = He(this.defaults, t);
                        const { transitional: r, paramsSerializer: n, headers: o } = t;
                        void 0 !== r && ht.assertOptions(r, {
                            silentJSONParsing: yt.transitional(yt.boolean),
                            forcedJSONParsing: yt.transitional(yt.boolean),
                            clarifyTimeoutError: yt.transitional(yt.boolean),
                            legacyInterceptorReqResOrdering: yt.transitional(yt.boolean)
                        }, !1), null != n && ($.isFunction(n) ? t.paramsSerializer = {
                            serialize: n
                        } : ht.assertOptions(n, {
                            encode: yt.function,
                            serialize: yt.function
                        }, !0)), void 0 !== t.allowAbsoluteUrls || (void 0 !== this.defaults.allowAbsoluteUrls ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), ht.assertOptions(t, {
                            baseUrl: yt.spelling("baseURL"),
                            withXsrfToken: yt.spelling("withXSRFToken")
                        }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
                        let i = o && $.merge(o.common, o[t.method]);
                        o && $.forEach([
                            "delete",
                            "get",
                            "head",
                            "post",
                            "put",
                            "patch",
                            "common"
                        ], (e)=>{
                            delete o[e];
                        }), t.headers = Re.concat(i, o);
                        const a = [];
                        let s = !0;
                        this.interceptors.request.forEach(function(e) {
                            if ("function" == typeof e.runWhen && !1 === e.runWhen(t)) return;
                            s = s && e.synchronous;
                            const r = t.transitional || pe;
                            r && r.legacyInterceptorReqResOrdering ? a.unshift(e.fulfilled, e.rejected) : a.push(e.fulfilled, e.rejected);
                        });
                        const u = [];
                        let c;
                        this.interceptors.response.forEach(function(e) {
                            u.push(e.fulfilled, e.rejected);
                        });
                        let l, f = 0;
                        if (!s) {
                            const e = [
                                lt.bind(this),
                                void 0
                            ];
                            for(e.unshift(...a), e.push(...u), l = e.length, c = Promise.resolve(t); f < l;)c = c.then(e[f++], e[f++]);
                            return c;
                        }
                        l = a.length;
                        let p = t;
                        for(; f < l;){
                            const e = a[f++], t = a[f++];
                            try {
                                p = e(p);
                            } catch (e) {
                                t.call(this, e);
                                break;
                            }
                        }
                        try {
                            c = lt.call(this, p);
                        } catch (e) {
                            return Promise.reject(e);
                        }
                        for(f = 0, l = u.length; f < l;)c = c.then(u[f++], u[f++]);
                        return c;
                    }
                    getUri(e) {
                        return le(qe((e = He(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
                    }
                }
                $.forEach([
                    "delete",
                    "get",
                    "head",
                    "options"
                ], function(e) {
                    mt.prototype[e] = function(t, r) {
                        return this.request(He(r || {}, {
                            method: e,
                            url: t,
                            data: (r || {}).data
                        }));
                    };
                }), $.forEach([
                    "post",
                    "put",
                    "patch"
                ], function(e) {
                    function t(t) {
                        return function(r, n, o) {
                            return this.request(He(o || {}, {
                                method: e,
                                headers: t ? {
                                    "Content-Type": "multipart/form-data"
                                } : {},
                                url: r,
                                data: n
                            }));
                        };
                    }
                    mt.prototype[e] = t(), mt.prototype[e + "Form"] = t(!0);
                });
                const gt = mt;
                class vt {
                    constructor(e){
                        if ("function" != typeof e) throw new TypeError("executor must be a function.");
                        let t;
                        this.promise = new Promise(function(e) {
                            t = e;
                        });
                        const r = this;
                        this.promise.then((e)=>{
                            if (!r._listeners) return;
                            let t = r._listeners.length;
                            for(; t-- > 0;)r._listeners[t](e);
                            r._listeners = null;
                        }), this.promise.then = (e)=>{
                            let t;
                            const n = new Promise((e)=>{
                                r.subscribe(e), t = e;
                            }).then(e);
                            return n.cancel = function() {
                                r.unsubscribe(t);
                            }, n;
                        }, e(function(e, n, o) {
                            r.reason || (r.reason = new Ce(e, n, o), t(r.reason));
                        });
                    }
                    throwIfRequested() {
                        if (this.reason) throw this.reason;
                    }
                    subscribe(e) {
                        this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [
                            e
                        ];
                    }
                    unsubscribe(e) {
                        if (!this._listeners) return;
                        const t = this._listeners.indexOf(e);
                        -1 !== t && this._listeners.splice(t, 1);
                    }
                    toAbortSignal() {
                        const e = new AbortController, t = (t)=>{
                            e.abort(t);
                        };
                        return this.subscribe(t), e.signal.unsubscribe = ()=>this.unsubscribe(t), e.signal;
                    }
                    static source() {
                        let e;
                        return {
                            token: new vt(function(t) {
                                e = t;
                            }),
                            cancel: e
                        };
                    }
                }
                const bt = vt;
                const wt = {
                    Continue: 100,
                    SwitchingProtocols: 101,
                    Processing: 102,
                    EarlyHints: 103,
                    Ok: 200,
                    Created: 201,
                    Accepted: 202,
                    NonAuthoritativeInformation: 203,
                    NoContent: 204,
                    ResetContent: 205,
                    PartialContent: 206,
                    MultiStatus: 207,
                    AlreadyReported: 208,
                    ImUsed: 226,
                    MultipleChoices: 300,
                    MovedPermanently: 301,
                    Found: 302,
                    SeeOther: 303,
                    NotModified: 304,
                    UseProxy: 305,
                    Unused: 306,
                    TemporaryRedirect: 307,
                    PermanentRedirect: 308,
                    BadRequest: 400,
                    Unauthorized: 401,
                    PaymentRequired: 402,
                    Forbidden: 403,
                    NotFound: 404,
                    MethodNotAllowed: 405,
                    NotAcceptable: 406,
                    ProxyAuthenticationRequired: 407,
                    RequestTimeout: 408,
                    Conflict: 409,
                    Gone: 410,
                    LengthRequired: 411,
                    PreconditionFailed: 412,
                    PayloadTooLarge: 413,
                    UriTooLong: 414,
                    UnsupportedMediaType: 415,
                    RangeNotSatisfiable: 416,
                    ExpectationFailed: 417,
                    ImATeapot: 418,
                    MisdirectedRequest: 421,
                    UnprocessableEntity: 422,
                    Locked: 423,
                    FailedDependency: 424,
                    TooEarly: 425,
                    UpgradeRequired: 426,
                    PreconditionRequired: 428,
                    TooManyRequests: 429,
                    RequestHeaderFieldsTooLarge: 431,
                    UnavailableForLegalReasons: 451,
                    InternalServerError: 500,
                    NotImplemented: 501,
                    BadGateway: 502,
                    ServiceUnavailable: 503,
                    GatewayTimeout: 504,
                    HttpVersionNotSupported: 505,
                    VariantAlsoNegotiates: 506,
                    InsufficientStorage: 507,
                    LoopDetected: 508,
                    NotExtended: 510,
                    NetworkAuthenticationRequired: 511,
                    WebServerIsDown: 521,
                    ConnectionTimedOut: 522,
                    OriginIsUnreachable: 523,
                    TimeoutOccurred: 524,
                    SslHandshakeFailed: 525,
                    InvalidSslCertificate: 526
                };
                Object.entries(wt).forEach(([e, t])=>{
                    wt[t] = e;
                });
                const St = wt;
                const At = function e(t) {
                    const r = new gt(t), n = o(gt.prototype.request, r);
                    return $.extend(n, gt.prototype, r, {
                        allOwnKeys: !0
                    }), $.extend(n, r, null, {
                        allOwnKeys: !0
                    }), n.create = function(r) {
                        return e(He(t, r));
                    }, n;
                }(Ae);
                At.Axios = gt, At.CanceledError = Ce, At.CancelToken = bt, At.isCancel = Be, At.VERSION = ft, At.toFormData = oe, At.AxiosError = Q, At.Cancel = At.CanceledError, At.all = function(e) {
                    return Promise.all(e);
                }, At.spread = function(e) {
                    return function(t) {
                        return e.apply(null, t);
                    };
                }, At.isAxiosError = function(e) {
                    return $.isObject(e) && !0 === e.isAxiosError;
                }, At.mergeConfig = He, At.AxiosHeaders = Re, At.formToJSON = (e)=>we($.isHTMLForm(e) ? new FormData(e) : e), At.getAdapter = ut.getAdapter, At.HttpStatusCode = St, At.default = At;
                var Et = At, Tt = At.create;
            },
            9983 (e, t, r) {
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, i(n.key), n);
                    }
                }
                function i(e) {
                    var t = function(e, t) {
                        if ("object" != n(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, t || "default");
                            if ("object" != n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == n(t) ? t : t + "";
                }
                r.d(t, {
                    vt: ()=>l,
                    ok: ()=>c
                });
                a = function e(t) {
                    var r, n = this;
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.promise = new Promise(function(e) {
                        r = e;
                    }), t(function(e) {
                        n.reason = e, r();
                    });
                }, s = [
                    {
                        key: "throwIfRequested",
                        value: function() {
                            if (this.reason) throw new Error(this.reason);
                        }
                    }
                ], o(a.prototype, s), u && o(a, u), Object.defineProperty(a, "prototype", {
                    writable: !1
                });
                var a, s, u, c, l, f = r(6121);
                c = f.axiosClient, l = f.create;
            },
            4356 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    AccountRequiresMemoError: ()=>n.Cu,
                    BadRequestError: ()=>n.v7,
                    BadResponseError: ()=>n.nS,
                    BindingGenerator: ()=>d.fe,
                    Config: ()=>o.T,
                    Federation: ()=>s,
                    Friendbot: ()=>c,
                    Horizon: ()=>l,
                    NetworkError: ()=>n.Dr,
                    NotFoundError: ()=>n.m_,
                    StellarToml: ()=>a,
                    Utils: ()=>i.A,
                    WebAuth: ()=>u,
                    contract: ()=>p,
                    default: ()=>m,
                    rpc: ()=>f
                });
                var n = r(5976), o = r(8732), i = r(3121), a = r(3898), s = r(6602), u = r(7504), c = r(8242), l = r(8733), f = r(3496), p = r(8250), d = r(6682), h = r(8950), y = {};
                for(const e in h)[
                    "default",
                    "Config",
                    "Utils",
                    "BindingGenerator",
                    "StellarToml",
                    "Federation",
                    "WebAuth",
                    "Friendbot",
                    "Horizon",
                    "rpc",
                    "contract",
                    "AccountRequiresMemoError",
                    "BadRequestError",
                    "BadResponseError",
                    "NetworkError",
                    "NotFoundError"
                ].indexOf(e) < 0 && (y[e] = ()=>h[e]);
                r.d(t, y);
                const m = (e = r.hmd(e)).exports;
                void 0 === r.g.__USE_AXIOS__ && (r.g.__USE_AXIOS__ = !0), void 0 === r.g.__USE_EVENTSOURCE__ && (r.g.__USE_EVENTSOURCE__ = !1);
            },
            4076 (e, t, r) {
                "use strict";
                var n;
                r.d(t, {
                    j: ()=>n
                }), function(e) {
                    var t = function(e) {
                        return e.SUCCESS = "SUCCESS", e.NOT_FOUND = "NOT_FOUND", e.FAILED = "FAILED", e;
                    }({});
                    function r(e) {
                        return "transactionData" in e;
                    }
                    e.GetTransactionStatus = t, e.isSimulationError = function(e) {
                        return "error" in e;
                    }, e.isSimulationSuccess = r, e.isSimulationRestore = function(e) {
                        return r(e) && "restorePreamble" in e && !!e.restorePreamble.transactionData;
                    }, e.isSimulationRaw = function(e) {
                        return !e._parsed;
                    };
                }(n || (n = {}));
            },
            3496 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    Api: ()=>n.j,
                    BasicSleepStrategy: ()=>U,
                    Durability: ()=>j,
                    LinearSleepStrategy: ()=>N,
                    Server: ()=>be,
                    assembleTransaction: ()=>v.X,
                    default: ()=>we,
                    parseRawEvents: ()=>b.fG,
                    parseRawSimulation: ()=>b.jr
                });
                var n = r(4076), o = r(4193), i = r.n(o), a = r(8950), s = r(9983);
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function c(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function l(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(r), !0).forEach(function(t) {
                            f(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function f(e, t, r) {
                    return (t = function(e) {
                        var t = function(e, t) {
                            if ("object" != u(e) || !e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(e, t || "default");
                                if ("object" != u(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(e, "string");
                        return "symbol" == u(t) ? t : t + "";
                    }(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function p() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return d(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (d(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function h(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, d(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, d(f, "constructor", c), d(c, "constructor", u), u.displayName = "GeneratorFunction", d(c, o, "GeneratorFunction"), d(f), d(f, o, "Generator"), d(f, n, function() {
                        return this;
                    }), d(f, "toString", function() {
                        return "[object Generator]";
                    }), (p = function() {
                        return {
                            w: i,
                            m: h
                        };
                    })();
                }
                function d(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    d = function(e, t, r, n) {
                        function i(t, r) {
                            d(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, d(e, t, r, n);
                }
                function h(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function y(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                function m(e, t, r) {
                    return g.apply(this, arguments);
                }
                function g() {
                    var e;
                    return e = p().m(function e(t, r, n) {
                        var o, i, a, s = arguments;
                        return p().w(function(e) {
                            for(;;)switch(e.n){
                                case 0:
                                    return o = s.length > 3 && void 0 !== s[3] ? s[3] : null, e.n = 1, t.post(r, {
                                        jsonrpc: "2.0",
                                        id: 1,
                                        method: n,
                                        params: o
                                    });
                                case 1:
                                    if (!y((i = e.v).data, "error")) {
                                        e.n = 2;
                                        break;
                                    }
                                    throw i.data.error;
                                case 2:
                                    return e.a(2, null === (a = i.data) || void 0 === a ? void 0 : a.result);
                                case 3:
                                    return e.a(2);
                            }
                        }, e);
                    }), g = function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                h(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                h(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    }, g.apply(this, arguments);
                }
                var v = r(8680), b = r(784), w = r(3121), S = r(8287).Buffer;
                function A(e) {
                    return A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, A(e);
                }
                function E(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function T(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? E(Object(r), !0).forEach(function(t) {
                            O(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function O(e, t, r) {
                    return (t = C(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function k(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, o, i, a, s = [], u = !0, c = !1;
                            try {
                                if (i = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    u = !1;
                                } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                            } catch (e) {
                                c = !0, o = e;
                            } finally{
                                try {
                                    if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw o;
                                }
                            }
                            return s;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return _(e, t);
                            var r = ({}).toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function _(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function x() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, c = Object.create(u.prototype);
                        return P(c, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), c;
                    }
                    var a = {};
                    function s() {}
                    function u() {}
                    function c() {}
                    t = Object.getPrototypeOf;
                    var l = [][n] ? t(t([][n]())) : (P(t = {}, n, function() {
                        return this;
                    }), t), f = c.prototype = s.prototype = Object.create(l);
                    function p(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, c) : (e.__proto__ = c, P(e, o, "GeneratorFunction")), e.prototype = Object.create(f), e;
                    }
                    return u.prototype = c, P(f, "constructor", c), P(c, "constructor", u), u.displayName = "GeneratorFunction", P(c, o, "GeneratorFunction"), P(f), P(f, o, "Generator"), P(f, n, function() {
                        return this;
                    }), P(f, "toString", function() {
                        return "[object Generator]";
                    }), (x = function() {
                        return {
                            w: i,
                            m: p
                        };
                    })();
                }
                function P(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    P = function(e, t, r, n) {
                        function i(t, r) {
                            P(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, P(e, t, r, n);
                }
                function R(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function I(e) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, o) {
                            var i = e.apply(t, r);
                            function a(e) {
                                R(i, n, o, a, s, "next", e);
                            }
                            function s(e) {
                                R(i, n, o, a, s, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function B(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, C(n.key), n);
                    }
                }
                function C(e) {
                    var t = function(e, t) {
                        if ("object" != A(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != A(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == A(t) ? t : t + "";
                }
                var j = function(e) {
                    return e.Temporary = "temporary", e.Persistent = "persistent", e;
                }({}), U = function(e) {
                    return 1e3;
                }, N = function(e) {
                    return 1e3 * e;
                };
                function L(e) {
                    var t, r = [];
                    switch(e.switch()){
                        case 0:
                            r = e.operations();
                            break;
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            r = e.value().operations();
                            break;
                        default:
                            throw new Error("Unexpected transaction meta switch value");
                    }
                    var n = null === (t = r.flatMap(function(e) {
                        return e.changes();
                    }).find(function(e) {
                        return e.switch() === a.xdr.LedgerEntryChangeType.ledgerEntryCreated() && e.created().data().switch() === a.xdr.LedgerEntryType.account();
                    })) || void 0 === t || null === (t = t.created()) || void 0 === t || null === (t = t.data()) || void 0 === t || null === (t = t.account()) || void 0 === t || null === (t = t.seqNum()) || void 0 === t ? void 0 : t.toString();
                    if (n) return n;
                    throw new Error("No account created in transaction");
                }
                var F, D, M, V, q, G, H, z, W, X, K, Z, $, Y, Q, J, ee, te, re, ne, oe, ie, ae, se, ue, ce, le, fe, pe, de, he, ye, me, ge, ve, be = (F = function e(t) {
                    var r, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.serverURL = i()(t), this.httpClient = (r = n.headers, (0, s.vt)({
                        headers: l(l({}, r), {}, {
                            "X-Client-Name": "js-stellar-sdk",
                            "X-Client-Version": "15.1.0"
                        })
                    })), "https" !== this.serverURL.protocol() && !n.allowHttp) throw new Error("Cannot connect to insecure Soroban RPC server if `allowHttp` isn't set");
                }, D = [
                    {
                        key: "getAccount",
                        value: (ve = I(x().m(function e(t) {
                            var r;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return e.n = 1, this.getAccountEntry(t);
                                    case 1:
                                        return r = e.v, e.a(2, new a.Account(t, r.seqNum().toString()));
                                }
                            }, e, this);
                        })), function(e) {
                            return ve.apply(this, arguments);
                        })
                    },
                    {
                        key: "getAccountEntry",
                        value: (ge = I(x().m(function e(t) {
                            var r, n;
                            return x().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        return r = a.xdr.LedgerKey.account(new a.xdr.LedgerKeyAccount({
                                            accountId: a.Keypair.fromPublicKey(t).xdrPublicKey()
                                        })), e.p = 1, e.n = 2, this.getLedgerEntry(r);
                                    case 2:
                                        return n = e.v, e.a(2, n.val.account());
                                    case 3:
                                        throw e.p = 3, e.v, new Error("Account not found: ".concat(t));
                                    case 4:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    1,
                                    3
                                ]
                            ]);
                        })), function(e) {
                            return ge.apply(this, arguments);
                        })
                    },
                    {
                        key: "getTrustline",
                        value: (me = I(x().m(function e(t, r) {
                            var n, o;
                            return x().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        return n = a.xdr.LedgerKey.trustline(new a.xdr.LedgerKeyTrustLine({
                                            accountId: a.Keypair.fromPublicKey(t).xdrAccountId(),
                                            asset: r.toTrustLineXDRObject()
                                        })), e.p = 1, e.n = 2, this.getLedgerEntry(n);
                                    case 2:
                                        return o = e.v, e.a(2, o.val.trustLine());
                                    case 3:
                                        throw e.p = 3, e.v, new Error("Trustline for ".concat(r.getCode(), ":").concat(r.getIssuer(), " not found for ").concat(t));
                                    case 4:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    1,
                                    3
                                ]
                            ]);
                        })), function(e, t) {
                            return me.apply(this, arguments);
                        })
                    },
                    {
                        key: "getClaimableBalance",
                        value: (ye = I(x().m(function e(t) {
                            var r, n, o, i, s;
                            return x().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        if (!a.StrKey.isValidClaimableBalance(t)) {
                                            e.n = 1;
                                            break;
                                        }
                                        n = a.StrKey.decodeClaimableBalance(t), o = S.concat([
                                            S.from("\0\0\0"),
                                            n.subarray(0, 1)
                                        ]), r = a.xdr.ClaimableBalanceId.fromXDR(S.concat([
                                            o,
                                            n.subarray(1)
                                        ])), e.n = 4;
                                        break;
                                    case 1:
                                        if (!t.match(/[a-f0-9]{72}/i)) {
                                            e.n = 2;
                                            break;
                                        }
                                        r = a.xdr.ClaimableBalanceId.fromXDR(t, "hex"), e.n = 4;
                                        break;
                                    case 2:
                                        if (!t.match(/[a-f0-9]{64}/i)) {
                                            e.n = 3;
                                            break;
                                        }
                                        r = a.xdr.ClaimableBalanceId.fromXDR(t.padStart(72, "0"), "hex"), e.n = 4;
                                        break;
                                    case 3:
                                        throw new TypeError("expected 72-char hex ID or strkey, not ".concat(t));
                                    case 4:
                                        return i = a.xdr.LedgerKey.claimableBalance(new a.xdr.LedgerKeyClaimableBalance({
                                            balanceId: r
                                        })), e.p = 5, e.n = 6, this.getLedgerEntry(i);
                                    case 6:
                                        return s = e.v, e.a(2, s.val.claimableBalance());
                                    case 7:
                                        throw e.p = 7, e.v, new Error("Claimable balance ".concat(t, " not found"));
                                    case 8:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    5,
                                    7
                                ]
                            ]);
                        })), function(e) {
                            return ye.apply(this, arguments);
                        })
                    },
                    {
                        key: "getAssetBalance",
                        value: (he = I(x().m(function e(t, r, n) {
                            var o, i, s, u, c;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if (o = t, "string" != typeof t) {
                                            e.n = 1;
                                            break;
                                        }
                                        o = t, e.n = 4;
                                        break;
                                    case 1:
                                        if (!(t instanceof a.Address)) {
                                            e.n = 2;
                                            break;
                                        }
                                        o = t.toString(), e.n = 4;
                                        break;
                                    case 2:
                                        if (!(t instanceof a.Contract)) {
                                            e.n = 3;
                                            break;
                                        }
                                        o = t.toString(), e.n = 4;
                                        break;
                                    case 3:
                                        throw new TypeError("invalid address: ".concat(t));
                                    case 4:
                                        if (!a.StrKey.isValidEd25519PublicKey(o)) {
                                            e.n = 6;
                                            break;
                                        }
                                        return e.n = 5, Promise.all([
                                            this.getTrustline(o, r),
                                            this.getLatestLedger()
                                        ]);
                                    case 5:
                                        return i = e.v, s = k(i, 2), u = s[0], c = s[1], e.a(2, {
                                            latestLedger: c.sequence,
                                            balanceEntry: {
                                                amount: u.balance().toString(),
                                                authorized: Boolean(1 & u.flags()),
                                                clawback: Boolean(4 & u.flags()),
                                                authorizedToMaintainLiabilities: Boolean(2 & u.flags()),
                                                revocable: Boolean(2 & u.flags())
                                            }
                                        });
                                    case 6:
                                        if (!a.StrKey.isValidContract(o)) {
                                            e.n = 7;
                                            break;
                                        }
                                        return e.a(2, this.getSACBalance(o, r, n));
                                    case 7:
                                        throw new Error("invalid address: ".concat(t));
                                    case 8:
                                        return e.a(2);
                                }
                            }, e, this);
                        })), function(e, t, r) {
                            return he.apply(this, arguments);
                        })
                    },
                    {
                        key: "getHealth",
                        value: (de = I(x().m(function e() {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getHealth"));
                            }, e, this);
                        })), function() {
                            return de.apply(this, arguments);
                        })
                    },
                    {
                        key: "getContractData",
                        value: (pe = I(x().m(function e(t, r) {
                            var n, o, i, s, u, c = arguments;
                            return x().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        if (n = c.length > 2 && void 0 !== c[2] ? c[2] : j.Persistent, "string" != typeof t) {
                                            e.n = 1;
                                            break;
                                        }
                                        o = new a.Contract(t).address().toScAddress(), e.n = 4;
                                        break;
                                    case 1:
                                        if (!(t instanceof a.Address)) {
                                            e.n = 2;
                                            break;
                                        }
                                        o = t.toScAddress(), e.n = 4;
                                        break;
                                    case 2:
                                        if (!(t instanceof a.Contract)) {
                                            e.n = 3;
                                            break;
                                        }
                                        o = t.address().toScAddress(), e.n = 4;
                                        break;
                                    case 3:
                                        throw new TypeError("unknown contract type: ".concat(t));
                                    case 4:
                                        u = n, e.n = u === j.Temporary ? 5 : u === j.Persistent ? 6 : 7;
                                        break;
                                    case 5:
                                        return i = a.xdr.ContractDataDurability.temporary(), e.a(3, 8);
                                    case 6:
                                        return i = a.xdr.ContractDataDurability.persistent(), e.a(3, 8);
                                    case 7:
                                        throw new TypeError("invalid durability: ".concat(n));
                                    case 8:
                                        return s = a.xdr.LedgerKey.contractData(new a.xdr.LedgerKeyContractData({
                                            key: r,
                                            contract: o,
                                            durability: i
                                        })), e.p = 9, e.n = 10, this.getLedgerEntry(s);
                                    case 10:
                                        return e.a(2, e.v);
                                    case 11:
                                        throw e.p = 11, e.v, {
                                            code: 404,
                                            message: "Contract data not found for ".concat(a.Address.fromScAddress(o).toString(), " with key ").concat(r.toXDR("base64"), " and durability: ").concat(n)
                                        };
                                    case 12:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    9,
                                    11
                                ]
                            ]);
                        })), function(e, t) {
                            return pe.apply(this, arguments);
                        })
                    },
                    {
                        key: "getContractWasmByContractId",
                        value: (fe = I(x().m(function e(t) {
                            var r, n, o, i;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return n = new a.Contract(t).getFootprint(), e.n = 1, this.getLedgerEntries(n);
                                    case 1:
                                        if ((o = e.v).entries.length && null !== (r = o.entries[0]) && void 0 !== r && r.val) {
                                            e.n = 2;
                                            break;
                                        }
                                        return e.a(2, Promise.reject({
                                            code: 404,
                                            message: "Could not obtain contract hash from server"
                                        }));
                                    case 2:
                                        return i = o.entries[0].val.contractData().val().instance().executable().wasmHash(), e.a(2, this.getContractWasmByHash(i));
                                }
                            }, e, this);
                        })), function(e) {
                            return fe.apply(this, arguments);
                        })
                    },
                    {
                        key: "getContractWasmByHash",
                        value: (le = I(x().m(function e(t) {
                            var r, n, o, i, s, u, c = arguments;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return n = c.length > 1 && void 0 !== c[1] ? c[1] : void 0, o = "string" == typeof t ? S.from(t, n) : t, i = a.xdr.LedgerKey.contractCode(new a.xdr.LedgerKeyContractCode({
                                            hash: o
                                        })), e.n = 1, this.getLedgerEntries(i);
                                    case 1:
                                        if ((s = e.v).entries.length && null !== (r = s.entries[0]) && void 0 !== r && r.val) {
                                            e.n = 2;
                                            break;
                                        }
                                        return e.a(2, Promise.reject({
                                            code: 404,
                                            message: "Could not obtain contract wasm from server"
                                        }));
                                    case 2:
                                        return u = s.entries[0].val.contractCode().code(), e.a(2, u);
                                }
                            }, e, this);
                        })), function(e) {
                            return le.apply(this, arguments);
                        })
                    },
                    {
                        key: "getLedgerEntries",
                        value: function() {
                            return this._getLedgerEntries.apply(this, arguments).then(b.$D);
                        }
                    },
                    {
                        key: "_getLedgerEntries",
                        value: function() {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return m(this.httpClient, this.serverURL.toString(), "getLedgerEntries", {
                                keys: t.map(function(e) {
                                    return e.toXDR("base64");
                                })
                            });
                        }
                    },
                    {
                        key: "getLedgerEntry",
                        value: (ce = I(x().m(function e(t) {
                            var r;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return e.n = 1, this._getLedgerEntries(t).then(b.$D);
                                    case 1:
                                        if (1 === (r = e.v).entries.length) {
                                            e.n = 2;
                                            break;
                                        }
                                        throw new Error("failed to find an entry for key ".concat(t.toXDR("base64")));
                                    case 2:
                                        return e.a(2, r.entries[0]);
                                }
                            }, e, this);
                        })), function(e) {
                            return ce.apply(this, arguments);
                        })
                    },
                    {
                        key: "pollTransaction",
                        value: (ue = I(x().m(function e(t, r) {
                            var o, i, a, s, u, c;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        a = (null !== (o = null == r ? void 0 : r.attempts) && void 0 !== o ? o : 0) < 1 ? 30 : null !== (i = null == r ? void 0 : r.attempts) && void 0 !== i ? i : 30, u = 1;
                                    case 1:
                                        if (!(u <= a)) {
                                            e.n = 5;
                                            break;
                                        }
                                        return e.n = 2, this.getTransaction(t);
                                    case 2:
                                        if ((s = e.v).status === n.j.GetTransactionStatus.NOT_FOUND) {
                                            e.n = 3;
                                            break;
                                        }
                                        return e.a(2, s);
                                    case 3:
                                        return e.n = 4, w.A.sleep((null !== (c = null == r ? void 0 : r.sleepStrategy) && void 0 !== c ? c : U)(u));
                                    case 4:
                                        u++, e.n = 1;
                                        break;
                                    case 5:
                                        return e.a(2, s);
                                }
                            }, e, this);
                        })), function(e, t) {
                            return ue.apply(this, arguments);
                        })
                    },
                    {
                        key: "getTransaction",
                        value: (se = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._getTransaction(t).then(function(e) {
                                    var r = {};
                                    return e.status !== n.j.GetTransactionStatus.NOT_FOUND && Object.assign(r, (0, b.WC)(e)), T({
                                        status: e.status,
                                        txHash: t,
                                        latestLedger: e.latestLedger,
                                        latestLedgerCloseTime: e.latestLedgerCloseTime,
                                        oldestLedger: e.oldestLedger,
                                        oldestLedgerCloseTime: e.oldestLedgerCloseTime
                                    }, r);
                                }));
                            }, e, this);
                        })), function(e) {
                            return se.apply(this, arguments);
                        })
                    },
                    {
                        key: "_getTransaction",
                        value: (ae = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getTransaction", {
                                    hash: t
                                }));
                            }, e, this);
                        })), function(e) {
                            return ae.apply(this, arguments);
                        })
                    },
                    {
                        key: "getTransactions",
                        value: (ie = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._getTransactions(t).then(function(e) {
                                    return {
                                        transactions: (e.transactions || []).map(b.tR),
                                        latestLedger: e.latestLedger,
                                        latestLedgerCloseTimestamp: e.latestLedgerCloseTimestamp,
                                        oldestLedger: e.oldestLedger,
                                        oldestLedgerCloseTimestamp: e.oldestLedgerCloseTimestamp,
                                        cursor: e.cursor
                                    };
                                }));
                            }, e, this);
                        })), function(e) {
                            return ie.apply(this, arguments);
                        })
                    },
                    {
                        key: "_getTransactions",
                        value: (oe = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getTransactions", t));
                            }, e, this);
                        })), function(e) {
                            return oe.apply(this, arguments);
                        })
                    },
                    {
                        key: "getEvents",
                        value: (ne = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._getEvents(t).then(b.fG));
                            }, e, this);
                        })), function(e) {
                            return ne.apply(this, arguments);
                        })
                    },
                    {
                        key: "_getEvents",
                        value: (re = I(x().m(function e(t) {
                            var r;
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getEvents", T(T({
                                    filters: null !== (r = t.filters) && void 0 !== r ? r : [],
                                    pagination: T(T({}, t.cursor && {
                                        cursor: t.cursor
                                    }), t.limit && {
                                        limit: t.limit
                                    })
                                }, t.startLedger && {
                                    startLedger: t.startLedger
                                }), t.endLedger && {
                                    endLedger: t.endLedger
                                })));
                            }, e, this);
                        })), function(e) {
                            return re.apply(this, arguments);
                        })
                    },
                    {
                        key: "getNetwork",
                        value: (te = I(x().m(function e() {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getNetwork"));
                            }, e, this);
                        })), function() {
                            return te.apply(this, arguments);
                        })
                    },
                    {
                        key: "getLatestLedger",
                        value: (ee = I(x().m(function e() {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._getLatestLedger().then(b.CA));
                            }, e, this);
                        })), function() {
                            return ee.apply(this, arguments);
                        })
                    },
                    {
                        key: "_getLatestLedger",
                        value: (J = I(x().m(function e() {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getLatestLedger"));
                            }, e, this);
                        })), function() {
                            return J.apply(this, arguments);
                        })
                    },
                    {
                        key: "simulateTransaction",
                        value: (Q = I(x().m(function e(t, r, n) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._simulateTransaction(t, r, n).then(b.jr));
                            }, e, this);
                        })), function(e, t, r) {
                            return Q.apply(this, arguments);
                        })
                    },
                    {
                        key: "_simulateTransaction",
                        value: (Y = I(x().m(function e(t, r, n) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "simulateTransaction", T({
                                    transaction: t.toXDR(),
                                    authMode: n
                                }, void 0 !== r && {
                                    resourceConfig: {
                                        instructionLeeway: r.cpuInstructions
                                    }
                                })));
                            }, e, this);
                        })), function(e, t, r) {
                            return Y.apply(this, arguments);
                        })
                    },
                    {
                        key: "prepareTransaction",
                        value: ($ = I(x().m(function e(t) {
                            var r;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        return e.n = 1, this.simulateTransaction(t);
                                    case 1:
                                        if (r = e.v, !n.j.isSimulationError(r)) {
                                            e.n = 2;
                                            break;
                                        }
                                        throw new Error(r.error);
                                    case 2:
                                        return e.a(2, (0, v.X)(t, r).build());
                                }
                            }, e, this);
                        })), function(e) {
                            return $.apply(this, arguments);
                        })
                    },
                    {
                        key: "sendTransaction",
                        value: (Z = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._sendTransaction(t).then(b.Af));
                            }, e, this);
                        })), function(e) {
                            return Z.apply(this, arguments);
                        })
                    },
                    {
                        key: "_sendTransaction",
                        value: (K = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "sendTransaction", {
                                    transaction: t.toXDR()
                                }));
                            }, e, this);
                        })), function(e) {
                            return K.apply(this, arguments);
                        })
                    },
                    {
                        key: "requestAirdrop",
                        value: (X = I(x().m(function e(t, r) {
                            var o, i, s, u, c, l, f, p, d;
                            return x().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        if (o = "string" == typeof t ? t : t.accountId(), p = r) {
                                            e.n = 2;
                                            break;
                                        }
                                        return e.n = 1, this.getNetwork();
                                    case 1:
                                        p = e.v.friendbotUrl;
                                    case 2:
                                        if (r = p) {
                                            e.n = 3;
                                            break;
                                        }
                                        throw new Error("No friendbot URL configured for current network");
                                    case 3:
                                        return e.p = 3, e.n = 4, this.httpClient.post("".concat(r, "?addr=").concat(encodeURIComponent(o)));
                                    case 4:
                                        if ((i = e.v).data.result_meta_xdr) {
                                            e.n = 7;
                                            break;
                                        }
                                        return e.n = 5, this.getTransaction(i.data.hash);
                                    case 5:
                                        if ((u = e.v).status === n.j.GetTransactionStatus.SUCCESS) {
                                            e.n = 6;
                                            break;
                                        }
                                        throw new Error("Funding account ".concat(t, " failed"));
                                    case 6:
                                        s = u.resultMetaXdr, e.n = 8;
                                        break;
                                    case 7:
                                        s = a.xdr.TransactionMeta.fromXDR(i.data.result_meta_xdr, "base64");
                                    case 8:
                                        return c = L(s), e.a(2, new a.Account(o, c));
                                    case 9:
                                        if (e.p = 9, d = e.v, 400 !== (null === (l = d.response) || void 0 === l ? void 0 : l.status)) {
                                            e.n = 10;
                                            break;
                                        }
                                        if (null === (f = d.response.data) || void 0 === f || null === (f = f.detail) || void 0 === f || !f.includes("createAccountAlreadyExist")) {
                                            e.n = 10;
                                            break;
                                        }
                                        return e.a(2, this.getAccount(o));
                                    case 10:
                                        throw d;
                                    case 11:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    3,
                                    9
                                ]
                            ]);
                        })), function(e, t) {
                            return X.apply(this, arguments);
                        })
                    },
                    {
                        key: "fundAddress",
                        value: (W = I(x().m(function e(t, r) {
                            var o, i, s, u, c, l, f;
                            return x().w(function(e) {
                                for(;;)switch(e.p = e.n){
                                    case 0:
                                        if (a.StrKey.isValidEd25519PublicKey(t) || a.StrKey.isValidContract(t)) {
                                            e.n = 1;
                                            break;
                                        }
                                        throw new Error("Invalid address: ".concat(t, ". Expected a Stellar account (G...) or contract (C...) address."));
                                    case 1:
                                        if (l = r) {
                                            e.n = 3;
                                            break;
                                        }
                                        return e.n = 2, this.getNetwork();
                                    case 2:
                                        l = e.v.friendbotUrl;
                                    case 3:
                                        if (r = l) {
                                            e.n = 4;
                                            break;
                                        }
                                        throw new Error("No friendbot URL configured for current network");
                                    case 4:
                                        return e.p = 4, e.n = 5, this.httpClient.post("".concat(r, "?addr=").concat(encodeURIComponent(t)));
                                    case 5:
                                        return o = e.v, e.n = 6, this.getTransaction(o.data.hash);
                                    case 6:
                                        if ((i = e.v).status === n.j.GetTransactionStatus.SUCCESS) {
                                            e.n = 7;
                                            break;
                                        }
                                        throw new Error("Funding address ".concat(t, " failed: transaction status ").concat(i.status));
                                    case 7:
                                        return e.a(2, i);
                                    case 8:
                                        if (e.p = 8, f = e.v, 400 !== (null === (s = f.response) || void 0 === s ? void 0 : s.status)) {
                                            e.n = 9;
                                            break;
                                        }
                                        throw new Error(null !== (u = null === (c = f.response.data) || void 0 === c ? void 0 : c.detail) && void 0 !== u ? u : "Bad Request");
                                    case 9:
                                        throw f;
                                    case 10:
                                        return e.a(2);
                                }
                            }, e, this, [
                                [
                                    4,
                                    8
                                ]
                            ]);
                        })), function(e, t) {
                            return W.apply(this, arguments);
                        })
                    },
                    {
                        key: "getFeeStats",
                        value: (z = I(x().m(function e() {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getFeeStats"));
                            }, e, this);
                        })), function() {
                            return z.apply(this, arguments);
                        })
                    },
                    {
                        key: "getVersionInfo",
                        value: (H = I(x().m(function e() {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getVersionInfo"));
                            }, e, this);
                        })), function() {
                            return H.apply(this, arguments);
                        })
                    },
                    {
                        key: "getSACBalance",
                        value: (G = I(x().m(function e(t, r, n) {
                            var o, i, s, u, c, l, f, p, d, h, y, m;
                            return x().w(function(e) {
                                for(;;)switch(e.n){
                                    case 0:
                                        if (o = t instanceof a.Address ? t.toString() : t, a.StrKey.isValidContract(o)) {
                                            e.n = 1;
                                            break;
                                        }
                                        throw new TypeError("expected contract ID, got ".concat(o));
                                    case 1:
                                        if (null == n) {
                                            e.n = 2;
                                            break;
                                        }
                                        m = n, e.n = 4;
                                        break;
                                    case 2:
                                        return e.n = 3, this.getNetwork().then(function(e) {
                                            return e.passphrase;
                                        });
                                    case 3:
                                        m = e.v;
                                    case 4:
                                        return i = m, s = r.contractId(i), u = (0, a.nativeToScVal)([
                                            "Balance",
                                            o
                                        ], {
                                            type: [
                                                "symbol",
                                                "address"
                                            ]
                                        }), c = a.xdr.LedgerKey.contractData(new a.xdr.LedgerKeyContractData({
                                            contract: new a.Address(s).toScAddress(),
                                            durability: a.xdr.ContractDataDurability.persistent(),
                                            key: u
                                        })), e.n = 5, this.getLedgerEntries(c);
                                    case 5:
                                        if (0 !== (l = e.v).entries.length) {
                                            e.n = 6;
                                            break;
                                        }
                                        return e.a(2, {
                                            latestLedger: l.latestLedger
                                        });
                                    case 6:
                                        if (f = l.entries[0], p = f.lastModifiedLedgerSeq, d = f.liveUntilLedgerSeq, (h = f.val).switch().value === a.xdr.LedgerEntryType.contractData().value) {
                                            e.n = 7;
                                            break;
                                        }
                                        return e.a(2, {
                                            latestLedger: l.latestLedger
                                        });
                                    case 7:
                                        return y = (0, a.scValToNative)(h.contractData().val()), e.a(2, {
                                            latestLedger: l.latestLedger,
                                            balanceEntry: {
                                                liveUntilLedgerSeq: d,
                                                lastModifiedLedgerSeq: p,
                                                amount: y.amount.toString(),
                                                authorized: y.authorized,
                                                clawback: y.clawback
                                            }
                                        });
                                }
                            }, e, this);
                        })), function(e, t, r) {
                            return G.apply(this, arguments);
                        })
                    },
                    {
                        key: "getLedgers",
                        value: (q = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, this._getLedgers(t).then(function(e) {
                                    return {
                                        ledgers: (e.ledgers || []).map(b.$E),
                                        latestLedger: e.latestLedger,
                                        latestLedgerCloseTime: e.latestLedgerCloseTime,
                                        oldestLedger: e.oldestLedger,
                                        oldestLedgerCloseTime: e.oldestLedgerCloseTime,
                                        cursor: e.cursor
                                    };
                                }));
                            }, e, this);
                        })), function(e) {
                            return q.apply(this, arguments);
                        })
                    },
                    {
                        key: "_getLedgers",
                        value: (V = I(x().m(function e(t) {
                            return x().w(function(e) {
                                for(;;)if (0 === e.n) return e.a(2, m(this.httpClient, this.serverURL.toString(), "getLedgers", t));
                            }, e, this);
                        })), function(e) {
                            return V.apply(this, arguments);
                        })
                    }
                ], D && B(F.prototype, D), M && B(F, M), Object.defineProperty(F, "prototype", {
                    writable: !1
                }), F);
                const we = (e = r.hmd(e)).exports;
            },
            784 (e, t, r) {
                "use strict";
                r.d(t, {
                    $D: ()=>d,
                    $E: ()=>y,
                    Af: ()=>c,
                    CA: ()=>m,
                    WC: ()=>l,
                    fG: ()=>p,
                    jr: ()=>h,
                    tR: ()=>f
                });
                var n = r(8950), o = r(4076);
                function i(e) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, i(e);
                }
                function a(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function s(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(r), !0).forEach(function(t) {
                            u(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function u(e, t, r) {
                    return (t = function(e) {
                        var t = function(e, t) {
                            if ("object" != i(e) || !e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(e, t || "default");
                                if ("object" != i(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(e, "string");
                        return "symbol" == i(t) ? t : t + "";
                    }(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function c(e) {
                    var t = e.errorResultXdr, r = e.diagnosticEventsXdr;
                    return delete e.errorResultXdr, delete e.diagnosticEventsXdr, t ? s(s(s({}, e), void 0 !== r && r.length > 0 && {
                        diagnosticEvents: r.map(function(e) {
                            return n.xdr.DiagnosticEvent.fromXDR(e, "base64");
                        })
                    }), {}, {
                        errorResult: n.xdr.TransactionResult.fromXDR(t, "base64")
                    }) : s({}, e);
                }
                function l(e) {
                    var t, r, o, i, a = n.xdr.TransactionMeta.fromXDR(e.resultMetaXdr, "base64"), s = {
                        ledger: e.ledger,
                        createdAt: e.createdAt,
                        applicationOrder: e.applicationOrder,
                        feeBump: e.feeBump,
                        envelopeXdr: n.xdr.TransactionEnvelope.fromXDR(e.envelopeXdr, "base64"),
                        resultXdr: n.xdr.TransactionResult.fromXDR(e.resultXdr, "base64"),
                        resultMetaXdr: a,
                        events: {
                            contractEventsXdr: (null !== (t = null === (r = e.events) || void 0 === r ? void 0 : r.contractEventsXdr) && void 0 !== t ? t : []).map(function(e) {
                                return e.map(function(e) {
                                    return n.xdr.ContractEvent.fromXDR(e, "base64");
                                });
                            }),
                            transactionEventsXdr: (null !== (o = null === (i = e.events) || void 0 === i ? void 0 : i.transactionEventsXdr) && void 0 !== o ? o : []).map(function(e) {
                                return n.xdr.TransactionEvent.fromXDR(e, "base64");
                            })
                        }
                    };
                    switch(a.switch()){
                        case 3:
                        case 4:
                            var u, c, l = a.value();
                            if (null !== l.sorobanMeta()) s.returnValue = null !== (u = null === (c = l.sorobanMeta()) || void 0 === c ? void 0 : c.returnValue()) && void 0 !== u ? u : void 0;
                    }
                    return e.diagnosticEventsXdr && (s.diagnosticEventsXdr = e.diagnosticEventsXdr.map(function(e) {
                        return n.xdr.DiagnosticEvent.fromXDR(e, "base64");
                    })), s;
                }
                function f(e) {
                    return s({
                        status: e.status,
                        txHash: e.txHash
                    }, l(e));
                }
                function p(e) {
                    var t;
                    return {
                        latestLedger: e.latestLedger,
                        oldestLedger: e.oldestLedger,
                        latestLedgerCloseTime: e.latestLedgerCloseTime,
                        oldestLedgerCloseTime: e.oldestLedgerCloseTime,
                        cursor: e.cursor,
                        events: (null !== (t = e.events) && void 0 !== t ? t : []).map(function(e) {
                            var t, r = s({}, e);
                            return delete r.contractId, s(s(s({}, r), "" !== e.contractId && {
                                contractId: new n.Contract(e.contractId)
                            }), {}, {
                                topic: (null !== (t = e.topic) && void 0 !== t ? t : []).map(function(e) {
                                    return n.xdr.ScVal.fromXDR(e, "base64");
                                }),
                                value: n.xdr.ScVal.fromXDR(e.value, "base64")
                            });
                        })
                    };
                }
                function d(e) {
                    var t;
                    return {
                        latestLedger: e.latestLedger,
                        entries: (null !== (t = e.entries) && void 0 !== t ? t : []).map(function(e) {
                            if (!e.key || !e.xdr) throw new TypeError("invalid ledger entry: ".concat(JSON.stringify(e)));
                            return s({
                                lastModifiedLedgerSeq: e.lastModifiedLedgerSeq,
                                key: n.xdr.LedgerKey.fromXDR(e.key, "base64"),
                                val: n.xdr.LedgerEntryData.fromXDR(e.xdr, "base64")
                            }, void 0 !== e.liveUntilLedgerSeq && {
                                liveUntilLedgerSeq: e.liveUntilLedgerSeq
                            });
                        })
                    };
                }
                function h(e) {
                    var t, r;
                    if (!o.j.isSimulationRaw(e)) return e;
                    var i = {
                        _parsed: !0,
                        id: e.id,
                        latestLedger: e.latestLedger,
                        events: null !== (t = null === (r = e.events) || void 0 === r ? void 0 : r.map(function(e) {
                            return n.xdr.DiagnosticEvent.fromXDR(e, "base64");
                        })) && void 0 !== t ? t : []
                    };
                    return "string" == typeof e.error ? s(s({}, i), {}, {
                        error: e.error
                    }) : function(e, t) {
                        var r, o, i, a, u, c = s(s(s({}, t), {}, {
                            transactionData: new n.SorobanDataBuilder(e.transactionData),
                            minResourceFee: e.minResourceFee
                        }, (null !== (r = null === (o = e.results) || void 0 === o ? void 0 : o.length) && void 0 !== r ? r : 0) > 0 && {
                            result: e.results.map(function(e) {
                                var t;
                                return {
                                    auth: (null !== (t = e.auth) && void 0 !== t ? t : []).map(function(e) {
                                        return n.xdr.SorobanAuthorizationEntry.fromXDR(e, "base64");
                                    }),
                                    retval: e.xdr ? n.xdr.ScVal.fromXDR(e.xdr, "base64") : n.xdr.ScVal.scvVoid()
                                };
                            })[0]
                        }), (null !== (i = null === (a = e.stateChanges) || void 0 === a ? void 0 : a.length) && void 0 !== i ? i : 0) > 0 && {
                            stateChanges: null === (u = e.stateChanges) || void 0 === u ? void 0 : u.map(function(e) {
                                return {
                                    type: e.type,
                                    key: n.xdr.LedgerKey.fromXDR(e.key, "base64"),
                                    before: e.before ? n.xdr.LedgerEntry.fromXDR(e.before, "base64") : null,
                                    after: e.after ? n.xdr.LedgerEntry.fromXDR(e.after, "base64") : null
                                };
                            })
                        });
                        return e.restorePreamble && "" !== e.restorePreamble.transactionData ? s(s({}, c), {}, {
                            restorePreamble: {
                                minResourceFee: e.restorePreamble.minResourceFee,
                                transactionData: new n.SorobanDataBuilder(e.restorePreamble.transactionData)
                            }
                        }) : c;
                    }(e, i);
                }
                function y(e) {
                    var t;
                    if (!e.metadataXdr || !e.headerXdr) throw t = e.metadataXdr || e.headerXdr ? e.metadataXdr ? "headerXdr" : "metadataXdr" : "metadataXdr and headerXdr", new TypeError("invalid ledger missing fields: ".concat(t));
                    var r = n.xdr.LedgerCloseMeta.fromXDR(e.metadataXdr, "base64"), o = n.xdr.LedgerHeaderHistoryEntry.fromXDR(e.headerXdr, "base64");
                    return {
                        hash: e.hash,
                        sequence: e.sequence,
                        ledgerCloseTime: e.ledgerCloseTime,
                        metadataXdr: r,
                        headerXdr: o
                    };
                }
                function m(e) {
                    var t, r = n.xdr.LedgerHeader.fromXDR(e.headerXdr, "base64"), o = n.xdr.LedgerCloseMeta.fromXDR(e.metadataXdr, "base64");
                    if (e.metadataXdr || e.headerXdr ? e.metadataXdr ? e.headerXdr || (t = "headerXdr") : t = "metadataXdr" : t = "metadataXdr and headerXdr", t) throw new TypeError("invalid getLatestLedger response missing fields: ".concat(t));
                    return {
                        id: e.id,
                        sequence: e.sequence,
                        protocolVersion: e.protocolVersion,
                        closeTime: e.closeTime,
                        headerXdr: r,
                        metadataXdr: o
                    };
                }
            },
            8680 (e, t, r) {
                "use strict";
                r.d(t, {
                    X: ()=>a
                });
                var n = r(8950), o = r(4076), i = r(784);
                function a(e, t) {
                    if ("innerTransaction" in e) return a(e.innerTransaction, t);
                    if (!function(e) {
                        if (1 !== e.operations.length) return !1;
                        switch(e.operations[0].type){
                            case "invokeHostFunction":
                            case "extendFootprintTtl":
                            case "restoreFootprint":
                                return !0;
                            default:
                                return !1;
                        }
                    }(e)) throw new TypeError("unsupported transaction: must contain exactly one invokeHostFunction, extendFootprintTtl, or restoreFootprint operation");
                    var r, s = (0, i.jr)(t);
                    if (!o.j.isSimulationSuccess(s)) throw new Error("simulation incorrect: ".concat(JSON.stringify(s)));
                    try {
                        r = BigInt(e.fee);
                    } catch (e) {
                        r = BigInt(0);
                    }
                    var u = e.toEnvelope().v1().tx().ext().value();
                    u && r - u.resourceFee().toBigInt() > BigInt(0) && (r -= u.resourceFee().toBigInt());
                    var c = n.TransactionBuilder.cloneFrom(e, {
                        fee: r.toString(),
                        sorobanData: s.transactionData.build(),
                        networkPassphrase: e.networkPassphrase
                    });
                    if ("invokeHostFunction" === e.operations[0].type) {
                        var l;
                        c.clearOperations();
                        var f = e.operations[0], p = null !== (l = f.auth) && void 0 !== l ? l : [];
                        c.addOperation(n.Operation.invokeHostFunction({
                            source: f.source,
                            func: f.func,
                            auth: p.length > 0 ? p : s.result.auth
                        }));
                    }
                    return c;
                }
            },
            3898 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    Api: ()=>{},
                    Resolver: ()=>w,
                    STELLAR_TOML_MAX_SIZE: ()=>v
                });
                var n = r(1293), o = r.n(n), i = r(9983), a = r(8732);
                function s(e) {
                    return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, s(e);
                }
                function u() {
                    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
                    function i(r, n, o, i) {
                        var u = n && n.prototype instanceof s ? n : s, l = Object.create(u.prototype);
                        return c(l, "_invoke", function(r, n, o) {
                            var i, s, u, c = 0, l = o || [], f = !1, p = {
                                p: 0,
                                n: 0,
                                v: e,
                                a: d,
                                f: d.bind(e, 4),
                                d: function(t, r) {
                                    return i = t, s = 0, u = e, p.n = r, a;
                                }
                            };
                            function d(r, n) {
                                for(s = r, u = n, t = 0; !f && c && !o && t < l.length; t++){
                                    var o, i = l[t], d = p.p, h = i[2];
                                    r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                                }
                                if (o || r > 1) return a;
                                throw f = !0, n;
                            }
                            return function(o, l, h) {
                                if (c > 1) throw TypeError("Generator is already running");
                                for(f && 1 === l && d(l, h), s = l, u = h; (t = s < 2 ? e : u) || !f;){
                                    i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                                    try {
                                        if (c = 2, i) {
                                            if (s || (o = "next"), t = i[o]) {
                                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                                if (!t.done) return t;
                                                u = t.value, s < 2 && (s = 0);
                                            } else 1 === s && (t = i.return) && t.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                            i = e;
                                        } else if ((t = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                                    } catch (t) {
                                        i = e, s = 1, u = t;
                                    } finally{
                                        c = 1;
                                    }
                                }
                                return {
                                    value: t,
                                    done: f
                                };
                            };
                        }(r, o, i), !0), l;
                    }
                    var a = {};
                    function s() {}
                    function l() {}
                    function f() {}
                    t = Object.getPrototypeOf;
                    var p = [][n] ? t(t([][n]())) : (c(t = {}, n, function() {
                        return this;
                    }), t), d = f.prototype = s.prototype = Object.create(p);
                    function h(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, c(e, o, "GeneratorFunction")), e.prototype = Object.create(d), e;
                    }
                    return l.prototype = f, c(d, "constructor", f), c(f, "constructor", l), l.displayName = "GeneratorFunction", c(f, o, "GeneratorFunction"), c(d), c(d, o, "Generator"), c(d, n, function() {
                        return this;
                    }), c(d, "toString", function() {
                        return "[object Generator]";
                    }), (u = function() {
                        return {
                            w: i,
                            m: h
                        };
                    })();
                }
                function c(e, t, r, n) {
                    var o = Object.defineProperty;
                    try {
                        o({}, "", {});
                    } catch (e) {
                        o = 0;
                    }
                    c = function(e, t, r, n) {
                        function i(t, r) {
                            c(e, t, function(e) {
                                return this._invoke(t, r, e);
                            });
                        }
                        t ? o ? o(e, t, {
                            value: r,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        }) : e[t] = r : (i("next", 0), i("throw", 1), i("return", 2));
                    }, c(e, t, r, n);
                }
                function l(e, t, r, n, o, i, a) {
                    try {
                        var s = e[i](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, o);
                }
                function f(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, p(n.key), n);
                    }
                }
                function p(e) {
                    var t = function(e, t) {
                        if ("object" != s(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != s(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == s(t) ? t : t + "";
                }
                var d, h, y, m, g, v = 102400, b = i.ok.CancelToken, w = (d = function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }, h = null, y = [
                    {
                        key: "resolve",
                        value: (m = u().m(function e(t) {
                            var r, n, s, c, l, f = arguments;
                            return u().w(function(e) {
                                for(;;)if (0 === e.n) return s = void 0 === (n = f.length > 1 && void 0 !== f[1] ? f[1] : {}).allowHttp ? a.T.isAllowHttp() : n.allowHttp, c = void 0 === n.timeout ? a.T.getTimeout() : n.timeout, l = s ? "http" : "https", e.a(2, i.ok.get("".concat(l, "://").concat(t, "/.well-known/stellar.toml"), {
                                    maxRedirects: null !== (r = n.allowedRedirects) && void 0 !== r ? r : 0,
                                    maxContentLength: v,
                                    cancelToken: c ? new b(function(e) {
                                        return setTimeout(function() {
                                            return e("timeout of ".concat(c, "ms exceeded"));
                                        }, c);
                                    }) : void 0,
                                    timeout: c
                                }).then(function(e) {
                                    try {
                                        var t = o().parse(e.data);
                                        return Promise.resolve(t);
                                    } catch (e) {
                                        return Promise.reject(new Error("stellar.toml is invalid - Parsing error on line ".concat(e.line, ", column ").concat(e.column, ": ").concat(e.message)));
                                    }
                                }).catch(function(e) {
                                    throw e.message.match(/^maxContentLength size/) ? new Error("stellar.toml file exceeds allowed size of ".concat(v)) : e;
                                }));
                            }, e);
                        }), g = function() {
                            var e = this, t = arguments;
                            return new Promise(function(r, n) {
                                var o = m.apply(e, t);
                                function i(e) {
                                    l(o, r, n, i, a, "next", e);
                                }
                                function a(e) {
                                    l(o, r, n, i, a, "throw", e);
                                }
                                i(void 0);
                            });
                        }, function(e) {
                            return g.apply(this, arguments);
                        })
                    }
                ], h && f(d.prototype, h), y && f(d, y), Object.defineProperty(d, "prototype", {
                    writable: !1
                }), d);
            },
            3121 (e, t, r) {
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, i(n.key), n);
                    }
                }
                function i(e) {
                    var t = function(e, t) {
                        if ("object" != n(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, t || "default");
                            if ("object" != n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == n(t) ? t : t + "";
                }
                r.d(t, {
                    A: ()=>c
                });
                var a, s, u, c = (a = function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }, u = [
                    {
                        key: "validateTimebounds",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                            if (!e.timeBounds) return !1;
                            var r = Math.floor(Date.now() / 1e3), n = e.timeBounds, o = n.minTime, i = n.maxTime;
                            return r >= Number.parseInt(o, 10) - t && r <= Number.parseInt(i, 10) + t;
                        }
                    },
                    {
                        key: "sleep",
                        value: function(e) {
                            return new Promise(function(t) {
                                return setTimeout(t, e);
                            });
                        }
                    }
                ], s = null, u && o(a, u), Object.defineProperty(a, "prototype", {
                    writable: !1
                }), a);
            },
            7504 (e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    InvalidChallengeError: ()=>p,
                    buildChallengeTx: ()=>P,
                    gatherTxSigners: ()=>m,
                    readChallengeTx: ()=>R,
                    verifyChallengeTxSigners: ()=>I,
                    verifyChallengeTxThreshold: ()=>B,
                    verifyTxSignedBy: ()=>g
                });
                var n = r(8950);
                function o(e) {
                    return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, o(e);
                }
                function i(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != o(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == o(t) ? t : t + "";
                }
                function s(e, t, r) {
                    return t = f(t), function(e, t) {
                        if (t && ("object" == o(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, c() ? Reflect.construct(t, r || [], f(e).constructor) : t.apply(e, r));
                }
                function u(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return u = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return function(e, t, r) {
                                if (c()) return Reflect.construct.apply(null, arguments);
                                var n = [
                                    null
                                ];
                                n.push.apply(n, t);
                                var o = new (e.bind.apply(e, n));
                                return r && l(o, r.prototype), o;
                            }(e, arguments, f(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), l(r, e);
                    }, u(e);
                }
                function c() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (c = function() {
                        return !!e;
                    })();
                }
                function l(e, t) {
                    return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, l(e, t);
                }
                function f(e) {
                    return f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, f(e);
                }
                var p = function(e) {
                    function t() {
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, t), s(this, t, arguments);
                    }
                    var r, n, o;
                    return function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && l(e, t);
                    }(t, e), r = t, n && i(r.prototype, n), o && i(r, o), Object.defineProperty(r, "prototype", {
                        writable: !1
                    }), r;
                }(u(Error));
                function d(e) {
                    return function(e) {
                        if (Array.isArray(e)) return y(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || h(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function h(e, t) {
                    if (e) {
                        if ("string" == typeof e) return y(e, t);
                        var r = ({}).toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y(e, t) : void 0;
                    }
                }
                function y(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function m(e, t) {
                    var r, o = e.hash(), i = d(e.signatures), a = new Set, s = function(e, t) {
                        var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (!r) {
                            if (Array.isArray(e) || (r = h(e)) || t && e && "number" == typeof e.length) {
                                r && (e = r);
                                var n = 0, o = function() {};
                                return {
                                    s: o,
                                    n: function() {
                                        return n >= e.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e[n++]
                                        };
                                    },
                                    e: function(e) {
                                        throw e;
                                    },
                                    f: o
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var i, a = !0, s = !1;
                        return {
                            s: function() {
                                r = r.call(e);
                            },
                            n: function() {
                                var e = r.next();
                                return a = e.done, e;
                            },
                            e: function(e) {
                                s = !0, i = e;
                            },
                            f: function() {
                                try {
                                    a || null == r.return || r.return();
                                } finally{
                                    if (s) throw i;
                                }
                            }
                        };
                    }(t);
                    try {
                        for(s.s(); !(r = s.n()).done;){
                            var u = r.value;
                            if (0 === i.length) break;
                            var c = void 0;
                            try {
                                c = n.Keypair.fromPublicKey(u);
                            } catch (e) {
                                throw new p("Signer is not a valid address: ".concat(e.message));
                            }
                            for(var l = 0; l < i.length; l++){
                                var f = i[l];
                                if (f.hint().equals(c.signatureHint()) && c.verify(o, f.signature())) {
                                    a.add(u), i.splice(l, 1);
                                    break;
                                }
                            }
                        }
                    } catch (e) {
                        s.e(e);
                    } finally{
                        s.f();
                    }
                    return Array.from(a);
                }
                function g(e, t) {
                    return 0 !== m(e, [
                        t
                    ]).length;
                }
                var v = r(3209), b = r.n(v), w = r(3121), S = r(8287).Buffer;
                function A(e) {
                    return function(e) {
                        if (Array.isArray(e)) return _(e);
                    }(e) || x(e) || k(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function E(e, t) {
                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e) || (r = k(e)) || t && e && "number" == typeof e.length) {
                            r && (e = r);
                            var n = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return n >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[n++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, s = !1;
                    return {
                        s: function() {
                            r = r.call(e);
                        },
                        n: function() {
                            var e = r.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            s = !0, i = e;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                    };
                }
                function T(e) {
                    return T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, T(e);
                }
                function O(e) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || x(e) || k(e) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function k(e, t) {
                    if (e) {
                        if ("string" == typeof e) return _(e, t);
                        var r = ({}).toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _(e, t) : void 0;
                    }
                }
                function _(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function x(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }
                function P(e, t, r) {
                    var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 300, i = arguments.length > 4 ? arguments[4] : void 0, a = arguments.length > 5 ? arguments[5] : void 0, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, c = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null;
                    if (t.startsWith("M") && s) throw Error("memo cannot be used if clientAccountID is a muxed account");
                    var l = new n.Account(e.publicKey(), "-1"), f = Math.floor(Date.now() / 1e3), p = b()(48).toString("base64"), d = new n.TransactionBuilder(l, {
                        fee: n.BASE_FEE,
                        networkPassphrase: i,
                        timebounds: {
                            minTime: f,
                            maxTime: f + o
                        }
                    }).addOperation(n.Operation.manageData({
                        name: "".concat(r, " auth"),
                        value: p,
                        source: t
                    })).addOperation(n.Operation.manageData({
                        name: "web_auth_domain",
                        value: a,
                        source: l.accountId()
                    }));
                    if (u) {
                        if (!c) throw Error("clientSigningKey is required if clientDomain is provided");
                        d.addOperation(n.Operation.manageData({
                            name: "client_domain",
                            value: u,
                            source: c
                        }));
                    }
                    s && d.addMemo(n.Memo.id(s));
                    var h = d.build();
                    return h.sign(e), h.toEnvelope().toXDR("base64").toString();
                }
                function R(e, t, r, o, i) {
                    var a, s;
                    if (t.startsWith("M")) throw Error("Invalid serverAccountID: multiplexed accounts are not supported.");
                    try {
                        s = new n.Transaction(e, r);
                    } catch (t) {
                        try {
                            s = new n.FeeBumpTransaction(e, r);
                        } catch (e) {
                            throw new p("Invalid challenge: unable to deserialize challengeTx transaction string");
                        }
                        throw new p("Invalid challenge: expected a Transaction but received a FeeBumpTransaction");
                    }
                    if (0 !== Number.parseInt(s.sequence, 10)) throw new p("The transaction sequence number should be zero");
                    if (s.source !== t) throw new p("The transaction source account is not equal to the server's account");
                    if (s.operations.length < 1) throw new p("The transaction should contain at least one operation");
                    var u = O(s.operations), c = u[0], l = _(u).slice(1);
                    if (!c.source) throw new p("The transaction's operation should contain a source account");
                    var f, d = c.source, h = null;
                    if (s.memo.type !== n.MemoNone) {
                        if (d.startsWith("M")) throw new p("The transaction has a memo but the client account ID is a muxed account");
                        if (s.memo.type !== n.MemoID) throw new p("The transaction's memo must be of type `id`");
                        h = s.memo.value;
                    }
                    if ("manageData" !== c.type) throw new p("The transaction's operation type should be 'manageData'");
                    if (s.timeBounds && Number.parseInt(null === (a = s.timeBounds) || void 0 === a ? void 0 : a.maxTime, 10) === n.TimeoutInfinite) throw new p("The transaction requires non-infinite timebounds");
                    if (!w.A.validateTimebounds(s, 300)) throw new p("The transaction has expired");
                    if (void 0 === c.value) throw new p("The transaction's operation values should not be null");
                    if (!c.value) throw new p("The transaction's operation value should not be null");
                    if (48 !== S.from(c.value.toString(), "base64").length) throw new p("The transaction's operation value should be a 64 bytes base64 random string");
                    if (!o) throw new p("Invalid homeDomains: a home domain must be provided for verification");
                    if ("string" == typeof o) "".concat(o, " auth") === c.name && (f = o);
                    else {
                        if (!Array.isArray(o)) throw new p("Invalid homeDomains: homeDomains type is ".concat(T(o), " but should be a string or an array"));
                        f = o.find(function(e) {
                            return "".concat(e, " auth") === c.name;
                        });
                    }
                    if (!f) throw new p("Invalid homeDomains: the transaction's operation key name does not match the expected home domain");
                    var y, m = E(l);
                    try {
                        for(m.s(); !(y = m.n()).done;){
                            var v = y.value;
                            if ("manageData" !== v.type) throw new p("The transaction has operations that are not of type 'manageData'");
                            if (v.source !== t && "client_domain" !== v.name) throw new p("The transaction has operations that are unrecognized");
                            if ("web_auth_domain" === v.name) {
                                if (void 0 === v.value) throw new p("'web_auth_domain' operation value should not be null");
                                if (v.value.compare(S.from(i))) throw new p("'web_auth_domain' operation value does not match ".concat(i));
                            }
                        }
                    } catch (e) {
                        m.e(e);
                    } finally{
                        m.f();
                    }
                    if (!g(s, t)) throw new p("Transaction not signed by server: '".concat(t, "'"));
                    return {
                        tx: s,
                        clientAccountID: d,
                        matchedHomeDomain: f,
                        memo: h
                    };
                }
                function I(e, t, r, o, i, a) {
                    var s, u = R(e, t, r, i, a).tx;
                    try {
                        s = n.Keypair.fromPublicKey(t);
                    } catch (e) {
                        throw new Error("Couldn't infer keypair from the provided 'serverAccountID': ".concat(e.message));
                    }
                    var c, l, f = new Set, d = E(o);
                    try {
                        for(d.s(); !(c = d.n()).done;){
                            var h = c.value;
                            h !== s.publicKey() && "G" === h.charAt(0) && f.add(h);
                        }
                    } catch (e) {
                        d.e(e);
                    } finally{
                        d.f();
                    }
                    if (0 === f.size) throw new p("No verifiable client signers provided, at least one G... address must be provided");
                    var y, g = E(u.operations);
                    try {
                        for(g.s(); !(y = g.n()).done;){
                            var v = y.value;
                            if ("manageData" === v.type && "client_domain" === v.name) {
                                if (l) throw new p("Found more than one client_domain operation");
                                l = v.source;
                            }
                        }
                    } catch (e) {
                        g.e(e);
                    } finally{
                        g.f();
                    }
                    var b = [
                        s.publicKey()
                    ].concat(A(Array.from(f)));
                    l && b.push(l);
                    var w, S = m(u, b), T = !1, O = !1, k = E(S);
                    try {
                        for(k.s(); !(w = k.n()).done;){
                            var _ = w.value;
                            _ === s.publicKey() && (T = !0), _ === l && (O = !0);
                        }
                    } catch (e) {
                        k.e(e);
                    } finally{
                        k.f();
                    }
                    if (!T) throw new p("Transaction not signed by server: '".concat(s.publicKey(), "'"));
                    if (l && !O) throw new p("Transaction not signed by the source account of the 'client_domain' ManageData operation");
                    if (1 === S.length) throw new p("None of the given signers match the transaction signatures");
                    if (S.length !== u.signatures.length) throw new p("Transaction has unrecognized signatures");
                    if (S.splice(S.indexOf(s.publicKey()), 1), l && S.splice(S.indexOf(l), 1), 0 === S.length) throw new p("None of the given signers match the transaction signatures");
                    return S;
                }
                function B(e, t, r, n, o, i, a) {
                    var s, u = I(e, t, r, o.map(function(e) {
                        return e.key;
                    }), i, a), c = 0, l = E(u);
                    try {
                        var f = function() {
                            var e, t = s.value, r = (null === (e = o.find(function(e) {
                                return e.key === t;
                            })) || void 0 === e ? void 0 : e.weight) || 0;
                            c += r;
                        };
                        for(l.s(); !(s = l.n()).done;)f();
                    } catch (e) {
                        l.e(e);
                    } finally{
                        l.f();
                    }
                    if (c < n) throw new p("signers with weight ".concat(c, " do not meet threshold ").concat(n, '"'));
                    return u;
                }
            },
            7526 (e, t) {
                "use strict";
                t.byteLength = function(e) {
                    var t = s(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, t.toByteArray = function(e) {
                    var t, r, i = s(e), a = i[0], u = i[1], c = new o(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, a, u)), l = 0, f = u > 0 ? a - 4 : a;
                    for(r = 0; r < f; r += 4)t = n[e.charCodeAt(r)] << 18 | n[e.charCodeAt(r + 1)] << 12 | n[e.charCodeAt(r + 2)] << 6 | n[e.charCodeAt(r + 3)], c[l++] = t >> 16 & 255, c[l++] = t >> 8 & 255, c[l++] = 255 & t;
                    2 === u && (t = n[e.charCodeAt(r)] << 2 | n[e.charCodeAt(r + 1)] >> 4, c[l++] = 255 & t);
                    1 === u && (t = n[e.charCodeAt(r)] << 10 | n[e.charCodeAt(r + 1)] << 4 | n[e.charCodeAt(r + 2)] >> 2, c[l++] = t >> 8 & 255, c[l++] = 255 & t);
                    return c;
                }, t.fromByteArray = function(e) {
                    for(var t, n = e.length, o = n % 3, i = [], a = 16383, s = 0, u = n - o; s < u; s += a)i.push(c(e, s, s + a > u ? u : s + a));
                    1 === o ? (t = e[n - 1], i.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === o && (t = (e[n - 2] << 8) + e[n - 1], i.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
                    return i.join("");
                };
                for(var r = [], n = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0; a < 64; ++a)r[a] = i[a], n[i.charCodeAt(a)] = a;
                function s(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e) {
                    return r[e >> 18 & 63] + r[e >> 12 & 63] + r[e >> 6 & 63] + r[63 & e];
                }
                function c(e, t, r) {
                    for(var n, o = [], i = t; i < r; i += 3)n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push(u(n));
                    return o.join("");
                }
                n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
            },
            8287 (e, t, r) {
                "use strict";
                const n = r(7526), o = r(251), i = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
                t.Buffer = u, t.SlowBuffer = function(e) {
                    +e != e && (e = 0);
                    return u.alloc(+e);
                }, t.INSPECT_MAX_BYTES = 50;
                const a = 2147483647;
                function s(e) {
                    if (e > a) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                    const t = new Uint8Array(e);
                    return Object.setPrototypeOf(t, u.prototype), t;
                }
                function u(e, t, r) {
                    if ("number" == typeof e) {
                        if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                        return f(e);
                    }
                    return c(e, t, r);
                }
                function c(e, t, r) {
                    if ("string" == typeof e) return function(e, t) {
                        "string" == typeof t && "" !== t || (t = "utf8");
                        if (!u.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                        const r = 0 | y(e, t);
                        let n = s(r);
                        const o = n.write(e, t);
                        o !== r && (n = n.slice(0, o));
                        return n;
                    }(e, t);
                    if (ArrayBuffer.isView(e)) return function(e) {
                        if (Z(e, Uint8Array)) {
                            const t = new Uint8Array(e);
                            return d(t.buffer, t.byteOffset, t.byteLength);
                        }
                        return p(e);
                    }(e);
                    if (null == e) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                    if (Z(e, ArrayBuffer) || e && Z(e.buffer, ArrayBuffer)) return d(e, t, r);
                    if ("undefined" != typeof SharedArrayBuffer && (Z(e, SharedArrayBuffer) || e && Z(e.buffer, SharedArrayBuffer))) return d(e, t, r);
                    if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                    const n = e.valueOf && e.valueOf();
                    if (null != n && n !== e) return u.from(n, t, r);
                    const o = function(e) {
                        if (u.isBuffer(e)) {
                            const t = 0 | h(e.length), r = s(t);
                            return 0 === r.length || e.copy(r, 0, 0, t), r;
                        }
                        if (void 0 !== e.length) return "number" != typeof e.length || $(e.length) ? s(0) : p(e);
                        if ("Buffer" === e.type && Array.isArray(e.data)) return p(e.data);
                    }(e);
                    if (o) return o;
                    if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return u.from(e[Symbol.toPrimitive]("string"), t, r);
                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                }
                function l(e) {
                    if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                    if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                }
                function f(e) {
                    return l(e), s(e < 0 ? 0 : 0 | h(e));
                }
                function p(e) {
                    const t = e.length < 0 ? 0 : 0 | h(e.length), r = s(t);
                    for(let n = 0; n < t; n += 1)r[n] = 255 & e[n];
                    return r;
                }
                function d(e, t, r) {
                    if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                    if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                    let n;
                    return n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r), Object.setPrototypeOf(n, u.prototype), n;
                }
                function h(e) {
                    if (e >= a) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
                    return 0 | e;
                }
                function y(e, t) {
                    if (u.isBuffer(e)) return e.length;
                    if (ArrayBuffer.isView(e) || Z(e, ArrayBuffer)) return e.byteLength;
                    if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                    const r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                    if (!n && 0 === r) return 0;
                    let o = !1;
                    for(;;)switch(t){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return r;
                        case "utf8":
                        case "utf-8":
                            return W(e).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return 2 * r;
                        case "hex":
                            return r >>> 1;
                        case "base64":
                            return X(e).length;
                        default:
                            if (o) return n ? -1 : W(e).length;
                            t = ("" + t).toLowerCase(), o = !0;
                    }
                }
                function m(e, t, r) {
                    let n = !1;
                    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                    if ((r >>>= 0) <= (t >>>= 0)) return "";
                    for(e || (e = "utf8");;)switch(e){
                        case "hex":
                            return R(this, t, r);
                        case "utf8":
                        case "utf-8":
                            return k(this, t, r);
                        case "ascii":
                            return x(this, t, r);
                        case "latin1":
                        case "binary":
                            return P(this, t, r);
                        case "base64":
                            return O(this, t, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return I(this, t, r);
                        default:
                            if (n) throw new TypeError("Unknown encoding: " + e);
                            e = (e + "").toLowerCase(), n = !0;
                    }
                }
                function g(e, t, r) {
                    const n = e[t];
                    e[t] = e[r], e[r] = n;
                }
                function v(e, t, r, n, o) {
                    if (0 === e.length) return -1;
                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), $(r = +r) && (r = o ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                        if (o) return -1;
                        r = e.length - 1;
                    } else if (r < 0) {
                        if (!o) return -1;
                        r = 0;
                    }
                    if ("string" == typeof t && (t = u.from(t, n)), u.isBuffer(t)) return 0 === t.length ? -1 : b(e, t, r, n, o);
                    if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : b(e, [
                        t
                    ], r, n, o);
                    throw new TypeError("val must be string, number or Buffer");
                }
                function b(e, t, r, n, o) {
                    let i, a = 1, s = e.length, u = t.length;
                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                        if (e.length < 2 || t.length < 2) return -1;
                        a = 2, s /= 2, u /= 2, r /= 2;
                    }
                    function c(e, t) {
                        return 1 === a ? e[t] : e.readUInt16BE(t * a);
                    }
                    if (o) {
                        let n = -1;
                        for(i = r; i < s; i++)if (c(e, i) === c(t, -1 === n ? 0 : i - n)) {
                            if (-1 === n && (n = i), i - n + 1 === u) return n * a;
                        } else -1 !== n && (i -= i - n), n = -1;
                    } else for(r + u > s && (r = s - u), i = r; i >= 0; i--){
                        let r = !0;
                        for(let n = 0; n < u; n++)if (c(e, i + n) !== c(t, n)) {
                            r = !1;
                            break;
                        }
                        if (r) return i;
                    }
                    return -1;
                }
                function w(e, t, r, n) {
                    r = Number(r) || 0;
                    const o = e.length - r;
                    n ? (n = Number(n)) > o && (n = o) : n = o;
                    const i = t.length;
                    let a;
                    for(n > i / 2 && (n = i / 2), a = 0; a < n; ++a){
                        const n = parseInt(t.substr(2 * a, 2), 16);
                        if ($(n)) return a;
                        e[r + a] = n;
                    }
                    return a;
                }
                function S(e, t, r, n) {
                    return K(W(t, e.length - r), e, r, n);
                }
                function A(e, t, r, n) {
                    return K(function(e) {
                        const t = [];
                        for(let r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                        return t;
                    }(t), e, r, n);
                }
                function E(e, t, r, n) {
                    return K(X(t), e, r, n);
                }
                function T(e, t, r, n) {
                    return K(function(e, t) {
                        let r, n, o;
                        const i = [];
                        for(let a = 0; a < e.length && !((t -= 2) < 0); ++a)r = e.charCodeAt(a), n = r >> 8, o = r % 256, i.push(o), i.push(n);
                        return i;
                    }(t, e.length - r), e, r, n);
                }
                function O(e, t, r) {
                    return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
                }
                function k(e, t, r) {
                    r = Math.min(e.length, r);
                    const n = [];
                    let o = t;
                    for(; o < r;){
                        const t = e[o];
                        let i = null, a = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
                        if (o + a <= r) {
                            let r, n, s, u;
                            switch(a){
                                case 1:
                                    t < 128 && (i = t);
                                    break;
                                case 2:
                                    r = e[o + 1], 128 == (192 & r) && (u = (31 & t) << 6 | 63 & r, u > 127 && (i = u));
                                    break;
                                case 3:
                                    r = e[o + 1], n = e[o + 2], 128 == (192 & r) && 128 == (192 & n) && (u = (15 & t) << 12 | (63 & r) << 6 | 63 & n, u > 2047 && (u < 55296 || u > 57343) && (i = u));
                                    break;
                                case 4:
                                    r = e[o + 1], n = e[o + 2], s = e[o + 3], 128 == (192 & r) && 128 == (192 & n) && 128 == (192 & s) && (u = (15 & t) << 18 | (63 & r) << 12 | (63 & n) << 6 | 63 & s, u > 65535 && u < 1114112 && (i = u));
                            }
                        }
                        null === i ? (i = 65533, a = 1) : i > 65535 && (i -= 65536, n.push(i >>> 10 & 1023 | 55296), i = 56320 | 1023 & i), n.push(i), o += a;
                    }
                    return function(e) {
                        const t = e.length;
                        if (t <= _) return String.fromCharCode.apply(String, e);
                        let r = "", n = 0;
                        for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += _));
                        return r;
                    }(n);
                }
                t.kMaxLength = a, u.TYPED_ARRAY_SUPPORT = function() {
                    try {
                        const e = new Uint8Array(1), t = {
                            foo: function() {
                                return 42;
                            }
                        };
                        return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e, t), 42 === e.foo();
                    } catch (e) {
                        return !1;
                    }
                }(), u.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(u.prototype, "parent", {
                    enumerable: !0,
                    get: function() {
                        if (u.isBuffer(this)) return this.buffer;
                    }
                }), Object.defineProperty(u.prototype, "offset", {
                    enumerable: !0,
                    get: function() {
                        if (u.isBuffer(this)) return this.byteOffset;
                    }
                }), u.poolSize = 8192, u.from = function(e, t, r) {
                    return c(e, t, r);
                }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array), u.alloc = function(e, t, r) {
                    return function(e, t, r) {
                        return l(e), e <= 0 ? s(e) : void 0 !== t ? "string" == typeof r ? s(e).fill(t, r) : s(e).fill(t) : s(e);
                    }(e, t, r);
                }, u.allocUnsafe = function(e) {
                    return f(e);
                }, u.allocUnsafeSlow = function(e) {
                    return f(e);
                }, u.isBuffer = function(e) {
                    return null != e && !0 === e._isBuffer && e !== u.prototype;
                }, u.compare = function(e, t) {
                    if (Z(e, Uint8Array) && (e = u.from(e, e.offset, e.byteLength)), Z(t, Uint8Array) && (t = u.from(t, t.offset, t.byteLength)), !u.isBuffer(e) || !u.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                    if (e === t) return 0;
                    let r = e.length, n = t.length;
                    for(let o = 0, i = Math.min(r, n); o < i; ++o)if (e[o] !== t[o]) {
                        r = e[o], n = t[o];
                        break;
                    }
                    return r < n ? -1 : n < r ? 1 : 0;
                }, u.isEncoding = function(e) {
                    switch(String(e).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return !0;
                        default:
                            return !1;
                    }
                }, u.concat = function(e, t) {
                    if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (0 === e.length) return u.alloc(0);
                    let r;
                    if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                    const n = u.allocUnsafe(t);
                    let o = 0;
                    for(r = 0; r < e.length; ++r){
                        let t = e[r];
                        if (Z(t, Uint8Array)) o + t.length > n.length ? (u.isBuffer(t) || (t = u.from(t)), t.copy(n, o)) : Uint8Array.prototype.set.call(n, t, o);
                        else {
                            if (!u.isBuffer(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                            t.copy(n, o);
                        }
                        o += t.length;
                    }
                    return n;
                }, u.byteLength = y, u.prototype._isBuffer = !0, u.prototype.swap16 = function() {
                    const e = this.length;
                    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(let t = 0; t < e; t += 2)g(this, t, t + 1);
                    return this;
                }, u.prototype.swap32 = function() {
                    const e = this.length;
                    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(let t = 0; t < e; t += 4)g(this, t, t + 3), g(this, t + 1, t + 2);
                    return this;
                }, u.prototype.swap64 = function() {
                    const e = this.length;
                    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(let t = 0; t < e; t += 8)g(this, t, t + 7), g(this, t + 1, t + 6), g(this, t + 2, t + 5), g(this, t + 3, t + 4);
                    return this;
                }, u.prototype.toString = function() {
                    const e = this.length;
                    return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : m.apply(this, arguments);
                }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(e) {
                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                    return this === e || 0 === u.compare(this, e);
                }, u.prototype.inspect = function() {
                    let e = "";
                    const r = t.INSPECT_MAX_BYTES;
                    return e = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (e += " ... "), "<Buffer " + e + ">";
                }, i && (u.prototype[i] = u.prototype.inspect), u.prototype.compare = function(e, t, r, n, o) {
                    if (Z(e, Uint8Array) && (e = u.from(e, e.offset, e.byteLength)), !u.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                    if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), t < 0 || r > e.length || n < 0 || o > this.length) throw new RangeError("out of range index");
                    if (n >= o && t >= r) return 0;
                    if (n >= o) return -1;
                    if (t >= r) return 1;
                    if (this === e) return 0;
                    let i = (o >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0);
                    const s = Math.min(i, a), c = this.slice(n, o), l = e.slice(t, r);
                    for(let e = 0; e < s; ++e)if (c[e] !== l[e]) {
                        i = c[e], a = l[e];
                        break;
                    }
                    return i < a ? -1 : a < i ? 1 : 0;
                }, u.prototype.includes = function(e, t, r) {
                    return -1 !== this.indexOf(e, t, r);
                }, u.prototype.indexOf = function(e, t, r) {
                    return v(this, e, t, r, !0);
                }, u.prototype.lastIndexOf = function(e, t, r) {
                    return v(this, e, t, r, !1);
                }, u.prototype.write = function(e, t, r, n) {
                    if (void 0 === t) n = "utf8", r = this.length, t = 0;
                    else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                    else {
                        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                        t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                    }
                    const o = this.length - t;
                    if ((void 0 === r || r > o) && (r = o), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    n || (n = "utf8");
                    let i = !1;
                    for(;;)switch(n){
                        case "hex":
                            return w(this, e, t, r);
                        case "utf8":
                        case "utf-8":
                            return S(this, e, t, r);
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return A(this, e, t, r);
                        case "base64":
                            return E(this, e, t, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return T(this, e, t, r);
                        default:
                            if (i) throw new TypeError("Unknown encoding: " + n);
                            n = ("" + n).toLowerCase(), i = !0;
                    }
                }, u.prototype.toJSON = function() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                const _ = 4096;
                function x(e, t, r) {
                    let n = "";
                    r = Math.min(e.length, r);
                    for(let o = t; o < r; ++o)n += String.fromCharCode(127 & e[o]);
                    return n;
                }
                function P(e, t, r) {
                    let n = "";
                    r = Math.min(e.length, r);
                    for(let o = t; o < r; ++o)n += String.fromCharCode(e[o]);
                    return n;
                }
                function R(e, t, r) {
                    const n = e.length;
                    (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                    let o = "";
                    for(let n = t; n < r; ++n)o += Y[e[n]];
                    return o;
                }
                function I(e, t, r) {
                    const n = e.slice(t, r);
                    let o = "";
                    for(let e = 0; e < n.length - 1; e += 2)o += String.fromCharCode(n[e] + 256 * n[e + 1]);
                    return o;
                }
                function B(e, t, r) {
                    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                    if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                }
                function C(e, t, r, n, o, i) {
                    if (!u.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (t > o || t < i) throw new RangeError('"value" argument is out of bounds');
                    if (r + n > e.length) throw new RangeError("Index out of range");
                }
                function j(e, t, r, n, o) {
                    q(t, n, o, e, r, 7);
                    let i = Number(t & BigInt(4294967295));
                    e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i, i >>= 8, e[r++] = i;
                    let a = Number(t >> BigInt(32) & BigInt(4294967295));
                    return e[r++] = a, a >>= 8, e[r++] = a, a >>= 8, e[r++] = a, a >>= 8, e[r++] = a, r;
                }
                function U(e, t, r, n, o) {
                    q(t, n, o, e, r, 7);
                    let i = Number(t & BigInt(4294967295));
                    e[r + 7] = i, i >>= 8, e[r + 6] = i, i >>= 8, e[r + 5] = i, i >>= 8, e[r + 4] = i;
                    let a = Number(t >> BigInt(32) & BigInt(4294967295));
                    return e[r + 3] = a, a >>= 8, e[r + 2] = a, a >>= 8, e[r + 1] = a, a >>= 8, e[r] = a, r + 8;
                }
                function N(e, t, r, n, o, i) {
                    if (r + n > e.length) throw new RangeError("Index out of range");
                    if (r < 0) throw new RangeError("Index out of range");
                }
                function L(e, t, r, n, i) {
                    return t = +t, r >>>= 0, i || N(e, 0, r, 4), o.write(e, t, r, n, 23, 4), r + 4;
                }
                function F(e, t, r, n, i) {
                    return t = +t, r >>>= 0, i || N(e, 0, r, 8), o.write(e, t, r, n, 52, 8), r + 8;
                }
                u.prototype.slice = function(e, t) {
                    const r = this.length;
                    (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                    const n = this.subarray(e, t);
                    return Object.setPrototypeOf(n, u.prototype), n;
                }, u.prototype.readUintLE = u.prototype.readUIntLE = function(e, t, r) {
                    e >>>= 0, t >>>= 0, r || B(e, t, this.length);
                    let n = this[e], o = 1, i = 0;
                    for(; ++i < t && (o *= 256);)n += this[e + i] * o;
                    return n;
                }, u.prototype.readUintBE = u.prototype.readUIntBE = function(e, t, r) {
                    e >>>= 0, t >>>= 0, r || B(e, t, this.length);
                    let n = this[e + --t], o = 1;
                    for(; t > 0 && (o *= 256);)n += this[e + --t] * o;
                    return n;
                }, u.prototype.readUint8 = u.prototype.readUInt8 = function(e, t) {
                    return e >>>= 0, t || B(e, 1, this.length), this[e];
                }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(e, t) {
                    return e >>>= 0, t || B(e, 2, this.length), this[e] | this[e + 1] << 8;
                }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(e, t) {
                    return e >>>= 0, t || B(e, 2, this.length), this[e] << 8 | this[e + 1];
                }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(e, t) {
                    return e >>>= 0, t || B(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(e, t) {
                    return e >>>= 0, t || B(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                }, u.prototype.readBigUInt64LE = Q(function(e) {
                    G(e >>>= 0, "offset");
                    const t = this[e], r = this[e + 7];
                    void 0 !== t && void 0 !== r || H(e, this.length - 8);
                    const n = t + 256 * this[++e] + 65536 * this[++e] + this[++e] * 2 ** 24, o = this[++e] + 256 * this[++e] + 65536 * this[++e] + r * 2 ** 24;
                    return BigInt(n) + (BigInt(o) << BigInt(32));
                }), u.prototype.readBigUInt64BE = Q(function(e) {
                    G(e >>>= 0, "offset");
                    const t = this[e], r = this[e + 7];
                    void 0 !== t && void 0 !== r || H(e, this.length - 8);
                    const n = t * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + this[++e], o = this[++e] * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + r;
                    return (BigInt(n) << BigInt(32)) + BigInt(o);
                }), u.prototype.readIntLE = function(e, t, r) {
                    e >>>= 0, t >>>= 0, r || B(e, t, this.length);
                    let n = this[e], o = 1, i = 0;
                    for(; ++i < t && (o *= 256);)n += this[e + i] * o;
                    return o *= 128, n >= o && (n -= Math.pow(2, 8 * t)), n;
                }, u.prototype.readIntBE = function(e, t, r) {
                    e >>>= 0, t >>>= 0, r || B(e, t, this.length);
                    let n = t, o = 1, i = this[e + --n];
                    for(; n > 0 && (o *= 256);)i += this[e + --n] * o;
                    return o *= 128, i >= o && (i -= Math.pow(2, 8 * t)), i;
                }, u.prototype.readInt8 = function(e, t) {
                    return e >>>= 0, t || B(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                }, u.prototype.readInt16LE = function(e, t) {
                    e >>>= 0, t || B(e, 2, this.length);
                    const r = this[e] | this[e + 1] << 8;
                    return 32768 & r ? 4294901760 | r : r;
                }, u.prototype.readInt16BE = function(e, t) {
                    e >>>= 0, t || B(e, 2, this.length);
                    const r = this[e + 1] | this[e] << 8;
                    return 32768 & r ? 4294901760 | r : r;
                }, u.prototype.readInt32LE = function(e, t) {
                    return e >>>= 0, t || B(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                }, u.prototype.readInt32BE = function(e, t) {
                    return e >>>= 0, t || B(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                }, u.prototype.readBigInt64LE = Q(function(e) {
                    G(e >>>= 0, "offset");
                    const t = this[e], r = this[e + 7];
                    void 0 !== t && void 0 !== r || H(e, this.length - 8);
                    const n = this[e + 4] + 256 * this[e + 5] + 65536 * this[e + 6] + (r << 24);
                    return (BigInt(n) << BigInt(32)) + BigInt(t + 256 * this[++e] + 65536 * this[++e] + this[++e] * 2 ** 24);
                }), u.prototype.readBigInt64BE = Q(function(e) {
                    G(e >>>= 0, "offset");
                    const t = this[e], r = this[e + 7];
                    void 0 !== t && void 0 !== r || H(e, this.length - 8);
                    const n = (t << 24) + 65536 * this[++e] + 256 * this[++e] + this[++e];
                    return (BigInt(n) << BigInt(32)) + BigInt(this[++e] * 2 ** 24 + 65536 * this[++e] + 256 * this[++e] + r);
                }), u.prototype.readFloatLE = function(e, t) {
                    return e >>>= 0, t || B(e, 4, this.length), o.read(this, e, !0, 23, 4);
                }, u.prototype.readFloatBE = function(e, t) {
                    return e >>>= 0, t || B(e, 4, this.length), o.read(this, e, !1, 23, 4);
                }, u.prototype.readDoubleLE = function(e, t) {
                    return e >>>= 0, t || B(e, 8, this.length), o.read(this, e, !0, 52, 8);
                }, u.prototype.readDoubleBE = function(e, t) {
                    return e >>>= 0, t || B(e, 8, this.length), o.read(this, e, !1, 52, 8);
                }, u.prototype.writeUintLE = u.prototype.writeUIntLE = function(e, t, r, n) {
                    if (e = +e, t >>>= 0, r >>>= 0, !n) C(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                    let o = 1, i = 0;
                    for(this[t] = 255 & e; ++i < r && (o *= 256);)this[t + i] = e / o & 255;
                    return t + r;
                }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(e, t, r, n) {
                    if (e = +e, t >>>= 0, r >>>= 0, !n) C(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                    let o = r - 1, i = 1;
                    for(this[t + o] = 255 & e; --o >= 0 && (i *= 256);)this[t + o] = e / i & 255;
                    return t + r;
                }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                }, u.prototype.writeBigUInt64LE = Q(function(e, t = 0) {
                    return j(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
                }), u.prototype.writeBigUInt64BE = Q(function(e, t = 0) {
                    return U(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
                }), u.prototype.writeIntLE = function(e, t, r, n) {
                    if (e = +e, t >>>= 0, !n) {
                        const n = Math.pow(2, 8 * r - 1);
                        C(this, e, t, r, n - 1, -n);
                    }
                    let o = 0, i = 1, a = 0;
                    for(this[t] = 255 & e; ++o < r && (i *= 256);)e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1), this[t + o] = (e / i | 0) - a & 255;
                    return t + r;
                }, u.prototype.writeIntBE = function(e, t, r, n) {
                    if (e = +e, t >>>= 0, !n) {
                        const n = Math.pow(2, 8 * r - 1);
                        C(this, e, t, r, n - 1, -n);
                    }
                    let o = r - 1, i = 1, a = 0;
                    for(this[t + o] = 255 & e; --o >= 0 && (i *= 256);)e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1), this[t + o] = (e / i | 0) - a & 255;
                    return t + r;
                }, u.prototype.writeInt8 = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                }, u.prototype.writeInt16LE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                }, u.prototype.writeInt16BE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                }, u.prototype.writeInt32LE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                }, u.prototype.writeInt32BE = function(e, t, r) {
                    return e = +e, t >>>= 0, r || C(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                }, u.prototype.writeBigInt64LE = Q(function(e, t = 0) {
                    return j(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                }), u.prototype.writeBigInt64BE = Q(function(e, t = 0) {
                    return U(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                }), u.prototype.writeFloatLE = function(e, t, r) {
                    return L(this, e, t, !0, r);
                }, u.prototype.writeFloatBE = function(e, t, r) {
                    return L(this, e, t, !1, r);
                }, u.prototype.writeDoubleLE = function(e, t, r) {
                    return F(this, e, t, !0, r);
                }, u.prototype.writeDoubleBE = function(e, t, r) {
                    return F(this, e, t, !1, r);
                }, u.prototype.copy = function(e, t, r, n) {
                    if (!u.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                    if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                    if (0 === e.length || 0 === this.length) return 0;
                    if (t < 0) throw new RangeError("targetStart out of bounds");
                    if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                    if (n < 0) throw new RangeError("sourceEnd out of bounds");
                    n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                    const o = n - r;
                    return this === e && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(t, r, n) : Uint8Array.prototype.set.call(e, this.subarray(r, n), t), o;
                }, u.prototype.fill = function(e, t, r, n) {
                    if ("string" == typeof e) {
                        if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                        if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                        if (1 === e.length) {
                            const t = e.charCodeAt(0);
                            ("utf8" === n && t < 128 || "latin1" === n) && (e = t);
                        }
                    } else "number" == typeof e ? e &= 255 : "boolean" == typeof e && (e = Number(e));
                    if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                    if (r <= t) return this;
                    let o;
                    if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                    else {
                        const i = u.isBuffer(e) ? e : u.from(e, n), a = i.length;
                        if (0 === a) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                        for(o = 0; o < r - t; ++o)this[o + t] = i[o % a];
                    }
                    return this;
                };
                const D = {};
                function M(e, t, r) {
                    D[e] = class extends r {
                        constructor(){
                            super(), Object.defineProperty(this, "message", {
                                value: t.apply(this, arguments),
                                writable: !0,
                                configurable: !0
                            }), this.name = `${this.name} [${e}]`, this.stack, delete this.name;
                        }
                        get code() {
                            return e;
                        }
                        set code(e) {
                            Object.defineProperty(this, "code", {
                                configurable: !0,
                                enumerable: !0,
                                value: e,
                                writable: !0
                            });
                        }
                        toString() {
                            return `${this.name} [${e}]: ${this.message}`;
                        }
                    };
                }
                function V(e) {
                    let t = "", r = e.length;
                    const n = "-" === e[0] ? 1 : 0;
                    for(; r >= n + 4; r -= 3)t = `_${e.slice(r - 3, r)}${t}`;
                    return `${e.slice(0, r)}${t}`;
                }
                function q(e, t, r, n, o, i) {
                    if (e > r || e < t) {
                        const n = "bigint" == typeof t ? "n" : "";
                        let o;
                        throw o = i > 3 ? 0 === t || t === BigInt(0) ? `>= 0${n} and < 2${n} ** ${8 * (i + 1)}${n}` : `>= -(2${n} ** ${8 * (i + 1) - 1}${n}) and < 2 ** ${8 * (i + 1) - 1}${n}` : `>= ${t}${n} and <= ${r}${n}`, new D.ERR_OUT_OF_RANGE("value", o, e);
                    }
                    !function(e, t, r) {
                        G(t, "offset"), void 0 !== e[t] && void 0 !== e[t + r] || H(t, e.length - (r + 1));
                    }(n, o, i);
                }
                function G(e, t) {
                    if ("number" != typeof e) throw new D.ERR_INVALID_ARG_TYPE(t, "number", e);
                }
                function H(e, t, r) {
                    if (Math.floor(e) !== e) throw G(e, r), new D.ERR_OUT_OF_RANGE(r || "offset", "an integer", e);
                    if (t < 0) throw new D.ERR_BUFFER_OUT_OF_BOUNDS;
                    throw new D.ERR_OUT_OF_RANGE(r || "offset", `>= ${r ? 1 : 0} and <= ${t}`, e);
                }
                M("ERR_BUFFER_OUT_OF_BOUNDS", function(e) {
                    return e ? `${e} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
                }, RangeError), M("ERR_INVALID_ARG_TYPE", function(e, t) {
                    return `The "${e}" argument must be of type number. Received type ${typeof t}`;
                }, TypeError), M("ERR_OUT_OF_RANGE", function(e, t, r) {
                    let n = `The value of "${e}" is out of range.`, o = r;
                    return Number.isInteger(r) && Math.abs(r) > 2 ** 32 ? o = V(String(r)) : "bigint" == typeof r && (o = String(r), (r > BigInt(2) ** BigInt(32) || r < -(BigInt(2) ** BigInt(32))) && (o = V(o)), o += "n"), n += ` It must be ${t}. Received ${o}`, n;
                }, RangeError);
                const z = /[^+/0-9A-Za-z-_]/g;
                function W(e, t) {
                    let r;
                    t = t || 1 / 0;
                    const n = e.length;
                    let o = null;
                    const i = [];
                    for(let a = 0; a < n; ++a){
                        if (r = e.charCodeAt(a), r > 55295 && r < 57344) {
                            if (!o) {
                                if (r > 56319) {
                                    (t -= 3) > -1 && i.push(239, 191, 189);
                                    continue;
                                }
                                if (a + 1 === n) {
                                    (t -= 3) > -1 && i.push(239, 191, 189);
                                    continue;
                                }
                                o = r;
                                continue;
                            }
                            if (r < 56320) {
                                (t -= 3) > -1 && i.push(239, 191, 189), o = r;
                                continue;
                            }
                            r = 65536 + (o - 55296 << 10 | r - 56320);
                        } else o && (t -= 3) > -1 && i.push(239, 191, 189);
                        if (o = null, r < 128) {
                            if ((t -= 1) < 0) break;
                            i.push(r);
                        } else if (r < 2048) {
                            if ((t -= 2) < 0) break;
                            i.push(r >> 6 | 192, 63 & r | 128);
                        } else if (r < 65536) {
                            if ((t -= 3) < 0) break;
                            i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                        } else {
                            if (!(r < 1114112)) throw new Error("Invalid code point");
                            if ((t -= 4) < 0) break;
                            i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                        }
                    }
                    return i;
                }
                function X(e) {
                    return n.toByteArray(function(e) {
                        if ((e = (e = e.split("=")[0]).trim().replace(z, "")).length < 2) return "";
                        for(; e.length % 4 != 0;)e += "=";
                        return e;
                    }(e));
                }
                function K(e, t, r, n) {
                    let o;
                    for(o = 0; o < n && !(o + r >= t.length || o >= e.length); ++o)t[o + r] = e[o];
                    return o;
                }
                function Z(e, t) {
                    return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                }
                function $(e) {
                    return e != e;
                }
                const Y = function() {
                    const e = "0123456789abcdef", t = new Array(256);
                    for(let r = 0; r < 16; ++r){
                        const n = 16 * r;
                        for(let o = 0; o < 16; ++o)t[n + o] = e[r] + e[o];
                    }
                    return t;
                }();
                function Q(e) {
                    return "undefined" == typeof BigInt ? J : e;
                }
                function J() {
                    throw new Error("BigInt not supported");
                }
            },
            6866 (e) {
                e.exports = {
                    100: "Continue",
                    101: "Switching Protocols",
                    102: "Processing",
                    200: "OK",
                    201: "Created",
                    202: "Accepted",
                    203: "Non-Authoritative Information",
                    204: "No Content",
                    205: "Reset Content",
                    206: "Partial Content",
                    207: "Multi-Status",
                    208: "Already Reported",
                    226: "IM Used",
                    300: "Multiple Choices",
                    301: "Moved Permanently",
                    302: "Found",
                    303: "See Other",
                    304: "Not Modified",
                    305: "Use Proxy",
                    307: "Temporary Redirect",
                    308: "Permanent Redirect",
                    400: "Bad Request",
                    401: "Unauthorized",
                    402: "Payment Required",
                    403: "Forbidden",
                    404: "Not Found",
                    405: "Method Not Allowed",
                    406: "Not Acceptable",
                    407: "Proxy Authentication Required",
                    408: "Request Timeout",
                    409: "Conflict",
                    410: "Gone",
                    411: "Length Required",
                    412: "Precondition Failed",
                    413: "Payload Too Large",
                    414: "URI Too Long",
                    415: "Unsupported Media Type",
                    416: "Range Not Satisfiable",
                    417: "Expectation Failed",
                    418: "I'm a teapot",
                    421: "Misdirected Request",
                    422: "Unprocessable Entity",
                    423: "Locked",
                    424: "Failed Dependency",
                    425: "Unordered Collection",
                    426: "Upgrade Required",
                    428: "Precondition Required",
                    429: "Too Many Requests",
                    431: "Request Header Fields Too Large",
                    451: "Unavailable For Legal Reasons",
                    500: "Internal Server Error",
                    501: "Not Implemented",
                    502: "Bad Gateway",
                    503: "Service Unavailable",
                    504: "Gateway Timeout",
                    505: "HTTP Version Not Supported",
                    506: "Variant Also Negotiates",
                    507: "Insufficient Storage",
                    508: "Loop Detected",
                    509: "Bandwidth Limit Exceeded",
                    510: "Not Extended",
                    511: "Network Authentication Required"
                };
            },
            3144 (e, t, r) {
                "use strict";
                var n = r(6743), o = r(1002), i = r(76), a = r(7119);
                e.exports = a || n.call(i, o);
            },
            2205 (e, t, r) {
                "use strict";
                var n = r(6743), o = r(1002), i = r(3144);
                e.exports = function() {
                    return i(n, o, arguments);
                };
            },
            1002 (e) {
                "use strict";
                e.exports = Function.prototype.apply;
            },
            76 (e) {
                "use strict";
                e.exports = Function.prototype.call;
            },
            3126 (e, t, r) {
                "use strict";
                var n = r(6743), o = r(9675), i = r(76), a = r(3144);
                e.exports = function(e) {
                    if (e.length < 1 || "function" != typeof e[0]) throw new o("a function is required");
                    return a(n, i, e);
                };
            },
            7119 (e) {
                "use strict";
                e.exports = "undefined" != typeof Reflect && Reflect && Reflect.apply;
            },
            487 (e, t, r) {
                "use strict";
                var n = r(6897), o = r(655), i = r(3126), a = r(2205);
                e.exports = function(e) {
                    var t = i(arguments), r = e.length - (arguments.length - 1);
                    return n(t, 1 + (r > 0 ? r : 0), !0);
                }, o ? o(e.exports, "apply", {
                    value: a
                }) : e.exports.apply = a;
            },
            6556 (e, t, r) {
                "use strict";
                var n = r(453), o = r(3126), i = o([
                    n("%String.prototype.indexOf%")
                ]);
                e.exports = function(e, t) {
                    var r = n(e, !!t);
                    return "function" == typeof r && i(e, ".prototype.") > -1 ? o([
                        r
                    ]) : r;
                };
            },
            41 (e, t, r) {
                "use strict";
                var n = r(655), o = r(8068), i = r(9675), a = r(5795);
                e.exports = function(e, t, r) {
                    if (!e || "object" != typeof e && "function" != typeof e) throw new i("`obj` must be an object or a function`");
                    if ("string" != typeof t && "symbol" != typeof t) throw new i("`property` must be a string or a symbol`");
                    if (arguments.length > 3 && "boolean" != typeof arguments[3] && null !== arguments[3]) throw new i("`nonEnumerable`, if provided, must be a boolean or null");
                    if (arguments.length > 4 && "boolean" != typeof arguments[4] && null !== arguments[4]) throw new i("`nonWritable`, if provided, must be a boolean or null");
                    if (arguments.length > 5 && "boolean" != typeof arguments[5] && null !== arguments[5]) throw new i("`nonConfigurable`, if provided, must be a boolean or null");
                    if (arguments.length > 6 && "boolean" != typeof arguments[6]) throw new i("`loose`, if provided, must be a boolean");
                    var s = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, l = arguments.length > 6 && arguments[6], f = !!a && a(e, t);
                    if (n) n(e, t, {
                        configurable: null === c && f ? f.configurable : !c,
                        enumerable: null === s && f ? f.enumerable : !s,
                        value: r,
                        writable: null === u && f ? f.writable : !u
                    });
                    else {
                        if (!l && (s || u || c)) throw new o("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
                        e[t] = r;
                    }
                };
            },
            7176 (e, t, r) {
                "use strict";
                var n, o = r(3126), i = r(5795);
                try {
                    n = [].__proto__ === Array.prototype;
                } catch (e) {
                    if (!e || "object" != typeof e || !("code" in e) || "ERR_PROTO_ACCESS" !== e.code) throw e;
                }
                var a = !!n && i && i(Object.prototype, "__proto__"), s = Object, u = s.getPrototypeOf;
                e.exports = a && "function" == typeof a.get ? o([
                    a.get
                ]) : "function" == typeof u && function(e) {
                    return u(null == e ? e : s(e));
                };
            },
            655 (e) {
                "use strict";
                var t = Object.defineProperty || !1;
                if (t) try {
                    t({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    t = !1;
                }
                e.exports = t;
            },
            1237 (e) {
                "use strict";
                e.exports = EvalError;
            },
            9383 (e) {
                "use strict";
                e.exports = Error;
            },
            9290 (e) {
                "use strict";
                e.exports = RangeError;
            },
            9538 (e) {
                "use strict";
                e.exports = ReferenceError;
            },
            8068 (e) {
                "use strict";
                e.exports = SyntaxError;
            },
            9675 (e) {
                "use strict";
                e.exports = TypeError;
            },
            5345 (e) {
                "use strict";
                e.exports = URIError;
            },
            9612 (e) {
                "use strict";
                e.exports = Object;
            },
            7007 (e) {
                "use strict";
                var t, r = "object" == typeof Reflect ? Reflect : null, n = r && "function" == typeof r.apply ? r.apply : function(e, t, r) {
                    return Function.prototype.apply.call(e, t, r);
                };
                t = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var o = Number.isNaN || function(e) {
                    return e != e;
                };
                function i() {
                    i.init.call(this);
                }
                e.exports = i, e.exports.once = function(e, t) {
                    return new Promise(function(r, n) {
                        function o(r) {
                            e.removeListener(t, i), n(r);
                        }
                        function i() {
                            "function" == typeof e.removeListener && e.removeListener("error", o), r([].slice.call(arguments));
                        }
                        y(e, t, i, {
                            once: !0
                        }), "error" !== t && function(e, t, r) {
                            "function" == typeof e.on && y(e, "error", t, r);
                        }(e, o, {
                            once: !0
                        });
                    });
                }, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
                var a = 10;
                function s(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function u(e) {
                    return void 0 === e._maxListeners ? i.defaultMaxListeners : e._maxListeners;
                }
                function c(e, t, r, n) {
                    var o, i, a, c;
                    if (s(r), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), i = e._events), a = i[t]), void 0 === a) a = i[t] = r, ++e._eventsCount;
                    else if ("function" == typeof a ? a = i[t] = n ? [
                        r,
                        a
                    ] : [
                        a,
                        r
                    ] : n ? a.unshift(r) : a.push(r), (o = u(e)) > 0 && a.length > o && !a.warned) {
                        a.warned = !0;
                        var l = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, c = l, console && console.warn && console.warn(c);
                    }
                    return e;
                }
                function l() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function f(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, o = l.bind(n);
                    return o.listener = r, n.wrapFn = o, o;
                }
                function p(e, t, r) {
                    var n = e._events;
                    if (void 0 === n) return [];
                    var o = n[t];
                    return void 0 === o ? [] : "function" == typeof o ? r ? [
                        o.listener || o
                    ] : [
                        o
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(o) : h(o, o.length);
                }
                function d(e) {
                    var t = this._events;
                    if (void 0 !== t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (void 0 !== r) return r.length;
                    }
                    return 0;
                }
                function h(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                function y(e, t, r, n) {
                    if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);
                    else {
                        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                        e.addEventListener(t, function o(i) {
                            n.once && e.removeEventListener(t, o), r(i);
                        });
                    }
                }
                Object.defineProperty(i, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return a;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        a = e;
                    }
                }), i.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, i.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, i.prototype.getMaxListeners = function() {
                    return u(this);
                }, i.prototype.emit = function(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t.push(arguments[r]);
                    var o = "error" === e, i = this._events;
                    if (void 0 !== i) o = o && void 0 === i.error;
                    else if (!o) return !1;
                    if (o) {
                        var a;
                        if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
                        var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
                        throw s.context = a, s;
                    }
                    var u = i[e];
                    if (void 0 === u) return !1;
                    if ("function" == typeof u) n(u, this, t);
                    else {
                        var c = u.length, l = h(u, c);
                        for(r = 0; r < c; ++r)n(l[r], this, t);
                    }
                    return !0;
                }, i.prototype.addListener = function(e, t) {
                    return c(this, e, t, !1);
                }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(e, t) {
                    return c(this, e, t, !0);
                }, i.prototype.once = function(e, t) {
                    return s(t), this.on(e, f(this, e, t)), this;
                }, i.prototype.prependOnceListener = function(e, t) {
                    return s(t), this.prependListener(e, f(this, e, t)), this;
                }, i.prototype.removeListener = function(e, t) {
                    var r, n, o, i, a;
                    if (s(t), void 0 === (n = this._events)) return this;
                    if (void 0 === (r = n[e])) return this;
                    if (r === t || r.listener === t) 0 === --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(o = -1, i = r.length - 1; i >= 0; i--)if (r[i] === t || r[i].listener === t) {
                            a = r[i].listener, o = i;
                            break;
                        }
                        if (o < 0) return this;
                        0 === o ? r.shift() : function(e, t) {
                            for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                            e.pop();
                        }(r, o), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(e) {
                    var t, r, n;
                    if (void 0 === (r = this._events)) return this;
                    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 === --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, i = Object.keys(r);
                        for(n = 0; n < i.length; ++n)"removeListener" !== (o = i[n]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (void 0 !== t) for(n = t.length - 1; n >= 0; n--)this.removeListener(e, t[n]);
                    return this;
                }, i.prototype.listeners = function(e) {
                    return p(this, e, !0);
                }, i.prototype.rawListeners = function(e) {
                    return p(this, e, !1);
                }, i.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : d.call(e, t);
                }, i.prototype.listenerCount = d, i.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? t(this._events) : [];
                };
            },
            1731 (e, t, r) {
                var n = r(8287).Buffer, o = r(8835).parse, i = r(7007), a = r(1083), s = r(1568), u = r(537), c = [
                    "pfx",
                    "key",
                    "passphrase",
                    "cert",
                    "ca",
                    "ciphers",
                    "rejectUnauthorized",
                    "secureProtocol",
                    "servername",
                    "checkServerIdentity"
                ], l = [
                    239,
                    187,
                    191
                ], f = 262144, p = /^(cookie|authorization)$/i;
                function d(e, t) {
                    var r = d.CONNECTING, i = t && t.headers, u = !1;
                    Object.defineProperty(this, "readyState", {
                        get: function() {
                            return r;
                        }
                    }), Object.defineProperty(this, "url", {
                        get: function() {
                            return e;
                        }
                    });
                    var m, g = this;
                    function v(t) {
                        r !== d.CLOSED && (r = d.CONNECTING, O("error", new h("error", {
                            message: t
                        })), E && (e = E, E = null, u = !1), setTimeout(function() {
                            r !== d.CONNECTING || g.connectionInProgress || (g.connectionInProgress = !0, T());
                        }, g.reconnectInterval));
                    }
                    g.reconnectInterval = 1e3, g.connectionInProgress = !1;
                    var b = "";
                    i && i["Last-Event-ID"] && (b = i["Last-Event-ID"], delete i["Last-Event-ID"]);
                    var w = !1, S = "", A = "", E = null;
                    function T() {
                        var y = o(e), S = "https:" === y.protocol;
                        if (y.headers = {
                            "Cache-Control": "no-cache",
                            Accept: "text/event-stream"
                        }, b && (y.headers["Last-Event-ID"] = b), i) {
                            var A = u ? function(e) {
                                var t = {};
                                for(var r in e)p.test(r) || (t[r] = e[r]);
                                return t;
                            }(i) : i;
                            for(var _ in A){
                                var x = A[_];
                                x && (y.headers[_] = x);
                            }
                        }
                        if (y.rejectUnauthorized = !(t && !t.rejectUnauthorized), t && void 0 !== t.createConnection && (y.createConnection = t.createConnection), t && t.proxy) {
                            var P = o(t.proxy);
                            S = "https:" === P.protocol, y.protocol = S ? "https:" : "http:", y.path = e, y.headers.Host = y.host, y.hostname = P.hostname, y.host = P.host, y.port = P.port;
                        }
                        if (t && t.https) {
                            for(var R in t.https)if (-1 !== c.indexOf(R)) {
                                var I = t.https[R];
                                void 0 !== I && (y[R] = I);
                            }
                        }
                        t && void 0 !== t.withCredentials && (y.withCredentials = t.withCredentials), m = (S ? a : s).request(y, function(t) {
                            if (g.connectionInProgress = !1, 500 === t.statusCode || 502 === t.statusCode || 503 === t.statusCode || 504 === t.statusCode) return O("error", new h("error", {
                                status: t.statusCode,
                                message: t.statusMessage
                            })), void v();
                            if (301 === t.statusCode || 302 === t.statusCode || 307 === t.statusCode) {
                                var o = t.headers.location;
                                if (!o) return void O("error", new h("error", {
                                    status: t.statusCode,
                                    message: t.statusMessage
                                }));
                                var i = new URL(e).origin, a = new URL(o).origin;
                                return u = i !== a, 307 === t.statusCode && (E = e), e = o, void $4TNnu.nextTick(T);
                            }
                            if (200 !== t.statusCode) return O("error", new h("error", {
                                status: t.statusCode,
                                message: t.statusMessage
                            })), g.close();
                            var s, c;
                            r = d.OPEN, t.on("close", function() {
                                t.removeAllListeners("close"), t.removeAllListeners("end"), v();
                            }), t.on("end", function() {
                                t.removeAllListeners("close"), t.removeAllListeners("end"), v();
                            }), O("open", new h("open"));
                            var p = 0, y = -1, m = 0, b = 0;
                            t.on("data", function(e) {
                                s ? (e.length > s.length - b && ((m = 2 * s.length + e.length) > f && (m = s.length + e.length + f), c = n.alloc(m), s.copy(c, 0, 0, b), s = c), e.copy(s, b), b += e.length) : (function(e) {
                                    return l.every(function(t, r) {
                                        return e[r] === t;
                                    });
                                }(s = e) && (s = s.slice(l.length)), b = s.length);
                                for(var t = 0, r = b; t < r;){
                                    w && (10 === s[t] && ++t, w = !1);
                                    for(var o, i = -1, a = y, u = p; i < 0 && u < r; ++u)58 === (o = s[u]) ? a < 0 && (a = u - t) : 13 === o ? (w = !0, i = u - t) : 10 === o && (i = u - t);
                                    if (i < 0) {
                                        p = r - t, y = a;
                                        break;
                                    }
                                    p = 0, y = -1, k(s, t, a, i), t += i + 1;
                                }
                                t === r ? (s = void 0, b = 0) : t > 0 && (s = s.slice(t, b), b = s.length);
                            });
                        }), m.on("error", function(e) {
                            g.connectionInProgress = !1, v(e.message);
                        }), m.setNoDelay && m.setNoDelay(!0), m.end();
                    }
                    function O() {
                        g.listeners(arguments[0]).length > 0 && g.emit.apply(g, arguments);
                    }
                    function k(t, r, n, o) {
                        if (0 === o) {
                            if (S.length > 0) {
                                var i = A || "message";
                                O(i, new y(i, {
                                    data: S.slice(0, -1),
                                    lastEventId: b,
                                    origin: new URL(e).origin
                                })), S = "";
                            }
                            A = void 0;
                        } else if (n > 0) {
                            var a = n < 0, s = 0, u = t.slice(r, r + (a ? o : n)).toString();
                            r += s = a ? o : 32 !== t[r + n + 1] ? n + 1 : n + 2;
                            var c = o - s, l = t.slice(r, r + c).toString();
                            if ("data" === u) S += l + "\n";
                            else if ("event" === u) A = l;
                            else if ("id" === u) b = l;
                            else if ("retry" === u) {
                                var f = parseInt(l, 10);
                                Number.isNaN(f) || (g.reconnectInterval = f);
                            }
                        }
                    }
                    T(), this._close = function() {
                        r !== d.CLOSED && (r = d.CLOSED, m.abort && m.abort(), m.xhr && m.xhr.abort && m.xhr.abort());
                    };
                }
                function h(e, t) {
                    if (Object.defineProperty(this, "type", {
                        writable: !1,
                        value: e,
                        enumerable: !0
                    }), t) for(var r in t)t.hasOwnProperty(r) && Object.defineProperty(this, r, {
                        writable: !1,
                        value: t[r],
                        enumerable: !0
                    });
                }
                function y(e, t) {
                    for(var r in Object.defineProperty(this, "type", {
                        writable: !1,
                        value: e,
                        enumerable: !0
                    }), t)t.hasOwnProperty(r) && Object.defineProperty(this, r, {
                        writable: !1,
                        value: t[r],
                        enumerable: !0
                    });
                }
                e.exports = d, u.inherits(d, i.EventEmitter), d.prototype.constructor = d, [
                    "open",
                    "error",
                    "message"
                ].forEach(function(e) {
                    Object.defineProperty(d.prototype, "on" + e, {
                        get: function() {
                            var t = this.listeners(e)[0];
                            return t ? t._listener ? t._listener : t : void 0;
                        },
                        set: function(t) {
                            this.removeAllListeners(e), this.addEventListener(e, t);
                        }
                    });
                }), Object.defineProperty(d, "CONNECTING", {
                    enumerable: !0,
                    value: 0
                }), Object.defineProperty(d, "OPEN", {
                    enumerable: !0,
                    value: 1
                }), Object.defineProperty(d, "CLOSED", {
                    enumerable: !0,
                    value: 2
                }), d.prototype.CONNECTING = 0, d.prototype.OPEN = 1, d.prototype.CLOSED = 2, d.prototype.close = function() {
                    this._close();
                }, d.prototype.addEventListener = function(e, t) {
                    "function" == typeof t && (t._listener = t, this.on(e, t));
                }, d.prototype.dispatchEvent = function(e) {
                    if (!e.type) throw new Error("UNSPECIFIED_EVENT_TYPE_ERR");
                    this.emit(e.type, e.detail);
                }, d.prototype.removeEventListener = function(e, t) {
                    "function" == typeof t && (t._listener = void 0, this.removeListener(e, t));
                };
            },
            2682 (e, t, r) {
                "use strict";
                var n = r(9600), o = Object.prototype.toString, i = Object.prototype.hasOwnProperty;
                e.exports = function(e, t, r) {
                    if (!n(t)) throw new TypeError("iterator must be a function");
                    var a, s;
                    arguments.length >= 3 && (a = r), s = e, "[object Array]" === o.call(s) ? function(e, t, r) {
                        for(var n = 0, o = e.length; n < o; n++)i.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                    }(e, t, a) : "string" == typeof e ? function(e, t, r) {
                        for(var n = 0, o = e.length; n < o; n++)null == r ? t(e.charAt(n), n, e) : t.call(r, e.charAt(n), n, e);
                    }(e, t, a) : function(e, t, r) {
                        for(var n in e)i.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                    }(e, t, a);
                };
            },
            9353 (e) {
                "use strict";
                var t = Object.prototype.toString, r = Math.max, n = function(e, t) {
                    for(var r = [], n = 0; n < e.length; n += 1)r[n] = e[n];
                    for(var o = 0; o < t.length; o += 1)r[o + e.length] = t[o];
                    return r;
                };
                e.exports = function(e) {
                    var o = this;
                    if ("function" != typeof o || "[object Function]" !== t.apply(o)) throw new TypeError("Function.prototype.bind called on incompatible " + o);
                    for(var i, a = function(e, t) {
                        for(var r = [], n = t || 0, o = 0; n < e.length; n += 1, o += 1)r[o] = e[n];
                        return r;
                    }(arguments, 1), s = r(0, o.length - a.length), u = [], c = 0; c < s; c++)u[c] = "$" + c;
                    if (i = Function("binder", "return function (" + function(e, t) {
                        for(var r = "", n = 0; n < e.length; n += 1)r += e[n], n + 1 < e.length && (r += t);
                        return r;
                    }(u, ",") + "){ return binder.apply(this,arguments); }")(function() {
                        if (this instanceof i) {
                            var t = o.apply(this, n(a, arguments));
                            return Object(t) === t ? t : this;
                        }
                        return o.apply(e, n(a, arguments));
                    }), o.prototype) {
                        var l = function() {};
                        l.prototype = o.prototype, i.prototype = new l, l.prototype = null;
                    }
                    return i;
                };
            },
            6743 (e, t, r) {
                "use strict";
                var n = r(9353);
                e.exports = Function.prototype.bind || n;
            },
            4233 (e) {
                "use strict";
                const t = (function*() {}).constructor;
                e.exports = ()=>t;
            },
            453 (e, t, r) {
                "use strict";
                var n, o = r(9612), i = r(9383), a = r(1237), s = r(9290), u = r(9538), c = r(8068), l = r(9675), f = r(5345), p = r(1514), d = r(8968), h = r(6188), y = r(8002), m = r(5880), g = r(414), v = r(3093), b = Function, w = function(e) {
                    try {
                        return b('"use strict"; return (' + e + ").constructor;")();
                    } catch (e) {}
                }, S = r(5795), A = r(655), E = function() {
                    throw new l;
                }, T = S ? function() {
                    try {
                        return E;
                    } catch (e) {
                        try {
                            return S(arguments, "callee").get;
                        } catch (e) {
                            return E;
                        }
                    }
                }() : E, O = r(4039)(), k = r(3628), _ = r(1064), x = r(8648), P = r(1002), R = r(76), I = {}, B = "undefined" != typeof Uint8Array && k ? k(Uint8Array) : n, C = {
                    __proto__: null,
                    "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
                    "%Array%": Array,
                    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
                    "%ArrayIteratorPrototype%": O && k ? k([][Symbol.iterator]()) : n,
                    "%AsyncFromSyncIteratorPrototype%": n,
                    "%AsyncFunction%": I,
                    "%AsyncGenerator%": I,
                    "%AsyncGeneratorFunction%": I,
                    "%AsyncIteratorPrototype%": I,
                    "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
                    "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
                    "%BigInt64Array%": "undefined" == typeof BigInt64Array ? n : BigInt64Array,
                    "%BigUint64Array%": "undefined" == typeof BigUint64Array ? n : BigUint64Array,
                    "%Boolean%": Boolean,
                    "%DataView%": "undefined" == typeof DataView ? n : DataView,
                    "%Date%": Date,
                    "%decodeURI%": decodeURI,
                    "%decodeURIComponent%": decodeURIComponent,
                    "%encodeURI%": encodeURI,
                    "%encodeURIComponent%": encodeURIComponent,
                    "%Error%": i,
                    "%eval%": eval,
                    "%EvalError%": a,
                    "%Float16Array%": "undefined" == typeof Float16Array ? n : Float16Array,
                    "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
                    "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
                    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
                    "%Function%": b,
                    "%GeneratorFunction%": I,
                    "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
                    "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
                    "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
                    "%isFinite%": isFinite,
                    "%isNaN%": isNaN,
                    "%IteratorPrototype%": O && k ? k(k([][Symbol.iterator]())) : n,
                    "%JSON%": "object" == typeof JSON ? JSON : n,
                    "%Map%": "undefined" == typeof Map ? n : Map,
                    "%MapIteratorPrototype%": "undefined" != typeof Map && O && k ? k((new Map)[Symbol.iterator]()) : n,
                    "%Math%": Math,
                    "%Number%": Number,
                    "%Object%": o,
                    "%Object.getOwnPropertyDescriptor%": S,
                    "%parseFloat%": parseFloat,
                    "%parseInt%": parseInt,
                    "%Promise%": "undefined" == typeof Promise ? n : Promise,
                    "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
                    "%RangeError%": s,
                    "%ReferenceError%": u,
                    "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
                    "%RegExp%": RegExp,
                    "%Set%": "undefined" == typeof Set ? n : Set,
                    "%SetIteratorPrototype%": "undefined" != typeof Set && O && k ? k((new Set)[Symbol.iterator]()) : n,
                    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                    "%String%": String,
                    "%StringIteratorPrototype%": O && k ? k(""[Symbol.iterator]()) : n,
                    "%Symbol%": O ? Symbol : n,
                    "%SyntaxError%": c,
                    "%ThrowTypeError%": T,
                    "%TypedArray%": B,
                    "%TypeError%": l,
                    "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
                    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                    "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
                    "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
                    "%URIError%": f,
                    "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
                    "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
                    "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet,
                    "%Function.prototype.call%": R,
                    "%Function.prototype.apply%": P,
                    "%Object.defineProperty%": A,
                    "%Object.getPrototypeOf%": _,
                    "%Math.abs%": p,
                    "%Math.floor%": d,
                    "%Math.max%": h,
                    "%Math.min%": y,
                    "%Math.pow%": m,
                    "%Math.round%": g,
                    "%Math.sign%": v,
                    "%Reflect.getPrototypeOf%": x
                };
                if (k) try {
                    null.error;
                } catch (e) {
                    var j = k(k(e));
                    C["%Error.prototype%"] = j;
                }
                var U = function e(t) {
                    var r;
                    if ("%AsyncFunction%" === t) r = w("async function () {}");
                    else if ("%GeneratorFunction%" === t) r = w("function* () {}");
                    else if ("%AsyncGeneratorFunction%" === t) r = w("async function* () {}");
                    else if ("%AsyncGenerator%" === t) {
                        var n = e("%AsyncGeneratorFunction%");
                        n && (r = n.prototype);
                    } else if ("%AsyncIteratorPrototype%" === t) {
                        var o = e("%AsyncGenerator%");
                        o && k && (r = k(o.prototype));
                    }
                    return C[t] = r, r;
                }, N = {
                    __proto__: null,
                    "%ArrayBufferPrototype%": [
                        "ArrayBuffer",
                        "prototype"
                    ],
                    "%ArrayPrototype%": [
                        "Array",
                        "prototype"
                    ],
                    "%ArrayProto_entries%": [
                        "Array",
                        "prototype",
                        "entries"
                    ],
                    "%ArrayProto_forEach%": [
                        "Array",
                        "prototype",
                        "forEach"
                    ],
                    "%ArrayProto_keys%": [
                        "Array",
                        "prototype",
                        "keys"
                    ],
                    "%ArrayProto_values%": [
                        "Array",
                        "prototype",
                        "values"
                    ],
                    "%AsyncFunctionPrototype%": [
                        "AsyncFunction",
                        "prototype"
                    ],
                    "%AsyncGenerator%": [
                        "AsyncGeneratorFunction",
                        "prototype"
                    ],
                    "%AsyncGeneratorPrototype%": [
                        "AsyncGeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%BooleanPrototype%": [
                        "Boolean",
                        "prototype"
                    ],
                    "%DataViewPrototype%": [
                        "DataView",
                        "prototype"
                    ],
                    "%DatePrototype%": [
                        "Date",
                        "prototype"
                    ],
                    "%ErrorPrototype%": [
                        "Error",
                        "prototype"
                    ],
                    "%EvalErrorPrototype%": [
                        "EvalError",
                        "prototype"
                    ],
                    "%Float32ArrayPrototype%": [
                        "Float32Array",
                        "prototype"
                    ],
                    "%Float64ArrayPrototype%": [
                        "Float64Array",
                        "prototype"
                    ],
                    "%FunctionPrototype%": [
                        "Function",
                        "prototype"
                    ],
                    "%Generator%": [
                        "GeneratorFunction",
                        "prototype"
                    ],
                    "%GeneratorPrototype%": [
                        "GeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%Int8ArrayPrototype%": [
                        "Int8Array",
                        "prototype"
                    ],
                    "%Int16ArrayPrototype%": [
                        "Int16Array",
                        "prototype"
                    ],
                    "%Int32ArrayPrototype%": [
                        "Int32Array",
                        "prototype"
                    ],
                    "%JSONParse%": [
                        "JSON",
                        "parse"
                    ],
                    "%JSONStringify%": [
                        "JSON",
                        "stringify"
                    ],
                    "%MapPrototype%": [
                        "Map",
                        "prototype"
                    ],
                    "%NumberPrototype%": [
                        "Number",
                        "prototype"
                    ],
                    "%ObjectPrototype%": [
                        "Object",
                        "prototype"
                    ],
                    "%ObjProto_toString%": [
                        "Object",
                        "prototype",
                        "toString"
                    ],
                    "%ObjProto_valueOf%": [
                        "Object",
                        "prototype",
                        "valueOf"
                    ],
                    "%PromisePrototype%": [
                        "Promise",
                        "prototype"
                    ],
                    "%PromiseProto_then%": [
                        "Promise",
                        "prototype",
                        "then"
                    ],
                    "%Promise_all%": [
                        "Promise",
                        "all"
                    ],
                    "%Promise_reject%": [
                        "Promise",
                        "reject"
                    ],
                    "%Promise_resolve%": [
                        "Promise",
                        "resolve"
                    ],
                    "%RangeErrorPrototype%": [
                        "RangeError",
                        "prototype"
                    ],
                    "%ReferenceErrorPrototype%": [
                        "ReferenceError",
                        "prototype"
                    ],
                    "%RegExpPrototype%": [
                        "RegExp",
                        "prototype"
                    ],
                    "%SetPrototype%": [
                        "Set",
                        "prototype"
                    ],
                    "%SharedArrayBufferPrototype%": [
                        "SharedArrayBuffer",
                        "prototype"
                    ],
                    "%StringPrototype%": [
                        "String",
                        "prototype"
                    ],
                    "%SymbolPrototype%": [
                        "Symbol",
                        "prototype"
                    ],
                    "%SyntaxErrorPrototype%": [
                        "SyntaxError",
                        "prototype"
                    ],
                    "%TypedArrayPrototype%": [
                        "TypedArray",
                        "prototype"
                    ],
                    "%TypeErrorPrototype%": [
                        "TypeError",
                        "prototype"
                    ],
                    "%Uint8ArrayPrototype%": [
                        "Uint8Array",
                        "prototype"
                    ],
                    "%Uint8ClampedArrayPrototype%": [
                        "Uint8ClampedArray",
                        "prototype"
                    ],
                    "%Uint16ArrayPrototype%": [
                        "Uint16Array",
                        "prototype"
                    ],
                    "%Uint32ArrayPrototype%": [
                        "Uint32Array",
                        "prototype"
                    ],
                    "%URIErrorPrototype%": [
                        "URIError",
                        "prototype"
                    ],
                    "%WeakMapPrototype%": [
                        "WeakMap",
                        "prototype"
                    ],
                    "%WeakSetPrototype%": [
                        "WeakSet",
                        "prototype"
                    ]
                }, L = r(6743), F = r(9957), D = L.call(R, Array.prototype.concat), M = L.call(P, Array.prototype.splice), V = L.call(R, String.prototype.replace), q = L.call(R, String.prototype.slice), G = L.call(R, RegExp.prototype.exec), H = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, z = /\\(\\)?/g, W = function(e, t) {
                    var r, n = e;
                    if (F(N, n) && (n = "%" + (r = N[n])[0] + "%"), F(C, n)) {
                        var o = C[n];
                        if (o === I && (o = U(n)), void 0 === o && !t) throw new l("intrinsic " + e + " exists, but is not available. Please file an issue!");
                        return {
                            alias: r,
                            name: n,
                            value: o
                        };
                    }
                    throw new c("intrinsic " + e + " does not exist!");
                };
                e.exports = function(e, t) {
                    if ("string" != typeof e || 0 === e.length) throw new l("intrinsic name must be a non-empty string");
                    if (arguments.length > 1 && "boolean" != typeof t) throw new l('"allowMissing" argument must be a boolean');
                    if (null === G(/^%?[^%]*%?$/, e)) throw new c("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                    var r = function(e) {
                        var t = q(e, 0, 1), r = q(e, -1);
                        if ("%" === t && "%" !== r) throw new c("invalid intrinsic syntax, expected closing `%`");
                        if ("%" === r && "%" !== t) throw new c("invalid intrinsic syntax, expected opening `%`");
                        var n = [];
                        return V(e, H, function(e, t, r, o) {
                            n[n.length] = r ? V(o, z, "$1") : t || e;
                        }), n;
                    }(e), n = r.length > 0 ? r[0] : "", o = W("%" + n + "%", t), i = o.name, a = o.value, s = !1, u = o.alias;
                    u && (n = u[0], M(r, D([
                        0,
                        1
                    ], u)));
                    for(var f = 1, p = !0; f < r.length; f += 1){
                        var d = r[f], h = q(d, 0, 1), y = q(d, -1);
                        if (('"' === h || "'" === h || "`" === h || '"' === y || "'" === y || "`" === y) && h !== y) throw new c("property names with quotes must have matching quotes");
                        if ("constructor" !== d && p || (s = !0), F(C, i = "%" + (n += "." + d) + "%")) a = C[i];
                        else if (null != a) {
                            if (!(d in a)) {
                                if (!t) throw new l("base intrinsic for " + e + " exists, but the property is not available.");
                                return;
                            }
                            if (S && f + 1 >= r.length) {
                                var m = S(a, d);
                                a = (p = !!m) && "get" in m && !("originalValue" in m.get) ? m.get : a[d];
                            } else p = F(a, d), a = a[d];
                            p && !s && (C[i] = a);
                        }
                    }
                    return a;
                };
            },
            1064 (e, t, r) {
                "use strict";
                var n = r(9612);
                e.exports = n.getPrototypeOf || null;
            },
            8648 (e) {
                "use strict";
                e.exports = "undefined" != typeof Reflect && Reflect.getPrototypeOf || null;
            },
            3628 (e, t, r) {
                "use strict";
                var n = r(8648), o = r(1064), i = r(7176);
                e.exports = n ? function(e) {
                    return n(e);
                } : o ? function(e) {
                    if (!e || "object" != typeof e && "function" != typeof e) throw new TypeError("getProto: not an object");
                    return o(e);
                } : i ? function(e) {
                    return i(e);
                } : null;
            },
            6549 (e) {
                "use strict";
                e.exports = Object.getOwnPropertyDescriptor;
            },
            5795 (e, t, r) {
                "use strict";
                var n = r(6549);
                if (n) try {
                    n([], "length");
                } catch (e) {
                    n = null;
                }
                e.exports = n;
            },
            592 (e, t, r) {
                "use strict";
                var n = r(655), o = function() {
                    return !!n;
                };
                o.hasArrayLengthDefineBug = function() {
                    if (!n) return null;
                    try {
                        return 1 !== n([], "length", {
                            value: 1
                        }).length;
                    } catch (e) {
                        return !0;
                    }
                }, e.exports = o;
            },
            4039 (e, t, r) {
                "use strict";
                var n = "undefined" != typeof Symbol && Symbol, o = r(1333);
                e.exports = function() {
                    return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && o();
                };
            },
            1333 (e) {
                "use strict";
                e.exports = function() {
                    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                    if ("symbol" == typeof Symbol.iterator) return !0;
                    var e = {}, t = Symbol("test"), r = Object(t);
                    if ("string" == typeof t) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                    for(var n in e[t] = 42, e)return !1;
                    if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
                    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
                    var o = Object.getOwnPropertySymbols(e);
                    if (1 !== o.length || o[0] !== t) return !1;
                    if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
                    if ("function" == typeof Object.getOwnPropertyDescriptor) {
                        var i = Object.getOwnPropertyDescriptor(e, t);
                        if (42 !== i.value || !0 !== i.enumerable) return !1;
                    }
                    return !0;
                };
            },
            9092 (e, t, r) {
                "use strict";
                var n = r(1333);
                e.exports = function() {
                    return n() && !!Symbol.toStringTag;
                };
            },
            9957 (e, t, r) {
                "use strict";
                var n = Function.prototype.call, o = Object.prototype.hasOwnProperty, i = r(6743);
                e.exports = i.call(n, o);
            },
            1083 (e, t, r) {
                var n = r(1568), o = r(8835), i = e.exports;
                for(var a in n)n.hasOwnProperty(a) && (i[a] = n[a]);
                function s(e) {
                    if ("string" == typeof e && (e = o.parse(e)), e.protocol || (e.protocol = "https:"), "https:" !== e.protocol) throw new Error('Protocol "' + e.protocol + '" not supported. Expected "https:"');
                    return e;
                }
                i.request = function(e, t) {
                    return e = s(e), n.request.call(this, e, t);
                }, i.get = function(e, t) {
                    return e = s(e), n.get.call(this, e, t);
                };
            },
            251 (e, t) {
                t.read = function(e, t, r, n, o) {
                    var i, a, s = 8 * o - n - 1, u = (1 << s) - 1, c = u >> 1, l = -7, f = r ? o - 1 : 0, p = r ? -1 : 1, d = e[t + f];
                    for(f += p, i = d & (1 << -l) - 1, d >>= -l, l += s; l > 0; i = 256 * i + e[t + f], f += p, l -= 8);
                    for(a = i & (1 << -l) - 1, i >>= -l, l += n; l > 0; a = 256 * a + e[t + f], f += p, l -= 8);
                    if (0 === i) i = 1 - c;
                    else {
                        if (i === u) return a ? NaN : 1 / 0 * (d ? -1 : 1);
                        a += Math.pow(2, n), i -= c;
                    }
                    return (d ? -1 : 1) * a * Math.pow(2, i - n);
                }, t.write = function(e, t, r, n, o, i) {
                    var a, s, u, c = 8 * i - o - 1, l = (1 << c) - 1, f = l >> 1, p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : i - 1, h = n ? 1 : -1, y = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + f >= 1 ? p / u : p * Math.pow(2, 1 - f)) * u >= 2 && (a++, u /= 2), a + f >= l ? (s = 0, a = l) : a + f >= 1 ? (s = (t * u - 1) * Math.pow(2, o), a += f) : (s = t * Math.pow(2, f - 1) * Math.pow(2, o), a = 0)); o >= 8; e[r + d] = 255 & s, d += h, s /= 256, o -= 8);
                    for(a = a << o | s, c += o; c > 0; e[r + d] = 255 & a, d += h, a /= 256, c -= 8);
                    e[r + d - h] |= 128 * y;
                };
            },
            6698 (e) {
                "function" == typeof Object.create ? e.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : e.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            7244 (e, t, r) {
                "use strict";
                var n = r(9092)(), o = r(6556)("Object.prototype.toString"), i = function(e) {
                    return !(n && e && "object" == typeof e && Symbol.toStringTag in e) && "[object Arguments]" === o(e);
                }, a = function(e) {
                    return !!i(e) || null !== e && "object" == typeof e && "length" in e && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== o(e) && "callee" in e && "[object Function]" === o(e.callee);
                }, s = function() {
                    return i(arguments);
                }();
                i.isLegacyArguments = a, e.exports = s ? i : a;
            },
            9600 (e) {
                "use strict";
                var t, r, n = Function.prototype.toString, o = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
                if ("function" == typeof o && "function" == typeof Object.defineProperty) try {
                    t = Object.defineProperty({}, "length", {
                        get: function() {
                            throw r;
                        }
                    }), r = {}, o(function() {
                        throw 42;
                    }, null, t);
                } catch (e) {
                    e !== r && (o = null);
                }
                else o = null;
                var i = /^\s*class\b/, a = function(e) {
                    try {
                        var t = n.call(e);
                        return i.test(t);
                    } catch (e) {
                        return !1;
                    }
                }, s = function(e) {
                    try {
                        return !a(e) && (n.call(e), !0);
                    } catch (e) {
                        return !1;
                    }
                }, u = Object.prototype.toString, c = "function" == typeof Symbol && !!Symbol.toStringTag, l = !(0 in [
                    , 
                ]), f = function() {
                    return !1;
                };
                if ("object" == typeof document) {
                    var p = document.all;
                    u.call(p) === u.call(document.all) && (f = function(e) {
                        if ((l || !e) && (void 0 === e || "object" == typeof e)) try {
                            var t = u.call(e);
                            return ("[object HTMLAllCollection]" === t || "[object HTML document.all class]" === t || "[object HTMLCollection]" === t || "[object Object]" === t) && null == e("");
                        } catch (e) {}
                        return !1;
                    });
                }
                e.exports = o ? function(e) {
                    if (f(e)) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" != typeof e) return !1;
                    try {
                        o(e, null, t);
                    } catch (e) {
                        if (e !== r) return !1;
                    }
                    return !a(e) && s(e);
                } : function(e) {
                    if (f(e)) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" != typeof e) return !1;
                    if (c) return s(e);
                    if (a(e)) return !1;
                    var t = u.call(e);
                    return !("[object Function]" !== t && "[object GeneratorFunction]" !== t && !/^\[object HTML/.test(t)) && s(e);
                };
            },
            8184 (e, t, r) {
                "use strict";
                var n = r(6556), o = r(9721)(/^\s*(?:function)?\*/), i = r(9092)(), a = r(3628), s = n("Object.prototype.toString"), u = n("Function.prototype.toString"), c = r(4233);
                e.exports = function(e) {
                    if ("function" != typeof e) return !1;
                    if (o(u(e))) return !0;
                    if (!i) return "[object GeneratorFunction]" === s(e);
                    if (!a) return !1;
                    var t = c();
                    return t && a(e) === t.prototype;
                };
            },
            4035 (e, t, r) {
                "use strict";
                var n, o = r(6556), i = r(9092)(), a = r(9957), s = r(5795);
                if (i) {
                    var u = o("RegExp.prototype.exec"), c = {}, l = function() {
                        throw c;
                    }, f = {
                        toString: l,
                        valueOf: l
                    };
                    "symbol" == typeof Symbol.toPrimitive && (f[Symbol.toPrimitive] = l), n = function(e) {
                        if (!e || "object" != typeof e) return !1;
                        var t = s(e, "lastIndex");
                        if (!(t && a(t, "value"))) return !1;
                        try {
                            u(e, f);
                        } catch (e) {
                            return e === c;
                        }
                    };
                } else {
                    var p = o("Object.prototype.toString");
                    n = function(e) {
                        return !(!e || "object" != typeof e && "function" != typeof e) && "[object RegExp]" === p(e);
                    };
                }
                e.exports = n;
            },
            5680 (e, t, r) {
                "use strict";
                var n = r(5767);
                e.exports = function(e) {
                    return !!n(e);
                };
            },
            1514 (e) {
                "use strict";
                e.exports = Math.abs;
            },
            8968 (e) {
                "use strict";
                e.exports = Math.floor;
            },
            4459 (e) {
                "use strict";
                e.exports = Number.isNaN || function(e) {
                    return e != e;
                };
            },
            6188 (e) {
                "use strict";
                e.exports = Math.max;
            },
            8002 (e) {
                "use strict";
                e.exports = Math.min;
            },
            5880 (e) {
                "use strict";
                e.exports = Math.pow;
            },
            414 (e) {
                "use strict";
                e.exports = Math.round;
            },
            3093 (e, t, r) {
                "use strict";
                var n = r(4459);
                e.exports = function(e) {
                    return n(e) || 0 === e ? e : e < 0 ? -1 : 1;
                };
            },
            8859 (e, t, r) {
                var n = "function" == typeof Map && Map.prototype, o = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, i = n && o && "function" == typeof o.get ? o.get : null, a = n && Map.prototype.forEach, s = "function" == typeof Set && Set.prototype, u = Object.getOwnPropertyDescriptor && s ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, c = s && u && "function" == typeof u.get ? u.get : null, l = s && Set.prototype.forEach, f = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, p = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, d = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, h = Boolean.prototype.valueOf, y = Object.prototype.toString, m = Function.prototype.toString, g = String.prototype.match, v = String.prototype.slice, b = String.prototype.replace, w = String.prototype.toUpperCase, S = String.prototype.toLowerCase, A = RegExp.prototype.test, E = Array.prototype.concat, T = Array.prototype.join, O = Array.prototype.slice, k = Math.floor, _ = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, x = Object.getOwnPropertySymbols, P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null, R = "function" == typeof Symbol && "object" == typeof Symbol.iterator, I = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === R || "symbol") ? Symbol.toStringTag : null, B = Object.prototype.propertyIsEnumerable, C = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
                    return e.__proto__;
                } : null);
                function j(e, t) {
                    if (e === 1 / 0 || e === -1 / 0 || e != e || e && e > -1000 && e < 1e3 || A.call(/e/, t)) return t;
                    var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
                    if ("number" == typeof e) {
                        var n = e < 0 ? -k(-e) : k(e);
                        if (n !== e) {
                            var o = String(n), i = v.call(t, o.length + 1);
                            return b.call(o, r, "$&_") + "." + b.call(b.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
                        }
                    }
                    return b.call(t, r, "$&_");
                }
                var U = r(2634), N = U.custom, L = z(N) ? N : null, F = {
                    __proto__: null,
                    double: '"',
                    single: "'"
                }, D = {
                    __proto__: null,
                    double: /(["\\])/g,
                    single: /(['\\])/g
                };
                function M(e, t, r) {
                    var n = r.quoteStyle || t, o = F[n];
                    return o + e + o;
                }
                function V(e) {
                    return b.call(String(e), /"/g, "&quot;");
                }
                function q(e) {
                    return !I || !("object" == typeof e && (I in e || void 0 !== e[I]));
                }
                function G(e) {
                    return "[object Array]" === K(e) && q(e);
                }
                function H(e) {
                    return "[object RegExp]" === K(e) && q(e);
                }
                function z(e) {
                    if (R) return e && "object" == typeof e && e instanceof Symbol;
                    if ("symbol" == typeof e) return !0;
                    if (!e || "object" != typeof e || !P) return !1;
                    try {
                        return P.call(e), !0;
                    } catch (e) {}
                    return !1;
                }
                e.exports = function e(t, n, o, s) {
                    var u = n || {};
                    if (X(u, "quoteStyle") && !X(F, u.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
                    if (X(u, "maxStringLength") && ("number" == typeof u.maxStringLength ? u.maxStringLength < 0 && u.maxStringLength !== 1 / 0 : null !== u.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
                    var y = !X(u, "customInspect") || u.customInspect;
                    if ("boolean" != typeof y && "symbol" !== y) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
                    if (X(u, "indent") && null !== u.indent && "\t" !== u.indent && !(parseInt(u.indent, 10) === u.indent && u.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
                    if (X(u, "numericSeparator") && "boolean" != typeof u.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
                    var w = u.numericSeparator;
                    if (void 0 === t) return "undefined";
                    if (null === t) return "null";
                    if ("boolean" == typeof t) return t ? "true" : "false";
                    if ("string" == typeof t) return $(t, u);
                    if ("number" == typeof t) {
                        if (0 === t) return 1 / 0 / t > 0 ? "0" : "-0";
                        var A = String(t);
                        return w ? j(t, A) : A;
                    }
                    if ("bigint" == typeof t) {
                        var k = String(t) + "n";
                        return w ? j(t, k) : k;
                    }
                    var x = void 0 === u.depth ? 5 : u.depth;
                    if (void 0 === o && (o = 0), o >= x && x > 0 && "object" == typeof t) return G(t) ? "[Array]" : "[Object]";
                    var N = function(e, t) {
                        var r;
                        if ("\t" === e.indent) r = "\t";
                        else {
                            if (!("number" == typeof e.indent && e.indent > 0)) return null;
                            r = T.call(Array(e.indent + 1), " ");
                        }
                        return {
                            base: r,
                            prev: T.call(Array(t + 1), r)
                        };
                    }(u, o);
                    if (void 0 === s) s = [];
                    else if (Z(s, t) >= 0) return "[Circular]";
                    function D(t, r, n) {
                        if (r && (s = O.call(s)).push(r), n) {
                            var i = {
                                depth: u.depth
                            };
                            return X(u, "quoteStyle") && (i.quoteStyle = u.quoteStyle), e(t, i, o + 1, s);
                        }
                        return e(t, u, o + 1, s);
                    }
                    if ("function" == typeof t && !H(t)) {
                        var W = function(e) {
                            if (e.name) return e.name;
                            var t = g.call(m.call(e), /^function\s*([\w$]+)/);
                            if (t) return t[1];
                            return null;
                        }(t), Y = re(t, D);
                        return "[Function" + (W ? ": " + W : " (anonymous)") + "]" + (Y.length > 0 ? " { " + T.call(Y, ", ") + " }" : "");
                    }
                    if (z(t)) {
                        var ne = R ? b.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : P.call(t);
                        return "object" != typeof t || R ? ne : Q(ne);
                    }
                    if (function(e) {
                        if (!e || "object" != typeof e) return !1;
                        if ("undefined" != typeof HTMLElement && e instanceof HTMLElement) return !0;
                        return "string" == typeof e.nodeName && "function" == typeof e.getAttribute;
                    }(t)) {
                        for(var oe = "<" + S.call(String(t.nodeName)), ie = t.attributes || [], ae = 0; ae < ie.length; ae++)oe += " " + ie[ae].name + "=" + M(V(ie[ae].value), "double", u);
                        return oe += ">", t.childNodes && t.childNodes.length && (oe += "..."), oe += "</" + S.call(String(t.nodeName)) + ">";
                    }
                    if (G(t)) {
                        if (0 === t.length) return "[]";
                        var se = re(t, D);
                        return N && !function(e) {
                            for(var t = 0; t < e.length; t++)if (Z(e[t], "\n") >= 0) return !1;
                            return !0;
                        }(se) ? "[" + te(se, N) + "]" : "[ " + T.call(se, ", ") + " ]";
                    }
                    if (function(e) {
                        return "[object Error]" === K(e) && q(e);
                    }(t)) {
                        var ue = re(t, D);
                        return "cause" in Error.prototype || !("cause" in t) || B.call(t, "cause") ? 0 === ue.length ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + T.call(ue, ", ") + " }" : "{ [" + String(t) + "] " + T.call(E.call("[cause]: " + D(t.cause), ue), ", ") + " }";
                    }
                    if ("object" == typeof t && y) {
                        if (L && "function" == typeof t[L] && U) return U(t, {
                            depth: x - o
                        });
                        if ("symbol" !== y && "function" == typeof t.inspect) return t.inspect();
                    }
                    if (function(e) {
                        if (!i || !e || "object" != typeof e) return !1;
                        try {
                            i.call(e);
                            try {
                                c.call(e);
                            } catch (e) {
                                return !0;
                            }
                            return e instanceof Map;
                        } catch (e) {}
                        return !1;
                    }(t)) {
                        var ce = [];
                        return a && a.call(t, function(e, r) {
                            ce.push(D(r, t, !0) + " => " + D(e, t));
                        }), ee("Map", i.call(t), ce, N);
                    }
                    if (function(e) {
                        if (!c || !e || "object" != typeof e) return !1;
                        try {
                            c.call(e);
                            try {
                                i.call(e);
                            } catch (e) {
                                return !0;
                            }
                            return e instanceof Set;
                        } catch (e) {}
                        return !1;
                    }(t)) {
                        var le = [];
                        return l && l.call(t, function(e) {
                            le.push(D(e, t));
                        }), ee("Set", c.call(t), le, N);
                    }
                    if (function(e) {
                        if (!f || !e || "object" != typeof e) return !1;
                        try {
                            f.call(e, f);
                            try {
                                p.call(e, p);
                            } catch (e) {
                                return !0;
                            }
                            return e instanceof WeakMap;
                        } catch (e) {}
                        return !1;
                    }(t)) return J("WeakMap");
                    if (function(e) {
                        if (!p || !e || "object" != typeof e) return !1;
                        try {
                            p.call(e, p);
                            try {
                                f.call(e, f);
                            } catch (e) {
                                return !0;
                            }
                            return e instanceof WeakSet;
                        } catch (e) {}
                        return !1;
                    }(t)) return J("WeakSet");
                    if (function(e) {
                        if (!d || !e || "object" != typeof e) return !1;
                        try {
                            return d.call(e), !0;
                        } catch (e) {}
                        return !1;
                    }(t)) return J("WeakRef");
                    if (function(e) {
                        return "[object Number]" === K(e) && q(e);
                    }(t)) return Q(D(Number(t)));
                    if (function(e) {
                        if (!e || "object" != typeof e || !_) return !1;
                        try {
                            return _.call(e), !0;
                        } catch (e) {}
                        return !1;
                    }(t)) return Q(D(_.call(t)));
                    if (function(e) {
                        return "[object Boolean]" === K(e) && q(e);
                    }(t)) return Q(h.call(t));
                    if (function(e) {
                        return "[object String]" === K(e) && q(e);
                    }(t)) return Q(D(String(t)));
                    if ("undefined" != typeof window && t === window) return "{ [object Window] }";
                    if ("undefined" != typeof globalThis && t === globalThis || void 0 !== r.g && t === r.g) return "{ [object globalThis] }";
                    if (!function(e) {
                        return "[object Date]" === K(e) && q(e);
                    }(t) && !H(t)) {
                        var fe = re(t, D), pe = C ? C(t) === Object.prototype : t instanceof Object || t.constructor === Object, de = t instanceof Object ? "" : "null prototype", he = !pe && I && Object(t) === t && I in t ? v.call(K(t), 8, -1) : de ? "Object" : "", ye = (pe || "function" != typeof t.constructor ? "" : t.constructor.name ? t.constructor.name + " " : "") + (he || de ? "[" + T.call(E.call([], he || [], de || []), ": ") + "] " : "");
                        return 0 === fe.length ? ye + "{}" : N ? ye + "{" + te(fe, N) + "}" : ye + "{ " + T.call(fe, ", ") + " }";
                    }
                    return String(t);
                };
                var W = Object.prototype.hasOwnProperty || function(e) {
                    return e in this;
                };
                function X(e, t) {
                    return W.call(e, t);
                }
                function K(e) {
                    return y.call(e);
                }
                function Z(e, t) {
                    if (e.indexOf) return e.indexOf(t);
                    for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                    return -1;
                }
                function $(e, t) {
                    if (e.length > t.maxStringLength) {
                        var r = e.length - t.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
                        return $(v.call(e, 0, t.maxStringLength), t) + n;
                    }
                    var o = D[t.quoteStyle || "single"];
                    return o.lastIndex = 0, M(b.call(b.call(e, o, "\\$1"), /[\x00-\x1f]/g, Y), "single", t);
                }
                function Y(e) {
                    var t = e.charCodeAt(0), r = {
                        8: "b",
                        9: "t",
                        10: "n",
                        12: "f",
                        13: "r"
                    }[t];
                    return r ? "\\" + r : "\\x" + (t < 16 ? "0" : "") + w.call(t.toString(16));
                }
                function Q(e) {
                    return "Object(" + e + ")";
                }
                function J(e) {
                    return e + " { ? }";
                }
                function ee(e, t, r, n) {
                    return e + " (" + t + ") {" + (n ? te(r, n) : T.call(r, ", ")) + "}";
                }
                function te(e, t) {
                    if (0 === e.length) return "";
                    var r = "\n" + t.prev + t.base;
                    return r + T.call(e, "," + r) + "\n" + t.prev;
                }
                function re(e, t) {
                    var r = G(e), n = [];
                    if (r) {
                        n.length = e.length;
                        for(var o = 0; o < e.length; o++)n[o] = X(e, o) ? t(e[o], e) : "";
                    }
                    var i, a = "function" == typeof x ? x(e) : [];
                    if (R) {
                        i = {};
                        for(var s = 0; s < a.length; s++)i["$" + a[s]] = a[s];
                    }
                    for(var u in e)X(e, u) && (r && String(Number(u)) === u && u < e.length || R && i["$" + u] instanceof Symbol || (A.call(/[^\w$]/, u) ? n.push(t(u, e) + ": " + t(e[u], e)) : n.push(u + ": " + t(e[u], e))));
                    if ("function" == typeof x) for(var c = 0; c < a.length; c++)B.call(e, a[c]) && n.push("[" + t(a[c]) + "]: " + t(e[a[c]], e));
                    return n;
                }
            },
            6578 (e) {
                "use strict";
                e.exports = [
                    "Float16Array",
                    "Float32Array",
                    "Float64Array",
                    "Int8Array",
                    "Int16Array",
                    "Int32Array",
                    "Uint8Array",
                    "Uint8ClampedArray",
                    "Uint16Array",
                    "Uint32Array",
                    "BigInt64Array",
                    "BigUint64Array"
                ];
            },
            4765 (e) {
                "use strict";
                var t = String.prototype.replace, r = /%20/g, n = "RFC1738", o = "RFC3986";
                e.exports = {
                    default: o,
                    formatters: {
                        RFC1738: function(e) {
                            return t.call(e, r, "+");
                        },
                        RFC3986: function(e) {
                            return String(e);
                        }
                    },
                    RFC1738: n,
                    RFC3986: o
                };
            },
            5373 (e, t, r) {
                "use strict";
                var n = r(8636), o = r(2642), i = r(4765);
                e.exports = {
                    formats: i,
                    parse: o,
                    stringify: n
                };
            },
            2642 (e, t, r) {
                "use strict";
                var n = r(7720), o = Object.prototype.hasOwnProperty, i = Array.isArray, a = {
                    allowDots: !1,
                    allowEmptyArrays: !1,
                    allowPrototypes: !1,
                    allowSparse: !1,
                    arrayLimit: 20,
                    charset: "utf-8",
                    charsetSentinel: !1,
                    comma: !1,
                    decodeDotInKeys: !1,
                    decoder: n.decode,
                    delimiter: "&",
                    depth: 5,
                    duplicates: "combine",
                    ignoreQueryPrefix: !1,
                    interpretNumericEntities: !1,
                    parameterLimit: 1e3,
                    parseArrays: !0,
                    plainObjects: !1,
                    strictDepth: !1,
                    strictMerge: !0,
                    strictNullHandling: !1,
                    throwOnLimitExceeded: !1
                }, s = function(e) {
                    return e.replace(/&#(\d+);/g, function(e, t) {
                        return String.fromCharCode(parseInt(t, 10));
                    });
                }, u = function(e, t, r) {
                    if (e && "string" == typeof e && t.comma && e.indexOf(",") > -1) return e.split(",");
                    if (t.throwOnLimitExceeded && r >= t.arrayLimit) throw new RangeError("Array limit exceeded. Only " + t.arrayLimit + " element" + (1 === t.arrayLimit ? "" : "s") + " allowed in an array.");
                    return e;
                }, c = function(e, t, r, i) {
                    if (e) {
                        var a = function(e, t) {
                            var r = t.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e;
                            if (t.depth <= 0) {
                                if (!t.plainObjects && o.call(Object.prototype, r) && !t.allowPrototypes) return;
                                return [
                                    r
                                ];
                            }
                            var n = /(\[[^[\]]*])/g, i = /(\[[^[\]]*])/.exec(r), a = i ? r.slice(0, i.index) : r, s = [];
                            if (a) {
                                if (!t.plainObjects && o.call(Object.prototype, a) && !t.allowPrototypes) return;
                                s[s.length] = a;
                            }
                            for(var u = 0; null !== (i = n.exec(r)) && u < t.depth;){
                                u += 1;
                                var c = i[1].slice(1, -1);
                                if (!t.plainObjects && o.call(Object.prototype, c) && !t.allowPrototypes) return;
                                s[s.length] = i[1];
                            }
                            if (i) {
                                if (!0 === t.strictDepth) throw new RangeError("Input depth exceeded depth option of " + t.depth + " and strictDepth is true");
                                s[s.length] = "[" + r.slice(i.index) + "]";
                            }
                            return s;
                        }(e, r);
                        if (a) return function(e, t, r, o) {
                            var i = 0;
                            if (e.length > 0 && "[]" === e[e.length - 1]) {
                                var a = e.slice(0, -1).join("");
                                i = Array.isArray(t) && t[a] ? t[a].length : 0;
                            }
                            for(var s = o ? t : u(t, r, i), c = e.length - 1; c >= 0; --c){
                                var l, f = e[c];
                                if ("[]" === f && r.parseArrays) l = n.isOverflow(s) ? s : r.allowEmptyArrays && ("" === s || r.strictNullHandling && null === s) ? [] : n.combine([], s, r.arrayLimit, r.plainObjects);
                                else {
                                    l = r.plainObjects ? {
                                        __proto__: null
                                    } : {};
                                    var p = "[" === f.charAt(0) && "]" === f.charAt(f.length - 1) ? f.slice(1, -1) : f, d = r.decodeDotInKeys ? p.replace(/%2E/g, ".") : p, h = parseInt(d, 10), y = !isNaN(h) && f !== d && String(h) === d && h >= 0 && r.parseArrays;
                                    if (r.parseArrays || "" !== d) {
                                        if (y && h < r.arrayLimit) (l = [])[h] = s;
                                        else {
                                            if (y && r.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + r.arrayLimit + " element" + (1 === r.arrayLimit ? "" : "s") + " allowed in an array.");
                                            y ? (l[h] = s, n.markOverflow(l, h)) : "__proto__" !== d && (l[d] = s);
                                        }
                                    } else l = {
                                        0: s
                                    };
                                }
                                s = l;
                            }
                            return s;
                        }(a, t, r, i);
                    }
                };
                e.exports = function(e, t) {
                    var r = function(e) {
                        if (!e) return a;
                        if (void 0 !== e.allowEmptyArrays && "boolean" != typeof e.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
                        if (void 0 !== e.decodeDotInKeys && "boolean" != typeof e.decodeDotInKeys) throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
                        if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
                        if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                        if (void 0 !== e.throwOnLimitExceeded && "boolean" != typeof e.throwOnLimitExceeded) throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
                        var t = void 0 === e.charset ? a.charset : e.charset, r = void 0 === e.duplicates ? a.duplicates : e.duplicates;
                        if ("combine" !== r && "first" !== r && "last" !== r) throw new TypeError("The duplicates option must be either combine, first, or last");
                        return {
                            allowDots: void 0 === e.allowDots ? !0 === e.decodeDotInKeys || a.allowDots : !!e.allowDots,
                            allowEmptyArrays: "boolean" == typeof e.allowEmptyArrays ? !!e.allowEmptyArrays : a.allowEmptyArrays,
                            allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : a.allowPrototypes,
                            allowSparse: "boolean" == typeof e.allowSparse ? e.allowSparse : a.allowSparse,
                            arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
                            charset: t,
                            charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : a.charsetSentinel,
                            comma: "boolean" == typeof e.comma ? e.comma : a.comma,
                            decodeDotInKeys: "boolean" == typeof e.decodeDotInKeys ? e.decodeDotInKeys : a.decodeDotInKeys,
                            decoder: "function" == typeof e.decoder ? e.decoder : a.decoder,
                            delimiter: "string" == typeof e.delimiter || n.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
                            depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : a.depth,
                            duplicates: r,
                            ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
                            interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : a.interpretNumericEntities,
                            parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : a.parameterLimit,
                            parseArrays: !1 !== e.parseArrays,
                            plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : a.plainObjects,
                            strictDepth: "boolean" == typeof e.strictDepth ? !!e.strictDepth : a.strictDepth,
                            strictMerge: "boolean" == typeof e.strictMerge ? !!e.strictMerge : a.strictMerge,
                            strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : a.strictNullHandling,
                            throwOnLimitExceeded: "boolean" == typeof e.throwOnLimitExceeded && e.throwOnLimitExceeded
                        };
                    }(t);
                    if ("" === e || null == e) return r.plainObjects ? {
                        __proto__: null
                    } : {};
                    for(var l = "string" == typeof e ? function(e, t) {
                        var r = {
                            __proto__: null
                        }, c = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e;
                        c = c.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                        var l = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, f = c.split(t.delimiter, t.throwOnLimitExceeded ? l + 1 : l);
                        if (t.throwOnLimitExceeded && f.length > l) throw new RangeError("Parameter limit exceeded. Only " + l + " parameter" + (1 === l ? "" : "s") + " allowed.");
                        var p, d = -1, h = t.charset;
                        if (t.charsetSentinel) for(p = 0; p < f.length; ++p)0 === f[p].indexOf("utf8=") && ("utf8=%E2%9C%93" === f[p] ? h = "utf-8" : "utf8=%26%2310003%3B" === f[p] && (h = "iso-8859-1"), d = p, p = f.length);
                        for(p = 0; p < f.length; ++p)if (p !== d) {
                            var y, m, g = f[p], v = g.indexOf("]="), b = -1 === v ? g.indexOf("=") : v + 1;
                            if (-1 === b ? (y = t.decoder(g, a.decoder, h, "key"), m = t.strictNullHandling ? null : "") : null !== (y = t.decoder(g.slice(0, b), a.decoder, h, "key")) && (m = n.maybeMap(u(g.slice(b + 1), t, i(r[y]) ? r[y].length : 0), function(e) {
                                return t.decoder(e, a.decoder, h, "value");
                            })), m && t.interpretNumericEntities && "iso-8859-1" === h && (m = s(String(m))), g.indexOf("[]=") > -1 && (m = i(m) ? [
                                m
                            ] : m), t.comma && i(m) && m.length > t.arrayLimit) {
                                if (t.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + t.arrayLimit + " element" + (1 === t.arrayLimit ? "" : "s") + " allowed in an array.");
                                m = n.combine([], m, t.arrayLimit, t.plainObjects);
                            }
                            if (null !== y) {
                                var w = o.call(r, y);
                                w && ("combine" === t.duplicates || g.indexOf("[]=") > -1) ? r[y] = n.combine(r[y], m, t.arrayLimit, t.plainObjects) : w && "last" !== t.duplicates || (r[y] = m);
                            }
                        }
                        return r;
                    }(e, r) : e, f = r.plainObjects ? {
                        __proto__: null
                    } : {}, p = Object.keys(l), d = 0; d < p.length; ++d){
                        var h = p[d], y = c(h, l[h], r, "string" == typeof e);
                        f = n.merge(f, y, r);
                    }
                    return !0 === r.allowSparse ? f : n.compact(f);
                };
            },
            8636 (e, t, r) {
                "use strict";
                var n = r(920), o = r(7720), i = r(4765), a = Object.prototype.hasOwnProperty, s = {
                    brackets: function(e) {
                        return e + "[]";
                    },
                    comma: "comma",
                    indices: function(e, t) {
                        return e + "[" + t + "]";
                    },
                    repeat: function(e) {
                        return e;
                    }
                }, u = Array.isArray, c = Array.prototype.push, l = function(e, t) {
                    c.apply(e, u(t) ? t : [
                        t
                    ]);
                }, f = Date.prototype.toISOString, p = i.default, d = {
                    addQueryPrefix: !1,
                    allowDots: !1,
                    allowEmptyArrays: !1,
                    arrayFormat: "indices",
                    charset: "utf-8",
                    charsetSentinel: !1,
                    commaRoundTrip: !1,
                    delimiter: "&",
                    encode: !0,
                    encodeDotInKeys: !1,
                    encoder: o.encode,
                    encodeValuesOnly: !1,
                    filter: void 0,
                    format: p,
                    formatter: i.formatters[p],
                    indices: !1,
                    serializeDate: function(e) {
                        return f.call(e);
                    },
                    skipNulls: !1,
                    strictNullHandling: !1
                }, h = {}, y = function e(t, r, i, a, s, c, f, p, y, m, g, v, b, w, S, A, E, T) {
                    for(var O, k = t, _ = T, x = 0, P = !1; void 0 !== (_ = _.get(h)) && !P;){
                        var R = _.get(t);
                        if (x += 1, void 0 !== R) {
                            if (R === x) throw new RangeError("Cyclic object value");
                            P = !0;
                        }
                        void 0 === _.get(h) && (x = 0);
                    }
                    if ("function" == typeof m ? k = m(r, k) : k instanceof Date ? k = b(k) : "comma" === i && u(k) && (k = o.maybeMap(k, function(e) {
                        return e instanceof Date ? b(e) : e;
                    })), null === k) {
                        if (c) return y && !A ? y(r, d.encoder, E, "key", w) : r;
                        k = "";
                    }
                    if ("string" == typeof (O = k) || "number" == typeof O || "boolean" == typeof O || "symbol" == typeof O || "bigint" == typeof O || o.isBuffer(k)) return y ? [
                        S(A ? r : y(r, d.encoder, E, "key", w)) + "=" + S(y(k, d.encoder, E, "value", w))
                    ] : [
                        S(r) + "=" + S(String(k))
                    ];
                    var I, B = [];
                    if (void 0 === k) return B;
                    if ("comma" === i && u(k)) A && y && (k = o.maybeMap(k, y)), I = [
                        {
                            value: k.length > 0 ? k.join(",") || null : void 0
                        }
                    ];
                    else if (u(m)) I = m;
                    else {
                        var C = Object.keys(k);
                        I = g ? C.sort(g) : C;
                    }
                    var j = p ? String(r).replace(/\./g, "%2E") : String(r), U = a && u(k) && 1 === k.length ? j + "[]" : j;
                    if (s && u(k) && 0 === k.length) return U + "[]";
                    for(var N = 0; N < I.length; ++N){
                        var L = I[N], F = "object" == typeof L && L && void 0 !== L.value ? L.value : k[L];
                        if (!f || null !== F) {
                            var D = v && p ? String(L).replace(/\./g, "%2E") : String(L), M = u(k) ? "function" == typeof i ? i(U, D) : U : U + (v ? "." + D : "[" + D + "]");
                            T.set(t, x);
                            var V = n();
                            V.set(h, T), l(B, e(F, M, i, a, s, c, f, p, "comma" === i && A && u(k) ? null : y, m, g, v, b, w, S, A, E, V));
                        }
                    }
                    return B;
                };
                e.exports = function(e, t) {
                    var r, o = e, c = function(e) {
                        if (!e) return d;
                        if (void 0 !== e.allowEmptyArrays && "boolean" != typeof e.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
                        if (void 0 !== e.encodeDotInKeys && "boolean" != typeof e.encodeDotInKeys) throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
                        if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
                        var t = e.charset || d.charset;
                        if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                        var r = i.default;
                        if (void 0 !== e.format) {
                            if (!a.call(i.formatters, e.format)) throw new TypeError("Unknown format option provided.");
                            r = e.format;
                        }
                        var n, o = i.formatters[r], c = d.filter;
                        if (("function" == typeof e.filter || u(e.filter)) && (c = e.filter), n = e.arrayFormat in s ? e.arrayFormat : "indices" in e ? e.indices ? "indices" : "repeat" : d.arrayFormat, "commaRoundTrip" in e && "boolean" != typeof e.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
                        var l = void 0 === e.allowDots ? !0 === e.encodeDotInKeys || d.allowDots : !!e.allowDots;
                        return {
                            addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : d.addQueryPrefix,
                            allowDots: l,
                            allowEmptyArrays: "boolean" == typeof e.allowEmptyArrays ? !!e.allowEmptyArrays : d.allowEmptyArrays,
                            arrayFormat: n,
                            charset: t,
                            charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : d.charsetSentinel,
                            commaRoundTrip: !!e.commaRoundTrip,
                            delimiter: void 0 === e.delimiter ? d.delimiter : e.delimiter,
                            encode: "boolean" == typeof e.encode ? e.encode : d.encode,
                            encodeDotInKeys: "boolean" == typeof e.encodeDotInKeys ? e.encodeDotInKeys : d.encodeDotInKeys,
                            encoder: "function" == typeof e.encoder ? e.encoder : d.encoder,
                            encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : d.encodeValuesOnly,
                            filter: c,
                            format: r,
                            formatter: o,
                            serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : d.serializeDate,
                            skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : d.skipNulls,
                            sort: "function" == typeof e.sort ? e.sort : null,
                            strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : d.strictNullHandling
                        };
                    }(t);
                    "function" == typeof c.filter ? o = (0, c.filter)("", o) : u(c.filter) && (r = c.filter);
                    var f = [];
                    if ("object" != typeof o || null === o) return "";
                    var p = s[c.arrayFormat], h = "comma" === p && c.commaRoundTrip;
                    r || (r = Object.keys(o)), c.sort && r.sort(c.sort);
                    for(var m = n(), g = 0; g < r.length; ++g){
                        var v = r[g], b = o[v];
                        c.skipNulls && null === b || l(f, y(b, v, p, h, c.allowEmptyArrays, c.strictNullHandling, c.skipNulls, c.encodeDotInKeys, c.encode ? c.encoder : null, c.filter, c.sort, c.allowDots, c.serializeDate, c.format, c.formatter, c.encodeValuesOnly, c.charset, m));
                    }
                    var w = f.join(c.delimiter), S = !0 === c.addQueryPrefix ? "?" : "";
                    return c.charsetSentinel && ("iso-8859-1" === c.charset ? S += "utf8=%26%2310003%3B&" : S += "utf8=%E2%9C%93&"), w.length > 0 ? S + w : "";
                };
            },
            7720 (e, t, r) {
                "use strict";
                var n = r(4765), o = r(920), i = Object.prototype.hasOwnProperty, a = Array.isArray, s = o(), u = function(e, t) {
                    return s.set(e, t), e;
                }, c = function(e) {
                    return s.has(e);
                }, l = function(e) {
                    return s.get(e);
                }, f = function(e, t) {
                    s.set(e, t);
                }, p = function() {
                    for(var e = [], t = 0; t < 256; ++t)e[e.length] = "%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase();
                    return e;
                }(), d = function(e, t) {
                    for(var r = t && t.plainObjects ? {
                        __proto__: null
                    } : {}, n = 0; n < e.length; ++n)void 0 !== e[n] && (r[n] = e[n]);
                    return r;
                }, h = 1024;
                e.exports = {
                    arrayToObject: d,
                    assign: function(e, t) {
                        return Object.keys(t).reduce(function(e, r) {
                            return e[r] = t[r], e;
                        }, e);
                    },
                    combine: function(e, t, r, n) {
                        if (c(e)) {
                            var o = l(e) + 1;
                            return e[o] = t, f(e, o), e;
                        }
                        var i = [].concat(e, t);
                        return i.length > r ? u(d(i, {
                            plainObjects: n
                        }), i.length - 1) : i;
                    },
                    compact: function(e) {
                        for(var t = [
                            {
                                obj: {
                                    o: e
                                },
                                prop: "o"
                            }
                        ], r = [], n = 0; n < t.length; ++n)for(var o = t[n], i = o.obj[o.prop], s = Object.keys(i), u = 0; u < s.length; ++u){
                            var c = s[u], l = i[c];
                            "object" == typeof l && null !== l && -1 === r.indexOf(l) && (t[t.length] = {
                                obj: i,
                                prop: c
                            }, r[r.length] = l);
                        }
                        return function(e) {
                            for(; e.length > 1;){
                                var t = e.pop(), r = t.obj[t.prop];
                                if (a(r)) {
                                    for(var n = [], o = 0; o < r.length; ++o)void 0 !== r[o] && (n[n.length] = r[o]);
                                    t.obj[t.prop] = n;
                                }
                            }
                        }(t), e;
                    },
                    decode: function(e, t, r) {
                        var n = e.replace(/\+/g, " ");
                        if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
                        try {
                            return decodeURIComponent(n);
                        } catch (e) {
                            return n;
                        }
                    },
                    encode: function(e, t, r, o, i) {
                        if (0 === e.length) return e;
                        var a = e;
                        if ("symbol" == typeof e ? a = Symbol.prototype.toString.call(e) : "string" != typeof e && (a = String(e)), "iso-8859-1" === r) return escape(a).replace(/%u[0-9a-f]{4}/gi, function(e) {
                            return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
                        });
                        for(var s = "", u = 0; u < a.length; u += h){
                            for(var c = a.length >= h ? a.slice(u, u + h) : a, l = [], f = 0; f < c.length; ++f){
                                var d = c.charCodeAt(f);
                                45 === d || 46 === d || 95 === d || 126 === d || d >= 48 && d <= 57 || d >= 65 && d <= 90 || d >= 97 && d <= 122 || i === n.RFC1738 && (40 === d || 41 === d) ? l[l.length] = c.charAt(f) : d < 128 ? l[l.length] = p[d] : d < 2048 ? l[l.length] = p[192 | d >> 6] + p[128 | 63 & d] : d < 55296 || d >= 57344 ? l[l.length] = p[224 | d >> 12] + p[128 | d >> 6 & 63] + p[128 | 63 & d] : (f += 1, d = 65536 + ((1023 & d) << 10 | 1023 & c.charCodeAt(f)), l[l.length] = p[240 | d >> 18] + p[128 | d >> 12 & 63] + p[128 | d >> 6 & 63] + p[128 | 63 & d]);
                            }
                            s += l.join("");
                        }
                        return s;
                    },
                    isBuffer: function(e) {
                        return !(!e || "object" != typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
                    },
                    isOverflow: c,
                    isRegExp: function(e) {
                        return "[object RegExp]" === Object.prototype.toString.call(e);
                    },
                    markOverflow: u,
                    maybeMap: function(e, t) {
                        if (a(e)) {
                            for(var r = [], n = 0; n < e.length; n += 1)r[r.length] = t(e[n]);
                            return r;
                        }
                        return t(e);
                    },
                    merge: function e(t, r, n) {
                        if (!r) return t;
                        if ("object" != typeof r && "function" != typeof r) {
                            if (a(t)) {
                                var o = t.length;
                                if (n && "number" == typeof n.arrayLimit && o > n.arrayLimit) return u(d(t.concat(r), n), o);
                                t[o] = r;
                            } else {
                                if (!t || "object" != typeof t) return [
                                    t,
                                    r
                                ];
                                if (c(t)) {
                                    var s = l(t) + 1;
                                    t[s] = r, f(t, s);
                                } else {
                                    if (n && n.strictMerge) return [
                                        t,
                                        r
                                    ];
                                    (n && (n.plainObjects || n.allowPrototypes) || !i.call(Object.prototype, r)) && (t[r] = !0);
                                }
                            }
                            return t;
                        }
                        if (!t || "object" != typeof t) {
                            if (c(r)) {
                                for(var p = Object.keys(r), h = n && n.plainObjects ? {
                                    __proto__: null,
                                    0: t
                                } : {
                                    0: t
                                }, y = 0; y < p.length; y++)h[parseInt(p[y], 10) + 1] = r[p[y]];
                                return u(h, l(r) + 1);
                            }
                            var m = [
                                t
                            ].concat(r);
                            return n && "number" == typeof n.arrayLimit && m.length > n.arrayLimit ? u(d(m, n), m.length - 1) : m;
                        }
                        var g = t;
                        return a(t) && !a(r) && (g = d(t, n)), a(t) && a(r) ? (r.forEach(function(r, o) {
                            if (i.call(t, o)) {
                                var a = t[o];
                                a && "object" == typeof a && r && "object" == typeof r ? t[o] = e(a, r, n) : t[t.length] = r;
                            } else t[o] = r;
                        }), t) : Object.keys(r).reduce(function(t, o) {
                            var a = r[o];
                            if (i.call(t, o) ? t[o] = e(t[o], a, n) : t[o] = a, c(r) && !c(t) && u(t, l(r)), c(t)) {
                                var s = parseInt(o, 10);
                                String(s) === o && s >= 0 && s > l(t) && f(t, s);
                            }
                            return t;
                        }, g);
                    }
                };
            },
            3209 (e, t, r) {
                "use strict";
                var n = 65536, o = 4294967295;
                var i = r(2861).Buffer, a = r.g.crypto || r.g.msCrypto;
                a && a.getRandomValues ? e.exports = function(e, t) {
                    if (e > o) throw new RangeError("requested too many random bytes");
                    var r = i.allocUnsafe(e);
                    if (e > 0) {
                        if (e > n) for(var s = 0; s < e; s += n)a.getRandomValues(r.slice(s, s + n));
                        else a.getRandomValues(r);
                    }
                    if ("function" == typeof t) return $4TNnu.nextTick(function() {
                        t(null, r);
                    });
                    return r;
                } : e.exports = function() {
                    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                };
            },
            2861 (e, t, r) {
                var n = r(8287), o = n.Buffer;
                function i(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function a(e, t, r) {
                    return o(e, t, r);
                }
                o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = a), a.prototype = Object.create(o.prototype), i(o, a), a.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return o(e, t, r);
                }, a.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = o(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, a.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return o(e);
                }, a.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            9721 (e, t, r) {
                "use strict";
                var n = r(6556), o = r(4035), i = n("RegExp.prototype.exec"), a = r(9675);
                e.exports = function(e) {
                    if (!o(e)) throw new a("`regex` must be a RegExp");
                    return function(t) {
                        return null !== i(e, t);
                    };
                };
            },
            6897 (e, t, r) {
                "use strict";
                var n = r(453), o = r(41), i = r(592)(), a = r(5795), s = r(9675), u = n("%Math.floor%");
                e.exports = function(e, t) {
                    if ("function" != typeof e) throw new s("`fn` is not a function");
                    if ("number" != typeof t || t < 0 || t > 4294967295 || u(t) !== t) throw new s("`length` must be a positive 32-bit integer");
                    var r = arguments.length > 2 && !!arguments[2], n = !0, c = !0;
                    if ("length" in e && a) {
                        var l = a(e, "length");
                        l && !l.configurable && (n = !1), l && !l.writable && (c = !1);
                    }
                    return (n || c || !r) && (i ? o(e, "length", t, !0, !0) : o(e, "length", t)), e;
                };
            },
            4803 (e, t, r) {
                "use strict";
                var n = r(8859), o = r(9675), i = function(e, t, r) {
                    for(var n, o = e; null != (n = o.next); o = n)if (n.key === t) return o.next = n.next, r || (n.next = e.next, e.next = n), n;
                };
                e.exports = function() {
                    var e, t = {
                        assert: function(e) {
                            if (!t.has(e)) throw new o("Side channel does not contain " + n(e));
                        },
                        delete: function(t) {
                            var r = e && e.next, n = function(e, t) {
                                if (e) return i(e, t, !0);
                            }(e, t);
                            return n && r && r === n && (e = void 0), !!n;
                        },
                        get: function(t) {
                            return function(e, t) {
                                if (e) {
                                    var r = i(e, t);
                                    return r && r.value;
                                }
                            }(e, t);
                        },
                        has: function(t) {
                            return function(e, t) {
                                return !!e && !!i(e, t);
                            }(e, t);
                        },
                        set: function(t, r) {
                            e || (e = {
                                next: void 0
                            }), function(e, t, r) {
                                var n = i(e, t);
                                n ? n.value = r : e.next = {
                                    key: t,
                                    next: e.next,
                                    value: r
                                };
                            }(e, t, r);
                        }
                    };
                    return t;
                };
            },
            507 (e, t, r) {
                "use strict";
                var n = r(453), o = r(6556), i = r(8859), a = r(9675), s = n("%Map%", !0), u = o("Map.prototype.get", !0), c = o("Map.prototype.set", !0), l = o("Map.prototype.has", !0), f = o("Map.prototype.delete", !0), p = o("Map.prototype.size", !0);
                e.exports = !!s && function() {
                    var e, t = {
                        assert: function(e) {
                            if (!t.has(e)) throw new a("Side channel does not contain " + i(e));
                        },
                        delete: function(t) {
                            if (e) {
                                var r = f(e, t);
                                return 0 === p(e) && (e = void 0), r;
                            }
                            return !1;
                        },
                        get: function(t) {
                            if (e) return u(e, t);
                        },
                        has: function(t) {
                            return !!e && l(e, t);
                        },
                        set: function(t, r) {
                            e || (e = new s), c(e, t, r);
                        }
                    };
                    return t;
                };
            },
            2271 (e, t, r) {
                "use strict";
                var n = r(453), o = r(6556), i = r(8859), a = r(507), s = r(9675), u = n("%WeakMap%", !0), c = o("WeakMap.prototype.get", !0), l = o("WeakMap.prototype.set", !0), f = o("WeakMap.prototype.has", !0), p = o("WeakMap.prototype.delete", !0);
                e.exports = u ? function() {
                    var e, t, r = {
                        assert: function(e) {
                            if (!r.has(e)) throw new s("Side channel does not contain " + i(e));
                        },
                        delete: function(r) {
                            if (u && r && ("object" == typeof r || "function" == typeof r)) {
                                if (e) return p(e, r);
                            } else if (a && t) return t.delete(r);
                            return !1;
                        },
                        get: function(r) {
                            return u && r && ("object" == typeof r || "function" == typeof r) && e ? c(e, r) : t && t.get(r);
                        },
                        has: function(r) {
                            return u && r && ("object" == typeof r || "function" == typeof r) && e ? f(e, r) : !!t && t.has(r);
                        },
                        set: function(r, n) {
                            u && r && ("object" == typeof r || "function" == typeof r) ? (e || (e = new u), l(e, r, n)) : a && (t || (t = a()), t.set(r, n));
                        }
                    };
                    return r;
                } : a;
            },
            920 (e, t, r) {
                "use strict";
                var n = r(9675), o = r(8859), i = r(4803), a = r(507), s = r(2271) || a || i;
                e.exports = function() {
                    var e, t = {
                        assert: function(e) {
                            if (!t.has(e)) throw new n("Side channel does not contain " + o(e));
                        },
                        delete: function(t) {
                            return !!e && e.delete(t);
                        },
                        get: function(t) {
                            return e && e.get(t);
                        },
                        has: function(t) {
                            return !!e && e.has(t);
                        },
                        set: function(t, r) {
                            e || (e = s()), e.set(t, r);
                        }
                    };
                    return t;
                };
            },
            1568 (e, t, r) {
                var n = r(5537), o = r(6917), i = r(7510), a = r(6866), s = r(8835), u = t;
                u.request = function(e, t) {
                    e = "string" == typeof e ? s.parse(e) : i(e);
                    var o = -1 === r.g.location.protocol.search(/^https?:$/) ? "http:" : "", a = e.protocol || o, u = e.hostname || e.host, c = e.port, l = e.path || "/";
                    u && -1 !== u.indexOf(":") && (u = "[" + u + "]"), e.url = (u ? a + "//" + u : "") + (c ? ":" + c : "") + l, e.method = (e.method || "GET").toUpperCase(), e.headers = e.headers || {};
                    var f = new n(e);
                    return t && f.on("response", t), f;
                }, u.get = function(e, t) {
                    var r = u.request(e, t);
                    return r.end(), r;
                }, u.ClientRequest = n, u.IncomingMessage = o.IncomingMessage, u.Agent = function() {}, u.Agent.defaultMaxSockets = 4, u.globalAgent = new u.Agent, u.STATUS_CODES = a, u.METHODS = [
                    "CHECKOUT",
                    "CONNECT",
                    "COPY",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "LOCK",
                    "M-SEARCH",
                    "MERGE",
                    "MKACTIVITY",
                    "MKCOL",
                    "MOVE",
                    "NOTIFY",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PROPFIND",
                    "PROPPATCH",
                    "PURGE",
                    "PUT",
                    "REPORT",
                    "SEARCH",
                    "SUBSCRIBE",
                    "TRACE",
                    "UNLOCK",
                    "UNSUBSCRIBE"
                ];
            },
            6688 (e, t, r) {
                var n;
                function o() {
                    if (void 0 !== n) return n;
                    if (r.g.XMLHttpRequest) {
                        n = new r.g.XMLHttpRequest;
                        try {
                            n.open("GET", r.g.XDomainRequest ? "/" : "https://example.com");
                        } catch (e) {
                            n = null;
                        }
                    } else n = null;
                    return n;
                }
                function i(e) {
                    var t = o();
                    if (!t) return !1;
                    try {
                        return t.responseType = e, t.responseType === e;
                    } catch (e) {}
                    return !1;
                }
                function a(e) {
                    return "function" == typeof e;
                }
                t.fetch = a(r.g.fetch) && a(r.g.ReadableStream), t.writableStream = a(r.g.WritableStream), t.abortController = a(r.g.AbortController), t.arraybuffer = t.fetch || i("arraybuffer"), t.msstream = !t.fetch && i("ms-stream"), t.mozchunkedarraybuffer = !t.fetch && i("moz-chunked-arraybuffer"), t.overrideMimeType = t.fetch || !!o() && a(o().overrideMimeType), n = null;
            },
            5537 (e, t, r) {
                var n = r(8287).Buffer, o = r(6688), i = r(6698), a = r(6917), s = r(3242), u = a.IncomingMessage, c = a.readyStates;
                var l = e.exports = function(e) {
                    var t, r = this;
                    s.Writable.call(r), r._opts = e, r._body = [], r._headers = {}, e.auth && r.setHeader("Authorization", "Basic " + n.from(e.auth).toString("base64")), Object.keys(e.headers).forEach(function(t) {
                        r.setHeader(t, e.headers[t]);
                    });
                    var i = !0;
                    if ("disable-fetch" === e.mode || "requestTimeout" in e && !o.abortController) i = !1, t = !0;
                    else if ("prefer-streaming" === e.mode) t = !1;
                    else if ("allow-wrong-content-type" === e.mode) t = !o.overrideMimeType;
                    else {
                        if (e.mode && "default" !== e.mode && "prefer-fast" !== e.mode) throw new Error("Invalid value for opts.mode");
                        t = !0;
                    }
                    r._mode = function(e, t) {
                        return o.fetch && t ? "fetch" : o.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : o.msstream ? "ms-stream" : o.arraybuffer && e ? "arraybuffer" : "text";
                    }(t, i), r._fetchTimer = null, r._socketTimeout = null, r._socketTimer = null, r.on("finish", function() {
                        r._onFinish();
                    });
                };
                i(l, s.Writable), l.prototype.setHeader = function(e, t) {
                    var r = e.toLowerCase();
                    -1 === f.indexOf(r) && (this._headers[r] = {
                        name: e,
                        value: t
                    });
                }, l.prototype.getHeader = function(e) {
                    var t = this._headers[e.toLowerCase()];
                    return t ? t.value : null;
                }, l.prototype.removeHeader = function(e) {
                    delete this._headers[e.toLowerCase()];
                }, l.prototype._onFinish = function() {
                    var e = this;
                    if (!e._destroyed) {
                        var t = e._opts;
                        "timeout" in t && 0 !== t.timeout && e.setTimeout(t.timeout);
                        var n = e._headers, i = null;
                        "GET" !== t.method && "HEAD" !== t.method && (i = new Blob(e._body, {
                            type: (n["content-type"] || {}).value || ""
                        }));
                        var a = [];
                        if (Object.keys(n).forEach(function(e) {
                            var t = n[e].name, r = n[e].value;
                            Array.isArray(r) ? r.forEach(function(e) {
                                a.push([
                                    t,
                                    e
                                ]);
                            }) : a.push([
                                t,
                                r
                            ]);
                        }), "fetch" === e._mode) {
                            var s = null;
                            if (o.abortController) {
                                var u = new AbortController;
                                s = u.signal, e._fetchAbortController = u, "requestTimeout" in t && 0 !== t.requestTimeout && (e._fetchTimer = r.g.setTimeout(function() {
                                    e.emit("requestTimeout"), e._fetchAbortController && e._fetchAbortController.abort();
                                }, t.requestTimeout));
                            }
                            r.g.fetch(e._opts.url, {
                                method: e._opts.method,
                                headers: a,
                                body: i || void 0,
                                mode: "cors",
                                credentials: t.withCredentials ? "include" : "same-origin",
                                signal: s
                            }).then(function(t) {
                                e._fetchResponse = t, e._resetTimers(!1), e._connect();
                            }, function(t) {
                                e._resetTimers(!0), e._destroyed || e.emit("error", t);
                            });
                        } else {
                            var l = e._xhr = new r.g.XMLHttpRequest;
                            try {
                                l.open(e._opts.method, e._opts.url, !0);
                            } catch (t) {
                                return void $4TNnu.nextTick(function() {
                                    e.emit("error", t);
                                });
                            }
                            "responseType" in l && (l.responseType = e._mode), "withCredentials" in l && (l.withCredentials = !!t.withCredentials), "text" === e._mode && "overrideMimeType" in l && l.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in t && (l.timeout = t.requestTimeout, l.ontimeout = function() {
                                e.emit("requestTimeout");
                            }), a.forEach(function(e) {
                                l.setRequestHeader(e[0], e[1]);
                            }), e._response = null, l.onreadystatechange = function() {
                                switch(l.readyState){
                                    case c.LOADING:
                                    case c.DONE:
                                        e._onXHRProgress();
                                }
                            }, "moz-chunked-arraybuffer" === e._mode && (l.onprogress = function() {
                                e._onXHRProgress();
                            }), l.onerror = function() {
                                e._destroyed || (e._resetTimers(!0), e.emit("error", new Error("XHR error")));
                            };
                            try {
                                l.send(i);
                            } catch (t) {
                                return void $4TNnu.nextTick(function() {
                                    e.emit("error", t);
                                });
                            }
                        }
                    }
                }, l.prototype._onXHRProgress = function() {
                    var e = this;
                    e._resetTimers(!1), function(e) {
                        try {
                            var t = e.status;
                            return null !== t && 0 !== t;
                        } catch (e) {
                            return !1;
                        }
                    }(e._xhr) && !e._destroyed && (e._response || e._connect(), e._response._onXHRProgress(e._resetTimers.bind(e)));
                }, l.prototype._connect = function() {
                    var e = this;
                    e._destroyed || (e._response = new u(e._xhr, e._fetchResponse, e._mode, e._resetTimers.bind(e)), e._response.on("error", function(t) {
                        e.emit("error", t);
                    }), e.emit("response", e._response));
                }, l.prototype._write = function(e, t, r) {
                    this._body.push(e), r();
                }, l.prototype._resetTimers = function(e) {
                    var t = this;
                    r.g.clearTimeout(t._socketTimer), t._socketTimer = null, e ? (r.g.clearTimeout(t._fetchTimer), t._fetchTimer = null) : t._socketTimeout && (t._socketTimer = r.g.setTimeout(function() {
                        t.emit("timeout");
                    }, t._socketTimeout));
                }, l.prototype.abort = l.prototype.destroy = function(e) {
                    var t = this;
                    t._destroyed = !0, t._resetTimers(!0), t._response && (t._response._destroyed = !0), t._xhr ? t._xhr.abort() : t._fetchAbortController && t._fetchAbortController.abort(), e && t.emit("error", e);
                }, l.prototype.end = function(e, t, r) {
                    "function" == typeof e && (r = e, e = void 0), s.Writable.prototype.end.call(this, e, t, r);
                }, l.prototype.setTimeout = function(e, t) {
                    var r = this;
                    t && r.once("timeout", t), r._socketTimeout = e, r._resetTimers(!1);
                }, l.prototype.flushHeaders = function() {}, l.prototype.setNoDelay = function() {}, l.prototype.setSocketKeepAlive = function() {};
                var f = [
                    "accept-charset",
                    "accept-encoding",
                    "access-control-request-headers",
                    "access-control-request-method",
                    "connection",
                    "content-length",
                    "cookie",
                    "cookie2",
                    "date",
                    "dnt",
                    "expect",
                    "host",
                    "keep-alive",
                    "origin",
                    "referer",
                    "te",
                    "trailer",
                    "transfer-encoding",
                    "upgrade",
                    "via"
                ];
            },
            6917 (e, t, r) {
                var n = r(8287).Buffer, o = r(6688), i = r(6698), a = r(3242), s = t.readyStates = {
                    UNSENT: 0,
                    OPENED: 1,
                    HEADERS_RECEIVED: 2,
                    LOADING: 3,
                    DONE: 4
                }, u = t.IncomingMessage = function(e, t, r, i) {
                    var s = this;
                    if (a.Readable.call(s), s._mode = r, s.headers = {}, s.rawHeaders = [], s.trailers = {}, s.rawTrailers = [], s.on("end", function() {
                        $4TNnu.nextTick(function() {
                            s.emit("close");
                        });
                    }), "fetch" === r) {
                        if (s._fetchResponse = t, s.url = t.url, s.statusCode = t.status, s.statusMessage = t.statusText, t.headers.forEach(function(e, t) {
                            s.headers[t.toLowerCase()] = e, s.rawHeaders.push(t, e);
                        }), o.writableStream) {
                            var u = new WritableStream({
                                write: function(e) {
                                    return i(!1), new Promise(function(t, r) {
                                        s._destroyed ? r() : s.push(n.from(e)) ? t() : s._resumeFetch = t;
                                    });
                                },
                                close: function() {
                                    i(!0), s._destroyed || s.push(null);
                                },
                                abort: function(e) {
                                    i(!0), s._destroyed || s.emit("error", e);
                                }
                            });
                            try {
                                return void t.body.pipeTo(u).catch(function(e) {
                                    i(!0), s._destroyed || s.emit("error", e);
                                });
                            } catch (e) {}
                        }
                        var c = t.body.getReader();
                        !function e() {
                            c.read().then(function(t) {
                                s._destroyed || (i(t.done), t.done ? s.push(null) : (s.push(n.from(t.value)), e()));
                            }).catch(function(e) {
                                i(!0), s._destroyed || s.emit("error", e);
                            });
                        }();
                    } else if (s._xhr = e, s._pos = 0, s.url = e.responseURL, s.statusCode = e.status, s.statusMessage = e.statusText, e.getAllResponseHeaders().split(/\r?\n/).forEach(function(e) {
                        var t = e.match(/^([^:]+):\s*(.*)/);
                        if (t) {
                            var r = t[1].toLowerCase();
                            "set-cookie" === r ? (void 0 === s.headers[r] && (s.headers[r] = []), s.headers[r].push(t[2])) : void 0 !== s.headers[r] ? s.headers[r] += ", " + t[2] : s.headers[r] = t[2], s.rawHeaders.push(t[1], t[2]);
                        }
                    }), s._charset = "x-user-defined", !o.overrideMimeType) {
                        var l = s.rawHeaders["mime-type"];
                        if (l) {
                            var f = l.match(/;\s*charset=([^;])(;|$)/);
                            f && (s._charset = f[1].toLowerCase());
                        }
                        s._charset || (s._charset = "utf-8");
                    }
                };
                i(u, a.Readable), u.prototype._read = function() {
                    var e = this._resumeFetch;
                    e && (this._resumeFetch = null, e());
                }, u.prototype._onXHRProgress = function(e) {
                    var t = this, o = t._xhr, i = null;
                    switch(t._mode){
                        case "text":
                            if ((i = o.responseText).length > t._pos) {
                                var a = i.substr(t._pos);
                                if ("x-user-defined" === t._charset) {
                                    for(var u = n.alloc(a.length), c = 0; c < a.length; c++)u[c] = 255 & a.charCodeAt(c);
                                    t.push(u);
                                } else t.push(a, t._charset);
                                t._pos = i.length;
                            }
                            break;
                        case "arraybuffer":
                            if (o.readyState !== s.DONE || !o.response) break;
                            i = o.response, t.push(n.from(new Uint8Array(i)));
                            break;
                        case "moz-chunked-arraybuffer":
                            if (i = o.response, o.readyState !== s.LOADING || !i) break;
                            t.push(n.from(new Uint8Array(i)));
                            break;
                        case "ms-stream":
                            if (i = o.response, o.readyState !== s.LOADING) break;
                            var l = new r.g.MSStreamReader;
                            l.onprogress = function() {
                                l.result.byteLength > t._pos && (t.push(n.from(new Uint8Array(l.result.slice(t._pos)))), t._pos = l.result.byteLength);
                            }, l.onload = function() {
                                e(!0), t.push(null);
                            }, l.readAsArrayBuffer(i);
                    }
                    t._xhr.readyState === s.DONE && "ms-stream" !== t._mode && (e(!0), t.push(null));
                };
            },
            3157 (e) {
                "use strict";
                var t = {};
                function r(e, r, n) {
                    n || (n = Error);
                    var o = function(e) {
                        var t, n;
                        function o(t, n, o) {
                            return e.call(this, function(e, t, n) {
                                return "string" == typeof r ? r : r(e, t, n);
                            }(t, n, o)) || this;
                        }
                        return n = e, (t = o).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, o;
                    }(n);
                    o.prototype.name = n.name, o.prototype.code = e, t[e] = o;
                }
                function n(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                r("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), r("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var o, i, a, s;
                    if ("string" == typeof t && (i = "not ", t.substr(!a || a < 0 ? 0 : +a, i.length) === i) ? (o = "must not be", t = t.replace(/^not /, "")) : o = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) s = "The ".concat(e, " ").concat(o, " ").concat(n(t, "type"));
                    else {
                        var u = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        s = 'The "'.concat(e, '" ').concat(u, " ").concat(o, " ").concat(n(t, "type"));
                    }
                    return s += ". Received type ".concat(typeof r);
                }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e.exports.F = t;
            },
            3527 (e, t, r) {
                "use strict";
                var n = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                e.exports = c;
                var o = r(2341), i = r(9573);
                r(6698)(c, o);
                for(var a = n(i.prototype), s = 0; s < a.length; s++){
                    var u = a[s];
                    c.prototype[u] || (c.prototype[u] = i.prototype[u]);
                }
                function c(e) {
                    if (!(this instanceof c)) return new c(e);
                    o.call(this, e), i.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", l)));
                }
                function l() {
                    this._writableState.ended || $4TNnu.nextTick(f, this);
                }
                function f(e) {
                    e.end();
                }
                Object.defineProperty(c.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(c.prototype, "writableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                }), Object.defineProperty(c.prototype, "writableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.length;
                    }
                }), Object.defineProperty(c.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                });
            },
            2571 (e, t, r) {
                "use strict";
                e.exports = o;
                var n = r(5689);
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e);
                }
                r(6698)(o, n), o.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            2341 (e, t, r) {
                "use strict";
                var n;
                e.exports = T, T.ReadableState = E;
                r(7007).EventEmitter;
                var o = function(e, t) {
                    return e.listeners(t).length;
                }, i = r(1914), a = r(8287).Buffer, s = (void 0 !== r.g ? r.g : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                var u, c = r(6833);
                u = c && c.debuglog ? c.debuglog("stream") : function() {};
                var l, f, p, d = r(272), h = r(6057), y = r(1922).getHighWaterMark, m = r(3157).F, g = m.ERR_INVALID_ARG_TYPE, v = m.ERR_STREAM_PUSH_AFTER_EOF, b = m.ERR_METHOD_NOT_IMPLEMENTED, w = m.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                r(6698)(T, i);
                var S = h.errorOrDestroy, A = [
                    "error",
                    "close",
                    "destroy",
                    "pause",
                    "resume"
                ];
                function E(e, t, o) {
                    n = n || r(3527), e = e || {}, "boolean" != typeof o && (o = t instanceof n), this.objectMode = !!e.objectMode, o && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = y(this, e, "readableHighWaterMark", o), this.buffer = new d, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (l || (l = r(3141).I), this.decoder = new l(e.encoding), this.encoding = e.encoding);
                }
                function T(e) {
                    if (n = n || r(3527), !(this instanceof T)) return new T(e);
                    var t = this instanceof n;
                    this._readableState = new E(e, this, t), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), i.call(this);
                }
                function O(e, t, r, n, o) {
                    u("readableAddChunk", t);
                    var i, c = e._readableState;
                    if (null === t) c.reading = !1, function(e, t) {
                        if (u("onEofChunk"), t.ended) return;
                        if (t.decoder) {
                            var r = t.decoder.end();
                            r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                        }
                        t.ended = !0, t.sync ? P(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                    }(e, c);
                    else if (o || (i = function(e, t) {
                        var r;
                        n = t, a.isBuffer(n) || n instanceof s || "string" == typeof t || void 0 === t || e.objectMode || (r = new g("chunk", [
                            "string",
                            "Buffer",
                            "Uint8Array"
                        ], t));
                        var n;
                        return r;
                    }(c, t)), i) S(e, i);
                    else if (c.objectMode || t && t.length > 0) {
                        if ("string" == typeof t || c.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                            return a.from(e);
                        }(t)), n) c.endEmitted ? S(e, new w) : k(e, c, t, !0);
                        else if (c.ended) S(e, new v);
                        else {
                            if (c.destroyed) return !1;
                            c.reading = !1, c.decoder && !r ? (t = c.decoder.write(t), c.objectMode || 0 !== t.length ? k(e, c, t, !1) : I(e, c)) : k(e, c, t, !1);
                        }
                    } else n || (c.reading = !1, I(e, c));
                    return !c.ended && (c.length < c.highWaterMark || 0 === c.length);
                }
                function k(e, t, r, n) {
                    t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && P(e)), I(e, t);
                }
                Object.defineProperty(T.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._readableState && this._readableState.destroyed;
                    },
                    set: function(e) {
                        this._readableState && (this._readableState.destroyed = e);
                    }
                }), T.prototype.destroy = h.destroy, T.prototype._undestroy = h.undestroy, T.prototype._destroy = function(e, t) {
                    t(e);
                }, T.prototype.push = function(e, t) {
                    var r, n = this._readableState;
                    return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), O(this, e, t, !1, r);
                }, T.prototype.unshift = function(e) {
                    return O(this, e, null, !0, !1);
                }, T.prototype.isPaused = function() {
                    return !1 === this._readableState.flowing;
                }, T.prototype.setEncoding = function(e) {
                    l || (l = r(3141).I);
                    var t = new l(e);
                    this._readableState.decoder = t, this._readableState.encoding = this._readableState.decoder.encoding;
                    for(var n = this._readableState.buffer.head, o = ""; null !== n;)o += t.write(n.data), n = n.next;
                    return this._readableState.buffer.clear(), "" !== o && this._readableState.buffer.push(o), this._readableState.length = o.length, this;
                };
                var _ = 1073741824;
                function x(e, t) {
                    return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                        return e >= _ ? e = _ : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                    }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                }
                function P(e) {
                    var t = e._readableState;
                    u("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (u("emitReadable", t.flowing), t.emittedReadable = !0, $4TNnu.nextTick(R, e));
                }
                function R(e) {
                    var t = e._readableState;
                    u("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, N(e);
                }
                function I(e, t) {
                    t.readingMore || (t.readingMore = !0, $4TNnu.nextTick(B, e, t));
                }
                function B(e, t) {
                    for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                        var r = t.length;
                        if (u("maybeReadMore read 0"), e.read(0), r === t.length) break;
                    }
                    t.readingMore = !1;
                }
                function C(e) {
                    var t = e._readableState;
                    t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                }
                function j(e) {
                    u("readable nexttick read 0"), e.read(0);
                }
                function U(e, t) {
                    u("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), N(e), t.flowing && !t.reading && e.read(0);
                }
                function N(e) {
                    var t = e._readableState;
                    for(u("flow", t.flowing); t.flowing && null !== e.read(););
                }
                function L(e, t) {
                    var r;
                    return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                }
                function F(e) {
                    var t = e._readableState;
                    u("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, $4TNnu.nextTick(D, t, e));
                }
                function D(e, t) {
                    if (u("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                        var r = t._writableState;
                        (!r || r.autoDestroy && r.finished) && t.destroy();
                    }
                }
                function M(e, t) {
                    for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                    return -1;
                }
                T.prototype.read = function(e) {
                    u("read", e), e = parseInt(e, 10);
                    var t = this._readableState, r = e;
                    if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return u("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : P(this), null;
                    if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && F(this), null;
                    var n, o = t.needReadable;
                    return u("need readable", o), (0 === t.length || t.length - e < t.highWaterMark) && u("length less than watermark", o = !0), t.ended || t.reading ? u("reading or ended", o = !1) : o && (u("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? L(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                }, T.prototype._read = function(e) {
                    S(this, new b("_read()"));
                }, T.prototype.pipe = function(e, t) {
                    var r = this, n = this._readableState;
                    switch(n.pipesCount){
                        case 0:
                            n.pipes = e;
                            break;
                        case 1:
                            n.pipes = [
                                n.pipes,
                                e
                            ];
                            break;
                        default:
                            n.pipes.push(e);
                    }
                    n.pipesCount += 1, u("pipe count=%d opts=%j", n.pipesCount, t);
                    var i = (!t || !1 !== t.end) && e !== $4TNnu.stdout && e !== $4TNnu.stderr ? s : y;
                    function a(t, o) {
                        u("onunpipe"), t === r && o && !1 === o.hasUnpiped && (o.hasUnpiped = !0, u("cleanup"), e.removeListener("close", d), e.removeListener("finish", h), e.removeListener("drain", c), e.removeListener("error", p), e.removeListener("unpipe", a), r.removeListener("end", s), r.removeListener("end", y), r.removeListener("data", f), l = !0, !n.awaitDrain || e._writableState && !e._writableState.needDrain || c());
                    }
                    function s() {
                        u("onend"), e.end();
                    }
                    n.endEmitted ? $4TNnu.nextTick(i) : r.once("end", i), e.on("unpipe", a);
                    var c = function(e) {
                        return function() {
                            var t = e._readableState;
                            u("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && o(e, "data") && (t.flowing = !0, N(e));
                        };
                    }(r);
                    e.on("drain", c);
                    var l = !1;
                    function f(t) {
                        u("ondata");
                        var o = e.write(t);
                        u("dest.write", o), !1 === o && ((1 === n.pipesCount && n.pipes === e || n.pipesCount > 1 && -1 !== M(n.pipes, e)) && !l && (u("false write response, pause", n.awaitDrain), n.awaitDrain++), r.pause());
                    }
                    function p(t) {
                        u("onerror", t), y(), e.removeListener("error", p), 0 === o(e, "error") && S(e, t);
                    }
                    function d() {
                        e.removeListener("finish", h), y();
                    }
                    function h() {
                        u("onfinish"), e.removeListener("close", d), y();
                    }
                    function y() {
                        u("unpipe"), r.unpipe(e);
                    }
                    return r.on("data", f), function(e, t, r) {
                        if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                        e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                            r,
                            e._events[t]
                        ] : e.on(t, r);
                    }(e, "error", p), e.once("close", d), e.once("finish", h), e.emit("pipe", r), n.flowing || (u("pipe resume"), r.resume()), e;
                }, T.prototype.unpipe = function(e) {
                    var t = this._readableState, r = {
                        hasUnpiped: !1
                    };
                    if (0 === t.pipesCount) return this;
                    if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                    if (!e) {
                        var n = t.pipes, o = t.pipesCount;
                        t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                        for(var i = 0; i < o; i++)n[i].emit("unpipe", this, {
                            hasUnpiped: !1
                        });
                        return this;
                    }
                    var a = M(t.pipes, e);
                    return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                }, T.prototype.on = function(e, t) {
                    var r = i.prototype.on.call(this, e, t), n = this._readableState;
                    return "data" === e ? (n.readableListening = this.listenerCount("readable") > 0, !1 !== n.flowing && this.resume()) : "readable" === e && (n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, u("on readable", n.length, n.reading), n.length ? P(this) : n.reading || $4TNnu.nextTick(j, this))), r;
                }, T.prototype.addListener = T.prototype.on, T.prototype.removeListener = function(e, t) {
                    var r = i.prototype.removeListener.call(this, e, t);
                    return "readable" === e && $4TNnu.nextTick(C, this), r;
                }, T.prototype.removeAllListeners = function(e) {
                    var t = i.prototype.removeAllListeners.apply(this, arguments);
                    return "readable" !== e && void 0 !== e || $4TNnu.nextTick(C, this), t;
                }, T.prototype.resume = function() {
                    var e = this._readableState;
                    return e.flowing || (u("resume"), e.flowing = !e.readableListening, function(e, t) {
                        t.resumeScheduled || (t.resumeScheduled = !0, $4TNnu.nextTick(U, e, t));
                    }(this, e)), e.paused = !1, this;
                }, T.prototype.pause = function() {
                    return u("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (u("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                }, T.prototype.wrap = function(e) {
                    var t = this, r = this._readableState, n = !1;
                    for(var o in e.on("end", function() {
                        if (u("wrapped end"), r.decoder && !r.ended) {
                            var e = r.decoder.end();
                            e && e.length && t.push(e);
                        }
                        t.push(null);
                    }), e.on("data", function(o) {
                        (u("wrapped data"), r.decoder && (o = r.decoder.write(o)), r.objectMode && null == o) || (r.objectMode || o && o.length) && (t.push(o) || (n = !0, e.pause()));
                    }), e)void 0 === this[o] && "function" == typeof e[o] && (this[o] = function(t) {
                        return function() {
                            return e[t].apply(e, arguments);
                        };
                    }(o));
                    for(var i = 0; i < A.length; i++)e.on(A[i], this.emit.bind(this, A[i]));
                    return this._read = function(t) {
                        u("wrapped _read", t), n && (n = !1, e.resume());
                    }, this;
                }, "function" == typeof Symbol && (T.prototype[Symbol.asyncIterator] = function() {
                    return void 0 === f && (f = r(7356)), f(this);
                }), Object.defineProperty(T.prototype, "readableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.highWaterMark;
                    }
                }), Object.defineProperty(T.prototype, "readableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState && this._readableState.buffer;
                    }
                }), Object.defineProperty(T.prototype, "readableFlowing", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.flowing;
                    },
                    set: function(e) {
                        this._readableState && (this._readableState.flowing = e);
                    }
                }), T._fromList = L, Object.defineProperty(T.prototype, "readableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.length;
                    }
                }), "function" == typeof Symbol && (T.from = function(e, t) {
                    return void 0 === p && (p = r(6314)), p(T, e, t);
                });
            },
            5689 (e, t, r) {
                "use strict";
                e.exports = l;
                var n = r(3157).F, o = n.ERR_METHOD_NOT_IMPLEMENTED, i = n.ERR_MULTIPLE_CALLBACK, a = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, s = n.ERR_TRANSFORM_WITH_LENGTH_0, u = r(3527);
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new i);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var o = this._readableState;
                    o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
                }
                function l(e) {
                    if (!(this instanceof l)) return new l(e);
                    u.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", f);
                }
                function f() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? p(this, null, null) : this._flush(function(t, r) {
                        p(e, t, r);
                    });
                }
                function p(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new s;
                    if (e._transformState.transforming) throw new a;
                    return e.push(null);
                }
                r(6698)(l, u), l.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, u.prototype.push.call(this, e, t);
                }, l.prototype._transform = function(e, t, r) {
                    r(new o("_transform()"));
                }, l.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var o = this._readableState;
                        (n.needTransform || o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
                    }
                }, l.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, l.prototype._destroy = function(e, t) {
                    u.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            9573 (e, t, r) {
                "use strict";
                function n(e) {
                    var t = this;
                    this.next = null, this.entry = null, this.finish = function() {
                        !function(e, t, r) {
                            var n = e.entry;
                            e.entry = null;
                            for(; n;){
                                var o = n.callback;
                                t.pendingcb--, o(r), n = n.next;
                            }
                            t.corkedRequestsFree.next = e;
                        }(t, e);
                    };
                }
                var o;
                e.exports = T, T.WritableState = E;
                var i = {
                    deprecate: r(4643)
                }, a = r(1914), s = r(8287).Buffer, u = (void 0 !== r.g ? r.g : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                var c, l = r(6057), f = r(1922).getHighWaterMark, p = r(3157).F, d = p.ERR_INVALID_ARG_TYPE, h = p.ERR_METHOD_NOT_IMPLEMENTED, y = p.ERR_MULTIPLE_CALLBACK, m = p.ERR_STREAM_CANNOT_PIPE, g = p.ERR_STREAM_DESTROYED, v = p.ERR_STREAM_NULL_VALUES, b = p.ERR_STREAM_WRITE_AFTER_END, w = p.ERR_UNKNOWN_ENCODING, S = l.errorOrDestroy;
                function A() {}
                function E(e, t, i) {
                    o = o || r(3527), e = e || {}, "boolean" != typeof i && (i = t instanceof o), this.objectMode = !!e.objectMode, i && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = f(this, e, "writableHighWaterMark", i), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                    var a = !1 === e.decodeStrings;
                    this.decodeStrings = !a, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                        !function(e, t) {
                            var r = e._writableState, n = r.sync, o = r.writecb;
                            if ("function" != typeof o) throw new y;
                            if (function(e) {
                                e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                            }(r), t) !function(e, t, r, n, o) {
                                --t.pendingcb, r ? ($4TNnu.nextTick(o, n), $4TNnu.nextTick(R, e, t), e._writableState.errorEmitted = !0, S(e, n)) : (o(n), e._writableState.errorEmitted = !0, S(e, n), R(e, t));
                            }(e, r, n, t, o);
                            else {
                                var i = x(r) || e.destroyed;
                                i || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? $4TNnu.nextTick(k, e, r, i, o) : k(e, r, i, o);
                            }
                        }(t, e);
                    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new n(this);
                }
                function T(e) {
                    var t = this instanceof (o = o || r(3527));
                    if (!t && !c.call(T, this)) return new T(e);
                    this._writableState = new E(e, this, t), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), a.call(this);
                }
                function O(e, t, r, n, o, i, a) {
                    t.writelen = n, t.writecb = a, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new g("write")) : r ? e._writev(o, t.onwrite) : e._write(o, i, t.onwrite), t.sync = !1;
                }
                function k(e, t, r, n) {
                    r || function(e, t) {
                        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                    }(e, t), t.pendingcb--, n(), R(e, t);
                }
                function _(e, t) {
                    t.bufferProcessing = !0;
                    var r = t.bufferedRequest;
                    if (e._writev && r && r.next) {
                        var o = t.bufferedRequestCount, i = new Array(o), a = t.corkedRequestsFree;
                        a.entry = r;
                        for(var s = 0, u = !0; r;)i[s] = r, r.isBuf || (u = !1), r = r.next, s += 1;
                        i.allBuffers = u, O(e, t, !0, t.length, i, "", a.finish), t.pendingcb++, t.lastBufferedRequest = null, a.next ? (t.corkedRequestsFree = a.next, a.next = null) : t.corkedRequestsFree = new n(t), t.bufferedRequestCount = 0;
                    } else {
                        for(; r;){
                            var c = r.chunk, l = r.encoding, f = r.callback;
                            if (O(e, t, !1, t.objectMode ? 1 : c.length, c, l, f), r = r.next, t.bufferedRequestCount--, t.writing) break;
                        }
                        null === r && (t.lastBufferedRequest = null);
                    }
                    t.bufferedRequest = r, t.bufferProcessing = !1;
                }
                function x(e) {
                    return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                }
                function P(e, t) {
                    e._final(function(r) {
                        t.pendingcb--, r && S(e, r), t.prefinished = !0, e.emit("prefinish"), R(e, t);
                    });
                }
                function R(e, t) {
                    var r = x(t);
                    if (r && (function(e, t) {
                        t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, $4TNnu.nextTick(P, e, t)));
                    }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                        var n = e._readableState;
                        (!n || n.autoDestroy && n.endEmitted) && e.destroy();
                    }
                    return r;
                }
                r(6698)(T, a), E.prototype.getBuffer = function() {
                    for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                    return t;
                }, function() {
                    try {
                        Object.defineProperty(E.prototype, "buffer", {
                            get: i.deprecate(function() {
                                return this.getBuffer();
                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                        });
                    } catch (e) {}
                }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (c = Function.prototype[Symbol.hasInstance], Object.defineProperty(T, Symbol.hasInstance, {
                    value: function(e) {
                        return !!c.call(this, e) || this === T && e && e._writableState instanceof E;
                    }
                })) : c = function(e) {
                    return e instanceof this;
                }, T.prototype.pipe = function() {
                    S(this, new m);
                }, T.prototype.write = function(e, t, r) {
                    var n, o = this._writableState, i = !1, a = !o.objectMode && (n = e, s.isBuffer(n) || n instanceof u);
                    return a && !s.isBuffer(e) && (e = function(e) {
                        return s.from(e);
                    }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = o.defaultEncoding), "function" != typeof r && (r = A), o.ending ? function(e, t) {
                        var r = new b;
                        S(e, r), $4TNnu.nextTick(t, r);
                    }(this, r) : (a || function(e, t, r, n) {
                        var o;
                        return null === r ? o = new v : "string" == typeof r || t.objectMode || (o = new d("chunk", [
                            "string",
                            "Buffer"
                        ], r)), !o || (S(e, o), $4TNnu.nextTick(n, o), !1);
                    }(this, o, e, r)) && (o.pendingcb++, i = function(e, t, r, n, o, i) {
                        if (!r) {
                            var a = function(e, t, r) {
                                e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = s.from(t, r));
                                return t;
                            }(t, n, o);
                            n !== a && (r = !0, o = "buffer", n = a);
                        }
                        var u = t.objectMode ? 1 : n.length;
                        t.length += u;
                        var c = t.length < t.highWaterMark;
                        c || (t.needDrain = !0);
                        if (t.writing || t.corked) {
                            var l = t.lastBufferedRequest;
                            t.lastBufferedRequest = {
                                chunk: n,
                                encoding: o,
                                isBuf: r,
                                callback: i,
                                next: null
                            }, l ? l.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                        } else O(e, t, !1, u, n, o, i);
                        return c;
                    }(this, o, a, e, t, r)), i;
                }, T.prototype.cork = function() {
                    this._writableState.corked++;
                }, T.prototype.uncork = function() {
                    var e = this._writableState;
                    e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                }, T.prototype.setDefaultEncoding = function(e) {
                    if ("string" == typeof e && (e = e.toLowerCase()), !([
                        "hex",
                        "utf8",
                        "utf-8",
                        "ascii",
                        "binary",
                        "base64",
                        "ucs2",
                        "ucs-2",
                        "utf16le",
                        "utf-16le",
                        "raw"
                    ].indexOf((e + "").toLowerCase()) > -1)) throw new w(e);
                    return this._writableState.defaultEncoding = e, this;
                }, Object.defineProperty(T.prototype, "writableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                }), Object.defineProperty(T.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), T.prototype._write = function(e, t, r) {
                    r(new h("_write()"));
                }, T.prototype._writev = null, T.prototype.end = function(e, t, r) {
                    var n = this._writableState;
                    return "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                        t.ending = !0, R(e, t), r && (t.finished ? $4TNnu.nextTick(r) : e.once("finish", r));
                        t.ended = !0, e.writable = !1;
                    }(this, n, r), this;
                }, Object.defineProperty(T.prototype, "writableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.length;
                    }
                }), Object.defineProperty(T.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._writableState && this._writableState.destroyed;
                    },
                    set: function(e) {
                        this._writableState && (this._writableState.destroyed = e);
                    }
                }), T.prototype.destroy = l.destroy, T.prototype._undestroy = l.undestroy, T.prototype._destroy = function(e, t) {
                    t(e);
                };
            },
            7356 (e, t, r) {
                "use strict";
                var n;
                function o(e, t, r) {
                    return (t = function(e) {
                        var t = function(e, t) {
                            if ("object" != typeof e || null === e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(e, t || "default");
                                if ("object" != typeof n) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(e, "string");
                        return "symbol" == typeof t ? t : String(t);
                    }(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                var i = r(9959), a = Symbol("lastResolve"), s = Symbol("lastReject"), u = Symbol("error"), c = Symbol("ended"), l = Symbol("lastPromise"), f = Symbol("handlePromise"), p = Symbol("stream");
                function d(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                }
                function h(e) {
                    var t = e[a];
                    if (null !== t) {
                        var r = e[p].read();
                        null !== r && (e[l] = null, e[a] = null, e[s] = null, t(d(r, !1)));
                    }
                }
                function y(e) {
                    $4TNnu.nextTick(h, e);
                }
                var m = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((o(n = {
                    get stream () {
                        return this[p];
                    },
                    next: function() {
                        var e = this, t = this[u];
                        if (null !== t) return Promise.reject(t);
                        if (this[c]) return Promise.resolve(d(void 0, !0));
                        if (this[p].destroyed) return new Promise(function(t, r) {
                            $4TNnu.nextTick(function() {
                                e[u] ? r(e[u]) : t(d(void 0, !0));
                            });
                        });
                        var r, n = this[l];
                        if (n) r = new Promise(function(e, t) {
                            return function(r, n) {
                                e.then(function() {
                                    t[c] ? r(d(void 0, !0)) : t[f](r, n);
                                }, n);
                            };
                        }(n, this));
                        else {
                            var o = this[p].read();
                            if (null !== o) return Promise.resolve(d(o, !1));
                            r = new Promise(this[f]);
                        }
                        return this[l] = r, r;
                    }
                }, Symbol.asyncIterator, function() {
                    return this;
                }), o(n, "return", function() {
                    var e = this;
                    return new Promise(function(t, r) {
                        e[p].destroy(null, function(e) {
                            e ? r(e) : t(d(void 0, !0));
                        });
                    });
                }), n), m);
                e.exports = function(e) {
                    var t, r = Object.create(g, (o(t = {}, p, {
                        value: e,
                        writable: !0
                    }), o(t, a, {
                        value: null,
                        writable: !0
                    }), o(t, s, {
                        value: null,
                        writable: !0
                    }), o(t, u, {
                        value: null,
                        writable: !0
                    }), o(t, c, {
                        value: e._readableState.endEmitted,
                        writable: !0
                    }), o(t, f, {
                        value: function(e, t) {
                            var n = r[p].read();
                            n ? (r[l] = null, r[a] = null, r[s] = null, e(d(n, !1))) : (r[a] = e, r[s] = t);
                        },
                        writable: !0
                    }), t));
                    return r[l] = null, i(e, function(e) {
                        if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                            var t = r[s];
                            return null !== t && (r[l] = null, r[a] = null, r[s] = null, t(e)), void (r[u] = e);
                        }
                        var n = r[a];
                        null !== n && (r[l] = null, r[a] = null, r[s] = null, n(d(void 0, !0))), r[c] = !0;
                    }), e.on("readable", y.bind(null, r)), r;
                };
            },
            272 (e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function o(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            i(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function i(e, t, r) {
                    return (t = s(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function a(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, s(n.key), n);
                    }
                }
                function s(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var u = r(8287).Buffer, c = r(9169).inspect, l = c && c.custom || "inspect";
                function f(e, t, r) {
                    u.prototype.copy.call(e, t, r);
                }
                e.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return u.alloc(0);
                                for(var t = u.allocUnsafe(e >>> 0), r = this.head, n = 0; r;)f(r.data, t, n), n += r.data.length, r = r.next;
                                return t;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var o = t.data, i = e > o.length ? o.length : e;
                                    if (i === o.length ? n += o : n += o.slice(0, e), 0 === (e -= i)) {
                                        i === o.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = o.slice(i));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = u.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var o = r.data, i = e > o.length ? o.length : e;
                                    if (o.copy(t, t.length - e, 0, i), 0 === (e -= i)) {
                                        i === o.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = o.slice(i));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: l,
                            value: function(e, t) {
                                return c(this, o(o({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], a(t.prototype, r), n && a(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            6057 (e) {
                "use strict";
                function t(e, t) {
                    n(e, t), r(e);
                }
                function r(e) {
                    e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                }
                function n(e, t) {
                    e.emit("error", t);
                }
                e.exports = {
                    destroy: function(e, o) {
                        var i = this, a = this._readableState && this._readableState.destroyed, s = this._writableState && this._writableState.destroyed;
                        return a || s ? (o ? o(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, $4TNnu.nextTick(n, this, e)) : $4TNnu.nextTick(n, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !o && e ? i._writableState ? i._writableState.errorEmitted ? $4TNnu.nextTick(r, i) : (i._writableState.errorEmitted = !0, $4TNnu.nextTick(t, i, e)) : $4TNnu.nextTick(t, i, e) : o ? ($4TNnu.nextTick(r, i), o(e)) : $4TNnu.nextTick(r, i);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    },
                    errorOrDestroy: function(e, t) {
                        var r = e._readableState, n = e._writableState;
                        r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                    }
                };
            },
            9959 (e, t, r) {
                "use strict";
                var n = r(3157).F.ERR_STREAM_PREMATURE_CLOSE;
                function o() {}
                e.exports = function e(t, r, i) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), i = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), o = 0; o < r; o++)n[o] = arguments[o];
                                e.apply(this, n);
                            }
                        };
                    }(i || o);
                    var a = r.readable || !1 !== r.readable && t.readable, s = r.writable || !1 !== r.writable && t.writable, u = function() {
                        t.writable || l();
                    }, c = t._writableState && t._writableState.finished, l = function() {
                        s = !1, c = !0, a || i.call(t);
                    }, f = t._readableState && t._readableState.endEmitted, p = function() {
                        a = !1, f = !0, s || i.call(t);
                    }, d = function(e) {
                        i.call(t, e);
                    }, h = function() {
                        var e;
                        return a && !f ? (t._readableState && t._readableState.ended || (e = new n), i.call(t, e)) : s && !c ? (t._writableState && t._writableState.ended || (e = new n), i.call(t, e)) : void 0;
                    }, y = function() {
                        t.req.on("finish", l);
                    };
                    return !function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? s && !t._writableState && (t.on("end", u), t.on("close", u)) : (t.on("complete", l), t.on("abort", h), t.req ? y() : t.on("request", y)), t.on("end", p), t.on("finish", l), !1 !== r.error && t.on("error", d), t.on("close", h), function() {
                        t.removeListener("complete", l), t.removeListener("abort", h), t.removeListener("request", y), t.req && t.req.removeListener("finish", l), t.removeListener("end", u), t.removeListener("close", u), t.removeListener("finish", l), t.removeListener("end", p), t.removeListener("error", d), t.removeListener("close", h);
                    };
                };
            },
            6314 (e) {
                e.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            7413 (e, t, r) {
                "use strict";
                var n;
                var o = r(3157).F, i = o.ERR_MISSING_ARGS, a = o.ERR_STREAM_DESTROYED;
                function s(e) {
                    if (e) throw e;
                }
                function u(e) {
                    e();
                }
                function c(e, t) {
                    return e.pipe(t);
                }
                e.exports = function() {
                    for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
                    var l, f = function(e) {
                        return e.length ? "function" != typeof e[e.length - 1] ? s : e.pop() : s;
                    }(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new i("streams");
                    var p = t.map(function(e, o) {
                        var i = o < t.length - 1;
                        return function(e, t, o, i) {
                            i = function(e) {
                                var t = !1;
                                return function() {
                                    t || (t = !0, e.apply(void 0, arguments));
                                };
                            }(i);
                            var s = !1;
                            e.on("close", function() {
                                s = !0;
                            }), void 0 === n && (n = r(9959)), n(e, {
                                readable: t,
                                writable: o
                            }, function(e) {
                                if (e) return i(e);
                                s = !0, i();
                            });
                            var u = !1;
                            return function(t) {
                                if (!s && !u) return u = !0, function(e) {
                                    return e.setHeader && "function" == typeof e.abort;
                                }(e) ? e.abort() : "function" == typeof e.destroy ? e.destroy() : void i(t || new a("pipe"));
                            };
                        }(e, i, o > 0, function(e) {
                            l || (l = e), e && p.forEach(u), i || (p.forEach(u), f(l));
                        });
                    });
                    return t.reduce(c);
                };
            },
            1922 (e, t, r) {
                "use strict";
                var n = r(3157).F.ERR_INVALID_OPT_VALUE;
                e.exports = {
                    getHighWaterMark: function(e, t, r, o) {
                        var i = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, o, r);
                        if (null != i) {
                            if (!isFinite(i) || Math.floor(i) !== i || i < 0) throw new n(o ? r : "highWaterMark", i);
                            return Math.floor(i);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            1914 (e, t, r) {
                e.exports = r(7007).EventEmitter;
            },
            3242 (e, t, r) {
                (t = e.exports = r(2341)).Stream = t, t.Readable = t, t.Writable = r(9573), t.Duplex = r(3527), t.Transform = r(5689), t.PassThrough = r(2571), t.finished = r(9959), t.pipeline = r(7413);
            },
            3141 (e, t, r) {
                "use strict";
                var n = r(2861).Buffer, o = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function i(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === o || !o(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = u, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = s, t = 4;
                            break;
                        case "base64":
                            this.text = l, this.end = f, t = 3;
                            break;
                        default:
                            return this.write = p, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function a(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function s(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function u(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function l(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function f(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function p(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                t.I = i, i.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, i.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, i.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var o = a(t[n]);
                        if (o >= 0) return o > 0 && (e.lastNeed = o - 1), o;
                        if (--n < r || -2 === o) return 0;
                        if (o = a(t[n]), o >= 0) return o > 0 && (e.lastNeed = o - 2), o;
                        if (--n < r || -2 === o) return 0;
                        if (o = a(t[n]), o >= 0) return o > 0 && (2 === o ? o = 0 : e.lastNeed = o - 3), o;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, i.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            1293 (e, t, r) {
                var n = r(5546), o = r(2708);
                e.exports = {
                    parse: function(e) {
                        var t = n.parse(e.toString());
                        return o.compile(t);
                    }
                };
            },
            2708 (e) {
                "use strict";
                e.exports = {
                    compile: function(e) {
                        var t = [], r = [], n = "", o = Object.create(null), i = o;
                        return function(e) {
                            for(var t, r = 0; r < e.length; r++)switch((t = e[r]).type){
                                case "Assign":
                                    s(t);
                                    break;
                                case "ObjectPath":
                                    f(t);
                                    break;
                                case "ArrayPath":
                                    p(t);
                            }
                            return o;
                        }(e);
                        function a(e, t, r) {
                            var n = new Error(e);
                            throw n.line = t, n.column = r, n;
                        }
                        function s(e) {
                            var o, s = e.key, l = e.value, f = e.line, p = e.column;
                            o = n ? n + "." + s : s, void 0 !== i[s] && a("Cannot redefine existing key '" + o + "'.", f, p), i[s] = c(l), u(o) || (t.push(o), r.push(o));
                        }
                        function u(e) {
                            return -1 !== t.indexOf(e);
                        }
                        function c(e) {
                            return "Array" === e.type ? function(e) {
                                for(var t = null, r = 0; r < e.length; r++){
                                    var n = e[r];
                                    null === t ? t = n.type : n.type !== t && a("Cannot add value of type " + n.type + " to array of type " + t + ".", n.line, n.column);
                                }
                                return e.map(c);
                            }(e.value) : "InlineTable" === e.type ? l(e.value) : e.value;
                        }
                        function l(e) {
                            for(var t = Object.create(null), r = 0; r < e.length; r++){
                                var n = e[r];
                                "InlineTable" === n.value.type ? t[n.key] = l(n.value.value) : "InlineTableValue" === n.type && (t[n.key] = c(n.value));
                            }
                            return t;
                        }
                        function f(e) {
                            var r = e.value, s = r.map(h).join("."), c = e.line, l = e.column;
                            u(s) && a("Cannot redefine existing key '" + r + "'.", c, l), t.push(s), i = d(o, r, Object.create(null), c, l), n = r;
                        }
                        function p(e) {
                            var r = e.value, s = r.map(h).join("."), c = e.line, l = e.column;
                            if (u(s) || t.push(s), (t = t.filter(function(e) {
                                return 0 !== e.indexOf(s);
                            })).push(s), i = d(o, r, [], c, l), n = s, i instanceof Array) {
                                var f = Object.create(null);
                                i.push(f), i = f;
                            } else a("Cannot redefine existing key '" + r + "'.", c, l);
                        }
                        function d(e, t, n, o, i) {
                            for(var s = [], u = "", c = (t.join("."), e), l = 0; l < t.length; l++){
                                var f = t[l];
                                s.push(f), u = s.join("."), void 0 === c[f] ? l === t.length - 1 ? c[f] = n : c[f] = Object.create(null) : l !== t.length - 1 && r.indexOf(u) > -1 && a("Cannot redefine existing key '" + u + "'.", o, i), (c = c[f]) instanceof Array && c.length && l < t.length - 1 && (c = c[c.length - 1]);
                            }
                            return c;
                        }
                        function h(e) {
                            return e.indexOf(".") > -1 ? '"' + e + '"' : e;
                        }
                    }
                };
            },
            5546 (e) {
                e.exports = function() {
                    function e(e, t, r, n, o, i) {
                        this.message = e, this.expected = t, this.found = r, this.offset = n, this.line = o, this.column = i, this.name = "SyntaxError";
                    }
                    return function(e, t) {
                        function r() {
                            this.constructor = e;
                        }
                        r.prototype = t.prototype, e.prototype = new r;
                    }(e, Error), {
                        SyntaxError: e,
                        parse: function(t) {
                            var r, n = arguments.length > 1 ? arguments[1] : {}, o = {}, i = {
                                start: jt
                            }, a = jt, s = function() {
                                return pr;
                            }, u = o, c = "#", l = {
                                type: "literal",
                                value: "#",
                                description: '"#"'
                            }, f = void 0, p = {
                                type: "any",
                                description: "any character"
                            }, d = "[", h = {
                                type: "literal",
                                value: "[",
                                description: '"["'
                            }, y = "]", m = {
                                type: "literal",
                                value: "]",
                                description: '"]"'
                            }, g = function(e) {
                                dr(hr("ObjectPath", e, Pt, Rt));
                            }, v = function(e) {
                                dr(hr("ArrayPath", e, Pt, Rt));
                            }, b = function(e, t) {
                                return e.concat(t);
                            }, w = function(e) {
                                return [
                                    e
                                ];
                            }, S = function(e) {
                                return e;
                            }, A = ".", E = {
                                type: "literal",
                                value: ".",
                                description: '"."'
                            }, T = "=", O = {
                                type: "literal",
                                value: "=",
                                description: '"="'
                            }, k = function(e, t) {
                                dr(hr("Assign", t, Pt, Rt, e));
                            }, _ = function(e) {
                                return e.join("");
                            }, x = function(e) {
                                return e.value;
                            }, P = '"""', R = {
                                type: "literal",
                                value: '"""',
                                description: '"\\"\\"\\""'
                            }, I = null, B = function(e) {
                                return hr("String", e.join(""), Pt, Rt);
                            }, C = '"', j = {
                                type: "literal",
                                value: '"',
                                description: '"\\""'
                            }, U = "'''", N = {
                                type: "literal",
                                value: "'''",
                                description: "\"'''\""
                            }, L = "'", F = {
                                type: "literal",
                                value: "'",
                                description: '"\'"'
                            }, D = function(e) {
                                return e;
                            }, M = function(e) {
                                return e;
                            }, V = "\\", q = {
                                type: "literal",
                                value: "\\",
                                description: '"\\\\"'
                            }, G = function() {
                                return "";
                            }, H = "e", z = {
                                type: "literal",
                                value: "e",
                                description: '"e"'
                            }, W = "E", X = {
                                type: "literal",
                                value: "E",
                                description: '"E"'
                            }, K = function(e, t) {
                                return hr("Float", parseFloat(e + "e" + t), Pt, Rt);
                            }, Z = function(e) {
                                return hr("Float", parseFloat(e), Pt, Rt);
                            }, $ = "+", Y = {
                                type: "literal",
                                value: "+",
                                description: '"+"'
                            }, Q = function(e) {
                                return e.join("");
                            }, J = "-", ee = {
                                type: "literal",
                                value: "-",
                                description: '"-"'
                            }, te = function(e) {
                                return "-" + e.join("");
                            }, re = function(e) {
                                return hr("Integer", parseInt(e, 10), Pt, Rt);
                            }, ne = "true", oe = {
                                type: "literal",
                                value: "true",
                                description: '"true"'
                            }, ie = function() {
                                return hr("Boolean", !0, Pt, Rt);
                            }, ae = "false", se = {
                                type: "literal",
                                value: "false",
                                description: '"false"'
                            }, ue = function() {
                                return hr("Boolean", !1, Pt, Rt);
                            }, ce = function() {
                                return hr("Array", [], Pt, Rt);
                            }, le = function(e) {
                                return hr("Array", e ? [
                                    e
                                ] : [], Pt, Rt);
                            }, fe = function(e) {
                                return hr("Array", e, Pt, Rt);
                            }, pe = function(e, t) {
                                return hr("Array", e.concat(t), Pt, Rt);
                            }, de = function(e) {
                                return e;
                            }, he = ",", ye = {
                                type: "literal",
                                value: ",",
                                description: '","'
                            }, me = "{", ge = {
                                type: "literal",
                                value: "{",
                                description: '"{"'
                            }, ve = "}", be = {
                                type: "literal",
                                value: "}",
                                description: '"}"'
                            }, we = function(e) {
                                return hr("InlineTable", e, Pt, Rt);
                            }, Se = function(e, t) {
                                return hr("InlineTableValue", t, Pt, Rt, e);
                            }, Ae = function(e) {
                                return "." + e;
                            }, Ee = function(e) {
                                return e.join("");
                            }, Te = ":", Oe = {
                                type: "literal",
                                value: ":",
                                description: '":"'
                            }, ke = function(e) {
                                return e.join("");
                            }, _e = "T", xe = {
                                type: "literal",
                                value: "T",
                                description: '"T"'
                            }, Pe = "Z", Re = {
                                type: "literal",
                                value: "Z",
                                description: '"Z"'
                            }, Ie = function(e, t) {
                                return hr("Date", new Date(e + "T" + t + "Z"), Pt, Rt);
                            }, Be = function(e, t) {
                                return hr("Date", new Date(e + "T" + t), Pt, Rt);
                            }, Ce = /^[ \t]/, je = {
                                type: "class",
                                value: "[ \\t]",
                                description: "[ \\t]"
                            }, Ue = "\n", Ne = {
                                type: "literal",
                                value: "\n",
                                description: '"\\n"'
                            }, Le = "\r", Fe = {
                                type: "literal",
                                value: "\r",
                                description: '"\\r"'
                            }, De = /^[0-9a-f]/i, Me = {
                                type: "class",
                                value: "[0-9a-f]i",
                                description: "[0-9a-f]i"
                            }, Ve = /^[0-9]/, qe = {
                                type: "class",
                                value: "[0-9]",
                                description: "[0-9]"
                            }, Ge = "_", He = {
                                type: "literal",
                                value: "_",
                                description: '"_"'
                            }, ze = function() {
                                return "";
                            }, We = /^[A-Za-z0-9_\-]/, Xe = {
                                type: "class",
                                value: "[A-Za-z0-9_\\-]",
                                description: "[A-Za-z0-9_\\-]"
                            }, Ke = function(e) {
                                return e.join("");
                            }, Ze = '\\"', $e = {
                                type: "literal",
                                value: '\\"',
                                description: '"\\\\\\""'
                            }, Ye = function() {
                                return '"';
                            }, Qe = "\\\\", Je = {
                                type: "literal",
                                value: "\\\\",
                                description: '"\\\\\\\\"'
                            }, et = function() {
                                return "\\";
                            }, tt = "\\b", rt = {
                                type: "literal",
                                value: "\\b",
                                description: '"\\\\b"'
                            }, nt = function() {
                                return "\b";
                            }, ot = "\\t", it = {
                                type: "literal",
                                value: "\\t",
                                description: '"\\\\t"'
                            }, at = function() {
                                return "\t";
                            }, st = "\\n", ut = {
                                type: "literal",
                                value: "\\n",
                                description: '"\\\\n"'
                            }, ct = function() {
                                return "\n";
                            }, lt = "\\f", ft = {
                                type: "literal",
                                value: "\\f",
                                description: '"\\\\f"'
                            }, pt = function() {
                                return "\f";
                            }, dt = "\\r", ht = {
                                type: "literal",
                                value: "\\r",
                                description: '"\\\\r"'
                            }, yt = function() {
                                return "\r";
                            }, mt = "\\U", gt = {
                                type: "literal",
                                value: "\\U",
                                description: '"\\\\U"'
                            }, vt = function(e) {
                                return function(e, t, r) {
                                    var n = parseInt("0x" + e);
                                    if (!(!isFinite(n) || Math.floor(n) != n || n < 0 || n > 1114111 || n > 55295 && n < 57344)) return function() {
                                        var e, t, r = 16384, n = [], o = -1, i = arguments.length;
                                        if (!i) return "";
                                        var a = "";
                                        for(; ++o < i;){
                                            var s = Number(arguments[o]);
                                            s <= 65535 ? n.push(s) : (e = 55296 + ((s -= 65536) >> 10), t = s % 1024 + 56320, n.push(e, t)), (o + 1 == i || n.length > r) && (a += String.fromCharCode.apply(null, n), n.length = 0);
                                        }
                                        return a;
                                    }(n);
                                    !function(e, t, r) {
                                        var n = new Error(e);
                                        throw n.line = t, n.column = r, n;
                                    }("Invalid Unicode escape code: " + e, t, r);
                                }(e.join(""));
                            }, bt = "\\u", wt = {
                                type: "literal",
                                value: "\\u",
                                description: '"\\\\u"'
                            }, St = 0, At = 0, Et = 0, Tt = {
                                line: 1,
                                column: 1,
                                seenCR: !1
                            }, Ot = 0, kt = [], _t = 0, xt = {};
                            if ("startRule" in n) {
                                if (!(n.startRule in i)) throw new Error("Can't start parsing from rule \"" + n.startRule + '".');
                                a = i[n.startRule];
                            }
                            function Pt() {
                                return It(At).line;
                            }
                            function Rt() {
                                return It(At).column;
                            }
                            function It(e) {
                                return Et !== e && (Et > e && (Et = 0, Tt = {
                                    line: 1,
                                    column: 1,
                                    seenCR: !1
                                }), function(e, r, n) {
                                    var o, i;
                                    for(o = r; o < n; o++)"\n" === (i = t.charAt(o)) ? (e.seenCR || e.line++, e.column = 1, e.seenCR = !1) : "\r" === i || "\u2028" === i || "\u2029" === i ? (e.line++, e.column = 1, e.seenCR = !0) : (e.column++, e.seenCR = !1);
                                }(Tt, Et, e), Et = e), Tt;
                            }
                            function Bt(e) {
                                St < Ot || (St > Ot && (Ot = St, kt = []), kt.push(e));
                            }
                            function Ct(r, n, o) {
                                var i = It(o), a = o < t.length ? t.charAt(o) : null;
                                return null !== n && function(e) {
                                    var t = 1;
                                    for(e.sort(function(e, t) {
                                        return e.description < t.description ? -1 : e.description > t.description ? 1 : 0;
                                    }); t < e.length;)e[t - 1] === e[t] ? e.splice(t, 1) : t++;
                                }(n), new e(null !== r ? r : function(e, t) {
                                    var r, n = new Array(e.length);
                                    for(r = 0; r < e.length; r++)n[r] = e[r].description;
                                    return "Expected " + (e.length > 1 ? n.slice(0, -1).join(", ") + " or " + n[e.length - 1] : n[0]) + " but " + (t ? '"' + function(e) {
                                        function t(e) {
                                            return e.charCodeAt(0).toString(16).toUpperCase();
                                        }
                                        return e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(e) {
                                            return "\\x0" + t(e);
                                        }).replace(/[\x10-\x1F\x80-\xFF]/g, function(e) {
                                            return "\\x" + t(e);
                                        }).replace(/[\u0180-\u0FFF]/g, function(e) {
                                            return "\\u0" + t(e);
                                        }).replace(/[\u1080-\uFFFF]/g, function(e) {
                                            return "\\u" + t(e);
                                        });
                                    }(t) + '"' : "end of input") + " found.";
                                }(n, a), n, a, o, i.line, i.column);
                            }
                            function jt() {
                                var e, t, r, n = 49 * St + 0, i = xt[n];
                                if (i) return St = i.nextPos, i.result;
                                for(e = St, t = [], r = Ut(); r !== o;)t.push(r), r = Ut();
                                return t !== o && (At = e, t = s()), e = t, xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Ut() {
                                var e, r, n, i, a, s, c, l = 49 * St + 1, f = xt[l];
                                if (f) return St = f.nextPos, f.result;
                                for(e = St, r = [], n = nr(); n !== o;)r.push(n), n = nr();
                                if (r !== o) {
                                    if (n = function() {
                                        var e, r = 49 * St + 2, n = xt[r];
                                        if (n) return St = n.nextPos, n.result;
                                        e = Nt(), e === o && (e = function() {
                                            var e, r, n, i, a, s, c = 49 * St + 4, l = xt[c];
                                            if (l) return St = l.nextPos, l.result;
                                            e = St, 91 === t.charCodeAt(St) ? (r = d, St++) : (r = o, 0 === _t && Bt(h));
                                            if (r !== o) {
                                                for(n = [], i = nr(); i !== o;)n.push(i), i = nr();
                                                if (n !== o) {
                                                    if ((i = Lt()) !== o) {
                                                        for(a = [], s = nr(); s !== o;)a.push(s), s = nr();
                                                        a !== o ? (93 === t.charCodeAt(St) ? (s = y, St++) : (s = o, 0 === _t && Bt(m)), s !== o ? (At = e, e = r = g(i)) : (St = e, e = u)) : (St = e, e = u);
                                                    } else St = e, e = u;
                                                } else St = e, e = u;
                                            } else St = e, e = u;
                                            return xt[c] = {
                                                nextPos: St,
                                                result: e
                                            }, e;
                                        }(), e === o && (e = function() {
                                            var e, r, n, i, a, s, c, l, f = 49 * St + 5, p = xt[f];
                                            if (p) return St = p.nextPos, p.result;
                                            e = St, 91 === t.charCodeAt(St) ? (r = d, St++) : (r = o, 0 === _t && Bt(h));
                                            if (r !== o) {
                                                if (91 === t.charCodeAt(St) ? (n = d, St++) : (n = o, 0 === _t && Bt(h)), n !== o) {
                                                    for(i = [], a = nr(); a !== o;)i.push(a), a = nr();
                                                    if (i !== o) {
                                                        if ((a = Lt()) !== o) {
                                                            for(s = [], c = nr(); c !== o;)s.push(c), c = nr();
                                                            s !== o ? (93 === t.charCodeAt(St) ? (c = y, St++) : (c = o, 0 === _t && Bt(m)), c !== o ? (93 === t.charCodeAt(St) ? (l = y, St++) : (l = o, 0 === _t && Bt(m)), l !== o ? (At = e, e = r = v(a)) : (St = e, e = u)) : (St = e, e = u)) : (St = e, e = u);
                                                        } else St = e, e = u;
                                                    } else St = e, e = u;
                                                } else St = e, e = u;
                                            } else St = e, e = u;
                                            return xt[f] = {
                                                nextPos: St,
                                                result: e
                                            }, e;
                                        }(), e === o && (e = function() {
                                            var e, r, n, i, a, s, c = 49 * St + 9, l = xt[c];
                                            if (l) return St = l.nextPos, l.result;
                                            if (e = St, r = Mt(), r !== o) {
                                                for(n = [], i = nr(); i !== o;)n.push(i), i = nr();
                                                if (n !== o) {
                                                    if (61 === t.charCodeAt(St) ? (i = T, St++) : (i = o, 0 === _t && Bt(O)), i !== o) {
                                                        for(a = [], s = nr(); s !== o;)a.push(s), s = nr();
                                                        a !== o && (s = qt()) !== o ? (At = e, e = r = k(r, s)) : (St = e, e = u);
                                                    } else St = e, e = u;
                                                } else St = e, e = u;
                                            } else St = e, e = u;
                                            if (e === o) {
                                                if (e = St, (r = Vt()) !== o) {
                                                    for(n = [], i = nr(); i !== o;)n.push(i), i = nr();
                                                    if (n !== o) {
                                                        if (61 === t.charCodeAt(St) ? (i = T, St++) : (i = o, 0 === _t && Bt(O)), i !== o) {
                                                            for(a = [], s = nr(); s !== o;)a.push(s), s = nr();
                                                            a !== o && (s = qt()) !== o ? (At = e, e = r = k(r, s)) : (St = e, e = u);
                                                        } else St = e, e = u;
                                                    } else St = e, e = u;
                                                } else St = e, e = u;
                                            }
                                            return xt[c] = {
                                                nextPos: St,
                                                result: e
                                            }, e;
                                        }())));
                                        return xt[r] = {
                                            nextPos: St,
                                            result: e
                                        }, e;
                                    }(), n !== o) {
                                        for(i = [], a = nr(); a !== o;)i.push(a), a = nr();
                                        if (i !== o) {
                                            for(a = [], s = Nt(); s !== o;)a.push(s), s = Nt();
                                            if (a !== o) {
                                                if (s = [], (c = or()) !== o) for(; c !== o;)s.push(c), c = or();
                                                else s = u;
                                                s === o && (s = ar()), s !== o ? e = r = [
                                                    r,
                                                    n,
                                                    i,
                                                    a,
                                                    s
                                                ] : (St = e, e = u);
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                } else St = e, e = u;
                                if (e === o) {
                                    if (e = St, r = [], (n = nr()) !== o) for(; n !== o;)r.push(n), n = nr();
                                    else r = u;
                                    if (r !== o) {
                                        if (n = [], (i = or()) !== o) for(; i !== o;)n.push(i), i = or();
                                        else n = u;
                                        n === o && (n = ar()), n !== o ? e = r = [
                                            r,
                                            n
                                        ] : (St = e, e = u);
                                    } else St = e, e = u;
                                    e === o && (e = or());
                                }
                                return xt[l] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Nt() {
                                var e, r, n, i, a, s, d = 49 * St + 3, h = xt[d];
                                if (h) return St = h.nextPos, h.result;
                                if (e = St, 35 === t.charCodeAt(St) ? (r = c, St++) : (r = o, 0 === _t && Bt(l)), r !== o) {
                                    for(n = [], i = St, a = St, _t++, (s = or()) === o && (s = ar()), _t--, s === o ? a = f : (St = a, a = u), a !== o ? (t.length > St ? (s = t.charAt(St), St++) : (s = o, 0 === _t && Bt(p)), s !== o ? i = a = [
                                        a,
                                        s
                                    ] : (St = i, i = u)) : (St = i, i = u); i !== o;)n.push(i), i = St, a = St, _t++, (s = or()) === o && (s = ar()), _t--, s === o ? a = f : (St = a, a = u), a !== o ? (t.length > St ? (s = t.charAt(St), St++) : (s = o, 0 === _t && Bt(p)), s !== o ? i = a = [
                                        a,
                                        s
                                    ] : (St = i, i = u)) : (St = i, i = u);
                                    n !== o ? e = r = [
                                        r,
                                        n
                                    ] : (St = e, e = u);
                                } else St = e, e = u;
                                return xt[d] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Lt() {
                                var e, t, r, n = 49 * St + 6, i = xt[n];
                                if (i) return St = i.nextPos, i.result;
                                if (e = St, t = [], (r = Dt()) !== o) for(; r !== o;)t.push(r), r = Dt();
                                else t = u;
                                return t !== o && (r = Ft()) !== o ? (At = e, e = t = b(t, r)) : (St = e, e = u), e === o && (e = St, (t = Ft()) !== o && (At = e, t = w(t)), e = t), xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Ft() {
                                var e, t, r, n, i, a = 49 * St + 7, s = xt[a];
                                if (s) return St = s.nextPos, s.result;
                                for(e = St, t = [], r = nr(); r !== o;)t.push(r), r = nr();
                                if (t !== o) {
                                    if ((r = Mt()) !== o) {
                                        for(n = [], i = nr(); i !== o;)n.push(i), i = nr();
                                        n !== o ? (At = e, e = t = S(r)) : (St = e, e = u);
                                    } else St = e, e = u;
                                } else St = e, e = u;
                                if (e === o) {
                                    for(e = St, t = [], r = nr(); r !== o;)t.push(r), r = nr();
                                    if (t !== o) {
                                        if ((r = Vt()) !== o) {
                                            for(n = [], i = nr(); i !== o;)n.push(i), i = nr();
                                            n !== o ? (At = e, e = t = S(r)) : (St = e, e = u);
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                }
                                return xt[a] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Dt() {
                                var e, r, n, i, a, s, c, l = 49 * St + 8, f = xt[l];
                                if (f) return St = f.nextPos, f.result;
                                for(e = St, r = [], n = nr(); n !== o;)r.push(n), n = nr();
                                if (r !== o) {
                                    if ((n = Mt()) !== o) {
                                        for(i = [], a = nr(); a !== o;)i.push(a), a = nr();
                                        if (i !== o) {
                                            if (46 === t.charCodeAt(St) ? (a = A, St++) : (a = o, 0 === _t && Bt(E)), a !== o) {
                                                for(s = [], c = nr(); c !== o;)s.push(c), c = nr();
                                                s !== o ? (At = e, e = r = S(n)) : (St = e, e = u);
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                } else St = e, e = u;
                                if (e === o) {
                                    for(e = St, r = [], n = nr(); n !== o;)r.push(n), n = nr();
                                    if (r !== o) {
                                        if ((n = Vt()) !== o) {
                                            for(i = [], a = nr(); a !== o;)i.push(a), a = nr();
                                            if (i !== o) {
                                                if (46 === t.charCodeAt(St) ? (a = A, St++) : (a = o, 0 === _t && Bt(E)), a !== o) {
                                                    for(s = [], c = nr(); c !== o;)s.push(c), c = nr();
                                                    s !== o ? (At = e, e = r = S(n)) : (St = e, e = u);
                                                } else St = e, e = u;
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                }
                                return xt[l] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Mt() {
                                var e, t, r, n = 49 * St + 10, i = xt[n];
                                if (i) return St = i.nextPos, i.result;
                                if (e = St, t = [], (r = cr()) !== o) for(; r !== o;)t.push(r), r = cr();
                                else t = u;
                                return t !== o && (At = e, t = _(t)), e = t, xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Vt() {
                                var e, t, r = 49 * St + 11, n = xt[r];
                                return n ? (St = n.nextPos, n.result) : (e = St, (t = Gt()) !== o && (At = e, t = x(t)), (e = t) === o && (e = St, (t = Ht()) !== o && (At = e, t = x(t)), e = t), xt[r] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function qt() {
                                var e, r = 49 * St + 12, n = xt[r];
                                return n ? (St = n.nextPos, n.result) : (e = function() {
                                    var e, r = 49 * St + 13, n = xt[r];
                                    if (n) return St = n.nextPos, n.result;
                                    e = function() {
                                        var e, r, n, i, a, s = 49 * St + 14, c = xt[s];
                                        if (c) return St = c.nextPos, c.result;
                                        e = St, t.substr(St, 3) === P ? (r = P, St += 3) : (r = o, 0 === _t && Bt(R));
                                        if (r !== o) {
                                            if ((n = or()) === o && (n = I), n !== o) {
                                                for(i = [], a = Xt(); a !== o;)i.push(a), a = Xt();
                                                i !== o ? (t.substr(St, 3) === P ? (a = P, St += 3) : (a = o, 0 === _t && Bt(R)), a !== o ? (At = e, e = r = B(i)) : (St = e, e = u)) : (St = e, e = u);
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                        return xt[s] = {
                                            nextPos: St,
                                            result: e
                                        }, e;
                                    }(), e === o && (e = Gt()) === o && (e = function() {
                                        var e, r, n, i, a, s = 49 * St + 16, c = xt[s];
                                        if (c) return St = c.nextPos, c.result;
                                        e = St, t.substr(St, 3) === U ? (r = U, St += 3) : (r = o, 0 === _t && Bt(N));
                                        if (r !== o) {
                                            if ((n = or()) === o && (n = I), n !== o) {
                                                for(i = [], a = Kt(); a !== o;)i.push(a), a = Kt();
                                                i !== o ? (t.substr(St, 3) === U ? (a = U, St += 3) : (a = o, 0 === _t && Bt(N)), a !== o ? (At = e, e = r = B(i)) : (St = e, e = u)) : (St = e, e = u);
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                        return xt[s] = {
                                            nextPos: St,
                                            result: e
                                        }, e;
                                    }(), e === o && (e = Ht()));
                                    return xt[r] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = function() {
                                    var e, r, n, i, a, s = 49 * St + 38, c = xt[s];
                                    if (c) return St = c.nextPos, c.result;
                                    e = St, (r = rr()) !== o ? (84 === t.charCodeAt(St) ? (n = _e, St++) : (n = o, 0 === _t && Bt(xe)), n !== o ? (i = function() {
                                        var e, r, n, i, a, s, c, l, f, p, d, h = 49 * St + 36, y = xt[h];
                                        if (y) return St = y.nextPos, y.result;
                                        e = St, r = St, n = ur(), n !== o && (i = ur()) !== o ? (58 === t.charCodeAt(St) ? (a = Te, St++) : (a = o, 0 === _t && Bt(Oe)), a !== o && (s = ur()) !== o && (c = ur()) !== o ? (58 === t.charCodeAt(St) ? (l = Te, St++) : (l = o, 0 === _t && Bt(Oe)), l !== o && (f = ur()) !== o && (p = ur()) !== o ? ((d = tr()) === o && (d = I), d !== o ? r = n = [
                                            n,
                                            i,
                                            a,
                                            s,
                                            c,
                                            l,
                                            f,
                                            p,
                                            d
                                        ] : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u);
                                        r !== o && (At = e, r = ke(r));
                                        return e = r, xt[h] = {
                                            nextPos: St,
                                            result: e
                                        }, e;
                                    }(), i !== o ? (90 === t.charCodeAt(St) ? (a = Pe, St++) : (a = o, 0 === _t && Bt(Re)), a !== o ? (At = e, e = r = Ie(r, i)) : (St = e, e = u)) : (St = e, e = u)) : (St = e, e = u)) : (St = e, e = u);
                                    e === o && (e = St, (r = rr()) !== o ? (84 === t.charCodeAt(St) ? (n = _e, St++) : (n = o, 0 === _t && Bt(xe)), n !== o ? (i = function() {
                                        var e, r, n, i, a, s, c, l, f, p, d, h, y, m, g, v, b, w = 49 * St + 37, S = xt[w];
                                        if (S) return St = S.nextPos, S.result;
                                        e = St, r = St, n = ur(), n !== o && (i = ur()) !== o ? (58 === t.charCodeAt(St) ? (a = Te, St++) : (a = o, 0 === _t && Bt(Oe)), a !== o && (s = ur()) !== o && (c = ur()) !== o ? (58 === t.charCodeAt(St) ? (l = Te, St++) : (l = o, 0 === _t && Bt(Oe)), l !== o && (f = ur()) !== o && (p = ur()) !== o ? ((d = tr()) === o && (d = I), d !== o ? (45 === t.charCodeAt(St) ? (h = J, St++) : (h = o, 0 === _t && Bt(ee)), h === o && (43 === t.charCodeAt(St) ? (h = $, St++) : (h = o, 0 === _t && Bt(Y))), h !== o && (y = ur()) !== o && (m = ur()) !== o ? (58 === t.charCodeAt(St) ? (g = Te, St++) : (g = o, 0 === _t && Bt(Oe)), g !== o && (v = ur()) !== o && (b = ur()) !== o ? r = n = [
                                            n,
                                            i,
                                            a,
                                            s,
                                            c,
                                            l,
                                            f,
                                            p,
                                            d,
                                            h,
                                            y,
                                            m,
                                            g,
                                            v,
                                            b
                                        ] : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u);
                                        r !== o && (At = e, r = ke(r));
                                        return e = r, xt[w] = {
                                            nextPos: St,
                                            result: e
                                        }, e;
                                    }(), i !== o ? (At = e, e = r = Be(r, i)) : (St = e, e = u)) : (St = e, e = u)) : (St = e, e = u));
                                    return xt[s] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = function() {
                                    var e, r, n, i, a = 49 * St + 23, s = xt[a];
                                    if (s) return St = s.nextPos, s.result;
                                    e = St, (r = Zt()) === o && (r = $t());
                                    r !== o ? (101 === t.charCodeAt(St) ? (n = H, St++) : (n = o, 0 === _t && Bt(z)), n === o && (69 === t.charCodeAt(St) ? (n = W, St++) : (n = o, 0 === _t && Bt(X))), n !== o && (i = $t()) !== o ? (At = e, e = r = K(r, i)) : (St = e, e = u)) : (St = e, e = u);
                                    e === o && (e = St, (r = Zt()) !== o && (At = e, r = Z(r)), e = r);
                                    return xt[a] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = function() {
                                    var e, t, r = 49 * St + 25, n = xt[r];
                                    if (n) return St = n.nextPos, n.result;
                                    e = St, (t = $t()) !== o && (At = e, t = re(t));
                                    return e = t, xt[r] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = function() {
                                    var e, r, n = 49 * St + 27, i = xt[n];
                                    if (i) return St = i.nextPos, i.result;
                                    e = St, t.substr(St, 4) === ne ? (r = ne, St += 4) : (r = o, 0 === _t && Bt(oe));
                                    r !== o && (At = e, r = ie());
                                    e = r, e === o && (e = St, t.substr(St, 5) === ae ? (r = ae, St += 5) : (r = o, 0 === _t && Bt(se)), r !== o && (At = e, r = ue()), e = r);
                                    return xt[n] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = function() {
                                    var e, r, n, i, a, s = 49 * St + 28, c = xt[s];
                                    if (c) return St = c.nextPos, c.result;
                                    e = St, 91 === t.charCodeAt(St) ? (r = d, St++) : (r = o, 0 === _t && Bt(h));
                                    if (r !== o) {
                                        for(n = [], i = Jt(); i !== o;)n.push(i), i = Jt();
                                        n !== o ? (93 === t.charCodeAt(St) ? (i = y, St++) : (i = o, 0 === _t && Bt(m)), i !== o ? (At = e, e = r = ce()) : (St = e, e = u)) : (St = e, e = u);
                                    } else St = e, e = u;
                                    if (e === o && (e = St, 91 === t.charCodeAt(St) ? (r = d, St++) : (r = o, 0 === _t && Bt(h)), r !== o ? ((n = Yt()) === o && (n = I), n !== o ? (93 === t.charCodeAt(St) ? (i = y, St++) : (i = o, 0 === _t && Bt(m)), i !== o ? (At = e, e = r = le(n)) : (St = e, e = u)) : (St = e, e = u)) : (St = e, e = u), e === o)) {
                                        if (e = St, 91 === t.charCodeAt(St) ? (r = d, St++) : (r = o, 0 === _t && Bt(h)), r !== o) {
                                            if (n = [], (i = Qt()) !== o) for(; i !== o;)n.push(i), i = Qt();
                                            else n = u;
                                            n !== o ? (93 === t.charCodeAt(St) ? (i = y, St++) : (i = o, 0 === _t && Bt(m)), i !== o ? (At = e, e = r = fe(n)) : (St = e, e = u)) : (St = e, e = u);
                                        } else St = e, e = u;
                                        if (e === o) {
                                            if (e = St, 91 === t.charCodeAt(St) ? (r = d, St++) : (r = o, 0 === _t && Bt(h)), r !== o) {
                                                if (n = [], (i = Qt()) !== o) for(; i !== o;)n.push(i), i = Qt();
                                                else n = u;
                                                n !== o && (i = Yt()) !== o ? (93 === t.charCodeAt(St) ? (a = y, St++) : (a = o, 0 === _t && Bt(m)), a !== o ? (At = e, e = r = pe(n, i)) : (St = e, e = u)) : (St = e, e = u);
                                            } else St = e, e = u;
                                        }
                                    }
                                    return xt[s] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = function() {
                                    var e, r, n, i, a, s, c = 49 * St + 32, l = xt[c];
                                    if (l) return St = l.nextPos, l.result;
                                    e = St, 123 === t.charCodeAt(St) ? (r = me, St++) : (r = o, 0 === _t && Bt(ge));
                                    if (r !== o) {
                                        for(n = [], i = nr(); i !== o;)n.push(i), i = nr();
                                        if (n !== o) {
                                            for(i = [], a = er(); a !== o;)i.push(a), a = er();
                                            if (i !== o) {
                                                for(a = [], s = nr(); s !== o;)a.push(s), s = nr();
                                                a !== o ? (125 === t.charCodeAt(St) ? (s = ve, St++) : (s = o, 0 === _t && Bt(be)), s !== o ? (At = e, e = r = we(i)) : (St = e, e = u)) : (St = e, e = u);
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                    return xt[c] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }())))))), xt[r] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function Gt() {
                                var e, r, n, i, a = 49 * St + 15, s = xt[a];
                                if (s) return St = s.nextPos, s.result;
                                if (e = St, 34 === t.charCodeAt(St) ? (r = C, St++) : (r = o, 0 === _t && Bt(j)), r !== o) {
                                    for(n = [], i = zt(); i !== o;)n.push(i), i = zt();
                                    n !== o ? (34 === t.charCodeAt(St) ? (i = C, St++) : (i = o, 0 === _t && Bt(j)), i !== o ? (At = e, e = r = B(n)) : (St = e, e = u)) : (St = e, e = u);
                                } else St = e, e = u;
                                return xt[a] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Ht() {
                                var e, r, n, i, a = 49 * St + 17, s = xt[a];
                                if (s) return St = s.nextPos, s.result;
                                if (e = St, 39 === t.charCodeAt(St) ? (r = L, St++) : (r = o, 0 === _t && Bt(F)), r !== o) {
                                    for(n = [], i = Wt(); i !== o;)n.push(i), i = Wt();
                                    n !== o ? (39 === t.charCodeAt(St) ? (i = L, St++) : (i = o, 0 === _t && Bt(F)), i !== o ? (At = e, e = r = B(n)) : (St = e, e = u)) : (St = e, e = u);
                                } else St = e, e = u;
                                return xt[a] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function zt() {
                                var e, r, n, i = 49 * St + 18, a = xt[i];
                                return a ? (St = a.nextPos, a.result) : ((e = fr()) === o && (e = St, r = St, _t++, 34 === t.charCodeAt(St) ? (n = C, St++) : (n = o, 0 === _t && Bt(j)), _t--, n === o ? r = f : (St = r, r = u), r !== o ? (t.length > St ? (n = t.charAt(St), St++) : (n = o, 0 === _t && Bt(p)), n !== o ? (At = e, e = r = D(n)) : (St = e, e = u)) : (St = e, e = u)), xt[i] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function Wt() {
                                var e, r, n, i = 49 * St + 19, a = xt[i];
                                return a ? (St = a.nextPos, a.result) : (e = St, r = St, _t++, 39 === t.charCodeAt(St) ? (n = L, St++) : (n = o, 0 === _t && Bt(F)), _t--, n === o ? r = f : (St = r, r = u), r !== o ? (t.length > St ? (n = t.charAt(St), St++) : (n = o, 0 === _t && Bt(p)), n !== o ? (At = e, e = r = D(n)) : (St = e, e = u)) : (St = e, e = u), xt[i] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function Xt() {
                                var e, r, n, i = 49 * St + 20, a = xt[i];
                                return a ? (St = a.nextPos, a.result) : ((e = fr()) === o && (e = function() {
                                    var e, r, n, i, a = 49 * St + 21, s = xt[a];
                                    if (s) return St = s.nextPos, s.result;
                                    e = St, 92 === t.charCodeAt(St) ? (r = V, St++) : (r = o, 0 === _t && Bt(q));
                                    if (r !== o) {
                                        if (or() !== o) {
                                            for(n = [], i = ir(); i !== o;)n.push(i), i = ir();
                                            n !== o ? (At = e, e = r = G()) : (St = e, e = u);
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                    return xt[a] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }(), e === o && (e = St, r = St, _t++, t.substr(St, 3) === P ? (n = P, St += 3) : (n = o, 0 === _t && Bt(R)), _t--, n === o ? r = f : (St = r, r = u), r !== o ? (t.length > St ? (n = t.charAt(St), St++) : (n = o, 0 === _t && Bt(p)), n !== o ? (At = e, e = r = M(n)) : (St = e, e = u)) : (St = e, e = u))), xt[i] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function Kt() {
                                var e, r, n, i = 49 * St + 22, a = xt[i];
                                return a ? (St = a.nextPos, a.result) : (e = St, r = St, _t++, t.substr(St, 3) === U ? (n = U, St += 3) : (n = o, 0 === _t && Bt(N)), _t--, n === o ? r = f : (St = r, r = u), r !== o ? (t.length > St ? (n = t.charAt(St), St++) : (n = o, 0 === _t && Bt(p)), n !== o ? (At = e, e = r = D(n)) : (St = e, e = u)) : (St = e, e = u), xt[i] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function Zt() {
                                var e, r, n, i, a, s, c = 49 * St + 24, l = xt[c];
                                return l ? (St = l.nextPos, l.result) : (e = St, 43 === t.charCodeAt(St) ? (r = $, St++) : (r = o, 0 === _t && Bt(Y)), r === o && (r = I), r !== o ? (n = St, (i = lr()) !== o ? (46 === t.charCodeAt(St) ? (a = A, St++) : (a = o, 0 === _t && Bt(E)), a !== o && (s = lr()) !== o ? n = i = [
                                    i,
                                    a,
                                    s
                                ] : (St = n, n = u)) : (St = n, n = u), n !== o ? (At = e, e = r = Q(n)) : (St = e, e = u)) : (St = e, e = u), e === o && (e = St, 45 === t.charCodeAt(St) ? (r = J, St++) : (r = o, 0 === _t && Bt(ee)), r !== o ? (n = St, (i = lr()) !== o ? (46 === t.charCodeAt(St) ? (a = A, St++) : (a = o, 0 === _t && Bt(E)), a !== o && (s = lr()) !== o ? n = i = [
                                    i,
                                    a,
                                    s
                                ] : (St = n, n = u)) : (St = n, n = u), n !== o ? (At = e, e = r = te(n)) : (St = e, e = u)) : (St = e, e = u)), xt[c] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function $t() {
                                var e, r, n, i, a, s = 49 * St + 26, c = xt[s];
                                if (c) return St = c.nextPos, c.result;
                                if (e = St, 43 === t.charCodeAt(St) ? (r = $, St++) : (r = o, 0 === _t && Bt(Y)), r === o && (r = I), r !== o) {
                                    if (n = [], (i = ur()) !== o) for(; i !== o;)n.push(i), i = ur();
                                    else n = u;
                                    n !== o ? (i = St, _t++, 46 === t.charCodeAt(St) ? (a = A, St++) : (a = o, 0 === _t && Bt(E)), _t--, a === o ? i = f : (St = i, i = u), i !== o ? (At = e, e = r = Q(n)) : (St = e, e = u)) : (St = e, e = u);
                                } else St = e, e = u;
                                if (e === o) {
                                    if (e = St, 45 === t.charCodeAt(St) ? (r = J, St++) : (r = o, 0 === _t && Bt(ee)), r !== o) {
                                        if (n = [], (i = ur()) !== o) for(; i !== o;)n.push(i), i = ur();
                                        else n = u;
                                        n !== o ? (i = St, _t++, 46 === t.charCodeAt(St) ? (a = A, St++) : (a = o, 0 === _t && Bt(E)), _t--, a === o ? i = f : (St = i, i = u), i !== o ? (At = e, e = r = te(n)) : (St = e, e = u)) : (St = e, e = u);
                                    } else St = e, e = u;
                                }
                                return xt[s] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Yt() {
                                var e, t, r, n, i, a = 49 * St + 29, s = xt[a];
                                if (s) return St = s.nextPos, s.result;
                                for(e = St, t = [], r = Jt(); r !== o;)t.push(r), r = Jt();
                                if (t !== o) {
                                    if ((r = qt()) !== o) {
                                        for(n = [], i = Jt(); i !== o;)n.push(i), i = Jt();
                                        n !== o ? (At = e, e = t = de(r)) : (St = e, e = u);
                                    } else St = e, e = u;
                                } else St = e, e = u;
                                return xt[a] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Qt() {
                                var e, r, n, i, a, s, c, l = 49 * St + 30, f = xt[l];
                                if (f) return St = f.nextPos, f.result;
                                for(e = St, r = [], n = Jt(); n !== o;)r.push(n), n = Jt();
                                if (r !== o) {
                                    if ((n = qt()) !== o) {
                                        for(i = [], a = Jt(); a !== o;)i.push(a), a = Jt();
                                        if (i !== o) {
                                            if (44 === t.charCodeAt(St) ? (a = he, St++) : (a = o, 0 === _t && Bt(ye)), a !== o) {
                                                for(s = [], c = Jt(); c !== o;)s.push(c), c = Jt();
                                                s !== o ? (At = e, e = r = de(n)) : (St = e, e = u);
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                } else St = e, e = u;
                                return xt[l] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function Jt() {
                                var e, t = 49 * St + 31, r = xt[t];
                                return r ? (St = r.nextPos, r.result) : ((e = nr()) === o && (e = or()) === o && (e = Nt()), xt[t] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function er() {
                                var e, r, n, i, a, s, c, l, f, p, d, h = 49 * St + 33, y = xt[h];
                                if (y) return St = y.nextPos, y.result;
                                for(e = St, r = [], n = nr(); n !== o;)r.push(n), n = nr();
                                if (r !== o) {
                                    if ((n = Mt()) !== o) {
                                        for(i = [], a = nr(); a !== o;)i.push(a), a = nr();
                                        if (i !== o) {
                                            if (61 === t.charCodeAt(St) ? (a = T, St++) : (a = o, 0 === _t && Bt(O)), a !== o) {
                                                for(s = [], c = nr(); c !== o;)s.push(c), c = nr();
                                                if (s !== o) {
                                                    if ((c = qt()) !== o) {
                                                        for(l = [], f = nr(); f !== o;)l.push(f), f = nr();
                                                        if (l !== o) {
                                                            if (44 === t.charCodeAt(St) ? (f = he, St++) : (f = o, 0 === _t && Bt(ye)), f !== o) {
                                                                for(p = [], d = nr(); d !== o;)p.push(d), d = nr();
                                                                p !== o ? (At = e, e = r = Se(n, c)) : (St = e, e = u);
                                                            } else St = e, e = u;
                                                        } else St = e, e = u;
                                                    } else St = e, e = u;
                                                } else St = e, e = u;
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                } else St = e, e = u;
                                if (e === o) {
                                    for(e = St, r = [], n = nr(); n !== o;)r.push(n), n = nr();
                                    if (r !== o) {
                                        if ((n = Mt()) !== o) {
                                            for(i = [], a = nr(); a !== o;)i.push(a), a = nr();
                                            if (i !== o) {
                                                if (61 === t.charCodeAt(St) ? (a = T, St++) : (a = o, 0 === _t && Bt(O)), a !== o) {
                                                    for(s = [], c = nr(); c !== o;)s.push(c), c = nr();
                                                    s !== o && (c = qt()) !== o ? (At = e, e = r = Se(n, c)) : (St = e, e = u);
                                                } else St = e, e = u;
                                            } else St = e, e = u;
                                        } else St = e, e = u;
                                    } else St = e, e = u;
                                }
                                return xt[h] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function tr() {
                                var e, r, n, i = 49 * St + 34, a = xt[i];
                                return a ? (St = a.nextPos, a.result) : (e = St, 46 === t.charCodeAt(St) ? (r = A, St++) : (r = o, 0 === _t && Bt(E)), r !== o && (n = lr()) !== o ? (At = e, e = r = Ae(n)) : (St = e, e = u), xt[i] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function rr() {
                                var e, r, n, i, a, s, c, l, f, p, d, h, y = 49 * St + 35, m = xt[y];
                                return m ? (St = m.nextPos, m.result) : (e = St, r = St, (n = ur()) !== o && (i = ur()) !== o && (a = ur()) !== o && (s = ur()) !== o ? (45 === t.charCodeAt(St) ? (c = J, St++) : (c = o, 0 === _t && Bt(ee)), c !== o && (l = ur()) !== o && (f = ur()) !== o ? (45 === t.charCodeAt(St) ? (p = J, St++) : (p = o, 0 === _t && Bt(ee)), p !== o && (d = ur()) !== o && (h = ur()) !== o ? r = n = [
                                    n,
                                    i,
                                    a,
                                    s,
                                    c,
                                    l,
                                    f,
                                    p,
                                    d,
                                    h
                                ] : (St = r, r = u)) : (St = r, r = u)) : (St = r, r = u), r !== o && (At = e, r = Ee(r)), e = r, xt[y] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function nr() {
                                var e, r = 49 * St + 39, n = xt[r];
                                return n ? (St = n.nextPos, n.result) : (Ce.test(t.charAt(St)) ? (e = t.charAt(St), St++) : (e = o, 0 === _t && Bt(je)), xt[r] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function or() {
                                var e, r, n, i = 49 * St + 40, a = xt[i];
                                return a ? (St = a.nextPos, a.result) : (10 === t.charCodeAt(St) ? (e = Ue, St++) : (e = o, 0 === _t && Bt(Ne)), e === o && (e = St, 13 === t.charCodeAt(St) ? (r = Le, St++) : (r = o, 0 === _t && Bt(Fe)), r !== o ? (10 === t.charCodeAt(St) ? (n = Ue, St++) : (n = o, 0 === _t && Bt(Ne)), n !== o ? e = r = [
                                    r,
                                    n
                                ] : (St = e, e = u)) : (St = e, e = u)), xt[i] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function ir() {
                                var e, t = 49 * St + 41, r = xt[t];
                                return r ? (St = r.nextPos, r.result) : ((e = or()) === o && (e = nr()), xt[t] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function ar() {
                                var e, r, n = 49 * St + 42, i = xt[n];
                                return i ? (St = i.nextPos, i.result) : (e = St, _t++, t.length > St ? (r = t.charAt(St), St++) : (r = o, 0 === _t && Bt(p)), _t--, r === o ? e = f : (St = e, e = u), xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function sr() {
                                var e, r = 49 * St + 43, n = xt[r];
                                return n ? (St = n.nextPos, n.result) : (De.test(t.charAt(St)) ? (e = t.charAt(St), St++) : (e = o, 0 === _t && Bt(Me)), xt[r] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function ur() {
                                var e, r, n = 49 * St + 44, i = xt[n];
                                return i ? (St = i.nextPos, i.result) : (Ve.test(t.charAt(St)) ? (e = t.charAt(St), St++) : (e = o, 0 === _t && Bt(qe)), e === o && (e = St, 95 === t.charCodeAt(St) ? (r = Ge, St++) : (r = o, 0 === _t && Bt(He)), r !== o && (At = e, r = ze()), e = r), xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function cr() {
                                var e, r = 49 * St + 45, n = xt[r];
                                return n ? (St = n.nextPos, n.result) : (We.test(t.charAt(St)) ? (e = t.charAt(St), St++) : (e = o, 0 === _t && Bt(Xe)), xt[r] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            function lr() {
                                var e, t, r, n = 49 * St + 46, i = xt[n];
                                if (i) return St = i.nextPos, i.result;
                                if (e = St, t = [], (r = ur()) !== o) for(; r !== o;)t.push(r), r = ur();
                                else t = u;
                                return t !== o && (At = e, t = Ke(t)), e = t, xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e;
                            }
                            function fr() {
                                var e, r, n = 49 * St + 47, i = xt[n];
                                return i ? (St = i.nextPos, i.result) : (e = St, t.substr(St, 2) === Ze ? (r = Ze, St += 2) : (r = o, 0 === _t && Bt($e)), r !== o && (At = e, r = Ye()), (e = r) === o && (e = St, t.substr(St, 2) === Qe ? (r = Qe, St += 2) : (r = o, 0 === _t && Bt(Je)), r !== o && (At = e, r = et()), (e = r) === o && (e = St, t.substr(St, 2) === tt ? (r = tt, St += 2) : (r = o, 0 === _t && Bt(rt)), r !== o && (At = e, r = nt()), (e = r) === o && (e = St, t.substr(St, 2) === ot ? (r = ot, St += 2) : (r = o, 0 === _t && Bt(it)), r !== o && (At = e, r = at()), (e = r) === o && (e = St, t.substr(St, 2) === st ? (r = st, St += 2) : (r = o, 0 === _t && Bt(ut)), r !== o && (At = e, r = ct()), (e = r) === o && (e = St, t.substr(St, 2) === lt ? (r = lt, St += 2) : (r = o, 0 === _t && Bt(ft)), r !== o && (At = e, r = pt()), (e = r) === o && (e = St, t.substr(St, 2) === dt ? (r = dt, St += 2) : (r = o, 0 === _t && Bt(ht)), r !== o && (At = e, r = yt()), (e = r) === o && (e = function() {
                                    var e, r, n, i, a, s, c, l, f, p, d, h = 49 * St + 48, y = xt[h];
                                    if (y) return St = y.nextPos, y.result;
                                    e = St, t.substr(St, 2) === mt ? (r = mt, St += 2) : (r = o, 0 === _t && Bt(gt));
                                    r !== o ? (n = St, (i = sr()) !== o && (a = sr()) !== o && (s = sr()) !== o && (c = sr()) !== o && (l = sr()) !== o && (f = sr()) !== o && (p = sr()) !== o && (d = sr()) !== o ? n = i = [
                                        i,
                                        a,
                                        s,
                                        c,
                                        l,
                                        f,
                                        p,
                                        d
                                    ] : (St = n, n = u), n !== o ? (At = e, e = r = vt(n)) : (St = e, e = u)) : (St = e, e = u);
                                    e === o && (e = St, t.substr(St, 2) === bt ? (r = bt, St += 2) : (r = o, 0 === _t && Bt(wt)), r !== o ? (n = St, (i = sr()) !== o && (a = sr()) !== o && (s = sr()) !== o && (c = sr()) !== o ? n = i = [
                                        i,
                                        a,
                                        s,
                                        c
                                    ] : (St = n, n = u), n !== o ? (At = e, e = r = vt(n)) : (St = e, e = u)) : (St = e, e = u));
                                    return xt[h] = {
                                        nextPos: St,
                                        result: e
                                    }, e;
                                }()))))))), xt[n] = {
                                    nextPos: St,
                                    result: e
                                }, e);
                            }
                            var pr = [];
                            function dr(e) {
                                pr.push(e);
                            }
                            function hr(e, t, r, n, o) {
                                var i = {
                                    type: e,
                                    value: t,
                                    line: r(),
                                    column: n()
                                };
                                return o && (i.key = o), i;
                            }
                            if ((r = a()) !== o && St === t.length) return r;
                            throw r !== o && St < t.length && Bt({
                                type: "end",
                                description: "end of input"
                            }), Ct(null, kt, Ot);
                        }
                    };
                }();
            },
            1430 (e, t, r) {
                var n, o;
                !function(i, a) {
                    "use strict";
                    e.exports ? e.exports = a() : void 0 === (o = "function" == typeof (n = a) ? n.call(t, r, t, e) : n) || (e.exports = o);
                }(0, function(e) {
                    "use strict";
                    var t = e && e.IPv6;
                    return {
                        best: function(e) {
                            var t, r, n = e.toLowerCase().split(":"), o = n.length, i = 8;
                            for("" === n[0] && "" === n[1] && "" === n[2] ? (n.shift(), n.shift()) : "" === n[0] && "" === n[1] ? n.shift() : "" === n[o - 1] && "" === n[o - 2] && n.pop(), -1 !== n[(o = n.length) - 1].indexOf(".") && (i = 7), t = 0; t < o && "" !== n[t]; t++);
                            if (t < i) for(n.splice(t, 1, "0000"); n.length < i;)n.splice(t, 0, "0000");
                            for(var a = 0; a < i; a++){
                                r = n[a].split("");
                                for(var s = 0; s < 3 && "0" === r[0] && r.length > 1; s++)r.splice(0, 1);
                                n[a] = r.join("");
                            }
                            var u = -1, c = 0, l = 0, f = -1, p = !1;
                            for(a = 0; a < i; a++)p ? "0" === n[a] ? l += 1 : (p = !1, l > c && (u = f, c = l)) : "0" === n[a] && (p = !0, f = a, l = 1);
                            l > c && (u = f, c = l), c > 1 && n.splice(u, c, ""), o = n.length;
                            var d = "";
                            for("" === n[0] && (d = ":"), a = 0; a < o && (d += n[a], a !== o - 1); a++)d += ":";
                            return "" === n[o - 1] && (d += ":"), d;
                        },
                        noConflict: function() {
                            return e.IPv6 === this && (e.IPv6 = t), this;
                        }
                    };
                });
            },
            4704 (e, t, r) {
                var n, o;
                !function(i, a) {
                    "use strict";
                    e.exports ? e.exports = a() : void 0 === (o = "function" == typeof (n = a) ? n.call(t, r, t, e) : n) || (e.exports = o);
                }(0, function(e) {
                    "use strict";
                    var t = e && e.SecondLevelDomains, r = {
                        list: {
                            ac: " com gov mil net org ",
                            ae: " ac co gov mil name net org pro sch ",
                            af: " com edu gov net org ",
                            al: " com edu gov mil net org ",
                            ao: " co ed gv it og pb ",
                            ar: " com edu gob gov int mil net org tur ",
                            at: " ac co gv or ",
                            au: " asn com csiro edu gov id net org ",
                            ba: " co com edu gov mil net org rs unbi unmo unsa untz unze ",
                            bb: " biz co com edu gov info net org store tv ",
                            bh: " biz cc com edu gov info net org ",
                            bn: " com edu gov net org ",
                            bo: " com edu gob gov int mil net org tv ",
                            br: " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
                            bs: " com edu gov net org ",
                            bz: " du et om ov rg ",
                            ca: " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
                            ck: " biz co edu gen gov info net org ",
                            cn: " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
                            co: " com edu gov mil net nom org ",
                            cr: " ac c co ed fi go or sa ",
                            cy: " ac biz com ekloges gov ltd name net org parliament press pro tm ",
                            do: " art com edu gob gov mil net org sld web ",
                            dz: " art asso com edu gov net org pol ",
                            ec: " com edu fin gov info med mil net org pro ",
                            eg: " com edu eun gov mil name net org sci ",
                            er: " com edu gov ind mil net org rochest w ",
                            es: " com edu gob nom org ",
                            et: " biz com edu gov info name net org ",
                            fj: " ac biz com info mil name net org pro ",
                            fk: " ac co gov net nom org ",
                            fr: " asso com f gouv nom prd presse tm ",
                            gg: " co net org ",
                            gh: " com edu gov mil org ",
                            gn: " ac com gov net org ",
                            gr: " com edu gov mil net org ",
                            gt: " com edu gob ind mil net org ",
                            gu: " com edu gov net org ",
                            hk: " com edu gov idv net org ",
                            hu: " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
                            id: " ac co go mil net or sch web ",
                            il: " ac co gov idf k12 muni net org ",
                            in: " ac co edu ernet firm gen gov i ind mil net nic org res ",
                            iq: " com edu gov i mil net org ",
                            ir: " ac co dnssec gov i id net org sch ",
                            it: " edu gov ",
                            je: " co net org ",
                            jo: " com edu gov mil name net org sch ",
                            jp: " ac ad co ed go gr lg ne or ",
                            ke: " ac co go info me mobi ne or sc ",
                            kh: " com edu gov mil net org per ",
                            ki: " biz com de edu gov info mob net org tel ",
                            km: " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
                            kn: " edu gov net org ",
                            kr: " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
                            kw: " com edu gov net org ",
                            ky: " com edu gov net org ",
                            kz: " com edu gov mil net org ",
                            lb: " com edu gov net org ",
                            lk: " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
                            lr: " com edu gov net org ",
                            lv: " asn com conf edu gov id mil net org ",
                            ly: " com edu gov id med net org plc sch ",
                            ma: " ac co gov m net org press ",
                            mc: " asso tm ",
                            me: " ac co edu gov its net org priv ",
                            mg: " com edu gov mil nom org prd tm ",
                            mk: " com edu gov inf name net org pro ",
                            ml: " com edu gov net org presse ",
                            mn: " edu gov org ",
                            mo: " com edu gov net org ",
                            mt: " com edu gov net org ",
                            mv: " aero biz com coop edu gov info int mil museum name net org pro ",
                            mw: " ac co com coop edu gov int museum net org ",
                            mx: " com edu gob net org ",
                            my: " com edu gov mil name net org sch ",
                            nf: " arts com firm info net other per rec store web ",
                            ng: " biz com edu gov mil mobi name net org sch ",
                            ni: " ac co com edu gob mil net nom org ",
                            np: " com edu gov mil net org ",
                            nr: " biz com edu gov info net org ",
                            om: " ac biz co com edu gov med mil museum net org pro sch ",
                            pe: " com edu gob mil net nom org sld ",
                            ph: " com edu gov i mil net ngo org ",
                            pk: " biz com edu fam gob gok gon gop gos gov net org web ",
                            pl: " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
                            pr: " ac biz com edu est gov info isla name net org pro prof ",
                            ps: " com edu gov net org plo sec ",
                            pw: " belau co ed go ne or ",
                            ro: " arts com firm info nom nt org rec store tm www ",
                            rs: " ac co edu gov in org ",
                            sb: " com edu gov net org ",
                            sc: " com edu gov net org ",
                            sh: " co com edu gov net nom org ",
                            sl: " com edu gov net org ",
                            st: " co com consulado edu embaixada gov mil net org principe saotome store ",
                            sv: " com edu gob org red ",
                            sz: " ac co org ",
                            tr: " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
                            tt: " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
                            tw: " club com ebiz edu game gov idv mil net org ",
                            mu: " ac co com gov net or org ",
                            mz: " ac co edu gov org ",
                            na: " co com ",
                            nz: " ac co cri geek gen govt health iwi maori mil net org parliament school ",
                            pa: " abo ac com edu gob ing med net nom org sld ",
                            pt: " com edu gov int net nome org publ ",
                            py: " com edu gov mil net org ",
                            qa: " com edu gov mil net org ",
                            re: " asso com nom ",
                            ru: " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
                            rw: " ac co com edu gouv gov int mil net ",
                            sa: " com edu gov med net org pub sch ",
                            sd: " com edu gov info med net org tv ",
                            se: " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
                            sg: " com edu gov idn net org per ",
                            sn: " art com edu gouv org perso univ ",
                            sy: " com edu gov mil net news org ",
                            th: " ac co go in mi net or ",
                            tj: " ac biz co com edu go gov info int mil name net nic org test web ",
                            tn: " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
                            tz: " ac co go ne or ",
                            ua: " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
                            ug: " ac co go ne or org sc ",
                            uk: " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
                            us: " dni fed isa kids nsn ",
                            uy: " com edu gub mil net org ",
                            ve: " co com edu gob info mil net org web ",
                            vi: " co com k12 net org ",
                            vn: " ac biz com edu gov health info int name net org pro ",
                            ye: " co com gov ltd me net org plc ",
                            yu: " ac co edu gov org ",
                            za: " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
                            zm: " ac co com edu gov net org sch ",
                            com: "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
                            net: "gb jp se uk ",
                            org: "ae",
                            de: "com "
                        },
                        has: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return !1;
                            var n = e.lastIndexOf(".", t - 1);
                            if (n <= 0 || n >= t - 1) return !1;
                            var o = r.list[e.slice(t + 1)];
                            return !!o && o.indexOf(" " + e.slice(n + 1, t) + " ") >= 0;
                        },
                        is: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return !1;
                            if (e.lastIndexOf(".", t - 1) >= 0) return !1;
                            var n = r.list[e.slice(t + 1)];
                            return !!n && n.indexOf(" " + e.slice(0, t) + " ") >= 0;
                        },
                        get: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return null;
                            var n = e.lastIndexOf(".", t - 1);
                            if (n <= 0 || n >= t - 1) return null;
                            var o = r.list[e.slice(t + 1)];
                            return o ? o.indexOf(" " + e.slice(n + 1, t) + " ") < 0 ? null : e.slice(n + 1) : null;
                        },
                        noConflict: function() {
                            return e.SecondLevelDomains === this && (e.SecondLevelDomains = t), this;
                        }
                    };
                    return r;
                });
            },
            4193 (e, t, r) {
                var n, o, i;
                !function(a, s) {
                    "use strict";
                    e.exports ? e.exports = s(r(9340), r(1430), r(4704)) : (o = [
                        r(9340),
                        r(1430),
                        r(4704)
                    ], void 0 === (i = "function" == typeof (n = s) ? n.apply(t, o) : n) || (e.exports = i));
                }(0, function(e, t, r, n) {
                    "use strict";
                    var o = n && n.URI;
                    function i(e, t) {
                        var r = arguments.length >= 1;
                        if (!(this instanceof i)) return r ? arguments.length >= 2 ? new i(e, t) : new i(e) : new i;
                        if (void 0 === e) {
                            if (r) throw new TypeError("undefined is not a valid argument for URI");
                            e = "undefined" != typeof location ? location.href + "" : "";
                        }
                        if (null === e && r) throw new TypeError("null is not a valid argument for URI");
                        return this.href(e), void 0 !== t ? this.absoluteTo(t) : this;
                    }
                    i.version = "1.19.11";
                    var a = i.prototype, s = Object.prototype.hasOwnProperty;
                    function u(e) {
                        return e.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
                    }
                    function c(e) {
                        return void 0 === e ? "Undefined" : String(Object.prototype.toString.call(e)).slice(8, -1);
                    }
                    function l(e) {
                        return "Array" === c(e);
                    }
                    function f(e, t) {
                        var r, n, o = {};
                        if ("RegExp" === c(t)) o = null;
                        else if (l(t)) for(r = 0, n = t.length; r < n; r++)o[t[r]] = !0;
                        else o[t] = !0;
                        for(r = 0, n = e.length; r < n; r++)(o && void 0 !== o[e[r]] || !o && t.test(e[r])) && (e.splice(r, 1), n--, r--);
                        return e;
                    }
                    function p(e, t) {
                        var r, n;
                        if (l(t)) {
                            for(r = 0, n = t.length; r < n; r++)if (!p(e, t[r])) return !1;
                            return !0;
                        }
                        var o = c(t);
                        for(r = 0, n = e.length; r < n; r++)if ("RegExp" === o) {
                            if ("string" == typeof e[r] && e[r].match(t)) return !0;
                        } else if (e[r] === t) return !0;
                        return !1;
                    }
                    function d(e, t) {
                        if (!l(e) || !l(t)) return !1;
                        if (e.length !== t.length) return !1;
                        e.sort(), t.sort();
                        for(var r = 0, n = e.length; r < n; r++)if (e[r] !== t[r]) return !1;
                        return !0;
                    }
                    function h(e) {
                        return e.replace(/^\/+|\/+$/g, "");
                    }
                    function y(e) {
                        return escape(e);
                    }
                    function m(e) {
                        return encodeURIComponent(e).replace(/[!'()*]/g, y).replace(/\*/g, "%2A");
                    }
                    i._parts = function() {
                        return {
                            protocol: null,
                            username: null,
                            password: null,
                            hostname: null,
                            urn: null,
                            port: null,
                            path: null,
                            query: null,
                            fragment: null,
                            preventInvalidHostname: i.preventInvalidHostname,
                            duplicateQueryParameters: i.duplicateQueryParameters,
                            escapeQuerySpace: i.escapeQuerySpace
                        };
                    }, i.preventInvalidHostname = !1, i.duplicateQueryParameters = !1, i.escapeQuerySpace = !0, i.protocol_expression = /^[a-z][a-z0-9.+-]*$/i, i.idn_expression = /[^a-z0-9\._-]/i, i.punycode_expression = /(xn--)/i, i.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, i.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, i.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?\xab\xbb\u201c\u201d\u2018\u2019]))/gi, i.findUri = {
                        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
                        end: /[\s\r\n]|$/,
                        trim: /[`!()\[\]{};:'".,<>?\xab\xbb\u201c\u201d\u201e\u2018\u2019]+$/,
                        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
                    }, i.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, i.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g, i.defaultPorts = {
                        http: "80",
                        https: "443",
                        ftp: "21",
                        gopher: "70",
                        ws: "80",
                        wss: "443"
                    }, i.hostProtocols = [
                        "http",
                        "https"
                    ], i.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/, i.domAttributes = {
                        a: "href",
                        blockquote: "cite",
                        link: "href",
                        base: "href",
                        script: "src",
                        form: "action",
                        img: "src",
                        area: "href",
                        iframe: "src",
                        embed: "src",
                        source: "src",
                        track: "src",
                        input: "src",
                        audio: "src",
                        video: "src"
                    }, i.getDomAttribute = function(e) {
                        if (e && e.nodeName) {
                            var t = e.nodeName.toLowerCase();
                            if ("input" !== t || "image" === e.type) return i.domAttributes[t];
                        }
                    }, i.encode = m, i.decode = decodeURIComponent, i.iso8859 = function() {
                        i.encode = escape, i.decode = unescape;
                    }, i.unicode = function() {
                        i.encode = m, i.decode = decodeURIComponent;
                    }, i.characters = {
                        pathname: {
                            encode: {
                                expression: /%(24|26|2B|2C|3B|3D|3A|40)/gi,
                                map: {
                                    "%24": "$",
                                    "%26": "&",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "=",
                                    "%3A": ":",
                                    "%40": "@"
                                }
                            },
                            decode: {
                                expression: /[\/\?#]/g,
                                map: {
                                    "/": "%2F",
                                    "?": "%3F",
                                    "#": "%23"
                                }
                            }
                        },
                        reserved: {
                            encode: {
                                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/gi,
                                map: {
                                    "%3A": ":",
                                    "%2F": "/",
                                    "%3F": "?",
                                    "%23": "#",
                                    "%5B": "[",
                                    "%5D": "]",
                                    "%40": "@",
                                    "%21": "!",
                                    "%24": "$",
                                    "%26": "&",
                                    "%27": "'",
                                    "%28": "(",
                                    "%29": ")",
                                    "%2A": "*",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "="
                                }
                            }
                        },
                        urnpath: {
                            encode: {
                                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/gi,
                                map: {
                                    "%21": "!",
                                    "%24": "$",
                                    "%27": "'",
                                    "%28": "(",
                                    "%29": ")",
                                    "%2A": "*",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "=",
                                    "%40": "@"
                                }
                            },
                            decode: {
                                expression: /[\/\?#:]/g,
                                map: {
                                    "/": "%2F",
                                    "?": "%3F",
                                    "#": "%23",
                                    ":": "%3A"
                                }
                            }
                        }
                    }, i.encodeQuery = function(e, t) {
                        var r = i.encode(e + "");
                        return void 0 === t && (t = i.escapeQuerySpace), t ? r.replace(/%20/g, "+") : r;
                    }, i.decodeQuery = function(e, t) {
                        e += "", void 0 === t && (t = i.escapeQuerySpace);
                        try {
                            return i.decode(t ? e.replace(/\+/g, "%20") : e);
                        } catch (t) {
                            return e;
                        }
                    };
                    var g, v = {
                        encode: "encode",
                        decode: "decode"
                    }, b = function(e, t) {
                        return function(r) {
                            try {
                                return i[t](r + "").replace(i.characters[e][t].expression, function(r) {
                                    return i.characters[e][t].map[r];
                                });
                            } catch (e) {
                                return r;
                            }
                        };
                    };
                    for(g in v)i[g + "PathSegment"] = b("pathname", v[g]), i[g + "UrnPathSegment"] = b("urnpath", v[g]);
                    var w = function(e, t, r) {
                        return function(n) {
                            var o;
                            o = r ? function(e) {
                                return i[t](i[r](e));
                            } : i[t];
                            for(var a = (n + "").split(e), s = 0, u = a.length; s < u; s++)a[s] = o(a[s]);
                            return a.join(e);
                        };
                    };
                    function S(e) {
                        return function(t, r) {
                            return void 0 === t ? this._parts[e] || "" : (this._parts[e] = t || null, this.build(!r), this);
                        };
                    }
                    function A(e, t) {
                        return function(r, n) {
                            return void 0 === r ? this._parts[e] || "" : (null !== r && (r += "").charAt(0) === t && (r = r.substring(1)), this._parts[e] = r, this.build(!n), this);
                        };
                    }
                    i.decodePath = w("/", "decodePathSegment"), i.decodeUrnPath = w(":", "decodeUrnPathSegment"), i.recodePath = w("/", "encodePathSegment", "decode"), i.recodeUrnPath = w(":", "encodeUrnPathSegment", "decode"), i.encodeReserved = b("reserved", "encode"), i.parse = function(e, t) {
                        var r;
                        return t || (t = {
                            preventInvalidHostname: i.preventInvalidHostname
                        }), (r = (e = (e = e.replace(i.leading_whitespace_expression, "")).replace(i.ascii_tab_whitespace, "")).indexOf("#")) > -1 && (t.fragment = e.substring(r + 1) || null, e = e.substring(0, r)), (r = e.indexOf("?")) > -1 && (t.query = e.substring(r + 1) || null, e = e.substring(0, r)), "//" === (e = (e = e.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, "$1://")).replace(/^[/\\]{2,}/i, "//")).substring(0, 2) ? (t.protocol = null, e = e.substring(2), e = i.parseAuthority(e, t)) : (r = e.indexOf(":")) > -1 && (t.protocol = e.substring(0, r) || null, t.protocol && !t.protocol.match(i.protocol_expression) ? t.protocol = void 0 : "//" === e.substring(r + 1, r + 3).replace(/\\/g, "/") ? (e = e.substring(r + 3), e = i.parseAuthority(e, t)) : (e = e.substring(r + 1), t.urn = !0)), t.path = e, t;
                    }, i.parseHost = function(e, t) {
                        e || (e = "");
                        var r, n, o = (e = e.replace(/\\/g, "/")).indexOf("/");
                        if (-1 === o && (o = e.length), "[" === e.charAt(0)) r = e.indexOf("]"), t.hostname = e.substring(1, r) || null, t.port = e.substring(r + 2, o) || null, "/" === t.port && (t.port = null);
                        else {
                            var a = e.indexOf(":"), s = e.indexOf("/"), u = e.indexOf(":", a + 1);
                            -1 !== u && (-1 === s || u < s) ? (t.hostname = e.substring(0, o) || null, t.port = null) : (n = e.substring(0, o).split(":"), t.hostname = n[0] || null, t.port = n[1] || null);
                        }
                        return t.hostname && "/" !== e.substring(o).charAt(0) && (o++, e = "/" + e), t.preventInvalidHostname && i.ensureValidHostname(t.hostname, t.protocol), t.port && i.ensureValidPort(t.port), e.substring(o) || "/";
                    }, i.parseAuthority = function(e, t) {
                        return e = i.parseUserinfo(e, t), i.parseHost(e, t);
                    }, i.parseUserinfo = function(e, t) {
                        var r = e;
                        -1 !== e.indexOf("\\") && (e = e.replace(/\\/g, "/"));
                        var n, o = e.indexOf("/"), a = e.lastIndexOf("@", o > -1 ? o : e.length - 1);
                        return a > -1 && (-1 === o || a < o) ? (n = e.substring(0, a).split(":"), t.username = n[0] ? i.decode(n[0]) : null, n.shift(), t.password = n[0] ? i.decode(n.join(":")) : null, e = r.substring(a + 1)) : (t.username = null, t.password = null), e;
                    }, i.parseQuery = function(e, t) {
                        if (!e) return {};
                        if (!(e = e.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, ""))) return {};
                        for(var r, n, o, a = {}, u = e.split("&"), c = u.length, l = 0; l < c; l++)r = u[l].split("="), n = i.decodeQuery(r.shift(), t), o = r.length ? i.decodeQuery(r.join("="), t) : null, "__proto__" !== n && (s.call(a, n) ? ("string" != typeof a[n] && null !== a[n] || (a[n] = [
                            a[n]
                        ]), a[n].push(o)) : a[n] = o);
                        return a;
                    }, i.build = function(e) {
                        var t = "", r = !1;
                        return e.protocol && (t += e.protocol + ":"), e.urn || !t && !e.hostname || (t += "//", r = !0), t += i.buildAuthority(e) || "", "string" == typeof e.path && ("/" !== e.path.charAt(0) && r && (t += "/"), t += e.path), "string" == typeof e.query && e.query && (t += "?" + e.query), "string" == typeof e.fragment && e.fragment && (t += "#" + e.fragment), t;
                    }, i.buildHost = function(e) {
                        var t = "";
                        return e.hostname ? (i.ip6_expression.test(e.hostname) ? t += "[" + e.hostname + "]" : t += e.hostname, e.port && (t += ":" + e.port), t) : "";
                    }, i.buildAuthority = function(e) {
                        return i.buildUserinfo(e) + i.buildHost(e);
                    }, i.buildUserinfo = function(e) {
                        var t = "";
                        return e.username && (t += i.encode(e.username)), e.password && (t += ":" + i.encode(e.password)), t && (t += "@"), t;
                    }, i.buildQuery = function(e, t, r) {
                        var n, o, a, u, c = "";
                        for(o in e)if ("__proto__" !== o && s.call(e, o)) {
                            if (l(e[o])) for(n = {}, a = 0, u = e[o].length; a < u; a++)void 0 !== e[o][a] && void 0 === n[e[o][a] + ""] && (c += "&" + i.buildQueryParameter(o, e[o][a], r), !0 !== t && (n[e[o][a] + ""] = !0));
                            else void 0 !== e[o] && (c += "&" + i.buildQueryParameter(o, e[o], r));
                        }
                        return c.substring(1);
                    }, i.buildQueryParameter = function(e, t, r) {
                        return i.encodeQuery(e, r) + (null !== t ? "=" + i.encodeQuery(t, r) : "");
                    }, i.addQuery = function(e, t, r) {
                        if ("object" == typeof t) for(var n in t)s.call(t, n) && i.addQuery(e, n, t[n]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
                            if (void 0 === e[t]) return void (e[t] = r);
                            "string" == typeof e[t] && (e[t] = [
                                e[t]
                            ]), l(r) || (r = [
                                r
                            ]), e[t] = (e[t] || []).concat(r);
                        }
                    }, i.setQuery = function(e, t, r) {
                        if ("object" == typeof t) for(var n in t)s.call(t, n) && i.setQuery(e, n, t[n]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
                            e[t] = void 0 === r ? null : r;
                        }
                    }, i.removeQuery = function(e, t, r) {
                        var n, o, a;
                        if (l(t)) for(n = 0, o = t.length; n < o; n++)e[t[n]] = void 0;
                        else if ("RegExp" === c(t)) for(a in e)t.test(a) && (e[a] = void 0);
                        else if ("object" == typeof t) for(a in t)s.call(t, a) && i.removeQuery(e, a, t[a]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
                            void 0 !== r ? "RegExp" === c(r) ? !l(e[t]) && r.test(e[t]) ? e[t] = void 0 : e[t] = f(e[t], r) : e[t] !== String(r) || l(r) && 1 !== r.length ? l(e[t]) && (e[t] = f(e[t], r)) : e[t] = void 0 : e[t] = void 0;
                        }
                    }, i.hasQuery = function(e, t, r, n) {
                        switch(c(t)){
                            case "String":
                                break;
                            case "RegExp":
                                for(var o in e)if (s.call(e, o) && t.test(o) && (void 0 === r || i.hasQuery(e, o, r))) return !0;
                                return !1;
                            case "Object":
                                for(var a in t)if (s.call(t, a) && !i.hasQuery(e, a, t[a])) return !1;
                                return !0;
                            default:
                                throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
                        }
                        switch(c(r)){
                            case "Undefined":
                                return t in e;
                            case "Boolean":
                                return r === Boolean(l(e[t]) ? e[t].length : e[t]);
                            case "Function":
                                return !!r(e[t], t, e);
                            case "Array":
                                return !!l(e[t]) && (n ? p : d)(e[t], r);
                            case "RegExp":
                                return l(e[t]) ? !!n && p(e[t], r) : Boolean(e[t] && e[t].match(r));
                            case "Number":
                                r = String(r);
                            case "String":
                                return l(e[t]) ? !!n && p(e[t], r) : e[t] === r;
                            default:
                                throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
                        }
                    }, i.joinPaths = function() {
                        for(var e = [], t = [], r = 0, n = 0; n < arguments.length; n++){
                            var o = new i(arguments[n]);
                            e.push(o);
                            for(var a = o.segment(), s = 0; s < a.length; s++)"string" == typeof a[s] && t.push(a[s]), a[s] && r++;
                        }
                        if (!t.length || !r) return new i("");
                        var u = new i("").segment(t);
                        return "" !== e[0].path() && "/" !== e[0].path().slice(0, 1) || u.path("/" + u.path()), u.normalize();
                    }, i.commonPath = function(e, t) {
                        var r, n = Math.min(e.length, t.length);
                        for(r = 0; r < n; r++)if (e.charAt(r) !== t.charAt(r)) {
                            r--;
                            break;
                        }
                        return r < 1 ? e.charAt(0) === t.charAt(0) && "/" === e.charAt(0) ? "/" : "" : ("/" === e.charAt(r) && "/" === t.charAt(r) || (r = e.substring(0, r).lastIndexOf("/")), e.substring(0, r + 1));
                    }, i.withinString = function(e, t, r) {
                        r || (r = {});
                        var n = r.start || i.findUri.start, o = r.end || i.findUri.end, a = r.trim || i.findUri.trim, s = r.parens || i.findUri.parens, u = /[a-z0-9-]=["']?$/i;
                        for(n.lastIndex = 0;;){
                            var c = n.exec(e);
                            if (!c) break;
                            var l = c.index;
                            if (r.ignoreHtml) {
                                var f = e.slice(Math.max(l - 3, 0), l);
                                if (f && u.test(f)) continue;
                            }
                            for(var p = l + e.slice(l).search(o), d = e.slice(l, p), h = -1;;){
                                var y = s.exec(d);
                                if (!y) break;
                                var m = y.index + y[0].length;
                                h = Math.max(h, m);
                            }
                            if (!((d = h > -1 ? d.slice(0, h) + d.slice(h).replace(a, "") : d.replace(a, "")).length <= c[0].length || r.ignore && r.ignore.test(d))) {
                                var g = t(d, l, p = l + d.length, e);
                                void 0 !== g ? (g = String(g), e = e.slice(0, l) + g + e.slice(p), n.lastIndex = l + g.length) : n.lastIndex = p;
                            }
                        }
                        return n.lastIndex = 0, e;
                    }, i.ensureValidHostname = function(t, r) {
                        var n = !!t, o = !1;
                        if (!!r && (o = p(i.hostProtocols, r)), o && !n) throw new TypeError("Hostname cannot be empty, if protocol is " + r);
                        if (t && t.match(i.invalid_hostname_characters)) {
                            if (!e) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
                            if (e.toASCII(t).match(i.invalid_hostname_characters)) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_]');
                        }
                    }, i.ensureValidPort = function(e) {
                        if (e) {
                            var t = Number(e);
                            if (!(/^[0-9]+$/.test(t) && t > 0 && t < 65536)) throw new TypeError('Port "' + e + '" is not a valid port');
                        }
                    }, i.noConflict = function(e) {
                        if (e) {
                            var t = {
                                URI: this.noConflict()
                            };
                            return n.URITemplate && "function" == typeof n.URITemplate.noConflict && (t.URITemplate = n.URITemplate.noConflict()), n.IPv6 && "function" == typeof n.IPv6.noConflict && (t.IPv6 = n.IPv6.noConflict()), n.SecondLevelDomains && "function" == typeof n.SecondLevelDomains.noConflict && (t.SecondLevelDomains = n.SecondLevelDomains.noConflict()), t;
                        }
                        return n.URI === this && (n.URI = o), this;
                    }, a.build = function(e) {
                        return !0 === e ? this._deferred_build = !0 : (void 0 === e || this._deferred_build) && (this._string = i.build(this._parts), this._deferred_build = !1), this;
                    }, a.clone = function() {
                        return new i(this);
                    }, a.valueOf = a.toString = function() {
                        return this.build(!1)._string;
                    }, a.protocol = S("protocol"), a.username = S("username"), a.password = S("password"), a.hostname = S("hostname"), a.port = S("port"), a.query = A("query", "?"), a.fragment = A("fragment", "#"), a.search = function(e, t) {
                        var r = this.query(e, t);
                        return "string" == typeof r && r.length ? "?" + r : r;
                    }, a.hash = function(e, t) {
                        var r = this.fragment(e, t);
                        return "string" == typeof r && r.length ? "#" + r : r;
                    }, a.pathname = function(e, t) {
                        if (void 0 === e || !0 === e) {
                            var r = this._parts.path || (this._parts.hostname ? "/" : "");
                            return e ? (this._parts.urn ? i.decodeUrnPath : i.decodePath)(r) : r;
                        }
                        return this._parts.urn ? this._parts.path = e ? i.recodeUrnPath(e) : "" : this._parts.path = e ? i.recodePath(e) : "/", this.build(!t), this;
                    }, a.path = a.pathname, a.href = function(e, t) {
                        var r;
                        if (void 0 === e) return this.toString();
                        this._string = "", this._parts = i._parts();
                        var n = e instanceof i, o = "object" == typeof e && (e.hostname || e.path || e.pathname);
                        e.nodeName && (e = e[i.getDomAttribute(e)] || "", o = !1);
                        if (!n && o && void 0 !== e.pathname && (e = e.toString()), "string" == typeof e || e instanceof String) this._parts = i.parse(String(e), this._parts);
                        else {
                            if (!n && !o) throw new TypeError("invalid input");
                            var a = n ? e._parts : e;
                            for(r in a)"query" !== r && s.call(this._parts, r) && (this._parts[r] = a[r]);
                            a.query && this.query(a.query, !1);
                        }
                        return this.build(!t), this;
                    }, a.is = function(e) {
                        var t = !1, n = !1, o = !1, a = !1, s = !1, u = !1, c = !1, l = !this._parts.urn;
                        switch(this._parts.hostname && (l = !1, n = i.ip4_expression.test(this._parts.hostname), o = i.ip6_expression.test(this._parts.hostname), s = (a = !(t = n || o)) && r && r.has(this._parts.hostname), u = a && i.idn_expression.test(this._parts.hostname), c = a && i.punycode_expression.test(this._parts.hostname)), e.toLowerCase()){
                            case "relative":
                                return l;
                            case "absolute":
                                return !l;
                            case "domain":
                            case "name":
                                return a;
                            case "sld":
                                return s;
                            case "ip":
                                return t;
                            case "ip4":
                            case "ipv4":
                            case "inet4":
                                return n;
                            case "ip6":
                            case "ipv6":
                            case "inet6":
                                return o;
                            case "idn":
                                return u;
                            case "url":
                                return !this._parts.urn;
                            case "urn":
                                return !!this._parts.urn;
                            case "punycode":
                                return c;
                        }
                        return null;
                    };
                    var E = a.protocol, T = a.port, O = a.hostname;
                    a.protocol = function(e, t) {
                        if (e && !(e = e.replace(/:(\/\/)?$/, "")).match(i.protocol_expression)) throw new TypeError('Protocol "' + e + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
                        return E.call(this, e, t);
                    }, a.scheme = a.protocol, a.port = function(e, t) {
                        return this._parts.urn ? void 0 === e ? "" : this : (void 0 !== e && (0 === e && (e = null), e && (":" === (e += "").charAt(0) && (e = e.substring(1)), i.ensureValidPort(e))), T.call(this, e, t));
                    }, a.hostname = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 !== e) {
                            var r = {
                                preventInvalidHostname: this._parts.preventInvalidHostname
                            };
                            if ("/" !== i.parseHost(e, r)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                            e = r.hostname, this._parts.preventInvalidHostname && i.ensureValidHostname(e, this._parts.protocol);
                        }
                        return O.call(this, e, t);
                    }, a.origin = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            var r = this.protocol();
                            return this.authority() ? (r ? r + "://" : "") + this.authority() : "";
                        }
                        var n = i(e);
                        return this.protocol(n.protocol()).authority(n.authority()).build(!t), this;
                    }, a.host = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) return this._parts.hostname ? i.buildHost(this._parts) : "";
                        if ("/" !== i.parseHost(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                        return this.build(!t), this;
                    }, a.authority = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) return this._parts.hostname ? i.buildAuthority(this._parts) : "";
                        if ("/" !== i.parseAuthority(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                        return this.build(!t), this;
                    }, a.userinfo = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            var r = i.buildUserinfo(this._parts);
                            return r ? r.substring(0, r.length - 1) : r;
                        }
                        return "@" !== e[e.length - 1] && (e += "@"), i.parseUserinfo(e, this._parts), this.build(!t), this;
                    }, a.resource = function(e, t) {
                        var r;
                        return void 0 === e ? this.path() + this.search() + this.hash() : (r = i.parse(e), this._parts.path = r.path, this._parts.query = r.query, this._parts.fragment = r.fragment, this.build(!t), this);
                    }, a.subdomain = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var r = this._parts.hostname.length - this.domain().length - 1;
                            return this._parts.hostname.substring(0, r) || "";
                        }
                        var n = this._parts.hostname.length - this.domain().length, o = this._parts.hostname.substring(0, n), a = new RegExp("^" + u(o));
                        if (e && "." !== e.charAt(e.length - 1) && (e += "."), -1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
                        return e && i.ensureValidHostname(e, this._parts.protocol), this._parts.hostname = this._parts.hostname.replace(a, e), this.build(!t), this;
                    }, a.domain = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var r = this._parts.hostname.match(/\./g);
                            if (r && r.length < 2) return this._parts.hostname;
                            var n = this._parts.hostname.length - this.tld(t).length - 1;
                            return n = this._parts.hostname.lastIndexOf(".", n - 1) + 1, this._parts.hostname.substring(n) || "";
                        }
                        if (!e) throw new TypeError("cannot set domain empty");
                        if (-1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
                        if (i.ensureValidHostname(e, this._parts.protocol), !this._parts.hostname || this.is("IP")) this._parts.hostname = e;
                        else {
                            var o = new RegExp(u(this.domain()) + "$");
                            this._parts.hostname = this._parts.hostname.replace(o, e);
                        }
                        return this.build(!t), this;
                    }, a.tld = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var n = this._parts.hostname.lastIndexOf("."), o = this._parts.hostname.substring(n + 1);
                            return !0 !== t && r && r.list[o.toLowerCase()] && r.get(this._parts.hostname) || o;
                        }
                        var i;
                        if (!e) throw new TypeError("cannot set TLD empty");
                        if (e.match(/[^a-zA-Z0-9-]/)) {
                            if (!r || !r.is(e)) throw new TypeError('TLD "' + e + '" contains characters other than [A-Z0-9]');
                            i = new RegExp(u(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(i, e);
                        } else {
                            if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
                            i = new RegExp(u(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(i, e);
                        }
                        return this.build(!t), this;
                    }, a.directory = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e || !0 === e) {
                            if (!this._parts.path && !this._parts.hostname) return "";
                            if ("/" === this._parts.path) return "/";
                            var r = this._parts.path.length - this.filename().length - 1, n = this._parts.path.substring(0, r) || (this._parts.hostname ? "/" : "");
                            return e ? i.decodePath(n) : n;
                        }
                        var o = this._parts.path.length - this.filename().length, a = this._parts.path.substring(0, o), s = new RegExp("^" + u(a));
                        return this.is("relative") || (e || (e = "/"), "/" !== e.charAt(0) && (e = "/" + e)), e && "/" !== e.charAt(e.length - 1) && (e += "/"), e = i.recodePath(e), this._parts.path = this._parts.path.replace(s, e), this.build(!t), this;
                    }, a.filename = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("string" != typeof e) {
                            if (!this._parts.path || "/" === this._parts.path) return "";
                            var r = this._parts.path.lastIndexOf("/"), n = this._parts.path.substring(r + 1);
                            return e ? i.decodePathSegment(n) : n;
                        }
                        var o = !1;
                        "/" === e.charAt(0) && (e = e.substring(1)), e.match(/\.?\//) && (o = !0);
                        var a = new RegExp(u(this.filename()) + "$");
                        return e = i.recodePath(e), this._parts.path = this._parts.path.replace(a, e), o ? this.normalizePath(t) : this.build(!t), this;
                    }, a.suffix = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e || !0 === e) {
                            if (!this._parts.path || "/" === this._parts.path) return "";
                            var r, n, o = this.filename(), a = o.lastIndexOf(".");
                            return -1 === a ? "" : (r = o.substring(a + 1), n = /^[a-z0-9%]+$/i.test(r) ? r : "", e ? i.decodePathSegment(n) : n);
                        }
                        "." === e.charAt(0) && (e = e.substring(1));
                        var s, c = this.suffix();
                        if (c) s = e ? new RegExp(u(c) + "$") : new RegExp(u("." + c) + "$");
                        else {
                            if (!e) return this;
                            this._parts.path += "." + i.recodePath(e);
                        }
                        return s && (e = i.recodePath(e), this._parts.path = this._parts.path.replace(s, e)), this.build(!t), this;
                    }, a.segment = function(e, t, r) {
                        var n = this._parts.urn ? ":" : "/", o = this.path(), i = "/" === o.substring(0, 1), a = o.split(n);
                        if (void 0 !== e && "number" != typeof e && (r = t, t = e, e = void 0), void 0 !== e && "number" != typeof e) throw new Error('Bad segment "' + e + '", must be 0-based integer');
                        if (i && a.shift(), e < 0 && (e = Math.max(a.length + e, 0)), void 0 === t) return void 0 === e ? a : a[e];
                        if (null === e || void 0 === a[e]) {
                            if (l(t)) {
                                a = [];
                                for(var s = 0, u = t.length; s < u; s++)(t[s].length || a.length && a[a.length - 1].length) && (a.length && !a[a.length - 1].length && a.pop(), a.push(h(t[s])));
                            } else (t || "string" == typeof t) && (t = h(t), "" === a[a.length - 1] ? a[a.length - 1] = t : a.push(t));
                        } else t ? a[e] = h(t) : a.splice(e, 1);
                        return i && a.unshift(""), this.path(a.join(n), r);
                    }, a.segmentCoded = function(e, t, r) {
                        var n, o, a;
                        if ("number" != typeof e && (r = t, t = e, e = void 0), void 0 === t) {
                            if (l(n = this.segment(e, t, r))) for(o = 0, a = n.length; o < a; o++)n[o] = i.decode(n[o]);
                            else n = void 0 !== n ? i.decode(n) : void 0;
                            return n;
                        }
                        if (l(t)) for(o = 0, a = t.length; o < a; o++)t[o] = i.encode(t[o]);
                        else t = "string" == typeof t || t instanceof String ? i.encode(t) : t;
                        return this.segment(e, t, r);
                    };
                    var k = a.query;
                    return a.query = function(e, t) {
                        if (!0 === e) return i.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        if ("function" == typeof e) {
                            var r = i.parseQuery(this._parts.query, this._parts.escapeQuerySpace), n = e.call(this, r);
                            return this._parts.query = i.buildQuery(n || r, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this;
                        }
                        return void 0 !== e && "string" != typeof e ? (this._parts.query = i.buildQuery(e, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this) : k.call(this, e, t);
                    }, a.setQuery = function(e, t, r) {
                        var n = i.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        if ("string" == typeof e || e instanceof String) n[e] = void 0 !== t ? t : null;
                        else {
                            if ("object" != typeof e) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
                            for(var o in e)s.call(e, o) && (n[o] = e[o]);
                        }
                        return this._parts.query = i.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.addQuery = function(e, t, r) {
                        var n = i.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return i.addQuery(n, e, void 0 === t ? null : t), this._parts.query = i.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.removeQuery = function(e, t, r) {
                        var n = i.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return i.removeQuery(n, e, t), this._parts.query = i.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.hasQuery = function(e, t, r) {
                        var n = i.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return i.hasQuery(n, e, t, r);
                    }, a.setSearch = a.setQuery, a.addSearch = a.addQuery, a.removeSearch = a.removeQuery, a.hasSearch = a.hasQuery, a.normalize = function() {
                        return this._parts.urn ? this.normalizeProtocol(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build() : this.normalizeProtocol(!1).normalizeHostname(!1).normalizePort(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build();
                    }, a.normalizeProtocol = function(e) {
                        return "string" == typeof this._parts.protocol && (this._parts.protocol = this._parts.protocol.toLowerCase(), this.build(!e)), this;
                    }, a.normalizeHostname = function(r) {
                        return this._parts.hostname && (this.is("IDN") && e ? this._parts.hostname = e.toASCII(this._parts.hostname) : this.is("IPv6") && t && (this._parts.hostname = t.best(this._parts.hostname)), this._parts.hostname = this._parts.hostname.toLowerCase(), this.build(!r)), this;
                    }, a.normalizePort = function(e) {
                        return "string" == typeof this._parts.protocol && this._parts.port === i.defaultPorts[this._parts.protocol] && (this._parts.port = null, this.build(!e)), this;
                    }, a.normalizePath = function(e) {
                        var t, r = this._parts.path;
                        if (!r) return this;
                        if (this._parts.urn) return this._parts.path = i.recodeUrnPath(this._parts.path), this.build(!e), this;
                        if ("/" === this._parts.path) return this;
                        var n, o, a = "";
                        for("/" !== (r = i.recodePath(r)).charAt(0) && (t = !0, r = "/" + r), "/.." !== r.slice(-3) && "/." !== r.slice(-2) || (r += "/"), r = r.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/"), t && (a = r.substring(1).match(/^(\.\.\/)+/) || "") && (a = a[0]); -1 !== (n = r.search(/\/\.\.(\/|$)/));)0 !== n ? (-1 === (o = r.substring(0, n).lastIndexOf("/")) && (o = n), r = r.substring(0, o) + r.substring(n + 3)) : r = r.substring(3);
                        return t && this.is("relative") && (r = a + r.substring(1)), this._parts.path = r, this.build(!e), this;
                    }, a.normalizePathname = a.normalizePath, a.normalizeQuery = function(e) {
                        return "string" == typeof this._parts.query && (this._parts.query.length ? this.query(i.parseQuery(this._parts.query, this._parts.escapeQuerySpace)) : this._parts.query = null, this.build(!e)), this;
                    }, a.normalizeFragment = function(e) {
                        return this._parts.fragment || (this._parts.fragment = null, this.build(!e)), this;
                    }, a.normalizeSearch = a.normalizeQuery, a.normalizeHash = a.normalizeFragment, a.iso8859 = function() {
                        var e = i.encode, t = i.decode;
                        i.encode = escape, i.decode = decodeURIComponent;
                        try {
                            this.normalize();
                        } finally{
                            i.encode = e, i.decode = t;
                        }
                        return this;
                    }, a.unicode = function() {
                        var e = i.encode, t = i.decode;
                        i.encode = m, i.decode = unescape;
                        try {
                            this.normalize();
                        } finally{
                            i.encode = e, i.decode = t;
                        }
                        return this;
                    }, a.readable = function() {
                        var t = this.clone();
                        t.username("").password("").normalize();
                        var r = "";
                        if (t._parts.protocol && (r += t._parts.protocol + "://"), t._parts.hostname && (t.is("punycode") && e ? (r += e.toUnicode(t._parts.hostname), t._parts.port && (r += ":" + t._parts.port)) : r += t.host()), t._parts.hostname && t._parts.path && "/" !== t._parts.path.charAt(0) && (r += "/"), r += t.path(!0), t._parts.query) {
                            for(var n = "", o = 0, a = t._parts.query.split("&"), s = a.length; o < s; o++){
                                var u = (a[o] || "").split("=");
                                n += "&" + i.decodeQuery(u[0], this._parts.escapeQuerySpace).replace(/&/g, "%26"), void 0 !== u[1] && (n += "=" + i.decodeQuery(u[1], this._parts.escapeQuerySpace).replace(/&/g, "%26"));
                            }
                            r += "?" + n.substring(1);
                        }
                        return r += i.decodeQuery(t.hash(), !0);
                    }, a.absoluteTo = function(e) {
                        var t, r, n, o = this.clone(), a = [
                            "protocol",
                            "username",
                            "password",
                            "hostname",
                            "port"
                        ];
                        if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
                        if (e instanceof i || (e = new i(e)), o._parts.protocol) return o;
                        if (o._parts.protocol = e._parts.protocol, this._parts.hostname) return o;
                        for(r = 0; n = a[r]; r++)o._parts[n] = e._parts[n];
                        return o._parts.path ? (".." === o._parts.path.substring(-2) && (o._parts.path += "/"), "/" !== o.path().charAt(0) && (t = (t = e.directory()) || (0 === e.path().indexOf("/") ? "/" : ""), o._parts.path = (t ? t + "/" : "") + o._parts.path, o.normalizePath())) : (o._parts.path = e._parts.path, o._parts.query || (o._parts.query = e._parts.query)), o.build(), o;
                    }, a.relativeTo = function(e) {
                        var t, r, n, o, a, s = this.clone().normalize();
                        if (s._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
                        if (e = new i(e).normalize(), t = s._parts, r = e._parts, o = s.path(), a = e.path(), "/" !== o.charAt(0)) throw new Error("URI is already relative");
                        if ("/" !== a.charAt(0)) throw new Error("Cannot calculate a URI relative to another relative URI");
                        if (t.protocol === r.protocol && (t.protocol = null), t.username !== r.username || t.password !== r.password) return s.build();
                        if (null !== t.protocol || null !== t.username || null !== t.password) return s.build();
                        if (t.hostname !== r.hostname || t.port !== r.port) return s.build();
                        if (t.hostname = null, t.port = null, o === a) return t.path = "", s.build();
                        if (!(n = i.commonPath(o, a))) return s.build();
                        var u = r.path.substring(n.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
                        return t.path = u + t.path.substring(n.length) || "./", s.build();
                    }, a.equals = function(e) {
                        var t, r, n, o, a, u = this.clone(), c = new i(e), f = {};
                        if (u.normalize(), c.normalize(), u.toString() === c.toString()) return !0;
                        if (n = u.query(), o = c.query(), u.query(""), c.query(""), u.toString() !== c.toString()) return !1;
                        if (n.length !== o.length) return !1;
                        for(a in t = i.parseQuery(n, this._parts.escapeQuerySpace), r = i.parseQuery(o, this._parts.escapeQuerySpace), t)if (s.call(t, a)) {
                            if (l(t[a])) {
                                if (!d(t[a], r[a])) return !1;
                            } else if (t[a] !== r[a]) return !1;
                            f[a] = !0;
                        }
                        for(a in r)if (s.call(r, a) && !f[a]) return !1;
                        return !0;
                    }, a.preventInvalidHostname = function(e) {
                        return this._parts.preventInvalidHostname = !!e, this;
                    }, a.duplicateQueryParameters = function(e) {
                        return this._parts.duplicateQueryParameters = !!e, this;
                    }, a.escapeQuerySpace = function(e) {
                        return this._parts.escapeQuerySpace = !!e, this;
                    }, i;
                });
            },
            9127 (e, t, r) {
                var n, o, i;
                !function(a, s) {
                    "use strict";
                    e.exports ? e.exports = s(r(4193)) : (o = [
                        r(4193)
                    ], void 0 === (i = "function" == typeof (n = s) ? n.apply(t, o) : n) || (e.exports = i));
                }(0, function(e, t) {
                    "use strict";
                    var r = t && t.URITemplate, n = Object.prototype.hasOwnProperty;
                    function o(e) {
                        return o._cache[e] ? o._cache[e] : this instanceof o ? (this.expression = e, o._cache[e] = this, this) : new o(e);
                    }
                    function i(e) {
                        this.data = e, this.cache = {};
                    }
                    var a = o.prototype, s = {
                        "": {
                            prefix: "",
                            separator: ",",
                            named: !1,
                            empty_name_separator: !1,
                            encode: "encode"
                        },
                        "+": {
                            prefix: "",
                            separator: ",",
                            named: !1,
                            empty_name_separator: !1,
                            encode: "encodeReserved"
                        },
                        "#": {
                            prefix: "#",
                            separator: ",",
                            named: !1,
                            empty_name_separator: !1,
                            encode: "encodeReserved"
                        },
                        ".": {
                            prefix: ".",
                            separator: ".",
                            named: !1,
                            empty_name_separator: !1,
                            encode: "encode"
                        },
                        "/": {
                            prefix: "/",
                            separator: "/",
                            named: !1,
                            empty_name_separator: !1,
                            encode: "encode"
                        },
                        ";": {
                            prefix: ";",
                            separator: ";",
                            named: !0,
                            empty_name_separator: !1,
                            encode: "encode"
                        },
                        "?": {
                            prefix: "?",
                            separator: "&",
                            named: !0,
                            empty_name_separator: !0,
                            encode: "encode"
                        },
                        "&": {
                            prefix: "&",
                            separator: "&",
                            named: !0,
                            empty_name_separator: !0,
                            encode: "encode"
                        }
                    };
                    return o._cache = {}, o.EXPRESSION_PATTERN = /\{([^a-zA-Z0-9%_]?)([^\}]+)(\}|$)/g, o.VARIABLE_PATTERN = /^([^*:.](?:\.?[^*:.])*)((\*)|:(\d+))?$/, o.VARIABLE_NAME_PATTERN = /[^a-zA-Z0-9%_.]/, o.LITERAL_PATTERN = /[<>{}"`^| \\]/, o.expand = function(e, t, r) {
                        var n, i, a, u = s[e.operator], c = u.named ? "Named" : "Unnamed", l = e.variables, f = [];
                        for(a = 0; i = l[a]; a++){
                            if (0 === (n = t.get(i.name)).type && r && r.strict) throw new Error('Missing expansion value for variable "' + i.name + '"');
                            if (n.val.length) {
                                if (n.type > 1 && i.maxlength) throw new Error('Invalid expression: Prefix modifier not applicable to variable "' + i.name + '"');
                                f.push(o["expand" + c](n, u, i.explode, i.explode && u.separator || ",", i.maxlength, i.name));
                            } else n.type && f.push("");
                        }
                        return f.length ? u.prefix + f.join(u.separator) : "";
                    }, o.expandNamed = function(t, r, n, o, i, a) {
                        var s, u, c, l = "", f = r.encode, p = r.empty_name_separator, d = !t[f].length, h = 2 === t.type ? "" : e[f](a);
                        for(u = 0, c = t.val.length; u < c; u++)i ? (s = e[f](t.val[u][1].substring(0, i)), 2 === t.type && (h = e[f](t.val[u][0].substring(0, i)))) : d ? (s = e[f](t.val[u][1]), 2 === t.type ? (h = e[f](t.val[u][0]), t[f].push([
                            h,
                            s
                        ])) : t[f].push([
                            void 0,
                            s
                        ])) : (s = t[f][u][1], 2 === t.type && (h = t[f][u][0])), l && (l += o), n ? l += h + (p || s ? "=" : "") + s : (u || (l += e[f](a) + (p || s ? "=" : "")), 2 === t.type && (l += h + ","), l += s);
                        return l;
                    }, o.expandUnnamed = function(t, r, n, o, i) {
                        var a, s, u, c = "", l = r.encode, f = r.empty_name_separator, p = !t[l].length;
                        for(s = 0, u = t.val.length; s < u; s++)i ? a = e[l](t.val[s][1].substring(0, i)) : p ? (a = e[l](t.val[s][1]), t[l].push([
                            2 === t.type ? e[l](t.val[s][0]) : void 0,
                            a
                        ])) : a = t[l][s][1], c && (c += o), 2 === t.type && (c += i ? e[l](t.val[s][0].substring(0, i)) : t[l][s][0], c += n ? f || a ? "=" : "" : ","), c += a;
                        return c;
                    }, o.noConflict = function() {
                        return t.URITemplate === o && (t.URITemplate = r), o;
                    }, a.expand = function(e, t) {
                        var r = "";
                        this.parts && this.parts.length || this.parse(), e instanceof i || (e = new i(e));
                        for(var n = 0, a = this.parts.length; n < a; n++)r += "string" == typeof this.parts[n] ? this.parts[n] : o.expand(this.parts[n], e, t);
                        return r;
                    }, a.parse = function() {
                        var e, t, r, n = this.expression, i = o.EXPRESSION_PATTERN, a = o.VARIABLE_PATTERN, u = o.VARIABLE_NAME_PATTERN, c = o.LITERAL_PATTERN, l = [], f = 0, p = function(e) {
                            if (e.match(c)) throw new Error('Invalid Literal "' + e + '"');
                            return e;
                        };
                        for(i.lastIndex = 0;;){
                            if (null === (t = i.exec(n))) {
                                l.push(p(n.substring(f)));
                                break;
                            }
                            if (l.push(p(n.substring(f, t.index))), f = t.index + t[0].length, !s[t[1]]) throw new Error('Unknown Operator "' + t[1] + '" in "' + t[0] + '"');
                            if (!t[3]) throw new Error('Unclosed Expression "' + t[0] + '"');
                            for(var d = 0, h = (e = t[2].split(",")).length; d < h; d++){
                                if (null === (r = e[d].match(a))) throw new Error('Invalid Variable "' + e[d] + '" in "' + t[0] + '"');
                                if (r[1].match(u)) throw new Error('Invalid Variable Name "' + r[1] + '" in "' + t[0] + '"');
                                e[d] = {
                                    name: r[1],
                                    explode: !!r[3],
                                    maxlength: r[4] && parseInt(r[4], 10)
                                };
                            }
                            if (!e.length) throw new Error('Expression Missing Variable(s) "' + t[0] + '"');
                            l.push({
                                expression: t[0],
                                operator: t[1],
                                variables: e
                            });
                        }
                        return l.length || l.push(p(n)), this.parts = l, this;
                    }, i.prototype.get = function(e) {
                        var t, r, o, i = this.data, a = {
                            type: 0,
                            val: [],
                            encode: [],
                            encodeReserved: []
                        };
                        if (void 0 !== this.cache[e]) return this.cache[e];
                        if (this.cache[e] = a, null == (o = "[object Function]" === String(Object.prototype.toString.call(i)) ? i(e) : "[object Function]" === String(Object.prototype.toString.call(i[e])) ? i[e](e) : i[e])) return a;
                        if ("[object Array]" === String(Object.prototype.toString.call(o))) {
                            for(t = 0, r = o.length; t < r; t++)void 0 !== o[t] && null !== o[t] && a.val.push([
                                void 0,
                                String(o[t])
                            ]);
                            a.val.length && (a.type = 3);
                        } else if ("[object Object]" === String(Object.prototype.toString.call(o))) {
                            for(t in o)n.call(o, t) && void 0 !== o[t] && null !== o[t] && a.val.push([
                                t,
                                String(o[t])
                            ]);
                            a.val.length && (a.type = 2);
                        } else a.type = 1, a.val.push([
                            void 0,
                            String(o)
                        ]);
                        return a;
                    }, e.expand = function(t, r) {
                        var n = new o(t).expand(r);
                        return new e(n);
                    }, o;
                });
            },
            9340 (e, t, r) {
                var n;
                e = r.nmd(e), function() {
                    t && t.nodeType, e && e.nodeType;
                    var o = "object" == typeof r.g && r.g;
                    o.global !== o && o.window !== o && o.self;
                    var i, a = 2147483647, s = 36, u = /^xn--/, c = /[^\x20-\x7E]/, l = /[\x2E\u3002\uFF0E\uFF61]/g, f = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, p = Math.floor, d = String.fromCharCode;
                    function h(e) {
                        throw new RangeError(f[e]);
                    }
                    function y(e, t) {
                        for(var r = e.length, n = []; r--;)n[r] = t(e[r]);
                        return n;
                    }
                    function m(e, t) {
                        var r = e.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", e = r[1]), n + y((e = e.replace(l, ".")).split("."), t).join(".");
                    }
                    function g(e) {
                        for(var t, r, n = [], o = 0, i = e.length; o < i;)(t = e.charCodeAt(o++)) >= 55296 && t <= 56319 && o < i ? 56320 == (64512 & (r = e.charCodeAt(o++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), o--) : n.push(t);
                        return n;
                    }
                    function v(e) {
                        return y(e, function(e) {
                            var t = "";
                            return e > 65535 && (t += d((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += d(e);
                        }).join("");
                    }
                    function b(e) {
                        return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : s;
                    }
                    function w(e, t) {
                        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                    }
                    function S(e, t, r) {
                        var n = 0;
                        for(e = r ? p(e / 700) : e >> 1, e += p(e / t); e > 455; n += s)e = p(e / 35);
                        return p(n + 36 * e / (e + 38));
                    }
                    function A(e) {
                        var t, r, n, o, i, u, c, l, f, d, y = [], m = e.length, g = 0, w = 128, A = 72;
                        for((r = e.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n)e.charCodeAt(n) >= 128 && h("not-basic"), y.push(e.charCodeAt(n));
                        for(o = r > 0 ? r + 1 : 0; o < m;){
                            for(i = g, u = 1, c = s; o >= m && h("invalid-input"), ((l = b(e.charCodeAt(o++))) >= s || l > p((a - g) / u)) && h("overflow"), g += l * u, !(l < (f = c <= A ? 1 : c >= A + 26 ? 26 : c - A)); c += s)u > p(a / (d = s - f)) && h("overflow"), u *= d;
                            A = S(g - i, t = y.length + 1, 0 == i), p(g / t) > a - w && h("overflow"), w += p(g / t), g %= t, y.splice(g++, 0, w);
                        }
                        return v(y);
                    }
                    function E(e) {
                        var t, r, n, o, i, u, c, l, f, y, m, v, b, A, E, T = [];
                        for(v = (e = g(e)).length, t = 128, r = 0, i = 72, u = 0; u < v; ++u)(m = e[u]) < 128 && T.push(d(m));
                        for(n = o = T.length, o && T.push("-"); n < v;){
                            for(c = a, u = 0; u < v; ++u)(m = e[u]) >= t && m < c && (c = m);
                            for(c - t > p((a - r) / (b = n + 1)) && h("overflow"), r += (c - t) * b, t = c, u = 0; u < v; ++u)if ((m = e[u]) < t && ++r > a && h("overflow"), m == t) {
                                for(l = r, f = s; !(l < (y = f <= i ? 1 : f >= i + 26 ? 26 : f - i)); f += s)E = l - y, A = s - y, T.push(d(w(y + E % A, 0))), l = p(E / A);
                                T.push(d(w(l, 0))), i = S(r, b, n == o), r = 0, ++n;
                            }
                            ++r, ++t;
                        }
                        return T.join("");
                    }
                    i = {
                        version: "1.3.2",
                        ucs2: {
                            decode: g,
                            encode: v
                        },
                        decode: A,
                        encode: E,
                        toASCII: function(e) {
                            return m(e, function(e) {
                                return c.test(e) ? "xn--" + E(e) : e;
                            });
                        },
                        toUnicode: function(e) {
                            return m(e, function(e) {
                                return u.test(e) ? A(e.slice(4).toLowerCase()) : e;
                            });
                        }
                    }, void 0 === (n = (function() {
                        return i;
                    }).call(t, r, t, e)) || (e.exports = n);
                }();
            },
            1270 (e, t, r) {
                var n;
                e = r.nmd(e), function() {
                    t && t.nodeType, e && e.nodeType;
                    var o = "object" == typeof r.g && r.g;
                    o.global !== o && o.window !== o && o.self;
                    var i, a = 2147483647, s = 36, u = /^xn--/, c = /[^\x20-\x7E]/, l = /[\x2E\u3002\uFF0E\uFF61]/g, f = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, p = Math.floor, d = String.fromCharCode;
                    function h(e) {
                        throw new RangeError(f[e]);
                    }
                    function y(e, t) {
                        for(var r = e.length, n = []; r--;)n[r] = t(e[r]);
                        return n;
                    }
                    function m(e, t) {
                        var r = e.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", e = r[1]), n + y((e = e.replace(l, ".")).split("."), t).join(".");
                    }
                    function g(e) {
                        for(var t, r, n = [], o = 0, i = e.length; o < i;)(t = e.charCodeAt(o++)) >= 55296 && t <= 56319 && o < i ? 56320 == (64512 & (r = e.charCodeAt(o++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), o--) : n.push(t);
                        return n;
                    }
                    function v(e) {
                        return y(e, function(e) {
                            var t = "";
                            return e > 65535 && (t += d((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += d(e);
                        }).join("");
                    }
                    function b(e) {
                        return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : s;
                    }
                    function w(e, t) {
                        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                    }
                    function S(e, t, r) {
                        var n = 0;
                        for(e = r ? p(e / 700) : e >> 1, e += p(e / t); e > 455; n += s)e = p(e / 35);
                        return p(n + 36 * e / (e + 38));
                    }
                    function A(e) {
                        var t, r, n, o, i, u, c, l, f, d, y = [], m = e.length, g = 0, w = 128, A = 72;
                        for((r = e.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n)e.charCodeAt(n) >= 128 && h("not-basic"), y.push(e.charCodeAt(n));
                        for(o = r > 0 ? r + 1 : 0; o < m;){
                            for(i = g, u = 1, c = s; o >= m && h("invalid-input"), ((l = b(e.charCodeAt(o++))) >= s || l > p((a - g) / u)) && h("overflow"), g += l * u, !(l < (f = c <= A ? 1 : c >= A + 26 ? 26 : c - A)); c += s)u > p(a / (d = s - f)) && h("overflow"), u *= d;
                            A = S(g - i, t = y.length + 1, 0 == i), p(g / t) > a - w && h("overflow"), w += p(g / t), g %= t, y.splice(g++, 0, w);
                        }
                        return v(y);
                    }
                    function E(e) {
                        var t, r, n, o, i, u, c, l, f, y, m, v, b, A, E, T = [];
                        for(v = (e = g(e)).length, t = 128, r = 0, i = 72, u = 0; u < v; ++u)(m = e[u]) < 128 && T.push(d(m));
                        for(n = o = T.length, o && T.push("-"); n < v;){
                            for(c = a, u = 0; u < v; ++u)(m = e[u]) >= t && m < c && (c = m);
                            for(c - t > p((a - r) / (b = n + 1)) && h("overflow"), r += (c - t) * b, t = c, u = 0; u < v; ++u)if ((m = e[u]) < t && ++r > a && h("overflow"), m == t) {
                                for(l = r, f = s; !(l < (y = f <= i ? 1 : f >= i + 26 ? 26 : f - i)); f += s)E = l - y, A = s - y, T.push(d(w(y + E % A, 0))), l = p(E / A);
                                T.push(d(w(l, 0))), i = S(r, b, n == o), r = 0, ++n;
                            }
                            ++r, ++t;
                        }
                        return T.join("");
                    }
                    i = {
                        version: "1.4.1",
                        ucs2: {
                            decode: g,
                            encode: v
                        },
                        decode: A,
                        encode: E,
                        toASCII: function(e) {
                            return m(e, function(e) {
                                return c.test(e) ? "xn--" + E(e) : e;
                            });
                        },
                        toUnicode: function(e) {
                            return m(e, function(e) {
                                return u.test(e) ? A(e.slice(4).toLowerCase()) : e;
                            });
                        }
                    }, void 0 === (n = (function() {
                        return i;
                    }).call(t, r, t, e)) || (e.exports = n);
                }();
            },
            8835 (e, t, r) {
                "use strict";
                var n = r(1270);
                function o() {
                    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
                }
                var i = /^([a-z0-9.+-]+:)/i, a = /:[0-9]*$/, s = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, u = [
                    "{",
                    "}",
                    "|",
                    "\\",
                    "^",
                    "`"
                ].concat([
                    "<",
                    ">",
                    '"',
                    "`",
                    " ",
                    "\r",
                    "\n",
                    "\t"
                ]), c = [
                    "'"
                ].concat(u), l = [
                    "%",
                    "/",
                    "?",
                    ";",
                    "#"
                ].concat(c), f = [
                    "/",
                    "?",
                    "#"
                ], p = /^[+a-z0-9A-Z_-]{0,63}$/, d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, h = {
                    javascript: !0,
                    "javascript:": !0
                }, y = {
                    javascript: !0,
                    "javascript:": !0
                }, m = {
                    http: !0,
                    https: !0,
                    ftp: !0,
                    gopher: !0,
                    file: !0,
                    "http:": !0,
                    "https:": !0,
                    "ftp:": !0,
                    "gopher:": !0,
                    "file:": !0
                }, g = r(5373);
                function v(e, t, r) {
                    if (e && "object" == typeof e && e instanceof o) return e;
                    var n = new o;
                    return n.parse(e, t, r), n;
                }
                o.prototype.parse = function(e, t, r) {
                    if ("string" != typeof e) throw new TypeError("Parameter 'url' must be a string, not " + typeof e);
                    var o = e.indexOf("?"), a = -1 !== o && o < e.indexOf("#") ? "?" : "#", u = e.split(a);
                    u[0] = u[0].replace(/\\/g, "/");
                    var v = e = u.join(a);
                    if (v = v.trim(), !r && 1 === e.split("#").length) {
                        var b = s.exec(v);
                        if (b) return this.path = v, this.href = v, this.pathname = b[1], b[2] ? (this.search = b[2], this.query = t ? g.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
                    }
                    var w = i.exec(v);
                    if (w) {
                        var S = (w = w[0]).toLowerCase();
                        this.protocol = S, v = v.substr(w.length);
                    }
                    if (r || w || v.match(/^\/\/[^@/]+@[^@/]+/)) {
                        var A = "//" === v.substr(0, 2);
                        !A || w && y[w] || (v = v.substr(2), this.slashes = !0);
                    }
                    if (!y[w] && (A || w && !m[w])) {
                        for(var E, T, O = -1, k = 0; k < f.length; k++)-1 !== (_ = v.indexOf(f[k])) && (-1 === O || _ < O) && (O = _);
                        -1 !== (T = -1 === O ? v.lastIndexOf("@") : v.lastIndexOf("@", O)) && (E = v.slice(0, T), v = v.slice(T + 1), this.auth = decodeURIComponent(E)), O = -1;
                        for(k = 0; k < l.length; k++){
                            var _;
                            -1 !== (_ = v.indexOf(l[k])) && (-1 === O || _ < O) && (O = _);
                        }
                        -1 === O && (O = v.length), this.host = v.slice(0, O), v = v.slice(O), this.parseHost(), this.hostname = this.hostname || "";
                        var x = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                        if (!x) for(var P = this.hostname.split(/\./), R = (k = 0, P.length); k < R; k++){
                            var I = P[k];
                            if (I && !I.match(p)) {
                                for(var B = "", C = 0, j = I.length; C < j; C++)I.charCodeAt(C) > 127 ? B += "x" : B += I[C];
                                if (!B.match(p)) {
                                    var U = P.slice(0, k), N = P.slice(k + 1), L = I.match(d);
                                    L && (U.push(L[1]), N.unshift(L[2])), N.length && (v = "/" + N.join(".") + v), this.hostname = U.join(".");
                                    break;
                                }
                            }
                        }
                        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), x || (this.hostname = n.toASCII(this.hostname));
                        var F = this.port ? ":" + this.port : "", D = this.hostname || "";
                        this.host = D + F, this.href += this.host, x && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== v[0] && (v = "/" + v));
                    }
                    if (!h[S]) for(k = 0, R = c.length; k < R; k++){
                        var M = c[k];
                        if (-1 !== v.indexOf(M)) {
                            var V = encodeURIComponent(M);
                            V === M && (V = escape(M)), v = v.split(M).join(V);
                        }
                    }
                    var q = v.indexOf("#");
                    -1 !== q && (this.hash = v.substr(q), v = v.slice(0, q));
                    var G = v.indexOf("?");
                    if (-1 !== G ? (this.search = v.substr(G), this.query = v.substr(G + 1), t && (this.query = g.parse(this.query)), v = v.slice(0, G)) : t && (this.search = "", this.query = {}), v && (this.pathname = v), m[S] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                        F = this.pathname || "";
                        var H = this.search || "";
                        this.path = F + H;
                    }
                    return this.href = this.format(), this;
                }, o.prototype.format = function() {
                    var e = this.auth || "";
                    e && (e = (e = encodeURIComponent(e)).replace(/%3A/i, ":"), e += "@");
                    var t = this.protocol || "", r = this.pathname || "", n = this.hash || "", o = !1, i = "";
                    this.host ? o = e + this.host : this.hostname && (o = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && "object" == typeof this.query && Object.keys(this.query).length && (i = g.stringify(this.query, {
                        arrayFormat: "repeat",
                        addQueryPrefix: !1
                    }));
                    var a = this.search || i && "?" + i || "";
                    return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || m[t]) && !1 !== o ? (o = "//" + (o || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : o || (o = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), t + o + (r = r.replace(/[?#]/g, function(e) {
                        return encodeURIComponent(e);
                    })) + (a = a.replace("#", "%23")) + n;
                }, o.prototype.resolve = function(e) {
                    return this.resolveObject(v(e, !1, !0)).format();
                }, o.prototype.resolveObject = function(e) {
                    if ("string" == typeof e) {
                        var t = new o;
                        t.parse(e, !1, !0), e = t;
                    }
                    for(var r = new o, n = Object.keys(this), i = 0; i < n.length; i++){
                        var a = n[i];
                        r[a] = this[a];
                    }
                    if (r.hash = e.hash, "" === e.href) return r.href = r.format(), r;
                    if (e.slashes && !e.protocol) {
                        for(var s = Object.keys(e), u = 0; u < s.length; u++){
                            var c = s[u];
                            "protocol" !== c && (r[c] = e[c]);
                        }
                        return m[r.protocol] && r.hostname && !r.pathname && (r.pathname = "/", r.path = r.pathname), r.href = r.format(), r;
                    }
                    if (e.protocol && e.protocol !== r.protocol) {
                        if (!m[e.protocol]) {
                            for(var l = Object.keys(e), f = 0; f < l.length; f++){
                                var p = l[f];
                                r[p] = e[p];
                            }
                            return r.href = r.format(), r;
                        }
                        if (r.protocol = e.protocol, e.host || y[e.protocol]) r.pathname = e.pathname;
                        else {
                            for(var d = (e.pathname || "").split("/"); d.length && !(e.host = d.shift()););
                            e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), r.pathname = d.join("/");
                        }
                        if (r.search = e.search, r.query = e.query, r.host = e.host || "", r.auth = e.auth, r.hostname = e.hostname || e.host, r.port = e.port, r.pathname || r.search) {
                            var h = r.pathname || "", g = r.search || "";
                            r.path = h + g;
                        }
                        return r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
                    }
                    var v = r.pathname && "/" === r.pathname.charAt(0), b = e.host || e.pathname && "/" === e.pathname.charAt(0), w = b || v || r.host && e.pathname, S = w, A = r.pathname && r.pathname.split("/") || [], E = (d = e.pathname && e.pathname.split("/") || [], r.protocol && !m[r.protocol]);
                    if (E && (r.hostname = "", r.port = null, r.host && ("" === A[0] ? A[0] = r.host : A.unshift(r.host)), r.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === d[0] ? d[0] = e.host : d.unshift(e.host)), e.host = null), w = w && ("" === d[0] || "" === A[0])), b) r.host = e.host || "" === e.host ? e.host : r.host, r.hostname = e.hostname || "" === e.hostname ? e.hostname : r.hostname, r.search = e.search, r.query = e.query, A = d;
                    else if (d.length) A || (A = []), A.pop(), A = A.concat(d), r.search = e.search, r.query = e.query;
                    else if (null != e.search) {
                        if (E) r.host = A.shift(), r.hostname = r.host, (x = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = x.shift(), r.hostname = x.shift(), r.host = r.hostname);
                        return r.search = e.search, r.query = e.query, null === r.pathname && null === r.search || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
                    }
                    if (!A.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
                    for(var T = A.slice(-1)[0], O = (r.host || e.host || A.length > 1) && ("." === T || ".." === T) || "" === T, k = 0, _ = A.length; _ >= 0; _--)"." === (T = A[_]) ? A.splice(_, 1) : ".." === T ? (A.splice(_, 1), k++) : k && (A.splice(_, 1), k--);
                    if (!w && !S) for(; k--; k)A.unshift("..");
                    !w || "" === A[0] || A[0] && "/" === A[0].charAt(0) || A.unshift(""), O && "/" !== A.join("/").substr(-1) && A.push("");
                    var x, P = "" === A[0] || A[0] && "/" === A[0].charAt(0);
                    E && (r.hostname = P ? "" : A.length ? A.shift() : "", r.host = r.hostname, (x = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = x.shift(), r.hostname = x.shift(), r.host = r.hostname));
                    return (w = w || r.host && A.length) && !P && A.unshift(""), A.length > 0 ? r.pathname = A.join("/") : (r.pathname = null, r.path = null), null === r.pathname && null === r.search || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = e.auth || r.auth, r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
                }, o.prototype.parseHost = function() {
                    var e = this.host, t = a.exec(e);
                    t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
                }, t.parse = v, t.resolve = function(e, t) {
                    return v(e, !1, !0).resolve(t);
                }, t.resolveObject = function(e, t) {
                    return e ? v(e, !1, !0).resolveObject(t) : t;
                }, t.format = function(e) {
                    return "string" == typeof e && (e = v(e)), e instanceof o ? e.format() : o.prototype.format.call(e);
                }, t.Url = o;
            },
            4643 (e, t, r) {
                function n(e) {
                    try {
                        if (!r.g.localStorage) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var t = r.g.localStorage[e];
                    return null != t && "true" === String(t).toLowerCase();
                }
                e.exports = function(e, t) {
                    if (n("noDeprecation")) return e;
                    var r = !1;
                    return function() {
                        if (!r) {
                            if (n("throwDeprecation")) throw new Error(t);
                            n("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
            },
            1135 (e) {
                e.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            9032 (e, t, r) {
                "use strict";
                var n = r(7244), o = r(8184), i = r(5767), a = r(5680);
                function s(e) {
                    return e.call.bind(e);
                }
                var u = "undefined" != typeof BigInt, c = "undefined" != typeof Symbol, l = s(Object.prototype.toString), f = s(Number.prototype.valueOf), p = s(String.prototype.valueOf), d = s(Boolean.prototype.valueOf);
                if (u) var h = s(BigInt.prototype.valueOf);
                if (c) var y = s(Symbol.prototype.valueOf);
                function m(e, t) {
                    if ("object" != typeof e) return !1;
                    try {
                        return t(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function g(e) {
                    return "[object Map]" === l(e);
                }
                function v(e) {
                    return "[object Set]" === l(e);
                }
                function b(e) {
                    return "[object WeakMap]" === l(e);
                }
                function w(e) {
                    return "[object WeakSet]" === l(e);
                }
                function S(e) {
                    return "[object ArrayBuffer]" === l(e);
                }
                function A(e) {
                    return "undefined" != typeof ArrayBuffer && (S.working ? S(e) : e instanceof ArrayBuffer);
                }
                function E(e) {
                    return "[object DataView]" === l(e);
                }
                function T(e) {
                    return "undefined" != typeof DataView && (E.working ? E(e) : e instanceof DataView);
                }
                t.isArgumentsObject = n, t.isGeneratorFunction = o, t.isTypedArray = a, t.isPromise = function(e) {
                    return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" == typeof e && "function" == typeof e.then && "function" == typeof e.catch;
                }, t.isArrayBufferView = function(e) {
                    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : a(e) || T(e);
                }, t.isUint8Array = function(e) {
                    return "Uint8Array" === i(e);
                }, t.isUint8ClampedArray = function(e) {
                    return "Uint8ClampedArray" === i(e);
                }, t.isUint16Array = function(e) {
                    return "Uint16Array" === i(e);
                }, t.isUint32Array = function(e) {
                    return "Uint32Array" === i(e);
                }, t.isInt8Array = function(e) {
                    return "Int8Array" === i(e);
                }, t.isInt16Array = function(e) {
                    return "Int16Array" === i(e);
                }, t.isInt32Array = function(e) {
                    return "Int32Array" === i(e);
                }, t.isFloat32Array = function(e) {
                    return "Float32Array" === i(e);
                }, t.isFloat64Array = function(e) {
                    return "Float64Array" === i(e);
                }, t.isBigInt64Array = function(e) {
                    return "BigInt64Array" === i(e);
                }, t.isBigUint64Array = function(e) {
                    return "BigUint64Array" === i(e);
                }, g.working = "undefined" != typeof Map && g(new Map), t.isMap = function(e) {
                    return "undefined" != typeof Map && (g.working ? g(e) : e instanceof Map);
                }, v.working = "undefined" != typeof Set && v(new Set), t.isSet = function(e) {
                    return "undefined" != typeof Set && (v.working ? v(e) : e instanceof Set);
                }, b.working = "undefined" != typeof WeakMap && b(new WeakMap), t.isWeakMap = function(e) {
                    return "undefined" != typeof WeakMap && (b.working ? b(e) : e instanceof WeakMap);
                }, w.working = "undefined" != typeof WeakSet && w(new WeakSet), t.isWeakSet = function(e) {
                    return w(e);
                }, S.working = "undefined" != typeof ArrayBuffer && S(new ArrayBuffer), t.isArrayBuffer = A, E.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && E(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = T;
                var O = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
                function k(e) {
                    return "[object SharedArrayBuffer]" === l(e);
                }
                function _(e) {
                    return void 0 !== O && (void 0 === k.working && (k.working = k(new O)), k.working ? k(e) : e instanceof O);
                }
                function x(e) {
                    return m(e, f);
                }
                function P(e) {
                    return m(e, p);
                }
                function R(e) {
                    return m(e, d);
                }
                function I(e) {
                    return u && m(e, h);
                }
                function B(e) {
                    return c && m(e, y);
                }
                t.isSharedArrayBuffer = _, t.isAsyncFunction = function(e) {
                    return "[object AsyncFunction]" === l(e);
                }, t.isMapIterator = function(e) {
                    return "[object Map Iterator]" === l(e);
                }, t.isSetIterator = function(e) {
                    return "[object Set Iterator]" === l(e);
                }, t.isGeneratorObject = function(e) {
                    return "[object Generator]" === l(e);
                }, t.isWebAssemblyCompiledModule = function(e) {
                    return "[object WebAssembly.Module]" === l(e);
                }, t.isNumberObject = x, t.isStringObject = P, t.isBooleanObject = R, t.isBigIntObject = I, t.isSymbolObject = B, t.isBoxedPrimitive = function(e) {
                    return x(e) || P(e) || R(e) || I(e) || B(e);
                }, t.isAnyArrayBuffer = function(e) {
                    return "undefined" != typeof Uint8Array && (A(e) || _(e));
                }, [
                    "isProxy",
                    "isExternal",
                    "isModuleNamespaceObject"
                ].forEach(function(e) {
                    Object.defineProperty(t, e, {
                        enumerable: !1,
                        value: function() {
                            throw new Error(e + " is not supported in userland");
                        }
                    });
                });
            },
            537 (e, t, r) {
                var n = Object.getOwnPropertyDescriptors || function(e) {
                    for(var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
                    return r;
                }, o = /%[sdj%]/g;
                t.format = function(e) {
                    if (!v(e)) {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(u(arguments[r]));
                        return t.join(" ");
                    }
                    r = 1;
                    for(var n = arguments, i = n.length, a = String(e).replace(o, function(e) {
                        if ("%%" === e) return "%";
                        if (r >= i) return e;
                        switch(e){
                            case "%s":
                                return String(n[r++]);
                            case "%d":
                                return Number(n[r++]);
                            case "%j":
                                try {
                                    return JSON.stringify(n[r++]);
                                } catch (e) {
                                    return "[Circular]";
                                }
                            default:
                                return e;
                        }
                    }), s = n[r]; r < i; s = n[++r])m(s) || !S(s) ? a += " " + s : a += " " + u(s);
                    return a;
                }, t.deprecate = function(e, r) {
                    var n;
                    return function() {
                        return t.deprecate(e, r).apply(this, arguments);
                    };
                };
                var i = {}, a = /^$/;
                var s;
                function u(e, r) {
                    var n = {
                        seen: [],
                        stylize: l
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), y(r) ? n.showHidden = r : r && t._extend(n, r), b(n.showHidden) && (n.showHidden = !1), b(n.depth) && (n.depth = 2), b(n.colors) && (n.colors = !1), b(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = c), f(n, e, n.depth);
                }
                function c(e, t) {
                    var r = u.styles[t];
                    return r ? "\x1b[" + u.colors[r][0] + "m" + e + "\x1b[" + u.colors[r][1] + "m" : e;
                }
                function l(e, t) {
                    return e;
                }
                function f(e, r, n) {
                    if (e.customInspect && r && T(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var o = r.inspect(n, e);
                        return v(o) || (o = f(e, o, n)), o;
                    }
                    var i = function(e, t) {
                        if (b(t)) return e.stylize("undefined", "undefined");
                        if (v(t)) {
                            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                            return e.stylize(r, "string");
                        }
                        if (g(t)) return e.stylize("" + t, "number");
                        if (y(t)) return e.stylize("" + t, "boolean");
                        if (m(t)) return e.stylize("null", "null");
                    }(e, r);
                    if (i) return i;
                    var a = Object.keys(r), s = function(e) {
                        var t = {};
                        return e.forEach(function(e, r) {
                            t[e] = !0;
                        }), t;
                    }(a);
                    if (e.showHidden && (a = Object.getOwnPropertyNames(r)), E(r) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return p(r);
                    if (0 === a.length) {
                        if (T(r)) {
                            var u = r.name ? ": " + r.name : "";
                            return e.stylize("[Function" + u + "]", "special");
                        }
                        if (w(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
                        if (A(r)) return e.stylize(Date.prototype.toString.call(r), "date");
                        if (E(r)) return p(r);
                    }
                    var c, l = "", S = !1, O = [
                        "{",
                        "}"
                    ];
                    (h(r) && (S = !0, O = [
                        "[",
                        "]"
                    ]), T(r)) && (l = " [Function" + (r.name ? ": " + r.name : "") + "]");
                    return w(r) && (l = " " + RegExp.prototype.toString.call(r)), A(r) && (l = " " + Date.prototype.toUTCString.call(r)), E(r) && (l = " " + p(r)), 0 !== a.length || S && 0 != r.length ? n < 0 ? w(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), c = S ? function(e, t, r, n, o) {
                        for(var i = [], a = 0, s = t.length; a < s; ++a)x(t, String(a)) ? i.push(d(e, t, r, n, String(a), !0)) : i.push("");
                        return o.forEach(function(o) {
                            o.match(/^\d+$/) || i.push(d(e, t, r, n, o, !0));
                        }), i;
                    }(e, r, n, s, a) : a.map(function(t) {
                        return d(e, r, n, s, t, S);
                    }), e.seen.pop(), function(e, t, r) {
                        var n = e.reduce(function(e, t) {
                            return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                        }, 0);
                        if (n > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                        return r[0] + t + " " + e.join(", ") + " " + r[1];
                    }(c, l, O)) : O[0] + l + O[1];
                }
                function p(e) {
                    return "[" + Error.prototype.toString.call(e) + "]";
                }
                function d(e, t, r, n, o, i) {
                    var a, s, u;
                    if ((u = Object.getOwnPropertyDescriptor(t, o) || {
                        value: t[o]
                    }).get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), x(n, o) || (a = "[" + o + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = m(r) ? f(e, u.value, null) : f(e, u.value, r - 1)).indexOf("\n") > -1 && (s = i ? s.split("\n").map(function(e) {
                        return "  " + e;
                    }).join("\n").slice(2) : "\n" + s.split("\n").map(function(e) {
                        return "   " + e;
                    }).join("\n")) : s = e.stylize("[Circular]", "special")), b(a)) {
                        if (i && o.match(/^\d+$/)) return s;
                        (a = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.slice(1, -1), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
                    }
                    return a + ": " + s;
                }
                function h(e) {
                    return Array.isArray(e);
                }
                function y(e) {
                    return "boolean" == typeof e;
                }
                function m(e) {
                    return null === e;
                }
                function g(e) {
                    return "number" == typeof e;
                }
                function v(e) {
                    return "string" == typeof e;
                }
                function b(e) {
                    return void 0 === e;
                }
                function w(e) {
                    return S(e) && "[object RegExp]" === O(e);
                }
                function S(e) {
                    return "object" == typeof e && null !== e;
                }
                function A(e) {
                    return S(e) && "[object Date]" === O(e);
                }
                function E(e) {
                    return S(e) && ("[object Error]" === O(e) || e instanceof Error);
                }
                function T(e) {
                    return "function" == typeof e;
                }
                function O(e) {
                    return Object.prototype.toString.call(e);
                }
                function k(e) {
                    return e < 10 ? "0" + e.toString(10) : e.toString(10);
                }
                t.debuglog = function(e) {
                    if (e = e.toUpperCase(), !i[e]) {
                        if (a.test(e)) {
                            var r = $4TNnu.pid;
                            i[e] = function() {
                                var n = t.format.apply(t, arguments);
                                console.error("%s %d: %s", e, r, n);
                            };
                        } else i[e] = function() {};
                    }
                    return i[e];
                }, t.inspect = u, u.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, u.styles = {
                    special: "cyan",
                    number: "yellow",
                    boolean: "yellow",
                    undefined: "grey",
                    null: "bold",
                    string: "green",
                    date: "magenta",
                    regexp: "red"
                }, t.types = r(9032), t.isArray = h, t.isBoolean = y, t.isNull = m, t.isNullOrUndefined = function(e) {
                    return null == e;
                }, t.isNumber = g, t.isString = v, t.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, t.isUndefined = b, t.isRegExp = w, t.types.isRegExp = w, t.isObject = S, t.isDate = A, t.types.isDate = A, t.isError = E, t.types.isNativeError = E, t.isFunction = T, t.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, t.isBuffer = r(1135);
                var _ = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                function x(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.log = function() {
                    var e, r;
                    console.log("%s - %s", (e = new Date, r = [
                        k(e.getHours()),
                        k(e.getMinutes()),
                        k(e.getSeconds())
                    ].join(":"), [
                        e.getDate(),
                        _[e.getMonth()],
                        r
                    ].join(" ")), t.format.apply(t, arguments));
                }, t.inherits = r(6698), t._extend = function(e, t) {
                    if (!t || !S(t)) return e;
                    for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                    return e;
                };
                var P = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
                function R(e, t) {
                    if (!e) {
                        var r = new Error("Promise was rejected with a falsy value");
                        r.reason = e, e = r;
                    }
                    return t(e);
                }
                t.promisify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    if (P && e[P]) {
                        var t;
                        if ("function" != typeof (t = e[P])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        return Object.defineProperty(t, P, {
                            value: t,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }), t;
                    }
                    function t() {
                        for(var t, r, n = new Promise(function(e, n) {
                            t = e, r = n;
                        }), o = [], i = 0; i < arguments.length; i++)o.push(arguments[i]);
                        o.push(function(e, n) {
                            e ? r(e) : t(n);
                        });
                        try {
                            e.apply(this, o);
                        } catch (e) {
                            r(e);
                        }
                        return n;
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), P && Object.defineProperty(t, P, {
                        value: t,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), Object.defineProperties(t, n(e));
                }, t.promisify.custom = P, t.callbackify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    function t() {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(arguments[r]);
                        var n = t.pop();
                        if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");
                        var o = this, i = function() {
                            return n.apply(o, arguments);
                        };
                        e.apply(this, t).then(function(e) {
                            $4TNnu.nextTick(i.bind(null, null, e));
                        }, function(e) {
                            $4TNnu.nextTick(R.bind(null, e, i));
                        });
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, n(e)), t;
                };
            },
            5767 (e, t, r) {
                "use strict";
                var n = r(2682), o = r(9209), i = r(487), a = r(6556), s = r(5795), u = r(3628), c = a("Object.prototype.toString"), l = r(9092)(), f = "undefined" == typeof globalThis ? r.g : globalThis, p = o(), d = a("String.prototype.slice"), h = a("Array.prototype.indexOf", !0) || function(e, t) {
                    for(var r = 0; r < e.length; r += 1)if (e[r] === t) return r;
                    return -1;
                }, y = {
                    __proto__: null
                };
                n(p, l && s && u ? function(e) {
                    var t = new f[e];
                    if (Symbol.toStringTag in t && u) {
                        var r = u(t), n = s(r, Symbol.toStringTag);
                        if (!n && r) {
                            var o = u(r);
                            n = s(o, Symbol.toStringTag);
                        }
                        if (n && n.get) {
                            var a = i(n.get);
                            y["$" + e] = a;
                        }
                    }
                } : function(e) {
                    var t = new f[e], r = t.slice || t.set;
                    if (r) {
                        var n = i(r);
                        y["$" + e] = n;
                    }
                });
                e.exports = function(e) {
                    if (!e || "object" != typeof e) return !1;
                    if (!l) {
                        var t = d(c(e), 8, -1);
                        return h(p, t) > -1 ? t : "Object" === t && function(e) {
                            var t = !1;
                            return n(y, function(r, n) {
                                if (!t) try {
                                    r(e), t = d(n, 1);
                                } catch (e) {}
                            }), t;
                        }(e);
                    }
                    return s ? function(e) {
                        var t = !1;
                        return n(y, function(r, n) {
                            if (!t) try {
                                "$" + r(e) === n && (t = d(n, 1));
                            } catch (e) {}
                        }), t;
                    }(e) : null;
                };
            },
            7510 (e) {
                e.exports = function() {
                    for(var e = {}, r = 0; r < arguments.length; r++){
                        var n = arguments[r];
                        for(var o in n)t.call(n, o) && (e[o] = n[o]);
                    }
                    return e;
                };
                var t = Object.prototype.hasOwnProperty;
            },
            2634 () {},
            9169 () {},
            6833 () {},
            9209 (e, t, r) {
                "use strict";
                var n = r(6578), o = "undefined" == typeof globalThis ? r.g : globalThis;
                e.exports = function() {
                    for(var e = [], t = 0; t < n.length; t++)"function" == typeof o[n[t]] && (e[e.length] = n[t]);
                    return e;
                };
            }
        }, t = {};
        function r(n) {
            var o = t[n];
            if (void 0 !== o) return o.exports;
            var i = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.loaded = !0, i.exports;
        }
        return r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.hmd = (e)=>((e = Object.create(e)).children || (e.children = []), Object.defineProperty(e, "exports", {
                enumerable: !0,
                set: ()=>{
                    throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e.id);
                }
            }), e), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e), r(1924);
    })());

});


parcelRegister("jJRID", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, ()=>(()=>{
        "use strict";
        var r, e, s = {
            d: (r, e)=>{
                for(var t in e)s.o(e, t) && !s.o(r, t) && Object.defineProperty(r, t, {
                    enumerable: !0,
                    get: e[t]
                });
            },
            o: (r, e)=>Object.prototype.hasOwnProperty.call(r, e),
            r: (r)=>{
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(r, "__esModule", {
                    value: !0
                });
            }
        }, t = {};
        s.r(t), s.d(t, {
            WatchWalletChanges: ()=>u,
            addToken: ()=>S,
            default: ()=>D,
            getAddress: ()=>i,
            getNetwork: ()=>C,
            getNetworkDetails: ()=>O,
            isAllowed: ()=>I,
            isBrowser: ()=>U,
            isConnected: ()=>c,
            requestAccess: ()=>w,
            setAllowed: ()=>R,
            signAuthEntry: ()=>N,
            signMessage: ()=>l,
            signTransaction: ()=>d
        }), function(r) {
            r.CREATE_ACCOUNT = "CREATE_ACCOUNT", r.FUND_ACCOUNT = "FUND_ACCOUNT", r.ADD_ACCOUNT = "ADD_ACCOUNT", r.IMPORT_ACCOUNT = "IMPORT_ACCOUNT", r.IMPORT_HARDWARE_WALLET = "IMPORT_HARDWARE_WALLET", r.LOAD_ACCOUNT = "LOAD_ACCOUNT", r.MAKE_ACCOUNT_ACTIVE = "MAKE_ACCOUNT_ACTIVE", r.UPDATE_ACCOUNT_NAME = "UPDATE_ACCOUNT_NAME", r.GET_MNEMONIC_PHRASE = "GET_MNEMONIC_PHRASE", r.CONFIRM_MNEMONIC_PHRASE = "CONFIRM_MNEMONIC_PHRASE", r.CONFIRM_MIGRATED_MNEMONIC_PHRASE = "CONFIRM_MIGRATED_MNEMONIC_PHRASE", r.RECOVER_ACCOUNT = "RECOVER_ACCOUNT", r.CONFIRM_PASSWORD = "CONFIRM_PASSWORD", r.REJECT_ACCESS = "REJECT_ACCESS", r.GRANT_ACCESS = "GRANT_ACCESS", r.ADD_TOKEN = "ADD_TOKEN", r.SIGN_TRANSACTION = "SIGN_TRANSACTION", r.SIGN_BLOB = "SIGN_BLOB", r.SIGN_AUTH_ENTRY = "SIGN_AUTH_ENTRY", r.HANDLE_SIGNED_HW_PAYLOAD = "HANDLE_SIGNED_HW_PAYLOAD", r.REJECT_TRANSACTION = "REJECT_TRANSACTION", r.SIGN_FREIGHTER_TRANSACTION = "SIGN_FREIGHTER_TRANSACTION", r.SIGN_FREIGHTER_SOROBAN_TRANSACTION = "SIGN_FREIGHTER_SOROBAN_TRANSACTION", r.ADD_RECENT_ADDRESS = "ADD_RECENT_ADDRESS", r.LOAD_RECENT_ADDRESSES = "LOAD_RECENT_ADDRESSES", r.LOAD_LAST_USED_ACCOUNT = "LOAD_LAST_USED_ACCOUNT", r.SIGN_OUT = "SIGN_OUT", r.SHOW_BACKUP_PHRASE = "SHOW_BACKUP_PHRASE", r.SAVE_ALLOWLIST = "SAVE_ALLOWLIST", r.SAVE_SETTINGS = "SAVE_SETTINGS", r.SAVE_EXPERIMENTAL_FEATURES = "SAVE_EXPERIMENTAL_FEATURES", r.LOAD_SETTINGS = "LOAD_SETTINGS", r.LOAD_BACKEND_SETTINGS = "LOAD_BACKEND_SETTINGS", r.GET_CACHED_ASSET_ICON_LIST = "GET_CACHED_ASSET_ICON_LIST", r.GET_CACHED_ASSET_ICON = "GET_CACHED_ASSET_ICON", r.CACHE_ASSET_ICON = "CACHE_ASSET_ICON", r.GET_CACHED_ASSET_DOMAIN = "GET_CACHED_ASSET_DOMAIN", r.CACHE_ASSET_DOMAIN = "CACHE_ASSET_DOMAIN", r.GET_MEMO_REQUIRED_ACCOUNTS = "GET_MEMO_REQUIRED_ACCOUNTS", r.ADD_CUSTOM_NETWORK = "ADD_CUSTOM_NETWORK", r.CHANGE_NETWORK = "CHANGE_NETWORK", r.REMOVE_CUSTOM_NETWORK = "REMOVE_CUSTOM_NETWORK", r.EDIT_CUSTOM_NETWORK = "EDIT_CUSTOM_NETWORK", r.RESET_EXP_DATA = "RESET_EXP_DATA", r.ADD_TOKEN_ID = "ADD_TOKEN_ID", r.GET_TOKEN_IDS = "GET_TOKEN_IDS", r.REMOVE_TOKEN_ID = "REMOVE_TOKEN_ID", r.GET_MIGRATABLE_ACCOUNTS = "GET_MIGRATABLE_ACCOUNTS", r.GET_MIGRATED_MNEMONIC_PHRASE = "GET_MIGRATED_MNEMONIC_PHRASE", r.MIGRATE_ACCOUNTS = "MIGRATE_ACCOUNTS", r.ADD_ASSETS_LIST = "ADD_ASSETS_LIST", r.MODIFY_ASSETS_LIST = "MODIFY_ASSETS_LIST", r.CHANGE_ASSET_VISIBILITY = "CHANGE_ASSET_VISIBILITY", r.GET_HIDDEN_ASSETS = "GET_HIDDEN_ASSETS", r.GET_IS_ACCOUNT_MISMATCH = "GET_IS_ACCOUNT_MISMATCH";
        }(r || (r = {})), function(r) {
            r.REQUEST_ACCESS = "REQUEST_ACCESS", r.REQUEST_PUBLIC_KEY = "REQUEST_PUBLIC_KEY", r.SUBMIT_TOKEN = "SUBMIT_TOKEN", r.SUBMIT_TRANSACTION = "SUBMIT_TRANSACTION", r.SUBMIT_BLOB = "SUBMIT_BLOB", r.SUBMIT_AUTH_ENTRY = "SUBMIT_AUTH_ENTRY", r.REQUEST_NETWORK = "REQUEST_NETWORK", r.REQUEST_NETWORK_DETAILS = "REQUEST_NETWORK_DETAILS", r.REQUEST_CONNECTION_STATUS = "REQUEST_CONNECTION_STATUS", r.REQUEST_ALLOWED_STATUS = "REQUEST_ALLOWED_STATUS", r.SET_ALLOWED_STATUS = "SET_ALLOWED_STATUS", r.REQUEST_USER_INFO = "REQUEST_USER_INFO";
        }(e || (e = {}));
        const n = (r)=>{
            const s = Date.now() + Math.random();
            return window.postMessage({
                source: "FREIGHTER_EXTERNAL_MSG_REQUEST",
                messageId: s,
                ...r
            }, window.location.origin), new Promise((t)=>{
                let n = 0;
                r.type !== e.REQUEST_CONNECTION_STATUS && r.type !== e.REQUEST_PUBLIC_KEY || (n = setTimeout(()=>{
                    t({
                        isConnected: !1,
                        publicKey: ""
                    }), window.removeEventListener("message", o);
                }, 2e3));
                const o = (r)=>{
                    var e, E;
                    r.source === window && "FREIGHTER_EXTERNAL_MSG_RESPONSE" === (null === (e = null == r ? void 0 : r.data) || void 0 === e ? void 0 : e.source) && (null === (E = null == r ? void 0 : r.data) || void 0 === E ? void 0 : E.messagedId) === s && (t(r.data), window.removeEventListener("message", o), clearTimeout(n));
                };
                window.addEventListener("message", o, !1);
            });
        }, o = {
            code: -1,
            message: "Node environment is not supported"
        }, E = {
            code: -1,
            message: "The wallet encountered an internal error. Please try again or contact the wallet if the problem persists."
        }, T = async ()=>{
            let r;
            try {
                r = await n({
                    type: e.REQUEST_ACCESS
                });
            } catch (r) {
                console.error(r);
            }
            const { publicKey: s } = r || {
                publicKey: ""
            };
            return {
                publicKey: s,
                error: null == r ? void 0 : r.apiError
            };
        }, A = async ()=>{
            let r;
            try {
                r = await n({
                    type: e.REQUEST_PUBLIC_KEY
                });
            } catch (r) {
                console.error(r);
            }
            return {
                publicKey: (null == r ? void 0 : r.publicKey) || "",
                error: null == r ? void 0 : r.apiError
            };
        }, _ = async ()=>{
            let r;
            try {
                r = await n({
                    type: e.REQUEST_NETWORK_DETAILS
                });
            } catch (r) {
                console.error(r);
            }
            const { networkDetails: s, apiError: t } = r || {
                networkDetails: {
                    network: "",
                    networkName: "",
                    networkUrl: "",
                    networkPassphrase: "",
                    sorobanRpcUrl: void 0,
                    apiError: ""
                }
            }, { network: o, networkUrl: E, networkPassphrase: T, sorobanRpcUrl: A } = s;
            return {
                network: o,
                networkUrl: E,
                networkPassphrase: T,
                sorobanRpcUrl: A,
                error: t
            };
        }, a = async ()=>{
            let r;
            try {
                r = await n({
                    type: e.REQUEST_ALLOWED_STATUS
                });
            } catch (r) {
                console.error(r);
            }
            const { isAllowed: s } = r || {
                isAllowed: !1
            };
            return {
                isAllowed: s,
                error: null == r ? void 0 : r.apiError
            };
        }, i = async ()=>{
            let r = "";
            if (U) {
                const e = await A();
                return r = e.publicKey, e.error ? {
                    address: r,
                    error: e.error
                } : {
                    address: r
                };
            }
            return {
                address: r,
                error: o
            };
        }, S = async (r)=>{
            if (U) {
                const s = await (async (r)=>{
                    let s;
                    try {
                        s = await n({
                            contractId: r.contractId,
                            networkPassphrase: r.networkPassphrase,
                            type: e.SUBMIT_TOKEN
                        });
                    } catch (r) {
                        return {
                            error: E
                        };
                    }
                    return {
                        contractId: s.contractId,
                        error: null == s ? void 0 : s.apiError
                    };
                })(r);
                return s.error ? {
                    contractId: "",
                    error: s.error
                } : {
                    contractId: s.contractId || ""
                };
            }
            return {
                contractId: "",
                error: o
            };
        }, d = async (r, s)=>{
            if (U) {
                const t = await (async (r, s)=>{
                    const t = null == s ? void 0 : s.address, o = null == s ? void 0 : s.networkPassphrase;
                    let T;
                    try {
                        T = await n({
                            transactionXdr: r,
                            network: void 0,
                            networkPassphrase: o,
                            accountToSign: t,
                            type: e.SUBMIT_TRANSACTION
                        });
                    } catch (r) {
                        return {
                            signedTransaction: "",
                            signerAddress: "",
                            error: E
                        };
                    }
                    const { signedTransaction: A, signerAddress: _ } = T;
                    return {
                        signedTransaction: A,
                        signerAddress: _,
                        error: null == T ? void 0 : T.apiError
                    };
                })(r, s);
                return t.error ? {
                    signedTxXdr: "",
                    signerAddress: "",
                    error: t.error
                } : {
                    signedTxXdr: t.signedTransaction,
                    signerAddress: t.signerAddress
                };
            }
            return {
                signedTxXdr: "",
                signerAddress: "",
                error: o
            };
        }, l = async (r, s)=>{
            if (U) {
                const { isAllowed: t } = await a();
                if (!t) {
                    const r = await T();
                    if (r.error) return {
                        signedMessage: null,
                        signerAddress: "",
                        error: r.error
                    };
                }
                const o = await (async (r, s, t)=>{
                    let o;
                    const T = (t || {}).address;
                    try {
                        o = await n({
                            blob: r,
                            accountToSign: T,
                            apiVersion: "6.0.1",
                            networkPassphrase: null == t ? void 0 : t.networkPassphrase,
                            type: e.SUBMIT_BLOB
                        });
                    } catch (r) {
                        return {
                            signedMessage: null,
                            signerAddress: "",
                            error: E
                        };
                    }
                    const { signedBlob: A, signerAddress: _ } = o;
                    return {
                        signedMessage: A || null,
                        signerAddress: _,
                        error: null == o ? void 0 : o.apiError
                    };
                })(r, 0, s);
                return o.error ? {
                    signedMessage: null,
                    signerAddress: "",
                    error: o.error
                } : {
                    signedMessage: o.signedMessage,
                    signerAddress: o.signerAddress
                };
            }
            return {
                signedMessage: null,
                signerAddress: "",
                error: o
            };
        }, N = async (r, s)=>{
            if (U) {
                const { isAllowed: t } = await a();
                if (!t) {
                    const r = await T();
                    if (r.error) return {
                        signedAuthEntry: null,
                        signerAddress: "",
                        error: r.error
                    };
                }
                const o = await (async (r, s, t)=>{
                    const o = (t || {}).address;
                    let T;
                    try {
                        T = await n({
                            entryXdr: r,
                            accountToSign: o,
                            apiVersion: "6.0.1",
                            networkPassphrase: null == t ? void 0 : t.networkPassphrase,
                            type: e.SUBMIT_AUTH_ENTRY
                        });
                    } catch (r) {
                        return console.error(r), {
                            signedAuthEntry: null,
                            signerAddress: "",
                            error: E
                        };
                    }
                    const { signedAuthEntry: A, signerAddress: _ } = T;
                    return {
                        signedAuthEntry: A || null,
                        signerAddress: _,
                        error: null == T ? void 0 : T.apiError
                    };
                })(r, 0, s);
                return o.error ? {
                    signedAuthEntry: null,
                    signerAddress: "",
                    error: o.error
                } : {
                    signedAuthEntry: o.signedAuthEntry,
                    signerAddress: o.signerAddress
                };
            }
            return {
                signedAuthEntry: null,
                signerAddress: "",
                error: o
            };
        }, c = async ()=>U ? window.freighter ? Promise.resolve({
                isConnected: window.freighter
            }) : (async ()=>{
                let r = {
                    isConnected: !1
                };
                try {
                    r = await n({
                        type: e.REQUEST_CONNECTION_STATUS
                    });
                } catch (r) {
                    console.error(r);
                }
                return {
                    isConnected: r.isConnected
                };
            })() : {
                isConnected: !1,
                error: o
            }, C = async ()=>{
            if (U) {
                const r = await (async ()=>{
                    let r;
                    try {
                        r = await n({
                            type: e.REQUEST_NETWORK_DETAILS
                        });
                    } catch (r) {
                        console.error(r);
                    }
                    const { networkDetails: s } = r || {
                        networkDetails: {
                            network: "",
                            networkPassphrase: ""
                        }
                    };
                    return {
                        network: null == s ? void 0 : s.network,
                        networkPassphrase: null == s ? void 0 : s.networkPassphrase,
                        error: null == r ? void 0 : r.apiError
                    };
                })();
                return r.error ? {
                    network: "",
                    networkPassphrase: "",
                    error: r.error
                } : {
                    network: r.network,
                    networkPassphrase: r.networkPassphrase
                };
            }
            return {
                network: "",
                networkPassphrase: "",
                error: o
            };
        }, O = async ()=>{
            if (U) {
                const r = await _();
                return r.error ? {
                    network: "",
                    networkUrl: "",
                    networkPassphrase: "",
                    error: r.error
                } : {
                    network: r.network,
                    networkUrl: r.networkUrl,
                    networkPassphrase: r.networkPassphrase,
                    sorobanRpcUrl: r.sorobanRpcUrl
                };
            }
            return {
                network: "",
                networkUrl: "",
                networkPassphrase: "",
                error: o
            };
        }, I = async ()=>{
            let r = !1;
            if (U) {
                const e = await a();
                return r = e.isAllowed, e.error ? {
                    isAllowed: r,
                    error: e.error
                } : {
                    isAllowed: r
                };
            }
            return {
                isAllowed: r,
                error: o
            };
        }, R = async ()=>{
            let r = !1;
            if (U) {
                const s = await (async ()=>{
                    let r;
                    try {
                        r = await n({
                            type: e.SET_ALLOWED_STATUS
                        });
                    } catch (r) {
                        console.error(r);
                    }
                    const { isAllowed: s } = r || {
                        isAllowed: !1
                    };
                    return {
                        isAllowed: s,
                        error: null == r ? void 0 : r.apiError
                    };
                })();
                return r = s.isAllowed, s.error ? {
                    isAllowed: r,
                    error: s.error
                } : {
                    isAllowed: r
                };
            }
            return {
                isAllowed: r,
                error: o
            };
        }, w = async ()=>{
            let r = "";
            if (U) {
                const e = await T();
                return r = e.publicKey, e.error ? {
                    address: r,
                    error: e.error
                } : {
                    address: r
                };
            }
            return {
                address: r,
                error: o
            };
        };
        class u {
            constructor(r = 3e3){
                this.fetchInfo = async (r)=>{
                    if (!this.isRunning) return;
                    const e = await A(), s = await _();
                    (e.error || s.error) && r({
                        address: "",
                        network: "",
                        networkPassphrase: "",
                        error: e.error || s.error
                    }), this.currentAddress === e.publicKey && this.currentNetwork === s.network && this.currentNetworkPassphrase === s.networkPassphrase || (this.currentAddress = e.publicKey, this.currentNetwork = s.network, this.currentNetworkPassphrase = s.networkPassphrase, r({
                        address: e.publicKey,
                        network: s.network,
                        networkPassphrase: s.networkPassphrase
                    })), setTimeout(()=>this.fetchInfo(r), this.timeout);
                }, this.timeout = r, this.currentAddress = "", this.currentNetwork = "", this.currentNetworkPassphrase = "", this.isRunning = !1;
            }
            watch(r) {
                return U ? (this.isRunning = !0, this.fetchInfo(r), {}) : {
                    error: o
                };
            }
            stop() {
                this.isRunning = !1;
            }
        }
        const U = "undefined" != typeof window, D = {
            getAddress: i,
            addToken: S,
            signTransaction: d,
            signMessage: l,
            signAuthEntry: N,
            isConnected: c,
            getNetwork: C,
            getNetworkDetails: O,
            isAllowed: I,
            setAllowed: R,
            requestAccess: w,
            WatchWalletChanges: u
        };
        return t;
    })());

});

parcelRegister("4ZOJS", function(module, exports) {

$parcel$export(module.exports, "changeAccountSubscriberBuilder", function () { return $af7e2d049a0a3d58$export$279bcb7ce4196302; });

var $f59Be = parcelRequire("f59Be");

var $6Mj8D = parcelRequire("6Mj8D");

var $jJRID = parcelRequire("jJRID");
const $af7e2d049a0a3d58$var$WATCH_WALLET_INTERVAL = 1000; // how often you want to check for changes in the wallet
function $af7e2d049a0a3d58$export$279bcb7ce4196302() {
    return new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(()=>new (0, $jJRID.WatchWalletChanges)($af7e2d049a0a3d58$var$WATCH_WALLET_INTERVAL)).format(async (_, payload)=>[
            (0, $6Mj8D.utils).formatAddressToCAIP(payload.address)
        ]).addEventListener((instance, callback)=>{
        instance.watch(callback);
    }).onSwitchAccount((event, context)=>{
        if (!event.payload.address) {
            context.action('disconnect');
            event.preventDefault();
        }
    }).removeEventListener((instance)=>{
        instance.stop();
    }).build();
}

});


parcelRegister("eehHp", function(module, exports) {

$parcel$export(module.exports, "namespace", function () { return (parcelRequire("aII0V")).namespace; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("fvxh1")).Signer; });

var $aII0V = parcelRequire("aII0V");

var $fvxh1 = parcelRequire("fvxh1");

});
parcelRegister("aII0V", function(module, exports) {

$parcel$export(module.exports, "namespace", function () { return $90085d021f0b0bbf$export$76a88f7de6507443; });

var $lfyg9 = parcelRequire("lfyg9");
parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $g0e4X = parcelRequire("g0e4X");

var $jP6wO = parcelRequire("jP6wO");

var $e0BbI = parcelRequire("e0BbI");

var $grUTp = parcelRequire("grUTp");
const [$90085d021f0b0bbf$var$changeAccountSubscriber, $90085d021f0b0bbf$var$changeAccountCleanup] = (0, $grUTp.changeAccountSubscriberBuilder)();
const $90085d021f0b0bbf$var$connect = (0, $g0e4X.builders).connect().action(async function() {
    const response = await (0, $lfyg9.getAddress)();
    if (response.type === 'reject') throw new Error('User has rejected the request.');
    if (!response.result?.address) throw new Error(`Couldn't access to your wallet address.`);
    return [
        (0, $g0e4X.utils).formatAddressToCAIP(response.result.address)
    ];
}).before($90085d021f0b0bbf$var$changeAccountSubscriber).or($90085d021f0b0bbf$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $90085d021f0b0bbf$var$accountLines = new (0, $fha7R.ActionBuilder)('accountLines').action(async (_, account, options)=>{
    const client = new (0, $jP6wO.Client)((0, $e0BbI.XRPL_PUBLIC_SERVER));
    await client.connect();
    const response = await client.request({
        command: 'account_lines',
        ledger_index: 'current',
        account: account,
        peer: options?.peer
    });
    await client.disconnect();
    return response.result.lines;
}).build();
const $90085d021f0b0bbf$var$disconnect = (0, $f59Be.builders).disconnect().after($90085d021f0b0bbf$var$changeAccountCleanup).build();
const $90085d021f0b0bbf$export$76a88f7de6507443 = new (0, $at2GJ.NamespaceBuilder)('XRPL', (0, $e0BbI.WALLET_ID)).action($90085d021f0b0bbf$var$connect).action($90085d021f0b0bbf$var$accountLines).action($90085d021f0b0bbf$var$disconnect).build();

});
parcelRegister("lfyg9", function(module, exports) {
"use strict";
var $f78592e61ef4058d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f78592e61ef4058d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f78592e61ef4058d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f78592e61ef4058d$var$__exportStar((parcelRequire("dRO9w")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("5doK4")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("goeYf")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("aHpsb")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("bo2v7")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("kD2pJ")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("3wQWw")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("enE6O")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("4DXPr")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("dRmBy")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("3wBQl")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("3aEIq")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("cEhwj")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("bcN4w")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("3Ckwn")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("atIDz")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("c47z8")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("bZNxR")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("bUbEe")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("hEgxf")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("fh2Xd")), module.exports);

$f78592e61ef4058d$var$__exportStar((parcelRequire("ir1QL")), module.exports);

});
parcelRegister("dRO9w", function(module, exports) {
"use strict";
var $a18720d9f1f366c2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a18720d9f1f366c2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a18720d9f1f366c2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a18720d9f1f366c2$var$__exportStar((parcelRequire("g0lUv")), module.exports);

});
parcelRegister("g0lUv", function(module, exports) {
"use strict";
var $ba6da463a3d3e0e8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ba6da463a3d3e0e8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.acceptNFTOffer = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $ba6da463a3d3e0e8$var$acceptNFTOffer = function(payload) {
    return $ba6da463a3d3e0e8$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $ba6da463a3d3e0e8$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_ACCEPT_NFT_OFFER/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.acceptNFTOffer = $ba6da463a3d3e0e8$var$acceptNFTOffer;

});
parcelRegister("3WN7v", function(module, exports) {
"use strict";
var $2dfce41adc45c6da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2dfce41adc45c6da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2dfce41adc45c6da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2dfce41adc45c6da$var$__exportStar((parcelRequire("bqPWw")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("bBlAB")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("1ljaH")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("hxEBX")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("6BUW8")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("a6UIJ")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("eAhAb")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("6b0sa")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("fpf7C")), module.exports);

$2dfce41adc45c6da$var$__exportStar((parcelRequire("6biNk")), module.exports);

});
parcelRegister("bqPWw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.API_ERROR_BAD_REQUEST = void 0;
module.exports.API_ERROR_BAD_REQUEST = 'gem_BAD_REQUEST';

});

parcelRegister("bBlAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1ljaH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MSG_INTERNAL_RECEIVE_SIGN_OUT = module.exports.MSG_INTERNAL_RECEIVE_PASSWORD = module.exports.MSG_INTERNAL_REQUEST_PASSWORD = void 0;
/*
 * Requests messages
 */ module.exports.MSG_INTERNAL_REQUEST_PASSWORD = 'INTERNAL_REQUEST_PASSWORD';
/*
 * Responses messages
 */ module.exports.MSG_INTERNAL_RECEIVE_PASSWORD = 'INTERNAL_RECEIVE_PASSWORD';
module.exports.MSG_INTERNAL_RECEIVE_SIGN_OUT = 'INTERNAL_RECEIVE_SIGN_OUT';

});

parcelRegister("hxEBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6BUW8", function(module, exports) {
"use strict";
var $4d025d375cb9e0c3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4d025d375cb9e0c3$var$_a, $4d025d375cb9e0c3$var$_b, $4d025d375cb9e0c3$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNetworkByNetworkID = module.exports.getNetwork = module.exports.getDefaultNetwork = module.exports.NETWORK = module.exports.FAUCET_XAHAU_TESTNET = module.exports.XAHAU_TESTNET_NODES = module.exports.XAHAU_MAINNET_NODES = module.exports.DEVNET_NODES = module.exports.TESTNET_NODES = module.exports.MAINNET_NODES = module.exports.MAINNET_CLIO_NODES = module.exports.XahauNetwork = module.exports.XRPLNetwork = module.exports.Chain = void 0;
var $4d025d375cb9e0c3$var$Chain;
(function(Chain) {
    Chain["XRPL"] = "XRPL";
    Chain["XAHAU"] = "XAHAU";
})($4d025d375cb9e0c3$var$Chain || (module.exports.Chain = $4d025d375cb9e0c3$var$Chain = {}));
var $4d025d375cb9e0c3$var$XRPLNetwork;
(function(XRPLNetwork) {
    XRPLNetwork["MAINNET"] = "Mainnet";
    XRPLNetwork["TESTNET"] = "Testnet";
    XRPLNetwork["DEVNET"] = "Devnet";
    XRPLNetwork["CUSTOM"] = "Custom";
})($4d025d375cb9e0c3$var$XRPLNetwork || (module.exports.XRPLNetwork = $4d025d375cb9e0c3$var$XRPLNetwork = {}));
var $4d025d375cb9e0c3$var$XahauNetwork;
(function(XahauNetwork) {
    XahauNetwork["XAHAU_MAINNET"] = "Mainnet";
    XahauNetwork["XAHAU_TESTNET"] = "Testnet";
    XahauNetwork["CUSTOM"] = "Custom";
})($4d025d375cb9e0c3$var$XahauNetwork || (module.exports.XahauNetwork = $4d025d375cb9e0c3$var$XahauNetwork = {}));
// XRPL
module.exports.MAINNET_CLIO_NODES = [
    'wss://s1.ripple.com',
    'wss://s2.ripple.com'
];
module.exports.MAINNET_NODES = $4d025d375cb9e0c3$var$__spreadArray([
    'wss://xrplcluster.com'
], module.exports.MAINNET_CLIO_NODES, true);
module.exports.TESTNET_NODES = [
    'wss://s.altnet.rippletest.net:51233',
    'wss://testnet.xrpl-labs.com'
];
module.exports.DEVNET_NODES = [
    'wss://s.devnet.rippletest.net:51233'
];
// Xahau
module.exports.XAHAU_MAINNET_NODES = [
    'wss://xahau.network'
];
module.exports.XAHAU_TESTNET_NODES = [
    'wss://xahau-test.net'
];
// Faucets
module.exports.FAUCET_XAHAU_TESTNET = 'https://xahau-test.net/accounts';
module.exports.NETWORK = ($4d025d375cb9e0c3$var$_a = {}, $4d025d375cb9e0c3$var$_a[$4d025d375cb9e0c3$var$Chain.XRPL] = ($4d025d375cb9e0c3$var$_b = {}, $4d025d375cb9e0c3$var$_b[$4d025d375cb9e0c3$var$XRPLNetwork.MAINNET] = {
    chain: $4d025d375cb9e0c3$var$Chain.XRPL,
    name: $4d025d375cb9e0c3$var$XRPLNetwork.MAINNET,
    server: module.exports.MAINNET_NODES[0],
    nodes: module.exports.MAINNET_NODES,
    description: 'Main network using the production version of the XRP Ledger.',
    networkID: 0
}, $4d025d375cb9e0c3$var$_b[$4d025d375cb9e0c3$var$XRPLNetwork.TESTNET] = {
    chain: $4d025d375cb9e0c3$var$Chain.XRPL,
    name: $4d025d375cb9e0c3$var$XRPLNetwork.TESTNET,
    server: module.exports.TESTNET_NODES[0],
    nodes: module.exports.TESTNET_NODES,
    description: 'Acts as a testing network, without impacting production users and risking real money.',
    networkID: 1
}, $4d025d375cb9e0c3$var$_b[$4d025d375cb9e0c3$var$XRPLNetwork.DEVNET] = {
    chain: $4d025d375cb9e0c3$var$Chain.XRPL,
    name: $4d025d375cb9e0c3$var$XRPLNetwork.DEVNET,
    server: module.exports.DEVNET_NODES[0],
    nodes: module.exports.DEVNET_NODES,
    description: 'A preview of upcoming features, where unstable changes are tested out.'
}, $4d025d375cb9e0c3$var$_b[$4d025d375cb9e0c3$var$XRPLNetwork.CUSTOM] = {
    chain: $4d025d375cb9e0c3$var$Chain.XRPL,
    name: $4d025d375cb9e0c3$var$XRPLNetwork.CUSTOM,
    server: '',
    description: 'Custom network configuration provided by the user.'
}, $4d025d375cb9e0c3$var$_b), $4d025d375cb9e0c3$var$_a[$4d025d375cb9e0c3$var$Chain.XAHAU] = ($4d025d375cb9e0c3$var$_c = {}, $4d025d375cb9e0c3$var$_c[$4d025d375cb9e0c3$var$XahauNetwork.XAHAU_MAINNET] = {
    chain: $4d025d375cb9e0c3$var$Chain.XAHAU,
    name: $4d025d375cb9e0c3$var$XahauNetwork.XAHAU_MAINNET,
    server: module.exports.XAHAU_MAINNET_NODES[0],
    nodes: module.exports.XAHAU_MAINNET_NODES,
    description: 'Mainnet for the Xahau blockchain.',
    networkID: 21337
}, $4d025d375cb9e0c3$var$_c[$4d025d375cb9e0c3$var$XahauNetwork.XAHAU_TESTNET] = {
    chain: $4d025d375cb9e0c3$var$Chain.XAHAU,
    name: $4d025d375cb9e0c3$var$XahauNetwork.XAHAU_TESTNET,
    server: module.exports.XAHAU_TESTNET_NODES[0],
    nodes: module.exports.XAHAU_TESTNET_NODES,
    description: 'Testnet for the Xahau blockchain.',
    networkID: 21338
}, $4d025d375cb9e0c3$var$_c[$4d025d375cb9e0c3$var$XahauNetwork.CUSTOM] = {
    chain: $4d025d375cb9e0c3$var$Chain.XAHAU,
    name: $4d025d375cb9e0c3$var$XahauNetwork.CUSTOM,
    server: '',
    description: 'Custom network configuration provided by the user.'
}, $4d025d375cb9e0c3$var$_c), $4d025d375cb9e0c3$var$_a);
var $4d025d375cb9e0c3$var$getDefaultNetwork = function(chain) {
    switch(chain){
        case $4d025d375cb9e0c3$var$Chain.XAHAU:
            return $4d025d375cb9e0c3$var$XahauNetwork.XAHAU_MAINNET;
        default:
            return $4d025d375cb9e0c3$var$XRPLNetwork.MAINNET;
    }
};
module.exports.getDefaultNetwork = $4d025d375cb9e0c3$var$getDefaultNetwork;
function $4d025d375cb9e0c3$var$getNetwork(chain, network) {
    if (chain === $4d025d375cb9e0c3$var$Chain.XRPL && Object.values($4d025d375cb9e0c3$var$XRPLNetwork).includes(network)) return module.exports.NETWORK[chain][network];
    if (chain === $4d025d375cb9e0c3$var$Chain.XAHAU && Object.values($4d025d375cb9e0c3$var$XahauNetwork).includes(network)) return module.exports.NETWORK[chain][network];
    throw new Error("Network ".concat(network, " is not valid for chain ").concat(chain));
}
module.exports.getNetwork = $4d025d375cb9e0c3$var$getNetwork;
var $4d025d375cb9e0c3$var$getNetworkByNetworkID = function(networkID) {
    // Hardcoded for performance reasons
    switch(networkID){
        case 0:
            return module.exports.NETWORK[$4d025d375cb9e0c3$var$Chain.XRPL][$4d025d375cb9e0c3$var$XRPLNetwork.MAINNET];
        case 1:
            return module.exports.NETWORK[$4d025d375cb9e0c3$var$Chain.XRPL][$4d025d375cb9e0c3$var$XRPLNetwork.TESTNET];
        case 21337:
            return module.exports.NETWORK[$4d025d375cb9e0c3$var$Chain.XAHAU][$4d025d375cb9e0c3$var$XahauNetwork.XAHAU_MAINNET];
        case 21338:
            return module.exports.NETWORK[$4d025d375cb9e0c3$var$Chain.XAHAU][$4d025d375cb9e0c3$var$XahauNetwork.XAHAU_TESTNET];
        default:
            throw new Error("Network ID ".concat(networkID, " is not valid"));
    }
};
module.exports.getNetworkByNetworkID = $4d025d375cb9e0c3$var$getNetworkByNetworkID;

});

parcelRegister("a6UIJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GEM_WALLET = void 0;
module.exports.GEM_WALLET = 'gem-wallet';

});

parcelRegister("eAhAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_SUBMIT_TX_BULK_ON_ERROR = void 0;
module.exports.DEFAULT_SUBMIT_TX_BULK_ON_ERROR = 'abort';

});

parcelRegister("6b0sa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fpf7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6biNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("cVKQz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeError = void 0;
var $969f25b653e3948c$var$deserializeError = function(error) {
    var e = new Error(error.message);
    e.stack = error.stack;
    e.name = error.name;
    return e;
};
module.exports.deserializeError = $969f25b653e3948c$var$deserializeError;

});

parcelRegister("6VPCs", function(module, exports) {
"use strict";
var $50c01b7899d0a9a6$var$__assign = module.exports && module.exports.__assign || function() {
    $50c01b7899d0a9a6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $50c01b7899d0a9a6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendMessageToContentScript = void 0;
/**
 * Sends a message from the current window to the content script.
 *
 * @param msg The message to send.
 * @returns A Promise that resolves with the response from the content script.
 * @throws An error if GemWallet is not connected and the message type is not a connection request.
 */ var $50c01b7899d0a9a6$var$sendMessageToContentScript = function(msg) {
    /*
      In the case of multiple calls coming in sequentially, we use this MESSAGE_ID to make sure we're responding to
      the appropriate message sender. Otherwise, we can run into race conditions where we simply resolve all
      sent messages with the first thing that comes back.
    */ var messageId = Date.now() + Math.random();
    window.postMessage($50c01b7899d0a9a6$var$__assign({
        source: 'GEM_WALLET_MSG_REQUEST',
        messageId: messageId
    }, msg), window.location.origin);
    return new Promise(function(resolve, reject) {
        if (!window.gemWallet && msg.type !== 'REQUEST_IS_INSTALLED/V3') reject(new Error('Please check if GemWallet is installed - GemWallet needs to be installed: https://gemwallet.app'));
        var messageListener = function(event) {
            var _a, _b;
            // We only accept messages from ourselves
            if (event.source !== window) return;
            // Only respond to messages tagged as being from our content script
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.source) !== 'GEM_WALLET_MSG_RESPONSE') return;
            // Only respond to messages that this instance of sendMessageToContentScript sent
            if (((_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.messagedId) !== messageId) return;
            resolve(event.data);
            window.removeEventListener('message', messageListener);
        };
        window.addEventListener('message', messageListener, false);
    });
};
module.exports.sendMessageToContentScript = $50c01b7899d0a9a6$var$sendMessageToContentScript;

});



parcelRegister("5doK4", function(module, exports) {
"use strict";
var $3cc15be3e97ce646$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3cc15be3e97ce646$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3cc15be3e97ce646$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3cc15be3e97ce646$var$__exportStar((parcelRequire("66FBP")), module.exports);

});
parcelRegister("66FBP", function(module, exports) {
"use strict";
var $4723944d7c8d8666$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4723944d7c8d8666$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.burnNFT = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $4723944d7c8d8666$var$burnNFT = function(payload) {
    return $4723944d7c8d8666$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $4723944d7c8d8666$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_BURN_NFT/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.burnNFT = $4723944d7c8d8666$var$burnNFT;

});


parcelRegister("goeYf", function(module, exports) {
"use strict";
var $beea80216367732e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $beea80216367732e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $beea80216367732e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$beea80216367732e$var$__exportStar((parcelRequire("kjQMi")), module.exports);

});
parcelRegister("kjQMi", function(module, exports) {
"use strict";
var $03d144381fc002c8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $03d144381fc002c8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cancelNFTOffer = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $03d144381fc002c8$var$cancelNFTOffer = function(payload) {
    return $03d144381fc002c8$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $03d144381fc002c8$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_CANCEL_NFT_OFFER/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.cancelNFTOffer = $03d144381fc002c8$var$cancelNFTOffer;

});


parcelRegister("aHpsb", function(module, exports) {
"use strict";
var $7ca1aa141eb1d3e0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7ca1aa141eb1d3e0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7ca1aa141eb1d3e0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7ca1aa141eb1d3e0$var$__exportStar((parcelRequire("7Fwdy")), module.exports);

});
parcelRegister("7Fwdy", function(module, exports) {
"use strict";
var $59555a7e31ab0450$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $59555a7e31ab0450$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cancelOffer = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $59555a7e31ab0450$var$cancelOffer = function(payload) {
    return $59555a7e31ab0450$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $59555a7e31ab0450$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_CANCEL_OFFER/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.cancelOffer = $59555a7e31ab0450$var$cancelOffer;

});


parcelRegister("bo2v7", function(module, exports) {
"use strict";
var $84a3e035690852f4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84a3e035690852f4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $84a3e035690852f4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$84a3e035690852f4$var$__exportStar((parcelRequire("eDfrE")), module.exports);

});
parcelRegister("eDfrE", function(module, exports) {
"use strict";
var $aa70b0421d671016$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aa70b0421d671016$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNFTOffer = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $aa70b0421d671016$var$createNFTOffer = function(payload) {
    return $aa70b0421d671016$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $aa70b0421d671016$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_CREATE_NFT_OFFER/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.createNFTOffer = $aa70b0421d671016$var$createNFTOffer;

});


parcelRegister("kD2pJ", function(module, exports) {
"use strict";
var $f049528fc9bec9cf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f049528fc9bec9cf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f049528fc9bec9cf$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f049528fc9bec9cf$var$__exportStar((parcelRequire("fQ3wa")), module.exports);

});
parcelRegister("fQ3wa", function(module, exports) {
"use strict";
var $b87e70ec5fb9bd2d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b87e70ec5fb9bd2d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createOffer = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $b87e70ec5fb9bd2d$var$createOffer = function(payload) {
    return $b87e70ec5fb9bd2d$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $b87e70ec5fb9bd2d$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_CREATE_OFFER/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.createOffer = $b87e70ec5fb9bd2d$var$createOffer;

});


parcelRegister("3wQWw", function(module, exports) {
"use strict";
var $291d6d9fe4dc31d6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $291d6d9fe4dc31d6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $291d6d9fe4dc31d6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$291d6d9fe4dc31d6$var$__exportStar((parcelRequire("dmQ8w")), module.exports);

});
parcelRegister("dmQ8w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.on = void 0;

var $3WN7v = parcelRequire("3WN7v");
var $9bb5c5aa5bf5b058$var$on = function(eventType, callback) {
    window.addEventListener('message', function(event) {
        // We only accept messages from ourselves
        if (event.origin !== window.origin) return;
        if (event.source !== window && event.data.app === $3WN7v.GEM_WALLET) return;
        if (!event.data.source || event.data.source !== 'GEM_WALLET_MSG_REQUEST') return;
        if (event.data.type && event.data.type === eventType) callback(event.data.payload.result);
    });
};
module.exports.on = $9bb5c5aa5bf5b058$var$on;

});


parcelRegister("enE6O", function(module, exports) {
"use strict";
var $a7825374ce0cc9e4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7825374ce0cc9e4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a7825374ce0cc9e4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a7825374ce0cc9e4$var$__exportStar((parcelRequire("cIbtl")), module.exports);

});
parcelRegister("cIbtl", function(module, exports) {
"use strict";
var $94127e447aac7504$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $94127e447aac7504$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAddress = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");

var $f5f90 = parcelRequire("f5f90");
var $94127e447aac7504$var$getAddress = function() {
    return $94127e447aac7504$var$__awaiter(void 0, void 0, void 0, function() {
        var response, favicon, message, _a, result, error, parsedError, e_1;
        return $94127e447aac7504$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    favicon = (0, $f5f90.getFavicon)();
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_GET_ADDRESS/V3',
                        payload: {
                            url: window.location.origin,
                            title: document.title,
                            favicon: favicon
                        }
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.getAddress = $94127e447aac7504$var$getAddress;

});
parcelRegister("f5f90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFavicon = void 0;
var $afb311fc94b7c09b$var$getFavicon = function() {
    var _a;
    var favicon = (_a = document.querySelector("link[rel*='icon']")) === null || _a === void 0 ? void 0 : _a.getAttribute('href');
    if (favicon) try {
        new URL(favicon);
    } catch (e) {
        favicon = window.location.origin + favicon;
    }
    return favicon;
};
module.exports.getFavicon = $afb311fc94b7c09b$var$getFavicon;

});



parcelRegister("4DXPr", function(module, exports) {
"use strict";
var $361936b3801f2d9d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $361936b3801f2d9d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $361936b3801f2d9d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$361936b3801f2d9d$var$__exportStar((parcelRequire("jlhx9")), module.exports);

});
parcelRegister("jlhx9", function(module, exports) {
"use strict";
var $e14d944eff56a40c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e14d944eff56a40c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNetwork = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $e14d944eff56a40c$var$getNetwork = function() {
    return $e14d944eff56a40c$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $e14d944eff56a40c$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_GET_NETWORK/V3'
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.getNetwork = $e14d944eff56a40c$var$getNetwork;

});


parcelRegister("dRmBy", function(module, exports) {
"use strict";
var $a171c26e2a8f6448$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a171c26e2a8f6448$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a171c26e2a8f6448$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a171c26e2a8f6448$var$__exportStar((parcelRequire("agLQo")), module.exports);

});
parcelRegister("agLQo", function(module, exports) {
"use strict";
var $77a082d07e9fa7e5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $77a082d07e9fa7e5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNFT = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");

var $f5f90 = parcelRequire("f5f90");
var $77a082d07e9fa7e5$var$getNFT = function(payload) {
    return $77a082d07e9fa7e5$var$__awaiter(void 0, void 0, void 0, function() {
        var response, favicon, message, _a, result, error, parsedError, e_1;
        var _b, _c;
        return $77a082d07e9fa7e5$var$__generator(this, function(_d) {
            switch(_d.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    favicon = (0, $f5f90.getFavicon)();
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_GET_NFT/V3',
                        payload: {
                            url: window.location.origin,
                            title: document.title,
                            favicon: favicon,
                            limit: (_b = payload === null || payload === void 0 ? void 0 : payload.limit) !== null && _b !== void 0 ? _b : undefined,
                            // Value from a previous paginated response. Resume retrieving data where that response left off.
                            marker: (_c = payload === null || payload === void 0 ? void 0 : payload.marker) !== null && _c !== void 0 ? _c : undefined
                        }
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _d.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _d.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.getNFT = $77a082d07e9fa7e5$var$getNFT;

});


parcelRegister("3wBQl", function(module, exports) {
"use strict";
var $2911b728c19dc051$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2911b728c19dc051$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2911b728c19dc051$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2911b728c19dc051$var$__exportStar((parcelRequire("gTN10")), module.exports);

});
parcelRegister("gTN10", function(module, exports) {
"use strict";
var $c4d7cdcb8045113a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4d7cdcb8045113a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPublicKey = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");

var $f5f90 = parcelRequire("f5f90");
var $c4d7cdcb8045113a$var$getPublicKey = function() {
    return $c4d7cdcb8045113a$var$__awaiter(void 0, void 0, void 0, function() {
        var response, favicon, message, _a, result, error, parsedError, e_1;
        return $c4d7cdcb8045113a$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    favicon = (0, $f5f90.getFavicon)();
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_GET_PUBLIC_KEY/V3',
                        payload: {
                            url: window.location.origin,
                            title: document.title,
                            favicon: favicon
                        }
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.getPublicKey = $c4d7cdcb8045113a$var$getPublicKey;

});


parcelRegister("3aEIq", function(module, exports) {
"use strict";
var $24f1e389904d3179$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $24f1e389904d3179$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $24f1e389904d3179$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$24f1e389904d3179$var$__exportStar((parcelRequire("2jvtW")), module.exports);

});
parcelRegister("2jvtW", function(module, exports) {
"use strict";
var $1af5c6c9cc389ffc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1af5c6c9cc389ffc$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInstalled = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $6VPCs = parcelRequire("6VPCs");
var $1af5c6c9cc389ffc$var$isInstalled = function() {
    if (window.gemWallet) return Promise.resolve({
        result: {
            isInstalled: true
        }
    });
    else {
        // If no answer from the extension after 1 second, then return false
        var timeoutId_1;
        var abortConnection = new Promise(function(resolve) {
            timeoutId_1 = setTimeout(function() {
                resolve({
                    result: {
                        isInstalled: false
                    }
                });
            }, 1000);
        });
        // Trying to connect to the extension
        var connectionToExtension = new Promise(function(resolve) {
            return $1af5c6c9cc389ffc$var$__awaiter(void 0, void 0, void 0, function() {
                var message, response, e_1;
                return $1af5c6c9cc389ffc$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            message = {
                                app: $3WN7v.GEM_WALLET,
                                type: 'REQUEST_IS_INSTALLED/V3'
                            };
                            return [
                                4 /*yield*/ ,
                                (0, $6VPCs.sendMessageToContentScript)(message)
                            ];
                        case 1:
                            response = _a.sent();
                            resolve({
                                result: {
                                    isInstalled: response.isInstalled || false
                                }
                            });
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            e_1 = _a.sent();
                            resolve({
                                result: {
                                    isInstalled: false
                                }
                            });
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        return Promise.race([
            abortConnection,
            connectionToExtension
        ]).then(function(res) {
            clearTimeout(timeoutId_1);
            if (res.result.isInstalled === true) window.gemWallet = true;
            return {
                result: {
                    isInstalled: res.result.isInstalled
                }
            };
        }).catch(function() {
            return {
                result: {
                    isInstalled: false
                }
            };
        });
    }
};
module.exports.isInstalled = $1af5c6c9cc389ffc$var$isInstalled;

});


parcelRegister("cEhwj", function(module, exports) {
"use strict";
var $9356cf9480b7aaf8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9356cf9480b7aaf8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9356cf9480b7aaf8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9356cf9480b7aaf8$var$__exportStar((parcelRequire("2iyM8")), module.exports);

});
parcelRegister("2iyM8", function(module, exports) {
"use strict";
var $1ac83cd9a88dd42c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1ac83cd9a88dd42c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mintNFT = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $1ac83cd9a88dd42c$var$mintNFT = function(payload) {
    return $1ac83cd9a88dd42c$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $1ac83cd9a88dd42c$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_MINT_NFT/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.mintNFT = $1ac83cd9a88dd42c$var$mintNFT;

});


parcelRegister("bcN4w", function(module, exports) {
"use strict";
var $8286e162fc184173$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8286e162fc184173$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8286e162fc184173$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8286e162fc184173$var$__exportStar((parcelRequire("1Nf6f")), module.exports);

});
parcelRegister("1Nf6f", function(module, exports) {
"use strict";
var $14e614911e7e6db4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $14e614911e7e6db4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendPayment = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $14e614911e7e6db4$var$sendPayment = function(paymentPayload) {
    return $14e614911e7e6db4$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $14e614911e7e6db4$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SEND_PAYMENT/V3',
                        payload: paymentPayload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.sendPayment = $14e614911e7e6db4$var$sendPayment;

});


parcelRegister("3Ckwn", function(module, exports) {
"use strict";
var $2a24d6cfd68c7e8a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a24d6cfd68c7e8a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2a24d6cfd68c7e8a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2a24d6cfd68c7e8a$var$__exportStar((parcelRequire("hCMwi")), module.exports);

});
parcelRegister("hCMwi", function(module, exports) {
"use strict";
var $cd4b9f5075367a47$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cd4b9f5075367a47$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setAccount = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $cd4b9f5075367a47$var$setAccount = function(payload) {
    return $cd4b9f5075367a47$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $cd4b9f5075367a47$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SET_ACCOUNT/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.setAccount = $cd4b9f5075367a47$var$setAccount;

});


parcelRegister("atIDz", function(module, exports) {
"use strict";
var $7a0f3cd419432313$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a0f3cd419432313$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7a0f3cd419432313$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7a0f3cd419432313$var$__exportStar((parcelRequire("l1oiU")), module.exports);

});
parcelRegister("l1oiU", function(module, exports) {
"use strict";
var $f4dc8b37b7bd84d1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f4dc8b37b7bd84d1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setHook = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $f4dc8b37b7bd84d1$var$setHook = function(payload) {
    return $f4dc8b37b7bd84d1$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $f4dc8b37b7bd84d1$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SET_HOOK/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.setHook = $f4dc8b37b7bd84d1$var$setHook;

});


parcelRegister("c47z8", function(module, exports) {
"use strict";
var $8c8bba22b71c9aa8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c8bba22b71c9aa8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8c8bba22b71c9aa8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8c8bba22b71c9aa8$var$__exportStar((parcelRequire("3H6KB")), module.exports);

});
parcelRegister("3H6KB", function(module, exports) {
"use strict";
var $2b0a9fc578d82df0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2b0a9fc578d82df0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setRegularKey = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $2b0a9fc578d82df0$var$setRegularKey = function(payload) {
    return $2b0a9fc578d82df0$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $2b0a9fc578d82df0$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SET_REGULAR_KEY/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.setRegularKey = $2b0a9fc578d82df0$var$setRegularKey;

});


parcelRegister("bZNxR", function(module, exports) {
"use strict";
var $8bbbd2d66de1d64a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8bbbd2d66de1d64a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8bbbd2d66de1d64a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8bbbd2d66de1d64a$var$__exportStar((parcelRequire("cgA5e")), module.exports);

});
parcelRegister("cgA5e", function(module, exports) {
"use strict";
var $8ee2f816352a109a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8ee2f816352a109a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setTrustline = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $8ee2f816352a109a$var$setTrustline = function(payload) {
    return $8ee2f816352a109a$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $8ee2f816352a109a$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SET_TRUSTLINE/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.setTrustline = $8ee2f816352a109a$var$setTrustline;

});


parcelRegister("bUbEe", function(module, exports) {
"use strict";
var $8aadf5b476079f0f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8aadf5b476079f0f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8aadf5b476079f0f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8aadf5b476079f0f$var$__exportStar((parcelRequire("fAJWz")), module.exports);

});
parcelRegister("fAJWz", function(module, exports) {
"use strict";
var $b59ddb3f747c74f2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b59ddb3f747c74f2$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signMessage = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");

var $f5f90 = parcelRequire("f5f90");
var $b59ddb3f747c74f2$var$signMessage = function(message, isHex) {
    return $b59ddb3f747c74f2$var$__awaiter(void 0, void 0, void 0, function() {
        var response, favicon, messageToContentScript, _a, result, error, parsedError, e_1;
        return $b59ddb3f747c74f2$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    favicon = (0, $f5f90.getFavicon)();
                    messageToContentScript = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SIGN_MESSAGE/V3',
                        payload: {
                            url: window.location.origin,
                            title: document.title,
                            favicon: favicon,
                            message: message,
                            isHex: isHex
                        }
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(messageToContentScript)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.signMessage = $b59ddb3f747c74f2$var$signMessage;

});


parcelRegister("hEgxf", function(module, exports) {
"use strict";
var $cd92ffa9b424ce77$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd92ffa9b424ce77$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd92ffa9b424ce77$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cd92ffa9b424ce77$var$__exportStar((parcelRequire("cQFpF")), module.exports);

});
parcelRegister("cQFpF", function(module, exports) {
"use strict";
var $95aa771a37165fe8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $95aa771a37165fe8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signTransaction = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $95aa771a37165fe8$var$signTransaction = function(payload) {
    return $95aa771a37165fe8$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $95aa771a37165fe8$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SIGN_TRANSACTION/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.signTransaction = $95aa771a37165fe8$var$signTransaction;

});


parcelRegister("fh2Xd", function(module, exports) {
"use strict";
var $b1eabc2d262d7386$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b1eabc2d262d7386$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b1eabc2d262d7386$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b1eabc2d262d7386$var$__exportStar((parcelRequire("44MS7")), module.exports);

});
parcelRegister("44MS7", function(module, exports) {
"use strict";
var $2f7d7216f8b1dcac$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2f7d7216f8b1dcac$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.submitTransaction = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $2f7d7216f8b1dcac$var$submitTransaction = function(payload) {
    return $2f7d7216f8b1dcac$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $2f7d7216f8b1dcac$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SUBMIT_TRANSACTION/V3',
                        payload: payload
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.submitTransaction = $2f7d7216f8b1dcac$var$submitTransaction;

});


parcelRegister("ir1QL", function(module, exports) {
"use strict";
var $d6bc2efd53338434$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d6bc2efd53338434$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d6bc2efd53338434$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d6bc2efd53338434$var$__exportStar((parcelRequire("4Kp2r")), module.exports);

});
parcelRegister("4Kp2r", function(module, exports) {
"use strict";
var $374ee169b711505d$var$__assign = module.exports && module.exports.__assign || function() {
    $374ee169b711505d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $374ee169b711505d$var$__assign.apply(this, arguments);
};
var $374ee169b711505d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $374ee169b711505d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.submitBulkTransactions = void 0;

var $3WN7v = parcelRequire("3WN7v");

var $cVKQz = parcelRequire("cVKQz");

var $6VPCs = parcelRequire("6VPCs");
var $374ee169b711505d$var$MAX_TRANSACTIONS = 50;
var $374ee169b711505d$var$submitBulkTransactions = function(payload) {
    return $374ee169b711505d$var$__awaiter(void 0, void 0, void 0, function() {
        var response, message, _a, result, error, parsedError, e_1;
        return $374ee169b711505d$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    response = {
                        type: "reject" /* ResponseType.Reject */ ,
                        result: undefined
                    };
                    if (!payload.transactions) throw new Error($3WN7v.API_ERROR_BAD_REQUEST);
                    if (payload.transactions.length === 0 || payload.transactions.length > $374ee169b711505d$var$MAX_TRANSACTIONS) throw new Error("Invalid number of transactions (must be between 1 and ".concat($374ee169b711505d$var$MAX_TRANSACTIONS, ")"));
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    message = {
                        app: $3WN7v.GEM_WALLET,
                        type: 'REQUEST_SUBMIT_BULK_TRANSACTIONS/V3',
                        payload: $374ee169b711505d$var$__assign($374ee169b711505d$var$__assign({}, payload), {
                            // Add an index to each transaction so that we can process them in order
                            transactions: payload.transactions.reduce(function(acc, transaction, index) {
                                acc[index] = transaction;
                                return acc;
                            }, {})
                        })
                    };
                    return [
                        4 /*yield*/ ,
                        (0, $6VPCs.sendMessageToContentScript)(message)
                    ];
                case 2:
                    _a = _b.sent(), result = _a.result, error = _a.error;
                    parsedError = error ? (0, $cVKQz.deserializeError)(error) : undefined;
                    if (parsedError) throw parsedError;
                    if (result) {
                        response.type = "response" /* ResponseType.Response */ ;
                        response.result = result;
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
};
module.exports.submitBulkTransactions = $374ee169b711505d$var$submitBulkTransactions;

});



parcelRegister("g0e4X", function(module, exports) {

$parcel$export(module.exports, "builders", function () { return $ba67913b1a941aa4$export$aea8daed5328d69c; });
$parcel$export(module.exports, "utils", function () { return $ba67913b1a941aa4$export$eab97d15b1788b8d; });



var $3ca9q = parcelRequire("3ca9q");
var $ba67913b1a941aa4$var$h = Object.defineProperty;
var $ba67913b1a941aa4$var$e = (r, t)=>$ba67913b1a941aa4$var$h(r, "name", {
        value: t,
        configurable: !0
    });
var $ba67913b1a941aa4$var$l = (r, t)=>{
    for(var n in t)$ba67913b1a941aa4$var$h(r, n, {
        get: t[n],
        enumerable: !0
    });
};
var $ba67913b1a941aa4$export$aea8daed5328d69c = {};
$ba67913b1a941aa4$var$l($ba67913b1a941aa4$export$aea8daed5328d69c, {
    connect: ()=>$ba67913b1a941aa4$var$I
});
var $ba67913b1a941aa4$var$o = class {
    static{
        $ba67913b1a941aa4$var$e(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #r = new Map;
    #o = new Map;
    #n;
    constructor(t){
        this.name = t;
    }
    and(t) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(t), this;
    }
    or(t) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(t), this;
    }
    before(t) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(t), this;
    }
    after(t) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(t), this;
    }
    action(t) {
        return this.#n = t, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#o,
            after: this.#r,
            and: this.#e,
            or: this.#t
        };
    }
};
function $ba67913b1a941aa4$var$p(r) {
    let [, t] = r.state();
    t("connecting", !1);
}
$ba67913b1a941aa4$var$e($ba67913b1a941aa4$var$p, "intoConnectionFinished");
function $ba67913b1a941aa4$var$g(r) {
    try {
        return (0, $3ca9q.AccountId).parse(r), !0;
    } catch  {
        return !1;
    }
}
$ba67913b1a941aa4$var$e($ba67913b1a941aa4$var$g, "isValidCaipAddress");
function $ba67913b1a941aa4$var$d(r, t) {
    if (!t.every($ba67913b1a941aa4$var$g)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${t}`);
    let [, n] = r.state();
    return n("accounts", t), n("connected", !0), t;
}
$ba67913b1a941aa4$var$e($ba67913b1a941aa4$var$d, "connectAndUpdateStateForSingleNetwork");
function $ba67913b1a941aa4$var$u(r) {
    let [, t] = r.state();
    t("connecting", !0);
}
$ba67913b1a941aa4$var$e($ba67913b1a941aa4$var$u, "intoConnecting");
var $ba67913b1a941aa4$var$I = $ba67913b1a941aa4$var$e(()=>new $ba67913b1a941aa4$var$o("connect").and($ba67913b1a941aa4$var$d).before($ba67913b1a941aa4$var$u).after($ba67913b1a941aa4$var$p), "connect");
var $ba67913b1a941aa4$export$eab97d15b1788b8d = {};
$ba67913b1a941aa4$var$l($ba67913b1a941aa4$export$eab97d15b1788b8d, {
    formatAddressToCAIP: ()=>$ba67913b1a941aa4$var$R
});
var $ba67913b1a941aa4$export$c67e5a7ce034264a = "xrpl", $ba67913b1a941aa4$export$44480c52749fb508 = "mainnet";
function $ba67913b1a941aa4$var$R(r) {
    return (0, $3ca9q.AccountId).format({
        address: r,
        chainId: {
            namespace: $ba67913b1a941aa4$export$c67e5a7ce034264a,
            reference: $ba67913b1a941aa4$export$44480c52749fb508
        }
    });
}
$ba67913b1a941aa4$var$e($ba67913b1a941aa4$var$R, "formatAddressToCAIP");

});

parcelRegister("jP6wO", function(module, exports) {
"use strict";
var $e6e7d81dc5e85d6f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e6e7d81dc5e85d6f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e6e7d81dc5e85d6f$var$__createBinding(exports1, m, p);
};
var $e6e7d81dc5e85d6f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rfc1751MnemonicToKey = module.exports.keyToRFC1751Mnemonic = module.exports.walletFromSecretNumbers = module.exports.Wallet = module.exports.ECDSA = module.exports.Client = void 0;

var $dKLQi = parcelRequire("dKLQi");
Object.defineProperty(module.exports, "Client", {
    enumerable: true,
    get: function() {
        return $dKLQi.Client;
    }
});

$e6e7d81dc5e85d6f$var$__exportStar((parcelRequire("7OgLe")), module.exports);

$e6e7d81dc5e85d6f$var$__exportStar((parcelRequire("3Urjz")), module.exports);

var $jbgk0 = parcelRequire("jbgk0");
Object.defineProperty(module.exports, "ECDSA", {
    enumerable: true,
    get: function() {
        return $e6e7d81dc5e85d6f$var$__importDefault($jbgk0).default;
    }
});

$e6e7d81dc5e85d6f$var$__exportStar((parcelRequire("aMl9I")), module.exports);

var $81kGK = parcelRequire("81kGK");
Object.defineProperty(module.exports, "Wallet", {
    enumerable: true,
    get: function() {
        return $81kGK.Wallet;
    }
});

var $c8A0F = parcelRequire("c8A0F");
Object.defineProperty(module.exports, "walletFromSecretNumbers", {
    enumerable: true,
    get: function() {
        return $c8A0F.walletFromSecretNumbers;
    }
});

var $hlDCx = parcelRequire("hlDCx");
Object.defineProperty(module.exports, "keyToRFC1751Mnemonic", {
    enumerable: true,
    get: function() {
        return $hlDCx.keyToRFC1751Mnemonic;
    }
});
Object.defineProperty(module.exports, "rfc1751MnemonicToKey", {
    enumerable: true,
    get: function() {
        return $hlDCx.rfc1751MnemonicToKey;
    }
});

$e6e7d81dc5e85d6f$var$__exportStar((parcelRequire("5VcT1")), module.exports);

});
parcelRegister("dKLQi", function(module, exports) {
"use strict";
var $a034aec8f2f73482$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Client = void 0;

var $6p5EE = parcelRequire("6p5EE");

var $aMl9I = parcelRequire("aMl9I");

var $6sfYg = parcelRequire("6sfYg");

var $jvbLy = parcelRequire("jvbLy");

var $8zzq8 = parcelRequire("8zzq8");

var $aCoW3 = parcelRequire("aCoW3");

var $9UKGz = parcelRequire("9UKGz");

var $73BaH = parcelRequire("73BaH");

var $3Urjz = parcelRequire("3Urjz");

var $81kGK = parcelRequire("81kGK");

var $iQnSA = parcelRequire("iQnSA");

var $8KxM7 = parcelRequire("8KxM7");

var $1iQdO = parcelRequire("1iQdO");
function $a034aec8f2f73482$var$getCollectKeyFromCommand(command) {
    switch(command){
        case 'account_channels':
            return 'channels';
        case 'account_lines':
            return 'lines';
        case 'account_objects':
            return 'account_objects';
        case 'account_tx':
            return 'transactions';
        case 'account_offers':
        case 'book_offers':
            return 'offers';
        case 'ledger_data':
            return 'state';
        default:
            return null;
    }
}
function $a034aec8f2f73482$var$clamp(value, min, max) {
    if (min > max) throw new Error('Illegal clamp bounds');
    return Math.min(Math.max(value, min), max);
}
const $a034aec8f2f73482$var$DEFAULT_FEE_CUSHION = 1.2;
const $a034aec8f2f73482$var$DEFAULT_MAX_FEE_XRP = '2';
const $a034aec8f2f73482$var$MIN_LIMIT = 10;
const $a034aec8f2f73482$var$MAX_LIMIT = 400;
const $a034aec8f2f73482$var$NORMAL_DISCONNECT_CODE = 1000;
class $a034aec8f2f73482$var$Client extends $6p5EE.EventEmitter {
    constructor(server, options = {}){
        var _a, _b;
        super();
        this.apiVersion = $6sfYg.DEFAULT_API_VERSION;
        if (typeof server !== 'string' || !/wss?(?:\+unix)?:\/\//u.exec(server)) throw new $aMl9I.ValidationError('server URI must start with `wss://`, `ws://`, `wss+unix://`, or `ws+unix://`.');
        this.feeCushion = (_a = options.feeCushion) !== null && _a !== void 0 ? _a : $a034aec8f2f73482$var$DEFAULT_FEE_CUSHION;
        this.maxFeeXRP = (_b = options.maxFeeXRP) !== null && _b !== void 0 ? _b : $a034aec8f2f73482$var$DEFAULT_MAX_FEE_XRP;
        this.connection = new $8KxM7.Connection(server, options);
        this.connection.on('error', (errorCode, errorMessage, data)=>{
            this.emit('error', errorCode, errorMessage, data);
        });
        this.connection.on('reconnect', ()=>{
            this.connection.on('connected', ()=>this.emit('connected'));
        });
        this.connection.on('disconnected', (code)=>{
            let finalCode = code;
            if (finalCode === $8KxM7.INTENTIONAL_DISCONNECT_CODE) finalCode = $a034aec8f2f73482$var$NORMAL_DISCONNECT_CODE;
            this.emit('disconnected', finalCode);
        });
        this.connection.on('ledgerClosed', (ledger)=>{
            this.emit('ledgerClosed', ledger);
        });
        this.connection.on('transaction', (tx)=>{
            (0, $1iQdO.handleStreamPartialPayment)(tx, this.connection.trace);
            this.emit('transaction', tx);
        });
        this.connection.on('validationReceived', (validation)=>{
            this.emit('validationReceived', validation);
        });
        this.connection.on('manifestReceived', (manifest)=>{
            this.emit('manifestReceived', manifest);
        });
        this.connection.on('peerStatusChange', (status)=>{
            this.emit('peerStatusChange', status);
        });
        this.connection.on('consensusPhase', (consensus)=>{
            this.emit('consensusPhase', consensus);
        });
        this.connection.on('path_find', (path)=>{
            this.emit('path_find', path);
        });
    }
    get url() {
        return this.connection.getUrl();
    }
    request(req) {
        var _a;
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const request = Object.assign(Object.assign({}, req), {
                account: typeof req.account === 'string' ? (0, $8zzq8.ensureClassicAddress)(req.account) : undefined,
                api_version: (_a = req.api_version) !== null && _a !== void 0 ? _a : this.apiVersion
            });
            const response = yield this.connection.request(request);
            (0, $1iQdO.handlePartialPayment)(req.command, response);
            return response;
        });
    }
    requestNextPage(req, resp) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            if (!resp.result.marker) return Promise.reject(new $aMl9I.NotFoundError('response does not have a next page'));
            const nextPageRequest = Object.assign(Object.assign({}, req), {
                marker: resp.result.marker
            });
            return this.request(nextPageRequest);
        });
    }
    on(eventName, listener) {
        return super.on(eventName, listener);
    }
    requestAll(request, collect) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const collectKey = collect !== null && collect !== void 0 ? collect : $a034aec8f2f73482$var$getCollectKeyFromCommand(request.command);
            if (!collectKey) throw new $aMl9I.ValidationError(`no collect key for command ${request.command}`);
            const countTo = request.limit == null ? Infinity : request.limit;
            let count = 0;
            let marker = request.marker;
            const results = [];
            do {
                const countRemaining = $a034aec8f2f73482$var$clamp(countTo - count, $a034aec8f2f73482$var$MIN_LIMIT, $a034aec8f2f73482$var$MAX_LIMIT);
                const repeatProps = Object.assign(Object.assign({}, request), {
                    limit: countRemaining,
                    marker: marker
                });
                const singleResponse = yield this.connection.request(repeatProps);
                const singleResult = singleResponse.result;
                if (!(collectKey in singleResult)) throw new $aMl9I.XrplError(`${collectKey} not in result`);
                const collectedData = singleResult[collectKey];
                marker = singleResult.marker;
                results.push(singleResponse);
                if (Array.isArray(collectedData)) count += collectedData.length;
            }while (Boolean(marker) && count < countTo);
            return results;
        });
    }
    getServerInfo() {
        var _a;
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const response = yield this.request({
                    command: 'server_info'
                });
                this.networkID = (_a = response.result.info.network_id) !== null && _a !== void 0 ? _a : undefined;
                this.buildVersion = response.result.info.build_version;
            } catch (error) {
                console.error(error);
            }
        });
    }
    connect() {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            return this.connection.connect().then(()=>$a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.getServerInfo();
                    this.emit('connected');
                }));
        });
    }
    disconnect() {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connection.disconnect();
        });
    }
    isConnected() {
        return this.connection.isConnected();
    }
    autofill(transaction, signersCount) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const tx = Object.assign({}, transaction);
            (0, $aCoW3.setValidAddresses)(tx);
            tx.Flags = (0, $jvbLy.convertTxFlagsToNumber)(tx);
            const promises = [];
            if (tx.NetworkID == null) tx.NetworkID = (0, $aCoW3.txNeedsNetworkID)(this) ? this.networkID : undefined;
            if (tx.Sequence == null) promises.push((0, $aCoW3.setNextValidSequenceNumber)(this, tx));
            if (tx.Fee == null) promises.push((0, $aCoW3.calculateFeePerTransactionType)(this, tx, signersCount));
            if (tx.LastLedgerSequence == null) promises.push((0, $aCoW3.setLatestValidatedLedgerSequence)(this, tx));
            if (tx.TransactionType === 'AccountDelete') promises.push((0, $aCoW3.checkAccountDeleteBlockers)(this, tx));
            if (tx.TransactionType === 'Payment' && tx.DeliverMax != null) {
                if (tx.Amount == null) tx.Amount = tx.DeliverMax;
                if (tx.Amount != null && tx.Amount !== tx.DeliverMax) return Promise.reject(new $aMl9I.ValidationError('PaymentTransaction: Amount and DeliverMax fields must be identical when both are provided'));
                delete tx.DeliverMax;
            }
            return Promise.all(promises).then(()=>tx);
        });
    }
    submit(transaction, opts) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const signedTx = yield (0, $8zzq8.getSignedTx)(this, transaction, opts);
            return (0, $8zzq8.submitRequest)(this, signedTx, opts === null || opts === void 0 ? void 0 : opts.failHard);
        });
    }
    simulate(transaction, opts) {
        var _a;
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const binary = (_a = opts === null || opts === void 0 ? void 0 : opts.binary) !== null && _a !== void 0 ? _a : false;
            const request = typeof transaction === 'string' ? {
                command: 'simulate',
                tx_blob: transaction,
                binary: binary
            } : {
                command: 'simulate',
                tx_json: transaction,
                binary: binary
            };
            return this.request(request);
        });
    }
    submitAndWait(transaction, opts) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const signedTx = yield (0, $8zzq8.getSignedTx)(this, transaction, opts);
            const lastLedger = (0, $8zzq8.getLastLedgerSequence)(signedTx);
            if (lastLedger == null) throw new $aMl9I.ValidationError('Transaction must contain a LastLedgerSequence value for reliable submission.');
            const response = yield (0, $8zzq8.submitRequest)(this, signedTx, opts === null || opts === void 0 ? void 0 : opts.failHard);
            const txHash = $3Urjz.hashes.hashSignedTx(signedTx);
            return (0, $8zzq8.waitForFinalTransactionOutcome)(this, txHash, lastLedger, response.result.engine_result);
        });
    }
    prepareTransaction(transaction, signersCount) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            return this.autofill(transaction, signersCount);
        });
    }
    getXrpBalance(address, options = {}) {
        var _a;
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const xrpRequest = {
                command: 'account_info',
                account: address,
                ledger_index: (_a = options.ledger_index) !== null && _a !== void 0 ? _a : 'validated',
                ledger_hash: options.ledger_hash
            };
            const response = yield this.request(xrpRequest);
            return (0, $3Urjz.dropsToXrp)(response.result.account_data.Balance);
        });
    }
    getBalances(address, options = {}) {
        var _a;
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const balances = [];
            let xrpPromise = Promise.resolve(0);
            if (!options.peer) xrpPromise = this.getXrpBalance(address, {
                ledger_hash: options.ledger_hash,
                ledger_index: options.ledger_index
            });
            const linesRequest = {
                command: 'account_lines',
                account: address,
                ledger_index: (_a = options.ledger_index) !== null && _a !== void 0 ? _a : 'validated',
                ledger_hash: options.ledger_hash,
                peer: options.peer,
                limit: options.limit
            };
            const linesPromise = this.requestAll(linesRequest);
            yield Promise.all([
                xrpPromise,
                linesPromise
            ]).then(([xrpBalance, linesResponses])=>{
                const accountLinesBalance = linesResponses.flatMap((response)=>(0, $9UKGz.formatBalances)(response.result.lines));
                if (xrpBalance !== 0) balances.push({
                    currency: 'XRP',
                    value: xrpBalance.toString()
                });
                balances.push(...accountLinesBalance);
            });
            return balances.slice(0, options.limit);
        });
    }
    getOrderbook(currency1, currency2, options = {}) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            (0, $73BaH.validateOrderbookOptions)(options);
            const request = (0, $73BaH.createBookOffersRequest)(currency1, currency2, options);
            const directOfferResults = yield (0, $73BaH.requestAllOffers)(this, request);
            const reverseOfferResults = yield (0, $73BaH.requestAllOffers)(this, (0, $73BaH.reverseRequest)(request));
            const directOffers = (0, $73BaH.extractOffers)(directOfferResults);
            const reverseOffers = (0, $73BaH.extractOffers)(reverseOfferResults);
            const orders = (0, $73BaH.combineOrders)(directOffers, reverseOffers);
            const { buy: buy, sell: sell } = (0, $73BaH.separateBuySellOrders)(orders);
            return {
                buy: (0, $73BaH.sortAndLimitOffers)(buy, options.limit),
                sell: (0, $73BaH.sortAndLimitOffers)(sell, options.limit)
            };
        });
    }
    getLedgerIndex() {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            const ledgerResponse = yield this.request({
                command: 'ledger',
                ledger_index: 'validated'
            });
            return ledgerResponse.result.ledger_index;
        });
    }
    fundWallet(wallet, options = {}) {
        return $a034aec8f2f73482$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isConnected()) throw new $aMl9I.RippledError('Client not connected, cannot call faucet');
            const existingWallet = Boolean(wallet);
            const walletToFund = wallet && (0, $3Urjz.isValidClassicAddress)(wallet.classicAddress) ? wallet : $81kGK.Wallet.generate();
            const postBody = {
                destination: walletToFund.classicAddress,
                xrpAmount: options.amount,
                usageContext: options.usageContext,
                userAgent: 'xrpl.js'
            };
            let startingBalance = 0;
            if (existingWallet) try {
                startingBalance = Number((yield this.getXrpBalance(walletToFund.classicAddress)));
            } catch (_a) {}
            return (0, $iQnSA.requestFunding)(options, this, startingBalance, walletToFund, postBody);
        });
    }
}
module.exports.Client = $a034aec8f2f73482$var$Client;

});
parcelRegister("6p5EE", function(module, exports) {
'use strict';
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
module.exports = $4a9976ca6ebf6735$var$EventEmitter;

});

parcelRegister("aMl9I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XRPLFaucetError = module.exports.NotFoundError = module.exports.ValidationError = module.exports.ResponseFormatError = module.exports.TimeoutError = module.exports.RippledNotInitializedError = module.exports.DisconnectedError = module.exports.NotConnectedError = module.exports.RippledError = module.exports.ConnectionError = module.exports.UnexpectedError = module.exports.XrplError = void 0;
class $7d8ecc23bd529e32$var$XrplError extends Error {
    constructor(message = '', data){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.data = data;
        if (Error.captureStackTrace != null) Error.captureStackTrace(this, this.constructor);
    }
    toString() {
        let result = `[${this.name}(${this.message}`;
        if (this.data) result += `, ${JSON.stringify(this.data)}`;
        result += ')]';
        return result;
    }
    inspect() {
        return this.toString();
    }
}
module.exports.XrplError = $7d8ecc23bd529e32$var$XrplError;
class $7d8ecc23bd529e32$var$RippledError extends $7d8ecc23bd529e32$var$XrplError {
}
module.exports.RippledError = $7d8ecc23bd529e32$var$RippledError;
class $7d8ecc23bd529e32$var$UnexpectedError extends $7d8ecc23bd529e32$var$XrplError {
}
module.exports.UnexpectedError = $7d8ecc23bd529e32$var$UnexpectedError;
class $7d8ecc23bd529e32$var$ConnectionError extends $7d8ecc23bd529e32$var$XrplError {
}
module.exports.ConnectionError = $7d8ecc23bd529e32$var$ConnectionError;
class $7d8ecc23bd529e32$var$NotConnectedError extends $7d8ecc23bd529e32$var$ConnectionError {
}
module.exports.NotConnectedError = $7d8ecc23bd529e32$var$NotConnectedError;
class $7d8ecc23bd529e32$var$DisconnectedError extends $7d8ecc23bd529e32$var$ConnectionError {
}
module.exports.DisconnectedError = $7d8ecc23bd529e32$var$DisconnectedError;
class $7d8ecc23bd529e32$var$RippledNotInitializedError extends $7d8ecc23bd529e32$var$ConnectionError {
}
module.exports.RippledNotInitializedError = $7d8ecc23bd529e32$var$RippledNotInitializedError;
class $7d8ecc23bd529e32$var$TimeoutError extends $7d8ecc23bd529e32$var$ConnectionError {
}
module.exports.TimeoutError = $7d8ecc23bd529e32$var$TimeoutError;
class $7d8ecc23bd529e32$var$ResponseFormatError extends $7d8ecc23bd529e32$var$ConnectionError {
}
module.exports.ResponseFormatError = $7d8ecc23bd529e32$var$ResponseFormatError;
class $7d8ecc23bd529e32$var$ValidationError extends $7d8ecc23bd529e32$var$XrplError {
}
module.exports.ValidationError = $7d8ecc23bd529e32$var$ValidationError;
class $7d8ecc23bd529e32$var$XRPLFaucetError extends $7d8ecc23bd529e32$var$XrplError {
}
module.exports.XRPLFaucetError = $7d8ecc23bd529e32$var$XRPLFaucetError;
class $7d8ecc23bd529e32$var$NotFoundError extends $7d8ecc23bd529e32$var$XrplError {
    constructor(message = 'Not found'){
        super(message);
    }
}
module.exports.NotFoundError = $7d8ecc23bd529e32$var$NotFoundError;

});

parcelRegister("6sfYg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_API_VERSION = module.exports.RIPPLED_API_V2 = module.exports.RIPPLED_API_V1 = void 0;
module.exports.RIPPLED_API_V1 = 1;
module.exports.RIPPLED_API_V2 = 2;
module.exports.DEFAULT_API_VERSION = module.exports.RIPPLED_API_V2;

});

parcelRegister("jvbLy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTransactionFlags = module.exports.convertTxFlagsToNumber = module.exports.setTransactionFlagsToNumber = module.exports.parseAccountRootFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $23VH6 = parcelRequire("23VH6");

var $9sZOr = parcelRequire("9sZOr");

var $4HOmt = parcelRequire("4HOmt");

var $lbyT0 = parcelRequire("lbyT0");

var $hQcIN = parcelRequire("hQcIN");

var $83INw = parcelRequire("83INw");

var $l0c6B = parcelRequire("l0c6B");

var $8W2RA = parcelRequire("8W2RA");

var $gwU9F = parcelRequire("gwU9F");

var $hWIeS = parcelRequire("hWIeS");

var $hgQ7j = parcelRequire("hgQ7j");

var $c45eL = parcelRequire("c45eL");

var $2907n = parcelRequire("2907n");

var $2sSFD = parcelRequire("2sSFD");

var $ajTnA = parcelRequire("ajTnA");

var $33Rto = parcelRequire("33Rto");
function $e32a0a0e5940ae59$var$parseAccountRootFlags(flags) {
    const flagsInterface = {};
    Object.values($23VH6.AccountRootFlags).forEach((flag)=>{
        if (typeof flag === 'string' && (0, $33Rto.isFlagEnabled)(flags, $23VH6.AccountRootFlags[flag])) flagsInterface[flag] = true;
    });
    return flagsInterface;
}
module.exports.parseAccountRootFlags = $e32a0a0e5940ae59$var$parseAccountRootFlags;
const $e32a0a0e5940ae59$var$txToFlag = {
    AccountSet: $9sZOr.AccountSetTfFlags,
    AMMClawback: $4HOmt.AMMClawbackFlags,
    AMMDeposit: $lbyT0.AMMDepositFlags,
    AMMWithdraw: $hQcIN.AMMWithdrawFlags,
    MPTokenAuthorize: $83INw.MPTokenAuthorizeFlags,
    MPTokenIssuanceCreate: $l0c6B.MPTokenIssuanceCreateFlags,
    MPTokenIssuanceSet: $8W2RA.MPTokenIssuanceSetFlags,
    NFTokenCreateOffer: $gwU9F.NFTokenCreateOfferFlags,
    NFTokenMint: $hWIeS.NFTokenMintFlags,
    OfferCreate: $hgQ7j.OfferCreateFlags,
    PaymentChannelClaim: $2907n.PaymentChannelClaimFlags,
    Payment: $c45eL.PaymentFlags,
    TrustSet: $2sSFD.TrustSetFlags,
    XChainModifyBridge: $ajTnA.XChainModifyBridgeFlags
};
function $e32a0a0e5940ae59$var$isTxToFlagKey(transactionType) {
    return transactionType in $e32a0a0e5940ae59$var$txToFlag;
}
function $e32a0a0e5940ae59$var$setTransactionFlagsToNumber(tx) {
    console.warn('This function is deprecated. Use convertTxFlagsToNumber() instead and use the returned value to modify the Transaction.Flags from the caller.');
    if (tx.Flags) tx.Flags = $e32a0a0e5940ae59$var$convertTxFlagsToNumber(tx);
}
module.exports.setTransactionFlagsToNumber = $e32a0a0e5940ae59$var$setTransactionFlagsToNumber;
function $e32a0a0e5940ae59$var$convertTxFlagsToNumber(tx) {
    if (!tx.Flags) return 0;
    if (typeof tx.Flags === 'number') return tx.Flags;
    if ($e32a0a0e5940ae59$var$isTxToFlagKey(tx.TransactionType)) {
        const flagEnum = $e32a0a0e5940ae59$var$txToFlag[tx.TransactionType];
        return Object.keys(tx.Flags).reduce((resultFlags, flag)=>{
            var _a;
            if (flagEnum[flag] == null) throw new $aMl9I.ValidationError(`Invalid flag ${flag}. Valid flags are ${JSON.stringify(flagEnum)}`);
            return ((_a = tx.Flags) === null || _a === void 0 ? void 0 : _a[flag]) ? resultFlags | flagEnum[flag] : resultFlags;
        }, 0);
    }
    return 0;
}
module.exports.convertTxFlagsToNumber = $e32a0a0e5940ae59$var$convertTxFlagsToNumber;
function $e32a0a0e5940ae59$var$parseTransactionFlags(tx) {
    const flags = $e32a0a0e5940ae59$var$convertTxFlagsToNumber(tx);
    if (flags === 0) return {};
    const booleanFlagMap = {};
    if ($e32a0a0e5940ae59$var$isTxToFlagKey(tx.TransactionType)) {
        const transactionTypeFlags = $e32a0a0e5940ae59$var$txToFlag[tx.TransactionType];
        Object.values(transactionTypeFlags).forEach((flag)=>{
            if (typeof flag === 'string' && (0, $33Rto.isFlagEnabled)(flags, transactionTypeFlags[flag])) booleanFlagMap[flag] = true;
        });
    }
    return booleanFlagMap;
}
module.exports.parseTransactionFlags = $e32a0a0e5940ae59$var$parseTransactionFlags;

});
parcelRegister("23VH6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountRootFlags = void 0;
var $18089d712d73ed49$var$AccountRootFlags;
(function(AccountRootFlags) {
    AccountRootFlags[AccountRootFlags["lsfPasswordSpent"] = 65536] = "lsfPasswordSpent";
    AccountRootFlags[AccountRootFlags["lsfRequireDestTag"] = 131072] = "lsfRequireDestTag";
    AccountRootFlags[AccountRootFlags["lsfRequireAuth"] = 262144] = "lsfRequireAuth";
    AccountRootFlags[AccountRootFlags["lsfDisallowXRP"] = 524288] = "lsfDisallowXRP";
    AccountRootFlags[AccountRootFlags["lsfDisableMaster"] = 1048576] = "lsfDisableMaster";
    AccountRootFlags[AccountRootFlags["lsfNoFreeze"] = 2097152] = "lsfNoFreeze";
    AccountRootFlags[AccountRootFlags["lsfGlobalFreeze"] = 4194304] = "lsfGlobalFreeze";
    AccountRootFlags[AccountRootFlags["lsfDefaultRipple"] = 8388608] = "lsfDefaultRipple";
    AccountRootFlags[AccountRootFlags["lsfDepositAuth"] = 16777216] = "lsfDepositAuth";
    AccountRootFlags[AccountRootFlags["lsfAMM"] = 33554432] = "lsfAMM";
    AccountRootFlags[AccountRootFlags["lsfDisallowIncomingNFTokenOffer"] = 67108864] = "lsfDisallowIncomingNFTokenOffer";
    AccountRootFlags[AccountRootFlags["lsfDisallowIncomingCheck"] = 134217728] = "lsfDisallowIncomingCheck";
    AccountRootFlags[AccountRootFlags["lsfDisallowIncomingPayChan"] = 268435456] = "lsfDisallowIncomingPayChan";
    AccountRootFlags[AccountRootFlags["lsfDisallowIncomingTrustline"] = 536870912] = "lsfDisallowIncomingTrustline";
    AccountRootFlags[AccountRootFlags["lsfAllowTrustLineClawback"] = 2147483648] = "lsfAllowTrustLineClawback";
})($18089d712d73ed49$var$AccountRootFlags || (module.exports.AccountRootFlags = $18089d712d73ed49$var$AccountRootFlags = {}));

});

parcelRegister("9sZOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAccountSet = module.exports.AccountSetTfFlags = module.exports.AccountSetAsfFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $6e46ad43eaeb7adb$var$AccountSetAsfFlags;
(function(AccountSetAsfFlags) {
    AccountSetAsfFlags[AccountSetAsfFlags["asfRequireDest"] = 1] = "asfRequireDest";
    AccountSetAsfFlags[AccountSetAsfFlags["asfRequireAuth"] = 2] = "asfRequireAuth";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDisallowXRP"] = 3] = "asfDisallowXRP";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDisableMaster"] = 4] = "asfDisableMaster";
    AccountSetAsfFlags[AccountSetAsfFlags["asfAccountTxnID"] = 5] = "asfAccountTxnID";
    AccountSetAsfFlags[AccountSetAsfFlags["asfNoFreeze"] = 6] = "asfNoFreeze";
    AccountSetAsfFlags[AccountSetAsfFlags["asfGlobalFreeze"] = 7] = "asfGlobalFreeze";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDefaultRipple"] = 8] = "asfDefaultRipple";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDepositAuth"] = 9] = "asfDepositAuth";
    AccountSetAsfFlags[AccountSetAsfFlags["asfAuthorizedNFTokenMinter"] = 10] = "asfAuthorizedNFTokenMinter";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDisallowIncomingNFTokenOffer"] = 12] = "asfDisallowIncomingNFTokenOffer";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDisallowIncomingCheck"] = 13] = "asfDisallowIncomingCheck";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDisallowIncomingPayChan"] = 14] = "asfDisallowIncomingPayChan";
    AccountSetAsfFlags[AccountSetAsfFlags["asfDisallowIncomingTrustline"] = 15] = "asfDisallowIncomingTrustline";
    AccountSetAsfFlags[AccountSetAsfFlags["asfAllowTrustLineClawback"] = 16] = "asfAllowTrustLineClawback";
})($6e46ad43eaeb7adb$var$AccountSetAsfFlags || (module.exports.AccountSetAsfFlags = $6e46ad43eaeb7adb$var$AccountSetAsfFlags = {}));
var $6e46ad43eaeb7adb$var$AccountSetTfFlags;
(function(AccountSetTfFlags) {
    AccountSetTfFlags[AccountSetTfFlags["tfRequireDestTag"] = 65536] = "tfRequireDestTag";
    AccountSetTfFlags[AccountSetTfFlags["tfOptionalDestTag"] = 131072] = "tfOptionalDestTag";
    AccountSetTfFlags[AccountSetTfFlags["tfRequireAuth"] = 262144] = "tfRequireAuth";
    AccountSetTfFlags[AccountSetTfFlags["tfOptionalAuth"] = 524288] = "tfOptionalAuth";
    AccountSetTfFlags[AccountSetTfFlags["tfDisallowXRP"] = 1048576] = "tfDisallowXRP";
    AccountSetTfFlags[AccountSetTfFlags["tfAllowXRP"] = 2097152] = "tfAllowXRP";
})($6e46ad43eaeb7adb$var$AccountSetTfFlags || (module.exports.AccountSetTfFlags = $6e46ad43eaeb7adb$var$AccountSetTfFlags = {}));
const $6e46ad43eaeb7adb$var$MIN_TICK_SIZE = 3;
const $6e46ad43eaeb7adb$var$MAX_TICK_SIZE = 15;
function $6e46ad43eaeb7adb$var$validateAccountSet(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'NFTokenMinter', $aDIrf.isAccount);
    if (tx.ClearFlag !== undefined) {
        if (typeof tx.ClearFlag !== 'number') throw new $aMl9I.ValidationError('AccountSet: invalid ClearFlag');
        if (!Object.values($6e46ad43eaeb7adb$var$AccountSetAsfFlags).includes(tx.ClearFlag)) throw new $aMl9I.ValidationError('AccountSet: invalid ClearFlag');
    }
    if (tx.Domain !== undefined && typeof tx.Domain !== 'string') throw new $aMl9I.ValidationError('AccountSet: invalid Domain');
    if (tx.EmailHash !== undefined && typeof tx.EmailHash !== 'string') throw new $aMl9I.ValidationError('AccountSet: invalid EmailHash');
    if (tx.MessageKey !== undefined && typeof tx.MessageKey !== 'string') throw new $aMl9I.ValidationError('AccountSet: invalid MessageKey');
    if (tx.SetFlag !== undefined) {
        if (typeof tx.SetFlag !== 'number') throw new $aMl9I.ValidationError('AccountSet: invalid SetFlag');
        if (!Object.values($6e46ad43eaeb7adb$var$AccountSetAsfFlags).includes(tx.SetFlag)) throw new $aMl9I.ValidationError('AccountSet: invalid SetFlag');
    }
    if (tx.TransferRate !== undefined && typeof tx.TransferRate !== 'number') throw new $aMl9I.ValidationError('AccountSet: invalid TransferRate');
    if (tx.TickSize !== undefined) {
        if (typeof tx.TickSize !== 'number') throw new $aMl9I.ValidationError('AccountSet: invalid TickSize');
        if (tx.TickSize !== 0 && (tx.TickSize < $6e46ad43eaeb7adb$var$MIN_TICK_SIZE || tx.TickSize > $6e46ad43eaeb7adb$var$MAX_TICK_SIZE)) throw new $aMl9I.ValidationError('AccountSet: invalid TickSize');
    }
}
module.exports.validateAccountSet = $6e46ad43eaeb7adb$var$validateAccountSet;

});
parcelRegister("aDIrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.containsDuplicates = module.exports.validateCredentialsList = module.exports.validateCredentialType = module.exports.parseAmountValue = module.exports.validateBaseTransaction = module.exports.validateOptionalField = module.exports.validateRequiredField = module.exports.isXChainBridge = module.exports.isAmount = module.exports.isAccount = module.exports.isMPTAmount = module.exports.isAuthorizeCredential = module.exports.isIssuedCurrency = module.exports.isCurrency = module.exports.isNumber = module.exports.isString = module.exports.MAX_AUTHORIZED_CREDENTIALS = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $7eC3g = parcelRequire("7eC3g");

var $eLMUD = parcelRequire("eLMUD");

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");
const $7bf004742536b30e$var$MEMO_SIZE = 3;
module.exports.MAX_AUTHORIZED_CREDENTIALS = 8;
const $7bf004742536b30e$var$MAX_CREDENTIAL_BYTE_LENGTH = 64;
const $7bf004742536b30e$var$MAX_CREDENTIAL_TYPE_LENGTH = $7bf004742536b30e$var$MAX_CREDENTIAL_BYTE_LENGTH * 2;
function $7bf004742536b30e$var$isMemo(obj) {
    if (obj.Memo == null) return false;
    const memo = obj.Memo;
    const size = Object.keys(memo).length;
    const validData = memo.MemoData == null || typeof memo.MemoData === 'string';
    const validFormat = memo.MemoFormat == null || typeof memo.MemoFormat === 'string';
    const validType = memo.MemoType == null || typeof memo.MemoType === 'string';
    return size >= 1 && size <= $7bf004742536b30e$var$MEMO_SIZE && validData && validFormat && validType && (0, $33Rto.onlyHasFields)(memo, [
        'MemoFormat',
        'MemoData',
        'MemoType'
    ]);
}
const $7bf004742536b30e$var$SIGNER_SIZE = 3;
function $7bf004742536b30e$var$isSigner(obj) {
    const signerWrapper = obj;
    if (signerWrapper.Signer == null) return false;
    const signer = signerWrapper.Signer;
    return Object.keys(signer).length === $7bf004742536b30e$var$SIGNER_SIZE && typeof signer.Account === 'string' && typeof signer.TxnSignature === 'string' && typeof signer.SigningPubKey === 'string';
}
const $7bf004742536b30e$var$XRP_CURRENCY_SIZE = 1;
const $7bf004742536b30e$var$ISSUE_SIZE = 2;
const $7bf004742536b30e$var$ISSUED_CURRENCY_SIZE = 3;
const $7bf004742536b30e$var$XCHAIN_BRIDGE_SIZE = 4;
const $7bf004742536b30e$var$MPTOKEN_SIZE = 2;
const $7bf004742536b30e$var$AUTHORIZE_CREDENTIAL_SIZE = 1;
function $7bf004742536b30e$var$isRecord(value) {
    return value !== null && typeof value === 'object';
}
function $7bf004742536b30e$var$isString(str) {
    return typeof str === 'string';
}
module.exports.isString = $7bf004742536b30e$var$isString;
function $7bf004742536b30e$var$isNumber(num) {
    return typeof num === 'number';
}
module.exports.isNumber = $7bf004742536b30e$var$isNumber;
function $7bf004742536b30e$var$isCurrency(input) {
    return $7bf004742536b30e$var$isRecord(input) && (Object.keys(input).length === $7bf004742536b30e$var$ISSUE_SIZE && typeof input.issuer === 'string' && typeof input.currency === 'string' || Object.keys(input).length === $7bf004742536b30e$var$XRP_CURRENCY_SIZE && input.currency === 'XRP');
}
module.exports.isCurrency = $7bf004742536b30e$var$isCurrency;
function $7bf004742536b30e$var$isIssuedCurrency(input) {
    return $7bf004742536b30e$var$isRecord(input) && Object.keys(input).length === $7bf004742536b30e$var$ISSUED_CURRENCY_SIZE && typeof input.value === 'string' && typeof input.issuer === 'string' && typeof input.currency === 'string';
}
module.exports.isIssuedCurrency = $7bf004742536b30e$var$isIssuedCurrency;
function $7bf004742536b30e$var$isAuthorizeCredential(input) {
    return $7bf004742536b30e$var$isRecord(input) && $7bf004742536b30e$var$isRecord(input.Credential) && Object.keys(input).length === $7bf004742536b30e$var$AUTHORIZE_CREDENTIAL_SIZE && typeof input.Credential.CredentialType === 'string' && typeof input.Credential.Issuer === 'string';
}
module.exports.isAuthorizeCredential = $7bf004742536b30e$var$isAuthorizeCredential;
function $7bf004742536b30e$var$isMPTAmount(input) {
    return $7bf004742536b30e$var$isRecord(input) && Object.keys(input).length === $7bf004742536b30e$var$MPTOKEN_SIZE && typeof input.value === 'string' && typeof input.mpt_issuance_id === 'string';
}
module.exports.isMPTAmount = $7bf004742536b30e$var$isMPTAmount;
function $7bf004742536b30e$var$isAccount(account) {
    return typeof account === 'string' && ((0, $7eC3g.isValidClassicAddress)(account) || (0, $7eC3g.isValidXAddress)(account));
}
module.exports.isAccount = $7bf004742536b30e$var$isAccount;
function $7bf004742536b30e$var$isAmount(amount) {
    return typeof amount === 'string' || $7bf004742536b30e$var$isIssuedCurrency(amount) || $7bf004742536b30e$var$isMPTAmount(amount);
}
module.exports.isAmount = $7bf004742536b30e$var$isAmount;
function $7bf004742536b30e$var$isXChainBridge(input) {
    return $7bf004742536b30e$var$isRecord(input) && Object.keys(input).length === $7bf004742536b30e$var$XCHAIN_BRIDGE_SIZE && typeof input.LockingChainDoor === 'string' && $7bf004742536b30e$var$isCurrency(input.LockingChainIssue) && typeof input.IssuingChainDoor === 'string' && $7bf004742536b30e$var$isCurrency(input.IssuingChainIssue);
}
module.exports.isXChainBridge = $7bf004742536b30e$var$isXChainBridge;
function $7bf004742536b30e$var$validateRequiredField(tx, paramName, checkValidity) {
    if (tx[paramName] == null) throw new $aMl9I.ValidationError(`${tx.TransactionType}: missing field ${paramName}`);
    if (!checkValidity(tx[paramName])) throw new $aMl9I.ValidationError(`${tx.TransactionType}: invalid field ${paramName}`);
}
module.exports.validateRequiredField = $7bf004742536b30e$var$validateRequiredField;
function $7bf004742536b30e$var$validateOptionalField(tx, paramName, checkValidity) {
    if (tx[paramName] !== undefined && !checkValidity(tx[paramName])) throw new $aMl9I.ValidationError(`${tx.TransactionType}: invalid field ${paramName}`);
}
module.exports.validateOptionalField = $7bf004742536b30e$var$validateOptionalField;
function $7bf004742536b30e$var$validateBaseTransaction(common) {
    if (common.TransactionType === undefined) throw new $aMl9I.ValidationError('BaseTransaction: missing field TransactionType');
    if (typeof common.TransactionType !== 'string') throw new $aMl9I.ValidationError('BaseTransaction: TransactionType not string');
    if (!$eLMUD.TRANSACTION_TYPES.includes(common.TransactionType)) throw new $aMl9I.ValidationError('BaseTransaction: Unknown TransactionType');
    $7bf004742536b30e$var$validateRequiredField(common, 'Account', $7bf004742536b30e$var$isString);
    $7bf004742536b30e$var$validateOptionalField(common, 'Fee', $7bf004742536b30e$var$isString);
    $7bf004742536b30e$var$validateOptionalField(common, 'Sequence', $7bf004742536b30e$var$isNumber);
    $7bf004742536b30e$var$validateOptionalField(common, 'AccountTxnID', $7bf004742536b30e$var$isString);
    $7bf004742536b30e$var$validateOptionalField(common, 'LastLedgerSequence', $7bf004742536b30e$var$isNumber);
    const memos = common.Memos;
    if (memos !== undefined && !memos.every($7bf004742536b30e$var$isMemo)) throw new $aMl9I.ValidationError('BaseTransaction: invalid Memos');
    const signers = common.Signers;
    if (signers !== undefined && (signers.length === 0 || !signers.every($7bf004742536b30e$var$isSigner))) throw new $aMl9I.ValidationError('BaseTransaction: invalid Signers');
    $7bf004742536b30e$var$validateOptionalField(common, 'SourceTag', $7bf004742536b30e$var$isNumber);
    $7bf004742536b30e$var$validateOptionalField(common, 'SigningPubKey', $7bf004742536b30e$var$isString);
    $7bf004742536b30e$var$validateOptionalField(common, 'TicketSequence', $7bf004742536b30e$var$isNumber);
    $7bf004742536b30e$var$validateOptionalField(common, 'TxnSignature', $7bf004742536b30e$var$isString);
    $7bf004742536b30e$var$validateOptionalField(common, 'NetworkID', $7bf004742536b30e$var$isNumber);
}
module.exports.validateBaseTransaction = $7bf004742536b30e$var$validateBaseTransaction;
function $7bf004742536b30e$var$parseAmountValue(amount) {
    if (!$7bf004742536b30e$var$isAmount(amount)) return NaN;
    if (typeof amount === 'string') return parseFloat(amount);
    return parseFloat(amount.value);
}
module.exports.parseAmountValue = $7bf004742536b30e$var$parseAmountValue;
function $7bf004742536b30e$var$validateCredentialType(tx) {
    if (typeof tx.TransactionType !== 'string') throw new $aMl9I.ValidationError('Invalid TransactionType');
    if (tx.CredentialType === undefined) throw new $aMl9I.ValidationError(`${tx.TransactionType}: missing field CredentialType`);
    if (!$7bf004742536b30e$var$isString(tx.CredentialType)) throw new $aMl9I.ValidationError(`${tx.TransactionType}: CredentialType must be a string`);
    if (tx.CredentialType.length === 0) throw new $aMl9I.ValidationError(`${tx.TransactionType}: CredentialType cannot be an empty string`);
    else if (tx.CredentialType.length > $7bf004742536b30e$var$MAX_CREDENTIAL_TYPE_LENGTH) throw new $aMl9I.ValidationError(`${tx.TransactionType}: CredentialType length cannot be > ${$7bf004742536b30e$var$MAX_CREDENTIAL_TYPE_LENGTH}`);
    if (!$8wxDW.HEX_REGEX.test(tx.CredentialType)) throw new $aMl9I.ValidationError(`${tx.TransactionType}: CredentialType must be encoded in hex`);
}
module.exports.validateCredentialType = $7bf004742536b30e$var$validateCredentialType;
function $7bf004742536b30e$var$validateCredentialsList(credentials, transactionType, isStringID, maxCredentials) {
    if (credentials == null) return;
    if (!Array.isArray(credentials)) throw new $aMl9I.ValidationError(`${transactionType}: Credentials must be an array`);
    if (credentials.length > maxCredentials) throw new $aMl9I.ValidationError(`${transactionType}: Credentials length cannot exceed ${maxCredentials} elements`);
    else if (credentials.length === 0) throw new $aMl9I.ValidationError(`${transactionType}: Credentials cannot be an empty array`);
    credentials.forEach((credential)=>{
        if (isStringID) {
            if (!$7bf004742536b30e$var$isString(credential)) throw new $aMl9I.ValidationError(`${transactionType}: Invalid Credentials ID list format`);
        } else if (!$7bf004742536b30e$var$isAuthorizeCredential(credential)) throw new $aMl9I.ValidationError(`${transactionType}: Invalid Credentials format`);
    });
    if ($7bf004742536b30e$var$containsDuplicates(credentials)) throw new $aMl9I.ValidationError(`${transactionType}: Credentials cannot contain duplicate elements`);
}
module.exports.validateCredentialsList = $7bf004742536b30e$var$validateCredentialsList;
function $7bf004742536b30e$var$isAuthorizeCredentialArray(list) {
    return typeof list[0] !== 'string';
}
function $7bf004742536b30e$var$containsDuplicates(objectList) {
    if (typeof objectList[0] === 'string') {
        const objSet = new Set(objectList.map((obj)=>JSON.stringify(obj)));
        return objSet.size !== objectList.length;
    }
    const seen = new Set();
    if ($7bf004742536b30e$var$isAuthorizeCredentialArray(objectList)) for (const item of objectList){
        const key = `${item.Credential.Issuer}-${item.Credential.CredentialType}`;
        if (seen.has(key)) return true;
        seen.add(key);
    }
    return false;
}
module.exports.containsDuplicates = $7bf004742536b30e$var$containsDuplicates;

});
parcelRegister("8wxDW", function(module, exports) {
"use strict";
var $634b68bdb09a07c9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $634b68bdb09a07c9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $634b68bdb09a07c9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.stringToHex = module.exports.hexToString = module.exports.hexToBytes = module.exports.bytesToHex = void 0;

var $ebEok = parcelRequire("ebEok");

/* eslint-disable func-style -- Typed to ensure uniformity between node and browser implementations and docs */ const $634b68bdb09a07c9$var$bytesToHex = (bytes)=>{
    const hex = (0, $ebEok.bytesToHex)(bytes instanceof Uint8Array ? bytes : Uint8Array.from(bytes));
    return hex.toUpperCase();
};
module.exports.bytesToHex = $634b68bdb09a07c9$var$bytesToHex;
// A clone of hexToBytes from @noble/hashes without the length checks. This allows us to do our own checks.
const $634b68bdb09a07c9$var$hexToBytes = (hex)=>{
    const len = hex.length;
    const array = new Uint8Array(len / 2);
    if (!(parcelRequire("fi5dx")).HEX_REGEX.test(hex)) throw new Error('Invalid hex string');
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error('Invalid byte sequence');
        array[i] = byte;
    }
    return array;
};
module.exports.hexToBytes = $634b68bdb09a07c9$var$hexToBytes;
const $634b68bdb09a07c9$var$hexToString = (hex, encoding = 'utf8')=>{
    return new TextDecoder(encoding).decode((0, module.exports.hexToBytes)(hex));
};
module.exports.hexToString = $634b68bdb09a07c9$var$hexToString;
const $634b68bdb09a07c9$var$stringToHex = (string)=>{
    return (0, module.exports.bytesToHex)(new TextEncoder().encode(string));
};
module.exports.stringToHex = $634b68bdb09a07c9$var$stringToHex;
/* eslint-enable func-style */ module.exports.randomBytes = $ebEok.randomBytes;

$634b68bdb09a07c9$var$__exportStar((parcelRequire("fi5dx")), module.exports);

});
parcelRegister("fi5dx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.equal = module.exports.concat = module.exports.HEX_REGEX = void 0;

var $ebEok = parcelRequire("ebEok");
module.exports.HEX_REGEX = /^[A-F0-9]*$/iu;
function $b21c957fef1ff7c7$var$concat(views) {
    return (0, $ebEok.concatBytes)(...views);
}
module.exports.concat = $b21c957fef1ff7c7$var$concat;
function $b21c957fef1ff7c7$var$equal(buf1, buf2) {
    if (buf1.byteLength !== buf2.byteLength) return false;
    const dv1 = new Int8Array(buf1);
    const dv2 = new Int8Array(buf2);
    for(let i = 0; i !== buf1.byteLength; i++){
        if (dv1[i] !== dv2[i]) return false;
    }
    return true;
}
module.exports.equal = $b21c957fef1ff7c7$var$equal;

});


parcelRegister("7eC3g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidXAddress = module.exports.decodeXAddress = module.exports.xAddressToClassicAddress = module.exports.encodeXAddress = module.exports.classicAddressToXAddress = module.exports.isValidClassicAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.decodeNodePublic = module.exports.encodeNodePublic = module.exports.decodeAccountID = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.codec = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $7ecTF = parcelRequire("7ecTF");
Object.defineProperty(module.exports, "codec", {
    enumerable: true,
    get: function() {
        return $7ecTF.codec;
    }
});
Object.defineProperty(module.exports, "encodeSeed", {
    enumerable: true,
    get: function() {
        return $7ecTF.encodeSeed;
    }
});
Object.defineProperty(module.exports, "decodeSeed", {
    enumerable: true,
    get: function() {
        return $7ecTF.decodeSeed;
    }
});
Object.defineProperty(module.exports, "encodeAccountID", {
    enumerable: true,
    get: function() {
        return $7ecTF.encodeAccountID;
    }
});
Object.defineProperty(module.exports, "decodeAccountID", {
    enumerable: true,
    get: function() {
        return $7ecTF.decodeAccountID;
    }
});
Object.defineProperty(module.exports, "encodeNodePublic", {
    enumerable: true,
    get: function() {
        return $7ecTF.encodeNodePublic;
    }
});
Object.defineProperty(module.exports, "decodeNodePublic", {
    enumerable: true,
    get: function() {
        return $7ecTF.decodeNodePublic;
    }
});
Object.defineProperty(module.exports, "encodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $7ecTF.encodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "decodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $7ecTF.decodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "isValidClassicAddress", {
    enumerable: true,
    get: function() {
        return $7ecTF.isValidClassicAddress;
    }
});
const $54475b75e19f2670$var$PREFIX_BYTES = {
    // 5, 68
    main: Uint8Array.from([
        0x05,
        0x44
    ]),
    // 4, 147
    test: Uint8Array.from([
        0x04,
        0x93
    ])
};
const $54475b75e19f2670$var$MAX_32_BIT_UNSIGNED_INT = 4294967295;
function $54475b75e19f2670$var$classicAddressToXAddress(classicAddress, tag, test) {
    const accountId = (0, $7ecTF.decodeAccountID)(classicAddress);
    return $54475b75e19f2670$var$encodeXAddress(accountId, tag, test);
}
module.exports.classicAddressToXAddress = $54475b75e19f2670$var$classicAddressToXAddress;
function $54475b75e19f2670$var$encodeXAddress(accountId, tag, test) {
    if (accountId.length !== 20) // RIPEMD160 is 160 bits = 20 bytes
    throw new Error('Account ID must be 20 bytes');
    if (tag !== false && tag > $54475b75e19f2670$var$MAX_32_BIT_UNSIGNED_INT) throw new Error('Invalid tag');
    const theTag = tag || 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Passing null is a common js mistake
    const flag = tag === false || tag == null ? 0 : 1;
    /* eslint-disable no-bitwise ---
     * need to use bitwise operations here */ const bytes = (0, $8wxDW.concat)([
        test ? $54475b75e19f2670$var$PREFIX_BYTES.test : $54475b75e19f2670$var$PREFIX_BYTES.main,
        accountId,
        Uint8Array.from([
            // 0x00 if no tag, 0x01 if 32-bit tag
            flag,
            // first byte
            theTag & 0xff,
            // second byte
            theTag >> 8 & 0xff,
            // third byte
            theTag >> 16 & 0xff,
            // fourth byte
            theTag >> 24 & 0xff,
            0,
            0,
            0,
            // four zero bytes (reserved for 64-bit tags)
            0
        ])
    ]);
    /* eslint-enable no-bitwise */ return $7ecTF.codec.encodeChecked(bytes);
}
module.exports.encodeXAddress = $54475b75e19f2670$var$encodeXAddress;
function $54475b75e19f2670$var$xAddressToClassicAddress(xAddress) {
    /* eslint-disable @typescript-eslint/naming-convention --
     * TODO 'test' should be something like 'isTest', do this later
     */ const { accountId: accountId, tag: tag, test: test } = $54475b75e19f2670$var$decodeXAddress(xAddress);
    /* eslint-enable @typescript-eslint/naming-convention */ const classicAddress = (0, $7ecTF.encodeAccountID)(accountId);
    return {
        classicAddress: classicAddress,
        tag: tag,
        test: test
    };
}
module.exports.xAddressToClassicAddress = $54475b75e19f2670$var$xAddressToClassicAddress;
function $54475b75e19f2670$var$decodeXAddress(xAddress) {
    const decoded = $7ecTF.codec.decodeChecked(xAddress);
    /* eslint-disable @typescript-eslint/naming-convention --
     * TODO 'test' should be something like 'isTest', do this later
     */ const test = $54475b75e19f2670$var$isUint8ArrayForTestAddress(decoded);
    /* eslint-enable @typescript-eslint/naming-convention */ const accountId = decoded.slice(2, 22);
    const tag = $54475b75e19f2670$var$tagFromUint8Array(decoded);
    return {
        accountId: accountId,
        tag: tag,
        test: test
    };
}
module.exports.decodeXAddress = $54475b75e19f2670$var$decodeXAddress;
function $54475b75e19f2670$var$isUint8ArrayForTestAddress(buf) {
    const decodedPrefix = buf.slice(0, 2);
    if ((0, $8wxDW.equal)($54475b75e19f2670$var$PREFIX_BYTES.main, decodedPrefix)) return false;
    if ((0, $8wxDW.equal)($54475b75e19f2670$var$PREFIX_BYTES.test, decodedPrefix)) return true;
    throw new Error('Invalid X-address: bad prefix');
}
function $54475b75e19f2670$var$tagFromUint8Array(buf) {
    const flag = buf[22];
    if (flag >= 2) // No support for 64-bit tags at this time
    throw new Error('Unsupported X-address');
    if (flag === 1) // Little-endian to big-endian
    return buf[23] + buf[24] * 0x100 + buf[25] * 0x10000 + buf[26] * 0x1000000;
    if (flag !== 0) throw new Error('flag must be zero to indicate no tag');
    if (!(0, $8wxDW.equal)((0, $8wxDW.hexToBytes)('0000000000000000'), buf.slice(23, 31))) throw new Error('remaining bytes must be zero');
    return false;
}
function $54475b75e19f2670$var$isValidXAddress(xAddress) {
    try {
        $54475b75e19f2670$var$decodeXAddress(xAddress);
    } catch (_error) {
        return false;
    }
    return true;
}
module.exports.isValidXAddress = $54475b75e19f2670$var$isValidXAddress;

});
parcelRegister("7ecTF", function(module, exports) {
"use strict";
/**
 * Codec class
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidClassicAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.encodeNodePublic = module.exports.decodeNodePublic = module.exports.decodeAddress = module.exports.decodeAccountID = module.exports.encodeAddress = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.codec = void 0;

var $3ctkB = parcelRequire("3ctkB");

var $eWnEn = parcelRequire("eWnEn");

var $lGyLP = parcelRequire("lGyLP");
class $5433d83c0b966be1$var$Codec {
    constructor(options){
        this._sha256 = options.sha256;
        this._codec = $3ctkB.base58xrp;
    }
    /**
     * Encoder.
     *
     * @param bytes - Uint8Array of data to encode.
     * @param opts - Options object including the version bytes and the expected length of the data to encode.
     */ encode(bytes, opts) {
        const versions = opts.versions;
        return this._encodeVersioned(bytes, versions, opts.expectedLength);
    }
    /**
     * Decoder.
     *
     * @param base58string - Base58Check-encoded string to decode.
     * @param opts - Options object including the version byte(s) and the expected length of the data after decoding.
     */ /* eslint-disable max-lines-per-function --
     * TODO refactor */ decode(base58string, opts) {
        var _a;
        const versions = opts.versions;
        const types = opts.versionTypes;
        const withoutSum = this.decodeChecked(base58string);
        if (versions.length > 1 && !opts.expectedLength) throw new Error('expectedLength is required because there are >= 2 possible versions');
        const versionLengthGuess = typeof versions[0] === 'number' ? 1 : versions[0].length;
        const payloadLength = (_a = opts.expectedLength) !== null && _a !== void 0 ? _a : withoutSum.length - versionLengthGuess;
        const versionBytes = withoutSum.slice(0, -payloadLength);
        const payload = withoutSum.slice(-payloadLength);
        for(let i = 0; i < versions.length; i++){
            /* eslint-disable @typescript-eslint/consistent-type-assertions --
             * TODO refactor */ const version = Array.isArray(versions[i]) ? versions[i] : [
                versions[i]
            ];
            if ((0, $lGyLP.arrayEqual)(versionBytes, version)) return {
                version: version,
                bytes: payload,
                type: types ? types[i] : null
            };
        /* eslint-enable @typescript-eslint/consistent-type-assertions */ }
        throw new Error('version_invalid: version bytes do not match any of the provided version(s)');
    }
    encodeChecked(bytes) {
        const check = this._sha256(this._sha256(bytes)).slice(0, 4);
        return this._encodeRaw(Uint8Array.from((0, $lGyLP.concatArgs)(bytes, check)));
    }
    decodeChecked(base58string) {
        const intArray = this._decodeRaw(base58string);
        if (intArray.byteLength < 5) throw new Error('invalid_input_size: decoded data must have length >= 5');
        if (!this._verifyCheckSum(intArray)) throw new Error('checksum_invalid');
        return intArray.slice(0, -4);
    }
    _encodeVersioned(bytes, versions, expectedLength) {
        if (!$5433d83c0b966be1$var$checkByteLength(bytes, expectedLength)) throw new Error("unexpected_payload_length: bytes.length does not match expectedLength. Ensure that the bytes are a Uint8Array.");
        return this.encodeChecked((0, $lGyLP.concatArgs)(versions, bytes));
    }
    _encodeRaw(bytes) {
        return this._codec.encode(Uint8Array.from(bytes));
    }
    /* eslint-enable max-lines-per-function */ _decodeRaw(base58string) {
        return this._codec.decode(base58string);
    }
    _verifyCheckSum(bytes) {
        const computed = this._sha256(this._sha256(bytes.slice(0, -4))).slice(0, 4);
        const checksum = bytes.slice(-4);
        return (0, $lGyLP.arrayEqual)(computed, checksum);
    }
}
/**
 * XRP codec
 */ // base58 encodings: https://xrpl.org/base58-encodings.html
// Account address (20 bytes)
const $5433d83c0b966be1$var$ACCOUNT_ID = 0;
// Account public key (33 bytes)
const $5433d83c0b966be1$var$ACCOUNT_PUBLIC_KEY = 0x23;
// 33; Seed value (for secret keys) (16 bytes)
const $5433d83c0b966be1$var$FAMILY_SEED = 0x21;
// 28; Validation public key (33 bytes)
const $5433d83c0b966be1$var$NODE_PUBLIC = 0x1c;
// [1, 225, 75]
const $5433d83c0b966be1$var$ED25519_SEED = [
    0x01,
    0xe1,
    0x4b
];
const $5433d83c0b966be1$var$codecOptions = {
    sha256: $eWnEn.sha256
};
const $5433d83c0b966be1$var$codecWithXrpAlphabet = new $5433d83c0b966be1$var$Codec($5433d83c0b966be1$var$codecOptions);
module.exports.codec = $5433d83c0b966be1$var$codecWithXrpAlphabet;
// entropy is a Uint8Array of size 16
// type is 'ed25519' or 'secp256k1'
function $5433d83c0b966be1$var$encodeSeed(entropy, type) {
    if (!$5433d83c0b966be1$var$checkByteLength(entropy, 16)) throw new Error('entropy must have length 16');
    const opts = {
        expectedLength: 16,
        // for secp256k1, use `FAMILY_SEED`
        versions: type === 'ed25519' ? $5433d83c0b966be1$var$ED25519_SEED : [
            $5433d83c0b966be1$var$FAMILY_SEED
        ]
    };
    // prefixes entropy with version bytes
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.encode(entropy, opts);
}
module.exports.encodeSeed = $5433d83c0b966be1$var$encodeSeed;
function $5433d83c0b966be1$var$decodeSeed(seed, opts = {
    versionTypes: [
        'ed25519',
        'secp256k1'
    ],
    versions: [
        $5433d83c0b966be1$var$ED25519_SEED,
        $5433d83c0b966be1$var$FAMILY_SEED
    ],
    expectedLength: 16
}) {
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.decode(seed, opts);
}
module.exports.decodeSeed = $5433d83c0b966be1$var$decodeSeed;
function $5433d83c0b966be1$var$encodeAccountID(bytes) {
    const opts = {
        versions: [
            $5433d83c0b966be1$var$ACCOUNT_ID
        ],
        expectedLength: 20
    };
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeAccountID = $5433d83c0b966be1$var$encodeAccountID;
/* eslint-disable import/no-unused-modules ---
 * unclear why this is aliased but we should keep it in case someone else is
 * importing it with the aliased name */ module.exports.encodeAddress = $5433d83c0b966be1$var$encodeAccountID;
/* eslint-enable import/no-unused-modules */ function $5433d83c0b966be1$var$decodeAccountID(accountId) {
    const opts = {
        versions: [
            $5433d83c0b966be1$var$ACCOUNT_ID
        ],
        expectedLength: 20
    };
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.decode(accountId, opts).bytes;
}
module.exports.decodeAccountID = $5433d83c0b966be1$var$decodeAccountID;
/* eslint-disable import/no-unused-modules ---
 * unclear why this is aliased but we should keep it in case someone else is
 * importing it with the aliased name */ module.exports.decodeAddress = $5433d83c0b966be1$var$decodeAccountID;
/* eslint-enable import/no-unused-modules */ function $5433d83c0b966be1$var$decodeNodePublic(base58string) {
    const opts = {
        versions: [
            $5433d83c0b966be1$var$NODE_PUBLIC
        ],
        expectedLength: 33
    };
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.decode(base58string, opts).bytes;
}
module.exports.decodeNodePublic = $5433d83c0b966be1$var$decodeNodePublic;
function $5433d83c0b966be1$var$encodeNodePublic(bytes) {
    const opts = {
        versions: [
            $5433d83c0b966be1$var$NODE_PUBLIC
        ],
        expectedLength: 33
    };
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeNodePublic = $5433d83c0b966be1$var$encodeNodePublic;
function $5433d83c0b966be1$var$encodeAccountPublic(bytes) {
    const opts = {
        versions: [
            $5433d83c0b966be1$var$ACCOUNT_PUBLIC_KEY
        ],
        expectedLength: 33
    };
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeAccountPublic = $5433d83c0b966be1$var$encodeAccountPublic;
function $5433d83c0b966be1$var$decodeAccountPublic(base58string) {
    const opts = {
        versions: [
            $5433d83c0b966be1$var$ACCOUNT_PUBLIC_KEY
        ],
        expectedLength: 33
    };
    return $5433d83c0b966be1$var$codecWithXrpAlphabet.decode(base58string, opts).bytes;
}
module.exports.decodeAccountPublic = $5433d83c0b966be1$var$decodeAccountPublic;
function $5433d83c0b966be1$var$isValidClassicAddress(address) {
    try {
        $5433d83c0b966be1$var$decodeAccountID(address);
    } catch (_error) {
        return false;
    }
    return true;
}
module.exports.isValidClassicAddress = $5433d83c0b966be1$var$isValidClassicAddress;
function $5433d83c0b966be1$var$checkByteLength(bytes, expectedLength) {
    return 'byteLength' in bytes ? bytes.byteLength === expectedLength : bytes.length === expectedLength;
}

});
parcelRegister("3ctkB", function(module, exports) {
"use strict";
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bytes = module.exports.stringToBytes = module.exports.str = module.exports.bytesToString = module.exports.hex = module.exports.utf8 = module.exports.bech32m = module.exports.bech32 = module.exports.base58check = module.exports.createBase58check = module.exports.base58xmr = module.exports.base58xrp = module.exports.base58flickr = module.exports.base58 = module.exports.base64urlnopad = module.exports.base64url = module.exports.base64nopad = module.exports.base64 = module.exports.base32crockford = module.exports.base32hexnopad = module.exports.base32hex = module.exports.base32nopad = module.exports.base32 = module.exports.base16 = module.exports.utils = module.exports.assertNumber = void 0;
function $25493ead2910198e$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $25493ead2910198e$var$isArrayOf(isString, arr) {
    if (!Array.isArray(arr)) return false;
    if (arr.length === 0) return true;
    if (isString) return arr.every((item)=>typeof item === 'string');
    else return arr.every((item)=>Number.isSafeInteger(item));
}
// no abytes: seems to have 10% slowdown. Why?!
function $25493ead2910198e$var$afn(input) {
    if (typeof input !== 'function') throw new Error('function expected');
    return true;
}
function $25493ead2910198e$var$astr(label, input) {
    if (typeof input !== 'string') throw new Error(`${label}: string expected`);
    return true;
}
function $25493ead2910198e$var$anumber(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`invalid integer: ${n}`);
}
module.exports.assertNumber = $25493ead2910198e$var$anumber;
function $25493ead2910198e$var$aArr(input) {
    if (!Array.isArray(input)) throw new Error('array expected');
}
function $25493ead2910198e$var$astrArr(label, input) {
    if (!$25493ead2910198e$var$isArrayOf(true, input)) throw new Error(`${label}: array of strings expected`);
}
function $25493ead2910198e$var$anumArr(label, input) {
    if (!$25493ead2910198e$var$isArrayOf(false, input)) throw new Error(`${label}: array of numbers expected`);
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$chain(...args) {
    const id = (a)=>a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x)=>x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x)=>x.decode).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back.
 * Could also be array of strings.
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$alphabet(letters) {
    // mapping 1 to "b"
    const lettersA = typeof letters === 'string' ? letters.split('') : letters;
    const len = lettersA.length;
    $25493ead2910198e$var$astrArr('alphabet', lettersA);
    // mapping "b" to 1
    const indexes = new Map(lettersA.map((l, i)=>[
            l,
            i
        ]));
    return {
        encode: (digits)=>{
            $25493ead2910198e$var$aArr(digits);
            return digits.map((i)=>{
                if (!Number.isSafeInteger(i) || i < 0 || i >= len) throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${letters}`);
                return lettersA[i];
            });
        },
        decode: (input)=>{
            $25493ead2910198e$var$aArr(input);
            return input.map((letter)=>{
                $25493ead2910198e$var$astr('alphabet.decode', letter);
                const i = indexes.get(letter);
                if (i === undefined) throw new Error(`Unknown letter: "${letter}". Allowed: ${letters}`);
                return i;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$join(separator = '') {
    $25493ead2910198e$var$astr('join', separator);
    return {
        encode: (from)=>{
            $25493ead2910198e$var$astrArr('join.decode', from);
            return from.join(separator);
        },
        decode: (to)=>{
            $25493ead2910198e$var$astr('join.decode', to);
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$padding(bits, chr = '=') {
    $25493ead2910198e$var$anumber(bits);
    $25493ead2910198e$var$astr('padding', chr);
    return {
        encode (data) {
            $25493ead2910198e$var$astrArr('padding.encode', data);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            $25493ead2910198e$var$astrArr('padding.decode', input);
            let end = input.length;
            if (end * bits % 8) throw new Error('padding: invalid, string should have whole number of bytes');
            for(; end > 0 && input[end - 1] === chr; end--){
                const last = end - 1;
                const byte = last * bits;
                if (byte % 8 === 0) throw new Error('padding: invalid, string has too much padding');
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$normalize(fn) {
    $25493ead2910198e$var$afn(fn);
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 */ function $25493ead2910198e$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: invalid from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: invalid to=${to}, base cannot be less than 2`);
    $25493ead2910198e$var$aArr(data);
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data, (d)=>{
        $25493ead2910198e$var$anumber(d);
        if (d < 0 || d >= from) throw new Error(`invalid integer: ${d}`);
        return d;
    });
    const dlen = digits.length;
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < dlen; i++){
            const digit = digits[i];
            const fromCarry = from * carry;
            const digitBase = fromCarry + digit;
            if (!Number.isSafeInteger(digitBase) || fromCarry / from !== carry || digitBase - digit !== fromCarry) throw new Error('convertRadix: carry overflow');
            const div = digitBase / to;
            carry = digitBase % to;
            const rounded = Math.floor(div);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error('convertRadix: carry overflow');
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $25493ead2910198e$var$gcd = (a, b)=>b === 0 ? a : $25493ead2910198e$var$gcd(b, a % b);
const $25493ead2910198e$var$radix2carry = /* @__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $25493ead2910198e$var$gcd(from, to));
const $25493ead2910198e$var$powers = /* @__PURE__ */ (()=>{
    let res = [];
    for(let i = 0; i < 40; i++)res.push(2 ** i);
    return res;
})();
/**
 * Implemented with numbers, because BigInt is 5x slower
 */ function $25493ead2910198e$var$convertRadix2(data, from, to, padding) {
    $25493ead2910198e$var$aArr(data);
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($25493ead2910198e$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$25493ead2910198e$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const max = $25493ead2910198e$var$powers[from];
    const mask = $25493ead2910198e$var$powers[to] - 1;
    const res = [];
    for (const n of data){
        $25493ead2910198e$var$anumber(n);
        if (n >= max) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        const pow = $25493ead2910198e$var$powers[pos];
        if (pow === undefined) throw new Error('invalid carry');
        carry &= pow - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error('Excess padding');
    if (!padding && carry > 0) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$radix(num) {
    $25493ead2910198e$var$anumber(num);
    const _256 = 256;
    return {
        encode: (bytes)=>{
            if (!$25493ead2910198e$var$isBytes(bytes)) throw new Error('radix.encode input should be Uint8Array');
            return $25493ead2910198e$var$convertRadix(Array.from(bytes), _256, num);
        },
        decode: (digits)=>{
            $25493ead2910198e$var$anumArr('radix.decode', digits);
            return Uint8Array.from($25493ead2910198e$var$convertRadix(digits, num, _256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$radix2(bits, revPadding = false) {
    $25493ead2910198e$var$anumber(bits);
    if (bits <= 0 || bits > 32) throw new Error('radix2: bits should be in (0..32]');
    if ($25493ead2910198e$var$radix2carry(8, bits) > 32 || $25493ead2910198e$var$radix2carry(bits, 8) > 32) throw new Error('radix2: carry overflow');
    return {
        encode: (bytes)=>{
            if (!$25493ead2910198e$var$isBytes(bytes)) throw new Error('radix2.encode input should be Uint8Array');
            return $25493ead2910198e$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            $25493ead2910198e$var$anumArr('radix2.decode', digits);
            return Uint8Array.from($25493ead2910198e$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $25493ead2910198e$var$unsafeWrapper(fn) {
    $25493ead2910198e$var$afn(fn);
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $25493ead2910198e$var$checksum(len, fn) {
    $25493ead2910198e$var$anumber(len);
    $25493ead2910198e$var$afn(fn);
    return {
        encode (data) {
            if (!$25493ead2910198e$var$isBytes(data)) throw new Error('checksum.encode: input should be Uint8Array');
            const sum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(sum, data.length);
            return res;
        },
        decode (data) {
            if (!$25493ead2910198e$var$isBytes(data)) throw new Error('checksum.decode: input should be Uint8Array');
            const payload = data.slice(0, -len);
            const oldChecksum = data.slice(-len);
            const newChecksum = fn(payload).slice(0, len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error('Invalid checksum');
            return payload;
        }
    };
}
// prettier-ignore
module.exports.utils = {
    alphabet: $25493ead2910198e$var$alphabet,
    chain: $25493ead2910198e$var$chain,
    checksum: $25493ead2910198e$var$checksum,
    convertRadix: $25493ead2910198e$var$convertRadix,
    convertRadix2: $25493ead2910198e$var$convertRadix2,
    radix: $25493ead2910198e$var$radix,
    radix2: $25493ead2910198e$var$radix2,
    join: $25493ead2910198e$var$join,
    padding: $25493ead2910198e$var$padding
};
// RFC 4648 aka RFC 3548
// ---------------------
/**
 * base16 encoding.
 */ module.exports.base16 = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(4), $25493ead2910198e$var$alphabet('0123456789ABCDEF'), $25493ead2910198e$var$join(''));
module.exports.base32 = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(5), $25493ead2910198e$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), $25493ead2910198e$var$padding(5), $25493ead2910198e$var$join(''));
module.exports.base32nopad = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(5), $25493ead2910198e$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), $25493ead2910198e$var$join(''));
module.exports.base32hex = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(5), $25493ead2910198e$var$alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), $25493ead2910198e$var$padding(5), $25493ead2910198e$var$join(''));
module.exports.base32hexnopad = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(5), $25493ead2910198e$var$alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), $25493ead2910198e$var$join(''));
module.exports.base32crockford = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(5), $25493ead2910198e$var$alphabet('0123456789ABCDEFGHJKMNPQRSTVWXYZ'), $25493ead2910198e$var$join(''), $25493ead2910198e$var$normalize((s)=>s.toUpperCase().replace(/O/g, '0').replace(/[IL]/g, '1')));
/**
 * base64 with padding. For no padding, use `base64nopad`.
 * @example
 * const b = base64.decode('A951'); // Uint8Array.from([ 3, 222, 117 ])
 * base64.encode(b); // 'A951'
 */ module.exports.base64 = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(6), $25493ead2910198e$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), $25493ead2910198e$var$padding(6), $25493ead2910198e$var$join(''));
/**
 * base64 without padding.
 */ module.exports.base64nopad = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(6), $25493ead2910198e$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), $25493ead2910198e$var$join(''));
module.exports.base64url = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(6), $25493ead2910198e$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), $25493ead2910198e$var$padding(6), $25493ead2910198e$var$join(''));
module.exports.base64urlnopad = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(6), $25493ead2910198e$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), $25493ead2910198e$var$join(''));
// base58 code
// -----------
const $25493ead2910198e$var$genBase58 = /* @__NO_SIDE_EFFECTS__ */ (abc)=>$25493ead2910198e$var$chain($25493ead2910198e$var$radix(58), $25493ead2910198e$var$alphabet(abc), $25493ead2910198e$var$join(''));
/**
 * Base58: base64 without characters +, /, 0, O, I, l.
 * Quadratic (O(n^2)) - so, can't be used on large inputs.
 */ module.exports.base58 = $25493ead2910198e$var$genBase58('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');
module.exports.base58flickr = $25493ead2910198e$var$genBase58('123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ');
module.exports.base58xrp = $25493ead2910198e$var$genBase58('rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz');
// Data len (index) -> encoded block len
const $25493ead2910198e$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
/**
 * XMR version of base58.
 * Done in 8-byte blocks (which equals 11 chars in decoding). Last (non-full) block padded with '1' to size in XMR_BLOCK_LEN.
 * Block encoding significantly reduces quadratic complexity of base58.
 */ module.exports.base58xmr = {
    encode (data) {
        let res = '';
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += module.exports.base58.encode(block).padStart($25493ead2910198e$var$XMR_BLOCK_LEN[block.length], '1');
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $25493ead2910198e$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = module.exports.base58.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error('base58xmr: wrong padding');
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $25493ead2910198e$var$createBase58check = (sha256)=>$25493ead2910198e$var$chain($25493ead2910198e$var$checksum(4, (data)=>sha256(sha256(data))), module.exports.base58);
module.exports.createBase58check = $25493ead2910198e$var$createBase58check;
/**
 * Use `createBase58check` instead.
 * @deprecated
 */ module.exports.base58check = module.exports.createBase58check;
const $25493ead2910198e$var$BECH_ALPHABET = $25493ead2910198e$var$chain($25493ead2910198e$var$alphabet('qpzry9x8gf2tvdw0s3jn54khce6mua7l'), $25493ead2910198e$var$join(''));
const $25493ead2910198e$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $25493ead2910198e$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $25493ead2910198e$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $25493ead2910198e$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $25493ead2910198e$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $25493ead2910198e$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $25493ead2910198e$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $25493ead2910198e$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $25493ead2910198e$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $25493ead2910198e$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $25493ead2910198e$var$BECH_ALPHABET.encode($25493ead2910198e$var$convertRadix2([
        chk % $25493ead2910198e$var$powers[30]
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $25493ead2910198e$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === 'bech32' ? 1 : 0x2bc830a3;
    const _words = $25493ead2910198e$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $25493ead2910198e$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        $25493ead2910198e$var$astr('bech32.encode prefix', prefix);
        if ($25493ead2910198e$var$isBytes(words)) words = Array.from(words);
        $25493ead2910198e$var$anumArr('bech32.encode', words);
        const plen = prefix.length;
        if (plen === 0) throw new TypeError(`Invalid prefix length ${plen}`);
        const actualLength = plen + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $25493ead2910198e$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$25493ead2910198e$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        $25493ead2910198e$var$astr('bech32.decode input', str);
        const slen = str.length;
        if (slen < 8 || limit !== false && slen > limit) throw new TypeError(`invalid string length: ${slen} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        const sepIndex = lowered.lastIndexOf('1');
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = lowered.slice(0, sepIndex);
        const data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error('Data must be at least 6 characters long');
        const words = $25493ead2910198e$var$BECH_ALPHABET.decode(data).slice(0, -6);
        const sum = $25493ead2910198e$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $25493ead2910198e$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    function encodeFromBytes(prefix, bytes) {
        return encode(prefix, toWords(bytes));
    }
    return {
        encode: encode,
        decode: decode,
        encodeFromBytes: encodeFromBytes,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
/**
 * Low-level bech32 operations. Operates on words.
 */ module.exports.bech32 = $25493ead2910198e$var$genBech32('bech32');
module.exports.bech32m = $25493ead2910198e$var$genBech32('bech32m');
/**
 * UTF-8-to-byte decoder. Uses built-in TextDecoder / TextEncoder.
 * @example
 * const b = utf8.decode("hey"); // => new Uint8Array([ 104, 101, 121 ])
 * const str = utf8.encode(b); // "hey"
 */ module.exports.utf8 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
/**
 * hex string decoder.
 * @example
 * const b = hex.decode("0102ff"); // => new Uint8Array([ 1, 2, 255 ])
 * const str = hex.encode(b); // "0102ff"
 */ module.exports.hex = $25493ead2910198e$var$chain($25493ead2910198e$var$radix2(4), $25493ead2910198e$var$alphabet('0123456789abcdef'), $25493ead2910198e$var$join(''), $25493ead2910198e$var$normalize((s)=>{
    if (typeof s !== 'string' || s.length % 2 !== 0) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $25493ead2910198e$var$CODERS = {
    utf8: module.exports.utf8,
    hex: module.exports.hex,
    base16: module.exports.base16,
    base32: module.exports.base32,
    base64: module.exports.base64,
    base64url: module.exports.base64url,
    base58: module.exports.base58,
    base58xmr: module.exports.base58xmr
};
const $25493ead2910198e$var$coderTypeError = 'Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr';
const $25493ead2910198e$var$bytesToString = (type, bytes)=>{
    if (typeof type !== 'string' || !$25493ead2910198e$var$CODERS.hasOwnProperty(type)) throw new TypeError($25493ead2910198e$var$coderTypeError);
    if (!$25493ead2910198e$var$isBytes(bytes)) throw new TypeError('bytesToString() expects Uint8Array');
    return $25493ead2910198e$var$CODERS[type].encode(bytes);
};
module.exports.bytesToString = $25493ead2910198e$var$bytesToString;
module.exports.str = module.exports.bytesToString; // as in python, but for bytes only
const $25493ead2910198e$var$stringToBytes = (type, str)=>{
    if (!$25493ead2910198e$var$CODERS.hasOwnProperty(type)) throw new TypeError($25493ead2910198e$var$coderTypeError);
    if (typeof str !== 'string') throw new TypeError('stringToBytes() expects string');
    return $25493ead2910198e$var$CODERS[type].decode(str);
};
module.exports.stringToBytes = $25493ead2910198e$var$stringToBytes;
module.exports.bytes = module.exports.stringToBytes;

});

parcelRegister("eWnEn", function(module, exports) {
"use strict";
var $ae08d3e9b692ad17$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = void 0;

var $lrsL3 = parcelRequire("lrsL3");

const $ae08d3e9b692ad17$var$wrapNoble_1 = $ae08d3e9b692ad17$var$__importDefault((parcelRequire("f8atV")));
/**
 * Wrap noble-libs's sha256 implementation in HashFn
 */ module.exports.sha256 = (0, $ae08d3e9b692ad17$var$wrapNoble_1.default)($lrsL3.sha256);

});
parcelRegister("f8atV", function(module, exports) {
"use strict";
var $b03fbbd47b38858b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b03fbbd47b38858b$var$normalizeInput_1 = $b03fbbd47b38858b$var$__importDefault((parcelRequire("9yC67")));
/**
 * Wrap a CHash object from @noble/hashes to provide a interface that is isomorphic
 *
 * @param chash - {CHash} hash function to wrap
 */ function $b03fbbd47b38858b$var$wrapNoble(chash) {
    function wrapped(input) {
        return chash((0, $b03fbbd47b38858b$var$normalizeInput_1.default)(input));
    }
    wrapped.create = ()=>{
        const hash = chash.create();
        return {
            update (input) {
                hash.update((0, $b03fbbd47b38858b$var$normalizeInput_1.default)(input));
                return this;
            },
            digest () {
                return hash.digest();
            }
        };
    };
    return wrapped;
}
module.exports.default = $b03fbbd47b38858b$var$wrapNoble;

});
parcelRegister("9yC67", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Normalize a string, number array, or Uint8Array to a string or Uint8Array.
 * Both node and noble lib functions accept these types.
 *
 * @param input - value to normalize
 */ function $6f54d76c63dd95c5$var$normalizeInput(input) {
    return Array.isArray(input) ? new Uint8Array(input) : input;
}
module.exports.default = $6f54d76c63dd95c5$var$normalizeInput;

});



parcelRegister("lGyLP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatArgs = module.exports.arrayEqual = void 0;
/**
 * Check whether two sequences (e.g. Arrays of numbers) are equal.
 *
 * @param arr1 - One of the arrays to compare.
 * @param arr2 - The other array to compare.
 */ function $fc987dec703e68ff$var$arrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((value, index)=>value === arr2[index]);
}
module.exports.arrayEqual = $fc987dec703e68ff$var$arrayEqual;
/**
 * Check whether a value is a scalar
 *
 * @param val - The value to check.
 */ function $fc987dec703e68ff$var$isScalar(val) {
    return typeof val === 'number';
}
/**
 * Concatenate all `arguments` into a single array. Each argument can be either
 * a single element or a sequence, which has a `length` property and supports
 * element retrieval via sequence[ix].
 *
 * > concatArgs(1, [2, 3], Uint8Array.from([4,5]), new Uint8Array([6, 7]));
 * [1,2,3,4,5,6,7]
 *
 * @param args - Concatenate of these args into a single array.
 * @returns Array of concatenated arguments
 */ function $fc987dec703e68ff$var$concatArgs(...args) {
    return args.flatMap((arg)=>{
        return $fc987dec703e68ff$var$isScalar(arg) ? [
            arg
        ] : Array.from(arg);
    });
}
module.exports.concatArgs = $fc987dec703e68ff$var$concatArgs;

});



parcelRegister("eLMUD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.coreTypes = module.exports.DEFAULT_DEFINITIONS = module.exports.XrplDefinitionsBase = module.exports.XrplDefinitions = module.exports.TRANSACTION_TYPES = module.exports.decodeLedgerData = module.exports.decodeQuality = module.exports.encodeQuality = module.exports.encodeForMultisigning = module.exports.encodeForSigningClaim = module.exports.encodeForSigning = module.exports.encode = module.exports.decode = void 0;

var $dC0zv = parcelRequire("dC0zv");

var $h0wvg = parcelRequire("h0wvg");
Object.defineProperty(module.exports, "decodeLedgerData", {
    enumerable: true,
    get: function() {
        return $h0wvg.decodeLedgerData;
    }
});

var $6HRNr = parcelRequire("6HRNr");
Object.defineProperty(module.exports, "XrplDefinitionsBase", {
    enumerable: true,
    get: function() {
        return $6HRNr.XrplDefinitionsBase;
    }
});
Object.defineProperty(module.exports, "TRANSACTION_TYPES", {
    enumerable: true,
    get: function() {
        return $6HRNr.TRANSACTION_TYPES;
    }
});
Object.defineProperty(module.exports, "DEFAULT_DEFINITIONS", {
    enumerable: true,
    get: function() {
        return $6HRNr.DEFAULT_DEFINITIONS;
    }
});

var $48CH0 = parcelRequire("48CH0");
Object.defineProperty(module.exports, "XrplDefinitions", {
    enumerable: true,
    get: function() {
        return $48CH0.XrplDefinitions;
    }
});

var $bff2V = parcelRequire("bff2V");
Object.defineProperty(module.exports, "coreTypes", {
    enumerable: true,
    get: function() {
        return $bff2V.coreTypes;
    }
});

var $8wxDW = parcelRequire("8wxDW");
const { signingData: $ac0b65789a1c13cf$var$signingData, signingClaimData: $ac0b65789a1c13cf$var$signingClaimData, multiSigningData: $ac0b65789a1c13cf$var$multiSigningData, binaryToJSON: $ac0b65789a1c13cf$var$binaryToJSON, serializeObject: $ac0b65789a1c13cf$var$serializeObject } = $dC0zv.binary;
/**
 * Decode a transaction
 *
 * @param binary hex-string of the encoded transaction
 * @param definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns the JSON representation of the transaction
 */ function $ac0b65789a1c13cf$var$decode(binary, definitions) {
    if (typeof binary !== 'string') throw new Error('binary must be a hex string');
    return $ac0b65789a1c13cf$var$binaryToJSON(binary, definitions);
}
module.exports.decode = $ac0b65789a1c13cf$var$decode;
/**
 * Encode a transaction
 *
 * @param json The JSON representation of a transaction
 * @param definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 *
 * @returns A hex-string of the encoded transaction
 */ function $ac0b65789a1c13cf$var$encode(json, definitions) {
    if (typeof json !== 'object') throw new Error();
    return (0, $8wxDW.bytesToHex)($ac0b65789a1c13cf$var$serializeObject(json, {
        definitions: definitions
    }));
}
module.exports.encode = $ac0b65789a1c13cf$var$encode;
/**
 * Encode a transaction and prepare for signing
 *
 * @param json JSON object representing the transaction
 * @param signer string representing the account to sign the transaction with
 * @param definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns a hex string of the encoded transaction
 */ function $ac0b65789a1c13cf$var$encodeForSigning(json, definitions) {
    if (typeof json !== 'object') throw new Error();
    return (0, $8wxDW.bytesToHex)($ac0b65789a1c13cf$var$signingData(json, $dC0zv.HashPrefix.transactionSig, {
        definitions: definitions
    }));
}
module.exports.encodeForSigning = $ac0b65789a1c13cf$var$encodeForSigning;
/**
 * Encode a transaction and prepare for signing with a claim
 *
 * @param json JSON object representing the transaction
 * @param signer string representing the account to sign the transaction with
 * @param definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns a hex string of the encoded transaction
 */ function $ac0b65789a1c13cf$var$encodeForSigningClaim(json) {
    if (typeof json !== 'object') throw new Error();
    return (0, $8wxDW.bytesToHex)($ac0b65789a1c13cf$var$signingClaimData(json));
}
module.exports.encodeForSigningClaim = $ac0b65789a1c13cf$var$encodeForSigningClaim;
/**
 * Encode a transaction and prepare for multi-signing
 *
 * @param json JSON object representing the transaction
 * @param signer string representing the account to sign the transaction with
 * @param definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns a hex string of the encoded transaction
 */ function $ac0b65789a1c13cf$var$encodeForMultisigning(json, signer, definitions) {
    if (typeof json !== 'object') throw new Error();
    if (json['SigningPubKey'] !== '') throw new Error();
    const definitionsOpt = definitions ? {
        definitions: definitions
    } : undefined;
    return (0, $8wxDW.bytesToHex)($ac0b65789a1c13cf$var$multiSigningData(json, signer, definitionsOpt));
}
module.exports.encodeForMultisigning = $ac0b65789a1c13cf$var$encodeForMultisigning;
/**
 * Encode a quality value
 *
 * @param value string representation of a number
 * @returns a hex-string representing the quality
 */ function $ac0b65789a1c13cf$var$encodeQuality(value) {
    if (typeof value !== 'string') throw new Error();
    return (0, $8wxDW.bytesToHex)($dC0zv.quality.encode(value));
}
module.exports.encodeQuality = $ac0b65789a1c13cf$var$encodeQuality;
/**
 * Decode a quality value
 *
 * @param value hex-string of a quality
 * @returns a string representing the quality
 */ function $ac0b65789a1c13cf$var$decodeQuality(value) {
    if (typeof value !== 'string') throw new Error();
    return $dC0zv.quality.decode(value).toString();
}
module.exports.decodeQuality = $ac0b65789a1c13cf$var$decodeQuality;

});
parcelRegister("dC0zv", function(module, exports) {
"use strict";
var $9e8f447f383fc418$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9e8f447f383fc418$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9e8f447f383fc418$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9e8f447f383fc418$var$__createBinding(result, mod, k);
    }
    $9e8f447f383fc418$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.types = module.exports.ShaMap = module.exports.HashPrefix = module.exports.quality = module.exports.TransactionResult = module.exports.Type = module.exports.LedgerEntryType = module.exports.TransactionType = module.exports.Field = module.exports.DEFAULT_DEFINITIONS = module.exports.ledgerHashes = module.exports.binary = module.exports.hashes = void 0;

var $6HRNr = parcelRequire("6HRNr");
Object.defineProperty(module.exports, "DEFAULT_DEFINITIONS", {
    enumerable: true,
    get: function() {
        return $6HRNr.DEFAULT_DEFINITIONS;
    }
});
Object.defineProperty(module.exports, "Field", {
    enumerable: true,
    get: function() {
        return $6HRNr.Field;
    }
});
Object.defineProperty(module.exports, "TransactionType", {
    enumerable: true,
    get: function() {
        return $6HRNr.TransactionType;
    }
});
Object.defineProperty(module.exports, "LedgerEntryType", {
    enumerable: true,
    get: function() {
        return $6HRNr.LedgerEntryType;
    }
});
Object.defineProperty(module.exports, "Type", {
    enumerable: true,
    get: function() {
        return $6HRNr.Type;
    }
});
Object.defineProperty(module.exports, "TransactionResult", {
    enumerable: true,
    get: function() {
        return $6HRNr.TransactionResult;
    }
});

const $9e8f447f383fc418$var$types = $9e8f447f383fc418$var$__importStar((parcelRequire("bff2V")));
module.exports.types = $9e8f447f383fc418$var$types;

const $9e8f447f383fc418$var$binary = $9e8f447f383fc418$var$__importStar((parcelRequire("AXH1k")));
module.exports.binary = $9e8f447f383fc418$var$binary;

var $hQdr1 = parcelRequire("hQdr1");
Object.defineProperty(module.exports, "ShaMap", {
    enumerable: true,
    get: function() {
        return $hQdr1.ShaMap;
    }
});

const $9e8f447f383fc418$var$ledgerHashes = $9e8f447f383fc418$var$__importStar((parcelRequire("h0wvg")));
module.exports.ledgerHashes = $9e8f447f383fc418$var$ledgerHashes;

const $9e8f447f383fc418$var$hashes = $9e8f447f383fc418$var$__importStar((parcelRequire("4EzQV")));
module.exports.hashes = $9e8f447f383fc418$var$hashes;

var $EQkV7 = parcelRequire("EQkV7");
Object.defineProperty(module.exports, "quality", {
    enumerable: true,
    get: function() {
        return $EQkV7.quality;
    }
});

var $1KMxh = parcelRequire("1KMxh");
Object.defineProperty(module.exports, "HashPrefix", {
    enumerable: true,
    get: function() {
        return $1KMxh.HashPrefix;
    }
});

});
parcelRegister("6HRNr", function(module, exports) {
"use strict";
var $4e207d0fa151e39c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRANSACTION_TYPES = module.exports.TransactionType = module.exports.TransactionResult = module.exports.LedgerEntryType = module.exports.Type = module.exports.Field = module.exports.DEFAULT_DEFINITIONS = module.exports.XrplDefinitionsBase = module.exports.Bytes = void 0;

const $4e207d0fa151e39c$var$definitions_json_1 = $4e207d0fa151e39c$var$__importDefault((parcelRequire("imNKo")));

var $dGSbb = parcelRequire("dGSbb");
Object.defineProperty(module.exports, "XrplDefinitionsBase", {
    enumerable: true,
    get: function() {
        return $dGSbb.XrplDefinitionsBase;
    }
});
Object.defineProperty(module.exports, "Bytes", {
    enumerable: true,
    get: function() {
        return $dGSbb.Bytes;
    }
});
/**
 * By default, coreTypes from the `types` folder is where known type definitions are initialized to avoid import cycles.
 */ const $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS = new $dGSbb.XrplDefinitionsBase($4e207d0fa151e39c$var$definitions_json_1.default, {});
module.exports.DEFAULT_DEFINITIONS = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS;
const $4e207d0fa151e39c$var$Type = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS.type;
module.exports.Type = $4e207d0fa151e39c$var$Type;
const $4e207d0fa151e39c$var$LedgerEntryType = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS.ledgerEntryType;
module.exports.LedgerEntryType = $4e207d0fa151e39c$var$LedgerEntryType;
const $4e207d0fa151e39c$var$TransactionType = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS.transactionType;
module.exports.TransactionType = $4e207d0fa151e39c$var$TransactionType;
const $4e207d0fa151e39c$var$TransactionResult = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS.transactionResult;
module.exports.TransactionResult = $4e207d0fa151e39c$var$TransactionResult;
const $4e207d0fa151e39c$var$Field = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS.field;
module.exports.Field = $4e207d0fa151e39c$var$Field;
/*
 * @brief: All valid transaction types
 */ const $4e207d0fa151e39c$var$TRANSACTION_TYPES = $4e207d0fa151e39c$var$DEFAULT_DEFINITIONS.transactionNames;
module.exports.TRANSACTION_TYPES = $4e207d0fa151e39c$var$TRANSACTION_TYPES;

});
parcelRegister("imNKo", function(module, exports) {
module.exports = JSON.parse("{\"FIELDS\":[[\"Generic\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":0,\"type\":\"Unknown\"}],[\"Invalid\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":-1,\"type\":\"Unknown\"}],[\"ObjectEndMarker\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"STObject\"}],[\"ArrayEndMarker\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"STArray\"}],[\"taker_gets_funded\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":258,\"type\":\"Amount\"}],[\"taker_pays_funded\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":259,\"type\":\"Amount\"}],[\"LedgerEntryType\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"UInt16\"}],[\"TransactionType\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"UInt16\"}],[\"SignerWeight\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"UInt16\"}],[\"TransferFee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"UInt16\"}],[\"TradingFee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"UInt16\"}],[\"DiscountedFee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"UInt16\"}],[\"Version\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"UInt16\"}],[\"HookStateChangeCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"UInt16\"}],[\"HookEmitCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"UInt16\"}],[\"HookExecutionIndex\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"UInt16\"}],[\"HookApiVersion\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":20,\"type\":\"UInt16\"}],[\"LedgerFixType\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":21,\"type\":\"UInt16\"}],[\"NetworkID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"UInt32\"}],[\"Flags\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"UInt32\"}],[\"SourceTag\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"UInt32\"}],[\"Sequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"UInt32\"}],[\"PreviousTxnLgrSeq\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"UInt32\"}],[\"LedgerSequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"UInt32\"}],[\"CloseTime\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":7,\"type\":\"UInt32\"}],[\"ParentCloseTime\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":8,\"type\":\"UInt32\"}],[\"SigningTime\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":9,\"type\":\"UInt32\"}],[\"Expiration\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":10,\"type\":\"UInt32\"}],[\"TransferRate\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":11,\"type\":\"UInt32\"}],[\"WalletSize\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":12,\"type\":\"UInt32\"}],[\"OwnerCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":13,\"type\":\"UInt32\"}],[\"DestinationTag\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":14,\"type\":\"UInt32\"}],[\"LastUpdateTime\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":15,\"type\":\"UInt32\"}],[\"HighQualityIn\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"UInt32\"}],[\"HighQualityOut\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"UInt32\"}],[\"LowQualityIn\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"UInt32\"}],[\"LowQualityOut\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"UInt32\"}],[\"QualityIn\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":20,\"type\":\"UInt32\"}],[\"QualityOut\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":21,\"type\":\"UInt32\"}],[\"StampEscrow\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":22,\"type\":\"UInt32\"}],[\"BondAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":23,\"type\":\"UInt32\"}],[\"LoadFee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":24,\"type\":\"UInt32\"}],[\"OfferSequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":25,\"type\":\"UInt32\"}],[\"FirstLedgerSequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":26,\"type\":\"UInt32\"}],[\"LastLedgerSequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":27,\"type\":\"UInt32\"}],[\"TransactionIndex\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":28,\"type\":\"UInt32\"}],[\"OperationLimit\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":29,\"type\":\"UInt32\"}],[\"ReferenceFeeUnits\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":30,\"type\":\"UInt32\"}],[\"ReserveBase\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":31,\"type\":\"UInt32\"}],[\"ReserveIncrement\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":32,\"type\":\"UInt32\"}],[\"SetFlag\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":33,\"type\":\"UInt32\"}],[\"ClearFlag\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":34,\"type\":\"UInt32\"}],[\"SignerQuorum\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":35,\"type\":\"UInt32\"}],[\"CancelAfter\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":36,\"type\":\"UInt32\"}],[\"FinishAfter\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":37,\"type\":\"UInt32\"}],[\"SignerListID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":38,\"type\":\"UInt32\"}],[\"SettleDelay\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":39,\"type\":\"UInt32\"}],[\"TicketCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":40,\"type\":\"UInt32\"}],[\"TicketSequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":41,\"type\":\"UInt32\"}],[\"NFTokenTaxon\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":42,\"type\":\"UInt32\"}],[\"MintedNFTokens\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":43,\"type\":\"UInt32\"}],[\"BurnedNFTokens\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":44,\"type\":\"UInt32\"}],[\"HookStateCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":45,\"type\":\"UInt32\"}],[\"EmitGeneration\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":46,\"type\":\"UInt32\"}],[\"VoteWeight\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":48,\"type\":\"UInt32\"}],[\"FirstNFTokenSequence\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":50,\"type\":\"UInt32\"}],[\"OracleDocumentID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":51,\"type\":\"UInt32\"}],[\"IndexNext\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"UInt64\"}],[\"IndexPrevious\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"UInt64\"}],[\"BookNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"UInt64\"}],[\"OwnerNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"UInt64\"}],[\"BaseFee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"UInt64\"}],[\"ExchangeRate\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"UInt64\"}],[\"LowNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":7,\"type\":\"UInt64\"}],[\"HighNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":8,\"type\":\"UInt64\"}],[\"DestinationNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":9,\"type\":\"UInt64\"}],[\"Cookie\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":10,\"type\":\"UInt64\"}],[\"ServerVersion\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":11,\"type\":\"UInt64\"}],[\"NFTokenOfferNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":12,\"type\":\"UInt64\"}],[\"EmitBurden\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":13,\"type\":\"UInt64\"}],[\"HookOn\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"UInt64\"}],[\"HookInstructionCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"UInt64\"}],[\"HookReturnCode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"UInt64\"}],[\"ReferenceCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"UInt64\"}],[\"XChainClaimID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":20,\"type\":\"UInt64\"}],[\"XChainAccountCreateCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":21,\"type\":\"UInt64\"}],[\"XChainAccountClaimCount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":22,\"type\":\"UInt64\"}],[\"AssetPrice\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":23,\"type\":\"UInt64\"}],[\"MaximumAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":24,\"type\":\"UInt64\"}],[\"OutstandingAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":25,\"type\":\"UInt64\"}],[\"MPTAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":26,\"type\":\"UInt64\"}],[\"IssuerNode\",{\"nth\":27,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"UInt64\"}],[\"SubjectNode\",{\"nth\":28,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"UInt64\"}],[\"EmailHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Hash128\"}],[\"LedgerHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Hash256\"}],[\"ParentHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"Hash256\"}],[\"TransactionHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"Hash256\"}],[\"AccountHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"Hash256\"}],[\"PreviousTxnID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"Hash256\"}],[\"LedgerIndex\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"Hash256\"}],[\"WalletLocator\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":7,\"type\":\"Hash256\"}],[\"RootIndex\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":8,\"type\":\"Hash256\"}],[\"AccountTxnID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":9,\"type\":\"Hash256\"}],[\"NFTokenID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":10,\"type\":\"Hash256\"}],[\"EmitParentTxnID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":11,\"type\":\"Hash256\"}],[\"EmitNonce\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":12,\"type\":\"Hash256\"}],[\"EmitHookHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":13,\"type\":\"Hash256\"}],[\"AMMID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":14,\"type\":\"Hash256\"}],[\"BookDirectory\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"Hash256\"}],[\"InvoiceID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"Hash256\"}],[\"Nickname\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"Hash256\"}],[\"Amendment\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"Hash256\"}],[\"Digest\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":21,\"type\":\"Hash256\"}],[\"Channel\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":22,\"type\":\"Hash256\"}],[\"ConsensusHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":23,\"type\":\"Hash256\"}],[\"CheckID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":24,\"type\":\"Hash256\"}],[\"ValidatedHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":25,\"type\":\"Hash256\"}],[\"PreviousPageMin\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":26,\"type\":\"Hash256\"}],[\"NextPageMin\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":27,\"type\":\"Hash256\"}],[\"NFTokenBuyOffer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":28,\"type\":\"Hash256\"}],[\"NFTokenSellOffer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":29,\"type\":\"Hash256\"}],[\"HookStateKey\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":30,\"type\":\"Hash256\"}],[\"HookHash\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":31,\"type\":\"Hash256\"}],[\"HookNamespace\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":32,\"type\":\"Hash256\"}],[\"HookSetTxnID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":33,\"type\":\"Hash256\"}],[\"DomainID\",{\"nth\":34,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"Hash256\"}],[\"hash\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":257,\"type\":\"Hash256\"}],[\"index\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":258,\"type\":\"Hash256\"}],[\"Amount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Amount\"}],[\"Balance\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"Amount\"}],[\"LimitAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"Amount\"}],[\"TakerPays\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"Amount\"}],[\"TakerGets\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"Amount\"}],[\"LowLimit\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"Amount\"}],[\"HighLimit\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":7,\"type\":\"Amount\"}],[\"Fee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":8,\"type\":\"Amount\"}],[\"SendMax\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":9,\"type\":\"Amount\"}],[\"DeliverMin\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":10,\"type\":\"Amount\"}],[\"Amount2\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":11,\"type\":\"Amount\"}],[\"BidMin\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":12,\"type\":\"Amount\"}],[\"BidMax\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":13,\"type\":\"Amount\"}],[\"MinimumOffer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"Amount\"}],[\"RippleEscrow\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"Amount\"}],[\"DeliveredAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"Amount\"}],[\"NFTokenBrokerFee\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"Amount\"}],[\"BaseFeeDrops\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":22,\"type\":\"Amount\"}],[\"ReserveBaseDrops\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":23,\"type\":\"Amount\"}],[\"ReserveIncrementDrops\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":24,\"type\":\"Amount\"}],[\"LPTokenOut\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":25,\"type\":\"Amount\"}],[\"LPTokenIn\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":26,\"type\":\"Amount\"}],[\"EPrice\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":27,\"type\":\"Amount\"}],[\"Price\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":28,\"type\":\"Amount\"}],[\"SignatureReward\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":29,\"type\":\"Amount\"}],[\"MinAccountCreateAmount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":30,\"type\":\"Amount\"}],[\"LPTokenBalance\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":31,\"type\":\"Amount\"}],[\"PublicKey\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":1,\"type\":\"Blob\"}],[\"MessageKey\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":2,\"type\":\"Blob\"}],[\"SigningPubKey\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":3,\"type\":\"Blob\"}],[\"TxnSignature\",{\"isSerialized\":true,\"isSigningField\":false,\"isVLEncoded\":true,\"nth\":4,\"type\":\"Blob\"}],[\"URI\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":5,\"type\":\"Blob\"}],[\"Signature\",{\"isSerialized\":true,\"isSigningField\":false,\"isVLEncoded\":true,\"nth\":6,\"type\":\"Blob\"}],[\"Domain\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":7,\"type\":\"Blob\"}],[\"FundCode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":8,\"type\":\"Blob\"}],[\"RemoveCode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":9,\"type\":\"Blob\"}],[\"ExpireCode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":10,\"type\":\"Blob\"}],[\"CreateCode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":11,\"type\":\"Blob\"}],[\"MemoType\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":12,\"type\":\"Blob\"}],[\"MemoData\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":13,\"type\":\"Blob\"}],[\"MemoFormat\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":14,\"type\":\"Blob\"}],[\"Fulfillment\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":16,\"type\":\"Blob\"}],[\"Condition\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":17,\"type\":\"Blob\"}],[\"MasterSignature\",{\"isSerialized\":true,\"isSigningField\":false,\"isVLEncoded\":true,\"nth\":18,\"type\":\"Blob\"}],[\"UNLModifyValidator\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":19,\"type\":\"Blob\"}],[\"ValidatorToDisable\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":20,\"type\":\"Blob\"}],[\"ValidatorToReEnable\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":21,\"type\":\"Blob\"}],[\"HookStateData\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":22,\"type\":\"Blob\"}],[\"HookReturnString\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":23,\"type\":\"Blob\"}],[\"HookParameterName\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":24,\"type\":\"Blob\"}],[\"HookParameterValue\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":25,\"type\":\"Blob\"}],[\"DIDDocument\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":26,\"type\":\"Blob\"}],[\"Data\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":27,\"type\":\"Blob\"}],[\"AssetClass\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":28,\"type\":\"Blob\"}],[\"Provider\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":29,\"type\":\"Blob\"}],[\"MPTokenMetadata\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":30,\"type\":\"Blob\"}],[\"CredentialType\",{\"nth\":31,\"isVLEncoded\":true,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"Blob\"}],[\"Account\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":1,\"type\":\"AccountID\"}],[\"Owner\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":2,\"type\":\"AccountID\"}],[\"Destination\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":3,\"type\":\"AccountID\"}],[\"Issuer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":4,\"type\":\"AccountID\"}],[\"Authorize\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":5,\"type\":\"AccountID\"}],[\"Unauthorize\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":6,\"type\":\"AccountID\"}],[\"RegularKey\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":8,\"type\":\"AccountID\"}],[\"NFTokenMinter\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":9,\"type\":\"AccountID\"}],[\"EmitCallback\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":10,\"type\":\"AccountID\"}],[\"Holder\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":11,\"type\":\"AccountID\"}],[\"HookAccount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":16,\"type\":\"AccountID\"}],[\"OtherChainSource\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":18,\"type\":\"AccountID\"}],[\"OtherChainDestination\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":19,\"type\":\"AccountID\"}],[\"AttestationSignerAccount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":20,\"type\":\"AccountID\"}],[\"AttestationRewardAccount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":21,\"type\":\"AccountID\"}],[\"LockingChainDoor\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":22,\"type\":\"AccountID\"}],[\"IssuingChainDoor\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":23,\"type\":\"AccountID\"}],[\"Subject\",{\"nth\":24,\"isVLEncoded\":true,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"AccountID\"}],[\"TransactionMetaData\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"STObject\"}],[\"CreatedNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"STObject\"}],[\"DeletedNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"STObject\"}],[\"ModifiedNode\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"STObject\"}],[\"PreviousFields\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"STObject\"}],[\"FinalFields\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":7,\"type\":\"STObject\"}],[\"NewFields\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":8,\"type\":\"STObject\"}],[\"TemplateEntry\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":9,\"type\":\"STObject\"}],[\"Memo\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":10,\"type\":\"STObject\"}],[\"SignerEntry\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":11,\"type\":\"STObject\"}],[\"NFToken\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":12,\"type\":\"STObject\"}],[\"EmitDetails\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":13,\"type\":\"STObject\"}],[\"Hook\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":14,\"type\":\"STObject\"}],[\"Signer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"STObject\"}],[\"Majority\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"STObject\"}],[\"DisabledValidator\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"STObject\"}],[\"EmittedTxn\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":20,\"type\":\"STObject\"}],[\"HookExecution\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":21,\"type\":\"STObject\"}],[\"HookDefinition\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":22,\"type\":\"STObject\"}],[\"HookParameter\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":23,\"type\":\"STObject\"}],[\"HookGrant\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":24,\"type\":\"STObject\"}],[\"VoteEntry\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":25,\"type\":\"STObject\"}],[\"AuctionSlot\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":26,\"type\":\"STObject\"}],[\"AuthAccount\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":27,\"type\":\"STObject\"}],[\"XChainClaimProofSig\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":28,\"type\":\"STObject\"}],[\"XChainCreateAccountProofSig\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":29,\"type\":\"STObject\"}],[\"XChainClaimAttestationCollectionElement\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":30,\"type\":\"STObject\"}],[\"XChainCreateAccountAttestationCollectionElement\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":31,\"type\":\"STObject\"}],[\"PriceData\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":32,\"type\":\"STObject\"}],[\"Credential\",{\"nth\":33,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"STObject\"}],[\"Signers\",{\"isSerialized\":true,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":3,\"type\":\"STArray\"}],[\"SignerEntries\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"STArray\"}],[\"Template\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"STArray\"}],[\"Necessary\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":6,\"type\":\"STArray\"}],[\"Sufficient\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":7,\"type\":\"STArray\"}],[\"AffectedNodes\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":8,\"type\":\"STArray\"}],[\"Memos\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":9,\"type\":\"STArray\"}],[\"NFTokens\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":10,\"type\":\"STArray\"}],[\"Hooks\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":11,\"type\":\"STArray\"}],[\"VoteSlots\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":12,\"type\":\"STArray\"}],[\"Majorities\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"STArray\"}],[\"DisabledValidators\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"STArray\"}],[\"HookExecutions\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"STArray\"}],[\"HookParameters\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"STArray\"}],[\"HookGrants\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":20,\"type\":\"STArray\"}],[\"XChainClaimAttestations\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":21,\"type\":\"STArray\"}],[\"XChainCreateAccountAttestations\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":22,\"type\":\"STArray\"}],[\"PriceDataSeries\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":24,\"type\":\"STArray\"}],[\"AuthAccounts\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":25,\"type\":\"STArray\"}],[\"AuthorizeCredentials\",{\"nth\":26,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"STArray\"}],[\"UnauthorizeCredentials\",{\"nth\":27,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"STArray\"}],[\"AcceptedCredentials\",{\"nth\":28,\"isVLEncoded\":false,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"STArray\"}],[\"CloseResolution\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"UInt8\"}],[\"Method\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"UInt8\"}],[\"TransactionResult\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"UInt8\"}],[\"Scale\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"UInt8\"}],[\"AssetScale\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":5,\"type\":\"UInt8\"}],[\"TickSize\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":16,\"type\":\"UInt8\"}],[\"UNLModifyDisabling\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":17,\"type\":\"UInt8\"}],[\"HookResult\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":18,\"type\":\"UInt8\"}],[\"WasLockingChainSend\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":19,\"type\":\"UInt8\"}],[\"TakerPaysCurrency\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Hash160\"}],[\"TakerPaysIssuer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"Hash160\"}],[\"TakerGetsCurrency\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"Hash160\"}],[\"TakerGetsIssuer\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"Hash160\"}],[\"Paths\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"PathSet\"}],[\"Indexes\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":1,\"type\":\"Vector256\"}],[\"Hashes\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":2,\"type\":\"Vector256\"}],[\"Amendments\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":3,\"type\":\"Vector256\"}],[\"NFTokenOffers\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":true,\"nth\":4,\"type\":\"Vector256\"}],[\"CredentialIDs\",{\"nth\":5,\"isVLEncoded\":true,\"isSerialized\":true,\"isSigningField\":true,\"type\":\"Vector256\"}],[\"MPTokenIssuanceID\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Hash192\"}],[\"LockingChainIssue\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Issue\"}],[\"IssuingChainIssue\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"Issue\"}],[\"Asset\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":3,\"type\":\"Issue\"}],[\"Asset2\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":4,\"type\":\"Issue\"}],[\"XChainBridge\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"XChainBridge\"}],[\"BaseAsset\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":1,\"type\":\"Currency\"}],[\"QuoteAsset\",{\"isSerialized\":true,\"isSigningField\":true,\"isVLEncoded\":false,\"nth\":2,\"type\":\"Currency\"}],[\"Transaction\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":257,\"type\":\"Transaction\"}],[\"LedgerEntry\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":257,\"type\":\"LedgerEntry\"}],[\"Validation\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":257,\"type\":\"Validation\"}],[\"Metadata\",{\"isSerialized\":false,\"isSigningField\":false,\"isVLEncoded\":false,\"nth\":257,\"type\":\"Metadata\"}]],\"LEDGER_ENTRY_TYPES\":{\"AMM\":121,\"AccountRoot\":97,\"Amendments\":102,\"Bridge\":105,\"Check\":67,\"DID\":73,\"DepositPreauth\":112,\"DirectoryNode\":100,\"Escrow\":117,\"FeeSettings\":115,\"Invalid\":-1,\"LedgerHashes\":104,\"MPToken\":127,\"MPTokenIssuance\":126,\"NFTokenOffer\":55,\"NFTokenPage\":80,\"NegativeUNL\":78,\"Offer\":111,\"Oracle\":128,\"Credential\":129,\"PayChannel\":120,\"PermissionedDomain\":130,\"RippleState\":114,\"SignerList\":83,\"Ticket\":84,\"XChainOwnedClaimID\":113,\"XChainOwnedCreateAccountClaimID\":116},\"TRANSACTION_RESULTS\":{\"tecAMM_ACCOUNT\":168,\"tecAMM_BALANCE\":163,\"tecAMM_EMPTY\":166,\"tecAMM_FAILED\":164,\"tecAMM_INVALID_TOKENS\":165,\"tecAMM_NOT_EMPTY\":167,\"tecARRAY_EMPTY\":190,\"tecARRAY_TOO_LARGE\":191,\"tecBAD_CREDENTIALS\":193,\"tecCANT_ACCEPT_OWN_NFTOKEN_OFFER\":158,\"tecCLAIM\":100,\"tecCRYPTOCONDITION_ERROR\":146,\"tecDIR_FULL\":121,\"tecDST_TAG_NEEDED\":143,\"tecDUPLICATE\":149,\"tecEMPTY_DID\":187,\"tecEXPIRED\":148,\"tecFAILED_PROCESSING\":105,\"tecFROZEN\":137,\"tecHAS_OBLIGATIONS\":151,\"tecINCOMPLETE\":169,\"tecINSUFFICIENT_FUNDS\":159,\"tecINSUFFICIENT_PAYMENT\":161,\"tecINSUFFICIENT_RESERVE\":141,\"tecINSUFF_FEE\":136,\"tecINSUF_RESERVE_LINE\":122,\"tecINSUF_RESERVE_OFFER\":123,\"tecINTERNAL\":144,\"tecINVALID_UPDATE_TIME\":188,\"tecINVARIANT_FAILED\":147,\"tecKILLED\":150,\"tecLOCKED\":192,\"tecMAX_SEQUENCE_REACHED\":154,\"tecNEED_MASTER_KEY\":142,\"tecNFTOKEN_BUY_SELL_MISMATCH\":156,\"tecNFTOKEN_OFFER_TYPE_MISMATCH\":157,\"tecNO_ALTERNATIVE_KEY\":130,\"tecNO_AUTH\":134,\"tecNO_DST\":124,\"tecNO_DST_INSUF_XRP\":125,\"tecNO_ENTRY\":140,\"tecNO_ISSUER\":133,\"tecNO_LINE\":135,\"tecNO_LINE_INSUF_RESERVE\":126,\"tecNO_LINE_REDUNDANT\":127,\"tecNO_PERMISSION\":139,\"tecNO_REGULAR_KEY\":131,\"tecNO_SUITABLE_NFTOKEN_PAGE\":155,\"tecNO_TARGET\":138,\"tecOBJECT_NOT_FOUND\":160,\"tecOVERSIZE\":145,\"tecOWNERS\":132,\"tecPATH_DRY\":128,\"tecPATH_PARTIAL\":101,\"tecTOKEN_PAIR_NOT_FOUND\":189,\"tecTOO_SOON\":152,\"tecUNFUNDED\":129,\"tecUNFUNDED_ADD\":102,\"tecUNFUNDED_AMM\":162,\"tecUNFUNDED_OFFER\":103,\"tecUNFUNDED_PAYMENT\":104,\"tecXCHAIN_ACCOUNT_CREATE_PAST\":181,\"tecXCHAIN_ACCOUNT_CREATE_TOO_MANY\":182,\"tecXCHAIN_BAD_CLAIM_ID\":172,\"tecXCHAIN_BAD_PUBLIC_KEY_ACCOUNT_PAIR\":185,\"tecXCHAIN_BAD_TRANSFER_ISSUE\":170,\"tecXCHAIN_CLAIM_NO_QUORUM\":173,\"tecXCHAIN_CREATE_ACCOUNT_DISABLED\":186,\"tecXCHAIN_CREATE_ACCOUNT_NONXRP_ISSUE\":175,\"tecXCHAIN_INSUFF_CREATE_AMOUNT\":180,\"tecXCHAIN_NO_CLAIM_ID\":171,\"tecXCHAIN_NO_SIGNERS_LIST\":178,\"tecXCHAIN_PAYMENT_FAILED\":183,\"tecXCHAIN_PROOF_UNKNOWN_KEY\":174,\"tecXCHAIN_REWARD_MISMATCH\":177,\"tecXCHAIN_SELF_COMMIT\":184,\"tecXCHAIN_SENDING_ACCOUNT_MISMATCH\":179,\"tecXCHAIN_WRONG_CHAIN\":176,\"tefALREADY\":-198,\"tefBAD_ADD_AUTH\":-197,\"tefBAD_AUTH\":-196,\"tefBAD_AUTH_MASTER\":-183,\"tefBAD_LEDGER\":-195,\"tefBAD_QUORUM\":-185,\"tefBAD_SIGNATURE\":-186,\"tefCREATED\":-194,\"tefEXCEPTION\":-193,\"tefFAILURE\":-199,\"tefINTERNAL\":-192,\"tefINVALID_LEDGER_FIX_TYPE\":-178,\"tefINVARIANT_FAILED\":-182,\"tefMASTER_DISABLED\":-188,\"tefMAX_LEDGER\":-187,\"tefNFTOKEN_IS_NOT_TRANSFERABLE\":-179,\"tefNOT_MULTI_SIGNING\":-184,\"tefNO_AUTH_REQUIRED\":-191,\"tefNO_TICKET\":-180,\"tefPAST_SEQ\":-190,\"tefTOO_BIG\":-181,\"tefWRONG_PRIOR\":-189,\"telBAD_DOMAIN\":-398,\"telBAD_PATH_COUNT\":-397,\"telBAD_PUBLIC_KEY\":-396,\"telCAN_NOT_QUEUE\":-392,\"telCAN_NOT_QUEUE_BALANCE\":-391,\"telCAN_NOT_QUEUE_BLOCKED\":-389,\"telCAN_NOT_QUEUE_BLOCKS\":-390,\"telCAN_NOT_QUEUE_FEE\":-388,\"telCAN_NOT_QUEUE_FULL\":-387,\"telENV_RPC_FAILED\":-383,\"telFAILED_PROCESSING\":-395,\"telINSUF_FEE_P\":-394,\"telLOCAL_ERROR\":-399,\"telNETWORK_ID_MAKES_TX_NON_CANONICAL\":-384,\"telNO_DST_PARTIAL\":-393,\"telREQUIRES_NETWORK_ID\":-385,\"telWRONG_NETWORK\":-386,\"temARRAY_EMPTY\":-253,\"temARRAY_TOO_LARGE\":-252,\"temBAD_AMM_TOKENS\":-261,\"temBAD_AMOUNT\":-298,\"temBAD_CURRENCY\":-297,\"temBAD_EXPIRATION\":-296,\"temBAD_FEE\":-295,\"temBAD_ISSUER\":-294,\"temBAD_LIMIT\":-293,\"temBAD_NFTOKEN_TRANSFER_FEE\":-262,\"temBAD_OFFER\":-292,\"temBAD_PATH\":-291,\"temBAD_PATH_LOOP\":-290,\"temBAD_QUORUM\":-271,\"temBAD_REGKEY\":-289,\"temBAD_SEND_XRP_LIMIT\":-288,\"temBAD_SEND_XRP_MAX\":-287,\"temBAD_SEND_XRP_NO_DIRECT\":-286,\"temBAD_SEND_XRP_PARTIAL\":-285,\"temBAD_SEND_XRP_PATHS\":-284,\"temBAD_SEQUENCE\":-283,\"temBAD_SIGNATURE\":-282,\"temBAD_SIGNER\":-272,\"temBAD_SRC_ACCOUNT\":-281,\"temBAD_TICK_SIZE\":-269,\"temBAD_TRANSFER_FEE\":-251,\"temBAD_TRANSFER_RATE\":-280,\"temBAD_WEIGHT\":-270,\"temCANNOT_PREAUTH_SELF\":-267,\"temDISABLED\":-273,\"temDST_IS_SRC\":-279,\"temDST_NEEDED\":-278,\"temEMPTY_DID\":-254,\"temINVALID\":-277,\"temINVALID_ACCOUNT_ID\":-268,\"temINVALID_COUNT\":-266,\"temINVALID_FLAG\":-276,\"temMALFORMED\":-299,\"temREDUNDANT\":-275,\"temRIPPLE_EMPTY\":-274,\"temSEQ_AND_TICKET\":-263,\"temUNCERTAIN\":-265,\"temUNKNOWN\":-264,\"temXCHAIN_BAD_PROOF\":-259,\"temXCHAIN_BRIDGE_BAD_ISSUES\":-258,\"temXCHAIN_BRIDGE_BAD_MIN_ACCOUNT_CREATE_AMOUNT\":-256,\"temXCHAIN_BRIDGE_BAD_REWARD_AMOUNT\":-255,\"temXCHAIN_BRIDGE_NONDOOR_OWNER\":-257,\"temXCHAIN_EQUAL_DOOR_ACCOUNTS\":-260,\"terFUNDS_SPENT\":-98,\"terINSUF_FEE_B\":-97,\"terLAST\":-91,\"terNO_ACCOUNT\":-96,\"terNO_AMM\":-87,\"terNO_AUTH\":-95,\"terNO_LINE\":-94,\"terNO_RIPPLE\":-90,\"terOWNERS\":-93,\"terPRE_SEQ\":-92,\"terPRE_TICKET\":-88,\"terQUEUED\":-89,\"terRETRY\":-99,\"tesSUCCESS\":0},\"TRANSACTION_TYPES\":{\"AMMBid\":39,\"AMMClawback\":31,\"AMMCreate\":35,\"AMMDelete\":40,\"AMMDeposit\":36,\"AMMVote\":38,\"AMMWithdraw\":37,\"AccountDelete\":21,\"AccountSet\":3,\"CheckCancel\":18,\"CheckCash\":17,\"CheckCreate\":16,\"Clawback\":30,\"CredentialCreate\":58,\"CredentialAccept\":59,\"CredentialDelete\":60,\"DIDDelete\":50,\"DIDSet\":49,\"DepositPreauth\":19,\"EnableAmendment\":100,\"EscrowCancel\":4,\"EscrowCreate\":1,\"EscrowFinish\":2,\"Invalid\":-1,\"LedgerStateFix\":53,\"MPTokenAuthorize\":57,\"MPTokenIssuanceCreate\":54,\"MPTokenIssuanceDestroy\":55,\"MPTokenIssuanceSet\":56,\"NFTokenAcceptOffer\":29,\"NFTokenBurn\":26,\"NFTokenCancelOffer\":28,\"NFTokenCreateOffer\":27,\"NFTokenMint\":25,\"NFTokenModify\":61,\"OfferCancel\":8,\"OfferCreate\":7,\"OracleDelete\":52,\"OracleSet\":51,\"Payment\":0,\"PaymentChannelClaim\":15,\"PaymentChannelCreate\":13,\"PaymentChannelFund\":14,\"PermissionedDomainSet\":62,\"PermissionedDomainDelete\":63,\"SetFee\":101,\"SetRegularKey\":5,\"SignerListSet\":12,\"TicketCreate\":10,\"TrustSet\":20,\"UNLModify\":102,\"XChainAccountCreateCommit\":44,\"XChainAddAccountCreateAttestation\":46,\"XChainAddClaimAttestation\":45,\"XChainClaim\":43,\"XChainCommit\":42,\"XChainCreateBridge\":48,\"XChainCreateClaimID\":41,\"XChainModifyBridge\":47},\"TYPES\":{\"AccountID\":8,\"Amount\":6,\"Blob\":7,\"Currency\":26,\"Done\":-1,\"Hash128\":4,\"Hash160\":17,\"Hash192\":21,\"Hash256\":5,\"Issue\":24,\"LedgerEntry\":10002,\"Metadata\":10004,\"NotPresent\":0,\"PathSet\":18,\"STArray\":15,\"STObject\":14,\"Transaction\":10001,\"UInt16\":1,\"UInt32\":2,\"UInt384\":22,\"UInt512\":23,\"UInt64\":3,\"UInt8\":16,\"UInt96\":20,\"Unknown\":-2,\"Validation\":10003,\"Vector256\":19,\"XChainBridge\":25}}");

});

parcelRegister("dGSbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BytesLookup = module.exports.Bytes = module.exports.FieldLookup = module.exports.XrplDefinitionsBase = void 0;

var $l8zQv = parcelRequire("l8zQv");
Object.defineProperty(module.exports, "Bytes", {
    enumerable: true,
    get: function() {
        return $l8zQv.Bytes;
    }
});
Object.defineProperty(module.exports, "BytesLookup", {
    enumerable: true,
    get: function() {
        return $l8zQv.BytesLookup;
    }
});

var $3VAy4 = parcelRequire("3VAy4");
Object.defineProperty(module.exports, "FieldLookup", {
    enumerable: true,
    get: function() {
        return $3VAy4.FieldLookup;
    }
});

var $cjcqo = parcelRequire("cjcqo");
/**
 * Stores the various types and fields for rippled to be used to encode/decode information later on.
 * XrplDefinitions should be instantiated instead of this class.
 */ class $9f79398362bfd7e7$var$XrplDefinitionsBase {
    /**
     * Present rippled types in a typed and updatable format.
     * For an example of the input format see `definitions.json`
     * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
     *
     * See the definitions.test.js file for examples of how to create your own updated definitions.json.
     *
     * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
     * @param types - A list of type objects with the same name as the fields defined.
     *              You can use the coreTypes object if you are not adding new types.
     */ constructor(enums, types){
        this.type = new $l8zQv.BytesLookup(enums.TYPES, $cjcqo.TYPE_WIDTH);
        this.ledgerEntryType = new $l8zQv.BytesLookup(enums.LEDGER_ENTRY_TYPES, $cjcqo.LEDGER_ENTRY_WIDTH);
        this.transactionType = new $l8zQv.BytesLookup(enums.TRANSACTION_TYPES, $cjcqo.TRANSACTION_TYPE_WIDTH);
        this.transactionResult = new $l8zQv.BytesLookup(enums.TRANSACTION_RESULTS, $cjcqo.TRANSACTION_RESULT_WIDTH);
        this.field = new $3VAy4.FieldLookup(enums.FIELDS, enums.TYPES);
        this.transactionNames = Object.entries(enums.TRANSACTION_TYPES).filter(([_key, value])=>value >= 0).map(([key, _value])=>key);
        this.dataTypes = {}; // Filled in via associateTypes
        this.associateTypes(types);
    }
    /**
     * Associates each Field to a corresponding class that TypeScript can recognize.
     *
     * @param types a list of type objects with the same name as the fields defined.
     *              Defaults to xrpl.js's core type definitions.
     */ associateTypes(types) {
        // Overwrite any existing type definitions with the given types
        this.dataTypes = Object.assign({}, this.dataTypes, types);
        Object.values(this.field).forEach((field)=>{
            field.associatedType = this.dataTypes[field.type.name];
        });
        this.field['TransactionType'].associatedType = this.transactionType;
        this.field['TransactionResult'].associatedType = this.transactionResult;
        this.field['LedgerEntryType'].associatedType = this.ledgerEntryType;
    }
    getAssociatedTypes() {
        return this.dataTypes;
    }
}
module.exports.XrplDefinitionsBase = $9f79398362bfd7e7$var$XrplDefinitionsBase;

});
parcelRegister("l8zQv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BytesLookup = module.exports.Bytes = void 0;
/*
 * @brief: Bytes, name, and ordinal representing one type, ledger_type, transaction type, or result
 */ class $f636268caea87bad$var$Bytes {
    constructor(name, ordinal, ordinalWidth){
        this.name = name;
        this.ordinal = ordinal;
        this.ordinalWidth = ordinalWidth;
        this.bytes = new Uint8Array(ordinalWidth);
        for(let i = 0; i < ordinalWidth; i++)this.bytes[ordinalWidth - i - 1] = ordinal >>> i * 8 & 0xff;
    }
    toJSON() {
        return this.name;
    }
    toBytesSink(sink) {
        sink.put(this.bytes);
    }
    toBytes() {
        return this.bytes;
    }
}
module.exports.Bytes = $f636268caea87bad$var$Bytes;
/*
 * @brief: Collection of Bytes objects, mapping bidirectionally
 */ class $f636268caea87bad$var$BytesLookup {
    constructor(types, ordinalWidth){
        this.ordinalWidth = ordinalWidth;
        Object.entries(types).forEach(([k, v])=>{
            this.add(k, v);
        });
    }
    /**
     * Add a new name value pair to the BytesLookup.
     *
     * @param name - A human readable name for the field.
     * @param value - The numeric value for the field.
     * @throws if the name or value already exist in the lookup because it's unclear how to decode.
     */ add(name, value) {
        if (this[name]) throw new SyntaxError(`Attempted to add a value with a duplicate name "${name}". This is not allowed because it is unclear how to decode.`);
        if (this[value.toString()]) throw new SyntaxError(`Attempted to add a duplicate value under a different name (Given name: "${name}" and previous name: "${this[value.toString()]}. This is not allowed because it is unclear how to decode.\nGiven value: ${value.toString()}`);
        this[name] = new $f636268caea87bad$var$Bytes(name, value, this.ordinalWidth);
        this[value.toString()] = this[name];
    }
    from(value) {
        return value instanceof $f636268caea87bad$var$Bytes ? value : this[value];
    }
    fromParser(parser) {
        return this.from(parser.readUIntN(this.ordinalWidth).toString());
    }
}
module.exports.BytesLookup = $f636268caea87bad$var$BytesLookup;

});

parcelRegister("3VAy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FieldLookup = void 0;

var $l8zQv = parcelRequire("l8zQv");

var $3PMBH = parcelRequire("3PMBH");

var $cjcqo = parcelRequire("cjcqo");
/*
 * @brief: Serialize a field based on type_code and Field.nth
 */ function $2dc30bbf10c0aac9$var$fieldHeader(type, nth) {
    const header = [];
    if (type < 16) {
        if (nth < 16) header.push(type << 4 | nth);
        else header.push(type << 4, nth);
    } else if (nth < 16) header.push(nth, type);
    else header.push(0, type, nth);
    return Uint8Array.from(header);
}
function $2dc30bbf10c0aac9$var$buildField([name, info], typeOrdinal) {
    const field = $2dc30bbf10c0aac9$var$fieldHeader(typeOrdinal, info.nth);
    return {
        name: name,
        nth: info.nth,
        isVariableLengthEncoded: info.isVLEncoded,
        isSerialized: info.isSerialized,
        isSigningField: info.isSigningField,
        ordinal: typeOrdinal << 16 | info.nth,
        type: new $l8zQv.Bytes(info.type, typeOrdinal, $cjcqo.TYPE_WIDTH),
        header: field,
        associatedType: $3PMBH.SerializedType
    };
}
/*
 * @brief: The collection of all fields as defined in definitions.json
 */ class $2dc30bbf10c0aac9$var$FieldLookup {
    constructor(fields, types){
        fields.forEach(([name, field_info])=>{
            const typeOrdinal = types[field_info.type];
            this[name] = $2dc30bbf10c0aac9$var$buildField([
                name,
                field_info
            ], typeOrdinal);
            this[this[name].ordinal.toString()] = this[name];
        });
    }
    fromString(value) {
        return this[value];
    }
}
module.exports.FieldLookup = $2dc30bbf10c0aac9$var$FieldLookup;

});
parcelRegister("3PMBH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Comparable = module.exports.SerializedType = void 0;

var $97POw = parcelRequire("97POw");

var $8wxDW = parcelRequire("8wxDW");
/**
 * The base class for all binary-codec types
 */ class $2cabd6d99e667457$var$SerializedType {
    constructor(bytes){
        this.bytes = new Uint8Array(0);
        this.bytes = bytes !== null && bytes !== void 0 ? bytes : new Uint8Array(0);
    }
    static fromParser(parser, hint) {
        throw new Error('fromParser not implemented');
    }
    static from(value) {
        throw new Error('from not implemented');
    }
    /**
     * Write the bytes representation of a SerializedType to a BytesList
     *
     * @param list The BytesList to write SerializedType bytes to
     */ toBytesSink(list) {
        list.put(this.bytes);
    }
    /**
     * Get the hex representation of a SerializedType's bytes
     *
     * @returns hex String of this.bytes
     */ toHex() {
        return (0, $8wxDW.bytesToHex)(this.toBytes());
    }
    /**
     * Get the bytes representation of a SerializedType
     *
     * @returns A Uint8Array of the bytes
     */ toBytes() {
        if (this.bytes) return this.bytes;
        const bytes = new $97POw.BytesList();
        this.toBytesSink(bytes);
        return bytes.toBytes();
    }
    /**
     * Return the JSON representation of a SerializedType
     *
     * @param _definitions rippled definitions used to parse the values of transaction types and such.
     *                          Unused in default, but used in STObject, STArray
     *                          Can be customized for sidechains and amendments.
     * @returns any type, if not overloaded returns hexString representation of bytes
     */ toJSON(_definitions, _fieldName) {
        return this.toHex();
    }
    /**
     * @returns hexString representation of this.bytes
     */ toString() {
        return this.toHex();
    }
}
module.exports.SerializedType = $2cabd6d99e667457$var$SerializedType;
/**
 * Base class for SerializedTypes that are comparable.
 *
 * @template T - What types you want to allow comparisons between. You must specify all types. Primarily used to allow
 * comparisons between built-in types (like `string`) and SerializedType subclasses (like `Hash`).
 *
 * Ex. `class Hash extends Comparable<Hash | string>`
 */ class $2cabd6d99e667457$var$Comparable extends $2cabd6d99e667457$var$SerializedType {
    lt(other) {
        return this.compareTo(other) < 0;
    }
    eq(other) {
        return this.compareTo(other) === 0;
    }
    gt(other) {
        return this.compareTo(other) > 0;
    }
    gte(other) {
        return this.compareTo(other) > -1;
    }
    lte(other) {
        return this.compareTo(other) < 1;
    }
    /**
     * Overload this method to define how two Comparable SerializedTypes are compared
     *
     * @param other The comparable object to compare this to
     * @returns A number denoting the relationship of this and other
     */ compareTo(other) {
        throw new Error(`cannot compare ${this.toString()} and ${other.toString()}`);
    }
}
module.exports.Comparable = $2cabd6d99e667457$var$Comparable;

});
parcelRegister("97POw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BinarySerializer = module.exports.BytesList = void 0;

var $8wxDW = parcelRequire("8wxDW");
/**
 * Bytes list is a collection of Uint8Array objects
 */ class $6a4cf5a9090a5dde$var$BytesList {
    constructor(){
        this.bytesArray = [];
    }
    /**
     * Get the total number of bytes in the BytesList
     *
     * @return the number of bytes
     */ getLength() {
        return (0, $8wxDW.concat)(this.bytesArray).byteLength;
    }
    /**
     * Put bytes in the BytesList
     *
     * @param bytesArg A Uint8Array
     * @return this BytesList
     */ put(bytesArg) {
        const bytes = Uint8Array.from(bytesArg); // Temporary, to catch instances of Uint8Array being passed in
        this.bytesArray.push(bytes);
        return this;
    }
    /**
     * Write this BytesList to the back of another bytes list
     *
     *  @param list The BytesList to write to
     */ toBytesSink(list) {
        list.put(this.toBytes());
    }
    toBytes() {
        return (0, $8wxDW.concat)(this.bytesArray);
    }
    toHex() {
        return (0, $8wxDW.bytesToHex)(this.toBytes());
    }
}
module.exports.BytesList = $6a4cf5a9090a5dde$var$BytesList;
/**
 * BinarySerializer is used to write fields and values to Uint8Arrays
 */ class $6a4cf5a9090a5dde$var$BinarySerializer {
    constructor(sink){
        this.sink = new $6a4cf5a9090a5dde$var$BytesList();
        this.sink = sink;
    }
    /**
     * Write a value to this BinarySerializer
     *
     * @param value a SerializedType value
     */ write(value) {
        value.toBytesSink(this.sink);
    }
    /**
     * Write bytes to this BinarySerializer
     *
     * @param bytes the bytes to write
     */ put(bytes) {
        this.sink.put(bytes);
    }
    /**
     * Write a value of a given type to this BinarySerializer
     *
     * @param type the type to write
     * @param value a value of that type
     */ writeType(type, value) {
        this.write(type.from(value));
    }
    /**
     * Write BytesList to this BinarySerializer
     *
     * @param bl BytesList to write to BinarySerializer
     */ writeBytesList(bl) {
        bl.toBytesSink(this.sink);
    }
    /**
     * Calculate the header of Variable Length encoded bytes
     *
     * @param length the length of the bytes
     */ encodeVariableLength(length) {
        const lenBytes = new Uint8Array(3);
        if (length <= 192) {
            lenBytes[0] = length;
            return lenBytes.slice(0, 1);
        } else if (length <= 12480) {
            length -= 193;
            lenBytes[0] = 193 + (length >>> 8);
            lenBytes[1] = length & 0xff;
            return lenBytes.slice(0, 2);
        } else if (length <= 918744) {
            length -= 12481;
            lenBytes[0] = 241 + (length >>> 16);
            lenBytes[1] = length >> 8 & 0xff;
            lenBytes[2] = length & 0xff;
            return lenBytes.slice(0, 3);
        }
        throw new Error('Overflow error');
    }
    /**
     * Write field and value to BinarySerializer
     *
     * @param field field to write to BinarySerializer
     * @param value value to write to BinarySerializer
     */ writeFieldAndValue(field, value, isUnlModifyWorkaround = false) {
        const associatedValue = field.associatedType.from(value);
        if (associatedValue.toBytesSink === undefined || field.name === undefined) throw new Error();
        this.sink.put(field.header);
        if (field.isVariableLengthEncoded) this.writeLengthEncoded(associatedValue, isUnlModifyWorkaround);
        else associatedValue.toBytesSink(this.sink);
    }
    /**
     * Write a variable length encoded value to the BinarySerializer
     *
     * @param value length encoded value to write to BytesList
     */ writeLengthEncoded(value, isUnlModifyWorkaround = false) {
        const bytes = new $6a4cf5a9090a5dde$var$BytesList();
        if (!isUnlModifyWorkaround) // this part doesn't happen for the Account field in a UNLModify transaction
        value.toBytesSink(bytes);
        this.put(this.encodeVariableLength(bytes.getLength()));
        this.writeBytesList(bytes);
    }
}
module.exports.BinarySerializer = $6a4cf5a9090a5dde$var$BinarySerializer;

});


parcelRegister("cjcqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRANSACTION_RESULT_WIDTH = module.exports.TRANSACTION_TYPE_WIDTH = module.exports.LEDGER_ENTRY_WIDTH = module.exports.TYPE_WIDTH = void 0;
module.exports.TYPE_WIDTH = 2;
module.exports.LEDGER_ENTRY_WIDTH = 2;
module.exports.TRANSACTION_TYPE_WIDTH = 2;
module.exports.TRANSACTION_RESULT_WIDTH = 1;

});




parcelRegister("bff2V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vector256 = module.exports.UInt64 = module.exports.UInt32 = module.exports.UInt16 = module.exports.UInt8 = module.exports.STObject = module.exports.STArray = module.exports.PathSet = module.exports.Hash256 = module.exports.Hash192 = module.exports.Hash160 = module.exports.Hash128 = module.exports.Currency = module.exports.Blob = module.exports.Amount = module.exports.AccountID = module.exports.coreTypes = void 0;

var $jbDn1 = parcelRequire("jbDn1");
Object.defineProperty(module.exports, "AccountID", {
    enumerable: true,
    get: function() {
        return $jbDn1.AccountID;
    }
});

var $jkyV0 = parcelRequire("jkyV0");
Object.defineProperty(module.exports, "Amount", {
    enumerable: true,
    get: function() {
        return $jkyV0.Amount;
    }
});

var $3D20P = parcelRequire("3D20P");
Object.defineProperty(module.exports, "Blob", {
    enumerable: true,
    get: function() {
        return $3D20P.Blob;
    }
});

var $jJkaQ = parcelRequire("jJkaQ");
Object.defineProperty(module.exports, "Currency", {
    enumerable: true,
    get: function() {
        return $jJkaQ.Currency;
    }
});

var $hWCSJ = parcelRequire("hWCSJ");
Object.defineProperty(module.exports, "Hash128", {
    enumerable: true,
    get: function() {
        return $hWCSJ.Hash128;
    }
});

var $czElY = parcelRequire("czElY");
Object.defineProperty(module.exports, "Hash160", {
    enumerable: true,
    get: function() {
        return $czElY.Hash160;
    }
});

var $hSQ7N = parcelRequire("hSQ7N");
Object.defineProperty(module.exports, "Hash192", {
    enumerable: true,
    get: function() {
        return $hSQ7N.Hash192;
    }
});

var $46bAN = parcelRequire("46bAN");
Object.defineProperty(module.exports, "Hash256", {
    enumerable: true,
    get: function() {
        return $46bAN.Hash256;
    }
});

var $knjDJ = parcelRequire("knjDJ");

var $cFPQs = parcelRequire("cFPQs");
Object.defineProperty(module.exports, "PathSet", {
    enumerable: true,
    get: function() {
        return $cFPQs.PathSet;
    }
});

var $4fDlD = parcelRequire("4fDlD");
Object.defineProperty(module.exports, "STArray", {
    enumerable: true,
    get: function() {
        return $4fDlD.STArray;
    }
});

var $8hs6X = parcelRequire("8hs6X");
Object.defineProperty(module.exports, "STObject", {
    enumerable: true,
    get: function() {
        return $8hs6X.STObject;
    }
});

var $7xLrQ = parcelRequire("7xLrQ");
Object.defineProperty(module.exports, "UInt16", {
    enumerable: true,
    get: function() {
        return $7xLrQ.UInt16;
    }
});

var $9W0MR = parcelRequire("9W0MR");
Object.defineProperty(module.exports, "UInt32", {
    enumerable: true,
    get: function() {
        return $9W0MR.UInt32;
    }
});

var $7dDUy = parcelRequire("7dDUy");
Object.defineProperty(module.exports, "UInt64", {
    enumerable: true,
    get: function() {
        return $7dDUy.UInt64;
    }
});

var $T7Ahl = parcelRequire("T7Ahl");
Object.defineProperty(module.exports, "UInt8", {
    enumerable: true,
    get: function() {
        return $T7Ahl.UInt8;
    }
});

var $6CJKR = parcelRequire("6CJKR");
Object.defineProperty(module.exports, "Vector256", {
    enumerable: true,
    get: function() {
        return $6CJKR.Vector256;
    }
});

var $g09Lr = parcelRequire("g09Lr");

var $6HRNr = parcelRequire("6HRNr");
const $82fcc44c893abd0c$var$coreTypes = {
    AccountID: $jbDn1.AccountID,
    Amount: $jkyV0.Amount,
    Blob: $3D20P.Blob,
    Currency: $jJkaQ.Currency,
    Hash128: $hWCSJ.Hash128,
    Hash160: $czElY.Hash160,
    Hash192: $hSQ7N.Hash192,
    Hash256: $46bAN.Hash256,
    Issue: $knjDJ.Issue,
    PathSet: $cFPQs.PathSet,
    STArray: $4fDlD.STArray,
    STObject: $8hs6X.STObject,
    UInt8: $T7Ahl.UInt8,
    UInt16: $7xLrQ.UInt16,
    UInt32: $9W0MR.UInt32,
    UInt64: $7dDUy.UInt64,
    Vector256: $6CJKR.Vector256,
    XChainBridge: $g09Lr.XChainBridge
};
module.exports.coreTypes = $82fcc44c893abd0c$var$coreTypes;
// Ensures that the DEFAULT_DEFINITIONS object connects these types to fields for serializing/deserializing
// This is done here instead of in enums/index.ts to avoid a circular dependency
// because some of the above types depend on BinarySerializer which depends on enums/index.ts.
$6HRNr.DEFAULT_DEFINITIONS.associateTypes($82fcc44c893abd0c$var$coreTypes);

});
parcelRegister("jbDn1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountID = void 0;

var $2qQFA = parcelRequire("2qQFA");

var $czElY = parcelRequire("czElY");

var $8wxDW = parcelRequire("8wxDW");
const $df7d95875c7d1e8a$var$HEX_REGEX = /^[A-F0-9]{40}$/;
/**
 * Class defining how to encode and decode an AccountID
 */ class $df7d95875c7d1e8a$var$AccountID extends $czElY.Hash160 {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $df7d95875c7d1e8a$var$AccountID.defaultAccountID.bytes);
    }
    /**
     * Defines how to construct an AccountID
     *
     * @param value either an existing AccountID, a hex-string, or a base58 r-Address
     * @returns an AccountID object
     */ static from(value) {
        if (value instanceof $df7d95875c7d1e8a$var$AccountID) return value;
        if (typeof value === 'string') {
            if (value === '') return new $df7d95875c7d1e8a$var$AccountID();
            return $df7d95875c7d1e8a$var$HEX_REGEX.test(value) ? new $df7d95875c7d1e8a$var$AccountID((0, $8wxDW.hexToBytes)(value)) : this.fromBase58(value);
        }
        throw new Error('Cannot construct AccountID from value given');
    }
    /**
     * Defines how to build an AccountID from a base58 r-Address
     *
     * @param value a base58 r-Address
     * @returns an AccountID object
     */ static fromBase58(value) {
        if ((0, $2qQFA.isValidXAddress)(value)) {
            const classic = (0, $2qQFA.xAddressToClassicAddress)(value);
            if (classic.tag !== false) throw new Error('Only allowed to have tag on Account or Destination');
            value = classic.classicAddress;
        }
        return new $df7d95875c7d1e8a$var$AccountID(Uint8Array.from((0, $2qQFA.decodeAccountID)(value)));
    }
    /**
     * Overload of toJSON
     *
     * @returns the base58 string for this AccountID
     */ toJSON() {
        return this.toBase58();
    }
    /**
     * Defines how to encode AccountID into a base58 address
     *
     * @returns the base58 string defined by this.bytes
     */ toBase58() {
        return (0, $2qQFA.encodeAccountID)(this.bytes);
    }
}
module.exports.AccountID = $df7d95875c7d1e8a$var$AccountID;
$df7d95875c7d1e8a$var$AccountID.defaultAccountID = new $df7d95875c7d1e8a$var$AccountID(new Uint8Array(20));

});
parcelRegister("2qQFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidXAddress = module.exports.decodeXAddress = module.exports.xAddressToClassicAddress = module.exports.encodeXAddress = module.exports.classicAddressToXAddress = module.exports.isValidClassicAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.decodeNodePublic = module.exports.encodeNodePublic = module.exports.decodeAccountID = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.codec = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $l2aZG = parcelRequire("l2aZG");
Object.defineProperty(module.exports, "codec", {
    enumerable: true,
    get: function() {
        return $l2aZG.codec;
    }
});
Object.defineProperty(module.exports, "encodeSeed", {
    enumerable: true,
    get: function() {
        return $l2aZG.encodeSeed;
    }
});
Object.defineProperty(module.exports, "decodeSeed", {
    enumerable: true,
    get: function() {
        return $l2aZG.decodeSeed;
    }
});
Object.defineProperty(module.exports, "encodeAccountID", {
    enumerable: true,
    get: function() {
        return $l2aZG.encodeAccountID;
    }
});
Object.defineProperty(module.exports, "decodeAccountID", {
    enumerable: true,
    get: function() {
        return $l2aZG.decodeAccountID;
    }
});
Object.defineProperty(module.exports, "encodeNodePublic", {
    enumerable: true,
    get: function() {
        return $l2aZG.encodeNodePublic;
    }
});
Object.defineProperty(module.exports, "decodeNodePublic", {
    enumerable: true,
    get: function() {
        return $l2aZG.decodeNodePublic;
    }
});
Object.defineProperty(module.exports, "encodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $l2aZG.encodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "decodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $l2aZG.decodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "isValidClassicAddress", {
    enumerable: true,
    get: function() {
        return $l2aZG.isValidClassicAddress;
    }
});
const $1c56dd94a5a70ce9$var$PREFIX_BYTES = {
    // 5, 68
    main: Uint8Array.from([
        0x05,
        0x44
    ]),
    // 4, 147
    test: Uint8Array.from([
        0x04,
        0x93
    ])
};
const $1c56dd94a5a70ce9$var$MAX_32_BIT_UNSIGNED_INT = 4294967295;
function $1c56dd94a5a70ce9$var$classicAddressToXAddress(classicAddress, tag, test) {
    const accountId = (0, $l2aZG.decodeAccountID)(classicAddress);
    return $1c56dd94a5a70ce9$var$encodeXAddress(accountId, tag, test);
}
module.exports.classicAddressToXAddress = $1c56dd94a5a70ce9$var$classicAddressToXAddress;
function $1c56dd94a5a70ce9$var$encodeXAddress(accountId, tag, test) {
    if (accountId.length !== 20) // RIPEMD160 is 160 bits = 20 bytes
    throw new Error('Account ID must be 20 bytes');
    if (tag !== false && tag > $1c56dd94a5a70ce9$var$MAX_32_BIT_UNSIGNED_INT) throw new Error('Invalid tag');
    const theTag = tag || 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Passing null is a common js mistake
    const flag = tag === false || tag == null ? 0 : 1;
    /* eslint-disable no-bitwise ---
     * need to use bitwise operations here */ const bytes = (0, $8wxDW.concat)([
        test ? $1c56dd94a5a70ce9$var$PREFIX_BYTES.test : $1c56dd94a5a70ce9$var$PREFIX_BYTES.main,
        accountId,
        Uint8Array.from([
            // 0x00 if no tag, 0x01 if 32-bit tag
            flag,
            // first byte
            theTag & 0xff,
            // second byte
            theTag >> 8 & 0xff,
            // third byte
            theTag >> 16 & 0xff,
            // fourth byte
            theTag >> 24 & 0xff,
            0,
            0,
            0,
            // four zero bytes (reserved for 64-bit tags)
            0
        ])
    ]);
    /* eslint-enable no-bitwise */ return $l2aZG.codec.encodeChecked(bytes);
}
module.exports.encodeXAddress = $1c56dd94a5a70ce9$var$encodeXAddress;
function $1c56dd94a5a70ce9$var$xAddressToClassicAddress(xAddress) {
    /* eslint-disable @typescript-eslint/naming-convention --
     * TODO 'test' should be something like 'isTest', do this later
     */ const { accountId: accountId, tag: tag, test: test } = $1c56dd94a5a70ce9$var$decodeXAddress(xAddress);
    /* eslint-enable @typescript-eslint/naming-convention */ const classicAddress = (0, $l2aZG.encodeAccountID)(accountId);
    return {
        classicAddress: classicAddress,
        tag: tag,
        test: test
    };
}
module.exports.xAddressToClassicAddress = $1c56dd94a5a70ce9$var$xAddressToClassicAddress;
function $1c56dd94a5a70ce9$var$decodeXAddress(xAddress) {
    const decoded = $l2aZG.codec.decodeChecked(xAddress);
    /* eslint-disable @typescript-eslint/naming-convention --
     * TODO 'test' should be something like 'isTest', do this later
     */ const test = $1c56dd94a5a70ce9$var$isUint8ArrayForTestAddress(decoded);
    /* eslint-enable @typescript-eslint/naming-convention */ const accountId = decoded.slice(2, 22);
    const tag = $1c56dd94a5a70ce9$var$tagFromUint8Array(decoded);
    return {
        accountId: accountId,
        tag: tag,
        test: test
    };
}
module.exports.decodeXAddress = $1c56dd94a5a70ce9$var$decodeXAddress;
function $1c56dd94a5a70ce9$var$isUint8ArrayForTestAddress(buf) {
    const decodedPrefix = buf.slice(0, 2);
    if ((0, $8wxDW.equal)($1c56dd94a5a70ce9$var$PREFIX_BYTES.main, decodedPrefix)) return false;
    if ((0, $8wxDW.equal)($1c56dd94a5a70ce9$var$PREFIX_BYTES.test, decodedPrefix)) return true;
    throw new Error('Invalid X-address: bad prefix');
}
function $1c56dd94a5a70ce9$var$tagFromUint8Array(buf) {
    const flag = buf[22];
    if (flag >= 2) // No support for 64-bit tags at this time
    throw new Error('Unsupported X-address');
    if (flag === 1) // Little-endian to big-endian
    return buf[23] + buf[24] * 0x100 + buf[25] * 0x10000 + buf[26] * 0x1000000;
    if (flag !== 0) throw new Error('flag must be zero to indicate no tag');
    if (!(0, $8wxDW.equal)((0, $8wxDW.hexToBytes)('0000000000000000'), buf.slice(23, 31))) throw new Error('remaining bytes must be zero');
    return false;
}
function $1c56dd94a5a70ce9$var$isValidXAddress(xAddress) {
    try {
        $1c56dd94a5a70ce9$var$decodeXAddress(xAddress);
    } catch (_error) {
        return false;
    }
    return true;
}
module.exports.isValidXAddress = $1c56dd94a5a70ce9$var$isValidXAddress;

});
parcelRegister("l2aZG", function(module, exports) {
"use strict";
/**
 * Codec class
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidClassicAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.encodeNodePublic = module.exports.decodeNodePublic = module.exports.decodeAddress = module.exports.decodeAccountID = module.exports.encodeAddress = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.codec = void 0;

var $3ctkB = parcelRequire("3ctkB");

var $eWnEn = parcelRequire("eWnEn");

var $j9ALr = parcelRequire("j9ALr");
class $f5025003e85909d3$var$Codec {
    constructor(options){
        this._sha256 = options.sha256;
        this._codec = $3ctkB.base58xrp;
    }
    /**
     * Encoder.
     *
     * @param bytes - Uint8Array of data to encode.
     * @param opts - Options object including the version bytes and the expected length of the data to encode.
     */ encode(bytes, opts) {
        const versions = opts.versions;
        return this._encodeVersioned(bytes, versions, opts.expectedLength);
    }
    /**
     * Decoder.
     *
     * @param base58string - Base58Check-encoded string to decode.
     * @param opts - Options object including the version byte(s) and the expected length of the data after decoding.
     */ /* eslint-disable max-lines-per-function --
     * TODO refactor */ decode(base58string, opts) {
        var _a;
        const versions = opts.versions;
        const types = opts.versionTypes;
        const withoutSum = this.decodeChecked(base58string);
        if (versions.length > 1 && !opts.expectedLength) throw new Error('expectedLength is required because there are >= 2 possible versions');
        const versionLengthGuess = typeof versions[0] === 'number' ? 1 : versions[0].length;
        const payloadLength = (_a = opts.expectedLength) !== null && _a !== void 0 ? _a : withoutSum.length - versionLengthGuess;
        const versionBytes = withoutSum.slice(0, -payloadLength);
        const payload = withoutSum.slice(-payloadLength);
        for(let i = 0; i < versions.length; i++){
            /* eslint-disable @typescript-eslint/consistent-type-assertions --
             * TODO refactor */ const version = Array.isArray(versions[i]) ? versions[i] : [
                versions[i]
            ];
            if ((0, $j9ALr.arrayEqual)(versionBytes, version)) return {
                version: version,
                bytes: payload,
                type: types ? types[i] : null
            };
        /* eslint-enable @typescript-eslint/consistent-type-assertions */ }
        throw new Error('version_invalid: version bytes do not match any of the provided version(s)');
    }
    encodeChecked(bytes) {
        const check = this._sha256(this._sha256(bytes)).slice(0, 4);
        return this._encodeRaw(Uint8Array.from((0, $j9ALr.concatArgs)(bytes, check)));
    }
    decodeChecked(base58string) {
        const intArray = this._decodeRaw(base58string);
        if (intArray.byteLength < 5) throw new Error('invalid_input_size: decoded data must have length >= 5');
        if (!this._verifyCheckSum(intArray)) throw new Error('checksum_invalid');
        return intArray.slice(0, -4);
    }
    _encodeVersioned(bytes, versions, expectedLength) {
        if (!$f5025003e85909d3$var$checkByteLength(bytes, expectedLength)) throw new Error("unexpected_payload_length: bytes.length does not match expectedLength. Ensure that the bytes are a Uint8Array.");
        return this.encodeChecked((0, $j9ALr.concatArgs)(versions, bytes));
    }
    _encodeRaw(bytes) {
        return this._codec.encode(Uint8Array.from(bytes));
    }
    /* eslint-enable max-lines-per-function */ _decodeRaw(base58string) {
        return this._codec.decode(base58string);
    }
    _verifyCheckSum(bytes) {
        const computed = this._sha256(this._sha256(bytes.slice(0, -4))).slice(0, 4);
        const checksum = bytes.slice(-4);
        return (0, $j9ALr.arrayEqual)(computed, checksum);
    }
}
/**
 * XRP codec
 */ // base58 encodings: https://xrpl.org/base58-encodings.html
// Account address (20 bytes)
const $f5025003e85909d3$var$ACCOUNT_ID = 0;
// Account public key (33 bytes)
const $f5025003e85909d3$var$ACCOUNT_PUBLIC_KEY = 0x23;
// 33; Seed value (for secret keys) (16 bytes)
const $f5025003e85909d3$var$FAMILY_SEED = 0x21;
// 28; Validation public key (33 bytes)
const $f5025003e85909d3$var$NODE_PUBLIC = 0x1c;
// [1, 225, 75]
const $f5025003e85909d3$var$ED25519_SEED = [
    0x01,
    0xe1,
    0x4b
];
const $f5025003e85909d3$var$codecOptions = {
    sha256: $eWnEn.sha256
};
const $f5025003e85909d3$var$codecWithXrpAlphabet = new $f5025003e85909d3$var$Codec($f5025003e85909d3$var$codecOptions);
module.exports.codec = $f5025003e85909d3$var$codecWithXrpAlphabet;
// entropy is a Uint8Array of size 16
// type is 'ed25519' or 'secp256k1'
function $f5025003e85909d3$var$encodeSeed(entropy, type) {
    if (!$f5025003e85909d3$var$checkByteLength(entropy, 16)) throw new Error('entropy must have length 16');
    const opts = {
        expectedLength: 16,
        // for secp256k1, use `FAMILY_SEED`
        versions: type === 'ed25519' ? $f5025003e85909d3$var$ED25519_SEED : [
            $f5025003e85909d3$var$FAMILY_SEED
        ]
    };
    // prefixes entropy with version bytes
    return $f5025003e85909d3$var$codecWithXrpAlphabet.encode(entropy, opts);
}
module.exports.encodeSeed = $f5025003e85909d3$var$encodeSeed;
function $f5025003e85909d3$var$decodeSeed(seed, opts = {
    versionTypes: [
        'ed25519',
        'secp256k1'
    ],
    versions: [
        $f5025003e85909d3$var$ED25519_SEED,
        $f5025003e85909d3$var$FAMILY_SEED
    ],
    expectedLength: 16
}) {
    return $f5025003e85909d3$var$codecWithXrpAlphabet.decode(seed, opts);
}
module.exports.decodeSeed = $f5025003e85909d3$var$decodeSeed;
function $f5025003e85909d3$var$encodeAccountID(bytes) {
    const opts = {
        versions: [
            $f5025003e85909d3$var$ACCOUNT_ID
        ],
        expectedLength: 20
    };
    return $f5025003e85909d3$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeAccountID = $f5025003e85909d3$var$encodeAccountID;
/* eslint-disable import/no-unused-modules ---
 * unclear why this is aliased but we should keep it in case someone else is
 * importing it with the aliased name */ module.exports.encodeAddress = $f5025003e85909d3$var$encodeAccountID;
/* eslint-enable import/no-unused-modules */ function $f5025003e85909d3$var$decodeAccountID(accountId) {
    const opts = {
        versions: [
            $f5025003e85909d3$var$ACCOUNT_ID
        ],
        expectedLength: 20
    };
    return $f5025003e85909d3$var$codecWithXrpAlphabet.decode(accountId, opts).bytes;
}
module.exports.decodeAccountID = $f5025003e85909d3$var$decodeAccountID;
/* eslint-disable import/no-unused-modules ---
 * unclear why this is aliased but we should keep it in case someone else is
 * importing it with the aliased name */ module.exports.decodeAddress = $f5025003e85909d3$var$decodeAccountID;
/* eslint-enable import/no-unused-modules */ function $f5025003e85909d3$var$decodeNodePublic(base58string) {
    const opts = {
        versions: [
            $f5025003e85909d3$var$NODE_PUBLIC
        ],
        expectedLength: 33
    };
    return $f5025003e85909d3$var$codecWithXrpAlphabet.decode(base58string, opts).bytes;
}
module.exports.decodeNodePublic = $f5025003e85909d3$var$decodeNodePublic;
function $f5025003e85909d3$var$encodeNodePublic(bytes) {
    const opts = {
        versions: [
            $f5025003e85909d3$var$NODE_PUBLIC
        ],
        expectedLength: 33
    };
    return $f5025003e85909d3$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeNodePublic = $f5025003e85909d3$var$encodeNodePublic;
function $f5025003e85909d3$var$encodeAccountPublic(bytes) {
    const opts = {
        versions: [
            $f5025003e85909d3$var$ACCOUNT_PUBLIC_KEY
        ],
        expectedLength: 33
    };
    return $f5025003e85909d3$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeAccountPublic = $f5025003e85909d3$var$encodeAccountPublic;
function $f5025003e85909d3$var$decodeAccountPublic(base58string) {
    const opts = {
        versions: [
            $f5025003e85909d3$var$ACCOUNT_PUBLIC_KEY
        ],
        expectedLength: 33
    };
    return $f5025003e85909d3$var$codecWithXrpAlphabet.decode(base58string, opts).bytes;
}
module.exports.decodeAccountPublic = $f5025003e85909d3$var$decodeAccountPublic;
function $f5025003e85909d3$var$isValidClassicAddress(address) {
    try {
        $f5025003e85909d3$var$decodeAccountID(address);
    } catch (_error) {
        return false;
    }
    return true;
}
module.exports.isValidClassicAddress = $f5025003e85909d3$var$isValidClassicAddress;
function $f5025003e85909d3$var$checkByteLength(bytes, expectedLength) {
    return 'byteLength' in bytes ? bytes.byteLength === expectedLength : bytes.length === expectedLength;
}

});
parcelRegister("j9ALr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatArgs = module.exports.arrayEqual = void 0;
/**
 * Check whether two sequences (e.g. Arrays of numbers) are equal.
 *
 * @param arr1 - One of the arrays to compare.
 * @param arr2 - The other array to compare.
 */ function $df1b6031d6be1711$var$arrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((value, index)=>value === arr2[index]);
}
module.exports.arrayEqual = $df1b6031d6be1711$var$arrayEqual;
/**
 * Check whether a value is a scalar
 *
 * @param val - The value to check.
 */ function $df1b6031d6be1711$var$isScalar(val) {
    return typeof val === 'number';
}
/**
 * Concatenate all `arguments` into a single array. Each argument can be either
 * a single element or a sequence, which has a `length` property and supports
 * element retrieval via sequence[ix].
 *
 * > concatArgs(1, [2, 3], Uint8Array.from([4,5]), new Uint8Array([6, 7]));
 * [1,2,3,4,5,6,7]
 *
 * @param args - Concatenate of these args into a single array.
 * @returns Array of concatenated arguments
 */ function $df1b6031d6be1711$var$concatArgs(...args) {
    return args.flatMap((arg)=>{
        return $df1b6031d6be1711$var$isScalar(arg) ? [
            arg
        ] : Array.from(arg);
    });
}
module.exports.concatArgs = $df1b6031d6be1711$var$concatArgs;

});



parcelRegister("czElY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash160 = void 0;

var $jUSxK = parcelRequire("jUSxK");
/**
 * Hash with a width of 160 bits
 */ class $92780e4a92e49238$var$Hash160 extends $jUSxK.Hash {
    constructor(bytes){
        if (bytes && bytes.byteLength === 0) bytes = $92780e4a92e49238$var$Hash160.ZERO_160.bytes;
        super(bytes !== null && bytes !== void 0 ? bytes : $92780e4a92e49238$var$Hash160.ZERO_160.bytes);
    }
}
module.exports.Hash160 = $92780e4a92e49238$var$Hash160;
$92780e4a92e49238$var$Hash160.width = 20;
$92780e4a92e49238$var$Hash160.ZERO_160 = new $92780e4a92e49238$var$Hash160(new Uint8Array($92780e4a92e49238$var$Hash160.width));

});
parcelRegister("jUSxK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = void 0;

var $3PMBH = parcelRequire("3PMBH");

var $8wxDW = parcelRequire("8wxDW");

var $hdCF9 = parcelRequire("hdCF9");
/**
 * Base class defining how to encode and decode hashes
 */ class $e7fd8e764c4c161e$var$Hash extends $3PMBH.Comparable {
    constructor(bytes){
        super(bytes);
        if (this.bytes.length !== this.constructor.width) throw new Error(`Invalid Hash length ${this.bytes.byteLength}`);
    }
    /**
     * Construct a Hash object from an existing Hash object or a hex-string
     *
     * @param value A hash object or hex-string of a hash
     */ static from(value) {
        if (value instanceof this) return value;
        if (typeof value === 'string') return new this((0, $8wxDW.hexToBytes)(value));
        throw new Error('Cannot construct Hash from given value');
    }
    /**
     * Read a Hash object from a BinaryParser
     *
     * @param parser BinaryParser to read the hash from
     * @param hint length of the bytes to read, optional
     */ static fromParser(parser, hint) {
        return new this(parser.read(hint !== null && hint !== void 0 ? hint : this.width));
    }
    /**
     * Overloaded operator for comparing two hash objects
     *
     * @param other The Hash to compare this to
     */ compareTo(other) {
        return (0, $hdCF9.compare)(this.bytes, this.constructor.from(other).bytes);
    }
    /**
     * @returns the hex-string representation of this Hash
     */ toString() {
        return this.toHex();
    }
    /**
     * Returns four bits at the specified depth within a hash
     *
     * @param depth The depth of the four bits
     * @returns The number represented by the four bits
     */ nibblet(depth) {
        const byteIx = depth > 0 ? depth / 2 | 0 : 0;
        let b = this.bytes[byteIx];
        if (depth % 2 === 0) b = (b & 0xf0) >>> 4;
        else b = b & 0x0f;
        return b;
    }
}
module.exports.Hash = $e7fd8e764c4c161e$var$Hash;

});
parcelRegister("hdCF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compare = module.exports.equal = module.exports.readUInt32BE = module.exports.readUInt16BE = module.exports.writeUInt32BE = module.exports.writeUInt16BE = module.exports.writeUInt8 = void 0;
/**
 * Writes value to array at the specified offset. The value must be a valid unsigned 8-bit integer.
 * @param array Uint8Array to be written to
 * @param value Number to be written to array.
 * @param offset plus the number of bytes written.
 */ function $c891a432b7ead7de$var$writeUInt8(array, value, offset) {
    value = Number(value);
    array[offset] = value;
}
module.exports.writeUInt8 = $c891a432b7ead7de$var$writeUInt8;
/**
 * Writes value to array at the specified offset as big-endian. The value must be a valid unsigned 16-bit integer.
 * @param array Uint8Array to be written to
 * @param value Number to be written to array.
 * @param offset plus the number of bytes written.
 */ function $c891a432b7ead7de$var$writeUInt16BE(array, value, offset) {
    value = Number(value);
    array[offset] = value >>> 8;
    array[offset + 1] = value;
}
module.exports.writeUInt16BE = $c891a432b7ead7de$var$writeUInt16BE;
/**
 * Writes value to array at the specified offset as big-endian. The value must be a valid unsigned 32-bit integer.
 * @param array Uint8Array to be written to
 * @param value Number to be written to array.
 * @param offset plus the number of bytes written.
 */ function $c891a432b7ead7de$var$writeUInt32BE(array, value, offset) {
    array[offset] = value >>> 24 & 0xff;
    array[offset + 1] = value >>> 16 & 0xff;
    array[offset + 2] = value >>> 8 & 0xff;
    array[offset + 3] = value & 0xff;
}
module.exports.writeUInt32BE = $c891a432b7ead7de$var$writeUInt32BE;
/**
 * Reads an unsigned, big-endian 16-bit integer from the array at the specified offset.
 * @param array Uint8Array to read
 * @param offset Number of bytes to skip before starting to read. Must satisfy 0 <= offset <= buf.length - 2
 */ function $c891a432b7ead7de$var$readUInt16BE(array, offset) {
    return new DataView(array.buffer).getUint16(offset, false).toString(10);
}
module.exports.readUInt16BE = $c891a432b7ead7de$var$readUInt16BE;
/**
 * Reads an unsigned, big-endian 16-bit integer from the array at the specified offset.
 * @param array Uint8Array to read
 * @param offset Number of bytes to skip before starting to read. Must satisfy 0 <= offset <= buf.length - 4
 */ function $c891a432b7ead7de$var$readUInt32BE(array, offset) {
    return new DataView(array.buffer).getUint32(offset, false).toString(10);
}
module.exports.readUInt32BE = $c891a432b7ead7de$var$readUInt32BE;
/**
 * Compares two Uint8Array or ArrayBuffers
 * @param a first array to compare
 * @param b second array to compare
 */ function $c891a432b7ead7de$var$equal(a, b) {
    const aUInt = a instanceof ArrayBuffer ? new Uint8Array(a, 0) : a;
    const bUInt = b instanceof ArrayBuffer ? new Uint8Array(b, 0) : b;
    if (aUInt.byteLength != bUInt.byteLength) return false;
    if ($c891a432b7ead7de$var$aligned32(aUInt) && $c891a432b7ead7de$var$aligned32(bUInt)) return $c891a432b7ead7de$var$compare32(aUInt, bUInt) === 0;
    if ($c891a432b7ead7de$var$aligned16(aUInt) && $c891a432b7ead7de$var$aligned16(bUInt)) return $c891a432b7ead7de$var$compare16(aUInt, bUInt) === 0;
    return $c891a432b7ead7de$var$compare8(aUInt, bUInt) === 0;
}
module.exports.equal = $c891a432b7ead7de$var$equal;
/**
 * Compares two 8 bit aligned arrays
 * @param a first array to compare
 * @param b second array to compare
 */ function $c891a432b7ead7de$var$compare8(a, b) {
    const ua = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    const ub = new Uint8Array(b.buffer, b.byteOffset, b.byteLength);
    return $c891a432b7ead7de$var$compare(ua, ub);
}
/**
 * Compares two 16 bit aligned arrays
 * @param a first array to compare
 * @param b second array to compare
 */ function $c891a432b7ead7de$var$compare16(a, b) {
    const ua = new Uint16Array(a.buffer, a.byteOffset, a.byteLength / 2);
    const ub = new Uint16Array(b.buffer, b.byteOffset, b.byteLength / 2);
    return $c891a432b7ead7de$var$compare(ua, ub);
}
/**
 * Compares two 32 bit aligned arrays
 * @param a first array to compare
 * @param b second array to compare
 */ function $c891a432b7ead7de$var$compare32(a, b) {
    const ua = new Uint32Array(a.buffer, a.byteOffset, a.byteLength / 4);
    const ub = new Uint32Array(b.buffer, b.byteOffset, b.byteLength / 4);
    return $c891a432b7ead7de$var$compare(ua, ub);
}
/**
 * Compare two TypedArrays
 * @param a first array to compare
 * @param b second array to compare
 */ function $c891a432b7ead7de$var$compare(a, b) {
    if (a.byteLength !== b.byteLength) throw new Error('Cannot compare arrays of different length');
    for(let i = 0; i < a.length - 1; i += 1){
        if (a[i] > b[i]) return 1;
        if (a[i] < b[i]) return -1;
    }
    return 0;
}
module.exports.compare = $c891a432b7ead7de$var$compare;
/**
 * Determine if TypedArray is 16 bit aligned
 * @param array The array to check
 */ function $c891a432b7ead7de$var$aligned16(array) {
    return array.byteOffset % 2 === 0 && array.byteLength % 2 === 0;
}
/**
 * Determine if TypedArray is 32 bit aligned
 * @param array The array to check
 */ function $c891a432b7ead7de$var$aligned32(array) {
    return array.byteOffset % 4 === 0 && array.byteLength % 4 === 0;
}

});




parcelRegister("jkyV0", function(module, exports) {
"use strict";
var $e12af8a22c261e12$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Amount = void 0;

var $fhZB1 = parcelRequire("fhZB1");

var $jbDn1 = parcelRequire("jbDn1");

var $jJkaQ = parcelRequire("jJkaQ");

var $3PMBH = parcelRequire("3PMBH");

const $e12af8a22c261e12$var$bignumber_js_1 = $e12af8a22c261e12$var$__importDefault((parcelRequire("hqAsy")));

var $8wxDW = parcelRequire("8wxDW");

var $hdCF9 = parcelRequire("hdCF9");

var $hSQ7N = parcelRequire("hSQ7N");
/**
 * Constants for validating amounts
 */ const $e12af8a22c261e12$var$MIN_IOU_EXPONENT = -96;
const $e12af8a22c261e12$var$MAX_IOU_EXPONENT = 80;
const $e12af8a22c261e12$var$MAX_IOU_PRECISION = 16;
const $e12af8a22c261e12$var$MAX_DROPS = new $e12af8a22c261e12$var$bignumber_js_1.default('1e17');
const $e12af8a22c261e12$var$MIN_XRP = new $e12af8a22c261e12$var$bignumber_js_1.default('1e-6');
const $e12af8a22c261e12$var$mask = BigInt(0x00000000ffffffff);
const $e12af8a22c261e12$var$mptMask = BigInt(0x8000000000000000);
/**
 * BigNumber configuration for Amount IOUs
 */ $e12af8a22c261e12$var$bignumber_js_1.default.config({
    EXPONENTIAL_AT: [
        $e12af8a22c261e12$var$MIN_IOU_EXPONENT - $e12af8a22c261e12$var$MAX_IOU_PRECISION,
        $e12af8a22c261e12$var$MAX_IOU_EXPONENT + $e12af8a22c261e12$var$MAX_IOU_PRECISION
    ]
});
/**
 * Type guard for AmountObjectIOU
 */ function $e12af8a22c261e12$var$isAmountObjectIOU(arg) {
    const keys = Object.keys(arg).sort();
    return keys.length === 3 && keys[0] === 'currency' && keys[1] === 'issuer' && keys[2] === 'value';
}
/**
 * Type guard for AmountObjectMPT
 */ function $e12af8a22c261e12$var$isAmountObjectMPT(arg) {
    const keys = Object.keys(arg).sort();
    return keys.length === 2 && keys[0] === 'mpt_issuance_id' && keys[1] === 'value';
}
/**
 * Class for serializing/Deserializing Amounts
 */ class $e12af8a22c261e12$var$Amount extends $3PMBH.SerializedType {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $e12af8a22c261e12$var$Amount.defaultAmount.bytes);
    }
    /**
     * Construct an amount from an IOU, MPT or string amount
     *
     * @param value An Amount, object representing an IOU, or a string
     *     representing an integer amount
     * @returns An Amount object
     */ static from(value) {
        if (value instanceof $e12af8a22c261e12$var$Amount) return value;
        let amount = new Uint8Array(8);
        if (typeof value === 'string') {
            $e12af8a22c261e12$var$Amount.assertXrpIsValid(value);
            const number = BigInt(value);
            const intBuf = [
                new Uint8Array(4),
                new Uint8Array(4)
            ];
            (0, $hdCF9.writeUInt32BE)(intBuf[0], Number(number >> BigInt(32)), 0);
            (0, $hdCF9.writeUInt32BE)(intBuf[1], Number(number & BigInt($e12af8a22c261e12$var$mask)), 0);
            amount = (0, $8wxDW.concat)(intBuf);
            amount[0] |= 0x40;
            return new $e12af8a22c261e12$var$Amount(amount);
        }
        if ($e12af8a22c261e12$var$isAmountObjectIOU(value)) {
            const number = new $e12af8a22c261e12$var$bignumber_js_1.default(value.value);
            $e12af8a22c261e12$var$Amount.assertIouIsValid(number);
            if (number.isZero()) amount[0] |= 0x80;
            else {
                const integerNumberString = number.times(`1e${-((number.e || 0) - 15)}`).abs().toString();
                const num = BigInt(integerNumberString);
                const intBuf = [
                    new Uint8Array(4),
                    new Uint8Array(4)
                ];
                (0, $hdCF9.writeUInt32BE)(intBuf[0], Number(num >> BigInt(32)), 0);
                (0, $hdCF9.writeUInt32BE)(intBuf[1], Number(num & BigInt($e12af8a22c261e12$var$mask)), 0);
                amount = (0, $8wxDW.concat)(intBuf);
                amount[0] |= 0x80;
                if (number.gt(new $e12af8a22c261e12$var$bignumber_js_1.default(0))) amount[0] |= 0x40;
                const exponent = (number.e || 0) - 15;
                const exponentByte = 97 + exponent;
                amount[0] |= exponentByte >>> 2;
                amount[1] |= (exponentByte & 0x03) << 6;
            }
            const currency = $jJkaQ.Currency.from(value.currency).toBytes();
            const issuer = $jbDn1.AccountID.from(value.issuer).toBytes();
            return new $e12af8a22c261e12$var$Amount((0, $8wxDW.concat)([
                amount,
                currency,
                issuer
            ]));
        }
        if ($e12af8a22c261e12$var$isAmountObjectMPT(value)) {
            $e12af8a22c261e12$var$Amount.assertMptIsValid(value.value);
            let leadingByte = new Uint8Array(1);
            leadingByte[0] |= 0x60;
            const num = BigInt(value.value);
            const intBuf = [
                new Uint8Array(4),
                new Uint8Array(4)
            ];
            (0, $hdCF9.writeUInt32BE)(intBuf[0], Number(num >> BigInt(32)), 0);
            (0, $hdCF9.writeUInt32BE)(intBuf[1], Number(num & BigInt($e12af8a22c261e12$var$mask)), 0);
            amount = (0, $8wxDW.concat)(intBuf);
            const mptIssuanceID = $hSQ7N.Hash192.from(value.mpt_issuance_id).toBytes();
            return new $e12af8a22c261e12$var$Amount((0, $8wxDW.concat)([
                leadingByte,
                amount,
                mptIssuanceID
            ]));
        }
        throw new Error('Invalid type to construct an Amount');
    }
    /**
     * Read an amount from a BinaryParser
     *
     * @param parser BinaryParser to read the Amount from
     * @returns An Amount object
     */ static fromParser(parser) {
        const isIOU = parser.peek() & 0x80;
        if (isIOU) return new $e12af8a22c261e12$var$Amount(parser.read(48));
        // the amount can be either MPT or XRP at this point
        const isMPT = parser.peek() & 0x20;
        const numBytes = isMPT ? 33 : 8;
        return new $e12af8a22c261e12$var$Amount(parser.read(numBytes));
    }
    /**
     * Get the JSON representation of this Amount
     *
     * @returns the JSON interpretation of this.bytes
     */ toJSON() {
        if (this.isNative()) {
            const bytes = this.bytes;
            const isPositive = bytes[0] & 0x40;
            const sign = isPositive ? '' : '-';
            bytes[0] &= 0x3f;
            const msb = BigInt((0, $hdCF9.readUInt32BE)(bytes.slice(0, 4), 0));
            const lsb = BigInt((0, $hdCF9.readUInt32BE)(bytes.slice(4), 0));
            const num = msb << BigInt(32) | lsb;
            return `${sign}${num.toString()}`;
        }
        if (this.isIOU()) {
            const parser = new $fhZB1.BinaryParser(this.toString());
            const mantissa = parser.read(8);
            const currency = $jJkaQ.Currency.fromParser(parser);
            const issuer = $jbDn1.AccountID.fromParser(parser);
            const b1 = mantissa[0];
            const b2 = mantissa[1];
            const isPositive = b1 & 0x40;
            const sign = isPositive ? '' : '-';
            const exponent = ((b1 & 0x3f) << 2) + ((b2 & 0xff) >> 6) - 97;
            mantissa[0] = 0;
            mantissa[1] &= 0x3f;
            const value = new $e12af8a22c261e12$var$bignumber_js_1.default(`${sign}0x${(0, $8wxDW.bytesToHex)(mantissa)}`).times(`1e${exponent}`);
            $e12af8a22c261e12$var$Amount.assertIouIsValid(value);
            return {
                value: value.toString(),
                currency: currency.toJSON(),
                issuer: issuer.toJSON()
            };
        }
        if (this.isMPT()) {
            const parser = new $fhZB1.BinaryParser(this.toString());
            const leadingByte = parser.read(1);
            const amount = parser.read(8);
            const mptID = $hSQ7N.Hash192.fromParser(parser);
            const isPositive = leadingByte[0] & 0x40;
            const sign = isPositive ? '' : '-';
            const msb = BigInt((0, $hdCF9.readUInt32BE)(amount.slice(0, 4), 0));
            const lsb = BigInt((0, $hdCF9.readUInt32BE)(amount.slice(4), 0));
            const num = msb << BigInt(32) | lsb;
            return {
                value: `${sign}${num.toString()}`,
                mpt_issuance_id: mptID.toString()
            };
        }
        throw new Error('Invalid amount to construct JSON');
    }
    /**
     * Validate XRP amount
     *
     * @param amount String representing XRP amount
     * @returns void, but will throw if invalid amount
     */ static assertXrpIsValid(amount) {
        if (amount.indexOf('.') !== -1) throw new Error(`${amount.toString()} is an illegal amount`);
        const decimal = new $e12af8a22c261e12$var$bignumber_js_1.default(amount);
        if (!decimal.isZero()) {
            if (decimal.lt($e12af8a22c261e12$var$MIN_XRP) || decimal.gt($e12af8a22c261e12$var$MAX_DROPS)) throw new Error(`${amount.toString()} is an illegal amount`);
        }
    }
    /**
     * Validate IOU.value amount
     *
     * @param decimal BigNumber object representing IOU.value
     * @returns void, but will throw if invalid amount
     */ static assertIouIsValid(decimal) {
        if (!decimal.isZero()) {
            const p = decimal.precision();
            const e = (decimal.e || 0) - 15;
            if (p > $e12af8a22c261e12$var$MAX_IOU_PRECISION || e > $e12af8a22c261e12$var$MAX_IOU_EXPONENT || e < $e12af8a22c261e12$var$MIN_IOU_EXPONENT) throw new Error('Decimal precision out of range');
            this.verifyNoDecimal(decimal);
        }
    }
    /**
     * Validate MPT.value amount
     *
     * @param decimal BigNumber object representing MPT.value
     * @returns void, but will throw if invalid amount
     */ static assertMptIsValid(amount) {
        if (amount.indexOf('.') !== -1) throw new Error(`${amount.toString()} is an illegal amount`);
        const decimal = new $e12af8a22c261e12$var$bignumber_js_1.default(amount);
        if (!decimal.isZero()) {
            if (decimal < (0, $e12af8a22c261e12$var$bignumber_js_1.default)(0)) throw new Error(`${amount.toString()} is an illegal amount`);
            if (Number(BigInt(amount) & BigInt($e12af8a22c261e12$var$mptMask)) != 0) throw new Error(`${amount.toString()} is an illegal amount`);
        }
    }
    /**
     * Ensure that the value after being multiplied by the exponent does not
     * contain a decimal.
     *
     * @param decimal a Decimal object
     * @returns a string of the object without a decimal
     */ static verifyNoDecimal(decimal) {
        const integerNumberString = decimal.times(`1e${-((decimal.e || 0) - 15)}`).abs().toString();
        if (integerNumberString.indexOf('.') !== -1) throw new Error('Decimal place found in integerNumberString');
    }
    /**
     * Test if this amount is in units of Native Currency(XRP)
     *
     * @returns true if Native (XRP)
     */ isNative() {
        return (this.bytes[0] & 0x80) === 0 && (this.bytes[0] & 0x20) === 0;
    }
    /**
     * Test if this amount is in units of MPT
     *
     * @returns true if MPT
     */ isMPT() {
        return (this.bytes[0] & 0x80) === 0 && (this.bytes[0] & 0x20) !== 0;
    }
    /**
     * Test if this amount is in units of IOU
     *
     * @returns true if IOU
     */ isIOU() {
        return (this.bytes[0] & 0x80) !== 0;
    }
}
module.exports.Amount = $e12af8a22c261e12$var$Amount;
$e12af8a22c261e12$var$Amount.defaultAmount = new $e12af8a22c261e12$var$Amount((0, $8wxDW.hexToBytes)('4000000000000000'));

});
parcelRegister("fhZB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BinaryParser = void 0;

var $6HRNr = parcelRequire("6HRNr");

var $8wxDW = parcelRequire("8wxDW");
/**
 * BinaryParser is used to compute fields and values from a HexString
 */ class $b218393bff7091f6$var$BinaryParser {
    /**
     * Initialize bytes to a hex string
     *
     * @param hexBytes a hex string
     * @param definitions Rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     */ constructor(hexBytes, definitions = $6HRNr.DEFAULT_DEFINITIONS){
        this.bytes = (0, $8wxDW.hexToBytes)(hexBytes);
        this.definitions = definitions;
    }
    /**
     * Peek the first byte of the BinaryParser
     *
     * @returns The first byte of the BinaryParser
     */ peek() {
        if (this.bytes.byteLength === 0) throw new Error();
        return this.bytes[0];
    }
    /**
     * Consume the first n bytes of the BinaryParser
     *
     * @param n the number of bytes to skip
     */ skip(n) {
        if (n > this.bytes.byteLength) throw new Error();
        this.bytes = this.bytes.slice(n);
    }
    /**
     * read the first n bytes from the BinaryParser
     *
     * @param n The number of bytes to read
     * @return The bytes
     */ read(n) {
        if (n > this.bytes.byteLength) throw new Error();
        const slice = this.bytes.slice(0, n);
        this.skip(n);
        return slice;
    }
    /**
     * Read an integer of given size
     *
     * @param n The number of bytes to read
     * @return The number represented by those bytes
     */ readUIntN(n) {
        if (0 >= n || n > 4) throw new Error('invalid n');
        return this.read(n).reduce((a, b)=>a << 8 | b) >>> 0;
    }
    readUInt8() {
        return this.readUIntN(1);
    }
    readUInt16() {
        return this.readUIntN(2);
    }
    readUInt32() {
        return this.readUIntN(4);
    }
    size() {
        return this.bytes.byteLength;
    }
    end(customEnd) {
        const length = this.bytes.byteLength;
        return length === 0 || customEnd !== undefined && length <= customEnd;
    }
    /**
     * Reads variable length encoded bytes
     *
     * @return The variable length bytes
     */ readVariableLength() {
        return this.read(this.readVariableLengthLength());
    }
    /**
     * Reads the length of the variable length encoded bytes
     *
     * @return The length of the variable length encoded bytes
     */ readVariableLengthLength() {
        const b1 = this.readUInt8();
        if (b1 <= 192) return b1;
        else if (b1 <= 240) {
            const b2 = this.readUInt8();
            return 193 + (b1 - 193) * 256 + b2;
        } else if (b1 <= 254) {
            const b2 = this.readUInt8();
            const b3 = this.readUInt8();
            return 12481 + (b1 - 241) * 65536 + b2 * 256 + b3;
        }
        throw new Error('Invalid variable length indicator');
    }
    /**
     * Reads the field ordinal from the BinaryParser
     *
     * @return Field ordinal
     */ readFieldOrdinal() {
        let type = this.readUInt8();
        let nth = type & 15;
        type >>= 4;
        if (type === 0) {
            type = this.readUInt8();
            if (type === 0 || type < 16) throw new Error(`Cannot read FieldOrdinal, type_code ${type} out of range`);
        }
        if (nth === 0) {
            nth = this.readUInt8();
            if (nth === 0 || nth < 16) throw new Error(`Cannot read FieldOrdinal, field_code ${nth} out of range`);
        }
        return type << 16 | nth;
    }
    /**
     * Read the field from the BinaryParser
     *
     * @return The field represented by the bytes at the head of the BinaryParser
     */ readField() {
        return this.definitions.field.fromString(this.readFieldOrdinal().toString());
    }
    /**
     * Read a given type from the BinaryParser
     *
     * @param type The type that you want to read from the BinaryParser
     * @return The instance of that type read from the BinaryParser
     */ readType(type) {
        return type.fromParser(this);
    }
    /**
     * Get the type associated with a given field
     *
     * @param field The field that you wan to get the type of
     * @return The type associated with the given field
     */ typeForField(field) {
        return field.associatedType;
    }
    /**
     * Read value of the type specified by field from the BinaryParser
     *
     * @param field The field that you want to get the associated value for
     * @return The value associated with the given field
     */ readFieldValue(field) {
        const type = this.typeForField(field);
        if (!type) throw new Error(`unsupported: (${field.name}, ${field.type.name})`);
        const sizeHint = field.isVariableLengthEncoded ? this.readVariableLengthLength() : undefined;
        const value = type.fromParser(this, sizeHint);
        if (value === undefined) throw new Error(`fromParser for (${field.name}, ${field.type.name}) -> undefined `);
        return value;
    }
    /**
     * Get the next field and value from the BinaryParser
     *
     * @return The field and value
     */ readFieldAndValue() {
        const field = this.readField();
        return [
            field,
            this.readFieldValue(field)
        ];
    }
}
module.exports.BinaryParser = $b218393bff7091f6$var$BinaryParser;

});

parcelRegister("jJkaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Currency = void 0;

var $czElY = parcelRequire("czElY");

var $8wxDW = parcelRequire("8wxDW");
const $e5d1de627d2b7ca7$var$XRP_HEX_REGEX = /^0{40}$/;
const $e5d1de627d2b7ca7$var$ISO_REGEX = /^[A-Z0-9a-z?!@#$%^&*(){}[\]|]{3}$/;
const $e5d1de627d2b7ca7$var$HEX_REGEX = /^[A-F0-9]{40}$/;
// eslint-disable-next-line no-control-regex
const $e5d1de627d2b7ca7$var$STANDARD_FORMAT_HEX_REGEX = /^0{24}[\x00-\x7F]{6}0{10}$/;
/**
 * Convert an ISO code to a currency bytes representation
 */ function $e5d1de627d2b7ca7$var$isoToBytes(iso) {
    const bytes = new Uint8Array(20);
    if (iso !== 'XRP') {
        const isoBytes = iso.split('').map((c)=>c.charCodeAt(0));
        bytes.set(isoBytes, 12);
    }
    return bytes;
}
/**
 * Tests if ISO is a valid iso code
 */ function $e5d1de627d2b7ca7$var$isIsoCode(iso) {
    return $e5d1de627d2b7ca7$var$ISO_REGEX.test(iso);
}
function $e5d1de627d2b7ca7$var$isoCodeFromHex(code) {
    const iso = (0, $8wxDW.hexToString)((0, $8wxDW.bytesToHex)(code));
    if (iso === 'XRP') return null;
    if ($e5d1de627d2b7ca7$var$isIsoCode(iso)) return iso;
    return null;
}
/**
 * Tests if hex is a valid hex-string
 */ function $e5d1de627d2b7ca7$var$isHex(hex) {
    return $e5d1de627d2b7ca7$var$HEX_REGEX.test(hex);
}
/**
 * Tests if a string is a valid representation of a currency
 */ function $e5d1de627d2b7ca7$var$isStringRepresentation(input) {
    return input.length === 3 || $e5d1de627d2b7ca7$var$isHex(input);
}
/**
 * Tests if a Uint8Array is a valid representation of a currency
 */ function $e5d1de627d2b7ca7$var$isBytesArray(bytes) {
    return bytes.byteLength === 20;
}
/**
 * Ensures that a value is a valid representation of a currency
 */ function $e5d1de627d2b7ca7$var$isValidRepresentation(input) {
    return input instanceof Uint8Array ? $e5d1de627d2b7ca7$var$isBytesArray(input) : $e5d1de627d2b7ca7$var$isStringRepresentation(input);
}
/**
 * Generate bytes from a string or UInt8Array representation of a currency
 */ function $e5d1de627d2b7ca7$var$bytesFromRepresentation(input) {
    if (!$e5d1de627d2b7ca7$var$isValidRepresentation(input)) throw new Error(`Unsupported Currency representation: ${input}`);
    return input.length === 3 ? $e5d1de627d2b7ca7$var$isoToBytes(input) : (0, $8wxDW.hexToBytes)(input);
}
/**
 * Class defining how to encode and decode Currencies
 */ class $e5d1de627d2b7ca7$var$Currency extends $czElY.Hash160 {
    constructor(byteBuf){
        super(byteBuf !== null && byteBuf !== void 0 ? byteBuf : $e5d1de627d2b7ca7$var$Currency.XRP.bytes);
        const hex = (0, $8wxDW.bytesToHex)(this.bytes);
        if ($e5d1de627d2b7ca7$var$XRP_HEX_REGEX.test(hex)) this._iso = 'XRP';
        else if ($e5d1de627d2b7ca7$var$STANDARD_FORMAT_HEX_REGEX.test(hex)) this._iso = $e5d1de627d2b7ca7$var$isoCodeFromHex(this.bytes.slice(12, 15));
        else this._iso = null;
    }
    /**
     * Return the ISO code of this currency
     *
     * @returns ISO code if it exists, else null
     */ iso() {
        return this._iso;
    }
    /**
     * Constructs a Currency object
     *
     * @param val Currency object or a string representation of a currency
     */ static from(value) {
        if (value instanceof $e5d1de627d2b7ca7$var$Currency) return value;
        if (typeof value === 'string') return new $e5d1de627d2b7ca7$var$Currency($e5d1de627d2b7ca7$var$bytesFromRepresentation(value));
        throw new Error('Cannot construct Currency from value given');
    }
    /**
     * Gets the JSON representation of a currency
     *
     * @returns JSON representation
     */ toJSON() {
        const iso = this.iso();
        if (iso !== null) return iso;
        return (0, $8wxDW.bytesToHex)(this.bytes);
    }
}
module.exports.Currency = $e5d1de627d2b7ca7$var$Currency;
$e5d1de627d2b7ca7$var$Currency.XRP = new $e5d1de627d2b7ca7$var$Currency(new Uint8Array(20));

});

parcelRegister("hqAsy", function(module, exports) {
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if (typeof v == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("hSQ7N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash192 = void 0;

var $jUSxK = parcelRequire("jUSxK");
/**
 * Hash with a width of 192 bits
 */ class $d04fe9ba1cdb1337$var$Hash192 extends $jUSxK.Hash {
    constructor(bytes){
        if (bytes && bytes.byteLength === 0) bytes = $d04fe9ba1cdb1337$var$Hash192.ZERO_192.bytes;
        super(bytes !== null && bytes !== void 0 ? bytes : $d04fe9ba1cdb1337$var$Hash192.ZERO_192.bytes);
    }
}
module.exports.Hash192 = $d04fe9ba1cdb1337$var$Hash192;
$d04fe9ba1cdb1337$var$Hash192.width = 24;
$d04fe9ba1cdb1337$var$Hash192.ZERO_192 = new $d04fe9ba1cdb1337$var$Hash192(new Uint8Array($d04fe9ba1cdb1337$var$Hash192.width));

});


parcelRegister("3D20P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Blob = void 0;

var $3PMBH = parcelRequire("3PMBH");

var $8wxDW = parcelRequire("8wxDW");
/**
 * Variable length encoded type
 */ class $2a4693391afe3383$var$Blob extends $3PMBH.SerializedType {
    constructor(bytes){
        super(bytes);
    }
    /**
     * Defines how to read a Blob from a BinaryParser
     *
     * @param parser The binary parser to read the Blob from
     * @param hint The length of the blob, computed by readVariableLengthLength() and passed in
     * @returns A Blob object
     */ static fromParser(parser, hint) {
        return new $2a4693391afe3383$var$Blob(parser.read(hint));
    }
    /**
     * Create a Blob object from a hex-string
     *
     * @param value existing Blob object or a hex-string
     * @returns A Blob object
     */ static from(value) {
        if (value instanceof $2a4693391afe3383$var$Blob) return value;
        if (typeof value === 'string') {
            if (!/^[A-F0-9]*$/iu.test(value)) throw new Error('Cannot construct Blob from a non-hex string');
            return new $2a4693391afe3383$var$Blob((0, $8wxDW.hexToBytes)(value));
        }
        throw new Error('Cannot construct Blob from value given');
    }
}
module.exports.Blob = $2a4693391afe3383$var$Blob;

});

parcelRegister("hWCSJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash128 = void 0;

var $jUSxK = parcelRequire("jUSxK");

var $8wxDW = parcelRequire("8wxDW");
/**
 * Hash with a width of 128 bits
 */ class $d1060391e35585a8$var$Hash128 extends $jUSxK.Hash {
    constructor(bytes){
        if (bytes && bytes.byteLength === 0) bytes = $d1060391e35585a8$var$Hash128.ZERO_128.bytes;
        super(bytes !== null && bytes !== void 0 ? bytes : $d1060391e35585a8$var$Hash128.ZERO_128.bytes);
    }
    /**
     * Get the hex representation of a hash-128 bytes, allowing unset
     *
     * @returns hex String of this.bytes
     */ toHex() {
        const hex = (0, $8wxDW.bytesToHex)(this.toBytes());
        if (/^0+$/.exec(hex)) return '';
        return hex;
    }
}
module.exports.Hash128 = $d1060391e35585a8$var$Hash128;
$d1060391e35585a8$var$Hash128.width = 16;
$d1060391e35585a8$var$Hash128.ZERO_128 = new $d1060391e35585a8$var$Hash128(new Uint8Array($d1060391e35585a8$var$Hash128.width));

});

parcelRegister("46bAN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash256 = void 0;

var $jUSxK = parcelRequire("jUSxK");
/**
 * Hash with a width of 256 bits
 */ class $2fc0b6fae0fdfd26$var$Hash256 extends $jUSxK.Hash {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $2fc0b6fae0fdfd26$var$Hash256.ZERO_256.bytes);
    }
}
module.exports.Hash256 = $2fc0b6fae0fdfd26$var$Hash256;
$2fc0b6fae0fdfd26$var$Hash256.width = 32;
$2fc0b6fae0fdfd26$var$Hash256.ZERO_256 = new $2fc0b6fae0fdfd26$var$Hash256(new Uint8Array($2fc0b6fae0fdfd26$var$Hash256.width));

});

parcelRegister("knjDJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Issue = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $fhZB1 = parcelRequire("fhZB1");

var $jbDn1 = parcelRequire("jbDn1");

var $jJkaQ = parcelRequire("jJkaQ");

var $3PMBH = parcelRequire("3PMBH");
/**
 * Type guard for AmountObject
 */ function $ed5530aab61ea5f6$var$isIssueObject(arg) {
    const keys = Object.keys(arg).sort();
    if (keys.length === 1) return keys[0] === 'currency';
    return keys.length === 2 && keys[0] === 'currency' && keys[1] === 'issuer';
}
/**
 * Class for serializing/Deserializing Amounts
 */ class $ed5530aab61ea5f6$var$Issue extends $3PMBH.SerializedType {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $ed5530aab61ea5f6$var$Issue.ZERO_ISSUED_CURRENCY.bytes);
    }
    /**
     * Construct an amount from an IOU or string amount
     *
     * @param value An Amount, object representing an IOU, or a string
     *     representing an integer amount
     * @returns An Amount object
     */ static from(value) {
        if (value instanceof $ed5530aab61ea5f6$var$Issue) return value;
        if ($ed5530aab61ea5f6$var$isIssueObject(value)) {
            const currency = $jJkaQ.Currency.from(value.currency).toBytes();
            if (value.issuer == null) return new $ed5530aab61ea5f6$var$Issue(currency);
            const issuer = $jbDn1.AccountID.from(value.issuer).toBytes();
            return new $ed5530aab61ea5f6$var$Issue((0, $8wxDW.concat)([
                currency,
                issuer
            ]));
        }
        throw new Error('Invalid type to construct an Amount');
    }
    /**
     * Read an amount from a BinaryParser
     *
     * @param parser BinaryParser to read the Amount from
     * @returns An Amount object
     */ static fromParser(parser) {
        const currency = parser.read(20);
        if (new $jJkaQ.Currency(currency).toJSON() === 'XRP') return new $ed5530aab61ea5f6$var$Issue(currency);
        const currencyAndIssuer = [
            currency,
            parser.read(20)
        ];
        return new $ed5530aab61ea5f6$var$Issue((0, $8wxDW.concat)(currencyAndIssuer));
    }
    /**
     * Get the JSON representation of this Amount
     *
     * @returns the JSON interpretation of this.bytes
     */ toJSON() {
        const parser = new $fhZB1.BinaryParser(this.toString());
        const currency = $jJkaQ.Currency.fromParser(parser);
        if (currency.toJSON() === 'XRP') return {
            currency: currency.toJSON()
        };
        const issuer = $jbDn1.AccountID.fromParser(parser);
        return {
            currency: currency.toJSON(),
            issuer: issuer.toJSON()
        };
    }
}
module.exports.Issue = $ed5530aab61ea5f6$var$Issue;
$ed5530aab61ea5f6$var$Issue.ZERO_ISSUED_CURRENCY = new $ed5530aab61ea5f6$var$Issue(new Uint8Array(20));

});

parcelRegister("cFPQs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PathSet = void 0;

var $jbDn1 = parcelRequire("jbDn1");

var $jJkaQ = parcelRequire("jJkaQ");

var $fhZB1 = parcelRequire("fhZB1");

var $3PMBH = parcelRequire("3PMBH");

var $8wxDW = parcelRequire("8wxDW");
/**
 * Constants for separating Paths in a PathSet
 */ const $93a187b5047823a5$var$PATHSET_END_BYTE = 0x00;
const $93a187b5047823a5$var$PATH_SEPARATOR_BYTE = 0xff;
/**
 * Constant for masking types of a Hop
 */ const $93a187b5047823a5$var$TYPE_ACCOUNT = 0x01;
const $93a187b5047823a5$var$TYPE_CURRENCY = 0x10;
const $93a187b5047823a5$var$TYPE_ISSUER = 0x20;
/**
 * TypeGuard for HopObject
 */ function $93a187b5047823a5$var$isHopObject(arg) {
    return arg.issuer !== undefined || arg.account !== undefined || arg.currency !== undefined;
}
/**
 * TypeGuard for PathSet
 */ function $93a187b5047823a5$var$isPathSet(arg) {
    return Array.isArray(arg) && arg.length === 0 || Array.isArray(arg) && Array.isArray(arg[0]) && arg[0].length === 0 || Array.isArray(arg) && Array.isArray(arg[0]) && $93a187b5047823a5$var$isHopObject(arg[0][0]);
}
/**
 * Serialize and Deserialize a Hop
 */ class $93a187b5047823a5$var$Hop extends $3PMBH.SerializedType {
    /**
     * Create a Hop from a HopObject
     *
     * @param value Either a hop or HopObject to create a hop with
     * @returns a Hop
     */ static from(value) {
        if (value instanceof $93a187b5047823a5$var$Hop) return value;
        const bytes = [
            Uint8Array.from([
                0
            ])
        ];
        if (value.account) {
            bytes.push($jbDn1.AccountID.from(value.account).toBytes());
            bytes[0][0] |= $93a187b5047823a5$var$TYPE_ACCOUNT;
        }
        if (value.currency) {
            bytes.push($jJkaQ.Currency.from(value.currency).toBytes());
            bytes[0][0] |= $93a187b5047823a5$var$TYPE_CURRENCY;
        }
        if (value.issuer) {
            bytes.push($jbDn1.AccountID.from(value.issuer).toBytes());
            bytes[0][0] |= $93a187b5047823a5$var$TYPE_ISSUER;
        }
        return new $93a187b5047823a5$var$Hop((0, $8wxDW.concat)(bytes));
    }
    /**
     * Construct a Hop from a BinaryParser
     *
     * @param parser BinaryParser to read the Hop from
     * @returns a Hop
     */ static fromParser(parser) {
        const type = parser.readUInt8();
        const bytes = [
            Uint8Array.from([
                type
            ])
        ];
        if (type & $93a187b5047823a5$var$TYPE_ACCOUNT) bytes.push(parser.read($jbDn1.AccountID.width));
        if (type & $93a187b5047823a5$var$TYPE_CURRENCY) bytes.push(parser.read($jJkaQ.Currency.width));
        if (type & $93a187b5047823a5$var$TYPE_ISSUER) bytes.push(parser.read($jbDn1.AccountID.width));
        return new $93a187b5047823a5$var$Hop((0, $8wxDW.concat)(bytes));
    }
    /**
     * Get the JSON interpretation of this hop
     *
     * @returns a HopObject, an JS object with optional account, issuer, and currency
     */ toJSON() {
        const hopParser = new $fhZB1.BinaryParser((0, $8wxDW.bytesToHex)(this.bytes));
        const type = hopParser.readUInt8();
        let account, currency, issuer;
        if (type & $93a187b5047823a5$var$TYPE_ACCOUNT) account = $jbDn1.AccountID.fromParser(hopParser).toJSON();
        if (type & $93a187b5047823a5$var$TYPE_CURRENCY) currency = $jJkaQ.Currency.fromParser(hopParser).toJSON();
        if (type & $93a187b5047823a5$var$TYPE_ISSUER) issuer = $jbDn1.AccountID.fromParser(hopParser).toJSON();
        const result = {};
        if (account) result.account = account;
        if (issuer) result.issuer = issuer;
        if (currency) result.currency = currency;
        return result;
    }
    /**
     * get a number representing the type of this hop
     *
     * @returns a number to be bitwise and-ed with TYPE_ constants to describe the types in the hop
     */ type() {
        return this.bytes[0];
    }
}
/**
 * Class for serializing/deserializing Paths
 */ class $93a187b5047823a5$var$Path extends $3PMBH.SerializedType {
    /**
     * construct a Path from an array of Hops
     *
     * @param value Path or array of HopObjects to construct a Path
     * @returns the Path
     */ static from(value) {
        if (value instanceof $93a187b5047823a5$var$Path) return value;
        const bytes = [];
        value.forEach((hop)=>{
            bytes.push($93a187b5047823a5$var$Hop.from(hop).toBytes());
        });
        return new $93a187b5047823a5$var$Path((0, $8wxDW.concat)(bytes));
    }
    /**
     * Read a Path from a BinaryParser
     *
     * @param parser BinaryParser to read Path from
     * @returns the Path represented by the bytes read from the BinaryParser
     */ static fromParser(parser) {
        const bytes = [];
        while(!parser.end()){
            bytes.push($93a187b5047823a5$var$Hop.fromParser(parser).toBytes());
            if (parser.peek() === $93a187b5047823a5$var$PATHSET_END_BYTE || parser.peek() === $93a187b5047823a5$var$PATH_SEPARATOR_BYTE) break;
        }
        return new $93a187b5047823a5$var$Path((0, $8wxDW.concat)(bytes));
    }
    /**
     * Get the JSON representation of this Path
     *
     * @returns an Array of HopObject constructed from this.bytes
     */ toJSON() {
        const json = [];
        const pathParser = new $fhZB1.BinaryParser(this.toString());
        while(!pathParser.end())json.push($93a187b5047823a5$var$Hop.fromParser(pathParser).toJSON());
        return json;
    }
}
/**
 * Deserialize and Serialize the PathSet type
 */ class $93a187b5047823a5$var$PathSet extends $3PMBH.SerializedType {
    /**
     * Construct a PathSet from an Array of Arrays representing paths
     *
     * @param value A PathSet or Array of Array of HopObjects
     * @returns the PathSet constructed from value
     */ static from(value) {
        if (value instanceof $93a187b5047823a5$var$PathSet) return value;
        if ($93a187b5047823a5$var$isPathSet(value)) {
            const bytes = [];
            value.forEach((path)=>{
                bytes.push($93a187b5047823a5$var$Path.from(path).toBytes());
                bytes.push(Uint8Array.from([
                    $93a187b5047823a5$var$PATH_SEPARATOR_BYTE
                ]));
            });
            bytes[bytes.length - 1] = Uint8Array.from([
                $93a187b5047823a5$var$PATHSET_END_BYTE
            ]);
            return new $93a187b5047823a5$var$PathSet((0, $8wxDW.concat)(bytes));
        }
        throw new Error('Cannot construct PathSet from given value');
    }
    /**
     * Construct a PathSet from a BinaryParser
     *
     * @param parser A BinaryParser to read PathSet from
     * @returns the PathSet read from parser
     */ static fromParser(parser) {
        const bytes = [];
        while(!parser.end()){
            bytes.push($93a187b5047823a5$var$Path.fromParser(parser).toBytes());
            bytes.push(parser.read(1));
            if (bytes[bytes.length - 1][0] == $93a187b5047823a5$var$PATHSET_END_BYTE) break;
        }
        return new $93a187b5047823a5$var$PathSet((0, $8wxDW.concat)(bytes));
    }
    /**
     * Get the JSON representation of this PathSet
     *
     * @returns an Array of Array of HopObjects, representing this PathSet
     */ toJSON() {
        const json = [];
        const pathParser = new $fhZB1.BinaryParser(this.toString());
        while(!pathParser.end()){
            json.push($93a187b5047823a5$var$Path.fromParser(pathParser).toJSON());
            pathParser.skip(1);
        }
        return json;
    }
}
module.exports.PathSet = $93a187b5047823a5$var$PathSet;

});

parcelRegister("4fDlD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.STArray = void 0;

var $6HRNr = parcelRequire("6HRNr");

var $3PMBH = parcelRequire("3PMBH");

var $8hs6X = parcelRequire("8hs6X");

var $fhZB1 = parcelRequire("fhZB1");

var $8wxDW = parcelRequire("8wxDW");
const $318715d410326998$var$ARRAY_END_MARKER = Uint8Array.from([
    0xf1
]);
const $318715d410326998$var$ARRAY_END_MARKER_NAME = 'ArrayEndMarker';
const $318715d410326998$var$OBJECT_END_MARKER = Uint8Array.from([
    0xe1
]);
/**
 * TypeGuard for Array<JsonObject>
 */ function $318715d410326998$var$isObjects(args) {
    return Array.isArray(args) && args.every((arg)=>typeof arg === 'object' && Object.keys(arg).length === 1 && typeof Object.values(arg)[0] === 'object');
}
/**
 * Class for serializing and deserializing Arrays of Objects
 */ class $318715d410326998$var$STArray extends $3PMBH.SerializedType {
    /**
     * Construct an STArray from a BinaryParser
     *
     * @param parser BinaryParser to parse an STArray from
     * @returns An STArray Object
     */ static fromParser(parser) {
        const bytes = [];
        while(!parser.end()){
            const field = parser.readField();
            if (field.name === $318715d410326998$var$ARRAY_END_MARKER_NAME) break;
            bytes.push(field.header, parser.readFieldValue(field).toBytes(), $318715d410326998$var$OBJECT_END_MARKER);
        }
        bytes.push($318715d410326998$var$ARRAY_END_MARKER);
        return new $318715d410326998$var$STArray((0, $8wxDW.concat)(bytes));
    }
    /**
     * Construct an STArray from an Array of JSON Objects
     *
     * @param value STArray or Array of Objects to parse into an STArray
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An STArray object
     */ static from(value, definitions = $6HRNr.DEFAULT_DEFINITIONS) {
        if (value instanceof $318715d410326998$var$STArray) return value;
        if ($318715d410326998$var$isObjects(value)) {
            const bytes = [];
            value.forEach((obj)=>{
                bytes.push($8hs6X.STObject.from(obj, undefined, definitions).toBytes());
            });
            bytes.push($318715d410326998$var$ARRAY_END_MARKER);
            return new $318715d410326998$var$STArray((0, $8wxDW.concat)(bytes));
        }
        throw new Error('Cannot construct STArray from value given');
    }
    /**
     * Return the JSON representation of this.bytes
     *
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An Array of JSON objects
     */ toJSON(definitions = $6HRNr.DEFAULT_DEFINITIONS) {
        const result = [];
        const arrayParser = new $fhZB1.BinaryParser(this.toString(), definitions);
        while(!arrayParser.end()){
            const field = arrayParser.readField();
            if (field.name === $318715d410326998$var$ARRAY_END_MARKER_NAME) break;
            const outer = {};
            outer[field.name] = $8hs6X.STObject.fromParser(arrayParser).toJSON(definitions);
            result.push(outer);
        }
        return result;
    }
}
module.exports.STArray = $318715d410326998$var$STArray;

});
parcelRegister("8hs6X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.STObject = void 0;

var $6HRNr = parcelRequire("6HRNr");

var $3PMBH = parcelRequire("3PMBH");

var $2qQFA = parcelRequire("2qQFA");

var $fhZB1 = parcelRequire("fhZB1");

var $97POw = parcelRequire("97POw");

var $4fDlD = parcelRequire("4fDlD");

var $7dDUy = parcelRequire("7dDUy");
const $6075b792ec2569b8$var$OBJECT_END_MARKER_BYTE = Uint8Array.from([
    0xe1
]);
const $6075b792ec2569b8$var$OBJECT_END_MARKER = 'ObjectEndMarker';
const $6075b792ec2569b8$var$ST_OBJECT = 'STObject';
const $6075b792ec2569b8$var$DESTINATION = 'Destination';
const $6075b792ec2569b8$var$ACCOUNT = 'Account';
const $6075b792ec2569b8$var$SOURCE_TAG = 'SourceTag';
const $6075b792ec2569b8$var$DEST_TAG = 'DestinationTag';
/**
 * Break down an X-Address into an account and a tag
 *
 * @param field Name of field
 * @param xAddress X-Address corresponding to the field
 */ function $6075b792ec2569b8$var$handleXAddress(field, xAddress) {
    const decoded = (0, $2qQFA.xAddressToClassicAddress)(xAddress);
    let tagName;
    if (field === $6075b792ec2569b8$var$DESTINATION) tagName = $6075b792ec2569b8$var$DEST_TAG;
    else if (field === $6075b792ec2569b8$var$ACCOUNT) tagName = $6075b792ec2569b8$var$SOURCE_TAG;
    else if (decoded.tag !== false) throw new Error(`${field} cannot have an associated tag`);
    return decoded.tag !== false ? {
        [field]: decoded.classicAddress,
        [tagName]: decoded.tag
    } : {
        [field]: decoded.classicAddress
    };
}
/**
 * Validate that two objects don't both have the same tag fields
 *
 * @param obj1 First object to check for tags
 * @param obj2 Second object to check for tags
 * @throws When both objects have SourceTag or DestinationTag
 */ function $6075b792ec2569b8$var$checkForDuplicateTags(obj1, obj2) {
    if (!(obj1[$6075b792ec2569b8$var$SOURCE_TAG] === undefined || obj2[$6075b792ec2569b8$var$SOURCE_TAG] === undefined)) throw new Error('Cannot have Account X-Address and SourceTag');
    if (!(obj1[$6075b792ec2569b8$var$DEST_TAG] === undefined || obj2[$6075b792ec2569b8$var$DEST_TAG] === undefined)) throw new Error('Cannot have Destination X-Address and DestinationTag');
}
/**
 * Class for Serializing/Deserializing objects
 */ class $6075b792ec2569b8$var$STObject extends $3PMBH.SerializedType {
    /**
     * Construct a STObject from a BinaryParser
     *
     * @param parser BinaryParser to read STObject from
     * @returns A STObject object
     */ static fromParser(parser) {
        const list = new $97POw.BytesList();
        const bytes = new $97POw.BinarySerializer(list);
        while(!parser.end()){
            const field = parser.readField();
            if (field.name === $6075b792ec2569b8$var$OBJECT_END_MARKER) break;
            const associatedValue = parser.readFieldValue(field);
            bytes.writeFieldAndValue(field, associatedValue);
            if (field.type.name === $6075b792ec2569b8$var$ST_OBJECT) bytes.put($6075b792ec2569b8$var$OBJECT_END_MARKER_BYTE);
        }
        return new $6075b792ec2569b8$var$STObject(list.toBytes());
    }
    /**
     * Construct a STObject from a JSON object
     *
     * @param value An object to include
     * @param filter optional, denote which field to include in serialized object
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns a STObject object
     */ static from(value, filter, definitions = $6HRNr.DEFAULT_DEFINITIONS) {
        if (value instanceof $6075b792ec2569b8$var$STObject) return value;
        const list = new $97POw.BytesList();
        const bytes = new $97POw.BinarySerializer(list);
        let isUnlModify = false;
        const xAddressDecoded = Object.entries(value).reduce((acc, [key, val])=>{
            let handled = undefined;
            if (val && (0, $2qQFA.isValidXAddress)(val.toString())) {
                handled = $6075b792ec2569b8$var$handleXAddress(key, val.toString());
                $6075b792ec2569b8$var$checkForDuplicateTags(handled, value);
            }
            return Object.assign(acc, handled !== null && handled !== void 0 ? handled : {
                [key]: val
            });
        }, {});
        let sorted = Object.keys(xAddressDecoded).map((f)=>definitions.field[f]).filter((f)=>f !== undefined && xAddressDecoded[f.name] !== undefined && f.isSerialized).sort((a, b)=>{
            return a.ordinal - b.ordinal;
        });
        if (filter !== undefined) sorted = sorted.filter(filter);
        sorted.forEach((field)=>{
            const associatedValue = field.type.name === $6075b792ec2569b8$var$ST_OBJECT ? this.from(xAddressDecoded[field.name], undefined, definitions) : field.type.name === 'STArray' ? $4fDlD.STArray.from(xAddressDecoded[field.name], definitions) : field.type.name === 'UInt64' ? $7dDUy.UInt64.from(xAddressDecoded[field.name], field.name) : field.associatedType.from(xAddressDecoded[field.name]);
            if (associatedValue == undefined) throw new TypeError(`Unable to interpret "${field.name}: ${xAddressDecoded[field.name]}".`);
            if (associatedValue.name === 'UNLModify') // triggered when the TransactionType field has a value of 'UNLModify'
            isUnlModify = true;
            // true when in the UNLModify pseudotransaction (after the transaction type has been processed) and working with the
            // Account field
            // The Account field must not be a part of the UNLModify pseudotransaction encoding, due to a bug in rippled
            const isUnlModifyWorkaround = field.name == 'Account' && isUnlModify;
            bytes.writeFieldAndValue(field, associatedValue, isUnlModifyWorkaround);
            if (field.type.name === $6075b792ec2569b8$var$ST_OBJECT) bytes.put($6075b792ec2569b8$var$OBJECT_END_MARKER_BYTE);
        });
        return new $6075b792ec2569b8$var$STObject(list.toBytes());
    }
    /**
     * Get the JSON interpretation of this.bytes
     * @param definitions rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     * @returns a JSON object
     */ toJSON(definitions) {
        const objectParser = new $fhZB1.BinaryParser(this.toString(), definitions);
        const accumulator = {};
        while(!objectParser.end()){
            const field = objectParser.readField();
            if (field.name === $6075b792ec2569b8$var$OBJECT_END_MARKER) break;
            accumulator[field.name] = objectParser.readFieldValue(field).toJSON(definitions, field.name);
        }
        return accumulator;
    }
}
module.exports.STObject = $6075b792ec2569b8$var$STObject;

});
parcelRegister("7dDUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UInt64 = void 0;

var $il9wz = parcelRequire("il9wz");

var $8wxDW = parcelRequire("8wxDW");

var $hdCF9 = parcelRequire("hdCF9");

var $6HRNr = parcelRequire("6HRNr");
const $5418b4d07a366d99$var$HEX_REGEX = /^[a-fA-F0-9]{1,16}$/;
const $5418b4d07a366d99$var$BASE10_REGEX = /^[0-9]{1,20}$/;
const $5418b4d07a366d99$var$mask = BigInt(0x00000000ffffffff);
function $5418b4d07a366d99$var$useBase10(fieldName) {
    return fieldName === 'MaximumAmount' || fieldName === 'OutstandingAmount' || fieldName === 'MPTAmount';
}
/**
 * Derived UInt class for serializing/deserializing 64 bit UInt
 */ class $5418b4d07a366d99$var$UInt64 extends $il9wz.UInt {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $5418b4d07a366d99$var$UInt64.defaultUInt64.bytes);
    }
    static fromParser(parser) {
        return new $5418b4d07a366d99$var$UInt64(parser.read($5418b4d07a366d99$var$UInt64.width));
    }
    /**
     * Construct a UInt64 object
     *
     * @param val A UInt64, hex-string, bigInt, or number
     * @returns A UInt64 object
     */ static from(val, fieldName = '') {
        if (val instanceof $5418b4d07a366d99$var$UInt64) return val;
        let buf = new Uint8Array($5418b4d07a366d99$var$UInt64.width);
        if (typeof val === 'number') {
            if (val < 0) throw new Error('value must be an unsigned integer');
            const number = BigInt(val);
            const intBuf = [
                new Uint8Array(4),
                new Uint8Array(4)
            ];
            (0, $hdCF9.writeUInt32BE)(intBuf[0], Number(number >> BigInt(32)), 0);
            (0, $hdCF9.writeUInt32BE)(intBuf[1], Number(number & BigInt($5418b4d07a366d99$var$mask)), 0);
            return new $5418b4d07a366d99$var$UInt64((0, $8wxDW.concat)(intBuf));
        }
        if (typeof val === 'string') {
            if ($5418b4d07a366d99$var$useBase10(fieldName)) {
                if (!$5418b4d07a366d99$var$BASE10_REGEX.test(val)) throw new Error(`${fieldName} ${val} is not a valid base 10 string`);
                val = BigInt(val).toString(16);
            }
            if (typeof val === 'string' && !$5418b4d07a366d99$var$HEX_REGEX.test(val)) throw new Error(`${val} is not a valid hex-string`);
            const strBuf = val.padStart(16, '0');
            buf = (0, $8wxDW.hexToBytes)(strBuf);
            return new $5418b4d07a366d99$var$UInt64(buf);
        }
        if (typeof val === 'bigint') {
            const intBuf = [
                new Uint8Array(4),
                new Uint8Array(4)
            ];
            (0, $hdCF9.writeUInt32BE)(intBuf[0], Number(Number(val >> BigInt(32))), 0);
            (0, $hdCF9.writeUInt32BE)(intBuf[1], Number(val & BigInt($5418b4d07a366d99$var$mask)), 0);
            return new $5418b4d07a366d99$var$UInt64((0, $8wxDW.concat)(intBuf));
        }
        throw new Error('Cannot construct UInt64 from given value');
    }
    /**
     * The JSON representation of a UInt64 object
     *
     * @returns a hex-string
     */ toJSON(_definitions = $6HRNr.DEFAULT_DEFINITIONS, fieldName = '') {
        const hexString = (0, $8wxDW.bytesToHex)(this.bytes);
        if ($5418b4d07a366d99$var$useBase10(fieldName)) return BigInt('0x' + hexString).toString(10);
        return hexString;
    }
    /**
     * Get the value of the UInt64
     *
     * @returns the number represented buy this.bytes
     */ valueOf() {
        const msb = BigInt((0, $hdCF9.readUInt32BE)(this.bytes.slice(0, 4), 0));
        const lsb = BigInt((0, $hdCF9.readUInt32BE)(this.bytes.slice(4), 0));
        return msb << BigInt(32) | lsb;
    }
    /**
     * Get the bytes representation of the UInt64 object
     *
     * @returns 8 bytes representing the UInt64
     */ toBytes() {
        return this.bytes;
    }
}
module.exports.UInt64 = $5418b4d07a366d99$var$UInt64;
$5418b4d07a366d99$var$UInt64.width = 8; // 8
$5418b4d07a366d99$var$UInt64.defaultUInt64 = new $5418b4d07a366d99$var$UInt64(new Uint8Array($5418b4d07a366d99$var$UInt64.width));

});
parcelRegister("il9wz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UInt = void 0;

var $3PMBH = parcelRequire("3PMBH");
/**
 * Compare numbers and bigInts n1 and n2
 *
 * @param n1 First object to compare
 * @param n2 Second object to compare
 * @returns -1, 0, or 1, depending on how the two objects compare
 */ function $d5a1937c007fd940$var$compare(n1, n2) {
    return n1 < n2 ? -1 : n1 == n2 ? 0 : 1;
}
/**
 * Base class for serializing and deserializing unsigned integers.
 */ class $d5a1937c007fd940$var$UInt extends $3PMBH.Comparable {
    constructor(bytes){
        super(bytes);
    }
    /**
     * Overload of compareTo for Comparable
     *
     * @param other other UInt to compare this to
     * @returns -1, 0, or 1 depending on how the objects relate to each other
     */ compareTo(other) {
        return $d5a1937c007fd940$var$compare(this.valueOf(), other.valueOf());
    }
    /**
     * Convert a UInt object to JSON
     *
     * @returns number or string represented by this.bytes
     */ toJSON() {
        const val = this.valueOf();
        return typeof val === 'number' ? val : val.toString();
    }
    static checkUintRange(val, min, max) {
        if (val < min || val > max) throw new Error(`Invalid ${this.constructor.name}: ${val} must be >= ${min} and <= ${max}`);
    }
}
module.exports.UInt = $d5a1937c007fd940$var$UInt;

});




parcelRegister("7xLrQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UInt16 = void 0;

var $il9wz = parcelRequire("il9wz");

var $hdCF9 = parcelRequire("hdCF9");
/**
 * Derived UInt class for serializing/deserializing 16 bit UInt
 */ class $57e06ba83e19b8ad$var$UInt16 extends $il9wz.UInt {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $57e06ba83e19b8ad$var$UInt16.defaultUInt16.bytes);
    }
    static fromParser(parser) {
        return new $57e06ba83e19b8ad$var$UInt16(parser.read($57e06ba83e19b8ad$var$UInt16.width));
    }
    /**
     * Construct a UInt16 object from a number
     *
     * @param val UInt16 object or number
     */ static from(val) {
        if (val instanceof $57e06ba83e19b8ad$var$UInt16) return val;
        if (typeof val === 'number') {
            $57e06ba83e19b8ad$var$UInt16.checkUintRange(val, 0, 0xffff);
            const buf = new Uint8Array($57e06ba83e19b8ad$var$UInt16.width);
            (0, $hdCF9.writeUInt16BE)(buf, val, 0);
            return new $57e06ba83e19b8ad$var$UInt16(buf);
        }
        throw new Error('Can not construct UInt16 with given value');
    }
    /**
     * get the value of a UInt16 object
     *
     * @returns the number represented by this.bytes
     */ valueOf() {
        return parseInt((0, $hdCF9.readUInt16BE)(this.bytes, 0));
    }
}
module.exports.UInt16 = $57e06ba83e19b8ad$var$UInt16;
$57e06ba83e19b8ad$var$UInt16.width = 2; // 2
$57e06ba83e19b8ad$var$UInt16.defaultUInt16 = new $57e06ba83e19b8ad$var$UInt16(new Uint8Array($57e06ba83e19b8ad$var$UInt16.width));

});

parcelRegister("9W0MR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UInt32 = void 0;

var $il9wz = parcelRequire("il9wz");

var $hdCF9 = parcelRequire("hdCF9");
/**
 * Derived UInt class for serializing/deserializing 32 bit UInt
 */ class $73ba2424abdbaf7a$var$UInt32 extends $il9wz.UInt {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $73ba2424abdbaf7a$var$UInt32.defaultUInt32.bytes);
    }
    static fromParser(parser) {
        return new $73ba2424abdbaf7a$var$UInt32(parser.read($73ba2424abdbaf7a$var$UInt32.width));
    }
    /**
     * Construct a UInt32 object from a number
     *
     * @param val UInt32 object or number
     */ static from(val) {
        if (val instanceof $73ba2424abdbaf7a$var$UInt32) return val;
        const buf = new Uint8Array($73ba2424abdbaf7a$var$UInt32.width);
        if (typeof val === 'string') {
            const num = Number.parseInt(val);
            (0, $hdCF9.writeUInt32BE)(buf, num, 0);
            return new $73ba2424abdbaf7a$var$UInt32(buf);
        }
        if (typeof val === 'number') {
            $73ba2424abdbaf7a$var$UInt32.checkUintRange(val, 0, 0xffffffff);
            (0, $hdCF9.writeUInt32BE)(buf, val, 0);
            return new $73ba2424abdbaf7a$var$UInt32(buf);
        }
        throw new Error('Cannot construct UInt32 from given value');
    }
    /**
     * get the value of a UInt32 object
     *
     * @returns the number represented by this.bytes
     */ valueOf() {
        return parseInt((0, $hdCF9.readUInt32BE)(this.bytes, 0), 10);
    }
}
module.exports.UInt32 = $73ba2424abdbaf7a$var$UInt32;
$73ba2424abdbaf7a$var$UInt32.width = 4; // 4
$73ba2424abdbaf7a$var$UInt32.defaultUInt32 = new $73ba2424abdbaf7a$var$UInt32(new Uint8Array($73ba2424abdbaf7a$var$UInt32.width));

});

parcelRegister("T7Ahl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UInt8 = void 0;

var $il9wz = parcelRequire("il9wz");

var $8wxDW = parcelRequire("8wxDW");

var $hdCF9 = parcelRequire("hdCF9");
/**
 * Derived UInt class for serializing/deserializing 8 bit UInt
 */ class $0a5b0538a3eb542b$var$UInt8 extends $il9wz.UInt {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $0a5b0538a3eb542b$var$UInt8.defaultUInt8.bytes);
    }
    static fromParser(parser) {
        return new $0a5b0538a3eb542b$var$UInt8(parser.read($0a5b0538a3eb542b$var$UInt8.width));
    }
    /**
     * Construct a UInt8 object from a number
     *
     * @param val UInt8 object or number
     */ static from(val) {
        if (val instanceof $0a5b0538a3eb542b$var$UInt8) return val;
        if (typeof val === 'number') {
            $0a5b0538a3eb542b$var$UInt8.checkUintRange(val, 0, 0xff);
            const buf = new Uint8Array($0a5b0538a3eb542b$var$UInt8.width);
            (0, $hdCF9.writeUInt8)(buf, val, 0);
            return new $0a5b0538a3eb542b$var$UInt8(buf);
        }
        throw new Error('Cannot construct UInt8 from given value');
    }
    /**
     * get the value of a UInt8 object
     *
     * @returns the number represented by this.bytes
     */ valueOf() {
        return parseInt((0, $8wxDW.bytesToHex)(this.bytes), 16);
    }
}
module.exports.UInt8 = $0a5b0538a3eb542b$var$UInt8;
$0a5b0538a3eb542b$var$UInt8.width = 1; // 1
$0a5b0538a3eb542b$var$UInt8.defaultUInt8 = new $0a5b0538a3eb542b$var$UInt8(new Uint8Array($0a5b0538a3eb542b$var$UInt8.width));

});

parcelRegister("6CJKR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vector256 = void 0;

var $3PMBH = parcelRequire("3PMBH");

var $46bAN = parcelRequire("46bAN");

var $97POw = parcelRequire("97POw");

var $8wxDW = parcelRequire("8wxDW");
/**
 * TypeGuard for Array<string>
 */ function $4d29c8a98c270c9e$var$isStrings(arg) {
    return Array.isArray(arg) && (arg.length === 0 || typeof arg[0] === 'string');
}
/**
 * Class for serializing and deserializing vectors of Hash256
 */ class $4d29c8a98c270c9e$var$Vector256 extends $3PMBH.SerializedType {
    constructor(bytes){
        super(bytes);
    }
    /**
     * Construct a Vector256 from a BinaryParser
     *
     * @param parser BinaryParser to
     * @param hint length of the vector, in bytes, optional
     * @returns a Vector256 object
     */ static fromParser(parser, hint) {
        const bytesList = new $97POw.BytesList();
        const bytes = hint !== null && hint !== void 0 ? hint : parser.size();
        const hashes = bytes / 32;
        for(let i = 0; i < hashes; i++)$46bAN.Hash256.fromParser(parser).toBytesSink(bytesList);
        return new $4d29c8a98c270c9e$var$Vector256(bytesList.toBytes());
    }
    /**
     * Construct a Vector256 object from an array of hashes
     *
     * @param value A Vector256 object or array of hex-strings representing Hash256's
     * @returns a Vector256 object
     */ static from(value) {
        if (value instanceof $4d29c8a98c270c9e$var$Vector256) return value;
        if ($4d29c8a98c270c9e$var$isStrings(value)) {
            const bytesList = new $97POw.BytesList();
            value.forEach((hash)=>{
                $46bAN.Hash256.from(hash).toBytesSink(bytesList);
            });
            return new $4d29c8a98c270c9e$var$Vector256(bytesList.toBytes());
        }
        throw new Error('Cannot construct Vector256 from given value');
    }
    /**
     * Return an Array of hex-strings represented by this.bytes
     *
     * @returns An Array of strings representing the Hash256 objects
     */ toJSON() {
        if (this.bytes.byteLength % 32 !== 0) throw new Error('Invalid bytes for Vector256');
        const result = [];
        for(let i = 0; i < this.bytes.byteLength; i += 32)result.push((0, $8wxDW.bytesToHex)(this.bytes.slice(i, i + 32)));
        return result;
    }
}
module.exports.Vector256 = $4d29c8a98c270c9e$var$Vector256;

});

parcelRegister("g09Lr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XChainBridge = void 0;

var $fhZB1 = parcelRequire("fhZB1");

var $jbDn1 = parcelRequire("jbDn1");

var $3PMBH = parcelRequire("3PMBH");

var $knjDJ = parcelRequire("knjDJ");

var $8wxDW = parcelRequire("8wxDW");
/**
 * Type guard for XChainBridgeObject
 */ function $ba643863450a1b98$var$isXChainBridgeObject(arg) {
    const keys = Object.keys(arg).sort();
    return keys.length === 4 && keys[0] === 'IssuingChainDoor' && keys[1] === 'IssuingChainIssue' && keys[2] === 'LockingChainDoor' && keys[3] === 'LockingChainIssue';
}
/**
 * Class for serializing/deserializing XChainBridges
 */ class $ba643863450a1b98$var$XChainBridge extends $3PMBH.SerializedType {
    constructor(bytes){
        super(bytes !== null && bytes !== void 0 ? bytes : $ba643863450a1b98$var$XChainBridge.ZERO_XCHAIN_BRIDGE.bytes);
    }
    /**
     * Construct a cross-chain bridge from a JSON
     *
     * @param value XChainBridge or JSON to parse into an XChainBridge
     * @returns An XChainBridge object
     */ static from(value) {
        if (value instanceof $ba643863450a1b98$var$XChainBridge) return value;
        if (!$ba643863450a1b98$var$isXChainBridgeObject(value)) throw new Error('Invalid type to construct an XChainBridge');
        const bytes = [];
        this.TYPE_ORDER.forEach((item)=>{
            const { name: name, type: type } = item;
            if (type === $jbDn1.AccountID) bytes.push(Uint8Array.from([
                0x14
            ]));
            const object = type.from(value[name]);
            bytes.push(object.toBytes());
        });
        return new $ba643863450a1b98$var$XChainBridge((0, $8wxDW.concat)(bytes));
    }
    /**
     * Read an XChainBridge from a BinaryParser
     *
     * @param parser BinaryParser to read the XChainBridge from
     * @returns An XChainBridge object
     */ static fromParser(parser) {
        const bytes = [];
        this.TYPE_ORDER.forEach((item)=>{
            const { type: type } = item;
            if (type === $jbDn1.AccountID) {
                parser.skip(1);
                bytes.push(Uint8Array.from([
                    0x14
                ]));
            }
            const object = type.fromParser(parser);
            bytes.push(object.toBytes());
        });
        return new $ba643863450a1b98$var$XChainBridge((0, $8wxDW.concat)(bytes));
    }
    /**
     * Get the JSON representation of this XChainBridge
     *
     * @returns the JSON interpretation of this.bytes
     */ toJSON() {
        const parser = new $fhZB1.BinaryParser(this.toString());
        const json = {};
        $ba643863450a1b98$var$XChainBridge.TYPE_ORDER.forEach((item)=>{
            const { name: name, type: type } = item;
            if (type === $jbDn1.AccountID) parser.skip(1);
            const object = type.fromParser(parser).toJSON();
            json[name] = object;
        });
        return json;
    }
}
module.exports.XChainBridge = $ba643863450a1b98$var$XChainBridge;
$ba643863450a1b98$var$XChainBridge.ZERO_XCHAIN_BRIDGE = new $ba643863450a1b98$var$XChainBridge((0, $8wxDW.concat)([
    Uint8Array.from([
        0x14
    ]),
    new Uint8Array(40),
    Uint8Array.from([
        0x14
    ]),
    new Uint8Array(40)
]));
$ba643863450a1b98$var$XChainBridge.TYPE_ORDER = [
    {
        name: 'LockingChainDoor',
        type: $jbDn1.AccountID
    },
    {
        name: 'LockingChainIssue',
        type: $knjDJ.Issue
    },
    {
        name: 'IssuingChainDoor',
        type: $jbDn1.AccountID
    },
    {
        name: 'IssuingChainIssue',
        type: $knjDJ.Issue
    }
];

});


parcelRegister("AXH1k", function(module, exports) {
"use strict";
/* eslint-disable func-style */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transactionID = module.exports.sha512Half = module.exports.binaryToJSON = module.exports.signingClaimData = module.exports.signingData = module.exports.multiSigningData = module.exports.readJSON = module.exports.serializeObject = module.exports.makeParser = module.exports.BytesList = module.exports.BinarySerializer = module.exports.BinaryParser = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $bff2V = parcelRequire("bff2V");

var $fhZB1 = parcelRequire("fhZB1");
Object.defineProperty(module.exports, "BinaryParser", {
    enumerable: true,
    get: function() {
        return $fhZB1.BinaryParser;
    }
});

var $1KMxh = parcelRequire("1KMxh");

var $97POw = parcelRequire("97POw");
Object.defineProperty(module.exports, "BinarySerializer", {
    enumerable: true,
    get: function() {
        return $97POw.BinarySerializer;
    }
});
Object.defineProperty(module.exports, "BytesList", {
    enumerable: true,
    get: function() {
        return $97POw.BytesList;
    }
});

var $4EzQV = parcelRequire("4EzQV");
Object.defineProperty(module.exports, "sha512Half", {
    enumerable: true,
    get: function() {
        return $4EzQV.sha512Half;
    }
});
Object.defineProperty(module.exports, "transactionID", {
    enumerable: true,
    get: function() {
        return $4EzQV.transactionID;
    }
});

var $6HRNr = parcelRequire("6HRNr");
/**
 * Construct a BinaryParser
 *
 * @param bytes hex-string or Uint8Array to construct BinaryParser from
 * @param definitions rippled definitions used to parse the values of transaction types and such.
 *                          Can be customized for sidechains and amendments.
 * @returns BinaryParser
 */ const $06f1aaab651526a4$var$makeParser = (bytes, definitions)=>new $fhZB1.BinaryParser(bytes instanceof Uint8Array ? (0, $8wxDW.bytesToHex)(bytes) : bytes, definitions);
module.exports.makeParser = $06f1aaab651526a4$var$makeParser;
/**
 * Parse BinaryParser into JSON
 *
 * @param parser BinaryParser object
 * @param definitions rippled definitions used to parse the values of transaction types and such.
 *                          Can be customized for sidechains and amendments.
 * @returns JSON for the bytes in the BinaryParser
 */ const $06f1aaab651526a4$var$readJSON = (parser, definitions = $6HRNr.DEFAULT_DEFINITIONS)=>parser.readType($bff2V.coreTypes.STObject).toJSON(definitions);
module.exports.readJSON = $06f1aaab651526a4$var$readJSON;
/**
 * Parse a hex-string into its JSON interpretation
 *
 * @param bytes hex-string to parse into JSON
 * @param definitions rippled definitions used to parse the values of transaction types and such.
 *                          Can be customized for sidechains and amendments.
 * @returns JSON
 */ const $06f1aaab651526a4$var$binaryToJSON = (bytes, definitions)=>$06f1aaab651526a4$var$readJSON($06f1aaab651526a4$var$makeParser(bytes, definitions), definitions);
module.exports.binaryToJSON = $06f1aaab651526a4$var$binaryToJSON;
/**
 * Function to serialize JSON object representing a transaction
 *
 * @param object JSON object to serialize
 * @param opts options for serializing, including optional prefix, suffix, signingFieldOnly, and definitions
 * @returns A Uint8Array containing the serialized object
 */ function $06f1aaab651526a4$var$serializeObject(object, opts = {}) {
    const { prefix: prefix, suffix: suffix, signingFieldsOnly: signingFieldsOnly = false, definitions: definitions } = opts;
    const bytesList = new $97POw.BytesList();
    if (prefix) bytesList.put(prefix);
    const filter = signingFieldsOnly ? (f)=>f.isSigningField : undefined;
    $bff2V.coreTypes.STObject.from(object, filter, definitions).toBytesSink(bytesList);
    if (suffix) bytesList.put(suffix);
    return bytesList.toBytes();
}
module.exports.serializeObject = $06f1aaab651526a4$var$serializeObject;
/**
 * Serialize an object for signing
 *
 * @param transaction Transaction to serialize
 * @param prefix Prefix bytes to put before the serialized object
 * @param opts.definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns A Uint8Array with the serialized object
 */ function $06f1aaab651526a4$var$signingData(transaction, prefix = $1KMxh.HashPrefix.transactionSig, opts = {}) {
    return $06f1aaab651526a4$var$serializeObject(transaction, {
        prefix: prefix,
        signingFieldsOnly: true,
        definitions: opts.definitions
    });
}
module.exports.signingData = $06f1aaab651526a4$var$signingData;
/**
 * Serialize a signingClaim
 *
 * @param claim A claim object to serialize
 * @param opts.definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns the serialized object with appropriate prefix
 */ function $06f1aaab651526a4$var$signingClaimData(claim) {
    const num = BigInt(String(claim.amount));
    const prefix = $1KMxh.HashPrefix.paymentChannelClaim;
    const channel = $bff2V.coreTypes.Hash256.from(claim.channel).toBytes();
    const amount = $bff2V.coreTypes.UInt64.from(num).toBytes();
    const bytesList = new $97POw.BytesList();
    bytesList.put(prefix);
    bytesList.put(channel);
    bytesList.put(amount);
    return bytesList.toBytes();
}
module.exports.signingClaimData = $06f1aaab651526a4$var$signingClaimData;
/**
 * Serialize a transaction object for multiSigning
 *
 * @param transaction transaction to serialize
 * @param signingAccount Account to sign the transaction with
 * @param opts.definitions Custom rippled types to use instead of the default. Used for sidechains and amendments.
 * @returns serialized transaction with appropriate prefix and suffix
 */ function $06f1aaab651526a4$var$multiSigningData(transaction, signingAccount, opts = {
    definitions: $6HRNr.DEFAULT_DEFINITIONS
}) {
    const prefix = $1KMxh.HashPrefix.transactionMultiSig;
    const suffix = $bff2V.coreTypes.AccountID.from(signingAccount).toBytes();
    return $06f1aaab651526a4$var$serializeObject(transaction, {
        prefix: prefix,
        suffix: suffix,
        signingFieldsOnly: true,
        definitions: opts.definitions
    });
}
module.exports.multiSigningData = $06f1aaab651526a4$var$multiSigningData;

});
parcelRegister("1KMxh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashPrefix = void 0;

var $hdCF9 = parcelRequire("hdCF9");
/**
 * Write a 32 bit integer to a Uint8Array
 *
 * @param uint32 32 bit integer to write to Uint8Array
 * @returns a Uint8Array with the bytes representation of uint32
 */ function $146fbc7ef1775378$var$bytes(uint32) {
    const result = new Uint8Array(4);
    (0, $hdCF9.writeUInt32BE)(result, uint32, 0);
    return result;
}
/**
 * Maps HashPrefix names to their byte representation
 */ const $146fbc7ef1775378$var$HashPrefix = {
    transactionID: $146fbc7ef1775378$var$bytes(0x54584e00),
    // transaction plus metadata
    transaction: $146fbc7ef1775378$var$bytes(0x534e4400),
    // account state
    accountStateEntry: $146fbc7ef1775378$var$bytes(0x4d4c4e00),
    // inner node in tree
    innerNode: $146fbc7ef1775378$var$bytes(0x4d494e00),
    // ledger master data for signing
    ledgerHeader: $146fbc7ef1775378$var$bytes(0x4c575200),
    // inner transaction to sign
    transactionSig: $146fbc7ef1775378$var$bytes(0x53545800),
    // inner transaction to sign
    transactionMultiSig: $146fbc7ef1775378$var$bytes(0x534d5400),
    // validation for signing
    validation: $146fbc7ef1775378$var$bytes(0x56414c00),
    // proposal for signing
    proposal: $146fbc7ef1775378$var$bytes(0x50525000),
    // payment channel claim
    paymentChannelClaim: $146fbc7ef1775378$var$bytes(0x434c4d00)
};
module.exports.HashPrefix = $146fbc7ef1775378$var$HashPrefix;

});

parcelRegister("4EzQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transactionID = module.exports.sha512Half = module.exports.Sha512Half = void 0;

var $1KMxh = parcelRequire("1KMxh");

var $bff2V = parcelRequire("bff2V");

var $97POw = parcelRequire("97POw");

var $fBYrP = parcelRequire("fBYrP");
/**
 * Class for hashing with SHA512
 * @extends BytesList So SerializedTypes can write bytes to a Sha512Half
 */ class $3636b56eebbd81a9$var$Sha512Half extends $97POw.BytesList {
    constructor(){
        super(...arguments);
        this.hash = $fBYrP.sha512.create();
    }
    /**
     * Construct a new Sha512Hash and write bytes this.hash
     *
     * @param bytes bytes to write to this.hash
     * @returns the new Sha512Hash object
     */ static put(bytes) {
        return new $3636b56eebbd81a9$var$Sha512Half().put(bytes);
    }
    /**
     * Write bytes to an existing Sha512Hash
     *
     * @param bytes bytes to write to object
     * @returns the Sha512 object
     */ put(bytes) {
        this.hash.update(bytes);
        return this;
    }
    /**
     * Compute SHA512 hash and slice in half
     *
     * @returns half of a SHA512 hash
     */ finish256() {
        return Uint8Array.from(this.hash.digest().slice(0, 32));
    }
    /**
     * Constructs a Hash256 from the Sha512Half object
     *
     * @returns a Hash256 object
     */ finish() {
        return new $bff2V.Hash256(this.finish256());
    }
}
module.exports.Sha512Half = $3636b56eebbd81a9$var$Sha512Half;
/**
 * compute SHA512 hash of a list of bytes
 *
 * @param args zero or more arguments to hash
 * @returns the sha512half hash of the arguments.
 */ function $3636b56eebbd81a9$var$sha512Half(...args) {
    const hash = new $3636b56eebbd81a9$var$Sha512Half();
    args.forEach((a)=>hash.put(a));
    return hash.finish256();
}
module.exports.sha512Half = $3636b56eebbd81a9$var$sha512Half;
/**
 * Construct a transactionID from a Serialized Transaction
 *
 * @param serialized bytes to hash
 * @returns a Hash256 object
 */ function $3636b56eebbd81a9$var$transactionID(serialized) {
    return new $bff2V.Hash256($3636b56eebbd81a9$var$sha512Half($1KMxh.HashPrefix.transactionID, serialized));
}
module.exports.transactionID = $3636b56eebbd81a9$var$transactionID;

});
parcelRegister("fBYrP", function(module, exports) {
"use strict";
var $b5d9336859215b67$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = void 0;

var $fJ9Lg = parcelRequire("fJ9Lg");

const $b5d9336859215b67$var$wrapNoble_1 = $b5d9336859215b67$var$__importDefault((parcelRequire("f8atV")));
/**
 * Wrap noble-libs's sha512 implementation in HashFn
 */ module.exports.sha512 = (0, $b5d9336859215b67$var$wrapNoble_1.default)($fJ9Lg.sha512);

});



parcelRegister("hQdr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShaMapLeaf = module.exports.ShaMapNode = module.exports.ShaMap = void 0;

var $bff2V = parcelRequire("bff2V");

var $1KMxh = parcelRequire("1KMxh");

var $4EzQV = parcelRequire("4EzQV");
/**
 * Abstract class describing a SHAMapNode
 */ class $cfd1b6e28f4b8ac5$var$ShaMapNode {
}
module.exports.ShaMapNode = $cfd1b6e28f4b8ac5$var$ShaMapNode;
/**
 * Class describing a Leaf of SHAMap
 */ class $cfd1b6e28f4b8ac5$var$ShaMapLeaf extends $cfd1b6e28f4b8ac5$var$ShaMapNode {
    constructor(index, item){
        super();
        this.index = index;
        this.item = item;
    }
    /**
     * @returns true as ShaMapLeaf is a leaf node
     */ isLeaf() {
        return true;
    }
    /**
     * @returns false as ShaMapLeaf is not an inner node
     */ isInner() {
        return false;
    }
    /**
     * Get the prefix of the this.item
     *
     * @returns The hash prefix, unless this.item is undefined, then it returns an empty Uint8Array
     */ hashPrefix() {
        return this.item === undefined ? new Uint8Array(0) : this.item.hashPrefix();
    }
    /**
     * Hash the bytes representation of this
     *
     * @returns hash of this.item concatenated with this.index
     */ hash() {
        const hash = $4EzQV.Sha512Half.put(this.hashPrefix());
        this.toBytesSink(hash);
        return hash.finish();
    }
    /**
     * Write the bytes representation of this to a BytesList
     * @param list BytesList to write bytes to
     */ toBytesSink(list) {
        if (this.item !== undefined) this.item.toBytesSink(list);
        this.index.toBytesSink(list);
    }
}
module.exports.ShaMapLeaf = $cfd1b6e28f4b8ac5$var$ShaMapLeaf;
/**
 * Class defining an Inner Node of a SHAMap
 */ class $cfd1b6e28f4b8ac5$var$ShaMapInner extends $cfd1b6e28f4b8ac5$var$ShaMapNode {
    constructor(depth = 0){
        super();
        this.depth = depth;
        this.slotBits = 0;
        this.branches = Array(16);
    }
    /**
     * @returns true as ShaMapInner is an inner node
     */ isInner() {
        return true;
    }
    /**
     * @returns false as ShaMapInner is not a leaf node
     */ isLeaf() {
        return false;
    }
    /**
     * Get the hash prefix for this node
     *
     * @returns hash prefix describing an inner node
     */ hashPrefix() {
        return $1KMxh.HashPrefix.innerNode;
    }
    /**
     * Set a branch of this node to be another node
     *
     * @param slot Slot to add branch to this.branches
     * @param branch Branch to add
     */ setBranch(slot, branch) {
        this.slotBits = this.slotBits | 1 << slot;
        this.branches[slot] = branch;
    }
    /**
     * @returns true if node is empty
     */ empty() {
        return this.slotBits === 0;
    }
    /**
     * Compute the hash of this node
     *
     * @returns The hash of this node
     */ hash() {
        if (this.empty()) return $bff2V.coreTypes.Hash256.ZERO_256;
        const hash = $4EzQV.Sha512Half.put(this.hashPrefix());
        this.toBytesSink(hash);
        return hash.finish();
    }
    /**
     * Writes the bytes representation of this node to a BytesList
     *
     * @param list BytesList to write bytes to
     */ toBytesSink(list) {
        for(let i = 0; i < this.branches.length; i++){
            const branch = this.branches[i];
            const hash = branch ? branch.hash() : $bff2V.coreTypes.Hash256.ZERO_256;
            hash.toBytesSink(list);
        }
    }
    /**
     * Add item to the SHAMap
     *
     * @param index Hash of the index of the item being inserted
     * @param item Item to insert in the map
     * @param leaf Leaf node to insert when branch doesn't exist
     */ addItem(index, item, leaf) {
        if (index === undefined) throw new Error();
        if (index !== undefined) {
            const nibble = index.nibblet(this.depth);
            const existing = this.branches[nibble];
            if (existing === undefined) this.setBranch(nibble, leaf || new $cfd1b6e28f4b8ac5$var$ShaMapLeaf(index, item));
            else if (existing instanceof $cfd1b6e28f4b8ac5$var$ShaMapLeaf) {
                const newInner = new $cfd1b6e28f4b8ac5$var$ShaMapInner(this.depth + 1);
                newInner.addItem(existing.index, undefined, existing);
                newInner.addItem(index, item, leaf);
                this.setBranch(nibble, newInner);
            } else if (existing instanceof $cfd1b6e28f4b8ac5$var$ShaMapInner) existing.addItem(index, item, leaf);
            else throw new Error('invalid ShaMap.addItem call');
        }
    }
}
class $cfd1b6e28f4b8ac5$var$ShaMap extends $cfd1b6e28f4b8ac5$var$ShaMapInner {
}
module.exports.ShaMap = $cfd1b6e28f4b8ac5$var$ShaMap;

});

parcelRegister("h0wvg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeLedgerData = module.exports.ledgerHash = module.exports.transactionTreeHash = module.exports.accountStateHash = void 0;

var $hQdr1 = parcelRequire("hQdr1");

var $1KMxh = parcelRequire("1KMxh");

var $4EzQV = parcelRequire("4EzQV");

var $AXH1k = parcelRequire("AXH1k");

var $46bAN = parcelRequire("46bAN");

var $8hs6X = parcelRequire("8hs6X");

var $7dDUy = parcelRequire("7dDUy");

var $9W0MR = parcelRequire("9W0MR");

var $T7Ahl = parcelRequire("T7Ahl");

var $fhZB1 = parcelRequire("fhZB1");
/**
 * Computes the hash of a list of objects
 *
 * @param itemizer Converts an item into a format that can be added to SHAMap
 * @param itemsJson Array of items to add to a SHAMap
 * @returns the hash of the SHAMap
 */ function $c61ba63a12468735$var$computeHash(itemizer, itemsJson) {
    const map = new $hQdr1.ShaMap();
    itemsJson.forEach((item)=>map.addItem(...itemizer(item)));
    return map.hash();
}
/**
 * Convert a transaction into an index and an item
 *
 * @param json transaction with metadata
 * @returns a tuple of index and item to be added to SHAMap
 */ function $c61ba63a12468735$var$transactionItemizer(json) {
    if (!json.hash) throw new Error();
    const index = $46bAN.Hash256.from(json.hash);
    const item = {
        hashPrefix () {
            return $1KMxh.HashPrefix.transaction;
        },
        toBytesSink (sink) {
            const serializer = new $AXH1k.BinarySerializer(sink);
            serializer.writeLengthEncoded($8hs6X.STObject.from(json));
            serializer.writeLengthEncoded($8hs6X.STObject.from(json.metaData));
        }
    };
    return [
        index,
        item,
        undefined
    ];
}
/**
 * Convert an entry to a pair Hash256 and ShaMapNode
 *
 * @param json JSON describing a ledger entry item
 * @returns a tuple of index and item to be added to SHAMap
 */ function $c61ba63a12468735$var$entryItemizer(json) {
    const index = $46bAN.Hash256.from(json.index);
    const bytes = (0, $AXH1k.serializeObject)(json);
    const item = {
        hashPrefix () {
            return $1KMxh.HashPrefix.accountStateEntry;
        },
        toBytesSink (sink) {
            sink.put(bytes);
        }
    };
    return [
        index,
        item,
        undefined
    ];
}
/**
 * Function computing the hash of a transaction tree
 *
 * @param param An array of transaction objects to hash
 * @returns A Hash256 object
 */ function $c61ba63a12468735$var$transactionTreeHash(param) {
    const itemizer = $c61ba63a12468735$var$transactionItemizer;
    return $c61ba63a12468735$var$computeHash(itemizer, param);
}
module.exports.transactionTreeHash = $c61ba63a12468735$var$transactionTreeHash;
/**
 * Function computing the hash of accountState
 *
 * @param param A list of accountStates hash
 * @returns A Hash256 object
 */ function $c61ba63a12468735$var$accountStateHash(param) {
    const itemizer = $c61ba63a12468735$var$entryItemizer;
    return $c61ba63a12468735$var$computeHash(itemizer, param);
}
module.exports.accountStateHash = $c61ba63a12468735$var$accountStateHash;
/**
 * Serialize and hash a ledger header
 *
 * @param header a ledger header
 * @returns the hash of header
 */ function $c61ba63a12468735$var$ledgerHash(header) {
    const hash = new $4EzQV.Sha512Half();
    hash.put($1KMxh.HashPrefix.ledgerHeader);
    if (header.parent_close_time === undefined || header.close_flags === undefined) throw new Error();
    $9W0MR.UInt32.from(header.ledger_index).toBytesSink(hash);
    $7dDUy.UInt64.from(BigInt(String(header.total_coins))).toBytesSink(hash);
    $46bAN.Hash256.from(header.parent_hash).toBytesSink(hash);
    $46bAN.Hash256.from(header.transaction_hash).toBytesSink(hash);
    $46bAN.Hash256.from(header.account_hash).toBytesSink(hash);
    $9W0MR.UInt32.from(header.parent_close_time).toBytesSink(hash);
    $9W0MR.UInt32.from(header.close_time).toBytesSink(hash);
    $T7Ahl.UInt8.from(header.close_time_resolution).toBytesSink(hash);
    $T7Ahl.UInt8.from(header.close_flags).toBytesSink(hash);
    return hash.finish();
}
module.exports.ledgerHash = $c61ba63a12468735$var$ledgerHash;
/**
 * Decodes a serialized ledger header
 *
 * @param binary A serialized ledger header
 * @param definitions Type definitions to parse the ledger objects.
 *      Used if there are non-default ledger objects to decode.
 * @returns A JSON object describing a ledger header
 */ function $c61ba63a12468735$var$decodeLedgerData(binary, definitions) {
    if (typeof binary !== 'string') throw new Error('binary must be a hex string');
    const parser = new $fhZB1.BinaryParser(binary, definitions);
    return {
        ledger_index: parser.readUInt32(),
        total_coins: parser.readType($7dDUy.UInt64).valueOf().toString(),
        parent_hash: parser.readType($46bAN.Hash256).toHex(),
        transaction_hash: parser.readType($46bAN.Hash256).toHex(),
        account_hash: parser.readType($46bAN.Hash256).toHex(),
        parent_close_time: parser.readUInt32(),
        close_time: parser.readUInt32(),
        close_time_resolution: parser.readUInt8(),
        close_flags: parser.readUInt8()
    };
}
module.exports.decodeLedgerData = $c61ba63a12468735$var$decodeLedgerData;

});

parcelRegister("EQkV7", function(module, exports) {
"use strict";
var $07ac55771eb1b364$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.quality = void 0;

var $bff2V = parcelRequire("bff2V");

const $07ac55771eb1b364$var$bignumber_js_1 = $07ac55771eb1b364$var$__importDefault((parcelRequire("hqAsy")));

var $8wxDW = parcelRequire("8wxDW");
/**
 * class for encoding and decoding quality
 */ class $07ac55771eb1b364$var$quality {
    /**
     * Encode quality amount
     *
     * @param arg string representation of an amount
     * @returns Serialized quality
     */ static encode(quality) {
        const decimal = (0, $07ac55771eb1b364$var$bignumber_js_1.default)(quality);
        const exponent = ((decimal === null || decimal === void 0 ? void 0 : decimal.e) || 0) - 15;
        const qualityString = decimal.times(`1e${-exponent}`).abs().toString();
        const bytes = $bff2V.coreTypes.UInt64.from(BigInt(qualityString)).toBytes();
        bytes[0] = exponent + 100;
        return bytes;
    }
    /**
     * Decode quality amount
     *
     * @param arg hex-string denoting serialized quality
     * @returns deserialized quality
     */ static decode(quality) {
        const bytes = (0, $8wxDW.hexToBytes)(quality).slice(-8);
        const exponent = bytes[0] - 100;
        const mantissa = new $07ac55771eb1b364$var$bignumber_js_1.default(`0x${(0, $8wxDW.bytesToHex)(bytes.slice(1))}`);
        return mantissa.times(`1e${exponent}`);
    }
}
module.exports.quality = $07ac55771eb1b364$var$quality;

});


parcelRegister("48CH0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XrplDefinitions = void 0;

var $dGSbb = parcelRequire("dGSbb");

var $bff2V = parcelRequire("bff2V");
/**
 * Stores the various types and fields for rippled to be used to encode/decode information later on.
 * Should be used instead of XrplDefinitionsBase since this defines default `types` for serializing/deserializing
 * ledger data.
 */ class $3035ec5100305f57$var$XrplDefinitions extends $dGSbb.XrplDefinitionsBase {
    /**
     * Present rippled types in a typed and updatable format.
     * For an example of the input format see `definitions.json`
     * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
     *
     * See the definitions.test.js file for examples of how to create your own updated definitions.json.
     *
     * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
     * @param additionalTypes - A list of SerializedType objects with the same name as the fields defined.
     *              These types will be included in addition to the coreTypes used on mainnet.
     */ constructor(enums, additionalTypes){
        const types = Object.assign({}, $bff2V.coreTypes, additionalTypes);
        super(enums, types);
    }
}
module.exports.XrplDefinitions = $3035ec5100305f57$var$XrplDefinitions;

});


parcelRegister("33Rto", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isHex = module.exports.isFlagEnabled = module.exports.onlyHasFields = module.exports.INTEGER_SANITY_CHECK = void 0;
const $23ab2186c8016ff5$var$HEX_REGEX = /^[0-9A-Fa-f]+$/u;
module.exports.INTEGER_SANITY_CHECK = /^[0-9]+$/u;
function $23ab2186c8016ff5$var$onlyHasFields(obj, fields) {
    return Object.keys(obj).every((key)=>fields.includes(key));
}
module.exports.onlyHasFields = $23ab2186c8016ff5$var$onlyHasFields;
function $23ab2186c8016ff5$var$isFlagEnabled(Flags, checkFlag) {
    return (BigInt(checkFlag) & BigInt(Flags)) === BigInt(checkFlag);
}
module.exports.isFlagEnabled = $23ab2186c8016ff5$var$isFlagEnabled;
function $23ab2186c8016ff5$var$isHex(str) {
    return $23ab2186c8016ff5$var$HEX_REGEX.test(str);
}
module.exports.isHex = $23ab2186c8016ff5$var$isHex;

});



parcelRegister("4HOmt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMClawback = module.exports.AMMClawbackFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $36d23e56622fbc83$var$AMMClawbackFlags;
(function(AMMClawbackFlags) {
    AMMClawbackFlags[AMMClawbackFlags["tfClawTwoAssets"] = 1] = "tfClawTwoAssets";
})($36d23e56622fbc83$var$AMMClawbackFlags || (module.exports.AMMClawbackFlags = $36d23e56622fbc83$var$AMMClawbackFlags = {}));
function $36d23e56622fbc83$var$validateAMMClawback(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Holder', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'Asset', $aDIrf.isCurrency);
    const asset = tx.Asset;
    const amount = tx.Amount;
    if (tx.Holder === asset.issuer) throw new $aMl9I.ValidationError('AMMClawback: Holder and Asset.issuer must be distinct');
    if (tx.Account !== asset.issuer) throw new $aMl9I.ValidationError('AMMClawback: Account must be the same as Asset.issuer');
    (0, $aDIrf.validateRequiredField)(tx, 'Asset2', $aDIrf.isCurrency);
    (0, $aDIrf.validateOptionalField)(tx, 'Amount', $aDIrf.isAmount);
    if (tx.Amount != null) {
        if (amount.currency !== asset.currency) throw new $aMl9I.ValidationError('AMMClawback: Amount.currency must match Asset.currency');
        if (amount.issuer !== asset.issuer) throw new $aMl9I.ValidationError('AMMClawback: Amount.issuer must match Amount.issuer');
    }
}
module.exports.validateAMMClawback = $36d23e56622fbc83$var$validateAMMClawback;

});

parcelRegister("lbyT0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMDeposit = module.exports.AMMDepositFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $f6c5afb9fe8c05b6$var$AMMDepositFlags;
(function(AMMDepositFlags) {
    AMMDepositFlags[AMMDepositFlags["tfLPToken"] = 65536] = "tfLPToken";
    AMMDepositFlags[AMMDepositFlags["tfSingleAsset"] = 524288] = "tfSingleAsset";
    AMMDepositFlags[AMMDepositFlags["tfTwoAsset"] = 1048576] = "tfTwoAsset";
    AMMDepositFlags[AMMDepositFlags["tfOneAssetLPToken"] = 2097152] = "tfOneAssetLPToken";
    AMMDepositFlags[AMMDepositFlags["tfLimitLPToken"] = 4194304] = "tfLimitLPToken";
    AMMDepositFlags[AMMDepositFlags["tfTwoAssetIfEmpty"] = 8388608] = "tfTwoAssetIfEmpty";
})($f6c5afb9fe8c05b6$var$AMMDepositFlags || (module.exports.AMMDepositFlags = $f6c5afb9fe8c05b6$var$AMMDepositFlags = {}));
function $f6c5afb9fe8c05b6$var$validateAMMDeposit(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Asset == null) throw new $aMl9I.ValidationError('AMMDeposit: missing field Asset');
    if (!(0, $aDIrf.isCurrency)(tx.Asset)) throw new $aMl9I.ValidationError('AMMDeposit: Asset must be a Currency');
    if (tx.Asset2 == null) throw new $aMl9I.ValidationError('AMMDeposit: missing field Asset2');
    if (!(0, $aDIrf.isCurrency)(tx.Asset2)) throw new $aMl9I.ValidationError('AMMDeposit: Asset2 must be a Currency');
    if (tx.Amount2 != null && tx.Amount == null) throw new $aMl9I.ValidationError('AMMDeposit: must set Amount with Amount2');
    else if (tx.EPrice != null && tx.Amount == null) throw new $aMl9I.ValidationError('AMMDeposit: must set Amount with EPrice');
    else if (tx.LPTokenOut == null && tx.Amount == null) throw new $aMl9I.ValidationError('AMMDeposit: must set at least LPTokenOut or Amount');
    if (tx.LPTokenOut != null && !(0, $aDIrf.isIssuedCurrency)(tx.LPTokenOut)) throw new $aMl9I.ValidationError('AMMDeposit: LPTokenOut must be an IssuedCurrencyAmount');
    if (tx.Amount != null && !(0, $aDIrf.isAmount)(tx.Amount)) throw new $aMl9I.ValidationError('AMMDeposit: Amount must be an Amount');
    if (tx.Amount2 != null && !(0, $aDIrf.isAmount)(tx.Amount2)) throw new $aMl9I.ValidationError('AMMDeposit: Amount2 must be an Amount');
    if (tx.EPrice != null && !(0, $aDIrf.isAmount)(tx.EPrice)) throw new $aMl9I.ValidationError('AMMDeposit: EPrice must be an Amount');
}
module.exports.validateAMMDeposit = $f6c5afb9fe8c05b6$var$validateAMMDeposit;

});

parcelRegister("hQcIN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMWithdraw = module.exports.AMMWithdrawFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $cfd129374f1a738a$var$AMMWithdrawFlags;
(function(AMMWithdrawFlags) {
    AMMWithdrawFlags[AMMWithdrawFlags["tfLPToken"] = 65536] = "tfLPToken";
    AMMWithdrawFlags[AMMWithdrawFlags["tfWithdrawAll"] = 131072] = "tfWithdrawAll";
    AMMWithdrawFlags[AMMWithdrawFlags["tfOneAssetWithdrawAll"] = 262144] = "tfOneAssetWithdrawAll";
    AMMWithdrawFlags[AMMWithdrawFlags["tfSingleAsset"] = 524288] = "tfSingleAsset";
    AMMWithdrawFlags[AMMWithdrawFlags["tfTwoAsset"] = 1048576] = "tfTwoAsset";
    AMMWithdrawFlags[AMMWithdrawFlags["tfOneAssetLPToken"] = 2097152] = "tfOneAssetLPToken";
    AMMWithdrawFlags[AMMWithdrawFlags["tfLimitLPToken"] = 4194304] = "tfLimitLPToken";
})($cfd129374f1a738a$var$AMMWithdrawFlags || (module.exports.AMMWithdrawFlags = $cfd129374f1a738a$var$AMMWithdrawFlags = {}));
function $cfd129374f1a738a$var$validateAMMWithdraw(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Asset == null) throw new $aMl9I.ValidationError('AMMWithdraw: missing field Asset');
    if (!(0, $aDIrf.isCurrency)(tx.Asset)) throw new $aMl9I.ValidationError('AMMWithdraw: Asset must be a Currency');
    if (tx.Asset2 == null) throw new $aMl9I.ValidationError('AMMWithdraw: missing field Asset2');
    if (!(0, $aDIrf.isCurrency)(tx.Asset2)) throw new $aMl9I.ValidationError('AMMWithdraw: Asset2 must be a Currency');
    if (tx.Amount2 != null && tx.Amount == null) throw new $aMl9I.ValidationError('AMMWithdraw: must set Amount with Amount2');
    else if (tx.EPrice != null && tx.Amount == null) throw new $aMl9I.ValidationError('AMMWithdraw: must set Amount with EPrice');
    if (tx.LPTokenIn != null && !(0, $aDIrf.isIssuedCurrency)(tx.LPTokenIn)) throw new $aMl9I.ValidationError('AMMWithdraw: LPTokenIn must be an IssuedCurrencyAmount');
    if (tx.Amount != null && !(0, $aDIrf.isAmount)(tx.Amount)) throw new $aMl9I.ValidationError('AMMWithdraw: Amount must be an Amount');
    if (tx.Amount2 != null && !(0, $aDIrf.isAmount)(tx.Amount2)) throw new $aMl9I.ValidationError('AMMWithdraw: Amount2 must be an Amount');
    if (tx.EPrice != null && !(0, $aDIrf.isAmount)(tx.EPrice)) throw new $aMl9I.ValidationError('AMMWithdraw: EPrice must be an Amount');
}
module.exports.validateAMMWithdraw = $cfd129374f1a738a$var$validateAMMWithdraw;

});

parcelRegister("83INw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateMPTokenAuthorize = module.exports.MPTokenAuthorizeFlags = void 0;

var $aDIrf = parcelRequire("aDIrf");
var $5de15a76b5b850ac$var$MPTokenAuthorizeFlags;
(function(MPTokenAuthorizeFlags) {
    MPTokenAuthorizeFlags[MPTokenAuthorizeFlags["tfMPTUnauthorize"] = 1] = "tfMPTUnauthorize";
})($5de15a76b5b850ac$var$MPTokenAuthorizeFlags || (module.exports.MPTokenAuthorizeFlags = $5de15a76b5b850ac$var$MPTokenAuthorizeFlags = {}));
function $5de15a76b5b850ac$var$validateMPTokenAuthorize(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'MPTokenIssuanceID', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'Holder', $aDIrf.isAccount);
}
module.exports.validateMPTokenAuthorize = $5de15a76b5b850ac$var$validateMPTokenAuthorize;

});

parcelRegister("l0c6B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateMPTokenIssuanceCreate = module.exports.MPTokenIssuanceCreateFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $aDIrf = parcelRequire("aDIrf");
const $f4a2fcf75e8c1eb8$var$MAX_AMT = '9223372036854775807';
const $f4a2fcf75e8c1eb8$var$MAX_TRANSFER_FEE = 50000;
var $f4a2fcf75e8c1eb8$var$MPTokenIssuanceCreateFlags;
(function(MPTokenIssuanceCreateFlags) {
    MPTokenIssuanceCreateFlags[MPTokenIssuanceCreateFlags["tfMPTCanLock"] = 2] = "tfMPTCanLock";
    MPTokenIssuanceCreateFlags[MPTokenIssuanceCreateFlags["tfMPTRequireAuth"] = 4] = "tfMPTRequireAuth";
    MPTokenIssuanceCreateFlags[MPTokenIssuanceCreateFlags["tfMPTCanEscrow"] = 8] = "tfMPTCanEscrow";
    MPTokenIssuanceCreateFlags[MPTokenIssuanceCreateFlags["tfMPTCanTrade"] = 16] = "tfMPTCanTrade";
    MPTokenIssuanceCreateFlags[MPTokenIssuanceCreateFlags["tfMPTCanTransfer"] = 32] = "tfMPTCanTransfer";
    MPTokenIssuanceCreateFlags[MPTokenIssuanceCreateFlags["tfMPTCanClawback"] = 64] = "tfMPTCanClawback";
})($f4a2fcf75e8c1eb8$var$MPTokenIssuanceCreateFlags || (module.exports.MPTokenIssuanceCreateFlags = $f4a2fcf75e8c1eb8$var$MPTokenIssuanceCreateFlags = {}));
function $f4a2fcf75e8c1eb8$var$validateMPTokenIssuanceCreate(tx) {
    var _a;
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'MaximumAmount', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'MPTokenMetadata', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'TransferFee', $aDIrf.isNumber);
    (0, $aDIrf.validateOptionalField)(tx, 'AssetScale', $aDIrf.isNumber);
    if (typeof tx.MPTokenMetadata === 'string' && tx.MPTokenMetadata === '') throw new $aMl9I.ValidationError('MPTokenIssuanceCreate: MPTokenMetadata must not be empty string');
    if (typeof tx.MPTokenMetadata === 'string' && !(0, $33Rto.isHex)(tx.MPTokenMetadata)) throw new $aMl9I.ValidationError('MPTokenIssuanceCreate: MPTokenMetadata must be in hex format');
    if (typeof tx.MaximumAmount === 'string') {
        if (!$33Rto.INTEGER_SANITY_CHECK.exec(tx.MaximumAmount)) throw new $aMl9I.ValidationError('MPTokenIssuanceCreate: Invalid MaximumAmount');
        else if (BigInt(tx.MaximumAmount) > BigInt($f4a2fcf75e8c1eb8$var$MAX_AMT) || BigInt(tx.MaximumAmount) < BigInt(`0`)) throw new $aMl9I.ValidationError('MPTokenIssuanceCreate: MaximumAmount out of range');
    }
    if (typeof tx.TransferFee === 'number') {
        const flags = tx.Flags;
        const isTfMPTCanTransfer = typeof flags === 'number' ? (0, $33Rto.isFlagEnabled)(flags, $f4a2fcf75e8c1eb8$var$MPTokenIssuanceCreateFlags.tfMPTCanTransfer) : (_a = flags.tfMPTCanTransfer) !== null && _a !== void 0 ? _a : false;
        if (tx.TransferFee < 0 || tx.TransferFee > $f4a2fcf75e8c1eb8$var$MAX_TRANSFER_FEE) throw new $aMl9I.ValidationError(`MPTokenIssuanceCreate: TransferFee must be between 0 and ${$f4a2fcf75e8c1eb8$var$MAX_TRANSFER_FEE}`);
        if (tx.TransferFee && !isTfMPTCanTransfer) throw new $aMl9I.ValidationError('MPTokenIssuanceCreate: TransferFee cannot be provided without enabling tfMPTCanTransfer flag');
    }
}
module.exports.validateMPTokenIssuanceCreate = $f4a2fcf75e8c1eb8$var$validateMPTokenIssuanceCreate;

});

parcelRegister("8W2RA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateMPTokenIssuanceSet = module.exports.MPTokenIssuanceSetFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $aDIrf = parcelRequire("aDIrf");
var $6815f619c5328a17$var$MPTokenIssuanceSetFlags;
(function(MPTokenIssuanceSetFlags) {
    MPTokenIssuanceSetFlags[MPTokenIssuanceSetFlags["tfMPTLock"] = 1] = "tfMPTLock";
    MPTokenIssuanceSetFlags[MPTokenIssuanceSetFlags["tfMPTUnlock"] = 2] = "tfMPTUnlock";
})($6815f619c5328a17$var$MPTokenIssuanceSetFlags || (module.exports.MPTokenIssuanceSetFlags = $6815f619c5328a17$var$MPTokenIssuanceSetFlags = {}));
function $6815f619c5328a17$var$validateMPTokenIssuanceSet(tx) {
    var _a, _b;
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'MPTokenIssuanceID', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'Holder', $aDIrf.isAccount);
    const flags = tx.Flags;
    const isTfMPTLock = typeof flags === 'number' ? (0, $33Rto.isFlagEnabled)(flags, $6815f619c5328a17$var$MPTokenIssuanceSetFlags.tfMPTLock) : (_a = flags.tfMPTLock) !== null && _a !== void 0 ? _a : false;
    const isTfMPTUnlock = typeof flags === 'number' ? (0, $33Rto.isFlagEnabled)(flags, $6815f619c5328a17$var$MPTokenIssuanceSetFlags.tfMPTUnlock) : (_b = flags.tfMPTUnlock) !== null && _b !== void 0 ? _b : false;
    if (isTfMPTLock && isTfMPTUnlock) throw new $aMl9I.ValidationError('MPTokenIssuanceSet: flag conflict');
}
module.exports.validateMPTokenIssuanceSet = $6815f619c5328a17$var$validateMPTokenIssuanceSet;

});

parcelRegister("gwU9F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNFTokenCreateOffer = module.exports.NFTokenCreateOfferFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $aDIrf = parcelRequire("aDIrf");
var $c08b31b723f1d3e9$var$NFTokenCreateOfferFlags;
(function(NFTokenCreateOfferFlags) {
    NFTokenCreateOfferFlags[NFTokenCreateOfferFlags["tfSellNFToken"] = 1] = "tfSellNFToken";
})($c08b31b723f1d3e9$var$NFTokenCreateOfferFlags || (module.exports.NFTokenCreateOfferFlags = $c08b31b723f1d3e9$var$NFTokenCreateOfferFlags = {}));
function $c08b31b723f1d3e9$var$validateNFTokenSellOfferCases(tx) {
    if (tx.Owner != null) throw new $aMl9I.ValidationError('NFTokenCreateOffer: Owner must not be present for sell offers');
}
function $c08b31b723f1d3e9$var$validateNFTokenBuyOfferCases(tx) {
    if (tx.Owner == null) throw new $aMl9I.ValidationError('NFTokenCreateOffer: Owner must be present for buy offers');
    if ((0, $aDIrf.parseAmountValue)(tx.Amount) <= 0) throw new $aMl9I.ValidationError('NFTokenCreateOffer: Amount must be greater than 0 for buy offers');
}
function $c08b31b723f1d3e9$var$validateNFTokenCreateOffer(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Account === tx.Owner) throw new $aMl9I.ValidationError('NFTokenCreateOffer: Owner and Account must not be equal');
    if (tx.Account === tx.Destination) throw new $aMl9I.ValidationError('NFTokenCreateOffer: Destination and Account must not be equal');
    (0, $aDIrf.validateOptionalField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'Owner', $aDIrf.isAccount);
    if (tx.NFTokenID == null) throw new $aMl9I.ValidationError('NFTokenCreateOffer: missing field NFTokenID');
    if (!(0, $aDIrf.isAmount)(tx.Amount)) throw new $aMl9I.ValidationError('NFTokenCreateOffer: invalid Amount');
    if (typeof tx.Flags === 'number' && (0, $33Rto.isFlagEnabled)(tx.Flags, $c08b31b723f1d3e9$var$NFTokenCreateOfferFlags.tfSellNFToken)) $c08b31b723f1d3e9$var$validateNFTokenSellOfferCases(tx);
    else $c08b31b723f1d3e9$var$validateNFTokenBuyOfferCases(tx);
}
module.exports.validateNFTokenCreateOffer = $c08b31b723f1d3e9$var$validateNFTokenCreateOffer;

});

parcelRegister("hWIeS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNFTokenMint = module.exports.NFTokenMintFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $aDIrf = parcelRequire("aDIrf");
var $d10a2b62e410c6d9$var$NFTokenMintFlags;
(function(NFTokenMintFlags) {
    NFTokenMintFlags[NFTokenMintFlags["tfBurnable"] = 1] = "tfBurnable";
    NFTokenMintFlags[NFTokenMintFlags["tfOnlyXRP"] = 2] = "tfOnlyXRP";
    NFTokenMintFlags[NFTokenMintFlags["tfTrustLine"] = 4] = "tfTrustLine";
    NFTokenMintFlags[NFTokenMintFlags["tfTransferable"] = 8] = "tfTransferable";
    NFTokenMintFlags[NFTokenMintFlags["tfMutable"] = 16] = "tfMutable";
})($d10a2b62e410c6d9$var$NFTokenMintFlags || (module.exports.NFTokenMintFlags = $d10a2b62e410c6d9$var$NFTokenMintFlags = {}));
function $d10a2b62e410c6d9$var$validateNFTokenMint(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Account === tx.Issuer) throw new $aMl9I.ValidationError('NFTokenMint: Issuer must not be equal to Account');
    (0, $aDIrf.validateOptionalField)(tx, 'Issuer', $aDIrf.isAccount);
    if (typeof tx.URI === 'string' && tx.URI === '') throw new $aMl9I.ValidationError('NFTokenMint: URI must not be empty string');
    if (typeof tx.URI === 'string' && !(0, $33Rto.isHex)(tx.URI)) throw new $aMl9I.ValidationError('NFTokenMint: URI must be in hex format');
    if (tx.NFTokenTaxon == null) throw new $aMl9I.ValidationError('NFTokenMint: missing field NFTokenTaxon');
}
module.exports.validateNFTokenMint = $d10a2b62e410c6d9$var$validateNFTokenMint;

});

parcelRegister("hgQ7j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateOfferCreate = module.exports.OfferCreateFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $c92c5ba5d84621ba$var$OfferCreateFlags;
(function(OfferCreateFlags) {
    OfferCreateFlags[OfferCreateFlags["tfPassive"] = 65536] = "tfPassive";
    OfferCreateFlags[OfferCreateFlags["tfImmediateOrCancel"] = 131072] = "tfImmediateOrCancel";
    OfferCreateFlags[OfferCreateFlags["tfFillOrKill"] = 262144] = "tfFillOrKill";
    OfferCreateFlags[OfferCreateFlags["tfSell"] = 524288] = "tfSell";
})($c92c5ba5d84621ba$var$OfferCreateFlags || (module.exports.OfferCreateFlags = $c92c5ba5d84621ba$var$OfferCreateFlags = {}));
function $c92c5ba5d84621ba$var$validateOfferCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.TakerGets === undefined) throw new $aMl9I.ValidationError('OfferCreate: missing field TakerGets');
    if (tx.TakerPays === undefined) throw new $aMl9I.ValidationError('OfferCreate: missing field TakerPays');
    if (typeof tx.TakerGets !== 'string' && !(0, $aDIrf.isAmount)(tx.TakerGets)) throw new $aMl9I.ValidationError('OfferCreate: invalid TakerGets');
    if (typeof tx.TakerPays !== 'string' && !(0, $aDIrf.isAmount)(tx.TakerPays)) throw new $aMl9I.ValidationError('OfferCreate: invalid TakerPays');
    if (tx.Expiration !== undefined && typeof tx.Expiration !== 'number') throw new $aMl9I.ValidationError('OfferCreate: invalid Expiration');
    if (tx.OfferSequence !== undefined && typeof tx.OfferSequence !== 'number') throw new $aMl9I.ValidationError('OfferCreate: invalid OfferSequence');
}
module.exports.validateOfferCreate = $c92c5ba5d84621ba$var$validateOfferCreate;

});

parcelRegister("c45eL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePayment = module.exports.PaymentFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $aDIrf = parcelRequire("aDIrf");
var $8c89ebc1f4e55ab5$var$PaymentFlags;
(function(PaymentFlags) {
    PaymentFlags[PaymentFlags["tfNoRippleDirect"] = 65536] = "tfNoRippleDirect";
    PaymentFlags[PaymentFlags["tfPartialPayment"] = 131072] = "tfPartialPayment";
    PaymentFlags[PaymentFlags["tfLimitQuality"] = 262144] = "tfLimitQuality";
})($8c89ebc1f4e55ab5$var$PaymentFlags || (module.exports.PaymentFlags = $8c89ebc1f4e55ab5$var$PaymentFlags = {}));
function $8c89ebc1f4e55ab5$var$validatePayment(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Amount === undefined) throw new $aMl9I.ValidationError('PaymentTransaction: missing field Amount');
    if (!(0, $aDIrf.isAmount)(tx.Amount)) throw new $aMl9I.ValidationError('PaymentTransaction: invalid Amount');
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'DestinationTag', $aDIrf.isNumber);
    (0, $aDIrf.validateCredentialsList)(tx.CredentialIDs, tx.TransactionType, true, $aDIrf.MAX_AUTHORIZED_CREDENTIALS);
    if (tx.InvoiceID !== undefined && typeof tx.InvoiceID !== 'string') throw new $aMl9I.ValidationError('PaymentTransaction: InvoiceID must be a string');
    if (tx.Paths !== undefined && !$8c89ebc1f4e55ab5$var$isPaths(tx.Paths)) throw new $aMl9I.ValidationError('PaymentTransaction: invalid Paths');
    if (tx.SendMax !== undefined && !(0, $aDIrf.isAmount)(tx.SendMax)) throw new $aMl9I.ValidationError('PaymentTransaction: invalid SendMax');
    $8c89ebc1f4e55ab5$var$checkPartialPayment(tx);
}
module.exports.validatePayment = $8c89ebc1f4e55ab5$var$validatePayment;
function $8c89ebc1f4e55ab5$var$checkPartialPayment(tx) {
    var _a;
    if (tx.DeliverMin != null) {
        if (tx.Flags == null) throw new $aMl9I.ValidationError('PaymentTransaction: tfPartialPayment flag required with DeliverMin');
        const flags = tx.Flags;
        const isTfPartialPayment = typeof flags === 'number' ? (0, $33Rto.isFlagEnabled)(flags, $8c89ebc1f4e55ab5$var$PaymentFlags.tfPartialPayment) : (_a = flags.tfPartialPayment) !== null && _a !== void 0 ? _a : false;
        if (!isTfPartialPayment) throw new $aMl9I.ValidationError('PaymentTransaction: tfPartialPayment flag required with DeliverMin');
        if (!(0, $aDIrf.isAmount)(tx.DeliverMin)) throw new $aMl9I.ValidationError('PaymentTransaction: invalid DeliverMin');
    }
}
function $8c89ebc1f4e55ab5$var$isPathStep(pathStep) {
    if (pathStep.account !== undefined && typeof pathStep.account !== 'string') return false;
    if (pathStep.currency !== undefined && typeof pathStep.currency !== 'string') return false;
    if (pathStep.issuer !== undefined && typeof pathStep.issuer !== 'string') return false;
    if (pathStep.account !== undefined && pathStep.currency === undefined && pathStep.issuer === undefined) return true;
    if (pathStep.currency !== undefined || pathStep.issuer !== undefined) return true;
    return false;
}
function $8c89ebc1f4e55ab5$var$isPath(path) {
    for (const pathStep of path){
        if (!$8c89ebc1f4e55ab5$var$isPathStep(pathStep)) return false;
    }
    return true;
}
function $8c89ebc1f4e55ab5$var$isPaths(paths) {
    if (!Array.isArray(paths) || paths.length === 0) return false;
    for (const path of paths){
        if (!Array.isArray(path) || path.length === 0) return false;
        if (!$8c89ebc1f4e55ab5$var$isPath(path)) return false;
    }
    return true;
}

});

parcelRegister("2907n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePaymentChannelClaim = module.exports.PaymentChannelClaimFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $18fc83733b264cb9$var$PaymentChannelClaimFlags;
(function(PaymentChannelClaimFlags) {
    PaymentChannelClaimFlags[PaymentChannelClaimFlags["tfRenew"] = 65536] = "tfRenew";
    PaymentChannelClaimFlags[PaymentChannelClaimFlags["tfClose"] = 131072] = "tfClose";
})($18fc83733b264cb9$var$PaymentChannelClaimFlags || (module.exports.PaymentChannelClaimFlags = $18fc83733b264cb9$var$PaymentChannelClaimFlags = {}));
function $18fc83733b264cb9$var$validatePaymentChannelClaim(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateCredentialsList)(tx.CredentialIDs, tx.TransactionType, true, $aDIrf.MAX_AUTHORIZED_CREDENTIALS);
    if (tx.Channel === undefined) throw new $aMl9I.ValidationError('PaymentChannelClaim: missing Channel');
    if (typeof tx.Channel !== 'string') throw new $aMl9I.ValidationError('PaymentChannelClaim: Channel must be a string');
    if (tx.Balance !== undefined && typeof tx.Balance !== 'string') throw new $aMl9I.ValidationError('PaymentChannelClaim: Balance must be a string');
    if (tx.Amount !== undefined && typeof tx.Amount !== 'string') throw new $aMl9I.ValidationError('PaymentChannelClaim: Amount must be a string');
    if (tx.Signature !== undefined && typeof tx.Signature !== 'string') throw new $aMl9I.ValidationError('PaymentChannelClaim: Signature must be a string');
    if (tx.PublicKey !== undefined && typeof tx.PublicKey !== 'string') throw new $aMl9I.ValidationError('PaymentChannelClaim: PublicKey must be a string');
}
module.exports.validatePaymentChannelClaim = $18fc83733b264cb9$var$validatePaymentChannelClaim;

});

parcelRegister("2sSFD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTrustSet = module.exports.TrustSetFlags = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
var $1cb89ab3885c2f30$var$TrustSetFlags;
(function(TrustSetFlags) {
    TrustSetFlags[TrustSetFlags["tfSetfAuth"] = 65536] = "tfSetfAuth";
    TrustSetFlags[TrustSetFlags["tfSetNoRipple"] = 131072] = "tfSetNoRipple";
    TrustSetFlags[TrustSetFlags["tfClearNoRipple"] = 262144] = "tfClearNoRipple";
    TrustSetFlags[TrustSetFlags["tfSetFreeze"] = 1048576] = "tfSetFreeze";
    TrustSetFlags[TrustSetFlags["tfClearFreeze"] = 2097152] = "tfClearFreeze";
    TrustSetFlags[TrustSetFlags["tfSetDeepFreeze"] = 4194304] = "tfSetDeepFreeze";
    TrustSetFlags[TrustSetFlags["tfClearDeepFreeze"] = 8388608] = "tfClearDeepFreeze";
})($1cb89ab3885c2f30$var$TrustSetFlags || (module.exports.TrustSetFlags = $1cb89ab3885c2f30$var$TrustSetFlags = {}));
function $1cb89ab3885c2f30$var$validateTrustSet(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    const { LimitAmount: LimitAmount, QualityIn: QualityIn, QualityOut: QualityOut } = tx;
    if (LimitAmount === undefined) throw new $aMl9I.ValidationError('TrustSet: missing field LimitAmount');
    if (!(0, $aDIrf.isAmount)(LimitAmount)) throw new $aMl9I.ValidationError('TrustSet: invalid LimitAmount');
    if (QualityIn !== undefined && typeof QualityIn !== 'number') throw new $aMl9I.ValidationError('TrustSet: QualityIn must be a number');
    if (QualityOut !== undefined && typeof QualityOut !== 'number') throw new $aMl9I.ValidationError('TrustSet: QualityOut must be a number');
}
module.exports.validateTrustSet = $1cb89ab3885c2f30$var$validateTrustSet;

});

parcelRegister("ajTnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainModifyBridge = module.exports.XChainModifyBridgeFlags = void 0;

var $aDIrf = parcelRequire("aDIrf");
var $7836a2ee1a17f3b6$var$XChainModifyBridgeFlags;
(function(XChainModifyBridgeFlags) {
    XChainModifyBridgeFlags[XChainModifyBridgeFlags["tfClearAccountCreateAmount"] = 65536] = "tfClearAccountCreateAmount";
})($7836a2ee1a17f3b6$var$XChainModifyBridgeFlags || (module.exports.XChainModifyBridgeFlags = $7836a2ee1a17f3b6$var$XChainModifyBridgeFlags = {}));
function $7836a2ee1a17f3b6$var$validateXChainModifyBridge(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateOptionalField)(tx, 'SignatureReward', $aDIrf.isAmount);
    (0, $aDIrf.validateOptionalField)(tx, 'MinAccountCreateAmount', $aDIrf.isAmount);
}
module.exports.validateXChainModifyBridge = $7836a2ee1a17f3b6$var$validateXChainModifyBridge;

});


parcelRegister("8zzq8", function(module, exports) {
"use strict";
var $63dd115e957a3ca9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $63dd115e957a3ca9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $63dd115e957a3ca9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$63dd115e957a3ca9$var$__exportStar((parcelRequire("7iuu2")), module.exports);

$63dd115e957a3ca9$var$__exportStar((parcelRequire("17lL2")), module.exports);

});
parcelRegister("7iuu2", function(module, exports) {
"use strict";
var $5501dc3d96f4e0a0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLastLedgerSequence = module.exports.getSignedTx = module.exports.waitForFinalTransactionOutcome = module.exports.submitRequest = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $3Urjz = parcelRequire("3Urjz");
const $5501dc3d96f4e0a0$var$LEDGER_CLOSE_TIME = 1000;
function $5501dc3d96f4e0a0$var$sleep(ms) {
    return $5501dc3d96f4e0a0$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve)=>{
            setTimeout(resolve, ms);
        });
    });
}
function $5501dc3d96f4e0a0$var$submitRequest(client, signedTransaction, failHard = false) {
    return $5501dc3d96f4e0a0$var$__awaiter(this, void 0, void 0, function*() {
        if (!$5501dc3d96f4e0a0$var$isSigned(signedTransaction)) throw new $aMl9I.ValidationError('Transaction must be signed.');
        const signedTxEncoded = typeof signedTransaction === 'string' ? signedTransaction : (0, $3Urjz.encode)(signedTransaction);
        const request = {
            command: 'submit',
            tx_blob: signedTxEncoded,
            fail_hard: $5501dc3d96f4e0a0$var$isAccountDelete(signedTransaction) || failHard
        };
        return client.request(request);
    });
}
module.exports.submitRequest = $5501dc3d96f4e0a0$var$submitRequest;
function $5501dc3d96f4e0a0$var$waitForFinalTransactionOutcome(client, txHash, lastLedger, submissionResult) {
    return $5501dc3d96f4e0a0$var$__awaiter(this, void 0, void 0, function*() {
        yield $5501dc3d96f4e0a0$var$sleep($5501dc3d96f4e0a0$var$LEDGER_CLOSE_TIME);
        const latestLedger = yield client.getLedgerIndex();
        if (lastLedger < latestLedger) throw new $aMl9I.XrplError(`The latest ledger sequence ${latestLedger} is greater than the transaction's LastLedgerSequence (${lastLedger}).\n` + `Preliminary result: ${submissionResult}`);
        const txResponse = yield client.request({
            command: 'tx',
            transaction: txHash
        }).catch((error)=>$5501dc3d96f4e0a0$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                const message = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.error;
                if (message === 'txnNotFound') return $5501dc3d96f4e0a0$var$waitForFinalTransactionOutcome(client, txHash, lastLedger, submissionResult);
                throw new Error(`${message} \n Preliminary result: ${submissionResult}.\nFull error details: ${String(error)}`);
            }));
        if (txResponse.result.validated) return txResponse;
        return $5501dc3d96f4e0a0$var$waitForFinalTransactionOutcome(client, txHash, lastLedger, submissionResult);
    });
}
module.exports.waitForFinalTransactionOutcome = $5501dc3d96f4e0a0$var$waitForFinalTransactionOutcome;
function $5501dc3d96f4e0a0$var$isSigned(transaction) {
    const tx = typeof transaction === 'string' ? (0, $3Urjz.decode)(transaction) : transaction;
    if (typeof tx === 'string') return false;
    if (tx.Signers != null) {
        const signers = tx.Signers;
        for (const signer of signers){
            if (signer.Signer.SigningPubKey == null || signer.Signer.TxnSignature == null) return false;
        }
        return true;
    }
    return tx.SigningPubKey != null && tx.TxnSignature != null;
}
function $5501dc3d96f4e0a0$var$getSignedTx(client, transaction, { autofill: autofill = true, wallet: wallet } = {}) {
    return $5501dc3d96f4e0a0$var$__awaiter(this, void 0, void 0, function*() {
        if ($5501dc3d96f4e0a0$var$isSigned(transaction)) return transaction;
        if (!wallet) throw new $aMl9I.ValidationError('Wallet must be provided when submitting an unsigned transaction');
        let tx = typeof transaction === 'string' ? (0, $3Urjz.decode)(transaction) : transaction;
        if (autofill) tx = yield client.autofill(tx);
        return wallet.sign(tx).tx_blob;
    });
}
module.exports.getSignedTx = $5501dc3d96f4e0a0$var$getSignedTx;
function $5501dc3d96f4e0a0$var$getLastLedgerSequence(transaction) {
    const tx = typeof transaction === 'string' ? (0, $3Urjz.decode)(transaction) : transaction;
    return tx.LastLedgerSequence;
}
module.exports.getLastLedgerSequence = $5501dc3d96f4e0a0$var$getLastLedgerSequence;
function $5501dc3d96f4e0a0$var$isAccountDelete(transaction) {
    const tx = typeof transaction === 'string' ? (0, $3Urjz.decode)(transaction) : transaction;
    return tx.TransactionType === 'AccountDelete';
}

});
parcelRegister("3Urjz", function(module, exports) {
"use strict";
var $2d8bca2d8d041bec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getXChainClaimID = module.exports.parseNFTokenID = module.exports.getNFTokenID = module.exports.encodeForSigningClaim = module.exports.encodeForSigning = module.exports.encodeForMultiSigning = module.exports.decode = module.exports.encode = module.exports.decodeXAddress = module.exports.encodeXAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.decodeNodePublic = module.exports.encodeNodePublic = module.exports.decodeAccountID = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.isValidClassicAddress = module.exports.isValidXAddress = module.exports.xAddressToClassicAddress = module.exports.classicAddressToXAddress = module.exports.convertHexToString = module.exports.convertStringToHex = module.exports.verifyPaymentChannelClaim = module.exports.verifyKeypairSignature = module.exports.signPaymentChannelClaim = module.exports.deriveXAddress = module.exports.deriveAddress = module.exports.deriveKeypair = module.exports.hashes = module.exports.isValidAddress = module.exports.isValidSecret = module.exports.qualityToDecimal = module.exports.transferRateToDecimal = module.exports.decimalToTransferRate = module.exports.percentToTransferRate = module.exports.decimalToQuality = module.exports.percentToQuality = module.exports.unixTimeToRippleTime = module.exports.rippleTimeToUnixTime = module.exports.isoTimeToRippleTime = module.exports.rippleTimeToISOTime = module.exports.hasNextPage = module.exports.xrpToDrops = module.exports.dropsToXrp = module.exports.getBalanceChanges = void 0;

var $7eC3g = parcelRequire("7eC3g");
Object.defineProperty(module.exports, "classicAddressToXAddress", {
    enumerable: true,
    get: function() {
        return $7eC3g.classicAddressToXAddress;
    }
});
Object.defineProperty(module.exports, "decodeAccountID", {
    enumerable: true,
    get: function() {
        return $7eC3g.decodeAccountID;
    }
});
Object.defineProperty(module.exports, "decodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $7eC3g.decodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "decodeNodePublic", {
    enumerable: true,
    get: function() {
        return $7eC3g.decodeNodePublic;
    }
});
Object.defineProperty(module.exports, "decodeSeed", {
    enumerable: true,
    get: function() {
        return $7eC3g.decodeSeed;
    }
});
Object.defineProperty(module.exports, "decodeXAddress", {
    enumerable: true,
    get: function() {
        return $7eC3g.decodeXAddress;
    }
});
Object.defineProperty(module.exports, "encodeAccountID", {
    enumerable: true,
    get: function() {
        return $7eC3g.encodeAccountID;
    }
});
Object.defineProperty(module.exports, "encodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $7eC3g.encodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "encodeNodePublic", {
    enumerable: true,
    get: function() {
        return $7eC3g.encodeNodePublic;
    }
});
Object.defineProperty(module.exports, "encodeSeed", {
    enumerable: true,
    get: function() {
        return $7eC3g.encodeSeed;
    }
});
Object.defineProperty(module.exports, "encodeXAddress", {
    enumerable: true,
    get: function() {
        return $7eC3g.encodeXAddress;
    }
});
Object.defineProperty(module.exports, "isValidClassicAddress", {
    enumerable: true,
    get: function() {
        return $7eC3g.isValidClassicAddress;
    }
});
Object.defineProperty(module.exports, "isValidXAddress", {
    enumerable: true,
    get: function() {
        return $7eC3g.isValidXAddress;
    }
});
Object.defineProperty(module.exports, "xAddressToClassicAddress", {
    enumerable: true,
    get: function() {
        return $7eC3g.xAddressToClassicAddress;
    }
});

var $eLMUD = parcelRequire("eLMUD");

var $cYPJw = parcelRequire("cYPJw");
Object.defineProperty(module.exports, "verifyKeypairSignature", {
    enumerable: true,
    get: function() {
        return $cYPJw.verify;
    }
});

var $cVkA1 = parcelRequire("cVkA1");
Object.defineProperty(module.exports, "deriveKeypair", {
    enumerable: true,
    get: function() {
        return $cVkA1.deriveKeypair;
    }
});
Object.defineProperty(module.exports, "deriveAddress", {
    enumerable: true,
    get: function() {
        return $cVkA1.deriveAddress;
    }
});
Object.defineProperty(module.exports, "deriveXAddress", {
    enumerable: true,
    get: function() {
        return $cVkA1.deriveXAddress;
    }
});

const $2d8bca2d8d041bec$var$getBalanceChanges_1 = $2d8bca2d8d041bec$var$__importDefault((parcelRequire("ggyID")));
module.exports.getBalanceChanges = $2d8bca2d8d041bec$var$getBalanceChanges_1.default;

const $2d8bca2d8d041bec$var$getNFTokenID_1 = $2d8bca2d8d041bec$var$__importDefault((parcelRequire("lgHcX")));
module.exports.getNFTokenID = $2d8bca2d8d041bec$var$getNFTokenID_1.default;

const $2d8bca2d8d041bec$var$getXChainClaimID_1 = $2d8bca2d8d041bec$var$__importDefault((parcelRequire("hg2av")));
module.exports.getXChainClaimID = $2d8bca2d8d041bec$var$getXChainClaimID_1.default;

var $2OCHQ = parcelRequire("2OCHQ");

const $2d8bca2d8d041bec$var$parseNFTokenID_1 = $2d8bca2d8d041bec$var$__importDefault((parcelRequire("ivvUB")));
module.exports.parseNFTokenID = $2d8bca2d8d041bec$var$parseNFTokenID_1.default;

var $c3Xtp = parcelRequire("c3Xtp");
Object.defineProperty(module.exports, "percentToTransferRate", {
    enumerable: true,
    get: function() {
        return $c3Xtp.percentToTransferRate;
    }
});
Object.defineProperty(module.exports, "decimalToTransferRate", {
    enumerable: true,
    get: function() {
        return $c3Xtp.decimalToTransferRate;
    }
});
Object.defineProperty(module.exports, "transferRateToDecimal", {
    enumerable: true,
    get: function() {
        return $c3Xtp.transferRateToDecimal;
    }
});
Object.defineProperty(module.exports, "percentToQuality", {
    enumerable: true,
    get: function() {
        return $c3Xtp.percentToQuality;
    }
});
Object.defineProperty(module.exports, "decimalToQuality", {
    enumerable: true,
    get: function() {
        return $c3Xtp.decimalToQuality;
    }
});
Object.defineProperty(module.exports, "qualityToDecimal", {
    enumerable: true,
    get: function() {
        return $c3Xtp.qualityToDecimal;
    }
});

const $2d8bca2d8d041bec$var$signPaymentChannelClaim_1 = $2d8bca2d8d041bec$var$__importDefault((parcelRequire("3oIYh")));
module.exports.signPaymentChannelClaim = $2d8bca2d8d041bec$var$signPaymentChannelClaim_1.default;

var $11XkW = parcelRequire("11XkW");
Object.defineProperty(module.exports, "convertHexToString", {
    enumerable: true,
    get: function() {
        return $11XkW.convertHexToString;
    }
});
Object.defineProperty(module.exports, "convertStringToHex", {
    enumerable: true,
    get: function() {
        return $11XkW.convertStringToHex;
    }
});

var $d0XAs = parcelRequire("d0XAs");
Object.defineProperty(module.exports, "rippleTimeToISOTime", {
    enumerable: true,
    get: function() {
        return $d0XAs.rippleTimeToISOTime;
    }
});
Object.defineProperty(module.exports, "isoTimeToRippleTime", {
    enumerable: true,
    get: function() {
        return $d0XAs.isoTimeToRippleTime;
    }
});
Object.defineProperty(module.exports, "rippleTimeToUnixTime", {
    enumerable: true,
    get: function() {
        return $d0XAs.rippleTimeToUnixTime;
    }
});
Object.defineProperty(module.exports, "unixTimeToRippleTime", {
    enumerable: true,
    get: function() {
        return $d0XAs.unixTimeToRippleTime;
    }
});

const $2d8bca2d8d041bec$var$verifyPaymentChannelClaim_1 = $2d8bca2d8d041bec$var$__importDefault((parcelRequire("5UhwR")));
module.exports.verifyPaymentChannelClaim = $2d8bca2d8d041bec$var$verifyPaymentChannelClaim_1.default;

var $iNnVr = parcelRequire("iNnVr");
Object.defineProperty(module.exports, "xrpToDrops", {
    enumerable: true,
    get: function() {
        return $iNnVr.xrpToDrops;
    }
});
Object.defineProperty(module.exports, "dropsToXrp", {
    enumerable: true,
    get: function() {
        return $iNnVr.dropsToXrp;
    }
});
function $2d8bca2d8d041bec$var$isValidSecret(secret) {
    try {
        (0, $cVkA1.deriveKeypair)(secret);
        return true;
    } catch (_err) {
        return false;
    }
}
module.exports.isValidSecret = $2d8bca2d8d041bec$var$isValidSecret;
function $2d8bca2d8d041bec$var$encode(object) {
    return (0, $eLMUD.encode)(object);
}
module.exports.encode = $2d8bca2d8d041bec$var$encode;
function $2d8bca2d8d041bec$var$encodeForSigning(object) {
    return (0, $eLMUD.encodeForSigning)(object);
}
module.exports.encodeForSigning = $2d8bca2d8d041bec$var$encodeForSigning;
function $2d8bca2d8d041bec$var$encodeForSigningClaim(object) {
    return (0, $eLMUD.encodeForSigningClaim)(object);
}
module.exports.encodeForSigningClaim = $2d8bca2d8d041bec$var$encodeForSigningClaim;
function $2d8bca2d8d041bec$var$encodeForMultiSigning(object, signer) {
    return (0, $eLMUD.encodeForMultisigning)(object, signer);
}
module.exports.encodeForMultiSigning = $2d8bca2d8d041bec$var$encodeForMultiSigning;
function $2d8bca2d8d041bec$var$decode(hex) {
    return (0, $eLMUD.decode)(hex);
}
module.exports.decode = $2d8bca2d8d041bec$var$decode;
function $2d8bca2d8d041bec$var$isValidAddress(address) {
    return (0, $7eC3g.isValidXAddress)(address) || (0, $7eC3g.isValidClassicAddress)(address);
}
module.exports.isValidAddress = $2d8bca2d8d041bec$var$isValidAddress;
function $2d8bca2d8d041bec$var$hasNextPage(response) {
    return Boolean(response.result['marker']);
}
module.exports.hasNextPage = $2d8bca2d8d041bec$var$hasNextPage;
const $2d8bca2d8d041bec$var$hashes = {
    hashSignedTx: $2OCHQ.hashSignedTx,
    hashTx: $2OCHQ.hashTx,
    hashAccountRoot: $2OCHQ.hashAccountRoot,
    hashSignerListId: $2OCHQ.hashSignerListId,
    hashOfferId: $2OCHQ.hashOfferId,
    hashTrustline: $2OCHQ.hashTrustline,
    hashTxTree: $2OCHQ.hashTxTree,
    hashStateTree: $2OCHQ.hashStateTree,
    hashLedger: $2OCHQ.hashLedger,
    hashLedgerHeader: $2OCHQ.hashLedgerHeader,
    hashEscrow: $2OCHQ.hashEscrow,
    hashPaymentChannel: $2OCHQ.hashPaymentChannel
};
module.exports.hashes = $2d8bca2d8d041bec$var$hashes;

});
parcelRegister("cYPJw", function(module, exports) {
"use strict";
var $973337c60c4c3b9a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeSeed = module.exports.deriveNodeAddress = module.exports.deriveAddress = module.exports.verify = module.exports.sign = module.exports.deriveKeypair = module.exports.generateSeed = void 0;

var $j61ah = parcelRequire("j61ah");
Object.defineProperty(module.exports, "decodeSeed", {
    enumerable: true,
    get: function() {
        return $j61ah.decodeSeed;
    }
});

var $lzSwC = parcelRequire("lzSwC");

var $eWnEn = parcelRequire("eWnEn");

var $8wxDW = parcelRequire("8wxDW");

var $pMfhq = parcelRequire("pMfhq");

const $973337c60c4c3b9a$var$Sha512_1 = $973337c60c4c3b9a$var$__importDefault((parcelRequire("iAcVK")));

const $973337c60c4c3b9a$var$assert_1 = $973337c60c4c3b9a$var$__importDefault((parcelRequire("Zccmt")));

var $gLV4U = parcelRequire("gLV4U");

const $973337c60c4c3b9a$var$secp256k1_1 = $973337c60c4c3b9a$var$__importDefault((parcelRequire("6UdLC")));

const $973337c60c4c3b9a$var$ed25519_1 = $973337c60c4c3b9a$var$__importDefault((parcelRequire("ePkUq")));
function $973337c60c4c3b9a$var$getSigningScheme(algorithm) {
    const schemes = {
        'ecdsa-secp256k1': $973337c60c4c3b9a$var$secp256k1_1.default,
        ed25519: $973337c60c4c3b9a$var$ed25519_1.default
    };
    return schemes[algorithm];
}
function $973337c60c4c3b9a$var$generateSeed(options = {}) {
    $973337c60c4c3b9a$var$assert_1.default.ok(!options.entropy || options.entropy.length >= 16, 'entropy too short');
    const entropy = options.entropy ? options.entropy.slice(0, 16) : (0, $8wxDW.randomBytes)(16);
    const type = options.algorithm === 'ed25519' ? 'ed25519' : 'secp256k1';
    return (0, $j61ah.encodeSeed)(entropy, type);
}
module.exports.generateSeed = $973337c60c4c3b9a$var$generateSeed;
function $973337c60c4c3b9a$var$deriveKeypair(seed, options) {
    var _a;
    const decoded = (0, $j61ah.decodeSeed)(seed);
    const proposedAlgorithm = (_a = options === null || options === void 0 ? void 0 : options.algorithm) !== null && _a !== void 0 ? _a : decoded.type;
    const algorithm = proposedAlgorithm === 'ed25519' ? 'ed25519' : 'ecdsa-secp256k1';
    const scheme = $973337c60c4c3b9a$var$getSigningScheme(algorithm);
    const keypair = scheme.deriveKeypair(decoded.bytes, options);
    const messageToVerify = $973337c60c4c3b9a$var$Sha512_1.default.half('This test message should verify.');
    const signature = scheme.sign(messageToVerify, keypair.privateKey);
    /* istanbul ignore if */ if (!scheme.verify(messageToVerify, signature, keypair.publicKey)) throw new Error('derived keypair did not generate verifiable signature');
    return keypair;
}
module.exports.deriveKeypair = $973337c60c4c3b9a$var$deriveKeypair;
function $973337c60c4c3b9a$var$sign(messageHex, privateKey) {
    const algorithm = (0, $gLV4U.getAlgorithmFromPrivateKey)(privateKey);
    return $973337c60c4c3b9a$var$getSigningScheme(algorithm).sign((0, $8wxDW.hexToBytes)(messageHex), privateKey);
}
module.exports.sign = $973337c60c4c3b9a$var$sign;
function $973337c60c4c3b9a$var$verify(messageHex, signature, publicKey) {
    const algorithm = (0, $gLV4U.getAlgorithmFromPublicKey)(publicKey);
    return $973337c60c4c3b9a$var$getSigningScheme(algorithm).verify((0, $8wxDW.hexToBytes)(messageHex), signature, publicKey);
}
module.exports.verify = $973337c60c4c3b9a$var$verify;
function $973337c60c4c3b9a$var$computePublicKeyHash(publicKeyBytes) {
    return (0, $lzSwC.ripemd160)((0, $eWnEn.sha256)(publicKeyBytes));
}
function $973337c60c4c3b9a$var$deriveAddressFromBytes(publicKeyBytes) {
    return (0, $j61ah.encodeAccountID)($973337c60c4c3b9a$var$computePublicKeyHash(publicKeyBytes));
}
function $973337c60c4c3b9a$var$deriveAddress(publicKey) {
    return $973337c60c4c3b9a$var$deriveAddressFromBytes((0, $8wxDW.hexToBytes)(publicKey));
}
module.exports.deriveAddress = $973337c60c4c3b9a$var$deriveAddress;
function $973337c60c4c3b9a$var$deriveNodeAddress(publicKey) {
    const generatorBytes = (0, $j61ah.decodeNodePublic)(publicKey);
    const accountPublicBytes = (0, $pMfhq.accountPublicFromPublicGenerator)(generatorBytes);
    return $973337c60c4c3b9a$var$deriveAddressFromBytes(accountPublicBytes);
}
module.exports.deriveNodeAddress = $973337c60c4c3b9a$var$deriveNodeAddress;

});
parcelRegister("j61ah", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidXAddress = module.exports.decodeXAddress = module.exports.xAddressToClassicAddress = module.exports.encodeXAddress = module.exports.classicAddressToXAddress = module.exports.isValidClassicAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.decodeNodePublic = module.exports.encodeNodePublic = module.exports.decodeAccountID = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.codec = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $9XNHT = parcelRequire("9XNHT");
Object.defineProperty(module.exports, "codec", {
    enumerable: true,
    get: function() {
        return $9XNHT.codec;
    }
});
Object.defineProperty(module.exports, "encodeSeed", {
    enumerable: true,
    get: function() {
        return $9XNHT.encodeSeed;
    }
});
Object.defineProperty(module.exports, "decodeSeed", {
    enumerable: true,
    get: function() {
        return $9XNHT.decodeSeed;
    }
});
Object.defineProperty(module.exports, "encodeAccountID", {
    enumerable: true,
    get: function() {
        return $9XNHT.encodeAccountID;
    }
});
Object.defineProperty(module.exports, "decodeAccountID", {
    enumerable: true,
    get: function() {
        return $9XNHT.decodeAccountID;
    }
});
Object.defineProperty(module.exports, "encodeNodePublic", {
    enumerable: true,
    get: function() {
        return $9XNHT.encodeNodePublic;
    }
});
Object.defineProperty(module.exports, "decodeNodePublic", {
    enumerable: true,
    get: function() {
        return $9XNHT.decodeNodePublic;
    }
});
Object.defineProperty(module.exports, "encodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $9XNHT.encodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "decodeAccountPublic", {
    enumerable: true,
    get: function() {
        return $9XNHT.decodeAccountPublic;
    }
});
Object.defineProperty(module.exports, "isValidClassicAddress", {
    enumerable: true,
    get: function() {
        return $9XNHT.isValidClassicAddress;
    }
});
const $de6f7b2a648b80c7$var$PREFIX_BYTES = {
    // 5, 68
    main: Uint8Array.from([
        0x05,
        0x44
    ]),
    // 4, 147
    test: Uint8Array.from([
        0x04,
        0x93
    ])
};
const $de6f7b2a648b80c7$var$MAX_32_BIT_UNSIGNED_INT = 4294967295;
function $de6f7b2a648b80c7$var$classicAddressToXAddress(classicAddress, tag, test) {
    const accountId = (0, $9XNHT.decodeAccountID)(classicAddress);
    return $de6f7b2a648b80c7$var$encodeXAddress(accountId, tag, test);
}
module.exports.classicAddressToXAddress = $de6f7b2a648b80c7$var$classicAddressToXAddress;
function $de6f7b2a648b80c7$var$encodeXAddress(accountId, tag, test) {
    if (accountId.length !== 20) // RIPEMD160 is 160 bits = 20 bytes
    throw new Error('Account ID must be 20 bytes');
    if (tag !== false && tag > $de6f7b2a648b80c7$var$MAX_32_BIT_UNSIGNED_INT) throw new Error('Invalid tag');
    const theTag = tag || 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Passing null is a common js mistake
    const flag = tag === false || tag == null ? 0 : 1;
    /* eslint-disable no-bitwise ---
     * need to use bitwise operations here */ const bytes = (0, $8wxDW.concat)([
        test ? $de6f7b2a648b80c7$var$PREFIX_BYTES.test : $de6f7b2a648b80c7$var$PREFIX_BYTES.main,
        accountId,
        Uint8Array.from([
            // 0x00 if no tag, 0x01 if 32-bit tag
            flag,
            // first byte
            theTag & 0xff,
            // second byte
            theTag >> 8 & 0xff,
            // third byte
            theTag >> 16 & 0xff,
            // fourth byte
            theTag >> 24 & 0xff,
            0,
            0,
            0,
            // four zero bytes (reserved for 64-bit tags)
            0
        ])
    ]);
    /* eslint-enable no-bitwise */ return $9XNHT.codec.encodeChecked(bytes);
}
module.exports.encodeXAddress = $de6f7b2a648b80c7$var$encodeXAddress;
function $de6f7b2a648b80c7$var$xAddressToClassicAddress(xAddress) {
    /* eslint-disable @typescript-eslint/naming-convention --
     * TODO 'test' should be something like 'isTest', do this later
     */ const { accountId: accountId, tag: tag, test: test } = $de6f7b2a648b80c7$var$decodeXAddress(xAddress);
    /* eslint-enable @typescript-eslint/naming-convention */ const classicAddress = (0, $9XNHT.encodeAccountID)(accountId);
    return {
        classicAddress: classicAddress,
        tag: tag,
        test: test
    };
}
module.exports.xAddressToClassicAddress = $de6f7b2a648b80c7$var$xAddressToClassicAddress;
function $de6f7b2a648b80c7$var$decodeXAddress(xAddress) {
    const decoded = $9XNHT.codec.decodeChecked(xAddress);
    /* eslint-disable @typescript-eslint/naming-convention --
     * TODO 'test' should be something like 'isTest', do this later
     */ const test = $de6f7b2a648b80c7$var$isUint8ArrayForTestAddress(decoded);
    /* eslint-enable @typescript-eslint/naming-convention */ const accountId = decoded.slice(2, 22);
    const tag = $de6f7b2a648b80c7$var$tagFromUint8Array(decoded);
    return {
        accountId: accountId,
        tag: tag,
        test: test
    };
}
module.exports.decodeXAddress = $de6f7b2a648b80c7$var$decodeXAddress;
function $de6f7b2a648b80c7$var$isUint8ArrayForTestAddress(buf) {
    const decodedPrefix = buf.slice(0, 2);
    if ((0, $8wxDW.equal)($de6f7b2a648b80c7$var$PREFIX_BYTES.main, decodedPrefix)) return false;
    if ((0, $8wxDW.equal)($de6f7b2a648b80c7$var$PREFIX_BYTES.test, decodedPrefix)) return true;
    throw new Error('Invalid X-address: bad prefix');
}
function $de6f7b2a648b80c7$var$tagFromUint8Array(buf) {
    const flag = buf[22];
    if (flag >= 2) // No support for 64-bit tags at this time
    throw new Error('Unsupported X-address');
    if (flag === 1) // Little-endian to big-endian
    return buf[23] + buf[24] * 0x100 + buf[25] * 0x10000 + buf[26] * 0x1000000;
    if (flag !== 0) throw new Error('flag must be zero to indicate no tag');
    if (!(0, $8wxDW.equal)((0, $8wxDW.hexToBytes)('0000000000000000'), buf.slice(23, 31))) throw new Error('remaining bytes must be zero');
    return false;
}
function $de6f7b2a648b80c7$var$isValidXAddress(xAddress) {
    try {
        $de6f7b2a648b80c7$var$decodeXAddress(xAddress);
    } catch (_error) {
        return false;
    }
    return true;
}
module.exports.isValidXAddress = $de6f7b2a648b80c7$var$isValidXAddress;

});
parcelRegister("9XNHT", function(module, exports) {
"use strict";
/**
 * Codec class
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidClassicAddress = module.exports.decodeAccountPublic = module.exports.encodeAccountPublic = module.exports.encodeNodePublic = module.exports.decodeNodePublic = module.exports.decodeAddress = module.exports.decodeAccountID = module.exports.encodeAddress = module.exports.encodeAccountID = module.exports.decodeSeed = module.exports.encodeSeed = module.exports.codec = void 0;

var $3ctkB = parcelRequire("3ctkB");

var $eWnEn = parcelRequire("eWnEn");

var $cYx2y = parcelRequire("cYx2y");
class $74102e87d41597ca$var$Codec {
    constructor(options){
        this._sha256 = options.sha256;
        this._codec = $3ctkB.base58xrp;
    }
    /**
     * Encoder.
     *
     * @param bytes - Uint8Array of data to encode.
     * @param opts - Options object including the version bytes and the expected length of the data to encode.
     */ encode(bytes, opts) {
        const versions = opts.versions;
        return this._encodeVersioned(bytes, versions, opts.expectedLength);
    }
    /**
     * Decoder.
     *
     * @param base58string - Base58Check-encoded string to decode.
     * @param opts - Options object including the version byte(s) and the expected length of the data after decoding.
     */ /* eslint-disable max-lines-per-function --
     * TODO refactor */ decode(base58string, opts) {
        var _a;
        const versions = opts.versions;
        const types = opts.versionTypes;
        const withoutSum = this.decodeChecked(base58string);
        if (versions.length > 1 && !opts.expectedLength) throw new Error('expectedLength is required because there are >= 2 possible versions');
        const versionLengthGuess = typeof versions[0] === 'number' ? 1 : versions[0].length;
        const payloadLength = (_a = opts.expectedLength) !== null && _a !== void 0 ? _a : withoutSum.length - versionLengthGuess;
        const versionBytes = withoutSum.slice(0, -payloadLength);
        const payload = withoutSum.slice(-payloadLength);
        for(let i = 0; i < versions.length; i++){
            /* eslint-disable @typescript-eslint/consistent-type-assertions --
             * TODO refactor */ const version = Array.isArray(versions[i]) ? versions[i] : [
                versions[i]
            ];
            if ((0, $cYx2y.arrayEqual)(versionBytes, version)) return {
                version: version,
                bytes: payload,
                type: types ? types[i] : null
            };
        /* eslint-enable @typescript-eslint/consistent-type-assertions */ }
        throw new Error('version_invalid: version bytes do not match any of the provided version(s)');
    }
    encodeChecked(bytes) {
        const check = this._sha256(this._sha256(bytes)).slice(0, 4);
        return this._encodeRaw(Uint8Array.from((0, $cYx2y.concatArgs)(bytes, check)));
    }
    decodeChecked(base58string) {
        const intArray = this._decodeRaw(base58string);
        if (intArray.byteLength < 5) throw new Error('invalid_input_size: decoded data must have length >= 5');
        if (!this._verifyCheckSum(intArray)) throw new Error('checksum_invalid');
        return intArray.slice(0, -4);
    }
    _encodeVersioned(bytes, versions, expectedLength) {
        if (!$74102e87d41597ca$var$checkByteLength(bytes, expectedLength)) throw new Error("unexpected_payload_length: bytes.length does not match expectedLength. Ensure that the bytes are a Uint8Array.");
        return this.encodeChecked((0, $cYx2y.concatArgs)(versions, bytes));
    }
    _encodeRaw(bytes) {
        return this._codec.encode(Uint8Array.from(bytes));
    }
    /* eslint-enable max-lines-per-function */ _decodeRaw(base58string) {
        return this._codec.decode(base58string);
    }
    _verifyCheckSum(bytes) {
        const computed = this._sha256(this._sha256(bytes.slice(0, -4))).slice(0, 4);
        const checksum = bytes.slice(-4);
        return (0, $cYx2y.arrayEqual)(computed, checksum);
    }
}
/**
 * XRP codec
 */ // base58 encodings: https://xrpl.org/base58-encodings.html
// Account address (20 bytes)
const $74102e87d41597ca$var$ACCOUNT_ID = 0;
// Account public key (33 bytes)
const $74102e87d41597ca$var$ACCOUNT_PUBLIC_KEY = 0x23;
// 33; Seed value (for secret keys) (16 bytes)
const $74102e87d41597ca$var$FAMILY_SEED = 0x21;
// 28; Validation public key (33 bytes)
const $74102e87d41597ca$var$NODE_PUBLIC = 0x1c;
// [1, 225, 75]
const $74102e87d41597ca$var$ED25519_SEED = [
    0x01,
    0xe1,
    0x4b
];
const $74102e87d41597ca$var$codecOptions = {
    sha256: $eWnEn.sha256
};
const $74102e87d41597ca$var$codecWithXrpAlphabet = new $74102e87d41597ca$var$Codec($74102e87d41597ca$var$codecOptions);
module.exports.codec = $74102e87d41597ca$var$codecWithXrpAlphabet;
// entropy is a Uint8Array of size 16
// type is 'ed25519' or 'secp256k1'
function $74102e87d41597ca$var$encodeSeed(entropy, type) {
    if (!$74102e87d41597ca$var$checkByteLength(entropy, 16)) throw new Error('entropy must have length 16');
    const opts = {
        expectedLength: 16,
        // for secp256k1, use `FAMILY_SEED`
        versions: type === 'ed25519' ? $74102e87d41597ca$var$ED25519_SEED : [
            $74102e87d41597ca$var$FAMILY_SEED
        ]
    };
    // prefixes entropy with version bytes
    return $74102e87d41597ca$var$codecWithXrpAlphabet.encode(entropy, opts);
}
module.exports.encodeSeed = $74102e87d41597ca$var$encodeSeed;
function $74102e87d41597ca$var$decodeSeed(seed, opts = {
    versionTypes: [
        'ed25519',
        'secp256k1'
    ],
    versions: [
        $74102e87d41597ca$var$ED25519_SEED,
        $74102e87d41597ca$var$FAMILY_SEED
    ],
    expectedLength: 16
}) {
    return $74102e87d41597ca$var$codecWithXrpAlphabet.decode(seed, opts);
}
module.exports.decodeSeed = $74102e87d41597ca$var$decodeSeed;
function $74102e87d41597ca$var$encodeAccountID(bytes) {
    const opts = {
        versions: [
            $74102e87d41597ca$var$ACCOUNT_ID
        ],
        expectedLength: 20
    };
    return $74102e87d41597ca$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeAccountID = $74102e87d41597ca$var$encodeAccountID;
/* eslint-disable import/no-unused-modules ---
 * unclear why this is aliased but we should keep it in case someone else is
 * importing it with the aliased name */ module.exports.encodeAddress = $74102e87d41597ca$var$encodeAccountID;
/* eslint-enable import/no-unused-modules */ function $74102e87d41597ca$var$decodeAccountID(accountId) {
    const opts = {
        versions: [
            $74102e87d41597ca$var$ACCOUNT_ID
        ],
        expectedLength: 20
    };
    return $74102e87d41597ca$var$codecWithXrpAlphabet.decode(accountId, opts).bytes;
}
module.exports.decodeAccountID = $74102e87d41597ca$var$decodeAccountID;
/* eslint-disable import/no-unused-modules ---
 * unclear why this is aliased but we should keep it in case someone else is
 * importing it with the aliased name */ module.exports.decodeAddress = $74102e87d41597ca$var$decodeAccountID;
/* eslint-enable import/no-unused-modules */ function $74102e87d41597ca$var$decodeNodePublic(base58string) {
    const opts = {
        versions: [
            $74102e87d41597ca$var$NODE_PUBLIC
        ],
        expectedLength: 33
    };
    return $74102e87d41597ca$var$codecWithXrpAlphabet.decode(base58string, opts).bytes;
}
module.exports.decodeNodePublic = $74102e87d41597ca$var$decodeNodePublic;
function $74102e87d41597ca$var$encodeNodePublic(bytes) {
    const opts = {
        versions: [
            $74102e87d41597ca$var$NODE_PUBLIC
        ],
        expectedLength: 33
    };
    return $74102e87d41597ca$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeNodePublic = $74102e87d41597ca$var$encodeNodePublic;
function $74102e87d41597ca$var$encodeAccountPublic(bytes) {
    const opts = {
        versions: [
            $74102e87d41597ca$var$ACCOUNT_PUBLIC_KEY
        ],
        expectedLength: 33
    };
    return $74102e87d41597ca$var$codecWithXrpAlphabet.encode(bytes, opts);
}
module.exports.encodeAccountPublic = $74102e87d41597ca$var$encodeAccountPublic;
function $74102e87d41597ca$var$decodeAccountPublic(base58string) {
    const opts = {
        versions: [
            $74102e87d41597ca$var$ACCOUNT_PUBLIC_KEY
        ],
        expectedLength: 33
    };
    return $74102e87d41597ca$var$codecWithXrpAlphabet.decode(base58string, opts).bytes;
}
module.exports.decodeAccountPublic = $74102e87d41597ca$var$decodeAccountPublic;
function $74102e87d41597ca$var$isValidClassicAddress(address) {
    try {
        $74102e87d41597ca$var$decodeAccountID(address);
    } catch (_error) {
        return false;
    }
    return true;
}
module.exports.isValidClassicAddress = $74102e87d41597ca$var$isValidClassicAddress;
function $74102e87d41597ca$var$checkByteLength(bytes, expectedLength) {
    return 'byteLength' in bytes ? bytes.byteLength === expectedLength : bytes.length === expectedLength;
}

});
parcelRegister("cYx2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatArgs = module.exports.arrayEqual = void 0;
/**
 * Check whether two sequences (e.g. Arrays of numbers) are equal.
 *
 * @param arr1 - One of the arrays to compare.
 * @param arr2 - The other array to compare.
 */ function $9724b7bc96083894$var$arrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((value, index)=>value === arr2[index]);
}
module.exports.arrayEqual = $9724b7bc96083894$var$arrayEqual;
/**
 * Check whether a value is a scalar
 *
 * @param val - The value to check.
 */ function $9724b7bc96083894$var$isScalar(val) {
    return typeof val === 'number';
}
/**
 * Concatenate all `arguments` into a single array. Each argument can be either
 * a single element or a sequence, which has a `length` property and supports
 * element retrieval via sequence[ix].
 *
 * > concatArgs(1, [2, 3], Uint8Array.from([4,5]), new Uint8Array([6, 7]));
 * [1,2,3,4,5,6,7]
 *
 * @param args - Concatenate of these args into a single array.
 * @returns Array of concatenated arguments
 */ function $9724b7bc96083894$var$concatArgs(...args) {
    return args.flatMap((arg)=>{
        return $9724b7bc96083894$var$isScalar(arg) ? [
            arg
        ] : Array.from(arg);
    });
}
module.exports.concatArgs = $9724b7bc96083894$var$concatArgs;

});



parcelRegister("lzSwC", function(module, exports) {
"use strict";
var $fb57296a8e9d8389$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = void 0;

var $imJuD = parcelRequire("imJuD");

const $fb57296a8e9d8389$var$wrapNoble_1 = $fb57296a8e9d8389$var$__importDefault((parcelRequire("f8atV")));
/**
 * Wrap noble-libs's ripemd160 implementation in HashFn
 */ module.exports.ripemd160 = (0, $fb57296a8e9d8389$var$wrapNoble_1.default)($imJuD.ripemd160);

});
parcelRegister("imJuD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $ebEok = parcelRequire("ebEok");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $d5ed9209f009742a$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $d5ed9209f009742a$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $d5ed9209f009742a$var$Pi = /* @__PURE__ */ $d5ed9209f009742a$var$Id.map((i)=>(9 * i + 5) % 16);
let $d5ed9209f009742a$var$idxL = [
    $d5ed9209f009742a$var$Id
];
let $d5ed9209f009742a$var$idxR = [
    $d5ed9209f009742a$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $d5ed9209f009742a$var$idxL,
    $d5ed9209f009742a$var$idxR
])j.push(j[i].map((k)=>$d5ed9209f009742a$var$Rho[k]));
const $d5ed9209f009742a$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $d5ed9209f009742a$var$shiftsL = /* @__PURE__ */ $d5ed9209f009742a$var$idxL.map((idx, i)=>idx.map((j)=>$d5ed9209f009742a$var$shifts[i][j]));
const $d5ed9209f009742a$var$shiftsR = /* @__PURE__ */ $d5ed9209f009742a$var$idxR.map((idx, i)=>idx.map((j)=>$d5ed9209f009742a$var$shifts[i][j]));
const $d5ed9209f009742a$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $d5ed9209f009742a$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $d5ed9209f009742a$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $d5ed9209f009742a$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $d5ed9209f009742a$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $d5ed9209f009742a$var$RIPEMD160 extends $lQ6Zm.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$d5ed9209f009742a$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $d5ed9209f009742a$var$Kl[group], hbr = $d5ed9209f009742a$var$Kr[group]; // prettier-ignore
            const rl = $d5ed9209f009742a$var$idxL[group], rr = $d5ed9209f009742a$var$idxR[group]; // prettier-ignore
            const sl = $d5ed9209f009742a$var$shiftsL[group], sr = $d5ed9209f009742a$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $d5ed9209f009742a$var$rotl(al + $d5ed9209f009742a$var$f(group, bl, cl, dl) + $d5ed9209f009742a$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $d5ed9209f009742a$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $d5ed9209f009742a$var$rotl(ar + $d5ed9209f009742a$var$f(rGroup, br, cr, dr) + $d5ed9209f009742a$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $d5ed9209f009742a$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $d5ed9209f009742a$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $d5ed9209f009742a$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $ebEok.wrapConstructor)(()=>new $d5ed9209f009742a$var$RIPEMD160());

});


parcelRegister("pMfhq", function(module, exports) {
"use strict";
var $04d7c274c47fe9e9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accountPublicFromPublicGenerator = module.exports.derivePrivateKey = void 0;

var $ldlsU = parcelRequire("ldlsU");

const $04d7c274c47fe9e9$var$Sha512_1 = $04d7c274c47fe9e9$var$__importDefault((parcelRequire("iAcVK")));
const $04d7c274c47fe9e9$var$ZERO = BigInt(0);
function $04d7c274c47fe9e9$var$deriveScalar(bytes, discrim) {
    const order = $ldlsU.secp256k1.CURVE.n;
    for(let i = 0; i <= 4294967295; i++){
        // We hash the bytes to find a 256-bit number, looping until we are sure it
        // is less than the order of the curve.
        const hasher = new $04d7c274c47fe9e9$var$Sha512_1.default().add(bytes);
        // If the optional discriminator index was passed in, update the hash.
        if (discrim !== undefined) hasher.addU32(discrim);
        hasher.addU32(i);
        const key = hasher.first256BigInt();
        /* istanbul ignore else */ if (key > $04d7c274c47fe9e9$var$ZERO && key < order) return key;
    }
    // This error is practically impossible to reach.
    // The order of the curve describes the (finite) amount of points on the curve
    // https://github.com/indutny/elliptic/blob/master/lib/elliptic/curves.js#L182
    // How often will an (essentially) random number generated by Sha512 be larger than that?
    // There's 2^32 chances (the for loop) to get a number smaller than the order,
    // and it's rare that you'll even get past the first loop iteration.
    // Note that in TypeScript we actually need the throw, otherwise the function signature would be bigint | undefined
    //
    /* istanbul ignore next */ throw new Error('impossible unicorn ;)');
}
/**
 * @param seed - Bytes.
 * @param [opts] - Object.
 * @param [opts.accountIndex=0] - The account number to generate.
 * @param [opts.validator=false] - Generate root key-pair,
 *                                              as used by validators.
 * @returns {bigint} 256 bit scalar value.
 *
 */ function $04d7c274c47fe9e9$var$derivePrivateKey(seed, opts = {}) {
    const root = opts.validator;
    const order = $ldlsU.secp256k1.CURVE.n;
    // This private generator represents the `root` private key, and is what's
    // used by validators for signing when a keypair is generated from a seed.
    const privateGen = $04d7c274c47fe9e9$var$deriveScalar(seed);
    if (root) // As returned by validation_create for a given seed
    return privateGen;
    const publicGen = $ldlsU.secp256k1.ProjectivePoint.BASE.multiply(privateGen).toRawBytes(true);
    // A seed can generate many keypairs as a function of the seed and a uint32.
    // Almost everyone just uses the first account, `0`.
    const accountIndex = opts.accountIndex || 0;
    return ($04d7c274c47fe9e9$var$deriveScalar(publicGen, accountIndex) + privateGen) % order;
}
module.exports.derivePrivateKey = $04d7c274c47fe9e9$var$derivePrivateKey;
function $04d7c274c47fe9e9$var$accountPublicFromPublicGenerator(publicGenBytes) {
    const rootPubPoint = $ldlsU.secp256k1.ProjectivePoint.fromHex(publicGenBytes);
    const scalar = $04d7c274c47fe9e9$var$deriveScalar(publicGenBytes, 0);
    const point = $ldlsU.secp256k1.ProjectivePoint.BASE.multiply(scalar);
    const offset = rootPubPoint.add(point);
    return offset.toRawBytes(true);
}
module.exports.accountPublicFromPublicGenerator = $04d7c274c47fe9e9$var$accountPublicFromPublicGenerator;

});
parcelRegister("ldlsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $khc1u = parcelRequire("khc1u");

var $5BLEh = parcelRequire("5BLEh");

var $4Bgxn = parcelRequire("4Bgxn");

var $2ZUl0 = parcelRequire("2ZUl0");

var $ceIYS = parcelRequire("ceIYS");

var $to2Dk = parcelRequire("to2Dk");

var $4q2Ml = parcelRequire("4q2Ml");
const $f71b7672c2f759ff$var$secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
const $f71b7672c2f759ff$var$secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
const $f71b7672c2f759ff$var$_1n = BigInt(1);
const $f71b7672c2f759ff$var$_2n = BigInt(2);
const $f71b7672c2f759ff$var$divNearest = (a, b)=>(a + b / $f71b7672c2f759ff$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $f71b7672c2f759ff$var$sqrtMod(y) {
    const P = $f71b7672c2f759ff$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $ceIYS.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $ceIYS.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $ceIYS.pow2)(b9, $f71b7672c2f759ff$var$_2n, P) * b2 % P;
    const b22 = (0, $ceIYS.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $ceIYS.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $ceIYS.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $ceIYS.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $ceIYS.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $ceIYS.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $ceIYS.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $ceIYS.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $ceIYS.pow2)(t2, $f71b7672c2f759ff$var$_2n, P);
    if (!$f71b7672c2f759ff$var$Fpk1.eql($f71b7672c2f759ff$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $f71b7672c2f759ff$var$Fpk1 = (0, $ceIYS.Field)($f71b7672c2f759ff$var$secp256k1P, undefined, undefined, {
    sqrt: $f71b7672c2f759ff$var$sqrtMod
});
/**
 * secp256k1 short weierstrass curve and ECDSA signatures over it.
 *
 * @example
 * import { secp256k1 } from '@noble/curves/secp256k1';
 *
 * const priv = secp256k1.utils.randomPrivateKey();
 * const pub = secp256k1.getPublicKey(priv);
 * const msg = new Uint8Array(32).fill(1); // message hash (not message) in ecdsa
 * const sig = secp256k1.sign(msg, priv); // `{prehash: true}` option is available
 * const isValid = secp256k1.verify(sig, msg, pub) === true;
 */ module.exports.secp256k1 = (0, $4Bgxn.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $f71b7672c2f759ff$var$Fpk1,
    n: $f71b7672c2f759ff$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    endo: {
        // Endomorphism, see above
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: (k)=>{
            const n = $f71b7672c2f759ff$var$secp256k1N;
            const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            const b1 = -$f71b7672c2f759ff$var$_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            const b2 = a1;
            const POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            const c1 = $f71b7672c2f759ff$var$divNearest(b2 * k, n);
            const c2 = $f71b7672c2f759ff$var$divNearest(-b1 * k, n);
            let k1 = (0, $ceIYS.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $ceIYS.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error('splitScalar: Endomorphism failed, k=' + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $khc1u.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $f71b7672c2f759ff$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $f71b7672c2f759ff$var$TAGGED_HASH_PREFIXES = {};
function $f71b7672c2f759ff$var$taggedHash(tag, ...messages) {
    let tagP = $f71b7672c2f759ff$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $khc1u.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $to2Dk.concatBytes)(tagH, tagH);
        $f71b7672c2f759ff$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $khc1u.sha256)((0, $to2Dk.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $f71b7672c2f759ff$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $f71b7672c2f759ff$var$numTo32b = (n)=>(0, $to2Dk.numberToBytesBE)(n, 32);
const $f71b7672c2f759ff$var$modP = (x)=>(0, $ceIYS.mod)(x, $f71b7672c2f759ff$var$secp256k1P);
const $f71b7672c2f759ff$var$modN = (x)=>(0, $ceIYS.mod)(x, $f71b7672c2f759ff$var$secp256k1N);
const $f71b7672c2f759ff$var$Point = module.exports.secp256k1.ProjectivePoint;
const $f71b7672c2f759ff$var$GmulAdd = (Q, a, b)=>$f71b7672c2f759ff$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $f71b7672c2f759ff$var$schnorrGetExtPubKey(priv) {
    let d_ = module.exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $f71b7672c2f759ff$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $f71b7672c2f759ff$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $f71b7672c2f759ff$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $f71b7672c2f759ff$var$lift_x(x) {
    (0, $to2Dk.aInRange)('x', x, $f71b7672c2f759ff$var$_1n, $f71b7672c2f759ff$var$secp256k1P); // Fail if x ≥ p.
    const xx = $f71b7672c2f759ff$var$modP(x * x);
    const c = $f71b7672c2f759ff$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $f71b7672c2f759ff$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $f71b7672c2f759ff$var$_2n !== $f71b7672c2f759ff$var$_0n) y = $f71b7672c2f759ff$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $f71b7672c2f759ff$var$Point(x, y, $f71b7672c2f759ff$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $f71b7672c2f759ff$var$num = $to2Dk.bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $f71b7672c2f759ff$var$challenge(...args) {
    return $f71b7672c2f759ff$var$modN($f71b7672c2f759ff$var$num($f71b7672c2f759ff$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $f71b7672c2f759ff$var$schnorrGetPublicKey(privateKey) {
    return $f71b7672c2f759ff$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $f71b7672c2f759ff$var$schnorrSign(message, privateKey, auxRand = (0, $5BLEh.randomBytes)(32)) {
    const m = (0, $to2Dk.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = $f71b7672c2f759ff$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $to2Dk.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $f71b7672c2f759ff$var$numTo32b(d ^ $f71b7672c2f759ff$var$num($f71b7672c2f759ff$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $f71b7672c2f759ff$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $f71b7672c2f759ff$var$modN($f71b7672c2f759ff$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $f71b7672c2f759ff$var$_0n) throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $f71b7672c2f759ff$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $f71b7672c2f759ff$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($f71b7672c2f759ff$var$numTo32b($f71b7672c2f759ff$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$f71b7672c2f759ff$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $f71b7672c2f759ff$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $to2Dk.ensureBytes)('signature', signature, 64);
    const m = (0, $to2Dk.ensureBytes)('message', message);
    const pub = (0, $to2Dk.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = $f71b7672c2f759ff$var$lift_x($f71b7672c2f759ff$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $f71b7672c2f759ff$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $to2Dk.inRange)(r, $f71b7672c2f759ff$var$_1n, $f71b7672c2f759ff$var$secp256k1P)) return false;
        const s = $f71b7672c2f759ff$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $to2Dk.inRange)(s, $f71b7672c2f759ff$var$_1n, $f71b7672c2f759ff$var$secp256k1N)) return false;
        const e = $f71b7672c2f759ff$var$challenge($f71b7672c2f759ff$var$numTo32b(r), $f71b7672c2f759ff$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $f71b7672c2f759ff$var$GmulAdd(P, s, $f71b7672c2f759ff$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 * https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
 * @example
 * import { schnorr } from '@noble/curves/secp256k1';
 * const priv = schnorr.utils.randomPrivateKey();
 * const pub = schnorr.getPublicKey(priv);
 * const msg = new TextEncoder().encode('hello');
 * const sig = schnorr.sign(msg, priv);
 * const isValid = schnorr.verify(sig, msg, pub);
 */ module.exports.schnorr = (()=>({
        getPublicKey: $f71b7672c2f759ff$var$schnorrGetPublicKey,
        sign: $f71b7672c2f759ff$var$schnorrSign,
        verify: $f71b7672c2f759ff$var$schnorrVerify,
        utils: {
            randomPrivateKey: module.exports.secp256k1.utils.randomPrivateKey,
            lift_x: $f71b7672c2f759ff$var$lift_x,
            pointToBytes: $f71b7672c2f759ff$var$pointToBytes,
            numberToBytesBE: $to2Dk.numberToBytesBE,
            bytesToNumberBE: $to2Dk.bytesToNumberBE,
            taggedHash: $f71b7672c2f759ff$var$taggedHash,
            mod: $ceIYS.mod
        }
    }))();
const $f71b7672c2f759ff$var$isoMap = /* @__PURE__ */ (()=>(0, $2ZUl0.isogenyMap)($f71b7672c2f759ff$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $f71b7672c2f759ff$var$mapSWU = /* @__PURE__ */ (()=>(0, $4q2Ml.mapToCurveSimpleSWU)($f71b7672c2f759ff$var$Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $f71b7672c2f759ff$var$Fpk1.create(BigInt('-11'))
    }))();
const $f71b7672c2f759ff$var$htf = /* @__PURE__ */ (()=>(0, $2ZUl0.createHasher)(module.exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $f71b7672c2f759ff$var$mapSWU($f71b7672c2f759ff$var$Fpk1.create(scalars[0]));
        return $f71b7672c2f759ff$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $f71b7672c2f759ff$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: $khc1u.sha256
    }))();
/** secp256k1 hash-to-curve from [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380). */ module.exports.hashToCurve = (()=>$f71b7672c2f759ff$var$htf.hashToCurve)();
/** secp256k1 encode-to-curve from [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380). */ module.exports.encodeToCurve = (()=>$f71b7672c2f759ff$var$htf.encodeToCurve)();

});
parcelRegister("khc1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = module.exports.SHA256 = void 0;

var $b7irD = parcelRequire("b7irD");

var $5BLEh = parcelRequire("5BLEh");
/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $ec2eb8b312a3e8ba$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $ec2eb8b312a3e8ba$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $ec2eb8b312a3e8ba$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $ec2eb8b312a3e8ba$var$SHA256 extends $b7irD.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $ec2eb8b312a3e8ba$var$SHA256_IV[0] | 0;
        this.B = $ec2eb8b312a3e8ba$var$SHA256_IV[1] | 0;
        this.C = $ec2eb8b312a3e8ba$var$SHA256_IV[2] | 0;
        this.D = $ec2eb8b312a3e8ba$var$SHA256_IV[3] | 0;
        this.E = $ec2eb8b312a3e8ba$var$SHA256_IV[4] | 0;
        this.F = $ec2eb8b312a3e8ba$var$SHA256_IV[5] | 0;
        this.G = $ec2eb8b312a3e8ba$var$SHA256_IV[6] | 0;
        this.H = $ec2eb8b312a3e8ba$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$ec2eb8b312a3e8ba$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $ec2eb8b312a3e8ba$var$SHA256_W[i - 15];
            const W2 = $ec2eb8b312a3e8ba$var$SHA256_W[i - 2];
            const s0 = (0, $5BLEh.rotr)(W15, 7) ^ (0, $5BLEh.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $5BLEh.rotr)(W2, 17) ^ (0, $5BLEh.rotr)(W2, 19) ^ W2 >>> 10;
            $ec2eb8b312a3e8ba$var$SHA256_W[i] = s1 + $ec2eb8b312a3e8ba$var$SHA256_W[i - 7] + s0 + $ec2eb8b312a3e8ba$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $5BLEh.rotr)(E, 6) ^ (0, $5BLEh.rotr)(E, 11) ^ (0, $5BLEh.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $b7irD.Chi)(E, F, G) + $ec2eb8b312a3e8ba$var$SHA256_K[i] + $ec2eb8b312a3e8ba$var$SHA256_W[i] | 0;
            const sigma0 = (0, $5BLEh.rotr)(A, 2) ^ (0, $5BLEh.rotr)(A, 13) ^ (0, $5BLEh.rotr)(A, 22);
            const T2 = sigma0 + (0, $b7irD.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $ec2eb8b312a3e8ba$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
module.exports.SHA256 = $ec2eb8b312a3e8ba$var$SHA256;
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $ec2eb8b312a3e8ba$var$SHA224 extends $ec2eb8b312a3e8ba$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/** SHA2-256 hash function */ module.exports.sha256 = (0, $5BLEh.wrapConstructor)(()=>new $ec2eb8b312a3e8ba$var$SHA256());
/** SHA2-224 hash function */ module.exports.sha224 = (0, $5BLEh.wrapConstructor)(()=>new $ec2eb8b312a3e8ba$var$SHA224());

});
parcelRegister("b7irD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashMD = void 0;
module.exports.setBigUint64 = $817ea7e4111a3541$var$setBigUint64;
module.exports.Chi = $817ea7e4111a3541$var$Chi;
module.exports.Maj = $817ea7e4111a3541$var$Maj;

var $017Tx = parcelRequire("017Tx");

var $5BLEh = parcelRequire("5BLEh");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $817ea7e4111a3541$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $817ea7e4111a3541$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $817ea7e4111a3541$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $817ea7e4111a3541$var$HashMD extends $5BLEh.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $5BLEh.createView)(this.buffer);
    }
    update(data) {
        (0, $017Tx.aexists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $5BLEh.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $5BLEh.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $017Tx.aexists)(this);
        (0, $017Tx.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $817ea7e4111a3541$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $5BLEh.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.HashMD = $817ea7e4111a3541$var$HashMD;

});
parcelRegister("017Tx", function(module, exports) {
"use strict";
/**
 * Internal assertion helpers.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.anumber = $003637d6ac88e27a$var$anumber;
module.exports.abytes = $003637d6ac88e27a$var$abytes;
module.exports.ahash = $003637d6ac88e27a$var$ahash;
module.exports.aexists = $003637d6ac88e27a$var$aexists;
module.exports.aoutput = $003637d6ac88e27a$var$aoutput;
/** Asserts something is positive integer. */ function $003637d6ac88e27a$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $003637d6ac88e27a$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is Uint8Array. */ function $003637d6ac88e27a$var$abytes(b, ...lengths) {
    if (!$003637d6ac88e27a$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function $003637d6ac88e27a$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $003637d6ac88e27a$var$anumber(h.outputLen);
    $003637d6ac88e27a$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $003637d6ac88e27a$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $003637d6ac88e27a$var$aoutput(out, instance) {
    $003637d6ac88e27a$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}

});

parcelRegister("5BLEh", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = module.exports.nextTick = module.exports.byteSwapIfBE = module.exports.isLE = void 0;
module.exports.isBytes = $41555e82662edae4$var$isBytes;
module.exports.u8 = $41555e82662edae4$var$u8;
module.exports.u32 = $41555e82662edae4$var$u32;
module.exports.createView = $41555e82662edae4$var$createView;
module.exports.rotr = $41555e82662edae4$var$rotr;
module.exports.rotl = $41555e82662edae4$var$rotl;
module.exports.byteSwap = $41555e82662edae4$var$byteSwap;
module.exports.byteSwap32 = $41555e82662edae4$var$byteSwap32;
module.exports.bytesToHex = $41555e82662edae4$var$bytesToHex;
module.exports.hexToBytes = $41555e82662edae4$var$hexToBytes;
module.exports.asyncLoop = $41555e82662edae4$var$asyncLoop;
module.exports.utf8ToBytes = $41555e82662edae4$var$utf8ToBytes;
module.exports.toBytes = $41555e82662edae4$var$toBytes;
module.exports.concatBytes = $41555e82662edae4$var$concatBytes;
module.exports.checkOpts = $41555e82662edae4$var$checkOpts;
module.exports.wrapConstructor = $41555e82662edae4$var$wrapConstructor;
module.exports.wrapConstructorWithOpts = $41555e82662edae4$var$wrapConstructorWithOpts;
module.exports.wrapXOFConstructorWithOpts = $41555e82662edae4$var$wrapXOFConstructorWithOpts;
module.exports.randomBytes = $41555e82662edae4$var$randomBytes;

var $lu1rE = parcelRequire("lu1rE");

var $017Tx = parcelRequire("017Tx");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $41555e82662edae4$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
// Cast array to different type
function $41555e82662edae4$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $41555e82662edae4$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
// Cast array to view
function $41555e82662edae4$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $41555e82662edae4$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $41555e82662edae4$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// The byte swap operation for uint32
function $41555e82662edae4$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>$41555e82662edae4$var$byteSwap(n);
/** In place byte swap for Uint32Array */ function $41555e82662edae4$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $41555e82662edae4$var$byteSwap(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $41555e82662edae4$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $41555e82662edae4$var$bytesToHex(bytes) {
    (0, $017Tx.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $41555e82662edae4$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $41555e82662edae4$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $41555e82662edae4$var$asciiToBase16(ch) {
    if (ch >= $41555e82662edae4$var$asciis._0 && ch <= $41555e82662edae4$var$asciis._9) return ch - $41555e82662edae4$var$asciis._0; // '2' => 50-48
    if (ch >= $41555e82662edae4$var$asciis.A && ch <= $41555e82662edae4$var$asciis.F) return ch - ($41555e82662edae4$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $41555e82662edae4$var$asciis.a && ch <= $41555e82662edae4$var$asciis.f) return ch - ($41555e82662edae4$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $41555e82662edae4$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $41555e82662edae4$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $41555e82662edae4$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $41555e82662edae4$var$nextTick = async ()=>{};
module.exports.nextTick = $41555e82662edae4$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $41555e82662edae4$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * Convert JS string to byte array.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $41555e82662edae4$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('utf8ToBytes expected string, got ' + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $41555e82662edae4$var$toBytes(data) {
    if (typeof data === 'string') data = $41555e82662edae4$var$utf8ToBytes(data);
    (0, $017Tx.abytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $41555e82662edae4$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $017Tx.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** For runtime check if class implements interface */ class $41555e82662edae4$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $41555e82662edae4$var$Hash;
function $41555e82662edae4$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** Wraps hash function, creating an interface on top of it */ function $41555e82662edae4$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($41555e82662edae4$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $41555e82662edae4$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($41555e82662edae4$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $41555e82662edae4$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($41555e82662edae4$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $41555e82662edae4$var$randomBytes(bytesLength = 32) {
    if ($lu1rE.crypto && typeof $lu1rE.crypto.getRandomValues === 'function') return $lu1rE.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($lu1rE.crypto && typeof $lu1rE.crypto.randomBytes === 'function') return $lu1rE.crypto.randomBytes(bytesLength);
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("lu1rE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("4Bgxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getHash = $359772162e17b812$var$getHash;
module.exports.createCurve = $359772162e17b812$var$createCurve;

var $9PYVr = parcelRequire("9PYVr");

var $5BLEh = parcelRequire("5BLEh");

var $4q2Ml = parcelRequire("4q2Ml");
/** connects noble-curves to noble-hashes */ function $359772162e17b812$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $9PYVr.hmac)(hash, key, (0, $5BLEh.concatBytes)(...msgs)),
        randomBytes: $5BLEh.randomBytes
    };
}
function $359772162e17b812$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $4q2Ml.weierstrass)({
            ...curveDef,
            ...$359772162e17b812$var$getHash(hash)
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("9PYVr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $017Tx = parcelRequire("017Tx");

var $5BLEh = parcelRequire("5BLEh");
class $7298230817a2bbd7$var$HMAC extends $5BLEh.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $017Tx.ahash)(hash);
        const key = (0, $5BLEh.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $017Tx.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $017Tx.aexists)(this);
        (0, $017Tx.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $7298230817a2bbd7$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $7298230817a2bbd7$var$hmac = (hash, key, message)=>new $7298230817a2bbd7$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $7298230817a2bbd7$var$hmac;
module.exports.hmac.create = (hash, key)=>new $7298230817a2bbd7$var$HMAC(hash, key);

});

parcelRegister("4q2Ml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DER = module.exports.DERErr = void 0;
module.exports.weierstrassPoints = $337bbef37b0b9eaa$var$weierstrassPoints;
module.exports.weierstrass = $337bbef37b0b9eaa$var$weierstrass;
module.exports.SWUFpSqrtRatio = $337bbef37b0b9eaa$var$SWUFpSqrtRatio;
module.exports.mapToCurveSimpleSWU = $337bbef37b0b9eaa$var$mapToCurveSimpleSWU;

var $cXqn6 = parcelRequire("cXqn6");

var $ceIYS = parcelRequire("ceIYS");

var $to2Dk = parcelRequire("to2Dk");

var $to2Dk = parcelRequire("to2Dk");
function $337bbef37b0b9eaa$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $to2Dk.abool)('lowS', opts.lowS);
    if (opts.prehash !== undefined) (0, $to2Dk.abool)('prehash', opts.prehash);
}
function $337bbef37b0b9eaa$var$validatePointOpts(curve) {
    const opts = (0, $cXqn6.validateBasic)(curve);
    $to2Dk.validateObject(opts, {
        a: 'field',
        b: 'field'
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function'
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error('invalid endomorphism, can only be defined for Koblitz curves that have a=0');
        if (typeof endo !== 'object' || typeof endo.beta !== 'bigint' || typeof endo.splitScalar !== 'function') throw new Error('invalid endomorphism, expected beta: bigint and splitScalar: function');
    }
    return Object.freeze({
        ...opts
    });
}
const { bytesToNumberBE: $337bbef37b0b9eaa$var$b2n, hexToBytes: $337bbef37b0b9eaa$var$h2b } = $to2Dk;
class $337bbef37b0b9eaa$var$DERErr extends Error {
    constructor(m = ''){
        super(m);
    }
}
module.exports.DERErr = $337bbef37b0b9eaa$var$DERErr;
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */ module.exports.DER = {
    // asn.1 DER encoding utils
    Err: $337bbef37b0b9eaa$var$DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = module.exports.DER;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = $to2Dk.numberToHexUnpadded(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? $to2Dk.numberToHexUnpadded(len.length / 2 | 128) : '';
            const t = $to2Dk.numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = module.exports.DER;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = module.exports.DER;
            if (num < $337bbef37b0b9eaa$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = $to2Dk.numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = module.exports.DER;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return $337bbef37b0b9eaa$var$b2n(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = module.exports.DER;
        const data = typeof hex === 'string' ? $337bbef37b0b9eaa$var$h2b(hex) : hex;
        $to2Dk.abytes(data);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = module.exports.DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $337bbef37b0b9eaa$var$_0n = BigInt(0), $337bbef37b0b9eaa$var$_1n = BigInt(1), $337bbef37b0b9eaa$var$_2n = BigInt(2), $337bbef37b0b9eaa$var$_3n = BigInt(3), $337bbef37b0b9eaa$var$_4n = BigInt(4);
function $337bbef37b0b9eaa$var$weierstrassPoints(opts) {
    const CURVE = $337bbef37b0b9eaa$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = (0, $ceIYS.Field)(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $to2Dk.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $to2Dk.inRange(num, $337bbef37b0b9eaa$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== 'bigint') {
            if ($to2Dk.isBytes(key)) key = $to2Dk.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length)) throw new Error('invalid private key');
            key = key.padStart(nByteLength * 2, '0');
        }
        let num;
        try {
            num = typeof key === 'bigint' ? key : $to2Dk.bytesToNumberBE((0, $to2Dk.ensureBytes)('private key', key, nByteLength));
        } catch (error) {
            throw new Error('invalid private key, expected hex or ' + nByteLength + ' bytes, got ' + typeof key);
        }
        if (wrapPrivateKey) num = (0, $ceIYS.mod)(num, N); // disabled by default, enabled for BLS
        $to2Dk.aInRange('private key', num, $337bbef37b0b9eaa$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $to2Dk.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $to2Dk.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not FE');
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error('x required');
            if (py == null || !Fp.isValid(py)) throw new Error('y required');
            if (pz == null || !Fp.isValid(pz)) throw new Error('z required');
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $to2Dk.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $cXqn6.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $337bbef37b0b9eaa$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $337bbef37b0b9eaa$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo, n: N } = CURVE;
            $to2Dk.aInRange('scalar', sc, $337bbef37b0b9eaa$var$_0n, N);
            const I = Point.ZERO;
            if (sc === $337bbef37b0b9eaa$var$_0n) return I;
            if (this.is0() || sc === $337bbef37b0b9eaa$var$_1n) return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this)) return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $337bbef37b0b9eaa$var$_0n || k2 > $337bbef37b0b9eaa$var$_0n){
                if (k1 & $337bbef37b0b9eaa$var$_1n) k1p = k1p.add(d);
                if (k2 & $337bbef37b0b9eaa$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $337bbef37b0b9eaa$var$_1n;
                k2 >>= $337bbef37b0b9eaa$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $to2Dk.aInRange('scalar', scalar, $337bbef37b0b9eaa$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $337bbef37b0b9eaa$var$_0n || a === $337bbef37b0b9eaa$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $337bbef37b0b9eaa$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $337bbef37b0b9eaa$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $to2Dk.abool)('isCompressed', isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $to2Dk.abool)('isCompressed', isCompressed);
            return $to2Dk.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $cXqn6.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $337bbef37b0b9eaa$var$validateOpts(curve) {
    const opts = (0, $cXqn6.validateBasic)(curve);
    $to2Dk.validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function'
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean'
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
/**
 * Creates short weierstrass curve and ECDSA signature methods for it.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, b, p, n, Gx, Gy
 * const curve = weierstrass({ a, b, Fp: Field(p), n, Gx, Gy, h: 1n })
 */ function $337bbef37b0b9eaa$var$weierstrass(curveDef) {
    const CURVE = $337bbef37b0b9eaa$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return (0, $ceIYS.mod)(a, CURVE_ORDER);
    }
    function invN(a) {
        return (0, $ceIYS.invert)(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $337bbef37b0b9eaa$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $to2Dk.concatBytes;
            (0, $to2Dk.abool)('isCompressed', isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $to2Dk.bytesToNumberBE(tail);
                if (!$to2Dk.inRange(x, $337bbef37b0b9eaa$var$_1n, Fp.ORDER)) throw new Error('Point is not on curve');
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                    throw new Error('Point is not on curve' + suffix);
                }
                const isYOdd = (y & $337bbef37b0b9eaa$var$_1n) === $337bbef37b0b9eaa$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error('invalid Point, expected length of ' + cl + ', or uncompressed ' + ul + ', got ' + len);
            }
        }
    });
    const numToNByteStr = (num)=>$to2Dk.bytesToHex($to2Dk.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $337bbef37b0b9eaa$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$to2Dk.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $to2Dk.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $to2Dk.ensureBytes)('DER', hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $to2Dk.aInRange('r', this.r, $337bbef37b0b9eaa$var$_1n, CURVE_ORDER); // r in [1..N]
            $to2Dk.aInRange('s', this.s, $337bbef37b0b9eaa$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $to2Dk.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error('recovery id 2 or 3 invalid');
            const prefix = (rec & 1) === 0 ? '02' : '03';
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $to2Dk.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $to2Dk.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = (0, $ceIYS.getMinHashLength)(CURVE.n);
            return (0, $ceIYS.mapHashToField)(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $to2Dk.isBytes(item);
        const str = typeof item === 'string';
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error('first arg must be private key');
        if (!isProbPub(publicB)) throw new Error('second arg must be public key');
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // Our custom check "just in case"
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $to2Dk.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $to2Dk.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $to2Dk.aInRange('num < 2^' + CURVE.nBitLength, num, $337bbef37b0b9eaa$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $to2Dk.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $to2Dk.ensureBytes)('msgHash', msgHash);
        $337bbef37b0b9eaa$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $to2Dk.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $to2Dk.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = $to2Dk.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $337bbef37b0b9eaa$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $337bbef37b0b9eaa$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $337bbef37b0b9eaa$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $to2Dk.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $to2Dk.ensureBytes)('msgHash', msgHash);
        publicKey = (0, $to2Dk.ensureBytes)('publicKey', publicKey);
        const { lowS: lowS, prehash: prehash, format: format } = opts;
        // Verify opts, deduce signature format
        $337bbef37b0b9eaa$var$validateSigVerOpts(opts);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        if (format !== undefined && format !== 'compact' && format !== 'der') throw new Error('format must be compact or der');
        const isHex = typeof sg === 'string' || $to2Dk.isBytes(sg);
        const isObj = !isHex && !format && typeof sg === 'object' && sg !== null && typeof sg.r === 'bigint' && typeof sg.s === 'bigint';
        if (!isHex && !isObj) throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        let _sig = undefined;
        let P;
        try {
            if (isObj) _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== 'compact') _sig = Signature.fromDER(sg);
                } catch (derError) {
                    if (!(derError instanceof module.exports.DER.Err)) throw derError;
                }
                if (!_sig && format !== 'der') _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        } catch (error) {
            return false;
        }
        if (!_sig) return false;
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $337bbef37b0b9eaa$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $337bbef37b0b9eaa$var$_0n;
    for(let o = q - $337bbef37b0b9eaa$var$_1n; o % $337bbef37b0b9eaa$var$_2n === $337bbef37b0b9eaa$var$_0n; o /= $337bbef37b0b9eaa$var$_2n)l += $337bbef37b0b9eaa$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $337bbef37b0b9eaa$var$_2n << c1 - $337bbef37b0b9eaa$var$_1n - $337bbef37b0b9eaa$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $337bbef37b0b9eaa$var$_2n;
    const c2 = (q - $337bbef37b0b9eaa$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $337bbef37b0b9eaa$var$_1n) / $337bbef37b0b9eaa$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $337bbef37b0b9eaa$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $337bbef37b0b9eaa$var$_1n) / $337bbef37b0b9eaa$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $337bbef37b0b9eaa$var$_1n; i--){
            let tv5 = i - $337bbef37b0b9eaa$var$_2n; // 18.    tv5 = i - 2
            tv5 = $337bbef37b0b9eaa$var$_2n << tv5 - $337bbef37b0b9eaa$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $337bbef37b0b9eaa$var$_4n === $337bbef37b0b9eaa$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $337bbef37b0b9eaa$var$_3n) / $337bbef37b0b9eaa$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $337bbef37b0b9eaa$var$mapToCurveSimpleSWU(Fp, opts) {
    (0, $ceIYS.validateField)(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $337bbef37b0b9eaa$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("cXqn6", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.pippenger = pippenger;
exports.precomputeMSMUnsafe = precomputeMSMUnsafe;
exports.validateBasic = validateBasic;

var $ceIYS = parcelRequire("ceIYS");

var $to2Dk = parcelRequire("to2Dk");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    const windows = Math.ceil(bits / W) + 1; // +1, because
    const windowSize = 2 ** (W - 1); // -1 because we skip zero
    return {
        windows: windows,
        windowSize: windowSize
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */ function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = calcWOpts(W, bits);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                if (n === _0n) break; // No need to go over empty scalar
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                if (wbits === 0) continue;
                let curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0) curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster with precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */ function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length) throw new Error('arrays of points and scalars must have equal length');
    const zero = c.ZERO;
    const wbits = (0, $to2Dk.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
/**
 * Precomputed multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @returns function which multiplies points with scaars
 */ function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = BigInt((1 << windowSize) - 1);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, $ceIYS.validateField)(curve.Fp);
    (0, $to2Dk.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $ceIYS.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("ceIYS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNegativeLE = void 0;
module.exports.mod = $8e89af203bc1b7f2$var$mod;
module.exports.pow = $8e89af203bc1b7f2$var$pow;
module.exports.pow2 = $8e89af203bc1b7f2$var$pow2;
module.exports.invert = $8e89af203bc1b7f2$var$invert;
module.exports.tonelliShanks = $8e89af203bc1b7f2$var$tonelliShanks;
module.exports.FpSqrt = $8e89af203bc1b7f2$var$FpSqrt;
module.exports.validateField = $8e89af203bc1b7f2$var$validateField;
module.exports.FpPow = $8e89af203bc1b7f2$var$FpPow;
module.exports.FpInvertBatch = $8e89af203bc1b7f2$var$FpInvertBatch;
module.exports.FpDiv = $8e89af203bc1b7f2$var$FpDiv;
module.exports.FpLegendre = $8e89af203bc1b7f2$var$FpLegendre;
module.exports.FpIsSquare = $8e89af203bc1b7f2$var$FpIsSquare;
module.exports.nLength = $8e89af203bc1b7f2$var$nLength;
module.exports.Field = $8e89af203bc1b7f2$var$Field;
module.exports.FpSqrtOdd = $8e89af203bc1b7f2$var$FpSqrtOdd;
module.exports.FpSqrtEven = $8e89af203bc1b7f2$var$FpSqrtEven;
module.exports.hashToPrivateScalar = $8e89af203bc1b7f2$var$hashToPrivateScalar;
module.exports.getFieldBytesLength = $8e89af203bc1b7f2$var$getFieldBytesLength;
module.exports.getMinHashLength = $8e89af203bc1b7f2$var$getMinHashLength;
module.exports.mapHashToField = $8e89af203bc1b7f2$var$mapHashToField;

var $to2Dk = parcelRequire("to2Dk");
// prettier-ignore
const $8e89af203bc1b7f2$var$_0n = BigInt(0), $8e89af203bc1b7f2$var$_1n = BigInt(1), $8e89af203bc1b7f2$var$_2n = /* @__PURE__ */ BigInt(2), $8e89af203bc1b7f2$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $8e89af203bc1b7f2$var$_4n = /* @__PURE__ */ BigInt(4), $8e89af203bc1b7f2$var$_5n = /* @__PURE__ */ BigInt(5), $8e89af203bc1b7f2$var$_8n = /* @__PURE__ */ BigInt(8);
// prettier-ignore
const $8e89af203bc1b7f2$var$_9n = /* @__PURE__ */ BigInt(9), $8e89af203bc1b7f2$var$_16n = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function $8e89af203bc1b7f2$var$mod(a, b) {
    const result = a % b;
    return result >= $8e89af203bc1b7f2$var$_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @todo use field version && remove
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ function $8e89af203bc1b7f2$var$pow(num, power, modulo) {
    if (power < $8e89af203bc1b7f2$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (modulo <= $8e89af203bc1b7f2$var$_0n) throw new Error('invalid modulus');
    if (modulo === $8e89af203bc1b7f2$var$_1n) return $8e89af203bc1b7f2$var$_0n;
    let res = $8e89af203bc1b7f2$var$_1n;
    while(power > $8e89af203bc1b7f2$var$_0n){
        if (power & $8e89af203bc1b7f2$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8e89af203bc1b7f2$var$_1n;
    }
    return res;
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */ function $8e89af203bc1b7f2$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $8e89af203bc1b7f2$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */ function $8e89af203bc1b7f2$var$invert(number, modulo) {
    if (number === $8e89af203bc1b7f2$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $8e89af203bc1b7f2$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $8e89af203bc1b7f2$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $8e89af203bc1b7f2$var$_0n, y = $8e89af203bc1b7f2$var$_1n, u = $8e89af203bc1b7f2$var$_1n, v = $8e89af203bc1b7f2$var$_0n;
    while(a !== $8e89af203bc1b7f2$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $8e89af203bc1b7f2$var$_1n) throw new Error('invert: does not exist');
    return $8e89af203bc1b7f2$var$mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $8e89af203bc1b7f2$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $8e89af203bc1b7f2$var$_1n) / $8e89af203bc1b7f2$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8e89af203bc1b7f2$var$_1n, S = 0; Q % $8e89af203bc1b7f2$var$_2n === $8e89af203bc1b7f2$var$_0n; Q /= $8e89af203bc1b7f2$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8e89af203bc1b7f2$var$_2n; Z < P && $8e89af203bc1b7f2$var$pow(Z, legendreC, P) !== P - $8e89af203bc1b7f2$var$_1n; Z++){
        // Crash instead of infinity loop, we cannot reasonable count until P.
        if (Z > 1000) throw new Error('Cannot find square root: likely non-prime P');
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $8e89af203bc1b7f2$var$_1n) / $8e89af203bc1b7f2$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $8e89af203bc1b7f2$var$_1n) / $8e89af203bc1b7f2$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error('Cannot find square root');
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $8e89af203bc1b7f2$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
/**
 * Square root for a finite field. It will try to check if optimizations are applicable and fall back to 4:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */ function $8e89af203bc1b7f2$var$FpSqrt(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8e89af203bc1b7f2$var$_4n === $8e89af203bc1b7f2$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $8e89af203bc1b7f2$var$_1n) / $8e89af203bc1b7f2$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8e89af203bc1b7f2$var$_8n === $8e89af203bc1b7f2$var$_5n) {
        const c1 = (P - $8e89af203bc1b7f2$var$_5n) / $8e89af203bc1b7f2$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $8e89af203bc1b7f2$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $8e89af203bc1b7f2$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8e89af203bc1b7f2$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8e89af203bc1b7f2$var$tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const $8e89af203bc1b7f2$var$isNegativeLE = (num, modulo)=>($8e89af203bc1b7f2$var$mod(num, modulo) & $8e89af203bc1b7f2$var$_1n) === $8e89af203bc1b7f2$var$_1n;
module.exports.isNegativeLE = $8e89af203bc1b7f2$var$isNegativeLE;
// prettier-ignore
const $8e89af203bc1b7f2$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $8e89af203bc1b7f2$var$validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger'
    };
    const opts = $8e89af203bc1b7f2$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    return (0, $to2Dk.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $8e89af203bc1b7f2$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8e89af203bc1b7f2$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $8e89af203bc1b7f2$var$_0n) return f.ONE;
    if (power === $8e89af203bc1b7f2$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $8e89af203bc1b7f2$var$_0n){
        if (power & $8e89af203bc1b7f2$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8e89af203bc1b7f2$var$_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $8e89af203bc1b7f2$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8e89af203bc1b7f2$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? $8e89af203bc1b7f2$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
/**
 * Legendre symbol.
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */ function $8e89af203bc1b7f2$var$FpLegendre(order) {
    const legendreConst = (order - $8e89af203bc1b7f2$var$_1n) / $8e89af203bc1b7f2$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
// This function returns True whenever the value x is a square in the field F.
function $8e89af203bc1b7f2$var$FpIsSquare(f) {
    const legendre = $8e89af203bc1b7f2$var$FpLegendre(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
// CURVE.n lengths
function $8e89af203bc1b7f2$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
/**
 * Initializes a finite field over prime.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $8e89af203bc1b7f2$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $8e89af203bc1b7f2$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = $8e89af203bc1b7f2$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $to2Dk.bitMask)(BITS),
        ZERO: $8e89af203bc1b7f2$var$_0n,
        ONE: $8e89af203bc1b7f2$var$_1n,
        create: (num)=>$8e89af203bc1b7f2$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return $8e89af203bc1b7f2$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $8e89af203bc1b7f2$var$_0n,
        isOdd: (num)=>(num & $8e89af203bc1b7f2$var$_1n) === $8e89af203bc1b7f2$var$_1n,
        neg: (num)=>$8e89af203bc1b7f2$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$8e89af203bc1b7f2$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$8e89af203bc1b7f2$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$8e89af203bc1b7f2$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$8e89af203bc1b7f2$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$8e89af203bc1b7f2$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$8e89af203bc1b7f2$var$mod(lhs * $8e89af203bc1b7f2$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$8e89af203bc1b7f2$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $8e89af203bc1b7f2$var$FpSqrt(ORDER);
            return sqrtP(f, n);
        }),
        invertBatch: (lst)=>$8e89af203bc1b7f2$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $to2Dk.numberToBytesLE)(num, BYTES) : (0, $to2Dk.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            return isLE ? (0, $to2Dk.bytesToNumberLE)(bytes) : (0, $to2Dk.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8e89af203bc1b7f2$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8e89af203bc1b7f2$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use `mapKeyToField` instead
 */ function $8e89af203bc1b7f2$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $to2Dk.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $8e89af203bc1b7f2$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, $to2Dk.bytesToNumberLE)(hash) : (0, $to2Dk.bytesToNumberBE)(hash);
    return $8e89af203bc1b7f2$var$mod(num, groupOrder - $8e89af203bc1b7f2$var$_1n) + $8e89af203bc1b7f2$var$_1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $8e89af203bc1b7f2$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $8e89af203bc1b7f2$var$getMinHashLength(fieldOrder) {
    const length = $8e89af203bc1b7f2$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $8e89af203bc1b7f2$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $8e89af203bc1b7f2$var$getFieldBytesLength(fieldOrder);
    const minLen = $8e89af203bc1b7f2$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $to2Dk.bytesToNumberLE)(key) : (0, $to2Dk.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $8e89af203bc1b7f2$var$mod(num, fieldOrder - $8e89af203bc1b7f2$var$_1n) + $8e89af203bc1b7f2$var$_1n;
    return isLE ? (0, $to2Dk.numberToBytesLE)(reduced, fieldLen) : (0, $to2Dk.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("to2Dk", function(module, exports) {
"use strict";
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notImplemented = module.exports.bitMask = void 0;
module.exports.isBytes = $05855baeff5964dc$var$isBytes;
module.exports.abytes = $05855baeff5964dc$var$abytes;
module.exports.abool = $05855baeff5964dc$var$abool;
module.exports.bytesToHex = $05855baeff5964dc$var$bytesToHex;
module.exports.numberToHexUnpadded = $05855baeff5964dc$var$numberToHexUnpadded;
module.exports.hexToNumber = $05855baeff5964dc$var$hexToNumber;
module.exports.hexToBytes = $05855baeff5964dc$var$hexToBytes;
module.exports.bytesToNumberBE = $05855baeff5964dc$var$bytesToNumberBE;
module.exports.bytesToNumberLE = $05855baeff5964dc$var$bytesToNumberLE;
module.exports.numberToBytesBE = $05855baeff5964dc$var$numberToBytesBE;
module.exports.numberToBytesLE = $05855baeff5964dc$var$numberToBytesLE;
module.exports.numberToVarBytesBE = $05855baeff5964dc$var$numberToVarBytesBE;
module.exports.ensureBytes = $05855baeff5964dc$var$ensureBytes;
module.exports.concatBytes = $05855baeff5964dc$var$concatBytes;
module.exports.equalBytes = $05855baeff5964dc$var$equalBytes;
module.exports.utf8ToBytes = $05855baeff5964dc$var$utf8ToBytes;
module.exports.inRange = $05855baeff5964dc$var$inRange;
module.exports.aInRange = $05855baeff5964dc$var$aInRange;
module.exports.bitLen = $05855baeff5964dc$var$bitLen;
module.exports.bitGet = $05855baeff5964dc$var$bitGet;
module.exports.bitSet = $05855baeff5964dc$var$bitSet;
module.exports.createHmacDrbg = $05855baeff5964dc$var$createHmacDrbg;
module.exports.validateObject = $05855baeff5964dc$var$validateObject;
module.exports.memoized = $05855baeff5964dc$var$memoized;
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $05855baeff5964dc$var$_0n = /* @__PURE__ */ BigInt(0);
const $05855baeff5964dc$var$_1n = /* @__PURE__ */ BigInt(1);
const $05855baeff5964dc$var$_2n = /* @__PURE__ */ BigInt(2);
function $05855baeff5964dc$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $05855baeff5964dc$var$abytes(item) {
    if (!$05855baeff5964dc$var$isBytes(item)) throw new Error('Uint8Array expected');
}
function $05855baeff5964dc$var$abool(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $05855baeff5964dc$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $05855baeff5964dc$var$bytesToHex(bytes) {
    $05855baeff5964dc$var$abytes(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $05855baeff5964dc$var$hexes[bytes[i]];
    return hex;
}
function $05855baeff5964dc$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $05855baeff5964dc$var$hexToNumber(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $05855baeff5964dc$var$_0n : BigInt('0x' + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const $05855baeff5964dc$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $05855baeff5964dc$var$asciiToBase16(ch) {
    if (ch >= $05855baeff5964dc$var$asciis._0 && ch <= $05855baeff5964dc$var$asciis._9) return ch - $05855baeff5964dc$var$asciis._0; // '2' => 50-48
    if (ch >= $05855baeff5964dc$var$asciis.A && ch <= $05855baeff5964dc$var$asciis.F) return ch - ($05855baeff5964dc$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $05855baeff5964dc$var$asciis.a && ch <= $05855baeff5964dc$var$asciis.f) return ch - ($05855baeff5964dc$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $05855baeff5964dc$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $05855baeff5964dc$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $05855baeff5964dc$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function $05855baeff5964dc$var$bytesToNumberBE(bytes) {
    return $05855baeff5964dc$var$hexToNumber($05855baeff5964dc$var$bytesToHex(bytes));
}
function $05855baeff5964dc$var$bytesToNumberLE(bytes) {
    $05855baeff5964dc$var$abytes(bytes);
    return $05855baeff5964dc$var$hexToNumber($05855baeff5964dc$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
function $05855baeff5964dc$var$numberToBytesBE(n, len) {
    return $05855baeff5964dc$var$hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
function $05855baeff5964dc$var$numberToBytesLE(n, len) {
    return $05855baeff5964dc$var$numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function $05855baeff5964dc$var$numberToVarBytesBE(n) {
    return $05855baeff5964dc$var$hexToBytes($05855baeff5964dc$var$numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $05855baeff5964dc$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = $05855baeff5964dc$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if ($05855baeff5964dc$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $05855baeff5964dc$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $05855baeff5964dc$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function $05855baeff5964dc$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $05855baeff5964dc$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $05855baeff5964dc$var$isPosBig = (n)=>typeof n === 'bigint' && $05855baeff5964dc$var$_0n <= n;
function $05855baeff5964dc$var$inRange(n, min, max) {
    return $05855baeff5964dc$var$isPosBig(n) && $05855baeff5964dc$var$isPosBig(min) && $05855baeff5964dc$var$isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */ function $05855baeff5964dc$var$aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$05855baeff5964dc$var$inRange(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $05855baeff5964dc$var$bitLen(n) {
    let len;
    for(len = 0; n > $05855baeff5964dc$var$_0n; n >>= $05855baeff5964dc$var$_1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $05855baeff5964dc$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $05855baeff5964dc$var$_1n;
}
/**
 * Sets single bit at position.
 */ function $05855baeff5964dc$var$bitSet(n, pos, value) {
    return n | (value ? $05855baeff5964dc$var$_1n : $05855baeff5964dc$var$_0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $05855baeff5964dc$var$bitMask = (n)=>($05855baeff5964dc$var$_2n << BigInt(n - 1)) - $05855baeff5964dc$var$_1n;
module.exports.bitMask = $05855baeff5964dc$var$bitMask;
// DRBG
const $05855baeff5964dc$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $05855baeff5964dc$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $05855baeff5964dc$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $05855baeff5964dc$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $05855baeff5964dc$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $05855baeff5964dc$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($05855baeff5964dc$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($05855baeff5964dc$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $05855baeff5964dc$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $05855baeff5964dc$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || $05855baeff5964dc$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $05855baeff5964dc$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $05855baeff5964dc$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * throws not implemented error
 */ const $05855baeff5964dc$var$notImplemented = ()=>{
    throw new Error('not implemented');
};
module.exports.notImplemented = $05855baeff5964dc$var$notImplemented;
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */ function $05855baeff5964dc$var$memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});





parcelRegister("2ZUl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expand_message_xmd = $22ecfac5b874797e$var$expand_message_xmd;
module.exports.expand_message_xof = $22ecfac5b874797e$var$expand_message_xof;
module.exports.hash_to_field = $22ecfac5b874797e$var$hash_to_field;
module.exports.isogenyMap = $22ecfac5b874797e$var$isogenyMap;
module.exports.createHasher = $22ecfac5b874797e$var$createHasher;

var $ceIYS = parcelRequire("ceIYS");

var $to2Dk = parcelRequire("to2Dk");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $22ecfac5b874797e$var$os2ip = $to2Dk.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $22ecfac5b874797e$var$i2osp(value, length) {
    $22ecfac5b874797e$var$anum(value);
    $22ecfac5b874797e$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $22ecfac5b874797e$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $22ecfac5b874797e$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
/**
 * Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits.
 * [RFC 9380 5.3.1](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1).
 */ function $22ecfac5b874797e$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, $to2Dk.abytes)(msg);
    (0, $to2Dk.abytes)(DST);
    $22ecfac5b874797e$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $to2Dk.concatBytes)((0, $to2Dk.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $to2Dk.concatBytes)(DST, $22ecfac5b874797e$var$i2osp(DST.length, 1));
    const Z_pad = $22ecfac5b874797e$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $22ecfac5b874797e$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $to2Dk.concatBytes)(Z_pad, msg, l_i_b_str, $22ecfac5b874797e$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $to2Dk.concatBytes)(b_0, $22ecfac5b874797e$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $22ecfac5b874797e$var$strxor(b_0, b[i - 1]),
            $22ecfac5b874797e$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $to2Dk.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $to2Dk.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
/**
 * Produces a uniformly random byte string using an extendable-output function (XOF) H.
 * 1. The collision resistance of H MUST be at least k bits.
 * 2. H MUST be an XOF that has been proved indifferentiable from
 *    a random oracle under a reasonable cryptographic assumption.
 * [RFC 9380 5.3.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2).
 */ function $22ecfac5b874797e$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, $to2Dk.abytes)(msg);
    (0, $to2Dk.abytes)(DST);
    $22ecfac5b874797e$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $to2Dk.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($22ecfac5b874797e$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($22ecfac5b874797e$var$i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F.
 * [RFC 9380 5.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.2).
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $22ecfac5b874797e$var$hash_to_field(msg, count, options) {
    (0, $to2Dk.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $to2Dk.abytes)(msg);
    $22ecfac5b874797e$var$anum(count);
    const DST = typeof _DST === 'string' ? (0, $to2Dk.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $22ecfac5b874797e$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $22ecfac5b874797e$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $ceIYS.mod)($22ecfac5b874797e$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $22ecfac5b874797e$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
/** Creates hash-to-curve methods from EC Point and mapToCurve function. */ function $22ecfac5b874797e$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $22ecfac5b874797e$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $22ecfac5b874797e$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('mapToCurve: expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('mapToCurve: expected array of bigints');
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});


parcelRegister("iAcVK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fBYrP = parcelRequire("fBYrP");

var $to2Dk = parcelRequire("to2Dk");
class $d8759e7e7cbfbafc$var$Sha512 {
    constructor(){
        // instantiate empty sha512 hash
        this.hash = $fBYrP.sha512.create();
    }
    static half(input) {
        return new $d8759e7e7cbfbafc$var$Sha512().add(input).first256();
    }
    add(bytes) {
        this.hash.update(bytes);
        return this;
    }
    addU32(i) {
        const buffer = new Uint8Array(4);
        new DataView(buffer.buffer).setUint32(0, i);
        return this.add(buffer);
    }
    finish() {
        return this.hash.digest();
    }
    first256() {
        return this.finish().slice(0, 32);
    }
    first256BigInt() {
        return (0, $to2Dk.bytesToNumberBE)(this.first256());
    }
}
module.exports.default = $d8759e7e7cbfbafc$var$Sha512;

});


parcelRegister("Zccmt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $0b7f28f6b7caa309$var$assertHelper = {
    ok (cond, message) {
        if (!cond) throw new Error(message);
    }
};
module.exports.default = $0b7f28f6b7caa309$var$assertHelper;

});

parcelRegister("gLV4U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAlgorithmFromPrivateKey = module.exports.getAlgorithmFromPublicKey = module.exports.getAlgorithmFromKey = void 0;
var $c35d4fad0436fc45$var$Prefix;
(function(Prefix) {
    Prefix[Prefix["NONE"] = -1] = "NONE";
    Prefix[Prefix["ED25519"] = 237] = "ED25519";
    Prefix[Prefix["SECP256K1_PUB_X"] = 2] = "SECP256K1_PUB_X";
    Prefix[Prefix["SECP256K1_PUB_X_ODD_Y"] = 3] = "SECP256K1_PUB_X_ODD_Y";
    Prefix[Prefix["SECP256K1_PUB_XY"] = 4] = "SECP256K1_PUB_XY";
    Prefix[Prefix["SECP256K1_PRIVATE"] = 0] = "SECP256K1_PRIVATE";
})($c35d4fad0436fc45$var$Prefix || ($c35d4fad0436fc45$var$Prefix = {}));
/**
 * | Curve     | Type        | Prefix | Length | Description                                           | Algorithm       |
 * |-----------|-------------|:------:|:------:|-------------------------------------------------------|----------------:|
 * | ed25519   | Private     |  0xED  |   33   | prefix + Uint256LE (0 < n < order )                   |         ed25519 |
 * | ed25519   | Public      |  0xED  |   33   | prefix + 32 y-bytes                                   |         ed25519 |
 * | secp256k1 | Public (1)  |  0x02  |   33   | prefix + 32 x-bytes                                   | ecdsa-secp256k1 |
 * | secp256k1 | Public (2)  |  0x03  |   33   | prefix + 32 x-bytes (y is odd)                        | ecdsa-secp256k1 |
 * | secp256k1 | Public (3)  |  0x04  |   65   | prefix + 32 x-bytes + 32 y-bytes                      | ecdsa-secp256k1 |
 * | secp256k1 | Private (1) |  None  |   32   | Uint256BE (0 < n < order)                             | ecdsa-secp256k1 |
 * | secp256k1 | Private (2) |  0x00  |   33   | prefix + Uint256BE (0 < n < order)                    | ecdsa-secp256k1 |
 *
 * Note: The 0x00 prefix for secpk256k1 Private (2) essentially 0 pads the number
 *       and the interpreted number is the same as 32 bytes.
 */ const $c35d4fad0436fc45$var$KEY_TYPES = {
    [`private_${$c35d4fad0436fc45$var$Prefix.NONE}_32`]: 'ecdsa-secp256k1',
    [`private_${$c35d4fad0436fc45$var$Prefix.SECP256K1_PRIVATE}_33`]: 'ecdsa-secp256k1',
    [`private_${$c35d4fad0436fc45$var$Prefix.ED25519}_33`]: 'ed25519',
    [`public_${$c35d4fad0436fc45$var$Prefix.ED25519}_33`]: 'ed25519',
    [`public_${$c35d4fad0436fc45$var$Prefix.SECP256K1_PUB_X}_33`]: 'ecdsa-secp256k1',
    [`public_${$c35d4fad0436fc45$var$Prefix.SECP256K1_PUB_X_ODD_Y}_33`]: 'ecdsa-secp256k1',
    [`public_${$c35d4fad0436fc45$var$Prefix.SECP256K1_PUB_XY}_65`]: 'ecdsa-secp256k1'
};
function $c35d4fad0436fc45$var$getKeyInfo(key) {
    return {
        prefix: key.length < 2 ? $c35d4fad0436fc45$var$Prefix.NONE : parseInt(key.slice(0, 2), 16),
        len: key.length / 2
    };
}
function $c35d4fad0436fc45$var$prefixRepr(prefix) {
    return prefix === $c35d4fad0436fc45$var$Prefix.NONE ? 'None' : `0x${prefix.toString(16).padStart(2, '0')}`;
}
function $c35d4fad0436fc45$var$getValidFormatsTable(type) {
    // No need overkill with renderTable method
    const padding = 2;
    const colWidth = {
        algorithm: 15 + padding,
        prefix: 4 + padding
    };
    return Object.entries($c35d4fad0436fc45$var$KEY_TYPES).filter(([key])=>key.startsWith(type)).map(([key, algorithm])=>{
        const [, prefix, length] = key.split('_');
        const paddedAlgo = algorithm.padEnd(colWidth.algorithm);
        const paddedPrefix = $c35d4fad0436fc45$var$prefixRepr(Number(prefix)).padEnd(colWidth.prefix);
        return `${paddedAlgo} - Prefix: ${paddedPrefix} Length: ${length} bytes`;
    }).join('\n');
}
function $c35d4fad0436fc45$var$keyError({ key: key, type: type, prefix: prefix, len: len }) {
    const validFormats = $c35d4fad0436fc45$var$getValidFormatsTable(type);
    return `invalid_key:

Type: ${type}
Key: ${key}
Prefix: ${$c35d4fad0436fc45$var$prefixRepr(prefix)} 
Length: ${len} bytes

Acceptable ${type} formats are:
${validFormats}
`;
}
/**
 * Determines the algorithm associated with a given key (public/private).
 *
 * @param key - hexadecimal string representation of the key.
 * @param type - whether expected key is public or private
 * @returns Algorithm algorithm for signing/verifying
 * @throws Error when key is invalid
 */ function $c35d4fad0436fc45$var$getAlgorithmFromKey(key, type) {
    const { prefix: prefix, len: len } = $c35d4fad0436fc45$var$getKeyInfo(key);
    // Special case back compat support for no prefix
    const usedPrefix = type === 'private' && len === 32 ? $c35d4fad0436fc45$var$Prefix.NONE : prefix;
    const algorithm = $c35d4fad0436fc45$var$KEY_TYPES[`${type}_${usedPrefix}_${len}`];
    if (!algorithm) throw new Error($c35d4fad0436fc45$var$keyError({
        key: key,
        type: type,
        len: len,
        prefix: usedPrefix
    }));
    return algorithm;
}
module.exports.getAlgorithmFromKey = $c35d4fad0436fc45$var$getAlgorithmFromKey;
function $c35d4fad0436fc45$var$getAlgorithmFromPublicKey(key) {
    return $c35d4fad0436fc45$var$getAlgorithmFromKey(key, 'public');
}
module.exports.getAlgorithmFromPublicKey = $c35d4fad0436fc45$var$getAlgorithmFromPublicKey;
function $c35d4fad0436fc45$var$getAlgorithmFromPrivateKey(key) {
    return $c35d4fad0436fc45$var$getAlgorithmFromKey(key, 'private');
}
module.exports.getAlgorithmFromPrivateKey = $c35d4fad0436fc45$var$getAlgorithmFromPrivateKey;

});

parcelRegister("6UdLC", function(module, exports) {
"use strict";
var $5072a6e13ef39d37$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $to2Dk = parcelRequire("to2Dk");

var $ldlsU = parcelRequire("ldlsU");

var $8wxDW = parcelRequire("8wxDW");

var $pMfhq = parcelRequire("pMfhq");

const $5072a6e13ef39d37$var$assert_1 = $5072a6e13ef39d37$var$__importDefault((parcelRequire("Zccmt")));

const $5072a6e13ef39d37$var$Sha512_1 = $5072a6e13ef39d37$var$__importDefault((parcelRequire("iAcVK")));
const $5072a6e13ef39d37$var$SECP256K1_PREFIX = '00';
const $5072a6e13ef39d37$var$secp256k1 = {
    deriveKeypair (entropy, options) {
        const derived = (0, $pMfhq.derivePrivateKey)(entropy, options);
        const privateKey = $5072a6e13ef39d37$var$SECP256K1_PREFIX + (0, $8wxDW.bytesToHex)((0, $to2Dk.numberToBytesBE)(derived, 32));
        const publicKey = (0, $8wxDW.bytesToHex)($ldlsU.secp256k1.getPublicKey(derived, true));
        return {
            privateKey: privateKey,
            publicKey: publicKey
        };
    },
    sign (message, privateKey) {
        // Some callers pass the privateKey with the prefix, others without.
        // @noble/curves will throw if the key is not exactly 32 bytes, so we
        // normalize it before passing to the sign method.
        $5072a6e13ef39d37$var$assert_1.default.ok(privateKey.length === 66 && privateKey.startsWith($5072a6e13ef39d37$var$SECP256K1_PREFIX) || privateKey.length === 64);
        const normedPrivateKey = privateKey.length === 66 ? privateKey.slice(2) : privateKey;
        return $ldlsU.secp256k1.sign($5072a6e13ef39d37$var$Sha512_1.default.half(message), normedPrivateKey, {
            // "Canonical" signatures
            lowS: true,
            // Would fail tests if signatures aren't deterministic
            extraEntropy: undefined
        }).toDERHex(true).toUpperCase();
    },
    verify (message, signature, publicKey) {
        const decoded = $ldlsU.secp256k1.Signature.fromDER(signature);
        return $ldlsU.secp256k1.verify(decoded, $5072a6e13ef39d37$var$Sha512_1.default.half(message), publicKey);
    }
};
module.exports.default = $5072a6e13ef39d37$var$secp256k1;

});

parcelRegister("ePkUq", function(module, exports) {
"use strict";
var $acb60c3c57efc6f3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9OPXK = parcelRequire("9OPXK");

var $8wxDW = parcelRequire("8wxDW");

const $acb60c3c57efc6f3$var$assert_1 = $acb60c3c57efc6f3$var$__importDefault((parcelRequire("Zccmt")));

const $acb60c3c57efc6f3$var$Sha512_1 = $acb60c3c57efc6f3$var$__importDefault((parcelRequire("iAcVK")));
const $acb60c3c57efc6f3$var$ED_PREFIX = 'ED';
const $acb60c3c57efc6f3$var$ed25519 = {
    deriveKeypair (entropy) {
        const rawPrivateKey = $acb60c3c57efc6f3$var$Sha512_1.default.half(entropy);
        const privateKey = $acb60c3c57efc6f3$var$ED_PREFIX + (0, $8wxDW.bytesToHex)(rawPrivateKey);
        const publicKey = $acb60c3c57efc6f3$var$ED_PREFIX + (0, $8wxDW.bytesToHex)($9OPXK.ed25519.getPublicKey(rawPrivateKey));
        return {
            privateKey: privateKey,
            publicKey: publicKey
        };
    },
    sign (message, privateKey) {
        $acb60c3c57efc6f3$var$assert_1.default.ok(message instanceof Uint8Array, 'message must be array of octets');
        $acb60c3c57efc6f3$var$assert_1.default.ok(privateKey.length === 66, 'private key must be 33 bytes including prefix');
        return (0, $8wxDW.bytesToHex)($9OPXK.ed25519.sign(message, privateKey.slice(2)));
    },
    verify (message, signature, publicKey) {
        // Unlikely to be triggered as these are internal and guarded by getAlgorithmFromKey
        $acb60c3c57efc6f3$var$assert_1.default.ok(publicKey.length === 66, 'public key must be 33 bytes including prefix');
        return $9OPXK.ed25519.verify(signature, message, // Remove the 0xED prefix
        publicKey.slice(2), // By default, set zip215 to false for compatibility reasons.
        // ZIP 215 is a stricter Ed25519 signature verification scheme.
        // However, setting it to false adheres to the more commonly used
        // RFC8032 / NIST186-5 standards, making it compatible with systems
        // like the XRP Ledger.
        {
            zip215: false
        });
    }
};
module.exports.default = $acb60c3c57efc6f3$var$ed25519;

});
parcelRegister("9OPXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255 = module.exports.RistrettoPoint = module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.edwardsToMontgomery = module.exports.x25519 = module.exports.ed25519ph = module.exports.ed25519ctx = module.exports.ed25519 = module.exports.ED25519_TORSION_SUBGROUP = void 0;
module.exports.edwardsToMontgomeryPub = $7261173fae120f8d$var$edwardsToMontgomeryPub;
module.exports.edwardsToMontgomeryPriv = $7261173fae120f8d$var$edwardsToMontgomeryPriv;

var $7PO07 = parcelRequire("7PO07");

var $5BLEh = parcelRequire("5BLEh");

var $cXqn6 = parcelRequire("cXqn6");

var $i2942 = parcelRequire("i2942");

var $2ZUl0 = parcelRequire("2ZUl0");

var $ceIYS = parcelRequire("ceIYS");

var $g6f51 = parcelRequire("g6f51");

var $to2Dk = parcelRequire("to2Dk");
const $7261173fae120f8d$var$ED25519_P = BigInt('57896044618658097711785492504343953926634992332820282019728792003956564819949');
// √(-1) aka √(a) aka 2^((p-1)/4)
const $7261173fae120f8d$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt('19681161376707505956807079304988542015446066515923890162744021073123829784752');
// prettier-ignore
const $7261173fae120f8d$var$_0n = BigInt(0), $7261173fae120f8d$var$_1n = BigInt(1), $7261173fae120f8d$var$_2n = BigInt(2), $7261173fae120f8d$var$_3n = BigInt(3);
// prettier-ignore
const $7261173fae120f8d$var$_5n = BigInt(5), $7261173fae120f8d$var$_8n = BigInt(8);
function $7261173fae120f8d$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $7261173fae120f8d$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $ceIYS.pow2)(b2, $7261173fae120f8d$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $ceIYS.pow2)(b4, $7261173fae120f8d$var$_1n, P) * x % P; // x^31
    const b10 = (0, $ceIYS.pow2)(b5, $7261173fae120f8d$var$_5n, P) * b5 % P;
    const b20 = (0, $ceIYS.pow2)(b10, _10n, P) * b10 % P;
    const b40 = (0, $ceIYS.pow2)(b20, _20n, P) * b20 % P;
    const b80 = (0, $ceIYS.pow2)(b40, _40n, P) * b40 % P;
    const b160 = (0, $ceIYS.pow2)(b80, _80n, P) * b80 % P;
    const b240 = (0, $ceIYS.pow2)(b160, _80n, P) * b80 % P;
    const b250 = (0, $ceIYS.pow2)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $ceIYS.pow2)(b250, $7261173fae120f8d$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $7261173fae120f8d$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $7261173fae120f8d$var$uvRatio(u, v) {
    const P = $7261173fae120f8d$var$ED25519_P;
    const v3 = (0, $ceIYS.mod)(v * v * v, P); // v³
    const v7 = (0, $ceIYS.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $7261173fae120f8d$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $ceIYS.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $ceIYS.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $ceIYS.mod)(x * $7261173fae120f8d$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $ceIYS.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $ceIYS.mod)(-u * $7261173fae120f8d$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $ceIYS.isNegativeLE)(x, P)) x = (0, $ceIYS.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
// Just in case
module.exports.ED25519_TORSION_SUBGROUP = [
    '0100000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a',
    '0000000000000000000000000000000000000000000000000000000000000080',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05',
    'ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85',
    '0000000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa'
];
const $7261173fae120f8d$var$Fp = /* @__PURE__ */ (()=>(0, $ceIYS.Field)($7261173fae120f8d$var$ED25519_P, undefined, true))();
const $7261173fae120f8d$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        // Param: a
        a: BigInt(-1),
        // d is equal to -121665/121666 over finite field.
        // Negative number is P - number, and division is invert(number, P)
        d: BigInt('37095705934669439343138083508754565189542113879843219016388785533085940283555'),
        Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
        $7261173fae120f8d$var$Fp,
        // Subgroup order: how many points curve has
        // 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt('7237005577332262213973186563042994240857116359379907606001950938285454250989'),
        // Cofactor
        h: $7261173fae120f8d$var$_8n,
        // Base point (x, y) aka generator point
        Gx: BigInt('15112221349535400772501151409588531511454012693041857206046113283949847762202'),
        Gy: BigInt('46316835694926478169428394003475163141307993866256225615783033603165251855960'),
        hash: $7PO07.sha512,
        randomBytes: $5BLEh.randomBytes,
        adjustScalarBytes: $7261173fae120f8d$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $7261173fae120f8d$var$uvRatio
    }))();
/**
 * ed25519 curve with EdDSA signatures.
 * @example
 * import { ed25519 } from '@noble/curves/ed25519';
 * const priv = ed25519.utils.randomPrivateKey();
 * const pub = ed25519.getPublicKey(priv);
 * const msg = new TextEncoder().encode('hello');
 * const sig = ed25519.sign(msg, priv);
 * ed25519.verify(sig, msg, pub); // Default mode: follows ZIP215
 * ed25519.verify(sig, msg, pub, { zip215: false }); // RFC8032 / FIPS 186-5
 */ module.exports.ed25519 = (()=>(0, $i2942.twistedEdwards)($7261173fae120f8d$var$ed25519Defaults))();
function $7261173fae120f8d$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error('Context is too big');
    return (0, $5BLEh.concatBytes)((0, $5BLEh.utf8ToBytes)('SigEd25519 no Ed25519 collisions'), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
module.exports.ed25519ctx = (()=>(0, $i2942.twistedEdwards)({
        ...$7261173fae120f8d$var$ed25519Defaults,
        domain: $7261173fae120f8d$var$ed25519_domain
    }))();
module.exports.ed25519ph = (()=>(0, $i2942.twistedEdwards)(Object.assign({}, $7261173fae120f8d$var$ed25519Defaults, {
        domain: $7261173fae120f8d$var$ed25519_domain,
        prehash: $7PO07.sha512
    })))();
/**
 * ECDH using curve25519 aka x25519.
 * @example
 * import { x25519 } from '@noble/curves/ed25519';
 * const priv = 'a546e36bf0527c9d3b16154b82465edd62144c0ac1fc5a18506a2244ba449ac4';
 * const pub = 'e6db6867583030db3594c1a424b15f7c726624ec26b3353b10a903a6d0ab1c4c';
 * x25519.getSharedSecret(priv, pub) === x25519.scalarMult(priv, pub); // aliases
 * x25519.getPublicKey(priv) === x25519.scalarMultBase(priv);
 * x25519.getPublicKey(x25519.utils.randomPrivateKey());
 */ module.exports.x25519 = (()=>(0, $g6f51.montgomery)({
        P: $7261173fae120f8d$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $7261173fae120f8d$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $7261173fae120f8d$var$ed25519_pow_2_252_3(x);
            return (0, $ceIYS.mod)((0, $ceIYS.pow2)(pow_p_5_8, $7261173fae120f8d$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $7261173fae120f8d$var$adjustScalarBytes,
        randomBytes: $5BLEh.randomBytes
    }))();
/**
 * Converts ed25519 public key to x25519 public key. Uses formula:
 * * `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
 * * `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
 * @example
 *   const someonesPub = ed25519.getPublicKey(ed25519.utils.randomPrivateKey());
 *   const aPriv = x25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(aPriv, edwardsToMontgomeryPub(someonesPub))
 */ function $7261173fae120f8d$var$edwardsToMontgomeryPub(edwardsPub) {
    const { y: y } = module.exports.ed25519.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $7261173fae120f8d$var$Fp.toBytes($7261173fae120f8d$var$Fp.create((_1n + y) * $7261173fae120f8d$var$Fp.inv(_1n - y)));
}
module.exports.edwardsToMontgomery = $7261173fae120f8d$var$edwardsToMontgomeryPub; // deprecated
/**
 * Converts ed25519 secret key to x25519 secret key.
 * @example
 *   const someonesPub = x25519.getPublicKey(x25519.utils.randomPrivateKey());
 *   const aPriv = ed25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(edwardsToMontgomeryPriv(aPriv), someonesPub)
 */ function $7261173fae120f8d$var$edwardsToMontgomeryPriv(edwardsPriv) {
    const hashed = $7261173fae120f8d$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $7261173fae120f8d$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $7261173fae120f8d$var$ELL2_C1 = /* @__PURE__ */ (()=>($7261173fae120f8d$var$Fp.ORDER + $7261173fae120f8d$var$_3n) / $7261173fae120f8d$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $7261173fae120f8d$var$ELL2_C2 = /* @__PURE__ */ (()=>$7261173fae120f8d$var$Fp.pow($7261173fae120f8d$var$_2n, $7261173fae120f8d$var$ELL2_C1))(); // 2. c2 = 2^c1
const $7261173fae120f8d$var$ELL2_C3 = /* @__PURE__ */ (()=>$7261173fae120f8d$var$Fp.sqrt($7261173fae120f8d$var$Fp.neg($7261173fae120f8d$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $7261173fae120f8d$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($7261173fae120f8d$var$Fp.ORDER - $7261173fae120f8d$var$_5n) / $7261173fae120f8d$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $7261173fae120f8d$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $7261173fae120f8d$var$Fp.mul(tv1, $7261173fae120f8d$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $7261173fae120f8d$var$Fp.add(tv1, $7261173fae120f8d$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $7261173fae120f8d$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $7261173fae120f8d$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $7261173fae120f8d$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $7261173fae120f8d$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $7261173fae120f8d$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $7261173fae120f8d$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $7261173fae120f8d$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $7261173fae120f8d$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $7261173fae120f8d$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $7261173fae120f8d$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $7261173fae120f8d$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $7261173fae120f8d$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $7261173fae120f8d$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $7261173fae120f8d$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $7261173fae120f8d$var$Fp.mul(y11, $7261173fae120f8d$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $7261173fae120f8d$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $7261173fae120f8d$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $7261173fae120f8d$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $7261173fae120f8d$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $7261173fae120f8d$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $7261173fae120f8d$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $7261173fae120f8d$var$Fp.mul(y21, $7261173fae120f8d$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $7261173fae120f8d$var$Fp.mul(y21, $7261173fae120f8d$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $7261173fae120f8d$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $7261173fae120f8d$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $7261173fae120f8d$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $7261173fae120f8d$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $7261173fae120f8d$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $7261173fae120f8d$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $7261173fae120f8d$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $7261173fae120f8d$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $7261173fae120f8d$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $7261173fae120f8d$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $7261173fae120f8d$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $7261173fae120f8d$var$Fp.cmov(y, $7261173fae120f8d$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $7261173fae120f8d$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $7261173fae120f8d$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $ceIYS.FpSqrtEven)($7261173fae120f8d$var$Fp, $7261173fae120f8d$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $7261173fae120f8d$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $7261173fae120f8d$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $7261173fae120f8d$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $7261173fae120f8d$var$Fp.mul(xn, $7261173fae120f8d$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $7261173fae120f8d$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $7261173fae120f8d$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $7261173fae120f8d$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $7261173fae120f8d$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $7261173fae120f8d$var$Fp.eql(tv1, $7261173fae120f8d$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $7261173fae120f8d$var$Fp.cmov(xn, $7261173fae120f8d$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $7261173fae120f8d$var$Fp.cmov(xd, $7261173fae120f8d$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $7261173fae120f8d$var$Fp.cmov(yn, $7261173fae120f8d$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $7261173fae120f8d$var$Fp.cmov(yd, $7261173fae120f8d$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $7261173fae120f8d$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $7261173fae120f8d$var$Fp.mul(xn, inv[0]),
        y: $7261173fae120f8d$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $7261173fae120f8d$var$htf = /* @__PURE__ */ (()=>(0, $2ZUl0.createHasher)(module.exports.ed25519.ExtendedPoint, (scalars)=>$7261173fae120f8d$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: 'edwards25519_XMD:SHA-512_ELL2_RO_',
        encodeDST: 'edwards25519_XMD:SHA-512_ELL2_NU_',
        p: $7261173fae120f8d$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: $7PO07.sha512
    }))();
module.exports.hashToCurve = (()=>$7261173fae120f8d$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$7261173fae120f8d$var$htf.encodeToCurve)();
function $7261173fae120f8d$var$assertRstPoint(other) {
    if (!(other instanceof $7261173fae120f8d$var$RistPoint)) throw new Error('RistrettoPoint expected');
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $7261173fae120f8d$var$SQRT_M1 = $7261173fae120f8d$var$ED25519_SQRT_M1;
// √(ad - 1)
const $7261173fae120f8d$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt('25063068953384623474111414158702152701244531502492656460079210482610430750235');
// 1 / √(a-d)
const $7261173fae120f8d$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt('54469307008909316920995813868745141605393597292927456921205312896311721017578');
// 1-d²
const $7261173fae120f8d$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt('1159843021668779879193775521855586647937357759715417654439879720876111806838');
// (d-1)²
const $7261173fae120f8d$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt('40440834346308536858101042469323190826248399146238708352240133220865137265952');
// Calculates 1/√(number)
const $7261173fae120f8d$var$invertSqrt = (number)=>$7261173fae120f8d$var$uvRatio($7261173fae120f8d$var$_1n, number);
const $7261173fae120f8d$var$MAX_255B = /* @__PURE__ */ BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
const $7261173fae120f8d$var$bytes255ToNumberLE = (bytes)=>module.exports.ed25519.CURVE.Fp.create((0, $to2Dk.bytesToNumberLE)(bytes) & $7261173fae120f8d$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $7261173fae120f8d$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = module.exports.ed25519.CURVE;
    const P = module.exports.ed25519.CURVE.Fp.ORDER;
    const mod = module.exports.ed25519.CURVE.Fp.create;
    const r = mod($7261173fae120f8d$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $7261173fae120f8d$var$_1n) * $7261173fae120f8d$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $7261173fae120f8d$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $ceIYS.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $7261173fae120f8d$var$_1n) * $7261173fae120f8d$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $7261173fae120f8d$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($7261173fae120f8d$var$_1n - s2); // 12
    const W3 = mod($7261173fae120f8d$var$_1n + s2); // 13
    return new module.exports.ed25519.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $7261173fae120f8d$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $7261173fae120f8d$var$RistPoint(module.exports.ed25519.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $to2Dk.ensureBytes)('ristrettoHash', hex, 64);
        const r1 = $7261173fae120f8d$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $7261173fae120f8d$var$calcElligatorRistrettoMap(r1);
        const r2 = $7261173fae120f8d$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $7261173fae120f8d$var$calcElligatorRistrettoMap(r2);
        return new $7261173fae120f8d$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $to2Dk.ensureBytes)('ristrettoHex', hex, 32);
        const { a: a, d: d } = module.exports.ed25519.CURVE;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const emsg = 'RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint';
        const s = $7261173fae120f8d$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $to2Dk.equalBytes)((0, $to2Dk.numberToBytesLE)(s, 32), hex) || (0, $ceIYS.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($7261173fae120f8d$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($7261173fae120f8d$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $7261173fae120f8d$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $ceIYS.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $ceIYS.isNegativeLE)(t, P) || y === $7261173fae120f8d$var$_0n) throw new Error(emsg);
        return new $7261173fae120f8d$var$RistPoint(new module.exports.ed25519.ExtendedPoint(x, y, $7261173fae120f8d$var$_1n, t));
    }
    static msm(points, scalars) {
        const Fn = (0, $ceIYS.Field)(module.exports.ed25519.CURVE.n, module.exports.ed25519.CURVE.nBitLength);
        return (0, $cXqn6.pippenger)($7261173fae120f8d$var$RistPoint, Fn, points, scalars);
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $7261173fae120f8d$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $ceIYS.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $7261173fae120f8d$var$SQRT_M1);
            let _y = mod(x * $7261173fae120f8d$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $7261173fae120f8d$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $ceIYS.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $ceIYS.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $to2Dk.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $to2Dk.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $7261173fae120f8d$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $7261173fae120f8d$var$assertRstPoint(other);
        return new $7261173fae120f8d$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $7261173fae120f8d$var$assertRstPoint(other);
        return new $7261173fae120f8d$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $7261173fae120f8d$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $7261173fae120f8d$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $7261173fae120f8d$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $7261173fae120f8d$var$RistPoint(this.ep.negate());
    }
}
module.exports.RistrettoPoint = (()=>{
    if (!$7261173fae120f8d$var$RistPoint.BASE) $7261173fae120f8d$var$RistPoint.BASE = new $7261173fae120f8d$var$RistPoint(module.exports.ed25519.ExtendedPoint.BASE);
    if (!$7261173fae120f8d$var$RistPoint.ZERO) $7261173fae120f8d$var$RistPoint.ZERO = new $7261173fae120f8d$var$RistPoint(module.exports.ed25519.ExtendedPoint.ZERO);
    return $7261173fae120f8d$var$RistPoint;
})();
// Hashing to ristretto255. https://www.rfc-editor.org/rfc/rfc9380#appendix-B
const $7261173fae120f8d$var$hashToRistretto255 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === 'string' ? (0, $5BLEh.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $2ZUl0.expand_message_xmd)(msg, DST, 64, $7PO07.sha512);
    const P = $7261173fae120f8d$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
module.exports.hashToRistretto255 = $7261173fae120f8d$var$hashToRistretto255;
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255; // legacy

});
parcelRegister("7PO07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA384 = module.exports.SHA512_256 = module.exports.SHA512_224 = module.exports.SHA512 = void 0;

var $b7irD = parcelRequire("b7irD");

var $deNaM = parcelRequire("deNaM");

var $5BLEh = parcelRequire("5BLEh");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$5b4414fad7fc14ea$var$SHA512_Kh, $5b4414fad7fc14ea$var$SHA512_Kl] = /* @__PURE__ */ (()=>$deNaM.default.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $5b4414fad7fc14ea$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $5b4414fad7fc14ea$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $5b4414fad7fc14ea$var$SHA512 extends $b7irD.HashMD {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $5b4414fad7fc14ea$var$SHA512_W_H[i] = view.getUint32(offset);
            $5b4414fad7fc14ea$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $5b4414fad7fc14ea$var$SHA512_W_H[i - 15] | 0;
            const W15l = $5b4414fad7fc14ea$var$SHA512_W_L[i - 15] | 0;
            const s0h = $deNaM.default.rotrSH(W15h, W15l, 1) ^ $deNaM.default.rotrSH(W15h, W15l, 8) ^ $deNaM.default.shrSH(W15h, W15l, 7);
            const s0l = $deNaM.default.rotrSL(W15h, W15l, 1) ^ $deNaM.default.rotrSL(W15h, W15l, 8) ^ $deNaM.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $5b4414fad7fc14ea$var$SHA512_W_H[i - 2] | 0;
            const W2l = $5b4414fad7fc14ea$var$SHA512_W_L[i - 2] | 0;
            const s1h = $deNaM.default.rotrSH(W2h, W2l, 19) ^ $deNaM.default.rotrBH(W2h, W2l, 61) ^ $deNaM.default.shrSH(W2h, W2l, 6);
            const s1l = $deNaM.default.rotrSL(W2h, W2l, 19) ^ $deNaM.default.rotrBL(W2h, W2l, 61) ^ $deNaM.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $deNaM.default.add4L(s0l, s1l, $5b4414fad7fc14ea$var$SHA512_W_L[i - 7], $5b4414fad7fc14ea$var$SHA512_W_L[i - 16]);
            const SUMh = $deNaM.default.add4H(SUMl, s0h, s1h, $5b4414fad7fc14ea$var$SHA512_W_H[i - 7], $5b4414fad7fc14ea$var$SHA512_W_H[i - 16]);
            $5b4414fad7fc14ea$var$SHA512_W_H[i] = SUMh | 0;
            $5b4414fad7fc14ea$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $deNaM.default.rotrSH(Eh, El, 14) ^ $deNaM.default.rotrSH(Eh, El, 18) ^ $deNaM.default.rotrBH(Eh, El, 41);
            const sigma1l = $deNaM.default.rotrSL(Eh, El, 14) ^ $deNaM.default.rotrSL(Eh, El, 18) ^ $deNaM.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $deNaM.default.add5L(Hl, sigma1l, CHIl, $5b4414fad7fc14ea$var$SHA512_Kl[i], $5b4414fad7fc14ea$var$SHA512_W_L[i]);
            const T1h = $deNaM.default.add5H(T1ll, Hh, sigma1h, CHIh, $5b4414fad7fc14ea$var$SHA512_Kh[i], $5b4414fad7fc14ea$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $deNaM.default.rotrSH(Ah, Al, 28) ^ $deNaM.default.rotrBH(Ah, Al, 34) ^ $deNaM.default.rotrBH(Ah, Al, 39);
            const sigma0l = $deNaM.default.rotrSL(Ah, Al, 28) ^ $deNaM.default.rotrBL(Ah, Al, 34) ^ $deNaM.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $deNaM.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $deNaM.default.add3L(T1l, sigma0l, MAJl);
            Ah = $deNaM.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $deNaM.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $deNaM.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $deNaM.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $deNaM.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $deNaM.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $deNaM.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $deNaM.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $deNaM.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $5b4414fad7fc14ea$var$SHA512_W_H.fill(0);
        $5b4414fad7fc14ea$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $5b4414fad7fc14ea$var$SHA512;
class $5b4414fad7fc14ea$var$SHA512_224 extends $5b4414fad7fc14ea$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
module.exports.SHA512_224 = $5b4414fad7fc14ea$var$SHA512_224;
class $5b4414fad7fc14ea$var$SHA512_256 extends $5b4414fad7fc14ea$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
module.exports.SHA512_256 = $5b4414fad7fc14ea$var$SHA512_256;
class $5b4414fad7fc14ea$var$SHA384 extends $5b4414fad7fc14ea$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.SHA384 = $5b4414fad7fc14ea$var$SHA384;
/** SHA2-512 hash function. */ module.exports.sha512 = (0, $5BLEh.wrapConstructor)(()=>new $5b4414fad7fc14ea$var$SHA512());
/** SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks. */ module.exports.sha512_224 = (0, $5BLEh.wrapConstructor)(()=>new $5b4414fad7fc14ea$var$SHA512_224());
/** SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks. */ module.exports.sha512_256 = (0, $5BLEh.wrapConstructor)(()=>new $5b4414fad7fc14ea$var$SHA512_256());
/** SHA2-384 hash function. */ module.exports.sha384 = (0, $5BLEh.wrapConstructor)(()=>new $5b4414fad7fc14ea$var$SHA384());

});
parcelRegister("deNaM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = void 0;
module.exports.fromBig = $9a32b9da918f25b9$var$fromBig;
module.exports.split = $9a32b9da918f25b9$var$split;
module.exports.add = $9a32b9da918f25b9$var$add;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $9a32b9da918f25b9$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $9a32b9da918f25b9$var$_32n = /* @__PURE__ */ BigInt(32);
function $9a32b9da918f25b9$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $9a32b9da918f25b9$var$U32_MASK64),
        l: Number(n >> $9a32b9da918f25b9$var$_32n & $9a32b9da918f25b9$var$U32_MASK64)
    };
    return {
        h: Number(n >> $9a32b9da918f25b9$var$_32n & $9a32b9da918f25b9$var$U32_MASK64) | 0,
        l: Number(n & $9a32b9da918f25b9$var$U32_MASK64) | 0
    };
}
function $9a32b9da918f25b9$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $9a32b9da918f25b9$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $9a32b9da918f25b9$var$toBig = (h, l)=>BigInt(h >>> 0) << $9a32b9da918f25b9$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $9a32b9da918f25b9$var$toBig;
// for Shift in [0, 32)
const $9a32b9da918f25b9$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $9a32b9da918f25b9$var$shrSH;
const $9a32b9da918f25b9$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $9a32b9da918f25b9$var$shrSL;
// Right rotate for Shift in [1, 32)
const $9a32b9da918f25b9$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $9a32b9da918f25b9$var$rotrSH;
const $9a32b9da918f25b9$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $9a32b9da918f25b9$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9a32b9da918f25b9$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $9a32b9da918f25b9$var$rotrBH;
const $9a32b9da918f25b9$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $9a32b9da918f25b9$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $9a32b9da918f25b9$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $9a32b9da918f25b9$var$rotr32H;
const $9a32b9da918f25b9$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $9a32b9da918f25b9$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $9a32b9da918f25b9$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $9a32b9da918f25b9$var$rotlSH;
const $9a32b9da918f25b9$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $9a32b9da918f25b9$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9a32b9da918f25b9$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $9a32b9da918f25b9$var$rotlBH;
const $9a32b9da918f25b9$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $9a32b9da918f25b9$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $9a32b9da918f25b9$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $9a32b9da918f25b9$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $9a32b9da918f25b9$var$add3L;
const $9a32b9da918f25b9$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $9a32b9da918f25b9$var$add3H;
const $9a32b9da918f25b9$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $9a32b9da918f25b9$var$add4L;
const $9a32b9da918f25b9$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $9a32b9da918f25b9$var$add4H;
const $9a32b9da918f25b9$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $9a32b9da918f25b9$var$add5L;
const $9a32b9da918f25b9$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $9a32b9da918f25b9$var$add5H;
// prettier-ignore
const $9a32b9da918f25b9$var$u64 = {
    fromBig: $9a32b9da918f25b9$var$fromBig,
    split: $9a32b9da918f25b9$var$split,
    toBig: $9a32b9da918f25b9$var$toBig,
    shrSH: $9a32b9da918f25b9$var$shrSH,
    shrSL: $9a32b9da918f25b9$var$shrSL,
    rotrSH: $9a32b9da918f25b9$var$rotrSH,
    rotrSL: $9a32b9da918f25b9$var$rotrSL,
    rotrBH: $9a32b9da918f25b9$var$rotrBH,
    rotrBL: $9a32b9da918f25b9$var$rotrBL,
    rotr32H: $9a32b9da918f25b9$var$rotr32H,
    rotr32L: $9a32b9da918f25b9$var$rotr32L,
    rotlSH: $9a32b9da918f25b9$var$rotlSH,
    rotlSL: $9a32b9da918f25b9$var$rotlSL,
    rotlBH: $9a32b9da918f25b9$var$rotlBH,
    rotlBL: $9a32b9da918f25b9$var$rotlBL,
    add: $9a32b9da918f25b9$var$add,
    add3L: $9a32b9da918f25b9$var$add3L,
    add3H: $9a32b9da918f25b9$var$add3H,
    add4L: $9a32b9da918f25b9$var$add4L,
    add4H: $9a32b9da918f25b9$var$add4H,
    add5H: $9a32b9da918f25b9$var$add5H,
    add5L: $9a32b9da918f25b9$var$add5L
};
module.exports.default = $9a32b9da918f25b9$var$u64;

});


parcelRegister("i2942", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.twistedEdwards = $d20f71d601585143$var$twistedEdwards;

var $cXqn6 = parcelRequire("cXqn6");

var $ceIYS = parcelRequire("ceIYS");

var $to2Dk = parcelRequire("to2Dk");

var $to2Dk = parcelRequire("to2Dk");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $d20f71d601585143$var$_0n = BigInt(0), $d20f71d601585143$var$_1n = BigInt(1), $d20f71d601585143$var$_2n = BigInt(2), $d20f71d601585143$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $d20f71d601585143$var$VERIFY_DEFAULT = {
    zip215: true
};
function $d20f71d601585143$var$validateOpts(curve) {
    const opts = (0, $cXqn6.validateBasic)(curve);
    $to2Dk.validateObject(curve, {
        hash: 'function',
        a: 'bigint',
        d: 'bigint',
        randomBytes: 'function'
    }, {
        adjustScalarBytes: 'function',
        domain: 'function',
        uvRatio: 'function',
        mapToCurve: 'function'
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
/**
 * Creates Twisted Edwards curve with EdDSA signatures.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, d, p, n, Gx, Gy, h
 * const curve = twistedEdwards({ a, d, Fp: Field(p), n, Gx, Gy, h })
 */ function $d20f71d601585143$var$twistedEdwards(curveDef) {
    const CURVE = $d20f71d601585143$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    // Important:
    // There are some places where Fp.BYTES is used instead of nByteLength.
    // So far, everything has been tested with curves of Fp.BYTES == nByteLength.
    // TODO: test and find curves which behave otherwise.
    const MASK = $d20f71d601585143$var$_2n << BigInt(nByteLength * 8) - $d20f71d601585143$var$_1n;
    const modP = Fp.create; // Function overrides
    const Fn = (0, $ceIYS.Field)(CURVE.n, CURVE.nBitLength);
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $d20f71d601585143$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        (0, $to2Dk.abool)('phflag', phflag);
        if (ctx.length || phflag) throw new Error('Contexts/pre-hash are not supported');
        return data;
    }); // NOOP
    // 0 <= n < MASK
    // Coordinates larger than Fp.ORDER are allowed for zip215
    function aCoordinate(title, n) {
        $to2Dk.aInRange('coordinate ' + title, n, $d20f71d601585143$var$_0n, MASK);
    }
    function assertPoint(other) {
        if (!(other instanceof Point)) throw new Error('ExtendedPoint expected');
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $to2Dk.memoized)((p, iz)=>{
        const { ex: x, ey: y, ez: z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $d20f71d601585143$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
        const ax = modP(x * iz);
        const ay = modP(y * iz);
        const zz = modP(z * iz);
        if (is0) return {
            x: $d20f71d601585143$var$_0n,
            y: $d20f71d601585143$var$_1n
        };
        if (zz !== $d20f71d601585143$var$_1n) throw new Error('invZ was invalid');
        return {
            x: ax,
            y: ay
        };
    });
    const assertValidMemo = (0, $to2Dk.memoized)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error('bad point: ZERO'); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { ex: X, ey: Y, ez: Z, et: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error('bad point: equation left != right (1)');
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error('bad point: equation left != right (2)');
        return true;
    });
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            aCoordinate('x', ex);
            aCoordinate('y', ey);
            aCoordinate('z', ez);
            aCoordinate('t', et);
            Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error('extended point not allowed');
            const { x: x, y: y } = p || {};
            aCoordinate('x', x);
            aCoordinate('y', y);
            return new Point(x, y, $d20f71d601585143$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $cXqn6.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            assertPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($d20f71d601585143$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            assertPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $d20f71d601585143$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $d20f71d601585143$var$_2n * T2);
                const D = modP(T1 * $d20f71d601585143$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const n = scalar;
            $to2Dk.aInRange('scalar', n, $d20f71d601585143$var$_1n, CURVE_ORDER); // 1 <= scalar < L
            const { p: p, f: f } = this.wNAF(n);
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        // Accepts optional accumulator to merge with multiply (important for sparse scalars)
        multiplyUnsafe(scalar, acc = Point.ZERO) {
            const n = scalar;
            $to2Dk.aInRange('scalar', n, $d20f71d601585143$var$_0n, CURVE_ORDER); // 0 <= scalar < L
            if (n === $d20f71d601585143$var$_0n) return I;
            if (this.is0() || n === $d20f71d601585143$var$_1n) return this;
            return wnaf.wNAFCachedUnsafe(this, n, Point.normalizeZ, acc);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $d20f71d601585143$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $to2Dk.ensureBytes)('pointHex', hex, len); // copy hex to a new array
            (0, $to2Dk.abool)('zip215', zip215);
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $to2Dk.bytesToNumberLE(normed);
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            $to2Dk.aInRange('pointHex.y', y, $d20f71d601585143$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $d20f71d601585143$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error('Point.fromHex: invalid y coordinate');
            const isXOdd = (x & $d20f71d601585143$var$_1n) === $d20f71d601585143$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $d20f71d601585143$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error('Point.fromHex: x=0 and x_0=1');
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $to2Dk.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $d20f71d601585143$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $to2Dk.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $d20f71d601585143$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($d20f71d601585143$var$_0n, $d20f71d601585143$var$_1n, $d20f71d601585143$var$_1n, $d20f71d601585143$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $cXqn6.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $ceIYS.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($to2Dk.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = Fp.BYTES;
        key = (0, $to2Dk.ensureBytes)('private key', key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $to2Dk.ensureBytes)('hashed private key', cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $to2Dk.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $to2Dk.ensureBytes)('context', context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $to2Dk.ensureBytes)('message', msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        $to2Dk.aInRange('signature.s', s, $d20f71d601585143$var$_0n, CURVE_ORDER); // 0 <= s < l
        const res = $to2Dk.concatBytes(R, $to2Dk.numberToBytesLE(s, Fp.BYTES));
        return (0, $to2Dk.ensureBytes)('result', res, Fp.BYTES * 2); // 64-byte signature
    }
    const verifyOpts = $d20f71d601585143$var$VERIFY_DEFAULT;
    /**
     * Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
     * An extended group equation is checked.
     */ function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $to2Dk.ensureBytes)('signature', sig, 2 * len); // An extended group equation is checked.
        msg = (0, $to2Dk.ensureBytes)('message', msg);
        publicKey = (0, $to2Dk.ensureBytes)('publicKey', publicKey, len);
        if (zip215 !== undefined) (0, $to2Dk.abool)('zip215', zip215);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $to2Dk.bytesToNumberLE(sig.slice(len, 2 * len));
        let A, R, SB;
        try {
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // Extended group equation
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}

});

parcelRegister("g6f51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.montgomery = $bb88e7792f1d4402$var$montgomery;

var $ceIYS = parcelRequire("ceIYS");

var $to2Dk = parcelRequire("to2Dk");
const $bb88e7792f1d4402$var$_0n = BigInt(0);
const $bb88e7792f1d4402$var$_1n = BigInt(1);
function $bb88e7792f1d4402$var$validateOpts(curve) {
    (0, $to2Dk.validateObject)(curve, {
        a: 'bigint'
    }, {
        montgomeryBits: 'isSafeInteger',
        nByteLength: 'isSafeInteger',
        adjustScalarBytes: 'function',
        domain: 'function',
        powPminus2: 'function',
        Gu: 'bigint'
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
// Uses only one coordinate instead of two
function $bb88e7792f1d4402$var$montgomery(curveDef) {
    const CURVE = $bb88e7792f1d4402$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $ceIYS.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $ceIYS.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $to2Dk.aInRange)('u', u, $bb88e7792f1d4402$var$_0n, P);
        (0, $to2Dk.aInRange)('scalar', scalar, $bb88e7792f1d4402$var$_0n, P);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = scalar;
        const x_1 = u;
        let x_2 = $bb88e7792f1d4402$var$_1n;
        let z_2 = $bb88e7792f1d4402$var$_0n;
        let x_3 = u;
        let z_3 = $bb88e7792f1d4402$var$_1n;
        let swap = $bb88e7792f1d4402$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $bb88e7792f1d4402$var$_0n; t--){
            const k_t = k >> t & $bb88e7792f1d4402$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $to2Dk.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $to2Dk.ensureBytes)('u coordinate', uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $to2Dk.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $to2Dk.ensureBytes)('scalar', n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) {
            let valid = '' + montgomeryBytes + ' or ' + fieldLen;
            throw new Error('invalid scalar, expected ' + valid + ' bytes, got ' + len);
        }
        return (0, $to2Dk.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $bb88e7792f1d4402$var$_0n) throw new Error('invalid private or public key received');
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}

});




parcelRegister("cVkA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deriveXAddress = module.exports.deriveAddress = module.exports.deriveKeypair = void 0;

var $7eC3g = parcelRequire("7eC3g");

var $cYPJw = parcelRequire("cYPJw");
Object.defineProperty(module.exports, "deriveKeypair", {
    enumerable: true,
    get: function() {
        return $cYPJw.deriveKeypair;
    }
});
Object.defineProperty(module.exports, "deriveAddress", {
    enumerable: true,
    get: function() {
        return $cYPJw.deriveAddress;
    }
});
function $968ac5aa2e5c6e4a$var$deriveXAddress(options) {
    const classicAddress = (0, $cYPJw.deriveAddress)(options.publicKey);
    return (0, $7eC3g.classicAddressToXAddress)(classicAddress, options.tag, options.test);
}
module.exports.deriveXAddress = $968ac5aa2e5c6e4a$var$deriveXAddress;

});

parcelRegister("ggyID", function(module, exports) {
"use strict";
var $bd791269bb4abb2d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $bd791269bb4abb2d$var$bignumber_js_1 = $bd791269bb4abb2d$var$__importDefault((parcelRequire("hqAsy")));

var $2dibF = parcelRequire("2dibF");

var $iNnVr = parcelRequire("iNnVr");
function $bd791269bb4abb2d$var$normalizeNode(affectedNode) {
    const diffType = Object.keys(affectedNode)[0];
    const node = affectedNode[diffType];
    return Object.assign(Object.assign({}, node), {
        NodeType: diffType,
        LedgerEntryType: node.LedgerEntryType,
        LedgerIndex: node.LedgerIndex,
        NewFields: node.NewFields,
        FinalFields: node.FinalFields,
        PreviousFields: node.PreviousFields
    });
}
function $bd791269bb4abb2d$var$normalizeNodes(metadata) {
    if (metadata.AffectedNodes.length === 0) return [];
    return metadata.AffectedNodes.map($bd791269bb4abb2d$var$normalizeNode);
}
function $bd791269bb4abb2d$var$groupByAccount(balanceChanges) {
    const grouped = (0, $2dibF.groupBy)(balanceChanges, (node)=>node.account);
    return Object.entries(grouped).map(([account, items])=>{
        return {
            account: account,
            balances: items.map((item)=>item.balance)
        };
    });
}
function $bd791269bb4abb2d$var$getValue(balance) {
    if (typeof balance === 'string') return new $bd791269bb4abb2d$var$bignumber_js_1.default(balance);
    return new $bd791269bb4abb2d$var$bignumber_js_1.default(balance.value);
}
function $bd791269bb4abb2d$var$computeBalanceChange(node) {
    var _a, _b, _c;
    let value = null;
    if ((_a = node.NewFields) === null || _a === void 0 ? void 0 : _a.Balance) value = $bd791269bb4abb2d$var$getValue(node.NewFields.Balance);
    else if (((_b = node.PreviousFields) === null || _b === void 0 ? void 0 : _b.Balance) && ((_c = node.FinalFields) === null || _c === void 0 ? void 0 : _c.Balance)) value = $bd791269bb4abb2d$var$getValue(node.FinalFields.Balance).minus($bd791269bb4abb2d$var$getValue(node.PreviousFields.Balance));
    if (value === null || value.isZero()) return null;
    return value;
}
function $bd791269bb4abb2d$var$getXRPQuantity(node) {
    var _a, _b, _c;
    const value = $bd791269bb4abb2d$var$computeBalanceChange(node);
    if (value === null) return null;
    return {
        account: (_b = (_a = node.FinalFields) === null || _a === void 0 ? void 0 : _a.Account) !== null && _b !== void 0 ? _b : (_c = node.NewFields) === null || _c === void 0 ? void 0 : _c.Account,
        balance: {
            currency: 'XRP',
            value: (0, $iNnVr.dropsToXrp)(value).toString()
        }
    };
}
function $bd791269bb4abb2d$var$flipTrustlinePerspective(balanceChange) {
    const negatedBalance = new $bd791269bb4abb2d$var$bignumber_js_1.default(balanceChange.balance.value).negated();
    return {
        account: balanceChange.balance.issuer,
        balance: {
            issuer: balanceChange.account,
            currency: balanceChange.balance.currency,
            value: negatedBalance.toString()
        }
    };
}
function $bd791269bb4abb2d$var$getTrustlineQuantity(node) {
    var _a, _b;
    const value = $bd791269bb4abb2d$var$computeBalanceChange(node);
    if (value === null) return null;
    const fields = node.NewFields == null ? node.FinalFields : node.NewFields;
    const result = {
        account: (_a = fields === null || fields === void 0 ? void 0 : fields.LowLimit) === null || _a === void 0 ? void 0 : _a.issuer,
        balance: {
            issuer: (_b = fields === null || fields === void 0 ? void 0 : fields.HighLimit) === null || _b === void 0 ? void 0 : _b.issuer,
            currency: (fields === null || fields === void 0 ? void 0 : fields.Balance).currency,
            value: value.toString()
        }
    };
    return [
        result,
        $bd791269bb4abb2d$var$flipTrustlinePerspective(result)
    ];
}
function $bd791269bb4abb2d$var$getBalanceChanges(metadata) {
    const quantities = $bd791269bb4abb2d$var$normalizeNodes(metadata).map((node)=>{
        if (node.LedgerEntryType === 'AccountRoot') {
            const xrpQuantity = $bd791269bb4abb2d$var$getXRPQuantity(node);
            if (xrpQuantity == null) return [];
            return [
                xrpQuantity
            ];
        }
        if (node.LedgerEntryType === 'RippleState') {
            const trustlineQuantity = $bd791269bb4abb2d$var$getTrustlineQuantity(node);
            if (trustlineQuantity == null) return [];
            return trustlineQuantity;
        }
        return [];
    });
    return $bd791269bb4abb2d$var$groupByAccount(quantities.flat());
}
module.exports.default = $bd791269bb4abb2d$var$getBalanceChanges;

});
parcelRegister("2dibF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.omitBy = module.exports.groupBy = void 0;
function $19cae7468957eb18$var$groupBy(array, iteratee) {
    function predicate(acc, value, index, arrayReference) {
        const key = iteratee(value, index, arrayReference) || 0;
        const group = acc[key] || [];
        group.push(value);
        acc[key] = group;
        return acc;
    }
    return array.reduce(predicate, {});
}
module.exports.groupBy = $19cae7468957eb18$var$groupBy;
function $19cae7468957eb18$var$omitBy(obj, predicate) {
    const keys = Object.keys(obj);
    const keysToKeep = keys.filter((kb)=>!predicate(obj[kb], kb));
    return keysToKeep.reduce((acc, key)=>{
        acc[key] = obj[key];
        return acc;
    }, {});
}
module.exports.omitBy = $19cae7468957eb18$var$omitBy;

});

parcelRegister("iNnVr", function(module, exports) {
"use strict";
var $daef5cb400219780$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.xrpToDrops = module.exports.dropsToXrp = void 0;

const $daef5cb400219780$var$bignumber_js_1 = $daef5cb400219780$var$__importDefault((parcelRequire("hqAsy")));

var $aMl9I = parcelRequire("aMl9I");
const $daef5cb400219780$var$DROPS_PER_XRP = 1000000.0;
const $daef5cb400219780$var$MAX_FRACTION_LENGTH = 6;
const $daef5cb400219780$var$BASE_TEN = 10;
const $daef5cb400219780$var$SANITY_CHECK = /^-?[0-9.]+$/u;
function $daef5cb400219780$var$dropsToXrp(dropsToConvert) {
    const drops = new $daef5cb400219780$var$bignumber_js_1.default(dropsToConvert).toString($daef5cb400219780$var$BASE_TEN);
    if (typeof dropsToConvert === 'string' && drops === 'NaN') throw new $aMl9I.ValidationError(`dropsToXrp: invalid value '${dropsToConvert}', should be a BigNumber or string-encoded number.`);
    if (drops.includes('.')) throw new $aMl9I.ValidationError(`dropsToXrp: value '${drops}' has too many decimal places.`);
    if (!$daef5cb400219780$var$SANITY_CHECK.exec(drops)) throw new $aMl9I.ValidationError(`dropsToXrp: failed sanity check -` + ` value '${drops}',` + ` does not match (^-?[0-9]+$).`);
    return new $daef5cb400219780$var$bignumber_js_1.default(drops).dividedBy($daef5cb400219780$var$DROPS_PER_XRP).toNumber();
}
module.exports.dropsToXrp = $daef5cb400219780$var$dropsToXrp;
function $daef5cb400219780$var$xrpToDrops(xrpToConvert) {
    const xrp = new $daef5cb400219780$var$bignumber_js_1.default(xrpToConvert).toString($daef5cb400219780$var$BASE_TEN);
    if (typeof xrpToConvert === 'string' && xrp === 'NaN') throw new $aMl9I.ValidationError(`xrpToDrops: invalid value '${xrpToConvert}', should be a BigNumber or string-encoded number.`);
    if (!$daef5cb400219780$var$SANITY_CHECK.exec(xrp)) throw new $aMl9I.ValidationError(`xrpToDrops: failed sanity check - value '${xrp}', does not match (^-?[0-9.]+$).`);
    const components = xrp.split('.');
    if (components.length > 2) throw new $aMl9I.ValidationError(`xrpToDrops: failed sanity check - value '${xrp}' has too many decimal points.`);
    const fraction = components[1] || '0';
    if (fraction.length > $daef5cb400219780$var$MAX_FRACTION_LENGTH) throw new $aMl9I.ValidationError(`xrpToDrops: value '${xrp}' has too many decimal places.`);
    return new $daef5cb400219780$var$bignumber_js_1.default(xrp).times($daef5cb400219780$var$DROPS_PER_XRP).integerValue($daef5cb400219780$var$bignumber_js_1.default.ROUND_FLOOR).toString($daef5cb400219780$var$BASE_TEN);
}
module.exports.xrpToDrops = $daef5cb400219780$var$xrpToDrops;

});


parcelRegister("lgHcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eLMUD = parcelRequire("eLMUD");

var $ldSGe = parcelRequire("ldSGe");
function $f7bc9bd4634a0f02$var$ensureDecodedMeta(meta) {
    if (typeof meta === 'string') return (0, $eLMUD.decode)(meta);
    return meta;
}
function $f7bc9bd4634a0f02$var$getNFTokenID(meta) {
    if (typeof meta !== 'string' && (meta === null || meta === void 0 ? void 0 : meta.AffectedNodes) === undefined) throw new TypeError(`Unable to parse the parameter given to getNFTokenID.
      'meta' must be the metadata from an NFTokenMint transaction. Received ${JSON.stringify(meta)} instead.`);
    const decodedMeta = $f7bc9bd4634a0f02$var$ensureDecodedMeta(meta);
    const affectedNodes = decodedMeta.AffectedNodes.filter((node)=>{
        var _a;
        if ((0, $ldSGe.isCreatedNode)(node)) return node.CreatedNode.LedgerEntryType === 'NFTokenPage';
        if ((0, $ldSGe.isModifiedNode)(node)) return node.ModifiedNode.LedgerEntryType === 'NFTokenPage' && Boolean((_a = node.ModifiedNode.PreviousFields) === null || _a === void 0 ? void 0 : _a.NFTokens);
        return false;
    });
    const previousTokenIDSet = new Set(affectedNodes.flatMap((node)=>{
        var _a;
        const nftokens = (0, $ldSGe.isModifiedNode)(node) ? (_a = node.ModifiedNode.PreviousFields) === null || _a === void 0 ? void 0 : _a.NFTokens : [];
        return nftokens.map((token)=>token.NFToken.NFTokenID);
    }).filter((id)=>Boolean(id)));
    const finalTokenIDs = affectedNodes.flatMap((node)=>{
        var _a, _b, _c, _d, _e, _f;
        return ((_f = (_c = (_b = (_a = node.ModifiedNode) === null || _a === void 0 ? void 0 : _a.FinalFields) === null || _b === void 0 ? void 0 : _b.NFTokens) !== null && _c !== void 0 ? _c : (_e = (_d = node.CreatedNode) === null || _d === void 0 ? void 0 : _d.NewFields) === null || _e === void 0 ? void 0 : _e.NFTokens) !== null && _f !== void 0 ? _f : []).map((token)=>token.NFToken.NFTokenID);
    }).filter((nftokenID)=>Boolean(nftokenID));
    const nftokenID = finalTokenIDs.find((id)=>!previousTokenIDSet.has(id));
    return nftokenID;
}
module.exports.default = $f7bc9bd4634a0f02$var$getNFTokenID;

});
parcelRegister("ldSGe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDeletedNode = module.exports.isModifiedNode = module.exports.isCreatedNode = void 0;
function $f7353a395b8583b3$var$isCreatedNode(node) {
    return Object.prototype.hasOwnProperty.call(node, `CreatedNode`);
}
module.exports.isCreatedNode = $f7353a395b8583b3$var$isCreatedNode;
function $f7353a395b8583b3$var$isModifiedNode(node) {
    return Object.prototype.hasOwnProperty.call(node, `ModifiedNode`);
}
module.exports.isModifiedNode = $f7353a395b8583b3$var$isModifiedNode;
function $f7353a395b8583b3$var$isDeletedNode(node) {
    return Object.prototype.hasOwnProperty.call(node, `DeletedNode`);
}
module.exports.isDeletedNode = $f7353a395b8583b3$var$isDeletedNode;

});


parcelRegister("hg2av", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eLMUD = parcelRequire("eLMUD");

var $ldSGe = parcelRequire("ldSGe");
function $c9059ce933509c23$var$ensureDecodedMeta(meta) {
    if (typeof meta === 'string') return (0, $eLMUD.decode)(meta);
    return meta;
}
function $c9059ce933509c23$var$getXChainClaimID(meta) {
    if (typeof meta !== 'string' && (meta === null || meta === void 0 ? void 0 : meta.AffectedNodes) === undefined) throw new TypeError(`Unable to parse the parameter given to getXChainClaimID.
      'meta' must be the metadata from an XChainCreateClaimID transaction. Received ${JSON.stringify(meta)} instead.`);
    const decodedMeta = $c9059ce933509c23$var$ensureDecodedMeta(meta);
    if (!decodedMeta.TransactionResult) throw new TypeError('Cannot get XChainClaimID from un-validated transaction');
    if (decodedMeta.TransactionResult !== 'tesSUCCESS') return undefined;
    const createdNode = decodedMeta.AffectedNodes.find((node)=>(0, $ldSGe.isCreatedNode)(node) && node.CreatedNode.LedgerEntryType === 'XChainOwnedClaimID');
    return createdNode.CreatedNode.NewFields.XChainClaimID;
}
module.exports.default = $c9059ce933509c23$var$getXChainClaimID;

});

parcelRegister("2OCHQ", function(module, exports) {
"use strict";
var $20ce468b37632417$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $20ce468b37632417$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $20ce468b37632417$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $20ce468b37632417$var$__createBinding(result, mod, k);
    }
    $20ce468b37632417$var$__setModuleDefault(result, mod);
    return result;
};
var $20ce468b37632417$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashTxTree = module.exports.hashStateTree = module.exports.hashLedger = module.exports.hashSignedTx = module.exports.hashLedgerHeader = module.exports.hashPaymentChannel = module.exports.hashEscrow = module.exports.hashTrustline = module.exports.hashOfferId = module.exports.hashSignerListId = module.exports.hashAccountRoot = module.exports.hashTx = void 0;

var $8wxDW = parcelRequire("8wxDW");

const $20ce468b37632417$var$bignumber_js_1 = $20ce468b37632417$var$__importDefault((parcelRequire("hqAsy")));

var $7eC3g = parcelRequire("7eC3g");

const $20ce468b37632417$var$hashLedger_1 = $20ce468b37632417$var$__importStar((parcelRequire("gu1KQ")));
module.exports.hashLedger = $20ce468b37632417$var$hashLedger_1.default;
Object.defineProperty(module.exports, "hashLedgerHeader", {
    enumerable: true,
    get: function() {
        return $20ce468b37632417$var$hashLedger_1.hashLedgerHeader;
    }
});
Object.defineProperty(module.exports, "hashSignedTx", {
    enumerable: true,
    get: function() {
        return $20ce468b37632417$var$hashLedger_1.hashSignedTx;
    }
});
Object.defineProperty(module.exports, "hashTxTree", {
    enumerable: true,
    get: function() {
        return $20ce468b37632417$var$hashLedger_1.hashTxTree;
    }
});
Object.defineProperty(module.exports, "hashStateTree", {
    enumerable: true,
    get: function() {
        return $20ce468b37632417$var$hashLedger_1.hashStateTree;
    }
});

const $20ce468b37632417$var$HashPrefix_1 = $20ce468b37632417$var$__importDefault((parcelRequire("h2tZ3")));

const $20ce468b37632417$var$ledgerSpaces_1 = $20ce468b37632417$var$__importDefault((parcelRequire("ea0pL")));

const $20ce468b37632417$var$sha512Half_1 = $20ce468b37632417$var$__importDefault((parcelRequire("esW6c")));
const $20ce468b37632417$var$HEX = 16;
const $20ce468b37632417$var$BYTE_LENGTH = 4;
function $20ce468b37632417$var$addressToHex(address) {
    return (0, $8wxDW.bytesToHex)((0, $7eC3g.decodeAccountID)(address));
}
function $20ce468b37632417$var$ledgerSpaceHex(name) {
    return $20ce468b37632417$var$ledgerSpaces_1.default[name].charCodeAt(0).toString($20ce468b37632417$var$HEX).padStart(4, '0');
}
const $20ce468b37632417$var$MASK = 0xff;
function $20ce468b37632417$var$currencyToHex(currency) {
    if (currency.length !== 3) return currency;
    const bytes = Array(20).fill(0);
    bytes[12] = currency.charCodeAt(0) & $20ce468b37632417$var$MASK;
    bytes[13] = currency.charCodeAt(1) & $20ce468b37632417$var$MASK;
    bytes[14] = currency.charCodeAt(2) & $20ce468b37632417$var$MASK;
    return (0, $8wxDW.bytesToHex)(Uint8Array.from(bytes));
}
function $20ce468b37632417$var$hashTx(txBlobHex) {
    const prefix = $20ce468b37632417$var$HashPrefix_1.default.TRANSACTION_SIGN.toString($20ce468b37632417$var$HEX).toUpperCase();
    return (0, $20ce468b37632417$var$sha512Half_1.default)(prefix + txBlobHex);
}
module.exports.hashTx = $20ce468b37632417$var$hashTx;
function $20ce468b37632417$var$hashAccountRoot(address) {
    return (0, $20ce468b37632417$var$sha512Half_1.default)($20ce468b37632417$var$ledgerSpaceHex('account') + $20ce468b37632417$var$addressToHex(address));
}
module.exports.hashAccountRoot = $20ce468b37632417$var$hashAccountRoot;
function $20ce468b37632417$var$hashSignerListId(address) {
    return (0, $20ce468b37632417$var$sha512Half_1.default)(`${$20ce468b37632417$var$ledgerSpaceHex('signerList') + $20ce468b37632417$var$addressToHex(address)}00000000`);
}
module.exports.hashSignerListId = $20ce468b37632417$var$hashSignerListId;
function $20ce468b37632417$var$hashOfferId(address, sequence) {
    const hexPrefix = $20ce468b37632417$var$ledgerSpaces_1.default.offer.charCodeAt(0).toString($20ce468b37632417$var$HEX).padStart(2, '0');
    const hexSequence = sequence.toString($20ce468b37632417$var$HEX).padStart(8, '0');
    const prefix = `00${hexPrefix}`;
    return (0, $20ce468b37632417$var$sha512Half_1.default)(prefix + $20ce468b37632417$var$addressToHex(address) + hexSequence);
}
module.exports.hashOfferId = $20ce468b37632417$var$hashOfferId;
function $20ce468b37632417$var$hashTrustline(address1, address2, currency) {
    const address1Hex = $20ce468b37632417$var$addressToHex(address1);
    const address2Hex = $20ce468b37632417$var$addressToHex(address2);
    const swap = new $20ce468b37632417$var$bignumber_js_1.default(address1Hex, 16).isGreaterThan(new $20ce468b37632417$var$bignumber_js_1.default(address2Hex, 16));
    const lowAddressHex = swap ? address2Hex : address1Hex;
    const highAddressHex = swap ? address1Hex : address2Hex;
    const prefix = $20ce468b37632417$var$ledgerSpaceHex('rippleState');
    return (0, $20ce468b37632417$var$sha512Half_1.default)(prefix + lowAddressHex + highAddressHex + $20ce468b37632417$var$currencyToHex(currency));
}
module.exports.hashTrustline = $20ce468b37632417$var$hashTrustline;
function $20ce468b37632417$var$hashEscrow(address, sequence) {
    return (0, $20ce468b37632417$var$sha512Half_1.default)($20ce468b37632417$var$ledgerSpaceHex('escrow') + $20ce468b37632417$var$addressToHex(address) + sequence.toString($20ce468b37632417$var$HEX).padStart($20ce468b37632417$var$BYTE_LENGTH * 2, '0'));
}
module.exports.hashEscrow = $20ce468b37632417$var$hashEscrow;
function $20ce468b37632417$var$hashPaymentChannel(address, dstAddress, sequence) {
    return (0, $20ce468b37632417$var$sha512Half_1.default)($20ce468b37632417$var$ledgerSpaceHex('paychan') + $20ce468b37632417$var$addressToHex(address) + $20ce468b37632417$var$addressToHex(dstAddress) + sequence.toString($20ce468b37632417$var$HEX).padStart($20ce468b37632417$var$BYTE_LENGTH * 2, '0'));
}
module.exports.hashPaymentChannel = $20ce468b37632417$var$hashPaymentChannel;

});
parcelRegister("gu1KQ", function(module, exports) {
"use strict";
var $c000cf15cec5ee20$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c000cf15cec5ee20$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c000cf15cec5ee20$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c000cf15cec5ee20$var$__createBinding(result, mod, k);
    }
    $c000cf15cec5ee20$var$__setModuleDefault(result, mod);
    return result;
};
var $c000cf15cec5ee20$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashStateTree = module.exports.hashTxTree = module.exports.hashLedgerHeader = module.exports.hashSignedTx = void 0;

var $8wxDW = parcelRequire("8wxDW");

const $c000cf15cec5ee20$var$bignumber_js_1 = $c000cf15cec5ee20$var$__importDefault((parcelRequire("hqAsy")));

var $eLMUD = parcelRequire("eLMUD");

var $aMl9I = parcelRequire("aMl9I");

const $c000cf15cec5ee20$var$HashPrefix_1 = $c000cf15cec5ee20$var$__importDefault((parcelRequire("h2tZ3")));

const $c000cf15cec5ee20$var$sha512Half_1 = $c000cf15cec5ee20$var$__importDefault((parcelRequire("esW6c")));

const $c000cf15cec5ee20$var$SHAMap_1 = $c000cf15cec5ee20$var$__importStar((parcelRequire("ktbLy")));
const $c000cf15cec5ee20$var$HEX = 16;
function $c000cf15cec5ee20$var$intToHex(integer, byteLength) {
    const foo = Number(integer).toString($c000cf15cec5ee20$var$HEX).padStart(byteLength * 2, '0');
    return foo;
}
function $c000cf15cec5ee20$var$bigintToHex(integerString, byteLength) {
    const hex = new $c000cf15cec5ee20$var$bignumber_js_1.default(integerString).toString($c000cf15cec5ee20$var$HEX);
    return hex.padStart(byteLength * 2, '0');
}
function $c000cf15cec5ee20$var$addLengthPrefix(hex) {
    const length = hex.length / 2;
    if (length <= 192) return (0, $8wxDW.bytesToHex)([
        length
    ]) + hex;
    if (length <= 12480) {
        const prefix = length - 193;
        return (0, $8wxDW.bytesToHex)([
            193 + (prefix >>> 8),
            prefix & 0xff
        ]) + hex;
    }
    if (length <= 918744) {
        const prefix = length - 12481;
        return (0, $8wxDW.bytesToHex)([
            241 + (prefix >>> 16),
            prefix >>> 8 & 0xff,
            prefix & 0xff
        ]) + hex;
    }
    throw new $aMl9I.XrplError('Variable integer overflow.');
}
function $c000cf15cec5ee20$var$hashSignedTx(tx) {
    let txBlob;
    let txObject;
    if (typeof tx === 'string') {
        txBlob = tx;
        txObject = (0, $eLMUD.decode)(tx);
    } else {
        txBlob = (0, $eLMUD.encode)(tx);
        txObject = tx;
    }
    if (txObject.TxnSignature === undefined && txObject.Signers === undefined && txObject.SigningPubKey === undefined) throw new $aMl9I.ValidationError('The transaction must be signed to hash it.');
    const prefix = $c000cf15cec5ee20$var$HashPrefix_1.default.TRANSACTION_ID.toString(16).toUpperCase();
    return (0, $c000cf15cec5ee20$var$sha512Half_1.default)(prefix.concat(txBlob));
}
module.exports.hashSignedTx = $c000cf15cec5ee20$var$hashSignedTx;
function $c000cf15cec5ee20$var$hashLedgerHeader(ledgerHeader) {
    const prefix = $c000cf15cec5ee20$var$HashPrefix_1.default.LEDGER.toString($c000cf15cec5ee20$var$HEX).toUpperCase();
    const ledger = prefix + $c000cf15cec5ee20$var$intToHex(Number(ledgerHeader.ledger_index), 4) + $c000cf15cec5ee20$var$bigintToHex(ledgerHeader.total_coins, 8) + ledgerHeader.parent_hash + ledgerHeader.transaction_hash + ledgerHeader.account_hash + $c000cf15cec5ee20$var$intToHex(ledgerHeader.parent_close_time, 4) + $c000cf15cec5ee20$var$intToHex(ledgerHeader.close_time, 4) + $c000cf15cec5ee20$var$intToHex(ledgerHeader.close_time_resolution, 1) + $c000cf15cec5ee20$var$intToHex(ledgerHeader.close_flags, 1);
    return (0, $c000cf15cec5ee20$var$sha512Half_1.default)(ledger);
}
module.exports.hashLedgerHeader = $c000cf15cec5ee20$var$hashLedgerHeader;
function $c000cf15cec5ee20$var$hashTxTree(transactions) {
    var _a;
    const shamap = new $c000cf15cec5ee20$var$SHAMap_1.default();
    for (const txJSON of transactions){
        const txBlobHex = (0, $eLMUD.encode)(txJSON);
        const metaHex = (0, $eLMUD.encode)((_a = txJSON.metaData) !== null && _a !== void 0 ? _a : {});
        const txHash = $c000cf15cec5ee20$var$hashSignedTx(txBlobHex);
        const data = $c000cf15cec5ee20$var$addLengthPrefix(txBlobHex) + $c000cf15cec5ee20$var$addLengthPrefix(metaHex);
        shamap.addItem(txHash, data, $c000cf15cec5ee20$var$SHAMap_1.NodeType.TRANSACTION_METADATA);
    }
    return shamap.hash;
}
module.exports.hashTxTree = $c000cf15cec5ee20$var$hashTxTree;
function $c000cf15cec5ee20$var$hashStateTree(entries) {
    const shamap = new $c000cf15cec5ee20$var$SHAMap_1.default();
    entries.forEach((ledgerEntry)=>{
        const data = (0, $eLMUD.encode)(ledgerEntry);
        shamap.addItem(ledgerEntry.index, data, $c000cf15cec5ee20$var$SHAMap_1.NodeType.ACCOUNT_STATE);
    });
    return shamap.hash;
}
module.exports.hashStateTree = $c000cf15cec5ee20$var$hashStateTree;
function $c000cf15cec5ee20$var$computeTransactionHash(ledger, options) {
    const { transaction_hash: transaction_hash } = ledger;
    if (!options.computeTreeHashes) return transaction_hash;
    if (ledger.transactions == null) throw new $aMl9I.ValidationError('transactions is missing from the ledger');
    const transactionHash = $c000cf15cec5ee20$var$hashTxTree(ledger.transactions);
    if (transaction_hash !== transactionHash) throw new $aMl9I.ValidationError("transactionHash in header does not match computed hash of transactions", {
        transactionHashInHeader: transaction_hash,
        computedHashOfTransactions: transactionHash
    });
    return transactionHash;
}
function $c000cf15cec5ee20$var$computeStateHash(ledger, options) {
    const { account_hash: account_hash } = ledger;
    if (!options.computeTreeHashes) return account_hash;
    if (ledger.accountState == null) throw new $aMl9I.ValidationError('accountState is missing from the ledger');
    const stateHash = $c000cf15cec5ee20$var$hashStateTree(ledger.accountState);
    if (account_hash !== stateHash) throw new $aMl9I.ValidationError('stateHash in header does not match computed hash of state');
    return stateHash;
}
function $c000cf15cec5ee20$var$hashLedger(ledger, options = {}) {
    const subhashes = {
        transaction_hash: $c000cf15cec5ee20$var$computeTransactionHash(ledger, options),
        account_hash: $c000cf15cec5ee20$var$computeStateHash(ledger, options)
    };
    return $c000cf15cec5ee20$var$hashLedgerHeader(Object.assign(Object.assign({}, ledger), subhashes));
}
module.exports.default = $c000cf15cec5ee20$var$hashLedger;

});
parcelRegister("h2tZ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c679e1b5f3c32272$var$HashPrefix;
(function(HashPrefix) {
    HashPrefix[HashPrefix["TRANSACTION_ID"] = 1415073280] = "TRANSACTION_ID";
    HashPrefix[HashPrefix["TRANSACTION_NODE"] = 1397638144] = "TRANSACTION_NODE";
    HashPrefix[HashPrefix["INNER_NODE"] = 1296649728] = "INNER_NODE";
    HashPrefix[HashPrefix["LEAF_NODE"] = 1296846336] = "LEAF_NODE";
    HashPrefix[HashPrefix["TRANSACTION_SIGN"] = 1398036480] = "TRANSACTION_SIGN";
    HashPrefix[HashPrefix["TRANSACTION_SIGN_TESTNET"] = 1937012736] = "TRANSACTION_SIGN_TESTNET";
    HashPrefix[HashPrefix["TRANSACTION_MULTISIGN"] = 1397576704] = "TRANSACTION_MULTISIGN";
    HashPrefix[HashPrefix["LEDGER"] = 1280791040] = "LEDGER";
})($c679e1b5f3c32272$var$HashPrefix || ($c679e1b5f3c32272$var$HashPrefix = {}));
module.exports.default = $c679e1b5f3c32272$var$HashPrefix;

});

parcelRegister("esW6c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fBYrP = parcelRequire("fBYrP");

var $8wxDW = parcelRequire("8wxDW");
const $a880bf7a434dea48$var$HASH_BYTES = 32;
function $a880bf7a434dea48$var$sha512Half(hex) {
    return (0, $8wxDW.bytesToHex)((0, $fBYrP.sha512)((0, $8wxDW.hexToBytes)(hex)).slice(0, $a880bf7a434dea48$var$HASH_BYTES));
}
module.exports.default = $a880bf7a434dea48$var$sha512Half;

});

parcelRegister("ktbLy", function(module, exports) {
"use strict";
var $ee6fa48df6fc7ec1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee6fa48df6fc7ec1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee6fa48df6fc7ec1$var$__createBinding(exports1, m, p);
};
var $ee6fa48df6fc7ec1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ee6fa48df6fc7ec1$var$InnerNode_1 = $ee6fa48df6fc7ec1$var$__importDefault((parcelRequire("cu55T")));

const $ee6fa48df6fc7ec1$var$LeafNode_1 = $ee6fa48df6fc7ec1$var$__importDefault((parcelRequire("5vzru")));
class $ee6fa48df6fc7ec1$var$SHAMap {
    constructor(){
        this.root = new $ee6fa48df6fc7ec1$var$InnerNode_1.default(0);
    }
    get hash() {
        return this.root.hash;
    }
    addItem(tag, data, type) {
        this.root.addItem(tag, new $ee6fa48df6fc7ec1$var$LeafNode_1.default(tag, data, type));
    }
}

$ee6fa48df6fc7ec1$var$__exportStar((parcelRequire("4vXX9")), module.exports);
module.exports.default = $ee6fa48df6fc7ec1$var$SHAMap;

});
parcelRegister("cu55T", function(module, exports) {
"use strict";
var $916c3cf2796f1a5d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aMl9I = parcelRequire("aMl9I");

const $916c3cf2796f1a5d$var$HashPrefix_1 = $916c3cf2796f1a5d$var$__importDefault((parcelRequire("h2tZ3")));

const $916c3cf2796f1a5d$var$sha512Half_1 = $916c3cf2796f1a5d$var$__importDefault((parcelRequire("esW6c")));

const $916c3cf2796f1a5d$var$LeafNode_1 = $916c3cf2796f1a5d$var$__importDefault((parcelRequire("5vzru")));

var $4vXX9 = parcelRequire("4vXX9");
const $916c3cf2796f1a5d$var$HEX_ZERO = '0000000000000000000000000000000000000000000000000000000000000000';
const $916c3cf2796f1a5d$var$SLOT_MAX = 15;
const $916c3cf2796f1a5d$var$HEX = 16;
class $916c3cf2796f1a5d$var$InnerNode extends $4vXX9.Node {
    constructor(depth = 0){
        super();
        this.leaves = {};
        this.type = $4vXX9.NodeType.INNER;
        this.depth = depth;
        this.empty = true;
    }
    get hash() {
        if (this.empty) return $916c3cf2796f1a5d$var$HEX_ZERO;
        let hex = '';
        for(let iter = 0; iter <= $916c3cf2796f1a5d$var$SLOT_MAX; iter++){
            const child = this.leaves[iter];
            const hash = child == null ? $916c3cf2796f1a5d$var$HEX_ZERO : child.hash;
            hex += hash;
        }
        const prefix = $916c3cf2796f1a5d$var$HashPrefix_1.default.INNER_NODE.toString($916c3cf2796f1a5d$var$HEX);
        return (0, $916c3cf2796f1a5d$var$sha512Half_1.default)(prefix + hex);
    }
    addItem(tag, node) {
        const existingNode = this.getNode(parseInt(tag[this.depth], $916c3cf2796f1a5d$var$HEX));
        if (existingNode === undefined) {
            this.setNode(parseInt(tag[this.depth], $916c3cf2796f1a5d$var$HEX), node);
            return;
        }
        if (existingNode instanceof $916c3cf2796f1a5d$var$InnerNode) existingNode.addItem(tag, node);
        else if (existingNode instanceof $916c3cf2796f1a5d$var$LeafNode_1.default) {
            if (existingNode.tag === tag) throw new $aMl9I.XrplError('Tried to add a node to a SHAMap that was already in there.');
            else {
                const newInnerNode = new $916c3cf2796f1a5d$var$InnerNode(this.depth + 1);
                newInnerNode.addItem(existingNode.tag, existingNode);
                newInnerNode.addItem(tag, node);
                this.setNode(parseInt(tag[this.depth], $916c3cf2796f1a5d$var$HEX), newInnerNode);
            }
        }
    }
    setNode(slot, node) {
        if (slot < 0 || slot > $916c3cf2796f1a5d$var$SLOT_MAX) throw new $aMl9I.XrplError('Invalid slot: slot must be between 0-15.');
        this.leaves[slot] = node;
        this.empty = false;
    }
    getNode(slot) {
        if (slot < 0 || slot > $916c3cf2796f1a5d$var$SLOT_MAX) throw new $aMl9I.XrplError('Invalid slot: slot must be between 0-15.');
        return this.leaves[slot];
    }
}
module.exports.default = $916c3cf2796f1a5d$var$InnerNode;

});
parcelRegister("5vzru", function(module, exports) {
"use strict";
var $402b5724a58d3e7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aMl9I = parcelRequire("aMl9I");

const $402b5724a58d3e7b$var$HashPrefix_1 = $402b5724a58d3e7b$var$__importDefault((parcelRequire("h2tZ3")));

const $402b5724a58d3e7b$var$sha512Half_1 = $402b5724a58d3e7b$var$__importDefault((parcelRequire("esW6c")));

var $4vXX9 = parcelRequire("4vXX9");
const $402b5724a58d3e7b$var$HEX = 16;
class $402b5724a58d3e7b$var$LeafNode extends $4vXX9.Node {
    constructor(tag, data, type){
        super();
        this.tag = tag;
        this.type = type;
        this.data = data;
    }
    get hash() {
        switch(this.type){
            case $4vXX9.NodeType.ACCOUNT_STATE:
                {
                    const leafPrefix = $402b5724a58d3e7b$var$HashPrefix_1.default.LEAF_NODE.toString($402b5724a58d3e7b$var$HEX);
                    return (0, $402b5724a58d3e7b$var$sha512Half_1.default)(leafPrefix + this.data + this.tag);
                }
            case $4vXX9.NodeType.TRANSACTION_NO_METADATA:
                {
                    const txIDPrefix = $402b5724a58d3e7b$var$HashPrefix_1.default.TRANSACTION_ID.toString($402b5724a58d3e7b$var$HEX);
                    return (0, $402b5724a58d3e7b$var$sha512Half_1.default)(txIDPrefix + this.data);
                }
            case $4vXX9.NodeType.TRANSACTION_METADATA:
                {
                    const txNodePrefix = $402b5724a58d3e7b$var$HashPrefix_1.default.TRANSACTION_NODE.toString($402b5724a58d3e7b$var$HEX);
                    return (0, $402b5724a58d3e7b$var$sha512Half_1.default)(txNodePrefix + this.data + this.tag);
                }
            default:
                throw new $aMl9I.XrplError('Tried to hash a SHAMap node of unknown type.');
        }
    }
    addItem(tag, node) {
        throw new $aMl9I.XrplError('Cannot call addItem on a LeafNode');
    }
}
module.exports.default = $402b5724a58d3e7b$var$LeafNode;

});
parcelRegister("4vXX9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Node = module.exports.NodeType = void 0;
var $34989019f0784a20$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["INNER"] = 1] = "INNER";
    NodeType[NodeType["TRANSACTION_NO_METADATA"] = 2] = "TRANSACTION_NO_METADATA";
    NodeType[NodeType["TRANSACTION_METADATA"] = 3] = "TRANSACTION_METADATA";
    NodeType[NodeType["ACCOUNT_STATE"] = 4] = "ACCOUNT_STATE";
})($34989019f0784a20$var$NodeType || (module.exports.NodeType = $34989019f0784a20$var$NodeType = {}));
class $34989019f0784a20$var$Node {
}
module.exports.Node = $34989019f0784a20$var$Node;

});





parcelRegister("ea0pL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $a4f25232081e3949$var$ledgerSpaces = {
    account: 'a',
    dirNode: 'd',
    generatorMap: 'g',
    rippleState: 'r',
    offer: 'o',
    ownerDir: 'O',
    bookDir: 'B',
    contract: 'c',
    skipList: 's',
    escrow: 'u',
    amendment: 'f',
    feeSettings: 'e',
    ticket: 'T',
    signerList: 'S',
    paychan: 'x',
    check: 'C',
    depositPreauth: 'p'
};
module.exports.default = $a4f25232081e3949$var$ledgerSpaces;

});


parcelRegister("ivvUB", function(module, exports) {
"use strict";
var $d793e04f7bc6e535$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8wxDW = parcelRequire("8wxDW");

const $d793e04f7bc6e535$var$bignumber_js_1 = $d793e04f7bc6e535$var$__importDefault((parcelRequire("hqAsy")));

var $7eC3g = parcelRequire("7eC3g");

var $aMl9I = parcelRequire("aMl9I");
function $d793e04f7bc6e535$var$unscrambleTaxon(taxon, tokenSeq) {
    const seed = 384160001;
    const increment = 2459;
    const max = 4294967296;
    const scramble = new $d793e04f7bc6e535$var$bignumber_js_1.default(seed).multipliedBy(tokenSeq).modulo(max).plus(increment).modulo(max).toNumber();
    return (taxon ^ scramble) >>> 0;
}
function $d793e04f7bc6e535$var$parseNFTokenID(nftokenID) {
    const expectedLength = 64;
    if (nftokenID.length !== expectedLength) throw new $aMl9I.XrplError(`Attempting to parse a nftokenID with length ${nftokenID.length}
    , but expected a token with length ${expectedLength}`);
    const scrambledTaxon = new $d793e04f7bc6e535$var$bignumber_js_1.default(nftokenID.substring(48, 56), 16).toNumber();
    const sequence = new $d793e04f7bc6e535$var$bignumber_js_1.default(nftokenID.substring(56, 64), 16).toNumber();
    const NFTokenIDData = {
        NFTokenID: nftokenID,
        Flags: new $d793e04f7bc6e535$var$bignumber_js_1.default(nftokenID.substring(0, 4), 16).toNumber(),
        TransferFee: new $d793e04f7bc6e535$var$bignumber_js_1.default(nftokenID.substring(4, 8), 16).toNumber(),
        Issuer: (0, $7eC3g.encodeAccountID)((0, $8wxDW.hexToBytes)(nftokenID.substring(8, 48))),
        Taxon: $d793e04f7bc6e535$var$unscrambleTaxon(scrambledTaxon, sequence),
        Sequence: sequence
    };
    return NFTokenIDData;
}
module.exports.default = $d793e04f7bc6e535$var$parseNFTokenID;

});

parcelRegister("c3Xtp", function(module, exports) {
"use strict";
var $8c83e5ff411eaee2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.percentToQuality = module.exports.transferRateToDecimal = module.exports.qualityToDecimal = module.exports.decimalToQuality = module.exports.percentToTransferRate = module.exports.decimalToTransferRate = void 0;

const $8c83e5ff411eaee2$var$bignumber_js_1 = $8c83e5ff411eaee2$var$__importDefault((parcelRequire("hqAsy")));

var $aMl9I = parcelRequire("aMl9I");
const $8c83e5ff411eaee2$var$BASE_TEN = 10;
const $8c83e5ff411eaee2$var$ONE_BILLION = '1000000000';
const $8c83e5ff411eaee2$var$TWO_BILLION = '2000000000';
function $8c83e5ff411eaee2$var$percentToDecimal(percent) {
    if (!percent.endsWith('%')) throw new $aMl9I.ValidationError(`Value ${percent} must end with %`);
    const split = percent.split('%').filter((str)=>str !== '');
    if (split.length !== 1) throw new $aMl9I.ValidationError(`Value ${percent} contains too many % signs`);
    return new $8c83e5ff411eaee2$var$bignumber_js_1.default(split[0]).dividedBy('100').toString($8c83e5ff411eaee2$var$BASE_TEN);
}
function $8c83e5ff411eaee2$var$decimalToTransferRate(decimal) {
    const rate = new $8c83e5ff411eaee2$var$bignumber_js_1.default(decimal).times($8c83e5ff411eaee2$var$ONE_BILLION).plus($8c83e5ff411eaee2$var$ONE_BILLION);
    if (rate.isLessThan($8c83e5ff411eaee2$var$ONE_BILLION) || rate.isGreaterThan($8c83e5ff411eaee2$var$TWO_BILLION)) throw new $aMl9I.ValidationError(`Decimal value must be between 0 and 1.00.`);
    const billionths = rate.toString($8c83e5ff411eaee2$var$BASE_TEN);
    if (billionths === $8c83e5ff411eaee2$var$ONE_BILLION) return 0;
    if (billionths === 'NaN') throw new $aMl9I.ValidationError(`Value is not a number`);
    if (billionths.includes('.')) throw new $aMl9I.ValidationError(`Decimal exceeds maximum precision.`);
    return Number(billionths);
}
module.exports.decimalToTransferRate = $8c83e5ff411eaee2$var$decimalToTransferRate;
function $8c83e5ff411eaee2$var$percentToTransferRate(percent) {
    return $8c83e5ff411eaee2$var$decimalToTransferRate($8c83e5ff411eaee2$var$percentToDecimal(percent));
}
module.exports.percentToTransferRate = $8c83e5ff411eaee2$var$percentToTransferRate;
function $8c83e5ff411eaee2$var$decimalToQuality(decimal) {
    const rate = new $8c83e5ff411eaee2$var$bignumber_js_1.default(decimal).times($8c83e5ff411eaee2$var$ONE_BILLION);
    const billionths = rate.toString($8c83e5ff411eaee2$var$BASE_TEN);
    if (billionths === 'NaN') throw new $aMl9I.ValidationError(`Value is not a number`);
    if (billionths.includes('-')) throw new $aMl9I.ValidationError('Cannot have negative Quality');
    if (billionths === $8c83e5ff411eaee2$var$ONE_BILLION) return 0;
    if (billionths.includes('.')) throw new $aMl9I.ValidationError(`Decimal exceeds maximum precision.`);
    return Number(billionths);
}
module.exports.decimalToQuality = $8c83e5ff411eaee2$var$decimalToQuality;
function $8c83e5ff411eaee2$var$qualityToDecimal(quality) {
    if (!Number.isInteger(quality)) throw new $aMl9I.ValidationError('Quality must be an integer');
    if (quality < 0) throw new $aMl9I.ValidationError('Negative quality not allowed');
    if (quality === 0) return '1';
    const decimal = new $8c83e5ff411eaee2$var$bignumber_js_1.default(quality).dividedBy($8c83e5ff411eaee2$var$ONE_BILLION);
    return decimal.toString($8c83e5ff411eaee2$var$BASE_TEN);
}
module.exports.qualityToDecimal = $8c83e5ff411eaee2$var$qualityToDecimal;
function $8c83e5ff411eaee2$var$transferRateToDecimal(rate) {
    if (!Number.isInteger(rate)) throw new $aMl9I.ValidationError('Error decoding, transfer Rate must be an integer');
    if (rate === 0) return '0';
    const decimal = new $8c83e5ff411eaee2$var$bignumber_js_1.default(rate).minus($8c83e5ff411eaee2$var$ONE_BILLION).dividedBy($8c83e5ff411eaee2$var$ONE_BILLION);
    if (decimal.isLessThan(0)) throw new $aMl9I.ValidationError('Error decoding, negative transfer rate');
    return decimal.toString($8c83e5ff411eaee2$var$BASE_TEN);
}
module.exports.transferRateToDecimal = $8c83e5ff411eaee2$var$transferRateToDecimal;
function $8c83e5ff411eaee2$var$percentToQuality(percent) {
    return $8c83e5ff411eaee2$var$decimalToQuality($8c83e5ff411eaee2$var$percentToDecimal(percent));
}
module.exports.percentToQuality = $8c83e5ff411eaee2$var$percentToQuality;

});

parcelRegister("3oIYh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eLMUD = parcelRequire("eLMUD");

var $cYPJw = parcelRequire("cYPJw");

var $iNnVr = parcelRequire("iNnVr");
function $27967f5a9a6bb43d$var$signPaymentChannelClaim(channel, xrpAmount, privateKey) {
    const signingData = (0, $eLMUD.encodeForSigningClaim)({
        channel: channel,
        amount: (0, $iNnVr.xrpToDrops)(xrpAmount)
    });
    return (0, $cYPJw.sign)(signingData, privateKey);
}
module.exports.default = $27967f5a9a6bb43d$var$signPaymentChannelClaim;

});

parcelRegister("11XkW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertStringToHex = module.exports.convertHexToString = void 0;

var $8wxDW = parcelRequire("8wxDW");
function $0c03e9762d18adc0$var$convertStringToHex(string) {
    return (0, $8wxDW.stringToHex)(string);
}
module.exports.convertStringToHex = $0c03e9762d18adc0$var$convertStringToHex;
function $0c03e9762d18adc0$var$convertHexToString(hex, encoding = 'utf8') {
    return (0, $8wxDW.hexToString)(hex, encoding);
}
module.exports.convertHexToString = $0c03e9762d18adc0$var$convertHexToString;

});

parcelRegister("d0XAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoTimeToRippleTime = module.exports.rippleTimeToISOTime = module.exports.unixTimeToRippleTime = module.exports.rippleTimeToUnixTime = void 0;
const $97997f2bb807a890$var$RIPPLE_EPOCH_DIFF = 0x386d4380;
function $97997f2bb807a890$var$rippleTimeToUnixTime(rpepoch) {
    return (rpepoch + $97997f2bb807a890$var$RIPPLE_EPOCH_DIFF) * 1000;
}
module.exports.rippleTimeToUnixTime = $97997f2bb807a890$var$rippleTimeToUnixTime;
function $97997f2bb807a890$var$unixTimeToRippleTime(timestamp) {
    return Math.round(timestamp / 1000) - $97997f2bb807a890$var$RIPPLE_EPOCH_DIFF;
}
module.exports.unixTimeToRippleTime = $97997f2bb807a890$var$unixTimeToRippleTime;
function $97997f2bb807a890$var$rippleTimeToISOTime(rippleTime) {
    return new Date($97997f2bb807a890$var$rippleTimeToUnixTime(rippleTime)).toISOString();
}
module.exports.rippleTimeToISOTime = $97997f2bb807a890$var$rippleTimeToISOTime;
function $97997f2bb807a890$var$isoTimeToRippleTime(iso8601) {
    const isoDate = typeof iso8601 === 'string' ? new Date(iso8601) : iso8601;
    return $97997f2bb807a890$var$unixTimeToRippleTime(isoDate.getTime());
}
module.exports.isoTimeToRippleTime = $97997f2bb807a890$var$isoTimeToRippleTime;

});

parcelRegister("5UhwR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eLMUD = parcelRequire("eLMUD");

var $cYPJw = parcelRequire("cYPJw");

var $iNnVr = parcelRequire("iNnVr");
function $44cfc798368238b5$var$verifyPaymentChannelClaim(channel, xrpAmount, signature, publicKey) {
    const signingData = (0, $eLMUD.encodeForSigningClaim)({
        channel: channel,
        amount: (0, $iNnVr.xrpToDrops)(xrpAmount)
    });
    return (0, $cYPJw.verify)(signingData, signature, publicKey);
}
module.exports.default = $44cfc798368238b5$var$verifyPaymentChannelClaim;

});



parcelRegister("17lL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ensureClassicAddress = void 0;

var $7eC3g = parcelRequire("7eC3g");
function $0d0752874f420cc6$var$ensureClassicAddress(account) {
    if ((0, $7eC3g.isValidXAddress)(account)) {
        const { classicAddress: classicAddress, tag: tag } = (0, $7eC3g.xAddressToClassicAddress)(account);
        if (tag !== false) throw new Error('This command does not support the use of a tag. Use an address without a tag.');
        return classicAddress;
    }
    return account;
}
module.exports.ensureClassicAddress = $0d0752874f420cc6$var$ensureClassicAddress;

});


parcelRegister("aCoW3", function(module, exports) {
"use strict";
var $7bb0cb9eb55d9238$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7bb0cb9eb55d9238$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkAccountDeleteBlockers = module.exports.setLatestValidatedLedgerSequence = module.exports.calculateFeePerTransactionType = module.exports.setNextValidSequenceNumber = module.exports.setValidAddresses = module.exports.txNeedsNetworkID = void 0;

const $7bb0cb9eb55d9238$var$bignumber_js_1 = $7bb0cb9eb55d9238$var$__importDefault((parcelRequire("hqAsy")));

var $7eC3g = parcelRequire("7eC3g");

var $aMl9I = parcelRequire("aMl9I");

var $3Urjz = parcelRequire("3Urjz");

const $7bb0cb9eb55d9238$var$getFeeXrp_1 = $7bb0cb9eb55d9238$var$__importDefault((parcelRequire("03wln")));
const $7bb0cb9eb55d9238$var$LEDGER_OFFSET = 20;
const $7bb0cb9eb55d9238$var$RESTRICTED_NETWORKS = 1024;
const $7bb0cb9eb55d9238$var$REQUIRED_NETWORKID_VERSION = '1.11.0';
function $7bb0cb9eb55d9238$var$isNotLaterRippledVersion(source, target) {
    if (source === target) return true;
    const sourceDecomp = source.split('.');
    const targetDecomp = target.split('.');
    const sourceMajor = parseInt(sourceDecomp[0], 10);
    const sourceMinor = parseInt(sourceDecomp[1], 10);
    const targetMajor = parseInt(targetDecomp[0], 10);
    const targetMinor = parseInt(targetDecomp[1], 10);
    if (sourceMajor !== targetMajor) return sourceMajor < targetMajor;
    if (sourceMinor !== targetMinor) return sourceMinor < targetMinor;
    const sourcePatch = sourceDecomp[2].split('-');
    const targetPatch = targetDecomp[2].split('-');
    const sourcePatchVersion = parseInt(sourcePatch[0], 10);
    const targetPatchVersion = parseInt(targetPatch[0], 10);
    if (sourcePatchVersion !== targetPatchVersion) return sourcePatchVersion < targetPatchVersion;
    if (sourcePatch.length !== targetPatch.length) return sourcePatch.length > targetPatch.length;
    if (sourcePatch.length === 2) {
        if (!sourcePatch[1][0].startsWith(targetPatch[1][0])) return sourcePatch[1] < targetPatch[1];
        if (sourcePatch[1].startsWith('b')) return parseInt(sourcePatch[1].slice(1), 10) < parseInt(targetPatch[1].slice(1), 10);
        return parseInt(sourcePatch[1].slice(2), 10) < parseInt(targetPatch[1].slice(2), 10);
    }
    return false;
}
function $7bb0cb9eb55d9238$var$txNeedsNetworkID(client) {
    if (client.networkID !== undefined && client.networkID > $7bb0cb9eb55d9238$var$RESTRICTED_NETWORKS) {
        if (client.buildVersion && $7bb0cb9eb55d9238$var$isNotLaterRippledVersion($7bb0cb9eb55d9238$var$REQUIRED_NETWORKID_VERSION, client.buildVersion)) return true;
    }
    return false;
}
module.exports.txNeedsNetworkID = $7bb0cb9eb55d9238$var$txNeedsNetworkID;
function $7bb0cb9eb55d9238$var$setValidAddresses(tx) {
    $7bb0cb9eb55d9238$var$validateAccountAddress(tx, 'Account', 'SourceTag');
    if (tx['Destination'] != null) $7bb0cb9eb55d9238$var$validateAccountAddress(tx, 'Destination', 'DestinationTag');
    $7bb0cb9eb55d9238$var$convertToClassicAddress(tx, 'Authorize');
    $7bb0cb9eb55d9238$var$convertToClassicAddress(tx, 'Unauthorize');
    $7bb0cb9eb55d9238$var$convertToClassicAddress(tx, 'Owner');
    $7bb0cb9eb55d9238$var$convertToClassicAddress(tx, 'RegularKey');
}
module.exports.setValidAddresses = $7bb0cb9eb55d9238$var$setValidAddresses;
function $7bb0cb9eb55d9238$var$validateAccountAddress(tx, accountField, tagField) {
    const { classicAccount: classicAccount, tag: tag } = $7bb0cb9eb55d9238$var$getClassicAccountAndTag(tx[accountField]);
    tx[accountField] = classicAccount;
    if (tag != null && tag !== false) {
        if (tx[tagField] && tx[tagField] !== tag) throw new $aMl9I.ValidationError(`The ${tagField}, if present, must match the tag of the ${accountField} X-address`);
        tx[tagField] = tag;
    }
}
function $7bb0cb9eb55d9238$var$getClassicAccountAndTag(Account, expectedTag) {
    if ((0, $7eC3g.isValidXAddress)(Account)) {
        const classic = (0, $7eC3g.xAddressToClassicAddress)(Account);
        if (expectedTag != null && classic.tag !== expectedTag) throw new $aMl9I.ValidationError('address includes a tag that does not match the tag specified in the transaction');
        return {
            classicAccount: classic.classicAddress,
            tag: classic.tag
        };
    }
    return {
        classicAccount: Account,
        tag: expectedTag
    };
}
function $7bb0cb9eb55d9238$var$convertToClassicAddress(tx, fieldName) {
    const account = tx[fieldName];
    if (typeof account === 'string') {
        const { classicAccount: classicAccount } = $7bb0cb9eb55d9238$var$getClassicAccountAndTag(account);
        tx[fieldName] = classicAccount;
    }
}
function $7bb0cb9eb55d9238$var$setNextValidSequenceNumber(client, tx) {
    return $7bb0cb9eb55d9238$var$__awaiter(this, void 0, void 0, function*() {
        const request = {
            command: 'account_info',
            account: tx.Account,
            ledger_index: 'current'
        };
        const data = yield client.request(request);
        tx.Sequence = data.result.account_data.Sequence;
    });
}
module.exports.setNextValidSequenceNumber = $7bb0cb9eb55d9238$var$setNextValidSequenceNumber;
function $7bb0cb9eb55d9238$var$fetchAccountDeleteFee(client) {
    var _a;
    return $7bb0cb9eb55d9238$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield client.request({
            command: 'server_state'
        });
        const fee = (_a = response.result.state.validated_ledger) === null || _a === void 0 ? void 0 : _a.reserve_inc;
        if (fee == null) return Promise.reject(new Error('Could not fetch Owner Reserve.'));
        return new $7bb0cb9eb55d9238$var$bignumber_js_1.default(fee);
    });
}
function $7bb0cb9eb55d9238$var$calculateFeePerTransactionType(client, tx, signersCount = 0) {
    return $7bb0cb9eb55d9238$var$__awaiter(this, void 0, void 0, function*() {
        const netFeeXRP = yield (0, $7bb0cb9eb55d9238$var$getFeeXrp_1.default)(client);
        const netFeeDrops = (0, $3Urjz.xrpToDrops)(netFeeXRP);
        let baseFee = new $7bb0cb9eb55d9238$var$bignumber_js_1.default(netFeeDrops);
        if (tx.TransactionType === 'EscrowFinish' && tx.Fulfillment != null) {
            const fulfillmentBytesSize = Math.ceil(tx.Fulfillment.length / 2);
            const product = new $7bb0cb9eb55d9238$var$bignumber_js_1.default($7bb0cb9eb55d9238$var$scaleValue(netFeeDrops, 33 + fulfillmentBytesSize / 16));
            baseFee = product.dp(0, $7bb0cb9eb55d9238$var$bignumber_js_1.default.ROUND_CEIL);
        }
        if (tx.TransactionType === 'AccountDelete' || tx.TransactionType === 'AMMCreate') baseFee = yield $7bb0cb9eb55d9238$var$fetchAccountDeleteFee(client);
        if (signersCount > 0) baseFee = $7bb0cb9eb55d9238$var$bignumber_js_1.default.sum(baseFee, $7bb0cb9eb55d9238$var$scaleValue(netFeeDrops, 1 + signersCount));
        const maxFeeDrops = (0, $3Urjz.xrpToDrops)(client.maxFeeXRP);
        const totalFee = tx.TransactionType === 'AccountDelete' ? baseFee : $7bb0cb9eb55d9238$var$bignumber_js_1.default.min(baseFee, maxFeeDrops);
        tx.Fee = totalFee.dp(0, $7bb0cb9eb55d9238$var$bignumber_js_1.default.ROUND_CEIL).toString(10);
    });
}
module.exports.calculateFeePerTransactionType = $7bb0cb9eb55d9238$var$calculateFeePerTransactionType;
function $7bb0cb9eb55d9238$var$scaleValue(value, multiplier) {
    return new $7bb0cb9eb55d9238$var$bignumber_js_1.default(value).times(multiplier).toString();
}
function $7bb0cb9eb55d9238$var$setLatestValidatedLedgerSequence(client, tx) {
    return $7bb0cb9eb55d9238$var$__awaiter(this, void 0, void 0, function*() {
        const ledgerSequence = yield client.getLedgerIndex();
        tx.LastLedgerSequence = ledgerSequence + $7bb0cb9eb55d9238$var$LEDGER_OFFSET;
    });
}
module.exports.setLatestValidatedLedgerSequence = $7bb0cb9eb55d9238$var$setLatestValidatedLedgerSequence;
function $7bb0cb9eb55d9238$var$checkAccountDeleteBlockers(client, tx) {
    return $7bb0cb9eb55d9238$var$__awaiter(this, void 0, void 0, function*() {
        const request = {
            command: 'account_objects',
            account: tx.Account,
            ledger_index: 'validated',
            deletion_blockers_only: true
        };
        const response = yield client.request(request);
        return new Promise((resolve, reject)=>{
            if (response.result.account_objects.length > 0) reject(new $aMl9I.XrplError(`Account ${tx.Account} cannot be deleted; there are Escrows, PayChannels, RippleStates, or Checks associated with the account.`, response.result.account_objects));
            resolve();
        });
    });
}
module.exports.checkAccountDeleteBlockers = $7bb0cb9eb55d9238$var$checkAccountDeleteBlockers;

});
parcelRegister("03wln", function(module, exports) {
"use strict";
var $00a95eb8a4c96b27$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $00a95eb8a4c96b27$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $00a95eb8a4c96b27$var$bignumber_js_1 = $00a95eb8a4c96b27$var$__importDefault((parcelRequire("hqAsy")));

var $aMl9I = parcelRequire("aMl9I");
const $00a95eb8a4c96b27$var$NUM_DECIMAL_PLACES = 6;
const $00a95eb8a4c96b27$var$BASE_10 = 10;
function $00a95eb8a4c96b27$var$getFeeXrp(client, cushion) {
    var _a;
    return $00a95eb8a4c96b27$var$__awaiter(this, void 0, void 0, function*() {
        const feeCushion = cushion !== null && cushion !== void 0 ? cushion : client.feeCushion;
        const serverInfo = (yield client.request({
            command: 'server_info'
        })).result.info;
        const baseFee = (_a = serverInfo.validated_ledger) === null || _a === void 0 ? void 0 : _a.base_fee_xrp;
        if (baseFee == null) throw new $aMl9I.XrplError('getFeeXrp: Could not get base_fee_xrp from server_info');
        const baseFeeXrp = new $00a95eb8a4c96b27$var$bignumber_js_1.default(baseFee);
        if (serverInfo.load_factor == null) serverInfo.load_factor = 1;
        let fee = baseFeeXrp.times(serverInfo.load_factor).times(feeCushion);
        fee = $00a95eb8a4c96b27$var$bignumber_js_1.default.min(fee, client.maxFeeXRP);
        return new $00a95eb8a4c96b27$var$bignumber_js_1.default(fee.toFixed($00a95eb8a4c96b27$var$NUM_DECIMAL_PLACES)).toString($00a95eb8a4c96b27$var$BASE_10);
    });
}
module.exports.default = $00a95eb8a4c96b27$var$getFeeXrp;

});


parcelRegister("9UKGz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatBalances = void 0;
function $737d8ecb3df211c6$var$formatBalances(trustlines) {
    return trustlines.map((trustline)=>({
            value: trustline.balance,
            currency: trustline.currency,
            issuer: trustline.account
        }));
}
module.exports.formatBalances = $737d8ecb3df211c6$var$formatBalances;

});

parcelRegister("73BaH", function(module, exports) {
"use strict";
var $5235a5b3a0d12eb3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5235a5b3a0d12eb3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortAndLimitOffers = module.exports.separateBuySellOrders = module.exports.combineOrders = module.exports.extractOffers = module.exports.reverseRequest = module.exports.requestAllOffers = module.exports.createBookOffersRequest = module.exports.validateOrderbookOptions = void 0;

const $5235a5b3a0d12eb3$var$bignumber_js_1 = $5235a5b3a0d12eb3$var$__importDefault((parcelRequire("hqAsy")));

var $aMl9I = parcelRequire("aMl9I");

var $4alJn = parcelRequire("4alJn");
const $5235a5b3a0d12eb3$var$DEFAULT_LIMIT = 20;
function $5235a5b3a0d12eb3$var$sortOffers(offers) {
    return offers.sort((offerA, offerB)=>{
        var _a, _b;
        const qualityA = (_a = offerA.quality) !== null && _a !== void 0 ? _a : 0;
        const qualityB = (_b = offerB.quality) !== null && _b !== void 0 ? _b : 0;
        return new $5235a5b3a0d12eb3$var$bignumber_js_1.default(qualityA).comparedTo(qualityB);
    });
}
const $5235a5b3a0d12eb3$var$getOrderbookOptionsSet = new Set([
    'limit',
    'ledger_index',
    'ledger_hash',
    'taker'
]);
function $5235a5b3a0d12eb3$var$validateOrderbookOptions(options) {
    for (const key of Object.keys(options)){
        if (!$5235a5b3a0d12eb3$var$getOrderbookOptionsSet.has(key)) throw new $aMl9I.ValidationError(`Unexpected option: ${key}`, options);
    }
    if (options.limit && typeof options.limit !== 'number') throw new $aMl9I.ValidationError('limit must be a number', options.limit);
    if (options.ledger_index && !(typeof options.ledger_index === 'number' || typeof options.ledger_index === 'string' && [
        'validated',
        'closed',
        'current'
    ].includes(options.ledger_index))) throw new $aMl9I.ValidationError('ledger_index must be a number or a string of "validated", "closed", or "current"', options.ledger_index);
    if (options.ledger_hash !== undefined && options.ledger_hash !== null && typeof options.ledger_hash !== 'string') throw new $aMl9I.ValidationError('ledger_hash must be a string', options.ledger_hash);
    if (options.taker !== undefined && typeof options.taker !== 'string') throw new $aMl9I.ValidationError('taker must be a string', options.taker);
}
module.exports.validateOrderbookOptions = $5235a5b3a0d12eb3$var$validateOrderbookOptions;
function $5235a5b3a0d12eb3$var$createBookOffersRequest(currency1, currency2, options) {
    var _a, _b;
    const request = {
        command: 'book_offers',
        taker_pays: currency1,
        taker_gets: currency2,
        ledger_index: (_a = options.ledger_index) !== null && _a !== void 0 ? _a : 'validated',
        ledger_hash: options.ledger_hash === null ? undefined : options.ledger_hash,
        limit: (_b = options.limit) !== null && _b !== void 0 ? _b : $5235a5b3a0d12eb3$var$DEFAULT_LIMIT,
        taker: options.taker ? options.taker : undefined
    };
    return request;
}
module.exports.createBookOffersRequest = $5235a5b3a0d12eb3$var$createBookOffersRequest;
function $5235a5b3a0d12eb3$var$requestAllOffers(client, request) {
    return $5235a5b3a0d12eb3$var$__awaiter(this, void 0, void 0, function*() {
        const results = yield client.requestAll(request);
        return results.map((result)=>result.result.offers);
    });
}
module.exports.requestAllOffers = $5235a5b3a0d12eb3$var$requestAllOffers;
function $5235a5b3a0d12eb3$var$reverseRequest(request) {
    return Object.assign(Object.assign({}, request), {
        taker_pays: request.taker_gets,
        taker_gets: request.taker_pays
    });
}
module.exports.reverseRequest = $5235a5b3a0d12eb3$var$reverseRequest;
function $5235a5b3a0d12eb3$var$extractOffers(offerResults) {
    return offerResults.flatMap((offerResult)=>offerResult);
}
module.exports.extractOffers = $5235a5b3a0d12eb3$var$extractOffers;
function $5235a5b3a0d12eb3$var$combineOrders(directOffers, reverseOffers) {
    return [
        ...directOffers,
        ...reverseOffers
    ];
}
module.exports.combineOrders = $5235a5b3a0d12eb3$var$combineOrders;
function $5235a5b3a0d12eb3$var$separateBuySellOrders(orders) {
    const buy = [];
    const sell = [];
    orders.forEach((order)=>{
        if ((order.Flags & $4alJn.OfferFlags.lsfSell) === 0) buy.push(order);
        else sell.push(order);
    });
    return {
        buy: buy,
        sell: sell
    };
}
module.exports.separateBuySellOrders = $5235a5b3a0d12eb3$var$separateBuySellOrders;
function $5235a5b3a0d12eb3$var$sortAndLimitOffers(offers, limit) {
    const sortedOffers = $5235a5b3a0d12eb3$var$sortOffers(offers);
    return sortedOffers.slice(0, limit);
}
module.exports.sortAndLimitOffers = $5235a5b3a0d12eb3$var$sortAndLimitOffers;

});
parcelRegister("4alJn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OfferFlags = void 0;
var $3088f3e54bbfab57$var$OfferFlags;
(function(OfferFlags) {
    OfferFlags[OfferFlags["lsfPassive"] = 65536] = "lsfPassive";
    OfferFlags[OfferFlags["lsfSell"] = 131072] = "lsfSell";
})($3088f3e54bbfab57$var$OfferFlags || (module.exports.OfferFlags = $3088f3e54bbfab57$var$OfferFlags = {}));

});


parcelRegister("81kGK", function(module, exports) {
"use strict";
var $5d6e7707e742dd91$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Wallet = void 0;

var $5NcYj = parcelRequire("5NcYj");

var $bEGP4 = parcelRequire("bEGP4");

var $81mA2 = parcelRequire("81mA2");

var $8wxDW = parcelRequire("8wxDW");

const $5d6e7707e742dd91$var$bignumber_js_1 = $5d6e7707e742dd91$var$__importDefault((parcelRequire("hqAsy")));

var $7eC3g = parcelRequire("7eC3g");

var $eLMUD = parcelRequire("eLMUD");

var $cYPJw = parcelRequire("cYPJw");

const $5d6e7707e742dd91$var$ECDSA_1 = $5d6e7707e742dd91$var$__importDefault((parcelRequire("jbgk0")));

var $aMl9I = parcelRequire("aMl9I");

var $64n0b = parcelRequire("64n0b");

var $17lL2 = parcelRequire("17lL2");

var $2dibF = parcelRequire("2dibF");

var $gu1KQ = parcelRequire("gu1KQ");

var $hlDCx = parcelRequire("hlDCx");

var $5VcT1 = parcelRequire("5VcT1");
const $5d6e7707e742dd91$var$DEFAULT_ALGORITHM = $5d6e7707e742dd91$var$ECDSA_1.default.ed25519;
const $5d6e7707e742dd91$var$DEFAULT_DERIVATION_PATH = "m/44'/144'/0'/0/0";
function $5d6e7707e742dd91$var$validateKey(node) {
    if (!(node.privateKey instanceof Uint8Array)) throw new $aMl9I.ValidationError('Unable to derive privateKey from mnemonic input');
    if (!(node.publicKey instanceof Uint8Array)) throw new $aMl9I.ValidationError('Unable to derive publicKey from mnemonic input');
}
class $5d6e7707e742dd91$var$Wallet {
    constructor(publicKey, privateKey, opts = {}){
        this.publicKey = publicKey;
        this.privateKey = privateKey;
        this.classicAddress = opts.masterAddress ? (0, $17lL2.ensureClassicAddress)(opts.masterAddress) : (0, $cYPJw.deriveAddress)(publicKey);
        this.seed = opts.seed;
    }
    get address() {
        return this.classicAddress;
    }
    static generate(algorithm = $5d6e7707e742dd91$var$DEFAULT_ALGORITHM) {
        if (!Object.values($5d6e7707e742dd91$var$ECDSA_1.default).includes(algorithm)) throw new $aMl9I.ValidationError('Invalid cryptographic signing algorithm');
        const seed = (0, $cYPJw.generateSeed)({
            algorithm: algorithm
        });
        return $5d6e7707e742dd91$var$Wallet.fromSeed(seed, {
            algorithm: algorithm
        });
    }
    static fromSeed(seed, opts = {}) {
        return $5d6e7707e742dd91$var$Wallet.deriveWallet(seed, {
            algorithm: opts.algorithm,
            masterAddress: opts.masterAddress
        });
    }
    static fromEntropy(entropy, opts = {}) {
        var _a;
        const algorithm = (_a = opts.algorithm) !== null && _a !== void 0 ? _a : $5d6e7707e742dd91$var$DEFAULT_ALGORITHM;
        const options = {
            entropy: Uint8Array.from(entropy),
            algorithm: algorithm
        };
        const seed = (0, $cYPJw.generateSeed)(options);
        return $5d6e7707e742dd91$var$Wallet.deriveWallet(seed, {
            algorithm: algorithm,
            masterAddress: opts.masterAddress
        });
    }
    static fromMnemonic(mnemonic, opts = {}) {
        var _a;
        if (opts.mnemonicEncoding === 'rfc1751') return $5d6e7707e742dd91$var$Wallet.fromRFC1751Mnemonic(mnemonic, {
            masterAddress: opts.masterAddress,
            algorithm: opts.algorithm
        });
        if (!(0, $bEGP4.validateMnemonic)(mnemonic, $81mA2.wordlist)) throw new $aMl9I.ValidationError('Unable to parse the given mnemonic using bip39 encoding');
        const seed = (0, $bEGP4.mnemonicToSeedSync)(mnemonic);
        const masterNode = $5NcYj.HDKey.fromMasterSeed(seed);
        const node = masterNode.derive((_a = opts.derivationPath) !== null && _a !== void 0 ? _a : $5d6e7707e742dd91$var$DEFAULT_DERIVATION_PATH);
        $5d6e7707e742dd91$var$validateKey(node);
        const publicKey = (0, $8wxDW.bytesToHex)(node.publicKey);
        const privateKey = (0, $8wxDW.bytesToHex)(node.privateKey);
        return new $5d6e7707e742dd91$var$Wallet(publicKey, `00${privateKey}`, {
            masterAddress: opts.masterAddress
        });
    }
    static fromRFC1751Mnemonic(mnemonic, opts) {
        const seed = (0, $hlDCx.rfc1751MnemonicToKey)(mnemonic);
        let encodeAlgorithm;
        if (opts.algorithm === $5d6e7707e742dd91$var$ECDSA_1.default.ed25519) encodeAlgorithm = 'ed25519';
        else encodeAlgorithm = 'secp256k1';
        const encodedSeed = (0, $7eC3g.encodeSeed)(seed, encodeAlgorithm);
        return $5d6e7707e742dd91$var$Wallet.fromSeed(encodedSeed, {
            masterAddress: opts.masterAddress,
            algorithm: opts.algorithm
        });
    }
    static deriveWallet(seed, opts = {}) {
        var _a;
        const { publicKey: publicKey, privateKey: privateKey } = (0, $cYPJw.deriveKeypair)(seed, {
            algorithm: (_a = opts.algorithm) !== null && _a !== void 0 ? _a : $5d6e7707e742dd91$var$DEFAULT_ALGORITHM
        });
        return new $5d6e7707e742dd91$var$Wallet(publicKey, privateKey, {
            seed: seed,
            masterAddress: opts.masterAddress
        });
    }
    sign(transaction, multisign) {
        let multisignAddress = false;
        if (typeof multisign === 'string' && multisign.startsWith('X')) multisignAddress = multisign;
        else if (multisign) multisignAddress = this.classicAddress;
        const tx = (0, $2dibF.omitBy)(Object.assign({}, transaction), (value)=>value == null);
        if (tx.TxnSignature || tx.Signers) throw new $aMl9I.ValidationError('txJSON must not contain "TxnSignature" or "Signers" properties');
        $5d6e7707e742dd91$var$removeTrailingZeros(tx);
        (0, $64n0b.validate)(tx);
        const txToSignAndEncode = Object.assign({}, tx);
        txToSignAndEncode.SigningPubKey = multisignAddress ? '' : this.publicKey;
        if (multisignAddress) {
            const signer = {
                Account: multisignAddress,
                SigningPubKey: this.publicKey,
                TxnSignature: $5d6e7707e742dd91$var$computeSignature(txToSignAndEncode, this.privateKey, multisignAddress)
            };
            txToSignAndEncode.Signers = [
                {
                    Signer: signer
                }
            ];
        } else txToSignAndEncode.TxnSignature = $5d6e7707e742dd91$var$computeSignature(txToSignAndEncode, this.privateKey);
        const serialized = (0, $eLMUD.encode)(txToSignAndEncode);
        return {
            tx_blob: serialized,
            hash: (0, $gu1KQ.hashSignedTx)(serialized)
        };
    }
    verifyTransaction(signedTransaction) {
        return (0, $5VcT1.verifySignature)(signedTransaction, this.publicKey);
    }
    getXAddress(tag = false, isTestnet = false) {
        return (0, $7eC3g.classicAddressToXAddress)(this.classicAddress, tag, isTestnet);
    }
}
module.exports.Wallet = $5d6e7707e742dd91$var$Wallet;
$5d6e7707e742dd91$var$Wallet.fromSecret = $5d6e7707e742dd91$var$Wallet.fromSeed;
function $5d6e7707e742dd91$var$computeSignature(tx, privateKey, signAs) {
    if (signAs) {
        const classicAddress = (0, $7eC3g.isValidXAddress)(signAs) ? (0, $7eC3g.xAddressToClassicAddress)(signAs).classicAddress : signAs;
        return (0, $cYPJw.sign)((0, $eLMUD.encodeForMultisigning)(tx, classicAddress), privateKey);
    }
    return (0, $cYPJw.sign)((0, $eLMUD.encodeForSigning)(tx), privateKey);
}
function $5d6e7707e742dd91$var$removeTrailingZeros(tx) {
    if (tx.TransactionType === 'Payment' && typeof tx.Amount !== 'string' && tx.Amount.value.includes('.') && tx.Amount.value.endsWith('0')) {
        tx.Amount = Object.assign({}, tx.Amount);
        tx.Amount.value = new $5d6e7707e742dd91$var$bignumber_js_1.default(tx.Amount.value).toString();
    }
}

});
parcelRegister("5NcYj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HDKey = module.exports.HARDENED_OFFSET = void 0;

var $j1avL = parcelRequire("j1avL");

var $6eJNn = parcelRequire("6eJNn");

var $3eepj = parcelRequire("3eepj");

var $elJmg = parcelRequire("elJmg");

var $7GIJy = parcelRequire("7GIJy");

var $2Isbu = parcelRequire("2Isbu");

var $bm3fk = parcelRequire("bm3fk");

var $5PiaG = parcelRequire("5PiaG");

var $3ctkB = parcelRequire("3ctkB");
const $437b974ba71b026b$var$Point = $bm3fk.secp256k1.ProjectivePoint;
const $437b974ba71b026b$var$base58check = (0, $3ctkB.createBase58check)($3eepj.sha256);
function $437b974ba71b026b$var$bytesToNumber(bytes) {
    (0, $7GIJy.abytes)(bytes);
    const h = bytes.length === 0 ? '0' : (0, $2Isbu.bytesToHex)(bytes);
    return BigInt('0x' + h);
}
function $437b974ba71b026b$var$numberToBytes(num) {
    if (typeof num !== 'bigint') throw new Error('bigint expected');
    return (0, $2Isbu.hexToBytes)(num.toString(16).padStart(64, '0'));
}
const $437b974ba71b026b$var$MASTER_SECRET = (0, $2Isbu.utf8ToBytes)('Bitcoin seed');
// Bitcoin hardcoded by default
const $437b974ba71b026b$var$BITCOIN_VERSIONS = {
    private: 0x0488ade4,
    public: 0x0488b21e
};
module.exports.HARDENED_OFFSET = 0x80000000;
const $437b974ba71b026b$var$hash160 = (data)=>(0, $6eJNn.ripemd160)((0, $3eepj.sha256)(data));
const $437b974ba71b026b$var$fromU32 = (data)=>(0, $2Isbu.createView)(data).getUint32(0, false);
const $437b974ba71b026b$var$toU32 = (n)=>{
    if (!Number.isSafeInteger(n) || n < 0 || n > 2 ** 32 - 1) throw new Error('invalid number, should be from 0 to 2**32-1, got ' + n);
    const buf = new Uint8Array(4);
    (0, $2Isbu.createView)(buf).setUint32(0, n, false);
    return buf;
};
class $437b974ba71b026b$var$HDKey {
    get fingerprint() {
        if (!this.pubHash) throw new Error('No publicKey set!');
        return $437b974ba71b026b$var$fromU32(this.pubHash);
    }
    get identifier() {
        return this.pubHash;
    }
    get pubKeyHash() {
        return this.pubHash;
    }
    get privateKey() {
        return this.privKeyBytes || null;
    }
    get publicKey() {
        return this.pubKey || null;
    }
    get privateExtendedKey() {
        const priv = this.privateKey;
        if (!priv) throw new Error('No private key');
        return $437b974ba71b026b$var$base58check.encode(this.serialize(this.versions.private, (0, $2Isbu.concatBytes)(new Uint8Array([
            0
        ]), priv)));
    }
    get publicExtendedKey() {
        if (!this.pubKey) throw new Error('No public key');
        return $437b974ba71b026b$var$base58check.encode(this.serialize(this.versions.public, this.pubKey));
    }
    static fromMasterSeed(seed, versions = $437b974ba71b026b$var$BITCOIN_VERSIONS) {
        (0, $7GIJy.abytes)(seed);
        if (8 * seed.length < 128 || 8 * seed.length > 512) throw new Error('HDKey: seed length must be between 128 and 512 bits; 256 bits is advised, got ' + seed.length);
        const I = (0, $j1avL.hmac)($elJmg.sha512, $437b974ba71b026b$var$MASTER_SECRET, seed);
        return new $437b974ba71b026b$var$HDKey({
            versions: versions,
            chainCode: I.slice(32),
            privateKey: I.slice(0, 32)
        });
    }
    static fromExtendedKey(base58key, versions = $437b974ba71b026b$var$BITCOIN_VERSIONS) {
        // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        const keyBuffer = $437b974ba71b026b$var$base58check.decode(base58key);
        const keyView = (0, $2Isbu.createView)(keyBuffer);
        const version = keyView.getUint32(0, false);
        const opt = {
            versions: versions,
            depth: keyBuffer[4],
            parentFingerprint: keyView.getUint32(5, false),
            index: keyView.getUint32(9, false),
            chainCode: keyBuffer.slice(13, 45)
        };
        const key = keyBuffer.slice(45);
        const isPriv = key[0] === 0;
        if (version !== versions[isPriv ? 'private' : 'public']) throw new Error('Version mismatch');
        if (isPriv) return new $437b974ba71b026b$var$HDKey({
            ...opt,
            privateKey: key.slice(1)
        });
        else return new $437b974ba71b026b$var$HDKey({
            ...opt,
            publicKey: key
        });
    }
    static fromJSON(json) {
        return $437b974ba71b026b$var$HDKey.fromExtendedKey(json.xpriv);
    }
    constructor(opt){
        this.depth = 0;
        this.index = 0;
        this.chainCode = null;
        this.parentFingerprint = 0;
        if (!opt || typeof opt !== 'object') throw new Error('HDKey.constructor must not be called directly');
        this.versions = opt.versions || $437b974ba71b026b$var$BITCOIN_VERSIONS;
        this.depth = opt.depth || 0;
        this.chainCode = opt.chainCode || null;
        this.index = opt.index || 0;
        this.parentFingerprint = opt.parentFingerprint || 0;
        if (!this.depth) {
            if (this.parentFingerprint || this.index) throw new Error('HDKey: zero depth with non-zero index/parent fingerprint');
        }
        if (opt.publicKey && opt.privateKey) throw new Error('HDKey: publicKey and privateKey at same time.');
        if (opt.privateKey) {
            if (!$bm3fk.secp256k1.utils.isValidPrivateKey(opt.privateKey)) throw new Error('Invalid private key');
            this.privKey = typeof opt.privateKey === 'bigint' ? opt.privateKey : $437b974ba71b026b$var$bytesToNumber(opt.privateKey);
            this.privKeyBytes = $437b974ba71b026b$var$numberToBytes(this.privKey);
            this.pubKey = $bm3fk.secp256k1.getPublicKey(opt.privateKey, true);
        } else if (opt.publicKey) this.pubKey = $437b974ba71b026b$var$Point.fromHex(opt.publicKey).toRawBytes(true); // force compressed point
        else throw new Error('HDKey: no public or private key provided');
        this.pubHash = $437b974ba71b026b$var$hash160(this.pubKey);
    }
    derive(path) {
        if (!/^[mM]'?/.test(path)) throw new Error('Path must start with "m" or "M"');
        if (/^[mM]'?$/.test(path)) return this;
        const parts = path.replace(/^[mM]'?\//, '').split('/');
        // tslint:disable-next-line
        let child = this;
        for (const c of parts){
            const m = /^(\d+)('?)$/.exec(c);
            const m1 = m && m[1];
            if (!m || m.length !== 3 || typeof m1 !== 'string') throw new Error('invalid child index: ' + c);
            let idx = +m1;
            if (!Number.isSafeInteger(idx) || idx >= module.exports.HARDENED_OFFSET) throw new Error('Invalid index');
            // hardened key
            if (m[2] === "'") idx += module.exports.HARDENED_OFFSET;
            child = child.deriveChild(idx);
        }
        return child;
    }
    deriveChild(index) {
        if (!this.pubKey || !this.chainCode) throw new Error('No publicKey or chainCode set');
        let data = $437b974ba71b026b$var$toU32(index);
        if (index >= module.exports.HARDENED_OFFSET) {
            // Hardened
            const priv = this.privateKey;
            if (!priv) throw new Error('Could not derive hardened child key');
            // Hardened child: 0x00 || ser256(kpar) || ser32(index)
            data = (0, $2Isbu.concatBytes)(new Uint8Array([
                0
            ]), priv, data);
        } else // Normal child: serP(point(kpar)) || ser32(index)
        data = (0, $2Isbu.concatBytes)(this.pubKey, data);
        const I = (0, $j1avL.hmac)($elJmg.sha512, this.chainCode, data);
        const childTweak = $437b974ba71b026b$var$bytesToNumber(I.slice(0, 32));
        const chainCode = I.slice(32);
        if (!$bm3fk.secp256k1.utils.isValidPrivateKey(childTweak)) throw new Error('Tweak bigger than curve order');
        const opt = {
            versions: this.versions,
            chainCode: chainCode,
            depth: this.depth + 1,
            parentFingerprint: this.fingerprint,
            index: index
        };
        try {
            // Private parent key -> private child key
            if (this.privateKey) {
                const added = (0, $5PiaG.mod)(this.privKey + childTweak, $bm3fk.secp256k1.CURVE.n);
                if (!$bm3fk.secp256k1.utils.isValidPrivateKey(added)) throw new Error('The tweak was out of range or the resulted private key is invalid');
                opt.privateKey = added;
            } else {
                const added = $437b974ba71b026b$var$Point.fromHex(this.pubKey).add($437b974ba71b026b$var$Point.fromPrivateKey(childTweak));
                // Cryptographically impossible: hmac-sha512 preimage would need to be found
                if (added.equals($437b974ba71b026b$var$Point.ZERO)) throw new Error('The tweak was equal to negative P, which made the result key invalid');
                opt.publicKey = added.toRawBytes(true);
            }
            return new $437b974ba71b026b$var$HDKey(opt);
        } catch (err) {
            return this.deriveChild(index + 1);
        }
    }
    sign(hash) {
        if (!this.privateKey) throw new Error('No privateKey set!');
        (0, $7GIJy.abytes)(hash, 32);
        return $bm3fk.secp256k1.sign(hash, this.privKey).toCompactRawBytes();
    }
    verify(hash, signature) {
        (0, $7GIJy.abytes)(hash, 32);
        (0, $7GIJy.abytes)(signature, 64);
        if (!this.publicKey) throw new Error('No publicKey set!');
        let sig;
        try {
            sig = $bm3fk.secp256k1.Signature.fromCompact(signature);
        } catch (error) {
            return false;
        }
        return $bm3fk.secp256k1.verify(sig, hash, this.publicKey);
    }
    wipePrivateData() {
        this.privKey = undefined;
        if (this.privKeyBytes) {
            this.privKeyBytes.fill(0);
            this.privKeyBytes = undefined;
        }
        return this;
    }
    toJSON() {
        return {
            xpriv: this.privateExtendedKey,
            xpub: this.publicExtendedKey
        };
    }
    serialize(version, key) {
        if (!this.chainCode) throw new Error('No chainCode set');
        (0, $7GIJy.abytes)(key, 33);
        // version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        return (0, $2Isbu.concatBytes)($437b974ba71b026b$var$toU32(version), new Uint8Array([
            this.depth
        ]), $437b974ba71b026b$var$toU32(this.parentFingerprint), $437b974ba71b026b$var$toU32(this.index), this.chainCode, key);
    }
}
module.exports.HDKey = $437b974ba71b026b$var$HDKey;

});
parcelRegister("j1avL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $7GIJy = parcelRequire("7GIJy");

var $2Isbu = parcelRequire("2Isbu");
class $dd8643a6f6854ce4$var$HMAC extends $2Isbu.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $7GIJy.ahash)(hash);
        const key = (0, $2Isbu.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $7GIJy.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $7GIJy.aexists)(this);
        (0, $7GIJy.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $dd8643a6f6854ce4$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $dd8643a6f6854ce4$var$hmac = (hash, key, message)=>new $dd8643a6f6854ce4$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $dd8643a6f6854ce4$var$hmac;
module.exports.hmac.create = (hash, key)=>new $dd8643a6f6854ce4$var$HMAC(hash, key);

});
parcelRegister("7GIJy", function(module, exports) {
"use strict";
/**
 * Internal assertion helpers.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.anumber = $598f27da51d7c527$var$anumber;
module.exports.abytes = $598f27da51d7c527$var$abytes;
module.exports.ahash = $598f27da51d7c527$var$ahash;
module.exports.aexists = $598f27da51d7c527$var$aexists;
module.exports.aoutput = $598f27da51d7c527$var$aoutput;
/** Asserts something is positive integer. */ function $598f27da51d7c527$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $598f27da51d7c527$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is Uint8Array. */ function $598f27da51d7c527$var$abytes(b, ...lengths) {
    if (!$598f27da51d7c527$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function $598f27da51d7c527$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $598f27da51d7c527$var$anumber(h.outputLen);
    $598f27da51d7c527$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $598f27da51d7c527$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $598f27da51d7c527$var$aoutput(out, instance) {
    $598f27da51d7c527$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}

});

parcelRegister("2Isbu", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = module.exports.nextTick = module.exports.byteSwapIfBE = module.exports.isLE = void 0;
module.exports.isBytes = $1fa58da93d5b382f$var$isBytes;
module.exports.u8 = $1fa58da93d5b382f$var$u8;
module.exports.u32 = $1fa58da93d5b382f$var$u32;
module.exports.createView = $1fa58da93d5b382f$var$createView;
module.exports.rotr = $1fa58da93d5b382f$var$rotr;
module.exports.rotl = $1fa58da93d5b382f$var$rotl;
module.exports.byteSwap = $1fa58da93d5b382f$var$byteSwap;
module.exports.byteSwap32 = $1fa58da93d5b382f$var$byteSwap32;
module.exports.bytesToHex = $1fa58da93d5b382f$var$bytesToHex;
module.exports.hexToBytes = $1fa58da93d5b382f$var$hexToBytes;
module.exports.asyncLoop = $1fa58da93d5b382f$var$asyncLoop;
module.exports.utf8ToBytes = $1fa58da93d5b382f$var$utf8ToBytes;
module.exports.toBytes = $1fa58da93d5b382f$var$toBytes;
module.exports.concatBytes = $1fa58da93d5b382f$var$concatBytes;
module.exports.checkOpts = $1fa58da93d5b382f$var$checkOpts;
module.exports.wrapConstructor = $1fa58da93d5b382f$var$wrapConstructor;
module.exports.wrapConstructorWithOpts = $1fa58da93d5b382f$var$wrapConstructorWithOpts;
module.exports.wrapXOFConstructorWithOpts = $1fa58da93d5b382f$var$wrapXOFConstructorWithOpts;
module.exports.randomBytes = $1fa58da93d5b382f$var$randomBytes;

var $hP48r = parcelRequire("hP48r");

var $7GIJy = parcelRequire("7GIJy");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $1fa58da93d5b382f$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
// Cast array to different type
function $1fa58da93d5b382f$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $1fa58da93d5b382f$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
// Cast array to view
function $1fa58da93d5b382f$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $1fa58da93d5b382f$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $1fa58da93d5b382f$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// The byte swap operation for uint32
function $1fa58da93d5b382f$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>$1fa58da93d5b382f$var$byteSwap(n);
/** In place byte swap for Uint32Array */ function $1fa58da93d5b382f$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $1fa58da93d5b382f$var$byteSwap(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $1fa58da93d5b382f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $1fa58da93d5b382f$var$bytesToHex(bytes) {
    (0, $7GIJy.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $1fa58da93d5b382f$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $1fa58da93d5b382f$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $1fa58da93d5b382f$var$asciiToBase16(ch) {
    if (ch >= $1fa58da93d5b382f$var$asciis._0 && ch <= $1fa58da93d5b382f$var$asciis._9) return ch - $1fa58da93d5b382f$var$asciis._0; // '2' => 50-48
    if (ch >= $1fa58da93d5b382f$var$asciis.A && ch <= $1fa58da93d5b382f$var$asciis.F) return ch - ($1fa58da93d5b382f$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $1fa58da93d5b382f$var$asciis.a && ch <= $1fa58da93d5b382f$var$asciis.f) return ch - ($1fa58da93d5b382f$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $1fa58da93d5b382f$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $1fa58da93d5b382f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $1fa58da93d5b382f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $1fa58da93d5b382f$var$nextTick = async ()=>{};
module.exports.nextTick = $1fa58da93d5b382f$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $1fa58da93d5b382f$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * Convert JS string to byte array.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $1fa58da93d5b382f$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('utf8ToBytes expected string, got ' + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $1fa58da93d5b382f$var$toBytes(data) {
    if (typeof data === 'string') data = $1fa58da93d5b382f$var$utf8ToBytes(data);
    (0, $7GIJy.abytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $1fa58da93d5b382f$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $7GIJy.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** For runtime check if class implements interface */ class $1fa58da93d5b382f$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $1fa58da93d5b382f$var$Hash;
function $1fa58da93d5b382f$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** Wraps hash function, creating an interface on top of it */ function $1fa58da93d5b382f$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($1fa58da93d5b382f$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $1fa58da93d5b382f$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($1fa58da93d5b382f$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $1fa58da93d5b382f$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($1fa58da93d5b382f$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $1fa58da93d5b382f$var$randomBytes(bytesLength = 32) {
    if ($hP48r.crypto && typeof $hP48r.crypto.getRandomValues === 'function') return $hP48r.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($hP48r.crypto && typeof $hP48r.crypto.randomBytes === 'function') return $hP48r.crypto.randomBytes(bytesLength);
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("hP48r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("6eJNn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $ZLPvO = parcelRequire("ZLPvO");

var $2Isbu = parcelRequire("2Isbu");
const $48a792e44854d442$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $48a792e44854d442$var$Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((_, i)=>i));
const $48a792e44854d442$var$Pi = /* @__PURE__ */ $48a792e44854d442$var$Id.map((i)=>(9 * i + 5) % 16);
let $48a792e44854d442$var$idxL = [
    $48a792e44854d442$var$Id
];
let $48a792e44854d442$var$idxR = [
    $48a792e44854d442$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $48a792e44854d442$var$idxL,
    $48a792e44854d442$var$idxR
])j.push(j[i].map((k)=>$48a792e44854d442$var$Rho[k]));
const $48a792e44854d442$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $48a792e44854d442$var$shiftsL = /* @__PURE__ */ $48a792e44854d442$var$idxL.map((idx, i)=>idx.map((j)=>$48a792e44854d442$var$shifts[i][j]));
const $48a792e44854d442$var$shiftsR = /* @__PURE__ */ $48a792e44854d442$var$idxR.map((idx, i)=>idx.map((j)=>$48a792e44854d442$var$shifts[i][j]));
const $48a792e44854d442$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $48a792e44854d442$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $48a792e44854d442$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $48a792e44854d442$var$R_BUF = /* @__PURE__ */ new Uint32Array(16);
class $48a792e44854d442$var$RIPEMD160 extends $ZLPvO.HashMD {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$48a792e44854d442$var$R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $48a792e44854d442$var$Kl[group], hbr = $48a792e44854d442$var$Kr[group]; // prettier-ignore
            const rl = $48a792e44854d442$var$idxL[group], rr = $48a792e44854d442$var$idxR[group]; // prettier-ignore
            const sl = $48a792e44854d442$var$shiftsL[group], sr = $48a792e44854d442$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = (0, $2Isbu.rotl)(al + $48a792e44854d442$var$f(group, bl, cl, dl) + $48a792e44854d442$var$R_BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = (0, $2Isbu.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = (0, $2Isbu.rotl)(ar + $48a792e44854d442$var$f(rGroup, br, cr, dr) + $48a792e44854d442$var$R_BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = (0, $2Isbu.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $48a792e44854d442$var$R_BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $48a792e44854d442$var$RIPEMD160;
/** RIPEMD-160 - a legacy hash function from 1990s. */ module.exports.ripemd160 = (0, $2Isbu.wrapConstructor)(()=>new $48a792e44854d442$var$RIPEMD160());

});
parcelRegister("ZLPvO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashMD = void 0;
module.exports.setBigUint64 = $0b9acca1531870e0$var$setBigUint64;
module.exports.Chi = $0b9acca1531870e0$var$Chi;
module.exports.Maj = $0b9acca1531870e0$var$Maj;

var $7GIJy = parcelRequire("7GIJy");

var $2Isbu = parcelRequire("2Isbu");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $0b9acca1531870e0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $0b9acca1531870e0$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $0b9acca1531870e0$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $0b9acca1531870e0$var$HashMD extends $2Isbu.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $2Isbu.createView)(this.buffer);
    }
    update(data) {
        (0, $7GIJy.aexists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $2Isbu.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $2Isbu.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $7GIJy.aexists)(this);
        (0, $7GIJy.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $0b9acca1531870e0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $2Isbu.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.HashMD = $0b9acca1531870e0$var$HashMD;

});


parcelRegister("3eepj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = module.exports.SHA256 = void 0;

var $ZLPvO = parcelRequire("ZLPvO");

var $2Isbu = parcelRequire("2Isbu");
/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $259ddae37519974a$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $259ddae37519974a$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $259ddae37519974a$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $259ddae37519974a$var$SHA256 extends $ZLPvO.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $259ddae37519974a$var$SHA256_IV[0] | 0;
        this.B = $259ddae37519974a$var$SHA256_IV[1] | 0;
        this.C = $259ddae37519974a$var$SHA256_IV[2] | 0;
        this.D = $259ddae37519974a$var$SHA256_IV[3] | 0;
        this.E = $259ddae37519974a$var$SHA256_IV[4] | 0;
        this.F = $259ddae37519974a$var$SHA256_IV[5] | 0;
        this.G = $259ddae37519974a$var$SHA256_IV[6] | 0;
        this.H = $259ddae37519974a$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$259ddae37519974a$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $259ddae37519974a$var$SHA256_W[i - 15];
            const W2 = $259ddae37519974a$var$SHA256_W[i - 2];
            const s0 = (0, $2Isbu.rotr)(W15, 7) ^ (0, $2Isbu.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $2Isbu.rotr)(W2, 17) ^ (0, $2Isbu.rotr)(W2, 19) ^ W2 >>> 10;
            $259ddae37519974a$var$SHA256_W[i] = s1 + $259ddae37519974a$var$SHA256_W[i - 7] + s0 + $259ddae37519974a$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $2Isbu.rotr)(E, 6) ^ (0, $2Isbu.rotr)(E, 11) ^ (0, $2Isbu.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $ZLPvO.Chi)(E, F, G) + $259ddae37519974a$var$SHA256_K[i] + $259ddae37519974a$var$SHA256_W[i] | 0;
            const sigma0 = (0, $2Isbu.rotr)(A, 2) ^ (0, $2Isbu.rotr)(A, 13) ^ (0, $2Isbu.rotr)(A, 22);
            const T2 = sigma0 + (0, $ZLPvO.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $259ddae37519974a$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
module.exports.SHA256 = $259ddae37519974a$var$SHA256;
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $259ddae37519974a$var$SHA224 extends $259ddae37519974a$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/** SHA2-256 hash function */ module.exports.sha256 = (0, $2Isbu.wrapConstructor)(()=>new $259ddae37519974a$var$SHA256());
/** SHA2-224 hash function */ module.exports.sha224 = (0, $2Isbu.wrapConstructor)(()=>new $259ddae37519974a$var$SHA224());

});

parcelRegister("elJmg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA384 = module.exports.SHA512_256 = module.exports.SHA512_224 = module.exports.SHA512 = void 0;

var $ZLPvO = parcelRequire("ZLPvO");

var $cKXmG = parcelRequire("cKXmG");

var $2Isbu = parcelRequire("2Isbu");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$a726360a69569ea3$var$SHA512_Kh, $a726360a69569ea3$var$SHA512_Kl] = /* @__PURE__ */ (()=>$cKXmG.default.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $a726360a69569ea3$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $a726360a69569ea3$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $a726360a69569ea3$var$SHA512 extends $ZLPvO.HashMD {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $a726360a69569ea3$var$SHA512_W_H[i] = view.getUint32(offset);
            $a726360a69569ea3$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $a726360a69569ea3$var$SHA512_W_H[i - 15] | 0;
            const W15l = $a726360a69569ea3$var$SHA512_W_L[i - 15] | 0;
            const s0h = $cKXmG.default.rotrSH(W15h, W15l, 1) ^ $cKXmG.default.rotrSH(W15h, W15l, 8) ^ $cKXmG.default.shrSH(W15h, W15l, 7);
            const s0l = $cKXmG.default.rotrSL(W15h, W15l, 1) ^ $cKXmG.default.rotrSL(W15h, W15l, 8) ^ $cKXmG.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $a726360a69569ea3$var$SHA512_W_H[i - 2] | 0;
            const W2l = $a726360a69569ea3$var$SHA512_W_L[i - 2] | 0;
            const s1h = $cKXmG.default.rotrSH(W2h, W2l, 19) ^ $cKXmG.default.rotrBH(W2h, W2l, 61) ^ $cKXmG.default.shrSH(W2h, W2l, 6);
            const s1l = $cKXmG.default.rotrSL(W2h, W2l, 19) ^ $cKXmG.default.rotrBL(W2h, W2l, 61) ^ $cKXmG.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $cKXmG.default.add4L(s0l, s1l, $a726360a69569ea3$var$SHA512_W_L[i - 7], $a726360a69569ea3$var$SHA512_W_L[i - 16]);
            const SUMh = $cKXmG.default.add4H(SUMl, s0h, s1h, $a726360a69569ea3$var$SHA512_W_H[i - 7], $a726360a69569ea3$var$SHA512_W_H[i - 16]);
            $a726360a69569ea3$var$SHA512_W_H[i] = SUMh | 0;
            $a726360a69569ea3$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $cKXmG.default.rotrSH(Eh, El, 14) ^ $cKXmG.default.rotrSH(Eh, El, 18) ^ $cKXmG.default.rotrBH(Eh, El, 41);
            const sigma1l = $cKXmG.default.rotrSL(Eh, El, 14) ^ $cKXmG.default.rotrSL(Eh, El, 18) ^ $cKXmG.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $cKXmG.default.add5L(Hl, sigma1l, CHIl, $a726360a69569ea3$var$SHA512_Kl[i], $a726360a69569ea3$var$SHA512_W_L[i]);
            const T1h = $cKXmG.default.add5H(T1ll, Hh, sigma1h, CHIh, $a726360a69569ea3$var$SHA512_Kh[i], $a726360a69569ea3$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $cKXmG.default.rotrSH(Ah, Al, 28) ^ $cKXmG.default.rotrBH(Ah, Al, 34) ^ $cKXmG.default.rotrBH(Ah, Al, 39);
            const sigma0l = $cKXmG.default.rotrSL(Ah, Al, 28) ^ $cKXmG.default.rotrBL(Ah, Al, 34) ^ $cKXmG.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $cKXmG.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $cKXmG.default.add3L(T1l, sigma0l, MAJl);
            Ah = $cKXmG.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $cKXmG.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $cKXmG.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $cKXmG.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $cKXmG.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $cKXmG.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $cKXmG.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $cKXmG.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $cKXmG.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $a726360a69569ea3$var$SHA512_W_H.fill(0);
        $a726360a69569ea3$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $a726360a69569ea3$var$SHA512;
class $a726360a69569ea3$var$SHA512_224 extends $a726360a69569ea3$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
module.exports.SHA512_224 = $a726360a69569ea3$var$SHA512_224;
class $a726360a69569ea3$var$SHA512_256 extends $a726360a69569ea3$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
module.exports.SHA512_256 = $a726360a69569ea3$var$SHA512_256;
class $a726360a69569ea3$var$SHA384 extends $a726360a69569ea3$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.SHA384 = $a726360a69569ea3$var$SHA384;
/** SHA2-512 hash function. */ module.exports.sha512 = (0, $2Isbu.wrapConstructor)(()=>new $a726360a69569ea3$var$SHA512());
/** SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks. */ module.exports.sha512_224 = (0, $2Isbu.wrapConstructor)(()=>new $a726360a69569ea3$var$SHA512_224());
/** SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks. */ module.exports.sha512_256 = (0, $2Isbu.wrapConstructor)(()=>new $a726360a69569ea3$var$SHA512_256());
/** SHA2-384 hash function. */ module.exports.sha384 = (0, $2Isbu.wrapConstructor)(()=>new $a726360a69569ea3$var$SHA384());

});
parcelRegister("cKXmG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = void 0;
module.exports.fromBig = $9497d48b1c3b6855$var$fromBig;
module.exports.split = $9497d48b1c3b6855$var$split;
module.exports.add = $9497d48b1c3b6855$var$add;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $9497d48b1c3b6855$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $9497d48b1c3b6855$var$_32n = /* @__PURE__ */ BigInt(32);
function $9497d48b1c3b6855$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $9497d48b1c3b6855$var$U32_MASK64),
        l: Number(n >> $9497d48b1c3b6855$var$_32n & $9497d48b1c3b6855$var$U32_MASK64)
    };
    return {
        h: Number(n >> $9497d48b1c3b6855$var$_32n & $9497d48b1c3b6855$var$U32_MASK64) | 0,
        l: Number(n & $9497d48b1c3b6855$var$U32_MASK64) | 0
    };
}
function $9497d48b1c3b6855$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $9497d48b1c3b6855$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $9497d48b1c3b6855$var$toBig = (h, l)=>BigInt(h >>> 0) << $9497d48b1c3b6855$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $9497d48b1c3b6855$var$toBig;
// for Shift in [0, 32)
const $9497d48b1c3b6855$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $9497d48b1c3b6855$var$shrSH;
const $9497d48b1c3b6855$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $9497d48b1c3b6855$var$shrSL;
// Right rotate for Shift in [1, 32)
const $9497d48b1c3b6855$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $9497d48b1c3b6855$var$rotrSH;
const $9497d48b1c3b6855$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $9497d48b1c3b6855$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9497d48b1c3b6855$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $9497d48b1c3b6855$var$rotrBH;
const $9497d48b1c3b6855$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $9497d48b1c3b6855$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $9497d48b1c3b6855$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $9497d48b1c3b6855$var$rotr32H;
const $9497d48b1c3b6855$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $9497d48b1c3b6855$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $9497d48b1c3b6855$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $9497d48b1c3b6855$var$rotlSH;
const $9497d48b1c3b6855$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $9497d48b1c3b6855$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $9497d48b1c3b6855$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $9497d48b1c3b6855$var$rotlBH;
const $9497d48b1c3b6855$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $9497d48b1c3b6855$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $9497d48b1c3b6855$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $9497d48b1c3b6855$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $9497d48b1c3b6855$var$add3L;
const $9497d48b1c3b6855$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $9497d48b1c3b6855$var$add3H;
const $9497d48b1c3b6855$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $9497d48b1c3b6855$var$add4L;
const $9497d48b1c3b6855$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $9497d48b1c3b6855$var$add4H;
const $9497d48b1c3b6855$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $9497d48b1c3b6855$var$add5L;
const $9497d48b1c3b6855$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $9497d48b1c3b6855$var$add5H;
// prettier-ignore
const $9497d48b1c3b6855$var$u64 = {
    fromBig: $9497d48b1c3b6855$var$fromBig,
    split: $9497d48b1c3b6855$var$split,
    toBig: $9497d48b1c3b6855$var$toBig,
    shrSH: $9497d48b1c3b6855$var$shrSH,
    shrSL: $9497d48b1c3b6855$var$shrSL,
    rotrSH: $9497d48b1c3b6855$var$rotrSH,
    rotrSL: $9497d48b1c3b6855$var$rotrSL,
    rotrBH: $9497d48b1c3b6855$var$rotrBH,
    rotrBL: $9497d48b1c3b6855$var$rotrBL,
    rotr32H: $9497d48b1c3b6855$var$rotr32H,
    rotr32L: $9497d48b1c3b6855$var$rotr32L,
    rotlSH: $9497d48b1c3b6855$var$rotlSH,
    rotlSL: $9497d48b1c3b6855$var$rotlSL,
    rotlBH: $9497d48b1c3b6855$var$rotlBH,
    rotlBL: $9497d48b1c3b6855$var$rotlBL,
    add: $9497d48b1c3b6855$var$add,
    add3L: $9497d48b1c3b6855$var$add3L,
    add3H: $9497d48b1c3b6855$var$add3H,
    add4L: $9497d48b1c3b6855$var$add4L,
    add4H: $9497d48b1c3b6855$var$add4H,
    add5H: $9497d48b1c3b6855$var$add5H,
    add5L: $9497d48b1c3b6855$var$add5L
};
module.exports.default = $9497d48b1c3b6855$var$u64;

});


parcelRegister("bm3fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $3eepj = parcelRequire("3eepj");

var $2Isbu = parcelRequire("2Isbu");

var $eYoOA = parcelRequire("eYoOA");

var $crndi = parcelRequire("crndi");

var $5PiaG = parcelRequire("5PiaG");

var $4h1oI = parcelRequire("4h1oI");

var $lNxgm = parcelRequire("lNxgm");
const $84444470fe7d4785$var$secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
const $84444470fe7d4785$var$secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
const $84444470fe7d4785$var$_1n = BigInt(1);
const $84444470fe7d4785$var$_2n = BigInt(2);
const $84444470fe7d4785$var$divNearest = (a, b)=>(a + b / $84444470fe7d4785$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $84444470fe7d4785$var$sqrtMod(y) {
    const P = $84444470fe7d4785$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $5PiaG.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $5PiaG.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $5PiaG.pow2)(b9, $84444470fe7d4785$var$_2n, P) * b2 % P;
    const b22 = (0, $5PiaG.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $5PiaG.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $5PiaG.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $5PiaG.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $5PiaG.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $5PiaG.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $5PiaG.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $5PiaG.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $5PiaG.pow2)(t2, $84444470fe7d4785$var$_2n, P);
    if (!$84444470fe7d4785$var$Fpk1.eql($84444470fe7d4785$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $84444470fe7d4785$var$Fpk1 = (0, $5PiaG.Field)($84444470fe7d4785$var$secp256k1P, undefined, undefined, {
    sqrt: $84444470fe7d4785$var$sqrtMod
});
/**
 * secp256k1 short weierstrass curve and ECDSA signatures over it.
 *
 * @example
 * import { secp256k1 } from '@noble/curves/secp256k1';
 *
 * const priv = secp256k1.utils.randomPrivateKey();
 * const pub = secp256k1.getPublicKey(priv);
 * const msg = new Uint8Array(32).fill(1); // message hash (not message) in ecdsa
 * const sig = secp256k1.sign(msg, priv); // `{prehash: true}` option is available
 * const isValid = secp256k1.verify(sig, msg, pub) === true;
 */ module.exports.secp256k1 = (0, $eYoOA.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $84444470fe7d4785$var$Fpk1,
    n: $84444470fe7d4785$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    endo: {
        // Endomorphism, see above
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: (k)=>{
            const n = $84444470fe7d4785$var$secp256k1N;
            const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            const b1 = -$84444470fe7d4785$var$_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            const b2 = a1;
            const POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            const c1 = $84444470fe7d4785$var$divNearest(b2 * k, n);
            const c2 = $84444470fe7d4785$var$divNearest(-b1 * k, n);
            let k1 = (0, $5PiaG.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $5PiaG.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error('splitScalar: Endomorphism failed, k=' + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $3eepj.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $84444470fe7d4785$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $84444470fe7d4785$var$TAGGED_HASH_PREFIXES = {};
function $84444470fe7d4785$var$taggedHash(tag, ...messages) {
    let tagP = $84444470fe7d4785$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $3eepj.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $4h1oI.concatBytes)(tagH, tagH);
        $84444470fe7d4785$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $3eepj.sha256)((0, $4h1oI.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $84444470fe7d4785$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $84444470fe7d4785$var$numTo32b = (n)=>(0, $4h1oI.numberToBytesBE)(n, 32);
const $84444470fe7d4785$var$modP = (x)=>(0, $5PiaG.mod)(x, $84444470fe7d4785$var$secp256k1P);
const $84444470fe7d4785$var$modN = (x)=>(0, $5PiaG.mod)(x, $84444470fe7d4785$var$secp256k1N);
const $84444470fe7d4785$var$Point = module.exports.secp256k1.ProjectivePoint;
const $84444470fe7d4785$var$GmulAdd = (Q, a, b)=>$84444470fe7d4785$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $84444470fe7d4785$var$schnorrGetExtPubKey(priv) {
    let d_ = module.exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $84444470fe7d4785$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $84444470fe7d4785$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $84444470fe7d4785$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $84444470fe7d4785$var$lift_x(x) {
    (0, $4h1oI.aInRange)('x', x, $84444470fe7d4785$var$_1n, $84444470fe7d4785$var$secp256k1P); // Fail if x ≥ p.
    const xx = $84444470fe7d4785$var$modP(x * x);
    const c = $84444470fe7d4785$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $84444470fe7d4785$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $84444470fe7d4785$var$_2n !== $84444470fe7d4785$var$_0n) y = $84444470fe7d4785$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $84444470fe7d4785$var$Point(x, y, $84444470fe7d4785$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $84444470fe7d4785$var$num = $4h1oI.bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $84444470fe7d4785$var$challenge(...args) {
    return $84444470fe7d4785$var$modN($84444470fe7d4785$var$num($84444470fe7d4785$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $84444470fe7d4785$var$schnorrGetPublicKey(privateKey) {
    return $84444470fe7d4785$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $84444470fe7d4785$var$schnorrSign(message, privateKey, auxRand = (0, $2Isbu.randomBytes)(32)) {
    const m = (0, $4h1oI.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = $84444470fe7d4785$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $4h1oI.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $84444470fe7d4785$var$numTo32b(d ^ $84444470fe7d4785$var$num($84444470fe7d4785$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $84444470fe7d4785$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $84444470fe7d4785$var$modN($84444470fe7d4785$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $84444470fe7d4785$var$_0n) throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $84444470fe7d4785$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $84444470fe7d4785$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($84444470fe7d4785$var$numTo32b($84444470fe7d4785$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$84444470fe7d4785$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $84444470fe7d4785$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $4h1oI.ensureBytes)('signature', signature, 64);
    const m = (0, $4h1oI.ensureBytes)('message', message);
    const pub = (0, $4h1oI.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = $84444470fe7d4785$var$lift_x($84444470fe7d4785$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $84444470fe7d4785$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $4h1oI.inRange)(r, $84444470fe7d4785$var$_1n, $84444470fe7d4785$var$secp256k1P)) return false;
        const s = $84444470fe7d4785$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $4h1oI.inRange)(s, $84444470fe7d4785$var$_1n, $84444470fe7d4785$var$secp256k1N)) return false;
        const e = $84444470fe7d4785$var$challenge($84444470fe7d4785$var$numTo32b(r), $84444470fe7d4785$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $84444470fe7d4785$var$GmulAdd(P, s, $84444470fe7d4785$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 * https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
 * @example
 * import { schnorr } from '@noble/curves/secp256k1';
 * const priv = schnorr.utils.randomPrivateKey();
 * const pub = schnorr.getPublicKey(priv);
 * const msg = new TextEncoder().encode('hello');
 * const sig = schnorr.sign(msg, priv);
 * const isValid = schnorr.verify(sig, msg, pub);
 */ module.exports.schnorr = (()=>({
        getPublicKey: $84444470fe7d4785$var$schnorrGetPublicKey,
        sign: $84444470fe7d4785$var$schnorrSign,
        verify: $84444470fe7d4785$var$schnorrVerify,
        utils: {
            randomPrivateKey: module.exports.secp256k1.utils.randomPrivateKey,
            lift_x: $84444470fe7d4785$var$lift_x,
            pointToBytes: $84444470fe7d4785$var$pointToBytes,
            numberToBytesBE: $4h1oI.numberToBytesBE,
            bytesToNumberBE: $4h1oI.bytesToNumberBE,
            taggedHash: $84444470fe7d4785$var$taggedHash,
            mod: $5PiaG.mod
        }
    }))();
const $84444470fe7d4785$var$isoMap = /* @__PURE__ */ (()=>(0, $crndi.isogenyMap)($84444470fe7d4785$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $84444470fe7d4785$var$mapSWU = /* @__PURE__ */ (()=>(0, $lNxgm.mapToCurveSimpleSWU)($84444470fe7d4785$var$Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $84444470fe7d4785$var$Fpk1.create(BigInt('-11'))
    }))();
const $84444470fe7d4785$var$htf = /* @__PURE__ */ (()=>(0, $crndi.createHasher)(module.exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $84444470fe7d4785$var$mapSWU($84444470fe7d4785$var$Fpk1.create(scalars[0]));
        return $84444470fe7d4785$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $84444470fe7d4785$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: $3eepj.sha256
    }))();
/** secp256k1 hash-to-curve from [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380). */ module.exports.hashToCurve = (()=>$84444470fe7d4785$var$htf.hashToCurve)();
/** secp256k1 encode-to-curve from [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380). */ module.exports.encodeToCurve = (()=>$84444470fe7d4785$var$htf.encodeToCurve)();

});
parcelRegister("eYoOA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getHash = $ae69eb05dc432eba$var$getHash;
module.exports.createCurve = $ae69eb05dc432eba$var$createCurve;

var $j1avL = parcelRequire("j1avL");

var $2Isbu = parcelRequire("2Isbu");

var $lNxgm = parcelRequire("lNxgm");
/** connects noble-curves to noble-hashes */ function $ae69eb05dc432eba$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $j1avL.hmac)(hash, key, (0, $2Isbu.concatBytes)(...msgs)),
        randomBytes: $2Isbu.randomBytes
    };
}
function $ae69eb05dc432eba$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $lNxgm.weierstrass)({
            ...curveDef,
            ...$ae69eb05dc432eba$var$getHash(hash)
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("lNxgm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DER = module.exports.DERErr = void 0;
module.exports.weierstrassPoints = $fde7f9e612d39316$var$weierstrassPoints;
module.exports.weierstrass = $fde7f9e612d39316$var$weierstrass;
module.exports.SWUFpSqrtRatio = $fde7f9e612d39316$var$SWUFpSqrtRatio;
module.exports.mapToCurveSimpleSWU = $fde7f9e612d39316$var$mapToCurveSimpleSWU;

var $jy6m7 = parcelRequire("jy6m7");

var $5PiaG = parcelRequire("5PiaG");

var $4h1oI = parcelRequire("4h1oI");

var $4h1oI = parcelRequire("4h1oI");
function $fde7f9e612d39316$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $4h1oI.abool)('lowS', opts.lowS);
    if (opts.prehash !== undefined) (0, $4h1oI.abool)('prehash', opts.prehash);
}
function $fde7f9e612d39316$var$validatePointOpts(curve) {
    const opts = (0, $jy6m7.validateBasic)(curve);
    $4h1oI.validateObject(opts, {
        a: 'field',
        b: 'field'
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function'
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error('invalid endomorphism, can only be defined for Koblitz curves that have a=0');
        if (typeof endo !== 'object' || typeof endo.beta !== 'bigint' || typeof endo.splitScalar !== 'function') throw new Error('invalid endomorphism, expected beta: bigint and splitScalar: function');
    }
    return Object.freeze({
        ...opts
    });
}
const { bytesToNumberBE: $fde7f9e612d39316$var$b2n, hexToBytes: $fde7f9e612d39316$var$h2b } = $4h1oI;
class $fde7f9e612d39316$var$DERErr extends Error {
    constructor(m = ''){
        super(m);
    }
}
module.exports.DERErr = $fde7f9e612d39316$var$DERErr;
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */ module.exports.DER = {
    // asn.1 DER encoding utils
    Err: $fde7f9e612d39316$var$DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = module.exports.DER;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = $4h1oI.numberToHexUnpadded(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? $4h1oI.numberToHexUnpadded(len.length / 2 | 128) : '';
            const t = $4h1oI.numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = module.exports.DER;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = module.exports.DER;
            if (num < $fde7f9e612d39316$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = $4h1oI.numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = module.exports.DER;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return $fde7f9e612d39316$var$b2n(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = module.exports.DER;
        const data = typeof hex === 'string' ? $fde7f9e612d39316$var$h2b(hex) : hex;
        $4h1oI.abytes(data);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = module.exports.DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $fde7f9e612d39316$var$_0n = BigInt(0), $fde7f9e612d39316$var$_1n = BigInt(1), $fde7f9e612d39316$var$_2n = BigInt(2), $fde7f9e612d39316$var$_3n = BigInt(3), $fde7f9e612d39316$var$_4n = BigInt(4);
function $fde7f9e612d39316$var$weierstrassPoints(opts) {
    const CURVE = $fde7f9e612d39316$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = (0, $5PiaG.Field)(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $4h1oI.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $4h1oI.inRange(num, $fde7f9e612d39316$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== 'bigint') {
            if ($4h1oI.isBytes(key)) key = $4h1oI.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length)) throw new Error('invalid private key');
            key = key.padStart(nByteLength * 2, '0');
        }
        let num;
        try {
            num = typeof key === 'bigint' ? key : $4h1oI.bytesToNumberBE((0, $4h1oI.ensureBytes)('private key', key, nByteLength));
        } catch (error) {
            throw new Error('invalid private key, expected hex or ' + nByteLength + ' bytes, got ' + typeof key);
        }
        if (wrapPrivateKey) num = (0, $5PiaG.mod)(num, N); // disabled by default, enabled for BLS
        $4h1oI.aInRange('private key', num, $fde7f9e612d39316$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $4h1oI.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $4h1oI.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not FE');
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error('x required');
            if (py == null || !Fp.isValid(py)) throw new Error('y required');
            if (pz == null || !Fp.isValid(pz)) throw new Error('z required');
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $4h1oI.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $jy6m7.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $fde7f9e612d39316$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $fde7f9e612d39316$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo, n: N } = CURVE;
            $4h1oI.aInRange('scalar', sc, $fde7f9e612d39316$var$_0n, N);
            const I = Point.ZERO;
            if (sc === $fde7f9e612d39316$var$_0n) return I;
            if (this.is0() || sc === $fde7f9e612d39316$var$_1n) return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this)) return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $fde7f9e612d39316$var$_0n || k2 > $fde7f9e612d39316$var$_0n){
                if (k1 & $fde7f9e612d39316$var$_1n) k1p = k1p.add(d);
                if (k2 & $fde7f9e612d39316$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $fde7f9e612d39316$var$_1n;
                k2 >>= $fde7f9e612d39316$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $4h1oI.aInRange('scalar', scalar, $fde7f9e612d39316$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $fde7f9e612d39316$var$_0n || a === $fde7f9e612d39316$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $fde7f9e612d39316$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $fde7f9e612d39316$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $4h1oI.abool)('isCompressed', isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $4h1oI.abool)('isCompressed', isCompressed);
            return $4h1oI.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $jy6m7.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $fde7f9e612d39316$var$validateOpts(curve) {
    const opts = (0, $jy6m7.validateBasic)(curve);
    $4h1oI.validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function'
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean'
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
/**
 * Creates short weierstrass curve and ECDSA signature methods for it.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, b, p, n, Gx, Gy
 * const curve = weierstrass({ a, b, Fp: Field(p), n, Gx, Gy, h: 1n })
 */ function $fde7f9e612d39316$var$weierstrass(curveDef) {
    const CURVE = $fde7f9e612d39316$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return (0, $5PiaG.mod)(a, CURVE_ORDER);
    }
    function invN(a) {
        return (0, $5PiaG.invert)(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $fde7f9e612d39316$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $4h1oI.concatBytes;
            (0, $4h1oI.abool)('isCompressed', isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $4h1oI.bytesToNumberBE(tail);
                if (!$4h1oI.inRange(x, $fde7f9e612d39316$var$_1n, Fp.ORDER)) throw new Error('Point is not on curve');
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                    throw new Error('Point is not on curve' + suffix);
                }
                const isYOdd = (y & $fde7f9e612d39316$var$_1n) === $fde7f9e612d39316$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error('invalid Point, expected length of ' + cl + ', or uncompressed ' + ul + ', got ' + len);
            }
        }
    });
    const numToNByteStr = (num)=>$4h1oI.bytesToHex($4h1oI.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $fde7f9e612d39316$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$4h1oI.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $4h1oI.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $4h1oI.ensureBytes)('DER', hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $4h1oI.aInRange('r', this.r, $fde7f9e612d39316$var$_1n, CURVE_ORDER); // r in [1..N]
            $4h1oI.aInRange('s', this.s, $fde7f9e612d39316$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $4h1oI.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error('recovery id 2 or 3 invalid');
            const prefix = (rec & 1) === 0 ? '02' : '03';
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $4h1oI.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $4h1oI.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = (0, $5PiaG.getMinHashLength)(CURVE.n);
            return (0, $5PiaG.mapHashToField)(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $4h1oI.isBytes(item);
        const str = typeof item === 'string';
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error('first arg must be private key');
        if (!isProbPub(publicB)) throw new Error('second arg must be public key');
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // Our custom check "just in case"
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $4h1oI.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $4h1oI.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $4h1oI.aInRange('num < 2^' + CURVE.nBitLength, num, $fde7f9e612d39316$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $4h1oI.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $4h1oI.ensureBytes)('msgHash', msgHash);
        $fde7f9e612d39316$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $4h1oI.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $4h1oI.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = $4h1oI.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $fde7f9e612d39316$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $fde7f9e612d39316$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $fde7f9e612d39316$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $4h1oI.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $4h1oI.ensureBytes)('msgHash', msgHash);
        publicKey = (0, $4h1oI.ensureBytes)('publicKey', publicKey);
        const { lowS: lowS, prehash: prehash, format: format } = opts;
        // Verify opts, deduce signature format
        $fde7f9e612d39316$var$validateSigVerOpts(opts);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        if (format !== undefined && format !== 'compact' && format !== 'der') throw new Error('format must be compact or der');
        const isHex = typeof sg === 'string' || $4h1oI.isBytes(sg);
        const isObj = !isHex && !format && typeof sg === 'object' && sg !== null && typeof sg.r === 'bigint' && typeof sg.s === 'bigint';
        if (!isHex && !isObj) throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        let _sig = undefined;
        let P;
        try {
            if (isObj) _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== 'compact') _sig = Signature.fromDER(sg);
                } catch (derError) {
                    if (!(derError instanceof module.exports.DER.Err)) throw derError;
                }
                if (!_sig && format !== 'der') _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        } catch (error) {
            return false;
        }
        if (!_sig) return false;
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $fde7f9e612d39316$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $fde7f9e612d39316$var$_0n;
    for(let o = q - $fde7f9e612d39316$var$_1n; o % $fde7f9e612d39316$var$_2n === $fde7f9e612d39316$var$_0n; o /= $fde7f9e612d39316$var$_2n)l += $fde7f9e612d39316$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $fde7f9e612d39316$var$_2n << c1 - $fde7f9e612d39316$var$_1n - $fde7f9e612d39316$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $fde7f9e612d39316$var$_2n;
    const c2 = (q - $fde7f9e612d39316$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $fde7f9e612d39316$var$_1n) / $fde7f9e612d39316$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $fde7f9e612d39316$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $fde7f9e612d39316$var$_1n) / $fde7f9e612d39316$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $fde7f9e612d39316$var$_1n; i--){
            let tv5 = i - $fde7f9e612d39316$var$_2n; // 18.    tv5 = i - 2
            tv5 = $fde7f9e612d39316$var$_2n << tv5 - $fde7f9e612d39316$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $fde7f9e612d39316$var$_4n === $fde7f9e612d39316$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $fde7f9e612d39316$var$_3n) / $fde7f9e612d39316$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $fde7f9e612d39316$var$mapToCurveSimpleSWU(Fp, opts) {
    (0, $5PiaG.validateField)(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $fde7f9e612d39316$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("jy6m7", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.pippenger = pippenger;
exports.precomputeMSMUnsafe = precomputeMSMUnsafe;
exports.validateBasic = validateBasic;

var $5PiaG = parcelRequire("5PiaG");

var $4h1oI = parcelRequire("4h1oI");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    const windows = Math.ceil(bits / W) + 1; // +1, because
    const windowSize = 2 ** (W - 1); // -1 because we skip zero
    return {
        windows: windows,
        windowSize: windowSize
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */ function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = calcWOpts(W, bits);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                if (n === _0n) break; // No need to go over empty scalar
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                if (wbits === 0) continue;
                let curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0) curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster with precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */ function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length) throw new Error('arrays of points and scalars must have equal length');
    const zero = c.ZERO;
    const wbits = (0, $4h1oI.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
/**
 * Precomputed multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @returns function which multiplies points with scaars
 */ function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = BigInt((1 << windowSize) - 1);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, $5PiaG.validateField)(curve.Fp);
    (0, $4h1oI.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $5PiaG.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("5PiaG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNegativeLE = void 0;
module.exports.mod = $43dfcfa282029093$var$mod;
module.exports.pow = $43dfcfa282029093$var$pow;
module.exports.pow2 = $43dfcfa282029093$var$pow2;
module.exports.invert = $43dfcfa282029093$var$invert;
module.exports.tonelliShanks = $43dfcfa282029093$var$tonelliShanks;
module.exports.FpSqrt = $43dfcfa282029093$var$FpSqrt;
module.exports.validateField = $43dfcfa282029093$var$validateField;
module.exports.FpPow = $43dfcfa282029093$var$FpPow;
module.exports.FpInvertBatch = $43dfcfa282029093$var$FpInvertBatch;
module.exports.FpDiv = $43dfcfa282029093$var$FpDiv;
module.exports.FpLegendre = $43dfcfa282029093$var$FpLegendre;
module.exports.FpIsSquare = $43dfcfa282029093$var$FpIsSquare;
module.exports.nLength = $43dfcfa282029093$var$nLength;
module.exports.Field = $43dfcfa282029093$var$Field;
module.exports.FpSqrtOdd = $43dfcfa282029093$var$FpSqrtOdd;
module.exports.FpSqrtEven = $43dfcfa282029093$var$FpSqrtEven;
module.exports.hashToPrivateScalar = $43dfcfa282029093$var$hashToPrivateScalar;
module.exports.getFieldBytesLength = $43dfcfa282029093$var$getFieldBytesLength;
module.exports.getMinHashLength = $43dfcfa282029093$var$getMinHashLength;
module.exports.mapHashToField = $43dfcfa282029093$var$mapHashToField;

var $4h1oI = parcelRequire("4h1oI");
// prettier-ignore
const $43dfcfa282029093$var$_0n = BigInt(0), $43dfcfa282029093$var$_1n = BigInt(1), $43dfcfa282029093$var$_2n = /* @__PURE__ */ BigInt(2), $43dfcfa282029093$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $43dfcfa282029093$var$_4n = /* @__PURE__ */ BigInt(4), $43dfcfa282029093$var$_5n = /* @__PURE__ */ BigInt(5), $43dfcfa282029093$var$_8n = /* @__PURE__ */ BigInt(8);
// prettier-ignore
const $43dfcfa282029093$var$_9n = /* @__PURE__ */ BigInt(9), $43dfcfa282029093$var$_16n = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function $43dfcfa282029093$var$mod(a, b) {
    const result = a % b;
    return result >= $43dfcfa282029093$var$_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @todo use field version && remove
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ function $43dfcfa282029093$var$pow(num, power, modulo) {
    if (power < $43dfcfa282029093$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (modulo <= $43dfcfa282029093$var$_0n) throw new Error('invalid modulus');
    if (modulo === $43dfcfa282029093$var$_1n) return $43dfcfa282029093$var$_0n;
    let res = $43dfcfa282029093$var$_1n;
    while(power > $43dfcfa282029093$var$_0n){
        if (power & $43dfcfa282029093$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $43dfcfa282029093$var$_1n;
    }
    return res;
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */ function $43dfcfa282029093$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $43dfcfa282029093$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */ function $43dfcfa282029093$var$invert(number, modulo) {
    if (number === $43dfcfa282029093$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $43dfcfa282029093$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $43dfcfa282029093$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $43dfcfa282029093$var$_0n, y = $43dfcfa282029093$var$_1n, u = $43dfcfa282029093$var$_1n, v = $43dfcfa282029093$var$_0n;
    while(a !== $43dfcfa282029093$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $43dfcfa282029093$var$_1n) throw new Error('invert: does not exist');
    return $43dfcfa282029093$var$mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $43dfcfa282029093$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $43dfcfa282029093$var$_1n) / $43dfcfa282029093$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $43dfcfa282029093$var$_1n, S = 0; Q % $43dfcfa282029093$var$_2n === $43dfcfa282029093$var$_0n; Q /= $43dfcfa282029093$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $43dfcfa282029093$var$_2n; Z < P && $43dfcfa282029093$var$pow(Z, legendreC, P) !== P - $43dfcfa282029093$var$_1n; Z++){
        // Crash instead of infinity loop, we cannot reasonable count until P.
        if (Z > 1000) throw new Error('Cannot find square root: likely non-prime P');
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $43dfcfa282029093$var$_1n) / $43dfcfa282029093$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $43dfcfa282029093$var$_1n) / $43dfcfa282029093$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error('Cannot find square root');
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $43dfcfa282029093$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
/**
 * Square root for a finite field. It will try to check if optimizations are applicable and fall back to 4:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */ function $43dfcfa282029093$var$FpSqrt(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $43dfcfa282029093$var$_4n === $43dfcfa282029093$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $43dfcfa282029093$var$_1n) / $43dfcfa282029093$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $43dfcfa282029093$var$_8n === $43dfcfa282029093$var$_5n) {
        const c1 = (P - $43dfcfa282029093$var$_5n) / $43dfcfa282029093$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $43dfcfa282029093$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $43dfcfa282029093$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $43dfcfa282029093$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $43dfcfa282029093$var$tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const $43dfcfa282029093$var$isNegativeLE = (num, modulo)=>($43dfcfa282029093$var$mod(num, modulo) & $43dfcfa282029093$var$_1n) === $43dfcfa282029093$var$_1n;
module.exports.isNegativeLE = $43dfcfa282029093$var$isNegativeLE;
// prettier-ignore
const $43dfcfa282029093$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $43dfcfa282029093$var$validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger'
    };
    const opts = $43dfcfa282029093$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    return (0, $4h1oI.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $43dfcfa282029093$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $43dfcfa282029093$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $43dfcfa282029093$var$_0n) return f.ONE;
    if (power === $43dfcfa282029093$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $43dfcfa282029093$var$_0n){
        if (power & $43dfcfa282029093$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $43dfcfa282029093$var$_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $43dfcfa282029093$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $43dfcfa282029093$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? $43dfcfa282029093$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
/**
 * Legendre symbol.
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */ function $43dfcfa282029093$var$FpLegendre(order) {
    const legendreConst = (order - $43dfcfa282029093$var$_1n) / $43dfcfa282029093$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
// This function returns True whenever the value x is a square in the field F.
function $43dfcfa282029093$var$FpIsSquare(f) {
    const legendre = $43dfcfa282029093$var$FpLegendre(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
// CURVE.n lengths
function $43dfcfa282029093$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
/**
 * Initializes a finite field over prime.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $43dfcfa282029093$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $43dfcfa282029093$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = $43dfcfa282029093$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $4h1oI.bitMask)(BITS),
        ZERO: $43dfcfa282029093$var$_0n,
        ONE: $43dfcfa282029093$var$_1n,
        create: (num)=>$43dfcfa282029093$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return $43dfcfa282029093$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $43dfcfa282029093$var$_0n,
        isOdd: (num)=>(num & $43dfcfa282029093$var$_1n) === $43dfcfa282029093$var$_1n,
        neg: (num)=>$43dfcfa282029093$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$43dfcfa282029093$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$43dfcfa282029093$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$43dfcfa282029093$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$43dfcfa282029093$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$43dfcfa282029093$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$43dfcfa282029093$var$mod(lhs * $43dfcfa282029093$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$43dfcfa282029093$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $43dfcfa282029093$var$FpSqrt(ORDER);
            return sqrtP(f, n);
        }),
        invertBatch: (lst)=>$43dfcfa282029093$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $4h1oI.numberToBytesLE)(num, BYTES) : (0, $4h1oI.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            return isLE ? (0, $4h1oI.bytesToNumberLE)(bytes) : (0, $4h1oI.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $43dfcfa282029093$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $43dfcfa282029093$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use `mapKeyToField` instead
 */ function $43dfcfa282029093$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $4h1oI.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $43dfcfa282029093$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, $4h1oI.bytesToNumberLE)(hash) : (0, $4h1oI.bytesToNumberBE)(hash);
    return $43dfcfa282029093$var$mod(num, groupOrder - $43dfcfa282029093$var$_1n) + $43dfcfa282029093$var$_1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $43dfcfa282029093$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $43dfcfa282029093$var$getMinHashLength(fieldOrder) {
    const length = $43dfcfa282029093$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $43dfcfa282029093$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $43dfcfa282029093$var$getFieldBytesLength(fieldOrder);
    const minLen = $43dfcfa282029093$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $4h1oI.bytesToNumberLE)(key) : (0, $4h1oI.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $43dfcfa282029093$var$mod(num, fieldOrder - $43dfcfa282029093$var$_1n) + $43dfcfa282029093$var$_1n;
    return isLE ? (0, $4h1oI.numberToBytesLE)(reduced, fieldLen) : (0, $4h1oI.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("4h1oI", function(module, exports) {
"use strict";
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notImplemented = module.exports.bitMask = void 0;
module.exports.isBytes = $31c9d583d88bbd0b$var$isBytes;
module.exports.abytes = $31c9d583d88bbd0b$var$abytes;
module.exports.abool = $31c9d583d88bbd0b$var$abool;
module.exports.bytesToHex = $31c9d583d88bbd0b$var$bytesToHex;
module.exports.numberToHexUnpadded = $31c9d583d88bbd0b$var$numberToHexUnpadded;
module.exports.hexToNumber = $31c9d583d88bbd0b$var$hexToNumber;
module.exports.hexToBytes = $31c9d583d88bbd0b$var$hexToBytes;
module.exports.bytesToNumberBE = $31c9d583d88bbd0b$var$bytesToNumberBE;
module.exports.bytesToNumberLE = $31c9d583d88bbd0b$var$bytesToNumberLE;
module.exports.numberToBytesBE = $31c9d583d88bbd0b$var$numberToBytesBE;
module.exports.numberToBytesLE = $31c9d583d88bbd0b$var$numberToBytesLE;
module.exports.numberToVarBytesBE = $31c9d583d88bbd0b$var$numberToVarBytesBE;
module.exports.ensureBytes = $31c9d583d88bbd0b$var$ensureBytes;
module.exports.concatBytes = $31c9d583d88bbd0b$var$concatBytes;
module.exports.equalBytes = $31c9d583d88bbd0b$var$equalBytes;
module.exports.utf8ToBytes = $31c9d583d88bbd0b$var$utf8ToBytes;
module.exports.inRange = $31c9d583d88bbd0b$var$inRange;
module.exports.aInRange = $31c9d583d88bbd0b$var$aInRange;
module.exports.bitLen = $31c9d583d88bbd0b$var$bitLen;
module.exports.bitGet = $31c9d583d88bbd0b$var$bitGet;
module.exports.bitSet = $31c9d583d88bbd0b$var$bitSet;
module.exports.createHmacDrbg = $31c9d583d88bbd0b$var$createHmacDrbg;
module.exports.validateObject = $31c9d583d88bbd0b$var$validateObject;
module.exports.memoized = $31c9d583d88bbd0b$var$memoized;
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $31c9d583d88bbd0b$var$_0n = /* @__PURE__ */ BigInt(0);
const $31c9d583d88bbd0b$var$_1n = /* @__PURE__ */ BigInt(1);
const $31c9d583d88bbd0b$var$_2n = /* @__PURE__ */ BigInt(2);
function $31c9d583d88bbd0b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $31c9d583d88bbd0b$var$abytes(item) {
    if (!$31c9d583d88bbd0b$var$isBytes(item)) throw new Error('Uint8Array expected');
}
function $31c9d583d88bbd0b$var$abool(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $31c9d583d88bbd0b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $31c9d583d88bbd0b$var$bytesToHex(bytes) {
    $31c9d583d88bbd0b$var$abytes(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $31c9d583d88bbd0b$var$hexes[bytes[i]];
    return hex;
}
function $31c9d583d88bbd0b$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $31c9d583d88bbd0b$var$hexToNumber(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $31c9d583d88bbd0b$var$_0n : BigInt('0x' + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const $31c9d583d88bbd0b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $31c9d583d88bbd0b$var$asciiToBase16(ch) {
    if (ch >= $31c9d583d88bbd0b$var$asciis._0 && ch <= $31c9d583d88bbd0b$var$asciis._9) return ch - $31c9d583d88bbd0b$var$asciis._0; // '2' => 50-48
    if (ch >= $31c9d583d88bbd0b$var$asciis.A && ch <= $31c9d583d88bbd0b$var$asciis.F) return ch - ($31c9d583d88bbd0b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $31c9d583d88bbd0b$var$asciis.a && ch <= $31c9d583d88bbd0b$var$asciis.f) return ch - ($31c9d583d88bbd0b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $31c9d583d88bbd0b$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $31c9d583d88bbd0b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $31c9d583d88bbd0b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function $31c9d583d88bbd0b$var$bytesToNumberBE(bytes) {
    return $31c9d583d88bbd0b$var$hexToNumber($31c9d583d88bbd0b$var$bytesToHex(bytes));
}
function $31c9d583d88bbd0b$var$bytesToNumberLE(bytes) {
    $31c9d583d88bbd0b$var$abytes(bytes);
    return $31c9d583d88bbd0b$var$hexToNumber($31c9d583d88bbd0b$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
function $31c9d583d88bbd0b$var$numberToBytesBE(n, len) {
    return $31c9d583d88bbd0b$var$hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
function $31c9d583d88bbd0b$var$numberToBytesLE(n, len) {
    return $31c9d583d88bbd0b$var$numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function $31c9d583d88bbd0b$var$numberToVarBytesBE(n) {
    return $31c9d583d88bbd0b$var$hexToBytes($31c9d583d88bbd0b$var$numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $31c9d583d88bbd0b$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = $31c9d583d88bbd0b$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if ($31c9d583d88bbd0b$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $31c9d583d88bbd0b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $31c9d583d88bbd0b$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function $31c9d583d88bbd0b$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $31c9d583d88bbd0b$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $31c9d583d88bbd0b$var$isPosBig = (n)=>typeof n === 'bigint' && $31c9d583d88bbd0b$var$_0n <= n;
function $31c9d583d88bbd0b$var$inRange(n, min, max) {
    return $31c9d583d88bbd0b$var$isPosBig(n) && $31c9d583d88bbd0b$var$isPosBig(min) && $31c9d583d88bbd0b$var$isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */ function $31c9d583d88bbd0b$var$aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$31c9d583d88bbd0b$var$inRange(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $31c9d583d88bbd0b$var$bitLen(n) {
    let len;
    for(len = 0; n > $31c9d583d88bbd0b$var$_0n; n >>= $31c9d583d88bbd0b$var$_1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $31c9d583d88bbd0b$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $31c9d583d88bbd0b$var$_1n;
}
/**
 * Sets single bit at position.
 */ function $31c9d583d88bbd0b$var$bitSet(n, pos, value) {
    return n | (value ? $31c9d583d88bbd0b$var$_1n : $31c9d583d88bbd0b$var$_0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $31c9d583d88bbd0b$var$bitMask = (n)=>($31c9d583d88bbd0b$var$_2n << BigInt(n - 1)) - $31c9d583d88bbd0b$var$_1n;
module.exports.bitMask = $31c9d583d88bbd0b$var$bitMask;
// DRBG
const $31c9d583d88bbd0b$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $31c9d583d88bbd0b$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $31c9d583d88bbd0b$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $31c9d583d88bbd0b$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $31c9d583d88bbd0b$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $31c9d583d88bbd0b$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($31c9d583d88bbd0b$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($31c9d583d88bbd0b$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $31c9d583d88bbd0b$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $31c9d583d88bbd0b$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || $31c9d583d88bbd0b$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $31c9d583d88bbd0b$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $31c9d583d88bbd0b$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * throws not implemented error
 */ const $31c9d583d88bbd0b$var$notImplemented = ()=>{
    throw new Error('not implemented');
};
module.exports.notImplemented = $31c9d583d88bbd0b$var$notImplemented;
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */ function $31c9d583d88bbd0b$var$memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});





parcelRegister("crndi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expand_message_xmd = $90ea03584c9281c0$var$expand_message_xmd;
module.exports.expand_message_xof = $90ea03584c9281c0$var$expand_message_xof;
module.exports.hash_to_field = $90ea03584c9281c0$var$hash_to_field;
module.exports.isogenyMap = $90ea03584c9281c0$var$isogenyMap;
module.exports.createHasher = $90ea03584c9281c0$var$createHasher;

var $5PiaG = parcelRequire("5PiaG");

var $4h1oI = parcelRequire("4h1oI");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $90ea03584c9281c0$var$os2ip = $4h1oI.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $90ea03584c9281c0$var$i2osp(value, length) {
    $90ea03584c9281c0$var$anum(value);
    $90ea03584c9281c0$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $90ea03584c9281c0$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $90ea03584c9281c0$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
/**
 * Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits.
 * [RFC 9380 5.3.1](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1).
 */ function $90ea03584c9281c0$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, $4h1oI.abytes)(msg);
    (0, $4h1oI.abytes)(DST);
    $90ea03584c9281c0$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $4h1oI.concatBytes)((0, $4h1oI.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $4h1oI.concatBytes)(DST, $90ea03584c9281c0$var$i2osp(DST.length, 1));
    const Z_pad = $90ea03584c9281c0$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $90ea03584c9281c0$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $4h1oI.concatBytes)(Z_pad, msg, l_i_b_str, $90ea03584c9281c0$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $4h1oI.concatBytes)(b_0, $90ea03584c9281c0$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $90ea03584c9281c0$var$strxor(b_0, b[i - 1]),
            $90ea03584c9281c0$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $4h1oI.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $4h1oI.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
/**
 * Produces a uniformly random byte string using an extendable-output function (XOF) H.
 * 1. The collision resistance of H MUST be at least k bits.
 * 2. H MUST be an XOF that has been proved indifferentiable from
 *    a random oracle under a reasonable cryptographic assumption.
 * [RFC 9380 5.3.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2).
 */ function $90ea03584c9281c0$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, $4h1oI.abytes)(msg);
    (0, $4h1oI.abytes)(DST);
    $90ea03584c9281c0$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $4h1oI.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($90ea03584c9281c0$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($90ea03584c9281c0$var$i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F.
 * [RFC 9380 5.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.2).
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $90ea03584c9281c0$var$hash_to_field(msg, count, options) {
    (0, $4h1oI.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $4h1oI.abytes)(msg);
    $90ea03584c9281c0$var$anum(count);
    const DST = typeof _DST === 'string' ? (0, $4h1oI.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $90ea03584c9281c0$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $90ea03584c9281c0$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $5PiaG.mod)($90ea03584c9281c0$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $90ea03584c9281c0$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
/** Creates hash-to-curve methods from EC Point and mapToCurve function. */ function $90ea03584c9281c0$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $90ea03584c9281c0$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $90ea03584c9281c0$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('mapToCurve: expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('mapToCurve: expected array of bigints');
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});



parcelRegister("bEGP4", function(module, exports) {
"use strict";
/**
 * Audited & minimal JS implementation of
 * [BIP39 mnemonic phrases](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki).
 * @module
 * @example
```js
import * as bip39 from '@scure/bip39';
import { wordlist } from '@scure/bip39/wordlists/english';
const mn = bip39.generateMnemonic(wordlist);
console.log(mn);
const ent = bip39.mnemonicToEntropy(mn, wordlist)
bip39.entropyToMnemonic(ent, wordlist);
bip39.validateMnemonic(mn, wordlist);
await bip39.mnemonicToSeed(mn, 'password');
bip39.mnemonicToSeedSync(mn, 'password');

// Wordlists
import { wordlist as czech } from '@scure/bip39/wordlists/czech';
import { wordlist as english } from '@scure/bip39/wordlists/english';
import { wordlist as french } from '@scure/bip39/wordlists/french';
import { wordlist as italian } from '@scure/bip39/wordlists/italian';
import { wordlist as japanese } from '@scure/bip39/wordlists/japanese';
import { wordlist as korean } from '@scure/bip39/wordlists/korean';
import { wordlist as portuguese } from '@scure/bip39/wordlists/portuguese';
import { wordlist as simplifiedChinese } from '@scure/bip39/wordlists/simplified-chinese';
import { wordlist as spanish } from '@scure/bip39/wordlists/spanish';
import { wordlist as traditionalChinese } from '@scure/bip39/wordlists/traditional-chinese';
```
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateMnemonic = $87c4a5d719ff395c$var$generateMnemonic;
module.exports.mnemonicToEntropy = $87c4a5d719ff395c$var$mnemonicToEntropy;
module.exports.entropyToMnemonic = $87c4a5d719ff395c$var$entropyToMnemonic;
module.exports.validateMnemonic = $87c4a5d719ff395c$var$validateMnemonic;
module.exports.mnemonicToSeed = $87c4a5d719ff395c$var$mnemonicToSeed;
module.exports.mnemonicToSeedSync = $87c4a5d719ff395c$var$mnemonicToSeedSync;

var $f0d8z = parcelRequire("f0d8z");

var $gepob = parcelRequire("gepob");

var $1115I = parcelRequire("1115I");

var $d6GSQ = parcelRequire("d6GSQ");

var $fS67t = parcelRequire("fS67t");

var $3ctkB = parcelRequire("3ctkB");
// Japanese wordlist
const $87c4a5d719ff395c$var$isJapanese = (wordlist)=>wordlist[0] === '\u3042\u3044\u3053\u304f\u3057\u3093';
// Normalization replaces equivalent sequences of characters
// so that any two texts that are equivalent will be reduced
// to the same sequence of code points, called the normal form of the original text.
// https://tonsky.me/blog/unicode/#why-is-a----
function $87c4a5d719ff395c$var$nfkd(str) {
    if (typeof str !== 'string') throw new TypeError('invalid mnemonic type: ' + typeof str);
    return str.normalize('NFKD');
}
function $87c4a5d719ff395c$var$normalize(str) {
    const norm = $87c4a5d719ff395c$var$nfkd(str);
    const words = norm.split(' ');
    if (![
        12,
        15,
        18,
        21,
        24
    ].includes(words.length)) throw new Error('Invalid mnemonic');
    return {
        nfkd: norm,
        words: words
    };
}
function $87c4a5d719ff395c$var$aentropy(ent) {
    (0, $f0d8z.abytes)(ent, 16, 20, 24, 28, 32);
}
/**
 * Generate x random words. Uses Cryptographically-Secure Random Number Generator.
 * @param wordlist imported wordlist for specific language
 * @param strength mnemonic strength 128-256 bits
 * @example
 * generateMnemonic(wordlist, 128)
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $87c4a5d719ff395c$var$generateMnemonic(wordlist, strength = 128) {
    (0, $f0d8z.anumber)(strength);
    if (strength % 32 !== 0 || strength > 256) throw new TypeError('Invalid entropy');
    return $87c4a5d719ff395c$var$entropyToMnemonic((0, $fS67t.randomBytes)(strength / 8), wordlist);
}
const $87c4a5d719ff395c$var$calcChecksum = (entropy)=>{
    // Checksum is ent.length/4 bits long
    const bitsLeft = 8 - entropy.length / 4;
    // Zero rightmost "bitsLeft" bits in byte
    // For example: bitsLeft=4 val=10111101 -> 10110000
    return new Uint8Array([
        (0, $1115I.sha256)(entropy)[0] >> bitsLeft << bitsLeft
    ]);
};
function $87c4a5d719ff395c$var$getCoder(wordlist) {
    if (!Array.isArray(wordlist) || wordlist.length !== 2048 || typeof wordlist[0] !== 'string') throw new Error('Wordlist: expected array of 2048 strings');
    wordlist.forEach((i)=>{
        if (typeof i !== 'string') throw new Error('wordlist: non-string element: ' + i);
    });
    return $3ctkB.utils.chain($3ctkB.utils.checksum(1, $87c4a5d719ff395c$var$calcChecksum), $3ctkB.utils.radix2(11, true), $3ctkB.utils.alphabet(wordlist));
}
/**
 * Reversible: Converts mnemonic string to raw entropy in form of byte array.
 * @param mnemonic 12-24 words
 * @param wordlist imported wordlist for specific language
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToEntropy(mnem, wordlist)
 * // Produces
 * new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ])
 */ function $87c4a5d719ff395c$var$mnemonicToEntropy(mnemonic, wordlist) {
    const { words: words } = $87c4a5d719ff395c$var$normalize(mnemonic);
    const entropy = $87c4a5d719ff395c$var$getCoder(wordlist).decode(words);
    $87c4a5d719ff395c$var$aentropy(entropy);
    return entropy;
}
/**
 * Reversible: Converts raw entropy in form of byte array to mnemonic string.
 * @param entropy byte array
 * @param wordlist imported wordlist for specific language
 * @returns 12-24 words
 * @example
 * const ent = new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ]);
 * entropyToMnemonic(ent, wordlist);
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $87c4a5d719ff395c$var$entropyToMnemonic(entropy, wordlist) {
    $87c4a5d719ff395c$var$aentropy(entropy);
    const words = $87c4a5d719ff395c$var$getCoder(wordlist).encode(entropy);
    return words.join($87c4a5d719ff395c$var$isJapanese(wordlist) ? '\u3000' : ' ');
}
/**
 * Validates mnemonic for being 12-24 words contained in `wordlist`.
 */ function $87c4a5d719ff395c$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $87c4a5d719ff395c$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
const $87c4a5d719ff395c$var$psalt = (passphrase)=>$87c4a5d719ff395c$var$nfkd('mnemonic' + passphrase);
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * await mnemonicToSeed(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $87c4a5d719ff395c$var$mnemonicToSeed(mnemonic, passphrase = '') {
    return (0, $gepob.pbkdf2Async)($d6GSQ.sha512, $87c4a5d719ff395c$var$normalize(mnemonic).nfkd, $87c4a5d719ff395c$var$psalt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToSeedSync(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $87c4a5d719ff395c$var$mnemonicToSeedSync(mnemonic, passphrase = '') {
    return (0, $gepob.pbkdf2)($d6GSQ.sha512, $87c4a5d719ff395c$var$normalize(mnemonic).nfkd, $87c4a5d719ff395c$var$psalt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}

});
parcelRegister("f0d8z", function(module, exports) {
"use strict";
/**
 * Internal assertion helpers.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.anumber = $aec10be457579746$var$anumber;
module.exports.abytes = $aec10be457579746$var$abytes;
module.exports.ahash = $aec10be457579746$var$ahash;
module.exports.aexists = $aec10be457579746$var$aexists;
module.exports.aoutput = $aec10be457579746$var$aoutput;
/** Asserts something is positive integer. */ function $aec10be457579746$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $aec10be457579746$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is Uint8Array. */ function $aec10be457579746$var$abytes(b, ...lengths) {
    if (!$aec10be457579746$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function $aec10be457579746$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $aec10be457579746$var$anumber(h.outputLen);
    $aec10be457579746$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $aec10be457579746$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $aec10be457579746$var$aoutput(out, instance) {
    $aec10be457579746$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}

});

parcelRegister("gepob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2 = $bd11a5dc41dae3b9$var$pbkdf2;
module.exports.pbkdf2Async = $bd11a5dc41dae3b9$var$pbkdf2Async;

var $f0d8z = parcelRequire("f0d8z");

var $gMYDE = parcelRequire("gMYDE");

var $fS67t = parcelRequire("fS67t");
// Common prologue and epilogue for sync/async functions
function $bd11a5dc41dae3b9$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $f0d8z.ahash)(hash);
    const opts = (0, $fS67t.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $f0d8z.anumber)(c);
    (0, $f0d8z.anumber)(dkLen);
    (0, $f0d8z.anumber)(asyncTick);
    if (c < 1) throw new Error('PBKDF2: iterations (c) should be >= 1');
    const password = (0, $fS67t.toBytes)(_password);
    const salt = (0, $fS67t.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $gMYDE.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $bd11a5dc41dae3b9$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 * @example
 * const key = pbkdf2(sha256, 'password', 'salt', { dkLen: 32, c: 2 ** 18 });
 */ function $bd11a5dc41dae3b9$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $bd11a5dc41dae3b9$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $fS67t.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $bd11a5dc41dae3b9$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function. Async version.
 * @example
 * await pbkdf2Async(sha256, 'password', 'salt', { dkLen: 32, c: 500_000 });
 */ async function $bd11a5dc41dae3b9$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $bd11a5dc41dae3b9$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $fS67t.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $fS67t.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $bd11a5dc41dae3b9$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}

});
parcelRegister("gMYDE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $f0d8z = parcelRequire("f0d8z");

var $fS67t = parcelRequire("fS67t");
class $c3902a9933f3af88$var$HMAC extends $fS67t.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $f0d8z.ahash)(hash);
        const key = (0, $fS67t.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $f0d8z.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $f0d8z.aexists)(this);
        (0, $f0d8z.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $c3902a9933f3af88$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $c3902a9933f3af88$var$hmac = (hash, key, message)=>new $c3902a9933f3af88$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $c3902a9933f3af88$var$hmac;
module.exports.hmac.create = (hash, key)=>new $c3902a9933f3af88$var$HMAC(hash, key);

});
parcelRegister("fS67t", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = module.exports.nextTick = module.exports.byteSwapIfBE = module.exports.isLE = void 0;
module.exports.isBytes = $b8e0a5647ac9f5b4$var$isBytes;
module.exports.u8 = $b8e0a5647ac9f5b4$var$u8;
module.exports.u32 = $b8e0a5647ac9f5b4$var$u32;
module.exports.createView = $b8e0a5647ac9f5b4$var$createView;
module.exports.rotr = $b8e0a5647ac9f5b4$var$rotr;
module.exports.rotl = $b8e0a5647ac9f5b4$var$rotl;
module.exports.byteSwap = $b8e0a5647ac9f5b4$var$byteSwap;
module.exports.byteSwap32 = $b8e0a5647ac9f5b4$var$byteSwap32;
module.exports.bytesToHex = $b8e0a5647ac9f5b4$var$bytesToHex;
module.exports.hexToBytes = $b8e0a5647ac9f5b4$var$hexToBytes;
module.exports.asyncLoop = $b8e0a5647ac9f5b4$var$asyncLoop;
module.exports.utf8ToBytes = $b8e0a5647ac9f5b4$var$utf8ToBytes;
module.exports.toBytes = $b8e0a5647ac9f5b4$var$toBytes;
module.exports.concatBytes = $b8e0a5647ac9f5b4$var$concatBytes;
module.exports.checkOpts = $b8e0a5647ac9f5b4$var$checkOpts;
module.exports.wrapConstructor = $b8e0a5647ac9f5b4$var$wrapConstructor;
module.exports.wrapConstructorWithOpts = $b8e0a5647ac9f5b4$var$wrapConstructorWithOpts;
module.exports.wrapXOFConstructorWithOpts = $b8e0a5647ac9f5b4$var$wrapXOFConstructorWithOpts;
module.exports.randomBytes = $b8e0a5647ac9f5b4$var$randomBytes;

var $lks5L = parcelRequire("lks5L");

var $f0d8z = parcelRequire("f0d8z");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $b8e0a5647ac9f5b4$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
// Cast array to different type
function $b8e0a5647ac9f5b4$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $b8e0a5647ac9f5b4$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
// Cast array to view
function $b8e0a5647ac9f5b4$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $b8e0a5647ac9f5b4$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $b8e0a5647ac9f5b4$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// The byte swap operation for uint32
function $b8e0a5647ac9f5b4$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>$b8e0a5647ac9f5b4$var$byteSwap(n);
/** In place byte swap for Uint32Array */ function $b8e0a5647ac9f5b4$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $b8e0a5647ac9f5b4$var$byteSwap(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $b8e0a5647ac9f5b4$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $b8e0a5647ac9f5b4$var$bytesToHex(bytes) {
    (0, $f0d8z.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $b8e0a5647ac9f5b4$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $b8e0a5647ac9f5b4$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $b8e0a5647ac9f5b4$var$asciiToBase16(ch) {
    if (ch >= $b8e0a5647ac9f5b4$var$asciis._0 && ch <= $b8e0a5647ac9f5b4$var$asciis._9) return ch - $b8e0a5647ac9f5b4$var$asciis._0; // '2' => 50-48
    if (ch >= $b8e0a5647ac9f5b4$var$asciis.A && ch <= $b8e0a5647ac9f5b4$var$asciis.F) return ch - ($b8e0a5647ac9f5b4$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $b8e0a5647ac9f5b4$var$asciis.a && ch <= $b8e0a5647ac9f5b4$var$asciis.f) return ch - ($b8e0a5647ac9f5b4$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $b8e0a5647ac9f5b4$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $b8e0a5647ac9f5b4$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $b8e0a5647ac9f5b4$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $b8e0a5647ac9f5b4$var$nextTick = async ()=>{};
module.exports.nextTick = $b8e0a5647ac9f5b4$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $b8e0a5647ac9f5b4$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * Convert JS string to byte array.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $b8e0a5647ac9f5b4$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('utf8ToBytes expected string, got ' + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $b8e0a5647ac9f5b4$var$toBytes(data) {
    if (typeof data === 'string') data = $b8e0a5647ac9f5b4$var$utf8ToBytes(data);
    (0, $f0d8z.abytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $b8e0a5647ac9f5b4$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $f0d8z.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** For runtime check if class implements interface */ class $b8e0a5647ac9f5b4$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $b8e0a5647ac9f5b4$var$Hash;
function $b8e0a5647ac9f5b4$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** Wraps hash function, creating an interface on top of it */ function $b8e0a5647ac9f5b4$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($b8e0a5647ac9f5b4$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $b8e0a5647ac9f5b4$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b8e0a5647ac9f5b4$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $b8e0a5647ac9f5b4$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b8e0a5647ac9f5b4$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $b8e0a5647ac9f5b4$var$randomBytes(bytesLength = 32) {
    if ($lks5L.crypto && typeof $lks5L.crypto.getRandomValues === 'function') return $lks5L.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($lks5L.crypto && typeof $lks5L.crypto.randomBytes === 'function') return $lks5L.crypto.randomBytes(bytesLength);
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("lks5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("1115I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = module.exports.SHA256 = void 0;

var $9DhBC = parcelRequire("9DhBC");

var $fS67t = parcelRequire("fS67t");
/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $0bd6bb2305e829dc$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $0bd6bb2305e829dc$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $0bd6bb2305e829dc$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $0bd6bb2305e829dc$var$SHA256 extends $9DhBC.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $0bd6bb2305e829dc$var$SHA256_IV[0] | 0;
        this.B = $0bd6bb2305e829dc$var$SHA256_IV[1] | 0;
        this.C = $0bd6bb2305e829dc$var$SHA256_IV[2] | 0;
        this.D = $0bd6bb2305e829dc$var$SHA256_IV[3] | 0;
        this.E = $0bd6bb2305e829dc$var$SHA256_IV[4] | 0;
        this.F = $0bd6bb2305e829dc$var$SHA256_IV[5] | 0;
        this.G = $0bd6bb2305e829dc$var$SHA256_IV[6] | 0;
        this.H = $0bd6bb2305e829dc$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$0bd6bb2305e829dc$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $0bd6bb2305e829dc$var$SHA256_W[i - 15];
            const W2 = $0bd6bb2305e829dc$var$SHA256_W[i - 2];
            const s0 = (0, $fS67t.rotr)(W15, 7) ^ (0, $fS67t.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $fS67t.rotr)(W2, 17) ^ (0, $fS67t.rotr)(W2, 19) ^ W2 >>> 10;
            $0bd6bb2305e829dc$var$SHA256_W[i] = s1 + $0bd6bb2305e829dc$var$SHA256_W[i - 7] + s0 + $0bd6bb2305e829dc$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $fS67t.rotr)(E, 6) ^ (0, $fS67t.rotr)(E, 11) ^ (0, $fS67t.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $9DhBC.Chi)(E, F, G) + $0bd6bb2305e829dc$var$SHA256_K[i] + $0bd6bb2305e829dc$var$SHA256_W[i] | 0;
            const sigma0 = (0, $fS67t.rotr)(A, 2) ^ (0, $fS67t.rotr)(A, 13) ^ (0, $fS67t.rotr)(A, 22);
            const T2 = sigma0 + (0, $9DhBC.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $0bd6bb2305e829dc$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
module.exports.SHA256 = $0bd6bb2305e829dc$var$SHA256;
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $0bd6bb2305e829dc$var$SHA224 extends $0bd6bb2305e829dc$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/** SHA2-256 hash function */ module.exports.sha256 = (0, $fS67t.wrapConstructor)(()=>new $0bd6bb2305e829dc$var$SHA256());
/** SHA2-224 hash function */ module.exports.sha224 = (0, $fS67t.wrapConstructor)(()=>new $0bd6bb2305e829dc$var$SHA224());

});
parcelRegister("9DhBC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashMD = void 0;
module.exports.setBigUint64 = $703569bbd67b86c4$var$setBigUint64;
module.exports.Chi = $703569bbd67b86c4$var$Chi;
module.exports.Maj = $703569bbd67b86c4$var$Maj;

var $f0d8z = parcelRequire("f0d8z");

var $fS67t = parcelRequire("fS67t");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $703569bbd67b86c4$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $703569bbd67b86c4$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $703569bbd67b86c4$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $703569bbd67b86c4$var$HashMD extends $fS67t.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $fS67t.createView)(this.buffer);
    }
    update(data) {
        (0, $f0d8z.aexists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $fS67t.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $fS67t.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $f0d8z.aexists)(this);
        (0, $f0d8z.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $703569bbd67b86c4$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $fS67t.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.HashMD = $703569bbd67b86c4$var$HashMD;

});


parcelRegister("d6GSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA384 = module.exports.SHA512_256 = module.exports.SHA512_224 = module.exports.SHA512 = void 0;

var $9DhBC = parcelRequire("9DhBC");

var $9Rq98 = parcelRequire("9Rq98");

var $fS67t = parcelRequire("fS67t");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$98ad19ae69bfa8fd$var$SHA512_Kh, $98ad19ae69bfa8fd$var$SHA512_Kl] = /* @__PURE__ */ (()=>$9Rq98.default.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $98ad19ae69bfa8fd$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $98ad19ae69bfa8fd$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $98ad19ae69bfa8fd$var$SHA512 extends $9DhBC.HashMD {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $98ad19ae69bfa8fd$var$SHA512_W_H[i] = view.getUint32(offset);
            $98ad19ae69bfa8fd$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $98ad19ae69bfa8fd$var$SHA512_W_H[i - 15] | 0;
            const W15l = $98ad19ae69bfa8fd$var$SHA512_W_L[i - 15] | 0;
            const s0h = $9Rq98.default.rotrSH(W15h, W15l, 1) ^ $9Rq98.default.rotrSH(W15h, W15l, 8) ^ $9Rq98.default.shrSH(W15h, W15l, 7);
            const s0l = $9Rq98.default.rotrSL(W15h, W15l, 1) ^ $9Rq98.default.rotrSL(W15h, W15l, 8) ^ $9Rq98.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $98ad19ae69bfa8fd$var$SHA512_W_H[i - 2] | 0;
            const W2l = $98ad19ae69bfa8fd$var$SHA512_W_L[i - 2] | 0;
            const s1h = $9Rq98.default.rotrSH(W2h, W2l, 19) ^ $9Rq98.default.rotrBH(W2h, W2l, 61) ^ $9Rq98.default.shrSH(W2h, W2l, 6);
            const s1l = $9Rq98.default.rotrSL(W2h, W2l, 19) ^ $9Rq98.default.rotrBL(W2h, W2l, 61) ^ $9Rq98.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $9Rq98.default.add4L(s0l, s1l, $98ad19ae69bfa8fd$var$SHA512_W_L[i - 7], $98ad19ae69bfa8fd$var$SHA512_W_L[i - 16]);
            const SUMh = $9Rq98.default.add4H(SUMl, s0h, s1h, $98ad19ae69bfa8fd$var$SHA512_W_H[i - 7], $98ad19ae69bfa8fd$var$SHA512_W_H[i - 16]);
            $98ad19ae69bfa8fd$var$SHA512_W_H[i] = SUMh | 0;
            $98ad19ae69bfa8fd$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $9Rq98.default.rotrSH(Eh, El, 14) ^ $9Rq98.default.rotrSH(Eh, El, 18) ^ $9Rq98.default.rotrBH(Eh, El, 41);
            const sigma1l = $9Rq98.default.rotrSL(Eh, El, 14) ^ $9Rq98.default.rotrSL(Eh, El, 18) ^ $9Rq98.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $9Rq98.default.add5L(Hl, sigma1l, CHIl, $98ad19ae69bfa8fd$var$SHA512_Kl[i], $98ad19ae69bfa8fd$var$SHA512_W_L[i]);
            const T1h = $9Rq98.default.add5H(T1ll, Hh, sigma1h, CHIh, $98ad19ae69bfa8fd$var$SHA512_Kh[i], $98ad19ae69bfa8fd$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $9Rq98.default.rotrSH(Ah, Al, 28) ^ $9Rq98.default.rotrBH(Ah, Al, 34) ^ $9Rq98.default.rotrBH(Ah, Al, 39);
            const sigma0l = $9Rq98.default.rotrSL(Ah, Al, 28) ^ $9Rq98.default.rotrBL(Ah, Al, 34) ^ $9Rq98.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $9Rq98.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $9Rq98.default.add3L(T1l, sigma0l, MAJl);
            Ah = $9Rq98.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $9Rq98.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $9Rq98.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $9Rq98.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $9Rq98.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $9Rq98.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $9Rq98.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $9Rq98.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $9Rq98.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $98ad19ae69bfa8fd$var$SHA512_W_H.fill(0);
        $98ad19ae69bfa8fd$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $98ad19ae69bfa8fd$var$SHA512;
class $98ad19ae69bfa8fd$var$SHA512_224 extends $98ad19ae69bfa8fd$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
module.exports.SHA512_224 = $98ad19ae69bfa8fd$var$SHA512_224;
class $98ad19ae69bfa8fd$var$SHA512_256 extends $98ad19ae69bfa8fd$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
module.exports.SHA512_256 = $98ad19ae69bfa8fd$var$SHA512_256;
class $98ad19ae69bfa8fd$var$SHA384 extends $98ad19ae69bfa8fd$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.SHA384 = $98ad19ae69bfa8fd$var$SHA384;
/** SHA2-512 hash function. */ module.exports.sha512 = (0, $fS67t.wrapConstructor)(()=>new $98ad19ae69bfa8fd$var$SHA512());
/** SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks. */ module.exports.sha512_224 = (0, $fS67t.wrapConstructor)(()=>new $98ad19ae69bfa8fd$var$SHA512_224());
/** SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks. */ module.exports.sha512_256 = (0, $fS67t.wrapConstructor)(()=>new $98ad19ae69bfa8fd$var$SHA512_256());
/** SHA2-384 hash function. */ module.exports.sha384 = (0, $fS67t.wrapConstructor)(()=>new $98ad19ae69bfa8fd$var$SHA384());

});
parcelRegister("9Rq98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = void 0;
module.exports.fromBig = $72dd5862ebdbb84b$var$fromBig;
module.exports.split = $72dd5862ebdbb84b$var$split;
module.exports.add = $72dd5862ebdbb84b$var$add;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $72dd5862ebdbb84b$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $72dd5862ebdbb84b$var$_32n = /* @__PURE__ */ BigInt(32);
function $72dd5862ebdbb84b$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $72dd5862ebdbb84b$var$U32_MASK64),
        l: Number(n >> $72dd5862ebdbb84b$var$_32n & $72dd5862ebdbb84b$var$U32_MASK64)
    };
    return {
        h: Number(n >> $72dd5862ebdbb84b$var$_32n & $72dd5862ebdbb84b$var$U32_MASK64) | 0,
        l: Number(n & $72dd5862ebdbb84b$var$U32_MASK64) | 0
    };
}
function $72dd5862ebdbb84b$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $72dd5862ebdbb84b$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $72dd5862ebdbb84b$var$toBig = (h, l)=>BigInt(h >>> 0) << $72dd5862ebdbb84b$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $72dd5862ebdbb84b$var$toBig;
// for Shift in [0, 32)
const $72dd5862ebdbb84b$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $72dd5862ebdbb84b$var$shrSH;
const $72dd5862ebdbb84b$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $72dd5862ebdbb84b$var$shrSL;
// Right rotate for Shift in [1, 32)
const $72dd5862ebdbb84b$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $72dd5862ebdbb84b$var$rotrSH;
const $72dd5862ebdbb84b$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $72dd5862ebdbb84b$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $72dd5862ebdbb84b$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $72dd5862ebdbb84b$var$rotrBH;
const $72dd5862ebdbb84b$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $72dd5862ebdbb84b$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $72dd5862ebdbb84b$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $72dd5862ebdbb84b$var$rotr32H;
const $72dd5862ebdbb84b$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $72dd5862ebdbb84b$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $72dd5862ebdbb84b$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $72dd5862ebdbb84b$var$rotlSH;
const $72dd5862ebdbb84b$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $72dd5862ebdbb84b$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $72dd5862ebdbb84b$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $72dd5862ebdbb84b$var$rotlBH;
const $72dd5862ebdbb84b$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $72dd5862ebdbb84b$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $72dd5862ebdbb84b$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $72dd5862ebdbb84b$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $72dd5862ebdbb84b$var$add3L;
const $72dd5862ebdbb84b$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $72dd5862ebdbb84b$var$add3H;
const $72dd5862ebdbb84b$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $72dd5862ebdbb84b$var$add4L;
const $72dd5862ebdbb84b$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $72dd5862ebdbb84b$var$add4H;
const $72dd5862ebdbb84b$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $72dd5862ebdbb84b$var$add5L;
const $72dd5862ebdbb84b$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $72dd5862ebdbb84b$var$add5H;
// prettier-ignore
const $72dd5862ebdbb84b$var$u64 = {
    fromBig: $72dd5862ebdbb84b$var$fromBig,
    split: $72dd5862ebdbb84b$var$split,
    toBig: $72dd5862ebdbb84b$var$toBig,
    shrSH: $72dd5862ebdbb84b$var$shrSH,
    shrSL: $72dd5862ebdbb84b$var$shrSL,
    rotrSH: $72dd5862ebdbb84b$var$rotrSH,
    rotrSL: $72dd5862ebdbb84b$var$rotrSL,
    rotrBH: $72dd5862ebdbb84b$var$rotrBH,
    rotrBL: $72dd5862ebdbb84b$var$rotrBL,
    rotr32H: $72dd5862ebdbb84b$var$rotr32H,
    rotr32L: $72dd5862ebdbb84b$var$rotr32L,
    rotlSH: $72dd5862ebdbb84b$var$rotlSH,
    rotlSL: $72dd5862ebdbb84b$var$rotlSL,
    rotlBH: $72dd5862ebdbb84b$var$rotlBH,
    rotlBL: $72dd5862ebdbb84b$var$rotlBL,
    add: $72dd5862ebdbb84b$var$add,
    add3L: $72dd5862ebdbb84b$var$add3L,
    add3H: $72dd5862ebdbb84b$var$add3H,
    add4L: $72dd5862ebdbb84b$var$add4L,
    add4H: $72dd5862ebdbb84b$var$add4H,
    add5H: $72dd5862ebdbb84b$var$add5H,
    add5L: $72dd5862ebdbb84b$var$add5L
};
module.exports.default = $72dd5862ebdbb84b$var$u64;

});



parcelRegister("81mA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wordlist = void 0;
module.exports.wordlist = `abandon
ability
able
about
above
absent
absorb
abstract
absurd
abuse
access
accident
account
accuse
achieve
acid
acoustic
acquire
across
act
action
actor
actress
actual
adapt
add
addict
address
adjust
admit
adult
advance
advice
aerobic
affair
afford
afraid
again
age
agent
agree
ahead
aim
air
airport
aisle
alarm
album
alcohol
alert
alien
all
alley
allow
almost
alone
alpha
already
also
alter
always
amateur
amazing
among
amount
amused
analyst
anchor
ancient
anger
angle
angry
animal
ankle
announce
annual
another
answer
antenna
antique
anxiety
any
apart
apology
appear
apple
approve
april
arch
arctic
area
arena
argue
arm
armed
armor
army
around
arrange
arrest
arrive
arrow
art
artefact
artist
artwork
ask
aspect
assault
asset
assist
assume
asthma
athlete
atom
attack
attend
attitude
attract
auction
audit
august
aunt
author
auto
autumn
average
avocado
avoid
awake
aware
away
awesome
awful
awkward
axis
baby
bachelor
bacon
badge
bag
balance
balcony
ball
bamboo
banana
banner
bar
barely
bargain
barrel
base
basic
basket
battle
beach
bean
beauty
because
become
beef
before
begin
behave
behind
believe
below
belt
bench
benefit
best
betray
better
between
beyond
bicycle
bid
bike
bind
biology
bird
birth
bitter
black
blade
blame
blanket
blast
bleak
bless
blind
blood
blossom
blouse
blue
blur
blush
board
boat
body
boil
bomb
bone
bonus
book
boost
border
boring
borrow
boss
bottom
bounce
box
boy
bracket
brain
brand
brass
brave
bread
breeze
brick
bridge
brief
bright
bring
brisk
broccoli
broken
bronze
broom
brother
brown
brush
bubble
buddy
budget
buffalo
build
bulb
bulk
bullet
bundle
bunker
burden
burger
burst
bus
business
busy
butter
buyer
buzz
cabbage
cabin
cable
cactus
cage
cake
call
calm
camera
camp
can
canal
cancel
candy
cannon
canoe
canvas
canyon
capable
capital
captain
car
carbon
card
cargo
carpet
carry
cart
case
cash
casino
castle
casual
cat
catalog
catch
category
cattle
caught
cause
caution
cave
ceiling
celery
cement
census
century
cereal
certain
chair
chalk
champion
change
chaos
chapter
charge
chase
chat
cheap
check
cheese
chef
cherry
chest
chicken
chief
child
chimney
choice
choose
chronic
chuckle
chunk
churn
cigar
cinnamon
circle
citizen
city
civil
claim
clap
clarify
claw
clay
clean
clerk
clever
click
client
cliff
climb
clinic
clip
clock
clog
close
cloth
cloud
clown
club
clump
cluster
clutch
coach
coast
coconut
code
coffee
coil
coin
collect
color
column
combine
come
comfort
comic
common
company
concert
conduct
confirm
congress
connect
consider
control
convince
cook
cool
copper
copy
coral
core
corn
correct
cost
cotton
couch
country
couple
course
cousin
cover
coyote
crack
cradle
craft
cram
crane
crash
crater
crawl
crazy
cream
credit
creek
crew
cricket
crime
crisp
critic
crop
cross
crouch
crowd
crucial
cruel
cruise
crumble
crunch
crush
cry
crystal
cube
culture
cup
cupboard
curious
current
curtain
curve
cushion
custom
cute
cycle
dad
damage
damp
dance
danger
daring
dash
daughter
dawn
day
deal
debate
debris
decade
december
decide
decline
decorate
decrease
deer
defense
define
defy
degree
delay
deliver
demand
demise
denial
dentist
deny
depart
depend
deposit
depth
deputy
derive
describe
desert
design
desk
despair
destroy
detail
detect
develop
device
devote
diagram
dial
diamond
diary
dice
diesel
diet
differ
digital
dignity
dilemma
dinner
dinosaur
direct
dirt
disagree
discover
disease
dish
dismiss
disorder
display
distance
divert
divide
divorce
dizzy
doctor
document
dog
doll
dolphin
domain
donate
donkey
donor
door
dose
double
dove
draft
dragon
drama
drastic
draw
dream
dress
drift
drill
drink
drip
drive
drop
drum
dry
duck
dumb
dune
during
dust
dutch
duty
dwarf
dynamic
eager
eagle
early
earn
earth
easily
east
easy
echo
ecology
economy
edge
edit
educate
effort
egg
eight
either
elbow
elder
electric
elegant
element
elephant
elevator
elite
else
embark
embody
embrace
emerge
emotion
employ
empower
empty
enable
enact
end
endless
endorse
enemy
energy
enforce
engage
engine
enhance
enjoy
enlist
enough
enrich
enroll
ensure
enter
entire
entry
envelope
episode
equal
equip
era
erase
erode
erosion
error
erupt
escape
essay
essence
estate
eternal
ethics
evidence
evil
evoke
evolve
exact
example
excess
exchange
excite
exclude
excuse
execute
exercise
exhaust
exhibit
exile
exist
exit
exotic
expand
expect
expire
explain
expose
express
extend
extra
eye
eyebrow
fabric
face
faculty
fade
faint
faith
fall
false
fame
family
famous
fan
fancy
fantasy
farm
fashion
fat
fatal
father
fatigue
fault
favorite
feature
february
federal
fee
feed
feel
female
fence
festival
fetch
fever
few
fiber
fiction
field
figure
file
film
filter
final
find
fine
finger
finish
fire
firm
first
fiscal
fish
fit
fitness
fix
flag
flame
flash
flat
flavor
flee
flight
flip
float
flock
floor
flower
fluid
flush
fly
foam
focus
fog
foil
fold
follow
food
foot
force
forest
forget
fork
fortune
forum
forward
fossil
foster
found
fox
fragile
frame
frequent
fresh
friend
fringe
frog
front
frost
frown
frozen
fruit
fuel
fun
funny
furnace
fury
future
gadget
gain
galaxy
gallery
game
gap
garage
garbage
garden
garlic
garment
gas
gasp
gate
gather
gauge
gaze
general
genius
genre
gentle
genuine
gesture
ghost
giant
gift
giggle
ginger
giraffe
girl
give
glad
glance
glare
glass
glide
glimpse
globe
gloom
glory
glove
glow
glue
goat
goddess
gold
good
goose
gorilla
gospel
gossip
govern
gown
grab
grace
grain
grant
grape
grass
gravity
great
green
grid
grief
grit
grocery
group
grow
grunt
guard
guess
guide
guilt
guitar
gun
gym
habit
hair
half
hammer
hamster
hand
happy
harbor
hard
harsh
harvest
hat
have
hawk
hazard
head
health
heart
heavy
hedgehog
height
hello
helmet
help
hen
hero
hidden
high
hill
hint
hip
hire
history
hobby
hockey
hold
hole
holiday
hollow
home
honey
hood
hope
horn
horror
horse
hospital
host
hotel
hour
hover
hub
huge
human
humble
humor
hundred
hungry
hunt
hurdle
hurry
hurt
husband
hybrid
ice
icon
idea
identify
idle
ignore
ill
illegal
illness
image
imitate
immense
immune
impact
impose
improve
impulse
inch
include
income
increase
index
indicate
indoor
industry
infant
inflict
inform
inhale
inherit
initial
inject
injury
inmate
inner
innocent
input
inquiry
insane
insect
inside
inspire
install
intact
interest
into
invest
invite
involve
iron
island
isolate
issue
item
ivory
jacket
jaguar
jar
jazz
jealous
jeans
jelly
jewel
job
join
joke
journey
joy
judge
juice
jump
jungle
junior
junk
just
kangaroo
keen
keep
ketchup
key
kick
kid
kidney
kind
kingdom
kiss
kit
kitchen
kite
kitten
kiwi
knee
knife
knock
know
lab
label
labor
ladder
lady
lake
lamp
language
laptop
large
later
latin
laugh
laundry
lava
law
lawn
lawsuit
layer
lazy
leader
leaf
learn
leave
lecture
left
leg
legal
legend
leisure
lemon
lend
length
lens
leopard
lesson
letter
level
liar
liberty
library
license
life
lift
light
like
limb
limit
link
lion
liquid
list
little
live
lizard
load
loan
lobster
local
lock
logic
lonely
long
loop
lottery
loud
lounge
love
loyal
lucky
luggage
lumber
lunar
lunch
luxury
lyrics
machine
mad
magic
magnet
maid
mail
main
major
make
mammal
man
manage
mandate
mango
mansion
manual
maple
marble
march
margin
marine
market
marriage
mask
mass
master
match
material
math
matrix
matter
maximum
maze
meadow
mean
measure
meat
mechanic
medal
media
melody
melt
member
memory
mention
menu
mercy
merge
merit
merry
mesh
message
metal
method
middle
midnight
milk
million
mimic
mind
minimum
minor
minute
miracle
mirror
misery
miss
mistake
mix
mixed
mixture
mobile
model
modify
mom
moment
monitor
monkey
monster
month
moon
moral
more
morning
mosquito
mother
motion
motor
mountain
mouse
move
movie
much
muffin
mule
multiply
muscle
museum
mushroom
music
must
mutual
myself
mystery
myth
naive
name
napkin
narrow
nasty
nation
nature
near
neck
need
negative
neglect
neither
nephew
nerve
nest
net
network
neutral
never
news
next
nice
night
noble
noise
nominee
noodle
normal
north
nose
notable
note
nothing
notice
novel
now
nuclear
number
nurse
nut
oak
obey
object
oblige
obscure
observe
obtain
obvious
occur
ocean
october
odor
off
offer
office
often
oil
okay
old
olive
olympic
omit
once
one
onion
online
only
open
opera
opinion
oppose
option
orange
orbit
orchard
order
ordinary
organ
orient
original
orphan
ostrich
other
outdoor
outer
output
outside
oval
oven
over
own
owner
oxygen
oyster
ozone
pact
paddle
page
pair
palace
palm
panda
panel
panic
panther
paper
parade
parent
park
parrot
party
pass
patch
path
patient
patrol
pattern
pause
pave
payment
peace
peanut
pear
peasant
pelican
pen
penalty
pencil
people
pepper
perfect
permit
person
pet
phone
photo
phrase
physical
piano
picnic
picture
piece
pig
pigeon
pill
pilot
pink
pioneer
pipe
pistol
pitch
pizza
place
planet
plastic
plate
play
please
pledge
pluck
plug
plunge
poem
poet
point
polar
pole
police
pond
pony
pool
popular
portion
position
possible
post
potato
pottery
poverty
powder
power
practice
praise
predict
prefer
prepare
present
pretty
prevent
price
pride
primary
print
priority
prison
private
prize
problem
process
produce
profit
program
project
promote
proof
property
prosper
protect
proud
provide
public
pudding
pull
pulp
pulse
pumpkin
punch
pupil
puppy
purchase
purity
purpose
purse
push
put
puzzle
pyramid
quality
quantum
quarter
question
quick
quit
quiz
quote
rabbit
raccoon
race
rack
radar
radio
rail
rain
raise
rally
ramp
ranch
random
range
rapid
rare
rate
rather
raven
raw
razor
ready
real
reason
rebel
rebuild
recall
receive
recipe
record
recycle
reduce
reflect
reform
refuse
region
regret
regular
reject
relax
release
relief
rely
remain
remember
remind
remove
render
renew
rent
reopen
repair
repeat
replace
report
require
rescue
resemble
resist
resource
response
result
retire
retreat
return
reunion
reveal
review
reward
rhythm
rib
ribbon
rice
rich
ride
ridge
rifle
right
rigid
ring
riot
ripple
risk
ritual
rival
river
road
roast
robot
robust
rocket
romance
roof
rookie
room
rose
rotate
rough
round
route
royal
rubber
rude
rug
rule
run
runway
rural
sad
saddle
sadness
safe
sail
salad
salmon
salon
salt
salute
same
sample
sand
satisfy
satoshi
sauce
sausage
save
say
scale
scan
scare
scatter
scene
scheme
school
science
scissors
scorpion
scout
scrap
screen
script
scrub
sea
search
season
seat
second
secret
section
security
seed
seek
segment
select
sell
seminar
senior
sense
sentence
series
service
session
settle
setup
seven
shadow
shaft
shallow
share
shed
shell
sheriff
shield
shift
shine
ship
shiver
shock
shoe
shoot
shop
short
shoulder
shove
shrimp
shrug
shuffle
shy
sibling
sick
side
siege
sight
sign
silent
silk
silly
silver
similar
simple
since
sing
siren
sister
situate
six
size
skate
sketch
ski
skill
skin
skirt
skull
slab
slam
sleep
slender
slice
slide
slight
slim
slogan
slot
slow
slush
small
smart
smile
smoke
smooth
snack
snake
snap
sniff
snow
soap
soccer
social
sock
soda
soft
solar
soldier
solid
solution
solve
someone
song
soon
sorry
sort
soul
sound
soup
source
south
space
spare
spatial
spawn
speak
special
speed
spell
spend
sphere
spice
spider
spike
spin
spirit
split
spoil
sponsor
spoon
sport
spot
spray
spread
spring
spy
square
squeeze
squirrel
stable
stadium
staff
stage
stairs
stamp
stand
start
state
stay
steak
steel
stem
step
stereo
stick
still
sting
stock
stomach
stone
stool
story
stove
strategy
street
strike
strong
struggle
student
stuff
stumble
style
subject
submit
subway
success
such
sudden
suffer
sugar
suggest
suit
summer
sun
sunny
sunset
super
supply
supreme
sure
surface
surge
surprise
surround
survey
suspect
sustain
swallow
swamp
swap
swarm
swear
sweet
swift
swim
swing
switch
sword
symbol
symptom
syrup
system
table
tackle
tag
tail
talent
talk
tank
tape
target
task
taste
tattoo
taxi
teach
team
tell
ten
tenant
tennis
tent
term
test
text
thank
that
theme
then
theory
there
they
thing
this
thought
three
thrive
throw
thumb
thunder
ticket
tide
tiger
tilt
timber
time
tiny
tip
tired
tissue
title
toast
tobacco
today
toddler
toe
together
toilet
token
tomato
tomorrow
tone
tongue
tonight
tool
tooth
top
topic
topple
torch
tornado
tortoise
toss
total
tourist
toward
tower
town
toy
track
trade
traffic
tragic
train
transfer
trap
trash
travel
tray
treat
tree
trend
trial
tribe
trick
trigger
trim
trip
trophy
trouble
truck
true
truly
trumpet
trust
truth
try
tube
tuition
tumble
tuna
tunnel
turkey
turn
turtle
twelve
twenty
twice
twin
twist
two
type
typical
ugly
umbrella
unable
unaware
uncle
uncover
under
undo
unfair
unfold
unhappy
uniform
unique
unit
universe
unknown
unlock
until
unusual
unveil
update
upgrade
uphold
upon
upper
upset
urban
urge
usage
use
used
useful
useless
usual
utility
vacant
vacuum
vague
valid
valley
valve
van
vanish
vapor
various
vast
vault
vehicle
velvet
vendor
venture
venue
verb
verify
version
very
vessel
veteran
viable
vibrant
vicious
victory
video
view
village
vintage
violin
virtual
virus
visa
visit
visual
vital
vivid
vocal
voice
void
volcano
volume
vote
voyage
wage
wagon
wait
walk
wall
walnut
want
warfare
warm
warrior
wash
wasp
waste
water
wave
way
wealth
weapon
wear
weasel
weather
web
wedding
weekend
weird
welcome
west
wet
whale
what
wheat
wheel
when
where
whip
whisper
wide
width
wife
wild
will
win
window
wine
wing
wink
winner
winter
wire
wisdom
wise
wish
witness
wolf
woman
wonder
wood
wool
word
work
world
worry
worth
wrap
wreck
wrestle
wrist
write
wrong
yard
year
yellow
you
young
youth
zebra
zero
zone
zoo`.split('\n');

});

parcelRegister("jbgk0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $df6bb490486f0aa0$var$ECDSA;
(function(ECDSA) {
    ECDSA["ed25519"] = "ed25519";
    ECDSA["secp256k1"] = "ecdsa-secp256k1";
})($df6bb490486f0aa0$var$ECDSA || ($df6bb490486f0aa0$var$ECDSA = {}));
module.exports.default = $df6bb490486f0aa0$var$ECDSA;

});

parcelRegister("64n0b", function(module, exports) {
"use strict";
var $46b4f57b90038077$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46b4f57b90038077$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $46b4f57b90038077$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XChainModifyBridgeFlags = module.exports.TrustSetFlags = module.exports.PaymentChannelClaimFlags = module.exports.PaymentFlags = module.exports.OfferCreateFlags = module.exports.validateNFTokenModify = module.exports.NFTokenMintFlags = module.exports.NFTokenCreateOfferFlags = module.exports.MPTokenIssuanceSetFlags = module.exports.MPTokenIssuanceCreateFlags = module.exports.MPTokenAuthorizeFlags = module.exports.EnableAmendmentFlags = module.exports.AMMWithdrawFlags = module.exports.AMMDepositFlags = module.exports.AMMClawbackFlags = module.exports.AccountSetTfFlags = module.exports.AccountSetAsfFlags = module.exports.validate = module.exports.isMPTAmount = void 0;

var $aDIrf = parcelRequire("aDIrf");
Object.defineProperty(module.exports, "isMPTAmount", {
    enumerable: true,
    get: function() {
        return $aDIrf.isMPTAmount;
    }
});

var $j93G2 = parcelRequire("j93G2");
Object.defineProperty(module.exports, "validate", {
    enumerable: true,
    get: function() {
        return $j93G2.validate;
    }
});

$46b4f57b90038077$var$__exportStar((parcelRequire("ldSGe")), module.exports);

var $9sZOr = parcelRequire("9sZOr");
Object.defineProperty(module.exports, "AccountSetAsfFlags", {
    enumerable: true,
    get: function() {
        return $9sZOr.AccountSetAsfFlags;
    }
});
Object.defineProperty(module.exports, "AccountSetTfFlags", {
    enumerable: true,
    get: function() {
        return $9sZOr.AccountSetTfFlags;
    }
});

var $4HOmt = parcelRequire("4HOmt");
Object.defineProperty(module.exports, "AMMClawbackFlags", {
    enumerable: true,
    get: function() {
        return $4HOmt.AMMClawbackFlags;
    }
});

var $lbyT0 = parcelRequire("lbyT0");
Object.defineProperty(module.exports, "AMMDepositFlags", {
    enumerable: true,
    get: function() {
        return $lbyT0.AMMDepositFlags;
    }
});

var $hQcIN = parcelRequire("hQcIN");
Object.defineProperty(module.exports, "AMMWithdrawFlags", {
    enumerable: true,
    get: function() {
        return $hQcIN.AMMWithdrawFlags;
    }
});

var $7myZC = parcelRequire("7myZC");
Object.defineProperty(module.exports, "EnableAmendmentFlags", {
    enumerable: true,
    get: function() {
        return $7myZC.EnableAmendmentFlags;
    }
});

var $83INw = parcelRequire("83INw");
Object.defineProperty(module.exports, "MPTokenAuthorizeFlags", {
    enumerable: true,
    get: function() {
        return $83INw.MPTokenAuthorizeFlags;
    }
});

var $l0c6B = parcelRequire("l0c6B");
Object.defineProperty(module.exports, "MPTokenIssuanceCreateFlags", {
    enumerable: true,
    get: function() {
        return $l0c6B.MPTokenIssuanceCreateFlags;
    }
});

var $8W2RA = parcelRequire("8W2RA");
Object.defineProperty(module.exports, "MPTokenIssuanceSetFlags", {
    enumerable: true,
    get: function() {
        return $8W2RA.MPTokenIssuanceSetFlags;
    }
});

var $gwU9F = parcelRequire("gwU9F");
Object.defineProperty(module.exports, "NFTokenCreateOfferFlags", {
    enumerable: true,
    get: function() {
        return $gwU9F.NFTokenCreateOfferFlags;
    }
});

var $hWIeS = parcelRequire("hWIeS");
Object.defineProperty(module.exports, "NFTokenMintFlags", {
    enumerable: true,
    get: function() {
        return $hWIeS.NFTokenMintFlags;
    }
});

var $7VmLp = parcelRequire("7VmLp");
Object.defineProperty(module.exports, "validateNFTokenModify", {
    enumerable: true,
    get: function() {
        return $7VmLp.validateNFTokenModify;
    }
});

var $hgQ7j = parcelRequire("hgQ7j");
Object.defineProperty(module.exports, "OfferCreateFlags", {
    enumerable: true,
    get: function() {
        return $hgQ7j.OfferCreateFlags;
    }
});

var $c45eL = parcelRequire("c45eL");
Object.defineProperty(module.exports, "PaymentFlags", {
    enumerable: true,
    get: function() {
        return $c45eL.PaymentFlags;
    }
});

var $2907n = parcelRequire("2907n");
Object.defineProperty(module.exports, "PaymentChannelClaimFlags", {
    enumerable: true,
    get: function() {
        return $2907n.PaymentChannelClaimFlags;
    }
});

var $2sSFD = parcelRequire("2sSFD");
Object.defineProperty(module.exports, "TrustSetFlags", {
    enumerable: true,
    get: function() {
        return $2sSFD.TrustSetFlags;
    }
});

var $ajTnA = parcelRequire("ajTnA");
Object.defineProperty(module.exports, "XChainModifyBridgeFlags", {
    enumerable: true,
    get: function() {
        return $ajTnA.XChainModifyBridgeFlags;
    }
});

});
parcelRegister("j93G2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validate = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $jvbLy = parcelRequire("jvbLy");

var $4zZ3F = parcelRequire("4zZ3F");

var $9sZOr = parcelRequire("9sZOr");

var $kWP0D = parcelRequire("kWP0D");

var $4HOmt = parcelRequire("4HOmt");

var $iBXiU = parcelRequire("iBXiU");

var $jqgXX = parcelRequire("jqgXX");

var $lbyT0 = parcelRequire("lbyT0");

var $1uhI9 = parcelRequire("1uhI9");

var $hQcIN = parcelRequire("hQcIN");

var $2ib7R = parcelRequire("2ib7R");

var $bUz9y = parcelRequire("bUz9y");

var $8UCN8 = parcelRequire("8UCN8");

var $jhazx = parcelRequire("jhazx");

var $aDIrf = parcelRequire("aDIrf");

var $9ewia = parcelRequire("9ewia");

var $fx9Lv = parcelRequire("fx9Lv");

var $cTjYk = parcelRequire("cTjYk");

var $lmhog = parcelRequire("lmhog");

var $5hKQM = parcelRequire("5hKQM");

var $e6Pg3 = parcelRequire("e6Pg3");

var $dcJa4 = parcelRequire("dcJa4");

var $lMRxp = parcelRequire("lMRxp");

var $f0MwY = parcelRequire("f0MwY");

var $83INw = parcelRequire("83INw");

var $l0c6B = parcelRequire("l0c6B");

var $01y2c = parcelRequire("01y2c");

var $8W2RA = parcelRequire("8W2RA");

var $4isQX = parcelRequire("4isQX");

var $3LNNg = parcelRequire("3LNNg");

var $4pxic = parcelRequire("4pxic");

var $gwU9F = parcelRequire("gwU9F");

var $hWIeS = parcelRequire("hWIeS");

var $7VmLp = parcelRequire("7VmLp");

var $9yptt = parcelRequire("9yptt");

var $hgQ7j = parcelRequire("hgQ7j");

var $leRZV = parcelRequire("leRZV");

var $8iw6o = parcelRequire("8iw6o");

var $c45eL = parcelRequire("c45eL");

var $2907n = parcelRequire("2907n");

var $bCTWh = parcelRequire("bCTWh");

var $hCtW3 = parcelRequire("hCtW3");

var $hqxhY = parcelRequire("hqxhY");

var $h2MPP = parcelRequire("h2MPP");

var $5vT3p = parcelRequire("5vT3p");

var $2OWrK = parcelRequire("2OWrK");

var $jFPml = parcelRequire("jFPml");

var $2sSFD = parcelRequire("2sSFD");

var $gAGff = parcelRequire("gAGff");

var $kkPYt = parcelRequire("kkPYt");

var $jiXHy = parcelRequire("jiXHy");

var $kDLeH = parcelRequire("kDLeH");

var $fCKCW = parcelRequire("fCKCW");

var $cDhU5 = parcelRequire("cDhU5");

var $64uqe = parcelRequire("64uqe");

var $ajTnA = parcelRequire("ajTnA");
function $df01b5c4aebb7279$var$validate(transaction) {
    const tx = Object.assign({}, transaction);
    if (tx.TransactionType == null) throw new $aMl9I.ValidationError('Object does not have a `TransactionType`');
    if (typeof tx.TransactionType !== 'string') throw new $aMl9I.ValidationError("Object's `TransactionType` is not a string");
    if (tx.Memos != null && typeof tx.Memos !== 'object') throw new $aMl9I.ValidationError('Memo must be array');
    if (tx.Memos != null) tx.Memos.forEach((memo)=>{
        if ((memo === null || memo === void 0 ? void 0 : memo.Memo) == null) throw new $aMl9I.ValidationError('Memo data must be in a `Memo` field');
        if (memo.Memo.MemoData) {
            if (!(0, $33Rto.isHex)(memo.Memo.MemoData)) throw new $aMl9I.ValidationError('MemoData field must be a hex value');
        }
        if (memo.Memo.MemoType) {
            if (!(0, $33Rto.isHex)(memo.Memo.MemoType)) throw new $aMl9I.ValidationError('MemoType field must be a hex value');
        }
        if (memo.Memo.MemoFormat) {
            if (!(0, $33Rto.isHex)(memo.Memo.MemoFormat)) throw new $aMl9I.ValidationError('MemoFormat field must be a hex value');
        }
    });
    Object.keys(tx).forEach((key)=>{
        const standard_currency_code_len = 3;
        if (tx[key] && (0, $aDIrf.isIssuedCurrency)(tx[key])) {
            const txCurrency = tx[key].currency;
            if (txCurrency.length === standard_currency_code_len && txCurrency.toUpperCase() === 'XRP') throw new $aMl9I.ValidationError(`Cannot have an issued currency with a similar standard code to XRP (received '${txCurrency}'). XRP is not an issued currency.`);
        }
    });
    tx.Flags = (0, $jvbLy.convertTxFlagsToNumber)(tx);
    switch(tx.TransactionType){
        case 'AMMBid':
            (0, $kWP0D.validateAMMBid)(tx);
            break;
        case 'AMMClawback':
            (0, $4HOmt.validateAMMClawback)(tx);
            break;
        case 'AMMCreate':
            (0, $iBXiU.validateAMMCreate)(tx);
            break;
        case 'AMMDelete':
            (0, $jqgXX.validateAMMDelete)(tx);
            break;
        case 'AMMDeposit':
            (0, $lbyT0.validateAMMDeposit)(tx);
            break;
        case 'AMMVote':
            (0, $1uhI9.validateAMMVote)(tx);
            break;
        case 'AMMWithdraw':
            (0, $hQcIN.validateAMMWithdraw)(tx);
            break;
        case 'AccountDelete':
            (0, $4zZ3F.validateAccountDelete)(tx);
            break;
        case 'AccountSet':
            (0, $9sZOr.validateAccountSet)(tx);
            break;
        case 'CheckCancel':
            (0, $2ib7R.validateCheckCancel)(tx);
            break;
        case 'CheckCash':
            (0, $bUz9y.validateCheckCash)(tx);
            break;
        case 'CheckCreate':
            (0, $8UCN8.validateCheckCreate)(tx);
            break;
        case 'Clawback':
            (0, $jhazx.validateClawback)(tx);
            break;
        case 'CredentialAccept':
            (0, $9ewia.validateCredentialAccept)(tx);
            break;
        case 'CredentialCreate':
            (0, $fx9Lv.validateCredentialCreate)(tx);
            break;
        case 'CredentialDelete':
            (0, $cTjYk.validateCredentialDelete)(tx);
            break;
        case 'DIDDelete':
            (0, $5hKQM.validateDIDDelete)(tx);
            break;
        case 'DIDSet':
            (0, $e6Pg3.validateDIDSet)(tx);
            break;
        case 'DepositPreauth':
            (0, $lmhog.validateDepositPreauth)(tx);
            break;
        case 'EscrowCancel':
            (0, $dcJa4.validateEscrowCancel)(tx);
            break;
        case 'EscrowCreate':
            (0, $lMRxp.validateEscrowCreate)(tx);
            break;
        case 'EscrowFinish':
            (0, $f0MwY.validateEscrowFinish)(tx);
            break;
        case 'MPTokenAuthorize':
            (0, $83INw.validateMPTokenAuthorize)(tx);
            break;
        case 'MPTokenIssuanceCreate':
            (0, $l0c6B.validateMPTokenIssuanceCreate)(tx);
            break;
        case 'MPTokenIssuanceDestroy':
            (0, $01y2c.validateMPTokenIssuanceDestroy)(tx);
            break;
        case 'MPTokenIssuanceSet':
            (0, $8W2RA.validateMPTokenIssuanceSet)(tx);
            break;
        case 'NFTokenAcceptOffer':
            (0, $4isQX.validateNFTokenAcceptOffer)(tx);
            break;
        case 'NFTokenBurn':
            (0, $3LNNg.validateNFTokenBurn)(tx);
            break;
        case 'NFTokenCancelOffer':
            (0, $4pxic.validateNFTokenCancelOffer)(tx);
            break;
        case 'NFTokenCreateOffer':
            (0, $gwU9F.validateNFTokenCreateOffer)(tx);
            break;
        case 'NFTokenMint':
            (0, $hWIeS.validateNFTokenMint)(tx);
            break;
        case 'NFTokenModify':
            (0, $7VmLp.validateNFTokenModify)(tx);
            break;
        case 'OfferCancel':
            (0, $9yptt.validateOfferCancel)(tx);
            break;
        case 'OfferCreate':
            (0, $hgQ7j.validateOfferCreate)(tx);
            break;
        case 'OracleDelete':
            (0, $leRZV.validateOracleDelete)(tx);
            break;
        case 'OracleSet':
            (0, $8iw6o.validateOracleSet)(tx);
            break;
        case 'Payment':
            (0, $c45eL.validatePayment)(tx);
            break;
        case 'PaymentChannelClaim':
            (0, $2907n.validatePaymentChannelClaim)(tx);
            break;
        case 'PaymentChannelCreate':
            (0, $bCTWh.validatePaymentChannelCreate)(tx);
            break;
        case 'PaymentChannelFund':
            (0, $hCtW3.validatePaymentChannelFund)(tx);
            break;
        case 'PermissionedDomainSet':
            (0, $h2MPP.validatePermissionedDomainSet)(tx);
            break;
        case 'PermissionedDomainDelete':
            (0, $hqxhY.validatePermissionedDomainDelete)(tx);
            break;
        case 'SetRegularKey':
            (0, $5vT3p.validateSetRegularKey)(tx);
            break;
        case 'SignerListSet':
            (0, $2OWrK.validateSignerListSet)(tx);
            break;
        case 'TicketCreate':
            (0, $jFPml.validateTicketCreate)(tx);
            break;
        case 'TrustSet':
            (0, $2sSFD.validateTrustSet)(tx);
            break;
        case 'XChainAccountCreateCommit':
            (0, $gAGff.validateXChainAccountCreateCommit)(tx);
            break;
        case 'XChainAddAccountCreateAttestation':
            (0, $kkPYt.validateXChainAddAccountCreateAttestation)(tx);
            break;
        case 'XChainAddClaimAttestation':
            (0, $jiXHy.validateXChainAddClaimAttestation)(tx);
            break;
        case 'XChainClaim':
            (0, $kDLeH.validateXChainClaim)(tx);
            break;
        case 'XChainCommit':
            (0, $fCKCW.validateXChainCommit)(tx);
            break;
        case 'XChainCreateBridge':
            (0, $cDhU5.validateXChainCreateBridge)(tx);
            break;
        case 'XChainCreateClaimID':
            (0, $64uqe.validateXChainCreateClaimID)(tx);
            break;
        case 'XChainModifyBridge':
            (0, $ajTnA.validateXChainModifyBridge)(tx);
            break;
        default:
            throw new $aMl9I.ValidationError(`Invalid field TransactionType: ${tx.TransactionType}`);
    }
}
module.exports.validate = $df01b5c4aebb7279$var$validate;

});
parcelRegister("4zZ3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAccountDelete = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $3559cb2ea7ff7e4c$var$validateAccountDelete(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'DestinationTag', $aDIrf.isNumber);
    (0, $aDIrf.validateCredentialsList)(tx.CredentialIDs, tx.TransactionType, true, $aDIrf.MAX_AUTHORIZED_CREDENTIALS);
}
module.exports.validateAccountDelete = $3559cb2ea7ff7e4c$var$validateAccountDelete;

});

parcelRegister("kWP0D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMBid = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
const $03ef7f2445edaaba$var$MAX_AUTH_ACCOUNTS = 4;
function $03ef7f2445edaaba$var$validateAMMBid(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Asset == null) throw new $aMl9I.ValidationError('AMMBid: missing field Asset');
    if (!(0, $aDIrf.isCurrency)(tx.Asset)) throw new $aMl9I.ValidationError('AMMBid: Asset must be a Currency');
    if (tx.Asset2 == null) throw new $aMl9I.ValidationError('AMMBid: missing field Asset2');
    if (!(0, $aDIrf.isCurrency)(tx.Asset2)) throw new $aMl9I.ValidationError('AMMBid: Asset2 must be a Currency');
    if (tx.BidMin != null && !(0, $aDIrf.isAmount)(tx.BidMin)) throw new $aMl9I.ValidationError('AMMBid: BidMin must be an Amount');
    if (tx.BidMax != null && !(0, $aDIrf.isAmount)(tx.BidMax)) throw new $aMl9I.ValidationError('AMMBid: BidMax must be an Amount');
    if (tx.AuthAccounts != null) {
        if (!Array.isArray(tx.AuthAccounts)) throw new $aMl9I.ValidationError(`AMMBid: AuthAccounts must be an AuthAccount array`);
        if (tx.AuthAccounts.length > $03ef7f2445edaaba$var$MAX_AUTH_ACCOUNTS) throw new $aMl9I.ValidationError(`AMMBid: AuthAccounts length must not be greater than ${$03ef7f2445edaaba$var$MAX_AUTH_ACCOUNTS}`);
        $03ef7f2445edaaba$var$validateAuthAccounts(tx.Account, tx.AuthAccounts);
    }
}
module.exports.validateAMMBid = $03ef7f2445edaaba$var$validateAMMBid;
function $03ef7f2445edaaba$var$validateAuthAccounts(senderAddress, authAccounts) {
    for (const authAccount of authAccounts){
        if (authAccount.AuthAccount == null || typeof authAccount.AuthAccount !== 'object') throw new $aMl9I.ValidationError(`AMMBid: invalid AuthAccounts`);
        if (authAccount.AuthAccount.Account == null) throw new $aMl9I.ValidationError(`AMMBid: invalid AuthAccounts`);
        if (typeof authAccount.AuthAccount.Account !== 'string') throw new $aMl9I.ValidationError(`AMMBid: invalid AuthAccounts`);
        if (authAccount.AuthAccount.Account === senderAddress) throw new $aMl9I.ValidationError(`AMMBid: AuthAccounts must not include sender's address`);
    }
    return true;
}

});

parcelRegister("iBXiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMCreate = module.exports.AMM_MAX_TRADING_FEE = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
module.exports.AMM_MAX_TRADING_FEE = 1000;
function $d8c9af3797173824$var$validateAMMCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Amount == null) throw new $aMl9I.ValidationError('AMMCreate: missing field Amount');
    if (!(0, $aDIrf.isAmount)(tx.Amount)) throw new $aMl9I.ValidationError('AMMCreate: Amount must be an Amount');
    if (tx.Amount2 == null) throw new $aMl9I.ValidationError('AMMCreate: missing field Amount2');
    if (!(0, $aDIrf.isAmount)(tx.Amount2)) throw new $aMl9I.ValidationError('AMMCreate: Amount2 must be an Amount');
    if (tx.TradingFee == null) throw new $aMl9I.ValidationError('AMMCreate: missing field TradingFee');
    if (typeof tx.TradingFee !== 'number') throw new $aMl9I.ValidationError('AMMCreate: TradingFee must be a number');
    if (tx.TradingFee < 0 || tx.TradingFee > module.exports.AMM_MAX_TRADING_FEE) throw new $aMl9I.ValidationError(`AMMCreate: TradingFee must be between 0 and ${module.exports.AMM_MAX_TRADING_FEE}`);
}
module.exports.validateAMMCreate = $d8c9af3797173824$var$validateAMMCreate;

});

parcelRegister("jqgXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMDelete = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $e23d9b22e4e23576$var$validateAMMDelete(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Asset == null) throw new $aMl9I.ValidationError('AMMDelete: missing field Asset');
    if (!(0, $aDIrf.isCurrency)(tx.Asset)) throw new $aMl9I.ValidationError('AMMDelete: Asset must be a Currency');
    if (tx.Asset2 == null) throw new $aMl9I.ValidationError('AMMDelete: missing field Asset2');
    if (!(0, $aDIrf.isCurrency)(tx.Asset2)) throw new $aMl9I.ValidationError('AMMDelete: Asset2 must be a Currency');
}
module.exports.validateAMMDelete = $e23d9b22e4e23576$var$validateAMMDelete;

});

parcelRegister("1uhI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAMMVote = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $iBXiU = parcelRequire("iBXiU");

var $aDIrf = parcelRequire("aDIrf");
function $115654daf0f554c9$var$validateAMMVote(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Asset == null) throw new $aMl9I.ValidationError('AMMVote: missing field Asset');
    if (!(0, $aDIrf.isCurrency)(tx.Asset)) throw new $aMl9I.ValidationError('AMMVote: Asset must be a Currency');
    if (tx.Asset2 == null) throw new $aMl9I.ValidationError('AMMVote: missing field Asset2');
    if (!(0, $aDIrf.isCurrency)(tx.Asset2)) throw new $aMl9I.ValidationError('AMMVote: Asset2 must be a Currency');
    if (tx.TradingFee == null) throw new $aMl9I.ValidationError('AMMVote: missing field TradingFee');
    if (typeof tx.TradingFee !== 'number') throw new $aMl9I.ValidationError('AMMVote: TradingFee must be a number');
    if (tx.TradingFee < 0 || tx.TradingFee > $iBXiU.AMM_MAX_TRADING_FEE) throw new $aMl9I.ValidationError(`AMMVote: TradingFee must be between 0 and ${$iBXiU.AMM_MAX_TRADING_FEE}`);
}
module.exports.validateAMMVote = $115654daf0f554c9$var$validateAMMVote;

});

parcelRegister("2ib7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateCheckCancel = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $1ab5e48a91e1514c$var$validateCheckCancel(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.CheckID !== undefined && typeof tx.CheckID !== 'string') throw new $aMl9I.ValidationError('CheckCancel: invalid CheckID');
}
module.exports.validateCheckCancel = $1ab5e48a91e1514c$var$validateCheckCancel;

});

parcelRegister("bUz9y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateCheckCash = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $8ac0315ca4a6f024$var$validateCheckCash(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Amount == null && tx.DeliverMin == null) throw new $aMl9I.ValidationError('CheckCash: must have either Amount or DeliverMin');
    if (tx.Amount != null && tx.DeliverMin != null) throw new $aMl9I.ValidationError('CheckCash: cannot have both Amount and DeliverMin');
    if (tx.Amount != null && tx.Amount !== undefined && !(0, $aDIrf.isAmount)(tx.Amount)) throw new $aMl9I.ValidationError('CheckCash: invalid Amount');
    if (tx.DeliverMin != null && tx.DeliverMin !== undefined && !(0, $aDIrf.isAmount)(tx.DeliverMin)) throw new $aMl9I.ValidationError('CheckCash: invalid DeliverMin');
    if (tx.CheckID !== undefined && typeof tx.CheckID !== 'string') throw new $aMl9I.ValidationError('CheckCash: invalid CheckID');
}
module.exports.validateCheckCash = $8ac0315ca4a6f024$var$validateCheckCash;

});

parcelRegister("8UCN8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateCheckCreate = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $67d1a4dd33ef5f20$var$validateCheckCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.SendMax === undefined) throw new $aMl9I.ValidationError('CheckCreate: missing field SendMax');
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'DestinationTag', $aDIrf.isNumber);
    if (typeof tx.SendMax !== 'string' && !(0, $aDIrf.isIssuedCurrency)(tx.SendMax)) throw new $aMl9I.ValidationError('CheckCreate: invalid SendMax');
    if (tx.Expiration !== undefined && typeof tx.Expiration !== 'number') throw new $aMl9I.ValidationError('CheckCreate: invalid Expiration');
    if (tx.InvoiceID !== undefined && typeof tx.InvoiceID !== 'string') throw new $aMl9I.ValidationError('CheckCreate: invalid InvoiceID');
}
module.exports.validateCheckCreate = $67d1a4dd33ef5f20$var$validateCheckCreate;

});

parcelRegister("jhazx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateClawback = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $e087ce4bda189cd3$var$validateClawback(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'Holder', $aDIrf.isAccount);
    if (tx.Amount == null) throw new $aMl9I.ValidationError('Clawback: missing field Amount');
    if (!(0, $aDIrf.isIssuedCurrency)(tx.Amount) && !(0, $aDIrf.isMPTAmount)(tx.Amount)) throw new $aMl9I.ValidationError('Clawback: invalid Amount');
    if ((0, $aDIrf.isIssuedCurrency)(tx.Amount) && tx.Account === tx.Amount.issuer) throw new $aMl9I.ValidationError('Clawback: invalid holder Account');
    if ((0, $aDIrf.isMPTAmount)(tx.Amount) && tx.Account === tx.Holder) throw new $aMl9I.ValidationError('Clawback: invalid holder Account');
    if ((0, $aDIrf.isIssuedCurrency)(tx.Amount) && tx.Holder) throw new $aMl9I.ValidationError('Clawback: cannot have Holder for currency');
    if ((0, $aDIrf.isMPTAmount)(tx.Amount) && !tx.Holder) throw new $aMl9I.ValidationError('Clawback: missing Holder');
}
module.exports.validateClawback = $e087ce4bda189cd3$var$validateClawback;

});

parcelRegister("9ewia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateCredentialAccept = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $6b8e78617d5a4031$var$validateCredentialAccept(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Account', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'Issuer', $aDIrf.isString);
    (0, $aDIrf.validateCredentialType)(tx);
}
module.exports.validateCredentialAccept = $6b8e78617d5a4031$var$validateCredentialAccept;

});

parcelRegister("fx9Lv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateCredentialCreate = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
const $b4f18341b2d5c041$var$MAX_URI_LENGTH = 256;
function $b4f18341b2d5c041$var$validateCredentialCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Account', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'Subject', $aDIrf.isString);
    (0, $aDIrf.validateCredentialType)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'Expiration', $aDIrf.isNumber);
    $b4f18341b2d5c041$var$validateURI(tx.URI);
}
module.exports.validateCredentialCreate = $b4f18341b2d5c041$var$validateCredentialCreate;
function $b4f18341b2d5c041$var$validateURI(URI) {
    if (URI === undefined) return;
    if (typeof URI !== 'string') throw new $aMl9I.ValidationError('CredentialCreate: invalid field URI');
    if (URI.length === 0) throw new $aMl9I.ValidationError('CredentialCreate: URI cannot be an empty string');
    else if (URI.length > $b4f18341b2d5c041$var$MAX_URI_LENGTH) throw new $aMl9I.ValidationError(`CredentialCreate: URI length must be <= ${$b4f18341b2d5c041$var$MAX_URI_LENGTH}`);
    if (!$8wxDW.HEX_REGEX.test(URI)) throw new $aMl9I.ValidationError('CredentialCreate: URI must be encoded in hex');
}

});

parcelRegister("cTjYk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateCredentialDelete = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $962a1d1cd2d4af13$var$validateCredentialDelete(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (!tx.Subject && !tx.Issuer) throw new $aMl9I.ValidationError('CredentialDelete: either `Issuer` or `Subject` must be provided');
    (0, $aDIrf.validateRequiredField)(tx, 'Account', $aDIrf.isString);
    (0, $aDIrf.validateCredentialType)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'Subject', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'Issuer', $aDIrf.isString);
}
module.exports.validateCredentialDelete = $962a1d1cd2d4af13$var$validateCredentialDelete;

});

parcelRegister("lmhog", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDepositPreauth = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $f8c9246bbb274792$var$validateDepositPreauth(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    $f8c9246bbb274792$var$validateSingleAuthorizationFieldProvided(tx);
    if (tx.Authorize !== undefined) {
        if (typeof tx.Authorize !== 'string') throw new $aMl9I.ValidationError('DepositPreauth: Authorize must be a string');
        if (tx.Account === tx.Authorize) throw new $aMl9I.ValidationError("DepositPreauth: Account can't preauthorize its own address");
    } else if (tx.Unauthorize !== undefined) {
        if (typeof tx.Unauthorize !== 'string') throw new $aMl9I.ValidationError('DepositPreauth: Unauthorize must be a string');
        if (tx.Account === tx.Unauthorize) throw new $aMl9I.ValidationError("DepositPreauth: Account can't unauthorize its own address");
    } else if (tx.AuthorizeCredentials !== undefined) (0, $aDIrf.validateCredentialsList)(tx.AuthorizeCredentials, tx.TransactionType, false, $aDIrf.MAX_AUTHORIZED_CREDENTIALS);
    else if (tx.UnauthorizeCredentials !== undefined) (0, $aDIrf.validateCredentialsList)(tx.UnauthorizeCredentials, tx.TransactionType, false, $aDIrf.MAX_AUTHORIZED_CREDENTIALS);
}
module.exports.validateDepositPreauth = $f8c9246bbb274792$var$validateDepositPreauth;
function $f8c9246bbb274792$var$validateSingleAuthorizationFieldProvided(tx) {
    const fields = [
        'Authorize',
        'Unauthorize',
        'AuthorizeCredentials',
        'UnauthorizeCredentials'
    ];
    const countProvided = fields.filter((key)=>tx[key] !== undefined).length;
    if (countProvided !== 1) throw new $aMl9I.ValidationError('DepositPreauth: Requires exactly one field of the following: Authorize, Unauthorize, AuthorizeCredentials, UnauthorizeCredentials.');
}

});

parcelRegister("5hKQM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDIDDelete = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $3d92e1c6f5196073$var$validateDIDDelete(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
}
module.exports.validateDIDDelete = $3d92e1c6f5196073$var$validateDIDDelete;

});

parcelRegister("e6Pg3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDIDSet = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $a45962f61d0b1946$var$validateDIDSet(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'Data', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'DIDDocument', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'URI', $aDIrf.isString);
    if (tx.Data === undefined && tx.DIDDocument === undefined && tx.URI === undefined) throw new $aMl9I.ValidationError('DIDSet: Must have at least one of `Data`, `DIDDocument`, and `URI`');
}
module.exports.validateDIDSet = $a45962f61d0b1946$var$validateDIDSet;

});

parcelRegister("dcJa4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateEscrowCancel = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $027b16691910436b$var$validateEscrowCancel(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Owner', $aDIrf.isAccount);
    if (tx.OfferSequence == null) throw new $aMl9I.ValidationError('EscrowCancel: missing OfferSequence');
    if (typeof tx.OfferSequence !== 'number' && typeof tx.OfferSequence !== 'string' || Number.isNaN(Number(tx.OfferSequence))) throw new $aMl9I.ValidationError('EscrowCancel: OfferSequence must be a number');
}
module.exports.validateEscrowCancel = $027b16691910436b$var$validateEscrowCancel;

});

parcelRegister("lMRxp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateEscrowCreate = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $fdc79c263310354e$var$validateEscrowCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Amount === undefined) throw new $aMl9I.ValidationError('EscrowCreate: missing field Amount');
    if (typeof tx.Amount !== 'string') throw new $aMl9I.ValidationError('EscrowCreate: Amount must be a string');
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'DestinationTag', $aDIrf.isNumber);
    if (tx.CancelAfter === undefined && tx.FinishAfter === undefined) throw new $aMl9I.ValidationError('EscrowCreate: Either CancelAfter or FinishAfter must be specified');
    if (tx.FinishAfter === undefined && tx.Condition === undefined) throw new $aMl9I.ValidationError('EscrowCreate: Either Condition or FinishAfter must be specified');
    if (tx.CancelAfter !== undefined && typeof tx.CancelAfter !== 'number') throw new $aMl9I.ValidationError('EscrowCreate: CancelAfter must be a number');
    if (tx.FinishAfter !== undefined && typeof tx.FinishAfter !== 'number') throw new $aMl9I.ValidationError('EscrowCreate: FinishAfter must be a number');
    if (tx.Condition !== undefined && typeof tx.Condition !== 'string') throw new $aMl9I.ValidationError('EscrowCreate: Condition must be a string');
}
module.exports.validateEscrowCreate = $fdc79c263310354e$var$validateEscrowCreate;

});

parcelRegister("f0MwY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateEscrowFinish = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $aedc8051274d1acc$var$validateEscrowFinish(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Owner', $aDIrf.isAccount);
    (0, $aDIrf.validateCredentialsList)(tx.CredentialIDs, tx.TransactionType, true, $aDIrf.MAX_AUTHORIZED_CREDENTIALS);
    if (tx.OfferSequence == null) throw new $aMl9I.ValidationError('EscrowFinish: missing field OfferSequence');
    if (typeof tx.OfferSequence !== 'number' && typeof tx.OfferSequence !== 'string' || Number.isNaN(Number(tx.OfferSequence))) throw new $aMl9I.ValidationError('EscrowFinish: OfferSequence must be a number');
    if (tx.Condition !== undefined && typeof tx.Condition !== 'string') throw new $aMl9I.ValidationError('EscrowFinish: Condition must be a string');
    if (tx.Fulfillment !== undefined && typeof tx.Fulfillment !== 'string') throw new $aMl9I.ValidationError('EscrowFinish: Fulfillment must be a string');
}
module.exports.validateEscrowFinish = $aedc8051274d1acc$var$validateEscrowFinish;

});

parcelRegister("01y2c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateMPTokenIssuanceDestroy = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $004a7ea801af1123$var$validateMPTokenIssuanceDestroy(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'MPTokenIssuanceID', $aDIrf.isString);
}
module.exports.validateMPTokenIssuanceDestroy = $004a7ea801af1123$var$validateMPTokenIssuanceDestroy;

});

parcelRegister("4isQX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNFTokenAcceptOffer = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $320f397e9b695e79$var$validateNFTokenBrokerFee(tx) {
    const value = (0, $aDIrf.parseAmountValue)(tx.NFTokenBrokerFee);
    if (Number.isNaN(value)) throw new $aMl9I.ValidationError('NFTokenAcceptOffer: invalid NFTokenBrokerFee');
    if (value <= 0) throw new $aMl9I.ValidationError('NFTokenAcceptOffer: NFTokenBrokerFee must be greater than 0; omit if there is no fee');
    if (tx.NFTokenSellOffer == null || tx.NFTokenBuyOffer == null) throw new $aMl9I.ValidationError('NFTokenAcceptOffer: both NFTokenSellOffer and NFTokenBuyOffer must be set if using brokered mode');
}
function $320f397e9b695e79$var$validateNFTokenAcceptOffer(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.NFTokenBrokerFee != null) $320f397e9b695e79$var$validateNFTokenBrokerFee(tx);
    if (tx.NFTokenSellOffer == null && tx.NFTokenBuyOffer == null) throw new $aMl9I.ValidationError('NFTokenAcceptOffer: must set either NFTokenSellOffer or NFTokenBuyOffer');
}
module.exports.validateNFTokenAcceptOffer = $320f397e9b695e79$var$validateNFTokenAcceptOffer;

});

parcelRegister("3LNNg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNFTokenBurn = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $2bec62d86934b55c$var$validateNFTokenBurn(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'NFTokenID', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'Owner', $aDIrf.isAccount);
}
module.exports.validateNFTokenBurn = $2bec62d86934b55c$var$validateNFTokenBurn;

});

parcelRegister("4pxic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNFTokenCancelOffer = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $33635267f4a1fd42$var$validateNFTokenCancelOffer(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (!Array.isArray(tx.NFTokenOffers)) throw new $aMl9I.ValidationError('NFTokenCancelOffer: missing field NFTokenOffers');
    if (tx.NFTokenOffers.length < 1) throw new $aMl9I.ValidationError('NFTokenCancelOffer: empty field NFTokenOffers');
}
module.exports.validateNFTokenCancelOffer = $33635267f4a1fd42$var$validateNFTokenCancelOffer;

});

parcelRegister("7VmLp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNFTokenModify = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $33Rto = parcelRequire("33Rto");

var $aDIrf = parcelRequire("aDIrf");
function $5c4f83a9896d05ae$var$validateNFTokenModify(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'NFTokenID', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'Owner', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'URI', $aDIrf.isString);
    if (tx.URI !== undefined && typeof tx.URI === 'string') {
        if (tx.URI === '') throw new $aMl9I.ValidationError('NFTokenModify: URI must not be empty string');
        if (!(0, $33Rto.isHex)(tx.URI)) throw new $aMl9I.ValidationError('NFTokenModify: URI must be in hex format');
    }
}
module.exports.validateNFTokenModify = $5c4f83a9896d05ae$var$validateNFTokenModify;

});

parcelRegister("9yptt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateOfferCancel = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $6f4b0cb2b8b4d29c$var$validateOfferCancel(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.OfferSequence === undefined) throw new $aMl9I.ValidationError('OfferCancel: missing field OfferSequence');
    if (typeof tx.OfferSequence !== 'number') throw new $aMl9I.ValidationError('OfferCancel: OfferSequence must be a number');
}
module.exports.validateOfferCancel = $6f4b0cb2b8b4d29c$var$validateOfferCancel;

});

parcelRegister("leRZV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateOracleDelete = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $f764caa106706cec$var$validateOracleDelete(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'OracleDocumentID', $aDIrf.isNumber);
}
module.exports.validateOracleDelete = $f764caa106706cec$var$validateOracleDelete;

});

parcelRegister("8iw6o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateOracleSet = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
const $60a8e7ff279a5a28$var$PRICE_DATA_SERIES_MAX_LENGTH = 10;
const $60a8e7ff279a5a28$var$SCALE_MAX = 10;
function $60a8e7ff279a5a28$var$validateOracleSet(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'OracleDocumentID', $aDIrf.isNumber);
    (0, $aDIrf.validateRequiredField)(tx, 'LastUpdateTime', $aDIrf.isNumber);
    (0, $aDIrf.validateOptionalField)(tx, 'Provider', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'URI', $aDIrf.isString);
    (0, $aDIrf.validateOptionalField)(tx, 'AssetClass', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'PriceDataSeries', (value)=>{
        if (!Array.isArray(value)) throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must be an array');
        if (value.length > $60a8e7ff279a5a28$var$PRICE_DATA_SERIES_MAX_LENGTH) throw new $aMl9I.ValidationError(`OracleSet: PriceDataSeries must have at most ${$60a8e7ff279a5a28$var$PRICE_DATA_SERIES_MAX_LENGTH} PriceData objects`);
        for (const priceData of value){
            if (typeof priceData !== 'object') throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must be an array of objects');
            if (priceData.PriceData == null) throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must have a `PriceData` object');
            if (Object.keys(priceData).length !== 1) throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must only have a single PriceData object');
            if (typeof priceData.PriceData.BaseAsset !== 'string') throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must have a `BaseAsset` string');
            if (typeof priceData.PriceData.QuoteAsset !== 'string') throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must have a `QuoteAsset` string');
            if (priceData.PriceData.AssetPrice == null !== (priceData.PriceData.Scale == null)) throw new $aMl9I.ValidationError('OracleSet: PriceDataSeries must have both `AssetPrice` and `Scale` if any are present');
            if ('AssetPrice' in priceData.PriceData && !(0, $aDIrf.isNumber)(priceData.PriceData.AssetPrice)) throw new $aMl9I.ValidationError('OracleSet: invalid field AssetPrice');
            if ('Scale' in priceData.PriceData && !(0, $aDIrf.isNumber)(priceData.PriceData.Scale)) throw new $aMl9I.ValidationError('OracleSet: invalid field Scale');
            if (priceData.PriceData.Scale < 0 || priceData.PriceData.Scale > $60a8e7ff279a5a28$var$SCALE_MAX) throw new $aMl9I.ValidationError(`OracleSet: Scale must be in range 0-${$60a8e7ff279a5a28$var$SCALE_MAX}`);
        }
        return true;
    });
}
module.exports.validateOracleSet = $60a8e7ff279a5a28$var$validateOracleSet;

});

parcelRegister("bCTWh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePaymentChannelCreate = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $876ea2a1fb72d890$var$validatePaymentChannelCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Amount === undefined) throw new $aMl9I.ValidationError('PaymentChannelCreate: missing Amount');
    if (typeof tx.Amount !== 'string') throw new $aMl9I.ValidationError('PaymentChannelCreate: Amount must be a string');
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'DestinationTag', $aDIrf.isNumber);
    if (tx.SettleDelay === undefined) throw new $aMl9I.ValidationError('PaymentChannelCreate: missing SettleDelay');
    if (typeof tx.SettleDelay !== 'number') throw new $aMl9I.ValidationError('PaymentChannelCreate: SettleDelay must be a number');
    if (tx.PublicKey === undefined) throw new $aMl9I.ValidationError('PaymentChannelCreate: missing PublicKey');
    if (typeof tx.PublicKey !== 'string') throw new $aMl9I.ValidationError('PaymentChannelCreate: PublicKey must be a string');
    if (tx.CancelAfter !== undefined && typeof tx.CancelAfter !== 'number') throw new $aMl9I.ValidationError('PaymentChannelCreate: CancelAfter must be a number');
}
module.exports.validatePaymentChannelCreate = $876ea2a1fb72d890$var$validatePaymentChannelCreate;

});

parcelRegister("hCtW3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePaymentChannelFund = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $cd3d34ca91c55290$var$validatePaymentChannelFund(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.Channel === undefined) throw new $aMl9I.ValidationError('PaymentChannelFund: missing Channel');
    if (typeof tx.Channel !== 'string') throw new $aMl9I.ValidationError('PaymentChannelFund: Channel must be a string');
    if (tx.Amount === undefined) throw new $aMl9I.ValidationError('PaymentChannelFund: missing Amount');
    if (typeof tx.Amount !== 'string') throw new $aMl9I.ValidationError('PaymentChannelFund: Amount must be a string');
    if (tx.Expiration !== undefined && typeof tx.Expiration !== 'number') throw new $aMl9I.ValidationError('PaymentChannelFund: Expiration must be a number');
}
module.exports.validatePaymentChannelFund = $cd3d34ca91c55290$var$validatePaymentChannelFund;

});

parcelRegister("hqxhY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePermissionedDomainDelete = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $cafeafe202982d2e$var$validatePermissionedDomainDelete(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'DomainID', $aDIrf.isString);
}
module.exports.validatePermissionedDomainDelete = $cafeafe202982d2e$var$validatePermissionedDomainDelete;

});

parcelRegister("h2MPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePermissionedDomainSet = void 0;

var $aDIrf = parcelRequire("aDIrf");
const $c688812c80c3bade$var$MAX_ACCEPTED_CREDENTIALS = 10;
function $c688812c80c3bade$var$validatePermissionedDomainSet(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateOptionalField)(tx, 'DomainID', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'AcceptedCredentials', ()=>tx.AcceptedCredentials instanceof Array);
    (0, $aDIrf.validateCredentialsList)(tx.AcceptedCredentials, tx.TransactionType, false, $c688812c80c3bade$var$MAX_ACCEPTED_CREDENTIALS);
}
module.exports.validatePermissionedDomainSet = $c688812c80c3bade$var$validatePermissionedDomainSet;

});

parcelRegister("5vT3p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSetRegularKey = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
function $403a8d90e8fafa36$var$validateSetRegularKey(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.RegularKey !== undefined && typeof tx.RegularKey !== 'string') throw new $aMl9I.ValidationError('SetRegularKey: RegularKey must be a string');
}
module.exports.validateSetRegularKey = $403a8d90e8fafa36$var$validateSetRegularKey;

});

parcelRegister("2OWrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSignerListSet = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
const $20dd9688d382f4d9$var$MAX_SIGNERS = 32;
const $20dd9688d382f4d9$var$HEX_WALLET_LOCATOR_REGEX = /^[0-9A-Fa-f]{64}$/u;
function $20dd9688d382f4d9$var$validateSignerListSet(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    if (tx.SignerQuorum === undefined) throw new $aMl9I.ValidationError('SignerListSet: missing field SignerQuorum');
    if (typeof tx.SignerQuorum !== 'number') throw new $aMl9I.ValidationError('SignerListSet: invalid SignerQuorum');
    if (tx.SignerQuorum === 0) return;
    if (tx.SignerEntries === undefined) throw new $aMl9I.ValidationError('SignerListSet: missing field SignerEntries');
    if (!Array.isArray(tx.SignerEntries)) throw new $aMl9I.ValidationError('SignerListSet: invalid SignerEntries');
    if (tx.SignerEntries.length === 0) throw new $aMl9I.ValidationError('SignerListSet: need at least 1 member in SignerEntries');
    if (tx.SignerEntries.length > $20dd9688d382f4d9$var$MAX_SIGNERS) throw new $aMl9I.ValidationError(`SignerListSet: maximum of ${$20dd9688d382f4d9$var$MAX_SIGNERS} members allowed in SignerEntries`);
    for (const entry of tx.SignerEntries){
        const signerEntry = entry;
        const { WalletLocator: WalletLocator } = signerEntry.SignerEntry;
        if (WalletLocator !== undefined && !$20dd9688d382f4d9$var$HEX_WALLET_LOCATOR_REGEX.test(WalletLocator)) throw new $aMl9I.ValidationError(`SignerListSet: WalletLocator in SignerEntry must be a 256-bit (32-byte) hexadecimal value`);
    }
}
module.exports.validateSignerListSet = $20dd9688d382f4d9$var$validateSignerListSet;

});

parcelRegister("jFPml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTicketCreate = void 0;

var $aMl9I = parcelRequire("aMl9I");

var $aDIrf = parcelRequire("aDIrf");
const $e529af8ab6cd938c$var$MAX_TICKETS = 250;
function $e529af8ab6cd938c$var$validateTicketCreate(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    const { TicketCount: TicketCount } = tx;
    if (TicketCount === undefined) throw new $aMl9I.ValidationError('TicketCreate: missing field TicketCount');
    if (typeof TicketCount !== 'number') throw new $aMl9I.ValidationError('TicketCreate: TicketCount must be a number');
    if (!Number.isInteger(TicketCount) || TicketCount < 1 || TicketCount > $e529af8ab6cd938c$var$MAX_TICKETS) throw new $aMl9I.ValidationError('TicketCreate: TicketCount must be an integer from 1 to 250');
}
module.exports.validateTicketCreate = $e529af8ab6cd938c$var$validateTicketCreate;

});

parcelRegister("gAGff", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainAccountCreateCommit = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $c140c71519d446a1$var$validateXChainAccountCreateCommit(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateRequiredField)(tx, 'SignatureReward', $aDIrf.isAmount);
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'Amount', $aDIrf.isAmount);
}
module.exports.validateXChainAccountCreateCommit = $c140c71519d446a1$var$validateXChainAccountCreateCommit;

});

parcelRegister("kkPYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainAddAccountCreateAttestation = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $ecddfdea349544dd$var$validateXChainAddAccountCreateAttestation(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Amount', $aDIrf.isAmount);
    (0, $aDIrf.validateRequiredField)(tx, 'AttestationRewardAccount', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'AttestationSignerAccount', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'OtherChainSource', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'PublicKey', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'Signature', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'SignatureReward', $aDIrf.isAmount);
    (0, $aDIrf.validateRequiredField)(tx, 'WasLockingChainSend', (inp)=>inp === 0 || inp === 1);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainAccountCreateCount', (inp)=>(0, $aDIrf.isNumber)(inp) || (0, $aDIrf.isString)(inp));
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
}
module.exports.validateXChainAddAccountCreateAttestation = $ecddfdea349544dd$var$validateXChainAddAccountCreateAttestation;

});

parcelRegister("jiXHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainAddClaimAttestation = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $e0de0236fd645e95$var$validateXChainAddClaimAttestation(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'Amount', $aDIrf.isAmount);
    (0, $aDIrf.validateRequiredField)(tx, 'AttestationRewardAccount', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'AttestationSignerAccount', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'OtherChainSource', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'PublicKey', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'Signature', $aDIrf.isString);
    (0, $aDIrf.validateRequiredField)(tx, 'WasLockingChainSend', (inp)=>inp === 0 || inp === 1);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainClaimID', (inp)=>(0, $aDIrf.isNumber)(inp) || (0, $aDIrf.isString)(inp));
}
module.exports.validateXChainAddClaimAttestation = $e0de0236fd645e95$var$validateXChainAddClaimAttestation;

});

parcelRegister("kDLeH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainClaim = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $f06c1745265fe398$var$validateXChainClaim(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainClaimID', (inp)=>(0, $aDIrf.isNumber)(inp) || (0, $aDIrf.isString)(inp));
    (0, $aDIrf.validateRequiredField)(tx, 'Destination', $aDIrf.isAccount);
    (0, $aDIrf.validateOptionalField)(tx, 'DestinationTag', $aDIrf.isNumber);
    (0, $aDIrf.validateRequiredField)(tx, 'Amount', $aDIrf.isAmount);
}
module.exports.validateXChainClaim = $f06c1745265fe398$var$validateXChainClaim;

});

parcelRegister("fCKCW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainCommit = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $b5fe92ceac263e0a$var$validateXChainCommit(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainClaimID', (inp)=>(0, $aDIrf.isNumber)(inp) || (0, $aDIrf.isString)(inp));
    (0, $aDIrf.validateOptionalField)(tx, 'OtherChainDestination', $aDIrf.isAccount);
    (0, $aDIrf.validateRequiredField)(tx, 'Amount', $aDIrf.isAmount);
}
module.exports.validateXChainCommit = $b5fe92ceac263e0a$var$validateXChainCommit;

});

parcelRegister("cDhU5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainCreateBridge = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $932703d29c819aa8$var$validateXChainCreateBridge(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateRequiredField)(tx, 'SignatureReward', $aDIrf.isAmount);
    (0, $aDIrf.validateOptionalField)(tx, 'MinAccountCreateAmount', $aDIrf.isAmount);
}
module.exports.validateXChainCreateBridge = $932703d29c819aa8$var$validateXChainCreateBridge;

});

parcelRegister("64uqe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateXChainCreateClaimID = void 0;

var $aDIrf = parcelRequire("aDIrf");
function $46bab6fb47d12fdd$var$validateXChainCreateClaimID(tx) {
    (0, $aDIrf.validateBaseTransaction)(tx);
    (0, $aDIrf.validateRequiredField)(tx, 'XChainBridge', $aDIrf.isXChainBridge);
    (0, $aDIrf.validateRequiredField)(tx, 'SignatureReward', $aDIrf.isAmount);
    (0, $aDIrf.validateRequiredField)(tx, 'OtherChainSource', $aDIrf.isAccount);
}
module.exports.validateXChainCreateClaimID = $46bab6fb47d12fdd$var$validateXChainCreateClaimID;

});


parcelRegister("7myZC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnableAmendmentFlags = void 0;
var $55c5bb56626f6e2b$var$EnableAmendmentFlags;
(function(EnableAmendmentFlags) {
    EnableAmendmentFlags[EnableAmendmentFlags["tfGotMajority"] = 65536] = "tfGotMajority";
    EnableAmendmentFlags[EnableAmendmentFlags["tfLostMajority"] = 131072] = "tfLostMajority";
})($55c5bb56626f6e2b$var$EnableAmendmentFlags || (module.exports.EnableAmendmentFlags = $55c5bb56626f6e2b$var$EnableAmendmentFlags = {}));

});


parcelRegister("hlDCx", function(module, exports) {
"use strict";
var $ca1321ab822fe322$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keyToRFC1751Mnemonic = module.exports.rfc1751MnemonicToKey = void 0;

var $8wxDW = parcelRequire("8wxDW");

const $ca1321ab822fe322$var$rfc1751Words_json_1 = $ca1321ab822fe322$var$__importDefault((parcelRequire("2xO8v")));
const $ca1321ab822fe322$var$rfc1751WordList = $ca1321ab822fe322$var$rfc1751Words_json_1.default;
const $ca1321ab822fe322$var$BINARY = [
    '0000',
    '0001',
    '0010',
    '0011',
    '0100',
    '0101',
    '0110',
    '0111',
    '1000',
    '1001',
    '1010',
    '1011',
    '1100',
    '1101',
    '1110',
    '1111'
];
function $ca1321ab822fe322$var$keyToBinary(key) {
    let res = '';
    for (const num of key)res += $ca1321ab822fe322$var$BINARY[num >> 4] + $ca1321ab822fe322$var$BINARY[num & 0x0f];
    return res;
}
function $ca1321ab822fe322$var$extract(key, start, length) {
    const subKey = key.substring(start, start + length);
    let acc = 0;
    for(let index = 0; index < subKey.length; index++)acc = acc * 2 + subKey.charCodeAt(index) - 48;
    return acc;
}
function $ca1321ab822fe322$var$keyToRFC1751Mnemonic(hex_key) {
    const buf = (0, $8wxDW.hexToBytes)(hex_key.replace(/\s+/gu, ''));
    let key = $ca1321ab822fe322$var$bufferToArray($ca1321ab822fe322$var$swap128(buf));
    const padding = [];
    for(let index = 0; index < (8 - key.length % 8) % 8; index++)padding.push(0);
    key = padding.concat(key);
    const english = [];
    for(let index = 0; index < key.length; index += 8){
        const subKey = key.slice(index, index + 8);
        let skbin = $ca1321ab822fe322$var$keyToBinary(subKey);
        let parity = 0;
        for(let j = 0; j < 64; j += 2)parity += $ca1321ab822fe322$var$extract(skbin, j, 2);
        subKey.push(parity << 6 & 0xff);
        skbin = $ca1321ab822fe322$var$keyToBinary(subKey);
        for(let j = 0; j < 64; j += 11)english.push($ca1321ab822fe322$var$rfc1751WordList[$ca1321ab822fe322$var$extract(skbin, j, 11)]);
    }
    return english.join(' ');
}
module.exports.keyToRFC1751Mnemonic = $ca1321ab822fe322$var$keyToRFC1751Mnemonic;
function $ca1321ab822fe322$var$rfc1751MnemonicToKey(english) {
    const words = english.split(' ');
    let key = [];
    for(let index = 0; index < words.length; index += 6){
        const { subKey: subKey, word: word } = $ca1321ab822fe322$var$getSubKey(words, index);
        const skbin = $ca1321ab822fe322$var$keyToBinary(subKey);
        let parity = 0;
        for(let j = 0; j < 64; j += 2)parity += $ca1321ab822fe322$var$extract(skbin, j, 2);
        const cs0 = $ca1321ab822fe322$var$extract(skbin, 64, 2);
        const cs1 = parity & 3;
        if (cs0 !== cs1) throw new Error(`Parity error at ${word}`);
        key = key.concat(subKey.slice(0, 8));
    }
    const bufferKey = $ca1321ab822fe322$var$swap128(Uint8Array.from(key));
    return bufferKey;
}
module.exports.rfc1751MnemonicToKey = $ca1321ab822fe322$var$rfc1751MnemonicToKey;
function $ca1321ab822fe322$var$getSubKey(words, index) {
    const sublist = words.slice(index, index + 6);
    let bits = 0;
    const ch = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    let word = '';
    for (word of sublist){
        const idx = $ca1321ab822fe322$var$rfc1751WordList.indexOf(word.toUpperCase());
        if (idx === -1) throw new TypeError(`Expected an RFC1751 word, but received '${word}'. ` + `For the full list of words in the RFC1751 encoding see https://datatracker.ietf.org/doc/html/rfc1751`);
        const shift = (8 - (bits + 11) % 8) % 8;
        const y = idx << shift;
        const cl = y >> 16;
        const cc = y >> 8 & 0xff;
        const cr = y & 0xff;
        const t = Math.floor(bits / 8);
        if (shift > 5) {
            ch[t] |= cl;
            ch[t + 1] |= cc;
            ch[t + 2] |= cr;
        } else if (shift > -3) {
            ch[t] |= cc;
            ch[t + 1] |= cr;
        } else ch[t] |= cr;
        bits += 11;
    }
    const subKey = ch.slice();
    return {
        subKey: subKey,
        word: word
    };
}
function $ca1321ab822fe322$var$bufferToArray(buf) {
    return Array.prototype.slice.call(buf);
}
function $ca1321ab822fe322$var$swap(arr, n, m) {
    const i = arr[n];
    arr[n] = arr[m];
    arr[m] = i;
}
function $ca1321ab822fe322$var$swap64(arr) {
    const len = arr.length;
    for(let i = 0; i < len; i += 8){
        $ca1321ab822fe322$var$swap(arr, i, i + 7);
        $ca1321ab822fe322$var$swap(arr, i + 1, i + 6);
        $ca1321ab822fe322$var$swap(arr, i + 2, i + 5);
        $ca1321ab822fe322$var$swap(arr, i + 3, i + 4);
    }
    return arr;
}
function $ca1321ab822fe322$var$swap128(arr) {
    const reversedBytes = $ca1321ab822fe322$var$swap64(arr);
    return (0, $8wxDW.concat)([
        reversedBytes.slice(8, 16),
        reversedBytes.slice(0, 8)
    ]);
}

});
parcelRegister("2xO8v", function(module, exports) {
module.exports = JSON.parse("[\"A\",\"ABE\",\"ACE\",\"ACT\",\"AD\",\"ADA\",\"ADD\",\"AGO\",\"AID\",\"AIM\",\"AIR\",\"ALL\",\"ALP\",\"AM\",\"AMY\",\"AN\",\"ANA\",\"AND\",\"ANN\",\"ANT\",\"ANY\",\"APE\",\"APS\",\"APT\",\"ARC\",\"ARE\",\"ARK\",\"ARM\",\"ART\",\"AS\",\"ASH\",\"ASK\",\"AT\",\"ATE\",\"AUG\",\"AUK\",\"AVE\",\"AWE\",\"AWK\",\"AWL\",\"AWN\",\"AX\",\"AYE\",\"BAD\",\"BAG\",\"BAH\",\"BAM\",\"BAN\",\"BAR\",\"BAT\",\"BAY\",\"BE\",\"BED\",\"BEE\",\"BEG\",\"BEN\",\"BET\",\"BEY\",\"BIB\",\"BID\",\"BIG\",\"BIN\",\"BIT\",\"BOB\",\"BOG\",\"BON\",\"BOO\",\"BOP\",\"BOW\",\"BOY\",\"BUB\",\"BUD\",\"BUG\",\"BUM\",\"BUN\",\"BUS\",\"BUT\",\"BUY\",\"BY\",\"BYE\",\"CAB\",\"CAL\",\"CAM\",\"CAN\",\"CAP\",\"CAR\",\"CAT\",\"CAW\",\"COD\",\"COG\",\"COL\",\"CON\",\"COO\",\"COP\",\"COT\",\"COW\",\"COY\",\"CRY\",\"CUB\",\"CUE\",\"CUP\",\"CUR\",\"CUT\",\"DAB\",\"DAD\",\"DAM\",\"DAN\",\"DAR\",\"DAY\",\"DEE\",\"DEL\",\"DEN\",\"DES\",\"DEW\",\"DID\",\"DIE\",\"DIG\",\"DIN\",\"DIP\",\"DO\",\"DOE\",\"DOG\",\"DON\",\"DOT\",\"DOW\",\"DRY\",\"DUB\",\"DUD\",\"DUE\",\"DUG\",\"DUN\",\"EAR\",\"EAT\",\"ED\",\"EEL\",\"EGG\",\"EGO\",\"ELI\",\"ELK\",\"ELM\",\"ELY\",\"EM\",\"END\",\"EST\",\"ETC\",\"EVA\",\"EVE\",\"EWE\",\"EYE\",\"FAD\",\"FAN\",\"FAR\",\"FAT\",\"FAY\",\"FED\",\"FEE\",\"FEW\",\"FIB\",\"FIG\",\"FIN\",\"FIR\",\"FIT\",\"FLO\",\"FLY\",\"FOE\",\"FOG\",\"FOR\",\"FRY\",\"FUM\",\"FUN\",\"FUR\",\"GAB\",\"GAD\",\"GAG\",\"GAL\",\"GAM\",\"GAP\",\"GAS\",\"GAY\",\"GEE\",\"GEL\",\"GEM\",\"GET\",\"GIG\",\"GIL\",\"GIN\",\"GO\",\"GOT\",\"GUM\",\"GUN\",\"GUS\",\"GUT\",\"GUY\",\"GYM\",\"GYP\",\"HA\",\"HAD\",\"HAL\",\"HAM\",\"HAN\",\"HAP\",\"HAS\",\"HAT\",\"HAW\",\"HAY\",\"HE\",\"HEM\",\"HEN\",\"HER\",\"HEW\",\"HEY\",\"HI\",\"HID\",\"HIM\",\"HIP\",\"HIS\",\"HIT\",\"HO\",\"HOB\",\"HOC\",\"HOE\",\"HOG\",\"HOP\",\"HOT\",\"HOW\",\"HUB\",\"HUE\",\"HUG\",\"HUH\",\"HUM\",\"HUT\",\"I\",\"ICY\",\"IDA\",\"IF\",\"IKE\",\"ILL\",\"INK\",\"INN\",\"IO\",\"ION\",\"IQ\",\"IRA\",\"IRE\",\"IRK\",\"IS\",\"IT\",\"ITS\",\"IVY\",\"JAB\",\"JAG\",\"JAM\",\"JAN\",\"JAR\",\"JAW\",\"JAY\",\"JET\",\"JIG\",\"JIM\",\"JO\",\"JOB\",\"JOE\",\"JOG\",\"JOT\",\"JOY\",\"JUG\",\"JUT\",\"KAY\",\"KEG\",\"KEN\",\"KEY\",\"KID\",\"KIM\",\"KIN\",\"KIT\",\"LA\",\"LAB\",\"LAC\",\"LAD\",\"LAG\",\"LAM\",\"LAP\",\"LAW\",\"LAY\",\"LEA\",\"LED\",\"LEE\",\"LEG\",\"LEN\",\"LEO\",\"LET\",\"LEW\",\"LID\",\"LIE\",\"LIN\",\"LIP\",\"LIT\",\"LO\",\"LOB\",\"LOG\",\"LOP\",\"LOS\",\"LOT\",\"LOU\",\"LOW\",\"LOY\",\"LUG\",\"LYE\",\"MA\",\"MAC\",\"MAD\",\"MAE\",\"MAN\",\"MAO\",\"MAP\",\"MAT\",\"MAW\",\"MAY\",\"ME\",\"MEG\",\"MEL\",\"MEN\",\"MET\",\"MEW\",\"MID\",\"MIN\",\"MIT\",\"MOB\",\"MOD\",\"MOE\",\"MOO\",\"MOP\",\"MOS\",\"MOT\",\"MOW\",\"MUD\",\"MUG\",\"MUM\",\"MY\",\"NAB\",\"NAG\",\"NAN\",\"NAP\",\"NAT\",\"NAY\",\"NE\",\"NED\",\"NEE\",\"NET\",\"NEW\",\"NIB\",\"NIL\",\"NIP\",\"NIT\",\"NO\",\"NOB\",\"NOD\",\"NON\",\"NOR\",\"NOT\",\"NOV\",\"NOW\",\"NU\",\"NUN\",\"NUT\",\"O\",\"OAF\",\"OAK\",\"OAR\",\"OAT\",\"ODD\",\"ODE\",\"OF\",\"OFF\",\"OFT\",\"OH\",\"OIL\",\"OK\",\"OLD\",\"ON\",\"ONE\",\"OR\",\"ORB\",\"ORE\",\"ORR\",\"OS\",\"OTT\",\"OUR\",\"OUT\",\"OVA\",\"OW\",\"OWE\",\"OWL\",\"OWN\",\"OX\",\"PA\",\"PAD\",\"PAL\",\"PAM\",\"PAN\",\"PAP\",\"PAR\",\"PAT\",\"PAW\",\"PAY\",\"PEA\",\"PEG\",\"PEN\",\"PEP\",\"PER\",\"PET\",\"PEW\",\"PHI\",\"PI\",\"PIE\",\"PIN\",\"PIT\",\"PLY\",\"PO\",\"POD\",\"POE\",\"POP\",\"POT\",\"POW\",\"PRO\",\"PRY\",\"PUB\",\"PUG\",\"PUN\",\"PUP\",\"PUT\",\"QUO\",\"RAG\",\"RAM\",\"RAN\",\"RAP\",\"RAT\",\"RAW\",\"RAY\",\"REB\",\"RED\",\"REP\",\"RET\",\"RIB\",\"RID\",\"RIG\",\"RIM\",\"RIO\",\"RIP\",\"ROB\",\"ROD\",\"ROE\",\"RON\",\"ROT\",\"ROW\",\"ROY\",\"RUB\",\"RUE\",\"RUG\",\"RUM\",\"RUN\",\"RYE\",\"SAC\",\"SAD\",\"SAG\",\"SAL\",\"SAM\",\"SAN\",\"SAP\",\"SAT\",\"SAW\",\"SAY\",\"SEA\",\"SEC\",\"SEE\",\"SEN\",\"SET\",\"SEW\",\"SHE\",\"SHY\",\"SIN\",\"SIP\",\"SIR\",\"SIS\",\"SIT\",\"SKI\",\"SKY\",\"SLY\",\"SO\",\"SOB\",\"SOD\",\"SON\",\"SOP\",\"SOW\",\"SOY\",\"SPA\",\"SPY\",\"SUB\",\"SUD\",\"SUE\",\"SUM\",\"SUN\",\"SUP\",\"TAB\",\"TAD\",\"TAG\",\"TAN\",\"TAP\",\"TAR\",\"TEA\",\"TED\",\"TEE\",\"TEN\",\"THE\",\"THY\",\"TIC\",\"TIE\",\"TIM\",\"TIN\",\"TIP\",\"TO\",\"TOE\",\"TOG\",\"TOM\",\"TON\",\"TOO\",\"TOP\",\"TOW\",\"TOY\",\"TRY\",\"TUB\",\"TUG\",\"TUM\",\"TUN\",\"TWO\",\"UN\",\"UP\",\"US\",\"USE\",\"VAN\",\"VAT\",\"VET\",\"VIE\",\"WAD\",\"WAG\",\"WAR\",\"WAS\",\"WAY\",\"WE\",\"WEB\",\"WED\",\"WEE\",\"WET\",\"WHO\",\"WHY\",\"WIN\",\"WIT\",\"WOK\",\"WON\",\"WOO\",\"WOW\",\"WRY\",\"WU\",\"YAM\",\"YAP\",\"YAW\",\"YE\",\"YEA\",\"YES\",\"YET\",\"YOU\",\"ABED\",\"ABEL\",\"ABET\",\"ABLE\",\"ABUT\",\"ACHE\",\"ACID\",\"ACME\",\"ACRE\",\"ACTA\",\"ACTS\",\"ADAM\",\"ADDS\",\"ADEN\",\"AFAR\",\"AFRO\",\"AGEE\",\"AHEM\",\"AHOY\",\"AIDA\",\"AIDE\",\"AIDS\",\"AIRY\",\"AJAR\",\"AKIN\",\"ALAN\",\"ALEC\",\"ALGA\",\"ALIA\",\"ALLY\",\"ALMA\",\"ALOE\",\"ALSO\",\"ALTO\",\"ALUM\",\"ALVA\",\"AMEN\",\"AMES\",\"AMID\",\"AMMO\",\"AMOK\",\"AMOS\",\"AMRA\",\"ANDY\",\"ANEW\",\"ANNA\",\"ANNE\",\"ANTE\",\"ANTI\",\"AQUA\",\"ARAB\",\"ARCH\",\"AREA\",\"ARGO\",\"ARID\",\"ARMY\",\"ARTS\",\"ARTY\",\"ASIA\",\"ASKS\",\"ATOM\",\"AUNT\",\"AURA\",\"AUTO\",\"AVER\",\"AVID\",\"AVIS\",\"AVON\",\"AVOW\",\"AWAY\",\"AWRY\",\"BABE\",\"BABY\",\"BACH\",\"BACK\",\"BADE\",\"BAIL\",\"BAIT\",\"BAKE\",\"BALD\",\"BALE\",\"BALI\",\"BALK\",\"BALL\",\"BALM\",\"BAND\",\"BANE\",\"BANG\",\"BANK\",\"BARB\",\"BARD\",\"BARE\",\"BARK\",\"BARN\",\"BARR\",\"BASE\",\"BASH\",\"BASK\",\"BASS\",\"BATE\",\"BATH\",\"BAWD\",\"BAWL\",\"BEAD\",\"BEAK\",\"BEAM\",\"BEAN\",\"BEAR\",\"BEAT\",\"BEAU\",\"BECK\",\"BEEF\",\"BEEN\",\"BEER\",\"BEET\",\"BELA\",\"BELL\",\"BELT\",\"BEND\",\"BENT\",\"BERG\",\"BERN\",\"BERT\",\"BESS\",\"BEST\",\"BETA\",\"BETH\",\"BHOY\",\"BIAS\",\"BIDE\",\"BIEN\",\"BILE\",\"BILK\",\"BILL\",\"BIND\",\"BING\",\"BIRD\",\"BITE\",\"BITS\",\"BLAB\",\"BLAT\",\"BLED\",\"BLEW\",\"BLOB\",\"BLOC\",\"BLOT\",\"BLOW\",\"BLUE\",\"BLUM\",\"BLUR\",\"BOAR\",\"BOAT\",\"BOCA\",\"BOCK\",\"BODE\",\"BODY\",\"BOGY\",\"BOHR\",\"BOIL\",\"BOLD\",\"BOLO\",\"BOLT\",\"BOMB\",\"BONA\",\"BOND\",\"BONE\",\"BONG\",\"BONN\",\"BONY\",\"BOOK\",\"BOOM\",\"BOON\",\"BOOT\",\"BORE\",\"BORG\",\"BORN\",\"BOSE\",\"BOSS\",\"BOTH\",\"BOUT\",\"BOWL\",\"BOYD\",\"BRAD\",\"BRAE\",\"BRAG\",\"BRAN\",\"BRAY\",\"BRED\",\"BREW\",\"BRIG\",\"BRIM\",\"BROW\",\"BUCK\",\"BUDD\",\"BUFF\",\"BULB\",\"BULK\",\"BULL\",\"BUNK\",\"BUNT\",\"BUOY\",\"BURG\",\"BURL\",\"BURN\",\"BURR\",\"BURT\",\"BURY\",\"BUSH\",\"BUSS\",\"BUST\",\"BUSY\",\"BYTE\",\"CADY\",\"CAFE\",\"CAGE\",\"CAIN\",\"CAKE\",\"CALF\",\"CALL\",\"CALM\",\"CAME\",\"CANE\",\"CANT\",\"CARD\",\"CARE\",\"CARL\",\"CARR\",\"CART\",\"CASE\",\"CASH\",\"CASK\",\"CAST\",\"CAVE\",\"CEIL\",\"CELL\",\"CENT\",\"CERN\",\"CHAD\",\"CHAR\",\"CHAT\",\"CHAW\",\"CHEF\",\"CHEN\",\"CHEW\",\"CHIC\",\"CHIN\",\"CHOU\",\"CHOW\",\"CHUB\",\"CHUG\",\"CHUM\",\"CITE\",\"CITY\",\"CLAD\",\"CLAM\",\"CLAN\",\"CLAW\",\"CLAY\",\"CLOD\",\"CLOG\",\"CLOT\",\"CLUB\",\"CLUE\",\"COAL\",\"COAT\",\"COCA\",\"COCK\",\"COCO\",\"CODA\",\"CODE\",\"CODY\",\"COED\",\"COIL\",\"COIN\",\"COKE\",\"COLA\",\"COLD\",\"COLT\",\"COMA\",\"COMB\",\"COME\",\"COOK\",\"COOL\",\"COON\",\"COOT\",\"CORD\",\"CORE\",\"CORK\",\"CORN\",\"COST\",\"COVE\",\"COWL\",\"CRAB\",\"CRAG\",\"CRAM\",\"CRAY\",\"CREW\",\"CRIB\",\"CROW\",\"CRUD\",\"CUBA\",\"CUBE\",\"CUFF\",\"CULL\",\"CULT\",\"CUNY\",\"CURB\",\"CURD\",\"CURE\",\"CURL\",\"CURT\",\"CUTS\",\"DADE\",\"DALE\",\"DAME\",\"DANA\",\"DANE\",\"DANG\",\"DANK\",\"DARE\",\"DARK\",\"DARN\",\"DART\",\"DASH\",\"DATA\",\"DATE\",\"DAVE\",\"DAVY\",\"DAWN\",\"DAYS\",\"DEAD\",\"DEAF\",\"DEAL\",\"DEAN\",\"DEAR\",\"DEBT\",\"DECK\",\"DEED\",\"DEEM\",\"DEER\",\"DEFT\",\"DEFY\",\"DELL\",\"DENT\",\"DENY\",\"DESK\",\"DIAL\",\"DICE\",\"DIED\",\"DIET\",\"DIME\",\"DINE\",\"DING\",\"DINT\",\"DIRE\",\"DIRT\",\"DISC\",\"DISH\",\"DISK\",\"DIVE\",\"DOCK\",\"DOES\",\"DOLE\",\"DOLL\",\"DOLT\",\"DOME\",\"DONE\",\"DOOM\",\"DOOR\",\"DORA\",\"DOSE\",\"DOTE\",\"DOUG\",\"DOUR\",\"DOVE\",\"DOWN\",\"DRAB\",\"DRAG\",\"DRAM\",\"DRAW\",\"DREW\",\"DRUB\",\"DRUG\",\"DRUM\",\"DUAL\",\"DUCK\",\"DUCT\",\"DUEL\",\"DUET\",\"DUKE\",\"DULL\",\"DUMB\",\"DUNE\",\"DUNK\",\"DUSK\",\"DUST\",\"DUTY\",\"EACH\",\"EARL\",\"EARN\",\"EASE\",\"EAST\",\"EASY\",\"EBEN\",\"ECHO\",\"EDDY\",\"EDEN\",\"EDGE\",\"EDGY\",\"EDIT\",\"EDNA\",\"EGAN\",\"ELAN\",\"ELBA\",\"ELLA\",\"ELSE\",\"EMIL\",\"EMIT\",\"EMMA\",\"ENDS\",\"ERIC\",\"EROS\",\"EVEN\",\"EVER\",\"EVIL\",\"EYED\",\"FACE\",\"FACT\",\"FADE\",\"FAIL\",\"FAIN\",\"FAIR\",\"FAKE\",\"FALL\",\"FAME\",\"FANG\",\"FARM\",\"FAST\",\"FATE\",\"FAWN\",\"FEAR\",\"FEAT\",\"FEED\",\"FEEL\",\"FEET\",\"FELL\",\"FELT\",\"FEND\",\"FERN\",\"FEST\",\"FEUD\",\"FIEF\",\"FIGS\",\"FILE\",\"FILL\",\"FILM\",\"FIND\",\"FINE\",\"FINK\",\"FIRE\",\"FIRM\",\"FISH\",\"FISK\",\"FIST\",\"FITS\",\"FIVE\",\"FLAG\",\"FLAK\",\"FLAM\",\"FLAT\",\"FLAW\",\"FLEA\",\"FLED\",\"FLEW\",\"FLIT\",\"FLOC\",\"FLOG\",\"FLOW\",\"FLUB\",\"FLUE\",\"FOAL\",\"FOAM\",\"FOGY\",\"FOIL\",\"FOLD\",\"FOLK\",\"FOND\",\"FONT\",\"FOOD\",\"FOOL\",\"FOOT\",\"FORD\",\"FORE\",\"FORK\",\"FORM\",\"FORT\",\"FOSS\",\"FOUL\",\"FOUR\",\"FOWL\",\"FRAU\",\"FRAY\",\"FRED\",\"FREE\",\"FRET\",\"FREY\",\"FROG\",\"FROM\",\"FUEL\",\"FULL\",\"FUME\",\"FUND\",\"FUNK\",\"FURY\",\"FUSE\",\"FUSS\",\"GAFF\",\"GAGE\",\"GAIL\",\"GAIN\",\"GAIT\",\"GALA\",\"GALE\",\"GALL\",\"GALT\",\"GAME\",\"GANG\",\"GARB\",\"GARY\",\"GASH\",\"GATE\",\"GAUL\",\"GAUR\",\"GAVE\",\"GAWK\",\"GEAR\",\"GELD\",\"GENE\",\"GENT\",\"GERM\",\"GETS\",\"GIBE\",\"GIFT\",\"GILD\",\"GILL\",\"GILT\",\"GINA\",\"GIRD\",\"GIRL\",\"GIST\",\"GIVE\",\"GLAD\",\"GLEE\",\"GLEN\",\"GLIB\",\"GLOB\",\"GLOM\",\"GLOW\",\"GLUE\",\"GLUM\",\"GLUT\",\"GOAD\",\"GOAL\",\"GOAT\",\"GOER\",\"GOES\",\"GOLD\",\"GOLF\",\"GONE\",\"GONG\",\"GOOD\",\"GOOF\",\"GORE\",\"GORY\",\"GOSH\",\"GOUT\",\"GOWN\",\"GRAB\",\"GRAD\",\"GRAY\",\"GREG\",\"GREW\",\"GREY\",\"GRID\",\"GRIM\",\"GRIN\",\"GRIT\",\"GROW\",\"GRUB\",\"GULF\",\"GULL\",\"GUNK\",\"GURU\",\"GUSH\",\"GUST\",\"GWEN\",\"GWYN\",\"HAAG\",\"HAAS\",\"HACK\",\"HAIL\",\"HAIR\",\"HALE\",\"HALF\",\"HALL\",\"HALO\",\"HALT\",\"HAND\",\"HANG\",\"HANK\",\"HANS\",\"HARD\",\"HARK\",\"HARM\",\"HART\",\"HASH\",\"HAST\",\"HATE\",\"HATH\",\"HAUL\",\"HAVE\",\"HAWK\",\"HAYS\",\"HEAD\",\"HEAL\",\"HEAR\",\"HEAT\",\"HEBE\",\"HECK\",\"HEED\",\"HEEL\",\"HEFT\",\"HELD\",\"HELL\",\"HELM\",\"HERB\",\"HERD\",\"HERE\",\"HERO\",\"HERS\",\"HESS\",\"HEWN\",\"HICK\",\"HIDE\",\"HIGH\",\"HIKE\",\"HILL\",\"HILT\",\"HIND\",\"HINT\",\"HIRE\",\"HISS\",\"HIVE\",\"HOBO\",\"HOCK\",\"HOFF\",\"HOLD\",\"HOLE\",\"HOLM\",\"HOLT\",\"HOME\",\"HONE\",\"HONK\",\"HOOD\",\"HOOF\",\"HOOK\",\"HOOT\",\"HORN\",\"HOSE\",\"HOST\",\"HOUR\",\"HOVE\",\"HOWE\",\"HOWL\",\"HOYT\",\"HUCK\",\"HUED\",\"HUFF\",\"HUGE\",\"HUGH\",\"HUGO\",\"HULK\",\"HULL\",\"HUNK\",\"HUNT\",\"HURD\",\"HURL\",\"HURT\",\"HUSH\",\"HYDE\",\"HYMN\",\"IBIS\",\"ICON\",\"IDEA\",\"IDLE\",\"IFFY\",\"INCA\",\"INCH\",\"INTO\",\"IONS\",\"IOTA\",\"IOWA\",\"IRIS\",\"IRMA\",\"IRON\",\"ISLE\",\"ITCH\",\"ITEM\",\"IVAN\",\"JACK\",\"JADE\",\"JAIL\",\"JAKE\",\"JANE\",\"JAVA\",\"JEAN\",\"JEFF\",\"JERK\",\"JESS\",\"JEST\",\"JIBE\",\"JILL\",\"JILT\",\"JIVE\",\"JOAN\",\"JOBS\",\"JOCK\",\"JOEL\",\"JOEY\",\"JOHN\",\"JOIN\",\"JOKE\",\"JOLT\",\"JOVE\",\"JUDD\",\"JUDE\",\"JUDO\",\"JUDY\",\"JUJU\",\"JUKE\",\"JULY\",\"JUNE\",\"JUNK\",\"JUNO\",\"JURY\",\"JUST\",\"JUTE\",\"KAHN\",\"KALE\",\"KANE\",\"KANT\",\"KARL\",\"KATE\",\"KEEL\",\"KEEN\",\"KENO\",\"KENT\",\"KERN\",\"KERR\",\"KEYS\",\"KICK\",\"KILL\",\"KIND\",\"KING\",\"KIRK\",\"KISS\",\"KITE\",\"KLAN\",\"KNEE\",\"KNEW\",\"KNIT\",\"KNOB\",\"KNOT\",\"KNOW\",\"KOCH\",\"KONG\",\"KUDO\",\"KURD\",\"KURT\",\"KYLE\",\"LACE\",\"LACK\",\"LACY\",\"LADY\",\"LAID\",\"LAIN\",\"LAIR\",\"LAKE\",\"LAMB\",\"LAME\",\"LAND\",\"LANE\",\"LANG\",\"LARD\",\"LARK\",\"LASS\",\"LAST\",\"LATE\",\"LAUD\",\"LAVA\",\"LAWN\",\"LAWS\",\"LAYS\",\"LEAD\",\"LEAF\",\"LEAK\",\"LEAN\",\"LEAR\",\"LEEK\",\"LEER\",\"LEFT\",\"LEND\",\"LENS\",\"LENT\",\"LEON\",\"LESK\",\"LESS\",\"LEST\",\"LETS\",\"LIAR\",\"LICE\",\"LICK\",\"LIED\",\"LIEN\",\"LIES\",\"LIEU\",\"LIFE\",\"LIFT\",\"LIKE\",\"LILA\",\"LILT\",\"LILY\",\"LIMA\",\"LIMB\",\"LIME\",\"LIND\",\"LINE\",\"LINK\",\"LINT\",\"LION\",\"LISA\",\"LIST\",\"LIVE\",\"LOAD\",\"LOAF\",\"LOAM\",\"LOAN\",\"LOCK\",\"LOFT\",\"LOGE\",\"LOIS\",\"LOLA\",\"LONE\",\"LONG\",\"LOOK\",\"LOON\",\"LOOT\",\"LORD\",\"LORE\",\"LOSE\",\"LOSS\",\"LOST\",\"LOUD\",\"LOVE\",\"LOWE\",\"LUCK\",\"LUCY\",\"LUGE\",\"LUKE\",\"LULU\",\"LUND\",\"LUNG\",\"LURA\",\"LURE\",\"LURK\",\"LUSH\",\"LUST\",\"LYLE\",\"LYNN\",\"LYON\",\"LYRA\",\"MACE\",\"MADE\",\"MAGI\",\"MAID\",\"MAIL\",\"MAIN\",\"MAKE\",\"MALE\",\"MALI\",\"MALL\",\"MALT\",\"MANA\",\"MANN\",\"MANY\",\"MARC\",\"MARE\",\"MARK\",\"MARS\",\"MART\",\"MARY\",\"MASH\",\"MASK\",\"MASS\",\"MAST\",\"MATE\",\"MATH\",\"MAUL\",\"MAYO\",\"MEAD\",\"MEAL\",\"MEAN\",\"MEAT\",\"MEEK\",\"MEET\",\"MELD\",\"MELT\",\"MEMO\",\"MEND\",\"MENU\",\"MERT\",\"MESH\",\"MESS\",\"MICE\",\"MIKE\",\"MILD\",\"MILE\",\"MILK\",\"MILL\",\"MILT\",\"MIMI\",\"MIND\",\"MINE\",\"MINI\",\"MINK\",\"MINT\",\"MIRE\",\"MISS\",\"MIST\",\"MITE\",\"MITT\",\"MOAN\",\"MOAT\",\"MOCK\",\"MODE\",\"MOLD\",\"MOLE\",\"MOLL\",\"MOLT\",\"MONA\",\"MONK\",\"MONT\",\"MOOD\",\"MOON\",\"MOOR\",\"MOOT\",\"MORE\",\"MORN\",\"MORT\",\"MOSS\",\"MOST\",\"MOTH\",\"MOVE\",\"MUCH\",\"MUCK\",\"MUDD\",\"MUFF\",\"MULE\",\"MULL\",\"MURK\",\"MUSH\",\"MUST\",\"MUTE\",\"MUTT\",\"MYRA\",\"MYTH\",\"NAGY\",\"NAIL\",\"NAIR\",\"NAME\",\"NARY\",\"NASH\",\"NAVE\",\"NAVY\",\"NEAL\",\"NEAR\",\"NEAT\",\"NECK\",\"NEED\",\"NEIL\",\"NELL\",\"NEON\",\"NERO\",\"NESS\",\"NEST\",\"NEWS\",\"NEWT\",\"NIBS\",\"NICE\",\"NICK\",\"NILE\",\"NINA\",\"NINE\",\"NOAH\",\"NODE\",\"NOEL\",\"NOLL\",\"NONE\",\"NOOK\",\"NOON\",\"NORM\",\"NOSE\",\"NOTE\",\"NOUN\",\"NOVA\",\"NUDE\",\"NULL\",\"NUMB\",\"OATH\",\"OBEY\",\"OBOE\",\"ODIN\",\"OHIO\",\"OILY\",\"OINT\",\"OKAY\",\"OLAF\",\"OLDY\",\"OLGA\",\"OLIN\",\"OMAN\",\"OMEN\",\"OMIT\",\"ONCE\",\"ONES\",\"ONLY\",\"ONTO\",\"ONUS\",\"ORAL\",\"ORGY\",\"OSLO\",\"OTIS\",\"OTTO\",\"OUCH\",\"OUST\",\"OUTS\",\"OVAL\",\"OVEN\",\"OVER\",\"OWLY\",\"OWNS\",\"QUAD\",\"QUIT\",\"QUOD\",\"RACE\",\"RACK\",\"RACY\",\"RAFT\",\"RAGE\",\"RAID\",\"RAIL\",\"RAIN\",\"RAKE\",\"RANK\",\"RANT\",\"RARE\",\"RASH\",\"RATE\",\"RAVE\",\"RAYS\",\"READ\",\"REAL\",\"REAM\",\"REAR\",\"RECK\",\"REED\",\"REEF\",\"REEK\",\"REEL\",\"REID\",\"REIN\",\"RENA\",\"REND\",\"RENT\",\"REST\",\"RICE\",\"RICH\",\"RICK\",\"RIDE\",\"RIFT\",\"RILL\",\"RIME\",\"RING\",\"RINK\",\"RISE\",\"RISK\",\"RITE\",\"ROAD\",\"ROAM\",\"ROAR\",\"ROBE\",\"ROCK\",\"RODE\",\"ROIL\",\"ROLL\",\"ROME\",\"ROOD\",\"ROOF\",\"ROOK\",\"ROOM\",\"ROOT\",\"ROSA\",\"ROSE\",\"ROSS\",\"ROSY\",\"ROTH\",\"ROUT\",\"ROVE\",\"ROWE\",\"ROWS\",\"RUBE\",\"RUBY\",\"RUDE\",\"RUDY\",\"RUIN\",\"RULE\",\"RUNG\",\"RUNS\",\"RUNT\",\"RUSE\",\"RUSH\",\"RUSK\",\"RUSS\",\"RUST\",\"RUTH\",\"SACK\",\"SAFE\",\"SAGE\",\"SAID\",\"SAIL\",\"SALE\",\"SALK\",\"SALT\",\"SAME\",\"SAND\",\"SANE\",\"SANG\",\"SANK\",\"SARA\",\"SAUL\",\"SAVE\",\"SAYS\",\"SCAN\",\"SCAR\",\"SCAT\",\"SCOT\",\"SEAL\",\"SEAM\",\"SEAR\",\"SEAT\",\"SEED\",\"SEEK\",\"SEEM\",\"SEEN\",\"SEES\",\"SELF\",\"SELL\",\"SEND\",\"SENT\",\"SETS\",\"SEWN\",\"SHAG\",\"SHAM\",\"SHAW\",\"SHAY\",\"SHED\",\"SHIM\",\"SHIN\",\"SHOD\",\"SHOE\",\"SHOT\",\"SHOW\",\"SHUN\",\"SHUT\",\"SICK\",\"SIDE\",\"SIFT\",\"SIGH\",\"SIGN\",\"SILK\",\"SILL\",\"SILO\",\"SILT\",\"SINE\",\"SING\",\"SINK\",\"SIRE\",\"SITE\",\"SITS\",\"SITU\",\"SKAT\",\"SKEW\",\"SKID\",\"SKIM\",\"SKIN\",\"SKIT\",\"SLAB\",\"SLAM\",\"SLAT\",\"SLAY\",\"SLED\",\"SLEW\",\"SLID\",\"SLIM\",\"SLIT\",\"SLOB\",\"SLOG\",\"SLOT\",\"SLOW\",\"SLUG\",\"SLUM\",\"SLUR\",\"SMOG\",\"SMUG\",\"SNAG\",\"SNOB\",\"SNOW\",\"SNUB\",\"SNUG\",\"SOAK\",\"SOAR\",\"SOCK\",\"SODA\",\"SOFA\",\"SOFT\",\"SOIL\",\"SOLD\",\"SOME\",\"SONG\",\"SOON\",\"SOOT\",\"SORE\",\"SORT\",\"SOUL\",\"SOUR\",\"SOWN\",\"STAB\",\"STAG\",\"STAN\",\"STAR\",\"STAY\",\"STEM\",\"STEW\",\"STIR\",\"STOW\",\"STUB\",\"STUN\",\"SUCH\",\"SUDS\",\"SUIT\",\"SULK\",\"SUMS\",\"SUNG\",\"SUNK\",\"SURE\",\"SURF\",\"SWAB\",\"SWAG\",\"SWAM\",\"SWAN\",\"SWAT\",\"SWAY\",\"SWIM\",\"SWUM\",\"TACK\",\"TACT\",\"TAIL\",\"TAKE\",\"TALE\",\"TALK\",\"TALL\",\"TANK\",\"TASK\",\"TATE\",\"TAUT\",\"TEAL\",\"TEAM\",\"TEAR\",\"TECH\",\"TEEM\",\"TEEN\",\"TEET\",\"TELL\",\"TEND\",\"TENT\",\"TERM\",\"TERN\",\"TESS\",\"TEST\",\"THAN\",\"THAT\",\"THEE\",\"THEM\",\"THEN\",\"THEY\",\"THIN\",\"THIS\",\"THUD\",\"THUG\",\"TICK\",\"TIDE\",\"TIDY\",\"TIED\",\"TIER\",\"TILE\",\"TILL\",\"TILT\",\"TIME\",\"TINA\",\"TINE\",\"TINT\",\"TINY\",\"TIRE\",\"TOAD\",\"TOGO\",\"TOIL\",\"TOLD\",\"TOLL\",\"TONE\",\"TONG\",\"TONY\",\"TOOK\",\"TOOL\",\"TOOT\",\"TORE\",\"TORN\",\"TOTE\",\"TOUR\",\"TOUT\",\"TOWN\",\"TRAG\",\"TRAM\",\"TRAY\",\"TREE\",\"TREK\",\"TRIG\",\"TRIM\",\"TRIO\",\"TROD\",\"TROT\",\"TROY\",\"TRUE\",\"TUBA\",\"TUBE\",\"TUCK\",\"TUFT\",\"TUNA\",\"TUNE\",\"TUNG\",\"TURF\",\"TURN\",\"TUSK\",\"TWIG\",\"TWIN\",\"TWIT\",\"ULAN\",\"UNIT\",\"URGE\",\"USED\",\"USER\",\"USES\",\"UTAH\",\"VAIL\",\"VAIN\",\"VALE\",\"VARY\",\"VASE\",\"VAST\",\"VEAL\",\"VEDA\",\"VEIL\",\"VEIN\",\"VEND\",\"VENT\",\"VERB\",\"VERY\",\"VETO\",\"VICE\",\"VIEW\",\"VINE\",\"VISE\",\"VOID\",\"VOLT\",\"VOTE\",\"WACK\",\"WADE\",\"WAGE\",\"WAIL\",\"WAIT\",\"WAKE\",\"WALE\",\"WALK\",\"WALL\",\"WALT\",\"WAND\",\"WANE\",\"WANG\",\"WANT\",\"WARD\",\"WARM\",\"WARN\",\"WART\",\"WASH\",\"WAST\",\"WATS\",\"WATT\",\"WAVE\",\"WAVY\",\"WAYS\",\"WEAK\",\"WEAL\",\"WEAN\",\"WEAR\",\"WEED\",\"WEEK\",\"WEIR\",\"WELD\",\"WELL\",\"WELT\",\"WENT\",\"WERE\",\"WERT\",\"WEST\",\"WHAM\",\"WHAT\",\"WHEE\",\"WHEN\",\"WHET\",\"WHOA\",\"WHOM\",\"WICK\",\"WIFE\",\"WILD\",\"WILL\",\"WIND\",\"WINE\",\"WING\",\"WINK\",\"WINO\",\"WIRE\",\"WISE\",\"WISH\",\"WITH\",\"WOLF\",\"WONT\",\"WOOD\",\"WOOL\",\"WORD\",\"WORE\",\"WORK\",\"WORM\",\"WORN\",\"WOVE\",\"WRIT\",\"WYNN\",\"YALE\",\"YANG\",\"YANK\",\"YARD\",\"YARN\",\"YAWL\",\"YAWN\",\"YEAH\",\"YEAR\",\"YELL\",\"YOGA\",\"YOKE\"]");

});


parcelRegister("5VcT1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.multisign = module.exports.verifySignature = void 0;

var $8wxDW = parcelRequire("8wxDW");

var $hqAsy = parcelRequire("hqAsy");

var $7eC3g = parcelRequire("7eC3g");

var $eLMUD = parcelRequire("eLMUD");

var $cYPJw = parcelRequire("cYPJw");

var $aMl9I = parcelRequire("aMl9I");

var $64n0b = parcelRequire("64n0b");
function $44fc459c49eff460$var$multisign(transactions) {
    if (transactions.length === 0) throw new $aMl9I.ValidationError('There were 0 transactions to multisign');
    const decodedTransactions = transactions.map((txOrBlob)=>{
        return $44fc459c49eff460$var$getDecodedTransaction(txOrBlob);
    });
    decodedTransactions.forEach((tx)=>{
        (0, $64n0b.validate)(tx);
        if (tx.Signers == null || tx.Signers.length === 0) throw new $aMl9I.ValidationError("For multisigning all transactions must include a Signers field containing an array of signatures. You may have forgotten to pass the 'forMultisign' parameter when signing.");
        if (tx.SigningPubKey !== '') throw new $aMl9I.ValidationError('SigningPubKey must be an empty string for all transactions when multisigning.');
    });
    $44fc459c49eff460$var$validateTransactionEquivalence(decodedTransactions);
    return (0, $eLMUD.encode)($44fc459c49eff460$var$getTransactionWithAllSigners(decodedTransactions));
}
module.exports.multisign = $44fc459c49eff460$var$multisign;
function $44fc459c49eff460$var$verifySignature(tx, publicKey) {
    const decodedTx = $44fc459c49eff460$var$getDecodedTransaction(tx);
    let key = publicKey;
    if (typeof decodedTx.TxnSignature !== 'string' || !decodedTx.TxnSignature) throw new Error('Transaction is missing a signature, TxnSignature');
    if (!key) {
        if (typeof decodedTx.SigningPubKey !== 'string' || !decodedTx.SigningPubKey) throw new Error('Transaction is missing a public key, SigningPubKey');
        key = decodedTx.SigningPubKey;
    }
    return (0, $cYPJw.verify)((0, $eLMUD.encodeForSigning)(decodedTx), decodedTx.TxnSignature, key);
}
module.exports.verifySignature = $44fc459c49eff460$var$verifySignature;
function $44fc459c49eff460$var$validateTransactionEquivalence(transactions) {
    const exampleTransaction = JSON.stringify(Object.assign(Object.assign({}, transactions[0]), {
        Signers: null
    }));
    if (transactions.slice(1).some((tx)=>JSON.stringify(Object.assign(Object.assign({}, tx), {
            Signers: null
        })) !== exampleTransaction)) throw new $aMl9I.ValidationError('txJSON is not the same for all signedTransactions');
}
function $44fc459c49eff460$var$getTransactionWithAllSigners(transactions) {
    const sortedSigners = transactions.flatMap((tx)=>{
        var _a;
        return (_a = tx.Signers) !== null && _a !== void 0 ? _a : [];
    }).sort($44fc459c49eff460$var$compareSigners);
    return Object.assign(Object.assign({}, transactions[0]), {
        Signers: sortedSigners
    });
}
function $44fc459c49eff460$var$compareSigners(left, right) {
    return $44fc459c49eff460$var$addressToBigNumber(left.Signer.Account).comparedTo($44fc459c49eff460$var$addressToBigNumber(right.Signer.Account));
}
const $44fc459c49eff460$var$NUM_BITS_IN_HEX = 16;
function $44fc459c49eff460$var$addressToBigNumber(address) {
    const hex = (0, $8wxDW.bytesToHex)((0, $7eC3g.decodeAccountID)(address));
    return new $hqAsy.BigNumber(hex, $44fc459c49eff460$var$NUM_BITS_IN_HEX);
}
function $44fc459c49eff460$var$getDecodedTransaction(txOrBlob) {
    if (typeof txOrBlob === 'object') return (0, $eLMUD.decode)((0, $eLMUD.encode)(txOrBlob));
    return (0, $eLMUD.decode)(txOrBlob);
}

});


parcelRegister("iQnSA", function(module, exports) {
"use strict";
var $db7f9b42b667aec2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestFunding = module.exports.getStartingBalance = module.exports.generateWalletToFund = void 0;

var $7eC3g = parcelRequire("7eC3g");

var $aMl9I = parcelRequire("aMl9I");

var $3C6kB = parcelRequire("3C6kB");

var $81kGK = parcelRequire("81kGK");
const $db7f9b42b667aec2$var$INTERVAL_SECONDS = 1;
const $db7f9b42b667aec2$var$MAX_ATTEMPTS = 20;
function $db7f9b42b667aec2$var$generateWalletToFund(wallet) {
    if (wallet && (0, $7eC3g.isValidClassicAddress)(wallet.classicAddress)) return wallet;
    return $81kGK.Wallet.generate();
}
module.exports.generateWalletToFund = $db7f9b42b667aec2$var$generateWalletToFund;
function $db7f9b42b667aec2$var$getStartingBalance(client, classicAddress) {
    return $db7f9b42b667aec2$var$__awaiter(this, void 0, void 0, function*() {
        let startingBalance = 0;
        try {
            startingBalance = Number((yield client.getXrpBalance(classicAddress)));
        } catch (_a) {}
        return startingBalance;
    });
}
module.exports.getStartingBalance = $db7f9b42b667aec2$var$getStartingBalance;
function $db7f9b42b667aec2$var$requestFunding(options, client, startingBalance, walletToFund, postBody) {
    var _a, _b, _c;
    return $db7f9b42b667aec2$var$__awaiter(this, void 0, void 0, function*() {
        const hostname = (_a = options.faucetHost) !== null && _a !== void 0 ? _a : (0, $3C6kB.getFaucetHost)(client);
        if (!hostname) throw new $aMl9I.XRPLFaucetError('No faucet hostname could be derived');
        const pathname = (_b = options.faucetPath) !== null && _b !== void 0 ? _b : (0, $3C6kB.getDefaultFaucetPath)(hostname);
        const response = yield fetch(`https://${hostname}${pathname}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postBody)
        });
        const body = yield response.json();
        if (response.ok && ((_c = response.headers.get('Content-Type')) === null || _c === void 0 ? void 0 : _c.startsWith('application/json'))) {
            const classicAddress = body.account.classicAddress;
            return $db7f9b42b667aec2$var$processSuccessfulResponse(client, classicAddress, walletToFund, startingBalance);
        }
        return $db7f9b42b667aec2$var$processError(response, body);
    });
}
module.exports.requestFunding = $db7f9b42b667aec2$var$requestFunding;
function $db7f9b42b667aec2$var$processSuccessfulResponse(client, classicAddress, walletToFund, startingBalance) {
    return $db7f9b42b667aec2$var$__awaiter(this, void 0, void 0, function*() {
        if (!classicAddress) return Promise.reject(new $aMl9I.XRPLFaucetError(`The faucet account is undefined`));
        try {
            const updatedBalance = yield $db7f9b42b667aec2$var$getUpdatedBalance(client, classicAddress, startingBalance);
            if (updatedBalance > startingBalance) return {
                wallet: walletToFund,
                balance: updatedBalance
            };
            throw new $aMl9I.XRPLFaucetError(`Unable to fund address with faucet after waiting ${$db7f9b42b667aec2$var$INTERVAL_SECONDS * $db7f9b42b667aec2$var$MAX_ATTEMPTS} seconds`);
        } catch (err) {
            if (err instanceof Error) throw new $aMl9I.XRPLFaucetError(err.message);
            throw err;
        }
    });
}
function $db7f9b42b667aec2$var$processError(response, body) {
    return $db7f9b42b667aec2$var$__awaiter(this, void 0, void 0, function*() {
        return Promise.reject(new $aMl9I.XRPLFaucetError(`Request failed: ${JSON.stringify({
            body: body || {},
            contentType: response.headers.get('Content-Type'),
            statusCode: response.status
        })}`));
    });
}
function $db7f9b42b667aec2$var$getUpdatedBalance(client, address, originalBalance) {
    return $db7f9b42b667aec2$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            let attempts = $db7f9b42b667aec2$var$MAX_ATTEMPTS;
            const interval = setInterval(()=>$db7f9b42b667aec2$var$__awaiter(this, void 0, void 0, function*() {
                    if (attempts < 0) {
                        clearInterval(interval);
                        resolve(originalBalance);
                    } else attempts -= 1;
                    try {
                        let newBalance;
                        try {
                            newBalance = Number((yield client.getXrpBalance(address)));
                        } catch (_a) {}
                        if (newBalance > originalBalance) {
                            clearInterval(interval);
                            resolve(newBalance);
                        }
                    } catch (err) {
                        clearInterval(interval);
                        if (err instanceof Error) reject(new $aMl9I.XRPLFaucetError(`Unable to check if the address ${address} balance has increased. Error: ${err.message}`));
                        reject(err);
                    }
                }), $db7f9b42b667aec2$var$INTERVAL_SECONDS * 1000);
        });
    });
}

});
parcelRegister("3C6kB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultFaucetPath = module.exports.getFaucetHost = module.exports.FaucetNetworkPaths = module.exports.FaucetNetwork = void 0;

var $aMl9I = parcelRequire("aMl9I");
var $2a19d4f671a689d6$var$FaucetNetwork;
(function(FaucetNetwork) {
    FaucetNetwork["Testnet"] = "faucet.altnet.rippletest.net";
    FaucetNetwork["Devnet"] = "faucet.devnet.rippletest.net";
})($2a19d4f671a689d6$var$FaucetNetwork || (module.exports.FaucetNetwork = $2a19d4f671a689d6$var$FaucetNetwork = {}));
module.exports.FaucetNetworkPaths = {
    [$2a19d4f671a689d6$var$FaucetNetwork.Testnet]: '/accounts',
    [$2a19d4f671a689d6$var$FaucetNetwork.Devnet]: '/accounts'
};
function $2a19d4f671a689d6$var$getFaucetHost(client) {
    const connectionUrl = client.url;
    if (connectionUrl.includes('altnet') || connectionUrl.includes('testnet')) return $2a19d4f671a689d6$var$FaucetNetwork.Testnet;
    if (connectionUrl.includes('sidechain-net2')) throw new $aMl9I.XRPLFaucetError('Cannot fund an account on an issuing chain. Accounts must be created via the bridge.');
    if (connectionUrl.includes('devnet')) return $2a19d4f671a689d6$var$FaucetNetwork.Devnet;
    throw new $aMl9I.XRPLFaucetError('Faucet URL is not defined or inferrable.');
}
module.exports.getFaucetHost = $2a19d4f671a689d6$var$getFaucetHost;
function $2a19d4f671a689d6$var$getDefaultFaucetPath(hostname) {
    if (hostname === undefined) return '/accounts';
    return module.exports.FaucetNetworkPaths[hostname] || '/accounts';
}
module.exports.getDefaultFaucetPath = $2a19d4f671a689d6$var$getDefaultFaucetPath;

});


parcelRegister("8KxM7", function(module, exports) {
"use strict";
var $65ecd1a104afced7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $65ecd1a104afced7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = module.exports.INTENTIONAL_DISCONNECT_CODE = void 0;

var $8wxDW = parcelRequire("8wxDW");

const $65ecd1a104afced7$var$ws_1 = $65ecd1a104afced7$var$__importDefault((parcelRequire("j6IB2")));

var $6p5EE = parcelRequire("6p5EE");

var $aMl9I = parcelRequire("aMl9I");

const $65ecd1a104afced7$var$ConnectionManager_1 = $65ecd1a104afced7$var$__importDefault((parcelRequire("7F9U7")));

const $65ecd1a104afced7$var$ExponentialBackoff_1 = $65ecd1a104afced7$var$__importDefault((parcelRequire("8O1Rb")));

const $65ecd1a104afced7$var$RequestManager_1 = $65ecd1a104afced7$var$__importDefault((parcelRequire("e2swt")));
const $65ecd1a104afced7$var$SECONDS_PER_MINUTE = 60;
const $65ecd1a104afced7$var$TIMEOUT = 20;
const $65ecd1a104afced7$var$CONNECTION_TIMEOUT = 5;
module.exports.INTENTIONAL_DISCONNECT_CODE = 4000;
function $65ecd1a104afced7$var$createWebSocket(url, config) {
    const options = {
        agent: config.agent
    };
    if (config.headers) options.headers = config.headers;
    if (config.authorization != null) options.headers = Object.assign(Object.assign({}, options.headers), {
        Authorization: `Basic ${btoa(config.authorization)}`
    });
    const websocketOptions = Object.assign({}, options);
    return new $65ecd1a104afced7$var$ws_1.default(url, websocketOptions);
}
function $65ecd1a104afced7$var$websocketSendAsync(ws, message) {
    return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            ws.send(message, (error)=>{
                if (error) reject(new $aMl9I.DisconnectedError(error.message, error));
                else resolve();
            });
        });
    });
}
class $65ecd1a104afced7$var$Connection extends $6p5EE.EventEmitter {
    constructor(url, options = {}){
        super();
        this.ws = null;
        this.reconnectTimeoutID = null;
        this.heartbeatIntervalID = null;
        this.retryConnectionBackoff = new $65ecd1a104afced7$var$ExponentialBackoff_1.default({
            min: 100,
            max: $65ecd1a104afced7$var$SECONDS_PER_MINUTE * 1000
        });
        this.requestManager = new $65ecd1a104afced7$var$RequestManager_1.default();
        this.connectionManager = new $65ecd1a104afced7$var$ConnectionManager_1.default();
        this.trace = ()=>{};
        this.url = url;
        this.config = Object.assign({
            timeout: $65ecd1a104afced7$var$TIMEOUT * 1000,
            connectionTimeout: $65ecd1a104afced7$var$CONNECTION_TIMEOUT * 1000
        }, options);
        if (typeof options.trace === 'function') this.trace = options.trace;
        else if (options.trace) this.trace = console.log;
    }
    get state() {
        return this.ws ? this.ws.readyState : $65ecd1a104afced7$var$ws_1.default.CLOSED;
    }
    get shouldBeConnected() {
        return this.ws !== null;
    }
    isConnected() {
        return this.state === $65ecd1a104afced7$var$ws_1.default.OPEN;
    }
    connect() {
        return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isConnected()) return Promise.resolve();
            if (this.state === $65ecd1a104afced7$var$ws_1.default.CONNECTING) return this.connectionManager.awaitConnection();
            if (!this.url) return Promise.reject(new $aMl9I.ConnectionError('Cannot connect because no server was specified'));
            if (this.ws != null) return Promise.reject(new $aMl9I.XrplError('Websocket connection never cleaned up.', {
                state: this.state
            }));
            const connectionTimeoutID = setTimeout(()=>{
                this.onConnectionFailed(new $aMl9I.ConnectionError(`Error: connect() timed out after ${this.config.connectionTimeout} ms. If your internet connection is working, the ` + `rippled server may be blocked or inaccessible. You can also try setting the 'connectionTimeout' option in the Client constructor.`));
            }, this.config.connectionTimeout);
            this.ws = $65ecd1a104afced7$var$createWebSocket(this.url, this.config);
            if (this.ws == null) throw new $aMl9I.XrplError('Connect: created null websocket');
            this.ws.on('error', (error)=>this.onConnectionFailed(error));
            this.ws.on('error', ()=>clearTimeout(connectionTimeoutID));
            this.ws.on('close', (reason)=>this.onConnectionFailed(reason));
            this.ws.on('close', ()=>clearTimeout(connectionTimeoutID));
            this.ws.once('open', ()=>{
                this.onceOpen(connectionTimeoutID);
            });
            return this.connectionManager.awaitConnection();
        });
    }
    disconnect() {
        return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
            this.clearHeartbeatInterval();
            if (this.reconnectTimeoutID !== null) {
                clearTimeout(this.reconnectTimeoutID);
                this.reconnectTimeoutID = null;
            }
            if (this.state === $65ecd1a104afced7$var$ws_1.default.CLOSED) return Promise.resolve(undefined);
            if (this.ws == null) return Promise.resolve(undefined);
            return new Promise((resolve)=>{
                if (this.ws == null) resolve(undefined);
                if (this.ws != null) this.ws.once('close', (code)=>resolve(code));
                if (this.ws != null && this.state !== $65ecd1a104afced7$var$ws_1.default.CLOSING) this.ws.close(module.exports.INTENTIONAL_DISCONNECT_CODE);
            });
        });
    }
    reconnect() {
        return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
            this.emit('reconnect');
            yield this.disconnect();
            yield this.connect();
        });
    }
    request(request, timeout) {
        return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.shouldBeConnected || this.ws == null) throw new $aMl9I.NotConnectedError(JSON.stringify(request), request);
            const [id, message, responsePromise] = this.requestManager.createRequest(request, timeout !== null && timeout !== void 0 ? timeout : this.config.timeout);
            this.trace('send', message);
            $65ecd1a104afced7$var$websocketSendAsync(this.ws, message).catch((error)=>{
                this.requestManager.reject(id, error);
            });
            return responsePromise;
        });
    }
    getUrl() {
        var _a;
        return (_a = this.url) !== null && _a !== void 0 ? _a : '';
    }
    onMessage(message) {
        this.trace('receive', message);
        let data;
        try {
            data = JSON.parse(message);
        } catch (error) {
            if (error instanceof Error) this.emit('error', 'badMessage', error.message, message);
            return;
        }
        if (data.type == null && data.error) {
            this.emit('error', data.error, data.error_message, data);
            return;
        }
        if (data.type) this.emit(data.type, data);
        if (data.type === 'response') try {
            this.requestManager.handleResponse(data);
        } catch (error) {
            if (error instanceof Error) this.emit('error', 'badMessage', error.message, message);
            else this.emit('error', 'badMessage', error, error);
        }
    }
    onceOpen(connectionTimeoutID) {
        return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
            if (this.ws == null) throw new $aMl9I.XrplError('onceOpen: ws is null');
            this.ws.removeAllListeners();
            clearTimeout(connectionTimeoutID);
            this.ws.on('message', (message)=>this.onMessage(message));
            this.ws.on('error', (error)=>this.emit('error', 'websocket', error.message, error));
            this.ws.once('close', (code, reason)=>{
                if (this.ws == null) throw new $aMl9I.XrplError('onceClose: ws is null');
                this.clearHeartbeatInterval();
                this.requestManager.rejectAll(new $aMl9I.DisconnectedError(`websocket was closed, ${reason ? (0, $8wxDW.hexToString)((0, $8wxDW.bytesToHex)(reason)) : ''}`));
                this.ws.removeAllListeners();
                this.ws = null;
                if (code === undefined) {
                    const internalErrorCode = 1011;
                    this.emit('disconnected', internalErrorCode);
                } else this.emit('disconnected', code);
                if (code !== module.exports.INTENTIONAL_DISCONNECT_CODE && code !== undefined) this.intentionalDisconnect();
            });
            try {
                this.retryConnectionBackoff.reset();
                this.startHeartbeatInterval();
                this.connectionManager.resolveAllAwaiting();
                this.emit('connected');
            } catch (error) {
                if (error instanceof Error) {
                    this.connectionManager.rejectAllAwaiting(error);
                    yield this.disconnect().catch(()=>{});
                }
            }
        });
    }
    intentionalDisconnect() {
        const retryTimeout = this.retryConnectionBackoff.duration();
        this.trace('reconnect', `Retrying connection in ${retryTimeout}ms.`);
        this.emit('reconnecting', this.retryConnectionBackoff.attempts);
        this.reconnectTimeoutID = setTimeout(()=>{
            this.reconnect().catch((error)=>{
                this.emit('error', 'reconnect', error.message, error);
            });
        }, retryTimeout);
    }
    clearHeartbeatInterval() {
        if (this.heartbeatIntervalID) clearInterval(this.heartbeatIntervalID);
    }
    startHeartbeatInterval() {
        this.clearHeartbeatInterval();
        this.heartbeatIntervalID = setInterval(()=>{
            this.heartbeat();
        }, this.config.timeout);
    }
    heartbeat() {
        return $65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
            this.request({
                command: 'ping'
            }).catch(()=>$65ecd1a104afced7$var$__awaiter(this, void 0, void 0, function*() {
                    return this.reconnect().catch((error)=>{
                        this.emit('error', 'reconnect', error.message, error);
                    });
                }));
        });
    }
    onConnectionFailed(errorOrCode) {
        if (this.ws) {
            this.ws.removeAllListeners();
            this.ws.on('error', ()=>{});
            this.ws.close();
            this.ws = null;
        }
        if (typeof errorOrCode === 'number') this.connectionManager.rejectAllAwaiting(new $aMl9I.NotConnectedError(`Connection failed with code ${errorOrCode}.`, {
            code: errorOrCode
        }));
        else if (errorOrCode === null || errorOrCode === void 0 ? void 0 : errorOrCode.message) this.connectionManager.rejectAllAwaiting(new $aMl9I.NotConnectedError(errorOrCode.message, errorOrCode));
        else this.connectionManager.rejectAllAwaiting(new $aMl9I.NotConnectedError('Connection failed.'));
    }
}
module.exports.Connection = $65ecd1a104afced7$var$Connection;

});
parcelRegister("j6IB2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6p5EE = parcelRequire("6p5EE");
/**
 * Provides `EventEmitter` interface for native browser `WebSocket`,
 * same, as `ws` package provides.
 */ class $de912bc297e467ea$var$WSWrapper extends $6p5EE.EventEmitter {
    /**
     * Constructs a browser-safe websocket.
     *
     * @param url - URL to connect to.
     * @param _protocols - Not used.
     * @param _websocketOptions - Not used.
     */ constructor(url, _protocols, _websocketOptions){
        super();
        this.ws = new WebSocket(url);
        this.ws.onclose = (closeEvent)=>{
            let reason;
            if (closeEvent.reason) {
                const enc = new TextEncoder();
                reason = enc.encode(closeEvent.reason);
            }
            this.emit('close', closeEvent.code, reason);
        };
        this.ws.onopen = ()=>{
            this.emit('open');
        };
        this.ws.onerror = (error)=>{
            this.emit('error', error);
        };
        this.ws.onmessage = (message)=>{
            this.emit('message', message.data);
        };
    }
    /**
     * Get the ready state of the websocket.
     *
     * @returns The Websocket's ready state.
     */ get readyState() {
        return this.ws.readyState;
    }
    /**
     * Closes the websocket.
     *
     * @param code - Close code.
     * @param reason - Close reason.
     */ close(code, reason) {
        if (this.readyState === 1) this.ws.close(code, reason);
    }
    /**
     * Sends a message over the Websocket connection.
     *
     * @param message - Message to send.
     */ send(message) {
        this.ws.send(message);
    }
}
$de912bc297e467ea$var$WSWrapper.CONNECTING = 0;
$de912bc297e467ea$var$WSWrapper.OPEN = 1;
$de912bc297e467ea$var$WSWrapper.CLOSING = 2;
$de912bc297e467ea$var$WSWrapper.CLOSED = 3;
module.exports.default = $de912bc297e467ea$var$WSWrapper;

});

parcelRegister("7F9U7", function(module, exports) {
"use strict";
var $59440b801b1b844c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $59440b801b1b844c$var$ConnectionManager {
    constructor(){
        this.promisesAwaitingConnection = [];
    }
    resolveAllAwaiting() {
        this.promisesAwaitingConnection.map(({ resolve: resolve })=>resolve());
        this.promisesAwaitingConnection = [];
    }
    rejectAllAwaiting(error) {
        this.promisesAwaitingConnection.map(({ reject: reject })=>reject(error));
        this.promisesAwaitingConnection = [];
    }
    awaitConnection() {
        return $59440b801b1b844c$var$__awaiter(this, void 0, void 0, function*() {
            return new Promise((resolve, reject)=>{
                this.promisesAwaitingConnection.push({
                    resolve: resolve,
                    reject: reject
                });
            });
        });
    }
}
module.exports.default = $59440b801b1b844c$var$ConnectionManager;

});

parcelRegister("8O1Rb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $66946ef0a3a43408$var$DEFAULT_MIN = 100;
const $66946ef0a3a43408$var$DEFAULT_MAX = 1000;
class $66946ef0a3a43408$var$ExponentialBackoff {
    constructor(opts = {}){
        var _a, _b;
        this.factor = 2;
        this.numAttempts = 0;
        this.ms = (_a = opts.min) !== null && _a !== void 0 ? _a : $66946ef0a3a43408$var$DEFAULT_MIN;
        this.max = (_b = opts.max) !== null && _b !== void 0 ? _b : $66946ef0a3a43408$var$DEFAULT_MAX;
    }
    get attempts() {
        return this.numAttempts;
    }
    duration() {
        const ms = this.ms * Math.pow(this.factor, this.numAttempts);
        this.numAttempts += 1;
        return Math.floor(Math.min(ms, this.max));
    }
    reset() {
        this.numAttempts = 0;
    }
}
module.exports.default = $66946ef0a3a43408$var$ExponentialBackoff;

});

parcelRegister("e2swt", function(module, exports) {
"use strict";
var $a38760a4f4b40ba2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aMl9I = parcelRequire("aMl9I");
class $a38760a4f4b40ba2$var$RequestManager {
    constructor(){
        this.nextId = 0;
        this.promisesAwaitingResponse = new Map();
    }
    addPromise(newId, timer) {
        return $a38760a4f4b40ba2$var$__awaiter(this, void 0, void 0, function*() {
            return new Promise((resolve, reject)=>{
                this.promisesAwaitingResponse.set(newId, {
                    resolve: resolve,
                    reject: reject,
                    timer: timer
                });
            });
        });
    }
    resolve(id, response) {
        const promise = this.promisesAwaitingResponse.get(id);
        if (promise == null) throw new $aMl9I.XrplError(`No existing promise with id ${id}`, {
            type: 'resolve',
            response: response
        });
        clearTimeout(promise.timer);
        promise.resolve(response);
        this.deletePromise(id);
    }
    reject(id, error) {
        const promise = this.promisesAwaitingResponse.get(id);
        if (promise == null) throw new $aMl9I.XrplError(`No existing promise with id ${id}`, {
            type: 'reject',
            error: error
        });
        clearTimeout(promise.timer);
        promise.reject(error);
        this.deletePromise(id);
    }
    rejectAll(error) {
        this.promisesAwaitingResponse.forEach((_promise, id, _map)=>{
            this.reject(id, error);
            this.deletePromise(id);
        });
    }
    createRequest(request, timeout) {
        let newId;
        if (request.id == null) {
            newId = this.nextId;
            this.nextId += 1;
        } else newId = request.id;
        const newRequest = JSON.stringify(Object.assign(Object.assign({}, request), {
            id: newId
        }));
        const timer = setTimeout(()=>{
            this.reject(newId, new $aMl9I.TimeoutError(`Timeout for request: ${JSON.stringify(request)} with id ${newId}`, request));
        }, timeout);
        if (timer.unref) timer.unref();
        if (this.promisesAwaitingResponse.has(newId)) {
            clearTimeout(timer);
            throw new $aMl9I.XrplError(`Response with id '${newId}' is already pending`, request);
        }
        const newPromise = new Promise((resolve, reject)=>{
            this.promisesAwaitingResponse.set(newId, {
                resolve: resolve,
                reject: reject,
                timer: timer
            });
        });
        return [
            newId,
            newRequest,
            newPromise
        ];
    }
    handleResponse(response) {
        var _a, _b;
        if (response.id == null || !(typeof response.id === 'string' || typeof response.id === 'number')) throw new $aMl9I.ResponseFormatError('valid id not found in response', response);
        if (!this.promisesAwaitingResponse.has(response.id)) return;
        if (response.status == null) {
            const error = new $aMl9I.ResponseFormatError('Response has no status');
            this.reject(response.id, error);
        }
        if (response.status === 'error') {
            const errorResponse = response;
            const error = new $aMl9I.RippledError((_a = errorResponse.error_message) !== null && _a !== void 0 ? _a : errorResponse.error, errorResponse);
            this.reject(response.id, error);
            return;
        }
        if (response.status !== 'success') {
            const error = new $aMl9I.ResponseFormatError(`unrecognized response.status: ${(_b = response.status) !== null && _b !== void 0 ? _b : ''}`, response);
            this.reject(response.id, error);
            return;
        }
        delete response.status;
        this.resolve(response.id, response);
    }
    deletePromise(id) {
        this.promisesAwaitingResponse.delete(id);
    }
}
module.exports.default = $a38760a4f4b40ba2$var$RequestManager;

});


parcelRegister("1iQdO", function(module, exports) {
"use strict";
var $0f2ffb06f84e280b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleStreamPartialPayment = module.exports.handlePartialPayment = void 0;

const $0f2ffb06f84e280b$var$bignumber_js_1 = $0f2ffb06f84e280b$var$__importDefault((parcelRequire("hqAsy")));

var $eLMUD = parcelRequire("eLMUD");

var $64n0b = parcelRequire("64n0b");

var $33Rto = parcelRequire("33Rto");
const $0f2ffb06f84e280b$var$WARN_PARTIAL_PAYMENT_CODE = 2001;
function $0f2ffb06f84e280b$var$amountsEqual(amt1, amt2) {
    if (typeof amt1 === 'string' && typeof amt2 === 'string') return amt1 === amt2;
    if (typeof amt1 === 'string' || typeof amt2 === 'string') return false;
    if ((0, $64n0b.isMPTAmount)(amt1) && (0, $64n0b.isMPTAmount)(amt2)) {
        const aValue = new $0f2ffb06f84e280b$var$bignumber_js_1.default(amt1.value);
        const bValue = new $0f2ffb06f84e280b$var$bignumber_js_1.default(amt2.value);
        return amt1.mpt_issuance_id === amt2.mpt_issuance_id && aValue.isEqualTo(bValue);
    }
    if ((0, $64n0b.isMPTAmount)(amt1) || (0, $64n0b.isMPTAmount)(amt2)) return false;
    const aValue = new $0f2ffb06f84e280b$var$bignumber_js_1.default(amt1.value);
    const bValue = new $0f2ffb06f84e280b$var$bignumber_js_1.default(amt2.value);
    return amt1.currency === amt2.currency && amt1.issuer === amt2.issuer && aValue.isEqualTo(bValue);
}
function $0f2ffb06f84e280b$var$isPartialPayment(tx, metadata) {
    var _a;
    if (tx == null || metadata == null || tx.TransactionType !== 'Payment') return false;
    let meta = metadata;
    if (typeof meta === 'string') {
        if (meta === 'unavailable') return false;
        meta = (0, $eLMUD.decode)(meta);
    }
    const tfPartial = typeof tx.Flags === 'number' ? (0, $33Rto.isFlagEnabled)(tx.Flags, $64n0b.PaymentFlags.tfPartialPayment) : (_a = tx.Flags) === null || _a === void 0 ? void 0 : _a.tfPartialPayment;
    if (!tfPartial) return false;
    const delivered = meta.delivered_amount;
    const amount = tx.DeliverMax;
    if (delivered === undefined) return false;
    return !$0f2ffb06f84e280b$var$amountsEqual(delivered, amount);
}
function $0f2ffb06f84e280b$var$txHasPartialPayment(response) {
    return $0f2ffb06f84e280b$var$isPartialPayment(response.result.tx_json, response.result.meta);
}
function $0f2ffb06f84e280b$var$txEntryHasPartialPayment(response) {
    return $0f2ffb06f84e280b$var$isPartialPayment(response.result.tx_json, response.result.metadata);
}
function $0f2ffb06f84e280b$var$accountTxHasPartialPayment(response) {
    const { transactions: transactions } = response.result;
    const foo = transactions.some((tx)=>{
        if (tx.tx_json != null) {
            const transaction = tx;
            return $0f2ffb06f84e280b$var$isPartialPayment(transaction.tx_json, transaction.meta);
        }
        const transaction = tx;
        return $0f2ffb06f84e280b$var$isPartialPayment(transaction.tx, transaction.meta);
    });
    return foo;
}
function $0f2ffb06f84e280b$var$hasPartialPayment(command, response) {
    switch(command){
        case 'tx':
            return $0f2ffb06f84e280b$var$txHasPartialPayment(response);
        case 'transaction_entry':
            return $0f2ffb06f84e280b$var$txEntryHasPartialPayment(response);
        case 'account_tx':
            return $0f2ffb06f84e280b$var$accountTxHasPartialPayment(response);
        default:
            return false;
    }
}
function $0f2ffb06f84e280b$var$handlePartialPayment(command, response) {
    var _a;
    if ($0f2ffb06f84e280b$var$hasPartialPayment(command, response)) {
        const warnings = (_a = response.warnings) !== null && _a !== void 0 ? _a : [];
        const warning = {
            id: $0f2ffb06f84e280b$var$WARN_PARTIAL_PAYMENT_CODE,
            message: 'This response contains a Partial Payment'
        };
        warnings.push(warning);
        response.warnings = warnings;
    }
}
module.exports.handlePartialPayment = $0f2ffb06f84e280b$var$handlePartialPayment;
function $0f2ffb06f84e280b$var$handleStreamPartialPayment(stream, log) {
    var _a, _b;
    if ($0f2ffb06f84e280b$var$isPartialPayment((_a = stream.tx_json) !== null && _a !== void 0 ? _a : stream.transaction, stream.meta)) {
        const warnings = (_b = stream.warnings) !== null && _b !== void 0 ? _b : [];
        const warning = {
            id: $0f2ffb06f84e280b$var$WARN_PARTIAL_PAYMENT_CODE,
            message: 'This response contains a Partial Payment'
        };
        warnings.push(warning);
        stream.warnings = warnings;
        log('Partial payment received', JSON.stringify(stream));
    }
}
module.exports.handleStreamPartialPayment = $0f2ffb06f84e280b$var$handleStreamPartialPayment;

});


parcelRegister("7OgLe", function(module, exports) {
"use strict";
var $5afa3442b945ab2a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5afa3442b945ab2a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5afa3442b945ab2a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5afa3442b945ab2a$var$__createBinding(result, mod, k);
    }
    $5afa3442b945ab2a$var$__setModuleDefault(result, mod);
    return result;
};
var $5afa3442b945ab2a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5afa3442b945ab2a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTransactionFlags = module.exports.convertTxFlagsToNumber = module.exports.setTransactionFlagsToNumber = module.exports.parseAccountRootFlags = module.exports.LedgerEntry = void 0;

module.exports.LedgerEntry = $5afa3442b945ab2a$var$__importStar((parcelRequire("g4jBX")));

var $jvbLy = parcelRequire("jvbLy");
Object.defineProperty(module.exports, "parseAccountRootFlags", {
    enumerable: true,
    get: function() {
        return $jvbLy.parseAccountRootFlags;
    }
});
Object.defineProperty(module.exports, "setTransactionFlagsToNumber", {
    enumerable: true,
    get: function() {
        return $jvbLy.setTransactionFlagsToNumber;
    }
});
Object.defineProperty(module.exports, "convertTxFlagsToNumber", {
    enumerable: true,
    get: function() {
        return $jvbLy.convertTxFlagsToNumber;
    }
});
Object.defineProperty(module.exports, "parseTransactionFlags", {
    enumerable: true,
    get: function() {
        return $jvbLy.parseTransactionFlags;
    }
});

$5afa3442b945ab2a$var$__exportStar((parcelRequire("hwltr")), module.exports);

$5afa3442b945ab2a$var$__exportStar((parcelRequire("64n0b")), module.exports);

$5afa3442b945ab2a$var$__exportStar((parcelRequire("6sfYg")), module.exports);

});
parcelRegister("g4jBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignerListFlags = module.exports.RippleStateFlags = module.exports.OfferFlags = module.exports.NEGATIVE_UNL_ID = module.exports.FEE_SETTINGS_ID = module.exports.AMENDMENTS_ID = module.exports.AccountRootFlags = void 0;

var $23VH6 = parcelRequire("23VH6");
Object.defineProperty(module.exports, "AccountRootFlags", {
    enumerable: true,
    get: function() {
        return $23VH6.AccountRootFlags;
    }
});

var $djXew = parcelRequire("djXew");
Object.defineProperty(module.exports, "AMENDMENTS_ID", {
    enumerable: true,
    get: function() {
        return $djXew.AMENDMENTS_ID;
    }
});

var $jv4SZ = parcelRequire("jv4SZ");
Object.defineProperty(module.exports, "FEE_SETTINGS_ID", {
    enumerable: true,
    get: function() {
        return $jv4SZ.FEE_SETTINGS_ID;
    }
});

var $g5vGh = parcelRequire("g5vGh");
Object.defineProperty(module.exports, "NEGATIVE_UNL_ID", {
    enumerable: true,
    get: function() {
        return $g5vGh.NEGATIVE_UNL_ID;
    }
});

var $4alJn = parcelRequire("4alJn");
Object.defineProperty(module.exports, "OfferFlags", {
    enumerable: true,
    get: function() {
        return $4alJn.OfferFlags;
    }
});

var $aiF9F = parcelRequire("aiF9F");
Object.defineProperty(module.exports, "RippleStateFlags", {
    enumerable: true,
    get: function() {
        return $aiF9F.RippleStateFlags;
    }
});

var $h1YH6 = parcelRequire("h1YH6");
Object.defineProperty(module.exports, "SignerListFlags", {
    enumerable: true,
    get: function() {
        return $h1YH6.SignerListFlags;
    }
});

});
parcelRegister("djXew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AMENDMENTS_ID = void 0;
module.exports.AMENDMENTS_ID = '7DB0788C020F02780A673DC74757F23823FA3014C1866E72CC4CD8B226CD6EF4';

});

parcelRegister("jv4SZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FEE_SETTINGS_ID = void 0;
module.exports.FEE_SETTINGS_ID = '4BC50C9B0D8515D3EAAE1E74B29A95804346C491EE1A95BF25E4AAB854A6A651';

});

parcelRegister("g5vGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NEGATIVE_UNL_ID = void 0;
module.exports.NEGATIVE_UNL_ID = '2E8A59AA9D3B5B186B0B9E0F62E6C02587CA74A4D778938E957B6357D364B244';

});

parcelRegister("aiF9F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RippleStateFlags = void 0;
var $77fb82566867543e$var$RippleStateFlags;
(function(RippleStateFlags) {
    RippleStateFlags[RippleStateFlags["lsfLowReserve"] = 65536] = "lsfLowReserve";
    RippleStateFlags[RippleStateFlags["lsfHighReserve"] = 131072] = "lsfHighReserve";
    RippleStateFlags[RippleStateFlags["lsfLowAuth"] = 262144] = "lsfLowAuth";
    RippleStateFlags[RippleStateFlags["lsfHighAuth"] = 524288] = "lsfHighAuth";
    RippleStateFlags[RippleStateFlags["lsfLowNoRipple"] = 1048576] = "lsfLowNoRipple";
    RippleStateFlags[RippleStateFlags["lsfHighNoRipple"] = 2097152] = "lsfHighNoRipple";
    RippleStateFlags[RippleStateFlags["lsfLowFreeze"] = 4194304] = "lsfLowFreeze";
    RippleStateFlags[RippleStateFlags["lsfHighFreeze"] = 8388608] = "lsfHighFreeze";
    RippleStateFlags[RippleStateFlags["lsfAMMNode"] = 16777216] = "lsfAMMNode";
    RippleStateFlags[RippleStateFlags["lsfLowDeepFreeze"] = 33554432] = "lsfLowDeepFreeze";
    RippleStateFlags[RippleStateFlags["lsfHighDeepFreeze"] = 67108864] = "lsfHighDeepFreeze";
})($77fb82566867543e$var$RippleStateFlags || (module.exports.RippleStateFlags = $77fb82566867543e$var$RippleStateFlags = {}));

});

parcelRegister("h1YH6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignerListFlags = void 0;
var $c6619c4b4832a011$var$SignerListFlags;
(function(SignerListFlags) {
    SignerListFlags[SignerListFlags["lsfOneOwnerCount"] = 65536] = "lsfOneOwnerCount";
})($c6619c4b4832a011$var$SignerListFlags || (module.exports.SignerListFlags = $c6619c4b4832a011$var$SignerListFlags = {}));

});


parcelRegister("hwltr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("c8A0F", function(module, exports) {
"use strict";
var $8d622a2ad66098fa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.walletFromSecretNumbers = void 0;

var $hR9XR = parcelRequire("hR9XR");

const $8d622a2ad66098fa$var$ECDSA_1 = $8d622a2ad66098fa$var$__importDefault((parcelRequire("jbgk0")));

var $81kGK = parcelRequire("81kGK");
function $8d622a2ad66098fa$var$walletFromSecretNumbers(secretNumbers, opts) {
    var _a;
    const secret = new $hR9XR.Account(secretNumbers).getFamilySeed();
    const updatedOpts = {
        masterAddress: undefined,
        algorithm: undefined
    };
    if (opts === undefined) updatedOpts.algorithm = $8d622a2ad66098fa$var$ECDSA_1.default.secp256k1;
    else {
        updatedOpts.masterAddress = opts.masterAddress;
        updatedOpts.algorithm = (_a = opts.algorithm) !== null && _a !== void 0 ? _a : $8d622a2ad66098fa$var$ECDSA_1.default.secp256k1;
    }
    return $81kGK.Wallet.fromSecret(secret, updatedOpts);
}
module.exports.walletFromSecretNumbers = $8d622a2ad66098fa$var$walletFromSecretNumbers;

});
parcelRegister("hR9XR", function(module, exports) {
"use strict";
var $cfff1da9a9ea483e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cfff1da9a9ea483e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cfff1da9a9ea483e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cfff1da9a9ea483e$var$__exportStar((parcelRequire("4fEX1")), module.exports);

$cfff1da9a9ea483e$var$__exportStar((parcelRequire("TRSnj")), module.exports);

});
parcelRegister("4fEX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

var $cYPJw = parcelRequire("cYPJw");

var $TRSnj = parcelRequire("TRSnj");
class $3188542954e9ca1d$var$Account {
    constructor(secretNumbers){
        this._account = {
            familySeed: '',
            address: '',
            keypair: {
                publicKey: '',
                privateKey: ''
            }
        };
        if (typeof secretNumbers === 'string') this._secret = (0, $TRSnj.parseSecretString)(secretNumbers);
        else if (Array.isArray(secretNumbers)) this._secret = secretNumbers;
        else if (secretNumbers instanceof Uint8Array) this._secret = (0, $TRSnj.entropyToSecret)(secretNumbers);
        else this._secret = (0, $TRSnj.randomSecret)();
        $3188542954e9ca1d$var$validateLengths(this._secret);
        this.derive();
    }
    getSecret() {
        return this._secret;
    }
    getSecretString() {
        return this._secret.join(' ');
    }
    getAddress() {
        return this._account.address;
    }
    getFamilySeed() {
        return this._account.familySeed;
    }
    getKeypair() {
        return this._account.keypair;
    }
    toString() {
        return this.getSecretString();
    }
    derive() {
        try {
            const entropy = (0, $TRSnj.secretToEntropy)(this._secret);
            this._account.familySeed = (0, $cYPJw.generateSeed)({
                entropy: entropy
            });
            this._account.keypair = (0, $cYPJw.deriveKeypair)(this._account.familySeed);
            this._account.address = (0, $cYPJw.deriveAddress)(this._account.keypair.publicKey);
        } catch (error) {
            let message = 'Unknown Error';
            if (error instanceof Error) message = error.message;
            throw new Error(message);
        }
    }
}
module.exports.Account = $3188542954e9ca1d$var$Account;
function $3188542954e9ca1d$var$validateLengths(secretNumbers) {
    if (secretNumbers.length !== 8) throw new Error('Secret must have 8 numbers');
    secretNumbers.forEach((num)=>{
        if (num.length !== 6) throw new Error('Each secret number must be 6 digits');
    });
}

});
parcelRegister("TRSnj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseSecretString = module.exports.checkChecksum = module.exports.calculateChecksum = module.exports.secretToEntropy = module.exports.entropyToSecret = module.exports.randomSecret = module.exports.randomEntropy = void 0;

var $8wxDW = parcelRequire("8wxDW");
function $0a7eedd2cbbb53fd$var$randomEntropy() {
    return (0, $8wxDW.randomBytes)(16);
}
module.exports.randomEntropy = $0a7eedd2cbbb53fd$var$randomEntropy;
function $0a7eedd2cbbb53fd$var$calculateChecksum(position, value) {
    return value * (position * 2 + 1) % 9;
}
module.exports.calculateChecksum = $0a7eedd2cbbb53fd$var$calculateChecksum;
function $0a7eedd2cbbb53fd$var$checkChecksum(position, value, checksum) {
    let normalizedChecksum;
    let normalizedValue;
    if (typeof value === 'string') {
        if (value.length !== 6) throw new Error('value must have a length of 6');
        normalizedChecksum = parseInt(value.slice(5), 10);
        normalizedValue = parseInt(value.slice(0, 5), 10);
    } else {
        if (typeof checksum !== 'number') throw new Error('checksum must be a number when value is a number');
        normalizedChecksum = checksum;
        normalizedValue = value;
    }
    return normalizedValue * (position * 2 + 1) % 9 === normalizedChecksum;
}
module.exports.checkChecksum = $0a7eedd2cbbb53fd$var$checkChecksum;
function $0a7eedd2cbbb53fd$var$entropyToSecret(entropy) {
    const len = new Array(Math.ceil(entropy.length / 2));
    const chunks = Array.from(len, (_a, chunk)=>{
        const buffChunk = entropy.slice(chunk * 2, (chunk + 1) * 2);
        const no = parseInt((0, $8wxDW.bytesToHex)(buffChunk), 16);
        const fill = '0'.repeat(5 - String(no).length);
        return fill + String(no) + String($0a7eedd2cbbb53fd$var$calculateChecksum(chunk, no));
    });
    if (chunks.length !== 8) throw new Error('Chucks must have 8 digits');
    return chunks;
}
module.exports.entropyToSecret = $0a7eedd2cbbb53fd$var$entropyToSecret;
function $0a7eedd2cbbb53fd$var$randomSecret() {
    return $0a7eedd2cbbb53fd$var$entropyToSecret($0a7eedd2cbbb53fd$var$randomEntropy());
}
module.exports.randomSecret = $0a7eedd2cbbb53fd$var$randomSecret;
function $0a7eedd2cbbb53fd$var$secretToEntropy(secret) {
    return (0, $8wxDW.concat)(secret.map((chunk, i)=>{
        const no = Number(chunk.slice(0, 5));
        const checksum = Number(chunk.slice(5));
        if (chunk.length !== 6) throw new Error('Invalid secret: number invalid');
        if (!$0a7eedd2cbbb53fd$var$checkChecksum(i, no, checksum)) throw new Error('Invalid secret part: checksum invalid');
        const hex = `0000${no.toString(16)}`.slice(-4);
        return (0, $8wxDW.hexToBytes)(hex);
    }));
}
module.exports.secretToEntropy = $0a7eedd2cbbb53fd$var$secretToEntropy;
function $0a7eedd2cbbb53fd$var$parseSecretString(secret) {
    const normalizedSecret = secret.replace(/[^0-9]/gu, '');
    if (normalizedSecret.length !== 48) throw new Error('Invalid secret string (should contain 8 blocks of 6 digits');
    return Array.from(new Array(8), (_a, index)=>{
        return normalizedSecret.slice(index * 6, (index + 1) * 6);
    });
}
module.exports.parseSecretString = $0a7eedd2cbbb53fd$var$parseSecretString;

});





parcelRegister("e0BbI", function(module, exports) {

$parcel$export(module.exports, "XRPL_PUBLIC_SERVER", function () { return $123b7f79da85a75c$export$8ddf0ce6d86841b9; });
$parcel$export(module.exports, "WALLET_ID", function () { return $123b7f79da85a75c$export$7c460c214963f696; });
$parcel$export(module.exports, "info", function () { return $123b7f79da85a75c$export$a80b3bd66acc52ff; });
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $8v8bK = parcelRequire("8v8bK");
const $123b7f79da85a75c$export$8ddf0ce6d86841b9 = 'wss://xrplcluster.com/';
const $123b7f79da85a75c$export$7c460c214963f696 = 'gemwallet';
const $123b7f79da85a75c$export$a80b3bd66acc52ff = {
    name: 'GemWallet',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/gemwallet/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/gemwallet/egebedonbdapoieedfcfkofloclfghab',
        homepage: 'https://gemwallet.app/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'XRPL',
                        value: 'XRPL',
                        id: 'XRPL',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.xrplBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $8v8bK.default)()
            }
        }
    ]
};

});
parcelRegister("8v8bK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c6c289869f4a8d9$export$2e2bcd8739ae039; });
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $6c6c289869f4a8d9$export$2e2bcd8739ae039() {
    const { Signer: XrplSigner } = await Promise.resolve((parcelRequire("eehHp")));
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).XRPL, new XrplSigner());
    return signers;
}

});


parcelRegister("grUTp", function(module, exports) {

$parcel$export(module.exports, "changeAccountSubscriberBuilder", function () { return $94ef184090b8829e$export$279bcb7ce4196302; });

var $lfyg9 = parcelRequire("lfyg9");

var $f59Be = parcelRequire("f59Be");

var $g0e4X = parcelRequire("g0e4X");
function $94ef184090b8829e$export$279bcb7ce4196302() {
    // `true` instead of ProviderAPI is just a workaround. we don't need to have instance here.
    return new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(()=>true).format(async (_, payload)=>[
            (0, $g0e4X.utils).formatAddressToCAIP(payload.wallet.publicAddress)
        ]).addEventListener((_, callback)=>{
        (0, $lfyg9.on)('walletChanged', callback);
    }).removeEventListener((_instance, _callback)=>{
    /*
       * TODO: gem wallet doesn't have support for unsubscribing.
       * Making a variable and keep the callback refrence then here make it `undefined` is a quick fix
       * but it makes new bugs, where if two subscribers added at once, we will loose the track of the first one and it will be staled.
       */ }).build();
}

});


parcelRegister("fvxh1", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $31001798466f9df0$export$fdf54fdde81cc9f0; });

var $lfyg9 = parcelRequire("lfyg9");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $5vvrT = parcelRequire("5vvrT");
class $31001798466f9df0$export$fdf54fdde81cc9f0 {
    async signMessage() {
        throw (0, $9gKM3.SignerError).UnimplementedError('signMessage');
    }
    async signAndSendTx(tx) {
        if (tx.data.TransactionType === 'TrustSet') {
            const result = await (0, $lfyg9.setTrustline)((0, $5vvrT.fromTrustSetTransactionDataToGemWalletRequest)(tx.data));
            if (result.type === 'reject') throw new Error('The request has been rejected', {
                cause: result
            });
            if (!result.result) throw new Error('Unexpected error where the result is not returned. (type: UnreachableCode)');
            return {
                hash: result.result.hash
            };
        } else if (tx.data.TransactionType === 'Payment') {
            const result = await (0, $lfyg9.sendPayment)((0, $5vvrT.fromPaymentTransactionDataToGemWalletRequest)(tx.data));
            if (result.type === 'reject') throw new Error('The request has been rejected', {
                cause: result
            });
            if (!result.result) throw new Error('Unexpected error where the result is not returned. (type: UnreachableCode)');
            return {
                hash: result.result.hash
            };
        }
        throw new Error('Unsupported transaction type');
    }
}

});
parcelRegister("5vvrT", function(module, exports) {

$parcel$export(module.exports, "fromTrustSetTransactionDataToGemWalletRequest", function () { return $1236f55de1a3aa74$export$a91416038074175e; });
$parcel$export(module.exports, "fromPaymentTransactionDataToGemWalletRequest", function () { return $1236f55de1a3aa74$export$ea13c2a70c043656; });
function $1236f55de1a3aa74$var$isIssuedCurrencyAmount(amount) {
    return typeof amount === 'object' && // @ts-expect-error it never throw an runtime error, since we are checking it should be an object first
    typeof amount.currency === 'string' && // @ts-expect-error it never throw an runtime error, since we are checking it should be an object first
    typeof amount.issuer === 'string' && typeof amount.value === 'string';
}
function $1236f55de1a3aa74$var$isMPTokenAmount(amount) {
    return typeof amount === 'object' && // @ts-expect-error it never throw an runtime error, since we are checking it should be an object first
    typeof amount.mpt_issuance_id === 'string' && typeof amount.value === 'string';
}
function $1236f55de1a3aa74$var$fromPaymentTransactionMemoToGemWalletMemo(memos) {
    if (!memos) return [];
    return memos.map((memo)=>{
        return {
            memo: {
                memoType: memo.Memo.MemoType,
                memoData: memo.Memo.MemoData,
                memoFormat: memo.Memo.MemoFormat
            }
        };
    });
}
function $1236f55de1a3aa74$export$a91416038074175e(data) {
    return {
        limitAmount: data.LimitAmount,
        memos: $1236f55de1a3aa74$var$fromPaymentTransactionMemoToGemWalletMemo(data.Memos),
        flags: data.Flags
    };
}
function $1236f55de1a3aa74$export$ea13c2a70c043656(data) {
    let amount;
    if ($1236f55de1a3aa74$var$isMPTokenAmount(data.Amount)) throw new Error("Current implemented signer doesn't have support for MPT");
    else if ($1236f55de1a3aa74$var$isIssuedCurrencyAmount(data.Amount)) amount = data.Amount;
    else if (typeof data.Amount === 'string') amount = data.Amount;
    else throw new Error("There is an unexpected type for Amount. current signer doesn't have support for that.");
    return {
        amount: amount,
        destination: data.Destination,
        destinationTag: data.DestinationTag,
        memos: $1236f55de1a3aa74$var$fromPaymentTransactionMemoToGemWalletMemo(data.Memos),
        flags: data.Flags
    };
}

});



parcelRegister("7lMFN", function(module, exports) {

$parcel$export(module.exports, "JsonRpcApiPollingProvider", function () { return $55a0400bac7872bd$export$e16ffa1aa36d1432; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $55a0400bac7872bd$export$da28308012bf6748; });
/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false

var $2rFFi = parcelRequire("2rFFi");

var $hbt3Q = parcelRequire("hbt3Q");
var $9XxdG = parcelRequire("9XxdG");

var $k9Aiw = parcelRequire("k9Aiw");

var $7E40U = parcelRequire("7E40U");

var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
var $9b9xw = parcelRequire("9b9xw");
var $ltdtW = parcelRequire("ltdtW");
var $k39Yy = parcelRequire("k39Yy");
var $jhFUp = parcelRequire("jhFUp");

var $62vB8 = parcelRequire("62vB8");

var $fEc8Y = parcelRequire("fEc8Y");

var $crad7 = parcelRequire("crad7");

var $9XYbB = parcelRequire("9XYbB");

var $dgf09 = parcelRequire("dgf09");
const $55a0400bac7872bd$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $55a0400bac7872bd$var$deepCopy(value) {
    if (value == null || $55a0400bac7872bd$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($55a0400bac7872bd$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $55a0400bac7872bd$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $55a0400bac7872bd$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $55a0400bac7872bd$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $55a0400bac7872bd$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $55a0400bac7872bd$export$5f7b5fca3508545a extends (0, $fEc8Y.AbstractSigner) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $hbt3Q.getAddress)(address);
        (0, $b74mN.defineProperties)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $bCA3C.assert)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $55a0400bac7872bd$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $9XxdG.resolveAddress)(_from, this.provider);
                (0, $bCA3C.assertArgument)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $9XxdG.resolveAddress)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $bCA3C.isError)(error, "CANCELLED") || (0, $bCA3C.isError)(error, "BAD_DATA") || (0, $bCA3C.isError)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $bCA3C.isError)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $bCA3C.makeError)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $55a0400bac7872bd$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $9XxdG.resolveAddress)(tx.from, this.provider);
            (0, $bCA3C.assertArgument)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $jhFUp.toUtf8Bytes)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $k39Yy.hexlify)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $55a0400bac7872bd$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $k9Aiw.TypedDataEncoder).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $9XxdG.resolveAddress)(value);
            (0, $bCA3C.assertArgument)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $k9Aiw.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $jhFUp.toUtf8Bytes)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $k39Yy.hexlify)(message)
        ]);
    }
}
class $55a0400bac7872bd$export$5afe35a44ca7ff9a extends (0, $62vB8.AbstractProvider) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $bCA3C.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $bCA3C.makeError)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $55a0400bac7872bd$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $bCA3C.assertArgument)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $crad7.Network).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $bCA3C.assertArgument)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $bCA3C.assert)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $ltdtW.getBigInt)(tx.type)) // If there are no EIP-1559 or newer properties, it might be pre-EIP-1559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $crad7.Network).from((0, $ltdtW.getBigInt)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $crad7.Network).from((0, $ltdtW.getBigInt)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $bCA3C.makeError)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $55a0400bac7872bd$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $9XYbB.FilterIdPendingSubscriber)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $dgf09.PollingEventSubscriber)(this, sub.filter);
            return new (0, $9XYbB.FilterIdEventSubscriber)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $62vB8.UnmanagedSubscriber)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $ltdtW.toQuantity)((0, $ltdtW.getBigInt)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $k39Yy.hexlify)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $7E40U.accessListify)(tx.accessList);
        if (tx.blobVersionedHashes) // @TODO: Remove this <any> case once EIP-4844 added to prepared tx
        result["blobVersionedHashes"] = tx.blobVersionedHashes.map((h)=>h.toLowerCase());
        // @TODO: blobs should probably also be copied over, optionally
        // accounting for the kzg property to backfill blobVersionedHashes
        // using the commitment. Or should that be left as an exercise to
        // the caller?
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $55a0400bac7872bd$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $55a0400bac7872bd$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $55a0400bac7872bd$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $55a0400bac7872bd$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($55a0400bac7872bd$var$getLowerCase);
                    else req.filter.address = $55a0400bac7872bd$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $bCA3C.makeError)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $55a0400bac7872bd$var$spelunkData(error);
            const e = (0, $2rFFi.AbiCoder).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($55a0400bac7872bd$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $bCA3C.makeError)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $bCA3C.makeError)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $bCA3C.makeError)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $bCA3C.makeError)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $bCA3C.makeError)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $bCA3C.makeError)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $bCA3C.makeError)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $bCA3C.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $55a0400bac7872bd$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $hbt3Q.getAddress)(address);
        for (const account of accounts){
            if ((0, $hbt3Q.getAddress)(account) === address) return new $55a0400bac7872bd$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $55a0400bac7872bd$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $bCA3C.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $55a0400bac7872bd$export$e16ffa1aa36d1432 extends $55a0400bac7872bd$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        let pollingInterval = this._getOption("pollingInterval");
        if (pollingInterval == null) pollingInterval = $55a0400bac7872bd$var$defaultOptions.pollingInterval;
        this.#pollingInterval = pollingInterval;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($55a0400bac7872bd$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($55a0400bac7872bd$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $55a0400bac7872bd$export$da28308012bf6748 extends $55a0400bac7872bd$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http:/\/localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $9b9xw.FetchRequest)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $55a0400bac7872bd$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $k39Yy.isHexString)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $55a0400bac7872bd$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $55a0400bac7872bd$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $55a0400bac7872bd$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$55a0400bac7872bd$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $55a0400bac7872bd$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $55a0400bac7872bd$var$spelunkMessage(value) {
    const result = [];
    $55a0400bac7872bd$var$_spelunkMessage(value, result);
    return result;
}

});
parcelRegister("2rFFi", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $1c7e6c341f9e09ce$export$fe041e1a83d3efc6; });
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");

var $2vkKj = parcelRequire("2vkKj");

var $7DEhe = parcelRequire("7DEhe");

var $d2hVs = parcelRequire("d2hVs");

var $1Xnoq = parcelRequire("1Xnoq");

var $3NuCv = parcelRequire("3NuCv");

var $9slDa = parcelRequire("9slDa");

var $3SVXk = parcelRequire("3SVXk");

var $bOJwi = parcelRequire("bOJwi");

var $8hBXc = parcelRequire("8hBXc");

var $8QPKU = parcelRequire("8QPKU");

var $1YicP = parcelRequire("1YicP");

var $hbt3Q = parcelRequire("hbt3Q");
// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $1c7e6c341f9e09ce$var$PanicReasons = new Map();
$1c7e6c341f9e09ce$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x11, "OVERFLOW");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$1c7e6c341f9e09ce$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $1c7e6c341f9e09ce$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $1c7e6c341f9e09ce$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $1c7e6c341f9e09ce$var$defaultCoder = null;
let $1c7e6c341f9e09ce$var$defaultMaxInflation = 1024;
function $1c7e6c341f9e09ce$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $k39Yy.getBytes)(data);
        data = (0, $k39Yy.hexlify)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $k39Yy.hexlify)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $k39Yy.hexlify)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$1c7e6c341f9e09ce$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $hbt3Q.getAddress)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $hbt3Q.getAddress)(tx.from);
    return (0, $bCA3C.makeError)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $1c7e6c341f9e09ce$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $d2hVs.ArrayCoder)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $8QPKU.TupleCoder)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $7DEhe.AddressCoder)(param.name);
            case "bool":
                return new (0, $1Xnoq.BooleanCoder)(param.name);
            case "string":
                return new (0, $8hBXc.StringCoder)(param.name);
            case "bytes":
                return new (0, $3NuCv.BytesCoder)(param.name);
            case "":
                return new (0, $3SVXk.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($1c7e6c341f9e09ce$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $bCA3C.assertArgument)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $bOJwi.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($1c7e6c341f9e09ce$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $bCA3C.assertArgument)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $9slDa.FixedBytesCoder)(size, param.name);
        }
        (0, $bCA3C.assertArgument)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $1YicP.ParamType).from(type)));
        const coder = new (0, $8QPKU.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $bCA3C.assertArgumentCount)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $1YicP.ParamType).from(type)));
        const coder = new (0, $8QPKU.TupleCoder)(coders, "_");
        const writer = new (0, $2vkKj.Writer)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $1YicP.ParamType).from(type)));
        const coder = new (0, $8QPKU.TupleCoder)(coders, "_");
        return coder.decode(new (0, $2vkKj.Reader)(data, loose, $1c7e6c341f9e09ce$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $bCA3C.assertArgument)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $1c7e6c341f9e09ce$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($1c7e6c341f9e09ce$var$defaultCoder == null) $1c7e6c341f9e09ce$var$defaultCoder = new $1c7e6c341f9e09ce$export$fe041e1a83d3efc6();
        return $1c7e6c341f9e09ce$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $1c7e6c341f9e09ce$var$getBuiltinCallException(action, tx, data, $1c7e6c341f9e09ce$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}

});
parcelRegister("2vkKj", function(module, exports) {

$parcel$export(module.exports, "WordSize", function () { return $1d2e91b963b648cd$export$b4b1d1fba463e69c; });
$parcel$export(module.exports, "Result", function () { return $1d2e91b963b648cd$export$8fdcabde73f49165; });
$parcel$export(module.exports, "Coder", function () { return $1d2e91b963b648cd$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $1d2e91b963b648cd$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $1d2e91b963b648cd$export$2f7a2f0e90c07dc4; });

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");
const $1d2e91b963b648cd$export$b4b1d1fba463e69c = 32;
const $1d2e91b963b648cd$var$Padding = new Uint8Array($1d2e91b963b648cd$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $1d2e91b963b648cd$var$passProperties = [
    "then"
];
const $1d2e91b963b648cd$var$_guard = {};
const $1d2e91b963b648cd$var$resultNames = new WeakMap();
function $1d2e91b963b648cd$var$getNames(result) {
    return $1d2e91b963b648cd$var$resultNames.get(result);
}
function $1d2e91b963b648cd$var$setNames(result, names) {
    $1d2e91b963b648cd$var$resultNames.set(result, names);
}
function $1d2e91b963b648cd$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
function $1d2e91b963b648cd$var$toObject(names, items, deep) {
    if (names.indexOf(null) >= 0) return items.map((item, index)=>{
        if (item instanceof $1d2e91b963b648cd$export$8fdcabde73f49165) return $1d2e91b963b648cd$var$toObject($1d2e91b963b648cd$var$getNames(item), item, deep);
        return item;
    });
    return names.reduce((accum, name, index)=>{
        let item = items.getValue(name);
        if (!(name in accum)) {
            if (deep && item instanceof $1d2e91b963b648cd$export$8fdcabde73f49165) item = $1d2e91b963b648cd$var$toObject($1d2e91b963b648cd$var$getNames(item), item, deep);
            accum[name] = item;
        }
        return accum;
    }, {});
}
class $1d2e91b963b648cd$export$8fdcabde73f49165 extends Array {
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $1d2e91b963b648cd$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        $1d2e91b963b648cd$var$setNames(this, Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        })));
        // Dummy operations to prevent TypeScript from complaining
        this.#names = [];
        if (this.#names == null) this.#names;
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        const proxy = new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $ltdtW.getNumber)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $1d2e91b963b648cd$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($1d2e91b963b648cd$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
        $1d2e91b963b648cd$var$setNames(proxy, $1d2e91b963b648cd$var$getNames(this));
        return proxy;
    }
    /**
     *  Returns the Result as a normal Array. If %%deep%%, any children
     *  which are Result objects are also converted to a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray(deep) {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $1d2e91b963b648cd$var$throwError(`index ${index}`, item);
            if (deep && item instanceof $1d2e91b963b648cd$export$8fdcabde73f49165) item = item.toArray(deep);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair. If
     *  %%deep%%, any children which are Result objects are also
     *  converted to an Object.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject(deep) {
        const names = $1d2e91b963b648cd$var$getNames(this);
        return names.reduce((accum, name, index)=>{
            (0, $bCA3C.assert)(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            return $1d2e91b963b648cd$var$toObject(names, this, deep);
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const _names = $1d2e91b963b648cd$var$getNames(this);
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(_names[i]);
        }
        return new $1d2e91b963b648cd$export$8fdcabde73f49165($1d2e91b963b648cd$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const _names = $1d2e91b963b648cd$var$getNames(this);
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $1d2e91b963b648cd$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(_names[i]);
            }
        }
        return new $1d2e91b963b648cd$export$8fdcabde73f49165($1d2e91b963b648cd$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $1d2e91b963b648cd$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = $1d2e91b963b648cd$var$getNames(this).indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $1d2e91b963b648cd$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $1d2e91b963b648cd$export$8fdcabde73f49165($1d2e91b963b648cd$var$_guard, items, keys);
    }
}
function $1d2e91b963b648cd$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $1d2e91b963b648cd$var$getValue(value) {
    let bytes = (0, $ltdtW.toBeArray)(value);
    (0, $bCA3C.assert)(bytes.length <= $1d2e91b963b648cd$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $1d2e91b963b648cd$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $1d2e91b963b648cd$export$b4b1d1fba463e69c) bytes = (0, $k39Yy.getBytesCopy)((0, $k39Yy.concat)([
        $1d2e91b963b648cd$var$Padding.slice(bytes.length % $1d2e91b963b648cd$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $1d2e91b963b648cd$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $b74mN.defineProperties)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $bCA3C.assertArgument)(false, message, this.localName, value);
    }
}
class $1d2e91b963b648cd$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $k39Yy.concat)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $k39Yy.getBytesCopy)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $k39Yy.getBytesCopy)(value);
        const paddingOffset = bytes.length % $1d2e91b963b648cd$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $k39Yy.getBytesCopy)((0, $k39Yy.concat)([
            bytes,
            $1d2e91b963b648cd$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($1d2e91b963b648cd$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($1d2e91b963b648cd$var$Padding);
        this.#dataLength += $1d2e91b963b648cd$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $1d2e91b963b648cd$var$getValue(value);
        };
    }
}
class $1d2e91b963b648cd$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $b74mN.defineProperties)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $k39Yy.getBytesCopy)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $k39Yy.hexlify)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $bCA3C.assert)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $k39Yy.getBytesCopy)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $1d2e91b963b648cd$export$b4b1d1fba463e69c) * $1d2e91b963b648cd$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $bCA3C.assert)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $k39Yy.getBytesCopy)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $1d2e91b963b648cd$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $ltdtW.toBigInt)(this.readBytes($1d2e91b963b648cd$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $ltdtW.toNumber)(this.readBytes($1d2e91b963b648cd$export$b4b1d1fba463e69c));
    }
}

});

parcelRegister("7DEhe", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $58fb6b170a9fdbdd$export$59dbbded7775bfe7; });

var $hbt3Q = parcelRequire("hbt3Q");

var $ltdtW = parcelRequire("ltdtW");

var $7BCLp = parcelRequire("7BCLp");

var $2vkKj = parcelRequire("2vkKj");
class $58fb6b170a9fdbdd$export$59dbbded7775bfe7 extends (0, $2vkKj.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $7BCLp.Typed).dereference(_value, "string");
        try {
            value = (0, $hbt3Q.getAddress)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $hbt3Q.getAddress)((0, $ltdtW.toBeHex)(reader.readValue(), 20));
    }
}

});
parcelRegister("7BCLp", function(module, exports) {

$parcel$export(module.exports, "Typed", function () { return $589a0ec6435e401c$export$af51273277efe223; });
/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
const $589a0ec6435e401c$var$_gaurd = {};
function $589a0ec6435e401c$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $589a0ec6435e401c$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $589a0ec6435e401c$var$_typedSymbol = Symbol.for("_ethers_typed");
class $589a0ec6435e401c$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $bCA3C.assertPrivate)($589a0ec6435e401c$var$_gaurd, gaurd, "Typed");
        (0, $b74mN.defineProperties)(this, {
            _typedSymbol: $589a0ec6435e401c$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $589a0ec6435e401c$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $589a0ec6435e401c$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $589a0ec6435e401c$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $589a0ec6435e401c$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $589a0ec6435e401c$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $589a0ec6435e401c$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $589a0ec6435e401c$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $589a0ec6435e401c$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $589a0ec6435e401c$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $589a0ec6435e401c$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $589a0ec6435e401c$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $589a0ec6435e401c$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $589a0ec6435e401c$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $589a0ec6435e401c$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $589a0ec6435e401c$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $589a0ec6435e401c$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $589a0ec6435e401c$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $589a0ec6435e401c$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $589a0ec6435e401c$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $589a0ec6435e401c$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $589a0ec6435e401c$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $589a0ec6435e401c$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $589a0ec6435e401c$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $589a0ec6435e401c$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $589a0ec6435e401c$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $589a0ec6435e401c$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $589a0ec6435e401c$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $589a0ec6435e401c$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $589a0ec6435e401c$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $589a0ec6435e401c$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $589a0ec6435e401c$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $589a0ec6435e401c$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $589a0ec6435e401c$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $589a0ec6435e401c$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $589a0ec6435e401c$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $589a0ec6435e401c$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $589a0ec6435e401c$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $589a0ec6435e401c$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $589a0ec6435e401c$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $589a0ec6435e401c$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $589a0ec6435e401c$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $589a0ec6435e401c$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $589a0ec6435e401c$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $589a0ec6435e401c$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $589a0ec6435e401c$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $589a0ec6435e401c$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $589a0ec6435e401c$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $589a0ec6435e401c$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $589a0ec6435e401c$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $589a0ec6435e401c$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $589a0ec6435e401c$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $589a0ec6435e401c$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $589a0ec6435e401c$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $589a0ec6435e401c$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $589a0ec6435e401c$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $589a0ec6435e401c$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $589a0ec6435e401c$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $589a0ec6435e401c$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $589a0ec6435e401c$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $589a0ec6435e401c$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $589a0ec6435e401c$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $589a0ec6435e401c$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $589a0ec6435e401c$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $589a0ec6435e401c$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $589a0ec6435e401c$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $589a0ec6435e401c$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $589a0ec6435e401c$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $589a0ec6435e401c$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $589a0ec6435e401c$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $589a0ec6435e401c$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $589a0ec6435e401c$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $589a0ec6435e401c$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $589a0ec6435e401c$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $589a0ec6435e401c$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $589a0ec6435e401c$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $589a0ec6435e401c$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $589a0ec6435e401c$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $589a0ec6435e401c$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $589a0ec6435e401c$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $589a0ec6435e401c$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $589a0ec6435e401c$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $589a0ec6435e401c$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $589a0ec6435e401c$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $589a0ec6435e401c$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $589a0ec6435e401c$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $589a0ec6435e401c$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $589a0ec6435e401c$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $589a0ec6435e401c$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $589a0ec6435e401c$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $589a0ec6435e401c$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $589a0ec6435e401c$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $589a0ec6435e401c$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $589a0ec6435e401c$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $589a0ec6435e401c$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $589a0ec6435e401c$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $589a0ec6435e401c$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $589a0ec6435e401c$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $589a0ec6435e401c$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $589a0ec6435e401c$export$af51273277efe223($589a0ec6435e401c$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $589a0ec6435e401c$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($589a0ec6435e401c$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}

});


parcelRegister("d2hVs", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $97d95df5b9fb0484$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $97d95df5b9fb0484$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $97d95df5b9fb0484$export$88bc419d2df11f54; });

var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");

var $7BCLp = parcelRequire("7BCLp");

var $2vkKj = parcelRequire("2vkKj");

var $76MhS = parcelRequire("76MhS");
function $97d95df5b9fb0484$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $bCA3C.assert)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $bCA3C.assert)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $bCA3C.assertArgument)(false, "invalid tuple value", "tuple", values);
    (0, $bCA3C.assertArgument)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $2vkKj.Writer)();
    let dynamicWriter = new (0, $2vkKj.Writer)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $97d95df5b9fb0484$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $bCA3C.isError)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $bCA3C.isError)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $2vkKj.Result).fromItems(values, keys);
}
class $97d95df5b9fb0484$export$88bc419d2df11f54 extends (0, $2vkKj.Coder) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $b74mN.defineProperties)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $7BCLp.Typed).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $bCA3C.assertArgumentCount)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $97d95df5b9fb0484$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $bCA3C.assert)(count * (0, $2vkKj.WordSize) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $2vkKj.WordSize),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $76MhS.AnonymousCoder)(this.coder));
        return $97d95df5b9fb0484$export$417857010dc9287f(reader, coders);
    }
}

});
parcelRegister("76MhS", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $52ce8ccf7f48dae8$export$87c41d1139a03fa2; });

var $2vkKj = parcelRequire("2vkKj");
class $52ce8ccf7f48dae8$export$87c41d1139a03fa2 extends (0, $2vkKj.Coder) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("1Xnoq", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $16cd727f4623355a$export$fe9118d6c093150c; });

var $7BCLp = parcelRequire("7BCLp");

var $2vkKj = parcelRequire("2vkKj");
class $16cd727f4623355a$export$fe9118d6c093150c extends (0, $2vkKj.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $7BCLp.Typed).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}

});

parcelRegister("3NuCv", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $2c3db339dcd09a73$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $2c3db339dcd09a73$export$e5823e9574df18d2; });

var $k39Yy = parcelRequire("k39Yy");

var $2vkKj = parcelRequire("2vkKj");
class $2c3db339dcd09a73$export$db9eadd8df12ad2e extends (0, $2vkKj.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $k39Yy.getBytesCopy)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $2c3db339dcd09a73$export$e5823e9574df18d2 extends $2c3db339dcd09a73$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $k39Yy.hexlify)(super.decode(reader));
    }
}

});

parcelRegister("9slDa", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $6e2781fb80947e2f$export$7dec9db68e6bcf5a; });

var $b74mN = parcelRequire("b74mN");
var $k39Yy = parcelRequire("k39Yy");

var $7BCLp = parcelRequire("7BCLp");

var $2vkKj = parcelRequire("2vkKj");
class $6e2781fb80947e2f$export$7dec9db68e6bcf5a extends (0, $2vkKj.Coder) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $b74mN.defineProperties)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $k39Yy.getBytesCopy)((0, $7BCLp.Typed).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $k39Yy.hexlify)(reader.readBytes(this.size));
    }
}

});

parcelRegister("3SVXk", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $2d435f1173bab81a$export$70982cadf2d6b4ec; });

var $2vkKj = parcelRequire("2vkKj");
const $2d435f1173bab81a$var$Empty = new Uint8Array([]);
class $2d435f1173bab81a$export$70982cadf2d6b4ec extends (0, $2vkKj.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($2d435f1173bab81a$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}

});

parcelRegister("bOJwi", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $89a7ac883013a1ff$export$b934dc8cfe13938c; });

var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");

var $7BCLp = parcelRequire("7BCLp");

var $2vkKj = parcelRequire("2vkKj");
const $89a7ac883013a1ff$var$BN_0 = BigInt(0);
const $89a7ac883013a1ff$var$BN_1 = BigInt(1);
const $89a7ac883013a1ff$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $89a7ac883013a1ff$export$b934dc8cfe13938c extends (0, $2vkKj.Coder) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $b74mN.defineProperties)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $ltdtW.getBigInt)((0, $7BCLp.Typed).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $ltdtW.mask)($89a7ac883013a1ff$var$BN_MAX_UINT256, (0, $2vkKj.WordSize) * 8);
        if (this.signed) {
            let bounds = (0, $ltdtW.mask)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $89a7ac883013a1ff$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $ltdtW.toTwos)(value, 8 * (0, $2vkKj.WordSize));
        } else if (value < $89a7ac883013a1ff$var$BN_0 || value > (0, $ltdtW.mask)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $ltdtW.mask)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $ltdtW.fromTwos)(value, this.size * 8);
        return value;
    }
}

});

parcelRegister("8hBXc", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $607d5a15ec66104d$export$2d1b854518731426; });

var $jhFUp = parcelRequire("jhFUp");

var $7BCLp = parcelRequire("7BCLp");

var $3NuCv = parcelRequire("3NuCv");
class $607d5a15ec66104d$export$2d1b854518731426 extends (0, $3NuCv.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $jhFUp.toUtf8Bytes)((0, $7BCLp.Typed).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $jhFUp.toUtf8String)(super.decode(reader));
    }
}

});
parcelRegister("jhFUp", function(module, exports) {

$parcel$export(module.exports, "toUtf8Bytes", function () { return $e0a01d0eea35351e$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "toUtf8String", function () { return $e0a01d0eea35351e$export$7643a1dc2c38d5eb; });
/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 
var $k39Yy = parcelRequire("k39Yy");

var $bCA3C = parcelRequire("bCA3C");
function $e0a01d0eea35351e$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $bCA3C.assertArgument)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $e0a01d0eea35351e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $e0a01d0eea35351e$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $bCA3C.assertArgument)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $e0a01d0eea35351e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $e0a01d0eea35351e$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $e0a01d0eea35351e$var$errorFunc,
    ignore: $e0a01d0eea35351e$var$ignoreFunc,
    replace: $e0a01d0eea35351e$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $e0a01d0eea35351e$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $e0a01d0eea35351e$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $k39Yy.getBytes)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $e0a01d0eea35351e$export$8feeb310b4b4752f(str, form) {
    (0, $bCA3C.assertArgument)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $bCA3C.assertNormalize)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $bCA3C.assertArgument)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $e0a01d0eea35351e$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $e0a01d0eea35351e$export$7643a1dc2c38d5eb(bytes, onError) {
    return $e0a01d0eea35351e$var$_toUtf8String($e0a01d0eea35351e$var$getUtf8CodePoints(bytes, onError));
}
function $e0a01d0eea35351e$export$ae470a36a31b28c2(str, form) {
    return $e0a01d0eea35351e$var$getUtf8CodePoints($e0a01d0eea35351e$export$8feeb310b4b4752f(str, form));
}

});


parcelRegister("8QPKU", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $671b53a22a7807ac$export$e9fceba8f110fea6; });

var $b74mN = parcelRequire("b74mN");

var $7BCLp = parcelRequire("7BCLp");

var $2vkKj = parcelRequire("2vkKj");

var $d2hVs = parcelRequire("d2hVs");
class $671b53a22a7807ac$export$e9fceba8f110fea6 extends (0, $2vkKj.Coder) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $b74mN.defineProperties)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $7BCLp.Typed).dereference(_value, "tuple");
        return (0, $d2hVs.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $d2hVs.unpack)(reader, this.coders);
    }
}

});

parcelRegister("1YicP", function(module, exports) {

$parcel$export(module.exports, "ParamType", function () { return $16f9845e6d058128$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $16f9845e6d058128$export$ffb0004e005737fa; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $16f9845e6d058128$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $16f9845e6d058128$export$2c42c6d543aa9b59; });
$parcel$export(module.exports, "EventFragment", function () { return $16f9845e6d058128$export$958548f08bac2833; });
$parcel$export(module.exports, "FunctionFragment", function () { return $16f9845e6d058128$export$8d576c928b93668f; });
/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 
var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");

var $3F7WM = parcelRequire("3F7WM");
// [ "a", "b" ] => { "a": 1, "b": 1 }
function $16f9845e6d058128$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $16f9845e6d058128$var$_kwVisibDeploy = "external public payable override";
const $16f9845e6d058128$var$KwVisibDeploy = $16f9845e6d058128$var$setify($16f9845e6d058128$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $16f9845e6d058128$var$_kwVisib = "constant external internal payable private public pure view override";
const $16f9845e6d058128$var$KwVisib = $16f9845e6d058128$var$setify($16f9845e6d058128$var$_kwVisib.split(" "));
const $16f9845e6d058128$var$_kwTypes = "constructor error event fallback function receive struct";
const $16f9845e6d058128$var$KwTypes = $16f9845e6d058128$var$setify($16f9845e6d058128$var$_kwTypes.split(" "));
const $16f9845e6d058128$var$_kwModifiers = "calldata memory storage payable indexed";
const $16f9845e6d058128$var$KwModifiers = $16f9845e6d058128$var$setify($16f9845e6d058128$var$_kwModifiers.split(" "));
const $16f9845e6d058128$var$_kwOther = "tuple returns";
// All Keywords
const $16f9845e6d058128$var$_keywords = [
    $16f9845e6d058128$var$_kwTypes,
    $16f9845e6d058128$var$_kwModifiers,
    $16f9845e6d058128$var$_kwOther,
    $16f9845e6d058128$var$_kwVisib
].join(" ");
const $16f9845e6d058128$var$Keywords = $16f9845e6d058128$var$setify($16f9845e6d058128$var$_keywords.split(" "));
// Single character tokens
const $16f9845e6d058128$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $16f9845e6d058128$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $16f9845e6d058128$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $16f9845e6d058128$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $16f9845e6d058128$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $16f9845e6d058128$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $16f9845e6d058128$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $16f9845e6d058128$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $16f9845e6d058128$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $16f9845e6d058128$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($16f9845e6d058128$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $16f9845e6d058128$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $ltdtW.getNumber)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($16f9845e6d058128$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($16f9845e6d058128$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($16f9845e6d058128$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($16f9845e6d058128$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $16f9845e6d058128$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $16f9845e6d058128$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $16f9845e6d058128$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($16f9845e6d058128$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $16f9845e6d058128$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $16f9845e6d058128$var$consumeMutability(tokens) {
    let modifiers = $16f9845e6d058128$var$consumeKeywords(tokens, $16f9845e6d058128$var$KwVisib);
    // Detect conflicting modifiers
    $16f9845e6d058128$var$allowSingle(modifiers, $16f9845e6d058128$var$setify("constant payable nonpayable".split(" ")));
    $16f9845e6d058128$var$allowSingle(modifiers, $16f9845e6d058128$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $16f9845e6d058128$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$16f9845e6d058128$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $16f9845e6d058128$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $ltdtW.getBigInt)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $16f9845e6d058128$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $16f9845e6d058128$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $16f9845e6d058128$var$verifyBasicType(type) {
    const match = type.match($16f9845e6d058128$var$regexType);
    (0, $bCA3C.assertArgument)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $bCA3C.assertArgument)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $bCA3C.assertArgument)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $16f9845e6d058128$var$_guard = {};
const $16f9845e6d058128$var$internal = Symbol.for("_ethers_internal");
const $16f9845e6d058128$var$ParamTypeInternal = "_ParamTypeInternal";
const $16f9845e6d058128$var$ErrorFragmentInternal = "_ErrorInternal";
const $16f9845e6d058128$var$EventFragmentInternal = "_EventInternal";
const $16f9845e6d058128$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $16f9845e6d058128$var$FallbackFragmentInternal = "_FallbackInternal";
const $16f9845e6d058128$var$FunctionFragmentInternal = "_FunctionInternal";
const $16f9845e6d058128$var$StructFragmentInternal = "_StructInternal";
class $16f9845e6d058128$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $bCA3C.assertPrivate)(guard, $16f9845e6d058128$var$_guard, "ParamType");
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $b74mN.defineProperties)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($16f9845e6d058128$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $16f9845e6d058128$export$426dc07f493a4c47.from($16f9845e6d058128$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $bCA3C.assertArgument)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$16f9845e6d058128$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $16f9845e6d058128$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $16f9845e6d058128$export$426dc07f493a4c47($16f9845e6d058128$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $16f9845e6d058128$export$426dc07f493a4c47($16f9845e6d058128$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $bCA3C.assertArgument)(!name || typeof name === "string" && name.match($16f9845e6d058128$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $bCA3C.assertArgument)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($16f9845e6d058128$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $16f9845e6d058128$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $16f9845e6d058128$export$426dc07f493a4c47($16f9845e6d058128$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$16f9845e6d058128$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $16f9845e6d058128$export$426dc07f493a4c47($16f9845e6d058128$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $16f9845e6d058128$var$verifyBasicType(obj.type);
        return new $16f9845e6d058128$export$426dc07f493a4c47($16f9845e6d058128$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$ParamTypeInternal;
    }
}
class $16f9845e6d058128$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $bCA3C.assertPrivate)(guard, $16f9845e6d058128$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $b74mN.defineProperties)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $16f9845e6d058128$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $16f9845e6d058128$export$ffb0004e005737fa.from($16f9845e6d058128$var$lex(obj));
        }
        if (obj instanceof $16f9845e6d058128$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($16f9845e6d058128$var$KwTypes);
            switch(type){
                case "constructor":
                    return $16f9845e6d058128$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $16f9845e6d058128$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $16f9845e6d058128$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $16f9845e6d058128$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $16f9845e6d058128$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $16f9845e6d058128$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $16f9845e6d058128$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $16f9845e6d058128$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $16f9845e6d058128$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $16f9845e6d058128$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $16f9845e6d058128$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $16f9845e6d058128$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $bCA3C.assert)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $bCA3C.assertArgument)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $16f9845e6d058128$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $16f9845e6d058128$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $16f9845e6d058128$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $16f9845e6d058128$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $16f9845e6d058128$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $16f9845e6d058128$export$85c6fc53d6299173 extends $16f9845e6d058128$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $bCA3C.assertArgument)(typeof name === "string" && name.match($16f9845e6d058128$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $b74mN.defineProperties)(this, {
            name: name
        });
    }
}
function $16f9845e6d058128$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $16f9845e6d058128$export$2c42c6d543aa9b59 extends $16f9845e6d058128$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $3F7WM.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $16f9845e6d058128$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($16f9845e6d058128$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $16f9845e6d058128$export$2c42c6d543aa9b59.from($16f9845e6d058128$var$lex(obj));
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            const name = $16f9845e6d058128$var$consumeName("error", obj);
            const inputs = $16f9845e6d058128$var$consumeParams(obj);
            $16f9845e6d058128$var$consumeEoi(obj);
            return new $16f9845e6d058128$export$2c42c6d543aa9b59($16f9845e6d058128$var$_guard, name, inputs);
        }
        return new $16f9845e6d058128$export$2c42c6d543aa9b59($16f9845e6d058128$var$_guard, obj.name, obj.inputs ? obj.inputs.map($16f9845e6d058128$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$ErrorFragmentInternal;
    }
}
class $16f9845e6d058128$export$958548f08bac2833 extends $16f9845e6d058128$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$EventFragmentInternal
        });
        (0, $b74mN.defineProperties)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $3F7WM.id)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $16f9845e6d058128$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$16f9845e6d058128$export$426dc07f493a4c47.from(p));
        const fragment = new $16f9845e6d058128$export$958548f08bac2833($16f9845e6d058128$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($16f9845e6d058128$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $16f9845e6d058128$export$958548f08bac2833.from($16f9845e6d058128$var$lex(obj));
        } catch (error) {
            (0, $bCA3C.assertArgument)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            const name = $16f9845e6d058128$var$consumeName("event", obj);
            const inputs = $16f9845e6d058128$var$consumeParams(obj, true);
            const anonymous = !!$16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$setify([
                "anonymous"
            ])).has("anonymous");
            $16f9845e6d058128$var$consumeEoi(obj);
            return new $16f9845e6d058128$export$958548f08bac2833($16f9845e6d058128$var$_guard, name, inputs, anonymous);
        }
        return new $16f9845e6d058128$export$958548f08bac2833($16f9845e6d058128$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$16f9845e6d058128$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$EventFragmentInternal;
    }
}
class $16f9845e6d058128$export$3ac5c9504f801ea4 extends $16f9845e6d058128$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$ConstructorFragmentInternal
        });
        (0, $b74mN.defineProperties)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $bCA3C.assert)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$16f9845e6d058128$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($16f9845e6d058128$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $16f9845e6d058128$export$3ac5c9504f801ea4.from($16f9845e6d058128$var$lex(obj));
        } catch (error) {
            (0, $bCA3C.assertArgument)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            $16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$setify([
                "constructor"
            ]));
            const inputs = $16f9845e6d058128$var$consumeParams(obj);
            const payable = !!$16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$KwVisibDeploy).has("payable");
            const gas = $16f9845e6d058128$var$consumeGas(obj);
            $16f9845e6d058128$var$consumeEoi(obj);
            return new $16f9845e6d058128$export$3ac5c9504f801ea4($16f9845e6d058128$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $16f9845e6d058128$export$3ac5c9504f801ea4($16f9845e6d058128$var$_guard, "constructor", obj.inputs ? obj.inputs.map($16f9845e6d058128$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$ConstructorFragmentInternal;
    }
}
class $16f9845e6d058128$export$71b1ea64c89c20fc extends $16f9845e6d058128$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$FallbackFragmentInternal
        });
        (0, $b74mN.defineProperties)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($16f9845e6d058128$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $16f9845e6d058128$export$71b1ea64c89c20fc.from($16f9845e6d058128$var$lex(obj));
        } catch (error) {
            (0, $bCA3C.assertArgument)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($16f9845e6d058128$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $bCA3C.assertArgument)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($16f9845e6d058128$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $16f9845e6d058128$var$consumeParams(obj);
                (0, $bCA3C.assertArgument)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$setify([
                    "payable"
                ]));
                $16f9845e6d058128$var$consumeEoi(obj);
                return new $16f9845e6d058128$export$71b1ea64c89c20fc($16f9845e6d058128$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $16f9845e6d058128$var$consumeParams(obj);
            if (inputs.length) (0, $bCA3C.assertArgument)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $16f9845e6d058128$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $16f9845e6d058128$var$consumeMutability(obj);
            (0, $bCA3C.assertArgument)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $16f9845e6d058128$var$consumeParams(obj);
                (0, $bCA3C.assertArgument)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $16f9845e6d058128$var$consumeEoi(obj);
            return new $16f9845e6d058128$export$71b1ea64c89c20fc($16f9845e6d058128$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $16f9845e6d058128$export$71b1ea64c89c20fc($16f9845e6d058128$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $16f9845e6d058128$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $16f9845e6d058128$export$71b1ea64c89c20fc($16f9845e6d058128$var$_guard, inputs, payable);
        }
        (0, $bCA3C.assertArgument)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$FallbackFragmentInternal;
    }
}
class $16f9845e6d058128$export$8d576c928b93668f extends $16f9845e6d058128$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $b74mN.defineProperties)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $3F7WM.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $16f9845e6d058128$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($16f9845e6d058128$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$16f9845e6d058128$export$426dc07f493a4c47.from(p));
        const fragment = new $16f9845e6d058128$export$8d576c928b93668f($16f9845e6d058128$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($16f9845e6d058128$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $16f9845e6d058128$export$8d576c928b93668f.from($16f9845e6d058128$var$lex(obj));
        } catch (error) {
            (0, $bCA3C.assertArgument)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            const name = $16f9845e6d058128$var$consumeName("function", obj);
            const inputs = $16f9845e6d058128$var$consumeParams(obj);
            const mutability = $16f9845e6d058128$var$consumeMutability(obj);
            let outputs = [];
            if ($16f9845e6d058128$var$consumeKeywords(obj, $16f9845e6d058128$var$setify([
                "returns"
            ])).has("returns")) outputs = $16f9845e6d058128$var$consumeParams(obj);
            const gas = $16f9845e6d058128$var$consumeGas(obj);
            $16f9845e6d058128$var$consumeEoi(obj);
            return new $16f9845e6d058128$export$8d576c928b93668f($16f9845e6d058128$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $16f9845e6d058128$export$8d576c928b93668f($16f9845e6d058128$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($16f9845e6d058128$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($16f9845e6d058128$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$FunctionFragmentInternal;
    }
}
class $16f9845e6d058128$export$9f91ba10bb234ec7 extends $16f9845e6d058128$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $16f9845e6d058128$var$internal, {
            value: $16f9845e6d058128$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $16f9845e6d058128$export$9f91ba10bb234ec7.from($16f9845e6d058128$var$lex(obj));
        } catch (error) {
            (0, $bCA3C.assertArgument)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $16f9845e6d058128$var$TokenString) {
            const name = $16f9845e6d058128$var$consumeName("struct", obj);
            const inputs = $16f9845e6d058128$var$consumeParams(obj);
            $16f9845e6d058128$var$consumeEoi(obj);
            return new $16f9845e6d058128$export$9f91ba10bb234ec7($16f9845e6d058128$var$_guard, name, inputs);
        }
        return new $16f9845e6d058128$export$9f91ba10bb234ec7($16f9845e6d058128$var$_guard, obj.name, obj.inputs ? obj.inputs.map($16f9845e6d058128$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$16f9845e6d058128$var$internal] === $16f9845e6d058128$var$StructFragmentInternal;
    }
}

});
parcelRegister("3F7WM", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $2aab5d93832e2724$export$d560c7e4a29451c2; });
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");

var $jhFUp = parcelRequire("jhFUp");
function $2aab5d93832e2724$export$d560c7e4a29451c2(value) {
    return (0, $eL5Ay.keccak256)((0, $jhFUp.toUtf8Bytes)(value));
}

});



parcelRegister("k9Aiw", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $eac0cde40a01f6e4$export$458ab927ae635c3; });
//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";

var $hbt3Q = parcelRequire("hbt3Q");
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");

var $26Tyr = parcelRequire("26Tyr");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");

var $3F7WM = parcelRequire("3F7WM");
const $eac0cde40a01f6e4$var$padding = new Uint8Array(32);
$eac0cde40a01f6e4$var$padding.fill(0);
const $eac0cde40a01f6e4$var$BN__1 = BigInt(-1);
const $eac0cde40a01f6e4$var$BN_0 = BigInt(0);
const $eac0cde40a01f6e4$var$BN_1 = BigInt(1);
const $eac0cde40a01f6e4$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $eac0cde40a01f6e4$var$hexPadRight(value) {
    const bytes = (0, $k39Yy.getBytes)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $k39Yy.concat)([
        bytes,
        $eac0cde40a01f6e4$var$padding.slice(padOffset)
    ]);
    return (0, $k39Yy.hexlify)(bytes);
}
const $eac0cde40a01f6e4$var$hexTrue = (0, $ltdtW.toBeHex)($eac0cde40a01f6e4$var$BN_1, 32);
const $eac0cde40a01f6e4$var$hexFalse = (0, $ltdtW.toBeHex)($eac0cde40a01f6e4$var$BN_0, 32);
const $eac0cde40a01f6e4$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $eac0cde40a01f6e4$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $eac0cde40a01f6e4$var$checkString(key) {
    return function(value) {
        (0, $bCA3C.assertArgument)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $eac0cde40a01f6e4$var$domainChecks = {
    name: $eac0cde40a01f6e4$var$checkString("name"),
    version: $eac0cde40a01f6e4$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $ltdtW.getBigInt)(_value, "domain.chainId");
        (0, $bCA3C.assertArgument)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $ltdtW.toQuantity)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $hbt3Q.getAddress)(value).toLowerCase();
        } catch (error) {}
        (0, $bCA3C.assertArgument)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $k39Yy.getBytes)(value, "domain.salt");
        (0, $bCA3C.assertArgument)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $k39Yy.hexlify)(bytes);
    }
};
function $eac0cde40a01f6e4$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $bCA3C.assertArgument)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $ltdtW.mask)($eac0cde40a01f6e4$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $eac0cde40a01f6e4$var$BN_1) * $eac0cde40a01f6e4$var$BN__1 : $eac0cde40a01f6e4$var$BN_0;
            return function(_value) {
                const value = (0, $ltdtW.getBigInt)(_value, "value");
                (0, $bCA3C.assertArgument)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $ltdtW.toBeHex)(signed ? (0, $ltdtW.toTwos)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $bCA3C.assertArgument)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $k39Yy.getBytes)(value);
                (0, $bCA3C.assertArgument)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $eac0cde40a01f6e4$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $k39Yy.zeroPadValue)((0, $hbt3Q.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $eac0cde40a01f6e4$var$hexFalse : $eac0cde40a01f6e4$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $eL5Ay.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $3F7WM.id)(value);
            };
    }
    return null;
}
function $eac0cde40a01f6e4$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $eac0cde40a01f6e4$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $eac0cde40a01f6e4$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $eac0cde40a01f6e4$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $bCA3C.assertArgument)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $eac0cde40a01f6e4$var$splitArray(field.type).base;
                (0, $bCA3C.assertArgument)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $eac0cde40a01f6e4$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $bCA3C.assertArgument)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $bCA3C.assertArgument)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $bCA3C.assertArgument)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $b74mN.defineProperties)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $bCA3C.assertArgument)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $eac0cde40a01f6e4$var$encodeType(name, types[name]) + st.map((t)=>$eac0cde40a01f6e4$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $eac0cde40a01f6e4$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $eac0cde40a01f6e4$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $bCA3C.assertArgument)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $eL5Ay.keccak256));
                return (0, $eL5Ay.keccak256)((0, $k39Yy.concat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $3F7WM.id)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $eL5Ay.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $k39Yy.concat)(values);
            };
        }
        (0, $bCA3C.assertArgument)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $bCA3C.assertArgument)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $eL5Ay.keccak256)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $eac0cde40a01f6e4$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $eac0cde40a01f6e4$var$splitArray(type).array;
        if (array) {
            (0, $bCA3C.assertArgument)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $bCA3C.assertArgument)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $eac0cde40a01f6e4$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $eac0cde40a01f6e4$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $eac0cde40a01f6e4$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $eac0cde40a01f6e4$var$domainFieldTypes[name];
            (0, $bCA3C.assertArgument)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $eac0cde40a01f6e4$var$domainFieldNames.indexOf(a.name) - $eac0cde40a01f6e4$var$domainFieldNames.indexOf(b.name);
        });
        return $eac0cde40a01f6e4$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $k39Yy.concat)([
            "0x1901",
            $eac0cde40a01f6e4$export$458ab927ae635c3.hashDomain(domain),
            $eac0cde40a01f6e4$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $eL5Ay.keccak256)($eac0cde40a01f6e4$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $k39Yy.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $eac0cde40a01f6e4$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $k39Yy.isHexString)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $eac0cde40a01f6e4$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $eac0cde40a01f6e4$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $eac0cde40a01f6e4$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $eac0cde40a01f6e4$var$domainFieldTypes[name]
            });
        });
        const encoder = $eac0cde40a01f6e4$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $bCA3C.assertArgument)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $k39Yy.hexlify)((0, $k39Yy.getBytes)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $ltdtW.getBigInt)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $bCA3C.assertArgument)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $bCA3C.assertArgument)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $eac0cde40a01f6e4$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $26Tyr.recoverAddress)($eac0cde40a01f6e4$export$458ab927ae635c3.hash(domain, types, value), signature);
}

});
parcelRegister("26Tyr", function(module, exports) {

$parcel$export(module.exports, "recoverAddress", function () { return $18973c4905536796$export$23cc18f96d8510e2; });

var $hbt3Q = parcelRequire("hbt3Q");
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");
var $hgbdt = parcelRequire("hgbdt");
function $18973c4905536796$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $hgbdt.SigningKey).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $hbt3Q.getAddress)((0, $eL5Ay.keccak256)("0x" + pubkey.substring(4)).substring(26));
}
function $18973c4905536796$export$23cc18f96d8510e2(digest, signature) {
    return $18973c4905536796$export$e67e2732ba9803f9((0, $hgbdt.SigningKey).recoverPublicKey(digest, signature));
}

});


parcelRegister("7E40U", function(module, exports) {

$parcel$export(module.exports, "accessListify", function () { return $590f61db8880ae6e$export$6c8662b1600dce2; });

var $hbt3Q = parcelRequire("hbt3Q");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
function $590f61db8880ae6e$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $hbt3Q.getAddress)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $590f61db8880ae6e$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $bCA3C.assertArgument)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $590f61db8880ae6e$var$accessSetify(set[0], set[1]);
        }
        (0, $bCA3C.assertArgument)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $590f61db8880ae6e$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $bCA3C.assertArgument)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $590f61db8880ae6e$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}

});

parcelRegister("9b9xw", function(module, exports) {

$parcel$export(module.exports, "FetchRequest", function () { return $6aec8a800d2f8f38$export$319b96fe59834522; });
/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ 
var $indpU = parcelRequire("indpU");

var $k39Yy = parcelRequire("k39Yy");

var $bCA3C = parcelRequire("bCA3C");

var $b74mN = parcelRequire("b74mN");

var $jhFUp = parcelRequire("jhFUp");

var $ktDdi = parcelRequire("ktDdi");
const $6aec8a800d2f8f38$var$MAX_ATTEMPTS = 12;
const $6aec8a800d2f8f38$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $6aec8a800d2f8f38$var$defaultGetUrlFunc = (0, $ktDdi.createGetUrl)();
const $6aec8a800d2f8f38$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $6aec8a800d2f8f38$var$reIpfs = new RegExp("^ipfs:/\/(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $6aec8a800d2f8f38$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $6aec8a800d2f8f38$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($6aec8a800d2f8f38$var$reData);
        if (!match) throw new Error("invalid data");
        return new $6aec8a800d2f8f38$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $indpU.decodeBase64)(match[3]) : $6aec8a800d2f8f38$var$unpercent(match[3]));
    } catch (error) {
        return new $6aec8a800d2f8f38$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $6aec8a800d2f8f38$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $6aec8a800d2f8f38$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($6aec8a800d2f8f38$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $6aec8a800d2f8f38$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $6aec8a800d2f8f38$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $6aec8a800d2f8f38$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $6aec8a800d2f8f38$var$Gateways = {
    "data": $6aec8a800d2f8f38$var$dataGatewayFunc,
    "ipfs": $6aec8a800d2f8f38$var$getIpfsGatewayFunc("https:/\/gateway.ipfs.io/ipfs/")
};
const $6aec8a800d2f8f38$var$fetchSignals = new WeakMap();
class $6aec8a800d2f8f38$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $6aec8a800d2f8f38$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $bCA3C.assert)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $bCA3C.assert)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $6aec8a800d2f8f38$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $6aec8a800d2f8f38$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $jhFUp.toUtf8Bytes)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $jhFUp.toUtf8Bytes)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $indpU.encodeBase64)((0, $jhFUp.toUtf8Bytes)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $bCA3C.assertArgument)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $bCA3C.assertArgument)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $6aec8a800d2f8f38$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $6aec8a800d2f8f38$var$SLOT_INTERVAL,
            maxAttempts: $6aec8a800d2f8f38$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $k39Yy.hexlify)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $bCA3C.assert)($6aec8a800d2f8f38$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $6aec8a800d2f8f38$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $6aec8a800d2f8f38$var$Gateways) {
            const result = await $6aec8a800d2f8f38$var$Gateways[scheme](req.url, $6aec8a800d2f8f38$var$checkSignal(_request.#signal));
            if (result instanceof $6aec8a800d2f8f38$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $6aec8a800d2f8f38$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $6aec8a800d2f8f38$var$checkSignal(_request.#signal));
        let response = new $6aec8a800d2f8f38$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $6aec8a800d2f8f38$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $bCA3C.assert)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $6aec8a800d2f8f38$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $6aec8a800d2f8f38$var$getTime() + this.timeout, 0, this, new $6aec8a800d2f8f38$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $bCA3C.assert)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $6aec8a800d2f8f38$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $bCA3C.assert)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $6aec8a800d2f8f38$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $6aec8a800d2f8f38$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#throttle = Object.assign({}, this.#throttle);
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $6aec8a800d2f8f38$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $6aec8a800d2f8f38$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($6aec8a800d2f8f38$var$locked) throw new Error("gateways locked");
        $6aec8a800d2f8f38$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($6aec8a800d2f8f38$var$locked) throw new Error("gateways locked");
        $6aec8a800d2f8f38$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $ktDdi.createGetUrl)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $6aec8a800d2f8f38$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $6aec8a800d2f8f38$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $6aec8a800d2f8f38$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $k39Yy.hexlify)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $jhFUp.toUtf8String)(this.#body);
        } catch (error) {
            (0, $bCA3C.assert)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $bCA3C.assert)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $6aec8a800d2f8f38$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $bCA3C.assertArgument)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $b74mN.defineProperties)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $jhFUp.toUtf8String)(this.#body);
        } catch (e) {}
        (0, $bCA3C.assert)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $6aec8a800d2f8f38$var$getTime() {
    return new Date().getTime();
}
function $6aec8a800d2f8f38$var$unpercent(value) {
    return (0, $jhFUp.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $6aec8a800d2f8f38$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}

});
parcelRegister("indpU", function(module, exports) {

$parcel$export(module.exports, "decodeBase64", function () { return $d604c84bb44d1454$export$94fdf11bafc8de6b; });
$parcel$export(module.exports, "encodeBase64", function () { return $d604c84bb44d1454$export$8fb536984ec8b4d7; });
// utils/base64-browser

var $k39Yy = parcelRequire("k39Yy");
function $d604c84bb44d1454$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $k39Yy.getBytes)(data);
}
function $d604c84bb44d1454$export$8fb536984ec8b4d7(_data) {
    const data = (0, $k39Yy.getBytes)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});

parcelRegister("ktDdi", function(module, exports) {

$parcel$export(module.exports, "createGetUrl", function () { return $ee84ef101a3d1fe6$export$d3950daf7bce5bf5; });

var $bCA3C = parcelRequire("bCA3C");
function $ee84ef101a3d1fe6$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        (0, $bCA3C.assert)(_signal == null || !_signal.cancelled, "request cancelled before sending", "CANCELLED");
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $bCA3C.assert)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $bCA3C.assert)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let error = null;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            error = (0, $bCA3C.makeError)("request timeout", "TIMEOUT");
            controller.abort();
        }, req.timeout);
        if (_signal) _signal.addListener(()=>{
            error = (0, $bCA3C.makeError)("request cancelled", "CANCELLED");
            controller.abort();
        });
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: controller.signal
        };
        let resp;
        try {
            resp = await fetch(req.url, init);
        } catch (_error) {
            clearTimeout(timer);
            if (error) throw error;
            throw _error;
        }
        clearTimeout(timer);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $ee84ef101a3d1fe6$var$defaultGetUrl = $ee84ef101a3d1fe6$export$d3950daf7bce5bf5({});
async function $ee84ef101a3d1fe6$export$94df0e59ebebf4a7(req, _signal) {
    return $ee84ef101a3d1fe6$var$defaultGetUrl(req, _signal);
}

});


parcelRegister("62vB8", function(module, exports) {

$parcel$export(module.exports, "UnmanagedSubscriber", function () { return $465b70ad31ccaed2$export$f255b979f86248fa; });
$parcel$export(module.exports, "AbstractProvider", function () { return $465b70ad31ccaed2$export$ae9650e85fb229fe; });
/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

var $hbt3Q = parcelRequire("hbt3Q");
var $9XxdG = parcelRequire("9XxdG");

var $dHvt6 = parcelRequire("dHvt6");

var $9sbiK = parcelRequire("9sbiK");

var $4rnT5 = parcelRequire("4rnT5");

var $df9mn = parcelRequire("df9mn");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $b74mN = parcelRequire("b74mN");
var $3vWS7 = parcelRequire("3vWS7");
var $9b9xw = parcelRequire("9b9xw");
var $ltdtW = parcelRequire("ltdtW");
var $jhFUp = parcelRequire("jhFUp");

var $4nyFX = parcelRequire("4nyFX");

var $2TJj4 = parcelRequire("2TJj4");

var $crad7 = parcelRequire("crad7");

var $7EGwX = parcelRequire("7EGwX");

var $dgf09 = parcelRequire("dgf09");
// Constants
const $465b70ad31ccaed2$var$BN_2 = BigInt(2);
const $465b70ad31ccaed2$var$MAX_CCIP_REDIRECTS = 10;
function $465b70ad31ccaed2$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $465b70ad31ccaed2$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $465b70ad31ccaed2$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $b74mN.defineProperties)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $465b70ad31ccaed2$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $465b70ad31ccaed2$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $465b70ad31ccaed2$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $k39Yy.isHexString)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $465b70ad31ccaed2$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $465b70ad31ccaed2$var$getTag("orphan", event),
            filter: $465b70ad31ccaed2$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $465b70ad31ccaed2$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $k39Yy.isHexString)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $9XxdG.resolveAddress)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $465b70ad31ccaed2$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $465b70ad31ccaed2$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $bCA3C.assertArgument)(false, "unknown ProviderEvent", "event", _event);
}
function $465b70ad31ccaed2$var$getTime() {
    return new Date().getTime();
}
const $465b70ad31ccaed2$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $465b70ad31ccaed2$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $465b70ad31ccaed2$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $crad7.Network).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $465b70ad31ccaed2$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $9b9xw.FetchRequest)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $bCA3C.assert)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $bCA3C.assert)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $7EGwX.Block)((0, $2TJj4.formatBlock)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $7EGwX.Log)((0, $2TJj4.formatLog)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $7EGwX.TransactionReceipt)((0, $2TJj4.formatTransactionReceipt)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $7EGwX.TransactionResponse)((0, $2TJj4.formatTransactionResponse)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $bCA3C.assert)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $bCA3C.assert)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $ltdtW.getNumber)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $9XxdG.resolveAddress)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $k39Yy.isHexString)(blockTag)) {
            if ((0, $k39Yy.isHexString)(blockTag, 32)) return blockTag;
            return (0, $ltdtW.toQuantity)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $ltdtW.getNumber)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $ltdtW.toQuantity)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $ltdtW.toQuantity)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $ltdtW.toQuantity)(b + blockTag));
        }
        (0, $bCA3C.assertArgument)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $465b70ad31ccaed2$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $7EGwX.copyRequest)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $9XxdG.resolveAddress)(request[key], this);
            if ($465b70ad31ccaed2$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($465b70ad31ccaed2$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $bCA3C.assert)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $b74mN.resolveProperties)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $ltdtW.getBigInt)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $ltdtW.getBigInt)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $465b70ad31ccaed2$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $7EGwX.FeeData)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $9b9xw.FetchRequest)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $7EGwX.FeeData)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($465b70ad31ccaed2$var$isPromise(tx)) tx = await tx;
        return (0, $ltdtW.getBigInt)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $bCA3C.assert)(attempt < $465b70ad31ccaed2$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $7EGwX.copyRequest)(tx);
        try {
            return (0, $k39Yy.hexlify)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $bCA3C.isCallException)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $k39Yy.dataSlice)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $9XxdG.resolveAddress)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $465b70ad31ccaed2$var$parseOffchainLookup((0, $k39Yy.dataSlice)(error.data, 4));
                } catch (error) {
                    (0, $bCA3C.assert)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $bCA3C.assert)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $bCA3C.assert)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $k39Yy.concat)([
                        ccipArgs.selector,
                        $465b70ad31ccaed2$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $b74mN.resolveProperties)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $ltdtW.getBigInt)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $ltdtW.getNumber)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $k39Yy.hexlify)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $ltdtW.getBigInt)(_position, "position");
        return (0, $k39Yy.hexlify)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $b74mN.resolveProperties)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $df9mn.Transaction).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $k39Yy.isHexString)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $k39Yy.hexlify)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($465b70ad31ccaed2$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $b74mN.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $bCA3C.assert)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $4nyFX.EnsResolver).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $hbt3Q.getAddress)(address);
        const node = (0, $4rnT5.namehash)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $4nyFX.EnsResolver).getEnsAddress(this);
            const ensContract = new (0, $9sbiK.Contract)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $dHvt6.ZeroAddress)) return null;
            const resolverContract = new (0, $9sbiK.Contract)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $bCA3C.isError)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $bCA3C.isError)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $bCA3C.makeError)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $bCA3C.assert)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $465b70ad31ccaed2$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $465b70ad31ccaed2$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $dgf09.PollingBlockSubscriber)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $dgf09.PollingBlockTagSubscriber)(this, sub.type);
            case "event":
                return new (0, $dgf09.PollingEventSubscriber)(this, sub.filter);
            case "transaction":
                return new (0, $dgf09.PollingTransactionSubscriber)(this, sub.hash);
            case "orphan":
                return new (0, $dgf09.PollingOrphanSubscriber)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $465b70ad31ccaed2$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $465b70ad31ccaed2$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $465b70ad31ccaed2$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $3vWS7.EventPayload)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $bCA3C.assert)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $465b70ad31ccaed2$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $465b70ad31ccaed2$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $465b70ad31ccaed2$var$_parseString(result, start) {
    try {
        const bytes = $465b70ad31ccaed2$var$_parseBytes(result, start);
        if (bytes) return (0, $jhFUp.toUtf8String)(bytes);
    } catch (error) {}
    return null;
}
function $465b70ad31ccaed2$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $ltdtW.getNumber)((0, $k39Yy.dataSlice)(result, start, start + 32));
        const length = (0, $ltdtW.getNumber)((0, $k39Yy.dataSlice)(result, offset, offset + 32));
        return (0, $k39Yy.dataSlice)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $465b70ad31ccaed2$var$numPad(value) {
    const result = (0, $ltdtW.toBeArray)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $465b70ad31ccaed2$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $465b70ad31ccaed2$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $465b70ad31ccaed2$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($465b70ad31ccaed2$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $k39Yy.getBytes)(datas[i]);
        // Update the bytes offset
        result[i] = $465b70ad31ccaed2$var$numPad(byteCount);
        // The length and padded value of data
        result.push($465b70ad31ccaed2$var$numPad(data.length));
        result.push($465b70ad31ccaed2$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $k39Yy.concat)(result);
}
const $465b70ad31ccaed2$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $465b70ad31ccaed2$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $bCA3C.assert)((0, $k39Yy.dataLength)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $k39Yy.dataSlice)(data, 0, 32);
    (0, $bCA3C.assert)((0, $k39Yy.dataSlice)(sender, 0, 12) === (0, $k39Yy.dataSlice)($465b70ad31ccaed2$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $k39Yy.dataSlice)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $ltdtW.getNumber)((0, $k39Yy.dataSlice)(data, 32, 64));
        const urlsLength = (0, $ltdtW.getNumber)((0, $k39Yy.dataSlice)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $k39Yy.dataSlice)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $465b70ad31ccaed2$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $bCA3C.assert)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $465b70ad31ccaed2$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $bCA3C.assert)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $bCA3C.assert)((0, $k39Yy.dataSlice)(data, 100, 128) === (0, $k39Yy.dataSlice)($465b70ad31ccaed2$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $k39Yy.dataSlice)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $465b70ad31ccaed2$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $bCA3C.assert)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}

});
parcelRegister("dHvt6", function(module, exports) {

$parcel$export(module.exports, "ZeroAddress", function () { return $9f97b37c1fe4d2f7$export$b7cbe423ba83da17; });
/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $9f97b37c1fe4d2f7$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("9sbiK", function(module, exports) {

$parcel$export(module.exports, "Contract", function () { return $6e1f7ece0fdd2a3b$export$8517d80acf00e19a; });

var $6IqbN = parcelRequire("6IqbN");
var $7BCLp = parcelRequire("7BCLp");

var $9XxdG = parcelRequire("9XxdG");

var $7EGwX = parcelRequire("7EGwX");

var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");
var $k39Yy = parcelRequire("k39Yy");

var $3LPZK = parcelRequire("3LPZK");
const $6e1f7ece0fdd2a3b$var$BN_0 = BigInt(0);
function $6e1f7ece0fdd2a3b$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $6e1f7ece0fdd2a3b$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $6e1f7ece0fdd2a3b$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $6e1f7ece0fdd2a3b$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $6e1f7ece0fdd2a3b$var$getResolver(value) {
    if (value != null) {
        if ($6e1f7ece0fdd2a3b$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $6e1f7ece0fdd2a3b$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $b74mN.defineProperties)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $6e1f7ece0fdd2a3b$var$getRunner(contract.runner, "resolveName");
        const resolver = $6e1f7ece0fdd2a3b$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $9XxdG.resolveAddress)(v, resolver)));
                        return (0, $9XxdG.resolveAddress)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $6e1f7ece0fdd2a3b$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $6e1f7ece0fdd2a3b$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $6e1f7ece0fdd2a3b$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $7BCLp.Typed).dereference(arg, "overrides");
    (0, $bCA3C.assertArgument)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $7EGwX.copyRequest)(_overrides);
    (0, $bCA3C.assertArgument)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $bCA3C.assertArgument)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $6e1f7ece0fdd2a3b$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $6e1f7ece0fdd2a3b$var$getRunner(_runner, "resolveName");
    const resolver = $6e1f7ece0fdd2a3b$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $7BCLp.Typed).dereference(value, type);
            if (type === "address") return (0, $9XxdG.resolveAddress)(value, resolver);
            return value;
        });
    }));
}
function $6e1f7ece0fdd2a3b$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $6e1f7ece0fdd2a3b$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $9XxdG.resolveAddress)(tx.from, $6e1f7ece0fdd2a3b$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $ltdtW.getBigInt)(tx.value || $6e1f7ece0fdd2a3b$var$BN_0, "overrides.value") === $6e1f7ece0fdd2a3b$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $bCA3C.assertArgument)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $bCA3C.assertArgument)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $bCA3C.assertArgument)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $bCA3C.assertArgument)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $6e1f7ece0fdd2a3b$var$getRunner(contract.runner, "call");
        (0, $bCA3C.assert)($6e1f7ece0fdd2a3b$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $bCA3C.isCallException)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $bCA3C.assert)($6e1f7ece0fdd2a3b$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $6e1f7ece0fdd2a3b$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $3LPZK.ContractTransactionResponse)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $6e1f7ece0fdd2a3b$var$getRunner(contract.runner, "estimateGas");
        (0, $bCA3C.assert)($6e1f7ece0fdd2a3b$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $b74mN.defineProperties)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $6e1f7ece0fdd2a3b$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $bCA3C.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $6e1f7ece0fdd2a3b$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $9XxdG.resolveAddress)(overrides.from, $6e1f7ece0fdd2a3b$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $6e1f7ece0fdd2a3b$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $b74mN.resolveProperties)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $bCA3C.assert)($6e1f7ece0fdd2a3b$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $6e1f7ece0fdd2a3b$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $3LPZK.ContractTransactionResponse)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $6e1f7ece0fdd2a3b$var$getRunner(contract.runner, "estimateGas");
        (0, $bCA3C.assert)($6e1f7ece0fdd2a3b$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $6e1f7ece0fdd2a3b$var$getRunner(contract.runner, "call");
        (0, $bCA3C.assert)($6e1f7ece0fdd2a3b$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $bCA3C.isCallException)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $b74mN.defineProperties)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $bCA3C.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $6e1f7ece0fdd2a3b$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $bCA3C.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $6e1f7ece0fdd2a3b$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $b74mN.defineProperties)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $bCA3C.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $6e1f7ece0fdd2a3b$var$internal = Symbol.for("_ethersInternal_contract");
const $6e1f7ece0fdd2a3b$var$internalValues = new WeakMap();
function $6e1f7ece0fdd2a3b$var$setInternal(contract, values) {
    $6e1f7ece0fdd2a3b$var$internalValues.set(contract[$6e1f7ece0fdd2a3b$var$internal], values);
}
function $6e1f7ece0fdd2a3b$var$getInternal(contract) {
    return $6e1f7ece0fdd2a3b$var$internalValues.get(contract[$6e1f7ece0fdd2a3b$var$internal]);
}
function $6e1f7ece0fdd2a3b$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $6e1f7ece0fdd2a3b$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $k39Yy.isHexString)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $bCA3C.assertArgument)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $k39Yy.isHexString)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $bCA3C.assertArgument)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($6e1f7ece0fdd2a3b$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $bCA3C.assertArgument)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $6e1f7ece0fdd2a3b$var$hasSub(contract, event) {
    const { subs: subs } = $6e1f7ece0fdd2a3b$var$getInternal(contract);
    return subs.get((await $6e1f7ece0fdd2a3b$var$getSubInfo(contract, event)).tag) || null;
}
async function $6e1f7ece0fdd2a3b$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $6e1f7ece0fdd2a3b$var$getProvider(contract.runner);
    (0, $bCA3C.assert)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $6e1f7ece0fdd2a3b$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $6e1f7ece0fdd2a3b$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $6e1f7ece0fdd2a3b$var$emit(contract, event, args, (listener)=>{
                    return new (0, $3LPZK.ContractEventPayload)(contract, listener, event, _foundFragment, log);
                });
            } else $6e1f7ece0fdd2a3b$var$emit(contract, event, [], (listener)=>{
                return new (0, $3LPZK.ContractUnknownEventPayload)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $6e1f7ece0fdd2a3b$var$lastEmit = Promise.resolve();
async function $6e1f7ece0fdd2a3b$var$_emit(contract, event, args, payloadFunc) {
    await $6e1f7ece0fdd2a3b$var$lastEmit;
    const sub = await $6e1f7ece0fdd2a3b$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $6e1f7ece0fdd2a3b$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $6e1f7ece0fdd2a3b$var$emit(contract, event, args, payloadFunc) {
    try {
        await $6e1f7ece0fdd2a3b$var$lastEmit;
    } catch (error) {}
    const resultPromise = $6e1f7ece0fdd2a3b$var$_emit(contract, event, args, payloadFunc);
    $6e1f7ece0fdd2a3b$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $6e1f7ece0fdd2a3b$var$passProperties = [
    "then"
];
class $6e1f7ece0fdd2a3b$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$6e1f7ece0fdd2a3b$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $bCA3C.assertArgument)(typeof target === "string" || (0, $9XxdG.isAddressable)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $6IqbN.Interface).from(abi);
        (0, $b74mN.defineProperties)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $6e1f7ece0fdd2a3b$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $6e1f7ece0fdd2a3b$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $3LPZK.ContractTransactionResponse)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $k39Yy.isHexString)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $6e1f7ece0fdd2a3b$var$getRunner(runner, "resolveName");
                if (!$6e1f7ece0fdd2a3b$var$canResolve(resolver)) throw (0, $bCA3C.makeError)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $bCA3C.makeError)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $6e1f7ece0fdd2a3b$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $6e1f7ece0fdd2a3b$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $6e1f7ece0fdd2a3b$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $6e1f7ece0fdd2a3b$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $bCA3C.isError)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($6e1f7ece0fdd2a3b$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $b74mN.defineProperties)(this, {
            filters: filters
        });
        (0, $b74mN.defineProperties)(this, {
            fallback: iface.receive || iface.fallback ? $6e1f7ece0fdd2a3b$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $6e1f7ece0fdd2a3b$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $bCA3C.isError)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $6e1f7ece0fdd2a3b$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $6e1f7ece0fdd2a3b$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $6e1f7ece0fdd2a3b$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $6e1f7ece0fdd2a3b$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $6e1f7ece0fdd2a3b$var$getProvider(this.runner);
        (0, $bCA3C.assert)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $6e1f7ece0fdd2a3b$var$getProvider(this.runner);
        (0, $bCA3C.assert)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $6e1f7ece0fdd2a3b$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $6e1f7ece0fdd2a3b$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $6e1f7ece0fdd2a3b$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $6e1f7ece0fdd2a3b$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $6e1f7ece0fdd2a3b$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $6e1f7ece0fdd2a3b$var$getProvider(this.runner);
        (0, $bCA3C.assert)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $3LPZK.EventLog)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $3LPZK.UndecodedEventLog)(log, error);
            }
            return new (0, $7EGwX.Log)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $6e1f7ece0fdd2a3b$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $6e1f7ece0fdd2a3b$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $6e1f7ece0fdd2a3b$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $6e1f7ece0fdd2a3b$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $6e1f7ece0fdd2a3b$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $6e1f7ece0fdd2a3b$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $6e1f7ece0fdd2a3b$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $6e1f7ece0fdd2a3b$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $6e1f7ece0fdd2a3b$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $6e1f7ece0fdd2a3b$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $6e1f7ece0fdd2a3b$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $6e1f7ece0fdd2a3b$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $6e1f7ece0fdd2a3b$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $6e1f7ece0fdd2a3b$var$_ContractBase() {
    return $6e1f7ece0fdd2a3b$export$304faa4fc17528db;
}
class $6e1f7ece0fdd2a3b$export$8517d80acf00e19a extends $6e1f7ece0fdd2a3b$var$_ContractBase() {
}

});
parcelRegister("6IqbN", function(module, exports) {

$parcel$export(module.exports, "Interface", function () { return $4e3b2ac423c72dbb$export$48cefb51a4e315b2; });
/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");

var $3F7WM = parcelRequire("3F7WM");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");

var $2rFFi = parcelRequire("2rFFi");

var $2vkKj = parcelRequire("2vkKj");

var $1YicP = parcelRequire("1YicP");

var $7BCLp = parcelRequire("7BCLp");
class $4e3b2ac423c72dbb$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $b74mN.defineProperties)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $4e3b2ac423c72dbb$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $b74mN.defineProperties)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $4e3b2ac423c72dbb$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $b74mN.defineProperties)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $4e3b2ac423c72dbb$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $b74mN.defineProperties)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $4e3b2ac423c72dbb$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $4e3b2ac423c72dbb$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $4e3b2ac423c72dbb$var$PanicReasons[code.toString()]) reason = $4e3b2ac423c72dbb$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $4e3b2ac423c72dbb$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $1YicP.Fragment).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $b74mN.defineProperties)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $b74mN.defineProperties)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $bCA3C.assertArgument)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $b74mN.defineProperties)(this, {
            deploy: (0, $1YicP.ConstructorFragment).from("constructor()")
        });
        (0, $b74mN.defineProperties)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $2rFFi.AbiCoder).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $k39Yy.isHexString)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $7BCLp.Typed).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $7BCLp.Typed).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $bCA3C.assertArgument)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $1YicP.FunctionFragment).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $bCA3C.assertArgument)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $k39Yy.isHexString)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $7BCLp.Typed).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $bCA3C.assertArgument)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $1YicP.EventFragment).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $bCA3C.assertArgument)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $k39Yy.isHexString)(key)) {
            const selector = key.toLowerCase();
            if ($4e3b2ac423c72dbb$var$BuiltinErrors[selector]) return (0, $1YicP.ErrorFragment).from($4e3b2ac423c72dbb$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $1YicP.ErrorFragment).from("error Error(string)");
                if (key === "Panic") return (0, $1YicP.ErrorFragment).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $bCA3C.assertArgument)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $1YicP.ErrorFragment).from(key).format();
        if (key === "Error(string)") return (0, $1YicP.ErrorFragment).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $1YicP.ErrorFragment).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataSlice)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $k39Yy.dataSlice)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $k39Yy.concat)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $bCA3C.assertArgument)((0, $k39Yy.dataSlice)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $k39Yy.dataSlice)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $k39Yy.concat)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $k39Yy.getBytesCopy)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $bCA3C.assert)(false, message, "BAD_DATA", {
            value: (0, $k39Yy.hexlify)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $k39Yy.getBytes)(_data, "data");
        const error = (0, $2rFFi.AbiCoder).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $k39Yy.hexlify)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $k39Yy.hexlify)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $bCA3C.assert)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $3F7WM.id)(value);
            else if (param.type === "bytes") return (0, $eL5Ay.keccak256)((0, $k39Yy.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $ltdtW.toBeHex)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $k39Yy.zeroPadBytes)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $k39Yy.zeroPadValue)((0, $k39Yy.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $bCA3C.assertArgument)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $bCA3C.assertArgument)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $bCA3C.assertArgument)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $3F7WM.id)(value));
                else if (param.type === "bytes") topics.push((0, $eL5Ay.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $bCA3C.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $1YicP.ParamType).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $k39Yy.concat)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $4e3b2ac423c72dbb$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $4e3b2ac423c72dbb$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $2vkKj.Result).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $k39Yy.getBytes)(tx.data, "tx.data");
        const value = (0, $ltdtW.getBigInt)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $k39Yy.hexlify)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $4e3b2ac423c72dbb$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $4e3b2ac423c72dbb$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $k39Yy.hexlify)(data);
        const fragment = this.getError((0, $k39Yy.dataSlice)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $k39Yy.dataSlice)(hexData, 4));
        return new $4e3b2ac423c72dbb$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $4e3b2ac423c72dbb$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $4e3b2ac423c72dbb$export$48cefb51a4e315b2(JSON.parse(value));
        // An Interface; possibly from another v6 instance
        if (typeof value.formatJson === "function") return new $4e3b2ac423c72dbb$export$48cefb51a4e315b2(value.formatJson());
        // A legacy Interface; from an older version
        if (typeof value.format === "function") return new $4e3b2ac423c72dbb$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $4e3b2ac423c72dbb$export$48cefb51a4e315b2(value);
    }
}

});

parcelRegister("7EGwX", function(module, exports) {

$parcel$export(module.exports, "FeeData", function () { return $592d428844c4051e$export$116c49c1e2a96a78; });
$parcel$export(module.exports, "copyRequest", function () { return $592d428844c4051e$export$607b34cdac162b7f; });
$parcel$export(module.exports, "Block", function () { return $592d428844c4051e$export$d96a8827a60d6b69; });
$parcel$export(module.exports, "TransactionResponse", function () { return $592d428844c4051e$export$70966cdb3bfc0785; });
$parcel$export(module.exports, "Log", function () { return $592d428844c4051e$export$ce30dbb46644d06c; });
$parcel$export(module.exports, "TransactionReceipt", function () { return $592d428844c4051e$export$375ffd5683aa5c1c; });
//import { resolveAddress } from "@ethersproject/address";

var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");
var $k39Yy = parcelRequire("k39Yy");

var $7E40U = parcelRequire("7E40U");
const $592d428844c4051e$var$BN_0 = BigInt(0);
// -----------------------
function $592d428844c4051e$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $592d428844c4051e$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $592d428844c4051e$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $b74mN.defineProperties)(this, {
            gasPrice: $592d428844c4051e$var$getValue(gasPrice),
            maxFeePerGas: $592d428844c4051e$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $592d428844c4051e$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $592d428844c4051e$var$toJson(gasPrice),
            maxFeePerGas: $592d428844c4051e$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $592d428844c4051e$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $592d428844c4051e$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $k39Yy.hexlify)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $ltdtW.getBigInt)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $ltdtW.getNumber)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $7E40U.accessListify)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    if ("blobVersionedHashes" in req && req.blobVersionedHashes) result.blobVersionedHashes = req.blobVersionedHashes.slice();
    if ("kzg" in req) result.kzg = req.kzg;
    if ("blobs" in req && req.blobs) result.blobs = req.blobs.map((b)=>{
        if ((0, $k39Yy.isBytesLike)(b)) return (0, $k39Yy.hexlify)(b);
        return Object.assign({}, b);
    });
    return result;
}
class $592d428844c4051e$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */ prevRandao;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $592d428844c4051e$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $b74mN.defineProperties)(this, {
            provider: provider,
            hash: $592d428844c4051e$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            prevRandao: $592d428844c4051e$var$getValue(block.prevRandao),
            extraData: block.extraData,
            baseFeePerGas: $592d428844c4051e$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $bCA3C.assert)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, prevRandao: prevRandao, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $592d428844c4051e$var$toJson(baseFeePerGas),
            difficulty: $592d428844c4051e$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $592d428844c4051e$var$toJson(gasLimit),
            gasUsed: $592d428844c4051e$var$toJson(gasUsed),
            blobGasUsed: $592d428844c4051e$var$toJson(this.blobGasUsed),
            excessBlobGas: $592d428844c4051e$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            prevRandao: prevRandao,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $bCA3C.assertArgument)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $592d428844c4051e$var$createOrphanedBlockFilter(this);
    }
}
class $592d428844c4051e$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $b74mN.defineProperties)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $bCA3C.assert)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $bCA3C.assert)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $bCA3C.assert)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $592d428844c4051e$var$createRemovedLogFilter(this);
    }
}
class $592d428844c4051e$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $592d428844c4051e$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $592d428844c4051e$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $b74mN.defineProperties)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $592d428844c4051e$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $592d428844c4051e$var$toJson(this.gasPrice),
            blobGasUsed: $592d428844c4051e$var$toJson(this.blobGasUsed),
            blobGasPrice: $592d428844c4051e$var$toJson(this.blobGasPrice),
            gasUsed: $592d428844c4051e$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $592d428844c4051e$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $bCA3C.assert)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $592d428844c4051e$var$createReorderedTransactionFilter(this, other);
    }
}
class $592d428844c4051e$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $592d428844c4051e$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $592d428844c4051e$var$toJson(this.gasLimit),
            gasPrice: $592d428844c4051e$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $592d428844c4051e$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $592d428844c4051e$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $592d428844c4051e$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $592d428844c4051e$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $b74mN.resolveProperties)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $b74mN.resolveProperties)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $592d428844c4051e$var$BN_0) reason = "cancelled";
                        (0, $bCA3C.assert)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $bCA3C.assert)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $bCA3C.makeError)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $bCA3C.isError)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $bCA3C.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $592d428844c4051e$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $bCA3C.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $bCA3C.assert)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $592d428844c4051e$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $bCA3C.assertArgument)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $592d428844c4051e$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $592d428844c4051e$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $592d428844c4051e$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $592d428844c4051e$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $592d428844c4051e$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}

});

parcelRegister("3LPZK", function(module, exports) {

$parcel$export(module.exports, "EventLog", function () { return $2bee180263b92ef9$export$f8203d08df5cd081; });
$parcel$export(module.exports, "UndecodedEventLog", function () { return $2bee180263b92ef9$export$53f6e6acc02bf489; });
$parcel$export(module.exports, "ContractTransactionResponse", function () { return $2bee180263b92ef9$export$853f7e2df34220ff; });
$parcel$export(module.exports, "ContractUnknownEventPayload", function () { return $2bee180263b92ef9$export$54be5ec94ad26a69; });
$parcel$export(module.exports, "ContractEventPayload", function () { return $2bee180263b92ef9$export$35f9272dc1c07dee; });
// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

var $7EGwX = parcelRequire("7EGwX");

var $b74mN = parcelRequire("b74mN");
var $3vWS7 = parcelRequire("3vWS7");
class $2bee180263b92ef9$export$f8203d08df5cd081 extends (0, $7EGwX.Log) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $b74mN.defineProperties)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $2bee180263b92ef9$export$53f6e6acc02bf489 extends (0, $7EGwX.Log) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $b74mN.defineProperties)(this, {
            error: error
        });
    }
}
class $2bee180263b92ef9$export$86bdc83e93503686 extends (0, $7EGwX.TransactionReceipt) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $2bee180263b92ef9$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $2bee180263b92ef9$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $2bee180263b92ef9$export$853f7e2df34220ff extends (0, $7EGwX.TransactionResponse) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $2bee180263b92ef9$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $2bee180263b92ef9$export$54be5ec94ad26a69 extends (0, $3vWS7.EventPayload) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $b74mN.defineProperties)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $2bee180263b92ef9$export$35f9272dc1c07dee extends $2bee180263b92ef9$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $2bee180263b92ef9$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $b74mN.defineProperties)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}

});
parcelRegister("3vWS7", function(module, exports) {

$parcel$export(module.exports, "EventPayload", function () { return $28f1ef19ce5ac928$export$9cec82196983b278; });
/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
var $b74mN = parcelRequire("b74mN");
class $28f1ef19ce5ac928$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $b74mN.defineProperties)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}

});



parcelRegister("4rnT5", function(module, exports) {

$parcel$export(module.exports, "namehash", function () { return $33bc369fa4657f9c$export$91d651ee363e1209; });
$parcel$export(module.exports, "dnsEncode", function () { return $33bc369fa4657f9c$export$6c0a8cdae51cb512; });
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $jhFUp = parcelRequire("jhFUp");

var $b9sjd = parcelRequire("b9sjd");
const $33bc369fa4657f9c$var$Zeros = new Uint8Array(32);
$33bc369fa4657f9c$var$Zeros.fill(0);
function $33bc369fa4657f9c$var$checkComponent(comp) {
    (0, $bCA3C.assertArgument)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $33bc369fa4657f9c$var$ensNameSplit(name) {
    const bytes = (0, $jhFUp.toUtf8Bytes)($33bc369fa4657f9c$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($33bc369fa4657f9c$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $bCA3C.assertArgument)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($33bc369fa4657f9c$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $33bc369fa4657f9c$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $b9sjd.ens_normalize)(name);
    } catch (error) {
        (0, $bCA3C.assertArgument)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $33bc369fa4657f9c$export$cce2300886e7ace6(name) {
    try {
        return $33bc369fa4657f9c$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $33bc369fa4657f9c$export$91d651ee363e1209(name) {
    (0, $bCA3C.assertArgument)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $bCA3C.assertArgument)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $33bc369fa4657f9c$var$Zeros;
    const comps = $33bc369fa4657f9c$var$ensNameSplit(name);
    while(comps.length)result = (0, $eL5Ay.keccak256)((0, $k39Yy.concat)([
        result,
        (0, $eL5Ay.keccak256)(comps.pop())
    ]));
    return (0, $k39Yy.hexlify)(result);
}
function $33bc369fa4657f9c$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $bCA3C.assertArgument)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $k39Yy.hexlify)((0, $k39Yy.concat)($33bc369fa4657f9c$var$ensNameSplit(name).map((comp)=>{
        (0, $bCA3C.assertArgument)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("b9sjd", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", function () { return $8f5079d43fa714ea$export$499f715881831a51; });
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $8f5079d43fa714ea$var$COMPRESSED$1 = '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';
const $8f5079d43fa714ea$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $8f5079d43fa714ea$var$NSM_MAX = 4;
function $8f5079d43fa714ea$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $8f5079d43fa714ea$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $8f5079d43fa714ea$var$read_compressed_payload(s) {
    return $8f5079d43fa714ea$var$read_payload($8f5079d43fa714ea$var$decode_arithmetic($8f5079d43fa714ea$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $8f5079d43fa714ea$var$unsafe_atob(s) {
    let lookup = [];
    [
        ...'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $8f5079d43fa714ea$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $8f5079d43fa714ea$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $8f5079d43fa714ea$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $8f5079d43fa714ea$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $8f5079d43fa714ea$var$read_sorted_arrays(next) {
    return $8f5079d43fa714ea$var$read_array_while(()=>{
        let v = $8f5079d43fa714ea$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $8f5079d43fa714ea$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($8f5079d43fa714ea$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($8f5079d43fa714ea$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $8f5079d43fa714ea$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $8f5079d43fa714ea$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$8f5079d43fa714ea$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $8f5079d43fa714ea$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $8f5079d43fa714ea$var$read_array_while(next);
    let m = $8f5079d43fa714ea$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $8f5079d43fa714ea$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $8f5079d43fa714ea$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $8f5079d43fa714ea$var$read_trie(next) {
    let ret = [];
    let sorted = $8f5079d43fa714ea$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $8f5079d43fa714ea$var$read_array_while(()=>{
            let cps = $8f5079d43fa714ea$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $8f5079d43fa714ea$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, '0');
}
function $8f5079d43fa714ea$var$quote_cp(cp) {
    return `{${$8f5079d43fa714ea$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $8f5079d43fa714ea$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $8f5079d43fa714ea$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join('');
}
function $8f5079d43fa714ea$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $8f5079d43fa714ea$var$COMPRESSED = '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';
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $8f5079d43fa714ea$var$S0 = 0xAC00;
const $8f5079d43fa714ea$var$L0 = 0x1100;
const $8f5079d43fa714ea$var$V0 = 0x1161;
const $8f5079d43fa714ea$var$T0 = 0x11A7;
const $8f5079d43fa714ea$var$L_COUNT = 19;
const $8f5079d43fa714ea$var$V_COUNT = 21;
const $8f5079d43fa714ea$var$T_COUNT = 28;
const $8f5079d43fa714ea$var$N_COUNT = $8f5079d43fa714ea$var$V_COUNT * $8f5079d43fa714ea$var$T_COUNT;
const $8f5079d43fa714ea$var$S_COUNT = $8f5079d43fa714ea$var$L_COUNT * $8f5079d43fa714ea$var$N_COUNT;
const $8f5079d43fa714ea$var$S1 = $8f5079d43fa714ea$var$S0 + $8f5079d43fa714ea$var$S_COUNT;
const $8f5079d43fa714ea$var$L1 = $8f5079d43fa714ea$var$L0 + $8f5079d43fa714ea$var$L_COUNT;
const $8f5079d43fa714ea$var$V1 = $8f5079d43fa714ea$var$V0 + $8f5079d43fa714ea$var$V_COUNT;
const $8f5079d43fa714ea$var$T1 = $8f5079d43fa714ea$var$T0 + $8f5079d43fa714ea$var$T_COUNT;
function $8f5079d43fa714ea$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $8f5079d43fa714ea$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $8f5079d43fa714ea$var$SHIFTED_RANK, $8f5079d43fa714ea$var$EXCLUSIONS, $8f5079d43fa714ea$var$DECOMP, $8f5079d43fa714ea$var$RECOMP;
function $8f5079d43fa714ea$var$init$1() {
    //console.time('nf');
    let r = $8f5079d43fa714ea$var$read_compressed_payload($8f5079d43fa714ea$var$COMPRESSED);
    $8f5079d43fa714ea$var$SHIFTED_RANK = new Map($8f5079d43fa714ea$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $8f5079d43fa714ea$var$EXCLUSIONS = new Set($8f5079d43fa714ea$var$read_sorted(r));
    $8f5079d43fa714ea$var$DECOMP = new Map();
    $8f5079d43fa714ea$var$RECOMP = new Map();
    for (let [cp, cps] of $8f5079d43fa714ea$var$read_mapped(r)){
        if (!$8f5079d43fa714ea$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $8f5079d43fa714ea$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $8f5079d43fa714ea$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $8f5079d43fa714ea$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $8f5079d43fa714ea$var$is_hangul(cp) {
    return cp >= $8f5079d43fa714ea$var$S0 && cp < $8f5079d43fa714ea$var$S1;
}
function $8f5079d43fa714ea$var$compose_pair(a, b) {
    if (a >= $8f5079d43fa714ea$var$L0 && a < $8f5079d43fa714ea$var$L1 && b >= $8f5079d43fa714ea$var$V0 && b < $8f5079d43fa714ea$var$V1) return $8f5079d43fa714ea$var$S0 + (a - $8f5079d43fa714ea$var$L0) * $8f5079d43fa714ea$var$N_COUNT + (b - $8f5079d43fa714ea$var$V0) * $8f5079d43fa714ea$var$T_COUNT;
    else if ($8f5079d43fa714ea$var$is_hangul(a) && b > $8f5079d43fa714ea$var$T0 && b < $8f5079d43fa714ea$var$T1 && (a - $8f5079d43fa714ea$var$S0) % $8f5079d43fa714ea$var$T_COUNT == 0) return a + (b - $8f5079d43fa714ea$var$T0);
    else {
        let recomp = $8f5079d43fa714ea$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $8f5079d43fa714ea$var$decomposed(cps) {
    if (!$8f5079d43fa714ea$var$SHIFTED_RANK) $8f5079d43fa714ea$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $8f5079d43fa714ea$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($8f5079d43fa714ea$var$is_hangul(cp)) {
            let s_index = cp - $8f5079d43fa714ea$var$S0;
            let l_index = s_index / $8f5079d43fa714ea$var$N_COUNT | 0;
            let v_index = s_index % $8f5079d43fa714ea$var$N_COUNT / $8f5079d43fa714ea$var$T_COUNT | 0;
            let t_index = s_index % $8f5079d43fa714ea$var$T_COUNT;
            add($8f5079d43fa714ea$var$L0 + l_index);
            add($8f5079d43fa714ea$var$V0 + v_index);
            if (t_index > 0) add($8f5079d43fa714ea$var$T0 + t_index);
        } else {
            let mapped = $8f5079d43fa714ea$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $8f5079d43fa714ea$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $8f5079d43fa714ea$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $8f5079d43fa714ea$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $8f5079d43fa714ea$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $8f5079d43fa714ea$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $8f5079d43fa714ea$var$unpack_cc(packed);
        let cp = $8f5079d43fa714ea$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $8f5079d43fa714ea$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $8f5079d43fa714ea$export$9d0d896b286a3dba(cps) {
    return $8f5079d43fa714ea$var$decomposed(cps).map($8f5079d43fa714ea$var$unpack_cp);
}
function $8f5079d43fa714ea$export$f42252642e08449(cps) {
    return $8f5079d43fa714ea$var$composed_from_decomposed($8f5079d43fa714ea$var$decomposed(cps));
}
const $8f5079d43fa714ea$var$HYPHEN = 0x2D;
const $8f5079d43fa714ea$var$STOP = 0x2E;
const $8f5079d43fa714ea$var$STOP_CH = '.';
const $8f5079d43fa714ea$var$FE0F = 0xFE0F;
const $8f5079d43fa714ea$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $8f5079d43fa714ea$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $8f5079d43fa714ea$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $8f5079d43fa714ea$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $8f5079d43fa714ea$var$MAPPED, $8f5079d43fa714ea$var$IGNORED, $8f5079d43fa714ea$var$CM, $8f5079d43fa714ea$var$NSM, $8f5079d43fa714ea$var$ESCAPE, $8f5079d43fa714ea$var$NFC_CHECK, $8f5079d43fa714ea$var$GROUPS, $8f5079d43fa714ea$var$WHOLE_VALID, $8f5079d43fa714ea$var$WHOLE_MAP, $8f5079d43fa714ea$var$VALID, $8f5079d43fa714ea$var$EMOJI_LIST, $8f5079d43fa714ea$var$EMOJI_ROOT;
function $8f5079d43fa714ea$var$init() {
    if ($8f5079d43fa714ea$var$MAPPED) return;
    let r = $8f5079d43fa714ea$var$read_compressed_payload($8f5079d43fa714ea$var$COMPRESSED$1);
    const read_sorted_array = ()=>$8f5079d43fa714ea$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $8f5079d43fa714ea$var$MAPPED = new Map($8f5079d43fa714ea$var$read_mapped(r));
    $8f5079d43fa714ea$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $8f5079d43fa714ea$var$CM = read_sorted_array();
    $8f5079d43fa714ea$var$NSM = new Set(read_sorted_array().map((i)=>$8f5079d43fa714ea$var$CM[i]));
    $8f5079d43fa714ea$var$CM = new Set($8f5079d43fa714ea$var$CM);
    $8f5079d43fa714ea$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $8f5079d43fa714ea$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $8f5079d43fa714ea$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $8f5079d43fa714ea$var$GROUPS = $8f5079d43fa714ea$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $8f5079d43fa714ea$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $8f5079d43fa714ea$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $8f5079d43fa714ea$var$WHOLE_VALID = read_sorted_set();
    $8f5079d43fa714ea$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($8f5079d43fa714ea$var$Array_from($8f5079d43fa714ea$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$8f5079d43fa714ea$var$WHOLE_VALID.has(cp)) $8f5079d43fa714ea$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($8f5079d43fa714ea$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $8f5079d43fa714ea$var$GROUPS.filter((g)=>$8f5079d43fa714ea$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$8f5079d43fa714ea$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $8f5079d43fa714ea$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$8f5079d43fa714ea$var$VALID.has(cp) ? multi.add(cp) : $8f5079d43fa714ea$var$VALID.add(cp);
    for (let g of $8f5079d43fa714ea$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $8f5079d43fa714ea$var$VALID)if (!$8f5079d43fa714ea$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $8f5079d43fa714ea$var$WHOLE_MAP.set(cp, $8f5079d43fa714ea$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($8f5079d43fa714ea$var$VALID, $8f5079d43fa714ea$export$9d0d896b286a3dba($8f5079d43fa714ea$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $8f5079d43fa714ea$var$EMOJI_LIST = $8f5079d43fa714ea$var$read_trie(r).map((v)=>$8f5079d43fa714ea$var$Emoji.from(v)).sort($8f5079d43fa714ea$var$compare_arrays);
    $8f5079d43fa714ea$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $8f5079d43fa714ea$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $8f5079d43fa714ea$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $8f5079d43fa714ea$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $8f5079d43fa714ea$var$quoted_cp(cp) {
    return ($8f5079d43fa714ea$export$4b1c9c18c687e5e9(cp) ? '' : `${$8f5079d43fa714ea$var$bidi_qq($8f5079d43fa714ea$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $8f5079d43fa714ea$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $8f5079d43fa714ea$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $8f5079d43fa714ea$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $8f5079d43fa714ea$var$HYPHEN && cps[3] == $8f5079d43fa714ea$var$HYPHEN) throw new Error(`invalid label extension: "${$8f5079d43fa714ea$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $8f5079d43fa714ea$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error('underscore allowed only at start');
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $8f5079d43fa714ea$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $8f5079d43fa714ea$var$FENCED.get(cp);
    if (prev) throw $8f5079d43fa714ea$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $8f5079d43fa714ea$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $8f5079d43fa714ea$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $8f5079d43fa714ea$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $8f5079d43fa714ea$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $8f5079d43fa714ea$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($8f5079d43fa714ea$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($8f5079d43fa714ea$export$4b1c9c18c687e5e9(cp)) {
            buf.push($8f5079d43fa714ea$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($8f5079d43fa714ea$var$str_from_cps(cps.slice(prev, n)));
    return buf.join('');
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $8f5079d43fa714ea$export$e29a9e4d2573411c(cp) {
    $8f5079d43fa714ea$var$init();
    return $8f5079d43fa714ea$var$CM.has(cp);
}
function $8f5079d43fa714ea$export$4b1c9c18c687e5e9(cp) {
    $8f5079d43fa714ea$var$init();
    return $8f5079d43fa714ea$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $8f5079d43fa714ea$export$95d5ea4de7964366() {
    $8f5079d43fa714ea$var$init();
    return $8f5079d43fa714ea$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $8f5079d43fa714ea$export$f4e6b2721065fb3d(frag, decompose) {
    $8f5079d43fa714ea$var$init();
    let nf = decompose ? $8f5079d43fa714ea$export$9d0d896b286a3dba : $8f5079d43fa714ea$export$f42252642e08449;
    return frag.split($8f5079d43fa714ea$var$STOP_CH).map((label)=>$8f5079d43fa714ea$var$str_from_cps($8f5079d43fa714ea$var$tokens_from_str($8f5079d43fa714ea$var$explode_cp(label), nf, $8f5079d43fa714ea$var$filter_fe0f).flat())).join($8f5079d43fa714ea$var$STOP_CH);
}
function $8f5079d43fa714ea$export$499f715881831a51(name) {
    return $8f5079d43fa714ea$var$flatten($8f5079d43fa714ea$var$split(name, $8f5079d43fa714ea$export$f42252642e08449, $8f5079d43fa714ea$var$filter_fe0f));
}
function $8f5079d43fa714ea$export$d2ee080f6ab2341d(name) {
    let labels = $8f5079d43fa714ea$var$split(name, $8f5079d43fa714ea$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== 'Greek') $8f5079d43fa714ea$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $8f5079d43fa714ea$var$flatten(labels);
}
function $8f5079d43fa714ea$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $8f5079d43fa714ea$export$d2ba335951b08421(name, preserve_emoji) {
    return $8f5079d43fa714ea$var$split(name, $8f5079d43fa714ea$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $8f5079d43fa714ea$var$filter_fe0f); // emoji are exposed so copy
}
function $8f5079d43fa714ea$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $8f5079d43fa714ea$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($8f5079d43fa714ea$var$STOP_CH).map((label)=>{
        let input = $8f5079d43fa714ea$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $8f5079d43fa714ea$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $8f5079d43fa714ea$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $8f5079d43fa714ea$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = 'ASCII';
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = 'Emoji';
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($8f5079d43fa714ea$var$CM.has(norm[0])) throw $8f5079d43fa714ea$var$error_placement('leading combining mark');
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $8f5079d43fa714ea$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $8f5079d43fa714ea$var$error_placement(`emoji + combining mark: "${$8f5079d43fa714ea$var$str_from_cps(tokens[i - 1])} + ${$8f5079d43fa714ea$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $8f5079d43fa714ea$var$check_fenced(norm);
                    let unique = $8f5079d43fa714ea$var$Array_from(new Set(chars));
                    let [g] = $8f5079d43fa714ea$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $8f5079d43fa714ea$var$check_group(g, chars); // need text in order
                    $8f5079d43fa714ea$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $8f5079d43fa714ea$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $8f5079d43fa714ea$var$WHOLE_MAP.get(cp);
        if (whole === $8f5079d43fa714ea$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $8f5079d43fa714ea$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$8f5079d43fa714ea$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $8f5079d43fa714ea$var$determine_group(unique) {
    let groups = $8f5079d43fa714ea$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$8f5079d43fa714ea$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$8f5079d43fa714ea$var$GROUPS.some((g)=>$8f5079d43fa714ea$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $8f5079d43fa714ea$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $8f5079d43fa714ea$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $8f5079d43fa714ea$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$8f5079d43fa714ea$var$bidi_qq($8f5079d43fa714ea$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $8f5079d43fa714ea$var$str_from_cps(output);
    }).join($8f5079d43fa714ea$var$STOP_CH);
}
function $8f5079d43fa714ea$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$8f5079d43fa714ea$var$quoted_cp(cp)}`);
}
function $8f5079d43fa714ea$var$error_group_member(g, cp) {
    let quoted = $8f5079d43fa714ea$var$quoted_cp(cp);
    let gg = $8f5079d43fa714ea$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $8f5079d43fa714ea$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $8f5079d43fa714ea$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$8f5079d43fa714ea$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $8f5079d43fa714ea$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $8f5079d43fa714ea$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($8f5079d43fa714ea$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $8f5079d43fa714ea$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$8f5079d43fa714ea$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $8f5079d43fa714ea$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$8f5079d43fa714ea$var$bidi_qq($8f5079d43fa714ea$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$8f5079d43fa714ea$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $8f5079d43fa714ea$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $8f5079d43fa714ea$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($8f5079d43fa714ea$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $8f5079d43fa714ea$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$8f5079d43fa714ea$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $8f5079d43fa714ea$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $8f5079d43fa714ea$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $8f5079d43fa714ea$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $8f5079d43fa714ea$var$consume_emoji_reversed(cps, eaten) {
    let node = $8f5079d43fa714ea$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $8f5079d43fa714ea$var$TY_VALID = 'valid';
const $8f5079d43fa714ea$var$TY_MAPPED = 'mapped';
const $8f5079d43fa714ea$var$TY_IGNORED = 'ignored';
const $8f5079d43fa714ea$var$TY_DISALLOWED = 'disallowed';
const $8f5079d43fa714ea$var$TY_EMOJI = 'emoji';
const $8f5079d43fa714ea$var$TY_NFC = 'nfc';
const $8f5079d43fa714ea$var$TY_STOP = 'stop';
function $8f5079d43fa714ea$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $8f5079d43fa714ea$var$init();
    let input = $8f5079d43fa714ea$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $8f5079d43fa714ea$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $8f5079d43fa714ea$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $8f5079d43fa714ea$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $8f5079d43fa714ea$var$STOP) tokens.push({
                type: $8f5079d43fa714ea$var$TY_STOP,
                cp: cp
            });
            else if ($8f5079d43fa714ea$var$VALID.has(cp)) tokens.push({
                type: $8f5079d43fa714ea$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($8f5079d43fa714ea$var$IGNORED.has(cp)) tokens.push({
                type: $8f5079d43fa714ea$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $8f5079d43fa714ea$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $8f5079d43fa714ea$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $8f5079d43fa714ea$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($8f5079d43fa714ea$var$is_valid_or_mapped(token.type)) {
            if ($8f5079d43fa714ea$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($8f5079d43fa714ea$var$is_valid_or_mapped(type)) {
                        if (!$8f5079d43fa714ea$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $8f5079d43fa714ea$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$8f5079d43fa714ea$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $8f5079d43fa714ea$export$f42252642e08449(cps0);
                if ($8f5079d43fa714ea$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $8f5079d43fa714ea$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $8f5079d43fa714ea$var$collapse_valid_tokens(slice),
                        tokens: $8f5079d43fa714ea$export$bac129d8210aa825($8f5079d43fa714ea$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $8f5079d43fa714ea$var$TY_IGNORED) start = -1; // reset
    }
    return $8f5079d43fa714ea$var$collapse_valid_tokens(tokens);
}
function $8f5079d43fa714ea$var$is_valid_or_mapped(type) {
    return type == $8f5079d43fa714ea$var$TY_VALID || type == $8f5079d43fa714ea$var$TY_MAPPED;
}
function $8f5079d43fa714ea$var$requires_check(cps) {
    return cps.some((cp)=>$8f5079d43fa714ea$var$NFC_CHECK.has(cp));
}
function $8f5079d43fa714ea$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $8f5079d43fa714ea$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $8f5079d43fa714ea$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $8f5079d43fa714ea$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}

});


parcelRegister("df9mn", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $9a43efc162d8cee8$export$febc5573c75cefb0; });

var $hbt3Q = parcelRequire("hbt3Q");

var $dHvt6 = parcelRequire("dHvt6");
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");
var $DAvpQ = parcelRequire("DAvpQ");
var $ba4Oi = parcelRequire("ba4Oi");
var $hgbdt = parcelRequire("hgbdt");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $e5QZv = parcelRequire("e5QZv");
var $lyqDW = parcelRequire("lyqDW");
var $ltdtW = parcelRequire("ltdtW");

var $7E40U = parcelRequire("7E40U");

var $26Tyr = parcelRequire("26Tyr");
const $9a43efc162d8cee8$var$BN_0 = BigInt(0);
const $9a43efc162d8cee8$var$BN_2 = BigInt(2);
const $9a43efc162d8cee8$var$BN_27 = BigInt(27);
const $9a43efc162d8cee8$var$BN_28 = BigInt(28);
const $9a43efc162d8cee8$var$BN_35 = BigInt(35);
const $9a43efc162d8cee8$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $9a43efc162d8cee8$var$BLOB_SIZE = 131072;
function $9a43efc162d8cee8$var$getVersionedHash(version, hash) {
    let versioned = version.toString(16);
    while(versioned.length < 2)versioned = "0" + versioned;
    versioned += (0, $DAvpQ.sha256)(hash).substring(4);
    return "0x" + versioned;
}
function $9a43efc162d8cee8$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $hbt3Q.getAddress)(value);
}
function $9a43efc162d8cee8$var$handleAccessList(value, param) {
    try {
        return (0, $7E40U.accessListify)(value);
    } catch (error) {
        (0, $bCA3C.assertArgument)(false, error.message, param, value);
    }
}
function $9a43efc162d8cee8$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $ltdtW.getNumber)(_value, param);
}
function $9a43efc162d8cee8$var$handleUint(_value, param) {
    if (_value === "0x") return $9a43efc162d8cee8$var$BN_0;
    const value = (0, $ltdtW.getBigInt)(_value, param);
    (0, $bCA3C.assertArgument)(value <= $9a43efc162d8cee8$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $9a43efc162d8cee8$var$formatNumber(_value, name) {
    const value = (0, $ltdtW.getBigInt)(_value, "value");
    const result = (0, $ltdtW.toBeArray)(value);
    (0, $bCA3C.assertArgument)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $9a43efc162d8cee8$var$formatAccessList(value) {
    return (0, $7E40U.accessListify)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $9a43efc162d8cee8$var$formatHashes(value, param) {
    (0, $bCA3C.assertArgument)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $9a43efc162d8cee8$var$_parseLegacy(data) {
    const fields = (0, $e5QZv.decodeRlp)(data);
    (0, $bCA3C.assertArgument)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $9a43efc162d8cee8$var$handleNumber(fields[0], "nonce"),
        gasPrice: $9a43efc162d8cee8$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $9a43efc162d8cee8$var$handleUint(fields[2], "gasLimit"),
        to: $9a43efc162d8cee8$var$handleAddress(fields[3]),
        value: $9a43efc162d8cee8$var$handleUint(fields[4], "value"),
        data: (0, $k39Yy.hexlify)(fields[5]),
        chainId: $9a43efc162d8cee8$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $9a43efc162d8cee8$var$handleUint(fields[6], "v");
    const r = $9a43efc162d8cee8$var$handleUint(fields[7], "r");
    const s = $9a43efc162d8cee8$var$handleUint(fields[8], "s");
    if (r === $9a43efc162d8cee8$var$BN_0 && s === $9a43efc162d8cee8$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $9a43efc162d8cee8$var$BN_35) / $9a43efc162d8cee8$var$BN_2;
        if (chainId < $9a43efc162d8cee8$var$BN_0) chainId = $9a43efc162d8cee8$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $bCA3C.assertArgument)(chainId !== $9a43efc162d8cee8$var$BN_0 || v === $9a43efc162d8cee8$var$BN_27 || v === $9a43efc162d8cee8$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $ba4Oi.Signature).from({
            r: (0, $k39Yy.zeroPadValue)(fields[7], 32),
            s: (0, $k39Yy.zeroPadValue)(fields[8], 32),
            v: v
        });
    //tx.hash = keccak256(data);
    }
    return tx;
}
function $9a43efc162d8cee8$var$_serializeLegacy(tx, sig) {
    const fields = [
        $9a43efc162d8cee8$var$formatNumber(tx.nonce, "nonce"),
        $9a43efc162d8cee8$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $9a43efc162d8cee8$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $9a43efc162d8cee8$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $9a43efc162d8cee8$var$BN_0;
    if (tx.chainId != $9a43efc162d8cee8$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $ltdtW.getBigInt)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $bCA3C.assertArgument)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $9a43efc162d8cee8$var$BN_0) {
            fields.push((0, $ltdtW.toBeArray)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $lyqDW.encodeRlp)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $9a43efc162d8cee8$var$BN_0) v = (0, $ba4Oi.Signature).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $bCA3C.assertArgument)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $ltdtW.toBeArray)(v));
    fields.push((0, $ltdtW.toBeArray)(sig.r));
    fields.push((0, $ltdtW.toBeArray)(sig.s));
    return (0, $lyqDW.encodeRlp)(fields);
}
function $9a43efc162d8cee8$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $9a43efc162d8cee8$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $bCA3C.assertArgument)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $k39Yy.zeroPadValue)(fields[1], 32);
    const s = (0, $k39Yy.zeroPadValue)(fields[2], 32);
    const signature = (0, $ba4Oi.Signature).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $9a43efc162d8cee8$var$_parseEip1559(data) {
    const fields = (0, $e5QZv.decodeRlp)((0, $k39Yy.getBytes)(data).slice(1));
    (0, $bCA3C.assertArgument)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $k39Yy.hexlify)(data));
    const tx = {
        type: 2,
        chainId: $9a43efc162d8cee8$var$handleUint(fields[0], "chainId"),
        nonce: $9a43efc162d8cee8$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $9a43efc162d8cee8$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $9a43efc162d8cee8$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $9a43efc162d8cee8$var$handleUint(fields[4], "gasLimit"),
        to: $9a43efc162d8cee8$var$handleAddress(fields[5]),
        value: $9a43efc162d8cee8$var$handleUint(fields[6], "value"),
        data: (0, $k39Yy.hexlify)(fields[7]),
        accessList: $9a43efc162d8cee8$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    //tx.hash = keccak256(data);
    $9a43efc162d8cee8$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $9a43efc162d8cee8$var$_serializeEip1559(tx, sig) {
    const fields = [
        $9a43efc162d8cee8$var$formatNumber(tx.chainId, "chainId"),
        $9a43efc162d8cee8$var$formatNumber(tx.nonce, "nonce"),
        $9a43efc162d8cee8$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $9a43efc162d8cee8$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $9a43efc162d8cee8$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $9a43efc162d8cee8$var$formatNumber(tx.value, "value"),
        tx.data,
        $9a43efc162d8cee8$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($9a43efc162d8cee8$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $ltdtW.toBeArray)(sig.r));
        fields.push((0, $ltdtW.toBeArray)(sig.s));
    }
    return (0, $k39Yy.concat)([
        "0x02",
        (0, $lyqDW.encodeRlp)(fields)
    ]);
}
function $9a43efc162d8cee8$var$_parseEip2930(data) {
    const fields = (0, $e5QZv.decodeRlp)((0, $k39Yy.getBytes)(data).slice(1));
    (0, $bCA3C.assertArgument)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $k39Yy.hexlify)(data));
    const tx = {
        type: 1,
        chainId: $9a43efc162d8cee8$var$handleUint(fields[0], "chainId"),
        nonce: $9a43efc162d8cee8$var$handleNumber(fields[1], "nonce"),
        gasPrice: $9a43efc162d8cee8$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $9a43efc162d8cee8$var$handleUint(fields[3], "gasLimit"),
        to: $9a43efc162d8cee8$var$handleAddress(fields[4]),
        value: $9a43efc162d8cee8$var$handleUint(fields[5], "value"),
        data: (0, $k39Yy.hexlify)(fields[6]),
        accessList: $9a43efc162d8cee8$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    //tx.hash = keccak256(data);
    $9a43efc162d8cee8$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $9a43efc162d8cee8$var$_serializeEip2930(tx, sig) {
    const fields = [
        $9a43efc162d8cee8$var$formatNumber(tx.chainId, "chainId"),
        $9a43efc162d8cee8$var$formatNumber(tx.nonce, "nonce"),
        $9a43efc162d8cee8$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $9a43efc162d8cee8$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $9a43efc162d8cee8$var$formatNumber(tx.value, "value"),
        tx.data,
        $9a43efc162d8cee8$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($9a43efc162d8cee8$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $ltdtW.toBeArray)(sig.r));
        fields.push((0, $ltdtW.toBeArray)(sig.s));
    }
    return (0, $k39Yy.concat)([
        "0x01",
        (0, $lyqDW.encodeRlp)(fields)
    ]);
}
function $9a43efc162d8cee8$var$_parseEip4844(data) {
    let fields = (0, $e5QZv.decodeRlp)((0, $k39Yy.getBytes)(data).slice(1));
    let typeName = "3";
    let blobs = null;
    // Parse the network format
    if (fields.length === 4 && Array.isArray(fields[0])) {
        typeName = "3 (network format)";
        const fBlobs = fields[1], fCommits = fields[2], fProofs = fields[3];
        (0, $bCA3C.assertArgument)(Array.isArray(fBlobs), "invalid network format: blobs not an array", "fields[1]", fBlobs);
        (0, $bCA3C.assertArgument)(Array.isArray(fCommits), "invalid network format: commitments not an array", "fields[2]", fCommits);
        (0, $bCA3C.assertArgument)(Array.isArray(fProofs), "invalid network format: proofs not an array", "fields[3]", fProofs);
        (0, $bCA3C.assertArgument)(fBlobs.length === fCommits.length, "invalid network format: blobs/commitments length mismatch", "fields", fields);
        (0, $bCA3C.assertArgument)(fBlobs.length === fProofs.length, "invalid network format: blobs/proofs length mismatch", "fields", fields);
        blobs = [];
        for(let i = 0; i < fields[1].length; i++)blobs.push({
            data: fBlobs[i],
            commitment: fCommits[i],
            proof: fProofs[i]
        });
        fields = fields[0];
    }
    (0, $bCA3C.assertArgument)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), `invalid field count for transaction type: ${typeName}`, "data", (0, $k39Yy.hexlify)(data));
    const tx = {
        type: 3,
        chainId: $9a43efc162d8cee8$var$handleUint(fields[0], "chainId"),
        nonce: $9a43efc162d8cee8$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $9a43efc162d8cee8$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $9a43efc162d8cee8$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $9a43efc162d8cee8$var$handleUint(fields[4], "gasLimit"),
        to: $9a43efc162d8cee8$var$handleAddress(fields[5]),
        value: $9a43efc162d8cee8$var$handleUint(fields[6], "value"),
        data: (0, $k39Yy.hexlify)(fields[7]),
        accessList: $9a43efc162d8cee8$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $9a43efc162d8cee8$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    if (blobs) tx.blobs = blobs;
    (0, $bCA3C.assertArgument)(tx.to != null, `invalid address for transaction type: ${typeName}`, "data", data);
    (0, $bCA3C.assertArgument)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    // @TODO: Do we need to do this? This is only called internally
    // and used to verify hashes; it might save time to not do this
    //tx.hash = keccak256(concat([ "0x03", encodeRlp(fields) ]));
    $9a43efc162d8cee8$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $9a43efc162d8cee8$var$_serializeEip4844(tx, sig, blobs) {
    const fields = [
        $9a43efc162d8cee8$var$formatNumber(tx.chainId, "chainId"),
        $9a43efc162d8cee8$var$formatNumber(tx.nonce, "nonce"),
        $9a43efc162d8cee8$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $9a43efc162d8cee8$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $9a43efc162d8cee8$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $dHvt6.ZeroAddress),
        $9a43efc162d8cee8$var$formatNumber(tx.value, "value"),
        tx.data,
        $9a43efc162d8cee8$var$formatAccessList(tx.accessList || []),
        $9a43efc162d8cee8$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $9a43efc162d8cee8$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($9a43efc162d8cee8$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $ltdtW.toBeArray)(sig.r));
        fields.push((0, $ltdtW.toBeArray)(sig.s));
        // We have blobs; return the network wrapped format
        if (blobs) return (0, $k39Yy.concat)([
            "0x03",
            (0, $lyqDW.encodeRlp)([
                fields,
                blobs.map((b)=>b.data),
                blobs.map((b)=>b.commitment),
                blobs.map((b)=>b.proof)
            ])
        ]);
    }
    return (0, $k39Yy.concat)([
        "0x03",
        (0, $lyqDW.encodeRlp)(fields)
    ]);
}
class $9a43efc162d8cee8$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    #kzg;
    #blobs;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, $bCA3C.assertArgument)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $dHvt6.ZeroAddress;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $hbt3Q.getAddress)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $ltdtW.getNumber)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $ltdtW.getBigInt)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $9a43efc162d8cee8$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $ltdtW.getBigInt)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $9a43efc162d8cee8$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $ltdtW.getBigInt)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $9a43efc162d8cee8$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $ltdtW.getBigInt)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $k39Yy.hexlify)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $ltdtW.getBigInt)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $ltdtW.getBigInt)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $ba4Oi.Signature).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $7E40U.accessListify)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $9a43efc162d8cee8$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $ltdtW.getBigInt)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $bCA3C.assertArgument)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */ get blobs() {
        if (this.#blobs == null) return null;
        return this.#blobs.map((b)=>Object.assign({}, b));
    }
    set blobs(_blobs) {
        if (_blobs == null) {
            this.#blobs = null;
            return;
        }
        const blobs = [];
        const versionedHashes = [];
        for(let i = 0; i < _blobs.length; i++){
            const blob = _blobs[i];
            if ((0, $k39Yy.isBytesLike)(blob)) {
                (0, $bCA3C.assert)(this.#kzg, "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
                    operation: "set blobs()"
                });
                let data = (0, $k39Yy.getBytes)(blob);
                (0, $bCA3C.assertArgument)(data.length <= $9a43efc162d8cee8$var$BLOB_SIZE, "blob is too large", `blobs[${i}]`, blob);
                // Pad blob if necessary
                if (data.length !== $9a43efc162d8cee8$var$BLOB_SIZE) {
                    const padded = new Uint8Array($9a43efc162d8cee8$var$BLOB_SIZE);
                    padded.set(data);
                    data = padded;
                }
                const commit = this.#kzg.blobToKzgCommitment(data);
                const proof = (0, $k39Yy.hexlify)(this.#kzg.computeBlobKzgProof(data, commit));
                blobs.push({
                    data: (0, $k39Yy.hexlify)(data),
                    commitment: (0, $k39Yy.hexlify)(commit),
                    proof: proof
                });
                versionedHashes.push($9a43efc162d8cee8$var$getVersionedHash(1, commit));
            } else {
                const commit = (0, $k39Yy.hexlify)(blob.commitment);
                blobs.push({
                    data: (0, $k39Yy.hexlify)(blob.data),
                    commitment: commit,
                    proof: (0, $k39Yy.hexlify)(blob.proof)
                });
                versionedHashes.push($9a43efc162d8cee8$var$getVersionedHash(1, commit));
            }
        }
        this.#blobs = blobs;
        this.#blobVersionedHashes = versionedHashes;
    }
    get kzg() {
        return this.#kzg;
    }
    set kzg(kzg) {
        this.#kzg = kzg;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $9a43efc162d8cee8$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $9a43efc162d8cee8$var$BN_0;
        this.#chainId = $9a43efc162d8cee8$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
        this.#blobs = null;
        this.#kzg = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $eL5Ay.keccak256)(this.#getSerialized(true, false));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $eL5Ay.keccak256)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $26Tyr.recoverAddress)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $hgbdt.SigningKey).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    #getSerialized(signed, sidecar) {
        (0, $bCA3C.assert)(!signed || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        const sig = signed ? this.signature : null;
        switch(this.inferType()){
            case 0:
                return $9a43efc162d8cee8$var$_serializeLegacy(this, sig);
            case 1:
                return $9a43efc162d8cee8$var$_serializeEip2930(this, sig);
            case 2:
                return $9a43efc162d8cee8$var$_serializeEip1559(this, sig);
            case 3:
                return $9a43efc162d8cee8$var$_serializeEip4844(this, sig, sidecar ? this.blobs : null);
        }
        (0, $bCA3C.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        return this.#getSerialized(true, true);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        return this.#getSerialized(false, false);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $bCA3C.assert)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $bCA3C.assert)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $bCA3C.assert)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $9a43efc162d8cee8$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $9a43efc162d8cee8$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $k39Yy.getBytes)(tx);
            if (payload[0] >= 0x7f) return $9a43efc162d8cee8$export$febc5573c75cefb0.from($9a43efc162d8cee8$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $9a43efc162d8cee8$export$febc5573c75cefb0.from($9a43efc162d8cee8$var$_parseEip2930(payload));
                case 2:
                    return $9a43efc162d8cee8$export$febc5573c75cefb0.from($9a43efc162d8cee8$var$_parseEip1559(payload));
                case 3:
                    return $9a43efc162d8cee8$export$febc5573c75cefb0.from($9a43efc162d8cee8$var$_parseEip4844(payload));
            }
            (0, $bCA3C.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $9a43efc162d8cee8$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $ba4Oi.Signature).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        // This will get overwritten by blobs, if present
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        // Make sure we assign the kzg before assigning blobs, which
        // require the library in the event raw blob data is provided.
        if (tx.kzg != null) result.kzg = tx.kzg;
        if (tx.blobs != null) result.blobs = tx.blobs;
        if (tx.hash != null) {
            (0, $bCA3C.assertArgument)(result.isSigned(), "unsigned transaction cannot define '.hash'", "tx", tx);
            (0, $bCA3C.assertArgument)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $bCA3C.assertArgument)(result.isSigned(), "unsigned transaction cannot define '.from'", "tx", tx);
            (0, $bCA3C.assertArgument)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}

});
parcelRegister("e5QZv", function(module, exports) {

$parcel$export(module.exports, "decodeRlp", function () { return $a42aa3392d227009$export$7dc021e13b2aa20d; });
//See: https://github.com/ethereum/wiki/wiki/RLP

var $k39Yy = parcelRequire("k39Yy");

var $bCA3C = parcelRequire("bCA3C");
function $a42aa3392d227009$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $a42aa3392d227009$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $a42aa3392d227009$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $a42aa3392d227009$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $bCA3C.assert)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $a42aa3392d227009$var$_decode(data, offset) {
    (0, $bCA3C.assert)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $bCA3C.assert)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $a42aa3392d227009$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $a42aa3392d227009$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $a42aa3392d227009$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $a42aa3392d227009$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $k39Yy.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $k39Yy.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $a42aa3392d227009$var$hexlifyByte(data[offset])
    };
}
function $a42aa3392d227009$export$7dc021e13b2aa20d(_data) {
    const data = (0, $k39Yy.getBytes)(_data, "data");
    const decoded = $a42aa3392d227009$var$_decode(data, 0);
    (0, $bCA3C.assertArgument)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

});

parcelRegister("lyqDW", function(module, exports) {

$parcel$export(module.exports, "encodeRlp", function () { return $fb1170c33f4ad303$export$aea7770274d28b7; });
//See: https://github.com/ethereum/wiki/wiki/RLP

var $k39Yy = parcelRequire("k39Yy");
function $fb1170c33f4ad303$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $fb1170c33f4ad303$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($fb1170c33f4ad303$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $fb1170c33f4ad303$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $k39Yy.getBytes)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $fb1170c33f4ad303$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $fb1170c33f4ad303$var$nibbles = "0123456789abcdef";
function $fb1170c33f4ad303$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $fb1170c33f4ad303$var$_encode(object)){
        result += $fb1170c33f4ad303$var$nibbles[v >> 4];
        result += $fb1170c33f4ad303$var$nibbles[v & 0xf];
    }
    return result;
}

});


parcelRegister("4nyFX", function(module, exports) {

$parcel$export(module.exports, "EnsResolver", function () { return $33043549869888da$export$d04afd034a0a53ae; });
/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 
var $hbt3Q = parcelRequire("hbt3Q");

var $dHvt6 = parcelRequire("dHvt6");

var $9sbiK = parcelRequire("9sbiK");

var $4rnT5 = parcelRequire("4rnT5");

var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
var $f7W57 = parcelRequire("f7W57");
var $9b9xw = parcelRequire("9b9xw");
var $k39Yy = parcelRequire("k39Yy");
var $ltdtW = parcelRequire("ltdtW");
// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $33043549869888da$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $bCA3C.assertArgument)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $33043549869888da$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $b74mN.defineProperties)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $33043549869888da$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $33043549869888da$export$dcf63b2028a708b5 extends $33043549869888da$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($33043549869888da$var$BasicMulticoinPluginId);
    }
}
const $33043549869888da$var$matcherIpfs = new RegExp("^(ipfs):/\/(.*)$", "i");
const $33043549869888da$var$matchers = [
    new RegExp("^(https):/\/(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $33043549869888da$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $33043549869888da$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $b74mN.defineProperties)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $9sbiK.Contract)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $bCA3C.isError)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $4rnT5.namehash)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $bCA3C.assert)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $4rnT5.dnsEncode)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $bCA3C.isError)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $dHvt6.ZeroAddress)) return null;
            return result;
        } catch (error) {
            if ((0, $bCA3C.isError)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $k39Yy.isHexString)(data, 20)) return (0, $hbt3Q.getAddress)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $33043549869888da$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $bCA3C.assert)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $f7W57.encodeBase58)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $bCA3C.assert)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $33043549869888da$var$matchers.length; i++){
                const match = avatar.match($33043549869888da$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $33043549869888da$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $9sbiK.Contract)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $ltdtW.toBeHex)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $33043549869888da$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $9b9xw.FetchRequest)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $k39Yy.hexlify)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($33043549869888da$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $33043549869888da$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $bCA3C.assert)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $33043549869888da$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $9sbiK.Contract)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $4rnT5.namehash)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $dHvt6.ZeroAddress)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $33043549869888da$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $33043549869888da$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}

});
parcelRegister("f7W57", function(module, exports) {

$parcel$export(module.exports, "encodeBase58", function () { return $b034903dc3ccccd2$export$743e6bddc3282b13; });
/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 
var $k39Yy = parcelRequire("k39Yy");

var $bCA3C = parcelRequire("bCA3C");

var $ltdtW = parcelRequire("ltdtW");
const $b034903dc3ccccd2$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $b034903dc3ccccd2$var$Lookup = null;
function $b034903dc3ccccd2$var$getAlpha(letter) {
    if ($b034903dc3ccccd2$var$Lookup == null) {
        $b034903dc3ccccd2$var$Lookup = {};
        for(let i = 0; i < $b034903dc3ccccd2$var$Alphabet.length; i++)$b034903dc3ccccd2$var$Lookup[$b034903dc3ccccd2$var$Alphabet[i]] = BigInt(i);
    }
    const result = $b034903dc3ccccd2$var$Lookup[letter];
    (0, $bCA3C.assertArgument)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $b034903dc3ccccd2$var$BN_0 = BigInt(0);
const $b034903dc3ccccd2$var$BN_58 = BigInt(58);
function $b034903dc3ccccd2$export$743e6bddc3282b13(_value) {
    const bytes = (0, $k39Yy.getBytes)(_value);
    let value = (0, $ltdtW.toBigInt)(bytes);
    let result = "";
    while(value){
        result = $b034903dc3ccccd2$var$Alphabet[Number(value % $b034903dc3ccccd2$var$BN_58)] + result;
        value /= $b034903dc3ccccd2$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $b034903dc3ccccd2$var$Alphabet[0] + result;
    }
    return result;
}
function $b034903dc3ccccd2$export$63d430871b22e3d9(value) {
    let result = $b034903dc3ccccd2$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $b034903dc3ccccd2$var$BN_58;
        result += $b034903dc3ccccd2$var$getAlpha(value[i]);
    }
    return result;
}

});


parcelRegister("2TJj4", function(module, exports) {

$parcel$export(module.exports, "formatLog", function () { return $21c3dcc1716784fc$export$fccdbdc2b9d7893; });
$parcel$export(module.exports, "formatBlock", function () { return $21c3dcc1716784fc$export$ba1152bc4017d62a; });
$parcel$export(module.exports, "formatTransactionResponse", function () { return $21c3dcc1716784fc$export$fe50e42b325965d; });
$parcel$export(module.exports, "formatTransactionReceipt", function () { return $21c3dcc1716784fc$export$30da670e49d6fc31; });
/**
 *  @_ignore
 */ 
var $hbt3Q = parcelRequire("hbt3Q");
var $2VJZB = parcelRequire("2VJZB");

var $ba4Oi = parcelRequire("ba4Oi");

var $7E40U = parcelRequire("7E40U");

var $bCA3C = parcelRequire("bCA3C");
var $ltdtW = parcelRequire("ltdtW");
var $k39Yy = parcelRequire("k39Yy");
const $21c3dcc1716784fc$var$BN_0 = BigInt(0);
function $21c3dcc1716784fc$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $21c3dcc1716784fc$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $21c3dcc1716784fc$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $bCA3C.assert)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $21c3dcc1716784fc$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $bCA3C.assertArgument)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $21c3dcc1716784fc$export$1f26277db27165ba(value) {
    (0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(value, true), "invalid data", "value", value);
    return value;
}
function $21c3dcc1716784fc$export$bb5bc852e1c64b88(value) {
    (0, $bCA3C.assertArgument)((0, $k39Yy.isHexString)(value, 32), "invalid hash", "value", value);
    return value;
}
function $21c3dcc1716784fc$export$aff4fda55e7ac0d6(value) {
    if (!(0, $k39Yy.isHexString)(value)) throw new Error("invalid uint256");
    return (0, $k39Yy.zeroPadValue)(value, 32);
}
const $21c3dcc1716784fc$var$_formatLog = $21c3dcc1716784fc$export$be5493f9613cbbe({
    address: (0, $hbt3Q.getAddress),
    blockHash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
    blockNumber: (0, $ltdtW.getNumber),
    data: $21c3dcc1716784fc$export$1f26277db27165ba,
    index: (0, $ltdtW.getNumber),
    removed: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$7a3be81718959bda, false),
    topics: $21c3dcc1716784fc$export$e57ff0f701c44363($21c3dcc1716784fc$export$bb5bc852e1c64b88),
    transactionHash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
    transactionIndex: (0, $ltdtW.getNumber)
}, {
    index: [
        "logIndex"
    ]
});
function $21c3dcc1716784fc$export$fccdbdc2b9d7893(value) {
    return $21c3dcc1716784fc$var$_formatLog(value);
}
const $21c3dcc1716784fc$var$_formatBlock = $21c3dcc1716784fc$export$be5493f9613cbbe({
    hash: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$bb5bc852e1c64b88),
    parentHash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$bb5bc852e1c64b88, null),
    number: (0, $ltdtW.getNumber),
    timestamp: (0, $ltdtW.getNumber),
    nonce: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$1f26277db27165ba),
    difficulty: (0, $ltdtW.getBigInt),
    gasLimit: (0, $ltdtW.getBigInt),
    gasUsed: (0, $ltdtW.getBigInt),
    stateRoot: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$bb5bc852e1c64b88, null),
    receiptsRoot: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$bb5bc852e1c64b88, null),
    blobGasUsed: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt), null),
    excessBlobGas: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt), null),
    miner: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $hbt3Q.getAddress)),
    prevRandao: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$bb5bc852e1c64b88, null),
    extraData: $21c3dcc1716784fc$export$1f26277db27165ba,
    baseFeePerGas: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt))
}, {
    prevRandao: [
        "mixHash"
    ]
});
function $21c3dcc1716784fc$export$ba1152bc4017d62a(value) {
    const result = $21c3dcc1716784fc$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $21c3dcc1716784fc$export$fe50e42b325965d(tx);
    });
    return result;
}
const $21c3dcc1716784fc$var$_formatReceiptLog = $21c3dcc1716784fc$export$be5493f9613cbbe({
    transactionIndex: (0, $ltdtW.getNumber),
    blockNumber: (0, $ltdtW.getNumber),
    transactionHash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
    address: (0, $hbt3Q.getAddress),
    topics: $21c3dcc1716784fc$export$e57ff0f701c44363($21c3dcc1716784fc$export$bb5bc852e1c64b88),
    data: $21c3dcc1716784fc$export$1f26277db27165ba,
    index: (0, $ltdtW.getNumber),
    blockHash: $21c3dcc1716784fc$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $21c3dcc1716784fc$export$5ec2fc59e0e92b87(value) {
    return $21c3dcc1716784fc$var$_formatReceiptLog(value);
}
const $21c3dcc1716784fc$var$_formatTransactionReceipt = $21c3dcc1716784fc$export$be5493f9613cbbe({
    to: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $hbt3Q.getAddress), null),
    from: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $hbt3Q.getAddress), null),
    contractAddress: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $hbt3Q.getAddress), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $ltdtW.getNumber),
    root: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $k39Yy.hexlify)),
    gasUsed: (0, $ltdtW.getBigInt),
    blobGasUsed: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt), null),
    logsBloom: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$1f26277db27165ba),
    blockHash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
    hash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
    logs: $21c3dcc1716784fc$export$e57ff0f701c44363($21c3dcc1716784fc$export$5ec2fc59e0e92b87),
    blockNumber: (0, $ltdtW.getNumber),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $ltdtW.getBigInt),
    effectiveGasPrice: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt)),
    blobGasPrice: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt), null),
    status: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getNumber)),
    type: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getNumber), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $21c3dcc1716784fc$export$30da670e49d6fc31(value) {
    return $21c3dcc1716784fc$var$_formatTransactionReceipt(value);
}
function $21c3dcc1716784fc$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $ltdtW.getBigInt)(value.to) === $21c3dcc1716784fc$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $21c3dcc1716784fc$export$be5493f9613cbbe({
        hash: $21c3dcc1716784fc$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getNumber), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $ltdtW.getNumber)(value);
        },
        accessList: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $7E40U.accessListify), null),
        blobVersionedHashes: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$e57ff0f701c44363($21c3dcc1716784fc$export$bb5bc852e1c64b88, true), null),
        blockHash: $21c3dcc1716784fc$export$4b08254e38b74fcd($21c3dcc1716784fc$export$bb5bc852e1c64b88, null),
        blockNumber: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getNumber), null),
        transactionIndex: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getNumber), null),
        from: (0, $hbt3Q.getAddress),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt)),
        maxPriorityFeePerGas: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt)),
        maxFeePerGas: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt)),
        maxFeePerBlobGas: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt), null),
        gasLimit: (0, $ltdtW.getBigInt),
        to: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $hbt3Q.getAddress), null),
        value: (0, $ltdtW.getBigInt),
        nonce: (0, $ltdtW.getNumber),
        data: $21c3dcc1716784fc$export$1f26277db27165ba,
        creates: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $hbt3Q.getAddress), null),
        chainId: $21c3dcc1716784fc$export$4b08254e38b74fcd((0, $ltdtW.getBigInt), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $2VJZB.getCreateAddress)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $ba4Oi.Signature).from(value.signature);
    else result.signature = (0, $ba4Oi.Signature).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $ltdtW.getBigInt)(result.blockHash) === $21c3dcc1716784fc$var$BN_0) result.blockHash = null;
    return result;
}

});
parcelRegister("2VJZB", function(module, exports) {

$parcel$export(module.exports, "getCreateAddress", function () { return $222494d4cd70284b$export$769b627a7e45189e; });
parcelRequire("iJHOx");
var $eL5Ay = parcelRequire("eL5Ay");

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
var $lyqDW = parcelRequire("lyqDW");
var $ltdtW = parcelRequire("ltdtW");

var $hbt3Q = parcelRequire("hbt3Q");
function $222494d4cd70284b$export$769b627a7e45189e(tx) {
    const from = (0, $hbt3Q.getAddress)(tx.from);
    const nonce = (0, $ltdtW.getBigInt)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $hbt3Q.getAddress)((0, $k39Yy.dataSlice)((0, $eL5Ay.keccak256)((0, $lyqDW.encodeRlp)([
        from,
        nonceHex
    ])), 12));
}
function $222494d4cd70284b$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $hbt3Q.getAddress)(_from);
    const salt = (0, $k39Yy.getBytes)(_salt, "salt");
    const initCodeHash = (0, $k39Yy.getBytes)(_initCodeHash, "initCodeHash");
    (0, $bCA3C.assertArgument)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $bCA3C.assertArgument)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $hbt3Q.getAddress)((0, $k39Yy.dataSlice)((0, $eL5Ay.keccak256)((0, $k39Yy.concat)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}

});


parcelRegister("crad7", function(module, exports) {

$parcel$export(module.exports, "Network", function () { return $90dfed44c886c34b$export$95be4ae94445245a; });
/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 
var $7E40U = parcelRequire("7E40U");

var $bCA3C = parcelRequire("bCA3C");
var $ltdtW = parcelRequire("ltdtW");

var $e38uR = parcelRequire("e38uR");
/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $90dfed44c886c34b$var$Networks = new Map();
class $90dfed44c886c34b$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $ltdtW.getBigInt)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $ltdtW.getBigInt)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $ltdtW.getBigInt)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $ltdtW.getBigInt)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $ltdtW.getBigInt)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $90dfed44c886c34b$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $e38uR.GasCostPlugin)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $7E40U.accessListify)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $90dfed44c886c34b$var$injectCommonNetworks();
        // Default network
        if (network == null) return $90dfed44c886c34b$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $90dfed44c886c34b$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $90dfed44c886c34b$export$95be4ae94445245a("unknown", network);
            (0, $bCA3C.assertArgument)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $bCA3C.assertArgument)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $90dfed44c886c34b$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $e38uR.EnsPlugin)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $bCA3C.assertArgument)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $90dfed44c886c34b$var$Networks.get(nameOrChainId);
        if (existing) (0, $bCA3C.assertArgument)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $90dfed44c886c34b$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $90dfed44c886c34b$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $90dfed44c886c34b$var$getGasStationPlugin(url) {
    return new (0, $e38uR.FetchUrlFeeDataNetworkPlugin)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $90dfed44c886c34b$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $90dfed44c886c34b$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $bCA3C.assert)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $90dfed44c886c34b$var$injected = false;
function $90dfed44c886c34b$var$injectCommonNetworks() {
    if ($90dfed44c886c34b$var$injected) return;
    $90dfed44c886c34b$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $90dfed44c886c34b$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $e38uR.EnsPlugin)(null, options.ensNetwork));
            network.attachPlugin(new (0, $e38uR.GasCostPlugin)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $90dfed44c886c34b$export$95be4ae94445245a.register(name, func);
        $90dfed44c886c34b$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $90dfed44c886c34b$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("linea-sepolia", 59141, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $90dfed44c886c34b$var$getGasStationPlugin("https:/\/gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-amoy", 80002, {});
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $90dfed44c886c34b$var$getGasStationPlugin("https:/\/gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}

});
parcelRegister("e38uR", function(module, exports) {

$parcel$export(module.exports, "GasCostPlugin", function () { return $02a3bdac7100733c$export$f2b0810a2dd50377; });
$parcel$export(module.exports, "EnsPlugin", function () { return $02a3bdac7100733c$export$9be0b2c573890879; });
$parcel$export(module.exports, "FetchUrlFeeDataNetworkPlugin", function () { return $02a3bdac7100733c$export$3bee30f9880d72e8; });

var $b74mN = parcelRequire("b74mN");

var $bCA3C = parcelRequire("bCA3C");
const $02a3bdac7100733c$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $02a3bdac7100733c$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $b74mN.defineProperties)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $02a3bdac7100733c$export$10ae60faeb7e2196(this.name);
    }
}
class $02a3bdac7100733c$export$f2b0810a2dd50377 extends $02a3bdac7100733c$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $bCA3C.assertArgument)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $b74mN.defineProperties)(this, props);
    }
    clone() {
        return new $02a3bdac7100733c$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $02a3bdac7100733c$export$9be0b2c573890879 extends $02a3bdac7100733c$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $b74mN.defineProperties)(this, {
            address: address || $02a3bdac7100733c$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $02a3bdac7100733c$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $02a3bdac7100733c$export$dd49482b7e9ea2da extends $02a3bdac7100733c$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $02a3bdac7100733c$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $02a3bdac7100733c$export$3bee30f9880d72e8 extends $02a3bdac7100733c$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 

});


parcelRegister("dgf09", function(module, exports) {

$parcel$export(module.exports, "PollingBlockSubscriber", function () { return $9a7867f0f76952da$export$aaf796a16ac1a157; });
$parcel$export(module.exports, "PollingTransactionSubscriber", function () { return $9a7867f0f76952da$export$4fe8a9740765f97e; });
$parcel$export(module.exports, "PollingBlockTagSubscriber", function () { return $9a7867f0f76952da$export$63862f83f14090ef; });
$parcel$export(module.exports, "PollingOrphanSubscriber", function () { return $9a7867f0f76952da$export$e4ed5c6414dc4e9e; });
$parcel$export(module.exports, "PollingEventSubscriber", function () { return $9a7867f0f76952da$export$bdb759dc2fe68c72; });

var $bCA3C = parcelRequire("bCA3C");
var $k39Yy = parcelRequire("k39Yy");
function $9a7867f0f76952da$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $9a7867f0f76952da$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $9a7867f0f76952da$export$aaf796a16ac1a157(provider);
    if ((0, $k39Yy.isHexString)(event, 32)) return new $9a7867f0f76952da$export$4fe8a9740765f97e(provider, event);
    (0, $bCA3C.assert)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $9a7867f0f76952da$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $9a7867f0f76952da$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $9a7867f0f76952da$export$63862f83f14090ef extends $9a7867f0f76952da$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $9a7867f0f76952da$export$e4ed5c6414dc4e9e extends $9a7867f0f76952da$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $9a7867f0f76952da$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $9a7867f0f76952da$export$4fe8a9740765f97e extends $9a7867f0f76952da$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $9a7867f0f76952da$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $9a7867f0f76952da$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $9a7867f0f76952da$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}

});


parcelRegister("fEc8Y", function(module, exports) {

$parcel$export(module.exports, "AbstractSigner", function () { return $b64402f526580469$export$6c02143914c373f1; });
/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 
var $9XxdG = parcelRequire("9XxdG");

var $df9mn = parcelRequire("df9mn");

var $bCA3C = parcelRequire("bCA3C");
var $b74mN = parcelRequire("b74mN");
var $ltdtW = parcelRequire("ltdtW");

var $7EGwX = parcelRequire("7EGwX");
function $b64402f526580469$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $bCA3C.assert)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $b64402f526580469$var$populate(signer, tx) {
    let pop = (0, $7EGwX.copyRequest)(tx);
    if (pop.to != null) pop.to = (0, $9XxdG.resolveAddress)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $9XxdG.resolveAddress)(from, signer)
        ]).then(([address, from])=>{
            (0, $bCA3C.assertArgument)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $b74mN.resolveProperties)(pop);
}
class $b64402f526580469$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $b74mN.defineProperties)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $b64402f526580469$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $b64402f526580469$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $b64402f526580469$var$checkProvider(this, "populateTransaction");
        const pop = await $b64402f526580469$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $ltdtW.getBigInt)(pop.chainId);
            (0, $bCA3C.assertArgument)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $bCA3C.assertArgument)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $bCA3C.assertArgument)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $bCA3C.assert)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $bCA3C.assert)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $bCA3C.assert)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2 || pop.type === 3) {
                // Explicitly using EIP-1559 or EIP-4844
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $b74mN.resolveProperties)(pop);
    }
    async estimateGas(tx) {
        return $b64402f526580469$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $b64402f526580469$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $b64402f526580469$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $b64402f526580469$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $df9mn.Transaction).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $b64402f526580469$export$7dbc56d9b9612bad extends $b64402f526580469$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $b74mN.defineProperties)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $b64402f526580469$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $bCA3C.assert)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}

});

parcelRegister("9XYbB", function(module, exports) {

$parcel$export(module.exports, "FilterIdEventSubscriber", function () { return $74184f75c6e695b9$export$60f65cdabb3c5771; });
$parcel$export(module.exports, "FilterIdPendingSubscriber", function () { return $74184f75c6e695b9$export$285511066b2a5499; });

var $bCA3C = parcelRequire("bCA3C");

var $dgf09 = parcelRequire("dgf09");
function $74184f75c6e695b9$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $74184f75c6e695b9$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $bCA3C.isError)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                if (this.#provider.destroyed) return;
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $74184f75c6e695b9$export$60f65cdabb3c5771 extends $74184f75c6e695b9$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $74184f75c6e695b9$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $dgf09.PollingEventSubscriber)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $74184f75c6e695b9$export$285511066b2a5499 extends $74184f75c6e695b9$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}

});


parcelRegister("33qmb", function(module, exports) {

$parcel$export(module.exports, "DisconnectedDevice", function () { return $239618d42c1198af$export$1e42f3936938e063; });
$parcel$export(module.exports, "DisconnectedDeviceDuringOperation", function () { return $239618d42c1198af$export$2a60f41a2ed2742; });
$parcel$export(module.exports, "TransportOpenUserCancelled", function () { return $239618d42c1198af$export$9642f061c2494239; });
$parcel$export(module.exports, "TransportPendingOperation", function () { return $239618d42c1198af$export$a02f8f98115efd5d; });
$parcel$export(module.exports, "TransportError", function () { return $239618d42c1198af$export$8e68de6fb26f2236; });
$parcel$export(module.exports, "StatusCodes", function () { return $239618d42c1198af$export$efd5569f873811b1; });
$parcel$export(module.exports, "getAltStatusMessage", function () { return $239618d42c1198af$export$799566c03457ebd5; });
$parcel$export(module.exports, "TransportStatusError", function () { return $239618d42c1198af$export$78917f4716d96cfe; });
$parcel$export(module.exports, "createCustomErrorClass", function () { return (parcelRequire("9nlr3")).createCustomErrorClass; });

var $9nlr3 = parcelRequire("9nlr3");
const $239618d42c1198af$export$d7dd32b41fc9c3a0 = (0, $9nlr3.createCustomErrorClass)("AccountNameRequired");
const $239618d42c1198af$export$fb9db505804530ec = (0, $9nlr3.createCustomErrorClass)("AccountNotSupported");
const $239618d42c1198af$export$c9d6bf2b06944665 = (0, $9nlr3.createCustomErrorClass)("AmountRequired");
const $239618d42c1198af$export$2628fce2396c23c2 = (0, $9nlr3.createCustomErrorClass)("BluetoothRequired");
const $239618d42c1198af$export$75f8b0767ef406f1 = (0, $9nlr3.createCustomErrorClass)("BtcUnmatchedApp");
const $239618d42c1198af$export$f60aa84fd00bc3ee = (0, $9nlr3.createCustomErrorClass)("CantOpenDevice");
const $239618d42c1198af$export$fc0260506e4022ab = (0, $9nlr3.createCustomErrorClass)("CashAddrNotSupported");
const $239618d42c1198af$export$1e9e90415b859c28 = (0, $9nlr3.createCustomErrorClass)("ClaimRewardsFeesWarning");
const $239618d42c1198af$export$e0b1ec53ba36e221 = (0, $9nlr3.createCustomErrorClass)("CurrencyNotSupported");
const $239618d42c1198af$export$fa9aacd48d3a45c2 = (0, $9nlr3.createCustomErrorClass)("DeviceAppVerifyNotSupported");
const $239618d42c1198af$export$f21ce806524ab8d4 = (0, $9nlr3.createCustomErrorClass)("DeviceGenuineSocketEarlyClose");
const $239618d42c1198af$export$9c30dc6872fcd74c = (0, $9nlr3.createCustomErrorClass)("DeviceNotGenuine");
const $239618d42c1198af$export$1d5ae41b109edf1f = (0, $9nlr3.createCustomErrorClass)("DeviceOnDashboardExpected");
const $239618d42c1198af$export$8eecf64ec9a8cfd7 = (0, $9nlr3.createCustomErrorClass)("DeviceOnDashboardUnexpected");
const $239618d42c1198af$export$a5e2071f1ac48fdd = (0, $9nlr3.createCustomErrorClass)("DeviceInOSUExpected");
const $239618d42c1198af$export$3be6e7231165f4ac = (0, $9nlr3.createCustomErrorClass)("DeviceHalted");
const $239618d42c1198af$export$fa7bfae6dce03474 = (0, $9nlr3.createCustomErrorClass)("DeviceNameInvalid");
const $239618d42c1198af$export$bcce4e5aded80ca0 = (0, $9nlr3.createCustomErrorClass)("DeviceSocketFail");
const $239618d42c1198af$export$944a0f9a7cc1e03a = (0, $9nlr3.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const $239618d42c1198af$export$612d1f6d08d4cfb = (0, $9nlr3.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const $239618d42c1198af$export$5f6bf7cdd5818529 = (0, $9nlr3.createCustomErrorClass)("UnresponsiveDeviceError");
const $239618d42c1198af$export$1e42f3936938e063 = (0, $9nlr3.createCustomErrorClass)("DisconnectedDevice");
const $239618d42c1198af$export$2a60f41a2ed2742 = (0, $9nlr3.createCustomErrorClass)("DisconnectedDeviceDuringOperation");
const $239618d42c1198af$export$93e2040d8e24d646 = (0, $9nlr3.createCustomErrorClass)("DeviceExtractOnboardingStateError");
const $239618d42c1198af$export$e6aaf90bcb4b2013 = (0, $9nlr3.createCustomErrorClass)("DeviceOnboardingStatePollingError");
const $239618d42c1198af$export$cfbd0adf8f9fdaf9 = (0, $9nlr3.createCustomErrorClass)("EnpointConfig");
const $239618d42c1198af$export$96d8d3c501f1625 = (0, $9nlr3.createCustomErrorClass)("EthAppPleaseEnableContractData");
const $239618d42c1198af$export$37b49553b7172cb1 = (0, $9nlr3.createCustomErrorClass)("FeeEstimationFailed");
const $239618d42c1198af$export$d00fd6c398a70fd9 = (0, $9nlr3.createCustomErrorClass)("FirmwareNotRecognized");
const $239618d42c1198af$export$3dc3bbf8c134219c = (0, $9nlr3.createCustomErrorClass)("HardResetFail");
const $239618d42c1198af$export$5e8f7ae1054a2777 = (0, $9nlr3.createCustomErrorClass)("InvalidXRPTag");
const $239618d42c1198af$export$953b602d2269ceba = (0, $9nlr3.createCustomErrorClass)("InvalidAddress");
const $239618d42c1198af$export$61e75f453df94067 = (0, $9nlr3.createCustomErrorClass)("InvalidNonce");
const $239618d42c1198af$export$bbdaf7c77a7508eb = (0, $9nlr3.createCustomErrorClass)("InvalidAddressBecauseDestinationIsAlsoSource");
const $239618d42c1198af$export$882967e2980534f9 = (0, $9nlr3.createCustomErrorClass)("LatestMCUInstalledError");
const $239618d42c1198af$export$59772a13ac97df0e = (0, $9nlr3.createCustomErrorClass)("UnknownMCU");
const $239618d42c1198af$export$26bf4f7c63d50901 = (0, $9nlr3.createCustomErrorClass)("LedgerAPIError");
const $239618d42c1198af$export$fdab6afd1b1820af = (0, $9nlr3.createCustomErrorClass)("LedgerAPIErrorWithMessage");
const $239618d42c1198af$export$c2996b38942cf758 = (0, $9nlr3.createCustomErrorClass)("LedgerAPINotAvailable");
const $239618d42c1198af$export$3d81abcc61613a27 = (0, $9nlr3.createCustomErrorClass)("ManagerAppAlreadyInstalled");
const $239618d42c1198af$export$87a9bff9fff141e2 = (0, $9nlr3.createCustomErrorClass)("ManagerAppRelyOnBTC");
const $239618d42c1198af$export$86581a722c4238c0 = (0, $9nlr3.createCustomErrorClass)("ManagerAppDepInstallRequired");
const $239618d42c1198af$export$267a8476044885dd = (0, $9nlr3.createCustomErrorClass)("ManagerAppDepUninstallRequired");
const $239618d42c1198af$export$bb771ca417eca344 = (0, $9nlr3.createCustomErrorClass)("ManagerDeviceLocked");
const $239618d42c1198af$export$b634ce25e3ff5229 = (0, $9nlr3.createCustomErrorClass)("ManagerFirmwareNotEnoughSpace");
const $239618d42c1198af$export$2d26f4eadfe37285 = (0, $9nlr3.createCustomErrorClass)("ManagerNotEnoughSpace");
const $239618d42c1198af$export$ceb7f9bef5a1e481 = (0, $9nlr3.createCustomErrorClass)("ManagerUninstallBTCDep");
const $239618d42c1198af$export$baadb6886fde1621 = (0, $9nlr3.createCustomErrorClass)("NetworkDown");
const $239618d42c1198af$export$bae979e68e4dc802 = (0, $9nlr3.createCustomErrorClass)("NetworkError");
const $239618d42c1198af$export$5cbfa0659f97216a = (0, $9nlr3.createCustomErrorClass)("NoAddressesFound");
const $239618d42c1198af$export$9e00aead3515e5c9 = (0, $9nlr3.createCustomErrorClass)("NotEnoughBalance");
const $239618d42c1198af$export$5ed90e0e011f4857 = (0, $9nlr3.createCustomErrorClass)("NotEnoughBalanceToDelegate");
const $239618d42c1198af$export$75178c95e66d9630 = (0, $9nlr3.createCustomErrorClass)("NotEnoughBalanceInParentAccount");
const $239618d42c1198af$export$e3e2865b29f7e0b0 = (0, $9nlr3.createCustomErrorClass)("NotEnoughSpendableBalance");
const $239618d42c1198af$export$a84b3634866707ea = (0, $9nlr3.createCustomErrorClass)("NotEnoughBalanceBecauseDestinationNotCreated");
const $239618d42c1198af$export$a282f858b69a7326 = (0, $9nlr3.createCustomErrorClass)("NoAccessToCamera");
const $239618d42c1198af$export$5111c405c5cacc97 = (0, $9nlr3.createCustomErrorClass)("NotEnoughGas");
const $239618d42c1198af$export$1cb5c4489aaca4d6 = (0, $9nlr3.createCustomErrorClass)("NotEnoughGasSwap");
const $239618d42c1198af$export$626e1fd20d22139c = (0, $9nlr3.createCustomErrorClass)("NotSupportedLegacyAddress");
const $239618d42c1198af$export$f919e2c9c746346b = (0, $9nlr3.createCustomErrorClass)("GasLessThanEstimate");
const $239618d42c1198af$export$cc562f3706902d22 = (0, $9nlr3.createCustomErrorClass)("PriorityFeeTooLow");
const $239618d42c1198af$export$ee14d05cd43eb762 = (0, $9nlr3.createCustomErrorClass)("PriorityFeeTooHigh");
const $239618d42c1198af$export$931458f4b7d53154 = (0, $9nlr3.createCustomErrorClass)("PriorityFeeHigherThanMaxFee");
const $239618d42c1198af$export$c0ce9cadb94c6b86 = (0, $9nlr3.createCustomErrorClass)("MaxFeeTooLow");
const $239618d42c1198af$export$22c5aa8937c5b423 = (0, $9nlr3.createCustomErrorClass)("PasswordsDontMatch");
const $239618d42c1198af$export$f57670cd1aaf386 = (0, $9nlr3.createCustomErrorClass)("PasswordIncorrect");
const $239618d42c1198af$export$3ba22bf10deb1448 = (0, $9nlr3.createCustomErrorClass)("RecommendSubAccountsToEmpty");
const $239618d42c1198af$export$33f73085e1b7871b = (0, $9nlr3.createCustomErrorClass)("RecommendUndelegation");
const $239618d42c1198af$export$cd4d967a66d81060 = (0, $9nlr3.createCustomErrorClass)("TimeoutTagged");
const $239618d42c1198af$export$9375635756d6156e = (0, $9nlr3.createCustomErrorClass)("UnexpectedBootloader");
const $239618d42c1198af$export$90478a5d08d6c2d7 = (0, $9nlr3.createCustomErrorClass)("MCUNotGenuineToDashboard");
const $239618d42c1198af$export$132f0197eaa65535 = (0, $9nlr3.createCustomErrorClass)("RecipientRequired");
const $239618d42c1198af$export$7aee729193ab77ba = (0, $9nlr3.createCustomErrorClass)("UnavailableTezosOriginatedAccountReceive");
const $239618d42c1198af$export$4ec11dc947a3c9d6 = (0, $9nlr3.createCustomErrorClass)("UnavailableTezosOriginatedAccountSend");
const $239618d42c1198af$export$5e3ed85b946872a1 = (0, $9nlr3.createCustomErrorClass)("UpdateFetchFileFail");
const $239618d42c1198af$export$5db6383ad081f01e = (0, $9nlr3.createCustomErrorClass)("UpdateIncorrectHash");
const $239618d42c1198af$export$92c199eb837d8df8 = (0, $9nlr3.createCustomErrorClass)("UpdateIncorrectSig");
const $239618d42c1198af$export$85e0c017833c894c = (0, $9nlr3.createCustomErrorClass)("UpdateYourApp");
const $239618d42c1198af$export$84115f1b54c874b3 = (0, $9nlr3.createCustomErrorClass)("UserRefusedDeviceNameChange");
const $239618d42c1198af$export$3f4864efb1638333 = (0, $9nlr3.createCustomErrorClass)("UserRefusedAddress");
const $239618d42c1198af$export$d777e0ef77faca34 = (0, $9nlr3.createCustomErrorClass)("UserRefusedFirmwareUpdate");
const $239618d42c1198af$export$3d8a4f08cd3eb133 = (0, $9nlr3.createCustomErrorClass)("UserRefusedAllowManager");
const $239618d42c1198af$export$db9b724c3524b5d6 = (0, $9nlr3.createCustomErrorClass)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $239618d42c1198af$export$65df6bdf4eb29653 = (0, $9nlr3.createCustomErrorClass)("ExpertModeRequired");
const $239618d42c1198af$export$9642f061c2494239 = (0, $9nlr3.createCustomErrorClass)("TransportOpenUserCancelled");
const $239618d42c1198af$export$fd71e3a51c4bf0ae = (0, $9nlr3.createCustomErrorClass)("TransportInterfaceNotAvailable");
const $239618d42c1198af$export$a02f8f98115efd5d = (0, $9nlr3.createCustomErrorClass)("TransportPendingOperation");
const $239618d42c1198af$export$c0ffbdd94649bd06 = (0, $9nlr3.createCustomErrorClass)("TransportWebUSBGestureRequired");
const $239618d42c1198af$export$28149f687a2e30c9 = (0, $9nlr3.createCustomErrorClass)("TransactionHasBeenValidatedError");
const $239618d42c1198af$export$448663d307bde953 = (0, $9nlr3.createCustomErrorClass)("TransportExchangeTimeoutError");
const $239618d42c1198af$export$4800af3cc6204928 = (0, $9nlr3.createCustomErrorClass)("DeviceShouldStayInApp");
const $239618d42c1198af$export$101490ec073327e1 = (0, $9nlr3.createCustomErrorClass)("WebsocketConnectionError");
const $239618d42c1198af$export$219228963d86b069 = (0, $9nlr3.createCustomErrorClass)("WebsocketConnectionFailed");
const $239618d42c1198af$export$25b49ca0efdfe5d1 = (0, $9nlr3.createCustomErrorClass)("WrongDeviceForAccount");
const $239618d42c1198af$export$4de3709f8e2844ca = (0, $9nlr3.createCustomErrorClass)("WrongDeviceForAccountPayout");
const $239618d42c1198af$export$b7651c38a977157 = (0, $9nlr3.createCustomErrorClass)("WrongDeviceForAccountRefund");
const $239618d42c1198af$export$63498b46122d8a23 = (0, $9nlr3.createCustomErrorClass)("WrongAppForCurrency");
const $239618d42c1198af$export$707f317a4761c46d = (0, $9nlr3.createCustomErrorClass)("ETHAddressNonEIP");
const $239618d42c1198af$export$a5d8da2f27618c16 = (0, $9nlr3.createCustomErrorClass)("CantScanQRCode");
const $239618d42c1198af$export$3f2d8a7775aab6cc = (0, $9nlr3.createCustomErrorClass)("FeeNotLoaded");
const $239618d42c1198af$export$3ae46f8c8f45dbe7 = (0, $9nlr3.createCustomErrorClass)("FeeNotLoadedSwap");
const $239618d42c1198af$export$ffbf6641e9ab88d3 = (0, $9nlr3.createCustomErrorClass)("FeeRequired");
const $239618d42c1198af$export$53e797c2fa09aff3 = (0, $9nlr3.createCustomErrorClass)("FeeTooHigh");
const $239618d42c1198af$export$cb0b645e3d7170ab = (0, $9nlr3.createCustomErrorClass)("PendingOperation");
const $239618d42c1198af$export$2aca4567d80fd933 = (0, $9nlr3.createCustomErrorClass)("SyncError");
const $239618d42c1198af$export$a2d6658d365c43df = (0, $9nlr3.createCustomErrorClass)("PairingFailed");
const $239618d42c1198af$export$4400fa093e7d20ad = (0, $9nlr3.createCustomErrorClass)("PeerRemovedPairing");
const $239618d42c1198af$export$3f7ba18f3c84cced = (0, $9nlr3.createCustomErrorClass)("GenuineCheckFailed");
const $239618d42c1198af$export$437e6aac14cab3d9 = (0, $9nlr3.createCustomErrorClass)("LedgerAPI4xx");
const $239618d42c1198af$export$309835543e52bf92 = (0, $9nlr3.createCustomErrorClass)("LedgerAPI5xx");
const $239618d42c1198af$export$c282cdb2f7fdc27a = (0, $9nlr3.createCustomErrorClass)("FirmwareOrAppUpdateRequired");
const $239618d42c1198af$export$aba9024c0d586a15 = (0, $9nlr3.createCustomErrorClass)("ReplacementTransactionUnderpriced");
const $239618d42c1198af$export$51a1e1b4f21df9f4 = (0, $9nlr3.createCustomErrorClass)("OpReturnSizeLimit");
const $239618d42c1198af$export$1d49177380419e3d = (0, $9nlr3.createCustomErrorClass)("DustLimit");
const $239618d42c1198af$export$28f62a162580c9c2 = (0, $9nlr3.createCustomErrorClass)("LanguageNotFound");
const $239618d42c1198af$export$d3cadb9f4e1fa40d = (0, $9nlr3.createCustomErrorClass)("NoDBPathGiven");
const $239618d42c1198af$export$de46c919e379f03f = (0, $9nlr3.createCustomErrorClass)("DBWrongPassword");
const $239618d42c1198af$export$e1c94c135b0a553e = (0, $9nlr3.createCustomErrorClass)("DBNotReset");
const $239618d42c1198af$export$35de8a1f557fb8bb = (0, $9nlr3.createCustomErrorClass)("SequenceNumberError");
const $239618d42c1198af$export$df2168717eaf23c6 = (0, $9nlr3.createCustomErrorClass)("DisabledTransactionBroadcastError");
var $239618d42c1198af$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($239618d42c1198af$export$62e86095f76df800 || ($239618d42c1198af$export$62e86095f76df800 = {}));
class $239618d42c1198af$export$ef5ffbe444ecd147 extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $239618d42c1198af$export$ef5ffbe444ecd147.prototype);
    }
}
class $239618d42c1198af$export$8e68de6fb26f2236 extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $9nlr3.addCustomErrorDeserializer)("TransportError", (e)=>new $239618d42c1198af$export$8e68de6fb26f2236(e.message, e.id));
const $239618d42c1198af$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CUSTOM_IMAGE_BOOTLOADER: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102
};
function $239618d42c1198af$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class $239618d42c1198af$export$78917f4716d96cfe extends Error {
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError: canBeMappedToChildError = true } = {}){
        const statusText = Object.keys($239618d42c1198af$export$efd5569f873811b1).find((k)=>$239618d42c1198af$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = $239618d42c1198af$export$799566c03457ebd5(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, $239618d42c1198af$export$78917f4716d96cfe.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $239618d42c1198af$export$efd5569f873811b1.LOCKED_DEVICE) return new $239618d42c1198af$export$1fb6667702a70644(message);
    }
}
class $239618d42c1198af$export$1fb6667702a70644 extends $239618d42c1198af$export$78917f4716d96cfe {
    constructor(message){
        super($239618d42c1198af$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, $239618d42c1198af$export$1fb6667702a70644.prototype);
    }
}
(0, $9nlr3.addCustomErrorDeserializer)("TransportStatusError", (e)=>new $239618d42c1198af$export$78917f4716d96cfe(e.statusCode));

});
parcelRegister("9nlr3", function(module, exports) {

$parcel$export(module.exports, "addCustomErrorDeserializer", function () { return $6d36e3a7c07eec8e$export$ff6248acd0c27a3f; });
$parcel$export(module.exports, "createCustomErrorClass", function () { return $6d36e3a7c07eec8e$export$94baff7bf5134824; });
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $6d36e3a7c07eec8e$var$errorClasses = {};
const $6d36e3a7c07eec8e$var$deserializers = {};
const $6d36e3a7c07eec8e$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $6d36e3a7c07eec8e$var$deserializers[name] = deserializer;
};
const $6d36e3a7c07eec8e$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $6d36e3a7c07eec8e$var$isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $6d36e3a7c07eec8e$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $6d36e3a7c07eec8e$var$isObject(value) {
    return typeof value === "object";
}
const $6d36e3a7c07eec8e$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $6d36e3a7c07eec8e$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $6d36e3a7c07eec8e$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $6d36e3a7c07eec8e$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $6d36e3a7c07eec8e$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $6d36e3a7c07eec8e$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $6d36e3a7c07eec8e$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $6d36e3a7c07eec8e$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $6d36e3a7c07eec8e$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}

});


parcelRegister("gLGU9", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("4135D"),
    $parcel$import("csTDN")
]).then(()=>parcelRequire('lN1kQ'));

});

parcelRegister("7XZVE", function(module, exports) {
module.exports = $parcel$import("letUy").then(()=>parcelRequire('7usvA'));

});

parcelRegister("8uJJT", function(module, exports) {
module.exports = $parcel$import("9RLFH").then(()=>parcelRequire('fMDeY'));

});

parcelRegister("5lj4U", function(module, exports) {

$parcel$export(module.exports, "SUI_MAINNET_CHAIN", function () { return $3e3db673a215f663$export$bbf5c270d4179b0c; });
const $3e3db673a215f663$export$f7a141fb150b747e = "sui:devnet";
const $3e3db673a215f663$export$b8c866317be37a8e = "sui:testnet";
const $3e3db673a215f663$export$6d1702353b14155f = "sui:localnet";
const $3e3db673a215f663$export$bbf5c270d4179b0c = "sui:mainnet";
const $3e3db673a215f663$export$c0b8ddb30576b6b5 = [
    $3e3db673a215f663$export$f7a141fb150b747e,
    $3e3db673a215f663$export$b8c866317be37a8e,
    $3e3db673a215f663$export$6d1702353b14155f,
    $3e3db673a215f663$export$bbf5c270d4179b0c
];
function $3e3db673a215f663$export$5ff0c9b8bfbf819e(chain) {
    return $3e3db673a215f663$export$c0b8ddb30576b6b5.includes(chain);
}

});

parcelRegister("4dXbr", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("lP2G7"),
    $parcel$import("hFfD2")
]).then(()=>parcelRequire('6NoiM'));

});

parcelRegister("3tfzf", function(module, exports) {
module.exports = $parcel$import("bnVuC").then(()=>parcelRequire('hZZY1'));

});

parcelRegister("41i2w", function(module, exports) {

$parcel$export(module.exports, "sdk", function () { return $be45c15929ef8447$export$2bd721eefbd23f7b; });
$parcel$export(module.exports, "getSafeInstance", function () { return $be45c15929ef8447$export$1dfff23d73f0d87c; });

var $PKui7 = parcelRequire("PKui7");

var $etJiI = parcelRequire("etJiI");
const $be45c15929ef8447$var$options = {
    debug: false
};
/*
 * similar to:
 * https://github.com/wagmi-dev/references/pull/114
 */ let $be45c15929ef8447$var$SDK = (0, $etJiI.default);
if (typeof (0, $etJiI.default) !== 'function' && // @ts-expect-error This import error is not visible to TypeScript
typeof (0, $etJiI.default).default === 'function') $be45c15929ef8447$var$SDK = (0, $etJiI.default).default;
const $be45c15929ef8447$export$2bd721eefbd23f7b = new $be45c15929ef8447$var$SDK($be45c15929ef8447$var$options);
async function $be45c15929ef8447$export$1dfff23d73f0d87c() {
    const timeout = 200;
    const accountInfo = await Promise.race([
        $be45c15929ef8447$export$2bd721eefbd23f7b.safe.getInfo(),
        new Promise((resolve)=>setTimeout(resolve, timeout))
    ]);
    return accountInfo ? new (0, $PKui7.SafeAppProvider)(accountInfo, $be45c15929ef8447$export$2bd721eefbd23f7b) : null;
}

});
parcelRegister("PKui7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppProvider = void 0;

var $dQ9CX = parcelRequire("dQ9CX");
Object.defineProperty(module.exports, "SafeAppProvider", {
    enumerable: true,
    get: function() {
        return $dQ9CX.SafeAppProvider;
    }
});

});
parcelRegister("dQ9CX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppProvider = void 0;

var $jMc9N = parcelRequire("jMc9N");

var $80lMI = parcelRequire("80lMI");
// The API is based on Ethereum JavaScript API Provider Standard. Link: https://eips.ethereum.org/EIPS/eip-1193
class $a13799752ee310ac$var$SafeAppProvider extends $jMc9N.EventEmitter {
    constructor(safe, sdk){
        super();
        this.submittedTxs = new Map();
        this.safe = safe;
        this.sdk = sdk;
    }
    async connect() {
        this.emit('connect', {
            chainId: this.chainId
        });
        return;
    }
    async disconnect() {
        return;
    }
    get chainId() {
        return this.safe.chainId;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async request(request) {
        const { method: method, params: params = [] } = request;
        switch(method){
            case 'eth_accounts':
                return [
                    this.safe.safeAddress
                ];
            case 'net_version':
            case 'eth_chainId':
                return `0x${this.chainId.toString(16)}`;
            case 'personal_sign':
                {
                    const [message, address] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error('The address or message hash is invalid');
                    const response = await this.sdk.txs.signMessage(message);
                    const signature = 'signature' in response ? response.signature : undefined;
                    return signature || '0x';
                }
            case 'eth_sign':
                {
                    const [address, messageHash] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase() || !messageHash.startsWith('0x')) throw new Error('The address or message hash is invalid');
                    const response = await this.sdk.txs.signMessage(messageHash);
                    const signature = 'signature' in response ? response.signature : undefined;
                    return signature || '0x';
                }
            case 'eth_signTypedData':
            case 'eth_signTypedData_v4':
                {
                    const [address, typedData] = params;
                    const parsedTypedData = typeof typedData === 'string' ? JSON.parse(typedData) : typedData;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error('The address is invalid');
                    const response = await this.sdk.txs.signTypedMessage(parsedTypedData);
                    const signature = 'signature' in response ? response.signature : undefined;
                    return signature || '0x';
                }
            case 'eth_sendTransaction':
                const tx = Object.assign({
                    value: '0',
                    data: '0x'
                }, params[0]);
                // Some ethereum libraries might pass the gas as a hex-encoded string
                // We need to convert it to a number because the SDK expects a number and our backend only supports
                // Decimal numbers
                if (typeof tx.gas === 'string' && tx.gas.startsWith('0x')) tx.gas = parseInt(tx.gas, 16);
                const resp = await this.sdk.txs.send({
                    txs: [
                        tx
                    ],
                    params: {
                        safeTxGas: tx.gas
                    }
                });
                // Store fake transaction
                this.submittedTxs.set(resp.safeTxHash, {
                    from: this.safe.safeAddress,
                    hash: resp.safeTxHash,
                    gas: 0,
                    gasPrice: '0x00',
                    nonce: 0,
                    input: tx.data,
                    value: tx.value,
                    to: tx.to,
                    blockHash: null,
                    blockNumber: null,
                    transactionIndex: null
                });
                return resp.safeTxHash;
            case 'eth_blockNumber':
                const block = await this.sdk.eth.getBlockByNumber([
                    'latest'
                ]);
                return block.number;
            case 'eth_getBalance':
                return this.sdk.eth.getBalance([
                    (0, $80lMI.getLowerCase)(params[0]),
                    params[1]
                ]);
            case 'eth_getCode':
                return this.sdk.eth.getCode([
                    (0, $80lMI.getLowerCase)(params[0]),
                    params[1]
                ]);
            case 'eth_getTransactionCount':
                return this.sdk.eth.getTransactionCount([
                    (0, $80lMI.getLowerCase)(params[0]),
                    params[1]
                ]);
            case 'eth_getStorageAt':
                return this.sdk.eth.getStorageAt([
                    (0, $80lMI.getLowerCase)(params[0]),
                    params[1],
                    params[2]
                ]);
            case 'eth_getBlockByNumber':
                return this.sdk.eth.getBlockByNumber([
                    params[0],
                    params[1]
                ]);
            case 'eth_getBlockByHash':
                return this.sdk.eth.getBlockByHash([
                    params[0],
                    params[1]
                ]);
            case 'eth_getTransactionByHash':
                let txHash = params[0];
                try {
                    const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                    txHash = resp.txHash || txHash;
                } catch (e) {}
                // Use fake transaction if we don't have a real tx hash
                if (this.submittedTxs.has(txHash)) return this.submittedTxs.get(txHash);
                return this.sdk.eth.getTransactionByHash([
                    txHash
                ]).then((tx)=>{
                    // We set the tx hash to the one requested, as some provider assert this
                    if (tx) tx.hash = params[0];
                    return tx;
                });
            case 'eth_getTransactionReceipt':
                {
                    let txHash = params[0];
                    try {
                        const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                        txHash = resp.txHash || txHash;
                    } catch (e) {}
                    return this.sdk.eth.getTransactionReceipt([
                        txHash
                    ]).then((tx)=>{
                        // We set the tx hash to the one requested, as some provider assert this
                        if (tx) tx.transactionHash = params[0];
                        return tx;
                    });
                }
            case 'eth_estimateGas':
                return this.sdk.eth.getEstimateGas(params[0]);
            case 'eth_call':
                return this.sdk.eth.call([
                    params[0],
                    params[1]
                ]);
            case 'eth_getLogs':
                return this.sdk.eth.getPastLogs([
                    params[0]
                ]);
            case 'eth_gasPrice':
                return this.sdk.eth.getGasPrice();
            case 'wallet_getPermissions':
                return this.sdk.wallet.getPermissions();
            case 'wallet_requestPermissions':
                return this.sdk.wallet.requestPermissions(params[0]);
            case 'safe_setSettings':
                return this.sdk.eth.setSafeSettings([
                    params[0]
                ]);
            default:
                throw Error(`"${request.method}" not implemented`);
        }
    }
    // this method is needed for ethers v4
    // https://github.com/ethers-io/ethers.js/blob/427e16826eb15d52d25c4f01027f8db22b74b76c/src.ts/providers/web3-provider.ts#L41-L55
    send(request, callback) {
        if (!request) callback('Undefined request');
        this.request(request).then((result)=>callback(null, {
                jsonrpc: '2.0',
                id: request.id,
                result: result
            })).catch((error)=>callback(error, null));
    }
}
module.exports.SafeAppProvider = $a13799752ee310ac$var$SafeAppProvider;

});
parcelRegister("80lMI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLowerCase = void 0;
function $5d3f38ca508068fc$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
module.exports.getLowerCase = $5d3f38ca508068fc$var$getLowerCase;

});



parcelRegister("etJiI", function(module, exports) {
$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("9cgOn")).TransactionStatus; });

$parcel$export(module.exports, "default", function () { return $a8a6e9eee1e0376e$export$2e2bcd8739ae039; });

var $hl7Hj = parcelRequire("hl7Hj");
parcelRequire("2GhJG");
parcelRequire("alqGi");
parcelRequire("4y2tg");

var $e3pnz = parcelRequire("e3pnz");
parcelRequire("flAIP");
var $a8a6e9eee1e0376e$export$2e2bcd8739ae039 = (0, $hl7Hj.default);

});
parcelRegister("hl7Hj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9fa5e6b1ac58531$export$2e2bcd8739ae039; });

var $HPuaT = parcelRequire("HPuaT");

var $02SgE = parcelRequire("02SgE");

var $lNx5y = parcelRequire("lNx5y");

var $4hOCt = parcelRequire("4hOCt");

var $6Xsd7 = parcelRequire("6Xsd7");
class $c9fa5e6b1ac58531$var$SafeAppsSDK {
    constructor(opts = {}){
        const { allowedDomains: allowedDomains = null, debug: debug = false } = opts;
        this.communicator = new (0, $HPuaT.default)(allowedDomains, debug);
        this.eth = new (0, $lNx5y.Eth)(this.communicator);
        this.txs = new (0, $02SgE.TXs)(this.communicator);
        this.safe = new (0, $4hOCt.Safe)(this.communicator);
        this.wallet = new (0, $6Xsd7.Wallet)(this.communicator);
    }
}
var $c9fa5e6b1ac58531$export$2e2bcd8739ae039 = $c9fa5e6b1ac58531$var$SafeAppsSDK;

});
parcelRegister("HPuaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $083bf4408c7893e8$export$2e2bcd8739ae039; });

var $4y2tg = parcelRequire("4y2tg");
parcelRequire("alqGi");
class $083bf4408c7893e8$var$PostMessageCommunicator {
    constructor(allowedOrigins = null, debugMode = false){
        this.allowedOrigins = null;
        this.callbacks = new Map();
        this.debugMode = false;
        this.isServer = typeof window === 'undefined';
        this.isValidMessage = ({ origin: origin, data: data, source: source })=>{
            const emptyOrMalformed = !data;
            const sentFromParentEl = !this.isServer && source === window.parent;
            const majorVersionNumber = typeof data.version !== 'undefined' && parseInt(data.version.split('.')[0]);
            const allowedSDKVersion = typeof majorVersionNumber === 'number' && majorVersionNumber >= 1;
            let validOrigin = true;
            if (Array.isArray(this.allowedOrigins)) validOrigin = this.allowedOrigins.find((regExp)=>regExp.test(origin)) !== undefined;
            return !emptyOrMalformed && sentFromParentEl && allowedSDKVersion && validOrigin;
        };
        this.logIncomingMessage = (msg)=>{
            console.info(`Safe Apps SDK v1: A message was received from origin ${msg.origin}. `, msg.data);
        };
        this.onParentMessage = (msg)=>{
            if (this.isValidMessage(msg)) {
                this.debugMode && this.logIncomingMessage(msg);
                this.handleIncomingMessage(msg.data);
            }
        };
        this.handleIncomingMessage = (payload)=>{
            const { id: id } = payload;
            const cb = this.callbacks.get(id);
            if (cb) {
                cb(payload);
                this.callbacks.delete(id);
            }
        };
        this.send = (method, params)=>{
            const request = (0, $4y2tg.MessageFormatter).makeRequest(method, params);
            if (this.isServer) throw new Error("Window doesn't exist");
            window.parent.postMessage(request, '*');
            return new Promise((resolve, reject)=>{
                this.callbacks.set(request.id, (response)=>{
                    if (!response.success) {
                        reject(new Error(response.error));
                        return;
                    }
                    resolve(response);
                });
            });
        };
        this.allowedOrigins = allowedOrigins;
        this.debugMode = debugMode;
        if (!this.isServer) window.addEventListener('message', this.onParentMessage);
    }
}
var $083bf4408c7893e8$export$2e2bcd8739ae039 = $083bf4408c7893e8$var$PostMessageCommunicator;

});
parcelRegister("4y2tg", function(module, exports) {

$parcel$export(module.exports, "MessageFormatter", function () { return $34fc4112e2edc28b$export$526ebc05ff964723; });

var $e3pnz = parcelRequire("e3pnz");

var $lAY6a = parcelRequire("lAY6a");
class $34fc4112e2edc28b$export$526ebc05ff964723 {
}
$34fc4112e2edc28b$export$526ebc05ff964723.makeRequest = (method, params)=>{
    const id = (0, $lAY6a.generateRequestId)();
    return {
        id: id,
        method: method,
        params: params,
        env: {
            sdkVersion: (0, $e3pnz.getSDKVersion)()
        }
    };
};
$34fc4112e2edc28b$export$526ebc05ff964723.makeResponse = (id, data, version)=>({
        id: id,
        success: true,
        version: version,
        data: data
    });
$34fc4112e2edc28b$export$526ebc05ff964723.makeErrorResponse = (id, error, version)=>({
        id: id,
        success: false,
        error: error,
        version: version
    });

});
parcelRegister("e3pnz", function(module, exports) {

$parcel$export(module.exports, "getSDKVersion", function () { return $a3b508433a02c8a9$export$31f5a83d65f30cbf; });
const $a3b508433a02c8a9$export$31f5a83d65f30cbf = ()=>'9.1.0';

});

parcelRegister("lAY6a", function(module, exports) {

$parcel$export(module.exports, "generateRequestId", function () { return $fb8b9415fb55b628$export$adb840ec535541d1; });
// i.e. 0-255 -> '00'-'ff'
const $fb8b9415fb55b628$var$dec2hex = (dec)=>dec.toString(16).padStart(2, '0');
const $fb8b9415fb55b628$var$generateId = (len)=>{
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, $fb8b9415fb55b628$var$dec2hex).join('');
};
const $fb8b9415fb55b628$export$adb840ec535541d1 = ()=>{
    if (typeof window !== 'undefined') return $fb8b9415fb55b628$var$generateId(10);
    return new Date().getTime().toString(36);
};

});


parcelRegister("alqGi", function(module, exports) {

$parcel$export(module.exports, "Methods", function () { return $78808fdb8e9960bd$export$abe5cd09e951a89a; });
$parcel$export(module.exports, "RestrictedMethods", function () { return $78808fdb8e9960bd$export$4ac6b1b5d280d305; });
var $78808fdb8e9960bd$export$abe5cd09e951a89a;
(function(Methods) {
    Methods["sendTransactions"] = "sendTransactions";
    Methods["rpcCall"] = "rpcCall";
    Methods["getChainInfo"] = "getChainInfo";
    Methods["getSafeInfo"] = "getSafeInfo";
    Methods["getTxBySafeTxHash"] = "getTxBySafeTxHash";
    Methods["getSafeBalances"] = "getSafeBalances";
    Methods["signMessage"] = "signMessage";
    Methods["signTypedMessage"] = "signTypedMessage";
    Methods["getEnvironmentInfo"] = "getEnvironmentInfo";
    Methods["getOffChainSignature"] = "getOffChainSignature";
    Methods["requestAddressBook"] = "requestAddressBook";
    Methods["wallet_getPermissions"] = "wallet_getPermissions";
    Methods["wallet_requestPermissions"] = "wallet_requestPermissions";
})($78808fdb8e9960bd$export$abe5cd09e951a89a || ($78808fdb8e9960bd$export$abe5cd09e951a89a = {}));
var $78808fdb8e9960bd$export$4ac6b1b5d280d305;
(function(RestrictedMethods) {
    RestrictedMethods["requestAddressBook"] = "requestAddressBook";
})($78808fdb8e9960bd$export$4ac6b1b5d280d305 || ($78808fdb8e9960bd$export$4ac6b1b5d280d305 = {}));

});


parcelRegister("02SgE", function(module, exports) {

$parcel$export(module.exports, "TXs", function () { return $008a48706f913f63$export$fb5246409507224d; });

var $alqGi = parcelRequire("alqGi");
parcelRequire("2GhJG");
var $gCn9A = parcelRequire("gCn9A");
class $008a48706f913f63$export$fb5246409507224d {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getBySafeTxHash(safeTxHash) {
        if (!safeTxHash) throw new Error('Invalid safeTxHash');
        const response = await this.communicator.send((0, $alqGi.Methods).getTxBySafeTxHash, {
            safeTxHash: safeTxHash
        });
        return response.data;
    }
    async signMessage(message) {
        const messagePayload = {
            message: message
        };
        const response = await this.communicator.send((0, $alqGi.Methods).signMessage, messagePayload);
        return response.data;
    }
    async signTypedMessage(typedData) {
        if (!(0, $gCn9A.isObjectEIP712TypedData)(typedData)) throw new Error('Invalid typed data');
        const response = await this.communicator.send((0, $alqGi.Methods).signTypedMessage, {
            typedData: typedData
        });
        return response.data;
    }
    async send({ txs: txs, params: params }) {
        if (!txs || !txs.length) throw new Error('No transactions were passed');
        const messagePayload = {
            txs: txs,
            params: params
        };
        const response = await this.communicator.send((0, $alqGi.Methods).sendTransactions, messagePayload);
        return response.data;
    }
}

});
parcelRegister("2GhJG", function(module, exports) {
$parcel$export(module.exports, "isObjectEIP712TypedData", function () { return (parcelRequire("gCn9A")).isObjectEIP712TypedData; });
$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("9cgOn")).TransactionStatus; });
parcelRequire("gCn9A");
parcelRequire("2wWzP");
parcelRequire("1swNV");
parcelRequire("9CPMF");

});
parcelRegister("gCn9A", function(module, exports) {

$parcel$export(module.exports, "isObjectEIP712TypedData", function () { return $c19227c14cce994d$export$a3ca91f403a95d3a; });
const $c19227c14cce994d$export$a3ca91f403a95d3a = (obj)=>{
    return typeof obj === 'object' && obj != null && 'domain' in obj && 'types' in obj && 'message' in obj;
};

});

parcelRegister("2wWzP", function(module, exports) {

});

parcelRegister("1swNV", function(module, exports) {

$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("9cgOn")).TransactionStatus; });

var $9cgOn = parcelRequire("9cgOn");

});
parcelRegister("9cgOn", function(module, exports) {
"use strict";
var $6b224676ea3a0580$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6b224676ea3a0580$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6b224676ea3a0580$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unregisterDevice = module.exports.unregisterSafe = module.exports.registerDevice = module.exports.getDelegates = module.exports.confirmSafeMessage = module.exports.proposeSafeMessage = module.exports.getSafeMessage = module.exports.getSafeMessages = module.exports.getDecodedData = module.exports.getMasterCopies = module.exports.getSafeApps = module.exports.getChainConfig = module.exports.getChainsConfig = module.exports.proposeTransaction = module.exports.getNonces = module.exports.postSafeGasEstimation = module.exports.getTransactionDetails = module.exports.getTransactionQueue = module.exports.getTransactionHistory = module.exports.getCollectiblesPage = module.exports.getCollectibles = module.exports.getOwnedSafes = module.exports.getFiatCurrencies = module.exports.getBalances = module.exports.getMultisigTransactions = module.exports.getModuleTransactions = module.exports.getIncomingTransfers = module.exports.getSafeInfo = module.exports.setBaseUrl = void 0;

var $uqZFO = parcelRequire("uqZFO");

var $3UQsN = parcelRequire("3UQsN");

$6b224676ea3a0580$var$__exportStar((parcelRequire("ahMc9")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("gQSZK")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("jQqtI")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("1h1lL")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("gUhuy")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("kQoCA")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("aecvB")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("hW7Mb")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("8BQqm")), module.exports);
// Can be set externally to a different CGW host
let $6b224676ea3a0580$var$baseUrl = $3UQsN.DEFAULT_BASE_URL;
/**
 * Set the base CGW URL
 */ const $6b224676ea3a0580$var$setBaseUrl = (url)=>{
    $6b224676ea3a0580$var$baseUrl = url;
};
module.exports.setBaseUrl = $6b224676ea3a0580$var$setBaseUrl;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Get basic information about a Safe. E.g. owners, modules, version etc
 */ function $6b224676ea3a0580$var$getSafeInfo(chainId, address) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{address}', {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getSafeInfo = $6b224676ea3a0580$var$getSafeInfo;
/**
 * Get filterable list of incoming transactions
 */ function $6b224676ea3a0580$var$getIncomingTransfers(chainId, address, query, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{address}/incoming-transfers/', {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getIncomingTransfers = $6b224676ea3a0580$var$getIncomingTransfers;
/**
 * Get filterable list of module transactions
 */ function $6b224676ea3a0580$var$getModuleTransactions(chainId, address, query, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{address}/module-transactions/', {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getModuleTransactions = $6b224676ea3a0580$var$getModuleTransactions;
/**
 * Get filterable list of multisig transactions
 */ function $6b224676ea3a0580$var$getMultisigTransactions(chainId, address, query, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{address}/multisig-transactions/', {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getMultisigTransactions = $6b224676ea3a0580$var$getMultisigTransactions;
/**
 * Get the total balance and all assets stored in a Safe
 */ function $6b224676ea3a0580$var$getBalances(chainId, address, currency = 'usd', query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{address}/balances/{currency}', {
        path: {
            chainId: chainId,
            address: address,
            currency: currency
        },
        query: query
    });
}
module.exports.getBalances = $6b224676ea3a0580$var$getBalances;
/**
 * Get a list of supported fiat currencies (e.g. USD, EUR etc)
 */ function $6b224676ea3a0580$var$getFiatCurrencies() {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/balances/supported-fiat-codes');
}
module.exports.getFiatCurrencies = $6b224676ea3a0580$var$getFiatCurrencies;
/**
 * Get the addresses of all Safes belonging to an owner
 */ function $6b224676ea3a0580$var$getOwnedSafes(chainId, address) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/owners/{address}/safes', {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getOwnedSafes = $6b224676ea3a0580$var$getOwnedSafes;
/**
 * Get NFTs stored in a Safe
 */ function $6b224676ea3a0580$var$getCollectibles(chainId, address, query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{address}/collectibles', {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    });
}
module.exports.getCollectibles = $6b224676ea3a0580$var$getCollectibles;
/**
 * Get NFTs stored in a Safe
 */ function $6b224676ea3a0580$var$getCollectiblesPage(chainId, address, query = {}, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v2/chains/{chainId}/safes/{address}/collectibles', {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getCollectiblesPage = $6b224676ea3a0580$var$getCollectiblesPage;
/**
 * Get a list of past Safe transactions
 */ function $6b224676ea3a0580$var$getTransactionHistory(chainId, address, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{safe_address}/transactions/history', {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getTransactionHistory = $6b224676ea3a0580$var$getTransactionHistory;
/**
 * Get the list of pending transactions
 */ function $6b224676ea3a0580$var$getTransactionQueue(chainId, address, pageUrl, trusted) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{safe_address}/transactions/queued', {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {
            trusted: trusted
        }
    }, pageUrl);
}
module.exports.getTransactionQueue = $6b224676ea3a0580$var$getTransactionQueue;
/**
 * Get the details of an individual transaction by its id
 */ function $6b224676ea3a0580$var$getTransactionDetails(chainId, transactionId) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/transactions/{transactionId}', {
        path: {
            chainId: chainId,
            transactionId: transactionId
        }
    });
}
module.exports.getTransactionDetails = $6b224676ea3a0580$var$getTransactionDetails;
/**
 * Request a gas estimate & recommmended tx nonce for a created transaction
 */ function $6b224676ea3a0580$var$postSafeGasEstimation(chainId, address, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, '/v2/chains/{chainId}/safes/{safe_address}/multisig-transactions/estimations', {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.postSafeGasEstimation = $6b224676ea3a0580$var$postSafeGasEstimation;
function $6b224676ea3a0580$var$getNonces(chainId, address) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{safe_address}/nonces', {
        path: {
            chainId: chainId,
            safe_address: address
        }
    });
}
module.exports.getNonces = $6b224676ea3a0580$var$getNonces;
/**
 * Propose a new transaction for other owners to sign/execute
 */ function $6b224676ea3a0580$var$proposeTransaction(chainId, address, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/transactions/{safe_address}/propose', {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeTransaction = $6b224676ea3a0580$var$proposeTransaction;
/**
 * Returns all defined chain configs
 */ function $6b224676ea3a0580$var$getChainsConfig(query) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains', {
        query: query
    });
}
module.exports.getChainsConfig = $6b224676ea3a0580$var$getChainsConfig;
/**
 * Returns a chain config
 */ function $6b224676ea3a0580$var$getChainConfig(chainId) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}', {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getChainConfig = $6b224676ea3a0580$var$getChainConfig;
/**
 * Returns Safe Apps List
 */ function $6b224676ea3a0580$var$getSafeApps(chainId, query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safe-apps', {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getSafeApps = $6b224676ea3a0580$var$getSafeApps;
/**
 * Returns list of Master Copies
 */ function $6b224676ea3a0580$var$getMasterCopies(chainId) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/about/master-copies', {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getMasterCopies = $6b224676ea3a0580$var$getMasterCopies;
/**
 * Returns decoded data
 */ function $6b224676ea3a0580$var$getDecodedData(chainId, encodedData, to) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/data-decoder', {
        path: {
            chainId: chainId
        },
        body: {
            data: encodedData,
            to: to
        }
    });
}
module.exports.getDecodedData = $6b224676ea3a0580$var$getDecodedData;
/**
 * Returns list of `SafeMessage`s
 */ function $6b224676ea3a0580$var$getSafeMessages(chainId, address, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{safe_address}/messages', {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getSafeMessages = $6b224676ea3a0580$var$getSafeMessages;
/**
 * Returns a `SafeMessage`
 */ function $6b224676ea3a0580$var$getSafeMessage(chainId, messageHash) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/messages/{message_hash}', {
        path: {
            chainId: chainId,
            message_hash: messageHash
        }
    });
}
module.exports.getSafeMessage = $6b224676ea3a0580$var$getSafeMessage;
/**
 * Propose a new `SafeMessage` for other owners to sign
 */ function $6b224676ea3a0580$var$proposeSafeMessage(chainId, address, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/safes/{safe_address}/messages', {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeSafeMessage = $6b224676ea3a0580$var$proposeSafeMessage;
/**
 * Add a confirmation to a `SafeMessage`
 */ function $6b224676ea3a0580$var$confirmSafeMessage(chainId, messageHash, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/messages/{message_hash}/signatures', {
        path: {
            chainId: chainId,
            message_hash: messageHash
        },
        body: body
    });
}
module.exports.confirmSafeMessage = $6b224676ea3a0580$var$confirmSafeMessage;
/**
 * Returns a list of delegates
 */ function $6b224676ea3a0580$var$getDelegates(chainId, query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/delegates', {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getDelegates = $6b224676ea3a0580$var$getDelegates;
/**
 * Registers a device/Safe for notifications
 */ function $6b224676ea3a0580$var$registerDevice(body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/register/notifications', {
        body: body
    });
}
module.exports.registerDevice = $6b224676ea3a0580$var$registerDevice;
/**
 * Unregisters a Safe from notifications
 */ function $6b224676ea3a0580$var$unregisterSafe(chainId, address, uuid) {
    return (0, $uqZFO.deleteEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/notifications/devices/{uuid}/safes/{safe_address}', {
        path: {
            chainId: chainId,
            safe_address: address,
            uuid: uuid
        }
    });
}
module.exports.unregisterSafe = $6b224676ea3a0580$var$unregisterSafe;
/**
 * Unregisters a device from notifications
 */ function $6b224676ea3a0580$var$unregisterDevice(chainId, uuid) {
    return (0, $uqZFO.deleteEndpoint)($6b224676ea3a0580$var$baseUrl, '/v1/chains/{chainId}/notifications/devices/{uuid}', {
        path: {
            chainId: chainId,
            uuid: uuid
        }
    });
}
module.exports.unregisterDevice = $6b224676ea3a0580$var$unregisterDevice; /* eslint-enable @typescript-eslint/explicit-module-boundary-types */ 

});
parcelRegister("uqZFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteEndpoint = module.exports.getEndpoint = module.exports.postEndpoint = void 0;

var $cOhiD = parcelRequire("cOhiD");
function $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, pathParams, query) {
    const pathname = (0, $cOhiD.insertParams)(path, pathParams);
    const search = (0, $cOhiD.stringifyQuery)(query);
    return `${baseUrl}${pathname}${search}`;
}
function $05b7bdd97f69be6a$var$postEndpoint(baseUrl, path, params) {
    const url = $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $cOhiD.fetchData)(url, params === null || params === void 0 ? void 0 : params.body);
}
module.exports.postEndpoint = $05b7bdd97f69be6a$var$postEndpoint;
function $05b7bdd97f69be6a$var$getEndpoint(baseUrl, path, params, rawUrl) {
    if (rawUrl) return (0, $cOhiD.fetchData)(rawUrl);
    const url = $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $cOhiD.fetchData)(url);
}
module.exports.getEndpoint = $05b7bdd97f69be6a$var$getEndpoint;
function $05b7bdd97f69be6a$var$deleteEndpoint(baseUrl, path, params) {
    const url = $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path);
    return (0, $cOhiD.deleteData)(url);
}
module.exports.deleteEndpoint = $05b7bdd97f69be6a$var$deleteEndpoint;

});
parcelRegister("cOhiD", function(module, exports) {
"use strict";
var $02681f45c167ec72$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteData = module.exports.fetchData = module.exports.stringifyQuery = module.exports.insertParams = void 0;
const $02681f45c167ec72$var$isErrorResponse = (data)=>{
    const isObject = typeof data === 'object' && data !== null;
    return isObject && 'code' in data && 'message' in data;
};
function $02681f45c167ec72$var$replaceParam(str, key, value) {
    return str.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
}
function $02681f45c167ec72$var$insertParams(template, params) {
    return params ? Object.keys(params).reduce((result, key)=>{
        return $02681f45c167ec72$var$replaceParam(result, key, String(params[key]));
    }, template) : template;
}
module.exports.insertParams = $02681f45c167ec72$var$insertParams;
function $02681f45c167ec72$var$stringifyQuery(query) {
    if (!query) return '';
    const searchParams = new URLSearchParams();
    Object.keys(query).forEach((key)=>{
        if (query[key] != null) searchParams.append(key, String(query[key]));
    });
    const searchString = searchParams.toString();
    return searchString ? `?${searchString}` : '';
}
module.exports.stringifyQuery = $02681f45c167ec72$var$stringifyQuery;
function $02681f45c167ec72$var$parseResponse(resp) {
    return $02681f45c167ec72$var$__awaiter(this, void 0, void 0, function*() {
        let json;
        try {
            json = yield resp.json();
        } catch (_a) {
            if (resp.headers && resp.headers.get('content-length') !== '0') throw new Error(`Invalid response content: ${resp.statusText}`);
        }
        if (!resp.ok) {
            const errTxt = $02681f45c167ec72$var$isErrorResponse(json) ? `${json.code}: ${json.message}` : resp.statusText;
            throw new Error(errTxt);
        }
        return json;
    });
}
function $02681f45c167ec72$var$fetchData(url, body) {
    return $02681f45c167ec72$var$__awaiter(this, void 0, void 0, function*() {
        let options;
        if (body != null) options = {
            method: 'POST',
            body: typeof body === 'string' ? body : JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        const resp = yield fetch(url, options);
        return $02681f45c167ec72$var$parseResponse(resp);
    });
}
module.exports.fetchData = $02681f45c167ec72$var$fetchData;
function $02681f45c167ec72$var$deleteData(url) {
    return $02681f45c167ec72$var$__awaiter(this, void 0, void 0, function*() {
        const options = {
            method: 'DELETE'
        };
        const resp = yield fetch(url, options);
        return $02681f45c167ec72$var$parseResponse(resp);
    });
}
module.exports.deleteData = $02681f45c167ec72$var$deleteData;

});


parcelRegister("3UQsN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BASE_URL = void 0;
module.exports.DEFAULT_BASE_URL = 'https://safe-client.safe.global';

});

parcelRegister("ahMc9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImplementationVersionState = void 0;
var $77d0e06deac62bef$var$ImplementationVersionState;
(function(ImplementationVersionState) {
    ImplementationVersionState["UP_TO_DATE"] = "UP_TO_DATE";
    ImplementationVersionState["OUTDATED"] = "OUTDATED";
    ImplementationVersionState["UNKNOWN"] = "UNKNOWN";
})($77d0e06deac62bef$var$ImplementationVersionState = module.exports.ImplementationVersionState || (module.exports.ImplementationVersionState = {}));

});

parcelRegister("gQSZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppSocialPlatforms = module.exports.SafeAppFeatures = module.exports.SafeAppAccessPolicyTypes = void 0;
var $c44c2982a882f983$var$SafeAppAccessPolicyTypes;
(function(SafeAppAccessPolicyTypes) {
    SafeAppAccessPolicyTypes["NoRestrictions"] = "NO_RESTRICTIONS";
    SafeAppAccessPolicyTypes["DomainAllowlist"] = "DOMAIN_ALLOWLIST";
})($c44c2982a882f983$var$SafeAppAccessPolicyTypes = module.exports.SafeAppAccessPolicyTypes || (module.exports.SafeAppAccessPolicyTypes = {}));
var $c44c2982a882f983$var$SafeAppFeatures;
(function(SafeAppFeatures) {
    SafeAppFeatures["BATCHED_TRANSACTIONS"] = "BATCHED_TRANSACTIONS";
})($c44c2982a882f983$var$SafeAppFeatures = module.exports.SafeAppFeatures || (module.exports.SafeAppFeatures = {}));
var $c44c2982a882f983$var$SafeAppSocialPlatforms;
(function(SafeAppSocialPlatforms) {
    SafeAppSocialPlatforms["TWITTER"] = "TWITTER";
    SafeAppSocialPlatforms["GITHUB"] = "GITHUB";
    SafeAppSocialPlatforms["DISCORD"] = "DISCORD";
})($c44c2982a882f983$var$SafeAppSocialPlatforms = module.exports.SafeAppSocialPlatforms || (module.exports.SafeAppSocialPlatforms = {}));

});

parcelRegister("jQqtI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabelValue = module.exports.DetailedExecutionInfoType = module.exports.TransactionListItemType = module.exports.ConflictType = module.exports.TransactionInfoType = module.exports.SettingsInfoType = module.exports.TransactionTokenType = module.exports.TransferDirection = module.exports.TransactionStatus = module.exports.Operation = void 0;
var $e72769b52ad6c30f$var$Operation;
(function(Operation) {
    Operation[Operation["CALL"] = 0] = "CALL";
    Operation[Operation["DELEGATE"] = 1] = "DELEGATE";
})($e72769b52ad6c30f$var$Operation = module.exports.Operation || (module.exports.Operation = {}));
var $e72769b52ad6c30f$var$TransactionStatus;
(function(TransactionStatus) {
    TransactionStatus["AWAITING_CONFIRMATIONS"] = "AWAITING_CONFIRMATIONS";
    TransactionStatus["AWAITING_EXECUTION"] = "AWAITING_EXECUTION";
    TransactionStatus["CANCELLED"] = "CANCELLED";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["SUCCESS"] = "SUCCESS";
})($e72769b52ad6c30f$var$TransactionStatus = module.exports.TransactionStatus || (module.exports.TransactionStatus = {}));
var $e72769b52ad6c30f$var$TransferDirection;
(function(TransferDirection) {
    TransferDirection["INCOMING"] = "INCOMING";
    TransferDirection["OUTGOING"] = "OUTGOING";
    TransferDirection["UNKNOWN"] = "UNKNOWN";
})($e72769b52ad6c30f$var$TransferDirection = module.exports.TransferDirection || (module.exports.TransferDirection = {}));
var $e72769b52ad6c30f$var$TransactionTokenType;
(function(TransactionTokenType) {
    TransactionTokenType["ERC20"] = "ERC20";
    TransactionTokenType["ERC721"] = "ERC721";
    TransactionTokenType["NATIVE_COIN"] = "NATIVE_COIN";
})($e72769b52ad6c30f$var$TransactionTokenType = module.exports.TransactionTokenType || (module.exports.TransactionTokenType = {}));
var $e72769b52ad6c30f$var$SettingsInfoType;
(function(SettingsInfoType) {
    SettingsInfoType["SET_FALLBACK_HANDLER"] = "SET_FALLBACK_HANDLER";
    SettingsInfoType["ADD_OWNER"] = "ADD_OWNER";
    SettingsInfoType["REMOVE_OWNER"] = "REMOVE_OWNER";
    SettingsInfoType["SWAP_OWNER"] = "SWAP_OWNER";
    SettingsInfoType["CHANGE_THRESHOLD"] = "CHANGE_THRESHOLD";
    SettingsInfoType["CHANGE_IMPLEMENTATION"] = "CHANGE_IMPLEMENTATION";
    SettingsInfoType["ENABLE_MODULE"] = "ENABLE_MODULE";
    SettingsInfoType["DISABLE_MODULE"] = "DISABLE_MODULE";
    SettingsInfoType["SET_GUARD"] = "SET_GUARD";
    SettingsInfoType["DELETE_GUARD"] = "DELETE_GUARD";
})($e72769b52ad6c30f$var$SettingsInfoType = module.exports.SettingsInfoType || (module.exports.SettingsInfoType = {}));
var $e72769b52ad6c30f$var$TransactionInfoType;
(function(TransactionInfoType) {
    TransactionInfoType["TRANSFER"] = "Transfer";
    TransactionInfoType["SETTINGS_CHANGE"] = "SettingsChange";
    TransactionInfoType["CUSTOM"] = "Custom";
    TransactionInfoType["CREATION"] = "Creation";
})($e72769b52ad6c30f$var$TransactionInfoType = module.exports.TransactionInfoType || (module.exports.TransactionInfoType = {}));
var $e72769b52ad6c30f$var$ConflictType;
(function(ConflictType) {
    ConflictType["NONE"] = "None";
    ConflictType["HAS_NEXT"] = "HasNext";
    ConflictType["END"] = "End";
})($e72769b52ad6c30f$var$ConflictType = module.exports.ConflictType || (module.exports.ConflictType = {}));
var $e72769b52ad6c30f$var$TransactionListItemType;
(function(TransactionListItemType) {
    TransactionListItemType["TRANSACTION"] = "TRANSACTION";
    TransactionListItemType["LABEL"] = "LABEL";
    TransactionListItemType["CONFLICT_HEADER"] = "CONFLICT_HEADER";
    TransactionListItemType["DATE_LABEL"] = "DATE_LABEL";
})($e72769b52ad6c30f$var$TransactionListItemType = module.exports.TransactionListItemType || (module.exports.TransactionListItemType = {}));
var $e72769b52ad6c30f$var$DetailedExecutionInfoType;
(function(DetailedExecutionInfoType) {
    DetailedExecutionInfoType["MULTISIG"] = "MULTISIG";
    DetailedExecutionInfoType["MODULE"] = "MODULE";
})($e72769b52ad6c30f$var$DetailedExecutionInfoType = module.exports.DetailedExecutionInfoType || (module.exports.DetailedExecutionInfoType = {}));
var $e72769b52ad6c30f$var$LabelValue;
(function(LabelValue) {
    LabelValue["Queued"] = "Queued";
    LabelValue["Next"] = "Next";
})($e72769b52ad6c30f$var$LabelValue = module.exports.LabelValue || (module.exports.LabelValue = {}));

});

parcelRegister("1h1lL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FEATURES = module.exports.GAS_PRICE_TYPE = module.exports.RPC_AUTHENTICATION = void 0;
var $0ed86d0c8ae1c805$var$RPC_AUTHENTICATION;
(function(RPC_AUTHENTICATION) {
    RPC_AUTHENTICATION["API_KEY_PATH"] = "API_KEY_PATH";
    RPC_AUTHENTICATION["NO_AUTHENTICATION"] = "NO_AUTHENTICATION";
    RPC_AUTHENTICATION["UNKNOWN"] = "UNKNOWN";
})($0ed86d0c8ae1c805$var$RPC_AUTHENTICATION = module.exports.RPC_AUTHENTICATION || (module.exports.RPC_AUTHENTICATION = {}));
var $0ed86d0c8ae1c805$var$GAS_PRICE_TYPE;
(function(GAS_PRICE_TYPE) {
    GAS_PRICE_TYPE["ORACLE"] = "ORACLE";
    GAS_PRICE_TYPE["FIXED"] = "FIXED";
    GAS_PRICE_TYPE["FIXED_1559"] = "FIXED1559";
    GAS_PRICE_TYPE["UNKNOWN"] = "UNKNOWN";
})($0ed86d0c8ae1c805$var$GAS_PRICE_TYPE = module.exports.GAS_PRICE_TYPE || (module.exports.GAS_PRICE_TYPE = {}));
var $0ed86d0c8ae1c805$var$FEATURES;
(function(FEATURES) {
    FEATURES["ERC721"] = "ERC721";
    FEATURES["SAFE_APPS"] = "SAFE_APPS";
    FEATURES["CONTRACT_INTERACTION"] = "CONTRACT_INTERACTION";
    FEATURES["DOMAIN_LOOKUP"] = "DOMAIN_LOOKUP";
    FEATURES["SPENDING_LIMIT"] = "SPENDING_LIMIT";
    FEATURES["EIP1559"] = "EIP1559";
    FEATURES["SAFE_TX_GAS_OPTIONAL"] = "SAFE_TX_GAS_OPTIONAL";
    FEATURES["TX_SIMULATION"] = "TX_SIMULATION";
    FEATURES["EIP1271"] = "EIP1271";
})($0ed86d0c8ae1c805$var$FEATURES = module.exports.FEATURES || (module.exports.FEATURES = {}));

});

parcelRegister("gUhuy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenType = void 0;
var $c4ef71cf4b4171c5$var$TokenType;
(function(TokenType) {
    TokenType["ERC20"] = "ERC20";
    TokenType["ERC721"] = "ERC721";
    TokenType["NATIVE_TOKEN"] = "NATIVE_TOKEN";
})($c4ef71cf4b4171c5$var$TokenType = module.exports.TokenType || (module.exports.TokenType = {}));

});

parcelRegister("kQoCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aecvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hW7Mb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeMessageStatus = module.exports.SafeMessageListItemType = void 0;
var $d0ede2a10330bff2$var$SafeMessageListItemType;
(function(SafeMessageListItemType) {
    SafeMessageListItemType["DATE_LABEL"] = "DATE_LABEL";
    SafeMessageListItemType["MESSAGE"] = "MESSAGE";
})($d0ede2a10330bff2$var$SafeMessageListItemType = module.exports.SafeMessageListItemType || (module.exports.SafeMessageListItemType = {}));
var $d0ede2a10330bff2$var$SafeMessageStatus;
(function(SafeMessageStatus) {
    SafeMessageStatus["NEEDS_CONFIRMATION"] = "NEEDS_CONFIRMATION";
    SafeMessageStatus["CONFIRMED"] = "CONFIRMED";
})($d0ede2a10330bff2$var$SafeMessageStatus = module.exports.SafeMessageStatus || (module.exports.SafeMessageStatus = {}));

});

parcelRegister("8BQqm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeviceType = void 0;
var $644a71c464f68b42$var$DeviceType;
(function(DeviceType) {
    DeviceType["ANDROID"] = "ANDROID";
    DeviceType["IOS"] = "IOS";
    DeviceType["WEB"] = "WEB";
})($644a71c464f68b42$var$DeviceType = module.exports.DeviceType || (module.exports.DeviceType = {}));

});



parcelRegister("9CPMF", function(module, exports) {
parcelRequire("alqGi");

});



parcelRegister("lNx5y", function(module, exports) {

$parcel$export(module.exports, "Eth", function () { return $fde7d7445238aed0$export$4a8fe6f3e78a368a; });

var $flAIP = parcelRequire("flAIP");

var $alqGi = parcelRequire("alqGi");
const $fde7d7445238aed0$var$inputFormatters = {
    defaultBlockParam: (arg = 'latest')=>arg,
    returnFullTxObjectParam: (arg = false)=>arg,
    blockNumberToHex: (arg)=>Number.isInteger(arg) ? `0x${arg.toString(16)}` : arg
};
class $fde7d7445238aed0$export$4a8fe6f3e78a368a {
    constructor(communicator){
        this.communicator = communicator;
        this.call = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_call,
            formatters: [
                null,
                $fde7d7445238aed0$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getBalance = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getBalance,
            formatters: [
                null,
                $fde7d7445238aed0$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getCode = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getCode,
            formatters: [
                null,
                $fde7d7445238aed0$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getStorageAt = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getStorageAt,
            formatters: [
                null,
                $fde7d7445238aed0$var$inputFormatters.blockNumberToHex,
                $fde7d7445238aed0$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getPastLogs = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getLogs
        });
        this.getBlockByHash = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getBlockByHash,
            formatters: [
                null,
                $fde7d7445238aed0$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getBlockByNumber = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getBlockByNumber,
            formatters: [
                $fde7d7445238aed0$var$inputFormatters.blockNumberToHex,
                $fde7d7445238aed0$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getTransactionByHash = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getTransactionByHash
        });
        this.getTransactionReceipt = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getTransactionReceipt
        });
        this.getTransactionCount = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_getTransactionCount,
            formatters: [
                null,
                $fde7d7445238aed0$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getGasPrice = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).eth_gasPrice
        });
        this.getEstimateGas = (transaction)=>this.buildRequest({
                call: (0, $flAIP.RPC_CALLS).eth_estimateGas
            })([
                transaction
            ]);
        this.setSafeSettings = this.buildRequest({
            call: (0, $flAIP.RPC_CALLS).safe_setSettings
        });
    }
    buildRequest(args) {
        const { call: call, formatters: formatters } = args;
        return async (params)=>{
            if (formatters && Array.isArray(params)) formatters.forEach((formatter, i)=>{
                if (formatter) params[i] = formatter(params[i]);
            });
            const payload = {
                call: call,
                params: params || []
            };
            const response = await this.communicator.send((0, $alqGi.Methods).rpcCall, payload);
            return response.data;
        };
    }
}

});
parcelRegister("flAIP", function(module, exports) {

$parcel$export(module.exports, "RPC_CALLS", function () { return $b2c54d68488248b5$export$342bf17e2a7081dd; });
const $b2c54d68488248b5$export$342bf17e2a7081dd = {
    eth_call: 'eth_call',
    eth_gasPrice: 'eth_gasPrice',
    eth_getLogs: 'eth_getLogs',
    eth_getBalance: 'eth_getBalance',
    eth_getCode: 'eth_getCode',
    eth_getBlockByHash: 'eth_getBlockByHash',
    eth_getBlockByNumber: 'eth_getBlockByNumber',
    eth_getStorageAt: 'eth_getStorageAt',
    eth_getTransactionByHash: 'eth_getTransactionByHash',
    eth_getTransactionReceipt: 'eth_getTransactionReceipt',
    eth_getTransactionCount: 'eth_getTransactionCount',
    eth_estimateGas: 'eth_estimateGas',
    safe_setSettings: 'safe_setSettings'
};

});


parcelRegister("4hOCt", function(module, exports) {

$parcel$export(module.exports, "Safe", function () { return $31f003f256870fd3$export$608e5f71f295e7a1; });

var $egjnX = parcelRequire("egjnX");
var $1gqt2 = parcelRequire("1gqt2");
var $4Jnow = parcelRequire("4Jnow");

var $6lRjy = parcelRequire("6lRjy");

var $alqGi = parcelRequire("alqGi");

var $flAIP = parcelRequire("flAIP");
parcelRequire("2GhJG");
var $gCn9A = parcelRequire("gCn9A");

var $lmXRc = parcelRequire("lmXRc");
var $31f003f256870fd3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $31f003f256870fd3$export$608e5f71f295e7a1 {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getChainInfo() {
        const response = await this.communicator.send((0, $alqGi.Methods).getChainInfo, undefined);
        return response.data;
    }
    async getInfo() {
        const response = await this.communicator.send((0, $alqGi.Methods).getSafeInfo, undefined);
        return response.data;
    }
    // There is a possibility that this method will change because we may add pagination to the endpoint
    async experimental_getBalances({ currency: currency = 'usd' } = {}) {
        const response = await this.communicator.send((0, $alqGi.Methods).getSafeBalances, {
            currency: currency
        });
        return response.data;
    }
    async check1271Signature(messageHash, signature = '0x') {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = (0, $egjnX.encodeFunctionData)({
            abi: [
                {
                    constant: false,
                    inputs: [
                        {
                            name: '_dataHash',
                            type: 'bytes32'
                        },
                        {
                            name: '_signature',
                            type: 'bytes'
                        }
                    ],
                    name: 'isValidSignature',
                    outputs: [
                        {
                            name: '',
                            type: 'bytes4'
                        }
                    ],
                    payable: false,
                    stateMutability: 'nonpayable',
                    type: 'function'
                }
            ],
            functionName: 'isValidSignature',
            args: [
                messageHash,
                signature
            ]
        });
        const payload = {
            call: (0, $flAIP.RPC_CALLS).eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                'latest'
            ]
        };
        try {
            const response = await this.communicator.send((0, $alqGi.Methods).rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === (0, $6lRjy.MAGIC_VALUE);
        } catch (err) {
            return false;
        }
    }
    async check1271SignatureBytes(messageHash, signature = '0x') {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = (0, $egjnX.encodeFunctionData)({
            abi: [
                {
                    constant: false,
                    inputs: [
                        {
                            name: '_data',
                            type: 'bytes'
                        },
                        {
                            name: '_signature',
                            type: 'bytes'
                        }
                    ],
                    name: 'isValidSignature',
                    outputs: [
                        {
                            name: '',
                            type: 'bytes4'
                        }
                    ],
                    payable: false,
                    stateMutability: 'nonpayable',
                    type: 'function'
                }
            ],
            functionName: 'isValidSignature',
            args: [
                messageHash,
                signature
            ]
        });
        const payload = {
            call: (0, $flAIP.RPC_CALLS).eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                'latest'
            ]
        };
        try {
            const response = await this.communicator.send((0, $alqGi.Methods).rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === (0, $6lRjy.MAGIC_VALUE_BYTES);
        } catch (err) {
            return false;
        }
    }
    calculateMessageHash(message) {
        return (0, $1gqt2.hashMessage)(message);
    }
    calculateTypedMessageHash(typedMessage) {
        const chainId = typeof typedMessage.domain.chainId === 'object' ? typedMessage.domain.chainId.toNumber() : Number(typedMessage.domain.chainId);
        let primaryType = typedMessage.primaryType;
        if (!primaryType) {
            const fields = Object.values(typedMessage.types);
            // We try to infer primaryType (simplified ether's version)
            const primaryTypes = Object.keys(typedMessage.types).filter((typeName)=>fields.every((dataTypes)=>dataTypes.every(({ type: type })=>type.replace('[', '').replace(']', '') !== typeName)));
            if (primaryTypes.length === 0 || primaryTypes.length > 1) throw new Error('Please specify primaryType');
            primaryType = primaryTypes[0];
        }
        return (0, $4Jnow.hashTypedData)({
            message: typedMessage.message,
            domain: {
                ...typedMessage.domain,
                chainId: chainId,
                verifyingContract: typedMessage.domain.verifyingContract,
                salt: typedMessage.domain.salt
            },
            types: typedMessage.types,
            primaryType: primaryType
        });
    }
    async getOffChainSignature(messageHash) {
        const response = await this.communicator.send((0, $alqGi.Methods).getOffChainSignature, messageHash);
        return response.data;
    }
    async isMessageSigned(message, signature = '0x') {
        let check;
        if (typeof message === 'string') check = async ()=>{
            const messageHash = this.calculateMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if ((0, $gCn9A.isObjectEIP712TypedData)(message)) check = async ()=>{
            const messageHash = this.calculateTypedMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if (check) {
            const isValid = await check();
            return isValid;
        }
        throw new Error('Invalid message type');
    }
    async isMessageHashSigned(messageHash, signature = '0x') {
        const checks = [
            this.check1271Signature.bind(this),
            this.check1271SignatureBytes.bind(this)
        ];
        for (const check of checks){
            const isValid = await check(messageHash, signature);
            if (isValid) return true;
        }
        return false;
    }
    async getEnvironmentInfo() {
        const response = await this.communicator.send((0, $alqGi.Methods).getEnvironmentInfo, undefined);
        return response.data;
    }
    async requestAddressBook() {
        const response = await this.communicator.send((0, $alqGi.Methods).requestAddressBook, undefined);
        return response.data;
    }
}
$31f003f256870fd3$var$__decorate([
    (0, $lmXRc.default)()
], $31f003f256870fd3$export$608e5f71f295e7a1.prototype, "requestAddressBook", null);

});
parcelRegister("egjnX", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", function () { return $a62198d9d88dc03a$export$f4ee15df45da9f03; });

var $cr3IT = parcelRequire("cr3IT");

var $4Gz5S = parcelRequire("4Gz5S");

var $eCXus = parcelRequire("eCXus");
function $a62198d9d88dc03a$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith('0x')) return parameters;
        return (0, $eCXus.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = 'inputs' in abiItem && abiItem.inputs ? (0, $4Gz5S.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $cr3IT.concatHex)([
        signature,
        data ?? '0x'
    ]);
}

});
parcelRegister("cr3IT", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $90dae4fa8d976163$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatHex", function () { return $90dae4fa8d976163$export$f6cc0b64b5a999af; });
function $90dae4fa8d976163$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === 'string') return $90dae4fa8d976163$export$f6cc0b64b5a999af(values);
    return $90dae4fa8d976163$export$287dd7971339c972(values);
}
function $90dae4fa8d976163$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $90dae4fa8d976163$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace('0x', ''), '')}`;
}

});

parcelRegister("4Gz5S", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", function () { return $36964e8a5f7497de$export$448ea0950d6dd7d7; });

var $aLn5t = parcelRequire("aLn5t");

var $2Puf4 = parcelRequire("2Puf4");

var $59dO4 = parcelRequire("59dO4");

var $deJrM = parcelRequire("deJrM");

var $cr3IT = parcelRequire("cr3IT");

var $2RzlM = parcelRequire("2RzlM");

var $6DW0V = parcelRequire("6DW0V");

var $1MtXL = parcelRequire("1MtXL");

var $erlnU = parcelRequire("erlnU");
function $36964e8a5f7497de$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $aLn5t.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $36964e8a5f7497de$var$prepareParams({
        params: params,
        values: values
    });
    const data = $36964e8a5f7497de$var$encodeParams(preparedParams);
    if (data.length === 0) return '0x';
    return data;
}
function $36964e8a5f7497de$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($36964e8a5f7497de$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $36964e8a5f7497de$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $36964e8a5f7497de$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $36964e8a5f7497de$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === 'tuple') return $36964e8a5f7497de$var$encodeTuple(value, {
        param: param
    });
    if (param.type === 'address') return $36964e8a5f7497de$var$encodeAddress(value);
    if (param.type === 'bool') return $36964e8a5f7497de$var$encodeBool(value);
    if (param.type.startsWith('uint') || param.type.startsWith('int')) {
        const signed = param.type.startsWith('int');
        return $36964e8a5f7497de$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith('bytes')) return $36964e8a5f7497de$var$encodeBytes(value, {
        param: param
    });
    if (param.type === 'string') return $36964e8a5f7497de$var$encodeString(value);
    throw new (0, $aLn5t.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: '/docs/contract/encodeAbiParameters'
    });
}
function $36964e8a5f7497de$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $6DW0V.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $erlnU.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $6DW0V.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $cr3IT.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $36964e8a5f7497de$var$encodeAddress(value) {
    if (!(0, $deJrM.isAddress)(value)) throw new (0, $2Puf4.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $2RzlM.padHex)(value.toLowerCase())
    };
}
function $36964e8a5f7497de$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $aLn5t.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $aLn5t.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $36964e8a5f7497de$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $36964e8a5f7497de$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $erlnU.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $cr3IT.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $cr3IT.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $36964e8a5f7497de$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split('bytes');
    const bytesSize = (0, $6DW0V.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $2RzlM.padHex)(value_, {
            dir: 'right',
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $cr3IT.concat)([
                (0, $2RzlM.padHex)((0, $erlnU.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $aLn5t.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $2RzlM.padHex)(value, {
            dir: 'right'
        })
    };
}
function $36964e8a5f7497de$var$encodeBool(value) {
    if (typeof value !== 'boolean') throw new (0, $59dO4.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $2RzlM.padHex)((0, $erlnU.boolToHex)(value))
    };
}
function $36964e8a5f7497de$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $erlnU.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $36964e8a5f7497de$var$encodeString(value) {
    const hexValue = (0, $erlnU.stringToHex)(value);
    const partsLength = Math.ceil((0, $6DW0V.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $2RzlM.padHex)((0, $1MtXL.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: 'right'
    }));
    return {
        dynamic: true,
        encoded: (0, $cr3IT.concat)([
            (0, $2RzlM.padHex)((0, $erlnU.numberToHex)((0, $6DW0V.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $36964e8a5f7497de$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $36964e8a5f7497de$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $36964e8a5f7497de$var$encodeParams(preparedParams) : (0, $cr3IT.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $36964e8a5f7497de$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("aLn5t", function(module, exports) {

$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", function () { return $7d6033cfd7f62470$export$a851da9bf50b557; });
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", function () { return $7d6033cfd7f62470$export$19c281dc8e23a2ea; });
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", function () { return $7d6033cfd7f62470$export$20737d495bb13c2d; });
$parcel$export(module.exports, "AbiFunctionNotFoundError", function () { return $7d6033cfd7f62470$export$c4faa308ea7f9b2; });
$parcel$export(module.exports, "AbiItemAmbiguityError", function () { return $7d6033cfd7f62470$export$fdbba54ba15f2c2d; });
$parcel$export(module.exports, "BytesSizeMismatchError", function () { return $7d6033cfd7f62470$export$a0eb884ede5c87eb; });
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", function () { return $7d6033cfd7f62470$export$53ed98b886965f49; });
$parcel$export(module.exports, "InvalidArrayError", function () { return $7d6033cfd7f62470$export$710dd6d4f78cc47e; });
$parcel$export(module.exports, "InvalidDefinitionTypeError", function () { return $7d6033cfd7f62470$export$81781a0fcfb9ed95; });

var $a7Tc3 = parcelRequire("a7Tc3");

var $6DW0V = parcelRequire("6DW0V");

var $59dO4 = parcelRequire("59dO4");
class $7d6033cfd7f62470$export$efa723f306cf6168 extends (0, $59dO4.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            'A constructor was not found on the ABI.',
            'Make sure you are using the correct ABI and that the constructor exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiConstructorNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$4faec14323ef9c47 extends (0, $59dO4.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            'Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.',
            'Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiConstructorParamsNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$68a7b570091cba69 extends (0, $59dO4.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            'Size must be in increments of 32 bytes (size % 32 === 0).'
        ].join('\n'), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: 'AbiDecodingDataSizeInvalidError'
        });
    }
}
class $7d6033cfd7f62470$export$7a409e433c5f3a8c extends (0, $59dO4.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join('\n'), {
            metaMessages: [
                `Params: (${(0, $a7Tc3.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: 'AbiDecodingDataSizeTooSmallError'
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $7d6033cfd7f62470$export$a063cde4013f1935 extends (0, $59dO4.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: 'AbiDecodingZeroDataError'
        });
    }
}
class $7d6033cfd7f62470$export$a851da9bf50b557 extends (0, $59dO4.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join('\n'), {
            name: 'AbiEncodingArrayLengthMismatchError'
        });
    }
}
class $7d6033cfd7f62470$export$19c281dc8e23a2ea extends (0, $59dO4.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $6DW0V.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: 'AbiEncodingBytesSizeMismatchError'
        });
    }
}
class $7d6033cfd7f62470$export$20737d495bb13c2d extends (0, $59dO4.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            'ABI encoding params/values length mismatch.',
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join('\n'), {
            name: 'AbiEncodingLengthMismatchError'
        });
    }
}
class $7d6033cfd7f62470$export$d47cf5ef47eda817 extends (0, $59dO4.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            'Cannot encode error result without knowing what the parameter types are.',
            'Make sure you are using the correct ABI and that the inputs exist on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiErrorInputsNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$86b719574b683f04 extends (0, $59dO4.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the error exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiErrorNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$8959cb729fefe1ea extends (0, $59dO4.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the error exists on it.',
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiErrorSignatureNotFoundError'
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $7d6033cfd7f62470$export$f83210ce5f9b901f extends (0, $59dO4.BaseError) {
    constructor({ docsPath: docsPath }){
        super('Cannot extract event signature from empty topics.', {
            docsPath: docsPath,
            name: 'AbiEventSignatureEmptyTopicsError'
        });
    }
}
class $7d6033cfd7f62470$export$3b44baeac92e4d3a extends (0, $59dO4.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the event exists on it.',
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiEventSignatureNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$c7be62baad13b157 extends (0, $59dO4.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the event exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiEventNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$c4faa308ea7f9b2 extends (0, $59dO4.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the function exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiFunctionNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$26f2edb605108b34 extends (0, $59dO4.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            'Cannot decode function result without knowing what the parameter types are.',
            'Make sure you are using the correct ABI and that the function exists on it.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiFunctionOutputsNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$14373147a0e60810 extends (0, $59dO4.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the function exists on it.',
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join('\n'), {
            docsPath: docsPath,
            name: 'AbiFunctionSignatureNotFoundError'
        });
    }
}
class $7d6033cfd7f62470$export$fdbba54ba15f2c2d extends (0, $59dO4.BaseError) {
    constructor(x, y){
        super('Found ambiguous types in overloaded ABI items.', {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $a7Tc3.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $a7Tc3.formatAbiItem)(y.abiItem)}\``,
                '',
                'These types encode differently and cannot be distinguished at runtime.',
                'Remove one of the ambiguous items in the ABI.'
            ],
            name: 'AbiItemAmbiguityError'
        });
    }
}
class $7d6033cfd7f62470$export$a0eb884ede5c87eb extends (0, $59dO4.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: 'BytesSizeMismatchError'
        });
    }
}
class $7d6033cfd7f62470$export$3978f86c08fc8c25 extends (0, $59dO4.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join('\n'), {
            metaMessages: [
                `Params: (${(0, $a7Tc3.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: 'DecodeLogDataMismatch'
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $7d6033cfd7f62470$export$6d7c6f419cf52377 extends (0, $59dO4.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ''} on event "${(0, $a7Tc3.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join('\n'), {
            name: 'DecodeLogTopicsMismatch'
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $7d6033cfd7f62470$export$53ed98b886965f49 extends (0, $59dO4.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            'Please provide a valid ABI type.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'InvalidAbiEncodingType'
        });
    }
}
class $7d6033cfd7f62470$export$cf94ccff0ff97c65 extends (0, $59dO4.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            'Please provide a valid ABI type.'
        ].join('\n'), {
            docsPath: docsPath,
            name: 'InvalidAbiDecodingType'
        });
    }
}
class $7d6033cfd7f62470$export$710dd6d4f78cc47e extends (0, $59dO4.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join('\n'), {
            name: 'InvalidArrayError'
        });
    }
}
class $7d6033cfd7f62470$export$81781a0fcfb9ed95 extends (0, $59dO4.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join('\n'), {
            name: 'InvalidDefinitionTypeError'
        });
    }
}
class $7d6033cfd7f62470$export$a16541e2fe420ef1 extends (0, $59dO4.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: 'UnsupportedPackedAbiType'
        });
    }
}

});
parcelRegister("a7Tc3", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $75f55f1c844ccb1e$export$dc5d0ff4fc2fdee1; });
$parcel$export(module.exports, "formatAbiParams", function () { return $75f55f1c844ccb1e$export$849e499971de75b3; });

var $aLn5t = parcelRequire("aLn5t");
function $75f55f1c844ccb1e$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== 'function' && abiItem.type !== 'event' && abiItem.type !== 'error') throw new (0, $aLn5t.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$75f55f1c844ccb1e$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $75f55f1c844ccb1e$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return '';
    return params.map((param)=>$75f55f1c844ccb1e$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ', ' : ',');
}
function $75f55f1c844ccb1e$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith('tuple')) return `(${$75f55f1c844ccb1e$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : '');
}

});

parcelRegister("6DW0V", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $4d6362efeafcab41$export$346677f925de839c; });

var $ihJau = parcelRequire("ihJau");
function $4d6362efeafcab41$export$346677f925de839c(value) {
    if ((0, $ihJau.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("ihJau", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $d4fcd9ff9c105dbb$export$8a9b6341a7c96bc; });
function $d4fcd9ff9c105dbb$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== 'string') return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
}

});


parcelRegister("59dO4", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $3bf880bb18caf752$export$a490eb03cb7a0a5e; });

var $7ihEk = parcelRequire("7ihEk");
let $3bf880bb18caf752$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = '', docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? 'https://viem.sh'}${docsPath}${docsSlug ? `#${docsSlug}` : ''}` : undefined,
    version: $7ihEk.version
};
function $3bf880bb18caf752$export$4ac109df0c5244e9(config) {
    $3bf880bb18caf752$var$errorConfig = config;
}
class $3bf880bb18caf752$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $3bf880bb18caf752$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $3bf880bb18caf752$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $3bf880bb18caf752$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || 'An error occurred.',
            '',
            ...args.metaMessages ? [
                ...args.metaMessages,
                ''
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$3bf880bb18caf752$var$errorConfig.version ? [
                `Version: ${$3bf880bb18caf752$var$errorConfig.version}`
            ] : []
        ].join('\n');
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'BaseError'
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $7ihEk.version);
    }
    walk(fn) {
        return $3bf880bb18caf752$var$walk(this, fn);
    }
}
function $3bf880bb18caf752$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === 'object' && 'cause' in err) return $3bf880bb18caf752$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("7ihEk", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $54f7e7a8cb4deead$export$83d89fbfd8236492; });
const $54f7e7a8cb4deead$export$83d89fbfd8236492 = '2.21.9';

});



parcelRegister("2Puf4", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", function () { return $20f7cd9fc093c31e$export$66c44d927ffead98; });

var $59dO4 = parcelRequire("59dO4");
class $20f7cd9fc093c31e$export$66c44d927ffead98 extends (0, $59dO4.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                '- Address must be a hex value of 20 bytes (40 hex characters).',
                '- Address must match its checksum counterpart.'
            ],
            name: 'InvalidAddressError'
        });
    }
}

});

parcelRegister("deJrM", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $9a2fd600d6c217f1$export$977e255126d763d6; });

var $4bZ2B = parcelRequire("4bZ2B");

var $eUR4p = parcelRequire("eUR4p");
const $9a2fd600d6c217f1$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $9a2fd600d6c217f1$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $4bZ2B.LruMap)(8192);
function $9a2fd600d6c217f1$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($9a2fd600d6c217f1$export$ef83598cc5072ce.has(cacheKey)) return $9a2fd600d6c217f1$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$9a2fd600d6c217f1$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $eUR4p.checksumAddress)(address) === address;
        return true;
    })();
    $9a2fd600d6c217f1$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});
parcelRegister("4bZ2B", function(module, exports) {

$parcel$export(module.exports, "LruMap", function () { return $30d789febc549f11$export$fcb3b6cad79d7e3a; });
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $30d789febc549f11$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}

});

parcelRegister("eUR4p", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", function () { return $adbf764b4c886e35$export$9ff46e8f6df13548; });

var $2Puf4 = parcelRequire("2Puf4");

var $di7YF = parcelRequire("di7YF");

var $cGfzM = parcelRequire("cGfzM");

var $4bZ2B = parcelRequire("4bZ2B");

var $deJrM = parcelRequire("deJrM");
const $adbf764b4c886e35$var$checksumAddressCache = /*#__PURE__*/ new (0, $4bZ2B.LruMap)(8192);
function $adbf764b4c886e35$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($adbf764b4c886e35$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $adbf764b4c886e35$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $cGfzM.keccak256)((0, $di7YF.stringToBytes)(hexAddress), 'bytes');
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split('');
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join('')}`;
    $adbf764b4c886e35$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $adbf764b4c886e35$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $deJrM.isAddress)(address, {
        strict: false
    })) throw new (0, $2Puf4.InvalidAddressError)({
        address: address
    });
    return $adbf764b4c886e35$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("di7YF", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $9ad324f98ce03a15$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $9ad324f98ce03a15$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $9ad324f98ce03a15$export$c8dd6bc66a63753c; });

var $59dO4 = parcelRequire("59dO4");

var $ihJau = parcelRequire("ihJau");

var $2RzlM = parcelRequire("2RzlM");

var $ldDrh = parcelRequire("ldDrh");

var $erlnU = parcelRequire("erlnU");
const $9ad324f98ce03a15$var$encoder = /*#__PURE__*/ new TextEncoder();
function $9ad324f98ce03a15$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $9ad324f98ce03a15$export$49ad9be85c347998(value, opts);
    if (typeof value === 'boolean') return $9ad324f98ce03a15$export$771517697a68241(value, opts);
    if ((0, $ihJau.isHex)(value)) return $9ad324f98ce03a15$export$31c96b9df38bc8d4(value, opts);
    return $9ad324f98ce03a15$export$c8dd6bc66a63753c(value, opts);
}
function $9ad324f98ce03a15$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === 'number') {
        (0, $ldDrh.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $2RzlM.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $9ad324f98ce03a15$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $9ad324f98ce03a15$var$charCodeToBase16(char) {
    if (char >= $9ad324f98ce03a15$var$charCodeMap.zero && char <= $9ad324f98ce03a15$var$charCodeMap.nine) return char - $9ad324f98ce03a15$var$charCodeMap.zero;
    if (char >= $9ad324f98ce03a15$var$charCodeMap.A && char <= $9ad324f98ce03a15$var$charCodeMap.F) return char - ($9ad324f98ce03a15$var$charCodeMap.A - 10);
    if (char >= $9ad324f98ce03a15$var$charCodeMap.a && char <= $9ad324f98ce03a15$var$charCodeMap.f) return char - ($9ad324f98ce03a15$var$charCodeMap.a - 10);
    return undefined;
}
function $9ad324f98ce03a15$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $ldDrh.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $2RzlM.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $9ad324f98ce03a15$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $9ad324f98ce03a15$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $59dO4.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $9ad324f98ce03a15$export$49ad9be85c347998(value, opts) {
    const hex = (0, $erlnU.numberToHex)(value, opts);
    return $9ad324f98ce03a15$export$31c96b9df38bc8d4(hex);
}
function $9ad324f98ce03a15$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $9ad324f98ce03a15$var$encoder.encode(value);
    if (typeof opts.size === 'number') {
        (0, $ldDrh.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $2RzlM.pad)(bytes, {
            dir: 'right',
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("2RzlM", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $215bf3da28f7d832$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $215bf3da28f7d832$export$1bcd51c0fce8ee55; });

var $4Yn1v = parcelRequire("4Yn1v");
function $215bf3da28f7d832$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === 'string') return $215bf3da28f7d832$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $215bf3da28f7d832$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $215bf3da28f7d832$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace('0x', '');
    if (hex.length > size * 2) throw new (0, $4Yn1v.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: 'hex'
    });
    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
}
function $215bf3da28f7d832$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $4Yn1v.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: 'bytes'
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === 'right';
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("4Yn1v", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $39ee9ff57af36d39$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $39ee9ff57af36d39$export$70445dc308a7f3d5; });

var $59dO4 = parcelRequire("59dO4");
class $39ee9ff57af36d39$export$cfcd41bba8b36dbd extends (0, $59dO4.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === 'start' ? 'starting' : 'ending'} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: 'SliceOffsetOutOfBoundsError'
        });
    }
}
class $39ee9ff57af36d39$export$70445dc308a7f3d5 extends (0, $59dO4.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: 'SizeExceedsPaddingSizeError'
        });
    }
}
class $39ee9ff57af36d39$export$8a5469becf223114 extends (0, $59dO4.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: 'InvalidBytesLengthError'
        });
    }
}

});


parcelRegister("ldDrh", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $f72967a4c05dbe2f$export$2af489edb7fa35fe; });

var $eKEJL = parcelRequire("eKEJL");

var $6DW0V = parcelRequire("6DW0V");

var $lJYR4 = parcelRequire("lJYR4");

var $di7YF = parcelRequire("di7YF");
function $f72967a4c05dbe2f$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $6DW0V.size)(hexOrBytes) > size) throw new (0, $eKEJL.SizeOverflowError)({
        givenSize: (0, $6DW0V.size)(hexOrBytes),
        maxSize: size
    });
}
function $f72967a4c05dbe2f$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === 'string' ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === 'number') return $f72967a4c05dbe2f$export$d57f2bacc26b4249(hex, opts);
    if (to === 'bigint') return $f72967a4c05dbe2f$export$92a44656ec81b584(hex, opts);
    if (to === 'string') return $f72967a4c05dbe2f$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === 'boolean') return $f72967a4c05dbe2f$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $di7YF.hexToBytes)(hex, opts);
}
function $f72967a4c05dbe2f$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $f72967a4c05dbe2f$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${'f'.padStart(size * 2, 'f')}`) - 1n;
}
function $f72967a4c05dbe2f$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $f72967a4c05dbe2f$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $lJYR4.trim)(hex);
    }
    if ((0, $lJYR4.trim)(hex) === '0x00') return false;
    if ((0, $lJYR4.trim)(hex) === '0x01') return true;
    throw new (0, $eKEJL.InvalidHexBooleanError)(hex);
}
function $f72967a4c05dbe2f$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($f72967a4c05dbe2f$export$92a44656ec81b584(hex, opts));
}
function $f72967a4c05dbe2f$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $di7YF.hexToBytes)(hex);
    if (opts.size) {
        $f72967a4c05dbe2f$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $lJYR4.trim)(bytes, {
            dir: 'right'
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("eKEJL", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $abd4f62236b6bb7a$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $abd4f62236b6bb7a$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $abd4f62236b6bb7a$export$beb44ed4f8747d0e; });

var $59dO4 = parcelRequire("59dO4");
class $abd4f62236b6bb7a$export$47d164a8071229a9 extends (0, $59dO4.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? 'signed' : 'unsigned'} ` : ''}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: 'IntegerOutOfRangeError'
        });
    }
}
class $abd4f62236b6bb7a$export$52fc62e5266c8838 extends (0, $59dO4.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: 'InvalidBytesBooleanError'
        });
    }
}
class $abd4f62236b6bb7a$export$f574ac54e35514c extends (0, $59dO4.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: 'InvalidHexBooleanError'
        });
    }
}
class $abd4f62236b6bb7a$export$ef05eafd11dd4a83 extends (0, $59dO4.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: 'InvalidHexValueError'
        });
    }
}
class $abd4f62236b6bb7a$export$beb44ed4f8747d0e extends (0, $59dO4.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: 'SizeOverflowError'
        });
    }
}

});

parcelRegister("lJYR4", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $fd3d0174f47ceb8f$export$87c2784dc9fc4ab; });
function $fd3d0174f47ceb8f$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = 'left' } = {}) {
    let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0') sliceLength++;
        else break;
    }
    data = dir === 'left' ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === 'string') {
        if (data.length === 1 && dir === 'right') data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("erlnU", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $a8342cda946d5b65$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $a8342cda946d5b65$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $a8342cda946d5b65$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $a8342cda946d5b65$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $a8342cda946d5b65$export$58b867e287a802c8; });

var $eKEJL = parcelRequire("eKEJL");

var $2RzlM = parcelRequire("2RzlM");

var $ldDrh = parcelRequire("ldDrh");
const $a8342cda946d5b65$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, '0'));
function $a8342cda946d5b65$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint') return $a8342cda946d5b65$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === 'string') return $a8342cda946d5b65$export$551c48dea6f88e6d(value, opts);
    if (typeof value === 'boolean') return $a8342cda946d5b65$export$b5c95dec4f62ef7a(value, opts);
    return $a8342cda946d5b65$export$58b867e287a802c8(value, opts);
}
function $a8342cda946d5b65$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === 'number') {
        (0, $ldDrh.assertSize)(hex, {
            size: opts.size
        });
        return (0, $2RzlM.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $a8342cda946d5b65$export$58b867e287a802c8(value, opts = {}) {
    let string = '';
    for(let i = 0; i < value.length; i++)string += $a8342cda946d5b65$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === 'number') {
        (0, $ldDrh.assertSize)(hex, {
            size: opts.size
        });
        return (0, $2RzlM.pad)(hex, {
            dir: 'right',
            size: opts.size
        });
    }
    return hex;
}
function $a8342cda946d5b65$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === 'number') maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === 'bigint' ? 'n' : '';
        throw new (0, $eKEJL.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $2RzlM.pad)(hex, {
        size: size
    });
    return hex;
}
const $a8342cda946d5b65$var$encoder = /*#__PURE__*/ new TextEncoder();
function $a8342cda946d5b65$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $a8342cda946d5b65$var$encoder.encode(value_);
    return $a8342cda946d5b65$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("cGfzM", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $93b57d5b01aa372f$export$f8151fce47ad1c35; });

var $2x4Sm = parcelRequire("2x4Sm");

var $ihJau = parcelRequire("ihJau");

var $di7YF = parcelRequire("di7YF");

var $erlnU = parcelRequire("erlnU");
function $93b57d5b01aa372f$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || 'hex';
    const bytes = (0, $2x4Sm.keccak_256)((0, $ihJau.isHex)(value, {
        strict: false
    }) ? (0, $di7YF.toBytes)(value) : value);
    if (to === 'bytes') return bytes;
    return (0, $erlnU.toHex)(bytes);
}

});
parcelRegister("2x4Sm", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $1d82720cedf7a08a$export$860ddaa9ca84a66d; });

var $kBuOB = parcelRequire("kBuOB");

var $iv9D2 = parcelRequire("iv9D2");

var $go151 = parcelRequire("go151");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $1d82720cedf7a08a$var$SHA3_PI = [];
const $1d82720cedf7a08a$var$SHA3_ROTL = [];
const $1d82720cedf7a08a$var$_SHA3_IOTA = [];
const $1d82720cedf7a08a$var$_0n = /* @__PURE__ */ BigInt(0);
const $1d82720cedf7a08a$var$_1n = /* @__PURE__ */ BigInt(1);
const $1d82720cedf7a08a$var$_2n = /* @__PURE__ */ BigInt(2);
const $1d82720cedf7a08a$var$_7n = /* @__PURE__ */ BigInt(7);
const $1d82720cedf7a08a$var$_256n = /* @__PURE__ */ BigInt(256);
const $1d82720cedf7a08a$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $1d82720cedf7a08a$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $1d82720cedf7a08a$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $1d82720cedf7a08a$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $1d82720cedf7a08a$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $1d82720cedf7a08a$var$_1n ^ (R >> $1d82720cedf7a08a$var$_7n) * $1d82720cedf7a08a$var$_0x71n) % $1d82720cedf7a08a$var$_256n;
        if (R & $1d82720cedf7a08a$var$_2n) t ^= $1d82720cedf7a08a$var$_1n << ($1d82720cedf7a08a$var$_1n << /* @__PURE__ */ BigInt(j)) - $1d82720cedf7a08a$var$_1n;
    }
    $1d82720cedf7a08a$var$_SHA3_IOTA.push(t);
}
const [$1d82720cedf7a08a$var$SHA3_IOTA_H, $1d82720cedf7a08a$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $iv9D2.split)($1d82720cedf7a08a$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $1d82720cedf7a08a$var$rotlH = (h, l, s)=>s > 32 ? (0, $iv9D2.rotlBH)(h, l, s) : (0, $iv9D2.rotlSH)(h, l, s);
const $1d82720cedf7a08a$var$rotlL = (h, l, s)=>s > 32 ? (0, $iv9D2.rotlBL)(h, l, s) : (0, $iv9D2.rotlSL)(h, l, s);
function $1d82720cedf7a08a$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $1d82720cedf7a08a$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $1d82720cedf7a08a$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $1d82720cedf7a08a$var$SHA3_ROTL[t];
            const Th = $1d82720cedf7a08a$var$rotlH(curH, curL, shift);
            const Tl = $1d82720cedf7a08a$var$rotlL(curH, curL, shift);
            const PI = $1d82720cedf7a08a$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $1d82720cedf7a08a$var$SHA3_IOTA_H[round];
        s[1] ^= $1d82720cedf7a08a$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $1d82720cedf7a08a$export$f7374b8b4498bc2e extends (0, $go151.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $kBuOB.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = (0, $go151.u32)(this.state);
    }
    keccak() {
        if (!(0, $go151.isLE)) (0, $go151.byteSwap32)(this.state32);
        $1d82720cedf7a08a$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $go151.isLE)) (0, $go151.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $kBuOB.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $go151.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $kBuOB.exists)(this, false);
        (0, $kBuOB.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $kBuOB.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $kBuOB.output)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $1d82720cedf7a08a$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $1d82720cedf7a08a$var$gen = (suffix, blockLen, outputLen)=>(0, $go151.wrapConstructor)(()=>new $1d82720cedf7a08a$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $1d82720cedf7a08a$export$fe6c2b96a79338e9 = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x06, 144, 28);
const $1d82720cedf7a08a$export$76e19b6966813b14 = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x06, 136, 32);
const $1d82720cedf7a08a$export$a58509fa80f30d15 = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x06, 104, 48);
const $1d82720cedf7a08a$export$20ed324dbdf09b7c = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x06, 72, 64);
const $1d82720cedf7a08a$export$2f7fb3c6fac246bc = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x01, 144, 28);
const $1d82720cedf7a08a$export$860ddaa9ca84a66d = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x01, 136, 32);
const $1d82720cedf7a08a$export$46fcdeb4c5686552 = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x01, 104, 48);
const $1d82720cedf7a08a$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $1d82720cedf7a08a$var$gen(0x01, 72, 64);
const $1d82720cedf7a08a$var$genShake = (suffix, blockLen, outputLen)=>(0, $go151.wrapXOFConstructorWithOpts)((opts = {})=>new $1d82720cedf7a08a$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $1d82720cedf7a08a$export$f43dc3bb86efbba2 = /* @__PURE__ */ $1d82720cedf7a08a$var$genShake(0x1f, 168, 16);
const $1d82720cedf7a08a$export$c240d011f1520440 = /* @__PURE__ */ $1d82720cedf7a08a$var$genShake(0x1f, 136, 32);

});
parcelRegister("kBuOB", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $efff2a9bfd5fbec0$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $efff2a9bfd5fbec0$export$b3317979f9250576; });
$parcel$export(module.exports, "exists", function () { return $efff2a9bfd5fbec0$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $efff2a9bfd5fbec0$export$c789db2c85949867; });
function $efff2a9bfd5fbec0$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $efff2a9bfd5fbec0$export$87b259aa03e3d267(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
function $efff2a9bfd5fbec0$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
function $efff2a9bfd5fbec0$export$b3317979f9250576(b, ...lengths) {
    if (!$efff2a9bfd5fbec0$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $efff2a9bfd5fbec0$export$d6af199866bfb566(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $efff2a9bfd5fbec0$export$98e628dec113755e(h.outputLen);
    $efff2a9bfd5fbec0$export$98e628dec113755e(h.blockLen);
}
function $efff2a9bfd5fbec0$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $efff2a9bfd5fbec0$export$c789db2c85949867(out, instance) {
    $efff2a9bfd5fbec0$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $efff2a9bfd5fbec0$var$assert = {
    number: $efff2a9bfd5fbec0$export$98e628dec113755e,
    bool: $efff2a9bfd5fbec0$export$87b259aa03e3d267,
    bytes: $efff2a9bfd5fbec0$export$b3317979f9250576,
    hash: $efff2a9bfd5fbec0$export$d6af199866bfb566,
    exists: $efff2a9bfd5fbec0$export$f7e9f41ea797a17,
    output: $efff2a9bfd5fbec0$export$c789db2c85949867
};
var $efff2a9bfd5fbec0$export$2e2bcd8739ae039 = $efff2a9bfd5fbec0$var$assert;

});

parcelRegister("iv9D2", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $d7829749d3e0d363$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $d7829749d3e0d363$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $d7829749d3e0d363$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $d7829749d3e0d363$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $d7829749d3e0d363$export$5d12cc1da441323f; });
const $d7829749d3e0d363$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $d7829749d3e0d363$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $d7829749d3e0d363$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $d7829749d3e0d363$var$U32_MASK64),
        l: Number(n >> $d7829749d3e0d363$var$_32n & $d7829749d3e0d363$var$U32_MASK64)
    };
    return {
        h: Number(n >> $d7829749d3e0d363$var$_32n & $d7829749d3e0d363$var$U32_MASK64) | 0,
        l: Number(n & $d7829749d3e0d363$var$U32_MASK64) | 0
    };
}
function $d7829749d3e0d363$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $d7829749d3e0d363$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $d7829749d3e0d363$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $d7829749d3e0d363$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $d7829749d3e0d363$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $d7829749d3e0d363$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $d7829749d3e0d363$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $d7829749d3e0d363$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $d7829749d3e0d363$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $d7829749d3e0d363$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $d7829749d3e0d363$export$a088d44bd387d2a3 = (_h, l)=>l;
const $d7829749d3e0d363$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $d7829749d3e0d363$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $d7829749d3e0d363$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $d7829749d3e0d363$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $d7829749d3e0d363$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $d7829749d3e0d363$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $d7829749d3e0d363$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $d7829749d3e0d363$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $d7829749d3e0d363$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $d7829749d3e0d363$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $d7829749d3e0d363$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $d7829749d3e0d363$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $d7829749d3e0d363$var$u64 = {
    fromBig: $d7829749d3e0d363$export$9625d4333cb56c3f,
    split: $d7829749d3e0d363$export$65980d18b75784e2,
    toBig: $d7829749d3e0d363$export$30f78adcaaa2eb7,
    shrSH: $d7829749d3e0d363$export$75aa78dc5bd52853,
    shrSL: $d7829749d3e0d363$export$a0225ff0aee14e25,
    rotrSH: $d7829749d3e0d363$export$97f812dfd830ca87,
    rotrSL: $d7829749d3e0d363$export$60987e30e2c9d9d,
    rotrBH: $d7829749d3e0d363$export$af9c7fbac44dcb76,
    rotrBL: $d7829749d3e0d363$export$f619171d6d5ac414,
    rotr32H: $d7829749d3e0d363$export$a088d44bd387d2a3,
    rotr32L: $d7829749d3e0d363$export$8415aae4d1f69577,
    rotlSH: $d7829749d3e0d363$export$4b80a2917447870e,
    rotlSL: $d7829749d3e0d363$export$20652918a7b63b3,
    rotlBH: $d7829749d3e0d363$export$a52f14bf902f9977,
    rotlBL: $d7829749d3e0d363$export$5d12cc1da441323f,
    add: $d7829749d3e0d363$export$e16d8520af44a096,
    add3L: $d7829749d3e0d363$export$c0c22b91f08911f,
    add3H: $d7829749d3e0d363$export$ef7b26044977a8ec,
    add4L: $d7829749d3e0d363$export$2f4e199c560f545d,
    add4H: $d7829749d3e0d363$export$e909220d675a7741,
    add5H: $d7829749d3e0d363$export$b45ee8d78c965098,
    add5L: $d7829749d3e0d363$export$d732b061fe9c9ae4
};
var $d7829749d3e0d363$export$2e2bcd8739ae039 = $d7829749d3e0d363$var$u64;

});

parcelRegister("go151", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $bedfb9b6c6ad46c4$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "isLE", function () { return $bedfb9b6c6ad46c4$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $bedfb9b6c6ad46c4$export$97b40fc37f25d711; });
$parcel$export(module.exports, "toBytes", function () { return $bedfb9b6c6ad46c4$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "Hash", function () { return $bedfb9b6c6ad46c4$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $bedfb9b6c6ad46c4$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $bedfb9b6c6ad46c4$export$e18964dbd6e083c1; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $dEyEH = parcelRequire("dEyEH");

var $kBuOB = parcelRequire("kBuOB");
function $bedfb9b6c6ad46c4$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
const $bedfb9b6c6ad46c4$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $bedfb9b6c6ad46c4$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $bedfb9b6c6ad46c4$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $bedfb9b6c6ad46c4$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $bedfb9b6c6ad46c4$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $bedfb9b6c6ad46c4$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $bedfb9b6c6ad46c4$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $bedfb9b6c6ad46c4$export$4a0a88cc2d284e7f = $bedfb9b6c6ad46c4$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$bedfb9b6c6ad46c4$export$a4170f7f8be47425(n);
function $bedfb9b6c6ad46c4$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $bedfb9b6c6ad46c4$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $bedfb9b6c6ad46c4$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $bedfb9b6c6ad46c4$export$58b867e287a802c8(bytes) {
    (0, $kBuOB.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $bedfb9b6c6ad46c4$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $bedfb9b6c6ad46c4$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $bedfb9b6c6ad46c4$var$asciiToBase16(char) {
    if (char >= $bedfb9b6c6ad46c4$var$asciis._0 && char <= $bedfb9b6c6ad46c4$var$asciis._9) return char - $bedfb9b6c6ad46c4$var$asciis._0;
    if (char >= $bedfb9b6c6ad46c4$var$asciis._A && char <= $bedfb9b6c6ad46c4$var$asciis._F) return char - ($bedfb9b6c6ad46c4$var$asciis._A - 10);
    if (char >= $bedfb9b6c6ad46c4$var$asciis._a && char <= $bedfb9b6c6ad46c4$var$asciis._f) return char - ($bedfb9b6c6ad46c4$var$asciis._a - 10);
    return;
}
function $bedfb9b6c6ad46c4$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $bedfb9b6c6ad46c4$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $bedfb9b6c6ad46c4$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $bedfb9b6c6ad46c4$export$bdd553fddd433dcb = async ()=>{};
async function $bedfb9b6c6ad46c4$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $bedfb9b6c6ad46c4$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $bedfb9b6c6ad46c4$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $bedfb9b6c6ad46c4$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $bedfb9b6c6ad46c4$export$3df70a15530b5e81(data);
    (0, $kBuOB.bytes)(data);
    return data;
}
function $bedfb9b6c6ad46c4$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $kBuOB.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $bedfb9b6c6ad46c4$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $bedfb9b6c6ad46c4$var$toStr = {}.toString;
function $bedfb9b6c6ad46c4$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $bedfb9b6c6ad46c4$var$toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $bedfb9b6c6ad46c4$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($bedfb9b6c6ad46c4$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $bedfb9b6c6ad46c4$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($bedfb9b6c6ad46c4$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $bedfb9b6c6ad46c4$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($bedfb9b6c6ad46c4$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $bedfb9b6c6ad46c4$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $dEyEH.crypto) && typeof (0, $dEyEH.crypto).getRandomValues === 'function') return (0, $dEyEH.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("dEyEH", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $9f09e4a13f1d4a76$export$7effb53edfc7fa2d; });
const $9f09e4a13f1d4a76$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});






parcelRegister("1MtXL", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $14c18421f12ded2f$export$58adb3bec8346d0f; });

var $4Yn1v = parcelRequire("4Yn1v");

var $ihJau = parcelRequire("ihJau");

var $6DW0V = parcelRequire("6DW0V");
function $14c18421f12ded2f$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $ihJau.isHex)(value, {
        strict: false
    })) return $14c18421f12ded2f$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $14c18421f12ded2f$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $14c18421f12ded2f$var$assertStartOffset(value, start) {
    if (typeof start === 'number' && start > 0 && start > (0, $6DW0V.size)(value) - 1) throw new (0, $4Yn1v.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: 'start',
        size: (0, $6DW0V.size)(value)
    });
}
function $14c18421f12ded2f$var$assertEndOffset(value, start, end) {
    if (typeof start === 'number' && typeof end === 'number' && (0, $6DW0V.size)(value) !== end - start) throw new (0, $4Yn1v.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: 'end',
        size: (0, $6DW0V.size)(value)
    });
}
function $14c18421f12ded2f$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $14c18421f12ded2f$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $14c18421f12ded2f$var$assertEndOffset(value, start, end);
    return value;
}
function $14c18421f12ded2f$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $14c18421f12ded2f$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace('0x', '').slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $14c18421f12ded2f$var$assertEndOffset(value, start, end);
    return value;
}

});


parcelRegister("eCXus", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", function () { return $aa62c2ce5d1eea1b$export$bb3e0a434581ff8; });

var $aLn5t = parcelRequire("aLn5t");

var $aC23r = parcelRequire("aC23r");

var $a7Tc3 = parcelRequire("a7Tc3");

var $b4dTF = parcelRequire("b4dTF");
const $aa62c2ce5d1eea1b$var$docsPath = '/docs/contract/encodeFunctionData';
function $aa62c2ce5d1eea1b$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $b4dTF.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $aLn5t.AbiFunctionNotFoundError)(functionName, {
            docsPath: $aa62c2ce5d1eea1b$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== 'function') throw new (0, $aLn5t.AbiFunctionNotFoundError)(undefined, {
        docsPath: $aa62c2ce5d1eea1b$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $aC23r.toFunctionSelector)((0, $a7Tc3.formatAbiItem)(abiItem))
    };
}

});
parcelRegister("aC23r", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", function () { return $7b9f0bfbc3fa94b0$export$e2442488533809cb; });

var $1MtXL = parcelRequire("1MtXL");

var $64mg2 = parcelRequire("64mg2");
const $7b9f0bfbc3fa94b0$export$e2442488533809cb = (fn)=>(0, $1MtXL.slice)((0, $64mg2.toSignatureHash)(fn), 0, 4);

});
parcelRegister("64mg2", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", function () { return $46b461b47ed7295b$export$d809beebc9c913db; });

var $gXN4S = parcelRequire("gXN4S");

var $hSsdh = parcelRequire("hSsdh");
function $46b461b47ed7295b$export$d809beebc9c913db(fn) {
    return (0, $gXN4S.hashSignature)((0, $hSsdh.toSignature)(fn));
}

});
parcelRegister("gXN4S", function(module, exports) {

$parcel$export(module.exports, "hashSignature", function () { return $c59839d656740c08$export$77bbcd7aaec17976; });

var $di7YF = parcelRequire("di7YF");

var $cGfzM = parcelRequire("cGfzM");
const $c59839d656740c08$var$hash = (value)=>(0, $cGfzM.keccak256)((0, $di7YF.toBytes)(value));
function $c59839d656740c08$export$77bbcd7aaec17976(sig) {
    return $c59839d656740c08$var$hash(sig);
}

});

parcelRegister("hSsdh", function(module, exports) {

$parcel$export(module.exports, "toSignature", function () { return $d03d5d61eccb967a$export$d075a2fd83e0ecb; });

var $e41aC = parcelRequire("e41aC");

var $fpgrB = parcelRequire("fpgrB");
const $d03d5d61eccb967a$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === 'string') return def;
        return (0, $e41aC.formatAbiItem)(def);
    })();
    return (0, $fpgrB.normalizeSignature)(def_);
};

});
parcelRegister("e41aC", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $a3d258ca130be4aa$export$dc5d0ff4fc2fdee1; });

var $8fiIF = parcelRequire("8fiIF");
function $a3d258ca130be4aa$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === 'function') return `function ${abiItem.name}(${(0, $8fiIF.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== 'nonpayable' ? ` ${abiItem.stateMutability}` : ''}${abiItem.outputs.length ? ` returns (${(0, $8fiIF.formatAbiParameters)(abiItem.outputs)})` : ''}`;
    if (abiItem.type === 'event') return `event ${abiItem.name}(${(0, $8fiIF.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === 'error') return `error ${abiItem.name}(${(0, $8fiIF.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === 'constructor') return `constructor(${(0, $8fiIF.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === 'payable' ? ' payable' : ''}`;
    if (abiItem.type === 'fallback') return 'fallback()';
    return 'receive() external payable';
}

});
parcelRegister("8fiIF", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", function () { return $600e3ebd955eaca7$export$c55dbda1a081631e; });

var $01OOt = parcelRequire("01OOt");
function $600e3ebd955eaca7$export$c55dbda1a081631e(abiParameters) {
    let params = '';
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $01OOt.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ', ';
    }
    return params;
}

});
parcelRegister("01OOt", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", function () { return $0057828a20d9252b$export$c75e01ebc733dc6b; });

var $a4qvc = parcelRequire("a4qvc");
// https://regexr.com/7f7rv
const $0057828a20d9252b$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $0057828a20d9252b$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($0057828a20d9252b$var$tupleRegex.test(abiParameter.type) && 'components' in abiParameter) {
        type = '(';
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $0057828a20d9252b$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ', ';
        }
        const result = (0, $a4qvc.execTyped)($0057828a20d9252b$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ''}`;
        return $0057828a20d9252b$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ('indexed' in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("a4qvc", function(module, exports) {

$parcel$export(module.exports, "execTyped", function () { return $754ed5ea97d64c56$export$1cca4755fb17f5bd; });
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $754ed5ea97d64c56$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $754ed5ea97d64c56$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $754ed5ea97d64c56$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $754ed5ea97d64c56$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("fpgrB", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", function () { return $b375f24798a6b56e$export$5cba87ebe4d0307a; });

var $59dO4 = parcelRequire("59dO4");
function $b375f24798a6b56e$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = '';
    let level = 0;
    let result = '';
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            '(',
            ')',
            ','
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === '(') level++;
        if (char === ')') level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === ' ' && [
                'event',
                'function',
                ''
            ].includes(result)) result = '';
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ')') {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === ' ') {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== ',' && current !== ',' && current !== ',(') {
                current = '';
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $59dO4.BaseError)('Unable to normalize signature.');
    return result;
}

});




parcelRegister("b4dTF", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", function () { return $80ead9149dbcb085$export$99b134cd177e9574; });

var $aLn5t = parcelRequire("aLn5t");

var $ihJau = parcelRequire("ihJau");

var $deJrM = parcelRequire("deJrM");

var $4SCWA = parcelRequire("4SCWA");

var $aC23r = parcelRequire("aC23r");
function $80ead9149dbcb085$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $ihJau.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === 'function') return (0, $aC23r.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === 'event') return (0, $4SCWA.toEventSelector)(abiItem) === name;
            return false;
        }
        return 'name' in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!('inputs' in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = 'inputs' in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $80ead9149dbcb085$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && 'inputs' in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $80ead9149dbcb085$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $aLn5t.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $80ead9149dbcb085$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case 'address':
            return (0, $deJrM.isAddress)(arg, {
                strict: false
            });
        case 'bool':
            return argType === 'boolean';
        case 'function':
            return argType === 'string';
        case 'string':
            return argType === 'string';
        default:
            if (abiParameterType === 'tuple' && 'components' in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $80ead9149dbcb085$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === 'number' || argType === 'bigint';
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === 'string' || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$80ead9149dbcb085$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, '')
                }));
            return false;
    }
}
function $80ead9149dbcb085$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === 'tuple' && targetParameter.type === 'tuple' && 'components' in sourceParameter && 'components' in targetParameter) return $80ead9149dbcb085$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes('address') && types.includes('bytes20')) return true;
            if (types.includes('address') && types.includes('string')) return (0, $deJrM.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes('address') && types.includes('bytes')) return (0, $deJrM.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("4SCWA", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", function () { return $38da6a06fb299f2f$export$351f40ec61b2972; });

var $64mg2 = parcelRequire("64mg2");
const $38da6a06fb299f2f$export$351f40ec61b2972 = (0, $64mg2.toSignatureHash);

});




parcelRegister("1gqt2", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $0ebbd0e940068cdc$export$d4c241cec96564c1; });

var $cGfzM = parcelRequire("cGfzM");

var $6C4WL = parcelRequire("6C4WL");
function $0ebbd0e940068cdc$export$d4c241cec96564c1(message, to_) {
    return (0, $cGfzM.keccak256)((0, $6C4WL.toPrefixedMessage)(message), to_);
}

});
parcelRegister("6C4WL", function(module, exports) {

$parcel$export(module.exports, "toPrefixedMessage", function () { return $4d0a21000310e448$export$6c55de89b570d8ea; });

var $3z3jw = parcelRequire("3z3jw");

var $cr3IT = parcelRequire("cr3IT");

var $6DW0V = parcelRequire("6DW0V");

var $erlnU = parcelRequire("erlnU");
function $4d0a21000310e448$export$6c55de89b570d8ea(message_) {
    const message = (()=>{
        if (typeof message_ === 'string') return (0, $erlnU.stringToHex)(message_);
        if (typeof message_.raw === 'string') return message_.raw;
        return (0, $erlnU.bytesToHex)(message_.raw);
    })();
    const prefix = (0, $erlnU.stringToHex)(`${(0, $3z3jw.presignMessagePrefix)}${(0, $6DW0V.size)(message)}`);
    return (0, $cr3IT.concat)([
        prefix,
        message
    ]);
}

});
parcelRegister("3z3jw", function(module, exports) {

$parcel$export(module.exports, "presignMessagePrefix", function () { return $29873607a8b92abc$export$39d5d904b514ff63; });
const $29873607a8b92abc$export$39d5d904b514ff63 = '\x19Ethereum Signed Message:\n';

});



parcelRegister("4Jnow", function(module, exports) {

$parcel$export(module.exports, "hashTypedData", function () { return $371d830d29cdd2d4$export$9e2bd399d9aaab56; });
$parcel$export(module.exports, "hashDomain", function () { return $371d830d29cdd2d4$export$d4e887b08c47faea; });
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $4Gz5S = parcelRequire("4Gz5S");

var $cr3IT = parcelRequire("cr3IT");

var $erlnU = parcelRequire("erlnU");

var $cGfzM = parcelRequire("cGfzM");

var $25ZIe = parcelRequire("25ZIe");
function $371d830d29cdd2d4$export$9e2bd399d9aaab56(parameters) {
    const { domain: domain = {}, message: message, primaryType: primaryType } = parameters;
    const types = {
        EIP712Domain: (0, $25ZIe.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $25ZIe.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        '0x1901'
    ];
    if (domain) parts.push($371d830d29cdd2d4$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== 'EIP712Domain') parts.push($371d830d29cdd2d4$export$4b8f67c208624fdf({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $cGfzM.keccak256)((0, $cr3IT.concat)(parts));
}
function $371d830d29cdd2d4$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $371d830d29cdd2d4$export$4b8f67c208624fdf({
        data: domain,
        primaryType: 'EIP712Domain',
        types: types
    });
}
function $371d830d29cdd2d4$export$4b8f67c208624fdf({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $371d830d29cdd2d4$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $cGfzM.keccak256)(encoded);
}
function $371d830d29cdd2d4$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: 'bytes32'
        }
    ];
    const encodedValues = [
        $371d830d29cdd2d4$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $371d830d29cdd2d4$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $4Gz5S.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $371d830d29cdd2d4$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $erlnU.toHex)($371d830d29cdd2d4$export$432cbecf661dce2b({
        primaryType: primaryType,
        types: types
    }));
    return (0, $cGfzM.keccak256)(encodedHashType);
}
function $371d830d29cdd2d4$export$432cbecf661dce2b({ primaryType: primaryType, types: types }) {
    let result = '';
    const unsortedDeps = $371d830d29cdd2d4$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(',')})`;
    return result;
}
function $371d830d29cdd2d4$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$371d830d29cdd2d4$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $371d830d29cdd2d4$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: 'bytes32'
        },
        (0, $cGfzM.keccak256)($371d830d29cdd2d4$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === 'bytes') {
        const prepend = value.length % 2 ? '0' : '';
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: 'bytes32'
            },
            (0, $cGfzM.keccak256)(value)
        ];
    }
    if (type === 'string') return [
        {
            type: 'bytes32'
        },
        (0, $cGfzM.keccak256)((0, $erlnU.toHex)(value))
    ];
    if (type.lastIndexOf(']') === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf('['));
        const typeValuePairs = value.map((item)=>$371d830d29cdd2d4$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: 'bytes32'
            },
            (0, $cGfzM.keccak256)((0, $4Gz5S.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}

});
parcelRegister("25ZIe", function(module, exports) {

$parcel$export(module.exports, "validateTypedData", function () { return $186beb36f1cde17d$export$fac174f558903e26; });
$parcel$export(module.exports, "getTypesForEIP712Domain", function () { return $186beb36f1cde17d$export$6a292159484ee032; });

var $aLn5t = parcelRequire("aLn5t");

var $2Puf4 = parcelRequire("2Puf4");

var $deJrM = parcelRequire("deJrM");

var $6DW0V = parcelRequire("6DW0V");

var $erlnU = parcelRequire("erlnU");

var $04MVF = parcelRequire("04MVF");

var $4Jnow = parcelRequire("4Jnow");

var $gX4Nd = parcelRequire("gX4Nd");
function $186beb36f1cde17d$export$ce8e1cf733064451(parameters) {
    const { domain: domain_, message: message_, primaryType: primaryType, types: types } = parameters;
    const normalizeData = (struct, data_)=>{
        const data = {
            ...data_
        };
        for (const param of struct){
            const { name: name, type: type } = param;
            if (type === 'address') data[name] = data[name].toLowerCase();
        }
        return data;
    };
    const domain = (()=>{
        if (!types.EIP712Domain) return {};
        if (!domain_) return {};
        return normalizeData(types.EIP712Domain, domain_);
    })();
    const message = (()=>{
        if (primaryType === 'EIP712Domain') return undefined;
        return normalizeData(types[primaryType], message_);
    })();
    return (0, $gX4Nd.stringify)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $186beb36f1cde17d$export$fac174f558903e26(parameters) {
    const { domain: domain, message: message, primaryType: primaryType, types: types } = parameters;
    const validateData = (struct, data)=>{
        for (const param of struct){
            const { name: name, type: type } = param;
            const value = data[name];
            const integerMatch = type.match((0, $04MVF.integerRegex));
            if (integerMatch && (typeof value === 'number' || typeof value === 'bigint')) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $erlnU.numberToHex)(value, {
                    signed: base === 'int',
                    size: Number.parseInt(size_) / 8
                });
            }
            if (type === 'address' && typeof value === 'string' && !(0, $deJrM.isAddress)(value)) throw new (0, $2Puf4.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $04MVF.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $6DW0V.size)(value) !== Number.parseInt(size_)) throw new (0, $aLn5t.BytesSizeMismatchError)({
                    expectedSize: Number.parseInt(size_),
                    givenSize: (0, $6DW0V.size)(value)
                });
            }
            const struct = types[type];
            if (struct) validateData(struct, value);
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    // Validate message types.
    if (primaryType !== 'EIP712Domain') validateData(types[primaryType], message);
}
function $186beb36f1cde17d$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === 'string' && {
            name: 'name',
            type: 'string'
        },
        domain?.version && {
            name: 'version',
            type: 'string'
        },
        typeof domain?.chainId === 'number' && {
            name: 'chainId',
            type: 'uint256'
        },
        domain?.verifyingContract && {
            name: 'verifyingContract',
            type: 'address'
        },
        domain?.salt && {
            name: 'salt',
            type: 'bytes32'
        }
    ].filter(Boolean);
}
function $186beb36f1cde17d$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $4Jnow.hashDomain)({
        domain: domain,
        types: {
            EIP712Domain: $186beb36f1cde17d$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}

});
parcelRegister("04MVF", function(module, exports) {

$parcel$export(module.exports, "bytesRegex", function () { return $00e65429a2dd391d$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $00e65429a2dd391d$export$45902cc189596eef; });
const $00e65429a2dd391d$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $00e65429a2dd391d$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $00e65429a2dd391d$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});

parcelRegister("gX4Nd", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $c575dfc227d35b4d$export$fac44ee5b035f737; });
const $c575dfc227d35b4d$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === 'bigint' ? value_.toString() : value_;
        return typeof replacer === 'function' ? replacer(key, value) : value;
    }, space);

});



parcelRegister("6lRjy", function(module, exports) {

$parcel$export(module.exports, "MAGIC_VALUE", function () { return $49fe0f59f2fbdc50$export$86f35aaf3a84cb8c; });
$parcel$export(module.exports, "MAGIC_VALUE_BYTES", function () { return $49fe0f59f2fbdc50$export$9306a0ebeb4e08a8; });
const $49fe0f59f2fbdc50$export$86f35aaf3a84cb8c = '0x1626ba7e';
const $49fe0f59f2fbdc50$export$9306a0ebeb4e08a8 = '0x20c13b0b';

});

parcelRegister("lmXRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8ea156c5092bea7$export$2e2bcd8739ae039; });

var $6Xsd7 = parcelRequire("6Xsd7");

var $jLELA = parcelRequire("jLELA");
const $f8ea156c5092bea7$var$hasPermission = (required, permissions)=>permissions.some((permission)=>permission.parentCapability === required);
const $f8ea156c5092bea7$var$requirePermission = ()=>(_, propertyKey, descriptor)=>{
        const originalMethod = descriptor.value;
        descriptor.value = async function() {
            // @ts-expect-error accessing private property from decorator. 'this' context is the class instance
            const wallet = new (0, $6Xsd7.Wallet)(this.communicator);
            let currentPermissions = await wallet.getPermissions();
            if (!$f8ea156c5092bea7$var$hasPermission(propertyKey, currentPermissions)) currentPermissions = await wallet.requestPermissions([
                {
                    [propertyKey]: {}
                }
            ]);
            if (!$f8ea156c5092bea7$var$hasPermission(propertyKey, currentPermissions)) throw new (0, $jLELA.PermissionsError)('Permissions rejected', (0, $jLELA.PERMISSIONS_REQUEST_REJECTED));
            return originalMethod.apply(this);
        };
        return descriptor;
    };
var $f8ea156c5092bea7$export$2e2bcd8739ae039 = $f8ea156c5092bea7$var$requirePermission;

});
parcelRegister("6Xsd7", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $510e22c748f7cdfe$export$bcca3ea514774656; });

var $alqGi = parcelRequire("alqGi");

var $jLELA = parcelRequire("jLELA");
class $510e22c748f7cdfe$export$bcca3ea514774656 {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getPermissions() {
        const response = await this.communicator.send((0, $alqGi.Methods).wallet_getPermissions, undefined);
        return response.data;
    }
    async requestPermissions(permissions) {
        if (!this.isPermissionRequestValid(permissions)) throw new (0, $jLELA.PermissionsError)('Permissions request is invalid', (0, $jLELA.PERMISSIONS_REQUEST_REJECTED));
        try {
            const response = await this.communicator.send((0, $alqGi.Methods).wallet_requestPermissions, permissions);
            return response.data;
        } catch  {
            throw new (0, $jLELA.PermissionsError)('Permissions rejected', (0, $jLELA.PERMISSIONS_REQUEST_REJECTED));
        }
    }
    isPermissionRequestValid(permissions) {
        return permissions.every((pr)=>{
            if (typeof pr === 'object') return Object.keys(pr).every((method)=>{
                if (Object.values((0, $alqGi.RestrictedMethods)).includes(method)) return true;
                return false;
            });
            return false;
        });
    }
}

});
parcelRegister("jLELA", function(module, exports) {

$parcel$export(module.exports, "PERMISSIONS_REQUEST_REJECTED", function () { return $e64207796f2569fe$export$7d5ee3f5e13b90d; });
$parcel$export(module.exports, "PermissionsError", function () { return $e64207796f2569fe$export$8bc636af3de07ca1; });
const $e64207796f2569fe$export$7d5ee3f5e13b90d = 4001;
class $e64207796f2569fe$export$8bc636af3de07ca1 extends Error {
    constructor(message, code, data){
        super(message);
        this.code = code;
        this.data = data;
        // Should adjust prototype manually because how TS handles the type extension compilation
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $e64207796f2569fe$export$8bc636af3de07ca1.prototype);
    }
}

});







parcelRegister("feuLT", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("bUb9a"),
    $parcel$import("63t4X")
]).then(()=>parcelRequire('dP5aB'));

});

parcelRegister("b8Trg", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("fgfcN"),
    $parcel$import("gVwVE")
]).then(()=>parcelRequire('kOszr'));

});

parcelRegister("gkNEl", function(module, exports) {
module.exports = $parcel$import("fgfcN").then(()=>parcelRequire('iTRKY'));

});

parcelRegister("2D1Ig", function(module, exports) {

$parcel$export(module.exports, "trezorErrorMessages", function () { return $ff9fa0d1d6a997e0$export$f34724b4e81a10e4; });
$parcel$export(module.exports, "getTrezorModule", function () { return $ff9fa0d1d6a997e0$export$7877c760b08e516b; });
$parcel$export(module.exports, "getTrezorInstance", function () { return $ff9fa0d1d6a997e0$export$22b246ed377359ea; });
$parcel$export(module.exports, "getEthereumAccounts", function () { return $ff9fa0d1d6a997e0$export$d5de980bfde9e56b; });
$parcel$export(module.exports, "valueToHex", function () { return $ff9fa0d1d6a997e0$export$7fd95ad4782e58f1; });
$parcel$export(module.exports, "getTrezorNormalizedDerivationPath", function () { return $ff9fa0d1d6a997e0$export$1e53c0113c559e93; });
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $9cRHO = parcelRequire("9cRHO");
var $9HEDW = parcelRequire("9HEDW");

var $9kvMd = parcelRequire("9kvMd");
const $ff9fa0d1d6a997e0$export$f34724b4e81a10e4 = {
    Failure_ActionCancelled: 'User rejected the transaction.'
};

async function $ff9fa0d1d6a997e0$export$7877c760b08e516b() {
    const mod = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("eLij4")));
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (mod.default.default) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return mod.default.default;
    return mod.default;
}
function $ff9fa0d1d6a997e0$export$22b246ed377359ea() {
    /*
   * Instances have a required property which is `chainId` and is using in swap execution.
   * Here we are setting it as Ethereum always since we are supporting only eth for now.
   */ const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, {
        chainId: (0, $9cRHO.ETHEREUM_CHAIN_ID)
    });
    return instances;
}
async function $ff9fa0d1d6a997e0$export$d5de980bfde9e56b() {
    const TrezorConnect = await $ff9fa0d1d6a997e0$export$7877c760b08e516b();
    const derivationPath = (0, $9kvMd.getDerivationPath)();
    const result = await TrezorConnect.ethereumGetAddress({
        path: derivationPath
    });
    if (!result.success) throw new Error(result.payload.error);
    return {
        accounts: [
            result.payload.address
        ],
        chainId: (0, $9cRHO.ETHEREUM_CHAIN_ID),
        derivationPath: derivationPath
    };
}
const $ff9fa0d1d6a997e0$export$7fd95ad4782e58f1 = (value)=>{
    const ZERO_BIGINT = BigInt(0);
    const HEX_BASE = 16;
    return BigInt(value) > ZERO_BIGINT ? `0x${BigInt(value).toString(HEX_BASE)}` : '0x0';
};
const $ff9fa0d1d6a997e0$export$1e53c0113c559e93 = (path // TrezorConnect needs master node to be added to derivation path
)=>path && !path.startsWith('m/') ? 'm/' + path : path;

});
parcelRegister("9kvMd", function(module, exports) {

$parcel$export(module.exports, "setDerivationPath", function () { return $78c70f05e4a5def0$export$7700d582a5b9e8d0; });
$parcel$export(module.exports, "getDerivationPath", function () { return $78c70f05e4a5def0$export$11792f2e0d4d6623; });
// We keep derivationPath here because we need to maintain it for signing transactions after it is set in connect method
let $78c70f05e4a5def0$var$derivationPath = '';
function $78c70f05e4a5def0$export$7700d582a5b9e8d0(path) {
    $78c70f05e4a5def0$var$derivationPath = path;
}
function $78c70f05e4a5def0$export$11792f2e0d4d6623() {
    return $78c70f05e4a5def0$var$derivationPath;
}

});

parcelRegister("eLij4", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("4135D"),
    $parcel$import("7327i")
]).then(()=>parcelRequire('efWRs'));

});


parcelRegister("jldXD", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("bUb9a"),
    $parcel$import("cX2Sd")
]).then(()=>parcelRequire('gtmay'));

});

parcelRegister("6c06I", function(module, exports) {
module.exports = $parcel$import("aFC8S").then(()=>parcelRequire('eEuQb'));

});

parcelRegister("jqcuV", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("lP2G7"),
    $parcel$import("i4xYE")
]).then(()=>parcelRequire('cNuAh'));

});

parcelRegister("d9JdJ", function(module, exports) {
module.exports = $parcel$import("goaIC").then(()=>parcelRequire('6OFP7'));

});

parcelRegister("4786x", function(module, exports) {

$parcel$export(module.exports, "namespace", function () { return $061984e7eaca629e$export$76a88f7de6507443; });
parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");

var $2BMXn = parcelRequire("2BMXn");

var $9odct = parcelRequire("9odct");
const $061984e7eaca629e$var$connect = (0, $er2za.builders).connect().action(async function() {
    const accounts = await (0, $9odct.requestZcashAccounts)();
    return (0, $er2za.utils).formatAccountsToCAIP(accounts, (0, $er2za.CAIP_ZCASH_CHAIN_ID));
}).or((0, $f59Be.standardizeAndThrowError)).build();
const $061984e7eaca629e$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action(async ()=>{
    const accounts = await (0, $9odct.getZcashAccounts)().catch(()=>[]);
    return accounts.length > 0;
}).build();
const $061984e7eaca629e$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $061984e7eaca629e$export$76a88f7de6507443 = new (0, $at2GJ.NamespaceBuilder)('UTXO', (0, $2BMXn.WALLET_ID)).action($061984e7eaca629e$var$connect).action($061984e7eaca629e$var$disconnect).action($061984e7eaca629e$var$canEagerConnect).build();

});
parcelRegister("er2za", function(module, exports) {

$parcel$export(module.exports, "builders", function () { return $a82593ebafe18eef$export$aea8daed5328d69c; });
$parcel$export(module.exports, "utils", function () { return $a82593ebafe18eef$export$eab97d15b1788b8d; });
$parcel$export(module.exports, "CAIP_NAMESPACE", function () { return $a82593ebafe18eef$export$c67e5a7ce034264a; });
$parcel$export(module.exports, "CAIP_BITCOIN_CHAIN_ID", function () { return $a82593ebafe18eef$export$28f4dfb0e05f1564; });
$parcel$export(module.exports, "CAIP_ZCASH_CHAIN_ID", function () { return $a82593ebafe18eef$export$bedb6b51960f0bf9; });



var $3ca9q = parcelRequire("3ca9q");
var $a82593ebafe18eef$var$v = Object.defineProperty;
var $a82593ebafe18eef$var$e = (o, t)=>$a82593ebafe18eef$var$v(o, "name", {
        value: t,
        configurable: !0
    });
var $a82593ebafe18eef$var$s = (o, t)=>{
    for(var r in t)$a82593ebafe18eef$var$v(o, r, {
        get: t[r],
        enumerable: !0
    });
};
var $a82593ebafe18eef$export$e324594224ef24da = {};
$a82593ebafe18eef$var$s($a82593ebafe18eef$export$e324594224ef24da, {
    recommended: ()=>$a82593ebafe18eef$var$T
});
function $a82593ebafe18eef$var$y(o) {
    let [, t] = o.state();
    t("network", null), t("accounts", null), t("connected", !1), t("connecting", !1), t("connectArgs", null);
}
$a82593ebafe18eef$var$e($a82593ebafe18eef$var$y, "disconnect");
var $a82593ebafe18eef$var$g = [
    [
        "disconnect",
        $a82593ebafe18eef$var$y
    ]
];
var $a82593ebafe18eef$var$T = [
    ...$a82593ebafe18eef$var$g
];
var $a82593ebafe18eef$export$742acabee3dd6465 = {};
$a82593ebafe18eef$var$s($a82593ebafe18eef$export$742acabee3dd6465, {
    recommended: ()=>$a82593ebafe18eef$var$k
});
function $a82593ebafe18eef$var$a(o) {
    let [, t] = o.state();
    t("connecting", !1);
}
$a82593ebafe18eef$var$e($a82593ebafe18eef$var$a, "intoConnectionFinished");
var $a82593ebafe18eef$var$d = [
    [
        "connect",
        $a82593ebafe18eef$var$a
    ]
];
var $a82593ebafe18eef$var$k = [
    ...$a82593ebafe18eef$var$d
];
var $a82593ebafe18eef$export$21c0ac7fe1cef1b8 = {};
$a82593ebafe18eef$var$s($a82593ebafe18eef$export$21c0ac7fe1cef1b8, {
    recommended: ()=>$a82593ebafe18eef$var$V
});
var $a82593ebafe18eef$var$n = class {
    static{
        $a82593ebafe18eef$var$e(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #o = new Map;
    #r = new Map;
    #n;
    constructor(t){
        this.name = t;
    }
    and(t) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(t), this;
    }
    or(t) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(t), this;
    }
    before(t) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(t), this;
    }
    after(t) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(t), this;
    }
    action(t) {
        return this.#n = t, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#r,
            after: this.#o,
            and: this.#e,
            or: this.#t
        };
    }
};
function $a82593ebafe18eef$var$C(o) {
    try {
        return (0, $3ca9q.AccountId).parse(o), !0;
    } catch  {
        return !1;
    }
}
$a82593ebafe18eef$var$e($a82593ebafe18eef$var$C, "isValidCaipAddress");
function $a82593ebafe18eef$var$i(o, t) {
    if (!t.every($a82593ebafe18eef$var$C)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${t}`);
    let [, r] = o.state();
    return r("accounts", t), r("connected", !0), t;
}
$a82593ebafe18eef$var$e($a82593ebafe18eef$var$i, "connectAndUpdateStateForSingleNetwork");
function $a82593ebafe18eef$var$p(o) {
    let [, t] = o.state();
    t("connecting", !0);
}
$a82593ebafe18eef$var$e($a82593ebafe18eef$var$p, "intoConnecting");
var $a82593ebafe18eef$var$h = [
    [
        "connect",
        $a82593ebafe18eef$var$p
    ]
];
var $a82593ebafe18eef$var$V = [
    [
        "connect",
        $a82593ebafe18eef$var$i
    ]
];
var $a82593ebafe18eef$export$1c4c1e3098bf5ebe = {};
$a82593ebafe18eef$var$s($a82593ebafe18eef$export$1c4c1e3098bf5ebe, {
    recommended: ()=>$a82593ebafe18eef$var$M
});
var $a82593ebafe18eef$var$M = [
    ...$a82593ebafe18eef$var$h
];
var $a82593ebafe18eef$export$aea8daed5328d69c = {};
$a82593ebafe18eef$var$s($a82593ebafe18eef$export$aea8daed5328d69c, {
    connect: ()=>$a82593ebafe18eef$var$W
});
var $a82593ebafe18eef$var$W = $a82593ebafe18eef$var$e(()=>new $a82593ebafe18eef$var$n("connect").and($a82593ebafe18eef$var$i).before($a82593ebafe18eef$var$p).after($a82593ebafe18eef$var$a), "connect");
var $a82593ebafe18eef$export$eab97d15b1788b8d = {};
$a82593ebafe18eef$var$s($a82593ebafe18eef$export$eab97d15b1788b8d, {
    formatAccountsToCAIP: ()=>$a82593ebafe18eef$var$L
});
var $a82593ebafe18eef$export$c67e5a7ce034264a = "bip122", $a82593ebafe18eef$export$28f4dfb0e05f1564 = "000000000019d6689c085ae165831e93", $a82593ebafe18eef$export$bedb6b51960f0bf9 = "zcash";
function $a82593ebafe18eef$var$L(o, t) {
    return o.map((r)=>(0, $3ca9q.AccountId).format({
            address: r.toString(),
            chainId: {
                namespace: $a82593ebafe18eef$export$c67e5a7ce034264a,
                reference: t
            }
        }));
}
$a82593ebafe18eef$var$e($a82593ebafe18eef$var$L, "formatAccountsToCAIP");

});

parcelRegister("2BMXn", function(module, exports) {

$parcel$export(module.exports, "WALLET_ID", function () { return $56cca921bc1a4318$export$7c460c214963f696; });
$parcel$export(module.exports, "info", function () { return $56cca921bc1a4318$export$a80b3bd66acc52ff; });

var $fMDeT = parcelRequire("fMDeT");
const $56cca921bc1a4318$export$7c460c214963f696 = 'vultisig';
const $56cca921bc1a4318$export$a80b3bd66acc52ff = {
    name: 'Vultisig',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/vultisig/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/vultisig-extension/ggafhcdaplkhmmnlbfjpnnkepdfjaelb',
        homepage: 'https://vultisig.com/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Zcash',
                        value: 'UTXO',
                        id: 'ZCASH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((blockchain)=>blockchain.name === 'ZCASH')
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $fMDeT.default)()
            }
        }
    ]
};

});
parcelRegister("fMDeT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fe7c9c8668941c4$export$2e2bcd8739ae039; });
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $1fe7c9c8668941c4$export$2e2bcd8739ae039() {
    const { Signer: UtxoSigner } = await (parcelRequire("d9JdJ"));
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new UtxoSigner());
    return signers;
}

});


parcelRegister("9odct", function(module, exports) {

$parcel$export(module.exports, "requestZcashAccounts", function () { return $1c11f022affd7603$export$2b19706f55e67963; });
$parcel$export(module.exports, "getZcashAccounts", function () { return $1c11f022affd7603$export$85b7e8c840a64ffe; });

var $5ZZUh = parcelRequire("5ZZUh");
async function $1c11f022affd7603$export$2b19706f55e67963() {
    return (0, $5ZZUh.vultisigZcash)().requestAccounts();
}
async function $1c11f022affd7603$export$85b7e8c840a64ffe() {
    return await (0, $5ZZUh.vultisigZcash)().request({
        method: 'get_accounts'
    });
}

});
parcelRegister("5ZZUh", function(module, exports) {

$parcel$export(module.exports, "vultisig", function () { return $1f36efab3d2af451$export$8db0aa19ab231262; });
$parcel$export(module.exports, "vultisigZcash", function () { return $1f36efab3d2af451$export$6fd81376925c3189; });

var $9HEDW = parcelRequire("9HEDW");
function $1f36efab3d2af451$export$8db0aa19ab231262() {
    const { vultisig: vultisig } = window;
    if (!vultisig) return null;
    const instances = new Map();
    if (vultisig.zcash) instances.set((0, $9HEDW.LegacyNetworks).ZCASH, vultisig.zcash);
    return instances;
}
function $1f36efab3d2af451$export$6fd81376925c3189() {
    const instances = $1f36efab3d2af451$export$8db0aa19ab231262();
    const zcashInstance = instances?.get((0, $9HEDW.LegacyNetworks).ZCASH);
    if (!zcashInstance) throw new Error('Vultisig not injected. Please check your wallet.');
    return zcashInstance;
}

});



parcelRegister("fyg7Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $1Hjuw = parcelRequire("1Hjuw");

var $jMc9N = parcelRequire("jMc9N");

var $5t6iP = parcelRequire("5t6iP");

var $dXotL = parcelRequire("dXotL");

var $kEua4 = parcelRequire("kEua4");
class $b5268a2e2dc51546$var$HeartBeat extends $dXotL.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $jMc9N.EventEmitter();
        this.interval = $kEua4.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $kEua4.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $1Hjuw.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $b5268a2e2dc51546$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $1Hjuw.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $1Hjuw.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $5t6iP.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($kEua4.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $b5268a2e2dc51546$var$HeartBeat;

});
parcelRegister("1Hjuw", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $13c8ed2d1d22cdeb$export$1050f835b63b671e; });
$parcel$export(module.exports, "__exportStar", function () { return $13c8ed2d1d22cdeb$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $13c8ed2d1d22cdeb$var$extendStatics = function(d, b) {
    $13c8ed2d1d22cdeb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $13c8ed2d1d22cdeb$var$extendStatics(d, b);
};
function $13c8ed2d1d22cdeb$export$a8ba968b8961cb8a(d, b) {
    $13c8ed2d1d22cdeb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $13c8ed2d1d22cdeb$export$18ce0697a983be9b = function() {
    $13c8ed2d1d22cdeb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13c8ed2d1d22cdeb$export$18ce0697a983be9b.apply(this, arguments);
};
function $13c8ed2d1d22cdeb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $13c8ed2d1d22cdeb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $13c8ed2d1d22cdeb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $13c8ed2d1d22cdeb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $13c8ed2d1d22cdeb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $13c8ed2d1d22cdeb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $13c8ed2d1d22cdeb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $13c8ed2d1d22cdeb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $13c8ed2d1d22cdeb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $13c8ed2d1d22cdeb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $13c8ed2d1d22cdeb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($13c8ed2d1d22cdeb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $13c8ed2d1d22cdeb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $13c8ed2d1d22cdeb$export$10c90e4f7922046c(v) {
    return this instanceof $13c8ed2d1d22cdeb$export$10c90e4f7922046c ? (this.v = v, this) : new $13c8ed2d1d22cdeb$export$10c90e4f7922046c(v);
}
function $13c8ed2d1d22cdeb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $13c8ed2d1d22cdeb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $13c8ed2d1d22cdeb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $13c8ed2d1d22cdeb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $13c8ed2d1d22cdeb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $13c8ed2d1d22cdeb$export$19a8beecd37a4c45 === "function" ? $13c8ed2d1d22cdeb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $13c8ed2d1d22cdeb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $13c8ed2d1d22cdeb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $13c8ed2d1d22cdeb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $13c8ed2d1d22cdeb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $13c8ed2d1d22cdeb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("5t6iP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("8kqvb")), module.exports);

$gb6Ch.__exportStar((parcelRequire("ixQvC")), module.exports);

$gb6Ch.__exportStar((parcelRequire("5jj58")), module.exports);

$gb6Ch.__exportStar((parcelRequire("kSiPP")), module.exports);

});
parcelRegister("gb6Ch", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $bc72ce4c09ef6dfc$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bc72ce4c09ef6dfc$var$extendStatics = function(d, b) {
    $bc72ce4c09ef6dfc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $bc72ce4c09ef6dfc$var$extendStatics(d, b);
};
function $bc72ce4c09ef6dfc$export$a8ba968b8961cb8a(d, b) {
    $bc72ce4c09ef6dfc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc72ce4c09ef6dfc$export$18ce0697a983be9b = function() {
    $bc72ce4c09ef6dfc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc72ce4c09ef6dfc$export$18ce0697a983be9b.apply(this, arguments);
};
function $bc72ce4c09ef6dfc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bc72ce4c09ef6dfc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bc72ce4c09ef6dfc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bc72ce4c09ef6dfc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bc72ce4c09ef6dfc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bc72ce4c09ef6dfc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $bc72ce4c09ef6dfc$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $bc72ce4c09ef6dfc$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $bc72ce4c09ef6dfc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bc72ce4c09ef6dfc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bc72ce4c09ef6dfc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bc72ce4c09ef6dfc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bc72ce4c09ef6dfc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bc72ce4c09ef6dfc$export$10c90e4f7922046c(v) {
    return this instanceof $bc72ce4c09ef6dfc$export$10c90e4f7922046c ? (this.v = v, this) : new $bc72ce4c09ef6dfc$export$10c90e4f7922046c(v);
}
function $bc72ce4c09ef6dfc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bc72ce4c09ef6dfc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bc72ce4c09ef6dfc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bc72ce4c09ef6dfc$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $bc72ce4c09ef6dfc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bc72ce4c09ef6dfc$export$19a8beecd37a4c45 === "function" ? $bc72ce4c09ef6dfc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bc72ce4c09ef6dfc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $bc72ce4c09ef6dfc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $bc72ce4c09ef6dfc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bc72ce4c09ef6dfc$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $bc72ce4c09ef6dfc$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("8kqvb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("3KNkk")), module.exports);

$gb6Ch.__exportStar((parcelRequire("6WgX8")), module.exports);

});
parcelRegister("3KNkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $2bbbee43388fbee0$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $2bbbee43388fbee0$var$delay;

});

parcelRegister("6WgX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $kSiPP = parcelRequire("kSiPP");
function $50d54f50538fb2d0$var$toMiliseconds(seconds) {
    return seconds * $kSiPP.ONE_THOUSAND;
}
module.exports.toMiliseconds = $50d54f50538fb2d0$var$toMiliseconds;
function $50d54f50538fb2d0$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $kSiPP.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $50d54f50538fb2d0$var$fromMiliseconds;

});
parcelRegister("kSiPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("Otqu1")), module.exports);

$gb6Ch.__exportStar((parcelRequire("4pbJv")), module.exports);

});
parcelRegister("Otqu1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("4pbJv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("ixQvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d8040a3ccb060e88$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d8040a3ccb060e88$var$Watch;
module.exports.default = $d8040a3ccb060e88$var$Watch;

});

parcelRegister("5jj58", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("cSSID")), module.exports);

});
parcelRegister("cSSID", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $9614f932f38bf643$var$IWatch {
}
module.exports.IWatch = $9614f932f38bf643$var$IWatch;

});



parcelRegister("dXotL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Hjuw = parcelRequire("1Hjuw");

$1Hjuw.__exportStar((parcelRequire("1g4a1")), module.exports);

});
parcelRegister("1g4a1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("4ekPy");
var $5PJ3Z = parcelRequire("5PJ3Z");
class $0eaa834b56de9154$var$IHeartBeat extends $5PJ3Z.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $0eaa834b56de9154$var$IHeartBeat;

});
parcelRegister("4ekPy", function(module, exports) {
$parcel$export(module.exports, "IEvents", function () { return (parcelRequire("5PJ3Z")).IEvents; });
parcelRequire("5PJ3Z");

});
parcelRegister("5PJ3Z", function(module, exports) {

$parcel$export(module.exports, "IEvents", function () { return $43f4abd668b3d79e$export$ab429ec7e240e546; });
class $43f4abd668b3d79e$export$ab429ec7e240e546 {
}

});




parcelRegister("kEua4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Hjuw = parcelRequire("1Hjuw");

$1Hjuw.__exportStar((parcelRequire("kldVY")), module.exports);

});
parcelRegister("kldVY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $5t6iP = parcelRequire("5t6iP");
module.exports.HEARTBEAT_INTERVAL = $5t6iP.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});



parcelRegister("3C0Nn", function(module, exports) {
'use strict';

var $bb5r4 = parcelRequire("bb5r4");
module.exports = $2a1589ac5e33c3f7$var$pino;
const $2a1589ac5e33c3f7$var$_console = $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback().console || {};
const $2a1589ac5e33c3f7$var$stdSerializers = {
    mapHttpRequest: $2a1589ac5e33c3f7$var$mock,
    mapHttpResponse: $2a1589ac5e33c3f7$var$mock,
    wrapRequestSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapResponseSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapErrorSerializer: $2a1589ac5e33c3f7$var$passthrough,
    req: $2a1589ac5e33c3f7$var$mock,
    res: $2a1589ac5e33c3f7$var$mock,
    err: $2a1589ac5e33c3f7$var$asErrValue
};
function $2a1589ac5e33c3f7$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== '!stdSerializers.err';
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $2a1589ac5e33c3f7$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== 'function') throw Error('pino: transmit option must have a send function');
    const proto = opts.browser.write || $2a1589ac5e33c3f7$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $2a1589ac5e33c3f7$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf('!stdSerializers.err') > -1) stdErrSerialize = false;
    const levels = [
        'error',
        'fatal',
        'warn',
        'info',
        'debug',
        'trace'
    ];
    if (typeof proto === 'function') proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = 'silent';
    const level = opts.level || 'info';
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $2a1589ac5e33c3f7$var$noop;
    Object.defineProperty(logger, 'levelVal', {
        get: getLevelVal
    });
    Object.defineProperty(logger, 'level', {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $2a1589ac5e33c3f7$var$getTimeFunction(opts)
    };
    logger.levels = $2a1589ac5e33c3f7$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $2a1589ac5e33c3f7$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape();
    function getLevelVal() {
        return this.level === 'silent' ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== 'silent' && !this.levels.values[level]) throw Error('unknown level ' + level);
        this._level = level;
        $2a1589ac5e33c3f7$var$set(setOpts, logger, 'error', 'log') // <-- must stay first
        ;
        $2a1589ac5e33c3f7$var$set(setOpts, logger, 'fatal', 'error');
        $2a1589ac5e33c3f7$var$set(setOpts, logger, 'warn', 'error');
        $2a1589ac5e33c3f7$var$set(setOpts, logger, 'info', 'log');
        $2a1589ac5e33c3f7$var$set(setOpts, logger, 'debug', 'log');
        $2a1589ac5e33c3f7$var$set(setOpts, logger, 'trace', 'log');
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error('missing bindings for child Pino');
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $2a1589ac5e33c3f7$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $2a1589ac5e33c3f7$var$bind(parent, bindings, 'error');
            this.fatal = $2a1589ac5e33c3f7$var$bind(parent, bindings, 'fatal');
            this.warn = $2a1589ac5e33c3f7$var$bind(parent, bindings, 'warn');
            this.info = $2a1589ac5e33c3f7$var$bind(parent, bindings, 'info');
            this.debug = $2a1589ac5e33c3f7$var$bind(parent, bindings, 'debug');
            this.trace = $2a1589ac5e33c3f7$var$bind(parent, bindings, 'trace');
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$2a1589ac5e33c3f7$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: 'trace',
        20: 'debug',
        30: 'info',
        40: 'warn',
        50: 'error',
        60: 'fatal'
    }
};
$2a1589ac5e33c3f7$var$pino.stdSerializers = $2a1589ac5e33c3f7$var$stdSerializers;
$2a1589ac5e33c3f7$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $2a1589ac5e33c3f7$var$nullTime,
    epochTime: $2a1589ac5e33c3f7$var$epochTime,
    unixTime: $2a1589ac5e33c3f7$var$unixTime,
    isoTime: $2a1589ac5e33c3f7$var$isoTime
});
function $2a1589ac5e33c3f7$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $2a1589ac5e33c3f7$var$noop : proto[level] ? proto[level] : $2a1589ac5e33c3f7$var$_console[level] || $2a1589ac5e33c3f7$var$_console[fallback] || $2a1589ac5e33c3f7$var$noop;
    $2a1589ac5e33c3f7$var$wrap(opts, logger, level);
}
function $2a1589ac5e33c3f7$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $2a1589ac5e33c3f7$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $2a1589ac5e33c3f7$var$_console ? $2a1589ac5e33c3f7$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $2a1589ac5e33c3f7$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $2a1589ac5e33c3f7$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $2a1589ac5e33c3f7$var$pino.levels.values[transmitLevel];
                const methodValue = $2a1589ac5e33c3f7$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $2a1589ac5e33c3f7$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $2a1589ac5e33c3f7$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $2a1589ac5e33c3f7$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $2a1589ac5e33c3f7$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === 'object') {
        while(lvl-- && typeof argsCloned[0] === 'object')Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $bb5r4(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === 'string') msg = $bb5r4(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $2a1589ac5e33c3f7$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $2a1589ac5e33c3f7$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $2a1589ac5e33c3f7$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $2a1589ac5e33c3f7$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape(bindings);
}
function $2a1589ac5e33c3f7$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: '',
            value: 0
        }
    };
}
function $2a1589ac5e33c3f7$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $2a1589ac5e33c3f7$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === 'function') return opts.timestamp;
    if (opts.timestamp === false) return $2a1589ac5e33c3f7$var$nullTime;
    return $2a1589ac5e33c3f7$var$epochTime;
}
function $2a1589ac5e33c3f7$var$mock() {
    return {};
}
function $2a1589ac5e33c3f7$var$passthrough(a) {
    return a;
}
function $2a1589ac5e33c3f7$var$noop() {}
function $2a1589ac5e33c3f7$var$nullTime() {
    return false;
}
function $2a1589ac5e33c3f7$var$epochTime() {
    return Date.now();
}
function $2a1589ac5e33c3f7$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $2a1589ac5e33c3f7$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== 'undefined' && o;
    }
    try {
        if (typeof globalThis !== 'undefined') return globalThis;
        Object.defineProperty(Object.prototype, 'globalThis', {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("bb5r4", function(module, exports) {
'use strict';
function $8234f0346c62e618$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $8234f0346c62e618$var$format;
function $8234f0346c62e618$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $8234f0346c62e618$var$tryStringify;
    var offset = 1;
    if (typeof f === 'object' && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(' ');
    }
    if (typeof f !== 'string') return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = '';
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === 'string') {
                        str += '\'' + args[a] + '\'';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === 'function') {
                        str += args[a].name || '<anonymous>';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += '%';
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRegister("cpzTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRegister("b6sMl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $cpzTH = parcelRequire("cpzTH");
function $8156941ea6d64310$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $cpzTH.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $8156941ea6d64310$var$getDefaultLoggerOptions;
function $8156941ea6d64310$var$getBrowserLoggerContext(logger, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $8156941ea6d64310$var$getBrowserLoggerContext;
function $8156941ea6d64310$var$setBrowserLoggerContext(logger, context, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $8156941ea6d64310$var$setBrowserLoggerContext;
function $8156941ea6d64310$var$getLoggerContext(logger, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $8156941ea6d64310$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $8156941ea6d64310$var$getLoggerContext;
function $8156941ea6d64310$var$formatChildLoggerContext(logger, childContext, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $8156941ea6d64310$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $8156941ea6d64310$var$formatChildLoggerContext;
function $8156941ea6d64310$var$generateChildLogger(logger, childContext, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $8156941ea6d64310$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $8156941ea6d64310$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $8156941ea6d64310$var$generateChildLogger;

});

parcelRegister("bw9Yg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $862a6ae97ae6f3b5$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $862a6ae97ae6f3b5$var$getBrowerCrypto;
function $862a6ae97ae6f3b5$var$getSubtleCrypto() {
    const browserCrypto = $862a6ae97ae6f3b5$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $862a6ae97ae6f3b5$var$getSubtleCrypto;
function $862a6ae97ae6f3b5$var$isBrowserCryptoAvailable() {
    return !!$862a6ae97ae6f3b5$var$getBrowerCrypto() && !!$862a6ae97ae6f3b5$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $862a6ae97ae6f3b5$var$isBrowserCryptoAvailable;

});

parcelRegister("6rhnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $4b02bfd8a2ba6b94$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $4b02bfd8a2ba6b94$var$isReactNative;
function $4b02bfd8a2ba6b94$var$isNode() {
    return false;
}
module.exports.isNode = $4b02bfd8a2ba6b94$var$isNode;
function $4b02bfd8a2ba6b94$var$isBrowser() {
    return !$4b02bfd8a2ba6b94$var$isReactNative() && !$4b02bfd8a2ba6b94$var$isNode();
}
module.exports.isBrowser = $4b02bfd8a2ba6b94$var$isBrowser;

});

parcelRegister("ivIUF", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("1DYgm", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("dHHUN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9fa15b283ed4abe9$export$2e2bcd8739ae039; });
function $9fa15b283ed4abe9$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("1RPA1", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_NETWORK", function () { return $ab8c7bd122209bad$export$6818d7655dbeaa11; });
$parcel$export(module.exports, "PING_TIMEOUT", function () { return $ab8c7bd122209bad$export$8e04482e451f7f3d; });
$parcel$export(module.exports, "NAMESPACES", function () { return $ab8c7bd122209bad$export$4d2fb7344096e022; });
$parcel$export(module.exports, "CHAIN_ID_STORAGE", function () { return $ab8c7bd122209bad$export$4719bc910dce5624; });
$parcel$export(module.exports, "SolanaRPCMethods", function () { return $ab8c7bd122209bad$export$3356036d1cf2007a; });
$parcel$export(module.exports, "EthereumRPCMethods", function () { return $ab8c7bd122209bad$export$7975683052f7ad27; });
$parcel$export(module.exports, "EthereumEvents", function () { return $ab8c7bd122209bad$export$3887db1ef7860390; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_EVENTS", function () { return $ab8c7bd122209bad$export$e0379e0639ead25b; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_METHODS", function () { return $ab8c7bd122209bad$export$469dd5b8e272d548; });
$parcel$export(module.exports, "DEFAULT_SOLANA_CHAIN_ID", function () { return $ab8c7bd122209bad$export$c3c3260cf26e915d; });
$parcel$export(module.exports, "DEFAULT_APP_METADATA", function () { return $ab8c7bd122209bad$export$b4cc18c8d87b93d3; });
$parcel$export(module.exports, "RELAY_URL", function () { return $ab8c7bd122209bad$export$5d8b1f887d985f47; });
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
const $ab8c7bd122209bad$export$6818d7655dbeaa11 = (0, $9HEDW.LegacyNetworks).ETHEREUM;
const $ab8c7bd122209bad$export$8e04482e451f7f3d = 10000;
var $ab8c7bd122209bad$export$4d2fb7344096e022 = /*#__PURE__*/ function(NAMESPACES) {
    NAMESPACES["ETHEREUM"] = "eip155";
    NAMESPACES["SOLANA"] = "solana";
    NAMESPACES["COSMOS"] = "cosmos";
    NAMESPACES["POLKADOT"] = "polkadot";
    NAMESPACES["CARDANO"] = "cip34";
    NAMESPACES["ERLOND"] = "elrond";
    NAMESPACES["MULTIVERSX"] = "multiversx";
    return NAMESPACES;
}({});
const $ab8c7bd122209bad$export$4719bc910dce5624 = 'wc@2:client//namespaces';
var $ab8c7bd122209bad$export$3356036d1cf2007a = /*#__PURE__*/ function(SolanaRPCMethods) {
    SolanaRPCMethods["GET_ACCOUNTS"] = "solana_getAccounts";
    SolanaRPCMethods["REQUEST_ACCOUNTS"] = "solana_requestAccounts";
    SolanaRPCMethods["SIGN_TRANSACTION"] = "solana_signTransaction";
    SolanaRPCMethods["SIGN_MESSAGE"] = "solana_signMessage";
    return SolanaRPCMethods;
}({});
var $ab8c7bd122209bad$export$3ff55fb95ffc0bde = /*#__PURE__*/ function(CosmosRPCMethods) {
    CosmosRPCMethods["GET_ACCOUNTS"] = "cosmos_getAccounts";
    CosmosRPCMethods["SIGN_DIRECT"] = "cosmos_signDirect";
    CosmosRPCMethods["SIGN_AMINO"] = "cosmos_signAmino";
    return CosmosRPCMethods;
}({});
var $ab8c7bd122209bad$export$7975683052f7ad27 = /*#__PURE__*/ function(EthereumRPCMethods) {
    EthereumRPCMethods["PERSONAL_SIGN"] = "personal_sign";
    EthereumRPCMethods["SIGN"] = "eth_sign";
    EthereumRPCMethods["SIGN_TYPED_DATA"] = "eth_signTypedData";
    EthereumRPCMethods["SIGN_TRANSACTION"] = "eth_signTransaction";
    EthereumRPCMethods["SEND_TRANSACTION"] = "eth_sendTransaction";
    EthereumRPCMethods["SEND_RAW_TRANSACTION"] = "eth_sendRawTransaction";
    EthereumRPCMethods["SWITCH_CHAIN"] = "wallet_switchEthereumChain";
    EthereumRPCMethods["ADD_CHAIN"] = "wallet_addEthereumChain";
    EthereumRPCMethods["GET_CHAIN"] = "eth_chainId";
    return EthereumRPCMethods;
}({});
var $ab8c7bd122209bad$export$6693fea3a81074a1 = /*#__PURE__*/ function(StarknetRPCMethods) {
    StarknetRPCMethods["REQUEST_ADD_INVOKE_TRANSACTION"] = "starknet_requestAddInvokeTransaction";
    StarknetRPCMethods["SIGN_TYPED_DATA"] = "starknet_signTypedData";
    return StarknetRPCMethods;
}({});
var $ab8c7bd122209bad$export$3887db1ef7860390 = /*#__PURE__*/ function(EthereumEvents) {
    EthereumEvents["CHAIN_CHANGED"] = "chainChanged";
    EthereumEvents["ACCOUNTS_CHANGED"] = "accountsChanged";
    return EthereumEvents;
}({});
const $ab8c7bd122209bad$export$e0379e0639ead25b = [
    "chainChanged",
    "accountsChanged"
];
const $ab8c7bd122209bad$export$469dd5b8e272d548 = [
    "personal_sign",
    "eth_sendTransaction",
    "eth_signTransaction",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "eth_chainId"
];
const $ab8c7bd122209bad$export$ed05091276d4db2b = [
    "solana_signTransaction",
    "solana_signMessage"
];
const $ab8c7bd122209bad$export$3c349725a6f26236 = [
    "cosmos_getAccounts",
    "cosmos_signAmino",
    "cosmos_signDirect"
];
const $ab8c7bd122209bad$export$c3c3260cf26e915d = '4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ';
const $ab8c7bd122209bad$export$b4cc18c8d87b93d3 = {
    name: 'Rango Exchange',
    description: 'The Ultimate Cross-Chain Solution',
    url: 'https://app.rango.exchange/',
    icons: [
        'https://app.rango.exchange/logo-rounded.png'
    ]
};
const $ab8c7bd122209bad$export$5d8b1f887d985f47 = 'wss://relay.walletconnect.com';

});

parcelRegister("dYErK", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", function () { return $a2d040d36bb8bef6$export$2dd8023fb2cd44c; });
$parcel$export(module.exports, "CoreUtil", function () { return $a2d040d36bb8bef6$export$2ff3ceb398d6f444; });
$parcel$export(module.exports, "EventsCtrl", function () { return $a2d040d36bb8bef6$export$59a837b99037295; });
$parcel$export(module.exports, "OptionsCtrl", function () { return $a2d040d36bb8bef6$export$5f7b08e38aeeee56; });
$parcel$export(module.exports, "ConfigCtrl", function () { return $a2d040d36bb8bef6$export$5239b2e4de4e2646; });
$parcel$export(module.exports, "ExplorerCtrl", function () { return $a2d040d36bb8bef6$export$8a0e3ad54b37ee57; });
$parcel$export(module.exports, "ModalCtrl", function () { return $a2d040d36bb8bef6$export$f6ef1648e6110c37; });
$parcel$export(module.exports, "ThemeCtrl", function () { return $a2d040d36bb8bef6$export$fed0363cf09933ba; });
$parcel$export(module.exports, "ToastCtrl", function () { return $a2d040d36bb8bef6$export$49bec3d5b199c07; });

var $lPTGX = parcelRequire("lPTGX");
const $a2d040d36bb8bef6$var$o = (0, $lPTGX.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $a2d040d36bb8bef6$export$2dd8023fb2cd44c = {
    state: $a2d040d36bb8bef6$var$o,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$o, ()=>e($a2d040d36bb8bef6$var$o));
    },
    push (e, t) {
        e !== $a2d040d36bb8bef6$var$o.view && ($a2d040d36bb8bef6$var$o.view = e, t && ($a2d040d36bb8bef6$var$o.data = t), $a2d040d36bb8bef6$var$o.history.push(e));
    },
    reset (e) {
        $a2d040d36bb8bef6$var$o.view = e, $a2d040d36bb8bef6$var$o.history = [
            e
        ];
    },
    replace (e) {
        $a2d040d36bb8bef6$var$o.history.length > 1 && ($a2d040d36bb8bef6$var$o.history[$a2d040d36bb8bef6$var$o.history.length - 1] = e, $a2d040d36bb8bef6$var$o.view = e);
    },
    goBack () {
        if ($a2d040d36bb8bef6$var$o.history.length > 1) {
            $a2d040d36bb8bef6$var$o.history.pop();
            const [e] = $a2d040d36bb8bef6$var$o.history.slice(-1);
            $a2d040d36bb8bef6$var$o.view = e;
        }
    },
    setData (e) {
        $a2d040d36bb8bef6$var$o.data = e;
    }
}, $a2d040d36bb8bef6$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    WCM_VERSION: "WCM_VERSION",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, s) {
        if ($a2d040d36bb8bef6$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
        let n = e;
        n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    formatUniversalUrl (e, t, s) {
        if (!$a2d040d36bb8bef6$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
        let n = e;
        n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WCM_VERSION, "2.6.2");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $a2d040d36bb8bef6$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    }
}, $a2d040d36bb8bef6$var$_ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $a2d040d36bb8bef6$var$r = (0, $lPTGX.proxy)({
    enabled: $a2d040d36bb8bef6$var$_,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $a2d040d36bb8bef6$export$59a837b99037295 = {
    state: $a2d040d36bb8bef6$var$r,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$r.events, ()=>e((0, $lPTGX.snapshot)($a2d040d36bb8bef6$var$r.events[$a2d040d36bb8bef6$var$r.events.length - 1])));
    },
    initialize () {
        $a2d040d36bb8bef6$var$r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($a2d040d36bb8bef6$var$r.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $a2d040d36bb8bef6$var$r.connectedWalletId = e;
    },
    click (e) {
        if ($a2d040d36bb8bef6$var$r.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $a2d040d36bb8bef6$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $a2d040d36bb8bef6$var$r.events.push(t);
        }
    },
    track (e) {
        if ($a2d040d36bb8bef6$var$r.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $a2d040d36bb8bef6$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $a2d040d36bb8bef6$var$r.events.push(t);
        }
    },
    view (e) {
        if ($a2d040d36bb8bef6$var$r.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $a2d040d36bb8bef6$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $a2d040d36bb8bef6$var$r.events.push(t);
        }
    }
}, $a2d040d36bb8bef6$var$c = (0, $lPTGX.proxy)({
    chains: void 0,
    walletConnectUri: void 0,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1
}), $a2d040d36bb8bef6$export$5f7b08e38aeeee56 = {
    state: $a2d040d36bb8bef6$var$c,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$c, ()=>e($a2d040d36bb8bef6$var$c));
    },
    setChains (e) {
        $a2d040d36bb8bef6$var$c.chains = e;
    },
    setWalletConnectUri (e) {
        $a2d040d36bb8bef6$var$c.walletConnectUri = e;
    },
    setIsCustomDesktop (e) {
        $a2d040d36bb8bef6$var$c.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $a2d040d36bb8bef6$var$c.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $a2d040d36bb8bef6$var$c.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $a2d040d36bb8bef6$var$c.isUiLoaded = e;
    },
    setIsAuth (e) {
        $a2d040d36bb8bef6$var$c.isAuth = e;
    }
}, $a2d040d36bb8bef6$var$W = (0, $lPTGX.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chains: void 0,
    enableAuthMode: !1,
    enableExplorer: !0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $a2d040d36bb8bef6$export$5239b2e4de4e2646 = {
    state: $a2d040d36bb8bef6$var$W,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$W, ()=>e($a2d040d36bb8bef6$var$W));
    },
    setConfig (e) {
        var t, s;
        $a2d040d36bb8bef6$export$59a837b99037295.initialize(), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setChains(e.chains), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setIsAuth(Boolean(e.enableAuthMode)), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), $a2d040d36bb8bef6$export$2ff3ceb398d6f444.setModalVersionInStorage(), Object.assign($a2d040d36bb8bef6$var$W, e);
    }
};
var $a2d040d36bb8bef6$var$V = Object.defineProperty, $a2d040d36bb8bef6$var$D = Object.getOwnPropertySymbols, $a2d040d36bb8bef6$var$H = Object.prototype.hasOwnProperty, $a2d040d36bb8bef6$var$B = Object.prototype.propertyIsEnumerable, $a2d040d36bb8bef6$var$M = (e, t, s)=>t in e ? $a2d040d36bb8bef6$var$V(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $a2d040d36bb8bef6$var$K = (e, t)=>{
    for(var s in t || (t = {}))$a2d040d36bb8bef6$var$H.call(t, s) && $a2d040d36bb8bef6$var$M(e, s, t[s]);
    if ($a2d040d36bb8bef6$var$D) for (var s of $a2d040d36bb8bef6$var$D(t))$a2d040d36bb8bef6$var$B.call(t, s) && $a2d040d36bb8bef6$var$M(e, s, t[s]);
    return e;
};
const $a2d040d36bb8bef6$var$L = "https://explorer-api.walletconnect.com", $a2d040d36bb8bef6$var$E = "wcm", $a2d040d36bb8bef6$var$O = "js-2.6.2";
async function $a2d040d36bb8bef6$var$w(e, t) {
    const s = $a2d040d36bb8bef6$var$K({
        sdkType: $a2d040d36bb8bef6$var$E,
        sdkVersion: $a2d040d36bb8bef6$var$O
    }, t), n = new URL(e, $a2d040d36bb8bef6$var$L);
    return n.searchParams.append("projectId", $a2d040d36bb8bef6$export$5239b2e4de4e2646.state.projectId), Object.entries(s).forEach(([i, l])=>{
        l && n.searchParams.append(i, String(l));
    }), (await fetch(n)).json();
}
const $a2d040d36bb8bef6$var$m = {
    async getDesktopListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$a2d040d36bb8bef6$var$L}/w3m/v1/getWalletImage/${e}?projectId=${$a2d040d36bb8bef6$export$5239b2e4de4e2646.state.projectId}&sdkType=${$a2d040d36bb8bef6$var$E}&sdkVersion=${$a2d040d36bb8bef6$var$O}`;
    },
    getAssetImageUrl (e) {
        return `${$a2d040d36bb8bef6$var$L}/w3m/v1/getAssetImage/${e}?projectId=${$a2d040d36bb8bef6$export$5239b2e4de4e2646.state.projectId}&sdkType=${$a2d040d36bb8bef6$var$E}&sdkVersion=${$a2d040d36bb8bef6$var$O}`;
    }
};
var $a2d040d36bb8bef6$var$z = Object.defineProperty, $a2d040d36bb8bef6$var$j = Object.getOwnPropertySymbols, $a2d040d36bb8bef6$var$J = Object.prototype.hasOwnProperty, $a2d040d36bb8bef6$var$q = Object.prototype.propertyIsEnumerable, $a2d040d36bb8bef6$var$k = (e, t, s)=>t in e ? $a2d040d36bb8bef6$var$z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $a2d040d36bb8bef6$var$F = (e, t)=>{
    for(var s in t || (t = {}))$a2d040d36bb8bef6$var$J.call(t, s) && $a2d040d36bb8bef6$var$k(e, s, t[s]);
    if ($a2d040d36bb8bef6$var$j) for (var s of $a2d040d36bb8bef6$var$j(t))$a2d040d36bb8bef6$var$q.call(t, s) && $a2d040d36bb8bef6$var$k(e, s, t[s]);
    return e;
};
const $a2d040d36bb8bef6$var$N = $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isMobile(), $a2d040d36bb8bef6$var$d = (0, $lPTGX.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $a2d040d36bb8bef6$export$8a0e3ad54b37ee57 = {
    state: $a2d040d36bb8bef6$var$d,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $a2d040d36bb8bef6$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $a2d040d36bb8bef6$var$d.recomendedWallets;
        if ($a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(e)) {
            const s = {
                recommendedIds: e.join(",")
            }, { listings: n } = await $a2d040d36bb8bef6$var$m.getAllListings(s), i = Object.values(n);
            i.sort((l, v)=>{
                const b = e.indexOf(l.id), f = e.indexOf(v.id);
                return b - f;
            }), $a2d040d36bb8bef6$var$d.recomendedWallets = i;
        } else {
            const { chains: s, isAuth: n } = $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state, i = s?.join(","), l = $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(t), v = {
                page: 1,
                sdks: n ? "auth_v1" : void 0,
                entries: $a2d040d36bb8bef6$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                chains: i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
            }, { listings: b } = $a2d040d36bb8bef6$var$N ? await $a2d040d36bb8bef6$var$m.getMobileListings(v) : await $a2d040d36bb8bef6$var$m.getDesktopListings(v);
            $a2d040d36bb8bef6$var$d.recomendedWallets = Object.values(b);
        }
        return $a2d040d36bb8bef6$var$d.recomendedWallets;
    },
    async getWallets (e) {
        const t = $a2d040d36bb8bef6$var$F({}, e), { explorerRecommendedWalletIds: s, explorerExcludedWalletIds: n } = $a2d040d36bb8bef6$export$5239b2e4de4e2646.state, { recomendedWallets: i } = $a2d040d36bb8bef6$var$d;
        if (n === "ALL") return $a2d040d36bb8bef6$var$d.wallets;
        i.length ? t.excludedIds = i.map((x)=>x.id).join(",") : $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = s.join(",")), $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = [
            t.excludedIds,
            n
        ].filter(Boolean).join(",")), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state.isAuth && (t.sdks = "auth_v1");
        const { page: l, search: v } = e, { listings: b, total: f } = $a2d040d36bb8bef6$var$N ? await $a2d040d36bb8bef6$var$m.getMobileListings(t) : await $a2d040d36bb8bef6$var$m.getDesktopListings(t), A = Object.values(b), U = v ? "search" : "wallets";
        return $a2d040d36bb8bef6$var$d[U] = {
            listings: [
                ...$a2d040d36bb8bef6$var$d[U].listings,
                ...A
            ],
            total: f,
            page: l ?? 1
        }, {
            listings: A,
            total: f
        };
    },
    getWalletImageUrl (e) {
        return $a2d040d36bb8bef6$var$m.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $a2d040d36bb8bef6$var$m.getAssetImageUrl(e);
    },
    resetSearch () {
        $a2d040d36bb8bef6$var$d.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $a2d040d36bb8bef6$var$I = (0, $lPTGX.proxy)({
    open: !1
}), $a2d040d36bb8bef6$export$f6ef1648e6110c37 = {
    state: $a2d040d36bb8bef6$var$I,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$I, ()=>e($a2d040d36bb8bef6$var$I));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: s, isDataLoaded: n } = $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state;
            if ($a2d040d36bb8bef6$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setWalletConnectUri(e?.uri), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setChains(e?.chains), $a2d040d36bb8bef6$export$2dd8023fb2cd44c.reset("ConnectWallet"), s && n) $a2d040d36bb8bef6$var$I.open = !0, t();
            else {
                const i = setInterval(()=>{
                    const l = $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), $a2d040d36bb8bef6$var$I.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $a2d040d36bb8bef6$var$I.open = !1;
    }
};
var $a2d040d36bb8bef6$var$G = Object.defineProperty, $a2d040d36bb8bef6$var$$ = Object.getOwnPropertySymbols, $a2d040d36bb8bef6$var$Q = Object.prototype.hasOwnProperty, $a2d040d36bb8bef6$var$X = Object.prototype.propertyIsEnumerable, $a2d040d36bb8bef6$var$S = (e, t, s)=>t in e ? $a2d040d36bb8bef6$var$G(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $a2d040d36bb8bef6$var$Y = (e, t)=>{
    for(var s in t || (t = {}))$a2d040d36bb8bef6$var$Q.call(t, s) && $a2d040d36bb8bef6$var$S(e, s, t[s]);
    if ($a2d040d36bb8bef6$var$$) for (var s of $a2d040d36bb8bef6$var$$(t))$a2d040d36bb8bef6$var$X.call(t, s) && $a2d040d36bb8bef6$var$S(e, s, t[s]);
    return e;
};
function $a2d040d36bb8bef6$var$Z() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $a2d040d36bb8bef6$var$C = (0, $lPTGX.proxy)({
    themeMode: $a2d040d36bb8bef6$var$Z() ? "dark" : "light"
}), $a2d040d36bb8bef6$export$fed0363cf09933ba = {
    state: $a2d040d36bb8bef6$var$C,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$C, ()=>e($a2d040d36bb8bef6$var$C));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: s } = e;
        t && ($a2d040d36bb8bef6$var$C.themeMode = t), s && ($a2d040d36bb8bef6$var$C.themeVariables = $a2d040d36bb8bef6$var$Y({}, s));
    }
}, $a2d040d36bb8bef6$var$g = (0, $lPTGX.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $a2d040d36bb8bef6$export$49bec3d5b199c07 = {
    state: $a2d040d36bb8bef6$var$g,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$g, ()=>e($a2d040d36bb8bef6$var$g));
    },
    openToast (e, t) {
        $a2d040d36bb8bef6$var$g.open = !0, $a2d040d36bb8bef6$var$g.message = e, $a2d040d36bb8bef6$var$g.variant = t;
    },
    closeToast () {
        $a2d040d36bb8bef6$var$g.open = !1;
    }
};

});
parcelRegister("lPTGX", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $4b6066c49feabaff$export$923f96dd5afa9ce6; });
$parcel$export(module.exports, "subscribe", function () { return $4b6066c49feabaff$export$ec068583843480e7; });
$parcel$export(module.exports, "snapshot", function () { return $4b6066c49feabaff$export$b8801ea43165ed7d; });

var $g0Ave = parcelRequire("g0Ave");
var $4b6066c49feabaff$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $4b6066c49feabaff$var$isObject = (x)=>typeof x === "object" && x !== null;
const $4b6066c49feabaff$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $4b6066c49feabaff$var$refSet = /* @__PURE__ */ new WeakSet();
const $4b6066c49feabaff$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$4b6066c49feabaff$var$isObject(x) && !$4b6066c49feabaff$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $g0Ave.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const desc = {
            value: value,
            enumerable: true,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($4b6066c49feabaff$var$refSet.has(value)) (0, $g0Ave.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($4b6066c49feabaff$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $4b6066c49feabaff$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$4b6066c49feabaff$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($4b6066c49feabaff$var$isObject(value)) value = (0, $g0Ave.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$4b6066c49feabaff$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$4b6066c49feabaff$var$refSet.has(nextValue) && $4b6066c49feabaff$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $4b6066c49feabaff$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $4b6066c49feabaff$var$proxyStateMap,
        $4b6066c49feabaff$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$4b6066c49feabaff$var$defaultProxyFunction] = $4b6066c49feabaff$var$buildProxyFunction();
function $4b6066c49feabaff$export$923f96dd5afa9ce6(initialObject = {}) {
    return $4b6066c49feabaff$var$defaultProxyFunction(initialObject);
}
function $4b6066c49feabaff$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $4b6066c49feabaff$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $4b6066c49feabaff$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $4b6066c49feabaff$var$proxyStateMap.get(proxyObject);
    if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $4b6066c49feabaff$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $4b6066c49feabaff$var$proxyStateMap.get(proxyObject);
    if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $4b6066c49feabaff$export$eff4d24c3ff7876e(obj) {
    $4b6066c49feabaff$var$refSet.add(obj);
    return obj;
}
const $4b6066c49feabaff$export$e7b04d37d9502758 = $4b6066c49feabaff$var$buildProxyFunction;

});
parcelRegister("g0Ave", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $ba78f61ff05aa2ce$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $ba78f61ff05aa2ce$export$2c8383c890e26a1c; });
const $ba78f61ff05aa2ce$var$e = Symbol(), $ba78f61ff05aa2ce$var$t = Symbol(), $ba78f61ff05aa2ce$var$r = "a", $ba78f61ff05aa2ce$var$n = "w";
let $ba78f61ff05aa2ce$var$o = (e, t)=>new Proxy(e, t);
const $ba78f61ff05aa2ce$var$s = Object.getPrototypeOf, $ba78f61ff05aa2ce$var$c = new WeakMap, $ba78f61ff05aa2ce$var$l = (e)=>e && ($ba78f61ff05aa2ce$var$c.has(e) ? $ba78f61ff05aa2ce$var$c.get(e) : $ba78f61ff05aa2ce$var$s(e) === Object.prototype || $ba78f61ff05aa2ce$var$s(e) === Array.prototype), $ba78f61ff05aa2ce$var$f = (e)=>"object" == typeof e && null !== e, $ba78f61ff05aa2ce$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($ba78f61ff05aa2ce$var$s(e), t);
}, $ba78f61ff05aa2ce$var$u = (e)=>e[$ba78f61ff05aa2ce$var$t] || e, $ba78f61ff05aa2ce$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$ba78f61ff05aa2ce$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $ba78f61ff05aa2ce$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $ba78f61ff05aa2ce$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$ba78f61ff05aa2ce$var$r].get(o);
                if (s || (s = {}, c[$ba78f61ff05aa2ce$var$r].set(o, s)), e === $ba78f61ff05aa2ce$var$n) s[$ba78f61ff05aa2ce$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $ba78f61ff05aa2ce$var$t ? o : (f("k", n), $ba78f61ff05aa2ce$export$7865d0c7f908de6b(Reflect.get(e, n), c[$ba78f61ff05aa2ce$var$r], c.c, c.t)),
            has: (t, n)=>n === $ba78f61ff05aa2ce$var$e ? (l = !0, c[$ba78f61ff05aa2ce$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($ba78f61ff05aa2ce$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $ba78f61ff05aa2ce$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$ba78f61ff05aa2ce$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $ba78f61ff05aa2ce$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$ba78f61ff05aa2ce$var$f(e) || !$ba78f61ff05aa2ce$var$f(t)) return !0;
    const s = r.get($ba78f61ff05aa2ce$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$ba78f61ff05aa2ce$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $ba78f61ff05aa2ce$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $ba78f61ff05aa2ce$export$badc26589cf7bb38 = (t)=>!!$ba78f61ff05aa2ce$var$l(t) && $ba78f61ff05aa2ce$var$e in t, $ba78f61ff05aa2ce$export$80d2cee7ee556e99 = (e)=>$ba78f61ff05aa2ce$var$l(e) && e[$ba78f61ff05aa2ce$var$t] || null, $ba78f61ff05aa2ce$export$2c8383c890e26a1c = (e, t = !0)=>{
    $ba78f61ff05aa2ce$var$c.set(e, t);
}, $ba78f61ff05aa2ce$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $ba78f61ff05aa2ce$var$f(e) && s.add(e);
        const i = $ba78f61ff05aa2ce$var$f(e) && t.get($ba78f61ff05aa2ce$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$ba78f61ff05aa2ce$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $ba78f61ff05aa2ce$export$9b4d5450dbd8e67e = (e)=>{
    $ba78f61ff05aa2ce$var$o = e;
};

});



parcelRegister("cb9ZC", function(module, exports) {
module.exports = $parcel$import("7zVVv").then(()=>parcelRequire('jLnKo'));

});

parcelRegister("5aKEd", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("bUb9a"),
    $parcel$import("5kvK0")
]).then(()=>parcelRequire('bi0sy'));

});

parcelRegister("a1VlE", function(module, exports) {
module.exports = $parcel$import("5HZtI").then(()=>parcelRequire('cfNv5'));

});

parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("7WGbV", function(module, exports) {
module.exports = $parcel$import("ljOTW").then(()=>parcelRequire('cCiiD'));

});

parcelRegister("iOQO2", function(module, exports) {

$parcel$export(module.exports, "BigNumber", function () { return $423fc98881121cb2$export$d97aa349ed20696; });
$parcel$export(module.exports, "default", function () { return $423fc98881121cb2$export$2e2bcd8739ae039; });
/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $423fc98881121cb2$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $423fc98881121cb2$var$mathceil = Math.ceil, $423fc98881121cb2$var$mathfloor = Math.floor, $423fc98881121cb2$var$bignumberError = '[BigNumber Error] ', $423fc98881121cb2$var$tooManyDigits = $423fc98881121cb2$var$bignumberError + 'Number primitive has more than 15 significant digits: ', $423fc98881121cb2$var$BASE = 1e14, $423fc98881121cb2$var$LOG_BASE = 14, $423fc98881121cb2$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$423fc98881121cb2$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $423fc98881121cb2$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$423fc98881121cb2$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $423fc98881121cb2$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: '',
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ',',
        decimalSeparator: '.',
        fractionGroupSize: 0,
        fractionGroupSeparator: '\xA0',
        suffix: ''
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == 'number') && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$423fc98881121cb2$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $423fc98881121cb2$var$intCheck(b, 2, ALPHABET.length, 'Base');
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == 'number') {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error($423fc98881121cb2$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == '.') // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $423fc98881121cb2$var$MAX_SAFE_INTEGER || v !== $423fc98881121cb2$var$mathfloor(v))) throw Error($423fc98881121cb2$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $423fc98881121cb2$var$LOG_BASE;
                if (e < 0) i += $423fc98881121cb2$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $423fc98881121cb2$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $423fc98881121cb2$var$LOG_BASE));
                    i = $423fc98881121cb2$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += '0');
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $423fc98881121cb2$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == 'object') {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, $423fc98881121cb2$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                    v = obj[p];
                    if (v && v.pop) {
                        $423fc98881121cb2$var$intCheck(v[0], -$423fc98881121cb2$var$MAX, 0, p);
                        $423fc98881121cb2$var$intCheck(v[1], 0, $423fc98881121cb2$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $423fc98881121cb2$var$intCheck(v, -$423fc98881121cb2$var$MAX, $423fc98881121cb2$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = 'RANGE')) {
                    v = obj[p];
                    if (v && v.pop) {
                        $423fc98881121cb2$var$intCheck(v[0], -$423fc98881121cb2$var$MAX, -1, p);
                        $423fc98881121cb2$var$intCheck(v[1], 1, $423fc98881121cb2$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $423fc98881121cb2$var$intCheck(v, -$423fc98881121cb2$var$MAX, $423fc98881121cb2$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($423fc98881121cb2$var$bignumberError + p + ' cannot be zero: ' + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = 'CRYPTO')) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($423fc98881121cb2$var$bignumberError + 'crypto unavailable');
                            }
                        } else CRYPTO = v;
                    } else throw Error($423fc98881121cb2$var$bignumberError + p + ' not true or false: ' + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, $423fc98881121cb2$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = 'FORMAT')) {
                    v = obj[p];
                    if (typeof v == 'object') FORMAT = v;
                    else throw Error($423fc98881121cb2$var$bignumberError + p + ' not an object: ' + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = 'ALPHABET')) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                        ALPHABET = v;
                    } else throw Error($423fc98881121cb2$var$bignumberError + p + ' invalid: ' + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($423fc98881121cb2$var$bignumberError + 'Object expected: ' + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == '[object Array]') {
            if ((s === 1 || s === -1) && e >= -$423fc98881121cb2$var$MAX && e <= $423fc98881121cb2$var$MAX && e === $423fc98881121cb2$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $423fc98881121cb2$var$LOG_BASE;
                if (i < 1) i += $423fc98881121cb2$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $423fc98881121cb2$var$BASE || n !== $423fc98881121cb2$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($423fc98881121cb2$var$bignumberError + 'Invalid BigNumber: ' + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $423fc98881121cb2$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            k = $423fc98881121cb2$var$mathceil(dp / $423fc98881121cb2$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($423fc98881121cb2$var$bignumberError + 'crypto unavailable');
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $423fc98881121cb2$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $423fc98881121cb2$var$POWS_TEN[$423fc98881121cb2$var$LOG_BASE - dp];
                c[i] = $423fc98881121cb2$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $423fc98881121cb2$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $423fc98881121cb2$var$LOG_BASE) e -= $423fc98881121cb2$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = '0123456789';
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace('.', '');
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $423fc98881121cb2$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $423fc98881121cb2$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $423fc98881121cb2$var$SQRT_BASE, khi = k / $423fc98881121cb2$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $423fc98881121cb2$var$SQRT_BASE;
                xhi = x[i] / $423fc98881121cb2$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $423fc98881121cb2$var$SQRT_BASE * $423fc98881121cb2$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $423fc98881121cb2$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $423fc98881121cb2$var$BASE;
                e = $423fc98881121cb2$var$bitFloor(x.e / $423fc98881121cb2$var$LOG_BASE) - $423fc98881121cb2$var$bitFloor(y.e / $423fc98881121cb2$var$LOG_BASE);
                s = s / $423fc98881121cb2$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $423fc98881121cb2$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $423fc98881121cb2$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $423fc98881121cb2$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $423fc98881121cb2$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $423fc98881121cb2$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $423fc98881121cb2$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $423fc98881121cb2$var$toExponential(str, ne) : $423fc98881121cb2$var$toFixedPoint(str, ne, '0');
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $423fc98881121cb2$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += '0', len++);
                str = $423fc98881121cb2$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $423fc98881121cb2$var$toFixedPoint(str, e, '0');
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += '.'; i--; str += '0');
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += '.';
                        for(; i--; str += '0');
                    }
                }
            }
        }
        return n.s < 0 && c0 ? '-' + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $423fc98881121cb2$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $423fc98881121cb2$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($423fc98881121cb2$var$bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $423fc98881121cb2$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $423fc98881121cb2$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $423fc98881121cb2$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $423fc98881121cb2$var$mathceil((i + 1) / $423fc98881121cb2$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $423fc98881121cb2$var$LOG_BASE;
                            j = i - $423fc98881121cb2$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $423fc98881121cb2$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $423fc98881121cb2$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $423fc98881121cb2$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($423fc98881121cb2$var$LOG_BASE - sd % $423fc98881121cb2$var$LOG_BASE) % $423fc98881121cb2$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$423fc98881121cb2$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $423fc98881121cb2$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $423fc98881121cb2$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $423fc98881121cb2$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $423fc98881121cb2$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $423fc98881121cb2$var$toExponential(str, e) : $423fc98881121cb2$var$toFixedPoint(str, e, '0');
        return n.s < 0 ? '-' + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $423fc98881121cb2$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $423fc98881121cb2$var$bitFloor(this.e / $423fc98881121cb2$var$LOG_BASE)) * $423fc98881121cb2$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($423fc98881121cb2$var$bignumberError + 'Exponent not an integer: ' + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $423fc98881121cb2$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $423fc98881121cb2$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $423fc98881121cb2$var$mathceil(POW_PRECISION / $423fc98881121cb2$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $423fc98881121cb2$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $423fc98881121cb2$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $423fc98881121cb2$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $423fc98881121cb2$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $423fc98881121cb2$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $423fc98881121cb2$var$bitFloor(this.e / $423fc98881121cb2$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $423fc98881121cb2$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $423fc98881121cb2$var$LOG_BASE, ye = y.e / $423fc98881121cb2$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $423fc98881121cb2$var$bitFloor(xe);
        ye = $423fc98881121cb2$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $423fc98881121cb2$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $423fc98881121cb2$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $423fc98881121cb2$var$bitFloor(x.e / $423fc98881121cb2$var$LOG_BASE) + $423fc98881121cb2$var$bitFloor(y.e / $423fc98881121cb2$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $423fc98881121cb2$var$BASE;
        sqrtBase = $423fc98881121cb2$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $423fc98881121cb2$var$LOG_BASE, ye = y.e / $423fc98881121cb2$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $423fc98881121cb2$var$bitFloor(xe);
        ye = $423fc98881121cb2$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $423fc98881121cb2$var$BASE | 0;
            xc[b] = $423fc98881121cb2$var$BASE === xc[b] ? 0 : xc[b] % $423fc98881121cb2$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $423fc98881121cb2$var$intCheck(sd, 1, $423fc98881121cb2$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $423fc98881121cb2$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $423fc98881121cb2$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $423fc98881121cb2$var$intCheck(k, -$423fc98881121cb2$var$MAX_SAFE_INTEGER, $423fc98881121cb2$var$MAX_SAFE_INTEGER);
        return this.times('1e' + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $423fc98881121cb2$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(+n);
            e = $423fc98881121cb2$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + '');
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($423fc98881121cb2$var$coeffToString(t.c).slice(0, s) === (n = $423fc98881121cb2$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == '9999' || !rep && n == '4999') {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == 'object') {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == 'object') {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != 'object') throw Error($423fc98881121cb2$var$bignumberError + 'Argument not an object: ' + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = '-' + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
        }
        return (format.prefix || '') + str + (format.suffix || '');
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($423fc98881121cb2$var$bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $423fc98881121cb2$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $423fc98881121cb2$var$POWS_TEN[(exp = e % $423fc98881121cb2$var$LOG_BASE) < 0 ? $423fc98881121cb2$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $423fc98881121cb2$var$intCheck(sd, 1, $423fc98881121cb2$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = 'Infinity';
                if (s < 0) str = '-' + str;
            } else str = 'NaN';
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $423fc98881121cb2$var$toExponential($423fc98881121cb2$var$coeffToString(n.c), e) : $423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(n.c), e, '0');
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(n.c), n.e, '0');
            } else {
                $423fc98881121cb2$var$intCheck(b, 2, ALPHABET.length, 'Base');
                str = convertBase($423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(n.c), e, '0'), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = '-' + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = 'BigNumber';
    // Node.js v10.12.0+
    P[Symbol.for('nodejs.util.inspect.custom')] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $423fc98881121cb2$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $423fc98881121cb2$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + '';
    for(; i < j;){
        s = a[i++] + '';
        z = $423fc98881121cb2$var$LOG_BASE - s.length;
        for(; z--; s = '0' + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $423fc98881121cb2$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $423fc98881121cb2$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $423fc98881121cb2$var$mathfloor(n)) throw Error($423fc98881121cb2$var$bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
}
// Assumes finite n.
function $423fc98881121cb2$var$isOdd(n) {
    var k = n.c.length - 1;
    return $423fc98881121cb2$var$bitFloor(n.e / $423fc98881121cb2$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $423fc98881121cb2$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
}
function $423fc98881121cb2$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + '.'; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
    }
    return str;
}
var $423fc98881121cb2$export$d97aa349ed20696 = $423fc98881121cb2$var$clone();
var $423fc98881121cb2$export$2e2bcd8739ae039 = $423fc98881121cb2$export$d97aa349ed20696;

});

parcelRegister("cvLQv", function(module, exports) {

$parcel$export(module.exports, "BrowserProvider", function () { return $91bd7e7c4e317608$export$8d50d0931f78dec8; });

var $bCA3C = parcelRequire("bCA3C");

var $7lMFN = parcelRequire("7lMFN");
class $91bd7e7c4e317608$export$8d50d0931f78dec8 extends (0, $7lMFN.JsonRpcApiPollingProvider) {
    #request;
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */ constructor(ethereum, network, _options){
        // Copy the options
        const options = Object.assign({}, _options != null ? _options : {}, {
            batchMaxCount: 1
        });
        (0, $bCA3C.assertArgument)(ethereum && ethereum.request, "invalid EIP-1193 provider", "ethereum", ethereum);
        super(network, options);
        this.#request = async (method, params)=>{
            const payload = {
                method: method,
                params: params
            };
            this.emit("debug", {
                action: "sendEip1193Request",
                payload: payload
            });
            try {
                const result = await ethereum.request(payload);
                this.emit("debug", {
                    action: "receiveEip1193Result",
                    result: result
                });
                return result;
            } catch (e) {
                const error = new Error(e.message);
                error.code = e.code;
                error.data = e.data;
                error.payload = payload;
                this.emit("debug", {
                    action: "receiveEip1193Error",
                    error: error
                });
                throw error;
            }
        };
    }
    async send(method, params) {
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        (0, $bCA3C.assertArgument)(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
        try {
            const result = await this.#request(payload.method, payload.params || []);
            return [
                {
                    id: payload.id,
                    result: result
                }
            ];
        } catch (e) {
            return [
                {
                    id: payload.id,
                    error: {
                        code: e.code,
                        data: e.data,
                        message: e.message
                    }
                }
            ];
        }
    }
    getRpcError(payload, error) {
        error = JSON.parse(JSON.stringify(error));
        // EIP-1193 gives us some machine-readable error codes, so rewrite
        // them into 
        switch(error.error.code || -1){
            case 4001:
                error.error.message = `ethers-user-denied: ${error.error.message}`;
                break;
            case 4200:
                error.error.message = `ethers-unsupported: ${error.error.message}`;
                break;
        }
        return super.getRpcError(payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */ async hasSigner(address) {
        if (address == null) address = 0;
        const accounts = await this.send("eth_accounts", []);
        if (typeof address === "number") return accounts.length > address;
        address = address.toLowerCase();
        return accounts.filter((a)=>a.toLowerCase() === address).length !== 0;
    }
    async getSigner(address) {
        if (address == null) address = 0;
        if (!await this.hasSigner(address)) try {
            //const resp = 
            await this.#request("eth_requestAccounts", []);
        //console.log("RESP", resp);
        } catch (error) {
            const payload = error.payload;
            throw this.getRpcError(payload, {
                id: payload.id,
                error: error
            });
        }
        return await super.getSigner(address);
    }
}

});

var $90360d4fa30ec2b9$exports = {};
$parcel$extendImportMap({
    "bUb9a": "signer-evm.83f240b7.js",
    "jrxP9": "signer-tron.448ad838.js",
    "gBgzU": "signer-starknet.ef8507f3.js",
    "619bN": "signer-cosmos.3190f78d.js",
    "gLEwd": "mod.49e49a91.js",
    "csTDN": "Eth.5ba15f61.js",
    "4135D": "Eth.0500f1d7.js",
    "letUy": "Solana.fa2ed573.js",
    "9RLFH": "TransportWebHID.f6ab1df5.js",
    "hFfD2": "utxoSigner.ca66f116.js",
    "lP2G7": "utxoSigner.c1eadcdb.js",
    "bnVuC": "signer-sui.6951066d.js",
    "63t4X": "evm.d67c5063.js",
    "gVwVE": "ton.a860e2f4.js",
    "fgfcN": "ui.772d6450.js",
    "7327i": "connect-web.5bc33a9a.js",
    "cX2Sd": "ethereum.9d2f650e.js",
    "aFC8S": "solanaSigner.63ba81f1.js",
    "i4xYE": "utxoSigner.8ed6c87b.js",
    "goaIC": "mod.3c1c5f19.js",
    "7zVVv": "dist.596b7c6c.js",
    "5kvK0": "evm.2f6dc12d.js",
    "5HZtI": "solana.c50ed1e7.js",
    "ljOTW": "build.cd732292.js"
});


var $3ca9q = parcelRequire("3ca9q");
var $ced745a80d9e02b4$var$s = Object.defineProperty;
var $ced745a80d9e02b4$var$n = (e, r)=>$ced745a80d9e02b4$var$s(e, "name", {
        value: r,
        configurable: !0
    });
function $ced745a80d9e02b4$export$614fbb61b67095d0(e, r) {
    return `${e}$$${r}`;
}
$ced745a80d9e02b4$var$n($ced745a80d9e02b4$export$614fbb61b67095d0, "generateStoreId");
function $ced745a80d9e02b4$export$e07c34986d13152a(e, r) {
    if (!r) throw new Error("You should provide a valid semver, e.g 1.0.0.");
    let o = e.find(([i])=>i === r);
    if (!o) throw new Error(`You target version hasn't been found. Available versions: ${Object.keys(e).join(", ")}`);
    return o;
}
$ced745a80d9e02b4$var$n($ced745a80d9e02b4$export$e07c34986d13152a, "pickVersion");
function $ced745a80d9e02b4$export$37be72d69eff8ef3() {
    let e = [], r = {
        version: (o, i)=>(e.push([
                o,
                i
            ]), r),
        build: ()=>e
    };
    return r;
}
$ced745a80d9e02b4$var$n($ced745a80d9e02b4$export$37be72d69eff8ef3, "defineVersions");
function $ced745a80d9e02b4$export$3ce31bfaa5288b9a(e) {
    return $ced745a80d9e02b4$export$37be72d69eff8ef3().version("0.0.0", e).build();
}
$ced745a80d9e02b4$var$n($ced745a80d9e02b4$export$3ce31bfaa5288b9a, "legacyProviderImportsToVersionsInterface");


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

var $9HEDW = parcelRequire("9HEDW");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $9906550309c31f86$export$2e2bcd8739ae039(provider) {
    const evmProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(evmProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $7bc03dcc2215ad65$export$210ce5fe93c52fab() {
    const { binancew3w: binancew3w } = window;
    if (!binancew3w) return null;
    const instances = new Map();
    if (binancew3w.ethereum) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, binancew3w.ethereum);
    if (instances.size === 0) return null;
    return instances;
}
function $7bc03dcc2215ad65$export$62115b9164fa6f77() {
    const instances = $7bc03dcc2215ad65$export$210ce5fe93c52fab();
    if (!instances) throw new Error('Binance Wallet is not injected. Please check your wallet.');
    return instances;
}
function $7bc03dcc2215ad65$export$e14d7c242d88da3d() {
    const instances = $7bc03dcc2215ad65$export$210ce5fe93c52fab();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Binance not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
async function $7bc03dcc2215ad65$export$785cd5e95d0717c1(provider) {
    /**
   * * WORKAROUND 2: Account Indexing Consistency
   * Binance Wallet's `connect` returns a list where the currently selected account
   * is always the first item. We're directly taking this first item as the active account.
   *
   */ const [account] = await provider.request({
        method: 'eth_requestAccounts'
    });
    const chainId = await provider.request({
        method: 'eth_chainId'
    });
    return {
        accounts: [
            account
        ],
        chainId: chainId
    };
}


const $11d07378db0311fb$export$7c460c214963f696 = 'binance';
const $11d07378db0311fb$export$6ae6d19d2a14f956 = [
    (0, $9HEDW.LegacyNetworks).OPTIMISM,
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).LINEA,
    (0, $9HEDW.LegacyNetworks).METIS,
    (0, $9HEDW.LegacyNetworks).BLAST,
    (0, $9HEDW.LegacyNetworks).CELO,
    (0, $9HEDW.LegacyNetworks).FANTOM,
    (0, $9HEDW.LegacyNetworks).MONAD,
    (0, $9HEDW.LegacyNetworks).SONIC,
    (0, $9HEDW.LegacyNetworks).BERACHAIN,
    (0, $9HEDW.LegacyNetworks).BASE,
    (0, $9HEDW.LegacyNetworks).ZETA_CHAIN,
    (0, $9HEDW.LegacyNetworks).ARBITRUM,
    (0, $9HEDW.LegacyNetworks).BSC,
    (0, $9HEDW.LegacyNetworks).SCROLL,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN
];
const $11d07378db0311fb$export$dbb5e893e736e4ee = {
    name: 'Binance Wallet',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/binance/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/binance-wallet/cadiboklkpojfamcoggejbbdjcoiljjk',
        brave: 'https://chromewebstore.google.com/detail/binance-wallet/cadiboklkpojfamcoggejbbdjcoiljjk',
        homepage: 'https://www.binance.com/binancewallet'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((blockchainMeta)=>$11d07378db0311fb$export$6ae6d19d2a14f956.includes(blockchainMeta.name))
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $9906550309c31f86$export$2e2bcd8739ae039)((0, $7bc03dcc2215ad65$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $3ca9q = parcelRequire("3ca9q");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");


var $795b2611c2574d92$var$_ = Object.defineProperty;
var $795b2611c2574d92$var$t = (o, e)=>$795b2611c2574d92$var$_(o, "name", {
        value: e,
        configurable: !0
    });
var $795b2611c2574d92$var$c = (o, e)=>{
    for(var r in e)$795b2611c2574d92$var$_(o, r, {
        get: e[r],
        enumerable: !0
    });
};
var $795b2611c2574d92$export$e324594224ef24da = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$e324594224ef24da, {
    canEagerConnect: ()=>$795b2611c2574d92$var$te,
    canSwitchNetwork: ()=>$795b2611c2574d92$var$oe,
    connect: ()=>$795b2611c2574d92$var$ee,
    getChainId: ()=>$795b2611c2574d92$var$re,
    recommended: ()=>$795b2611c2574d92$var$Z
});
function $795b2611c2574d92$var$O(o) {
    let [, e] = o.state();
    e("network", null), e("accounts", null), e("connected", !1), e("connecting", !1), e("connectArgs", null);
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$O, "disconnect");
var $795b2611c2574d92$var$j = [
    [
        "disconnect",
        $795b2611c2574d92$var$O
    ]
];
var $795b2611c2574d92$export$eab97d15b1788b8d = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$eab97d15b1788b8d, {
    filterAndGetEvmBlockchainNames: ()=>$795b2611c2574d92$var$C,
    formatAccountsToCAIP: ()=>$795b2611c2574d92$var$m,
    getAccounts: ()=>$795b2611c2574d92$var$b,
    isUserRejectionError: ()=>$795b2611c2574d92$var$X,
    suggestNetwork: ()=>$795b2611c2574d92$var$K,
    switchNetwork: ()=>$795b2611c2574d92$var$D,
    switchOrAddNetwork: ()=>$795b2611c2574d92$var$w
});
var $795b2611c2574d92$export$c67e5a7ce034264a = "eip155", $795b2611c2574d92$export$f7ddd38c1d8175b6 = "1";
var $795b2611c2574d92$var$Q = 16;
async function $795b2611c2574d92$var$b(o) {
    let [e, r] = await Promise.all([
        o.request({
            method: "eth_requestAccounts"
        }),
        o.request({
            method: "eth_chainId"
        })
    ]), n = r;
    return typeof n == "number" && (n = `0x${Number(r).toString($795b2611c2574d92$var$Q)}`), {
        accounts: e,
        chainId: n
    };
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$b, "getAccounts");
async function $795b2611c2574d92$var$K(o, e) {
    return await o.request({
        method: "wallet_addEthereumChain",
        params: [
            e
        ]
    });
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$K, "suggestNetwork");
async function $795b2611c2574d92$var$D(o, e) {
    return await o.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: e
            }
        ]
    });
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$D, "switchNetwork");
function $795b2611c2574d92$var$C(o) {
    return (0, $hE77Y.evmBlockchains)(o).map((e)=>e.name);
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$C, "filterAndGetEvmBlockchainNames");
async function $795b2611c2574d92$var$w(o, e) {
    try {
        let r = typeof e == "string" ? e : e.chainId;
        await $795b2611c2574d92$var$D(o, r);
    } catch (r) {
        let n = r;
        if (typeof e != "string" && (n.code === 4902 || !n.code)) {
            await $795b2611c2574d92$var$K(o, e);
            return;
        }
        throw r;
    }
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$w, "switchOrAddNetwork");
var $795b2611c2574d92$var$F = 4001;
function $795b2611c2574d92$var$X(o) {
    if (typeof o == "object" && o !== null) {
        let e = o.code, r = o.cause?.code;
        return e === $795b2611c2574d92$var$F || r === $795b2611c2574d92$var$F;
    }
    return !1;
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$X, "isUserRejectionError");
function $795b2611c2574d92$var$m(o, e) {
    return o.map((r)=>(0, $3ca9q.AccountId).format({
            address: r,
            chainId: {
                namespace: $795b2611c2574d92$export$c67e5a7ce034264a,
                reference: e
            }
        }));
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$m, "formatAccountsToCAIP");
var $795b2611c2574d92$var$Z = [
    ...$795b2611c2574d92$var$j
];
function $795b2611c2574d92$var$ee(o, e) {
    return async (r, n)=>{
        let [, d] = r.state();
        d("connectArgs", {
            chain: n
        });
        let a = o();
        if (!a) throw new Error("Do your wallet injected correctly and is evm compatible?");
        n && (e?.switchOrAddNetwork ? await e.switchOrAddNetwork(a, n) : await $795b2611c2574d92$var$w(a, n));
        let s;
        if (e?.getAccounts ? s = await e.getAccounts(a) : s = await $795b2611c2574d92$var$b(a), !s.accounts || !s.accounts.length) throw new Error("No accounts were returned by the provider. Please make sure your wallet has an active EVM-compatible account selected.");
        return {
            accounts: $795b2611c2574d92$var$m(s.accounts, s.chainId),
            network: s.chainId
        };
    };
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$ee, "connect");
function $795b2611c2574d92$var$te(o) {
    return async ()=>{
        let e = o();
        if (!e) throw new Error("Trying to eagerly connect to your EVM wallet, but seems its instance is not available.");
        try {
            return !!(await e.request({
                method: "eth_accounts"
            })).length;
        } catch  {
            return !1;
        }
    };
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$te, "canEagerConnect");
function $795b2611c2574d92$var$oe() {
    return (o, e)=>{
        let { network: r, supportedChains: n } = e;
        return $795b2611c2574d92$var$C(n).includes(r);
    };
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$oe, "canSwitchNetwork");
function $795b2611c2574d92$var$re(o) {
    return async ()=>{
        let e = o();
        if (!e) throw new Error("Trying to get chain id from your EVM wallet, but instance is not available.");
        return e.request({
            method: "eth_chainId"
        });
    };
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$re, "getChainId");
var $795b2611c2574d92$export$11949c6f5fba7dcd = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$11949c6f5fba7dcd, {
    changeAccountSubscriber: ()=>$795b2611c2574d92$var$ne,
    changeChainSubscriber: ()=>$795b2611c2574d92$var$se
});
function $795b2611c2574d92$var$ne(o) {
    return $795b2611c2574d92$export$aea8daed5328d69c.changeAccountSubscriber(o).build();
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$ne, "changeAccountSubscriber");
function $795b2611c2574d92$var$se(o) {
    let e;
    return [
        (r)=>{
            let n = o();
            if (!n) throw new Error("Trying to subscribe to your EVM wallet, but seems its instance is not available.");
            let [, d] = r.state();
            e = $795b2611c2574d92$var$t(async (a)=>{
                d("network", a);
            }, "eventCallback"), n.on("chainChanged", e);
        },
        ()=>{
            let r = o();
            e && r && r.removeListener("chainChanged", e);
        }
    ];
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$se, "changeChainSubscriber");
var $795b2611c2574d92$export$742acabee3dd6465 = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$742acabee3dd6465, {
    recommended: ()=>$795b2611c2574d92$var$ie
});
function $795b2611c2574d92$var$v(o) {
    let [, e] = o.state();
    e("connecting", !1);
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$v, "intoConnectionFinished");
var $795b2611c2574d92$var$E = [
    [
        "connect",
        $795b2611c2574d92$var$v
    ]
];
var $795b2611c2574d92$var$ie = [
    ...$795b2611c2574d92$var$E
];
var $795b2611c2574d92$export$21c0ac7fe1cef1b8 = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$21c0ac7fe1cef1b8, {
    recommended: ()=>$795b2611c2574d92$var$he
});
var $795b2611c2574d92$var$i = class {
    static{
        $795b2611c2574d92$var$t(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #r = new Map;
    #o = new Map;
    #n;
    constructor(e){
        this.name = e;
    }
    and(e) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(e), this;
    }
    or(e) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(e), this;
    }
    before(e) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(e), this;
    }
    after(e) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(e), this;
    }
    action(e) {
        return this.#n = e, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#o,
            after: this.#r,
            and: this.#e,
            or: this.#t
        };
    }
};
var $795b2611c2574d92$var$f = class {
    static{
        $795b2611c2574d92$var$t(this, "ChangeAccountSubscriberBuilder");
    }
    #e = null;
    #t = null;
    #r = null;
    #o = null;
    #n = null;
    getInstance(e) {
        return this.#e = e, this;
    }
    format(e) {
        return this.#t = e, this;
    }
    onSwitchAccount(e) {
        return this.#r = e, this;
    }
    addEventListener(e) {
        return this.#o = e, this;
    }
    removeEventListener(e) {
        return this.#n = e, this;
    }
    build() {
        if (this.#e === null) throw new Error(this.#s("getInstance"));
        if (this.#t === null) throw new Error(this.#s("format"));
        if (this.#o === null) throw new Error(this.#s("addEventListener"));
        if (this.#n === null) throw new Error(this.#s("removeEventListener"));
        let e = this.#e, r = this.#t, n = this.#o, d = this.#n, a = this.#r, s, p;
        return [
            async (x)=>{
                let [, S] = x.state(), u = e();
                if (!u) throw new Error("Trying to subscribe to your wallet, but seems its instance is not available.");
                s = $795b2611c2574d92$var$t(async (T)=>{
                    let R = !0;
                    a?.({
                        payload: T,
                        preventDefault: ()=>{
                            R = !1;
                        }
                    }, x), R && S("accounts", await r(u, T));
                }, "subscriber"), p = n(u, s);
            },
            (x, S)=>{
                p && typeof p == "function" && p();
                let u = e();
                return d(u, s), S;
            }
        ];
    }
    #s(e) {
        return `Required "${e}" operation has not been set for "changeAccountSubscriber"`;
    }
};
function $795b2611c2574d92$var$L(o) {
    try {
        return (0, $3ca9q.AccountId).parse(o), !0;
    } catch  {
        return !1;
    }
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$L, "isValidCaipAddress");
function $795b2611c2574d92$var$h(o, e) {
    if (!e.accounts.every($795b2611c2574d92$var$L)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e.accounts}`);
    let [, r] = o.state();
    return r("accounts", e.accounts), r("network", e.network), r("connected", !0), e;
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$h, "connectAndUpdateStateForMultiNetworks");
function $795b2611c2574d92$var$g(o) {
    let [, e] = o.state();
    e("connecting", !0);
}
$795b2611c2574d92$var$t($795b2611c2574d92$var$g, "intoConnecting");
var $795b2611c2574d92$var$k = [
    [
        "connect",
        $795b2611c2574d92$var$g
    ]
];
var $795b2611c2574d92$var$he = [
    [
        "connect",
        $795b2611c2574d92$var$h
    ]
];
var $795b2611c2574d92$export$1c4c1e3098bf5ebe = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$1c4c1e3098bf5ebe, {
    recommended: ()=>$795b2611c2574d92$var$le
});
var $795b2611c2574d92$var$le = [
    ...$795b2611c2574d92$var$k
];
var $795b2611c2574d92$export$aea8daed5328d69c = {};
$795b2611c2574d92$var$c($795b2611c2574d92$export$aea8daed5328d69c, {
    canEagerConnect: ()=>$795b2611c2574d92$var$ye,
    canSwitchNetwork: ()=>$795b2611c2574d92$var$ge,
    changeAccountSubscriber: ()=>$795b2611c2574d92$var$xe,
    connect: ()=>$795b2611c2574d92$var$ve,
    getChainId: ()=>$795b2611c2574d92$var$Se
});
var $795b2611c2574d92$var$ve = $795b2611c2574d92$var$t(()=>new $795b2611c2574d92$var$i("connect").and($795b2611c2574d92$var$h).before($795b2611c2574d92$var$g).after($795b2611c2574d92$var$v), "connect"), $795b2611c2574d92$var$ye = $795b2611c2574d92$var$t(()=>new $795b2611c2574d92$var$i("canEagerConnect"), "canEagerConnect"), $795b2611c2574d92$var$ge = $795b2611c2574d92$var$t(()=>new $795b2611c2574d92$var$i("canSwitchNetwork"), "canSwitchNetwork"), $795b2611c2574d92$var$xe = $795b2611c2574d92$var$t((o)=>new $795b2611c2574d92$var$f().getInstance(o).onSwitchAccount((e, r)=>{
        (!e.payload || !e.payload.length) && (r.action("disconnect"), e.preventDefault());
    }).format(async (e, r)=>{
        let n = await e.request({
            method: "eth_chainId"
        });
        return $795b2611c2574d92$var$m(r, n);
    }).addEventListener((e, r)=>{
        e.on("accountsChanged", r);
    }).removeEventListener((e, r)=>{
        e.removeListener?.("accountsChanged", r);
    }), "changeAccountSubscriber"), $795b2611c2574d92$var$Se = $795b2611c2574d92$var$t(()=>new $795b2611c2574d92$var$i("getChainId"), "getChainId");




const [$dd69876cb02bdf12$var$changeAccountSubscriber, $dd69876cb02bdf12$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $7bc03dcc2215ad65$export$e14d7c242d88da3d))/*
   * Binance returns an array of connected accounts with the active one first.
   * Since we only need the active account, we take the first element as a workaround.
   */ .format(async (instance, accounts)=>{
    const chainId = await instance.request({
        method: 'eth_chainId'
    });
    return (0, $795b2611c2574d92$export$eab97d15b1788b8d).formatAccountsToCAIP([
        accounts[0]
    ], chainId);
}).build();
const $dd69876cb02bdf12$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $7bc03dcc2215ad65$export$e14d7c242d88da3d), {
    getAccounts: (0, $7bc03dcc2215ad65$export$785cd5e95d0717c1)
})).before($dd69876cb02bdf12$var$changeAccountSubscriber).or($dd69876cb02bdf12$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $dd69876cb02bdf12$var$disconnect = (0, $f59Be.builders).disconnect().after($dd69876cb02bdf12$var$changeAccountCleanup).build();
const $dd69876cb02bdf12$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $dd69876cb02bdf12$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $7bc03dcc2215ad65$export$e14d7c242d88da3d))).build();
const $dd69876cb02bdf12$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $11d07378db0311fb$export$7c460c214963f696)).action($dd69876cb02bdf12$var$connect).action($dd69876cb02bdf12$var$disconnect).action($dd69876cb02bdf12$var$canSwitchNetwork).action($dd69876cb02bdf12$var$getChainId).build();



const $6be6cc0ab9fabdc6$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $11d07378db0311fb$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $7bc03dcc2215ad65$export$210ce5fe93c52fab)()) {
            setState('installed', true);
            console.debug('[binance-wallet] instance detected.', context);
        }
    }).config('metadata', (0, $11d07378db0311fb$export$dbb5e893e736e4ee)).add('evm', (0, $dd69876cb02bdf12$export$2f7490c34b49803e)).build();


const $1ec0d9d807afcd8b$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $6be6cc0ab9fabdc6$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $ihoyg = parcelRequire("ihoyg");
var $4b29aa6033ba2baa$require$Buffer = $ihoyg.Buffer;
class $4b29aa6033ba2baa$export$102d5e874509d465 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $9gKM3.SignerError).UnimplementedError('signMessage');
    }
    async signAndSendTx(tx) {
        const { asset: asset, psbt: psbt } = tx;
        if (!psbt) throw new Error('No PSBT found to sign. Ensure a valid PSBT is provided.');
        if (asset.blockchain !== (0, $9HEDW.LegacyNetworks).BTC) throw new Error(`Signing ${asset.blockchain} transaction is not implemented by the signer.`);
        // 1. Decode Base64 to hex
        const psbtHex = $4b29aa6033ba2baa$require$Buffer.from(psbt.unsignedPsbtBase64, 'base64').toString('hex');
        // 2. Build UniSat inputs
        const toSignInputs = psbt.inputsToSign.flatMap(({ address: address, signingIndexes: signingIndexes })=>signingIndexes.map((index)=>({
                    index: index,
                    address: address
                })));
        try {
            // 3. Sign (& auto-finalize)
            const signedPsbtHex = await this.provider.signPsbt(psbtHex, {
                autoFinalized: true,
                toSignInputs: toSignInputs
            });
            // 4. Push signed psbt
            const transactionHash = await this.provider.pushPsbt(signedPsbtHex);
            return {
                hash: transactionHash
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            throw new Error(error?.message || 'Error during signing transaction');
        }
    }
}




async function $4f7cfc51537a4c29$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const tronProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).TRON);
    const utxoProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).BTC);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    const { DefaultTronSigner: DefaultTronSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("cCZtf")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).TRON, new DefaultTronSigner(tronProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new (0, $4b29aa6033ba2baa$export$102d5e874509d465)(utxoProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $90bf17280c1f5a47$export$13e69e4fcd089856() {
    const instances = new Map();
    const { bitkeep: bitkeep } = window;
    if (!bitkeep) return null;
    if (bitkeep.ethereum) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, bitkeep.ethereum);
    if (bitkeep.tronLink) instances.set((0, $9HEDW.LegacyNetworks).TRON, bitkeep.tronLink);
    if (bitkeep.unisat) instances.set((0, $9HEDW.LegacyNetworks).BTC, bitkeep.unisat);
    if (instances.size === 0) return null;
    return instances;
}
function $90bf17280c1f5a47$export$62115b9164fa6f77() {
    const instances = $90bf17280c1f5a47$export$13e69e4fcd089856();
    if (!instances) throw new Error('Bitget is not injected. Please check your wallet.');
    return instances;
}
function $90bf17280c1f5a47$export$5eb8048e1e4b83b0() {
    const instances = $90bf17280c1f5a47$export$13e69e4fcd089856();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Bitget not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $90bf17280c1f5a47$export$ba387645e397d2f2() {
    const instance = $90bf17280c1f5a47$export$13e69e4fcd089856();
    const tronInstance = instance?.get((0, $9HEDW.LegacyNetworks).TRON);
    if (!tronInstance) throw new Error('Bitget not injected or Tron not enabled. Please check your wallet.');
    return tronInstance;
}
function $90bf17280c1f5a47$export$8ff222e30ec3002a() {
    const instance = $90bf17280c1f5a47$export$13e69e4fcd089856();
    const utxoInstance = instance?.get((0, $9HEDW.LegacyNetworks).BTC);
    if (!utxoInstance) throw new Error('Bitget not injected or BTC not enabled. Please check your wallet.');
    return utxoInstance;
}


const $238a495bb683bd90$export$7c460c214963f696 = 'bitget';
const $238a495bb683bd90$export$b2fbad1e9ff26ff3 = 200;
const $238a495bb683bd90$export$dbb5e893e736e4ee = {
    name: 'Bitget',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/bitget/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak',
        brave: 'https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak',
        homepage: 'https://web3.bitget.com/en/wallet-download?type=1'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Tron',
                        value: 'Tron',
                        id: 'TRON',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.tronBlockchain)(allBlockchains)
                    },
                    {
                        label: 'BTC',
                        value: 'UTXO',
                        id: 'BTC',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $4f7cfc51537a4c29$export$2e2bcd8739ae039)((0, $90bf17280c1f5a47$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$d0f8f0d65f93beb3$var$changeAccountSubscriber, $d0f8f0d65f93beb3$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $90bf17280c1f5a47$export$5eb8048e1e4b83b0));
const $d0f8f0d65f93beb3$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $90bf17280c1f5a47$export$5eb8048e1e4b83b0))).before($d0f8f0d65f93beb3$var$changeAccountSubscriber).or($d0f8f0d65f93beb3$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $d0f8f0d65f93beb3$var$disconnect = (0, $f59Be.builders).disconnect().after($d0f8f0d65f93beb3$var$changeAccountCleanup).build();
const $d0f8f0d65f93beb3$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $d0f8f0d65f93beb3$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $90bf17280c1f5a47$export$5eb8048e1e4b83b0))).build();
const $d0f8f0d65f93beb3$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $90bf17280c1f5a47$export$5eb8048e1e4b83b0))).build();
const $d0f8f0d65f93beb3$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $238a495bb683bd90$export$7c460c214963f696)).action($d0f8f0d65f93beb3$var$connect).action($d0f8f0d65f93beb3$var$disconnect).action($d0f8f0d65f93beb3$var$getChainId).action($d0f8f0d65f93beb3$var$canEagerConnect).action($d0f8f0d65f93beb3$var$canSwitchNetwork).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



var $3ca9q = parcelRequire("3ca9q");
var $838c2177a0531a1c$var$y = Object.defineProperty;
var $838c2177a0531a1c$var$e = (o, t)=>$838c2177a0531a1c$var$y(o, "name", {
        value: t,
        configurable: !0
    });
var $838c2177a0531a1c$var$n = (o, t)=>{
    for(var s in t)$838c2177a0531a1c$var$y(o, s, {
        get: t[s],
        enumerable: !0
    });
};
var $838c2177a0531a1c$export$e324594224ef24da = {};
$838c2177a0531a1c$var$n($838c2177a0531a1c$export$e324594224ef24da, {
    recommended: ()=>$838c2177a0531a1c$var$k
});
function $838c2177a0531a1c$var$g(o) {
    let [, t] = o.state();
    t("network", null), t("accounts", null), t("connected", !1), t("connecting", !1), t("connectArgs", null);
}
$838c2177a0531a1c$var$e($838c2177a0531a1c$var$g, "disconnect");
var $838c2177a0531a1c$var$x = [
    [
        "disconnect",
        $838c2177a0531a1c$var$g
    ]
];
var $838c2177a0531a1c$var$k = [
    ...$838c2177a0531a1c$var$x
];
var $838c2177a0531a1c$export$742acabee3dd6465 = {};
$838c2177a0531a1c$var$n($838c2177a0531a1c$export$742acabee3dd6465, {
    recommended: ()=>$838c2177a0531a1c$var$R
});
function $838c2177a0531a1c$var$a(o) {
    let [, t] = o.state();
    t("connecting", !1);
}
$838c2177a0531a1c$var$e($838c2177a0531a1c$var$a, "intoConnectionFinished");
var $838c2177a0531a1c$var$d = [
    [
        "connect",
        $838c2177a0531a1c$var$a
    ]
];
var $838c2177a0531a1c$var$R = [
    ...$838c2177a0531a1c$var$d
];
var $838c2177a0531a1c$export$21c0ac7fe1cef1b8 = {};
$838c2177a0531a1c$var$n($838c2177a0531a1c$export$21c0ac7fe1cef1b8, {
    recommended: ()=>$838c2177a0531a1c$var$M
});
var $838c2177a0531a1c$var$r = class {
    static{
        $838c2177a0531a1c$var$e(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #o = new Map;
    #r = new Map;
    #n;
    constructor(t){
        this.name = t;
    }
    and(t) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(t), this;
    }
    or(t) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(t), this;
    }
    before(t) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(t), this;
    }
    after(t) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(t), this;
    }
    action(t) {
        return this.#n = t, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#r,
            after: this.#o,
            and: this.#e,
            or: this.#t
        };
    }
};
function $838c2177a0531a1c$var$C(o) {
    try {
        return (0, $3ca9q.AccountId).parse(o), !0;
    } catch  {
        return !1;
    }
}
$838c2177a0531a1c$var$e($838c2177a0531a1c$var$C, "isValidCaipAddress");
function $838c2177a0531a1c$var$i(o, t) {
    if (!t.every($838c2177a0531a1c$var$C)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${t}`);
    let [, s] = o.state();
    return s("accounts", t), s("connected", !0), t;
}
$838c2177a0531a1c$var$e($838c2177a0531a1c$var$i, "connectAndUpdateStateForSingleNetwork");
function $838c2177a0531a1c$var$p(o) {
    let [, t] = o.state();
    t("connecting", !0);
}
$838c2177a0531a1c$var$e($838c2177a0531a1c$var$p, "intoConnecting");
var $838c2177a0531a1c$var$h = [
    [
        "connect",
        $838c2177a0531a1c$var$p
    ]
];
var $838c2177a0531a1c$var$M = [
    [
        "connect",
        $838c2177a0531a1c$var$i
    ]
];
var $838c2177a0531a1c$export$1c4c1e3098bf5ebe = {};
$838c2177a0531a1c$var$n($838c2177a0531a1c$export$1c4c1e3098bf5ebe, {
    recommended: ()=>$838c2177a0531a1c$var$W
});
var $838c2177a0531a1c$var$W = [
    ...$838c2177a0531a1c$var$h
];
var $838c2177a0531a1c$export$aea8daed5328d69c = {};
$838c2177a0531a1c$var$n($838c2177a0531a1c$export$aea8daed5328d69c, {
    canEagerConnect: ()=>$838c2177a0531a1c$var$B,
    connect: ()=>$838c2177a0531a1c$var$H
});
var $838c2177a0531a1c$var$H = $838c2177a0531a1c$var$e(()=>new $838c2177a0531a1c$var$r("connect").and($838c2177a0531a1c$var$i).before($838c2177a0531a1c$var$p).after($838c2177a0531a1c$var$a), "connect"), $838c2177a0531a1c$var$B = $838c2177a0531a1c$var$e(()=>new $838c2177a0531a1c$var$r("canEagerConnect"), "canEagerConnect");
var $838c2177a0531a1c$export$eab97d15b1788b8d = {};
$838c2177a0531a1c$var$n($838c2177a0531a1c$export$eab97d15b1788b8d, {
    formatAccountsToCAIP: ()=>$838c2177a0531a1c$var$L
});
var $838c2177a0531a1c$export$c67e5a7ce034264a = "tron", $838c2177a0531a1c$export$b3b3a07ef606aa99 = "tron";
function $838c2177a0531a1c$var$L(o) {
    return o.map((t)=>(0, $3ca9q.AccountId).format({
            address: t.toString(),
            chainId: {
                namespace: $838c2177a0531a1c$export$c67e5a7ce034264a,
                reference: $838c2177a0531a1c$export$b3b3a07ef606aa99
            }
        }));
}
$838c2177a0531a1c$var$e($838c2177a0531a1c$var$L, "formatAccountsToCAIP");



/*
 * Bitget does not provide an eager connection mechanism for its Tron wallet.
 * The only workaround is to use the EVM-based eager connect approach.
 * However, this will only work if the EVM namespace has been connected at least once before.
 * If either wallet instance is unavailable, we throw an error.
 */ const $c2ad8cf038a14c27$var$canEagerConnectAction = async ()=>{
    const evmInstance = (0, $90bf17280c1f5a47$export$5eb8048e1e4b83b0)();
    const tronInstance = (0, $90bf17280c1f5a47$export$ba387645e397d2f2)();
    // Making sure that the Tron instance is available first to prevent errors.
    if (!tronInstance) throw new Error('Trying to eagerly connect to your wallet, but seems its tron instance is not available.');
    if (!evmInstance) throw new Error('Trying to eagerly connect to your EVM wallet, but seems its instance is not available.');
    try {
        const accounts = await evmInstance.request({
            method: 'eth_accounts'
        });
        if (accounts.length) return true;
        return false;
    } catch  {
        return false;
    }
};
const $c2ad8cf038a14c27$export$b77666ae30db36c3 = {
    canEagerConnectAction: $c2ad8cf038a14c27$var$canEagerConnectAction
};



var $f59Be = parcelRequire("f59Be");

const $ba670c2941954ad6$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event, context)=>{
        if (!event.payload.data.isBitkeep || event.payload.data.message?.action !== 'accountsChanged') {
            event.preventDefault();
            return;
        }
        if (!event.payload.data.message.data.address) {
            event.preventDefault();
            context.action('disconnect');
        }
    }).format(async (_, accounts)=>(0, $838c2177a0531a1c$export$eab97d15b1788b8d).formatAccountsToCAIP([
            accounts.data.message.data.address
        ])).addEventListener((_, callback)=>{
        window.addEventListener('message', callback);
    }).removeEventListener((_, callback)=>{
        window.removeEventListener('message', callback);
    });
const $ba670c2941954ad6$export$458c54615707a7bf = {
    changeAccountSubscriber: $ba670c2941954ad6$export$bc681aebb548377e
};




const [$1e3607a5a1f8dd69$var$changeAccountSubscriber, $1e3607a5a1f8dd69$var$changeAccountCleanup] = (0, $ba670c2941954ad6$export$458c54615707a7bf).changeAccountSubscriber((0, $90bf17280c1f5a47$export$ba387645e397d2f2)).build();
const $1e3607a5a1f8dd69$var$connect = (0, $838c2177a0531a1c$export$aea8daed5328d69c).connect().action(async ()=>{
    const instance = (0, $90bf17280c1f5a47$export$ba387645e397d2f2)();
    const accountsResult = await instance.request({
        method: 'tron_requestAccounts'
    });
    if (!accountsResult) throw new Error('Please unlock your Bitget extension first.');
    if (!!accountsResult?.code && !!accountsResult.message && accountsResult.code !== (0, $238a495bb683bd90$export$b2fbad1e9ff26ff3)) throw new Error(accountsResult.message);
    return (0, $838c2177a0531a1c$export$eab97d15b1788b8d).formatAccountsToCAIP([
        instance.tronWeb.defaultAddress.base58
    ]);
}).before($1e3607a5a1f8dd69$var$changeAccountSubscriber).or((0, $f59Be.standardizeAndThrowError)).or($1e3607a5a1f8dd69$var$changeAccountCleanup).build();
const $1e3607a5a1f8dd69$var$disconnect = (0, $f59Be.builders).disconnect().after($1e3607a5a1f8dd69$var$changeAccountCleanup).build();
const $1e3607a5a1f8dd69$var$canEagerConnect = (0, $838c2177a0531a1c$export$aea8daed5328d69c).canEagerConnect().action((0, $c2ad8cf038a14c27$export$b77666ae30db36c3).canEagerConnectAction).build();
const $1e3607a5a1f8dd69$export$861f0f2ab432c70 = new (0, $at2GJ.NamespaceBuilder)('Tron', (0, $238a495bb683bd90$export$7c460c214963f696)).action($1e3607a5a1f8dd69$var$connect).action($1e3607a5a1f8dd69$var$disconnect).action($1e3607a5a1f8dd69$var$canEagerConnect).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");

var $er2za = parcelRequire("er2za");
function $ba0ce0801a0077f2$export$64605811ab45167f(instance) {
    return async ()=>{
        const utxoInstance = instance();
        if (!utxoInstance) throw new Error('Do your wallet injected correctly and is utxo compatible?');
        const accounts = await utxoInstance.requestAccounts();
        return (0, $er2za.utils).formatAccountsToCAIP(accounts, (0, $er2za.CAIP_BITCOIN_CHAIN_ID));
    };
}
const $ba0ce0801a0077f2$export$47061ea3cbbbe241 = {
    connect: $ba0ce0801a0077f2$export$64605811ab45167f
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");
const $8839e637fcf132af$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event, context)=>{
        if (!event.payload) {
            event.preventDefault();
            context.action('disconnect');
        }
    }).format(async (_, address)=>{
        return (0, $er2za.utils).formatAccountsToCAIP(address ? [
            address
        ] : [], (0, $er2za.CAIP_BITCOIN_CHAIN_ID));
    }).addEventListener((instance, callback)=>{
        return instance.addListener('accountChanged', callback);
    }).removeEventListener((instance, callback)=>{
        return instance.removeListener('accountChanged', callback);
    });
function $8839e637fcf132af$var$canEagerConnect(getInstance) {
    return new (0, $fha7R.ActionBuilder)('canEagerConnect').action(async ()=>{
        const instance = getInstance();
        const accounts = await instance.getAccounts();
        return !!accounts.length;
    });
}
const $8839e637fcf132af$export$4ec68a7e2bb108ab = {
    changeAccountSubscriber: $8839e637fcf132af$export$bc681aebb548377e,
    canEagerConnect: $8839e637fcf132af$var$canEagerConnect
};



function $b48c9dd228de9637$var$disconnectSubscriber(instance) {
    let eventCallback;
    // subscriber can be passed to `or`, it will get the error and should rethrow error to pass the error to next `or` or throw error.
    return [
        (context, err)=>{
            const bitcoinInstance = instance();
            if (!bitcoinInstance) throw new Error('Trying to subscribe to your BTC wallet, but seems its instance is not available.');
            eventCallback = ()=>{
                context.action('disconnect');
            };
            bitcoinInstance.on('disconnect', eventCallback);
            if (err instanceof Error) throw err;
        },
        (_context, err)=>{
            const bitcoinInstance = instance();
            if (eventCallback && bitcoinInstance) bitcoinInstance.removeListener('disconnect', eventCallback);
            return err;
        }
    ];
}
const $b48c9dd228de9637$export$3f1c6eb2a2dd84cb = {
    disconnectSubscriber: $b48c9dd228de9637$var$disconnectSubscriber
};



const [$89ac6d40ec66fe33$var$changeAccountSubscriber, $89ac6d40ec66fe33$var$changeAccountCleanup] = (0, $8839e637fcf132af$export$4ec68a7e2bb108ab).changeAccountSubscriber((0, $90bf17280c1f5a47$export$8ff222e30ec3002a)).build();
const [$89ac6d40ec66fe33$var$disconnectSubscriber, $89ac6d40ec66fe33$var$disconnectSubscriberCleanup] = (0, $b48c9dd228de9637$export$3f1c6eb2a2dd84cb).disconnectSubscriber((0, $90bf17280c1f5a47$export$8ff222e30ec3002a));
const $89ac6d40ec66fe33$var$connect = (0, $er2za.builders).connect().action((0, $ba0ce0801a0077f2$export$47061ea3cbbbe241).connect((0, $90bf17280c1f5a47$export$8ff222e30ec3002a))).before($89ac6d40ec66fe33$var$changeAccountSubscriber).before($89ac6d40ec66fe33$var$disconnectSubscriber).or($89ac6d40ec66fe33$var$changeAccountCleanup).or($89ac6d40ec66fe33$var$disconnectSubscriberCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $89ac6d40ec66fe33$var$disconnect = (0, $f59Be.builders).disconnect().after($89ac6d40ec66fe33$var$changeAccountCleanup).after($89ac6d40ec66fe33$var$disconnectSubscriberCleanup).build();
const $89ac6d40ec66fe33$var$canEagerConnect = (0, $8839e637fcf132af$export$4ec68a7e2bb108ab).canEagerConnect((0, $90bf17280c1f5a47$export$8ff222e30ec3002a)).build();
const $89ac6d40ec66fe33$export$85601e73083fc493 = new (0, $at2GJ.NamespaceBuilder)('UTXO', (0, $238a495bb683bd90$export$7c460c214963f696)).action($89ac6d40ec66fe33$var$connect).action($89ac6d40ec66fe33$var$disconnect).action($89ac6d40ec66fe33$var$canEagerConnect).build();



const $ac5c3804cd9f1b77$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $238a495bb683bd90$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $90bf17280c1f5a47$export$13e69e4fcd089856)()) {
            setState('installed', true);
            console.debug('[bitget] instance detected.', context);
        }
    }).config('metadata', (0, $238a495bb683bd90$export$dbb5e893e736e4ee)).add('tron', (0, $1e3607a5a1f8dd69$export$861f0f2ab432c70)).add('evm', (0, $d0f8f0d65f93beb3$export$2f7490c34b49803e)).add('utxo', (0, $89ac6d40ec66fe33$export$85601e73083fc493)).build();


const $cc1b5f400113376f$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $ac5c3804cd9f1b77$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $c23333f8650667b4$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const starknetProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).STARKNET);
    const { DefaultStarknetSigner: DefaultStarknetSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("1q68f")));
    signers.registerSigner((0, $9B1kL.TransactionType).STARKNET, new DefaultStarknetSigner(starknetProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $0586ed4db9c90a96$export$67aacea29accde42() {
    const instances = new Map();
    const { starknet_braavos: starknet_braavos } = window;
    if (!starknet_braavos) return null;
    instances.set((0, $9HEDW.LegacyNetworks).STARKNET, starknet_braavos);
    return instances;
}
function $0586ed4db9c90a96$export$62115b9164fa6f77() {
    const instances = $0586ed4db9c90a96$export$67aacea29accde42();
    if (!instances) throw new Error('Braavos is not injected. Please check your wallet.');
    return instances;
}
function $0586ed4db9c90a96$export$b7e74e35e84fc95c() {
    const instances = $0586ed4db9c90a96$export$67aacea29accde42();
    const starknetInstance = instances?.get((0, $9HEDW.LegacyNetworks).STARKNET);
    if (!starknetInstance) throw new Error('Braavos not injected or Starknet not enabled. Please check your wallet.');
    return starknetInstance;
}


const $c15095fed85ed469$export$7c460c214963f696 = 'braavos';
const $c15095fed85ed469$export$dbb5e893e736e4ee = {
    name: 'Braavos',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/braavos/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/braavos-smart-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma',
        brave: 'https://chrome.google.com/webstore/detail/braavos-smart-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet/',
        edge: 'https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc',
        homepage: 'https://braavos.app/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Braavos',
                        value: 'Starknet',
                        id: 'STARKNET',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.starknetBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $c23333f8650667b4$export$2e2bcd8739ae039)((0, $0586ed4db9c90a96$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



var $3ca9q = parcelRequire("3ca9q");
var $383083a8c49ef7e6$var$g = Object.defineProperty;
var $383083a8c49ef7e6$var$e = (n, t)=>$383083a8c49ef7e6$var$g(n, "name", {
        value: t,
        configurable: !0
    });
var $383083a8c49ef7e6$var$s = (n, t)=>{
    for(var r in t)$383083a8c49ef7e6$var$g(n, r, {
        get: t[r],
        enumerable: !0
    });
};
var $383083a8c49ef7e6$export$e324594224ef24da = {};
$383083a8c49ef7e6$var$s($383083a8c49ef7e6$export$e324594224ef24da, {
    canEagerConnect: ()=>$383083a8c49ef7e6$var$R,
    recommended: ()=>$383083a8c49ef7e6$var$O
});
function $383083a8c49ef7e6$var$S(n) {
    let [, t] = n.state();
    t("network", null), t("accounts", null), t("connected", !1), t("connecting", !1), t("connectArgs", null);
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$S, "disconnect");
var $383083a8c49ef7e6$var$A = [
    [
        "disconnect",
        $383083a8c49ef7e6$var$S
    ]
];
var $383083a8c49ef7e6$var$O = [
    ...$383083a8c49ef7e6$var$A
];
function $383083a8c49ef7e6$var$R(n) {
    return async ()=>{
        let t = n();
        if (!t) throw new Error("Trying to eagerly connect to your Starknet wallet, but seems its instance is not available.");
        return t.isPreauthorized();
    };
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$R, "canEagerConnect");
var $383083a8c49ef7e6$export$742acabee3dd6465 = {};
$383083a8c49ef7e6$var$s($383083a8c49ef7e6$export$742acabee3dd6465, {
    recommended: ()=>$383083a8c49ef7e6$var$M
});
function $383083a8c49ef7e6$var$a(n) {
    let [, t] = n.state();
    t("connecting", !1);
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$a, "intoConnectionFinished");
var $383083a8c49ef7e6$var$d = [
    [
        "connect",
        $383083a8c49ef7e6$var$a
    ]
];
var $383083a8c49ef7e6$var$M = [
    ...$383083a8c49ef7e6$var$d
];
var $383083a8c49ef7e6$export$21c0ac7fe1cef1b8 = {};
$383083a8c49ef7e6$var$s($383083a8c49ef7e6$export$21c0ac7fe1cef1b8, {
    recommended: ()=>$383083a8c49ef7e6$var$_
});
var $383083a8c49ef7e6$var$o = class {
    static{
        $383083a8c49ef7e6$var$e(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #n = new Map;
    #o = new Map;
    #r;
    constructor(t){
        this.name = t;
    }
    and(t) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(t), this;
    }
    or(t) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(t), this;
    }
    before(t) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(t), this;
    }
    after(t) {
        return this.#n.has(this.name) || this.#n.set(this.name, []), this.#n.get(this.name)?.push(t), this;
    }
    action(t) {
        return this.#r = t, this;
    }
    build() {
        if (!this.#r) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#r,
            before: this.#o,
            after: this.#n,
            and: this.#e,
            or: this.#t
        };
    }
};
function $383083a8c49ef7e6$var$b(n) {
    try {
        return (0, $3ca9q.AccountId).parse(n), !0;
    } catch  {
        return !1;
    }
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$b, "isValidCaipAddress");
function $383083a8c49ef7e6$var$i(n, t) {
    if (!t.every($383083a8c49ef7e6$var$b)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${t}`);
    let [, r] = n.state();
    return r("accounts", t), r("connected", !0), t;
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$i, "connectAndUpdateStateForSingleNetwork");
function $383083a8c49ef7e6$var$p(n) {
    let [, t] = n.state();
    t("connecting", !0);
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$p, "intoConnecting");
var $383083a8c49ef7e6$var$h = [
    [
        "connect",
        $383083a8c49ef7e6$var$p
    ]
];
var $383083a8c49ef7e6$var$_ = [
    [
        "connect",
        $383083a8c49ef7e6$var$i
    ]
];
var $383083a8c49ef7e6$export$1c4c1e3098bf5ebe = {};
$383083a8c49ef7e6$var$s($383083a8c49ef7e6$export$1c4c1e3098bf5ebe, {
    recommended: ()=>$383083a8c49ef7e6$var$H
});
var $383083a8c49ef7e6$var$H = [
    ...$383083a8c49ef7e6$var$h
];
var $383083a8c49ef7e6$export$aea8daed5328d69c = {};
$383083a8c49ef7e6$var$s($383083a8c49ef7e6$export$aea8daed5328d69c, {
    canEagerConnect: ()=>$383083a8c49ef7e6$var$U,
    connect: ()=>$383083a8c49ef7e6$var$V
});
var $383083a8c49ef7e6$var$V = $383083a8c49ef7e6$var$e(()=>new $383083a8c49ef7e6$var$o("connect").and($383083a8c49ef7e6$var$i).before($383083a8c49ef7e6$var$p).after($383083a8c49ef7e6$var$a), "connect"), $383083a8c49ef7e6$var$U = $383083a8c49ef7e6$var$e(()=>new $383083a8c49ef7e6$var$o("canEagerConnect"), "canEagerConnect");
var $383083a8c49ef7e6$export$eab97d15b1788b8d = {};
$383083a8c49ef7e6$var$s($383083a8c49ef7e6$export$eab97d15b1788b8d, {
    formatAccountsToCAIP: ()=>$383083a8c49ef7e6$var$Z,
    getAccounts: ()=>$383083a8c49ef7e6$var$X
});
var $383083a8c49ef7e6$export$c67e5a7ce034264a = "starknet", $383083a8c49ef7e6$export$ca044345c4fd381b = "SN_MAIN";
async function $383083a8c49ef7e6$var$X(n) {
    let t = await n.connect();
    return {
        accounts: [
            t ? t.publicKey.toString() : n.publicKey.toString()
        ],
        chainId: "SOLANA"
    };
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$X, "getAccounts");
function $383083a8c49ef7e6$var$Z(n) {
    return n.map((t)=>(0, $3ca9q.AccountId).format({
            address: t.toString(),
            chainId: {
                namespace: $383083a8c49ef7e6$export$c67e5a7ce034264a,
                reference: $383083a8c49ef7e6$export$ca044345c4fd381b
            }
        }));
}
$383083a8c49ef7e6$var$e($383083a8c49ef7e6$var$Z, "formatAccountsToCAIP");



function $97b0657f3cd26f77$export$64605811ab45167f(instance) {
    return async ()=>{
        const starknetInstance = instance();
        const connectResult = await starknetInstance?.enable();
        if (!connectResult || !starknetInstance.isConnected || !connectResult?.length) throw new Error('Error during connection');
        if (starknetInstance?.chainId && starknetInstance.chainId !== (0, $383083a8c49ef7e6$export$ca044345c4fd381b)) throw new Error(`Please switch to Mainnet, current network is ${starknetInstance?.chainId}`);
        return (0, $383083a8c49ef7e6$export$eab97d15b1788b8d).formatAccountsToCAIP(connectResult);
    };
}
const $97b0657f3cd26f77$export$cadf35f7f22c9f8c = {
    connect: $97b0657f3cd26f77$export$64605811ab45167f
};



var $f59Be = parcelRequire("f59Be");

const $75cca5afee2f75e8$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event)=>{
        if (!event.payload) event.preventDefault();
    }).format(async (_, accounts)=>(0, $383083a8c49ef7e6$export$eab97d15b1788b8d).formatAccountsToCAIP([
            accounts
        ])).addEventListener((instance, callback)=>{
        instance.on('accountsChanged', callback);
    }).removeEventListener((instance, callback)=>{
        instance.off('accountsChanged', callback);
    });
const $75cca5afee2f75e8$export$d782570be268a1b8 = {
    changeAccountSubscriber: $75cca5afee2f75e8$export$bc681aebb548377e
};




const [$b38e25cd9609b2ed$var$changeAccountSubscriber, $b38e25cd9609b2ed$var$changeAccountCleanup] = (0, $75cca5afee2f75e8$export$d782570be268a1b8).changeAccountSubscriber((0, $0586ed4db9c90a96$export$b7e74e35e84fc95c)).build();
const $b38e25cd9609b2ed$var$connect = (0, $383083a8c49ef7e6$export$aea8daed5328d69c).connect().action((0, $97b0657f3cd26f77$export$cadf35f7f22c9f8c).connect((0, $0586ed4db9c90a96$export$b7e74e35e84fc95c))).before($b38e25cd9609b2ed$var$changeAccountSubscriber).or($b38e25cd9609b2ed$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $b38e25cd9609b2ed$var$disconnect = (0, $f59Be.builders).disconnect().after($b38e25cd9609b2ed$var$changeAccountCleanup).build();
const $b38e25cd9609b2ed$var$canEagerConnect = (0, $383083a8c49ef7e6$export$aea8daed5328d69c).canEagerConnect().action((0, $383083a8c49ef7e6$export$e324594224ef24da).canEagerConnect((0, $0586ed4db9c90a96$export$b7e74e35e84fc95c))).build();
const $b38e25cd9609b2ed$export$6fd5aae21d757e0f = new (0, $at2GJ.NamespaceBuilder)('Starknet', (0, $c15095fed85ed469$export$7c460c214963f696)).action($b38e25cd9609b2ed$var$connect).action($b38e25cd9609b2ed$var$disconnect).action($b38e25cd9609b2ed$var$canEagerConnect).build();



const $cdebcf2fb48e60c6$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $c15095fed85ed469$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $0586ed4db9c90a96$export$67aacea29accde42)()) {
            setState('installed', true);
            console.debug('[braavos] instance detected.', context);
        }
    }).config('metadata', (0, $c15095fed85ed469$export$dbb5e893e736e4ee)).add('starknet', (0, $b38e25cd9609b2ed$export$6fd5aae21d757e0f)).build();


const $2cb5b9ef6797d819$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $cdebcf2fb48e60c6$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $13wKd = parcelRequire("13wKd");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");
class $9ebfe8599041864c$export$374a514027b7a67d extends (0, $13wKd.DefaultSolanaSigner) {
    constructor(provider){
        super(provider);
    }
    async signMessage(msg) {
        try {
            const encodedMessage = new TextEncoder().encode(msg);
            const { signature: signature } = await this.provider.request({
                method: 'signMessage',
                params: {
                    message: encodedMessage
                }
            });
            return signature;
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
}



async function $22f1d82bf0526e56$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $9ebfe8599041864c$export$374a514027b7a67d)(solProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $2fa974c7dc6564de$export$55900a4725b84e07() {
    const { braveEthereum: braveEthereum, braveSolana: braveSolana } = window;
    if (!braveEthereum || !braveSolana) return null;
    const instances = new Map();
    if (braveEthereum) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, braveEthereum);
    if (braveSolana) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, braveSolana);
    return instances;
}
function $2fa974c7dc6564de$export$62115b9164fa6f77() {
    const instances = $2fa974c7dc6564de$export$55900a4725b84e07();
    if (!instances) throw new Error('Brave Wallet is not injected. Please check your wallet.');
    return instances;
}
function $2fa974c7dc6564de$export$5c6e527fc25d8209() {
    const instances = $2fa974c7dc6564de$export$55900a4725b84e07();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Brave Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $2fa974c7dc6564de$export$52654fdde2b90b57() {
    const instance = $2fa974c7dc6564de$export$55900a4725b84e07();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Brave Wallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}


const $ee636cc34c349920$export$7c460c214963f696 = 'brave';
const $ee636cc34c349920$export$dbb5e893e736e4ee = {
    name: 'Brave',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/brave/icon.svg',
    extensions: {
        homepage: 'https://brave.com/wallet/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $22f1d82bf0526e56$export$2e2bcd8739ae039)((0, $2fa974c7dc6564de$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$a5fa00f2bd9aef3e$var$changeAccountSubscriber, $a5fa00f2bd9aef3e$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $2fa974c7dc6564de$export$5c6e527fc25d8209));
const $a5fa00f2bd9aef3e$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $2fa974c7dc6564de$export$5c6e527fc25d8209))).before($a5fa00f2bd9aef3e$var$changeAccountSubscriber).or($a5fa00f2bd9aef3e$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $a5fa00f2bd9aef3e$var$disconnect = (0, $f59Be.builders).disconnect().after($a5fa00f2bd9aef3e$var$changeAccountCleanup).build();
const $a5fa00f2bd9aef3e$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $a5fa00f2bd9aef3e$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $2fa974c7dc6564de$export$5c6e527fc25d8209))).build();
const $a5fa00f2bd9aef3e$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $2fa974c7dc6564de$export$5c6e527fc25d8209))).build();
const $a5fa00f2bd9aef3e$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $ee636cc34c349920$export$7c460c214963f696)).action($a5fa00f2bd9aef3e$var$connect).action($a5fa00f2bd9aef3e$var$disconnect).action($a5fa00f2bd9aef3e$var$canEagerConnect).action($a5fa00f2bd9aef3e$var$canSwitchNetwork).action($a5fa00f2bd9aef3e$var$getChainId).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $3ca9q = parcelRequire("3ca9q");


var $3b5535826a909102$var$T = Object.defineProperty;
var $3b5535826a909102$var$t = (n, e)=>$3b5535826a909102$var$T(n, "name", {
        value: e,
        configurable: !0
    });
var $3b5535826a909102$var$r = (n, e)=>{
    for(var o in e)$3b5535826a909102$var$T(n, o, {
        get: e[o],
        enumerable: !0
    });
};
var $3b5535826a909102$export$e324594224ef24da = {};
$3b5535826a909102$var$r($3b5535826a909102$export$e324594224ef24da, {
    canEagerConnect: ()=>$3b5535826a909102$var$X,
    connect: ()=>$3b5535826a909102$var$J,
    recommended: ()=>$3b5535826a909102$var$Z
});
function $3b5535826a909102$var$k(n) {
    let [, e] = n.state();
    e("network", null), e("accounts", null), e("connected", !1), e("connecting", !1), e("connectArgs", null);
}
$3b5535826a909102$var$t($3b5535826a909102$var$k, "disconnect");
var $3b5535826a909102$var$O = [
    [
        "disconnect",
        $3b5535826a909102$var$k
    ]
];
var $3b5535826a909102$export$eab97d15b1788b8d = {};
$3b5535826a909102$var$r($3b5535826a909102$export$eab97d15b1788b8d, {
    formatAccountsToCAIP: ()=>$3b5535826a909102$var$a,
    getAccounts: ()=>$3b5535826a909102$var$C
});
var $3b5535826a909102$export$c67e5a7ce034264a = "solana", $3b5535826a909102$export$a3d7ecd9c7e8a4a = "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp";
async function $3b5535826a909102$var$C(n) {
    let e = await n.connect();
    return {
        accounts: [
            e ? e.publicKey.toString() : n.publicKey.toString()
        ],
        chainId: "SOLANA"
    };
}
$3b5535826a909102$var$t($3b5535826a909102$var$C, "getAccounts");
function $3b5535826a909102$var$a(n) {
    return n.map((e)=>(0, $3ca9q.AccountId).format({
            address: e.toString(),
            chainId: {
                namespace: $3b5535826a909102$export$c67e5a7ce034264a,
                reference: $3b5535826a909102$export$a3d7ecd9c7e8a4a
            }
        }));
}
$3b5535826a909102$var$t($3b5535826a909102$var$a, "formatAccountsToCAIP");
var $3b5535826a909102$var$Z = [
    ...$3b5535826a909102$var$O
];
function $3b5535826a909102$var$J(n) {
    return async ()=>{
        let e = n(), o = await $3b5535826a909102$var$C(e);
        if (Array.isArray(o)) throw new Error("Expecting solana response to be a single value, not an array.");
        return $3b5535826a909102$var$a(o.accounts);
    };
}
$3b5535826a909102$var$t($3b5535826a909102$var$J, "connect");
function $3b5535826a909102$var$X(n) {
    return async ()=>{
        let e = n();
        if (!e) throw new Error("Trying to eagerly connect to your Solana wallet, but seems its instance is not available.");
        try {
            return !!await e.connect({
                onlyIfTrusted: !0
            });
        } catch  {
            return !1;
        }
    };
}
$3b5535826a909102$var$t($3b5535826a909102$var$X, "canEagerConnect");
var $3b5535826a909102$export$11949c6f5fba7dcd = {};
$3b5535826a909102$var$r($3b5535826a909102$export$11949c6f5fba7dcd, {
    changeAccountSubscriber: ()=>$3b5535826a909102$var$q
});
function $3b5535826a909102$var$q(n) {
    return $3b5535826a909102$export$aea8daed5328d69c.changeAccountSubscriber(n).build();
}
$3b5535826a909102$var$t($3b5535826a909102$var$q, "changeAccountSubscriber");
var $3b5535826a909102$export$742acabee3dd6465 = {};
$3b5535826a909102$var$r($3b5535826a909102$export$742acabee3dd6465, {
    recommended: ()=>$3b5535826a909102$var$Q
});
function $3b5535826a909102$var$l(n) {
    let [, e] = n.state();
    e("connecting", !1);
}
$3b5535826a909102$var$t($3b5535826a909102$var$l, "intoConnectionFinished");
var $3b5535826a909102$var$x = [
    [
        "connect",
        $3b5535826a909102$var$l
    ]
];
var $3b5535826a909102$var$Q = [
    ...$3b5535826a909102$var$x
];
var $3b5535826a909102$export$21c0ac7fe1cef1b8 = {};
$3b5535826a909102$var$r($3b5535826a909102$export$21c0ac7fe1cef1b8, {
    recommended: ()=>$3b5535826a909102$var$ae
});
var $3b5535826a909102$var$s = class {
    static{
        $3b5535826a909102$var$t(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #o = new Map;
    #n = new Map;
    #r;
    constructor(e){
        this.name = e;
    }
    and(e) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(e), this;
    }
    or(e) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(e), this;
    }
    before(e) {
        return this.#n.has(this.name) || this.#n.set(this.name, []), this.#n.get(this.name)?.push(e), this;
    }
    after(e) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(e), this;
    }
    action(e) {
        return this.#r = e, this;
    }
    build() {
        if (!this.#r) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#r,
            before: this.#n,
            after: this.#o,
            and: this.#e,
            or: this.#t
        };
    }
};
var $3b5535826a909102$var$c = class {
    static{
        $3b5535826a909102$var$t(this, "ChangeAccountSubscriberBuilder");
    }
    #e = null;
    #t = null;
    #o = null;
    #n = null;
    #r = null;
    getInstance(e) {
        return this.#e = e, this;
    }
    format(e) {
        return this.#t = e, this;
    }
    onSwitchAccount(e) {
        return this.#o = e, this;
    }
    addEventListener(e) {
        return this.#n = e, this;
    }
    removeEventListener(e) {
        return this.#r = e, this;
    }
    build() {
        if (this.#e === null) throw new Error(this.#s("getInstance"));
        if (this.#t === null) throw new Error(this.#s("format"));
        if (this.#n === null) throw new Error(this.#s("addEventListener"));
        if (this.#r === null) throw new Error(this.#s("removeEventListener"));
        let e = this.#e, o = this.#t, _ = this.#n, H = this.#r, U = this.#o, f, d;
        return [
            async (v)=>{
                let [, y] = v.state(), i = e();
                if (!i) throw new Error("Trying to subscribe to your wallet, but seems its instance is not available.");
                f = $3b5535826a909102$var$t(async (N)=>{
                    let P = !0;
                    U?.({
                        payload: N,
                        preventDefault: ()=>{
                            P = !1;
                        }
                    }, v), P && y("accounts", await o(i, N));
                }, "subscriber"), d = _(i, f);
            },
            (v, y)=>{
                d && typeof d == "function" && d();
                let i = e();
                return H(i, f), y;
            }
        ];
    }
    #s(e) {
        return `Required "${e}" operation has not been set for "changeAccountSubscriber"`;
    }
};
function $3b5535826a909102$var$K(n) {
    try {
        return (0, $3ca9q.AccountId).parse(n), !0;
    } catch  {
        return !1;
    }
}
$3b5535826a909102$var$t($3b5535826a909102$var$K, "isValidCaipAddress");
function $3b5535826a909102$var$p(n, e) {
    if (!e.every($3b5535826a909102$var$K)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e}`);
    let [, o] = n.state();
    return o("accounts", e), o("connected", !0), e;
}
$3b5535826a909102$var$t($3b5535826a909102$var$p, "connectAndUpdateStateForSingleNetwork");
function $3b5535826a909102$var$h(n) {
    let [, e] = n.state();
    e("connecting", !0);
}
$3b5535826a909102$var$t($3b5535826a909102$var$h, "intoConnecting");
var $3b5535826a909102$var$w = [
    [
        "connect",
        $3b5535826a909102$var$h
    ]
];
var $3b5535826a909102$var$ae = [
    [
        "connect",
        $3b5535826a909102$var$p
    ]
];
var $3b5535826a909102$export$1c4c1e3098bf5ebe = {};
$3b5535826a909102$var$r($3b5535826a909102$export$1c4c1e3098bf5ebe, {
    recommended: ()=>$3b5535826a909102$var$ce
});
var $3b5535826a909102$var$ce = [
    ...$3b5535826a909102$var$w
];
var $3b5535826a909102$export$aea8daed5328d69c = {};
$3b5535826a909102$var$r($3b5535826a909102$export$aea8daed5328d69c, {
    changeAccountSubscriber: ()=>$3b5535826a909102$var$de,
    connect: ()=>$3b5535826a909102$var$pe
});
var $3b5535826a909102$var$pe = $3b5535826a909102$var$t(()=>new $3b5535826a909102$var$s("connect").and($3b5535826a909102$var$p).before($3b5535826a909102$var$h).after($3b5535826a909102$var$l), "connect"), $3b5535826a909102$var$de = $3b5535826a909102$var$t((n)=>new $3b5535826a909102$var$c().getInstance(n).onSwitchAccount((e, o)=>{
        e.payload || (o.action("disconnect"), e.preventDefault());
    }).format(async (e, o)=>$3b5535826a909102$var$a([
            o
        ])).addEventListener((e, o)=>{
        e.on("accountChanged", o);
    }).removeEventListener((e, o)=>{
        e.off("accountChanged", o);
    }), "changeAccountSubscriber");




const [$218463a92ca54dd5$var$changeAccountSubscriber, $218463a92ca54dd5$var$changeAccountCleanup] = (0, $3b5535826a909102$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $2fa974c7dc6564de$export$52654fdde2b90b57));
const $218463a92ca54dd5$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $3b5535826a909102$export$e324594224ef24da).connect((0, $2fa974c7dc6564de$export$52654fdde2b90b57))).before($218463a92ca54dd5$var$changeAccountSubscriber).or($218463a92ca54dd5$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $218463a92ca54dd5$var$disconnect = (0, $f59Be.builders).disconnect().after($218463a92ca54dd5$var$changeAccountCleanup).build();
const $218463a92ca54dd5$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $3b5535826a909102$export$e324594224ef24da).canEagerConnect((0, $2fa974c7dc6564de$export$52654fdde2b90b57))).build();
const $218463a92ca54dd5$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $ee636cc34c349920$export$7c460c214963f696)).action($218463a92ca54dd5$var$connect).action($218463a92ca54dd5$var$disconnect).action($218463a92ca54dd5$var$canEagerConnect).build();



const $1f8fd58bcb1aa759$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $ee636cc34c349920$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $2fa974c7dc6564de$export$55900a4725b84e07)()) {
            setState('installed', true);
            console.debug('[brave] instance detected.', context);
        }
    }).config('metadata', (0, $ee636cc34c349920$export$dbb5e893e736e4ee)).add('solana', (0, $218463a92ca54dd5$export$ee6400bf8f8c2a0d)).add('evm', (0, $a5fa00f2bd9aef3e$export$2f7490c34b49803e)).build();


const $4b9b50c2c639efa4$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $1f8fd58bcb1aa759$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $4tkSS = parcelRequire("4tkSS");

var $ihoyg = parcelRequire("ihoyg");

var $evN8c = parcelRequire("evN8c");

var $7vYz3 = parcelRequire("7vYz3");
var $bda1ba034b4c2cde$exports = {};

var $kG2My = parcelRequire("kG2My");
var $bda1ba034b4c2cde$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
$bda1ba034b4c2cde$exports = $kG2My($bda1ba034b4c2cde$var$ALPHABET);


function $1d20e36ed6262e72$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $1d20e36ed6262e72$export$87b259aa03e3d267(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
function $1d20e36ed6262e72$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
function $1d20e36ed6262e72$export$b3317979f9250576(b, ...lengths) {
    if (!$1d20e36ed6262e72$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $1d20e36ed6262e72$export$d6af199866bfb566(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $1d20e36ed6262e72$export$98e628dec113755e(h.outputLen);
    $1d20e36ed6262e72$export$98e628dec113755e(h.blockLen);
}
function $1d20e36ed6262e72$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $1d20e36ed6262e72$export$c789db2c85949867(out, instance) {
    $1d20e36ed6262e72$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $1d20e36ed6262e72$var$assert = {
    number: $1d20e36ed6262e72$export$98e628dec113755e,
    bool: $1d20e36ed6262e72$export$87b259aa03e3d267,
    bytes: $1d20e36ed6262e72$export$b3317979f9250576,
    hash: $1d20e36ed6262e72$export$d6af199866bfb566,
    exists: $1d20e36ed6262e72$export$f7e9f41ea797a17,
    output: $1d20e36ed6262e72$export$c789db2c85949867
};
var $1d20e36ed6262e72$export$2e2bcd8739ae039 = $1d20e36ed6262e72$var$assert;


/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $8678caa289c04941$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;



function $9fae005a6aeab423$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
const $9fae005a6aeab423$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $9fae005a6aeab423$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $9fae005a6aeab423$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $9fae005a6aeab423$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $9fae005a6aeab423$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $9fae005a6aeab423$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $9fae005a6aeab423$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $9fae005a6aeab423$export$4a0a88cc2d284e7f = $9fae005a6aeab423$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$9fae005a6aeab423$export$a4170f7f8be47425(n);
function $9fae005a6aeab423$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $9fae005a6aeab423$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $9fae005a6aeab423$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $9fae005a6aeab423$export$58b867e287a802c8(bytes) {
    (0, $1d20e36ed6262e72$export$b3317979f9250576)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $9fae005a6aeab423$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $9fae005a6aeab423$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $9fae005a6aeab423$var$asciiToBase16(char) {
    if (char >= $9fae005a6aeab423$var$asciis._0 && char <= $9fae005a6aeab423$var$asciis._9) return char - $9fae005a6aeab423$var$asciis._0;
    if (char >= $9fae005a6aeab423$var$asciis._A && char <= $9fae005a6aeab423$var$asciis._F) return char - ($9fae005a6aeab423$var$asciis._A - 10);
    if (char >= $9fae005a6aeab423$var$asciis._a && char <= $9fae005a6aeab423$var$asciis._f) return char - ($9fae005a6aeab423$var$asciis._a - 10);
    return;
}
function $9fae005a6aeab423$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $9fae005a6aeab423$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $9fae005a6aeab423$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $9fae005a6aeab423$export$bdd553fddd433dcb = async ()=>{};
async function $9fae005a6aeab423$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $9fae005a6aeab423$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $9fae005a6aeab423$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $9fae005a6aeab423$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $9fae005a6aeab423$export$3df70a15530b5e81(data);
    (0, $1d20e36ed6262e72$export$b3317979f9250576)(data);
    return data;
}
function $9fae005a6aeab423$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $1d20e36ed6262e72$export$b3317979f9250576)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $9fae005a6aeab423$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $9fae005a6aeab423$var$toStr = {}.toString;
function $9fae005a6aeab423$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $9fae005a6aeab423$var$toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $9fae005a6aeab423$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($9fae005a6aeab423$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $9fae005a6aeab423$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($9fae005a6aeab423$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $9fae005a6aeab423$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($9fae005a6aeab423$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $9fae005a6aeab423$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $8678caa289c04941$export$7effb53edfc7fa2d) && typeof (0, $8678caa289c04941$export$7effb53edfc7fa2d).getRandomValues === 'function') return (0, $8678caa289c04941$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}


// Polyfill for Safari 14
function $63c4b87468151962$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $63c4b87468151962$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $63c4b87468151962$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $63c4b87468151962$export$f9f830659f932cb2 extends (0, $9fae005a6aeab423$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9fae005a6aeab423$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $1d20e36ed6262e72$export$f7e9f41ea797a17)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $9fae005a6aeab423$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9fae005a6aeab423$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $1d20e36ed6262e72$export$f7e9f41ea797a17)(this);
        (0, $1d20e36ed6262e72$export$c789db2c85949867)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $63c4b87468151962$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9fae005a6aeab423$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $146966cdd8c8322e$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $146966cdd8c8322e$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $146966cdd8c8322e$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $146966cdd8c8322e$var$SHA256 extends (0, $63c4b87468151962$export$f9f830659f932cb2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $146966cdd8c8322e$var$SHA256_IV[0] | 0;
        this.B = $146966cdd8c8322e$var$SHA256_IV[1] | 0;
        this.C = $146966cdd8c8322e$var$SHA256_IV[2] | 0;
        this.D = $146966cdd8c8322e$var$SHA256_IV[3] | 0;
        this.E = $146966cdd8c8322e$var$SHA256_IV[4] | 0;
        this.F = $146966cdd8c8322e$var$SHA256_IV[5] | 0;
        this.G = $146966cdd8c8322e$var$SHA256_IV[6] | 0;
        this.H = $146966cdd8c8322e$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$146966cdd8c8322e$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $146966cdd8c8322e$var$SHA256_W[i - 15];
            const W2 = $146966cdd8c8322e$var$SHA256_W[i - 2];
            const s0 = (0, $9fae005a6aeab423$export$466993d7d0d272aa)(W15, 7) ^ (0, $9fae005a6aeab423$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $9fae005a6aeab423$export$466993d7d0d272aa)(W2, 17) ^ (0, $9fae005a6aeab423$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $146966cdd8c8322e$var$SHA256_W[i] = s1 + $146966cdd8c8322e$var$SHA256_W[i - 7] + s0 + $146966cdd8c8322e$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $9fae005a6aeab423$export$466993d7d0d272aa)(E, 6) ^ (0, $9fae005a6aeab423$export$466993d7d0d272aa)(E, 11) ^ (0, $9fae005a6aeab423$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $63c4b87468151962$export$d0d97f016526eaf0)(E, F, G) + $146966cdd8c8322e$var$SHA256_K[i] + $146966cdd8c8322e$var$SHA256_W[i] | 0;
            const sigma0 = (0, $9fae005a6aeab423$export$466993d7d0d272aa)(A, 2) ^ (0, $9fae005a6aeab423$export$466993d7d0d272aa)(A, 13) ^ (0, $9fae005a6aeab423$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $63c4b87468151962$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $146966cdd8c8322e$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $146966cdd8c8322e$var$SHA224 extends $146966cdd8c8322e$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $146966cdd8c8322e$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $9fae005a6aeab423$export$f081816339df1972)(()=>new $146966cdd8c8322e$var$SHA256());
const $146966cdd8c8322e$export$97b70509d4e397ea = /* @__PURE__ */ (0, $9fae005a6aeab423$export$f081816339df1972)(()=>new $146966cdd8c8322e$var$SHA224());



var $4xx4u = parcelRequire("4xx4u");

var $3wEH9 = parcelRequire("3wEH9");

var $gbKvo = parcelRequire("gbKvo");
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $e87afc78b8edabee$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join('.') + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $e87afc78b8edabee$var$isIterable(x) {
    return $e87afc78b8edabee$var$isObject(x) && typeof x[Symbol.iterator] === 'function';
}
/**
 * Check if a value is a plain object.
 */ function $e87afc78b8edabee$var$isObject(x) {
    return typeof x === 'object' && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $e87afc78b8edabee$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $e87afc78b8edabee$var$print(value) {
    return typeof value === 'string' ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $e87afc78b8edabee$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $e87afc78b8edabee$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === 'string') result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : '') + ", but received: `" + $e87afc78b8edabee$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $e87afc78b8edabee$var$toFailures(result, context, struct, value) {
    if (!$e87afc78b8edabee$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $e87afc78b8edabee$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $e87afc78b8edabee$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== 'type' && $e87afc78b8edabee$var$isObject(struct.schema) && $e87afc78b8edabee$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $e87afc78b8edabee$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($e87afc78b8edabee$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $e87afc78b8edabee$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $e87afc78b8edabee$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $e87afc78b8edabee$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $e87afc78b8edabee$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $e87afc78b8edabee$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $e87afc78b8edabee$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $e87afc78b8edabee$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $e87afc78b8edabee$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $e87afc78b8edabee$export$a7a9523472993e97(value, struct) {
    const result = $e87afc78b8edabee$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $e87afc78b8edabee$export$185802fd694ee1f5(value, struct) {
    const result = $e87afc78b8edabee$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $e87afc78b8edabee$export$d99f0801a68bbcf1(value, struct) {
    const result = $e87afc78b8edabee$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $e87afc78b8edabee$export$226b3eccf92c9ed9(value, struct) {
    const result = $e87afc78b8edabee$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $e87afc78b8edabee$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $e87afc78b8edabee$var$run(value, struct, options);
    const tuple = $e87afc78b8edabee$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $e87afc78b8edabee$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $e87afc78b8edabee$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $e87afc78b8edabee$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $e87afc78b8edabee$export$f36d6a7a5c09a23e(name, validator) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $e87afc78b8edabee$export$cdd73fc4100a6ef4(struct, log) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $e87afc78b8edabee$export$7077912c31975674(fn) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'dynamic',
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $e87afc78b8edabee$export$488013bae63b21da(fn) {
    let struct;
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'lazy',
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $e87afc78b8edabee$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $e87afc78b8edabee$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $e87afc78b8edabee$export$e45945969df8035a(struct) {
    const schema = struct instanceof $e87afc78b8edabee$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $e87afc78b8edabee$export$516e28dec6a4b6d4(schema[key]);
    return $e87afc78b8edabee$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $e87afc78b8edabee$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $e87afc78b8edabee$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $e87afc78b8edabee$export$8cf3da7c1c9174ea(name, validator) {
    console.warn('superstruct@0.11 - The `struct` helper has been renamed to `define`.');
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $e87afc78b8edabee$export$4154a199d7d90455() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('any', ()=>true);
}
function $e87afc78b8edabee$export$2f23118c22fb2630(Element) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'array',
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $e87afc78b8edabee$export$4a21f16c33752377() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('boolean', (value)=>{
        return typeof value === 'boolean';
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $e87afc78b8edabee$export$324d90190a8b822a() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('date', (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $e87afc78b8edabee$var$print(value);
    });
}
function $e87afc78b8edabee$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$e87afc78b8edabee$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'enums',
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $e87afc78b8edabee$export$86951950244e2001() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('func', (value)=>{
        return typeof value === 'function' || "Expected a function, but received: " + $e87afc78b8edabee$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $e87afc78b8edabee$export$9544d5bb712b01ea(Class) {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('instance', (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $e87afc78b8edabee$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $e87afc78b8edabee$export$32744b5b3bba4764() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('integer', (value)=>{
        return typeof value === 'number' && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $e87afc78b8edabee$var$print(value);
    });
}
function $e87afc78b8edabee$export$bc86dfbf7795668c(Structs) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'intersection',
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $e87afc78b8edabee$export$c8ec6e1ec9fefcb0(constant) {
    const description = $e87afc78b8edabee$var$print(constant);
    const t = typeof constant;
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'literal',
        schema: t === 'string' || t === 'number' || t === 'boolean' ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
function $e87afc78b8edabee$export$871de8747c9eaa88(Key, Value) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'map',
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $e87afc78b8edabee$export$b3e22bcfd64c1022() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('never', ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $e87afc78b8edabee$export$133fc36489ac9add(struct) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $e87afc78b8edabee$export$98e628dec113755e() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('number', (value)=>{
        return typeof value === 'number' && !isNaN(value) || "Expected a number, but received: " + $e87afc78b8edabee$var$print(value);
    });
}
function $e87afc78b8edabee$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $e87afc78b8edabee$export$b3e22bcfd64c1022();
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'object',
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $e87afc78b8edabee$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $e87afc78b8edabee$var$isObject(value) || "Expected an object, but received: " + $e87afc78b8edabee$var$print(value);
        },
        coercer (value) {
            return $e87afc78b8edabee$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $e87afc78b8edabee$export$516e28dec6a4b6d4(struct) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $e87afc78b8edabee$export$e5185e241753e543(Key, Value) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'record',
        schema: null,
        *entries (value) {
            if ($e87afc78b8edabee$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $e87afc78b8edabee$var$isObject(value) || "Expected an object, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $e87afc78b8edabee$export$efdc1e5bdb609bb() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('regexp', (value)=>{
        return value instanceof RegExp;
    });
}
function $e87afc78b8edabee$export$adaa4cf7ef1b65be(Element) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'set',
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $e87afc78b8edabee$export$22b082955e083ec3() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('string', (value)=>{
        return typeof value === 'string' || "Expected a string, but received: " + $e87afc78b8edabee$var$print(value);
    });
}
function $e87afc78b8edabee$export$65e3907585753458(Elements) {
    const Never = $e87afc78b8edabee$export$b3e22bcfd64c1022();
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'tuple',
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $e87afc78b8edabee$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'type',
        schema: schema,
        *entries (value) {
            if ($e87afc78b8edabee$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $e87afc78b8edabee$var$isObject(value) || "Expected an object, but received: " + $e87afc78b8edabee$var$print(value);
        }
    });
}
function $e87afc78b8edabee$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(' | ');
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        type: 'union',
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $e87afc78b8edabee$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $e87afc78b8edabee$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $e87afc78b8edabee$export$19282c40b967aec6() {
    return $e87afc78b8edabee$export$f36d6a7a5c09a23e('unknown', ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $e87afc78b8edabee$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $e87afc78b8edabee$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $e87afc78b8edabee$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $e87afc78b8edabee$export$8c14e57e778d3873(struct, $e87afc78b8edabee$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === 'function' ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $e87afc78b8edabee$var$isPlainObject(x) && $e87afc78b8edabee$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $e87afc78b8edabee$export$41f369984ed28930(struct) {
    return $e87afc78b8edabee$export$8c14e57e778d3873(struct, $e87afc78b8edabee$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $e87afc78b8edabee$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $e87afc78b8edabee$export$edc9d475108b3212(struct, 'empty', (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $e87afc78b8edabee$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $e87afc78b8edabee$export$edc9d475108b3212(struct, 'max', (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $e87afc78b8edabee$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $e87afc78b8edabee$export$edc9d475108b3212(struct, 'min', (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $e87afc78b8edabee$export$24f82734ea047e6f(struct, regexp) {
    return $e87afc78b8edabee$export$edc9d475108b3212(struct, 'pattern', (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + "/` but received \"" + value + "\"";
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $e87afc78b8edabee$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $e87afc78b8edabee$export$edc9d475108b3212(struct, 'size', (value)=>{
        if (typeof value === 'number' || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $e87afc78b8edabee$export$edc9d475108b3212(struct, name, refiner) {
    return new $e87afc78b8edabee$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $e87afc78b8edabee$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}



var $fFbWN = parcelRequire("fFbWN");

var $81012 = parcelRequire("81012");

var $6U8NG = parcelRequire("6U8NG");

const $2aba0eeae8bf01d5$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $2aba0eeae8bf01d5$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $2aba0eeae8bf01d5$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $2aba0eeae8bf01d5$var$U32_MASK64),
        l: Number(n >> $2aba0eeae8bf01d5$var$_32n & $2aba0eeae8bf01d5$var$U32_MASK64)
    };
    return {
        h: Number(n >> $2aba0eeae8bf01d5$var$_32n & $2aba0eeae8bf01d5$var$U32_MASK64) | 0,
        l: Number(n & $2aba0eeae8bf01d5$var$U32_MASK64) | 0
    };
}
function $2aba0eeae8bf01d5$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $2aba0eeae8bf01d5$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $2aba0eeae8bf01d5$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $2aba0eeae8bf01d5$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $2aba0eeae8bf01d5$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $2aba0eeae8bf01d5$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $2aba0eeae8bf01d5$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $2aba0eeae8bf01d5$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $2aba0eeae8bf01d5$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $2aba0eeae8bf01d5$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $2aba0eeae8bf01d5$export$a088d44bd387d2a3 = (_h, l)=>l;
const $2aba0eeae8bf01d5$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $2aba0eeae8bf01d5$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $2aba0eeae8bf01d5$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $2aba0eeae8bf01d5$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $2aba0eeae8bf01d5$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $2aba0eeae8bf01d5$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $2aba0eeae8bf01d5$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $2aba0eeae8bf01d5$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $2aba0eeae8bf01d5$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $2aba0eeae8bf01d5$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $2aba0eeae8bf01d5$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $2aba0eeae8bf01d5$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $2aba0eeae8bf01d5$var$u64 = {
    fromBig: $2aba0eeae8bf01d5$export$9625d4333cb56c3f,
    split: $2aba0eeae8bf01d5$export$65980d18b75784e2,
    toBig: $2aba0eeae8bf01d5$export$30f78adcaaa2eb7,
    shrSH: $2aba0eeae8bf01d5$export$75aa78dc5bd52853,
    shrSL: $2aba0eeae8bf01d5$export$a0225ff0aee14e25,
    rotrSH: $2aba0eeae8bf01d5$export$97f812dfd830ca87,
    rotrSL: $2aba0eeae8bf01d5$export$60987e30e2c9d9d,
    rotrBH: $2aba0eeae8bf01d5$export$af9c7fbac44dcb76,
    rotrBL: $2aba0eeae8bf01d5$export$f619171d6d5ac414,
    rotr32H: $2aba0eeae8bf01d5$export$a088d44bd387d2a3,
    rotr32L: $2aba0eeae8bf01d5$export$8415aae4d1f69577,
    rotlSH: $2aba0eeae8bf01d5$export$4b80a2917447870e,
    rotlSL: $2aba0eeae8bf01d5$export$20652918a7b63b3,
    rotlBH: $2aba0eeae8bf01d5$export$a52f14bf902f9977,
    rotlBL: $2aba0eeae8bf01d5$export$5d12cc1da441323f,
    add: $2aba0eeae8bf01d5$export$e16d8520af44a096,
    add3L: $2aba0eeae8bf01d5$export$c0c22b91f08911f,
    add3H: $2aba0eeae8bf01d5$export$ef7b26044977a8ec,
    add4L: $2aba0eeae8bf01d5$export$2f4e199c560f545d,
    add4H: $2aba0eeae8bf01d5$export$e909220d675a7741,
    add5H: $2aba0eeae8bf01d5$export$b45ee8d78c965098,
    add5L: $2aba0eeae8bf01d5$export$d732b061fe9c9ae4
};
var $2aba0eeae8bf01d5$export$2e2bcd8739ae039 = $2aba0eeae8bf01d5$var$u64;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $0e93aae1090a8d90$var$SHA3_PI = [];
const $0e93aae1090a8d90$var$SHA3_ROTL = [];
const $0e93aae1090a8d90$var$_SHA3_IOTA = [];
const $0e93aae1090a8d90$var$_0n = /* @__PURE__ */ BigInt(0);
const $0e93aae1090a8d90$var$_1n = /* @__PURE__ */ BigInt(1);
const $0e93aae1090a8d90$var$_2n = /* @__PURE__ */ BigInt(2);
const $0e93aae1090a8d90$var$_7n = /* @__PURE__ */ BigInt(7);
const $0e93aae1090a8d90$var$_256n = /* @__PURE__ */ BigInt(256);
const $0e93aae1090a8d90$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $0e93aae1090a8d90$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $0e93aae1090a8d90$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $0e93aae1090a8d90$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $0e93aae1090a8d90$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $0e93aae1090a8d90$var$_1n ^ (R >> $0e93aae1090a8d90$var$_7n) * $0e93aae1090a8d90$var$_0x71n) % $0e93aae1090a8d90$var$_256n;
        if (R & $0e93aae1090a8d90$var$_2n) t ^= $0e93aae1090a8d90$var$_1n << ($0e93aae1090a8d90$var$_1n << /* @__PURE__ */ BigInt(j)) - $0e93aae1090a8d90$var$_1n;
    }
    $0e93aae1090a8d90$var$_SHA3_IOTA.push(t);
}
const [$0e93aae1090a8d90$var$SHA3_IOTA_H, $0e93aae1090a8d90$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $2aba0eeae8bf01d5$export$65980d18b75784e2)($0e93aae1090a8d90$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $0e93aae1090a8d90$var$rotlH = (h, l, s)=>s > 32 ? (0, $2aba0eeae8bf01d5$export$a52f14bf902f9977)(h, l, s) : (0, $2aba0eeae8bf01d5$export$4b80a2917447870e)(h, l, s);
const $0e93aae1090a8d90$var$rotlL = (h, l, s)=>s > 32 ? (0, $2aba0eeae8bf01d5$export$5d12cc1da441323f)(h, l, s) : (0, $2aba0eeae8bf01d5$export$20652918a7b63b3)(h, l, s);
function $0e93aae1090a8d90$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $0e93aae1090a8d90$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $0e93aae1090a8d90$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $0e93aae1090a8d90$var$SHA3_ROTL[t];
            const Th = $0e93aae1090a8d90$var$rotlH(curH, curL, shift);
            const Tl = $0e93aae1090a8d90$var$rotlL(curH, curL, shift);
            const PI = $0e93aae1090a8d90$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $0e93aae1090a8d90$var$SHA3_IOTA_H[round];
        s[1] ^= $0e93aae1090a8d90$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $0e93aae1090a8d90$export$f7374b8b4498bc2e extends (0, $9fae005a6aeab423$export$ab85ecd77ce6a5cd) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $1d20e36ed6262e72$export$98e628dec113755e)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = (0, $9fae005a6aeab423$export$8bacf4ad828c7fe7)(this.state);
    }
    keccak() {
        if (!(0, $9fae005a6aeab423$export$a0f88e38d4cf9577)) (0, $9fae005a6aeab423$export$97b40fc37f25d711)(this.state32);
        $0e93aae1090a8d90$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $9fae005a6aeab423$export$a0f88e38d4cf9577)) (0, $9fae005a6aeab423$export$97b40fc37f25d711)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $1d20e36ed6262e72$export$f7e9f41ea797a17)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $9fae005a6aeab423$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $1d20e36ed6262e72$export$f7e9f41ea797a17)(this, false);
        (0, $1d20e36ed6262e72$export$b3317979f9250576)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $1d20e36ed6262e72$export$98e628dec113755e)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $1d20e36ed6262e72$export$c789db2c85949867)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $0e93aae1090a8d90$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $0e93aae1090a8d90$var$gen = (suffix, blockLen, outputLen)=>(0, $9fae005a6aeab423$export$f081816339df1972)(()=>new $0e93aae1090a8d90$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $0e93aae1090a8d90$export$fe6c2b96a79338e9 = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x06, 144, 28);
const $0e93aae1090a8d90$export$76e19b6966813b14 = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x06, 136, 32);
const $0e93aae1090a8d90$export$a58509fa80f30d15 = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x06, 104, 48);
const $0e93aae1090a8d90$export$20ed324dbdf09b7c = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x06, 72, 64);
const $0e93aae1090a8d90$export$2f7fb3c6fac246bc = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x01, 144, 28);
const $0e93aae1090a8d90$export$860ddaa9ca84a66d = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x01, 136, 32);
const $0e93aae1090a8d90$export$46fcdeb4c5686552 = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x01, 104, 48);
const $0e93aae1090a8d90$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $0e93aae1090a8d90$var$gen(0x01, 72, 64);
const $0e93aae1090a8d90$var$genShake = (suffix, blockLen, outputLen)=>(0, $9fae005a6aeab423$export$e18964dbd6e083c1)((opts = {})=>new $0e93aae1090a8d90$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $0e93aae1090a8d90$export$f43dc3bb86efbba2 = /* @__PURE__ */ $0e93aae1090a8d90$var$genShake(0x1f, 168, 16);
const $0e93aae1090a8d90$export$c240d011f1520440 = /* @__PURE__ */ $0e93aae1090a8d90$var$genShake(0x1f, 136, 32);



var $75Cpc = parcelRequire("75Cpc");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $d29309e4a0887ac0$var$generatePrivateKey = (0, $evN8c.ed25519).utils.randomPrivateKey;
const $d29309e4a0887ac0$var$generateKeypair = ()=>{
    const privateScalar = (0, $evN8c.ed25519).utils.randomPrivateKey();
    const publicKey = $d29309e4a0887ac0$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $d29309e4a0887ac0$var$getPublicKey = (0, $evN8c.ed25519).getPublicKey;
function $d29309e4a0887ac0$var$isOnCurve(publicKey) {
    try {
        (0, $evN8c.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $d29309e4a0887ac0$var$sign = (message, secretKey)=>(0, $evN8c.ed25519).sign(message, secretKey.slice(0, 32));
const $d29309e4a0887ac0$var$verify = (0, $evN8c.ed25519).verify;
const $d29309e4a0887ac0$var$toBuffer = (arr)=>{
    if ((0, $ihoyg.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $ihoyg.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $ihoyg.Buffer).from(arr);
};
// Class wrapping a plain object
class $d29309e4a0887ac0$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $ihoyg.Buffer).from((0, $4xx4u.serialize)($d29309e4a0887ac0$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $4xx4u.deserialize)($d29309e4a0887ac0$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $4xx4u.deserializeUnchecked)($d29309e4a0887ac0$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $d29309e4a0887ac0$export$deb82508dd66d288 extends $d29309e4a0887ac0$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = '';
        if (Object.keys(properties).length !== 1) throw new Error('Enum can only take single value');
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $d29309e4a0887ac0$export$68d13ce9b4cc48f3 = new Map();
var $d29309e4a0887ac0$var$_class;
let $d29309e4a0887ac0$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $d29309e4a0887ac0$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $d29309e4a0887ac0$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $d29309e4a0887ac0$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $d29309e4a0887ac0$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $d29309e4a0887ac0$var$_Symbol$toStringTag = Symbol.toStringTag;
class $d29309e4a0887ac0$export$ca8b6604d6ce14de extends $d29309e4a0887ac0$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($d29309e4a0887ac0$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === 'string') {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(value);
                if (decoded.length != $d29309e4a0887ac0$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(value);
            if (this._bn.byteLength() > $d29309e4a0887ac0$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $d29309e4a0887ac0$export$ca8b6604d6ce14de($d29309e4a0887ac0$var$uniquePublicKeyCounter);
        $d29309e4a0887ac0$var$uniquePublicKeyCounter += 1;
        return new $d29309e4a0887ac0$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $ihoyg.Buffer));
        if (b.length === $d29309e4a0887ac0$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $ihoyg.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$d29309e4a0887ac0$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $ihoyg.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $ihoyg.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $146966cdd8c8322e$export$bced8d2aada2d1c9)(buffer);
        return new $d29309e4a0887ac0$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $ihoyg.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $d29309e4a0887ac0$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $ihoyg.Buffer).concat([
                buffer,
                $d29309e4a0887ac0$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $ihoyg.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $ihoyg.Buffer).from('ProgramDerivedAddress')
        ]);
        const publicKeyBytes = (0, $146966cdd8c8322e$export$bced8d2aada2d1c9)(buffer);
        if ($d29309e4a0887ac0$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $d29309e4a0887ac0$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $ihoyg.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $d29309e4a0887ac0$export$ca8b6604d6ce14de(pubkeyData);
        return $d29309e4a0887ac0$var$isOnCurve(pubkey.toBytes());
    }
}
$d29309e4a0887ac0$var$_class = $d29309e4a0887ac0$export$ca8b6604d6ce14de;
$d29309e4a0887ac0$export$ca8b6604d6ce14de.default = new $d29309e4a0887ac0$var$_class('11111111111111111111111111111111');
$d29309e4a0887ac0$export$68d13ce9b4cc48f3.set($d29309e4a0887ac0$export$ca8b6604d6ce14de, {
    kind: 'struct',
    fields: [
        [
            '_bn',
            'u256'
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $d29309e4a0887ac0$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $d29309e4a0887ac0$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error('bad secret key size');
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $d29309e4a0887ac0$var$toBuffer($d29309e4a0887ac0$var$generatePrivateKey());
            this._publicKey = $d29309e4a0887ac0$var$toBuffer($d29309e4a0887ac0$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $d29309e4a0887ac0$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $ihoyg.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $d29309e4a0887ac0$export$42bd37c1c64962b6 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('BPFLoader1111111111111111111111111111111111');
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $d29309e4a0887ac0$export$4c6d5b89e1596f26 = 1232;
const $d29309e4a0887ac0$export$3c3793d809f8b858 = 0x7f;
const $d29309e4a0887ac0$export$14aee086fde78fa6 = 64;
class $d29309e4a0887ac0$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($d29309e4a0887ac0$export$718fcd78527f88ed.prototype, 'name', {
    value: 'TransactionExpiredBlockheightExceededError'
});
class $d29309e4a0887ac0$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + 'unknown if it succeeded or failed. Check signature ' + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($d29309e4a0887ac0$export$b822204c22e46bdf.prototype, 'name', {
    value: 'TransactionExpiredTimeoutError'
});
class $d29309e4a0887ac0$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($d29309e4a0887ac0$export$a3e7565a95f5a1e5.prototype, 'name', {
    value: 'TransactionExpiredNonceInvalidError'
});
class $d29309e4a0887ac0$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error('Account index overflow encountered during compilation');
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error('Encountered an unknown instruction account key during compilation');
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $d29309e4a0887ac0$var$publicKey = (property = 'publicKey')=>{
    return $3wEH9.blob(32, property);
};
/**
 * Layout for a signature
 */ const $d29309e4a0887ac0$var$signature = (property = 'signature')=>{
    return $3wEH9.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $d29309e4a0887ac0$var$rustString = (property = 'string')=>{
    const rsl = $3wEH9.struct([
        $3wEH9.u32('length'),
        $3wEH9.u32('lengthPadding'),
        $3wEH9.blob($3wEH9.offset($3wEH9.u32(), -8), 'chars')
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data['chars'].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $ihoyg.Buffer).from(str, 'utf8')
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $3wEH9.u32().span + $3wEH9.u32().span + (0, $ihoyg.Buffer).from(str, 'utf8').length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $d29309e4a0887ac0$var$authorized = (property = 'authorized')=>{
    return $3wEH9.struct([
        $d29309e4a0887ac0$var$publicKey('staker'),
        $d29309e4a0887ac0$var$publicKey('withdrawer')
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $d29309e4a0887ac0$var$lockup = (property = 'lockup')=>{
    return $3wEH9.struct([
        $3wEH9.ns64('unixTimestamp'),
        $3wEH9.ns64('epoch'),
        $d29309e4a0887ac0$var$publicKey('custodian')
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $d29309e4a0887ac0$var$voteInit = (property = 'voteInit')=>{
    return $3wEH9.struct([
        $d29309e4a0887ac0$var$publicKey('nodePubkey'),
        $d29309e4a0887ac0$var$publicKey('authorizedVoter'),
        $d29309e4a0887ac0$var$publicKey('authorizedWithdrawer'),
        $3wEH9.u8('commission')
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $d29309e4a0887ac0$var$voteAuthorizeWithSeedArgs = (property = 'voteAuthorizeWithSeedArgs')=>{
    return $3wEH9.struct([
        $3wEH9.u32('voteAuthorizationType'),
        $d29309e4a0887ac0$var$publicKey('currentAuthorityDerivedKeyOwnerPubkey'),
        $d29309e4a0887ac0$var$rustString('currentAuthorityDerivedKeySeed'),
        $d29309e4a0887ac0$var$publicKey('newAuthorized')
    ], property);
};
function $d29309e4a0887ac0$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === 'function') return item.alloc(fields[item.property]);
        else if ('count' in item && 'elementLayout' in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ('fields' in item) // This is a `Structure` whose size needs to be recursively measured.
        return $d29309e4a0887ac0$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $d29309e4a0887ac0$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $d29309e4a0887ac0$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $d29309e4a0887ac0$var$assert(condition, message) {
    if (!condition) throw new Error(message || 'Assertion failed');
}
class $d29309e4a0887ac0$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $d29309e4a0887ac0$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $d29309e4a0887ac0$var$assert(mapEntries.length <= 256, 'Max static account keys length exceeded');
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $d29309e4a0887ac0$var$assert(writableSigners.length > 0, 'Expected at least one writable signer key');
            const [payerAddress] = writableSigners[0];
            $d29309e4a0887ac0$var$assert(payerAddress === this.payer.toBase58(), 'Expected first writable signer key to be the fee payer');
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $d29309e4a0887ac0$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $d29309e4a0887ac0$var$assert(lookupTableIndex < 256, 'Max lookup table index exceeded');
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $d29309e4a0887ac0$var$END_OF_BUFFER_ERROR_MESSAGE = 'Reached end of buffer unexpectedly';
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $d29309e4a0887ac0$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($d29309e4a0887ac0$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $d29309e4a0887ac0$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($d29309e4a0887ac0$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $d29309e4a0887ac0$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return 'legacy';
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $d29309e4a0887ac0$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $d29309e4a0887ac0$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $d29309e4a0887ac0$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode(ix.data)
            }));
        return new $d29309e4a0887ac0$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $d29309e4a0887ac0$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(instruction.data));
            let keyIndicesCount = [];
            $d29309e4a0887ac0$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $d29309e4a0887ac0$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $ihoyg.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $ihoyg.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $d29309e4a0887ac0$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $ihoyg.Buffer).alloc($d29309e4a0887ac0$export$4c6d5b89e1596f26);
        (0, $ihoyg.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $3wEH9.struct([
                $3wEH9.u8('programIdIndex'),
                $3wEH9.blob(instruction.keyIndicesCount.length, 'keyIndicesCount'),
                $3wEH9.seq($3wEH9.u8('keyIndex'), instruction.keyIndices.length, 'keyIndices'),
                $3wEH9.blob(instruction.dataLength.length, 'dataLength'),
                $3wEH9.seq($3wEH9.u8('userdatum'), instruction.data.length, 'data')
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $3wEH9.struct([
            $3wEH9.blob(1, 'numRequiredSignatures'),
            $3wEH9.blob(1, 'numReadonlySignedAccounts'),
            $3wEH9.blob(1, 'numReadonlyUnsignedAccounts'),
            $3wEH9.blob(keyCount.length, 'keyCount'),
            $3wEH9.seq($d29309e4a0887ac0$var$publicKey('key'), numKeys, 'keys'),
            $d29309e4a0887ac0$var$publicKey('recentBlockhash')
        ]);
        const transaction = {
            numRequiredSignatures: (0, $ihoyg.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $ihoyg.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $ihoyg.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $ihoyg.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$d29309e4a0887ac0$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(this.recentBlockhash)
        };
        let signData = (0, $ihoyg.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $d29309e4a0887ac0$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $d29309e4a0887ac0$export$3c3793d809f8b858)) throw new Error('Versioned messages must be deserialized with VersionedMessage.deserialize()');
        const numReadonlySignedAccounts = $d29309e4a0887ac0$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $d29309e4a0887ac0$var$guardedShift(byteArray);
        const accountCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$84fc0a248cc54343);
            accountKeys.push(new $d29309e4a0887ac0$export$ca8b6604d6ce14de((0, $ihoyg.Buffer).from(account)));
        }
        const recentBlockhash = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$84fc0a248cc54343);
        const instructionCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $d29309e4a0887ac0$var$guardedShift(byteArray);
            const accountCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
            const accounts = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
            const dataSlice = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode((0, $ihoyg.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode((0, $ihoyg.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $d29309e4a0887ac0$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $d29309e4a0887ac0$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && 'accountKeysFromLookups' in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error('Failed to get account keys because of a mismatch in the number of account keys from lookups');
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && 'addressLookupTableAccounts' in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error('Failed to get account keys because address table lookups were not resolved');
        return new $d29309e4a0887ac0$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $d29309e4a0887ac0$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $d29309e4a0887ac0$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $d29309e4a0887ac0$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $d29309e4a0887ac0$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $d29309e4a0887ac0$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $d29309e4a0887ac0$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $3wEH9.struct([
            $3wEH9.u8('prefix'),
            $3wEH9.struct([
                $3wEH9.u8('numRequiredSignatures'),
                $3wEH9.u8('numReadonlySignedAccounts'),
                $3wEH9.u8('numReadonlyUnsignedAccounts')
            ], 'header'),
            $3wEH9.blob(encodedStaticAccountKeysLength.length, 'staticAccountKeysLength'),
            $3wEH9.seq($d29309e4a0887ac0$var$publicKey(), this.staticAccountKeys.length, 'staticAccountKeys'),
            $d29309e4a0887ac0$var$publicKey('recentBlockhash'),
            $3wEH9.blob(encodedInstructionsLength.length, 'instructionsLength'),
            $3wEH9.blob(serializedInstructions.length, 'serializedInstructions'),
            $3wEH9.blob(encodedAddressTableLookupsLength.length, 'addressTableLookupsLength'),
            $3wEH9.blob(serializedAddressTableLookups.length, 'serializedAddressTableLookups')
        ]);
        const serializedMessage = new Uint8Array($d29309e4a0887ac0$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($d29309e4a0887ac0$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $d29309e4a0887ac0$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $d29309e4a0887ac0$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $3wEH9.struct([
                $3wEH9.u8('programIdIndex'),
                $3wEH9.blob(encodedAccountKeyIndexesLength.length, 'encodedAccountKeyIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), instruction.accountKeyIndexes.length, 'accountKeyIndexes'),
                $3wEH9.blob(encodedDataLength.length, 'encodedDataLength'),
                $3wEH9.blob(instruction.data.length, 'data')
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($d29309e4a0887ac0$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $d29309e4a0887ac0$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $d29309e4a0887ac0$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $3wEH9.struct([
                $d29309e4a0887ac0$var$publicKey('accountKey'),
                $3wEH9.blob(encodedWritableIndexesLength.length, 'encodedWritableIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), lookup.writableIndexes.length, 'writableIndexes'),
                $3wEH9.blob(encodedReadonlyIndexesLength.length, 'encodedReadonlyIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), lookup.readonlyIndexes.length, 'readonlyIndexes')
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $d29309e4a0887ac0$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $d29309e4a0887ac0$export$3c3793d809f8b858;
        $d29309e4a0887ac0$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $d29309e4a0887ac0$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $d29309e4a0887ac0$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $d29309e4a0887ac0$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $d29309e4a0887ac0$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $d29309e4a0887ac0$export$ca8b6604d6ce14de($d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode($d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$84fc0a248cc54343));
        const instructionCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $d29309e4a0887ac0$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
            const accountKeyIndexes = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
            const data = new Uint8Array($d29309e4a0887ac0$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $d29309e4a0887ac0$export$ca8b6604d6ce14de($d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$84fc0a248cc54343));
            const writableIndexesLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
            const writableIndexes = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
            const readonlyIndexes = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $d29309e4a0887ac0$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $d29309e4a0887ac0$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $d29309e4a0887ac0$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return 'legacy';
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $d29309e4a0887ac0$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === 'legacy') return $d29309e4a0887ac0$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $d29309e4a0887ac0$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $d29309e4a0887ac0$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $d29309e4a0887ac0$var$DEFAULT_SIGNATURE = (0, $ihoyg.Buffer).alloc($d29309e4a0887ac0$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $d29309e4a0887ac0$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $ihoyg.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $d29309e4a0887ac0$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, 'nonceInfo')) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, 'lastValidBlockHeight')) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error('No instructions');
        items.forEach((item)=>{
            if ('instructions' in item) this.instructions = this.instructions.concat(item.instructions);
            else if ('data' in item && 'programId' in item && 'keys' in item) this.instructions.push(item);
            else this.instructions.push(new $d29309e4a0887ac0$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error('Transaction recentBlockhash required');
        if (instructions.length < 1) console.warn('No instructions provided');
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error('Transaction fee payer required');
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: 'best fit',
                usage: 'sort',
                sensitivity: 'variant',
                ignorePunctuation: false,
                numeric: false,
                caseFirst: 'lower'
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), 'en', options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $d29309e4a0887ac0$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$d29309e4a0887ac0$var$assert(keyIndex >= 0));
        });
        return new $d29309e4a0887ac0$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $d29309e4a0887ac0$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $d29309e4a0887ac0$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $d29309e4a0887ac0$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $ihoyg.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$d29309e4a0887ac0$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = 'Signature verification failed.';
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? '' : '(s)'} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join('`, `')}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? '' : '(s)'} [\`${sigErrors.missing.map((p)=>p.toBase58()).join('`, `')}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $d29309e4a0887ac0$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $ihoyg.Buffer).alloc(transactionLength);
        $d29309e4a0887ac0$var$assert(signatures.length < 256);
        (0, $ihoyg.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $d29309e4a0887ac0$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $ihoyg.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $d29309e4a0887ac0$var$assert(wireTransaction.length <= $d29309e4a0887ac0$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$d29309e4a0887ac0$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $d29309e4a0887ac0$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $d29309e4a0887ac0$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $d29309e4a0887ac0$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode((0, $ihoyg.Buffer).from(signature)));
        }
        return $d29309e4a0887ac0$export$febc5573c75cefb0.populate($d29309e4a0887ac0$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).encode($d29309e4a0887ac0$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $d29309e4a0887ac0$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $d29309e4a0887ac0$var$assert(numWritableSignedAccounts > 0, 'Message header is invalid');
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $d29309e4a0887ac0$var$assert(numWritableUnsignedAccounts >= 0, 'Message header is invalid');
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error('Failed to decompile message because no account keys were found');
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $d29309e4a0887ac0$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $d29309e4a0887ac0$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $d29309e4a0887ac0$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $d29309e4a0887ac0$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $d29309e4a0887ac0$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $d29309e4a0887ac0$var$assert(signatures.length === message.header.numRequiredSignatures, 'Expected signatures length to be equal to the number of required signatures');
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($d29309e4a0887ac0$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $d29309e4a0887ac0$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $3wEH9.struct([
            $3wEH9.blob(encodedSignaturesLength.length, 'encodedSignaturesLength'),
            $3wEH9.seq($d29309e4a0887ac0$var$signature(), this.signatures.length, 'signatures'),
            $3wEH9.blob(serializedMessage.length, 'serializedMessage')
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $d29309e4a0887ac0$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$14aee086fde78fa6)));
        const message = $d29309e4a0887ac0$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $d29309e4a0887ac0$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $d29309e4a0887ac0$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $d29309e4a0887ac0$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $d29309e4a0887ac0$var$assert(signature.byteLength === 64, 'Signature must be 64 bytes long');
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $d29309e4a0887ac0$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $d29309e4a0887ac0$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $d29309e4a0887ac0$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $d29309e4a0887ac0$var$NUM_SLOTS_PER_SECOND = $d29309e4a0887ac0$var$NUM_TICKS_PER_SECOND / $d29309e4a0887ac0$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $d29309e4a0887ac0$var$MS_PER_SLOT = 1000 / $d29309e4a0887ac0$var$NUM_SLOTS_PER_SECOND;
const $d29309e4a0887ac0$export$393aa1412d47050e = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarC1ock11111111111111111111111111111111');
const $d29309e4a0887ac0$export$2b71d479444d2f4 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarEpochSchedu1e111111111111111111111111');
const $d29309e4a0887ac0$export$54419cc1a3ece8d6 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('Sysvar1nstructions1111111111111111111111111');
const $d29309e4a0887ac0$export$e74201139e9833db = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarRecentB1ockHashes11111111111111111111');
const $d29309e4a0887ac0$export$970d0190cdb3a8e9 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarRent111111111111111111111111111111111');
const $d29309e4a0887ac0$export$da3b38d796bc1af1 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarRewards111111111111111111111111111111');
const $d29309e4a0887ac0$export$7b3a057916a4a7ae = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarS1otHashes111111111111111111111111111');
const $d29309e4a0887ac0$export$3272815bf0633907 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarS1otHistory11111111111111111111111111');
const $d29309e4a0887ac0$export$ca994171317280ea = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('SysvarStakeHistory1111111111111111111111111');
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $d29309e4a0887ac0$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $d29309e4a0887ac0$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $d29309e4a0887ac0$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $d29309e4a0887ac0$var$getAlloc(type, fields);
    const data = (0, $ihoyg.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $d29309e4a0887ac0$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $d29309e4a0887ac0$export$d1cc579b1c48f515 = $3wEH9.nu64('lamportsPerSignature');
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $d29309e4a0887ac0$var$NonceAccountLayout = $3wEH9.struct([
    $3wEH9.u32('version'),
    $3wEH9.u32('state'),
    $d29309e4a0887ac0$var$publicKey('authorizedPubkey'),
    $d29309e4a0887ac0$var$publicKey('nonce'),
    $3wEH9.struct([
        $d29309e4a0887ac0$export$d1cc579b1c48f515
    ], 'feeCalculator')
]);
const $d29309e4a0887ac0$export$7126250b6d8bd94a = $d29309e4a0887ac0$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $d29309e4a0887ac0$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $d29309e4a0887ac0$var$NonceAccountLayout.decode($d29309e4a0887ac0$var$toBuffer(buffer), 0);
        return new $d29309e4a0887ac0$export$ed1c2356ce604759({
            authorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $d29309e4a0887ac0$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $d29309e4a0887ac0$var$bigInt = (length)=>(property)=>{
        const layout = (0, $3wEH9.blob)(length, property);
        const { encode: encode, decode: decode } = $d29309e4a0887ac0$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $gbKvo.toBigIntLE)((0, $ihoyg.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $gbKvo.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $d29309e4a0887ac0$var$u64 = $d29309e4a0887ac0$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $d29309e4a0887ac0$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($d29309e4a0887ac0$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a SystemInstruction');
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($d29309e4a0887ac0$export$d8c4e17726848113.programId)) throw new Error('invalid instruction; programId is not SystemProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $d29309e4a0887ac0$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports'),
            $3wEH9.ns64('space'),
            $d29309e4a0887ac0$var$publicKey('programId')
        ])
    },
    Assign: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('programId')
        ])
    },
    Transfer: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$u64('lamports')
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('base'),
            $d29309e4a0887ac0$var$rustString('seed'),
            $3wEH9.ns64('lamports'),
            $3wEH9.ns64('space'),
            $d29309e4a0887ac0$var$publicKey('programId')
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('authorized')
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('authorized')
        ])
    },
    Allocate: {
        index: 8,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('space')
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('base'),
            $d29309e4a0887ac0$var$rustString('seed'),
            $3wEH9.ns64('space'),
            $d29309e4a0887ac0$var$publicKey('programId')
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('base'),
            $d29309e4a0887ac0$var$rustString('seed'),
            $d29309e4a0887ac0$var$publicKey('programId')
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$u64('lamports'),
            $d29309e4a0887ac0$var$rustString('seed'),
            $d29309e4a0887ac0$var$publicKey('programId')
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $d29309e4a0887ac0$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.Create;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $d29309e4a0887ac0$var$toBuffer(params.programId.toBuffer())
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $d29309e4a0887ac0$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $d29309e4a0887ac0$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.Transfer;
            data = $d29309e4a0887ac0$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $d29309e4a0887ac0$var$encodeData(type, {
                base: $d29309e4a0887ac0$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $d29309e4a0887ac0$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.Assign;
            data = $d29309e4a0887ac0$var$encodeData(type, {
                programId: $d29309e4a0887ac0$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            base: $d29309e4a0887ac0$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $d29309e4a0887ac0$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        if ('basePubkey' in params && 'seed' in params) transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $d29309e4a0887ac0$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $d29309e4a0887ac0$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            authorized: $d29309e4a0887ac0$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            authorized: $d29309e4a0887ac0$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $d29309e4a0887ac0$var$encodeData(type, {
                base: $d29309e4a0887ac0$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $d29309e4a0887ac0$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $d29309e4a0887ac0$export$74bdf41d8d1e7108.Allocate;
            data = $d29309e4a0887ac0$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$d29309e4a0887ac0$export$d8c4e17726848113.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('11111111111111111111111111111111');
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $d29309e4a0887ac0$var$CHUNK_SIZE = $d29309e4a0887ac0$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $d29309e4a0887ac0$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $d29309e4a0887ac0$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, 'confirmed');
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error('Program load failed, account is already executable');
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $d29309e4a0887ac0$export$febc5573c75cefb0();
                    transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $d29309e4a0887ac0$export$febc5573c75cefb0();
                    transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $d29309e4a0887ac0$export$febc5573c75cefb0();
                    transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0().add($d29309e4a0887ac0$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $d29309e4a0887ac0$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            });
        }
        const dataLayout = $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.u32('offset'),
            $3wEH9.u32('bytesLength'),
            $3wEH9.u32('bytesLengthPadding'),
            $3wEH9.seq($3wEH9.u8('byte'), $3wEH9.offset($3wEH9.u32(), -8), 'bytes')
        ]);
        const chunkSize = $d29309e4a0887ac0$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $ihoyg.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($d29309e4a0887ac0$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes('solana.com')) {
                const REQUESTS_PER_SECOND = 4;
                await $d29309e4a0887ac0$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $3wEH9.struct([
                $3wEH9.u32('instruction')
            ]);
            const data = (0, $ihoyg.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $d29309e4a0887ac0$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = 'processed';
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($d29309e4a0887ac0$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$d29309e4a0887ac0$export$3b0d6d7590275603.chunkSize = $d29309e4a0887ac0$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $d29309e4a0887ac0$export$59833422f998b937 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('BPFLoader2111111111111111111111111111111111');
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $d29309e4a0887ac0$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $d29309e4a0887ac0$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $d29309e4a0887ac0$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $d29309e4a0887ac0$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $d29309e4a0887ac0$var$objToString = Object.prototype.toString;
var $d29309e4a0887ac0$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $d29309e4a0887ac0$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $d29309e4a0887ac0$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $d29309e4a0887ac0$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = '[';
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $d29309e4a0887ac0$var$stringify(val[i], true) + ',';
                    if (max > -1) str += $d29309e4a0887ac0$var$stringify(val[i], true);
                    return str + ']';
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $d29309e4a0887ac0$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $d29309e4a0887ac0$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ',';
                            str += JSON.stringify(key) + ':' + propVal;
                        }
                        i++;
                    }
                    return '{' + str + '}';
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $d29309e4a0887ac0$var$fastStableStringify = function(val) {
    var returnVal = $d29309e4a0887ac0$var$stringify(val, false);
    if (returnVal !== undefined) return '' + returnVal;
};
var $d29309e4a0887ac0$var$fastStableStringify$1 = /*@__PURE__*/ $d29309e4a0887ac0$var$getDefaultExportFromCjs($d29309e4a0887ac0$var$fastStableStringify);
const $d29309e4a0887ac0$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $d29309e4a0887ac0$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $d29309e4a0887ac0$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $d29309e4a0887ac0$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $d29309e4a0887ac0$var$trailingZeros($d29309e4a0887ac0$var$nextPowerOfTwo(slot + $d29309e4a0887ac0$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $d29309e4a0887ac0$var$trailingZeros($d29309e4a0887ac0$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $d29309e4a0887ac0$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $d29309e4a0887ac0$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $d29309e4a0887ac0$var$trailingZeros($d29309e4a0887ac0$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $d29309e4a0887ac0$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $d29309e4a0887ac0$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $d29309e4a0887ac0$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = 'SolanaJSONRPCError';
    }
}
var $d29309e4a0887ac0$var$fetchImpl = globalThis.fetch;
class $d29309e4a0887ac0$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($81012))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($6U8NG)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ('socket' in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error('Tried to call a JSON-RPC method `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error('Tried to send a JSON-RPC notification `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $d29309e4a0887ac0$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $d29309e4a0887ac0$var$LOOKUP_TABLE_META_SIZE = 56;
class $d29309e4a0887ac0$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt('0xffffffffffffffff');
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $d29309e4a0887ac0$var$decodeData($d29309e4a0887ac0$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $d29309e4a0887ac0$var$LOOKUP_TABLE_META_SIZE;
        $d29309e4a0887ac0$var$assert(serializedAddressesLen >= 0, 'lookup table is invalid');
        $d29309e4a0887ac0$var$assert(serializedAddressesLen % 32 === 0, 'lookup table is invalid');
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $3wEH9.struct([
            $3wEH9.seq($d29309e4a0887ac0$var$publicKey(), numSerializedAddresses, 'addresses')
        ]).decode(accountData.slice($d29309e4a0887ac0$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $d29309e4a0887ac0$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(address))
        };
    }
}
const $d29309e4a0887ac0$var$LookupTableMetaLayout = {
    index: 1,
    layout: $3wEH9.struct([
        $3wEH9.u32('typeIndex'),
        $d29309e4a0887ac0$var$u64('deactivationSlot'),
        $3wEH9.nu64('lastExtendedSlot'),
        $3wEH9.u8('lastExtendedStartIndex'),
        $3wEH9.u8(),
        // option
        $3wEH9.seq($d29309e4a0887ac0$var$publicKey(), $3wEH9.offset($3wEH9.u8(), -1), 'authority')
    ])
};
const $d29309e4a0887ac0$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $d29309e4a0887ac0$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($d29309e4a0887ac0$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith('https:') ? 'wss:' : 'ws:';
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? '' : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $d29309e4a0887ac0$var$PublicKeyFromString = (0, $e87afc78b8edabee$export$8c14e57e778d3873)((0, $e87afc78b8edabee$export$9544d5bb712b01ea)($d29309e4a0887ac0$export$ca8b6604d6ce14de), (0, $e87afc78b8edabee$export$22b082955e083ec3)(), (value)=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(value));
const $d29309e4a0887ac0$var$RawAccountDataResult = (0, $e87afc78b8edabee$export$65e3907585753458)([
    (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('base64')
]);
const $d29309e4a0887ac0$var$BufferFromRawAccountData = (0, $e87afc78b8edabee$export$8c14e57e778d3873)((0, $e87afc78b8edabee$export$9544d5bb712b01ea)((0, $ihoyg.Buffer)), $d29309e4a0887ac0$var$RawAccountDataResult, (value)=>(0, $ihoyg.Buffer).from(value[0], 'base64'));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $d29309e4a0887ac0$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $d29309e4a0887ac0$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError('Endpoint URL must start with `http:` or `https:`.');
    return putativeUrl;
}
/** @internal */ function $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === 'string') commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $d29309e4a0887ac0$var$createRpcResult(result) {
    return (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
        (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            jsonrpc: (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('2.0'),
            id: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
            result: result
        }),
        (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            jsonrpc: (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('2.0'),
            id: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
            error: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
                code: (0, $e87afc78b8edabee$export$19282c40b967aec6)(),
                message: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
                data: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$4154a199d7d90455)())
            })
        })
    ]);
}
const $d29309e4a0887ac0$var$UnknownRpcResult = $d29309e4a0887ac0$var$createRpcResult((0, $e87afc78b8edabee$export$19282c40b967aec6)());
/**
 * @internal
 */ function $d29309e4a0887ac0$var$jsonRpcResult(schema) {
    return (0, $e87afc78b8edabee$export$8c14e57e778d3873)($d29309e4a0887ac0$var$createRpcResult(schema), $d29309e4a0887ac0$var$UnknownRpcResult, (value)=>{
        if ('error' in value) return value;
        else return {
            ...value,
            result: (0, $e87afc78b8edabee$export$185802fd694ee1f5)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $d29309e4a0887ac0$var$jsonRpcResultAndContext(value) {
    return $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        context: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            slot: (0, $e87afc78b8edabee$export$98e628dec113755e)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $d29309e4a0887ac0$var$notificationResultAndContext(value) {
    return (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        context: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            slot: (0, $e87afc78b8edabee$export$98e628dec113755e)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $d29309e4a0887ac0$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $d29309e4a0887ac0$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $d29309e4a0887ac0$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $d29309e4a0887ac0$var$GetInflationGovernorResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    foundation: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    foundationTerm: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    initial: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    taper: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    terminal: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $d29309e4a0887ac0$var$GetInflationRewardResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    epoch: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    effectiveSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    amount: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    postBalance: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    commission: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $d29309e4a0887ac0$var$GetRecentPrioritizationFeesResult = (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    prioritizationFee: (0, $e87afc78b8edabee$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $d29309e4a0887ac0$var$GetInflationRateResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    total: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    validator: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    foundation: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    epoch: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * Information about the current epoch
 */ const $d29309e4a0887ac0$var$GetEpochInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    epoch: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    slotIndex: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    slotsInEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    absoluteSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    blockHeight: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    transactionCount: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)())
});
const $d29309e4a0887ac0$var$GetEpochScheduleResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    slotsPerEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    leaderScheduleSlotOffset: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    warmup: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
    firstNormalEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    firstNormalSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $d29309e4a0887ac0$var$GetLeaderScheduleResult = (0, $e87afc78b8edabee$export$e5185e241753e543)((0, $e87afc78b8edabee$export$22b082955e083ec3)(), (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()));
/**
 * Transaction error or null
 */ const $d29309e4a0887ac0$var$TransactionErrorResult = (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({}),
    (0, $e87afc78b8edabee$export$22b082955e083ec3)()
]));
/**
 * Signature status for a transaction
 */ const $d29309e4a0887ac0$var$SignatureStatusResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    err: $d29309e4a0887ac0$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $d29309e4a0887ac0$var$SignatureReceivedResult = (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('receivedSignature');
/**
 * Version info for a node
 */ const $d29309e4a0887ac0$var$VersionResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    'solana-core': (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    'feature-set': (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)())
});
const $d29309e4a0887ac0$var$SimulatedTransactionResponseStruct = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    err: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
        (0, $e87afc78b8edabee$export$bf9fb029d174d554)({}),
        (0, $e87afc78b8edabee$export$22b082955e083ec3)()
    ])),
    logs: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)())),
    accounts: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        executable: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
        owner: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
        lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        data: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
        rentEpoch: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)())
    }))))),
    unitsConsumed: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    returnData: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        programId: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
        data: (0, $e87afc78b8edabee$export$65e3907585753458)([
            (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
            (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('base64')
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $d29309e4a0887ac0$var$BlockProductionResponseStruct = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    byIdentity: (0, $e87afc78b8edabee$export$e5185e241753e543)((0, $e87afc78b8edabee$export$22b082955e083ec3)(), (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)())),
    range: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        firstSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        lastSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    })
}));
/**
 * A performance sample
 */ function $d29309e4a0887ac0$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $d29309e4a0887ac0$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($fFbWN)))(async (request, callback)=>{
        const options = {
            method: 'POST',
            body: request,
            agent: agent,
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, httpHeaders || {}, $d29309e4a0887ac0$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $d29309e4a0887ac0$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $d29309e4a0887ac0$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $d29309e4a0887ac0$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $d29309e4a0887ac0$var$GetInflationGovernorRpcResult = $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $d29309e4a0887ac0$var$GetInflationRateRpcResult = $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $d29309e4a0887ac0$var$GetRecentPrioritizationFeesRpcResult = $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $d29309e4a0887ac0$var$GetEpochInfoRpcResult = $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $d29309e4a0887ac0$var$GetEpochScheduleRpcResult = $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $d29309e4a0887ac0$var$GetLeaderScheduleRpcResult = $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $d29309e4a0887ac0$var$SlotRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$98e628dec113755e)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $d29309e4a0887ac0$var$GetSupplyRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    total: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    circulating: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    nonCirculating: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    nonCirculatingAccounts: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $d29309e4a0887ac0$var$TokenAmountResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    amount: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    uiAmount: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    decimals: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    uiAmountString: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$22b082955e083ec3)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $d29309e4a0887ac0$var$GetTokenLargestAccountsResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    address: $d29309e4a0887ac0$var$PublicKeyFromString,
    amount: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    uiAmount: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    decimals: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    uiAmountString: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$22b082955e083ec3)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $d29309e4a0887ac0$var$GetTokenAccountsByOwner = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: $d29309e4a0887ac0$var$PublicKeyFromString,
    account: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        executable: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
        owner: $d29309e4a0887ac0$var$PublicKeyFromString,
        lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        data: $d29309e4a0887ac0$var$BufferFromRawAccountData,
        rentEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    })
})));
const $d29309e4a0887ac0$var$ParsedAccountDataResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    program: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parsed: (0, $e87afc78b8edabee$export$19282c40b967aec6)(),
    space: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $d29309e4a0887ac0$var$GetParsedTokenAccountsByOwner = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: $d29309e4a0887ac0$var$PublicKeyFromString,
    account: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        executable: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
        owner: $d29309e4a0887ac0$var$PublicKeyFromString,
        lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        data: $d29309e4a0887ac0$var$ParsedAccountDataResult,
        rentEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $d29309e4a0887ac0$var$GetLargestAccountsRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    address: $d29309e4a0887ac0$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $d29309e4a0887ac0$var$AccountInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    executable: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
    owner: $d29309e4a0887ac0$var$PublicKeyFromString,
    lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    data: $d29309e4a0887ac0$var$BufferFromRawAccountData,
    rentEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$KeyedAccountInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: $d29309e4a0887ac0$var$PublicKeyFromString,
    account: $d29309e4a0887ac0$var$AccountInfoResult
});
const $d29309e4a0887ac0$var$ParsedOrRawAccountData = (0, $e87afc78b8edabee$export$8c14e57e778d3873)((0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    (0, $e87afc78b8edabee$export$9544d5bb712b01ea)((0, $ihoyg.Buffer)),
    $d29309e4a0887ac0$var$ParsedAccountDataResult
]), (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    $d29309e4a0887ac0$var$RawAccountDataResult,
    $d29309e4a0887ac0$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $e87afc78b8edabee$export$185802fd694ee1f5)(value, $d29309e4a0887ac0$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$ParsedAccountInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    executable: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
    owner: $d29309e4a0887ac0$var$PublicKeyFromString,
    lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    data: $d29309e4a0887ac0$var$ParsedOrRawAccountData,
    rentEpoch: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
const $d29309e4a0887ac0$var$KeyedParsedAccountInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: $d29309e4a0887ac0$var$PublicKeyFromString,
    account: $d29309e4a0887ac0$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$StakeActivationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    state: (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
        (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('active'),
        (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('inactive'),
        (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('activating'),
        (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('deactivating')
    ]),
    active: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    inactive: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $d29309e4a0887ac0$var$GetConfirmedSignaturesForAddress2RpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    signature: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    err: $d29309e4a0887ac0$var$TransactionErrorResult,
    memo: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    blockTime: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $d29309e4a0887ac0$var$GetSignaturesForAddressRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    signature: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    err: $d29309e4a0887ac0$var$TransactionErrorResult,
    memo: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    blockTime: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $d29309e4a0887ac0$var$AccountNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    result: $d29309e4a0887ac0$var$notificationResultAndContext($d29309e4a0887ac0$var$AccountInfoResult)
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$ProgramAccountInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: $d29309e4a0887ac0$var$PublicKeyFromString,
    account: $d29309e4a0887ac0$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $d29309e4a0887ac0$var$ProgramAccountNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    result: $d29309e4a0887ac0$var$notificationResultAndContext($d29309e4a0887ac0$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$SlotInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    parent: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    root: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $d29309e4a0887ac0$var$SlotNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    result: $d29309e4a0887ac0$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $d29309e4a0887ac0$var$SlotUpdateResult = (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        type: (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
            (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('firstShredReceived'),
            (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('completed'),
            (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('optimisticConfirmation'),
            (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('root')
        ]),
        slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        timestamp: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    }),
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        type: (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('createdBank'),
        parent: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        timestamp: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    }),
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        type: (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('frozen'),
        slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        timestamp: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        stats: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            numTransactionEntries: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
            numSuccessfulTransactions: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
            numFailedTransactions: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
            maxTransactionsPerEntry: (0, $e87afc78b8edabee$export$98e628dec113755e)()
        })
    }),
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        type: (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('dead'),
        slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        timestamp: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        err: (0, $e87afc78b8edabee$export$22b082955e083ec3)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $d29309e4a0887ac0$var$SlotUpdateNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    result: $d29309e4a0887ac0$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $d29309e4a0887ac0$var$SignatureNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    result: $d29309e4a0887ac0$var$notificationResultAndContext((0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
        $d29309e4a0887ac0$var$SignatureStatusResult,
        $d29309e4a0887ac0$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $d29309e4a0887ac0$var$RootNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    result: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
const $d29309e4a0887ac0$var$ContactInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    gossip: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    tpu: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    rpc: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    version: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)())
});
const $d29309e4a0887ac0$var$VoteAccountInfoResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    votePubkey: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    nodePubkey: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    activatedStake: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    epochVoteAccount: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
    epochCredits: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$65e3907585753458)([
        (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        (0, $e87afc78b8edabee$export$98e628dec113755e)()
    ])),
    commission: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    lastVote: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    rootSlot: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $d29309e4a0887ac0$var$GetVoteAccounts = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    current: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$VoteAccountInfoResult),
    delinquent: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$VoteAccountInfoResult)
}));
const $d29309e4a0887ac0$var$ConfirmationStatus = (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('processed'),
    (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('confirmed'),
    (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('finalized')
]);
const $d29309e4a0887ac0$var$SignatureStatusResponse = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    confirmations: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    err: $d29309e4a0887ac0$var$TransactionErrorResult,
    confirmationStatus: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $d29309e4a0887ac0$var$GetSignatureStatusesRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $d29309e4a0887ac0$var$GetMinimumBalanceForRentExemptionRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$98e628dec113755e)());
const $d29309e4a0887ac0$var$AddressTableLookupStruct = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    accountKey: $d29309e4a0887ac0$var$PublicKeyFromString,
    writableIndexes: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    readonlyIndexes: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)())
});
const $d29309e4a0887ac0$var$ConfirmedTransactionResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    signatures: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    message: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        accountKeys: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
        header: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            numRequiredSignatures: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
            numReadonlySignedAccounts: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
            numReadonlyUnsignedAccounts: (0, $e87afc78b8edabee$export$98e628dec113755e)()
        }),
        instructions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            accounts: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
            data: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
            programIdIndex: (0, $e87afc78b8edabee$export$98e628dec113755e)()
        })),
        recentBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
        addressTableLookups: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$AddressTableLookupStruct))
    })
});
const $d29309e4a0887ac0$var$AnnotatedAccountKey = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: $d29309e4a0887ac0$var$PublicKeyFromString,
    signer: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
    writable: (0, $e87afc78b8edabee$export$4a21f16c33752377)(),
    source: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
        (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('transaction'),
        (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('lookupTable')
    ]))
});
const $d29309e4a0887ac0$var$ConfirmedTransactionAccountsModeResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    accountKeys: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$AnnotatedAccountKey),
    signatures: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)())
});
const $d29309e4a0887ac0$var$ParsedInstructionResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    parsed: (0, $e87afc78b8edabee$export$19282c40b967aec6)(),
    program: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    programId: $d29309e4a0887ac0$var$PublicKeyFromString
});
const $d29309e4a0887ac0$var$RawInstructionResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    accounts: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$PublicKeyFromString),
    data: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    programId: $d29309e4a0887ac0$var$PublicKeyFromString
});
const $d29309e4a0887ac0$var$InstructionResult = (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    $d29309e4a0887ac0$var$RawInstructionResult,
    $d29309e4a0887ac0$var$ParsedInstructionResult
]);
const $d29309e4a0887ac0$var$UnknownInstructionResult = (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        parsed: (0, $e87afc78b8edabee$export$19282c40b967aec6)(),
        program: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
        programId: (0, $e87afc78b8edabee$export$22b082955e083ec3)()
    }),
    (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        accounts: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
        data: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
        programId: (0, $e87afc78b8edabee$export$22b082955e083ec3)()
    })
]);
const $d29309e4a0887ac0$var$ParsedOrRawInstruction = (0, $e87afc78b8edabee$export$8c14e57e778d3873)($d29309e4a0887ac0$var$InstructionResult, $d29309e4a0887ac0$var$UnknownInstructionResult, (value)=>{
    if ('accounts' in value) return (0, $e87afc78b8edabee$export$185802fd694ee1f5)(value, $d29309e4a0887ac0$var$RawInstructionResult);
    else return (0, $e87afc78b8edabee$export$185802fd694ee1f5)(value, $d29309e4a0887ac0$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$ParsedConfirmedTransactionResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    signatures: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    message: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        accountKeys: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$AnnotatedAccountKey),
        instructions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
        addressTableLookups: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$AddressTableLookupStruct)))
    })
});
const $d29309e4a0887ac0$var$TokenBalanceResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    accountIndex: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    mint: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    owner: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    uiTokenAmount: $d29309e4a0887ac0$var$TokenAmountResult
});
const $d29309e4a0887ac0$var$LoadedAddressesResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    writable: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$PublicKeyFromString),
    readonly: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$ConfirmedTransactionMetaResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    err: $d29309e4a0887ac0$var$TransactionErrorResult,
    fee: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    innerInstructions: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        index: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        instructions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
            accounts: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
            data: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
            programIdIndex: (0, $e87afc78b8edabee$export$98e628dec113755e)()
        }))
    })))),
    preBalances: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    postBalances: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    logMessages: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$TokenBalanceResult))),
    postTokenBalances: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$TokenBalanceResult))),
    loadedAddresses: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)())
});
/**
 * @internal
 */ const $d29309e4a0887ac0$var$ParsedConfirmedTransactionMetaResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    err: $d29309e4a0887ac0$var$TransactionErrorResult,
    fee: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    innerInstructions: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        index: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
        instructions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    postBalances: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    logMessages: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$TokenBalanceResult))),
    postTokenBalances: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$TokenBalanceResult))),
    loadedAddresses: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$98e628dec113755e)())
});
const $d29309e4a0887ac0$var$TransactionVersionStruct = (0, $e87afc78b8edabee$export$971dd5b0dfd021b6)([
    (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)(0),
    (0, $e87afc78b8edabee$export$c8ec6e1ec9fefcb0)('legacy')
]);
/** @internal */ const $d29309e4a0887ac0$var$RewardsResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    pubkey: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    lamports: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    postBalance: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    rewardType: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    commission: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $d29309e4a0887ac0$var$GetBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    transactions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        transaction: $d29309e4a0887ac0$var$ConfirmedTransactionResult,
        meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ConfirmedTransactionMetaResult),
        version: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$TransactionVersionStruct)
    })),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    blockHeight: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $d29309e4a0887ac0$var$GetNoneModeBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    blockHeight: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $d29309e4a0887ac0$var$GetAccountsModeBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    transactions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        transaction: $d29309e4a0887ac0$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ConfirmedTransactionMetaResult),
        version: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$TransactionVersionStruct)
    })),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    blockHeight: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $d29309e4a0887ac0$var$GetParsedBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    transactions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        transaction: $d29309e4a0887ac0$var$ParsedConfirmedTransactionResult,
        meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$TransactionVersionStruct)
    })),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    blockHeight: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $d29309e4a0887ac0$var$GetParsedAccountsModeBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    transactions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        transaction: $d29309e4a0887ac0$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$TransactionVersionStruct)
    })),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    blockHeight: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $d29309e4a0887ac0$var$GetParsedNoneModeBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)()),
    blockHeight: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $d29309e4a0887ac0$var$GetConfirmedBlockRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    transactions: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        transaction: $d29309e4a0887ac0$var$ConfirmedTransactionResult,
        meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$RewardsResult)),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $d29309e4a0887ac0$var$GetBlockSignaturesRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    previousBlockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    parentSlot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    signatures: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    blockTime: (0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $d29309e4a0887ac0$var$GetTransactionRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())),
    transaction: $d29309e4a0887ac0$var$ConfirmedTransactionResult,
    version: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $d29309e4a0887ac0$var$GetParsedTransactionRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    transaction: $d29309e4a0887ac0$var$ParsedConfirmedTransactionResult,
    meta: (0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())),
    version: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)($d29309e4a0887ac0$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $d29309e4a0887ac0$var$GetRecentBlockhashAndContextRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    feeCalculator: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $d29309e4a0887ac0$var$GetLatestBlockhashRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    blockhash: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    lastValidBlockHeight: (0, $e87afc78b8edabee$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $d29309e4a0887ac0$var$IsBlockhashValidRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$4a21f16c33752377)());
const $d29309e4a0887ac0$var$PerfSampleResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    slot: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    numTransactions: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    numSlots: (0, $e87afc78b8edabee$export$98e628dec113755e)(),
    samplePeriodSecs: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $d29309e4a0887ac0$var$GetRecentPerformanceSamplesRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $d29309e4a0887ac0$var$GetFeeCalculatorRpcResult = $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    feeCalculator: (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $e87afc78b8edabee$export$98e628dec113755e)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $d29309e4a0887ac0$var$RequestAirdropRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$22b082955e083ec3)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $d29309e4a0887ac0$var$SendTransactionRpcResult = $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$22b082955e083ec3)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $d29309e4a0887ac0$var$LogsResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    err: $d29309e4a0887ac0$var$TransactionErrorResult,
    logs: (0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    signature: (0, $e87afc78b8edabee$export$22b082955e083ec3)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $d29309e4a0887ac0$var$LogsNotificationResult = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    result: $d29309e4a0887ac0$var$notificationResultAndContext($d29309e4a0887ac0$var$LogsResult),
    subscription: (0, $e87afc78b8edabee$export$98e628dec113755e)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $d29309e4a0887ac0$var$COMMON_HTTP_HEADERS = {
    'solana-client': `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $d29309e4a0887ac0$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $d29309e4a0887ac0$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest('getBlockHeight', args);
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$98e628dec113755e)()));
                        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get block height information');
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === 'string') this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $d29309e4a0887ac0$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $d29309e4a0887ac0$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $d29309e4a0887ac0$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $d29309e4a0887ac0$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $d29309e4a0887ac0$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $d29309e4a0887ac0$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on('open', this._wsOnOpen.bind(this));
        this._rpcWebSocket.on('error', this._wsOnError.bind(this));
        this._rpcWebSocket.on('close', this._wsOnClose.bind(this));
        this._rpcWebSocket.on('accountNotification', this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on('programNotification', this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on('slotNotification', this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on('slotsUpdatesNotification', this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on('signatureNotification', this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on('rootNotification', this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on('logsNotification', this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBalance', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$98e628dec113755e)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get balance of account ' + publicKey.toBase58() + ': ' + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest('getBlockTime', [
            slot
        ]);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest('minimumLedgerSlot', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$98e628dec113755e)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get minimum ledger slot');
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest('getFirstAvailableBlock', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$SlotRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get first available block');
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === 'string') configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest('getSupply', [
            configArg
        ]);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetSupplyRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get supply');
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenSupply', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext($d29309e4a0887ac0$var$TokenAmountResult));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get token supply');
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenAccountBalance', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext($d29309e4a0887ac0$var$TokenAmountResult));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get token account balance');
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetTokenAccountsByOwner);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedTokenAccountsByOwner);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest('getLargestAccounts', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetLargestAccountsRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get largest accounts');
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenLargestAccounts', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetTokenLargestAccountsResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get token largest accounts');
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$AccountInfoResult)));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ParsedAccountInfoResult)));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get info about account ' + publicKey.toBase58() + ': ' + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$ParsedAccountInfoResult))));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$133fc36489ac9add)($d29309e4a0887ac0$var$AccountInfoResult))));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getStakeActivation', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$StakeActivationResult));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || 'base64', configWithoutEncoding);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const baseSchema = (0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext(baseSchema)) : (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult(baseSchema));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$KeyedParsedAccountInfoResult)));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == 'string') rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($bda1ba034b4c2cde$exports))).decode(rawSignature);
        } catch (err) {
            throw new Error('signature must be base58 encoded: ' + rawSignature);
        }
        $d29309e4a0887ac0$var$assert(decodedSignature.length === 64, 'signature has invalid length');
        if (typeof strategy === 'string') return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ('lastValidBlockHeight' in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener('abort', ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $d29309e4a0887ac0$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === 'subscribed') resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case 'confirmed':
                            case 'single':
                            case 'singleGossip':
                                if (value.confirmationStatus === 'processed') return;
                                break;
                            case 'finalized':
                            case 'max':
                            case 'root':
                                if (value.confirmationStatus === 'processed' || value.confirmationStatus === 'confirmed') return;
                                break;
                            // exhaust enums to ensure full coverage
                            case 'processed':
                            case 'recent':
                        }
                        done = true;
                        resolve({
                            __type: $d29309e4a0887ac0$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $d29309e4a0887ac0$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $d29309e4a0887ac0$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $d29309e4a0887ac0$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $d29309e4a0887ac0$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $d29309e4a0887ac0$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $d29309e4a0887ac0$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $d29309e4a0887ac0$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $d29309e4a0887ac0$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || 'finalized';
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case 'processed':
                        case 'recent':
                            if (confirmationStatus !== 'processed' && confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $d29309e4a0887ac0$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'confirmed':
                        case 'single':
                        case 'singleGossip':
                            if (confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $d29309e4a0887ac0$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'finalized':
                        case 'max':
                        case 'root':
                            if (confirmationStatus !== 'finalized') throw new $d29309e4a0887ac0$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $d29309e4a0887ac0$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case 'processed':
                case 'recent':
                case 'single':
                case 'confirmed':
                case 'singleGossip':
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $d29309e4a0887ac0$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $d29309e4a0887ac0$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $d29309e4a0887ac0$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest('getClusterNodes', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$ContactInfoResult)));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get cluster nodes');
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getVoteAccounts', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetVoteAccounts);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get vote accounts');
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlot', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$98e628dec113755e)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot');
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlotLeader', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$22b082955e083ec3)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leader');
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest('getSlotLeaders', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)($d29309e4a0887ac0$var$PublicKeyFromString)));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leaders');
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $d29309e4a0887ac0$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest('getSignatureStatuses', params);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetSignatureStatusesRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get signature status');
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransactionCount', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$98e628dec113755e)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction count');
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getInflationGovernor', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetInflationGovernorRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation');
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getInflationReward', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetInflationRewardResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation reward');
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest('getInflationRate', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetInflationRateRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation rate');
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getEpochInfo', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetEpochInfoRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch info');
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest('getEpochSchedule', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetEpochScheduleRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch schedule');
        const epochSchedule = res.result;
        return new $d29309e4a0887ac0$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest('getLeaderSchedule', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetLeaderScheduleRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get leader schedule');
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest('getMinimumBalanceForRentExemption', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ('error' in res) {
            console.warn('Unable to fetch minimum balance for rent exemption');
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getRecentBlockhash', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetRecentBlockhashAndContextRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent blockhash');
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest('getRecentPerformanceSamples', limit ? [
            limit
        ] : []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetRecentPerformanceSamplesRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent performance samples');
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeCalculatorForBlockhash', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetFeeCalculatorRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee calculator');
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $d29309e4a0887ac0$var$toBuffer(message.serialize()).toString('base64');
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeForMessage', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$133fc36489ac9add)((0, $e87afc78b8edabee$export$98e628dec113755e)())));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee for message');
        if (res.result === null) throw new Error('invalid blockhash');
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest('getRecentPrioritizationFees', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetRecentPrioritizationFeesRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent prioritization fees');
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getLatestBlockhash', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetLatestBlockhashRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get latest blockhash');
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('isBlockhashValid', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$IsBlockhashValidRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to determine if the blockhash `' + blockhash + '`is valid');
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest('getVersion', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult($d29309e4a0887ac0$var$VersionResult));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get version');
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest('getGenesisHash', []);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$22b082955e083ec3)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get genesis hash');
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetBlockRpcResult);
                        if ('error' in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $d29309e4a0887ac0$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(e, 'failed to get confirmed block');
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(e, 'failed to get block');
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === 'string') commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, 'base64', extra);
        const unsafeRes = await this._rpcRequest('getBlockProduction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$BlockProductionResponseStruct);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get block production information');
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetTransactionRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $d29309e4a0887ac0$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed', config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetTransactionRpcResult);
            if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $d29309e4a0887ac0$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getConfirmedBlock', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetConfirmedBlockRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $d29309e4a0887ac0$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $d29309e4a0887ac0$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getBlocks', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResult((0, $e87afc78b8edabee$export$2f23118c22fb2630)((0, $e87afc78b8edabee$export$98e628dec113755e)())));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get blocks');
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getBlock', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get block');
        const result = res.result;
        if (!result) throw new Error('Block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getConfirmedBlock', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest('getConfirmedTransaction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetTransactionRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        const message = new $d29309e4a0887ac0$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $d29309e4a0887ac0$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getConfirmedTransaction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed');
            return {
                methodName: 'getConfirmedTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!('until' in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, 'finalized');
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot('finalized');
        while(!('before' in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getConfirmedSignaturesForAddress2', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed signatures for address');
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getSignaturesForAddress', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$GetSignaturesForAddressRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, 'failed to get signatures for address');
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $d29309e4a0887ac0$export$5b2310da10e607da({
            key: accountKey,
            state: $d29309e4a0887ac0$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $d29309e4a0887ac0$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get nonce for account ' + nonceAccount.toBase58() + ': ' + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest('requestAirdrop', [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$RequestAirdropRpcResult);
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $d29309e4a0887ac0$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $d29309e4a0887ac0$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash('finalized');
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $d29309e4a0887ac0$var$sleep($d29309e4a0887ac0$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $d29309e4a0887ac0$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, 'base64', configArg);
        const unsafeRes = await this._rpcRequest('getStakeMinimumDelegation', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$jsonRpcResultAndContext((0, $e87afc78b8edabee$export$98e628dec113755e)()));
        if ('error' in res) throw new $d29309e4a0887ac0$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ('message' in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $ihoyg.Buffer).from(wireTransaction).toString('base64');
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error('Invalid arguments');
            const config = configOrSigners || {};
            config.encoding = 'base64';
            if (!('commitment' in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest('simulateTransaction', args);
            const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$SimulatedTransactionResponseStruct);
            if ('error' in res) throw new Error('failed to simulate transaction: ' + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $d29309e4a0887ac0$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $d29309e4a0887ac0$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error('Invalid arguments');
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString('base64');
        const config = {
            encoding: 'base64',
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config['accounts'] = {
                encoding: 'base64',
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('simulateTransaction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$SimulatedTransactionResponseStruct);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = '\n    ';
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $d29309e4a0887ac0$export$121e803f723b3045('failed to simulate transaction: ' + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ('version' in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $d29309e4a0887ac0$var$toBuffer(rawTransaction).toString('base64');
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: 'base64'
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? 'processed' // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('sendTransaction', args);
        const res = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(unsafeRes, $d29309e4a0887ac0$var$SendTransactionRpcResult);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) logs = res.error.data.logs;
            throw new $d29309e4a0887ac0$export$121e803f723b3045('failed to send transaction: ' + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify('ping');
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error('ws error:', err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: 'pending'
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case 'pending':
                case 'unsubscribed':
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === 'unsubscribed') delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'subscribing'
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: 'subscribed'
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'pending'
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case 'subscribed':
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: 'subscribed'
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: 'unsubscribed'
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $d29309e4a0887ac0$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: 'pending'
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $d29309e4a0887ac0$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64');
        return this._makeSubscription({
            callback: callback,
            method: 'accountSubscribe',
            unsubscribeMethod: 'accountUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'account change');
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64' /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: 'programSubscribe',
            unsubscribeMethod: 'programUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'program account change');
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === 'object' ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: 'logsSubscribe',
            unsubscribeMethod: 'logsUnsubscribe'
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'logs');
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotSubscribe',
            unsubscribeMethod: 'slotUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot change');
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotsUpdatesSubscribe',
            unsubscribeMethod: 'slotsUpdatesUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot update');
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn('Ignored unsubscribe request because an active subscription with id ' + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + 'could not be found.');
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            'confirmed',
            'finalized'
        ].includes(commitment)) throw new Error('Using Connection with default commitment: `' + this._commitment + '`, but method requires at least `confirmed`');
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$SignatureNotificationResult);
        if (result.value !== 'receivedSignature') /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === 'receivedSignature' ? [
            {
                type: 'received'
            },
            result.context
        ] : [
            {
                type: 'status',
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === 'status') {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || 'finalized' // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'signature result');
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $e87afc78b8edabee$export$185802fd694ee1f5)(notification, $d29309e4a0887ac0$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'rootSubscribe',
            unsubscribeMethod: 'rootUnsubscribe'
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'root change');
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $d29309e4a0887ac0$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $d29309e4a0887ac0$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $d29309e4a0887ac0$export$c53bca448cf33676($d29309e4a0887ac0$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error('bad secret key size');
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $d29309e4a0887ac0$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error('provided secretKey is invalid');
            }
        }
        return new $d29309e4a0887ac0$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $d29309e4a0887ac0$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $d29309e4a0887ac0$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $d29309e4a0887ac0$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $d29309e4a0887ac0$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$u64('recentSlot'),
            $3wEH9.u8('bumpSeed')
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$u64(),
            $3wEH9.seq($d29309e4a0887ac0$var$publicKey(), $3wEH9.offset($3wEH9.u32(), -8), 'addresses')
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    }
});
class $d29309e4a0887ac0$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($d29309e4a0887ac0$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error('Invalid Instruction. Should be a LookupTable Instruction');
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $d29309e4a0887ac0$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($d29309e4a0887ac0$export$5147a345798de168.programId)) throw new Error('invalid instruction; programId is not AddressLookupTable Program');
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $d29309e4a0887ac0$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $d29309e4a0887ac0$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $gbKvo.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $d29309e4a0887ac0$export$7d102200c3a357d6.CreateLookupTable;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $d29309e4a0887ac0$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $d29309e4a0887ac0$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $d29309e4a0887ac0$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $d29309e4a0887ac0$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $d29309e4a0887ac0$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $d29309e4a0887ac0$export$7d102200c3a357d6.CloseLookupTable;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$d29309e4a0887ac0$export$5147a345798de168.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('AddressLookupTab1e1111111111111111111111111');
/**
 * Compute Budget Instruction class
 */ class $d29309e4a0887ac0$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u8('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($d29309e4a0887ac0$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a ComputeBudgetInstruction');
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($d29309e4a0887ac0$export$11585db5942bcdb7.programId)) throw new Error('invalid instruction; programId is not ComputeBudgetProgram');
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $d29309e4a0887ac0$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('units'),
            $3wEH9.u32('additionalFee')
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('bytes')
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('units')
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $d29309e4a0887ac0$var$u64('microLamports')
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $d29309e4a0887ac0$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $d29309e4a0887ac0$export$b7c79c50764da3d6.RequestUnits;
        const data = $d29309e4a0887ac0$var$encodeData(type, params);
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $d29309e4a0887ac0$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $d29309e4a0887ac0$var$encodeData(type, params);
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $d29309e4a0887ac0$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $d29309e4a0887ac0$var$encodeData(type, params);
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $d29309e4a0887ac0$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$d29309e4a0887ac0$export$11585db5942bcdb7.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('ComputeBudget111111111111111111111111111111');
const $d29309e4a0887ac0$var$PRIVATE_KEY_BYTES$1 = 64;
const $d29309e4a0887ac0$var$PUBLIC_KEY_BYTES$1 = 32;
const $d29309e4a0887ac0$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $d29309e4a0887ac0$var$ED25519_INSTRUCTION_LAYOUT = $3wEH9.struct([
    $3wEH9.u8('numSignatures'),
    $3wEH9.u8('padding'),
    $3wEH9.u16('signatureOffset'),
    $3wEH9.u16('signatureInstructionIndex'),
    $3wEH9.u16('publicKeyOffset'),
    $3wEH9.u16('publicKeyInstructionIndex'),
    $3wEH9.u16('messageDataOffset'),
    $3wEH9.u16('messageDataSize'),
    $3wEH9.u16('messageInstructionIndex')
]);
class $d29309e4a0887ac0$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $d29309e4a0887ac0$var$assert(publicKey.length === $d29309e4a0887ac0$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$d29309e4a0887ac0$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $d29309e4a0887ac0$var$assert(signature.length === $d29309e4a0887ac0$var$SIGNATURE_BYTES, `Signature must be ${$d29309e4a0887ac0$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $d29309e4a0887ac0$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $ihoyg.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $d29309e4a0887ac0$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $d29309e4a0887ac0$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $d29309e4a0887ac0$var$assert(privateKey.length === $d29309e4a0887ac0$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$d29309e4a0887ac0$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $d29309e4a0887ac0$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $d29309e4a0887ac0$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$d29309e4a0887ac0$export$e5087aea02631e.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('Ed25519SigVerify111111111111111111111111111');
const $d29309e4a0887ac0$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $75Cpc.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $75Cpc.secp256k1).utils.isValidPrivateKey;
const $d29309e4a0887ac0$var$publicKeyCreate = (0, $75Cpc.secp256k1).getPublicKey;
const $d29309e4a0887ac0$var$PRIVATE_KEY_BYTES = 32;
const $d29309e4a0887ac0$var$ETHEREUM_ADDRESS_BYTES = 20;
const $d29309e4a0887ac0$var$PUBLIC_KEY_BYTES = 64;
const $d29309e4a0887ac0$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $d29309e4a0887ac0$var$SECP256K1_INSTRUCTION_LAYOUT = $3wEH9.struct([
    $3wEH9.u8('numSignatures'),
    $3wEH9.u16('signatureOffset'),
    $3wEH9.u8('signatureInstructionIndex'),
    $3wEH9.u16('ethAddressOffset'),
    $3wEH9.u8('ethAddressInstructionIndex'),
    $3wEH9.u16('messageDataOffset'),
    $3wEH9.u16('messageDataSize'),
    $3wEH9.u8('messageInstructionIndex'),
    $3wEH9.blob(20, 'ethAddress'),
    $3wEH9.blob(64, 'signature'),
    $3wEH9.u8('recoveryId')
]);
class $d29309e4a0887ac0$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $d29309e4a0887ac0$var$assert(publicKey.length === $d29309e4a0887ac0$var$PUBLIC_KEY_BYTES, `Public key must be ${$d29309e4a0887ac0$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $ihoyg.Buffer).from((0, $0e93aae1090a8d90$export$860ddaa9ca84a66d)($d29309e4a0887ac0$var$toBuffer(publicKey))).slice(-$d29309e4a0887ac0$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $d29309e4a0887ac0$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $d29309e4a0887ac0$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === 'string') {
            if (rawAddress.startsWith('0x')) ethAddress = (0, $ihoyg.Buffer).from(rawAddress.substr(2), 'hex');
            else ethAddress = (0, $ihoyg.Buffer).from(rawAddress, 'hex');
        } else ethAddress = rawAddress;
        $d29309e4a0887ac0$var$assert(ethAddress.length === $d29309e4a0887ac0$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$d29309e4a0887ac0$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $d29309e4a0887ac0$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $ihoyg.Buffer).alloc($d29309e4a0887ac0$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $d29309e4a0887ac0$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $d29309e4a0887ac0$var$toBuffer(signature),
            ethAddress: $d29309e4a0887ac0$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($d29309e4a0887ac0$var$toBuffer(message), $d29309e4a0887ac0$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $d29309e4a0887ac0$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $d29309e4a0887ac0$var$assert(pkey.length === $d29309e4a0887ac0$var$PRIVATE_KEY_BYTES, `Private key must be ${$d29309e4a0887ac0$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $d29309e4a0887ac0$var$toBuffer(pkey);
            const publicKey = $d29309e4a0887ac0$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $ihoyg.Buffer).from((0, $0e93aae1090a8d90$export$860ddaa9ca84a66d)($d29309e4a0887ac0$var$toBuffer(message)));
            const [signature, recoveryId] = $d29309e4a0887ac0$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$d29309e4a0887ac0$export$d85dd4c1161d13c9.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('KeccakSecp256k11111111111111111111111111111');
var $d29309e4a0887ac0$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $d29309e4a0887ac0$export$18aac71979bdd08f = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('StakeConfig11111111111111111111111111111111');
/**
 * Stake account authority info
 */ class $d29309e4a0887ac0$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $d29309e4a0887ac0$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$d29309e4a0887ac0$var$_class2 = $d29309e4a0887ac0$export$e7f3941ade35598c;
$d29309e4a0887ac0$export$e7f3941ade35598c.default = new $d29309e4a0887ac0$var$_class2(0, 0, $d29309e4a0887ac0$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $d29309e4a0887ac0$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($d29309e4a0887ac0$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a StakeInstruction');
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $d29309e4a0887ac0$export$9ac74ae66932a145(new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorized.staker), new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $d29309e4a0887ac0$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $d29309e4a0887ac0$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($d29309e4a0887ac0$export$df86f933e9f8fb15.programId)) throw new Error('invalid instruction; programId is not StakeProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $d29309e4a0887ac0$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$authorized(),
            $d29309e4a0887ac0$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('newAuthorized'),
            $3wEH9.u32('stakeAuthorizationType')
        ])
    },
    Delegate: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    Split: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    Withdraw: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    Deactivate: {
        index: 5,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    Merge: {
        index: 7,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('newAuthorized'),
            $3wEH9.u32('stakeAuthorizationType'),
            $d29309e4a0887ac0$var$rustString('authoritySeed'),
            $d29309e4a0887ac0$var$publicKey('authorityOwner')
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $d29309e4a0887ac0$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $d29309e4a0887ac0$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $d29309e4a0887ac0$export$e7f3941ade35598c.default;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Initialize;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            authorized: {
                staker: $d29309e4a0887ac0$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $d29309e4a0887ac0$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $d29309e4a0887ac0$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Delegate;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Authorize;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            newAuthorized: $d29309e4a0887ac0$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            newAuthorized: $d29309e4a0887ac0$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $d29309e4a0887ac0$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Split;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            lamports: lamports
        });
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Merge;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Withdraw;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $d29309e4a0887ac0$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $d29309e4a0887ac0$export$c89793bd2bba8b2e.Deactivate;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$d29309e4a0887ac0$export$df86f933e9f8fb15.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('Stake11111111111111111111111111111111111111');
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $d29309e4a0887ac0$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $d29309e4a0887ac0$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $d29309e4a0887ac0$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a VoteInstruction');
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $d29309e4a0887ac0$export$3f9d1b16ff840d7(new $d29309e4a0887ac0$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $d29309e4a0887ac0$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $d29309e4a0887ac0$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $d29309e4a0887ac0$var$decodeData$1($d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($d29309e4a0887ac0$export$83db2bc702bee1eb.programId)) throw new Error('invalid instruction; programId is not VoteProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$publicKey('newAuthorized'),
            $3wEH9.u32('voteAuthorizationType')
        ])
    },
    Withdraw: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $d29309e4a0887ac0$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $d29309e4a0887ac0$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $d29309e4a0887ac0$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            voteInit: {
                nodePubkey: $d29309e4a0887ac0$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $d29309e4a0887ac0$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $d29309e4a0887ac0$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $d29309e4a0887ac0$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $d29309e4a0887ac0$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $d29309e4a0887ac0$export$febc5573c75cefb0();
        transaction.add($d29309e4a0887ac0$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            newAuthorized: $d29309e4a0887ac0$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $d29309e4a0887ac0$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $d29309e4a0887ac0$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $d29309e4a0887ac0$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $d29309e4a0887ac0$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error('Withdraw will leave vote account with insufficient funds.');
        return $d29309e4a0887ac0$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $d29309e4a0887ac0$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $d29309e4a0887ac0$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $d29309e4a0887ac0$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$d29309e4a0887ac0$export$83db2bc702bee1eb.programId = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $d29309e4a0887ac0$export$83db2bc702bee1eb.space = 3762;
const $d29309e4a0887ac0$export$afdb09d3afdde87c = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('Va1idator1nfo111111111111111111111111111111');
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $d29309e4a0887ac0$var$InfoString = (0, $e87afc78b8edabee$export$bf9fb029d174d554)({
    name: (0, $e87afc78b8edabee$export$22b082955e083ec3)(),
    website: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    details: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$22b082955e083ec3)()),
    keybaseUsername: (0, $e87afc78b8edabee$export$516e28dec6a4b6d4)((0, $e87afc78b8edabee$export$22b082955e083ec3)())
});
/**
 * ValidatorInfo class
 */ class $d29309e4a0887ac0$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $d29309e4a0887ac0$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $d29309e4a0887ac0$export$ca8b6604d6ce14de($d29309e4a0887ac0$var$guardedSplice(byteArray, 0, $d29309e4a0887ac0$export$84fc0a248cc54343));
            const isSigner = $d29309e4a0887ac0$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($d29309e4a0887ac0$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $d29309e4a0887ac0$var$rustString().decode((0, $ihoyg.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $e87afc78b8edabee$export$a7a9523472993e97)(info, $d29309e4a0887ac0$var$InfoString);
                return new $d29309e4a0887ac0$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $d29309e4a0887ac0$export$90bca02a3aea0768 = new $d29309e4a0887ac0$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $d29309e4a0887ac0$var$VoteAccountLayout = $3wEH9.struct([
    $d29309e4a0887ac0$var$publicKey('nodePubkey'),
    $d29309e4a0887ac0$var$publicKey('authorizedWithdrawer'),
    $3wEH9.u8('commission'),
    $3wEH9.nu64(),
    // votes.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('slot'),
        $3wEH9.u32('confirmationCount')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'votes'),
    $3wEH9.u8('rootSlotValid'),
    $3wEH9.nu64('rootSlot'),
    $3wEH9.nu64(),
    // authorizedVoters.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('epoch'),
        $d29309e4a0887ac0$var$publicKey('authorizedVoter')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'authorizedVoters'),
    $3wEH9.struct([
        $3wEH9.seq($3wEH9.struct([
            $d29309e4a0887ac0$var$publicKey('authorizedPubkey'),
            $3wEH9.nu64('epochOfLastAuthorizedSwitch'),
            $3wEH9.nu64('targetEpoch')
        ]), 32, 'buf'),
        $3wEH9.nu64('idx'),
        $3wEH9.u8('isEmpty')
    ], 'priorVoters'),
    $3wEH9.nu64(),
    // epochCredits.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('epoch'),
        $3wEH9.nu64('credits'),
        $3wEH9.nu64('prevCredits')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'epochCredits'),
    $3wEH9.struct([
        $3wEH9.nu64('slot'),
        $3wEH9.nu64('timestamp')
    ], 'lastTimestamp')
]);
/**
 * VoteAccount class
 */ class $d29309e4a0887ac0$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $d29309e4a0887ac0$var$VoteAccountLayout.decode($d29309e4a0887ac0$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $d29309e4a0887ac0$export$89ef186f708d638b({
            nodePubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($d29309e4a0887ac0$var$parseAuthorizedVoter),
            priorVoters: $d29309e4a0887ac0$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $d29309e4a0887ac0$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $d29309e4a0887ac0$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $d29309e4a0887ac0$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $d29309e4a0887ac0$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($d29309e4a0887ac0$var$parsePriorVoters),
        ...buf.slice(0, idx).map($d29309e4a0887ac0$var$parsePriorVoters)
    ];
}
const $d29309e4a0887ac0$var$endpoint = {
    http: {
        devnet: 'http://api.devnet.solana.com',
        testnet: 'http://api.testnet.solana.com',
        'mainnet-beta': 'http://api.mainnet-beta.solana.com/'
    },
    https: {
        devnet: 'https://api.devnet.solana.com',
        testnet: 'https://api.testnet.solana.com',
        'mainnet-beta': 'https://api.mainnet-beta.solana.com/'
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $d29309e4a0887ac0$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? 'http' : 'https';
    if (!cluster) return $d29309e4a0887ac0$var$endpoint[key]['devnet'];
    const url = $d29309e4a0887ac0$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $d29309e4a0887ac0$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'lastValidBlockHeight')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'nonceValue')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $d29309e4a0887ac0$export$5f6a2f2669741bbe = 1000000000;



var $hZS7n = parcelRequire("hZS7n");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $ihoyg = parcelRequire("ihoyg");
var $cfa761622e50d092$require$Buffer = $ihoyg.Buffer;
class $cfa761622e50d092$export$541911c92d3803ed {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage(msg) {
        try {
            const result = await this.provider.signMessage(msg);
            return result.signature;
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
            const response = await this.provider.request({
                method: 'sol_sign',
                params: [
                    solanaWeb3Transaction
                ]
            });
            const publicKey = new (0, $d29309e4a0887ac0$export$ca8b6604d6ce14de)(response.publicKey);
            const sign = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(response.signature);
            solanaWeb3Transaction.addSignature(publicKey, $cfa761622e50d092$require$Buffer.from(sign));
            const raw = solanaWeb3Transaction.serialize();
            return raw;
        };
        try {
            const hash = await (0, $4tkSS.generalSolanaTransactionExecutor)(tx, DefaultSolanaSigner);
            return {
                hash: hash
            };
        } catch (e) {
            const REJECTION_CODE = 4001;
            if (e && typeof e === 'object' && 'code' in e && e.code === REJECTION_CODE) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).REJECTED_BY_USER, undefined, e);
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, e);
        }
    }
}



async function $1c15c6556a99f70c$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $cfa761622e50d092$export$541911c92d3803ed)(solProvider));
    return signers;
}


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
function $5bd48801fede983f$export$98327fbacb25d5d5() {
    const { coin98: coin98 } = window;
    if (!coin98) return null;
    const instances = new Map();
    if (coin98.provider) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, coin98.provider);
    if (coin98.sol) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, coin98.sol);
    return instances;
}
function $5bd48801fede983f$export$62115b9164fa6f77() {
    const instances = $5bd48801fede983f$export$98327fbacb25d5d5();
    if (!instances) throw new Error('Coin98 is not injected. Please check your wallet.');
    return instances;
}
function $5bd48801fede983f$export$a698454c4b869cb() {
    const instances = $5bd48801fede983f$export$98327fbacb25d5d5();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Coin98 not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $5bd48801fede983f$export$f213720757bdbdda() {
    const instances = $5bd48801fede983f$export$98327fbacb25d5d5();
    const solanaInstance = instances?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Coin98 Solana instance is not available. Ensure that Solana support is enabled in your wallet.');
    return solanaInstance;
}


const $376f3ce652ce069b$export$7c460c214963f696 = (0, $9cRHO.WalletTypes).COIN98;
const $376f3ce652ce069b$export$eec1bbb320053d5a = 1000;
const $376f3ce652ce069b$export$dbb5e893e736e4ee = {
    name: 'Coin98',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coin98/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg',
        brave: 'https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg',
        homepage: 'https://coin98.com/wallet'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $1c15c6556a99f70c$export$2e2bcd8739ae039)((0, $5bd48801fede983f$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$9c185a8597ccabf4$var$changeAccountSubscriber, $9c185a8597ccabf4$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $5bd48801fede983f$export$a698454c4b869cb)).build();
const $9c185a8597ccabf4$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $5bd48801fede983f$export$a698454c4b869cb))).before($9c185a8597ccabf4$var$changeAccountSubscriber).or($9c185a8597ccabf4$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $9c185a8597ccabf4$var$disconnect = (0, $f59Be.builders).disconnect().after($9c185a8597ccabf4$var$changeAccountCleanup).build();
const $9c185a8597ccabf4$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $9c185a8597ccabf4$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $5bd48801fede983f$export$a698454c4b869cb))).build();
const $9c185a8597ccabf4$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $376f3ce652ce069b$export$7c460c214963f696)).action($9c185a8597ccabf4$var$connect).action($9c185a8597ccabf4$var$disconnect).action($9c185a8597ccabf4$var$canSwitchNetwork).action($9c185a8597ccabf4$var$getChainId).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


function $8ccd545c5ca20d98$var$connect(getInstance) {
    return async ()=>{
        const solanaInstance = getInstance();
        const connectResult = await solanaInstance.connect();
        return (0, $3b5535826a909102$export$eab97d15b1788b8d).formatAccountsToCAIP(connectResult);
    };
}
const $8ccd545c5ca20d98$export$43912867441655c2 = {
    connect: $8ccd545c5ca20d98$var$connect
};




const [$ebc286eabe61d659$var$changeAccountSubscriber, $ebc286eabe61d659$var$changeAccountCleanup] = (0, $3b5535826a909102$export$aea8daed5328d69c).changeAccountSubscriber((0, $5bd48801fede983f$export$f213720757bdbdda))/*
   * Coin98 returns EVM addresses on account change instead of Solana addresses even though
   * we are listening to the changes on the Solana instance.
   * But if we get the EVM address, it means that we also have permission to eagerly get
   * the Solana address of the new account.
   */ .onSwitchAccount(async (event, context)=>{
    event.preventDefault();
    if (event.payload && event.payload.length !== 0) context.action('connect');
    else context.action('disconnect');
}).addEventListener((instance, callback)=>instance.on('accountsChanged', callback)).removeEventListener((instance, callback)=>instance.off('accountsChanged', callback)).build();
const $ebc286eabe61d659$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $8ccd545c5ca20d98$export$43912867441655c2).connect((0, $5bd48801fede983f$export$f213720757bdbdda))).before($ebc286eabe61d659$var$changeAccountSubscriber).or($ebc286eabe61d659$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $ebc286eabe61d659$var$disconnect = (0, $f59Be.builders).disconnect().after($ebc286eabe61d659$var$changeAccountCleanup).build();
const $ebc286eabe61d659$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $376f3ce652ce069b$export$7c460c214963f696)).action($ebc286eabe61d659$var$connect).action($ebc286eabe61d659$var$disconnect).build();



const $4926b3df3d8808a5$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $376f3ce652ce069b$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $5bd48801fede983f$export$98327fbacb25d5d5)()) {
                setState('installed', true);
                console.debug('[coin98] instance detected.', context);
            }
        }, (0, $376f3ce652ce069b$export$eec1bbb320053d5a));
    }).config('metadata', (0, $376f3ce652ce069b$export$dbb5e893e736e4ee)).add('evm', (0, $9c185a8597ccabf4$export$2f7490c34b49803e)).add('solana', (0, $ebc286eabe61d659$export$ee6400bf8f8c2a0d)).build();


const $6558836aa09bcb2f$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $4926b3df3d8808a5$export$afa934a86232cabe)()).build();




var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $13wKd = parcelRequire("13wKd");

var $hZS7n = parcelRequire("hZS7n");
class $3b1f1a2b3852d2e3$export$c51c8fd6dbcc716f extends (0, $13wKd.DefaultSolanaSigner) {
    constructor(provider){
        super(provider);
    }
    async signMessage(msg) {
        const { signature: signature } = await this.provider.signMessage(msg);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(signature);
    }
}



async function $f99a74e4d7d07fd1$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $3b1f1a2b3852d2e3$export$c51c8fd6dbcc716f)(solProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $ba40899a1957e39e$export$15e9669680853bb4() {
    const { coinbaseWalletExtension: coinbaseWalletExtension, coinbaseSolana: coinbaseSolana } = window;
    if (!coinbaseSolana && !coinbaseWalletExtension) return null;
    const instances = new Map();
    if (coinbaseWalletExtension) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, coinbaseWalletExtension);
    if (coinbaseSolana) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, coinbaseSolana);
    return instances;
}
function $ba40899a1957e39e$export$3862064932f77df7() {
    const instances = $ba40899a1957e39e$export$15e9669680853bb4();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Coinbase not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $ba40899a1957e39e$export$79a192613e202622() {
    const instance = $ba40899a1957e39e$export$15e9669680853bb4();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Coinbase not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}
function $ba40899a1957e39e$export$62115b9164fa6f77() {
    const instances = $ba40899a1957e39e$export$15e9669680853bb4();
    if (!instances) throw new Error('Coinbase is not injected. Please check your wallet.');
    return instances;
}
async function $ba40899a1957e39e$export$a009f0f0c363aa6c(instance) {
    await instance.connect();
    const account = instance.publicKey.toString();
    return {
        accounts: [
            account
        ],
        chainId: (0, $9HEDW.LegacyNetworks).SOLANA
    };
}


const $f3f48a1ac9eb0ec6$var$WALLET = (0, $9cRHO.WalletTypes).COINBASE;
const $f3f48a1ac9eb0ec6$export$e506a1d27d1eaa20 = {
    type: $f3f48a1ac9eb0ec6$var$WALLET,
    defaultNetwork: (0, $9HEDW.LegacyNetworks).ETHEREUM
};
const $f3f48a1ac9eb0ec6$export$8bedcca5bbd73999 = (0, $ba40899a1957e39e$export$15e9669680853bb4);
const $f3f48a1ac9eb0ec6$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const evm_instance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const results = [];
    if (evm_instance) {
        const evm = await (0, $gSYt0.getEvmAccounts)(evm_instance);
        results.push(evm);
    }
    const solanaInstance = (0, $ba40899a1957e39e$export$79a192613e202622)();
    if (solanaInstance) {
        const solanaResults = await (0, $ba40899a1957e39e$export$a009f0f0c363aa6c)(solanaInstance);
        results.push(solanaResults);
    }
    return results;
};
const $f3f48a1ac9eb0ec6$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solanaInstance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, (0, $9HEDW.LegacyNetworks).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $hE77Y.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $9HEDW.LegacyNetworks).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleSolanaAccountChanged = async (publicKey)=>{
        if (state.network != (0, $9HEDW.LegacyNetworks).SOLANA) updateChainId(meta.filter((0, $hE77Y.isSolanaBlockchain))[0].chainId);
        const network = (0, $9HEDW.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    ethInstance?.on?.('accountsChanged', handleEvmAccountsChanged);
    solanaInstance?.on?.('accountChanged', handleSolanaAccountChanged);
    return ()=>{
        ethInstance?.off?.('accountsChanged', handleEvmAccountsChanged);
        solanaInstance?.off?.('accountChanged', handleSolanaAccountChanged);
    };
};
const $f3f48a1ac9eb0ec6$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $f3f48a1ac9eb0ec6$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $f3f48a1ac9eb0ec6$export$6352a17a50193ded = (0, $f99a74e4d7d07fd1$export$2e2bcd8739ae039);
const $f3f48a1ac9eb0ec6$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $gSYt0.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $f3f48a1ac9eb0ec6$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    const solana = (0, $hE77Y.solanaBlockchain)(allBlockChains);
    return {
        name: 'Coinbase',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coinbase/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad',
            BRAVE: 'https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad',
            DEFAULT: 'https://www.coinbase.com/wallet'
        },
        color: '#2a62f5',
        supportedChains: [
            ...evms,
            ...solana
        ],
        needsNamespace: {
            selection: 'multiple',
            data: [
                {
                    label: 'EVM',
                    value: 'EVM',
                    id: 'ETH',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                },
                {
                    label: 'Solana',
                    value: 'Solana',
                    id: 'SOLANA',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                }
            ]
        }
    };
};
const $f3f48a1ac9eb0ec6$export$107c8cc6b37a1ffa = ()=>({
        config: $f3f48a1ac9eb0ec6$export$e506a1d27d1eaa20,
        getInstance: $f3f48a1ac9eb0ec6$export$8bedcca5bbd73999,
        connect: $f3f48a1ac9eb0ec6$export$64605811ab45167f,
        subscribe: $f3f48a1ac9eb0ec6$export$ec068583843480e7,
        switchNetwork: $f3f48a1ac9eb0ec6$export$f3473d805e486329,
        canSwitchNetworkTo: $f3f48a1ac9eb0ec6$export$3b3cf9ab9019de20,
        getSigners: $f3f48a1ac9eb0ec6$export$6352a17a50193ded,
        getWalletInfo: $f3f48a1ac9eb0ec6$export$e5b9d96c6aeb3ff7,
        canEagerConnect: $f3f48a1ac9eb0ec6$export$be9f3c5ed1d25e42
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");


const $689446bbfbbded90$export$7c460c214963f696 = 'coinbase';
const $689446bbfbbded90$export$dbb5e893e736e4ee = {
    name: 'Coinbase',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coinbase/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad',
        brave: 'https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad',
        homepage: 'https://www.coinbase.com/wallet'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $f99a74e4d7d07fd1$export$2e2bcd8739ae039)((0, $ba40899a1957e39e$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$33780b89926f8b98$var$changeAccountSubscriber, $33780b89926f8b98$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $ba40899a1957e39e$export$3862064932f77df7))/*
   * Coinbase returns an array of connected accounts with the active one first.
   * Since we only need the active account, we take the first element as a workaround.
   */ .format(async (instance, accounts)=>{
    const chainId = await instance.request({
        method: 'eth_chainId'
    });
    return (0, $795b2611c2574d92$export$eab97d15b1788b8d).formatAccountsToCAIP([
        accounts[0]
    ], chainId);
}).build();
const $33780b89926f8b98$var$connect = new (0, $fha7R.ActionBuilder)('connect').action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $ba40899a1957e39e$export$3862064932f77df7)))/*
   * Coinbase Wallet's `connect` returns a list where the currently selected account
   * is always the first item. We're directly taking this first item as the active account.
   *
   * ***NOTE***: Please keep it synced with `wallets/core/src/namespaces/solana/builders.ts`.
   *
   */ .and((_, connectResult)=>({
        ...connectResult,
        accounts: [
            connectResult.accounts[0]
        ]
    })).and((0, $f59Be.connectAndUpdateStateForMultiNetworks)).before((0, $f59Be.intoConnecting)).before($33780b89926f8b98$var$changeAccountSubscriber).or($33780b89926f8b98$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).after((0, $f59Be.intoConnectionFinished)).build();
const $33780b89926f8b98$var$disconnect = (0, $f59Be.builders).disconnect().before(()=>{
    /*
     * Coinbase sometimes stays connected and causes the page to refresh.
     * This ensures we also disconnect from the wallet to prevent that behavior.
     */ (0, $ba40899a1957e39e$export$3862064932f77df7)().disconnect();
}).after($33780b89926f8b98$var$changeAccountCleanup).build();
const $33780b89926f8b98$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $ba40899a1957e39e$export$3862064932f77df7))).build();
const $33780b89926f8b98$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $33780b89926f8b98$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $ba40899a1957e39e$export$3862064932f77df7))).build();
const $33780b89926f8b98$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $689446bbfbbded90$export$7c460c214963f696)).action($33780b89926f8b98$var$connect).action($33780b89926f8b98$var$disconnect).action($33780b89926f8b98$var$canEagerConnect).action($33780b89926f8b98$var$canSwitchNetwork).action($33780b89926f8b98$var$getChainId).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


/*
 * Coinbase does not provide an eager connection mechanism for its Solana wallet.
 * The only workaround is to use the EVM-based eager connect approach.
 * However, this will only work if the EVM namespace has been connected at least once before.
 * If either wallet instance is unavailable, we throw an error.
 */ const $a39d1399cf47a2ea$var$canEagerConnectAction = async ()=>{
    const evmInstance = (0, $ba40899a1957e39e$export$3862064932f77df7)();
    const solanaInstance = (0, $ba40899a1957e39e$export$79a192613e202622)();
    // Making sure that the Solana instance is available first to prevent errors.
    if (!solanaInstance) throw new Error('Trying to eagerly connect to your wallet, but seems its solana instance is not available.');
    if (!evmInstance) throw new Error('Trying to eagerly connect to your EVM wallet, but seems its instance is not available.');
    try {
        const accounts = await evmInstance.request({
            method: 'eth_accounts'
        });
        if (accounts.length) return true;
        return false;
    } catch  {
        return false;
    }
};
const $a39d1399cf47a2ea$export$43912867441655c2 = {
    canEagerConnectAction: $a39d1399cf47a2ea$var$canEagerConnectAction
};




const [$d39acfa13d2933ee$var$changeAccountSubscriber, $d39acfa13d2933ee$var$changeAccountCleanup] = (0, $3b5535826a909102$export$aea8daed5328d69c).changeAccountSubscriber((0, $ba40899a1957e39e$export$79a192613e202622)).build();
const $d39acfa13d2933ee$var$connect = new (0, $fha7R.ActionBuilder)('connect').action((0, $3b5535826a909102$export$e324594224ef24da).connect((0, $ba40899a1957e39e$export$79a192613e202622)))/*
   * Coinbase Wallet's `connect` returns a list where the currently selected account
   * is always the first item. We're directly taking this first item as the active account.
   */ .and((_, connectResult)=>[
        connectResult[0]
    ]).and((0, $f59Be.connectAndUpdateStateForSingleNetwork)).before((0, $f59Be.intoConnecting)).before($d39acfa13d2933ee$var$changeAccountSubscriber).after((0, $f59Be.intoConnectionFinished)).or($d39acfa13d2933ee$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $d39acfa13d2933ee$var$disconnect = (0, $f59Be.builders).disconnect().before(()=>{
    /*
     * Coinbase sometimes stays connected and causes the page to refresh.
     * This ensures we also disconnect from the wallet to prevent that behavior.
     */ (0, $ba40899a1957e39e$export$79a192613e202622)().disconnect();
}).after($d39acfa13d2933ee$var$changeAccountCleanup).build();
const $d39acfa13d2933ee$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $a39d1399cf47a2ea$export$43912867441655c2).canEagerConnectAction).build();
const $d39acfa13d2933ee$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $689446bbfbbded90$export$7c460c214963f696)).action($d39acfa13d2933ee$var$connect).action($d39acfa13d2933ee$var$disconnect).action($d39acfa13d2933ee$var$canEagerConnect).build();



const $df03465056407171$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $689446bbfbbded90$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $ba40899a1957e39e$export$15e9669680853bb4)()) {
            setState('installed', true);
            console.debug('[coinbase] instance detected.', context);
        }
    }).config('metadata', (0, $689446bbfbbded90$export$dbb5e893e736e4ee)).add('solana', (0, $d39acfa13d2933ee$export$ee6400bf8f8c2a0d)).add('evm', (0, $33780b89926f8b98$export$2f7490c34b49803e)).build();


const $e8dc4df19f88520c$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $f3f48a1ac9eb0ec6$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $df03465056407171$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");


async function $b072a8f6701b2597$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).COSMOS);
    const evmProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultCosmosSigner: DefaultCosmosSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("f6MG1")));
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(evmProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).COSMOS, new DefaultCosmosSigner(cosmosProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $6f99bac7a53781a2$export$f10fc90c2179d193() {
    const { cosmostation: cosmostation } = window;
    const instances = new Map();
    if (!cosmostation || !cosmostation.providers) return null;
    const evmInstance = cosmostation.providers.metamask;
    if (evmInstance) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, evmInstance);
    const cosmosInstance = cosmostation.providers.keplr;
    if (cosmosInstance) instances.set((0, $9HEDW.LegacyNetworks).COSMOS, cosmosInstance);
    if (instances.size === 0) return null;
    return instances;
}
function $6f99bac7a53781a2$export$62115b9164fa6f77() {
    const instances = $6f99bac7a53781a2$export$f10fc90c2179d193();
    if (!instances) throw new Error('Cosmostation Wallet is not injected. Please check your wallet.');
    return instances;
}
function $6f99bac7a53781a2$export$90b44d4f48642d60() {
    const instances = $6f99bac7a53781a2$export$f10fc90c2179d193();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Cosmostation Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $6f99bac7a53781a2$export$3a0834928c0d49b() {
    const instance = $6f99bac7a53781a2$export$f10fc90c2179d193();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).COSMOS);
    if (!solanaInstance) throw new Error('Cosmostation Wallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}


const $f0ac5d07b43a6b11$export$7c460c214963f696 = 'cosmostation';
const $f0ac5d07b43a6b11$export$2d687fc1bd6ada84 = 1000;
const $f0ac5d07b43a6b11$export$dbb5e893e736e4ee = {
    name: 'Cosmostation',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/cosmostation/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf',
        brave: 'https://chrome.google.com/webstore/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf',
        homepage: 'https://cosmostation.io/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Cosmos',
                        value: 'Cosmos',
                        id: 'COSMOS',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.cosmosBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $b072a8f6701b2597$export$2e2bcd8739ae039)((0, $6f99bac7a53781a2$export$62115b9164fa6f77)())
            }
        }
    ]
};


var $4e4e07fbc7086f67$exports = {};
"use strict";
var $4e4e07fbc7086f67$var$__createBinding = $4e4e07fbc7086f67$exports && $4e4e07fbc7086f67$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e4e07fbc7086f67$var$__exportStar = $4e4e07fbc7086f67$exports && $4e4e07fbc7086f67$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4e4e07fbc7086f67$var$__createBinding(exports1, m, p);
};
Object.defineProperty($4e4e07fbc7086f67$exports, "__esModule", {
    value: true
});

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("dTrds")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("lWBwx")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("4Ve8M")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("3kRIM")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("cDipa")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("SezG1")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("hXbrg")), $4e4e07fbc7086f67$exports);


var $99efb2e94f0cb07b$exports = {};
'use strict';

var $5SJmA = parcelRequire("5SJmA");

var $5h1gV = parcelRequire("5h1gV");
var $d784ca79df3eec32$exports = {};
'use strict';

var $55cMj = parcelRequire("55cMj");

var $5h1gV = parcelRequire("5h1gV");
var $d784ca79df3eec32$require$MAX_LENGTH = $5h1gV.MAX_LENGTH;
var $d784ca79df3eec32$require$MAX_SAFE_INTEGER = $5h1gV.MAX_SAFE_INTEGER;

var $5SJmA = parcelRequire("5SJmA");
var $d784ca79df3eec32$require$re = $5SJmA.safeRe;
var $d784ca79df3eec32$require$t = $5SJmA.t;
var $5af4e608a8edf16d$exports = {};
'use strict';
// parse out just the options we care about
const $5af4e608a8edf16d$var$looseOption = Object.freeze({
    loose: true
});
const $5af4e608a8edf16d$var$emptyOpts = Object.freeze({});
const $5af4e608a8edf16d$var$parseOptions = (options)=>{
    if (!options) return $5af4e608a8edf16d$var$emptyOpts;
    if (typeof options !== 'object') return $5af4e608a8edf16d$var$looseOption;
    return options;
};
$5af4e608a8edf16d$exports = $5af4e608a8edf16d$var$parseOptions;


var $ee5030db3bda8271$exports = {};
'use strict';
const $ee5030db3bda8271$var$numeric = /^[0-9]+$/;
const $ee5030db3bda8271$var$compareIdentifiers = (a, b)=>{
    if (typeof a === 'number' && typeof b === 'number') return a === b ? 0 : a < b ? -1 : 1;
    const anum = $ee5030db3bda8271$var$numeric.test(a);
    const bnum = $ee5030db3bda8271$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ee5030db3bda8271$var$rcompareIdentifiers = (a, b)=>$ee5030db3bda8271$var$compareIdentifiers(b, a);
$ee5030db3bda8271$exports = {
    compareIdentifiers: $ee5030db3bda8271$var$compareIdentifiers,
    rcompareIdentifiers: $ee5030db3bda8271$var$rcompareIdentifiers
};


var $d784ca79df3eec32$require$compareIdentifiers = $ee5030db3bda8271$exports.compareIdentifiers;
class $d784ca79df3eec32$var$SemVer {
    constructor(version, options){
        options = $5af4e608a8edf16d$exports(options);
        if (version instanceof $d784ca79df3eec32$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $d784ca79df3eec32$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$d784ca79df3eec32$require$MAX_LENGTH} characters`);
        $55cMj('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $d784ca79df3eec32$require$re[$d784ca79df3eec32$require$t.LOOSE] : $d784ca79df3eec32$require$re[$d784ca79df3eec32$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $d784ca79df3eec32$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > $d784ca79df3eec32$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > $d784ca79df3eec32$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $d784ca79df3eec32$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $55cMj('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof $d784ca79df3eec32$var$SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new $d784ca79df3eec32$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $d784ca79df3eec32$var$SemVer)) other = new $d784ca79df3eec32$var$SemVer(other, this.options);
        if (this.major < other.major) return -1;
        if (this.major > other.major) return 1;
        if (this.minor < other.minor) return -1;
        if (this.minor > other.minor) return 1;
        if (this.patch < other.patch) return -1;
        if (this.patch > other.patch) return 1;
        return 0;
    }
    comparePre(other) {
        if (!(other instanceof $d784ca79df3eec32$var$SemVer)) other = new $d784ca79df3eec32$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $55cMj('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $d784ca79df3eec32$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $d784ca79df3eec32$var$SemVer)) other = new $d784ca79df3eec32$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $55cMj('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $d784ca79df3eec32$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const match = `-${identifier}`.match(this.options.loose ? $d784ca79df3eec32$require$re[$d784ca79df3eec32$require$t.PRERELEASELOOSE] : $d784ca79df3eec32$require$re[$d784ca79df3eec32$require$t.PRERELEASE]);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($d784ca79df3eec32$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
$d784ca79df3eec32$exports = $d784ca79df3eec32$var$SemVer;



var $c47b982b2f876dc7$exports = {};
'use strict';

const $c47b982b2f876dc7$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $d784ca79df3eec32$exports) return version;
    try {
        return new $d784ca79df3eec32$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$c47b982b2f876dc7$exports = $c47b982b2f876dc7$var$parse;


var $bb1a16aa81b7c201$exports = {};
'use strict';

const $bb1a16aa81b7c201$var$valid = (version, options)=>{
    const v = $c47b982b2f876dc7$exports(version, options);
    return v ? v.version : null;
};
$bb1a16aa81b7c201$exports = $bb1a16aa81b7c201$var$valid;


var $183c3208889fde65$exports = {};
'use strict';

const $183c3208889fde65$var$clean = (version, options)=>{
    const s = $c47b982b2f876dc7$exports(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
$183c3208889fde65$exports = $183c3208889fde65$var$clean;


var $6dc49bb2eb7ce026$exports = {};
'use strict';

const $6dc49bb2eb7ce026$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $d784ca79df3eec32$exports(version instanceof $d784ca79df3eec32$exports ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
$6dc49bb2eb7ce026$exports = $6dc49bb2eb7ce026$var$inc;


var $40b4d954793c783a$exports = {};
'use strict';

const $40b4d954793c783a$var$diff = (version1, version2)=>{
    const v1 = $c47b982b2f876dc7$exports(version1, null, true);
    const v2 = $c47b982b2f876dc7$exports(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
$40b4d954793c783a$exports = $40b4d954793c783a$var$diff;


var $24b49f718161bca0$exports = {};
'use strict';

const $24b49f718161bca0$var$major = (a, loose)=>new $d784ca79df3eec32$exports(a, loose).major;
$24b49f718161bca0$exports = $24b49f718161bca0$var$major;


var $c4982f38992abc17$exports = {};
'use strict';

const $c4982f38992abc17$var$minor = (a, loose)=>new $d784ca79df3eec32$exports(a, loose).minor;
$c4982f38992abc17$exports = $c4982f38992abc17$var$minor;


var $eb5774d0871f4264$exports = {};
'use strict';

const $eb5774d0871f4264$var$patch = (a, loose)=>new $d784ca79df3eec32$exports(a, loose).patch;
$eb5774d0871f4264$exports = $eb5774d0871f4264$var$patch;


var $ce8a68c942ae0d1d$exports = {};
'use strict';

const $ce8a68c942ae0d1d$var$prerelease = (version, options)=>{
    const parsed = $c47b982b2f876dc7$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$ce8a68c942ae0d1d$exports = $ce8a68c942ae0d1d$var$prerelease;


var $b5683ebc1599fb75$exports = {};
'use strict';

const $b5683ebc1599fb75$var$compare = (a, b, loose)=>new $d784ca79df3eec32$exports(a, loose).compare(new $d784ca79df3eec32$exports(b, loose));
$b5683ebc1599fb75$exports = $b5683ebc1599fb75$var$compare;


var $f853848c75d33d8a$exports = {};
'use strict';

const $f853848c75d33d8a$var$rcompare = (a, b, loose)=>$b5683ebc1599fb75$exports(b, a, loose);
$f853848c75d33d8a$exports = $f853848c75d33d8a$var$rcompare;


var $c6ff8b80b7f3da24$exports = {};
'use strict';

const $c6ff8b80b7f3da24$var$compareLoose = (a, b)=>$b5683ebc1599fb75$exports(a, b, true);
$c6ff8b80b7f3da24$exports = $c6ff8b80b7f3da24$var$compareLoose;


var $a9bf654280bacccd$exports = {};
'use strict';

const $a9bf654280bacccd$var$compareBuild = (a, b, loose)=>{
    const versionA = new $d784ca79df3eec32$exports(a, loose);
    const versionB = new $d784ca79df3eec32$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$a9bf654280bacccd$exports = $a9bf654280bacccd$var$compareBuild;


var $6bcc1306d1dfab5a$exports = {};
'use strict';

const $6bcc1306d1dfab5a$var$sort = (list, loose)=>list.sort((a, b)=>$a9bf654280bacccd$exports(a, b, loose));
$6bcc1306d1dfab5a$exports = $6bcc1306d1dfab5a$var$sort;


var $1cb3f218be54e0bb$exports = {};
'use strict';

const $1cb3f218be54e0bb$var$rsort = (list, loose)=>list.sort((a, b)=>$a9bf654280bacccd$exports(b, a, loose));
$1cb3f218be54e0bb$exports = $1cb3f218be54e0bb$var$rsort;


var $e47208be82aa828c$exports = {};
'use strict';

const $e47208be82aa828c$var$gt = (a, b, loose)=>$b5683ebc1599fb75$exports(a, b, loose) > 0;
$e47208be82aa828c$exports = $e47208be82aa828c$var$gt;


var $701493f0098e4ed5$exports = {};
'use strict';

const $701493f0098e4ed5$var$lt = (a, b, loose)=>$b5683ebc1599fb75$exports(a, b, loose) < 0;
$701493f0098e4ed5$exports = $701493f0098e4ed5$var$lt;


var $8672096e82830f01$exports = {};
'use strict';

const $8672096e82830f01$var$eq = (a, b, loose)=>$b5683ebc1599fb75$exports(a, b, loose) === 0;
$8672096e82830f01$exports = $8672096e82830f01$var$eq;


var $f8a890d03029a552$exports = {};
'use strict';

const $f8a890d03029a552$var$neq = (a, b, loose)=>$b5683ebc1599fb75$exports(a, b, loose) !== 0;
$f8a890d03029a552$exports = $f8a890d03029a552$var$neq;


var $c35fcc5e918bc343$exports = {};
'use strict';

const $c35fcc5e918bc343$var$gte = (a, b, loose)=>$b5683ebc1599fb75$exports(a, b, loose) >= 0;
$c35fcc5e918bc343$exports = $c35fcc5e918bc343$var$gte;


var $a8853a3a880dbb43$exports = {};
'use strict';

const $a8853a3a880dbb43$var$lte = (a, b, loose)=>$b5683ebc1599fb75$exports(a, b, loose) <= 0;
$a8853a3a880dbb43$exports = $a8853a3a880dbb43$var$lte;


var $675b37cc12b91af1$exports = {};
'use strict';






const $675b37cc12b91af1$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return $8672096e82830f01$exports(a, b, loose);
        case '!=':
            return $f8a890d03029a552$exports(a, b, loose);
        case '>':
            return $e47208be82aa828c$exports(a, b, loose);
        case '>=':
            return $c35fcc5e918bc343$exports(a, b, loose);
        case '<':
            return $701493f0098e4ed5$exports(a, b, loose);
        case '<=':
            return $a8853a3a880dbb43$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$675b37cc12b91af1$exports = $675b37cc12b91af1$var$cmp;


var $c9e91599466ee0da$exports = {};
'use strict';



var $5SJmA = parcelRequire("5SJmA");
var $c9e91599466ee0da$require$re = $5SJmA.safeRe;
var $c9e91599466ee0da$require$t = $5SJmA.t;
const $c9e91599466ee0da$var$coerce = (version, options)=>{
    if (version instanceof $d784ca79df3eec32$exports) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $c9e91599466ee0da$require$re[$c9e91599466ee0da$require$t.COERCEFULL] : $c9e91599466ee0da$require$re[$c9e91599466ee0da$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $c9e91599466ee0da$require$re[$c9e91599466ee0da$require$t.COERCERTLFULL] : $c9e91599466ee0da$require$re[$c9e91599466ee0da$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return $c47b982b2f876dc7$exports(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
$c9e91599466ee0da$exports = $c9e91599466ee0da$var$coerce;


var $4dd58727d26fed71$exports = {};
'use strict';
const $4dd58727d26fed71$var$ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class $4dd58727d26fed71$var$Comparator {
    static get ANY() {
        return $4dd58727d26fed71$var$ANY;
    }
    constructor(comp, options){
        options = $5af4e608a8edf16d$exports(options);
        if (comp instanceof $4dd58727d26fed71$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        $55cMj('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $4dd58727d26fed71$var$ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        $55cMj('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? $4dd58727d26fed71$require$re[$4dd58727d26fed71$require$t.COMPARATORLOOSE] : $4dd58727d26fed71$require$re[$4dd58727d26fed71$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $4dd58727d26fed71$var$ANY;
        else this.semver = new $d784ca79df3eec32$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $55cMj('Comparator.test', version, this.options.loose);
        if (this.semver === $4dd58727d26fed71$var$ANY || version === $4dd58727d26fed71$var$ANY) return true;
        if (typeof version === 'string') try {
            version = new $d784ca79df3eec32$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $675b37cc12b91af1$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $4dd58727d26fed71$var$Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new $9b1a143f910b9eea$exports(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new $9b1a143f910b9eea$exports(this.value, options).test(comp.semver);
        }
        options = $5af4e608a8edf16d$exports(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if ($675b37cc12b91af1$exports(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if ($675b37cc12b91af1$exports(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
$4dd58727d26fed71$exports = $4dd58727d26fed71$var$Comparator;


var $5SJmA = parcelRequire("5SJmA");
var $4dd58727d26fed71$require$re = $5SJmA.safeRe;
var $4dd58727d26fed71$require$t = $5SJmA.t;


var $55cMj = parcelRequire("55cMj");

var $9b1a143f910b9eea$exports = {};
'use strict';
const $9b1a143f910b9eea$var$SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class $9b1a143f910b9eea$var$Range {
    constructor(range, options){
        options = $5af4e608a8edf16d$exports(options);
        if (range instanceof $9b1a143f910b9eea$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $9b1a143f910b9eea$var$Range(range.raw, options);
        }
        if (range instanceof $4dd58727d26fed71$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace($9b1a143f910b9eea$var$SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$9b1a143f910b9eea$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $9b1a143f910b9eea$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $9b1a143f910b9eea$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $9b1a143f910b9eea$require$FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = $9b1a143f910b9eea$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.HYPHENRANGELOOSE] : $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.HYPHENRANGE];
        range = range.replace(hr, $9b1a143f910b9eea$var$hyphenReplace(this.options.includePrerelease));
        $55cMj('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.COMPARATORTRIM], $9b1a143f910b9eea$require$comparatorTrimReplace);
        $55cMj('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.TILDETRIM], $9b1a143f910b9eea$require$tildeTrimReplace);
        $55cMj('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.CARETTRIM], $9b1a143f910b9eea$require$caretTrimReplace);
        $55cMj('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>$9b1a143f910b9eea$var$parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$9b1a143f910b9eea$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $55cMj('loose invalid filter', comp, this.options);
            return !!comp.match($9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.COMPARATORLOOSE]);
        });
        $55cMj('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $4dd58727d26fed71$exports(comp, this.options));
        for (const comp of comparators){
            if ($9b1a143f910b9eea$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        $9b1a143f910b9eea$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $9b1a143f910b9eea$var$Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return $9b1a143f910b9eea$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $9b1a143f910b9eea$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new $d784ca79df3eec32$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($9b1a143f910b9eea$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$9b1a143f910b9eea$exports = $9b1a143f910b9eea$var$Range;
var $07ba6925f335637e$exports = {};
'use strict';
class $07ba6925f335637e$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
$07ba6925f335637e$exports = $07ba6925f335637e$var$LRUCache;


const $9b1a143f910b9eea$var$cache = new $07ba6925f335637e$exports();



var $55cMj = parcelRequire("55cMj");


var $5SJmA = parcelRequire("5SJmA");
var $9b1a143f910b9eea$require$re = $5SJmA.safeRe;
var $9b1a143f910b9eea$require$t = $5SJmA.t;
var $9b1a143f910b9eea$require$comparatorTrimReplace = $5SJmA.comparatorTrimReplace;
var $9b1a143f910b9eea$require$tildeTrimReplace = $5SJmA.tildeTrimReplace;
var $9b1a143f910b9eea$require$caretTrimReplace = $5SJmA.caretTrimReplace;

var $5h1gV = parcelRequire("5h1gV");
var $9b1a143f910b9eea$require$FLAG_INCLUDE_PRERELEASE = $5h1gV.FLAG_INCLUDE_PRERELEASE;
var $9b1a143f910b9eea$require$FLAG_LOOSE = $5h1gV.FLAG_LOOSE;
const $9b1a143f910b9eea$var$isNullSet = (c)=>c.value === '<0.0.0-0';
const $9b1a143f910b9eea$var$isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $9b1a143f910b9eea$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $9b1a143f910b9eea$var$parseComparator = (comp, options)=>{
    comp = comp.replace($9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.BUILD], '');
    $55cMj('comp', comp, options);
    comp = $9b1a143f910b9eea$var$replaceCarets(comp, options);
    $55cMj('caret', comp);
    comp = $9b1a143f910b9eea$var$replaceTildes(comp, options);
    $55cMj('tildes', comp);
    comp = $9b1a143f910b9eea$var$replaceXRanges(comp, options);
    $55cMj('xrange', comp);
    comp = $9b1a143f910b9eea$var$replaceStars(comp, options);
    $55cMj('stars', comp);
    return comp;
};
const $9b1a143f910b9eea$var$isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $9b1a143f910b9eea$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$9b1a143f910b9eea$var$replaceTilde(c, options)).join(' ');
};
const $9b1a143f910b9eea$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.TILDELOOSE] : $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $55cMj('tilde', comp, _, M, m, p, pr);
        let ret;
        if ($9b1a143f910b9eea$var$isX(M)) ret = '';
        else if ($9b1a143f910b9eea$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($9b1a143f910b9eea$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $55cMj('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $55cMj('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $9b1a143f910b9eea$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$9b1a143f910b9eea$var$replaceCaret(c, options)).join(' ');
};
const $9b1a143f910b9eea$var$replaceCaret = (comp, options)=>{
    $55cMj('caret', comp, options);
    const r = options.loose ? $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.CARETLOOSE] : $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        $55cMj('caret', comp, _, M, m, p, pr);
        let ret;
        if ($9b1a143f910b9eea$var$isX(M)) ret = '';
        else if ($9b1a143f910b9eea$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($9b1a143f910b9eea$var$isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $55cMj('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $55cMj('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $55cMj('caret return', ret);
        return ret;
    });
};
const $9b1a143f910b9eea$var$replaceXRanges = (comp, options)=>{
    $55cMj('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>$9b1a143f910b9eea$var$replaceXRange(c, options)).join(' ');
};
const $9b1a143f910b9eea$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.XRANGELOOSE] : $9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $55cMj('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = $9b1a143f910b9eea$var$isX(M);
        const xm = xM || $9b1a143f910b9eea$var$isX(m);
        const xp = xm || $9b1a143f910b9eea$var$isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $55cMj('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $9b1a143f910b9eea$var$replaceStars = (comp, options)=>{
    $55cMj('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($9b1a143f910b9eea$require$re[$9b1a143f910b9eea$require$t.STAR], '');
};
const $9b1a143f910b9eea$var$replaceGTE0 = (comp, options)=>{
    $55cMj('replaceGTE0', comp, options);
    return comp.trim().replace($9b1a143f910b9eea$require$re[options.includePrerelease ? $9b1a143f910b9eea$require$t.GTE0PRE : $9b1a143f910b9eea$require$t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $9b1a143f910b9eea$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($9b1a143f910b9eea$var$isX(fM)) from = '';
        else if ($9b1a143f910b9eea$var$isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if ($9b1a143f910b9eea$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if ($9b1a143f910b9eea$var$isX(tM)) to = '';
        else if ($9b1a143f910b9eea$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($9b1a143f910b9eea$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $9b1a143f910b9eea$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $55cMj(set[i].semver);
            if (set[i].semver === $4dd58727d26fed71$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $a46a09b84b6afa68$exports = {};
'use strict';

const $a46a09b84b6afa68$var$satisfies = (version, range, options)=>{
    try {
        range = new $9b1a143f910b9eea$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$a46a09b84b6afa68$exports = $a46a09b84b6afa68$var$satisfies;


var $f4eade25bb60a3b4$exports = {};
'use strict';

// Mostly just for testing and legacy API reasons
const $f4eade25bb60a3b4$var$toComparators = (range, options)=>new $9b1a143f910b9eea$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
$f4eade25bb60a3b4$exports = $f4eade25bb60a3b4$var$toComparators;


var $497b3954dd63343c$exports = {};
'use strict';


const $497b3954dd63343c$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $9b1a143f910b9eea$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $d784ca79df3eec32$exports(max, options);
            }
        }
    });
    return max;
};
$497b3954dd63343c$exports = $497b3954dd63343c$var$maxSatisfying;


var $54fbf0076cdeea84$exports = {};
'use strict';


const $54fbf0076cdeea84$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $9b1a143f910b9eea$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $d784ca79df3eec32$exports(min, options);
            }
        }
    });
    return min;
};
$54fbf0076cdeea84$exports = $54fbf0076cdeea84$var$minSatisfying;


var $f4506f55b8639719$exports = {};
'use strict';



const $f4506f55b8639719$var$minVersion = (range, loose)=>{
    range = new $9b1a143f910b9eea$exports(range, loose);
    let minver = new $d784ca79df3eec32$exports('0.0.0');
    if (range.test(minver)) return minver;
    minver = new $d784ca79df3eec32$exports('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $d784ca79df3eec32$exports(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || $e47208be82aa828c$exports(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $e47208be82aa828c$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$f4506f55b8639719$exports = $f4506f55b8639719$var$minVersion;


var $c16f64282ff1c050$exports = {};
'use strict';

const $c16f64282ff1c050$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $9b1a143f910b9eea$exports(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
$c16f64282ff1c050$exports = $c16f64282ff1c050$var$validRange;


var $5783a9560ffb1794$exports = {};
'use strict';


const { ANY: $5783a9560ffb1794$var$ANY } = $4dd58727d26fed71$exports;






const $5783a9560ffb1794$var$outside = (version, range, hilo, options)=>{
    version = new $d784ca79df3eec32$exports(version, options);
    range = new $9b1a143f910b9eea$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = $e47208be82aa828c$exports;
            ltefn = $a8853a3a880dbb43$exports;
            ltfn = $701493f0098e4ed5$exports;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = $701493f0098e4ed5$exports;
            ltefn = $c35fcc5e918bc343$exports;
            ltfn = $e47208be82aa828c$exports;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($a46a09b84b6afa68$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $5783a9560ffb1794$var$ANY) comparator = new $4dd58727d26fed71$exports('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$5783a9560ffb1794$exports = $5783a9560ffb1794$var$outside;


var $e05d29d156cdb2eb$exports = {};
'use strict';

const $e05d29d156cdb2eb$var$gtr = (version, range, options)=>$5783a9560ffb1794$exports(version, range, '>', options);
$e05d29d156cdb2eb$exports = $e05d29d156cdb2eb$var$gtr;


var $fc3526f22003cf6f$exports = {};
'use strict';

// Determine if version is less than all the versions possible in the range
const $fc3526f22003cf6f$var$ltr = (version, range, options)=>$5783a9560ffb1794$exports(version, range, '<', options);
$fc3526f22003cf6f$exports = $fc3526f22003cf6f$var$ltr;


var $8421af4d971e9b10$exports = {};
'use strict';

const $8421af4d971e9b10$var$intersects = (r1, r2, options)=>{
    r1 = new $9b1a143f910b9eea$exports(r1, options);
    r2 = new $9b1a143f910b9eea$exports(r2, options);
    return r1.intersects(r2, options);
};
$8421af4d971e9b10$exports = $8421af4d971e9b10$var$intersects;


var $3367777aad2c8fd2$exports = {};
'use strict';


$3367777aad2c8fd2$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$b5683ebc1599fb75$exports(a, b, options));
    for (const version of v){
        const included = $a46a09b84b6afa68$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $916bb86509895c71$exports = {};
'use strict';


const { ANY: $916bb86509895c71$var$ANY } = $4dd58727d26fed71$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $916bb86509895c71$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $9b1a143f910b9eea$exports(sub, options);
    dom = new $9b1a143f910b9eea$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $916bb86509895c71$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $916bb86509895c71$var$minimumVersionWithPreRelease = [
    new $4dd58727d26fed71$exports('>=0.0.0-0')
];
const $916bb86509895c71$var$minimumVersion = [
    new $4dd58727d26fed71$exports('>=0.0.0')
];
const $916bb86509895c71$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $916bb86509895c71$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $916bb86509895c71$var$ANY) return true;
        else if (options.includePrerelease) sub = $916bb86509895c71$var$minimumVersionWithPreRelease;
        else sub = $916bb86509895c71$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $916bb86509895c71$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $916bb86509895c71$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = $916bb86509895c71$var$higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = $916bb86509895c71$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $b5683ebc1599fb75$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$a46a09b84b6afa68$exports(eq, String(gt), options)) return null;
        if (lt && !$a46a09b84b6afa68$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$a46a09b84b6afa68$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = $916bb86509895c71$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !$a46a09b84b6afa68$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = $916bb86509895c71$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !$a46a09b84b6afa68$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $916bb86509895c71$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b5683ebc1599fb75$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $916bb86509895c71$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b5683ebc1599fb75$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
$916bb86509895c71$exports = $916bb86509895c71$var$subset;


$99efb2e94f0cb07b$exports = {
    parse: $c47b982b2f876dc7$exports,
    valid: $bb1a16aa81b7c201$exports,
    clean: $183c3208889fde65$exports,
    inc: $6dc49bb2eb7ce026$exports,
    diff: $40b4d954793c783a$exports,
    major: $24b49f718161bca0$exports,
    minor: $c4982f38992abc17$exports,
    patch: $eb5774d0871f4264$exports,
    prerelease: $ce8a68c942ae0d1d$exports,
    compare: $b5683ebc1599fb75$exports,
    rcompare: $f853848c75d33d8a$exports,
    compareLoose: $c6ff8b80b7f3da24$exports,
    compareBuild: $a9bf654280bacccd$exports,
    sort: $6bcc1306d1dfab5a$exports,
    rsort: $1cb3f218be54e0bb$exports,
    gt: $e47208be82aa828c$exports,
    lt: $701493f0098e4ed5$exports,
    eq: $8672096e82830f01$exports,
    neq: $f8a890d03029a552$exports,
    gte: $c35fcc5e918bc343$exports,
    lte: $a8853a3a880dbb43$exports,
    cmp: $675b37cc12b91af1$exports,
    coerce: $c9e91599466ee0da$exports,
    Comparator: $4dd58727d26fed71$exports,
    Range: $9b1a143f910b9eea$exports,
    satisfies: $a46a09b84b6afa68$exports,
    toComparators: $f4eade25bb60a3b4$exports,
    maxSatisfying: $497b3954dd63343c$exports,
    minSatisfying: $54fbf0076cdeea84$exports,
    minVersion: $f4506f55b8639719$exports,
    validRange: $c16f64282ff1c050$exports,
    outside: $5783a9560ffb1794$exports,
    gtr: $e05d29d156cdb2eb$exports,
    ltr: $fc3526f22003cf6f$exports,
    intersects: $8421af4d971e9b10$exports,
    simplifyRange: $3367777aad2c8fd2$exports,
    subset: $916bb86509895c71$exports,
    SemVer: $d784ca79df3eec32$exports,
    re: $5SJmA.re,
    src: $5SJmA.src,
    tokens: $5SJmA.t,
    SEMVER_SPEC_VERSION: $5h1gV.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $5h1gV.RELEASE_TYPES,
    compareIdentifiers: $ee5030db3bda8271$exports.compareIdentifiers,
    rcompareIdentifiers: $ee5030db3bda8271$exports.rcompareIdentifiers
};


const $c93b91c6d381acba$var$getRpc = (chain)=>chain.apis?.rpc?.[0]?.address ?? '';
const $c93b91c6d381acba$var$getRest = (chain)=>chain.apis?.rest?.[0]?.address ?? '';
const $c93b91c6d381acba$var$getExplr = (chain)=>chain.explorers?.[0]?.url ?? '';
const $c93b91c6d381acba$var$versionPatterns = {
    fullSemver: /v?(\d+\.\d+\.\d+)(?=-[\w.-]+|$)/,
    partialSemver: /v?(\d+\.\d+)(?=(?:\.\d+)?(?=-[\w.-]+|$))/,
    basicVersion: /v?(\d+)(?=(?:\.\d+)?(?:\.\d+)?(?=-[\w.-]+|$))/,
    tagged: /@v(\d+\.\d+)(?:\.x)?(?=-[\w.-]+|$)/,
    embedded: /\/v(\d+\.\d+\.\d+)(?=-[\w.-]+|$)/,
    simple: /v?(\d+)(?:\.(\d+))?(?:\.(\d+))?$/,
    complexEmbedded: /[\w-]+\/[\w-]+ v(\d+)(?:\.(\d+))?(?:\.(\d+))?(?:-\d+[\w.-]*)/,
    taggedVersion: /[\w-]+\/[\w-]+ v(\d+)(?:\.(\d+))?(?:\.(\d+))?(?=-[\w.-]+|$)/ // Versions with descriptive tags
};
function $c93b91c6d381acba$export$e3c02be309be1f23(input) {
    let version = null;
    // Check each pattern in turn
    if ($c93b91c6d381acba$var$versionPatterns.fullSemver.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.fullSemver)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.partialSemver.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.partialSemver)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.basicVersion.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.basicVersion)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.taggedVersion.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.taggedVersion)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.complexEmbedded.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.complexEmbedded)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.simple.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.simple)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.tagged.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.tagged)?.[1];
    else if ($c93b91c6d381acba$var$versionPatterns.embedded.test(input)) version = input.match($c93b91c6d381acba$var$versionPatterns.embedded)?.[1];
    return version ? $c93b91c6d381acba$var$normalizeVersion(version) : null;
}
function $c93b91c6d381acba$var$normalizeVersion(version) {
    // Ensures the version is normalized to the 'x.y.z' format, if applicable
    const parts = version.split('.');
    while(parts.length < 3)parts.push('0');
    return parts.join('.');
}
const $c93b91c6d381acba$export$c6fe1e1876712b72 = (chain, assets, options = {
    getRpcEndpoint: $c93b91c6d381acba$var$getRpc,
    getRestEndpoint: $c93b91c6d381acba$var$getRest,
    getExplorer: $c93b91c6d381acba$var$getExplr
})=>{
    if (!options.getRestEndpoint) options.getRestEndpoint = $c93b91c6d381acba$var$getRest;
    if (!options.getRpcEndpoint) options.getRpcEndpoint = $c93b91c6d381acba$var$getRpc;
    if (!options.getExplorer) options.getExplorer = $c93b91c6d381acba$var$getExplr;
    const features = [];
    // check if it's a Cosmos SDK chain (either new or old format)
    const isCosmosSDKChain = chain.codebase?.sdk?.type === 'cosmos' || !!chain.codebase?.cosmosSdkVersion;
    if (isCosmosSDKChain) {
        // determine SDK version
        let sdkVer;
        if (chain.codebase?.sdk?.type === 'cosmos' && chain.codebase.sdk.version) sdkVer = $c93b91c6d381acba$export$e3c02be309be1f23(chain.codebase.sdk.version);
        else if (chain.codebase?.cosmosSdkVersion) sdkVer = $c93b91c6d381acba$export$e3c02be309be1f23(chain.codebase.cosmosSdkVersion);
        else // if NOT specified, we assume stargate, sorry not sorry
        sdkVer = '0.40.0';
        // stargate
        if ((0, (/*@__PURE__*/$parcel$interopDefault($99efb2e94f0cb07b$exports))).satisfies(sdkVer, '>=0.40')) features.push('stargate');
        // no-legacy-stdTx
        if ((0, (/*@__PURE__*/$parcel$interopDefault($99efb2e94f0cb07b$exports))).satisfies(sdkVer, '>=0.43')) features.push('no-legacy-stdTx');
        // until further notice, assume 'ibc-transfer'
        features.push('ibc-transfer');
        // ibc-go
        if ((0, (/*@__PURE__*/$parcel$interopDefault($99efb2e94f0cb07b$exports))).satisfies(sdkVer, '>=0.45')) features.push('ibc-go');
        // CosmWasm feature detection
        const cosmwasmEnabled = chain.codebase?.cosmwasm?.enabled ?? chain.codebase?.cosmwasmEnabled ?? false;
        if (cosmwasmEnabled) {
            features.push('cosmwasm');
            const wasmVer = $c93b91c6d381acba$export$e3c02be309be1f23(chain.codebase?.cosmwasm?.version ?? chain.codebase?.cosmwasmVersion ?? '0.24.0');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($99efb2e94f0cb07b$exports))).satisfies(wasmVer, '>=0.24.0')) features.push('wasmd_0.24+');
        }
    }
    const chainAssets = assets.find((asset)=>asset.chainName === chain.chainName)?.assets || [];
    const feeDenoms = chain.fees?.feeTokens.map((feeToken)=>feeToken.denom) || [];
    const gasPriceSteps = chain.fees?.feeTokens?.reduce((m, feeToken)=>{
        m[feeToken.denom] = {
            low: feeToken.lowGasPrice ?? 0.01,
            average: feeToken.averageGasPrice ?? 0.025,
            high: feeToken.highGasPrice ?? 0.04
        };
        return m;
    }, {});
    const stakingDenoms = chain.staking?.stakingTokens.map((stakingToken)=>stakingToken.denom) || [];
    const currencies = chainAssets.map((currency)=>{
        return {
            coinDenom: currency.symbol,
            coinMinimalDenom: currency.base,
            coinDecimals: currency.denomUnits.filter((denomUnit)=>denomUnit.denom === currency.display)[0]?.exponent,
            coinGeckoId: currency.coingeckoId || undefined,
            coinImageUrl: currency.logoURIs?.svg ?? currency.logoURIs?.png
        };
    });
    const stakeCurrency = currencies.find((currency)=>stakingDenoms.includes(currency.coinDenom)) ?? currencies[0];
    const feeCurrencies = currencies// USE THE FEE DENOMS
    .filter((currency)=>feeDenoms.includes(currency.coinMinimalDenom)).map((feeCurrency)=>{
        if (!(feeCurrency.coinMinimalDenom in gasPriceSteps)) return feeCurrency;
        // has gas
        const gasPriceStep = gasPriceSteps[feeCurrency.coinMinimalDenom];
        return {
            ...feeCurrency,
            gasPriceStep: gasPriceStep
        };
    });
    const feeCurrenciesDefault = currencies// USE THE STAKE CURRENCY
    .filter((currency)=>stakeCurrency.coinDenom === currency.coinDenom).map((feeCurrency)=>{
        if (!(feeCurrency.coinMinimalDenom in gasPriceSteps)) return feeCurrency;
        // has gas
        const gasPriceStep = gasPriceSteps[feeCurrency.coinMinimalDenom];
        return {
            ...feeCurrency,
            gasPriceStep: gasPriceStep
        };
    });
    const chainInfo = {
        rpc: options.getRpcEndpoint(chain),
        rest: options.getRestEndpoint(chain),
        chainId: chain.chainId,
        chainName: chain.prettyName,
        bip44: {
            coinType: chain.slip44
        },
        bech32Config: (0, $4e4e07fbc7086f67$exports.Bech32Address).defaultBech32Config(chain.bech32Prefix),
        currencies: currencies,
        stakeCurrency: stakeCurrency || currencies[0],
        feeCurrencies: feeCurrencies.length !== 0 ? feeCurrencies : feeCurrenciesDefault,
        features: features
    };
    return chainInfo;
};





var $3ca9q = parcelRequire("3ca9q");
var $79cc43c70481c16f$var$g = Object.defineProperty;
var $79cc43c70481c16f$var$t = (o, e)=>$79cc43c70481c16f$var$g(o, "name", {
        value: e,
        configurable: !0
    });
var $79cc43c70481c16f$var$s = (o, e)=>{
    for(var r in e)$79cc43c70481c16f$var$g(o, r, {
        get: e[r],
        enumerable: !0
    });
};
var $79cc43c70481c16f$export$e324594224ef24da = {};
$79cc43c70481c16f$var$s($79cc43c70481c16f$export$e324594224ef24da, {
    recommended: ()=>$79cc43c70481c16f$var$I
});
function $79cc43c70481c16f$var$x(o) {
    let [, e] = o.state();
    e("network", null), e("accounts", null), e("connected", !1), e("connecting", !1), e("connectArgs", null);
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$x, "disconnect");
var $79cc43c70481c16f$var$S = [
    [
        "disconnect",
        $79cc43c70481c16f$var$x
    ]
];
var $79cc43c70481c16f$var$I = [
    ...$79cc43c70481c16f$var$S
];
var $79cc43c70481c16f$export$742acabee3dd6465 = {};
$79cc43c70481c16f$var$s($79cc43c70481c16f$export$742acabee3dd6465, {
    recommended: ()=>$79cc43c70481c16f$var$R
});
function $79cc43c70481c16f$var$i(o) {
    let [, e] = o.state();
    e("connecting", !1);
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$i, "intoConnectionFinished");
var $79cc43c70481c16f$var$p = [
    [
        "connect",
        $79cc43c70481c16f$var$i
    ]
];
var $79cc43c70481c16f$var$R = [
    ...$79cc43c70481c16f$var$p
];
var $79cc43c70481c16f$export$21c0ac7fe1cef1b8 = {};
$79cc43c70481c16f$var$s($79cc43c70481c16f$export$21c0ac7fe1cef1b8, {
    recommended: ()=>$79cc43c70481c16f$var$M
});
var $79cc43c70481c16f$var$n = class {
    static{
        $79cc43c70481c16f$var$t(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #o = new Map;
    #r = new Map;
    #n;
    constructor(e){
        this.name = e;
    }
    and(e) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(e), this;
    }
    or(e) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(e), this;
    }
    before(e) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(e), this;
    }
    after(e) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(e), this;
    }
    action(e) {
        return this.#n = e, this;
    }
    build() {
        if (!this.#n) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#n,
            before: this.#r,
            after: this.#o,
            and: this.#e,
            or: this.#t
        };
    }
};
function $79cc43c70481c16f$var$f(o) {
    try {
        return (0, $3ca9q.AccountId).parse(o), !0;
    } catch  {
        return !1;
    }
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$f, "isValidCaipAddress");
function $79cc43c70481c16f$var$h(o, e) {
    if (!e.every($79cc43c70481c16f$var$f)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e}`);
    let [, r] = o.state();
    return r("accounts", e), r("connected", !0), e;
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$h, "connectAndUpdateStateForSingleNetwork");
function $79cc43c70481c16f$var$l(o, e) {
    if (!e.accounts.every($79cc43c70481c16f$var$f)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e.accounts}`);
    let [, r] = o.state();
    return r("accounts", e.accounts), r("network", e.network), r("connected", !0), e;
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$l, "connectAndUpdateStateForMultiNetworks");
function $79cc43c70481c16f$var$c(o) {
    let [, e] = o.state();
    e("connecting", !0);
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$c, "intoConnecting");
var $79cc43c70481c16f$var$v = [
    [
        "connect",
        $79cc43c70481c16f$var$c
    ]
];
var $79cc43c70481c16f$var$M = [
    [
        "connect",
        $79cc43c70481c16f$var$l
    ]
];
var $79cc43c70481c16f$export$1c4c1e3098bf5ebe = {};
$79cc43c70481c16f$var$s($79cc43c70481c16f$export$1c4c1e3098bf5ebe, {
    recommended: ()=>$79cc43c70481c16f$var$W
});
var $79cc43c70481c16f$var$W = [
    ...$79cc43c70481c16f$var$v
];
var $79cc43c70481c16f$export$eab97d15b1788b8d = {};
$79cc43c70481c16f$var$s($79cc43c70481c16f$export$eab97d15b1788b8d, {
    formatAccountsToCAIP: ()=>$79cc43c70481c16f$var$B
});
var $79cc43c70481c16f$export$c67e5a7ce034264a = "cosmos";
function $79cc43c70481c16f$var$B(o) {
    return o.flatMap((e)=>e.accounts.map((r)=>(0, $3ca9q.AccountId).format({
                address: r,
                chainId: {
                    namespace: $79cc43c70481c16f$export$c67e5a7ce034264a,
                    reference: e.chainId
                }
            })));
}
$79cc43c70481c16f$var$t($79cc43c70481c16f$var$B, "formatAccountsToCAIP");
var $79cc43c70481c16f$export$aea8daed5328d69c = {};
$79cc43c70481c16f$var$s($79cc43c70481c16f$export$aea8daed5328d69c, {
    connect: ()=>$79cc43c70481c16f$var$L
});
var $79cc43c70481c16f$var$L = $79cc43c70481c16f$var$t(()=>new $79cc43c70481c16f$var$n("connect").and($79cc43c70481c16f$var$h).before($79cc43c70481c16f$var$c).after($79cc43c70481c16f$var$i), "connect");


parcelRequire("9HEDW");
var $11d0192628c1d279$var$d = Object.defineProperty;
var $11d0192628c1d279$var$i = (o, s)=>$11d0192628c1d279$var$d(o, "name", {
        value: s,
        configurable: !0
    });
var $11d0192628c1d279$var$f = 1e3, $11d0192628c1d279$export$12e2b4f87ab596f0 = $11d0192628c1d279$var$i(async (o, s, t)=>{
    await o.enable(s);
    let r = s.concat(t || []).map((e)=>({
            signer: o.getOfflineSigner(e),
            chainId: e
        })).filter(Boolean), n = new Promise((e, a)=>setTimeout(()=>a(new Error("Timeout while fetching accounts")), $11d0192628c1d279$var$f)), c = r.map(async ({ signer: e })=>Promise.race([
            e.getAccounts(),
            n
        ])), u = await Promise.allSettled(c), l = [];
    return u.forEach((e, a)=>{
        if (e.status === "fulfilled") {
            let { chainId: p } = r[a];
            l.push({
                accounts: e.value.map((C)=>C.address),
                chainId: p
            });
        }
    }), l;
}, "getCosmosAccounts");
function $11d0192628c1d279$var$A(o) {
    return async (s, t)=>{
        let [, r] = s.state();
        r("connectArgs", {
            options: t
        });
        let n = o();
        if (!n) throw new Error("Do your wallet injected correctly and is cosmos compatible?");
        if (!t?.chainIds) throw new Error("Passing chainIds meta to the connect options is mandatory");
        let c = await $11d0192628c1d279$export$12e2b4f87ab596f0(n, t.chainIds, t.customChainIds);
        return (0, $79cc43c70481c16f$export$eab97d15b1788b8d).formatAccountsToCAIP(c);
    };
}
$11d0192628c1d279$var$i($11d0192628c1d279$var$A, "connect");
function $11d0192628c1d279$var$h(o) {
    return async (s, t, r)=>{
        let n = o();
        if (!n) throw new Error("Is your wallet injected correctly and cosmos compatible?");
        let c = (0, $c93b91c6d381acba$export$c6fe1e1876712b72)(t, [
            r
        ]);
        return await n.experimentalSuggestChain(c);
    };
}
$11d0192628c1d279$var$i($11d0192628c1d279$var$h, "suggest");
var $11d0192628c1d279$export$ba74bf608f040474 = {
    connect: $11d0192628c1d279$var$A,
    suggest: $11d0192628c1d279$var$h
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


/*
 * Cosmostation does not provide an eager connection mechanism for its Tron wallet.
 * The only workaround is to use the EVM-based eager connect approach.
 * However, this will only work if the EVM namespace has been connected at least once before.
 * If either wallet instance is unavailable, we throw an error.
 */ const $c3dbeae47c527539$var$canEagerConnect = async ()=>{
    const evmInstance = (0, $6f99bac7a53781a2$export$90b44d4f48642d60)();
    const cosmosInstance = (0, $6f99bac7a53781a2$export$3a0834928c0d49b)();
    // Making sure that the Tron instance is available first to prevent errors.
    if (!cosmosInstance) throw new Error('Trying to eagerly connect to your wallet, but seems its tron instance is not available.');
    if (!evmInstance) throw new Error('Trying to eagerly connect to your EVM wallet, but seems its instance is not available.');
    try {
        const accounts = await evmInstance.request({
            method: 'eth_accounts'
        });
        if (accounts.length) return true;
        return false;
    } catch  {
        return false;
    }
};
const $c3dbeae47c527539$export$85b8f7d91711aecc = {
    canEagerConnect: $c3dbeae47c527539$var$canEagerConnect
};




const $2ccb42e8d052ab43$var$connect = (0, $79cc43c70481c16f$export$aea8daed5328d69c).connect().action((0, $11d0192628c1d279$export$ba74bf608f040474).connect((0, $6f99bac7a53781a2$export$3a0834928c0d49b))).or((0, $f59Be.standardizeAndThrowError)).build();
const $2ccb42e8d052ab43$var$suggest = new (0, $fha7R.ActionBuilder)('suggest').action((0, $11d0192628c1d279$export$ba74bf608f040474).suggest((0, $6f99bac7a53781a2$export$3a0834928c0d49b))).or((0, $f59Be.standardizeAndThrowError)).build();
const $2ccb42e8d052ab43$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $c3dbeae47c527539$export$85b8f7d91711aecc).canEagerConnect).build();
const $2ccb42e8d052ab43$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $2ccb42e8d052ab43$export$9a006fed4141ee7e = new (0, $at2GJ.NamespaceBuilder)('Cosmos', (0, $f0ac5d07b43a6b11$export$7c460c214963f696)).action($2ccb42e8d052ab43$var$connect).action($2ccb42e8d052ab43$var$disconnect).action($2ccb42e8d052ab43$var$suggest).action($2ccb42e8d052ab43$var$canEagerConnect).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$cfc0ef4c41ad978f$var$changeAccountSubscriber, $cfc0ef4c41ad978f$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $6f99bac7a53781a2$export$90b44d4f48642d60));
const $cfc0ef4c41ad978f$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $6f99bac7a53781a2$export$90b44d4f48642d60))).before($cfc0ef4c41ad978f$var$changeAccountSubscriber).or($cfc0ef4c41ad978f$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $cfc0ef4c41ad978f$var$disconnect = (0, $f59Be.builders).disconnect().after($cfc0ef4c41ad978f$var$changeAccountCleanup).build();
const $cfc0ef4c41ad978f$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $cfc0ef4c41ad978f$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $6f99bac7a53781a2$export$90b44d4f48642d60))).build();
const $cfc0ef4c41ad978f$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $6f99bac7a53781a2$export$90b44d4f48642d60))).build();
const $cfc0ef4c41ad978f$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $f0ac5d07b43a6b11$export$7c460c214963f696)).action($cfc0ef4c41ad978f$var$connect).action($cfc0ef4c41ad978f$var$disconnect).action($cfc0ef4c41ad978f$var$canEagerConnect).action($cfc0ef4c41ad978f$var$canSwitchNetwork).action($cfc0ef4c41ad978f$var$getChainId).build();



const $8ef1fc30ad1e7ef1$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $f0ac5d07b43a6b11$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $6f99bac7a53781a2$export$f10fc90c2179d193)()) {
                setState('installed', true);
                console.debug('[cosmostation] instance detected.', context);
            }
        }, (0, $f0ac5d07b43a6b11$export$2d687fc1bd6ada84));
    }).config('metadata', (0, $f0ac5d07b43a6b11$export$dbb5e893e736e4ee)).add('cosmos', (0, $2ccb42e8d052ab43$export$9a006fed4141ee7e)).add('evm', (0, $cfc0ef4c41ad978f$export$2f7490c34b49803e)).build();


const $2ea6c3ce60db8b11$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $8ef1fc30ad1e7ef1$export$afa934a86232cabe)()).build();


var $efcc27ba195cb412$exports = {};

$parcel$export($efcc27ba195cb412$exports, "config", function () { return $efcc27ba195cb412$export$e506a1d27d1eaa20; });
$parcel$export($efcc27ba195cb412$exports, "getInstance", function () { return $efcc27ba195cb412$export$8bedcca5bbd73999; });
$parcel$export($efcc27ba195cb412$exports, "connect", function () { return $efcc27ba195cb412$export$64605811ab45167f; });
$parcel$export($efcc27ba195cb412$exports, "subscribe", function () { return $efcc27ba195cb412$export$ec068583843480e7; });
$parcel$export($efcc27ba195cb412$exports, "switchNetwork", function () { return $efcc27ba195cb412$export$f3473d805e486329; });
$parcel$export($efcc27ba195cb412$exports, "canSwitchNetworkTo", function () { return $efcc27ba195cb412$export$3b3cf9ab9019de20; });
$parcel$export($efcc27ba195cb412$exports, "getSigners", function () { return $efcc27ba195cb412$export$6352a17a50193ded; });
$parcel$export($efcc27ba195cb412$exports, "canEagerConnect", function () { return $efcc27ba195cb412$export$be9f3c5ed1d25e42; });
$parcel$export($efcc27ba195cb412$exports, "getWalletInfo", function () { return $efcc27ba195cb412$export$e5b9d96c6aeb3ff7; });
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
function $a15e503e747d28ea$export$9526fb4b4acd9f98() {
    const { ethereum: ethereum } = window;
    return ethereum ?? null;
}


parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $c531f04149edbb6e$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(provider));
    return signers;
}


const $efcc27ba195cb412$var$WALLET = (0, $9cRHO.WalletTypes).DEFAULT;
const $efcc27ba195cb412$export$e506a1d27d1eaa20 = {
    type: $efcc27ba195cb412$var$WALLET
};
const $efcc27ba195cb412$export$8bedcca5bbd73999 = (0, $a15e503e747d28ea$export$9526fb4b4acd9f98);
const $efcc27ba195cb412$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $gSYt0.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $efcc27ba195cb412$export$ec068583843480e7 = (0, $gSYt0.subscribeToEvm);
const $efcc27ba195cb412$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $efcc27ba195cb412$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $efcc27ba195cb412$export$6352a17a50193ded = (0, $c531f04149edbb6e$export$2e2bcd8739ae039);
const $efcc27ba195cb412$export$be9f3c5ed1d25e42 = (0, $gSYt0.canEagerlyConnectToEvm);
const $efcc27ba195cb412$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    return {
        name: 'Default',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/default/icon.svg',
        installLink: {
            DEFAULT: 'https://metamask.io/download/'
        },
        color: '#dac7ae',
        supportedChains: evms
    };
};



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $627c0eba6bfcec73$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $04eadd6194cc9ee4$export$a44e33b8de461ecd() {
    const { enkrypt: enkrypt } = window;
    const ethereum = enkrypt?.providers?.ethereum;
    if (!ethereum) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, ethereum);
    return instances;
}
function $04eadd6194cc9ee4$export$62115b9164fa6f77() {
    const instances = $04eadd6194cc9ee4$export$a44e33b8de461ecd();
    if (!instances) throw new Error('Enkrypt Wallet is not injected. Please check your wallet.');
    return instances;
}
function $04eadd6194cc9ee4$export$8dd52ab42e37d70b() {
    const instances = $04eadd6194cc9ee4$export$a44e33b8de461ecd();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Enkrypt Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}


const $81d2c1329d0d8099$export$7c460c214963f696 = 'enkrypt';
const $81d2c1329d0d8099$export$dbb5e893e736e4ee = {
    name: 'Enkrypt',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/enkrypt/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/enkrypt/kkpllkodjeloidieedojogacfhpaihoh',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/enkrypt/',
        brave: 'https://chrome.google.com/webstore/detail/enkrypt/kkpllkodjeloidieedojogacfhpaihoh',
        edge: 'https://microsoftedge.microsoft.com/addons/detail/enkrypt-ethereum-polkad/gfenajajnjjmmdojhdjmnngomkhlnfjl',
        homepage: 'https://www.enkrypt.com/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $627c0eba6bfcec73$export$2e2bcd8739ae039)((0, $04eadd6194cc9ee4$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$de22bb177b668de6$var$changeAccountSubscriber, $de22bb177b668de6$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $04eadd6194cc9ee4$export$8dd52ab42e37d70b));
const $de22bb177b668de6$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $04eadd6194cc9ee4$export$8dd52ab42e37d70b))).before($de22bb177b668de6$var$changeAccountSubscriber).or($de22bb177b668de6$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $de22bb177b668de6$var$disconnect = (0, $f59Be.builders).disconnect().after($de22bb177b668de6$var$changeAccountCleanup).build();
const $de22bb177b668de6$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $de22bb177b668de6$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $04eadd6194cc9ee4$export$8dd52ab42e37d70b))).build();
const $de22bb177b668de6$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $04eadd6194cc9ee4$export$8dd52ab42e37d70b))).build();
const $de22bb177b668de6$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $81d2c1329d0d8099$export$7c460c214963f696)).action($de22bb177b668de6$var$connect).action($de22bb177b668de6$var$disconnect).action($de22bb177b668de6$var$canEagerConnect).action($de22bb177b668de6$var$canSwitchNetwork).action($de22bb177b668de6$var$getChainId).build();



const $dbdea1dacbc65950$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $81d2c1329d0d8099$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $04eadd6194cc9ee4$export$a44e33b8de461ecd)()) {
            setState('installed', true);
            console.debug('[enkrypt] instance detected.', context);
        }
    }).config('metadata', (0, $81d2c1329d0d8099$export$dbb5e893e736e4ee)).add('evm', (0, $de22bb177b668de6$export$2f7490c34b49803e)).build();


const $fd15553f1aea7a9f$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $dbdea1dacbc65950$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $fIwj6 = parcelRequire("fIwj6");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $13wKd = parcelRequire("13wKd");

var $hZS7n = parcelRequire("hZS7n");
class $27560bf01bd5c28e$export$be93886be1059070 extends (0, $13wKd.DefaultSolanaSigner) {
    constructor(provider){
        super(provider);
    }
    async signMessage(msg) {
        const { signature: signature } = await this.provider.signMessage(msg);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(signature);
    }
}



async function $22dfe2562731c391$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $27560bf01bd5c28e$export$be93886be1059070)(solProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $d2da7dc8c0033d46$export$178463b44e077948() {
    const { exodus: exodus } = window;
    if (!exodus) return null;
    const instances = new Map();
    if (exodus.ethereum) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, exodus.ethereum);
    if (exodus.solana) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, exodus.solana);
    return instances;
}
function $d2da7dc8c0033d46$export$62115b9164fa6f77() {
    const instances = $d2da7dc8c0033d46$export$178463b44e077948();
    if (!instances) throw new Error('Exodus Wallet is not injected. Please check your wallet.');
    return instances;
}
function $d2da7dc8c0033d46$export$f1ad4b1d9f391e93() {
    const instances = $d2da7dc8c0033d46$export$178463b44e077948();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Exodus Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $d2da7dc8c0033d46$export$5d5c0048e3a587cd() {
    const instance = $d2da7dc8c0033d46$export$178463b44e077948();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Exodus Wallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}


const $cd8c883c9d29e5d3$export$7c460c214963f696 = 'exodus';
const $cd8c883c9d29e5d3$export$1ac55c078823cdb2 = [
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).BSC,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN
];
const $cd8c883c9d29e5d3$export$dbb5e893e736e4ee = {
    name: 'Exodus',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/exodus/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno',
        brave: 'https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno',
        homepage: 'https://www.exodus.com/download'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((blockchainMeta)=>$cd8c883c9d29e5d3$export$1ac55c078823cdb2.includes(blockchainMeta.name))
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $22dfe2562731c391$export$2e2bcd8739ae039)((0, $d2da7dc8c0033d46$export$62115b9164fa6f77)())
            }
        }
    ]
};




const $841d29e18001b615$var$WALLET = (0, $9cRHO.WalletTypes).EXODUS;
const $841d29e18001b615$export$e506a1d27d1eaa20 = {
    type: $841d29e18001b615$var$WALLET,
    // TODO: Get from evm networks
    defaultNetwork: (0, $9HEDW.LegacyNetworks).ETHEREUM
};
const $841d29e18001b615$export$8bedcca5bbd73999 = (0, $d2da7dc8c0033d46$export$178463b44e077948);
const $841d29e18001b615$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evmInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const results = [];
    if (evmInstance) {
        const evm = await (0, $gSYt0.getEvmAccounts)(evmInstance);
        results.push(evm);
    }
    const solanaResults = await (0, $fIwj6.getSolanaAccounts)(instance);
    results.push(...Array.isArray(solanaResults) ? solanaResults : [
        solanaResults
    ]);
    return results;
};
const $841d29e18001b615$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solanaInstance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, (0, $9HEDW.LegacyNetworks).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    ethInstance?.on?.('accountsChanged', (addresses)=>{
        const eth_chainId = meta.filter((0, $hE77Y.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $9HEDW.LegacyNetworks).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    });
    solanaInstance?.on?.('accountChanged', async (publicKey)=>{
        if (state.network != (0, $9HEDW.LegacyNetworks).SOLANA) updateChainId(meta.filter((0, $hE77Y.isSolanaBlockchain))[0].chainId);
        const network = (0, $9HEDW.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    });
};
const $841d29e18001b615$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $gSYt0.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $841d29e18001b615$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $841d29e18001b615$export$6352a17a50193ded = (0, $22dfe2562731c391$export$2e2bcd8739ae039);
const $841d29e18001b615$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $gSYt0.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $841d29e18001b615$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>({
        name: 'Exodus',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/exodus/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno',
            BRAVE: 'https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno',
            DEFAULT: 'https://www.exodus.com/'
        },
        color: '#8f70fa',
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $cd8c883c9d29e5d3$export$1ac55c078823cdb2).includes(blockchainMeta.name))
    });
const $841d29e18001b615$export$107c8cc6b37a1ffa = ()=>({
        config: $841d29e18001b615$export$e506a1d27d1eaa20,
        getInstance: $841d29e18001b615$export$8bedcca5bbd73999,
        connect: $841d29e18001b615$export$64605811ab45167f,
        subscribe: $841d29e18001b615$export$ec068583843480e7,
        switchNetwork: $841d29e18001b615$export$f3473d805e486329,
        canSwitchNetworkTo: $841d29e18001b615$export$3b3cf9ab9019de20,
        getSigners: $841d29e18001b615$export$6352a17a50193ded,
        getWalletInfo: $841d29e18001b615$export$e5b9d96c6aeb3ff7,
        canEagerConnect: $841d29e18001b615$export$be9f3c5ed1d25e42
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const $2df1640e837d6932$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $d2da7dc8c0033d46$export$f1ad4b1d9f391e93))).or((0, $f59Be.standardizeAndThrowError)).build();
const $2df1640e837d6932$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $2df1640e837d6932$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $2df1640e837d6932$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $d2da7dc8c0033d46$export$f1ad4b1d9f391e93))).build();
const $2df1640e837d6932$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $d2da7dc8c0033d46$export$f1ad4b1d9f391e93))).build();
const $2df1640e837d6932$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $cd8c883c9d29e5d3$export$7c460c214963f696)).action($2df1640e837d6932$var$connect).action($2df1640e837d6932$var$disconnect).action($2df1640e837d6932$var$canEagerConnect).action($2df1640e837d6932$var$getChainId).action($2df1640e837d6932$var$canSwitchNetwork).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


/*
 * Exodus does not provide an eager connection mechanism for its Solana wallet.
 * The only workaround is to use the EVM-based eager connect approach.
 * However, this will only work if the EVM namespace has been connected at least once before.
 * If either wallet instance is unavailable, we throw an error.
 */ const $680bc40d2cdb9971$var$canEagerConnectAction = async ()=>{
    const evmInstance = (0, $d2da7dc8c0033d46$export$f1ad4b1d9f391e93)();
    const solanaInstance = (0, $d2da7dc8c0033d46$export$5d5c0048e3a587cd)();
    // Making sure that the Solana instance is available first to prevent errors.
    if (!solanaInstance) throw new Error('Trying to eagerly connect to your wallet, but seems its solana instance is not available.');
    if (!evmInstance) throw new Error('Trying to eagerly connect to your EVM wallet, but seems its instance is not available.');
    try {
        const accounts = await evmInstance.request({
            method: 'eth_accounts'
        });
        if (accounts.length) return true;
        return false;
    } catch  {
        return false;
    }
};
const $680bc40d2cdb9971$export$43912867441655c2 = {
    canEagerConnectAction: $680bc40d2cdb9971$var$canEagerConnectAction
};




const $126fe8758c7f571b$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $3b5535826a909102$export$e324594224ef24da).connect((0, $d2da7dc8c0033d46$export$5d5c0048e3a587cd))).or((0, $f59Be.standardizeAndThrowError)).build();
const $126fe8758c7f571b$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $126fe8758c7f571b$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $680bc40d2cdb9971$export$43912867441655c2).canEagerConnectAction).build();
const $126fe8758c7f571b$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $cd8c883c9d29e5d3$export$7c460c214963f696)).action($126fe8758c7f571b$var$connect).action($126fe8758c7f571b$var$disconnect).action($126fe8758c7f571b$var$canEagerConnect).build();



const $23918bfad1da24e0$var$WALLET_INJECTION_DELAY_MS = 1000;
const $23918bfad1da24e0$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $cd8c883c9d29e5d3$export$7c460c214963f696)).init((context)=>setTimeout(function() {
            const [, setState] = context.state();
            if ((0, $d2da7dc8c0033d46$export$178463b44e077948)()) {
                setState('installed', true);
                console.debug('[exodus] instance detected.', context);
            }
        }, $23918bfad1da24e0$var$WALLET_INJECTION_DELAY_MS)).config('metadata', (0, $cd8c883c9d29e5d3$export$dbb5e893e736e4ee)).add('solana', (0, $126fe8758c7f571b$export$ee6400bf8f8c2a0d)).add('evm', (0, $2df1640e837d6932$export$2f7490c34b49803e)).build();


const $cdc8511741eaa8b6$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $841d29e18001b615$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $23918bfad1da24e0$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

var $87el0 = parcelRequire("87el0");

var $13w09 = parcelRequire("13w09");

var $jJRID = parcelRequire("jJRID");
async function $b362bc9705a8376a$export$e17f4eace6c4cbf1() {
    const result = await $jJRID.isConnected();
    return result.isConnected;
}


const $483e71647136f1ce$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $87el0.WALLET_ID)).init(function(context) {
        const [, setState] = context.state();
        const setInstallState = (result)=>setState('installed', result);
        (0, $b362bc9705a8376a$export$e17f4eace6c4cbf1)().then(setInstallState).catch(console.error);
    }).config('metadata', (0, $87el0.metadata)).add('stellar', (0, $13w09.namespace)).build();


const $6599bf6bbe0c6254$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $483e71647136f1ce$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

var $e0BbI = parcelRequire("e0BbI");
parcelRequire("eehHp");
var $aII0V = parcelRequire("aII0V");

var $lfyg9 = parcelRequire("lfyg9");
async function $03a82b0d85b62040$export$f1eb944c7e947208() {
    return new Promise((resolve, reject)=>{
        window.addEventListener('load', ()=>{
            (0, $lfyg9.isInstalled)().then((response)=>{
                if (response.result.isInstalled) resolve(true);
                else resolve(false);
            }).catch(reject);
        });
    });
}


const $032fb75a58fa3d7d$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $e0BbI.WALLET_ID)).init(function(context) {
        const [, setState] = context.state();
        const setInstallState = (result)=>setState('installed', result);
        (0, $03a82b0d85b62040$export$f1eb944c7e947208)().then(setInstallState).catch(console.error);
    }).config('metadata', (0, $e0BbI.info)).add('xrpl', (0, $aII0V.namespace)).build();


const $df89cc1d92343f67$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $032fb75a58fa3d7d$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $315fa469c05ec8ce$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).COSMOS);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultCosmosSigner: DefaultCosmosSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("f6MG1")));
    signers.registerSigner((0, $9B1kL.TransactionType).COSMOS, new DefaultCosmosSigner(cosmosProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $b5a33651c7eaf813$export$6ebea13480cb087e() {
    const { keplr: keplr } = window;
    if (!keplr) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).COSMOS, keplr);
    return instances;
}
function $b5a33651c7eaf813$export$62115b9164fa6f77() {
    const instances = $b5a33651c7eaf813$export$6ebea13480cb087e();
    if (!instances) throw new Error('Cosmos Wallet is not injected. Please check your wallet.');
    return instances;
}
function $b5a33651c7eaf813$export$f07ed8518bc46705() {
    const instances = $b5a33651c7eaf813$export$6ebea13480cb087e();
    const cosmosInstance = instances?.get((0, $9HEDW.LegacyNetworks).COSMOS);
    if (!cosmosInstance) throw new Error('Keplr Wallet not injected or Cosmos not enabled. Please check your wallet.');
    return cosmosInstance;
}
const $b5a33651c7eaf813$var$GET_ACCOUNTS_TIMEOUT = 1000;
const $b5a33651c7eaf813$export$d4d8333f992ebe8c = async (instance, chainIds, miscChainIds)=>{
    await instance.enable(chainIds);
    // Trying to get accounts from chainIds and also miscChainIds
    const offlineSigners = chainIds.concat(miscChainIds || []).map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    }).filter(Boolean);
    // Set a timeout for fetching accounts
    const timeout = new Promise((_, reject)=>setTimeout(()=>reject(new Error('Timeout while fetching accounts')), $b5a33651c7eaf813$var$GET_ACCOUNTS_TIMEOUT));
    const accountsPromises = offlineSigners.map(async ({ signer: signer })=>Promise.race([
            signer.getAccounts(),
            timeout
        ]));
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const accountsResult = [];
    availableAccountForChains.forEach((fetchResult, index)=>{
        if (fetchResult.status === 'fulfilled') {
            const { chainId: chainId } = offlineSigners[index];
            accountsResult.push({
                accounts: fetchResult.value.map((account)=>account.address),
                chainId: chainId
            });
        }
    });
    return accountsResult;
};


const $83d06aeb556d51e8$export$7c460c214963f696 = 'keplr';
const $83d06aeb556d51e8$export$dbb5e893e736e4ee = {
    name: 'Keplr',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/keplr/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap',
        brave: 'https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/keplr',
        homepage: 'https://www.keplr.app'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Cosmos',
                        value: 'Cosmos',
                        id: 'Cosmos',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.cosmosBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $315fa469c05ec8ce$export$2e2bcd8739ae039)((0, $b5a33651c7eaf813$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");




function $dc758b6082dec265$var$connect(instance) {
    return async (context, options)=>{
        // Setting connect args to be used on other actions
        const [, setState] = context.state();
        setState('connectArgs', {
            options: options
        });
        const cosmosInstance = instance();
        if (!cosmosInstance) throw new Error('Do your wallet injected correctly and is cosmos compatible?');
        if (!options?.chainIds) throw new Error('Passing chainIds meta to the connect options is mandatory');
        const providerAccounts = await (0, $b5a33651c7eaf813$export$d4d8333f992ebe8c)(cosmosInstance, options.chainIds, options.customChainIds);
        return (0, $79cc43c70481c16f$export$eab97d15b1788b8d).formatAccountsToCAIP(providerAccounts);
    };
}
function $dc758b6082dec265$var$suggest(instance) {
    return async (_context, chain, assetList)=>{
        const cosmosInstance = instance();
        if (!cosmosInstance) throw new Error('Is your wallet injected correctly and cosmos compatible?');
        const experimentalChain = (0, $c93b91c6d381acba$export$c6fe1e1876712b72)(chain, [
            assetList
        ]);
        return await cosmosInstance.experimentalSuggestChain(experimentalChain);
    };
}
const $dc758b6082dec265$export$85b8f7d91711aecc = {
    connect: $dc758b6082dec265$var$connect,
    suggest: $dc758b6082dec265$var$suggest
};



var $f59Be = parcelRequire("f59Be");

// Hooks
const $f526141a3506915f$var$changeAccountSubscriber = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event, context)=>{
        const [getState] = context.state();
        event.preventDefault();
        const connectArgs = getState('connectArgs');
        if (!connectArgs) throw new Error('Connect args are empty');
        context.action('disconnect');
        context.action('connect', connectArgs.options);
    }).format(async (_, __)=>(0, $79cc43c70481c16f$export$eab97d15b1788b8d).formatAccountsToCAIP([])).addEventListener((_, callback)=>{
        window.addEventListener('keplr_keystorechange', callback);
    }).removeEventListener((_, callback)=>{
        window.removeEventListener('keplr_keystorechange', callback);
    });
const $f526141a3506915f$export$e58ec12bfc63bf13 = {
    changeAccountSubscriber: $f526141a3506915f$var$changeAccountSubscriber
};




const [$8f1cd5e38e11630b$var$changeAccountSubscriber, $8f1cd5e38e11630b$var$changeAccountCleanup] = (0, $f526141a3506915f$export$e58ec12bfc63bf13).changeAccountSubscriber((0, $b5a33651c7eaf813$export$f07ed8518bc46705)).build();
const $8f1cd5e38e11630b$var$connect = (0, $79cc43c70481c16f$export$aea8daed5328d69c).connect().action((0, $dc758b6082dec265$export$85b8f7d91711aecc).connect((0, $b5a33651c7eaf813$export$f07ed8518bc46705))).or((0, $f59Be.standardizeAndThrowError)).or($8f1cd5e38e11630b$var$changeAccountCleanup).before($8f1cd5e38e11630b$var$changeAccountSubscriber).build();
const $8f1cd5e38e11630b$var$suggest = new (0, $fha7R.ActionBuilder)('suggest').action((0, $dc758b6082dec265$export$85b8f7d91711aecc).suggest((0, $b5a33651c7eaf813$export$f07ed8518bc46705))).or((0, $f59Be.standardizeAndThrowError)).build();
const $8f1cd5e38e11630b$var$disconnect = (0, $f59Be.builders).disconnect().before($8f1cd5e38e11630b$var$changeAccountCleanup).build();
const $8f1cd5e38e11630b$export$9a006fed4141ee7e = new (0, $at2GJ.NamespaceBuilder)('Cosmos', (0, $83d06aeb556d51e8$export$7c460c214963f696)).action($8f1cd5e38e11630b$var$connect).action($8f1cd5e38e11630b$var$disconnect).action($8f1cd5e38e11630b$var$suggest).build();



const $22efaae130d18316$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $83d06aeb556d51e8$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $b5a33651c7eaf813$export$6ebea13480cb087e)()) {
            setState('installed', true);
            console.debug('[keplr] instance detected.', context);
        }
    }).config('metadata', (0, $83d06aeb556d51e8$export$dbb5e893e736e4ee)).add('cosmos', (0, $8f1cd5e38e11630b$export$9a006fed4141ee7e)).build();


const $04f2e359365b093d$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $22efaae130d18316$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $e6d10106c63fcc14$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).COSMOS);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultCosmosSigner: DefaultCosmosSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("f6MG1")));
    signers.registerSigner((0, $9B1kL.TransactionType).COSMOS, new DefaultCosmosSigner(cosmosProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $ff8248dbb08108c7$export$61a6623ec12f5491() {
    const { leap: leap } = window;
    if (!leap) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).COSMOS, leap);
    return instances;
}
function $ff8248dbb08108c7$export$62115b9164fa6f77() {
    const instances = $ff8248dbb08108c7$export$61a6623ec12f5491();
    if (!instances) throw new Error('Leap Wallet is not injected. Please check your wallet.');
    return instances;
}
function $ff8248dbb08108c7$export$dfbf92676b276986() {
    const instances = $ff8248dbb08108c7$export$61a6623ec12f5491();
    const cosmosInstance = instances?.get((0, $9HEDW.LegacyNetworks).COSMOS);
    if (!cosmosInstance) throw new Error('Leap Wallet not injected or Cosmos not enabled. Please check your wallet.');
    return cosmosInstance;
}


const $51701798db3b50de$export$7c460c214963f696 = 'leap-cosmos';
const $51701798db3b50de$export$ffcc7778551a70e9 = 1000;
const $51701798db3b50de$export$dbb5e893e736e4ee = {
    name: 'Leap',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/leap-cosmos/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg',
        brave: 'https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg',
        homepage: 'https://www.leapwallet.io/cosmos'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Cosmos',
                        value: 'Cosmos',
                        id: 'Cosmos',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.cosmosBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $e6d10106c63fcc14$export$2e2bcd8739ae039)((0, $ff8248dbb08108c7$export$62115b9164fa6f77)())
            }
        }
    ]
};



parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


var $f59Be = parcelRequire("f59Be");

// Hooks
const $23e49cc4bf0cdb55$var$changeAccountSubscriber = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event, context)=>{
        const [getState] = context.state();
        event.preventDefault();
        const connectArgs = getState('connectArgs');
        if (!connectArgs) throw new Error('Connect args are empty');
        context.action('disconnect');
        context.action('connect', connectArgs.options);
    }).format(async (_, __)=>(0, $79cc43c70481c16f$export$eab97d15b1788b8d).formatAccountsToCAIP([])).addEventListener((_, callback)=>{
        window.addEventListener('leap_keystorechange', callback);
    }).removeEventListener((_, callback)=>{
        window.removeEventListener('leap_keystorechange', callback);
    });
const $23e49cc4bf0cdb55$export$e58ec12bfc63bf13 = {
    changeAccountSubscriber: $23e49cc4bf0cdb55$var$changeAccountSubscriber
};




const [$221368383918b778$var$changeAccountSubscriber, $221368383918b778$var$changeAccountCleanup] = (0, $23e49cc4bf0cdb55$export$e58ec12bfc63bf13).changeAccountSubscriber((0, $ff8248dbb08108c7$export$dfbf92676b276986)).build();
const $221368383918b778$var$connect = (0, $79cc43c70481c16f$export$aea8daed5328d69c).connect().action((0, $11d0192628c1d279$export$ba74bf608f040474).connect((0, $ff8248dbb08108c7$export$dfbf92676b276986))).or((0, $f59Be.standardizeAndThrowError)).or($221368383918b778$var$changeAccountCleanup).before($221368383918b778$var$changeAccountSubscriber).build();
const $221368383918b778$var$suggest = new (0, $fha7R.ActionBuilder)('suggest').action((0, $11d0192628c1d279$export$ba74bf608f040474).suggest((0, $ff8248dbb08108c7$export$dfbf92676b276986))).or((0, $f59Be.standardizeAndThrowError)).build();
const $221368383918b778$var$disconnect = (0, $f59Be.builders).disconnect().before($221368383918b778$var$changeAccountCleanup).build();
const $221368383918b778$export$9a006fed4141ee7e = new (0, $at2GJ.NamespaceBuilder)('Cosmos', (0, $51701798db3b50de$export$7c460c214963f696)).action($221368383918b778$var$connect).action($221368383918b778$var$disconnect).action($221368383918b778$var$suggest).build();



const $b4c6a08e0ae74273$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $51701798db3b50de$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $ff8248dbb08108c7$export$61a6623ec12f5491)()) {
                setState('installed', true);
                console.debug('[leap] instance detected.', context);
            }
        }, (0, $51701798db3b50de$export$ffcc7778551a70e9));
    }).config('metadata', (0, $51701798db3b50de$export$dbb5e893e736e4ee)).add('cosmos', (0, $221368383918b778$export$9a006fed4141ee7e)).build();


const $4e9d1f1b1c89fc2d$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $b4c6a08e0ae74273$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");
var $fIwj6 = parcelRequire("fIwj6");

var $7lMFN = parcelRequire("7lMFN");
var $df9mn = parcelRequire("df9mn");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");
// We keep derivationPath here because we need to maintain it for signing transactions after it is set in connect method
let $a0be4e76406c4732$var$derivationPath = '';
function $a0be4e76406c4732$export$7700d582a5b9e8d0(path) {
    $a0be4e76406c4732$var$derivationPath = path;
}
function $a0be4e76406c4732$export$11792f2e0d4d6623() {
    return $a0be4e76406c4732$var$derivationPath;
}



var $33qmb = parcelRequire("33qmb");

var $9HEDW = parcelRequire("9HEDW");

parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $9cRHO = parcelRequire("9cRHO");

var $hZS7n = parcelRequire("hZS7n");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");

const $3f84ff410e44abba$export$6ae6d19d2a14f956 = [
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).BASE
];
const $3f84ff410e44abba$export$7dd621d8a174fee6 = 16;
const $3f84ff410e44abba$export$7c460c214963f696 = 'ledger';
const $3f84ff410e44abba$export$dbb5e893e736e4ee = {
    name: 'Ledger',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/ledger/icon.svg',
    extensions: {
        homepage: 'https://support.ledger.com/hc/en-us/articles/4404389606417-Download-and-install-Ledger-Live?docs=true'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'single',
                data: [
                    {
                        label: 'Ethereum',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).SOLANA)
                    }
                ]
            }
        },
        {
            name: 'derivationPath',
            value: {
                data: [
                    {
                        id: 'metamask',
                        label: `Metamask (m/44'/60'/0'/0/index)`,
                        namespace: 'EVM',
                        generateDerivationPath: (index)=>`44'/60'/0'/0/${index}`
                    },
                    {
                        id: 'ledgerLive',
                        label: `LedgerLive (m/44'/60'/index'/0/0)`,
                        namespace: 'EVM',
                        generateDerivationPath: (index)=>`44'/60'/${index}'/0/0`
                    },
                    {
                        id: 'legacy',
                        label: `Legacy (m/44'/60'/0'/index)`,
                        namespace: 'EVM',
                        generateDerivationPath: (index)=>`44'/60'/0'/${index}`
                    },
                    {
                        id: `(m/44'/501'/index')`,
                        label: `(m/44'/501'/index')`,
                        namespace: 'Solana',
                        generateDerivationPath: (index)=>`44'/501'/${index}'`
                    },
                    {
                        id: `(m/44'/501'/0'/index)`,
                        label: `(m/44'/501'/0'/index)`,
                        namespace: 'Solana',
                        generateDerivationPath: (index)=>`44'/501'/0'/${index}`
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $a768160d671222fe$export$2e2bcd8739ae039)()
            }
        }
    ]
};



function $4ceb4776397f30f0$export$70fb6ebd9084576e() {
    /*
   * Instances have a required property which is `chainId` and is using in swap execution.
   * Here we are setting it as Ethereum always since we are supporting only eth for now.
   */ const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, {
        chainId: (0, $9cRHO.ETHEREUM_CHAIN_ID)
    });
    instances.set((0, $9HEDW.LegacyNetworks).SOLANA, {
        chainId: (0, $9HEDW.LegacyNetworks).SOLANA
    });
    return instances;
}
const $4ceb4776397f30f0$var$ledgerFrequentErrorMessages = {
    0x5515: 'The device is locked',
    0x650f: 'Related application is not ready on your device',
    0x6985: 'Action denied by user'
};
function $4ceb4776397f30f0$var$getLedgerErrorMessage(statusCode) {
    if ($4ceb4776397f30f0$var$ledgerFrequentErrorMessages[statusCode]) return $4ceb4776397f30f0$var$ledgerFrequentErrorMessages[statusCode];
    else if ((0, $33qmb.getAltStatusMessage)(statusCode)) return (0, $33qmb.getAltStatusMessage)(statusCode);
    return `Ledger device unknown error 0x${statusCode.toString((0, $3f84ff410e44abba$export$7dd621d8a174fee6))}`; // Hexadecimal numbers are more commonly recognized and utilized for representing ledger error codes
}
function $4ceb4776397f30f0$export$36edca307d1b62d1(error) {
    if (error?.statusCode) return new Error($4ceb4776397f30f0$var$getLedgerErrorMessage(error.statusCode));
    if (error?.code === 'INSUFFICIENT_FUNDS') return new Error('Insufficient funds for transaction');
    return error;
}
function $4ceb4776397f30f0$export$293a71a421d178e1(_, error) {
    throw $4ceb4776397f30f0$export$36edca307d1b62d1(error);
}

async function $4ceb4776397f30f0$export$d5de980bfde9e56b() {
    try {
        const transport = await $4ceb4776397f30f0$export$ea1f07d757001497();
        const LedgerAppEth = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("gLGU9")))).default;
        const eth = new LedgerAppEth(transport);
        const derivationPath = (0, $a0be4e76406c4732$export$11792f2e0d4d6623)();
        const accounts = [];
        const result = await eth.getAddress(derivationPath, false, true);
        accounts.push(result.address);
        return {
            accounts: accounts,
            chainId: (0, $9cRHO.ETHEREUM_CHAIN_ID),
            derivationPath: derivationPath
        };
    } catch (error) {
        throw $4ceb4776397f30f0$export$36edca307d1b62d1(error);
    } finally{
        await $4ceb4776397f30f0$export$a84ecb994933e890();
    }
}

async function $4ceb4776397f30f0$export$a009f0f0c363aa6c() {
    try {
        const transport = await $4ceb4776397f30f0$export$ea1f07d757001497();
        const LedgerAppSolana = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7XZVE")))).default;
        const solana = new LedgerAppSolana(transport);
        const derivationPath = (0, $a0be4e76406c4732$export$11792f2e0d4d6623)();
        const accounts = [];
        const result = await solana.getAddress(derivationPath);
        accounts.push((0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(result.address));
        return {
            accounts: accounts,
            chainId: (0, $3b5535826a909102$export$a3d7ecd9c7e8a4a),
            derivationPath: derivationPath
        };
    } catch (error) {
        throw $4ceb4776397f30f0$export$36edca307d1b62d1(error);
    } finally{
        await $4ceb4776397f30f0$export$a84ecb994933e890();
    }
}
let $4ceb4776397f30f0$var$transportConnection = null;

async function $4ceb4776397f30f0$export$ea1f07d757001497() {
    const TransportWebHID = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("8uJJT")))).default;
    $4ceb4776397f30f0$var$transportConnection = await TransportWebHID.create();
    return $4ceb4776397f30f0$var$transportConnection;
}
async function $4ceb4776397f30f0$export$a84ecb994933e890() {
    if ($4ceb4776397f30f0$var$transportConnection) {
        await $4ceb4776397f30f0$var$transportConnection.close();
        $4ceb4776397f30f0$var$transportConnection = null;
    }
}



var $ihoyg = parcelRequire("ihoyg");
var $edafe799ccc2bad0$require$Buffer = $ihoyg.Buffer;


class $edafe799ccc2bad0$export$badd91e21a327d29 {
    async signMessage(msg) {
        try {
            const transport = await (0, $4ceb4776397f30f0$export$ea1f07d757001497)();
            const LedgerAppEth = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("gLGU9")))).default;
            const eth = new LedgerAppEth(transport);
            const result = await eth.signPersonalMessage((0, $a0be4e76406c4732$export$11792f2e0d4d6623)(), $edafe799ccc2bad0$require$Buffer.from(msg).toString('hex'));
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            let v = (result['v'] - 27).toString(16);
            if (v.length < 2) v = '0' + v;
            return '0x' + result['r'] + result['s'] + v;
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx, fromAddress, chainId) {
        try {
            const provider = new (0, $7lMFN.JsonRpcProvider)((0, $9cRHO.DEFAULT_ETHEREUM_RPC_URL)); // Provider to broadcast transaction
            const transactionCount = await provider.getTransactionCount(fromAddress); // Get nonce
            const transaction = {
                to: tx.to,
                gasPrice: tx.gasPrice,
                gasLimit: tx.gasLimit,
                nonce: transactionCount,
                chainId: chainId,
                data: tx.data,
                value: tx.value,
                maxPriorityFeePerGas: tx.maxPriorityFeePerGas,
                maxFeePerGas: tx.maxFeePerGas
            };
            const unsignedTx = (0, $df9mn.Transaction).from(transaction).unsignedSerialized.substring(2); // Create unsigned transaction
            const transport = await (0, $4ceb4776397f30f0$export$ea1f07d757001497)();
            const LedgerHqAppEth = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("gLGU9")));
            const LedgerAppEth = LedgerHqAppEth.default;
            const eth = new LedgerAppEth(transport);
            const resolution = await LedgerHqAppEth.ledgerService.resolveTransaction(unsignedTx, {}, {}); // metadata necessary to allow the device to clear sign information
            const signature = await eth.signTransaction((0, $a0be4e76406c4732$export$11792f2e0d4d6623)(), unsignedTx, resolution);
            const signedTx = (0, $df9mn.Transaction).from({
                ...transaction,
                signature: {
                    r: '0x' + signature.r,
                    s: '0x' + signature.s,
                    v: parseInt(signature.v)
                }
            }).serialized;
            const broadcastResult = await provider.broadcastTransaction(signedTx);
            return {
                hash: broadcastResult.hash
            };
        } catch (error) {
            throw (0, $4ceb4776397f30f0$export$36edca307d1b62d1)(error);
        } finally{
            await (0, $4ceb4776397f30f0$export$a84ecb994933e890)();
        }
    }
}


parcelRequire("6Zvtg");
var $4tkSS = parcelRequire("4tkSS");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");

var $ihoyg = parcelRequire("ihoyg");

var $evN8c = parcelRequire("evN8c");

var $7vYz3 = parcelRequire("7vYz3");
var $5542bfd98d16174f$exports = {};

var $kG2My = parcelRequire("kG2My");
var $5542bfd98d16174f$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
$5542bfd98d16174f$exports = $kG2My($5542bfd98d16174f$var$ALPHABET);


function $7d8a565183ca5e46$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $7d8a565183ca5e46$export$87b259aa03e3d267(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
function $7d8a565183ca5e46$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
function $7d8a565183ca5e46$export$b3317979f9250576(b, ...lengths) {
    if (!$7d8a565183ca5e46$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $7d8a565183ca5e46$export$d6af199866bfb566(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    $7d8a565183ca5e46$export$98e628dec113755e(h.outputLen);
    $7d8a565183ca5e46$export$98e628dec113755e(h.blockLen);
}
function $7d8a565183ca5e46$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $7d8a565183ca5e46$export$c789db2c85949867(out, instance) {
    $7d8a565183ca5e46$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $7d8a565183ca5e46$var$assert = {
    number: $7d8a565183ca5e46$export$98e628dec113755e,
    bool: $7d8a565183ca5e46$export$87b259aa03e3d267,
    bytes: $7d8a565183ca5e46$export$b3317979f9250576,
    hash: $7d8a565183ca5e46$export$d6af199866bfb566,
    exists: $7d8a565183ca5e46$export$f7e9f41ea797a17,
    output: $7d8a565183ca5e46$export$c789db2c85949867
};
var $7d8a565183ca5e46$export$2e2bcd8739ae039 = $7d8a565183ca5e46$var$assert;


/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $a6e7c0e84a224052$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;



function $88e38fd113a6cf11$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
const $88e38fd113a6cf11$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $88e38fd113a6cf11$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $88e38fd113a6cf11$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $88e38fd113a6cf11$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $88e38fd113a6cf11$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $88e38fd113a6cf11$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $88e38fd113a6cf11$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $88e38fd113a6cf11$export$4a0a88cc2d284e7f = $88e38fd113a6cf11$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$88e38fd113a6cf11$export$a4170f7f8be47425(n);
function $88e38fd113a6cf11$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $88e38fd113a6cf11$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $88e38fd113a6cf11$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $88e38fd113a6cf11$export$58b867e287a802c8(bytes) {
    (0, $7d8a565183ca5e46$export$b3317979f9250576)(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $88e38fd113a6cf11$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $88e38fd113a6cf11$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $88e38fd113a6cf11$var$asciiToBase16(char) {
    if (char >= $88e38fd113a6cf11$var$asciis._0 && char <= $88e38fd113a6cf11$var$asciis._9) return char - $88e38fd113a6cf11$var$asciis._0;
    if (char >= $88e38fd113a6cf11$var$asciis._A && char <= $88e38fd113a6cf11$var$asciis._F) return char - ($88e38fd113a6cf11$var$asciis._A - 10);
    if (char >= $88e38fd113a6cf11$var$asciis._a && char <= $88e38fd113a6cf11$var$asciis._f) return char - ($88e38fd113a6cf11$var$asciis._a - 10);
    return;
}
function $88e38fd113a6cf11$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $88e38fd113a6cf11$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $88e38fd113a6cf11$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $88e38fd113a6cf11$export$bdd553fddd433dcb = async ()=>{};
async function $88e38fd113a6cf11$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $88e38fd113a6cf11$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $88e38fd113a6cf11$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $88e38fd113a6cf11$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $88e38fd113a6cf11$export$3df70a15530b5e81(data);
    (0, $7d8a565183ca5e46$export$b3317979f9250576)(data);
    return data;
}
function $88e38fd113a6cf11$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $7d8a565183ca5e46$export$b3317979f9250576)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $88e38fd113a6cf11$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $88e38fd113a6cf11$var$toStr = {}.toString;
function $88e38fd113a6cf11$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $88e38fd113a6cf11$var$toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $88e38fd113a6cf11$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($88e38fd113a6cf11$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $88e38fd113a6cf11$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($88e38fd113a6cf11$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $88e38fd113a6cf11$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($88e38fd113a6cf11$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $88e38fd113a6cf11$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $a6e7c0e84a224052$export$7effb53edfc7fa2d) && typeof (0, $a6e7c0e84a224052$export$7effb53edfc7fa2d).getRandomValues === 'function') return (0, $a6e7c0e84a224052$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}


// Polyfill for Safari 14
function $ac42251d7f300352$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $ac42251d7f300352$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $ac42251d7f300352$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $ac42251d7f300352$export$f9f830659f932cb2 extends (0, $88e38fd113a6cf11$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $88e38fd113a6cf11$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $7d8a565183ca5e46$export$f7e9f41ea797a17)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $88e38fd113a6cf11$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $88e38fd113a6cf11$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $7d8a565183ca5e46$export$f7e9f41ea797a17)(this);
        (0, $7d8a565183ca5e46$export$c789db2c85949867)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $ac42251d7f300352$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $88e38fd113a6cf11$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $a71f3af8acb76dac$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $a71f3af8acb76dac$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $a71f3af8acb76dac$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $a71f3af8acb76dac$var$SHA256 extends (0, $ac42251d7f300352$export$f9f830659f932cb2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $a71f3af8acb76dac$var$SHA256_IV[0] | 0;
        this.B = $a71f3af8acb76dac$var$SHA256_IV[1] | 0;
        this.C = $a71f3af8acb76dac$var$SHA256_IV[2] | 0;
        this.D = $a71f3af8acb76dac$var$SHA256_IV[3] | 0;
        this.E = $a71f3af8acb76dac$var$SHA256_IV[4] | 0;
        this.F = $a71f3af8acb76dac$var$SHA256_IV[5] | 0;
        this.G = $a71f3af8acb76dac$var$SHA256_IV[6] | 0;
        this.H = $a71f3af8acb76dac$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$a71f3af8acb76dac$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $a71f3af8acb76dac$var$SHA256_W[i - 15];
            const W2 = $a71f3af8acb76dac$var$SHA256_W[i - 2];
            const s0 = (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(W15, 7) ^ (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(W2, 17) ^ (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $a71f3af8acb76dac$var$SHA256_W[i] = s1 + $a71f3af8acb76dac$var$SHA256_W[i - 7] + s0 + $a71f3af8acb76dac$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(E, 6) ^ (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(E, 11) ^ (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $ac42251d7f300352$export$d0d97f016526eaf0)(E, F, G) + $a71f3af8acb76dac$var$SHA256_K[i] + $a71f3af8acb76dac$var$SHA256_W[i] | 0;
            const sigma0 = (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(A, 2) ^ (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(A, 13) ^ (0, $88e38fd113a6cf11$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $ac42251d7f300352$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $a71f3af8acb76dac$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $a71f3af8acb76dac$var$SHA224 extends $a71f3af8acb76dac$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $a71f3af8acb76dac$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $88e38fd113a6cf11$export$f081816339df1972)(()=>new $a71f3af8acb76dac$var$SHA256());
const $a71f3af8acb76dac$export$97b70509d4e397ea = /* @__PURE__ */ (0, $88e38fd113a6cf11$export$f081816339df1972)(()=>new $a71f3af8acb76dac$var$SHA224());



var $4xx4u = parcelRequire("4xx4u");

var $3wEH9 = parcelRequire("3wEH9");

var $gbKvo = parcelRequire("gbKvo");
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $d0df8b81fd061078$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join('.') + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $d0df8b81fd061078$var$isIterable(x) {
    return $d0df8b81fd061078$var$isObject(x) && typeof x[Symbol.iterator] === 'function';
}
/**
 * Check if a value is a plain object.
 */ function $d0df8b81fd061078$var$isObject(x) {
    return typeof x === 'object' && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $d0df8b81fd061078$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $d0df8b81fd061078$var$print(value) {
    return typeof value === 'string' ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $d0df8b81fd061078$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $d0df8b81fd061078$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === 'string') result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : '') + ", but received: `" + $d0df8b81fd061078$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $d0df8b81fd061078$var$toFailures(result, context, struct, value) {
    if (!$d0df8b81fd061078$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $d0df8b81fd061078$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $d0df8b81fd061078$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== 'type' && $d0df8b81fd061078$var$isObject(struct.schema) && $d0df8b81fd061078$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $d0df8b81fd061078$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($d0df8b81fd061078$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $d0df8b81fd061078$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $d0df8b81fd061078$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $d0df8b81fd061078$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $d0df8b81fd061078$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $d0df8b81fd061078$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $d0df8b81fd061078$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $d0df8b81fd061078$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $d0df8b81fd061078$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $d0df8b81fd061078$export$a7a9523472993e97(value, struct) {
    const result = $d0df8b81fd061078$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $d0df8b81fd061078$export$185802fd694ee1f5(value, struct) {
    const result = $d0df8b81fd061078$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $d0df8b81fd061078$export$d99f0801a68bbcf1(value, struct) {
    const result = $d0df8b81fd061078$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $d0df8b81fd061078$export$226b3eccf92c9ed9(value, struct) {
    const result = $d0df8b81fd061078$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $d0df8b81fd061078$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $d0df8b81fd061078$var$run(value, struct, options);
    const tuple = $d0df8b81fd061078$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $d0df8b81fd061078$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $d0df8b81fd061078$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $d0df8b81fd061078$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $d0df8b81fd061078$export$f36d6a7a5c09a23e(name, validator) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $d0df8b81fd061078$export$cdd73fc4100a6ef4(struct, log) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $d0df8b81fd061078$export$7077912c31975674(fn) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'dynamic',
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $d0df8b81fd061078$export$488013bae63b21da(fn) {
    let struct;
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'lazy',
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $d0df8b81fd061078$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $d0df8b81fd061078$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $d0df8b81fd061078$export$e45945969df8035a(struct) {
    const schema = struct instanceof $d0df8b81fd061078$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $d0df8b81fd061078$export$516e28dec6a4b6d4(schema[key]);
    return $d0df8b81fd061078$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $d0df8b81fd061078$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $d0df8b81fd061078$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $d0df8b81fd061078$export$8cf3da7c1c9174ea(name, validator) {
    console.warn('superstruct@0.11 - The `struct` helper has been renamed to `define`.');
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $d0df8b81fd061078$export$4154a199d7d90455() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('any', ()=>true);
}
function $d0df8b81fd061078$export$2f23118c22fb2630(Element) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'array',
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $d0df8b81fd061078$export$4a21f16c33752377() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('boolean', (value)=>{
        return typeof value === 'boolean';
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $d0df8b81fd061078$export$324d90190a8b822a() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('date', (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $d0df8b81fd061078$var$print(value);
    });
}
function $d0df8b81fd061078$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$d0df8b81fd061078$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'enums',
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $d0df8b81fd061078$export$86951950244e2001() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('func', (value)=>{
        return typeof value === 'function' || "Expected a function, but received: " + $d0df8b81fd061078$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $d0df8b81fd061078$export$9544d5bb712b01ea(Class) {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('instance', (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $d0df8b81fd061078$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $d0df8b81fd061078$export$32744b5b3bba4764() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('integer', (value)=>{
        return typeof value === 'number' && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $d0df8b81fd061078$var$print(value);
    });
}
function $d0df8b81fd061078$export$bc86dfbf7795668c(Structs) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'intersection',
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $d0df8b81fd061078$export$c8ec6e1ec9fefcb0(constant) {
    const description = $d0df8b81fd061078$var$print(constant);
    const t = typeof constant;
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'literal',
        schema: t === 'string' || t === 'number' || t === 'boolean' ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
function $d0df8b81fd061078$export$871de8747c9eaa88(Key, Value) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'map',
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $d0df8b81fd061078$export$b3e22bcfd64c1022() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('never', ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $d0df8b81fd061078$export$133fc36489ac9add(struct) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $d0df8b81fd061078$export$98e628dec113755e() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('number', (value)=>{
        return typeof value === 'number' && !isNaN(value) || "Expected a number, but received: " + $d0df8b81fd061078$var$print(value);
    });
}
function $d0df8b81fd061078$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $d0df8b81fd061078$export$b3e22bcfd64c1022();
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'object',
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $d0df8b81fd061078$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $d0df8b81fd061078$var$isObject(value) || "Expected an object, but received: " + $d0df8b81fd061078$var$print(value);
        },
        coercer (value) {
            return $d0df8b81fd061078$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $d0df8b81fd061078$export$516e28dec6a4b6d4(struct) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $d0df8b81fd061078$export$e5185e241753e543(Key, Value) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'record',
        schema: null,
        *entries (value) {
            if ($d0df8b81fd061078$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $d0df8b81fd061078$var$isObject(value) || "Expected an object, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $d0df8b81fd061078$export$efdc1e5bdb609bb() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('regexp', (value)=>{
        return value instanceof RegExp;
    });
}
function $d0df8b81fd061078$export$adaa4cf7ef1b65be(Element) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'set',
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $d0df8b81fd061078$export$22b082955e083ec3() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('string', (value)=>{
        return typeof value === 'string' || "Expected a string, but received: " + $d0df8b81fd061078$var$print(value);
    });
}
function $d0df8b81fd061078$export$65e3907585753458(Elements) {
    const Never = $d0df8b81fd061078$export$b3e22bcfd64c1022();
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'tuple',
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $d0df8b81fd061078$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'type',
        schema: schema,
        *entries (value) {
            if ($d0df8b81fd061078$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $d0df8b81fd061078$var$isObject(value) || "Expected an object, but received: " + $d0df8b81fd061078$var$print(value);
        }
    });
}
function $d0df8b81fd061078$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(' | ');
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        type: 'union',
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $d0df8b81fd061078$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $d0df8b81fd061078$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $d0df8b81fd061078$export$19282c40b967aec6() {
    return $d0df8b81fd061078$export$f36d6a7a5c09a23e('unknown', ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $d0df8b81fd061078$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $d0df8b81fd061078$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $d0df8b81fd061078$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $d0df8b81fd061078$export$8c14e57e778d3873(struct, $d0df8b81fd061078$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === 'function' ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $d0df8b81fd061078$var$isPlainObject(x) && $d0df8b81fd061078$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $d0df8b81fd061078$export$41f369984ed28930(struct) {
    return $d0df8b81fd061078$export$8c14e57e778d3873(struct, $d0df8b81fd061078$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $d0df8b81fd061078$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $d0df8b81fd061078$export$edc9d475108b3212(struct, 'empty', (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $d0df8b81fd061078$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $d0df8b81fd061078$export$edc9d475108b3212(struct, 'max', (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $d0df8b81fd061078$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $d0df8b81fd061078$export$edc9d475108b3212(struct, 'min', (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? '' : 'or equal to ') + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $d0df8b81fd061078$export$24f82734ea047e6f(struct, regexp) {
    return $d0df8b81fd061078$export$edc9d475108b3212(struct, 'pattern', (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + "/` but received \"" + value + "\"";
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $d0df8b81fd061078$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $d0df8b81fd061078$export$edc9d475108b3212(struct, 'size', (value)=>{
        if (typeof value === 'number' || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $d0df8b81fd061078$export$edc9d475108b3212(struct, name, refiner) {
    return new $d0df8b81fd061078$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $d0df8b81fd061078$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}



var $fFbWN = parcelRequire("fFbWN");

var $81012 = parcelRequire("81012");

var $6U8NG = parcelRequire("6U8NG");

const $5a0b8c6d73eab685$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $5a0b8c6d73eab685$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $5a0b8c6d73eab685$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $5a0b8c6d73eab685$var$U32_MASK64),
        l: Number(n >> $5a0b8c6d73eab685$var$_32n & $5a0b8c6d73eab685$var$U32_MASK64)
    };
    return {
        h: Number(n >> $5a0b8c6d73eab685$var$_32n & $5a0b8c6d73eab685$var$U32_MASK64) | 0,
        l: Number(n & $5a0b8c6d73eab685$var$U32_MASK64) | 0
    };
}
function $5a0b8c6d73eab685$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $5a0b8c6d73eab685$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $5a0b8c6d73eab685$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $5a0b8c6d73eab685$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $5a0b8c6d73eab685$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $5a0b8c6d73eab685$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $5a0b8c6d73eab685$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $5a0b8c6d73eab685$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $5a0b8c6d73eab685$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $5a0b8c6d73eab685$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $5a0b8c6d73eab685$export$a088d44bd387d2a3 = (_h, l)=>l;
const $5a0b8c6d73eab685$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $5a0b8c6d73eab685$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $5a0b8c6d73eab685$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $5a0b8c6d73eab685$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $5a0b8c6d73eab685$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $5a0b8c6d73eab685$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $5a0b8c6d73eab685$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $5a0b8c6d73eab685$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $5a0b8c6d73eab685$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $5a0b8c6d73eab685$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $5a0b8c6d73eab685$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $5a0b8c6d73eab685$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $5a0b8c6d73eab685$var$u64 = {
    fromBig: $5a0b8c6d73eab685$export$9625d4333cb56c3f,
    split: $5a0b8c6d73eab685$export$65980d18b75784e2,
    toBig: $5a0b8c6d73eab685$export$30f78adcaaa2eb7,
    shrSH: $5a0b8c6d73eab685$export$75aa78dc5bd52853,
    shrSL: $5a0b8c6d73eab685$export$a0225ff0aee14e25,
    rotrSH: $5a0b8c6d73eab685$export$97f812dfd830ca87,
    rotrSL: $5a0b8c6d73eab685$export$60987e30e2c9d9d,
    rotrBH: $5a0b8c6d73eab685$export$af9c7fbac44dcb76,
    rotrBL: $5a0b8c6d73eab685$export$f619171d6d5ac414,
    rotr32H: $5a0b8c6d73eab685$export$a088d44bd387d2a3,
    rotr32L: $5a0b8c6d73eab685$export$8415aae4d1f69577,
    rotlSH: $5a0b8c6d73eab685$export$4b80a2917447870e,
    rotlSL: $5a0b8c6d73eab685$export$20652918a7b63b3,
    rotlBH: $5a0b8c6d73eab685$export$a52f14bf902f9977,
    rotlBL: $5a0b8c6d73eab685$export$5d12cc1da441323f,
    add: $5a0b8c6d73eab685$export$e16d8520af44a096,
    add3L: $5a0b8c6d73eab685$export$c0c22b91f08911f,
    add3H: $5a0b8c6d73eab685$export$ef7b26044977a8ec,
    add4L: $5a0b8c6d73eab685$export$2f4e199c560f545d,
    add4H: $5a0b8c6d73eab685$export$e909220d675a7741,
    add5H: $5a0b8c6d73eab685$export$b45ee8d78c965098,
    add5L: $5a0b8c6d73eab685$export$d732b061fe9c9ae4
};
var $5a0b8c6d73eab685$export$2e2bcd8739ae039 = $5a0b8c6d73eab685$var$u64;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $60f1612060468e08$var$SHA3_PI = [];
const $60f1612060468e08$var$SHA3_ROTL = [];
const $60f1612060468e08$var$_SHA3_IOTA = [];
const $60f1612060468e08$var$_0n = /* @__PURE__ */ BigInt(0);
const $60f1612060468e08$var$_1n = /* @__PURE__ */ BigInt(1);
const $60f1612060468e08$var$_2n = /* @__PURE__ */ BigInt(2);
const $60f1612060468e08$var$_7n = /* @__PURE__ */ BigInt(7);
const $60f1612060468e08$var$_256n = /* @__PURE__ */ BigInt(256);
const $60f1612060468e08$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $60f1612060468e08$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $60f1612060468e08$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $60f1612060468e08$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $60f1612060468e08$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $60f1612060468e08$var$_1n ^ (R >> $60f1612060468e08$var$_7n) * $60f1612060468e08$var$_0x71n) % $60f1612060468e08$var$_256n;
        if (R & $60f1612060468e08$var$_2n) t ^= $60f1612060468e08$var$_1n << ($60f1612060468e08$var$_1n << /* @__PURE__ */ BigInt(j)) - $60f1612060468e08$var$_1n;
    }
    $60f1612060468e08$var$_SHA3_IOTA.push(t);
}
const [$60f1612060468e08$var$SHA3_IOTA_H, $60f1612060468e08$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $5a0b8c6d73eab685$export$65980d18b75784e2)($60f1612060468e08$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $60f1612060468e08$var$rotlH = (h, l, s)=>s > 32 ? (0, $5a0b8c6d73eab685$export$a52f14bf902f9977)(h, l, s) : (0, $5a0b8c6d73eab685$export$4b80a2917447870e)(h, l, s);
const $60f1612060468e08$var$rotlL = (h, l, s)=>s > 32 ? (0, $5a0b8c6d73eab685$export$5d12cc1da441323f)(h, l, s) : (0, $5a0b8c6d73eab685$export$20652918a7b63b3)(h, l, s);
function $60f1612060468e08$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $60f1612060468e08$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $60f1612060468e08$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $60f1612060468e08$var$SHA3_ROTL[t];
            const Th = $60f1612060468e08$var$rotlH(curH, curL, shift);
            const Tl = $60f1612060468e08$var$rotlL(curH, curL, shift);
            const PI = $60f1612060468e08$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $60f1612060468e08$var$SHA3_IOTA_H[round];
        s[1] ^= $60f1612060468e08$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $60f1612060468e08$export$f7374b8b4498bc2e extends (0, $88e38fd113a6cf11$export$ab85ecd77ce6a5cd) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $7d8a565183ca5e46$export$98e628dec113755e)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = (0, $88e38fd113a6cf11$export$8bacf4ad828c7fe7)(this.state);
    }
    keccak() {
        if (!(0, $88e38fd113a6cf11$export$a0f88e38d4cf9577)) (0, $88e38fd113a6cf11$export$97b40fc37f25d711)(this.state32);
        $60f1612060468e08$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $88e38fd113a6cf11$export$a0f88e38d4cf9577)) (0, $88e38fd113a6cf11$export$97b40fc37f25d711)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $7d8a565183ca5e46$export$f7e9f41ea797a17)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $88e38fd113a6cf11$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $7d8a565183ca5e46$export$f7e9f41ea797a17)(this, false);
        (0, $7d8a565183ca5e46$export$b3317979f9250576)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $7d8a565183ca5e46$export$98e628dec113755e)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $7d8a565183ca5e46$export$c789db2c85949867)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $60f1612060468e08$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $60f1612060468e08$var$gen = (suffix, blockLen, outputLen)=>(0, $88e38fd113a6cf11$export$f081816339df1972)(()=>new $60f1612060468e08$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $60f1612060468e08$export$fe6c2b96a79338e9 = /* @__PURE__ */ $60f1612060468e08$var$gen(0x06, 144, 28);
const $60f1612060468e08$export$76e19b6966813b14 = /* @__PURE__ */ $60f1612060468e08$var$gen(0x06, 136, 32);
const $60f1612060468e08$export$a58509fa80f30d15 = /* @__PURE__ */ $60f1612060468e08$var$gen(0x06, 104, 48);
const $60f1612060468e08$export$20ed324dbdf09b7c = /* @__PURE__ */ $60f1612060468e08$var$gen(0x06, 72, 64);
const $60f1612060468e08$export$2f7fb3c6fac246bc = /* @__PURE__ */ $60f1612060468e08$var$gen(0x01, 144, 28);
const $60f1612060468e08$export$860ddaa9ca84a66d = /* @__PURE__ */ $60f1612060468e08$var$gen(0x01, 136, 32);
const $60f1612060468e08$export$46fcdeb4c5686552 = /* @__PURE__ */ $60f1612060468e08$var$gen(0x01, 104, 48);
const $60f1612060468e08$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $60f1612060468e08$var$gen(0x01, 72, 64);
const $60f1612060468e08$var$genShake = (suffix, blockLen, outputLen)=>(0, $88e38fd113a6cf11$export$e18964dbd6e083c1)((opts = {})=>new $60f1612060468e08$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $60f1612060468e08$export$f43dc3bb86efbba2 = /* @__PURE__ */ $60f1612060468e08$var$genShake(0x1f, 168, 16);
const $60f1612060468e08$export$c240d011f1520440 = /* @__PURE__ */ $60f1612060468e08$var$genShake(0x1f, 136, 32);



var $75Cpc = parcelRequire("75Cpc");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $4ae4b35b64318a06$var$generatePrivateKey = (0, $evN8c.ed25519).utils.randomPrivateKey;
const $4ae4b35b64318a06$var$generateKeypair = ()=>{
    const privateScalar = (0, $evN8c.ed25519).utils.randomPrivateKey();
    const publicKey = $4ae4b35b64318a06$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $4ae4b35b64318a06$var$getPublicKey = (0, $evN8c.ed25519).getPublicKey;
function $4ae4b35b64318a06$var$isOnCurve(publicKey) {
    try {
        (0, $evN8c.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $4ae4b35b64318a06$var$sign = (message, secretKey)=>(0, $evN8c.ed25519).sign(message, secretKey.slice(0, 32));
const $4ae4b35b64318a06$var$verify = (0, $evN8c.ed25519).verify;
const $4ae4b35b64318a06$var$toBuffer = (arr)=>{
    if ((0, $ihoyg.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $ihoyg.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $ihoyg.Buffer).from(arr);
};
// Class wrapping a plain object
class $4ae4b35b64318a06$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $ihoyg.Buffer).from((0, $4xx4u.serialize)($4ae4b35b64318a06$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $4xx4u.deserialize)($4ae4b35b64318a06$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $4xx4u.deserializeUnchecked)($4ae4b35b64318a06$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $4ae4b35b64318a06$export$deb82508dd66d288 extends $4ae4b35b64318a06$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = '';
        if (Object.keys(properties).length !== 1) throw new Error('Enum can only take single value');
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $4ae4b35b64318a06$export$68d13ce9b4cc48f3 = new Map();
var $4ae4b35b64318a06$var$_class;
let $4ae4b35b64318a06$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $4ae4b35b64318a06$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $4ae4b35b64318a06$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $4ae4b35b64318a06$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $4ae4b35b64318a06$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $4ae4b35b64318a06$var$_Symbol$toStringTag = Symbol.toStringTag;
class $4ae4b35b64318a06$export$ca8b6604d6ce14de extends $4ae4b35b64318a06$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($4ae4b35b64318a06$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === 'string') {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(value);
                if (decoded.length != $4ae4b35b64318a06$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(value);
            if (this._bn.byteLength() > $4ae4b35b64318a06$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $4ae4b35b64318a06$export$ca8b6604d6ce14de($4ae4b35b64318a06$var$uniquePublicKeyCounter);
        $4ae4b35b64318a06$var$uniquePublicKeyCounter += 1;
        return new $4ae4b35b64318a06$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $ihoyg.Buffer));
        if (b.length === $4ae4b35b64318a06$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $ihoyg.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$4ae4b35b64318a06$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $ihoyg.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $ihoyg.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $a71f3af8acb76dac$export$bced8d2aada2d1c9)(buffer);
        return new $4ae4b35b64318a06$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $ihoyg.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $4ae4b35b64318a06$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $ihoyg.Buffer).concat([
                buffer,
                $4ae4b35b64318a06$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $ihoyg.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $ihoyg.Buffer).from('ProgramDerivedAddress')
        ]);
        const publicKeyBytes = (0, $a71f3af8acb76dac$export$bced8d2aada2d1c9)(buffer);
        if ($4ae4b35b64318a06$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $4ae4b35b64318a06$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $ihoyg.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $4ae4b35b64318a06$export$ca8b6604d6ce14de(pubkeyData);
        return $4ae4b35b64318a06$var$isOnCurve(pubkey.toBytes());
    }
}
$4ae4b35b64318a06$var$_class = $4ae4b35b64318a06$export$ca8b6604d6ce14de;
$4ae4b35b64318a06$export$ca8b6604d6ce14de.default = new $4ae4b35b64318a06$var$_class('11111111111111111111111111111111');
$4ae4b35b64318a06$export$68d13ce9b4cc48f3.set($4ae4b35b64318a06$export$ca8b6604d6ce14de, {
    kind: 'struct',
    fields: [
        [
            '_bn',
            'u256'
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $4ae4b35b64318a06$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $4ae4b35b64318a06$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error('bad secret key size');
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $4ae4b35b64318a06$var$toBuffer($4ae4b35b64318a06$var$generatePrivateKey());
            this._publicKey = $4ae4b35b64318a06$var$toBuffer($4ae4b35b64318a06$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $4ae4b35b64318a06$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $ihoyg.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $4ae4b35b64318a06$export$42bd37c1c64962b6 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('BPFLoader1111111111111111111111111111111111');
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $4ae4b35b64318a06$export$4c6d5b89e1596f26 = 1232;
const $4ae4b35b64318a06$export$3c3793d809f8b858 = 0x7f;
const $4ae4b35b64318a06$export$14aee086fde78fa6 = 64;
class $4ae4b35b64318a06$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($4ae4b35b64318a06$export$718fcd78527f88ed.prototype, 'name', {
    value: 'TransactionExpiredBlockheightExceededError'
});
class $4ae4b35b64318a06$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + 'unknown if it succeeded or failed. Check signature ' + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($4ae4b35b64318a06$export$b822204c22e46bdf.prototype, 'name', {
    value: 'TransactionExpiredTimeoutError'
});
class $4ae4b35b64318a06$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($4ae4b35b64318a06$export$a3e7565a95f5a1e5.prototype, 'name', {
    value: 'TransactionExpiredNonceInvalidError'
});
class $4ae4b35b64318a06$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error('Account index overflow encountered during compilation');
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error('Encountered an unknown instruction account key during compilation');
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $4ae4b35b64318a06$var$publicKey = (property = 'publicKey')=>{
    return $3wEH9.blob(32, property);
};
/**
 * Layout for a signature
 */ const $4ae4b35b64318a06$var$signature = (property = 'signature')=>{
    return $3wEH9.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $4ae4b35b64318a06$var$rustString = (property = 'string')=>{
    const rsl = $3wEH9.struct([
        $3wEH9.u32('length'),
        $3wEH9.u32('lengthPadding'),
        $3wEH9.blob($3wEH9.offset($3wEH9.u32(), -8), 'chars')
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data['chars'].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $ihoyg.Buffer).from(str, 'utf8')
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $3wEH9.u32().span + $3wEH9.u32().span + (0, $ihoyg.Buffer).from(str, 'utf8').length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $4ae4b35b64318a06$var$authorized = (property = 'authorized')=>{
    return $3wEH9.struct([
        $4ae4b35b64318a06$var$publicKey('staker'),
        $4ae4b35b64318a06$var$publicKey('withdrawer')
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $4ae4b35b64318a06$var$lockup = (property = 'lockup')=>{
    return $3wEH9.struct([
        $3wEH9.ns64('unixTimestamp'),
        $3wEH9.ns64('epoch'),
        $4ae4b35b64318a06$var$publicKey('custodian')
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $4ae4b35b64318a06$var$voteInit = (property = 'voteInit')=>{
    return $3wEH9.struct([
        $4ae4b35b64318a06$var$publicKey('nodePubkey'),
        $4ae4b35b64318a06$var$publicKey('authorizedVoter'),
        $4ae4b35b64318a06$var$publicKey('authorizedWithdrawer'),
        $3wEH9.u8('commission')
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $4ae4b35b64318a06$var$voteAuthorizeWithSeedArgs = (property = 'voteAuthorizeWithSeedArgs')=>{
    return $3wEH9.struct([
        $3wEH9.u32('voteAuthorizationType'),
        $4ae4b35b64318a06$var$publicKey('currentAuthorityDerivedKeyOwnerPubkey'),
        $4ae4b35b64318a06$var$rustString('currentAuthorityDerivedKeySeed'),
        $4ae4b35b64318a06$var$publicKey('newAuthorized')
    ], property);
};
function $4ae4b35b64318a06$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === 'function') return item.alloc(fields[item.property]);
        else if ('count' in item && 'elementLayout' in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ('fields' in item) // This is a `Structure` whose size needs to be recursively measured.
        return $4ae4b35b64318a06$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $4ae4b35b64318a06$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $4ae4b35b64318a06$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $4ae4b35b64318a06$var$assert(condition, message) {
    if (!condition) throw new Error(message || 'Assertion failed');
}
class $4ae4b35b64318a06$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $4ae4b35b64318a06$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $4ae4b35b64318a06$var$assert(mapEntries.length <= 256, 'Max static account keys length exceeded');
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $4ae4b35b64318a06$var$assert(writableSigners.length > 0, 'Expected at least one writable signer key');
            const [payerAddress] = writableSigners[0];
            $4ae4b35b64318a06$var$assert(payerAddress === this.payer.toBase58(), 'Expected first writable signer key to be the fee payer');
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $4ae4b35b64318a06$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $4ae4b35b64318a06$var$assert(lookupTableIndex < 256, 'Max lookup table index exceeded');
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $4ae4b35b64318a06$var$END_OF_BUFFER_ERROR_MESSAGE = 'Reached end of buffer unexpectedly';
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $4ae4b35b64318a06$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($4ae4b35b64318a06$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $4ae4b35b64318a06$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($4ae4b35b64318a06$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $4ae4b35b64318a06$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return 'legacy';
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $4ae4b35b64318a06$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $4ae4b35b64318a06$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $4ae4b35b64318a06$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode(ix.data)
            }));
        return new $4ae4b35b64318a06$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $4ae4b35b64318a06$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(instruction.data));
            let keyIndicesCount = [];
            $4ae4b35b64318a06$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $4ae4b35b64318a06$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $ihoyg.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $ihoyg.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $4ae4b35b64318a06$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $ihoyg.Buffer).alloc($4ae4b35b64318a06$export$4c6d5b89e1596f26);
        (0, $ihoyg.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $3wEH9.struct([
                $3wEH9.u8('programIdIndex'),
                $3wEH9.blob(instruction.keyIndicesCount.length, 'keyIndicesCount'),
                $3wEH9.seq($3wEH9.u8('keyIndex'), instruction.keyIndices.length, 'keyIndices'),
                $3wEH9.blob(instruction.dataLength.length, 'dataLength'),
                $3wEH9.seq($3wEH9.u8('userdatum'), instruction.data.length, 'data')
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $3wEH9.struct([
            $3wEH9.blob(1, 'numRequiredSignatures'),
            $3wEH9.blob(1, 'numReadonlySignedAccounts'),
            $3wEH9.blob(1, 'numReadonlyUnsignedAccounts'),
            $3wEH9.blob(keyCount.length, 'keyCount'),
            $3wEH9.seq($4ae4b35b64318a06$var$publicKey('key'), numKeys, 'keys'),
            $4ae4b35b64318a06$var$publicKey('recentBlockhash')
        ]);
        const transaction = {
            numRequiredSignatures: (0, $ihoyg.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $ihoyg.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $ihoyg.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $ihoyg.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$4ae4b35b64318a06$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(this.recentBlockhash)
        };
        let signData = (0, $ihoyg.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $4ae4b35b64318a06$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $4ae4b35b64318a06$export$3c3793d809f8b858)) throw new Error('Versioned messages must be deserialized with VersionedMessage.deserialize()');
        const numReadonlySignedAccounts = $4ae4b35b64318a06$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $4ae4b35b64318a06$var$guardedShift(byteArray);
        const accountCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$84fc0a248cc54343);
            accountKeys.push(new $4ae4b35b64318a06$export$ca8b6604d6ce14de((0, $ihoyg.Buffer).from(account)));
        }
        const recentBlockhash = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$84fc0a248cc54343);
        const instructionCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $4ae4b35b64318a06$var$guardedShift(byteArray);
            const accountCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
            const accounts = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
            const dataSlice = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode((0, $ihoyg.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode((0, $ihoyg.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $4ae4b35b64318a06$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $4ae4b35b64318a06$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && 'accountKeysFromLookups' in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error('Failed to get account keys because of a mismatch in the number of account keys from lookups');
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && 'addressLookupTableAccounts' in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error('Failed to get account keys because address table lookups were not resolved');
        return new $4ae4b35b64318a06$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $4ae4b35b64318a06$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $4ae4b35b64318a06$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $4ae4b35b64318a06$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $4ae4b35b64318a06$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $4ae4b35b64318a06$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $4ae4b35b64318a06$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $3wEH9.struct([
            $3wEH9.u8('prefix'),
            $3wEH9.struct([
                $3wEH9.u8('numRequiredSignatures'),
                $3wEH9.u8('numReadonlySignedAccounts'),
                $3wEH9.u8('numReadonlyUnsignedAccounts')
            ], 'header'),
            $3wEH9.blob(encodedStaticAccountKeysLength.length, 'staticAccountKeysLength'),
            $3wEH9.seq($4ae4b35b64318a06$var$publicKey(), this.staticAccountKeys.length, 'staticAccountKeys'),
            $4ae4b35b64318a06$var$publicKey('recentBlockhash'),
            $3wEH9.blob(encodedInstructionsLength.length, 'instructionsLength'),
            $3wEH9.blob(serializedInstructions.length, 'serializedInstructions'),
            $3wEH9.blob(encodedAddressTableLookupsLength.length, 'addressTableLookupsLength'),
            $3wEH9.blob(serializedAddressTableLookups.length, 'serializedAddressTableLookups')
        ]);
        const serializedMessage = new Uint8Array($4ae4b35b64318a06$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($4ae4b35b64318a06$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $4ae4b35b64318a06$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $4ae4b35b64318a06$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $3wEH9.struct([
                $3wEH9.u8('programIdIndex'),
                $3wEH9.blob(encodedAccountKeyIndexesLength.length, 'encodedAccountKeyIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), instruction.accountKeyIndexes.length, 'accountKeyIndexes'),
                $3wEH9.blob(encodedDataLength.length, 'encodedDataLength'),
                $3wEH9.blob(instruction.data.length, 'data')
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($4ae4b35b64318a06$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $4ae4b35b64318a06$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $4ae4b35b64318a06$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $3wEH9.struct([
                $4ae4b35b64318a06$var$publicKey('accountKey'),
                $3wEH9.blob(encodedWritableIndexesLength.length, 'encodedWritableIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), lookup.writableIndexes.length, 'writableIndexes'),
                $3wEH9.blob(encodedReadonlyIndexesLength.length, 'encodedReadonlyIndexesLength'),
                $3wEH9.seq($3wEH9.u8(), lookup.readonlyIndexes.length, 'readonlyIndexes')
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $4ae4b35b64318a06$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $4ae4b35b64318a06$export$3c3793d809f8b858;
        $4ae4b35b64318a06$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $4ae4b35b64318a06$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $4ae4b35b64318a06$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $4ae4b35b64318a06$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $4ae4b35b64318a06$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $4ae4b35b64318a06$export$ca8b6604d6ce14de($4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode($4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$84fc0a248cc54343));
        const instructionCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $4ae4b35b64318a06$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
            const accountKeyIndexes = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
            const data = new Uint8Array($4ae4b35b64318a06$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $4ae4b35b64318a06$export$ca8b6604d6ce14de($4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$84fc0a248cc54343));
            const writableIndexesLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
            const writableIndexes = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
            const readonlyIndexes = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $4ae4b35b64318a06$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $4ae4b35b64318a06$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $4ae4b35b64318a06$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return 'legacy';
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $4ae4b35b64318a06$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === 'legacy') return $4ae4b35b64318a06$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $4ae4b35b64318a06$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $4ae4b35b64318a06$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $4ae4b35b64318a06$var$DEFAULT_SIGNATURE = (0, $ihoyg.Buffer).alloc($4ae4b35b64318a06$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $4ae4b35b64318a06$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $ihoyg.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $4ae4b35b64318a06$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, 'nonceInfo')) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, 'lastValidBlockHeight')) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error('No instructions');
        items.forEach((item)=>{
            if ('instructions' in item) this.instructions = this.instructions.concat(item.instructions);
            else if ('data' in item && 'programId' in item && 'keys' in item) this.instructions.push(item);
            else this.instructions.push(new $4ae4b35b64318a06$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error('Transaction recentBlockhash required');
        if (instructions.length < 1) console.warn('No instructions provided');
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error('Transaction fee payer required');
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: 'best fit',
                usage: 'sort',
                sensitivity: 'variant',
                ignorePunctuation: false,
                numeric: false,
                caseFirst: 'lower'
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), 'en', options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $4ae4b35b64318a06$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$4ae4b35b64318a06$var$assert(keyIndex >= 0));
        });
        return new $4ae4b35b64318a06$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $4ae4b35b64318a06$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $4ae4b35b64318a06$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $4ae4b35b64318a06$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $ihoyg.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$4ae4b35b64318a06$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = 'Signature verification failed.';
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? '' : '(s)'} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join('`, `')}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? '' : '(s)'} [\`${sigErrors.missing.map((p)=>p.toBase58()).join('`, `')}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $4ae4b35b64318a06$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $ihoyg.Buffer).alloc(transactionLength);
        $4ae4b35b64318a06$var$assert(signatures.length < 256);
        (0, $ihoyg.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $4ae4b35b64318a06$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $ihoyg.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $4ae4b35b64318a06$var$assert(wireTransaction.length <= $4ae4b35b64318a06$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$4ae4b35b64318a06$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $4ae4b35b64318a06$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $4ae4b35b64318a06$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $4ae4b35b64318a06$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode((0, $ihoyg.Buffer).from(signature)));
        }
        return $4ae4b35b64318a06$export$febc5573c75cefb0.populate($4ae4b35b64318a06$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).encode($4ae4b35b64318a06$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $4ae4b35b64318a06$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $4ae4b35b64318a06$var$assert(numWritableSignedAccounts > 0, 'Message header is invalid');
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $4ae4b35b64318a06$var$assert(numWritableUnsignedAccounts >= 0, 'Message header is invalid');
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error('Failed to decompile message because no account keys were found');
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $4ae4b35b64318a06$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $4ae4b35b64318a06$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $4ae4b35b64318a06$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $4ae4b35b64318a06$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $4ae4b35b64318a06$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $4ae4b35b64318a06$var$assert(signatures.length === message.header.numRequiredSignatures, 'Expected signatures length to be equal to the number of required signatures');
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($4ae4b35b64318a06$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $4ae4b35b64318a06$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $3wEH9.struct([
            $3wEH9.blob(encodedSignaturesLength.length, 'encodedSignaturesLength'),
            $3wEH9.seq($4ae4b35b64318a06$var$signature(), this.signatures.length, 'signatures'),
            $3wEH9.blob(serializedMessage.length, 'serializedMessage')
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $4ae4b35b64318a06$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$14aee086fde78fa6)));
        const message = $4ae4b35b64318a06$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $4ae4b35b64318a06$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $4ae4b35b64318a06$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $4ae4b35b64318a06$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $4ae4b35b64318a06$var$assert(signature.byteLength === 64, 'Signature must be 64 bytes long');
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $4ae4b35b64318a06$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $4ae4b35b64318a06$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $4ae4b35b64318a06$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $4ae4b35b64318a06$var$NUM_SLOTS_PER_SECOND = $4ae4b35b64318a06$var$NUM_TICKS_PER_SECOND / $4ae4b35b64318a06$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $4ae4b35b64318a06$var$MS_PER_SLOT = 1000 / $4ae4b35b64318a06$var$NUM_SLOTS_PER_SECOND;
const $4ae4b35b64318a06$export$393aa1412d47050e = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarC1ock11111111111111111111111111111111');
const $4ae4b35b64318a06$export$2b71d479444d2f4 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarEpochSchedu1e111111111111111111111111');
const $4ae4b35b64318a06$export$54419cc1a3ece8d6 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('Sysvar1nstructions1111111111111111111111111');
const $4ae4b35b64318a06$export$e74201139e9833db = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarRecentB1ockHashes11111111111111111111');
const $4ae4b35b64318a06$export$970d0190cdb3a8e9 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarRent111111111111111111111111111111111');
const $4ae4b35b64318a06$export$da3b38d796bc1af1 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarRewards111111111111111111111111111111');
const $4ae4b35b64318a06$export$7b3a057916a4a7ae = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarS1otHashes111111111111111111111111111');
const $4ae4b35b64318a06$export$3272815bf0633907 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarS1otHistory11111111111111111111111111');
const $4ae4b35b64318a06$export$ca994171317280ea = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('SysvarStakeHistory1111111111111111111111111');
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $4ae4b35b64318a06$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $4ae4b35b64318a06$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $4ae4b35b64318a06$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $4ae4b35b64318a06$var$getAlloc(type, fields);
    const data = (0, $ihoyg.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $4ae4b35b64318a06$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $4ae4b35b64318a06$export$d1cc579b1c48f515 = $3wEH9.nu64('lamportsPerSignature');
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $4ae4b35b64318a06$var$NonceAccountLayout = $3wEH9.struct([
    $3wEH9.u32('version'),
    $3wEH9.u32('state'),
    $4ae4b35b64318a06$var$publicKey('authorizedPubkey'),
    $4ae4b35b64318a06$var$publicKey('nonce'),
    $3wEH9.struct([
        $4ae4b35b64318a06$export$d1cc579b1c48f515
    ], 'feeCalculator')
]);
const $4ae4b35b64318a06$export$7126250b6d8bd94a = $4ae4b35b64318a06$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $4ae4b35b64318a06$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $4ae4b35b64318a06$var$NonceAccountLayout.decode($4ae4b35b64318a06$var$toBuffer(buffer), 0);
        return new $4ae4b35b64318a06$export$ed1c2356ce604759({
            authorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $4ae4b35b64318a06$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $4ae4b35b64318a06$var$bigInt = (length)=>(property)=>{
        const layout = (0, $3wEH9.blob)(length, property);
        const { encode: encode, decode: decode } = $4ae4b35b64318a06$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $gbKvo.toBigIntLE)((0, $ihoyg.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $gbKvo.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $4ae4b35b64318a06$var$u64 = $4ae4b35b64318a06$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $4ae4b35b64318a06$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($4ae4b35b64318a06$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a SystemInstruction');
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($4ae4b35b64318a06$export$d8c4e17726848113.programId)) throw new Error('invalid instruction; programId is not SystemProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $4ae4b35b64318a06$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports'),
            $3wEH9.ns64('space'),
            $4ae4b35b64318a06$var$publicKey('programId')
        ])
    },
    Assign: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('programId')
        ])
    },
    Transfer: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$u64('lamports')
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('base'),
            $4ae4b35b64318a06$var$rustString('seed'),
            $3wEH9.ns64('lamports'),
            $3wEH9.ns64('space'),
            $4ae4b35b64318a06$var$publicKey('programId')
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('authorized')
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('authorized')
        ])
    },
    Allocate: {
        index: 8,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('space')
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('base'),
            $4ae4b35b64318a06$var$rustString('seed'),
            $3wEH9.ns64('space'),
            $4ae4b35b64318a06$var$publicKey('programId')
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('base'),
            $4ae4b35b64318a06$var$rustString('seed'),
            $4ae4b35b64318a06$var$publicKey('programId')
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$u64('lamports'),
            $4ae4b35b64318a06$var$rustString('seed'),
            $4ae4b35b64318a06$var$publicKey('programId')
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $4ae4b35b64318a06$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.Create;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $4ae4b35b64318a06$var$toBuffer(params.programId.toBuffer())
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $4ae4b35b64318a06$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $4ae4b35b64318a06$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.Transfer;
            data = $4ae4b35b64318a06$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $4ae4b35b64318a06$var$encodeData(type, {
                base: $4ae4b35b64318a06$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $4ae4b35b64318a06$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.Assign;
            data = $4ae4b35b64318a06$var$encodeData(type, {
                programId: $4ae4b35b64318a06$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            base: $4ae4b35b64318a06$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $4ae4b35b64318a06$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        if ('basePubkey' in params && 'seed' in params) transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $4ae4b35b64318a06$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $4ae4b35b64318a06$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            authorized: $4ae4b35b64318a06$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            authorized: $4ae4b35b64318a06$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $4ae4b35b64318a06$var$encodeData(type, {
                base: $4ae4b35b64318a06$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $4ae4b35b64318a06$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $4ae4b35b64318a06$export$74bdf41d8d1e7108.Allocate;
            data = $4ae4b35b64318a06$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$4ae4b35b64318a06$export$d8c4e17726848113.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('11111111111111111111111111111111');
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $4ae4b35b64318a06$var$CHUNK_SIZE = $4ae4b35b64318a06$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $4ae4b35b64318a06$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $4ae4b35b64318a06$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, 'confirmed');
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error('Program load failed, account is already executable');
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $4ae4b35b64318a06$export$febc5573c75cefb0();
                    transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $4ae4b35b64318a06$export$febc5573c75cefb0();
                    transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $4ae4b35b64318a06$export$febc5573c75cefb0();
                    transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0().add($4ae4b35b64318a06$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $4ae4b35b64318a06$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            });
        }
        const dataLayout = $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.u32('offset'),
            $3wEH9.u32('bytesLength'),
            $3wEH9.u32('bytesLengthPadding'),
            $3wEH9.seq($3wEH9.u8('byte'), $3wEH9.offset($3wEH9.u32(), -8), 'bytes')
        ]);
        const chunkSize = $4ae4b35b64318a06$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $ihoyg.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($4ae4b35b64318a06$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes('solana.com')) {
                const REQUESTS_PER_SECOND = 4;
                await $4ae4b35b64318a06$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $3wEH9.struct([
                $3wEH9.u32('instruction')
            ]);
            const data = (0, $ihoyg.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $4ae4b35b64318a06$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = 'processed';
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($4ae4b35b64318a06$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$4ae4b35b64318a06$export$3b0d6d7590275603.chunkSize = $4ae4b35b64318a06$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $4ae4b35b64318a06$export$59833422f998b937 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('BPFLoader2111111111111111111111111111111111');
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $4ae4b35b64318a06$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $4ae4b35b64318a06$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $4ae4b35b64318a06$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $4ae4b35b64318a06$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $4ae4b35b64318a06$var$objToString = Object.prototype.toString;
var $4ae4b35b64318a06$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $4ae4b35b64318a06$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $4ae4b35b64318a06$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $4ae4b35b64318a06$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = '[';
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $4ae4b35b64318a06$var$stringify(val[i], true) + ',';
                    if (max > -1) str += $4ae4b35b64318a06$var$stringify(val[i], true);
                    return str + ']';
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $4ae4b35b64318a06$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $4ae4b35b64318a06$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ',';
                            str += JSON.stringify(key) + ':' + propVal;
                        }
                        i++;
                    }
                    return '{' + str + '}';
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $4ae4b35b64318a06$var$fastStableStringify = function(val) {
    var returnVal = $4ae4b35b64318a06$var$stringify(val, false);
    if (returnVal !== undefined) return '' + returnVal;
};
var $4ae4b35b64318a06$var$fastStableStringify$1 = /*@__PURE__*/ $4ae4b35b64318a06$var$getDefaultExportFromCjs($4ae4b35b64318a06$var$fastStableStringify);
const $4ae4b35b64318a06$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $4ae4b35b64318a06$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $4ae4b35b64318a06$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $4ae4b35b64318a06$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $4ae4b35b64318a06$var$trailingZeros($4ae4b35b64318a06$var$nextPowerOfTwo(slot + $4ae4b35b64318a06$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $4ae4b35b64318a06$var$trailingZeros($4ae4b35b64318a06$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $4ae4b35b64318a06$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $4ae4b35b64318a06$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $4ae4b35b64318a06$var$trailingZeros($4ae4b35b64318a06$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $4ae4b35b64318a06$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $4ae4b35b64318a06$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $4ae4b35b64318a06$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = 'SolanaJSONRPCError';
    }
}
var $4ae4b35b64318a06$var$fetchImpl = globalThis.fetch;
class $4ae4b35b64318a06$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($81012))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($6U8NG)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ('socket' in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error('Tried to call a JSON-RPC method `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error('Tried to send a JSON-RPC notification `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $4ae4b35b64318a06$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $4ae4b35b64318a06$var$LOOKUP_TABLE_META_SIZE = 56;
class $4ae4b35b64318a06$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt('0xffffffffffffffff');
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $4ae4b35b64318a06$var$decodeData($4ae4b35b64318a06$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $4ae4b35b64318a06$var$LOOKUP_TABLE_META_SIZE;
        $4ae4b35b64318a06$var$assert(serializedAddressesLen >= 0, 'lookup table is invalid');
        $4ae4b35b64318a06$var$assert(serializedAddressesLen % 32 === 0, 'lookup table is invalid');
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $3wEH9.struct([
            $3wEH9.seq($4ae4b35b64318a06$var$publicKey(), numSerializedAddresses, 'addresses')
        ]).decode(accountData.slice($4ae4b35b64318a06$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $4ae4b35b64318a06$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(address))
        };
    }
}
const $4ae4b35b64318a06$var$LookupTableMetaLayout = {
    index: 1,
    layout: $3wEH9.struct([
        $3wEH9.u32('typeIndex'),
        $4ae4b35b64318a06$var$u64('deactivationSlot'),
        $3wEH9.nu64('lastExtendedSlot'),
        $3wEH9.u8('lastExtendedStartIndex'),
        $3wEH9.u8(),
        // option
        $3wEH9.seq($4ae4b35b64318a06$var$publicKey(), $3wEH9.offset($3wEH9.u8(), -1), 'authority')
    ])
};
const $4ae4b35b64318a06$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $4ae4b35b64318a06$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($4ae4b35b64318a06$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith('https:') ? 'wss:' : 'ws:';
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? '' : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $4ae4b35b64318a06$var$PublicKeyFromString = (0, $d0df8b81fd061078$export$8c14e57e778d3873)((0, $d0df8b81fd061078$export$9544d5bb712b01ea)($4ae4b35b64318a06$export$ca8b6604d6ce14de), (0, $d0df8b81fd061078$export$22b082955e083ec3)(), (value)=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(value));
const $4ae4b35b64318a06$var$RawAccountDataResult = (0, $d0df8b81fd061078$export$65e3907585753458)([
    (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('base64')
]);
const $4ae4b35b64318a06$var$BufferFromRawAccountData = (0, $d0df8b81fd061078$export$8c14e57e778d3873)((0, $d0df8b81fd061078$export$9544d5bb712b01ea)((0, $ihoyg.Buffer)), $4ae4b35b64318a06$var$RawAccountDataResult, (value)=>(0, $ihoyg.Buffer).from(value[0], 'base64'));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $4ae4b35b64318a06$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $4ae4b35b64318a06$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError('Endpoint URL must start with `http:` or `https:`.');
    return putativeUrl;
}
/** @internal */ function $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === 'string') commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $4ae4b35b64318a06$var$createRpcResult(result) {
    return (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
        (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            jsonrpc: (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('2.0'),
            id: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
            result: result
        }),
        (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            jsonrpc: (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('2.0'),
            id: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
            error: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
                code: (0, $d0df8b81fd061078$export$19282c40b967aec6)(),
                message: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
                data: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$4154a199d7d90455)())
            })
        })
    ]);
}
const $4ae4b35b64318a06$var$UnknownRpcResult = $4ae4b35b64318a06$var$createRpcResult((0, $d0df8b81fd061078$export$19282c40b967aec6)());
/**
 * @internal
 */ function $4ae4b35b64318a06$var$jsonRpcResult(schema) {
    return (0, $d0df8b81fd061078$export$8c14e57e778d3873)($4ae4b35b64318a06$var$createRpcResult(schema), $4ae4b35b64318a06$var$UnknownRpcResult, (value)=>{
        if ('error' in value) return value;
        else return {
            ...value,
            result: (0, $d0df8b81fd061078$export$185802fd694ee1f5)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $4ae4b35b64318a06$var$jsonRpcResultAndContext(value) {
    return $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        context: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            slot: (0, $d0df8b81fd061078$export$98e628dec113755e)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $4ae4b35b64318a06$var$notificationResultAndContext(value) {
    return (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        context: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            slot: (0, $d0df8b81fd061078$export$98e628dec113755e)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $4ae4b35b64318a06$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $4ae4b35b64318a06$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $4ae4b35b64318a06$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $4ae4b35b64318a06$var$GetInflationGovernorResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    foundation: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    foundationTerm: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    initial: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    taper: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    terminal: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $4ae4b35b64318a06$var$GetInflationRewardResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    epoch: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    effectiveSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    amount: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    postBalance: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    commission: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $4ae4b35b64318a06$var$GetRecentPrioritizationFeesResult = (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    prioritizationFee: (0, $d0df8b81fd061078$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $4ae4b35b64318a06$var$GetInflationRateResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    total: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    validator: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    foundation: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    epoch: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * Information about the current epoch
 */ const $4ae4b35b64318a06$var$GetEpochInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    epoch: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    slotIndex: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    slotsInEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    absoluteSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    blockHeight: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    transactionCount: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)())
});
const $4ae4b35b64318a06$var$GetEpochScheduleResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    slotsPerEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    leaderScheduleSlotOffset: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    warmup: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
    firstNormalEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    firstNormalSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $4ae4b35b64318a06$var$GetLeaderScheduleResult = (0, $d0df8b81fd061078$export$e5185e241753e543)((0, $d0df8b81fd061078$export$22b082955e083ec3)(), (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()));
/**
 * Transaction error or null
 */ const $4ae4b35b64318a06$var$TransactionErrorResult = (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({}),
    (0, $d0df8b81fd061078$export$22b082955e083ec3)()
]));
/**
 * Signature status for a transaction
 */ const $4ae4b35b64318a06$var$SignatureStatusResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    err: $4ae4b35b64318a06$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $4ae4b35b64318a06$var$SignatureReceivedResult = (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('receivedSignature');
/**
 * Version info for a node
 */ const $4ae4b35b64318a06$var$VersionResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    'solana-core': (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    'feature-set': (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)())
});
const $4ae4b35b64318a06$var$SimulatedTransactionResponseStruct = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    err: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
        (0, $d0df8b81fd061078$export$bf9fb029d174d554)({}),
        (0, $d0df8b81fd061078$export$22b082955e083ec3)()
    ])),
    logs: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)())),
    accounts: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        executable: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
        owner: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
        lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        data: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
        rentEpoch: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)())
    }))))),
    unitsConsumed: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    returnData: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        programId: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
        data: (0, $d0df8b81fd061078$export$65e3907585753458)([
            (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
            (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('base64')
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $4ae4b35b64318a06$var$BlockProductionResponseStruct = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    byIdentity: (0, $d0df8b81fd061078$export$e5185e241753e543)((0, $d0df8b81fd061078$export$22b082955e083ec3)(), (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)())),
    range: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        firstSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        lastSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    })
}));
/**
 * A performance sample
 */ function $4ae4b35b64318a06$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $4ae4b35b64318a06$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($fFbWN)))(async (request, callback)=>{
        const options = {
            method: 'POST',
            body: request,
            agent: agent,
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, httpHeaders || {}, $4ae4b35b64318a06$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $4ae4b35b64318a06$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $4ae4b35b64318a06$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $4ae4b35b64318a06$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $4ae4b35b64318a06$var$GetInflationGovernorRpcResult = $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $4ae4b35b64318a06$var$GetInflationRateRpcResult = $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $4ae4b35b64318a06$var$GetRecentPrioritizationFeesRpcResult = $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $4ae4b35b64318a06$var$GetEpochInfoRpcResult = $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $4ae4b35b64318a06$var$GetEpochScheduleRpcResult = $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $4ae4b35b64318a06$var$GetLeaderScheduleRpcResult = $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $4ae4b35b64318a06$var$SlotRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$98e628dec113755e)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $4ae4b35b64318a06$var$GetSupplyRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    total: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    circulating: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    nonCirculating: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    nonCirculatingAccounts: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $4ae4b35b64318a06$var$TokenAmountResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    amount: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    uiAmount: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    decimals: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    uiAmountString: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$22b082955e083ec3)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $4ae4b35b64318a06$var$GetTokenLargestAccountsResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    address: $4ae4b35b64318a06$var$PublicKeyFromString,
    amount: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    uiAmount: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    decimals: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    uiAmountString: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$22b082955e083ec3)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $4ae4b35b64318a06$var$GetTokenAccountsByOwner = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: $4ae4b35b64318a06$var$PublicKeyFromString,
    account: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        executable: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
        owner: $4ae4b35b64318a06$var$PublicKeyFromString,
        lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        data: $4ae4b35b64318a06$var$BufferFromRawAccountData,
        rentEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    })
})));
const $4ae4b35b64318a06$var$ParsedAccountDataResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    program: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parsed: (0, $d0df8b81fd061078$export$19282c40b967aec6)(),
    space: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $4ae4b35b64318a06$var$GetParsedTokenAccountsByOwner = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: $4ae4b35b64318a06$var$PublicKeyFromString,
    account: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        executable: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
        owner: $4ae4b35b64318a06$var$PublicKeyFromString,
        lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        data: $4ae4b35b64318a06$var$ParsedAccountDataResult,
        rentEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $4ae4b35b64318a06$var$GetLargestAccountsRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    address: $4ae4b35b64318a06$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $4ae4b35b64318a06$var$AccountInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    executable: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
    owner: $4ae4b35b64318a06$var$PublicKeyFromString,
    lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    data: $4ae4b35b64318a06$var$BufferFromRawAccountData,
    rentEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$KeyedAccountInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: $4ae4b35b64318a06$var$PublicKeyFromString,
    account: $4ae4b35b64318a06$var$AccountInfoResult
});
const $4ae4b35b64318a06$var$ParsedOrRawAccountData = (0, $d0df8b81fd061078$export$8c14e57e778d3873)((0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    (0, $d0df8b81fd061078$export$9544d5bb712b01ea)((0, $ihoyg.Buffer)),
    $4ae4b35b64318a06$var$ParsedAccountDataResult
]), (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    $4ae4b35b64318a06$var$RawAccountDataResult,
    $4ae4b35b64318a06$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $d0df8b81fd061078$export$185802fd694ee1f5)(value, $4ae4b35b64318a06$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$ParsedAccountInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    executable: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
    owner: $4ae4b35b64318a06$var$PublicKeyFromString,
    lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    data: $4ae4b35b64318a06$var$ParsedOrRawAccountData,
    rentEpoch: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
const $4ae4b35b64318a06$var$KeyedParsedAccountInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: $4ae4b35b64318a06$var$PublicKeyFromString,
    account: $4ae4b35b64318a06$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$StakeActivationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    state: (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
        (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('active'),
        (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('inactive'),
        (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('activating'),
        (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('deactivating')
    ]),
    active: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    inactive: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $4ae4b35b64318a06$var$GetConfirmedSignaturesForAddress2RpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    signature: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    err: $4ae4b35b64318a06$var$TransactionErrorResult,
    memo: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    blockTime: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $4ae4b35b64318a06$var$GetSignaturesForAddressRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    signature: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    err: $4ae4b35b64318a06$var$TransactionErrorResult,
    memo: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    blockTime: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $4ae4b35b64318a06$var$AccountNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    result: $4ae4b35b64318a06$var$notificationResultAndContext($4ae4b35b64318a06$var$AccountInfoResult)
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$ProgramAccountInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: $4ae4b35b64318a06$var$PublicKeyFromString,
    account: $4ae4b35b64318a06$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $4ae4b35b64318a06$var$ProgramAccountNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    result: $4ae4b35b64318a06$var$notificationResultAndContext($4ae4b35b64318a06$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$SlotInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    parent: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    root: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $4ae4b35b64318a06$var$SlotNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    result: $4ae4b35b64318a06$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $4ae4b35b64318a06$var$SlotUpdateResult = (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        type: (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
            (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('firstShredReceived'),
            (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('completed'),
            (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('optimisticConfirmation'),
            (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('root')
        ]),
        slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        timestamp: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    }),
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        type: (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('createdBank'),
        parent: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        timestamp: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    }),
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        type: (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('frozen'),
        slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        timestamp: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        stats: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            numTransactionEntries: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
            numSuccessfulTransactions: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
            numFailedTransactions: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
            maxTransactionsPerEntry: (0, $d0df8b81fd061078$export$98e628dec113755e)()
        })
    }),
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        type: (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('dead'),
        slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        timestamp: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        err: (0, $d0df8b81fd061078$export$22b082955e083ec3)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $4ae4b35b64318a06$var$SlotUpdateNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    result: $4ae4b35b64318a06$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $4ae4b35b64318a06$var$SignatureNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    result: $4ae4b35b64318a06$var$notificationResultAndContext((0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
        $4ae4b35b64318a06$var$SignatureStatusResult,
        $4ae4b35b64318a06$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $4ae4b35b64318a06$var$RootNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    result: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
const $4ae4b35b64318a06$var$ContactInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    gossip: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    tpu: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    rpc: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    version: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)())
});
const $4ae4b35b64318a06$var$VoteAccountInfoResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    votePubkey: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    nodePubkey: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    activatedStake: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    epochVoteAccount: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
    epochCredits: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$65e3907585753458)([
        (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        (0, $d0df8b81fd061078$export$98e628dec113755e)()
    ])),
    commission: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    lastVote: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    rootSlot: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $4ae4b35b64318a06$var$GetVoteAccounts = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    current: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$VoteAccountInfoResult),
    delinquent: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$VoteAccountInfoResult)
}));
const $4ae4b35b64318a06$var$ConfirmationStatus = (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('processed'),
    (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('confirmed'),
    (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('finalized')
]);
const $4ae4b35b64318a06$var$SignatureStatusResponse = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    confirmations: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    err: $4ae4b35b64318a06$var$TransactionErrorResult,
    confirmationStatus: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $4ae4b35b64318a06$var$GetSignatureStatusesRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $4ae4b35b64318a06$var$GetMinimumBalanceForRentExemptionRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$98e628dec113755e)());
const $4ae4b35b64318a06$var$AddressTableLookupStruct = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    accountKey: $4ae4b35b64318a06$var$PublicKeyFromString,
    writableIndexes: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    readonlyIndexes: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)())
});
const $4ae4b35b64318a06$var$ConfirmedTransactionResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    signatures: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    message: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        accountKeys: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
        header: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            numRequiredSignatures: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
            numReadonlySignedAccounts: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
            numReadonlyUnsignedAccounts: (0, $d0df8b81fd061078$export$98e628dec113755e)()
        }),
        instructions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            accounts: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
            data: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
            programIdIndex: (0, $d0df8b81fd061078$export$98e628dec113755e)()
        })),
        recentBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
        addressTableLookups: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$AddressTableLookupStruct))
    })
});
const $4ae4b35b64318a06$var$AnnotatedAccountKey = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: $4ae4b35b64318a06$var$PublicKeyFromString,
    signer: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
    writable: (0, $d0df8b81fd061078$export$4a21f16c33752377)(),
    source: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
        (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('transaction'),
        (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('lookupTable')
    ]))
});
const $4ae4b35b64318a06$var$ConfirmedTransactionAccountsModeResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    accountKeys: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$AnnotatedAccountKey),
    signatures: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)())
});
const $4ae4b35b64318a06$var$ParsedInstructionResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    parsed: (0, $d0df8b81fd061078$export$19282c40b967aec6)(),
    program: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    programId: $4ae4b35b64318a06$var$PublicKeyFromString
});
const $4ae4b35b64318a06$var$RawInstructionResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    accounts: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$PublicKeyFromString),
    data: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    programId: $4ae4b35b64318a06$var$PublicKeyFromString
});
const $4ae4b35b64318a06$var$InstructionResult = (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    $4ae4b35b64318a06$var$RawInstructionResult,
    $4ae4b35b64318a06$var$ParsedInstructionResult
]);
const $4ae4b35b64318a06$var$UnknownInstructionResult = (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        parsed: (0, $d0df8b81fd061078$export$19282c40b967aec6)(),
        program: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
        programId: (0, $d0df8b81fd061078$export$22b082955e083ec3)()
    }),
    (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        accounts: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
        data: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
        programId: (0, $d0df8b81fd061078$export$22b082955e083ec3)()
    })
]);
const $4ae4b35b64318a06$var$ParsedOrRawInstruction = (0, $d0df8b81fd061078$export$8c14e57e778d3873)($4ae4b35b64318a06$var$InstructionResult, $4ae4b35b64318a06$var$UnknownInstructionResult, (value)=>{
    if ('accounts' in value) return (0, $d0df8b81fd061078$export$185802fd694ee1f5)(value, $4ae4b35b64318a06$var$RawInstructionResult);
    else return (0, $d0df8b81fd061078$export$185802fd694ee1f5)(value, $4ae4b35b64318a06$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$ParsedConfirmedTransactionResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    signatures: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    message: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        accountKeys: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$AnnotatedAccountKey),
        instructions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
        addressTableLookups: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$AddressTableLookupStruct)))
    })
});
const $4ae4b35b64318a06$var$TokenBalanceResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    accountIndex: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    mint: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    owner: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    uiTokenAmount: $4ae4b35b64318a06$var$TokenAmountResult
});
const $4ae4b35b64318a06$var$LoadedAddressesResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    writable: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$PublicKeyFromString),
    readonly: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$ConfirmedTransactionMetaResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    err: $4ae4b35b64318a06$var$TransactionErrorResult,
    fee: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    innerInstructions: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        index: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        instructions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
            accounts: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
            data: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
            programIdIndex: (0, $d0df8b81fd061078$export$98e628dec113755e)()
        }))
    })))),
    preBalances: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    postBalances: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    logMessages: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$TokenBalanceResult))),
    postTokenBalances: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$TokenBalanceResult))),
    loadedAddresses: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)())
});
/**
 * @internal
 */ const $4ae4b35b64318a06$var$ParsedConfirmedTransactionMetaResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    err: $4ae4b35b64318a06$var$TransactionErrorResult,
    fee: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    innerInstructions: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        index: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
        instructions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    postBalances: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    logMessages: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$TokenBalanceResult))),
    postTokenBalances: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$TokenBalanceResult))),
    loadedAddresses: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$98e628dec113755e)())
});
const $4ae4b35b64318a06$var$TransactionVersionStruct = (0, $d0df8b81fd061078$export$971dd5b0dfd021b6)([
    (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)(0),
    (0, $d0df8b81fd061078$export$c8ec6e1ec9fefcb0)('legacy')
]);
/** @internal */ const $4ae4b35b64318a06$var$RewardsResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    pubkey: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    lamports: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    postBalance: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    rewardType: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    commission: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $4ae4b35b64318a06$var$GetBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    transactions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        transaction: $4ae4b35b64318a06$var$ConfirmedTransactionResult,
        meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ConfirmedTransactionMetaResult),
        version: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$TransactionVersionStruct)
    })),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    blockHeight: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $4ae4b35b64318a06$var$GetNoneModeBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    blockHeight: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $4ae4b35b64318a06$var$GetAccountsModeBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    transactions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        transaction: $4ae4b35b64318a06$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ConfirmedTransactionMetaResult),
        version: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$TransactionVersionStruct)
    })),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    blockHeight: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $4ae4b35b64318a06$var$GetParsedBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    transactions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        transaction: $4ae4b35b64318a06$var$ParsedConfirmedTransactionResult,
        meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$TransactionVersionStruct)
    })),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    blockHeight: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $4ae4b35b64318a06$var$GetParsedAccountsModeBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    transactions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        transaction: $4ae4b35b64318a06$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$TransactionVersionStruct)
    })),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    blockHeight: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $4ae4b35b64318a06$var$GetParsedNoneModeBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)()),
    blockHeight: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $4ae4b35b64318a06$var$GetConfirmedBlockRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    transactions: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        transaction: $4ae4b35b64318a06$var$ConfirmedTransactionResult,
        meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$RewardsResult)),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $4ae4b35b64318a06$var$GetBlockSignaturesRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    previousBlockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    parentSlot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    signatures: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    blockTime: (0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $4ae4b35b64318a06$var$GetTransactionRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())),
    transaction: $4ae4b35b64318a06$var$ConfirmedTransactionResult,
    version: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $4ae4b35b64318a06$var$GetParsedTransactionRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    transaction: $4ae4b35b64318a06$var$ParsedConfirmedTransactionResult,
    meta: (0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())),
    version: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)($4ae4b35b64318a06$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $4ae4b35b64318a06$var$GetRecentBlockhashAndContextRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    feeCalculator: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $4ae4b35b64318a06$var$GetLatestBlockhashRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    blockhash: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    lastValidBlockHeight: (0, $d0df8b81fd061078$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $4ae4b35b64318a06$var$IsBlockhashValidRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$4a21f16c33752377)());
const $4ae4b35b64318a06$var$PerfSampleResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    slot: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    numTransactions: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    numSlots: (0, $d0df8b81fd061078$export$98e628dec113755e)(),
    samplePeriodSecs: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $4ae4b35b64318a06$var$GetRecentPerformanceSamplesRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $4ae4b35b64318a06$var$GetFeeCalculatorRpcResult = $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    feeCalculator: (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $d0df8b81fd061078$export$98e628dec113755e)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $4ae4b35b64318a06$var$RequestAirdropRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$22b082955e083ec3)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $4ae4b35b64318a06$var$SendTransactionRpcResult = $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$22b082955e083ec3)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $4ae4b35b64318a06$var$LogsResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    err: $4ae4b35b64318a06$var$TransactionErrorResult,
    logs: (0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    signature: (0, $d0df8b81fd061078$export$22b082955e083ec3)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $4ae4b35b64318a06$var$LogsNotificationResult = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    result: $4ae4b35b64318a06$var$notificationResultAndContext($4ae4b35b64318a06$var$LogsResult),
    subscription: (0, $d0df8b81fd061078$export$98e628dec113755e)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $4ae4b35b64318a06$var$COMMON_HTTP_HEADERS = {
    'solana-client': `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $4ae4b35b64318a06$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $4ae4b35b64318a06$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest('getBlockHeight', args);
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$98e628dec113755e)()));
                        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get block height information');
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === 'string') this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $4ae4b35b64318a06$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $4ae4b35b64318a06$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $4ae4b35b64318a06$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $4ae4b35b64318a06$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $4ae4b35b64318a06$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $4ae4b35b64318a06$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on('open', this._wsOnOpen.bind(this));
        this._rpcWebSocket.on('error', this._wsOnError.bind(this));
        this._rpcWebSocket.on('close', this._wsOnClose.bind(this));
        this._rpcWebSocket.on('accountNotification', this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on('programNotification', this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on('slotNotification', this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on('slotsUpdatesNotification', this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on('signatureNotification', this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on('rootNotification', this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on('logsNotification', this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBalance', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$98e628dec113755e)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get balance of account ' + publicKey.toBase58() + ': ' + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest('getBlockTime', [
            slot
        ]);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest('minimumLedgerSlot', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$98e628dec113755e)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get minimum ledger slot');
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest('getFirstAvailableBlock', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$SlotRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get first available block');
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === 'string') configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest('getSupply', [
            configArg
        ]);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetSupplyRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get supply');
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenSupply', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext($4ae4b35b64318a06$var$TokenAmountResult));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get token supply');
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenAccountBalance', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext($4ae4b35b64318a06$var$TokenAmountResult));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get token account balance');
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetTokenAccountsByOwner);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedTokenAccountsByOwner);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest('getLargestAccounts', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetLargestAccountsRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get largest accounts');
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenLargestAccounts', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetTokenLargestAccountsResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get token largest accounts');
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$AccountInfoResult)));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ParsedAccountInfoResult)));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get info about account ' + publicKey.toBase58() + ': ' + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$ParsedAccountInfoResult))));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$133fc36489ac9add)($4ae4b35b64318a06$var$AccountInfoResult))));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getStakeActivation', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$StakeActivationResult));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || 'base64', configWithoutEncoding);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const baseSchema = (0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext(baseSchema)) : (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult(baseSchema));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$KeyedParsedAccountInfoResult)));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == 'string') rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($5542bfd98d16174f$exports))).decode(rawSignature);
        } catch (err) {
            throw new Error('signature must be base58 encoded: ' + rawSignature);
        }
        $4ae4b35b64318a06$var$assert(decodedSignature.length === 64, 'signature has invalid length');
        if (typeof strategy === 'string') return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ('lastValidBlockHeight' in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener('abort', ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $4ae4b35b64318a06$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === 'subscribed') resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case 'confirmed':
                            case 'single':
                            case 'singleGossip':
                                if (value.confirmationStatus === 'processed') return;
                                break;
                            case 'finalized':
                            case 'max':
                            case 'root':
                                if (value.confirmationStatus === 'processed' || value.confirmationStatus === 'confirmed') return;
                                break;
                            // exhaust enums to ensure full coverage
                            case 'processed':
                            case 'recent':
                        }
                        done = true;
                        resolve({
                            __type: $4ae4b35b64318a06$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $4ae4b35b64318a06$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $4ae4b35b64318a06$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $4ae4b35b64318a06$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $4ae4b35b64318a06$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $4ae4b35b64318a06$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $4ae4b35b64318a06$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $4ae4b35b64318a06$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $4ae4b35b64318a06$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || 'finalized';
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case 'processed':
                        case 'recent':
                            if (confirmationStatus !== 'processed' && confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $4ae4b35b64318a06$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'confirmed':
                        case 'single':
                        case 'singleGossip':
                            if (confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $4ae4b35b64318a06$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'finalized':
                        case 'max':
                        case 'root':
                            if (confirmationStatus !== 'finalized') throw new $4ae4b35b64318a06$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $4ae4b35b64318a06$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case 'processed':
                case 'recent':
                case 'single':
                case 'confirmed':
                case 'singleGossip':
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $4ae4b35b64318a06$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $4ae4b35b64318a06$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $4ae4b35b64318a06$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest('getClusterNodes', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$ContactInfoResult)));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get cluster nodes');
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getVoteAccounts', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetVoteAccounts);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get vote accounts');
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlot', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$98e628dec113755e)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot');
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlotLeader', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$22b082955e083ec3)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leader');
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest('getSlotLeaders', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)($4ae4b35b64318a06$var$PublicKeyFromString)));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leaders');
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $4ae4b35b64318a06$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest('getSignatureStatuses', params);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetSignatureStatusesRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get signature status');
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransactionCount', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$98e628dec113755e)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction count');
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getInflationGovernor', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetInflationGovernorRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation');
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getInflationReward', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetInflationRewardResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation reward');
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest('getInflationRate', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetInflationRateRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation rate');
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getEpochInfo', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetEpochInfoRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch info');
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest('getEpochSchedule', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetEpochScheduleRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch schedule');
        const epochSchedule = res.result;
        return new $4ae4b35b64318a06$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest('getLeaderSchedule', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetLeaderScheduleRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get leader schedule');
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest('getMinimumBalanceForRentExemption', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ('error' in res) {
            console.warn('Unable to fetch minimum balance for rent exemption');
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getRecentBlockhash', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetRecentBlockhashAndContextRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent blockhash');
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest('getRecentPerformanceSamples', limit ? [
            limit
        ] : []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetRecentPerformanceSamplesRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent performance samples');
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeCalculatorForBlockhash', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetFeeCalculatorRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee calculator');
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $4ae4b35b64318a06$var$toBuffer(message.serialize()).toString('base64');
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeForMessage', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$133fc36489ac9add)((0, $d0df8b81fd061078$export$98e628dec113755e)())));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee for message');
        if (res.result === null) throw new Error('invalid blockhash');
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest('getRecentPrioritizationFees', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetRecentPrioritizationFeesRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent prioritization fees');
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getLatestBlockhash', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetLatestBlockhashRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get latest blockhash');
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('isBlockhashValid', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$IsBlockhashValidRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to determine if the blockhash `' + blockhash + '`is valid');
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest('getVersion', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult($4ae4b35b64318a06$var$VersionResult));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get version');
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest('getGenesisHash', []);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$22b082955e083ec3)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get genesis hash');
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetBlockRpcResult);
                        if ('error' in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $4ae4b35b64318a06$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(e, 'failed to get confirmed block');
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(e, 'failed to get block');
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === 'string') commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, 'base64', extra);
        const unsafeRes = await this._rpcRequest('getBlockProduction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$BlockProductionResponseStruct);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get block production information');
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetTransactionRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $4ae4b35b64318a06$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed', config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetTransactionRpcResult);
            if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $4ae4b35b64318a06$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getConfirmedBlock', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetConfirmedBlockRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $4ae4b35b64318a06$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $4ae4b35b64318a06$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getBlocks', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResult((0, $d0df8b81fd061078$export$2f23118c22fb2630)((0, $d0df8b81fd061078$export$98e628dec113755e)())));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get blocks');
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getBlock', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get block');
        const result = res.result;
        if (!result) throw new Error('Block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getConfirmedBlock', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest('getConfirmedTransaction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetTransactionRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        const message = new $4ae4b35b64318a06$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $4ae4b35b64318a06$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getConfirmedTransaction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed');
            return {
                methodName: 'getConfirmedTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!('until' in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, 'finalized');
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot('finalized');
        while(!('before' in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getConfirmedSignaturesForAddress2', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed signatures for address');
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getSignaturesForAddress', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$GetSignaturesForAddressRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, 'failed to get signatures for address');
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $4ae4b35b64318a06$export$5b2310da10e607da({
            key: accountKey,
            state: $4ae4b35b64318a06$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $4ae4b35b64318a06$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get nonce for account ' + nonceAccount.toBase58() + ': ' + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest('requestAirdrop', [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$RequestAirdropRpcResult);
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $4ae4b35b64318a06$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $4ae4b35b64318a06$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash('finalized');
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $4ae4b35b64318a06$var$sleep($4ae4b35b64318a06$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $4ae4b35b64318a06$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, 'base64', configArg);
        const unsafeRes = await this._rpcRequest('getStakeMinimumDelegation', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$jsonRpcResultAndContext((0, $d0df8b81fd061078$export$98e628dec113755e)()));
        if ('error' in res) throw new $4ae4b35b64318a06$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ('message' in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $ihoyg.Buffer).from(wireTransaction).toString('base64');
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error('Invalid arguments');
            const config = configOrSigners || {};
            config.encoding = 'base64';
            if (!('commitment' in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest('simulateTransaction', args);
            const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$SimulatedTransactionResponseStruct);
            if ('error' in res) throw new Error('failed to simulate transaction: ' + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $4ae4b35b64318a06$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $4ae4b35b64318a06$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error('Invalid arguments');
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString('base64');
        const config = {
            encoding: 'base64',
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config['accounts'] = {
                encoding: 'base64',
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('simulateTransaction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$SimulatedTransactionResponseStruct);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = '\n    ';
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $4ae4b35b64318a06$export$121e803f723b3045('failed to simulate transaction: ' + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ('version' in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $4ae4b35b64318a06$var$toBuffer(rawTransaction).toString('base64');
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: 'base64'
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? 'processed' // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('sendTransaction', args);
        const res = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(unsafeRes, $4ae4b35b64318a06$var$SendTransactionRpcResult);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) logs = res.error.data.logs;
            throw new $4ae4b35b64318a06$export$121e803f723b3045('failed to send transaction: ' + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify('ping');
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error('ws error:', err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: 'pending'
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case 'pending':
                case 'unsubscribed':
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === 'unsubscribed') delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'subscribing'
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: 'subscribed'
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'pending'
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case 'subscribed':
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: 'subscribed'
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: 'unsubscribed'
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $4ae4b35b64318a06$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: 'pending'
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $4ae4b35b64318a06$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64');
        return this._makeSubscription({
            callback: callback,
            method: 'accountSubscribe',
            unsubscribeMethod: 'accountUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'account change');
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64' /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: 'programSubscribe',
            unsubscribeMethod: 'programUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'program account change');
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === 'object' ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: 'logsSubscribe',
            unsubscribeMethod: 'logsUnsubscribe'
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'logs');
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotSubscribe',
            unsubscribeMethod: 'slotUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot change');
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotsUpdatesSubscribe',
            unsubscribeMethod: 'slotsUpdatesUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot update');
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn('Ignored unsubscribe request because an active subscription with id ' + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + 'could not be found.');
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            'confirmed',
            'finalized'
        ].includes(commitment)) throw new Error('Using Connection with default commitment: `' + this._commitment + '`, but method requires at least `confirmed`');
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$SignatureNotificationResult);
        if (result.value !== 'receivedSignature') /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === 'receivedSignature' ? [
            {
                type: 'received'
            },
            result.context
        ] : [
            {
                type: 'status',
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === 'status') {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || 'finalized' // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'signature result');
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $d0df8b81fd061078$export$185802fd694ee1f5)(notification, $4ae4b35b64318a06$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'rootSubscribe',
            unsubscribeMethod: 'rootUnsubscribe'
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'root change');
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $4ae4b35b64318a06$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $4ae4b35b64318a06$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $4ae4b35b64318a06$export$c53bca448cf33676($4ae4b35b64318a06$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error('bad secret key size');
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $4ae4b35b64318a06$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error('provided secretKey is invalid');
            }
        }
        return new $4ae4b35b64318a06$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $4ae4b35b64318a06$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $4ae4b35b64318a06$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $4ae4b35b64318a06$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $4ae4b35b64318a06$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$u64('recentSlot'),
            $3wEH9.u8('bumpSeed')
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$u64(),
            $3wEH9.seq($4ae4b35b64318a06$var$publicKey(), $3wEH9.offset($3wEH9.u32(), -8), 'addresses')
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    }
});
class $4ae4b35b64318a06$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($4ae4b35b64318a06$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error('Invalid Instruction. Should be a LookupTable Instruction');
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $4ae4b35b64318a06$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($4ae4b35b64318a06$export$5147a345798de168.programId)) throw new Error('invalid instruction; programId is not AddressLookupTable Program');
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $4ae4b35b64318a06$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $4ae4b35b64318a06$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $gbKvo.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $4ae4b35b64318a06$export$7d102200c3a357d6.CreateLookupTable;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $4ae4b35b64318a06$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $4ae4b35b64318a06$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $4ae4b35b64318a06$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $4ae4b35b64318a06$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $4ae4b35b64318a06$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $4ae4b35b64318a06$export$7d102200c3a357d6.CloseLookupTable;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$4ae4b35b64318a06$export$5147a345798de168.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('AddressLookupTab1e1111111111111111111111111');
/**
 * Compute Budget Instruction class
 */ class $4ae4b35b64318a06$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u8('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($4ae4b35b64318a06$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a ComputeBudgetInstruction');
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($4ae4b35b64318a06$export$11585db5942bcdb7.programId)) throw new Error('invalid instruction; programId is not ComputeBudgetProgram');
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $4ae4b35b64318a06$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('units'),
            $3wEH9.u32('additionalFee')
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('bytes')
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $3wEH9.u32('units')
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u8('instruction'),
            $4ae4b35b64318a06$var$u64('microLamports')
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $4ae4b35b64318a06$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $4ae4b35b64318a06$export$b7c79c50764da3d6.RequestUnits;
        const data = $4ae4b35b64318a06$var$encodeData(type, params);
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $4ae4b35b64318a06$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $4ae4b35b64318a06$var$encodeData(type, params);
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $4ae4b35b64318a06$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $4ae4b35b64318a06$var$encodeData(type, params);
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $4ae4b35b64318a06$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$4ae4b35b64318a06$export$11585db5942bcdb7.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('ComputeBudget111111111111111111111111111111');
const $4ae4b35b64318a06$var$PRIVATE_KEY_BYTES$1 = 64;
const $4ae4b35b64318a06$var$PUBLIC_KEY_BYTES$1 = 32;
const $4ae4b35b64318a06$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $4ae4b35b64318a06$var$ED25519_INSTRUCTION_LAYOUT = $3wEH9.struct([
    $3wEH9.u8('numSignatures'),
    $3wEH9.u8('padding'),
    $3wEH9.u16('signatureOffset'),
    $3wEH9.u16('signatureInstructionIndex'),
    $3wEH9.u16('publicKeyOffset'),
    $3wEH9.u16('publicKeyInstructionIndex'),
    $3wEH9.u16('messageDataOffset'),
    $3wEH9.u16('messageDataSize'),
    $3wEH9.u16('messageInstructionIndex')
]);
class $4ae4b35b64318a06$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $4ae4b35b64318a06$var$assert(publicKey.length === $4ae4b35b64318a06$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$4ae4b35b64318a06$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $4ae4b35b64318a06$var$assert(signature.length === $4ae4b35b64318a06$var$SIGNATURE_BYTES, `Signature must be ${$4ae4b35b64318a06$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $4ae4b35b64318a06$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $ihoyg.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $4ae4b35b64318a06$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $4ae4b35b64318a06$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $4ae4b35b64318a06$var$assert(privateKey.length === $4ae4b35b64318a06$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$4ae4b35b64318a06$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $4ae4b35b64318a06$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $4ae4b35b64318a06$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$4ae4b35b64318a06$export$e5087aea02631e.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('Ed25519SigVerify111111111111111111111111111');
const $4ae4b35b64318a06$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $75Cpc.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $75Cpc.secp256k1).utils.isValidPrivateKey;
const $4ae4b35b64318a06$var$publicKeyCreate = (0, $75Cpc.secp256k1).getPublicKey;
const $4ae4b35b64318a06$var$PRIVATE_KEY_BYTES = 32;
const $4ae4b35b64318a06$var$ETHEREUM_ADDRESS_BYTES = 20;
const $4ae4b35b64318a06$var$PUBLIC_KEY_BYTES = 64;
const $4ae4b35b64318a06$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $4ae4b35b64318a06$var$SECP256K1_INSTRUCTION_LAYOUT = $3wEH9.struct([
    $3wEH9.u8('numSignatures'),
    $3wEH9.u16('signatureOffset'),
    $3wEH9.u8('signatureInstructionIndex'),
    $3wEH9.u16('ethAddressOffset'),
    $3wEH9.u8('ethAddressInstructionIndex'),
    $3wEH9.u16('messageDataOffset'),
    $3wEH9.u16('messageDataSize'),
    $3wEH9.u8('messageInstructionIndex'),
    $3wEH9.blob(20, 'ethAddress'),
    $3wEH9.blob(64, 'signature'),
    $3wEH9.u8('recoveryId')
]);
class $4ae4b35b64318a06$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $4ae4b35b64318a06$var$assert(publicKey.length === $4ae4b35b64318a06$var$PUBLIC_KEY_BYTES, `Public key must be ${$4ae4b35b64318a06$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $ihoyg.Buffer).from((0, $60f1612060468e08$export$860ddaa9ca84a66d)($4ae4b35b64318a06$var$toBuffer(publicKey))).slice(-$4ae4b35b64318a06$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $4ae4b35b64318a06$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $4ae4b35b64318a06$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === 'string') {
            if (rawAddress.startsWith('0x')) ethAddress = (0, $ihoyg.Buffer).from(rawAddress.substr(2), 'hex');
            else ethAddress = (0, $ihoyg.Buffer).from(rawAddress, 'hex');
        } else ethAddress = rawAddress;
        $4ae4b35b64318a06$var$assert(ethAddress.length === $4ae4b35b64318a06$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$4ae4b35b64318a06$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $4ae4b35b64318a06$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $ihoyg.Buffer).alloc($4ae4b35b64318a06$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $4ae4b35b64318a06$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $4ae4b35b64318a06$var$toBuffer(signature),
            ethAddress: $4ae4b35b64318a06$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($4ae4b35b64318a06$var$toBuffer(message), $4ae4b35b64318a06$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $4ae4b35b64318a06$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $4ae4b35b64318a06$var$assert(pkey.length === $4ae4b35b64318a06$var$PRIVATE_KEY_BYTES, `Private key must be ${$4ae4b35b64318a06$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $4ae4b35b64318a06$var$toBuffer(pkey);
            const publicKey = $4ae4b35b64318a06$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $ihoyg.Buffer).from((0, $60f1612060468e08$export$860ddaa9ca84a66d)($4ae4b35b64318a06$var$toBuffer(message)));
            const [signature, recoveryId] = $4ae4b35b64318a06$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$4ae4b35b64318a06$export$d85dd4c1161d13c9.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('KeccakSecp256k11111111111111111111111111111');
var $4ae4b35b64318a06$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $4ae4b35b64318a06$export$18aac71979bdd08f = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('StakeConfig11111111111111111111111111111111');
/**
 * Stake account authority info
 */ class $4ae4b35b64318a06$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $4ae4b35b64318a06$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$4ae4b35b64318a06$var$_class2 = $4ae4b35b64318a06$export$e7f3941ade35598c;
$4ae4b35b64318a06$export$e7f3941ade35598c.default = new $4ae4b35b64318a06$var$_class2(0, 0, $4ae4b35b64318a06$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $4ae4b35b64318a06$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($4ae4b35b64318a06$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a StakeInstruction');
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $4ae4b35b64318a06$export$9ac74ae66932a145(new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorized.staker), new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $4ae4b35b64318a06$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $4ae4b35b64318a06$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($4ae4b35b64318a06$export$df86f933e9f8fb15.programId)) throw new Error('invalid instruction; programId is not StakeProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $4ae4b35b64318a06$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$authorized(),
            $4ae4b35b64318a06$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('newAuthorized'),
            $3wEH9.u32('stakeAuthorizationType')
        ])
    },
    Delegate: {
        index: 2,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    Split: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    Withdraw: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    Deactivate: {
        index: 5,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    Merge: {
        index: 7,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('newAuthorized'),
            $3wEH9.u32('stakeAuthorizationType'),
            $4ae4b35b64318a06$var$rustString('authoritySeed'),
            $4ae4b35b64318a06$var$publicKey('authorityOwner')
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $4ae4b35b64318a06$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $4ae4b35b64318a06$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $4ae4b35b64318a06$export$e7f3941ade35598c.default;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Initialize;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            authorized: {
                staker: $4ae4b35b64318a06$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $4ae4b35b64318a06$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $4ae4b35b64318a06$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Delegate;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Authorize;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            newAuthorized: $4ae4b35b64318a06$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            newAuthorized: $4ae4b35b64318a06$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $4ae4b35b64318a06$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Split;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            lamports: lamports
        });
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Merge;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Withdraw;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $4ae4b35b64318a06$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $4ae4b35b64318a06$export$c89793bd2bba8b2e.Deactivate;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$4ae4b35b64318a06$export$df86f933e9f8fb15.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('Stake11111111111111111111111111111111111111');
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $4ae4b35b64318a06$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $4ae4b35b64318a06$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $4ae4b35b64318a06$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $3wEH9.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a VoteInstruction');
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $4ae4b35b64318a06$export$3f9d1b16ff840d7(new $4ae4b35b64318a06$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $4ae4b35b64318a06$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $4ae4b35b64318a06$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $4ae4b35b64318a06$var$decodeData$1($4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($4ae4b35b64318a06$export$83db2bc702bee1eb.programId)) throw new Error('invalid instruction; programId is not VoteProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$publicKey('newAuthorized'),
            $3wEH9.u32('voteAuthorizationType')
        ])
    },
    Withdraw: {
        index: 3,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $3wEH9.ns64('lamports')
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $3wEH9.struct([
            $3wEH9.u32('instruction'),
            $4ae4b35b64318a06$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $4ae4b35b64318a06$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $4ae4b35b64318a06$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            voteInit: {
                nodePubkey: $4ae4b35b64318a06$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $4ae4b35b64318a06$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $4ae4b35b64318a06$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $4ae4b35b64318a06$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $4ae4b35b64318a06$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $4ae4b35b64318a06$export$febc5573c75cefb0();
        transaction.add($4ae4b35b64318a06$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            newAuthorized: $4ae4b35b64318a06$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $4ae4b35b64318a06$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $4ae4b35b64318a06$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $4ae4b35b64318a06$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $4ae4b35b64318a06$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error('Withdraw will leave vote account with insufficient funds.');
        return $4ae4b35b64318a06$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $4ae4b35b64318a06$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $4ae4b35b64318a06$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $4ae4b35b64318a06$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$4ae4b35b64318a06$export$83db2bc702bee1eb.programId = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $4ae4b35b64318a06$export$83db2bc702bee1eb.space = 3762;
const $4ae4b35b64318a06$export$afdb09d3afdde87c = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('Va1idator1nfo111111111111111111111111111111');
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $4ae4b35b64318a06$var$InfoString = (0, $d0df8b81fd061078$export$bf9fb029d174d554)({
    name: (0, $d0df8b81fd061078$export$22b082955e083ec3)(),
    website: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    details: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$22b082955e083ec3)()),
    keybaseUsername: (0, $d0df8b81fd061078$export$516e28dec6a4b6d4)((0, $d0df8b81fd061078$export$22b082955e083ec3)())
});
/**
 * ValidatorInfo class
 */ class $4ae4b35b64318a06$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $4ae4b35b64318a06$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $4ae4b35b64318a06$export$ca8b6604d6ce14de($4ae4b35b64318a06$var$guardedSplice(byteArray, 0, $4ae4b35b64318a06$export$84fc0a248cc54343));
            const isSigner = $4ae4b35b64318a06$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($4ae4b35b64318a06$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $4ae4b35b64318a06$var$rustString().decode((0, $ihoyg.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $d0df8b81fd061078$export$a7a9523472993e97)(info, $4ae4b35b64318a06$var$InfoString);
                return new $4ae4b35b64318a06$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $4ae4b35b64318a06$export$90bca02a3aea0768 = new $4ae4b35b64318a06$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $4ae4b35b64318a06$var$VoteAccountLayout = $3wEH9.struct([
    $4ae4b35b64318a06$var$publicKey('nodePubkey'),
    $4ae4b35b64318a06$var$publicKey('authorizedWithdrawer'),
    $3wEH9.u8('commission'),
    $3wEH9.nu64(),
    // votes.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('slot'),
        $3wEH9.u32('confirmationCount')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'votes'),
    $3wEH9.u8('rootSlotValid'),
    $3wEH9.nu64('rootSlot'),
    $3wEH9.nu64(),
    // authorizedVoters.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('epoch'),
        $4ae4b35b64318a06$var$publicKey('authorizedVoter')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'authorizedVoters'),
    $3wEH9.struct([
        $3wEH9.seq($3wEH9.struct([
            $4ae4b35b64318a06$var$publicKey('authorizedPubkey'),
            $3wEH9.nu64('epochOfLastAuthorizedSwitch'),
            $3wEH9.nu64('targetEpoch')
        ]), 32, 'buf'),
        $3wEH9.nu64('idx'),
        $3wEH9.u8('isEmpty')
    ], 'priorVoters'),
    $3wEH9.nu64(),
    // epochCredits.length
    $3wEH9.seq($3wEH9.struct([
        $3wEH9.nu64('epoch'),
        $3wEH9.nu64('credits'),
        $3wEH9.nu64('prevCredits')
    ]), $3wEH9.offset($3wEH9.u32(), -8), 'epochCredits'),
    $3wEH9.struct([
        $3wEH9.nu64('slot'),
        $3wEH9.nu64('timestamp')
    ], 'lastTimestamp')
]);
/**
 * VoteAccount class
 */ class $4ae4b35b64318a06$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $4ae4b35b64318a06$var$VoteAccountLayout.decode($4ae4b35b64318a06$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $4ae4b35b64318a06$export$89ef186f708d638b({
            nodePubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($4ae4b35b64318a06$var$parseAuthorizedVoter),
            priorVoters: $4ae4b35b64318a06$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $4ae4b35b64318a06$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $4ae4b35b64318a06$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $4ae4b35b64318a06$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $4ae4b35b64318a06$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($4ae4b35b64318a06$var$parsePriorVoters),
        ...buf.slice(0, idx).map($4ae4b35b64318a06$var$parsePriorVoters)
    ];
}
const $4ae4b35b64318a06$var$endpoint = {
    http: {
        devnet: 'http://api.devnet.solana.com',
        testnet: 'http://api.testnet.solana.com',
        'mainnet-beta': 'http://api.mainnet-beta.solana.com/'
    },
    https: {
        devnet: 'https://api.devnet.solana.com',
        testnet: 'https://api.testnet.solana.com',
        'mainnet-beta': 'https://api.mainnet-beta.solana.com/'
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $4ae4b35b64318a06$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? 'http' : 'https';
    if (!cluster) return $4ae4b35b64318a06$var$endpoint[key]['devnet'];
    const url = $4ae4b35b64318a06$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $4ae4b35b64318a06$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'lastValidBlockHeight')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'nonceValue')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $4ae4b35b64318a06$export$5f6a2f2669741bbe = 1000000000;


parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");



var $ihoyg = parcelRequire("ihoyg");
var $fcef959906443fe9$require$Buffer = $ihoyg.Buffer;
function $fcef959906443fe9$export$37ce1cc82e255d8(transaction) {
    return 'version' in transaction;
}


class $fcef959906443fe9$export$21c9244a2965fad7 {
    async signMessage(msg) {
        try {
            const transport = await (0, $4ceb4776397f30f0$export$ea1f07d757001497)();
            const LedgerAppSolana = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7XZVE")))).default;
            const solana = new LedgerAppSolana(transport);
            const result = await solana.signOffchainMessage((0, $a0be4e76406c4732$export$11792f2e0d4d6623)(), $fcef959906443fe9$require$Buffer.from(msg));
            return result.signature.toString();
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        try {
            const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
                const transport = await (0, $4ceb4776397f30f0$export$ea1f07d757001497)();
                const LedgerAppSolana = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7XZVE")))).default;
                const solana = new LedgerAppSolana(transport);
                let signResult;
                if ($fcef959906443fe9$export$37ce1cc82e255d8(solanaWeb3Transaction)) signResult = await solana.signTransaction((0, $a0be4e76406c4732$export$11792f2e0d4d6623)(), solanaWeb3Transaction.message.serialize());
                else signResult = await solana.signTransaction((0, $a0be4e76406c4732$export$11792f2e0d4d6623)(), solanaWeb3Transaction.serialize());
                const addressResult = await solana.getAddress((0, $a0be4e76406c4732$export$11792f2e0d4d6623)());
                const publicKey = new (0, $4ae4b35b64318a06$export$ca8b6604d6ce14de)(addressResult.address);
                solanaWeb3Transaction.addSignature(publicKey, $fcef959906443fe9$require$Buffer.from(signResult.signature));
                const serializedTx = solanaWeb3Transaction.serialize();
                return serializedTx;
            };
            const hash = await (0, $4tkSS.generalSolanaTransactionExecutor)(tx, DefaultSolanaSigner);
            return {
                hash: hash
            };
        } catch (error) {
            throw (0, $4ceb4776397f30f0$export$36edca307d1b62d1)(error);
        } finally{
            await (0, $4ceb4776397f30f0$export$a84ecb994933e890)();
        }
    }
}


async function $a768160d671222fe$export$2e2bcd8739ae039() {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new (0, $edafe799ccc2bad0$export$badd91e21a327d29)());
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $fcef959906443fe9$export$21c9244a2965fad7)());
    return signers;
}




const $3b1f7dbaa6b1ccfe$export$e506a1d27d1eaa20 = {
    type: (0, $9cRHO.WalletTypes).LEDGER
};
const $3b1f7dbaa6b1ccfe$export$8bedcca5bbd73999 = (0, $4ceb4776397f30f0$export$70fb6ebd9084576e);
const $3b1f7dbaa6b1ccfe$export$64605811ab45167f = async ({ namespaces: namespaces })=>{
    const results = [];
    const solanaNamespace = namespaces?.find((namespaceItem)=>namespaceItem.namespace === 'Solana');
    const evmNamespace = namespaces?.find((namespaceItem)=>namespaceItem.namespace === 'EVM');
    if (solanaNamespace) {
        if (solanaNamespace.derivationPath) {
            (0, $a0be4e76406c4732$export$7700d582a5b9e8d0)(solanaNamespace.derivationPath);
            const accounts = await (0, $4ceb4776397f30f0$export$a009f0f0c363aa6c)();
            results.push(accounts);
        } else throw new Error('Derivation Path can not be empty.');
    } else if (evmNamespace) {
        if (evmNamespace.derivationPath) {
            (0, $a0be4e76406c4732$export$7700d582a5b9e8d0)(evmNamespace.derivationPath);
            const accounts = await (0, $4ceb4776397f30f0$export$d5de980bfde9e56b)();
            results.push(accounts);
        } else throw new Error('Derivation Path can not be empty.');
    } else throw new Error(`It appears that you have selected a namespace that is not yet supported by our system. Your namespaces: ${namespaces?.map((namespaceItem)=>namespaceItem.namespace)}`);
    return results;
};
const $3b1f7dbaa6b1ccfe$export$37dfea93db2e14ed = async ()=>{
    (0, $4ceb4776397f30f0$export$a84ecb994933e890)();
};
const $3b1f7dbaa6b1ccfe$export$6352a17a50193ded = (0, $a768160d671222fe$export$2e2bcd8739ae039);
const $3b1f7dbaa6b1ccfe$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedChains = [];
    const ethereumBlockchain = allBlockChains.find((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (ethereumBlockchain) supportedChains.push(ethereumBlockchain);
    const solanaBlockchain = allBlockChains.find((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).SOLANA);
    if (solanaBlockchain) supportedChains.push(solanaBlockchain);
    return {
        name: 'Ledger',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/ledger/icon.svg',
        installLink: {
            DEFAULT: 'https://support.ledger.com/hc/en-us/articles/4404389606417-Download-and-install-Ledger-Live?docs=true'
        },
        color: 'black',
        supportedChains: supportedChains,
        showOnMobile: false,
        needsDerivationPath: {
            data: [
                {
                    id: 'metamask',
                    label: `Metamask (m/44'/60'/0'/0/index)`,
                    namespace: 'EVM',
                    generateDerivationPath: (index)=>`44'/60'/0'/0/${index}`
                },
                {
                    id: 'ledgerLive',
                    label: `LedgerLive (m/44'/60'/index'/0/0)`,
                    namespace: 'EVM',
                    generateDerivationPath: (index)=>`44'/60'/${index}'/0/0`
                },
                {
                    id: 'legacy',
                    label: `Legacy (m/44'/60'/0'/index)`,
                    namespace: 'EVM',
                    generateDerivationPath: (index)=>`44'/60'/0'/${index}`
                },
                {
                    id: `(m/44'/501'/index')`,
                    label: `(m/44'/501'/index')`,
                    namespace: 'Solana',
                    generateDerivationPath: (index)=>`44'/501'/${index}'`
                },
                {
                    id: `(m/44'/501'/0'/index)`,
                    label: `(m/44'/501'/0'/index)`,
                    namespace: 'Solana',
                    generateDerivationPath: (index)=>`44'/501'/0'/${index}`
                }
            ]
        },
        needsNamespace: {
            selection: 'single',
            data: [
                {
                    label: 'EVM',
                    value: 'EVM',
                    id: 'ETH',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM)
                },
                {
                    label: 'Solana',
                    value: 'Solana',
                    id: 'SOLANA',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).SOLANA)
                }
            ]
        }
    };
};
const $3b1f7dbaa6b1ccfe$export$107c8cc6b37a1ffa = ()=>({
        config: $3b1f7dbaa6b1ccfe$export$e506a1d27d1eaa20,
        getInstance: $3b1f7dbaa6b1ccfe$export$8bedcca5bbd73999,
        connect: $3b1f7dbaa6b1ccfe$export$64605811ab45167f,
        getSigners: $3b1f7dbaa6b1ccfe$export$6352a17a50193ded,
        getWalletInfo: $3b1f7dbaa6b1ccfe$export$e5b9d96c6aeb3ff7
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


var $3ca9q = parcelRequire("3ca9q");
parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");



const $d99795c3f306f848$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action(async function(_context, _chain, options) {
    if (!options?.derivationPath) throw new Error('Derivation Path can not be empty.');
    (0, $a0be4e76406c4732$export$7700d582a5b9e8d0)(options.derivationPath);
    const result = await (0, $4ceb4776397f30f0$export$d5de980bfde9e56b)();
    const formatAccounts = result.accounts.map((account)=>(0, $3ca9q).AccountId.format({
            address: account,
            chainId: {
                namespace: (0, $795b2611c2574d92$export$c67e5a7ce034264a),
                reference: result.chainId
            }
        }));
    return {
        accounts: formatAccounts,
        network: result.chainId
    };
}).or((0, $4ceb4776397f30f0$export$293a71a421d178e1)).build();
const $d99795c3f306f848$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $d99795c3f306f848$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action(()=>(0, $9cRHO.ETHEREUM_CHAIN_ID)).build();
const $d99795c3f306f848$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $3f84ff410e44abba$export$7c460c214963f696)).action($d99795c3f306f848$var$connect).action($d99795c3f306f848$var$disconnect).action($d99795c3f306f848$var$getChainId).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


var $3ca9q = parcelRequire("3ca9q");



const $4b964c999546bc4d$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action(async function(_context, options) {
    if (!options?.derivationPath) throw new Error('Derivation Path can not be empty.');
    (0, $a0be4e76406c4732$export$7700d582a5b9e8d0)(options.derivationPath);
    const result = await (0, $4ceb4776397f30f0$export$a009f0f0c363aa6c)();
    const formatAccounts = result.accounts.map((account)=>(0, $3ca9q).AccountId.format({
            address: account,
            chainId: {
                namespace: (0, $3b5535826a909102$export$c67e5a7ce034264a),
                reference: result.chainId
            }
        }));
    return formatAccounts;
}).or((0, $4ceb4776397f30f0$export$293a71a421d178e1)).build();
const $4b964c999546bc4d$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $4b964c999546bc4d$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $3f84ff410e44abba$export$7c460c214963f696)).action($4b964c999546bc4d$var$connect).action($4b964c999546bc4d$var$disconnect).build();



const $afd5828e25b10037$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $3f84ff410e44abba$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $4ceb4776397f30f0$export$70fb6ebd9084576e)()) setState('installed', true);
    }).config('metadata', (0, $3f84ff410e44abba$export$dbb5e893e736e4ee)).add('solana', (0, $4b964c999546bc4d$export$ee6400bf8f8c2a0d)).add('evm', (0, $d99795c3f306f848$export$2f7490c34b49803e)).build();


const $609db939f26db573$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $3b1f7dbaa6b1ccfe$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $afd5828e25b10037$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");


async function $2cc02ab0cb079b8c$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    const { DefaultSolanaSigner: DefaultSolanaSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await Promise.resolve((parcelRequire("6Zvtg"))));
    if (!!ethProvider) signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    if (!!solProvider) signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new DefaultSolanaSigner(solProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $30f00226f377b7c1$export$a696bbed8f4d981d() {
    const { solana: solana, ethereum: ethereum } = window;
    const instances = new Map();
    if (ethereum && ethereum.isMathWallet) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, ethereum);
    if (solana && solana.isMathWallet) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, solana);
    if (instances.size === 0) return null;
    return instances;
}
function $30f00226f377b7c1$export$62115b9164fa6f77() {
    const instances = $30f00226f377b7c1$export$a696bbed8f4d981d();
    if (!instances) throw new Error('Math Wallet is not injected. Please check your wallet.');
    return instances;
}
function $30f00226f377b7c1$export$55ed3f74302d7ed0() {
    const instances = $30f00226f377b7c1$export$a696bbed8f4d981d();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Math Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $30f00226f377b7c1$export$b01a34d66bac3f83() {
    const instance = $30f00226f377b7c1$export$a696bbed8f4d981d();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Math Wallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}


const $9abb2bd22b622013$export$7c460c214963f696 = 'math';
const $9abb2bd22b622013$export$69aeee0c48e63d0e = 1000;
const $9abb2bd22b622013$export$dbb5e893e736e4ee = {
    name: 'Math Wallet',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/math/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc',
        brave: 'https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc',
        homepage: 'https://mathwallet.org/en-us/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'single',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $2cc02ab0cb079b8c$export$2e2bcd8739ae039)((0, $30f00226f377b7c1$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const $ba9a058883161f81$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $30f00226f377b7c1$export$55ed3f74302d7ed0))).or((0, $f59Be.standardizeAndThrowError)).build();
const $ba9a058883161f81$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $30f00226f377b7c1$export$55ed3f74302d7ed0))).build();
const $ba9a058883161f81$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $ba9a058883161f81$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork()// Math wallet doesn't support switch network.
.action(()=>false).build();
const $ba9a058883161f81$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $30f00226f377b7c1$export$55ed3f74302d7ed0))).build();
const $ba9a058883161f81$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $9abb2bd22b622013$export$7c460c214963f696)).action($ba9a058883161f81$var$connect).action($ba9a058883161f81$var$disconnect).action($ba9a058883161f81$var$canSwitchNetwork).action($ba9a058883161f81$var$canEagerConnect).action($ba9a058883161f81$var$getChainId).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const $ce6e331411a78f73$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $3b5535826a909102$export$e324594224ef24da).connect((0, $30f00226f377b7c1$export$b01a34d66bac3f83))).or((0, $f59Be.standardizeAndThrowError)).build();
const $ce6e331411a78f73$var$disconnect = (0, $f59Be.builders).disconnect().build();
const $ce6e331411a78f73$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $9abb2bd22b622013$export$7c460c214963f696)).action($ce6e331411a78f73$var$connect).action($ce6e331411a78f73$var$disconnect).build();



const $90ca74756afb2d56$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $9abb2bd22b622013$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $30f00226f377b7c1$export$a696bbed8f4d981d)()) {
                setState('installed', true);
                console.debug('[math-wallet] instance detected.', context);
            }
        }, (0, $9abb2bd22b622013$export$69aeee0c48e63d0e));
    }).config('metadata', (0, $9abb2bd22b622013$export$dbb5e893e736e4ee)).add('solana', (0, $ce6e331411a78f73$export$ee6400bf8f8c2a0d)).add('evm', (0, $ba9a058883161f81$export$2f7490c34b49803e)).build();


const $242f3355b3097f8e$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $90ca74756afb2d56$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $4tkSS = parcelRequire("4tkSS");

var $hZS7n = parcelRequire("hZS7n");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");
async function $120b012c043581bf$var$executeSolanaTransaction(tx, solanaProvider) {
    const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
        const [currentAccount] = solanaProvider.accounts;
        if (!currentAccount.publicKey) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, 'Please make sure the required account is connected properly.');
        if (tx.from !== currentAccount.address) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, `Your connected account doesn't match with the required account. Please ensure that you are connected with the correct account and try again.`);
        try {
            const [signOutput] = await solanaProvider.features['solana:signTransaction'].signTransaction({
                account: currentAccount,
                transaction: solanaWeb3Transaction.serialize()
            });
            return signOutput.signedTransaction;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            const REJECTION_CODE = 4001;
            if (e && Object.hasOwn(e, 'code') && e.code === REJECTION_CODE) throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).REJECTED_BY_USER, undefined, e);
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, e);
        }
    };
    return await (0, $4tkSS.generalSolanaTransactionExecutor)(tx, DefaultSolanaSigner);
}
class $120b012c043581bf$export$7c99ab141dd0b498 {
    constructor(provider){
        this._provider = provider;
    }
    get provider() {
        return this._provider;
    }
    async signMessage(msg) {
        try {
            const encodedMessage = new TextEncoder().encode(msg);
            const [account] = this.provider.accounts;
            const [signOutput] = await this._provider.features['solana:signMessage'].signMessage({
                message: encodedMessage,
                account: account
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(signOutput.signature);
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        const hash = await $120b012c043581bf$var$executeSolanaTransaction(tx, this._provider);
        return {
            hash: hash
        };
    }
}



async function $83d7dc7223dc148d$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solanaProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $120b012c043581bf$export$7c99ab141dd0b498)(solanaProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
var $35a775a5f76d24f4$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $35a775a5f76d24f4$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $35a775a5f76d24f4$var$_AppReadyEvent_detail;
let $35a775a5f76d24f4$var$wallets = undefined;
const $35a775a5f76d24f4$var$registeredWalletsSet = new Set();
function $35a775a5f76d24f4$var$addRegisteredWallet(wallet) {
    $35a775a5f76d24f4$var$cachedWalletsArray = undefined;
    $35a775a5f76d24f4$var$registeredWalletsSet.add(wallet);
}
function $35a775a5f76d24f4$var$removeRegisteredWallet(wallet) {
    $35a775a5f76d24f4$var$cachedWalletsArray = undefined;
    $35a775a5f76d24f4$var$registeredWalletsSet.delete(wallet);
}
const $35a775a5f76d24f4$var$listeners = {};
function $35a775a5f76d24f4$export$ac4d188b6eef3eb7() {
    if ($35a775a5f76d24f4$var$wallets) return $35a775a5f76d24f4$var$wallets;
    $35a775a5f76d24f4$var$wallets = Object.freeze({
        register: $35a775a5f76d24f4$var$register,
        get: $35a775a5f76d24f4$var$get,
        on: $35a775a5f76d24f4$var$on
    });
    if (typeof window === 'undefined') return $35a775a5f76d24f4$var$wallets;
    const api = Object.freeze({
        register: $35a775a5f76d24f4$var$register
    });
    try {
        window.addEventListener('wallet-standard:register-wallet', ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error('wallet-standard:register-wallet event listener could not be added\n', error);
    }
    try {
        window.dispatchEvent(new $35a775a5f76d24f4$var$AppReadyEvent(api));
    } catch (error) {
        console.error('wallet-standard:app-ready event could not be dispatched\n', error);
    }
    return $35a775a5f76d24f4$var$wallets;
}
function $35a775a5f76d24f4$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$35a775a5f76d24f4$var$registeredWalletsSet.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$35a775a5f76d24f4$var$addRegisteredWallet(wallet));
    $35a775a5f76d24f4$var$listeners['register']?.forEach((listener)=>$35a775a5f76d24f4$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$35a775a5f76d24f4$var$removeRegisteredWallet(wallet));
        $35a775a5f76d24f4$var$listeners['unregister']?.forEach((listener)=>$35a775a5f76d24f4$var$guard(()=>listener(...wallets)));
    };
}
let $35a775a5f76d24f4$var$cachedWalletsArray;
function $35a775a5f76d24f4$var$get() {
    if (!$35a775a5f76d24f4$var$cachedWalletsArray) $35a775a5f76d24f4$var$cachedWalletsArray = [
        ...$35a775a5f76d24f4$var$registeredWalletsSet
    ];
    return $35a775a5f76d24f4$var$cachedWalletsArray;
}
function $35a775a5f76d24f4$var$on(event, listener) {
    $35a775a5f76d24f4$var$listeners[event]?.push(listener) || ($35a775a5f76d24f4$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $35a775a5f76d24f4$var$listeners[event] = $35a775a5f76d24f4$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $35a775a5f76d24f4$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $35a775a5f76d24f4$var$AppReadyEvent extends Event {
    get detail() {
        return $35a775a5f76d24f4$var$__classPrivateFieldGet(this, $35a775a5f76d24f4$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return 'wallet-standard:app-ready';
    }
    constructor(api){
        super('wallet-standard:app-ready', {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $35a775a5f76d24f4$var$_AppReadyEvent_detail.set(this, void 0);
        $35a775a5f76d24f4$var$__classPrivateFieldSet(this, $35a775a5f76d24f4$var$_AppReadyEvent_detail, api, "f");
    }
    /** @deprecated */ preventDefault() {
        throw new Error('preventDefault cannot be called');
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error('stopImmediatePropagation cannot be called');
    }
    /** @deprecated */ stopPropagation() {
        throw new Error('stopPropagation cannot be called');
    }
}
$35a775a5f76d24f4$var$_AppReadyEvent_detail = new WeakMap();
function $35a775a5f76d24f4$export$2194deb72a59836d() {
    if ($35a775a5f76d24f4$var$wallets) return $35a775a5f76d24f4$var$wallets;
    $35a775a5f76d24f4$var$wallets = $35a775a5f76d24f4$export$ac4d188b6eef3eb7();
    if (typeof window === 'undefined') return $35a775a5f76d24f4$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error('window.navigator.wallets is not an array');
        return $35a775a5f76d24f4$var$wallets;
    }
    const { register: register } = $35a775a5f76d24f4$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$35a775a5f76d24f4$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, 'wallets', {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error('window.navigator.wallets could not be set');
        return $35a775a5f76d24f4$var$wallets;
    }
    push(...callbacks);
    return $35a775a5f76d24f4$var$wallets;
}


parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");


const $56fcb437c4a857a0$export$7c460c214963f696 = 'metamask';
const $56fcb437c4a857a0$export$33c1f06a8bc4ab0f = 'MetaMask';
const $56fcb437c4a857a0$export$5a8a5f6e0e7e5610 = 'solana:mainnet';
const $56fcb437c4a857a0$export$dbb5e893e736e4ee = {
    name: 'MetaMask',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/metamask/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en',
        brave: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask',
        edge: 'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US',
        homepage: 'https://metamask.io/download/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $83d7dc7223dc148d$export$2e2bcd8739ae039)((0, $6ef0608bd9a95911$export$62115b9164fa6f77)())
            }
        }
    ]
};


function $6ef0608bd9a95911$export$35acf79c20989cf0() {
    const { ethereum: ethereum } = window;
    const solana = $6ef0608bd9a95911$var$getSolanaWalletInstance();
    if (!ethereum || !$6ef0608bd9a95911$var$isEthereumMetamaskProvider(ethereum)) return null;
    const instances = new Map();
    if (ethereum) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, ethereum);
    if (solana) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, solana);
    return instances;
}
function $6ef0608bd9a95911$var$isEthereumMetamaskProvider(ethereum) {
    if (!ethereum?.isMetaMask) return false;
    /*
   * Brave tries to make itself look like MetaMask
   * Could also try RPC `web3_clientVersion` if following is unreliable
   */ if (ethereum.isBraveWallet && !ethereum._events && !ethereum._state) return false;
    if (ethereum.isApexWallet) return false;
    if (ethereum.isAvalanche) return false;
    if (ethereum.isBitKeep) return false;
    if (ethereum.isBlockWallet) return false;
    if (ethereum.isCoin98) return false;
    if (ethereum.isFordefi) return false;
    if (ethereum.__XDEFI) return false;
    if (ethereum.isMathWallet) return false;
    if (ethereum.isOkxWallet || ethereum.isOKExWallet) return false;
    if (ethereum.isOneInchIOSWallet || ethereum.isOneInchAndroidWallet) return false;
    if (ethereum.isOpera) return false;
    if (ethereum.isPortal) return false;
    if (ethereum.isRabby) return false;
    if (ethereum.isDefiant) return false;
    if (ethereum.isTokenPocket) return false;
    if (ethereum.isTokenary) return false;
    if (ethereum.isZeal) return false;
    if (ethereum.isZerion) return false;
    if (ethereum.isSafePal) return false;
    return true;
}
function $6ef0608bd9a95911$export$4dbe14e07b635205() {
    const instances = $6ef0608bd9a95911$export$35acf79c20989cf0();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Metamask not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $6ef0608bd9a95911$export$d834d0a4b6d76a73() {
    const instances = $6ef0608bd9a95911$export$35acf79c20989cf0();
    const solanaInstance = instances?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Metamask Solana instance is not available. Ensure that Solana support is enabled in your wallet.');
    return solanaInstance;
}
function $6ef0608bd9a95911$export$62115b9164fa6f77() {
    const instances = $6ef0608bd9a95911$export$35acf79c20989cf0();
    if (!instances) throw new Error('MetaMask is not injected. Please check your wallet.');
    return instances;
}
function $6ef0608bd9a95911$var$getSolanaWalletInstance() {
    return (0, $35a775a5f76d24f4$export$ac4d188b6eef3eb7)().get().find((wallet)=>wallet.name === (0, $56fcb437c4a857a0$export$33c1f06a8bc4ab0f) && wallet.chains.includes((0, $56fcb437c4a857a0$export$5a8a5f6e0e7e5610)));
}


const $eb8bbbef2c38800f$var$WALLET = (0, $9cRHO.WalletTypes).META_MASK;
const $eb8bbbef2c38800f$export$e506a1d27d1eaa20 = {
    type: $eb8bbbef2c38800f$var$WALLET
};
const $eb8bbbef2c38800f$export$8bedcca5bbd73999 = (0, $6ef0608bd9a95911$export$35acf79c20989cf0);
const $eb8bbbef2c38800f$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $gSYt0.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $eb8bbbef2c38800f$export$ec068583843480e7 = (0, $gSYt0.subscribeToEvm);
const $eb8bbbef2c38800f$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $eb8bbbef2c38800f$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $eb8bbbef2c38800f$export$6352a17a50193ded = (0, $83d7dc7223dc148d$export$2e2bcd8739ae039);
const $eb8bbbef2c38800f$export$be9f3c5ed1d25e42 = (0, $gSYt0.canEagerlyConnectToEvm);
const $eb8bbbef2c38800f$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    return {
        name: 'MetaMask',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/metamask/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en',
            BRAVE: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en',
            FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask',
            EDGE: 'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US',
            DEFAULT: 'https://metamask.io/download/'
        },
        color: '#dac7ae',
        supportedChains: evms
    };
};
const $eb8bbbef2c38800f$export$107c8cc6b37a1ffa = ()=>({
        config: $eb8bbbef2c38800f$export$e506a1d27d1eaa20,
        getInstance: $eb8bbbef2c38800f$export$8bedcca5bbd73999,
        connect: $eb8bbbef2c38800f$export$64605811ab45167f,
        subscribe: $eb8bbbef2c38800f$export$ec068583843480e7,
        getSigners: $eb8bbbef2c38800f$export$6352a17a50193ded,
        getWalletInfo: $eb8bbbef2c38800f$export$e5b9d96c6aeb3ff7,
        canSwitchNetworkTo: $eb8bbbef2c38800f$export$3b3cf9ab9019de20,
        canEagerConnect: $eb8bbbef2c38800f$export$be9f3c5ed1d25e42
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$e07cdb9dd5f8c0ce$var$changeAccountSubscriber, $e07cdb9dd5f8c0ce$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $6ef0608bd9a95911$export$4dbe14e07b635205))/*
   * Metamask returns an array of connected accounts with the active one first.
   * Since we only need the active account, we take the first element as a workaround.
   */ .format(async (instance, accounts)=>{
    const chainId = await instance.request({
        method: 'eth_chainId'
    });
    return (0, $795b2611c2574d92$export$eab97d15b1788b8d).formatAccountsToCAIP([
        accounts[0]
    ], chainId);
}).build();
const $e07cdb9dd5f8c0ce$var$connect = new (0, $fha7R.ActionBuilder)('connect').action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $6ef0608bd9a95911$export$4dbe14e07b635205)))/*
   * Metamask Wallet's `connect` returns a list where the currently selected account
   * is always the first item. We're directly taking this first item as the active account.
   *
   * ***NOTE***: Please keep it synced with `wallets/core/src/namespaces/solana/builders.ts`.
   *
   */ .and((_, connectResult)=>({
        ...connectResult,
        accounts: [
            connectResult.accounts[0]
        ]
    })).and((0, $f59Be.connectAndUpdateStateForMultiNetworks)).before((0, $f59Be.intoConnecting)).before($e07cdb9dd5f8c0ce$var$changeAccountSubscriber).or($e07cdb9dd5f8c0ce$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).after((0, $f59Be.intoConnectionFinished)).build();
const $e07cdb9dd5f8c0ce$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $6ef0608bd9a95911$export$4dbe14e07b635205))).build();
const $e07cdb9dd5f8c0ce$var$disconnect = (0, $f59Be.builders).disconnect().after($e07cdb9dd5f8c0ce$var$changeAccountCleanup).build();
const $e07cdb9dd5f8c0ce$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $e07cdb9dd5f8c0ce$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $6ef0608bd9a95911$export$4dbe14e07b635205))).build();
const $e07cdb9dd5f8c0ce$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $56fcb437c4a857a0$export$7c460c214963f696)).action($e07cdb9dd5f8c0ce$var$connect).action($e07cdb9dd5f8c0ce$var$disconnect).action($e07cdb9dd5f8c0ce$var$canSwitchNetwork).action($e07cdb9dd5f8c0ce$var$canEagerConnect).action($e07cdb9dd5f8c0ce$var$getChainId).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


function $3d4a906ec0c2985a$var$connect(getInstance) {
    return async ()=>{
        const solanaInstance = getInstance();
        const connectResult = await solanaInstance.features['standard:connect'].connect();
        return (0, $3b5535826a909102$export$eab97d15b1788b8d).formatAccountsToCAIP(connectResult.accounts.map((account)=>account.address));
    };
}
function $3d4a906ec0c2985a$var$canEagerConnect(getInstance) {
    return async ()=>{
        const solanaInstance = getInstance();
        if (!solanaInstance) throw new Error('Trying to eagerly connect to your Solana wallet, but it seems that its instance is not available.');
        try {
            const result = await solanaInstance.features['standard:connect'].connect({
                silent: true
            });
            return !!result.accounts.length;
        } catch  {
            return false;
        }
    };
}
const $3d4a906ec0c2985a$export$43912867441655c2 = {
    connect: $3d4a906ec0c2985a$var$connect,
    canEagerConnect: $3d4a906ec0c2985a$var$canEagerConnect
};



var $f59Be = parcelRequire("f59Be");

// Hooks
const $3e110ad415922f04$var$changeAccountSubscriber = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event, context)=>{
        if (!event.payload.accounts?.length) {
            context.action('disconnect');
            event.preventDefault();
        }
    }).format(async (_, event)=>(0, $3b5535826a909102$export$eab97d15b1788b8d).formatAccountsToCAIP(event.accounts.map((account)=>account.address))).addEventListener((instance, callback)=>{
        instance.features['standard:events'].on('change', callback);
    }).removeEventListener((_, __)=>{});
const $3e110ad415922f04$export$a351778fe7878f00 = {
    changeAccountSubscriber: $3e110ad415922f04$var$changeAccountSubscriber
};




const [$ec7c9fe105701647$var$changeAccountSubscriber, $ec7c9fe105701647$var$changeAccountCleanup] = (0, $3e110ad415922f04$export$a351778fe7878f00).changeAccountSubscriber((0, $6ef0608bd9a95911$export$d834d0a4b6d76a73)).build();
const $ec7c9fe105701647$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $3d4a906ec0c2985a$export$43912867441655c2).connect((0, $6ef0608bd9a95911$export$d834d0a4b6d76a73))).before($ec7c9fe105701647$var$changeAccountSubscriber).or($ec7c9fe105701647$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $ec7c9fe105701647$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $3d4a906ec0c2985a$export$43912867441655c2).canEagerConnect((0, $6ef0608bd9a95911$export$d834d0a4b6d76a73))).build();
const $ec7c9fe105701647$var$disconnect = (0, $f59Be.builders).disconnect().after($ec7c9fe105701647$var$changeAccountCleanup).build();
const $ec7c9fe105701647$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $56fcb437c4a857a0$export$7c460c214963f696)).action($ec7c9fe105701647$var$connect).action($ec7c9fe105701647$var$disconnect).action($ec7c9fe105701647$var$canEagerConnect).build();



const $61bbd94eb0268038$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $56fcb437c4a857a0$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $6ef0608bd9a95911$export$35acf79c20989cf0)()) {
            setState('installed', true);
            console.debug('[metamask] instance detected.', context);
        }
    }).config('metadata', (0, $56fcb437c4a857a0$export$dbb5e893e736e4ee)).add('evm', (0, $e07cdb9dd5f8c0ce$export$2f7490c34b49803e)).add('solana', (0, $ec7c9fe105701647$export$ee6400bf8f8c2a0d)).build();


const $e24e68e14f9e5c99$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $eb8bbbef2c38800f$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $61bbd94eb0268038$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $fIwj6 = parcelRequire("fIwj6");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $13wKd = parcelRequire("13wKd");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");
class $f035fbfe5a34ec84$export$696d31f5b31a7de8 extends (0, $13wKd.DefaultSolanaSigner) {
    constructor(provider){
        super(provider);
    }
    async signMessage(msg) {
        try {
            const { signature: signature } = await this.provider.request({
                method: 'signMessage',
                params: {
                    message: msg
                }
            });
            return signature;
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
}


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

var $ihoyg = parcelRequire("ihoyg");
var $c52fabb01ec4667e$require$Buffer = $ihoyg.Buffer;
class $c52fabb01ec4667e$export$f422968faa76f8e1 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $9gKM3.SignerError).UnimplementedError('signMessage');
    }
    async signAndSendTx(tx) {
        const { asset: asset, psbt: psbt } = tx;
        if (!psbt) throw new Error('No PSBT found to sign. Ensure a valid PSBT is provided.');
        if (asset.blockchain !== (0, $9HEDW.LegacyNetworks).BTC) throw new Error(`Signing ${asset.blockchain} transaction is not implemented by the signer.`);
        // 1. Decode Base64 to hex
        const psbtHex = $c52fabb01ec4667e$require$Buffer.from(psbt.unsignedPsbtBase64, 'base64').toString('hex');
        // 2. Build UniSat inputs
        const toSignInputs = psbt.inputsToSign.flatMap(({ address: address, signingIndexes: signingIndexes })=>signingIndexes.map((index)=>({
                    index: index,
                    address: address
                })));
        try {
            // 3. Sign (& auto-finalize)
            const signedPsbtHex = await this.provider.signPsbt(psbtHex, {
                autoFinalized: true,
                toSignInputs: toSignInputs
            });
            // 4. Push signed psbt
            const transactionHash = await this.provider.pushPsbt(signedPsbtHex);
            return {
                hash: transactionHash
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            throw new Error(error?.message || 'Error during signing transaction');
        }
    }
}



async function $0daba56d637c29e3$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const utxoProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).BTC);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $f035fbfe5a34ec84$export$696d31f5b31a7de8)(solProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new (0, $c52fabb01ec4667e$export$f422968faa76f8e1)(utxoProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $c7b2bd35d763472a$export$1eaef715b733fff4() {
    const { okxwallet: okxwallet } = window;
    if (!okxwallet) return null;
    const instances = new Map();
    if (okxwallet) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, okxwallet);
    if (okxwallet.solana) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, okxwallet.solana);
    if (okxwallet.bitcoin) instances.set((0, $9HEDW.LegacyNetworks).BTC, okxwallet.bitcoin);
    return instances;
}
function $c7b2bd35d763472a$export$62115b9164fa6f77() {
    const instances = $c7b2bd35d763472a$export$1eaef715b733fff4();
    if (!instances) throw new Error('OKX Wallet is not injected. Please check your wallet.');
    return instances;
}
function $c7b2bd35d763472a$export$a81d0078ec7632cf() {
    const instances = $c7b2bd35d763472a$export$1eaef715b733fff4();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('OKX Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $c7b2bd35d763472a$export$8c6f5cfabd785bc4() {
    const instance = $c7b2bd35d763472a$export$1eaef715b733fff4();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('OKX Wallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}
function $c7b2bd35d763472a$export$c1ec0da514a33ec9() {
    const instance = $c7b2bd35d763472a$export$1eaef715b733fff4();
    const bitcoinInstance = instance?.get((0, $9HEDW.LegacyNetworks).BTC);
    if (!bitcoinInstance) throw new Error('OKX Wallet not injected or Utxo not enabled. Please check your wallet.');
    return bitcoinInstance;
}
async function $c7b2bd35d763472a$export$990bd7c7f4a34867() {
    const instance = $c7b2bd35d763472a$export$c1ec0da514a33ec9();
    const requestResult = await instance.connect();
    if (requestResult.error?.message) throw new Error(requestResult.error.message);
    return requestResult;
}


const $e5b247b65e2b9089$export$7c460c214963f696 = 'okx';
const $e5b247b65e2b9089$export$ac6b831b3b0dc450 = [
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).BSC,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).FANTOM,
    (0, $9HEDW.LegacyNetworks).ARBITRUM,
    (0, $9HEDW.LegacyNetworks).OPTIMISM,
    (0, $9HEDW.LegacyNetworks).CRONOS,
    (0, $9HEDW.LegacyNetworks).BOBA,
    (0, $9HEDW.LegacyNetworks).GNOSIS,
    (0, $9HEDW.LegacyNetworks).MOONBEAM,
    (0, $9HEDW.LegacyNetworks).MOONRIVER,
    (0, $9HEDW.LegacyNetworks).HARMONY,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN
];
const $e5b247b65e2b9089$export$dbb5e893e736e4ee = {
    name: 'OKX',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/okx/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge',
        brave: 'https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/okexwallet',
        homepage: 'https://www.okx.com/web3'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((blockchainMeta)=>$e5b247b65e2b9089$export$ac6b831b3b0dc450.includes(blockchainMeta.name))
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    },
                    {
                        label: 'BTC',
                        value: 'UTXO',
                        id: 'BTC',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $0daba56d637c29e3$export$2e2bcd8739ae039)((0, $c7b2bd35d763472a$export$62115b9164fa6f77)())
            }
        }
    ]
};




const $3b3e390e60097a2a$var$WALLET = (0, $9cRHO.WalletTypes).OKX;
const $3b3e390e60097a2a$export$e506a1d27d1eaa20 = {
    type: $3b3e390e60097a2a$var$WALLET,
    defaultNetwork: (0, $9HEDW.LegacyNetworks).ETHEREUM
};
const $3b3e390e60097a2a$export$8bedcca5bbd73999 = (0, $c7b2bd35d763472a$export$1eaef715b733fff4);
const $3b3e390e60097a2a$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const results = [];
    const evmInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (evmInstance) {
        const evmResults = await (0, $gSYt0.getEvmAccounts)(evmInstance);
        results.push(evmResults);
    }
    const solanaResults = await (0, $fIwj6.getSolanaAccounts)(instance);
    results.push(...Array.isArray(solanaResults) ? solanaResults : [
        solanaResults
    ]);
    return results;
};
const $3b3e390e60097a2a$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, meta: meta })=>{
    const ethInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const handleEvmAccountsChanged = async (addresses)=>{
        const eth_chainId = meta.filter((0, $hE77Y.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM)?.chainId;
        updateAccounts(addresses, eth_chainId);
        const solanaResults = await (0, $fIwj6.getSolanaAccounts)(instance);
        const resultsArray = Array.isArray(solanaResults) ? solanaResults : [
            solanaResults
        ];
        resultsArray.forEach(({ chainId: chainId, accounts: accounts })=>{
            updateAccounts(accounts, chainId);
        });
    };
    ethInstance?.on?.('accountsChanged', handleEvmAccountsChanged);
    return ()=>{
        ethInstance?.off?.('accountsChanged', handleEvmAccountsChanged);
    };
};
const $3b3e390e60097a2a$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $gSYt0.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $3b3e390e60097a2a$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $3b3e390e60097a2a$export$6352a17a50193ded = (0, $0daba56d637c29e3$export$2e2bcd8739ae039);
const $3b3e390e60097a2a$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $gSYt0.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $3b3e390e60097a2a$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>({
        name: 'OKX',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/okx/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge',
            BRAVE: 'https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge',
            FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/okexwallet',
            DEFAULT: 'https://www.okx.com/web3'
        },
        color: 'white',
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $e5b247b65e2b9089$export$ac6b831b3b0dc450).includes(blockchainMeta.name))
    });
const $3b3e390e60097a2a$export$107c8cc6b37a1ffa = ()=>({
        config: $3b3e390e60097a2a$export$e506a1d27d1eaa20,
        getInstance: $3b3e390e60097a2a$export$8bedcca5bbd73999,
        connect: $3b3e390e60097a2a$export$64605811ab45167f,
        subscribe: $3b3e390e60097a2a$export$ec068583843480e7,
        switchNetwork: $3b3e390e60097a2a$export$f3473d805e486329,
        canSwitchNetworkTo: $3b3e390e60097a2a$export$3b3cf9ab9019de20,
        getSigners: $3b3e390e60097a2a$export$6352a17a50193ded,
        getWalletInfo: $3b3e390e60097a2a$export$e5b9d96c6aeb3ff7,
        canEagerConnect: $3b3e390e60097a2a$export$be9f3c5ed1d25e42
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$c326b627a44636d3$var$changeAccountSubscriber, $c326b627a44636d3$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $c7b2bd35d763472a$export$a81d0078ec7632cf))/*
   * Okx wallet may call the `changeAccount` event with `null` value
   * but we shouldn't disconnect in this case.
   */ .onSwitchAccount((event)=>{
    if (!event.payload.length) event.preventDefault();
}).format(async (instance, event)=>{
    const chainId = await instance.request({
        method: 'eth_chainId'
    });
    // The wallet may emit a `null` value in its `sent` event.
    return (0, $795b2611c2574d92$export$eab97d15b1788b8d).formatAccountsToCAIP(event.filter(Boolean), chainId);
}).build();
const $c326b627a44636d3$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $c7b2bd35d763472a$export$a81d0078ec7632cf))).before($c326b627a44636d3$var$changeAccountSubscriber).or($c326b627a44636d3$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $c326b627a44636d3$var$disconnect = (0, $f59Be.builders).disconnect().before(()=>{
    (0, $c7b2bd35d763472a$export$a81d0078ec7632cf)().disconnect();
}).after($c326b627a44636d3$var$changeAccountCleanup).build();
const $c326b627a44636d3$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $c326b627a44636d3$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $c7b2bd35d763472a$export$a81d0078ec7632cf))).build();
const $c326b627a44636d3$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $c7b2bd35d763472a$export$a81d0078ec7632cf))).build();
const $c326b627a44636d3$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $e5b247b65e2b9089$export$7c460c214963f696)).action($c326b627a44636d3$var$connect).action($c326b627a44636d3$var$disconnect).action($c326b627a44636d3$var$canEagerConnect).action($c326b627a44636d3$var$canSwitchNetwork).action($c326b627a44636d3$var$getChainId).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$8d8e5b5e2f86fd6f$var$changeAccountSubscriber, $8d8e5b5e2f86fd6f$var$changeAccountCleanup] = (0, $3b5535826a909102$export$aea8daed5328d69c).changeAccountSubscriber((0, $c7b2bd35d763472a$export$8c6f5cfabd785bc4))/*
   * Okx wallet may call the `changeAccount` event with `null` value
   * but we shouldn't disconnect in this case.
   */ .onSwitchAccount((event)=>{
    if (!event.payload) event.preventDefault();
}).format(async (_, event)=>{
    // The wallet may emit a `null` value in its `sent` event.
    return (0, $3b5535826a909102$export$eab97d15b1788b8d).formatAccountsToCAIP(event ? [
        event
    ] : []);
}).build();
const $8d8e5b5e2f86fd6f$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $3b5535826a909102$export$e324594224ef24da).connect((0, $c7b2bd35d763472a$export$8c6f5cfabd785bc4))).before($8d8e5b5e2f86fd6f$var$changeAccountSubscriber).or($8d8e5b5e2f86fd6f$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $8d8e5b5e2f86fd6f$var$disconnect = (0, $f59Be.builders).disconnect().before(()=>{
    (0, $c7b2bd35d763472a$export$8c6f5cfabd785bc4)().disconnect();
}).after($8d8e5b5e2f86fd6f$var$changeAccountCleanup).build();
const $8d8e5b5e2f86fd6f$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $3b5535826a909102$export$e324594224ef24da).canEagerConnect((0, $c7b2bd35d763472a$export$8c6f5cfabd785bc4))).build();
const $8d8e5b5e2f86fd6f$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $e5b247b65e2b9089$export$7c460c214963f696)).action($8d8e5b5e2f86fd6f$var$connect).action($8d8e5b5e2f86fd6f$var$disconnect).action($8d8e5b5e2f86fd6f$var$canEagerConnect).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");
parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");
const $28e9644633ccf500$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance)/*
     * Okx wallet may call the `changeAccount` event with `null` value
     * but we shouldn't disconnect in this case.
     */ .onSwitchAccount((event)=>{
        if (!event.payload?.address) event.preventDefault();
    }).format(async (_, event)=>{
        return (0, $er2za.utils).formatAccountsToCAIP(event ? [
            event.address
        ] : [], (0, $er2za.CAIP_BITCOIN_CHAIN_ID));
    }).addEventListener((instance, callback)=>{
        return instance.addListener('accountChanged', callback);
    }).removeEventListener((instance, callback)=>{
        return instance.removeListener('accountChanged', callback);
    });
function $28e9644633ccf500$var$canEagerConnect(getInstance) {
    return new (0, $fha7R.ActionBuilder)('canEagerConnect').action(async ()=>{
        const instance = getInstance();
        try {
            const accounts = await instance.getAccounts();
            return !!accounts.length;
        } catch  {
            return false;
        }
    });
}
const $28e9644633ccf500$export$4ec68a7e2bb108ab = {
    changeAccountSubscriber: $28e9644633ccf500$export$bc681aebb548377e,
    canEagerConnect: $28e9644633ccf500$var$canEagerConnect
};




const [$bb7e214e9687eae8$var$changeAccountSubscriber, $bb7e214e9687eae8$var$changeAccountCleanup] = (0, $28e9644633ccf500$export$4ec68a7e2bb108ab).changeAccountSubscriber((0, $c7b2bd35d763472a$export$c1ec0da514a33ec9)).build();
const $bb7e214e9687eae8$var$canEagerConnect = (0, $28e9644633ccf500$export$4ec68a7e2bb108ab).canEagerConnect((0, $c7b2bd35d763472a$export$c1ec0da514a33ec9)).build();
const $bb7e214e9687eae8$var$connect = (0, $er2za.builders).connect().action(async function() {
    const accountsResult = await (0, $c7b2bd35d763472a$export$990bd7c7f4a34867)();
    if (!accountsResult?.address) throw new Error("Couldn't find any address!");
    return (0, $er2za.utils).formatAccountsToCAIP([
        accountsResult.address
    ], (0, $er2za.CAIP_BITCOIN_CHAIN_ID));
}).before($bb7e214e9687eae8$var$changeAccountSubscriber).or($bb7e214e9687eae8$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $bb7e214e9687eae8$var$disconnect = (0, $f59Be.builders).disconnect().before(()=>{
    (0, $c7b2bd35d763472a$export$c1ec0da514a33ec9)().disconnect();
}).after($bb7e214e9687eae8$var$changeAccountCleanup).build();
const $bb7e214e9687eae8$export$85601e73083fc493 = new (0, $at2GJ.NamespaceBuilder)('UTXO', (0, $e5b247b65e2b9089$export$7c460c214963f696)).action($bb7e214e9687eae8$var$connect).action($bb7e214e9687eae8$var$disconnect).action($bb7e214e9687eae8$var$canEagerConnect).build();



const $947cc5430289ae40$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $e5b247b65e2b9089$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $c7b2bd35d763472a$export$1eaef715b733fff4)()) {
            setState('installed', true);
            console.debug('[okx] instance detected.', context);
        }
    }).config('metadata', (0, $e5b247b65e2b9089$export$dbb5e893e736e4ee)).add('solana', (0, $8d8e5b5e2f86fd6f$export$ee6400bf8f8c2a0d)).add('evm', (0, $c326b627a44636d3$export$2f7490c34b49803e)).add('utxo', (0, $bb7e214e9687eae8$export$85601e73083fc493)).build();


const $bafc65d919b03fba$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $3b3e390e60097a2a$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $947cc5430289ae40$export$afa934a86232cabe)()).build();




var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $fIwj6 = parcelRequire("fIwj6");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
var $9B1kL = parcelRequire("9B1kL");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
var $9B1kL = parcelRequire("9B1kL");

var $9HEDW = parcelRequire("9HEDW");



var $3ca9q = parcelRequire("3ca9q");

var $5lj4U = parcelRequire("5lj4U");
var $2ee4b5c7f608ffed$var$I = Object.defineProperty;
var $2ee4b5c7f608ffed$var$t = (r, e)=>$2ee4b5c7f608ffed$var$I(r, "name", {
        value: e,
        configurable: !0
    });
var $2ee4b5c7f608ffed$var$y = (r, e)=>{
    for(var n in e)$2ee4b5c7f608ffed$var$I(r, n, {
        get: e[n],
        enumerable: !0
    });
};
var $2ee4b5c7f608ffed$export$e324594224ef24da = {};
$2ee4b5c7f608ffed$var$y($2ee4b5c7f608ffed$export$e324594224ef24da, {
    canEagerConnect: ()=>$2ee4b5c7f608ffed$var$D
});
function $2ee4b5c7f608ffed$var$D(r) {
    return async ()=>{
        let e = $2ee4b5c7f608ffed$export$62115b9164fa6f77(r.name);
        try {
            return !!(await e.features["standard:connect"].connect({
                silent: !0
            })).accounts.length;
        } catch  {
            return !1;
        }
    };
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$D, "canEagerConnect");
var $2ee4b5c7f608ffed$export$aea8daed5328d69c = {};
$2ee4b5c7f608ffed$var$y($2ee4b5c7f608ffed$export$aea8daed5328d69c, {
    canEagerConnect: ()=>$2ee4b5c7f608ffed$var$Q,
    changeAccountSubscriber: ()=>$2ee4b5c7f608ffed$var$Z,
    connect: ()=>$2ee4b5c7f608ffed$var$q
});
var $2ee4b5c7f608ffed$var$o = class {
    static{
        $2ee4b5c7f608ffed$var$t(this, "ActionBuilder");
    }
    name;
    #e = new Map;
    #t = new Map;
    #n = new Map;
    #r = new Map;
    #o;
    constructor(e){
        this.name = e;
    }
    and(e) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(e), this;
    }
    or(e) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(e), this;
    }
    before(e) {
        return this.#r.has(this.name) || this.#r.set(this.name, []), this.#r.get(this.name)?.push(e), this;
    }
    after(e) {
        return this.#n.has(this.name) || this.#n.set(this.name, []), this.#n.get(this.name)?.push(e), this;
    }
    action(e) {
        return this.#o = e, this;
    }
    build() {
        if (!this.#o) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#o,
            before: this.#r,
            after: this.#n,
            and: this.#e,
            or: this.#t
        };
    }
};
var $2ee4b5c7f608ffed$var$a = class {
    static{
        $2ee4b5c7f608ffed$var$t(this, "ChangeAccountSubscriberBuilder");
    }
    #e = null;
    #t = null;
    #n = null;
    #r = null;
    #o = null;
    getInstance(e) {
        return this.#e = e, this;
    }
    format(e) {
        return this.#t = e, this;
    }
    onSwitchAccount(e) {
        return this.#n = e, this;
    }
    addEventListener(e) {
        return this.#r = e, this;
    }
    removeEventListener(e) {
        return this.#o = e, this;
    }
    build() {
        if (this.#e === null) throw new Error(this.#s("getInstance"));
        if (this.#t === null) throw new Error(this.#s("format"));
        if (this.#r === null) throw new Error(this.#s("addEventListener"));
        if (this.#o === null) throw new Error(this.#s("removeEventListener"));
        let e = this.#e, n = this.#t, P = this.#r, w = this.#o, f = this.#n, l, p;
        return [
            async (h)=>{
                let [, v] = h.state(), i = e();
                if (!i) throw new Error("Trying to subscribe to your wallet, but seems its instance is not available.");
                l = $2ee4b5c7f608ffed$var$t(async (E)=>{
                    let N = !0;
                    f?.({
                        payload: E,
                        preventDefault: ()=>{
                            N = !1;
                        }
                    }, h), N && v("accounts", await n(i, E));
                }, "subscriber"), p = P(i, l);
            },
            (h, v)=>{
                p && typeof p == "function" && p();
                let i = e();
                return w(i, l), v;
            }
        ];
    }
    #s(e) {
        return `Required "${e}" operation has not been set for "changeAccountSubscriber"`;
    }
};
function $2ee4b5c7f608ffed$var$A(r) {
    let [, e] = r.state();
    e("connecting", !1);
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$A, "intoConnectionFinished");
function $2ee4b5c7f608ffed$var$F(r) {
    try {
        return (0, $3ca9q.AccountId).parse(r), !0;
    } catch  {
        return !1;
    }
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$F, "isValidCaipAddress");
function $2ee4b5c7f608ffed$var$b(r, e) {
    if (!e.every($2ee4b5c7f608ffed$var$F)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${e}`);
    let [, n] = r.state();
    return n("accounts", e), n("connected", !0), e;
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$b, "connectAndUpdateStateForSingleNetwork");
function $2ee4b5c7f608ffed$var$C(r) {
    let [, e] = r.state();
    e("connecting", !0);
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$C, "intoConnecting");
var $2ee4b5c7f608ffed$export$c67e5a7ce034264a = "sui", $2ee4b5c7f608ffed$export$9c41be39b09f8968 = "sui";
function $2ee4b5c7f608ffed$export$8bedcca5bbd73999(r) {
    return (0, $35a775a5f76d24f4$export$ac4d188b6eef3eb7)().get().find((n)=>n.name === r && n.chains.includes((0, $5lj4U.SUI_MAINNET_CHAIN)));
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$export$8bedcca5bbd73999, "getInstance");
function $2ee4b5c7f608ffed$export$62115b9164fa6f77(r) {
    let e = $2ee4b5c7f608ffed$export$8bedcca5bbd73999(r);
    if (!e) throw new Error("We couldn't find the Sui instance on your wallet. It may be fixed by refreshing the page.");
    return e;
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$export$62115b9164fa6f77, "getInstanceOrThrow");
function $2ee4b5c7f608ffed$var$j(r) {
    return r.map((e)=>(0, $3ca9q.AccountId).format({
            address: e.address,
            chainId: {
                namespace: $2ee4b5c7f608ffed$export$c67e5a7ce034264a,
                reference: $2ee4b5c7f608ffed$export$9c41be39b09f8968
            }
        }));
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$j, "formatAccountsToCAIP");
var $2ee4b5c7f608ffed$var$q = $2ee4b5c7f608ffed$var$t((r)=>new $2ee4b5c7f608ffed$var$o("connect").action(async function() {
        return (await $2ee4b5c7f608ffed$export$62115b9164fa6f77(r.name).features["standard:connect"].connect()).accounts.map((f)=>$3ca9q.AccountId.format({
                address: f.address,
                chainId: {
                    namespace: $2ee4b5c7f608ffed$export$c67e5a7ce034264a,
                    reference: $2ee4b5c7f608ffed$export$9c41be39b09f8968
                }
            }));
    }).and($2ee4b5c7f608ffed$var$b).before($2ee4b5c7f608ffed$var$C).after($2ee4b5c7f608ffed$var$A), "connect"), $2ee4b5c7f608ffed$var$Q = $2ee4b5c7f608ffed$var$t(()=>new $2ee4b5c7f608ffed$var$o("canEagerConnect"), "canEagerConnect"), $2ee4b5c7f608ffed$var$Z = $2ee4b5c7f608ffed$var$t((r)=>new $2ee4b5c7f608ffed$var$a().getInstance(()=>$2ee4b5c7f608ffed$export$62115b9164fa6f77(r.name)).onSwitchAccount((e, n)=>{
        e.payload.accounts?.length || (n.action("disconnect"), e.preventDefault());
    }).format(async (e, n)=>$2ee4b5c7f608ffed$var$j(n.accounts)).addEventListener((e, n)=>e.features["standard:events"].on("change", n)).removeEventListener((e, n)=>{}), "changeAccountSubscriber");
var $2ee4b5c7f608ffed$export$11949c6f5fba7dcd = {};
$2ee4b5c7f608ffed$var$y($2ee4b5c7f608ffed$export$11949c6f5fba7dcd, {
    changeAccountSubscriber: ()=>$2ee4b5c7f608ffed$var$J
});
function $2ee4b5c7f608ffed$var$J(r) {
    return $2ee4b5c7f608ffed$export$aea8daed5328d69c.changeAccountSubscriber({
        name: r.name
    }).build();
}
$2ee4b5c7f608ffed$var$t($2ee4b5c7f608ffed$var$J, "changeAccountSubscriber");


parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");





async function $432968d31153d496$export$2e2bcd8739ae039(provider) {
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const evmProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const bitcoinInstance = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).BTC);
    const suiProvider = (0, $2ee4b5c7f608ffed$export$8bedcca5bbd73999)((0, $0c414e9707a4c833$export$a54267529b947bd8));
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    const { DefaultSolanaSigner: DefaultSolanaSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await Promise.resolve((parcelRequire("6Zvtg"))));
    const { BTCSigner: BTCSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("4dXbr")));
    const { DefaultSuiSigner: DefaultSuiSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("3tfzf")));
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new DefaultSolanaSigner(solProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(evmProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new BTCSigner(bitcoinInstance));
    if (!!suiProvider) signers.registerSigner((0, $9B1kL.TransactionType).SUI, new DefaultSuiSigner(suiProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $eb284851236684b7$export$40b6ddfff396bf5b() {
    const { phantom: phantom } = window;
    if (!phantom) return null;
    const { solana: solana, ethereum: ethereum, bitcoin: bitcoin, sui: sui } = phantom;
    const instances = new Map();
    if (ethereum && ethereum.isPhantom) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, ethereum);
    if (solana && solana.isPhantom) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, solana);
    if (bitcoin && bitcoin.isPhantom) instances.set((0, $9HEDW.LegacyNetworks).BTC, bitcoin);
    if (sui && sui.isPhantom) instances.set((0, $9HEDW.LegacyNetworks).SUI, sui);
    return instances;
}
function $eb284851236684b7$export$62115b9164fa6f77() {
    const instances = $eb284851236684b7$export$40b6ddfff396bf5b();
    if (!instances) throw new Error('Phantom is not injected. Please check your wallet.');
    return instances;
}
function $eb284851236684b7$export$b8130868f114a8d5() {
    const instances = $eb284851236684b7$export$40b6ddfff396bf5b();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Phantom not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $eb284851236684b7$export$21360755953cef72() {
    const instance = $eb284851236684b7$export$40b6ddfff396bf5b();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Phantom not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}
function $eb284851236684b7$export$74ba08f8787dea92() {
    const instance = $eb284851236684b7$export$40b6ddfff396bf5b();
    const bitcoinInstance = instance?.get((0, $9HEDW.LegacyNetworks).BTC);
    if (!bitcoinInstance) throw new Error('Phantom not injected or Bitcoin not enabled. Please check your wallet.');
    return bitcoinInstance;
}
function $eb284851236684b7$export$b56cda58f1abc5aa() {
    const instance = $eb284851236684b7$export$40b6ddfff396bf5b();
    const suiInstance = instance?.get((0, $9HEDW.LegacyNetworks).SUI);
    if (!suiInstance) throw new Error('Phantom not injected or Sui not enabled. Please check your wallet.');
    return suiInstance;
}


const $0c414e9707a4c833$export$6ae6d19d2a14f956 = [
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).BASE
];
const $0c414e9707a4c833$export$7c460c214963f696 = 'phantom';
const $0c414e9707a4c833$export$a54267529b947bd8 = 'Phantom';
const $0c414e9707a4c833$export$dbb5e893e736e4ee = {
    name: 'Phantom',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/phantom/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa',
        homepage: 'https://phantom.app/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>(0, $hE77Y.isEvmBlockchain)(chain) && $0c414e9707a4c833$export$6ae6d19d2a14f956.includes(chain.name))
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    },
                    {
                        label: 'BTC',
                        value: 'UTXO',
                        id: 'BTC',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                    },
                    {
                        label: 'Sui',
                        value: 'Sui',
                        id: 'SUI',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.type === (0, $9B1kL.TransactionType).SUI)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $432968d31153d496$export$2e2bcd8739ae039)((0, $eb284851236684b7$export$62115b9164fa6f77)())
            }
        }
    ]
};




const $4d652050f42a8195$var$WALLET = (0, $9cRHO.WalletTypes).PHANTOM;
const $4d652050f42a8195$export$e506a1d27d1eaa20 = {
    type: $4d652050f42a8195$var$WALLET
};
const $4d652050f42a8195$export$8bedcca5bbd73999 = (0, $eb284851236684b7$export$40b6ddfff396bf5b);
/*
 * NOTE: Phantom's Hub version has support for EVM as well since we are deprecating the legacy,
 * we just want to keep the implementation for some time and then legacy provider will be removed soon.
 * So we don't add new namespaces (like EVM) to legacy.
 */ const $4d652050f42a8195$var$connect = async ({ instance: instance, meta: meta })=>{
    const solanaInstance = instance.get((0, $9HEDW.LegacyNetworks).SOLANA);
    const result = await (0, $fIwj6.getSolanaAccounts)({
        instance: solanaInstance,
        meta: meta
    });
    return result;
};
const $4d652050f42a8195$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, connect: connect })=>{
    const handleAccountsChanged = async (publicKey)=>{
        const network = (0, $9HEDW.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    instance?.on?.('accountChanged', handleAccountsChanged);
    return ()=>{
        instance?.off?.('accountChanged', handleAccountsChanged);
    };
};
const $4d652050f42a8195$var$canSwitchNetworkTo = ({ network: network })=>{
    return (0, $0c414e9707a4c833$export$6ae6d19d2a14f956).includes(network);
};
const $4d652050f42a8195$export$6352a17a50193ded = (0, $432968d31153d496$export$2e2bcd8739ae039);
const $4d652050f42a8195$var$canEagerConnect = async ({ instance: instance, meta: meta })=>{
    const solanaInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).SOLANA);
    try {
        const result = await solanaInstance.connect({
            onlyIfTrusted: true
        });
        return !!result;
    } catch  {
        return false;
    }
};
const $4d652050f42a8195$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    let supportedChains = [];
    const sui = allBlockChains.filter((blockchain)=>blockchain.type === (0, $9B1kL.TransactionType).SUI);
    const solana = (0, $hE77Y.solanaBlockchain)(allBlockChains);
    const evms = allBlockChains.filter((chain)=>(0, $hE77Y.isEvmBlockchain)(chain) && (0, $0c414e9707a4c833$export$6ae6d19d2a14f956).includes(chain.name));
    const btc = allBlockChains.find((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC);
    supportedChains = supportedChains.concat(solana, evms, sui);
    if (btc) supportedChains.push(btc);
    return {
        name: 'Phantom',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/phantom/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa',
            DEFAULT: 'https://phantom.app/'
        },
        color: '#4d40c6',
        // if you are adding a new namespace, don't forget to also update `properties`
        needsNamespace: {
            selection: 'multiple',
            data: [
                {
                    label: 'EVM',
                    value: 'EVM',
                    id: 'ETH',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>(0, $hE77Y.isEvmBlockchain)(chain) && (0, $0c414e9707a4c833$export$6ae6d19d2a14f956).includes(chain.name))
                },
                {
                    label: 'Solana',
                    value: 'Solana',
                    id: 'SOLANA',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                },
                {
                    label: 'BTC',
                    value: 'UTXO',
                    id: 'BTC',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                },
                {
                    label: 'Sui',
                    value: 'Sui',
                    id: 'SUI',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.type === (0, $9B1kL.TransactionType).SUI)
                }
            ]
        },
        supportedChains: supportedChains
    };
};
const $4d652050f42a8195$export$107c8cc6b37a1ffa = ()=>({
        config: $4d652050f42a8195$export$e506a1d27d1eaa20,
        getInstance: $4d652050f42a8195$export$8bedcca5bbd73999,
        connect: $4d652050f42a8195$var$connect,
        subscribe: $4d652050f42a8195$export$ec068583843480e7,
        getSigners: $4d652050f42a8195$export$6352a17a50193ded,
        getWalletInfo: $4d652050f42a8195$export$e5b9d96c6aeb3ff7,
        canSwitchNetworkTo: $4d652050f42a8195$var$canSwitchNetworkTo,
        canEagerConnect: $4d652050f42a8195$var$canEagerConnect
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$2fcab256c1e887a5$var$changeAccountSubscriber, $2fcab256c1e887a5$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $eb284851236684b7$export$b8130868f114a8d5));
/*
 * TODO: If user imported a private key for EVM, it hasn't solana.
 * when trying to connect to solana for this user we go through `-32603` which is an internal error.
 * If phantom added an specific error code for this situation, we can consider handling the error here.
 * @see https://docs.phantom.app/solana/errors
 */ const $2fcab256c1e887a5$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $eb284851236684b7$export$b8130868f114a8d5))).before($2fcab256c1e887a5$var$changeAccountSubscriber).or($2fcab256c1e887a5$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $2fcab256c1e887a5$var$disconnect = (0, $f59Be.builders).disconnect().after($2fcab256c1e887a5$var$changeAccountCleanup).build();
const $2fcab256c1e887a5$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $eb284851236684b7$export$b8130868f114a8d5))).build();
const $2fcab256c1e887a5$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $2fcab256c1e887a5$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $eb284851236684b7$export$b8130868f114a8d5))).build();
const $2fcab256c1e887a5$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $0c414e9707a4c833$export$7c460c214963f696)).action($2fcab256c1e887a5$var$connect).action($2fcab256c1e887a5$var$disconnect).action($2fcab256c1e887a5$var$canEagerConnect).action($2fcab256c1e887a5$var$canSwitchNetwork).action($2fcab256c1e887a5$var$getChainId).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


var $3ca9q = parcelRequire("3ca9q");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");


const [$f365878d16dc2b2f$var$changeAccountSubscriber, $f365878d16dc2b2f$var$changeAccountCleanup] = (0, $3b5535826a909102$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $eb284851236684b7$export$21360755953cef72));
/*
 * TODO: If user imported a private key for EVM, it hasn't solana.
 * when trying to connect to solana for this user we go through `-32603` which is an internal error.
 * If phantom added an specific error code for this situation, we can consider handling the error here.
 * @see https://docs.phantom.app/solana/errors
 */ const $f365878d16dc2b2f$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action(async function() {
    const solanaInstance = (0, $eb284851236684b7$export$21360755953cef72)();
    const result = await (0, $fIwj6.getSolanaAccounts)({
        instance: solanaInstance,
        meta: []
    });
    if (Array.isArray(result)) throw new Error('Expecting solana response to be a single value, not an array.');
    const formatAccounts = result.accounts.map((account)=>(0, $3ca9q).AccountId.format({
            address: account,
            chainId: {
                namespace: (0, $3b5535826a909102$export$c67e5a7ce034264a),
                reference: (0, $3b5535826a909102$export$a3d7ecd9c7e8a4a)
            }
        }));
    return formatAccounts;
}).before($f365878d16dc2b2f$var$changeAccountSubscriber).or($f365878d16dc2b2f$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $f365878d16dc2b2f$var$disconnect = (0, $f59Be.builders).disconnect().after($f365878d16dc2b2f$var$changeAccountCleanup).build();
const $f365878d16dc2b2f$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $3b5535826a909102$export$e324594224ef24da).canEagerConnect((0, $eb284851236684b7$export$21360755953cef72))).build();
const $f365878d16dc2b2f$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $0c414e9707a4c833$export$7c460c214963f696)).action($f365878d16dc2b2f$var$connect).action($f365878d16dc2b2f$var$disconnect).action($f365878d16dc2b2f$var$canEagerConnect).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");




const [$783e30d7fc79c9e9$var$changeAccountSubscriber, $783e30d7fc79c9e9$var$changeAccountCleanup] = (0, $2ee4b5c7f608ffed$export$11949c6f5fba7dcd).changeAccountSubscriber({
    name: (0, $0c414e9707a4c833$export$a54267529b947bd8)
});
const $783e30d7fc79c9e9$var$connect = (0, $2ee4b5c7f608ffed$export$aea8daed5328d69c).connect({
    name: (0, $0c414e9707a4c833$export$a54267529b947bd8)
}).before($783e30d7fc79c9e9$var$changeAccountSubscriber).or($783e30d7fc79c9e9$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $783e30d7fc79c9e9$var$disconnect = (0, $f59Be.builders).disconnect().after($783e30d7fc79c9e9$var$changeAccountCleanup).build();
/*
 * TODO: We are currently using `solanaCanEagerConnectAction` to establish an eager connection to the Sui instance.
 * This is a temporary workaround due to Phantom's limitation in silently connecting to a Sui account.
 * Once Phantom introduces support for silent Sui connections, this implementation should be updated accordingly.
 */ const $783e30d7fc79c9e9$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $3b5535826a909102$export$e324594224ef24da).canEagerConnect((0, $eb284851236684b7$export$21360755953cef72))).build();
const $783e30d7fc79c9e9$export$6b552e3351f14b18 = new (0, $at2GJ.NamespaceBuilder)('Sui', (0, $0c414e9707a4c833$export$7c460c214963f696)).action($783e30d7fc79c9e9$var$connect).action($783e30d7fc79c9e9$var$disconnect).action($783e30d7fc79c9e9$var$canEagerConnect).build();


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


var $er2za = parcelRequire("er2za");

var $3ca9q = parcelRequire("3ca9q");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");


const $402f8a36ad9b108d$var$getBitcoinAccounts = async ()=>{
    const instance = (0, $eb284851236684b7$export$74ba08f8787dea92)();
    const accounts = await instance.requestAccounts();
    return {
        accounts: accounts.filter((account)=>account.purpose === 'payment').map((account)=>account.address),
        chainId: (0, $9HEDW.LegacyNetworks).BTC
    };
};
function $402f8a36ad9b108d$var$getChangeAccountSubscriber(instance) {
    let eventCallback;
    // subscriber can be passed to `or`, it will get the error and should rethrow error to pass the error to next `or` or throw error.
    return [
        (context, err)=>{
            const bitcoinInstance = instance();
            if (!bitcoinInstance) throw new Error('Trying to subscribe to your Solana wallet, but seems its instance is not available.');
            const [, setState] = context.state();
            eventCallback = (accounts)=>{
                /*
         * In Phantom, when user is switching to an account which is not connected to dApp yet, it returns an empty array on `accountsChanged`.
         * So empty array means we don't have access to account and we need to disconnect and let the user connect the account.
         */ if (!accounts.length) {
                    context.action('disconnect');
                    return;
                }
                const formatAccounts = accounts.filter((account)=>account.purpose === 'payment').map((account)=>(0, $3ca9q).AccountId.format({
                        address: account.address,
                        chainId: {
                            namespace: (0, $er2za.CAIP_NAMESPACE),
                            reference: (0, $er2za.CAIP_BITCOIN_CHAIN_ID)
                        }
                    }));
                setState('accounts', formatAccounts);
            };
            bitcoinInstance.on('accountsChanged', eventCallback);
            if (err instanceof Error) throw err;
        },
        (_context, err)=>{
            const bitcoinInstance = instance();
            if (eventCallback && bitcoinInstance) bitcoinInstance.off('accountsChanged', eventCallback);
            return err;
        }
    ];
}
const [$402f8a36ad9b108d$var$changeAccountSubscriber, $402f8a36ad9b108d$var$changeAccountCleanup] = $402f8a36ad9b108d$var$getChangeAccountSubscriber((0, $eb284851236684b7$export$74ba08f8787dea92));
const $402f8a36ad9b108d$var$connect = (0, $er2za.builders).connect().action(async function() {
    const result = await $402f8a36ad9b108d$var$getBitcoinAccounts();
    if (Array.isArray(result)) throw new Error('Expecting bitcoin response to be a single value, not an array.');
    const formatAccounts = result.accounts.map((account)=>(0, $3ca9q).AccountId.format({
            address: account,
            chainId: {
                namespace: (0, $er2za.CAIP_NAMESPACE),
                reference: (0, $er2za.CAIP_BITCOIN_CHAIN_ID)
            }
        }));
    return formatAccounts;
}).before($402f8a36ad9b108d$var$changeAccountSubscriber).or($402f8a36ad9b108d$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $402f8a36ad9b108d$var$disconnect = (0, $f59Be.builders).disconnect().after($402f8a36ad9b108d$var$changeAccountCleanup).build();
/*
 * TODO: We are currently using `solanaCanEagerConnectAction` to establish an eager connection to the BTC instance.
 * This is a temporary workaround due to Phantom's limitation in silently connecting to a BTC account.
 * Once Phantom introduces support for silent BTC connections, this implementation should be updated accordingly.
 */ const $402f8a36ad9b108d$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $3b5535826a909102$export$e324594224ef24da).canEagerConnect((0, $eb284851236684b7$export$21360755953cef72))).build();
const $402f8a36ad9b108d$export$85601e73083fc493 = new (0, $at2GJ.NamespaceBuilder)('UTXO', (0, $0c414e9707a4c833$export$7c460c214963f696)).action($402f8a36ad9b108d$var$connect).action($402f8a36ad9b108d$var$disconnect).action($402f8a36ad9b108d$var$canEagerConnect).build();



const $66a286892aece54c$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $0c414e9707a4c833$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $eb284851236684b7$export$40b6ddfff396bf5b)()) {
            setState('installed', true);
            console.debug('[phantom] instance detected.', context);
        }
    }).config('metadata', (0, $0c414e9707a4c833$export$dbb5e893e736e4ee)).add('solana', (0, $f365878d16dc2b2f$export$ee6400bf8f8c2a0d)).add('evm', (0, $2fcab256c1e887a5$export$2f7490c34b49803e)).add('utxo', (0, $402f8a36ad9b108d$export$85601e73083fc493)).add('sui', (0, $783e30d7fc79c9e9$export$6b552e3351f14b18)).build();


const $4504323b5333b7d7$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $4d652050f42a8195$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $66a286892aece54c$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $cf3466b2f7b04054$export$2e2bcd8739ae039(provider) {
    const evmProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(evmProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");

function $bbe4edb44334b68e$export$6e053ecfae416447() {
    const { ethereum: ethereum } = window;
    if (!ethereum?.isRabby) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, ethereum);
    return instances;
}
function $bbe4edb44334b68e$export$4f187c1429d55acb() {
    const instances = $bbe4edb44334b68e$export$6e053ecfae416447();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Rabby not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
async function $bbe4edb44334b68e$export$174137fbf327b70f(instance, chain) {
    try {
        const chainId = typeof chain === 'string' ? chain : chain.chainId;
        await (0, $795b2611c2574d92$export$eab97d15b1788b8d).switchNetwork(instance, chainId);
    } catch (switchError) {
        const error = switchError;
        /*
     * Workaround for handling unrecognized chain errors in rabby where error code -32603
     * (defined in EIP-1474 as an internal RPC error) is used instead of the metamask chain-not-found code.
     * Combine the code check with the specific error message "Unrecognized chain ID"
     * to reliably identify this scenario.
     */ const NOT_FOUND_CHAIN_ERROR_CODE = -32603;
        const NOT_FOUND_ERROR_MESSAGE = 'Unrecognized chain ID';
        if (typeof chain !== 'string' && error.code === NOT_FOUND_CHAIN_ERROR_CODE && error.message.includes(NOT_FOUND_ERROR_MESSAGE)) {
            await (0, $795b2611c2574d92$export$eab97d15b1788b8d).suggestNetwork(instance, chain);
            return;
        }
        throw switchError;
    }
}


const $b409f6a274fff712$export$e506a1d27d1eaa20 = {
    type: (0, $9cRHO.WalletTypes).Rabby
};
const $b409f6a274fff712$export$8bedcca5bbd73999 = (0, $bbe4edb44334b68e$export$6e053ecfae416447);
const $b409f6a274fff712$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $gSYt0.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $b409f6a274fff712$export$ec068583843480e7 = (0, $gSYt0.subscribeToEvm);
const $b409f6a274fff712$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $b409f6a274fff712$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $b409f6a274fff712$export$6352a17a50193ded = (0, $cf3466b2f7b04054$export$2e2bcd8739ae039);
const $b409f6a274fff712$export$be9f3c5ed1d25e42 = (0, $gSYt0.canEagerlyConnectToEvm);
const $b409f6a274fff712$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    return {
        name: 'Rabby',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/rabby/icon.svg',
        installLink: {
            CHROME: 'https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch',
            BRAVE: 'https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch',
            FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/rabby-wallet/',
            DEFAULT: 'https://rabby.io/'
        },
        color: '#fff',
        supportedChains: evms,
        needsNamespace: {
            selection: 'multiple',
            data: [
                {
                    id: 'ETH',
                    value: 'EVM',
                    label: 'Evm',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                }
            ]
        }
    };
};
const $b409f6a274fff712$export$107c8cc6b37a1ffa = ()=>({
        config: $b409f6a274fff712$export$e506a1d27d1eaa20,
        getInstance: $b409f6a274fff712$export$8bedcca5bbd73999,
        connect: $b409f6a274fff712$export$64605811ab45167f,
        subscribe: $b409f6a274fff712$export$ec068583843480e7,
        switchNetwork: $b409f6a274fff712$export$f3473d805e486329,
        canSwitchNetworkTo: $b409f6a274fff712$export$3b3cf9ab9019de20,
        getSigners: $b409f6a274fff712$export$6352a17a50193ded,
        canEagerConnect: $b409f6a274fff712$export$be9f3c5ed1d25e42,
        getWalletInfo: $b409f6a274fff712$export$e5b9d96c6aeb3ff7
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");


const $63fa7f4386e6cb05$export$7c460c214963f696 = 'rabby';
const $63fa7f4386e6cb05$export$dbb5e893e736e4ee = {
    name: 'Rabby',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/rabby/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch',
        brave: 'https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/rabby-wallet',
        homepage: 'https://rabby.io/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $cf3466b2f7b04054$export$2e2bcd8739ae039)((0, $bbe4edb44334b68e$export$4f187c1429d55acb)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$e491823972e93021$var$changeAccountSubscriber, $e491823972e93021$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $bbe4edb44334b68e$export$4f187c1429d55acb));
const $e491823972e93021$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $bbe4edb44334b68e$export$4f187c1429d55acb), {
    switchOrAddNetwork: $bbe4edb44334b68e$export$174137fbf327b70f
})).before($e491823972e93021$var$changeAccountSubscriber).or($e491823972e93021$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $e491823972e93021$var$disconnect = (0, $f59Be.builders).disconnect().after($e491823972e93021$var$changeAccountCleanup).build();
const $e491823972e93021$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $e491823972e93021$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $bbe4edb44334b68e$export$4f187c1429d55acb))).build();
const $e491823972e93021$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $bbe4edb44334b68e$export$4f187c1429d55acb))).build();
const $e491823972e93021$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $63fa7f4386e6cb05$export$7c460c214963f696)).action($e491823972e93021$var$connect).action($e491823972e93021$var$disconnect).action($e491823972e93021$var$canEagerConnect).action($e491823972e93021$var$canSwitchNetwork).action($e491823972e93021$var$getChainId).build();



const $9648bd09b2e108dd$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $63fa7f4386e6cb05$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $bbe4edb44334b68e$export$6e053ecfae416447)()) {
            setState('installed', true);
            console.debug('[rabby] instance detected.', context);
        }
    }).config('metadata', (0, $63fa7f4386e6cb05$export$dbb5e893e736e4ee)).add('evm', (0, $e491823972e93021$export$2f7490c34b49803e)).build();


const $9c01529d79753eb3$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $b409f6a274fff712$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $9648bd09b2e108dd$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $cab834934c594cea$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const starknetProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).STARKNET);
    const { DefaultStarknetSigner: DefaultStarknetSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("1q68f")));
    signers.registerSigner((0, $9B1kL.TransactionType).STARKNET, new DefaultStarknetSigner(starknetProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $f762435cbee8a5b5$export$28ee1007e174a2a6() {
    const instances = new Map();
    const { starknet_argentX: starknet_argentX } = window;
    if (!starknet_argentX) return null;
    instances.set((0, $9HEDW.LegacyNetworks).STARKNET, starknet_argentX);
    return instances;
}
function $f762435cbee8a5b5$export$62115b9164fa6f77() {
    const instances = $f762435cbee8a5b5$export$28ee1007e174a2a6();
    if (!instances) throw new Error('Ready is not injected. Please check your wallet.');
    return instances;
}
function $f762435cbee8a5b5$export$c2565b9ee017fd54() {
    const instances = $f762435cbee8a5b5$export$28ee1007e174a2a6();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).STARKNET);
    if (!evmInstance) throw new Error('Ready not injected or Starknet not enabled. Please check your wallet.');
    return evmInstance;
}


const $fb227b9ab3b2bda3$export$7c460c214963f696 = 'ready';
const $fb227b9ab3b2bda3$export$dbb5e893e736e4ee = {
    name: 'Ready',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/argentx/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/ready-wallet-formerly-arg/dlcobpjiigpikoobohmabehhmhfoodbb',
        brave: 'https://chromewebstore.google.com/detail/ready-wallet-formerly-arg/dlcobpjiigpikoobohmabehhmhfoodbb',
        firefox: 'https://addons.mozilla.org/en-GB/firefox/addon/argent-x',
        homepage: 'https://www.ready.co/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Ready',
                        value: 'Starknet',
                        id: 'STARKNET',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.starknetBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $cab834934c594cea$export$2e2bcd8739ae039)((0, $f762435cbee8a5b5$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


function $e2b3dc224ac9fb4f$export$64605811ab45167f(instance) {
    return async ()=>{
        const starknetInstance = instance();
        const connectResult = await starknetInstance?.enable();
        if (!connectResult || !starknetInstance.isConnected || !connectResult?.length) throw new Error('Error during connection');
        if (starknetInstance?.chainId !== (0, $383083a8c49ef7e6$export$ca044345c4fd381b)) throw new Error(`Please switch to Mainnet, current network is ${starknetInstance?.chainId}`);
        return (0, $383083a8c49ef7e6$export$eab97d15b1788b8d).formatAccountsToCAIP(connectResult);
    };
}
const $e2b3dc224ac9fb4f$export$cadf35f7f22c9f8c = {
    connect: $e2b3dc224ac9fb4f$export$64605811ab45167f
};



var $f59Be = parcelRequire("f59Be");

const $c46e01db4c156b08$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event)=>{
        if (!event.payload.length) event.preventDefault();
    }).format(async (_, accounts)=>(0, $383083a8c49ef7e6$export$eab97d15b1788b8d).formatAccountsToCAIP(accounts)).addEventListener((instance, callback)=>{
        instance.on('accountsChanged', callback);
    }).removeEventListener((instance, callback)=>{
        instance.off('accountsChanged', callback);
    });
const $c46e01db4c156b08$export$d782570be268a1b8 = {
    changeAccountSubscriber: $c46e01db4c156b08$export$bc681aebb548377e
};




const [$13b8b29e76783004$var$changeAccountSubscriber, $13b8b29e76783004$var$changeAccountCleanup] = (0, $c46e01db4c156b08$export$d782570be268a1b8).changeAccountSubscriber((0, $f762435cbee8a5b5$export$c2565b9ee017fd54)).build();
const $13b8b29e76783004$var$connect = (0, $383083a8c49ef7e6$export$aea8daed5328d69c).connect().action((0, $e2b3dc224ac9fb4f$export$cadf35f7f22c9f8c).connect((0, $f762435cbee8a5b5$export$c2565b9ee017fd54))).before($13b8b29e76783004$var$changeAccountSubscriber).or($13b8b29e76783004$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $13b8b29e76783004$var$disconnect = (0, $f59Be.builders).disconnect().after($13b8b29e76783004$var$changeAccountCleanup).build();
const $13b8b29e76783004$var$canEagerConnect = (0, $383083a8c49ef7e6$export$aea8daed5328d69c).canEagerConnect().action((0, $383083a8c49ef7e6$export$e324594224ef24da).canEagerConnect((0, $f762435cbee8a5b5$export$c2565b9ee017fd54))).build();
const $13b8b29e76783004$export$6fd5aae21d757e0f = new (0, $at2GJ.NamespaceBuilder)('Starknet', (0, $fb227b9ab3b2bda3$export$7c460c214963f696)).action($13b8b29e76783004$var$connect).action($13b8b29e76783004$var$disconnect).action($13b8b29e76783004$var$canEagerConnect).build();



const $42a649c73a0a949f$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $fb227b9ab3b2bda3$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $f762435cbee8a5b5$export$28ee1007e174a2a6)()) {
            setState('installed', true);
            console.debug('[ready] instance detected.', context);
        }
    }).config('metadata', (0, $fb227b9ab3b2bda3$export$dbb5e893e736e4ee)).add('starknet', (0, $13b8b29e76783004$export$6fd5aae21d757e0f)).build();


const $70da00cffcb1e8da$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $42a649c73a0a949f$export$afa934a86232cabe)()).build();


var $bf59b7aa4802b6ce$exports = {};

$parcel$export($bf59b7aa4802b6ce$exports, "config", function () { return $bf59b7aa4802b6ce$export$e506a1d27d1eaa20; });
$parcel$export($bf59b7aa4802b6ce$exports, "getInstance", function () { return $bf59b7aa4802b6ce$export$8bedcca5bbd73999; });
$parcel$export($bf59b7aa4802b6ce$exports, "connect", function () { return $bf59b7aa4802b6ce$export$64605811ab45167f; });
$parcel$export($bf59b7aa4802b6ce$exports, "subscribe", function () { return $bf59b7aa4802b6ce$export$ec068583843480e7; });
$parcel$export($bf59b7aa4802b6ce$exports, "switchNetwork", function () { return $bf59b7aa4802b6ce$export$f3473d805e486329; });
$parcel$export($bf59b7aa4802b6ce$exports, "canSwitchNetworkTo", function () { return $bf59b7aa4802b6ce$export$3b3cf9ab9019de20; });
$parcel$export($bf59b7aa4802b6ce$exports, "getSigners", function () { return $bf59b7aa4802b6ce$export$6352a17a50193ded; });
$parcel$export($bf59b7aa4802b6ce$exports, "canEagerConnect", function () { return $bf59b7aa4802b6ce$export$be9f3c5ed1d25e42; });
$parcel$export($bf59b7aa4802b6ce$exports, "getWalletInfo", function () { return $bf59b7aa4802b6ce$export$e5b9d96c6aeb3ff7; });
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $41i2w = parcelRequire("41i2w");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $0ac12e8a9efea017$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { CustomEvmSigner: CustomEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("feuLT")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new CustomEvmSigner(provider));
    return signers;
}


const $bf59b7aa4802b6ce$var$WALLET = (0, $9cRHO.WalletTypes).SAFE;
const $bf59b7aa4802b6ce$export$e506a1d27d1eaa20 = {
    type: $bf59b7aa4802b6ce$var$WALLET,
    isAsyncInstance: true
};
const $bf59b7aa4802b6ce$export$8bedcca5bbd73999 = async ()=>{
    return await (0, $41i2w.getSafeInstance)();
};
const $bf59b7aa4802b6ce$export$64605811ab45167f = async ({ instance: instance })=>{
    const accounts = await instance.request({
        method: 'eth_accounts'
    });
    const { chainId: chainId } = instance;
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $bf59b7aa4802b6ce$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const evmBlockchainMeta = meta.filter((0, $hE77Y.isEvmBlockchain));
    const cleanup = (0, $gSYt0.subscribeToEvm)({
        instance: instance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: evmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $bf59b7aa4802b6ce$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $bf59b7aa4802b6ce$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $bf59b7aa4802b6ce$export$6352a17a50193ded = (0, $0ac12e8a9efea017$export$2e2bcd8739ae039);
const $bf59b7aa4802b6ce$export$be9f3c5ed1d25e42 = (0, $gSYt0.canEagerlyConnectToEvm);
const $bf59b7aa4802b6ce$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    return {
        name: 'Safe',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safe/icon.svg',
        installLink: {
            DEFAULT: 'https://app.safe.global/'
        },
        color: '#ffffff',
        supportedChains: evms,
        isContractWallet: true
    };
};




var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $d3c1218280132cec$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9XxdG = parcelRequire("9XxdG");
function $2a0f603940a93cf9$export$ff14f0e3b306c092() {
    const { safepalProvider: safePalEvm } = window;
    if (!safePalEvm) return null;
    const instances = new Map();
    if (safePalEvm) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, safePalEvm);
    return instances;
}
function $2a0f603940a93cf9$export$4700fa2f2f0e6b28() {
    const instances = $2a0f603940a93cf9$export$ff14f0e3b306c092();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Safepal not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $2a0f603940a93cf9$export$62115b9164fa6f77() {
    const instances = $2a0f603940a93cf9$export$ff14f0e3b306c092();
    if (!instances) throw new Error('Trust Wallet is not injected. Please check your wallet.');
    return instances;
}
function $2a0f603940a93cf9$export$21b2b006055ebb47(address) {
    // Pick wallet address.
    const walletAddress = address.split(':')[2];
    return (0, $9XxdG.isAddress)(walletAddress);
}


const $e3f7831db0647533$var$WALLET = (0, $9cRHO.WalletTypes).SAFEPAL;
const $e3f7831db0647533$export$e506a1d27d1eaa20 = {
    type: $e3f7831db0647533$var$WALLET,
    defaultNetwork: (0, $9HEDW.LegacyNetworks).ETHEREUM
};
const $e3f7831db0647533$export$8bedcca5bbd73999 = (0, $2a0f603940a93cf9$export$ff14f0e3b306c092);
const $e3f7831db0647533$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const results = [];
    if (ethInstance) {
        const evmResult = await (0, $gSYt0.getEvmAccounts)(ethInstance);
        results.push(evmResult);
    }
    return results;
};
const $e3f7831db0647533$export$ec068583843480e7 = (options)=>{
    let cleanup;
    const ethInstance = (0, $gSYt0.chooseInstance)(options.instance, options.meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (ethInstance) cleanup = (0, $gSYt0.subscribeToEvm)({
        ...options,
        instance: ethInstance
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $e3f7831db0647533$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $e3f7831db0647533$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $e3f7831db0647533$export$6352a17a50193ded = (0, $d3c1218280132cec$export$2e2bcd8739ae039);
const $e3f7831db0647533$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    const solana = (0, $hE77Y.solanaBlockchain)(allBlockChains);
    return {
        name: 'SafePal',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safepal/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa',
            BRAVE: 'https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa',
            FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/safepal-extension-wallet',
            DEFAULT: 'https://www.safepal.com/download'
        },
        color: '#4A21EF',
        supportedChains: [
            ...evms,
            ...solana
        ],
        needsNamespace: {
            selection: 'multiple',
            data: [
                {
                    label: 'EVM',
                    value: 'EVM',
                    id: 'ETH',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                },
                {
                    label: 'Solana',
                    value: 'Solana',
                    id: 'SOLANA',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                }
            ]
        }
    };
};
const $e3f7831db0647533$export$107c8cc6b37a1ffa = ()=>({
        config: $e3f7831db0647533$export$e506a1d27d1eaa20,
        getInstance: $e3f7831db0647533$export$8bedcca5bbd73999,
        connect: $e3f7831db0647533$export$64605811ab45167f,
        subscribe: $e3f7831db0647533$export$ec068583843480e7,
        switchNetwork: $e3f7831db0647533$export$f3473d805e486329,
        canSwitchNetworkTo: $e3f7831db0647533$export$3b3cf9ab9019de20,
        getSigners: $e3f7831db0647533$export$6352a17a50193ded,
        getWalletInfo: $e3f7831db0647533$export$e5b9d96c6aeb3ff7
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");


const $52a50a3f74ff3e6c$export$7c460c214963f696 = 'safepal';
const $52a50a3f74ff3e6c$export$dbb5e893e736e4ee = {
    name: 'SafePal',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safepal/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa',
        brave: 'https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/safepal-extension-wallet',
        homepage: 'https://www.safepal.com/download'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $d3c1218280132cec$export$2e2bcd8739ae039)((0, $2a0f603940a93cf9$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$65ed37901daca935$var$changeAccountSubscriber, $65ed37901daca935$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $2a0f603940a93cf9$export$4700fa2f2f0e6b28)).build();
/**
 * Important: Keep this implementation in sync with wallets/core/src/namespaces/evm/builders
 */ const $65ed37901daca935$var$connect = new (0, $fha7R.ActionBuilder)('connect').action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $2a0f603940a93cf9$export$4700fa2f2f0e6b28))).before($65ed37901daca935$var$changeAccountSubscriber).before((0, $f59Be.intoConnecting))/*
   * Validate all accounts are valid EVM addresses
   * Sometimes wallets may return non-EVM addresses - this check prevents that
   */ .and((_, args)=>{
    if (args.accounts.some((account)=>!(0, $2a0f603940a93cf9$export$21b2b006055ebb47)(account))) throw new Error('Non valid EVM address returned from wallet');
    return args;
}).and((0, $f59Be.connectAndUpdateStateForMultiNetworks)).after((0, $f59Be.intoConnectionFinished)).or($65ed37901daca935$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $65ed37901daca935$var$disconnect = (0, $f59Be.builders).disconnect().after($65ed37901daca935$var$changeAccountCleanup).build();
const $65ed37901daca935$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $65ed37901daca935$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $2a0f603940a93cf9$export$4700fa2f2f0e6b28))).build();
const $65ed37901daca935$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $52a50a3f74ff3e6c$export$7c460c214963f696)).action($65ed37901daca935$var$connect).action($65ed37901daca935$var$disconnect).action($65ed37901daca935$var$canSwitchNetwork).action($65ed37901daca935$var$getChainId).build();



const $d91c9ed343235c95$var$WAIT_TO_LOAD_INSTANCE_DELAY = 1000;
const $d91c9ed343235c95$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $52a50a3f74ff3e6c$export$7c460c214963f696)).init(function(context) {
        setTimeout(()=>{
            if ((0, $2a0f603940a93cf9$export$ff14f0e3b306c092)()) {
                const [, setState] = context.state();
                setState('installed', true);
                console.debug('[safepal] instance detected.', context);
            }
        }, $d91c9ed343235c95$var$WAIT_TO_LOAD_INSTANCE_DELAY);
    }).config('metadata', (0, $52a50a3f74ff3e6c$export$dbb5e893e736e4ee)).add('evm', (0, $65ed37901daca935$export$2f7490c34b49803e)).build();


const $35fd058f1d09b998$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $e3f7831db0647533$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $d91c9ed343235c95$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");

parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");

const $5343add447a3a0e0$export$7c460c214963f696 = 'slush';
const $5343add447a3a0e0$export$a54267529b947bd8 = 'Slush';
const $5343add447a3a0e0$export$dbb5e893e736e4ee = {
    name: 'Slush',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/slush/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/slush-%E2%80%94-a-sui-wallet/opcgpfmipidbgpenhmajoajpbobppdil',
        edge: 'https://chromewebstore.google.com/detail/slush-%E2%80%94-a-sui-wallet/opcgpfmipidbgpenhmajoajpbobppdil',
        brave: 'https://chromewebstore.google.com/detail/slush-%E2%80%94-a-sui-wallet/opcgpfmipidbgpenhmajoajpbobppdil',
        homepage: 'https://slush.app/download'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                data: [
                    {
                        label: 'Sui',
                        value: 'Sui',
                        id: 'SUI',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.type === (0, $9B1kL.TransactionType).SUI)
                    }
                ],
                selection: 'multiple'
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $2dabcfc6ae05ccb8$export$2e2bcd8739ae039)()
            }
        }
    ]
};



async function $2dabcfc6ae05ccb8$export$2e2bcd8739ae039() {
    const suiWalletProvider = (0, $2ee4b5c7f608ffed$export$62115b9164fa6f77)((0, $5343add447a3a0e0$export$a54267529b947bd8));
    const { DefaultSuiSigner: DefaultSuiSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("3tfzf")));
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).SUI, new DefaultSuiSigner(suiWalletProvider));
    return signers;
}




function $1a5dbe0a0813828c$export$b4b903248030444f() {
    try {
        return (0, $2ee4b5c7f608ffed$export$62115b9164fa6f77)((0, $5343add447a3a0e0$export$a54267529b947bd8));
    } catch  {
        return null;
    }
}


const $f30a64cf355f8eb7$var$WALLET = (0, $9cRHO.WalletTypes).SLUSH;
const $f30a64cf355f8eb7$export$e506a1d27d1eaa20 = {
    type: $f30a64cf355f8eb7$var$WALLET
};
const $f30a64cf355f8eb7$export$8bedcca5bbd73999 = (0, $1a5dbe0a0813828c$export$b4b903248030444f);
const $f30a64cf355f8eb7$var$connect = async ()=>{
    throw new Error('not implemented');
};
const $f30a64cf355f8eb7$export$6352a17a50193ded = (0, $2dabcfc6ae05ccb8$export$2e2bcd8739ae039);
const $f30a64cf355f8eb7$export$e5b9d96c6aeb3ff7 = ()=>{
    throw new Error('not implemented');
};
const $f30a64cf355f8eb7$export$107c8cc6b37a1ffa = ()=>({
        config: $f30a64cf355f8eb7$export$e506a1d27d1eaa20,
        getInstance: $f30a64cf355f8eb7$export$8bedcca5bbd73999,
        connect: $f30a64cf355f8eb7$var$connect,
        getSigners: $f30a64cf355f8eb7$export$6352a17a50193ded,
        getWalletInfo: $f30a64cf355f8eb7$export$e5b9d96c6aeb3ff7
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const $6afca6c15e9907bb$var$canEagerConnect = (0, $2ee4b5c7f608ffed$export$aea8daed5328d69c).canEagerConnect().action((0, $2ee4b5c7f608ffed$export$e324594224ef24da).canEagerConnect({
    name: (0, $5343add447a3a0e0$export$a54267529b947bd8)
})).build();
const $6afca6c15e9907bb$var$connect = (0, $2ee4b5c7f608ffed$export$aea8daed5328d69c).connect({
    name: (0, $5343add447a3a0e0$export$a54267529b947bd8)
}).build();
const $6afca6c15e9907bb$var$disconnect = (0, $f59Be.builders).disconnect()/*
   * This addresses a wallet bug where changing accounts within the app
   *  and then reconnecting results in a connection to the previously connected account.
   *  Explicitly calling `disconnect()` on the wallet instance ensures the wallet
   *  itself is disconnected, allowing for a proper connection to the intended account
   *  upon subsequent reconnection.
   */ .before(async ()=>{
    await (0, $1a5dbe0a0813828c$export$b4b903248030444f)()?.features['standard:disconnect'].disconnect();
}).build();
const $6afca6c15e9907bb$export$6b552e3351f14b18 = new (0, $at2GJ.NamespaceBuilder)('Sui', (0, $5343add447a3a0e0$export$7c460c214963f696)).action($6afca6c15e9907bb$var$connect).action($6afca6c15e9907bb$var$disconnect).action($6afca6c15e9907bb$var$canEagerConnect).build();



const $22f4d3b82924adfa$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $5343add447a3a0e0$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $1a5dbe0a0813828c$export$b4b903248030444f)()) {
            setState('installed', true);
            console.debug('[slush] instance detected.', context);
        }
    }).config('metadata', (0, $5343add447a3a0e0$export$dbb5e893e736e4ee)).add('sui', (0, $6afca6c15e9907bb$export$6b552e3351f14b18)).build();


const $c71c5199e7c6aecc$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $f30a64cf355f8eb7$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $22f4d3b82924adfa$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("6Zvtg");
var $13wKd = parcelRequire("13wKd");

var $hZS7n = parcelRequire("hZS7n");
class $80964b808e73c619$export$4817c67cb84dd1b6 extends (0, $13wKd.DefaultSolanaSigner) {
    constructor(provider){
        super(provider);
    }
    async signMessage(msg) {
        const encoder = new TextEncoder();
        const messageBytes = encoder.encode(msg);
        // Used any instead of Solflare because there is an issue in type of `signTransaction` method of Solflare
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const messageSignature = await this.provider.signMessage(messageBytes, 'utf8');
        return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(messageSignature.signature);
    }
}


async function $ef0cc1019a5338fa$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $80964b808e73c619$export$4817c67cb84dd1b6)(solProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $8a41a9b41ffd3920$export$9ecb1260657d2501() {
    const instances = new Map();
    const { solflare: solflare } = window;
    if (!solflare) return null;
    instances.set((0, $9HEDW.LegacyNetworks).SOLANA, solflare);
    return instances;
}
function $8a41a9b41ffd3920$export$62115b9164fa6f77() {
    const instances = $8a41a9b41ffd3920$export$9ecb1260657d2501();
    if (!instances) throw new Error('Solflare Wallet is not injected. Please check your wallet.');
    return instances;
}
function $8a41a9b41ffd3920$export$c03c524f6cf72e38() {
    const instance = $8a41a9b41ffd3920$export$9ecb1260657d2501();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('Solflare Wallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}


const $22e45b3bbf68a017$export$7c460c214963f696 = 'solflare';
const $22e45b3bbf68a017$export$20f81dafcc53c9d4 = 1000;
const $22e45b3bbf68a017$export$dbb5e893e736e4ee = {
    name: 'Solflare',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/solflare/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/solflare-wallet/bhhhlbepdkbapadjdnnojkbgioiodbic',
        brave: 'https://chromewebstore.google.com/detail/solflare-wallet/bhhhlbepdkbapadjdnnojkbgioiodbic',
        firefox: 'https://addons.mozilla.org/en-US/firefox/addon/solflare-wallet/',
        edge: 'https://chromewebstore.google.com/detail/solflare-wallet/bhhhlbepdkbapadjdnnojkbgioiodbic',
        homepage: 'https://solflare.com'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $ef0cc1019a5338fa$export$2e2bcd8739ae039)((0, $8a41a9b41ffd3920$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


function $8027f3356632fa9e$var$connect(instance) {
    return async ()=>{
        const solanaInstance = instance();
        const isConnected = await solanaInstance.connect();
        if (!isConnected) throw new Error('Connecting to solana has been failed');
        return (0, $3b5535826a909102$export$eab97d15b1788b8d).formatAccountsToCAIP([
            solanaInstance.publicKey.toString()
        ]);
    };
}
function $8027f3356632fa9e$var$canEagerConnect(instance) {
    return ()=>{
        const solanaInstance = instance();
        if (!solanaInstance) throw new Error('Trying to eagerly connect to your Solana wallet, but seems its instance is not available.');
        return solanaInstance.isConnected;
    };
}
const $8027f3356632fa9e$export$43912867441655c2 = {
    canEagerConnect: $8027f3356632fa9e$var$canEagerConnect,
    connect: $8027f3356632fa9e$var$connect
};



function $ec02bba9acecc245$var$getDisconnectSubscriber(instance) {
    let eventCallback;
    // subscriber can be passed to `or`, it will get the error and should rethrow error to pass the error to next `or` or throw error.
    return [
        (context, err)=>{
            const solanaInstance = instance();
            if (!solanaInstance) throw new Error('Trying to subscribe to your Solana wallet, but seems its instance is not available.');
            eventCallback = ()=>{
                context.action('disconnect');
            };
            solanaInstance.on('disconnect', eventCallback);
            if (err instanceof Error) throw err;
        },
        (_context, err)=>{
            const solanaInstance = instance();
            if (eventCallback && solanaInstance) solanaInstance.removeListener('disconnect', eventCallback);
            return err;
        }
    ];
}
const $ec02bba9acecc245$export$38e18f39d221f642 = {
    getDisconnectSubscriber: $ec02bba9acecc245$var$getDisconnectSubscriber
};



const [$5b1d0f1e69203d8c$var$changeAccountSubscriber, $5b1d0f1e69203d8c$var$changeAccountCleanup] = (0, $3b5535826a909102$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $8a41a9b41ffd3920$export$c03c524f6cf72e38));
const [$5b1d0f1e69203d8c$var$disconnectSubscriber, $5b1d0f1e69203d8c$var$disconnectCleanUp] = (0, $ec02bba9acecc245$export$38e18f39d221f642).getDisconnectSubscriber((0, $8a41a9b41ffd3920$export$c03c524f6cf72e38));
const $5b1d0f1e69203d8c$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $8027f3356632fa9e$export$43912867441655c2).connect((0, $8a41a9b41ffd3920$export$c03c524f6cf72e38))).before($5b1d0f1e69203d8c$var$changeAccountSubscriber).before($5b1d0f1e69203d8c$var$disconnectSubscriber).or($5b1d0f1e69203d8c$var$changeAccountCleanup).or($5b1d0f1e69203d8c$var$disconnectCleanUp).or((0, $f59Be.standardizeAndThrowError)).build();
const $5b1d0f1e69203d8c$var$disconnect = (0, $f59Be.builders).disconnect().and($5b1d0f1e69203d8c$var$disconnectCleanUp).after($5b1d0f1e69203d8c$var$changeAccountCleanup).build();
const $5b1d0f1e69203d8c$var$canEagerConnect = new (0, $fha7R.ActionBuilder)('canEagerConnect').action((0, $8027f3356632fa9e$export$43912867441655c2).canEagerConnect((0, $8a41a9b41ffd3920$export$c03c524f6cf72e38))).build();
const $5b1d0f1e69203d8c$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $22e45b3bbf68a017$export$7c460c214963f696)).action($5b1d0f1e69203d8c$var$connect).action($5b1d0f1e69203d8c$var$disconnect).action($5b1d0f1e69203d8c$var$canEagerConnect).build();



const $9866a001fea36138$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $22e45b3bbf68a017$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $8a41a9b41ffd3920$export$9ecb1260657d2501)()) {
                setState('installed', true);
                console.debug('[solflare] instance detected.', context);
            }
        }, (0, $22e45b3bbf68a017$export$20f81dafcc53c9d4));
    }).config('metadata', (0, $22e45b3bbf68a017$export$dbb5e893e736e4ee)).add('solana', (0, $5b1d0f1e69203d8c$export$ee6400bf8f8c2a0d)).build();


const $6f18c8d3d270ce49$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $9866a001fea36138$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $ead94cb6d615d760$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $3ae87408e7ee95c4$export$a6e3712902d7179d() {
    const { tally: tally } = window;
    if (!tally) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, tally);
    return instances;
}
function $3ae87408e7ee95c4$export$62115b9164fa6f77() {
    const instances = $3ae87408e7ee95c4$export$a6e3712902d7179d();
    if (!instances) throw new Error('Taho Wallet is not injected. Please check your wallet.');
    return instances;
}
function $3ae87408e7ee95c4$export$3c176b4a097c144e() {
    const instances = $3ae87408e7ee95c4$export$a6e3712902d7179d();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Taho Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}


const $d2a9baed4a2c1451$export$b84c8372c2f5f68b = [
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).OPTIMISM,
    (0, $9HEDW.LegacyNetworks).ARBITRUM,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN,
    (0, $9HEDW.LegacyNetworks).BSC
];
const $d2a9baed4a2c1451$export$7c460c214963f696 = 'taho';
const $d2a9baed4a2c1451$export$dbb5e893e736e4ee = {
    name: 'Taho',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/taho/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/taho/eajafomhmkipbjmfmhebemolkcicgfmd',
        brave: 'https://chrome.google.com/webstore/detail/taho/eajafomhmkipbjmfmhebemolkcicgfmd',
        homepage: 'https://taho.xyz'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((blockchainMeta)=>$d2a9baed4a2c1451$export$b84c8372c2f5f68b.includes(blockchainMeta.name))
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $ead94cb6d615d760$export$2e2bcd8739ae039)((0, $3ae87408e7ee95c4$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$b73259ee8152ffa7$var$changeAccountSubscriber, $b73259ee8152ffa7$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $3ae87408e7ee95c4$export$3c176b4a097c144e));
const $b73259ee8152ffa7$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $3ae87408e7ee95c4$export$3c176b4a097c144e))).before($b73259ee8152ffa7$var$changeAccountSubscriber).or($b73259ee8152ffa7$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $b73259ee8152ffa7$var$disconnect = (0, $f59Be.builders).disconnect().after($b73259ee8152ffa7$var$changeAccountCleanup).build();
const $b73259ee8152ffa7$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $b73259ee8152ffa7$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $3ae87408e7ee95c4$export$3c176b4a097c144e))).build();
const $b73259ee8152ffa7$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $3ae87408e7ee95c4$export$3c176b4a097c144e))).build();
const $b73259ee8152ffa7$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $d2a9baed4a2c1451$export$7c460c214963f696)).action($b73259ee8152ffa7$var$connect).action($b73259ee8152ffa7$var$disconnect).action($b73259ee8152ffa7$var$canEagerConnect).action($b73259ee8152ffa7$var$canSwitchNetwork).action($b73259ee8152ffa7$var$getChainId).build();



const $542ec3ddd13e7589$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $d2a9baed4a2c1451$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $3ae87408e7ee95c4$export$a6e3712902d7179d)()) {
            setState('installed', true);
            console.debug('[taho] instance detected.', context);
        }
    }).config('metadata', (0, $d2a9baed4a2c1451$export$dbb5e893e736e4ee)).add('evm', (0, $b73259ee8152ffa7$export$2f7490c34b49803e)).build();


const $bd2a0e2574af9718$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $542ec3ddd13e7589$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $e862d12a077827dd$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $16639c7cd6ea6b47$export$2c5714fd929933ad() {
    const { tokenpocket: tokenpocket } = window;
    const ethereum = tokenpocket?.ethereum;
    if (!ethereum) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, ethereum);
    return instances;
}
function $16639c7cd6ea6b47$export$62115b9164fa6f77() {
    const instances = $16639c7cd6ea6b47$export$2c5714fd929933ad();
    if (!instances) throw new Error('TokenPocket Wallet is not injected. Please check your wallet.');
    return instances;
}
function $16639c7cd6ea6b47$export$9af585641665d701() {
    const instances = $16639c7cd6ea6b47$export$2c5714fd929933ad();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('TokenPocket Wallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}


const $e32336225916cb5e$export$7c460c214963f696 = 'token-pocket';
const $e32336225916cb5e$export$dbb5e893e736e4ee = {
    name: 'Token Pocket',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tokenpocket/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii',
        brave: 'https://chrome.google.com/webstore/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii',
        homepage: 'https://www.tokenpocket.pro/en/download/app'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $e862d12a077827dd$export$2e2bcd8739ae039)((0, $16639c7cd6ea6b47$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$83788af09263ae36$var$changeAccountSubscriber, $83788af09263ae36$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $16639c7cd6ea6b47$export$9af585641665d701));
const $83788af09263ae36$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $16639c7cd6ea6b47$export$9af585641665d701))).before($83788af09263ae36$var$changeAccountSubscriber).or($83788af09263ae36$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $83788af09263ae36$var$disconnect = (0, $f59Be.builders).disconnect().after($83788af09263ae36$var$changeAccountCleanup).build();
const $83788af09263ae36$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $83788af09263ae36$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $16639c7cd6ea6b47$export$9af585641665d701))).build();
const $83788af09263ae36$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $16639c7cd6ea6b47$export$9af585641665d701))).build();
const $83788af09263ae36$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $e32336225916cb5e$export$7c460c214963f696)).action($83788af09263ae36$var$connect).action($83788af09263ae36$var$disconnect).action($83788af09263ae36$var$canEagerConnect).action($83788af09263ae36$var$canSwitchNetwork).action($83788af09263ae36$var$getChainId).build();



const $f5df0e356990e88b$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $e32336225916cb5e$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $16639c7cd6ea6b47$export$2c5714fd929933ad)()) {
            setState('installed', true);
            console.debug('[token-pocket] instance detected.', context);
        }
    }).config('metadata', (0, $e32336225916cb5e$export$dbb5e893e736e4ee)).add('evm', (0, $83788af09263ae36$export$2f7490c34b49803e)).build();


const $b49c1afa5c798896$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $f5df0e356990e88b$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $2552319319075f07$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
function $07d66752c3149653$export$80e00309bbc24489() {
    const { tomo_evm: tomo_evm } = window;
    if (!tomo_evm) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, tomo_evm);
    return instances;
}
function $07d66752c3149653$export$62115b9164fa6f77() {
    const instances = $07d66752c3149653$export$80e00309bbc24489();
    if (!instances) throw new Error('Tomo is not injected. Please check your wallet.');
    return instances;
}
function $07d66752c3149653$export$e16c516de248f665() {
    const instances = $07d66752c3149653$export$80e00309bbc24489();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('Tomo not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}


const $3fb1826612b61e03$export$7c460c214963f696 = (0, $9cRHO.WalletTypes).TOMO;
const $3fb1826612b61e03$export$618aac217f28709b = 1000;
const $3fb1826612b61e03$export$dbb5e893e736e4ee = {
    name: 'Tomo',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tomo/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/tomo-wallet/pfccjkejcgoppjnllalolplgogenfojk?hl=en',
        brave: 'https://chromewebstore.google.com/detail/tomo-wallet/pfccjkejcgoppjnllalolplgogenfojk?hl=en',
        homepage: 'https://tomo.inc/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'single',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $2552319319075f07$export$2e2bcd8739ae039)((0, $07d66752c3149653$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$c188c165af228427$var$changeAccountSubscriber, $c188c165af228427$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$aea8daed5328d69c).changeAccountSubscriber((0, $07d66752c3149653$export$e16c516de248f665)).build();
const $c188c165af228427$var$connect = new (0, $fha7R.ActionBuilder)('connect').action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $07d66752c3149653$export$e16c516de248f665)))/*
   * Tomo Wallet's `connect` returns a list where the currently selected account
   * is always the first item. We're directly taking this first item as the active account.
   *
   * ***NOTE***: Please keep it synced with `wallets/core/src/namespaces/evm/builders.ts`.
   *
   */ .and((_, connectResult)=>({
        ...connectResult,
        accounts: [
            connectResult.accounts[0]
        ]
    })).and((0, $f59Be.connectAndUpdateStateForMultiNetworks)).before((0, $f59Be.intoConnecting)).before($c188c165af228427$var$changeAccountSubscriber).or($c188c165af228427$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).after((0, $f59Be.intoConnectionFinished)).build();
const $c188c165af228427$var$canEagerConnect = (0, $795b2611c2574d92$export$aea8daed5328d69c).canEagerConnect().action((0, $795b2611c2574d92$export$e324594224ef24da).canEagerConnect((0, $07d66752c3149653$export$e16c516de248f665))).build();
const $c188c165af228427$var$disconnect = (0, $f59Be.builders).disconnect().after($c188c165af228427$var$changeAccountCleanup).build();
const $c188c165af228427$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $c188c165af228427$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $07d66752c3149653$export$e16c516de248f665))).build();
const $c188c165af228427$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $3fb1826612b61e03$export$7c460c214963f696)).action($c188c165af228427$var$connect).action($c188c165af228427$var$disconnect).action($c188c165af228427$var$canSwitchNetwork).action($c188c165af228427$var$canEagerConnect).action($c188c165af228427$var$getChainId).build();



const $bd1594d52457a247$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $3fb1826612b61e03$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $07d66752c3149653$export$80e00309bbc24489)()) {
                setState('installed', true);
                console.debug('[tomo] instance detected.', context);
            }
        }, (0, $3fb1826612b61e03$export$618aac217f28709b));
    }).config('metadata', (0, $3fb1826612b61e03$export$dbb5e893e736e4ee)).add('evm', (0, $c188c165af228427$export$2f7490c34b49803e)).build();


const $1b0c59c17e6e6043$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $bd1594d52457a247$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $d2a0080b086d89a8$export$2e2bcd8739ae039(provider) {
    const tonProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).TON);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { CustomTonSigner: CustomTonSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("b8Trg")));
    signers.registerSigner((0, $9B1kL.TransactionType).TON, new CustomTonSigner(tonProvider));
    return signers;
}


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");

class $9061e246ecb68654$export$8ed287f6d2e626c7 {
    #tonModule;
    #tonConnectInstance;
    async initialize(env) {
        if (!env) throw new Error('Environments are not set');
        this.#tonModule = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("gkNEl")));
        const { TonConnectUI: TonConnectUI } = this.#tonModule;
        this.#tonConnectInstance = new TonConnectUI(env);
    }
    getInstance() {
        if (!this.#tonConnectInstance) throw new Error("TonConnect instance isn't initialized. Please ensure you have provided the TonConnect config.");
        return this.#tonConnectInstance;
    }
    getModule() {
        if (!this.#tonModule) throw new Error("Couldn't initialize the TonConnect module");
        return this.#tonModule;
    }
    async waitForConnection() {
        const tonConnectUI = this.getInstance();
        return new Promise((resolve, reject)=>{
            const unsubscribeStatusChange = tonConnectUI.onStatusChange((state)=>{
                const walletConnected = !!state?.account.address;
                if (walletConnected) {
                    unsubscribe();
                    resolve(state.account.address);
                }
            }, (error)=>{
                unsubscribe();
                reject(error);
            });
            const unsubscribeModalStateChange = tonConnectUI.onModalStateChange((modalState)=>{
                if (modalState.closeReason === 'action-cancelled') {
                    unsubscribe();
                    reject(new Error('The action was canceled by the user'));
                }
            });
            const unsubscribe = ()=>{
                unsubscribeStatusChange();
                unsubscribeModalStateChange();
            };
        });
    }
}


const $5d6015ea4fcdee65$export$5e6671a5f79470db = new (0, $9061e246ecb68654$export$8ed287f6d2e626c7)();
function $5d6015ea4fcdee65$export$62115b9164fa6f77() {
    const instance = $5d6015ea4fcdee65$export$5e6671a5f79470db.getInstance();
    const instances = new Map([
        [
            (0, $9HEDW.LegacyNetworks).TON,
            instance
        ]
    ]);
    return instances;
}


const $91112cd84c260583$export$7c460c214963f696 = (0, $9cRHO.WalletTypes).TON_CONNECT;
const $91112cd84c260583$export$dbb5e893e736e4ee = {
    name: 'TON Connect',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/7fb19ed5d5019b4d6a41ce91b39cde64f86af4c6/wallets/tonconnect/icon.svg',
    extensions: {
        homepage: 'https://docs.ton.org/ecosystem/ton-connect/overview'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'single',
                data: [
                    {
                        label: 'Ton',
                        value: 'Ton',
                        id: 'TON',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.tonBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $d2a0080b086d89a8$export$2e2bcd8739ae039)((0, $5d6015ea4fcdee65$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $3ca9q = parcelRequire("3ca9q");
var $d90f58c84ad0ffac$var$c = Object.defineProperty;
var $d90f58c84ad0ffac$var$e = (n, t)=>$d90f58c84ad0ffac$var$c(n, "name", {
        value: t,
        configurable: !0
    });
var $d90f58c84ad0ffac$var$a = (n, t)=>{
    for(var o in t)$d90f58c84ad0ffac$var$c(n, o, {
        get: t[o],
        enumerable: !0
    });
};
var $d90f58c84ad0ffac$export$eab97d15b1788b8d = {};
$d90f58c84ad0ffac$var$a($d90f58c84ad0ffac$export$eab97d15b1788b8d, {
    formatAccountsToCAIP: ()=>$d90f58c84ad0ffac$var$A
});
var $d90f58c84ad0ffac$export$c67e5a7ce034264a = "tvm", $d90f58c84ad0ffac$export$6128b9ca05d1430c = "-239";
function $d90f58c84ad0ffac$var$A(n) {
    return n.map((t)=>(0, $3ca9q.AccountId).format({
            address: t.toString(),
            chainId: {
                namespace: $d90f58c84ad0ffac$export$c67e5a7ce034264a,
                reference: $d90f58c84ad0ffac$export$6128b9ca05d1430c
            }
        }));
}
$d90f58c84ad0ffac$var$e($d90f58c84ad0ffac$var$A, "formatAccountsToCAIP");
var $d90f58c84ad0ffac$export$aea8daed5328d69c = {};
$d90f58c84ad0ffac$var$a($d90f58c84ad0ffac$export$aea8daed5328d69c, {
    canEagerConnect: ()=>$d90f58c84ad0ffac$var$y,
    connect: ()=>$d90f58c84ad0ffac$var$T
});
var $d90f58c84ad0ffac$var$r = class {
    static{
        $d90f58c84ad0ffac$var$e(this, "ActionBuilder");
    }
    name;
    #t = new Map;
    #e = new Map;
    #n = new Map;
    #o = new Map;
    #r;
    constructor(t){
        this.name = t;
    }
    and(t) {
        return this.#t.has(this.name) || this.#t.set(this.name, []), this.#t.get(this.name)?.push(t), this;
    }
    or(t) {
        return this.#e.has(this.name) || this.#e.set(this.name, []), this.#e.get(this.name)?.push(t), this;
    }
    before(t) {
        return this.#o.has(this.name) || this.#o.set(this.name, []), this.#o.get(this.name)?.push(t), this;
    }
    after(t) {
        return this.#n.has(this.name) || this.#n.set(this.name, []), this.#n.get(this.name)?.push(t), this;
    }
    action(t) {
        return this.#r = t, this;
    }
    build() {
        if (!this.#r) throw new Error("Your action builder should includes an action.");
        return {
            actionName: this.name,
            action: this.#r,
            before: this.#o,
            after: this.#n,
            and: this.#t,
            or: this.#e
        };
    }
};
function $d90f58c84ad0ffac$var$u(n) {
    let [, t] = n.state();
    t("connecting", !1);
}
$d90f58c84ad0ffac$var$e($d90f58c84ad0ffac$var$u, "intoConnectionFinished");
function $d90f58c84ad0ffac$var$m(n) {
    try {
        return (0, $3ca9q.AccountId).parse(n), !0;
    } catch  {
        return !1;
    }
}
$d90f58c84ad0ffac$var$e($d90f58c84ad0ffac$var$m, "isValidCaipAddress");
function $d90f58c84ad0ffac$var$h(n, t) {
    if (!t.every($d90f58c84ad0ffac$var$m)) throw new Error(`Your provider should format account addresses in CAIP-10 format. Your provided accounts: ${t}`);
    let [, o] = n.state();
    return o("accounts", t), o("connected", !0), t;
}
$d90f58c84ad0ffac$var$e($d90f58c84ad0ffac$var$h, "connectAndUpdateStateForSingleNetwork");
function $d90f58c84ad0ffac$var$d(n) {
    let [, t] = n.state();
    t("connecting", !0);
}
$d90f58c84ad0ffac$var$e($d90f58c84ad0ffac$var$d, "intoConnecting");
var $d90f58c84ad0ffac$var$T = $d90f58c84ad0ffac$var$e(()=>new $d90f58c84ad0ffac$var$r("connect").and($d90f58c84ad0ffac$var$h).before($d90f58c84ad0ffac$var$d).after($d90f58c84ad0ffac$var$u), "connect"), $d90f58c84ad0ffac$var$y = $d90f58c84ad0ffac$var$e(()=>new $d90f58c84ad0ffac$var$r("canEagerConnect"), "canEagerConnect");




function $a3098dd4311c3567$export$64605811ab45167f(getInstance) {
    return async ()=>{
        const tonInstance = getInstance();
        const connectionRestored = await tonInstance.connectionRestored;
        const { toUserFriendlyAddress: toUserFriendlyAddress } = (0, $5d6015ea4fcdee65$export$5e6671a5f79470db).getModule();
        let userFriendlyAddress;
        if (connectionRestored && tonInstance.account?.address) userFriendlyAddress = toUserFriendlyAddress(tonInstance.account.address);
        else {
            await tonInstance.openModal();
            const result = await (0, $5d6015ea4fcdee65$export$5e6671a5f79470db).waitForConnection();
            userFriendlyAddress = toUserFriendlyAddress(result);
        }
        return (0, $d90f58c84ad0ffac$export$eab97d15b1788b8d).formatAccountsToCAIP([
            userFriendlyAddress
        ]);
    };
}
function $a3098dd4311c3567$export$be9f3c5ed1d25e42(getInstance) {
    return async ()=>{
        const tonConnectUI = getInstance();
        const connectionRestored = await tonConnectUI.connectionRestored;
        return connectionRestored;
    };
}
const $a3098dd4311c3567$export$cc1523b064b2cee1 = {
    connect: $a3098dd4311c3567$export$64605811ab45167f,
    canEagerConnect: $a3098dd4311c3567$export$be9f3c5ed1d25e42
};




function $0b5542191d975665$var$getDisconnectSubscriber(instance) {
    let eventCallback;
    let unsubscribe;
    // subscriber can be passed to `or`, it will get the error and should rethrow error to pass the error to next `or` or throw error.
    return [
        (context, err)=>{
            const tonInstance = instance();
            if (!tonInstance) throw new Error('Trying to subscribe to your Ton wallet, but seems its instance is not available.');
            eventCallback = (wallet)=>{
                if (!wallet) context.action('disconnect');
            };
            unsubscribe = tonInstance.onStatusChange(eventCallback);
            if (err instanceof Error) throw err;
        },
        (_, err)=>{
            if (unsubscribe) unsubscribe();
            return err;
        }
    ];
}
async function $0b5542191d975665$export$922257654df9c424(_) {
    const tonInstance = (0, $5d6015ea4fcdee65$export$5e6671a5f79470db).getInstance();
    if (tonInstance.connected) await tonInstance.disconnect();
}
const $0b5542191d975665$export$269b3db55d5ec782 = {
    getDisconnectSubscriber: $0b5542191d975665$var$getDisconnectSubscriber,
    handleProviderDisconnect: $0b5542191d975665$export$922257654df9c424
};



const [$dd75d0f606cf828a$var$disconnectSubscriber, $dd75d0f606cf828a$var$disconnectCleanUp] = (0, $0b5542191d975665$export$269b3db55d5ec782).getDisconnectSubscriber((0, $5d6015ea4fcdee65$export$5e6671a5f79470db).getInstance.bind((0, $5d6015ea4fcdee65$export$5e6671a5f79470db)));
const $dd75d0f606cf828a$var$connect = (0, $d90f58c84ad0ffac$export$aea8daed5328d69c).connect().action((0, $a3098dd4311c3567$export$cc1523b064b2cee1).connect((0, $5d6015ea4fcdee65$export$5e6671a5f79470db).getInstance.bind((0, $5d6015ea4fcdee65$export$5e6671a5f79470db)))).and($dd75d0f606cf828a$var$disconnectSubscriber).or($dd75d0f606cf828a$var$disconnectCleanUp).or((0, $f59Be.standardizeAndThrowError)).build();
const $dd75d0f606cf828a$var$canEagerConnect = (0, $d90f58c84ad0ffac$export$aea8daed5328d69c).canEagerConnect().action((0, $a3098dd4311c3567$export$cc1523b064b2cee1).canEagerConnect((0, $5d6015ea4fcdee65$export$5e6671a5f79470db).getInstance.bind((0, $5d6015ea4fcdee65$export$5e6671a5f79470db)))).build();
const $dd75d0f606cf828a$var$disconnect = (0, $f59Be.builders).disconnect().before((0, $0b5542191d975665$export$269b3db55d5ec782).handleProviderDisconnect).after($dd75d0f606cf828a$var$disconnectCleanUp).build();
const $dd75d0f606cf828a$export$dcab28a09063a5d7 = new (0, $at2GJ.NamespaceBuilder)('Ton', (0, $91112cd84c260583$export$7c460c214963f696)).action($dd75d0f606cf828a$var$connect).action($dd75d0f606cf828a$var$disconnect).action($dd75d0f606cf828a$var$canEagerConnect).build();



const $8da3e659a4caaa25$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $91112cd84c260583$export$7c460c214963f696)).init(function(context, environments) {
        const [, setState] = context.state();
        async function initializeTon() {
            try {
                await (0, $5d6015ea4fcdee65$export$5e6671a5f79470db).initialize(environments);
                console.debug('[ton] instance initialized.', context);
                setState('installed', true);
            } catch (err) {
                console.warn('[ton] failed to initialize TonConnect:', err);
            }
        }
        initializeTon();
    }).config('metadata', (0, $91112cd84c260583$export$dbb5e893e736e4ee)).add('ton', (0, $dd75d0f606cf828a$export$dcab28a09063a5d7)).build();


const $c1b8e30c78f1cf4e$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $8da3e659a4caaa25$export$afa934a86232cabe)()).build();


var $9f9be13dfd5d2b11$exports = {};

$parcel$export($9f9be13dfd5d2b11$exports, "config", function () { return $9f9be13dfd5d2b11$export$e506a1d27d1eaa20; });
$parcel$export($9f9be13dfd5d2b11$exports, "init", function () { return $9f9be13dfd5d2b11$export$2cd8252107eb640b; });
$parcel$export($9f9be13dfd5d2b11$exports, "getInstance", function () { return $9f9be13dfd5d2b11$export$8bedcca5bbd73999; });
$parcel$export($9f9be13dfd5d2b11$exports, "connect", function () { return $9f9be13dfd5d2b11$export$64605811ab45167f; });
$parcel$export($9f9be13dfd5d2b11$exports, "getSigners", function () { return $9f9be13dfd5d2b11$export$6352a17a50193ded; });
$parcel$export($9f9be13dfd5d2b11$exports, "getWalletInfo", function () { return $9f9be13dfd5d2b11$export$e5b9d96c6aeb3ff7; });
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");

var $2D1Ig = parcelRequire("2D1Ig");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $84411cc5650583f4$export$2e2bcd8739ae039() {
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { EthereumSigner: EthereumSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("jldXD")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new EthereumSigner());
    return signers;
}



var $9kvMd = parcelRequire("9kvMd");
let $9f9be13dfd5d2b11$var$trezorManifest = {
    appUrl: '',
    email: ''
};
const $9f9be13dfd5d2b11$export$e506a1d27d1eaa20 = {
    type: (0, $9cRHO.WalletTypes).TREZOR
};
const $9f9be13dfd5d2b11$export$2cd8252107eb640b = (environments)=>{
    $9f9be13dfd5d2b11$var$trezorManifest = environments.manifest;
};
const $9f9be13dfd5d2b11$export$8bedcca5bbd73999 = (0, $2D1Ig.getTrezorInstance);
let $9f9be13dfd5d2b11$var$isTrezorInitialized = false;
const $9f9be13dfd5d2b11$export$64605811ab45167f = async ({ namespaces: namespaces })=>{
    const results = [];
    const TrezorConnect = await (0, $2D1Ig.getTrezorModule)();
    const evmNamespace = namespaces?.find((namespaceItem)=>namespaceItem.namespace === 'EVM');
    if (evmNamespace) {
        if (evmNamespace.derivationPath) {
            (0, $9kvMd.setDerivationPath)((0, $2D1Ig.getTrezorNormalizedDerivationPath)(evmNamespace.derivationPath));
            if (!$9f9be13dfd5d2b11$var$isTrezorInitialized) {
                await TrezorConnect.init({
                    lazyLoad: true,
                    manifest: $9f9be13dfd5d2b11$var$trezorManifest
                });
                $9f9be13dfd5d2b11$var$isTrezorInitialized = true;
            }
            const accounts = await (0, $2D1Ig.getEthereumAccounts)();
            results.push(accounts);
        } else throw new Error('Derivation Path can not be empty.');
    } else throw new Error(`It appears that you have selected a namespace that is not yet supported by our system. Your namespaces: ${namespaces?.map((namespaceItem)=>namespaceItem.namespace)}`);
    return results;
};
const $9f9be13dfd5d2b11$export$6352a17a50193ded = (0, $84411cc5650583f4$export$2e2bcd8739ae039);
const $9f9be13dfd5d2b11$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedChains = [];
    const ethereumBlockchain = allBlockChains.find((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (ethereumBlockchain) supportedChains.push(ethereumBlockchain);
    return {
        name: 'Trezor',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/trezor/icon.svg',
        installLink: {
            DEFAULT: 'https://trezor.io/learn/a/download-verify-trezor-suite'
        },
        color: 'black',
        supportedChains: supportedChains,
        showOnMobile: false,
        needsNamespace: {
            selection: 'single',
            data: [
                {
                    id: 'ETH',
                    value: 'EVM',
                    label: 'Ethereum',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).ETHEREUM)
                }
            ]
        },
        needsDerivationPath: {
            data: [
                {
                    id: 'metamask',
                    label: `Metamask (m/44'/60'/0'/0/index)`,
                    namespace: 'EVM',
                    generateDerivationPath: (index)=>`44'/60'/0'/0/${index}`
                },
                {
                    id: 'ledgerLive',
                    label: `LedgerLive (m/44'/60'/index'/0/0)`,
                    namespace: 'EVM',
                    generateDerivationPath: (index)=>`44'/60'/${index}'/0/0`
                },
                {
                    id: 'legacy',
                    label: `Legacy (m/44'/60'/0'/index)`,
                    namespace: 'EVM',
                    generateDerivationPath: (index)=>`44'/60'/0'/${index}`
                },
                {
                    id: `(m/44'/501'/index')`,
                    label: `(m/44'/501'/index')`,
                    namespace: 'Solana',
                    generateDerivationPath: (index)=>`44'/501'/${index}'`
                },
                {
                    id: `(m/44'/501'/0'/index)`,
                    label: `(m/44'/501'/0'/index)`,
                    namespace: 'Solana',
                    generateDerivationPath: (index)=>`44'/501'/0'/${index}`
                }
            ]
        }
    };
};



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $dfe2996fef1405e6$export$2e2bcd8739ae039(provider) {
    const tronProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).TRON);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultTronSigner: DefaultTronSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("cCZtf")));
    signers.registerSigner((0, $9B1kL.TransactionType).TRON, new DefaultTronSigner(tronProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $3317d9edd94f1e1f$export$8c91bb610eb9ab6b() {
    const instances = new Map();
    const { tronLink: tronLink } = window;
    if (!tronLink) return null;
    instances.set((0, $9HEDW.LegacyNetworks).TRON, tronLink);
    return instances;
}
function $3317d9edd94f1e1f$export$62115b9164fa6f77() {
    const instances = $3317d9edd94f1e1f$export$8c91bb610eb9ab6b();
    if (!instances) throw new Error('TronLink is not injected. Please check your wallet.');
    return instances;
}
function $3317d9edd94f1e1f$export$c8bc6d5470264c6f() {
    const instance = $3317d9edd94f1e1f$export$8c91bb610eb9ab6b();
    const tronInstance = instance?.get((0, $9HEDW.LegacyNetworks).TRON);
    if (!tronInstance) throw new Error('TronLink not injected or Tron not enabled. Please check your wallet.');
    return tronInstance;
}


const $56ffc56a6d6d17a1$export$7c460c214963f696 = 'tron-link';
const $56ffc56a6d6d17a1$export$b2fbad1e9ff26ff3 = 200;
const $56ffc56a6d6d17a1$export$afb2409f7e157308 = 1000;
const $56ffc56a6d6d17a1$export$dbb5e893e736e4ee = {
    name: 'TronLink',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tronlink/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec',
        brave: 'https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec',
        homepage: 'https://www.tronlink.org'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'Tron',
                        value: 'Tron',
                        id: 'TRON',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.tronBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $dfe2996fef1405e6$export$2e2bcd8739ae039)((0, $3317d9edd94f1e1f$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");


const $19a10446b3f5c280$var$canEagerConnectAction = ()=>{
    const tronInstance = (0, $3317d9edd94f1e1f$export$c8bc6d5470264c6f)();
    // Making sure that the Tron instance is available first to prevent errors.
    if (!tronInstance) throw new Error('Trying to eagerly connect to your wallet, but seems its tron instance is not available.');
    return tronInstance.ready;
};
const $19a10446b3f5c280$export$b77666ae30db36c3 = {
    canEagerConnectAction: $19a10446b3f5c280$var$canEagerConnectAction
};



var $f59Be = parcelRequire("f59Be");


const $01a659f22988a299$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance).onSwitchAccount((event, context)=>{
        if (!event.payload?.data?.isTronLink || event.payload.data.message.action !== 'accountsChanged') {
            event.preventDefault();
            return;
        }
        if (!event.payload?.data?.message.data.address || !(0, $3317d9edd94f1e1f$export$c8bc6d5470264c6f)().ready) {
            event.preventDefault();
            context.action('connect').catch(()=>{
                console.debug('There were a problem during connecting');
            });
        }
    }).format(async (_, event)=>(0, $838c2177a0531a1c$export$eab97d15b1788b8d).formatAccountsToCAIP([
            event.data.message.data.address
        ])).addEventListener((_, callback)=>{
        window.addEventListener('message', callback);
    }).removeEventListener((_, callback)=>{
        window.removeEventListener('message', callback);
    });
const $01a659f22988a299$export$458c54615707a7bf = {
    changeAccountSubscriber: $01a659f22988a299$export$bc681aebb548377e
};




const [$83466b46246c57c6$var$changeAccountSubscriber, $83466b46246c57c6$var$changeAccountCleanup] = (0, $01a659f22988a299$export$458c54615707a7bf).changeAccountSubscriber((0, $3317d9edd94f1e1f$export$c8bc6d5470264c6f)).build();
const $83466b46246c57c6$var$connect = (0, $838c2177a0531a1c$export$aea8daed5328d69c).connect().action(async ()=>{
    const instance = (0, $3317d9edd94f1e1f$export$c8bc6d5470264c6f)();
    const accountsResult = await instance.request({
        method: 'tron_requestAccounts'
    });
    if (!accountsResult) throw new Error('Please unlock your TronLink extension first.');
    if (!!accountsResult?.code && !!accountsResult.message && accountsResult.code !== (0, $56ffc56a6d6d17a1$export$b2fbad1e9ff26ff3)) throw new Error(accountsResult.message);
    return (0, $838c2177a0531a1c$export$eab97d15b1788b8d).formatAccountsToCAIP([
        instance.tronWeb.defaultAddress.base58
    ]);
}).before($83466b46246c57c6$var$changeAccountSubscriber).or((0, $f59Be.standardizeAndThrowError)).or($83466b46246c57c6$var$changeAccountCleanup).build();
const $83466b46246c57c6$var$canEagerConnect = (0, $838c2177a0531a1c$export$aea8daed5328d69c).canEagerConnect().action((0, $19a10446b3f5c280$export$b77666ae30db36c3).canEagerConnectAction).build();
const $83466b46246c57c6$var$disconnect = (0, $f59Be.builders).disconnect().after($83466b46246c57c6$var$changeAccountCleanup).build();
const $83466b46246c57c6$export$861f0f2ab432c70 = new (0, $at2GJ.NamespaceBuilder)('Tron', (0, $56ffc56a6d6d17a1$export$7c460c214963f696)).action($83466b46246c57c6$var$connect).action($83466b46246c57c6$var$disconnect).action($83466b46246c57c6$var$canEagerConnect).build();



const $338f80d7ab5f7d4d$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $56ffc56a6d6d17a1$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        setTimeout(()=>{
            if ((0, $3317d9edd94f1e1f$export$8c91bb610eb9ab6b)()) {
                setState('installed', true);
                console.debug('[tron-link] instance detected.', context);
            }
        }, (0, $56ffc56a6d6d17a1$export$afb2409f7e157308));
    }).config('metadata', (0, $56ffc56a6d6d17a1$export$dbb5e893e736e4ee)).add('tron', (0, $83466b46246c57c6$export$861f0f2ab432c70)).build();


const $c9fefc9db13081bd$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $338f80d7ab5f7d4d$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");


async function $281ca880ff5b5d10$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("6c06I")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $8a68b06d5acae85f$export$9c52be32606cd1e4() {
    const { trustwallet: trustwallet } = window;
    if (!trustwallet || !(trustwallet?.isTrust || trustwallet?.isTrustWallet)) return null;
    const instances = new Map();
    instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, trustwallet);
    const { solana: solana } = trustwallet;
    if (solana && solana.isTrustWallet) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, solana);
    return instances;
}
function $8a68b06d5acae85f$export$62115b9164fa6f77() {
    const instances = $8a68b06d5acae85f$export$9c52be32606cd1e4();
    if (!instances) throw new Error('Trust Wallet is not injected. Please check your wallet.');
    return instances;
}
function $8a68b06d5acae85f$export$d195f05cbdbb587f() {
    const instances = $8a68b06d5acae85f$export$9c52be32606cd1e4();
    const evmInstance = instances?.get((0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (!evmInstance) throw new Error('TrustWallet not injected or EVM not enabled. Please check your wallet.');
    return evmInstance;
}
function $8a68b06d5acae85f$export$ab6cfe3f813b9fd() {
    const instance = $8a68b06d5acae85f$export$9c52be32606cd1e4();
    const solanaInstance = instance?.get((0, $9HEDW.LegacyNetworks).SOLANA);
    if (!solanaInstance) throw new Error('TrustWallet not injected or Solana not enabled. Please check your wallet.');
    return solanaInstance;
}
function $8a68b06d5acae85f$export$7b047f9bb81fcf7e(_context, error) {
    if (typeof error === 'string' && error === 'cancelled') {
        const error = new Error('User rejected the request');
        error.code = 4001;
        return error;
    }
    return error;
}


const $68811db5500a9d6b$var$WALLET = (0, $9cRHO.WalletTypes).TRUST_WALLET;
const $68811db5500a9d6b$export$e506a1d27d1eaa20 = {
    type: $68811db5500a9d6b$var$WALLET
};
const $68811db5500a9d6b$export$8bedcca5bbd73999 = (0, $8a68b06d5acae85f$export$9c52be32606cd1e4);
const $68811db5500a9d6b$export$64605811ab45167f = async ({ instance: instance })=>{
    const { accounts: accounts, chainId: chainId } = await (0, $gSYt0.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $68811db5500a9d6b$export$ec068583843480e7 = (0, $gSYt0.subscribeToEvm);
const $68811db5500a9d6b$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $68811db5500a9d6b$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $68811db5500a9d6b$export$6352a17a50193ded = (0, $281ca880ff5b5d10$export$2e2bcd8739ae039);
const $68811db5500a9d6b$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    const solana = (0, $hE77Y.solanaBlockchain)(allBlockChains);
    return {
        name: 'Trust Wallet',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/trustwallet/icon.svg',
        installLink: {
            CHROME: 'https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph',
            BRAVE: 'https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph',
            DEFAULT: 'https://trustwallet.com/browser-extension'
        },
        color: '#ffffff',
        supportedChains: [
            ...evms,
            ...solana
        ],
        needsNamespace: {
            selection: 'multiple',
            data: [
                {
                    label: 'EVM',
                    value: 'EVM',
                    id: 'ETH',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                },
                {
                    label: 'Solana',
                    value: 'Solana',
                    id: 'SOLANA',
                    getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                }
            ]
        }
    };
};
const $68811db5500a9d6b$export$107c8cc6b37a1ffa = ()=>({
        config: $68811db5500a9d6b$export$e506a1d27d1eaa20,
        getInstance: $68811db5500a9d6b$export$8bedcca5bbd73999,
        connect: $68811db5500a9d6b$export$64605811ab45167f,
        subscribe: $68811db5500a9d6b$export$ec068583843480e7,
        switchNetwork: $68811db5500a9d6b$export$f3473d805e486329,
        canSwitchNetworkTo: $68811db5500a9d6b$export$3b3cf9ab9019de20,
        getSigners: $68811db5500a9d6b$export$6352a17a50193ded,
        getWalletInfo: $68811db5500a9d6b$export$e5b9d96c6aeb3ff7
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");


const $6d711a5287db56c9$export$7c460c214963f696 = 'trust-wallet';
const $6d711a5287db56c9$export$dbb5e893e736e4ee = {
    name: 'Trust Wallet',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/trustwallet/icon.svg',
    extensions: {
        chrome: 'https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph',
        brave: 'https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph',
        homepage: 'https://trustwallet.com/browser-extension'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'multiple',
                data: [
                    {
                        label: 'EVM',
                        value: 'EVM',
                        id: 'ETH',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.evmBlockchains)(allBlockchains)
                    },
                    {
                        label: 'Solana',
                        value: 'Solana',
                        id: 'SOLANA',
                        getSupportedChains: (allBlockchains)=>(0, $hE77Y.solanaBlockchain)(allBlockchains)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $281ca880ff5b5d10$export$2e2bcd8739ae039)((0, $8a68b06d5acae85f$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$b24f690b9d3de811$var$changeAccountSubscriber, $b24f690b9d3de811$var$changeAccountCleanup] = (0, $795b2611c2574d92$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $8a68b06d5acae85f$export$d195f05cbdbb587f));
const $b24f690b9d3de811$var$connect = (0, $795b2611c2574d92$export$aea8daed5328d69c).connect().action((0, $795b2611c2574d92$export$e324594224ef24da).connect((0, $8a68b06d5acae85f$export$d195f05cbdbb587f))).before($b24f690b9d3de811$var$changeAccountSubscriber).or($b24f690b9d3de811$var$changeAccountCleanup).or((0, $8a68b06d5acae85f$export$7b047f9bb81fcf7e)).or((0, $f59Be.standardizeAndThrowError)).build();
const $b24f690b9d3de811$var$disconnect = (0, $f59Be.builders).disconnect().after($b24f690b9d3de811$var$changeAccountCleanup).build();
const $b24f690b9d3de811$var$canSwitchNetwork = (0, $795b2611c2574d92$export$aea8daed5328d69c).canSwitchNetwork().action((0, $795b2611c2574d92$export$e324594224ef24da).canSwitchNetwork()).build();
const $b24f690b9d3de811$var$getChainId = (0, $795b2611c2574d92$export$aea8daed5328d69c).getChainId().action((0, $795b2611c2574d92$export$e324594224ef24da).getChainId((0, $8a68b06d5acae85f$export$d195f05cbdbb587f))).build();
const $b24f690b9d3de811$export$2f7490c34b49803e = new (0, $at2GJ.NamespaceBuilder)('EVM', (0, $6d711a5287db56c9$export$7c460c214963f696)).action($b24f690b9d3de811$var$connect).action($b24f690b9d3de811$var$disconnect).action($b24f690b9d3de811$var$canSwitchNetwork).action($b24f690b9d3de811$var$getChainId).build();


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");



const [$87c8ecd175c8df91$var$changeAccountSubscriber, $87c8ecd175c8df91$var$changeAccountCleanup] = (0, $3b5535826a909102$export$11949c6f5fba7dcd).changeAccountSubscriber((0, $8a68b06d5acae85f$export$ab6cfe3f813b9fd));
const $87c8ecd175c8df91$var$connect = (0, $3b5535826a909102$export$aea8daed5328d69c).connect().action((0, $3b5535826a909102$export$e324594224ef24da).connect((0, $8a68b06d5acae85f$export$ab6cfe3f813b9fd))).before($87c8ecd175c8df91$var$changeAccountSubscriber).or($87c8ecd175c8df91$var$changeAccountCleanup).or((0, $8a68b06d5acae85f$export$7b047f9bb81fcf7e)).or((0, $f59Be.standardizeAndThrowError)).build();
const $87c8ecd175c8df91$var$disconnect = (0, $f59Be.builders).disconnect().after($87c8ecd175c8df91$var$changeAccountCleanup).build();
const $87c8ecd175c8df91$export$ee6400bf8f8c2a0d = new (0, $at2GJ.NamespaceBuilder)('Solana', (0, $6d711a5287db56c9$export$7c460c214963f696)).action($87c8ecd175c8df91$var$connect).action($87c8ecd175c8df91$var$disconnect).build();



const $bb4444667b092558$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $6d711a5287db56c9$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $8a68b06d5acae85f$export$9c52be32606cd1e4)()) {
            setState('installed', true);
            console.debug('[trustwallet] instance detected.', context);
        }
    }).config('metadata', (0, $6d711a5287db56c9$export$dbb5e893e736e4ee)).add('evm', (0, $b24f690b9d3de811$export$2f7490c34b49803e)).add('solana', (0, $87c8ecd175c8df91$export$ee6400bf8f8c2a0d)).build();


const $0c2e7f8a1d69d90b$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $68811db5500a9d6b$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $bb4444667b092558$export$afa934a86232cabe)()).build();




var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");

async function $09d8bcb1ccddcab1$export$2e2bcd8739ae039(provider) {
    const bitcoinInstance = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).BTC);
    const { BTCSigner: BTCSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("jqcuV")));
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new BTCSigner(bitcoinInstance));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $1845e434199bfc99$export$b42520d3cb063518() {
    const { unisat: unisat } = window;
    if (!unisat) return null;
    const instances = new Map();
    if (unisat) instances.set((0, $9HEDW.LegacyNetworks).BTC, unisat);
    return instances;
}
function $1845e434199bfc99$export$62115b9164fa6f77() {
    const instances = $1845e434199bfc99$export$b42520d3cb063518();
    if (!instances) throw new Error('Unisat is not injected. Please check your wallet.');
    return instances;
}
function $1845e434199bfc99$export$eacbd9e95432eb88() {
    const instances = $1845e434199bfc99$export$b42520d3cb063518();
    const bitcoinInstance = instances?.get((0, $9HEDW.LegacyNetworks).BTC);
    if (!bitcoinInstance) throw new Error('UniSat not injected. Please check your wallet.');
    return bitcoinInstance;
}


const $824e1109e09d5b6a$export$7c460c214963f696 = 'unisat';
const $824e1109e09d5b6a$export$dbb5e893e736e4ee = {
    name: 'UniSat',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/unisat/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/unisat-wallet/ppbibelpcjmhbdihakflkdcoccbgbkpo',
        homepage: 'https://unisat.io/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'single',
                data: [
                    {
                        label: 'BTC',
                        value: 'UTXO',
                        id: 'BTC',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $09d8bcb1ccddcab1$export$2e2bcd8739ae039)((0, $1845e434199bfc99$export$62115b9164fa6f77)())
            }
        }
    ]
};




const $da7afb993802de8d$var$config = {
    type: (0, $824e1109e09d5b6a$export$7c460c214963f696)
};
const $da7afb993802de8d$export$8bedcca5bbd73999 = (0, $1845e434199bfc99$export$b42520d3cb063518);
const $da7afb993802de8d$var$getWalletInfo = (allBlockChains)=>{
    const supportedChains = [];
    const btc = allBlockChains.find((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC);
    if (btc) supportedChains.push(btc);
    return {
        name: (0, $824e1109e09d5b6a$export$dbb5e893e736e4ee).name,
        img: (0, $824e1109e09d5b6a$export$dbb5e893e736e4ee).icon,
        installLink: {
            CHROME: (0, $824e1109e09d5b6a$export$dbb5e893e736e4ee).extensions.chrome,
            DEFAULT: (0, $824e1109e09d5b6a$export$dbb5e893e736e4ee).extensions.homepage || ''
        },
        color: '#e9983d',
        needsNamespace: {
            selection: 'multiple',
            data: [
                {
                    label: 'BTC',
                    value: 'UTXO',
                    id: 'BTC',
                    getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                }
            ]
        },
        supportedChains: supportedChains
    };
};
const $da7afb993802de8d$var$getSigners = (0, $09d8bcb1ccddcab1$export$2e2bcd8739ae039);
const $da7afb993802de8d$export$107c8cc6b37a1ffa = ()=>({
        config: $da7afb993802de8d$var$config,
        getWalletInfo: $da7afb993802de8d$var$getWalletInfo,
        connect: async ()=>{
            return [];
        },
        getInstance: $da7afb993802de8d$export$8bedcca5bbd73999,
        getSigners: $da7afb993802de8d$var$getSigners
    });


parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");

var $3ca9q = parcelRequire("3ca9q");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");


const $af0b684ea8b01bd1$var$getBitcoinAccounts = async ()=>{
    const instance = (0, $1845e434199bfc99$export$eacbd9e95432eb88)();
    const accounts = await instance.requestAccounts();
    return {
        accounts: accounts,
        chainId: (0, $9HEDW.LegacyNetworks).BTC
    };
};
function $af0b684ea8b01bd1$var$getChangeAccountSubscriber(instance) {
    let eventCallback;
    // subscriber can be passed to `or`, it will get the error and should rethrow error to pass the error to next `or` or throw error.
    return [
        (context, err)=>{
            const bitcoinInstance = instance();
            if (!bitcoinInstance) throw new Error('Trying to subscribe to your Solana wallet, but seems its instance is not available.');
            const [, setState] = context.state();
            eventCallback = (accounts)=>{
                if (!accounts.length) {
                    context.action('disconnect');
                    return;
                }
                const formatAccounts = accounts.map((account)=>(0, $3ca9q).AccountId.format({
                        address: account,
                        chainId: {
                            namespace: (0, $er2za.CAIP_NAMESPACE),
                            reference: (0, $er2za.CAIP_BITCOIN_CHAIN_ID)
                        }
                    }));
                setState('accounts', formatAccounts);
            };
            bitcoinInstance.on('accountsChanged', eventCallback);
            if (err instanceof Error) throw err;
        },
        (_context, err)=>{
            const bitcoinInstance = instance();
            if (eventCallback && bitcoinInstance) bitcoinInstance.removeListener('accountsChanged', eventCallback);
            return err;
        }
    ];
}
const [$af0b684ea8b01bd1$var$changeAccountSubscriber, $af0b684ea8b01bd1$var$changeAccountCleanup] = $af0b684ea8b01bd1$var$getChangeAccountSubscriber((0, $1845e434199bfc99$export$eacbd9e95432eb88));
const $af0b684ea8b01bd1$var$connect = (0, $er2za.builders).connect().action(async function() {
    const result = await $af0b684ea8b01bd1$var$getBitcoinAccounts();
    if (Array.isArray(result)) throw new Error('Expecting bitcoin response to be a single value, not an array.');
    const formatAccounts = result.accounts.map((account)=>(0, $3ca9q).AccountId.format({
            address: account,
            chainId: {
                namespace: (0, $er2za.CAIP_NAMESPACE),
                reference: (0, $er2za.CAIP_BITCOIN_CHAIN_ID)
            }
        }));
    return formatAccounts;
}).before($af0b684ea8b01bd1$var$changeAccountSubscriber).or($af0b684ea8b01bd1$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $af0b684ea8b01bd1$var$disconnect = (0, $f59Be.builders).disconnect().after($af0b684ea8b01bd1$var$changeAccountCleanup).build();
const $af0b684ea8b01bd1$export$85601e73083fc493 = new (0, $at2GJ.NamespaceBuilder)('UTXO', (0, $824e1109e09d5b6a$export$7c460c214963f696)).action($af0b684ea8b01bd1$var$connect).action($af0b684ea8b01bd1$var$disconnect).build();



const $a2587d71e1b865ed$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $824e1109e09d5b6a$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $1845e434199bfc99$export$b42520d3cb063518)()) {
            setState('installed', true);
            console.debug('[unisat] instance detected.', context);
        }
    }).config('metadata', (0, $824e1109e09d5b6a$export$dbb5e893e736e4ee)).add('utxo', (0, $af0b684ea8b01bd1$export$85601e73083fc493)).build();


const $576be99fff1bf187$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('0.0.0', (0, $da7afb993802de8d$export$107c8cc6b37a1ffa)()).version('1.0.0', (0, $a2587d71e1b865ed$export$afa934a86232cabe)()).build();



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");

var $2BMXn = parcelRequire("2BMXn");

var $4786x = parcelRequire("4786x");

var $5ZZUh = parcelRequire("5ZZUh");
const $dee0e3ef82a7f389$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $2BMXn.WALLET_ID)).init(function(context) {
        const [, setState] = context.state();
        if ((0, $5ZZUh.vultisig)()) {
            setState('installed', true);
            console.debug('[vultisig] instance detected.', context);
        }
    }).config('metadata', (0, $2BMXn.info)).add('utxo', (0, $4786x.namespace)).build();


const $7277f73a69a2cc79$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $dee0e3ef82a7f389$export$afa934a86232cabe)()).build();


var $d18cf0d374648d44$exports = {};

$parcel$export($d18cf0d374648d44$exports, "init", function () { return $d18cf0d374648d44$export$2cd8252107eb640b; });
$parcel$export($d18cf0d374648d44$exports, "config", function () { return $d18cf0d374648d44$export$e506a1d27d1eaa20; });
$parcel$export($d18cf0d374648d44$exports, "getInstance", function () { return $d18cf0d374648d44$export$8bedcca5bbd73999; });
$parcel$export($d18cf0d374648d44$exports, "connect", function () { return $d18cf0d374648d44$export$64605811ab45167f; });
$parcel$export($d18cf0d374648d44$exports, "subscribe", function () { return $d18cf0d374648d44$export$ec068583843480e7; });
$parcel$export($d18cf0d374648d44$exports, "switchNetwork", function () { return $d18cf0d374648d44$export$f3473d805e486329; });
$parcel$export($d18cf0d374648d44$exports, "canSwitchNetworkTo", function () { return $d18cf0d374648d44$export$3b3cf9ab9019de20; });
$parcel$export($d18cf0d374648d44$exports, "disconnect", function () { return $d18cf0d374648d44$export$37dfea93db2e14ed; });
$parcel$export($d18cf0d374648d44$exports, "getSigners", function () { return $d18cf0d374648d44$export$6352a17a50193ded; });
$parcel$export($d18cf0d374648d44$exports, "getWalletInfo", function () { return $d18cf0d374648d44$export$e5b9d96c6aeb3ff7; });
/* eslint-disable @typescript-eslint/no-magic-numbers */ var $46d43cbd77bc87e3$export$ca664994d1d54bff = /*#__PURE__*/ function(Level) {
    Level[Level["Off"] = 99] = "Off";
    Level[Level["Trace"] = 0] = "Trace";
    Level[Level["Debug"] = 1] = "Debug";
    Level[Level["Info"] = 2] = "Info";
    Level[Level["Warn"] = 3] = "Warn";
    Level[Level["Error"] = 4] = "Error";
    return Level;
}({});
const $46d43cbd77bc87e3$export$3d7865934588d77e = 'logger-message-event';


function $1897e625a59ad158$export$2f9235b8134cbdd4(error) {
    return error instanceof Error;
}


function $634f26ddaad1954d$export$9f30d106dee2fb21(level, message, data) {
    if (!(0, $1897e625a59ad158$export$2f9235b8134cbdd4)(message)) throw new Error('Your error input should be an instance of Error.');
    const event = new CustomEvent((0, $46d43cbd77bc87e3$export$3d7865934588d77e), {
        detail: {
            level: level,
            message: message,
            data: data
        }
    });
    if (!document) console.warn("document isn't available.");
    else document.dispatchEvent(event);
}
function $634f26ddaad1954d$export$a3bc9b8ed74fc(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Error, message, data);
}
function $634f26ddaad1954d$export$c106dd0671a0fc2d(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Warn, message, data);
}
function $634f26ddaad1954d$export$a80b3bd66acc52ff(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Info, message, data);
}
function $634f26ddaad1954d$export$1c9f709888824e05(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Debug, message, data);
}
function $634f26ddaad1954d$export$357889f174732d38(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Trace, message, data);
}




parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");

var $jMc9N = parcelRequire("jMc9N");
const $0a68f2729ded0545$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $0a68f2729ded0545$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $0a68f2729ded0545$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $0a68f2729ded0545$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $0a68f2729ded0545$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $0a68f2729ded0545$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $0a68f2729ded0545$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.at(-1) === '"' && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$0a68f2729ded0545$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($0a68f2729ded0545$var$suspectProtoRx.test(value) || $0a68f2729ded0545$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $0a68f2729ded0545$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $0a68f2729ded0545$export$4b2a7c187ff4b28c(value, options = {}) {
    return $0a68f2729ded0545$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}



var $ihoyg = parcelRequire("ihoyg");
var $f9bb6c267c86675e$require$Buffer = $ihoyg.Buffer;
function $f9bb6c267c86675e$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $f9bb6c267c86675e$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $f9bb6c267c86675e$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $f9bb6c267c86675e$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $f9bb6c267c86675e$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $f9bb6c267c86675e$export$2408f22a0fab9ae5(value) {
    if ($f9bb6c267c86675e$var$isPrimitive(value)) return String(value);
    if ($f9bb6c267c86675e$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $f9bb6c267c86675e$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $f9bb6c267c86675e$var$checkBufferSupport() {}
const $f9bb6c267c86675e$var$BASE64_PREFIX = "base64:";
function $f9bb6c267c86675e$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $f9bb6c267c86675e$var$checkBufferSupport();
    const base64 = $f9bb6c267c86675e$require$Buffer.from(value).toString("base64");
    return $f9bb6c267c86675e$var$BASE64_PREFIX + base64;
}
function $f9bb6c267c86675e$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($f9bb6c267c86675e$var$BASE64_PREFIX)) return value;
    $f9bb6c267c86675e$var$checkBufferSupport();
    return $f9bb6c267c86675e$require$Buffer.from(value.slice($f9bb6c267c86675e$var$BASE64_PREFIX.length), "base64");
}
const $f9bb6c267c86675e$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $f9bb6c267c86675e$export$ffb5f4729a158638(storage, base) {
    base = $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $f9bb6c267c86675e$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $f9bb6c267c86675e$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $f9bb6c267c86675e$export$35e795649ee09318(...keys) {
    return $f9bb6c267c86675e$export$407448d2b89b1813(keys.join(":"));
}
function $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5(base) {
    base = $f9bb6c267c86675e$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}


function $c71285538d2d369a$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $c71285538d2d369a$var$DRIVER_NAME = "memory";
const $c71285538d2d369a$var$memory = $c71285538d2d369a$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $c71285538d2d369a$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $c71285538d2d369a$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $c71285538d2d369a$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $c71285538d2d369a$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $0a68f2729ded0545$export$2e2bcd8739ae039)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $f9bb6c267c86675e$export$35e795649ee09318)(batch.base, item.key),
                            value: (0, $0a68f2729ded0545$export$2e2bcd8739ae039)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $0a68f2729ded0545$export$2e2bcd8739ae039)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItemRaw, relativeKey, opts);
            return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $f9bb6c267c86675e$export$4368d992c4eafac0)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $f9bb6c267c86675e$export$2408f22a0fab9ae5)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $f9bb6c267c86675e$export$2408f22a0fab9ae5)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.setItem, item.relativeKey, (0, $f9bb6c267c86675e$export$2408f22a0fab9ae5)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $f9bb6c267c86675e$export$db3b6bfb95261072)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $0a68f2729ded0545$export$2e2bcd8739ae039)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$c71285538d2d369a$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($c71285538d2d369a$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $c71285538d2d369a$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $c71285538d2d369a$export$b8801ea43165ed7d(storage, base) {
    base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $c71285538d2d369a$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $c71285538d2d369a$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $c71285538d2d369a$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.dispose);
}
const $c71285538d2d369a$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};


function $97cc708142de7e57$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $97cc708142de7e57$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $97cc708142de7e57$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $97cc708142de7e57$var$defaultGetStoreFunc;
function $97cc708142de7e57$var$defaultGetStore() {
    if (!$97cc708142de7e57$var$defaultGetStoreFunc) $97cc708142de7e57$var$defaultGetStoreFunc = $97cc708142de7e57$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $97cc708142de7e57$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$3988ae62b71be9a3(key, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$97cc708142de7e57$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$adaa4cf7ef1b65be(key, value, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$daa0a5170277c7a8(entries, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$5df405cccea42673(keys, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$97cc708142de7e57$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$722fbec263ad908a(key, updater, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($97cc708142de7e57$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$1d2f21e549771e67(key, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$c8aa84257229cac8(keys, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$42ffd38884aecdac(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
function $97cc708142de7e57$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$ed97f33186d4b816(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $97cc708142de7e57$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $97cc708142de7e57$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$68c286be0e7e55b7(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $97cc708142de7e57$export$b327150396135fe7(store.getAll());
        const items = [];
        return $97cc708142de7e57$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$3e9f948b41964866(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $97cc708142de7e57$export$b327150396135fe7(store.getAllKeys()),
            $97cc708142de7e57$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$97cc708142de7e57$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}


const $7a932d4f32f2e2c3$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $7a932d4f32f2e2c3$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, "$1\"$2n\"$3");
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $7a932d4f32f2e2c3$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $7a932d4f32f2e2c3$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $7a932d4f32f2e2c3$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $7a932d4f32f2e2c3$var$JSONStringify(value) || "";
}


function $409b09bfc77a18bb$var$C(i) {
    return i;
}
const $409b09bfc77a18bb$var$x = "idb-keyval";
var $409b09bfc77a18bb$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $97cc708142de7e57$export$f51a9068ac82ea43)(i.dbName, i.storeName)), {
        name: $409b09bfc77a18bb$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $97cc708142de7e57$export$3988ae62b71be9a3)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $97cc708142de7e57$export$3988ae62b71be9a3)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $97cc708142de7e57$export$adaa4cf7ef1b65be)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $97cc708142de7e57$export$1d2f21e549771e67)(e(s), n);
        },
        getKeys () {
            return (0, $97cc708142de7e57$export$ed97f33186d4b816)(n);
        },
        clear () {
            return (0, $97cc708142de7e57$export$42ffd38884aecdac)(n);
        }
    };
};
const $409b09bfc77a18bb$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $409b09bfc77a18bb$var$E = "keyvaluestorage";
class $409b09bfc77a18bb$var$_ {
    constructor(){
        this.indexedDb = (0, $c71285538d2d369a$export$d184a47a971dd4b9)({
            driver: $409b09bfc77a18bb$var$z({
                dbName: $409b09bfc77a18bb$var$D,
                storeName: $409b09bfc77a18bb$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $409b09bfc77a18bb$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $409b09bfc77a18bb$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $409b09bfc77a18bb$var$l < "u" && $409b09bfc77a18bb$var$l.localStorage ? $409b09bfc77a18bb$var$c.exports = $409b09bfc77a18bb$var$l.localStorage : typeof window < "u" && window.localStorage ? $409b09bfc77a18bb$var$c.exports = window.localStorage : $409b09bfc77a18bb$var$c.exports = new t;
})();
function $409b09bfc77a18bb$var$k(i) {
    var t;
    return [
        i[0],
        (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)((t = i[1]) != null ? t : "")
    ];
}
class $409b09bfc77a18bb$var$K {
    constructor(){
        this.localStorage = $409b09bfc77a18bb$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($409b09bfc77a18bb$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $409b09bfc77a18bb$var$N = "wc_storage_version", $409b09bfc77a18bb$var$y = 1, $409b09bfc77a18bb$var$O = async (i, t, e)=>{
    const n = $409b09bfc77a18bb$var$N, s = await t.getItem(n);
    if (s && s >= $409b09bfc77a18bb$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $409b09bfc77a18bb$var$y), e(t), $409b09bfc77a18bb$var$j(i, m);
}, $409b09bfc77a18bb$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $409b09bfc77a18bb$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $409b09bfc77a18bb$var$K;
        this.storage = t;
        try {
            const e = new $409b09bfc77a18bb$var$_;
            $409b09bfc77a18bb$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}


var $ebef95dfb67b1a3a$exports = {};
"use strict";
Object.defineProperty($ebef95dfb67b1a3a$exports, "__esModule", {
    value: true
});

var $1Hjuw = parcelRequire("1Hjuw");

$1Hjuw.__exportStar((parcelRequire("fyg7Q")), $ebef95dfb67b1a3a$exports);

$1Hjuw.__exportStar((parcelRequire("dXotL")), $ebef95dfb67b1a3a$exports);

$1Hjuw.__exportStar((parcelRequire("kEua4")), $ebef95dfb67b1a3a$exports);


var $edb0745dd7881952$exports = {};
"use strict";
Object.defineProperty($edb0745dd7881952$exports, "__esModule", {
    value: true
});
$edb0745dd7881952$exports.pino = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $17fbfb27aaabebbb$var$extendStatics = function(d, b) {
    $17fbfb27aaabebbb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $17fbfb27aaabebbb$var$extendStatics(d, b);
};
function $17fbfb27aaabebbb$export$a8ba968b8961cb8a(d, b) {
    $17fbfb27aaabebbb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $17fbfb27aaabebbb$export$18ce0697a983be9b = function() {
    $17fbfb27aaabebbb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17fbfb27aaabebbb$export$18ce0697a983be9b.apply(this, arguments);
};
function $17fbfb27aaabebbb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $17fbfb27aaabebbb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $17fbfb27aaabebbb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $17fbfb27aaabebbb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $17fbfb27aaabebbb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $17fbfb27aaabebbb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $17fbfb27aaabebbb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $17fbfb27aaabebbb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $17fbfb27aaabebbb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $17fbfb27aaabebbb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $17fbfb27aaabebbb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($17fbfb27aaabebbb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $17fbfb27aaabebbb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $17fbfb27aaabebbb$export$10c90e4f7922046c(v) {
    return this instanceof $17fbfb27aaabebbb$export$10c90e4f7922046c ? (this.v = v, this) : new $17fbfb27aaabebbb$export$10c90e4f7922046c(v);
}
function $17fbfb27aaabebbb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $17fbfb27aaabebbb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $17fbfb27aaabebbb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $17fbfb27aaabebbb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $17fbfb27aaabebbb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $17fbfb27aaabebbb$export$19a8beecd37a4c45 === "function" ? $17fbfb27aaabebbb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $17fbfb27aaabebbb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $17fbfb27aaabebbb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $17fbfb27aaabebbb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $17fbfb27aaabebbb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $17fbfb27aaabebbb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



const $edb0745dd7881952$var$pino_1 = $17fbfb27aaabebbb$export$da59b14a69baef04((parcelRequire("3C0Nn")));
Object.defineProperty($edb0745dd7881952$exports, "pino", {
    enumerable: true,
    get: function() {
        return $edb0745dd7881952$var$pino_1.default;
    }
});

$17fbfb27aaabebbb$export$f33643c0debef087((parcelRequire("cpzTH")), $edb0745dd7881952$exports);

$17fbfb27aaabebbb$export$f33643c0debef087((parcelRequire("b6sMl")), $edb0745dd7881952$exports);


parcelRequire("4ekPy");
var $5PJ3Z = parcelRequire("5PJ3Z");

var $jMc9N = parcelRequire("jMc9N");
class $ccb0ab7c4fc6b77f$export$ed533416df113881 extends (0, $5PJ3Z.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $ccb0ab7c4fc6b77f$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$45b2c2643615b67 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $ccb0ab7c4fc6b77f$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $ccb0ab7c4fc6b77f$export$3b0872bbd7e675a2 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$9a0f755fd4f79434 extends (0, $5PJ3Z.IEvents) {
    constructor(s){
        super();
    }
}
class $ccb0ab7c4fc6b77f$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $ccb0ab7c4fc6b77f$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $ccb0ab7c4fc6b77f$export$300eed987e764b57 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$41aaa3c39f6f2861 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $ccb0ab7c4fc6b77f$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $ccb0ab7c4fc6b77f$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))) {
    constructor(){
        super();
    }
}
class $ccb0ab7c4fc6b77f$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $ccb0ab7c4fc6b77f$export$623dd0f793f15643 extends (0, $jMc9N.EventEmitter) {
    constructor(){
        super();
    }
}
class $ccb0ab7c4fc6b77f$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}



var $94391278a6d0d2c0$exports = {};
$parcel$export($94391278a6d0d2c0$exports, "generateKeyPair", function () { return $d84f4f8904446ab3$export$a949d36eab55b41f; });
$parcel$export($94391278a6d0d2c0$exports, "signJWT", function () { return $d84f4f8904446ab3$export$a8dda30659d36d45; });
$parcel$export($94391278a6d0d2c0$exports, "encodeIss", function () { return $7a7c9fd5ff6ad871$export$1b29ef9371459e10; });
var $d35a84b798dfb767$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($d35a84b798dfb767$exports, "__esModule", {
    value: true
});
$d35a84b798dfb767$exports.convertSecretKeyToX25519 = $d35a84b798dfb767$exports.convertPublicKeyToX25519 = $d35a84b798dfb767$exports.verify = $d35a84b798dfb767$exports.sign = $d35a84b798dfb767$exports.extractPublicKeyFromSecretKey = $d35a84b798dfb767$exports.generateKeyPair = $d35a84b798dfb767$exports.generateKeyPairFromSeed = $d35a84b798dfb767$exports.SEED_LENGTH = $d35a84b798dfb767$exports.SECRET_KEY_LENGTH = $d35a84b798dfb767$exports.PUBLIC_KEY_LENGTH = $d35a84b798dfb767$exports.SIGNATURE_LENGTH = void 0;
var $a82db7e016d530d5$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($a82db7e016d530d5$exports, "__esModule", {
    value: true
});
$a82db7e016d530d5$exports.randomStringForEntropy = $a82db7e016d530d5$exports.randomString = $a82db7e016d530d5$exports.randomUint32 = $a82db7e016d530d5$exports.randomBytes = $a82db7e016d530d5$exports.defaultRandomSource = void 0;
var $1f275ba6aa118d05$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($1f275ba6aa118d05$exports, "__esModule", {
    value: true
});
$1f275ba6aa118d05$exports.SystemRandomSource = void 0;
var $eac49d77ca343475$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eac49d77ca343475$exports, "__esModule", {
    value: true
});
$eac49d77ca343475$exports.BrowserRandomSource = void 0;
const $eac49d77ca343475$var$QUOTA = 65536;
class $eac49d77ca343475$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== 'undefined' ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $eac49d77ca343475$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $eac49d77ca343475$var$QUOTA)));
        return out;
    }
}
$eac49d77ca343475$exports.BrowserRandomSource = $eac49d77ca343475$var$BrowserRandomSource;


var $7e9881e8c2e2bc67$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($7e9881e8c2e2bc67$exports, "__esModule", {
    value: true
});
$7e9881e8c2e2bc67$exports.NodeRandomSource = void 0;
var $558f303e9dbce718$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($558f303e9dbce718$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $558f303e9dbce718$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$558f303e9dbce718$exports.wipe = $558f303e9dbce718$var$wipe;



class $7e9881e8c2e2bc67$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("5Io6y"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $558f303e9dbce718$exports.wipe)(buffer);
        return out;
    }
}
$7e9881e8c2e2bc67$exports.NodeRandomSource = $7e9881e8c2e2bc67$var$NodeRandomSource;


class $1f275ba6aa118d05$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $eac49d77ca343475$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $7e9881e8c2e2bc67$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$1f275ba6aa118d05$exports.SystemRandomSource = $1f275ba6aa118d05$var$SystemRandomSource;


var $979a159667db6ad3$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($979a159667db6ad3$exports, "__esModule", {
    value: true
});
var $5f7b2f0281c53cf6$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($5f7b2f0281c53cf6$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $5f7b2f0281c53cf6$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$5f7b2f0281c53cf6$exports.mul = Math.imul || $5f7b2f0281c53cf6$var$imulShim;
/** 32-bit integer addition.  */ function $5f7b2f0281c53cf6$var$add(a, b) {
    return a + b | 0;
}
$5f7b2f0281c53cf6$exports.add = $5f7b2f0281c53cf6$var$add;
/**  32-bit integer subtraction.  */ function $5f7b2f0281c53cf6$var$sub(a, b) {
    return a - b | 0;
}
$5f7b2f0281c53cf6$exports.sub = $5f7b2f0281c53cf6$var$sub;
/** 32-bit integer left rotation */ function $5f7b2f0281c53cf6$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$5f7b2f0281c53cf6$exports.rotl = $5f7b2f0281c53cf6$var$rotl;
/** 32-bit integer left rotation */ function $5f7b2f0281c53cf6$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$5f7b2f0281c53cf6$exports.rotr = $5f7b2f0281c53cf6$var$rotr;
function $5f7b2f0281c53cf6$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $5f7b2f0281c53cf6$exports.isInteger = Number.isInteger || $5f7b2f0281c53cf6$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $5f7b2f0281c53cf6$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $5f7b2f0281c53cf6$exports.isSafeInteger = function(n) {
    return $5f7b2f0281c53cf6$exports.isInteger(n) && n >= -$5f7b2f0281c53cf6$exports.MAX_SAFE_INTEGER && n <= $5f7b2f0281c53cf6$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$979a159667db6ad3$exports.readInt16BE = $979a159667db6ad3$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$979a159667db6ad3$exports.readUint16BE = $979a159667db6ad3$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$979a159667db6ad3$exports.readInt16LE = $979a159667db6ad3$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$979a159667db6ad3$exports.readUint16LE = $979a159667db6ad3$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$979a159667db6ad3$exports.writeUint16BE = $979a159667db6ad3$var$writeUint16BE;
$979a159667db6ad3$exports.writeInt16BE = $979a159667db6ad3$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$979a159667db6ad3$exports.writeUint16LE = $979a159667db6ad3$var$writeUint16LE;
$979a159667db6ad3$exports.writeInt16LE = $979a159667db6ad3$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$979a159667db6ad3$exports.readInt32BE = $979a159667db6ad3$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$979a159667db6ad3$exports.readUint32BE = $979a159667db6ad3$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$979a159667db6ad3$exports.readInt32LE = $979a159667db6ad3$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$979a159667db6ad3$exports.readUint32LE = $979a159667db6ad3$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$979a159667db6ad3$exports.writeUint32BE = $979a159667db6ad3$var$writeUint32BE;
$979a159667db6ad3$exports.writeInt32BE = $979a159667db6ad3$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$979a159667db6ad3$exports.writeUint32LE = $979a159667db6ad3$var$writeUint32LE;
$979a159667db6ad3$exports.writeInt32LE = $979a159667db6ad3$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $979a159667db6ad3$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $979a159667db6ad3$var$readInt32BE(array, offset);
    var lo = $979a159667db6ad3$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$979a159667db6ad3$exports.readInt64BE = $979a159667db6ad3$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $979a159667db6ad3$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $979a159667db6ad3$var$readUint32BE(array, offset);
    var lo = $979a159667db6ad3$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$979a159667db6ad3$exports.readUint64BE = $979a159667db6ad3$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $979a159667db6ad3$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $979a159667db6ad3$var$readInt32LE(array, offset);
    var hi = $979a159667db6ad3$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$979a159667db6ad3$exports.readInt64LE = $979a159667db6ad3$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $979a159667db6ad3$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $979a159667db6ad3$var$readUint32LE(array, offset);
    var hi = $979a159667db6ad3$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$979a159667db6ad3$exports.readUint64LE = $979a159667db6ad3$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $979a159667db6ad3$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $979a159667db6ad3$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$979a159667db6ad3$exports.writeUint64BE = $979a159667db6ad3$var$writeUint64BE;
$979a159667db6ad3$exports.writeInt64BE = $979a159667db6ad3$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $979a159667db6ad3$var$writeUint32LE(value >>> 0, out, offset);
    $979a159667db6ad3$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$979a159667db6ad3$exports.writeUint64LE = $979a159667db6ad3$var$writeUint64LE;
$979a159667db6ad3$exports.writeInt64LE = $979a159667db6ad3$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $979a159667db6ad3$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$979a159667db6ad3$exports.readUintBE = $979a159667db6ad3$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $979a159667db6ad3$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$979a159667db6ad3$exports.readUintLE = $979a159667db6ad3$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$5f7b2f0281c53cf6$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$979a159667db6ad3$exports.writeUintBE = $979a159667db6ad3$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$5f7b2f0281c53cf6$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$979a159667db6ad3$exports.writeUintLE = $979a159667db6ad3$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $979a159667db6ad3$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$979a159667db6ad3$exports.readFloat32BE = $979a159667db6ad3$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $979a159667db6ad3$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$979a159667db6ad3$exports.readFloat32LE = $979a159667db6ad3$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $979a159667db6ad3$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$979a159667db6ad3$exports.readFloat64BE = $979a159667db6ad3$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $979a159667db6ad3$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$979a159667db6ad3$exports.readFloat64LE = $979a159667db6ad3$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$979a159667db6ad3$exports.writeFloat32BE = $979a159667db6ad3$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$979a159667db6ad3$exports.writeFloat32LE = $979a159667db6ad3$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$979a159667db6ad3$exports.writeFloat64BE = $979a159667db6ad3$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$979a159667db6ad3$exports.writeFloat64LE = $979a159667db6ad3$var$writeFloat64LE;



$a82db7e016d530d5$exports.defaultRandomSource = new $1f275ba6aa118d05$exports.SystemRandomSource();
function $a82db7e016d530d5$var$randomBytes(length, prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$a82db7e016d530d5$exports.randomBytes = $a82db7e016d530d5$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $a82db7e016d530d5$var$randomUint32(prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $a82db7e016d530d5$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $979a159667db6ad3$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $558f303e9dbce718$exports.wipe)(buf);
    return result;
}
$a82db7e016d530d5$exports.randomUint32 = $a82db7e016d530d5$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $a82db7e016d530d5$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $a82db7e016d530d5$var$randomString(length, charset = $a82db7e016d530d5$var$ALPHANUMERIC, prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = '';
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $a82db7e016d530d5$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $558f303e9dbce718$exports.wipe)(buf);
    }
    return out;
}
$a82db7e016d530d5$exports.randomString = $a82db7e016d530d5$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $a82db7e016d530d5$var$randomStringForEntropy(bits, charset = $a82db7e016d530d5$var$ALPHANUMERIC, prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $a82db7e016d530d5$var$randomString(length, charset, prng);
}
$a82db7e016d530d5$exports.randomStringForEntropy = $a82db7e016d530d5$var$randomStringForEntropy;


var $ec3d888014568220$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ec3d888014568220$exports, "__esModule", {
    value: true
});


$ec3d888014568220$exports.DIGEST_LENGTH = 64;
$ec3d888014568220$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $ec3d888014568220$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $ec3d888014568220$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $ec3d888014568220$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._tempHi);
        $558f303e9dbce718$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $ec3d888014568220$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $ec3d888014568220$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $ec3d888014568220$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $979a159667db6ad3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $979a159667db6ad3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $ec3d888014568220$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $979a159667db6ad3$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $979a159667db6ad3$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $558f303e9dbce718$exports.wipe(savedState.stateHi);
        $558f303e9dbce718$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $558f303e9dbce718$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$ec3d888014568220$exports.SHA512 = $ec3d888014568220$var$SHA512;
// Constants
var $ec3d888014568220$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $ec3d888014568220$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $979a159667db6ad3$exports.readUint32BE(m, j);
            wl[i] = $979a159667db6ad3$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $ec3d888014568220$var$K[i * 2];
            l = $ec3d888014568220$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $ec3d888014568220$var$hash(data) {
    var h = new $ec3d888014568220$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$ec3d888014568220$exports.hash = $ec3d888014568220$var$hash;



$d35a84b798dfb767$exports.SIGNATURE_LENGTH = 64;
$d35a84b798dfb767$exports.PUBLIC_KEY_LENGTH = 32;
$d35a84b798dfb767$exports.SECRET_KEY_LENGTH = 64;
$d35a84b798dfb767$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $d35a84b798dfb767$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $d35a84b798dfb767$var$_9 = new Uint8Array(32);
$d35a84b798dfb767$var$_9[0] = 9;
const $d35a84b798dfb767$var$gf0 = $d35a84b798dfb767$var$gf();
const $d35a84b798dfb767$var$gf1 = $d35a84b798dfb767$var$gf([
    1
]);
const $d35a84b798dfb767$var$D = $d35a84b798dfb767$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $d35a84b798dfb767$var$D2 = $d35a84b798dfb767$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $d35a84b798dfb767$var$X = $d35a84b798dfb767$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $d35a84b798dfb767$var$Y = $d35a84b798dfb767$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $d35a84b798dfb767$var$I = $d35a84b798dfb767$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $d35a84b798dfb767$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $d35a84b798dfb767$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $d35a84b798dfb767$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $d35a84b798dfb767$var$pack25519(o, n) {
    const m = $d35a84b798dfb767$var$gf();
    const t = $d35a84b798dfb767$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $d35a84b798dfb767$var$car25519(t);
    $d35a84b798dfb767$var$car25519(t);
    $d35a84b798dfb767$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $d35a84b798dfb767$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $d35a84b798dfb767$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $d35a84b798dfb767$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $d35a84b798dfb767$var$pack25519(c, a);
    $d35a84b798dfb767$var$pack25519(d, b);
    return $d35a84b798dfb767$var$verify32(c, d);
}
function $d35a84b798dfb767$var$par25519(a) {
    const d = new Uint8Array(32);
    $d35a84b798dfb767$var$pack25519(d, a);
    return d[0] & 1;
}
function $d35a84b798dfb767$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $d35a84b798dfb767$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $d35a84b798dfb767$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $d35a84b798dfb767$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $d35a84b798dfb767$var$square(o, a) {
    $d35a84b798dfb767$var$mul(o, a, a);
}
function $d35a84b798dfb767$var$inv25519(o, i) {
    const c = $d35a84b798dfb767$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $d35a84b798dfb767$var$square(c, c);
        if (a !== 2 && a !== 4) $d35a84b798dfb767$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $d35a84b798dfb767$var$pow2523(o, i) {
    const c = $d35a84b798dfb767$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $d35a84b798dfb767$var$square(c, c);
        if (a !== 1) $d35a84b798dfb767$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $d35a84b798dfb767$var$edadd(p, q) {
    const a = $d35a84b798dfb767$var$gf(), b = $d35a84b798dfb767$var$gf(), c = $d35a84b798dfb767$var$gf(), d = $d35a84b798dfb767$var$gf(), e = $d35a84b798dfb767$var$gf(), f = $d35a84b798dfb767$var$gf(), g = $d35a84b798dfb767$var$gf(), h = $d35a84b798dfb767$var$gf(), t = $d35a84b798dfb767$var$gf();
    $d35a84b798dfb767$var$sub(a, p[1], p[0]);
    $d35a84b798dfb767$var$sub(t, q[1], q[0]);
    $d35a84b798dfb767$var$mul(a, a, t);
    $d35a84b798dfb767$var$add(b, p[0], p[1]);
    $d35a84b798dfb767$var$add(t, q[0], q[1]);
    $d35a84b798dfb767$var$mul(b, b, t);
    $d35a84b798dfb767$var$mul(c, p[3], q[3]);
    $d35a84b798dfb767$var$mul(c, c, $d35a84b798dfb767$var$D2);
    $d35a84b798dfb767$var$mul(d, p[2], q[2]);
    $d35a84b798dfb767$var$add(d, d, d);
    $d35a84b798dfb767$var$sub(e, b, a);
    $d35a84b798dfb767$var$sub(f, d, c);
    $d35a84b798dfb767$var$add(g, d, c);
    $d35a84b798dfb767$var$add(h, b, a);
    $d35a84b798dfb767$var$mul(p[0], e, f);
    $d35a84b798dfb767$var$mul(p[1], h, g);
    $d35a84b798dfb767$var$mul(p[2], g, f);
    $d35a84b798dfb767$var$mul(p[3], e, h);
}
function $d35a84b798dfb767$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$d35a84b798dfb767$var$sel25519(p[i], q[i], b);
}
function $d35a84b798dfb767$var$pack(r, p) {
    const tx = $d35a84b798dfb767$var$gf(), ty = $d35a84b798dfb767$var$gf(), zi = $d35a84b798dfb767$var$gf();
    $d35a84b798dfb767$var$inv25519(zi, p[2]);
    $d35a84b798dfb767$var$mul(tx, p[0], zi);
    $d35a84b798dfb767$var$mul(ty, p[1], zi);
    $d35a84b798dfb767$var$pack25519(r, ty);
    r[31] ^= $d35a84b798dfb767$var$par25519(tx) << 7;
}
function $d35a84b798dfb767$var$scalarmult(p, q, s) {
    $d35a84b798dfb767$var$set25519(p[0], $d35a84b798dfb767$var$gf0);
    $d35a84b798dfb767$var$set25519(p[1], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$set25519(p[2], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$set25519(p[3], $d35a84b798dfb767$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $d35a84b798dfb767$var$cswap(p, q, b);
        $d35a84b798dfb767$var$edadd(q, p);
        $d35a84b798dfb767$var$edadd(p, p);
        $d35a84b798dfb767$var$cswap(p, q, b);
    }
}
function $d35a84b798dfb767$var$scalarbase(p, s) {
    const q = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    $d35a84b798dfb767$var$set25519(q[0], $d35a84b798dfb767$var$X);
    $d35a84b798dfb767$var$set25519(q[1], $d35a84b798dfb767$var$Y);
    $d35a84b798dfb767$var$set25519(q[2], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$mul(q[3], $d35a84b798dfb767$var$X, $d35a84b798dfb767$var$Y);
    $d35a84b798dfb767$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $d35a84b798dfb767$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $d35a84b798dfb767$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$d35a84b798dfb767$exports.SEED_LENGTH} bytes`);
    const d = (0, $ec3d888014568220$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    $d35a84b798dfb767$var$scalarbase(p, d);
    $d35a84b798dfb767$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$d35a84b798dfb767$exports.generateKeyPairFromSeed = $d35a84b798dfb767$var$generateKeyPairFromSeed;
function $d35a84b798dfb767$var$generateKeyPair(prng) {
    const seed = (0, $a82db7e016d530d5$exports.randomBytes)(32, prng);
    const result = $d35a84b798dfb767$var$generateKeyPairFromSeed(seed);
    (0, $558f303e9dbce718$exports.wipe)(seed);
    return result;
}
$d35a84b798dfb767$exports.generateKeyPair = $d35a84b798dfb767$var$generateKeyPair;
function $d35a84b798dfb767$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $d35a84b798dfb767$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$d35a84b798dfb767$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$d35a84b798dfb767$exports.extractPublicKeyFromSecretKey = $d35a84b798dfb767$var$extractPublicKeyFromSecretKey;
const $d35a84b798dfb767$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $d35a84b798dfb767$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $d35a84b798dfb767$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $d35a84b798dfb767$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $d35a84b798dfb767$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $d35a84b798dfb767$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $d35a84b798dfb767$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $d35a84b798dfb767$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    const d = (0, $ec3d888014568220$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $ec3d888014568220$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $d35a84b798dfb767$var$reduce(r);
    $d35a84b798dfb767$var$scalarbase(p, r);
    $d35a84b798dfb767$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $d35a84b798dfb767$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $d35a84b798dfb767$var$modL(signature.subarray(32), x);
    return signature;
}
$d35a84b798dfb767$exports.sign = $d35a84b798dfb767$var$sign;
function $d35a84b798dfb767$var$unpackneg(r, p) {
    const t = $d35a84b798dfb767$var$gf(), chk = $d35a84b798dfb767$var$gf(), num = $d35a84b798dfb767$var$gf(), den = $d35a84b798dfb767$var$gf(), den2 = $d35a84b798dfb767$var$gf(), den4 = $d35a84b798dfb767$var$gf(), den6 = $d35a84b798dfb767$var$gf();
    $d35a84b798dfb767$var$set25519(r[2], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$unpack25519(r[1], p);
    $d35a84b798dfb767$var$square(num, r[1]);
    $d35a84b798dfb767$var$mul(den, num, $d35a84b798dfb767$var$D);
    $d35a84b798dfb767$var$sub(num, num, r[2]);
    $d35a84b798dfb767$var$add(den, r[2], den);
    $d35a84b798dfb767$var$square(den2, den);
    $d35a84b798dfb767$var$square(den4, den2);
    $d35a84b798dfb767$var$mul(den6, den4, den2);
    $d35a84b798dfb767$var$mul(t, den6, num);
    $d35a84b798dfb767$var$mul(t, t, den);
    $d35a84b798dfb767$var$pow2523(t, t);
    $d35a84b798dfb767$var$mul(t, t, num);
    $d35a84b798dfb767$var$mul(t, t, den);
    $d35a84b798dfb767$var$mul(t, t, den);
    $d35a84b798dfb767$var$mul(r[0], t, den);
    $d35a84b798dfb767$var$square(chk, r[0]);
    $d35a84b798dfb767$var$mul(chk, chk, den);
    if ($d35a84b798dfb767$var$neq25519(chk, num)) $d35a84b798dfb767$var$mul(r[0], r[0], $d35a84b798dfb767$var$I);
    $d35a84b798dfb767$var$square(chk, r[0]);
    $d35a84b798dfb767$var$mul(chk, chk, den);
    if ($d35a84b798dfb767$var$neq25519(chk, num)) return -1;
    if ($d35a84b798dfb767$var$par25519(r[0]) === p[31] >> 7) $d35a84b798dfb767$var$sub(r[0], $d35a84b798dfb767$var$gf0, r[0]);
    $d35a84b798dfb767$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $d35a84b798dfb767$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    const q = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    if (signature.length !== $d35a84b798dfb767$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$d35a84b798dfb767$exports.SIGNATURE_LENGTH} bytes`);
    if ($d35a84b798dfb767$var$unpackneg(q, publicKey)) return false;
    const hs = new $ec3d888014568220$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $d35a84b798dfb767$var$reduce(h);
    $d35a84b798dfb767$var$scalarmult(p, q, h);
    $d35a84b798dfb767$var$scalarbase(q, signature.subarray(32));
    $d35a84b798dfb767$var$edadd(p, q);
    $d35a84b798dfb767$var$pack(t, p);
    if ($d35a84b798dfb767$var$verify32(signature, t)) return false;
    return true;
}
$d35a84b798dfb767$exports.verify = $d35a84b798dfb767$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $d35a84b798dfb767$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    if ($d35a84b798dfb767$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $d35a84b798dfb767$var$gf();
    let b = $d35a84b798dfb767$var$gf();
    let y = q[1];
    $d35a84b798dfb767$var$add(a, $d35a84b798dfb767$var$gf1, y);
    $d35a84b798dfb767$var$sub(b, $d35a84b798dfb767$var$gf1, y);
    $d35a84b798dfb767$var$inv25519(b, b);
    $d35a84b798dfb767$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $d35a84b798dfb767$var$pack25519(z, a);
    return z;
}
$d35a84b798dfb767$exports.convertPublicKeyToX25519 = $d35a84b798dfb767$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $d35a84b798dfb767$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $ec3d888014568220$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $558f303e9dbce718$exports.wipe)(d);
    return o;
}
$d35a84b798dfb767$exports.convertSecretKeyToX25519 = $d35a84b798dfb767$var$convertSecretKeyToX25519;




var $5t6iP = parcelRequire("5t6iP");
const $e4de822a7e12ea5f$export$51745f7832485c34 = "EdDSA";
const $e4de822a7e12ea5f$export$f51b45e220f2ba98 = "JWT";
const $e4de822a7e12ea5f$export$a3e35a0f952eb3ef = ".";
const $e4de822a7e12ea5f$export$d2e6fe38c55f8e23 = "base64url";
const $e4de822a7e12ea5f$export$c09c2801e10a2b95 = "utf8";
const $e4de822a7e12ea5f$export$1e9219c0b91a4257 = "utf8";
const $e4de822a7e12ea5f$export$d4057275de9d060b = ":";
const $e4de822a7e12ea5f$export$acf13c61a1a0ccf3 = "did";
const $e4de822a7e12ea5f$export$b908fe81ccf30934 = "key";
const $e4de822a7e12ea5f$export$7bd18b7a7a4d0471 = "base58btc";
const $e4de822a7e12ea5f$export$6d6d3d2e39be8d68 = "z";
const $e4de822a7e12ea5f$export$9902a33a5776d1fc = "K36";
const $e4de822a7e12ea5f$export$ca477e91394a742a = 32;
const $e4de822a7e12ea5f$export$f09ad228919f26fb = 32;


function $0a6a50095078105a$export$db814d038928c649(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}


function $9830581d32c31a36$export$2de70f21292aac9e(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return (0, $0a6a50095078105a$export$db814d038928c649)(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $9830581d32c31a36$export$19833a56117fe205(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return (0, $0a6a50095078105a$export$db814d038928c649)(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}



function $d7a55c5922d01322$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = (0, $9830581d32c31a36$export$19833a56117fe205)(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return (0, $0a6a50095078105a$export$db814d038928c649)(output);
}


var $f3abcf60a31ee860$exports = {};

$parcel$export($f3abcf60a31ee860$exports, "identity", function () { return $f3abcf60a31ee860$export$f0954fd7d5368655; });
function $8386e20daae15c29$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === ' ') return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        if (source[psz] === ' ') return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $8386e20daae15c29$var$src = $8386e20daae15c29$var$base;
var $8386e20daae15c29$var$_brrp__multiformats_scope_baseX = $8386e20daae15c29$var$src;
var $8386e20daae15c29$export$2e2bcd8739ae039 = $8386e20daae15c29$var$_brrp__multiformats_scope_baseX;


const $230aef02968da43e$export$6e22c362a0406a2c = new Uint8Array(0);
const $230aef02968da43e$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, '0'), '');
const $230aef02968da43e$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $230aef02968da43e$export$6e22c362a0406a2c;
};
const $230aef02968da43e$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $230aef02968da43e$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array') return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error('Unknown type, must be binary type');
};
const $230aef02968da43e$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $230aef02968da43e$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $230aef02968da43e$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);


class $c2760641b13c9983$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error('Unknown type, must be binary type');
    }
}
class $c2760641b13c9983$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error('Invalid prefix character');
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === 'string') {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error('Can only multibase decode strings');
    }
    or(decoder) {
        return $c2760641b13c9983$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $c2760641b13c9983$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $c2760641b13c9983$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $c2760641b13c9983$export$252bb8b3bbdf6749 = (left, right)=>new $c2760641b13c9983$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $c2760641b13c9983$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $c2760641b13c9983$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $c2760641b13c9983$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $c2760641b13c9983$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $c2760641b13c9983$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $c2760641b13c9983$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $8386e20daae15c29$export$2e2bcd8739ae039)(alphabet, name);
    return $c2760641b13c9983$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $230aef02968da43e$export$8c14e57e778d3873)(decode(text))
    });
};
const $c2760641b13c9983$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === '=')--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError('Unexpected end of data');
    return out;
};
const $c2760641b13c9983$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === '=';
    const mask = (1 << bitsPerChar) - 1;
    let out = '';
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += '=';
    return out;
};
const $c2760641b13c9983$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $c2760641b13c9983$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $c2760641b13c9983$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $c2760641b13c9983$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};



const $f3abcf60a31ee860$export$f0954fd7d5368655 = (0, $c2760641b13c9983$export$6788812c4e6611e6)({
    prefix: '\0',
    name: 'identity',
    encode: (buf)=>(0, $230aef02968da43e$export$f84e8e69fd4488a5)(buf),
    decode: (str)=>(0, $230aef02968da43e$export$3004f64547af360e)(str)
});


var $13db2a1e6d9fa682$exports = {};

$parcel$export($13db2a1e6d9fa682$exports, "base2", function () { return $13db2a1e6d9fa682$export$ed5f7917e37e31aa; });

const $13db2a1e6d9fa682$export$ed5f7917e37e31aa = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: '0',
    name: 'base2',
    alphabet: '01',
    bitsPerChar: 1
});


var $f69f8c42d4cf5b8b$exports = {};

$parcel$export($f69f8c42d4cf5b8b$exports, "base8", function () { return $f69f8c42d4cf5b8b$export$43b580ac9deb5b96; });

const $f69f8c42d4cf5b8b$export$43b580ac9deb5b96 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: '7',
    name: 'base8',
    alphabet: '01234567',
    bitsPerChar: 3
});


var $b88fb1cc60e91d44$exports = {};

$parcel$export($b88fb1cc60e91d44$exports, "base10", function () { return $b88fb1cc60e91d44$export$63d6a7de0ff813cc; });

const $b88fb1cc60e91d44$export$63d6a7de0ff813cc = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    prefix: '9',
    name: 'base10',
    alphabet: '0123456789'
});


var $4cb6bfbb12c0b90f$exports = {};

$parcel$export($4cb6bfbb12c0b90f$exports, "base16", function () { return $4cb6bfbb12c0b90f$export$586f61c71cb02fe4; });
$parcel$export($4cb6bfbb12c0b90f$exports, "base16upper", function () { return $4cb6bfbb12c0b90f$export$2d835b8dd4032b62; });

const $4cb6bfbb12c0b90f$export$586f61c71cb02fe4 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'f',
    name: 'base16',
    alphabet: '0123456789abcdef',
    bitsPerChar: 4
});
const $4cb6bfbb12c0b90f$export$2d835b8dd4032b62 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'F',
    name: 'base16upper',
    alphabet: '0123456789ABCDEF',
    bitsPerChar: 4
});


var $79239b1dbaba4da1$exports = {};

$parcel$export($79239b1dbaba4da1$exports, "base32", function () { return $79239b1dbaba4da1$export$4a4d5965e2738b2a; });
$parcel$export($79239b1dbaba4da1$exports, "base32upper", function () { return $79239b1dbaba4da1$export$fbaa3bbbd754def4; });
$parcel$export($79239b1dbaba4da1$exports, "base32pad", function () { return $79239b1dbaba4da1$export$e194fa100d329365; });
$parcel$export($79239b1dbaba4da1$exports, "base32padupper", function () { return $79239b1dbaba4da1$export$3a9fc48d294dce32; });
$parcel$export($79239b1dbaba4da1$exports, "base32hex", function () { return $79239b1dbaba4da1$export$c57d6760d519c8ac; });
$parcel$export($79239b1dbaba4da1$exports, "base32hexupper", function () { return $79239b1dbaba4da1$export$8cf4640df3165d29; });
$parcel$export($79239b1dbaba4da1$exports, "base32hexpad", function () { return $79239b1dbaba4da1$export$8c6a05c08ec7d456; });
$parcel$export($79239b1dbaba4da1$exports, "base32hexpadupper", function () { return $79239b1dbaba4da1$export$29f73c6a744e639f; });
$parcel$export($79239b1dbaba4da1$exports, "base32z", function () { return $79239b1dbaba4da1$export$fdad9af4bdc05e3; });

const $79239b1dbaba4da1$export$4a4d5965e2738b2a = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'b',
    name: 'base32',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$fbaa3bbbd754def4 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'B',
    name: 'base32upper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$e194fa100d329365 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'c',
    name: 'base32pad',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$3a9fc48d294dce32 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'C',
    name: 'base32padupper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$c57d6760d519c8ac = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'v',
    name: 'base32hex',
    alphabet: '0123456789abcdefghijklmnopqrstuv',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$8cf4640df3165d29 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'V',
    name: 'base32hexupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$8c6a05c08ec7d456 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 't',
    name: 'base32hexpad',
    alphabet: '0123456789abcdefghijklmnopqrstuv=',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$29f73c6a744e639f = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'T',
    name: 'base32hexpadupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$fdad9af4bdc05e3 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'h',
    name: 'base32z',
    alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
    bitsPerChar: 5
});


var $325a4f6ff55d21fd$exports = {};

$parcel$export($325a4f6ff55d21fd$exports, "base36", function () { return $325a4f6ff55d21fd$export$95b61e7c39ae893a; });
$parcel$export($325a4f6ff55d21fd$exports, "base36upper", function () { return $325a4f6ff55d21fd$export$bab7c9bdb963afd; });

const $325a4f6ff55d21fd$export$95b61e7c39ae893a = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    prefix: 'k',
    name: 'base36',
    alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const $325a4f6ff55d21fd$export$bab7c9bdb963afd = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    prefix: 'K',
    name: 'base36upper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});


var $08e78e2317497ed5$exports = {};

$parcel$export($08e78e2317497ed5$exports, "base58btc", function () { return $08e78e2317497ed5$export$65c61748a9b98a2c; });
$parcel$export($08e78e2317497ed5$exports, "base58flickr", function () { return $08e78e2317497ed5$export$c6a7baed2941aad2; });

const $08e78e2317497ed5$export$65c61748a9b98a2c = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    name: 'base58btc',
    prefix: 'z',
    alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const $08e78e2317497ed5$export$c6a7baed2941aad2 = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    name: 'base58flickr',
    prefix: 'Z',
    alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});


var $324b6785866cb426$exports = {};

$parcel$export($324b6785866cb426$exports, "base64", function () { return $324b6785866cb426$export$b3b2de96497acc47; });
$parcel$export($324b6785866cb426$exports, "base64pad", function () { return $324b6785866cb426$export$a9c086fc40b4563c; });
$parcel$export($324b6785866cb426$exports, "base64url", function () { return $324b6785866cb426$export$7d21597c7bc64465; });
$parcel$export($324b6785866cb426$exports, "base64urlpad", function () { return $324b6785866cb426$export$e87ddc9183aa53c9; });

const $324b6785866cb426$export$b3b2de96497acc47 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'm',
    name: 'base64',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    bitsPerChar: 6
});
const $324b6785866cb426$export$a9c086fc40b4563c = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'M',
    name: 'base64pad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    bitsPerChar: 6
});
const $324b6785866cb426$export$7d21597c7bc64465 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'u',
    name: 'base64url',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
    bitsPerChar: 6
});
const $324b6785866cb426$export$e87ddc9183aa53c9 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: 'U',
    name: 'base64urlpad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
    bitsPerChar: 6
});


var $0af0dbcf0f754230$exports = {};

$parcel$export($0af0dbcf0f754230$exports, "base256emoji", function () { return $0af0dbcf0f754230$export$6a5d4ab6075d2779; });

const $0af0dbcf0f754230$var$alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
const $0af0dbcf0f754230$var$alphabetBytesToChars = $0af0dbcf0f754230$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $0af0dbcf0f754230$var$alphabetCharsToBytes = $0af0dbcf0f754230$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $0af0dbcf0f754230$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $0af0dbcf0f754230$var$alphabetBytesToChars[c];
        return p;
    }, '');
}
function $0af0dbcf0f754230$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $0af0dbcf0f754230$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $0af0dbcf0f754230$export$6a5d4ab6075d2779 = (0, $c2760641b13c9983$export$6788812c4e6611e6)({
    prefix: '\uD83D\uDE80',
    name: 'base256emoji',
    encode: $0af0dbcf0f754230$var$encode,
    decode: $0af0dbcf0f754230$var$decode
});


var $e71899ea4f6ab358$exports = {};

$parcel$export($e71899ea4f6ab358$exports, "sha256", function () { return $e71899ea4f6ab358$export$bced8d2aada2d1c9; });
$parcel$export($e71899ea4f6ab358$exports, "sha512", function () { return $e71899ea4f6ab358$export$a888d2532e6dc7bb; });

var $43dd651984eec6ec$var$encode_1 = $43dd651984eec6ec$var$encode;
var $43dd651984eec6ec$var$MSB = 128, $43dd651984eec6ec$var$REST = 127, $43dd651984eec6ec$var$MSBALL = ~$43dd651984eec6ec$var$REST, $43dd651984eec6ec$var$INT = Math.pow(2, 31);
function $43dd651984eec6ec$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $43dd651984eec6ec$var$INT){
        out[offset++] = num & 255 | $43dd651984eec6ec$var$MSB;
        num /= 128;
    }
    while(num & $43dd651984eec6ec$var$MSBALL){
        out[offset++] = num & 255 | $43dd651984eec6ec$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $43dd651984eec6ec$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $43dd651984eec6ec$var$decode = $43dd651984eec6ec$var$read;
var $43dd651984eec6ec$var$MSB$1 = 128, $43dd651984eec6ec$var$REST$1 = 127;
function $43dd651984eec6ec$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $43dd651984eec6ec$var$read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $43dd651984eec6ec$var$REST$1) << shift : (b & $43dd651984eec6ec$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $43dd651984eec6ec$var$MSB$1);
    $43dd651984eec6ec$var$read.bytes = counter - offset;
    return res;
}
var $43dd651984eec6ec$var$N1 = Math.pow(2, 7);
var $43dd651984eec6ec$var$N2 = Math.pow(2, 14);
var $43dd651984eec6ec$var$N3 = Math.pow(2, 21);
var $43dd651984eec6ec$var$N4 = Math.pow(2, 28);
var $43dd651984eec6ec$var$N5 = Math.pow(2, 35);
var $43dd651984eec6ec$var$N6 = Math.pow(2, 42);
var $43dd651984eec6ec$var$N7 = Math.pow(2, 49);
var $43dd651984eec6ec$var$N8 = Math.pow(2, 56);
var $43dd651984eec6ec$var$N9 = Math.pow(2, 63);
var $43dd651984eec6ec$var$length = function(value) {
    return value < $43dd651984eec6ec$var$N1 ? 1 : value < $43dd651984eec6ec$var$N2 ? 2 : value < $43dd651984eec6ec$var$N3 ? 3 : value < $43dd651984eec6ec$var$N4 ? 4 : value < $43dd651984eec6ec$var$N5 ? 5 : value < $43dd651984eec6ec$var$N6 ? 6 : value < $43dd651984eec6ec$var$N7 ? 7 : value < $43dd651984eec6ec$var$N8 ? 8 : value < $43dd651984eec6ec$var$N9 ? 9 : 10;
};
var $43dd651984eec6ec$var$varint = {
    encode: $43dd651984eec6ec$var$encode_1,
    decode: $43dd651984eec6ec$var$decode,
    encodingLength: $43dd651984eec6ec$var$length
};
var $43dd651984eec6ec$var$_brrp_varint = $43dd651984eec6ec$var$varint;
var $43dd651984eec6ec$export$2e2bcd8739ae039 = $43dd651984eec6ec$var$_brrp_varint;


const $c5efd6f152fb9135$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $43dd651984eec6ec$export$2e2bcd8739ae039).decode(data, offset);
    return [
        code,
        (0, $43dd651984eec6ec$export$2e2bcd8739ae039).decode.bytes
    ];
};
const $c5efd6f152fb9135$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $43dd651984eec6ec$export$2e2bcd8739ae039).encode(int, target, offset);
    return target;
};
const $c5efd6f152fb9135$export$cbee51f25f0626d7 = (int)=>{
    return (0, $43dd651984eec6ec$export$2e2bcd8739ae039).encodingLength(int);
};


const $a2b827e55fb36179$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $c5efd6f152fb9135$export$cbee51f25f0626d7(code);
    const digestOffset = sizeOffset + $c5efd6f152fb9135$export$cbee51f25f0626d7(size);
    const bytes = new Uint8Array(digestOffset + size);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(code, bytes, 0);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $a2b827e55fb36179$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $a2b827e55fb36179$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $230aef02968da43e$export$8c14e57e778d3873)(multihash);
    const [code, sizeOffset] = $c5efd6f152fb9135$export$2f872c0f2117be69(bytes);
    const [size, digestOffset] = $c5efd6f152fb9135$export$2f872c0f2117be69(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error('Incorrect length');
    return new $a2b827e55fb36179$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $a2b827e55fb36179$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $230aef02968da43e$export$e9bab7fafb253603)(a.bytes, b.bytes);
};
class $a2b827e55fb36179$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}


const $22d7739e185bfb4f$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $22d7739e185bfb4f$export$df06eed23808f4d0(name, code, encode);
class $22d7739e185bfb4f$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $a2b827e55fb36179$export$185802fd694ee1f5(this.code, result) : result.then((digest)=>$a2b827e55fb36179$export$185802fd694ee1f5(this.code, digest));
        } else throw Error('Unknown type, must be binary type');
    }
}


const $e71899ea4f6ab358$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $e71899ea4f6ab358$export$bced8d2aada2d1c9 = (0, $22d7739e185bfb4f$export$6788812c4e6611e6)({
    name: 'sha2-256',
    code: 18,
    encode: $e71899ea4f6ab358$var$sha('SHA-256')
});
const $e71899ea4f6ab358$export$a888d2532e6dc7bb = (0, $22d7739e185bfb4f$export$6788812c4e6611e6)({
    name: 'sha2-512',
    code: 19,
    encode: $e71899ea4f6ab358$var$sha('SHA-512')
});


var $7c6c67fae84999e6$exports = {};

$parcel$export($7c6c67fae84999e6$exports, "identity", function () { return $7c6c67fae84999e6$export$f0954fd7d5368655; });


const $7c6c67fae84999e6$var$code = 0;
const $7c6c67fae84999e6$var$name = 'identity';
const $7c6c67fae84999e6$var$encode = (0, $230aef02968da43e$export$8c14e57e778d3873);
const $7c6c67fae84999e6$var$digest = (input)=>$a2b827e55fb36179$export$185802fd694ee1f5($7c6c67fae84999e6$var$code, $7c6c67fae84999e6$var$encode(input));
const $7c6c67fae84999e6$export$f0954fd7d5368655 = {
    code: $7c6c67fae84999e6$var$code,
    name: $7c6c67fae84999e6$var$name,
    encode: $7c6c67fae84999e6$var$encode,
    digest: $7c6c67fae84999e6$var$digest
};


var $b535406b0ef893a6$exports = {};

$parcel$export($b535406b0ef893a6$exports, "name", function () { return $b535406b0ef893a6$export$a8ff84c12d48cfa6; });
$parcel$export($b535406b0ef893a6$exports, "code", function () { return $b535406b0ef893a6$export$6565f9f03506010b; });
$parcel$export($b535406b0ef893a6$exports, "encode", function () { return $b535406b0ef893a6$export$c564cdbbe6da493; });
$parcel$export($b535406b0ef893a6$exports, "decode", function () { return $b535406b0ef893a6$export$2f872c0f2117be69; });

const $b535406b0ef893a6$export$a8ff84c12d48cfa6 = 'raw';
const $b535406b0ef893a6$export$6565f9f03506010b = 85;
const $b535406b0ef893a6$export$c564cdbbe6da493 = (node)=>(0, $230aef02968da43e$export$8c14e57e778d3873)(node);
const $b535406b0ef893a6$export$2f872c0f2117be69 = (data)=>(0, $230aef02968da43e$export$8c14e57e778d3873)(data);


var $d1df71ac31e336d7$exports = {};

$parcel$export($d1df71ac31e336d7$exports, "name", function () { return $d1df71ac31e336d7$export$a8ff84c12d48cfa6; });
$parcel$export($d1df71ac31e336d7$exports, "code", function () { return $d1df71ac31e336d7$export$6565f9f03506010b; });
$parcel$export($d1df71ac31e336d7$exports, "encode", function () { return $d1df71ac31e336d7$export$c564cdbbe6da493; });
$parcel$export($d1df71ac31e336d7$exports, "decode", function () { return $d1df71ac31e336d7$export$2f872c0f2117be69; });
const $d1df71ac31e336d7$var$textEncoder = new TextEncoder();
const $d1df71ac31e336d7$var$textDecoder = new TextDecoder();
const $d1df71ac31e336d7$export$a8ff84c12d48cfa6 = 'json';
const $d1df71ac31e336d7$export$6565f9f03506010b = 512;
const $d1df71ac31e336d7$export$c564cdbbe6da493 = (node)=>$d1df71ac31e336d7$var$textEncoder.encode(JSON.stringify(node));
const $d1df71ac31e336d7$export$2f872c0f2117be69 = (data)=>JSON.parse($d1df71ac31e336d7$var$textDecoder.decode(data));







class $dd5d7ee27f33ba60$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $dd5d7ee27f33ba60$var$hidden,
            byteLength: $dd5d7ee27f33ba60$var$hidden,
            code: $dd5d7ee27f33ba60$var$readonly,
            version: $dd5d7ee27f33ba60$var$readonly,
            multihash: $dd5d7ee27f33ba60$var$readonly,
            bytes: $dd5d7ee27f33ba60$var$readonly,
            _baseCache: $dd5d7ee27f33ba60$var$hidden,
            asCID: $dd5d7ee27f33ba60$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $dd5d7ee27f33ba60$var$DAG_PB_CODE) throw new Error('Cannot convert a non dag-pb CID to CIDv0');
                    if (multihash.code !== $dd5d7ee27f33ba60$var$SHA_256_CODE) throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
                    return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $a2b827e55fb36179$export$185802fd694ee1f5(code, digest);
                    return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $a2b827e55fb36179$export$e9bab7fafb253603(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $dd5d7ee27f33ba60$var$toStringV0(bytes, _baseCache, base || (0, $08e78e2317497ed5$export$65c61748a9b98a2c).encoder);
            default:
                return $dd5d7ee27f33ba60$var$toStringV1(bytes, _baseCache, base || (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return 'CID';
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return 'CID(' + this.toString() + ')';
    }
    static isCID(value) {
        $dd5d7ee27f33ba60$var$deprecate(/^0\.0/, $dd5d7ee27f33ba60$var$IS_CID_DEPRECATION);
        return !!(value && (value[$dd5d7ee27f33ba60$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error('Deprecated, use .toString()');
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $dd5d7ee27f33ba60$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $dd5d7ee27f33ba60$export$12d863fcef3f6aa(version, code, multihash, bytes || $dd5d7ee27f33ba60$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$dd5d7ee27f33ba60$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $a2b827e55fb36179$export$2f872c0f2117be69(multihash);
            return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== 'number') throw new Error('String codecs are no longer supported');
        switch(version){
            case 0:
                if (code !== $dd5d7ee27f33ba60$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$dd5d7ee27f33ba60$var$DAG_PB_CODE}) block encoding`);
                else return new $dd5d7ee27f33ba60$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $dd5d7ee27f33ba60$var$encodeCID(version, code, digest.bytes);
                    return new $dd5d7ee27f33ba60$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error('Invalid version');
        }
    }
    static createV0(digest) {
        return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.create(0, $dd5d7ee27f33ba60$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $dd5d7ee27f33ba60$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error('Incorrect length');
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $dd5d7ee27f33ba60$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $230aef02968da43e$export$8c14e57e778d3873)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error('Incorrect length');
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $a2b827e55fb36179$export$d67a82ff561eff43(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV0(digest) : $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $c5efd6f152fb9135$export$2f872c0f2117be69(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $dd5d7ee27f33ba60$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $dd5d7ee27f33ba60$var$parseCIDtoBytes(source, base);
        const cid = $dd5d7ee27f33ba60$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $dd5d7ee27f33ba60$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case 'Q':
            {
                const decoder = base || (0, $08e78e2317497ed5$export$65c61748a9b98a2c);
                return [
                    (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix,
                    decoder.decode(`${(0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix}${source}`)
                ];
            }
        case (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix:
            {
                const decoder = base || (0, $08e78e2317497ed5$export$65c61748a9b98a2c);
                return [
                    (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a).prefix:
            {
                const decoder = base || (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a);
                return [
                    (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $dd5d7ee27f33ba60$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $dd5d7ee27f33ba60$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $dd5d7ee27f33ba60$var$DAG_PB_CODE = 112;
const $dd5d7ee27f33ba60$var$SHA_256_CODE = 18;
const $dd5d7ee27f33ba60$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $c5efd6f152fb9135$export$cbee51f25f0626d7(version);
    const hashOffset = codeOffset + $c5efd6f152fb9135$export$cbee51f25f0626d7(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(version, bytes, 0);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $dd5d7ee27f33ba60$var$cidSymbol = Symbol.for('@ipld/js-cid/CID');
const $dd5d7ee27f33ba60$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $dd5d7ee27f33ba60$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $dd5d7ee27f33ba60$var$version = '0.0.0-dev';
const $dd5d7ee27f33ba60$var$deprecate = (range, message)=>{
    if (range.test($dd5d7ee27f33ba60$var$version)) console.warn(message);
    else throw new Error(message);
};
const $dd5d7ee27f33ba60$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;








const $7c41a9a86dba9037$export$196f613671eb7dd9 = {
    ...$f3abcf60a31ee860$exports,
    ...$13db2a1e6d9fa682$exports,
    ...$f69f8c42d4cf5b8b$exports,
    ...$b88fb1cc60e91d44$exports,
    ...$4cb6bfbb12c0b90f$exports,
    ...$79239b1dbaba4da1$exports,
    ...$325a4f6ff55d21fd$exports,
    ...$08e78e2317497ed5$exports,
    ...$324b6785866cb426$exports,
    ...$0af0dbcf0f754230$exports
};
const $7c41a9a86dba9037$export$cff071c6f82b8944 = {
    ...$e71899ea4f6ab358$exports,
    ...$7c6c67fae84999e6$exports
};
const $7c41a9a86dba9037$export$b2c6ab3b27d60531 = {
    raw: $b535406b0ef893a6$exports,
    json: $d1df71ac31e336d7$exports
};



function $245e6dc4d723b03c$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $245e6dc4d723b03c$var$string = $245e6dc4d723b03c$var$createCodec('utf8', 'u', (buf)=>{
    const decoder = new TextDecoder('utf8');
    return 'u' + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $245e6dc4d723b03c$var$ascii = $245e6dc4d723b03c$var$createCodec('ascii', 'a', (buf)=>{
    let string = 'a';
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = (0, $9830581d32c31a36$export$19833a56117fe205)(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $245e6dc4d723b03c$var$BASES = {
    utf8: $245e6dc4d723b03c$var$string,
    'utf-8': $245e6dc4d723b03c$var$string,
    hex: (0, $7c41a9a86dba9037$export$196f613671eb7dd9).base16,
    latin1: $245e6dc4d723b03c$var$ascii,
    ascii: $245e6dc4d723b03c$var$ascii,
    binary: $245e6dc4d723b03c$var$ascii,
    ...(0, $7c41a9a86dba9037$export$196f613671eb7dd9)
};
var $245e6dc4d723b03c$export$2e2bcd8739ae039 = $245e6dc4d723b03c$var$BASES;


function $5d73656cf817e699$export$f84e8e69fd4488a5(array, encoding = 'utf8') {
    const base = (0, $245e6dc4d723b03c$export$2e2bcd8739ae039)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString('utf8');
    return base.encoder.encode(array).substring(1);
}




function $56aa271a838dc1ea$export$3004f64547af360e(string, encoding = 'utf8') {
    const base = (0, $245e6dc4d723b03c$export$2e2bcd8739ae039)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) return (0, $0a6a50095078105a$export$db814d038928c649)(globalThis.Buffer.from(string, 'utf-8'));
    return base.decoder.decode(`${base.prefix}${string}`);
}




function $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(str) {
    return (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)((0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $56aa271a838dc1ea$export$3004f64547af360e)(str, (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23)), (0, $e4de822a7e12ea5f$export$c09c2801e10a2b95)));
}
function $7a7c9fd5ff6ad871$export$84046f8082657cdf(val) {
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $56aa271a838dc1ea$export$3004f64547af360e)((0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(val), (0, $e4de822a7e12ea5f$export$c09c2801e10a2b95)), (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23));
}
function $7a7c9fd5ff6ad871$export$1b29ef9371459e10(publicKey) {
    const header = (0, $56aa271a838dc1ea$export$3004f64547af360e)((0, $e4de822a7e12ea5f$export$9902a33a5776d1fc), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    const multicodec = (0, $e4de822a7e12ea5f$export$6d6d3d2e39be8d68) + (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
        header,
        publicKey
    ]), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    return [
        (0, $e4de822a7e12ea5f$export$acf13c61a1a0ccf3),
        (0, $e4de822a7e12ea5f$export$b908fe81ccf30934),
        multicodec
    ].join((0, $e4de822a7e12ea5f$export$d4057275de9d060b));
}
function $7a7c9fd5ff6ad871$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $e4de822a7e12ea5f$export$d4057275de9d060b));
    if (prefix !== (0, $e4de822a7e12ea5f$export$acf13c61a1a0ccf3) || method !== (0, $e4de822a7e12ea5f$export$b908fe81ccf30934)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $e4de822a7e12ea5f$export$6d6d3d2e39be8d68)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $56aa271a838dc1ea$export$3004f64547af360e)(multicodec.slice(1), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    const type = (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(bytes.slice(0, 2), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    if (type !== (0, $e4de822a7e12ea5f$export$9902a33a5776d1fc)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $e4de822a7e12ea5f$export$ca477e91394a742a)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $7a7c9fd5ff6ad871$export$d9746ef301b2089b(bytes) {
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(bytes, (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23));
}
function $7a7c9fd5ff6ad871$export$c37aeb372ac07c0e(encoded) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)(encoded, (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23));
}
function $7a7c9fd5ff6ad871$export$cfdd1f2478131e3d(params) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)([
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.header),
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.payload)
    ].join((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef)), (0, $e4de822a7e12ea5f$export$1e9219c0b91a4257));
}
function $7a7c9fd5ff6ad871$export$13923bea59211b58(data) {
    const params = (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(data, (0, $e4de822a7e12ea5f$export$1e9219c0b91a4257)).split((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef));
    const header = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[0]);
    const payload = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $7a7c9fd5ff6ad871$export$1b70f4551c751d68(params) {
    return [
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.header),
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.payload),
        $7a7c9fd5ff6ad871$export$d9746ef301b2089b(params.signature)
    ].join((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef));
}
function $7a7c9fd5ff6ad871$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef));
    const header = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[0]);
    const payload = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[1]);
    const signature = $7a7c9fd5ff6ad871$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $56aa271a838dc1ea$export$3004f64547af360e)(params.slice(0, 2).join((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef)), (0, $e4de822a7e12ea5f$export$1e9219c0b91a4257));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}


function $d84f4f8904446ab3$export$a949d36eab55b41f(seed = (0, $a82db7e016d530d5$exports.randomBytes)((0, $e4de822a7e12ea5f$export$f09ad228919f26fb))) {
    return $d35a84b798dfb767$exports.generateKeyPairFromSeed(seed);
}
async function $d84f4f8904446ab3$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $5t6iP.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $e4de822a7e12ea5f$export$51745f7832485c34),
        typ: (0, $e4de822a7e12ea5f$export$f51b45e220f2ba98)
    };
    const iss = (0, $7a7c9fd5ff6ad871$export$1b29ef9371459e10)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $7a7c9fd5ff6ad871$export$cfdd1f2478131e3d)({
        header: header,
        payload: payload
    });
    const signature = $d35a84b798dfb767$exports.sign(keyPair.secretKey, data);
    return (0, $7a7c9fd5ff6ad871$export$1b70f4551c751d68)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $d84f4f8904446ab3$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $7a7c9fd5ff6ad871$export$9a62e6c0a30e00bc)(jwt);
    if (header.alg !== (0, $e4de822a7e12ea5f$export$51745f7832485c34) || header.typ !== (0, $e4de822a7e12ea5f$export$f51b45e220f2ba98)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $7a7c9fd5ff6ad871$export$86ac046d72244356)(payload.iss);
    return $d35a84b798dfb767$exports.verify(publicKey, data, signature);
}



var $4b3fdb2f5c46b4aa$exports = {};



$parcel$exportWildcard($94391278a6d0d2c0$exports, $4b3fdb2f5c46b4aa$exports);


var $27bf83211ca625a1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($27bf83211ca625a1$exports, "__esModule", {
    value: true
});
var $eb1c5e8bae1f6d11$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eb1c5e8bae1f6d11$exports, "__esModule", {
    value: true
});


// Number of ChaCha rounds (ChaCha20).
var $eb1c5e8bae1f6d11$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $eb1c5e8bae1f6d11$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $eb1c5e8bae1f6d11$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $979a159667db6ad3$exports.writeUint32LE(x0 + j0 | 0, out, 0);
    $979a159667db6ad3$exports.writeUint32LE(x1 + j1 | 0, out, 4);
    $979a159667db6ad3$exports.writeUint32LE(x2 + j2 | 0, out, 8);
    $979a159667db6ad3$exports.writeUint32LE(x3 + j3 | 0, out, 12);
    $979a159667db6ad3$exports.writeUint32LE(x4 + j4 | 0, out, 16);
    $979a159667db6ad3$exports.writeUint32LE(x5 + j5 | 0, out, 20);
    $979a159667db6ad3$exports.writeUint32LE(x6 + j6 | 0, out, 24);
    $979a159667db6ad3$exports.writeUint32LE(x7 + j7 | 0, out, 28);
    $979a159667db6ad3$exports.writeUint32LE(x8 + j8 | 0, out, 32);
    $979a159667db6ad3$exports.writeUint32LE(x9 + j9 | 0, out, 36);
    $979a159667db6ad3$exports.writeUint32LE(x10 + j10 | 0, out, 40);
    $979a159667db6ad3$exports.writeUint32LE(x11 + j11 | 0, out, 44);
    $979a159667db6ad3$exports.writeUint32LE(x12 + j12 | 0, out, 48);
    $979a159667db6ad3$exports.writeUint32LE(x13 + j13 | 0, out, 52);
    $979a159667db6ad3$exports.writeUint32LE(x14 + j14 | 0, out, 56);
    $979a159667db6ad3$exports.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $eb1c5e8bae1f6d11$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $eb1c5e8bae1f6d11$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $eb1c5e8bae1f6d11$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $558f303e9dbce718$exports.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $558f303e9dbce718$exports.wipe(nc);
    return dst;
}
$eb1c5e8bae1f6d11$exports.streamXOR = $eb1c5e8bae1f6d11$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $eb1c5e8bae1f6d11$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $558f303e9dbce718$exports.wipe(dst);
    return $eb1c5e8bae1f6d11$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
$eb1c5e8bae1f6d11$exports.stream = $eb1c5e8bae1f6d11$var$stream;
function $eb1c5e8bae1f6d11$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}


var $ffaf4739a0948788$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ffaf4739a0948788$exports, "__esModule", {
    value: true
});
var $ca3166a483d9c1fd$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ca3166a483d9c1fd$exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $ca3166a483d9c1fd$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
$ca3166a483d9c1fd$exports.select = $ca3166a483d9c1fd$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $ca3166a483d9c1fd$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
$ca3166a483d9c1fd$exports.lessOrEqual = $ca3166a483d9c1fd$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $ca3166a483d9c1fd$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
$ca3166a483d9c1fd$exports.compare = $ca3166a483d9c1fd$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $ca3166a483d9c1fd$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $ca3166a483d9c1fd$var$compare(a, b) !== 0;
}
$ca3166a483d9c1fd$exports.equal = $ca3166a483d9c1fd$var$equal;



$ffaf4739a0948788$exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $ffaf4739a0948788$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = $ffaf4739a0948788$exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._r);
        $558f303e9dbce718$exports.wipe(this._h);
        $558f303e9dbce718$exports.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
$ffaf4739a0948788$exports.Poly1305 = $ffaf4739a0948788$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $ffaf4739a0948788$var$oneTimeAuth(key, data) {
    var h = new $ffaf4739a0948788$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$ffaf4739a0948788$exports.oneTimeAuth = $ffaf4739a0948788$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $ffaf4739a0948788$var$equal(a, b) {
    if (a.length !== $ffaf4739a0948788$exports.DIGEST_LENGTH || b.length !== $ffaf4739a0948788$exports.DIGEST_LENGTH) return false;
    return $ca3166a483d9c1fd$exports.equal(a, b);
}
$ffaf4739a0948788$exports.equal = $ffaf4739a0948788$var$equal;





$27bf83211ca625a1$exports.KEY_LENGTH = 32;
$27bf83211ca625a1$exports.NONCE_LENGTH = 12;
$27bf83211ca625a1$exports.TAG_LENGTH = 16;
var $27bf83211ca625a1$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $27bf83211ca625a1$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = $27bf83211ca625a1$exports.NONCE_LENGTH;
        this.tagLength = $27bf83211ca625a1$exports.TAG_LENGTH;
        if (key.length !== $27bf83211ca625a1$exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $eb1c5e8bae1f6d11$exports.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $eb1c5e8bae1f6d11$exports.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $558f303e9dbce718$exports.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $eb1c5e8bae1f6d11$exports.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$ca3166a483d9c1fd$exports.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $eb1c5e8bae1f6d11$exports.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $558f303e9dbce718$exports.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $ffaf4739a0948788$exports.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($27bf83211ca625a1$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($27bf83211ca625a1$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $979a159667db6ad3$exports.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $979a159667db6ad3$exports.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $558f303e9dbce718$exports.wipe(tag);
        $558f303e9dbce718$exports.wipe(length);
    };
    return ChaCha20Poly1305;
}();
$27bf83211ca625a1$exports.ChaCha20Poly1305 = $27bf83211ca625a1$var$ChaCha20Poly1305;


var $73217b27b6ce6be7$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($73217b27b6ce6be7$exports, "__esModule", {
    value: true
});
var $b489bb1d9c0011b7$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($b489bb1d9c0011b7$exports, "__esModule", {
    value: true
});
var $225ea7fe7d80121a$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($225ea7fe7d80121a$exports, "__esModule", {
    value: true
});
function $225ea7fe7d80121a$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
$225ea7fe7d80121a$exports.isSerializableHash = $225ea7fe7d80121a$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.




/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $b489bb1d9c0011b7$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($225ea7fe7d80121a$exports.isSerializableHash(this._inner) && $225ea7fe7d80121a$exports.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $558f303e9dbce718$exports.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner) || !$225ea7fe7d80121a$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($225ea7fe7d80121a$exports.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($225ea7fe7d80121a$exports.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner) || !$225ea7fe7d80121a$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
$b489bb1d9c0011b7$exports.HMAC = $b489bb1d9c0011b7$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $b489bb1d9c0011b7$var$hmac(hash, key, data) {
    var h = new $b489bb1d9c0011b7$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$b489bb1d9c0011b7$exports.hmac = $b489bb1d9c0011b7$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ $b489bb1d9c0011b7$exports.equal = $ca3166a483d9c1fd$exports.equal;



/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $73217b27b6ce6be7$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $b489bb1d9c0011b7$exports.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $b489bb1d9c0011b7$exports.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
$73217b27b6ce6be7$exports.HKDF = $73217b27b6ce6be7$var$HKDF; // TODO(dchest): maybe implement deriveKey?



var $489f6e82929df31f$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($489f6e82929df31f$exports, "__esModule", {
    value: true
});


$489f6e82929df31f$exports.DIGEST_LENGTH = 32;
$489f6e82929df31f$exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $489f6e82929df31f$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = $489f6e82929df31f$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $489f6e82929df31f$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $489f6e82929df31f$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $489f6e82929df31f$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $979a159667db6ad3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $979a159667db6ad3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $489f6e82929df31f$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$979a159667db6ad3$exports.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $558f303e9dbce718$exports.wipe(savedState.state);
        if (savedState.buffer) $558f303e9dbce718$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
$489f6e82929df31f$exports.SHA256 = $489f6e82929df31f$var$SHA256;
// Constants
var $489f6e82929df31f$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $489f6e82929df31f$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $979a159667db6ad3$exports.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($489f6e82929df31f$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $489f6e82929df31f$var$hash(data) {
    var h = new $489f6e82929df31f$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$489f6e82929df31f$exports.hash = $489f6e82929df31f$var$hash;


var $65448ed271866a3b$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($65448ed271866a3b$exports, "__esModule", {
    value: true
});
$65448ed271866a3b$exports.sharedKey = $65448ed271866a3b$exports.generateKeyPair = $65448ed271866a3b$exports.generateKeyPairFromSeed = $65448ed271866a3b$exports.scalarMultBase = $65448ed271866a3b$exports.scalarMult = $65448ed271866a3b$exports.SHARED_KEY_LENGTH = $65448ed271866a3b$exports.SECRET_KEY_LENGTH = $65448ed271866a3b$exports.PUBLIC_KEY_LENGTH = void 0;


$65448ed271866a3b$exports.PUBLIC_KEY_LENGTH = 32;
$65448ed271866a3b$exports.SECRET_KEY_LENGTH = 32;
$65448ed271866a3b$exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $65448ed271866a3b$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $65448ed271866a3b$var$_9 = new Uint8Array(32);
$65448ed271866a3b$var$_9[0] = 9;
const $65448ed271866a3b$var$_121665 = $65448ed271866a3b$var$gf([
    0xdb41,
    1
]);
function $65448ed271866a3b$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $65448ed271866a3b$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $65448ed271866a3b$var$pack25519(o, n) {
    const m = $65448ed271866a3b$var$gf();
    const t = $65448ed271866a3b$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $65448ed271866a3b$var$car25519(t);
    $65448ed271866a3b$var$car25519(t);
    $65448ed271866a3b$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $65448ed271866a3b$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $65448ed271866a3b$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $65448ed271866a3b$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $65448ed271866a3b$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $65448ed271866a3b$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $65448ed271866a3b$var$square(o, a) {
    $65448ed271866a3b$var$mul(o, a, a);
}
function $65448ed271866a3b$var$inv25519(o, inp) {
    const c = $65448ed271866a3b$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $65448ed271866a3b$var$square(c, c);
        if (i !== 2 && i !== 4) $65448ed271866a3b$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $65448ed271866a3b$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $65448ed271866a3b$var$gf(), b = $65448ed271866a3b$var$gf(), c = $65448ed271866a3b$var$gf(), d = $65448ed271866a3b$var$gf(), e = $65448ed271866a3b$var$gf(), f = $65448ed271866a3b$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $65448ed271866a3b$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $65448ed271866a3b$var$sel25519(a, b, r);
        $65448ed271866a3b$var$sel25519(c, d, r);
        $65448ed271866a3b$var$add(e, a, c);
        $65448ed271866a3b$var$sub(a, a, c);
        $65448ed271866a3b$var$add(c, b, d);
        $65448ed271866a3b$var$sub(b, b, d);
        $65448ed271866a3b$var$square(d, e);
        $65448ed271866a3b$var$square(f, a);
        $65448ed271866a3b$var$mul(a, c, a);
        $65448ed271866a3b$var$mul(c, b, e);
        $65448ed271866a3b$var$add(e, a, c);
        $65448ed271866a3b$var$sub(a, a, c);
        $65448ed271866a3b$var$square(b, a);
        $65448ed271866a3b$var$sub(c, d, f);
        $65448ed271866a3b$var$mul(a, c, $65448ed271866a3b$var$_121665);
        $65448ed271866a3b$var$add(a, a, d);
        $65448ed271866a3b$var$mul(c, c, a);
        $65448ed271866a3b$var$mul(a, d, f);
        $65448ed271866a3b$var$mul(d, b, x);
        $65448ed271866a3b$var$square(b, e);
        $65448ed271866a3b$var$sel25519(a, b, r);
        $65448ed271866a3b$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $65448ed271866a3b$var$inv25519(x32, x32);
    $65448ed271866a3b$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $65448ed271866a3b$var$pack25519(q, x16);
    return q;
}
$65448ed271866a3b$exports.scalarMult = $65448ed271866a3b$var$scalarMult;
function $65448ed271866a3b$var$scalarMultBase(n) {
    return $65448ed271866a3b$var$scalarMult(n, $65448ed271866a3b$var$_9);
}
$65448ed271866a3b$exports.scalarMultBase = $65448ed271866a3b$var$scalarMultBase;
function $65448ed271866a3b$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $65448ed271866a3b$exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${$65448ed271866a3b$exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $65448ed271866a3b$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$65448ed271866a3b$exports.generateKeyPairFromSeed = $65448ed271866a3b$var$generateKeyPairFromSeed;
function $65448ed271866a3b$var$generateKeyPair(prng) {
    const seed = (0, $a82db7e016d530d5$exports.randomBytes)(32, prng);
    const result = $65448ed271866a3b$var$generateKeyPairFromSeed(seed);
    (0, $558f303e9dbce718$exports.wipe)(seed);
    return result;
}
$65448ed271866a3b$exports.generateKeyPair = $65448ed271866a3b$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $65448ed271866a3b$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $65448ed271866a3b$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $65448ed271866a3b$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $65448ed271866a3b$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
$65448ed271866a3b$exports.sharedKey = $65448ed271866a3b$var$sharedKey;


function $812c269a889cf005$export$398604a469f7de9a(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}



function $a965876d86f721c2$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}






function $4f8f7588d3c997a5$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error('Inputs should have the same length');
    const result = (0, $9830581d32c31a36$export$19833a56117fe205)(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return (0, $0a6a50095078105a$export$db814d038928c649)(result);
}





var $4TNnu = parcelRequire("4TNnu");
var $e5e04069c5ff0401$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e5e04069c5ff0401$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}();
var $e5e04069c5ff0401$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = $4TNnu.platform;
    }
    return NodeInfo;
}();
var $e5e04069c5ff0401$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}();
var $e5e04069c5ff0401$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $e5e04069c5ff0401$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $e5e04069c5ff0401$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $e5e04069c5ff0401$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $e5e04069c5ff0401$var$REQUIRED_VERSION_PARTS = 3;
var $e5e04069c5ff0401$var$userAgentRules = [
    [
        'aol',
        /AOLShield\/([0-9\._]+)/
    ],
    [
        'edge',
        /Edge\/([0-9\._]+)/
    ],
    [
        'edge-ios',
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        'yandexbrowser',
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        'kakaotalk',
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        'samsung',
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        'silk',
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        'miui',
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        'beaker',
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        'edge-chromium',
        /EdgA?\/([0-9\.]+)/
    ],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'chrome',
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'phantomjs',
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'crios',
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'firefox',
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'fxios',
        /FxiOS\/([0-9\.]+)/
    ],
    [
        'opera-mini',
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        'opera',
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'opera',
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'pie',
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        'pie',
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        'netfront',
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        'ie',
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        'ie',
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        'ie',
        /MSIE\s(7\.0)/
    ],
    [
        'bb10',
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        'android',
        /Android\s([0-9\.]+)/
    ],
    [
        'ios',
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        'safari',
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        'facebook',
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        'instagram',
        /Instagram\s([0-9\.]+)/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        'curl',
        /^curl\/([0-9\.]+)$/
    ],
    [
        'searchbot',
        $e5e04069c5ff0401$var$SEARCHBOX_UA_REGEX
    ]
];
var $e5e04069c5ff0401$var$operatingSystemRules = [
    [
        'iOS',
        /iP(hone|od|ad)/
    ],
    [
        'Android OS',
        /Android/
    ],
    [
        'BlackBerry OS',
        /BlackBerry|BB10/
    ],
    [
        'Windows Mobile',
        /IEMobile/
    ],
    [
        'Amazon OS',
        /Kindle/
    ],
    [
        'Windows 3.11',
        /Win16/
    ],
    [
        'Windows 95',
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        'Windows 98',
        /(Windows 98)|(Win98)/
    ],
    [
        'Windows 2000',
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        'Windows XP',
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        'Windows Server 2003',
        /(Windows NT 5.2)/
    ],
    [
        'Windows Vista',
        /(Windows NT 6.0)/
    ],
    [
        'Windows 7',
        /(Windows NT 6.1)/
    ],
    [
        'Windows 8',
        /(Windows NT 6.2)/
    ],
    [
        'Windows 8.1',
        /(Windows NT 6.3)/
    ],
    [
        'Windows 10',
        /(Windows NT 10.0)/
    ],
    [
        'Windows ME',
        /Windows ME/
    ],
    [
        'Windows CE',
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        'Open BSD',
        /OpenBSD/
    ],
    [
        'Sun OS',
        /SunOS/
    ],
    [
        'Chrome OS',
        /CrOS/
    ],
    [
        'Linux',
        /(Linux)|(X11)/
    ],
    [
        'Mac OS',
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        'QNX',
        /QNX/
    ],
    [
        'BeOS',
        /BeOS/
    ],
    [
        'OS/2',
        /OS\/2/
    ]
];
function $e5e04069c5ff0401$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $e5e04069c5ff0401$export$1184956100eddc3c(userAgent);
    if (typeof document === 'undefined' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return new $e5e04069c5ff0401$export$7c78fe95a9d9b03e();
    if (typeof navigator !== 'undefined') return $e5e04069c5ff0401$export$1184956100eddc3c(navigator.userAgent);
    return $e5e04069c5ff0401$export$bf2c6630ab904918();
}
function $e5e04069c5ff0401$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== '' && $e5e04069c5ff0401$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $e5e04069c5ff0401$export$89ca9f8ca1a50fd5(ua) {
    var data = $e5e04069c5ff0401$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $e5e04069c5ff0401$export$1184956100eddc3c(ua) {
    var matchedRule = $e5e04069c5ff0401$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') return new $e5e04069c5ff0401$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $e5e04069c5ff0401$var$REQUIRED_VERSION_PARTS) versionParts = $e5e04069c5ff0401$var$__spreadArray($e5e04069c5ff0401$var$__spreadArray([], versionParts, true), $e5e04069c5ff0401$var$createVersionParts($e5e04069c5ff0401$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join('.');
    var os = $e5e04069c5ff0401$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $e5e04069c5ff0401$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $e5e04069c5ff0401$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $e5e04069c5ff0401$export$8fa985da04a86f0(name, version, os);
}
function $e5e04069c5ff0401$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $e5e04069c5ff0401$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $e5e04069c5ff0401$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $e5e04069c5ff0401$export$bf2c6630ab904918() {
    var isNode = false;
    return isNode ? new $e5e04069c5ff0401$export$62457c674e0167c0($4TNnu.version.slice(1)) : null;
}
function $e5e04069c5ff0401$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push('0');
    return output;
}



var $5t6iP = parcelRequire("5t6iP");
var $77e64dd613f9cca8$exports = {};
"use strict";
Object.defineProperty($77e64dd613f9cca8$exports, "__esModule", {
    value: true
});
$77e64dd613f9cca8$exports.getLocalStorage = $77e64dd613f9cca8$exports.getLocalStorageOrThrow = $77e64dd613f9cca8$exports.getCrypto = $77e64dd613f9cca8$exports.getCryptoOrThrow = $77e64dd613f9cca8$exports.getLocation = $77e64dd613f9cca8$exports.getLocationOrThrow = $77e64dd613f9cca8$exports.getNavigator = $77e64dd613f9cca8$exports.getNavigatorOrThrow = $77e64dd613f9cca8$exports.getDocument = $77e64dd613f9cca8$exports.getDocumentOrThrow = $77e64dd613f9cca8$exports.getFromWindowOrThrow = $77e64dd613f9cca8$exports.getFromWindow = void 0;
function $77e64dd613f9cca8$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$77e64dd613f9cca8$exports.getFromWindow = $77e64dd613f9cca8$var$getFromWindow;
function $77e64dd613f9cca8$var$getFromWindowOrThrow(name) {
    const res = $77e64dd613f9cca8$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$77e64dd613f9cca8$exports.getFromWindowOrThrow = $77e64dd613f9cca8$var$getFromWindowOrThrow;
function $77e64dd613f9cca8$var$getDocumentOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("document");
}
$77e64dd613f9cca8$exports.getDocumentOrThrow = $77e64dd613f9cca8$var$getDocumentOrThrow;
function $77e64dd613f9cca8$var$getDocument() {
    return $77e64dd613f9cca8$var$getFromWindow("document");
}
$77e64dd613f9cca8$exports.getDocument = $77e64dd613f9cca8$var$getDocument;
function $77e64dd613f9cca8$var$getNavigatorOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("navigator");
}
$77e64dd613f9cca8$exports.getNavigatorOrThrow = $77e64dd613f9cca8$var$getNavigatorOrThrow;
function $77e64dd613f9cca8$var$getNavigator() {
    return $77e64dd613f9cca8$var$getFromWindow("navigator");
}
$77e64dd613f9cca8$exports.getNavigator = $77e64dd613f9cca8$var$getNavigator;
function $77e64dd613f9cca8$var$getLocationOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("location");
}
$77e64dd613f9cca8$exports.getLocationOrThrow = $77e64dd613f9cca8$var$getLocationOrThrow;
function $77e64dd613f9cca8$var$getLocation() {
    return $77e64dd613f9cca8$var$getFromWindow("location");
}
$77e64dd613f9cca8$exports.getLocation = $77e64dd613f9cca8$var$getLocation;
function $77e64dd613f9cca8$var$getCryptoOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("crypto");
}
$77e64dd613f9cca8$exports.getCryptoOrThrow = $77e64dd613f9cca8$var$getCryptoOrThrow;
function $77e64dd613f9cca8$var$getCrypto() {
    return $77e64dd613f9cca8$var$getFromWindow("crypto");
}
$77e64dd613f9cca8$exports.getCrypto = $77e64dd613f9cca8$var$getCrypto;
function $77e64dd613f9cca8$var$getLocalStorageOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("localStorage");
}
$77e64dd613f9cca8$exports.getLocalStorageOrThrow = $77e64dd613f9cca8$var$getLocalStorageOrThrow;
function $77e64dd613f9cca8$var$getLocalStorage() {
    return $77e64dd613f9cca8$var$getFromWindow("localStorage");
}
$77e64dd613f9cca8$exports.getLocalStorage = $77e64dd613f9cca8$var$getLocalStorage;


var $4ca1e3c52696b8be$exports = {};
"use strict";
Object.defineProperty($4ca1e3c52696b8be$exports, "__esModule", {
    value: true
});
$4ca1e3c52696b8be$exports.getWindowMetadata = void 0;

function $4ca1e3c52696b8be$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $77e64dd613f9cca8$exports.getDocumentOrThrow();
        loc = $77e64dd613f9cca8$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$4ca1e3c52696b8be$exports.getWindowMetadata = $4ca1e3c52696b8be$var$getWindowMetadata;


var $d1ffd40e86b7fa1f$export$f9380c9a627682d3;
var $d1ffd40e86b7fa1f$export$98e6a39c04603d36;
var $d1ffd40e86b7fa1f$export$fac44ee5b035f737;
var $d1ffd40e86b7fa1f$export$7a5253c0f62e0150;
var $d1ffd40e86b7fa1f$export$a8c1621ea79325d3;
var $d1ffd40e86b7fa1f$export$357523c63a2253b9;
var $d1ffd40e86b7fa1f$export$44c361b8ec72ef7f;
'use strict';
var $294d26d8a99a3ff6$exports = {};
'use strict';
$294d26d8a99a3ff6$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $e1c58bf2e246f16d$exports = {};
'use strict';
var $e1c58bf2e246f16d$var$token = '%[a-f0-9]{2}';
var $e1c58bf2e246f16d$var$singleMatcher = new RegExp('(' + $e1c58bf2e246f16d$var$token + ')|([^%]+?)', 'gi');
var $e1c58bf2e246f16d$var$multiMatcher = new RegExp('(' + $e1c58bf2e246f16d$var$token + ')+', 'gi');
function $e1c58bf2e246f16d$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $e1c58bf2e246f16d$var$decodeComponents(left), $e1c58bf2e246f16d$var$decodeComponents(right));
}
function $e1c58bf2e246f16d$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $e1c58bf2e246f16d$var$decodeComponents(tokens, i).join('');
            tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e1c58bf2e246f16d$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $e1c58bf2e246f16d$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
$e1c58bf2e246f16d$exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $e1c58bf2e246f16d$var$customDecodeURIComponent(encodedURI);
    }
};


var $731a0efefa6baa63$exports = {};
'use strict';
$731a0efefa6baa63$exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $f2797a3f33da989b$exports = {};
'use strict';
$f2797a3f33da989b$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $d1ffd40e86b7fa1f$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $d1ffd40e86b7fa1f$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $d1ffd40e86b7fa1f$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            '[',
                            $d1ffd40e86b7fa1f$var$encode(index, options),
                            ']=',
                            $d1ffd40e86b7fa1f$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            '[]=',
                            $d1ffd40e86b7fa1f$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            ':list=',
                            $d1ffd40e86b7fa1f$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $d1ffd40e86b7fa1f$var$encode(key, options),
                                keyValueSep,
                                $d1ffd40e86b7fa1f$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $d1ffd40e86b7fa1f$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $d1ffd40e86b7fa1f$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $d1ffd40e86b7fa1f$var$encode(key, options),
                            '=',
                            $d1ffd40e86b7fa1f$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $d1ffd40e86b7fa1f$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $d1ffd40e86b7fa1f$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $d1ffd40e86b7fa1f$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$d1ffd40e86b7fa1f$var$decode(item, options)) : value === null ? value : $d1ffd40e86b7fa1f$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $d1ffd40e86b7fa1f$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$d1ffd40e86b7fa1f$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $d1ffd40e86b7fa1f$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $d1ffd40e86b7fa1f$var$encode(value, options) {
    if (options.encode) return options.strict ? $294d26d8a99a3ff6$exports(value) : encodeURIComponent(value);
    return value;
}
function $d1ffd40e86b7fa1f$var$decode(value, options) {
    if (options.decode) return $e1c58bf2e246f16d$exports(value);
    return value;
}
function $d1ffd40e86b7fa1f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $d1ffd40e86b7fa1f$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $d1ffd40e86b7fa1f$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $d1ffd40e86b7fa1f$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $d1ffd40e86b7fa1f$var$extract(input) {
    input = $d1ffd40e86b7fa1f$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $d1ffd40e86b7fa1f$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $d1ffd40e86b7fa1f$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $d1ffd40e86b7fa1f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $d1ffd40e86b7fa1f$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $731a0efefa6baa63$exports(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $d1ffd40e86b7fa1f$var$decode(value, options);
        formatter($d1ffd40e86b7fa1f$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $d1ffd40e86b7fa1f$var$parseValue(value[k], options);
        else ret[key] = $d1ffd40e86b7fa1f$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $d1ffd40e86b7fa1f$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$d1ffd40e86b7fa1f$export$f9380c9a627682d3 = $d1ffd40e86b7fa1f$var$extract;
$d1ffd40e86b7fa1f$export$98e6a39c04603d36 = $d1ffd40e86b7fa1f$var$parse;
$d1ffd40e86b7fa1f$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $d1ffd40e86b7fa1f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $d1ffd40e86b7fa1f$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $d1ffd40e86b7fa1f$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $d1ffd40e86b7fa1f$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $d1ffd40e86b7fa1f$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $d1ffd40e86b7fa1f$var$encode(key, options) + '=' + $d1ffd40e86b7fa1f$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$d1ffd40e86b7fa1f$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $731a0efefa6baa63$exports(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $d1ffd40e86b7fa1f$var$parse($d1ffd40e86b7fa1f$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $d1ffd40e86b7fa1f$var$decode(hash, options)
    } : {});
};
$d1ffd40e86b7fa1f$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$d1ffd40e86b7fa1f$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $d1ffd40e86b7fa1f$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $d1ffd40e86b7fa1f$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $d1ffd40e86b7fa1f$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $d1ffd40e86b7fa1f$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $d1ffd40e86b7fa1f$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$d1ffd40e86b7fa1f$var$encodeFragmentIdentifier] ? $d1ffd40e86b7fa1f$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$d1ffd40e86b7fa1f$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$d1ffd40e86b7fa1f$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $d1ffd40e86b7fa1f$export$7a5253c0f62e0150(input, options);
    return $d1ffd40e86b7fa1f$export$a8c1621ea79325d3({
        url: url,
        query: $f2797a3f33da989b$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$d1ffd40e86b7fa1f$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $d1ffd40e86b7fa1f$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $0026de0b4c1c15e7$exports = {};
$parcel$export($0026de0b4c1c15e7$exports, "RELAY_JSONRPC", function () { return $7146a15d65e314d8$export$af490b3b9a6de00f; });
var $c8ed3d444977616b$exports = {};


function $57bcb3f407d8f978$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $57bcb3f407d8f978$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $57bcb3f407d8f978$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $57bcb3f407d8f978$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $57bcb3f407d8f978$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $57bcb3f407d8f978$export$e4b3f942a6d00ef9(params, required.length) : $57bcb3f407d8f978$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $57bcb3f407d8f978$export$c538c02216fcdc03(params, required);
}
function $57bcb3f407d8f978$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}



function $ab0a4a67ec40aa9a$export$c75580565fa025bd(request) {
    return $ab0a4a67ec40aa9a$export$f576347163de0984(request.method) && $ab0a4a67ec40aa9a$export$dae2311546d43680(request.params);
}
function $ab0a4a67ec40aa9a$export$f576347163de0984(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "subscribe");
}
function $ab0a4a67ec40aa9a$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}
function $ab0a4a67ec40aa9a$export$8fa7cf76b41caee0(request) {
    return $ab0a4a67ec40aa9a$export$71d4d33ac7f7a269(request.method) && $ab0a4a67ec40aa9a$export$71e8d1aa48c3e86f(request.params);
}
function $ab0a4a67ec40aa9a$export$71d4d33ac7f7a269(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "publish");
}
function $ab0a4a67ec40aa9a$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}
function $ab0a4a67ec40aa9a$export$83e292763180b41b(request) {
    return $ab0a4a67ec40aa9a$export$568d956f39536025(request.method) && $ab0a4a67ec40aa9a$export$cbc597c53c3b4f80(request.params);
}
function $ab0a4a67ec40aa9a$export$568d956f39536025(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "unsubscribe");
}
function $ab0a4a67ec40aa9a$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}
function $ab0a4a67ec40aa9a$export$43cf4100d6287b8e(request) {
    return $ab0a4a67ec40aa9a$export$3cb4ad320e3a46a4(request.method) && $ab0a4a67ec40aa9a$export$6366ff9a39f2da4c(request.params);
}
function $ab0a4a67ec40aa9a$export$3cb4ad320e3a46a4(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "subscription");
}
function $ab0a4a67ec40aa9a$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}


function $e43832afd6651c15$export$abdf96c288cb375(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$f576347163de0984)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $ab0a4a67ec40aa9a$export$dae2311546d43680)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "topic");
    return params;
}
function $e43832afd6651c15$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$71d4d33ac7f7a269)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $ab0a4a67ec40aa9a$export$71e8d1aa48c3e86f)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "topic");
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "message");
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "ttl", "number");
    return params;
}
function $e43832afd6651c15$export$78baa72f78156594(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$568d956f39536025)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $ab0a4a67ec40aa9a$export$cbc597c53c3b4f80)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "id");
    return params;
}
function $e43832afd6651c15$export$4d5822edd41f3b48(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$3cb4ad320e3a46a4)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $ab0a4a67ec40aa9a$export$6366ff9a39f2da4c)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "id");
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "data");
    return params;
}


const $7146a15d65e314d8$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};



$parcel$exportWildcard($0026de0b4c1c15e7$exports, $c8ed3d444977616b$exports);


const $7ca7cbbf2d0451fa$var$K = ":";
function $7ca7cbbf2d0451fa$export$4764229d78de4437(e) {
    const [n, t] = e.split($7ca7cbbf2d0451fa$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $7ca7cbbf2d0451fa$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($7ca7cbbf2d0451fa$var$K);
}
function $7ca7cbbf2d0451fa$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($7ca7cbbf2d0451fa$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $7ca7cbbf2d0451fa$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($7ca7cbbf2d0451fa$var$K);
}
function $7ca7cbbf2d0451fa$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $7ca7cbbf2d0451fa$export$2806d446053abd1d(e) {
    const { address: n } = $7ca7cbbf2d0451fa$export$276ab0158c66e3d(e);
    return n;
}
function $7ca7cbbf2d0451fa$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $7ca7cbbf2d0451fa$export$276ab0158c66e3d(e);
    return $7ca7cbbf2d0451fa$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $7ca7cbbf2d0451fa$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $7ca7cbbf2d0451fa$export$4764229d78de4437(n);
    return $7ca7cbbf2d0451fa$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $7ca7cbbf2d0451fa$export$aa4a6b630dfcfa83(e) {
    return $7ca7cbbf2d0451fa$export$d579bc26e95946b5(e, $7ca7cbbf2d0451fa$export$2806d446053abd1d);
}
function $7ca7cbbf2d0451fa$export$d5ee58c6b13696e9(e) {
    return $7ca7cbbf2d0451fa$export$d579bc26e95946b5(e, $7ca7cbbf2d0451fa$export$93512919ec2ab555);
}
function $7ca7cbbf2d0451fa$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $7ca7cbbf2d0451fa$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$7ca7cbbf2d0451fa$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $7ca7cbbf2d0451fa$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$7ca7cbbf2d0451fa$export$376384387cd15b27(r, o));
    }), t;
}
function $7ca7cbbf2d0451fa$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $7ca7cbbf2d0451fa$export$a524ae552db7912 = (e)=>e?.split(":"), $7ca7cbbf2d0451fa$export$85f23c05c80b194 = (e)=>{
    const n = e && $7ca7cbbf2d0451fa$export$a524ae552db7912(e);
    if (n) return n[3];
}, $7ca7cbbf2d0451fa$export$a8b149927aef7051 = (e)=>{
    const n = e && $7ca7cbbf2d0451fa$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $7ca7cbbf2d0451fa$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $7ca7cbbf2d0451fa$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $7ca7cbbf2d0451fa$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $7ca7cbbf2d0451fa$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$7ca7cbbf2d0451fa$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $7ca7cbbf2d0451fa$export$f7403969428298bd = "base10", $7ca7cbbf2d0451fa$export$49eb910ab2518105 = "base16", $7ca7cbbf2d0451fa$export$9bff723d552e6bcf = "base64pad", $7ca7cbbf2d0451fa$export$9560dad2a83e4f04 = "utf8", $7ca7cbbf2d0451fa$export$3425bd336a9673d8 = 0, $7ca7cbbf2d0451fa$export$406e97c329f0f3d4 = 1, $7ca7cbbf2d0451fa$var$Dn = 0, $7ca7cbbf2d0451fa$var$Te = 1, $7ca7cbbf2d0451fa$var$Z = 12, $7ca7cbbf2d0451fa$var$X = 32;
function $7ca7cbbf2d0451fa$export$a949d36eab55b41f() {
    const e = $65448ed271866a3b$exports.generateKeyPair();
    return {
        privateKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.secretKey, $7ca7cbbf2d0451fa$export$49eb910ab2518105),
        publicKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.publicKey, $7ca7cbbf2d0451fa$export$49eb910ab2518105)
    };
}
function $7ca7cbbf2d0451fa$export$d15a28e4f1821243() {
    const e = (0, $a82db7e016d530d5$exports.randomBytes)($7ca7cbbf2d0451fa$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $7ca7cbbf2d0451fa$export$49eb910ab2518105);
}
function $7ca7cbbf2d0451fa$export$f8378f68e053f5c6(e, n) {
    const t = $65448ed271866a3b$exports.sharedKey((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $7ca7cbbf2d0451fa$export$49eb910ab2518105), (0, $56aa271a838dc1ea$export$3004f64547af360e)(n, $7ca7cbbf2d0451fa$export$49eb910ab2518105), !0), r = new (0, $73217b27b6ce6be7$exports.HKDF)((0, $489f6e82929df31f$exports.SHA256), t).expand($7ca7cbbf2d0451fa$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(r, $7ca7cbbf2d0451fa$export$49eb910ab2518105);
}
function $7ca7cbbf2d0451fa$export$1e87d19d4aab5805(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $7ca7cbbf2d0451fa$export$49eb910ab2518105));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $7ca7cbbf2d0451fa$export$49eb910ab2518105);
}
function $7ca7cbbf2d0451fa$export$d4c241cec96564c1(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $7ca7cbbf2d0451fa$export$9560dad2a83e4f04));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $7ca7cbbf2d0451fa$export$49eb910ab2518105);
}
function $7ca7cbbf2d0451fa$export$e9d2f9ba70428fb6(e) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)(`${e}`, $7ca7cbbf2d0451fa$export$f7403969428298bd);
}
function $7ca7cbbf2d0451fa$export$7547a514ee29b9d4(e) {
    return Number((0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $7ca7cbbf2d0451fa$export$f7403969428298bd));
}
function $7ca7cbbf2d0451fa$export$5b0f6292f11d1d18(e) {
    const n = $7ca7cbbf2d0451fa$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $7ca7cbbf2d0451fa$export$3425bd336a9673d8);
    if ($7ca7cbbf2d0451fa$export$7547a514ee29b9d4(n) === $7ca7cbbf2d0451fa$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.senderPublicKey, $7ca7cbbf2d0451fa$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.iv, $7ca7cbbf2d0451fa$export$49eb910ab2518105) : (0, $a82db7e016d530d5$exports.randomBytes)($7ca7cbbf2d0451fa$var$Z), o = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $7ca7cbbf2d0451fa$export$49eb910ab2518105)).seal(r, (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.message, $7ca7cbbf2d0451fa$export$9560dad2a83e4f04));
    return $7ca7cbbf2d0451fa$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $7ca7cbbf2d0451fa$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $7ca7cbbf2d0451fa$export$49eb910ab2518105)), { sealed: t, iv: r } = $7ca7cbbf2d0451fa$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(o, $7ca7cbbf2d0451fa$export$9560dad2a83e4f04);
}
function $7ca7cbbf2d0451fa$export$dfdc1655ccc5b9cb(e) {
    if ($7ca7cbbf2d0451fa$export$7547a514ee29b9d4(e.type) === $7ca7cbbf2d0451fa$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $7ca7cbbf2d0451fa$export$9bff723d552e6bcf);
    }
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $7ca7cbbf2d0451fa$export$9bff723d552e6bcf);
}
function $7ca7cbbf2d0451fa$export$efcd34ab6248d3cd(e) {
    const n = (0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $7ca7cbbf2d0451fa$export$9bff723d552e6bcf), t = n.slice($7ca7cbbf2d0451fa$var$Dn, $7ca7cbbf2d0451fa$var$Te), r = $7ca7cbbf2d0451fa$var$Te;
    if ($7ca7cbbf2d0451fa$export$7547a514ee29b9d4(t) === $7ca7cbbf2d0451fa$export$406e97c329f0f3d4) {
        const d = r + $7ca7cbbf2d0451fa$var$X, l = d + $7ca7cbbf2d0451fa$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $7ca7cbbf2d0451fa$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $7ca7cbbf2d0451fa$export$177f3e316562333d(e, n) {
    const t = $7ca7cbbf2d0451fa$export$efcd34ab6248d3cd(e);
    return $7ca7cbbf2d0451fa$export$7949f60f2444aef2({
        type: $7ca7cbbf2d0451fa$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(t.senderPublicKey, $7ca7cbbf2d0451fa$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $7ca7cbbf2d0451fa$export$7949f60f2444aef2(e) {
    const n = e?.type || $7ca7cbbf2d0451fa$export$3425bd336a9673d8;
    if (n === $7ca7cbbf2d0451fa$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $7ca7cbbf2d0451fa$export$8c165704db2d5c15(e) {
    return e.type === $7ca7cbbf2d0451fa$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $7ca7cbbf2d0451fa$var$Bn = Object.defineProperty, $7ca7cbbf2d0451fa$var$Ue = Object.getOwnPropertySymbols, $7ca7cbbf2d0451fa$var$Gn = Object.prototype.hasOwnProperty, $7ca7cbbf2d0451fa$var$Wn = Object.prototype.propertyIsEnumerable, $7ca7cbbf2d0451fa$var$_e = (e, n, t)=>n in e ? $7ca7cbbf2d0451fa$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $7ca7cbbf2d0451fa$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$7ca7cbbf2d0451fa$var$Gn.call(n, t) && $7ca7cbbf2d0451fa$var$_e(e, t, n[t]);
    if ($7ca7cbbf2d0451fa$var$Ue) for (var t of $7ca7cbbf2d0451fa$var$Ue(n))$7ca7cbbf2d0451fa$var$Wn.call(n, t) && $7ca7cbbf2d0451fa$var$_e(e, t, n[t]);
    return e;
};
const $7ca7cbbf2d0451fa$export$f12873d77424d47b = "ReactNative", $7ca7cbbf2d0451fa$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $7ca7cbbf2d0451fa$export$657dee6d5648750a = " ", $7ca7cbbf2d0451fa$export$96c3628b3b9d2079 = ":", $7ca7cbbf2d0451fa$export$98238152dfccf046 = "/", $7ca7cbbf2d0451fa$export$7f882bb969de14a3 = 2, $7ca7cbbf2d0451fa$export$77baccb4c6bd5852 = 1e3, $7ca7cbbf2d0451fa$export$e08b61c98317d88c = "js";
function $7ca7cbbf2d0451fa$export$8ee0fc9ee280b4ee() {
    return false;
}
function $7ca7cbbf2d0451fa$export$f7a1e23e542d38e3() {
    return !(0, $77e64dd613f9cca8$exports.getDocument)() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && navigator.product === $7ca7cbbf2d0451fa$export$f12873d77424d47b;
}
function $7ca7cbbf2d0451fa$export$4e09c449d6c407f7() {
    return !$7ca7cbbf2d0451fa$export$8ee0fc9ee280b4ee() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && !!(0, $77e64dd613f9cca8$exports.getDocument)();
}
function $7ca7cbbf2d0451fa$export$57570b1603cf6adb() {
    return $7ca7cbbf2d0451fa$export$f7a1e23e542d38e3() ? $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.reactNative : $7ca7cbbf2d0451fa$export$8ee0fc9ee280b4ee() ? $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.node : $7ca7cbbf2d0451fa$export$4e09c449d6c407f7() ? $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.browser : $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.unknown;
}
function $7ca7cbbf2d0451fa$export$40a40f90174d197c() {
    var e;
    try {
        return $7ca7cbbf2d0451fa$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $7ca7cbbf2d0451fa$export$c4147c69f6845da(e, n) {
    let t = $d1ffd40e86b7fa1f$export$98e6a39c04603d36(e);
    return t = $7ca7cbbf2d0451fa$var$$e($7ca7cbbf2d0451fa$var$$e({}, t), n), e = $d1ffd40e86b7fa1f$export$fac44ee5b035f737(t), e;
}
function $7ca7cbbf2d0451fa$export$ba31e015127122bb() {
    return (0, $4ca1e3c52696b8be$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $7ca7cbbf2d0451fa$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $7ca7cbbf2d0451fa$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $7ca7cbbf2d0451fa$export$20d4a3cb5829b8b6() {
    if ($7ca7cbbf2d0451fa$export$57570b1603cf6adb() === $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $e5e04069c5ff0401$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $7ca7cbbf2d0451fa$export$4389b0987726d52d() {
    var e;
    const n = $7ca7cbbf2d0451fa$export$57570b1603cf6adb();
    return n === $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $7ca7cbbf2d0451fa$export$b55a4c6e272b719f(e, n, t) {
    const r = $7ca7cbbf2d0451fa$export$20d4a3cb5829b8b6(), o = $7ca7cbbf2d0451fa$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $7ca7cbbf2d0451fa$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $7ca7cbbf2d0451fa$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $7ca7cbbf2d0451fa$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $7ca7cbbf2d0451fa$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $7ca7cbbf2d0451fa$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $7ca7cbbf2d0451fa$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $7ca7cbbf2d0451fa$export$1e21530e896c0b0b(e, n = $7ca7cbbf2d0451fa$export$7f882bb969de14a3) {
    return $7ca7cbbf2d0451fa$export$7f00885504704576(e.split($7ca7cbbf2d0451fa$export$98238152dfccf046), n);
}
function $7ca7cbbf2d0451fa$export$80bffd46c37a96f6(e) {
    return $7ca7cbbf2d0451fa$export$1e21530e896c0b0b(e).join($7ca7cbbf2d0451fa$export$657dee6d5648750a);
}
function $7ca7cbbf2d0451fa$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $7ca7cbbf2d0451fa$export$7f00885504704576(e, n = $7ca7cbbf2d0451fa$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $7ca7cbbf2d0451fa$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $7ca7cbbf2d0451fa$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $7ca7cbbf2d0451fa$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $7ca7cbbf2d0451fa$export$85c927578394b28b = (e)=>e;
function $7ca7cbbf2d0451fa$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $7ca7cbbf2d0451fa$export$9a00dee1beb8f576(e) {
    return e.split($7ca7cbbf2d0451fa$export$657dee6d5648750a).map((n)=>$7ca7cbbf2d0451fa$export$e9f8fcacef3bca4b(n)).join($7ca7cbbf2d0451fa$export$657dee6d5648750a);
}
function $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb(e = (0, $5t6iP.FIVE_MINUTES), n) {
    const t = (0, $5t6iP.toMiliseconds)(e || (0, $5t6iP.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $7ca7cbbf2d0451fa$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $7ca7cbbf2d0451fa$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $7ca7cbbf2d0451fa$export$43ab92477f8713b9(e) {
    return $7ca7cbbf2d0451fa$export$187ab6574b2ae23f("topic", e);
}
function $7ca7cbbf2d0451fa$export$bd13103c2e5cc0c3(e) {
    return $7ca7cbbf2d0451fa$export$187ab6574b2ae23f("id", e);
}
function $7ca7cbbf2d0451fa$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $7ca7cbbf2d0451fa$export$b136d03015bfc12(e, n) {
    return (0, $5t6iP.fromMiliseconds)((n || Date.now()) + (0, $5t6iP.toMiliseconds)(e));
}
function $7ca7cbbf2d0451fa$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $5t6iP.toMiliseconds)(e);
}
function $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $7ca7cbbf2d0451fa$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $7ca7cbbf2d0451fa$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $7ca7cbbf2d0451fa$export$57570b1603cf6adb();
        i === $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $7ca7cbbf2d0451fa$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($7ca7cbbf2d0451fa$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $7ca7cbbf2d0451fa$export$822d0bd1635d5360 = "irn";
function $7ca7cbbf2d0451fa$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $7ca7cbbf2d0451fa$export$822d0bd1635d5360
    };
}
function $7ca7cbbf2d0451fa$export$604e3deb95e1b734(e) {
    const n = (0, $7146a15d65e314d8$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $7ca7cbbf2d0451fa$var$bt = Object.defineProperty, $7ca7cbbf2d0451fa$var$Nt = Object.defineProperties, $7ca7cbbf2d0451fa$var$Ot = Object.getOwnPropertyDescriptors, $7ca7cbbf2d0451fa$var$qe = Object.getOwnPropertySymbols, $7ca7cbbf2d0451fa$var$St = Object.prototype.hasOwnProperty, $7ca7cbbf2d0451fa$var$wt = Object.prototype.propertyIsEnumerable, $7ca7cbbf2d0451fa$var$Be = (e, n, t)=>n in e ? $7ca7cbbf2d0451fa$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $7ca7cbbf2d0451fa$var$It = (e, n)=>{
    for(var t in n || (n = {}))$7ca7cbbf2d0451fa$var$St.call(n, t) && $7ca7cbbf2d0451fa$var$Be(e, t, n[t]);
    if ($7ca7cbbf2d0451fa$var$qe) for (var t of $7ca7cbbf2d0451fa$var$qe(n))$7ca7cbbf2d0451fa$var$wt.call(n, t) && $7ca7cbbf2d0451fa$var$Be(e, t, n[t]);
    return e;
}, $7ca7cbbf2d0451fa$var$Tt = (e, n)=>$7ca7cbbf2d0451fa$var$Nt(e, $7ca7cbbf2d0451fa$var$Ot(n));
function $7ca7cbbf2d0451fa$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $7ca7cbbf2d0451fa$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $d1ffd40e86b7fa1f$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $7ca7cbbf2d0451fa$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $7ca7cbbf2d0451fa$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $7ca7cbbf2d0451fa$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $7ca7cbbf2d0451fa$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $7ca7cbbf2d0451fa$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $d1ffd40e86b7fa1f$export$fac44ee5b035f737($7ca7cbbf2d0451fa$var$Tt($7ca7cbbf2d0451fa$var$It({
        symKey: e.symKey
    }, $7ca7cbbf2d0451fa$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $7ca7cbbf2d0451fa$var$At = Object.defineProperty, $7ca7cbbf2d0451fa$var$Ut = Object.defineProperties, $7ca7cbbf2d0451fa$var$_t = Object.getOwnPropertyDescriptors, $7ca7cbbf2d0451fa$var$Ye = Object.getOwnPropertySymbols, $7ca7cbbf2d0451fa$var$$t = Object.prototype.hasOwnProperty, $7ca7cbbf2d0451fa$var$Ct = Object.prototype.propertyIsEnumerable, $7ca7cbbf2d0451fa$var$Je = (e, n, t)=>n in e ? $7ca7cbbf2d0451fa$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $7ca7cbbf2d0451fa$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$7ca7cbbf2d0451fa$var$$t.call(n, t) && $7ca7cbbf2d0451fa$var$Je(e, t, n[t]);
    if ($7ca7cbbf2d0451fa$var$Ye) for (var t of $7ca7cbbf2d0451fa$var$Ye(n))$7ca7cbbf2d0451fa$var$Ct.call(n, t) && $7ca7cbbf2d0451fa$var$Je(e, t, n[t]);
    return e;
}, $7ca7cbbf2d0451fa$var$Dt = (e, n)=>$7ca7cbbf2d0451fa$var$Ut(e, $7ca7cbbf2d0451fa$var$_t(n));
function $7ca7cbbf2d0451fa$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $7ca7cbbf2d0451fa$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$7ca7cbbf2d0451fa$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $7ca7cbbf2d0451fa$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $7ca7cbbf2d0451fa$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $7ca7cbbf2d0451fa$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $7ca7cbbf2d0451fa$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $7ca7cbbf2d0451fa$export$a8daa26a7c60ef90(e, n) {
    const t = $7ca7cbbf2d0451fa$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $7ca7cbbf2d0451fa$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $7ca7cbbf2d0451fa$export$2994550cda701c96(n), s = $7ca7cbbf2d0451fa$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $7ca7cbbf2d0451fa$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $7ca7cbbf2d0451fa$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $7ca7cbbf2d0451fa$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $7ca7cbbf2d0451fa$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $7ca7cbbf2d0451fa$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $7ca7cbbf2d0451fa$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $7ca7cbbf2d0451fa$export$dd404c96fbbb1ff8(e) {
    return $7ca7cbbf2d0451fa$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $7ca7cbbf2d0451fa$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$7ca7cbbf2d0451fa$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $7ca7cbbf2d0451fa$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $7ca7cbbf2d0451fa$export$dd404c96fbbb1ff8(s);
        o[u] = $7ca7cbbf2d0451fa$var$Dt($7ca7cbbf2d0451fa$var$jt({}, o[u]), {
            chains: $7ca7cbbf2d0451fa$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $7ca7cbbf2d0451fa$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $7ca7cbbf2d0451fa$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $7ca7cbbf2d0451fa$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $7ca7cbbf2d0451fa$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $7ca7cbbf2d0451fa$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $7ca7cbbf2d0451fa$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $7ca7cbbf2d0451fa$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $7ca7cbbf2d0451fa$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $7ca7cbbf2d0451fa$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $7ca7cbbf2d0451fa$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e, n) {
    return n && $7ca7cbbf2d0451fa$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $7ca7cbbf2d0451fa$export$d6781b696a0576d1(e, n) {
    return n && $7ca7cbbf2d0451fa$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $7ca7cbbf2d0451fa$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $7ca7cbbf2d0451fa$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $7ca7cbbf2d0451fa$export$d46695d9c3664fe9(d), a = t[i];
        (!$7ca7cbbf2d0451fa$export$1468a49de573f7f9($7ca7cbbf2d0451fa$export$376384387cd15b27(i, a), u) || !$7ca7cbbf2d0451fa$export$1468a49de573f7f9(a.methods, l) || !$7ca7cbbf2d0451fa$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $7ca7cbbf2d0451fa$export$e544b39f0a22e47a(e) {
    return $7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $7ca7cbbf2d0451fa$export$49e4a5b6862e3c71(e) {
    if ($7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $7ca7cbbf2d0451fa$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $7ca7cbbf2d0451fa$export$bef94a5618bf18bf(e) {
    if ($7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $7ca7cbbf2d0451fa$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $7ca7cbbf2d0451fa$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $7ca7cbbf2d0451fa$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $7ca7cbbf2d0451fa$export$c12fced8176774f3(e) {
    let n = !0;
    return $7ca7cbbf2d0451fa$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$7ca7cbbf2d0451fa$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $7ca7cbbf2d0451fa$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $7ca7cbbf2d0451fa$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $7ca7cbbf2d0451fa$export$e544b39f0a22e47a(o) || (r = $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $7ca7cbbf2d0451fa$export$e544b39f0a22e47a(e) || (r = $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $7ca7cbbf2d0451fa$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $7ca7cbbf2d0451fa$export$df46c123d7e298ce(o, $7ca7cbbf2d0451fa$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $7ca7cbbf2d0451fa$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $7ca7cbbf2d0451fa$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $7ca7cbbf2d0451fa$export$49e4a5b6862e3c71(r) || (t = $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $7ca7cbbf2d0451fa$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $7ca7cbbf2d0451fa$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $7ca7cbbf2d0451fa$export$b32541d63753af56(e, n) {
    let t = null;
    return $7ca7cbbf2d0451fa$export$c12fced8176774f3(e?.methods) ? $7ca7cbbf2d0451fa$export$c12fced8176774f3(e?.events) || (t = $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $7ca7cbbf2d0451fa$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $7ca7cbbf2d0451fa$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $7ca7cbbf2d0451fa$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $7ca7cbbf2d0451fa$export$16a0268bc22b47b0(e)) {
        const o = $7ca7cbbf2d0451fa$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $7ca7cbbf2d0451fa$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $7ca7cbbf2d0451fa$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $7ca7cbbf2d0451fa$export$16a0268bc22b47b0(e)) {
        const r = $7ca7cbbf2d0451fa$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $7ca7cbbf2d0451fa$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $7ca7cbbf2d0451fa$export$1b3fc298be8c9a7b(e) {
    return $7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e.protocol, !0);
}
function $7ca7cbbf2d0451fa$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $7ca7cbbf2d0451fa$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $7ca7cbbf2d0451fa$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $7ca7cbbf2d0451fa$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $7ca7cbbf2d0451fa$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $7ca7cbbf2d0451fa$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$7ca7cbbf2d0451fa$export$d6781b696a0576d1(e.code, !1) || !e.message || !$7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e.message, !1));
}
function $7ca7cbbf2d0451fa$export$1a2af3c017fb6d42(e) {
    return !($7ca7cbbf2d0451fa$export$fce6876652108ab(e) || !$7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e.method, !1));
}
function $7ca7cbbf2d0451fa$export$1ae38cf0a848f651(e) {
    return !($7ca7cbbf2d0451fa$export$fce6876652108ab(e) || $7ca7cbbf2d0451fa$export$fce6876652108ab(e.result) && $7ca7cbbf2d0451fa$export$fce6876652108ab(e.error) || !$7ca7cbbf2d0451fa$export$d6781b696a0576d1(e.id, !1) || !$7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $7ca7cbbf2d0451fa$export$cbe4cdc5960cfa11(e) {
    return !($7ca7cbbf2d0451fa$export$fce6876652108ab(e) || !$7ca7cbbf2d0451fa$export$ee898ca48ab56c74(e.name, !1));
}
function $7ca7cbbf2d0451fa$export$144fc36610eb6522(e, n) {
    return !(!$7ca7cbbf2d0451fa$export$e544b39f0a22e47a(n) || !$7ca7cbbf2d0451fa$export$fb6db6038e742b14(e).includes(n));
}
function $7ca7cbbf2d0451fa$export$8db4804e3a6de711(e, n, t) {
    return $7ca7cbbf2d0451fa$export$ee898ca48ab56c74(t, !1) ? $7ca7cbbf2d0451fa$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $7ca7cbbf2d0451fa$export$df2c67ef8baad16b(e, n, t) {
    return $7ca7cbbf2d0451fa$export$ee898ca48ab56c74(t, !1) ? $7ca7cbbf2d0451fa$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $7ca7cbbf2d0451fa$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $7ca7cbbf2d0451fa$var$er(e), s = $7ca7cbbf2d0451fa$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $7ca7cbbf2d0451fa$var$pn(Object.keys(e)), c = $7ca7cbbf2d0451fa$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $7ca7cbbf2d0451fa$export$1468a49de573f7f9(i, d) || (r = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $7ca7cbbf2d0451fa$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($7ca7cbbf2d0451fa$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $7ca7cbbf2d0451fa$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $7ca7cbbf2d0451fa$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $7ca7cbbf2d0451fa$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $7ca7cbbf2d0451fa$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $7ca7cbbf2d0451fa$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $7ca7cbbf2d0451fa$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $7ca7cbbf2d0451fa$export$59fba2af1ac782b(e, n) {
    return $7ca7cbbf2d0451fa$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $7ca7cbbf2d0451fa$export$53c2fd0173ad2b80() {
    const e = $7ca7cbbf2d0451fa$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.browser:
                n($7ca7cbbf2d0451fa$export$2f147c609a999e49());
                break;
            case $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.reactNative:
                n($7ca7cbbf2d0451fa$export$1444c95b1570bd12());
                break;
            case $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.node:
                n($7ca7cbbf2d0451fa$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $7ca7cbbf2d0451fa$export$2f147c609a999e49() {
    return $7ca7cbbf2d0451fa$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $7ca7cbbf2d0451fa$export$1444c95b1570bd12() {
    if ($7ca7cbbf2d0451fa$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $7ca7cbbf2d0451fa$export$aec5b2d627eec500() {
    return !0;
}
function $7ca7cbbf2d0451fa$export$600a1ee4bc680996(e) {
    switch($7ca7cbbf2d0451fa$export$57570b1603cf6adb()){
        case $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.browser:
            $7ca7cbbf2d0451fa$export$d32b24f18d96c5f2(e);
            break;
        case $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.reactNative:
            $7ca7cbbf2d0451fa$export$904edb1c18ec91c7(e);
            break;
        case $7ca7cbbf2d0451fa$export$86b1301a63b15dd9.node:
            break;
    }
}
function $7ca7cbbf2d0451fa$export$d32b24f18d96c5f2(e) {
    !$7ca7cbbf2d0451fa$export$f7a1e23e542d38e3() && $7ca7cbbf2d0451fa$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $7ca7cbbf2d0451fa$export$904edb1c18ec91c7(e) {
    $7ca7cbbf2d0451fa$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $7ca7cbbf2d0451fa$var$ae = {};
class $7ca7cbbf2d0451fa$export$b72d712fed4d036d {
    static get(n) {
        return $7ca7cbbf2d0451fa$var$ae[n];
    }
    static set(n, t) {
        $7ca7cbbf2d0451fa$var$ae[n] = t;
    }
    static delete(n) {
        delete $7ca7cbbf2d0451fa$var$ae[n];
    }
}




var $5t6iP = parcelRequire("5t6iP");

var $jMc9N = parcelRequire("jMc9N");
var $d761c08357130c84$exports = {};
$parcel$export($d761c08357130c84$exports, "parseConnectionError", function () { return $14147cefa63870d2$export$f555d7d8f922e407; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcError", function () { return $1ec6bfddbfefe57e$exports.formatJsonRpcError; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcRequest", function () { return $1ec6bfddbfefe57e$exports.formatJsonRpcRequest; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcResult", function () { return $1ec6bfddbfefe57e$exports.formatJsonRpcResult; });
$parcel$export($d761c08357130c84$exports, "getBigIntRpcId", function () { return $1ec6bfddbfefe57e$exports.getBigIntRpcId; });
$parcel$export($d761c08357130c84$exports, "IJsonRpcProvider", function () { return $1ec6bfddbfefe57e$exports.IJsonRpcProvider; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcError", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcError; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcRequest", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcRequest; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResponse", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcResponse; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResult", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcResult; });
$parcel$export($d761c08357130c84$exports, "isLocalhostUrl", function () { return $1ec6bfddbfefe57e$exports.isLocalhostUrl; });
$parcel$export($d761c08357130c84$exports, "isReactNative", function () { return $1ec6bfddbfefe57e$exports.isReactNative; });
$parcel$export($d761c08357130c84$exports, "isWsUrl", function () { return $1ec6bfddbfefe57e$exports.isWsUrl; });
$parcel$export($d761c08357130c84$exports, "parseConnectionError", function () { return $1ec6bfddbfefe57e$exports.parseConnectionError; });
$parcel$export($d761c08357130c84$exports, "payloadId", function () { return $1ec6bfddbfefe57e$exports.payloadId; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcError", function () { return $259791faf8debdd7$export$9f7302ae26c3f77; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcRequest", function () { return $259791faf8debdd7$export$11d081ebb32d4398; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcResult", function () { return $259791faf8debdd7$export$478fdea01c2a3198; });
$parcel$export($d761c08357130c84$exports, "getBigIntRpcId", function () { return $259791faf8debdd7$export$799a3db5df197877; });
$parcel$export($d761c08357130c84$exports, "payloadId", function () { return $259791faf8debdd7$export$2f5364a5d4b80251; });
$parcel$export($d761c08357130c84$exports, "IJsonRpcProvider", function () { return $60d11f99137fc0b2$export$46957420a688a16d; });
$parcel$export($d761c08357130c84$exports, "isLocalhostUrl", function () { return $6dd669543a480c30$export$8eb4a0a481601f29; });
$parcel$export($d761c08357130c84$exports, "isWsUrl", function () { return $6dd669543a480c30$export$4e4463e75eccf20c; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcError", function () { return $f4d72c9188675517$export$5662a1047b4d1d15; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcRequest", function () { return $f4d72c9188675517$export$f6e4034abe07d2a5; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResponse", function () { return $f4d72c9188675517$export$308ba927de2bcbe8; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResult", function () { return $f4d72c9188675517$export$cb3d3b20e3223d77; });
const $5980472fa1fc5dc7$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $5980472fa1fc5dc7$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $5980472fa1fc5dc7$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $5980472fa1fc5dc7$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $5980472fa1fc5dc7$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $5980472fa1fc5dc7$export$125ebd30471ac25c = "SERVER_ERROR";
const $5980472fa1fc5dc7$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $5980472fa1fc5dc7$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $5980472fa1fc5dc7$export$cca5387ab287e1ae = {
    [$5980472fa1fc5dc7$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$5980472fa1fc5dc7$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$5980472fa1fc5dc7$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$5980472fa1fc5dc7$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$5980472fa1fc5dc7$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$5980472fa1fc5dc7$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $5980472fa1fc5dc7$export$d166979eca925bce = $5980472fa1fc5dc7$export$125ebd30471ac25c;



function $14147cefa63870d2$export$e463129eb4bc487f(code) {
    return code <= (0, $5980472fa1fc5dc7$export$fff5b44b15c75f69)[0] && code >= (0, $5980472fa1fc5dc7$export$fff5b44b15c75f69)[1];
}
function $14147cefa63870d2$export$2ae0ec6393ab16c3(code) {
    return (0, $5980472fa1fc5dc7$export$af84821b5448ca78).includes(code);
}
function $14147cefa63870d2$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $14147cefa63870d2$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)).includes(type)) return (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[0, $5980472fa1fc5dc7$export$d166979eca925bce];
    return (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[type];
}
function $14147cefa63870d2$export$60a3bac005957e12(code) {
    const match = Object.values((0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[0, $5980472fa1fc5dc7$export$d166979eca925bce];
    return match;
}
function $14147cefa63870d2$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$14147cefa63870d2$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($14147cefa63870d2$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $14147cefa63870d2$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[0, $5980472fa1fc5dc7$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $14147cefa63870d2$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $1ec6bfddbfefe57e$exports = {};
"use strict";
Object.defineProperty($1ec6bfddbfefe57e$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c99beea473744f6d$var$extendStatics = function(d, b) {
    $c99beea473744f6d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c99beea473744f6d$var$extendStatics(d, b);
};
function $c99beea473744f6d$export$a8ba968b8961cb8a(d, b) {
    $c99beea473744f6d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c99beea473744f6d$export$18ce0697a983be9b = function() {
    $c99beea473744f6d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c99beea473744f6d$export$18ce0697a983be9b.apply(this, arguments);
};
function $c99beea473744f6d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c99beea473744f6d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c99beea473744f6d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c99beea473744f6d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c99beea473744f6d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c99beea473744f6d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c99beea473744f6d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c99beea473744f6d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c99beea473744f6d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c99beea473744f6d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c99beea473744f6d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c99beea473744f6d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c99beea473744f6d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c99beea473744f6d$export$10c90e4f7922046c(v) {
    return this instanceof $c99beea473744f6d$export$10c90e4f7922046c ? (this.v = v, this) : new $c99beea473744f6d$export$10c90e4f7922046c(v);
}
function $c99beea473744f6d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c99beea473744f6d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c99beea473744f6d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c99beea473744f6d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c99beea473744f6d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c99beea473744f6d$export$19a8beecd37a4c45 === "function" ? $c99beea473744f6d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c99beea473744f6d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c99beea473744f6d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c99beea473744f6d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c99beea473744f6d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c99beea473744f6d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



$c99beea473744f6d$export$f33643c0debef087((parcelRequire("bw9Yg")), $1ec6bfddbfefe57e$exports);

$c99beea473744f6d$export$f33643c0debef087((parcelRequire("6rhnT")), $1ec6bfddbfefe57e$exports);


const $905db93922ffd651$export$d1694901a048d7c8 = (0, $1ec6bfddbfefe57e$exports.isNode);




function $259791faf8debdd7$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $259791faf8debdd7$export$799a3db5df197877(entropy = 6) {
    return BigInt($259791faf8debdd7$export$2f5364a5d4b80251(entropy));
}
function $259791faf8debdd7$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $259791faf8debdd7$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $259791faf8debdd7$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $259791faf8debdd7$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $259791faf8debdd7$export$5201d50a34753d71(error, data)
    };
}
function $259791faf8debdd7$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $14147cefa63870d2$export$e1599abf47b5b568)((0, $5980472fa1fc5dc7$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $14147cefa63870d2$export$e1599abf47b5b568)((0, $5980472fa1fc5dc7$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $14147cefa63870d2$export$2ae0ec6393ab16c3)(error.code)) error = (0, $14147cefa63870d2$export$60a3bac005957e12)(error.code);
    return error;
}


function $308daebfb2c3653f$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $308daebfb2c3653f$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $308daebfb2c3653f$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $308daebfb2c3653f$export$8e8b9bea55b56df2(route) {
    if ($308daebfb2c3653f$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $308daebfb2c3653f$export$2d48faaafcc8fbdc(route) {
    return !$308daebfb2c3653f$export$c7e2040809cad2c4(route) && $308daebfb2c3653f$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $308daebfb2c3653f$export$be298a4710fab756(route) {
    return !$308daebfb2c3653f$export$c7e2040809cad2c4(route) && $308daebfb2c3653f$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $5e6c30d627746be1$export$ab429ec7e240e546 {
}



class $60d11f99137fc0b2$export$77d426dd89724fbe extends (0, $5e6c30d627746be1$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $60d11f99137fc0b2$export$cb916a2eed49af33 extends (0, $5e6c30d627746be1$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $60d11f99137fc0b2$export$46957420a688a16d extends $60d11f99137fc0b2$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $6dd669543a480c30$var$HTTP_REGEX = "^https?:";
const $6dd669543a480c30$var$WS_REGEX = "^wss?:";
function $6dd669543a480c30$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $6dd669543a480c30$var$matchRegexProtocol(url, regex) {
    const protocol = $6dd669543a480c30$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $6dd669543a480c30$export$206c3129b8bb1b4f(url) {
    return $6dd669543a480c30$var$matchRegexProtocol(url, $6dd669543a480c30$var$HTTP_REGEX);
}
function $6dd669543a480c30$export$4e4463e75eccf20c(url) {
    return $6dd669543a480c30$var$matchRegexProtocol(url, $6dd669543a480c30$var$WS_REGEX);
}
function $6dd669543a480c30$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $f4d72c9188675517$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $f4d72c9188675517$export$f6e4034abe07d2a5(payload) {
    return $f4d72c9188675517$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $f4d72c9188675517$export$308ba927de2bcbe8(payload) {
    return $f4d72c9188675517$export$bf3617e9fafa893f(payload) && ($f4d72c9188675517$export$cb3d3b20e3223d77(payload) || $f4d72c9188675517$export$5662a1047b4d1d15(payload));
}
function $f4d72c9188675517$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $f4d72c9188675517$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $f4d72c9188675517$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $d4223bff86af1fbd$export$da28308012bf6748 extends (0, $60d11f99137fc0b2$export$46957420a688a16d) {
    constructor(connection){
        super(connection);
        this.events = new (0, $jMc9N.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $259791faf8debdd7$export$11d081ebb32d4398)(request.method, request.params || [], request.id || (0, $259791faf8debdd7$export$799a3db5df197877)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $f4d72c9188675517$export$5662a1047b4d1d15)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $f4d72c9188675517$export$308ba927de2bcbe8)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $d4223bff86af1fbd$export$2e2bcd8739ae039 = $d4223bff86af1fbd$export$da28308012bf6748;


var $8923b5a35766a3f9$export$2e2bcd8739ae039 = (0, $d4223bff86af1fbd$export$2e2bcd8739ae039);




var $jMc9N = parcelRequire("jMc9N");



const $2982830246d7e4aa$var$w = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("ivIUF")), $2982830246d7e4aa$var$b = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $2982830246d7e4aa$var$a = (c)=>c.split("?")[0], $2982830246d7e4aa$var$h = 10, $2982830246d7e4aa$var$S = $2982830246d7e4aa$var$w();
class $2982830246d7e4aa$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $jMc9N.EventEmitter), this.registering = !1, !(0, $6dd669543a480c30$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $6dd669543a480c30$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, o)=>{
                this.events.once("register_error", (s)=>{
                    this.resetMaxListeners(), o(s);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return o(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const o = new URLSearchParams(e).get("origin"), s = (0, $1ec6bfddbfefe57e$exports.isReactNative)() ? {
                headers: {
                    origin: o
                }
            } : {
                rejectUnauthorized: !(0, $6dd669543a480c30$export$8eb4a0a481601f29)(e)
            }, i = new $2982830246d7e4aa$var$S(e, [], s);
            $2982830246d7e4aa$var$b() ? i.onerror = (r)=>{
                const l = r;
                n(this.emitError(l.error));
            } : i.on("error", (r)=>{
                n(this.emitError(r));
            }), i.onopen = ()=>{
                this.onOpen(i), t(i);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), o = n.message || n.toString(), s = (0, $259791faf8debdd7$export$9f7302ae26c3f77)(e, o);
        this.events.emit("payload", s);
    }
    parseError(e, t = this.url) {
        return (0, $14147cefa63870d2$export$f555d7d8f922e407)(e, $2982830246d7e4aa$var$a(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $2982830246d7e4aa$var$h && this.events.setMaxListeners($2982830246d7e4aa$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$2982830246d7e4aa$var$a(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}



var $1DYgm = parcelRequire("1DYgm");
var $3de1b64a58624d5b$exports = {};


$3de1b64a58624d5b$exports = self.fetch || (self.fetch = (parcelRequire("dHHUN")).default || (parcelRequire("dHHUN")));


function $b9ab72458979c84f$var$Hi(n, e) {
    if (n.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < n.length; s++){
        var r = n.charAt(s), o = r.charCodeAt(0);
        if (t[o] !== 255) throw new TypeError(r + " is ambiguous");
        t[o] = s;
    }
    var a = n.length, h = n.charAt(0), l = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function p(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var m = 0, z = 0, I = 0, _ = u.length; I !== _ && u[I] === 0;)I++, m++;
        for(var T = (_ - I) * d + 1 >>> 0, f = new Uint8Array(T); I !== _;){
            for(var S = u[I], A = 0, C = T - 1; (S !== 0 || A < z) && C !== -1; C--, A++)S += 256 * f[C] >>> 0, f[C] = S % a >>> 0, S = S / a >>> 0;
            if (S !== 0) throw new Error("Non-zero carry");
            z = A, I++;
        }
        for(var x = T - z; x !== T && f[x] === 0;)x++;
        for(var j = h.repeat(m); x < T; ++x)j += n.charAt(f[x]);
        return j;
    }
    function y(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var m = 0;
        if (u[m] !== " ") {
            for(var z = 0, I = 0; u[m] === h;)z++, m++;
            for(var _ = (u.length - m) * l + 1 >>> 0, T = new Uint8Array(_); u[m];){
                var f = t[u.charCodeAt(m)];
                if (f === 255) return;
                for(var S = 0, A = _ - 1; (f !== 0 || S < I) && A !== -1; A--, S++)f += a * T[A] >>> 0, T[A] = f % 256 >>> 0, f = f / 256 >>> 0;
                if (f !== 0) throw new Error("Non-zero carry");
                I = S, m++;
            }
            if (u[m] !== " ") {
                for(var C = _ - I; C !== _ && T[C] === 0;)C++;
                for(var x = new Uint8Array(z + (_ - C)), j = z; C !== _;)x[j++] = T[C++];
                return x;
            }
        }
    }
    function M(u) {
        var m = y(u);
        if (m) return m;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: p,
        decodeUnsafe: y,
        decode: M
    };
}
var $b9ab72458979c84f$var$Ji = $b9ab72458979c84f$var$Hi, $b9ab72458979c84f$var$Xi = $b9ab72458979c84f$var$Ji;
const $b9ab72458979c84f$var$Ne = (n)=>{
    if (n instanceof Uint8Array && n.constructor.name === "Uint8Array") return n;
    if (n instanceof ArrayBuffer) return new Uint8Array(n);
    if (ArrayBuffer.isView(n)) return new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $b9ab72458979c84f$var$Wi = (n)=>new TextEncoder().encode(n), $b9ab72458979c84f$var$Qi = (n)=>new TextDecoder().decode(n);
class $b9ab72458979c84f$var$Zi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $b9ab72458979c84f$var$es {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $b9ab72458979c84f$var$Ue(this, e);
    }
}
class $b9ab72458979c84f$var$ts {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $b9ab72458979c84f$var$Ue(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $b9ab72458979c84f$var$Ue = (n, e)=>new $b9ab72458979c84f$var$ts({
        ...n.decoders || {
            [n.prefix]: n
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $b9ab72458979c84f$var$is {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $b9ab72458979c84f$var$Zi(e, t, i), this.decoder = new $b9ab72458979c84f$var$es(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $b9ab72458979c84f$var$W = ({ name: n, prefix: e, encode: t, decode: i })=>new $b9ab72458979c84f$var$is(n, e, t, i), $b9ab72458979c84f$var$B = ({ prefix: n, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $b9ab72458979c84f$var$Xi(t, e);
    return $b9ab72458979c84f$var$W({
        prefix: n,
        name: e,
        encode: i,
        decode: (r)=>$b9ab72458979c84f$var$Ne(s(r))
    });
}, $b9ab72458979c84f$var$ss = (n, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let r = n.length;
    for(; n[r - 1] === "=";)--r;
    const o = new Uint8Array(r * t / 8 | 0);
    let a = 0, h = 0, l = 0;
    for(let d = 0; d < r; ++d){
        const p = s[n[d]];
        if (p === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | p, a += t, a >= 8 && (a -= 8, o[l++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return o;
}, $b9ab72458979c84f$var$rs = (n, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let r = "", o = 0, a = 0;
    for(let h = 0; h < n.length; ++h)for(a = a << 8 | n[h], o += 8; o > t;)o -= t, r += e[s & a >> o];
    if (o && (r += e[s & a << t - o]), i) for(; r.length * t & 7;)r += "=";
    return r;
}, $b9ab72458979c84f$var$g = ({ name: n, prefix: e, bitsPerChar: t, alphabet: i })=>$b9ab72458979c84f$var$W({
        prefix: e,
        name: n,
        encode (s) {
            return $b9ab72458979c84f$var$rs(s, i, t);
        },
        decode (s) {
            return $b9ab72458979c84f$var$ss(s, i, t, n);
        }
    }), $b9ab72458979c84f$var$ns = $b9ab72458979c84f$var$W({
    prefix: "\0",
    name: "identity",
    encode: (n)=>$b9ab72458979c84f$var$Qi(n),
    decode: (n)=>$b9ab72458979c84f$var$Wi(n)
});
var $b9ab72458979c84f$var$os = Object.freeze({
    __proto__: null,
    identity: $b9ab72458979c84f$var$ns
});
const $b9ab72458979c84f$var$as = $b9ab72458979c84f$var$g({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $b9ab72458979c84f$var$hs = Object.freeze({
    __proto__: null,
    base2: $b9ab72458979c84f$var$as
});
const $b9ab72458979c84f$var$cs = $b9ab72458979c84f$var$g({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $b9ab72458979c84f$var$us = Object.freeze({
    __proto__: null,
    base8: $b9ab72458979c84f$var$cs
});
const $b9ab72458979c84f$var$ls = $b9ab72458979c84f$var$B({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $b9ab72458979c84f$var$ds = Object.freeze({
    __proto__: null,
    base10: $b9ab72458979c84f$var$ls
});
const $b9ab72458979c84f$var$gs = $b9ab72458979c84f$var$g({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $b9ab72458979c84f$var$ps = $b9ab72458979c84f$var$g({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $b9ab72458979c84f$var$Ds = Object.freeze({
    __proto__: null,
    base16: $b9ab72458979c84f$var$gs,
    base16upper: $b9ab72458979c84f$var$ps
});
const $b9ab72458979c84f$var$ys = $b9ab72458979c84f$var$g({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$ms = $b9ab72458979c84f$var$g({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$bs = $b9ab72458979c84f$var$g({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$fs = $b9ab72458979c84f$var$g({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$Es = $b9ab72458979c84f$var$g({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$ws = $b9ab72458979c84f$var$g({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$vs = $b9ab72458979c84f$var$g({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$Is = $b9ab72458979c84f$var$g({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$Cs = $b9ab72458979c84f$var$g({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $b9ab72458979c84f$var$Rs = Object.freeze({
    __proto__: null,
    base32: $b9ab72458979c84f$var$ys,
    base32upper: $b9ab72458979c84f$var$ms,
    base32pad: $b9ab72458979c84f$var$bs,
    base32padupper: $b9ab72458979c84f$var$fs,
    base32hex: $b9ab72458979c84f$var$Es,
    base32hexupper: $b9ab72458979c84f$var$ws,
    base32hexpad: $b9ab72458979c84f$var$vs,
    base32hexpadupper: $b9ab72458979c84f$var$Is,
    base32z: $b9ab72458979c84f$var$Cs
});
const $b9ab72458979c84f$var$_s = $b9ab72458979c84f$var$B({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $b9ab72458979c84f$var$Ts = $b9ab72458979c84f$var$B({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $b9ab72458979c84f$var$Ss = Object.freeze({
    __proto__: null,
    base36: $b9ab72458979c84f$var$_s,
    base36upper: $b9ab72458979c84f$var$Ts
});
const $b9ab72458979c84f$var$Ps = $b9ab72458979c84f$var$B({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $b9ab72458979c84f$var$xs = $b9ab72458979c84f$var$B({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $b9ab72458979c84f$var$Os = Object.freeze({
    __proto__: null,
    base58btc: $b9ab72458979c84f$var$Ps,
    base58flickr: $b9ab72458979c84f$var$xs
});
const $b9ab72458979c84f$var$As = $b9ab72458979c84f$var$g({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $b9ab72458979c84f$var$zs = $b9ab72458979c84f$var$g({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $b9ab72458979c84f$var$Ns = $b9ab72458979c84f$var$g({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $b9ab72458979c84f$var$Us = $b9ab72458979c84f$var$g({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $b9ab72458979c84f$var$Ls = Object.freeze({
    __proto__: null,
    base64: $b9ab72458979c84f$var$As,
    base64pad: $b9ab72458979c84f$var$zs,
    base64url: $b9ab72458979c84f$var$Ns,
    base64urlpad: $b9ab72458979c84f$var$Us
});
const $b9ab72458979c84f$var$Le = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $b9ab72458979c84f$var$$s = $b9ab72458979c84f$var$Le.reduce((n, e, t)=>(n[t] = e, n), []), $b9ab72458979c84f$var$Fs = $b9ab72458979c84f$var$Le.reduce((n, e, t)=>(n[e.codePointAt(0)] = t, n), []);
function $b9ab72458979c84f$var$Ms(n) {
    return n.reduce((e, t)=>(e += $b9ab72458979c84f$var$$s[t], e), "");
}
function $b9ab72458979c84f$var$ks(n) {
    const e = [];
    for (const t of n){
        const i = $b9ab72458979c84f$var$Fs[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $b9ab72458979c84f$var$Ks = $b9ab72458979c84f$var$W({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $b9ab72458979c84f$var$Ms,
    decode: $b9ab72458979c84f$var$ks
});
var $b9ab72458979c84f$var$Bs = Object.freeze({
    __proto__: null,
    base256emoji: $b9ab72458979c84f$var$Ks
}), $b9ab72458979c84f$var$Vs = $b9ab72458979c84f$var$Fe, $b9ab72458979c84f$var$$e = 128, $b9ab72458979c84f$var$qs = 127, $b9ab72458979c84f$var$js = ~$b9ab72458979c84f$var$qs, $b9ab72458979c84f$var$Gs = Math.pow(2, 31);
function $b9ab72458979c84f$var$Fe(n, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; n >= $b9ab72458979c84f$var$Gs;)e[t++] = n & 255 | $b9ab72458979c84f$var$$e, n /= 128;
    for(; n & $b9ab72458979c84f$var$js;)e[t++] = n & 255 | $b9ab72458979c84f$var$$e, n >>>= 7;
    return e[t] = n | 0, $b9ab72458979c84f$var$Fe.bytes = t - i + 1, e;
}
var $b9ab72458979c84f$var$Ys = $b9ab72458979c84f$var$he, $b9ab72458979c84f$var$Hs = 128, $b9ab72458979c84f$var$Me = 127;
function $b9ab72458979c84f$var$he(n, i) {
    var t = 0, i = i || 0, s = 0, r = i, o, a = n.length;
    do {
        if (r >= a) throw $b9ab72458979c84f$var$he.bytes = 0, new RangeError("Could not decode varint");
        o = n[r++], t += s < 28 ? (o & $b9ab72458979c84f$var$Me) << s : (o & $b9ab72458979c84f$var$Me) * Math.pow(2, s), s += 7;
    }while (o >= $b9ab72458979c84f$var$Hs);
    return $b9ab72458979c84f$var$he.bytes = r - i, t;
}
var $b9ab72458979c84f$var$Js = Math.pow(2, 7), $b9ab72458979c84f$var$Xs = Math.pow(2, 14), $b9ab72458979c84f$var$Ws = Math.pow(2, 21), $b9ab72458979c84f$var$Qs = Math.pow(2, 28), $b9ab72458979c84f$var$Zs = Math.pow(2, 35), $b9ab72458979c84f$var$er = Math.pow(2, 42), $b9ab72458979c84f$var$tr = Math.pow(2, 49), $b9ab72458979c84f$var$ir = Math.pow(2, 56), $b9ab72458979c84f$var$sr = Math.pow(2, 63), $b9ab72458979c84f$var$rr = function(n) {
    return n < $b9ab72458979c84f$var$Js ? 1 : n < $b9ab72458979c84f$var$Xs ? 2 : n < $b9ab72458979c84f$var$Ws ? 3 : n < $b9ab72458979c84f$var$Qs ? 4 : n < $b9ab72458979c84f$var$Zs ? 5 : n < $b9ab72458979c84f$var$er ? 6 : n < $b9ab72458979c84f$var$tr ? 7 : n < $b9ab72458979c84f$var$ir ? 8 : n < $b9ab72458979c84f$var$sr ? 9 : 10;
}, $b9ab72458979c84f$var$nr = {
    encode: $b9ab72458979c84f$var$Vs,
    decode: $b9ab72458979c84f$var$Ys,
    encodingLength: $b9ab72458979c84f$var$rr
}, $b9ab72458979c84f$var$ke = $b9ab72458979c84f$var$nr;
const $b9ab72458979c84f$var$Ke = (n, e, t = 0)=>($b9ab72458979c84f$var$ke.encode(n, e, t), e), $b9ab72458979c84f$var$Be = (n)=>$b9ab72458979c84f$var$ke.encodingLength(n), $b9ab72458979c84f$var$ce = (n, e)=>{
    const t = e.byteLength, i = $b9ab72458979c84f$var$Be(n), s = i + $b9ab72458979c84f$var$Be(t), r = new Uint8Array(s + t);
    return $b9ab72458979c84f$var$Ke(n, r, 0), $b9ab72458979c84f$var$Ke(t, r, i), r.set(e, s), new $b9ab72458979c84f$var$or(n, t, e, r);
};
class $b9ab72458979c84f$var$or {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $b9ab72458979c84f$var$Ve = ({ name: n, code: e, encode: t })=>new $b9ab72458979c84f$var$ar(n, e, t);
class $b9ab72458979c84f$var$ar {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $b9ab72458979c84f$var$ce(this.code, t) : t.then((i)=>$b9ab72458979c84f$var$ce(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $b9ab72458979c84f$var$qe = (n)=>async (e)=>new Uint8Array(await crypto.subtle.digest(n, e)), $b9ab72458979c84f$var$hr = $b9ab72458979c84f$var$Ve({
    name: "sha2-256",
    code: 18,
    encode: $b9ab72458979c84f$var$qe("SHA-256")
}), $b9ab72458979c84f$var$cr = $b9ab72458979c84f$var$Ve({
    name: "sha2-512",
    code: 19,
    encode: $b9ab72458979c84f$var$qe("SHA-512")
});
var $b9ab72458979c84f$var$ur = Object.freeze({
    __proto__: null,
    sha256: $b9ab72458979c84f$var$hr,
    sha512: $b9ab72458979c84f$var$cr
});
const $b9ab72458979c84f$var$je = 0, $b9ab72458979c84f$var$lr = "identity", $b9ab72458979c84f$var$Ge = $b9ab72458979c84f$var$Ne, $b9ab72458979c84f$var$dr = (n)=>$b9ab72458979c84f$var$ce($b9ab72458979c84f$var$je, $b9ab72458979c84f$var$Ge(n)), $b9ab72458979c84f$var$gr = {
    code: $b9ab72458979c84f$var$je,
    name: $b9ab72458979c84f$var$lr,
    encode: $b9ab72458979c84f$var$Ge,
    digest: $b9ab72458979c84f$var$dr
};
var $b9ab72458979c84f$var$pr = Object.freeze({
    __proto__: null,
    identity: $b9ab72458979c84f$var$gr
});
new TextEncoder, new TextDecoder;
const $b9ab72458979c84f$var$Ye = {
    ...$b9ab72458979c84f$var$os,
    ...$b9ab72458979c84f$var$hs,
    ...$b9ab72458979c84f$var$us,
    ...$b9ab72458979c84f$var$ds,
    ...$b9ab72458979c84f$var$Ds,
    ...$b9ab72458979c84f$var$Rs,
    ...$b9ab72458979c84f$var$Ss,
    ...$b9ab72458979c84f$var$Os,
    ...$b9ab72458979c84f$var$Ls,
    ...$b9ab72458979c84f$var$Bs
};
({
    ...$b9ab72458979c84f$var$ur,
    ...$b9ab72458979c84f$var$pr
});
function $b9ab72458979c84f$var$He(n) {
    return globalThis.Buffer != null ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : n;
}
function $b9ab72458979c84f$var$Dr(n = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $b9ab72458979c84f$var$He(globalThis.Buffer.allocUnsafe(n)) : new Uint8Array(n);
}
function $b9ab72458979c84f$var$Je(n, e, t, i) {
    return {
        name: n,
        prefix: e,
        encoder: {
            name: n,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $b9ab72458979c84f$var$Xe = $b9ab72458979c84f$var$Je("utf8", "u", (n)=>"u" + new TextDecoder("utf8").decode(n), (n)=>new TextEncoder().encode(n.substring(1))), $b9ab72458979c84f$var$ue = $b9ab72458979c84f$var$Je("ascii", "a", (n)=>{
    let e = "a";
    for(let t = 0; t < n.length; t++)e += String.fromCharCode(n[t]);
    return e;
}, (n)=>{
    n = n.substring(1);
    const e = $b9ab72458979c84f$var$Dr(n.length);
    for(let t = 0; t < n.length; t++)e[t] = n.charCodeAt(t);
    return e;
}), $b9ab72458979c84f$var$yr = {
    utf8: $b9ab72458979c84f$var$Xe,
    "utf-8": $b9ab72458979c84f$var$Xe,
    hex: $b9ab72458979c84f$var$Ye.base16,
    latin1: $b9ab72458979c84f$var$ue,
    ascii: $b9ab72458979c84f$var$ue,
    binary: $b9ab72458979c84f$var$ue,
    ...$b9ab72458979c84f$var$Ye
};
function $b9ab72458979c84f$var$mr(n, e = "utf8") {
    const t = $b9ab72458979c84f$var$yr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $b9ab72458979c84f$var$He(globalThis.Buffer.from(n, "utf-8")) : t.decoder.decode(`${t.prefix}${n}`);
}
const $b9ab72458979c84f$export$51b1c900ac262bdf = "wc", $b9ab72458979c84f$export$f30bd3c8747cdfbe = 2, $b9ab72458979c84f$export$d47601f9de5ee22b = "core", $b9ab72458979c84f$export$f258d29ae5e3d545 = `${$b9ab72458979c84f$export$51b1c900ac262bdf}@2:${$b9ab72458979c84f$export$d47601f9de5ee22b}:`, $b9ab72458979c84f$export$db0fdb6d486555c2 = {
    name: $b9ab72458979c84f$export$d47601f9de5ee22b,
    logger: "error"
}, $b9ab72458979c84f$export$ba920abfe854b85d = {
    database: ":memory:"
}, $b9ab72458979c84f$export$92a79f21481c803d = "crypto", $b9ab72458979c84f$export$3613aa6e652146e4 = "client_ed25519_seed", $b9ab72458979c84f$export$c4bc5e31a4d0ec78 = (0, $5t6iP.ONE_DAY), $b9ab72458979c84f$export$9d7218f72e8dc49b = "keychain", $b9ab72458979c84f$export$34f82f4ba0c3d769 = "0.3", $b9ab72458979c84f$export$9662bbc7d10cf481 = "messages", $b9ab72458979c84f$export$19dfd1896412c038 = "0.3", $b9ab72458979c84f$export$8ddbe6611b67d926 = (0, $5t6iP.SIX_HOURS), $b9ab72458979c84f$export$9d92662178f2abd1 = "publisher", $b9ab72458979c84f$export$822d0bd1635d5360 = "irn", $b9ab72458979c84f$export$5176ffa6778d6637 = "error", $b9ab72458979c84f$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $b9ab72458979c84f$export$27fee22bec112637 = "wss://relay.walletconnect.org", $b9ab72458979c84f$export$602d6e27611c3fcb = "relayer", $b9ab72458979c84f$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $b9ab72458979c84f$export$119b4645f6b233c8 = "_subscription", $b9ab72458979c84f$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $b9ab72458979c84f$export$11ccd39be2c57d6 = (0, $5t6iP.ONE_SECOND), $b9ab72458979c84f$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $b9ab72458979c84f$export$5f30917a6f8c9025 = "2.11.2", $b9ab72458979c84f$export$fb3eab7adf12329d = 1e4, $b9ab72458979c84f$export$629a342182ba24b = "0.3", $b9ab72458979c84f$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $b9ab72458979c84f$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $b9ab72458979c84f$export$9d35d0a6a3599be = (0, $5t6iP.THIRTY_DAYS), $b9ab72458979c84f$export$9c3a96bb670cddb8 = "subscription", $b9ab72458979c84f$export$fb57e03bef4c4cea = "0.3", $b9ab72458979c84f$export$9a2ddbfe54f8af77 = (0, $5t6iP.FIVE_SECONDS) * 1e3, $b9ab72458979c84f$export$390360ea476c6145 = "pairing", $b9ab72458979c84f$export$5593ec74b27d1b18 = "0.3", $b9ab72458979c84f$export$ee4b1978d0aedfad = (0, $5t6iP.THIRTY_DAYS), $b9ab72458979c84f$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $b9ab72458979c84f$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $b9ab72458979c84f$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $b9ab72458979c84f$export$160142c73cb99dc3 = "history", $b9ab72458979c84f$export$8eba9ce85616c607 = "0.3", $b9ab72458979c84f$export$4ddf883392bbc828 = "expirer", $b9ab72458979c84f$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $b9ab72458979c84f$export$717295846191925d = "0.3", $b9ab72458979c84f$export$3cfe73d6765db74 = (0, $5t6iP.ONE_DAY), $b9ab72458979c84f$export$3b58f2450f2297e3 = "verify-api", $b9ab72458979c84f$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com", $b9ab72458979c84f$export$4fe83ee8f9aec7b6 = "https://verify.walletconnect.org", $b9ab72458979c84f$export$be24df03c4baa778 = [
    $b9ab72458979c84f$export$7e3b1a28ddecdbaa,
    $b9ab72458979c84f$export$4fe83ee8f9aec7b6
], $b9ab72458979c84f$export$40c022d2cffe0adc = "echo", $b9ab72458979c84f$export$3c48c4faab79aab1 = "https://echo.walletconnect.com";
class $b9ab72458979c84f$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $b9ab72458979c84f$export$9d7218f72e8dc49b, this.version = $b9ab72458979c84f$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: r } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(r);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $7ca7cbbf2d0451fa$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $7ca7cbbf2d0451fa$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $b9ab72458979c84f$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), r = $d84f4f8904446ab3$export$a949d36eab55b41f(s);
            return $7a7c9fd5ff6ad871$export$1b29ef9371459e10(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $7ca7cbbf2d0451fa$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), o = $d84f4f8904446ab3$export$a949d36eab55b41f(r), a = (0, $7ca7cbbf2d0451fa$export$d15a28e4f1821243)(), h = $b9ab72458979c84f$export$c4bc5e31a4d0ec78;
            return await $d84f4f8904446ab3$export$a8dda30659d36d45(a, s, h, o);
        }, this.generateSharedKey = (s, r, o)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), h = (0, $7ca7cbbf2d0451fa$export$f8378f68e053f5c6)(a, r);
            return this.setSymKey(h, o);
        }, this.setSymKey = async (s, r)=>{
            this.isInitialized();
            const o = r || (0, $7ca7cbbf2d0451fa$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(o, s), o;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $7ca7cbbf2d0451fa$export$7949f60f2444aef2)(o), h = (0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(r);
            if ((0, $7ca7cbbf2d0451fa$export$8c165704db2d5c15)(a)) {
                const y = a.senderPublicKey, M = a.receiverPublicKey;
                s = await this.generateSharedKey(y, M);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: p } = a;
            return (0, $7ca7cbbf2d0451fa$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: p
            });
        }, this.decode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $7ca7cbbf2d0451fa$export$177f3e316562333d)(r, o);
            if ((0, $7ca7cbbf2d0451fa$export$8c165704db2d5c15)(a)) {
                const h = a.receiverPublicKey, l = a.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $7ca7cbbf2d0451fa$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: r
                });
                return (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const r = (0, $7ca7cbbf2d0451fa$export$efcd34ab6248d3cd)(s);
            return (0, $7ca7cbbf2d0451fa$export$7547a514ee29b9d4)(r.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const r = (0, $7ca7cbbf2d0451fa$export$efcd34ab6248d3cd)(s);
            return r.senderPublicKey ? (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(r.senderPublicKey, (0, $7ca7cbbf2d0451fa$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.keychain = i || new $b9ab72458979c84f$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($b9ab72458979c84f$export$3613aa6e652146e4);
        } catch  {
            e = (0, $7ca7cbbf2d0451fa$export$d15a28e4f1821243)(), await this.keychain.set($b9ab72458979c84f$export$3613aa6e652146e4, e);
        }
        return $b9ab72458979c84f$var$mr(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$4a2542d0790ac2fd extends (0, $ccb0ab7c4fc6b77f$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $b9ab72458979c84f$export$9662bbc7d10cf481, this.version = $b9ab72458979c84f$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const r = (0, $7ca7cbbf2d0451fa$export$d4c241cec96564c1)(s);
            let o = this.messages.get(i);
            return typeof o > "u" && (o = {}), typeof o[r] < "u" || (o[r] = s, this.messages.set(i, o), await this.persist()), r;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const r = this.get(i), o = (0, $7ca7cbbf2d0451fa$export$d4c241cec96564c1)(s);
            return typeof r[o] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $7ca7cbbf2d0451fa$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $7ca7cbbf2d0451fa$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$var$vr extends (0, $ccb0ab7c4fc6b77f$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $5t6iP.toMiliseconds)((0, $5t6iP.TEN_SECONDS) * 2), this.needsTransportRestart = !1, this.publish = async (i, s, r)=>{
            var o;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: r
                }
            });
            try {
                const a = r?.ttl || $b9ab72458979c84f$export$8ddbe6611b67d926, h = (0, $7ca7cbbf2d0451fa$export$cf77af25151525db)(r), l = r?.prompt || !1, d = r?.tag || 0, p = r?.id || (0, $259791faf8debdd7$export$799a3db5df197877)().toString(), y = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: a,
                        relay: h,
                        prompt: l,
                        tag: d,
                        id: p
                    }
                }, M = setTimeout(()=>this.queue.set(p, y), this.publishTimeout);
                try {
                    await await (0, $7ca7cbbf2d0451fa$export$3da2293b007ed708)(this.rpcPublish(i, s, a, h, l, d, p), this.publishTimeout, `Failed to publish payload, please try again. id:${p} tag:${d}`), this.removeRequestFromQueue(p), this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.publish, y);
                } catch (u) {
                    if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (o = r?.internal) != null && o.throwOnFailedPublish) throw this.removeRequestFromQueue(p), u;
                    return;
                } finally{
                    clearTimeout(M);
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: r
                    }
                });
            } catch (a) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(a), a;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, r, o, a) {
        var h, l, d, p;
        const y = {
            method: (0, $7ca7cbbf2d0451fa$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: r,
                tag: o
            },
            id: a
        };
        return (0, $7ca7cbbf2d0451fa$export$fce6876652108ab)((h = y.params) == null ? void 0 : h.prompt) && ((l = y.params) == null || delete l.prompt), (0, $7ca7cbbf2d0451fa$export$fce6876652108ab)((d = y.params) == null ? void 0 : d.tag) && ((p = y.params) == null || delete p.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($b9ab72458979c84f$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $b9ab72458979c84f$var$Ir {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((r)=>r !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $b9ab72458979c84f$var$Cr = Object.defineProperty, $b9ab72458979c84f$var$Rr = Object.defineProperties, $b9ab72458979c84f$var$_r = Object.getOwnPropertyDescriptors, $b9ab72458979c84f$var$At = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$Tr = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Sr = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$zt = (n, e, t)=>e in n ? $b9ab72458979c84f$var$Cr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$q = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$Tr.call(e, t) && $b9ab72458979c84f$var$zt(n, t, e[t]);
    if ($b9ab72458979c84f$var$At) for (var t of $b9ab72458979c84f$var$At(e))$b9ab72458979c84f$var$Sr.call(e, t) && $b9ab72458979c84f$var$zt(n, t, e[t]);
    return n;
}, $b9ab72458979c84f$var$De = (n, e)=>$b9ab72458979c84f$var$Rr(n, $b9ab72458979c84f$var$_r(e));
class $b9ab72458979c84f$export$60959659b2c22881 extends (0, $ccb0ab7c4fc6b77f$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $b9ab72458979c84f$var$Ir, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$9c3a96bb670cddb8, this.version = $b9ab72458979c84f$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const r = (0, $7ca7cbbf2d0451fa$export$cf77af25151525db)(s), o = {
                    topic: i,
                    relay: r
                };
                this.pending.set(i, o);
                const a = await this.rpcSubscribe(i, r);
                return this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>{
            if (this.topics.includes(i)) return !0;
            const s = `${this.pendingSubscriptionWatchLabel}_${i}`;
            return await new Promise((r, o)=>{
                const a = new (0, $5t6iP.Watch);
                a.start(s);
                const h = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(h), a.stop(s), r(!0)), a.elapsed(s) >= $b9ab72458979c84f$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(s), o(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $7ca7cbbf2d0451fa$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const r = (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $7ca7cbbf2d0451fa$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $7ca7cbbf2d0451fa$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.connection_stalled);
        }
        return (0, $7ca7cbbf2d0451fa$export$d4c241cec96564c1)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $7ca7cbbf2d0451fa$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $7ca7cbbf2d0451fa$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $7ca7cbbf2d0451fa$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $b9ab72458979c84f$var$De($b9ab72458979c84f$var$q({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $b9ab72458979c84f$var$q({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $b9ab72458979c84f$var$q({}, t)), this.topicMap.set(t.topic, e), this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.deleted, $b9ab72458979c84f$var$De($b9ab72458979c84f$var$q({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $7ca7cbbf2d0451fa$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$b9ab72458979c84f$var$De($b9ab72458979c84f$var$q({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on($b9ab72458979c84f$export$d56245796e2837d.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on($b9ab72458979c84f$export$d56245796e2837d.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on($b9ab72458979c84f$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $b9ab72458979c84f$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($b9ab72458979c84f$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $b9ab72458979c84f$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $b9ab72458979c84f$var$Pr = Object.defineProperty, $b9ab72458979c84f$var$Ut = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$xr = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Or = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$Lt = (n, e, t)=>e in n ? $b9ab72458979c84f$var$Pr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$Ar = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$xr.call(e, t) && $b9ab72458979c84f$var$Lt(n, t, e[t]);
    if ($b9ab72458979c84f$var$Ut) for (var t of $b9ab72458979c84f$var$Ut(e))$b9ab72458979c84f$var$Or.call(e, t) && $b9ab72458979c84f$var$Lt(n, t, e[t]);
    return n;
};
class $b9ab72458979c84f$export$70e73aa29a3d4407 extends (0, $ccb0ab7c4fc6b77f$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = new Map, this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            const i = t.id;
            try {
                await this.toEstablishConnection();
                const s = this.provider.request(t);
                return this.requestsInFlight.set(i, {
                    promise: s,
                    request: t
                }), await s;
            } catch (s) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(s), s;
            } finally{
                this.requestsInFlight.delete(i);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t);
        }, this.onConnectHandler = ()=>{
            this.events.emit($b9ab72458979c84f$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($b9ab72458979c84f$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $edb0745dd7881952$exports.generateChildLogger)(e.logger, this.name) : (0, $edb0745dd7881952$exports.pino)((0, $edb0745dd7881952$exports.getDefaultLoggerOptions)({
            level: e.logger || $b9ab72458979c84f$export$5176ffa6778d6637
        })), this.messages = new $b9ab72458979c84f$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $b9ab72458979c84f$export$60959659b2c22881(this, this.logger), this.publisher = new $b9ab72458979c84f$var$vr(this, this.logger), this.relayUrl = e?.relayUrl || $b9ab72458979c84f$export$a68061e6c48f332a, this.projectId = e.projectId, this.bundleId = (0, $7ca7cbbf2d0451fa$export$40a40f90174d197c)(), this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$b9ab72458979c84f$export$27fee22bec112637}...`), await this.restartTransport($b9ab72458979c84f$export$27fee22bec112637);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $b9ab72458979c84f$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        if (s) return s;
        let r;
        const o = (a)=>{
            a.topic === e && (this.subscriber.off($b9ab72458979c84f$export$24ff3e54e94ef413.created, o), r());
        };
        return await Promise.all([
            new Promise((a)=>{
                r = a, this.subscriber.on($b9ab72458979c84f$export$24ff3e54e94ef413.created, o);
            }),
            new Promise(async (a)=>{
                s = await this.subscriber.subscribe(e, t), a();
            })
        ]), s;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.requestsInFlight.size > 0 && (this.logger.debug("Waiting for all in-flight requests to finish before closing transport..."), this.requestsInFlight.forEach(async (e)=>{
            await e.promise;
        })), this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await (0, $7ca7cbbf2d0451fa$export$3da2293b007ed708)(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
            e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        if (!this.initialized) return t();
                        this.subscriber.once($b9ab72458979c84f$export$24ff3e54e94ef413.resubscribed, ()=>{
                            t();
                        });
                    }),
                    new Promise(async (t, i)=>{
                        try {
                            await (0, $7ca7cbbf2d0451fa$export$3da2293b007ed708)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
                        } catch (s) {
                            i(s);
                            return;
                        }
                        t();
                    })
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.provider.events.emit($b9ab72458979c84f$export$58062acf2f31ddf8.disconnect);
            } finally{
                this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
            }
        }
    }
    async restartTransport(e) {
        await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $7ca7cbbf2d0451fa$export$53c2fd0173ad2b80)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $d4223bff86af1fbd$export$da28308012bf6748)(new (0, $2982830246d7e4aa$export$ea0df116fa892998)((0, $7ca7cbbf2d0451fa$export$d875b3963ef774f5)({
            sdkVersion: $b9ab72458979c84f$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $f4d72c9188675517$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($b9ab72458979c84f$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: r } = t.data, o = {
                topic: i,
                message: s,
                publishedAt: r
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($b9ab72458979c84f$var$Ar({
                type: "event",
                event: t.id
            }, o)), this.events.emit(t.id, o), await this.acknowledgePayload(e), await this.onMessageEvent(o);
        } else (0, $f4d72c9188675517$export$308ba927de2bcbe8)(e) && this.events.emit($b9ab72458979c84f$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($b9ab72458979c84f$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $259791faf8debdd7$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
    }
    async registerEventListeners() {
        this.events.on($b9ab72458979c84f$export$d56245796e2837d.connection_stalled, ()=>{
            this.restartTransport().catch((t)=>this.logger.error(t));
        });
        let e = await (0, $7ca7cbbf2d0451fa$export$53c2fd0173ad2b80)();
        (0, $7ca7cbbf2d0451fa$export$600a1ee4bc680996)(async (t)=>{
            this.initialized && e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((i)=>this.logger.error(i))));
        });
    }
    onProviderDisconnect() {
        this.events.emit($b9ab72458979c84f$export$d56245796e2837d.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async ()=>{
            await this.restartTransport().catch((e)=>this.logger.error(e));
        }, (0, $5t6iP.toMiliseconds)($b9ab72458979c84f$export$11ccd39be2c57d6)));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (await this.confirmOnlineStateOrThrow(), !this.connected) {
            if (this.connectionAttemptInProgress) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var $b9ab72458979c84f$var$zr = Object.defineProperty, $b9ab72458979c84f$var$Ft = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$Nr = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Ur = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$Mt = (n, e, t)=>e in n ? $b9ab72458979c84f$var$zr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$kt = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$Nr.call(e, t) && $b9ab72458979c84f$var$Mt(n, t, e[t]);
    if ($b9ab72458979c84f$var$Ft) for (var t of $b9ab72458979c84f$var$Ft(e))$b9ab72458979c84f$var$Ur.call(e, t) && $b9ab72458979c84f$var$Mt(n, t, e[t]);
    return n;
};
class $b9ab72458979c84f$export$390f32400eaf98c9 extends (0, $ccb0ab7c4fc6b77f$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $b9ab72458979c84f$export$f258d29ae5e3d545, r){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $b9ab72458979c84f$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o)=>{
                this.getKey && o !== null && !(0, $7ca7cbbf2d0451fa$export$fce6876652108ab)(o) ? this.map.set(this.getKey(o), o) : (0, $7ca7cbbf2d0451fa$export$f657f7976bb2769d)(o) ? this.map.set(o.id, o) : (0, $7ca7cbbf2d0451fa$export$c96d5113768aaf5e)(o) && this.map.set(o.topic, o);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (o, a)=>{
            this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: o,
                value: a
            }), this.map.set(o, a), await this.persist());
        }, this.get = (o)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: o
            }), this.getData(o)), this.getAll = (o)=>(this.isInitialized(), o ? this.values.filter((a)=>Object.keys(o).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($1DYgm)))(a[h], o[h]))) : this.values), this.update = async (o, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: o,
                update: a
            });
            const h = $b9ab72458979c84f$var$kt($b9ab72458979c84f$var$kt({}, this.getData(o)), a);
            this.map.set(o, h), await this.persist();
        }, this.delete = async (o, a)=>{
            this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: o,
                reason: a
            }), this.map.delete(o), await this.persist());
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = r;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $b9ab72458979c84f$export$390360ea476c6145, this.version = $b9ab72458979c84f$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))), this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $7ca7cbbf2d0451fa$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $7ca7cbbf2d0451fa$export$d15a28e4f1821243)(), s = await this.core.crypto.setSymKey(i), r = (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)((0, $5t6iP.FIVE_MINUTES)), o = {
                protocol: $b9ab72458979c84f$export$822d0bd1635d5360
            }, a = {
                topic: s,
                expiry: r,
                relay: o,
                active: !1
            }, h = (0, $7ca7cbbf2d0451fa$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: o,
                expiryTimestamp: r
            });
            return await this.pairings.set(s, a), await this.core.relayer.subscribe(s), this.core.expirer.set(s, r), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: r, relay: o, expiryTimestamp: a } = (0, $7ca7cbbf2d0451fa$export$59f58847421cfb28)(i.uri);
            let h;
            if (this.pairings.keys.includes(s) && (h = this.pairings.get(s), h.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            const l = a || (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)((0, $5t6iP.FIVE_MINUTES)), d = {
                topic: s,
                relay: o,
                expiry: l,
                active: !1
            };
            return await this.pairings.set(s, d), this.core.expirer.set(s, l), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.create, d), this.core.crypto.keychain.has(s) || (await this.core.crypto.setSymKey(r, s), await this.core.relayer.subscribe(s, {
                relay: o
            })), d;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)((0, $5t6iP.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const r = await this.sendRequest(s, "wc_pairingPing", {}), { done: o, resolve: a, reject: h } = (0, $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("pairing_ping", r), ({ error: l })=>{
                    l ? h(l) : a();
                }), await o();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, r)=>{
            const o = (0, $259791faf8debdd7$export$11d081ebb32d4398)(s, r), a = await this.core.crypto.encode(i, o), h = $b9ab72458979c84f$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, o), this.core.relayer.publish(i, a, h), o.id;
        }, this.sendResult = async (i, s, r)=>{
            const o = (0, $259791faf8debdd7$export$478fdea01c2a3198)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $b9ab72458979c84f$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.sendError = async (i, s, r)=>{
            const o = (0, $259791faf8debdd7$export$9f7302ae26c3f77)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $b9ab72458979c84f$export$d94d6986a8185883[h.request.method] ? $b9ab72458979c84f$export$d94d6986a8185883[h.request.method].res : $b9ab72458979c84f$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: r } = i;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, r);
                default:
                    return this.onUnknownRpcMethodRequest(s, r);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: r } = i, o = (await this.core.history.get(s, r.id)).request.method;
            switch(o){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, r);
                default:
                    return this.onUnknownRpcMethodResponse(o);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(r, i, !0), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: r } = s;
            setTimeout(()=>{
                (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("pairing_ping", r), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("pairing_ping", r), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: r, method: o } = s;
            try {
                if (this.registeredMethods.includes(o)) return;
                const a = (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", o);
                await this.sendError(r, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            var s;
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(i)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(o);
            }
            if (!(0, $7ca7cbbf2d0451fa$export$bef94a5618bf18bf)(i.uri)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(o);
            }
            const r = (0, $7ca7cbbf2d0451fa$export$59f58847421cfb28)(i.uri);
            if (!((s = r?.relay) != null && s.protocol)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw new Error(o);
            }
            if (!(r != null && r.symKey)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw new Error(o);
            }
            if (r != null && r.expiryTimestamp && (0, $5t6iP.toMiliseconds)(r?.expiryTimestamp) < Date.now()) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(o);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.pairings = new $b9ab72458979c84f$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($b9ab72458979c84f$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $f4d72c9188675517$export$f6e4034abe07d2a5)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $f4d72c9188675517$export$308ba927de2bcbe8)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (r) {
                this.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($b9ab72458979c84f$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $7ca7cbbf2d0451fa$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $b9ab72458979c84f$export$eeb4f10f25d479cb extends (0, $ccb0ab7c4fc6b77f$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$160142c73cb99dc3, this.version = $b9ab72458979c84f$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: r
            }), this.records.has(s.id)) return;
            const o = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: r,
                expiry: (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)((0, $5t6iP.THIRTY_DAYS))
            };
            this.records.set(o.id, o), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.created, o);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $f4d72c9188675517$export$5662a1047b4d1d15)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((r)=>{
                if (r.topic === i) {
                    if (typeof s < "u" && r.id !== s) return;
                    this.records.delete(r.id), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.deleted, r);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $259791faf8debdd7$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($b9ab72458979c84f$export$a682338b5ffca937.created, (e)=>{
            const t = $b9ab72458979c84f$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$a682338b5ffca937.updated, (e)=>{
            const t = $b9ab72458979c84f$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$a682338b5ffca937.deleted, (e)=>{
            const t = $b9ab72458979c84f$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $5t6iP.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$e76805ce609031cb extends (0, $ccb0ab7c4fc6b77f$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$4ddf883392bbc828, this.version = $b9ab72458979c84f$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const r = this.formatTarget(i), o = {
                target: r,
                expiry: s
            };
            this.expirations.set(r, o), this.checkExpiry(r, o), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.created, {
                target: r,
                expiration: o
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), r = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: r
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $7ca7cbbf2d0451fa$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $7ca7cbbf2d0451fa$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $5t6iP.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($b9ab72458979c84f$export$9013719d9206b0c1.created, (e)=>{
            const t = $b9ab72458979c84f$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$9013719d9206b0c1.expired, (e)=>{
            const t = $b9ab72458979c84f$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $b9ab72458979c84f$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$91a8e56769aeb334 extends (0, $ccb0ab7c4fc6b77f$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $b9ab72458979c84f$export$3b58f2450f2297e3, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (i)=>{
            if (this.verifyDisabled || (0, $7ca7cbbf2d0451fa$export$f7a1e23e542d38e3)() || !(0, $7ca7cbbf2d0451fa$export$4e09c449d6c407f7)()) return;
            const s = this.getVerifyUrl(i?.verifyUrl);
            this.verifyUrl !== s && this.removeIframe(), this.verifyUrl = s;
            try {
                await this.createIframe();
            } catch (r) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = $b9ab72458979c84f$export$4fe83ee8f9aec7b6;
                try {
                    await this.createIframe();
                } catch (r) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = this.getVerifyUrl(i?.verifyUrl);
            let r;
            try {
                r = await this.fetchAttestation(i.attestationId, s);
            } catch (o) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(o), r = await this.fetchAttestation(i.attestationId, $b9ab72458979c84f$export$4fe83ee8f9aec7b6);
            }
            return r;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const r = this.startAbortTimer((0, $5t6iP.ONE_SECOND) * 2), o = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(r), o.status === 200 ? await o.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (r)=>{
                r.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((r)=>{
                    if (document.getElementById($b9ab72458979c84f$export$3b58f2450f2297e3)) return r();
                    window.addEventListener("message", s);
                    const o = document.createElement("iframe");
                    o.id = $b9ab72458979c84f$export$3b58f2450f2297e3, o.src = `${this.verifyUrl}/${this.projectId}`, o.style.display = "none", document.body.append(o), this.iframe = o, i = r;
                }),
                new Promise((r, o)=>setTimeout(()=>{
                        window.removeEventListener("message", s), o("verify iframe load timeout");
                    }, (0, $5t6iP.toMiliseconds)((0, $5t6iP.FIVE_SECONDS))))
            ]);
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.getVerifyUrl = (i)=>{
            let s = i || $b9ab72458979c84f$export$7e3b1a28ddecdbaa;
            return $b9ab72458979c84f$export$be24df03c4baa778.includes(s) || (this.logger.info(`verify url: ${s}, not included in trusted list, assigning default: ${$b9ab72458979c84f$export$7e3b1a28ddecdbaa}`), s = $b9ab72458979c84f$export$7e3b1a28ddecdbaa), s;
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.verifyUrl = $b9ab72458979c84f$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $7ca7cbbf2d0451fa$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $5t6iP.toMiliseconds)(e));
    }
}
class $b9ab72458979c84f$export$c393c48c5b0cf59a extends (0, $ccb0ab7c4fc6b77f$export$7db533fb638f979d) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $b9ab72458979c84f$export$40c022d2cffe0adc, this.registerDeviceToken = async (i)=>{
            const { clientId: s, token: r, notificationType: o, enableEncrypted: a = !1 } = i, h = `${$b9ab72458979c84f$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await (0, (/*@__PURE__*/$parcel$interopDefault($3de1b64a58624d5b$exports)))(h, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: o,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.context);
    }
}
var $b9ab72458979c84f$var$Lr = Object.defineProperty, $b9ab72458979c84f$var$Yt = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$$r = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Fr = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$Ht = (n, e, t)=>e in n ? $b9ab72458979c84f$var$Lr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$Jt = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$$r.call(e, t) && $b9ab72458979c84f$var$Ht(n, t, e[t]);
    if ($b9ab72458979c84f$var$Yt) for (var t of $b9ab72458979c84f$var$Yt(e))$b9ab72458979c84f$var$Fr.call(e, t) && $b9ab72458979c84f$var$Ht(n, t, e[t]);
    return n;
};
class $b9ab72458979c84f$export$2e2bcd8739ae039 extends (0, $ccb0ab7c4fc6b77f$export$ed533416df113881) {
    constructor(e){
        super(e), this.protocol = $b9ab72458979c84f$export$51b1c900ac262bdf, this.version = $b9ab72458979c84f$export$f30bd3c8747cdfbe, this.name = $b9ab72458979c84f$export$d47601f9de5ee22b, this.events = new (0, $jMc9N.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $b9ab72458979c84f$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $edb0745dd7881952$exports.pino)((0, $edb0745dd7881952$exports.getDefaultLoggerOptions)({
            level: e?.logger || $b9ab72458979c84f$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.heartbeat = new (0, $ebef95dfb67b1a3a$exports.HeartBeat), this.crypto = new $b9ab72458979c84f$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $b9ab72458979c84f$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $b9ab72458979c84f$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $409b09bfc77a18bb$export$8536778e426ddf92)($b9ab72458979c84f$var$Jt($b9ab72458979c84f$var$Jt({}, $b9ab72458979c84f$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $b9ab72458979c84f$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $b9ab72458979c84f$export$3370ee24730992a3(this, this.logger), this.verify = new $b9ab72458979c84f$export$91a8e56769aeb334(this.projectId || "", this.logger), this.echoClient = new $b9ab72458979c84f$export$c393c48c5b0cf59a(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $b9ab72458979c84f$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($b9ab72458979c84f$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $b9ab72458979c84f$export$4143ab5b91744744 = $b9ab72458979c84f$export$2e2bcd8739ae039;






var $jMc9N = parcelRequire("jMc9N");

var $5t6iP = parcelRequire("5t6iP");

const $8ca29bbccfa76532$export$4fa962fc67384e02 = "wc", $8ca29bbccfa76532$export$61085c48796ff049 = 2, $8ca29bbccfa76532$export$94715592c220319a = "client", $8ca29bbccfa76532$export$7fa6f9ee1e2cab96 = `${$8ca29bbccfa76532$export$4fa962fc67384e02}@${$8ca29bbccfa76532$export$61085c48796ff049}:${$8ca29bbccfa76532$export$94715592c220319a}:`, $8ca29bbccfa76532$export$8dffb3242f2c5f72 = {
    name: $8ca29bbccfa76532$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $8ca29bbccfa76532$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_request_expire: "session_request_expire"
}, $8ca29bbccfa76532$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $8ca29bbccfa76532$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $8ca29bbccfa76532$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $8ca29bbccfa76532$export$160142c73cb99dc3 = "history", $8ca29bbccfa76532$export$8eba9ce85616c607 = "0.3", $8ca29bbccfa76532$export$ae6c7a4f7ed730a1 = "proposal", $8ca29bbccfa76532$export$6db28e89b135a53c = (0, $5t6iP.THIRTY_DAYS), $8ca29bbccfa76532$export$1e6a4dc5172f4830 = "Proposal expired", $8ca29bbccfa76532$export$a069e98a8dfeec1e = "session", $8ca29bbccfa76532$export$84b1b9dbcdea0475 = (0, $5t6iP.SEVEN_DAYS), $8ca29bbccfa76532$export$2db42d5151ad6eb8 = "engine", $8ca29bbccfa76532$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, $8ca29bbccfa76532$export$409f0c0a13a1b7c6 = {
    min: (0, $5t6iP.FIVE_MINUTES),
    max: (0, $5t6iP.SEVEN_DAYS)
}, $8ca29bbccfa76532$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $8ca29bbccfa76532$export$40b296af21bd38a4 = "request", $8ca29bbccfa76532$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $8ca29bbccfa76532$var$as = Object.defineProperty, $8ca29bbccfa76532$var$cs = Object.defineProperties, $8ca29bbccfa76532$var$ls = Object.getOwnPropertyDescriptors, $8ca29bbccfa76532$var$de = Object.getOwnPropertySymbols, $8ca29bbccfa76532$var$ps = Object.prototype.hasOwnProperty, $8ca29bbccfa76532$var$hs = Object.prototype.propertyIsEnumerable, $8ca29bbccfa76532$var$ue = (w, r, e)=>r in w ? $8ca29bbccfa76532$var$as(w, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : w[r] = e, $8ca29bbccfa76532$var$g = (w, r)=>{
    for(var e in r || (r = {}))$8ca29bbccfa76532$var$ps.call(r, e) && $8ca29bbccfa76532$var$ue(w, e, r[e]);
    if ($8ca29bbccfa76532$var$de) for (var e of $8ca29bbccfa76532$var$de(r))$8ca29bbccfa76532$var$hs.call(r, e) && $8ca29bbccfa76532$var$ue(w, e, r[e]);
    return w;
}, $8ca29bbccfa76532$var$D = (w, r)=>$8ca29bbccfa76532$var$cs(w, $8ca29bbccfa76532$var$ls(r));
class $8ca29bbccfa76532$var$ds extends (0, $ccb0ab7c4fc6b77f$export$87df43c730effa30) {
    constructor(r){
        super(r), this.name = $8ca29bbccfa76532$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $7ca7cbbf2d0451fa$export$406e97c329f0f3d4)
        ], this.requestQueue = {
            state: $8ca29bbccfa76532$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $8ca29bbccfa76532$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $5t6iP.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($8ca29bbccfa76532$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $5t6iP.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            await this.isInitialized();
            const s = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let c = t, p, d = !1;
            if (c && (d = this.client.core.pairing.pairings.get(c).active), !c || !d) {
                const { topic: T, uri: _ } = await this.client.core.pairing.create();
                c = T, p = _;
            }
            const h = await this.client.core.crypto.generateKeyPair(), N = $8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $5t6iP.FIVE_MINUTES), m = (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)(N), f = $8ca29bbccfa76532$var$g({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, $b9ab72458979c84f$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiryTimestamp: m
            }, o && {
                sessionProperties: o
            }), { reject: k, resolve: O, done: we } = (0, $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb)(N, $8ca29bbccfa76532$export$1e6a4dc5172f4830);
            if (this.events.once((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: T, session: _ })=>{
                if (T) k(T);
                else if (_) {
                    _.self.publicKey = h;
                    const B = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, _), {
                        requiredNamespaces: f.requiredNamespaces,
                        optionalNamespaces: f.optionalNamespaces
                    });
                    await this.client.session.set(_.topic, B), await this.setExpiry(_.topic, _.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: _.peer.metadata
                    }), O(B);
                }
            }), !c) {
                const { message: T } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(T);
            }
            const W = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: f,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(W, $8ca29bbccfa76532$var$g({
                id: W
            }, f)), {
                uri: p,
                approval: we
            };
        }, this.pair = async (e)=>(await this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            await this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: c, requiredNamespaces: p, optionalNamespaces: d } = o;
            a = a || "";
            const h = await this.client.core.crypto.generateKeyPair(), N = c.publicKey, m = await this.client.core.crypto.generateSharedKey(h, N);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: c.metadata
            }), await this.sendResult({
                id: s,
                topic: a,
                result: {
                    relay: {
                        protocol: t ?? "irn"
                    },
                    responderPublicKey: h
                }
            }), await this.client.proposal.delete(s, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const f = $8ca29bbccfa76532$var$g({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                pairingTopic: a,
                controller: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiry: (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(m);
            const k = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, f), {
                topic: m,
                requiredNamespaces: p,
                optionalNamespaces: d,
                pairingTopic: a,
                acknowledged: !1,
                self: f.controller,
                peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                },
                controller: h
            });
            await this.client.session.set(m, k);
            try {
                await this.sendRequest({
                    topic: m,
                    method: "wc_sessionSettle",
                    params: f,
                    throwOnFailedPublish: !0
                });
            } catch (O) {
                throw this.client.logger.error(O), this.client.session.delete(m, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(m), O;
            }
            return await this.setExpiry(m, (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)), {
                topic: m,
                acknowledged: ()=>new Promise((O)=>setTimeout(()=>O(this.client.session.get(m)), 500))
            };
        }, this.reject = async (e)=>{
            await this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            await this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest({
                topic: s,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: t
                }
            }), { done: n, resolve: o, reject: a } = (0, $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_update", i), ({ error: c })=>{
                c ? a(c) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            await this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest({
                topic: s,
                method: "wc_sessionExtend",
                params: {}
            }), { done: i, resolve: n, reject: o } = (0, $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            await this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n = $8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = e, o = (0, $259791faf8debdd7$export$2f5364a5d4b80251)(), { done: a, resolve: c, reject: p } = (0, $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb)(n, "Request expired. Please try again.");
            return this.events.once((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_request", o), ({ error: d, result: h })=>{
                d ? p(d) : c(h);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: o,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, t), {
                                expiryTimestamp: (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)(n)
                            }),
                            chainId: s
                        },
                        expiry: n,
                        throwOnFailedPublish: !0
                    }).catch((h)=>p(h)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: t,
                        chainId: s,
                        id: o
                    }), d();
                }),
                new Promise(async (d)=>{
                    const h = await (0, $7ca7cbbf2d0451fa$export$e55bfdac47149a32)(this.client.core.storage, $8ca29bbccfa76532$export$a26ccd6441b7d638);
                    (0, $7ca7cbbf2d0451fa$export$694a208c8abca99a)({
                        id: o,
                        topic: i,
                        wcDeepLink: h
                    }), d();
                }),
                a()
            ]).then((d)=>d[2]);
        }, this.respond = async (e)=>{
            await this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(t) ? await this.sendResult({
                id: i,
                topic: s,
                result: t.result,
                throwOnFailedPublish: !0
            }) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            await this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest({
                    topic: s,
                    method: "wc_sessionPing",
                    params: {}
                }), { done: i, resolve: n, reject: o } = (0, $7ca7cbbf2d0451fa$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            await this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest({
                topic: s,
                method: "wc_sessionEvent",
                params: {
                    event: t,
                    chainId: i
                }
            });
        }, this.disconnect = async (e)=>{
            await this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) await this.sendRequest({
                topic: s,
                method: "wc_sessionDelete",
                params: (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: s,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(s)) await this.client.core.pairing.disconnect({
                topic: s
            });
            else {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${s}`);
                throw new Error(t);
            }
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, $7ca7cbbf2d0451fa$export$6fc4971bf8f326a)(s, e))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e)=>{
            const { topic: s, expirerHasDeleted: t = !1, emitEvent: i = !0, id: n = 0 } = e, { self: o } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(o.publicKey) && await this.client.core.crypto.deleteKeyPair(o.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), t || this.client.core.expirer.del(s), this.client.core.storage.removeItem($8ca29bbccfa76532$export$a26ccd6441b7d638).catch((a)=>this.client.logger.warn(a)), this.getPendingSessionRequests().forEach((a)=>{
                a.topic === s && this.deletePendingSessionRequest(a.id, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
            }), i && this.client.events.emit("session_delete", {
                id: n,
                topic: s
            });
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), t && (this.sessionRequestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: e
            }));
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionPropose.req.ttl));
        }, this.setPendingSessionRequest = async (e)=>{
            const { id: s, topic: t, params: i, verifyContext: n } = e, o = i.request.expiryTimestamp || (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            await this.client.pendingRequest.set(s, {
                id: s,
                topic: t,
                params: i,
                verifyContext: n
            }), o && this.client.core.expirer.set(s, o);
        }, this.sendRequest = async (e)=>{
            const { topic: s, method: t, params: i, expiry: n, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = e, p = (0, $259791faf8debdd7$export$11d081ebb32d4398)(t, i, a);
            if ((0, $7ca7cbbf2d0451fa$export$4e09c449d6c407f7)() && $8ca29bbccfa76532$export$63c37d8ae5931ad5.includes(t)) {
                const N = (0, $7ca7cbbf2d0451fa$export$d4c241cec96564c1)(JSON.stringify(p));
                this.client.core.verify.register({
                    attestationId: N
                });
            }
            const d = await this.client.core.crypto.encode(s, p), h = $8ca29bbccfa76532$export$4edb1ca37014192d[t].req;
            return n && (h.ttl = n), o && (h.id = o), this.client.core.history.set(s, p), c ? (h.internal = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, h.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, d, h)) : this.client.core.relayer.publish(s, d, h).catch((N)=>this.client.logger.error(N)), p.id;
        }, this.sendResult = async (e)=>{
            const { id: s, topic: t, result: i, throwOnFailedPublish: n } = e, o = (0, $259791faf8debdd7$export$478fdea01c2a3198)(s, i), a = await this.client.core.crypto.encode(t, o), c = await this.client.core.history.get(t, s), p = $8ca29bbccfa76532$export$4edb1ca37014192d[c.request.method].res;
            n ? (p.internal = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, p.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(t, a, p)) : this.client.core.relayer.publish(t, a, p).catch((d)=>this.client.logger.error(d)), await this.client.core.history.resolve(o);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, $259791faf8debdd7$export$9f7302ae26c3f77)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $8ca29bbccfa76532$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                let i = !1;
                (0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(t.expiry) && (i = !0), this.client.core.crypto.keychain.has(t.topic) || (i = !0), i && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(t.expiryTimestamp) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession({
                        topic: t
                    })),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $8ca29bbccfa76532$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    this.processRequest(e), await new Promise((s)=>setTimeout(s, 300));
                } catch (s) {
                    this.client.logger.warn(s);
                }
            }
            this.requestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.idle;
        }, this.processRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect($8ca29bbccfa76532$var$g({}, s.params));
                const n = t.expiryTimestamp || (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), o = $8ca29bbccfa76532$var$g({
                    id: i,
                    pairingTopic: e,
                    expiryTimestamp: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, $7ca7cbbf2d0451fa$export$d4c241cec96564c1)(JSON.stringify(s)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const p = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: p
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && (await this.client.proposal.delete(t, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: c, sessionProperties: p, pairingTopic: d } = s.params, h = $8ca29bbccfa76532$var$g({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: d,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, p && {
                    sessionProperties: p
                });
                await this.sendResult({
                    id: s.id,
                    topic: e,
                    result: !0
                }), this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: h
                }), this.cleanupDuplicatePairings(h);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_approve", t), {})) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && (await this.client.session.delete(e, (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                const n = `${e}_session_update`, o = (0, $7ca7cbbf2d0451fa$export$b72d712fed4d036d).get(n);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`);
                    return;
                }
                this.isValidUpdate($8ca29bbccfa76532$var$g({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult({
                    id: i,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                }), (0, $7ca7cbbf2d0451fa$export$b72d712fed4d036d).set(n, i);
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.isRequestOutOfSync = (e, s)=>parseInt(s.toString().slice(0, -3)) <= parseInt(e.toString().slice(0, -3)), this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_update", t), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $7ca7cbbf2d0451fa$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_extend", t), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_ping", t), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $b9ab72458979c84f$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: e,
                                id: t
                            }));
                        });
                    }),
                    this.sendResult({
                        id: t,
                        topic: e,
                        result: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: e,
                        error: (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
                    })
                ]);
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest($8ca29bbccfa76532$var$g({
                    topic: e
                }, i));
                const n = (0, $7ca7cbbf2d0451fa$export$d4c241cec96564c1)(JSON.stringify((0, $259791faf8debdd7$export$11d081ebb32d4398)("wc_sessionRequest", i, t))), o = this.client.session.get(e), a = await this.getVerifyContext(n, o.peer.metadata), c = {
                    id: t,
                    topic: e,
                    params: i,
                    verifyContext: a
                };
                await this.setPendingSessionRequest(c), this.addSessionRequestToSessionRequestQueue(c), this.processSessionRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_request", t), {
                result: s.result
            }) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                const n = `${e}_session_event_${i.event.name}`, o = (0, $7ca7cbbf2d0451fa$export$b72d712fed4d036d).get(n);
                if (o && this.isRequestOutOfSync(o, t)) {
                    this.client.logger.info(`Discarding out of sync request - ${t}`);
                    return;
                }
                this.isValidEmit($8ca29bbccfa76532$var$g({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                }), (0, $7ca7cbbf2d0451fa$export$b72d712fed4d036d).set(n, t);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addSessionRequestToSessionRequestQueue = (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $5t6iP.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: e, error: s })=>{
            const t = this.client.core.history.pending;
            t.length > 0 && t.filter((i)=>i.topic === e && i.request.method === "wc_sessionRequest").forEach((i)=>{
                this.events.emit((0, $7ca7cbbf2d0451fa$export$e3eb27ce66c0f6d9)("session_request", i.request.id), {
                    error: s
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $8ca29bbccfa76532$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.active, this.client.events.emit("session_request", e);
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.onPairingCreated = (e)=>{
            if (e.active) return;
            const s = this.client.proposal.getAll().find((t)=>t.pairingTopic === e.topic);
            s && this.onSessionProposeRequest(e.topic, (0, $259791faf8debdd7$export$11d081ebb32d4398)("wc_sessionPropose", {
                requiredNamespaces: s.requiredNamespaces,
                optionalNamespaces: s.optionalNamespaces,
                relays: s.relays,
                proposer: s.proposer,
                sessionProperties: s.sessionProperties
            }, s.id));
        }, this.isValidConnect = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, $7ca7cbbf2d0451fa$export$fce6876652108ab)(s) || await this.isValidPairingTopic(s), !(0, $7ca7cbbf2d0451fa$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $7ca7cbbf2d0451fa$export$fce6876652108ab)(t) && (0, $7ca7cbbf2d0451fa$export$16a0268bc22b47b0)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $7ca7cbbf2d0451fa$export$fce6876652108ab)(i) && (0, $7ca7cbbf2d0451fa$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $7ca7cbbf2d0451fa$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, $7ca7cbbf2d0451fa$export$9e2b2cae22c6a8b3)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) throw new Error((0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, $7ca7cbbf2d0451fa$export$93f7b81dc815a714)(t, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $7ca7cbbf2d0451fa$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, t, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $7ca7cbbf2d0451fa$export$ee898ca48ab56c74)(i, !0)) {
                const { message: p } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(p);
            }
            (0, $7ca7cbbf2d0451fa$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, $7ca7cbbf2d0451fa$export$766fe78377d96f2a)(t)) {
                const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: c } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(c);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, $7ca7cbbf2d0451fa$export$1b3fc298be8c9a7b)(s)) {
                const { message: c } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $7ca7cbbf2d0451fa$export$5e1c5c89613c213f)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $7ca7cbbf2d0451fa$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(n)) {
                const { message: c } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, $7ca7cbbf2d0451fa$export$93f7b81dc815a714)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, $7ca7cbbf2d0451fa$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, $7ca7cbbf2d0451fa$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $7ca7cbbf2d0451fa$export$1a2af3c017fb6d42)(t)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $7ca7cbbf2d0451fa$export$8db4804e3a6de711)(o, i, t.method)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, $7ca7cbbf2d0451fa$export$59fba2af1ac782b)(n, $8ca29bbccfa76532$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${$8ca29bbccfa76532$export$409f0c0a13a1b7c6.min} and ${$8ca29bbccfa76532$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            var s;
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: n } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(n);
            }
            const { topic: t, response: i } = e;
            try {
                await this.isValidSessionTopic(t);
            } catch (n) {
                throw (s = e?.response) != null && s.id && this.cleanupAfterResponse(e), n;
            }
            if (!(0, $7ca7cbbf2d0451fa$export$1ae38cf0a848f651)(i)) {
                const { message: n } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(n);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, $7ca7cbbf2d0451fa$export$144fc36610eb6522)(n, i)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $7ca7cbbf2d0451fa$export$cbe4cdc5960cfa11)(t)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $7ca7cbbf2d0451fa$export$df2c67ef8baad16b)(n, i, t.name)) {
                const { message: o } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $7ca7cbbf2d0451fa$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || (0, $b9ab72458979c84f$export$7e3b1a28ddecdbaa),
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(s.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, $7ca7cbbf2d0451fa$export$ee898ca48ab56c74)(t, !1)) {
                    const { message: i } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $b9ab72458979c84f$export$d56245796e2837d).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, $f4d72c9188675517$export$f6e4034abe07d2a5)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, $f4d72c9188675517$export$308ba927de2bcbe8)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $b9ab72458979c84f$export$9013719d9206b0c1).expired, async (r)=>{
            const { topic: e, id: s } = (0, $7ca7cbbf2d0451fa$export$93adeb0f16e8e51d)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession({
                topic: e,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $b9ab72458979c84f$export$ca3c0b962acf7b75).create, (r)=>this.onPairingCreated(r));
    }
    isValidPairingTopic(r) {
        if (!(0, $7ca7cbbf2d0451fa$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, $7ca7cbbf2d0451fa$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(this.client.session.get(r).expiry)) {
            await this.deleteSession({
                topic: r
            });
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.crypto.keychain.has(r)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${r}`);
            throw await this.deleteSession({
                topic: r
            }), new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, $7ca7cbbf2d0451fa$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, $7ca7cbbf2d0451fa$export$53551be28ad5e34d)(r)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $7ca7cbbf2d0451fa$export$57947cfd429801a2)(this.client.proposal.get(r).expiryTimestamp)) {
            await this.deleteProposal(r);
            const { message: e } = (0, $7ca7cbbf2d0451fa$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class $8ca29bbccfa76532$var$us extends (0, $b9ab72458979c84f$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $8ca29bbccfa76532$export$ae6c7a4f7ed730a1, $8ca29bbccfa76532$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $8ca29bbccfa76532$var$ge extends (0, $b9ab72458979c84f$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $8ca29bbccfa76532$export$a069e98a8dfeec1e, $8ca29bbccfa76532$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $8ca29bbccfa76532$var$gs extends (0, $b9ab72458979c84f$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $8ca29bbccfa76532$export$40b296af21bd38a4, $8ca29bbccfa76532$export$7fa6f9ee1e2cab96, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class $8ca29bbccfa76532$export$2e2bcd8739ae039 extends (0, $ccb0ab7c4fc6b77f$export$2ebcf6eeacedad44) {
    constructor(r){
        super(r), this.protocol = $8ca29bbccfa76532$export$4fa962fc67384e02, this.version = $8ca29bbccfa76532$export$61085c48796ff049, this.name = $8ca29bbccfa76532$export$8dffb3242f2c5f72.name, this.events = new (0, $jMc9N.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || $8ca29bbccfa76532$export$8dffb3242f2c5f72.name, this.metadata = r?.metadata || (0, $7ca7cbbf2d0451fa$export$ba31e015127122bb)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, $edb0745dd7881952$exports.pino)((0, $edb0745dd7881952$exports.getDefaultLoggerOptions)({
            level: r?.logger || $8ca29bbccfa76532$export$8dffb3242f2c5f72.logger
        }));
        this.core = r?.core || new (0, $b9ab72458979c84f$export$4143ab5b91744744)(r), this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(e, this.name), this.session = new $8ca29bbccfa76532$var$ge(this.core, this.logger), this.proposal = new $8ca29bbccfa76532$var$us(this.core, this.logger), this.pendingRequest = new $8ca29bbccfa76532$var$gs(this.core, this.logger), this.engine = new $8ca29bbccfa76532$var$ds(this);
    }
    static async init(r) {
        const e = new $8ca29bbccfa76532$export$2e2bcd8739ae039(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const $8ca29bbccfa76532$export$90b8cff65c105172 = $8ca29bbccfa76532$var$ge, $8ca29bbccfa76532$export$bdf4ba258ec679dc = $8ca29bbccfa76532$export$2e2bcd8739ae039;



var $3ca9q = parcelRequire("3ca9q");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $1RPA1 = parcelRequire("1RPA1");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $9XxdG = parcelRequire("9XxdG");
var $9HEDW = parcelRequire("9HEDW");

var $dYErK = parcelRequire("dYErK");

class $a635a570b9dfb049$export$642f71372fab1590 {
    constructor(e){
        this.openModal = (0, $dYErK.ModalCtrl).open, this.closeModal = (0, $dYErK.ModalCtrl).close, this.subscribeModal = (0, $dYErK.ModalCtrl).subscribe, this.setTheme = (0, $dYErK.ThemeCtrl).setThemeConfig, (0, $dYErK.ThemeCtrl).setThemeConfig(e), (0, $dYErK.ConfigCtrl).setConfig(e), this.initUi();
    }
    async initUi() {
        if (typeof window < "u") {
            await (parcelRequire("cb9ZC"));
            const e = document.createElement("wcm-modal");
            document.body.insertAdjacentElement("beforeend", e), (0, $dYErK.OptionsCtrl).setIsUiLoaded(!0);
        }
    }
}



var $3ca9q = parcelRequire("3ca9q");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $1RPA1 = parcelRequire("1RPA1");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $fIwj6 = parcelRequire("fIwj6");


var $3ca9q = parcelRequire("3ca9q");

var $1RPA1 = parcelRequire("1RPA1");

function $01f72aabc4f39a3b$export$e3cecf4b77dd45d7(client) {
    return client.session.values[client.session.values.length - 1];
}
async function $01f72aabc4f39a3b$export$97f2d6af95e164f5(client, pairingTopic) {
    await (0, $fIwj6.timeout)(client.ping({
        topic: pairingTopic
    }), (0, $1RPA1.PING_TIMEOUT));
    // We assume last session is the correct session, beacuse we are doing clean up and keeps only one pairing/session.
    const session = $01f72aabc4f39a3b$export$e3cecf4b77dd45d7(client);
    return session;
}
async function $01f72aabc4f39a3b$export$f7c62c73429afa28(client, options, configs) {
    const { requiredNamespaces: requiredNamespaces, optionalNamespaces: optionalNamespaces, pairingTopic: pairingTopic } = options;
    try {
        const { uri: uri, approval: approval } = await client.connect({
            requiredNamespaces: requiredNamespaces,
            optionalNamespaces: optionalNamespaces,
            pairingTopic: pairingTopic
        });
        // Open QRCode modal if a URI was returned (i.e. we're not connecting an existing pairing).
        let onCloseModal;
        if (uri) {
            /*
       * There are some wallets have been listed in WC itself (https://docs.walletconnect.com/cloud/explorer-submission),
       * Using `DISABLE_MODAL_AND_OPEN_LINK` option, we can directly open a specific desktop wallet.
       */ const redirectLink = configs.envs.DISABLE_MODAL_AND_OPEN_LINK;
            if (redirectLink) {
                const url = `${redirectLink}/wc?uri=${encodeURIComponent(uri)}`;
                window.open(url, '_blank', 'noreferrer noopener');
            } else {
                // Create a flat array of all requested chains across namespaces.
                const allNamespaces = {
                    ...requiredNamespaces || {},
                    ...optionalNamespaces || {}
                };
                const standaloneChains = Object.values(allNamespaces).map((namespace)=>namespace.chains).flat();
                const modal = (0, $5364ec85d4ac93db$export$f4be253ad5d01050)();
                modal.openModal({
                    uri: uri,
                    chains: standaloneChains
                });
                onCloseModal = new Promise((_, reject)=>{
                    modal.subscribeModal((state)=>{
                        // the modal was closed so reject the promise
                        if (!state.open) reject(new Error('Modal has been closed.'));
                    });
                });
            }
        }
        const session = approval();
        if (onCloseModal) {
            const result = await Promise.race([
                session,
                onCloseModal
            ]);
            // We know onClose only reject a modal and never returns a value.
            return result;
        }
        return await session;
    } finally{
        (0, $5364ec85d4ac93db$export$f4be253ad5d01050)().closeModal();
    }
}
function $01f72aabc4f39a3b$export$4774a1f21338acb(client) {
    const pairings = client.pairing.getAll({
        active: true
    });
    const lastPairing = pairings.length > 0 ? pairings[pairings.length - 1] : undefined;
    return lastPairing;
}
async function $01f72aabc4f39a3b$export$7215d6c263aa9e76(client, params) {
    const { meta: meta } = params;
    // We try to get all of our supported chains as optional.
    const optionalNamespaces = (0, $5364ec85d4ac93db$export$246abed5cb9ad8b7)(meta);
    // Check if the user has a session, if yes, restore the session and use it.
    let session;
    const pairing = $01f72aabc4f39a3b$export$4774a1f21338acb(client);
    if (pairing) try {
        session = await $01f72aabc4f39a3b$export$97f2d6af95e164f5(client, pairing.topic);
    } catch (e) {
        await $01f72aabc4f39a3b$export$bb9762dbf655cc61(client);
    }
    // In case of connecting for the first time or session couldn't be restored, we will create a new session.
    if (!session) session = await $01f72aabc4f39a3b$export$f7c62c73429afa28(client, {
        requiredNamespaces: {},
        optionalNamespaces: optionalNamespaces
    }, {
        envs: params.envs
    });
    return session;
}
async function $01f72aabc4f39a3b$export$82837ae09132684e(client, topic) {
    const sessions = client.session.getAll();
    const pairings = client.pairing.getAll();
    sessions.forEach((session)=>{
        if (session.topic === topic || session.pairingTopic === topic) {
            const requestForDeleteTopic = session.pairingTopic === topic ? session.pairingTopic : session.topic;
            client.core.expirer.set(requestForDeleteTopic, 0);
        }
    });
    pairings.forEach((pairing)=>{
        if (pairing.topic === topic) client.core.expirer.set(topic, 0);
    });
}
async function $01f72aabc4f39a3b$export$bb9762dbf655cc61(client) {
    const allPromises = [];
    const sessions = client.session.getAll();
    for (const session of sessions)allPromises.push(client.disconnect({
        topic: session.topic,
        reason: (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)('USER_DISCONNECTED')
    }));
    const pairings = client.pairing.getAll();
    for (const pairing of pairings)allPromises.push(client.disconnect({
        topic: pairing.topic,
        reason: (0, $7ca7cbbf2d0451fa$export$8203ef1531c8b5b5)('USER_DISCONNECTED')
    }));
    // reset the current chain id
    $01f72aabc4f39a3b$export$d6555d45666e2426(client, undefined);
    return await Promise.all(allPromises);
}
function $01f72aabc4f39a3b$export$797dcf9bf9d15555(session) {
    const accounts = Object.values(session.namespaces).map((namespace)=>namespace.accounts).flat().map((account)=>{
        const { address: address, chainId: chainId } = new (0, $3ca9q.AccountId)(account);
        /*
       * Note: Solana has a specific ID, we need to convert it back to network name.
       * It will return the chain id itslef if it's not that specific ID.
       */ const chain = (0, $5364ec85d4ac93db$export$6a4876fc98b55b42)(chainId.reference);
        return {
            address: address,
            chainId: chain
        };
    });
    return accounts;
}
function $01f72aabc4f39a3b$export$728ff8346bb6c973(event) {
    const accounts = Object.values(event.params.namespaces).map((namespace)=>namespace.accounts).flat().map((account)=>{
        const { address: address, chainId: chainId } = new (0, $3ca9q.AccountId)(account);
        return {
            accounts: [
                address
            ],
            chainId: chainId.namespace === 'solana' ? (0, $9HEDW.LegacyNetworks).SOLANA : chainId.reference
        };
    });
    return accounts;
}
async function $01f72aabc4f39a3b$export$1420fad475829053(instance, requestedNetwork, currentNetwork, meta) {
    const session = instance.session;
    const namespaces = session.namespaces;
    let needUpdateNamepspace = false;
    const accounts = namespaces.eip155.accounts;
    const currentAccountAddress = (0, $5364ec85d4ac93db$export$1b7c4178e86d86b0)(instance);
    const requestedAccount = (0, $5364ec85d4ac93db$export$7b89a811b933f464)(requestedNetwork, currentAccountAddress, meta);
    if (!accounts.includes(requestedAccount)) {
        accounts.push(requestedAccount);
        needUpdateNamepspace = true;
    }
    const currentAccount = (0, $5364ec85d4ac93db$export$7b89a811b933f464)(currentNetwork, currentAccountAddress, meta);
    if (!accounts.includes(currentAccount)) {
        accounts.push(currentAccount);
        needUpdateNamepspace = true;
    }
    if (needUpdateNamepspace) {
        const updatedNamespaces = {
            ...namespaces,
            eip155: {
                ...namespaces.eip155,
                accounts: accounts
            }
        };
        await instance.client.session.update({
            topic: session.topic,
            namespaces: updatedNamespaces
        }).catch((err)=>{
            console.log(err);
        });
    }
}
function $01f72aabc4f39a3b$export$84f4ff2dba79932a(instance) {
    const WALLETS_WITH_WRONG_NAMESPACE_METHODS = [
        'trust',
        '1inch'
    ];
    const peerName = instance?.session?.peer?.metadata?.name;
    return WALLETS_WITH_WRONG_NAMESPACE_METHODS.some((name)=>peerName?.toLowerCase()?.includes(name));
}
async function $01f72aabc4f39a3b$export$d6555d45666e2426(client, chainId) {
    return client.core.storage.setItem((0, $1RPA1.CHAIN_ID_STORAGE), {
        defaultChainId: chainId ? parseInt(chainId) : ''
    });
}
async function $01f72aabc4f39a3b$export$6223f21353aa8cdc(client) {
    try {
        const chainId = (await client.core.storage.getItem((0, $1RPA1.CHAIN_ID_STORAGE)))?.defaultChainId;
        return !!chainId ? String(chainId) : undefined;
    } catch  {
        return undefined;
    }
}


let $5364ec85d4ac93db$var$web3Modal;
function $5364ec85d4ac93db$export$cd9972eecd25d22(projectId) {
    if (!$5364ec85d4ac93db$var$web3Modal) $5364ec85d4ac93db$var$web3Modal = new (0, $a635a570b9dfb049$export$642f71372fab1590)({
        projectId: projectId,
        themeMode: 'light',
        themeVariables: {
            '--wcm-z-index': '999999999'
        }
    });
}
function $5364ec85d4ac93db$export$f4be253ad5d01050() {
    return $5364ec85d4ac93db$var$web3Modal;
}
function $5364ec85d4ac93db$export$246abed5cb9ad8b7(meta) {
    const evm = (0, $hE77Y.evmBlockchains)(meta);
    const evmChains = evm.map((chain)=>{
        return new (0, $3ca9q.ChainId)({
            namespace: (0, $1RPA1.NAMESPACES).ETHEREUM,
            reference: String(parseInt(chain.chainId))
        }).toString();
    });
    const namespaces = {
        [(0, $1RPA1.NAMESPACES).ETHEREUM]: {
            methods: (0, $1RPA1.DEFAULT_ETHEREUM_METHODS),
            events: (0, $1RPA1.DEFAULT_ETHEREUM_EVENTS),
            chains: evmChains
        }
    };
    return namespaces;
}
function $5364ec85d4ac93db$export$6a4876fc98b55b42(chainId) {
    return chainId === (0, $1RPA1.DEFAULT_SOLANA_CHAIN_ID) ? (0, $9HEDW.LegacyNetworks).SOLANA : chainId;
}
async function $5364ec85d4ac93db$export$218515c613c9d06f(params, provider, meta, getState) {
    if (params.method === 'eth_chainId') {
        const currentSession = (0, $01f72aabc4f39a3b$export$e3cecf4b77dd45d7)(provider);
        const standaloneChains = Object.values(currentSession.namespaces).map((namespace)=>namespace.chains).flat();
        const network = getState().network;
        if (standaloneChains.length > 0) {
            const chainId = network ? $5364ec85d4ac93db$export$a98607e13f3cedcc(network, meta) : undefined;
            if (chainId) return chainId;
            const firstIndex = 0;
            const firstChain = standaloneChains[firstIndex];
            const firstChainId = new (0, $3ca9q.ChainId)(firstChain);
            return firstChainId.reference;
        }
        throw new Error(`Couldn't find any chain on namespace`);
    }
    throw new Error('Dissallowed method:', params);
}
function $5364ec85d4ac93db$export$a98607e13f3cedcc(network, meta) {
    const targetBlockchain = meta.find((blockchain)=>blockchain.name === network);
    const chainIdInHex = targetBlockchain?.chainId;
    if (!chainIdInHex) return undefined;
    const chainId = String(parseInt(chainIdInHex));
    return chainId;
}
async function $5364ec85d4ac93db$export$d112ba85ab1851ef(meta, requestedNetwork, currentNetwork, instance) {
    const evmBlockchains = meta.filter((0, $hE77Y.isEvmBlockchain));
    const evmNetworksChainInfo = (0, $fIwj6.convertEvmBlockchainMetaToEvmChainInfo)(evmBlockchains);
    const targetChain = evmNetworksChainInfo[requestedNetwork];
    const targetBlockchain = meta.find((blockchain)=>blockchain.name === requestedNetwork);
    const chainIdInHex = targetBlockchain?.chainId;
    const currentChainId = $5364ec85d4ac93db$export$a98607e13f3cedcc(currentNetwork, meta);
    const currentChainEip = (0, $3ca9q.ChainId).format({
        namespace: (0, $1RPA1.NAMESPACES).ETHEREUM,
        reference: String(currentChainId)
    });
    const session = instance.session;
    try {
        await instance.client.request({
            topic: session.topic,
            request: {
                method: (0, $1RPA1.EthereumRPCMethods).SWITCH_CHAIN,
                params: [
                    {
                        chainId: chainIdInHex
                    }
                ]
            },
            // It's required to pass current chain, otherwise it won't work
            chainId: currentChainEip
        });
    } catch (err) {
        const addChainError = 4902;
        if (err?.code === addChainError || err?.message?.includes(String(addChainError))) await instance.client.request({
            topic: session.topic,
            request: {
                method: (0, $1RPA1.EthereumRPCMethods).ADD_CHAIN,
                params: [
                    targetChain
                ]
            },
            // It's required to pass current chain, otherwise it won't work
            chainId: currentChainEip
        });
        else throw err;
    }
}
function $5364ec85d4ac93db$export$1b7c4178e86d86b0(instance) {
    return instance.session.namespaces.eip155.accounts?.map((account)=>{
        return new (0, $3ca9q.AccountId)(account).address;
    })?.filter((address)=>(0, $9XxdG.isAddress)(address))?.[0];
}
function $5364ec85d4ac93db$export$7b89a811b933f464(network, address, meta) {
    const currentChainId = $5364ec85d4ac93db$export$a98607e13f3cedcc(network, meta);
    return (0, $3ca9q.AccountId).format({
        chainId: {
            namespace: (0, $1RPA1.NAMESPACES).ETHEREUM,
            reference: String(currentChainId)
        },
        address: address
    });
}
function $5364ec85d4ac93db$export$a39e82169bfefc19(accounts, currentChainId) {
    let firstEvmAddress = false;
    return accounts.filter(({ address: address, chainId: chainId })=>{
        const isEvm = (0, $9XxdG.isAddress)(address);
        if (isEvm) {
            if (currentChainId && chainId !== currentChainId) return false;
            if (!currentChainId) {
                if (firstEvmAddress) return false;
                firstEvmAddress = true;
            }
        }
        return true;
    }).map(({ address: address, chainId: chainId })=>({
            accounts: [
                address
            ],
            chainId: chainId
        }));
}



parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");


async function $fb2a8277a843ab8b$export$2e2bcd8739ae039(instance) {
    if (!instance.session) throw new Error('Session is required for wallet connect signers.');
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const EVMSigner = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("5aKEd")))).default;
    const SOLANASigner = (await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("a1VlE")))).default;
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new EVMSigner(instance.client, instance.session));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new SOLANASigner(instance.client, instance.session));
    return signers;
}


const $d18cf0d374648d44$var$WALLET = (0, $9cRHO.WalletTypes).WALLET_CONNECT_2;
let $d18cf0d374648d44$var$envs = {
    WC_PROJECT_ID: '',
    DISABLE_MODAL_AND_OPEN_LINK: undefined
};
const $d18cf0d374648d44$export$2cd8252107eb640b = (environments)=>{
    $d18cf0d374648d44$var$envs = environments;
    (0, $5364ec85d4ac93db$export$cd9972eecd25d22)($d18cf0d374648d44$var$envs.WC_PROJECT_ID);
};
const $d18cf0d374648d44$export$e506a1d27d1eaa20 = {
    type: $d18cf0d374648d44$var$WALLET,
    checkInstallation: false,
    isAsyncInstance: true,
    defaultNetwork: (0, $1RPA1.DEFAULT_NETWORK),
    isAsyncSwitchNetwork: true
};
const $d18cf0d374648d44$export$8bedcca5bbd73999 = async (options)=>{
    const { currentProvider: currentProvider, getState: getState, meta: meta } = options;
    /*
   * Create a new pair, if exists use the pair,
   * Or use the already created one.
   */ let provider;
    if (!currentProvider) {
        if (!$d18cf0d374648d44$var$envs.WC_PROJECT_ID) throw new Error('You need to set `WC_PROJECT_ID` in Wallet Connect provider.');
        provider = await (0, $8ca29bbccfa76532$export$2e2bcd8739ae039).init({
            relayUrl: (0, $1RPA1.RELAY_URL),
            projectId: $d18cf0d374648d44$var$envs.WC_PROJECT_ID,
            metadata: (0, $1RPA1.DEFAULT_APP_METADATA)
        });
    } else provider = currentProvider;
    return {
        client: provider,
        session: null,
        request: async (params)=>(0, $5364ec85d4ac93db$export$218515c613c9d06f)(params, provider, meta, getState)
    };
};
const $d18cf0d374648d44$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const { client: client } = instance;
    // Try to restore the session first, if couldn't, create a new session by showing a modal.
    const session = await (0, $01f72aabc4f39a3b$export$7215d6c263aa9e76)(client, {
        meta: meta,
        envs: $d18cf0d374648d44$var$envs
    });
    // Override the value (session).
    instance.session = session;
    const currentChainId = await (0, $01f72aabc4f39a3b$export$6223f21353aa8cdc)(client);
    const accounts = (0, $01f72aabc4f39a3b$export$797dcf9bf9d15555)(session);
    return (0, $5364ec85d4ac93db$export$a39e82169bfefc19)(accounts, currentChainId);
};
const $d18cf0d374648d44$export$ec068583843480e7 = ({ instance: instance, updateChainId: updateChainId, updateAccounts: updateAccounts, disconnect: disconnect })=>{
    const { client: client } = instance;
    /**
   * Session events refrence:
   * https://docs.walletconnect.com/2.0/specs/clients/sign/session-events
   */ // Listen to updating the session by adding a new chain, method, or event
    client.on('session_update', (args)=>{
        const allAccounts = (0, $01f72aabc4f39a3b$export$728ff8346bb6c973)(args);
        allAccounts.forEach((accountsWithChain)=>{
            updateAccounts(accountsWithChain.accounts, accountsWithChain.chainId);
        });
    });
    // Listen to events triggred by wallet. (e.g. accountsChanged and chainChanged)
    client.on('session_event', (args)=>{
        if (args.params.event.name === (0, $1RPA1.EthereumEvents).ACCOUNTS_CHANGED) {
            const accounts = args.params.event.data.map((account)=>{
                return new (0, $3ca9q.AccountId)(account).address;
            });
            const chainId = (0, $3ca9q.ChainId).parse(args.params.chainId).reference;
            updateAccounts(accounts);
            updateChainId(chainId);
        } else if (args.params.event.name === (0, $1RPA1.EthereumEvents).CHAIN_CHANGED) {
            const chainId = args.params.event.data;
            updateChainId(chainId);
            (0, $01f72aabc4f39a3b$export$d6555d45666e2426)(instance.client, chainId);
        } else console.log('[WC2] session_event not supported', args.params.event);
    });
    client.on('session_delete', async (event)=>{
        console.log('[WC2] your wallet has requested to delete session.', event);
        (0, $01f72aabc4f39a3b$export$82837ae09132684e)(client, event.topic);
        disconnect();
    });
};
const $d18cf0d374648d44$export$f3473d805e486329 = async ({ network: network, instance: instance, meta: meta, getState: getState, updateChainId: updateChainId })=>{
    const evm = (0, $hE77Y.evmBlockchains)(meta);
    const chainId = evm.find((chain)=>chain.name === network)?.chainId;
    if (!chainId) {
        const error = new Error(`There is no match for ${chainId}`);
        (0, $634f26ddaad1954d$export$a3bc9b8ed74fc)(error);
        throw error;
    }
    const chaindIdStr = new (0, $3ca9q.ChainId)({
        namespace: (0, $1RPA1.NAMESPACES).ETHEREUM,
        reference: String(parseInt(chainId))
    }).toString();
    const session = instance.session;
    const evmNamespace = session.namespaces[(0, $1RPA1.NAMESPACES).ETHEREUM];
    const authorizedChains = evmNamespace?.chains || [];
    const authorizedMethods = evmNamespace?.methods || [];
    if (authorizedMethods.includes((0, $1RPA1.EthereumRPCMethods).SWITCH_CHAIN) && !(0, $01f72aabc4f39a3b$export$84f4ff2dba79932a)(instance)) {
        const currentNetwork = getState?.().network || (0, $9HEDW.LegacyNetworks).ETHEREUM;
        await (0, $01f72aabc4f39a3b$export$1420fad475829053)(instance, network, currentNetwork, meta);
        await (0, $5364ec85d4ac93db$export$d112ba85ab1851ef)(meta, network, currentNetwork, instance);
    } else if (authorizedChains.includes(chaindIdStr)) {
        updateChainId(chainId);
        return;
    } else {
        const error = new Error(`Chain ${chainId} is not configured.`);
        (0, $634f26ddaad1954d$export$a3bc9b8ed74fc)(error);
        throw error;
    }
};
const $d18cf0d374648d44$export$3b3cf9ab9019de20 = ()=>true;
const $d18cf0d374648d44$export$37dfea93db2e14ed = async ({ instance: instance })=>{
    const { client: client } = instance;
    if (client) (0, $01f72aabc4f39a3b$export$bb9762dbf655cc61)(client).catch((error)=>(0, $634f26ddaad1954d$export$1c9f709888824e05)(error));
};
const $d18cf0d374648d44$export$6352a17a50193ded = (0, $fb2a8277a843ab8b$export$2e2bcd8739ae039);
const $d18cf0d374648d44$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $hE77Y.evmBlockchains)(allBlockChains);
    return {
        name: 'WalletConnect',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/walletconnect/icon.svg',
        installLink: '',
        color: '#b2dbff',
        supportedChains: evms,
        showOnMobile: true,
        mobileWallet: true
    };
};


var $1d992394cfde0d25$exports = {};

$parcel$export($1d992394cfde0d25$exports, "config", function () { return $1d992394cfde0d25$export$e506a1d27d1eaa20; });
$parcel$export($1d992394cfde0d25$exports, "getInstance", function () { return $1d992394cfde0d25$export$8bedcca5bbd73999; });
$parcel$export($1d992394cfde0d25$exports, "connect", function () { return $1d992394cfde0d25$export$64605811ab45167f; });
$parcel$export($1d992394cfde0d25$exports, "subscribe", function () { return $1d992394cfde0d25$export$ec068583843480e7; });
$parcel$export($1d992394cfde0d25$exports, "switchNetwork", function () { return $1d992394cfde0d25$export$f3473d805e486329; });
$parcel$export($1d992394cfde0d25$exports, "canSwitchNetworkTo", function () { return $1d992394cfde0d25$export$3b3cf9ab9019de20; });
$parcel$export($1d992394cfde0d25$exports, "getSigners", function () { return $1d992394cfde0d25$export$6352a17a50193ded; });
$parcel$export($1d992394cfde0d25$exports, "canEagerConnect", function () { return $1d992394cfde0d25$export$be9f3c5ed1d25e42; });
$parcel$export($1d992394cfde0d25$exports, "getWalletInfo", function () { return $1d992394cfde0d25$export$e5b9d96c6aeb3ff7; });
$parcel$export($1d992394cfde0d25$exports, "SUPPORTED_ETH_CHAINS", function () { return $db414cb596f30543$export$2f1ee95fdafdbc6f; });
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
var $ehvdX = parcelRequire("ehvdX");
var $fIwj6 = parcelRequire("fIwj6");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");
const $db414cb596f30543$export$1ab337da26caa141 = (0, $9cRHO.XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS);
const $db414cb596f30543$export$2f1ee95fdafdbc6f = [
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).BSC,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN,
    (0, $9HEDW.LegacyNetworks).FANTOM,
    (0, $9HEDW.LegacyNetworks).ARBITRUM
];
const $db414cb596f30543$export$35f3dd08d92fdef4 = [
    (0, $9HEDW.LegacyNetworks).COSMOS,
    (0, $9HEDW.LegacyNetworks).AKASH,
    (0, $9HEDW.LegacyNetworks).AXELAR,
    (0, $9HEDW.LegacyNetworks).CRYPTO_ORG,
    (0, $9HEDW.LegacyNetworks).JUNO,
    (0, $9HEDW.LegacyNetworks).KUJIRA,
    (0, $9HEDW.LegacyNetworks).MARS,
    (0, $9HEDW.LegacyNetworks).OSMOSIS,
    (0, $9HEDW.LegacyNetworks).STARGAZE,
    (0, $9HEDW.LegacyNetworks).STRIDE
];


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

function $c9aa80bb225f4805$export$addfd73ac5984873() {
    const { xfi: xfi } = window;
    if (!xfi) return null;
    const instances = new Map();
    if (xfi.bitcoin) instances.set((0, $9HEDW.LegacyNetworks).BTC, xfi.bitcoin);
    if (xfi.litecoin) instances.set((0, $9HEDW.LegacyNetworks).LTC, xfi.litecoin);
    if (xfi.thorchain) instances.set((0, $9HEDW.LegacyNetworks).THORCHAIN, xfi.thorchain);
    if (xfi.bitcoincash) instances.set((0, $9HEDW.LegacyNetworks).BCH, xfi.bitcoincash);
    if (xfi.ethereum) instances.set((0, $9HEDW.LegacyNetworks).ETHEREUM, xfi.ethereum);
    if (xfi.dogecoin) instances.set((0, $9HEDW.LegacyNetworks).DOGE, xfi.dogecoin);
    if (xfi.solana) instances.set((0, $9HEDW.LegacyNetworks).SOLANA, xfi.solana);
    if (xfi.mayachain) instances.set((0, $9HEDW.LegacyNetworks).MAYA, xfi.mayachain);
    if (xfi.keplr) instances.set((0, $9HEDW.LegacyNetworks).COSMOS, xfi.keplr);
    return instances;
}
function $c9aa80bb225f4805$export$d1cfcb1ce8ae2e4e(netowrk) {
    if (!netowrk) return null;
    return (0, $db414cb596f30543$export$2f1ee95fdafdbc6f).includes(netowrk) ? (0, $9HEDW.LegacyNetworks).ETHEREUM : null;
}
async function $c9aa80bb225f4805$export$78e7a9381dd8e059(instances) {
    const nonEvmNetworks = (0, $db414cb596f30543$export$1ab337da26caa141).filter((net)=>net !== (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const promises = nonEvmNetworks.filter((network)=>// Ensure the instance is defined
        instances.get(network) !== undefined).map(async (network)=>{
        return new Promise((resolve, reject)=>{
            const instance = instances.get(network);
            instance.request({
                method: 'request_accounts',
                params: []
            }, (error, accounts)=>{
                if (error) {
                    reject(error);
                    return error;
                }
                const result = {
                    accounts: accounts,
                    chainId: network
                };
                resolve(result);
            });
        });
    });
    const results = await Promise.all(promises);
    return results;
}
async function $c9aa80bb225f4805$export$b137d6c170e38e8e(blockchain, ticker, from, amount, decimals, recipientAddress, provider, method, memo) {
    return new Promise(function(resolve, reject) {
        const params = {
            asset: {
                chain: blockchain,
                symbol: ticker,
                ticker: ticker
            },
            from: from,
            amount: {
                amount: amount,
                decimals: decimals
            },
            memo: memo
        };
        if (recipientAddress) params.recipient = recipientAddress;
        provider.request({
            method: method,
            params: [
                params
            ]
        }, (error, result)=>{
            if (error) reject(new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SEND_TX_ERROR, undefined, error));
            else resolve(result);
        });
    });
}


parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

class $190c9cd0cb838f2d$export$75630daf98d4e9ed {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage(msg, address, chainId) {
        try {
            if (!chainId) throw Error('ChainId is required');
            const { signature: signature } = await this.provider.signArbitrary(chainId, address, msg);
            return signature;
        } catch (error) {
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        const { executeCosmosTransaction: executeCosmosTransaction } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("f6MG1")));
        if (tx.rawTransfer === null) {
            const cosmosProvider = (0, $gSYt0.getNetworkInstance)(this.provider, (0, $9HEDW.LegacyNetworks).COSMOS);
            const hash = await executeCosmosTransaction(tx, cosmosProvider);
            return {
                hash: hash
            };
        }
        throw Error('raw transfer is not null for cosmos transactions');
    }
}


parcelRequire("6Zvtg");
var $13wKd = parcelRequire("13wKd");

var $hZS7n = parcelRequire("hZS7n");
class $e12c58d09ddf79fa$export$c51c8fd6dbcc716f extends (0, $13wKd.DefaultSolanaSigner) {
    constructor(provider){
        super(provider);
    }
    async signMessage(msg) {
        const encodedMessage = new TextEncoder().encode(msg);
        const { signature: signature } = await this.provider.signMessage(encodedMessage);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(signature);
    }
}


parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");

class $5e19590a39da77f2$export$c5ceb3c61438beb1 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $9gKM3.SignerError).UnimplementedError('signMessage');
    }
    async signAndSendTx(tx) {
        const { blockchain: blockchain } = tx.asset;
        // Everything except ETH
        if (!(0, $9cRHO.XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS).includes(blockchain)) throw new Error(`blockchain: ${blockchain} transfer not implemented yet.`);
        if (blockchain === (0, $9HEDW.LegacyNetworks).BTC) return await this.#signPsbt(tx);
        return await this.#signTransferObject(tx);
    }
    // Interface for PSBT: https://developers.ctrl.xyz/developers/extension-bitcoin#sign-psbt-partially-signed-bitcoin-transaction
    async #signPsbt(tx) {
        const { asset: asset, psbt: psbt } = tx;
        if (!psbt) throw new Error('No PSBT found to sign. Ensure a valid PSBT is provided.');
        const provider = (0, $gSYt0.getNetworkInstance)(this.provider, asset.blockchain);
        const signInputs = {};
        psbt.inputsToSign.forEach((input)=>{
            signInputs[input.address] = input.signingIndexes;
        });
        const response = await provider.request({
            method: 'sign_psbt',
            params: {
                psbt: psbt.unsignedPsbtBase64,
                signInputs: signInputs,
                allowedSignHash: 1,
                broadcast: true
            }
        }).catch((error)=>{
            throw new (0, $9gKM3.SignerError)((0, $9gKM3.SignerErrorCode).SEND_TX_ERROR, undefined, error);
        });
        /*
     * `status` is useful for callback style (e.g. `(err, res) => void`) form of `xfi.request`.
     * here we are using the promise interface, so it should be always `success` when reach here.
     *
     * just for ensuring unexpected behaviors will be handled, we can keep this.
     *
     * @see https://docs.xverse.app/sats-connect/wallet-methods/request-methods#response-format-and-error-handling
     */ if (response.status === 'success') return {
            hash: response.result.txId
        };
        throw new Error('The operation (sign and broadcast) failed on your wallet.', {
            cause: response
        });
    }
    async #signTransferObject(tx) {
        const { blockchain: blockchain } = tx.asset;
        const transferProvider = (0, $gSYt0.getNetworkInstance)(this.provider, blockchain);
        const { method: method, memo: memo, recipientAddress: recipientAddress, decimals: decimals, amount: amount, fromWalletAddress: from, asset: asset } = tx;
        const hash = await (0, $c9aa80bb225f4805$export$b137d6c170e38e8e)(blockchain, asset.ticker, from, amount, decimals, recipientAddress, transferProvider, method, memo ?? undefined);
        return {
            hash: hash
        };
    }
}



async function $14b6e48dca43b78d$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).SOLANA);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (0, $fIwj6.dynamicImportWithRefinedError)(async ()=>await (parcelRequire("7tam3")));
    signers.registerSigner((0, $9B1kL.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $9B1kL.TransactionType).SOLANA, new (0, $e12c58d09ddf79fa$export$c51c8fd6dbcc716f)(solProvider));
    // passed provider for transfer as it comprises several signers
    signers.registerSigner((0, $9B1kL.TransactionType).COSMOS, new (0, $190c9cd0cb838f2d$export$75630daf98d4e9ed)(provider));
    // passed provider for transfer as it comprises several signers
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new (0, $5e19590a39da77f2$export$c5ceb3c61438beb1)(provider));
    return signers;
}


const $1d992394cfde0d25$var$DEFAULT_NETWORK = (0, $9HEDW.LegacyNetworks).ETHEREUM;
const $1d992394cfde0d25$var$WALLET = (0, $9cRHO.WalletTypes).XDEFI;
const $1d992394cfde0d25$export$e506a1d27d1eaa20 = {
    type: $1d992394cfde0d25$var$WALLET,
    defaultNetwork: $1d992394cfde0d25$var$DEFAULT_NETWORK
};
const $1d992394cfde0d25$export$8bedcca5bbd73999 = (0, $c9aa80bb225f4805$export$addfd73ac5984873);
const $1d992394cfde0d25$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    const solInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).SOLANA);
    const cosmosInstance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).COSMOS);
    const evmResult = await (0, $gSYt0.getEvmAccounts)(ethInstance);
    const nonEvmResults = await (0, $c9aa80bb225f4805$export$78e7a9381dd8e059)(instance);
    const solanaAccounts = await (0, $fIwj6.getSolanaAccounts)({
        instance: solInstance,
        meta: meta
    });
    const cosmosAccounts = [];
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((blockchainMeta)=>(0, $hE77Y.isCosmosBlockchain)(blockchainMeta) && (0, $db414cb596f30543$export$35f3dd08d92fdef4).includes(blockchainMeta.name));
        const requestedNetwork = (0, $9HEDW.LegacyNetworks).COSMOS;
        const cosmosResult = await (0, $ehvdX.getCosmosAccounts)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: requestedNetwork
        });
        if (Array.isArray(cosmosResult)) cosmosAccounts.push(...cosmosResult);
        else cosmosAccounts.push(cosmosResult);
    }
    return [
        evmResult,
        ...nonEvmResults,
        solanaAccounts,
        ...cosmosAccounts
    ];
};
const $1d992394cfde0d25$export$ec068583843480e7 = ({ instance: instance, meta: meta, updateChainId: updateChainId, connect: connect })=>{
    const handleChainChanged = (chainId)=>{
        const network = (0, $9HEDW.legacyGetBlockChainNameFromId)(chainId, meta) || (0, $9HEDW.LegacyNetworks).Unknown;
        /*
     *TODO:
     *We are calling `connect` here because signer can't detect
     *currect network, I guess the bug is in our signer and it
     *gets the wrong network by calling a wrong method or something.
     *Anyways, this works for now, maybe we can reconsider it in future
     *Whenever we refactored the signer code as well.
     */ /*
     *  we need to update `network` first, if not, it will goes through
     * the switching network and will open unneccessary pop ups.
     */ updateChainId(chainId);
        connect(network);
    };
    const eth = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    eth?.on?.('chainChanged', handleChainChanged);
    return ()=>{
        eth?.off?.('chainChanged', handleChainChanged);
    };
};
const $1d992394cfde0d25$export$f3473d805e486329 = (0, $gSYt0.switchNetworkForEvm);
const $1d992394cfde0d25$export$3b3cf9ab9019de20 = (0, $gSYt0.canSwitchNetworkToEvm);
const $1d992394cfde0d25$export$6352a17a50193ded = (0, $14b6e48dca43b78d$export$2e2bcd8739ae039);
const $1d992394cfde0d25$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $gSYt0.chooseInstance)(instance, meta, (0, $9HEDW.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $gSYt0.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $1d992394cfde0d25$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedCosmosChains = (0, $hE77Y.cosmosBlockchains)(allBlockChains).filter((blockchainMeta)=>!!blockchainMeta.info && (0, $db414cb596f30543$export$35f3dd08d92fdef4).includes(blockchainMeta.name));
    const supportedChains = [
        ...allBlockChains.filter((blockchainMeta)=>[
                ...(0, $db414cb596f30543$export$2f1ee95fdafdbc6f),
                ...(0, $9cRHO.XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS),
                (0, $9HEDW.LegacyNetworks).SOLANA
            ].includes(blockchainMeta.name)),
        ...supportedCosmosChains
    ];
    return {
        name: 'Ctrl',
        img: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/xdefi/icon.svg',
        installLink: {
            CHROME: 'https://chromewebstore.google.com/detail/ctrl-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf',
            BRAVE: 'https://chromewebstore.google.com/detail/ctrl-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf',
            DEFAULT: 'https://ctrl.xyz/'
        },
        color: '#0646c7',
        supportedChains: supportedChains
    };
};



parcelRequire("fvuxD");
var $fFglI = parcelRequire("fFglI");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $gSYt0 = parcelRequire("gSYt0");
parcelRequire("9U3Qn");
var $fbZBq = parcelRequire("fbZBq");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");
class $8b8f33aade0e8f17$export$312c29acd931b8b3 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $9gKM3.SignerError).UnimplementedError('signMessage');
    }
    async signAndSendTx(tx) {
        const { asset: asset, psbt: psbt } = tx;
        if (!psbt) throw new Error('No PSBT found to sign. Ensure a valid PSBT is provided.');
        if (asset.blockchain !== (0, $9HEDW.LegacyNetworks).BTC) throw new Error(`Signing ${asset.blockchain} transaction is not implemented by the signer.`);
        // 2. Build sign inputs
        const signInputs = {};
        psbt.inputsToSign.forEach(({ address: address, signingIndexes: signingIndexes })=>{
            signInputs[address] = signingIndexes;
        });
        // 3. Sign (& broadcast)
        const signPsbtResult = await this.provider.request('signPsbt', {
            psbt: psbt.unsignedPsbtBase64,
            signInputs: signInputs,
            broadcast: true
        });
        if (signPsbtResult?.error) throw new Error(signPsbtResult.error.message || 'Error during transaction sign');
        if (!signPsbtResult?.result?.txid) throw new Error('Transaction not found!');
        return {
            hash: signPsbtResult.result.txid
        };
    }
}


async function $a437ea288ef7922d$export$2e2bcd8739ae039(provider) {
    const bitcoinInstance = (0, $gSYt0.getNetworkInstance)(provider, (0, $9HEDW.LegacyNetworks).BTC);
    const signers = new (0, $fbZBq.DefaultSignerFactory)();
    signers.registerSigner((0, $9B1kL.TransactionType).TRANSFER, new (0, $8b8f33aade0e8f17$export$312c29acd931b8b3)(bitcoinInstance));
    return signers;
}



var $9HEDW = parcelRequire("9HEDW");
function $a0ba3f2f33f7cb2e$export$2151d408a4cc6fd3() {
    const { XverseProviders: XverseProviders } = window;
    if (!XverseProviders) return null;
    const instances = new Map();
    if (XverseProviders.BitcoinProvider) instances.set((0, $9HEDW.LegacyNetworks).BTC, XverseProviders.BitcoinProvider);
    return instances;
}
function $a0ba3f2f33f7cb2e$export$62115b9164fa6f77() {
    const instances = $a0ba3f2f33f7cb2e$export$2151d408a4cc6fd3();
    if (!instances) throw new Error('Xverse is not injected. Please check your wallet.');
    return instances;
}
function $a0ba3f2f33f7cb2e$export$d2cac28ce5d6098e() {
    const instances = $a0ba3f2f33f7cb2e$export$2151d408a4cc6fd3();
    const bitcoinInstance = instances?.get((0, $9HEDW.LegacyNetworks).BTC);
    if (!bitcoinInstance) throw new Error('Xverse not injected. Please check your wallet.');
    return bitcoinInstance;
}
async function $a0ba3f2f33f7cb2e$export$990bd7c7f4a34867() {
    const instance = $a0ba3f2f33f7cb2e$export$d2cac28ce5d6098e();
    const requestResult = await instance.request('wallet_connect', {
        addresses: [
            'payment'
        ],
        network: 'Mainnet'
    });
    if (requestResult.error?.message) throw new Error(requestResult.error.message);
    return requestResult;
}


const $d9379d8454bb9053$export$5a5ee48a50577a07 = 1000;
const $d9379d8454bb9053$export$fb2f8fe6fc4a5f33 = -32002;
const $d9379d8454bb9053$export$7c460c214963f696 = 'xverse';
const $d9379d8454bb9053$export$dbb5e893e736e4ee = {
    name: 'xverse',
    icon: 'https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/xverse/icon.svg',
    extensions: {
        chrome: 'https://chromewebstore.google.com/detail/idnnbdplmphpflfnlkomgpfbpcgelopg',
        homepage: 'https://www.xverse.app/'
    },
    properties: [
        {
            name: 'namespaces',
            value: {
                selection: 'single',
                data: [
                    {
                        label: 'BTC',
                        value: 'UTXO',
                        id: 'BTC',
                        getSupportedChains: (allBlockchains)=>allBlockchains.filter((chain)=>chain.name === (0, $9HEDW.LegacyNetworks).BTC)
                    }
                ]
            }
        },
        {
            name: 'signers',
            value: {
                getSigners: async ()=>(0, $a437ea288ef7922d$export$2e2bcd8739ae039)((0, $a0ba3f2f33f7cb2e$export$62115b9164fa6f77)())
            }
        }
    ]
};


parcelRequire("fvuxD");
var $at2GJ = parcelRequire("at2GJ");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");
parcelRequire("fvuxD");
var $fha7R = parcelRequire("fha7R");

var $f59Be = parcelRequire("f59Be");

var $er2za = parcelRequire("er2za");

const $7e272da93c10131d$export$bc681aebb548377e = (getInstance)=>new (0, $f59Be.ChangeAccountSubscriberBuilder)().getInstance(getInstance)/*
     * Xverse wallet may call the `changeAccount` event with `empty` value
     * but we shouldn't disconnect in this case.
     */ .onSwitchAccount((event)=>{
        if (!event.payload?.addresses?.length) event.preventDefault();
    }).format(async (_, event)=>{
        return (0, $er2za.utils).formatAccountsToCAIP(event.addresses.filter((address)=>address.purpose === 'payment').map((address)=>address.address), (0, $er2za.CAIP_BITCOIN_CHAIN_ID));
    }).addEventListener((instance, callback)=>{
        return instance.addListener('accountChange', callback);
    }).removeEventListener((_, __)=>{
    // it will be removed by the main class
    });
function $7e272da93c10131d$var$canEagerConnect(getInstance) {
    return new (0, $fha7R.ActionBuilder)('canEagerConnect').action(async ()=>{
        const instance = getInstance();
        try {
            const addressesResponse = await instance.request('getAddresses', {
                purposes: [
                    'payment'
                ]
            });
            if (addressesResponse.error?.code === (0, $d9379d8454bb9053$export$fb2f8fe6fc4a5f33)) return false;
            return !!addressesResponse.result?.addresses?.length;
        } catch  {
            return false;
        }
    });
}
const $7e272da93c10131d$export$4ec68a7e2bb108ab = {
    changeAccountSubscriber: $7e272da93c10131d$export$bc681aebb548377e,
    canEagerConnect: $7e272da93c10131d$var$canEagerConnect
};




const [$9ac4694082b76834$var$changeAccountSubscriber, $9ac4694082b76834$var$changeAccountCleanup] = (0, $7e272da93c10131d$export$4ec68a7e2bb108ab).changeAccountSubscriber((0, $a0ba3f2f33f7cb2e$export$d2cac28ce5d6098e)).build();
const $9ac4694082b76834$var$canEagerConnect = (0, $7e272da93c10131d$export$4ec68a7e2bb108ab).canEagerConnect((0, $a0ba3f2f33f7cb2e$export$d2cac28ce5d6098e)).build();
const $9ac4694082b76834$var$connect = (0, $er2za.builders).connect().action(async function() {
    const accountsResult = await (0, $a0ba3f2f33f7cb2e$export$990bd7c7f4a34867)();
    if (accountsResult.result?.addresses?.length === 0) throw new Error("Couldn't find any address!");
    return (0, $er2za.utils).formatAccountsToCAIP(accountsResult.result.addresses.map((address)=>address.address), (0, $er2za.CAIP_BITCOIN_CHAIN_ID));
}).before($9ac4694082b76834$var$changeAccountSubscriber).or($9ac4694082b76834$var$changeAccountCleanup).or((0, $f59Be.standardizeAndThrowError)).build();
const $9ac4694082b76834$var$disconnect = (0, $f59Be.builders).disconnect().after($9ac4694082b76834$var$changeAccountCleanup).build();
const $9ac4694082b76834$export$85601e73083fc493 = new (0, $at2GJ.NamespaceBuilder)('UTXO', (0, $d9379d8454bb9053$export$7c460c214963f696)).action($9ac4694082b76834$var$connect).action($9ac4694082b76834$var$disconnect).action($9ac4694082b76834$var$canEagerConnect).build();



const $ef233c497a6c6c6d$export$afa934a86232cabe = ()=>new (0, $fFglI.ProviderBuilder)((0, $d9379d8454bb9053$export$7c460c214963f696)).init(function(context) {
        const [, setState] = context.state();
        // TODO: We should remove this after we solved not initiating issue.
        setTimeout(()=>{
            if ((0, $a0ba3f2f33f7cb2e$export$2151d408a4cc6fd3)()) {
                setState('installed', true);
                console.debug('[xverse] instance detected.', context);
            }
        }, (0, $d9379d8454bb9053$export$5a5ee48a50577a07));
    }).config('metadata', (0, $d9379d8454bb9053$export$dbb5e893e736e4ee)).add('utxo', (0, $9ac4694082b76834$export$85601e73083fc493)).build();


const $1e5f7ae7c7f6b939$export$3acacdf112fc9c85 = ()=>(0, $ced745a80d9e02b4$export$37be72d69eff8ef3)().version('1.0.0', (0, $ef233c497a6c6c6d$export$afa934a86232cabe)()).build();



parcelRequire("7MbFH");
var $9cRHO = parcelRequire("9cRHO");
parcelRequire("fvuxD");
var $hmR2n = parcelRequire("hmR2n");
const $dd760fd61e20cea4$export$8b867028656ffdd3 = (providers, wallet)=>{
    return providers.length && !providers.find((provider)=>{
        if (typeof provider === 'string') return provider === wallet.type;
        if (provider instanceof (0, $hmR2n.Provider)) return provider.id === wallet.type;
        return provider.getWalletInfo([]).name === wallet.name;
    });
};
const $dd760fd61e20cea4$export$8d0767d85173b4a1 = (provider)=>()=>provider;


const $6a21b2259c5f602a$export$e6f06807598c9e91 = (options)=>{
    const providers = options?.selectedProviders || [];
    if (!(0, $dd760fd61e20cea4$export$8b867028656ffdd3)(providers, {
        type: (0, $9cRHO.WalletTypes).WALLET_CONNECT_2,
        name: 'WalletConnect'
    })) {
        if (!!options?.walletconnect2?.WC_PROJECT_ID) $d18cf0d374648d44$exports.init(options.walletconnect2);
        else throw new Error('WalletConnect has been included in your providers. Passing a Project ID is required. Make sure you are passing "WC_PROJECT_ID".');
    }
    if (!(0, $dd760fd61e20cea4$export$8b867028656ffdd3)(providers, {
        type: (0, $9cRHO.WalletTypes).TREZOR,
        name: 'Trezor'
    })) {
        if (!!options?.trezor?.manifest) $9f9be13dfd5d2b11$exports.init(options.trezor);
    }
    return [
        (0, $dd760fd61e20cea4$export$8d0767d85173b4a1)((0, $ced745a80d9e02b4$export$3ce31bfaa5288b9a)($bf59b7aa4802b6ce$exports)),
        (0, $dd760fd61e20cea4$export$8d0767d85173b4a1)((0, $ced745a80d9e02b4$export$3ce31bfaa5288b9a)($efcc27ba195cb412$exports)),
        (0, $e24e68e14f9e5c99$export$3acacdf112fc9c85),
        (0, $dd760fd61e20cea4$export$8d0767d85173b4a1)((0, $ced745a80d9e02b4$export$3ce31bfaa5288b9a)($d18cf0d374648d44$exports)),
        (0, $c1b8e30c78f1cf4e$export$3acacdf112fc9c85),
        (0, $04f2e359365b093d$export$3acacdf112fc9c85),
        (0, $4504323b5333b7d7$export$3acacdf112fc9c85),
        (0, $70da00cffcb1e8da$export$3acacdf112fc9c85),
        (0, $0c2e7f8a1d69d90b$export$3acacdf112fc9c85),
        (0, $c9fefc9db13081bd$export$3acacdf112fc9c85),
        (0, $fd15553f1aea7a9f$export$3acacdf112fc9c85),
        (0, $cc1b5f400113376f$export$3acacdf112fc9c85),
        (0, $1ec0d9d807afcd8b$export$3acacdf112fc9c85),
        (0, $dd760fd61e20cea4$export$8d0767d85173b4a1)((0, $ced745a80d9e02b4$export$3ce31bfaa5288b9a)($1d992394cfde0d25$exports)),
        (0, $1e5f7ae7c7f6b939$export$3acacdf112fc9c85),
        (0, $35fd058f1d09b998$export$3acacdf112fc9c85),
        (0, $4b9b50c2c639efa4$export$3acacdf112fc9c85),
        (0, $6558836aa09bcb2f$export$3acacdf112fc9c85),
        (0, $e8dc4df19f88520c$export$3acacdf112fc9c85),
        (0, $2ea6c3ce60db8b11$export$3acacdf112fc9c85),
        (0, $6599bf6bbe0c6254$export$3acacdf112fc9c85),
        (0, $cdc8511741eaa8b6$export$3acacdf112fc9c85),
        (0, $242f3355b3097f8e$export$3acacdf112fc9c85),
        (0, $bafc65d919b03fba$export$3acacdf112fc9c85),
        (0, $b49c1afa5c798896$export$3acacdf112fc9c85),
        (0, $1b0c59c17e6e6043$export$3acacdf112fc9c85),
        (0, $4e9d1f1b1c89fc2d$export$3acacdf112fc9c85),
        (0, $bd2a0e2574af9718$export$3acacdf112fc9c85),
        (0, $2cb5b9ef6797d819$export$3acacdf112fc9c85),
        (0, $609db939f26db573$export$3acacdf112fc9c85),
        (0, $9c01529d79753eb3$export$3acacdf112fc9c85),
        (0, $dd760fd61e20cea4$export$8d0767d85173b4a1)((0, $ced745a80d9e02b4$export$3ce31bfaa5288b9a)($9f9be13dfd5d2b11$exports)),
        (0, $6f18c8d3d270ce49$export$3acacdf112fc9c85),
        (0, $c71c5199e7c6aecc$export$3acacdf112fc9c85),
        (0, $576be99fff1bf187$export$3acacdf112fc9c85),
        (0, $7277f73a69a2cc79$export$3acacdf112fc9c85),
        (0, $df89cc1d92343f67$export$3acacdf112fc9c85)
    ];
};



var $9HEDW = parcelRequire("9HEDW");
const $5d552da03ce94102$export$df2b7e2d428c9ef = 'last-connected-wallets';
const $5d552da03ce94102$export$e7e817e2ff6fbc13 = 'hub-v1-last-connected-wallets';



var $9HEDW = parcelRequire("9HEDW");

class $4b9ee661cb885ab3$export$61446c92b3f6d01f {
    #storageKey;
    constructor(storageKey){
        this.#storageKey = storageKey;
    }
    addWallet(providerId, namespaces) {
        if (this.#storageKey === (0, $5d552da03ce94102$export$e7e817e2ff6fbc13)) return this.#addWalletToHub(providerId, namespaces);
        else if (this.#storageKey === (0, $5d552da03ce94102$export$df2b7e2d428c9ef)) return this.#addWalletToLegacy(providerId);
        throw new Error('Not implemented');
    }
    removeWallets(providerIds) {
        if (this.#storageKey === (0, $5d552da03ce94102$export$e7e817e2ff6fbc13)) return this.#removeWalletsFromHub(providerIds);
        else if (this.#storageKey === (0, $5d552da03ce94102$export$df2b7e2d428c9ef)) return this.#removeWalletsFromLegacy(providerIds);
        throw new Error('Not implemented');
    }
    list() {
        if (this.#storageKey === (0, $5d552da03ce94102$export$e7e817e2ff6fbc13)) return this.#listFromHub();
        else if (this.#storageKey === (0, $5d552da03ce94102$export$df2b7e2d428c9ef)) return this.#listFromLegacy();
        throw new Error('Not implemented');
    }
    removeNamespacesFromWallet(providerId, namespaceIds) {
        if (this.#storageKey === (0, $5d552da03ce94102$export$e7e817e2ff6fbc13)) return this.#removeNamespaceFromWalletHub(providerId, namespaceIds);
        throw new Error('Not implemented');
    }
    #listFromLegacy() {
        const persistor = new (0, $9HEDW.Persistor)();
        const lastConnectedWallets = persistor.getItem((0, $5d552da03ce94102$export$df2b7e2d428c9ef)) || [];
        const output = {};
        lastConnectedWallets.forEach((provider)=>{
            // Setting empty namespaces
            output[provider] = [];
        });
        return output;
    }
    #listFromHub() {
        const persistor = new (0, $9HEDW.Persistor)();
        const lastConnectedWallets = persistor.getItem((0, $5d552da03ce94102$export$e7e817e2ff6fbc13)) || {};
        return lastConnectedWallets;
    }
    #addWalletToHub(providerId, namespaces) {
        const storage = new (0, $9HEDW.Persistor)();
        const storageState = storage.getItem(this.#storageKey) || {};
        let toBeAddedNamespaces = namespaces;
        // If provider already exits in the storage, we should just add new namespaces to the previously added namespaces.
        if (!!storageState[providerId]) {
            const storedNamespaces = storageState[providerId];
            toBeAddedNamespaces = storedNamespaces.concat(namespaces.filter((namespace)=>!storedNamespaces.some((storedNamespace)=>storedNamespace.namespace === namespace.namespace)));
        }
        storage.setItem(this.#storageKey, {
            ...storageState,
            [providerId]: toBeAddedNamespaces
        });
    }
    #addWalletToLegacy(providerId) {
        const storage = new (0, $9HEDW.Persistor)();
        const storageState = storage.getItem(this.#storageKey) || [];
        storage.setItem((0, $5d552da03ce94102$export$df2b7e2d428c9ef), storageState.concat(providerId));
    }
    #removeWalletsFromHub(providerIds) {
        const persistor = new (0, $9HEDW.Persistor)();
        const storageState = persistor.getItem(this.#storageKey) || {};
        // Remove all wallets
        if (!providerIds) {
            persistor.setItem(this.#storageKey, {});
            return;
        }
        // Remove some of the wallets
        providerIds.forEach((providerId)=>{
            if (storageState[providerId]) delete storageState[providerId];
        });
        persistor.setItem(this.#storageKey, storageState);
    }
    #removeNamespaceFromWalletHub(providerId, namespaceIds) {
        const persistor = new (0, $9HEDW.Persistor)();
        const storageState = persistor.getItem(this.#storageKey) || {};
        const currentProviderNamespaces = storageState[providerId];
        const newProviderNamespaces = currentProviderNamespaces?.filter((namespace)=>!namespaceIds.includes(namespace.namespace));
        this.#removeWalletsFromHub([
            providerId
        ]);
        if (newProviderNamespaces?.length > 0) this.#addWalletToHub(providerId, newProviderNamespaces);
    }
    #removeWalletsFromLegacy(providerIds) {
        const persistor = new (0, $9HEDW.Persistor)();
        const storageState = persistor.getItem(this.#storageKey) || [];
        // Remove all wallets
        if (!providerIds) {
            persistor.setItem(this.#storageKey, []);
            return;
        }
        // Remove some of the wallets
        persistor.setItem((0, $5d552da03ce94102$export$df2b7e2d428c9ef), storageState.filter((wallet)=>!providerIds.includes(wallet)));
    }
}


function $e2e7a0c4c8c8e0a7$export$7877a478dd30fd3d(wallets, type) {
    return wallets.find((wallet)=>wallet.type === type) || null;
}
const $e2e7a0c4c8c8e0a7$export$583dd06ffb7665f8 = {
    connected: false,
    connecting: false,
    reachable: false,
    installed: false,
    accounts: null,
    network: null
};
function $e2e7a0c4c8c8e0a7$export$ca8ebd435faad836(state, action) {
    if (action.type === 'new_state') {
        // TODO fix problem and remove ts-ignore
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const target_wallet = state[action.wallet];
        if (!target_wallet) return {
            ...state,
            [action.wallet]: {
                ...$e2e7a0c4c8c8e0a7$export$583dd06ffb7665f8,
                [action.name]: action.value
            }
        };
        return {
            ...state,
            [action.wallet]: {
                ...target_wallet,
                [action.name]: action.value
            }
        };
    }
    return state;
}
function $e2e7a0c4c8c8e0a7$export$5ae027e423e49e34(providersState) {
    return Object.entries(providersState).filter(([, wallet_state])=>{
        return wallet_state?.connected;
    }).map(([type])=>{
        return type;
    });
}
function $e2e7a0c4c8c8e0a7$export$fa8b8bfe0657110e(providersState) {
    return Object.entries(providersState).map(([type])=>{
        return type;
    });
}
function $e2e7a0c4c8c8e0a7$export$927cec00467ddd76(list) {
    const wallets = new Map();
    list.forEach((provider)=>{
        const { config: config, ...actions } = provider;
        wallets.set(config.type, {
            actions: actions,
            config: config
        });
    });
    return wallets;
}
function $e2e7a0c4c8c8e0a7$export$aefee5ebe1dcfd9e(fn) {
    return fn?.constructor?.name === 'AsyncFunction';
}
function $e2e7a0c4c8c8e0a7$export$bfabd3ae82f8899f(options) {
    const { checkInstallation: checkInstallation = true } = options.config;
    return checkInstallation;
}
async function $e2e7a0c4c8c8e0a7$export$567be3f12e4409f4({ type: type, walletActions: walletActions, getState: getState }) {
    if (walletActions.canEagerConnect) {
        const lastConnectedWalletsFromStorage = new (0, $4b9ee661cb885ab3$export$61446c92b3f6d01f)((0, $5d552da03ce94102$export$df2b7e2d428c9ef));
        const lastConnectedWallets = lastConnectedWalletsFromStorage.list();
        const walletAlreadyPersisted = !!lastConnectedWallets[type];
        /*
     *If on the last attempt we are unable to eagerly connect to any wallet and the user connects any wallet manualy,
     *persistance will be outdated and will need to be removed.
     */ if (walletAlreadyPersisted && !getState(type).connected) $e2e7a0c4c8c8e0a7$export$68f445eb81c96373();
        if (!walletAlreadyPersisted) lastConnectedWalletsFromStorage.addWallet(type, []);
    }
}
function $e2e7a0c4c8c8e0a7$export$967c813e2e19faa4({ type: type, walletActions: walletActions }) {
    if (walletActions.canEagerConnect) {
        const lastConnectedWalletsFromStorage = new (0, $4b9ee661cb885ab3$export$61446c92b3f6d01f)((0, $5d552da03ce94102$export$df2b7e2d428c9ef));
        lastConnectedWalletsFromStorage.removeWallets([
            type
        ]);
    }
}
function $e2e7a0c4c8c8e0a7$export$68f445eb81c96373() {
    const persistor = new (0, $9HEDW.Persistor)();
    const wallets = persistor.getItem((0, $5d552da03ce94102$export$df2b7e2d428c9ef));
    if (wallets) persistor.removeItem((0, $5d552da03ce94102$export$df2b7e2d428c9ef));
}
function $e2e7a0c4c8c8e0a7$export$a94115b6ef8724e(dispatcher, onUpdateState) {
    const handler = (type, name, value, coreState, supportedChains)=>{
        const action = {
            type: 'new_state',
            wallet: type,
            name: name,
            value: value
        };
        // Update state
        dispatcher(action);
        // Giving the event to the outside listener
        if (onUpdateState) onUpdateState(type, name, value, coreState, supportedChains);
    };
    return handler;
}


var $d4dab640dcbe486c$exports = {};
'use strict';

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $c4572a2d5cf8409d$var$defaultErrorMessage = "Context hasn't been initialized yet.";
const $c4572a2d5cf8409d$var$defaultContext = {
    async connect () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    async disconnect () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    async disconnectAll () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    async suggestAndConnect () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    state () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    canSwitchNetworkTo () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    providers () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    getWalletInfo () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    getSigners () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    },
    hubProvider () {
        throw new Error($c4572a2d5cf8409d$var$defaultErrorMessage);
    }
};
const $c4572a2d5cf8409d$export$19648c908dc8d0bf = (0, $bh6RR.createContext)($c4572a2d5cf8409d$var$defaultContext);



var $9HEDW = parcelRequire("9HEDW");

parcelRequire("7MbFH");
var $fIwj6 = parcelRequire("fIwj6");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");



var $bh6RR = parcelRequire("bh6RR");


async function $0d7cc4364d8e3299$export$392c2457b7907874(wallets, getWalletInstance) {
    const lastConnectedWalletsFromStorage = new (0, $4b9ee661cb885ab3$export$61446c92b3f6d01f)((0, $5d552da03ce94102$export$df2b7e2d428c9ef));
    const lastConnectedWallets = lastConnectedWalletsFromStorage.list();
    const walletIds = Object.keys(lastConnectedWallets);
    if (walletIds.length) {
        const eagerConnectQueue = [];
        walletIds.forEach((walletType)=>{
            const wallet = wallets.get(walletType);
            if (!!wallet) {
                const walletInstance = getWalletInstance(wallet);
                eagerConnectQueue.push({
                    walletType: walletType,
                    eagerConnect: walletInstance.eagerConnect.bind(walletInstance)
                });
            }
        });
        const result = await Promise.allSettled(eagerConnectQueue.map(async ({ eagerConnect: eagerConnect })=>eagerConnect()));
        const walletsToRemoveFromPersistance = [];
        result.forEach((settleResult, index)=>{
            const { status: status } = settleResult;
            if (status === 'rejected') walletsToRemoveFromPersistance.push(eagerConnectQueue[index].walletType);
        });
        if (walletsToRemoveFromPersistance.length) lastConnectedWalletsFromStorage.removeWallets(walletsToRemoveFromPersistance);
    }
}




var $9HEDW = parcelRequire("9HEDW");

var $bh6RR = parcelRequire("bh6RR");

function $a3605f36c193ada0$export$ff0ad642b4872edc(onChangeState) {
    const availableWallets = (0, $bh6RR.useRef)({});
    /*
   * If `wallet` hasn't been added to `availableWallets`,
   * Get a instance of `Wallet` and save the refrence in `availableWallets`.
   * Otherwise, return the already created instance.
   */ function updater(wallet) {
        const type = wallet.config.type;
        // We only update, if there is no instance available.
        if (typeof availableWallets.current[type] === 'undefined') availableWallets.current[type] = new (0, $9HEDW.LegacyWallet)({
            config: wallet.config,
            handler: onChangeState
        }, wallet.actions);
        return availableWallets.current[type];
    }
    return updater;
}
function $a3605f36c193ada0$export$934951b5ed2ebf82() {
    const context = (0, $bh6RR.useContext)((0, $c4572a2d5cf8409d$export$19648c908dc8d0bf));
    if (!context) throw Error('useWallet can only be used within the Provider component');
    return context;
}



var $bh6RR = parcelRequire("bh6RR");
function $87f15deb7065acfc$export$78ab635f7488c800(props) {
    return !!props.allBlockChains?.length && !!props.autoConnect;
}


function $4b9fd758e7ceea46$export$6c56af1685106432(props) {
    const autoConnectInitiated = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        if ((0, $87f15deb7065acfc$export$78ab635f7488c800)(props) && !autoConnectInitiated.current) {
            autoConnectInitiated.current = true;
            props.autoConnectHandler();
        }
    }, [
        props.autoConnect,
        props.allBlockChains
    ]);
}


function $145393fac953fa93$export$fefdcf5a1fbabdc6(props) {
    const [providersState, dispatch] = (0, $bh6RR.useReducer)((0, $e2e7a0c4c8c8e0a7$export$ca8ebd435faad836), {});
    // Get (or add) wallet instance (`provider`s will be wrapped in a `Wallet`)
    const getWalletInstance = (0, $a3605f36c193ada0$export$ff0ad642b4872edc)((0, $e2e7a0c4c8c8e0a7$export$a94115b6ef8724e)(dispatch, props.onUpdateState));
    // Getting providers from props and put all of them in a `Map` with an appropriate interface.
    const listOfProviders = props.providers;
    const wallets = (0, $e2e7a0c4c8c8e0a7$export$927cec00467ddd76)(listOfProviders);
    (0, $4b9fd758e7ceea46$export$6c56af1685106432)({
        allBlockChains: props.allBlockChains,
        autoConnect: props.autoConnect,
        autoConnectHandler: async ()=>(0, $0d7cc4364d8e3299$export$392c2457b7907874)(wallets, getWalletInstance)
    });
    // Final API we put in context and it will be available to use for users.
    const api = {
        async connect (type, namespaces) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            // Legacy providers doesn't implemented multiple namespaces, so it will always be one value.
            let network = undefined;
            if (namespaces && namespaces.length > 0) /*
         * This may not be safe in cases there are two `network` for namespaces, the first one will be picked always.
         * But since legacy provider only accepts one value, it shouldn't be happened when we are using legacy mode.
         */ network = namespaces.find((ns)=>!!ns.network)?.network;
            const walletInstance = getWalletInstance(wallet);
            const result = await walletInstance.connect(network, namespaces);
            if (props.autoConnect) (0, $e2e7a0c4c8c8e0a7$export$567be3f12e4409f4)({
                type: type,
                walletActions: wallet.actions,
                getState: api.state
            });
            return [
                result
            ];
        },
        async disconnect (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            await walletInstance.disconnect();
            if (props.autoConnect) (0, $e2e7a0c4c8c8e0a7$export$967c813e2e19faa4)({
                type: type,
                walletActions: wallet.actions
            });
        },
        async disconnectAll () {
            const disconnect_promises = [];
            /*
       * When a wallet is initializing, a record will be added to `providersState`
       * So we use them to know what wallet has been initialized then we need to
       * filter connected wallets only.
       */ (0, $e2e7a0c4c8c8e0a7$export$5ae027e423e49e34)(providersState).forEach((type)=>{
                const wallet = wallets.get(type);
                if (wallet) {
                    const walletInstance = getWalletInstance(wallet);
                    disconnect_promises.push(walletInstance.disconnect());
                }
            });
            if (props.autoConnect) (0, $e2e7a0c4c8c8e0a7$export$68f445eb81c96373)();
            return await Promise.allSettled(disconnect_promises);
        },
        async suggestAndConnect (type, namespace) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            if (!namespace.network) throw new Error(`You should pass network to the suggestAndConnect`);
            const result = await walletInstance.suggestAndConnect(namespace.network);
            return result;
        },
        state (type) {
            return providersState[type] || (0, $e2e7a0c4c8c8e0a7$export$583dd06ffb7665f8);
        },
        canSwitchNetworkTo (type, network) {
            const wallet = wallets.get(type);
            if (!wallet) return false;
            const walletInstance = getWalletInstance(wallet);
            return walletInstance.canSwitchNetworkTo ? walletInstance.canSwitchNetworkTo(network, walletInstance.provider) : false;
        },
        providers () {
            const providers = {};
            (0, $e2e7a0c4c8c8e0a7$export$fa8b8bfe0657110e)(providersState).forEach((type)=>{
                const wallet = wallets.get(type);
                if (wallet) {
                    const walletInstance = getWalletInstance(wallet);
                    providers[type] = walletInstance.provider;
                }
            });
            return providers;
        },
        getWalletInfo (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            /*
       * Get wallet info could be used in render methods to show wallets data
       * So, addWalletRef method shouldn't be called in this method
       */ return wallet.actions.getWalletInfo(props.allBlockChains || []);
        },
        async getSigners (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const provider = walletInstance.provider;
            const result = walletInstance.getSigners(provider);
            return result;
        },
        hubProvider () {
            throw new Error('This method is not available on legacy providers.');
        }
    };
    // Initialize instances
    (0, $bh6RR.useEffect)(()=>{
        wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            const runOnInit = ()=>{
                if (walletInstance.onInit) walletInstance.onInit();
            };
            const initWhenPageIsReady = (event)=>{
                if (event.target && event.target.readyState === 'complete') {
                    runOnInit();
                    document.removeEventListener('readystatechange', initWhenPageIsReady);
                }
            };
            // Try to run, maybe it's ready.
            runOnInit();
            /*
       * Try again when the page has been completely loaded.
       * Some of wallets, take some time to be fully injected and loaded.
       */ document.addEventListener('readystatechange', initWhenPageIsReady);
        });
    }, []);
    // Setting supported blockchains on instances
    (0, $bh6RR.useEffect)(()=>{
        const allBlockChains = props.allBlockChains;
        if (allBlockChains) wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            const walletInfo = walletInstance.getWalletInfo(props.allBlockChains || []);
            walletInstance.setInfo({
                supportedBlockchains: walletInfo.supportedChains,
                isContractWallet: !!walletInfo.isContractWallet
            });
        });
    }, [
        props.allBlockChains
    ]);
    // Setting event handler on instances
    (0, $bh6RR.useEffect)(()=>{
        wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            walletInstance.setHandler((0, $e2e7a0c4c8c8e0a7$export$a94115b6ef8724e)(dispatch, props.onUpdateState));
        });
    }, [
        props.onUpdateState
    ]);
    return api;
}





var $9HEDW = parcelRequire("9HEDW");




var $er2za = parcelRequire("er2za");

var $3ca9q = parcelRequire("3ca9q");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
function $207b7d62896e775d$export$f84e8e69fd4488a5(val) {
    var value = String(val);
    if (value === '[object Object]') try {
        value = JSON.stringify(val);
    } catch (_a) {}
    return value;
}




/**
 * Contains the None value
 */ var $bd278ccfb1710dd6$var$NoneImpl = /** @class */ function() {
    function NoneImpl() {
        this.some = false;
        this.none = true;
    }
    NoneImpl.prototype[Symbol.iterator] = function() {
        return {
            next: function() {
                return {
                    done: true,
                    value: undefined
                };
            }
        };
    };
    NoneImpl.prototype.unwrapOr = function(val) {
        return val;
    };
    NoneImpl.prototype.expect = function(msg) {
        throw new Error("" + msg);
    };
    NoneImpl.prototype.unwrap = function() {
        throw new Error("Tried to unwrap None");
    };
    NoneImpl.prototype.map = function(_mapper) {
        return this;
    };
    NoneImpl.prototype.andThen = function(op) {
        return this;
    };
    NoneImpl.prototype.toResult = function(error) {
        return (0, $c88854de77322012$export$3659d3f2d3dfceb8)(error);
    };
    NoneImpl.prototype.toString = function() {
        return 'None';
    };
    return NoneImpl;
}();
var $bd278ccfb1710dd6$export$57ca7e07b341709d = new $bd278ccfb1710dd6$var$NoneImpl();
Object.freeze($bd278ccfb1710dd6$export$57ca7e07b341709d);
/**
 * Contains the success value
 */ var $bd278ccfb1710dd6$var$SomeImpl = /** @class */ function() {
    function SomeImpl(val) {
        if (!(this instanceof SomeImpl)) return new SomeImpl(val);
        this.some = true;
        this.none = false;
        this.val = val;
    }
    /**
     * Helper function if you know you have an Some<T> and T is iterable
     */ SomeImpl.prototype[Symbol.iterator] = function() {
        var obj = Object(this.val);
        return Symbol.iterator in obj ? obj[Symbol.iterator]() : {
            next: function() {
                return {
                    done: true,
                    value: undefined
                };
            }
        };
    };
    SomeImpl.prototype.unwrapOr = function(_val) {
        return this.val;
    };
    SomeImpl.prototype.expect = function(_msg) {
        return this.val;
    };
    SomeImpl.prototype.unwrap = function() {
        return this.val;
    };
    SomeImpl.prototype.map = function(mapper) {
        return $bd278ccfb1710dd6$export$9f9d0139d032da4f(mapper(this.val));
    };
    SomeImpl.prototype.andThen = function(mapper) {
        return mapper(this.val);
    };
    SomeImpl.prototype.toResult = function(error) {
        return (0, $c88854de77322012$export$8146e38189b4f4dc)(this.val);
    };
    /**
     * Returns the contained `Some` value, but never throws.
     * Unlike `unwrap()`, this method doesn't throw and is only callable on an Some<T>
     *
     * Therefore, it can be used instead of `unwrap()` as a maintainability safeguard
     * that will fail to compile if the type of the Option is later changed to a None that can actually occur.
     *
     * (this is the `into_Some()` in rust)
     */ SomeImpl.prototype.safeUnwrap = function() {
        return this.val;
    };
    SomeImpl.prototype.toString = function() {
        return "Some(" + (0, $207b7d62896e775d$export$f84e8e69fd4488a5)(this.val) + ")";
    };
    SomeImpl.EMPTY = new SomeImpl(undefined);
    return SomeImpl;
}();
var $bd278ccfb1710dd6$export$9f9d0139d032da4f = $bd278ccfb1710dd6$var$SomeImpl;
var $bd278ccfb1710dd6$export$36d18380658d5d20;
(function(Option) {
    /**
     * Parse a set of `Option`s, returning an array of all `Some` values.
     * Short circuits with the first `None` found, if any
     */ function all() {
        var options = [];
        for(var _i = 0; _i < arguments.length; _i++)options[_i] = arguments[_i];
        var someOption = [];
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.some) someOption.push(option.val);
            else return option;
        }
        return $bd278ccfb1710dd6$export$9f9d0139d032da4f(someOption);
    }
    Option.all = all;
    /**
     * Parse a set of `Option`s, short-circuits when an input value is `Some`.
     * If no `Some` is found, returns `None`.
     */ function any() {
        var options = [];
        for(var _i = 0; _i < arguments.length; _i++)options[_i] = arguments[_i];
        // short-circuits
        for(var _a = 0, options_2 = options; _a < options_2.length; _a++){
            var option = options_2[_a];
            if (option.some) return option;
            else return option;
        }
        // it must be None
        return $bd278ccfb1710dd6$export$57ca7e07b341709d;
    }
    Option.any = any;
    function isOption(value) {
        return value instanceof $bd278ccfb1710dd6$export$9f9d0139d032da4f || value === $bd278ccfb1710dd6$export$57ca7e07b341709d;
    }
    Option.isOption = isOption;
})($bd278ccfb1710dd6$export$36d18380658d5d20 || ($bd278ccfb1710dd6$export$36d18380658d5d20 = {}));


/**
 * Contains the error value
 */ var $c88854de77322012$export$b8a5a788bff8b675 = /** @class */ function() {
    function ErrImpl(val) {
        if (!(this instanceof ErrImpl)) return new ErrImpl(val);
        this.ok = false;
        this.err = true;
        this.val = val;
        var stackLines = new Error().stack.split('\n').slice(2);
        if (stackLines && stackLines.length > 0 && stackLines[0].includes('ErrImpl')) stackLines.shift();
        this._stack = stackLines.join('\n');
    }
    ErrImpl.prototype[Symbol.iterator] = function() {
        return {
            next: function() {
                return {
                    done: true,
                    value: undefined
                };
            }
        };
    };
    /**
     * @deprecated in favor of unwrapOr
     * @see unwrapOr
     */ ErrImpl.prototype.else = function(val) {
        return val;
    };
    ErrImpl.prototype.unwrapOr = function(val) {
        return val;
    };
    ErrImpl.prototype.expect = function(msg) {
        throw new Error(msg + " - Error: " + (0, $207b7d62896e775d$export$f84e8e69fd4488a5)(this.val) + "\n" + this._stack);
    };
    ErrImpl.prototype.unwrap = function() {
        throw new Error("Tried to unwrap Error: " + (0, $207b7d62896e775d$export$f84e8e69fd4488a5)(this.val) + "\n" + this._stack);
    };
    ErrImpl.prototype.map = function(_mapper) {
        return this;
    };
    ErrImpl.prototype.andThen = function(op) {
        return this;
    };
    ErrImpl.prototype.mapErr = function(mapper) {
        return new $c88854de77322012$export$3659d3f2d3dfceb8(mapper(this.val));
    };
    ErrImpl.prototype.toOption = function() {
        return 0, $bd278ccfb1710dd6$export$57ca7e07b341709d;
    };
    ErrImpl.prototype.toString = function() {
        return "Err(" + (0, $207b7d62896e775d$export$f84e8e69fd4488a5)(this.val) + ")";
    };
    Object.defineProperty(ErrImpl.prototype, "stack", {
        get: function() {
            return this + "\n" + this._stack;
        },
        enumerable: false,
        configurable: true
    });
    /** An empty Err */ ErrImpl.EMPTY = new ErrImpl(undefined);
    return ErrImpl;
}();
var $c88854de77322012$export$3659d3f2d3dfceb8 = $c88854de77322012$export$b8a5a788bff8b675;
/**
 * Contains the success value
 */ var $c88854de77322012$export$f6dde300674b3d5a = /** @class */ function() {
    function OkImpl(val) {
        if (!(this instanceof OkImpl)) return new OkImpl(val);
        this.ok = true;
        this.err = false;
        this.val = val;
    }
    /**
     * Helper function if you know you have an Ok<T> and T is iterable
     */ OkImpl.prototype[Symbol.iterator] = function() {
        var obj = Object(this.val);
        return Symbol.iterator in obj ? obj[Symbol.iterator]() : {
            next: function() {
                return {
                    done: true,
                    value: undefined
                };
            }
        };
    };
    /**
     * @see unwrapOr
     * @deprecated in favor of unwrapOr
     */ OkImpl.prototype.else = function(_val) {
        return this.val;
    };
    OkImpl.prototype.unwrapOr = function(_val) {
        return this.val;
    };
    OkImpl.prototype.expect = function(_msg) {
        return this.val;
    };
    OkImpl.prototype.unwrap = function() {
        return this.val;
    };
    OkImpl.prototype.map = function(mapper) {
        return new $c88854de77322012$export$8146e38189b4f4dc(mapper(this.val));
    };
    OkImpl.prototype.andThen = function(mapper) {
        return mapper(this.val);
    };
    OkImpl.prototype.mapErr = function(_mapper) {
        return this;
    };
    OkImpl.prototype.toOption = function() {
        return (0, $bd278ccfb1710dd6$export$9f9d0139d032da4f)(this.val);
    };
    /**
     * Returns the contained `Ok` value, but never throws.
     * Unlike `unwrap()`, this method doesn't throw and is only callable on an Ok<T>
     *
     * Therefore, it can be used instead of `unwrap()` as a maintainability safeguard
     * that will fail to compile if the error type of the Result is later changed to an error that can actually occur.
     *
     * (this is the `into_ok()` in rust)
     */ OkImpl.prototype.safeUnwrap = function() {
        return this.val;
    };
    OkImpl.prototype.toString = function() {
        return "Ok(" + (0, $207b7d62896e775d$export$f84e8e69fd4488a5)(this.val) + ")";
    };
    OkImpl.EMPTY = new OkImpl(undefined);
    return OkImpl;
}();
var $c88854de77322012$export$8146e38189b4f4dc = $c88854de77322012$export$f6dde300674b3d5a;
var $c88854de77322012$export$8fdcabde73f49165;
(function(Result) {
    /**
     * Parse a set of `Result`s, returning an array of all `Ok` values.
     * Short circuits with the first `Err` found, if any
     */ function all() {
        var results = [];
        for(var _i = 0; _i < arguments.length; _i++)results[_i] = arguments[_i];
        var okResult = [];
        for(var _a = 0, results_1 = results; _a < results_1.length; _a++){
            var result = results_1[_a];
            if (result.ok) okResult.push(result.val);
            else return result;
        }
        return new $c88854de77322012$export$8146e38189b4f4dc(okResult);
    }
    Result.all = all;
    /**
     * Parse a set of `Result`s, short-circuits when an input value is `Ok`.
     * If no `Ok` is found, returns an `Err` containing the collected error values
     */ function any() {
        var results = [];
        for(var _i = 0; _i < arguments.length; _i++)results[_i] = arguments[_i];
        var errResult = [];
        // short-circuits
        for(var _a = 0, results_2 = results; _a < results_2.length; _a++){
            var result = results_2[_a];
            if (result.ok) return result;
            else errResult.push(result.val);
        }
        // it must be a Err
        return new $c88854de77322012$export$3659d3f2d3dfceb8(errResult);
    }
    Result.any = any;
    /**
     * Wrap an operation that may throw an Error (`try-catch` style) into checked exception style
     * @param op The operation function
     */ function wrap(op) {
        try {
            return new $c88854de77322012$export$8146e38189b4f4dc(op());
        } catch (e) {
            return new $c88854de77322012$export$3659d3f2d3dfceb8(e);
        }
    }
    Result.wrap = wrap;
    /**
     * Wrap an async operation that may throw an Error (`try-catch` style) into checked exception style
     * @param op The operation function
     */ function wrapAsync(op) {
        try {
            return op().then(function(val) {
                return new $c88854de77322012$export$8146e38189b4f4dc(val);
            }).catch(function(e) {
                return new $c88854de77322012$export$3659d3f2d3dfceb8(e);
            });
        } catch (e) {
            return Promise.resolve(new $c88854de77322012$export$3659d3f2d3dfceb8(e));
        }
    }
    Result.wrapAsync = wrapAsync;
    function isResult(val) {
        return val instanceof $c88854de77322012$export$3659d3f2d3dfceb8 || val instanceof $c88854de77322012$export$8146e38189b4f4dc;
    }
    Result.isResult = isResult;
})($c88854de77322012$export$8fdcabde73f49165 || ($c88854de77322012$export$8fdcabde73f49165 = {}));





function $20c756994ff5e19c$export$f9554d48deca6680(chainId, allBlockChains) {
    if (typeof chainId === 'string') return chainId;
    const useNamespaceAsNetworkFor = [
        'solana',
        'xrpl',
        'stellar'
    ];
    if (useNamespaceAsNetworkFor.includes(chainId.namespace.toLowerCase())) return chainId.namespace.toUpperCase();
    if (chainId.namespace.toLowerCase() === 'eip155') return 'ETH';
    else if (chainId.reference === (0, $er2za.CAIP_BITCOIN_CHAIN_ID)) return 'BTC';
    else if (chainId.reference === (0, $er2za.CAIP_ZCASH_CHAIN_ID)) return 'ZCASH';
    if (chainId.namespace.toLowerCase() === (0, $d90f58c84ad0ffac$export$c67e5a7ce034264a)) return 'TON';
    if (chainId.namespace.toLowerCase() === (0, $79cc43c70481c16f$export$c67e5a7ce034264a)) {
        const network = (0, $9HEDW.legacyGetBlockChainNameFromId)(chainId.reference, allBlockChains);
        if (!network) throw new Error(`Network didn't found for given chainId: ${chainId.reference}`);
        return network;
    }
    if (chainId.namespace === 'sui' || chainId.reference === (0, $838c2177a0531a1c$export$b3b3a07ef606aa99)) return chainId.reference.toUpperCase();
    if (chainId.namespace === 'starknet') return chainId.namespace.toUpperCase();
    return chainId.reference;
}
function $20c756994ff5e19c$export$96ee53d48509b544(account, allBlockChains) {
    const { chainId: chainId, address: address } = (0, $3ca9q).AccountId.parse(account);
    const network = $20c756994ff5e19c$export$f9554d48deca6680(chainId, allBlockChains);
    return (0, $9HEDW.legacyFormatAddressWithNetwork)(address, network);
}
async function $20c756994ff5e19c$export$9c253b7a18cdc391(promises) {
    return promises.reduce(async (prevPromise, task)=>{
        const previousResults = await prevPromise;
        try {
            const taskResult = await task();
            return [
                ...previousResults,
                new (0, $c88854de77322012$export$8146e38189b4f4dc)(taskResult)
            ];
        } catch (error) {
            return [
                ...previousResults,
                new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(error)
            ];
        }
    }, Promise.resolve([]));
}
function $20c756994ff5e19c$export$1beb3e5bf2d336dd(result) {
    return typeof result === 'object' && !Array.isArray(result);
}
function $20c756994ff5e19c$export$313016891176960b(result) {
    return Array.isArray(result);
}
function $20c756994ff5e19c$export$d16acf4b6e75743d(options) {
    const processingKeys = new Set();
    let queue = [];
    const removeKeyFromQueue = (key, result)=>{
        queue = queue.filter((q)=>{
            if (q.key !== key) return true;
            q.resolve(result);
            return false;
        });
    };
    const processQueue = async ()=>{
        const currentItem = queue.find((item)=>!processingKeys.has(item.key));
        if (!currentItem) return;
        const { task: task, resolve: resolve, key: key } = currentItem;
        processingKeys.add(key);
        try {
            const result = await task();
            resolve(new (0, $c88854de77322012$export$8146e38189b4f4dc)(result));
        } catch (error) {
            if (options?.onError) options.onError(error, {
                removeCurrentKeyFromQueue: ()=>removeKeyFromQueue(key, new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(error))
            });
            resolve(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(error));
        } finally{
            const indexOfCurrentItem = queue.findIndex((item)=>item.key === key);
            if (indexOfCurrentItem >= 0) queue.splice(indexOfCurrentItem, 1);
            processingKeys.delete(key);
            processQueue();
        }
    };
    const queueTask = async (task, key)=>new Promise((resolve)=>{
            queue.push({
                task: task,
                resolve: resolve,
                key: key
            });
            processQueue();
        });
    return queueTask;
}



function $acada4b00987355d$export$f8d285a8297f4aea(providers) {
    const LEGACY_VERSION = '0.0.0';
    const HUB_VERSION = '1.0.0';
    const legacyProviders = [];
    const hubProviders = [];
    providers.forEach((provider)=>{
        try {
            const target = (0, $ced745a80d9e02b4$export$e07c34986d13152a)(provider, HUB_VERSION);
            hubProviders.push(target[1]);
        } catch  {
            const target = (0, $ced745a80d9e02b4$export$e07c34986d13152a)(provider, LEGACY_VERSION);
            legacyProviders.push(target[1]);
        }
    });
    return [
        legacyProviders,
        hubProviders
    ];
}
function $acada4b00987355d$export$fcb191413cf8d878(providers, type) {
    return providers.find((provider)=>provider.id === type);
}
/**
 * We will call this function on hub's `subscribe`.
 * it will check states and will emit legacy events for backward compatibility.
 */ const $acada4b00987355d$var$lastConnectedWalletsFromStorage = new (0, $4b9ee661cb885ab3$export$61446c92b3f6d01f)((0, $5d552da03ce94102$export$e7e817e2ff6fbc13));
function $acada4b00987355d$export$d4b36a195a1b02e(provider, allBlockChains) {
    const namespacesProperty = provider.info()?.metadata.properties?.find((property)=>property.name === 'namespaces');
    const supportedChains = namespacesProperty?.value.data.flatMap((namespace)=>namespace.getSupportedChains(allBlockChains || [])) || [];
    return supportedChains;
}
function $acada4b00987355d$export$f073b85f3fec5040(hub, event, onUpdateState, metadata) {
    const provider = hub.get(event.provider);
    if (!provider) throw new Error("Currently all the events have assigned to a provider. The event doesn't include one.", {
        cause: event
    });
    // @ts-expect-error for those events that doesn't have namespace, it will be undefinded
    const namespaceId = event.namespace;
    const namespace = namespaceId ? provider.findByNamespace(namespaceId) : undefined;
    let accounts = null;
    let network = null;
    let derivationPath;
    if (namespace) {
        const [getNamespaceState] = namespace.state();
        accounts = getNamespaceState().accounts;
        network = getNamespaceState().network;
        if (metadata.lastConnectAttemptParams[event.provider]) derivationPath = metadata.lastConnectAttemptParams[event.provider].find((namespace)=>namespace.namespace === namespaceId)?.derivationPath;
    }
    const [getProviderState] = provider.state();
    const coreState = {
        connected: getProviderState().connected,
        connecting: getProviderState().connecting,
        installed: getProviderState().installed,
        accounts: accounts,
        network: network,
        reachable: true,
        derivationPath: derivationPath
    };
    const eventInfo = {
        supportedBlockchains: $acada4b00987355d$export$d4b36a195a1b02e(provider, metadata.allBlockChains),
        isContractWallet: false,
        isHub: true,
        namespace: namespaceId
    };
    switch(event.type){
        case 'provider_detected':
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).INSTALLED, true, coreState, eventInfo);
            break;
        case 'provider_connecting':
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).CONNECTING, event.value, coreState, eventInfo);
            break;
        case 'provider_connected':
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).CONNECTED, true, coreState, eventInfo);
            break;
        case 'provider_disconnected':
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).PROVIDER_DISCONNECTED, event.provider, coreState, eventInfo);
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).CONNECTED, false, coreState, eventInfo);
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).ACCOUNTS, null, coreState, eventInfo);
            break;
        case 'namespace_disconnected':
            $acada4b00987355d$var$lastConnectedWalletsFromStorage.removeNamespacesFromWallet(event.provider, [
                event.namespace
            ]);
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).NAMESPACE_DISCONNECTED, event.namespace, coreState, {
                ...eventInfo,
                namespace: event.namespace
            });
            break;
        case 'namespace_connected':
        case 'namespace_account_switched':
            {
                if (event.type === 'namespace_account_switched') onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).NAMESPACE_DISCONNECTED, event.namespace, coreState, eventInfo);
                const formattedAddresses = event.accounts.map((accounts)=>(0, $20c756994ff5e19c$export$96ee53d48509b544)(accounts, metadata.allBlockChains || []));
                onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).ACCOUNTS, formattedAddresses, coreState, {
                    ...eventInfo,
                    namespace: event.namespace
                });
            }
            break;
        case 'namespace_network_switched':
            onUpdateState(event.provider, (0, $9HEDW.LegacyEvents).NETWORK, event.network, coreState, {
                ...eventInfo,
                namespace: event.namespace
            });
            break;
    }
}
function $acada4b00987355d$export$fcb9739f5dd6fd58(allProviders) {
    const LEGACY_VERSION = '0.0.0';
    const legacyProviders = [];
    allProviders.forEach((provider)=>{
        const target = (0, $ced745a80d9e02b4$export$e07c34986d13152a)(provider, LEGACY_VERSION);
        legacyProviders.push(target[1]);
    });
    return legacyProviders;
}
function $acada4b00987355d$export$8e9da7a05b0d1dc5(namespace, meta) {
    if (!namespace.network) return undefined;
    const evmBlockchainsList = meta.filter((0, $hE77Y.isEvmBlockchain));
    const evmChains = (0, $fIwj6.convertEvmBlockchainMetaToEvmChainInfo)(evmBlockchainsList);
    return evmChains[namespace.network];
}
function $acada4b00987355d$export$1da12cf344f340e5(namespace, meta) {
    // `undefined` means it's not evm or we couldn't find it in meta.
    const evmChain = $acada4b00987355d$export$8e9da7a05b0d1dc5(namespace, meta);
    const network = evmChain || namespace.network;
    return network;
}
function $acada4b00987355d$export$b2e471f835f7c8fb(res) {
    if ((0, $20c756994ff5e19c$export$1beb3e5bf2d336dd)(res)) return {
        accounts: res.accounts,
        network: res.network,
        provider: undefined
    };
    else if ((0, $20c756994ff5e19c$export$313016891176960b)(res)) return {
        accounts: res,
        network: null,
        provider: undefined
    };
    return {
        accounts: [
            res
        ],
        network: null,
        provider: undefined
    };
}
function $acada4b00987355d$export$d0f8297916b79436(hub, configurationProviders) {
    const registeredProviders = hub.getAll();
    // Register and initialize providers that exist in config but not in hub
    const providersToRegister = configurationProviders.filter((configProvider)=>!registeredProviders.get(configProvider.id));
    providersToRegister.forEach((providerToRegister)=>{
        hub.add(providerToRegister.id, providerToRegister);
        providerToRegister.init();
    });
    // Remove providers that exist in hub but not in config
    registeredProviders.forEach((registeredProvider)=>{
        const isProviderInConfig = configurationProviders.some((configProvider)=>configProvider.id === registeredProvider.id);
        if (!isProviderInConfig) hub.remove(registeredProvider.id);
    });
}
function $acada4b00987355d$export$ec5f2951c47bab99(ns) {
    return ns.namespaceId === 'Solana';
}
function $acada4b00987355d$export$3ab2bdc88f2fb217(ns) {
    return ns.namespaceId === 'EVM';
}
function $acada4b00987355d$export$7c14e8873a10c013(ns) {
    return ns.namespaceId === 'Cosmos';
}



parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");

var $bh6RR = parcelRequire("bh6RR");



parcelRequire("fvuxD");
var $hmR2n = parcelRequire("hmR2n");

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");





// Getting connected wallets from storage
const $f9eb8d99cd669cb6$var$lastConnectedWalletsFromStorage = new (0, $4b9ee661cb885ab3$export$61446c92b3f6d01f)((0, $5d552da03ce94102$export$e7e817e2ff6fbc13));
/**
 * Run `.connect` action on some selected namespaces (passed as param) for a provider.
 */ async function $f9eb8d99cd669cb6$var$eagerConnect(type, namespacesInput, params) {
    const { getHub: getHub, allBlockChains: allBlockChains } = params;
    const wallet = getHub().get(type);
    if (!wallet) throw new Error(`You should add ${type} to provider first then call 'connect'.`);
    if (!namespacesInput) throw new Error('Passing namespace to `connect` is required. ');
    const targetNamespaces = [];
    namespacesInput.forEach((namespaceInput)=>{
        const targetNamespace = namespaceInput.namespace;
        const result = wallet.findByNamespace(targetNamespace);
        if (!result) throw new Error(`We couldn't find any provider matched with your request namespace. (requested namespace: ${namespaceInput.namespace})`);
        targetNamespaces.push([
            namespaceInput,
            result
        ]);
    });
    const connectNamespacesPromises = targetNamespaces.map(([info, namespace])=>{
        const evmChain = (0, $9HEDW.legacyIsEvmNamespace)(info) ? (0, $acada4b00987355d$export$8e9da7a05b0d1dc5)(info, allBlockChains || []) : undefined;
        const chain = evmChain || info.network;
        return async ()=>{
            let connectNamespacePromise;
            if ((0, $acada4b00987355d$export$3ab2bdc88f2fb217)(namespace)) connectNamespacePromise = async ()=>namespace.connect(chain);
            else if ((0, $acada4b00987355d$export$7c14e8873a10c013)(namespace)) {
                const cosmosBlockChains = (0, $hE77Y.cosmosBlockchains)(params.allBlockChains || []).filter((chain)=>!!chain.chainId);
                connectNamespacePromise = async ()=>{
                    return namespace.connect({
                        chainIds: cosmosBlockChains.filter((chain)=>chain.info && !chain.info.experimental)?.map((chain)=>chain.chainId),
                        customChainIds: cosmosBlockChains.filter((chain)=>chain.info?.experimental).map((chain)=>chain.chainId)
                    });
                };
            } else connectNamespacePromise = async ()=>namespace.connect();
            try {
                await connectNamespacePromise();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                /*
           * Since we check for connect failures using `instanceof Error`
           * this check is added here to make sure the thrown error always is an instance of `Error`
           */ if (e instanceof Error) throw e;
                throw new Error(e);
            }
        };
    });
    /**
   * Sometimes calling methods on a instance in parallel, would cause an error in wallet.
   * We are running a method at a time to make sure we are covering this.
   * e.g. when we are trying to eagerConnect evm and solana on phantom at the same time, the last namespace throw an error.
   */ const connectNamespacesResult = await (0, $20c756994ff5e19c$export$9c253b7a18cdc391)(connectNamespacesPromises);
    const failedNamespaces = targetNamespaces.filter((_, index)=>connectNamespacesResult[index].err).map((targetNamespace)=>targetNamespace[0]);
    if (failedNamespaces.length > 0) $f9eb8d99cd669cb6$var$lastConnectedWalletsFromStorage.removeNamespacesFromWallet(type, failedNamespaces.map((namespace)=>namespace.namespace));
    const atLeastOneNamespaceConnectedSuccessfully = connectNamespacesResult.some((result)=>result.ok);
    if (!atLeastOneNamespaceConnectedSuccessfully) throw new Error(`No namespace connected for ${type}`);
    return (0, $c88854de77322012$export$8fdcabde73f49165).all(...connectNamespacesResult.filter((result)=>result.ok)).unwrap();
}
/**
 * Run `.canEagerConnect` action on some selected namespaces of a wallet.
 */ async function $f9eb8d99cd669cb6$var$tryRunCanEagerConnect(namespaces, wallet) {
    const foundNamespaces = [];
    const successNamespaces = [];
    const failedNamespaces = [];
    const canEagerConnectPromises = [];
    // 1. Try find namespace instances and create canEagerConnect promises
    namespaces.forEach((namespace)=>{
        const namespaceInstance = wallet.findByNamespace(namespace.namespace);
        if (namespaceInstance) {
            foundNamespaces.push(namespace);
            canEagerConnectPromises.push(async ()=>await namespaceInstance.canEagerConnect());
        } else failedNamespaces.push(namespace);
    });
    // 2. Run canEagerConnect sequentially on namespaces
    const canEagerConnectResults = await (0, $20c756994ff5e19c$export$9c253b7a18cdc391)(canEagerConnectPromises);
    // 3. Separate success and failed namespaces based on canEagerConnect result
    foundNamespaces.forEach((namespace, index)=>{
        if (canEagerConnectResults[index].ok && canEagerConnectResults[index].val) successNamespaces.push(namespace);
        else failedNamespaces.push(namespace);
    });
    return {
        successNamespaces: successNamespaces,
        failedNamespaces: failedNamespaces
    };
}
async function $f9eb8d99cd669cb6$export$392c2457b7907874(deps) {
    const { getHub: getHub, allBlockChains: allBlockChains, wallets: wallets } = deps;
    const lastConnectedWallets = $f9eb8d99cd669cb6$var$lastConnectedWalletsFromStorage.list();
    const walletIds = Object.keys(lastConnectedWallets);
    const walletsToRemoveFromPersistence = [];
    if (walletIds.length) {
        const eagerConnectQueue = [];
        const configWalletNames = wallets?.map((wallet)=>{
            if (typeof wallet === 'string') return wallet;
            if (wallet instanceof (0, $hmR2n.Provider)) return wallet.id;
            return wallet.config.type;
        });
        // Run `.connect` if `.canEagerConnect` returns `true`.
        walletIds.forEach(async (providerName)=>{
            if (configWalletNames && !configWalletNames.includes(providerName)) {
                console.warn('Trying to run auto connect for a wallet which is not included in config. Desired wallet:', providerName);
                walletsToRemoveFromPersistence.push(providerName);
                return;
            }
            const wallet = getHub().get(providerName);
            const lastConnectedNamespaces = lastConnectedWallets[providerName].map((namespace)=>({
                    namespace: namespace.namespace,
                    network: namespace.network
                }));
            if (!lastConnectedNamespaces.length || !wallet) {
                walletsToRemoveFromPersistence.push(providerName);
                return;
            }
            const { successNamespaces: successNamespaces, failedNamespaces: failedNamespaces } = await $f9eb8d99cd669cb6$var$tryRunCanEagerConnect(lastConnectedNamespaces, wallet);
            if (!successNamespaces.length) {
                walletsToRemoveFromPersistence.push(providerName);
                return;
            } else if (failedNamespaces.length) $f9eb8d99cd669cb6$var$lastConnectedWalletsFromStorage.removeNamespacesFromWallet(wallet.id, failedNamespaces.map((namespace)=>namespace.namespace));
            eagerConnectQueue.push($f9eb8d99cd669cb6$var$eagerConnect(providerName, successNamespaces, {
                allBlockChains: allBlockChains,
                getHub: getHub
            }).catch((error)=>console.warn(error)));
        });
        $f9eb8d99cd669cb6$var$lastConnectedWalletsFromStorage.removeWallets(walletsToRemoveFromPersistence);
        await Promise.all(eagerConnectQueue);
    }
}


function $cd6583130e7d9586$export$4bdf286a2e1762bc(meta) {
    const info = meta.info;
    if (!info) throw new Error('CosmosChainInfo is required for conversion');
    const chain = $cd6583130e7d9586$var$convertToChain(meta, info);
    const assetList = $cd6583130e7d9586$var$convertToAssetList(info);
    return {
        chain: chain,
        assetList: assetList
    };
}
function $cd6583130e7d9586$var$convertToChain(meta, info) {
    const chain = {
        chainName: info.chainName,
        chainType: 'cosmos',
        chainId: meta.chainId || undefined,
        prettyName: meta.displayName,
        status: meta.enabled ? 'live' : 'killed',
        networkType: 'mainnet',
        bech32Prefix: info.bech32Config.bech32PrefixAccAddr,
        bech32Config: {
            bech32PrefixAccAddr: info.bech32Config.bech32PrefixAccAddr,
            bech32PrefixAccPub: info.bech32Config.bech32PrefixAccPub,
            bech32PrefixValAddr: info.bech32Config.bech32PrefixValAddr,
            bech32PrefixValPub: info.bech32Config.bech32PrefixValPub,
            bech32PrefixConsAddr: info.bech32Config.bech32PrefixConsAddr,
            bech32PrefixConsPub: info.bech32Config.bech32PrefixConsPub
        },
        slip44: info.bip44.coinType,
        fees: {
            feeTokens: $cd6583130e7d9586$var$convertFeeTokens(info)
        },
        staking: {
            stakingTokens: $cd6583130e7d9586$var$convertStakingTokens(info)
        },
        apis: {
            rpc: info.rpc ? [
                {
                    address: info.rpc
                }
            ] : undefined,
            rest: info.rest ? [
                {
                    address: info.rest
                }
            ] : undefined
        },
        explorers: $cd6583130e7d9586$var$convertExplorers(info),
        logoURIs: meta.logo ? {
            png: window.location.origin + meta.logo
        } : undefined,
        keywords: info.experimental ? [
            'experimental'
        ] : undefined
    };
    return chain;
}
function $cd6583130e7d9586$var$convertFeeTokens(info) {
    return info.feeCurrencies.map((currency)=>{
        const feeToken = {
            denom: currency.coinMinimalDenom
        };
        if (info.gasPriceStep) {
            feeToken.lowGasPrice = info.gasPriceStep.low;
            feeToken.averageGasPrice = info.gasPriceStep.average;
            feeToken.highGasPrice = info.gasPriceStep.high;
        }
        return feeToken;
    });
}
function $cd6583130e7d9586$var$convertStakingTokens(info) {
    return [
        {
            denom: info.stakeCurrency.coinMinimalDenom
        }
    ];
}
function $cd6583130e7d9586$var$convertExplorers(info) {
    const explorers = [];
    if (info.explorerUrlToTx) {
        const baseUrl = info.explorerUrlToTx.split('/tx/')[0];
        explorers.push({
            url: baseUrl,
            txPage: info.explorerUrlToTx.replace(/\{txHash\}|\$\{txHash\}/g, '${txHash}')
        });
    }
    if (info.blockExplorerUrls && info.blockExplorerUrls.length > 0) info.blockExplorerUrls.forEach((url)=>{
        if (!explorers.some((e)=>e.url === url)) explorers.push({
            url: url
        });
    });
    return explorers.length > 0 ? explorers : undefined;
}
function $cd6583130e7d9586$var$convertToAssetList(info) {
    const assets = [];
    // Add staking currency
    assets.push({
        denomUnits: [
            {
                denom: info.stakeCurrency.coinMinimalDenom,
                exponent: 0
            },
            {
                denom: info.stakeCurrency.coinDenom.toLowerCase(),
                exponent: info.stakeCurrency.coinDecimals
            }
        ],
        base: info.stakeCurrency.coinMinimalDenom,
        name: info.stakeCurrency.coinDenom,
        display: info.stakeCurrency.coinDenom.toLowerCase(),
        symbol: info.stakeCurrency.coinDenom,
        typeAsset: 'sdk.coin',
        logoURIs: info.stakeCurrency.coinImageUrl ? {
            png: window.location.origin + info.stakeCurrency.coinImageUrl
        } : undefined,
        coingeckoId: info.stakeCurrency.coinGeckoId || undefined
    });
    // Add other currencies
    info.currencies.forEach((currency)=>{
        // Skip if already added as staking currency
        if (currency.coinMinimalDenom === info.stakeCurrency.coinMinimalDenom) return;
        assets.push({
            denomUnits: [
                {
                    denom: currency.coinMinimalDenom,
                    exponent: 0
                },
                {
                    denom: currency.coinDenom.toLowerCase(),
                    exponent: currency.coinDecimals
                }
            ],
            base: currency.coinMinimalDenom,
            name: currency.coinDenom,
            display: currency.coinDenom.toLowerCase(),
            symbol: currency.coinDenom,
            typeAsset: 'sdk.coin',
            logoURIs: currency.coinImageUrl ? {
                png: window.location.origin + currency.coinImageUrl
            } : undefined,
            coingeckoId: currency.coinGeckoId || undefined
        });
    });
    return {
        chainName: info.chainName,
        assets: assets
    };
}




parcelRequire("fvuxD");
var $e21ow = parcelRequire("e21ow");
var $hRmKL = parcelRequire("hRmKL");

var $bh6RR = parcelRequire("bh6RR");

function $228bdd82c7e7f7c4$export$fbff232574c1d05c(providers) {
    const store = (0, $bh6RR.useRef)(null);
    const hub = (0, $bh6RR.useRef)(null);
    function createHub() {
        const createdHub = new (0, $hRmKL.Hub)({
            store: getStore()
        });
        /*
     * First add providers to hub
     * This helps to `getWalletInfo` be usable, before initialize.
     */ providers.forEach((provider)=>{
            createdHub.add(provider.id, provider);
        });
        hub.current = createdHub;
        return createdHub;
    }
    // https://react.dev/reference/react/useRef#avoiding-recreating-the-ref-contents
    function getStore() {
        if (store.current !== null) return store.current;
        const createdStore = (0, $e21ow.createStore)();
        store.current = createdStore;
        return createdStore;
    }
    function getHub() {
        const hubProviders = hub.current?.getAll();
        if (!hub.current || !hubProviders) return createHub();
        (0, $acada4b00987355d$export$d0f8297916b79436)(hub.current, providers);
        return hub.current;
    }
    return {
        getStore: getStore,
        getHub: getHub
    };
}



function $d1be72ea709f82ef$export$985b5837ed664745(params) {
    const { getStore: getStore, getHub: getHub } = (0, $228bdd82c7e7f7c4$export$fbff232574c1d05c)(params.providers);
    const [, rerender] = (0, $bh6RR.useState)(0);
    // useEffect will run `subscribe` once, so we need a reference and mutate the value if it's changes.
    const dataRef = (0, $bh6RR.useRef)({
        onUpdateState: params.onUpdateState,
        allVersionedProviders: params.allVersionedProviders,
        allBlockChains: params.allBlockChains
    });
    /*
   * Params of each connection attempt for each wallet type are stored here.
   * Derivation path from params is used in `mapHubEventsToLegacy` to be added to the payload of connect events.
   */ const lastConnectAttemptParamsRef = (0, $bh6RR.useRef)({});
    const updateLastConnectAttemptParams = (type, namespaces)=>{
        lastConnectAttemptParamsRef.current[type] = namespaces || [];
    };
    const queueTask = (0, $20c756994ff5e19c$export$d16acf4b6e75743d)({
        onError: (error, actions)=>{
            if ((0, $795b2611c2574d92$export$eab97d15b1788b8d).isUserRejectionError(error)) actions.removeCurrentKeyFromQueue();
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        dataRef.current = {
            onUpdateState: params.onUpdateState,
            allVersionedProviders: params.allVersionedProviders,
            allBlockChains: params.allBlockChains
        };
    }, [
        params
    ]);
    // Initialize instances
    (0, $bh6RR.useEffect)(()=>{
        const runOnInit = ()=>{
            getHub().init(params.configs?.walletOptions);
            rerender((currentRender)=>currentRender + 1);
        };
        // Then will call init whenever page is ready.
        const initHubWhenPageIsReady = (event)=>{
            // Then will call init whenever page is ready.
            if (event.target && event.target.readyState === 'complete') {
                runOnInit();
                document.removeEventListener('readystatechange', initHubWhenPageIsReady);
            }
        };
        // Try to run, maybe it's ready.
        runOnInit();
        /*
     * Try again when the page has been completely loaded.
     * Some of wallets, take some time to be fully injected and loaded.
     */ document.addEventListener('readystatechange', initHubWhenPageIsReady);
        getStore().subscribe((event)=>{
            if (dataRef.current.onUpdateState) try {
                (0, $acada4b00987355d$export$f073b85f3fec5040)(getHub(), event, dataRef.current.onUpdateState, {
                    allBlockChains: dataRef.current.allBlockChains,
                    lastConnectAttemptParams: lastConnectAttemptParamsRef.current
                });
            } catch (e) {
                console.error(e);
            }
            rerender((currentRender)=>currentRender + 1);
        }).flushEvents();
    }, []);
    (0, $4b9fd758e7ceea46$export$6c56af1685106432)({
        autoConnect: params.autoConnect,
        allBlockChains: params.allBlockChains,
        autoConnectHandler: ()=>{
            (0, $f9eb8d99cd669cb6$export$392c2457b7907874)({
                allBlockChains: params.allBlockChains,
                getHub: getHub,
                wallets: params.configs?.wallets
            });
        }
    });
    const lastConnectedWalletsFromStorage = new (0, $4b9ee661cb885ab3$export$61446c92b3f6d01f)((0, $5d552da03ce94102$export$e7e817e2ff6fbc13));
    const api = {
        canSwitchNetworkTo (type, network, namespace) {
            const provider = getHub().get(type);
            if (!provider) throw new Error(`You should add ${type} to provider first then call 'canSwitchNetworkTo'.`);
            if (!namespace) throw new Error('Passing namespace to `canSwitchNetworkTo` is required.');
            const proxiedNamespace = provider.findByNamespace(namespace.namespace);
            if (!proxiedNamespace) throw new Error(`We couldn't find any matched namespace on your request provider. (requested namespace: ${namespace.namespace})`);
            if (!('canSwitchNetwork' in proxiedNamespace)) return false;
            const namespacesProperty = provider.info()?.metadata?.properties?.find((property)=>property.name === 'namespaces');
            if (!dataRef.current.allBlockChains) throw new Error(`Blockchains are not available`);
            const providerSupportedChainsOfNamespace = namespacesProperty?.value.data.find((providerNamespace)=>providerNamespace.value === namespace.namespace)?.getSupportedChains(dataRef.current.allBlockChains);
            if (!providerSupportedChainsOfNamespace) throw new Error(`NamespaceMeta is not defined for requested namespace: ${namespace.namespace}`);
            return proxiedNamespace.canSwitchNetwork({
                network: network,
                supportedChains: providerSupportedChainsOfNamespace
            });
        },
        async connect (type, namespaces) {
            const wallet = getHub().get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first then call 'connect'.`);
            if (!namespaces) throw new Error('Passing namespace to `connect` is required.');
            updateLastConnectAttemptParams(type, namespaces);
            // Check `namespace` and look into hub to see how it can match given namespace to hub namespace.
            const targetNamespaces = [];
            namespaces.forEach((namespace)=>{
                const targetNamespace = namespace.namespace;
                const result = wallet.findByNamespace(targetNamespace);
                if (!result) throw new Error(`We couldn't find any provider matched with your request namespace. (requested namespace: ${namespace.namespace})`);
                targetNamespaces.push([
                    namespace,
                    result
                ]);
            });
            // Try to run `connect` on matched namespaces
            const connectResultFromTargetNamespaces = targetNamespaces.map(async ([namespaceInput, namespace])=>{
                const network = (0, $acada4b00987355d$export$1da12cf344f340e5)(namespaceInput, params.allBlockChains || []);
                let connectNamespacePromise;
                if ((0, $acada4b00987355d$export$ec5f2951c47bab99)(namespace)) connectNamespacePromise = async ()=>namespace.connect({
                        derivationPath: namespaceInput.derivationPath
                    });
                else if ((0, $acada4b00987355d$export$3ab2bdc88f2fb217)(namespace)) connectNamespacePromise = async ()=>namespace.connect(network, {
                        derivationPath: namespaceInput.derivationPath
                    });
                else if ((0, $acada4b00987355d$export$7c14e8873a10c013)(namespace)) {
                    const cosmosBlockChains = (0, $hE77Y.cosmosBlockchains)(params.allBlockChains || []).filter((chain)=>!!chain.chainId);
                    connectNamespacePromise = async ()=>{
                        return namespace.connect({
                            chainIds: cosmosBlockChains.filter((chain)=>chain.info && !chain.info.experimental)?.map((chain)=>chain.chainId),
                            customChainIds: cosmosBlockChains.filter((chain)=>chain.info?.experimental).map((chain)=>chain.chainId)
                        });
                    };
                } else connectNamespacePromise = async ()=>namespace.connect();
                const connectNamespaceProcess = async ()=>connectNamespacePromise().then((0, $acada4b00987355d$export$b2e471f835f7c8fb)).then((connectResult)=>{
                        return {
                            response: connectResult,
                            input: {
                                namespace: namespaceInput.namespace,
                                network: namespaceInput.network,
                                supportsEagerConnect: 'canEagerConnect' in namespace
                            }
                        };
                    });
                return queueTask(connectNamespaceProcess, type);
            });
            /*
       * We need to connect to namespace one after another, sending multiple requests at the same time may be failed.
       * e.g. when wallet popup opens and asking for the password from the user, it should be resolved first, then other request will be resolved.
       */ const connectResultWithLegacyFormat = await Promise.all(connectResultFromTargetNamespaces);
            // Keeping only namespaces that connected successfully and support eager connect, then we'll store them on storage for auto connect functionality.
            const successfullyConnectedSupportingEagerConnectNamespaces = connectResultWithLegacyFormat.filter((result)=>result.ok).filter((result)=>result.val.input.supportsEagerConnect).map((result)=>({
                    namespace: result.val.input.namespace,
                    network: result.val.input.network
                }));
            if (successfullyConnectedSupportingEagerConnectNamespaces.length > 0) lastConnectedWalletsFromStorage.addWallet(type, successfullyConnectedSupportingEagerConnectNamespaces);
            // Getting rid of `input` from Result
            const connectResults = connectResultWithLegacyFormat.map((result)=>result.andThen((okResult)=>new (0, $c88854de77322012$export$8146e38189b4f4dc)(okResult.response)));
            const allResult = (0, $c88854de77322012$export$8fdcabde73f49165).all(...connectResults);
            if (allResult.err) throw allResult.val;
            return allResult.unwrap();
        },
        async disconnect (type, namespaces) {
            const wallet = getHub().get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first then call 'disconnect'.`);
            wallet.getAll().forEach((namespace)=>{
                const namespaceShouldBeDisconnected = !namespaces || namespaces.includes(namespace.namespaceId);
                const namespaceIsConnected = namespace.state()[0]().connected;
                if (namespaceShouldBeDisconnected && namespaceIsConnected) return namespace.disconnect();
            });
            if (params.autoConnect) {
                if (namespaces) lastConnectedWalletsFromStorage.removeNamespacesFromWallet(type, namespaces);
                else lastConnectedWalletsFromStorage.removeWallets([
                    type
                ]);
            }
        },
        async disconnectAll () {
            const disconnectPromises = Array.from(getHub().getAll().values()).map(async (provider)=>this.disconnect(provider.id));
            return await Promise.allSettled(disconnectPromises);
        },
        async getSigners (type) {
            const wallet = getHub().get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const info = wallet.info();
            if (!info) throw new Error('Your provider should have required `info`.');
            const providerProperties = info.metadata.properties;
            const signerProperty = providerProperties?.find((property)=>property.name === 'signers');
            if (!signerProperty) throw new Error('Your provider should contain signers property.');
            return signerProperty.value.getSigners();
        },
        getWalletInfo (type) {
            const wallet = getHub().get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const info = wallet.info();
            if (!info) throw new Error('Your provider should have required `info`.');
            const installLink = {
                DEFAULT: ''
            };
            const { metadata: metadata } = info;
            const { extensions: extensions } = metadata;
            // `extensions` in legacy format was uppercase and also `DEFAULT` was used instead of `homepage`
            Object.keys(extensions).forEach((k)=>{
                const key = k;
                if (key === 'homepage') installLink.DEFAULT = extensions[key] || '';
                const allowedKeys = [
                    'firefox',
                    'chrome',
                    'brave',
                    'edge'
                ];
                if (allowedKeys.includes(key)) {
                    const upperCasedKey = key.toUpperCase();
                    installLink[upperCasedKey] = extensions[key] || '';
                }
            });
            const providerProperties = metadata.properties;
            const namespacesProperty = providerProperties?.find((property)=>property.name === 'namespaces');
            const derivationPathProperty = providerProperties?.find((property)=>property.name === 'derivationPath');
            const detailsProperty = providerProperties?.find((property)=>property.name === 'details');
            return {
                name: metadata.name,
                img: metadata.icon,
                installLink: installLink,
                // We don't have this values anymore, fill them with some values that communicate this.
                color: 'red',
                supportedChains: (0, $acada4b00987355d$export$d4b36a195a1b02e)(wallet, dataRef.current.allBlockChains),
                isContractWallet: detailsProperty?.value?.isContractWallet,
                mobileWallet: detailsProperty?.value?.mobileWallet,
                // if set to false here, it will not show the wallet in mobile in anyways. to be compatible with old behavior, undefined is more appropirate.
                showOnMobile: detailsProperty?.value?.showOnMobile,
                needsNamespace: namespacesProperty?.value,
                needsDerivationPath: derivationPathProperty?.value,
                isHub: true,
                properties: metadata.properties
            };
        },
        providers () {
            throw new Error('This method is not available on hub providers.');
        },
        state (type) {
            const hubState = getHub().state();
            const wallet = getHub().get(type);
            const walletState = hubState[type];
            if (!walletState || !wallet) throw new Error(`It seems your requested provider doesn't exist in hub. Provider Id: ${type}`);
            const accounts = walletState.namespaces.filter((namespace)=>namespace.connected).flatMap((namespace)=>namespace.accounts?.map((accounts)=>(0, $20c756994ff5e19c$export$96ee53d48509b544)(accounts, params.allBlockChains || []))).filter((account)=>!!account);
            const namespacesState = new Map(Array.from(wallet.getAll(), ([_, value])=>[
                    value.namespaceId,
                    value.state()[0]()
                ]));
            const coreState = {
                connected: walletState.connected,
                connecting: walletState.connecting,
                installed: walletState.installed,
                reachable: true,
                accounts: accounts,
                network: null,
                namespaces: namespacesState
            };
            return coreState;
        },
        async suggestAndConnect (type, namespace) {
            const provider = getHub().get(type);
            if (!provider) throw new Error(`You should add ${type} to provider first then call 'suggestAndConnect'.`);
            const proxiedNamespace = provider.findByNamespace(namespace.namespace);
            if (!proxiedNamespace) throw new Error(`We couldn't find any matched namespace on your request provider. (requested namespace: ${namespace.namespace})`);
            if (!('suggest' in proxiedNamespace)) throw new Error('Suggest is not implemented on the provider');
            if (!namespace.network) throw new Error('You should pass network to the suggest and connect');
            if ((0, $acada4b00987355d$export$7c14e8873a10c013)(proxiedNamespace)) {
                const suggestedChainMeta = (0, $hE77Y.cosmosBlockchains)(params.allBlockChains || [])?.filter((chain)=>chain.info && chain.info.experimental).find((chain)=>chain.name === namespace.network);
                if (!suggestedChainMeta) throw new Error(`We couldn't find the suggested chain (${namespace.network}) in our metadata.`);
                const { assetList: assetList, chain: chain } = (0, $cd6583130e7d9586$export$4bdf286a2e1762bc)(suggestedChainMeta);
                await proxiedNamespace.suggest(chain, assetList);
                const [connectResult] = await this.connect(type, [
                    namespace
                ]);
                return connectResult;
            }
            throw new Error(`Suggest has not been implemented for given chain: ${namespace.network}`);
        },
        hubProvider () {
            throw new Error('Unreachable code. the method has been implemented in main adapter instance.');
        }
    };
    return api;
}





/*
 * We have two separate interface for our providers: legacy and hub.
 * This hook sits between this two interface by keeping old interface as main API and try to add Hub providers by using an adapter.
 * For gradual migrating and backward compatibility, we are supporting hub by an adapter besides of the old one.
 */ function $08c46cddf65fcad3$export$e4c19534640d7866(props) {
    const { providers: providers, ...restProps } = props;
    const [legacyProviders, hubProviders] = (0, $acada4b00987355d$export$f8d285a8297f4aea)(providers);
    const legacyApi = (0, $145393fac953fa93$export$fefdcf5a1fbabdc6)({
        ...restProps,
        providers: legacyProviders
    });
    const hubApi = (0, $d1be72ea709f82ef$export$985b5837ed664745)({
        ...restProps,
        providers: hubProviders,
        allVersionedProviders: providers
    });
    const api = {
        canSwitchNetworkTo (type, network, namespace) {
            if ((0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type)) return hubApi.canSwitchNetworkTo(type, network, namespace);
            return legacyApi.canSwitchNetworkTo(type, network);
        },
        async connect (type, namespaces) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return await hubApi.connect(type, namespaces);
            return await legacyApi.connect(type, namespaces);
        },
        async disconnect (type, namespaces) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return await hubApi.disconnect(type, namespaces);
            return await legacyApi.disconnect(type);
        },
        async disconnectAll () {
            return await Promise.allSettled([
                hubApi.disconnectAll(),
                legacyApi.disconnectAll()
            ]);
        },
        async getSigners (type) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return hubApi.getSigners(type);
            return legacyApi.getSigners(type);
        },
        getWalletInfo (type) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return hubApi.getWalletInfo(type);
            return legacyApi.getWalletInfo(type);
        },
        // This method only returns the legacy providers.
        providers () {
            return legacyApi.providers();
        },
        state (type) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return hubApi.state(type);
            return legacyApi.state(type);
        },
        async suggestAndConnect (type, network) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return hubApi.suggestAndConnect(type, network);
            return await legacyApi.suggestAndConnect(type, network);
        },
        hubProvider (type) {
            const hubProvider = (0, $acada4b00987355d$export$fcb191413cf8d878)(hubProviders, type);
            if (hubProvider) return hubProvider;
            throw new Error(`You're trying to access ${type} provider which is not found in hub providers. you may try to access a legacy provider or it's not been registered yet.`);
        }
    };
    return api;
}


function $6713dd8e2740824f$var$Provider(props) {
    const api = (0, $08c46cddf65fcad3$export$e4c19534640d7866)(props);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c4572a2d5cf8409d$export$19648c908dc8d0bf).Provider, {
        value: api,
        children: props.children
    });
}
var $6713dd8e2740824f$export$2e2bcd8739ae039 = $6713dd8e2740824f$var$Provider;




var $9HEDW = parcelRequire("9HEDW");




var $9HEDW = parcelRequire("9HEDW");
var $229428e7240420de$exports = {};
"use strict";

(function() {
    var buf, bufIdx = 0, hexBytes = [], i;
    // Pre-calculate toString(16) for speed
    for(i = 0; i < 256; i++)hexBytes[i] = (i + 0x100).toString(16).substr(1);
    // Buffer random numbers for speed
    // Reduce memory usage by decreasing this number (min 16)
    // or improve speed by increasing this number (try 16384)
    uuid.BUFFER_SIZE = 4096;
    // Binary uuids
    uuid.bin = uuidBin;
    // Clear buffer
    uuid.clearBuffer = function() {
        buf = null;
        bufIdx = 0;
    };
    // Test for uuid
    uuid.test = function(uuid) {
        if (typeof uuid === 'string') return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
        return false;
    };
    // Node & Browser support
    var crypt0;
    if (typeof crypto !== 'undefined') crypt0 = crypto;
    else if (typeof window !== 'undefined' && typeof window.msCrypto !== 'undefined') crypt0 = window.msCrypto; // IE11
    crypt0 = crypt0 || (parcelRequire("5Io6y"));
    $229428e7240420de$exports = uuid;
    // Use best available PRNG
    // Also expose this so you can override it.
    uuid.randomBytes = function() {
        if (crypt0) {
            if (crypt0.randomBytes) return crypt0.randomBytes;
            if (crypt0.getRandomValues) {
                if (typeof Uint8Array.prototype.slice !== 'function') return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return Array.from(bytes);
                };
                return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return bytes;
                };
            }
        }
        return function(n) {
            var i, r = [];
            for(i = 0; i < n; i++)r.push(Math.floor(Math.random() * 256));
            return r;
        };
    }();
    // Buffer some random bytes for speed
    function randomBytesBuffered(n) {
        if (!buf || bufIdx + n > uuid.BUFFER_SIZE) {
            bufIdx = 0;
            buf = uuid.randomBytes(uuid.BUFFER_SIZE);
        }
        return buf.slice(bufIdx, bufIdx += n);
    }
    // uuid.bin
    function uuidBin() {
        var b = randomBytesBuffered(16);
        b[6] = b[6] & 0x0f | 0x40;
        b[8] = b[8] & 0x3f | 0x80;
        return b;
    }
    // String UUIDv4 (Random)
    function uuid() {
        var b = uuidBin();
        return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + '-' + hexBytes[b[4]] + hexBytes[b[5]] + '-' + hexBytes[b[6]] + hexBytes[b[7]] + '-' + hexBytes[b[8]] + hexBytes[b[9]] + '-' + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
    }
})();


'use strict';
function $03f71d95c2566149$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $12414dea316661ed$var$toString } = Object.prototype;
const { getPrototypeOf: $12414dea316661ed$var$getPrototypeOf } = Object;
const $12414dea316661ed$var$kindOf = ((cache)=>(thing)=>{
        const str = $12414dea316661ed$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $12414dea316661ed$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$12414dea316661ed$var$kindOf(thing) === type;
};
const $12414dea316661ed$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $12414dea316661ed$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $12414dea316661ed$var$isUndefined = $12414dea316661ed$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $12414dea316661ed$var$isBuffer(val) {
    return val !== null && !$12414dea316661ed$var$isUndefined(val) && val.constructor !== null && !$12414dea316661ed$var$isUndefined(val.constructor) && $12414dea316661ed$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $12414dea316661ed$var$isArrayBuffer = $12414dea316661ed$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $12414dea316661ed$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $12414dea316661ed$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $12414dea316661ed$var$isString = $12414dea316661ed$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $12414dea316661ed$var$isFunction = $12414dea316661ed$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $12414dea316661ed$var$isNumber = $12414dea316661ed$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $12414dea316661ed$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $12414dea316661ed$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $12414dea316661ed$var$isPlainObject = (val)=>{
    if ($12414dea316661ed$var$kindOf(val) !== 'object') return false;
    const prototype = $12414dea316661ed$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $12414dea316661ed$var$isDate = $12414dea316661ed$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $12414dea316661ed$var$isFile = $12414dea316661ed$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $12414dea316661ed$var$isBlob = $12414dea316661ed$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $12414dea316661ed$var$isFileList = $12414dea316661ed$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $12414dea316661ed$var$isStream = (val)=>$12414dea316661ed$var$isObject(val) && $12414dea316661ed$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $12414dea316661ed$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $12414dea316661ed$var$isFunction(thing.append) && ((kind = $12414dea316661ed$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $12414dea316661ed$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $12414dea316661ed$var$isURLSearchParams = $12414dea316661ed$var$kindOfTest('URLSearchParams');
const [$12414dea316661ed$var$isReadableStream, $12414dea316661ed$var$isRequest, $12414dea316661ed$var$isResponse, $12414dea316661ed$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($12414dea316661ed$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $12414dea316661ed$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $12414dea316661ed$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($12414dea316661ed$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $12414dea316661ed$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $12414dea316661ed$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $12414dea316661ed$var$isContextDefined = (context)=>!$12414dea316661ed$var$isUndefined(context) && context !== $12414dea316661ed$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $12414dea316661ed$var$merge() {
    const { caseless: caseless } = $12414dea316661ed$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $12414dea316661ed$var$findKey(result, key) || key;
        if ($12414dea316661ed$var$isPlainObject(result[targetKey]) && $12414dea316661ed$var$isPlainObject(val)) result[targetKey] = $12414dea316661ed$var$merge(result[targetKey], val);
        else if ($12414dea316661ed$var$isPlainObject(val)) result[targetKey] = $12414dea316661ed$var$merge({}, val);
        else if ($12414dea316661ed$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $12414dea316661ed$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $12414dea316661ed$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $12414dea316661ed$var$forEach(b, (val, key)=>{
        if (thisArg && $12414dea316661ed$var$isFunction(val)) a[key] = (0, $03f71d95c2566149$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $12414dea316661ed$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $12414dea316661ed$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $12414dea316661ed$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $12414dea316661ed$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $12414dea316661ed$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $12414dea316661ed$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($12414dea316661ed$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$12414dea316661ed$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $12414dea316661ed$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $12414dea316661ed$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $12414dea316661ed$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $12414dea316661ed$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $12414dea316661ed$var$isHTMLForm = $12414dea316661ed$var$kindOfTest('HTMLFormElement');
const $12414dea316661ed$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $12414dea316661ed$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $12414dea316661ed$var$isRegExp = $12414dea316661ed$var$kindOfTest('RegExp');
const $12414dea316661ed$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $12414dea316661ed$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $12414dea316661ed$var$freezeMethods = (obj)=>{
    $12414dea316661ed$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($12414dea316661ed$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$12414dea316661ed$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $12414dea316661ed$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $12414dea316661ed$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $12414dea316661ed$var$noop = ()=>{};
const $12414dea316661ed$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $12414dea316661ed$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $12414dea316661ed$var$DIGIT = '0123456789';
const $12414dea316661ed$var$ALPHABET = {
    DIGIT: $12414dea316661ed$var$DIGIT,
    ALPHA: $12414dea316661ed$var$ALPHA,
    ALPHA_DIGIT: $12414dea316661ed$var$ALPHA + $12414dea316661ed$var$ALPHA.toUpperCase() + $12414dea316661ed$var$DIGIT
};
const $12414dea316661ed$var$generateString = (size = 16, alphabet = $12414dea316661ed$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $12414dea316661ed$var$isSpecCompliantForm(thing) {
    return !!(thing && $12414dea316661ed$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $12414dea316661ed$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($12414dea316661ed$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $12414dea316661ed$var$isArray(source) ? [] : {};
                $12414dea316661ed$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$12414dea316661ed$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $12414dea316661ed$var$isAsyncFn = $12414dea316661ed$var$kindOfTest('AsyncFunction');
const $12414dea316661ed$var$isThenable = (thing)=>thing && ($12414dea316661ed$var$isObject(thing) || $12414dea316661ed$var$isFunction(thing)) && $12414dea316661ed$var$isFunction(thing.then) && $12414dea316661ed$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $12414dea316661ed$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $12414dea316661ed$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $12414dea316661ed$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $12414dea316661ed$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $12414dea316661ed$var$isFunction($12414dea316661ed$var$_global.postMessage));
const $12414dea316661ed$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($12414dea316661ed$var$_global) : $12414dea316661ed$var$_setImmediate;
var // *********************
$12414dea316661ed$export$2e2bcd8739ae039 = {
    isArray: $12414dea316661ed$var$isArray,
    isArrayBuffer: $12414dea316661ed$var$isArrayBuffer,
    isBuffer: $12414dea316661ed$var$isBuffer,
    isFormData: $12414dea316661ed$var$isFormData,
    isArrayBufferView: $12414dea316661ed$var$isArrayBufferView,
    isString: $12414dea316661ed$var$isString,
    isNumber: $12414dea316661ed$var$isNumber,
    isBoolean: $12414dea316661ed$var$isBoolean,
    isObject: $12414dea316661ed$var$isObject,
    isPlainObject: $12414dea316661ed$var$isPlainObject,
    isReadableStream: $12414dea316661ed$var$isReadableStream,
    isRequest: $12414dea316661ed$var$isRequest,
    isResponse: $12414dea316661ed$var$isResponse,
    isHeaders: $12414dea316661ed$var$isHeaders,
    isUndefined: $12414dea316661ed$var$isUndefined,
    isDate: $12414dea316661ed$var$isDate,
    isFile: $12414dea316661ed$var$isFile,
    isBlob: $12414dea316661ed$var$isBlob,
    isRegExp: $12414dea316661ed$var$isRegExp,
    isFunction: $12414dea316661ed$var$isFunction,
    isStream: $12414dea316661ed$var$isStream,
    isURLSearchParams: $12414dea316661ed$var$isURLSearchParams,
    isTypedArray: $12414dea316661ed$var$isTypedArray,
    isFileList: $12414dea316661ed$var$isFileList,
    forEach: $12414dea316661ed$var$forEach,
    merge: $12414dea316661ed$var$merge,
    extend: $12414dea316661ed$var$extend,
    trim: $12414dea316661ed$var$trim,
    stripBOM: $12414dea316661ed$var$stripBOM,
    inherits: $12414dea316661ed$var$inherits,
    toFlatObject: $12414dea316661ed$var$toFlatObject,
    kindOf: $12414dea316661ed$var$kindOf,
    kindOfTest: $12414dea316661ed$var$kindOfTest,
    endsWith: $12414dea316661ed$var$endsWith,
    toArray: $12414dea316661ed$var$toArray,
    forEachEntry: $12414dea316661ed$var$forEachEntry,
    matchAll: $12414dea316661ed$var$matchAll,
    isHTMLForm: $12414dea316661ed$var$isHTMLForm,
    hasOwnProperty: $12414dea316661ed$var$hasOwnProperty,
    hasOwnProp: $12414dea316661ed$var$hasOwnProperty,
    reduceDescriptors: $12414dea316661ed$var$reduceDescriptors,
    freezeMethods: $12414dea316661ed$var$freezeMethods,
    toObjectSet: $12414dea316661ed$var$toObjectSet,
    toCamelCase: $12414dea316661ed$var$toCamelCase,
    noop: $12414dea316661ed$var$noop,
    toFiniteNumber: $12414dea316661ed$var$toFiniteNumber,
    findKey: $12414dea316661ed$var$findKey,
    global: $12414dea316661ed$var$_global,
    isContextDefined: $12414dea316661ed$var$isContextDefined,
    ALPHABET: $12414dea316661ed$var$ALPHABET,
    generateString: $12414dea316661ed$var$generateString,
    isSpecCompliantForm: $12414dea316661ed$var$isSpecCompliantForm,
    toJSONObject: $12414dea316661ed$var$toJSONObject,
    isAsyncFn: $12414dea316661ed$var$isAsyncFn,
    isThenable: $12414dea316661ed$var$isThenable,
    setImmediate: $12414dea316661ed$var$_setImmediate,
    asap: $12414dea316661ed$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $567737c4d03f138c$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $12414dea316661ed$export$2e2bcd8739ae039).inherits($567737c4d03f138c$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $12414dea316661ed$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $567737c4d03f138c$var$prototype = $567737c4d03f138c$var$AxiosError.prototype;
const $567737c4d03f138c$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $567737c4d03f138c$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($567737c4d03f138c$var$AxiosError, $567737c4d03f138c$var$descriptors);
Object.defineProperty($567737c4d03f138c$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$567737c4d03f138c$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($567737c4d03f138c$var$prototype);
    (0, $12414dea316661ed$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $567737c4d03f138c$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $567737c4d03f138c$export$2e2bcd8739ae039 = $567737c4d03f138c$var$AxiosError;


// eslint-disable-next-line strict
var $d9106daa272ec211$export$2e2bcd8739ae039 = null;



var $ihoyg = parcelRequire("ihoyg");
var $8cb9b335b6ebd1ce$require$Buffer = $ihoyg.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $8cb9b335b6ebd1ce$var$isVisitable(thing) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $8cb9b335b6ebd1ce$var$removeBrackets(key) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $8cb9b335b6ebd1ce$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $8cb9b335b6ebd1ce$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $8cb9b335b6ebd1ce$var$isFlatArray(arr) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(arr) && !arr.some($8cb9b335b6ebd1ce$var$isVisitable);
}
const $8cb9b335b6ebd1ce$var$predicates = (0, $12414dea316661ed$export$2e2bcd8739ae039).toFlatObject((0, $12414dea316661ed$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $8cb9b335b6ebd1ce$var$toFormData(obj, formData, options) {
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $d9106daa272ec211$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $12414dea316661ed$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $12414dea316661ed$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $12414dea316661ed$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $8cb9b335b6ebd1ce$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(value) && $8cb9b335b6ebd1ce$var$isFlatArray(value) || ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFileList(value) || (0, $12414dea316661ed$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $12414dea316661ed$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $8cb9b335b6ebd1ce$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $8cb9b335b6ebd1ce$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($8cb9b335b6ebd1ce$var$isVisitable(value)) return true;
        formData.append($8cb9b335b6ebd1ce$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($8cb9b335b6ebd1ce$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $8cb9b335b6ebd1ce$var$isVisitable
    });
    function build(value, path) {
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $8cb9b335b6ebd1ce$export$2e2bcd8739ae039 = $8cb9b335b6ebd1ce$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $bf17c3c7584515aa$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $bf17c3c7584515aa$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039)(params, this, options);
}
const $bf17c3c7584515aa$var$prototype = $bf17c3c7584515aa$var$AxiosURLSearchParams.prototype;
$bf17c3c7584515aa$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$bf17c3c7584515aa$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $bf17c3c7584515aa$var$encode);
    } : $bf17c3c7584515aa$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $bf17c3c7584515aa$export$2e2bcd8739ae039 = $bf17c3c7584515aa$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $14a382a9b03b915a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $14a382a9b03b915a$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $14a382a9b03b915a$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $12414dea316661ed$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $bf17c3c7584515aa$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $62a472615ed90c4c$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $62a472615ed90c4c$export$2e2bcd8739ae039 = $62a472615ed90c4c$var$InterceptorManager;





'use strict';
var $838af30675204450$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $e7a2c0c7e36d4162$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $bf17c3c7584515aa$export$2e2bcd8739ae039);


'use strict';
var $f9bea8cd817aaf71$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $84da518ec5fec1b4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $d7c59004ec6de3bd$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $e7a2c0c7e36d4162$export$2e2bcd8739ae039,
        FormData: $f9bea8cd817aaf71$export$2e2bcd8739ae039,
        Blob: $84da518ec5fec1b4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $42cd85f968592eea$exports = {};

$parcel$export($42cd85f968592eea$exports, "hasBrowserEnv", function () { return $42cd85f968592eea$export$c4996c4b7b93b0bf; });
$parcel$export($42cd85f968592eea$exports, "navigator", function () { return $42cd85f968592eea$export$ec7c8efa7f5790ae; });
$parcel$export($42cd85f968592eea$exports, "hasStandardBrowserEnv", function () { return $42cd85f968592eea$export$c0bcc9250309d66; });
$parcel$export($42cd85f968592eea$exports, "hasStandardBrowserWebWorkerEnv", function () { return $42cd85f968592eea$export$c81692cf5af97dac; });
$parcel$export($42cd85f968592eea$exports, "origin", function () { return $42cd85f968592eea$export$f710a83a91838a36; });
const $42cd85f968592eea$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $42cd85f968592eea$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $42cd85f968592eea$export$c0bcc9250309d66 = $42cd85f968592eea$export$c4996c4b7b93b0bf && (!$42cd85f968592eea$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($42cd85f968592eea$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $42cd85f968592eea$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $42cd85f968592eea$export$f710a83a91838a36 = $42cd85f968592eea$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bdb8d664828df03f$export$2e2bcd8739ae039 = {
    ...$42cd85f968592eea$exports,
    ...(0, $d7c59004ec6de3bd$export$2e2bcd8739ae039)
};


'use strict';
function $0f3ff5b6941462d8$export$2e2bcd8739ae039(data, options) {
    return (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039)(data, new (0, $bdb8d664828df03f$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bdb8d664828df03f$export$2e2bcd8739ae039).isNode && (0, $12414dea316661ed$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $943ed241d5bda4c4$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $943ed241d5bda4c4$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $943ed241d5bda4c4$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $943ed241d5bda4c4$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(formData) && (0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($943ed241d5bda4c4$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $943ed241d5bda4c4$export$2e2bcd8739ae039 = $943ed241d5bda4c4$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $245713dbdddae8bf$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $12414dea316661ed$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $245713dbdddae8bf$var$defaults = {
    transitional: (0, $838af30675204450$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $12414dea316661ed$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $943ed241d5bda4c4$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isBuffer(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isStream(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isFile(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isBlob(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $0f3ff5b6941462d8$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $12414dea316661ed$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $245713dbdddae8bf$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $245713dbdddae8bf$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isResponse(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $567737c4d03f138c$export$2e2bcd8739ae039).from(e, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bdb8d664828df03f$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bdb8d664828df03f$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $245713dbdddae8bf$var$defaults.headers[method] = {};
});
var $245713dbdddae8bf$export$2e2bcd8739ae039 = $245713dbdddae8bf$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cbdc254b5cb8d725$var$ignoreDuplicateOf = (0, $12414dea316661ed$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cbdc254b5cb8d725$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cbdc254b5cb8d725$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $55a0f0438ae3fbda$var$$internals = Symbol('internals');
function $55a0f0438ae3fbda$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $55a0f0438ae3fbda$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(value) ? value.map($55a0f0438ae3fbda$var$normalizeValue) : String(value);
}
function $55a0f0438ae3fbda$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $55a0f0438ae3fbda$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $55a0f0438ae3fbda$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $55a0f0438ae3fbda$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $55a0f0438ae3fbda$var$buildAccessors(obj, header) {
    const accessorName = (0, $12414dea316661ed$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $55a0f0438ae3fbda$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $55a0f0438ae3fbda$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $55a0f0438ae3fbda$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$55a0f0438ae3fbda$var$isValidHeaderName(header)) setHeaders((0, $cbdc254b5cb8d725$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $55a0f0438ae3fbda$var$normalizeHeader(header);
        if (header) {
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $55a0f0438ae3fbda$var$parseTokens(value);
                if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $55a0f0438ae3fbda$var$normalizeHeader(header);
        if (header) {
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $55a0f0438ae3fbda$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $55a0f0438ae3fbda$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $55a0f0438ae3fbda$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $55a0f0438ae3fbda$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $55a0f0438ae3fbda$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $55a0f0438ae3fbda$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $55a0f0438ae3fbda$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$55a0f0438ae3fbda$var$$internals] = this[$55a0f0438ae3fbda$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $55a0f0438ae3fbda$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $55a0f0438ae3fbda$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$55a0f0438ae3fbda$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $12414dea316661ed$export$2e2bcd8739ae039).reduceDescriptors($55a0f0438ae3fbda$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $12414dea316661ed$export$2e2bcd8739ae039).freezeMethods($55a0f0438ae3fbda$var$AxiosHeaders);
var $55a0f0438ae3fbda$export$2e2bcd8739ae039 = $55a0f0438ae3fbda$var$AxiosHeaders;


'use strict';
function $f2060579565d1b89$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $245713dbdddae8bf$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $9e8894b20ba9a2ea$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $a35edcbde59a6f97$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $567737c4d03f138c$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $12414dea316661ed$export$2e2bcd8739ae039).inherits($a35edcbde59a6f97$var$CanceledError, (0, $567737c4d03f138c$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $a35edcbde59a6f97$export$2e2bcd8739ae039 = $a35edcbde59a6f97$var$CanceledError;







'use strict';
function $48968fb9e6a3186d$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $c84582474905e9a9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $35c56f6b763b9fdb$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $35c56f6b763b9fdb$export$2e2bcd8739ae039 = $35c56f6b763b9fdb$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2a5ffdb86455c57d$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2a5ffdb86455c57d$export$2e2bcd8739ae039 = $2a5ffdb86455c57d$var$throttle;



const $c6d121c34aecba06$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $35c56f6b763b9fdb$export$2e2bcd8739ae039)(50, 250);
    return (0, $2a5ffdb86455c57d$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $c6d121c34aecba06$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $c6d121c34aecba06$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $12414dea316661ed$export$2e2bcd8739ae039).asap(()=>fn(...args));






'use strict';
var $35202b92e9fe5a36$export$2e2bcd8739ae039 = (0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $bdb8d664828df03f$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bdb8d664828df03f$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $44530b996c306f8b$export$2e2bcd8739ae039 = (0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $ada52957f7ffd5d7$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $a1270be2b5354972$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $757f974e62f878f1$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ada52957f7ffd5d7$export$2e2bcd8739ae039)(requestedURL)) return (0, $a1270be2b5354972$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $e16daabe21b7af7d$var$headersToObject = (thing)=>thing instanceof (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $e16daabe21b7af7d$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(target) && (0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $12414dea316661ed$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $12414dea316661ed$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($e16daabe21b7af7d$var$headersToObject(a), $e16daabe21b7af7d$var$headersToObject(b), true)
    };
    (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $c38178c4a782dc1b$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $14a382a9b03b915a$export$2e2bcd8739ae039)((0, $757f974e62f878f1$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $35202b92e9fe5a36$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $44530b996c306f8b$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $a67023a14ed5a5fb$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $a67023a14ed5a5fb$export$2e2bcd8739ae039 = $a67023a14ed5a5fb$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $c38178c4a782dc1b$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $48968fb9e6a3186d$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Request aborted', (0, $567737c4d03f138c$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Network Error', (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $838af30675204450$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $567737c4d03f138c$export$2e2bcd8739ae039).ETIMEDOUT : (0, $567737c4d03f138c$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $c6d121c34aecba06$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $c6d121c34aecba06$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $c84582474905e9a9$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bdb8d664828df03f$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $49caa06b0edf594e$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $567737c4d03f138c$export$2e2bcd8739ae039) ? err : new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $12414dea316661ed$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $49caa06b0edf594e$export$2e2bcd8739ae039 = $49caa06b0edf594e$var$composeSignals;


const $d6e962a9ab43279c$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $d6e962a9ab43279c$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $d6e962a9ab43279c$var$readStream(iterable))yield* $d6e962a9ab43279c$export$71b051935044bd5d(chunk, chunkSize);
};
const $d6e962a9ab43279c$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $d6e962a9ab43279c$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $d6e962a9ab43279c$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $ffa9b458491640a2$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $ffa9b458491640a2$var$isReadableStreamSupported = $ffa9b458491640a2$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $ffa9b458491640a2$var$encodeText = $ffa9b458491640a2$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $ffa9b458491640a2$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $ffa9b458491640a2$var$supportsRequestStream = $ffa9b458491640a2$var$isReadableStreamSupported && $ffa9b458491640a2$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bdb8d664828df03f$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $ffa9b458491640a2$var$DEFAULT_CHUNK_SIZE = 65536;
const $ffa9b458491640a2$var$supportsResponseStream = $ffa9b458491640a2$var$isReadableStreamSupported && $ffa9b458491640a2$var$test(()=>(0, $12414dea316661ed$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $ffa9b458491640a2$var$resolvers = {
    stream: $ffa9b458491640a2$var$supportsResponseStream && ((res)=>res.body)
};
$ffa9b458491640a2$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$ffa9b458491640a2$var$resolvers[type] && ($ffa9b458491640a2$var$resolvers[type] = (0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $ffa9b458491640a2$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bdb8d664828df03f$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(body)) return (await $ffa9b458491640a2$var$encodeText(body)).byteLength;
};
const $ffa9b458491640a2$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $12414dea316661ed$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $ffa9b458491640a2$var$getBodyLength(body) : length;
};
var $ffa9b458491640a2$export$2e2bcd8739ae039 = $ffa9b458491640a2$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $c38178c4a782dc1b$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $49caa06b0edf594e$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $ffa9b458491640a2$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $ffa9b458491640a2$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $c6d121c34aecba06$export$d9fadd12586c18d6)(requestContentLength, (0, $c6d121c34aecba06$export$c1b28109d46c3592)((0, $c6d121c34aecba06$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $d6e962a9ab43279c$export$b0119225647bd83)(_request.body, $ffa9b458491640a2$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $ffa9b458491640a2$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($ffa9b458491640a2$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $12414dea316661ed$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $c6d121c34aecba06$export$d9fadd12586c18d6)(responseContentLength, (0, $c6d121c34aecba06$export$c1b28109d46c3592)((0, $c6d121c34aecba06$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $d6e962a9ab43279c$export$b0119225647bd83)(response.body, $ffa9b458491640a2$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $ffa9b458491640a2$var$resolvers[(0, $12414dea316661ed$export$2e2bcd8739ae039).findKey($ffa9b458491640a2$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $48968fb9e6a3186d$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Network Error', (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $567737c4d03f138c$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $a71cc9182308b5c7$var$knownAdapters = {
    http: (0, $d9106daa272ec211$export$2e2bcd8739ae039),
    xhr: (0, $a67023a14ed5a5fb$export$2e2bcd8739ae039),
    fetch: (0, $ffa9b458491640a2$export$2e2bcd8739ae039)
};
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach($a71cc9182308b5c7$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $a71cc9182308b5c7$var$renderReason = (reason)=>`- ${reason}`;
const $a71cc9182308b5c7$var$isResolvedHandle = (adapter)=>(0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $a71cc9182308b5c7$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$a71cc9182308b5c7$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $a71cc9182308b5c7$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($a71cc9182308b5c7$var$renderReason).join('\n') : ' ' + $a71cc9182308b5c7$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $a71cc9182308b5c7$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $186cc4b671ca12e1$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(null, config);
}
function $186cc4b671ca12e1$export$2e2bcd8739ae039(config) {
    $186cc4b671ca12e1$var$throwIfCancellationRequested(config);
    config.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $f2060579565d1b89$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $a71cc9182308b5c7$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $245713dbdddae8bf$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $186cc4b671ca12e1$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $f2060579565d1b89$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $9e8894b20ba9a2ea$export$2e2bcd8739ae039)(reason)) {
            $186cc4b671ca12e1$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $f2060579565d1b89$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $04a0d75cca4371a6$export$a4ad2735b021c132 = "1.7.7";



'use strict';
const $a79d9df5066fe49c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $a79d9df5066fe49c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $a79d9df5066fe49c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $a79d9df5066fe49c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $04a0d75cca4371a6$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$a79d9df5066fe49c$var$deprecatedWarnings[opt]) {
            $a79d9df5066fe49c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $a79d9df5066fe49c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('options must be an object', (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $a79d9df5066fe49c$export$2e2bcd8739ae039 = {
    assertOptions: $a79d9df5066fe49c$var$assertOptions,
    validators: $a79d9df5066fe49c$var$validators
};



'use strict';
const $2446ff993efa9fb1$var$validators = (0, $a79d9df5066fe49c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $2446ff993efa9fb1$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $62a472615ed90c4c$export$2e2bcd8739ae039)(),
            response: new (0, $62a472615ed90c4c$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $a79d9df5066fe49c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $2446ff993efa9fb1$var$validators.transitional($2446ff993efa9fb1$var$validators.boolean),
            forcedJSONParsing: $2446ff993efa9fb1$var$validators.transitional($2446ff993efa9fb1$var$validators.boolean),
            clarifyTimeoutError: $2446ff993efa9fb1$var$validators.transitional($2446ff993efa9fb1$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $a79d9df5066fe49c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $2446ff993efa9fb1$var$validators.function,
                serialize: $2446ff993efa9fb1$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $12414dea316661ed$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $186cc4b671ca12e1$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $186cc4b671ca12e1$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $757f974e62f878f1$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $14a382a9b03b915a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $2446ff993efa9fb1$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $2446ff993efa9fb1$var$Axios.prototype[method] = generateHTTPMethod();
    $2446ff993efa9fb1$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $2446ff993efa9fb1$export$2e2bcd8739ae039 = $2446ff993efa9fb1$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $96b4ca820e93479e$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $96b4ca820e93479e$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $96b4ca820e93479e$export$2e2bcd8739ae039 = $96b4ca820e93479e$var$CancelToken;






'use strict';
function $4b78113684b86341$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $50446323438a098c$export$2e2bcd8739ae039(payload) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $736459cc0ebf6165$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($736459cc0ebf6165$var$HttpStatusCode).forEach(([key, value])=>{
    $736459cc0ebf6165$var$HttpStatusCode[value] = key;
});
var $736459cc0ebf6165$export$2e2bcd8739ae039 = $736459cc0ebf6165$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $8f7d270ed9cb53d0$var$createInstance(defaultConfig) {
    const context = new (0, $2446ff993efa9fb1$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $03f71d95c2566149$export$2e2bcd8739ae039)((0, $2446ff993efa9fb1$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $12414dea316661ed$export$2e2bcd8739ae039).extend(instance, (0, $2446ff993efa9fb1$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $12414dea316661ed$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $8f7d270ed9cb53d0$var$createInstance((0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $8f7d270ed9cb53d0$var$axios = $8f7d270ed9cb53d0$var$createInstance((0, $245713dbdddae8bf$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$8f7d270ed9cb53d0$var$axios.Axios = (0, $2446ff993efa9fb1$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$8f7d270ed9cb53d0$var$axios.CanceledError = (0, $a35edcbde59a6f97$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.CancelToken = (0, $96b4ca820e93479e$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.isCancel = (0, $9e8894b20ba9a2ea$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.VERSION = (0, $04a0d75cca4371a6$export$a4ad2735b021c132);
$8f7d270ed9cb53d0$var$axios.toFormData = (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039);
// Expose AxiosError class
$8f7d270ed9cb53d0$var$axios.AxiosError = (0, $567737c4d03f138c$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$8f7d270ed9cb53d0$var$axios.Cancel = $8f7d270ed9cb53d0$var$axios.CanceledError;
// Expose all/spread
$8f7d270ed9cb53d0$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$8f7d270ed9cb53d0$var$axios.spread = (0, $4b78113684b86341$export$2e2bcd8739ae039);
// Expose isAxiosError
$8f7d270ed9cb53d0$var$axios.isAxiosError = (0, $50446323438a098c$export$2e2bcd8739ae039);
// Expose mergeConfig
$8f7d270ed9cb53d0$var$axios.mergeConfig = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.AxiosHeaders = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.formToJSON = (thing)=>(0, $943ed241d5bda4c4$export$2e2bcd8739ae039)((0, $12414dea316661ed$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$8f7d270ed9cb53d0$var$axios.getAdapter = (0, $a71cc9182308b5c7$export$2e2bcd8739ae039).getAdapter;
$8f7d270ed9cb53d0$var$axios.HttpStatusCode = (0, $736459cc0ebf6165$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.default = $8f7d270ed9cb53d0$var$axios;
var // this module should only have a default export
$8f7d270ed9cb53d0$export$2e2bcd8739ae039 = $8f7d270ed9cb53d0$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $3105efc40bde876b$export$1c00760e9e5a4e95, AxiosError: $3105efc40bde876b$export$c1fbed17c2f6a328, CanceledError: $3105efc40bde876b$export$1ab0c6b20d94fa14, isCancel: $3105efc40bde876b$export$3b22524397b493c6, CancelToken: $3105efc40bde876b$export$fd08e3cb425f0d61, VERSION: $3105efc40bde876b$export$a4ad2735b021c132, all: $3105efc40bde876b$export$84bf76cd7afc7469, Cancel: $3105efc40bde876b$export$848c9b7ead0df967, isAxiosError: $3105efc40bde876b$export$fbafdbe06a5b5a9a, spread: $3105efc40bde876b$export$3ae0fd4797ed47c8, toFormData: $3105efc40bde876b$export$10ae0d317ea97f8b, AxiosHeaders: $3105efc40bde876b$export$4e7d6ff0f3e6520, HttpStatusCode: $3105efc40bde876b$export$a972f69c851492b3, formToJSON: $3105efc40bde876b$export$86d7c59254d6a2c9, getAdapter: $3105efc40bde876b$export$17ddc20a97d669e2, mergeConfig: $3105efc40bde876b$export$7ec1ebcfa9d8bd6a } = (0, $8f7d270ed9cb53d0$export$2e2bcd8739ae039);


function $078a8abb74f92b71$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $078a8abb74f92b71$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $078a8abb74f92b71$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $078a8abb74f92b71$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $078a8abb74f92b71$var$_extends() {
    return $078a8abb74f92b71$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $078a8abb74f92b71$var$_extends.apply(null, arguments);
}
function $078a8abb74f92b71$var$_regeneratorRuntime() {
    $078a8abb74f92b71$var$_regeneratorRuntime = function() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
var $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8 = /*#__PURE__*/ function() {
    function RangoClient(apiKey, apiUrl) {
        this.apiUrl = apiUrl || 'https://api.rango.exchange';
        this.apiKey = apiKey;
        try {
            if (typeof window !== 'undefined') {
                var deviceId = localStorage.getItem('deviceId');
                if (deviceId) this.deviceId = deviceId;
                else {
                    var generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
                    localStorage.setItem('deviceId', generatedId);
                    this.deviceId = generatedId;
                }
            } else this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
        } catch (e) {
            this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
        }
        this.httpService = (0, $8f7d270ed9cb53d0$export$2e2bcd8739ae039).create({
            baseURL: this.apiUrl
        });
    }
    var _proto = RangoClient.prototype;
    _proto.getAllMetadata = /*#__PURE__*/ function() {
        var _getAllMetadata = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee(metaRequest, options) {
            var _metaRequest$blockcha, _metaRequest$swappers, _metaRequest$swappers2, _metaRequest$transact;
            var params, axiosResponse, reformatTokens, tokens, popularTokens;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        params = $078a8abb74f92b71$var$_extends({}, metaRequest, {
                            blockchains: metaRequest == null || (_metaRequest$blockcha = metaRequest.blockchains) == null ? void 0 : _metaRequest$blockcha.join(),
                            swappers: metaRequest == null || (_metaRequest$swappers = metaRequest.swappers) == null ? void 0 : _metaRequest$swappers.join(),
                            swappersGroups: metaRequest == null || (_metaRequest$swappers2 = metaRequest.swappersGroups) == null ? void 0 : _metaRequest$swappers2.join(),
                            transactionTypes: metaRequest == null || (_metaRequest$transact = metaRequest.transactionTypes) == null ? void 0 : _metaRequest$transact.join()
                        });
                        _context.next = 3;
                        return this.httpService.get("/meta/compact?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: params
                        }, options));
                    case 3:
                        axiosResponse = _context.sent;
                        reformatTokens = function reformatTokens(tokens) {
                            return tokens.map(function(tm) {
                                return {
                                    blockchain: tm.b,
                                    symbol: tm.s,
                                    image: tm.i,
                                    address: tm.a || null,
                                    usdPrice: tm.p || null,
                                    isSecondaryCoin: tm.is || false,
                                    coinSource: tm.c || null,
                                    coinSourceUrl: tm.cu || null,
                                    name: tm.n || null,
                                    decimals: tm.d,
                                    isPopular: tm.ip || false,
                                    supportedSwappers: tm.ss || []
                                };
                            });
                        };
                        tokens = reformatTokens(axiosResponse.data.tokens);
                        popularTokens = reformatTokens(axiosResponse.data.popularTokens);
                        return _context.abrupt("return", $078a8abb74f92b71$var$_extends({}, axiosResponse.data, {
                            tokens: tokens,
                            popularTokens: popularTokens
                        }));
                    case 8:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function getAllMetadata(_x, _x2) {
            return _getAllMetadata.apply(this, arguments);
        }
        return getAllMetadata;
    }();
    _proto.getBlockchains = /*#__PURE__*/ function() {
        var _getBlockchains = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee2(options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return this.httpService.get("/meta/blockchains?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context2.sent;
                        return _context2.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function getBlockchains(_x3) {
            return _getBlockchains.apply(this, arguments);
        }
        return getBlockchains;
    }();
    _proto.getSwappers = /*#__PURE__*/ function() {
        var _getSwappers = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee3(options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return this.httpService.get("/meta/swappers?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context3.sent;
                        return _context3.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function getSwappers(_x4) {
            return _getSwappers.apply(this, arguments);
        }
        return getSwappers;
    }();
    _proto.getCustomToken = /*#__PURE__*/ function() {
        var _getCustomToken = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee4(customTokenRequest, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return this.httpService.get("/meta/custom-token?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: customTokenRequest
                        }, options));
                    case 2:
                        axiosResponse = _context4.sent;
                        return _context4.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4, this);
        }));
        function getCustomToken(_x5, _x6) {
            return _getCustomToken.apply(this, arguments);
        }
        return getCustomToken;
    }();
    _proto.searchCustomTokens = /*#__PURE__*/ function() {
        var _searchCustomTokens = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee5(searchCustomTokensRequest, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return this.httpService.get("/meta/token/search?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: searchCustomTokensRequest
                        }, options));
                    case 2:
                        axiosResponse = _context5.sent;
                        return _context5.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5, this);
        }));
        function searchCustomTokens(_x7, _x8) {
            return _searchCustomTokens.apply(this, arguments);
        }
        return searchCustomTokens;
    }();
    _proto.getBestRoute = /*#__PURE__*/ function() {
        var _getBestRoute = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee6(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        _context6.next = 2;
                        return this.httpService.post("/routing/best?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                'X-Rango-Id': this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context6.sent;
                        return _context6.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, this);
        }));
        function getBestRoute(_x9, _x10) {
            return _getBestRoute.apply(this, arguments);
        }
        return getBestRoute;
    }();
    _proto.getAllRoutes = /*#__PURE__*/ function() {
        var _getAllRoutes = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee7(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return this.httpService.post("/routing/bests?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                'X-Rango-Id': this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context7.sent;
                        return _context7.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context7.stop();
                }
            }, _callee7, this);
        }));
        function getAllRoutes(_x11, _x12) {
            return _getAllRoutes.apply(this, arguments);
        }
        return getAllRoutes;
    }();
    _proto.confirmRoute = /*#__PURE__*/ function() {
        var _confirmRoute = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee8(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        _context8.next = 2;
                        return this.httpService.post("/routing/confirm?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                'X-Rango-Id': this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context8.sent;
                        return _context8.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context8.stop();
                }
            }, _callee8, this);
        }));
        function confirmRoute(_x13, _x14) {
            return _confirmRoute.apply(this, arguments);
        }
        return confirmRoute;
    }() // @deprecated use confirmRoute instead
    ;
    _proto.confirmRouteRequest = /*#__PURE__*/ function() {
        var _confirmRouteRequest = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee9(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee9$(_context9) {
                while(true)switch(_context9.prev = _context9.next){
                    case 0:
                        _context9.next = 2;
                        return this.httpService.post("/routing/confirm?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                'X-Rango-Id': this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context9.sent;
                        return _context9.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context9.stop();
                }
            }, _callee9, this);
        }));
        function confirmRouteRequest(_x15, _x16) {
            return _confirmRouteRequest.apply(this, arguments);
        }
        return confirmRouteRequest;
    }();
    _proto.checkApproval = /*#__PURE__*/ function() {
        var _checkApproval = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee10(requestId, txId, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee10$(_context10) {
                while(true)switch(_context10.prev = _context10.next){
                    case 0:
                        _context10.next = 2;
                        return this.httpService.get("/tx/" + requestId + "/check-approval?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: {
                                txId: txId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context10.sent;
                        return _context10.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context10.stop();
                }
            }, _callee10, this);
        }));
        function checkApproval(_x17, _x18, _x19) {
            return _checkApproval.apply(this, arguments);
        }
        return checkApproval;
    }();
    _proto.checkStatus = /*#__PURE__*/ function() {
        var _checkStatus = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee11(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee11$(_context11) {
                while(true)switch(_context11.prev = _context11.next){
                    case 0:
                        _context11.next = 2;
                        return this.httpService.post("/tx/check-status?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context11.sent;
                        return _context11.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context11.stop();
                }
            }, _callee11, this);
        }));
        function checkStatus(_x20, _x21) {
            return _checkStatus.apply(this, arguments);
        }
        return checkStatus;
    }();
    _proto.createTransaction = /*#__PURE__*/ function() {
        var _createTransaction = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee12(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee12$(_context12) {
                while(true)switch(_context12.prev = _context12.next){
                    case 0:
                        _context12.next = 2;
                        return this.httpService.post("/tx/create?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context12.sent;
                        return _context12.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context12.stop();
                }
            }, _callee12, this);
        }));
        function createTransaction(_x22, _x23) {
            return _createTransaction.apply(this, arguments);
        }
        return createTransaction;
    }();
    _proto.reportFailure = /*#__PURE__*/ function() {
        var _reportFailure = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee13(requestBody, options) {
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee13$(_context13) {
                while(true)switch(_context13.prev = _context13.next){
                    case 0:
                        _context13.next = 2;
                        return this.httpService.post("/tx/report-tx?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                    case "end":
                        return _context13.stop();
                }
            }, _callee13, this);
        }));
        function reportFailure(_x24, _x25) {
            return _reportFailure.apply(this, arguments);
        }
        return reportFailure;
    }();
    _proto.getWalletsDetails = /*#__PURE__*/ function() {
        var _getWalletsDetails = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee14(walletAddresses, options) {
            var walletAddressesQueryParams, i, walletAddress, axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee14$(_context14) {
                while(true)switch(_context14.prev = _context14.next){
                    case 0:
                        walletAddressesQueryParams = '';
                        for(i = 0; i < walletAddresses.length; i++){
                            walletAddress = walletAddresses[i];
                            walletAddressesQueryParams += "&address=" + walletAddress.blockchain + "." + walletAddress.address;
                        }
                        _context14.next = 4;
                        return this.httpService.get("/wallets/details?apiKey=" + this.apiKey + walletAddressesQueryParams, $078a8abb74f92b71$var$_extends({}, options));
                    case 4:
                        axiosResponse = _context14.sent;
                        return _context14.abrupt("return", axiosResponse.data);
                    case 6:
                    case "end":
                        return _context14.stop();
                }
            }, _callee14, this);
        }));
        function getWalletsDetails(_x26, _x27) {
            return _getWalletsDetails.apply(this, arguments);
        }
        return getWalletsDetails;
    }();
    _proto.getTokenBalance = /*#__PURE__*/ function() {
        var _getTokenBalance = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee15(tokenBalanceRequest, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee15$(_context15) {
                while(true)switch(_context15.prev = _context15.next){
                    case 0:
                        _context15.next = 2;
                        return this.httpService.get("/wallets/token-balance?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: tokenBalanceRequest
                        }, options));
                    case 2:
                        axiosResponse = _context15.sent;
                        return _context15.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context15.stop();
                }
            }, _callee15, this);
        }));
        function getTokenBalance(_x28, _x29) {
            return _getTokenBalance.apply(this, arguments);
        }
        return getTokenBalance;
    }();
    _proto.getMultipleTokenBalance = /*#__PURE__*/ function() {
        var _getMultipleTokenBalance = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee16(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee16$(_context16) {
                while(true)switch(_context16.prev = _context16.next){
                    case 0:
                        _context16.next = 2;
                        return this.httpService.post("/wallets/multiple-token-balance?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context16.sent;
                        return _context16.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context16.stop();
                }
            }, _callee16, this);
        }));
        function getMultipleTokenBalance(_x30, _x31) {
            return _getMultipleTokenBalance.apply(this, arguments);
        }
        return getMultipleTokenBalance;
    }();
    return RangoClient;
}();
var $078a8abb74f92b71$export$9d749b8b357dfab2 = function isEvmBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'EVM';
};
var $078a8abb74f92b71$export$d917e9e8a70036a6 = function isCosmosBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'COSMOS';
};
var $078a8abb74f92b71$export$ff5a0a65a8982bf2 = function isSolanaBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'SOLANA';
};
var $078a8abb74f92b71$export$744fa0907a94ca40 = function isTronBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'TRON';
};
var $078a8abb74f92b71$export$83b5ebc3a9031095 = function isTransferBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'TRANSFER';
};
var $078a8abb74f92b71$export$80db8fd9e7a31db2 = function isStarknetBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'STARKNET';
};
var $078a8abb74f92b71$export$9500a92ad5d775aa = function isTonBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'TON';
};
var $078a8abb74f92b71$export$91bd0dedd228558 = function isXrplBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'XRPL';
};
var $078a8abb74f92b71$export$166c7bb8293a61af = function isHyperliquidBlockchain(blockchainMeta) {
    return blockchainMeta.type === 'HYPERLIQUID';
};
var $078a8abb74f92b71$export$e2a694e57950e88e = function evmBlockchains(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$9d749b8b357dfab2);
};
var $078a8abb74f92b71$export$11a35c42f4dd4832 = function solanaBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$ff5a0a65a8982bf2);
};
var $078a8abb74f92b71$export$e1f5443c7a926d0f = function starknetBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$80db8fd9e7a31db2);
};
var $078a8abb74f92b71$export$61a2144ef91f3622 = function tronBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$744fa0907a94ca40);
};
var $078a8abb74f92b71$export$7a136f0d6bb0d722 = function cosmosBlockchains(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$d917e9e8a70036a6);
};
var $078a8abb74f92b71$export$80dff8c560b1e7ce = function transferBlockchains(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$83b5ebc3a9031095);
};
var $078a8abb74f92b71$export$e38bf62be0c23ec5 = function tonBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$9500a92ad5d775aa);
};
var $078a8abb74f92b71$export$b872edb03b12cfaa = function xrplBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$91bd0dedd228558);
};
var $078a8abb74f92b71$export$18c65c826bbef61 = function hyperliquidBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$166c7bb8293a61af);
};
/**
 * Routing Result Type
 *
 */ var $078a8abb74f92b71$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
    RoutingResultType["HIGH_IMPACT_FOR_CREATE_TX"] = "HIGH_IMPACT_FOR_CREATE_TX";
})($078a8abb74f92b71$export$9244fb3192b4c649 || ($078a8abb74f92b71$export$9244fb3192b4c649 = {}));
/**
 * The type of transaction
 */ var $078a8abb74f92b71$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
    TransactionType["SUI"] = "SUI";
    TransactionType["XRPL"] = "XRPL";
    TransactionType["STELLAR"] = "STELLAR";
    TransactionType["HYPERLIQUID"] = "HYPERLIQUID";
})($078a8abb74f92b71$export$d513b00599f845d4 || ($078a8abb74f92b71$export$d513b00599f845d4 = {}));
/**
 * The type of transaction
 * @deprecated use TransactionType instead
 */ var $078a8abb74f92b71$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($078a8abb74f92b71$export$d5c0ec10a1bea971 || ($078a8abb74f92b71$export$d5c0ec10a1bea971 = {}));
/**
 * The status of transaction in tracking
 */ var $078a8abb74f92b71$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($078a8abb74f92b71$export$7c391bd3b61d2374 || ($078a8abb74f92b71$export$7c391bd3b61d2374 = {}));
var $078a8abb74f92b71$export$16073528a91c8d2a = function isCosmosTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.COSMOS;
};
var $078a8abb74f92b71$export$b1818bc93202fd47 = function isSolanaTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.SOLANA;
};
var $078a8abb74f92b71$export$a6e014f972e5c64c = function isTransferTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.TRANSFER;
};
var $078a8abb74f92b71$export$9fd5291d9179852a = function isTronTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.TRON;
};
var $078a8abb74f92b71$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($078a8abb74f92b71$export$6ef804aee1395a14 || ($078a8abb74f92b71$export$6ef804aee1395a14 = {}));
var $078a8abb74f92b71$export$232916af2d90d322 = function isTonTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.TON;
};
var $078a8abb74f92b71$export$b9109202fe95a066 = function isEvmTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.EVM;
};



var $bh6RR = parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
'use strict';
var $47cfd4084854a574$exports = {};
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;


function $da8b025973eb845b$export$1c382ce64232cf3a() {
    // NOTE: parcel doesn't support for dynamic keys, so we have to do it statically.
    return "4a624ab5-16ff-4f96-90b7-ab00ddfc342c";
}
function $da8b025973eb845b$export$c42d9896c9899da() {
    // NOTE: parcel doesn't support for dynamic keys, so we have to do it statically.
    const value = $da8b025973eb845b$export$1c382ce64232cf3a();
    if (value) return value;
    throw new Error('Ensure you have set REACT_APP_RANGO_API_KEY in your env variables.');
}
function $da8b025973eb845b$export$c3961f85995aa844() {
    return $da8b025973eb845b$export$1c382ce64232cf3a() || 'NOT_SET';
}


let $86a9fd6e2401871c$var$configs = {
    API_KEY: (0, $da8b025973eb845b$export$c3961f85995aa844)(),
    BASE_URL: ''
};
function $86a9fd6e2401871c$export$44487a86467333c3(name) {
    return $86a9fd6e2401871c$var$configs[name];
}
function $86a9fd6e2401871c$export$940a7873bb071df8(name, value) {
    $86a9fd6e2401871c$var$configs[name] = value;
    return value;
}
function $86a9fd6e2401871c$export$b9b9cdb96b829919(nextConfigs) {
    $86a9fd6e2401871c$var$configs = nextConfigs;
    return $86a9fd6e2401871c$var$configs;
}


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
parcelRequire("9U3Qn");
var $gEbmX = parcelRequire("gEbmX");

/* eslint-disable destructuring/in-params */ /* eslint-disable @typescript-eslint/no-floating-promises */ 
const $f264d8a52804be44$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $f264d8a52804be44$export$2e2bcd8739ae039 = {
    randomUUID: $f264d8a52804be44$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $2d610bb95518b9a1$var$getRandomValues;
const $2d610bb95518b9a1$var$rnds8 = new Uint8Array(16);
function $2d610bb95518b9a1$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$2d610bb95518b9a1$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $2d610bb95518b9a1$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$2d610bb95518b9a1$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $2d610bb95518b9a1$var$getRandomValues($2d610bb95518b9a1$var$rnds8);
}


var $da5b7c6300fefe7c$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8fc69e9cd2be6974$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $da5b7c6300fefe7c$export$2e2bcd8739ae039).test(uuid);
}
var $8fc69e9cd2be6974$export$2e2bcd8739ae039 = $8fc69e9cd2be6974$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $101e3de50ea62e18$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$101e3de50ea62e18$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $101e3de50ea62e18$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $101e3de50ea62e18$var$byteToHex[arr[offset + 0]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 1]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 2]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 3]] + '-' + $101e3de50ea62e18$var$byteToHex[arr[offset + 4]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 5]] + '-' + $101e3de50ea62e18$var$byteToHex[arr[offset + 6]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 7]] + '-' + $101e3de50ea62e18$var$byteToHex[arr[offset + 8]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 9]] + '-' + $101e3de50ea62e18$var$byteToHex[arr[offset + 10]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 11]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 12]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 13]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 14]] + $101e3de50ea62e18$var$byteToHex[arr[offset + 15]];
}
function $101e3de50ea62e18$var$stringify(arr, offset = 0) {
    const uuid = $101e3de50ea62e18$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8fc69e9cd2be6974$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $101e3de50ea62e18$export$2e2bcd8739ae039 = $101e3de50ea62e18$var$stringify;


function $6f61046155174072$var$v4(options, buf, offset) {
    if ((0, $f264d8a52804be44$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $f264d8a52804be44$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $2d610bb95518b9a1$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $101e3de50ea62e18$export$8fb373d660548968)(rnds);
}
var $6f61046155174072$export$2e2bcd8739ae039 = $6f61046155174072$var$v4;


const $6d5ad09ed8dd1162$export$3c22ff8b64b8f565 = 'queues-manager';
const $6d5ad09ed8dd1162$var$OBJECT_STORE_NAME = 'queues';
const $6d5ad09ed8dd1162$var$VERSION = 1;

class $6d5ad09ed8dd1162$var$Persistor {
    constructor(){
        this.db = (parcelRequire("7WGbV")).then(async (idb)=>{
            return idb.openDB($6d5ad09ed8dd1162$export$3c22ff8b64b8f565, $6d5ad09ed8dd1162$var$VERSION, {
                upgrade (db) {
                    db.createObjectStore($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, {
                        keyPath: 'id'
                    });
                }
            });
        }).catch(()=>{
            throw new Error("Couldn't load idb.");
        });
    }
    async insertQueue(queue) {
        const db = await this.db;
        const queueRecord = await db.get($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, queue.id);
        if (queueRecord) ;
        else await db.add($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, queue);
    }
    async updateQueue(id, queue) {
        const db = await this.db;
        const currentRecord = await db.get($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, id);
        if (!currentRecord) return;
        const updatedRecord = {
            ...currentRecord,
            ...queue
        };
        await db.put($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, updatedRecord);
    }
    async getAll() {
        const db = await this.db;
        const results = await db.getAll($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME);
        return results;
    }
    async deleteQueue(id) {
        const db = await this.db;
        const currentRecord = await db.get($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, id);
        if (currentRecord) await db.delete($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, id);
    }
}
var $6d5ad09ed8dd1162$export$2e2bcd8739ae039 = $6d5ad09ed8dd1162$var$Persistor;



var $8b414db6fb875971$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PENDING"] = "PENDING";
    Status["RUNNING"] = "RUNNING";
    Status["FAILED"] = "FAILED";
    Status["SUCCESS"] = "SUCCESS";
    Status["CANCELED"] = "CANCELED";
    Status["BLOCKED"] = "BLOCKED";
    return Status;
}({});
const $8b414db6fb875971$export$638f14178e6e0c43 = 5000;


/**
 *
 * Notes on statuses:
 *  - Success: last task has success status
 *  - Failed: any of task has been failed
 *  - Running: first task is not on pending
 *  - Pending: default state. not started
 *
 */ class $419d2d2011694812$var$Queue {
    constructor(options){
        this.state = {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING,
            activeTaskIndex: 0,
            tasks: {}
        };
        this.tasks = [];
        this.storage = {};
        this.id = options.id;
        this.events = options.events;
        this.actions = options.actions;
    }
    /**
   * Update queue status and trigger an event
   *
   */ updateQueueStatus(status) {
        this.state.status = status;
        this.events.onUpdateListStatus(status);
    }
    updateActiveTaskIndex(index) {
        this.state.activeTaskIndex = index;
    }
    /**
   *
   * Update task state (`status`, `blockedFor`) and trigger an event.
   * @param id
   * @param nextState
   */ updateTaskState(id, nextState) {
        if (nextState.status) this.state.tasks[id].status = nextState.status;
        if (nextState.blockedFor) this.state.tasks[id].blockedFor = nextState.blockedFor;
        const updatedTaskEvent = {
            id: id,
            task: this.get(id),
            action: this.tasks.find((task)=>task.id === id).action
        };
        this.events.onUpdate(updatedTaskEvent);
    }
    /**
   * Create a task by providing an `action` name.
   *
   * this method creating the task, push it to the queue's tasks and trigger an event.
   * @param action
   */ createTask(action) {
        const id = (0, $6f61046155174072$export$2e2bcd8739ae039)();
        this.tasks.push({
            action: action,
            id: id
        });
        this.state.tasks[id] = {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING,
            blockedFor: null
        };
        const createdTask = this.get(id);
        this.events.onCreate({
            id: id,
            task: createdTask,
            action: action
        });
    }
    /**
   * Initilize a queue with some tasks, instead of an empty queue.
   *
   * Using it for recover the queue state from persistor.
   *
   */ initTasks(info) {
        this.state = info.state;
        this.storage = info.storage;
        info.tasks.forEach((task)=>{
            this.tasks.push(task);
            const action = this.tasks.find((t)=>t.id === task.id).action;
            this.events.onCreate({
                id: task.id,
                task: this.get(task.id),
                action: action
            });
        });
    }
    checkBlock() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) return;
        const { task: task, state: state } = currentActiveTask;
        if (state.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) this.events.onBlock({
            action: task.action,
            id: task.id,
            reason: state.blockedFor
        });
    }
    /**
   * Getting task state by ID
   */ get(id) {
        const task = this.state.tasks[id];
        if (!task) return null;
        return task;
    }
    /**
   *
   * Checking if status of the last is `SUCCESS` or not
   *
   */ lastTaskIsSuccessful() {
        const lastTask = this.tasks[this.tasks.length - 1];
        // checking for empty lists.
        if (lastTask) {
            const lastTaskState = this.state.tasks[lastTask.id];
            // Maybe we didn't create the state yet. It should has success status as well.
            if (!!lastTaskState && lastTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS) return true;
        }
        return false;
    }
    /**
   * If the first task started (it's not PENDING),
   * it means the queue has been ran.
   *
   * @returns
   */ firstTaskIsStarted() {
        const firstTask = this.tasks[0];
        // checking for empty lists.
        if (firstTask) {
            const firstTaskState = this.state.tasks[firstTask.id];
            // Maybe we didn't create the state yet.
            if (!!firstTaskState) {
                if (firstTaskState.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING) return true;
            }
        }
        return false;
    }
    /**
   * Getting active task index from state and
   * returns the task and its state.
   *
   */ getActiveTask() {
        // First try to get task with `activeTask`
        const index = this.state.activeTaskIndex;
        const task = this.tasks[index];
        // Consider all the tasks has been executed.
        if (!task) return null;
        const state = this.state.tasks[task.id];
        return {
            task: task,
            state: state,
            index: index
        };
    }
    /**
   * Update and find the queue status by checking state of each tasks in the queue.
   */ check() {
        const currentListStatus = this.state.status;
        let nextListStatus = this.firstTaskIsStarted() ? (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING : (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING;
        if (this.lastTaskIsSuccessful()) nextListStatus = (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS;
        else // Is there any failed task?
        for (const task of this.tasks){
            const state = this.state.tasks[task.id];
            // If one item fails, we stop to work on the list.
            if (state.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED) {
                nextListStatus = (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED;
                break;
            }
        }
        // We only update and trigger an event when there is a new value
        if (nextListStatus !== currentListStatus) this.updateQueueStatus(nextListStatus);
    }
    /**
   * Execute active task.
   * Based on the state of active task, the behaviour is different. If status is:
   *  - Success -> we need to go to next task by updating the active index and try `next` on more time.
   *  - Failed, Running, or no active task -> doesn't do anything.
   *  - Pending or Blocked -> update the task and queue status to running, and execute the provided `action` for the task.
   *
   * The queue is a linked list somehow, active task means the pointer to where we are in the queue right now.
   *
   */ next(params) {
        this.check();
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) return;
        const { index: activeTaskIndex, task: activeTask, state: activeTaskState } = currentActiveTask;
        // if `activeTask` is already done, we will go for next one.
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS) {
            this.updateActiveTaskIndex(activeTaskIndex + 1);
            this.next(params);
            return;
        }
        if ([
            (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
        ].includes(activeTaskState.status)) return;
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING || activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) {
            // Update task status to `running`
            this.updateTaskState(activeTask.id, {
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
            });
            this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING);
            // Try to execute task.
            const execute = this.actions[activeTask.action];
            execute({
                context: this.getContext(params),
                next: ()=>{
                    this.markCurrentTaskAsFinished(params);
                },
                retry: ()=>{
                    this.resume(params);
                },
                failed: ()=>{
                    this.updateTaskState(activeTask.id, {
                        status: (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED
                    });
                    this.check();
                },
                schedule: (action)=>{
                    this.createTask(action);
                    this.check();
                },
                getStorage: this.getStorage.bind(this),
                setStorage: this.setStorage.bind(this),
                block: (reason)=>{
                    this.block({
                        reason: reason
                    });
                },
                unblock: ()=>{
                    this.unblock();
                }
            });
        }
    }
    /**
   * Change the `status` of active task and queue to BLOCKED, then trigger an event.
   */ block({ reason: reason, silent: silent = false }) {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) throw new Error("Task isn't exist.");
        this.updateTaskState(currentActiveTask.task.id, {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED,
            blockedFor: reason
        });
        this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED);
        if (!silent) this.events.onBlock({
            action: currentActiveTask.task.action,
            id: currentActiveTask.task.id,
            reason: reason
        });
    }
    /**
   * If the active task is `BLOCKED`, update the task status to `PENDING`, queue status to `RUNNING`
   * then trigger an event.
   */ unblock() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask || currentActiveTask.state.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) throw new Error('Task is not blocked.');
        this.updateTaskState(currentActiveTask.task.id, {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING
        });
        this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING);
        this.events.onUnblock({
            id: currentActiveTask.task.id
        });
    }
    /**
   * If the active task is `BLOCKED` then execute the `action` for the task.
   *
   * It is useful for when we need to run a blocked task without changing the status of task at the first place.
   * For scenarios like we have some conditions in `action` and needs to run the `action` again
   * to check the conditions are met or not, if yes, so we can proceed the `action`.
   *
   */ forceRun(params) {
        const currentTask = this.getActiveTask();
        if (!currentTask || currentTask.state.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) throw new Error('Task is not blocked.');
        // Try to execute task.
        const execute = this.actions[currentTask.task.action];
        execute({
            context: this.getContext(params),
            next: ()=>{
                /*
          NOTE:
            When running `forceRun`, the status of task can be `BLOCKED`
            So we need to change to `Running` first. 
        */ // Update task status to `running`
                this.updateTaskState(currentTask.task.id, {
                    status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
                });
                this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING);
                this.markCurrentTaskAsFinished(params);
            },
            retry: ()=>{
                this.resume(params);
            },
            failed: ()=>{
                this.updateTaskState(currentTask.task.id, {
                    status: (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED
                });
                this.check();
            },
            schedule: (action)=>{
                this.createTask(action);
                this.check();
            },
            getStorage: this.getStorage.bind(this),
            setStorage: this.setStorage.bind(this),
            block: (reason)=>{
                this.block({
                    reason: reason
                });
            },
            unblock: ()=>{
                this.unblock();
            }
        });
    }
    markCurrentTaskAsFinished(params) {
        this.check();
        const activeTaskIndex = this.state.activeTaskIndex;
        const activeTask = this.tasks[activeTaskIndex];
        if (!activeTask) return;
        const activeTaskState = this.state.tasks[activeTask.id];
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING) {
            this.updateTaskState(activeTask.id, {
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS
            });
            this.updateActiveTaskIndex(activeTaskIndex + 1);
            const updatedTaskEvent = {
                id: activeTask.id,
                task: this.get(activeTask.id),
                action: this.tasks.find((task)=>task.id === activeTask.id).action
            };
            this.events.onUpdate(updatedTaskEvent);
            this.next(params);
        }
    }
    /**
   * If the active task is `RUNNING`, change it to `PENING` the try to run the task by calling `next`.
   * If it's other than `RUNNING` we reset the queue state and run the queue from the beggining.
   *
   * @param params
   * @returns
   */ resume(params) {
        const activeTaskIndex = this.state.activeTaskIndex;
        const activeTask = this.tasks[activeTaskIndex];
        if (!activeTask) return;
        const activeTaskState = this.state.tasks[activeTask.id];
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING) {
            this.updateTaskState(activeTask.id, {
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING
            });
            this.next(params);
        } else {
            this.resetState();
            this.next(params);
        }
    }
    /**
   *
   * Cancel the queue by changing active task and queue status to `CANCELED`.
   *
   */ cancel() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask || [
            (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS
        ].includes(currentActiveTask.state.status)) return;
        const { task: task } = currentActiveTask;
        // Update task status to `canceled`
        this.updateTaskState(task.id, {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED
        });
        const updatedTaskEvent = {
            id: task.id,
            task: this.get(task.id),
            action: this.tasks.find((t)=>t.id === task.id).action
        };
        this.events.onUpdate(updatedTaskEvent);
        // Update queue status to `canceled`
        this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED);
    }
    /**
   * Update queue status, and all the tasks inside queue to `PENDING`.
   */ resetState() {
        this.state.activeTaskIndex = 0;
        this.state.status = (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING;
        Object.keys(this.state.tasks).forEach((id)=>{
            this.state.tasks[id].status = (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING;
        });
    }
    getStorage() {
        return this.storage;
    }
    setStorage(data) {
        this.storage = data;
        this.events.onStorageUpdate(data);
        return this.storage;
    }
    getContext(params) {
        return {
            ...params.context,
            _queue: {
                id: this.id
            }
        };
    }
}
var $419d2d2011694812$export$2e2bcd8739ae039 = $419d2d2011694812$var$Queue;



class $40ce72f69a9a8814$export$d0d38e7dec7a1a61 {
    /**
   *
   * Making an instance, initilize events, setup a persistor and try to recover the last state of the manager.
   *
   *
   */ constructor(options){
        this.queuesDefs = new Map();
        this.queues = new Map();
        this.isPaused = false;
        // The client won't get any update on pause, We are using a polling mode to fix this issue for now.
        this.syncInterval = null;
        const defaultEventHandlers = {
            onCreateQueue: ()=>{
            // ...
            },
            onCreateTask: ()=>{
            // ...
            },
            onUpdateQueue: ()=>{
            // ...
            },
            onUpdateTask: ()=>{
            // ...
            },
            onStorageUpdate: ()=>{
            // ...
            },
            onTaskBlock: ()=>{
            // ...
            },
            onPersistedDataLoaded: ()=>{
            // ..
            },
            onDeleteQueue: ()=>{
            // ...
            }
        };
        if (options.events) this.events = {
            ...defaultEventHandlers,
            ...options.events
        };
        else this.events = defaultEventHandlers;
        options.queuesDefs.map((qDef)=>{
            this.queuesDefs.set(qDef.name, qDef);
        });
        this.context = options.context || {};
        this.persistor = new (0, $6d5ad09ed8dd1162$export$2e2bcd8739ae039)();
        this.sync();
        if (options.isPaused) this.pause();
    }
    // Create a new queue
    /**
   *
   * Create a new queue by client.
   *
   * It will do the internal things to make a queue from definitions, and running using Manager.
   *
   * Notes:
   *  - After creating the queue, it will be run automatically.
   *
   * @returns an ID for queue so it can be used to get the created queue later by client.
   *
   */ async create(name, storage, options) {
        if (!this.queuesDefs.has(name)) throw new Error('You need to add a queue definition first.');
        try {
            const def = this.queuesDefs.get(name);
            const queue_id = options?.id || (0, $6f61046155174072$export$2e2bcd8739ae039)();
            const createdAt = Date.now();
            const list = this.createQueue({
                queue_id: queue_id,
                queue_name: name
            });
            list.setStorage(storage);
            const createdQueue = this.add(queue_id, {
                list: list,
                createdAt: createdAt,
                name: name,
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING,
                actions: {
                    run: ()=>{
                        list.next({
                            context: this.getContext()
                        });
                    },
                    cancel: ()=>{
                        list.cancel();
                    },
                    setStorage: (...args)=>{
                        list.setStorage(...args);
                    },
                    getStorage: ()=>{
                        return list.getStorage();
                    }
                }
            });
            /*
       * Persist initial queue
       * Note: we need to first insert the queue, and then it can be updated by internal events.
       */ await this.persistor.insertQueue({
                id: queue_id,
                createdAt: createdAt,
                name: createdQueue.name,
                status: createdQueue.status,
                tasks: list.tasks,
                state: list.state,
                storage: list.getStorage()
            });
            // adding initial tasks
            def.run.forEach((action)=>{
                list.createTask(action);
            });
            // After creating a new queue, try to run.
            this.execute();
            return queue_id;
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw new Error(e?.message);
        }
    }
    /**
   *
   * Reading persisted data from storage then brings into memory.
   *
   * Notes:
   *  - Reset the memory, so we can call this method whenever we want and not only on the initialize process.
   *  - All the events will be tirggered (like onCreateQueue, onCreateTask, onBlock, ....)
   *  - Try to `resume` if the status is `running`.
   *  - Trigger `onPersistedDataLoaded` event when queues recovered from storage.
   *
   */ /**
   * Get a queue by its ID.
   *
   * @returns An object includes queue and its state in `Manager`.
   */ get(queue_id) {
        return this.queues.get(queue_id);
    }
    /**
   * Get all queues from `Manager`
   *
   * @returns a list of queues includes all the queues and their states.
   */ getAll() {
        return this.queues;
    }
    deleteQueue(queue_id) {
        this.queues.delete(queue_id);
        this.persistor.deleteQueue(queue_id);
    }
    async clearQueue() {
        // Identify queues that are not running
        this.queues.forEach((queue, queue_id)=>{
            if (queue.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING && queue.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING && queue.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) this.deleteQueue(queue_id);
        });
    }
    /**
   *
   * Ask from manager to run pending queues.
   *
   * It only try to run queues with `PENDING` status and ignore all the other statuses.
   *
   */ execute() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING) q.actions.run();
    }
    /**
   *
   * Try to find queues with `RUNNING` status to run them again.
   *
   * It's useful for recovering the queue at some certain points
   * like running a currepted task (reloaded when it was running) or needs manual trigger from UI.
   *
   * @returns
   */ resume() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING) {
            q.list.resume({
                context: this.getContext()
            });
            return;
        }
        // If there is no running queue, try to run a new queue.
        this.execute();
    }
    /**
   *
   * Run all `BLOCKED` queues once again.
   *
   * If a queue has `BLOCKED` status and the last task is `BLOCKED` as well,
   * The task will be run one more time.
   *
   * Useful for scenarios like we are blocking the queue under some conditions in task,
   * We can use this method to ask the queue to run the blocked task one more time and
   * maybe this time condtions are met and the queue can be proceed.
   *
   * @returns
   */ retry() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) q.list.checkBlock();
        // If there is no running queue, try to run a new queue.
        this.execute();
    }
    /**
   *
   * Run a blocked task on a specific queue with the ability to pass more data.
   *
   * Useful when we have a custom logic for running queue and needs to pass some specific data
   * to the task and try to run it manually with the provided data.
   *
   */ forceExecute(queue_id, data) {
        const queue = this.get(queue_id);
        let context = this.getContext();
        if (data) context = {
            ...context,
            ...data
        };
        queue?.list.forceRun({
            context: context
        });
    }
    /**
   * Active readonly mode for manager, it means it doesn't run anythin,
   * And only can be used to read the data.
   */ pause() {
        if (this.isPaused) return;
        this.isPaused = true;
        this.syncInterval = window.setInterval(()=>{
            this.sync();
        }, (0, $8b414db6fb875971$export$638f14178e6e0c43));
    }
    /**
   * Activate normal mode which means it will be able to run the queuese as well.
   */ run() {
        // If call this method multiple times, it should be run for once.
        if (this.isPaused) {
            this.isPaused = false;
            if (!!this.syncInterval) {
                clearInterval(this.syncInterval);
                this.syncInterval = null;
            }
            this.sync();
        }
    }
    async sync() {
        try {
            // Reading queues from storage
            const queues = await this.persistor.getAll();
            // Reset queues, if anything is exist in memory.
            this.queues = new Map();
            // Brings them into memory
            queues.forEach((q)=>{
                const list = this.createQueue({
                    queue_id: q.id,
                    queue_name: q.name
                });
                this.add(q.id, {
                    list: list,
                    createdAt: q.createdAt,
                    name: q.name,
                    status: q.status,
                    actions: {
                        run: ()=>{
                            list.next({
                                context: this.getContext()
                            });
                        },
                        cancel: ()=>{
                            list.cancel();
                        },
                        setStorage: (...args)=>{
                            list.setStorage(...args);
                        },
                        getStorage: ()=>{
                            return list.getStorage();
                        }
                    }
                });
                list.initTasks({
                    state: q.state,
                    tasks: q.tasks,
                    storage: q.storage || {}
                });
                if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING && this.shouldExecute()) list.resume({
                    context: this.getContext()
                });
            });
        } catch (e) {
            console.log(`IndexDB Error: ${e}`);
        }
        // Trigger an event to let the subscribers we are done here.
        this.events.onPersistedDataLoaded(this);
    }
    /**
   *
   * Making a new instance from `Queue` and adds Manager's event handlers to it.
   *
   * @returns An instance of `Queue` with wrapped event handlers from Manager.
   *
   */ createQueue(info) {
        const { queue_id: queue_id, queue_name: queue_name } = info;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const def = this.queuesDefs.get(queue_name);
        const list = new (0, $419d2d2011694812$export$2e2bcd8739ae039)({
            id: queue_id,
            events: {
                onCreate: (task)=>{
                    this.events.onCreateTask(queue_id, task);
                    this.handleUpdate(queue_id);
                    if (def.events?.onCreate) def.events.onCreate(task);
                },
                onUpdate: (task)=>{
                    this.events.onUpdateTask(queue_id, task);
                    this.handleUpdate(queue_id);
                    if (def.events?.onUpdate) def.events.onUpdate(task);
                },
                onUpdateListStatus: (status)=>{
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: status
                    });
                    this.events.onUpdateQueue(queue_id, this.get(queue_id));
                    this.handleUpdate(queue_id);
                    // After finishing a queue, try to run other queues.
                    this.execute();
                    if (def.events?.onUpdateListStatus) def.events.onUpdateListStatus(status);
                },
                onStorageUpdate: (data)=>{
                    this.events.onStorageUpdate(queue_id, data);
                    if (def.events?.onStorageUpdate) def.events.onStorageUpdate(data);
                    this.handleUpdate(queue_id);
                },
                onBlock: (event)=>{
                    // Update queue status
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED
                    });
                    // Trigger event
                    this.events.onTaskBlock(queue_id);
                    if (def.whenTaskBlocked) def.whenTaskBlocked(event, {
                        queue_id: queue_id,
                        queue: list,
                        context: this.getContext(),
                        getBlockedTasks: this.getBlockedTasks.bind(this),
                        forceExecute: this.forceExecute.bind(this),
                        retry: this.retry.bind(this),
                        manager: manager
                    });
                    // Sync
                    this.handleUpdate(queue_id);
                },
                onUnblock: ()=>{
                    // Update queue status
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING
                    });
                    // Sync
                    this.handleUpdate(queue_id);
                    this.execute();
                }
            },
            actions: def.actions
        });
        return list;
    }
    /**
   * Go through all tasks (from all queues) and return a list of blocked tasks
   *
   * @returns a list of blocked tasks including enough information to get the queue and mutate the storage.
   *
   */ getBlockedTasks() {
        const queues = this.getAll();
        const blockedTasks = [];
        queues.forEach((q, queue_id)=>{
            q.list.tasks.forEach((task)=>{
                const state = q.list.state.tasks[task.id];
                if (state.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) blockedTasks.push({
                    task_id: task.id,
                    queue_id: queue_id,
                    action: task.action,
                    reason: state.blockedFor,
                    storage: {
                        get: ()=>{
                            return q.list.getStorage();
                        },
                        set: (data)=>{
                            return q.list.setStorage(data);
                        }
                    }
                });
            });
        });
        return blockedTasks;
    }
    /**
   *
   * Add a queue to the manager to keep track of the queue and its state.
   *
   * @param id
   * @param queue
   * @returns
   */ add(id, queue) {
        this.queues.set(id, queue);
        const createdQueue = this.get(id);
        this.events.onCreateQueue({
            ...createdQueue,
            id: id
        });
        return createdQueue;
    }
    /**
   *
   * Sync in-memory state (of `Manager`) with storage (persist).
   *
   * Usually we call this method after a change detected in the state of manager.
   *
   */ handleUpdate(queue_id) {
        const queue = this.get(queue_id);
        if (queue) {
            const status = queue.status;
            const state = queue.list.state;
            const tasks = queue.list.tasks;
            this.persistor.updateQueue(queue_id, {
                status: status,
                state: state,
                tasks: tasks,
                storage: queue.list.getStorage()
            });
        }
    }
    getContext() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return this.context?.current || {};
    }
    shouldExecute() {
        return !this.isPaused;
    }
}







var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $gSYt0 = parcelRequire("gSYt0");

var $iOQO2 = parcelRequire("iOQO2");
parcelRequire("9U3Qn");
var $k5IP8 = parcelRequire("k5IP8");
var $9gKM3 = parcelRequire("9gKM3");
var $9B1kL = parcelRequire("9B1kL");
parcelRequire("9U3Qn");
var $gEbmX = parcelRequire("gEbmX");

var $4a641b36af06aafc$export$f01edf6b00a44c8a = /*#__PURE__*/ function(SwapActionTypes) {
    SwapActionTypes["START"] = "START";
    SwapActionTypes["SCHEDULE_NEXT_STEP"] = "SCHEDULE_NEXT_STEP";
    SwapActionTypes["CREATE_TRANSACTION"] = "CREATE_TRANSACTION";
    SwapActionTypes["CHECK_PREREQUISITES"] = "CHECK_PREREQUISITES";
    SwapActionTypes["CHECK_XRPL_TRUSTLINE"] = "CHECK_XRPL_TRUSTLINE";
    SwapActionTypes["CHECK_STELLAR_TRUSTLINE"] = "CHECK_STELLAR_TRUSTLINE";
    SwapActionTypes["CHECK_XRPL_TRUSTLINE_TRANSACTION_STATUS"] = "CHECK_XRPL_TRUSTLINE_TRANSACTION_STATUS";
    SwapActionTypes["EXECUTE_TRANSACTION"] = "EXECUTE_TRANSACTION";
    SwapActionTypes["EXECUTE_XRPL_TRANSACTION"] = "EXECUTE_XRPL_TRANSACTION";
    SwapActionTypes["EXECUTE_STELLAR_TRANSACTION"] = "EXECUTE_STELLAR_TRANSACTION";
    SwapActionTypes["CHECK_TRANSACTION_STATUS"] = "CHECK_TRANSACTION_STATUS";
    return SwapActionTypes;
}({});
var $4a641b36af06aafc$export$b022a9988c1688ba = /*#__PURE__*/ function(BlockReason) {
    BlockReason["WAIT_FOR_CONNECT_WALLET"] = "waiting_for_connecting_wallet";
    BlockReason["WAIT_FOR_NETWORK_CHANGE"] = "waiting_for_network_change";
    BlockReason["DEPENDS_ON_OTHER_QUEUES"] = "depends_on_other_queues";
    return BlockReason;
}({});
var $4a641b36af06aafc$export$54f5f69c1651567f = /*#__PURE__*/ function(WidgetEvents) {
    WidgetEvents["RouteEvent"] = "routeEvent";
    WidgetEvents["StepEvent"] = "stepEvent";
    return WidgetEvents;
}({});
var $4a641b36af06aafc$export$543d0a6c7f452841 = /*#__PURE__*/ function(RouteEventType) {
    RouteEventType["STARTED"] = "started";
    RouteEventType["FAILED"] = "failed";
    RouteEventType["SUCCEEDED"] = "succeeded";
    return RouteEventType;
}({});
var $4a641b36af06aafc$export$4a1a2e5c997cdbb1 = /*#__PURE__*/ function(StepExecutionEventStatus) {
    StepExecutionEventStatus["CREATE_TX"] = "create_tx";
    StepExecutionEventStatus["SEND_TX"] = "send_tx";
    StepExecutionEventStatus["TX_SENT"] = "tx_sent";
    return StepExecutionEventStatus;
}({});
var $4a641b36af06aafc$export$ee459e29d25d53b0 = /*#__PURE__*/ function(StepExecutionBlockedEventStatus) {
    StepExecutionBlockedEventStatus["WAITING_FOR_QUEUE"] = "waiting_for_queue";
    StepExecutionBlockedEventStatus["WAITING_FOR_WALLET_CONNECT"] = "waiting_for_wallet_connect";
    StepExecutionBlockedEventStatus["WAITING_FOR_NETWORK_CHANGE"] = "waiting_for_network_change";
    StepExecutionBlockedEventStatus["WAITING_FOR_CHANGE_WALLET_ACCOUNT"] = "waiting_for_change_wallet_account";
    return StepExecutionBlockedEventStatus;
}({});
var $4a641b36af06aafc$export$19ce097d7421ac9a = /*#__PURE__*/ function(StepEventType) {
    StepEventType["STARTED"] = "started";
    StepEventType["FAILED"] = "failed";
    StepEventType["SUCCEEDED"] = "succeeded";
    StepEventType["TX_EXECUTION"] = "tx_execution";
    StepEventType["TX_EXECUTION_BLOCKED"] = "tx_execution_blocked";
    StepEventType["APPROVAL_TX_SUCCEEDED"] = "approval_tx_succeeded";
    StepEventType["CHECK_STATUS"] = "check_status";
    StepEventType["OUTPUT_REVEALED"] = "output_revealed";
    return StepEventType;
}({});
var $4a641b36af06aafc$export$ac89cc7182ae1ed0 = /*#__PURE__*/ function(EventSeverity) {
    EventSeverity["ERROR"] = "error";
    EventSeverity["SUCCESS"] = "success";
    EventSeverity["WARNING"] = "warning";
    EventSeverity["INFO"] = "info";
    return EventSeverity;
}({});


const $4919c4b385f2331a$export$7b1c89ab7f8b9b40 = (prerequisiteInfo, step)=>{
    const prerequisiteResult = $4919c4b385f2331a$export$59d93e7e020342a8(step, prerequisiteInfo);
    if (prerequisiteResult?.status === 'success' || prerequisiteResult?.status === 'skipped') return true;
    return false;
};
function $4919c4b385f2331a$export$59d93e7e020342a8(step, key) {
    return step.prerequisiteResults?.find((r)=>$4919c4b385f2331a$export$9168835764674a25(r, key));
}
const $4919c4b385f2331a$export$9168835764674a25 = (a, b)=>a.prerequisiteIndex === b.prerequisiteIndex && a.prerequisiteType === b.prerequisiteType;
function $4919c4b385f2331a$export$9b853567ad655b30(prerequisiteIndex, currentStep) {
    const prerequisiteResult = $4919c4b385f2331a$export$59d93e7e020342a8(currentStep, {
        prerequisiteType: (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE),
        prerequisiteIndex: prerequisiteIndex
    });
    if (!prerequisiteResult) return new (0, $c88854de77322012$export$8146e38189b4f4dc)((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_XRPL_TRUSTLINE);
    switch(prerequisiteResult.status){
        case 'pending':
            return new (0, $c88854de77322012$export$8146e38189b4f4dc)((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_XRPL_TRUSTLINE_TRANSACTION_STATUS);
        case 'success':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: xrpl change trustline prerequisite is already met!');
        case 'skipped':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: xrpl change trustline prerequisite is already met!');
        case 'failed':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: xrpl change trustline prerequisite failed!');
        default:
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: xrpl change trustline prerequisite has an invalid status!');
    }
}
function $4919c4b385f2331a$export$63136d3552b24042(prerequisiteIndex, currentStep) {
    const prerequisiteResult = $4919c4b385f2331a$export$59d93e7e020342a8(currentStep, {
        prerequisiteType: (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE),
        prerequisiteIndex: prerequisiteIndex
    });
    if (!prerequisiteResult) return new (0, $c88854de77322012$export$8146e38189b4f4dc)((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_STELLAR_TRUSTLINE);
    switch(prerequisiteResult.status){
        case 'pending':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: stellar change trustline prerequisite has invalid "pending" status!');
        case 'success':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: stellar change trustline prerequisite is already met!');
        case 'skipped':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: stellar change trustline prerequisite is already met!');
        case 'failed':
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: stellar change trustline prerequisite failed!');
        default:
            return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: stellar change trustline prerequisite has an invalid status!');
    }
}


const $d96636b74cb7ca13$export$bbfd8242d61c310 = 'Waiting for other swaps to complete';
const $d96636b74cb7ca13$export$d6102d677d637a6d = 'Waiting for connecting wallet';
const $d96636b74cb7ca13$export$f2aac43aeaf7ba5a = (type, address)=>`Please change your ${type || 'wallet'} account to ${address || 'proper address'}`;
const $d96636b74cb7ca13$export$2f02fd340a90fed8 = (type)=>`Please connect your ${type ?? ''} wallet.`;
const $d96636b74cb7ca13$export$721abf6846856403 = (network)=>`Please change your network to ${network}.`;
const $d96636b74cb7ca13$export$c93d4c74989d686f = 'CLIENT_UNEXPECTED_BEHAVIOUR';




let $e48877d26b43b539$var$rango = undefined;
const $e48877d26b43b539$export$c1b2b945bea31d71 = ()=>{
    if ($e48877d26b43b539$var$rango) return $e48877d26b43b539$var$rango;
    $e48877d26b43b539$var$rango = new (0, $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8)((0, $86a9fd6e2401871c$export$44487a86467333c3)('API_KEY'), (0, $86a9fd6e2401871c$export$44487a86467333c3)('BASE_URL'));
    return $e48877d26b43b539$var$rango;
};







var $iOQO2 = parcelRequire("iOQO2");

var $iOQO2 = parcelRequire("iOQO2");
const $a34ccf87ef4fdc6c$export$f67be9d9b0e25d7b = (number, minDecimals = null, maxDecimals = null)=>{
    if (number === null) return '';
    if (number === '') return '';
    const n = new (0, $iOQO2.default)(number);
    const roundingMode = 1;
    let maxI = 1000;
    for(let i = 0; i < 60; i++)if (new (0, $iOQO2.default)(n.toFixed(i, roundingMode)).eq(n)) {
        maxI = i;
        break;
    }
    if (n.gte(10000)) return n.toFormat(0, roundingMode);
    if (n.gte(1000)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(100)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(1)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 2))), roundingMode);
    if (n.gte(0.01)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 4))), roundingMode);
    for(let i = minDecimals || 4; i < 17; i++)if (n.gte(Math.pow(10, -i))) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, i))), roundingMode);
    if (n.isEqualTo(0)) return '0';
    return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 8))), roundingMode);
};


parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");
var $9gKM3 = parcelRequire("9gKM3");

const $e8937742787bc347$var$ERROR_ASSERTION_FAILED = 'Assertion failed (Unexpected behaviour)';
const $e8937742787bc347$var$ERROR_CREATE_TRANSACTION = 'Create transaction failed in Rango Server';
const $e8937742787bc347$var$ERROR_INPUT_WALLET_NOT_FOUND = 'Input wallet not found';
class $e8937742787bc347$export$89427b94e5b39218 extends Error {
    constructor(code, m, root, detail){
        super(m), this._isPrettyError = true;
        Object.setPrototypeOf(this, $e8937742787bc347$export$89427b94e5b39218.prototype);
        $e8937742787bc347$export$89427b94e5b39218.prototype._isPrettyError = true;
        this.code = code;
        this.detail = detail;
        this.root = root;
    }
    static isPrettyError(obj) {
        return obj instanceof $e8937742787bc347$export$89427b94e5b39218 || Object.prototype.hasOwnProperty.call(obj, '_isPrettyError');
    }
    getErrorDetail() {
        const rawMessage = typeof this.root === 'object' && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        const rootStr = typeof this.root === 'string' ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            extraMessage: this.message,
            extraMessageDetail: this.detail || rootStr,
            extraMessageErrorCode: this.code || null
        };
    }
    static AssertionFailed(m) {
        return new $e8937742787bc347$export$89427b94e5b39218('CLIENT_UNEXPECTED_BEHAVIOUR', $e8937742787bc347$var$ERROR_ASSERTION_FAILED, null, m);
    }
    static BadStatusCode(message, statusCode) {
        return new $e8937742787bc347$export$89427b94e5b39218('TX_FAIL', message, null, `status code = ${statusCode}`);
    }
    static CreateTransaction(detail) {
        return new $e8937742787bc347$export$89427b94e5b39218('FETCH_TX_FAILED', $e8937742787bc347$var$ERROR_CREATE_TRANSACTION, null, detail);
    }
    static WalletMissing() {
        return new $e8937742787bc347$export$89427b94e5b39218('CLIENT_UNEXPECTED_BEHAVIOUR', $e8937742787bc347$var$ERROR_INPUT_WALLET_NOT_FOUND, null, 'Server requested for a blockchain or address not selected by user');
    }
    static BlockchainMissing() {
        return new $e8937742787bc347$export$89427b94e5b39218('CLIENT_UNEXPECTED_BEHAVIOUR', $e8937742787bc347$var$ERROR_INPUT_WALLET_NOT_FOUND, null, 'Server requested for a blockchain or address not selected by user');
    }
}
function $e8937742787bc347$export$6de13c9ec5bf007b(errorCode) {
    try {
        if (!errorCode) return 0, $d96636b74cb7ca13$export$c93d4c74989d686f;
        if ((0, $9B1kL.isAPIErrorCode)(errorCode)) return errorCode;
        if ((0, $9gKM3.isSignerErrorCode)(errorCode)) {
            const t = {
                [(0, $9gKM3.SignerErrorCode).REJECTED_BY_USER]: 'USER_REJECT',
                [(0, $9gKM3.SignerErrorCode).SIGN_TX_ERROR]: 'CALL_WALLET_FAILED',
                [(0, $9gKM3.SignerErrorCode).SEND_TX_ERROR]: 'SEND_TX_FAILED',
                [(0, $9gKM3.SignerErrorCode).TX_FAILED_IN_BLOCKCHAIN]: 'TX_FAILED_IN_BLOCKCHAIN',
                [(0, $9gKM3.SignerErrorCode).NOT_IMPLEMENTED]: (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
                [(0, $9gKM3.SignerErrorCode).OPERATION_UNSUPPORTED]: (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
                [(0, $9gKM3.SignerErrorCode).UNEXPECTED_BEHAVIOUR]: (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
            };
            return t[errorCode];
        }
        return 0, $d96636b74cb7ca13$export$c93d4c74989d686f;
    } catch (err) {
        return 0, $d96636b74cb7ca13$export$c93d4c74989d686f;
    }
}
const $e8937742787bc347$export$8a2553b801670ae3 = (obj)=>{
    if (!obj) return {
        extraMessage: '',
        extraMessageErrorCode: null
    };
    if ($e8937742787bc347$export$89427b94e5b39218.isPrettyError(obj)) return obj.getErrorDetail();
    if ((0, $9gKM3.SignerError).isSignerError(obj)) {
        const t = obj.getErrorDetail();
        return {
            extraMessage: t.message,
            extraMessageDetail: t.detail,
            extraMessageErrorCode: t.code
        };
    }
    if (obj instanceof Error) return {
        extraMessage: obj.toString(),
        extraMessageErrorCode: null
    };
    if (typeof obj !== 'string') return {
        extraMessage: JSON.stringify(obj),
        extraMessageErrorCode: null
    };
    return {
        extraMessage: obj,
        extraMessageErrorCode: null
    };
};


var $671edadeda3a0e7c$export$bb45678bd9ad9127 = /*#__PURE__*/ function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
    return MessageSeverity;
}({});
const $671edadeda3a0e7c$export$7da8f4a451ab824d = (swap, step)=>{
    try {
        return $671edadeda3a0e7c$export$8f95be1c56c514cf(swap, step);
    } catch  {
        return null;
    }
};
const $671edadeda3a0e7c$export$8f95be1c56c514cf = (swap, step)=>{
    const evmNetwork = step.evmTransaction?.blockChain || step.evmApprovalTransaction?.blockChain;
    const starknetNetwork = step.starknetTransaction?.blockChain || step.starknetApprovalTransaction?.blockChain;
    const tronNetwork = step.tronTransaction?.blockChain || step.tronApprovalTransaction?.blockChain;
    const cosmosNetwork = step.cosmosTransaction?.blockChain;
    const solanaNetwork = step.solanaTransaction?.blockChain;
    const tonNetwork = step.tonTransaction?.blockChain;
    const suiNetwork = step.suiTransaction?.blockChain;
    const xrplNetwork = step.xrplTransaction?.blockChain;
    const stellarNetwork = step.stellarTransaction?.blockChain;
    if (evmNetwork) return {
        namespace: 'EVM',
        network: evmNetwork
    };
    else if (starknetNetwork) return {
        namespace: 'Starknet',
        network: starknetNetwork
    };
    else if (tronNetwork) return {
        namespace: 'Tron',
        network: tronNetwork
    };
    else if (cosmosNetwork) return {
        namespace: 'Cosmos',
        network: cosmosNetwork
    };
    else if (solanaNetwork) return {
        namespace: 'Solana',
        network: solanaNetwork
    };
    else if (tonNetwork) return {
        namespace: 'Ton',
        network: tonNetwork
    };
    else if (suiNetwork) return {
        namespace: 'Sui',
        network: suiNetwork
    };
    else if (xrplNetwork) return {
        namespace: 'XRPL',
        network: xrplNetwork
    };
    else if (stellarNetwork) return {
        namespace: 'Stellar',
        network: stellarNetwork
    };
    else if (!!step.transferTransaction) {
        const transferAddress = step.transferTransaction.fromWalletAddress;
        if (!transferAddress) throw (0, $e8937742787bc347$export$89427b94e5b39218).BlockchainMissing();
        const utxoNetwork = Object.keys(swap.wallets).find((network)=>swap.wallets[network]?.address === transferAddress);
        if (!utxoNetwork) throw (0, $e8937742787bc347$export$89427b94e5b39218).BlockchainMissing();
        return {
            namespace: 'UTXO',
            network: utxoNetwork
        };
    }
    throw new Error('Unsupported transaction type has been included in your swap.', {
        cause: step
    });
};
const $671edadeda3a0e7c$export$1dc40019f7ea36bf = (txHash, network, blockchainMetaMap)=>{
    const blockchainMeta = blockchainMetaMap[network];
    const baseUrl = blockchainMeta.info?.transactionUrl;
    if (!baseUrl) return;
    if (baseUrl.indexOf('/{txHash}') !== -1) return baseUrl.replace('{txHash}', txHash);
    return `${baseUrl}/${txHash}`;
};
function $671edadeda3a0e7c$export$b6b54d9bbb742a92(swap, currentStep) {
    return swap.steps.find((step)=>step.status !== 'failed' && step.status !== 'success' && step.id !== currentStep.id) || null;
}
const $671edadeda3a0e7c$export$f0323cedfa58d4dc = (swap, step)=>{
    const result = swap.wallets[step.evmTransaction?.blockChain || ''] || swap.wallets[step.evmApprovalTransaction?.blockChain || ''] || swap.wallets[step.tronTransaction?.blockChain || ''] || swap.wallets[step.tronApprovalTransaction?.blockChain || ''] || swap.wallets[step.starknetTransaction?.blockChain || ''] || swap.wallets[step.starknetApprovalTransaction?.blockChain || ''] || swap.wallets[step.cosmosTransaction?.blockChain || ''] || swap.wallets[step.solanaTransaction?.blockChain || ''] || swap.wallets[step.tonTransaction?.blockChain || ''] || swap.wallets[step.suiTransaction?.blockChain || ''] || swap.wallets[step.xrplTransaction?.blockChain || ''] || swap.wallets[step.stellarTransaction?.blockChain || ''] || (step.transferTransaction?.fromWalletAddress ? {
        address: step.transferTransaction.fromWalletAddress,
        walletType: Object.values(swap.wallets).find((wallet)=>wallet.address === step.transferTransaction?.fromWalletAddress)?.walletType
    } : null) || null;
    if (result == null) throw (0, $e8937742787bc347$export$89427b94e5b39218).WalletMissing();
    return result;
};
const $671edadeda3a0e7c$export$336d89edaa0d6235 = (swap, step)=>{
    return $671edadeda3a0e7c$export$f0323cedfa58d4dc(swap, step).address;
};
function $671edadeda3a0e7c$export$f9842af9f6c21d6d(swap, currentStep) {
    const { address: address, walletType: type } = $671edadeda3a0e7c$export$f0323cedfa58d4dc(swap, currentStep);
    const walletKV = Object.keys(swap.wallets).map((k)=>({
            k: k,
            v: swap.wallets[k]
        })).find(({ v: v })=>v.address === address && v.walletType === type) || null;
    const blockchain = walletKV?.k || null;
    const wallet = walletKV?.v || null;
    const walletType = wallet?.walletType;
    if (wallet === null) throw (0, $e8937742787bc347$export$89427b94e5b39218).AssertionFailed(`Wallet for source ${blockchain} not passed: walletType: ${walletType}`);
    return wallet;
}
function $671edadeda3a0e7c$export$5be79e3cb2436f0b(swap, currentStep) {
    if (!currentStep) return null;
    try {
        return $671edadeda3a0e7c$export$f9842af9f6c21d6d(swap, currentStep);
    } catch (e) {
        console.log({
            e: e
        });
        return null;
    }
}
const $671edadeda3a0e7c$export$6d86cb5a06ea37cc = (blockchain, symbol, address, allTokens)=>{
    const token = allTokens?.find((t)=>t.blockchain === blockchain && t.symbol?.toUpperCase() === symbol?.toUpperCase() && t.address === address);
    return token?.usdPrice || null;
};
function $671edadeda3a0e7c$export$acbec34e083696b5(step, allTokens) {
    let totalFeeInUsd = new (0, $iOQO2.default)(0);
    for(let i = 0; i < step.fee.length; i++){
        const fee = step.fee[i];
        if (fee.expenseType === 'DECREASE_FROM_OUTPUT') continue;
        const unitPrice = $671edadeda3a0e7c$export$6d86cb5a06ea37cc(fee.asset.blockchain, fee.asset.symbol, fee.asset.address, allTokens);
        totalFeeInUsd = totalFeeInUsd.plus(new (0, $iOQO2.default)(fee.amount).multipliedBy(unitPrice || 0));
    }
    return totalFeeInUsd;
}
function $671edadeda3a0e7c$var$mapSwapStepToPendingSwapStep(swap, meta) {
    return {
        // from
        fromBlockchain: swap.from.blockchain,
        fromBlockchainLogo: swap.from.blockchainLogo,
        fromLogo: swap.from.logo,
        fromSymbol: swap.from.symbol,
        fromSymbolAddress: swap.from.address,
        fromDecimals: swap.from.decimals,
        fromAmountPrecision: swap.fromAmountPrecision,
        fromAmountMinValue: swap.fromAmountMinValue,
        fromAmountMaxValue: swap.fromAmountMaxValue,
        fromAmountRestrictionType: swap.fromAmountRestrictionType,
        fromUsdPrice: swap.from.usdPrice,
        // to
        toBlockchain: swap.to.blockchain,
        toBlockchainLogo: swap.to.blockchainLogo,
        toSymbol: swap.to.symbol,
        toSymbolAddress: swap.to.address,
        toDecimals: swap.to.decimals,
        toLogo: swap.to.logo,
        toUsdPrice: swap.to.usdPrice,
        // swapper
        swapperId: swap.swapperId,
        swapperLogo: swap.swapperLogo,
        swapperType: swap.swapperType,
        // route
        expectedOutputAmountHumanReadable: swap.toAmount,
        feeInUsd: meta ? (0, $a34ccf87ef4fdc6c$export$f67be9d9b0e25d7b)($671edadeda3a0e7c$export$acbec34e083696b5(swap, meta?.tokens), null, 8) : null,
        estimatedTimeInSeconds: swap.estimatedTimeInSeconds || null,
        internalSteps: null
    };
}
function $671edadeda3a0e7c$export$dc09743a86365433(params) {
    const { inputAmount: inputAmount, bestRoute: bestRoute, wallets: wallets, settings: settings, validateBalanceOrFee: validateBalanceOrFee, meta: meta, swapMode: swapMode = 'swap' } = params;
    const simulationResult = bestRoute.result;
    if (!simulationResult) throw Error('Simulation result should not be null');
    return {
        creationTime: new Date().getTime().toString(),
        finishTime: null,
        requestId: bestRoute.requestId || '',
        inputAmount: inputAmount,
        wallets: wallets,
        status: 'running',
        mode: swapMode,
        isPaused: false,
        extraMessage: null,
        extraMessageSeverity: null,
        extraMessageDetail: null,
        extraMessageErrorCode: null,
        networkStatusExtraMessage: null,
        networkStatusExtraMessageDetail: null,
        lastNotificationTime: null,
        settings: settings,
        simulationResult: simulationResult,
        validateBalanceOrFee: validateBalanceOrFee,
        steps: bestRoute.result?.swaps?.map((swap, index)=>{
            const stepRoute = $671edadeda3a0e7c$var$mapSwapStepToPendingSwapStep(swap, meta);
            return {
                id: index + 1,
                // route
                ...stepRoute,
                internalSwaps: swap?.internalSwaps?.map((internalSwap)=>{
                    const stepRoute = $671edadeda3a0e7c$var$mapSwapStepToPendingSwapStep(internalSwap, meta);
                    return stepRoute;
                }) || null,
                // status, tracking
                outputAmount: '',
                prerequisiteResults: [],
                status: 'created',
                networkStatus: null,
                startTransactionTime: new Date().getTime(),
                externalTransactionId: null,
                executedTransactionId: null,
                executedTransactionTime: null,
                explorerUrl: null,
                diagnosisUrl: null,
                trackingCode: null,
                internalSteps: null,
                // transactions
                evmTransaction: null,
                evmApprovalTransaction: null,
                starknetTransaction: null,
                starknetApprovalTransaction: null,
                tronTransaction: null,
                tronApprovalTransaction: null,
                cosmosTransaction: null,
                solanaTransaction: null,
                transferTransaction: null,
                tonTransaction: null,
                suiTransaction: null,
                xrplTransaction: null,
                stellarTransaction: null,
                hyperliquidTransaction: null,
                // front fields
                hasAlreadyProceededToSign: false
            };
        }) || []
    };
}



function $8c4a8d1a062db6d2$var$createSteps(swapSteps) {
    return swapSteps.map((swapStep)=>{
        const { diagnosisUrl: diagnosisUrl, estimatedTimeInSeconds: estimatedTimeInSeconds, explorerUrl: explorerUrl, feeInUsd: feeInUsd, executedTransactionId: executedTransactionId, executedTransactionTime: executedTransactionTime, expectedOutputAmountHumanReadable: expectedOutputAmountHumanReadable, fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, fromSymbol: fromSymbol, toSymbol: toSymbol, fromSymbolAddress: fromSymbolAddress, toSymbolAddress: toSymbolAddress, swapperType: swapperType, swapperId: swapperId, outputAmount: outputAmount, fromAmountMaxValue: fromAmountMaxValue, fromAmountMinValue: fromAmountMinValue, fromAmountPrecision: fromAmountPrecision, fromAmountRestrictionType: fromAmountRestrictionType, fromDecimals: fromDecimals, status: stepStatus } = swapStep;
        const step = {
            diagnosisUrl: diagnosisUrl,
            estimatedTimeInSeconds: estimatedTimeInSeconds,
            explorerUrl: explorerUrl,
            feeInUsd: feeInUsd,
            executedTransactionId: executedTransactionId,
            executedTransactionTime: executedTransactionTime,
            expectedOutputAmountHumanReadable: expectedOutputAmountHumanReadable,
            fromBlockchain: fromBlockchain,
            toBlockchain: toBlockchain,
            fromSymbol: fromSymbol,
            toSymbol: toSymbol,
            fromSymbolAddress: fromSymbolAddress,
            toSymbolAddress: toSymbolAddress,
            swapperName: swapperId,
            swapperType: swapperType,
            outputAmount: outputAmount,
            fromAmountMaxValue: fromAmountMaxValue,
            fromAmountMinValue: fromAmountMinValue,
            fromAmountPrecision: fromAmountPrecision,
            fromAmountRestrictionType: fromAmountRestrictionType,
            fromDecimals: fromDecimals,
            status: stepStatus,
            transaction: (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(swapStep)
        };
        return step;
    });
}
function $8c4a8d1a062db6d2$var$getEventPayload(swap, type, swapStep) {
    const { creationTime: creationTime, finishTime: finishTime, requestId: requestId, inputAmount: inputAmount, status: status, wallets: wallets, steps: steps, settings: settings } = swap;
    const routeSteps = $8c4a8d1a062db6d2$var$createSteps(steps);
    const route = {
        creationTime: creationTime,
        finishTime: finishTime,
        requestId: requestId,
        inputAmount: inputAmount,
        status: status,
        wallets: wallets,
        steps: routeSteps,
        slippage: settings.slippage,
        infiniteApproval: settings.infiniteApprove
    };
    const result = {
        route: route,
        step: routeSteps[routeSteps.length - 1]
    };
    if (swapStep) result.step = $8c4a8d1a062db6d2$var$createSteps([
        swapStep
    ])[0];
    else if (type === 'failed') {
        const failedStep = (0, $fe4c6e12ce942e12$export$2574a36ee57e8565)(routeSteps);
        if (failedStep) result.step = failedStep;
    } else {
        const lastSuccessfulStep = (0, $fe4c6e12ce942e12$export$ce182e0a92d996da)(routeSteps);
        if (lastSuccessfulStep) result.step = lastSuccessfulStep;
    }
    return result;
}
function $8c4a8d1a062db6d2$var$emitRouteEvent(stepEvent, route, swap) {
    let routeEvent;
    const { type: type } = stepEvent;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(type){
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED:
            routeEvent = {
                ...stepEvent,
                type: (0, $4a641b36af06aafc$export$543d0a6c7f452841).STARTED
            };
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED:
            routeEvent = {
                ...stepEvent,
                type: (0, $4a641b36af06aafc$export$543d0a6c7f452841).FAILED,
                inputAmount: swap.inputAmount,
                inputAmountUsd: (0, $fe4c6e12ce942e12$export$2d4003599601ab3f)(swap),
                swapMode: swap.mode || 'swap'
            };
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED:
            routeEvent = {
                ...stepEvent,
                type: (0, $4a641b36af06aafc$export$543d0a6c7f452841).SUCCEEDED,
                inputAmount: swap.inputAmount,
                inputAmountUsd: (0, $fe4c6e12ce942e12$export$2d4003599601ab3f)(swap),
                outputAmount: swap.steps[swap.steps.length - 1].outputAmount ?? '',
                outputAmountUsd: (0, $fe4c6e12ce942e12$export$f2123948d3527ee5)(swap),
                swapMode: swap.mode || 'swap'
            };
            break;
        default:
            break;
    }
    if (routeEvent) {
        const eventEmitter = (0, $86a9fd6e2401871c$export$44487a86467333c3)('emitter');
        eventEmitter?.emit((0, $4a641b36af06aafc$export$54f5f69c1651567f).RouteEvent, {
            event: routeEvent,
            route: route
        });
    }
}
function $8c4a8d1a062db6d2$var$emitStepEvent(stepEvent, route, step) {
    const eventEmitter = (0, $86a9fd6e2401871c$export$44487a86467333c3)('emitter');
    eventEmitter?.emit((0, $4a641b36af06aafc$export$54f5f69c1651567f).StepEvent, {
        event: stepEvent,
        route: route,
        step: step
    });
}
function $8c4a8d1a062db6d2$export$95858563cfce6cd6(params) {
    const { event: event } = params;
    const { type: type } = event;
    const { route: route, step: step } = $8c4a8d1a062db6d2$var$getEventPayload(params.swap, type, params.step ?? undefined);
    const fromAsset = `${step.fromBlockchain}.${step.fromSymbol}`;
    const toAsset = `${step.toBlockchain}.${step.toSymbol}`;
    const outputAmount = step.outputAmount ?? '';
    const currentFromNamespace = !!params.step ? (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(params.swap, params.step) : null;
    let message = '';
    let messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
    switch(type){
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED:
            message = 'Swap process started';
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED:
            message = `You received ${outputAmount} ${toAsset}, hooray!`;
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED:
            message = `Swap failed: ${params.swap?.extraMessage ?? 'Reason is unknown'}`;
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).ERROR;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION:
            if (event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).CREATE_TX) {
                message = 'Please wait while the transaction is created ...';
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
            } else if (event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).SEND_TX) {
                if (params.step && (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(params.step)) message = `Please confirm '${step.swapperName}' smart contract access to ${fromAsset}`;
                else message = 'Please confirm transaction request in your wallet';
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).TX_SENT) {
                message = 'Transaction sent successfully';
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
            }
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS:
            if (params.step && (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(params.step)) message = 'Checking approve transaction status ...';
            else message = 'Checking transaction status ...';
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).APPROVAL_TX_SUCCEEDED:
            message = 'Smart contract called successfully';
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).OUTPUT_REVEALED:
            message = 'Transaction output amount revealed';
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED:
            if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT) {
                message = 'Please connect your wallet.';
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE) {
                message = 'Waiting for other swaps to complete';
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_CHANGE_WALLET_ACCOUNT) {
                message = 'Please change your wallet account.';
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE) {
                message = `Please change your wallet network to ${currentFromNamespace?.network}.`;
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            }
            break;
        default:
            break;
    }
    if (params.step) $8c4a8d1a062db6d2$var$emitStepEvent({
        ...event,
        message: message,
        messageSeverity: messageSeverity
    }, route, step);
    if (params.event.type === (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED || !params.step) $8c4a8d1a062db6d2$var$emitRouteEvent({
        ...event,
        message: message,
        messageSeverity: messageSeverity
    }, route, params.swap);
}





let $fe4c6e12ce942e12$var$swapClaimedBy = null;
function $fe4c6e12ce942e12$export$269a5aa1e1356b04() {
    return {
        claimedBy: ()=>$fe4c6e12ce942e12$var$swapClaimedBy?.id,
        setClaimer: (queue_id)=>{
            $fe4c6e12ce942e12$var$swapClaimedBy = {
                id: queue_id
            };
        },
        reset: ()=>{
            $fe4c6e12ce942e12$var$swapClaimedBy = null;
        }
    };
}
const $fe4c6e12ce942e12$var$swapTransactionToDataMap = {};
function $fe4c6e12ce942e12$export$156145f76a656206() {
    return {
        getTransactionDataByHash: (hash)=>$fe4c6e12ce942e12$var$swapTransactionToDataMap[hash] || {},
        setTransactionDataByHash: (hash, data)=>{
            const r = $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash];
            if (!r) $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash] = {};
            $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].response = data.response || $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].response;
            $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].receiptReceived = data.receiptReceived || $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].receiptReceived || false;
        }
    };
}
const $fe4c6e12ce942e12$export$613fded3c60df0c1 = (swap)=>{
    return swap.steps.find((step)=>step.status !== 'failed' && step.status !== 'success') || null;
};
const $fe4c6e12ce942e12$export$e0828339165e66a2 = (currentStep)=>{
    const { evmTransaction: evmTransaction, evmApprovalTransaction: evmApprovalTransaction, cosmosTransaction: cosmosTransaction, solanaTransaction: solanaTransaction, transferTransaction: transferTransaction, starknetApprovalTransaction: starknetApprovalTransaction, starknetTransaction: starknetTransaction, stellarTransaction: stellarTransaction, tronApprovalTransaction: tronApprovalTransaction, tronTransaction: tronTransaction, tonTransaction: tonTransaction, suiTransaction: suiTransaction, xrplTransaction: xrplTransaction } = currentStep;
    return evmTransaction || evmApprovalTransaction || cosmosTransaction || solanaTransaction || transferTransaction || starknetApprovalTransaction || starknetTransaction || stellarTransaction || tronApprovalTransaction || tronTransaction || tonTransaction || suiTransaction || xrplTransaction;
};
const $fe4c6e12ce942e12$export$6b6ed2f9ae969f2d = (currentStep, transaction)=>{
    currentStep.transferTransaction = null;
    currentStep.cosmosTransaction = null;
    currentStep.evmTransaction = null;
    currentStep.solanaTransaction = null;
    currentStep.evmApprovalTransaction = null;
    currentStep.starknetApprovalTransaction = null;
    currentStep.starknetTransaction = null;
    currentStep.tronApprovalTransaction = null;
    currentStep.tronTransaction = null;
    currentStep.tonTransaction = null;
    currentStep.suiTransaction = null;
    currentStep.xrplTransaction = null;
    currentStep.stellarTransaction = null;
    const txType = transaction.type;
    switch(txType){
        case (0, $9B1kL.TransactionType).EVM:
            if (transaction.isApprovalTx) currentStep.evmApprovalTransaction = transaction;
            else currentStep.evmTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).TRON:
            if (transaction.isApprovalTx) currentStep.tronApprovalTransaction = transaction;
            else currentStep.tronTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).STARKNET:
            if (transaction.isApprovalTx) currentStep.starknetApprovalTransaction = transaction;
            else currentStep.starknetTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).COSMOS:
            currentStep.cosmosTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).SOLANA:
            currentStep.solanaTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).TRANSFER:
            currentStep.transferTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).TON:
            currentStep.tonTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).SUI:
            currentStep.suiTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).XRPL:
            currentStep.xrplTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).STELLAR:
            currentStep.stellarTransaction = transaction;
            break;
        case (0, $9B1kL.TransactionType).HYPERLIQUID:
            currentStep.hyperliquidTransaction = transaction;
            break;
        default:
            ((x)=>{
                throw new Error(`${x} was unhandled!`);
            })(txType);
    }
    return currentStep;
};
const $fe4c6e12ce942e12$export$e959b2e816f5278e = (currentStep)=>{
    return $fe4c6e12ce942e12$export$e0828339165e66a2(currentStep)?.type;
};
const $fe4c6e12ce942e12$export$b9926026bbb60802 = (currentStep)=>{
    const { evmApprovalTransaction: evmApprovalTransaction, starknetApprovalTransaction: starknetApprovalTransaction, tronApprovalTransaction: tronApprovalTransaction } = currentStep;
    return !!(evmApprovalTransaction || starknetApprovalTransaction || tronApprovalTransaction);
};
function $fe4c6e12ce942e12$export$4ed458d278ce509a({ getStorage: getStorage, setStorage: setStorage, nextStatus: nextStatus, nextStepStatus: nextStepStatus, message: message, details: details, errorCode: errorCode = null, hasAlreadyProceededToSign: hasAlreadyProceededToSign, trace: trace = null }) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const updatedResult = {
        swap: swap,
        step: currentStep
    };
    if (!!nextStepStatus && !!currentStep) currentStep.status = nextStepStatus;
    if (nextStatus) swap.status = nextStatus;
    swap.hasAlreadyProceededToSign = hasAlreadyProceededToSign;
    if (!!nextStatus && [
        'failed',
        'success'
    ].includes(nextStatus)) swap.finishTime = new Date().getTime().toString();
    if (!!message || !!details) {
        swap.extraMessage = message || '';
        swap.extraMessageDetail = details || '';
    }
    if (!!nextStepStatus && [
        'failed'
    ].includes(nextStepStatus)) {
        //if user cancel the swap, we should pass relevant reason to the server.
        const errorReason = details && details.includes('Warning') ? 'Swap canceled by user.' : details;
        const walletType = (0, $671edadeda3a0e7c$export$5be79e3cb2436f0b)(swap, currentStep)?.walletType;
        swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).error;
        const failureType = (0, $e8937742787bc347$export$6de13c9ec5bf007b)(errorCode);
        updatedResult.failureType = failureType;
        // If trace of error was available, we will send it to the api (except user rejection)
        const errorReasonForAPI = errorCode !== 'REJECTED_BY_USER' && trace?.message && typeof trace.message === 'string' ? trace.message : errorReason || '';
        (0, $e48877d26b43b539$export$c1b2b945bea31d71)().reportFailure({
            requestId: swap.requestId,
            step: currentStep?.id || 1,
            eventType: failureType,
            reason: errorReasonForAPI,
            tags: walletType ? {
                wallet: walletType
            } : undefined
        }).then().catch();
    } else if (!!nextStepStatus && [
        'running'
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).info;
    else if (!!nextStepStatus && [
        'success',
        'approved'
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).success;
    else if (nextStepStatus && [
        'waitingForApproval'
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).warning;
    if (nextStepStatus === 'running' && currentStep) currentStep.startTransactionTime = new Date().getTime();
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return updatedResult;
}
function $fe4c6e12ce942e12$export$d2255bf7fdde61bf({ getStorage: getStorage, setStorage: setStorage }, txId, explorerUrl) {
    const swap = getStorage().swapDetails;
    swap.hasAlreadyProceededToSign = null;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    currentStep.executedTransactionId = txId;
    currentStep.executedTransactionTime = new Date().getTime().toString();
    if (explorerUrl?.url) currentStep.explorerUrl = [
        ...currentStep.explorerUrl || [],
        {
            url: explorerUrl.url,
            description: explorerUrl.description || null
        }
    ];
    const isApproval = $fe4c6e12ce942e12$export$b9926026bbb60802(currentStep);
    if (isApproval) swap.extraMessage = 'Checking approve transaction status ...';
    else swap.extraMessage = 'Checking transaction status ...';
    swap.extraMessageDetail = '';
    swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).info;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION,
            status: (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).TX_SENT
        },
        swap: swap,
        step: currentStep
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS
        },
        swap: swap,
        step: currentStep
    });
}
function $fe4c6e12ce942e12$export$79aac2cf09acb365({ getStorage: getStorage, setStorage: setStorage }, reason, reasonDetail) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    const currentTime = new Date();
    swap.lastNotificationTime = currentTime.getTime().toString();
    const isAlreadyMarked = currentStep.networkStatus === (0, $k5IP8.PendingSwapNetworkStatus).WaitingForConnectingWallet && swap.networkStatusExtraMessage === reason && swap.networkStatusExtraMessageDetail === reasonDetail;
    if (isAlreadyMarked) return;
    currentStep.networkStatus = (0, $k5IP8.PendingSwapNetworkStatus).WaitingForConnectingWallet;
    swap.networkStatusExtraMessage = reason;
    swap.networkStatusExtraMessageDetail = reasonDetail;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
}
function $fe4c6e12ce942e12$export$ef6de5a7a1eb84b5({ getStorage: getStorage, setStorage: setStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    // Generate message
    const { type: type } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
    const fromNamespace = (0, $671edadeda3a0e7c$export$8f95be1c56c514cf)(swap, currentStep);
    const reason = `Change ${type} wallet network to ${fromNamespace.network}`;
    const reasonDetail = `We\u{2019}re switching the connected network to ${fromNamespace.network}. Please check your wallet.`;
    const currentTime = new Date();
    swap.lastNotificationTime = currentTime.getTime().toString();
    currentStep.networkStatus = (0, $k5IP8.PendingSwapNetworkStatus).WaitingForNetworkChange;
    swap.networkStatusExtraMessage = reason;
    swap.networkStatusExtraMessageDetail = reasonDetail;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return {
        swap: swap,
        step: currentStep
    };
}
function $fe4c6e12ce942e12$export$13dec43429df168f({ getStorage: getStorage, setStorage: setStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    swap.networkStatusExtraMessage = '';
    swap.networkStatusExtraMessageDetail = '';
    currentStep.networkStatus = (0, $k5IP8.PendingSwapNetworkStatus).WaitingForQueue;
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
            status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE
        },
        swap: swap,
        step: currentStep
    });
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return {
        swap: swap,
        step: currentStep
    };
}
async function $fe4c6e12ce942e12$export$1391212d75b2ee65(ms) {
    return new Promise((res)=>setTimeout(res, ms));
}
const $fe4c6e12ce942e12$export$bb807b0a6bc347f5 = (swap, network)=>{
    return swap.wallets[network]?.walletType;
};
function $fe4c6e12ce942e12$export$a07d9470285db41(wallet) {
    return wallet === null || wallet?.blockchains === null || wallet?.blockchains.length === 0;
}
function $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap) {
    const step = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const currentNamespace = (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(swap, step);
    if (!currentNamespace) return {
        type: null,
        namespace: null,
        address: null
    };
    const walletType = $fe4c6e12ce942e12$export$bb807b0a6bc347f5(swap, currentNamespace.network);
    const sourceWallet = swap.wallets[currentNamespace.network];
    return {
        type: walletType || null,
        namespace: currentNamespace,
        address: sourceWallet ? sourceWallet.address : null
    };
}
/**
 * On EVM compatible wallets, There is one instance with different chains (like Polygon)
 * To get the chain from instance we will use this function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
async function $fe4c6e12ce942e12$var$getChainId(provider) {
    try {
        const chainId = await provider.request({
            method: 'eth_chainId'
        }) || provider?.chainId;
        return chainId;
    } catch  {
        return provider?.chainId;
    }
}
async function $fe4c6e12ce942e12$export$886b500b18d761c(providers, hubProvider, walletType) {
    const legacyProvider = (0, $gSYt0.getEvmProvider)(providers, walletType);
    if (legacyProvider) {
        const chainId = await $fe4c6e12ce942e12$var$getChainId(legacyProvider);
        return chainId;
    }
    // Legacy provider was not found, try to get the chain id from hub provider.
    const provider = hubProvider(walletType);
    const evmNamespace = provider.get('evm');
    if (!evmNamespace) throw new Error('EVM namespace not found for wallet type: ' + walletType);
    const chainId = evmNamespace.getChainId();
    return chainId;
}
async function $fe4c6e12ce942e12$export$e51ad0ccc6210c75(swap, step, wallet, meta, providers, hubProvider) {
    if ($fe4c6e12ce942e12$export$a07d9470285db41(wallet)) return false;
    const fromNamespace = (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(swap, step);
    if (!fromNamespace) return false;
    if (meta.evmBasedChains.find((evmBlochain)=>evmBlochain.name === fromNamespace.network)) {
        try {
            const sourceWallet = swap.wallets[fromNamespace.network];
            if (sourceWallet) {
                const chainId = await $fe4c6e12ce942e12$export$886b500b18d761c(providers, hubProvider, sourceWallet.walletType);
                if (chainId) {
                    const blockChain = (0, $9HEDW.legacyGetBlockChainNameFromId)(chainId, Object.entries(meta.blockchains).map(([, blockchainMeta])=>blockchainMeta));
                    if (blockChain && blockChain.toLowerCase() === fromNamespace.network.toLowerCase()) return true;
                    if (blockChain && blockChain.toLowerCase() !== fromNamespace.network.toLowerCase()) return false;
                }
            }
        } catch (e) {
            console.log(e);
        }
        return false;
    }
    return true;
}
const $fe4c6e12ce942e12$export$9f101a08b811faba = (swap, step)=>{
    const result = swap.wallets[step.evmTransaction?.blockChain || ''] || swap.wallets[step.evmApprovalTransaction?.blockChain || ''] || swap.wallets[step.tronTransaction?.blockChain || ''] || swap.wallets[step.tronApprovalTransaction?.blockChain || ''] || swap.wallets[step.starknetTransaction?.blockChain || ''] || swap.wallets[step.starknetApprovalTransaction?.blockChain || ''] || swap.wallets[step.cosmosTransaction?.blockChain || ''] || swap.wallets[step.solanaTransaction?.blockChain || ''] || swap.wallets[step.tonTransaction?.blockChain || ''] || swap.wallets[step.suiTransaction?.blockChain || ''] || swap.wallets[step.stellarTransaction?.blockChain || ''] || swap.wallets[step.xrplTransaction?.blockChain || ''] || step.transferTransaction?.fromWalletAddress || null;
    return result !== null;
};
function $fe4c6e12ce942e12$export$84ffc71d1c4cf1c1(actions) {
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (currentStep?.networkStatus) {
        currentStep.networkStatus = null;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
    }
}
function $fe4c6e12ce942e12$export$92b8d849bafb537c(actions, data = {
    message: '',
    details: '',
    status: null
}) {
    const { message: message, details: details, status: status } = data;
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (currentStep?.networkStatus) {
        swap.networkStatusExtraMessage = message;
        swap.networkStatusExtraMessageDetail = details;
        currentStep.networkStatus = status;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
    }
}
function $fe4c6e12ce942e12$export$c29c9a248811e0a7(event, meta) {
    const { context: context, queue: queue } = meta;
    const swap = queue.getStorage().swapDetails;
    const { ok: ok, reason: reason } = $fe4c6e12ce942e12$export$ba15f3931e3e12e6(swap, context.state);
    if (!ok) {
        const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
        const { type: walletType, address: address } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
                ...reason === 'account_miss_match' ? {
                    status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_CHANGE_WALLET_ACCOUNT,
                    requiredAccount: address ?? undefined
                } : {
                    status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT,
                    requiredWallet: walletType ?? undefined,
                    requiredAccount: address ?? undefined
                }
            },
            swap: swap,
            step: currentStep
        });
        $fe4c6e12ce942e12$export$79aac2cf09acb365({
            getStorage: queue.getStorage.bind(queue),
            setStorage: queue.setStorage.bind(queue)
        }, (0, $d96636b74cb7ca13$export$d6102d677d637a6d), event.reason.description);
        return;
    }
    queue.unblock();
}
function $fe4c6e12ce942e12$export$15bd368e2f15ea8b(_event, meta) {
    const { context: context, queue: queue } = meta;
    const swap = queue.getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep || swap.status !== 'running') return;
    const result = $fe4c6e12ce942e12$export$ef6de5a7a1eb84b5({
        getStorage: queue.getStorage.bind(queue),
        setStorage: queue.setStorage.bind(queue)
    });
    const requiredNetwork = (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(swap, currentStep)?.network;
    const requiredWallet = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap).type;
    const currentNetwork = requiredWallet ? context.state(requiredWallet).network : undefined;
    if (result) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
            status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE,
            requiredNetwork: requiredNetwork ?? undefined,
            currentNetwork: currentNetwork ?? undefined
        },
        swap: result.swap,
        step: result.step
    });
    // Try to auto switch
    const { type: type, namespace: namespace } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
    if (!!type && !!namespace?.network) {
        if (context.canSwitchNetworkTo(type, namespace.network, namespace)) {
            const result = context.switchNetwork(type, namespace);
            if (result) result.then(()=>{
                queue.unblock();
            }).catch((error)=>{
                // Update network to mark it as network change failed.
                $fe4c6e12ce942e12$export$92b8d849bafb537c({
                    getStorage: queue.getStorage.bind(queue),
                    setStorage: queue.setStorage.bind(queue)
                }, {
                    message: error.message,
                    details: error.message,
                    status: (0, $k5IP8.PendingSwapNetworkStatus).NetworkChangeFailed
                });
            });
        }
    }
}
function $fe4c6e12ce942e12$export$63f1cfbd06c1a0f9(_event, meta) {
    const { getBlockedTasks: getBlockedTasks, forceExecute: forceExecute, queue: queue, manager: manager, context: context } = meta;
    const { setClaimer: setClaimer, claimedBy: claimedBy, reset: reset } = $fe4c6e12ce942e12$export$269a5aa1e1356b04();
    // We only needs those blocked tasks that have DEPENDS_ON_OTHER_QUEUES reason.
    const blockedTasks = getBlockedTasks().filter((task)=>task.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES);
    if (blockedTasks.length === 0) return;
    const claimerId = claimedBy();
    const isClaimedByAnyQueue = !!claimerId;
    if (claimerId === queue.id) return;
    // Check if any queue `claimed` before, if yes, we don't should do anything.
    if (isClaimedByAnyQueue) {
        // We need to keep the latest swap messages
        $fe4c6e12ce942e12$export$13dec43429df168f({
            getStorage: queue.getStorage.bind(queue),
            setStorage: queue.setStorage.bind(queue)
        });
        return;
    }
    // Prioritize current queue to be run first.
    let task = blockedTasks.find((task)=>{
        return task.queue_id === meta.queue_id;
    });
    // If current task isn't available anymore, fallback to first blocked task.
    if (!task) {
        const firstBlockedTask = blockedTasks[0];
        task = firstBlockedTask;
    }
    setClaimer(task.queue_id);
    const claimedStorage = task.storage.get();
    const { type: type, namespace: namespace, address: address } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(claimedStorage.swapDetails);
    // Run
    forceExecute(task.queue_id, {
        claimedBy: claimedBy(),
        resetClaimedBy: ()=>{
            reset();
            // TODO: Use key generator
            if (type) $fe4c6e12ce942e12$export$4ca8cf19c61b3860({
                walletType: type,
                network: namespace?.network,
                accounts: address ? [
                    address
                ] : []
            }, manager, context.canSwitchNetworkTo);
        }
    });
}
function $fe4c6e12ce942e12$export$ba15f3931e3e12e6(swap, getState) {
    const { type: type, address: address } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
    if (!type || !address) return {
        ok: false,
        reason: 'not_connected'
    };
    const walletState = getState(type);
    const { accounts: accounts, connected: connected } = walletState;
    const connectedAccounts = accounts || [];
    if (!connected) return {
        ok: false,
        reason: 'not_connected'
    };
    const matched = connectedAccounts.some((account)=>{
        const { address: accountAddress } = (0, $9HEDW.legacyReadAccountAddress)(account);
        return address.toLocaleLowerCase() === accountAddress.toLocaleLowerCase();
    });
    return {
        ok: matched,
        reason: 'account_miss_match'
    };
}
function $fe4c6e12ce942e12$export$f418268c692fe64f(actions, prerequisiteResult) {
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const index = currentStep.prerequisiteResults.findIndex((existing)=>(0, $4919c4b385f2331a$export$9168835764674a25)(existing, prerequisiteResult));
    if (index >= 0) currentStep.prerequisiteResults[index] = prerequisiteResult;
    else currentStep.prerequisiteResults.push(prerequisiteResult);
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
}
function $fe4c6e12ce942e12$export$8d786d6c8b37fd4(actions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
signResult, data) {
    const { setTransactionDataByHash: setTransactionDataByHash } = $fe4c6e12ce942e12$export$156145f76a656206();
    const { getStorage: getStorage, context: context } = actions;
    const { meta: meta } = context;
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const currentStepNamespace = (0, $671edadeda3a0e7c$export$8f95be1c56c514cf)(swap, currentStep);
    const explorerUrl = (0, $671edadeda3a0e7c$export$1dc40019f7ea36bf)(signResult.hash, currentStepNamespace.network, meta.blockchains);
    $fe4c6e12ce942e12$export$d2255bf7fdde61bf(actions, signResult.hash, explorerUrl && (!signResult.response || signResult.response && !signResult.response.hashRequiringUpdate) ? {
        url: explorerUrl,
        description: data.isApproval ? 'Approve' : 'Swap'
    } : undefined);
    // response used for evm transactions to get receipt and track replaced
    if (signResult.response) setTransactionDataByHash(signResult.hash, {
        response: signResult.response
    });
}
function $fe4c6e12ce942e12$export$793b8a12247c3aee(actions, data) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ({ hash: hash, response: response })=>{
        const { schedule: schedule, next: next } = actions;
        $fe4c6e12ce942e12$export$8d786d6c8b37fd4(actions, {
            hash: hash,
            response: response
        }, data);
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS);
        next();
    };
}
function $fe4c6e12ce942e12$export$43684a9f4c55c7c3(actions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error)=>{
        const { getStorage: getStorage, setStorage: setStorage, failed: failed } = actions;
        const swap = getStorage().swapDetails;
        const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
        if (swap.status === 'failed') return;
        const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(error, {
            tags: {
                requestId: swap.requestId,
                rpc: true,
                swapper: currentStep?.swapperId || '',
                walletType: sourceWallet?.walletType || ''
            },
            context: (0, $9gKM3.SignerError).isSignerError(error) ? error.getErrorContext() : {}
        });
        const updateResult = $fe4c6e12ce942e12$export$4ed458d278ce509a({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode,
            trace: error?.cause
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
                inputAmount: $fe4c6e12ce942e12$export$70860efeae8a3a0e(swap),
                inputAmountUsd: $fe4c6e12ce942e12$export$4ad99a385f7fc2d6(swap)
            },
            ...updateResult
        });
        failed();
    };
}
function $fe4c6e12ce942e12$export$4855f2a4839078ef(params) {
    const { lastConnectedWallet: lastConnectedWallet, evmChains: evmChains, manager: manager } = params;
    const { walletType: wallet, network: network } = lastConnectedWallet;
    // We only need change network for EVM chains.
    if (!evmChains.some((chain)=>chain.name == network)) return;
    manager?.getAll().forEach((q)=>{
        const queueStorage = q.list.getStorage();
        const swap = queueStorage?.swapDetails;
        if (swap && swap.status === 'running') {
            const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
            if (currentStep) {
                const currentStepRequiredWallet = queueStorage?.swapDetails.wallets[currentStep.fromBlockchain]?.walletType;
                const hasWaitingForConnect = Object.keys(q.list.state.tasks).some((taskId)=>{
                    const task = q.list.state.tasks[taskId];
                    return task.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED && // TODO double check later
                    [
                        (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET
                    ].includes(task.blockedFor?.reason);
                });
                const requiredNetwork = (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(swap, currentStep)?.network;
                // We only need change network for EVM chains.
                if (!evmChains.some((chain)=>chain.name == requiredNetwork)) return;
                if (currentStepRequiredWallet === wallet && hasWaitingForConnect && requiredNetwork != network) {
                    const queueInstance = q.list;
                    const { type: type } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
                    const description = (0, $d96636b74cb7ca13$export$721abf6846856403)(type);
                    q.list.block({
                        reason: {
                            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
                            description: description
                        },
                        silent: true
                    });
                    const result = $fe4c6e12ce942e12$export$ef6de5a7a1eb84b5({
                        getStorage: queueInstance.getStorage.bind(queueInstance),
                        setStorage: queueInstance.setStorage.bind(queueInstance)
                    });
                    if (result) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
                        event: {
                            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
                            status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE,
                            currentNetwork: network,
                            requiredNetwork: requiredNetwork ?? undefined
                        },
                        swap: result.swap,
                        step: result.step
                    });
                }
            }
        }
    });
}
function $fe4c6e12ce942e12$export$d9db0ccdbfe08fc3(manager) {
    manager?.getAll().forEach((q)=>{
        const hasWaitingForNetwork = Object.keys(q.list.state.tasks).some((taskId)=>{
            const task = q.list.state.tasks[taskId];
            return task.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED && [
                (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
                (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES
            ].includes(task.blockedFor?.reason);
        });
        if (hasWaitingForNetwork) {
            const swap = q.list.getStorage()?.swapDetails;
            if (swap.status === 'running') {
                const { type: type } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
                const description = (0, $d96636b74cb7ca13$export$2f02fd340a90fed8)(type);
                // Change the block reason to waiting for connecting wallet
                q.list.block({
                    reason: {
                        reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
                        description: description
                    }
                });
            }
        }
    });
}
function $fe4c6e12ce942e12$export$fbf0d9b8906779ef(manager) {
    const queues = manager?.getAll() || new Map();
    const result = [];
    queues.forEach((q)=>{
        // retry only on affected queues
        const queueStorage = q.list.getStorage();
        const swap = queueStorage?.swapDetails;
        if (!swap || swap.status !== 'running') return;
        result.push(swap);
    });
    return result;
}
function $fe4c6e12ce942e12$export$31570cddaa6e4311(runningSwaps) {
    runningSwaps.forEach((swap)=>{
        const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
        const eventType = (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED;
        let eventSubtype;
        if (currentStep?.networkStatus === (0, $k5IP8.PendingSwapNetworkStatus).WaitingForQueue) eventSubtype = (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE;
        else if (swap?.status === 'running') eventSubtype = (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT;
        if (!!eventType && !!(0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: eventType,
                status: eventSubtype ?? (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE
            },
            swap: swap,
            step: currentStep
        });
    });
}
function $fe4c6e12ce942e12$export$4ca8cf19c61b3860(lastConnectedWallet, manager, canSwitchNetworkTo, options = {
    fallbackToOnlyWallet: true
}) {
    const { walletType: wallet, network: network } = lastConnectedWallet;
    if (!wallet) return;
    const walletAndNetworkMatched = [];
    const onlyWalletMatched = [];
    manager?.getAll().forEach((q)=>{
        // retry only on affected queues
        if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) {
            const queueStorage = q.list.getStorage();
            const swap = queueStorage?.swapDetails;
            if (swap && swap.status === 'running') {
                const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
                if (currentStep) {
                    if (network && (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(swap, currentStep)?.network == network && queueStorage?.swapDetails.wallets[network]?.walletType === wallet) walletAndNetworkMatched.push(q.list);
                    else if (queueStorage?.swapDetails.wallets[currentStep.fromBlockchain]?.walletType === wallet) onlyWalletMatched.push(q.list);
                }
            }
        }
    });
    let finalQueueToBeRun = undefined;
    if (walletAndNetworkMatched.length > 0) {
        finalQueueToBeRun = walletAndNetworkMatched[0];
        if (walletAndNetworkMatched.length > 1) for(let i = 1; i < walletAndNetworkMatched.length; i++){
            const currentQueue = walletAndNetworkMatched[i];
            $fe4c6e12ce942e12$export$13dec43429df168f({
                getStorage: currentQueue.getStorage.bind(currentQueue),
                setStorage: currentQueue.setStorage.bind(currentQueue)
            });
        }
    } else if (onlyWalletMatched.length > 0 && options.fallbackToOnlyWallet) finalQueueToBeRun = onlyWalletMatched[0];
    if (finalQueueToBeRun) {
        const finalQueueStorage = finalQueueToBeRun.getStorage();
        const currentSwap = $fe4c6e12ce942e12$export$613fded3c60df0c1(finalQueueStorage?.swapDetails);
        const currentNamespace = currentSwap ? (0, $671edadeda3a0e7c$export$7da8f4a451ab824d)(finalQueueStorage.swapDetails, currentSwap) : null;
        if (!network || !currentNamespace || !canSwitchNetworkTo?.(wallet, network, currentNamespace)) finalQueueToBeRun.unblock();
        else finalQueueToBeRun.checkBlock();
    }
}
function $fe4c6e12ce942e12$export$d31e98f8646bca08(step) {
    return !!step.evmTransaction || !!step.evmApprovalTransaction;
}
async function $fe4c6e12ce942e12$export$495b8adaeb8ab9b9(rawResponse) {
    const responseBody = await rawResponse;
    if (!responseBody.ok || !responseBody.transaction) throw (0, $e8937742787bc347$export$89427b94e5b39218).CreateTransaction(responseBody.error || 'bad response from create tx endpoint');
    return responseBody;
}
function $fe4c6e12ce942e12$export$c778f9ff5514f6d7(swap, manager) {
    const { reset: reset } = $fe4c6e12ce942e12$export$269a5aa1e1356b04();
    swap.actions.cancel();
    const updateResult = $fe4c6e12ce942e12$export$4ed458d278ce509a({
        getStorage: swap.actions.getStorage,
        setStorage: swap.actions.setStorage,
        message: 'Swap canceled by user.',
        details: "Warning: If you've already signed and sent a transaction, it won't be affected, but next swap steps will not be executed.",
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        errorCode: 'USER_CANCEL'
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
            reasonCode: 'USER_CANCEL',
            reason: updateResult.swap.extraMessage ?? undefined,
            inputAmount: $fe4c6e12ce942e12$export$70860efeae8a3a0e(updateResult.swap),
            inputAmountUsd: $fe4c6e12ce942e12$export$4ad99a385f7fc2d6(updateResult.swap)
        },
        swap: updateResult.swap,
        step: updateResult.step
    });
    reset();
    if (manager) manager?.retry();
    return updateResult;
}
function $fe4c6e12ce942e12$export$ce182e0a92d996da(steps) {
    return steps.slice().reverse().find((step)=>step.status === 'success');
}
function $fe4c6e12ce942e12$export$2574a36ee57e8565(steps) {
    return steps.slice().reverse().find((step)=>step.status === 'failed');
}
function $fe4c6e12ce942e12$export$5265eafbefe28577(step) {
    const { transaction: transaction } = step;
    const approvalTx = transaction?.type === (0, $9B1kL.TransactionType).EVM && transaction.isApprovalTx || transaction?.type === (0, $9B1kL.TransactionType).STARKNET && transaction.isApprovalTx || transaction?.type === (0, $9B1kL.TransactionType).TRON && transaction.isApprovalTx;
    return approvalTx;
}
function $fe4c6e12ce942e12$export$ab4672d656f03d3b(amount, usdPrice) {
    const usdValue = new (0, $iOQO2.default)(amount).multipliedBy(usdPrice);
    if (isNaN(usdValue.toNumber())) return '';
    return usdValue.toString();
}
function $fe4c6e12ce942e12$export$2d4003599601ab3f(swap) {
    return $fe4c6e12ce942e12$export$ab4672d656f03d3b(swap.inputAmount, swap.steps[0].fromUsdPrice ?? '');
}
function $fe4c6e12ce942e12$export$f2123948d3527ee5(swap) {
    const lastStep = swap.steps[swap.steps.length - 1];
    return $fe4c6e12ce942e12$export$ab4672d656f03d3b(lastStep.outputAmount ?? '', lastStep.toUsdPrice ?? '');
}
function $fe4c6e12ce942e12$export$4a476235428b9cf(swap) {
    const FINISHED_STATUS = [
        'success',
        'failed'
    ];
    const lastFinishedStepIndex = swap.steps.findLastIndex((step)=>FINISHED_STATUS.includes(step.status));
    return lastFinishedStepIndex < 0 ? undefined : {
        step: swap.steps[lastFinishedStepIndex],
        index: lastFinishedStepIndex
    };
}
function $fe4c6e12ce942e12$export$70860efeae8a3a0e(swap) {
    const lastFinishedStep = $fe4c6e12ce942e12$export$4a476235428b9cf(swap);
    if (!lastFinishedStep) return '';
    return lastFinishedStep.index === 0 ? swap.inputAmount : swap.steps[lastFinishedStep.index - 1].outputAmount ?? '';
}
function $fe4c6e12ce942e12$export$4ad99a385f7fc2d6(swap) {
    const lastSuccessfulStep = $fe4c6e12ce942e12$export$4a476235428b9cf(swap);
    return $fe4c6e12ce942e12$export$ab4672d656f03d3b($fe4c6e12ce942e12$export$70860efeae8a3a0e(swap), lastSuccessfulStep?.step?.fromUsdPrice ?? '');
}
function $fe4c6e12ce942e12$export$35379c0d97a1f8d9(swap) {
    const lastSuccessfulStep = $fe4c6e12ce942e12$export$ce182e0a92d996da(swap.steps);
    return $fe4c6e12ce942e12$export$ab4672d656f03d3b(lastSuccessfulStep?.outputAmount ?? '', lastSuccessfulStep?.toUsdPrice ?? '');
}
function $fe4c6e12ce942e12$export$4aa5c06f67fb07d8(swap, message, reasonCode) {
    return {
        type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
        reason: message,
        reasonCode: reasonCode ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
        inputAmount: $fe4c6e12ce942e12$export$70860efeae8a3a0e(swap),
        inputAmountUsd: $fe4c6e12ce942e12$export$4ad99a385f7fc2d6(swap)
    };
}









function $f23fbb512d7a3254$export$484d2d105e634a64(actions) {
    const { getStorage: getStorage, context: context } = actions;
    const { isMobileWallet: isMobileWallet } = context;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
    const mobileWallet = isMobileWallet(sourceWallet?.walletType);
    const tx = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    const isApproval = (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(currentStep);
    if (!tx || !tx.type) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: 'Unexpected Error: tx is null!',
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    const hasAlreadyProceededToSign = !!swap.hasAlreadyProceededToSign;
    if (isApproval) return new (0, $c88854de77322012$export$8146e38189b4f4dc)({
        nextStatus: undefined,
        nextStepStatus: 'waitingForApproval',
        details: 'Waiting for approve transaction to be mined and confirmed successfully',
        message: `Waiting for approval of ${currentStep?.fromSymbol} coin ${mobileWallet ? 'on your mobile phone!' : ''}`
    });
    else if (hasAlreadyProceededToSign) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        message: 'Transaction is expired. Please try again.',
        nextStepStatus: 'failed',
        nextStatus: 'failed',
        details: '',
        errorCode: 'TX_EXPIRED'
    });
    return new (0, $c88854de77322012$export$8146e38189b4f4dc)({
        message: 'Executing transaction ...',
        nextStepStatus: 'running',
        nextStatus: 'running',
        details: `${mobileWallet ? 'Check your mobile phone!' : ''}`
    });
}
function $f23fbb512d7a3254$export$b8ebd28fe6122be4(actions, error) {
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const isApproval = (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(currentStep);
    const hasAlreadyProceededToSign = typeof swap.hasAlreadyProceededToSign === 'boolean';
    const updatedResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
        getStorage: getStorage,
        setStorage: setStorage,
        nextStepStatus: error.nextStepStatus,
        nextStatus: error.nextStatus,
        message: error.message,
        details: error.details,
        errorCode: error.errorCode,
        hasAlreadyProceededToSign: isApproval ? undefined : hasAlreadyProceededToSign
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
            reason: error.message,
            reasonCode: updatedResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
            inputAmount: (0, $fe4c6e12ce942e12$export$70860efeae8a3a0e)(swap),
            inputAmountUsd: (0, $fe4c6e12ce942e12$export$4ad99a385f7fc2d6)(swap)
        },
        ...updatedResult
    });
}
function $f23fbb512d7a3254$export$8cd2ff900a31c0b6(actions, ok) {
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const isApproval = (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(currentStep);
    const hasAlreadyProceededToSign = typeof swap.hasAlreadyProceededToSign === 'boolean';
    const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
        getStorage: getStorage,
        setStorage: setStorage,
        nextStepStatus: ok.nextStepStatus,
        nextStatus: ok.nextStatus,
        message: ok.message,
        details: ok.details,
        hasAlreadyProceededToSign: isApproval ? undefined : hasAlreadyProceededToSign
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION,
            status: (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).SEND_TX
        },
        ...updateResult
    });
}



async function $bf0eef63f5dc4f1c$export$7a470df434686642(actions) {
    const { failed: failed, schedule: schedule, getStorage: getStorage, next: next } = actions;
    const onFinish = ()=>{
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const handleErr = (err)=>{
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, err.val);
        failed();
        onFinish();
    };
    const scheduleAction = (action)=>{
        schedule(action);
        next();
        onFinish();
    };
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const currentTransactionFromStorage = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!currentTransactionFromStorage) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: tx is null!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    const prerequisites = currentTransactionFromStorage.prerequisites;
    const unmetPrerequisiteIndex = prerequisites.findIndex((prerequisite, prerequisiteIndex)=>!(0, $4919c4b385f2331a$export$7b1c89ab7f8b9b40)({
            prerequisiteType: prerequisite.type,
            prerequisiteIndex: prerequisiteIndex
        }, currentStep));
    let result = null;
    if (unmetPrerequisiteIndex !== -1) switch(prerequisites[unmetPrerequisiteIndex].type){
        case 0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE:
            result = (0, $4919c4b385f2331a$export$9b853567ad655b30)(unmetPrerequisiteIndex, currentStep);
            break;
        case 0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE:
            result = (0, $4919c4b385f2331a$export$63136d3552b24042)(unmetPrerequisiteIndex, currentStep);
            break;
        default:
            result = new (0, $c88854de77322012$export$3659d3f2d3dfceb8)('Unexpected Error: unknown prerequisite type!');
            break;
    }
    else if (currentStep.fromBlockchain === (0, $9HEDW.LegacyNetworks).XRPL) result = new (0, $c88854de77322012$export$8146e38189b4f4dc)((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_XRPL_TRANSACTION);
    else result = new (0, $c88854de77322012$export$8146e38189b4f4dc)((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION);
    if (result?.err) handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: result.val,
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    }));
    else scheduleAction(result.val);
}





parcelRequire("9U3Qn");
var $9gKM3 = parcelRequire("9gKM3");






const $4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_STATUS = 5000;
const $4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_APPROVAL = 5000;
/**
 * Subscribe to status of swap transaction by checking from server periodically.
 * After getting the status, notify the user and schedule `SCHEDULE_NEXT_STEP`.
 */ async function $4e7ff774d97a18f4$var$checkTransactionStatus({ getStorage: getStorage, setStorage: setStorage, next: next, schedule: schedule, retry: retry, failed: failed, context: context }) {
    const swap = getStorage().swapDetails;
    const { meta: meta } = context;
    const checkStatusError = new Error('check status Error');
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    if (!currentStep?.executedTransactionId) return;
    const tx = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    let txId = currentStep.executedTransactionId;
    let getTxReceiptFailed = false;
    let status = null;
    let signer = null;
    const { getTransactionDataByHash: getTransactionDataByHash, setTransactionDataByHash: setTransactionDataByHash } = (0, $fe4c6e12ce942e12$export$156145f76a656206)();
    try {
        const txType = (0, $fe4c6e12ce942e12$export$e959b2e816f5278e)(currentStep);
        const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
        if (txType && sourceWallet) signer = (await context.getSigners(sourceWallet.walletType)).getSigner(txType);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
    /*
     * wallet is not connected yet
     * no need to do anything
     */ }
    try {
        // if wallet is connected, try to get transaction reciept
        const { response: txResponse, receiptReceived: receiptReceived } = getTransactionDataByHash(txId);
        if (signer?.wait && !receiptReceived) {
            const chainId = tx?.blockChain && meta.blockchains?.[tx?.blockChain]?.chainId || undefined;
            const { hash: updatedTxHash, response: updatedTxResponse } = await signer.wait(txId, chainId, txResponse);
            if (updatedTxHash !== txId) {
                currentStep.executedTransactionId = updatedTxHash || currentStep.executedTransactionId;
                const currentStepNamespace = (0, $671edadeda3a0e7c$export$8f95be1c56c514cf)(swap, currentStep);
                let explorerUrl;
                const blockchainsMetaNotEmpty = !!Object.keys(meta.blockchains).length;
                if (blockchainsMetaNotEmpty) explorerUrl = (0, $671edadeda3a0e7c$export$1dc40019f7ea36bf)(currentStep.executedTransactionId, currentStepNamespace.network, meta.blockchains);
                if (explorerUrl) {
                    if (currentStep.explorerUrl && currentStep.explorerUrl?.length >= 1) currentStep.explorerUrl[currentStep.explorerUrl.length - 1] = {
                        url: explorerUrl,
                        description: 'Replaced Swap'
                    };
                }
                txId = currentStep.executedTransactionId;
                if (updatedTxHash && updatedTxResponse) setTransactionDataByHash(updatedTxHash, {
                    response: updatedTxResponse
                });
            } else setTransactionDataByHash(updatedTxHash, {
                receiptReceived: true
            });
        }
    } catch (error) {
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
        const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        const event = (0, $fe4c6e12ce942e12$export$4aa5c06f67fb07d8)(swap, extraMessage, updateResult.failureType);
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(checkStatusError, {
            tags: {
                type: 'singer-error',
                reason: event.reason,
                reasonCode: event.reasonCode,
                message: extraMessage,
                messageDetail: extraMessageDetail,
                pendingSwap: swap
            },
            context: (0, $9gKM3.SignerError).isSignerError(error) ? error.getErrorContext() : {}
        });
        getTxReceiptFailed = true;
    /*
     * We shouldn't return here, because we need to trigger check status job in backend.
     * This is not a ui requirement but the backend one.
     */ }
    const requestBody = {
        requestId: swap.requestId,
        txId: txId,
        step: currentStep.id
    };
    try {
        status = await (0, $e48877d26b43b539$export$c1b2b945bea31d71)().checkStatus(requestBody);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)($4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_STATUS);
        retry();
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(checkStatusError, {
            tags: {
                type: 'request-error',
                requestBody: requestBody,
                pendingSwap: swap
            }
        });
        return;
    }
    /*
   * If user cancel swap during check status api call,
   * or getting transaction receipt failed,
   * we should ignore check status response and return
   */ if (getTxReceiptFailed) return failed();
    if (currentStep?.status === 'failed') return;
    const outputAmount = status?.outputAmount || (currentStep.outputAmount ? currentStep.outputAmount : null);
    const prevOutputAmount = currentStep.outputAmount || null;
    swap.extraMessage = status?.extraMessage || swap.extraMessage;
    swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).info;
    swap.extraMessageDetail = '';
    currentStep.status = status?.status || currentStep.status;
    currentStep.diagnosisUrl = status?.diagnosisUrl || currentStep.diagnosisUrl || null;
    currentStep.outputAmount = outputAmount || currentStep.outputAmount;
    currentStep.explorerUrl = status?.explorerUrl || currentStep.explorerUrl;
    currentStep.internalSteps = status?.steps || null;
    const newTransaction = status?.newTx;
    if (newTransaction) {
        currentStep.status = 'created';
        currentStep.executedTransactionId = null;
        currentStep.executedTransactionTime = null;
        (0, $fe4c6e12ce942e12$export$6b6ed2f9ae969f2d)(currentStep, newTransaction);
    }
    if (prevOutputAmount === null && outputAmount !== null) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).OUTPUT_REVEALED,
            outputAmount: outputAmount
        },
        swap: swap,
        step: currentStep
    });
    else if (prevOutputAmount === null && outputAmount === null) // it is needed to set notification after reloading the page
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS
        },
        swap: swap,
        step: currentStep
    });
    if (currentStep.status === 'success') {
        const nextStep = (0, $671edadeda3a0e7c$export$b6b54d9bbb742a92)(swap, currentStep);
        swap.extraMessageDetail = '';
        swap.extraMessage = nextStep ? `starting next step: ${nextStep.swapperId}: ${nextStep.fromBlockchain} -> ${nextStep.toBlockchain}` : '';
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED,
                inputAmount: (0, $fe4c6e12ce942e12$export$70860efeae8a3a0e)(swap),
                inputAmountUsd: (0, $fe4c6e12ce942e12$export$4ad99a385f7fc2d6)(swap),
                outputAmount: currentStep.outputAmount ?? '',
                outputAmountUsd: (0, $fe4c6e12ce942e12$export$35379c0d97a1f8d9)(swap)
            },
            swap: swap,
            step: currentStep
        });
    } else if (currentStep.status === 'failed') {
        swap.extraMessage = 'Transaction failed in blockchain';
        swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).error;
        swap.extraMessageDetail = status?.extraMessage || '';
        swap.status = 'failed';
        swap.finishTime = new Date().getTime().toString();
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(checkStatusError, {
            tags: {
                type: 'transaction-failed',
                message: swap.extraMessage,
                messageDetails: swap.extraMessageDetail,
                pendingSwap: swap
            }
        });
    }
    // Sync data with storage
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    if (status?.status === 'failed') failed();
    else if (status?.status === 'success' || status?.status === 'running' && !!status.newTx) {
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
        next();
    } else {
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)($4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_STATUS);
        retry();
    }
}
/**
 * Subscribe to status of approval transaction by checking from server periodically.
 * After getting the status, notify the user and schedule `SCHEDULE_NEXT_STEP`.
 */ async function $4e7ff774d97a18f4$var$checkApprovalStatus({ getStorage: getStorage, setStorage: setStorage, next: next, schedule: schedule, retry: retry, failed: failed, context: context }) {
    const swap = getStorage().swapDetails;
    const { meta: meta } = context;
    const { getTransactionDataByHash: getTransactionDataByHash, setTransactionDataByHash: setTransactionDataByHash } = (0, $fe4c6e12ce942e12$export$156145f76a656206)();
    const checkApprovalStatusError = new Error('check approval status error');
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    if (!currentStep) {
        console.log('ignore check status, current step is null');
        return;
    }
    const tx = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!currentStep?.executedTransactionId) return;
    let txId = currentStep.executedTransactionId;
    let signer = null;
    try {
        const txType = (0, $fe4c6e12ce942e12$export$e959b2e816f5278e)(currentStep);
        const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
        if (txType && sourceWallet) {
            const walletSigners = await context.getSigners(sourceWallet.walletType);
            signer = walletSigners.getSigner(txType);
        }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
    /*
     * wallet is not connected yet
     * no need to do anything
     */ }
    try {
        const { response: txResponse, receiptReceived: receiptReceived } = getTransactionDataByHash(txId);
        // if wallet is connected, try to get transaction reciept
        if (signer?.wait && !receiptReceived) {
            const chainId = tx?.blockChain && meta.blockchains?.[tx?.blockChain]?.chainId || undefined;
            const { hash: updatedTxHash, response: updatedTxResponse } = await signer.wait(txId, chainId, txResponse);
            if (updatedTxHash !== txId) {
                currentStep.executedTransactionId = updatedTxHash || currentStep.executedTransactionId;
                const currentStepNamespace = (0, $671edadeda3a0e7c$export$8f95be1c56c514cf)(swap, currentStep);
                let explorerUrl;
                const blockchainsMetaNotEmpty = !!Object.keys(meta.blockchains).length;
                if (blockchainsMetaNotEmpty) explorerUrl = (0, $671edadeda3a0e7c$export$1dc40019f7ea36bf)(currentStep.executedTransactionId, currentStepNamespace.network, meta.blockchains);
                if (explorerUrl) {
                    if (currentStep.explorerUrl && currentStep.explorerUrl?.length >= 1) currentStep.explorerUrl[currentStep.explorerUrl.length - 1] = {
                        url: explorerUrl,
                        description: 'Replaced Approve'
                    };
                }
                txId = currentStep.executedTransactionId;
                if (updatedTxHash && updatedTxResponse) setTransactionDataByHash(updatedTxHash, {
                    response: updatedTxResponse
                });
            } else setTransactionDataByHash(updatedTxHash, {
                receiptReceived: true
            });
        }
    } catch (error) {
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
        const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        const event = (0, $fe4c6e12ce942e12$export$4aa5c06f67fb07d8)(swap, extraMessage, updateResult.failureType);
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: event,
            ...updateResult
        });
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(checkApprovalStatusError, {
            tags: {
                type: 'singer-error',
                reason: event.reason,
                reasonCode: event.reasonCode,
                message: extraMessage,
                messageDetail: extraMessageDetail,
                pendingSwap: swap
            },
            context: (0, $9gKM3.SignerError).isSignerError(error) ? error.getErrorContext() : {}
        });
        return failed();
    }
    let isApproved = false;
    const request = {
        requestId: swap.requestId,
        txId: currentStep.executedTransactionId
    };
    try {
        const response = await (0, $e48877d26b43b539$export$c1b2b945bea31d71)().checkApproval(request.requestId, request.txId);
        // If user cancel swap during check status api call, we should ignore check approval response
        if (currentStep?.status === 'failed') return;
        isApproved = response.isApproved;
        if (!isApproved && (response.txStatus === 'failed' || response.txStatus === 'success')) {
            let message, details;
            if (response.txStatus === 'failed') {
                message = 'Approve transaction failed';
                details = 'Smart contract approval tx failed in blockchain.';
            } else {
                message = 'Not enough approval';
                if (response.requiredApprovedAmount && response.currentApprovedAmount) details = `Required approval: ${response.requiredApprovedAmount}, current approval: ${response.currentApprovedAmount}`;
                else details = `You still don't have enough approval for this swap.`;
            }
            /*
       * approve transaction failed on
       * we should fail the whole swap
       */ const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
                getStorage: getStorage,
                setStorage: setStorage,
                nextStatus: 'failed',
                nextStepStatus: 'failed',
                errorCode: 'INSUFFICIENT_APPROVE',
                message: message,
                details: details
            });
            const event = (0, $fe4c6e12ce942e12$export$4aa5c06f67fb07d8)(swap, message, updateResult.failureType);
            (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
                event: event,
                ...updateResult
            });
            (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(checkApprovalStatusError, {
                tags: {
                    type: 'approval-failed',
                    message: swap.extraMessage,
                    messageDetails: swap.extraMessageDetail,
                    pendingSwap: swap
                }
            });
            failed();
        } else if (!isApproved) // it is needed to set notification after reloading the page
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS
            },
            swap: swap,
            step: currentStep
        });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        isApproved = false;
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(checkApprovalStatusError, {
            tags: {
                type: 'request-error',
                requestBody: request,
                pendingSwap: swap
            }
        });
    }
    if (isApproved) {
        currentStep.status = 'approved';
        swap.extraMessage = `Spending ${currentStep.fromSymbol} approved successfully.`;
        swap.extraMessageDetail = null;
        swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).success;
        currentStep.evmApprovalTransaction = null;
        currentStep.executedTransactionId = null;
        currentStep.executedTransactionTime = null;
        currentStep.starknetApprovalTransaction = null;
        currentStep.tronApprovalTransaction = null;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).APPROVAL_TX_SUCCEEDED
            },
            swap: swap,
            step: currentStep
        });
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
        next();
    } else {
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)($4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_APPROVAL);
        retry();
    }
}
async function $4e7ff774d97a18f4$export$1c8f61c1db5300d2(actions) {
    const swap = actions.getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    if (!currentStep) {
        console.log('ignore check status, current step is null', swap.requestId);
        return;
    }
    /*
   * Reset network status
   * Because when check status is on `loading` or `failed` status, it shows previous message that isn't related to current state.
   */ (0, $fe4c6e12ce942e12$export$84ffc71d1c4cf1c1)(actions);
    if (currentStep.status === 'running') await $4e7ff774d97a18f4$var$checkTransactionStatus(actions);
    else if (currentStep.status === 'waitingForApproval') await $4e7ff774d97a18f4$var$checkApprovalStatus(actions);
}


parcelRequire("9U3Qn");
var $gEbmX = parcelRequire("gEbmX");
var $9B1kL = parcelRequire("9B1kL");




function $108ca4bdeafb7841$export$e27885dd7586505b(context) {
    return context.claimedBy === context._queue?.id;
}
function $108ca4bdeafb7841$export$8e946397ab051bc5(actions, blockedFor) {
    actions.block(blockedFor);
    const isClaimed = $108ca4bdeafb7841$export$e27885dd7586505b(actions.context);
    if (isClaimed && actions.context.resetClaimedBy) actions.context.resetClaimedBy();
}



var $9HEDW = parcelRequire("9HEDW");

var $4lvIP = parcelRequire("4lvIP");

var $iOQO2 = parcelRequire("iOQO2");
parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");



const $b2e15ef1c26d9256$export$6fa71e0e78f85f1d = '922337203685.4775807'; // https://stellar-sdk.readthedocs.io/en/stable/_modules/stellar_sdk/operation/change_trust.html


async function $3414435c8a52e25b$export$527726c6ba482ac4(context, walletType) {
    // We need to work with namespace instance
    const provider = context.hubProvider(walletType);
    const stellarNamespace = provider.get('stellar');
    if (!stellarNamespace) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: 'Stellar is not available on your wallet.',
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    return (0, $c88854de77322012$export$8146e38189b4f4dc)(stellarNamespace);
}
async function $3414435c8a52e25b$export$4d80de999dbfc4b(account, token, options) {
    try {
        // Get account lines for the account
        const accountLines = await options.namespace.balanceLines(account);
        // Find the target account line
        const targetAccountLine = accountLines.filter((accountLine)=>accountLine.asset_type !== 'native' && accountLine.asset_type !== 'liquidity_pool_shares').find((accountLine)=>accountLine.asset_code === token.code && accountLine.asset_issuer === token.issuer);
        // If not account line is open on the target token, return false
        if (!targetAccountLine) return new (0, $c88854de77322012$export$8146e38189b4f4dc)({
            trustLineIsAlreadyOpened: false
        });
        const lineLimit = new (0, $iOQO2.default)(targetAccountLine.limit);
        const targetLimit = new (0, $iOQO2.default)((0, $b2e15ef1c26d9256$export$6fa71e0e78f85f1d));
        /*
     * If the account line is open, and contains a suitable limit, return true
     * TODO: we can add some logic to check if the target limit has enough capacity to hold the token amount,
     * but it needs that we always get the correct needed limit value in prerequisites
     */ return new (0, $c88854de77322012$export$8146e38189b4f4dc)({
            trustLineIsAlreadyOpened: lineLimit.gte(targetLimit)
        });
    } catch  {
        return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Could not get account lines from Stellar.',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        });
    }
}
function $3414435c8a52e25b$export$fcf25e67416588e4(_accountId, token) {
    const asset = new $4lvIP.Asset(token.code, token.issuer);
    const TRUST_LINE_FEE = '100';
    const TRUST_LINE_TIMEOUT = 30;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const now = Math.floor(Date.now() / 1000);
    const operation = $4lvIP.Operation.changeTrust({
        asset: asset,
        limit: (0, $b2e15ef1c26d9256$export$6fa71e0e78f85f1d)
    });
    return {
        type: (0, $9B1kL.TransactionType).STELLAR,
        blockChain: 'Stellar',
        prerequisites: [],
        data: {
            baseFee: TRUST_LINE_FEE,
            memoXdrBase64: null,
            preconditions: {
                timeBounds: {
                    minTime: 0,
                    maxTime: now + TRUST_LINE_TIMEOUT
                },
                ledgerBounds: {
                    minLedger: 0,
                    maxLedger: 0
                },
                minSeqNumber: null,
                minSeqAge: null,
                minSeqLedgerGap: null,
                extraSigners: null
            },
            operationsXdrBase64: [
                operation.toXDR('base64')
            ]
        }
    };
}
function $3414435c8a52e25b$export$e95a7cad2d0445e4(swap) {
    const stellarWallet = swap.wallets['STELLAR'];
    if (!stellarWallet) return null;
    return {
        type: stellarWallet.walletType,
        namespace: {
            namespace: 'Stellar',
            network: 'Stellar'
        },
        address: stellarWallet.address
    };
}
async function $3414435c8a52e25b$export$630f08e99f644c5e(actions, requiredWallet) {
    const { context: context } = actions;
    const walletState = context.state(requiredWallet.type);
    const { accounts: accounts, connected: connected } = walletState;
    if (!connected) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
        description: (0, $d96636b74cb7ca13$export$2f02fd340a90fed8)(requiredWallet.type)
    });
    if (!accounts?.find((account)=>(0, $9HEDW.legacyReadAccountAddress)(account).address === requiredWallet.address)) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
        description: (0, $d96636b74cb7ca13$export$f2aac43aeaf7ba5a)(requiredWallet.type, requiredWallet.address)
    });
    return new (0, $c88854de77322012$export$8146e38189b4f4dc)(true);
}


async function $2a884e26b90620e9$export$8ff3304f8e4c9e62(actions) {
    const { failed: failed, context: context, schedule: schedule, getStorage: getStorage, next: next } = actions;
    const { meta: meta, getSigners: getSigners } = context;
    const onFinish = ()=>{
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const scheduleCheckPrerequisites = ()=>{
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_PREREQUISITES);
        next();
        onFinish();
    };
    const handleErr = (err)=>{
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, err.val);
        failed();
        onFinish();
    };
    /*
   *
   * 1. Ensure transaction is available.
   *
   */ const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const currentTransactionFromStorage = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!currentTransactionFromStorage) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: tx is null!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    /*
   *
   * 2. Check if there is a prerequisite with STELLAR_CHANGE_TRUSTLINE_TYPE that does not have any result.
   *
   */ let unmetStellarChangeTrustLineMeta = null;
    for(let prerequisiteIndex = 0; prerequisiteIndex < currentTransactionFromStorage.prerequisites.length; prerequisiteIndex++){
        const prerequisite = currentTransactionFromStorage.prerequisites[prerequisiteIndex];
        if (prerequisite.type === (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE)) {
            const prerequisiteResult = currentStep.prerequisiteResults.find((prerequisiteResult)=>prerequisiteResult.prerequisiteIndex === prerequisiteIndex && prerequisiteResult.prerequisiteType === (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE));
            if (!prerequisiteResult) {
                unmetStellarChangeTrustLineMeta = {
                    prerequisite: prerequisite,
                    prerequisiteIndex: prerequisiteIndex
                };
                break;
            }
        }
    }
    if (!unmetStellarChangeTrustLineMeta) {
        scheduleCheckPrerequisites();
        return;
    }
    /*
   *
   * 3. Ensure Stellar wallet is connected.
   *
   */ const stellarWallet = (0, $3414435c8a52e25b$export$e95a7cad2d0445e4)(swap);
    if (!stellarWallet) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: Stellar wallet was not found in the swap!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    const namespace = await (0, $3414435c8a52e25b$export$527726c6ba482ac4)(context, stellarWallet.type);
    if (namespace.err) {
        handleErr(namespace);
        return;
    }
    const ensureRequiredStellarWalletIsConnectedResult = await (0, $3414435c8a52e25b$export$630f08e99f644c5e)(actions, stellarWallet);
    if (ensureRequiredStellarWalletIsConnectedResult.err) {
        (0, $108ca4bdeafb7841$export$8e946397ab051bc5)(actions, ensureRequiredStellarWalletIsConnectedResult.val);
        return;
    }
    /*
   *
   * 3. Check if trust line is already opened.
   *
   */ const token = {
        code: unmetStellarChangeTrustLineMeta.prerequisite.code,
        issuer: unmetStellarChangeTrustLineMeta.prerequisite.issuer,
        value: unmetStellarChangeTrustLineMeta.prerequisite.value
    };
    const trustLineIsAlreadyOpenedResult = await (0, $3414435c8a52e25b$export$4d80de999dbfc4b)(unmetStellarChangeTrustLineMeta.prerequisite.wallet, token, {
        namespace: namespace.val
    });
    if (trustLineIsAlreadyOpenedResult.err) {
        handleErr(trustLineIsAlreadyOpenedResult);
        return;
    }
    if (trustLineIsAlreadyOpenedResult.val.trustLineIsAlreadyOpened) {
        const prerequisiteResult = {
            prerequisiteIndex: unmetStellarChangeTrustLineMeta.prerequisiteIndex,
            prerequisiteType: (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE),
            status: 'skipped',
            data: null
        };
        (0, $fe4c6e12ce942e12$export$f418268c692fe64f)(actions, prerequisiteResult);
        scheduleCheckPrerequisites();
        return;
    }
    /*
   *
   * 4. Create trust line transaction.
   *
   */ try {
        // Create trust line transaction with the required limit
        const trustlineTransaction = await (0, $3414435c8a52e25b$export$fcf25e67416588e4)(unmetStellarChangeTrustLineMeta.prerequisite.wallet, token);
        const chainId = meta.blockchains['Stellar']?.chainId;
        const walletSigners = await getSigners(stellarWallet.type);
        const signer = walletSigners.getSigner((0, $9B1kL.TransactionType).STELLAR);
        const transactionResult = await signer.signAndSendTx(trustlineTransaction, stellarWallet.address, chainId);
        const prerequisiteResult = {
            prerequisiteIndex: unmetStellarChangeTrustLineMeta.prerequisiteIndex,
            prerequisiteType: (0, $gEbmX.STELLAR_CHANGE_TRUSTLINE_TYPE),
            status: 'success',
            data: {
                executedTransactionHash: transactionResult.hash
            }
        };
        (0, $fe4c6e12ce942e12$export$f418268c692fe64f)(actions, prerequisiteResult);
        scheduleCheckPrerequisites();
    } catch (e) {
        (0, $fe4c6e12ce942e12$export$43684a9f4c55c7c3)(actions)(e);
        onFinish();
    }
}





parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");
var $gEbmX = parcelRequire("gEbmX");






var $9HEDW = parcelRequire("9HEDW");

var $iOQO2 = parcelRequire("iOQO2");
parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");



const $1b25b8760e8a22d0$export$6fa71e0e78f85f1d = '10000000000000';


async function $e2cce607bb288890$export$2d9511095ae1c5ec(context, walletType) {
    // We need to work with namespace instance
    const provider = context.hubProvider(walletType);
    const xrplNamespace = provider.get('xrpl');
    if (!xrplNamespace) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: 'XRPL is not available on your wallet.',
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    return (0, $c88854de77322012$export$8146e38189b4f4dc)(xrplNamespace);
}
async function $e2cce607bb288890$export$4d80de999dbfc4b(account, token, options) {
    try {
        // Get account lines for the account
        const accountLines = await options.namespace.accountLines(account, {
            peer: token.account
        });
        // Find the target account line
        const targetAccountLine = accountLines.find((accountLine)=>accountLine.currency === token.currency && accountLine.account === token.account);
        // If not account line is open on the target token, return false
        if (!targetAccountLine) return new (0, $c88854de77322012$export$8146e38189b4f4dc)({
            trustLineIsAlreadyOpened: false
        });
        const lineLimit = new (0, $iOQO2.default)(targetAccountLine.limit);
        const targetLimit = new (0, $iOQO2.default)((0, $1b25b8760e8a22d0$export$6fa71e0e78f85f1d));
        // If the account line is open, and contains a suitable limit, return true
        return new (0, $c88854de77322012$export$8146e38189b4f4dc)({
            trustLineIsAlreadyOpened: lineLimit.gte(targetLimit)
        });
    } catch  {
        return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Could not get account lines from XRPL.',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        });
    }
}
function $e2cce607bb288890$export$fcf25e67416588e4(account, token) {
    return {
        type: (0, $9B1kL.TransactionType).XRPL,
        blockChain: 'XRPL',
        prerequisites: [],
        data: {
            TransactionType: 'TrustSet',
            Account: account,
            LimitAmount: {
                currency: token.currency,
                issuer: token.account,
                value: (0, $1b25b8760e8a22d0$export$6fa71e0e78f85f1d)
            }
        }
    };
}
function $e2cce607bb288890$export$eedf4dd1ba0598ff(swap) {
    const xrplWallet = swap.wallets['XRPL'];
    if (!xrplWallet) return null;
    return {
        type: xrplWallet.walletType,
        namespace: {
            namespace: 'XRPL',
            network: 'XRPL'
        },
        address: xrplWallet.address
    };
}
async function $e2cce607bb288890$export$c5d7e5fa7233dfb9(actions, requiredWallet) {
    const { context: context } = actions;
    const walletState = context.state(requiredWallet.type);
    const { accounts: accounts, connected: connected } = walletState;
    if (!connected) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
        description: (0, $d96636b74cb7ca13$export$2f02fd340a90fed8)(requiredWallet.type)
    });
    if (!accounts?.find((account)=>(0, $9HEDW.legacyReadAccountAddress)(account).address === requiredWallet.address)) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
        description: (0, $d96636b74cb7ca13$export$f2aac43aeaf7ba5a)(requiredWallet.type, requiredWallet.address)
    });
    return new (0, $c88854de77322012$export$8146e38189b4f4dc)(true);
}


async function $74606ea7f8281e8a$export$e58e192e1310b9cd(actions) {
    const { failed: failed, context: context, schedule: schedule, getStorage: getStorage, next: next } = actions;
    const { meta: meta, getSigners: getSigners } = context;
    const onFinish = ()=>{
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const scheduleCheckPrerequisites = ()=>{
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_PREREQUISITES);
        next();
        onFinish();
    };
    const handleErr = (err)=>{
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, err.val);
        failed();
        onFinish();
    };
    /*
   *
   * 1. Ensure transaction is available.
   *
   */ const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const currentTransactionFromStorage = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!currentTransactionFromStorage) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: tx is null!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    /*
   *
   * 2. Check if there is a prerequisite with XRPL_CHANGE_TRUSTLINE_TYPE that does not have any result.
   *
   */ let unmetXrplChangeTrustLineMeta = null;
    for(let prerequisiteIndex = 0; prerequisiteIndex < currentTransactionFromStorage.prerequisites.length; prerequisiteIndex++){
        const prerequisite = currentTransactionFromStorage.prerequisites[prerequisiteIndex];
        if (prerequisite.type === (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE)) {
            const prerequisiteResult = currentStep.prerequisiteResults?.find((prerequisiteResult)=>prerequisiteResult.prerequisiteIndex === prerequisiteIndex && prerequisiteResult.prerequisiteType === (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE));
            if (!prerequisiteResult) unmetXrplChangeTrustLineMeta = {
                prerequisite: prerequisite,
                prerequisiteIndex: prerequisiteIndex
            };
        }
    }
    if (!unmetXrplChangeTrustLineMeta) {
        scheduleCheckPrerequisites();
        return;
    }
    /*
   *
   * 3. Ensure XRPL wallet is connected.
   *
   */ const xrplWallet = (0, $e2cce607bb288890$export$eedf4dd1ba0598ff)(swap);
    if (!xrplWallet) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: XRPL wallet was not found in the swap!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    const namespace = await (0, $e2cce607bb288890$export$2d9511095ae1c5ec)(context, xrplWallet.type);
    if (namespace.err) {
        handleErr(namespace);
        return;
    }
    const ensureRequiredXrplWalletIsConnectedResult = await (0, $e2cce607bb288890$export$c5d7e5fa7233dfb9)(actions, xrplWallet);
    if (ensureRequiredXrplWalletIsConnectedResult.err) {
        (0, $108ca4bdeafb7841$export$8e946397ab051bc5)(actions, ensureRequiredXrplWalletIsConnectedResult.val);
        return;
    }
    /*
   *
   * 3. Check if trust line is already opened.
   *
   */ const token = {
        currency: unmetXrplChangeTrustLineMeta.prerequisite.currency,
        account: unmetXrplChangeTrustLineMeta.prerequisite.issuer,
        amount: unmetXrplChangeTrustLineMeta.prerequisite.value
    };
    const trustLineIsAlreadyOpenedResult = await (0, $e2cce607bb288890$export$4d80de999dbfc4b)(unmetXrplChangeTrustLineMeta.prerequisite.wallet, token, {
        namespace: namespace.val
    });
    if (trustLineIsAlreadyOpenedResult.err) {
        handleErr(trustLineIsAlreadyOpenedResult);
        return;
    }
    if (trustLineIsAlreadyOpenedResult.val.trustLineIsAlreadyOpened) {
        const prerequisiteResult = {
            prerequisiteIndex: unmetXrplChangeTrustLineMeta.prerequisiteIndex,
            prerequisiteType: (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE),
            status: 'skipped',
            data: null
        };
        (0, $fe4c6e12ce942e12$export$f418268c692fe64f)(actions, prerequisiteResult);
        scheduleCheckPrerequisites();
        return;
    }
    /*
   *
   * 4. Create trust line transaction.
   *
   */ try {
        // Create trust line transaction with the required limit
        const trustlineTransaction = (0, $e2cce607bb288890$export$fcf25e67416588e4)(unmetXrplChangeTrustLineMeta.prerequisite.wallet, token);
        const chainId = meta.blockchains['XRPL']?.chainId;
        const walletSigners = await getSigners(xrplWallet.type);
        const signer = walletSigners.getSigner((0, $9B1kL.TransactionType).XRPL);
        const transactionResult = await signer.signAndSendTx(trustlineTransaction, xrplWallet.address, chainId);
        const prerequisiteResult = {
            prerequisiteIndex: unmetXrplChangeTrustLineMeta.prerequisiteIndex,
            prerequisiteType: (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE),
            status: 'pending',
            data: {
                executedTransactionHash: transactionResult.hash
            }
        };
        (0, $fe4c6e12ce942e12$export$f418268c692fe64f)(actions, prerequisiteResult);
        scheduleCheckPrerequisites();
    } catch (e) {
        (0, $fe4c6e12ce942e12$export$43684a9f4c55c7c3)(actions)(e);
        onFinish();
    }
}





parcelRequire("9U3Qn");
var $8H2HB = parcelRequire("8H2HB");
var $gEbmX = parcelRequire("gEbmX");


var $jP6wO = parcelRequire("jP6wO");



const $08e4b18ea5a46080$export$3ecdc23c0c54457e = 5000;
const $08e4b18ea5a46080$export$8ddf0ce6d86841b9 = 'wss://xrplcluster.com/';


async function $92e4890f7ff8493b$export$6922335a62ca07f6(actions) {
    const { failed: failed, getStorage: getStorage, retry: retry, next: next, schedule: schedule } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const onFinish = ()=>{
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const onSuccessfulFinish = ()=>{
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_PREREQUISITES);
        next();
        onFinish();
    };
    const handleErr = (err)=>{
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, err.val);
        failed();
        onFinish();
    };
    const retryAfterDelay = async ()=>{
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)((0, $08e4b18ea5a46080$export$3ecdc23c0c54457e));
        retry();
    };
    /*
   *
   * 1. Ensure a pending XRPL_CHANGE_TRUSTLINE prerequisite result is available.
   *
   */ let pendingXrplChangeTrustLinePrerequisiteResult = null;
    for (const prerequisiteResult of currentStep.prerequisiteResults)if ((0, $8H2HB.isXrplChangeTrustLinePrerequisiteResult)(prerequisiteResult) && prerequisiteResult.status === 'pending') {
        pendingXrplChangeTrustLinePrerequisiteResult = prerequisiteResult;
        break;
    }
    if (!pendingXrplChangeTrustLinePrerequisiteResult) {
        onSuccessfulFinish();
        return;
    }
    try {
        const client = new (0, $jP6wO.Client)((0, $08e4b18ea5a46080$export$8ddf0ce6d86841b9));
        await client.connect();
        const response = await client.request({
            command: 'tx',
            transaction: pendingXrplChangeTrustLinePrerequisiteResult.data.executedTransactionHash
        });
        if (!response.result.validated) {
            // If data is not final, we need to retry
            await retryAfterDelay();
            return;
        }
        // If data is final, we can update the prerequisite status
        if (typeof response.result.meta !== 'string' && // `response.result.meta` should not be of type "string" because `binary` filed is not set in tx request
        response.result.meta?.TransactionResult === 'tesSUCCESS' // https://xrpl.org/docs/references/protocol/transactions/transaction-results
        ) {
            const prerequisiteResult = {
                prerequisiteIndex: pendingXrplChangeTrustLinePrerequisiteResult.prerequisiteIndex,
                prerequisiteType: (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE),
                status: 'success',
                data: {
                    executedTransactionHash: pendingXrplChangeTrustLinePrerequisiteResult.data.executedTransactionHash
                }
            };
            (0, $fe4c6e12ce942e12$export$f418268c692fe64f)(actions, prerequisiteResult);
            onSuccessfulFinish();
        } else {
            const prerequisiteResult = {
                prerequisiteIndex: pendingXrplChangeTrustLinePrerequisiteResult.prerequisiteIndex,
                prerequisiteType: (0, $gEbmX.XRPL_CHANGE_TRUSTLINE_TYPE),
                status: 'failed',
                data: {
                    executedTransactionHash: pendingXrplChangeTrustLinePrerequisiteResult.data.executedTransactionHash
                }
            };
            (0, $fe4c6e12ce942e12$export$f418268c692fe64f)(actions, prerequisiteResult);
            handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
                nextStatus: 'failed',
                nextStepStatus: 'failed',
                message: 'Unexpected Error: xrpl change trustline transaction failed!',
                details: undefined,
                errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
            }));
        }
    } catch  {
        await retryAfterDelay();
    }
}










async function $8297ff50f7dcdefd$export$714aebfec8ead7f0(actions) {
    const { setStorage: setStorage, getStorage: getStorage, next: next, schedule: schedule } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const transaction = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!transaction) {
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION,
                status: (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).CREATE_TX
            },
            swap: swap,
            step: currentStep
        });
        const request = {
            requestId: swap.requestId,
            step: currentStep.id,
            userSettings: {
                slippage: swap.settings.slippage,
                infiniteApprove: swap.settings.infiniteApprove
            },
            validations: {
                balance: swap.validateBalanceOrFee,
                fee: swap.validateBalanceOrFee,
                approve: true
            }
        };
        try {
            // Getting transcation from server.
            const { transaction: transaction } = await (0, $fe4c6e12ce942e12$export$495b8adaeb8ab9b9)((0, $e48877d26b43b539$export$c1b2b945bea31d71)().createTransaction(request));
            if (transaction) (0, $fe4c6e12ce942e12$export$6b6ed2f9ae969f2d)(currentStep, transaction);
            setStorage({
                ...getStorage(),
                swapDetails: swap
            });
            schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
            next();
        } catch (error) {
            swap.status = 'failed';
            swap.finishTime = new Date().getTime().toString();
            const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
            const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
                getStorage: getStorage,
                setStorage: setStorage,
                nextStatus: 'failed',
                nextStepStatus: 'failed',
                message: extraMessage,
                details: extraMessageDetail,
                errorCode: 'FETCH_TX_FAILED'
            });
            const event = (0, $fe4c6e12ce942e12$export$4aa5c06f67fb07d8)(swap, extraMessage, updateResult.failureType);
            (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
                event: event,
                ...updateResult
            });
            if (error instanceof Error) (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(new Error('create transaction error'), {
                tags: {
                    message: error.message,
                    requestBody: request,
                    reason: event.reason,
                    reasonCode: event.reasonCode,
                    pendingSwap: swap
                }
            });
            actions.failed();
        }
    }
}


parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");






parcelRequire("9U3Qn");
var $2UxIz = parcelRequire("2UxIz");

function $209020fcc2c3c0c8$export$9317663580413d5(symbolAddress) {
    const [currency, account] = symbolAddress.split('-');
    return [
        currency,
        account
    ];
}
async function $209020fcc2c3c0c8$export$c803f76d69bfe09b(tx) {
    if (!tx) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: 'Unexpected Error: tx is null!',
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    if (!(0, $2UxIz.isStellarTransaction)(tx)) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: "Unexpected Error: Expected Stellar transaction but it doesn't match with the structure.",
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    return (0, $c88854de77322012$export$8146e38189b4f4dc)(tx);
}


async function $dbab2729e0bae7a6$export$a04ae49a347781ff(actions) {
    const { failed: failed, getStorage: getStorage, context: context } = actions;
    const { meta: meta, getSigners: getSigners } = context;
    const onFinish = ()=>{
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const handleErr = (err)=>{
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, err.val);
        failed();
        onFinish();
    };
    /*
   *
   * 1. Ensure transaction is available.
   *
   */ const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const currentTransactionFromStorage = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    const transaction = await (0, $209020fcc2c3c0c8$export$c803f76d69bfe09b)(currentTransactionFromStorage);
    if (transaction.err) {
        handleErr(transaction);
        return;
    }
    /*
   *
   * 2. Ensure wallet is connected with a correct address.
   *
   */ const stellarWallet = (0, $3414435c8a52e25b$export$e95a7cad2d0445e4)(swap);
    if (!stellarWallet) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: Stellar wallet was not found in the swap!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    const namespace = await (0, $3414435c8a52e25b$export$527726c6ba482ac4)(context, stellarWallet.type);
    if (namespace.err) {
        handleErr(namespace);
        return;
    }
    const ensureRequiredStellarWalletIsConnectedResult = await (0, $3414435c8a52e25b$export$630f08e99f644c5e)(actions, stellarWallet);
    if (ensureRequiredStellarWalletIsConnectedResult.err) {
        (0, $108ca4bdeafb7841$export$8e946397ab051bc5)(actions, ensureRequiredStellarWalletIsConnectedResult.val);
        return;
    }
    const walletAddress = (0, $671edadeda3a0e7c$export$336d89edaa0d6235)(swap, currentStep);
    /*
   * Checking the current transaction state to determine the next step.
   * It will either be Err, indicating process should stop, or Ok, indicating process should continue.
   */ const nextStateResult = (0, $f23fbb512d7a3254$export$484d2d105e634a64)(actions);
    if (nextStateResult.err) {
        handleErr(nextStateResult);
        return;
    }
    // On success, we should update Swap object and also call notifier
    (0, $f23fbb512d7a3254$export$8cd2ff900a31c0b6)(actions, nextStateResult.val);
    /*
   *
   * 3. Execute transaction
   *
   */ const chainId = meta.blockchains['Stellar']?.chainId;
    let signer;
    try {
        const walletSigners = await getSigners(stellarWallet.type);
        signer = walletSigners.getSigner((0, $9B1kL.TransactionType).STELLAR);
    } catch  {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: Failed to load the signer. Please refresh the page and try again.',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    try {
        const result = await signer.signAndSendTx(transaction.val, walletAddress, chainId);
        (0, $fe4c6e12ce942e12$export$793b8a12247c3aee)(actions, {
            isApproval: false
        })(result);
    } catch (e) {
        (0, $fe4c6e12ce942e12$export$43684a9f4c55c7c3)(actions)(e);
    }
    // this works as `finally` for the iterator.
    onFinish();
}






parcelRequire("9U3Qn");
var $k5IP8 = parcelRequire("k5IP8");






async function $b8bdbaf51d218890$export$cf43e5aa0575f6c3(actions) {
    const { getStorage: getStorage, context: context } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    /* Make sure wallet is connected and also the connected wallet is matched with tx by checking address. */ const addressCheckResult = $b8bdbaf51d218890$var$ensureRequiredWalletIsConnected(actions);
    if (addressCheckResult.err) return addressCheckResult;
    /* Wallet should be on correct network */ const networkResult = await $b8bdbaf51d218890$var$ensureWalletIsOnCorrectNetwork(actions);
    if (networkResult.err) return networkResult;
    if (currentStep.networkStatus === (0, $k5IP8.PendingSwapNetworkStatus).NetworkChanged) // Considering that network is matched now, if currently network status of the current step is equal to `NetworkChanged`, we need to update the network status to mark it as network changed successfully.
    (0, $fe4c6e12ce942e12$export$92b8d849bafb537c)(actions, {
        message: '',
        details: 'The network has been successfully changed.',
        status: (0, $k5IP8.PendingSwapNetworkStatus).NetworkChanged
    });
    /*
   *For avoiding conflict by making too many requests to wallet, we need to make sure
   *We only run one request at a time (In parallel mode).
   */ const needsToBlockQueue = (0, $fe4c6e12ce942e12$export$d31e98f8646bca08)(currentStep);
    const isClaimed = (0, $108ca4bdeafb7841$export$e27885dd7586505b)(context);
    if (needsToBlockQueue && !isClaimed) {
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES,
            description: (0, $d96636b74cb7ca13$export$bbfd8242d61c310),
            details: {}
        };
        return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(blockedFor);
    }
    return new (0, $c88854de77322012$export$8146e38189b4f4dc)(true);
}
function $b8bdbaf51d218890$var$ensureRequiredWalletIsConnected(actions) {
    const { getStorage: getStorage, context: context } = actions;
    const { wallets: wallets } = context;
    const swap = getStorage().swapDetails;
    const isWrongAddress = !(0, $fe4c6e12ce942e12$export$ba15f3931e3e12e6)(swap, context.state).ok;
    if (isWrongAddress) {
        const { type: type, address: address } = (0, $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55)(swap);
        const isWalletInCompatible = wallets?.blockchains?.find((w)=>!w.accounts?.find((account)=>account.walletType === type));
        const description = (0, $fe4c6e12ce942e12$export$a07d9470285db41)(wallets) || isWalletInCompatible ? (0, $d96636b74cb7ca13$export$2f02fd340a90fed8)(type) : (0, $d96636b74cb7ca13$export$f2aac43aeaf7ba5a)(type, address);
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
            description: description
        };
        return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(blockedFor);
    }
    return new (0, $c88854de77322012$export$8146e38189b4f4dc)(true);
}
async function $b8bdbaf51d218890$var$ensureWalletIsOnCorrectNetwork(actions) {
    const { getStorage: getStorage, context: context } = actions;
    const { meta: meta, wallets: wallets, providers: providers, hubProvider: hubProvider } = context;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const networkMatched = await (0, $fe4c6e12ce942e12$export$e51ad0ccc6210c75)(swap, currentStep, wallets, meta, providers, hubProvider);
    const { claimedBy: claimedBy } = (0, $fe4c6e12ce942e12$export$269a5aa1e1356b04)();
    const claimerId = claimedBy();
    const isClaimedByAnyQueue = !!claimerId && !(0, $108ca4bdeafb7841$export$e27885dd7586505b)(context);
    if (isClaimedByAnyQueue && !networkMatched) {
        const details = (0, $d96636b74cb7ca13$export$bbfd8242d61c310);
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES,
            details: details
        };
        return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(blockedFor);
    } else if (!networkMatched) {
        const fromNamespace = (0, $671edadeda3a0e7c$export$8f95be1c56c514cf)(swap, currentStep);
        const details = (0, $d96636b74cb7ca13$export$721abf6846856403)(fromNamespace.network);
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
            details: details
        };
        return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)(blockedFor);
    }
    return new (0, $c88854de77322012$export$8146e38189b4f4dc)(true);
}




async function $3ebe8685a307bf43$export$794e1f6267917bde(actions) {
    const checkResult = await (0, $b8bdbaf51d218890$export$cf43e5aa0575f6c3)(actions);
    if (checkResult.err) {
        (0, $108ca4bdeafb7841$export$8e946397ab051bc5)(actions, checkResult.val);
        return;
    }
    (0, $fe4c6e12ce942e12$export$84ffc71d1c4cf1c1)(actions);
    // All the conditions are met. We can safely send the tx to wallet for sign.
    const { failed: failed, getStorage: getStorage, context: context } = actions;
    const { meta: meta, getSigners: getSigners } = context;
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const isApproval = (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(currentStep);
    const onFinish = ()=>{
        // TODO resetClaimedBy is undefined here
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    /*
   * Checking the current transaction state to determine the next step.
   * It will either be Err, indicating process should stop, or Ok, indicating process should continu.
   */ const nextStateResult = (0, $f23fbb512d7a3254$export$484d2d105e634a64)(actions);
    if (nextStateResult.err) {
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, nextStateResult.val);
        failed();
        onFinish();
        return;
    }
    // On sucess, we should update Swap object and also call notifier
    (0, $f23fbb512d7a3254$export$8cd2ff900a31c0b6)(actions, nextStateResult.val);
    // when we are producing next step, it will check to tx shouldn't be null. So ! here is safe.
    const tx = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
    const walletAddress = (0, $671edadeda3a0e7c$export$336d89edaa0d6235)(swap, currentStep);
    const chainId = meta.blockchains?.[tx.blockChain]?.chainId;
    let walletSigners;
    try {
        walletSigners = await getSigners(sourceWallet.walletType);
    } catch (error) {
        (0, $fe4c6e12ce942e12$export$43684a9f4c55c7c3)(actions)(error);
        onFinish();
        return;
    }
    const signer = walletSigners.getSigner(tx.type);
    await signer.signAndSendTx(tx, walletAddress, chainId).then((0, $fe4c6e12ce942e12$export$793b8a12247c3aee)(actions, {
        isApproval: isApproval
    }), (0, $fe4c6e12ce942e12$export$43684a9f4c55c7c3)(actions)).finally(()=>{
        onFinish();
    });
}




parcelRequire("9U3Qn");
var $9B1kL = parcelRequire("9B1kL");






parcelRequire("9U3Qn");
var $3RHtn = parcelRequire("3RHtn");

function $0fdb3059a8397291$export$9317663580413d5(symbolAddress) {
    const [currency, account] = symbolAddress.split('-');
    return [
        currency,
        account
    ];
}
async function $0fdb3059a8397291$export$474bbe0149e1062e(tx) {
    if (!tx) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: 'Unexpected Error: tx is null!',
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    if (!(0, $3RHtn.isXrplTransaction)(tx)) return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: "Unexpected Error: Expected XRPL transaction but it doesn't match with the structure.",
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    if (tx.data.TransactionType !== 'Payment') return new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
        nextStatus: 'failed',
        nextStepStatus: 'failed',
        message: 'Unexpected Error: Only XRPL transactions with payment type are supported',
        details: undefined,
        errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
    });
    return (0, $c88854de77322012$export$8146e38189b4f4dc)(tx);
}


async function $03da1ee1bbcfeb0c$export$8588ae6b1c788e29(actions) {
    const { failed: failed, getStorage: getStorage, context: context } = actions;
    const { meta: meta, getSigners: getSigners } = context;
    const onFinish = ()=>{
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const handleErr = (err)=>{
        (0, $f23fbb512d7a3254$export$b8ebd28fe6122be4)(actions, err.val);
        failed();
        onFinish();
    };
    /*
   *
   * 1. Ensure transaction is available.
   *
   */ const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const currentTransactionFromStorage = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    const transaction = await (0, $0fdb3059a8397291$export$474bbe0149e1062e)(currentTransactionFromStorage);
    if (transaction.err) {
        handleErr(transaction);
        return;
    }
    /*
   *
   * 2. Ensure wallet is connected with a correct address.
   *
   */ const xrplWallet = (0, $e2cce607bb288890$export$eedf4dd1ba0598ff)(swap);
    if (!xrplWallet) {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: Stellar wallet was not found in the swap!',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    const namespace = await (0, $e2cce607bb288890$export$2d9511095ae1c5ec)(context, xrplWallet.type);
    if (namespace.err) {
        handleErr(namespace);
        return;
    }
    const ensureRequiredXrplWalletIsConnectedResult = await (0, $e2cce607bb288890$export$c5d7e5fa7233dfb9)(actions, xrplWallet);
    if (ensureRequiredXrplWalletIsConnectedResult.err) {
        (0, $108ca4bdeafb7841$export$8e946397ab051bc5)(actions, ensureRequiredXrplWalletIsConnectedResult.val);
        return;
    }
    const walletAddress = (0, $671edadeda3a0e7c$export$336d89edaa0d6235)(swap, currentStep);
    /*
   * Checking the current transaction state to determine the next step.
   * It will either be Err, indicating process should stop, or Ok, indicating process should continue.
   */ const nextStateResult = (0, $f23fbb512d7a3254$export$484d2d105e634a64)(actions);
    if (nextStateResult.err) {
        handleErr(nextStateResult);
        return;
    }
    // On success, we should update Swap object and also call notifier
    (0, $f23fbb512d7a3254$export$8cd2ff900a31c0b6)(actions, nextStateResult.val);
    /*
   *
   * 3. Execute transaction
   *
   */ const chainId = meta.blockchains['XRPL']?.chainId;
    let signer;
    try {
        const walletSigners = await getSigners(xrplWallet.type);
        signer = walletSigners.getSigner((0, $9B1kL.TransactionType).XRPL);
    } catch  {
        handleErr(new (0, $c88854de77322012$export$3659d3f2d3dfceb8)({
            nextStatus: 'failed',
            nextStepStatus: 'failed',
            message: 'Unexpected Error: Failed to load the signer. Please refresh the page and try again.',
            details: undefined,
            errorCode: 'CLIENT_UNEXPECTED_BEHAVIOUR'
        }));
        return;
    }
    try {
        const result = await signer.signAndSendTx(transaction.val, walletAddress, chainId);
        (0, $fe4c6e12ce942e12$export$793b8a12247c3aee)(actions, {
            isApproval: transaction.val.data.TransactionType === 'TrustSet'
        })(result);
    } catch (e) {
        (0, $fe4c6e12ce942e12$export$43684a9f4c55c7c3)(actions)(e);
    }
    // this works as `finally` for the iterator.
    onFinish();
}







function $d3c05c11512f8681$export$a4cc6fa6e89e741e({ schedule: schedule, next: next, failed: failed, setStorage: setStorage, getStorage: getStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const isFailed = swap.steps.find((step)=>step.status === 'failed');
    if (!!currentStep && !isFailed) {
        if ((0, $fe4c6e12ce942e12$export$9f101a08b811faba)(swap, currentStep)) {
            schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_PREREQUISITES);
            return next();
        }
        if (currentStep?.executedTransactionId) {
            schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS);
            return next();
        }
        swap.status = 'running';
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED
            },
            swap: swap,
            step: currentStep
        });
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CREATE_TRANSACTION);
        next();
    } else {
        swap.status = isFailed ? 'failed' : 'success';
        swap.finishTime = new Date().getTime().toString();
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        const inputAmount = (0, $fe4c6e12ce942e12$export$70860efeae8a3a0e)(swap);
        const inputAmountUsd = (0, $fe4c6e12ce942e12$export$4ad99a385f7fc2d6)(swap);
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            ...isFailed ? {
                event: {
                    type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                    reason: swap.extraMessage ?? undefined,
                    reasonCode: 'CALL_OR_SEND_FAILED',
                    inputAmount: inputAmount,
                    inputAmountUsd: inputAmountUsd
                }
            } : {
                event: {
                    type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED,
                    inputAmount: inputAmount,
                    inputAmountUsd: inputAmountUsd,
                    outputAmount: (0, $fe4c6e12ce942e12$export$ce182e0a92d996da)(swap.steps)?.outputAmount ?? '',
                    outputAmountUsd: (0, $fe4c6e12ce942e12$export$35379c0d97a1f8d9)(swap)
                }
            },
            swap: swap,
            step: null
        });
        if (isFailed) failed();
        else next();
    }
}




function $0dffcdf74d6c3f4a$export$b3571188c770cc5a({ schedule: schedule, next: next, getStorage: getStorage }) {
    const swap = getStorage().swapDetails;
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED
        },
        swap: swap,
        step: null
    });
    schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
    next();
}




const $4c48cda7676828c7$export$5b43de9847fa5c2b = {
    name: 'swap',
    actions: {
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).START]: (0, $0dffcdf74d6c3f4a$export$b3571188c770cc5a),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP]: (0, $d3c05c11512f8681$export$a4cc6fa6e89e741e),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CREATE_TRANSACTION]: (0, $8297ff50f7dcdefd$export$714aebfec8ead7f0),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_PREREQUISITES]: (0, $bf0eef63f5dc4f1c$export$7a470df434686642),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_XRPL_TRUSTLINE]: (0, $74606ea7f8281e8a$export$e58e192e1310b9cd),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_XRPL_TRUSTLINE_TRANSACTION_STATUS]: (0, $92e4890f7ff8493b$export$6922335a62ca07f6),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_STELLAR_TRUSTLINE]: (0, $2a884e26b90620e9$export$8ff3304f8e4c9e62),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION]: (0, $3ebe8685a307bf43$export$794e1f6267917bde),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_XRPL_TRANSACTION]: (0, $03da1ee1bbcfeb0c$export$8588ae6b1c788e29),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_STELLAR_TRANSACTION]: (0, $dbab2729e0bae7a6$export$a04ae49a347781ff),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS]: (0, $4e7ff774d97a18f4$export$1c8f61c1db5300d2)
    },
    run: [
        (0, $4a641b36af06aafc$export$f01edf6b00a44c8a).START
    ],
    whenTaskBlocked: (event, meta)=>{
        if (event.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET) (0, $fe4c6e12ce942e12$export$c29c9a248811e0a7)(event, meta);
        else if (event.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE) (0, $fe4c6e12ce942e12$export$15bd368e2f15ea8b)(event, meta);
        else if (event.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES) (0, $fe4c6e12ce942e12$export$63f1cfbd06c1a0f9)(event, meta);
    }
};









var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $a9cc98c18933ffe3$export$f6196a6c6bb539b4 = {
    loadedFromPersistor: false
};
function $a9cc98c18933ffe3$var$reducer(state, action) {
    switch(action.type){
        case 'UPDATE':
            return {
                ...state,
                [action.name]: action.value
            };
        default:
            return state;
    }
}
function $a9cc98c18933ffe3$export$78aa9f240301775c() {
    const [state, dispatch] = (0, $bh6RR.useReducer)($a9cc98c18933ffe3$var$reducer, $a9cc98c18933ffe3$export$f6196a6c6bb539b4);
    return {
        state: state,
        update: (name, value)=>{
            dispatch({
                type: 'UPDATE',
                name: name,
                value: value
            });
        }
    };
}


const $5f16708435ec29c2$var$ManagerCtx = /*#__PURE__*/ (0, $bh6RR.createContext)({
    manager: undefined,
    state: (0, $a9cc98c18933ffe3$export$f6196a6c6bb539b4)
});
function $5f16708435ec29c2$var$Provider(props) {
    // TODO: this is not a proper way but i don't want to change the context interface atm.
    const [, forceRender] = (0, $bh6RR.useState)({});
    const { state: state, update: update } = (0, $a9cc98c18933ffe3$export$78aa9f240301775c)();
    const context = (0, $bh6RR.useRef)(props.context);
    const manager = (0, $bh6RR.useMemo)(()=>{
        return new (0, $40ce72f69a9a8814$export$d0d38e7dec7a1a61)({
            queuesDefs: props.queuesDefs,
            events: {
                onStorageUpdate: ()=>{
                    forceRender({});
                },
                onCreateQueue: ()=>{
                    forceRender({});
                },
                onCreateTask: ()=>{
                    forceRender({});
                },
                onUpdateQueue: ()=>{
                    forceRender({});
                },
                onUpdateTask: ()=>{
                    forceRender({});
                },
                onPersistedDataLoaded: (manager)=>{
                    forceRender({});
                    if (props.onPersistedDataLoaded) props.onPersistedDataLoaded(manager);
                    /*
           * This condition will make sure, we only update the `loadedFromPersistor`.
           * But be aware `onPersistedDataLoaded` is calling after each `sync` which means can be called multiple times.
           */ if (!state.loadedFromPersistor) update('loadedFromPersistor', true);
                },
                onTaskBlock: ()=>{
                    forceRender({});
                },
                onDeleteQueue: ()=>{
                    forceRender({});
                }
            },
            context: context || {},
            isPaused: props.isPaused
        });
    }, []);
    (0, $bh6RR.useLayoutEffect)(()=>{
        context.current = props.context;
    }, [
        props.context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (typeof props.isPaused !== 'undefined') {
            if (props.isPaused) manager.pause();
            else manager.run();
            forceRender({});
        }
    }, [
        props.isPaused
    ]);
    return(// eslint-disable-next-line react/jsx-no-constructed-context-values
    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5f16708435ec29c2$var$ManagerCtx.Provider, {
        value: {
            manager: manager,
            state: state
        },
        children: props.children
    }));
}
function $5f16708435ec29c2$export$ddf53f26a9d1c984() {
    const context = (0, $bh6RR.useContext)($5f16708435ec29c2$var$ManagerCtx);
    if (!context) throw Error('useManager can only be used within the Provider component');
    return context;
}
var $5f16708435ec29c2$export$2e2bcd8739ae039 = $5f16708435ec29c2$var$Provider;





var $bh6RR = parcelRequire("bh6RR");


const $4aa388da88c9191a$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $4aa388da88c9191a$export$2e2bcd8739ae039 = {
    randomUUID: $4aa388da88c9191a$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $65095c686cb9b048$var$getRandomValues;
const $65095c686cb9b048$var$rnds8 = new Uint8Array(16);
function $65095c686cb9b048$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$65095c686cb9b048$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $65095c686cb9b048$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$65095c686cb9b048$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $65095c686cb9b048$var$getRandomValues($65095c686cb9b048$var$rnds8);
}


var $0e7a8ce22ba9b8a9$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $56c607f0da2d78e0$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $0e7a8ce22ba9b8a9$export$2e2bcd8739ae039).test(uuid);
}
var $56c607f0da2d78e0$export$2e2bcd8739ae039 = $56c607f0da2d78e0$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $bb2c25b3aaaec315$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$bb2c25b3aaaec315$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $bb2c25b3aaaec315$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $bb2c25b3aaaec315$var$byteToHex[arr[offset + 0]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 1]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 2]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 3]] + '-' + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 4]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 5]] + '-' + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 6]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 7]] + '-' + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 8]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 9]] + '-' + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 10]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 11]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 12]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 13]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 14]] + $bb2c25b3aaaec315$var$byteToHex[arr[offset + 15]];
}
function $bb2c25b3aaaec315$var$stringify(arr, offset = 0) {
    const uuid = $bb2c25b3aaaec315$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $56c607f0da2d78e0$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $bb2c25b3aaaec315$export$2e2bcd8739ae039 = $bb2c25b3aaaec315$var$stringify;


function $15fdf0a27810aeb5$var$v4(options, buf, offset) {
    if ((0, $4aa388da88c9191a$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $4aa388da88c9191a$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $65095c686cb9b048$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $bb2c25b3aaaec315$export$8fb373d660548968)(rnds);
}
var $15fdf0a27810aeb5$export$2e2bcd8739ae039 = $15fdf0a27810aeb5$var$v4;



const $5f1f0bac19915991$var$MIGRATED_KEY = 'migratedToQueueManager';
/**
 *
 * If `MIGRATED_KEY` is set, it means we already migrated data from localstorage.
 *
 */ function $5f1f0bac19915991$export$993f7575d6ad7c5b() {
    return !!window.localStorage.getItem($5f1f0bac19915991$var$MIGRATED_KEY);
}
async function $5f1f0bac19915991$var$hasQueueManagerOnIDB() {
    try {
        return (await window.indexedDB.databases()).map((db)=>db.name).includes((0, $6d5ad09ed8dd1162$export$3c22ff8b64b8f565));
    } catch  {
        return false;
    }
}
/**
 *
 * By calling this function, we first check if the data already migrated or not,
 * If not, starting to migrating to IndexedDb with proper format that queue manager is understand.
 *
 */ async function $5f1f0bac19915991$export$f07d3c018abd1a6b() {
    const swapsFromStorage = window.localStorage.getItem('pendingSwaps');
    const hasIndexDB = await $5f1f0bac19915991$var$hasQueueManagerOnIDB();
    // For new users or already migrated.
    if (!swapsFromStorage || $5f1f0bac19915991$export$993f7575d6ad7c5b() || hasIndexDB) return true;
    // For old users, but they didn't do any swaps yet.
    const swaps = JSON.parse(swapsFromStorage);
    const convertedSwaps = [];
    swaps.forEach((swap)=>{
        /*
     *For running task we need to add some more work
     *We need to create a queue task to be run and resume the running task from queue manager.
     */ if (swap.status === 'running') {
            const taskId = (0, $15fdf0a27810aeb5$export$2e2bcd8739ae039)();
            const convertedSwap = {
                id: swap.requestId,
                createdAt: Number(swap.creationTime),
                name: 'swap',
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING,
                storage: {
                    swapDetails: swap
                },
                state: {
                    status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING,
                    activeTaskIndex: 0,
                    tasks: {
                        [taskId]: {
                            blockedFor: null,
                            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
                        }
                    }
                },
                tasks: [
                    {
                        id: taskId,
                        action: (0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP
                    }
                ]
            };
            convertedSwaps.push(convertedSwap);
        } else {
            /*
       * For failed or successful swaps, we only move it to IndexedDB,
       * And there is no need to consider them to be run.
       */ const status = swap.status === 'success' ? (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS : (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED;
            const convertedSwap = {
                id: swap.requestId,
                createdAt: Number(swap.creationTime),
                name: 'swap',
                status: status,
                storage: {
                    swapDetails: swap
                },
                state: {
                    status: status,
                    activeTaskIndex: 0,
                    tasks: {}
                },
                tasks: []
            };
            convertedSwaps.push(convertedSwap);
        }
    });
    // Getting an instance from persistor, so we can directly put our data inside it.
    const persistor = new (0, $6d5ad09ed8dd1162$export$2e2bcd8739ae039)();
    const promises = convertedSwaps.map(async (queue)=>persistor.insertQueue(queue));
    await Promise.all(promises);
    // Mark as the data has been successfully migrated.
    window.localStorage.setItem($5f1f0bac19915991$var$MIGRATED_KEY, '1');
    return true;
}


let $db134805b942a1fe$var$isCalled = 0;
function $db134805b942a1fe$var$getLastConnectedWalletHash(lastConnectedWallet) {
    return `${lastConnectedWallet?.walletType}-${lastConnectedWallet?.network}-${lastConnectedWallet?.accounts?.toString()}`;
}
/**
 *
 * Runs a migration (old swaps from localstorage to queue manager's IndexedDB)
 * It will be run only once on page load.
 *
 */ function $db134805b942a1fe$export$62d22dd62ac1f1b() {
    const isMigrated = (0, $5f1f0bac19915991$export$993f7575d6ad7c5b)();
    const [status, setStatus] = (0, $bh6RR.useState)(isMigrated);
    (0, $bh6RR.useEffect)(()=>{
        (async ()=>{
            // Preventing react to be called twice on Strict Mode (development)
            if ($db134805b942a1fe$var$isCalled) return;
            $db134805b942a1fe$var$isCalled = 1;
            (0, $5f1f0bac19915991$export$f07d3c018abd1a6b)().finally(()=>{
                setStatus(true);
            });
        })();
    }, []);
    return {
        status: status
    };
}
/**
 *
 * On initial load and also connect/disconnect we may need to update swap's notified message.
 * And also if a new wallet is connected we will retry the queue to see we can resume it or not.
 *
 */ function $db134805b942a1fe$export$1fbfa58ad4d80d3a(params) {
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const { lastConnectedWallet: lastConnectedWallet, disconnectedWallet: disconnectedWallet, evmChains: evmChains, canSwitchNetworkTo: canSwitchNetworkTo, clearDisconnectedWallet: clearDisconnectedWallet } = params;
    (0, $bh6RR.useEffect)(()=>{
        if (lastConnectedWallet) {
            (0, $fe4c6e12ce942e12$export$4855f2a4839078ef)({
                evmChains: evmChains,
                lastConnectedWallet: lastConnectedWallet,
                manager: manager
            });
            (0, $fe4c6e12ce942e12$export$4ca8cf19c61b3860)(lastConnectedWallet, manager, canSwitchNetworkTo);
        }
    }, [
        $db134805b942a1fe$var$getLastConnectedWalletHash(lastConnectedWallet)
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (disconnectedWallet) {
            (0, $fe4c6e12ce942e12$export$d9db0ccdbfe08fc3)(manager);
            /*
       *We need to reset the state value, so if a wallet disconnected twice (after reconnect),
       *this effect will be run properly.
       */ clearDisconnectedWallet();
        }
    }, [
        disconnectedWallet
    ]);
}


function $3e49d40922a6294a$export$e5055f26eedfa461(configs) {
    (0, $86a9fd6e2401871c$export$b9b9cdb96b829919)(configs);
    return 0, $4c48cda7676828c7$export$5b43de9847fa5c2b;
}





var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-throw-literal */ /* eslint-disable @typescript-eslint/member-ordering */ /* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $9HEDW = parcelRequire("9HEDW");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");

var $iOQO2 = parcelRequire("iOQO2");
/**
 *  The Application Programming Interface (API) is the collection of
 *  functions, classes and types offered by the Ethers library.
 *
 *  @_section: api:Application Programming Interface  [about-api]
 *  @_navTitle: API
 */ parcelRequire("cvLQv");parcelRequire("9XxdG");parcelRequire("bCA3C");parcelRequire("7lMFN");parcelRequire("df9mn");


parcelRequire("9U3Qn");
var $hE77Y = parcelRequire("hE77Y");
var $9gKM3 = parcelRequire("9gKM3");
parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $9cRHO = parcelRequire("9cRHO");
const $1f30fcf397122368$var$evmAddress = '0x2702d89c1c8658b49c45dd460deebcc45faec03c';
const $1f30fcf397122368$var$cosmosAddress = 'cosmos1unf2rcytjxfpz8x8ar63h4qeftadptg5r5qswd';
const $1f30fcf397122368$export$6fc3cee911cc8c20 = (()=>{
    const evm = [
        'BSC',
        'POLYGON',
        'ETH',
        'AVAX_CCHAIN',
        'ARBITRUM',
        'FANTOM',
        'OPTIMISM',
        'OKC',
        'CRONOS',
        'MOONRIVER',
        'MOONBEAM',
        'HECO',
        'AURORA',
        'HARMONY',
        'EVMOS',
        'GNOSIS',
        'FUSE',
        'BOBA'
    ].map((network)=>{
        return {
            name: network,
            accounts: [
                {
                    address: $1f30fcf397122368$var$evmAddress,
                    walletType: (0, $9cRHO.WalletTypes).META_MASK
                }
            ]
        };
    });
    const cosmos = [
        {
            name: (0, $9HEDW.LegacyNetworks).COSMOS,
            accounts: [
                {
                    address: $1f30fcf397122368$var$cosmosAddress,
                    walletType: (0, $9cRHO.WalletTypes).KEPLR
                }
            ]
        }
    ];
    return {
        blockchains: [
            ...evm,
            ...cosmos
        ]
    };
})();
const $1f30fcf397122368$export$8c2c13478e869569 = {
    blockchains: [
        {
            name: 'BSC',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'BSC',
                            symbol: 'SWAP8.IO',
                            ticker: 'SWAP8.IO',
                            address: '0xcaee79616cffeb53fdda5792742a5c084f879dec',
                            rawAmount: '980000000000000000000000',
                            decimal: 18,
                            amount: '980000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'PDOT.IO',
                            ticker: 'PDOT.IO',
                            address: '0x8bd0e87273364ebbe3482efc166f7e0d34d82c25',
                            rawAmount: '95641000000000000000000',
                            decimal: 18,
                            amount: '95641',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ZEPE.IO',
                            ticker: 'ZEPE.IO',
                            address: '0x119e2ad8f0c85c6f61afdf0df69693028cdc10be',
                            rawAmount: '750000000000000000000000',
                            decimal: 18,
                            amount: '750000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: '0GAS.IO',
                            ticker: '0GAS.IO',
                            address: '0x2231e1c01056aebab3113d684b034b50a99a56c7',
                            rawAmount: '16000000000000',
                            decimal: 9,
                            amount: '16000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'LUNA',
                            ticker: 'LUNA',
                            address: '0x030612e22610219733f3e942bb67004d6cbd796b',
                            rawAmount: '350000000000000000000',
                            decimal: 18,
                            amount: '350',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FTM',
                            ticker: 'FTM',
                            address: '0xad29abb318791d579433d831ed122afeaf29dcfe',
                            rawAmount: '60035619283908361569',
                            decimal: 18,
                            amount: '60.035619283908361569',
                            logo: 'https://api.rango.exchange/i/mZqhCJ',
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'GGBOXS.COM',
                            ticker: 'GGBOXS.COM',
                            address: '0x2248ba304d2045cdc144866ce37d1435a30b29f3',
                            rawAmount: '60000000000000000000000',
                            decimal: 18,
                            amount: '60000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AGP',
                            ticker: 'AGP',
                            address: '0x1c749d5f5630cf365673bf6c0b6b0570c48da112',
                            rawAmount: '6300000',
                            decimal: 6,
                            amount: '6.3',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'UST',
                            ticker: 'UST',
                            address: '0x3d4350cd54aef9f9b2c29435e0fa809957b3f30a',
                            rawAmount: '5015300',
                            decimal: 6,
                            amount: '5.0153',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ALPACA',
                            ticker: 'ALPACA',
                            address: '0xb926beb62d7a680406e06327c87307c1ffc4ab09',
                            rawAmount: '50',
                            decimal: 18,
                            amount: '0.00000000000000005',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'NUSD',
                            ticker: 'NUSD',
                            address: '0x23b891e5c62e0955ae2bd185990103928ab817b3',
                            rawAmount: '25863658894004353627',
                            decimal: 18,
                            amount: '25.863658894004353627',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'RENUSDT',
                            ticker: 'RENUSDT',
                            address: '0xf55941e971302c634c586416c43469f3ead5ad3e',
                            rawAmount: '4997500',
                            decimal: 6,
                            amount: '4.9975',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MMDEX.IO',
                            ticker: 'MMDEX.IO',
                            address: '0xdc4cb4c3587532409a4545aa79a15d967bed1c08',
                            rawAmount: '250000000000000000000000',
                            decimal: 18,
                            amount: '250000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BOWDAO.NET',
                            ticker: 'BOWDAO.NET',
                            address: '0x3bab61ad5d103bb5b203c9092eb3a5e11677a5d0',
                            rawAmount: '660000000000000000000000',
                            decimal: 18,
                            amount: '660000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'APC',
                            ticker: 'APC',
                            address: '0xda2d21872999e700a715a1bda3153eb9079770bb',
                            rawAmount: '124889000',
                            decimal: 6,
                            amount: '124.889',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'LINK',
                            ticker: 'LINK',
                            address: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
                            rawAmount: '7095490344',
                            decimal: 18,
                            amount: '0.000000007095490344',
                            logo: 'https://api.rango.exchange/i/hWjRK2',
                            usdPrice: 5.947
                        },
                        {
                            chain: 'BSC',
                            symbol: 'LUNA2.APP',
                            ticker: 'LUNA2.APP',
                            address: '0x9171c79f543b298fbd39642dc29e1454e2878665',
                            rawAmount: '188888',
                            decimal: 0,
                            amount: '188888',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'EOS',
                            ticker: 'EOS',
                            address: '0x56b6fb708fc5732dec1afc8d8556423a2edccbd6',
                            rawAmount: '6521653134',
                            decimal: 18,
                            amount: '0.000000006521653134',
                            logo: 'https://api.rango.exchange/i/KeunI3',
                            usdPrice: 0.874
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ANGELDUST',
                            ticker: 'ANGELDUST',
                            address: '0x32d3499feca3f881d779f0183d7b41d32b2498df',
                            rawAmount: '741825180000',
                            decimal: 6,
                            amount: '741825.18',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ORBIT',
                            ticker: 'ORBIT',
                            address: '0xdfb8603d947ab42fb76eb3bb14d9dde4334130d2',
                            rawAmount: '58397000000000000000000',
                            decimal: 18,
                            amount: '58397',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'WAVAX',
                            ticker: 'WAVAX',
                            address: '0x96412902aa9aff61e13f085e70d3152c6ef2a817',
                            rawAmount: '8087494716',
                            decimal: 18,
                            amount: '0.000000008087494716',
                            logo: 'https://api.rango.exchange/i/7QDOTz',
                            usdPrice: 11.745
                        },
                        {
                            chain: 'BSC',
                            symbol: 'GASDAO.CC',
                            ticker: 'GASDAO.CC',
                            address: '0x1c0294b8a8ae3d64d8629de723cb9e44f5f12c63',
                            rawAmount: '9500000000000',
                            decimal: 8,
                            amount: '95000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MINIDOGE',
                            ticker: 'MINIDOGE',
                            address: '0x50fa1d465b2a4a13d64e9fa428ccc98ec873ae64',
                            rawAmount: '500000000000000000000000000000',
                            decimal: 18,
                            amount: '500000000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'VELO',
                            ticker: 'VELO',
                            address: '0x17d1285bc68d9085f8e4b86fc565e452b29dc48f',
                            rawAmount: '150000000000000000000000',
                            decimal: 18,
                            amount: '150000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ARTQ.ME',
                            ticker: 'ARTQ.ME',
                            address: '0xf0ef30735455d5315873cc2e2966cb20047bdb29',
                            rawAmount: '6000000000000000000000',
                            decimal: 18,
                            amount: '6000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'USDCSWAP.ORG',
                            ticker: 'USDCSWAP.ORG',
                            address: '0x43217359af5f01cf82c12a7a058ba221acdaef38',
                            rawAmount: '500',
                            decimal: 0,
                            amount: '500',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: '1INCH',
                            ticker: '1INCH',
                            address: '0x111111111117dc0aa78b770fa6a738034120c302',
                            rawAmount: '271002710027100234',
                            decimal: 18,
                            amount: '0.271002710027100234',
                            logo: 'https://api.rango.exchange/i/9D6oXE',
                            usdPrice: 0.397
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MAI',
                            ticker: 'MAI',
                            address: '0x3f56e0c36d275367b8c502090edf38289b3dea0d',
                            rawAmount: '19277503723092914708',
                            decimal: 18,
                            amount: '19.277503723092914708',
                            logo: 'https://api.rango.exchange/i/rcaHva',
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ATOM',
                            ticker: 'ATOM',
                            address: '0x0eb3a705fc54725037cc9e008bdede697f62f335',
                            rawAmount: '28750711363627413',
                            decimal: 18,
                            amount: '0.028750711363627413',
                            logo: 'https://api.rango.exchange/i/UT9ERo',
                            usdPrice: 8.94
                        },
                        {
                            chain: 'BSC',
                            symbol: '1GAS.ORG',
                            ticker: '1GAS.ORG',
                            address: '0xd35f9ab96d04adb02fd549ef6a576ce4e2c1d935',
                            rawAmount: '92280000000000000000000',
                            decimal: 18,
                            amount: '92280',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BOHM',
                            ticker: 'BOHM',
                            address: '0xbe2bac22b5f4d1126c705cb21335960531bae847',
                            rawAmount: '100000000000000000000',
                            decimal: 18,
                            amount: '100',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BTCB',
                            ticker: 'BTCB',
                            address: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
                            rawAmount: '71529099712895',
                            decimal: 18,
                            amount: '0.000071529099712895',
                            logo: 'https://api.rango.exchange/i/MHEGHG',
                            usdPrice: 16863.776
                        },
                        {
                            chain: 'BSC',
                            symbol: 'EDG',
                            ticker: 'EDG',
                            address: '0xa2e26f5f663e18fa942db6edf3269449d75d6d85',
                            rawAmount: '10000000000',
                            decimal: 25,
                            amount: '0.000000000000001',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SUSHI',
                            ticker: 'SUSHI',
                            address: '0x947950bcc74888a40ffa2593c5798f11fc9124c4',
                            rawAmount: '836519539228464427',
                            decimal: 18,
                            amount: '0.836519539228464427',
                            logo: 'https://api.rango.exchange/i/NgIT7y',
                            usdPrice: 0.941
                        },
                        {
                            chain: 'BSC',
                            symbol: 'PGAME',
                            ticker: 'PGAME',
                            address: '0x4dc90e30015af10e64a2f1ac390754cfb0454373',
                            rawAmount: '10952400',
                            decimal: 6,
                            amount: '10.9524',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MATIC',
                            ticker: 'MATIC',
                            address: '0xcc42724c6683b7e57334c4e856f4c9965ed682bd',
                            rawAmount: '1000000008755996216',
                            decimal: 18,
                            amount: '1.000000008755996216',
                            logo: 'https://api.rango.exchange/i/vTlTjv',
                            usdPrice: 0.791
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FISTDAO',
                            ticker: 'FISTDAO',
                            address: '0x41791dab02a1f9b2430cd46f2c6a2b33aa7fd25d',
                            rawAmount: '880000000000',
                            decimal: 9,
                            amount: '880',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FF18.IO',
                            ticker: 'FF18.IO',
                            address: '0x491b25000d386cd31307580171a510d32d7e64ee',
                            rawAmount: '800000000000000000000000',
                            decimal: 18,
                            amount: '800000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'RAY',
                            ticker: 'RAY',
                            address: '0x13b6a55662f6591f8b8408af1c73b017e32eedb8',
                            rawAmount: '4793579',
                            decimal: 6,
                            amount: '4.793579',
                            logo: 'https://api.rango.exchange/i/kNjVdm',
                            usdPrice: 0.15
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AGEUR',
                            ticker: 'AGEUR',
                            address: '0x38c84d5bbad726d465cf6a5349e41d6d7095faf7',
                            rawAmount: '8242220000000000',
                            decimal: 18,
                            amount: '0.00824222',
                            logo: 'https://api.rango.exchange/i/d5IrO0',
                            usdPrice: 1.059
                        },
                        {
                            chain: 'BSC',
                            symbol: 'KK',
                            ticker: 'KK',
                            address: '0x482794a6efb37e3fbd51f537c7102e9ab188b818',
                            rawAmount: '53000000000000000000',
                            decimal: 18,
                            amount: '53',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'O3',
                            ticker: 'O3',
                            address: '0xee9801669c6138e84bd50deb500827b776777d28',
                            rawAmount: '1256000000000000000',
                            decimal: 18,
                            amount: '1.256',
                            logo: 'https://api.rango.exchange/i/lfPJOy',
                            usdPrice: 0.0443
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AIR',
                            ticker: 'AIR',
                            address: '0xbc6675de91e3da8eac51293ecb87c359019621cf',
                            rawAmount: '1921604000000000000000000',
                            decimal: 18,
                            amount: '1921604',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'DOGGY',
                            ticker: 'DOGGY',
                            address: '0x74926b3d118a63f6958922d3dc05eb9c6e6e00c6',
                            rawAmount: '283511485676805491',
                            decimal: 18,
                            amount: '0.283511485676805491',
                            logo: 'https://api.rango.exchange/i/1lJ2Z3',
                            usdPrice: 0.00031
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SEG',
                            ticker: 'SEG',
                            address: '0x2eeff21c71ae38f9c34496cd9250c0d186dcd988',
                            rawAmount: '100000000000000',
                            decimal: 18,
                            amount: '0.0001',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MIM',
                            ticker: 'MIM',
                            address: '0xfe19f0b51438fd612f6fd59c1dbb3ea319f433ba',
                            rawAmount: '15022048536804216097',
                            decimal: 18,
                            amount: '15.022048536804216097',
                            logo: 'https://api.rango.exchange/i/L5wafC',
                            usdPrice: 0.993
                        },
                        {
                            chain: 'BSC',
                            symbol: 'USDSWAP.IO',
                            ticker: 'USDSWAP.IO',
                            address: '0xb2ad5142b8ccb380731866bc42b3619759f3f7b3',
                            rawAmount: '1286698',
                            decimal: 0,
                            amount: '1286698',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'PSG',
                            ticker: 'PSG',
                            address: '0xbc5609612b7c44bef426de600b5fd1379db2ecf1',
                            rawAmount: '14',
                            decimal: 2,
                            amount: '0.14',
                            logo: 'https://api.rango.exchange/i/OiA2jQ',
                            usdPrice: 5.685
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ETH',
                            ticker: 'ETH',
                            address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
                            rawAmount: '14825954098793468',
                            decimal: 18,
                            amount: '0.014825954098793468',
                            logo: 'https://api.rango.exchange/i/qr4L6S',
                            usdPrice: 1209.693
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SAFEMOON',
                            ticker: 'SAFEMOON',
                            address: '0x2df0b14ee90671021b016dab59f2300fb08681fa',
                            rawAmount: '255',
                            decimal: 18,
                            amount: '0.000000000000000255',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'POODL',
                            ticker: 'POODL',
                            address: '0x4a68c250486a116dc8d6a0c5b0677de07cc09c5d',
                            rawAmount: '6184580930',
                            decimal: 9,
                            amount: '6.18458093',
                            logo: 'https://api.rango.exchange/i/ehIL4M',
                            usdPrice: 7.1e-9
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AVAX',
                            ticker: 'AVAX',
                            address: '0x1ce0c2827e2ef14d5c4f29a091d735a204794041',
                            rawAmount: '4705457968658479',
                            decimal: 18,
                            amount: '0.004705457968658479',
                            logo: 'https://api.rango.exchange/i/kX4edQ',
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MGRT',
                            ticker: 'MGRT',
                            address: '0xd08f7b01fdd26928dcdc956610a5332f17b3ea11',
                            rawAmount: '1119800000000000000',
                            decimal: 18,
                            amount: '1.1198',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'WBNB',
                            ticker: 'WBNB',
                            address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
                            rawAmount: '23374035802351054',
                            decimal: 18,
                            amount: '0.023374035802351054',
                            logo: 'https://api.rango.exchange/i/lRTcZT',
                            usdPrice: 248.431
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ANYFUSE',
                            ticker: 'ANYFUSE',
                            address: '0x43242138833e8d360e84920462a483eb9e35c8b4',
                            rawAmount: '32000000000000000000',
                            decimal: 18,
                            amount: '32',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AGILESWAP.IO',
                            ticker: 'AGILESWAP.IO',
                            address: '0xcf8b4e69707e22dc5062f80576d9f069275ed1b5',
                            rawAmount: '12000000000000',
                            decimal: 9,
                            amount: '12000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BNBM',
                            ticker: 'BNBM',
                            address: '0xe8d6eccf4df7067a52d43495c11b69deeedb965e',
                            rawAmount: '207961000000000000000000',
                            decimal: 18,
                            amount: '207961',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'PAYOU',
                            ticker: 'PAYOU',
                            address: '0x1e8f7bfdcf6d95eea81e039234624fa6b78bd389',
                            rawAmount: '923000000000000000000',
                            decimal: 18,
                            amount: '923',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AABEK',
                            ticker: 'AABEK',
                            address: '0x68d1569d1a6968f194b4d93f8d0b416c123a599f',
                            rawAmount: '20819314000000000',
                            decimal: 9,
                            amount: '20819314',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'TRX',
                            ticker: 'TRX',
                            address: '0x85eac5ac2f758618dfa09bdbe0cf174e7d574d5b',
                            rawAmount: '2425322528',
                            decimal: 18,
                            amount: '0.000000002425322528',
                            logo: 'https://api.rango.exchange/i/sJnSkq',
                            usdPrice: 0.055
                        },
                        {
                            chain: 'BSC',
                            symbol: 'RIFTDAO.NET',
                            ticker: 'RIFTDAO.NET',
                            address: '0x4f6a82bb5fd0996158c9ac6bd3605489cad82d8d',
                            rawAmount: '738097000000000000000000',
                            decimal: 18,
                            amount: '738097',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ETH-1INCH.IO',
                            ticker: 'ETH-1INCH.IO',
                            address: '0xa83b6a470771da2d979480b2e742962088608ced',
                            rawAmount: '870000000000000000',
                            decimal: 18,
                            amount: '0.87',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ODDZ',
                            ticker: 'ODDZ',
                            address: '0xcd40f2670cf58720b694968698a5514e924f742d',
                            rawAmount: '77970995683712403',
                            decimal: 18,
                            amount: '0.077970995683712403',
                            logo: 'https://api.rango.exchange/i/s6bU0A',
                            usdPrice: 0.0121
                        },
                        {
                            chain: 'BSC',
                            symbol: 'TBBT.ORG',
                            ticker: 'TBBT.ORG',
                            address: '0xbf7183b8c8e5bb2d10f63678abb5d52df72712b2',
                            rawAmount: '50000000000000000000000',
                            decimal: 18,
                            amount: '50000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'DASH',
                            ticker: 'DASH',
                            address: '0x3291a9352e553740bf78ce94fad611924b640d0f',
                            rawAmount: '100000000000000000000',
                            decimal: 18,
                            amount: '100',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BAKE',
                            ticker: 'BAKE',
                            address: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
                            rawAmount: '2896167082922666',
                            decimal: 18,
                            amount: '0.002896167082922666',
                            logo: 'https://api.rango.exchange/i/dQuv0N',
                            usdPrice: 0.141
                        },
                        {
                            chain: 'BSC',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
                            rawAmount: '15641472731959171181',
                            decimal: 18,
                            amount: '15.641472731959171181',
                            logo: 'https://api.rango.exchange/i/toXKGV',
                            usdPrice: 1.005
                        },
                        {
                            chain: 'BSC',
                            symbol: 'LTC',
                            ticker: 'LTC',
                            address: '0x4338665cbb7b2485a8855a139b75d5e34ab0db94',
                            rawAmount: '6918750157',
                            decimal: 18,
                            amount: '0.000000006918750157',
                            logo: 'https://api.rango.exchange/i/Rw2jCX',
                            usdPrice: 65.204
                        },
                        {
                            chain: 'BSC',
                            symbol: 'NEAR',
                            ticker: 'NEAR',
                            address: '0x1fa4a73a3f0133f0025378af00236f3abdee5d63',
                            rawAmount: '508963275751495577',
                            decimal: 18,
                            amount: '0.508963275751495577',
                            logo: 'https://api.rango.exchange/i/kL2qwj',
                            usdPrice: 1.298
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BTG',
                            ticker: 'BTG',
                            address: '0x1385e68e3b5ea66fc50a221f8dcbabbfd3ee282b',
                            rawAmount: '11000000000',
                            decimal: 6,
                            amount: '11000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'YTS',
                            ticker: 'YTS',
                            address: '0x3b4deb27a46e746776a661ecf523c42ed0400d54',
                            rawAmount: '9000000000000000000000000',
                            decimal: 18,
                            amount: '9000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FLOKI',
                            ticker: 'FLOKI',
                            address: '0x2b3f34e9d4b127797ce6244ea341a83733ddd6e4',
                            rawAmount: '62088935293887',
                            decimal: 9,
                            amount: '62088.935293887',
                            logo: 'https://api.rango.exchange/i/UhBFxd',
                            usdPrice: 1.89e-7
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SXP',
                            ticker: 'SXP',
                            address: '0x47bead2563dcbf3bf2c9407fea4dc236faba485a',
                            rawAmount: '7193114712',
                            decimal: 18,
                            amount: '0.000000007193114712',
                            logo: 'https://api.rango.exchange/i/3njEos',
                            usdPrice: 0.207
                        },
                        {
                            chain: 'BSC',
                            symbol: 'COSMICMINE',
                            ticker: 'COSMICMINE',
                            address: '0xde1e01b3ab6aa67909e41330067be7a46ec16c38',
                            rawAmount: '300000000000000000',
                            decimal: 18,
                            amount: '0.3',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SPACEPI',
                            ticker: 'SPACEPI',
                            address: '0x69b14e8d3cebfdd8196bfe530954a0c226e5008e',
                            rawAmount: '5500000000000000',
                            decimal: 9,
                            amount: '5500000',
                            logo: 'https://api.rango.exchange/i/01weSc',
                            usdPrice: 1.02e-9
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ALPACA',
                            ticker: 'ALPACA',
                            address: '0x373233a38ae21cf0c4f9de11570e7d5aa6824a1e',
                            rawAmount: '28102000000000000000000000',
                            decimal: 18,
                            amount: '28102000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MNEB',
                            ticker: 'MNEB',
                            address: '0xd22202d23fe7de9e3dbe11a2a88f42f4cb9507cf',
                            rawAmount: '15000000000000',
                            decimal: 8,
                            amount: '150000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'DAO',
                            ticker: 'DAO',
                            address: '0x037b202ca88d2028d82936d5615ee5088cb9fd78',
                            rawAmount: '9970000000000000',
                            decimal: 18,
                            amount: '0.00997',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BRISE',
                            ticker: 'BRISE',
                            address: '0x8fff93e810a2edaafc326edee51071da9d398e83',
                            rawAmount: '10',
                            decimal: 9,
                            amount: '0.00000001',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: '3WORLDS.IO',
                            ticker: '3WORLDS.IO',
                            address: '0xc3238c3b7b8e32588a49c751aed808368e85122d',
                            rawAmount: '12000000000000',
                            decimal: 9,
                            amount: '12000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ARKR.ORG',
                            ticker: 'ARKR.ORG',
                            address: '0x04645027122c9f152011f128c7085449b27cb6d7',
                            rawAmount: '800000000000000000000000',
                            decimal: 18,
                            amount: '800000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'WADAX',
                            ticker: 'WADAX',
                            address: '0x35122d1fe8001296f61290b8ba42ef597af31fb7',
                            rawAmount: '1000000000000',
                            decimal: 6,
                            amount: '1000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BNBW',
                            ticker: 'BNBW',
                            address: '0x5558447b06867ffebd87dd63426d61c868c45904',
                            rawAmount: '23752199000000000',
                            decimal: 9,
                            amount: '23752199',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'QI',
                            ticker: 'QI',
                            address: '0x8729438eb15e2c8b576fcc6aecda6a148776c0f5',
                            rawAmount: '208452535759624275628',
                            decimal: 18,
                            amount: '208.452535759624275628',
                            logo: 'https://api.rango.exchange/i/PwbKO2',
                            usdPrice: 0.00664
                        },
                        {
                            chain: 'BSC',
                            symbol: 'CAKE',
                            ticker: 'CAKE',
                            address: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
                            rawAmount: '132130918185825847',
                            decimal: 18,
                            amount: '0.132130918185825847',
                            logo: 'https://api.rango.exchange/i/UA0myt',
                            usdPrice: 3.433
                        },
                        {
                            chain: 'BSC',
                            symbol: 'LINKP.IO',
                            ticker: 'LINKP.IO',
                            address: '0xd5e3bf9045cfb1e6ded4b35d1b9c34be16d6eec3',
                            rawAmount: '800000000000000000000000',
                            decimal: 18,
                            amount: '800000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BSCTOKEN',
                            ticker: 'BSCTOKEN',
                            address: '0x569b2cf0b745ef7fad04e8ae226251814b3395f9',
                            rawAmount: '23752199000000000',
                            decimal: 9,
                            amount: '23752199',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'VERSE',
                            ticker: 'VERSE',
                            address: '0xbb92b9d18db99c3695bc820bf2c876d4b1527fa5',
                            rawAmount: '3000000000000000',
                            decimal: 9,
                            amount: '3000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'VERA',
                            ticker: 'VERA',
                            address: '0x0df62d2cd80591798721ddc93001afe868c367ff',
                            rawAmount: '800000000000000000000000',
                            decimal: 18,
                            amount: '800000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SQUIDV2',
                            ticker: 'SQUIDV2',
                            address: '0xd85842708252c7752f9e503f90561068433d0044',
                            rawAmount: '1000000000000000000',
                            decimal: 18,
                            amount: '1',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0x4db5a66e937a9f4473fa95b1caf1d1e1d62e29ea',
                            rawAmount: '9430724572',
                            decimal: 18,
                            amount: '0.000000009430724572',
                            logo: 'https://api.rango.exchange/i/wNnplE',
                            usdPrice: 1396.147
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ATOM',
                            ticker: 'ATOM',
                            address: '0x725e02c7f9168f45b3699cfb7c262fb6dd355e84',
                            rawAmount: '99561480',
                            decimal: 6,
                            amount: '99.56148',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FLOKI',
                            ticker: 'FLOKI',
                            address: '0xfb5b838b6cfeedc2873ab27866079ac55363d37e',
                            rawAmount: '62088935293887',
                            decimal: 9,
                            amount: '62088.935293887',
                            logo: 'https://api.rango.exchange/i/fIrbfa',
                            usdPrice: 0.00000913
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AZSWAP.IO',
                            ticker: 'AZSWAP.IO',
                            address: '0xfd4c532a8c17bd326c2dc63b88d49306ce27f80b',
                            rawAmount: '18000000000000',
                            decimal: 9,
                            amount: '18000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'TU7.ORG',
                            ticker: 'TU7.ORG',
                            address: '0x442b656f5a5c3dd09790951810c5a15ea5295b51',
                            rawAmount: '7127850000000000',
                            decimal: 9,
                            amount: '7127850',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FLUX',
                            ticker: 'FLUX',
                            address: '0xb16600c510b0f323dee2cb212924d90e58864421',
                            rawAmount: '950000000000000000000000',
                            decimal: 18,
                            amount: '950000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'XRP',
                            ticker: 'XRP',
                            address: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
                            rawAmount: '5688021754',
                            decimal: 18,
                            amount: '0.000000005688021754',
                            logo: 'https://api.rango.exchange/i/zTYnq2',
                            usdPrice: 0.34
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BITTT.IO',
                            ticker: 'BITTT.IO',
                            address: '0x9603a3d3dcccf5ef1a2060a3da796ac084cc66eb',
                            rawAmount: '268551000000000000000000',
                            decimal: 18,
                            amount: '268551',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AXLUSDC',
                            ticker: 'AXLUSDC',
                            address: '0x4268b8f0b87b6eae5d897996e6b845ddbd99adf3',
                            rawAmount: '5978049',
                            decimal: 6,
                            amount: '5.978049',
                            logo: 'https://api.rango.exchange/tokens/COSMOS/AXLUSDC.png',
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SDJT',
                            ticker: 'SDJT',
                            address: '0xbb368656efa67361b0063fe0f11cb08bd460246d',
                            rawAmount: '100000000',
                            decimal: 9,
                            amount: '0.1',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ONE',
                            ticker: 'ONE',
                            address: '0x03ff0ff224f904be3118461335064bb48df47938',
                            rawAmount: '4789152388',
                            decimal: 18,
                            amount: '0.000000004789152388',
                            logo: 'https://api.rango.exchange/i/5MOMsg',
                            usdPrice: 0.0115
                        },
                        {
                            chain: 'BSC',
                            symbol: 'STI',
                            ticker: 'STI',
                            address: '0x4f5f7a7dca8ba0a7983381d23dfc5eaf4be9c79a',
                            rawAmount: '1000',
                            decimal: 10,
                            amount: '0.0000001',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'APE',
                            ticker: 'APE',
                            address: '0xa1b99485d58d70d86e455ab8823492090c3f43c0',
                            rawAmount: '350000000000000000000',
                            decimal: 18,
                            amount: '350',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'COOK',
                            ticker: 'COOK',
                            address: '0x965b0df5bda0e7a0649324d78f03d5f7f2de086a',
                            rawAmount: '35733206194802111275189',
                            decimal: 18,
                            amount: '35733.206194802111275189',
                            logo: 'https://api.rango.exchange/i/owq1WS',
                            usdPrice: 0.000247
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FUSE',
                            ticker: 'FUSE',
                            address: '0x5857c96dae9cf8511b08cb07f85753c472d36ea3',
                            rawAmount: '102000000000000000000',
                            decimal: 18,
                            amount: '102',
                            logo: 'https://api.rango.exchange/i/3hWqus',
                            usdPrice: 0.0603
                        },
                        {
                            chain: 'BSC',
                            symbol: 'CGB',
                            ticker: 'CGB',
                            address: '0x7e6202903275772044198d07b8a536cc064f8480',
                            rawAmount: '211000000',
                            decimal: 6,
                            amount: '211',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'DEF8.IO',
                            ticker: 'DEF8.IO',
                            address: '0x556798dd55db12562a6950ea8339a273539b0495',
                            rawAmount: '82445000000000000000000',
                            decimal: 18,
                            amount: '82445',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'WMATIC',
                            ticker: 'WMATIC',
                            address: '0xc836d8dc361e44dbe64c4862d55ba041f88ddd39',
                            rawAmount: '1887651939',
                            decimal: 18,
                            amount: '0.000000001887651939',
                            logo: 'https://api.rango.exchange/i/QpOgNr',
                            usdPrice: 0.791
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BSTAKE.NET',
                            ticker: 'BSTAKE.NET',
                            address: '0x1f040f15ab15b7e0dfac935873fadbe43d015535',
                            rawAmount: '480000000000000000000000',
                            decimal: 18,
                            amount: '480000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'XCH5.IO',
                            ticker: 'XCH5.IO',
                            address: '0xb3ec4e17c1c0079d977354875ab924c088325306',
                            rawAmount: '821112000000000',
                            decimal: 9,
                            amount: '821112',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FS',
                            ticker: 'FS',
                            address: '0xe3a41e4dacc892ecaedfa009be5baa2d3ab4844d',
                            rawAmount: '1003947318555099196',
                            decimal: 18,
                            amount: '1.003947318555099196',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BSC-COIN',
                            ticker: 'BSC-COIN',
                            address: '0xe3e1147acd39687a25ca7716227c604500f5c31a',
                            rawAmount: '5000000000000',
                            decimal: 6,
                            amount: '5000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'APEFESTPOAP.COM',
                            ticker: 'APEFESTPOAP.COM',
                            address: '0x57dac6482784a0f093483e6313804812fa177437',
                            rawAmount: '5555000000000000000000',
                            decimal: 18,
                            amount: '5555',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SAFEMOON-DIVIDEND.COM',
                            ticker: 'SAFEMOON-DIVIDEND.COM',
                            address: '0xdbe3e700ab26cbf3523d850b5d892fd17e0ce343',
                            rawAmount: '31820000000000000000000',
                            decimal: 18,
                            amount: '31820',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AXAX.IO',
                            ticker: 'AXAX.IO',
                            address: '0x58b5c4697dc70f3d889225260944cdd9c270c132',
                            rawAmount: '77000000000000',
                            decimal: 9,
                            amount: '77000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'RRDAO.NET',
                            ticker: 'RRDAO.NET',
                            address: '0xa47b34ff31e22ef03f6054af19542bcde260cdc7',
                            rawAmount: '738097000000000000000000',
                            decimal: 18,
                            amount: '738097',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ETP',
                            ticker: 'ETP',
                            address: '0x89679307c3d2e4e289da2ccd4d3c44ff39292189',
                            rawAmount: '100000000000000',
                            decimal: 18,
                            amount: '0.0001',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'DOT',
                            ticker: 'DOT',
                            address: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
                            rawAmount: '7180274458',
                            decimal: 18,
                            amount: '0.000000007180274458',
                            logo: 'https://api.rango.exchange/i/suQRJx',
                            usdPrice: 4.528
                        },
                        {
                            chain: 'BSC',
                            symbol: 'AGMC.IO',
                            ticker: 'AGMC.IO',
                            address: '0xef27b9cb67aa93ec3494a60f1ea9380e86175b26',
                            rawAmount: '800000000000000000000000',
                            decimal: 18,
                            amount: '800000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'RDRIP',
                            ticker: 'RDRIP',
                            address: '0xa02a0b2d67d4fa48677a79cadc483e114049916d',
                            rawAmount: '40214587120000',
                            decimal: 6,
                            amount: '40214587.12',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BUSD',
                            ticker: 'BUSD',
                            address: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
                            rawAmount: '2925825323281948117',
                            decimal: 18,
                            amount: '2.925825323281948117',
                            logo: 'https://api.rango.exchange/i/tY13sD',
                            usdPrice: 1.001
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MKS',
                            ticker: 'MKS',
                            address: '0x64f2c2aa04755507a2ecd22ceb8c475b7a750a3a',
                            rawAmount: '6500000000000000000000000',
                            decimal: 18,
                            amount: '6500000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BITMARTEX.COM',
                            ticker: 'BITMARTEX.COM',
                            address: '0xdac0bb03158048b70abcfeb3be2607b625526f20',
                            rawAmount: '400000000000000000000',
                            decimal: 18,
                            amount: '400',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'APT',
                            ticker: 'APT',
                            address: '0xec811fbcd12f67874891cdbbbc95d9f73db3fbb0',
                            rawAmount: '40000000',
                            decimal: 6,
                            amount: '40',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MELLO',
                            ticker: 'MELLO',
                            address: '0x0198be93b7cae38da7e2fd966946412cc36447bf',
                            rawAmount: '17777000000000000000000',
                            decimal: 18,
                            amount: '17777',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ICE',
                            ticker: 'ICE',
                            address: '0xf16e81dce15b08f326220742020379b855b87df9',
                            rawAmount: '3071447531',
                            decimal: 18,
                            amount: '0.000000003071447531',
                            logo: 'https://api.rango.exchange/i/my1npH',
                            usdPrice: 0.121
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ADDBNB.COM',
                            ticker: 'ADDBNB.COM',
                            address: '0x617bf230a6886accec5952385eed8bc85d1a09b2',
                            rawAmount: '29998899999900',
                            decimal: 8,
                            amount: '299988.999999',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'POWNFT.NET',
                            ticker: 'POWNFT.NET',
                            address: '0x893c25c46bfaa9b66cd557837d32af3fe264a07b',
                            rawAmount: '96816550000000000000000',
                            decimal: 18,
                            amount: '96816.55',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MINIDOGE',
                            ticker: 'MINIDOGE',
                            address: '0x9b1ba20ae9335197c72be094d4fa300d4ef95351',
                            rawAmount: '500000000000000000000000000000',
                            decimal: 18,
                            amount: '500000000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FIFA',
                            ticker: 'FIFA',
                            address: '0xe19417837d8e61f17dfae2e6a11b1e4810dae2a5',
                            rawAmount: '99000000000000',
                            decimal: 18,
                            amount: '0.000099',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MDT',
                            ticker: 'MDT',
                            address: '0x668db7aa38eac6b40c9d13dbe61361dc4c4611d1',
                            rawAmount: '4965562423',
                            decimal: 18,
                            amount: '0.000000004965562423',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ZIL',
                            ticker: 'ZIL',
                            address: '0xb86abcb37c3a4b64f74f59301aff131a1becc787',
                            rawAmount: '5995',
                            decimal: 12,
                            amount: '0.000000005995',
                            logo: 'https://api.rango.exchange/i/aiPfMq',
                            usdPrice: 0.0176
                        },
                        {
                            chain: 'BSC',
                            symbol: ' "995$ VISIT USDTREWARD.COM TO CLAIM',
                            ticker: ' "995$ VISIT USDTREWARD.COM TO CLAIM',
                            address: '0x67c4a6da86da4f45030904b143d6b00d25e366e9',
                            rawAmount: '6',
                            decimal: 0,
                            amount: '6',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ADA',
                            ticker: 'ADA',
                            address: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
                            rawAmount: '6081419213',
                            decimal: 18,
                            amount: '0.000000006081419213',
                            logo: 'https://api.rango.exchange/i/ne4pEv',
                            usdPrice: 0.25
                        },
                        {
                            chain: 'BSC',
                            symbol: 'ZEPE.IO',
                            ticker: 'ZEPE.IO',
                            address: '0xb0557906c617f0048a700758606f64b33d0c41a6',
                            rawAmount: '750000000000000000000000',
                            decimal: 18,
                            amount: '750000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MN',
                            ticker: 'MN',
                            address: '0x1a09f518a8293d519de20700076ad9cd2125d224',
                            rawAmount: '454000000000000',
                            decimal: 18,
                            amount: '0.000454',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'EVER',
                            ticker: 'EVER',
                            address: '0x5190b01965b6e3d786706fd4a999978626c19880',
                            rawAmount: '800000000000000000000000',
                            decimal: 18,
                            amount: '800000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'SGC',
                            ticker: 'SGC',
                            address: '0x7aa3a53360541283ffa9192972223b47a902dc0c',
                            rawAmount: '1450000000000',
                            decimal: 6,
                            amount: '1450000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BCH',
                            ticker: 'BCH',
                            address: '0x8ff795a6f4d97e7887c79bea79aba5cc76444adf',
                            rawAmount: '208175286',
                            decimal: 18,
                            amount: '0.000000000208175286',
                            logo: 'https://api.rango.exchange/i/TPdCZV',
                            usdPrice: 101.758
                        },
                        {
                            chain: 'BSC',
                            symbol: 'KK8.IO',
                            ticker: 'KK8.IO',
                            address: '0x2ba6204c23fbd5698ed90abc911de263e5f41266',
                            rawAmount: '166574000000000000000000',
                            decimal: 18,
                            amount: '166574',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BCNFT',
                            ticker: 'BCNFT',
                            address: '0xe5677103191711bad85cf99e0dfc9b35449b790b',
                            rawAmount: '99800000000000000000',
                            decimal: 18,
                            amount: '99.8',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'MNFLX',
                            ticker: 'MNFLX',
                            address: '0xa04f060077d90fe2647b61e4da4ad1f97d6649dc',
                            rawAmount: '18298000000000000',
                            decimal: 18,
                            amount: '0.018298',
                            logo: 'https://api.rango.exchange/i/66c2BP',
                            usdPrice: null
                        },
                        {
                            chain: 'BSC',
                            symbol: 'FIL',
                            ticker: 'FIL',
                            address: '0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153',
                            rawAmount: '166801647873165921',
                            decimal: 18,
                            amount: '0.166801647873165921',
                            logo: 'https://api.rango.exchange/i/diq2au',
                            usdPrice: 2.925
                        },
                        {
                            chain: 'BSC',
                            symbol: 'DAI',
                            ticker: 'DAI',
                            address: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
                            rawAmount: '7308178549281467169',
                            decimal: 18,
                            amount: '7.308178549281467169',
                            logo: 'https://api.rango.exchange/i/EcBuF8',
                            usdPrice: 1.002
                        },
                        {
                            chain: 'BSC',
                            symbol: 'BNB',
                            ticker: 'BNB',
                            address: null,
                            rawAmount: '64638855809280692',
                            decimal: 18,
                            amount: '0.064638855809280692',
                            logo: 'https://api.rango.exchange/i/Y3v1KW',
                            usdPrice: null
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://bscscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'POLYGON',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: true,
                    error: true,
                    explorerUrl: 'https://polygonscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'ETH',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'ETH',
                            symbol: 'BAT',
                            ticker: 'BAT',
                            address: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
                            rawAmount: '4000000000000000000',
                            decimal: 18,
                            amount: '4',
                            logo: 'https://api.rango.exchange/i/fRlt4J',
                            usdPrice: 0.187
                        },
                        {
                            chain: 'ETH',
                            symbol: 'WBTC',
                            ticker: 'WBTC',
                            address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
                            rawAmount: '4777',
                            decimal: 8,
                            amount: '0.00004777',
                            logo: 'https://api.rango.exchange/i/LZSo9D',
                            usdPrice: 16748.345
                        },
                        {
                            chain: 'ETH',
                            symbol: 'BUSD',
                            ticker: 'BUSD',
                            address: '0x4fabb145d64652a948d72533023f6e7a623c7c53',
                            rawAmount: '44533649981450616971',
                            decimal: 18,
                            amount: '44.533649981450616971',
                            logo: 'https://api.rango.exchange/i/sQLw6p',
                            usdPrice: 0.996
                        },
                        {
                            chain: 'ETH',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
                            rawAmount: '68026943',
                            decimal: 6,
                            amount: '68.026943',
                            logo: 'https://api.rango.exchange/i/ns0AMf',
                            usdPrice: 0.998
                        },
                        {
                            chain: 'ETH',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                            rawAmount: '69476760000000000',
                            decimal: 18,
                            amount: '0.06947676',
                            logo: 'https://api.rango.exchange/i/yZ9N1N',
                            usdPrice: 1207.06
                        },
                        {
                            chain: 'ETH',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
                            rawAmount: '458820363',
                            decimal: 6,
                            amount: '458.820363',
                            logo: 'https://api.rango.exchange/i/aR1yFx',
                            usdPrice: 0.999
                        },
                        {
                            chain: 'ETH',
                            symbol: 'RENBTC',
                            ticker: 'RENBTC',
                            address: '0xeb4c2781e4eba804ce9a9803c67d0893436bb27d',
                            rawAmount: '92825',
                            decimal: 8,
                            amount: '0.00092825',
                            logo: 'https://api.rango.exchange/i/kwXCDn',
                            usdPrice: 17122.537
                        },
                        {
                            chain: 'ETH',
                            symbol: 'ETH',
                            ticker: 'ETH',
                            address: null,
                            rawAmount: '216333389734077345',
                            decimal: 18,
                            amount: '0.216333389734077345',
                            logo: 'https://api.rango.exchange/i/MTyH5i',
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'MATIC',
                            ticker: 'MATIC',
                            address: '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0',
                            rawAmount: '31663446408882142552',
                            decimal: 18,
                            amount: '31.663446408882142552',
                            logo: 'https://api.rango.exchange/i/xt6ATN',
                            usdPrice: 0.79
                        },
                        {
                            chain: 'ETH',
                            symbol: 'DAI',
                            ticker: 'DAI',
                            address: '0x6b175474e89094c44da98b954eedeac495271d0f',
                            rawAmount: '1987151466068153485',
                            decimal: 18,
                            amount: '1.987151466068153485',
                            logo: 'https://api.rango.exchange/i/yJvJre',
                            usdPrice: 0.999
                        },
                        {
                            chain: 'ETH',
                            symbol: 'TUSD',
                            ticker: 'TUSD',
                            address: '0x0000000000085d4780b73119b644ae5ecd22b376',
                            rawAmount: '16993200000000000000',
                            decimal: 18,
                            amount: '16.9932',
                            logo: 'https://api.rango.exchange/i/af3mkt',
                            usdPrice: 0.994
                        },
                        {
                            chain: 'ETH',
                            symbol: 'SUSHI',
                            ticker: 'SUSHI',
                            address: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
                            rawAmount: '3943357318101926305',
                            decimal: 18,
                            amount: '3.943357318101926305',
                            logo: 'https://api.rango.exchange/i/2GXZEZ',
                            usdPrice: 0.951
                        },
                        {
                            chain: 'ETH',
                            symbol: 'AAVE',
                            ticker: 'AAVE',
                            address: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
                            rawAmount: '25162269244382386',
                            decimal: 18,
                            amount: '0.025162269244382386',
                            logo: 'https://api.rango.exchange/i/ZizYhl',
                            usdPrice: 55.363
                        },
                        {
                            chain: 'ETH',
                            symbol: 'PERP',
                            ticker: 'PERP',
                            address: '0xbc396689893d065f41bc2c6ecbee5e0085233447',
                            rawAmount: '6774928920',
                            decimal: 18,
                            amount: '0.00000000677492892',
                            logo: 'https://api.rango.exchange/i/VrMbR6',
                            usdPrice: 0.39
                        },
                        {
                            chain: 'ETH',
                            symbol: 'STETH',
                            ticker: 'STETH',
                            address: '0xae7ab96520de3a18e5e111b5eaab095312d7fe84',
                            rawAmount: '39341623',
                            decimal: 18,
                            amount: '0.000000000039341623',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'SHIB',
                            ticker: 'SHIB',
                            address: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
                            rawAmount: '414477447646226736858871',
                            decimal: 18,
                            amount: '414477.447646226736858871',
                            logo: 'https://api.rango.exchange/i/cbCyuY',
                            usdPrice: 0.00000824
                        },
                        {
                            chain: 'ETH',
                            symbol: 'EROWAN',
                            ticker: 'EROWAN',
                            address: '0x07bac35846e5ed502aa91adf6a9e7aa210f2dcbe',
                            rawAmount: '17095432307032160581',
                            decimal: 18,
                            amount: '17.095432307032160581',
                            logo: 'https://api.rango.exchange/i/X97ibo',
                            usdPrice: 0.000317
                        },
                        {
                            chain: 'ETH',
                            symbol: 'UST',
                            ticker: 'UST',
                            address: '0xa693b19d2931d498c5b318df961919bb4aee87a5',
                            rawAmount: '1000000',
                            decimal: 6,
                            amount: '1',
                            logo: 'https://api.rango.exchange/i/IvLUkp',
                            usdPrice: 0.02
                        },
                        {
                            chain: 'ETH',
                            symbol: 'XDATA',
                            ticker: 'XDATA',
                            address: '0x0cf0ee63788a0849fe5297f3407f701e122cc023',
                            rawAmount: '230414265395638755692',
                            decimal: 18,
                            amount: '230.414265395638755692',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'bETH',
                            ticker: 'bETH',
                            address: '0x707f9118e33a9b8998bea41dd0d46f38bb963fc8',
                            rawAmount: '184000000000000',
                            decimal: 18,
                            amount: '0.000184',
                            logo: 'https://api.rango.exchange/tokens/TERRA/BETH.png',
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'AKSWAP.IO',
                            ticker: 'AKSWAP.IO',
                            address: '0x82dfdb2ec1aa6003ed4acba663403d7c2127ff67',
                            rawAmount: '250000000000000000000000',
                            decimal: 18,
                            amount: '250000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'WBNB',
                            ticker: 'WBNB',
                            address: '0x418d75f65a02b3d53b2418fb8e1fe493759c7605',
                            rawAmount: '10000000000000000',
                            decimal: 18,
                            amount: '0.01',
                            logo: 'https://api.rango.exchange/i/Xzflek',
                            usdPrice: 248.36
                        },
                        {
                            chain: 'ETH',
                            symbol: 'RANGO',
                            ticker: 'RANGO',
                            address: '0x5846d81d8e4a3b9cc53ce1dcdc12b6619ae3507d',
                            rawAmount: '40000000',
                            decimal: 6,
                            amount: '40',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'LUNAV2.IO (LUNA TOKEN)',
                            ticker: 'LUNAV2.IO (LUNA TOKEN)',
                            address: '0xaf0b2fbedd5d1fda457580fb3dabad1f5c8bbc36',
                            rawAmount: '258542000000000000000000',
                            decimal: 18,
                            amount: '258542',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'LUNA 2.0 (LUNAV2.IO)',
                            ticker: 'LUNA 2.0 (LUNAV2.IO)',
                            address: '0x471c3a7f132bc94938516cb2bf6f02c7521d2797',
                            rawAmount: '250457000000000000000000',
                            decimal: 18,
                            amount: '250457',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'LIDOLP.COM',
                            ticker: 'LIDOLP.COM',
                            address: '0x0332d00ae8e9baa609edc48844f48fdd94ca9547',
                            rawAmount: '6000',
                            decimal: 0,
                            amount: '6000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'HBOT',
                            ticker: 'HBOT',
                            address: '0xe5097d9baeafb89f9bcb78c9290d545db5f9e9cb',
                            rawAmount: '155042558533708582423',
                            decimal: 18,
                            amount: '155.042558533708582423',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: '1650811245.077F',
                            ticker: '1650811245.077F',
                            address: '0xba8d75baccc4d5c4bd814fde69267213052ea663',
                            rawAmount: '1000000000000000000',
                            decimal: 18,
                            amount: '1',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'PWING',
                            ticker: 'PWING',
                            address: '0xdb0f18081b505a7de20b18ac41856bcb4ba86a1a',
                            rawAmount: '498133925',
                            decimal: 9,
                            amount: '0.498133925',
                            logo: 'https://api.rango.exchange/i/Ba5IQF',
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'VISIT [AAVE-SR.XYZ] AND CLAIM SPECIAL REWARDS',
                            ticker: 'VISIT [AAVE-SR.XYZ] AND CLAIM SPECIAL REWARDS',
                            address: '0xd1e61fcb6e26d4deffa77f21cc5b581c3afa95e2',
                            rawAmount: '920816400',
                            decimal: 6,
                            amount: '920.8164',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'VISIT [AUSD.SHOP] AND SUPPLY OR BORROW USDT',
                            ticker: 'VISIT [AUSD.SHOP] AND SUPPLY OR BORROW USDT',
                            address: '0x38715ab4b9d4e00890773d7338d94778b0dfc0a8',
                            rawAmount: '2294101815',
                            decimal: 6,
                            amount: '2294.101815',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: '[LIDOSR.XYZ] CLAIM YOUR SPECIAL REWARDS.',
                            ticker: '[LIDOSR.XYZ] CLAIM YOUR SPECIAL REWARDS.',
                            address: '0x511b5f248269c0b90b60e33ef9df744048c84a83',
                            rawAmount: '149260000',
                            decimal: 6,
                            amount: '149.26',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'ENJOY [HTTPS://SPINGAME.ME]',
                            ticker: 'ENJOY [HTTPS://SPINGAME.ME]',
                            address: '0xcdc94877e4164d2e915fc5e8310155d661a995f1',
                            rawAmount: '2294101815',
                            decimal: 6,
                            amount: '2294.101815',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: 'WMATIC',
                            ticker: 'WMATIC',
                            address: '0x7c9f4c87d911613fe9ca58b579f737911aad2d43',
                            rawAmount: '100000000000000000',
                            decimal: 18,
                            amount: '0.1',
                            logo: 'https://api.rango.exchange/i/QpOgNr',
                            usdPrice: null
                        },
                        {
                            chain: 'ETH',
                            symbol: '$ VISIT NFTGIFTX.COM TO CLAIM',
                            ticker: '$ VISIT NFTGIFTX.COM TO CLAIM',
                            address: '0x0d3716e3e411af431a6e87e715d4b05bbcd67000',
                            rawAmount: '4000',
                            decimal: 0,
                            amount: '4000',
                            logo: null,
                            usdPrice: null
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://etherscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'AVAX_CCHAIN',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'BNB',
                            ticker: 'BNB',
                            address: '0x264c1383ea520f73dd837f915ef3a732e204a493',
                            rawAmount: '7107381667',
                            decimal: 18,
                            amount: '0.000000007107381667',
                            logo: 'https://api.rango.exchange/i/BtRUoA',
                            usdPrice: 247.386
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'TUSD',
                            ticker: 'TUSD',
                            address: '0x1c20e891bab6b1727d14da358fae2984ed9b59eb',
                            rawAmount: '2819919094',
                            decimal: 18,
                            amount: '0.000000002819919094',
                            logo: 'https://api.rango.exchange/i/UBghmk',
                            usdPrice: 1
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'SOL',
                            ticker: 'SOL',
                            address: '0xfe6b19286885a4f7f55adad09c3cd1f906d2478f',
                            rawAmount: '110',
                            decimal: 9,
                            amount: '0.00000011',
                            logo: 'https://api.rango.exchange/i/YhJ1nK',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'OPENDAO.IS',
                            ticker: 'OPENDAO.IS',
                            address: '0xc03f94e49c944c4f118c3f97af7cce8f01df9430',
                            rawAmount: '10000000000000000000',
                            decimal: 18,
                            amount: '10',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'IMX.A',
                            ticker: 'IMX.A',
                            address: '0xea6887e4a9cda1b77e70129e5fba830cdb5cddef',
                            rawAmount: '7119477388984802736',
                            decimal: 18,
                            amount: '7.119477388984802736',
                            logo: 'https://api.rango.exchange/i/qhi6I3',
                            usdPrice: 0.000139
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'AVAXCLASSIC.COM',
                            ticker: 'AVAXCLASSIC.COM',
                            address: '0x4c4f4f4122c3a80d30c1ad6ad2828953015bd52c',
                            rawAmount: '74041750000000000000',
                            decimal: 18,
                            amount: '74.04175',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'ORBS',
                            ticker: 'ORBS',
                            address: '0x340fe1d898eccaad394e2ba0fc1f93d27c7b717a',
                            rawAmount: '7336115152',
                            decimal: 18,
                            amount: '0.000000007336115152',
                            logo: 'https://api.rango.exchange/i/hktmCG',
                            usdPrice: 0.0228
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'PENDLE',
                            ticker: 'PENDLE',
                            address: '0xfb98b335551a418cd0737375a2ea0ded62ea213b',
                            rawAmount: '43168168325557885527',
                            decimal: 18,
                            amount: '43.168168325557885527',
                            logo: 'https://api.rango.exchange/i/p4dkte',
                            usdPrice: 0.046
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'WMATIC',
                            ticker: 'WMATIC',
                            address: '0xf2f13f0b7008ab2fa4a2418f4ccc3684e49d20eb',
                            rawAmount: '45499998000000000000',
                            decimal: 18,
                            amount: '45.499998',
                            logo: 'https://api.rango.exchange/i/QpOgNr',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'avaxUSDC',
                            ticker: 'avaxUSDC',
                            address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
                            rawAmount: '15844946',
                            decimal: 6,
                            amount: '15.844946',
                            logo: 'https://api.rango.exchange/i/FHj2LZ',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'SPELL',
                            ticker: 'SPELL',
                            address: '0xce1bffbd5374dac86a2893119683f4911a2f7814',
                            rawAmount: '144687727088072773130',
                            decimal: 18,
                            amount: '144.68772708807277313',
                            logo: 'https://api.rango.exchange/i/zW5ZK2',
                            usdPrice: 0.000535
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'WBNB',
                            ticker: 'WBNB',
                            address: '0x442f7f22b1ee2c842beaff52880d4573e9201158',
                            rawAmount: '57933890000000000',
                            decimal: 18,
                            amount: '0.05793389',
                            logo: 'https://api.rango.exchange/i/Xzflek',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'GMX',
                            ticker: 'GMX',
                            address: '0x62edc0692bd897d2295872a9ffcac5425011c661',
                            rawAmount: '379543333707025854',
                            decimal: 18,
                            amount: '0.379543333707025854',
                            logo: 'https://api.rango.exchange/i/0aQTDd',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'JOE',
                            ticker: 'JOE',
                            address: '0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd',
                            rawAmount: '35980183723492368253',
                            decimal: 18,
                            amount: '35.980183723492368253',
                            logo: 'https://api.rango.exchange/i/Vw0Fv2',
                            usdPrice: 0.141
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'WETH.E',
                            ticker: 'WETH.E',
                            address: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
                            rawAmount: '17684493183273648',
                            decimal: 18,
                            amount: '0.017684493183273648',
                            logo: 'https://api.rango.exchange/i/j9xgdC',
                            usdPrice: 1210.2
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'UST',
                            ticker: 'UST',
                            address: '0xb599c3590f42f8f995ecfa0f85d2980b76862fc1',
                            rawAmount: '3993',
                            decimal: 6,
                            amount: '0.003993',
                            logo: 'https://api.rango.exchange/i/0lk6id',
                            usdPrice: 0.02
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0xde3a24028580884448a5397872046a019649b084',
                            rawAmount: '35748023',
                            decimal: 6,
                            amount: '35.748023',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: '24DROP.NET',
                            ticker: '24DROP.NET',
                            address: '0x2be494c06316c0d7371250419a9c659a0752ecb3',
                            rawAmount: '200000000000',
                            decimal: 8,
                            amount: '2000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0x8b82a291f83ca07af22120aba21632088fc92931',
                            rawAmount: '5200000000000000',
                            decimal: 18,
                            amount: '0.0052',
                            logo: 'https://api.rango.exchange/i/wNnplE',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: '0006648936.E9CB',
                            ticker: '0006648936.E9CB',
                            address: '0x38dcf0532699b880e6a125f7d918380524cd60a6',
                            rawAmount: '10000000000000000000',
                            decimal: 18,
                            amount: '10',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: '$ FREE CLAIM AND PLAY',
                            ticker: '$ FREE CLAIM AND PLAY',
                            address: '0xd23345e0e6340616b1cf7200762d0289547ccf87',
                            rawAmount: '50000000000',
                            decimal: 8,
                            amount: '500',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'AMPL',
                            ticker: 'AMPL',
                            address: '0x027dbca046ca156de9622cd1e2d907d375e53aa7',
                            rawAmount: '8302538186',
                            decimal: 9,
                            amount: '8.302538186',
                            logo: 'https://api.rango.exchange/i/AiXtEj',
                            usdPrice: 1.078
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
                            rawAmount: '35280647',
                            decimal: 6,
                            amount: '35.280647',
                            logo: 'https://api.rango.exchange/i/9e1hH8',
                            usdPrice: 1.005
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'MNEAV',
                            ticker: 'MNEAV',
                            address: '0xf9d922c055a3f1759299467dafafdf43be844f7a',
                            rawAmount: '30000000000000',
                            decimal: 8,
                            amount: '300000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'USDC.E',
                            ticker: 'USDC.E',
                            address: '0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664',
                            rawAmount: '92749613',
                            decimal: 6,
                            amount: '92.749613',
                            logo: 'https://api.rango.exchange/i/j9eYAa',
                            usdPrice: 1
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'BLIZZ',
                            ticker: 'BLIZZ',
                            address: '0xb147656604217a03fe2c73c4838770df8d9d21b8',
                            rawAmount: '135470487277154696313',
                            decimal: 18,
                            amount: '135.470487277154696313',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0xc7198437980c041c805a1edcba50c1ce5db95118',
                            rawAmount: '36943578',
                            decimal: 6,
                            amount: '36.943578',
                            logo: 'https://api.rango.exchange/i/niIihm',
                            usdPrice: null
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'MIM',
                            ticker: 'MIM',
                            address: '0x130966628846bfd36ff31a822705796e8cb8c18d',
                            rawAmount: '13661627814282704200',
                            decimal: 18,
                            amount: '13.6616278142827042',
                            logo: 'https://api.rango.exchange/i/RmsZZl',
                            usdPrice: 0.998
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'WAVAX',
                            ticker: 'WAVAX',
                            address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
                            rawAmount: '553221840010000000',
                            decimal: 18,
                            amount: '0.55322184001',
                            logo: 'https://api.rango.exchange/i/9bwFaG',
                            usdPrice: 11.97
                        },
                        {
                            chain: 'AVAX_CCHAIN',
                            symbol: 'AVAX',
                            ticker: 'AVAX',
                            address: null,
                            rawAmount: '3293457782165450159',
                            decimal: 18,
                            amount: '3.293457782165450159',
                            logo: 'https://api.rango.exchange/i/kX4edQ',
                            usdPrice: 11.77
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://snowtrace.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'ARBITRUM',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'ARBITRUM',
                            symbol: 'JONES',
                            ticker: 'JONES',
                            address: '0x10393c20975cf177a3513071bc110f7962cd67da',
                            rawAmount: '1933131668197791405',
                            decimal: 18,
                            amount: '1.933131668197791405',
                            logo: 'https://api.rango.exchange/i/FUexNn',
                            usdPrice: null
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'DAI',
                            ticker: 'DAI',
                            address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
                            rawAmount: '19526880162738340394',
                            decimal: 18,
                            amount: '19.526880162738340394',
                            logo: 'https://api.rango.exchange/i/yJvJre',
                            usdPrice: 1
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'MAGIC',
                            ticker: 'MAGIC',
                            address: '0x539bde0d7dbd336b79148aa742883198bbf60342',
                            rawAmount: '9059590242',
                            decimal: 18,
                            amount: '0.000000009059590242',
                            logo: 'https://api.rango.exchange/i/tazAGH',
                            usdPrice: null
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'UNI',
                            ticker: 'UNI',
                            address: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
                            rawAmount: '2392264468',
                            decimal: 18,
                            amount: '0.000000002392264468',
                            logo: 'https://api.rango.exchange/i/n8RX8F',
                            usdPrice: 5.246
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'HND',
                            ticker: 'HND',
                            address: '0x10010078a54396f62c96df8532dc2b4847d47ed3',
                            rawAmount: '150921229948215461100',
                            decimal: 18,
                            amount: '150.9212299482154611',
                            logo: 'https://api.rango.exchange/i/2SsRdS',
                            usdPrice: null
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'GMX',
                            ticker: 'GMX',
                            address: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
                            rawAmount: '128216748136770842',
                            decimal: 18,
                            amount: '0.128216748136770842',
                            logo: 'https://api.rango.exchange/i/vCEMKq',
                            usdPrice: 46.259
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'RIFTDAO.NET',
                            ticker: 'RIFTDAO.NET',
                            address: '0xe1cc7371f2c2b7ebb1af2b0c053ec86596e3f6d0',
                            rawAmount: '738097000000000000000000',
                            decimal: 18,
                            amount: '738097',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
                            rawAmount: '40064700',
                            decimal: 6,
                            amount: '40.0647',
                            logo: 'https://api.rango.exchange/i/aR1yFx',
                            usdPrice: 1
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'BADGER',
                            ticker: 'BADGER',
                            address: '0xbfa641051ba0a0ad1b0acf549a89536a0d76472e',
                            rawAmount: '2089136975803812618',
                            decimal: 18,
                            amount: '2.089136975803812618',
                            logo: 'https://api.rango.exchange/i/aaEEDq',
                            usdPrice: 2.26
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
                            rawAmount: '55298622',
                            decimal: 6,
                            amount: '55.298622',
                            logo: 'https://api.rango.exchange/i/ns0AMf',
                            usdPrice: 1
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'MIM',
                            ticker: 'MIM',
                            address: '0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a',
                            rawAmount: '10100000000000000000',
                            decimal: 18,
                            amount: '10.1',
                            logo: 'https://api.rango.exchange/i/JKT05f',
                            usdPrice: 0.998
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'AXLUSDC',
                            ticker: 'AXLUSDC',
                            address: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
                            rawAmount: '5500000',
                            decimal: 6,
                            amount: '5.5',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'ARBITRUM',
                            symbol: 'ETH',
                            ticker: 'ETH',
                            address: null,
                            rawAmount: '82905399282605538',
                            decimal: 18,
                            amount: '0.082905399282605538',
                            logo: 'https://api.rango.exchange/i/MTyH5i',
                            usdPrice: null
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://arbiscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'FANTOM',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'FANTOM',
                            symbol: 'FBNB',
                            ticker: 'FBNB',
                            address: '0x27f26f00e1605903645bbabc0a73e35027dccd45',
                            rawAmount: '15851797577951',
                            decimal: 18,
                            amount: '0.000015851797577951',
                            logo: 'https://api.rango.exchange/tokens/FANTOM/FBNB.png',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0x74b23882a30290451a17c44f4f05243b6b58c76d',
                            rawAmount: '2171678666801825',
                            decimal: 18,
                            amount: '0.002171678666801825',
                            logo: 'https://api.rango.exchange/tokens/FANTOM/WETH.png',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'FXS',
                            ticker: 'FXS',
                            address: '0x7d016eec9c25232b01f23ef992d98ca97fc2af5a',
                            rawAmount: '8129029359551099',
                            decimal: 18,
                            amount: '0.008129029359551099',
                            logo: 'https://api.rango.exchange/i/TVDwaE',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'WAVAX',
                            ticker: 'WAVAX',
                            address: '0x511d35c52a3c244e7b8bd92c0c297755fbd89212',
                            rawAmount: '103423419794091413',
                            decimal: 18,
                            amount: '0.103423419794091413',
                            logo: 'https://api.rango.exchange/tokens/FANTOM/WAVAX.png',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'WOO',
                            ticker: 'WOO',
                            address: '0x6626c47c00f1d87902fc13eecfac3ed06d5e8d8a',
                            rawAmount: '3069453396',
                            decimal: 18,
                            amount: '0.000000003069453396',
                            logo: 'https://api.rango.exchange/i/UuEujP',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'SWAPFTM.COM',
                            ticker: 'SWAPFTM.COM',
                            address: '0x87e377820010d818aa316f8c3f1c2b9d025eb5ee',
                            rawAmount: '100000000000000000000',
                            decimal: 18,
                            amount: '100',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'BIFI',
                            ticker: 'BIFI',
                            address: '0xd6070ae98b8069de6b494332d1a1a81b6179d960',
                            rawAmount: '5427265333',
                            decimal: 18,
                            amount: '0.000000005427265333',
                            logo: 'https://api.rango.exchange/i/euTXdM',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'BNB',
                            ticker: 'BNB',
                            address: '0xd67de0e0a0fd7b15dc8348bb9be742f3c5850454',
                            rawAmount: '4343993985',
                            decimal: 18,
                            amount: '0.000000004343993985',
                            logo: 'https://api.rango.exchange/i/Yj2w83',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'NUSD',
                            ticker: 'NUSD',
                            address: '0xed2a7edd7413021d440b09d654f3b87712abab66',
                            rawAmount: '1993985245375892955',
                            decimal: 18,
                            amount: '1.993985245375892955',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'MIM',
                            ticker: 'MIM',
                            address: '0x82f0b8b456c1a451378467398982d4834b6829c1',
                            rawAmount: '38400000001430563305',
                            decimal: 18,
                            amount: '38.400000001430563305',
                            logo: 'https://api.rango.exchange/i/ceBRSU',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '888CRYPTO.PRO',
                            ticker: '888CRYPTO.PRO',
                            address: '0x7082ca5058c358997063400ad78306b16a5c30d9',
                            rawAmount: '150000000000000',
                            decimal: 8,
                            amount: '1500000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '2XCO',
                            ticker: '2XCO',
                            address: '0xcaef42682040a19e09eb8a6773f17da81b0604c1',
                            rawAmount: '9500000000000',
                            decimal: 8,
                            amount: '95000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '$ AIRDROP IN CAKE (MULTICHAIN)',
                            ticker: '$ AIRDROP IN CAKE (MULTICHAIN)',
                            address: '0xb502b79c9ec490c4eee130a03370d490b069e59b',
                            rawAmount: '50000000000',
                            decimal: 8,
                            amount: '500',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
                            rawAmount: '268477851',
                            decimal: 6,
                            amount: '268.477851',
                            logo: 'https://api.rango.exchange/i/pva3ih',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '0CASINO.IO',
                            ticker: '0CASINO.IO',
                            address: '0x383c5e5a05ba830579adc2fccd6403894e1caa59',
                            rawAmount: '150000000000000',
                            decimal: 8,
                            amount: '1500000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'WFTM',
                            ticker: 'WFTM',
                            address: '0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83',
                            rawAmount: '262664414658966373114',
                            decimal: 18,
                            amount: '262.664414658966373114',
                            logo: 'https://api.rango.exchange/i/auYSf8',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'ETH-1INCH.IO',
                            ticker: 'ETH-1INCH.IO',
                            address: '0x5a7aad61871a39a972c11aa9cd48e8df1e10311d',
                            rawAmount: '870000000000000000',
                            decimal: 18,
                            amount: '0.87',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'BUSD',
                            ticker: 'BUSD',
                            address: '0xc931f61b1534eb21d8c11b24f3f5ab2471d4ab50',
                            rawAmount: '996216277676653329',
                            decimal: 18,
                            amount: '0.996216277676653329',
                            logo: 'https://api.rango.exchange/i/zOV927',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'DAI',
                            ticker: 'DAI',
                            address: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
                            rawAmount: '6907579712',
                            decimal: 18,
                            amount: '0.000000006907579712',
                            logo: 'https://api.rango.exchange/i/iIxCAk',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'RBNB',
                            ticker: 'RBNB',
                            address: '0xc3394bb9b118b3c9b5b8da297e20c08878edbed4',
                            rawAmount: '100000000000000',
                            decimal: 18,
                            amount: '0.0001',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'IMX',
                            ticker: 'IMX',
                            address: '0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2',
                            rawAmount: '116509710',
                            decimal: 18,
                            amount: '0.00000000011650971',
                            logo: 'https://api.rango.exchange/i/3nnwQN',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '24DROP.NET',
                            ticker: '24DROP.NET',
                            address: '0x67a58a20f087a600aec491d5cd329ba597b71aa7',
                            rawAmount: '200000000000',
                            decimal: 8,
                            amount: '2000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'MNEF',
                            ticker: 'MNEF',
                            address: '0xf9d922c055a3f1759299467dafafdf43be844f7a',
                            rawAmount: '30000000000000',
                            decimal: 8,
                            amount: '300000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: ' 0VISIT [003ERRORNOTICE.COM] TO SECURE YOUR FUNDS.',
                            ticker: ' 0VISIT [003ERRORNOTICE.COM] TO SECURE YOUR FUNDS.',
                            address: '0x98e4b3866602fc72ff766616e15146c9153b473b',
                            rawAmount: '2200000000000000000000',
                            decimal: 18,
                            amount: '2200',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '0CASINO.IO',
                            ticker: '0CASINO.IO',
                            address: '0xbe1b23d652580052dd8e774e0e7e92cf5cc31bb3',
                            rawAmount: '150000000000000',
                            decimal: 8,
                            amount: '1500000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'CRV',
                            ticker: 'CRV',
                            address: '0x1e4f97b9f9f913c46f1632781732927b9019c68b',
                            rawAmount: '2433604212107615486',
                            decimal: 18,
                            amount: '2.433604212107615486',
                            logo: 'https://api.rango.exchange/i/60avSg',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: '4GAMBLING.IO',
                            ticker: '4GAMBLING.IO',
                            address: '0xe4517100ae62cbeefc363e59d0f8df5754dc7e40',
                            rawAmount: '300000000000000',
                            decimal: 8,
                            amount: '3000000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0x049d68029688eabf473097a2fc38ef61633a3c7a',
                            rawAmount: '63082358',
                            decimal: 6,
                            amount: '63.082358',
                            logo: 'https://api.rango.exchange/i/niIihm',
                            usdPrice: null
                        },
                        {
                            chain: 'FANTOM',
                            symbol: 'FTM',
                            ticker: 'FTM',
                            address: null,
                            rawAmount: '1346689531144440162650',
                            decimal: 18,
                            amount: '1346.68953114444016265',
                            logo: 'https://api.rango.exchange/i/JC2fWD',
                            usdPrice: null
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://ftmscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'OPTIMISM',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'OPTIMISM',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
                            rawAmount: '22874529',
                            decimal: 6,
                            amount: '22.874529',
                            logo: 'https://api.rango.exchange/i/K6j5VN',
                            usdPrice: 1
                        },
                        {
                            chain: 'OPTIMISM',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
                            rawAmount: '39610548',
                            decimal: 6,
                            amount: '39.610548',
                            logo: 'https://api.rango.exchange/i/e4x0s8',
                            usdPrice: 0.999
                        },
                        {
                            chain: 'OPTIMISM',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0x4200000000000000000000000000000000000006',
                            rawAmount: '30671676019131723',
                            decimal: 18,
                            amount: '0.030671676019131723',
                            logo: 'https://api.rango.exchange/i/yZ9N1N',
                            usdPrice: 1207.06
                        },
                        {
                            chain: 'OPTIMISM',
                            symbol: 'DAI',
                            ticker: 'DAI',
                            address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
                            rawAmount: '1535439265',
                            decimal: 18,
                            amount: '0.000000001535439265',
                            logo: 'https://api.rango.exchange/i/zyZx0X',
                            usdPrice: 1
                        },
                        {
                            chain: 'OPTIMISM',
                            symbol: 'ETH',
                            ticker: 'ETH',
                            address: null,
                            rawAmount: '3809903995186154',
                            decimal: 18,
                            amount: '0.003809903995186154',
                            logo: 'https://api.rango.exchange/i/MTyH5i',
                            usdPrice: null
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://optimistic.etherscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'OKC',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: true,
                    explorerUrl: 'https://www.oklink.com/en/okc/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'CRONOS',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'CRONOS',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0xe44fd7fcb2b1581822d0c862b68222998a0c299a',
                            rawAmount: '4788770370',
                            decimal: 18,
                            amount: '0.00000000478877037',
                            logo: 'https://api.rango.exchange/i/j9xgdC',
                            usdPrice: 1210.2
                        },
                        {
                            chain: 'CRONOS',
                            symbol: 'AUTO',
                            ticker: 'AUTO',
                            address: '0x0dcb0cb0120d355cde1ce56040be57add0185baa',
                            rawAmount: '43013763072696143',
                            decimal: 18,
                            amount: '0.043013763072696143',
                            logo: 'https://api.rango.exchange/i/YxjmF0',
                            usdPrice: 222.98
                        },
                        {
                            chain: 'CRONOS',
                            symbol: 'CRONOSCLASSIC.COM',
                            ticker: 'CRONOSCLASSIC.COM',
                            address: '0x772c96ed2f99d84c2a83e67fbada9a1db4303be1',
                            rawAmount: '9000000000000000000000',
                            decimal: 18,
                            amount: '9000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'CRONOS',
                            symbol: 'BNB',
                            ticker: 'BNB',
                            address: '0xfa9343c3897324496a05fc75abed6bac29f8a40f',
                            rawAmount: '86000000000000000',
                            decimal: 18,
                            amount: '0.086',
                            logo: 'https://api.rango.exchange/i/B4ULZJ',
                            usdPrice: 248.28
                        },
                        {
                            chain: 'CRONOS',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0x66e428c3f67a68878562e79a0234c1f83c208770',
                            rawAmount: '1287808',
                            decimal: 6,
                            amount: '1.287808',
                            logo: 'https://api.rango.exchange/i/GJxbOP',
                            usdPrice: 1
                        },
                        {
                            chain: 'CRONOS',
                            symbol: 'CRONOSCLASSIC.COM',
                            ticker: 'CRONOSCLASSIC.COM',
                            address: '0x75f920403641ddbd66f8ce3ddd3a648ddb496c89',
                            rawAmount: '9000000000000000000000',
                            decimal: 18,
                            amount: '9000',
                            logo: null,
                            usdPrice: null
                        },
                        {
                            chain: 'CRONOS',
                            symbol: 'CRO',
                            ticker: 'CRO',
                            address: null,
                            rawAmount: '218462428966917726855',
                            decimal: 18,
                            amount: '218.462428966917726855',
                            logo: 'https://api.rango.exchange/i/S3tFKF',
                            usdPrice: 0.0579
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://cronoscan.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'MOONRIVER',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'MOONRIVER',
                            symbol: 'MOVR',
                            ticker: 'MOVR',
                            address: null,
                            rawAmount: '1409467396930959879',
                            decimal: 18,
                            amount: '1.409467396930959879',
                            logo: 'https://api.rango.exchange/i/AKXDjV',
                            usdPrice: null
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://moonriver.moonscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'MOONBEAM',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'MOONBEAM',
                            symbol: 'GLMR',
                            ticker: 'GLMR',
                            address: null,
                            rawAmount: '7637316155712999392',
                            decimal: 18,
                            amount: '7.637316155712999392',
                            logo: 'https://api.rango.exchange/i/Ra0xKh',
                            usdPrice: 0.343
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://moonbeam.moonscan.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'HECO',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'HECO',
                            symbol: 'HT',
                            ticker: 'HT',
                            address: null,
                            rawAmount: '8900958749249974840',
                            decimal: 18,
                            amount: '8.90095874924997484',
                            logo: 'https://api.rango.exchange/i/9uAYzf',
                            usdPrice: 5.361
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://hecoinfo.com/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'AURORA',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'AURORA',
                            symbol: 'MATIC',
                            ticker: 'MATIC',
                            address: '0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8',
                            rawAmount: '4963601767',
                            decimal: 18,
                            amount: '0.000000004963601767',
                            logo: 'https://api.rango.exchange/i/yVbC8U',
                            usdPrice: 0.793
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'AVAX',
                            ticker: 'AVAX',
                            address: '0x80a16016cc4a2e6a2caca8a4a498b1699ff0f844',
                            rawAmount: '2088345237',
                            decimal: 18,
                            amount: '0.000000002088345237',
                            logo: 'https://api.rango.exchange/i/kX4edQ',
                            usdPrice: 11.77
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0xc9bdeed33cd01541e1eed10f90519d2c06fe3feb',
                            rawAmount: '1000000328916822',
                            decimal: 18,
                            amount: '0.001000000328916822',
                            logo: 'https://api.rango.exchange/i/3h0NwB',
                            usdPrice: 1272.743
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0xb12bfca5a55806aaf64e99521918a4bf0fc40802',
                            rawAmount: '25059116',
                            decimal: 6,
                            amount: '25.059116',
                            logo: 'https://api.rango.exchange/i/UfM0ap',
                            usdPrice: 0.998
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'USDT',
                            ticker: 'USDT',
                            address: '0x4988a896b1227218e4a686fde5eabdcabd91571f',
                            rawAmount: '9373920',
                            decimal: 6,
                            amount: '9.37392',
                            logo: 'https://api.rango.exchange/i/sq7c5G',
                            usdPrice: 1.005
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'ATLUNA',
                            ticker: 'ATLUNA',
                            address: '0xc4bdd27c33ec7daa6fcfd8532ddb524bf4038096',
                            rawAmount: '7269857397',
                            decimal: 18,
                            amount: '0.000000007269857397',
                            logo: 'https://api.rango.exchange/i/kIZ1fy',
                            usdPrice: null
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'PICKLE',
                            ticker: 'PICKLE',
                            address: '0x291c8fceaca3342b29cc36171deb98106f712c66',
                            rawAmount: '3462515627985423594',
                            decimal: 18,
                            amount: '3.462515627985423594',
                            logo: 'https://api.rango.exchange/i/LPaa2J',
                            usdPrice: null
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'PAPR',
                            ticker: 'PAPR',
                            address: '0xa5c09de3aa1cdb5cb190be66c77e033be1ca594a',
                            rawAmount: '163912004957041283',
                            decimal: 18,
                            amount: '0.163912004957041283',
                            logo: 'https://api.rango.exchange/i/sXsnQu',
                            usdPrice: 0.452
                        },
                        {
                            chain: 'AURORA',
                            symbol: 'PRNTR',
                            ticker: 'PRNTR',
                            address: '0x29daeb6a2a87b159f5fee1f19ec6ccaf4ef2acca',
                            rawAmount: '307884579855694445',
                            decimal: 18,
                            amount: '0.307884579855694445',
                            logo: 'https://api.rango.exchange/i/Uf33Cw',
                            usdPrice: 0.602
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://explorer.mainnet.aurora.dev/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'HARMONY',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'HARMONY',
                            symbol: 'ONE',
                            ticker: 'ONE',
                            address: null,
                            rawAmount: '48801440860746527271',
                            decimal: 18,
                            amount: '48.801440860746527271',
                            logo: 'https://api.rango.exchange/i/gpMxOP',
                            usdPrice: 0.109
                        },
                        {
                            chain: 'HARMONY',
                            symbol: '1DAI',
                            ticker: '1DAI',
                            address: '0xef977d2f931c1978db5f6747666fa1eacb0d0339',
                            rawAmount: '3951799808',
                            decimal: 18,
                            amount: '0.000000003951799808',
                            logo: 'https://api.rango.exchange/i/7UdDll',
                            usdPrice: 0.961
                        },
                        {
                            chain: 'HARMONY',
                            symbol: '1USDC',
                            ticker: '1USDC',
                            address: '0x985458e523db3d53125813ed68c274899e9dfab4',
                            rawAmount: '4480342',
                            decimal: 6,
                            amount: '4.480342',
                            logo: 'https://api.rango.exchange/i/4eEvKA',
                            usdPrice: 1.006
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'bscBUSD',
                            ticker: 'bscBUSD',
                            address: '0x0ab43550a6915f9f67d0c454c2e90385e6497eaa',
                            rawAmount: '12000000009249314069',
                            decimal: 18,
                            amount: '12.000000009249314069',
                            logo: 'https://api.rango.exchange/i/uZMcKl',
                            usdPrice: 0.946
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'BUSD',
                            ticker: 'BUSD',
                            address: '0xe176ebe47d621b984a73036b9da5d834411ef734',
                            rawAmount: '6201993388439322612',
                            decimal: 18,
                            amount: '6.201993388439322612',
                            logo: 'https://api.rango.exchange/i/qWxf4I',
                            usdPrice: 0.84
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'UST',
                            ticker: 'UST',
                            address: '0x224e64ec1bdce3870a6a6c777edd450454068fec',
                            rawAmount: '5449588252',
                            decimal: 18,
                            amount: '0.000000005449588252',
                            logo: 'https://api.rango.exchange/i/wmyHK9',
                            usdPrice: 0.194
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'WONE',
                            ticker: 'WONE',
                            address: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
                            rawAmount: '2000000000624440839',
                            decimal: 18,
                            amount: '2.000000000624440839',
                            logo: 'https://api.rango.exchange/i/u283bK',
                            usdPrice: 0.109
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'BIFI',
                            ticker: 'BIFI',
                            address: '0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8',
                            rawAmount: '6500000000000000',
                            decimal: 18,
                            amount: '0.0065',
                            logo: 'https://api.rango.exchange/i/EuFqit',
                            usdPrice: 325.37
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'JENN',
                            ticker: 'JENN',
                            address: '0x2f459dd7cbcc9d8323621f6fb430cd0555411e7b',
                            rawAmount: '82666600666715773',
                            decimal: 18,
                            amount: '0.082666600666715773',
                            logo: 'https://api.rango.exchange/i/5CYmzQ',
                            usdPrice: 0.00429
                        },
                        {
                            chain: 'HARMONY',
                            symbol: 'LMA',
                            ticker: 'LMA',
                            address: '0x7d0546dbb1dca8108d99aa389a8e9ce0c40b2370',
                            rawAmount: '2335555755',
                            decimal: 18,
                            amount: '0.000000002335555755',
                            logo: 'https://api.rango.exchange/i/A8Kw4L',
                            usdPrice: 33.26
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://explorer.harmony.one/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'EVMOS',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: true,
                    explorerUrl: 'https://evm.evmos.org/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'GNOSIS',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: true,
                    explorerUrl: 'https://blockscout.com/xdai/mainnet/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'FUSE',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: true,
                    explorerUrl: 'https://explorer.fuse.io/address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        },
        {
            name: 'BOBA',
            accounts: [
                {
                    address: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
                    balances: [
                        {
                            chain: 'BOBA',
                            symbol: 'MIM',
                            ticker: 'MIM',
                            address: '0x218c3c3d49d0e7b37aff0d8bb079de36ae61a4c0',
                            rawAmount: '105604450000000000',
                            decimal: 18,
                            amount: '0.10560445',
                            logo: 'https://api.rango.exchange/i/RmsZZl',
                            usdPrice: 0.998
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'BUSD',
                            ticker: 'BUSD',
                            address: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
                            rawAmount: '5431734874',
                            decimal: 18,
                            amount: '0.000000005431734874',
                            logo: 'https://api.rango.exchange/i/PsiPay',
                            usdPrice: 0.999
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'UNIDX',
                            ticker: 'UNIDX',
                            address: '0x375488f097176507e39b9653b88fdc52cde736bf',
                            rawAmount: '23224657182604680757',
                            decimal: 18,
                            amount: '23.224657182604680757',
                            logo: 'https://api.rango.exchange/i/TZv5rn',
                            usdPrice: 2.3
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'BANA',
                            ticker: 'BANA',
                            address: '0xc67b9b1b0557aeafa10aa1ffa1d7c87087a6149e',
                            rawAmount: '9067814698',
                            decimal: 18,
                            amount: '0.000000009067814698',
                            logo: 'https://api.rango.exchange/i/gyHe7C',
                            usdPrice: null
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'BDOGE',
                            ticker: 'BDOGE',
                            address: '0x121636c43e96d97ab00b6c6994cddebef27de1c7',
                            rawAmount: '723068225237233960',
                            decimal: 18,
                            amount: '0.72306822523723396',
                            logo: 'https://api.rango.exchange/i/U6UPsb',
                            usdPrice: 1.64e-9
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'SHIBUI',
                            ticker: 'SHIBUI',
                            address: '0xf08ad7c3f6b1c6843ba027ad54ed8ddb6d71169b',
                            rawAmount: '1827087060',
                            decimal: 18,
                            amount: '0.00000000182708706',
                            logo: 'https://api.rango.exchange/i/Mwv1h9',
                            usdPrice: 0.00631
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'USDC',
                            ticker: 'USDC',
                            address: '0x66a2a913e447d6b4bf33efbec43aaef87890fbbc',
                            rawAmount: '11210692',
                            decimal: 6,
                            amount: '11.210692',
                            logo: 'https://api.rango.exchange/i/ahp7BS',
                            usdPrice: 0.993
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'BOBA',
                            ticker: 'BOBA',
                            address: '0xa18bf3994c0cc6e3b63ac420308e5383f53120d7',
                            rawAmount: '1093312869',
                            decimal: 18,
                            amount: '0.000000001093312869',
                            logo: 'https://api.rango.exchange/i/vWYKUH',
                            usdPrice: 0.181
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'WETH',
                            ticker: 'WETH',
                            address: '0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000',
                            rawAmount: '2606189668',
                            decimal: 18,
                            amount: '0.000000002606189668',
                            logo: 'https://api.rango.exchange/i/fEyllw',
                            usdPrice: 1197.276
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'DAI',
                            ticker: 'DAI',
                            address: '0xf74195bb8a5cf652411867c5c2c5b8c2a402be35',
                            rawAmount: '2131602501374765414',
                            decimal: 18,
                            amount: '2.131602501374765414',
                            logo: 'https://api.rango.exchange/i/U8PEdb',
                            usdPrice: null
                        },
                        {
                            chain: 'BOBA',
                            symbol: 'ETH',
                            ticker: 'ETH',
                            address: null,
                            rawAmount: '884271636924027',
                            decimal: 18,
                            amount: '0.000884271636924027',
                            logo: 'https://api.rango.exchange/i/MTyH5i',
                            usdPrice: 1197.276
                        }
                    ],
                    loading: false,
                    walletType: 'metamask',
                    isConnected: false,
                    error: false,
                    explorerUrl: 'https://bobascan.com//address/0x2702d89c1c8658b49c45dd460deebcc45faec03c'
                }
            ]
        }
    ]
};
const $1f30fcf397122368$export$6990040ee07315 = {
    blockchains: {
        BSC: {
            name: 'BSC',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BSC',
                    symbol: 'BNB',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/binance.svg',
            displayName: 'BSC',
            shortName: 'BSC',
            sort: 1,
            color: '#F3BA2F',
            enabled: true,
            type: 'EVM',
            chainId: '0x38',
            info: {
                chainName: 'Binance Smart Chain Mainnet',
                nativeCurrency: {
                    name: 'BNB',
                    symbol: 'BNB',
                    decimals: 18
                },
                rpcUrls: [
                    'https://bsc-dataseed1.ninicoin.io'
                ],
                blockExplorerUrls: [
                    'https://bscscan.com'
                ],
                addressUrl: 'https://bscscan.com/address/{wallet}',
                transactionUrl: 'https://bscscan.com/tx/{txHash}',
                tokenUrl: 'https://bscscan.com/token/{address}'
            }
        },
        POLYGON: {
            name: 'POLYGON',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'POLYGON',
                    symbol: 'MATIC',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/polygon.svg',
            displayName: 'Polygon',
            shortName: 'Polygon',
            sort: 2,
            color: '#8247E5',
            enabled: true,
            type: 'EVM',
            chainId: '0x89',
            info: {
                chainName: 'Polygon Mainnet',
                nativeCurrency: {
                    name: 'MATIC',
                    symbol: 'MATIC',
                    decimals: 18
                },
                rpcUrls: [
                    'https://polygon-rpc.com'
                ],
                blockExplorerUrls: [
                    'https://polygonscan.com'
                ],
                addressUrl: 'https://polygonscan.com/address/{wallet}',
                transactionUrl: 'https://polygonscan.com/tx/{txHash}',
                tokenUrl: 'https://polygonscan.com/token/{address}'
            }
        },
        ETH: {
            name: 'ETH',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'ETH',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/ethereum.svg',
            displayName: 'Ethereum',
            shortName: 'ETH',
            sort: 3,
            color: '#ecf0f1',
            enabled: true,
            type: 'EVM',
            chainId: '0x1',
            info: {
                chainName: 'Ethereum Mainnet',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.ankr.com/eth'
                ],
                blockExplorerUrls: [
                    'https://etherscan.io'
                ],
                addressUrl: 'https://etherscan.io/address/{wallet}',
                transactionUrl: 'https://etherscan.io/tx/{txHash}',
                tokenUrl: 'https://etherscan.io/token/{address}'
            }
        },
        OSMOSIS: {
            name: 'OSMOSIS',
            defaultDecimals: 6,
            addressPatterns: [
                '^(osmo1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'OSMOSIS',
                    symbol: 'OSMO',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/osmosis.svg',
            displayName: 'Osmosis',
            shortName: 'Osmosis',
            sort: 4,
            color: '#7901B4',
            enabled: true,
            type: 'COSMOS',
            chainId: 'osmosis-1',
            info: {
                experimental: false,
                rpc: 'https://rpc-osmosis.keplr.app',
                rest: 'https://lcd-osmosis.keplr.app',
                cosmostationLcdUrl: 'https://lcd-osmosis.cosmostation.io',
                cosmostationApiUrl: 'https://api-osmosis.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'osmosis',
                chainName: 'Osmosis',
                stakeCurrency: {
                    coinDenom: 'OSMO',
                    coinMinimalDenom: 'uosmo',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:uosmo',
                    coinImageUrl: '/tokens/blockchain/osmosis.svg'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'osmo',
                    bech32PrefixAccPub: 'osmopub',
                    bech32PrefixValAddr: 'osmovaloper',
                    bech32PrefixValPub: 'osmovaloperpub',
                    bech32PrefixConsAddr: 'osmovalcons',
                    bech32PrefixConsPub: 'osmovalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'OSMO',
                        coinMinimalDenom: 'uosmo',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uosmo',
                        coinImageUrl: '/tokens/blockchain/osmosis.svg'
                    },
                    {
                        coinDenom: 'ION',
                        coinMinimalDenom: 'uion',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uion',
                        coinImageUrl: '/tokens/blockchain/ion.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'OSMO',
                        coinMinimalDenom: 'uosmo',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uosmo',
                        coinImageUrl: '/tokens/blockchain/osmosis.svg'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/osmosis/txs/{txHash}',
                gasPriceStep: {
                    low: 0,
                    average: 0.025,
                    high: 0.04
                },
                tokenUrl: 'https://www.mintscan.io/osmosis/assets/{address}'
            }
        },
        JUNO: {
            name: 'JUNO',
            defaultDecimals: 6,
            addressPatterns: [
                '^(juno1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'JUNO',
                    symbol: 'JUNO',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/juno.svg',
            displayName: 'Juno',
            shortName: 'Juno',
            sort: 5,
            color: '#f0827d',
            enabled: true,
            type: 'COSMOS',
            chainId: 'juno-1',
            info: {
                experimental: false,
                rpc: 'https://rpc-juno.itastakers.com:443/',
                rest: 'https://lcd-juno.keplr.app',
                cosmostationLcdUrl: 'https://lcd-juno.cosmostation.io',
                cosmostationApiUrl: 'https://api-juno.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'juno',
                chainName: 'Juno',
                stakeCurrency: {
                    coinDenom: 'JUNO',
                    coinMinimalDenom: 'ujuno',
                    coinDecimals: 6,
                    coinGeckoId: 'juno-network',
                    coinImageUrl: '/tokens/blockchain/JUNO.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'juno',
                    bech32PrefixAccPub: 'junopub',
                    bech32PrefixValAddr: 'junovaloper',
                    bech32PrefixValPub: 'junovaloperpub',
                    bech32PrefixConsAddr: 'junovalcons',
                    bech32PrefixConsPub: 'junovalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'JUNO',
                        coinMinimalDenom: 'ujuno',
                        coinDecimals: 6,
                        coinGeckoId: 'juno-network',
                        coinImageUrl: '/tokens/blockchain/JUNO.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'JUNO',
                        coinMinimalDenom: 'ujuno',
                        coinDecimals: 6,
                        coinGeckoId: 'juno-network',
                        coinImageUrl: '/tokens/blockchain/JUNO.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/juno/txs/{txHash}',
                gasPriceStep: {
                    low: 0.001,
                    average: 0.0025,
                    high: 0.004
                },
                tokenUrl: null
            }
        },
        AVAX_CCHAIN: {
            name: 'AVAX_CCHAIN',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'AVAX_CCHAIN',
                    symbol: 'AVAX',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/avax_cchain.svg',
            displayName: 'Avalanche',
            shortName: 'Avax',
            sort: 6,
            color: '#e84142',
            enabled: true,
            type: 'EVM',
            chainId: '0xa86a',
            info: {
                chainName: 'Avalanche C-Chain',
                nativeCurrency: {
                    name: 'AVAX',
                    symbol: 'AVAX',
                    decimals: 18
                },
                rpcUrls: [
                    'https://api.avax.network/ext/bc/C/rpc'
                ],
                blockExplorerUrls: [
                    'https://snowtrace.io'
                ],
                addressUrl: 'https://snowtrace.io/address/{wallet}',
                transactionUrl: 'https://snowtrace.io/tx/{txHash}',
                tokenUrl: 'https://snowtrace.dev/token/{address}'
            }
        },
        ARBITRUM: {
            name: 'ARBITRUM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'ARBITRUM',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/arbitrum.svg',
            displayName: 'Arbitrum',
            shortName: 'Arbitrum',
            sort: 7,
            color: '#28a0f0',
            enabled: true,
            type: 'EVM',
            chainId: '0xa4b1',
            info: {
                chainName: 'Arbitrum One',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://arb1.arbitrum.io/rpc'
                ],
                blockExplorerUrls: [
                    'https://arbiscan.io'
                ],
                addressUrl: 'https://arbiscan.io/address/{wallet}',
                transactionUrl: 'https://arbiscan.io/tx/{txHash}',
                tokenUrl: 'https://arbiscan.io/token/{address}'
            }
        },
        COSMOS: {
            name: 'COSMOS',
            defaultDecimals: 6,
            addressPatterns: [
                '^(cosmos1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'COSMOS',
                    symbol: 'ATOM',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/cosmos.svg',
            displayName: 'Cosmos',
            shortName: 'Cosmos',
            sort: 8,
            color: '#2E3148',
            enabled: true,
            type: 'COSMOS',
            chainId: 'cosmoshub-4',
            info: {
                experimental: false,
                rpc: 'https://cosmos-rpc.polkachu.com',
                rest: 'https://lcd-cosmoshub.keplr.app',
                cosmostationLcdUrl: 'https://lcd-cosmos.cosmostation.io',
                cosmostationApiUrl: 'https://api-cosmos.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'cosmos',
                chainName: 'Cosmos',
                stakeCurrency: {
                    coinDenom: 'ATOM',
                    coinMinimalDenom: 'uatom',
                    coinDecimals: 6,
                    coinGeckoId: 'cosmos',
                    coinImageUrl: '/tokens/blockchain/cosmos.svg'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'cosmos',
                    bech32PrefixAccPub: 'cosmospub',
                    bech32PrefixValAddr: 'cosmosvaloper',
                    bech32PrefixValPub: 'cosmosvaloperpub',
                    bech32PrefixConsAddr: 'cosmosvalcons',
                    bech32PrefixConsPub: 'cosmosvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'ATOM',
                        coinMinimalDenom: 'uatom',
                        coinDecimals: 6,
                        coinGeckoId: 'cosmos',
                        coinImageUrl: '/tokens/blockchain/cosmos.svg'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'ATOM',
                        coinMinimalDenom: 'uatom',
                        coinDecimals: 6,
                        coinGeckoId: 'cosmos',
                        coinImageUrl: '/tokens/blockchain/cosmos.svg'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/cosmos/txs/{txHash}',
                gasPriceStep: {
                    low: 0.01,
                    average: 0.025,
                    high: 0.04
                },
                tokenUrl: 'https://www.mintscan.io/cosmos/assets/{address}'
            }
        },
        STARKNET: {
            name: 'STARKNET',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{64}$'
            ],
            feeAssets: [
                {
                    blockchain: 'STARKNET',
                    symbol: 'ETH',
                    address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7'
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/starknet.svg',
            displayName: 'StarkNet',
            shortName: 'StarkNet',
            sort: 8,
            color: '#28286E',
            enabled: true,
            type: 'ZK_ROLLUP',
            chainId: 'SN_MAIN',
            info: null
        },
        FANTOM: {
            name: 'FANTOM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'FANTOM',
                    symbol: 'FTM',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/fantom.png',
            displayName: 'Fantom',
            shortName: 'Fantom',
            sort: 9,
            color: '#337afe',
            enabled: true,
            type: 'EVM',
            chainId: '0xfa',
            info: {
                chainName: 'Fantom Opera',
                nativeCurrency: {
                    name: 'FTM',
                    symbol: 'FTM',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.ftm.tools'
                ],
                blockExplorerUrls: [
                    'https://ftmscan.com'
                ],
                addressUrl: 'https://ftmscan.com/address/{wallet}',
                transactionUrl: 'https://ftmscan.com/tx/{txHash}',
                tokenUrl: 'https://explorer.fantom.network/token/{address}'
            }
        },
        OPTIMISM: {
            name: 'OPTIMISM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'OPTIMISM',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/optimism.svg',
            displayName: 'Optimism',
            shortName: 'Optimism',
            sort: 10,
            color: '#FF0420',
            enabled: true,
            type: 'EVM',
            chainId: '0xa',
            info: {
                chainName: 'Optimism',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://mainnet.optimism.io'
                ],
                blockExplorerUrls: [
                    'https://optimistic.etherscan.io'
                ],
                addressUrl: 'https://optimistic.etherscan.io/address/{wallet}',
                transactionUrl: 'https://optimistic.etherscan.io/tx/{txHash}',
                tokenUrl: 'https://optimistic.etherscan.io/token/{address}'
            }
        },
        SOLANA: {
            name: 'SOLANA',
            defaultDecimals: 9,
            addressPatterns: [
                '^[1-9A-HJ-NP-Za-km-z]{32,44}$'
            ],
            feeAssets: [
                {
                    blockchain: 'SOLANA',
                    symbol: 'SOL',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/solana.svg',
            displayName: 'Solana',
            shortName: 'Solana',
            sort: 11,
            color: '#708DD2',
            enabled: true,
            type: 'SOLANA',
            chainId: 'mainnet-beta',
            info: null
        },
        OKC: {
            name: 'OKC',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'OKC',
                    symbol: 'OKT',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/okx.png',
            displayName: 'OKX Chain (OKC)',
            shortName: 'Okx',
            sort: 11,
            color: '#29a0f0',
            enabled: true,
            type: 'EVM',
            chainId: '0x42',
            info: {
                chainName: 'OKX Chain',
                nativeCurrency: {
                    name: 'OKT',
                    symbol: 'OKT',
                    decimals: 18
                },
                rpcUrls: [
                    'https://exchainrpc.okex.org'
                ],
                blockExplorerUrls: [
                    'https://www.oklink.com/en/okc'
                ],
                addressUrl: 'https://www.oklink.com/en/okc/address/{wallet}',
                transactionUrl: 'https://www.oklink.com/en/okc/tx/{txHash}',
                tokenUrl: null
            }
        },
        CRONOS: {
            name: 'CRONOS',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'CRONOS',
                    symbol: 'CRO',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/cronos.svg',
            displayName: 'Cronos',
            shortName: 'Cronos',
            sort: 12,
            color: '#1a90ff',
            enabled: true,
            type: 'EVM',
            chainId: '0x19',
            info: {
                chainName: 'Cronos Mainnet Beta',
                nativeCurrency: {
                    name: 'CRO',
                    symbol: 'CRO',
                    decimals: 18
                },
                rpcUrls: [
                    'https://cronosrpc-1.xstaking.sg'
                ],
                blockExplorerUrls: [
                    'https://cronoscan.com'
                ],
                addressUrl: 'https://cronoscan.com/address/{wallet}',
                transactionUrl: 'https://cronoscan.com/tx/{txHash}',
                tokenUrl: 'https://cronoscan.com/token/{address}'
            }
        },
        MOONRIVER: {
            name: 'MOONRIVER',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'MOONRIVER',
                    symbol: 'MOVR',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/moonriver.svg',
            displayName: 'MoonRiver',
            shortName: 'MoonRiver',
            sort: 13,
            color: '#F3B404',
            enabled: true,
            type: 'EVM',
            chainId: '0x505',
            info: {
                chainName: 'MoonRiver',
                nativeCurrency: {
                    name: 'MOVR',
                    symbol: 'MOVR',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.moonriver.moonbeam.network'
                ],
                blockExplorerUrls: [
                    'https://moonriver.moonscan.io'
                ],
                addressUrl: 'https://moonriver.moonscan.io/address/{wallet}',
                transactionUrl: 'https://moonriver.moonscan.io/tx/{txHash}',
                tokenUrl: null
            }
        },
        MOONBEAM: {
            name: 'MOONBEAM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'MOONBEAM',
                    symbol: 'GLMR',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/moonbeam.png',
            displayName: 'MoonBeam',
            shortName: 'MoonBeam',
            sort: 14,
            color: '#B3206B',
            enabled: true,
            type: 'EVM',
            chainId: '0x504',
            info: {
                chainName: 'MoonBeam',
                nativeCurrency: {
                    name: 'GLMR',
                    symbol: 'GLMR',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.api.moonbeam.network'
                ],
                blockExplorerUrls: [
                    'https://moonbeam.moonscan.io'
                ],
                addressUrl: 'https://moonbeam.moonscan.io/address/{wallet}',
                transactionUrl: 'https://moonbeam.moonscan.io/tx/{txHash}',
                tokenUrl: null
            }
        },
        HECO: {
            name: 'HECO',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'HECO',
                    symbol: 'HT',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/heco.png',
            displayName: 'Heco',
            shortName: 'Heco',
            sort: 15,
            color: '#4CA852',
            enabled: true,
            type: 'EVM',
            chainId: '0x80',
            info: {
                chainName: 'Huobi ECO Chain Mainnet',
                nativeCurrency: {
                    name: 'HT',
                    symbol: 'HT',
                    decimals: 18
                },
                rpcUrls: [
                    'https://http-mainnet.hecochain.com'
                ],
                blockExplorerUrls: [
                    'https://hecoinfo.com'
                ],
                addressUrl: 'https://hecoinfo.com/address/{wallet}',
                transactionUrl: 'https://hecoinfo.com/tx/{txHash}',
                tokenUrl: null
            }
        },
        AURORA: {
            name: 'AURORA',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'AURORA',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/aurora.svg',
            displayName: 'Aurora',
            shortName: 'Aurora',
            sort: 15,
            color: '#78d64b',
            enabled: true,
            type: 'EVM',
            chainId: '0x4e454152',
            info: {
                chainName: 'Aurora Mainnet',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://mainnet.aurora.dev'
                ],
                blockExplorerUrls: [
                    'https://explorer.mainnet.aurora.dev'
                ],
                addressUrl: 'https://explorer.mainnet.aurora.dev/address/{wallet}',
                transactionUrl: 'https://explorer.mainnet.aurora.dev/tx/{txHash}',
                tokenUrl: 'https://explorer.mainnet.aurora.dev/token/{address}'
            }
        },
        HARMONY: {
            name: 'HARMONY',
            defaultDecimals: 18,
            addressPatterns: [
                '^(one1)[0-9a-z]{38}$',
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'HARMONY',
                    symbol: 'ONE',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/harmony.svg',
            displayName: 'Harmony',
            shortName: 'Harmony',
            sort: 15,
            color: '#50AEE9',
            enabled: true,
            type: 'EVM',
            chainId: '0x63564c40',
            info: {
                chainName: 'Harmony Mainnet',
                nativeCurrency: {
                    name: 'ONE',
                    symbol: 'ONE',
                    decimals: 18
                },
                rpcUrls: [
                    'https://api.s0.t.hmny.io'
                ],
                blockExplorerUrls: [
                    'https://explorer.harmony.one'
                ],
                addressUrl: 'https://explorer.harmony.one/address/{wallet}',
                transactionUrl: 'https://explorer.harmony.one/tx/{txHash}',
                tokenUrl: null
            }
        },
        EVMOS: {
            name: 'EVMOS',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'EVMOS',
                    symbol: 'EVMOS',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/evmos.png',
            displayName: 'Evmos',
            shortName: 'Evmos',
            sort: 15,
            color: '#2D2925',
            enabled: true,
            type: 'EVM',
            chainId: '0x2329',
            info: {
                chainName: 'Evmos',
                nativeCurrency: {
                    name: 'EVMOS',
                    symbol: 'EVMOS',
                    decimals: 18
                },
                rpcUrls: [
                    'https://eth.bd.evmos.org:8545'
                ],
                blockExplorerUrls: [
                    'https://evm.evmos.org'
                ],
                addressUrl: 'https://evm.evmos.org/address/{wallet}',
                transactionUrl: 'https://evm.evmos.org/tx/{txHash}',
                tokenUrl: null
            }
        },
        SIF: {
            name: 'SIF',
            defaultDecimals: 18,
            addressPatterns: [
                '^(sif1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'SIF',
                    symbol: 'ROWAN',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/sif.png',
            displayName: 'Sifchain',
            shortName: 'Sifchain',
            sort: 16,
            color: '#CAAA3A',
            enabled: true,
            type: 'COSMOS',
            chainId: 'sifchain-1',
            info: {
                experimental: false,
                rpc: 'https://rpc.sifchain.finance',
                rest: 'https://api-int.sifchain.finance',
                cosmostationLcdUrl: 'https://lcd-sifchain.cosmostation.io',
                cosmostationApiUrl: 'https://api-sifchain.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'sifchain',
                chainName: 'Sifchain',
                stakeCurrency: {
                    coinDenom: 'ROWAN',
                    coinMinimalDenom: 'rowan',
                    coinDecimals: 18,
                    coinGeckoId: '',
                    coinImageUrl: ''
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'sif',
                    bech32PrefixAccPub: 'sifpub',
                    bech32PrefixValAddr: 'sifvaloper',
                    bech32PrefixValPub: 'sifvaloperpub',
                    bech32PrefixConsAddr: 'sifvalcons',
                    bech32PrefixConsPub: 'sifvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'ROWAN',
                        coinMinimalDenom: 'rowan',
                        coinDecimals: 18,
                        coinGeckoId: '',
                        coinImageUrl: ''
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'ROWAN',
                        coinMinimalDenom: 'rowan',
                        coinDecimals: 18,
                        coinGeckoId: '',
                        coinImageUrl: ''
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/sifchain/txs/{txHash}',
                gasPriceStep: {
                    low: 1000000000000,
                    average: 1500000000000,
                    high: 2000000000000
                },
                tokenUrl: null
            }
        },
        THOR: {
            name: 'THOR',
            defaultDecimals: 8,
            addressPatterns: [
                '^(thor1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'THOR',
                    symbol: 'RUNE',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/thorchain.svg',
            displayName: 'Thorchain',
            shortName: 'Thorchain',
            sort: 17,
            color: '#1AE6CB',
            enabled: true,
            type: 'TRANSFER',
            chainId: null,
            info: null
        },
        BNB: {
            name: 'BNB',
            defaultDecimals: 8,
            addressPatterns: [
                '^(bnb1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BNB',
                    symbol: 'BNB',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/bnb.svg',
            displayName: 'Binance Chain',
            shortName: 'BNB',
            sort: 18,
            color: '#F3BA2F',
            enabled: true,
            type: 'COSMOS',
            chainId: null,
            info: null
        },
        STARGAZE: {
            name: 'STARGAZE',
            defaultDecimals: 6,
            addressPatterns: [
                '^(stars1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'STARGAZE',
                    symbol: 'STARS',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/stargaze.png',
            displayName: 'Stargaze',
            shortName: 'Stargaze',
            sort: 19,
            color: '#231B60',
            enabled: true,
            type: 'COSMOS',
            chainId: 'stargaze-1',
            info: {
                experimental: false,
                rpc: 'https://rpc.stargaze-apis.com',
                rest: 'https://rest.stargaze-apis.com',
                cosmostationLcdUrl: 'https://lcd-stargaze.cosmostation.io',
                cosmostationApiUrl: 'https://api-stargaze.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'stargaze',
                chainName: 'Stargaze',
                stakeCurrency: {
                    coinDenom: 'STARS',
                    coinMinimalDenom: 'ustars',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:ustars',
                    coinImageUrl: '/tokens/blockchain/STARS.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'stars',
                    bech32PrefixAccPub: 'starspub',
                    bech32PrefixValAddr: 'starsvaloper',
                    bech32PrefixValPub: 'starsvaloperpub',
                    bech32PrefixConsAddr: 'starsvalcons',
                    bech32PrefixConsPub: 'starsvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'STARS',
                        coinMinimalDenom: 'ustars',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:ustars',
                        coinImageUrl: '/tokens/blockchain/STARS.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'STARS',
                        coinMinimalDenom: 'ustars',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:ustars',
                        coinImageUrl: '/tokens/blockchain/STARS.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/stargaze/txs/{txHash}',
                gasPriceStep: {
                    low: 1,
                    average: 1,
                    high: 1
                },
                tokenUrl: null
            }
        },
        BTC: {
            name: 'BTC',
            defaultDecimals: 8,
            addressPatterns: [
                '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^(bc1)[0-9A-Za-z]{39,59}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BTC',
                    symbol: 'BTC',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/btc.svg',
            displayName: 'Bitcoin',
            shortName: 'BTC',
            sort: 20,
            color: '#F7931A',
            enabled: true,
            type: 'TRANSFER',
            chainId: null,
            info: null
        },
        CRYPTO_ORG: {
            name: 'CRYPTO_ORG',
            defaultDecimals: 8,
            addressPatterns: [
                '^(cro1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'CRYPTO_ORG',
                    symbol: 'CRO',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/crypto_org.png',
            displayName: 'Crypto.org',
            shortName: 'Crypto.org',
            sort: 21,
            color: '#103F68',
            enabled: true,
            type: 'COSMOS',
            chainId: 'crypto-org-chain-mainnet-1',
            info: {
                experimental: false,
                rpc: 'https://rpc-crypto-org.keplr.app',
                rest: 'https://lcd-crypto-org.keplr.app',
                cosmostationLcdUrl: 'https://lcd-cryptocom.cosmostation.io',
                cosmostationApiUrl: 'https://api-cryptocom.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'crypto-org',
                chainName: 'Crypto.org',
                stakeCurrency: {
                    coinDenom: 'CRO',
                    coinMinimalDenom: 'basecro',
                    coinDecimals: 8,
                    coinGeckoId: 'crypto-com-chain',
                    coinImageUrl: '/tokens/blockchain/cro.png'
                },
                bip44: {
                    coinType: 394
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'cro',
                    bech32PrefixAccPub: 'cropub',
                    bech32PrefixValAddr: 'crovaloper',
                    bech32PrefixValPub: 'crovaloperpub',
                    bech32PrefixConsAddr: 'crovalcons',
                    bech32PrefixConsPub: 'crovalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'CRO',
                        coinMinimalDenom: 'basecro',
                        coinDecimals: 8,
                        coinGeckoId: 'crypto-com-chain',
                        coinImageUrl: '/tokens/blockchain/cro.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'CRO',
                        coinMinimalDenom: 'basecro',
                        coinDecimals: 8,
                        coinGeckoId: 'crypto-com-chain',
                        coinImageUrl: '/tokens/blockchain/cro.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/crypto-org/txs/{txHash}',
                gasPriceStep: {
                    low: 0.025,
                    average: 0.03,
                    high: 0.04
                },
                tokenUrl: null
            }
        },
        CHIHUAHUA: {
            name: 'CHIHUAHUA',
            defaultDecimals: 6,
            addressPatterns: [
                '^(chihuahua1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'CHIHUAHUA',
                    symbol: 'HUAHUA',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/chihuahua.png',
            displayName: 'Chihuahua',
            shortName: 'Chihuahua',
            sort: 22,
            color: '#EFC92B',
            enabled: true,
            type: 'COSMOS',
            chainId: 'chihuahua-1',
            info: {
                experimental: true,
                rpc: 'https://rpc.chihuahua.wtf/',
                rest: 'https://api.chihuahua.wtf/',
                cosmostationLcdUrl: 'https://lcd-chihuahua.cosmostation.io',
                cosmostationApiUrl: 'https://api-chihuahua.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'chihuahua',
                chainName: 'Chihuahua',
                stakeCurrency: {
                    coinDenom: 'HUAHUA',
                    coinMinimalDenom: 'uhuahua',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:uhuahua',
                    coinImageUrl: '/tokens/blockchain/HUAHUA.svg'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'chihuahua',
                    bech32PrefixAccPub: 'chihuahuapub',
                    bech32PrefixValAddr: 'chihuahuavaloper',
                    bech32PrefixValPub: 'chihuahuavaloperpub',
                    bech32PrefixConsAddr: 'chihuahuavalcons',
                    bech32PrefixConsPub: 'chihuahuavalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'HUAHUA',
                        coinMinimalDenom: 'uhuahua',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uhuahua',
                        coinImageUrl: '/tokens/blockchain/HUAHUA.svg'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'HUAHUA',
                        coinMinimalDenom: 'uhuahua',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uhuahua',
                        coinImageUrl: '/tokens/blockchain/HUAHUA.svg'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx'
                ],
                explorerUrlToTx: 'https://ping.pub/chihuahua/tx/{txHash}',
                gasPriceStep: {
                    low: 0.025,
                    average: 0.03,
                    high: 0.035
                },
                tokenUrl: null
            }
        },
        BANDCHAIN: {
            name: 'BANDCHAIN',
            defaultDecimals: 6,
            addressPatterns: [
                '^(band1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BANDCHAIN',
                    symbol: 'BAND',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/bandchain.svg',
            displayName: 'BandChain',
            shortName: 'BandChain',
            sort: 23,
            color: '#4520E6',
            enabled: true,
            type: 'COSMOS',
            chainId: 'laozi-mainnet',
            info: {
                experimental: true,
                rpc: 'https://rpc.laozi3.bandchain.org/',
                rest: 'https://lcd-band.cosmostation.io',
                cosmostationLcdUrl: 'https://lcd-band.cosmostation.io',
                cosmostationApiUrl: 'https://api-band.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'band',
                chainName: 'BandChain',
                stakeCurrency: {
                    coinDenom: 'BAND',
                    coinMinimalDenom: 'uband',
                    coinDecimals: 6,
                    coinGeckoId: 'band-protocol',
                    coinImageUrl: '/tokens/blockchain/BAND.svg'
                },
                bip44: {
                    coinType: 494
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'band',
                    bech32PrefixAccPub: 'bandpub',
                    bech32PrefixValAddr: 'bandvaloper',
                    bech32PrefixValPub: 'bandvaloperpub',
                    bech32PrefixConsAddr: 'bandvalcons',
                    bech32PrefixConsPub: 'bandvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'BAND',
                        coinMinimalDenom: 'uband',
                        coinDecimals: 6,
                        coinGeckoId: 'band-protocol',
                        coinImageUrl: '/tokens/blockchain/BAND.svg'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'BAND',
                        coinMinimalDenom: 'uband',
                        coinDecimals: 6,
                        coinGeckoId: 'band-protocol',
                        coinImageUrl: '/tokens/blockchain/BAND.svg'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx'
                ],
                explorerUrlToTx: 'https://cosmoscan.io/tx/{txHash}',
                gasPriceStep: null,
                tokenUrl: null
            }
        },
        COMDEX: {
            name: 'COMDEX',
            defaultDecimals: 6,
            addressPatterns: [
                '^(comdex1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'COMDEX',
                    symbol: 'CMDX',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/comdex.svg',
            displayName: 'Comdex',
            shortName: 'Comdex',
            sort: 23,
            color: '#FE4350',
            enabled: true,
            type: 'COSMOS',
            chainId: 'comdex-1',
            info: {
                experimental: true,
                rpc: 'https://rpc.comdex.one',
                rest: 'https://rest.comdex.one',
                cosmostationLcdUrl: 'https://lcd-comdex.cosmostation.io',
                cosmostationApiUrl: 'https://api-comdex.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'comdex',
                chainName: 'Comdex',
                stakeCurrency: {
                    coinDenom: 'CMDX',
                    coinMinimalDenom: 'ucmdx',
                    coinDecimals: 6,
                    coinGeckoId: 'comdex',
                    coinImageUrl: '/tokens/blockchain/CMDX.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'comdex',
                    bech32PrefixAccPub: 'comdexpub',
                    bech32PrefixValAddr: 'comdexvaloper',
                    bech32PrefixValPub: 'comdexvaloperpub',
                    bech32PrefixConsAddr: 'comdexvalcons',
                    bech32PrefixConsPub: 'comdexvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'CMDX',
                        coinMinimalDenom: 'ucmdx',
                        coinDecimals: 6,
                        coinGeckoId: 'comdex',
                        coinImageUrl: '/tokens/blockchain/CMDX.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'CMDX',
                        coinMinimalDenom: 'ucmdx',
                        coinDecimals: 6,
                        coinGeckoId: 'comdex',
                        coinImageUrl: '/tokens/blockchain/CMDX.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/comdex/txs/{txHash}',
                gasPriceStep: null,
                tokenUrl: null
            }
        },
        REGEN: {
            name: 'REGEN',
            defaultDecimals: 6,
            addressPatterns: [
                '^(regen1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'REGEN',
                    symbol: 'REGEN',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/regen.png',
            displayName: 'Regen Network',
            shortName: 'Regen Network',
            sort: 24,
            color: '#4FB573',
            enabled: true,
            type: 'COSMOS',
            chainId: 'regen-1',
            info: {
                experimental: false,
                rpc: 'https://rpc-regen.keplr.app',
                rest: 'https://lcd-regen.keplr.app',
                cosmostationLcdUrl: 'https://lcd-regen.keplr.app',
                cosmostationApiUrl: 'https://api-regen.cosmostation.io/',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'regen',
                chainName: 'Regen Network',
                stakeCurrency: {
                    coinDenom: 'REGEN',
                    coinMinimalDenom: 'uregen',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:uregen',
                    coinImageUrl: '/tokens/blockchain/regen.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'regen',
                    bech32PrefixAccPub: 'regenpub',
                    bech32PrefixValAddr: 'regenvaloper',
                    bech32PrefixValPub: 'regenvaloperpub',
                    bech32PrefixConsAddr: 'regenvalcons',
                    bech32PrefixConsPub: 'regenvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'REGEN',
                        coinMinimalDenom: 'uregen',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uregen',
                        coinImageUrl: '/tokens/blockchain/regen.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'REGEN',
                        coinMinimalDenom: 'uregen',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uregen',
                        coinImageUrl: '/tokens/blockchain/regen.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://regen.aneka.io/txs/{txHash}',
                gasPriceStep: {
                    low: 0.015,
                    average: 0.025,
                    high: 0.04
                },
                tokenUrl: null
            }
        },
        IRIS: {
            name: 'IRIS',
            defaultDecimals: 6,
            addressPatterns: [
                '^(iaa1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'IRIS',
                    symbol: 'IRIS',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/iris.png',
            displayName: 'IRISnet',
            shortName: 'IRISnet',
            sort: 25,
            color: '#8A4A8E',
            enabled: true,
            type: 'COSMOS',
            chainId: 'irishub-1',
            info: {
                experimental: false,
                rpc: 'https://rpc-iris.keplr.app',
                rest: 'https://lcd-iris.keplr.app',
                cosmostationLcdUrl: 'https://lcd-iris.cosmostation.io',
                cosmostationApiUrl: 'https://api-iris.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'iris',
                chainName: 'IRISnet',
                stakeCurrency: {
                    coinDenom: 'IRIS',
                    coinMinimalDenom: 'uiris',
                    coinDecimals: 6,
                    coinGeckoId: 'iris-network',
                    coinImageUrl: '/tokens/blockchain/iris.svg'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'iaa',
                    bech32PrefixAccPub: 'iaapub',
                    bech32PrefixValAddr: 'iaavaloper',
                    bech32PrefixValPub: 'iaavaloperpub',
                    bech32PrefixConsAddr: 'iaavalcons',
                    bech32PrefixConsPub: 'iaavalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'IRIS',
                        coinMinimalDenom: 'uiris',
                        coinDecimals: 6,
                        coinGeckoId: 'iris-network',
                        coinImageUrl: '/tokens/blockchain/iris.svg'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'IRIS',
                        coinMinimalDenom: 'uiris',
                        coinDecimals: 6,
                        coinGeckoId: 'iris-network',
                        coinImageUrl: '/tokens/blockchain/iris.svg'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/iris/txs/{txHash}',
                gasPriceStep: {
                    low: 0.2,
                    average: 0.3,
                    high: 0.4
                },
                tokenUrl: null
            }
        },
        EMONEY: {
            name: 'EMONEY',
            defaultDecimals: 6,
            addressPatterns: [
                '^(emoney1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'EMONEY',
                    symbol: 'NGM',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/emoney.svg',
            displayName: 'e-Money',
            shortName: 'e-Money',
            sort: 25,
            color: '#DFF5EF',
            enabled: true,
            type: 'COSMOS',
            chainId: 'emoney-3',
            info: {
                experimental: true,
                rpc: 'https://rpc-emoney.keplr.app',
                rest: 'https://lcd-emoney.keplr.app',
                cosmostationLcdUrl: 'https://lcd-emoney.cosmostation.io',
                cosmostationApiUrl: 'https://api-emoney.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/applications/transfer/v1beta1/denom_traces/',
                mintScanName: 'emoney',
                chainName: 'e-Money',
                stakeCurrency: {
                    coinDenom: 'NGM',
                    coinMinimalDenom: 'ungm',
                    coinDecimals: 6,
                    coinGeckoId: 'e-money',
                    coinImageUrl: '/tokens/blockchain/NGM.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'emoney',
                    bech32PrefixAccPub: 'emoneypub',
                    bech32PrefixValAddr: 'emoneyvaloper',
                    bech32PrefixValPub: 'emoneyvaloperpub',
                    bech32PrefixConsAddr: 'emoneyvalcons',
                    bech32PrefixConsPub: 'emoneyvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'NGM',
                        coinMinimalDenom: 'ungm',
                        coinDecimals: 6,
                        coinGeckoId: 'e-money',
                        coinImageUrl: '/tokens/blockchain/NGM.png'
                    },
                    {
                        coinDenom: 'EEUR',
                        coinMinimalDenom: 'eeur',
                        coinDecimals: 6,
                        coinGeckoId: 'e-money-eur',
                        coinImageUrl: '/tokens/blockchain/EEUR.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'NGM',
                        coinMinimalDenom: 'ungm',
                        coinDecimals: 6,
                        coinGeckoId: 'e-money',
                        coinImageUrl: '/tokens/blockchain/NGM.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://emoney.bigdipper.live/transactions/{txHash}',
                gasPriceStep: {
                    low: 1,
                    average: 1,
                    high: 1
                },
                tokenUrl: null
            }
        },
        GNOSIS: {
            name: 'GNOSIS',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'GNOSIS',
                    symbol: 'XDAI',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/gnosis.svg',
            displayName: 'Gnosis',
            shortName: 'Gnosis',
            sort: 26,
            color: '#3E6957',
            enabled: true,
            type: 'EVM',
            chainId: '0x64',
            info: {
                chainName: 'Gnosis Chain',
                nativeCurrency: {
                    name: 'XDAI',
                    symbol: 'XDAI',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.gnosischain.com'
                ],
                blockExplorerUrls: [
                    'https://blockscout.com/xdai/mainnet'
                ],
                addressUrl: 'https://blockscout.com/xdai/mainnet/address/{wallet}',
                transactionUrl: 'https://blockscout.com/xdai/mainnet/tx/{txHash}',
                tokenUrl: null
            }
        },
        LTC: {
            name: 'LTC',
            defaultDecimals: 8,
            addressPatterns: [
                '^(L|M|3)[A-Za-z0-9]{33}$|^(ltc1)[0-9A-Za-z]{39}$'
            ],
            feeAssets: [
                {
                    blockchain: 'LTC',
                    symbol: 'LTC',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/ltc.svg',
            displayName: 'LiteCoin',
            shortName: 'LTC',
            sort: 27,
            color: '#345D9D',
            enabled: true,
            type: 'TRANSFER',
            chainId: null,
            info: null
        },
        BCH: {
            name: 'BCH',
            defaultDecimals: 8,
            addressPatterns: [
                '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[0-9A-Za-z]{42,42}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BCH',
                    symbol: 'BCH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/bch.svg',
            displayName: 'Bitcoin Cash',
            shortName: 'BCH',
            sort: 28,
            color: '#0AC18E',
            enabled: true,
            type: 'TRANSFER',
            chainId: null,
            info: null
        },
        FUSE: {
            name: 'FUSE',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'FUSE',
                    symbol: 'FUSE',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/fuse.png',
            displayName: 'Fuse',
            shortName: 'Fuse',
            sort: 29,
            color: '#C5F9AD',
            enabled: true,
            type: 'EVM',
            chainId: '0x7a',
            info: {
                chainName: 'Fuse Mainnet',
                nativeCurrency: {
                    name: 'FUSE',
                    symbol: 'FUSE',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.fuse.io'
                ],
                blockExplorerUrls: [
                    'https://explorer.fuse.io'
                ],
                addressUrl: 'https://explorer.fuse.io/address/{wallet}',
                transactionUrl: 'https://explorer.fuse.io/tx/{txHash}',
                tokenUrl: null
            }
        },
        AKASH: {
            name: 'AKASH',
            defaultDecimals: 6,
            addressPatterns: [
                '^(akash1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'AKASH',
                    symbol: 'AKT',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/akash.svg',
            displayName: 'Akash',
            shortName: 'Akash',
            sort: 30,
            color: '#ED3524',
            enabled: true,
            type: 'COSMOS',
            chainId: 'akashnet-2',
            info: {
                experimental: false,
                rpc: 'https://rpc-akash.keplr.app',
                rest: 'https://lcd-akash.keplr.app',
                cosmostationLcdUrl: 'https://lcd-akash.cosmostation.io',
                cosmostationApiUrl: 'https://api-akash.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'akash',
                chainName: 'Akash',
                stakeCurrency: {
                    coinDenom: 'AKT',
                    coinMinimalDenom: 'uakt',
                    coinDecimals: 6,
                    coinGeckoId: 'akash-network',
                    coinImageUrl: '/tokens/blockchain/akt.svg'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'akash',
                    bech32PrefixAccPub: 'akashpub',
                    bech32PrefixValAddr: 'akashvaloper',
                    bech32PrefixValPub: 'akashvaloperpub',
                    bech32PrefixConsAddr: 'akashvalcons',
                    bech32PrefixConsPub: 'akashvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'AKT',
                        coinMinimalDenom: 'uakt',
                        coinDecimals: 6,
                        coinGeckoId: 'akash-network',
                        coinImageUrl: '/tokens/blockchain/akt.svg'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'AKT',
                        coinMinimalDenom: 'uakt',
                        coinDecimals: 6,
                        coinGeckoId: 'akash-network',
                        coinImageUrl: '/tokens/blockchain/akt.svg'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/akash/txs/{txHash}',
                gasPriceStep: {
                    low: 0.001,
                    average: 0.0025,
                    high: 0.004
                },
                tokenUrl: null
            }
        },
        KI: {
            name: 'KI',
            defaultDecimals: 6,
            addressPatterns: [
                '^(ki1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'KI',
                    symbol: 'XKI',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/ki.png',
            displayName: 'Ki',
            shortName: 'Ki',
            sort: 30,
            color: '#0F2B3D',
            enabled: true,
            type: 'COSMOS',
            chainId: 'kichain-2',
            info: {
                experimental: true,
                rpc: 'https://rpc-mainnet.blockchain.ki',
                rest: 'https://api-mainnet.blockchain.ki',
                cosmostationLcdUrl: 'https://lcd-kichain.cosmostation.io',
                cosmostationApiUrl: 'https://api-kichain.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'ki-chain',
                chainName: 'Ki',
                stakeCurrency: {
                    coinDenom: 'XKI',
                    coinMinimalDenom: 'uxki',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:uxki',
                    coinImageUrl: '/tokens/blockchain/XKI.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'ki',
                    bech32PrefixAccPub: 'kipub',
                    bech32PrefixValAddr: 'kivaloper',
                    bech32PrefixValPub: 'kivaloperpub',
                    bech32PrefixConsAddr: 'kivalcons',
                    bech32PrefixConsPub: 'kivalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'XKI',
                        coinMinimalDenom: 'uxki',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uxki',
                        coinImageUrl: '/tokens/blockchain/XKI.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'XKI',
                        coinMinimalDenom: 'uxki',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uxki',
                        coinImageUrl: '/tokens/blockchain/XKI.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/ki-chain/txs/{txHash}',
                gasPriceStep: null,
                tokenUrl: null
            }
        },
        KUJIRA: {
            name: 'KUJIRA',
            defaultDecimals: 6,
            addressPatterns: [
                '^(kujira1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'KUJIRA',
                    symbol: 'KUJI',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/kuji.svg',
            displayName: 'Kujira',
            shortName: 'Kujira',
            sort: 31,
            color: '#DF3935',
            enabled: true,
            type: 'COSMOS',
            chainId: 'kaiyo-1',
            info: {
                experimental: true,
                rpc: 'https://rpc.kaiyo.kujira.setten.io',
                rest: 'https://lcd.kaiyo.kujira.setten.io',
                cosmostationLcdUrl: 'https://lcd-kujira.cosmostation.io',
                cosmostationApiUrl: 'https://api-kujira.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'kujira',
                chainName: 'Kujira',
                stakeCurrency: {
                    coinDenom: 'KUJI',
                    coinMinimalDenom: 'ukuji',
                    coinDecimals: 6,
                    coinGeckoId: 'kujira',
                    coinImageUrl: '/tokens/blockchain/kuji.svg'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'kujira',
                    bech32PrefixAccPub: 'kujirapub',
                    bech32PrefixValAddr: 'kujiravaloper',
                    bech32PrefixValPub: 'kujiravaloperpub',
                    bech32PrefixConsAddr: 'kujiravalcons',
                    bech32PrefixConsPub: 'kujiravalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'KUJI',
                        coinMinimalDenom: 'ukuji',
                        coinDecimals: 6,
                        coinGeckoId: 'kujira',
                        coinImageUrl: '/tokens/blockchain/kuji.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'KUJI',
                        coinMinimalDenom: 'ukuji',
                        coinDecimals: 6,
                        coinGeckoId: 'kujira',
                        coinImageUrl: '/tokens/blockchain/kuji.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://finder.kujira.app/kaiyo-1/tx/{txHash}',
                gasPriceStep: {
                    low: 0.01,
                    average: 0.025,
                    high: 0.03
                },
                tokenUrl: null
            }
        },
        PERSISTENCE: {
            name: 'PERSISTENCE',
            defaultDecimals: 6,
            addressPatterns: [
                '^(persistence1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'PERSISTENCE',
                    symbol: 'XPRT',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/persistence.png',
            displayName: 'Persistence',
            shortName: 'Persistence',
            sort: 31,
            color: '#383838',
            enabled: true,
            type: 'COSMOS',
            chainId: 'core-1',
            info: {
                experimental: false,
                rpc: 'https://rpc-persistence.keplr.app',
                rest: 'https://lcd-persistence.keplr.app',
                cosmostationLcdUrl: 'https://lcd-persistence.cosmostation.io',
                cosmostationApiUrl: 'https://api-persistence.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'persistence',
                chainName: 'Persistence',
                stakeCurrency: {
                    coinDenom: 'XPRT',
                    coinMinimalDenom: 'uxprt',
                    coinDecimals: 6,
                    coinGeckoId: 'persistence',
                    coinImageUrl: '/tokens/blockchain/xprt.png'
                },
                bip44: {
                    coinType: 750
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'persistence',
                    bech32PrefixAccPub: 'persistencepub',
                    bech32PrefixValAddr: 'persistencevaloper',
                    bech32PrefixValPub: 'persistencevaloperpub',
                    bech32PrefixConsAddr: 'persistencevalcons',
                    bech32PrefixConsPub: 'persistencevalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'XPRT',
                        coinMinimalDenom: 'uxprt',
                        coinDecimals: 6,
                        coinGeckoId: 'persistence',
                        coinImageUrl: '/tokens/blockchain/xprt.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'XPRT',
                        coinMinimalDenom: 'uxprt',
                        coinDecimals: 6,
                        coinGeckoId: 'persistence',
                        coinImageUrl: '/tokens/blockchain/xprt.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/persistence/txs/{txHash}',
                gasPriceStep: {
                    low: 0,
                    average: 0.025,
                    high: 0.04
                },
                tokenUrl: null
            }
        },
        SENTINEL: {
            name: 'SENTINEL',
            defaultDecimals: 6,
            addressPatterns: [
                '^(sent1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'SENTINEL',
                    symbol: 'DVPN',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/sentinel.png',
            displayName: 'Sentinel',
            shortName: 'Sentinel',
            sort: 32,
            color: '#142E51',
            enabled: true,
            type: 'COSMOS',
            chainId: 'sentinelhub-2',
            info: {
                experimental: false,
                rpc: 'https://rpc-sentinel.keplr.app',
                rest: 'https://lcd-sentinel.keplr.app',
                cosmostationLcdUrl: 'https://lcd-sentinel.cosmostation.io',
                cosmostationApiUrl: 'https://api-sentinel.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'sentinel',
                chainName: 'Sentinel',
                stakeCurrency: {
                    coinDenom: 'DVPN',
                    coinMinimalDenom: 'udvpn',
                    coinDecimals: 6,
                    coinGeckoId: 'sentinel',
                    coinImageUrl: '/tokens/blockchain/dvpn.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'sent',
                    bech32PrefixAccPub: 'sentpub',
                    bech32PrefixValAddr: 'sentvaloper',
                    bech32PrefixValPub: 'sentvaloperpub',
                    bech32PrefixConsAddr: 'sentvalcons',
                    bech32PrefixConsPub: 'sentvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'DVPN',
                        coinMinimalDenom: 'udvpn',
                        coinDecimals: 6,
                        coinGeckoId: 'sentinel',
                        coinImageUrl: '/tokens/blockchain/dvpn.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'DVPN',
                        coinMinimalDenom: 'udvpn',
                        coinDecimals: 6,
                        coinGeckoId: 'sentinel',
                        coinImageUrl: '/tokens/blockchain/dvpn.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/sentinel/txs/{txHash}',
                gasPriceStep: {
                    low: 0.1,
                    average: 0.25,
                    high: 0.4
                },
                tokenUrl: null
            }
        },
        STARNAME: {
            name: 'STARNAME',
            defaultDecimals: 6,
            addressPatterns: [
                '^(star1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'STARNAME',
                    symbol: 'IOV',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/starname.png',
            displayName: 'Starname',
            shortName: 'Starname',
            sort: 35,
            color: '#BC64BB',
            enabled: true,
            type: 'COSMOS',
            chainId: 'iov-mainnet-ibc',
            info: {
                experimental: false,
                rpc: 'https://rpc-iov.keplr.app',
                rest: 'https://lcd-iov.keplr.app',
                cosmostationLcdUrl: 'https://lcd-iov.cosmostation.io',
                cosmostationApiUrl: 'https://api-iov.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/applications/transfer/v1beta1/denom_traces/',
                mintScanName: 'starname',
                chainName: 'Starname',
                stakeCurrency: {
                    coinDenom: 'IOV',
                    coinMinimalDenom: 'uiov',
                    coinDecimals: 6,
                    coinGeckoId: 'starname',
                    coinImageUrl: '/tokens/blockchain/IOV.png'
                },
                bip44: {
                    coinType: 494
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'star',
                    bech32PrefixAccPub: 'starpub',
                    bech32PrefixValAddr: 'starvaloper',
                    bech32PrefixValPub: 'starvaloperpub',
                    bech32PrefixConsAddr: 'starvalcons',
                    bech32PrefixConsPub: 'starvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'IOV',
                        coinMinimalDenom: 'uiov',
                        coinDecimals: 6,
                        coinGeckoId: 'starname',
                        coinImageUrl: '/tokens/blockchain/IOV.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'IOV',
                        coinMinimalDenom: 'uiov',
                        coinDecimals: 6,
                        coinGeckoId: 'starname',
                        coinImageUrl: '/tokens/blockchain/IOV.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/starname/txs/{txHash}',
                gasPriceStep: {
                    low: 1,
                    average: 2,
                    high: 3
                },
                tokenUrl: null
            }
        },
        UMEE: {
            name: 'UMEE',
            defaultDecimals: 6,
            addressPatterns: [
                '^(umee1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'UMEE',
                    symbol: 'UMEE',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/umee.svg',
            displayName: 'Umee',
            shortName: 'Umee',
            sort: 36,
            color: '#D2B6FF',
            enabled: true,
            type: 'COSMOS',
            chainId: 'umee-1',
            info: {
                experimental: false,
                rpc: 'https://api.barnacle.mainnet.network.umee.cc',
                rest: 'https://lcd-umee.cosmostation.io',
                cosmostationLcdUrl: 'https://lcd-umee.cosmostation.io',
                cosmostationApiUrl: 'https://api-umee.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'umee',
                chainName: 'Umee',
                stakeCurrency: {
                    coinDenom: 'UMEE',
                    coinMinimalDenom: 'uumee',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:uumee',
                    coinImageUrl: '/tokens/blockchain/UMEE.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'umee',
                    bech32PrefixAccPub: 'umeepub',
                    bech32PrefixValAddr: 'umeevaloper',
                    bech32PrefixValPub: 'umeevaloperpub',
                    bech32PrefixConsAddr: 'umeevalcons',
                    bech32PrefixConsPub: 'umeevalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'UMEE',
                        coinMinimalDenom: 'uumee',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uumee',
                        coinImageUrl: '/tokens/blockchain/UMEE.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'UMEE',
                        coinMinimalDenom: 'uumee',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:uumee',
                        coinImageUrl: '/tokens/blockchain/UMEE.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/umee/txs/{txHash}',
                gasPriceStep: {
                    low: 0.05,
                    average: 0.06,
                    high: 0.1
                },
                tokenUrl: null
            }
        },
        BITCANNA: {
            name: 'BITCANNA',
            defaultDecimals: 6,
            addressPatterns: [
                '^(bcna1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BITCANNA',
                    symbol: 'BCNA',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/bitcanna.svg',
            displayName: 'BitCanna',
            shortName: 'BitCanna',
            sort: 36,
            color: '#3CC194',
            enabled: true,
            type: 'COSMOS',
            chainId: 'bitcanna-1',
            info: {
                experimental: true,
                rpc: 'https://rpc.bitcanna.io',
                rest: 'https://lcd.bitcanna.io',
                cosmostationLcdUrl: 'https://lcd-bitcanna.cosmostation.io',
                cosmostationApiUrl: 'https://api-bitcanna.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'bitcanna',
                chainName: 'BitCanna',
                stakeCurrency: {
                    coinDenom: 'BCNA',
                    coinMinimalDenom: 'ubcna',
                    coinDecimals: 6,
                    coinGeckoId: 'bitcanna',
                    coinImageUrl: '/tokens/blockchain/BCNA.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'bcna',
                    bech32PrefixAccPub: 'bcnapub',
                    bech32PrefixValAddr: 'bcnavaloper',
                    bech32PrefixValPub: 'bcnavaloperpub',
                    bech32PrefixConsAddr: 'bcnavalcons',
                    bech32PrefixConsPub: 'bcnavalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'BCNA',
                        coinMinimalDenom: 'ubcna',
                        coinDecimals: 6,
                        coinGeckoId: 'bitcanna',
                        coinImageUrl: '/tokens/blockchain/BCNA.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'BCNA',
                        coinMinimalDenom: 'ubcna',
                        coinDecimals: 6,
                        coinGeckoId: 'bitcanna',
                        coinImageUrl: '/tokens/blockchain/BCNA.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/bitcanna/txs/{txHash}',
                gasPriceStep: null,
                tokenUrl: null
            }
        },
        DESMOS: {
            name: 'DESMOS',
            defaultDecimals: 6,
            addressPatterns: [
                '^(desmos1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'DESMOS',
                    symbol: 'DSM',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/desmos.svg',
            displayName: 'Desmos',
            shortName: 'Desmos',
            sort: 37,
            color: '#DF6952',
            enabled: true,
            type: 'COSMOS',
            chainId: 'desmos-mainnet',
            info: {
                experimental: true,
                rpc: 'https://rpc.mainnet.desmos.network',
                rest: 'https://api.mainnet.desmos.network',
                cosmostationLcdUrl: 'https://lcd-desmos.cosmostation.io',
                cosmostationApiUrl: 'https://api-desmos.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'desmos',
                chainName: 'Desmos',
                stakeCurrency: {
                    coinDenom: 'DSM',
                    coinMinimalDenom: 'udsm',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:udsm',
                    coinImageUrl: '/tokens/blockchain/DSM.png'
                },
                bip44: {
                    coinType: 852
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'desmos',
                    bech32PrefixAccPub: 'desmospub',
                    bech32PrefixValAddr: 'desmosvaloper',
                    bech32PrefixValPub: 'desmosvaloperpub',
                    bech32PrefixConsAddr: 'desmosvalcons',
                    bech32PrefixConsPub: 'desmosvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'DSM',
                        coinMinimalDenom: 'udsm',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:udsm',
                        coinImageUrl: '/tokens/blockchain/DSM.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'DSM',
                        coinMinimalDenom: 'udsm',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:udsm',
                        coinImageUrl: '/tokens/blockchain/DSM.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx',
                    'ibc-go'
                ],
                explorerUrlToTx: 'https://explorer.desmos.network/transactions/{txHash}',
                gasPriceStep: null,
                tokenUrl: null
            }
        },
        LUMNETWORK: {
            name: 'LUMNETWORK',
            defaultDecimals: 6,
            addressPatterns: [
                '^(lum1)[0-9a-z]{38}$'
            ],
            feeAssets: [
                {
                    blockchain: 'LUMNETWORK',
                    symbol: 'LUM',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/lumnetwork.svg',
            displayName: 'Lum Network',
            shortName: 'Lum Network',
            sort: 38,
            color: '#1B42B4',
            enabled: true,
            type: 'COSMOS',
            chainId: 'lum-network-1',
            info: {
                experimental: true,
                rpc: 'https://node0.mainnet.lum.network/rpc',
                rest: 'https://node0.mainnet.lum.network/rest',
                cosmostationLcdUrl: 'https://lcd-lum.cosmostation.io',
                cosmostationApiUrl: 'https://api-lum.cosmostation.io',
                cosmostationDenomTracePath: '/ibc/apps/transfer/v1/denom_traces/',
                mintScanName: 'lum',
                chainName: 'Lum Network',
                stakeCurrency: {
                    coinDenom: 'LUM',
                    coinMinimalDenom: 'ulum',
                    coinDecimals: 6,
                    coinGeckoId: 'pool:ulum',
                    coinImageUrl: '/tokens/blockchain/LUM.png'
                },
                bip44: {
                    coinType: 118
                },
                bech32Config: {
                    bech32PrefixAccAddr: 'lum',
                    bech32PrefixAccPub: 'lumpub',
                    bech32PrefixValAddr: 'lumvaloper',
                    bech32PrefixValPub: 'lumvaloperpub',
                    bech32PrefixConsAddr: 'lumvalcons',
                    bech32PrefixConsPub: 'lumvalconspub'
                },
                currencies: [
                    {
                        coinDenom: 'LUM',
                        coinMinimalDenom: 'ulum',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:ulum',
                        coinImageUrl: '/tokens/blockchain/LUM.png'
                    }
                ],
                feeCurrencies: [
                    {
                        coinDenom: 'LUM',
                        coinMinimalDenom: 'ulum',
                        coinDecimals: 6,
                        coinGeckoId: 'pool:ulum',
                        coinImageUrl: '/tokens/blockchain/LUM.png'
                    }
                ],
                features: [
                    'stargate',
                    'ibc-transfer',
                    'no-legacy-stdTx',
                    'ibc-go'
                ],
                explorerUrlToTx: 'https://www.mintscan.io/lum/txs/{txHash}',
                gasPriceStep: null,
                tokenUrl: null
            }
        },
        BOBA: {
            name: 'BOBA',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BOBA',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/boba.png',
            displayName: 'Boba',
            shortName: 'Boba',
            sort: 39,
            color: '#ccff00',
            enabled: true,
            type: 'EVM',
            chainId: '0x120',
            info: {
                chainName: 'Boba Network',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://mainnet.boba.network'
                ],
                blockExplorerUrls: [
                    'https://bobascan.com/'
                ],
                addressUrl: 'https://bobascan.com//address/{wallet}',
                transactionUrl: 'https://bobascan.com//tx/{txHash}',
                tokenUrl: null
            }
        }
    },
    evmNetworkChainInfo: {
        BSC: {
            chainName: 'Binance Smart Chain Mainnet',
            chainId: '0x38',
            nativeCurrency: {
                name: 'BNB',
                symbol: 'BNB',
                decimals: 18
            },
            rpcUrls: [
                'https://bsc-dataseed1.ninicoin.io'
            ],
            blockExplorerUrls: [
                'https://bscscan.com'
            ]
        },
        POLYGON: {
            chainName: 'Polygon Mainnet',
            chainId: '0x89',
            nativeCurrency: {
                name: 'MATIC',
                symbol: 'MATIC',
                decimals: 18
            },
            rpcUrls: [
                'https://polygon-rpc.com'
            ],
            blockExplorerUrls: [
                'https://polygonscan.com'
            ]
        },
        ETH: {
            chainName: 'Ethereum Mainnet',
            chainId: '0x1',
            nativeCurrency: {
                name: 'ETH',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: [
                'https://rpc.ankr.com/eth'
            ],
            blockExplorerUrls: [
                'https://etherscan.io'
            ]
        },
        AVAX_CCHAIN: {
            chainName: 'Avalanche C-Chain',
            chainId: '0xa86a',
            nativeCurrency: {
                name: 'AVAX',
                symbol: 'AVAX',
                decimals: 18
            },
            rpcUrls: [
                'https://api.avax.network/ext/bc/C/rpc'
            ],
            blockExplorerUrls: [
                'https://snowtrace.io'
            ]
        },
        ARBITRUM: {
            chainName: 'Arbitrum One',
            chainId: '0xa4b1',
            nativeCurrency: {
                name: 'ETH',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: [
                'https://arb1.arbitrum.io/rpc'
            ],
            blockExplorerUrls: [
                'https://arbiscan.io'
            ]
        },
        FANTOM: {
            chainName: 'Fantom Opera',
            chainId: '0xfa',
            nativeCurrency: {
                name: 'FTM',
                symbol: 'FTM',
                decimals: 18
            },
            rpcUrls: [
                'https://rpc.ftm.tools'
            ],
            blockExplorerUrls: [
                'https://ftmscan.com'
            ]
        },
        OPTIMISM: {
            chainName: 'Optimism',
            chainId: '0xa',
            nativeCurrency: {
                name: 'ETH',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: [
                'https://mainnet.optimism.io'
            ],
            blockExplorerUrls: [
                'https://optimistic.etherscan.io'
            ]
        },
        OKC: {
            chainName: 'OKX Chain',
            chainId: '0x42',
            nativeCurrency: {
                name: 'OKT',
                symbol: 'OKT',
                decimals: 18
            },
            rpcUrls: [
                'https://exchainrpc.okex.org'
            ],
            blockExplorerUrls: [
                'https://www.oklink.com/en/okc'
            ]
        },
        CRONOS: {
            chainName: 'Cronos Mainnet Beta',
            chainId: '0x19',
            nativeCurrency: {
                name: 'CRO',
                symbol: 'CRO',
                decimals: 18
            },
            rpcUrls: [
                'https://cronosrpc-1.xstaking.sg'
            ],
            blockExplorerUrls: [
                'https://cronoscan.com'
            ]
        },
        MOONRIVER: {
            chainName: 'MoonRiver',
            chainId: '0x505',
            nativeCurrency: {
                name: 'MOVR',
                symbol: 'MOVR',
                decimals: 18
            },
            rpcUrls: [
                'https://rpc.moonriver.moonbeam.network'
            ],
            blockExplorerUrls: [
                'https://moonriver.moonscan.io'
            ]
        },
        MOONBEAM: {
            chainName: 'MoonBeam',
            chainId: '0x504',
            nativeCurrency: {
                name: 'GLMR',
                symbol: 'GLMR',
                decimals: 18
            },
            rpcUrls: [
                'https://rpc.api.moonbeam.network'
            ],
            blockExplorerUrls: [
                'https://moonbeam.moonscan.io'
            ]
        },
        HECO: {
            chainName: 'Huobi ECO Chain Mainnet',
            chainId: '0x80',
            nativeCurrency: {
                name: 'HT',
                symbol: 'HT',
                decimals: 18
            },
            rpcUrls: [
                'https://http-mainnet.hecochain.com'
            ],
            blockExplorerUrls: [
                'https://hecoinfo.com'
            ]
        },
        AURORA: {
            chainName: 'Aurora Mainnet',
            chainId: '0x4e454152',
            nativeCurrency: {
                name: 'ETH',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: [
                'https://mainnet.aurora.dev'
            ],
            blockExplorerUrls: [
                'https://explorer.mainnet.aurora.dev'
            ]
        },
        HARMONY: {
            chainName: 'Harmony Mainnet',
            chainId: '0x63564c40',
            nativeCurrency: {
                name: 'ONE',
                symbol: 'ONE',
                decimals: 18
            },
            rpcUrls: [
                'https://api.s0.t.hmny.io'
            ],
            blockExplorerUrls: [
                'https://explorer.harmony.one'
            ]
        },
        EVMOS: {
            chainName: 'Evmos',
            chainId: '0x2329',
            nativeCurrency: {
                name: 'EVMOS',
                symbol: 'EVMOS',
                decimals: 18
            },
            rpcUrls: [
                'https://eth.bd.evmos.org:8545'
            ],
            blockExplorerUrls: [
                'https://evm.evmos.org'
            ]
        },
        GNOSIS: {
            chainName: 'Gnosis Chain',
            chainId: '0x64',
            nativeCurrency: {
                name: 'XDAI',
                symbol: 'XDAI',
                decimals: 18
            },
            rpcUrls: [
                'https://rpc.gnosischain.com'
            ],
            blockExplorerUrls: [
                'https://blockscout.com/xdai/mainnet'
            ]
        },
        FUSE: {
            chainName: 'Fuse Mainnet',
            chainId: '0x7a',
            nativeCurrency: {
                name: 'FUSE',
                symbol: 'FUSE',
                decimals: 18
            },
            rpcUrls: [
                'https://rpc.fuse.io'
            ],
            blockExplorerUrls: [
                'https://explorer.fuse.io'
            ]
        },
        BOBA: {
            chainName: 'Boba Network',
            chainId: '0x120',
            nativeCurrency: {
                name: 'ETH',
                symbol: 'ETH',
                decimals: 18
            },
            rpcUrls: [
                'https://mainnet.boba.network'
            ],
            blockExplorerUrls: [
                'https://bobascan.com/'
            ]
        }
    },
    walletsAndSupportedChainsNames: {
        'binance-chain': [
            'BSC',
            'ETH',
            'BNB'
        ],
        metamask: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA'
        ],
        coinbase: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'SOLANA'
        ],
        keplr: [
            'OSMOSIS',
            'JUNO',
            'COSMOS',
            'SIF',
            'STARGAZE',
            'CRYPTO_ORG',
            'CHIHUAHUA',
            'BANDCHAIN',
            'COMDEX',
            'REGEN',
            'IRIS',
            'EMONEY',
            'AKASH',
            'KI',
            'KUJIRA',
            'PERSISTENCE',
            'SENTINEL',
            'STARNAME',
            'UMEE',
            'BITCANNA',
            'DESMOS',
            'LUMNETWORK'
        ],
        phantom: [
            'SOLANA'
        ],
        xdefi: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'SOLANA',
            'THOR',
            'BNB',
            'BTC',
            'LTC',
            'BCH'
        ],
        'wallet-connect-2': [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA'
        ],
        'trust-wallet': [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA'
        ],
        coin98: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'SOLANA'
        ],
        okx: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'SOLANA',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HARMONY',
            'BTC',
            'GNOSIS',
            'LTC',
            'BOBA'
        ],
        exodus: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'SOLANA',
            'BNB'
        ],
        'token-pocket': [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA'
        ],
        'terra-station': [],
        leap: [],
        math: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'SOLANA'
        ],
        safepal: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'SOLANA'
        ],
        clover: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'SOLANA'
        ],
        cosmostation: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'OSMOSIS',
            'JUNO',
            'COSMOS',
            'SIF',
            'STARGAZE',
            'CRYPTO_ORG',
            'CHIHUAHUA',
            'BANDCHAIN',
            'COMDEX',
            'REGEN',
            'IRIS',
            'EMONEY',
            'AKASH',
            'KI',
            'KUJIRA',
            'PERSISTENCE',
            'SENTINEL',
            'STARNAME',
            'UMEE',
            'BITCANNA',
            'DESMOS',
            'LUMNETWORK'
        ],
        brave: [
            'BSC',
            'POLYGON',
            'ETH',
            'AVAX_CCHAIN',
            'ARBITRUM',
            'FANTOM',
            'OPTIMISM',
            'OKC',
            'CRONOS',
            'MOONRIVER',
            'MOONBEAM',
            'HECO',
            'AURORA',
            'HARMONY',
            'EVMOS',
            'GNOSIS',
            'FUSE',
            'BOBA',
            'SOLANA'
        ],
        unknown: []
    },
    evmBasedChains: [
        {
            name: 'BSC',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BSC',
                    symbol: 'BNB',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/binance.svg',
            displayName: 'BSC',
            shortName: 'BSC',
            sort: 1,
            color: '#F3BA2F',
            enabled: true,
            type: 'EVM',
            chainId: '0x38',
            info: {
                chainName: 'Binance Smart Chain Mainnet',
                nativeCurrency: {
                    name: 'BNB',
                    symbol: 'BNB',
                    decimals: 18
                },
                rpcUrls: [
                    'https://bsc-dataseed1.ninicoin.io'
                ],
                blockExplorerUrls: [
                    'https://bscscan.com'
                ],
                addressUrl: 'https://bscscan.com/address/{wallet}',
                transactionUrl: 'https://bscscan.com/tx/{txHash}',
                tokenUrl: 'https://bscscan.com/token/{address}'
            }
        },
        {
            name: 'POLYGON',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'POLYGON',
                    symbol: 'MATIC',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/polygon.svg',
            displayName: 'Polygon',
            shortName: 'Polygon',
            sort: 2,
            color: '#8247E5',
            enabled: true,
            type: 'EVM',
            chainId: '0x89',
            info: {
                chainName: 'Polygon Mainnet',
                nativeCurrency: {
                    name: 'MATIC',
                    symbol: 'MATIC',
                    decimals: 18
                },
                rpcUrls: [
                    'https://polygon-rpc.com'
                ],
                blockExplorerUrls: [
                    'https://polygonscan.com'
                ],
                addressUrl: 'https://polygonscan.com/address/{wallet}',
                transactionUrl: 'https://polygonscan.com/tx/{txHash}',
                tokenUrl: 'https://polygonscan.com/token/{address}'
            }
        },
        {
            name: 'ETH',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'ETH',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/ethereum.svg',
            displayName: 'Ethereum',
            shortName: 'ETH',
            sort: 3,
            color: '#ecf0f1',
            enabled: true,
            type: 'EVM',
            chainId: '0x1',
            info: {
                chainName: 'Ethereum Mainnet',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.ankr.com/eth'
                ],
                blockExplorerUrls: [
                    'https://etherscan.io'
                ],
                addressUrl: 'https://etherscan.io/address/{wallet}',
                transactionUrl: 'https://etherscan.io/tx/{txHash}',
                tokenUrl: 'https://etherscan.io/token/{address}'
            }
        },
        {
            name: 'AVAX_CCHAIN',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'AVAX_CCHAIN',
                    symbol: 'AVAX',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/avax_cchain.svg',
            displayName: 'Avalanche',
            shortName: 'Avax',
            sort: 6,
            color: '#e84142',
            enabled: true,
            type: 'EVM',
            chainId: '0xa86a',
            info: {
                chainName: 'Avalanche C-Chain',
                nativeCurrency: {
                    name: 'AVAX',
                    symbol: 'AVAX',
                    decimals: 18
                },
                rpcUrls: [
                    'https://api.avax.network/ext/bc/C/rpc'
                ],
                blockExplorerUrls: [
                    'https://snowtrace.io'
                ],
                addressUrl: 'https://snowtrace.io/address/{wallet}',
                transactionUrl: 'https://snowtrace.io/tx/{txHash}',
                tokenUrl: 'https://snowtrace.dev/token/{address}'
            }
        },
        {
            name: 'ARBITRUM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'ARBITRUM',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/arbitrum.svg',
            displayName: 'Arbitrum',
            shortName: 'Arbitrum',
            sort: 7,
            color: '#28a0f0',
            enabled: true,
            type: 'EVM',
            chainId: '0xa4b1',
            info: {
                chainName: 'Arbitrum One',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://arb1.arbitrum.io/rpc'
                ],
                blockExplorerUrls: [
                    'https://arbiscan.io'
                ],
                addressUrl: 'https://arbiscan.io/address/{wallet}',
                transactionUrl: 'https://arbiscan.io/tx/{txHash}',
                tokenUrl: 'https://arbiscan.io/token/{address}'
            }
        },
        {
            name: 'FANTOM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'FANTOM',
                    symbol: 'FTM',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/fantom.png',
            displayName: 'Fantom',
            shortName: 'Fantom',
            sort: 9,
            color: '#337afe',
            enabled: true,
            type: 'EVM',
            chainId: '0xfa',
            info: {
                chainName: 'Fantom Opera',
                nativeCurrency: {
                    name: 'FTM',
                    symbol: 'FTM',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.ftm.tools'
                ],
                blockExplorerUrls: [
                    'https://ftmscan.com'
                ],
                addressUrl: 'https://ftmscan.com/address/{wallet}',
                transactionUrl: 'https://ftmscan.com/tx/{txHash}',
                tokenUrl: 'https://explorer.fantom.network/token/{address}'
            }
        },
        {
            name: 'OPTIMISM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'OPTIMISM',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/optimism.svg',
            displayName: 'Optimism',
            shortName: 'Optimism',
            sort: 10,
            color: '#FF0420',
            enabled: true,
            type: 'EVM',
            chainId: '0xa',
            info: {
                chainName: 'Optimism',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://mainnet.optimism.io'
                ],
                blockExplorerUrls: [
                    'https://optimistic.etherscan.io'
                ],
                addressUrl: 'https://optimistic.etherscan.io/address/{wallet}',
                transactionUrl: 'https://optimistic.etherscan.io/tx/{txHash}',
                tokenUrl: 'https://optimistic.etherscan.io/token/{address}'
            }
        },
        {
            name: 'OKC',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'OKC',
                    symbol: 'OKT',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/okx.png',
            displayName: 'OKX Chain (OKC)',
            shortName: 'Okx',
            sort: 11,
            color: '#29a0f0',
            enabled: true,
            type: 'EVM',
            chainId: '0x42',
            info: {
                chainName: 'OKX Chain',
                nativeCurrency: {
                    name: 'OKT',
                    symbol: 'OKT',
                    decimals: 18
                },
                rpcUrls: [
                    'https://exchainrpc.okex.org'
                ],
                blockExplorerUrls: [
                    'https://www.oklink.com/en/okc'
                ],
                addressUrl: 'https://www.oklink.com/en/okc/address/{wallet}',
                transactionUrl: 'https://www.oklink.com/en/okc/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'CRONOS',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'CRONOS',
                    symbol: 'CRO',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/cronos.svg',
            displayName: 'Cronos',
            shortName: 'Cronos',
            sort: 12,
            color: '#1a90ff',
            enabled: true,
            type: 'EVM',
            chainId: '0x19',
            info: {
                chainName: 'Cronos Mainnet Beta',
                nativeCurrency: {
                    name: 'CRO',
                    symbol: 'CRO',
                    decimals: 18
                },
                rpcUrls: [
                    'https://cronosrpc-1.xstaking.sg'
                ],
                blockExplorerUrls: [
                    'https://cronoscan.com'
                ],
                addressUrl: 'https://cronoscan.com/address/{wallet}',
                transactionUrl: 'https://cronoscan.com/tx/{txHash}',
                tokenUrl: 'https://cronoscan.com/token/{address}'
            }
        },
        {
            name: 'MOONRIVER',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'MOONRIVER',
                    symbol: 'MOVR',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/moonriver.svg',
            displayName: 'MoonRiver',
            shortName: 'MoonRiver',
            sort: 13,
            color: '#F3B404',
            enabled: true,
            type: 'EVM',
            chainId: '0x505',
            info: {
                chainName: 'MoonRiver',
                nativeCurrency: {
                    name: 'MOVR',
                    symbol: 'MOVR',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.moonriver.moonbeam.network'
                ],
                blockExplorerUrls: [
                    'https://moonriver.moonscan.io'
                ],
                addressUrl: 'https://moonriver.moonscan.io/address/{wallet}',
                transactionUrl: 'https://moonriver.moonscan.io/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'MOONBEAM',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'MOONBEAM',
                    symbol: 'GLMR',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/moonbeam.png',
            displayName: 'MoonBeam',
            shortName: 'MoonBeam',
            sort: 14,
            color: '#B3206B',
            enabled: true,
            type: 'EVM',
            chainId: '0x504',
            info: {
                chainName: 'MoonBeam',
                nativeCurrency: {
                    name: 'GLMR',
                    symbol: 'GLMR',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.api.moonbeam.network'
                ],
                blockExplorerUrls: [
                    'https://moonbeam.moonscan.io'
                ],
                addressUrl: 'https://moonbeam.moonscan.io/address/{wallet}',
                transactionUrl: 'https://moonbeam.moonscan.io/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'HECO',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'HECO',
                    symbol: 'HT',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/heco.png',
            displayName: 'Heco',
            shortName: 'Heco',
            sort: 15,
            color: '#4CA852',
            enabled: true,
            type: 'EVM',
            chainId: '0x80',
            info: {
                chainName: 'Huobi ECO Chain Mainnet',
                nativeCurrency: {
                    name: 'HT',
                    symbol: 'HT',
                    decimals: 18
                },
                rpcUrls: [
                    'https://http-mainnet.hecochain.com'
                ],
                blockExplorerUrls: [
                    'https://hecoinfo.com'
                ],
                addressUrl: 'https://hecoinfo.com/address/{wallet}',
                transactionUrl: 'https://hecoinfo.com/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'AURORA',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'AURORA',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/aurora.svg',
            displayName: 'Aurora',
            shortName: 'Aurora',
            sort: 15,
            color: '#78d64b',
            enabled: true,
            type: 'EVM',
            chainId: '0x4e454152',
            info: {
                chainName: 'Aurora Mainnet',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://mainnet.aurora.dev'
                ],
                blockExplorerUrls: [
                    'https://explorer.mainnet.aurora.dev'
                ],
                addressUrl: 'https://explorer.mainnet.aurora.dev/address/{wallet}',
                transactionUrl: 'https://explorer.mainnet.aurora.dev/tx/{txHash}',
                tokenUrl: 'https://explorer.mainnet.aurora.dev/token/{address}'
            }
        },
        {
            name: 'HARMONY',
            defaultDecimals: 18,
            addressPatterns: [
                '^(one1)[0-9a-z]{38}$',
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'HARMONY',
                    symbol: 'ONE',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/harmony.svg',
            displayName: 'Harmony',
            shortName: 'Harmony',
            sort: 15,
            color: '#50AEE9',
            enabled: true,
            type: 'EVM',
            chainId: '0x63564c40',
            info: {
                chainName: 'Harmony Mainnet',
                nativeCurrency: {
                    name: 'ONE',
                    symbol: 'ONE',
                    decimals: 18
                },
                rpcUrls: [
                    'https://api.s0.t.hmny.io'
                ],
                blockExplorerUrls: [
                    'https://explorer.harmony.one'
                ],
                addressUrl: 'https://explorer.harmony.one/address/{wallet}',
                transactionUrl: 'https://explorer.harmony.one/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'EVMOS',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'EVMOS',
                    symbol: 'EVMOS',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/evmos.png',
            displayName: 'Evmos',
            shortName: 'Evmos',
            sort: 15,
            color: '#2D2925',
            enabled: true,
            type: 'EVM',
            chainId: '0x2329',
            info: {
                chainName: 'Evmos',
                nativeCurrency: {
                    name: 'EVMOS',
                    symbol: 'EVMOS',
                    decimals: 18
                },
                rpcUrls: [
                    'https://eth.bd.evmos.org:8545'
                ],
                blockExplorerUrls: [
                    'https://evm.evmos.org'
                ],
                addressUrl: 'https://evm.evmos.org/address/{wallet}',
                transactionUrl: 'https://evm.evmos.org/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'GNOSIS',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'GNOSIS',
                    symbol: 'XDAI',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/gnosis.svg',
            displayName: 'Gnosis',
            shortName: 'Gnosis',
            sort: 26,
            color: '#3E6957',
            enabled: true,
            type: 'EVM',
            chainId: '0x64',
            info: {
                chainName: 'Gnosis Chain',
                nativeCurrency: {
                    name: 'XDAI',
                    symbol: 'XDAI',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.gnosischain.com'
                ],
                blockExplorerUrls: [
                    'https://blockscout.com/xdai/mainnet'
                ],
                addressUrl: 'https://blockscout.com/xdai/mainnet/address/{wallet}',
                transactionUrl: 'https://blockscout.com/xdai/mainnet/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'FUSE',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'FUSE',
                    symbol: 'FUSE',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/fuse.png',
            displayName: 'Fuse',
            shortName: 'Fuse',
            sort: 29,
            color: '#C5F9AD',
            enabled: true,
            type: 'EVM',
            chainId: '0x7a',
            info: {
                chainName: 'Fuse Mainnet',
                nativeCurrency: {
                    name: 'FUSE',
                    symbol: 'FUSE',
                    decimals: 18
                },
                rpcUrls: [
                    'https://rpc.fuse.io'
                ],
                blockExplorerUrls: [
                    'https://explorer.fuse.io'
                ],
                addressUrl: 'https://explorer.fuse.io/address/{wallet}',
                transactionUrl: 'https://explorer.fuse.io/tx/{txHash}',
                tokenUrl: null
            }
        },
        {
            name: 'BOBA',
            defaultDecimals: 18,
            addressPatterns: [
                '^(0x)[0-9A-Fa-f]{40}$'
            ],
            feeAssets: [
                {
                    blockchain: 'BOBA',
                    symbol: 'ETH',
                    address: null
                }
            ],
            logo: 'https://api.rango.exchange/blockchains/boba.png',
            displayName: 'Boba',
            shortName: 'Boba',
            sort: 39,
            color: '#ccff00',
            enabled: true,
            type: 'EVM',
            chainId: '0x120',
            info: {
                chainName: 'Boba Network',
                nativeCurrency: {
                    name: 'ETH',
                    symbol: 'ETH',
                    decimals: 18
                },
                rpcUrls: [
                    'https://mainnet.boba.network'
                ],
                blockExplorerUrls: [
                    'https://bobascan.com/'
                ],
                addressUrl: 'https://bobascan.com//address/{wallet}',
                transactionUrl: 'https://bobascan.com//tx/{txHash}',
                tokenUrl: null
            }
        }
    ]
};


parcelRequire("7MbFH");
var $9HEDW = parcelRequire("9HEDW");
var $5a284c98426d7812$export$bb45678bd9ad9127 = /*#__PURE__*/ function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
    return MessageSeverity;
}({});
var $5a284c98426d7812$export$b1569e7f9d4064a9 = /*#__PURE__*/ function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
    return PendingSwapNetworkStatus;
}({});
const $5a284c98426d7812$export$6dda194cc719681 = 'OneInchEth';
const $5a284c98426d7812$export$38ad06dac3f281e2 = 'OneInchBsc';
const $5a284c98426d7812$export$21e653ae411187e3 = 'OneInchPolygon';
const $5a284c98426d7812$export$20a3449b8d7719c0 = 'Terra Bridge';
const $5a284c98426d7812$export$dc3cd679b8659a17 = 'Lido';
const $5a284c98426d7812$export$22df7c70199f520f = 'TerraSwap';
const $5a284c98426d7812$export$6d9125d5f3349ad4 = 'ThorChain';
const $5a284c98426d7812$export$c59fb7c70e27a38a = 'Binance Bridge';
const $5a284c98426d7812$export$4599477bfd98c98d = 'Osmosis';
const $5a284c98426d7812$export$d7bdddcc8b17e284 = [
    $5a284c98426d7812$export$6dda194cc719681,
    $5a284c98426d7812$export$38ad06dac3f281e2,
    $5a284c98426d7812$export$21e653ae411187e3
];
const $5a284c98426d7812$export$5fc74bc3c90095a2 = [
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).BSC
];
const $5a284c98426d7812$export$10794b7cd0786422 = 'BNB';
const $5a284c98426d7812$export$b83f797a75f556e0 = 'MATIC';
const $5a284c98426d7812$export$4b8df58f907f74d3 = new Map([
    [
        (0, $9HEDW.LegacyNetworks).ETHEREUM,
        (0, $9HEDW.LegacyNetworks).ETHEREUM
    ],
    [
        (0, $9HEDW.LegacyNetworks).BSC,
        $5a284c98426d7812$export$10794b7cd0786422
    ],
    [
        (0, $9HEDW.LegacyNetworks).POLYGON,
        $5a284c98426d7812$export$b83f797a75f556e0
    ]
]);
var $5a284c98426d7812$export$1494cd15f5dbc3a6 = /*#__PURE__*/ function(ApiMethodName) {
    ApiMethodName["RequestingSwapTransaction"] = "Requesting Swap Transaction";
    ApiMethodName["CreatingSwap"] = "Creating Swap";
    ApiMethodName["CheckingTransactionStatus"] = "Checking transaction status";
    ApiMethodName["CreateTransaction"] = "Create Transaction";
    ApiMethodName["CheckApproval"] = "Check TX Approval";
    ApiMethodName["GettingSwapDetail"] = "Getting Swap Detail";
    ApiMethodName["GettingUserLimits"] = "Getting user limits";
    return ApiMethodName;
}({});
var $5a284c98426d7812$export$c4e919e2c984d64b = /*#__PURE__*/ function(TransactionName) {
    TransactionName["GenericTransaction"] = "transaction";
    TransactionName["SendingOneInchTransaction"] = "1inch transaction";
    TransactionName["Approval"] = "approve transaction";
    return TransactionName;
}({});
const $5a284c98426d7812$export$ac6b831b3b0dc450 = [
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).BTC,
    (0, $9HEDW.LegacyNetworks).BSC,
    (0, $9HEDW.LegacyNetworks).TRON,
    (0, $9HEDW.LegacyNetworks).SOLANA,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).FANTOM,
    (0, $9HEDW.LegacyNetworks).ARBITRUM,
    (0, $9HEDW.LegacyNetworks).OPTIMISM,
    (0, $9HEDW.LegacyNetworks).CRONOS,
    (0, $9HEDW.LegacyNetworks).BOBA,
    (0, $9HEDW.LegacyNetworks).GNOSIS,
    (0, $9HEDW.LegacyNetworks).MOONBEAM,
    (0, $9HEDW.LegacyNetworks).MOONRIVER,
    (0, $9HEDW.LegacyNetworks).HARMONY,
    (0, $9HEDW.LegacyNetworks).LTC,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN
];
const $5a284c98426d7812$export$1ac55c078823cdb2 = [
    (0, $9HEDW.LegacyNetworks).SOLANA,
    (0, $9HEDW.LegacyNetworks).ETHEREUM,
    (0, $9HEDW.LegacyNetworks).BSC,
    (0, $9HEDW.LegacyNetworks).POLYGON,
    (0, $9HEDW.LegacyNetworks).AVAX_CCHAIN,
    $5a284c98426d7812$export$10794b7cd0786422
];


const $03818170076a0629$var$UNKNOWN_COIN_IMAGE = '/coins/unknown.png';
const $03818170076a0629$var$BRAVE_USER_AGENT_HEADER = 'X-Brave';
const $03818170076a0629$var$url = 'https://api.rango.exchange';
const $03818170076a0629$export$ca6dda5263526f75 = $03818170076a0629$var$url;
const $03818170076a0629$export$2709f4b3f874057c = 'X-Rango-Id';
const $03818170076a0629$export$3cf0d11e3988f233 = 'apiKey=4a624ab5-16ff-4f96-90b7-ab00ddfc342c';
function $03818170076a0629$export$dc09743a86365433(inputAmount, bestRoute, wallets, settings, validateBalanceOrFee) {
    const simulationResult = bestRoute.result;
    if (!simulationResult) throw Error('Simulation result should not be null');
    return {
        creationTime: new Date().getTime().toString(),
        finishTime: null,
        requestId: bestRoute.requestId || '',
        inputAmount: inputAmount,
        wallets: wallets,
        status: 'running',
        isPaused: false,
        extraMessage: null,
        extraMessageSeverity: null,
        extraMessageDetail: null,
        extraMessageErrorCode: null,
        networkStatusExtraMessage: null,
        networkStatusExtraMessageDetail: null,
        lastNotificationTime: null,
        settings: settings,
        simulationResult: simulationResult,
        validateBalanceOrFee: validateBalanceOrFee,
        steps: bestRoute.result?.swaps?.map((s, i)=>({
                id: i + 1,
                fromBlockchain: s.from.blockchain,
                fromSymbol: s.from.symbol,
                fromSymbolAddress: (0, $5a284c98426d7812$export$5fc74bc3c90095a2).includes(s.from.blockchain) && (0, $5a284c98426d7812$export$d7bdddcc8b17e284).includes(s.swapperId) && (!s.from.address || s.from.address.length === 0) ? null : s.from.address,
                fromDecimals: s.from.decimals,
                fromAmountPrecision: s.fromAmountPrecision,
                fromAmountMinValue: s.fromAmountMinValue,
                fromAmountMaxValue: s.fromAmountMaxValue,
                toBlockchain: s.to.blockchain,
                fromLogo: s.from.logo,
                toSymbol: s.to.symbol,
                toSymbolAddress: (0, $5a284c98426d7812$export$5fc74bc3c90095a2).includes(s.to.blockchain) && (0, $5a284c98426d7812$export$d7bdddcc8b17e284).includes(s.swapperId) && (0, $5a284c98426d7812$export$4b8df58f907f74d3).get(s.to.blockchain) === s.to.symbol && (!s.to.address || s.to.address.length === 0) ? null : s.to.address,
                toDecimals: s.to.decimals,
                toLogo: s.to.logo,
                startTransactionTime: new Date().getTime(),
                swapperId: s.swapperId,
                expectedOutputAmountHumanReadable: s.toAmount,
                outputAmount: null,
                status: 'created',
                networkStatus: null,
                executedTransactionId: null,
                externalTransactionId: null,
                explorerUrl: null,
                trackingCode: null,
                cosmosTransaction: null,
                solanaTransaction: null,
                evmTransaction: null,
                evmApprovalTransaction: null,
                transferTransaction: null,
                diagnosisUrl: null,
                internalSteps: null
            })) || []
    };
}
function $03818170076a0629$export$2e0c4038c37de934() {
    const key = 'X-Rango-Id';
    const cookieId = window.localStorage.getItem(key);
    if (cookieId) return cookieId;
    const value = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    window.localStorage.setItem(key, value);
    return value;
}
const $03818170076a0629$export$23f2ca38df543ad7 = async (from, to, amount, rawAccounts, checkPrerequisites, signal, selectedWallets, swappersGroupsBlackList, blockchainsWhiteList)=>{
    const connectedWallets = (rawAccounts?.blockchains || []).map((b)=>({
            blockchain: b.name,
            addresses: Array.from(new Set(b.accounts.map((a)=>a.address)))
        }));
    const body = {
        from: {
            blockchain: from.blockchain,
            symbol: from.symbol,
            address: from.address
        },
        to: {
            blockchain: to.blockchain,
            symbol: to.symbol,
            address: to.address
        },
        amount: amount.toString(),
        connectedWallets: connectedWallets,
        selectedWallets: selectedWallets || {},
        checkPrerequisites: checkPrerequisites,
        affiliateRef: localStorage.getItem('affiliateRef'),
        swapperGroups: swappersGroupsBlackList,
        ...!!swappersGroupsBlackList && {
            swappersGroupsExclude: true
        },
        blockchains: blockchainsWhiteList
    };
    const url = `${$03818170076a0629$export$ca6dda5263526f75}/routing/best?${$03818170076a0629$export$3cf0d11e3988f233}`;
    let isBrave;
    try {
        isBrave = navigator.brave && await navigator.brave.isBrave();
    } catch (error) {
        isBrave = false;
    }
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json;charset=UTF-8',
            [$03818170076a0629$export$2709f4b3f874057c]: $03818170076a0629$export$2e0c4038c37de934(),
            ...isBrave && {
                [$03818170076a0629$var$BRAVE_USER_AGENT_HEADER]: 'true'
            }
        },
        body: JSON.stringify(body),
        signal: signal
    });
    const res = await response.json();
    if (res?.status === 500 || res?.error) throw new Error(res?.error || `Error from server, status: ${res.status}`);
    return res;
};
const $03818170076a0629$export$85817003298b4e11 = (s)=>{
    if (!s) return null;
    const ps1 = s.split('--');
    const ps2 = ps1[0].split('.');
    return {
        // symbol: ps2[1], // this doesnt work for USDT.E (on avax) AVAX.WETH.E--0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab
        symbol: ps2.slice(1).join('.'),
        image: $03818170076a0629$var$UNKNOWN_COIN_IMAGE,
        blockchain: ps2[0],
        address: ps1.length === 2 ? decodeURIComponent(ps1[1]) : null,
        usdPrice: null,
        isSecondaryCoin: false,
        coinSource: null,
        name: null,
        coinSourceUrl: null,
        decimals: 18
    };
};
async function $03818170076a0629$export$9f153b88ceb7a73b(requestId) {
    const url = `${$03818170076a0629$export$ca6dda5263526f75}/tx/${requestId}/check-approval?${$03818170076a0629$export$3cf0d11e3988f233}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'content-type': 'application/json;charset=UTF-8',
            [$03818170076a0629$export$2709f4b3f874057c]: $03818170076a0629$export$2e0c4038c37de934()
        }
    });
    if (!!response.status && (response.status < 200 || response.status >= 400) || !response.ok) {
        const apiError = $03818170076a0629$export$c3305233df7aa094((0, $5a284c98426d7812$export$1494cd15f5dbc3a6).CheckApproval);
        throw $03818170076a0629$export$89427b94e5b39218.BadStatusCode(apiError, response.status);
    }
    return await response.json();
}
async function $03818170076a0629$export$5c5ef592c1ed0e3f(requestId, txId, step) {
    const url = `${$03818170076a0629$export$ca6dda5263526f75}/tx/check-status?${$03818170076a0629$export$3cf0d11e3988f233}`;
    const body = {
        step: step,
        txId: txId,
        requestId: requestId
    };
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            [$03818170076a0629$export$2709f4b3f874057c]: $03818170076a0629$export$2e0c4038c37de934(),
            'content-type': 'application/json;charset=UTF-8'
        },
        body: JSON.stringify(body)
    });
    if (!!response.status && (response.status < 200 || response.status >= 400) || !response.ok) {
        const apiError = $03818170076a0629$export$c3305233df7aa094((0, $5a284c98426d7812$export$1494cd15f5dbc3a6).CheckingTransactionStatus);
        throw $03818170076a0629$export$89427b94e5b39218.BadStatusCode(apiError, response.status);
    }
    const res = await response.json();
    return {
        ...res,
        outputAmount: res.outputAmount ? new (0, $iOQO2.BigNumber)(res.outputAmount) : null
    };
}
const $03818170076a0629$export$13c42f14b1ed4d42 = 'Assertion failed (Unexpected behaviour)';
const $03818170076a0629$export$c3305233df7aa094 = (apiMethodName)=>`Unexpected response from API (${apiMethodName})`;
const $03818170076a0629$export$887432f68b2e052f = (method, walletType)=>`method: ${method} call is unsupported for wallet ${walletType}`;
const $03818170076a0629$export$37be8ead8f4f1a8e = (transactionName)=>`Error sending ${transactionName}`;
const $03818170076a0629$export$c246b8cefc7f7f15 = 'User rejected the message signing';
const $03818170076a0629$export$462049133d2566ee = 'Create transaction failed in Rango Server';
const $03818170076a0629$export$54468d1767862690 = 'Input wallet not found';
const $03818170076a0629$export$b78c12c1b5f5dc34 = 'Failed to connect to wallet, if you have turned injection off (disable default wallet for xDefi), turn it on and refresh the page';
class $03818170076a0629$export$89427b94e5b39218 extends Error {
    constructor(code, m, root, detail){
        super(m);
        Object.setPrototypeOf(this, $03818170076a0629$export$89427b94e5b39218.prototype);
        this.code = code;
        this.detail = detail;
        this.root = root;
    }
    getErrorDetail() {
        const rawMessage = typeof this.root === 'object' && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        const rootStr = typeof this.root === 'string' ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            extraMessage: this.message,
            extraMessageDetail: this.detail || rootStr,
            extraMessageErrorCode: this.code || null
        };
    }
    static AssertionFailed(m) {
        return new $03818170076a0629$export$89427b94e5b39218('CLIENT_UNEXPECTED_BEHAVIOUR', $03818170076a0629$export$13c42f14b1ed4d42, m);
    }
    static BadStatusCode(message, statusCode) {
        return new $03818170076a0629$export$89427b94e5b39218('TX_FAIL', message, null, `status code = ${statusCode}`);
    }
    static CreateTransaction(detail) {
        return new $03818170076a0629$export$89427b94e5b39218('FETCH_TX_FAILED', $03818170076a0629$export$462049133d2566ee, null, detail);
    }
    static WalletMissing() {
        return new $03818170076a0629$export$89427b94e5b39218('CLIENT_UNEXPECTED_BEHAVIOUR', $03818170076a0629$export$54468d1767862690, null, 'Server requested for a blockchain or address not selected by user');
    }
    static BlockchainMissing() {
        return new $03818170076a0629$export$89427b94e5b39218('CLIENT_UNEXPECTED_BEHAVIOUR', $03818170076a0629$export$54468d1767862690, null, 'Server requested for a blockchain or address not selected by user');
    }
}
function $03818170076a0629$export$b6b54d9bbb742a92(swap, currentStep) {
    return swap.steps.find((step)=>step.status !== 'failed' && step.status !== 'success' && step.id !== currentStep.id) || null;
}
async function $03818170076a0629$export$714aebfec8ead7f0(request) {
    const url = `${$03818170076a0629$export$ca6dda5263526f75}/tx/create?${$03818170076a0629$export$3cf0d11e3988f233}`;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'content-type': 'application/json;charset=UTF-8',
                [$03818170076a0629$export$2709f4b3f874057c]: $03818170076a0629$export$2e0c4038c37de934()
            },
            body: JSON.stringify(request)
        });
        if (!!response.status && (response.status < 200 || response.status >= 400) || !response.ok) throw $03818170076a0629$export$89427b94e5b39218.CreateTransaction(`Error creating the transaction, status code: ${response.status}`);
        const result = await response.json();
        if (!result.ok || !result.transaction) throw $03818170076a0629$export$89427b94e5b39218.CreateTransaction(result.error || 'bad response from create tx endpoint');
        return result;
    } catch (error) {
        throw $03818170076a0629$export$89427b94e5b39218.CreateTransaction(error.message);
    }
}
const $03818170076a0629$export$8a2553b801670ae3 = (obj)=>{
    if (!obj) return {
        extraMessage: '',
        extraMessageErrorCode: null
    };
    if (obj instanceof $03818170076a0629$export$89427b94e5b39218) return obj.getErrorDetail();
    if (obj instanceof (0, $9gKM3.SignerError)) {
        const t = obj.getErrorDetail();
        return {
            extraMessage: t.message,
            extraMessageDetail: t.detail,
            extraMessageErrorCode: t.code
        };
    }
    if (obj instanceof Error) return {
        extraMessage: obj.toString(),
        extraMessageErrorCode: null
    };
    if (typeof obj !== 'string') return {
        extraMessage: JSON.stringify(obj),
        extraMessageErrorCode: null
    };
    return {
        extraMessage: obj,
        extraMessageErrorCode: null
    };
};
const $03818170076a0629$export$f29d84d66d2341b1 = (tx, network, evmBasedBlockchains)=>{
    const evmBlochain = evmBasedBlockchains.find((blockchain)=>blockchain.name === network);
    if (!evmBlochain) throw Error(`unsupported network: ${network} for getting approve url.`);
    if (evmBlochain.info.transactionUrl) return evmBlochain.info.transactionUrl.replace('{txHash}', tx.toLowerCase());
    throw Error(`Explorer url for ${network} is not implemented`);
};
const $03818170076a0629$export$e07f0a7a416c5e36 = (swap, step)=>{
    try {
        return $03818170076a0629$export$e314a0b0b5946154(swap, step);
    } catch (e) {
        return null;
    }
};
const $03818170076a0629$export$e314a0b0b5946154 = (swap, step)=>{
    const b1 = step.evmTransaction?.blockChain || step.evmApprovalTransaction?.blockChain || step.cosmosTransaction?.blockChain || step.solanaTransaction?.blockChain;
    if (b1) return b1;
    const transferAddress = step.transferTransaction?.fromWalletAddress;
    if (!transferAddress) throw $03818170076a0629$export$89427b94e5b39218.BlockchainMissing();
    const blockchain = Object.keys(swap.wallets).find((b)=>swap.wallets[b]?.address === transferAddress) || null;
    if (blockchain == null) throw $03818170076a0629$export$89427b94e5b39218.BlockchainMissing();
    // TODO: check why it returns string
    return blockchain;
};
function $03818170076a0629$export$996107875f5e42aa(wallet, accounts, connectedNetwork, info) {
    const { evmBasedChainsNames: evmBasedChains, supportedChainsByWallets: supportedChainsByWallets } = info;
    const result = {};
    function addAccount(network, address) {
        const isConnected = network === connectedNetwork;
        const newAccount = {
            address: address,
            balances: null,
            loading: true,
            walletType: wallet,
            isConnected: isConnected,
            error: false,
            explorerUrl: null
        };
        if (result[network]) result[network].accounts.push(newAccount);
        else result[network] = {
            name: network,
            accounts: [
                newAccount
            ]
        };
    }
    const supportedChains = supportedChainsByWallets?.[wallet] || [];
    accounts.forEach((account)=>{
        const { address: address, network: network } = (0, $9HEDW.legacyReadAccountAddress)(account);
        const hasLimitation = supportedChains.length > 0;
        const isSupported = supportedChains.includes(network);
        const isUnknown = network === (0, $9HEDW.LegacyNetworks).Unknown;
        const notSupportedNetworkByWallet = hasLimitation && !isSupported && !isUnknown;
        /*
     * Here we check given `network` is not supported by wallet
     * And also the network is known.
     */ if (notSupportedNetworkByWallet) return;
        /*
     * In some cases we can handle unknown network by checking its address
     * pattern and act on it.
     * Example: showing our evm compatible netwrok when the uknown network is evem.
     * Otherwise, we stop executing this function.
     */ const isUknownAndEvmBased = network === (0, $9HEDW.LegacyNetworks).Unknown && (0, $1b9728dd04f93c4c$re_export$ethers).isAddress(address);
        if (isUnknown && !isUknownAndEvmBased) return;
        const isEvmBasedChain = evmBasedChains.includes(network);
        // If it's an evm network, we will add the address to all the evm chains.
        if (isEvmBasedChain || isUknownAndEvmBased) {
            /*
       * all evm chains are not supported in wallets, so we are adding
       * only to those that are supported by wallet.
       */ const evmChainsSupportedByWallet = supportedChains.filter((chain)=>evmBasedChains.includes(chain));
            evmChainsSupportedByWallet.forEach((network)=>{
                /*
         * EVM addresses are not case sensetive.
         * Some wallets like Binance-chain return some letters in uppercase which produces bugs in our wallet state.
         */ addAccount(network, address.toLowerCase());
            });
        } else addAccount(network, address);
    });
    return Object.values(result);
}
const $03818170076a0629$export$3b61355da848f692 = (blockchains)=>Object.entries(blockchains).map(([, blockchainMeta])=>blockchainMeta).filter((0, $hE77Y.isEvmBlockchain)).map((blockchainMeta)=>blockchainMeta.name);
const $03818170076a0629$export$f3b8ad4ddbc4a503 = (blockchains)=>{
    // TODO WalletsAndSupportedChains can't find model for return type
    if (Object.entries(blockchains).length === 0) return null;
    const blockchainsArray = Object.entries(blockchains).map(([, blockchainMeta])=>blockchainMeta);
    const evmBlockchains = blockchainsArray.filter((0, $hE77Y.isEvmBlockchain));
    const solanaBlockchain = blockchainsArray.filter((0, $hE77Y.isSolanaBlockchain));
    const cosmosBlockchains = blockchainsArray.filter((0, $hE77Y.isCosmosBlockchain));
    return {
        [(0, $9cRHO.WalletTypes).META_MASK]: evmBlockchains,
        [(0, $9cRHO.WalletTypes).COINBASE]: [
            ...evmBlockchains,
            ...solanaBlockchain
        ],
        [(0, $9cRHO.WalletTypes).KEPLR]: cosmosBlockchains.filter((blockchainMeta)=>!!blockchainMeta.info),
        [(0, $9cRHO.WalletTypes).PHANTOM]: solanaBlockchain,
        [(0, $9cRHO.WalletTypes).XDEFI]: blockchainsArray.filter((blockchainMeta)=>[
                ...(0, $db414cb596f30543$export$2f1ee95fdafdbc6f),
                ...(0, $9cRHO.XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS),
                (0, $9HEDW.LegacyNetworks).SOLANA
            ].includes(blockchainMeta.name)),
        [(0, $9cRHO.WalletTypes).TRUST_WALLET]: evmBlockchains,
        [(0, $9cRHO.WalletTypes).COIN98]: [
            ...evmBlockchains,
            ...solanaBlockchain
        ],
        [(0, $9cRHO.WalletTypes).OKX]: blockchainsArray.filter((blockchainMeta)=>(0, $5a284c98426d7812$export$ac6b831b3b0dc450).includes(blockchainMeta.name)),
        [(0, $9cRHO.WalletTypes).EXODUS]: blockchainsArray.filter((blockchainMeta)=>(0, $5a284c98426d7812$export$1ac55c078823cdb2).includes(blockchainMeta.name)),
        [(0, $9cRHO.WalletTypes).TOKEN_POCKET]: evmBlockchains,
        [(0, $9cRHO.WalletTypes).STATION]: [],
        [(0, $9cRHO.WalletTypes).LEAP]: [],
        [(0, $9cRHO.WalletTypes).MATH]: [
            ...evmBlockchains,
            ...solanaBlockchain
        ],
        [(0, $9cRHO.WalletTypes).SAFEPAL]: [
            ...evmBlockchains,
            ...solanaBlockchain
        ],
        [(0, $9cRHO.WalletTypes).CLOVER]: [
            ...evmBlockchains,
            ...solanaBlockchain
        ],
        [(0, $9cRHO.WalletTypes).COSMOSTATION]: [
            ...evmBlockchains,
            ...cosmosBlockchains.filter((blockchainMeta)=>!!blockchainMeta.info)
        ],
        [(0, $9cRHO.WalletTypes).BRAVE]: [
            ...evmBlockchains,
            ...solanaBlockchain
        ]
    };
};
const $03818170076a0629$export$79051f1a1263cc5 = (blockchains)=>{
    const walletsAndSupportedChainsMeta = $03818170076a0629$export$f3b8ad4ddbc4a503(blockchains);
    if (!walletsAndSupportedChainsMeta) return null;
    const walletsAndSupportedChainsNames = {};
    for(const key in walletsAndSupportedChainsMeta)walletsAndSupportedChainsNames[key] = walletsAndSupportedChainsMeta[key].map((blockchainMeta)=>blockchainMeta.name);
    return walletsAndSupportedChainsNames;
};
async function $03818170076a0629$export$fc64c459ac7458f9(input, from, to) {
    const inputAmount = input;
    const amount = new (0, $iOQO2.BigNumber)(inputAmount);
    const rawAccounts = (0, $1f30fcf397122368$export$6fc3cee911cc8c20);
    const checkPrerequisites = true;
    const signal = undefined;
    const selectedWallets = {
        BSC: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        POLYGON: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        FANTOM: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        AVAX_CCHAIN: '0x2702d89c1c8658b49c45dd460deebcc45faec03c',
        COSMOS: 'cosmos1unf2rcytjxfpz8x8ar63h4qeftadptg5r5qswd'
    };
    const swappersGroupsBlackList = [];
    const blockchainsWhiteList = [];
    const bestRoute = await $03818170076a0629$export$23f2ca38df543ad7(from, to, amount, rawAccounts, checkPrerequisites, signal, selectedWallets, swappersGroupsBlackList, blockchainsWhiteList);
    if (!bestRoute) throw 'No route found.';
    const settings = {
        slippage: '1.0',
        disabledSwappersIds: [],
        disabledSwappersGroups: []
    };
    const wallets = {};
    if (rawAccounts) rawAccounts.blockchains.forEach((item)=>{
        // We know there is only one account.
        wallets[item.name] = item.accounts[0];
    });
    const newSwap = $03818170076a0629$export$dc09743a86365433(inputAmount, bestRoute, wallets, settings, false);
    return newSwap;
}



var $bh6RR = parcelRequire("bh6RR");
function $e2d64ad5c670a905$export$f3788100aef62107(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h2", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("p", null, props.description), !!props.requirements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("p", null, "Requirements:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("ul", null, props.requirements.map((text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("li", null, text)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("p", null, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
        onClick: props.onRun
    }, "Run")));
}


function $d30bbec84a7478e2$export$8aba6644811adb34(props) {
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const [fromToken, setFrom] = (0, $bh6RR.useState)('FANTOM.USDC--0x04068da6c83afcfa0e13ba15a6696662335d5b75');
    const [toToken, setTo] = (0, $bh6RR.useState)('COSMOS.ATOM');
    const [input, setInput] = (0, $bh6RR.useState)('10');
    (0, $bh6RR.useEffect)(()=>{
        manager?.run();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (props.connectedWallets.length) {
            console.log('[React] run retry on `props.connectedWallets`');
            manager?.retry();
        }
    }, [
        props.connectedWallets
    ]);
    const flows = [
        {
            title: 'Single Wallet',
            description: 'Run a simple swap by metamask',
            requirements: [
                'Use metamsk',
                'Change your network to ethereum.'
            ],
            onRun: ()=>{
                const qId = manager?.create('simpleSwap', {});
                console.debug(`[Queue] created. ID: ${qId}`, manager);
            }
        },
        {
            title: 'Rango Swap (On-chain)',
            description: 'Run a swap using Rango flow.',
            requirements: [
                'Please use Metamask & Keplr',
                'USDC -> USDT'
            ],
            onRun: async ()=>{
                const from = (0, $03818170076a0629$export$85817003298b4e11)('POLYGON.USDC--0x2791bca1f2de4661ed88a30c99a7a9449aa84174');
                const to = (0, $03818170076a0629$export$85817003298b4e11)('POLYGON.USDT--0xc2132d05d31c914a87c6611c10748aeb04b58e8f');
                const swap = await (0, $03818170076a0629$export$fc64c459ac7458f9)('2', from, to);
                //   toast({ eventType: 'swap_started', swap: newSwap, step: newSwap.steps[0] });
                const qId = manager?.create('rango-swap', {
                    swapDetails: swap
                });
                console.debug(`[Queue] Swap created. ID: ${qId}`, manager);
            }
        },
        {
            title: 'Rango Swap (Cross-chain)',
            description: 'Run a swap using Rango flow.',
            requirements: [
                'Please use Metamask & Keplr (cosmos) for now.'
            ],
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, "From:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
                type: "text",
                value: fromToken,
                onChange: (e)=>{
                    setFrom(e.target.value);
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, "To:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
                type: "text",
                value: toToken,
                onChange: (e)=>{
                    setTo(e.target.value);
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, "Amount:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
                type: "text",
                value: input,
                onChange: (e)=>{
                    setInput(e.target.value);
                }
            }))),
            onRun: async ()=>{
                const from = (0, $03818170076a0629$export$85817003298b4e11)(fromToken);
                const to = (0, $03818170076a0629$export$85817003298b4e11)(toToken);
                const swap = await (0, $03818170076a0629$export$fc64c459ac7458f9)(input, from, to);
                //   toast({ eventType: 'swap_started', swap: newSwap, step: newSwap.steps[0] });
                const qId = manager?.create('rango-swap', {
                    swapDetails: swap
                });
                console.debug(`[Queue] Swap created. ID: ${qId}`, manager);
            }
        },
        {
            title: 'Rango Parallel Swaps',
            description: 'Run multiple swaps at the same time using Rango flow.',
            requirements: [
                'Please use Metamask & Keplr (cosmos) for now.',
                'FTM -> ATOM and USDC -> USDT on polygon'
            ],
            onRun: async ()=>{
                const from1 = (0, $03818170076a0629$export$85817003298b4e11)('POLYGON.USDC--0x2791bca1f2de4661ed88a30c99a7a9449aa84174');
                const to1 = (0, $03818170076a0629$export$85817003298b4e11)('POLYGON.USDT--0xc2132d05d31c914a87c6611c10748aeb04b58e8f');
                const from2 = (0, $03818170076a0629$export$85817003298b4e11)('FANTOM.USDC--0x04068da6c83afcfa0e13ba15a6696662335d5b75');
                const to2 = (0, $03818170076a0629$export$85817003298b4e11)('COSMOS.ATOM');
                const swap1 = await (0, $03818170076a0629$export$fc64c459ac7458f9)('2', from1, to1);
                const swap2 = await (0, $03818170076a0629$export$fc64c459ac7458f9)('10', from2, to2);
                //   toast({ eventType: 'swap_started', swap: newSwap, step: newSwap.steps[0] });
                const qId = manager?.create('rango-swap', {
                    swapDetails: swap1
                });
                const q2Id = manager?.create('rango-swap', {
                    swapDetails: swap2
                });
                console.debug(`[Queue] Swap created. ID: ${qId}`);
                console.debug(`[Queue] Swap created. ID: ${q2Id}`);
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "list"
    }, flows.map((flow, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e2d64ad5c670a905$export$f3788100aef62107), {
            key: `flow-${i}`,
            ...flow
        })));
}




var $bh6RR = parcelRequire("bh6RR");
function $cab60ad7d1a7b4d8$export$84202caead5689ba() {
    const id = "xxxx-x-xxx-x-xx-x-x-x--xx";
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const storage = manager?.getAll() || new Map();
    const queues = [];
    storage.forEach((v, k)=>{
        const tasks = v.list.state.tasks;
        const taskIds = Object.keys(tasks);
        queues.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "q",
            id: `q-${k}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h4", null, "Queue ", v.name, " (", k, ")", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
            className: `status ${v.list.state.status.toLowerCase()}`
        }, v.list.state.status)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "q-list"
        }, taskIds.map((id)=>{
            const taskStatus = tasks[id].status;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: "task",
                id: `t-${id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: "id tooltip"
            }, "Task ...", id.slice(-4), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
                className: "tooltiptext"
            }, id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: `status ${taskStatus.toLowerCase()}`
            }, taskStatus));
        }))));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "queues"
    }, queues);
}




var $bh6RR = parcelRequire("bh6RR");
function $02556a5c2897602b$export$5cde6cad58293e28() {
    const { connect: connect, providers: providers, state: state, disconnect: disconnect } = (0, $a3605f36c193ada0$export$934951b5ed2ebf82)();
    const list = Object.keys(providers());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h3", null, "Available Wallets"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "wallets"
    }, list.map((type)=>{
        const wallet_type = type;
        const wallet_state = state(wallet_type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "wallet",
            key: type
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h5", null, wallet_type), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("p", null, "Address: ", wallet_state.accounts?.join(',')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
            onClick: ()=>{
                if (wallet_state.connected) disconnect(wallet_type);
                else connect(wallet_type);
            }
        }, wallet_state.connected ? 'Disconnect' : 'Connect'));
    })));
}


/*
 * this API key is limited and
 * it is only for test purpose
 */ const $14da69a755a028ad$var$RANGO_PUBLIC_API_KEY = 'c6381a79-2817-4602-83bf-6a641a409e32';
const $14da69a755a028ad$export$5a31b40893a5df6f = 'e24844c5deb5193c1c14840a7af6a40b';
const $14da69a755a028ad$export$7bd4d5ccbedcb39c = {
    appUrl: 'https://widget.rango.exchange/',
    email: 'hi+trezorwidget@rango.exchange'
};
const $14da69a755a028ad$export$a7d6c84d16fd9182 = 'https://raw.githubusercontent.com/rango-exchange/assets/refs/heads/main/manifests/tonconnect/manifest.json';
let $14da69a755a028ad$var$configs = {
    API_KEY: $14da69a755a028ad$var$RANGO_PUBLIC_API_KEY
};
function $14da69a755a028ad$export$44487a86467333c3(name) {
    return $14da69a755a028ad$var$configs[name];
}
function $14da69a755a028ad$export$940a7873bb071df8(name, value) {
    $14da69a755a028ad$var$configs[name] = value;
    return value;
}
function $14da69a755a028ad$export$b9b9cdb96b829919(nextConfigs) {
    $14da69a755a028ad$var$configs = structuredClone(nextConfigs);
    return $14da69a755a028ad$var$configs;
}



const $0ba9e4f1b04c8e31$var$wallet = (0, $1f30fcf397122368$export$8c2c13478e869569);
function $0ba9e4f1b04c8e31$export$86fbec116b87613f(props) {
    const { providers: providers, getSigners: getSigners, state: state, canSwitchNetworkTo: canSwitchNetworkTo, connect: connect, getWalletInfo: getWalletInfo } = (0, $a3605f36c193ada0$export$934951b5ed2ebf82)();
    const switchNetwork = async (wallet, network)=>{
        if (!canSwitchNetworkTo(wallet, network)) return undefined;
        return connect(wallet, network);
    };
    const isMobileWallet = (walletType)=>!!getWalletInfo(walletType).mobileWallet;
    const allProviders = providers();
    const queueContext = {
        meta: $1f30fcf397122368$export$6990040ee07315,
        getSigners: getSigners,
        wallets: $0ba9e4f1b04c8e31$var$wallet,
        providers: allProviders,
        switchNetwork: switchNetwork,
        connect: connect,
        state: state,
        isMobileWallet: isMobileWallet,
        canSwitchNetworkTo: canSwitchNetworkTo
    };
    const swapQueueDef = (0, $bh6RR.useMemo)(()=>{
        return (0, $3e49d40922a6294a$export$e5055f26eedfa461)({
            API_KEY: (0, $14da69a755a028ad$export$44487a86467333c3)('API_KEY')
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5f16708435ec29c2$export$2e2bcd8739ae039), {
        queuesDefs: [
            swapQueueDef
        ],
        context: queueContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $02556a5c2897602b$export$5cde6cad58293e28), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h2", null, "Flows"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d30bbec84a7478e2$export$8aba6644811adb34), {
        connectedWallets: props.connectedWallets
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("h2", null, "History"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $cab60ad7d1a7b4d8$export$84202caead5689ba), null));
}



const $1404572f217719d6$var$providers = (0, $6a21b2259c5f602a$export$e6f06807598c9e91)({
    walletconnect2: {
        WC_PROJECT_ID: (0, $14da69a755a028ad$export$5a31b40893a5df6f)
    },
    trezorManifest: (0, $14da69a755a028ad$export$7bd4d5ccbedcb39c),
    tonconnect: {
        manifestUrl: (0, $14da69a755a028ad$export$a7d6c84d16fd9182)
    }
});
function $1404572f217719d6$var$AppContainer() {
    const [connectedWallets, setConnectedWallets] = (0, $bh6RR.useState)([]);
    const client = new (0, $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8)("4a624ab5-16ff-4f96-90b7-ab00ddfc342c");
    // Because allBlockChains didn't use the BlockchainMeta type from rango-sdk, we have to use any type
    const [blockchains, setBlockChains] = (0, $bh6RR.useState)([]);
    const [, setError] = (0, $bh6RR.useState)('');
    const [, setLoading] = (0, $bh6RR.useState)(true);
    (0, $bh6RR.useEffect)(()=>{
        const getAllBlockchains = async ()=>{
            try {
                const res = await client.getAllMetadata();
                setBlockChains(res.blockchains);
            } catch (e) {
                setError(e.message);
            }
            setLoading(false);
        };
        getAllBlockchains();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6713dd8e2740824f$export$2e2bcd8739ae039), {
        providers: $1404572f217719d6$var$providers,
        allBlockChains: blockchains,
        onUpdateState: (type, event, value, coreState)=>{
            if (event === (0, $9HEDW.LegacyEvents).ACCOUNTS && coreState.connected) {
                if (coreState.connected) {
                    if (!connectedWallets.includes(type)) {
                        const nextState = [
                            ...connectedWallets
                        ];
                        nextState.push(type);
                        setConnectedWallets(nextState);
                    }
                } else {
                    const nextState = [
                        ...connectedWallets
                    ].filter((wallet)=>wallet !== type);
                    setConnectedWallets(nextState);
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0ba9e4f1b04c8e31$export$86fbec116b87613f), {
        connectedWallets: connectedWallets
    }));
}
const $1404572f217719d6$var$container = document.getElementById('app');
const $1404572f217719d6$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($1404572f217719d6$var$container);
$1404572f217719d6$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1404572f217719d6$var$AppContainer, null));


//# sourceMappingURL=public.9a261fd5.js.map
